"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/@prisma/client/runtime/index-browser.js
var require_index_browser = __commonJS({
  "../../node_modules/@prisma/client/runtime/index-browser.js"(exports2, module2) {
    "use strict";
    var de = Object.defineProperty;
    var We = Object.getOwnPropertyDescriptor;
    var Ge = Object.getOwnPropertyNames;
    var Je = Object.prototype.hasOwnProperty;
    var Me = (e2, n) => {
      for (var i2 in n) de(e2, i2, { get: n[i2], enumerable: true });
    };
    var Xe = (e2, n, i2, t2) => {
      if (n && typeof n == "object" || typeof n == "function") for (let r of Ge(n)) !Je.call(e2, r) && r !== i2 && de(e2, r, { get: () => n[r], enumerable: !(t2 = We(n, r)) || t2.enumerable });
      return e2;
    };
    var Ke = (e2) => Xe(de({}, "__esModule", { value: true }), e2);
    var Xn = {};
    Me(Xn, { Decimal: () => je, Public: () => he, getRuntime: () => be, makeStrictEnum: () => Pe, objectEnumValues: () => Oe });
    module2.exports = Ke(Xn);
    var he = {};
    Me(he, { validator: () => Ce });
    function Ce(...e2) {
      return (n) => n;
    }
    var ne = Symbol();
    var pe = /* @__PURE__ */ new WeakMap();
    var ge = class {
      constructor(n) {
        n === ne ? pe.set(this, "Prisma.".concat(this._getName())) : pe.set(this, "new Prisma.".concat(this._getNamespace(), ".").concat(this._getName(), "()"));
      }
      _getName() {
        return this.constructor.name;
      }
      toString() {
        return pe.get(this);
      }
    };
    var G2 = class extends ge {
      _getNamespace() {
        return "NullTypes";
      }
    };
    var J = class extends G2 {
    };
    me(J, "DbNull");
    var X2 = class extends G2 {
    };
    me(X2, "JsonNull");
    var K2 = class extends G2 {
    };
    me(K2, "AnyNull");
    var Oe = { classes: { DbNull: J, JsonNull: X2, AnyNull: K2 }, instances: { DbNull: new J(ne), JsonNull: new X2(ne), AnyNull: new K2(ne) } };
    function me(e2, n) {
      Object.defineProperty(e2, "name", { value: n, configurable: true });
    }
    var xe = /* @__PURE__ */ new Set(["toJSON", "$$typeof", "asymmetricMatch", Symbol.iterator, Symbol.toStringTag, Symbol.isConcatSpreadable, Symbol.toPrimitive]);
    function Pe(e2) {
      return new Proxy(e2, { get(n, i2) {
        if (i2 in n) return n[i2];
        if (!xe.has(i2)) throw new TypeError("Invalid enum value: ".concat(String(i2)));
      } });
    }
    var Qe = "Cloudflare-Workers";
    var Ye = "node";
    function Re() {
      var e2, n, i2;
      return typeof Netlify == "object" ? "netlify" : typeof EdgeRuntime == "string" ? "edge-light" : ((e2 = globalThis.navigator) == null ? void 0 : e2.userAgent) === Qe ? "workerd" : globalThis.Deno ? "deno" : globalThis.__lagon__ ? "lagon" : ((i2 = (n = globalThis.process) == null ? void 0 : n.release) == null ? void 0 : i2.name) === Ye ? "node" : globalThis.Bun ? "bun" : globalThis.fastly ? "fastly" : "unknown";
    }
    var ze = { node: "Node.js", workerd: "Cloudflare Workers", deno: "Deno and Deno Deploy", netlify: "Netlify Edge Functions", "edge-light": "Edge Runtime (Vercel Edge Functions, Vercel Edge Middleware, Next.js (Pages Router) Edge API Routes, Next.js (App Router) Edge Route Handlers or Next.js Middleware)" };
    function be() {
      let e2 = Re();
      return { id: e2, prettyName: ze[e2] || e2, isEdge: ["workerd", "deno", "netlify", "edge-light"].includes(e2) };
    }
    var H3 = 9e15;
    var $ = 1e9;
    var we = "0123456789abcdef";
    var te = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058";
    var re = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789";
    var Ne = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -H3, maxE: H3, crypto: false };
    var Te;
    var Z;
    var w2 = true;
    var oe = "[DecimalError] ";
    var V = oe + "Invalid argument: ";
    var Le = oe + "Precision limit exceeded";
    var De = oe + "crypto unavailable";
    var Fe = "[object Decimal]";
    var b2 = Math.floor;
    var C = Math.pow;
    var ye = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i;
    var en = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i;
    var nn = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i;
    var Ie = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    var D2 = 1e7;
    var m3 = 7;
    var tn = 9007199254740991;
    var rn = te.length - 1;
    var ve = re.length - 1;
    var h3 = { toStringTag: Fe };
    h3.absoluteValue = h3.abs = function() {
      var e2 = new this.constructor(this);
      return e2.s < 0 && (e2.s = 1), p(e2);
    };
    h3.ceil = function() {
      return p(new this.constructor(this), this.e + 1, 2);
    };
    h3.clampedTo = h3.clamp = function(e2, n) {
      var i2, t2 = this, r = t2.constructor;
      if (e2 = new r(e2), n = new r(n), !e2.s || !n.s) return new r(NaN);
      if (e2.gt(n)) throw Error(V + n);
      return i2 = t2.cmp(e2), i2 < 0 ? e2 : t2.cmp(n) > 0 ? n : new r(t2);
    };
    h3.comparedTo = h3.cmp = function(e2) {
      var n, i2, t2, r, s3 = this, o = s3.d, u2 = (e2 = new s3.constructor(e2)).d, l = s3.s, f = e2.s;
      if (!o || !u2) return !l || !f ? NaN : l !== f ? l : o === u2 ? 0 : !o ^ l < 0 ? 1 : -1;
      if (!o[0] || !u2[0]) return o[0] ? l : u2[0] ? -f : 0;
      if (l !== f) return l;
      if (s3.e !== e2.e) return s3.e > e2.e ^ l < 0 ? 1 : -1;
      for (t2 = o.length, r = u2.length, n = 0, i2 = t2 < r ? t2 : r; n < i2; ++n) if (o[n] !== u2[n]) return o[n] > u2[n] ^ l < 0 ? 1 : -1;
      return t2 === r ? 0 : t2 > r ^ l < 0 ? 1 : -1;
    };
    h3.cosine = h3.cos = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return i2.d ? i2.d[0] ? (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + Math.max(i2.e, i2.sd()) + m3, t2.rounding = 1, i2 = sn(t2, $e(t2, i2)), t2.precision = e2, t2.rounding = n, p(Z == 2 || Z == 3 ? i2.neg() : i2, e2, n, true)) : new t2(1) : new t2(NaN);
    };
    h3.cubeRoot = h3.cbrt = function() {
      var e2, n, i2, t2, r, s3, o, u2, l, f, c2 = this, a3 = c2.constructor;
      if (!c2.isFinite() || c2.isZero()) return new a3(c2);
      for (w2 = false, s3 = c2.s * C(c2.s * c2, 1 / 3), !s3 || Math.abs(s3) == 1 / 0 ? (i2 = O2(c2.d), e2 = c2.e, (s3 = (e2 - i2.length + 1) % 3) && (i2 += s3 == 1 || s3 == -2 ? "0" : "00"), s3 = C(i2, 1 / 3), e2 = b2((e2 + 1) / 3) - (e2 % 3 == (e2 < 0 ? -1 : 2)), s3 == 1 / 0 ? i2 = "5e" + e2 : (i2 = s3.toExponential(), i2 = i2.slice(0, i2.indexOf("e") + 1) + e2), t2 = new a3(i2), t2.s = c2.s) : t2 = new a3(s3.toString()), o = (e2 = a3.precision) + 3; ; ) if (u2 = t2, l = u2.times(u2).times(u2), f = l.plus(c2), t2 = S3(f.plus(c2).times(u2), f.plus(l), o + 2, 1), O2(u2.d).slice(0, o) === (i2 = O2(t2.d)).slice(0, o)) if (i2 = i2.slice(o - 3, o + 1), i2 == "9999" || !r && i2 == "4999") {
        if (!r && (p(u2, e2 + 1, 0), u2.times(u2).times(u2).eq(c2))) {
          t2 = u2;
          break;
        }
        o += 4, r = 1;
      } else {
        (!+i2 || !+i2.slice(1) && i2.charAt(0) == "5") && (p(t2, e2 + 1, 1), n = !t2.times(t2).times(t2).eq(c2));
        break;
      }
      return w2 = true, p(t2, e2, a3.rounding, n);
    };
    h3.decimalPlaces = h3.dp = function() {
      var e2, n = this.d, i2 = NaN;
      if (n) {
        if (e2 = n.length - 1, i2 = (e2 - b2(this.e / m3)) * m3, e2 = n[e2], e2) for (; e2 % 10 == 0; e2 /= 10) i2--;
        i2 < 0 && (i2 = 0);
      }
      return i2;
    };
    h3.dividedBy = h3.div = function(e2) {
      return S3(this, new this.constructor(e2));
    };
    h3.dividedToIntegerBy = h3.divToInt = function(e2) {
      var n = this, i2 = n.constructor;
      return p(S3(n, new i2(e2), 0, 1, 1), i2.precision, i2.rounding);
    };
    h3.equals = h3.eq = function(e2) {
      return this.cmp(e2) === 0;
    };
    h3.floor = function() {
      return p(new this.constructor(this), this.e + 1, 3);
    };
    h3.greaterThan = h3.gt = function(e2) {
      return this.cmp(e2) > 0;
    };
    h3.greaterThanOrEqualTo = h3.gte = function(e2) {
      var n = this.cmp(e2);
      return n == 1 || n === 0;
    };
    h3.hyperbolicCosine = h3.cosh = function() {
      var e2, n, i2, t2, r, s3 = this, o = s3.constructor, u2 = new o(1);
      if (!s3.isFinite()) return new o(s3.s ? 1 / 0 : NaN);
      if (s3.isZero()) return u2;
      i2 = o.precision, t2 = o.rounding, o.precision = i2 + Math.max(s3.e, s3.sd()) + 4, o.rounding = 1, r = s3.d.length, r < 32 ? (e2 = Math.ceil(r / 3), n = (1 / fe(4, e2)).toString()) : (e2 = 16, n = "2.3283064365386962890625e-10"), s3 = j(o, 1, s3.times(n), new o(1), true);
      for (var l, f = e2, c2 = new o(8); f--; ) l = s3.times(s3), s3 = u2.minus(l.times(c2.minus(l.times(c2))));
      return p(s3, o.precision = i2, o.rounding = t2, true);
    };
    h3.hyperbolicSine = h3.sinh = function() {
      var e2, n, i2, t2, r = this, s3 = r.constructor;
      if (!r.isFinite() || r.isZero()) return new s3(r);
      if (n = s3.precision, i2 = s3.rounding, s3.precision = n + Math.max(r.e, r.sd()) + 4, s3.rounding = 1, t2 = r.d.length, t2 < 3) r = j(s3, 2, r, r, true);
      else {
        e2 = 1.4 * Math.sqrt(t2), e2 = e2 > 16 ? 16 : e2 | 0, r = r.times(1 / fe(5, e2)), r = j(s3, 2, r, r, true);
        for (var o, u2 = new s3(5), l = new s3(16), f = new s3(20); e2--; ) o = r.times(r), r = r.times(u2.plus(o.times(l.times(o).plus(f))));
      }
      return s3.precision = n, s3.rounding = i2, p(r, n, i2, true);
    };
    h3.hyperbolicTangent = h3.tanh = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return i2.isFinite() ? i2.isZero() ? new t2(i2) : (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + 7, t2.rounding = 1, S3(i2.sinh(), i2.cosh(), t2.precision = e2, t2.rounding = n)) : new t2(i2.s);
    };
    h3.inverseCosine = h3.acos = function() {
      var e2, n = this, i2 = n.constructor, t2 = n.abs().cmp(1), r = i2.precision, s3 = i2.rounding;
      return t2 !== -1 ? t2 === 0 ? n.isNeg() ? L2(i2, r, s3) : new i2(0) : new i2(NaN) : n.isZero() ? L2(i2, r + 4, s3).times(0.5) : (i2.precision = r + 6, i2.rounding = 1, n = n.asin(), e2 = L2(i2, r + 4, s3).times(0.5), i2.precision = r, i2.rounding = s3, e2.minus(n));
    };
    h3.inverseHyperbolicCosine = h3.acosh = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return i2.lte(1) ? new t2(i2.eq(1) ? 0 : NaN) : i2.isFinite() ? (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + Math.max(Math.abs(i2.e), i2.sd()) + 4, t2.rounding = 1, w2 = false, i2 = i2.times(i2).minus(1).sqrt().plus(i2), w2 = true, t2.precision = e2, t2.rounding = n, i2.ln()) : new t2(i2);
    };
    h3.inverseHyperbolicSine = h3.asinh = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return !i2.isFinite() || i2.isZero() ? new t2(i2) : (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + 2 * Math.max(Math.abs(i2.e), i2.sd()) + 6, t2.rounding = 1, w2 = false, i2 = i2.times(i2).plus(1).sqrt().plus(i2), w2 = true, t2.precision = e2, t2.rounding = n, i2.ln());
    };
    h3.inverseHyperbolicTangent = h3.atanh = function() {
      var e2, n, i2, t2, r = this, s3 = r.constructor;
      return r.isFinite() ? r.e >= 0 ? new s3(r.abs().eq(1) ? r.s / 0 : r.isZero() ? r : NaN) : (e2 = s3.precision, n = s3.rounding, t2 = r.sd(), Math.max(t2, e2) < 2 * -r.e - 1 ? p(new s3(r), e2, n, true) : (s3.precision = i2 = t2 - r.e, r = S3(r.plus(1), new s3(1).minus(r), i2 + e2, 1), s3.precision = e2 + 4, s3.rounding = 1, r = r.ln(), s3.precision = e2, s3.rounding = n, r.times(0.5))) : new s3(NaN);
    };
    h3.inverseSine = h3.asin = function() {
      var e2, n, i2, t2, r = this, s3 = r.constructor;
      return r.isZero() ? new s3(r) : (n = r.abs().cmp(1), i2 = s3.precision, t2 = s3.rounding, n !== -1 ? n === 0 ? (e2 = L2(s3, i2 + 4, t2).times(0.5), e2.s = r.s, e2) : new s3(NaN) : (s3.precision = i2 + 6, s3.rounding = 1, r = r.div(new s3(1).minus(r.times(r)).sqrt().plus(1)).atan(), s3.precision = i2, s3.rounding = t2, r.times(2)));
    };
    h3.inverseTangent = h3.atan = function() {
      var e2, n, i2, t2, r, s3, o, u2, l, f = this, c2 = f.constructor, a3 = c2.precision, d3 = c2.rounding;
      if (f.isFinite()) {
        if (f.isZero()) return new c2(f);
        if (f.abs().eq(1) && a3 + 4 <= ve) return o = L2(c2, a3 + 4, d3).times(0.25), o.s = f.s, o;
      } else {
        if (!f.s) return new c2(NaN);
        if (a3 + 4 <= ve) return o = L2(c2, a3 + 4, d3).times(0.5), o.s = f.s, o;
      }
      for (c2.precision = u2 = a3 + 10, c2.rounding = 1, i2 = Math.min(28, u2 / m3 + 2 | 0), e2 = i2; e2; --e2) f = f.div(f.times(f).plus(1).sqrt().plus(1));
      for (w2 = false, n = Math.ceil(u2 / m3), t2 = 1, l = f.times(f), o = new c2(f), r = f; e2 !== -1; ) if (r = r.times(l), s3 = o.minus(r.div(t2 += 2)), r = r.times(l), o = s3.plus(r.div(t2 += 2)), o.d[n] !== void 0) for (e2 = n; o.d[e2] === s3.d[e2] && e2--; ) ;
      return i2 && (o = o.times(2 << i2 - 1)), w2 = true, p(o, c2.precision = a3, c2.rounding = d3, true);
    };
    h3.isFinite = function() {
      return !!this.d;
    };
    h3.isInteger = h3.isInt = function() {
      return !!this.d && b2(this.e / m3) > this.d.length - 2;
    };
    h3.isNaN = function() {
      return !this.s;
    };
    h3.isNegative = h3.isNeg = function() {
      return this.s < 0;
    };
    h3.isPositive = h3.isPos = function() {
      return this.s > 0;
    };
    h3.isZero = function() {
      return !!this.d && this.d[0] === 0;
    };
    h3.lessThan = h3.lt = function(e2) {
      return this.cmp(e2) < 0;
    };
    h3.lessThanOrEqualTo = h3.lte = function(e2) {
      return this.cmp(e2) < 1;
    };
    h3.logarithm = h3.log = function(e2) {
      var n, i2, t2, r, s3, o, u2, l, f = this, c2 = f.constructor, a3 = c2.precision, d3 = c2.rounding, g = 5;
      if (e2 == null) e2 = new c2(10), n = true;
      else {
        if (e2 = new c2(e2), i2 = e2.d, e2.s < 0 || !i2 || !i2[0] || e2.eq(1)) return new c2(NaN);
        n = e2.eq(10);
      }
      if (i2 = f.d, f.s < 0 || !i2 || !i2[0] || f.eq(1)) return new c2(i2 && !i2[0] ? -1 / 0 : f.s != 1 ? NaN : i2 ? 0 : 1 / 0);
      if (n) if (i2.length > 1) s3 = true;
      else {
        for (r = i2[0]; r % 10 === 0; ) r /= 10;
        s3 = r !== 1;
      }
      if (w2 = false, u2 = a3 + g, o = B2(f, u2), t2 = n ? se(c2, u2 + 10) : B2(e2, u2), l = S3(o, t2, u2, 1), x2(l.d, r = a3, d3)) do
        if (u2 += 10, o = B2(f, u2), t2 = n ? se(c2, u2 + 10) : B2(e2, u2), l = S3(o, t2, u2, 1), !s3) {
          +O2(l.d).slice(r + 1, r + 15) + 1 == 1e14 && (l = p(l, a3 + 1, 0));
          break;
        }
      while (x2(l.d, r += 10, d3));
      return w2 = true, p(l, a3, d3);
    };
    h3.minus = h3.sub = function(e2) {
      var n, i2, t2, r, s3, o, u2, l, f, c2, a3, d3, g = this, v = g.constructor;
      if (e2 = new v(e2), !g.d || !e2.d) return !g.s || !e2.s ? e2 = new v(NaN) : g.d ? e2.s = -e2.s : e2 = new v(e2.d || g.s !== e2.s ? g : NaN), e2;
      if (g.s != e2.s) return e2.s = -e2.s, g.plus(e2);
      if (f = g.d, d3 = e2.d, u2 = v.precision, l = v.rounding, !f[0] || !d3[0]) {
        if (d3[0]) e2.s = -e2.s;
        else if (f[0]) e2 = new v(g);
        else return new v(l === 3 ? -0 : 0);
        return w2 ? p(e2, u2, l) : e2;
      }
      if (i2 = b2(e2.e / m3), c2 = b2(g.e / m3), f = f.slice(), s3 = c2 - i2, s3) {
        for (a3 = s3 < 0, a3 ? (n = f, s3 = -s3, o = d3.length) : (n = d3, i2 = c2, o = f.length), t2 = Math.max(Math.ceil(u2 / m3), o) + 2, s3 > t2 && (s3 = t2, n.length = 1), n.reverse(), t2 = s3; t2--; ) n.push(0);
        n.reverse();
      } else {
        for (t2 = f.length, o = d3.length, a3 = t2 < o, a3 && (o = t2), t2 = 0; t2 < o; t2++) if (f[t2] != d3[t2]) {
          a3 = f[t2] < d3[t2];
          break;
        }
        s3 = 0;
      }
      for (a3 && (n = f, f = d3, d3 = n, e2.s = -e2.s), o = f.length, t2 = d3.length - o; t2 > 0; --t2) f[o++] = 0;
      for (t2 = d3.length; t2 > s3; ) {
        if (f[--t2] < d3[t2]) {
          for (r = t2; r && f[--r] === 0; ) f[r] = D2 - 1;
          --f[r], f[t2] += D2;
        }
        f[t2] -= d3[t2];
      }
      for (; f[--o] === 0; ) f.pop();
      for (; f[0] === 0; f.shift()) --i2;
      return f[0] ? (e2.d = f, e2.e = ue(f, i2), w2 ? p(e2, u2, l) : e2) : new v(l === 3 ? -0 : 0);
    };
    h3.modulo = h3.mod = function(e2) {
      var n, i2 = this, t2 = i2.constructor;
      return e2 = new t2(e2), !i2.d || !e2.s || e2.d && !e2.d[0] ? new t2(NaN) : !e2.d || i2.d && !i2.d[0] ? p(new t2(i2), t2.precision, t2.rounding) : (w2 = false, t2.modulo == 9 ? (n = S3(i2, e2.abs(), 0, 3, 1), n.s *= e2.s) : n = S3(i2, e2, 0, t2.modulo, 1), n = n.times(e2), w2 = true, i2.minus(n));
    };
    h3.naturalExponential = h3.exp = function() {
      return Ee(this);
    };
    h3.naturalLogarithm = h3.ln = function() {
      return B2(this);
    };
    h3.negated = h3.neg = function() {
      var e2 = new this.constructor(this);
      return e2.s = -e2.s, p(e2);
    };
    h3.plus = h3.add = function(e2) {
      var n, i2, t2, r, s3, o, u2, l, f, c2, a3 = this, d3 = a3.constructor;
      if (e2 = new d3(e2), !a3.d || !e2.d) return !a3.s || !e2.s ? e2 = new d3(NaN) : a3.d || (e2 = new d3(e2.d || a3.s === e2.s ? a3 : NaN)), e2;
      if (a3.s != e2.s) return e2.s = -e2.s, a3.minus(e2);
      if (f = a3.d, c2 = e2.d, u2 = d3.precision, l = d3.rounding, !f[0] || !c2[0]) return c2[0] || (e2 = new d3(a3)), w2 ? p(e2, u2, l) : e2;
      if (s3 = b2(a3.e / m3), t2 = b2(e2.e / m3), f = f.slice(), r = s3 - t2, r) {
        for (r < 0 ? (i2 = f, r = -r, o = c2.length) : (i2 = c2, t2 = s3, o = f.length), s3 = Math.ceil(u2 / m3), o = s3 > o ? s3 + 1 : o + 1, r > o && (r = o, i2.length = 1), i2.reverse(); r--; ) i2.push(0);
        i2.reverse();
      }
      for (o = f.length, r = c2.length, o - r < 0 && (r = o, i2 = c2, c2 = f, f = i2), n = 0; r; ) n = (f[--r] = f[r] + c2[r] + n) / D2 | 0, f[r] %= D2;
      for (n && (f.unshift(n), ++t2), o = f.length; f[--o] == 0; ) f.pop();
      return e2.d = f, e2.e = ue(f, t2), w2 ? p(e2, u2, l) : e2;
    };
    h3.precision = h3.sd = function(e2) {
      var n, i2 = this;
      if (e2 !== void 0 && e2 !== !!e2 && e2 !== 1 && e2 !== 0) throw Error(V + e2);
      return i2.d ? (n = Ze(i2.d), e2 && i2.e + 1 > n && (n = i2.e + 1)) : n = NaN, n;
    };
    h3.round = function() {
      var e2 = this, n = e2.constructor;
      return p(new n(e2), e2.e + 1, n.rounding);
    };
    h3.sine = h3.sin = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return i2.isFinite() ? i2.isZero() ? new t2(i2) : (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + Math.max(i2.e, i2.sd()) + m3, t2.rounding = 1, i2 = un(t2, $e(t2, i2)), t2.precision = e2, t2.rounding = n, p(Z > 2 ? i2.neg() : i2, e2, n, true)) : new t2(NaN);
    };
    h3.squareRoot = h3.sqrt = function() {
      var e2, n, i2, t2, r, s3, o = this, u2 = o.d, l = o.e, f = o.s, c2 = o.constructor;
      if (f !== 1 || !u2 || !u2[0]) return new c2(!f || f < 0 && (!u2 || u2[0]) ? NaN : u2 ? o : 1 / 0);
      for (w2 = false, f = Math.sqrt(+o), f == 0 || f == 1 / 0 ? (n = O2(u2), (n.length + l) % 2 == 0 && (n += "0"), f = Math.sqrt(n), l = b2((l + 1) / 2) - (l < 0 || l % 2), f == 1 / 0 ? n = "5e" + l : (n = f.toExponential(), n = n.slice(0, n.indexOf("e") + 1) + l), t2 = new c2(n)) : t2 = new c2(f.toString()), i2 = (l = c2.precision) + 3; ; ) if (s3 = t2, t2 = s3.plus(S3(o, s3, i2 + 2, 1)).times(0.5), O2(s3.d).slice(0, i2) === (n = O2(t2.d)).slice(0, i2)) if (n = n.slice(i2 - 3, i2 + 1), n == "9999" || !r && n == "4999") {
        if (!r && (p(s3, l + 1, 0), s3.times(s3).eq(o))) {
          t2 = s3;
          break;
        }
        i2 += 4, r = 1;
      } else {
        (!+n || !+n.slice(1) && n.charAt(0) == "5") && (p(t2, l + 1, 1), e2 = !t2.times(t2).eq(o));
        break;
      }
      return w2 = true, p(t2, l, c2.rounding, e2);
    };
    h3.tangent = h3.tan = function() {
      var e2, n, i2 = this, t2 = i2.constructor;
      return i2.isFinite() ? i2.isZero() ? new t2(i2) : (e2 = t2.precision, n = t2.rounding, t2.precision = e2 + 10, t2.rounding = 1, i2 = i2.sin(), i2.s = 1, i2 = S3(i2, new t2(1).minus(i2.times(i2)).sqrt(), e2 + 10, 0), t2.precision = e2, t2.rounding = n, p(Z == 2 || Z == 4 ? i2.neg() : i2, e2, n, true)) : new t2(NaN);
    };
    h3.times = h3.mul = function(e2) {
      var n, i2, t2, r, s3, o, u2, l, f, c2 = this, a3 = c2.constructor, d3 = c2.d, g = (e2 = new a3(e2)).d;
      if (e2.s *= c2.s, !d3 || !d3[0] || !g || !g[0]) return new a3(!e2.s || d3 && !d3[0] && !g || g && !g[0] && !d3 ? NaN : !d3 || !g ? e2.s / 0 : e2.s * 0);
      for (i2 = b2(c2.e / m3) + b2(e2.e / m3), l = d3.length, f = g.length, l < f && (s3 = d3, d3 = g, g = s3, o = l, l = f, f = o), s3 = [], o = l + f, t2 = o; t2--; ) s3.push(0);
      for (t2 = f; --t2 >= 0; ) {
        for (n = 0, r = l + t2; r > t2; ) u2 = s3[r] + g[t2] * d3[r - t2 - 1] + n, s3[r--] = u2 % D2 | 0, n = u2 / D2 | 0;
        s3[r] = (s3[r] + n) % D2 | 0;
      }
      for (; !s3[--o]; ) s3.pop();
      return n ? ++i2 : s3.shift(), e2.d = s3, e2.e = ue(s3, i2), w2 ? p(e2, a3.precision, a3.rounding) : e2;
    };
    h3.toBinary = function(e2, n) {
      return ke(this, 2, e2, n);
    };
    h3.toDecimalPlaces = h3.toDP = function(e2, n) {
      var i2 = this, t2 = i2.constructor;
      return i2 = new t2(i2), e2 === void 0 ? i2 : (_(e2, 0, $), n === void 0 ? n = t2.rounding : _(n, 0, 8), p(i2, e2 + i2.e + 1, n));
    };
    h3.toExponential = function(e2, n) {
      var i2, t2 = this, r = t2.constructor;
      return e2 === void 0 ? i2 = F(t2, true) : (_(e2, 0, $), n === void 0 ? n = r.rounding : _(n, 0, 8), t2 = p(new r(t2), e2 + 1, n), i2 = F(t2, true, e2 + 1)), t2.isNeg() && !t2.isZero() ? "-" + i2 : i2;
    };
    h3.toFixed = function(e2, n) {
      var i2, t2, r = this, s3 = r.constructor;
      return e2 === void 0 ? i2 = F(r) : (_(e2, 0, $), n === void 0 ? n = s3.rounding : _(n, 0, 8), t2 = p(new s3(r), e2 + r.e + 1, n), i2 = F(t2, false, e2 + t2.e + 1)), r.isNeg() && !r.isZero() ? "-" + i2 : i2;
    };
    h3.toFraction = function(e2) {
      var n, i2, t2, r, s3, o, u2, l, f, c2, a3, d3, g = this, v = g.d, N = g.constructor;
      if (!v) return new N(g);
      if (f = i2 = new N(1), t2 = l = new N(0), n = new N(t2), s3 = n.e = Ze(v) - g.e - 1, o = s3 % m3, n.d[0] = C(10, o < 0 ? m3 + o : o), e2 == null) e2 = s3 > 0 ? n : f;
      else {
        if (u2 = new N(e2), !u2.isInt() || u2.lt(f)) throw Error(V + u2);
        e2 = u2.gt(n) ? s3 > 0 ? n : f : u2;
      }
      for (w2 = false, u2 = new N(O2(v)), c2 = N.precision, N.precision = s3 = v.length * m3 * 2; a3 = S3(u2, n, 0, 1, 1), r = i2.plus(a3.times(t2)), r.cmp(e2) != 1; ) i2 = t2, t2 = r, r = f, f = l.plus(a3.times(r)), l = r, r = n, n = u2.minus(a3.times(r)), u2 = r;
      return r = S3(e2.minus(i2), t2, 0, 1, 1), l = l.plus(r.times(f)), i2 = i2.plus(r.times(t2)), l.s = f.s = g.s, d3 = S3(f, t2, s3, 1).minus(g).abs().cmp(S3(l, i2, s3, 1).minus(g).abs()) < 1 ? [f, t2] : [l, i2], N.precision = c2, w2 = true, d3;
    };
    h3.toHexadecimal = h3.toHex = function(e2, n) {
      return ke(this, 16, e2, n);
    };
    h3.toNearest = function(e2, n) {
      var i2 = this, t2 = i2.constructor;
      if (i2 = new t2(i2), e2 == null) {
        if (!i2.d) return i2;
        e2 = new t2(1), n = t2.rounding;
      } else {
        if (e2 = new t2(e2), n === void 0 ? n = t2.rounding : _(n, 0, 8), !i2.d) return e2.s ? i2 : e2;
        if (!e2.d) return e2.s && (e2.s = i2.s), e2;
      }
      return e2.d[0] ? (w2 = false, i2 = S3(i2, e2, 0, n, 1).times(e2), w2 = true, p(i2)) : (e2.s = i2.s, i2 = e2), i2;
    };
    h3.toNumber = function() {
      return +this;
    };
    h3.toOctal = function(e2, n) {
      return ke(this, 8, e2, n);
    };
    h3.toPower = h3.pow = function(e2) {
      var n, i2, t2, r, s3, o, u2 = this, l = u2.constructor, f = +(e2 = new l(e2));
      if (!u2.d || !e2.d || !u2.d[0] || !e2.d[0]) return new l(C(+u2, f));
      if (u2 = new l(u2), u2.eq(1)) return u2;
      if (t2 = l.precision, s3 = l.rounding, e2.eq(1)) return p(u2, t2, s3);
      if (n = b2(e2.e / m3), n >= e2.d.length - 1 && (i2 = f < 0 ? -f : f) <= tn) return r = Ue(l, u2, i2, t2), e2.s < 0 ? new l(1).div(r) : p(r, t2, s3);
      if (o = u2.s, o < 0) {
        if (n < e2.d.length - 1) return new l(NaN);
        if (e2.d[n] & 1 || (o = 1), u2.e == 0 && u2.d[0] == 1 && u2.d.length == 1) return u2.s = o, u2;
      }
      return i2 = C(+u2, f), n = i2 == 0 || !isFinite(i2) ? b2(f * (Math.log("0." + O2(u2.d)) / Math.LN10 + u2.e + 1)) : new l(i2 + "").e, n > l.maxE + 1 || n < l.minE - 1 ? new l(n > 0 ? o / 0 : 0) : (w2 = false, l.rounding = u2.s = 1, i2 = Math.min(12, (n + "").length), r = Ee(e2.times(B2(u2, t2 + i2)), t2), r.d && (r = p(r, t2 + 5, 1), x2(r.d, t2, s3) && (n = t2 + 10, r = p(Ee(e2.times(B2(u2, n + i2)), n), n + 5, 1), +O2(r.d).slice(t2 + 1, t2 + 15) + 1 == 1e14 && (r = p(r, t2 + 1, 0)))), r.s = o, w2 = true, l.rounding = s3, p(r, t2, s3));
    };
    h3.toPrecision = function(e2, n) {
      var i2, t2 = this, r = t2.constructor;
      return e2 === void 0 ? i2 = F(t2, t2.e <= r.toExpNeg || t2.e >= r.toExpPos) : (_(e2, 1, $), n === void 0 ? n = r.rounding : _(n, 0, 8), t2 = p(new r(t2), e2, n), i2 = F(t2, e2 <= t2.e || t2.e <= r.toExpNeg, e2)), t2.isNeg() && !t2.isZero() ? "-" + i2 : i2;
    };
    h3.toSignificantDigits = h3.toSD = function(e2, n) {
      var i2 = this, t2 = i2.constructor;
      return e2 === void 0 ? (e2 = t2.precision, n = t2.rounding) : (_(e2, 1, $), n === void 0 ? n = t2.rounding : _(n, 0, 8)), p(new t2(i2), e2, n);
    };
    h3.toString = function() {
      var e2 = this, n = e2.constructor, i2 = F(e2, e2.e <= n.toExpNeg || e2.e >= n.toExpPos);
      return e2.isNeg() && !e2.isZero() ? "-" + i2 : i2;
    };
    h3.truncated = h3.trunc = function() {
      return p(new this.constructor(this), this.e + 1, 1);
    };
    h3.valueOf = h3.toJSON = function() {
      var e2 = this, n = e2.constructor, i2 = F(e2, e2.e <= n.toExpNeg || e2.e >= n.toExpPos);
      return e2.isNeg() ? "-" + i2 : i2;
    };
    function O2(e2) {
      var n, i2, t2, r = e2.length - 1, s3 = "", o = e2[0];
      if (r > 0) {
        for (s3 += o, n = 1; n < r; n++) t2 = e2[n] + "", i2 = m3 - t2.length, i2 && (s3 += U(i2)), s3 += t2;
        o = e2[n], t2 = o + "", i2 = m3 - t2.length, i2 && (s3 += U(i2));
      } else if (o === 0) return "0";
      for (; o % 10 === 0; ) o /= 10;
      return s3 + o;
    }
    function _(e2, n, i2) {
      if (e2 !== ~~e2 || e2 < n || e2 > i2) throw Error(V + e2);
    }
    function x2(e2, n, i2, t2) {
      var r, s3, o, u2;
      for (s3 = e2[0]; s3 >= 10; s3 /= 10) --n;
      return --n < 0 ? (n += m3, r = 0) : (r = Math.ceil((n + 1) / m3), n %= m3), s3 = C(10, m3 - n), u2 = e2[r] % s3 | 0, t2 == null ? n < 3 ? (n == 0 ? u2 = u2 / 100 | 0 : n == 1 && (u2 = u2 / 10 | 0), o = i2 < 4 && u2 == 99999 || i2 > 3 && u2 == 49999 || u2 == 5e4 || u2 == 0) : o = (i2 < 4 && u2 + 1 == s3 || i2 > 3 && u2 + 1 == s3 / 2) && (e2[r + 1] / s3 / 100 | 0) == C(10, n - 2) - 1 || (u2 == s3 / 2 || u2 == 0) && (e2[r + 1] / s3 / 100 | 0) == 0 : n < 4 ? (n == 0 ? u2 = u2 / 1e3 | 0 : n == 1 ? u2 = u2 / 100 | 0 : n == 2 && (u2 = u2 / 10 | 0), o = (t2 || i2 < 4) && u2 == 9999 || !t2 && i2 > 3 && u2 == 4999) : o = ((t2 || i2 < 4) && u2 + 1 == s3 || !t2 && i2 > 3 && u2 + 1 == s3 / 2) && (e2[r + 1] / s3 / 1e3 | 0) == C(10, n - 3) - 1, o;
    }
    function ie(e2, n, i2) {
      for (var t2, r = [0], s3, o = 0, u2 = e2.length; o < u2; ) {
        for (s3 = r.length; s3--; ) r[s3] *= n;
        for (r[0] += we.indexOf(e2.charAt(o++)), t2 = 0; t2 < r.length; t2++) r[t2] > i2 - 1 && (r[t2 + 1] === void 0 && (r[t2 + 1] = 0), r[t2 + 1] += r[t2] / i2 | 0, r[t2] %= i2);
      }
      return r.reverse();
    }
    function sn(e2, n) {
      var i2, t2, r;
      if (n.isZero()) return n;
      t2 = n.d.length, t2 < 32 ? (i2 = Math.ceil(t2 / 3), r = (1 / fe(4, i2)).toString()) : (i2 = 16, r = "2.3283064365386962890625e-10"), e2.precision += i2, n = j(e2, 1, n.times(r), new e2(1));
      for (var s3 = i2; s3--; ) {
        var o = n.times(n);
        n = o.times(o).minus(o).times(8).plus(1);
      }
      return e2.precision -= i2, n;
    }
    var S3 = /* @__PURE__ */ function() {
      function e2(t2, r, s3) {
        var o, u2 = 0, l = t2.length;
        for (t2 = t2.slice(); l--; ) o = t2[l] * r + u2, t2[l] = o % s3 | 0, u2 = o / s3 | 0;
        return u2 && t2.unshift(u2), t2;
      }
      function n(t2, r, s3, o) {
        var u2, l;
        if (s3 != o) l = s3 > o ? 1 : -1;
        else for (u2 = l = 0; u2 < s3; u2++) if (t2[u2] != r[u2]) {
          l = t2[u2] > r[u2] ? 1 : -1;
          break;
        }
        return l;
      }
      function i2(t2, r, s3, o) {
        for (var u2 = 0; s3--; ) t2[s3] -= u2, u2 = t2[s3] < r[s3] ? 1 : 0, t2[s3] = u2 * o + t2[s3] - r[s3];
        for (; !t2[0] && t2.length > 1; ) t2.shift();
      }
      return function(t2, r, s3, o, u2, l) {
        var f, c2, a3, d3, g, v, N, A, M3, q2, E2, P, Y2, I2, le, z110, W, ce, T2, y3, ee = t2.constructor, ae = t2.s == r.s ? 1 : -1, R2 = t2.d, k2 = r.d;
        if (!R2 || !R2[0] || !k2 || !k2[0]) return new ee(!t2.s || !r.s || (R2 ? k2 && R2[0] == k2[0] : !k2) ? NaN : R2 && R2[0] == 0 || !k2 ? ae * 0 : ae / 0);
        for (l ? (g = 1, c2 = t2.e - r.e) : (l = D2, g = m3, c2 = b2(t2.e / g) - b2(r.e / g)), T2 = k2.length, W = R2.length, M3 = new ee(ae), q2 = M3.d = [], a3 = 0; k2[a3] == (R2[a3] || 0); a3++) ;
        if (k2[a3] > (R2[a3] || 0) && c2--, s3 == null ? (I2 = s3 = ee.precision, o = ee.rounding) : u2 ? I2 = s3 + (t2.e - r.e) + 1 : I2 = s3, I2 < 0) q2.push(1), v = true;
        else {
          if (I2 = I2 / g + 2 | 0, a3 = 0, T2 == 1) {
            for (d3 = 0, k2 = k2[0], I2++; (a3 < W || d3) && I2--; a3++) le = d3 * l + (R2[a3] || 0), q2[a3] = le / k2 | 0, d3 = le % k2 | 0;
            v = d3 || a3 < W;
          } else {
            for (d3 = l / (k2[0] + 1) | 0, d3 > 1 && (k2 = e2(k2, d3, l), R2 = e2(R2, d3, l), T2 = k2.length, W = R2.length), z110 = T2, E2 = R2.slice(0, T2), P = E2.length; P < T2; ) E2[P++] = 0;
            y3 = k2.slice(), y3.unshift(0), ce = k2[0], k2[1] >= l / 2 && ++ce;
            do
              d3 = 0, f = n(k2, E2, T2, P), f < 0 ? (Y2 = E2[0], T2 != P && (Y2 = Y2 * l + (E2[1] || 0)), d3 = Y2 / ce | 0, d3 > 1 ? (d3 >= l && (d3 = l - 1), N = e2(k2, d3, l), A = N.length, P = E2.length, f = n(N, E2, A, P), f == 1 && (d3--, i2(N, T2 < A ? y3 : k2, A, l))) : (d3 == 0 && (f = d3 = 1), N = k2.slice()), A = N.length, A < P && N.unshift(0), i2(E2, N, P, l), f == -1 && (P = E2.length, f = n(k2, E2, T2, P), f < 1 && (d3++, i2(E2, T2 < P ? y3 : k2, P, l))), P = E2.length) : f === 0 && (d3++, E2 = [0]), q2[a3++] = d3, f && E2[0] ? E2[P++] = R2[z110] || 0 : (E2 = [R2[z110]], P = 1);
            while ((z110++ < W || E2[0] !== void 0) && I2--);
            v = E2[0] !== void 0;
          }
          q2[0] || q2.shift();
        }
        if (g == 1) M3.e = c2, Te = v;
        else {
          for (a3 = 1, d3 = q2[0]; d3 >= 10; d3 /= 10) a3++;
          M3.e = a3 + c2 * g - 1, p(M3, u2 ? s3 + M3.e + 1 : s3, o, v);
        }
        return M3;
      };
    }();
    function p(e2, n, i2, t2) {
      var r, s3, o, u2, l, f, c2, a3, d3, g = e2.constructor;
      e: if (n != null) {
        if (a3 = e2.d, !a3) return e2;
        for (r = 1, u2 = a3[0]; u2 >= 10; u2 /= 10) r++;
        if (s3 = n - r, s3 < 0) s3 += m3, o = n, c2 = a3[d3 = 0], l = c2 / C(10, r - o - 1) % 10 | 0;
        else if (d3 = Math.ceil((s3 + 1) / m3), u2 = a3.length, d3 >= u2) if (t2) {
          for (; u2++ <= d3; ) a3.push(0);
          c2 = l = 0, r = 1, s3 %= m3, o = s3 - m3 + 1;
        } else break e;
        else {
          for (c2 = u2 = a3[d3], r = 1; u2 >= 10; u2 /= 10) r++;
          s3 %= m3, o = s3 - m3 + r, l = o < 0 ? 0 : c2 / C(10, r - o - 1) % 10 | 0;
        }
        if (t2 = t2 || n < 0 || a3[d3 + 1] !== void 0 || (o < 0 ? c2 : c2 % C(10, r - o - 1)), f = i2 < 4 ? (l || t2) && (i2 == 0 || i2 == (e2.s < 0 ? 3 : 2)) : l > 5 || l == 5 && (i2 == 4 || t2 || i2 == 6 && (s3 > 0 ? o > 0 ? c2 / C(10, r - o) : 0 : a3[d3 - 1]) % 10 & 1 || i2 == (e2.s < 0 ? 8 : 7)), n < 1 || !a3[0]) return a3.length = 0, f ? (n -= e2.e + 1, a3[0] = C(10, (m3 - n % m3) % m3), e2.e = -n || 0) : a3[0] = e2.e = 0, e2;
        if (s3 == 0 ? (a3.length = d3, u2 = 1, d3--) : (a3.length = d3 + 1, u2 = C(10, m3 - s3), a3[d3] = o > 0 ? (c2 / C(10, r - o) % C(10, o) | 0) * u2 : 0), f) for (; ; ) if (d3 == 0) {
          for (s3 = 1, o = a3[0]; o >= 10; o /= 10) s3++;
          for (o = a3[0] += u2, u2 = 1; o >= 10; o /= 10) u2++;
          s3 != u2 && (e2.e++, a3[0] == D2 && (a3[0] = 1));
          break;
        } else {
          if (a3[d3] += u2, a3[d3] != D2) break;
          a3[d3--] = 0, u2 = 1;
        }
        for (s3 = a3.length; a3[--s3] === 0; ) a3.pop();
      }
      return w2 && (e2.e > g.maxE ? (e2.d = null, e2.e = NaN) : e2.e < g.minE && (e2.e = 0, e2.d = [0])), e2;
    }
    function F(e2, n, i2) {
      if (!e2.isFinite()) return Ve(e2);
      var t2, r = e2.e, s3 = O2(e2.d), o = s3.length;
      return n ? (i2 && (t2 = i2 - o) > 0 ? s3 = s3.charAt(0) + "." + s3.slice(1) + U(t2) : o > 1 && (s3 = s3.charAt(0) + "." + s3.slice(1)), s3 = s3 + (e2.e < 0 ? "e" : "e+") + e2.e) : r < 0 ? (s3 = "0." + U(-r - 1) + s3, i2 && (t2 = i2 - o) > 0 && (s3 += U(t2))) : r >= o ? (s3 += U(r + 1 - o), i2 && (t2 = i2 - r - 1) > 0 && (s3 = s3 + "." + U(t2))) : ((t2 = r + 1) < o && (s3 = s3.slice(0, t2) + "." + s3.slice(t2)), i2 && (t2 = i2 - o) > 0 && (r + 1 === o && (s3 += "."), s3 += U(t2))), s3;
    }
    function ue(e2, n) {
      var i2 = e2[0];
      for (n *= m3; i2 >= 10; i2 /= 10) n++;
      return n;
    }
    function se(e2, n, i2) {
      if (n > rn) throw w2 = true, i2 && (e2.precision = i2), Error(Le);
      return p(new e2(te), n, 1, true);
    }
    function L2(e2, n, i2) {
      if (n > ve) throw Error(Le);
      return p(new e2(re), n, i2, true);
    }
    function Ze(e2) {
      var n = e2.length - 1, i2 = n * m3 + 1;
      if (n = e2[n], n) {
        for (; n % 10 == 0; n /= 10) i2--;
        for (n = e2[0]; n >= 10; n /= 10) i2++;
      }
      return i2;
    }
    function U(e2) {
      for (var n = ""; e2--; ) n += "0";
      return n;
    }
    function Ue(e2, n, i2, t2) {
      var r, s3 = new e2(1), o = Math.ceil(t2 / m3 + 4);
      for (w2 = false; ; ) {
        if (i2 % 2 && (s3 = s3.times(n), _e(s3.d, o) && (r = true)), i2 = b2(i2 / 2), i2 === 0) {
          i2 = s3.d.length - 1, r && s3.d[i2] === 0 && ++s3.d[i2];
          break;
        }
        n = n.times(n), _e(n.d, o);
      }
      return w2 = true, s3;
    }
    function Ae(e2) {
      return e2.d[e2.d.length - 1] & 1;
    }
    function Be(e2, n, i2) {
      for (var t2, r = new e2(n[0]), s3 = 0; ++s3 < n.length; ) if (t2 = new e2(n[s3]), t2.s) r[i2](t2) && (r = t2);
      else {
        r = t2;
        break;
      }
      return r;
    }
    function Ee(e2, n) {
      var i2, t2, r, s3, o, u2, l, f = 0, c2 = 0, a3 = 0, d3 = e2.constructor, g = d3.rounding, v = d3.precision;
      if (!e2.d || !e2.d[0] || e2.e > 17) return new d3(e2.d ? e2.d[0] ? e2.s < 0 ? 0 : 1 / 0 : 1 : e2.s ? e2.s < 0 ? 0 : e2 : NaN);
      for (n == null ? (w2 = false, l = v) : l = n, u2 = new d3(0.03125); e2.e > -2; ) e2 = e2.times(u2), a3 += 5;
      for (t2 = Math.log(C(2, a3)) / Math.LN10 * 2 + 5 | 0, l += t2, i2 = s3 = o = new d3(1), d3.precision = l; ; ) {
        if (s3 = p(s3.times(e2), l, 1), i2 = i2.times(++c2), u2 = o.plus(S3(s3, i2, l, 1)), O2(u2.d).slice(0, l) === O2(o.d).slice(0, l)) {
          for (r = a3; r--; ) o = p(o.times(o), l, 1);
          if (n == null) if (f < 3 && x2(o.d, l - t2, g, f)) d3.precision = l += 10, i2 = s3 = u2 = new d3(1), c2 = 0, f++;
          else return p(o, d3.precision = v, g, w2 = true);
          else return d3.precision = v, o;
        }
        o = u2;
      }
    }
    function B2(e2, n) {
      var i2, t2, r, s3, o, u2, l, f, c2, a3, d3, g = 1, v = 10, N = e2, A = N.d, M3 = N.constructor, q2 = M3.rounding, E2 = M3.precision;
      if (N.s < 0 || !A || !A[0] || !N.e && A[0] == 1 && A.length == 1) return new M3(A && !A[0] ? -1 / 0 : N.s != 1 ? NaN : A ? 0 : N);
      if (n == null ? (w2 = false, c2 = E2) : c2 = n, M3.precision = c2 += v, i2 = O2(A), t2 = i2.charAt(0), Math.abs(s3 = N.e) < 15e14) {
        for (; t2 < 7 && t2 != 1 || t2 == 1 && i2.charAt(1) > 3; ) N = N.times(e2), i2 = O2(N.d), t2 = i2.charAt(0), g++;
        s3 = N.e, t2 > 1 ? (N = new M3("0." + i2), s3++) : N = new M3(t2 + "." + i2.slice(1));
      } else return f = se(M3, c2 + 2, E2).times(s3 + ""), N = B2(new M3(t2 + "." + i2.slice(1)), c2 - v).plus(f), M3.precision = E2, n == null ? p(N, E2, q2, w2 = true) : N;
      for (a3 = N, l = o = N = S3(N.minus(1), N.plus(1), c2, 1), d3 = p(N.times(N), c2, 1), r = 3; ; ) {
        if (o = p(o.times(d3), c2, 1), f = l.plus(S3(o, new M3(r), c2, 1)), O2(f.d).slice(0, c2) === O2(l.d).slice(0, c2)) if (l = l.times(2), s3 !== 0 && (l = l.plus(se(M3, c2 + 2, E2).times(s3 + ""))), l = S3(l, new M3(g), c2, 1), n == null) if (x2(l.d, c2 - v, q2, u2)) M3.precision = c2 += v, f = o = N = S3(a3.minus(1), a3.plus(1), c2, 1), d3 = p(N.times(N), c2, 1), r = u2 = 1;
        else return p(l, M3.precision = E2, q2, w2 = true);
        else return M3.precision = E2, l;
        l = f, r += 2;
      }
    }
    function Ve(e2) {
      return String(e2.s * e2.s / 0);
    }
    function Se(e2, n) {
      var i2, t2, r;
      for ((i2 = n.indexOf(".")) > -1 && (n = n.replace(".", "")), (t2 = n.search(/e/i)) > 0 ? (i2 < 0 && (i2 = t2), i2 += +n.slice(t2 + 1), n = n.substring(0, t2)) : i2 < 0 && (i2 = n.length), t2 = 0; n.charCodeAt(t2) === 48; t2++) ;
      for (r = n.length; n.charCodeAt(r - 1) === 48; --r) ;
      if (n = n.slice(t2, r), n) {
        if (r -= t2, e2.e = i2 = i2 - t2 - 1, e2.d = [], t2 = (i2 + 1) % m3, i2 < 0 && (t2 += m3), t2 < r) {
          for (t2 && e2.d.push(+n.slice(0, t2)), r -= m3; t2 < r; ) e2.d.push(+n.slice(t2, t2 += m3));
          n = n.slice(t2), t2 = m3 - n.length;
        } else t2 -= r;
        for (; t2--; ) n += "0";
        e2.d.push(+n), w2 && (e2.e > e2.constructor.maxE ? (e2.d = null, e2.e = NaN) : e2.e < e2.constructor.minE && (e2.e = 0, e2.d = [0]));
      } else e2.e = 0, e2.d = [0];
      return e2;
    }
    function on(e2, n) {
      var i2, t2, r, s3, o, u2, l, f, c2;
      if (n.indexOf("_") > -1) {
        if (n = n.replace(/(\d)_(?=\d)/g, "$1"), Ie.test(n)) return Se(e2, n);
      } else if (n === "Infinity" || n === "NaN") return +n || (e2.s = NaN), e2.e = NaN, e2.d = null, e2;
      if (en.test(n)) i2 = 16, n = n.toLowerCase();
      else if (ye.test(n)) i2 = 2;
      else if (nn.test(n)) i2 = 8;
      else throw Error(V + n);
      for (s3 = n.search(/p/i), s3 > 0 ? (l = +n.slice(s3 + 1), n = n.substring(2, s3)) : n = n.slice(2), s3 = n.indexOf("."), o = s3 >= 0, t2 = e2.constructor, o && (n = n.replace(".", ""), u2 = n.length, s3 = u2 - s3, r = Ue(t2, new t2(i2), s3, s3 * 2)), f = ie(n, i2, D2), c2 = f.length - 1, s3 = c2; f[s3] === 0; --s3) f.pop();
      return s3 < 0 ? new t2(e2.s * 0) : (e2.e = ue(f, c2), e2.d = f, w2 = false, o && (e2 = S3(e2, r, u2 * 4)), l && (e2 = e2.times(Math.abs(l) < 54 ? C(2, l) : Q2.pow(2, l))), w2 = true, e2);
    }
    function un(e2, n) {
      var i2, t2 = n.d.length;
      if (t2 < 3) return n.isZero() ? n : j(e2, 2, n, n);
      i2 = 1.4 * Math.sqrt(t2), i2 = i2 > 16 ? 16 : i2 | 0, n = n.times(1 / fe(5, i2)), n = j(e2, 2, n, n);
      for (var r, s3 = new e2(5), o = new e2(16), u2 = new e2(20); i2--; ) r = n.times(n), n = n.times(s3.plus(r.times(o.times(r).minus(u2))));
      return n;
    }
    function j(e2, n, i2, t2, r) {
      var s3, o, u2, l, f = 1, c2 = e2.precision, a3 = Math.ceil(c2 / m3);
      for (w2 = false, l = i2.times(i2), u2 = new e2(t2); ; ) {
        if (o = S3(u2.times(l), new e2(n++ * n++), c2, 1), u2 = r ? t2.plus(o) : t2.minus(o), t2 = S3(o.times(l), new e2(n++ * n++), c2, 1), o = u2.plus(t2), o.d[a3] !== void 0) {
          for (s3 = a3; o.d[s3] === u2.d[s3] && s3--; ) ;
          if (s3 == -1) break;
        }
        s3 = u2, u2 = t2, t2 = o, o = s3, f++;
      }
      return w2 = true, o.d.length = a3 + 1, o;
    }
    function fe(e2, n) {
      for (var i2 = e2; --n; ) i2 *= e2;
      return i2;
    }
    function $e(e2, n) {
      var i2, t2 = n.s < 0, r = L2(e2, e2.precision, 1), s3 = r.times(0.5);
      if (n = n.abs(), n.lte(s3)) return Z = t2 ? 4 : 1, n;
      if (i2 = n.divToInt(r), i2.isZero()) Z = t2 ? 3 : 2;
      else {
        if (n = n.minus(i2.times(r)), n.lte(s3)) return Z = Ae(i2) ? t2 ? 2 : 3 : t2 ? 4 : 1, n;
        Z = Ae(i2) ? t2 ? 1 : 4 : t2 ? 3 : 2;
      }
      return n.minus(r).abs();
    }
    function ke(e2, n, i2, t2) {
      var r, s3, o, u2, l, f, c2, a3, d3, g = e2.constructor, v = i2 !== void 0;
      if (v ? (_(i2, 1, $), t2 === void 0 ? t2 = g.rounding : _(t2, 0, 8)) : (i2 = g.precision, t2 = g.rounding), !e2.isFinite()) c2 = Ve(e2);
      else {
        for (c2 = F(e2), o = c2.indexOf("."), v ? (r = 2, n == 16 ? i2 = i2 * 4 - 3 : n == 8 && (i2 = i2 * 3 - 2)) : r = n, o >= 0 && (c2 = c2.replace(".", ""), d3 = new g(1), d3.e = c2.length - o, d3.d = ie(F(d3), 10, r), d3.e = d3.d.length), a3 = ie(c2, 10, r), s3 = l = a3.length; a3[--l] == 0; ) a3.pop();
        if (!a3[0]) c2 = v ? "0p+0" : "0";
        else {
          if (o < 0 ? s3-- : (e2 = new g(e2), e2.d = a3, e2.e = s3, e2 = S3(e2, d3, i2, t2, 0, r), a3 = e2.d, s3 = e2.e, f = Te), o = a3[i2], u2 = r / 2, f = f || a3[i2 + 1] !== void 0, f = t2 < 4 ? (o !== void 0 || f) && (t2 === 0 || t2 === (e2.s < 0 ? 3 : 2)) : o > u2 || o === u2 && (t2 === 4 || f || t2 === 6 && a3[i2 - 1] & 1 || t2 === (e2.s < 0 ? 8 : 7)), a3.length = i2, f) for (; ++a3[--i2] > r - 1; ) a3[i2] = 0, i2 || (++s3, a3.unshift(1));
          for (l = a3.length; !a3[l - 1]; --l) ;
          for (o = 0, c2 = ""; o < l; o++) c2 += we.charAt(a3[o]);
          if (v) {
            if (l > 1) if (n == 16 || n == 8) {
              for (o = n == 16 ? 4 : 3, --l; l % o; l++) c2 += "0";
              for (a3 = ie(c2, r, n), l = a3.length; !a3[l - 1]; --l) ;
              for (o = 1, c2 = "1."; o < l; o++) c2 += we.charAt(a3[o]);
            } else c2 = c2.charAt(0) + "." + c2.slice(1);
            c2 = c2 + (s3 < 0 ? "p" : "p+") + s3;
          } else if (s3 < 0) {
            for (; ++s3; ) c2 = "0" + c2;
            c2 = "0." + c2;
          } else if (++s3 > l) for (s3 -= l; s3--; ) c2 += "0";
          else s3 < l && (c2 = c2.slice(0, s3) + "." + c2.slice(s3));
        }
        c2 = (n == 16 ? "0x" : n == 2 ? "0b" : n == 8 ? "0o" : "") + c2;
      }
      return e2.s < 0 ? "-" + c2 : c2;
    }
    function _e(e2, n) {
      if (e2.length > n) return e2.length = n, true;
    }
    function fn(e2) {
      return new this(e2).abs();
    }
    function ln(e2) {
      return new this(e2).acos();
    }
    function cn(e2) {
      return new this(e2).acosh();
    }
    function an(e2, n) {
      return new this(e2).plus(n);
    }
    function dn(e2) {
      return new this(e2).asin();
    }
    function hn(e2) {
      return new this(e2).asinh();
    }
    function pn(e2) {
      return new this(e2).atan();
    }
    function gn(e2) {
      return new this(e2).atanh();
    }
    function mn(e2, n) {
      e2 = new this(e2), n = new this(n);
      var i2, t2 = this.precision, r = this.rounding, s3 = t2 + 4;
      return !e2.s || !n.s ? i2 = new this(NaN) : !e2.d && !n.d ? (i2 = L2(this, s3, 1).times(n.s > 0 ? 0.25 : 0.75), i2.s = e2.s) : !n.d || e2.isZero() ? (i2 = n.s < 0 ? L2(this, t2, r) : new this(0), i2.s = e2.s) : !e2.d || n.isZero() ? (i2 = L2(this, s3, 1).times(0.5), i2.s = e2.s) : n.s < 0 ? (this.precision = s3, this.rounding = 1, i2 = this.atan(S3(e2, n, s3, 1)), n = L2(this, s3, 1), this.precision = t2, this.rounding = r, i2 = e2.s < 0 ? i2.minus(n) : i2.plus(n)) : i2 = this.atan(S3(e2, n, s3, 1)), i2;
    }
    function wn(e2) {
      return new this(e2).cbrt();
    }
    function Nn(e2) {
      return p(e2 = new this(e2), e2.e + 1, 2);
    }
    function vn(e2, n, i2) {
      return new this(e2).clamp(n, i2);
    }
    function En(e2) {
      if (!e2 || typeof e2 != "object") throw Error(oe + "Object expected");
      var n, i2, t2, r = e2.defaults === true, s3 = ["precision", 1, $, "rounding", 0, 8, "toExpNeg", -H3, 0, "toExpPos", 0, H3, "maxE", 0, H3, "minE", -H3, 0, "modulo", 0, 9];
      for (n = 0; n < s3.length; n += 3) if (i2 = s3[n], r && (this[i2] = Ne[i2]), (t2 = e2[i2]) !== void 0) if (b2(t2) === t2 && t2 >= s3[n + 1] && t2 <= s3[n + 2]) this[i2] = t2;
      else throw Error(V + i2 + ": " + t2);
      if (i2 = "crypto", r && (this[i2] = Ne[i2]), (t2 = e2[i2]) !== void 0) if (t2 === true || t2 === false || t2 === 0 || t2 === 1) if (t2) if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[i2] = true;
      else throw Error(De);
      else this[i2] = false;
      else throw Error(V + i2 + ": " + t2);
      return this;
    }
    function Sn(e2) {
      return new this(e2).cos();
    }
    function kn(e2) {
      return new this(e2).cosh();
    }
    function He(e2) {
      var n, i2, t2;
      function r(s3) {
        var o, u2, l, f = this;
        if (!(f instanceof r)) return new r(s3);
        if (f.constructor = r, qe(s3)) {
          f.s = s3.s, w2 ? !s3.d || s3.e > r.maxE ? (f.e = NaN, f.d = null) : s3.e < r.minE ? (f.e = 0, f.d = [0]) : (f.e = s3.e, f.d = s3.d.slice()) : (f.e = s3.e, f.d = s3.d ? s3.d.slice() : s3.d);
          return;
        }
        if (l = typeof s3, l === "number") {
          if (s3 === 0) {
            f.s = 1 / s3 < 0 ? -1 : 1, f.e = 0, f.d = [0];
            return;
          }
          if (s3 < 0 ? (s3 = -s3, f.s = -1) : f.s = 1, s3 === ~~s3 && s3 < 1e7) {
            for (o = 0, u2 = s3; u2 >= 10; u2 /= 10) o++;
            w2 ? o > r.maxE ? (f.e = NaN, f.d = null) : o < r.minE ? (f.e = 0, f.d = [0]) : (f.e = o, f.d = [s3]) : (f.e = o, f.d = [s3]);
            return;
          } else if (s3 * 0 !== 0) {
            s3 || (f.s = NaN), f.e = NaN, f.d = null;
            return;
          }
          return Se(f, s3.toString());
        } else if (l !== "string") throw Error(V + s3);
        return (u2 = s3.charCodeAt(0)) === 45 ? (s3 = s3.slice(1), f.s = -1) : (u2 === 43 && (s3 = s3.slice(1)), f.s = 1), Ie.test(s3) ? Se(f, s3) : on(f, s3);
      }
      if (r.prototype = h3, r.ROUND_UP = 0, r.ROUND_DOWN = 1, r.ROUND_CEIL = 2, r.ROUND_FLOOR = 3, r.ROUND_HALF_UP = 4, r.ROUND_HALF_DOWN = 5, r.ROUND_HALF_EVEN = 6, r.ROUND_HALF_CEIL = 7, r.ROUND_HALF_FLOOR = 8, r.EUCLID = 9, r.config = r.set = En, r.clone = He, r.isDecimal = qe, r.abs = fn, r.acos = ln, r.acosh = cn, r.add = an, r.asin = dn, r.asinh = hn, r.atan = pn, r.atanh = gn, r.atan2 = mn, r.cbrt = wn, r.ceil = Nn, r.clamp = vn, r.cos = Sn, r.cosh = kn, r.div = Mn, r.exp = Cn, r.floor = On, r.hypot = Pn, r.ln = Rn, r.log = bn, r.log10 = _n, r.log2 = An, r.max = qn, r.min = Tn, r.mod = Ln, r.mul = Dn, r.pow = Fn, r.random = In, r.round = Zn, r.sign = Un, r.sin = Bn, r.sinh = Vn, r.sqrt = $n, r.sub = Hn, r.sum = jn, r.tan = Wn, r.tanh = Gn, r.trunc = Jn, e2 === void 0 && (e2 = {}), e2 && e2.defaults !== true) for (t2 = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"], n = 0; n < t2.length; ) e2.hasOwnProperty(i2 = t2[n++]) || (e2[i2] = this[i2]);
      return r.config(e2), r;
    }
    function Mn(e2, n) {
      return new this(e2).div(n);
    }
    function Cn(e2) {
      return new this(e2).exp();
    }
    function On(e2) {
      return p(e2 = new this(e2), e2.e + 1, 3);
    }
    function Pn() {
      var e2, n, i2 = new this(0);
      for (w2 = false, e2 = 0; e2 < arguments.length; ) if (n = new this(arguments[e2++]), n.d) i2.d && (i2 = i2.plus(n.times(n)));
      else {
        if (n.s) return w2 = true, new this(1 / 0);
        i2 = n;
      }
      return w2 = true, i2.sqrt();
    }
    function qe(e2) {
      return e2 instanceof Q2 || e2 && e2.toStringTag === Fe || false;
    }
    function Rn(e2) {
      return new this(e2).ln();
    }
    function bn(e2, n) {
      return new this(e2).log(n);
    }
    function An(e2) {
      return new this(e2).log(2);
    }
    function _n(e2) {
      return new this(e2).log(10);
    }
    function qn() {
      return Be(this, arguments, "lt");
    }
    function Tn() {
      return Be(this, arguments, "gt");
    }
    function Ln(e2, n) {
      return new this(e2).mod(n);
    }
    function Dn(e2, n) {
      return new this(e2).mul(n);
    }
    function Fn(e2, n) {
      return new this(e2).pow(n);
    }
    function In(e2) {
      var n, i2, t2, r, s3 = 0, o = new this(1), u2 = [];
      if (e2 === void 0 ? e2 = this.precision : _(e2, 1, $), t2 = Math.ceil(e2 / m3), this.crypto) if (crypto.getRandomValues) for (n = crypto.getRandomValues(new Uint32Array(t2)); s3 < t2; ) r = n[s3], r >= 429e7 ? n[s3] = crypto.getRandomValues(new Uint32Array(1))[0] : u2[s3++] = r % 1e7;
      else if (crypto.randomBytes) {
        for (n = crypto.randomBytes(t2 *= 4); s3 < t2; ) r = n[s3] + (n[s3 + 1] << 8) + (n[s3 + 2] << 16) + ((n[s3 + 3] & 127) << 24), r >= 214e7 ? crypto.randomBytes(4).copy(n, s3) : (u2.push(r % 1e7), s3 += 4);
        s3 = t2 / 4;
      } else throw Error(De);
      else for (; s3 < t2; ) u2[s3++] = Math.random() * 1e7 | 0;
      for (t2 = u2[--s3], e2 %= m3, t2 && e2 && (r = C(10, m3 - e2), u2[s3] = (t2 / r | 0) * r); u2[s3] === 0; s3--) u2.pop();
      if (s3 < 0) i2 = 0, u2 = [0];
      else {
        for (i2 = -1; u2[0] === 0; i2 -= m3) u2.shift();
        for (t2 = 1, r = u2[0]; r >= 10; r /= 10) t2++;
        t2 < m3 && (i2 -= m3 - t2);
      }
      return o.e = i2, o.d = u2, o;
    }
    function Zn(e2) {
      return p(e2 = new this(e2), e2.e + 1, this.rounding);
    }
    function Un(e2) {
      return e2 = new this(e2), e2.d ? e2.d[0] ? e2.s : 0 * e2.s : e2.s || NaN;
    }
    function Bn(e2) {
      return new this(e2).sin();
    }
    function Vn(e2) {
      return new this(e2).sinh();
    }
    function $n(e2) {
      return new this(e2).sqrt();
    }
    function Hn(e2, n) {
      return new this(e2).sub(n);
    }
    function jn() {
      var e2 = 0, n = arguments, i2 = new this(n[e2]);
      for (w2 = false; i2.s && ++e2 < n.length; ) i2 = i2.plus(n[e2]);
      return w2 = true, p(i2, this.precision, this.rounding);
    }
    function Wn(e2) {
      return new this(e2).tan();
    }
    function Gn(e2) {
      return new this(e2).tanh();
    }
    function Jn(e2) {
      return p(e2 = new this(e2), e2.e + 1, 1);
    }
    h3[Symbol.for("nodejs.util.inspect.custom")] = h3.toString;
    h3[Symbol.toStringTag] = "Decimal";
    var Q2 = h3.constructor = He(Ne);
    te = new Q2(te);
    re = new Q2(re);
    var je = Q2;
  }
});

// ../../node_modules/.prisma/client/index-browser.js
var require_index_browser2 = __commonJS({
  "../../node_modules/.prisma/client/index-browser.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", { value: true });
    var {
      Decimal: Decimal11,
      objectEnumValues: objectEnumValues2,
      makeStrictEnum: makeStrictEnum2,
      Public: Public2,
      getRuntime: getRuntime2,
      skip
    } = require_index_browser();
    var Prisma27 = {};
    exports2.Prisma = Prisma27;
    exports2.$Enums = {};
    Prisma27.prismaVersion = {
      client: "5.20.0",
      engine: "06fc58a368dc7be9fbbbe894adf8d445d208c284"
    };
    Prisma27.PrismaClientKnownRequestError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.PrismaClientUnknownRequestError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.PrismaClientRustPanicError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.PrismaClientInitializationError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.PrismaClientValidationError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.NotFoundError = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.Decimal = Decimal11;
    Prisma27.sql = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.empty = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.join = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.raw = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.validator = Public2.validator;
    Prisma27.getExtensionContext = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.defineExtension = () => {
      const runtimeName = getRuntime2().prettyName;
      throw new Error(
        `Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`
      );
    };
    Prisma27.DbNull = objectEnumValues2.instances.DbNull;
    Prisma27.JsonNull = objectEnumValues2.instances.JsonNull;
    Prisma27.AnyNull = objectEnumValues2.instances.AnyNull;
    Prisma27.NullTypes = {
      DbNull: objectEnumValues2.classes.DbNull,
      JsonNull: objectEnumValues2.classes.JsonNull,
      AnyNull: objectEnumValues2.classes.AnyNull
    };
    exports2.Prisma.TransactionIsolationLevel = makeStrictEnum2({
      ReadUncommitted: "ReadUncommitted",
      ReadCommitted: "ReadCommitted",
      RepeatableRead: "RepeatableRead",
      Serializable: "Serializable"
    });
    exports2.Prisma.CityScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id",
      country: "country",
      state: "state"
    };
    exports2.Prisma.CountryZipCodeScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      country: "country",
      state: "state",
      city: "city",
      zip_code: "zip_code"
    };
    exports2.Prisma.VirtualViewFilterScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      column: "column",
      value: "value",
      display_value: "display_value",
      virtual_view_id: "virtual_view_id"
    };
    exports2.Prisma.VirtualViewColumnScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      column: "column",
      sort: "sort",
      virtual_view_id: "virtual_view_id"
    };
    exports2.Prisma.VirtualViewScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      resource: "resource",
      company_id: "company_id",
      user_id: "user_id",
      page_size: "page_size",
      default: "default",
      visible_filters: "visible_filters",
      created_at: "created_at"
    };
    exports2.Prisma.TagScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description",
      type: "type",
      alias: "alias",
      created_at: "created_at",
      updated_at: "updated_at",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.ValidationResultScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      validation: "validation",
      validation_definition_id: "validation_definition_id",
      file_id: "file_id",
      inferred_entity_id: "inferred_entity_id",
      valid: "valid",
      reason: "reason",
      created_at: "created_at"
    };
    exports2.Prisma.InferredNationalIdentityCardScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      birth_date: "birth_date",
      issued_date: "issued_date",
      sex: "sex",
      expiration_date: "expiration_date",
      document_number: "document_number"
    };
    exports2.Prisma.InferredCoverageCertificateScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      effective_date_from: "effective_date_from",
      effective_date_to: "effective_date_to"
    };
    exports2.Prisma.InferredDeathCertificateScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      day: "day",
      hour: "hour",
      year: "year",
      reason: "reason"
    };
    exports2.Prisma.InferredMedicalCertificateScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      doctor_full_name: "doctor_full_name",
      doctor_license_number: "doctor_license_number",
      date: "date",
      diagnosis: "diagnosis"
    };
    exports2.Prisma.InferredVehicleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      license_plate: "license_plate"
    };
    exports2.Prisma.InferredVehicleIdCardFrontScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      license_plate: "license_plate",
      id_card_number: "id_card_number",
      chassis_number: "chassis_number",
      model: "model",
      make: "make",
      type: "type",
      use: "use",
      motor: "motor",
      expiration_date: "expiration_date"
    };
    exports2.Prisma.InferredVehicleIdCardBackScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      owner_name: "owner_name",
      owner_address: "owner_address",
      owner_identity_number: "owner_identity_number"
    };
    exports2.Prisma.InferredEntityScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entity_type: "entity_type",
      entity_id: "entity_id",
      file_id: "file_id"
    };
    exports2.Prisma.FileScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      original_name: "original_name",
      external_id: "external_id",
      external_synced_at: "external_synced_at",
      kach_synced_at: "kach_synced_at",
      stored_name: "stored_name",
      size: "size",
      type: "type",
      extension: "extension",
      mimetype: "mimetype",
      original_uploaded_at: "original_uploaded_at",
      uploaded_by_id: "uploaded_by_id",
      company_id: "company_id",
      inverse_relation_id: "inverse_relation_id",
      inverse_relation_object: "inverse_relation_object",
      created_at: "created_at"
    };
    exports2.Prisma.LegalPersonScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      social_reason: "social_reason",
      cuit: "cuit",
      address: "address",
      state: "state",
      type: "type",
      city: "city",
      zip_code: "zip_code",
      email: "email"
    };
    exports2.Prisma.NaturalPersonScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      birth_date: "birth_date",
      nationality: "nationality",
      address: "address",
      marital_status: "marital_status",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      zip_code: "zip_code",
      email: "email",
      cellphone: "cellphone",
      sex: "sex",
      identification_type: "identification_type",
      identification_value: "identification_value"
    };
    exports2.Prisma.PersonParentScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      identification: "identification",
      type: "type",
      birth_date: "birth_date",
      natural_person_id: "natural_person_id"
    };
    exports2.Prisma.InHouseLawyerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      status: "status",
      email: "email",
      registered_user_id: "registered_user_id",
      company_id: "company_id",
      created_at: "created_at",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.PersonDamageDetailScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      damage: "damage",
      severity: "severity",
      person_damage_id: "person_damage_id",
      body_parts: "body_parts"
    };
    exports2.Prisma.PersonDamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      surgery_description: "surgery_description",
      health_insurance_fund: "health_insurance_fund",
      treatment_worker_compensation_insurer: "treatment_worker_compensation_insurer",
      treatment_medical_institution: "treatment_medical_institution",
      driver_id: "driver_id",
      victim_role: "victim_role",
      policyholder_relationship: "policyholder_relationship",
      policyholder_relationship_other: "policyholder_relationship_other"
    };
    exports2.Prisma.RecoveryDamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claimant_institution_relationship: "claimant_institution_relationship",
      institution_id: "institution_id",
      damaged_person_id: "damaged_person_id"
    };
    exports2.Prisma.OrderReportScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      order_id: "order_id",
      file_id: "file_id",
      status: "status",
      rejected_at: "rejected_at",
      accepted_at: "accepted_at",
      created_by_id: "created_by_id",
      created_at: "created_at",
      version: "version",
      rejected_by_id: "rejected_by_id",
      accepted_by_id: "accepted_by_id",
      rejected_reason: "rejected_reason",
      notes: "notes"
    };
    exports2.Prisma.OrderInvoiceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      file_id: "file_id",
      order_id: "order_id",
      version: "version",
      status: "status",
      accepted_at: "accepted_at",
      rejected_at: "rejected_at",
      accepted_by_id: "accepted_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason",
      created_at: "created_at"
    };
    exports2.Prisma.OrderItemScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      order_id: "order_id",
      product_id: "product_id",
      description: "description",
      quantity: "quantity",
      list_unit_price: "list_unit_price",
      unit_price: "unit_price",
      subtotal: "subtotal"
    };
    exports2.Prisma.OrderScalarFieldEnum = {
      id: "id",
      sequence: "sequence",
      ref_id: "ref_id",
      type: "type",
      sub_type: "sub_type",
      relation_type: "relation_type",
      company_id: "company_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      request_for_proposal_id: "request_for_proposal_id",
      provider_id: "provider_id",
      engagement_id: "engagement_id",
      vertical_id: "vertical_id",
      vertical_name: "vertical_name",
      service_id: "service_id",
      service_name: "service_name",
      good_id: "good_id",
      good_name: "good_name",
      locality_id: "locality_id",
      locality_name: "locality_name",
      department_name: "department_name",
      province_name: "province_name",
      description: "description",
      name: "name",
      vendor_contact_id: "vendor_contact_id",
      vendor_user_id: "vendor_user_id",
      start_date: "start_date",
      end_date: "end_date",
      notes: "notes",
      created_at: "created_at",
      status: "status",
      created_by_id: "created_by_id",
      accepted_at: "accepted_at",
      rejected_at: "rejected_at",
      completed_at: "completed_at",
      canceled_at: "canceled_at",
      rejected_reason: "rejected_reason",
      canceled_reason: "canceled_reason",
      responded_by_user_id: "responded_by_user_id",
      canceled_by_user_id: "canceled_by_user_id",
      completed_by_id: "completed_by_id",
      external_id: "external_id",
      total_amount: "total_amount",
      coverage_amount: "coverage_amount",
      amount_to_charge: "amount_to_charge",
      taxes_percent: "taxes_percent",
      taxes_amount: "taxes_amount",
      total_with_taxes: "total_with_taxes",
      currency: "currency",
      work_proof_mechanism: "work_proof_mechanism",
      workflow_stage: "workflow_stage",
      workflow_stage_status: "workflow_stage_status",
      workflow_rank: "workflow_rank",
      workflow_pending_provider: "workflow_pending_provider",
      workflow_pending_insurer: "workflow_pending_insurer",
      workflow_since: "workflow_since",
      trace_id: "trace_id"
    };
    exports2.Prisma.OrderScheduleScalarFieldEnum = {
      id: "id",
      order_id: "order_id",
      status: "status",
      scheduled_for: "scheduled_for",
      note: "note",
      branch_id: "branch_id",
      invite_email: "invite_email",
      calendar_uid: "calendar_uid",
      calendar_sequence: "calendar_sequence",
      created_at: "created_at",
      created_by_id: "created_by_id",
      canceled_at: "canceled_at",
      canceled_by_id: "canceled_by_id",
      canceled_reason: "canceled_reason"
    };
    exports2.Prisma.OrderFileScalarFieldEnum = {
      id: "id",
      order_id: "order_id",
      file_id: "file_id",
      uploader: "uploader",
      source: "source",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.OrderDocumentRequirementScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      uploader: "uploader",
      is_required: "is_required",
      requires_review: "requires_review",
      is_active: "is_active",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CompanyOrderClaimStatusMappingScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      workflow_stage: "workflow_stage",
      workflow_stage_status: "workflow_stage_status",
      claim_status_id: "claim_status_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.OrderRequiredDocumentScalarFieldEnum = {
      id: "id",
      order_id: "order_id",
      requirement_id: "requirement_id",
      name: "name",
      description: "description",
      uploader: "uploader",
      is_required: "is_required",
      requires_review: "requires_review",
      created_at: "created_at"
    };
    exports2.Prisma.OrderRequiredDocumentVersionScalarFieldEnum = {
      id: "id",
      required_document_id: "required_document_id",
      file_id: "file_id",
      version: "version",
      status: "status",
      created_by_id: "created_by_id",
      created_at: "created_at",
      accepted_at: "accepted_at",
      accepted_by_id: "accepted_by_id",
      rejected_at: "rejected_at",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason"
    };
    exports2.Prisma.OrderTimelineScalarFieldEnum = {
      id: "id",
      order_id: "order_id",
      status: "status",
      created_at: "created_at"
    };
    exports2.Prisma.RequestForProposalVendorScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      contact_id: "contact_id",
      request_for_proposal_id: "request_for_proposal_id"
    };
    exports2.Prisma.BidLineScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      make: "make",
      model: "model",
      serial_number: "serial_number",
      quantity: "quantity",
      unit_of_measurement: "unit_of_measurement",
      unit_price: "unit_price",
      total_price: "total_price",
      bid_id: "bid_id"
    };
    exports2.Prisma.RequestForProposalBidScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request_for_proposal_id: "request_for_proposal_id",
      expiration: "expiration",
      submitted_by_id: "submitted_by_id",
      created_at: "created_at",
      total_amount: "total_amount",
      winner: "winner",
      won_at: "won_at"
    };
    exports2.Prisma.RequestForProposalScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      country: "country",
      state: "state",
      city: "city",
      description: "description",
      tags: "tags",
      mode: "mode",
      status: "status",
      deadline: "deadline",
      canceled_reason: "canceled_reason",
      canceled_by_id: "canceled_by_id",
      type: "type",
      created_by_id: "created_by_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      closed_at: "closed_at",
      canceled_at: "canceled_at",
      created_at: "created_at"
    };
    exports2.Prisma.EntrypointSnapshotProgressScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entrypoint_id: "entrypoint_id",
      user_id: "user_id",
      session_id: "session_id",
      recording_id: "recording_id",
      data: "data",
      error: "error",
      created_at: "created_at",
      updated_at: "updated_at",
      completed_at: "completed_at",
      failed_at: "failed_at"
    };
    exports2.Prisma.ContractReportScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      contract_id: "contract_id",
      file_id: "file_id",
      status: "status",
      rejected_at: "rejected_at",
      accepted_at: "accepted_at",
      created_by_id: "created_by_id",
      created_at: "created_at",
      version: "version",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason",
      notes: "notes"
    };
    exports2.Prisma.RequestForProposalContractScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request_for_proposal_id: "request_for_proposal_id",
      cost_value: "cost_value",
      cost_type: "cost_type",
      name: "name",
      vendor_contact_id: "vendor_contact_id",
      vendor_user_id: "vendor_user_id",
      start_date: "start_date",
      end_date: "end_date",
      notes: "notes",
      created_at: "created_at",
      status: "status",
      created_by_id: "created_by_id"
    };
    exports2.Prisma.MaterialDamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      insurance_id: "insurance_id",
      vehicle_id: "vehicle_id",
      real_property_id: "real_property_id",
      driver_id: "driver_id"
    };
    exports2.Prisma.LicenseCategoryTypeScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id",
      tenant: "tenant",
      role: "role"
    };
    exports2.Prisma.DriverScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      cellphone: "cellphone",
      email: "email",
      address: "address",
      country: "country",
      state: "state",
      city: "city",
      city_external_id: "city_external_id",
      age: "age",
      license_number: "license_number",
      identification_number: "identification_number",
      birth_date: "birth_date",
      license_issue_date: "license_issue_date",
      license_category_type: "license_category_type",
      license_category_type_external_id: "license_category_type_external_id",
      license_category_other: "license_category_other",
      identification_expended_date: "identification_expended_date",
      ownership: "ownership"
    };
    exports2.Prisma.VehicleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      document_type: "document_type",
      type: "type",
      driver_id: "driver_id",
      identification_key: "identification_key",
      registration_state: "registration_state",
      registration_city: "registration_city",
      year: "year",
      use: "use",
      make: "make",
      model: "model",
      version: "version",
      version_external_id: "version_external_id",
      category: "category",
      market_value: "market_value",
      license_plate: "license_plate",
      chassis: "chassis",
      engine: "engine"
    };
    exports2.Prisma.InsuranceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      coverage: "coverage",
      other_coverage: "other_coverage",
      insurer: "insurer",
      insurer_external_id: "insurer_external_id",
      policy_number: "policy_number",
      provided_policy_number: "provided_policy_number",
      franchise_amount: "franchise_amount",
      plan: "plan",
      coverage_amount: "coverage_amount"
    };
    exports2.Prisma.OcurrenceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      address: "address",
      time: "time",
      witnesses_info: "witnesses_info",
      police_intervention: "police_intervention",
      police_station: "police_station",
      criminal_case_number: "criminal_case_number",
      court: "court",
      clerks_office: "clerks_office",
      judicial_department: "judicial_department",
      circulation_direction: "circulation_direction",
      speed: "speed",
      damage_description: "damage_description",
      sinister_date: "sinister_date",
      state: "state",
      country: "country",
      city: "city",
      city_external_id: "city_external_id",
      zip_code: "zip_code",
      description: "description",
      latitude: "latitude",
      longitude: "longitude"
    };
    exports2.Prisma.ClaimantScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      role: "role",
      victim_relationship: "victim_relationship",
      victim_relationship_other: "victim_relationship_other",
      type: "type",
      natural_person_id: "natural_person_id",
      legal_person_id: "legal_person_id",
      claim_id: "claim_id"
    };
    exports2.Prisma.FileRequestPlaceholderScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      tag_id: "tag_id",
      max_files: "max_files",
      dirty: "dirty",
      context: "context",
      types: "types",
      file_request_id: "file_request_id",
      uploaded_files_at: "uploaded_files_at",
      confirmed_at: "confirmed_at",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id",
      deleted_reason: "deleted_reason"
    };
    exports2.Prisma.FileRequestScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      complaint_id: "complaint_id",
      claim_id: "claim_id",
      created_at: "created_at"
    };
    exports2.Prisma.ClaimSharedDocumentScalarFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      file_id: "file_id",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.MessageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      author_type: "author_type",
      sender_id: "sender_id",
      policyholder_id: "policyholder_id",
      type: "type",
      file_request_id: "file_request_id",
      created_at: "created_at",
      answered_at: "answered_at",
      latest: "latest",
      reminder_sent_at: "reminder_sent_at"
    };
    exports2.Prisma.DamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      material_damage_id: "material_damage_id",
      person_damage_id: "person_damage_id",
      recovery_damage_id: "recovery_damage_id",
      description: "description",
      fixed: "fixed",
      claim_id: "claim_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.SLAObjectiveScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sla_id: "sla_id",
      group_type: "group_type",
      group_value: "group_value",
      reference_type: "reference_type",
      reference_value: "reference_value",
      duration_type: "duration_type",
      duration_value: "duration_value"
    };
    exports2.Prisma.CompanySLAScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      effective_from: "effective_from",
      company_id: "company_id",
      active: "active",
      latest: "latest",
      deactivated_at: "deactivated_at",
      scope: "scope",
      type: "type",
      total_duration_type: "total_duration_type",
      total_duration_value: "total_duration_value",
      elapsed_duration_criteria: "elapsed_duration_criteria",
      created_at: "created_at",
      updated_at: "updated_at",
      group_sla_id: "group_sla_id",
      expire_notification: "expire_notification",
      version: "version",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.ComplaintTypeDamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      damage_type: "damage_type",
      sub_damage_type: "sub_damage_type",
      company_complaint_type_id: "company_complaint_type_id",
      entity_damaged_category: "entity_damaged_category"
    };
    exports2.Prisma.ClaimTypeDamageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      damage_type: "damage_type",
      sub_damage_type: "sub_damage_type",
      entity_damaged_category: "entity_damaged_category",
      company_claim_type_id: "company_claim_type_id"
    };
    exports2.Prisma.CompanyClaimTypeScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id",
      priority: "priority"
    };
    exports2.Prisma.CompanyComplaintTypeScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id"
    };
    exports2.Prisma.GroupSLAScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      scope: "scope",
      type: "type",
      version_seeded: "version_seeded"
    };
    exports2.Prisma.RoleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      type: "type",
      base: "base",
      owner: "owner",
      non_operative: "non_operative",
      company_id: "company_id",
      built_in: "built_in",
      created_at: "created_at"
    };
    exports2.Prisma.PermissionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      scope: "scope",
      limit: "limit",
      relative_deviation_percentage: "relative_deviation_percentage"
    };
    exports2.Prisma.RealPropertyScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      address: "address",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      country: "country",
      zip_code: "zip_code",
      type: "type",
      ownership: "ownership",
      other_ownership: "other_ownership",
      other_type: "other_type"
    };
    exports2.Prisma.VictimScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      natural_person_id: "natural_person_id",
      legal_person_id: "legal_person_id"
    };
    exports2.Prisma.ClaimHandlerDelegatedScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      destination_id: "destination_id",
      source_id: "source_id",
      delegated_by_id: "delegated_by_id",
      created_at: "created_at",
      claim_id: "claim_id"
    };
    exports2.Prisma.ComplaintHandlerDelegatedScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      destination_id: "destination_id",
      source_id: "source_id",
      delegated_by_id: "delegated_by_id",
      created_at: "created_at",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.ClaimHandlerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      claim_id: "claim_id",
      deleted_at: "deleted_at",
      type: "type",
      created_at: "created_at",
      team_id: "team_id"
    };
    exports2.Prisma.ComplaintHandlerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      complaint_id: "complaint_id",
      deleted_at: "deleted_at",
      type: "type"
    };
    exports2.Prisma.LoadBalanceRuleConditionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      path: "path",
      type: "type",
      operator: "operator",
      value: "value",
      load_balance_rule_id: "load_balance_rule_id"
    };
    exports2.Prisma.LoadBalanceRuleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      type: "type",
      priority: "priority",
      target_group_id: "target_group_id",
      team_id: "team_id"
    };
    exports2.Prisma.TargetGroupScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      coordinator_id: "coordinator_id",
      scope: "scope",
      last_assigned_user_id: "last_assigned_user_id",
      last_assigned_index: "last_assigned_index"
    };
    exports2.Prisma.EventDetailScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      object_id: "object_id",
      object_type: "object_type",
      event_id: "event_id"
    };
    exports2.Prisma.IngestEventScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      created_at: "created_at",
      timestamp: "timestamp",
      status: "status",
      hash: "hash",
      company_id: "company_id",
      processed_at: "processed_at",
      failed_reason: "failed_reason",
      failed_at: "failed_at",
      processing_at: "processing_at",
      payload: "payload"
    };
    exports2.Prisma.EventScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      created_at: "created_at",
      initiator_type: "initiator_type",
      policyholder_id: "policyholder_id",
      triggered_by_id: "triggered_by_id",
      metadata: "metadata",
      remote_ip: "remote_ip",
      user_agent: "user_agent",
      source: "source",
      company_id: "company_id"
    };
    exports2.Prisma.CommentScalarFieldEnum = {
      id: "id",
      commented_by_id: "commented_by_id",
      claim_id: "claim_id",
      content: "content",
      created_at: "created_at"
    };
    exports2.Prisma.MentionScalarFieldEnum = {
      id: "id",
      comment_id: "comment_id",
      mentioned_to_id: "mentioned_to_id",
      created_at: "created_at"
    };
    exports2.Prisma.SinisterExpertAppraisalScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sinister_id: "sinister_id",
      external_id: "external_id",
      license_plate: "license_plate",
      owner_first_name: "owner_first_name",
      owner_last_name: "owner_last_name"
    };
    exports2.Prisma.PolicyholderInspectionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request: "request",
      report: "report",
      license_plate: "license_plate",
      authorize: "authorize",
      observations: "observations",
      chasis: "chasis",
      color: "color",
      km: "km",
      tires: "tires",
      verification_code: "verification_code",
      condition: "condition",
      location: "location",
      motor: "motor",
      status: "status",
      plan: "plan",
      validity: "validity",
      inspected_at: "inspected_at",
      policyholder_id: "policyholder_id",
      external_id: "external_id"
    };
    exports2.Prisma.PolicyholderScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policy_number: "policy_number",
      external_id: "external_id",
      agency: "agency",
      order: "order",
      cuil: "cuil",
      type: "type",
      person_type: "person_type",
      address: "address",
      birth_date: "birth_date",
      birth_place: "birth_place",
      cellphone: "cellphone",
      city: "city",
      country: "country",
      identification: "identification",
      email: "email",
      first_name: "first_name",
      last_name: "last_name",
      sex: "sex",
      landline_phone: "landline_phone",
      marital_status: "marital_status",
      politician: "politician",
      state: "state",
      license_plate: "license_plate",
      plan: "plan",
      use: "use",
      year: "year",
      validity: "validity",
      zip_code: "zip_code",
      make: "make",
      model: "model"
    };
    exports2.Prisma.PendingComplaintScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      sinister_id: "sinister_id",
      external_status: "external_status",
      external_created_at: "external_created_at",
      external_id: "external_id",
      created_by_id: "created_by_id",
      created_at: "created_at"
    };
    exports2.Prisma.ExternalInsurancePolicyScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policy_number: "policy_number",
      risk: "risk",
      issue_date: "issue_date",
      validity_from: "validity_from",
      section_code: "section_code",
      section_name: "section_name",
      validity_to: "validity_to",
      endorsement: "endorsement",
      type: "type",
      insured_amount: "insured_amount",
      coverages: "coverages",
      created_at: "created_at"
    };
    exports2.Prisma.ExternalComplaintScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policyholder_id: "policyholder_id",
      external_insurance_policy_id: "external_insurance_policy_id",
      external_id: "external_id",
      external_status: "external_status",
      agency: "agency",
      pending_complaint_id: "pending_complaint_id",
      selected: "selected",
      selected_by_id: "selected_by_id",
      selected_at: "selected_at",
      occurrence_date: "occurrence_date",
      affected_coverages: "affected_coverages",
      registered_by: "registered_by",
      handler_cellphone: "handler_cellphone",
      handler_name: "handler_name",
      handler_email: "handler_email",
      registered_at: "registered_at",
      location: "location",
      source: "source",
      sinister_id: "sinister_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.IdempotentRequestScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      idempotent_key: "idempotent_key",
      status: "status",
      request_path: "request_path",
      request_method: "request_method",
      response_body: "response_body",
      response_code: "response_code",
      created_at: "created_at"
    };
    exports2.Prisma.NewsAnswerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      description: "description",
      publisher_first_name: "publisher_first_name",
      publisher_last_name: "publisher_last_name",
      publisher_email: "publisher_email",
      external_id: "external_id",
      news_request_id: "news_request_id",
      destinations: "destinations",
      created_at: "created_at",
      external_created_at: "external_created_at",
      fraud_investigation_case_id: "fraud_investigation_case_id"
    };
    exports2.Prisma.NewsRequestScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      annotation: "annotation",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      external_id: "external_id",
      requested_by_id: "requested_by_id"
    };
    exports2.Prisma.FraudInvestigationCaseAcceptedReportScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      accepted_by_first_name: "accepted_by_first_name",
      accepted_by_last_name: "accepted_by_last_name",
      accepted_by_email: "accepted_by_email",
      report_created_at: "report_created_at",
      report_accepted_at: "report_accepted_at",
      lab_name: "lab_name",
      conclusion: "conclusion",
      report_id: "report_id"
    };
    exports2.Prisma.FraudInvestigationCaseClaimResultScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      claim_id: "claim_id",
      result: "result",
      external_updated_at: "external_updated_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.FraudInvestigationCaseScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sinister_id: "sinister_id",
      case_type: "case_type",
      creation_mode: "creation_mode",
      reason: "reason",
      sinister_number: "sinister_number",
      external_case_id: "external_case_id",
      status: "status",
      internal_status: "internal_status",
      sinister_type: "sinister_type",
      description: "description",
      handler_first_name: "handler_first_name",
      handler_last_name: "handler_last_name",
      handler_email: "handler_email",
      instance: "instance",
      close_motive: "close_motive",
      external_status: "external_status",
      responsible_first_name: "responsible_first_name",
      responsible_last_name: "responsible_last_name",
      responsible_email: "responsible_email",
      ramo: "ramo",
      agency: "agency",
      result: "result",
      created_by_id: "created_by_id",
      kach_case_creator_first_name: "kach_case_creator_first_name",
      kach_case_creator_last_name: "kach_case_creator_last_name",
      kach_case_creator_email: "kach_case_creator_email",
      closed_at: "closed_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.FraudCaseParticipantSyncRequestScalarFieldEnum = {
      id: "id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      claim_id: "claim_id",
      reason: "reason",
      status: "status",
      requested_at: "requested_at",
      dispatched_at: "dispatched_at",
      processed_at: "processed_at",
      last_error_code: "last_error_code"
    };
    exports2.Prisma.CompanyClaimPublicStatusScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name"
    };
    exports2.Prisma.SinisterScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      date: "date",
      entrypoint_backend_policyholder_complaint_exists: "entrypoint_backend_policyholder_complaint_exists",
      policyholder_license_plate: "policyholder_license_plate",
      policyholder_policy_number: "policyholder_policy_number",
      policyholder_identification: "policyholder_identification",
      company_id: "company_id",
      created_at: "created_at",
      external_status: "external_status",
      external_sinister_id: "external_sinister_id"
    };
    exports2.Prisma.OfferAgreementScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      provider_type: "provider_type",
      provider_id: "provider_id",
      status: "status",
      offer_id: "offer_id",
      created_by_id: "created_by_id",
      created_at: "created_at",
      completed_at: "completed_at",
      cancelled_at: "cancelled_at",
      cancelled_reason: "cancelled_reason",
      canceled_at: "canceled_at",
      canceled_reason: "canceled_reason",
      rejected_at: "rejected_at",
      rejected_reason: "rejected_reason",
      expired_at: "expired_at",
      token: "token",
      document_id: "document_id",
      sender_user_id: "sender_user_id",
      sender_account_email: "sender_account_email",
      provider_document_id: "provider_document_id",
      recipients: "recipients",
      fields: "fields",
      start_requested_at: "start_requested_at",
      dispatched_at: "dispatched_at",
      failure_code: "failure_code",
      failure_message: "failure_message",
      failed_at: "failed_at",
      last_provider_sync_at: "last_provider_sync_at",
      signed_documents_pending_at: "signed_documents_pending_at",
      signature_origin: "signature_origin"
    };
    exports2.Prisma.OfferAgreementEventScalarFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      provider_event_id: "provider_event_id",
      type: "type",
      payload: "payload",
      outcome: "outcome",
      error: "error",
      created_at: "created_at"
    };
    exports2.Prisma.OfferAgreementSigningLinkScalarFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      provider_transaction_id: "provider_transaction_id",
      provider_recipient_id: "provider_recipient_id",
      recipient_email: "recipient_email",
      url_ciphertext: "url_ciphertext",
      obtained_at: "obtained_at"
    };
    exports2.Prisma.OfferAgreementCeremonyWindowScalarFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      entry: "entry",
      remote_ip: "remote_ip",
      opened_at: "opened_at",
      last_seen_at: "last_seen_at"
    };
    exports2.Prisma.OfferEmbeddedSigningSessionScalarFieldEnum = {
      id: "id",
      offer_id: "offer_id",
      secret_hash: "secret_hash",
      owner_email: "owner_email",
      expires_at: "expires_at",
      created_at: "created_at"
    };
    exports2.Prisma.AgreementTemplateScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      kind: "kind",
      name: "name",
      description: "description",
      created_at: "created_at",
      updated_at: "updated_at",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.AgreementTemplateVersionScalarFieldEnum = {
      id: "id",
      template_id: "template_id",
      version: "version",
      status: "status",
      blocks: "blocks",
      signers: "signers",
      variables: "variables",
      layout_variant: "layout_variant",
      content_hash: "content_hash",
      published_at: "published_at",
      deprecated_at: "deprecated_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AgreementDocumentScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_id: "claim_id",
      offer_id: "offer_id",
      kind: "kind",
      template_version_id: "template_version_id",
      file_id: "file_id",
      variables_snapshot: "variables_snapshot",
      context_snapshot: "context_snapshot",
      blocks_snapshot: "blocks_snapshot",
      signers_snapshot: "signers_snapshot",
      anchors_snapshot: "anchors_snapshot",
      meta_snapshot: "meta_snapshot",
      status: "status",
      invalid_reason: "invalid_reason",
      content_hash: "content_hash",
      pdf_sha256: "pdf_sha256",
      rendered_at: "rendered_at",
      rendered_by_id: "rendered_by_id",
      render_ms: "render_ms",
      plan_id: "plan_id",
      status_code: "status_code",
      diagnostics: "diagnostics",
      created_at: "created_at"
    };
    exports2.Prisma.CompanyAgreementSettingsScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      enabled: "enabled",
      variable_bindings: "variable_bindings",
      offer_terms: "offer_terms",
      offer_message_template_id: "offer_message_template_id",
      validate_bank_data: "validate_bank_data",
      validate_acceptance_payee: "validate_acceptance_payee",
      signature_enabled: "signature_enabled",
      embedded_signing_enabled: "embedded_signing_enabled",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AgreementRuleScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      name: "name",
      description: "description",
      enabled: "enabled",
      priority: "priority",
      template_id: "template_id",
      conditions: "conditions",
      recipients: "recipients",
      created_at: "created_at",
      updated_at: "updated_at",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.AgreementSignatureRuleScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      name: "name",
      description: "description",
      enabled: "enabled",
      priority: "priority",
      method: "method",
      conditions: "conditions",
      template_ids: "template_ids",
      created_at: "created_at",
      updated_at: "updated_at",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.OfferAgreementPlanScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_id: "claim_id",
      offer_id: "offer_id",
      rule_id: "rule_id",
      template_version_id: "template_version_id",
      outcome: "outcome",
      reason: "reason",
      stage: "stage",
      signature_method: "signature_method",
      signature_rule_id: "signature_rule_id",
      signature: "signature",
      recipients: "recipients",
      missing: "missing",
      warnings: "warnings",
      evaluations: "evaluations",
      context_snapshot: "context_snapshot",
      meta_snapshot: "meta_snapshot",
      subject_snapshot: "subject_snapshot",
      signature_enabled: "signature_enabled",
      planned_at: "planned_at",
      planned_by_id: "planned_by_id",
      superseded_at: "superseded_at"
    };
    exports2.Prisma.VariableValueScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      guid: "guid",
      type: "type",
      value: "value",
      created_at: "created_at"
    };
    exports2.Prisma.IntegrationTemplateFieldMappingScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid",
      provider_field_id: "provider_field_id",
      local_field_type: "local_field_type",
      local_field_reference: "local_field_reference",
      integration_template_id: "integration_template_id"
    };
    exports2.Prisma.IntegrationTemplateScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      provider_template_name: "provider_template_name",
      provider_type: "provider_type",
      provider_template_id: "provider_template_id",
      message_template_id: "message_template_id",
      created_by_id: "created_by_id",
      created_at: "created_at",
      company_id: "company_id"
    };
    exports2.Prisma.OfferScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      token: "token",
      rejected_reason: "rejected_reason",
      canceled_reason: "canceled_reason",
      pretension: "pretension",
      third_party_user_requested_amount: "third_party_user_requested_amount",
      status: "status",
      name: "name",
      offer_template_message: "offer_template_message",
      message_template_id: "message_template_id",
      company_id: "company_id",
      offered_by_id: "offered_by_id",
      accepted_by_id: "accepted_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_on_behalf_by_id: "rejected_on_behalf_by_id",
      canceled_by_id: "canceled_by_id",
      type: "type",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      expires_at: "expires_at",
      expired_at: "expired_at",
      created_at: "created_at",
      accepted_at: "accepted_at",
      rejected_at: "rejected_at",
      canceled_at: "canceled_at",
      amount: "amount",
      predicted_acceptance_probability: "predicted_acceptance_probability",
      probability_factors_snapshot: "probability_factors_snapshot",
      probability_model_version: "probability_model_version",
      accepted_material_judicial_amount: "accepted_material_judicial_amount",
      accepted_person_judicial_amount: "accepted_person_judicial_amount",
      accepted_percentage_of_liability: "accepted_percentage_of_liability",
      public_canceled_reason: "public_canceled_reason",
      offered_reason: "offered_reason",
      public_offered_reason: "public_offered_reason",
      installments: "installments",
      fee_percentage: "fee_percentage",
      payment_days: "payment_days",
      offer_message_template_version_id: "offer_message_template_version_id",
      acceptance_requirements: "acceptance_requirements",
      agreement_reviewed_at: "agreement_reviewed_at",
      manual_agreement_file_id: "manual_agreement_file_id"
    };
    exports2.Prisma.InspectionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      external_id: "external_id",
      template_name: "template_name",
      type: "type",
      status: "status",
      verdict: "verdict",
      consumer_type: "consumer_type"
    };
    exports2.Prisma.ContactScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      type: "type",
      email: "email",
      cellphone: "cellphone",
      country: "country",
      zip_code: "zip_code",
      city: "city",
      state: "state",
      address: "address",
      external_id: "external_id",
      company_id: "company_id",
      created_by_id: "created_by_id",
      user_id: "user_id",
      created_at: "created_at"
    };
    exports2.Prisma.UpdateNoteScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      published_by_id: "published_by_id",
      created_at: "created_at"
    };
    exports2.Prisma.AppraisalReportScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      risk: "risk",
      total_disability: "total_disability",
      appraised_total_value: "appraised_total_value",
      report_id: "report_id",
      status: "status",
      rejected_at: "rejected_at",
      version: "version",
      accepted_at: "accepted_at",
      created_at: "created_at",
      rejected_reason: "rejected_reason",
      rejected_by_id: "rejected_by_id",
      accepted_by_id: "accepted_by_id",
      created_by_id: "created_by_id",
      type: "type",
      claim_id: "claim_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.OwnershipTransferScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      status: "status",
      type: "type",
      claim_id: "claim_id",
      source_user_id: "source_user_id",
      destination_user_id: "destination_user_id",
      transferred_by_id: "transferred_by_id",
      created_at: "created_at",
      updated_at: "updated_at",
      accepted_at: "accepted_at",
      rejected_at: "rejected_at",
      token: "token"
    };
    exports2.Prisma.ResponsibilityTransferScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      status: "status",
      type: "type",
      claim_id: "claim_id",
      source_handler_id: "source_handler_id",
      destination_handler_id: "destination_handler_id",
      source_user_id: "source_user_id",
      destination_user_id: "destination_user_id",
      transferred_by_id: "transferred_by_id",
      created_at: "created_at",
      updated_at: "updated_at",
      accepted_at: "accepted_at",
      rejected_at: "rejected_at",
      token: "token",
      returned: "returned",
      returned_at: "returned_at",
      is_derivation: "is_derivation"
    };
    exports2.Prisma.TransitionTargetScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      reference: "reference",
      stage_id: "stage_id"
    };
    exports2.Prisma.CompanyClaimStatusOrderRuleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id",
      reference: "reference",
      order: "order",
      company_id: "company_id",
      fixed: "fixed"
    };
    exports2.Prisma.CompanyClaimTriggerMappingScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      trigger: "trigger",
      message_template_id: "message_template_id",
      action: "action",
      status_id: "status_id",
      reference_id: "reference_id",
      preserves_reference: "preserves_reference",
      stage_id: "stage_id",
      system_status: "system_status",
      request_resolution_review: "request_resolution_review",
      order: "order"
    };
    exports2.Prisma.SLAInstanceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sla_id: "sla_id",
      created_at: "created_at",
      deadline: "deadline",
      completed_at: "completed_at",
      company_id: "company_id",
      company_linked_at: "company_linked_at",
      time_to_resolution_type: "time_to_resolution_type",
      time_to_resolution_value: "time_to_resolution_value",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.ClaimEstimateChangeScalarFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      property: "property",
      from_value: "from_value",
      to_value: "to_value",
      reason: "reason",
      source: "source",
      changed_by_id: "changed_by_id",
      ingest_event_id: "ingest_event_id",
      created_at: "created_at"
    };
    exports2.Prisma.ClaimScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      external_claim_id: "external_claim_id",
      external_claim_request_id: "external_claim_request_id",
      external_claim_created_at: "external_claim_created_at",
      external_claim_request_created_at: "external_claim_request_created_at",
      external_policyholder_number: "external_policyholder_number",
      ref_id: "ref_id",
      sequence: "sequence",
      closed_at: "closed_at",
      claim_type_id: "claim_type_id",
      external_claim_updated_at: "external_claim_updated_at",
      company_id: "company_id",
      target_group_id: "target_group_id",
      team_id: "team_id",
      titular_user_id: "titular_user_id",
      titular_team_id: "titular_team_id",
      coordinator_id: "coordinator_id",
      selected_external_complaint_id: "selected_external_complaint_id",
      external_complaint_selected_at: "external_complaint_selected_at",
      selected_pending_complaint_id: "selected_pending_complaint_id",
      pending_complaint_selected_at: "pending_complaint_selected_at",
      entrypoint_id: "entrypoint_id",
      entrypoint_snapshot_progress_id: "entrypoint_snapshot_progress_id",
      entrypoint_integration: "entrypoint_integration",
      entrypoint_backend: "entrypoint_backend",
      entrypoint_environment: "entrypoint_environment",
      policyholder_license_plate: "policyholder_license_plate",
      is_policyholder_vehicle_trailer: "is_policyholder_vehicle_trailer",
      policyholder_policy_number: "policyholder_policy_number",
      victim_id: "victim_id",
      sinister_id: "sinister_id",
      field_adjuster_id: "field_adjuster_id",
      field_adjuster_contact_id: "field_adjuster_contact_id",
      ramo_id: "ramo_id",
      owner_id: "owner_id",
      created_by_id: "created_by_id",
      material_judicial_amount: "material_judicial_amount",
      person_judicial_amount: "person_judicial_amount",
      person_percentage_of_judicial_risk: "person_percentage_of_judicial_risk",
      percentage_of_liability: "percentage_of_liability",
      administrative_amount: "administrative_amount",
      material_administrative_amount: "material_administrative_amount",
      person_administrative_amount: "person_administrative_amount",
      estimates_updated_at: "estimates_updated_at",
      estimates_updated_source: "estimates_updated_source",
      latest_estimates_update_reason: "latest_estimates_update_reason",
      created_at: "created_at",
      desired_support_location_state: "desired_support_location_state",
      desired_support_location_state_municipality: "desired_support_location_state_municipality",
      ocurrence_id: "ocurrence_id",
      claimed_amount: "claimed_amount",
      latest_communication_status_id: "latest_communication_status_id",
      claim_status_id: "claim_status_id",
      system_status: "system_status",
      reference_id: "reference_id",
      stage_id: "stage_id",
      sequence_starter: "sequence_starter",
      created_notification_sent_at: "created_notification_sent_at",
      sla_migrated_at: "sla_migrated_at",
      status_sla_deadline: "status_sla_deadline",
      is_claimant_and_victim_same_insurer: "is_claimant_and_victim_same_insurer",
      customer_organization_id: "customer_organization_id"
    };
    exports2.Prisma.ClaimDerivationScalarFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      derived_at: "derived_at",
      derived_by_user_id: "derived_by_user_id",
      derived_to_user_id: "derived_to_user_id",
      reason: "reason",
      paused_status_objective_instance_id: "paused_status_objective_instance_id",
      returned_at: "returned_at",
      canceled_at: "canceled_at",
      canceled_reason: "canceled_reason",
      canceled_by_user_id: "canceled_by_user_id",
      previous_company_claim_status_id: "previous_company_claim_status_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ClaimAlertScalarFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      type: "type",
      created_at: "created_at",
      resolved_at: "resolved_at",
      fraud_investigation_case_id: "fraud_investigation_case_id"
    };
    exports2.Prisma.CompanyClaimStageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.ComplaintTransitionTargetScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id"
    };
    exports2.Prisma.CompanyComplaintStatusOrderRuleScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id",
      reference: "reference",
      order: "order",
      company_id: "company_id",
      fixed: "fixed"
    };
    exports2.Prisma.CompanyComplaintStageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.TotalInstanceSLAScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      sla_id: "sla_id",
      company_linked_at: "company_linked_at",
      start_pointer_type: "start_pointer_type",
      start_pointer_id: "start_pointer_id",
      end_pointer_type: "end_pointer_type",
      end_pointer_id: "end_pointer_id",
      time_to_resolution_type: "time_to_resolution_type",
      time_to_resolution_value: "time_to_resolution_value",
      deadline: "deadline",
      completed_at: "completed_at",
      created_at: "created_at",
      updated_at: "updated_at",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.ObjectiveInstanceSLAScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      objective_id: "objective_id",
      time_to_resolution_type: "time_to_resolution_type",
      time_to_resolution_value: "time_to_resolution_value",
      consumed_before_resume_value: "consumed_before_resume_value",
      parent_objective_instance_id: "parent_objective_instance_id",
      created_at: "created_at",
      started_at: "started_at",
      deadline: "deadline",
      completed_at: "completed_at",
      company_id: "company_id",
      company_linked_at: "company_linked_at",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.StatusTransitionDurationScalarFieldEnum = {
      id: "id",
      duration_type: "duration_type",
      duration_value: "duration_value",
      elapsed_duration_criteria: "elapsed_duration_criteria",
      calendar_id: "calendar_id",
      company_id: "company_id",
      reference_type: "reference_type",
      reference_value: "reference_value",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ClaimStatusTransitionDurationScalarFieldEnum = {
      id: "id",
      status_transition_duration_id: "status_transition_duration_id",
      claim_status_transition_id: "claim_status_transition_id"
    };
    exports2.Prisma.ClaimStatusTransitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      from_claim_status_id: "from_claim_status_id",
      to_claim_status_id: "to_claim_status_id",
      claim_status_sequence: "claim_status_sequence",
      from_reference_id: "from_reference_id",
      to_reference_id: "to_reference_id",
      reference_sequence: "reference_sequence",
      from_stage_id: "from_stage_id",
      to_stage_id: "to_stage_id",
      stage_sequence: "stage_sequence",
      from_system_status: "from_system_status",
      to_system_status: "to_system_status",
      created_at: "created_at",
      communication_sent_at: "communication_sent_at",
      triggered_by_derivation_end: "triggered_by_derivation_end",
      action_type: "action_type",
      action_output_id: "action_output_id"
    };
    exports2.Prisma.ComplaintStatusTransitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      complaint_id: "complaint_id",
      from_complaint_status_id: "from_complaint_status_id",
      to_complaint_status_id: "to_complaint_status_id",
      from_reference_id: "from_reference_id",
      to_reference_id: "to_reference_id",
      from_stage_id: "from_stage_id",
      to_stage_id: "to_stage_id",
      from_system_status: "from_system_status",
      to_system_status: "to_system_status",
      created_at: "created_at"
    };
    exports2.Prisma.CompanyClaimReferenceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.CompanyComplaintReferenceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.CompanyClaimStatusScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      status: "status",
      sub_status_name: "sub_status_name",
      reference: "reference",
      company_claim_public_status_id: "company_claim_public_status_id",
      role: "role",
      deleted_at: "deleted_at",
      external_id: "external_id",
      metadata: "metadata"
    };
    exports2.Prisma.ClaimResultScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id"
    };
    exports2.Prisma.ReviewScalarFieldEnum = {
      id: "id",
      type: "type",
      respondent_type: "respondent_type",
      score: "score",
      comment: "comment",
      company_id: "company_id",
      claim_id: "claim_id",
      user_id: "user_id",
      token: "token",
      invited_at: "invited_at",
      answered_at: "answered_at",
      requested_status_id: "requested_status_id",
      created_at: "created_at"
    };
    exports2.Prisma.TeamDelegationNoticeDismissalScalarFieldEnum = {
      id: "id",
      user_id: "user_id",
      job_id: "job_id",
      kind: "kind",
      starts_at: "starts_at",
      created_at: "created_at"
    };
    exports2.Prisma.PerformanceSnapshotScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      scope_key: "scope_key",
      block: "block",
      payload: "payload",
      computed_at: "computed_at"
    };
    exports2.Prisma.NegotiationTypeAverageSnapshotScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_type_id: "claim_type_id",
      ratio_sum: "ratio_sum",
      universe_size: "universe_size",
      window_start: "window_start",
      as_of: "as_of",
      refresh_leased_until: "refresh_leased_until"
    };
    exports2.Prisma.ReleaseNoteScalarFieldEnum = {
      id: "id",
      slug: "slug",
      title: "title",
      subtitle: "subtitle",
      audience: "audience",
      kind: "kind",
      status: "status",
      required_company_flag: "required_company_flag",
      visible: "visible",
      adoption: "adoption",
      published_at: "published_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ReleaseNoteItemScalarFieldEnum = {
      id: "id",
      release_note_id: "release_note_id",
      position: "position",
      kind: "kind",
      title: "title",
      description: "description",
      summary: "summary"
    };
    exports2.Prisma.ReleaseNoteSectionScalarFieldEnum = {
      id: "id",
      item_id: "item_id",
      position: "position",
      kind: "kind",
      title: "title",
      content: "content"
    };
    exports2.Prisma.ReleaseNoteEventScalarFieldEnum = {
      id: "id",
      type: "type",
      visit_id: "visit_id",
      user_id: "user_id",
      company_id: "company_id",
      release_note_id: "release_note_id",
      item_id: "item_id",
      section_id: "section_id",
      metadata: "metadata",
      duration_ms: "duration_ms",
      occurred_at: "occurred_at",
      created_at: "created_at"
    };
    exports2.Prisma.ReleaseNoteRecipientScalarFieldEnum = {
      id: "id",
      release_note_id: "release_note_id",
      company_id: "company_id",
      user_id: "user_id",
      role_id: "role_id",
      created_at: "created_at"
    };
    exports2.Prisma.ValidationPatternScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      extractor: "extractor",
      pattern: "pattern",
      column: "column",
      company_id: "company_id"
    };
    exports2.Prisma.EncryptedMessageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      iv: "iv",
      content: "content"
    };
    exports2.Prisma.LoginCredentialsScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user: "user",
      password_id: "password_id",
      extra_credential_value: "extra_credential_value",
      locked: "locked",
      locked_by_job_id: "locked_by_job_id"
    };
    exports2.Prisma.IntegrationConnectionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      integration_id: "integration_id",
      access_token: "access_token",
      connected_account_email: "connected_account_email",
      refresh_token: "refresh_token",
      expires_at: "expires_at",
      company_id: "company_id",
      user_id: "user_id",
      webhook_id: "webhook_id",
      webhook_created_at: "webhook_created_at",
      webhook_secret: "webhook_secret",
      scopes: "scopes",
      invalidated_at: "invalidated_at",
      invalidated_reason: "invalidated_reason",
      external_user_id: "external_user_id",
      external_company_id: "external_company_id",
      oauth_mode: "oauth_mode",
      kach_m2m_enabled: "kach_m2m_enabled",
      client_id: "client_id",
      client_secret: "client_secret",
      refresh_lease_until: "refresh_lease_until",
      connected_at: "connected_at",
      created_at: "created_at"
    };
    exports2.Prisma.OAuthAuthorizationAttemptScalarFieldEnum = {
      id: "id",
      state_hash: "state_hash",
      code_verifier: "code_verifier",
      integration_backend: "integration_backend",
      redirect_uri: "redirect_uri",
      user_id: "user_id",
      company_id: "company_id",
      expires_at: "expires_at",
      used_at: "used_at",
      created_at: "created_at"
    };
    exports2.Prisma.IntegrationScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      backend: "backend",
      oauth_url: "oauth_url",
      description: "description",
      name: "name",
      scope: "scope",
      method: "method",
      visibility: "visibility",
      file_id: "file_id"
    };
    exports2.Prisma.AutoinspectorTemplateScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      use_case: "use_case",
      external_id: "external_id",
      external_name: "external_name",
      generates_report: "generates_report",
      field_mappings: "field_mappings",
      enabled: "enabled",
      deleted_at: "deleted_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AutoinspectorInspectionScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      template_id: "template_id",
      use_case: "use_case",
      external_id: "external_id",
      external_template_id: "external_template_id",
      status: "status",
      result: "result",
      correlation_type: "correlation_type",
      correlation_id: "correlation_id",
      magic_link: "magic_link",
      access_code: "access_code",
      metadata: "metadata",
      started_at: "started_at",
      finished_at: "finished_at",
      completed_at: "completed_at",
      raw_result: "raw_result",
      request_body: "request_body",
      report_file_id: "report_file_id",
      report_request_id: "report_request_id",
      report_requested_at: "report_requested_at",
      report_failed_at: "report_failed_at",
      report_attempts: "report_attempts",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AutoinspectorInspectionAssetScalarFieldEnum = {
      id: "id",
      inspection_id: "inspection_id",
      file_id: "file_id",
      external_file_id: "external_file_id",
      asset_identifier: "asset_identifier",
      verdict: "verdict",
      inferences: "inferences",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AutoinspectorWebhookEventScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      external_inspection_id: "external_inspection_id",
      event: "event",
      payload: "payload",
      payload_hash: "payload_hash",
      status: "status",
      processed_at: "processed_at",
      error: "error",
      received_at: "received_at"
    };
    exports2.Prisma.ClaimFileInspectionStateScalarFieldEnum = {
      id: "id",
      file_id: "file_id",
      claim_id: "claim_id",
      company_id: "company_id",
      job_id: "job_id",
      status: "status",
      reserved_at: "reserved_at",
      sent_at: "sent_at",
      verified_at: "verified_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ValidationDefinitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entrypoint_id: "entrypoint_id",
      entity_id: "entity_id",
      tag_id: "tag_id",
      validation: "validation"
    };
    exports2.Prisma.ExportedReportScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      status: "status",
      columns: "columns",
      filters: "filters",
      generated_by_id: "generated_by_id",
      file_id: "file_id",
      completed_at: "completed_at"
    };
    exports2.Prisma.JobScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      schedule: "schedule",
      error_trace: "error_trace",
      reschedule_locked_at: "reschedule_locked_at",
      execute_at: "execute_at",
      scheduled_at: "scheduled_at",
      started_at: "started_at",
      failed_at: "failed_at",
      cancelled_at: "cancelled_at",
      locked: "locked",
      completed_at: "completed_at",
      manual: "manual",
      status: "status",
      failed_reason: "failed_reason",
      cancelled_reason: "cancelled_reason",
      created_by_id: "created_by_id",
      progress: "progress",
      payload: "payload",
      created_at: "created_at",
      metadata: "metadata",
      company_id: "company_id"
    };
    exports2.Prisma.EntityDefinitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entity: "entity",
      entrypoint_id: "entrypoint_id",
      tag_id: "tag_id"
    };
    exports2.Prisma.EntrypointScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      company_id: "company_id",
      endpoint: "endpoint",
      integration: "integration",
      backend: "backend",
      environment: "environment",
      name: "name",
      avatar_id: "avatar_id",
      specification: "specification"
    };
    exports2.Prisma.EntrypointSpecialPermissionScalarFieldEnum = {
      id: "id",
      entrypoint_id: "entrypoint_id",
      user_id: "user_id",
      permission: "permission",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.UserScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      username: "username",
      cellphone: "cellphone",
      mail_verification_locked_at: "mail_verification_locked_at",
      mail_verification_attempts: "mail_verification_attempts",
      first_name: "first_name",
      source: "source",
      profile_photo: "profile_photo",
      nationality: "nationality",
      profession: "profession",
      last_name: "last_name",
      is_owner: "is_owner",
      country: "country",
      email: "email",
      verified: "verified",
      role_id: "role_id",
      birth_date: "birth_date",
      password: "password",
      identification: "identification",
      sex: "sex",
      marital_status: "marital_status",
      address: "address",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      zip_code: "zip_code",
      type: "type",
      company_id: "company_id",
      is_operational: "is_operational",
      ein: "ein",
      dni: "dni",
      accepts_assignments: "accepts_assignments",
      assignments_paused_at: "assignments_paused_at",
      avatar_id: "avatar_id",
      deleted_at: "deleted_at",
      created_at: "created_at",
      customer_organization_id: "customer_organization_id"
    };
    exports2.Prisma.IdentityProviderScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      provider_id: "provider_id",
      provider_type: "provider_type",
      user_id: "user_id"
    };
    exports2.Prisma.EstimatesOperandDefinitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      natural_key: "natural_key",
      estimates_definition_id: "estimates_definition_id",
      min_value: "min_value",
      max_value: "max_value"
    };
    exports2.Prisma.CompanyEstimatesDefinitionScalarFieldEnum = {
      name: "name",
      strategy: "strategy",
      scope: "scope",
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CompanyFlagsScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      claim_evaluation: "claim_evaluation",
      claim_rfp: "claim_rfp",
      orders: "orders",
      providers: "providers",
      performance_metrics: "performance_metrics",
      recovery_claim: "recovery_claim",
      team_management: "team_management",
      release_notes: "release_notes"
    };
    exports2.Prisma.CompanyWorkingExceptionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      start_date: "start_date",
      end_date: "end_date"
    };
    exports2.Prisma.CompanyWorkingDayScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      enabled: "enabled",
      day: "day",
      start_time: "start_time",
      end_time: "end_time",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.CompanyCalendarScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      version: "version",
      latest: "latest",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CompanyCurrencyScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      default: "default",
      currency: "currency"
    };
    exports2.Prisma.FieldMappingConfigScalarFieldEnum = {
      id: "id",
      entity: "entity",
      from_field: "from_field",
      to_field: "to_field",
      company_id: "company_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.MemberScalarFieldEnum = {
      id: "id",
      user_id: "user_id",
      company_id: "company_id"
    };
    exports2.Prisma.CustomerOrganizationScalarFieldEnum = {
      id: "id",
      name: "name",
      ein: "ein",
      phone: "phone",
      email: "email",
      address: "address",
      logo_id: "logo_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CustomerOrganizationInvitationScalarFieldEnum = {
      id: "id",
      customer_organization_id: "customer_organization_id",
      company_id: "company_id",
      email: "email",
      first_name: "first_name",
      last_name: "last_name",
      token_hash: "token_hash",
      status: "status",
      expires_at: "expires_at",
      accepted_at: "accepted_at",
      cancelled_at: "cancelled_at",
      last_sent_at: "last_sent_at",
      sent_count: "sent_count",
      user_id: "user_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CompanyScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      name: "name",
      ein: "ein",
      domain: "domain",
      domain_invitations_only: "domain_invitations_only",
      company_owner_id: "company_owner_id",
      logo_id: "logo_id",
      tenant_slug: "tenant_slug",
      prod_api_key: "prod_api_key",
      sandbox_api_key: "sandbox_api_key",
      country: "country",
      alias: "alias",
      insurer_theme: "insurer_theme",
      customer_theme: "customer_theme"
    };
    exports2.Prisma.VerticalScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      slug: "slug",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.GoodScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      vertical_id: "vertical_id",
      name: "name",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ServiceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      vertical_id: "vertical_id",
      name: "name",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.CompanyVerticalScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      vertical_id: "vertical_id",
      created_at: "created_at"
    };
    exports2.Prisma.ProvinceScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      georef_id: "georef_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.DepartmentScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      georef_id: "georef_id",
      province_id: "province_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.LocalityScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      georef_id: "georef_id",
      name: "name",
      latitude: "latitude",
      longitude: "longitude",
      province_id: "province_id",
      department_id: "department_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderInvitationScalarFieldEnum = {
      id: "id",
      insurer_company_id: "insurer_company_id",
      invited_by_user_id: "invited_by_user_id",
      email: "email",
      invitation_name: "invitation_name",
      token: "token",
      status: "status",
      responded_at: "responded_at",
      registered_at: "registered_at",
      engagement_id: "engagement_id",
      deleted_at: "deleted_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      legal_name: "legal_name",
      email: "email",
      ein: "ein",
      phone: "phone",
      source: "source",
      onboarding_completed: "onboarding_completed",
      address: "address",
      locality_id: "locality_id",
      contact_email: "contact_email",
      description: "description",
      deleted_at: "deleted_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.EngagementScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      insurer_company_id: "insurer_company_id",
      provider_id: "provider_id",
      status: "status",
      onboarding_completeness: "onboarding_completeness",
      notes: "notes",
      external_id: "external_id",
      deleted_at: "deleted_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderCapabilityScalarFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      vertical_id: "vertical_id",
      service_id: "service_id",
      created_at: "created_at"
    };
    exports2.Prisma.ProviderCapabilityGoodScalarFieldEnum = {
      id: "id",
      capability_id: "capability_id",
      good_id: "good_id"
    };
    exports2.Prisma.ProviderCoverageScalarFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      level: "level",
      province_id: "province_id",
      department_id: "department_id",
      locality_id: "locality_id",
      created_at: "created_at"
    };
    exports2.Prisma.ProviderBranchScalarFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      name: "name",
      address: "address",
      locality_id: "locality_id",
      latitude: "latitude",
      longitude: "longitude",
      phones: "phones",
      emails: "emails",
      is_central: "is_central",
      deleted_at: "deleted_at",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderDocumentTypeScalarFieldEnum = {
      id: "id",
      name: "name",
      description: "description",
      is_required: "is_required",
      is_active: "is_active",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderDocumentScalarFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      document_type_id: "document_type_id",
      file_id: "file_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.InsurerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id"
    };
    exports2.Prisma.MotoScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      make: "make",
      model: "model",
      version: "version",
      tenant: "tenant",
      external_id: "external_id"
    };
    exports2.Prisma.CarScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      make: "make",
      model: "model",
      version: "version",
      tenant: "tenant",
      external_id: "external_id"
    };
    exports2.Prisma.HealthInsuranceFundScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name"
    };
    exports2.Prisma.WorkerCompensationInsurerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name"
    };
    exports2.Prisma.CompanyRamoScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      code: "code",
      description: "description",
      is_automotive: "is_automotive",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyAgencyScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      code: "code",
      description: "description",
      company_id: "company_id"
    };
    exports2.Prisma.ProductScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      sku: "sku",
      name: "name",
      brand: "brand",
      description: "description",
      unit_price: "unit_price",
      is_active: "is_active",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProductImportScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      created_by_id: "created_by_id",
      file_id: "file_id",
      status: "status",
      mapping: "mapping",
      options: "options",
      errors: "errors",
      total_rows: "total_rows",
      created_count: "created_count",
      updated_count: "updated_count",
      skipped_count: "skipped_count",
      error_count: "error_count",
      failed_reason: "failed_reason",
      error_trace: "error_trace",
      started_at: "started_at",
      completed_at: "completed_at",
      failed_at: "failed_at",
      created_at: "created_at"
    };
    exports2.Prisma.CompanyCustomerScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      code: "code",
      description: "description",
      deleted_at: "deleted_at",
      deleted_by_id: "deleted_by_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.IntakeSubmissionScalarFieldEnum = {
      id: "id",
      type: "type",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      company_customer_id: "company_customer_id",
      locality_id: "locality_id",
      good_id: "good_id",
      service_id: "service_id",
      vertical_id: "vertical_id",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderGroupScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ProviderGroupMemberScalarFieldEnum = {
      id: "id",
      group_id: "group_id",
      provider_id: "provider_id",
      created_at: "created_at"
    };
    exports2.Prisma.InvitationScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      created_at: "created_at",
      accepted: "accepted",
      accepted_at: "accepted_at",
      role_id: "role_id",
      user_id: "user_id",
      email: "email",
      token: "token",
      guest_user_id: "guest_user_id"
    };
    exports2.Prisma.SeederScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      key: "key",
      executed_at: "executed_at"
    };
    exports2.Prisma.TopicSubscriptionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      topic_id: "topic_id",
      user_id: "user_id",
      protocols: "protocols"
    };
    exports2.Prisma.TopicScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      event: "event",
      name: "name",
      description: "description",
      scope: "scope"
    };
    exports2.Prisma.AlertScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      name: "name",
      description: "description",
      display_target: "display_target",
      scope: "scope"
    };
    exports2.Prisma.AlertSubscriptionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      alert_id: "alert_id",
      user_id: "user_id",
      company_id: "company_id",
      interval_hours: "interval_hours",
      active: "active",
      trigger_count: "trigger_count",
      progress_trigger: "progress_trigger",
      created_at: "created_at",
      scope: "scope"
    };
    exports2.Prisma.NotificationReceiverScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      notification_id: "notification_id",
      user_id: "user_id",
      read: "read"
    };
    exports2.Prisma.NotificationScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      actor_id: "actor_id",
      protocol: "protocol",
      href: "href",
      effective_date: "effective_date",
      created_at: "created_at",
      claim_id: "claim_id"
    };
    exports2.Prisma.StylesConfigScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      scope: "scope",
      company_id: "company_id",
      logo_id: "logo_id",
      border_radius: "border_radius",
      color_theme: "color_theme",
      mode: "mode",
      font_family: "font_family"
    };
    exports2.Prisma.CompanyLinkScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      logo_id: "logo_id",
      link: "link",
      name: "name"
    };
    exports2.Prisma.CompanySinisterConfigCountriesScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      config_id: "config_id",
      code: "code"
    };
    exports2.Prisma.CompanySinisterConfigScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.WebhookLogScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      webhook_id: "webhook_id",
      event: "event",
      endpoint: "endpoint",
      payload: "payload",
      signature: "signature",
      created_at: "created_at",
      response: "response",
      status_code: "status_code",
      mode: "mode"
    };
    exports2.Prisma.WebhookEventSubscriptionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      webhook_id: "webhook_id",
      event: "event",
      created_at: "created_at"
    };
    exports2.Prisma.WebhookScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      endpoint: "endpoint",
      name: "name",
      created_at: "created_at",
      updated_at: "updated_at",
      created_by_id: "created_by_id",
      disabled: "disabled",
      signature: "signature",
      events: "events",
      company_id: "company_id",
      mode: "mode"
    };
    exports2.Prisma.CompanyComplaintPublicStatusScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name"
    };
    exports2.Prisma.CompanyComplaintTriggerMappingScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      trigger: "trigger",
      status_id: "status_id",
      reference_id: "reference_id",
      stage_id: "stage_id",
      system_status: "system_status",
      message_template_id: "message_template_id",
      action: "action"
    };
    exports2.Prisma.CompanyComplaintStatusScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      sub_status_name: "sub_status_name",
      status: "status",
      reference: "reference",
      company_complaint_public_status_id: "company_complaint_public_status_id",
      role: "role",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.EntrypointSessionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      token: "token",
      entrypoint_id: "entrypoint_id",
      company_id: "company_id",
      status: "status",
      expires_at: "expires_at",
      completed_at: "completed_at"
    };
    exports2.Prisma.ComplaintSinisterCauseScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.EstimatesOperandValueScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      estimates_operand_definition_id: "estimates_operand_definition_id",
      name: "name",
      min_value: "min_value",
      max_value: "max_value",
      value: "value",
      natural_key: "natural_key",
      latest: "latest",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.AffectedCoverageScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      balance: "balance",
      insured_amount: "insured_amount",
      additional: "additional",
      external_id: "external_id",
      sync_status: "sync_status",
      synced_at: "synced_at",
      created_at: "created_at"
    };
    exports2.Prisma.ComplaintScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      is_recoverable: "is_recoverable",
      requires_spare_parts: "requires_spare_parts",
      external_complaint_updated_at: "external_complaint_updated_at",
      field_adjuster_contact_id: "field_adjuster_contact_id",
      ref_id: "ref_id",
      sequence: "sequence",
      field_adjuster_id: "field_adjuster_id",
      sinister_cause_id: "sinister_cause_id",
      proxy_external_complaint_id: "proxy_external_complaint_id",
      authorized_at: "authorized_at",
      authorized_by_id: "authorized_by_id",
      external_authorized_at: "external_authorized_at",
      rejected_at: "rejected_at",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason",
      external_rejected_at: "external_rejected_at",
      approved_at: "approved_at",
      approved_by_id: "approved_by_id",
      external_approved_at: "external_approved_at",
      company_id: "company_id",
      created_at: "created_at",
      updated_at: "updated_at",
      saved_at: "saved_at",
      portal_token: "portal_token",
      type: "type",
      policyholder_id: "policyholder_id",
      sinister_id: "sinister_id",
      system_status: "system_status",
      status_id: "status_id",
      reference_id: "reference_id",
      stage_id: "stage_id",
      ramo_id: "ramo_id",
      entrypoint_integration: "entrypoint_integration",
      entrypoint_backend: "entrypoint_backend",
      entrypoint_id: "entrypoint_id",
      third_party_exists: "third_party_exists",
      occurrence_id: "occurrence_id",
      signature_id: "signature_id"
    };
    exports2.Prisma.VariableDefinitionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      type: "type",
      min_value_type: "min_value_type",
      min_value_reference: "min_value_reference",
      min_value_literal: "min_value_literal",
      determination: "determination",
      max_value_type: "max_value_type",
      max_value_reference: "max_value_reference",
      max_value_literal: "max_value_literal",
      options: "options",
      required: "required",
      min_length: "min_length",
      max_length: "max_length",
      guid: "guid",
      numeric_format: "numeric_format",
      numeric_format_currency: "numeric_format_currency"
    };
    exports2.Prisma.VariableValidationScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid",
      validation: "validation",
      references: "references"
    };
    exports2.Prisma.VariableConditionScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid",
      variable: "variable",
      operator: "operator",
      value: "value",
      action: "action",
      target: "target"
    };
    exports2.Prisma.MessageTemplateScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      message: "message",
      context: "context",
      subject: "subject",
      scope: "scope",
      role: "role",
      company_id: "company_id"
    };
    exports2.Prisma.TeamScalarFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      coordinator_id: "coordinator_id",
      default: "default",
      last_assigned_user_id: "last_assigned_user_id",
      last_assigned_index: "last_assigned_index",
      accepts_assignments: "accepts_assignments",
      deleted_at: "deleted_at"
    };
    exports2.Prisma.ServiceAccountScalarFieldEnum = {
      id: "id",
      name: "name",
      description: "description",
      created_at: "created_at",
      updated_at: "updated_at",
      company_id: "company_id",
      token: "token"
    };
    exports2.Prisma.MessageHashScalarFieldEnum = {
      id: "id",
      hash: "hash",
      created_at: "created_at"
    };
    exports2.Prisma.VerificationScalarFieldEnum = {
      id: "id",
      value: "value",
      expires_at: "expires_at",
      created_at: "created_at",
      email: "email",
      user_id: "user_id"
    };
    exports2.Prisma.InferredFileDataScalarFieldEnum = {
      id: "id",
      file_id: "file_id",
      created_at: "created_at",
      response: "response",
      summary: "summary"
    };
    exports2.Prisma.InferredFileDataManualUpdateScalarFieldEnum = {
      id: "id",
      inferred_file_data_id: "inferred_file_data_id",
      updated_by_id: "updated_by_id",
      from_tag_id: "from_tag_id",
      to_tag_id: "to_tag_id"
    };
    exports2.Prisma.InferredKeywordsScalarFieldEnum = {
      id: "id",
      inferred_file_data_id: "inferred_file_data_id",
      key: "key",
      value: "value",
      non_registered_value_type: "non_registered_value_type",
      type: "type",
      created_at: "created_at"
    };
    exports2.Prisma.InferredKeywordsManualUpdateScalarFieldEnum = {
      id: "id",
      inferred_keywords_id: "inferred_keywords_id",
      updated_by_id: "updated_by_id",
      from_key: "from_key",
      to_key: "to_key",
      from_value: "from_value",
      to_value: "to_value",
      created_at: "created_at"
    };
    exports2.Prisma.WorkflowScalarFieldEnum = {
      id: "id",
      company_id: "company_id",
      provider: "provider",
      key_name: "key_name",
      description: "description",
      workflow_external_id: "workflow_external_id",
      workflow_external_name: "workflow_external_name",
      workflow_version_external_id: "workflow_version_external_id",
      workflow_version_external_name: "workflow_version_external_name",
      created_at: "created_at",
      updated_at: "updated_at"
    };
    exports2.Prisma.ErrorNotificationScalarFieldEnum = {
      id: "id",
      error: "error",
      url: "url",
      queue_name: "queue_name",
      queue_message: "queue_message",
      created_at: "created_at",
      recieved_count: "recieved_count",
      last_recieved_at: "last_recieved_at"
    };
    exports2.Prisma.SortOrder = {
      asc: "asc",
      desc: "desc"
    };
    exports2.Prisma.NullableJsonNullValueInput = {
      DbNull: Prisma27.DbNull,
      JsonNull: Prisma27.JsonNull
    };
    exports2.Prisma.JsonNullValueInput = {
      JsonNull: Prisma27.JsonNull
    };
    exports2.Prisma.NullsOrder = {
      first: "first",
      last: "last"
    };
    exports2.Prisma.CityOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id",
      country: "country",
      state: "state"
    };
    exports2.Prisma.CountryZipCodeOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      country: "country",
      state: "state",
      city: "city",
      zip_code: "zip_code"
    };
    exports2.Prisma.VirtualViewFilterOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      column: "column",
      value: "value",
      display_value: "display_value",
      virtual_view_id: "virtual_view_id"
    };
    exports2.Prisma.VirtualViewColumnOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      column: "column",
      virtual_view_id: "virtual_view_id"
    };
    exports2.Prisma.JsonNullValueFilter = {
      DbNull: Prisma27.DbNull,
      JsonNull: Prisma27.JsonNull,
      AnyNull: Prisma27.AnyNull
    };
    exports2.Prisma.VirtualViewOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      user_id: "user_id"
    };
    exports2.Prisma.TagOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description"
    };
    exports2.Prisma.ValidationResultOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      validation_definition_id: "validation_definition_id",
      file_id: "file_id",
      inferred_entity_id: "inferred_entity_id"
    };
    exports2.Prisma.InferredNationalIdentityCardOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      birth_date: "birth_date",
      issued_date: "issued_date",
      sex: "sex",
      expiration_date: "expiration_date",
      document_number: "document_number"
    };
    exports2.Prisma.InferredCoverageCertificateOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      effective_date_from: "effective_date_from",
      effective_date_to: "effective_date_to"
    };
    exports2.Prisma.InferredDeathCertificateOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      day: "day",
      hour: "hour",
      year: "year",
      reason: "reason"
    };
    exports2.Prisma.InferredMedicalCertificateOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      doctor_full_name: "doctor_full_name",
      doctor_license_number: "doctor_license_number",
      date: "date",
      diagnosis: "diagnosis"
    };
    exports2.Prisma.InferredVehicleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      license_plate: "license_plate"
    };
    exports2.Prisma.InferredVehicleIdCardFrontOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      license_plate: "license_plate",
      id_card_number: "id_card_number",
      chassis_number: "chassis_number",
      model: "model",
      make: "make",
      type: "type",
      use: "use",
      motor: "motor",
      expiration_date: "expiration_date"
    };
    exports2.Prisma.InferredVehicleIdCardBackOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      owner_name: "owner_name",
      owner_address: "owner_address",
      owner_identity_number: "owner_identity_number"
    };
    exports2.Prisma.InferredEntityOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entity_id: "entity_id",
      file_id: "file_id"
    };
    exports2.Prisma.FileOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      original_name: "original_name",
      external_id: "external_id",
      stored_name: "stored_name",
      extension: "extension",
      mimetype: "mimetype",
      uploaded_by_id: "uploaded_by_id",
      company_id: "company_id",
      inverse_relation_id: "inverse_relation_id"
    };
    exports2.Prisma.LegalPersonOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      social_reason: "social_reason",
      cuit: "cuit",
      address: "address",
      state: "state",
      city: "city",
      zip_code: "zip_code",
      email: "email"
    };
    exports2.Prisma.NaturalPersonOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      nationality: "nationality",
      address: "address",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      zip_code: "zip_code",
      email: "email",
      cellphone: "cellphone",
      identification_value: "identification_value"
    };
    exports2.Prisma.PersonParentOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      identification: "identification",
      natural_person_id: "natural_person_id"
    };
    exports2.Prisma.InHouseLawyerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      email: "email",
      registered_user_id: "registered_user_id",
      company_id: "company_id"
    };
    exports2.Prisma.PersonDamageDetailOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      person_damage_id: "person_damage_id"
    };
    exports2.Prisma.PersonDamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      surgery_description: "surgery_description",
      health_insurance_fund: "health_insurance_fund",
      treatment_worker_compensation_insurer: "treatment_worker_compensation_insurer",
      treatment_medical_institution: "treatment_medical_institution",
      driver_id: "driver_id",
      policyholder_relationship_other: "policyholder_relationship_other"
    };
    exports2.Prisma.RecoveryDamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      institution_id: "institution_id",
      damaged_person_id: "damaged_person_id"
    };
    exports2.Prisma.OrderReportOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      order_id: "order_id",
      file_id: "file_id",
      created_by_id: "created_by_id",
      rejected_by_id: "rejected_by_id",
      accepted_by_id: "accepted_by_id",
      rejected_reason: "rejected_reason",
      notes: "notes"
    };
    exports2.Prisma.OrderInvoiceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      file_id: "file_id",
      order_id: "order_id",
      accepted_by_id: "accepted_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason"
    };
    exports2.Prisma.OrderItemOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      order_id: "order_id",
      product_id: "product_id",
      description: "description"
    };
    exports2.Prisma.OrderOrderByRelevanceFieldEnum = {
      id: "id",
      ref_id: "ref_id",
      company_id: "company_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      request_for_proposal_id: "request_for_proposal_id",
      provider_id: "provider_id",
      engagement_id: "engagement_id",
      vertical_id: "vertical_id",
      vertical_name: "vertical_name",
      service_id: "service_id",
      service_name: "service_name",
      good_id: "good_id",
      good_name: "good_name",
      locality_id: "locality_id",
      locality_name: "locality_name",
      department_name: "department_name",
      province_name: "province_name",
      description: "description",
      name: "name",
      vendor_contact_id: "vendor_contact_id",
      vendor_user_id: "vendor_user_id",
      notes: "notes",
      created_by_id: "created_by_id",
      rejected_reason: "rejected_reason",
      canceled_reason: "canceled_reason",
      responded_by_user_id: "responded_by_user_id",
      canceled_by_user_id: "canceled_by_user_id",
      completed_by_id: "completed_by_id",
      external_id: "external_id",
      trace_id: "trace_id"
    };
    exports2.Prisma.OrderScheduleOrderByRelevanceFieldEnum = {
      id: "id",
      order_id: "order_id",
      note: "note",
      branch_id: "branch_id",
      invite_email: "invite_email",
      calendar_uid: "calendar_uid",
      created_by_id: "created_by_id",
      canceled_by_id: "canceled_by_id",
      canceled_reason: "canceled_reason"
    };
    exports2.Prisma.OrderFileOrderByRelevanceFieldEnum = {
      id: "id",
      order_id: "order_id",
      file_id: "file_id",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.OrderDocumentRequirementOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.CompanyOrderClaimStatusMappingOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_status_id: "claim_status_id"
    };
    exports2.Prisma.OrderRequiredDocumentOrderByRelevanceFieldEnum = {
      id: "id",
      order_id: "order_id",
      requirement_id: "requirement_id",
      name: "name",
      description: "description"
    };
    exports2.Prisma.OrderRequiredDocumentVersionOrderByRelevanceFieldEnum = {
      id: "id",
      required_document_id: "required_document_id",
      file_id: "file_id",
      created_by_id: "created_by_id",
      accepted_by_id: "accepted_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason"
    };
    exports2.Prisma.OrderTimelineOrderByRelevanceFieldEnum = {
      id: "id",
      order_id: "order_id"
    };
    exports2.Prisma.RequestForProposalVendorOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      contact_id: "contact_id",
      request_for_proposal_id: "request_for_proposal_id"
    };
    exports2.Prisma.BidLineOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      make: "make",
      model: "model",
      serial_number: "serial_number",
      bid_id: "bid_id"
    };
    exports2.Prisma.RequestForProposalBidOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request_for_proposal_id: "request_for_proposal_id",
      submitted_by_id: "submitted_by_id"
    };
    exports2.Prisma.RequestForProposalOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      country: "country",
      state: "state",
      city: "city",
      description: "description",
      canceled_reason: "canceled_reason",
      canceled_by_id: "canceled_by_id",
      created_by_id: "created_by_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.EntrypointSnapshotProgressOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entrypoint_id: "entrypoint_id",
      user_id: "user_id",
      session_id: "session_id",
      recording_id: "recording_id"
    };
    exports2.Prisma.ContractReportOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      contract_id: "contract_id",
      file_id: "file_id",
      created_by_id: "created_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason",
      notes: "notes"
    };
    exports2.Prisma.RequestForProposalContractOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request_for_proposal_id: "request_for_proposal_id",
      name: "name",
      vendor_contact_id: "vendor_contact_id",
      vendor_user_id: "vendor_user_id",
      notes: "notes",
      created_by_id: "created_by_id"
    };
    exports2.Prisma.MaterialDamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      insurance_id: "insurance_id",
      vehicle_id: "vehicle_id",
      real_property_id: "real_property_id",
      driver_id: "driver_id"
    };
    exports2.Prisma.LicenseCategoryTypeOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id"
    };
    exports2.Prisma.DriverOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      first_name: "first_name",
      last_name: "last_name",
      cellphone: "cellphone",
      email: "email",
      address: "address",
      country: "country",
      state: "state",
      city: "city",
      city_external_id: "city_external_id",
      license_number: "license_number",
      identification_number: "identification_number",
      license_category_type: "license_category_type",
      license_category_type_external_id: "license_category_type_external_id",
      license_category_other: "license_category_other"
    };
    exports2.Prisma.VehicleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      driver_id: "driver_id",
      registration_state: "registration_state",
      registration_city: "registration_city",
      make: "make",
      model: "model",
      version: "version",
      version_external_id: "version_external_id",
      license_plate: "license_plate",
      chassis: "chassis",
      engine: "engine"
    };
    exports2.Prisma.InsuranceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      other_coverage: "other_coverage",
      insurer: "insurer",
      insurer_external_id: "insurer_external_id",
      policy_number: "policy_number",
      provided_policy_number: "provided_policy_number",
      plan: "plan"
    };
    exports2.Prisma.OcurrenceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      address: "address",
      time: "time",
      witnesses_info: "witnesses_info",
      police_station: "police_station",
      criminal_case_number: "criminal_case_number",
      court: "court",
      clerks_office: "clerks_office",
      judicial_department: "judicial_department",
      damage_description: "damage_description",
      state: "state",
      country: "country",
      city: "city",
      city_external_id: "city_external_id",
      zip_code: "zip_code",
      description: "description"
    };
    exports2.Prisma.ClaimantOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      victim_relationship_other: "victim_relationship_other",
      natural_person_id: "natural_person_id",
      legal_person_id: "legal_person_id",
      claim_id: "claim_id"
    };
    exports2.Prisma.FileRequestPlaceholderOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      tag_id: "tag_id",
      context: "context",
      file_request_id: "file_request_id",
      deleted_by_id: "deleted_by_id",
      deleted_reason: "deleted_reason"
    };
    exports2.Prisma.FileRequestOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      complaint_id: "complaint_id",
      claim_id: "claim_id"
    };
    exports2.Prisma.ClaimSharedDocumentOrderByRelevanceFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      file_id: "file_id",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.MessageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      sender_id: "sender_id",
      policyholder_id: "policyholder_id",
      file_request_id: "file_request_id"
    };
    exports2.Prisma.DamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      material_damage_id: "material_damage_id",
      person_damage_id: "person_damage_id",
      recovery_damage_id: "recovery_damage_id",
      description: "description",
      claim_id: "claim_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.SLAObjectiveOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sla_id: "sla_id",
      group_value: "group_value",
      reference_value: "reference_value"
    };
    exports2.Prisma.CompanySLAOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      group_sla_id: "group_sla_id"
    };
    exports2.Prisma.ComplaintTypeDamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_complaint_type_id: "company_complaint_type_id"
    };
    exports2.Prisma.ClaimTypeDamageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_claim_type_id: "company_claim_type_id"
    };
    exports2.Prisma.CompanyClaimTypeOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id"
    };
    exports2.Prisma.CompanyComplaintTypeOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id"
    };
    exports2.Prisma.GroupSLAOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.RoleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id"
    };
    exports2.Prisma.PermissionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id"
    };
    exports2.Prisma.RealPropertyOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      address: "address",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      country: "country",
      zip_code: "zip_code",
      other_ownership: "other_ownership",
      other_type: "other_type"
    };
    exports2.Prisma.VictimOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      natural_person_id: "natural_person_id",
      legal_person_id: "legal_person_id"
    };
    exports2.Prisma.ClaimHandlerDelegatedOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      destination_id: "destination_id",
      source_id: "source_id",
      delegated_by_id: "delegated_by_id",
      claim_id: "claim_id"
    };
    exports2.Prisma.ComplaintHandlerDelegatedOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      destination_id: "destination_id",
      source_id: "source_id",
      delegated_by_id: "delegated_by_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.ClaimHandlerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      claim_id: "claim_id",
      team_id: "team_id"
    };
    exports2.Prisma.ComplaintHandlerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user_id: "user_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.LoadBalanceRuleConditionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      path: "path",
      value: "value",
      load_balance_rule_id: "load_balance_rule_id"
    };
    exports2.Prisma.LoadBalanceRuleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      target_group_id: "target_group_id",
      team_id: "team_id"
    };
    exports2.Prisma.TargetGroupOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      coordinator_id: "coordinator_id",
      last_assigned_user_id: "last_assigned_user_id"
    };
    exports2.Prisma.EventDetailOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      object_id: "object_id",
      event_id: "event_id"
    };
    exports2.Prisma.IngestEventOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      hash: "hash",
      company_id: "company_id"
    };
    exports2.Prisma.EventOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      type: "type",
      policyholder_id: "policyholder_id",
      triggered_by_id: "triggered_by_id",
      remote_ip: "remote_ip",
      user_agent: "user_agent",
      company_id: "company_id"
    };
    exports2.Prisma.CommentOrderByRelevanceFieldEnum = {
      id: "id",
      commented_by_id: "commented_by_id",
      claim_id: "claim_id",
      content: "content"
    };
    exports2.Prisma.MentionOrderByRelevanceFieldEnum = {
      id: "id",
      comment_id: "comment_id",
      mentioned_to_id: "mentioned_to_id"
    };
    exports2.Prisma.SinisterExpertAppraisalOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sinister_id: "sinister_id",
      external_id: "external_id",
      license_plate: "license_plate",
      owner_first_name: "owner_first_name",
      owner_last_name: "owner_last_name"
    };
    exports2.Prisma.PolicyholderInspectionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      request: "request",
      report: "report",
      license_plate: "license_plate",
      authorize: "authorize",
      observations: "observations",
      chasis: "chasis",
      color: "color",
      km: "km",
      tires: "tires",
      verification_code: "verification_code",
      condition: "condition",
      location: "location",
      motor: "motor",
      status: "status",
      plan: "plan",
      validity: "validity",
      policyholder_id: "policyholder_id",
      external_id: "external_id"
    };
    exports2.Prisma.PolicyholderOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policy_number: "policy_number",
      external_id: "external_id",
      agency: "agency",
      order: "order",
      cuil: "cuil",
      type: "type",
      address: "address",
      birth_date: "birth_date",
      birth_place: "birth_place",
      cellphone: "cellphone",
      city: "city",
      country: "country",
      identification: "identification",
      email: "email",
      first_name: "first_name",
      last_name: "last_name",
      sex: "sex",
      landline_phone: "landline_phone",
      marital_status: "marital_status",
      politician: "politician",
      state: "state",
      license_plate: "license_plate",
      plan: "plan",
      use: "use",
      year: "year",
      validity: "validity",
      zip_code: "zip_code",
      make: "make",
      model: "model"
    };
    exports2.Prisma.PendingComplaintOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      sinister_id: "sinister_id",
      external_id: "external_id",
      created_by_id: "created_by_id"
    };
    exports2.Prisma.ExternalInsurancePolicyOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policy_number: "policy_number",
      risk: "risk",
      section_code: "section_code",
      section_name: "section_name",
      endorsement: "endorsement",
      type: "type"
    };
    exports2.Prisma.ExternalComplaintOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policyholder_id: "policyholder_id",
      external_insurance_policy_id: "external_insurance_policy_id",
      external_id: "external_id",
      external_status: "external_status",
      agency: "agency",
      pending_complaint_id: "pending_complaint_id",
      selected_by_id: "selected_by_id",
      registered_by: "registered_by",
      handler_cellphone: "handler_cellphone",
      handler_name: "handler_name",
      handler_email: "handler_email",
      location: "location",
      sinister_id: "sinister_id"
    };
    exports2.Prisma.IdempotentRequestOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      idempotent_key: "idempotent_key",
      request_path: "request_path",
      request_method: "request_method"
    };
    exports2.Prisma.NewsAnswerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      description: "description",
      publisher_first_name: "publisher_first_name",
      publisher_last_name: "publisher_last_name",
      publisher_email: "publisher_email",
      external_id: "external_id",
      news_request_id: "news_request_id",
      fraud_investigation_case_id: "fraud_investigation_case_id"
    };
    exports2.Prisma.NewsRequestOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      annotation: "annotation",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      external_id: "external_id",
      requested_by_id: "requested_by_id"
    };
    exports2.Prisma.FraudInvestigationCaseAcceptedReportOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      accepted_by_first_name: "accepted_by_first_name",
      accepted_by_last_name: "accepted_by_last_name",
      accepted_by_email: "accepted_by_email",
      lab_name: "lab_name",
      conclusion: "conclusion",
      report_id: "report_id"
    };
    exports2.Prisma.FraudInvestigationCaseClaimResultOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      claim_id: "claim_id",
      result: "result"
    };
    exports2.Prisma.FraudInvestigationCaseOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sinister_id: "sinister_id",
      reason: "reason",
      sinister_number: "sinister_number",
      external_case_id: "external_case_id",
      status: "status",
      internal_status: "internal_status",
      sinister_type: "sinister_type",
      description: "description",
      handler_first_name: "handler_first_name",
      handler_last_name: "handler_last_name",
      handler_email: "handler_email",
      instance: "instance",
      close_motive: "close_motive",
      external_status: "external_status",
      responsible_first_name: "responsible_first_name",
      responsible_last_name: "responsible_last_name",
      responsible_email: "responsible_email",
      ramo: "ramo",
      agency: "agency",
      result: "result",
      created_by_id: "created_by_id",
      kach_case_creator_first_name: "kach_case_creator_first_name",
      kach_case_creator_last_name: "kach_case_creator_last_name",
      kach_case_creator_email: "kach_case_creator_email"
    };
    exports2.Prisma.FraudCaseParticipantSyncRequestOrderByRelevanceFieldEnum = {
      id: "id",
      fraud_investigation_case_id: "fraud_investigation_case_id",
      claim_id: "claim_id",
      reason: "reason",
      last_error_code: "last_error_code"
    };
    exports2.Prisma.CompanyClaimPublicStatusOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name"
    };
    exports2.Prisma.SinisterOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      policyholder_license_plate: "policyholder_license_plate",
      policyholder_policy_number: "policyholder_policy_number",
      policyholder_identification: "policyholder_identification",
      company_id: "company_id",
      external_status: "external_status",
      external_sinister_id: "external_sinister_id"
    };
    exports2.Prisma.OfferAgreementOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      provider_id: "provider_id",
      offer_id: "offer_id",
      created_by_id: "created_by_id",
      cancelled_reason: "cancelled_reason",
      canceled_reason: "canceled_reason",
      rejected_reason: "rejected_reason",
      token: "token",
      document_id: "document_id",
      sender_user_id: "sender_user_id",
      sender_account_email: "sender_account_email",
      provider_document_id: "provider_document_id",
      failure_code: "failure_code",
      failure_message: "failure_message"
    };
    exports2.Prisma.OfferAgreementEventOrderByRelevanceFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      provider_event_id: "provider_event_id",
      type: "type",
      error: "error"
    };
    exports2.Prisma.OfferAgreementSigningLinkOrderByRelevanceFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      provider_transaction_id: "provider_transaction_id",
      provider_recipient_id: "provider_recipient_id",
      recipient_email: "recipient_email",
      url_ciphertext: "url_ciphertext"
    };
    exports2.Prisma.OfferAgreementCeremonyWindowOrderByRelevanceFieldEnum = {
      id: "id",
      agreement_id: "agreement_id",
      remote_ip: "remote_ip"
    };
    exports2.Prisma.OfferEmbeddedSigningSessionOrderByRelevanceFieldEnum = {
      id: "id",
      offer_id: "offer_id",
      secret_hash: "secret_hash",
      owner_email: "owner_email"
    };
    exports2.Prisma.AgreementTemplateOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      name: "name",
      description: "description"
    };
    exports2.Prisma.AgreementTemplateVersionOrderByRelevanceFieldEnum = {
      id: "id",
      template_id: "template_id",
      layout_variant: "layout_variant",
      content_hash: "content_hash"
    };
    exports2.Prisma.AgreementDocumentOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_id: "claim_id",
      offer_id: "offer_id",
      template_version_id: "template_version_id",
      file_id: "file_id",
      invalid_reason: "invalid_reason",
      content_hash: "content_hash",
      pdf_sha256: "pdf_sha256",
      rendered_by_id: "rendered_by_id",
      plan_id: "plan_id",
      status_code: "status_code"
    };
    exports2.Prisma.CompanyAgreementSettingsOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      offer_message_template_id: "offer_message_template_id"
    };
    exports2.Prisma.AgreementRuleOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      name: "name",
      description: "description",
      template_id: "template_id"
    };
    exports2.Prisma.AgreementSignatureRuleOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      name: "name",
      description: "description"
    };
    exports2.Prisma.OfferAgreementPlanOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_id: "claim_id",
      offer_id: "offer_id",
      rule_id: "rule_id",
      template_version_id: "template_version_id",
      reason: "reason",
      stage: "stage",
      signature_rule_id: "signature_rule_id",
      planned_by_id: "planned_by_id"
    };
    exports2.Prisma.VariableValueOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      guid: "guid",
      value: "value"
    };
    exports2.Prisma.IntegrationTemplateFieldMappingOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid",
      provider_field_id: "provider_field_id",
      local_field_reference: "local_field_reference",
      integration_template_id: "integration_template_id"
    };
    exports2.Prisma.IntegrationTemplateOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      provider_template_name: "provider_template_name",
      provider_template_id: "provider_template_id",
      message_template_id: "message_template_id",
      created_by_id: "created_by_id",
      company_id: "company_id"
    };
    exports2.Prisma.OfferOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      token: "token",
      rejected_reason: "rejected_reason",
      canceled_reason: "canceled_reason",
      name: "name",
      offer_template_message: "offer_template_message",
      message_template_id: "message_template_id",
      company_id: "company_id",
      offered_by_id: "offered_by_id",
      accepted_by_id: "accepted_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_on_behalf_by_id: "rejected_on_behalf_by_id",
      canceled_by_id: "canceled_by_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      probability_model_version: "probability_model_version",
      public_canceled_reason: "public_canceled_reason",
      offered_reason: "offered_reason",
      public_offered_reason: "public_offered_reason",
      offer_message_template_version_id: "offer_message_template_version_id",
      manual_agreement_file_id: "manual_agreement_file_id"
    };
    exports2.Prisma.InspectionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      external_id: "external_id",
      template_name: "template_name",
      type: "type",
      status: "status",
      verdict: "verdict"
    };
    exports2.Prisma.ContactOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      email: "email",
      cellphone: "cellphone",
      country: "country",
      zip_code: "zip_code",
      city: "city",
      state: "state",
      address: "address",
      external_id: "external_id",
      company_id: "company_id",
      created_by_id: "created_by_id",
      user_id: "user_id"
    };
    exports2.Prisma.UpdateNoteOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      published_by_id: "published_by_id"
    };
    exports2.Prisma.AppraisalReportOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      report_id: "report_id",
      rejected_reason: "rejected_reason",
      rejected_by_id: "rejected_by_id",
      accepted_by_id: "accepted_by_id",
      created_by_id: "created_by_id",
      claim_id: "claim_id",
      complaint_id: "complaint_id"
    };
    exports2.Prisma.OwnershipTransferOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      source_user_id: "source_user_id",
      destination_user_id: "destination_user_id",
      transferred_by_id: "transferred_by_id",
      token: "token"
    };
    exports2.Prisma.ResponsibilityTransferOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      source_handler_id: "source_handler_id",
      destination_handler_id: "destination_handler_id",
      source_user_id: "source_user_id",
      destination_user_id: "destination_user_id",
      transferred_by_id: "transferred_by_id",
      token: "token"
    };
    exports2.Prisma.TransitionTargetOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id"
    };
    exports2.Prisma.CompanyClaimStatusOrderRuleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyClaimTriggerMappingOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      message_template_id: "message_template_id",
      status_id: "status_id",
      reference_id: "reference_id",
      stage_id: "stage_id"
    };
    exports2.Prisma.SLAInstanceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      sla_id: "sla_id",
      company_id: "company_id",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.ClaimEstimateChangeOrderByRelevanceFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      reason: "reason",
      changed_by_id: "changed_by_id",
      ingest_event_id: "ingest_event_id"
    };
    exports2.Prisma.ClaimOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      external_claim_id: "external_claim_id",
      external_claim_request_id: "external_claim_request_id",
      external_policyholder_number: "external_policyholder_number",
      ref_id: "ref_id",
      claim_type_id: "claim_type_id",
      company_id: "company_id",
      target_group_id: "target_group_id",
      team_id: "team_id",
      titular_user_id: "titular_user_id",
      titular_team_id: "titular_team_id",
      coordinator_id: "coordinator_id",
      selected_external_complaint_id: "selected_external_complaint_id",
      selected_pending_complaint_id: "selected_pending_complaint_id",
      entrypoint_id: "entrypoint_id",
      entrypoint_snapshot_progress_id: "entrypoint_snapshot_progress_id",
      policyholder_license_plate: "policyholder_license_plate",
      policyholder_policy_number: "policyholder_policy_number",
      victim_id: "victim_id",
      sinister_id: "sinister_id",
      field_adjuster_id: "field_adjuster_id",
      field_adjuster_contact_id: "field_adjuster_contact_id",
      ramo_id: "ramo_id",
      owner_id: "owner_id",
      created_by_id: "created_by_id",
      latest_estimates_update_reason: "latest_estimates_update_reason",
      desired_support_location_state: "desired_support_location_state",
      desired_support_location_state_municipality: "desired_support_location_state_municipality",
      ocurrence_id: "ocurrence_id",
      latest_communication_status_id: "latest_communication_status_id",
      claim_status_id: "claim_status_id",
      reference_id: "reference_id",
      stage_id: "stage_id",
      customer_organization_id: "customer_organization_id"
    };
    exports2.Prisma.ClaimDerivationOrderByRelevanceFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      derived_by_user_id: "derived_by_user_id",
      derived_to_user_id: "derived_to_user_id",
      reason: "reason",
      paused_status_objective_instance_id: "paused_status_objective_instance_id",
      canceled_reason: "canceled_reason",
      canceled_by_user_id: "canceled_by_user_id",
      previous_company_claim_status_id: "previous_company_claim_status_id"
    };
    exports2.Prisma.ClaimAlertOrderByRelevanceFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      fraud_investigation_case_id: "fraud_investigation_case_id"
    };
    exports2.Prisma.CompanyClaimStageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description"
    };
    exports2.Prisma.ComplaintTransitionTargetOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id"
    };
    exports2.Prisma.CompanyComplaintStatusOrderRuleOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      stage_id: "stage_id",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyComplaintStageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description"
    };
    exports2.Prisma.TotalInstanceSLAOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      sla_id: "sla_id",
      start_pointer_id: "start_pointer_id",
      end_pointer_id: "end_pointer_id",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.ObjectiveInstanceSLAOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      objective_id: "objective_id",
      parent_objective_instance_id: "parent_objective_instance_id",
      company_id: "company_id",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.StatusTransitionDurationOrderByRelevanceFieldEnum = {
      id: "id",
      calendar_id: "calendar_id",
      company_id: "company_id",
      reference_value: "reference_value"
    };
    exports2.Prisma.ClaimStatusTransitionDurationOrderByRelevanceFieldEnum = {
      id: "id",
      status_transition_duration_id: "status_transition_duration_id",
      claim_status_transition_id: "claim_status_transition_id"
    };
    exports2.Prisma.ClaimStatusTransitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      claim_id: "claim_id",
      from_claim_status_id: "from_claim_status_id",
      to_claim_status_id: "to_claim_status_id",
      claim_status_sequence: "claim_status_sequence",
      from_reference_id: "from_reference_id",
      to_reference_id: "to_reference_id",
      reference_sequence: "reference_sequence",
      from_stage_id: "from_stage_id",
      to_stage_id: "to_stage_id",
      stage_sequence: "stage_sequence",
      action_output_id: "action_output_id"
    };
    exports2.Prisma.ComplaintStatusTransitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      complaint_id: "complaint_id",
      from_complaint_status_id: "from_complaint_status_id",
      to_complaint_status_id: "to_complaint_status_id",
      from_reference_id: "from_reference_id",
      to_reference_id: "to_reference_id",
      from_stage_id: "from_stage_id",
      to_stage_id: "to_stage_id"
    };
    exports2.Prisma.CompanyClaimReferenceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description"
    };
    exports2.Prisma.CompanyComplaintReferenceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      description: "description"
    };
    exports2.Prisma.CompanyClaimStatusOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      sub_status_name: "sub_status_name",
      company_claim_public_status_id: "company_claim_public_status_id",
      external_id: "external_id"
    };
    exports2.Prisma.ClaimResultOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id"
    };
    exports2.Prisma.ReviewOrderByRelevanceFieldEnum = {
      id: "id",
      comment: "comment",
      company_id: "company_id",
      claim_id: "claim_id",
      user_id: "user_id",
      token: "token",
      requested_status_id: "requested_status_id"
    };
    exports2.Prisma.TeamDelegationNoticeDismissalOrderByRelevanceFieldEnum = {
      id: "id",
      user_id: "user_id",
      job_id: "job_id",
      kind: "kind"
    };
    exports2.Prisma.PerformanceSnapshotOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      scope_key: "scope_key",
      block: "block"
    };
    exports2.Prisma.NegotiationTypeAverageSnapshotOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      claim_type_id: "claim_type_id"
    };
    exports2.Prisma.ReleaseNoteOrderByRelevanceFieldEnum = {
      id: "id",
      slug: "slug",
      title: "title",
      subtitle: "subtitle",
      audience: "audience",
      kind: "kind",
      status: "status",
      required_company_flag: "required_company_flag"
    };
    exports2.Prisma.ReleaseNoteItemOrderByRelevanceFieldEnum = {
      id: "id",
      release_note_id: "release_note_id",
      kind: "kind",
      title: "title",
      description: "description",
      summary: "summary"
    };
    exports2.Prisma.ReleaseNoteSectionOrderByRelevanceFieldEnum = {
      id: "id",
      item_id: "item_id",
      kind: "kind",
      title: "title"
    };
    exports2.Prisma.ReleaseNoteEventOrderByRelevanceFieldEnum = {
      id: "id",
      type: "type",
      visit_id: "visit_id",
      user_id: "user_id",
      company_id: "company_id",
      release_note_id: "release_note_id",
      item_id: "item_id",
      section_id: "section_id"
    };
    exports2.Prisma.ReleaseNoteRecipientOrderByRelevanceFieldEnum = {
      id: "id",
      release_note_id: "release_note_id",
      company_id: "company_id",
      user_id: "user_id",
      role_id: "role_id"
    };
    exports2.Prisma.ValidationPatternOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      pattern: "pattern",
      company_id: "company_id"
    };
    exports2.Prisma.EncryptedMessageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      iv: "iv",
      content: "content"
    };
    exports2.Prisma.LoginCredentialsOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      user: "user",
      password_id: "password_id",
      extra_credential_value: "extra_credential_value",
      locked_by_job_id: "locked_by_job_id"
    };
    exports2.Prisma.IntegrationConnectionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      integration_id: "integration_id",
      access_token: "access_token",
      connected_account_email: "connected_account_email",
      refresh_token: "refresh_token",
      company_id: "company_id",
      user_id: "user_id",
      webhook_id: "webhook_id",
      webhook_secret: "webhook_secret",
      scopes: "scopes",
      invalidated_reason: "invalidated_reason",
      external_user_id: "external_user_id",
      external_company_id: "external_company_id",
      client_id: "client_id",
      client_secret: "client_secret"
    };
    exports2.Prisma.OAuthAuthorizationAttemptOrderByRelevanceFieldEnum = {
      id: "id",
      state_hash: "state_hash",
      code_verifier: "code_verifier",
      redirect_uri: "redirect_uri",
      user_id: "user_id",
      company_id: "company_id"
    };
    exports2.Prisma.IntegrationOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      oauth_url: "oauth_url",
      description: "description",
      name: "name",
      file_id: "file_id"
    };
    exports2.Prisma.AutoinspectorTemplateOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      use_case: "use_case",
      external_id: "external_id",
      external_name: "external_name"
    };
    exports2.Prisma.AutoinspectorInspectionOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      template_id: "template_id",
      use_case: "use_case",
      external_id: "external_id",
      external_template_id: "external_template_id",
      result: "result",
      correlation_type: "correlation_type",
      correlation_id: "correlation_id",
      magic_link: "magic_link",
      access_code: "access_code",
      report_file_id: "report_file_id",
      report_request_id: "report_request_id"
    };
    exports2.Prisma.AutoinspectorInspectionAssetOrderByRelevanceFieldEnum = {
      id: "id",
      inspection_id: "inspection_id",
      file_id: "file_id",
      external_file_id: "external_file_id",
      asset_identifier: "asset_identifier",
      verdict: "verdict"
    };
    exports2.Prisma.AutoinspectorWebhookEventOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      external_inspection_id: "external_inspection_id",
      event: "event",
      payload_hash: "payload_hash",
      error: "error"
    };
    exports2.Prisma.ClaimFileInspectionStateOrderByRelevanceFieldEnum = {
      id: "id",
      file_id: "file_id",
      claim_id: "claim_id",
      company_id: "company_id",
      job_id: "job_id"
    };
    exports2.Prisma.ValidationDefinitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entrypoint_id: "entrypoint_id",
      entity_id: "entity_id",
      tag_id: "tag_id"
    };
    exports2.Prisma.ExportedReportOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      generated_by_id: "generated_by_id",
      file_id: "file_id"
    };
    exports2.Prisma.JobOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      schedule: "schedule",
      error_trace: "error_trace",
      failed_reason: "failed_reason",
      cancelled_reason: "cancelled_reason",
      created_by_id: "created_by_id",
      company_id: "company_id"
    };
    exports2.Prisma.EntityDefinitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      entrypoint_id: "entrypoint_id",
      tag_id: "tag_id"
    };
    exports2.Prisma.EntrypointOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      endpoint: "endpoint",
      name: "name",
      avatar_id: "avatar_id"
    };
    exports2.Prisma.EntrypointSpecialPermissionOrderByRelevanceFieldEnum = {
      id: "id",
      entrypoint_id: "entrypoint_id",
      user_id: "user_id"
    };
    exports2.Prisma.UserOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      username: "username",
      cellphone: "cellphone",
      first_name: "first_name",
      profile_photo: "profile_photo",
      nationality: "nationality",
      last_name: "last_name",
      country: "country",
      email: "email",
      role_id: "role_id",
      password: "password",
      identification: "identification",
      address: "address",
      address_street: "address_street",
      address_number: "address_number",
      address_apartment: "address_apartment",
      state: "state",
      city: "city",
      zip_code: "zip_code",
      company_id: "company_id",
      ein: "ein",
      dni: "dni",
      avatar_id: "avatar_id",
      customer_organization_id: "customer_organization_id"
    };
    exports2.Prisma.IdentityProviderOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      provider_id: "provider_id",
      user_id: "user_id"
    };
    exports2.Prisma.EstimatesOperandDefinitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      natural_key: "natural_key",
      estimates_definition_id: "estimates_definition_id"
    };
    exports2.Prisma.CompanyEstimatesDefinitionOrderByRelevanceFieldEnum = {
      name: "name",
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyFlagsOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyWorkingExceptionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyWorkingDayOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      calendar_id: "calendar_id"
    };
    exports2.Prisma.CompanyCalendarOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyCurrencyOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.FieldMappingConfigOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id"
    };
    exports2.Prisma.MemberOrderByRelevanceFieldEnum = {
      id: "id",
      user_id: "user_id",
      company_id: "company_id"
    };
    exports2.Prisma.CustomerOrganizationOrderByRelevanceFieldEnum = {
      id: "id",
      name: "name",
      ein: "ein",
      phone: "phone",
      email: "email",
      address: "address",
      logo_id: "logo_id"
    };
    exports2.Prisma.CustomerOrganizationInvitationOrderByRelevanceFieldEnum = {
      id: "id",
      customer_organization_id: "customer_organization_id",
      company_id: "company_id",
      email: "email",
      first_name: "first_name",
      last_name: "last_name",
      token_hash: "token_hash",
      user_id: "user_id"
    };
    exports2.Prisma.CompanyOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      ein: "ein",
      domain: "domain",
      company_owner_id: "company_owner_id",
      logo_id: "logo_id",
      tenant_slug: "tenant_slug",
      prod_api_key: "prod_api_key",
      sandbox_api_key: "sandbox_api_key",
      country: "country",
      alias: "alias"
    };
    exports2.Prisma.VerticalOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      slug: "slug"
    };
    exports2.Prisma.GoodOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      vertical_id: "vertical_id",
      name: "name"
    };
    exports2.Prisma.ServiceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      vertical_id: "vertical_id",
      name: "name"
    };
    exports2.Prisma.CompanyVerticalOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      vertical_id: "vertical_id"
    };
    exports2.Prisma.ProvinceOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      georef_id: "georef_id"
    };
    exports2.Prisma.DepartmentOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      georef_id: "georef_id",
      province_id: "province_id"
    };
    exports2.Prisma.LocalityOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      georef_id: "georef_id",
      name: "name",
      province_id: "province_id",
      department_id: "department_id"
    };
    exports2.Prisma.ProviderInvitationOrderByRelevanceFieldEnum = {
      id: "id",
      insurer_company_id: "insurer_company_id",
      invited_by_user_id: "invited_by_user_id",
      email: "email",
      invitation_name: "invitation_name",
      token: "token",
      engagement_id: "engagement_id"
    };
    exports2.Prisma.ProviderOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      legal_name: "legal_name",
      email: "email",
      ein: "ein",
      phone: "phone",
      address: "address",
      locality_id: "locality_id",
      contact_email: "contact_email",
      description: "description"
    };
    exports2.Prisma.EngagementOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      insurer_company_id: "insurer_company_id",
      provider_id: "provider_id",
      notes: "notes",
      external_id: "external_id"
    };
    exports2.Prisma.ProviderCapabilityOrderByRelevanceFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      vertical_id: "vertical_id",
      service_id: "service_id"
    };
    exports2.Prisma.ProviderCapabilityGoodOrderByRelevanceFieldEnum = {
      id: "id",
      capability_id: "capability_id",
      good_id: "good_id"
    };
    exports2.Prisma.ProviderCoverageOrderByRelevanceFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      province_id: "province_id",
      department_id: "department_id",
      locality_id: "locality_id"
    };
    exports2.Prisma.ProviderBranchOrderByRelevanceFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      name: "name",
      address: "address",
      locality_id: "locality_id"
    };
    exports2.Prisma.ProviderDocumentTypeOrderByRelevanceFieldEnum = {
      id: "id",
      name: "name",
      description: "description"
    };
    exports2.Prisma.ProviderDocumentOrderByRelevanceFieldEnum = {
      id: "id",
      provider_id: "provider_id",
      document_type_id: "document_type_id",
      file_id: "file_id"
    };
    exports2.Prisma.InsurerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id"
    };
    exports2.Prisma.MotoOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      make: "make",
      model: "model",
      version: "version",
      external_id: "external_id"
    };
    exports2.Prisma.CarOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      make: "make",
      model: "model",
      version: "version",
      external_id: "external_id"
    };
    exports2.Prisma.HealthInsuranceFundOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name"
    };
    exports2.Prisma.WorkerCompensationInsurerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name"
    };
    exports2.Prisma.CompanyRamoOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      code: "code",
      description: "description",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyAgencyOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      code: "code",
      description: "description",
      company_id: "company_id"
    };
    exports2.Prisma.ProductOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      sku: "sku",
      name: "name",
      brand: "brand",
      description: "description",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.ProductImportOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      created_by_id: "created_by_id",
      file_id: "file_id",
      failed_reason: "failed_reason",
      error_trace: "error_trace"
    };
    exports2.Prisma.CompanyCustomerOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      code: "code",
      description: "description",
      deleted_by_id: "deleted_by_id"
    };
    exports2.Prisma.IntakeSubmissionOrderByRelevanceFieldEnum = {
      id: "id",
      claim_id: "claim_id",
      complaint_id: "complaint_id",
      company_customer_id: "company_customer_id",
      locality_id: "locality_id",
      good_id: "good_id",
      service_id: "service_id",
      vertical_id: "vertical_id"
    };
    exports2.Prisma.ProviderGroupOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description"
    };
    exports2.Prisma.ProviderGroupMemberOrderByRelevanceFieldEnum = {
      id: "id",
      group_id: "group_id",
      provider_id: "provider_id"
    };
    exports2.Prisma.InvitationOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      role_id: "role_id",
      user_id: "user_id",
      email: "email",
      token: "token",
      guest_user_id: "guest_user_id"
    };
    exports2.Prisma.SeederOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      key: "key"
    };
    exports2.Prisma.TopicSubscriptionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      topic_id: "topic_id",
      user_id: "user_id"
    };
    exports2.Prisma.TopicOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      event: "event",
      name: "name",
      description: "description",
      scope: "scope"
    };
    exports2.Prisma.AlertOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      description: "description",
      display_target: "display_target"
    };
    exports2.Prisma.AlertSubscriptionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      alert_id: "alert_id",
      user_id: "user_id",
      company_id: "company_id"
    };
    exports2.Prisma.NotificationReceiverOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      notification_id: "notification_id",
      user_id: "user_id"
    };
    exports2.Prisma.NotificationOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      message: "message",
      actor_id: "actor_id",
      href: "href",
      claim_id: "claim_id"
    };
    exports2.Prisma.StylesConfigOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      logo_id: "logo_id"
    };
    exports2.Prisma.CompanyLinkOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      logo_id: "logo_id",
      link: "link",
      name: "name"
    };
    exports2.Prisma.CompanySinisterConfigCountriesOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      config_id: "config_id",
      code: "code"
    };
    exports2.Prisma.CompanySinisterConfigOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id"
    };
    exports2.Prisma.WebhookLogOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      webhook_id: "webhook_id",
      event: "event",
      endpoint: "endpoint",
      signature: "signature"
    };
    exports2.Prisma.WebhookEventSubscriptionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      webhook_id: "webhook_id",
      event: "event"
    };
    exports2.Prisma.WebhookOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      endpoint: "endpoint",
      name: "name",
      created_by_id: "created_by_id",
      signature: "signature",
      company_id: "company_id"
    };
    exports2.Prisma.CompanyComplaintPublicStatusOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name"
    };
    exports2.Prisma.CompanyComplaintTriggerMappingOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      status_id: "status_id",
      reference_id: "reference_id",
      stage_id: "stage_id",
      message_template_id: "message_template_id"
    };
    exports2.Prisma.CompanyComplaintStatusOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      company_id: "company_id",
      name: "name",
      description: "description",
      sub_status_name: "sub_status_name",
      company_complaint_public_status_id: "company_complaint_public_status_id"
    };
    exports2.Prisma.EntrypointSessionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      token: "token",
      entrypoint_id: "entrypoint_id",
      company_id: "company_id"
    };
    exports2.Prisma.ComplaintSinisterCauseOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      external_id: "external_id"
    };
    exports2.Prisma.EstimatesOperandValueOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      estimates_operand_definition_id: "estimates_operand_definition_id",
      name: "name",
      natural_key: "natural_key"
    };
    exports2.Prisma.AffectedCoverageOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      external_id: "external_id"
    };
    exports2.Prisma.ComplaintOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      field_adjuster_contact_id: "field_adjuster_contact_id",
      ref_id: "ref_id",
      field_adjuster_id: "field_adjuster_id",
      sinister_cause_id: "sinister_cause_id",
      proxy_external_complaint_id: "proxy_external_complaint_id",
      authorized_by_id: "authorized_by_id",
      rejected_by_id: "rejected_by_id",
      rejected_reason: "rejected_reason",
      approved_by_id: "approved_by_id",
      company_id: "company_id",
      portal_token: "portal_token",
      policyholder_id: "policyholder_id",
      sinister_id: "sinister_id",
      status_id: "status_id",
      reference_id: "reference_id",
      stage_id: "stage_id",
      ramo_id: "ramo_id",
      entrypoint_id: "entrypoint_id",
      occurrence_id: "occurrence_id",
      signature_id: "signature_id"
    };
    exports2.Prisma.VariableDefinitionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      guid: "guid"
    };
    exports2.Prisma.VariableValidationOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid"
    };
    exports2.Prisma.VariableConditionOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      guid: "guid",
      variable: "variable",
      value: "value",
      target: "target"
    };
    exports2.Prisma.MessageTemplateOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      message: "message",
      subject: "subject",
      company_id: "company_id"
    };
    exports2.Prisma.TeamOrderByRelevanceFieldEnum = {
      id: "id",
      deprecated_id: "deprecated_id",
      name: "name",
      company_id: "company_id",
      coordinator_id: "coordinator_id",
      last_assigned_user_id: "last_assigned_user_id"
    };
    exports2.Prisma.ServiceAccountOrderByRelevanceFieldEnum = {
      id: "id",
      name: "name",
      description: "description",
      company_id: "company_id",
      token: "token"
    };
    exports2.Prisma.MessageHashOrderByRelevanceFieldEnum = {
      id: "id",
      hash: "hash"
    };
    exports2.Prisma.VerificationOrderByRelevanceFieldEnum = {
      id: "id",
      value: "value",
      email: "email",
      user_id: "user_id"
    };
    exports2.Prisma.InferredFileDataOrderByRelevanceFieldEnum = {
      id: "id",
      file_id: "file_id",
      summary: "summary"
    };
    exports2.Prisma.InferredFileDataManualUpdateOrderByRelevanceFieldEnum = {
      id: "id",
      inferred_file_data_id: "inferred_file_data_id",
      updated_by_id: "updated_by_id",
      from_tag_id: "from_tag_id",
      to_tag_id: "to_tag_id"
    };
    exports2.Prisma.InferredKeywordsOrderByRelevanceFieldEnum = {
      id: "id",
      inferred_file_data_id: "inferred_file_data_id",
      key: "key",
      value: "value"
    };
    exports2.Prisma.InferredKeywordsManualUpdateOrderByRelevanceFieldEnum = {
      id: "id",
      inferred_keywords_id: "inferred_keywords_id",
      updated_by_id: "updated_by_id",
      from_key: "from_key",
      to_key: "to_key",
      from_value: "from_value",
      to_value: "to_value"
    };
    exports2.Prisma.WorkflowOrderByRelevanceFieldEnum = {
      id: "id",
      company_id: "company_id",
      description: "description",
      workflow_external_id: "workflow_external_id",
      workflow_external_name: "workflow_external_name",
      workflow_version_external_id: "workflow_version_external_id",
      workflow_version_external_name: "workflow_version_external_name"
    };
    exports2.Prisma.ErrorNotificationOrderByRelevanceFieldEnum = {
      id: "id",
      error: "error",
      url: "url",
      queue_name: "queue_name",
      queue_message: "queue_message"
    };
    exports2.ColumnSort = exports2.$Enums.ColumnSort = {
      asc: "asc",
      desc: "desc"
    };
    exports2.VirtualViewResources = exports2.$Enums.VirtualViewResources = {
      claim: "claim",
      complaint: "complaint",
      sinister: "sinister"
    };
    exports2.TagTypes = exports2.$Enums.TagTypes = {
      native: "native",
      custom: "custom"
    };
    exports2.TagAliases = exports2.$Enums.TagAliases = {
      vehicle_authorization_document: "vehicle_authorization_document",
      vehicle_registration_card: "vehicle_registration_card",
      driver_license: "driver_license",
      identity_card: "identity_card",
      vehicle_roof: "vehicle_roof",
      vehicle_back: "vehicle_back",
      vehicle_front: "vehicle_front",
      vehicle_side_right: "vehicle_side_right",
      vehicle_side_left: "vehicle_side_left",
      vehicle_damage_photo_bonnet: "vehicle_damage_photo_bonnet",
      vehicle_damage_photo_boot: "vehicle_damage_photo_boot",
      vehicle_damage_photo_door_left: "vehicle_damage_photo_door_left",
      vehicle_damage_photo_door_right: "vehicle_damage_photo_door_right",
      vehicle_damage_photo_roof: "vehicle_damage_photo_roof",
      vehicle_qualification: "vehicle_qualification",
      incident_damage_photo: "incident_damage_photo",
      policy_holder_vehicle_identity_card_front: "policy_holder_vehicle_identity_card_front",
      policy_holder_vehicle_identity_card_back: "policy_holder_vehicle_identity_card_back",
      policy_holder_identity_card: "policy_holder_identity_card",
      policy_holder_identity_card_front: "policy_holder_identity_card_front",
      policy_holder_identity_card_back: "policy_holder_identity_card_back",
      policy_holder_driver_license_front: "policy_holder_driver_license_front",
      policy_holder_driver_license_back: "policy_holder_driver_license_back",
      rfp_contract_file: "rfp_contract_file",
      rfp_bid_file: "rfp_bid_file",
      contract_updates_file: "contract_updates_file",
      appraisal_updates_file: "appraisal_updates_file",
      contract_report: "contract_report",
      appraisal_report: "appraisal_report",
      contract_invoice: "contract_invoice",
      appraisal_invoice: "appraisal_invoice",
      offer_agreement: "offer_agreement",
      expert_appraisal_photo: "expert_appraisal_photo",
      inspection_photo: "inspection_photo",
      complaint: "complaint",
      orion_report: "orion_report",
      sinister_digitalized_document: "sinister_digitalized_document",
      sinister_video: "sinister_video",
      sinister_photo: "sinister_photo",
      policy_coverage_certificate: "policy_coverage_certificate",
      policy_deductible_letter: "policy_deductible_letter",
      accounting_certificate: "accounting_certificate",
      medical_discharge: "medical_discharge",
      medical_report: "medical_report",
      expense_receipt: "expense_receipt",
      subrogation_certificate: "subrogation_certificate",
      deed: "deed",
      rental_agreement: "rental_agreement",
      vehicle: "vehicle",
      real_property: "real_property",
      damage_budget: "damage_budget",
      repair_bill: "repair_bill",
      policy_insurance: "policy_insurance",
      police_report: "police_report",
      victim_national_identity_card_front: "victim_national_identity_card_front",
      victim_national_identity_card_back: "victim_national_identity_card_back",
      material_victim_national_identity_card_front: "material_victim_national_identity_card_front",
      material_victim_national_identity_card_back: "material_victim_national_identity_card_back",
      vehicle_title: "vehicle_title",
      vehicle_id_card_front: "vehicle_id_card_front",
      vehicle_id_card_back: "vehicle_id_card_back",
      proof_of_ownership_document: "proof_of_ownership_document",
      insurance_complaint: "insurance_complaint",
      affidavit_of_no_insurance: "affidavit_of_no_insurance",
      certificate_medical_treatment: "certificate_medical_treatment",
      birth_certificate: "birth_certificate",
      death_certificate: "death_certificate",
      occupancy_report: "occupancy_report",
      income_verification: "income_verification",
      father_national_id_document_front: "father_national_id_document_front",
      father_national_id_document_back: "father_national_id_document_back",
      mother_national_id_document_front: "mother_national_id_document_front",
      mother_national_id_document_back: "mother_national_id_document_back",
      order_invoice: "order_invoice",
      order_file: "order_file",
      order_report: "order_report",
      vehicle_side_left_damage: "vehicle_side_left_damage",
      vehicle_side_right_damage: "vehicle_side_right_damage",
      vehicle_back_damage: "vehicle_back_damage",
      vehicle_front_damage: "vehicle_front_damage",
      vehicle_roof_damage: "vehicle_roof_damage",
      vehicle_registration_card_front: "vehicle_registration_card_front",
      vehicle_registration_card_back: "vehicle_registration_card_back",
      vehicle_authorization_document_front: "vehicle_authorization_document_front",
      vehicle_authorization_document_back: "vehicle_authorization_document_back",
      signature: "signature",
      claim_note: "claim_note",
      untagged: "untagged",
      accident_diagram: "accident_diagram",
      additional_medical_tests: "additional_medical_tests",
      declaration_of_heirs: "declaration_of_heirs",
      vehicle_license_plate_photos: "vehicle_license_plate_photos",
      cbu_certificate: "cbu_certificate",
      fee_invoice: "fee_invoice",
      power_of_attorney: "power_of_attorney",
      service_bill: "service_bill",
      fraud_news_artifact: "fraud_news_artifact",
      expense_detail_sheet: "expense_detail_sheet",
      work_incapacity_payment_receipt: "work_incapacity_payment_receipt",
      permanent_work_incapacity_documentation: "permanent_work_incapacity_documentation",
      medical_record: "medical_record",
      insurer_lawyer_report: "insurer_lawyer_report",
      no_total_loss_letter: "no_total_loss_letter",
      supplementary_information: "supplementary_information",
      vehicle_transfer_form: "vehicle_transfer_form",
      committee_escalation_sheet: "committee_escalation_sheet",
      purchase_agreement: "purchase_agreement",
      legal_entity_representation_document: "legal_entity_representation_document",
      account_holder_national_identity_card: "account_holder_national_identity_card",
      legal_entity_supporting_document: "legal_entity_supporting_document"
    };
    exports2.ValidationsType = exports2.$Enums.ValidationsType = {
      health_insurance_fund: "health_insurance_fund",
      worker_compensation_insurer: "worker_compensation_insurer",
      birth_date: "birth_date",
      national_identity_card_fields: "national_identity_card_fields",
      medical_certificate_sinister_date: "medical_certificate_sinister_date",
      doctor_stamp_visible: "doctor_stamp_visible",
      doctor_license_number_visible: "doctor_license_number_visible",
      diagnosis_visible: "diagnosis_visible",
      license_plate: "license_plate",
      full_name: "full_name",
      address: "address",
      document_number: "document_number",
      make: "make",
      model: "model",
      policy_period: "policy_period",
      death_certificate_fields: "death_certificate_fields"
    };
    exports2.InferrableEntities = exports2.$Enums.InferrableEntities = {
      national_identity_card: "national_identity_card",
      vehicle_id_card_front: "vehicle_id_card_front",
      vehicle_id_card_back: "vehicle_id_card_back",
      coverage_certificate: "coverage_certificate",
      medical_certificate: "medical_certificate",
      vehicle: "vehicle",
      death_certificate: "death_certificate"
    };
    exports2.FileTypes = exports2.$Enums.FileTypes = {
      audio: "audio",
      image: "image",
      video: "video",
      pdf: "pdf",
      document: "document",
      other: "other"
    };
    exports2.EventDetailObjects = exports2.$Enums.EventDetailObjects = {
      complaint: "complaint",
      company: "company",
      user: "user",
      claim: "claim",
      file_request: "file_request",
      file: "file",
      message: "message",
      sinister: "sinister",
      news_request: "news_request",
      news_answer: "news_answer",
      fraud_investigation_case_report_accepted: "fraud_investigation_case_report_accepted",
      fraud_investigation_case: "fraud_investigation_case"
    };
    exports2.LegalPersonTypes = exports2.$Enums.LegalPersonTypes = {
      hospital: "hospital",
      worker_compensation_insurer: "worker_compensation_insurer",
      health_insurance_fund: "health_insurance_fund",
      insurer: "insurer"
    };
    exports2.MaritalStatus = exports2.$Enums.MaritalStatus = {
      single: "single",
      married: "married",
      widowed: "widowed",
      divorced: "divorced",
      common_law: "common_law",
      separated: "separated"
    };
    exports2.SexTypes = exports2.$Enums.SexTypes = {
      male: "male",
      female: "female",
      other: "other"
    };
    exports2.IdentificationTypes = exports2.$Enums.IdentificationTypes = {
      enrollment_book: "enrollment_book",
      civil_registry_card: "civil_registry_card",
      national_id_document: "national_id_document",
      passport: "passport",
      cuil: "cuil",
      cuit: "cuit"
    };
    exports2.PersonParentTypes = exports2.$Enums.PersonParentTypes = {
      father: "father",
      mother: "mother"
    };
    exports2.InHouseLawyerStatus = exports2.$Enums.InHouseLawyerStatus = {
      pending: "pending",
      registered: "registered"
    };
    exports2.PersonDamageDetailTypes = exports2.$Enums.PersonDamageDetailTypes = {
      abrasions: "abrasions",
      whiplash: "whiplash",
      severe_had_injury: "severe_had_injury",
      fractures: "fractures"
    };
    exports2.PersonDamageDetailSeverityTypes = exports2.$Enums.PersonDamageDetailSeverityTypes = {
      major: "major",
      minor: "minor",
      moderate: "moderate"
    };
    exports2.PersonDamageTypes = exports2.$Enums.PersonDamageTypes = {
      death: "death",
      injury: "injury"
    };
    exports2.VictimRoleTypes = exports2.$Enums.VictimRoleTypes = {
      pedestrian: "pedestrian",
      driver: "driver",
      rider: "rider",
      policyholder_rider: "policyholder_rider"
    };
    exports2.PolicyHolderRelationshipTypes = exports2.$Enums.PolicyHolderRelationshipTypes = {
      friend: "friend",
      brother: "brother",
      couple: "couple",
      parent: "parent",
      son: "son",
      uncle: "uncle",
      cousin: "cousin",
      niece: "niece",
      rider: "rider",
      other: "other",
      spouse: "spouse",
      concubine: "concubine"
    };
    exports2.ClaimantInstitutionRelationship = exports2.$Enums.ClaimantInstitutionRelationship = {
      legal_representative: "legal_representative",
      attorney_representative: "attorney_representative",
      attorney_in_fact: "attorney_in_fact",
      other: "other"
    };
    exports2.OrderReportStatus = exports2.$Enums.OrderReportStatus = {
      pending: "pending",
      accepted: "accepted",
      rejected: "rejected"
    };
    exports2.OrderType = exports2.$Enums.OrderType = {
      purchase: "purchase",
      service: "service"
    };
    exports2.OrderSubType = exports2.$Enums.OrderSubType = {
      assessment: "assessment",
      repair: "repair",
      investigation: "investigation",
      parts: "parts"
    };
    exports2.OrderRelationType = exports2.$Enums.OrderRelationType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.OrderStatus = exports2.$Enums.OrderStatus = {
      pending: "pending",
      in_progress: "in_progress",
      completed: "completed",
      rejected: "rejected",
      canceled: "canceled"
    };
    exports2.CurrencySymbol = exports2.$Enums.CurrencySymbol = {
      ARS: "ARS",
      USD: "USD",
      PYG: "PYG",
      EUR: "EUR"
    };
    exports2.OrderWorkProofMechanism = exports2.$Enums.OrderWorkProofMechanism = {
      report: "report",
      inspection: "inspection"
    };
    exports2.OrderWorkflowStage = exports2.$Enums.OrderWorkflowStage = {
      created: "created",
      accepted: "accepted",
      scheduling: "scheduling",
      work_proof: "work_proof",
      documentation: "documentation",
      completed: "completed"
    };
    exports2.OrderWorkflowStageStatus = exports2.$Enums.OrderWorkflowStageStatus = {
      blocked: "blocked",
      awaiting_provider: "awaiting_provider",
      awaiting_insurer: "awaiting_insurer",
      in_progress: "in_progress",
      rejected: "rejected",
      done: "done",
      unreachable: "unreachable",
      canceled: "canceled"
    };
    exports2.OrderScheduleStatus = exports2.$Enums.OrderScheduleStatus = {
      active: "active",
      superseded: "superseded",
      canceled: "canceled"
    };
    exports2.OrderFileUploader = exports2.$Enums.OrderFileUploader = {
      insurer: "insurer",
      provider: "provider"
    };
    exports2.OrderFileSource = exports2.$Enums.OrderFileSource = {
      uploaded: "uploaded",
      imported: "imported"
    };
    exports2.OrderTimelineStatus = exports2.$Enums.OrderTimelineStatus = {
      pending_assignment: "pending_assignment",
      technician_assigned: "technician_assigned",
      schedule_visit: "schedule_visit",
      visit_scheduled: "visit_scheduled",
      budget_waiting_approval: "budget_waiting_approval",
      budget_sent: "budget_sent",
      approved_in_repair: "approved_in_repair",
      repaired_pending_delivery: "repaired_pending_delivery",
      delivered_with_conformity: "delivered_with_conformity",
      settlement: "settlement",
      settled: "settled"
    };
    exports2.BidLineType = exports2.$Enums.BidLineType = {
      labor: "labor",
      auto_part: "auto_part",
      material: "material",
      shipping: "shipping"
    };
    exports2.BidLineUnitOfMeasurement = exports2.$Enums.BidLineUnitOfMeasurement = {
      hour: "hour",
      day: "day",
      unit: "unit",
      km: "km"
    };
    exports2.RequestForProposalMode = exports2.$Enums.RequestForProposalMode = {
      streaming: "streaming",
      batch: "batch"
    };
    exports2.RequestForProposalStatus = exports2.$Enums.RequestForProposalStatus = {
      open: "open",
      closed: "closed",
      canceled: "canceled"
    };
    exports2.RequestForProposalType = exports2.$Enums.RequestForProposalType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.ContractReportStatus = exports2.$Enums.ContractReportStatus = {
      pending: "pending",
      accepted: "accepted",
      rejected: "rejected"
    };
    exports2.CostType = exports2.$Enums.CostType = {
      one_time: "one_time",
      monthly: "monthly",
      yearly: "yearly"
    };
    exports2.RequestForProposalContractStatus = exports2.$Enums.RequestForProposalContractStatus = {
      open: "open",
      closed: "closed"
    };
    exports2.MaterialDamageTypes = exports2.$Enums.MaterialDamageTypes = {
      vehicle: "vehicle",
      real_property: "real_property"
    };
    exports2.DatasetEntityTenant = exports2.$Enums.DatasetEntityTenant = {
      sebaot: "sebaot",
      default: "default"
    };
    exports2.LicenseCategoryTypeRole = exports2.$Enums.LicenseCategoryTypeRole = {
      other: "other"
    };
    exports2.DriverOwnershipTypes = exports2.$Enums.DriverOwnershipTypes = {
      owner: "owner",
      third: "third"
    };
    exports2.VehicleDocumentTypes = exports2.$Enums.VehicleDocumentTypes = {
      other: "other",
      title: "title",
      registration: "registration"
    };
    exports2.VehicleTypes = exports2.$Enums.VehicleTypes = {
      other: "other",
      car: "car",
      moto: "moto",
      bike: "bike",
      machinery: "machinery",
      skateboard: "skateboard",
      special_transport_service: "special_transport_service",
      public_transport_service: "public_transport_service",
      trailer_motor_home: "trailer_motor_home",
      pickup_class_a_and_b_jeep: "pickup_class_a_and_b_jeep",
      truck_chassis: "truck_chassis",
      hitched_semi_trailer: "hitched_semi_trailer",
      tractors_and_rural_machines: "tractors_and_rural_machines"
    };
    exports2.VehicleIdentificationKeys = exports2.$Enums.VehicleIdentificationKeys = {
      license_plate: "license_plate",
      chassis: "chassis"
    };
    exports2.VehicleUseTypes = exports2.$Enums.VehicleUseTypes = {
      private: "private",
      taxi: "taxi",
      remis: "remis",
      rental: "rental",
      ambulance: "ambulance",
      police: "police",
      school: "school",
      special_service: "special_service",
      goods_transport: "goods_transport",
      local: "local",
      route_service: "route_service",
      electronic_platform: "electronic_platform",
      delivery_service: "delivery_service",
      agency: "agency",
      school_transport: "school_transport",
      special_school_pickup: "special_school_pickup"
    };
    exports2.VehicleCategoryTypes = exports2.$Enums.VehicleCategoryTypes = {
      with_license_plate: "with_license_plate",
      without_license_plate: "without_license_plate"
    };
    exports2.CoverageTypes = exports2.$Enums.CoverageTypes = {
      civil_responsibility: "civil_responsibility",
      third_robbery_fire: "third_robbery_fire",
      third_full: "third_full",
      all_risks_without_franchise: "all_risks_without_franchise",
      all_risks_with_franchise: "all_risks_with_franchise",
      other: "other"
    };
    exports2.CirculationDirection = exports2.$Enums.CirculationDirection = {
      one_way: "one_way",
      two_way: "two_way"
    };
    exports2.ClaimantRoles = exports2.$Enums.ClaimantRoles = {
      claimant: "claimant",
      heir: "heir"
    };
    exports2.VictimRelationshipTypes = exports2.$Enums.VictimRelationshipTypes = {
      own: "own",
      mother: "mother",
      father: "father",
      brother: "brother",
      other_family_member: "other_family_member",
      tutor_curator: "tutor_curator",
      attorney_in_fact: "attorney_in_fact",
      attorney_representative: "attorney_representative",
      other: "other",
      legal_representative: "legal_representative",
      producer: "producer",
      workshopper: "workshopper",
      particular_victim: "particular_victim",
      son: "son",
      spouse: "spouse",
      concubine: "concubine",
      grandparent: "grandparent"
    };
    exports2.ClaimantTypes = exports2.$Enums.ClaimantTypes = {
      natural_person: "natural_person",
      legal_person: "legal_person"
    };
    exports2.FileRequestType = exports2.$Enums.FileRequestType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.MessageAuthorType = exports2.$Enums.MessageAuthorType = {
      sender: "sender",
      policyholder: "policyholder"
    };
    exports2.ConversationMessageTypes = exports2.$Enums.ConversationMessageTypes = {
      plain: "plain",
      file_request: "file_request"
    };
    exports2.DamageTypes = exports2.$Enums.DamageTypes = {
      material: "material",
      person: "person",
      recovery: "recovery"
    };
    exports2.ObjectiveGroupType = exports2.$Enums.ObjectiveGroupType = {
      claim_type: "claim_type",
      complaint_type: "complaint_type"
    };
    exports2.TypeSLA = exports2.$Enums.TypeSLA = {
      reference: "reference",
      status: "status",
      stage: "stage",
      chat: "chat"
    };
    exports2.DurationType = exports2.$Enums.DurationType = {
      days: "days",
      hours: "hours"
    };
    exports2.ScopeSLA = exports2.$Enums.ScopeSLA = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.ElapsedDurationCriteria = exports2.$Enums.ElapsedDurationCriteria = {
      elapsed_days: "elapsed_days",
      working_days: "working_days",
      elapsed_hours: "elapsed_hours",
      working_hours: "working_hours"
    };
    exports2.SubDamageTypes = exports2.$Enums.SubDamageTypes = {
      vehicle: "vehicle",
      real_property: "real_property",
      death: "death",
      injury: "injury",
      recovery: "recovery"
    };
    exports2.EntityDamagedCategory = exports2.$Enums.EntityDamagedCategory = {
      with_license_plate: "with_license_plate",
      without_license_plate: "without_license_plate"
    };
    exports2.UserType = exports2.$Enums.UserType = {
      system: "system",
      third: "third",
      policyholder: "policyholder",
      insurer: "insurer",
      backoffice: "backoffice",
      field_adjuster: "field_adjuster",
      vendor: "vendor",
      inhouse_lawyer: "inhouse_lawyer"
    };
    exports2.PermissionType = exports2.$Enums.PermissionType = {
      can_create_entrypoint_session: "can_create_entrypoint_session",
      can_read_developer_resources: "can_read_developer_resources",
      can_update_webhook: "can_update_webhook",
      can_update_contract: "can_update_contract",
      can_read_contract: "can_read_contract",
      can_update_request_for_proposal: "can_update_request_for_proposal",
      can_read_request_for_proposal: "can_read_request_for_proposal",
      can_read_contact: "can_read_contact",
      can_update_contact: "can_update_contact",
      can_create_contact: "can_create_contact",
      can_read_virtual_view: "can_read_virtual_view",
      can_delete_virtual_view: "can_delete_virtual_view",
      can_save_virtual_view: "can_save_virtual_view",
      can_manage_integrations: "can_manage_integrations",
      can_export_claims: "can_export_claims",
      can_export_orders: "can_export_orders",
      can_read_stats: "can_read_stats",
      can_read_company_events: "can_read_company_events",
      can_create_claim: "can_create_claim",
      can_read_claim: "can_read_claim",
      can_update_claim: "can_update_claim",
      can_delete_claim: "can_delete_claim",
      can_update_sinister: "can_update_sinister",
      can_read_sinister: "can_read_sinister",
      can_create_sinister: "can_create_sinister",
      can_delete_sinister: "can_delete_sinister",
      can_read_target_group: "can_read_target_group",
      can_create_target_group: "can_create_target_group",
      can_delete_target_group: "can_delete_target_group",
      can_update_target_group: "can_update_target_group",
      can_create_load_balance_rule: "can_create_load_balance_rule",
      can_update_load_balance_rule: "can_update_load_balance_rule",
      can_read_load_balance_rule: "can_read_load_balance_rule",
      can_delete_load_balance_rule: "can_delete_load_balance_rule",
      can_read_role: "can_read_role",
      can_create_role: "can_create_role",
      can_update_role: "can_update_role",
      can_delete_role: "can_delete_role",
      can_read_user: "can_read_user",
      can_create_user: "can_create_user",
      can_update_user: "can_update_user",
      can_delete_user: "can_delete_user",
      can_read_complaint: "can_read_complaint",
      can_create_complaint: "can_create_complaint",
      can_update_complaint: "can_update_complaint",
      can_delete_complaint: "can_delete_complaint",
      can_read_invitation: "can_read_invitation",
      can_create_invitation: "can_create_invitation",
      can_update_invitation: "can_update_invitation",
      can_delete_invitation: "can_delete_invitation",
      can_read_settings: "can_read_settings",
      can_update_settings: "can_update_settings",
      can_read_account: "can_read_account",
      can_update_account: "can_update_account",
      can_read_team: "can_read_team",
      can_update_team: "can_update_team",
      can_read_notification: "can_read_notification",
      can_read_alert: "can_read_alert",
      can_update_alert: "can_update_alert",
      can_read_company_link: "can_read_company_link",
      can_update_developer_settings: "can_update_developer_settings",
      can_read_inhouse_lawyer: "can_read_inhouse_lawyer",
      can_delete_inhouse_lawyer: "can_delete_inhouse_lawyer",
      can_update_inhouse_lawyer: "can_update_inhouse_lawyer",
      can_create_inhouse_lawyer: "can_create_inhouse_lawyer",
      can_create_judicial_amount: "can_create_judicial_amount",
      can_update_judicial_amount: "can_update_judicial_amount",
      can_create_administrative_amount: "can_create_administrative_amount",
      can_update_administrative_amount: "can_update_administrative_amount",
      can_create_percentage_of_liability: "can_create_percentage_of_liability",
      can_update_percentage_of_liability: "can_update_percentage_of_liability",
      can_create_integration_template: "can_create_integration_template",
      can_update_integration_template: "can_update_integration_template",
      can_delete_integration_template: "can_delete_integration_template",
      can_read_integration_template: "can_read_integration_template",
      can_read_order: "can_read_order",
      can_update_company_working_day: "can_update_company_working_day",
      can_read_company_working_day: "can_read_company_working_day",
      can_create_company_working_exception: "can_create_company_working_exception",
      can_update_company_working_exception: "can_update_company_working_exception",
      can_read_company_working_exception: "can_read_company_working_exception",
      can_read_company_sla: "can_read_company_sla",
      can_create_company_sla: "can_create_company_sla",
      can_update_company_sla: "can_update_company_sla",
      can_read_company_sla_stats: "can_read_company_sla_stats",
      can_update_user_alert: "can_update_user_alert",
      can_read_user_alert: "can_read_user_alert",
      can_create_webhook: "can_create_webhook",
      can_read_webhook: "can_read_webhook",
      can_delete_webhook: "can_delete_webhook",
      can_read_api_key: "can_read_api_key",
      can_create_team: "can_create_team",
      can_delete_team: "can_delete_team",
      can_update_company: "can_update_company",
      can_delete_company_sla: "can_delete_company_sla",
      can_read_tags: "can_read_tags",
      can_manage_tags: "can_manage_tags",
      can_contact_third_party: "can_contact_third_party",
      can_upload_files: "can_upload_files",
      can_read_catalog: "can_read_catalog",
      can_read_providers: "can_read_providers",
      can_create_engagement: "can_create_engagement",
      can_update_engagement: "can_update_engagement",
      can_read_products: "can_read_products",
      can_create_product: "can_create_product",
      can_update_product: "can_update_product",
      can_delete_product: "can_delete_product",
      can_read_customers: "can_read_customers",
      can_create_customer: "can_create_customer",
      can_update_customer: "can_update_customer",
      can_delete_customer: "can_delete_customer",
      can_manage_provider_groups: "can_manage_provider_groups",
      can_read_performance_metrics: "can_read_performance_metrics",
      can_read_team_performance_metrics: "can_read_team_performance_metrics",
      can_cancel_claim_derivation: "can_cancel_claim_derivation",
      can_manage_autoinspector_integration: "can_manage_autoinspector_integration",
      can_update_user_availability: "can_update_user_availability",
      can_read_team_management: "can_read_team_management",
      can_pause_user_assignments: "can_pause_user_assignments",
      can_reassign_team_claims: "can_reassign_team_claims",
      can_read_claim_estimates: "can_read_claim_estimates",
      can_read_claim_offers: "can_read_claim_offers",
      can_read_claim_agreements: "can_read_claim_agreements"
    };
    exports2.PermissionScope = exports2.$Enums.PermissionScope = {
      all: "all",
      own: "own"
    };
    exports2.RealPropertyTypes = exports2.$Enums.RealPropertyTypes = {
      commercial: "commercial",
      building: "building",
      government: "government",
      warehouse: "warehouse",
      housing: "housing",
      other: "other"
    };
    exports2.RealPropertyOwnershipTypes = exports2.$Enums.RealPropertyOwnershipTypes = {
      own: "own",
      other: "other",
      rented: "rented"
    };
    exports2.VictimTypes = exports2.$Enums.VictimTypes = {
      natural_person: "natural_person",
      legal_person: "legal_person"
    };
    exports2.ClaimHandlerTypes = exports2.$Enums.ClaimHandlerTypes = {
      responsible: "responsible",
      collaborator: "collaborator"
    };
    exports2.ComplaintHandlerType = exports2.$Enums.ComplaintHandlerType = {
      responsible: "responsible",
      collaborator: "collaborator"
    };
    exports2.ConditionTypes = exports2.$Enums.ConditionTypes = {
      reference: "reference",
      value: "value"
    };
    exports2.ConditionOperator = exports2.$Enums.ConditionOperator = {
      equals: "equals"
    };
    exports2.LoadBalanceRuleType = exports2.$Enums.LoadBalanceRuleType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.TargetGroupScopes = exports2.$Enums.TargetGroupScopes = {
      derivation: "derivation",
      assignment: "assignment"
    };
    exports2.IngestEventType = exports2.$Enums.IngestEventType = {
      claim_estimates_updated: "claim_estimates_updated",
      sinister_status_updated: "sinister_status_updated",
      claim_mediation_started: "claim_mediation_started",
      claim_lawsuit_started: "claim_lawsuit_started",
      claim_reconciled: "claim_reconciled"
    };
    exports2.IngestEventStatus = exports2.$Enums.IngestEventStatus = {
      pending: "pending",
      processing: "processing",
      processed: "processed",
      failed: "failed"
    };
    exports2.EventInitiator = exports2.$Enums.EventInitiator = {
      triggered_by: "triggered_by",
      policyholder: "policyholder"
    };
    exports2.EventSources = exports2.$Enums.EventSources = {
      alert: "alert",
      external: "external",
      internal: "internal"
    };
    exports2.PersonType = exports2.$Enums.PersonType = {
      natural_person: "natural_person",
      legal_person: "legal_person"
    };
    exports2.PendingComplainExternalStatus = exports2.$Enums.PendingComplainExternalStatus = {
      pending: "pending",
      created: "created"
    };
    exports2.third_party_complaintsources = exports2.$Enums.third_party_complaintsources = {
      local: "local",
      remote: "remote"
    };
    exports2.IdempotentRequestStatus = exports2.$Enums.IdempotentRequestStatus = {
      pending: "pending",
      completed: "completed"
    };
    exports2.FraudInvestigationCaseType = exports2.$Enums.FraudInvestigationCaseType = {
      insured: "insured",
      third_party: "third_party"
    };
    exports2.FraudInvestigationCaseCreationMode = exports2.$Enums.FraudInvestigationCaseCreationMode = {
      created_in_kach: "created_in_kach",
      associated_existing_kach_case: "associated_existing_kach_case"
    };
    exports2.FraudCaseParticipantSyncStatus = exports2.$Enums.FraudCaseParticipantSyncStatus = {
      pending: "pending",
      processed: "processed",
      skipped: "skipped",
      failed: "failed"
    };
    exports2.OfferAgreementProvider = exports2.$Enums.OfferAgreementProvider = {
      autosign: "autosign"
    };
    exports2.OfferAgreementStatus = exports2.$Enums.OfferAgreementStatus = {
      expired: "expired",
      rejected: "rejected",
      draft: "draft",
      started: "started",
      completed: "completed",
      cancelled: "cancelled",
      canceled: "canceled",
      pending: "pending",
      failed: "failed"
    };
    exports2.OfferAgreementSignatureOrigin = exports2.$Enums.OfferAgreementSignatureOrigin = {
      piramid_after_acceptance: "piramid_after_acceptance",
      piramid_signing_cta: "piramid_signing_cta",
      external: "external"
    };
    exports2.OfferAgreementEventOutcome = exports2.$Enums.OfferAgreementEventOutcome = {
      applied: "applied",
      ignored_duplicate: "ignored_duplicate",
      ignored_terminal: "ignored_terminal",
      ignored_unknown: "ignored_unknown",
      failed: "failed"
    };
    exports2.OfferAgreementCeremonyEntry = exports2.$Enums.OfferAgreementCeremonyEntry = {
      after_acceptance: "after_acceptance",
      signing_cta: "signing_cta"
    };
    exports2.AgreementTemplateKind = exports2.$Enums.AgreementTemplateKind = {
      agreement: "agreement",
      offer_message: "offer_message"
    };
    exports2.AgreementTemplateVersionStatus = exports2.$Enums.AgreementTemplateVersionStatus = {
      draft: "draft",
      published: "published",
      deprecated: "deprecated"
    };
    exports2.AgreementDocumentKind = exports2.$Enums.AgreementDocumentKind = {
      preview: "preview",
      final: "final",
      sample: "sample"
    };
    exports2.AgreementDocumentStatus = exports2.$Enums.AgreementDocumentStatus = {
      rendering: "rendering",
      ready: "ready",
      invalid: "invalid",
      failed: "failed"
    };
    exports2.AgreementSignatureMethod = exports2.$Enums.AgreementSignatureMethod = {
      digital: "digital",
      in_person: "in_person"
    };
    exports2.AgreementPlanOutcome = exports2.$Enums.AgreementPlanOutcome = {
      selected: "selected",
      blocked: "blocked",
      no_match: "no_match",
      undetermined: "undetermined",
      disabled: "disabled"
    };
    exports2.MessageTemplateVariableType = exports2.$Enums.MessageTemplateVariableType = {
      numeric: "numeric",
      text: "text",
      select: "select",
      file: "file",
      context_path: "context_path"
    };
    exports2.IntegrationTemplateFieldType = exports2.$Enums.IntegrationTemplateFieldType = {
      message_template_variable: "message_template_variable",
      parent_object_field: "parent_object_field"
    };
    exports2.IntegrationTemplateProviderType = exports2.$Enums.IntegrationTemplateProviderType = {
      autosign: "autosign"
    };
    exports2.OfferStatus = exports2.$Enums.OfferStatus = {
      pending: "pending",
      accepted: "accepted",
      rejected: "rejected",
      expired: "expired",
      cancelled: "cancelled",
      canceled: "canceled"
    };
    exports2.OfferType = exports2.$Enums.OfferType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.InspectionConsumerTypes = exports2.$Enums.InspectionConsumerTypes = {
      policyholder: "policyholder",
      claimant: "claimant"
    };
    exports2.ContactTypes = exports2.$Enums.ContactTypes = {
      field_adjuster: "field_adjuster",
      vendor: "vendor"
    };
    exports2.AppraisalReporStatus = exports2.$Enums.AppraisalReporStatus = {
      pending: "pending",
      accepted: "accepted",
      rejected: "rejected"
    };
    exports2.AppraisalReportType = exports2.$Enums.AppraisalReportType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.OwnershipTransferStatus = exports2.$Enums.OwnershipTransferStatus = {
      accepted: "accepted",
      rejected: "rejected",
      pending: "pending"
    };
    exports2.OwnershipTransferResourceType = exports2.$Enums.OwnershipTransferResourceType = {
      claim: "claim"
    };
    exports2.ClaimStatusReference = exports2.$Enums.ClaimStatusReference = {
      on_claim: "on_claim",
      technical_analysis: "technical_analysis",
      inspection: "inspection",
      responsibility_analysis: "responsibility_analysis",
      negotiation: "negotiation",
      payment_process: "payment_process",
      homologation: "homologation",
      demand_transfer: "demand_transfer",
      canceled: "canceled",
      rejected: "rejected",
      settlement_payment: "settlement_payment",
      mediation: "mediation",
      judgment: "judgment",
      fraud: "fraud",
      analysis: "analysis",
      derivation: "derivation",
      in_closing_process: "in_closing_process",
      reconciled: "reconciled",
      not_successful: "not_successful",
      claimant_disinterest: "claimant_disinterest"
    };
    exports2.TriggerMapping = exports2.$Enums.TriggerMapping = {
      status: "status"
    };
    exports2.TriggerAction = exports2.$Enums.TriggerAction = {
      file_request: "file_request",
      derive_to_fraud: "derive_to_fraud"
    };
    exports2.ClaimSystemStatus = exports2.$Enums.ClaimSystemStatus = {
      open: "open",
      closed: "closed"
    };
    exports2.ClaimEstimateProperty = exports2.$Enums.ClaimEstimateProperty = {
      material_administrative_amount: "material_administrative_amount",
      person_administrative_amount: "person_administrative_amount",
      material_judicial_amount: "material_judicial_amount",
      person_judicial_amount: "person_judicial_amount",
      administrative_amount: "administrative_amount",
      percentage_of_liability: "percentage_of_liability",
      person_percentage_of_judicial_risk: "person_percentage_of_judicial_risk",
      vehicle_market_value: "vehicle_market_value"
    };
    exports2.EstimatesUpdatedSource = exports2.$Enums.EstimatesUpdatedSource = {
      manual: "manual",
      system: "system"
    };
    exports2.EntrypointIntegration = exports2.$Enums.EntrypointIntegration = {
      sebaot: "sebaot"
    };
    exports2.EntrypointBackendTypes = exports2.$Enums.EntrypointBackendTypes = {
      rivadavia: "rivadavia",
      tajy: "tajy",
      demoempleo: "demoempleo",
      gamma: "gamma"
    };
    exports2.EntrypointEnvironment = exports2.$Enums.EntrypointEnvironment = {
      sandbox: "sandbox",
      production: "production"
    };
    exports2.ClaimAlertType = exports2.$Enums.ClaimAlertType = {
      fraud_investigation_in_progress: "fraud_investigation_in_progress",
      fraud_resolved_positive: "fraud_resolved_positive",
      fraud_related_positive_in_sinister: "fraud_related_positive_in_sinister"
    };
    exports2.ComplaintStatusReference = exports2.$Enums.ComplaintStatusReference = {
      on_claim: "on_claim",
      technical_analysis: "technical_analysis",
      inspection: "inspection",
      responsibility_analysis: "responsibility_analysis",
      negotiation: "negotiation",
      payment_process: "payment_process",
      homologation: "homologation",
      demand_transfer: "demand_transfer",
      canceled: "canceled",
      rejected: "rejected",
      settlement_payment: "settlement_payment",
      mediation: "mediation",
      judgment: "judgment",
      fraud: "fraud"
    };
    exports2.TotalInstanceTypeSLA = exports2.$Enums.TotalInstanceTypeSLA = {
      stage: "stage",
      reference: "reference"
    };
    exports2.StatusTransitionReferenceType = exports2.$Enums.StatusTransitionReferenceType = {
      stage: "stage",
      reference: "reference",
      status: "status"
    };
    exports2.ComplaintSystemStatus = exports2.$Enums.ComplaintSystemStatus = {
      open: "open",
      closed: "closed"
    };
    exports2.ClaimStatusType = exports2.$Enums.ClaimStatusType = {
      open: "open",
      closed: "closed"
    };
    exports2.ClaimStatusRole = exports2.$Enums.ClaimStatusRole = {
      default: "default",
      documentation_request: "documentation_request",
      documentation_completed: "documentation_completed",
      criminal_case_request: "criminal_case_request",
      offer_flow: "offer_flow",
      not_response: "not_response",
      claim_rejected: "claim_rejected",
      additional_management: "additional_management",
      default_missing_documentation: "default_missing_documentation",
      default_missing_documentation_no_complaint: "default_missing_documentation_no_complaint",
      default_no_complaint: "default_no_complaint",
      claim_derived_user_strategy: "claim_derived_user_strategy",
      claim_derived_target_group_strategy: "claim_derived_target_group_strategy",
      offer_agreement_completed: "offer_agreement_completed",
      offer_accepted: "offer_accepted",
      claim_derived_team_strategy: "claim_derived_team_strategy",
      offer_created: "offer_created",
      offer_rejected: "offer_rejected",
      sinister_derived_fraud: "sinister_derived_fraud",
      fraud: "fraud",
      mediation: "mediation",
      lawsuit: "lawsuit",
      reconciled: "reconciled",
      offer_canceled: "offer_canceled",
      offer_expired: "offer_expired",
      offer_agreement_started: "offer_agreement_started",
      order_created: "order_created",
      order_accepted: "order_accepted",
      order_rejected: "order_rejected",
      order_canceled: "order_canceled",
      order_completed: "order_completed",
      order_work_proof_completed: "order_work_proof_completed",
      order_work_proof_approved: "order_work_proof_approved",
      order_work_proof_disapproved: "order_work_proof_disapproved"
    };
    exports2.ReviewType = exports2.$Enums.ReviewType = {
      claim_creation_form: "claim_creation_form",
      claim_resolution: "claim_resolution"
    };
    exports2.ValidationPatternExtractors = exports2.$Enums.ValidationPatternExtractors = {
      rivadavia: "rivadavia",
      tajy: "tajy"
    };
    exports2.ValidationPatternColumns = exports2.$Enums.ValidationPatternColumns = {
      policy_number: "policy_number",
      external_claim_id: "external_claim_id"
    };
    exports2.KachOAuthMode = exports2.$Enums.KachOAuthMode = {
      off: "off",
      preferred: "preferred",
      required: "required"
    };
    exports2.IntegrationBackendType = exports2.$Enums.IntegrationBackendType = {
      autoinspector_service_account: "autoinspector_service_account",
      autoinspector: "autoinspector",
      adobe_sign: "adobe_sign",
      rivadavia_productores: "rivadavia_productores",
      kach: "kach",
      kach_user: "kach_user",
      autosign: "autosign",
      autoinspector_templates: "autoinspector_templates"
    };
    exports2.IntegrationScope = exports2.$Enums.IntegrationScope = {
      company: "company",
      user: "user"
    };
    exports2.IntegrationMethodType = exports2.$Enums.IntegrationMethodType = {
      apikey: "apikey",
      oauth: "oauth",
      login: "login"
    };
    exports2.IntegrationVisibility = exports2.$Enums.IntegrationVisibility = {
      public: "public",
      private: "private"
    };
    exports2.AutoinspectorInspectionStatus = exports2.$Enums.AutoinspectorInspectionStatus = {
      created: "created",
      started: "started",
      blocked: "blocked",
      processing: "processing",
      completed: "completed"
    };
    exports2.AutoinspectorWebhookEventStatus = exports2.$Enums.AutoinspectorWebhookEventStatus = {
      pending: "pending",
      processed: "processed",
      unhandled: "unhandled",
      stale: "stale",
      failed: "failed"
    };
    exports2.ClaimFileInspectionStatus = exports2.$Enums.ClaimFileInspectionStatus = {
      reserved: "reserved",
      sent: "sent",
      leftover: "leftover",
      verified: "verified"
    };
    exports2.ExportedReportTypes = exports2.$Enums.ExportedReportTypes = {
      claim: "claim",
      sla_claim: "sla_claim",
      sla_complaint: "sla_complaint",
      event: "event",
      order: "order"
    };
    exports2.ExportedReportStatus = exports2.$Enums.ExportedReportStatus = {
      pending: "pending",
      completed: "completed"
    };
    exports2.JobTypes = exports2.$Enums.JobTypes = {
      scrape_sinister_data: "scrape_sinister_data",
      non_operational_user: "non_operational_user",
      operational_user: "operational_user",
      propagate_claim_creation: "propagate_claim_creation",
      propagate_pending_complaint_creation: "propagate_pending_complaint_creation",
      propagate_claim_updated: "propagate_claim_updated",
      propagate_external_complaint_selected: "propagate_external_complaint_selected",
      external_authorize_complaint: "external_authorize_complaint",
      external_approve_complaint: "external_approve_complaint",
      external_reject_complaint: "external_reject_complaint",
      propagate_complaint_updated: "propagate_complaint_updated",
      batch_delegate_user_claims: "batch_delegate_user_claims",
      batch_restore_user_claims: "batch_restore_user_claims",
      process_offer_agreement: "process_offer_agreement",
      dispatch_offer_agreement: "dispatch_offer_agreement",
      claim_document_analysis: "claim_document_analysis",
      reconcile_offer_agreement: "reconcile_offer_agreement",
      cancel_offer_agreement: "cancel_offer_agreement"
    };
    exports2.JobStatus = exports2.$Enums.JobStatus = {
      pending: "pending",
      running: "running",
      completed: "completed",
      failed: "failed",
      cancelled: "cancelled"
    };
    exports2.EntrypointType = exports2.$Enums.EntrypointType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.EntrypointSpecification = exports2.$Enums.EntrypointSpecification = {
      rivadavia_v2: "rivadavia_v2",
      demoempleo: "demoempleo",
      gamma: "gamma"
    };
    exports2.SpecialPermissionType = exports2.$Enums.SpecialPermissionType = {
      sinister_date_limit: "sinister_date_limit",
      vehicle_id_card_ocr: "vehicle_id_card_ocr",
      recovery_claim: "recovery_claim"
    };
    exports2.UserSources = exports2.$Enums.UserSources = {
      autogenerated: "autogenerated"
    };
    exports2.ProfessionType = exports2.$Enums.ProfessionType = {
      lawyer: "lawyer",
      other: "other"
    };
    exports2.IdentityProviderType = exports2.$Enums.IdentityProviderType = {
      google: "google",
      facebook: "facebook",
      microsoft: "microsoft"
    };
    exports2.EstimatesDefinitionStrategy = exports2.$Enums.EstimatesDefinitionStrategy = {
      coverage: "coverage"
    };
    exports2.CompanyEstimatesDefinitionScope = exports2.$Enums.CompanyEstimatesDefinitionScope = {
      complaint: "complaint"
    };
    exports2.DayOfWeek = exports2.$Enums.DayOfWeek = {
      monday: "monday",
      tuesday: "tuesday",
      wednesday: "wednesday",
      thursday: "thursday",
      friday: "friday",
      saturday: "saturday",
      sunday: "sunday"
    };
    exports2.FieldMappingEntity = exports2.$Enums.FieldMappingEntity = {
      claim: "claim"
    };
    exports2.MappingFieldName = exports2.$Enums.MappingFieldName = {
      ref_id: "ref_id",
      external_claim_request_id: "external_claim_request_id"
    };
    exports2.CustomerOrganizationInvitationStatus = exports2.$Enums.CustomerOrganizationInvitationStatus = {
      pending: "pending",
      accepted: "accepted",
      cancelled: "cancelled",
      expired: "expired"
    };
    exports2.CompanyType = exports2.$Enums.CompanyType = {
      system: "system",
      insurer: "insurer",
      provider: "provider"
    };
    exports2.CompanyTheme = exports2.$Enums.CompanyTheme = {
      theme_red: "theme_red",
      theme_orange: "theme_orange",
      theme_amber: "theme_amber",
      theme_yellow: "theme_yellow",
      theme_lime: "theme_lime",
      theme_green: "theme_green",
      theme_emerald: "theme_emerald",
      theme_teal: "theme_teal",
      theme_cyan: "theme_cyan",
      theme_sky: "theme_sky",
      theme_blue: "theme_blue",
      theme_indigo: "theme_indigo",
      theme_violet: "theme_violet",
      theme_purple: "theme_purple",
      theme_fuchsia: "theme_fuchsia",
      theme_pink: "theme_pink",
      theme_rose: "theme_rose"
    };
    exports2.ProviderInvitationStatus = exports2.$Enums.ProviderInvitationStatus = {
      pending: "pending",
      registered: "registered",
      rejected: "rejected",
      cancelled: "cancelled",
      expired: "expired"
    };
    exports2.ProviderSource = exports2.$Enums.ProviderSource = {
      invited: "invited",
      csv: "csv",
      marketplace: "marketplace"
    };
    exports2.EngagementStatus = exports2.$Enums.EngagementStatus = {
      pending: "pending",
      active: "active",
      rejected: "rejected",
      paused: "paused",
      suspended: "suspended"
    };
    exports2.GeoLevel = exports2.$Enums.GeoLevel = {
      province: "province",
      department: "department",
      locality: "locality"
    };
    exports2.ProductImportStatus = exports2.$Enums.ProductImportStatus = {
      pending: "pending",
      processing: "processing",
      completed: "completed",
      completed_with_errors: "completed_with_errors",
      failed: "failed"
    };
    exports2.IntakeSubmissionType = exports2.$Enums.IntakeSubmissionType = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.Alerts = exports2.$Enums.Alerts = {
      pending_file_request_upload: "pending_file_request_upload",
      pending_sinister_complaint: "pending_sinister_complaint",
      pending_offer_response: "pending_offer_response",
      pending_offer_agreement_response: "pending_offer_agreement_response",
      pending_offer_response_internal: "pending_offer_response_internal",
      pending_offer_agreement_response_internal: "pending_offer_agreement_response_internal",
      sla_objective_progress: "sla_objective_progress",
      sla_total_progress: "sla_total_progress"
    };
    exports2.AlertScope = exports2.$Enums.AlertScope = {
      company: "company",
      user: "user"
    };
    exports2.NotificationProtocol = exports2.$Enums.NotificationProtocol = {
      email: "email",
      push: "push"
    };
    exports2.StylesConfigScope = exports2.$Enums.StylesConfigScope = {
      insurer: "insurer",
      claim: "claim",
      complaint: "complaint"
    };
    exports2.ColorThemeType = exports2.$Enums.ColorThemeType = {
      zinc: "zinc",
      slate: "slate",
      stone: "stone",
      gray: "gray",
      neutral: "neutral",
      red: "red",
      rose: "rose",
      orange: "orange",
      green: "green",
      blue: "blue",
      yellow: "yellow",
      violet: "violet"
    };
    exports2.StyleMode = exports2.$Enums.StyleMode = {
      dark: "dark",
      light: "light"
    };
    exports2.FontFamily = exports2.$Enums.FontFamily = {
      inter: "inter",
      roboto: "roboto",
      roboto_mono: "roboto_mono",
      space_grotesk: "space_grotesk",
      space_mono: "space_mono",
      playfair_display: "playfair_display",
      prata: "prata",
      glegoo: "glegoo",
      robot_flex: "robot_flex",
      roboto_condensed: "roboto_condensed",
      roboto_slab: "roboto_slab",
      ibm_plex_sans_condensed: "ibm_plex_sans_condensed",
      ubuntu_condensed: "ubuntu_condensed",
      barlow_condensed: "barlow_condensed",
      saira_condensed: "saira_condensed"
    };
    exports2.WebhookMode = exports2.$Enums.WebhookMode = {
      test: "test",
      prod: "prod"
    };
    exports2.ComplaintTriggerAction = exports2.$Enums.ComplaintTriggerAction = {
      authorize_complaint: "authorize_complaint",
      approve_complaint: "approve_complaint",
      reject_complaint: "reject_complaint"
    };
    exports2.ComplaintStatus = exports2.$Enums.ComplaintStatus = {
      open: "open",
      closed: "closed"
    };
    exports2.ComplaintStatusRole = exports2.$Enums.ComplaintStatusRole = {
      default: "default"
    };
    exports2.EntrypointSessionStatus = exports2.$Enums.EntrypointSessionStatus = {
      open: "open",
      closed: "closed",
      created: "created",
      completed: "completed",
      expired: "expired"
    };
    exports2.SyncStatus = exports2.$Enums.SyncStatus = {
      pending: "pending",
      synced: "synced",
      failed: "failed",
      running: "running"
    };
    exports2.ComplaintType = exports2.$Enums.ComplaintType = {
      vehicle: "vehicle",
      building: "building",
      glass: "glass",
      medical_assistance_accident: "medical_assistance_accident",
      electronic_equipment: "electronic_equipment",
      theft: "theft",
      other: "other"
    };
    exports2.VariableValidationValueType = exports2.$Enums.VariableValidationValueType = {
      reference: "reference",
      literal: "literal"
    };
    exports2.VariableValidationValueReference = exports2.$Enums.VariableValidationValueReference = {
      judicial_amount_times_percentage_of_liability: "judicial_amount_times_percentage_of_liability"
    };
    exports2.VariableDetermination = exports2.$Enums.VariableDetermination = {
      compile_time: "compile_time",
      runtime: "runtime"
    };
    exports2.MessageTemplateValidationTypes = exports2.$Enums.MessageTemplateValidationTypes = {
      interbanking: "interbanking"
    };
    exports2.ConditionAction = exports2.$Enums.ConditionAction = {
      show: "show"
    };
    exports2.MessageTemplateContext = exports2.$Enums.MessageTemplateContext = {
      claim: "claim",
      complaint: "complaint"
    };
    exports2.MessageTemplateScope = exports2.$Enums.MessageTemplateScope = {
      offer: "offer",
      communication: "communication"
    };
    exports2.MessageTemplateRole = exports2.$Enums.MessageTemplateRole = {
      automatic_response: "automatic_response"
    };
    exports2.InferredKeywordsType = exports2.$Enums.InferredKeywordsType = {
      boolean: "boolean",
      string: "string",
      number: "number"
    };
    exports2.WorkflowProvider = exports2.$Enums.WorkflowProvider = {
      ravel_ai: "ravel_ai"
    };
    exports2.WorkflowKeyName = exports2.$Enums.WorkflowKeyName = {
      infer_file_data: "infer_file_data",
      vehicle_id_card_ocr: "vehicle_id_card_ocr"
    };
    exports2.Prisma.ModelName = {
      City: "City",
      CountryZipCode: "CountryZipCode",
      VirtualViewFilter: "VirtualViewFilter",
      VirtualViewColumn: "VirtualViewColumn",
      VirtualView: "VirtualView",
      Tag: "Tag",
      ValidationResult: "ValidationResult",
      InferredNationalIdentityCard: "InferredNationalIdentityCard",
      InferredCoverageCertificate: "InferredCoverageCertificate",
      InferredDeathCertificate: "InferredDeathCertificate",
      InferredMedicalCertificate: "InferredMedicalCertificate",
      InferredVehicle: "InferredVehicle",
      InferredVehicleIdCardFront: "InferredVehicleIdCardFront",
      InferredVehicleIdCardBack: "InferredVehicleIdCardBack",
      InferredEntity: "InferredEntity",
      File: "File",
      LegalPerson: "LegalPerson",
      NaturalPerson: "NaturalPerson",
      PersonParent: "PersonParent",
      InHouseLawyer: "InHouseLawyer",
      PersonDamageDetail: "PersonDamageDetail",
      PersonDamage: "PersonDamage",
      RecoveryDamage: "RecoveryDamage",
      OrderReport: "OrderReport",
      OrderInvoice: "OrderInvoice",
      OrderItem: "OrderItem",
      Order: "Order",
      OrderSchedule: "OrderSchedule",
      OrderFile: "OrderFile",
      OrderDocumentRequirement: "OrderDocumentRequirement",
      CompanyOrderClaimStatusMapping: "CompanyOrderClaimStatusMapping",
      OrderRequiredDocument: "OrderRequiredDocument",
      OrderRequiredDocumentVersion: "OrderRequiredDocumentVersion",
      OrderTimeline: "OrderTimeline",
      RequestForProposalVendor: "RequestForProposalVendor",
      BidLine: "BidLine",
      RequestForProposalBid: "RequestForProposalBid",
      RequestForProposal: "RequestForProposal",
      EntrypointSnapshotProgress: "EntrypointSnapshotProgress",
      ContractReport: "ContractReport",
      RequestForProposalContract: "RequestForProposalContract",
      MaterialDamage: "MaterialDamage",
      LicenseCategoryType: "LicenseCategoryType",
      Driver: "Driver",
      Vehicle: "Vehicle",
      Insurance: "Insurance",
      Ocurrence: "Ocurrence",
      Claimant: "Claimant",
      FileRequestPlaceholder: "FileRequestPlaceholder",
      FileRequest: "FileRequest",
      ClaimSharedDocument: "ClaimSharedDocument",
      Message: "Message",
      Damage: "Damage",
      SLAObjective: "SLAObjective",
      CompanySLA: "CompanySLA",
      ComplaintTypeDamage: "ComplaintTypeDamage",
      ClaimTypeDamage: "ClaimTypeDamage",
      CompanyClaimType: "CompanyClaimType",
      CompanyComplaintType: "CompanyComplaintType",
      GroupSLA: "GroupSLA",
      Role: "Role",
      Permission: "Permission",
      RealProperty: "RealProperty",
      Victim: "Victim",
      ClaimHandlerDelegated: "ClaimHandlerDelegated",
      ComplaintHandlerDelegated: "ComplaintHandlerDelegated",
      ClaimHandler: "ClaimHandler",
      ComplaintHandler: "ComplaintHandler",
      LoadBalanceRuleCondition: "LoadBalanceRuleCondition",
      LoadBalanceRule: "LoadBalanceRule",
      TargetGroup: "TargetGroup",
      EventDetail: "EventDetail",
      IngestEvent: "IngestEvent",
      Event: "Event",
      Comment: "Comment",
      Mention: "Mention",
      SinisterExpertAppraisal: "SinisterExpertAppraisal",
      PolicyholderInspection: "PolicyholderInspection",
      Policyholder: "Policyholder",
      PendingComplaint: "PendingComplaint",
      ExternalInsurancePolicy: "ExternalInsurancePolicy",
      ExternalComplaint: "ExternalComplaint",
      IdempotentRequest: "IdempotentRequest",
      NewsAnswer: "NewsAnswer",
      NewsRequest: "NewsRequest",
      FraudInvestigationCaseAcceptedReport: "FraudInvestigationCaseAcceptedReport",
      FraudInvestigationCaseClaimResult: "FraudInvestigationCaseClaimResult",
      FraudInvestigationCase: "FraudInvestigationCase",
      FraudCaseParticipantSyncRequest: "FraudCaseParticipantSyncRequest",
      CompanyClaimPublicStatus: "CompanyClaimPublicStatus",
      Sinister: "Sinister",
      OfferAgreement: "OfferAgreement",
      OfferAgreementEvent: "OfferAgreementEvent",
      OfferAgreementSigningLink: "OfferAgreementSigningLink",
      OfferAgreementCeremonyWindow: "OfferAgreementCeremonyWindow",
      OfferEmbeddedSigningSession: "OfferEmbeddedSigningSession",
      AgreementTemplate: "AgreementTemplate",
      AgreementTemplateVersion: "AgreementTemplateVersion",
      AgreementDocument: "AgreementDocument",
      CompanyAgreementSettings: "CompanyAgreementSettings",
      AgreementRule: "AgreementRule",
      AgreementSignatureRule: "AgreementSignatureRule",
      OfferAgreementPlan: "OfferAgreementPlan",
      VariableValue: "VariableValue",
      IntegrationTemplateFieldMapping: "IntegrationTemplateFieldMapping",
      IntegrationTemplate: "IntegrationTemplate",
      Offer: "Offer",
      Inspection: "Inspection",
      Contact: "Contact",
      UpdateNote: "UpdateNote",
      AppraisalReport: "AppraisalReport",
      OwnershipTransfer: "OwnershipTransfer",
      ResponsibilityTransfer: "ResponsibilityTransfer",
      TransitionTarget: "TransitionTarget",
      CompanyClaimStatusOrderRule: "CompanyClaimStatusOrderRule",
      CompanyClaimTriggerMapping: "CompanyClaimTriggerMapping",
      SLAInstance: "SLAInstance",
      ClaimEstimateChange: "ClaimEstimateChange",
      Claim: "Claim",
      ClaimDerivation: "ClaimDerivation",
      ClaimAlert: "ClaimAlert",
      CompanyClaimStage: "CompanyClaimStage",
      ComplaintTransitionTarget: "ComplaintTransitionTarget",
      CompanyComplaintStatusOrderRule: "CompanyComplaintStatusOrderRule",
      CompanyComplaintStage: "CompanyComplaintStage",
      TotalInstanceSLA: "TotalInstanceSLA",
      ObjectiveInstanceSLA: "ObjectiveInstanceSLA",
      StatusTransitionDuration: "StatusTransitionDuration",
      ClaimStatusTransitionDuration: "ClaimStatusTransitionDuration",
      ClaimStatusTransition: "ClaimStatusTransition",
      ComplaintStatusTransition: "ComplaintStatusTransition",
      CompanyClaimReference: "CompanyClaimReference",
      CompanyComplaintReference: "CompanyComplaintReference",
      CompanyClaimStatus: "CompanyClaimStatus",
      ClaimResult: "ClaimResult",
      Review: "Review",
      TeamDelegationNoticeDismissal: "TeamDelegationNoticeDismissal",
      PerformanceSnapshot: "PerformanceSnapshot",
      NegotiationTypeAverageSnapshot: "NegotiationTypeAverageSnapshot",
      ReleaseNote: "ReleaseNote",
      ReleaseNoteItem: "ReleaseNoteItem",
      ReleaseNoteSection: "ReleaseNoteSection",
      ReleaseNoteEvent: "ReleaseNoteEvent",
      ReleaseNoteRecipient: "ReleaseNoteRecipient",
      ValidationPattern: "ValidationPattern",
      EncryptedMessage: "EncryptedMessage",
      LoginCredentials: "LoginCredentials",
      IntegrationConnection: "IntegrationConnection",
      OAuthAuthorizationAttempt: "OAuthAuthorizationAttempt",
      Integration: "Integration",
      AutoinspectorTemplate: "AutoinspectorTemplate",
      AutoinspectorInspection: "AutoinspectorInspection",
      AutoinspectorInspectionAsset: "AutoinspectorInspectionAsset",
      AutoinspectorWebhookEvent: "AutoinspectorWebhookEvent",
      ClaimFileInspectionState: "ClaimFileInspectionState",
      ValidationDefinition: "ValidationDefinition",
      ExportedReport: "ExportedReport",
      Job: "Job",
      EntityDefinition: "EntityDefinition",
      Entrypoint: "Entrypoint",
      EntrypointSpecialPermission: "EntrypointSpecialPermission",
      User: "User",
      IdentityProvider: "IdentityProvider",
      EstimatesOperandDefinition: "EstimatesOperandDefinition",
      CompanyEstimatesDefinition: "CompanyEstimatesDefinition",
      CompanyFlags: "CompanyFlags",
      CompanyWorkingException: "CompanyWorkingException",
      CompanyWorkingDay: "CompanyWorkingDay",
      CompanyCalendar: "CompanyCalendar",
      CompanyCurrency: "CompanyCurrency",
      FieldMappingConfig: "FieldMappingConfig",
      Member: "Member",
      CustomerOrganization: "CustomerOrganization",
      CustomerOrganizationInvitation: "CustomerOrganizationInvitation",
      Company: "Company",
      Vertical: "Vertical",
      Good: "Good",
      Service: "Service",
      CompanyVertical: "CompanyVertical",
      Province: "Province",
      Department: "Department",
      Locality: "Locality",
      ProviderInvitation: "ProviderInvitation",
      Provider: "Provider",
      Engagement: "Engagement",
      ProviderCapability: "ProviderCapability",
      ProviderCapabilityGood: "ProviderCapabilityGood",
      ProviderCoverage: "ProviderCoverage",
      ProviderBranch: "ProviderBranch",
      ProviderDocumentType: "ProviderDocumentType",
      ProviderDocument: "ProviderDocument",
      Insurer: "Insurer",
      Moto: "Moto",
      Car: "Car",
      HealthInsuranceFund: "HealthInsuranceFund",
      WorkerCompensationInsurer: "WorkerCompensationInsurer",
      CompanyRamo: "CompanyRamo",
      CompanyAgency: "CompanyAgency",
      Product: "Product",
      ProductImport: "ProductImport",
      CompanyCustomer: "CompanyCustomer",
      IntakeSubmission: "IntakeSubmission",
      ProviderGroup: "ProviderGroup",
      ProviderGroupMember: "ProviderGroupMember",
      Invitation: "Invitation",
      Seeder: "Seeder",
      TopicSubscription: "TopicSubscription",
      Topic: "Topic",
      Alert: "Alert",
      AlertSubscription: "AlertSubscription",
      NotificationReceiver: "NotificationReceiver",
      Notification: "Notification",
      StylesConfig: "StylesConfig",
      CompanyLink: "CompanyLink",
      CompanySinisterConfigCountries: "CompanySinisterConfigCountries",
      CompanySinisterConfig: "CompanySinisterConfig",
      WebhookLog: "WebhookLog",
      WebhookEventSubscription: "WebhookEventSubscription",
      Webhook: "Webhook",
      CompanyComplaintPublicStatus: "CompanyComplaintPublicStatus",
      CompanyComplaintTriggerMapping: "CompanyComplaintTriggerMapping",
      CompanyComplaintStatus: "CompanyComplaintStatus",
      EntrypointSession: "EntrypointSession",
      ComplaintSinisterCause: "ComplaintSinisterCause",
      EstimatesOperandValue: "EstimatesOperandValue",
      AffectedCoverage: "AffectedCoverage",
      Complaint: "Complaint",
      VariableDefinition: "VariableDefinition",
      VariableValidation: "VariableValidation",
      VariableCondition: "VariableCondition",
      MessageTemplate: "MessageTemplate",
      Team: "Team",
      ServiceAccount: "ServiceAccount",
      MessageHash: "MessageHash",
      Verification: "Verification",
      InferredFileData: "InferredFileData",
      InferredFileDataManualUpdate: "InferredFileDataManualUpdate",
      InferredKeywords: "InferredKeywords",
      InferredKeywordsManualUpdate: "InferredKeywordsManualUpdate",
      Workflow: "Workflow",
      ErrorNotification: "ErrorNotification"
    };
    var PrismaClient = class {
      constructor() {
        return new Proxy(this, {
          get(target, prop) {
            let message;
            const runtime = getRuntime2();
            if (runtime.isEdge) {
              message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
            } else {
              message = "PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `" + runtime.prettyName + "`).";
            }
            message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`;
            throw new Error(message);
          }
        });
      }
    };
    exports2.PrismaClient = PrismaClient;
    Object.assign(exports2, Prisma27);
  }
});

// ../../node_modules/@prisma/client/index-browser.js
var require_index_browser3 = __commonJS({
  "../../node_modules/@prisma/client/index-browser.js"(exports2, module2) {
    "use strict";
    var prisma = require_index_browser2();
    module2.exports = prisma;
  }
});

// ../database/dist/index-browser.js
var require_index_browser4 = __commonJS({
  "../database/dist/index-browser.js"(exports2, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __reExport = (target, mod, secondTarget) => (__copyProps2(target, mod, "default"), secondTarget && __copyProps2(secondTarget, mod, "default"));
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var index_browser_exports = {};
    __export2(index_browser_exports, {
      RELEASE_NOTES_ROLE_FILTER: () => RELEASE_NOTES_ROLE_FILTER2,
      eventTypes: () => eventTypes2,
      fraudInvestigationStatuses: () => fraudInvestigationStatuses3,
      isFraudInvestigationStatus: () => isFraudInvestigationStatus,
      kachParticipantSyncReasons: () => kachParticipantSyncReasons,
      releaseNoteCompanyFlags: () => releaseNoteCompanyFlags2,
      releaseNoteComparisonTones: () => releaseNoteComparisonTones2,
      releaseNoteDemos: () => releaseNoteDemos2,
      releaseNoteEventTypes: () => releaseNoteEventTypes2,
      releaseNoteItemKinds: () => releaseNoteItemKinds2,
      releaseNoteKinds: () => releaseNoteKinds2,
      releaseNoteListFilters: () => releaseNoteListFilters2,
      releaseNoteMetricDirections: () => releaseNoteMetricDirections,
      releaseNoteMetricSummaries: () => releaseNoteMetricSummaries,
      releaseNoteMetricUnits: () => releaseNoteMetricUnits,
      releaseNoteSectionKinds: () => releaseNoteSectionKinds2,
      releaseNoteStatuses: () => releaseNoteStatuses,
      releaseNoteViewSources: () => releaseNoteViewSources2,
      teamDelegationNoticeKinds: () => teamDelegationNoticeKinds2
    });
    module2.exports = __toCommonJS2(index_browser_exports);
    __reExport(index_browser_exports, require_index_browser3(), module2.exports);
    var eventTypes2 = [
      "complaint_form_step_view",
      "sinister_complaints_view",
      "rfp_bid_winner_selected",
      "rfp_bid_submitted",
      "rfp_created",
      "rfp_canceled",
      "contract_created",
      "contract_report_created",
      "contract_report_accepted",
      "contract_report_rejected",
      "contract_updates_published",
      "contract_updates_requested",
      "contract_invoice_uploaded",
      "appraisal_invoice_uploaded",
      "appraisal_updates_published",
      "appraisal_updates_requested",
      "appraisal_report_rejected",
      "appraisal_report_accepted",
      "appraisal_report_created",
      "field_adjuster_assigned",
      "offer_expired",
      "offer_rejected",
      "offer_accepted",
      "fraud_updated",
      "fraud_closed",
      "fraud_investigation_report_accepted",
      "fraud_news_answered",
      "fraud_news_requested",
      "fraud_claim_result_updated",
      "complaint_file_request_uploaded",
      "file_request_uploaded",
      "file_view",
      "role_detail_view",
      "sinister_created",
      "roles_view",
      "invitations_view",
      "settings_notifications_view",
      "settings_team_view",
      "settings_distribution_view",
      "settings_profile_view",
      "sinister_claim_detail_view",
      "sinister_third_party_complaints_view",
      "sinister_fraud_investigation_cases_view",
      "sinister_claims_view",
      "sinister_expert_appraisals_view",
      "forwarded_invitation",
      "complaint_created",
      "sinister_complaint_chat_message_send",
      "sinister_claim_chat_message_send",
      "sinister_claim_chat_view",
      "documentation_filter",
      "documentation_search",
      "claim_document_view",
      "external_complaint_documentation_list_view",
      "complaint_documentation_list_view",
      "sinister_documentation_list_view",
      "claim_documentation_list_view",
      "fraud_activity_view",
      "claim_activity_view",
      "complaint_activity_view",
      "sinister_claim_view",
      "sinister_table_view",
      "claim_form_step_view",
      "claim_form_step_completed",
      "sinister_view",
      "sinister_search",
      "sinister_filter",
      "sinister_list_view",
      "target_group_updated",
      "users_invited",
      "load_balance_rule_detail_view",
      "target_group_detail_view",
      "target_groups_view",
      "load_balance_rules_view",
      "load_balance_rule_updated",
      "load_balance_rule_deleted",
      "load_balance_rule_created",
      "target_group_deleted",
      "target_group_created",
      "complaint_collaborator_unassigned",
      "claim_collaborator_unassigned",
      "complaint_collaborator_assigned",
      "claim_collaborator_assigned",
      "claim_responsible_unassigned",
      "claim_responsible_assigned",
      "claim_created",
      "claim_status_updated",
      "complaint_status_updated",
      "complaint_responsible_assigned",
      "file_requested",
      "file_request_placeholder_cancelled",
      "upload_files",
      "pending_sinister_complaint",
      "pending_file_request_upload",
      "login",
      "logout",
      "claim_documentation_requested",
      "criminal_case_request",
      "claim_not_response",
      "claim_offer_flow",
      "claim_documentation_completed",
      "claim_rejected",
      "claim_additional_management",
      "claim_ownership_transfer_requested",
      "claim_ownership_transfer_accepted",
      "claim_ownership_transfer_rejected",
      "claim_ownership_assigned",
      "claim_estimates_updated",
      "pending_offer_response",
      "pending_offer_agreement_response",
      "offer_agreement_completed",
      "offer_agreement_rejected",
      "offer_agreement_expired",
      "offer_agreement_cancelled",
      "pending_offer_response_internal",
      "pending_offer_agreement_response_internal",
      "claim_updated",
      "complaint_sinister_cause_updated",
      "external_complaint_selected",
      "claim_sinister_changed",
      "claim_derived",
      "claim_responsibility_returned",
      "claim_derived_returned",
      "claim_derivation_canceled",
      "claim_derivation_restore_status_updated",
      "pending_complaint_created",
      "rfp_expired",
      "external_complaint_created",
      "complaint_authorized",
      "external_complaint_authorized",
      "complaint_approved",
      "external_complaint_approved",
      "complaint_rejected",
      "external_complaint_rejected",
      "complaint_estimates_updated",
      "order_created",
      "order_report_created",
      "order_report_accepted",
      "order_report_rejected",
      "order_updates_published",
      "order_updates_requested",
      "order_invoice_uploaded",
      "alert_sla_objective_progress",
      "alert_sla_total_progress",
      "sinister_external_status_updated",
      "complaint_updated",
      "complaint_confirmation_signature",
      "claim_file_uploaded",
      "offer_created",
      "offer_agreement_created",
      "offer_canceled",
      "claim_confirmation_signature",
      "team_updated",
      "team_detail_view",
      "teams_view",
      "team_deleted",
      "team_created",
      "tags_view",
      "tag_created",
      "tag_updated",
      "tag_deleted",
      "claim_comment_created",
      "claim_created_documents_missing",
      "claim_file_request_completed",
      "pending_complaint_requested",
      "pending_complaint_creation_failed",
      "external_complaint_selection_failed",
      "fraud_investigation_case_created",
      "fraud_reopened",
      "claim_status_communication_sent",
      "order_accepted",
      "order_rejected",
      "order_canceled",
      "order_report_reset",
      "order_invoice_accepted",
      "order_invoice_rejected",
      "order_invoice_reset",
      "order_completed",
      "order_reopened",
      "order_document_uploaded",
      "order_work_proof_created",
      "order_work_proof_approved",
      "order_work_proof_disapproved",
      "order_work_proof_blocked",
      "claim_mediation_started",
      "claim_lawsuit_started",
      "order_scheduled",
      "order_rescheduled",
      "order_schedule_canceled",
      "order_required_document_uploaded",
      "order_required_document_accepted",
      "order_required_document_rejected",
      "order_required_document_reset",
      "order_document_removed",
      "claim_reconciled",
      "claim_form_vehicle_id_card_extracted",
      "offer_agreement_dispatch_failed",
      "offer_agreement_recipient_submitted",
      "user_assignments_paused",
      "user_assignments_resumed",
      "team_claims_reassigned",
      "user_inactivity_started",
      "user_inactivity_ended",
      "user_inactivity_scheduled",
      "user_inactivity_rescheduled",
      "user_inactivity_return_changed",
      "user_inactivity_cancelled",
      "team_claims_delegated",
      "user_inactivity_claims_delegated",
      "user_inactivity_delegation_updated",
      "user_inactivity_delegation_discarded",
      "team_claims_recovered",
      "user_delegated_claims_recovered",
      "user_delegated_claims_returned",
      "user_derived_claims_returned",
      "user_derived_claims_recovered"
    ];
    var teamDelegationNoticeKinds2 = [
      "delegation_review",
      "uncovered_claims"
    ];
    var fraudInvestigationStatuses3 = [
      "not_assigned",
      "in_progress",
      "derived_to_lab",
      "in_extension",
      "without_result",
      "closed"
    ];
    var isFraudInvestigationStatus = (value) => fraudInvestigationStatuses3.includes(value);
    var kachParticipantSyncReasons = [
      "handler_committed",
      "responsibility_returned",
      "substitute_assigned",
      "derivation_closed_externally",
      "team_reassigned",
      "team_delegated",
      "team_delegated_claims_moved",
      "responsible_reassigned",
      "responsibility_derived",
      "delegation_restored",
      "collaborator_removed",
      "claim_moved",
      "case_derived",
      "claim_added_to_case",
      "case_reopened",
      "sinister_handler_changed",
      "claim_status_changed",
      "sinister_status_changed",
      "periodic_reconcile",
      "backfill"
    ];
    var releaseNoteKinds2 = ["feature", "improvement", "fix"];
    var releaseNoteStatuses = ["draft", "published"];
    var releaseNoteCompanyFlags2 = [
      "claim_evaluation",
      "claim_rfp",
      "orders",
      "providers",
      "performance_metrics",
      "recovery_claim",
      "team_management"
    ];
    var releaseNoteListFilters2 = ["all", "unread", "mine"];
    var RELEASE_NOTES_ROLE_FILTER2 = "role";
    var releaseNoteItemKinds2 = ["overview", "feature"];
    var releaseNoteSectionKinds2 = [
      "text",
      "heading",
      "bullets",
      "steps",
      "comparison",
      "cards",
      "callout",
      "decision",
      "demo",
      "image"
    ];
    var releaseNoteDemos2 = ["team_members_table"];
    var releaseNoteComparisonTones2 = ["accent", "neutral"];
    var releaseNoteEventTypes2 = [
      "release_notes_list_view",
      "release_notes_list_filter",
      "release_notes_list_search",
      // The sidebar's quick look at the latest note, before opening it.
      "release_note_peek",
      "release_note_view",
      "release_note_item_view",
      "release_note_toc_click",
      "release_note_demo_interaction",
      "release_note_link_click",
      "release_note_feedback",
      // Sent when the reader leaves, with how long and how far they read.
      "release_note_read",
      // Recorded by the backoffice for each user it emails about a note.
      "release_note_notified"
    ];
    var releaseNoteViewSources2 = [
      "list",
      "direct",
      "sidebar",
      "email"
    ];
    var releaseNoteMetricDirections = ["up", "down", "flat"];
    var releaseNoteMetricUnits = [
      "count",
      "users",
      "percent",
      "minutes",
      "hours",
      "days"
    ];
    var releaseNoteMetricSummaries = [
      "weekly_average",
      "share",
      "median",
      "latest"
    ];
  }
});

// ../../node_modules/lodash.get/index.js
var require_lodash = __commonJS({
  "../../node_modules/lodash.get/index.js"(exports2, module2) {
    "use strict";
    var FUNC_ERROR_TEXT = "Expected a function";
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var INFINITY = 1 / 0;
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var symbolTag = "[object Symbol]";
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
    var reIsPlainProp = /^\w*$/;
    var reLeadingDot = /^\./;
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reEscapeChar = /\\(\\)?/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function isHostObject(value) {
      var result = false;
      if (value != null && typeof value.toString != "function") {
        try {
          result = !!(value + "");
        } catch (e2) {
        }
      }
      return result;
    }
    var arrayProto = Array.prototype;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var coreJsData = root["__core-js_shared__"];
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Symbol2 = root.Symbol;
    var splice = arrayProto.splice;
    var Map2 = getNative(root, "Map");
    var nativeCreate = getNative(Object, "create");
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function Hash(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      return getMapData(this, key)["delete"](key);
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseGet(object, path) {
      path = isKey(path, object) ? [path] : castPath(path);
      var index = 0, length = path.length;
      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return index && index == length ? object : void 0;
    }
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    function castPath(value) {
      return isArray(value) ? value : stringToPath(value);
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    var stringToPath = memoize(function(string) {
      string = toString(string);
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push("");
      }
      string.replace(rePropName, function(match83, number, quote, string2) {
        result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match83);
      });
      return result;
    });
    function toKey(value) {
      if (typeof value == "string" || isSymbol(value)) {
        return value;
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e2) {
        }
        try {
          return func + "";
        } catch (e2) {
        }
      }
      return "";
    }
    function memoize(func, resolver) {
      if (typeof func != "function" || resolver && typeof resolver != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache)();
      return memoized;
    }
    memoize.Cache = MapCache;
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArray = Array.isArray;
    function isFunction(value) {
      var tag = isObject(value) ? objectToString.call(value) : "";
      return tag == funcTag || tag == genTag;
    }
    function isObject(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
    }
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    function get(object, path, defaultValue) {
      var result = object == null ? void 0 : baseGet(object, path);
      return result === void 0 ? defaultValue : result;
    }
    module2.exports = get;
  }
});

// ../i11n/dist/index.js
var require_dist = __commonJS({
  "../i11n/dist/index.js"(exports2, module2) {
    "use strict";
    var __create2 = Object.create;
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __getProtoOf2 = Object.getPrototypeOf;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toESM2 = (mod, isNodeMode, target) => (target = mod != null ? __create2(__getProtoOf2(mod)) : {}, __copyProps2(
      // If the importer is in node compatibility mode or this is not an ESM
      // file that has been converted to a CommonJS file using a Babel-
      // compatible transform (i.e. "__esModule" has not been set), then set
      // "default" to the CommonJS "module.exports" for node compatibility.
      isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
      mod
    ));
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var i11n_exports = {};
    __export2(i11n_exports, {
      translate: () => translate7,
      useTranslations: () => useTranslations
    });
    module2.exports = __toCommonJS2(i11n_exports);
    var import_lodash = __toESM2(require_lodash());
    var es_exports = {};
    __export2(es_exports, {
      "/autoinspector-inspections": () => _autoinspector_inspections,
      "/catalog": () => _catalog,
      "/claims": () => _claims,
      "/companies": () => _companies,
      "/complaints": () => _complaints,
      "/customer-organizations": () => _customer_organizations,
      "/document-types": () => _document_types,
      "/fraud-investigations": () => _fraud_investigations,
      "/geo": () => _geo,
      "/integrations": () => _integrations,
      "/metrics": () => _metrics,
      "/metrics/experimental": () => _metrics_experimental,
      "/metrics/performance": () => _metrics_performance,
      "/orders": () => _orders,
      "/provider-invitations": () => _provider_invitations,
      "/providers": () => _providers,
      "/recordings": () => _recordings,
      "/release-notes": () => _release_notes,
      "/reviews": () => _reviews,
      "/users": () => _users,
      actions: () => actions,
      activity: () => activity,
      agreementRules: () => agreementRules,
      agreementSettings: () => agreementSettings,
      agreementSignatureRules: () => agreementSignatureRules,
      agreementTemplates: () => agreementTemplates,
      agreementVariables: () => agreementVariables2,
      autoinspectorInspections: () => autoinspectorInspections,
      backends: () => backends,
      backofficeCustomerOrganizations: () => backofficeCustomerOrganizations,
      backofficeOrders: () => backofficeOrders,
      backofficeProviders: () => backofficeProviders,
      backofficeReleaseNotes: () => backofficeReleaseNotes,
      bid: () => bid,
      branches: () => branches,
      breadcrumb: () => breadcrumb,
      catalog: () => catalog,
      chart: () => chart,
      circulation: () => circulation,
      claim: () => claim,
      "claim.address.label": () => claim_address_label,
      "claim.city.label": () => claim_city_label,
      "claim.country.label": () => claim_country_label,
      "claim.cuit.label": () => claim_cuit_label,
      "claim.first_name.label": () => claim_first_name_label,
      "claim.identification.label": () => claim_identification_label,
      "claim.identification_type.label": () => claim_identification_type_label,
      "claim.last_name.label": () => claim_last_name_label,
      "claim.properties.damage.driver.first_name": () => claim_properties_damage_driver_first_name,
      "claim.properties.damage.driver.last_name": () => claim_properties_damage_driver_last_name,
      "claim.properties.damage.hasInsurance": () => claim_properties_damage_hasInsurance,
      "claim.properties.damage.type": () => claim_properties_damage_type,
      "claim.properties.driver.owner": () => claim_properties_driver_owner,
      "claim.properties.driver.ownership": () => claim_properties_driver_ownership,
      "claim.properties.driver.ownership.owner": () => claim_properties_driver_ownership_owner,
      "claim.properties.insurance.coverage": () => claim_properties_insurance_coverage,
      "claim.properties.insurance.coverage.third_full": () => claim_properties_insurance_coverage_third_full,
      "claim.properties.insurance.insurer": () => claim_properties_insurance_insurer,
      "claim.properties.insurance.policy_number": () => claim_properties_insurance_policy_number,
      "claim.properties.vehicle.category": () => claim_properties_vehicle_category,
      "claim.properties.vehicle.category.with_license_plate": () => claim_properties_vehicle_category_with_license_plate,
      "claim.properties.vehicle.chassis": () => claim_properties_vehicle_chassis,
      "claim.properties.vehicle.document_type": () => claim_properties_vehicle_document_type,
      "claim.properties.vehicle.document_type.title": () => claim_properties_vehicle_document_type_title,
      "claim.properties.vehicle.engine": () => claim_properties_vehicle_engine,
      "claim.properties.vehicle.license_plate": () => claim_properties_vehicle_license_plate,
      "claim.properties.vehicle.make": () => claim_properties_vehicle_make,
      "claim.properties.vehicle.model": () => claim_properties_vehicle_model,
      "claim.properties.vehicle.type": () => claim_properties_vehicle_type,
      "claim.properties.vehicle.type.car": () => claim_properties_vehicle_type_car,
      "claim.properties.vehicle.use": () => claim_properties_vehicle_use,
      "claim.properties.vehicle.version": () => claim_properties_vehicle_version,
      "claim.properties.vehicle.year": () => claim_properties_vehicle_year,
      "claim.social_reason.label": () => claim_social_reason_label,
      "claim.state.label": () => claim_state_label,
      "claim.type.label": () => claim_type_label,
      "claim.victim_relationship.label": () => claim_victim_relationship_label,
      "claim.victim_relationship.own": () => claim_victim_relationship_own,
      "claim.zip_code.label": () => claim_zip_code_label,
      claimCurrentOrder: () => claimCurrentOrder,
      claimOrderTracking: () => claimOrderTracking,
      claimSharedDocuments: () => claimSharedDocuments,
      claim_ownership_transfer: () => claim_ownership_transfer,
      claim_status_locked_by_derivation: () => claim_status_locked_by_derivation,
      claimantPendingActions: () => claimantPendingActions,
      claimant_victim_violation: () => claimant_victim_violation,
      claimants: () => claimants,
      claims: () => claims,
      claims_table: () => claims_table,
      company: () => company,
      "company-enums.agencies": () => company_enums_agencies,
      "company-enums.claim_public_status": () => company_enums_claim_public_status,
      "company-enums.claim_reference": () => company_enums_claim_reference,
      "company-enums.claim_stage": () => company_enums_claim_stage,
      "company-enums.claim_status": () => company_enums_claim_status,
      "company-enums.claim_status_order_rule": () => company_enums_claim_status_order_rule,
      "company-enums.claim_type": () => company_enums_claim_type,
      "company-enums.complaint_public_status": () => company_enums_complaint_public_status,
      "company-enums.complaint_reference": () => company_enums_complaint_reference,
      "company-enums.complaint_stage": () => company_enums_complaint_stage,
      "company-enums.complaint_status": () => company_enums_complaint_status,
      "company-enums.complaint_status_order_rule": () => company_enums_complaint_status_order_rule,
      "company-enums.ramos": () => company_enums_ramos,
      "company-service": () => company_service,
      complaint: () => complaint,
      contact: () => contact,
      contract: () => contract,
      cost: () => cost,
      coverages: () => coverages,
      currencies: () => currencies,
      customerAccountSettings: () => customerAccountSettings,
      customerClaims: () => customerClaims,
      customer_organization_invitation: () => customer_organization_invitation,
      customer_signin_as: () => customer_signin_as,
      damages: () => damages,
      "damages.material.real_property": () => damages_material_real_property,
      "damages.material.vehicle": () => damages_material_vehicle,
      default: () => es_default2,
      delta: () => delta,
      demoempleo: () => demoempleo,
      distribution: () => distribution,
      document: () => document2,
      documentAnalysis: () => documentAnalysis,
      documentTypes: () => documentTypes,
      documents: () => documents,
      "driver-ownership": () => driver_ownership,
      engagements: () => engagements,
      entities: () => entities,
      entrypoint: () => entrypoint,
      entrypoints: () => entrypoints,
      errors: () => errors,
      "estimates-definition": () => estimates_definition,
      events: () => events,
      "exported-report": () => exported_report,
      field_adjuster_registration: () => field_adjuster_registration,
      field_mapping_config: () => field_mapping_config,
      fileRequest: () => fileRequest,
      file_types: () => file_types,
      filters: () => filters,
      filtersPanel: () => filtersPanel,
      fractures: () => fractures,
      fraud: () => fraud,
      "fraud-investigation-case": () => fraud_investigation_case,
      fraud_investigations: () => fraud_investigations,
      frequency: () => frequency,
      gamma: () => gamma,
      geo: () => geo,
      home: () => home,
      idCardScan: () => idCardScan,
      "identification-type": () => identification_type,
      "inhouse-lawyer": () => inhouse_lawyer,
      injuries: () => injuries,
      inspection: () => inspection,
      integrations: () => integrations,
      legalPersonType: () => legalPersonType,
      legal_person: () => legal_person,
      license: () => license,
      load_balance_rule: () => load_balance_rule,
      "local-insured-relationships": () => local_insured_relationships,
      materialDamage: () => materialDamage,
      message_template: () => message_template,
      metrics: () => metrics,
      network: () => network,
      notifications: () => notifications,
      occurrence: () => occurrence,
      offer: () => offer,
      offerAgreement: () => offerAgreement,
      onboarding: () => onboarding,
      openai_decision: () => openai_decision,
      operators: () => operators,
      orderClaimStatusMappings: () => orderClaimStatusMappings,
      orderDocumentRequirements: () => orderDocumentRequirements,
      orders: () => orders,
      parents: () => parents,
      "payment-method": () => payment_method,
      permissions: () => permissions,
      person: () => person,
      productImport: () => productImport,
      products: () => products,
      professions: () => professions,
      providerAccountSettings: () => providerAccountSettings,
      providerGroups: () => providerGroups,
      providerInvitations: () => providerInvitations,
      provider_registration: () => provider_registration,
      provider_signin_as: () => provider_signin_as,
      real_property: () => real_property,
      recordings: () => recordings,
      "release-notes": () => release_notes,
      resources: () => resources,
      review: () => review,
      reviews: () => reviews,
      rfp: () => rfp,
      role: () => role,
      severities: () => severities,
      sex: () => sex,
      sidebar: () => sidebar,
      sinister: () => sinister,
      sla: () => sla,
      stats: () => stats,
      "style-config": () => style_config,
      "target-group": () => target_group,
      "team-management": () => team_management,
      teams: () => teams,
      test_environment: () => test_environment,
      "trigger-mappings": () => trigger_mappings,
      type: () => type,
      use_cases: () => use_cases,
      user: () => user,
      "validation-pattern": () => validation_pattern,
      validations: () => validations,
      variable: () => variable,
      vehicle: () => vehicle,
      "victim-injuries-roles": () => victim_injuries_roles,
      victim_relationship: () => victim_relationship,
      webhook: () => webhook,
      "working-days": () => working_days,
      zod: () => zod
    });
    var claim_status_locked_by_derivation = "El estado no puede cambiarse mientras el reclamo est\xE9 derivado. Devolv\xE9 la derivaci\xF3n primero.";
    var autoinspectorInspections = {
      title: "Inspecciones Autoinspector",
      description: "Diagn\xF3stico interno: todas las inspecciones creadas desde Piramid.",
      entityLabel: "inspecciones",
      filters: {
        dateFrom: "Desde",
        dateTo: "Hasta",
        status: "Estado",
        result: "Resultado",
        company: "Compa\xF1\xEDa",
        template: "Plantilla",
        useCase: "Caso de uso",
        search: "ID externo o de entidad (prefijo)",
        clear: "Limpiar",
        all: "Todos"
      },
      stats: {
        total: "Inspecciones",
        byStatus: "Por estado",
        byResult: "Por resultado global",
        files: "Archivos enviados"
      },
      status: {
        created: "Creada",
        started: "Iniciada",
        blocked: "Bloqueada",
        processing: "Procesando",
        completed: "Completada"
      },
      result: {
        approved: "Aprobada",
        disapproved: "Desaprobada",
        error: "Error",
        none: "Sin resultado"
      },
      verdicts: {
        approved: "aprobados",
        needs_review: "a revisar",
        disapproved: "desaprobados",
        no_result: "sin resultado"
      },
      columns: {
        date: "Fecha",
        company: "Compa\xF1\xEDa / plantilla",
        useCase: "Caso de uso",
        correlation: "Entidad",
        externalId: "ID externo",
        status: "Estado",
        result: "Resultado",
        files: "Archivos",
        body: "Body"
      },
      deletedTemplate: "(eliminada)",
      body: {
        view: "Ver",
        title: "Cuerpos de la inspecci\xF3n",
        request: "Enviado a Autoinspector",
        response: "\xDAltimo payload recibido",
        copy: "Copiar",
        empty: "Sin body registrado"
      }
    };
    var documentAnalysis = {
      approved: "Documentaci\xF3n validada por Autoinspector",
      needsReview: "Autoinspector recomienda revisi\xF3n",
      disapproved: "Autoinspector detect\xF3 irregularidades",
      noResult: "Enviado a Autoinspector, resultado pendiente",
      inferences: {
        ia_detectada_images: "Creaci\xF3n o alteraci\xF3n con IA",
        similitud_web_images: "Imagen similar en la web",
        pdf_forgery_verdict: "Documento PDF alterado",
        pdf_forgery_trust_score: "Baja confianza de integridad del PDF",
        unknown: "Irregularidad detectada"
      }
    };
    var providerInvitations = {
      title: "Invitaciones a proveedores",
      description: "Todas las invitaciones enviadas por las aseguradoras",
      search_placeholder: "Buscar por email o nombre..."
    };
    var backofficeCustomerOrganizations = {
      title: "Organizaciones",
      description: "Organizaciones que agrupan usuarios reclamantes (call centers, centros de toma de denuncias, etc.)",
      entityLabel: "organizaciones",
      search_placeholder: "Buscar por nombre o CUIT...",
      create: "Crear organizaci\xF3n",
      create_title: "Nueva organizaci\xF3n",
      create_description: "Los usuarios de la organizaci\xF3n comparten la gesti\xF3n de todos sus reclamos.",
      created: "Organizaci\xF3n creada correctamente",
      columns: {
        id: "ID",
        name: "Nombre organizaci\xF3n",
        ein: "CUIT",
        users: "Usuarios",
        claims: "Reclamos",
        createdAt: "Fecha alta",
        actions: "Acciones"
      },
      view_detail: "Ver detalle",
      fields: {
        name: "Nombre",
        ein: "CUIT",
        email: "Email",
        first_name: "Nombre",
        last_name: "Apellido",
        phone: "Tel\xE9fono",
        contact_email: "Email de contacto",
        address: "Direcci\xF3n",
        tenant: "Aseguradora"
      },
      placeholders: {
        name: "Nombre de la organizaci\xF3n",
        ein: "CUIT de la organizaci\xF3n",
        email: "Email del usuario",
        first_name: "Nombre del usuario",
        last_name: "Apellido del usuario",
        phone: "Tel\xE9fono de contacto",
        contact_email: "contacto@organizacion.com",
        address: "Direcci\xF3n de la organizaci\xF3n",
        tenant: "Busc\xE1 la aseguradora..."
      },
      detail: {
        edit: "Editar",
        edit_title: "Editar organizaci\xF3n",
        edit_description: "Modific\xE1 el nombre o el CUIT de la organizaci\xF3n.",
        save: "Guardar cambios",
        updated: "Organizaci\xF3n actualizada correctamente",
        logo_title: "Logo",
        logo_description: "Se muestra en el men\xFA lateral del portal del cliente para los usuarios de la organizaci\xF3n.",
        logo_updated: "Logo actualizado correctamente",
        users_title: "Usuarios",
        users_description: "Todos los usuarios comparten los reclamos de la empresa",
        add_user: "Crear con contrase\xF1a temporal",
        add_user_title: "Nuevo usuario",
        add_user_description: "Se crea un usuario reclamante dentro de la empresa con una contrase\xF1a temporal. Prefer\xED la invitaci\xF3n por email: la contrase\xF1a temporal hay que comunicarla a mano.",
        link_user: "Vincular existente",
        link_user_title: "Vincular usuario existente",
        link_user_description: "El usuario debe ser un reclamante sin empresa. Sus reclamos previos siguen siendo personales y no se comparten con la empresa.",
        link_user_search: "Buscar",
        link_user_confirm: "Confirmar vinculaci\xF3n",
        link_user_found: "Usuario encontrado",
        link_user_personal_claims: "Reclamos personales (no se comparten): {{count}}",
        link_user_already_linked: "Este usuario ya pertenece a {{organization}} y no puede vincularse.",
        link_user_not_third: "Este usuario no es un reclamante y no puede vincularse.",
        linked: "Usuario vinculado correctamente",
        unlink_user: "Desvincular",
        unlink_user_title: "Desvincular usuario",
        unlink_user_description: "Los reclamos de la organizaci\xF3n que este usuario tenga a su nombre se reasignan a otro miembro; sus reclamos personales se van con \xE9l.",
        unlink_user_transfer_to: "Reasignar reclamos a",
        unlink_user_transfer_placeholder: "Eleg\xED un miembro",
        unlink_user_transfer_none: "No hay otros miembros para reasignar",
        unlink_user_owns_claims: "El usuario tiene {{count}} reclamo(s) de la organizaci\xF3n a su nombre: eleg\xED a qui\xE9n reasignarlos.",
        unlink_user_confirm: "Confirmar desvinculaci\xF3n",
        unlinked: "Usuario desvinculado correctamente",
        unlinked_with_claims: "Usuario desvinculado; se reasignaron {{count}} reclamo(s)",
        user_created: "Usuario creado correctamente",
        invite_user: "Invitar usuario",
        invite_user_title: "Invitar usuario",
        invite_user_description: "Recibe un email con un enlace para crear su propia contrase\xF1a en el portal de la aseguradora elegida. El enlace vence en 7 d\xEDas.",
        invite_user_confirm: "Enviar invitaci\xF3n",
        invited: "Invitaci\xF3n enviada correctamente",
        invitations_title: "Invitaciones",
        invitations_description: "Invitaciones enviadas que a\xFAn no fueron aceptadas",
        invitations_empty: "No hay invitaciones pendientes",
        tenant_empty: "No se encontraron aseguradoras",
        sign_in_as: "Sign in",
        sign_in_as_title: "Iniciar sesi\xF3n como el usuario",
        sign_in_as_description: "Se abre el portal del cliente de la aseguradora elegida en una pesta\xF1a nueva, con la sesi\xF3n de este usuario.",
        sign_in_as_confirm: "Abrir sesi\xF3n",
        invitation_status: {
          pending: "Pendiente",
          accepted: "Aceptada",
          cancelled: "Cancelada",
          expired: "Vencida"
        },
        resend_invitation: "Reenviar",
        resent: "Invitaci\xF3n reenviada correctamente",
        cancel_invitation: "Cancelar",
        cancel_invitation_title: "Cancelar invitaci\xF3n",
        cancel_invitation_description: "El enlace enviado deja de funcionar. Pod\xE9s volver a invitar al mismo email m\xE1s adelante.",
        cancel_invitation_confirm: "Cancelar invitaci\xF3n",
        invitation_cancelled: "Invitaci\xF3n cancelada",
        invitation_columns: {
          user: "Usuario",
          tenant: "Aseguradora",
          status: "Estado",
          expires_at: "Vence",
          sent_count: "Env\xEDos",
          actions: "Acciones"
        },
        credentials_title: "Credenciales temporales",
        credentials_description: "Guardalas ahora: la contrase\xF1a no vuelve a mostrarse. El usuario inicia sesi\xF3n con su email y esta contrase\xF1a en el portal del cliente.",
        credentials_email: "Email",
        credentials_password: "Contrase\xF1a",
        verified: "Verificado",
        pending_verification: "Pendiente"
      }
    };
    var backofficeReleaseNotes = {
      title: "Novedades",
      description: "Qu\xE9 alcance tuvo cada nota en una compa\xF1\xEDa, qui\xE9n la ley\xF3 y qu\xE9 hizo despu\xE9s.",
      "pick-company": "Eleg\xED una compa\xF1\xEDa para ver sus lecturas.",
      empty: "Todav\xEDa no hay notas cargadas.",
      status: {
        draft: "Borrador",
        published: "Publicada"
      },
      unavailable: "No disponible",
      "unavailable-hint": "La compa\xF1\xEDa no tiene la flag que pide la nota.",
      hidden: "Oculta",
      "hidden-hint": "Los usuarios no la ven hasta que se vuelva a hacer visible.",
      unpublished: "Sin publicar",
      visibility: {
        label: "Visible",
        hint: "Apagalo para que los usuarios de todas las compa\xF1\xEDas dejen de verla, sin despublicarla.",
        shown: "Nota visible para los usuarios",
        hidden: "Nota oculta para los usuarios"
      },
      columns: {
        note: "Nota",
        published: "Publicada",
        visible: "Visible",
        recipients: "Destinatarios",
        reach: "Alcance",
        others: "Otros lectores",
        demos: "Probaron una demo",
        feedback: "\xDAtil / no \xFAtil",
        user: "Usuario",
        role: "Rol",
        teams: "Equipos",
        recipient: "Destinatario",
        "first-read": "Primera lectura",
        "last-read": "\xDAltima lectura",
        "read-time": "Tiempo de lectura",
        items: "Novedades vistas",
        "demo-interactions": "Acciones en demos",
        type: "Evento",
        when: "Cu\xE1ndo",
        target: "Sobre",
        data: "Datos",
        "last-notice": "\xDAltimo aviso"
      },
      reach: "{{readers}} de {{audience}}",
      "not-sent": "Sin enviar",
      "recipient-yes": "S\xED",
      "recipient-no": "No",
      send: {
        button: "Enviar a la compa\xF1\xEDa",
        "add-button": "Agregar roles",
        title: "Enviar \xAB{{title}}\xBB",
        description: "Eleg\xED los roles de la compa\xF1\xEDa que reciben la nota. Sus usuarios pasan a ser los destinatarios: contra ellos se mide el alcance.",
        roles: "Roles",
        "role-users": "{{users}} usuarios",
        already: "Ya enviada a {{count}} destinatarios; los roles nuevos se suman.",
        notify: "Avisar por mail a los destinatarios nuevos",
        confirm: "Enviar",
        cancel: "Cancelar",
        sent: "Enviada a {{added}} destinatarios nuevos ({{notified}} avisados por mail)",
        nothing: "Esos roles no suman destinatarios nuevos.",
        "no-roles": "La compa\xF1\xEDa no tiene roles con usuarios."
      },
      kpi: {
        reach: "Alcance",
        "reach-hint": "{{readers}} de {{audience}} destinatarios la abrieron",
        "days-to-read": "Tiempo hasta leerla",
        "days-to-read-hint": "Mediana desde la publicaci\xF3n",
        "read-time": "Tiempo de lectura",
        "read-time-hint": "Mediana con la nota en pantalla",
        demos: "Probaron una demo",
        "demos-hint": "{{users}} lectores",
        feedback: "Les result\xF3 \xFAtil",
        "feedback-hint": "{{helpful}} s\xED \xB7 {{unhelpful}} no",
        "feedback-help": "{{unanswered}} de {{readers}} lectores no contestaron si les result\xF3 \xFAtil.",
        none: "\u2014"
      },
      tabs: {
        preview: "Vista previa",
        readers: "Lectores",
        pending: "Pendientes",
        adoption: "Adopci\xF3n",
        events: "Eventos"
      },
      format: {
        copy: "Copiar formato",
        copied: "Copiado",
        "copy-error": "No se pudo copiar el formato.",
        "note-hint": "Copi\xE1 el formato y pedile a tu agente que adapte la release note a ese JSON antes de subirlo."
      },
      help: "C\xF3mo se calcula",
      adoption: {
        empty: "Esta nota no define m\xE9tricas de adopci\xF3n.",
        window: "Valores semanales: {{before}} semanas antes del lanzamiento, en gris, y desde el lanzamiento hasta hoy, en naranja. El n\xFAmero grande resume las semanas desde el lanzamiento y \xABAntes\xBB las previas; cada valor dice cu\xE1ntos casos tiene detr\xE1s. La nota se envi\xF3 a {{recipients}} destinatarios de la compa\xF1\xEDa.",
        "no-data": "Sin datos",
        cases: "{{cases}} casos",
        before: "Antes: {{value}}",
        "before-none": "Antes: sin datos",
        summary: {
          weekly_average: "promedio por semana",
          share: "sobre el total del per\xEDodo",
          median: "mediana de todos los casos",
          latest: "\xFAltima lectura"
        },
        direction: {
          up: "\u2191 subir",
          down: "\u2193 bajar",
          flat: "observar"
        },
        units: {
          minutes: "{{value}} min",
          hours: "{{value}} h",
          days: "{{value}} d"
        }
      },
      "readers-empty": "Nadie la abri\xF3 todav\xEDa.",
      "pending-empty": "Todos los destinatarios la abrieron.",
      "pending-count": "{{count}} destinatarios todav\xEDa no la abrieron.",
      "events-empty": "Sin eventos registrados.",
      "events-all": "Todos los eventos",
      "load-more": "Cargar m\xE1s",
      notify: {
        button: "Avisar por mail a los pendientes",
        title: "\xBFEnviar el aviso por mail?",
        description: "Se env\xEDa un mail a los {{count}} destinatarios que todav\xEDa no abrieron la nota, con el link para leerla.",
        confirm: "Enviar",
        cancel: "Cancelar",
        sent: "Aviso enviado a {{count}} personas",
        none: "No hab\xEDa nadie a quien avisar."
      },
      "view-note": "Ver la nota",
      back: "Volver a Novedades",
      days: "{{days}} d",
      minutes: "{{minutes}} min",
      "items-of": "{{viewed}} de {{total}}",
      preview: {
        hint: "As\xED la ven los usuarios de la compa\xF1\xEDa. Las demos interactivas s\xF3lo se ven en la app.",
        draft: "Borrador: todav\xEDa no la ve nadie. Revisala ac\xE1 y publicala cuando est\xE9 lista."
      },
      import: {
        button: "Importar nota",
        title: "Importar una nota",
        description: "Un archivo JSON con el formato de las notas, el mismo que escribe el comando /release-note. Entra como borrador: se revisa en la vista previa y despu\xE9s se publica.",
        file: "Archivo",
        "invalid-json": "El archivo no es un JSON v\xE1lido.",
        invalid: "El archivo no tiene el formato de una nota:",
        summary: "{{slug}} \xB7 {{items}} novedades",
        confirm: "Importar",
        cancel: "Cancelar",
        created: "Nota importada como borrador",
        replaced: "Borrador actualizado"
      },
      publish: {
        button: "Publicar",
        title: "\xBFPublicar \xAB{{title}}\xBB?",
        description: "Desde ahora la ven los usuarios de las compa\xF1\xEDas con las flags que pide. Despu\xE9s hay que enviarla a cada compa\xF1\xEDa para fijar destinatarios y avisar por mail.",
        confirm: "Publicar",
        cancel: "Cancelar",
        done: "Nota publicada"
      },
      delete: {
        button: "Eliminar borrador",
        title: "\xBFEliminar el borrador \xAB{{title}}\xBB?",
        description: "Se borra la nota con sus novedades. Se puede volver a importar.",
        confirm: "Eliminar",
        cancel: "Cancelar",
        done: "Borrador eliminado"
      }
    };
    var backofficeProviders = {
      title: "Proveedores",
      description: "Empresas proveedoras registradas (datos de la empresa y del proveedor)",
      entityLabel: "proveedores",
      search_placeholder: "Buscar por raz\xF3n social, email o CUIT...",
      columns: {
        legalName: "Raz\xF3n social",
        email: "Email",
        ein: "CUIT",
        phone: "Tel\xE9fono",
        source: "Origen",
        onboarding: "Onboarding",
        country: "Pa\xEDs",
        createdAt: "Alta"
      },
      source: {
        invited: "Invitado",
        csv: "CSV",
        marketplace: "Auto-registro"
      },
      onboarding: {
        completed: "Completo",
        pending: "Pendiente"
      },
      detail: "Detalle",
      detail_title: "Detalle del proveedor",
      detail_description: "Datos del proveedor, sus sucursales y sus usuarios",
      sections: {
        branches: "Sucursales",
        users: "Usuarios"
      },
      branches: {
        name: "Nombre",
        address: "Direcci\xF3n",
        locality: "Localidad",
        phones: "Tel\xE9fonos",
        emails: "Emails",
        central: "Central",
        empty: "Este proveedor no tiene sucursales cargadas."
      },
      users: {
        name: "Nombre",
        type: "Tipo",
        status: "Estado",
        createdAt: "Registro",
        verified: "Verificado",
        pending_verification: "Pendiente",
        sign_in_as: "Sign in",
        popup_blocked: "El navegador bloque\xF3 la pesta\xF1a nueva. Habilit\xE1 las ventanas emergentes para este sitio y volv\xE9 a intentar.",
        empty: "Este proveedor no tiene usuarios."
      }
    };
    var customer_signin_as = {
      loading: "Iniciando sesi\xF3n...",
      error_title: "Error de autenticaci\xF3n",
      error_description: "No pudimos iniciar la sesi\xF3n. El enlace puede haber vencido: ped\xED uno nuevo desde el Backoffice.",
      go_to_login: "Ir al login"
    };
    var customer_organization_invitation = {
      title: "Sumate a {{organization}}",
      description: "{{organization}} te invit\xF3 a gestionar sus reclamos en el portal de {{tenant}}. Cre\xE1 tu contrase\xF1a para activar tu cuenta.",
      email_label: "Email",
      password_label: "Contrase\xF1a",
      password_confirmation_label: "Confirmar contrase\xF1a",
      submit: "Activar mi cuenta",
      expired_title: "Esta invitaci\xF3n venci\xF3",
      expired_description: "Pedile a quien te invit\xF3 que la reenv\xEDe para recibir un enlace nuevo.",
      invalid_title: "Esta invitaci\xF3n no es v\xE1lida",
      invalid_description: "El enlace ya fue usado o cancelado. Si cre\xE9s que es un error, ped\xED que te reenv\xEDen la invitaci\xF3n."
    };
    var provider_registration = {
      title: "Complet\xE1 tu registro en Piramid.",
      description: "Cre\xE1 tu cuenta de proveedor para sumarte a la red.",
      invitedBy: "{{company}} te invit\xF3 a su red.",
      emailLabel: "Email",
      emailPlaceholder: "proveedor@empresa.com",
      emailDescription: "Este email ser\xE1 utilizado para acceder a la plataforma.",
      firstNameLabel: "Nombre",
      firstNamePlaceholder: "Tu nombre",
      lastNameLabel: "Apellido",
      lastNamePlaceholder: "Tu apellido",
      passwordLabel: "Contrase\xF1a",
      passwordPlaceholder: "M\xEDnimo 8 caracteres",
      confirmPasswordLabel: "Confirmar contrase\xF1a",
      confirmPasswordPlaceholder: "Repet\xED la contrase\xF1a",
      passwordsDontMatch: "Las contrase\xF1as no coinciden",
      legalNameLabel: "Raz\xF3n social",
      legalNamePlaceholder: "Nombre legal de la empresa",
      einLabel: "CUIT",
      einPlaceholder: "CUIT de la empresa (sin guiones)",
      einDescription: "El CUIT es necesario para la verificaci\xF3n de la empresa.",
      phoneLabel: "Tel\xE9fono (opcional)",
      phonePlaceholder: "Ej. 11 5555 5555",
      submit: "Crear cuenta",
      invalidTokenTitle: "Invitaci\xF3n inv\xE1lida o vencida",
      invalidTokenDescription: "El enlace de invitaci\xF3n no es v\xE1lido o ya expir\xF3. Ped\xED a la aseguradora que te reenv\xEDe la invitaci\xF3n.",
      backToLogin: "Volver al inicio de sesi\xF3n"
    };
    var engagements = {
      title: "Compa\xF1\xEDas vinculadas",
      description: "Consult\xE1 las compa\xF1\xEDas vinculadas a tu empresa y respond\xE9 las invitaciones pendientes.",
      entityLabel: "compa\xF1\xEDas",
      columns: {
        insurer: "Compa\xF1\xEDa",
        ein: "CUIT",
        status: "Estado",
        createdAt: "Fecha invitaci\xF3n",
        actions: "Acciones"
      },
      actions: {
        accept: "Aceptar invitaci\xF3n",
        accepted: "Invitaci\xF3n aceptada",
        reject: "Rechazar invitaci\xF3n",
        rejected: "Invitaci\xF3n rechazada",
        cancel: "Cancelar",
        confirm: {
          accept: {
            title: "\xBFAceptar la invitaci\xF3n?",
            description: "Vas a aceptar la relaci\xF3n comercial con {{insurer}}. Podr\xE1s empezar a recibir su trabajo.",
            action: "S\xED, aceptar"
          },
          reject: {
            title: "\xBFRechazar la invitaci\xF3n?",
            description: "Vas a rechazar la relaci\xF3n comercial con {{insurer}}. Esta acci\xF3n no se puede deshacer.",
            action: "S\xED, rechazar"
          }
        }
      }
    };
    var branches = {
      title: "Registro de sucursales",
      description: "Administr\xE1 las sucursales de tu empresa con su ubicaci\xF3n precisa en el mapa.",
      entityLabel: "sucursales",
      create: "Crear sucursal",
      viewMap: "Ver mapa",
      columns: {
        name: "Nombre",
        locality: "Localidad",
        address: "Direcci\xF3n",
        central: "Central",
        centralYes: "Central"
      },
      type: {
        central: "Central",
        regular: "Sucursal"
      },
      detail: {
        locality: "Localidad",
        address: "Direcci\xF3n",
        phones: "Tel\xE9fonos",
        emails: "Emails",
        empty: "\u2014"
      },
      map: {
        title: "Sucursales en el mapa",
        empty: "No hay sucursales para mostrar."
      },
      actions: {
        edit: "Editar",
        delete: "Eliminar",
        deleted: "Sucursal eliminada",
        confirm: {
          delete: {
            title: "\xBFEliminar la sucursal?",
            description: 'Vas a eliminar la sucursal "{{name}}". Esta acci\xF3n no se puede deshacer.',
            cancel: "Cancelar",
            action: "S\xED, eliminar"
          }
        }
      },
      form: {
        createTitle: "Nueva sucursal",
        editTitle: "Editar sucursal",
        name: "Nombre",
        namePlaceholder: "Ej: Casa central",
        locality: "Localidad",
        localityPlaceholder: "Busc\xE1 una localidad...",
        noResults: "Sin resultados",
        address: "Direcci\xF3n",
        addressPlaceholder: "Av. San Mart\xEDn 123",
        location: "Ubicaci\xF3n en el mapa",
        mapHint: "Hac\xE9 click en el mapa para marcar la ubicaci\xF3n exacta. Pod\xE9s arrastrar el pin para ajustarlo.",
        mapSelectLocalityHint: "Seleccion\xE1 una localidad para ubicar la sucursal en el mapa.",
        phones: "Tel\xE9fonos",
        phonePlaceholder: "Tel\xE9fono",
        addPhone: "Agregar tel\xE9fono",
        emails: "Emails",
        emailPlaceholder: "Email",
        addEmail: "Agregar email",
        isCentral: "Marcar como sucursal principal",
        cancel: "Cancelar",
        save: "Guardar",
        created: "Sucursal creada",
        updated: "Sucursal actualizada",
        errors: {
          nameRequired: "El nombre es obligatorio",
          localityRequired: "La localidad es obligatoria",
          locationRequired: "Marc\xE1 la ubicaci\xF3n en el mapa",
          invalidEmail: "Email inv\xE1lido"
        }
      }
    };
    var network = {
      entityLabel: "proveedores",
      searchPlaceholder: "Buscar por nombre o email...",
      viewInvitations: "Invitaciones",
      viewMap: "Mapa",
      map: {
        title: "Sucursales de la red",
        description: "Sucursales de los proveedores activos de tu red.",
        empty: "Todav\xEDa no hay sucursales geolocalizadas en tu red.",
        error: "No pudimos cargar las sucursales de tu red.",
        central: "Central",
        branchCount: "{{count}} sucursales",
        truncated: "Mostrando las primeras {{limit}} sucursales de tu red."
      },
      columns: {
        provider: "Proveedor",
        email: "Email proveedor",
        phone: "Tel\xE9fono",
        status: "Estado",
        code: "C\xF3digo",
        name: "Nombre proveedor",
        createdAt: "Fecha alta",
        invitedAt: "Invitado el",
        respondedAt: "Respondido el",
        insurerCompany: "Aseguradora",
        invitedBy: "Invitado por"
      },
      status: {
        pending: "Pendiente",
        active: "Activo",
        rejected: "Rechazado",
        paused: "Pausado",
        suspended: "Suspendido"
      },
      invitationStatus: {
        pending: "Pendiente",
        registered: "Registrado",
        rejected: "Rechazada",
        cancelled: "Anulada",
        expired: "Expirada"
      },
      invite: {
        button: "Invitar proveedor",
        dialogTitle: "Invitar proveedor",
        dialogDescription: "Ingres\xE1 el email del proveedor que quer\xE9s sumar a tu red. El enlace de invitaci\xF3n ser\xE1 v\xE1lido por 7 d\xEDas.",
        emailLabel: "Email",
        emailPlaceholder: "proveedor@empresa.com",
        nameLabel: "Nombre (opcional)",
        namePlaceholder: "Nombre de referencia del proveedor",
        submit: "Enviar invitaci\xF3n",
        successTitle: "Invitaci\xF3n enviada",
        successDescription: "Se envi\xF3 la invitaci\xF3n al proveedor"
      },
      actions: {
        updated: "Estado actualizado",
        active: "Reactivar",
        paused: "Pausar",
        suspended: "Suspender"
      },
      externalId: {
        action: "C\xF3digo interno",
        title: "C\xF3digo interno del proveedor",
        description: "C\xF3digo con el que tu empresa identifica a este proveedor. Dejalo vac\xEDo para quitarlo.",
        label: "C\xF3digo",
        placeholder: "COD-1234",
        save: "Guardar",
        success: "C\xF3digo actualizado"
      },
      invitations: {
        entityLabel: "invitaciones",
        searchPlaceholder: "Buscar por nombre o email...",
        cancel: "S\xED, anular",
        cannotCancel: "Solo se puede anular una invitaci\xF3n pendiente",
        cancelled: "Invitaci\xF3n anulada",
        cancelConfirmTitle: "\xBFAnular invitaci\xF3n?",
        cancelConfirmDescription: "La invitaci\xF3n quedar\xE1 anulada y el proveedor no podr\xE1 utilizarla para sumarse a tu red. Deber\xE1s enviarle una nueva invitaci\xF3n.",
        cancelConfirmBack: "Volver"
      },
      detail: {
        back: "Proveedores",
        identity: {
          ein: "CUIT",
          email: "Email",
          contactEmail: "Email de contacto",
          phone: "Tel\xE9fono",
          address: "Direcci\xF3n",
          locality: "Localidad",
          code: "C\xF3digo interno",
          joinedNetwork: "En tu red desde",
          registeredAt: "Alta en Piramid",
          onboardingComplete: "Onboarding completo",
          noDescription: "El proveedor todav\xEDa no carg\xF3 una descripci\xF3n.",
          onboardingIncomplete: "Onboarding incompleto"
        },
        stats: {
          title: "Desempe\xF1o",
          total: "\xD3rdenes derivadas",
          totalHint: "{{count}} en los \xFAltimos 30 d\xEDas",
          open: "Abiertas",
          openHint: "Pendientes y en curso",
          completed: "Completadas",
          dropped: "Rechazadas o anuladas",
          acceptanceRate: "Tasa de aceptaci\xF3n",
          acceptanceRateHint: "Sobre las \xF3rdenes que el proveedor respondi\xF3",
          timesTitle: "Tiempos y atenci\xF3n",
          avgToAccept: "Tiempo medio hasta aceptaci\xF3n",
          avgToComplete: "Tiempo medio de ciclo",
          avgToCompleteHint: "Desde que el proveedor acepta hasta que finaliz\xE1s la orden. Incluye tu propio tiempo de revisi\xF3n.",
          awaitingProvider: "Esperan al proveedor",
          awaitingInsurer: "Te esperan a vos",
          oldestWait: "Espera m\xE1s antigua del proveedor",
          billed: "Facturado",
          billedHint: "Suma de las \xF3rdenes completadas.",
          trend: "Derivaciones por mes",
          trendHint: "\xDAltimos 12 meses, por mes de derivaci\xF3n",
          trendTotal: "Derivadas",
          trendCompleted: "Completadas",
          trendDropped: "Rechazadas o anuladas",
          empty: "Todav\xEDa no derivaste trabajo a este proveedor.",
          error: "No pudimos cargar las m\xE9tricas del proveedor.",
          noValue: "Sin datos",
          duration: {
            minutes: "{{value}} min",
            hours: "{{value}} h",
            days: "{{value}} d\xEDas"
          }
        },
        branches: {
          title: "Sucursales",
          central: "Central",
          mapEmptyHint: "El proveedor todav\xEDa no carg\xF3 sucursales"
        },
        capabilities: {
          title: "Capacidades",
          description: "Servicios que el proveedor declar\xF3 que puede realizar.",
          allGoods: "Todos los bienes",
          empty: "El proveedor todav\xEDa no declar\xF3 capacidades."
        },
        orders: {
          title: "\xD3rdenes derivadas",
          description: "Todo el trabajo que derivaste a este proveedor.",
          viewAll: "Ver todas",
          searchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
          allStatuses: "Todos los estados",
          empty: "Todav\xEDa no hay \xF3rdenes derivadas a este proveedor.",
          error: "No pudimos cargar las \xF3rdenes del proveedor."
        }
      }
    };
    var use_cases = {
      infer_file_data: "Clasificacion de archivo e inferencia atributos",
      vehicle_id_card_ocr: "Extracci\xF3n de datos de la c\xE9dula de identidad del veh\xEDculo"
    };
    var field_mapping_config = {
      entities: {
        claim: {
          label: "Reclamo"
        }
      },
      fields: {
        external_claim_request_id: {
          label: "N\xFAmero de tramite"
        },
        ref_id: {
          label: "ID de referencia"
        }
      }
    };
    var message_template = {
      roles: {
        automatic_response: "Respuesta autom\xE1tica del chat"
      },
      context_path: {
        claim: {
          ref_id: "ID de referencia",
          external_claim_id: "ID Reclamo Externo",
          id: "ID Reclamo",
          owner: {
            first_name: "Nombre Reclamante Usuario",
            last_name: "Apellido Reclamante Usuario",
            email: "Email Reclamante Usuario"
          },
          sinister: {
            selected_external_complaint: {
              external_id: "N\xFAmero de siniestro"
            },
            policyholder_license_plate: "Patente Asegurado"
          }
        },
        file_request_placeholder_list: "Lista de archivos solicitados",
        file_request_message: "Mensaje de solicitud de archivos"
      },
      scope: {
        offer: "Ofrecimiento",
        communication: "Comunicaci\xF3n"
      }
    };
    var stats = {
      modules: {
        claim: "Reclamos",
        complaint: "Denuncias"
      }
    };
    var chart = {
      frequencies: {
        daily: "Diario",
        weekly: "Semanal",
        monthly: "Mensual"
      }
    };
    var distribution = {
      categories: {
        worst: "peor",
        best: "mejor"
      }
    };
    var trigger_mappings = {
      actions: {
        file_request: "Solicitud de archivo",
        authorize_complaint: "Autorizar denuncia",
        approve_complaint: "Aprobar denuncia",
        reject_complaint: "Rechazar denuncia",
        derive_to_fraud: "Derivar a fraude"
      },
      status: "Estado",
      columns: {
        position: "Orden"
      },
      moveUp: "Subir",
      moveDown: "Bajar",
      statusRole: "Rol: {{role}}"
    };
    var sla = {
      form: {
        types: {
          stage: {
            title: "Etapas"
          },
          reference: {
            title: "Referencias"
          },
          status: {
            title: "Estados"
          }
        }
      },
      columns: {
        sla_expected_time_to_resolution: "Tiempo estipulado",
        sla_current_time_to_resolution: "Tiempo transcurrido",
        sla_type: "Tipo de SLA",
        sla_name: "Nombre de SLA",
        sla_elapsed_duration_criteria: "Criterio de duraci\xF3n",
        sla_version: "Versi\xF3n de SLA",
        relation_type_responsible: "Responsable",
        relation_type_coordinator: "Coordinador",
        relation_type_id: "{{relationTypeLabel}} ID",
        started_at: "Fecha inicio",
        deadline: "Fecha l\xEDmite",
        completed_at: "Fecha finalizaci\xF3n",
        status: "Estado",
        compliance: "Cumplimiento",
        progress: "Progreso",
        sla_objective_reference_name: "Nombre de objetivo"
      },
      metrics: {
        avg: "Promedio",
        max: "M\xE1ximo",
        min: "M\xEDnimo",
        median: "Mediana",
        percentile_25: "Percentil 25",
        percentile_50: "Percentil 50",
        percentile_75: "Percentil 75",
        percentile_80: "Percentil 80",
        percentile_90: "Percentil 90",
        trendline: "Tendencia"
      },
      commitments: {
        time: {
          singular: {
            days: "D\xEDa",
            hours: "Hora"
          },
          plural: {
            days: "D\xEDas",
            hours: "Horas"
          }
        },
        elapsed_duration_criteria: {
          singular: {
            working_days: "h\xE1bil",
            working_hours: "h\xE1bil"
          },
          plural: {
            working_days: "h\xE1biles",
            working_hours: "h\xE1biles"
          }
        }
      },
      virtual_metric: {
        time_to_first_response: {
          name: "Tiempo para primera respuesta",
          description: "Tiempo que se tarda en responder al primer mensaje recibido"
        },
        avg_response_time: {
          name: "Tiempo promedio de respuesta",
          description: "Tiempo promedio de respuesta luego del primer mensaje respondido"
        }
      },
      status: {
        completed: "Completado",
        active: "Activo",
        effective: "Vigente",
        planned: "Planificado",
        expired: "Expirado",
        deactivated: "Desactivado"
      },
      report: {
        status: {
          active: "Activo",
          completed: "Completado"
        },
        compliance: {
          on_time: "A tiempo",
          expired: "Vencido"
        }
      },
      elapsed_duration_criteria: {
        elapsed_days: "D\xEDas corridos",
        working_days: "D\xEDas h\xE1biles",
        elapsed_hours: "Horas corridas",
        working_hours: "Horas h\xE1biles"
      },
      scopes: {
        claim: "Reclamo",
        complaint: "Denuncia"
      },
      types: {
        stage: "Etapa",
        status: "Estado",
        reference: "Referencia",
        chat: "Mensajes"
      }
    };
    var working_days = {
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Mi\xE9rcoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "S\xE1bado",
        sunday: "Domingo"
      }
    };
    var payment_method = {
      cash: "Contado",
      credit: "Cr\xE9dito"
    };
    var estimates_definition = {
      strategies: {
        coverage: "Por cobertura"
      },
      scopes: {
        complaint: "Denuncia"
      }
    };
    var person = {
      type: {
        natural_person: "Persona f\xEDsica",
        legal_person: "Persona jur\xEDdica"
      }
    };
    var entrypoint = {
      special_permissions: {
        sinister_date_limit: "Sin l\xEDmite de fecha de siniestro",
        vehicle_id_card_ocr: "Forzar carga de c\xE9dula del veh\xEDculo",
        recovery_claim: "Forzar carga de reclamo de recuperos"
      },
      environments: {
        production: "Producci\xF3n",
        sandbox: "Sandbox"
      },
      backends: {
        tajy: "Sebaot",
        demoempleo: "Demo Empleo",
        gamma: "Gamma"
      },
      specifications: {
        rivadavia_v2: "Rivadavia V2",
        demoempleo: "Demo Empleo",
        gamma: "Gamma"
      }
    };
    var demoempleo = {
      fields: {
        doc_identity_card: "C\xE9dula de identidad",
        doc_income_verification: "Certificado de cotizaciones (AFP)",
        doc_accounting_certificate: "Finiquito",
        doc_policy_insurance: "Constancia / P\xF3liza de cesant\xEDa"
      }
    };
    var gamma = {
      welcome: {
        title: "Nuevo reclamo",
        description: "Complet\xE1 la informaci\xF3n solicitada para registrar el reclamo en Gamma.",
        start: "Comenzar"
      },
      step: {
        title: "Nuevo reclamo",
        description: "Complet\xE1 todos los datos del reclamo. Se asignar\xE1 N\xB0 de reclamo Piramid al confirmar el ingreso."
      },
      sections: {
        derivation: {
          title: "Datos del siniestro",
          description: "Datos del siniestro en la aseguradora de origen."
        },
        insured: {
          title: "Datos del asegurado",
          description: "Datos de la persona responsable original del reclamo."
        },
        vehicle: {
          title: "Datos del veh\xEDculo",
          description: "Veh\xEDculo afectado por el da\xF1o."
        },
        damage: {
          title: "Datos del da\xF1o",
          description: "Servicio a realizar sobre el veh\xEDculo."
        },
        occurrence: {
          title: "Datos de la ocurrencia del siniestro",
          description: "Cu\xE1ndo y d\xF3nde ocurri\xF3 el hecho."
        },
        franchise: {
          title: "Franquicia",
          description: "Franquicia aplicable seg\xFAn la p\xF3liza."
        },
        documentation: {
          title: "Documentaci\xF3n",
          description: "Adjunt\xE1 la documentaci\xF3n del siniestro. Es opcional; pod\xE9s completarla luego."
        }
      },
      fields: {
        insurer: "Aseguradora",
        origin_sinister_number: "N\xB0 de siniestro/reclamo externo",
        policy_number: "N\xB0 de p\xF3liza (opcional)",
        plan: "Plan (opcional)",
        coverage_amount: "Monto de cobertura (opcional)",
        full_name: "Nombre y apellido",
        identification: "DNI / CUIT",
        birth_date: "Fecha de nacimiento (opcional)",
        marital_status: "Estado civil (opcional)",
        cellphone: "Tel\xE9fono",
        email: "Email",
        address: "Domicilio (opcional)",
        locality: "Localidad (opcional)",
        make: "Marca",
        model: "Modelo",
        year: "A\xF1o",
        version: "Versi\xF3n (opcional)",
        license_plate: "Patente",
        service: "Servicio a realizar",
        good: "Bien afectado",
        repair_locality: "Localidad o zona del servicio",
        damage_description: "Descripci\xF3n del da\xF1o (opcional)",
        date: "Fecha del hecho",
        time: "Hora aproximada",
        place: "Lugar del hecho",
        state: "Provincia del hecho",
        city: "Ciudad",
        zip_code: "C\xF3digo postal",
        story: "Relato del siniestro",
        report_sinister: "Completar informaci\xF3n del siniestro",
        doc_vehicle_id_card_front: "C\xE9dula verde (frente)",
        doc_vehicle_id_card_back: "C\xE9dula verde (dorso)",
        doc_victim_dni_front: "DNI del damnificado (frente)",
        doc_victim_dni_back: "DNI del damnificado (dorso)",
        doc_damage_photos: "Fotos del da\xF1o (veh\xEDculo)",
        documentation: "Documentaci\xF3n"
      },
      documents_status: {
        none: "No cargada",
        partial: "Carga parcial",
        complete: "Carga completa"
      },
      steps: {
        sinister: {
          title: "Datos de la ocurrencia del siniestro",
          description: "Datos de la derivaci\xF3n y del siniestro de origen."
        },
        documents: {
          title: "Documentaci\xF3n",
          description: "Adjunt\xE1 la documentaci\xF3n del siniestro. Es opcional; pod\xE9s completarla luego."
        }
      },
      confirmation: {
        title: "Env\xEDo de reclamo",
        description: "Revis\xE1 que los datos ingresados sean correctos. Si necesit\xE1s corregirlos, pod\xE9s volver hacia atr\xE1s."
      }
    };
    var target_group = {
      scopes: {
        derivation: "Derivaci\xF3n",
        assignment: "Asignaci\xF3n"
      }
    };
    var actions = {
      show: "Mostrar"
    };
    var operators = {
      equals: "="
    };
    var delta = {
      actions: {
        change: "Actualizaci\xF3n",
        remove: "Eliminaci\xF3n",
        create: "Definici\xF3n"
      }
    };
    var offer = {
      status: {
        expired: "Expirada",
        rejected: "Rechazado",
        archived: "Archivada",
        draft: "Borrador",
        pending: "Pendiente",
        started: "Iniciada",
        completed: "Completada",
        canceled: "Anulada",
        cancelled: "Anulada",
        accepted: "Aceptado"
      },
      agreement: {
        status: {
          expired: "Expirada",
          rejected: "Rechazado",
          archived: "Archivada",
          draft: "Borrador",
          pending: "Pendiente",
          started: "Iniciada",
          completed: "Completada",
          cancelled: "Anulada",
          canceled: "Anulada",
          failed: "Env\xEDo fallido"
        },
        groups: {
          company: "Compa\xF1\xEDa",
          claim: "Reclamo",
          victim: "Damnificado",
          claimant: "Reclamante",
          lawyer: "Abogado",
          heirs: "Herederos",
          insured: "Asegurado",
          insured_vehicle: "Veh\xEDculo asegurado",
          sinister: "Siniestro",
          damage_material: "Da\xF1o material",
          damage_person: "Da\xF1o a la persona",
          damage_recovery: "Recupero",
          offer: "Ofrecimiento",
          payment: "Pago",
          acceptance: "Aceptaci\xF3n",
          document: "Documento"
        },
        variables: {
          company: {
            name: "Nombre de la compa\xF1\xEDa",
            tax_id: "CUIT de la compa\xF1\xEDa"
          },
          claim: {
            ref_id: "N\xFAmero de reclamo",
            external_claim_id: "N\xFAmero de reclamo en la aseguradora",
            external_claim_request_id: "N\xFAmero de tr\xE1mite en la aseguradora",
            type: "Tipo de reclamo",
            damages: {
              types: "Tipos de da\xF1o",
              material: {
                kind: "Tipo de bien da\xF1ado",
                description: "Descripci\xF3n del da\xF1o material",
                summary: "Bien da\xF1ado (resumen)",
                vehicle: {
                  description: "Veh\xEDculo da\xF1ado",
                  make: "Marca del veh\xEDculo da\xF1ado",
                  model: "Modelo del veh\xEDculo da\xF1ado",
                  version: "Versi\xF3n del veh\xEDculo da\xF1ado",
                  year: "A\xF1o del veh\xEDculo da\xF1ado",
                  license_plate: "Patente del veh\xEDculo da\xF1ado",
                  chassis: "Chasis del veh\xEDculo da\xF1ado",
                  engine: "Motor del veh\xEDculo da\xF1ado",
                  type: "Tipo de veh\xEDculo da\xF1ado",
                  use: "Uso del veh\xEDculo da\xF1ado"
                },
                driver: {
                  full_name: "Conductor del veh\xEDculo da\xF1ado"
                },
                insurance: {
                  insurer: "Aseguradora del bien da\xF1ado",
                  policy_number: "P\xF3liza del bien da\xF1ado",
                  coverage: "Cobertura del bien da\xF1ado"
                },
                real_property: {
                  type: "Tipo de inmueble da\xF1ado",
                  ownership: "Tenencia del inmueble da\xF1ado",
                  address: "Domicilio del inmueble da\xF1ado",
                  city: "Localidad del inmueble da\xF1ado",
                  state: "Provincia del inmueble da\xF1ado",
                  zip_code: "C\xF3digo postal del inmueble da\xF1ado"
                }
              },
              person: {
                kind: "Tipo de da\xF1o a la persona",
                victim_role: "Rol del damnificado en el siniestro",
                policyholder_relationship: "Relaci\xF3n del damnificado con el asegurado",
                treatment_medical_institution: "Instituci\xF3n m\xE9dica",
                health_insurance_fund: "Obra social",
                treatment_worker_compensation_insurer: "ART",
                surgery_description: "Cirug\xEDa",
                injuries: "Lesiones (detalle y gravedad)"
              },
              recovery: {
                institution: {
                  full_name: "Instituci\xF3n que recupera",
                  identification: "CUIT de la instituci\xF3n",
                  type: "Tipo de instituci\xF3n"
                },
                claimant_relationship: "V\xEDnculo del reclamante con la instituci\xF3n"
              }
            }
          },
          victim: {
            full_name: "Nombre completo del damnificado",
            first_name: "Nombre del damnificado",
            last_name: "Apellido del damnificado",
            identification_type: "Tipo de documento del damnificado",
            identification: "Documento del damnificado",
            address: "Domicilio del damnificado",
            city: "Localidad del damnificado",
            state: "Provincia del damnificado",
            zip_code: "C\xF3digo postal del damnificado",
            email: "Email del damnificado",
            phone: "Tel\xE9fono del damnificado",
            birth_date: "Fecha de nacimiento del damnificado",
            is_minor: "Damnificado menor de edad",
            is_deceased: "Damnificado fallecido",
            parents: {
              father: {
                full_name: "Nombre del padre del damnificado",
                identification: "Documento del padre del damnificado"
              },
              mother: {
                full_name: "Nombre de la madre del damnificado",
                identification: "Documento de la madre del damnificado"
              }
            },
            representatives: "Representantes del damnificado"
          },
          claimant: {
            full_name: "Nombre completo del reclamante",
            first_name: "Nombre del reclamante",
            last_name: "Apellido del reclamante",
            identification_type: "Tipo de documento del reclamante",
            identification: "Documento del reclamante",
            address: "Domicilio del reclamante",
            city: "Localidad del reclamante",
            state: "Provincia del reclamante",
            zip_code: "C\xF3digo postal del reclamante",
            email: "Email del reclamante",
            phone: "Tel\xE9fono del reclamante",
            relationship: "V\xEDnculo del reclamante con el damnificado",
            relationship_other: "Otro v\xEDnculo del reclamante",
            is_victim: "El reclamante es el damnificado"
          },
          lawyer: {
            full_name: "Nombre completo del abogado",
            first_name: "Nombre del abogado",
            last_name: "Apellido del abogado",
            identification_type: "Tipo de documento del abogado",
            identification: "Documento del abogado",
            address: "Domicilio del abogado",
            city: "Localidad del abogado",
            state: "Provincia del abogado",
            zip_code: "C\xF3digo postal del abogado",
            email: "Email del abogado",
            phone: "Tel\xE9fono del abogado",
            kind: "Tipo de abogado",
            cuit: "CUIT del abogado"
          },
          heirs: {
            count: "Cantidad de herederos",
            list: "Herederos (nombre, v\xEDnculo y documento)",
            names: "Nombres de los herederos"
          },
          insured: {
            full_name: "Nombre del asegurado",
            identification: "Documento del asegurado",
            address: "Domicilio del asegurado",
            city: "Localidad del asegurado",
            state: "Provincia del asegurado",
            policy_number: "N\xFAmero de p\xF3liza"
          },
          insured_vehicle: {
            license_plate: "Patente del veh\xEDculo asegurado",
            description: "Veh\xEDculo asegurado",
            make: "Marca del veh\xEDculo asegurado",
            model: "Modelo del veh\xEDculo asegurado",
            year: "A\xF1o del veh\xEDculo asegurado"
          },
          sinister: {
            number: "N\xFAmero de siniestro",
            date: "Fecha del siniestro",
            date_long: "Fecha del siniestro en letras",
            address: "Lugar del siniestro",
            city: "Localidad del siniestro",
            state: "Provincia del siniestro"
          },
          offer: {
            amount: "Importe ofrecido",
            amount_in_words: "Importe ofrecido en letras",
            amount_in_words_declared: "Importe en letras declarado en el ofrecimiento",
            installments: "Cantidad de cuotas",
            fee_percentage: "Porcentaje de honorarios",
            payment_days: "Plazo de pago (d\xEDas)",
            public_reason: "Motivo del ofrecimiento",
            sent_at: "Fecha de env\xEDo del ofrecimiento",
            accepted_at: "Fecha de aceptaci\xF3n"
          },
          payment: {
            fees_amount: "Importe de honorarios",
            fees_amount_in_words: "Importe de honorarios en letras",
            total_amount: "Importe total a pagar",
            installment_amount: "Importe de cada cuota",
            installment_amount_in_words: "Importe de cada cuota en letras"
          },
          acceptance: {
            payment_method: "Medio de pago",
            cbu: "CBU del tercero",
            cuit: "CUIT del tercero",
            lawyer_cbu: "CBU del letrado",
            lawyer_cuit: "CUIT del letrado",
            identification: "Documento declarado al aceptar"
          },
          document: {
            date: "Fecha del documento",
            date_short: "Fecha del documento (corta)"
          }
        },
        lawyer_kind: {
          attorney_in_fact: "Abogado apoderado",
          attorney_representative: "Abogado patrocinante"
        },
        boolean: {
          yes: "S\xED",
          no: "No"
        },
        parents: {
          father: "Padre",
          mother: "Madre"
        },
        person_damage_kind: {
          injury: "Lesiones",
          death: "Fallecimiento"
        },
        victim_role: {
          pedestrian: "Peat\xF3n",
          driver: "Conductor del veh\xEDculo tercero",
          rider: "Transportado en el veh\xEDculo tercero",
          policyholder_rider: "Transportado en el veh\xEDculo asegurado"
        },
        material_damage_summary: {
          vehicle: "veh\xEDculo {{description}}",
          vehicle_with_plate: "veh\xEDculo {{description}}, dominio {{license_plate}}",
          real_property: "inmueble sito en {{address}}",
          real_property_with_city: "inmueble sito en {{address}}, {{city}}"
        },
        reasons: {
          empty_field: "Dato vac\xEDo",
          no_selected_external_complaint: "Sin denuncia seleccionada",
          acceptance_unknown: "Sin aceptaci\xF3n",
          not_provided: "No informado al aceptar",
          invalid_value: "Valor inv\xE1lido",
          out_of_range: "Fuera de rango",
          unsupported_currency: "Moneda no soportada",
          unknown_state_code: "Provincia desconocida",
          no_claimant: "Sin reclamante",
          lawyer_identification_not_cuit: "El abogado no tiene CUIT cargado",
          birth_date_missing: "Sin fecha de nacimiento",
          representative_unknown: "Sin representante cargado",
          legal_person: "Persona jur\xEDdica",
          no_lawyer: "Sin abogado",
          no_parents: "Sin padres cargados",
          not_represented: "No requiere representaci\xF3n",
          no_heirs: "Sin herederos",
          no_installments: "Sin cuotas",
          no_fees: "Sin honorarios",
          no_binding: "Sin variable vinculada",
          ambiguous_binding: "M\xE1s de una variable coincide",
          hidden_by_condition: "Oculta por condici\xF3n",
          unprintable: "No imprimible (archivo)",
          draft_offer: "Ofrecimiento en borrador",
          no_material_damage: "Sin da\xF1o material",
          no_person_damage: "Sin da\xF1o a la persona",
          no_recovery_damage: "Sin recupero",
          no_vehicle: "El da\xF1o material no es un veh\xEDculo",
          no_real_property: "El da\xF1o material no es un inmueble",
          no_driver: "Sin conductor cargado",
          no_insurance: "Sin seguro cargado",
          no_injury_details: "Sin detalle de lesiones",
          not_policyholder_rider: "No viajaba en el veh\xEDculo asegurado",
          not_requested: "No se le pide al reclamante",
          no_public_reason: "El ofrecimiento se envi\xF3 sin motivo",
          no_offer: "El reclamo no tiene ofrecimiento",
          no_claim_type: "El reclamo no tiene tipo asignado"
        },
        warnings: {
          multiple_principal_claimants: "Hay m\xE1s de un reclamante principal",
          principal_fallback_positional: "Reclamante principal elegido por orden de carga",
          multiple_lawyers: "Hay m\xE1s de un abogado",
          heirs_without_death: "Hay herederos sin fallecimiento",
          parents_without_minor: "Padres cargados con damnificado mayor",
          owner_not_a_claimant: "El due\xF1o del reclamo no coincide con ning\xFAn reclamante",
          claimant_victim_mismatch: "El reclamante principal y el damnificado no coinciden en DNI o email (reclamo en nombre propio)",
          relationship_null: "Reclamante sin v\xEDnculo",
          relationship_other_free_text: "V\xEDnculo en texto libre",
          sinister_date_mismatch: "La fecha del siniestro difiere de la ocurrencia",
          invalid_cbu_format: "CBU con formato inv\xE1lido",
          invalid_cuit_checksum: "CUIT con d\xEDgito verificador inv\xE1lido",
          bank_fields_swapped: "CBU y CUIT parecen intercambiados",
          amount_in_words_mismatch: "El importe en letras declarado no coincide con el calculado",
          currency_differs_from_company_default: "La moneda difiere de la de la compa\xF1\xEDa",
          binding_matched_by_normalization: "Variable vinculada por nombre normalizado",
          ambiguous_binding: "Vinculaci\xF3n ambigua",
          definitions_not_snapshotted: "El ofrecimiento no tiene definiciones de variables",
          unknown_select_option: "Opci\xF3n no reconocida",
          dynamic_key_collision: "Dos variables generan la misma clave",
          multiple_damages_of_same_type: "Hay m\xE1s de un da\xF1o del mismo tipo: se usa el primero cargado",
          multiple_rules_matched: "M\xE1s de una regla coincide con el reclamo: se aplic\xF3 la de mayor prioridad",
          external_complaint_inferred: "La denuncia del asegurado se tom\xF3 del siniestro por la patente del reclamo",
          external_complaint_unmatched: "El siniestro tiene denuncias con asegurado pero ninguna coincide con la patente del reclamo",
          claim_type_damages_mismatch: "Los da\xF1os cargados no coinciden con la composici\xF3n del tipo de reclamo"
        },
        claimant_victim_identity: {
          identification_mismatch: "El DNI del reclamante principal no coincide con el del damnificado (reclamo en nombre propio)",
          email_mismatch: "El email del reclamante principal no coincide con el del damnificado (reclamo en nombre propio)",
          identification_and_email_mismatch: "El DNI y el email del reclamante principal no coinciden con los del damnificado (reclamo en nombre propio)",
          identification_missing_on_victim: "Falta el DNI del damnificado (reclamo en nombre propio)",
          identification_missing_on_claimant: "Falta el DNI del reclamante principal (reclamo en nombre propio)",
          identification_missing_on_both: "Falta el DNI del damnificado y del reclamante principal (reclamo en nombre propio)",
          email_missing_on_victim: "Falta el email del damnificado (reclamo en nombre propio)",
          email_missing_on_claimant: "Falta el email del reclamante principal (reclamo en nombre propio)",
          email_missing_on_both: "Falta el email del damnificado y del reclamante principal (reclamo en nombre propio)"
        },
        claim_classification: {
          material: "Da\xF1os materiales",
          material_vehicle_with_license_plate: "Veh\xEDculo con patente",
          material_vehicle_without_license_plate: "Veh\xEDculo sin patente",
          person_injury: "Lesiones",
          material_and_person_injury: "Da\xF1os materiales y lesiones",
          person_death: "Fallecimiento",
          material_real_property: "Inmueble",
          claimant_worker_compensation_insurer: "Reclamo de ART",
          material_and_person_death: "Da\xF1os materiales y fallecimiento",
          recovery: "Recupero"
        },
        person_kind: {
          natural_person: "Persona f\xEDsica",
          legal_person: "Persona jur\xEDdica"
        },
        currency: {
          ARS: "Pesos",
          USD: "D\xF3lares",
          EUR: "Euros",
          PYG: "Guaran\xEDes"
        },
        sub_damage_type: {
          vehicle: "Veh\xEDculo",
          real_property: "Inmueble",
          injury: "Lesiones",
          death: "Fallecimiento",
          recovery: "Recupero"
        },
        entity_damaged_category: {
          with_license_plate: "con patente",
          without_license_plate: "sin patente"
        },
        signatureMethods: {
          digital: "Firma digital",
          in_person: "Firma presencial"
        },
        signatureOutcomes: {
          selected: "M\xE9todo de firma decidido",
          undetermined: "M\xE9todo de firma pendiente",
          unresolved: "Sin m\xE9todo de firma"
        },
        attributeGroups: {
          claim: "Reclamo",
          offer: "Ofrecimiento",
          acceptance: "Aceptaci\xF3n"
        },
        attributes: {
          claim: {
            claim_type_id: "Tipo de reclamo",
            classification: "Clasificaci\xF3n del reclamo",
            damage_types: "Tipos de da\xF1o",
            person_damage_types: "Tipos de da\xF1o a la persona",
            material_damage_types: "Tipos de da\xF1o material",
            victim_kind: "Tipo de damnificado",
            victim_is_minor: "El damnificado es menor",
            victim_is_deceased: "El damnificado falleci\xF3",
            victim_has_parents: "El damnificado tiene padres cargados",
            claimants_count: "Cantidad de reclamantes",
            claimant_relationship: "V\xEDnculo del reclamante principal",
            claimant_relationships: "V\xEDnculos de los reclamantes",
            claimant_is_victim: "El reclamante es el damnificado",
            has_lawyer: "Tiene abogado",
            lawyer_kind: "Tipo de abogado",
            lawyer_count: "Cantidad de abogados",
            heirs_count: "Cantidad de sucesores",
            has_external_complaint: "Tiene denuncia del asegurado",
            team_id: "Grupo responsable",
            responsible_user_id: "Responsable"
          },
          offer: {
            message_template_id: "Plantilla del ofrecimiento",
            amount: "Importe ofrecido",
            currency: "Moneda",
            installments: "Cantidad de cuotas",
            fee_percentage: "Porcentaje de honorarios",
            payment_days: "Plazo de pago en d\xEDas",
            has_installments: "Se ofrece en cuotas",
            has_fees: "Incluye honorarios",
            variable: "Variable del ofrecimiento"
          },
          acceptance: {
            complete: "La aceptaci\xF3n est\xE1 completa",
            payment_method: "M\xE9todo de pago",
            has_lawyer_bank_data: "Tiene datos bancarios del abogado",
            variable: "Variable de la aceptaci\xF3n"
          }
        },
        operators: {
          eq: "es igual a",
          ne: "es distinto de",
          in: "es alguno de",
          not_in: "no es ninguno de",
          gt: "es mayor que",
          gte: "es mayor o igual que",
          lt: "es menor que",
          lte: "es menor o igual que",
          contains_any: "incluye alguno de",
          contains_all: "incluye todos",
          contains_none: "no incluye ninguno de",
          is_empty: "est\xE1 vac\xEDo",
          exists: "existe"
        },
        planOutcomes: {
          selected: "Conformidad seleccionada",
          blocked: "Regla sin documento",
          no_match: "Ninguna regla aplica",
          undetermined: "Falta informaci\xF3n",
          disabled: "Automatizaci\xF3n apagada"
        },
        planReasons: {
          automation_disabled: "La conformidad autom\xE1tica est\xE1 apagada para esta compa\xF1\xEDa",
          no_rules_configured: "La compa\xF1\xEDa todav\xEDa no tiene reglas habilitadas",
          no_rule_matched: "Ninguna regla habilitada coincide con el reclamo",
          pending_acceptance: "Se decide cuando el reclamante acepte el ofrecimiento",
          missing_context_data: "Falta un dato del reclamo para evaluar una regla",
          template_not_published: "La plantilla de la regla no tiene una versi\xF3n publicada",
          template_deleted: "La plantilla de la regla fue eliminada",
          pending_offer: "Se decide cuando exista el ofrecimiento"
        },
        conditionResults: {
          true: "Se cumple",
          false: "No se cumple",
          undetermined: "Indeterminada"
        },
        ruleResults: {
          match: "Coincide",
          no_match: "No coincide",
          undetermined: "Indeterminada"
        },
        undeterminedReasons: {
          unknown_value: "El reclamo no tiene ese dato cargado",
          pending_acceptance: "Depende de la aceptaci\xF3n, que todav\xEDa no ocurri\xF3",
          unknown_variable: "Ninguna plantilla del ofrecimiento define esa variable",
          pending_offer: "Depende del ofrecimiento, que todav\xEDa no existe"
        },
        recipientReasons: {
          no_claimant: "El reclamo no tiene reclamante cargado",
          no_lawyer: "El reclamo no tiene abogado",
          no_heirs: "El reclamo no tiene tantos sucesores",
          no_name: "La persona no tiene nombre cargado",
          no_email: "La persona no tiene email y la firma es digital",
          company_sender_unavailable: "La cuenta remitente de la compa\xF1\xEDa todav\xEDa no se configura"
        },
        gapKinds: {
          variable: "Variable",
          signer: "Recuadro de firma",
          signature: "M\xE9todo de firma"
        },
        gapClasses: {
          pending: "Lo completa el reclamante al aceptar",
          absent: "Falta en el reclamo",
          not_applicable: "No corresponde a este caso",
          unknown_key: "Variable desconocida"
        },
        placeholder: {
          pending: "{{label}} (lo completa el reclamante)",
          absent: "{{label}} (faltante)",
          unknown_key: "{{key}} (variable desconocida)"
        },
        templateKinds: {
          agreement: "Conformidad",
          offer_message: "Mensaje de ofrecimiento"
        },
        termsSources: {
          typed: "T\xE9rminos tipados del ofrecimiento",
          bindings: "Variables de la plantilla por nombre",
          none: "Sin ofrecimiento"
        },
        messagePreview: {
          title: "As\xED lo ver\xE1 el reclamante"
        },
        wizardModes: {
          guided: "Guiado por reglas",
          legacy: "Plantilla manual"
        },
        legacyReasons: {
          automation_disabled: "La automatizaci\xF3n est\xE1 apagada para esta compa\xF1\xEDa",
          offer_message_missing: "La compa\xF1\xEDa todav\xEDa no eligi\xF3 su mensaje de ofrecimiento",
          offer_message_not_published: "El mensaje de ofrecimiento no tiene versi\xF3n publicada"
        },
        ruleIssues: {
          template_not_published: "La plantilla no tiene versi\xF3n publicada",
          template_deleted: "La plantilla fue eliminada",
          unknown_condition_variable: "Una condici\xF3n usa una variable que ya no existe",
          unknown_condition_option: "Una condici\xF3n usa un tipo de reclamo, plantilla, grupo o responsable que ya no existe",
          unknown_scope_template: "El alcance nombra una plantilla eliminada"
        },
        dispatch: {
          transaction_name: "Conformidad \xB7 Reclamo {{ref}}",
          transaction_description: "Transacci\xF3n de firma de la conformidad",
          notification: "No se pudo enviar a firmar la conformidad {{name}}: {{reason}}",
          failure: {
            signature_disabled: "La firma digital de la compa\xF1\xEDa est\xE1 apagada. Cuando se vuelva a encender, se puede reintentar.",
            claim_closed: "El reclamo est\xE1 cerrado.",
            sender_unavailable: "El tramitador que la enviaba ya no est\xE1 en la compa\xF1\xEDa. Otro tramitador puede reintentar con su cuenta de AutoSign.",
            sender_connection_missing: "El remitente no tiene su cuenta de AutoSign conectada.",
            sender_connection_reconnect_required: "La cuenta de AutoSign del remitente dej\xF3 de funcionar: hay que volver a conectarla.",
            document_unavailable: "El documento final no est\xE1 listo para enviarse.",
            document_mismatch: "El PDF guardado no coincide con el que se imprimi\xF3, as\xED que no se env\xEDa.",
            document_too_large: "El PDF supera el tama\xF1o que acepta AutoSign.",
            recipient_unresolved: "Un recuadro de firma obligatorio no tiene a qui\xE9n envi\xE1rselo.",
            recipient_without_email: "Un firmante obligatorio no tiene un email v\xE1lido.",
            anchor_missing: "El PDF no trae el lugar de una firma obligatoria.",
            no_signers: "El documento no tiene recuadros de firma para enviar.",
            notification_endpoint_too_long: "La direcci\xF3n de avisos para AutoSign supera el largo permitido.",
            provider_rejected: "AutoSign rechaz\xF3 el pedido.",
            provider_document_failed: "AutoSign no pudo procesar el PDF.",
            provider_start_unconfirmed: "AutoSign no confirm\xF3 si la solicitud sali\xF3 desde la cuenta anterior. Solo esa cuenta puede comprobarlo, as\xED que el reintento tiene que hacerse desde ella.",
            provider_unavailable: "AutoSign no respondi\xF3. Se reintenta solo.",
            provider_document_processing: "AutoSign sigue procesando el PDF. Se reintenta solo.",
            provider_transaction_missing: "La solicitud ya no existe en AutoSign. Se arma otra en el pr\xF3ximo intento.",
            unexpected_error: "Algo fall\xF3 al enviar. Se reintenta solo."
          }
        },
        signatureOrigin: {
          label: "Firma del reclamante",
          piramid_after_acceptance: "En Piramid, al aceptar el ofrecimiento",
          piramid_signing_cta: "En Piramid, desde el reclamo",
          external: "Fuera de Piramid"
        }
      },
      acceptancePayee: {
        cases: {
          victim: "Los datos de cobro deben corresponder al damnificado del reclamo.",
          minor_victim: "El damnificado es menor de edad. La cuenta de cobro debe corresponder al padre o a la madre.",
          deceased_victim: "La cuenta de cobro debe corresponder a uno de los herederos.",
          legal_person_victim: "Los datos de cobro deben corresponder a la empresa damnificada."
        },
        attorney_case: "El reclamo corresponde al damnificado con DNI {{document}}.",
        account_subtitle: "Cuenta donde se depositar\xE1 la indemnizaci\xF3n",
        payee_block_title: "Datos del damnificado",
        payee_block_hint: "D\xF3nde vas a recibir la transferencia.",
        lawyer_block_title: "Datos del letrado",
        lawyer_block_hint: "Cuenta de tu abogado. Los honorarios se transfieren por separado.",
        prefilled_hint: "Este dato viene del reclamo. Si es incorrecto, contact\xE1 al tramitador.",
        submit: "Enviar datos y aceptar el ofrecimiento",
        lawyer: {
          unnamed: "Abogado del reclamo",
          kinds: {
            attorney_in_fact: "Abogado apoderado",
            attorney_representative: "Abogado patrocinante"
          }
        },
        placeholders: {
          identification: "Ingres\xE1 el documento",
          cbu: "Ingres\xE1 el CBU",
          cuit: "Ingres\xE1 el CUIT",
          lawyer_cbu: "Ingres\xE1 el CBU del letrado",
          lawyer_cuit: "Ingres\xE1 el CUIT del letrado"
        },
        errors: {
          exact_length: "Tiene que tener {{length}} d\xEDgitos.",
          length_range: "Tiene que tener entre {{min}} y {{max}} d\xEDgitos.",
          interbanking: "No pudimos validar la cuenta. Asegurate de que el CUIT y el CBU sean correctos y pertenezcan a la misma persona."
        },
        relations: {
          victim: "Damnificado",
          father: "Padre",
          mother: "Madre",
          heir: "Heredero",
          tutor_curator: "Tutor o curador",
          legal_representative: "Representante legal"
        },
        issues: {
          payee_cuit_invalid: "El CUIT ingresado no es v\xE1lido. Revis\xE1 los d\xEDgitos.",
          payee_cuit_does_not_match_identification: "El CUIT no corresponde al DNI ingresado.",
          payee_identification_not_a_candidate: "El DNI ingresado no corresponde a ninguna de las personas que pueden cobrar este reclamo.",
          payee_cuit_not_a_candidate: "El CUIT ingresado no corresponde a ninguna de las personas que pueden cobrar este reclamo.",
          payee_unresolved: "No podemos validar los datos de cobro de este reclamo. Contact\xE1 a la aseguradora.",
          payee_cuit_not_attorney: "La indemnizaci\xF3n se deposita en la cuenta del abogado apoderado: el CUIT tiene que ser el suyo.",
          lawyer_cuit_does_not_match: "El CUIT ingresado no corresponde al abogado asociado al reclamo.",
          lawyer_cuit_unavailable: "El abogado registrado en tu reclamo no tiene CUIT cargado. Contact\xE1 a la aseguradora.",
          lawyer_identification_not_cuit: "El abogado registrado en tu reclamo no tiene CUIT cargado. Contact\xE1 a la aseguradora."
        },
        blockers: {
          payee_unresolved: "El reclamo no permite determinar qui\xE9n puede cobrar. Revis\xE1 el damnificado: su documento y su fecha de nacimiento, y si es menor o falleci\xF3, que est\xE9n cargados el padre y la madre o los herederos.",
          lawyer_cuit_unavailable: "El abogado del reclamo no tiene CUIT cargado. Sin CUIT el reclamante no va a poder completar los datos del letrado.",
          payee_cuit_invalid: "El CUIT declarado no es v\xE1lido.",
          payee_cuit_does_not_match_identification: "El CUIT declarado no corresponde al DNI.",
          payee_identification_not_a_candidate: "El DNI declarado no corresponde a nadie del reclamo.",
          payee_cuit_not_a_candidate: "El CUIT declarado no corresponde a nadie del reclamo.",
          payee_cuit_not_attorney: "El CUIT declarado no es el del abogado apoderado.",
          lawyer_cuit_does_not_match: "El CUIT del letrado no corresponde al abogado del reclamo."
        }
      },
      embeddedSigning: {
        notice: "Al aceptar vas a poder firmar la conformidad en esta misma pantalla.",
        accepted: "Aceptaste el ofrecimiento",
        preparing: {
          title: "Estamos preparando tu conformidad",
          description: "En unos segundos vas a poder revisarla y firmarla ac\xE1 mismo. No cierres esta p\xE1gina.",
          slow: "Est\xE1 tardando un poco m\xE1s de lo habitual. Seguimos trabajando.",
          stages: {
            document: "Generando el documento",
            dispatch: "Prepar\xE1ndolo para la firma"
          }
        },
        ready: {
          title: "Revis\xE1 y firm\xE1 tu conformidad",
          description: "Le\xE9 el documento y firmalo al final. Cuando termines, haz click en Enviar y esta pantalla se actualizar\xE1 sola.",
          frameTitle: "Firma de la conformidad"
        },
        signed: {
          title: "\xA1Listo! Firmaste la conformidad",
          description: "Te vamos a avisar cuando la firmen todas las partes."
        },
        fallback: {
          description: "Te vamos a mandar un email de AutoSign para que firmes la conformidad."
        }
      },
      agreementSigning: {
        cta: "Firmar conformidad",
        back: "Volver a los ofrecimientos",
        unavailable: {
          title: "No pod\xE9s firmar la conformidad desde ac\xE1",
          description: "Pod\xE9s firmarla desde el email que te mand\xF3 AutoSign.",
          otherSigner: "Esta conformidad la firma otra persona. Si sos vos, ingres\xE1 con el email al que te lleg\xF3 la solicitud de firma de AutoSign."
        }
      },
      paymentMethods: {
        transfer: "transferencia"
      },
      providers: {
        autosign: "Autosign"
      }
    };
    var orders = {
      status: {
        pending: "Pendiente",
        in_progress: "En curso",
        completed: "Finalizada",
        rejected: "Rechazada",
        canceled: "Anulada"
      },
      progress: {
        title: "Progreso de la orden",
        stage: {
          created: "Solicitud",
          accepted: "Respuesta",
          scheduling: "Coordinaci\xF3n turno",
          work_proof: "Inspecci\xF3n",
          documentation: "Documentaci\xF3n",
          completed: "Finalizada"
        },
        status: {
          done: "Completada",
          awaiting_provider: {
            insurer: "Espera al proveedor",
            provider: "Es tu turno",
            customer: "En curso"
          },
          awaiting_insurer: {
            insurer: "Tenes que revisar",
            provider: "En revisi\xF3n",
            customer: "En revisi\xF3n"
          },
          in_progress: "En proceso",
          rejected: "Rechazada",
          blocked: "Bloqueada",
          unreachable: "No corresponde",
          canceled: "Anulada"
        },
        statusByStage: {
          scheduling: {
            done: "Coordinado",
            awaiting_provider: "Falta coordinar"
          },
          work_proof: {
            rejected: "No completada",
            awaiting_insurer: "Falta crearla"
          },
          documentation: {
            done: "Completa",
            rejected: "Con rechazos"
          }
        },
        verdict: {
          approved: "Aprobada",
          disapproved: "Desaprobada",
          error: "Sin veredicto"
        },
        openAttempt: {
          pending_capture: {
            insurer: "Nuevo intento pendiente de captura",
            provider: "Ten\xE9s un nuevo intento para capturar",
            customer: "Nuevo intento en curso"
          },
          capturing: {
            insurer: "Nuevo intento en captura",
            provider: "Est\xE1s capturando un nuevo intento",
            customer: "Nuevo intento en curso"
          },
          processing: {
            insurer: "Nuevo intento en an\xE1lisis",
            provider: "Nuevo intento en an\xE1lisis",
            customer: "Nuevo intento en curso"
          }
        },
        scheduledFor: "Trabajo previsto: {{at}}",
        waitingOn: {
          provider: "Depende del proveedor",
          insurer: "Depende de la aseguradora",
          external: "Depende de Autoinspector"
        },
        next: {
          accepted: {
            awaiting_provider: {
              insurer: "Esperando que el proveedor acepte la orden.",
              provider: "Ten\xE9s que aceptar o rechazar la orden."
            }
          },
          scheduling: {
            awaiting_provider: {
              insurer: "Esperando que el proveedor coordine cu\xE1ndo se realiza el trabajo.",
              provider: "Ten\xE9s que coordinar cu\xE1ndo se realiza el trabajo antes de hacerlo."
            }
          },
          work_proof: {
            awaiting_provider: {
              insurer: "Esperando que el proveedor capture la inspecci\xF3n.",
              provider: "Te falta capturar la inspecci\xF3n."
            },
            awaiting_insurer: {
              insurer: "La orden requiere prueba de trabajo y todav\xEDa no hay inspecci\xF3n: creala para poder finalizar.",
              provider: "La aseguradora todav\xEDa tiene que crear la inspecci\xF3n."
            },
            rejected: {
              insurer: "La inspecci\xF3n no se complet\xF3 (bloqueada o vencida): cre\xE1 una nueva para poder finalizar.",
              provider: "La inspecci\xF3n no se complet\xF3: la aseguradora tiene que generar una nueva."
            },
            in_progress: "La inspecci\xF3n se est\xE1 analizando."
          },
          documentation: {
            awaiting_provider: {
              insurer: "Esperando que el proveedor cargue la documentaci\xF3n requerida.",
              provider: "Te falta cargar documentaci\xF3n requerida de la orden."
            },
            awaiting_insurer: {
              insurer: "Ten\xE9s documentaci\xF3n requerida por cargar o revisar.",
              provider: "Est\xE1s esperando que la aseguradora complete o revise la documentaci\xF3n."
            },
            rejected: {
              insurer: "Rechazaste un documento: esperando que el proveedor suba una nueva versi\xF3n.",
              provider: "Un documento fue rechazado: ten\xE9s que subir una nueva versi\xF3n."
            }
          },
          completed: {
            awaiting_insurer: {
              insurer: "Todo listo: pod\xE9s finalizar la orden.",
              provider: "Todo listo: falta que la aseguradora finalice la orden."
            }
          }
        },
        outcome: {
          completed: "La orden est\xE1 finalizada.",
          rejected: "El proveedor rechaz\xF3 la orden.",
          canceled: "La aseguradora anul\xF3 la orden.",
          idle: "No hay acciones pendientes por el momento."
        },
        version: "Versi\xF3n {{ version }}",
        by: "por {{ actor }}"
      },
      actions: {
        accept: "Aceptar orden",
        reject: "Rechazar orden",
        cancel: "Anular",
        cancelTooltip: "Anular orden",
        complete: "Finalizar orden",
        reopen: "Reabrir orden",
        confirm: {
          accept: {
            title: "Aceptar orden de trabajo",
            description: "\xBFConfirm\xE1s que acept\xE1s esta orden? Pasar\xE1 a estar en curso.",
            action: "Aceptar orden"
          },
          reject: {
            title: "Rechazar orden de trabajo",
            description: "El rechazo es definitivo: no podr\xE1s revertirlo.",
            action: "Rechazar orden",
            label: "Motivo de rechazo"
          },
          cancel: {
            title: "Anular orden de trabajo",
            description: "La anulaci\xF3n es definitiva: no podr\xE1s revertirla.",
            action: "Anular orden",
            label: "Motivo de anulaci\xF3n"
          },
          complete: {
            title: "Finalizar orden de trabajo",
            description: "La orden se marcar\xE1 como finalizada. Pod\xE9s reabrirla despu\xE9s si hace falta corregir algo.",
            action: "Finalizar orden",
            workProof: {
              title: "Revis\xE1 la prueba de trabajo",
              disapproved: "La inspecci\xF3n que complet\xF3 la prueba de trabajo fue desaprobada por Autoinspector. Revis\xE1 la evidencia en la pesta\xF1a Inspecciones antes de finalizar.",
              error: "La inspecci\xF3n que complet\xF3 la prueba de trabajo termin\xF3 sin veredicto de Autoinspector. Revis\xE1 la evidencia en la pesta\xF1a Inspecciones antes de finalizar.",
              openAttempt: "Hay un nuevo intento de inspecci\xF3n todav\xEDa sin completar."
            }
          },
          reopen: {
            title: "Reabrir orden de trabajo",
            description: "La orden volver\xE1 a estar en curso para poder corregir su documentaci\xF3n o coordinaci\xF3n.",
            action: "Reabrir orden"
          }
        },
        reasonLabel: "Motivo",
        reasonPlaceholder: "Escrib\xED el motivo",
        back: "Volver",
        acceptSuccess: "Orden aceptada",
        rejectSuccess: "Orden rechazada",
        cancelSuccess: "Orden anulada",
        completeSuccess: "Orden finalizada",
        reopenSuccess: "Orden reabierta",
        refreshProgress: "Recalcular avance",
        refreshProgressSuccess: "Avance recalculado",
        refreshProgressUnchanged: "El avance ya estaba actualizado",
        downloadPdf: "Descargar PDF"
      },
      review: {
        actions: {
          accept: "Aceptar",
          reject: "Rechazar",
          undo: "Deshacer",
          back: "Volver"
        },
        reasonLabel: "Motivo de rechazo",
        reasonPlaceholder: "Escrib\xED el motivo del rechazo",
        gate: {
          orderNotInProgress: "La orden debe estar en curso para subir entregables.",
          workProofNotCompleted: "Falta una inspecci\xF3n de Autoinspector completada para poder finalizar la orden.",
          notScheduled: "Falta registrar la coordinaci\xF3n del trabajo: sin eso la orden no puede finalizarse.",
          documentationIncomplete: "Falta documentaci\xF3n requerida (cargarla o aprobarla): sin eso la orden no puede finalizarse.",
          mechanismIsInspection: "Esta orden demuestra el trabajo con una inspecci\xF3n de Autoinspector: no admite reportes.",
          mechanismIsReport: "Esta orden demuestra el trabajo con un reporte: no admite inspecciones."
        },
        document: {
          accept: {
            title: "Aprobar documento",
            description: "El documento quedar\xE1 como cumplido para la finalizaci\xF3n de la orden.",
            success: "Documento aprobado"
          },
          reject: {
            title: "Rechazar documento",
            description: "Para rechazar este documento, ingres\xE1 el motivo. El proveedor podr\xE1 subir una nueva versi\xF3n.",
            success: "Documento rechazado"
          },
          undo: {
            title: "Deshacer revisi\xF3n del documento",
            description: "El documento volver\xE1 a estado pendiente de revisi\xF3n.",
            success: "Revisi\xF3n deshecha"
          }
        }
      },
      "sub-types": {
        assessment: "Peritaci\xF3n",
        repair: "Reparaci\xF3n",
        investigation: "Investigaci\xF3n",
        parts: "Repuestos"
      },
      types: {
        purchase: "Compra",
        service: "Servicio"
      },
      derive: {
        trigger: "Crear orden",
        title: "Derivar orden de trabajo a un proveedor",
        description: "Eleg\xED el trabajo a realizar y la ubicaci\xF3n, y seleccion\xE1 un proveedor de tu red.",
        vertical: "Rubro",
        verticalPlaceholder: "Seleccion\xE1 un rubro",
        service: "Servicio",
        servicePlaceholder: "Seleccion\xE1 un servicio",
        good: "Bien",
        goodPlaceholder: "Seleccion\xE1 un bien",
        locality: "Localidad",
        localityPlaceholder: "Busc\xE1 una ubicaci\xF3n",
        groupFilter: "Grupo",
        groupPlaceholder: "Todos los grupos",
        clearGroup: "Quitar filtro",
        allGroups: "Todos",
        noGroups: "No se encontraron grupos",
        available: "Proveedores con cobertura en la zona",
        nearby: "Otros proveedores que realizan el trabajo",
        nearbyHint: "Estos proveedores no declararon cobertura en la zona seleccionada.",
        recommended: "Proveedores recomendados",
        distanceHint: "Ordenados por cercan\xEDa. Las distancias son aproximadas y se calculan en l\xEDnea recta al centro de la localidad base.",
        searchPlaceholder: "Busc\xE1 a tu proveedor",
        showNearbyPrompt: "\xBFNo encontr\xE1s al proveedor que busc\xE1s? Prob\xE1 buscar alguno con cobertura en otras zonas",
        hideNearby: "Ocultar",
        loadingCandidates: "Buscando proveedores...",
        noCandidates: "No se encontraron proveedores para esa selecci\xF3n.",
        selectedProvider: "Proveedor seleccionado",
        currentOrderNotice: {
          title: "Orden de trabajo vigente",
          cancel: "Cancelar",
          continue: "Continuar",
          becomes_current: "Tu empresa le muestra al reclamante el resumen de la orden de trabajo vigente (la m\xE1s reciente). Al crearla, esta orden pasar\xE1 a ser la vigente.",
          replaces_current: "Este reclamo ya tiene una orden de trabajo vigente y es la que ve el reclamante. Si cre\xE1s esta orden, pasar\xE1 a ser la vigente y reemplazar\xE1 a la actual."
        },
        nameLabel: "Descripci\xF3n de la orden",
        namePlaceholder: "Ej.: Parabrisas FIAT CRONOS 2022 (AC123DD)",
        descriptionLabel: "Informaci\xF3n adicional",
        descriptionPlaceholder: "Detall\xE1 cualquier tipo de informaci\xF3n adicional que sea relevante para el trabajo",
        notesLabel: "Notas",
        filesLabel: "Adjuntos",
        documentationStep: "Documentaci\xF3n",
        documentationOptional: "Documentaci\xF3n (opcional)",
        attachFromClaim: "Documentaci\xF3n del reclamo",
        attachFromComplaint: "Documentaci\xF3n de la denuncia",
        attachedCount: "Documentaci\xF3n compartida",
        skip: "Omitir",
        next: "Siguiente",
        review: "Siguiente",
        back: "Atr\xE1s",
        submit: "Crear orden",
        noResults: "No se encontraron resultados",
        successTitle: "Orden creada",
        successDescription: "La orden fue derivada al proveedor con \xE9xito."
      },
      items: {
        title: "Detalle de la orden",
        addLine: "Agregar \xEDtem",
        emptyPrefix: "No agregaste \xEDtems. Pod\xE9s dejar la orden sin \xEDtems, sumar",
        addProducts: "productos",
        emptyOr: "o cargar un",
        addCustom: "detalle personalizado",
        product: "Producto",
        productPlaceholder: "Busc\xE1 un producto",
        noProducts: "No se encontraron productos",
        description: "Descripci\xF3n",
        descriptionPlaceholder: "Detalle del \xEDtem",
        quantity: "Cantidad",
        unitPrice: "Precio unitario",
        subtotal: "Subtotal",
        amount: "Importe",
        priceOverridden: "Modificado \xB7 lista {{price}} \xB7 Restaurar",
        removeLine: "Quitar \xEDtem"
      },
      coverage: {
        title: "Cobertura",
        totalAmount: "Importe",
        coverageAmount: "Cobertura ",
        amountToCharge: "Importe neto",
        taxesPercent: "IVA",
        taxOptionNone: "Sin IVA",
        taxOptionLabel: "{{percent}}%",
        taxesAmount: "IVA ({{percent}}%)",
        totalWithTaxes: "Total"
      },
      scheduling: {
        tab: "Coordinaci\xF3n turno",
        title: "Coordinaci\xF3n turno",
        description: "Cu\xE1ndo est\xE1 previsto realizar el trabajo. Se acuerda antes de realizarlo, y la orden no puede finalizarse sin esta informaci\xF3n.",
        status: {
          scheduled: "Coordinado",
          pending: "Sin coordinar"
        },
        empty: "Todav\xEDa nadie registr\xF3 cu\xE1ndo se realiza el trabajo.",
        recordedBy: "Registrado por {{actor}} el {{at}}",
        saveSuccess: "Coordinaci\xF3n turno registrado",
        action: {
          create: "Registrar turno",
          edit: "Modificar",
          cancel: "Anular turno"
        },
        blocked: {
          order_not_accepted: "La orden todav\xEDa no fue aceptada: no hay nada que coordinar.",
          invalid_order_status: "La orden ya no est\xE1 en curso: no se puede modificar la coordinaci\xF3n.",
          claim_not_open: "El reclamo no admite cambios.",
          no_branches: "El proveedor no tiene sucursales cargadas: no hay lugar al que citar al reclamante.",
          not_scheduled: "No hay un turno coordinado para anular."
        },
        branch: {
          directions: "C\xF3mo llegar"
        },
        form: {
          date: "Fecha",
          time: "Hora",
          branch: "Sucursal",
          branchPlaceholder: "Eleg\xED a qu\xE9 sucursal debe ir el reclamante",
          note: "Nota (opcional)",
          notePlaceholder: "Franja horaria acordada, con qui\xE9n se habl\xF3, condiciones\u2026",
          notifyInsured: "Notificar al reclamante ({{email}})",
          notifyInsuredNoEmail: "El reclamante no tiene email cargado: no se le puede avisar.",
          submit: "Guardar"
        },
        insured: {
          title: "Datos del reclamante",
          empty: "No hay datos de contacto cargados."
        },
        history: {
          title: "Historial",
          status: {
            active: "Turno vigente para el {{at}}",
            superseded: "Turno del {{at}}, reemplazado por otro",
            canceled: "Turno del {{at}}, anulado"
          },
          atBranch: "En {{branch}} ({{provider}})",
          insuredNotified: "se avis\xF3 al reclamante",
          canceledBy: "Anulado por {{actor}} \u2014 {{at}}"
        },
        cancel: {
          title: "Anular el turno",
          description: "El turno del {{at}} queda sin efecto y la orden vuelve a quedar sin coordinar. Si ya se le avis\xF3 al reclamante, se le va a informar la anulaci\xF3n.",
          reason: "Motivo",
          reasonPlaceholder: "Por qu\xE9 se anula el turno\u2026",
          confirm: "Anular turno"
        },
        cancelSuccess: "Turno anulado"
      },
      workProof: {
        tab: "Inspecciones",
        title: "Inspecci\xF3n #{{id}}",
        listTitle: "Inspecciones realizadas",
        listDescription: "Inspecci\xF3n(es) de Autoinspector que validan el trabajo realizado. La orden puede finalizarse una vez que exista al menos una completada, aprobada o no.",
        config: {
          templateConfigured: "Plantilla configurada para prueba de trabajo",
          missingTitle: "Falta configurar la integraci\xF3n de Autoinspector",
          missingApiKey: "La compa\xF1\xEDa no tiene configurada la integraci\xF3n con Autoinspector.",
          missingTemplate: 'No hay una plantilla asignada al caso de uso "Prueba de trabajo".'
        },
        checkboxTemplate: "Plantilla configurada: {{name}}",
        blockedReason: {
          not_required: "Esta orden demuestra el trabajo con un reporte: la decisi\xF3n se toma al crearla y no se puede cambiar.",
          order_not_accepted: "El proveedor todav\xEDa no acept\xF3 la orden: la inspecci\xF3n se crea autom\xE1ticamente cuando la acepte.",
          not_configured: "La compa\xF1\xEDa no tiene configurada integraci\xF3n con Autoinspector.",
          template_not_assigned: 'No hay una plantilla asignada al caso de uso "Prueba de trabajo".',
          inspection_in_progress: "Ya hay una inspecci\xF3n en curso. Esper\xE1 su resultado para solicitar otra.",
          inspection_approved: "La prueba de trabajo ya est\xE1 aprobada.",
          invalid_order_status: "La orden ya est\xE1 cerrada: no se pueden solicitar inspecciones.",
          claim_not_open: "El reclamo no est\xE1 abierto."
        },
        status: {
          pending_capture: "Pendiente",
          capturing: "En curso",
          processing: "En an\xE1lisis",
          approved: "Aprobada",
          disapproved: "Desaprobada",
          error: "Ocurri\xF3 un error",
          blocked: "Bloqueada"
        },
        createdAt: "Creada",
        completedAt: "Analizada",
        empty: {
          insurer: 'No hay ninguna inspecci\xF3n para esta orden: la creaci\xF3n autom\xE1tica no se complet\xF3. Pod\xE9s crearla con "Crear inspecci\xF3n".',
          provider: "Todav\xEDa no hay ninguna inspecci\xF3n para esta orden. La aseguradora tiene que crearla.",
          awaitingAcceptanceInsurer: "La inspecci\xF3n se crear\xE1 autom\xE1ticamente cuando el proveedor acepte la orden.",
          awaitingAcceptanceProvider: "La inspecci\xF3n se crear\xE1 cuando aceptes la orden.",
          notRequired: "Esta orden demuestra el trabajo realizado con un reporte, as\xED que no lleva inspecciones."
        },
        refresh: "Actualizar",
        refreshSuccess: "Estado actualizado",
        viewDetail: "Ver inspecci\xF3n",
        detailTitle: "Detalle de la inspecci\xF3n",
        detailDescription: "Detalle provisto por Autoinspector.",
        openInspection: "Abrir inspecci\xF3n",
        copyLink: "Copiar link",
        linkCopied: "Link copiado",
        qrHint: "Escane\xE1 el c\xF3digo para capturar la evidencia desde tu tel\xE9fono.",
        accessCode: "C\xF3digo de acceso",
        history: "Historial de inspecciones",
        create: {
          trigger: "Crear inspecci\xF3n",
          title: "Crear inspecci\xF3n",
          description: "Se crear\xE1 una nueva inspecci\xF3n en Autoinspector y el proveedor deber\xE1 capturar la evidencia.",
          action: "Crear inspecci\xF3n",
          cancel: "Cancelar",
          success: "Inspecci\xF3n creada"
        },
        report: {
          trigger: "Ver informe",
          title: "Informe de la inspecci\xF3n",
          description: "Informe en PDF de la inspecci\xF3n realizada.",
          openInNewTab: "Abrir en una pesta\xF1a nueva",
          retry: "Reintentar",
          loadError: "No pudimos consultar el estado del informe. Volv\xE9 a intentarlo en unos minutos.",
          status: {
            unavailable: "Todav\xEDa no hay informe para mostrar de esta inspecci\xF3n.",
            generating: "Estamos generando el informe. Puede tardar unos segundos.",
            failed: "No pudimos generar el informe de esta inspecci\xF3n. La aseguradora puede volver a pedirlo desde su panel."
          }
        }
      },
      vehicle: {
        make: "Marca",
        model: "Modelo",
        version: "Versi\xF3n",
        year: "A\xF1o",
        licensePlate: "Patente"
      },
      table: {
        title: "\xD3rdenes de trabajo",
        description: "Lista de \xF3rdenes de trabajo derivadas a tu empresa",
        entityLabel: "\xF3rdenes",
        searchPlaceholder: "Buscar por N\xB0 de orden o descripci\xF3n",
        searchTooltip: "Busca por n\xFAmero de orden o descripci\xF3n de la orden",
        insurerSearchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
        insurerSearchTooltip: "Busca por n\xFAmero de orden, descripci\xF3n de la orden o n\xFAmero de reclamo",
        columns: {
          reference: "Orden",
          derivedAt: "Fecha derivaci\xF3n",
          completedAt: "Fecha finalizaci\xF3n",
          claimRef: "N\xB0 reclamo",
          externalClaimRef: "N\xB0 reclamo externo",
          provider: "Proveedor",
          name: "Descripci\xF3n de la orden",
          service: "Servicio",
          good: "Bien",
          company: "Empresa",
          derivedBy: "Derivado por",
          status: "Estado",
          stage: "Etapa",
          nextAction: "Pr\xF3xima acci\xF3n",
          acceptedAt: "Fecha aceptaci\xF3n",
          totalAmount: "Importe",
          totalWithTaxes: "Importe final"
        }
      },
      mechanism: {
        checkboxLabel: "Incluir prueba de trabajo con Autoinspector",
        autoNotice: "Esta orden incluir\xE1 la prueba de trabajo con Autoinspector. Para finalizarla, el proveedor tiene que completar la inspecci\xF3n.",
        autoNoticeHint: "La inspecci\xF3n se crea cuando el proveedor acepta la orden, y la orden puede finalizarse una vez que la inspecci\xF3n est\xE9 completada.",
        reportNotice: "Esta orden va a demostrar el trabajo con un reporte del proveedor",
        checkboxHint: "La inspecci\xF3n se crea cuando el proveedor acepta la orden, y la orden puede finalizarse una vez completada. Sin ella, el trabajo se demuestra con un reporte del proveedor.",
        summary: "Prueba del trabajo",
        report: {
          label: "Reporte del proveedor"
        },
        inspection: {
          label: "Inspecci\xF3n con Autoinspector"
        },
        notice: {
          report: "Esta orden demuestra el trabajo realizado con un reporte, as\xED que no usa inspecciones. Esta secci\xF3n queda solo para consulta.",
          inspection: "Esta orden demuestra el trabajo realizado con una inspecci\xF3n de Autoinspector, as\xED que no usa reportes. Esta secci\xF3n queda solo para consulta."
        }
      },
      pendingSide: {
        provider: "Proveedor",
        insurer: "Aseguradora"
      },
      inbox: {
        title: "\xD3rdenes que requieren tu atenci\xF3n",
        count: "{{count}} pendientes",
        awaitingProvider: "{{count}} esperando al proveedor",
        empty: "No hay \xF3rdenes esperando una acci\xF3n tuya.",
        seeAll: "Ver todas las \xF3rdenes"
      }
    };
    var variable = {
      value: {
        reference: {
          judicial_amount_times_percentage_of_liability: "Monto Judicial x % de Responsabilidad"
        },
        type: {
          reference: "Referencia",
          literal: "Literal"
        }
      },
      types: {
        text: "Texto",
        numeric: "Num\xE9rico",
        select: "Selecci\xF3n",
        file: "Archivo"
      },
      determination: {
        compile_time: "Compilaci\xF3n",
        runtime: "En tiempo de ejecuci\xF3n"
      }
    };
    var inhouse_lawyer = {
      status: {
        pending: "Pendiente",
        registered: "Registrado"
      },
      name: "Nombre",
      email: "Correo",
      create: {
        trigger: "Agregar abogado interno",
        title: "Agregar abogado interno",
        description: "Completa la informaci\xF3n del abogado interno que deseas vincular a tu empresa",
        submit: "Crear abogado interno",
        success_title: "Abogado interno creado",
        success_description: "El abogado interno {{name}} ha sido creado con \xE9xito"
      },
      edit: {
        trigger: "Editar",
        title: "Editar abogado interno",
        description: "Al cambiar el correo tambi\xE9n se actualiza el que usa para iniciar sesi\xF3n y el que se informa como negociador a la aseguradora",
        submit: "Guardar cambios",
        success_title: "Abogado interno actualizado",
        success_description: "El abogado interno {{name}} ha sido actualizado con \xE9xito"
      }
    };
    var load_balance_rule = {
      paths: {
        desired_support_location_state_municipality: "Partido",
        ramo: "Secci\xF3n",
        desired_support_location_state: "Estado",
        claim_type: "Tipo de reclamo",
        occurrence: {
          city: "Ciudad"
        },
        user_type: "Tipo de usuario",
        is_claimant_and_victim_same_insurer: "Tercero socio",
        sinister_object: "Objeto del siniestro"
      },
      types: {
        claim: "Reclamo",
        complaint: "Denuncia"
      }
    };
    var document2 = {
      group: {
        vehicle_damages: "da\xF1os al veh\xEDculo",
        documentation: "documentaci\xF3n"
      },
      reference: "Referencia",
      generated_at: "Emitido el",
      tax_id: "CUIT",
      agreement: {
        name: "Conformidad",
        filename: "conformidad",
        watermark: {
          preview: "BORRADOR",
          sample: "DOCUMENTO DE PRUEBA"
        },
        signature: {
          date: "Fecha",
          name: "Aclaraci\xF3n",
          identification: "Tipo y N\xB0 documento"
        },
        footer: 'Documento {{id}} \xB7 versi\xF3n {{version}} de la plantilla "{{template}}"'
      },
      generated_note: "Generado en Piramid el {{date}} por {{email}} \xB7 Documento {{document_id}}",
      generated_note_system: "Generado en Piramid el {{date}} \xB7 Documento {{document_id}}",
      footer_disclaimer: "Documento generado autom\xE1ticamente por {{company}}.",
      download: {
        generating_title: "Generando el PDF",
        generating_description: "Estamos generando el documento. Puede demorar unos segundos.",
        ready_title: "El PDF est\xE1 listo",
        ready_description: "Se abre en una pesta\xF1a nueva.",
        open: "Abrir PDF"
      },
      sample: {
        name: "Documento de ejemplo",
        filename: "documento-de-ejemplo",
        summary: "Resumen",
        issued_by: "Emitido por",
        total: "Total",
        notes: "Observaciones",
        items: {
          title: "Detalle",
          description: "Descripci\xF3n",
          quantity: "Cantidad",
          unit_amount: "Precio unitario",
          total_amount: "Importe"
        }
      },
      order_report: {
        name: "Orden de trabajo",
        filename: "orden-de-trabajo",
        number: "ORDEN N\xB0",
        claim_number: "Reclamo N\xB0",
        created_at: "Fecha orden",
        insurer: "Aseguradora",
        provider: "Taller",
        insured: "Reclamante",
        phone: "Tel\xE9fono",
        email: "Correo",
        address: "Direcci\xF3n",
        vehicle: "Veh\xEDculo",
        license_plate: "Patente",
        observation: "Observaci\xF3n",
        details_title: "Detalle de la orden",
        items: {
          quantity: "Cant",
          description: "Descripci\xF3n",
          unit_price: "Precio unitario",
          subtotal: "Importe"
        },
        total_amount: "Importe total",
        amount_to_charge: "A cargo del reclamante",
        coverage_amount: "L\xEDmite de cobertura",
        no_coverage_limit: "SIN L\xCDMITE",
        taxes_amount: "Impuestos ({{percent}}%)",
        total_with_taxes: "Total",
        signature: "Firma reclamante",
        clarification: "Aclaraci\xF3n",
        identification: "Documento N\xB0",
        date: "Fecha y hora",
        work_proof: {
          title: "Prueba de trabajo",
          qr_hint: "Escane\xE1 el c\xF3digo QR para completar la inspecci\xF3n.",
          private_notice: "Uso exclusivo del prestador. No compartir.",
          unavailable_title: "Inspecci\xF3n no disponible",
          not_created: "Todav\xEDa no se cre\xF3 la inspecci\xF3n."
        }
      }
    };
    var circulation = {
      direction: {
        one_way: "\xDAnico",
        two_way: "Doble"
      }
    };
    var license = {
      category: {
        car: "Auto",
        motorcycle: "Moto",
        foreign: "Extranjero",
        other: "Otro"
      }
    };
    var contract = {
      status: {
        open: "Abierto",
        close: "Cerrado"
      }
    };
    var cost = {
      type: {
        one_time: "Un solo pago",
        monthly: "Mensual",
        yearly: "Anualmente"
      }
    };
    var bid = {
      line: {
        unit: {
          hour: "Hora",
          day: "Dia",
          unit: "Piezas",
          km: "Kil\xF3metros"
        },
        type: {
          labor: "Mano de obra",
          auto_part: "Auto-parte",
          material: "Material",
          shipping: "Env\xEDo"
        }
      }
    };
    var rfp = {
      status: {
        open: "Abierto",
        closed: "Cerrado",
        canceled: "Cancelado"
      },
      tab: {
        detail: "Detalle",
        localization: "Zona",
        vendors: "Proveedores",
        files: "Archivos"
      },
      mode: {
        streaming: "En cualquier momento",
        batch: "Al cierre"
      }
    };
    var contact = {
      type: {
        field_adjuster: "Liquidador/Perito",
        vendor: "Proveedor"
      },
      searchUser: "Buscar usuario existente",
      searchUserPlaceholder: "Buscar por correo electr\xF3nico",
      noUsersFound: "No se encontraron usuarios",
      linkedUserMessage: "Usuario vinculado - los campos se completaron autom\xE1ticamente y no son editables",
      registration: {
        invited: "Invitaci\xF3n enviada",
        pending_verification: "Registro sin confirmar",
        registered: "Registrado",
        label: "Estado",
        unreachableAccount: "El email ya pertenece a un usuario de otro tipo: no puede acceder al portal de proveedores."
      },
      resendInvitation: {
        action: "Reenviar invitaci\xF3n",
        confirmTitle: "\xBFReenviar la invitaci\xF3n?",
        confirmDescription: "Se enviar\xE1 nuevamente el correo de invitaci\xF3n al contacto.",
        confirmBack: "Cancelar",
        confirmAction: "Reenviar",
        success: "Invitaci\xF3n reenviada"
      }
    };
    var filters = {
      stage: "Etapa",
      system_status: "Condici\xF3n",
      fraud_status: "Estado de fraude",
      company: "Empresa",
      claimed_amount: "Monto reclamado",
      zone: "Zona",
      coordinator: "Coordinador",
      collaborator: "Colaborador",
      team: "Equipo",
      relationship: "V\xEDnculo",
      ramo: "Ramo",
      sub_status: "Sub-Estado",
      responsible: "Responsable",
      reference: "Referencia",
      type: "Tipo",
      status: "Estado",
      claim_damage: "Da\xF1os",
      is_claimant_and_victim_same_insurer: "Tercero socio",
      customer_organization: "Empresa Customer",
      sinister_object: "Objeto del siniestro",
      good: "Bien",
      service: "Servicio",
      derivation_date: "Fecha de derivaci\xF3n",
      provider: "Proveedor",
      derived_by: "Derivado por",
      clear: "Limpiar",
      order_stage: "Paso",
      pending: "Acci\xF3n pendiente de",
      order_date: "Fecha"
    };
    var filtersPanel = {
      trigger: "Filtros",
      clearAll: "Limpiar todo",
      done: "Listo",
      search: "Buscar...",
      empty: "Ning\xFAn resultado"
    };
    var legal_person = {
      type: {
        hospital: "Hospital",
        worker_compensation_insurer: "ART",
        health_insurance_fund: "Obra social",
        insurer: "Aseguradora"
      }
    };
    var user = {
      availability: {
        schedule_action: "Programar inactividad",
        restore_action: "Finalizar inactividad",
        schedule_title: "Programar inactividad",
        schedule_description: "Defin\xED el per\xEDodo de inactividad de {{name}}. Durante ese lapso no se le asignar\xE1n nuevos reclamos.",
        period_label: "Per\xEDodo",
        period_required: "El rango de fechas es requerido",
        confirm: "Confirmar",
        cancel: "Cancelar",
        schedule_success_title: "Inactividad programada",
        schedule_success_description: "{{name}} no recibir\xE1 nuevos reclamos entre el {{from}} y el {{to}}",
        cancel_action: "Cancelar inactividad",
        cancel_title: "Cancelar inactividad",
        cancel_description: "\xBFConfirm\xE1s cancelar la inactividad de {{name}} programada del {{from}} al {{to}}? No se le va a aplicar.",
        cancel_confirm: "Cancelar inactividad",
        cancel_success_title: "Inactividad cancelada",
        cancel_success_description: "{{name}} ya no tiene una inactividad programada",
        restore_title: "Finalizar inactividad",
        restore_description: "\xBFConfirm\xE1s finalizar la inactividad de {{name}}? Volver\xE1 a recibir reclamos seg\xFAn lo que permita su rol.",
        restore_confirm: "Finalizar",
        restore_success_title: "Inactividad finalizada",
        restore_success_description: "{{name}} vuelve a recibir reclamos",
        unavailable_until: "Inactividad hasta el {{to}}",
        unavailable_between: "Inactividad del {{from}} al {{to}}",
        scheduled_banner_title: "Inactividad programada",
        scheduled_banner_description: "Vas a estar inactivo desde el {{from}} y volv\xE9s el {{to}}",
        return_banner_title: "Fin de la inactividad",
        return_banner_description: "A partir del {{date}} volv\xE9s a estar activo y a recibir reclamos nuevos."
      },
      override_permission: {
        can_create_judicial_amount: "Crear Monto Judicial",
        can_update_judicial_amount: "Actualizar Monto Judicial",
        can_create_administrative_amount: "Crear Monto Admin.",
        can_update_administrative_amount: "Actualizar Monto Admin.",
        can_create_percentage_of_liability: "Crear % de Responsabilidad",
        can_update_percentage_of_liability: "Actualizar % de Responsabilidad"
      },
      type: {
        system: "Sistema",
        third: "Tercero",
        insurer: "Aseguradora",
        policyholder: "Asegurado",
        backoffice: "Backoffice",
        inhouse_lawyer: "Abogado Interno",
        field_adjuster: "Liquidador/Perito",
        vendor: "Proveedor"
      },
      delegation: {
        action: "Delegar reclamos",
        dialog_title: "Reclamos de {{name}}",
        dialog_description: "Deleg\xE1 los reclamos de los que es responsable entre su equipo, o recuper\xE1 los que ya tiene delegados.",
        restore_all_action: "Recuperar todos",
        restore_all_title: "\xBFRecuperar los {{count}} reclamos delegados?",
        restore_all_description: "Los usuarios a quienes fueron delegados dejar\xE1n de verlos. Los que est\xE9n derivados a un tercero se quedan con quien los tiene y vuelven a esta lista cuando se los devuelvan.",
        restore_all_confirm: "Continuar",
        restore_all_cancel: "Cancelar",
        restore_all_empty_title: "No hay reclamos para recuperar",
        restore_all_empty_description: "No quedan reclamos delegados pendientes.",
        restore_all_queued_title: "Procesando en segundo plano",
        restore_all_queued_description: "{{count}} reclamo(s) en proceso de recuperaci\xF3n. Pod\xE9s ver el progreso al lado del t\xEDtulo."
      }
    };
    var zod = {
      errors: {
        missing_variable_definition: "El mensaje contiene una referencia una variable inexistente",
        invalid_type: "Se esperaba {{expected}}, se recibi\xF3 {{received}}",
        invalid_type_received_undefined: "Requerido",
        invalid_literal: "Valor literal inv\xE1lido, se esperaba {{expected}}",
        unrecognized_keys: "Llave(s) no reconocida(s) en el objeto: {{- keys}}",
        invalid_union: "Entrada inv\xE1lida",
        invalid_union_discriminator: "Valor discriminador inv\xE1lido. Se esperaba {{- options}}",
        invalid_enum_value: "Valor inv\xE1lido. Se esperaba {{- options}}, se recibi\xF3 '{{received}}'",
        invalid_arguments: "Argumentos de funci\xF3n inv\xE1lidos",
        invalid_return_type: "Tipo de retorno de funci\xF3n inv\xE1lido",
        invalid_date: "Fecha inv\xE1lida",
        custom: "Entrada inv\xE1lida",
        invalid_intersection_types: "Valores de intersecci\xF3n no pudieron ser mezclados",
        not_multiple_of: "N\xFAmero debe ser m\xFAltiplo de {{multipleOf}}",
        not_finite: "N\xFAmero no puede ser infinito",
        invalid_string: {
          email: "{{validation}} inv\xE1lido",
          url: "{{validation}} inv\xE1lido",
          uuid: "{{validation}} inv\xE1lido",
          cuid: "{{validation}} inv\xE1lido",
          regex: "Inv\xE1lido",
          datetime: "{{validation}} inv\xE1lida",
          startsWith: 'Entrada inv\xE1lida: debe comenzar con "{{startsWith}}"',
          endsWith: 'Entrada inv\xE1lida: debe finalizar con "{{endsWith}}"'
        },
        too_small: {
          array: {
            exact: "La lista debe contener exactamente {{minimum}} elemento(s)",
            inclusive: "La lista debe contener al menos {{minimum}} elemento(s)",
            not_inclusive: "La lista debe contener m\xE1s de {{minimum}} elemento(s)"
          },
          string: {
            exact: "El texto debe contener exactamente {{minimum}} car\xE1cter(es)",
            inclusive: "El texto debe contener al menos {{minimum}} car\xE1cter(es)",
            not_inclusive: "El texto debe contener m\xE1s de {{minimum}} car\xE1cter(es)"
          },
          number: {
            exact: "El n\xFAmero debe ser exactamente {{minimum}}",
            inclusive: "El n\xFAmero debe ser mayor o igual a {{minimum}}",
            not_inclusive: "El n\xFAmero debe ser mayor que {{minimum}}"
          },
          set: {
            exact: "Entrada inv\xE1lida",
            inclusive: "Entrada inv\xE1lida",
            not_inclusive: "Entrada inv\xE1lida"
          },
          date: {
            exact: "La fecha debe ser exactamente {{- minimum, datetime}}",
            inclusive: "La fecha debe ser mayor o igual al {{- minimum, datetime}}",
            not_inclusive: "La fecha debe ser mayor que el {{- minimum, datetime}}"
          }
        },
        too_big: {
          array: {
            exact: "La lista debe contener exactamente {{maximum}} elemento(s)",
            inclusive: "La lista debe contener como m\xE1ximo {{maximum}} elemento(s)",
            not_inclusive: "La lista debe contener menos que {{maximum}} elemento(s)"
          },
          string: {
            exact: "El texto debe contener exactamente {{maximum}} car\xE1cter(es)",
            inclusive: "El texto debe contener como m\xE1ximo {{maximum}} car\xE1cter(es)",
            not_inclusive: "El texto debe contener menos de {{maximum}} car\xE1cter(es)"
          },
          number: {
            exact: "El n\xFAmero debe ser exactamente {{maximum}}",
            inclusive: "El n\xFAmero debe ser menor o igual a {{maximum}}",
            not_inclusive: "El n\xFAmero debe ser menor que {{maximum}}"
          },
          set: {
            exact: "Entrada inv\xE1lida",
            inclusive: "Entrada inv\xE1lida",
            not_inclusive: "Entrada inv\xE1lida"
          },
          date: {
            exact: "La fecha debe ser exactamente {{- maximum, datetime}}",
            inclusive: "La fecha debe ser menor o igual al {{- maximum, datetime}}",
            not_inclusive: "La fecha debe ser menor que el {{- maximum, datetime}}"
          }
        }
      },
      validations: {
        email: "correo",
        url: "enlace",
        uuid: "uuid",
        cuid: "cuid",
        regex: "expresi\xF3n regular",
        datetime: "fecha"
      },
      types: {
        function: "funci\xF3n",
        number: "n\xFAmero",
        string: "texto",
        nan: "valor no n\xFAmerico",
        integer: "entero",
        float: "decimal",
        boolean: "booleano",
        date: "fecha",
        bigint: "entero grande",
        undefined: "indefinido",
        symbol: "s\xEDmbolo",
        null: "nulo",
        array: "lista",
        object: "objeto",
        unknown: "desconocido",
        promise: "promesa",
        void: "void",
        never: "nunca",
        map: "mapa",
        set: "conjunto"
      }
    };
    var inspection = {
      verdict: {
        approved: "Aprobado",
        disapproved: "Desaprobado",
        not_defined: "No definido",
        not_provided: "Sin resultado"
      },
      type: {
        bike: "Bicicleta",
        car: "Auto",
        moto: "Moto",
        people: "Persona",
        goods: "Bienes",
        machinery: "Maquinaria",
        custom: "Personalizado"
      },
      status: {
        created: "Creado",
        started: "Empezado",
        completed: "Completado",
        blocked: "Bloqueado",
        processing: "Procesando"
      },
      consumer_type: {
        policyholder: "Asegurado",
        claimant: "Tercero"
      }
    };
    var professions = {
      lawyer: "Abogado",
      other: "Otro"
    };
    var exported_report = {
      types: {
        sla_complaint: "sla-denuncias",
        sla_claim: "sla-reclamos",
        claim: "reclamos",
        event: "eventos",
        order: "ordenes-de-trabajo",
        backoffice_order: "ordenes-de-trabajo-global"
      },
      "event-columns": {
        user: "Usuario",
        email: "Email",
        event: "Evento",
        metadata: "Metadata",
        sinister_id: "ID Siniestro",
        selected_external_complaint: "N\xBA Siniestro",
        claim_id: "ID Reclamo",
        external_claim_request_id: "N\xBA Reclamo",
        remote_ip: "Direcci\xF3n IP",
        user_agent: "User Agent",
        date: "Fecha"
      },
      "order-columns": {
        company_name: "Empresa",
        ref_id: "N\xB0 Orden",
        created_at: "Fecha de derivaci\xF3n",
        status: "Estado de la orden",
        claim_ref_id: "N\xB0 Reclamo",
        claim_external_id: "N\xB0 Reclamo externo",
        claim_created_at: "Fecha de alta del reclamo",
        claim_status: "Estado del reclamo",
        claim_owner_name: "Responsable del reclamo",
        insurer_name: "Aseguradora origen",
        claimant_name: "Damnificado",
        claimant_identification: "Documento del damnificado",
        vehicle_make: "Marca del veh\xEDculo",
        vehicle_model: "Modelo del veh\xEDculo",
        vehicle_version: "Versi\xF3n del veh\xEDculo",
        vehicle_year: "A\xF1o del veh\xEDculo",
        vehicle_license_plate: "Patente del veh\xEDculo",
        service_name: "Servicio",
        good_name: "Bien",
        name: "T\xEDtulo",
        items_quantity: "Cantidad de productos",
        items_detail: "Productos",
        currency: "Moneda",
        total_amount: "Importe",
        coverage_amount: "Cobertura",
        amount_to_charge: "Importe neto",
        taxes_percent: "IVA (%)",
        taxes_amount: "IVA",
        total_with_taxes: "Total",
        provider_legal_name: "Proveedor",
        provider_ein: "CUIT del proveedor",
        provider_external_id: "C\xF3digo interno del proveedor",
        derived_by_name: "Derivado por",
        scheduled_for: "Turno coordinado",
        scheduled_branch: "Sucursal del turno",
        workflow_stage: "Etapa",
        description: "Descripci\xF3n",
        items_brands: "Marcas",
        vertical_name: "Vertical",
        accepted_at: "Fecha de aceptaci\xF3n",
        completed_at: "Fecha de finalizaci\xF3n",
        rejected_at: "Fecha de rechazo",
        rejected_reason: "Motivo de rechazo",
        canceled_at: "Fecha de anulaci\xF3n",
        canceled_reason: "Motivo de anulaci\xF3n",
        work_proof_mechanism: "Prueba de trabajo",
        work_proof_status: "Estado de la inspecci\xF3n",
        provider_email: "Email del proveedor",
        derived_by_email: "Email de quien deriv\xF3",
        locality_name: "Localidad",
        department_name: "Departamento",
        province_name: "Provincia",
        sinister_external_id: "N\xB0 Siniestro origen",
        claim_system_status: "Condici\xF3n del reclamo",
        claim_ramo: "Ramo",
        occurrence_sinister_date: "Fecha del siniestro",
        claimant_email: "Email del damnificado",
        claimant_phone: "Tel\xE9fono del damnificado",
        claimant_address: "Domicilio del damnificado",
        policyholder_policy_number: "N\xB0 de p\xF3liza",
        policyholder_license_plate: "Patente del asegurado",
        insurance_coverage: "Cobertura de la p\xF3liza",
        insurance_policy_number: "N\xB0 de p\xF3liza del da\xF1o",
        insurance_franchise_amount: "Franquicia"
      },
      columns_count: "Columnas ({{count}})"
    };
    var claims = {
      offer: {
        status: {
          pending: "Pendiente",
          accepted: "Aceptado",
          rejected: "Rechazado",
          canceled: "Anulado",
          expired: "Expirado"
        }
      },
      export: {
        select_all: "Seleccionar todas",
        deselect_all: "Deseleccionar todas"
      },
      columns: {
        external_claim_id: "N. Reclamo Externo",
        complaint_registered_by: "Nombre Creador Denuncia",
        responsible_email: "Email Responsable",
        responsible_name: "Nombre Responsable",
        claimed_amount: "Monto reclamado",
        complaint_agency: "Agencia Denuncia",
        complaint_external_id: "N. Siniestro de Denuncia",
        complaint_external_status: "Estado Denuncia",
        complaint_handler_email: "Email Tramitador Denuncia",
        complaint_handler_name: "Nombre Tramitador Denuncia",
        complaint_location: "Ubicaci\xF3n Denuncia",
        complaint_occurrence_date: "Fecha Ocurrencia Denuncia",
        complaint_registered_at: "Fecha Registro Denuncia",
        created_at: "Fecha Creaci\xF3n Reclamo",
        created_by_email: "Email Creador Reclamo",
        created_by_name: "Nombre Creador Reclamo",
        declared_damages: "Da\xF1os Declarados",
        desired_support_location: "Ubicaci\xF3n Reclamo",
        fraud_close_motive: "Motivo Cierre Investigaci\xF3n Fraude",
        fraud_created_at: "Fecha Creaci\xF3n Investigaci\xF3n Fraude",
        fraud_description: "Descripci\xF3n Investigaci\xF3n Fraude",
        fraud_sinister_number: "N. Siniestro Investigaci\xF3n Fraude",
        fraud_external_status: "Estado Investigaci\xF3n Fraude",
        fraud_instance: "Instancia Investigaci\xF3n Fraude",
        fraud_reason: "Motivo Investigaci\xF3n Fraude",
        fraud_report_accepted_by_email: "Email Aceptador Reporte Investigaci\xF3n Fraude",
        fraud_report_accepted_by_name: "Nombre Aceptador Reporte Investigaci\xF3n Fraude",
        fraud_report_conclusion: "Conclusi\xF3n Reporte Investigaci\xF3n Fraude",
        fraud_report_lab: "Estudio Reporte Investigaci\xF3n Fraude",
        fraud_responsible_email: "Email Responsable Investigaci\xF3n Fraude",
        fraud_responsible_name: "Nombre Responsable Investigaci\xF3n Fraude",
        fraud_result: "Resultado Investigaci\xF3n Fraude",
        fraud_sinister_type: "Tipo Siniestro Investigaci\xF3n Fraude",
        fraud_external_id: "N. Investigaci\xF3n Fraude",
        id: "N. Reclamo",
        occurrence_address: "Direcci\xF3n Ocurrencia",
        occurrence_city: "Ciudad Ocurrencia",
        occurrence_state: "Provincia Ocurrencia",
        occurrence_country: "Pa\xEDs Ocurrencia",
        occurrence_description: "Descripci\xF3n Ocurrencia",
        occurrence_sinister_date: "Fecha Ocurrencia",
        occurrence_zip_code: "C\xF3digo Postal Ocurrencia",
        policyholder_license_plate: "Patente Asegurado",
        policyholder_policy_number: "N. P\xF3liza Asegurado",
        ramo: "Ramo",
        reference: "Referencia",
        status: "Condici\xF3n",
        victim_type: "Tipo de v\xEDctima",
        victim_city: "Ciudad V\xEDctima",
        victim_identification_type: "Tipo de documento V\xEDctima",
        victim_identification_value: "N. Documento V\xEDctima",
        victim_name: "Nombre V\xEDctima",
        claim_status: "Estado del Reclamo",
        team: "Grupo",
        closed_at: "Fecha Baja Reclamo",
        offers_count: "Cantidad de Ofrecimientos",
        latest_offer_amount: "Importe \xDAltimo Ofrecimiento",
        latest_offer_status: "Estado \xDAltimo Ofrecimiento",
        latest_offer_sent_at: "Fecha \xDAltimo Ofrecimiento",
        current_pretension: "Pretensi\xF3n Actual",
        material_judicial_amount: "Monto Judicial Da\xF1os Materiales",
        person_judicial_amount: "Monto Judicial Da\xF1os Corporales",
        material_administrative_amount: "Monto Administrativo Da\xF1os Materiales",
        person_administrative_amount: "Monto Administrativo Da\xF1os Corporales",
        percentage_of_liability: "% Responsabilidad",
        person_percentage_of_judicial_risk: "% Riesgo Judicial",
        estimates_updated_at: "Fecha Actualizaci\xF3n Estimaciones"
      },
      "delegate-strategies": {
        users: "Usuarios",
        team: "Equipo"
      },
      "derive-strategies": {
        user: "Usuario",
        team: "Equipo"
      },
      "return-responsibility": {
        "reason-hint": "Indica el motivo del retorno del reclamo",
        "inactive-deriver-hint": "Si el tramitador que deleg\xF3 se encuentra inactivo, el reclamo ser\xE1 derivado a un tramitador del mismo equipo."
      }
    };
    var notifications = {
      scopes: {
        unread: "Sin leer",
        read: "Le\xEDdo",
        all: "Todas"
      },
      view: {
        true: "Le\xEDdo"
      }
    };
    var fraud = {
      conclusions: {
        positive: "Positivo",
        negative: "Negativo"
      },
      results: {
        resignation: "Resignaci\xF3n",
        surrender: "Desistimiento",
        negative: "Negativo",
        fraud: "Fraude",
        positive: "Positivo",
        elements_for_rejection: "Elementos para rechazo",
        in_extension: "En ampliaci\xF3n",
        canceled: "Cancelado",
        possible_prescription: "Posible prescripci\xF3n",
        without_result: "Sin Definir",
        not_defined: "Sin definir",
        not_derived: "No se deriva",
        canceled_by_management: "De baja por gerencia"
      },
      claimResults: {
        fraud: "Fraude",
        not_fraud: "Sin fraude",
        not_defined: "Sin definir"
      },
      internalStatus: {
        not_assigned: "No asignado",
        in_progress: "En curso",
        closed: "Cerrado"
      },
      status: {
        not_assigned: "Sin asignar",
        in_progress: "En curso",
        derived_to_lab: "Derivado a estudio",
        in_extension: "En ampliaci\xF3n",
        without_result: "Sin resultado",
        closed: "Cerrada"
      },
      attributes: {
        status: "Estado",
        kach_status: "Estado en Kach"
      },
      automatic_derivation: "Derivaci\xF3n autom\xE1tica",
      case_created_in_kach: "Cre\xF3 el caso en Kach \xB7 derivaci\xF3n autom\xE1tica"
    };
    var breadcrumb = {
      contract: "Contratos",
      request: "Licitaciones",
      fraud: "Investigaci\xF3n de fraude",
      complaint: "Denuncia",
      sinister: "Siniestro",
      claim: "Reclamos",
      inspection: "Inspecci\xF3n"
    };
    var complaint = {
      attributes: {
        is_recoverable: {
          label: "Recuperable",
          value: {
            true: "S\xED",
            false: "No"
          }
        },
        requires_spare_parts: {
          label: "Requiere repuestos",
          value: {
            true: "S\xED",
            false: "No"
          }
        }
      },
      "system-status": {
        open: "Abierto",
        closed: "Cerrado"
      },
      reference: {
        on_claim: "Generaci\xF3n de Reclamo",
        technical_analysis: "An\xE1lisis T\xE9cnico",
        inspection: "Inspecci\xF3n",
        responsibility_analysis: "An\xE1lisis de Responsabilidad",
        negotiation: "Negociaci\xF3n",
        payment_process: "En proceso de Pago",
        homologation: "Homologaci\xF3n",
        demand_transfer: "Traslado Demanda",
        canceled: "Anulado",
        rejected: "Rechazado (luego del An\xE1lisis)",
        settlement_payment: "Liquidaci\xF3n y Pago",
        mediation: "Mediaci\xF3n",
        judgment: "Juicio",
        fraud: "Indicio de Fraude"
      },
      role: {
        none: "Sin rol",
        default: "Default",
        documentation_completed: "Documentaci\xF3n completa",
        documentation_request: "Documentaci\xF3n requerida",
        criminal_case_request: "Solicitud causa penal",
        offer_flow: "Ofrecimiento",
        not_response: "Sin respuesta",
        claim_rejected: "Rechazo",
        additional_management: "Gestiones adicionales"
      },
      types: {
        vehicle: "Veh\xEDculo",
        building: "Edificio",
        glass: "Cristales",
        medical_assistance_accident: "Asistencia medica por accidente",
        electronic_equipment: "Equipos electr\xF3nicos",
        theft: "Robo",
        other: "Otro"
      },
      tabs: {
        orders: "Ordenes",
        estimates: "Estimaciones",
        offers: "Ofrecimiento",
        "evaluation/reports": "Evaluacion",
        rfps: "Licitaciones",
        activity: "Actividad",
        documents: "Documentaci\xF3n",
        detail: "Detalle",
        inspections: "Inspecciones",
        inspection: "Inspecciones"
      },
      steps: {
        "vehicle-identification-key": "\xBFEl veh\xEDculo cuenta con N\xFAmero de Chapa?",
        "policyholder-type": "\xBFEs usted una persona f\xEDsica o jur\xEDdica?",
        "policyholder-info": "Informaci\xF3n del asegurado",
        "ask-police-intervention": "\xBFHubo intervenci\xF3n policial?",
        "complaint-type": "Tipo de denuncia",
        "occurrence-sinister": "Datos del siniestro",
        "third-party-info": "Datos del tercero involucrado",
        "is-third-party-involved": "\xBFHay un tercero involucrado?",
        "has-damage-budget": "\xBFYa cuentas con alg\xFAn presupuesto?",
        "did-third-party-flee": "\xBFEl tercero se dio a la fuga?",
        "vehicle-driver-info": "Datos del conductor",
        "policyholder-vehicle-info": "Datos vehiculares del asegurado",
        "current-email": "Email actual",
        welcome: "Bienvenido \u{1F44B}",
        "insured-info": "Informaci\xF3n del asegurado",
        "driver-detail": "Detalle del conductor",
        "insured-type": "Tipo de asegurado",
        "third-party-exists": "\xBFExiste un tercero?",
        "third-party-vehicle-type": "Tipo de veh\xEDculo del tercero",
        "third-party-detail": "Detalle del tercero",
        occurrence: "Siniestro",
        "complaint-confirmation": "Resumen",
        "complaint-other-details": "Detalle del riesgo",
        "doc-load": "Carga de documentos"
      },
      status: {
        role: {
          default: "Default"
        },
        open: "Abierto",
        closed: "Cerrado",
        reference: {
          claimant_disinterest: "Desinter\xE9s del Reclamante",
          not_successful: "No Prosper\xF3",
          reconciled: "Conciliado",
          in_closing_process: "En proceso de Cierre",
          derivation: "Derivaci\xF3n",
          analysis: "An\xE1lisis del reclamo",
          on_claim: "Generaci\xF3n de Reclamo",
          technical_analysis: "An\xE1lisis T\xE9cnico",
          inspection: "Inspecci\xF3n",
          responsibility_analysis: "An\xE1lisis de Responsabilidad",
          negotiation: "Negociaci\xF3n",
          payment_process: "En proceso de Pago",
          homologation: "Homologaci\xF3n",
          demand_transfer: "Traslado Demanda",
          canceled: "Anulado",
          rejected: "Rechazado (luego del An\xE1lisis)",
          settlement_payment: "Liquidaci\xF3n y Pago",
          mediation: "Mediaci\xF3n",
          judgment: "Juicio",
          fraud: "Indicio de Fraude"
        }
      },
      "delegate-strategies": {
        users: "Usuarios",
        team: "Equipo"
      }
    };
    var validation_pattern = {
      extractors: {
        rivadavia: "Rivadavia",
        tajy: "Tajy"
      },
      columns: {
        policy_number: "N\xFAmero de p\xF3liza",
        external_claim_id: "ID Reclamo Externo"
      }
    };
    var frequency = {
      monthly: "Mensual",
      daily: "Diario"
    };
    var claimants = {
      natural_person: "Persona f\xEDsica",
      legal_person: "Persona jur\xEDdica"
    };
    var claim = {
      summary: {
        intake: {
          title: "Datos de la derivaci\xF3n",
          insurer: "Aseguradora de origen",
          service: "Servicio a realizar",
          good: "Bien afectado",
          repair_locality: "Localidad o zona del servicio",
          empty: "Sin datos",
          saved: "Datos de la derivaci\xF3n actualizados"
        }
      },
      responsible: {
        group: {
          current_team_membership: "Miembros del equipo",
          prev_responsible: "Responsables anteriores",
          team_coordinator: "Equipos derivables"
        }
      },
      "new-claim-block": {
        inactive: "Inactivo",
        paused: "No disponible",
        overloaded: "Sobrepasado",
        hints: {
          inactive: "Est\xE1 inactivo: no puede recibir el reclamo.",
          "inactive-until": "Est\xE1 inactivo y vuelve el {{date}}: no puede recibir el reclamo.",
          paused: "No est\xE1 recibiendo reclamos nuevos.",
          overloaded: "Ya tiene m\xE1s carga que la habitual de su equipo. Pod\xE9s asign\xE1rselo igual."
        }
      },
      sinisterTypes: {
        policyholder: {
          text: "Siniestro sin veh\xEDculo involucrado",
          description: "Utiliz\xE1 esta opci\xF3n **SOLO** si tu siniestro no fue contra un veh\xEDculo automotor."
        },
        policyholder_vehicle: {
          text: "Siniestro con un veh\xEDculo asegurado en {{companyName}}",
          description: "Complet\xE1 la patente del asegurado, la fecha y hora del hecho. Nosotros identificamos su p\xF3liza autom\xE1ticamente."
        }
      },
      "system-status": {
        open: "Abierto",
        closed: "Cerrado"
      },
      attributes: {
        intake: {
          label: "Datos de la derivaci\xF3n",
          insurer: {
            label: "Aseguradora de origen"
          },
          service: {
            label: "Servicio a realizar"
          },
          good: {
            label: "Bien afectado"
          },
          repair_locality: {
            label: "Localidad o zona del servicio"
          }
        },
        damages: {
          fixed: {
            label: "\xBFFue arreglado?"
          },
          label: "Da\xF1os",
          material: {
            insurance: {
              label: "Seguro",
              has_insurance: {
                label: "\xBFPosee seguro?",
                hint: "Si ten\xE9s seguro pero no encontr\xE1s tu aseguradora en el listado, eleg\xED S\xED y seleccion\xE1 OTRAS ASEGURADORAS",
                value: {
                  true: "S\xED",
                  false: "No"
                }
              },
              coverage: {
                label: "Cobertura",
                value: {
                  civil_responsibility: "Responsabilidad Civil",
                  third_robbery_fire: "Tercero, Robo e incendio",
                  third_full: "Tercero Completo",
                  all_risks_without_franchise: "Todo Riesgo sin Franquicia",
                  all_risks_with_franchise: "Todo Riesgo con Franquicia"
                }
              },
              insurer: {
                label: "Aseguradora",
                hint: "Si no encontr\xE1s tu aseguradora en el listado, seleccion\xE1 OTRAS ASEGURADORAS"
              },
              policy_number: {
                label: "N\xFAmero de p\xF3liza"
              },
              franchise_amount: {
                label: "Monto de franquicia"
              }
            },
            label: "Materiales",
            vehicle: {
              type: {
                label: "Tipo",
                value: {
                  bike: "Bicicleta",
                  machinery: "Maquinaria",
                  skateboard: "Monopat\xEDn",
                  other: "Otro",
                  car: "Auto",
                  moto: "Moto"
                }
              },
              make: {
                label: "Marca del veh\xEDculo"
              },
              model: {
                label: "Modelo del veh\xEDculo"
              },
              year: {
                label: "A\xF1o del veh\xEDculo"
              },
              version: {
                label: "Versi\xF3n del veh\xEDculo"
              },
              market_value: {
                label: "Valor venal"
              },
              use: {
                label: "Uso del veh\xEDculo",
                value: {
                  private: "Particular",
                  public: "P\xFAblico",
                  taxi: "Taxi",
                  remis: "Remis",
                  rental: "Alquiler de Autos",
                  ambulance: "Ambulancia",
                  police: "Patrullero",
                  school: "Escuela",
                  specialService: "Sev. Especial Plataforma Electron",
                  special_service: "Sev. Especial Plataforma Electron",
                  goods: "Transporte de mercader\xEDas",
                  persons: "Transporte de personas",
                  special_school_pickup: "Servicios Especiales y Escolares (Pick Up)",
                  goods_transport: "Transporte de Bienes",
                  local: "Locales",
                  route_service: "Ruteros",
                  school_transport: "Escolares",
                  electronic_platform: "Servicio Especial Plataforma Electr\xF3nica",
                  delivery_service: "Servicio de Reparto y Mensajer\xEDa",
                  agency: "Agencias (Con/Sin Chofer c/ chapa Particular)"
                }
              },
              category: {
                label: "Categor\xEDa",
                value: {
                  with_license_plate: "Veh\xEDculo con patente (Auto o Moto)",
                  without_license_plate: "Veh\xEDculo sin patente (Bicicleta, Monopatines, Maquinaria, etc)"
                }
              },
              license_plate: {
                label: "Patente"
              },
              chassis: {
                label: "Chassis"
              },
              engine: {
                label: "Motor"
              },
              label: "Veh\xEDculo",
              driver: {
                ownership: {
                  label: "Conductor Propiedad",
                  value: {
                    owner: "Due\xF1o",
                    third: "Tercero"
                  }
                },
                label: "Conductor",
                first_name: {
                  label: "Conductor Nombre"
                },
                last_name: {
                  label: "Conductor Apellido"
                },
                cellphone: {
                  label: "Conductor Celular"
                }
              }
            }
          },
          person: {
            health_insurance_fund: {
              label: "Obra social"
            },
            surgery_description: {
              label: "Intervenci\xF3n quir\xFArgica"
            },
            treatment_medical_institution: {
              label: "Instituci\xF3n M\xE9dica"
            },
            treatment_worker_compensation_insurer: {
              label: "ART"
            },
            policyholder_relationship_other: {
              label: "Otro v\xEDnculo"
            },
            policyholder_relationship: {
              label: "Relaci\xF3n con el asegurado"
            },
            label: "Persona",
            victim_role: {
              label: "Condici\xF3n de",
              value: {
                pedestrian: "Peat\xF3n",
                driver: "Conductor del veh\xEDculo tercero",
                rider: "Transportado en el veh\xEDculo tercero",
                policyholder_rider: "Transportado en el veh\xEDculo asegurado en {{insurerName}}"
              }
            }
          }
        },
        claimants: {
          label: "Reclamante",
          role: {
            label: "Rol",
            value: {
              claimant: "Reclamante",
              heir: "Heredero"
            }
          },
          ownership_history: {
            label: "Transferencias de reclamo"
          },
          victim_relationship_other: {
            label: "Otro v\xEDnculo"
          },
          victim_relationship: {
            label: "V\xEDnculo con damnificado",
            value: {
              label: "Relaci\xF3n con el asegurado",
              mother: "Madre",
              father: "Padre",
              other_family_member: "Otro familiar",
              tutor_curator: "Tutor/Curador",
              attorney_in_fact: "Abogado apoderado",
              legal_representative: "Apoderado legal",
              attorney_representative: "Abogado patrocinante",
              other: "Otro",
              brother: "Hermano",
              producer: "Productor",
              workshopper: "Tallerista",
              own: "Reclamo en nombre propio",
              particular_victim: "Damnificado particular",
              son: "Hijo/a",
              spouse: "C\xF3nyuge",
              concubine: "Concubino/a",
              grandparent: "Abuelo/a"
            }
          },
          natural_person: {
            parents: {
              label: "Padres",
              first_name: {
                label: "Nombre"
              },
              last_name: {
                label: "Apellido"
              },
              identification: {
                label: "Documento"
              },
              type: {
                label: "Tipo",
                value: {
                  father: "Padre",
                  mother: "Madre"
                }
              }
            },
            label: "Persona F\xEDsica",
            first_name: {
              label: "Nombre"
            },
            last_name: {
              label: "Apellido"
            },
            birth_date: {
              label: "Fecha de nacimiento"
            },
            sex: {
              label: "G\xE9nero"
            },
            identification_type: {
              label: "Tipo de documento"
            },
            identification_value: {
              label: "Documento"
            },
            nationality: {
              label: "Nacionalidad"
            },
            state: {
              label: "Provincia"
            },
            city: {
              label: "Ciudad"
            },
            address: {
              label: "Direcci\xF3n"
            },
            zip_code: {
              label: "C\xF3digo postal"
            },
            email: {
              label: "Correo electr\xF3nico"
            }
          }
        },
        victim: {
          label: "Damnificado",
          natural_person: {
            cellphone: {
              label: "Celular"
            },
            marital_status: {
              label: "Estado civil",
              value: {
                single: "Soltero/a",
                married: "Casado/a",
                widowed: "Viudo/a",
                divorced: "Divorciado/a",
                common_law: "Uni\xF3n de hecho",
                separated: "Separado/a"
              }
            },
            parents: {
              label: "Padres",
              first_name: {
                label: "Nombre"
              },
              last_name: {
                label: "Apellido"
              },
              identification: {
                label: "Documento"
              },
              type: {
                label: "Tipo",
                value: {
                  father: "Padre",
                  mother: "Madre"
                }
              }
            },
            label: "Persona F\xEDsica",
            first_name: {
              label: "Nombre"
            },
            last_name: {
              label: "Apellido"
            },
            birth_date: {
              label: "Fecha de nacimiento"
            },
            sex: {
              label: "G\xE9nero",
              value: {
                male: "Masculino",
                female: "Femenino",
                other: "Otro"
              }
            },
            identification_type: {
              label: "Tipo de documento",
              value: {
                national_id_document: "DNI",
                enrollment_book: "Libreta Enrolamiento",
                civil_registry_card: "Libreta C\xEDvica",
                passport: "Pasaporte",
                cuil: "CUIL",
                cuit: "CUIT"
              }
            },
            identification_value: {
              label: "Documento"
            },
            nationality: {
              label: "Nacionalidad"
            },
            state: {
              label: "Provincia"
            },
            city: {
              label: "Ciudad"
            },
            address: {
              label: "Direcci\xF3n"
            },
            address_street: {
              label: "Calle"
            },
            address_number: {
              label: "N\xFAmero"
            },
            address_apartment: {
              label: "Departamento"
            },
            zip_code: {
              label: "C\xF3digo postal"
            },
            email: {
              label: "Correo electr\xF3nico"
            }
          },
          victim_relationship: {
            label: ""
          }
        },
        owner: {
          label: "Usuario reclamante",
          username: {
            label: "Nombre de usuario"
          },
          email: {
            label: "Correo"
          },
          first_name: {
            label: "Nombre"
          },
          last_name: {
            label: "Apellido"
          },
          cellphone: {
            label: "Celular"
          },
          identification: {
            label: "Identificaci\xF3n"
          },
          sex: {
            label: "G\xE9nero"
          }
        },
        created_by: {
          label: "Usuario creador",
          username: {
            label: "Nombre de usuario"
          },
          email: {
            label: "Correo"
          },
          first_name: {
            label: "Nombre"
          },
          last_name: {
            label: "Apellido"
          },
          cellphone: {
            label: "Celular"
          },
          identification: {
            label: "Identificaci\xF3n"
          },
          sex: {
            label: "G\xE9nero"
          }
        },
        sinister: {
          label: "Siniestro",
          date: {
            label: "Fecha del siniestro"
          },
          license_plate: {
            label: "Patente del asegurado"
          },
          external_complaint: {
            label: "Denuncia",
            date: {
              label: "Fecha"
            },
            agency: {
              label: "Agencia"
            },
            external_id: {
              label: "N\xFAmero de siniestro"
            },
            external_status: {
              label: "Estado"
            },
            occurrence_date: {
              label: "Fecha de la denuncia"
            },
            registered_by: {
              label: "Registrado por"
            },
            policyholder: {
              label: "Asegurado",
              policy_number: {
                label: "N\xFAmero de p\xF3liza"
              },
              agency: {
                label: "Agencia"
              },
              order: {
                label: "Orden"
              },
              cuil: {
                label: "CUIL"
              },
              address: {
                label: "Direcci\xF3n"
              },
              city: {
                label: "Ciudad"
              },
              country: {
                label: "Pa\xEDs"
              },
              make: {
                label: "Marca"
              },
              model: {
                label: "Modelo"
              },
              identification: {
                label: "Identificaci\xF3n"
              },
              first_name: {
                label: "Nombre"
              },
              last_name: {
                label: "Apellido"
              },
              sex: {
                label: "G\xE9nero"
              },
              landline_phone: {
                label: "Tel\xE9fono"
              },
              marital_status: {
                label: "Estado civil"
              },
              license_plate: {
                label: "Patente"
              },
              plan: {
                label: "Plan"
              },
              use: {
                label: "Uso"
              },
              yer: {
                label: "A\xF1o"
              },
              zip_code: {
                label: "C\xF3digo postal"
              }
            }
          }
        },
        license_plate: {
          label: "Patente del asegurado"
        },
        occurrence: {
          label: "Ocurrencia",
          address: {
            label: "Direcci\xF3n"
          },
          time: {
            label: "Hora"
          },
          witnesses_info: {
            label: "Informaci\xF3n de los testigos"
          },
          police_intervention: {
            label: "Intervenci\xF3n Policial"
          },
          police_station: {
            label: "Estaci\xF3n policial"
          },
          criminal_case_number: {
            label: "N\xFAmero causa penal"
          },
          judicial_department: {
            label: "Departamento judicial"
          },
          clerks_office: {
            label: "N\xFAmero de Secretaria"
          },
          court: {
            label: "N\xFAmero de Juzgado"
          },
          country: {
            label: "Pa\xEDs"
          },
          city: {
            label: "Ciudad"
          },
          zip_code: {
            label: "C\xF3digo Postal"
          },
          description: {
            label: "Descripci\xF3n"
          },
          state: {
            label: "Provincia"
          },
          damage_description: {
            label: "Descripci\xF3n de los da\xF1os"
          },
          sinister_date: {
            label: "Fecha del siniestro"
          }
        }
      },
      negotiation: {
        title: "Negociaci\xF3n",
        stages: {
          estimates: "Estimaci\xF3n",
          estimates_hint: "Montos estimados y responsabilidad",
          offers: "Ofrecimiento",
          offers_hint: "Propuesta econ\xF3mica al reclamante.",
          agreement: "Conformidad",
          agreement_hint: "Firma del reclamante",
          state: {
            done: "Completada",
            in_progress: "En curso",
            attention: "Requiere atenci\xF3n",
            pending: "Pendiente",
            agreement_pending: "Sin conformidad vigente"
          }
        },
        offer_summary: {
          sent_at: "Fecha de env\xEDo",
          amount: "Importe del ofrecimiento"
        },
        reject: {
          title: "Rechazar ofrecimiento",
          description: "Registr\xE1s el rechazo en nombre del reclamante. Va a quedar indicado que lo cargaste vos.",
          reason_label: "Motivo del rechazo",
          reason_placeholder: "Lo que expres\xF3 el reclamante",
          pretension_label: "Pretensi\xF3n del reclamante (opcional)",
          pretension_placeholder: "Monto que pretende",
          submit: "Rechazar",
          success_title: "Ofrecimiento rechazado",
          success_description: "Se registr\xF3 el rechazo en nombre del reclamante"
        },
        cancel: {
          title: "Anular ofrecimiento",
          description: "El ofrecimiento realizado al reclamante ser\xE1 anulado.",
          internal_reason_label: "Motivo interno",
          internal_reason_placeholder: "Queda registrado, no se comparte con el tercero",
          public_reason_label: "Motivo para el reclamante (opcional)",
          public_reason_placeholder: 'Si queda vac\xEDo, el reclamante recibe: "El ofrecimiento previo ha sido dejado sin efecto"',
          submit: "Anular",
          success_title: "Ofrecimiento anulado",
          success_description: "El ofrecimiento fue anulado correctamente",
          internal_reason_display: "Motivo interno",
          public_reason_display: "Motivo p\xFAblico",
          agreement_notice: {
            cancels_signature_request: {
              title: "Tambi\xE9n se cancela la solicitud de firma",
              description: "La conformidad est\xE1 en proceso de firma en AutoSign. Al anular el ofrecimiento se cancela la solicitud: quienes todav\xEDa no firmaron ya no podr\xE1n hacerlo."
            },
            keeps_signed_document: {
              title: "Este ofrecimiento tiene una conformidad firmada",
              description: "Anularlo no elimina ni revierte las firmas: el documento firmado se conserva."
            }
          },
          agreement_provider_cancel_requested: "Ofrecimiento anulado. Estamos cancelando la solicitud de firma en AutoSign."
        },
        offer_card: {
          offered_amount: "Importe ofrecido",
          installments_title: "Cuotas",
          installments_value: "{{count}} cuotas de {{amount}}",
          single_payment: "Pago \xFAnico",
          payment_days_title: "D\xEDas a pagar",
          days_value: "{{count}} d\xEDas",
          fees_title: "Honorarios",
          fees_value: "{{percentage}} %",
          no_fees: "Sin honorarios",
          sent_at: "Enviado el",
          sent_by: "por {{name}}",
          internal_badge: "No visible para el reclamante",
          reason_internal: "Motivo interno",
          reason_public: "Motivo para el reclamante",
          offer_reasons: "Motivos del ofrecimiento",
          offer_reason: "Motivo del ofrecimiento",
          canceled_reasons: "Motivos de la anulaci\xF3n",
          canceled_reason: "Motivo de la anulaci\xF3n",
          rejection_reason: "Rechazo del reclamante",
          rejection_on_behalf_title: "Rechazo registrado en nombre del reclamante",
          rejection_on_behalf_title_claimant: "Rechazo registrado en tu nombre",
          rejected_on_behalf_by: "Registrado por {{name}}",
          rejected_on_behalf_by_company: "Registrado por la compa\xF1\xEDa",
          pretension: "Pretensi\xF3n",
          agreement: {
            title: "Conformidad",
            name: "Nombre",
            provider: "Proveedor",
            transaction: "Transacci\xF3n",
            status: "Estado",
            canceled_at: "Cancelado el",
            expired_at: "Expirado el",
            canceled_reason: "Motivo cancelaci\xF3n",
            rejected_at: "Rechazado el",
            rejected_reason: "Motivo de rechazo",
            completed_at: "Completado el",
            signed_documents: "Documentos firmados"
          }
        },
        context: {
          days_since_last_offer: "d\xEDas al \xFAltimo ofrecimiento",
          day_since_last_offer: "d\xEDa al \xFAltimo ofrecimiento",
          less_than_one_day: "Menos de un d\xEDa",
          since_last_offer: "al \xFAltimo ofrecimiento",
          first_offer: "Primer ofrecimiento",
          first_offer_hint: "Todav\xEDa no se envi\xF3 ning\xFAn ofrecimiento",
          escalated: "del mismo tercero en Mediaci\xF3n/Juicio",
          escalated_tooltip: "Reclamos del mismo tercero",
          round: "{{round}}\xB0 ofrecimiento",
          stage_mediation: "En mediaci\xF3n",
          stage_judgment: "En juicio"
        },
        bar: {
          administrative: "Base Admin",
          type_average: "Acept. General",
          claimer_average: "Acept. Reclamante",
          pretension: "Pretensi\xF3n Tercero",
          cap: "TOPE",
          judicial: "Judicial",
          hint: "Arrastr\xE1 el selector sobre la barra o us\xE1 los campos para definir el ofrecimiento.",
          simulated: "Ofrecimiento simulado"
        },
        simulator: {
          amount_label: "Importe del ofrecimiento ($)",
          percentage_label: "Porcentaje del judicial (%)",
          distance_to_cap: "Distancia al TOPE",
          distance_to_pretension: "Distancia a pretensi\xF3n",
          probability: "Probabilidad de aceptaci\xF3n",
          not_computable: "No calculable",
          not_computable_probability_hint: "Defin\xED la responsabilidad en Estimaci\xF3n para calcular la probabilidad",
          above: "{{value}}% por encima",
          below: "{{value}}% por debajo",
          general_info: "Informaci\xF3n general",
          missing_estimates_title: "Sin estimaci\xF3n cargada",
          missing_estimates_description: "Carg\xE1 el monto judicial en Estimaci\xF3n para simular el ofrecimiento. Pod\xE9s continuar y completar el env\xEDo manualmente.",
          band: {
            high: "Alta",
            medium: "Media",
            low: "Baja"
          },
          tooltip: {
            title: "Probabilidad estimada",
            base: "Base",
            total: "Total",
            with_clip: "{{total}} \u2192 {{probability}}% (con ajuste)",
            factor: {
              cap_offered: "TOPE ofrecido: {{value}}%",
              liability_percentage: "Responsabilidad: {{value}}%",
              third_party_expectation: "Vs. pretensi\xF3n del tercero: {{value}}",
              type_average: "Vs. aceptaci\xF3n promedio del tipo: {{value}}",
              claimer_average: "Vs. aceptaci\xF3n promedio del reclamante: {{value}}",
              mediation_judgment_floor: "Vs. piso Mediaci\xF3n/Juicio del tipo: {{value}}",
              previous_rejection: "Rechazo previo con prob. {{value}}%"
            }
          }
        },
        wizard: {
          title: "Nuevo ofrecimiento",
          step_simulate: "Simul\xE1 el ofrecimiento",
          step_complete: "Complet\xE1 el ofrecimiento",
          continue: "Continuar",
          back: "Volver",
          cancel: "Cancelar",
          submit: "Confirmar y enviar",
          send: "Enviar ofrecimiento",
          summary_amount: "Importe total",
          summary_of_judicial: "{{value}}% del judicial",
          summary_of_cap: "{{value}}% del tope",
          amount_in_words: "Importe en letras",
          amount_in_words_hint: "Se genera autom\xE1ticamente a partir del importe",
          public_reason_label: "Motivo para el reclamante (opcional)",
          public_reason_placeholder: "Se comunica al tercero junto con el ofrecimiento",
          internal_reason_label: "Motivo interno",
          internal_reason_placeholder: "Queda registrado, no se comparte con el tercero",
          payment_conditions: "Condiciones de pago",
          installment: "{{count}} cuota",
          installments: "{{count}} cuotas",
          day: "{{count}} d\xEDa",
          days: "{{count}} d\xEDas",
          payment_days_label: "Cantidad de d\xEDas a pagar",
          single_payment_hint: "Pago \xFAnico de {{amount}}",
          installments_hint: "{{count}} cuotas de {{amount}}",
          installments_hint_with_fees: " \xB7 los honorarios se pagan aparte",
          fees_hint: "Honorarios {{fees}} en un pago",
          days_to_pay: "{{count}} d\xEDas",
          template_label: "Plantilla",
          template_placeholder: "Seleccion\xE1 una plantilla",
          select_option: "Selecciona una opci\xF3n",
          unsupported_variable_type: "Este tipo de variable no se completa desde este formulario",
          amount_locked_hint: "Definido en el simulador. Volv\xE9 al paso anterior para cambiarlo.",
          no_amount_variable_warning: 'La plantilla elegida no tiene la variable "Importe": el monto simulado no se aplicar\xE1 autom\xE1ticamente.',
          success_title: "Ofrecimiento creado",
          success_description: "Se ha creado el ofrecimiento de indemnizaci\xF3n correctamente",
          step_terms: "Condiciones del ofrecimiento",
          step_agreement: "Conformidad",
          single_payment: "Pago \xFAnico",
          installments_label: "Forma de pago",
          fees_label: "Honorarios del letrado",
          fees_required_hint: "El reclamo tiene abogado: el porcentaje es obligatorio",
          payee_label: "\xBFQui\xE9n cobra la indemnizaci\xF3n?",
          payee_hint: "El reclamo tiene abogado apoderado",
          payee_options: {
            victim: "Damnificado",
            attorney_in_fact: "Apoderado"
          },
          message_preview_title: "Mensaje de ofrecimiento (as\xED lo ver\xE1 el reclamante)",
          message_preview_hint: "Eleg\xED las condiciones de pago para ver el mensaje",
          message_preview_loading: "Preparando el mensaje\u2026",
          message_syntax_error: "La plantilla del mensaje tiene un error de sintaxis. Avis\xE1 al administrador.",
          message_blocking_title: "Faltan datos del reclamo para completar el mensaje",
          message_blocking_hint: "Completalos en el reclamo y volv\xE9 a intentar: el ofrecimiento no se puede enviar con huecos.",
          acceptance_title: "Qu\xE9 le vamos a pedir al reclamante",
          acceptance_file: "archivo",
          acceptance_optional: "opcional",
          acceptance_blocking_title: "Falta informaci\xF3n del reclamo para que el reclamante pueda cobrar",
          agreement_template: "Plantilla de conformidad",
          signature_undetermined: "Se define al aceptar",
          signature_unresolved: "Sin regla de firma: avis\xE1 al administrador",
          signers_title: "Firmantes de la conformidad",
          signers_empty: "La plantilla no declara recuadros de firma",
          signer_optional: "opcional",
          disclaimer: "Confirmo que revis\xE9 los datos del ofrecimiento y el modelo de conformidad que se va a enviar, y que los datos registrados son correctos.",
          pending_data_title: "Lo completa el reclamante al aceptar",
          absent_data_title: "Datos opcionales del reclamo que faltan",
          absent_data_hint: "No impiden enviar: las partes de la conformidad que los usan no se imprimen.",
          legacy_notice: "Este reclamo sigue el flujo manual: {{reason}}",
          agreement_plan_changed_notice: "La configuraci\xF3n cambi\xF3 desde la vista previa. Revis\xE1 el mensaje y la conformidad antes de enviar.",
          warnings_title: "Avisos sobre los datos del reclamo",
          blocking_issues_title: "Revis\xE1 los datos del reclamo para continuar con la conformidad",
          blocking_issues_hint: "Correg\xED los datos en el reclamo y actualiz\xE1 la vista previa. El ofrecimiento no se puede enviar as\xED.",
          blocking_issues_refresh: "Actualizar",
          blocking_signer: "{{label}}: {{reason}}",
          agreement_blocking_issues_notice: "Los datos del reclamo no permiten generar la conformidad ({{keys}}). Corregilos y actualiz\xE1 la vista previa.",
          agreement_review_required_notice: "Este reclamo lleva conformidad: revis\xE1 el documento y confirm\xE1 el deslinde antes de enviar.",
          offer_message_not_configured_notice: "La carta de ofrecimiento dej\xF3 de estar disponible. Avis\xE1 al administrador y volv\xE9 a intentar.",
          message_incomplete_notice: "El mensaje tiene datos del reclamo faltantes ({{keys}}). Completalos antes de enviar.",
          preview_error: "No pudimos evaluar la conformidad para este reclamo.",
          preview_error_fallback: "El ofrecimiento se env\xEDa igual, por el flujo de siempre: eleg\xED la plantilla y complet\xE1 sus datos.",
          preview_loading: "Preparando el ofrecimiento\u2026",
          retry: "Reintentar",
          blocking_variable: "Falta {{label}} en el reclamo",
          blocking_condition: "Una cl\xE1usula depende de un dato que falta en el reclamo: {{attribute}}",
          signature_dispatch_from: "Al aceptarse, la conformidad sale a firmar desde tu cuenta de AutoSign ({{email}}).",
          signature_dispatch_blocked_title: "Todav\xEDa no se puede enviar a firmar",
          signature_dispatch_blockers: {
            sender_connection_missing: "Conect\xE1 tu cuenta de AutoSign desde Integraciones: la conformidad sale a firmar desde ella.",
            sender_connection_reconnect_required: "Tu cuenta de AutoSign tiene que volver a conectarse desde Integraciones.",
            signer_email_missing: "La firma se decide al aceptar y estos firmantes no tienen email: {{keys}}.",
            signer_email_shared: "Los firmantes deben tener correos electr\xF3nicos diferentes: {{shared}} usan el mismo correo."
          },
          agreement_signature_dispatch_blocked_notice: "El ofrecimiento no se envi\xF3: la conformidad sale a firmar por AutoSign y falta tu cuenta conectada, falta el email de un firmante o dos firmantes comparten el mismo correo.",
          amount_exceeds_cap: "El monto no debe superar el tope.",
          offer_amount_exceeds_cap_notice: "La estimaci\xF3n del reclamo cambi\xF3 y el monto supera el tope vigente. Revis\xE1 el monto antes de enviar.",
          offer_cap_not_computable_notice: "El reclamo ya no tiene un tope calculable. Carg\xE1 la responsabilidad y la estimaci\xF3n judicial antes de ofrecer.",
          cap_not_computable_reason: "Carg\xE1 la responsabilidad y la estimaci\xF3n judicial para calcular el tope del ofrecimiento",
          cap_zero_reason: "El tope del ofrecimiento es $0: actualiz\xE1 la estimaci\xF3n para poder ofrecer",
          derived_claim_reason: "El reclamo est\xE1 derivado: devolv\xE9 o cancel\xE1 la derivaci\xF3n para poder ofrecer"
        },
        panel: {
          title: "Contexto hist\xF3rico (\xFAltimos 12 meses)",
          claimer_average: "Aceptaci\xF3n promedio del reclamante",
          claimer_average_hint: "Promedio de lo que acept\xF3 este mismo reclamante, como % del tope, en otros reclamos del mismo tipo. Cuenta la \xFAltima aceptaci\xF3n vigente de cada reclamo. \xDAltimos 12 meses.",
          type_average: "Aceptaci\xF3n promedio general",
          type_average_hint: "Promedio de todos los reclamos de la compa\xF1\xEDa con ofrecimiento aceptado en este tipo de reclamo, como % del tope. \xDAltimos 12 meses.",
          mediation_judgment: "Piso Mediaci\xF3n/Juicio",
          mediation_judgment_hint: "Mediana del \xFAltimo ofrecimiento rechazado de cada reclamo que igual termin\xF3 en Mediaci\xF3n o Juicio, como % del tope: son montos que no alcanzaron para acordar. Mismo tipo de reclamo, \xFAltimos 12 meses.",
          cases: "{{count}} casos",
          no_data: "Sin data suficiente",
          of_cap: "del tope",
          on_this_claim: "en este reclamo",
          cases_tooltip: "Reclamos considerados (no incluye el actual)",
          cases_tooltip_more: "y {{count}} m\xE1s"
        },
        table: {
          sent: "Fecha ofrecimiento",
          sent_by: "Enviado por",
          amount: "Importe",
          distance_to_cap: "Porc. del tope",
          probability: "Prob. acept.",
          status: "Estado",
          of_cap: "{{value}}% del tope",
          empty_title: "No se encontraron ofrecimientos",
          empty_description: "De momento no se realizaron ofrecimientos de indemnizaci\xF3n al tercero involucrado",
          of_judicial: "{{value}}% del judicial",
          context_title: "Contexto del ofrecimiento",
          context_offer: "Este ofrecimiento",
          context_claimer_average: "Prom. reclamante",
          context_type_average: "Prom. general",
          context_mediation_judgment: "Piso Med./Juicio",
          context_cases: "{{count}} casos",
          context_cap: "Tope",
          context_liability: "resp. {{value}}%",
          context_pretension: "Pretensi\xF3n",
          view_agreement: "Ver conformidad",
          detail_title: "Detalle del ofrecimiento",
          view_previous_agreement: "Ver conformidad (anterior)",
          agreement: "Conformidad"
        },
        agreement_document: {
          status_code: {
            missing_data: "Faltan datos obligatorios del reclamo, as\xED que no se imprimi\xF3.",
            syntax_error: "Un bloque de la plantilla no compila, as\xED que no se imprimi\xF3.",
            undetermined_condition: "Una cl\xE1usula depende de un dato que falta en el reclamo, as\xED que no se imprimi\xF3.",
            missing_anchors: "El PDF no trae el lugar de una firma obligatoria: sirve para firmar en papel, no digitalmente.",
            render_failed: "El generador de PDF no respondi\xF3. Se reintenta solo; si sigue fallando, us\xE1 Reintentar.",
            pdf_unreadable: "No se pudo leer el PDF generado para ubicar las firmas.",
            abandoned: "La generaci\xF3n se interrumpi\xF3 y se volvi\xF3 a intentar."
          },
          skip_reason: {
            offer_not_accepted: "El ofrecimiento ya no est\xE1 aceptado.",
            automation_disabled: "La conformidad autom\xE1tica de la compa\xF1\xEDa est\xE1 apagada.",
            plan_not_found: "No se encontr\xF3 la conformidad que se eligi\xF3 al enviar.",
            plan_not_selected: "El ofrecimiento se envi\xF3 sin conformidad.",
            resolution_failed: "No se pudieron leer los datos del reclamo o del ofrecimiento."
          },
          missing_title: "Datos que faltan",
          download: "Descargar PDF",
          dispatch: {
            sender: "Remitente: {{name}} ({{email}})",
            dispatched_at: "Enviada el {{date}}",
            connect_hint: "Para reintentar el env\xEDo con tu cuenta, conect\xE1 AutoSign desde Integraciones.",
            retry_account_required: "Solo se puede reintentar desde la cuenta de AutoSign {{email}}: la solicitud pudo haber salido desde ella.",
            retry: "Reintentar env\xEDo desde {{email}}"
          },
          signing: {
            sync: "Sincronizar",
            sync_success: "Estado actualizado con AutoSign",
            signed: "Firm\xF3",
            signed_at: "Firm\xF3 el {{date}}",
            pending: "Pendiente de firma",
            documents_pending: "La firma se complet\xF3, pero los documentos firmados todav\xEDa no llegaron desde AutoSign.",
            synced_at: "\xDAltima novedad de AutoSign: {{date}}"
          }
        },
        agreement: {
          title: "Conformidad",
          context: {
            accepted: "aceptado el {{date}}",
            sent: "enviado el {{date}}",
            sent_by: "enviado por {{name}}",
            view_offer: "Ver ofrecimiento"
          },
          phase: {
            awaiting_acceptance: "Esperando aceptaci\xF3n",
            generating: "Generando documento",
            skipped: "No se gener\xF3",
            generation_failed: "Fall\xF3 la generaci\xF3n",
            invalid: "No se pudo imprimir",
            ready_offline: "Lista para firmar",
            dispatching: "Enviando a AutoSign",
            dispatch_failed: "Env\xEDo detenido",
            signing: "En firma",
            completed: "Firmada",
            rejected: "Rechazada",
            expired: "Vencida",
            canceled_by_provider: "Cancelada en AutoSign",
            canceled: "Anulada"
          },
          summary: {
            awaiting_acceptance: "La conformidad se genera cuando el reclamante acepte el ofrecimiento.",
            generating: "Se est\xE1 generando el documento de la conformidad.",
            skipped: "La conformidad no se gener\xF3 para esta aceptaci\xF3n.",
            generation_failed: "No se pudo generar el documento de la conformidad.",
            invalid: "El documento no se imprimi\xF3: el reclamo no ten\xEDa todo lo necesario cuando se envi\xF3 el ofrecimiento.",
            ready_offline: "El documento est\xE1 listo. Esta conformidad se firma por fuera de AutoSign: descargalo y gestion\xE1 la firma.",
            dispatching: "Se est\xE1 enviando la conformidad a firmar por AutoSign.",
            dispatch_failed: "El env\xEDo a AutoSign se detuvo.",
            signing: "Esperando firmas: {{signed}} de {{total}}.",
            signing_next: "Le toca firmar a {{name}}.",
            completed: "La conformidad est\xE1 firmada por todas las partes.",
            rejected: "Un firmante rechaz\xF3 la conformidad en AutoSign.",
            expired: "La conformidad venci\xF3 sin que se completaran las firmas.",
            canceled_by_provider: "La conformidad se cancel\xF3 desde el panel de AutoSign.",
            canceled: "La conformidad se anul\xF3 junto con su ofrecimiento."
          },
          guidance: {
            fix_with_new_offer: "Para corregirlo, anul\xE1 el ofrecimiento y envi\xE1 uno nuevo.",
            continue_with_new_offer: "Para avanzar, anul\xE1 el ofrecimiento y envi\xE1 uno nuevo.",
            go_to_offers: "Ir a Ofrecimiento"
          },
          status: {
            rejected_reason: "Motivo del rechazo: {{reason}}",
            transaction: "Transacci\xF3n en AutoSign",
            cancel_in_autosign: "La solicitud puede seguir activa en AutoSign: cancelala desde el panel de AutoSign buscando \xAB{{name}}\xBB (transacci\xF3n {{id}}).",
            provider_cancel: {
              in_progress: "Estamos cancelando la solicitud de firma en AutoSign.",
              canceled: "La solicitud de firma tambi\xE9n se cancel\xF3 en AutoSign.",
              signed_before: "AutoSign registr\xF3 todas las firmas antes de la cancelaci\xF3n: el documento firmado est\xE1 en AutoSign."
            },
            retry_generation: "Reintentar generaci\xF3n",
            transaction_name: "Nombre: {{name}}",
            canceled_reason: "Motivo de la cancelaci\xF3n: {{reason}}"
          },
          steps: {
            acceptance: "Aceptaci\xF3n",
            document: "Documento",
            dispatch: "Env\xEDo",
            signature: "Firma",
            signature_count: "Firma {{signed}}/{{total}}",
            signature_in_person: "Firma presencial",
            signature_offline: "Firma fuera de AutoSign",
            title: "Avance de la conformidad",
            completed: "Finalizada",
            current: {
              acceptance: "Esperando respuesta",
              document: "Generando",
              dispatch: "Enviando",
              signature: "Esperando firmas",
              completed: "En curso",
              offline: "Por fuera de AutoSign"
            },
            state: {
              done: "Completado",
              current: "En curso",
              upcoming: "Pendiente",
              error: "Con problemas"
            }
          },
          signers: {
            title: "Firmantes",
            planned: "Previstos al enviar el ofrecimiento.",
            empty: "La plantilla no tiene recuadros de firma.",
            no_email: "Sin email",
            next: "Le toca firmar",
            waiting: "En espera",
            offline: "Firma fuera de AutoSign",
            upcoming: "Se env\xEDa a firmar al aceptar"
          },
          document: {
            title: "Documento de conformidad",
            template: "Plantilla \xAB{{name}}\xBB \xB7 versi\xF3n {{version}}",
            template_rule: "Elegida por la regla \xAB{{name}}\xBB.",
            signature_digital: "Firma digital por AutoSign",
            signature_digital_off: "Firma digital por fuera de Piramid: el env\xEDo a AutoSign estaba apagado cuando se envi\xF3 el ofrecimiento",
            signature_in_person: "Firma presencial",
            signature_undecided: "M\xE9todo de firma sin definir",
            unsigned: "Conformidad para firmar",
            generated_at: "Generada el {{date}}",
            signed: "Conformidad firmada",
            signed_hint: "Tambi\xE9n est\xE1 en la Documentaci\xF3n del reclamo.",
            pending_generation: "El documento se genera cuando el reclamante acepte el ofrecimiento.",
            not_available: "Todav\xEDa no hay un documento generado.",
            view: "Ver",
            download: "Descargar",
            open_in_new_tab: "Abrir en una pesta\xF1a nueva",
            original: "Documento original (sin firmar)",
            origin: {
              action: "Ver c\xF3mo se cre\xF3 esta conformidad",
              title: "C\xF3mo se cre\xF3 esta conformidad",
              template: "Plantilla",
              signature: "Modalidad de firma",
              signature_rule: "Decidida por la regla \xAB{{name}}\xBB."
            }
          },
          history: {
            title: "Historial de eventos",
            empty: "Todav\xEDa no hay movimientos de esta conformidad.",
            error: "No pudimos cargar el historial."
          },
          empty: {
            title: "Este reclamo no tiene una conformidad vigente"
          },
          manual: {
            description: "Este ofrecimiento se envi\xF3 sin una conformidad generada por Piramid. Carg\xE1 el PDF de la conformidad gestionada externamente.",
            uploaded_hint: "Cargada a mano. Tambi\xE9n est\xE1 en la Documentaci\xF3n del reclamo.",
            upload: "Cargar PDF",
            replace: "Reemplazar",
            cancel: "Cancelar",
            upload_success: "Conformidad cargada",
            replace_hint: "El PDF anterior queda en la Documentaci\xF3n del reclamo."
          },
          errors: {
            load: "No pudimos cargar la conformidad.",
            offers: "No pudimos cargar los ofrecimientos del reclamo.",
            retry: "Reintentar"
          },
          vigency: {
            current: "Vigente",
            current_hint: "Es la conformidad actual del reclamo.",
            previous: "Anterior",
            previous_canceled: "No es la vigente: se anul\xF3 junto con su ofrecimiento el {{date}}.",
            previous_superseded: "No es la vigente: la reemplaz\xF3 \xAB{{name}}\xBB, enviado el {{date}}."
          }
        },
        offer_detail: {
          tabs: {
            offer: "Ofrecimiento",
            agreement: "Conformidad"
          },
          legacy_badge: "Circuito anterior"
        }
      },
      estimates: {
        empty_value: "Sin valor",
        vehicle_market_value: "Valor Venal",
        person_percentage_of_judicial_risk: "Riesgo Judicial",
        administrative_amount: "Administrativo",
        judicial_amount: "Judicial",
        percentage_of_liability: "Responsabilidad",
        material_judicial_amount: "Judicial",
        person_judicial_amount: "Judicial",
        material_administrative_amount: "Administrativo",
        person_administrative_amount: "Administrativo",
        groups: {
          general: "General",
          material: "Da\xF1os materiales",
          person: "Da\xF1os corporales"
        },
        activity: {
          percentage_of_liability: "la responsabilidad",
          person_percentage_of_judicial_risk: "el riesgo judicial",
          administrative_amount: "el monto administrativo",
          material_judicial_amount: "el monto judicial de da\xF1os materiales",
          person_judicial_amount: "el monto judicial de da\xF1os corporales",
          material_administrative_amount: "el monto administrativo de da\xF1os materiales",
          person_administrative_amount: "el monto administrativo de da\xF1os corporales"
        },
        validation: {
          group_out_of_range: "El total {{ scope }} ({{ members }}) debe quedar entre {{ from }} y {{ to }}. Hoy es {{ current }}.",
          group_limit_exceeded: "El total {{ scope }} ({{ members }}) no debe superar {{ limit }}. Con este cambio quedar\xEDa en {{ total }}.",
          out_of_range: "Debe estar en el rango de {{ from }} a {{ to }}",
          limit_exceeded: "No debe superar {{ limit }}",
          missing_permission: "No ten\xE9s permiso para realizar esta acci\xF3n"
        },
        offer_cap: {
          label: "Tope ofrecimiento:",
          not_computable: "No calculable",
          not_computable_hint: "Falta responsabilidad o monto judicial",
          formula_title: "C\xF3mo se calcula",
          formula: "(Da\xF1os materiales judicial + Da\xF1os corporales judicial) \xD7 Responsabilidad",
          formula_hint: "Los montos administrativos y el valor venal no intervienen."
        },
        update_result: {
          updated_title: "Estimaci\xF3n actualizada",
          updated_description: "El cambio qued\xF3 registrado correctamente",
          unchanged_title: "Sin cambios para registrar",
          unchanged_description: "El valor enviado es el que ya estaba registrado"
        }
      },
      type: {
        material_vehicle_with_license_plate: "Da\xF1os Materiales de veh\xEDculos con patente",
        material: "Da\xF1os Materiales",
        material_vehicle_without_license_plate: "Da\xF1os Materiales de veh\xEDculos sin patente",
        person_injury: "Lesiones",
        material_and_person_injury: "Combinado con Lesiones",
        person_death: "Fallecidos",
        material_real_property: "Da\xF1os materiales a inmuebles",
        claimant_worker_compensation_insurer: "ART",
        material_and_person_death: "Da\xF1os Materiales y Fallecidos",
        recovery: "Recupero"
      },
      status: {
        open: "Abierto",
        closed: "Cerrado",
        reference: {
          claimant_disinterest: "Desinter\xE9s del Reclamante",
          not_successful: "No Prosper\xF3",
          reconciled: "Conciliado",
          in_closing_process: "En proceso de Cierre",
          derivation: "Derivaci\xF3n",
          analysis: "An\xE1lisis del reclamo",
          on_claim: "Generaci\xF3n de Reclamo",
          technical_analysis: "An\xE1lisis T\xE9cnico",
          inspection: "Inspecci\xF3n",
          responsibility_analysis: "An\xE1lisis de Responsabilidad",
          negotiation: "Negociaci\xF3n",
          payment_process: "En proceso de Pago",
          homologation: "Homologaci\xF3n",
          demand_transfer: "Traslado Demanda",
          canceled: "Anulado",
          rejected: "Rechazado (luego del An\xE1lisis)",
          settlement_payment: "Liquidaci\xF3n y Pago",
          mediation: "Mediaci\xF3n",
          judgment: "Juicio",
          fraud: "Fraude"
        },
        role: {
          none: "Sin rol",
          default: "Por defecto",
          default_no_complaint: "Por defecto - (sin denuncia)",
          documentation_completed: "Documentaci\xF3n completa",
          documentation_request: "Documentaci\xF3n requerida",
          criminal_case_request: "Solicitud causa penal",
          offer_flow: "Ofrecimiento",
          not_response: "Sin respuesta",
          claim_rejected: "Rechazo",
          additional_management: "Gestiones adicionales",
          default_missing_documentation: "Por defecto - Documentaci\xF3n faltante",
          default_missing_documentation_no_complaint: "Por defecto - Documentaci\xF3n faltante (sin denuncia)",
          claim_derived_user_strategy: "Reclamo derivado a usuario",
          claim_derived_team_strategy: "Reclamo derivado a grupo de destino",
          offer_agreement_completed: "Conformidad completada",
          offer_accepted: "Ofrecimiento aceptado",
          offer_rejected: "Ofrecimiento rechazado",
          offer_created: "Ofrecimiento creado",
          claim_derived_target_group_strategy: "Reclamo derivado a grupo de destino",
          sinister_derived_fraud: "Siniestro derivado a fraude",
          fraud: "Fraude",
          mediation: "Mediaci\xF3n",
          lawsuit: "Juicio",
          reconciled: "Conciliado",
          offer_canceled: "Ofrecimiento anulado",
          offer_expired: "Ofrecimiento expirado",
          offer_agreement_started: "Conformidad digital pendiente de firma",
          order_created: "Orden de trabajo creada",
          order_accepted: "Orden de trabajo aceptada",
          order_rejected: "Orden de trabajo rechazada por el proveedor",
          order_canceled: "Orden de trabajo anulada",
          order_completed: "Orden de trabajo finalizada",
          order_work_proof_completed: "Inspecci\xF3n de trabajo completada",
          order_work_proof_approved: "Inspecci\xF3n de trabajo aprobada",
          order_work_proof_disapproved: "Inspecci\xF3n de trabajo desaprobada"
        }
      },
      tabs: {
        detail: "Detalle",
        documents: "Documentaci\xF3n",
        claims: "Reclamos",
        activity: "Actividad",
        fraud: "Fraude",
        complaints: "Denuncias"
      },
      steps: {
        "doc-proof_of_ownership_document": "Certificado de propiedad",
        "doc-vehicle_title": "T\xEDtulo del veh\xEDculo",
        "doc-victim_national_identity_card_back": "DNI (dorso)",
        "doc-victim_national_identity_card_front": "DNI (frente)",
        "doc-material_victim_national_identity_card_back": "DNI (dorso)",
        "doc-material_victim_national_identity_card_front": "DNI (frente)",
        "doc-policy_insurance": "Copia completa de la p\xF3liza",
        "doc-repair_bill": "Factura de reparaci\xF3n",
        "doc-damage_budget": "Presupuesto de los da\xF1os",
        "doc-real_property": "Fotos de la propiedad",
        "doc-vehicle": "Fotos del veh\xEDculo",
        "doc-rental_agreement": "Contrato de alquiler",
        "doc-deed": "Escritura",
        "doc-subrogation_certificate": "Constancia de subrogaci\xF3n",
        "doc-expense_receipt": "Factura/Comprobante por gastos medicos",
        "doc-medical_report": "Dictamen m\xE9dico de ART",
        "doc-medical_discharge": "Alta m\xE9dica de ART",
        "doc-accounting_certificate": "Certificado contable",
        "doc-policy_deductible_letter": "Carta de franquicia",
        "doc-policy_coverage_certificate": "Certificado de cobertura",
        "doc-inspection_photo": "Foto de Inspecci\xF3n",
        "doc-orion_report": "Informe Orion",
        "doc-sinister_video": "Video del siniestro",
        "doc-sinister_photo": "Foto del siniestro",
        "doc-vehicle_id_card_back": "C\xE9dula verde (dorso)",
        "doc-vehicle_id_card_front": "C\xE9dula verde (frente)",
        "doc-mother_national_id_document_front": "DNI de la madre (frente)",
        "doc-mother_national_id_document_back": "DNI de la madre (dorso)",
        "doc-father_national_id_document_back": "DNI del padre (dorso)",
        "doc-father_national_id_document_front": "DNI del padre (frente)",
        "doc-income_verification": "Acreditaci\xF3n de ingresos",
        "doc-occupancy_report": "Informe de ocupaci\xF3n",
        "doc-death_certificate": "Acta de defunci\xF3n",
        "doc-birth_certificate": "Partida de nacimiento",
        "doc-certificate_medical_treatment": "Certificado atenci\xF3n m\xE9dica",
        "doc-affidavit_of_no_insurance": "Declaraci\xF3n jurada de no seguro",
        "doc-insurance_complaint": "Denuncia del siniestro realizada en tu aseguradora",
        "doc-complaint": "Denuncia",
        "doc-load": "Carga de documentos",
        "doc-claim-note": "Escrito de reclamo",
        "claim-created": "Reclamo creado",
        "claimant-list": "Lista de reclamantes",
        "medical-institution-info": "Datos de la instituci\xF3n m\xE9dica",
        "worker-compensation-insurer-info": "Datos de la ART",
        "health-insurance-info": "Datos de la obra social",
        "was-treated-by-medical-institution": "Atenci\xF3n M\xE9dica",
        "had-surgery": "Intervenci\xF3n quir\xFArgica",
        "surgery-description": "Intervenci\xF3n quir\xFArgica",
        "was-treated-by-worker-compensation-insurer": "Servicio de ART",
        "has-health-insurance": "Obra social",
        "victim-minor-mother-info": "Datos de la madre",
        "victim-minor-father-info": "Datos del padre",
        "victim-injuries-details": "Detalles de lesiones",
        "victim-injuries-rol": "Datos del damnificado",
        "victim-injuries-rol-material": "Datos del damnificado de da\xF1os materiales",
        "vehicle-ownership-document-choose": "Acreditaci\xF3n de titularidad del bien",
        "real-property-info": "Informaci\xF3n del Inmueble",
        "real-property-location": "Ubicaci\xF3n del Inmueble",
        "match-real-property-victim-address": "Coincidencia de domicilio",
        "location-info": "Ubicaci\xF3n del reclamo",
        "claimed-amount": "Monto reclamado",
        "sinister-info": "Datos del siniestro",
        "sinister-type": "Ingres\xE1 tu reclamo",
        "vehicle-driver-info": "Datos del conductor",
        "material-damage-insurer-info": "Datos del seguro",
        "vehicle-info": "Datos del veh\xEDculo",
        "legal-person-reimbursements-info": "Datos de la instituci\xF3n reclamante",
        "vehicle-driver-ownership": "Propiedad del veh\xEDculo",
        "victim-natural-person-info": "Datos del Damnificado (persona f\xEDsica)",
        "victim-natural-person-address-info": "Domicilio Damnificado (persona f\xEDsica)",
        "victim-relationship": "V\xEDnculo con el damnificado",
        "victim-legal-person-info": "Damnificado (persona jur\xEDdica)",
        "recovery-institution-info": "Instituci\xF3n Reclamante",
        "own-claim-choose": "\xBFReclama en nombre propio?",
        "own-material-claim-choose": "Da\xF1os materiales, \xBFReclama en nombre propio?",
        "victim-type-choose": "Damnificado due\xF1o del bien",
        "damage-declaration": "Selecciona los da\xF1os que deseas declarar.",
        "damage-material-type": "\xBFQue tipo de da\xF1o material sufri\xF3?",
        "special-branch-info": "Reporte del siniestro",
        "is-local-insured-involved": "\xBFEl siniestro involucr\xF3 un veh\xEDculo asegurado por {{companyName}}?",
        "vehicle-category": "Tipo de veh\xEDculo",
        "claim-confirmation": "Env\xEDo de reclamo",
        welcome: "Bienvenido",
        "insured-info": "Siniestro con un veh\xEDculo asegurado en {{companyName}}",
        "claimant-info": "Reclamante",
        "has-insurance": "\xBFPose\xEDa seguro al momento del siniestro?",
        "has-income-verification": "\xBFPosee la acreditaci\xF3n de ingresos del damnificado?",
        "occurrence-optional-info": "Intervenci\xF3n policial",
        "injured-identity-card": "Documentaci\xF3n de la persona damnificada",
        "material-damage-documents": "Documentaci\xF3n del titular del bien",
        "same-damage-victim": "\xBFLa persona lesionada es la titular del veh\xEDculo?",
        "same-damage-victim-real-property": "\xBFLa persona lesionada es la titular del inmueble?",
        "material-victim-natural-person-info": "Datos del titular del bien",
        "material-victim-natural-person-address-info": "Domicilio del titular del bien",
        "material-victim-minor-father-info": "Datos del padre del titular del bien",
        "material-victim-minor-mother-info": "Datos de la madre del titular del bien",
        "material-claimant-info": "Reclamante de da\xF1os materiales",
        "material-claimant-address-info": "Domicilio del reclamante de da\xF1os materiales",
        "material-victim-relationship": "V\xEDnculo con el titular del bien",
        v2: {
          "victim-relationship": "V\xEDnculo con la persona lesionada",
          "victim-death-relationship": "V\xEDnculo con la persona fallecida",
          "victim-natural-person-info": "Datos de la persona lesionada",
          "victim-natural-person-address-info": "Domicilio de la persona lesionada",
          "victim-death-info": "Datos de la persona fallecida",
          "victim-death-address-info": "Domicilio de la persona fallecida",
          "victim-injuries-rol": "Condici\xF3n al momento del siniestro",
          "injured-identity-card": "Documentaci\xF3n de la persona lesionada",
          "own-claim-choose": "Lesiones, \xBFReclama en nombre propio?",
          "victim-type-choose": "El titular del veh\xEDculo",
          "victim-type-choose-real-property": "El titular del inmueble"
        },
        "recovery-institution-relationship": "V\xEDnculo con el damnificado",
        "recovery-claimant-info": "Reclamante",
        "recovery-claimant-address-info": "Reclamante",
        "recovery-injured-person-info": "Datos del beneficiario de las prestaciones",
        "recovery-asset-owner-info": "Datos del beneficiario de las prestaciones",
        "recovery-damage-type": "Da\xF1o que origina el recupero"
      },
      draft: {
        restored: {
          title: "Recuperamos lo que hab\xEDas cargado",
          description: "Segu\xEDs desde donde lo dejaste."
        },
        documents_restored: {
          title: "Recuperamos los archivos que hab\xEDas subido",
          description: "El formulario cambi\xF3 desde tu \xFAltima visita, as\xED que ten\xE9s que volver a completar los datos."
        },
        expired_documents: "Algunos archivos vencieron y hay que volver a subirlos.",
        continue: "Seguir",
        start_over: "Empezar de cero",
        saved_at: "Guardado el {{date}} a las {{time}}",
        license_plate: "Patente {{plate}}",
        elsewhere: {
          title: "Ten\xE9s un reclamo sin terminar en otra pesta\xF1a",
          description: "Pod\xE9s seguirlo ac\xE1 o empezar uno nuevo."
        },
        continue_here: "Continuar ac\xE1",
        start_new: "Empezar uno nuevo",
        maybe_submitted: {
          title: "Puede que este reclamo ya se haya enviado",
          description: "Se cort\xF3 mientras lo enviabas. Revis\xE1 tus reclamos antes de mandarlo de nuevo."
        },
        see_claims: "Ver mis reclamos",
        taken: {
          title: "Este reclamo se abri\xF3 en otra pesta\xF1a",
          description: "Para no mezclar datos, seguilo en la otra pesta\xF1a. Si quer\xE9s cargar otro reclamo, recarg\xE1 esta.",
          reload: "Recargar"
        }
      },
      notices: {
        "minor-material-victim": "La fecha ingresada indica que el titular del bien es menor de edad. Si es correcto, continu\xE1. Si fue un error, correg\xED la fecha.",
        "minor-victim": "La fecha ingresada indica que el damnificado es menor de edad. Si es correcto, continu\xE1. Si fue un error, correg\xED la fecha."
      },
      document: {
        police_report: "Parte policial",
        identity_card: "C\xE9dula de identidad",
        incident_damage_photo: "Foto del incidente",
        vehicle_roof: "Veh\xEDculo Parte Techo",
        vehicle_side_right: "Veh\xEDculo Parte Acompa\xF1ante",
        vehicle_side_left: "Veh\xEDculo Parte Conductor",
        vehicle_front: "Veh\xEDculo Parte Frontal",
        vehicle_back: "Veh\xEDculo Parte Trasera",
        vehicle_damage_photo_bonnet: "Veh\xEDculo - Da\xF1o Capot",
        vehicle_damage_photo_boot: "Veh\xEDculo - Da\xF1o Trasero",
        vehicle_damage_photo_door_left: "Veh\xEDculo - Da\xF1o Puerta Izquierda",
        vehicle_damage_photo_door_right: "Veh\xEDculo - Da\xF1o Puerta Derecha",
        vehicle_damage_photo_roof: "Veh\xEDculo - Da\xF1o Techo",
        vehicle_qualification: "Veh\xEDculo - Habilitacion",
        policy_holder_vehicle_identity_card_front: "C\xE9dula verde (frente)",
        policy_holder_vehicle_identity_card_back: "C\xE9dula verde (dorso)",
        policy_holder_identity_card_front: "C\xE9dula de identidad (frente)",
        policy_holder_identity_card_back: "C\xE9dula de identidad (dorso)",
        vehicle_authorization_document: "Veh\xEDculo - Habilitaci\xF3n",
        vehicle_authorization_document_front: "Veh\xEDculo - Habilitaci\xF3n (frente)",
        vehicle_authorization_document_back: "Veh\xEDculo - Habilitaci\xF3n (dorso)",
        vehicle_registration_card: "C\xE9dula del veh\xEDculo",
        vehicle_registration_card_front: "C\xE9dula del veh\xEDculo (frente)",
        vehicle_registration_card_back: "C\xE9dula del veh\xEDculo (dorso)",
        driver_license: "C\xE9dula de conducir",
        policy_holder_driver_license_front: "C\xE9dula de conducir (frente)",
        policy_holder_driver_license_back: "C\xE9dula de conducir (dorso)",
        policy_coverage_certificate: "Certificado de cobertura",
        policy_deductible_letter: "Carta de franquicia",
        accounting_certificate: "Certificado contable",
        medical_discharge: "Alta m\xE9dica de ART",
        medical_report: "Dictamen m\xE9dico de ART",
        expense_receipt: "Factura/Comprobante por gastos medicos",
        subrogation_certificate: "Nota de subrogaci\xF3n",
        deed: "Escritura",
        appraisal_invoice: "Factura del liquidador/perito",
        contract_invoice: "Factura del contratista",
        rental_agreement: "Contrato de alquiler",
        vehicle: "Fotos del veh\xEDculo",
        real_property: "Fotos de la propiedad",
        damage_budget: "Presupuesto de los da\xF1os",
        repair_bill: "Factura de reparaci\xF3n",
        policy_insurance: "Copia completa de la p\xF3liza",
        victim_national_identity_card_front: "DNI del damnificado (frente)",
        victim_national_identity_card_back: "DNI del damnificado (dorso)",
        material_victim_national_identity_card_front: "DNI del damnificado (frente)",
        material_victim_national_identity_card_back: "DNI del damnificado (dorso)",
        vehicle_title: "T\xEDtulo del veh\xEDculo",
        proof_of_ownership_document: "Certificado de propiedad",
        complaint: "Denuncia Policial",
        insurance_complaint: "Denuncia del siniestro realizada en tu aseguradora",
        affidavit_of_no_insurance: "Declaraci\xF3n jurada de no seguro",
        certificate_medical_treatment: "Certificado atenci\xF3n m\xE9dica",
        birth_certificate: "Partida de nacimiento",
        death_certificate: "Acta de defunci\xF3n",
        occupancy_report: "Informe de ocupaci\xF3n",
        income_verification: "Acreditaci\xF3n de ingresos",
        father_national_id_document_front: "DNI del padre (frente)",
        father_national_id_document_back: "DNI del padre (dorso)",
        mother_national_id_document_front: "DNI de la madre (frente)",
        mother_national_id_document_back: "DNI de la madre (dorso)",
        vehicle_id_card_front: "C\xE9dula verde (frente)",
        vehicle_id_card_back: "C\xE9dula verde (dorso)",
        sinister_photo: "Foto del siniestro",
        sinister_video: "Video del siniestro",
        orion_report: "Informe Orion",
        inspection_photo: "Foto de Inspecci\xF3n",
        expert_appraisal_photo: "Foto de Peritaci\xF3n",
        offer_agreement: "Ofrecimiento de Indemnizaci\xF3n",
        appraisal_report: "Informe de evaluaci\xF3n",
        contract_report: "Reporte de contrato",
        appraisal_updates_file: "Novedades de la evaluaci\xF3n",
        contract_updates_file: "Novedades del contrato",
        rfp_bid_file: "Licitaci\xF3n Proveedor Documento",
        rfp_contract_file: "Reporte Licitaci\xF3n Contrato",
        order_report: "Reporte de orden",
        order_invoice: "Factura de orden",
        vehicle_side_left_damage: "Da\xF1os en el lado conductor",
        vehicle_side_right_damage: "Da\xF1os en el lado acompa\xF1ante",
        vehicle_back_damage: "Da\xF1os en la parte trasera",
        vehicle_front_damage: "Da\xF1os en la parte frontal",
        vehicle_roof_damage: "Da\xF1os en el techo",
        signature: "Firma",
        claim_note: "Escrito de reclamo",
        power_of_attorney: "Poder",
        service_bill: "Factura de servicio/impuesto",
        expense_detail_sheet: "Planilla de erogaciones",
        work_incapacity_payment_receipt: "Comprobantes de pago ILT/ILP",
        permanent_work_incapacity_documentation: "Documentaci\xF3n de ILP",
        medical_record: "Historia cl\xEDnica"
      },
      document_group: {
        title: "Documentaci\xF3n que podemos pedirte",
        subtitle: "Revis\xE1 qu\xE9 papeles tener a mano antes de empezar",
        description: "No necesit\xE1s tenerla ahora para crear el reclamo, pero algunas son necesarias para que podamos avanzar con la tramitaci\xF3n.",
        vehicle: "Da\xF1os a un veh\xEDculo",
        real_property: "Da\xF1os a un inmueble",
        injury: "Lesiones",
        death: "Fallecimiento",
        recovery: "Recupero de gastos",
        representation: "Si reclam\xE1s en representaci\xF3n de otra persona",
        other: "Otra documentaci\xF3n"
      },
      document_merged: {
        vehicle_ownership: "T\xEDtulo del veh\xEDculo o C\xE9dula verde",
        national_identity_card: "DNI del damnificado"
      }
    };
    var events = {
      complaint_collaborator_assigned: "Colaborador asignado",
      claim_collaborator_assigned: "Colaborador asignado",
      claim_activity_view: "Vista de actividad de reclamo",
      complaint_documentation_list_view: "Vista de documentaci\xF3n de denuncia",
      fraud_news_requested: "Solicitud de novedades en investigaci\xF3n de fraude",
      fraud_news_answered: "Novedades en investigaci\xF3n de fraude",
      fraud_investigation_case_created: "Investigaci\xF3n de fraude creada",
      fraud_reopened: "Investigaci\xF3n de fraude reabierta",
      fraud_claim_result_updated: "Resultado de reclamo actualizado",
      complaint_responsible_assigned: "Responsable asignado",
      claim_responsible_assigned: "Responsable asignado",
      sinister_complaints_view: "Vista de denuncias",
      sinister_fraud_investigation_cases_view: "Vista de casos de investigaci\xF3n de fraude",
      sinister_expert_appraisals_view: "Vista de peritaciones",
      claim_form_step_completed: "Paso de formulario de reclamo completado",
      claim_form_step_view: "Vista de paso de formulario de reclamo",
      claim_form_vehicle_id_card_extracted: "Lectura de c\xE9dula del veh\xEDculo",
      claim_form_navigation: "Navegaci\xF3n en formulario de reclamo",
      sinister_list_view: "Vista de siniestros",
      settings_profile_view: "Vista de perfil",
      documentation_filter: "Filtro de documentaci\xF3n",
      settings_distribution_view: "Vista de distribuci\xF3n",
      team_created: "Equipo creado",
      team_detail_view: "Vista de detalle de grupo de destino",
      load_balance_rule_created: "Regla de distribuci\xF3n creada",
      load_balance_rule_detail_view: "Vista de detalle de regla de distribuci\xF3n",
      teams_view: "Vista de equipos",
      invitations_view: "Vista de invitaciones",
      roles_view: "Vista de roles",
      load_balance_rules_view: "Vista de reglas de distribuci\xF3n",
      users_invited: "Usuarios invitados",
      forwarded_invitation: "Invitaci\xF3n reenviada",
      role_detail_view: "Vista de detalle de rol",
      claim_created: "Reclamo creado",
      documentation_search: "B\xFAsqueda de documentaci\xF3n",
      file_requested: "Solicitud de documentaci\xF3n creada",
      file_request_placeholder_cancelled: "Solicitud de documentaci\xF3n cancelada",
      file_view: "Vista de documento",
      load_balance_rule_deleted: "Regla de distribuci\xF3n eliminada",
      load_balance_rule_updated: "Regla de distribuci\xF3n actualizada",
      login: "Inicio de sesi\xF3n",
      logout: "Cierre de sesi\xF3n",
      settings_notifications_view: "Vista de notificaciones",
      settings_team_view: "Vista de equipo",
      sinister_activity_view: "Vista de actividad de siniestro",
      files_requested: "Documentaci\xF3n solicitada",
      sinister_complaint_chat_message_send: "Denuncia - Mensaje de chat enviado",
      sinister_claim_chat_message_send: "Reclamo - Mensaje de chat enviado",
      sinister_claim_chat_view: "Vista de chat de reclamo",
      sinister_claim_detail_view: "Vista de detalle de reclamo",
      sinister_claim_view: "Vista del detalle de un reclamo",
      sinister_claims_view: "Vista de reclamos",
      sinister_collaborator_assigned: "Colaborador asignado",
      sinister_collaborator_unassigned: "Colaborador removido",
      sinister_document_view: "Vista de documento de siniestro",
      sinister_documentation_list_view: "Vista de documentaci\xF3n de siniestro",
      sinister_filter: "Filtro de siniestros",
      sinister_responsible_assigned: "Responsable asignado",
      sinister_responsible_unassigned: "Responsable removido",
      sinister_search: "B\xFAsqueda de siniestros",
      sinister_table_view: "Vista de tabla de siniestros",
      sinister_view: "Vista de siniestro",
      team_deleted: "Equipo eliminado",
      team_updated: "Equipo actualizado",
      upload_files: "Subida de archivos",
      claim_responsible_unassigned: "Responsable removido",
      claim_status_updated: "Estado de reclamo actualizado",
      claim_status_communication_sent: "Comunicaci\xF3n autom\xE1tica enviada",
      claim_documentation_requested: "Documentacion solicitada",
      claim_documentation_completed: "Documentacion completa",
      contract_created: "Contrato creado",
      contract_report_created: "Reporte de contrato creado",
      contract_report_accepted: "Reporte de contrato aceptado",
      contract_report_rejected: "Reporte de contrato rechazado",
      offer_expired: "Ofrecimiento expirado",
      offer_rejected: "Ofrecimiento rechazado",
      offer_accepted: "Ofrecimiento aceptado",
      offer_canceled: "Ofrecimiento anulado",
      fraud_closed: "Fraude cerrado",
      resource_type: {
        claim: "reclamo",
        complaint: "denuncia"
      },
      complaint_form_step_view: "Vista de formulario de denuncia",
      rfp_bid_winner_selected: "Ganador de la oferta de licitaci\xF3n seleccionado",
      rfp_bid_submitted: "Oferta de licitaci\xF3n presentada",
      rfp_created: "Licitaci\xF3n creada",
      contract_updates_published: "Novedades de contrato publicadas",
      contract_updates_requested: "Novedades de contrato solicitadas",
      contract_invoice_uploaded: "Factura de contrato cargada",
      appraisal_invoice_uploaded: "Factura de peritaje cargada",
      appraisal_updates_published: "Novedades de peritaje publicadas",
      appraisal_updates_requested: "Novedades de peritaje solicitadas",
      appraisal_report_rejected: "Informe de evaluaci\xF3n rechazado",
      appraisal_report_created: "Informe de evaluaci\xF3n creado",
      appraisal_report_accepted: "Informe de evaluaci\xF3n aceptado",
      field_adjuster_assigned: "Liquidador/Perito asignado",
      fraud_updated: "Investigaci\xF3n de fraude actualizada",
      fraud_investigation_report_accepted: "Informe de investigaci\xF3n de fraude aceptado",
      complaint_file_request_uploaded: "Solicitud de documentaci\xF3n de denuncia cargada",
      file_request_uploaded: "Solicitud de documentaci\xF3n cargada",
      sinister_created: "Siniestro creado",
      sinister_third_party_complaints_view: "Vista de denuncias de terceros",
      complaint_created: "Denuncia creada",
      claim_document_view: "Vista de documento de reclamo",
      external_complaint_documentation_list_view: "Vista de documentaci\xF3n de denuncia externa",
      claim_documentation_list_view: "Vista de documentaci\xF3n de reclamo",
      fraud_activity_view: "Vista de actividad de fraude",
      complaint_activity_view: "Vista de actividad de denuncia",
      complaint_collaborator_unassigned: "Colaborador removido",
      claim_collaborator_unassigned: "Colaborador removido",
      complaint_status_updated: "Estado de denuncia actualizado",
      pending_sinister_complaint: "Denuncia de siniestro pendiente",
      pending_file_request_upload: "Solicitud de carga de documentaci\xF3n pendiente",
      criminal_case_request: "Solicitud de causa penal",
      claim_not_response: "Reclamo sin respuesta",
      claim_offer_flow: "Ofrecimiento de reclamo",
      claim_rejected: "Reclamo rechazado",
      claim_additional_management: "Gestiones adicionales de reclamo",
      claim_ownership_transfer_requested: "Solicitud de transferencia de propiedad de reclamo",
      claim_ownership_transfer_accepted: "Transferencia de propiedad de reclamo aceptada",
      claim_ownership_transfer_rejected: "Transferencia de propiedad de reclamo rechazada",
      claim_ownership_assigned: "Propiedad de reclamo asignada",
      claim_estimates_updated: "Estimaciones de reclamo actualizadas",
      pending_offer_response: "Respuesta de conformidad",
      pending_offer_agreement_response: "Respuesta acuerdo de conformidad pendiente",
      offer_agreement_completed: "Conformidad completada",
      offer_agreement_rejected: "Conformidad rechazada",
      offer_agreement_expired: "Conformidad expirada",
      offer_agreement_cancelled: "Conformidad anulada",
      pending_offer_response_internal: "Respuesta de oferta interna pendiente",
      pending_offer_agreement_response_internal: "Respuesta acuerdo de conformidad interna pendiente",
      claim_updated: "Reclamo actualizado",
      complaint_updated: "Denuncia actualizada",
      complaint_sinister_cause_updated: "Causa de siniestro de denuncia actualizada",
      external_complaint_selected: "Definir denuncia principal",
      claim_derived: "Reclamo derivado",
      claim_derived_returned: "Reclamo derivado devuelto",
      claim_responsibility_returned: "Responsabilidad de reclamo devuelta",
      pending_complaint_created: "Denuncia de oficio creada",
      pending_complaint_requested: "Denuncia de oficio solicitada",
      pending_complaint_creation_failed: "Error en creaci\xF3n de denuncia de oficio",
      external_complaint_selection_failed: "Error en selecci\xF3n de denuncia principal",
      rfp_expired: "Licitaci\xF3n expirada",
      external_complaint_created: "Denuncia creada en el sistema tercero",
      complaint_authorized: "Denuncia autorizada",
      external_complaint_authorized: "Denuncia autorizada en el sistema tercero",
      complaint_approved: "Denuncia aprobada",
      external_complaint_approved: "Denuncia aprobada en el sistema tercero",
      complaint_rejected: "Denuncia rechazada",
      external_complaint_rejected: "Denuncia rechazada en el sistema tercero",
      complaint_estimates_updated: "Estimaciones de denuncia actualizadas",
      order_created: "Orden creada",
      order_report_created: "Reporte de orden creado",
      order_report_accepted: "Reporte de orden aceptado",
      order_report_rejected: "Reporte de orden rechazado",
      order_updates_published: "Mensajes de orden enviados",
      order_updates_requested: "Mensajes de orden solicitados",
      order_invoice_uploaded: "Factura de orden cargada",
      order_scheduled: "Trabajo de orden coordinado",
      order_rescheduled: "Trabajo de orden recoordinado",
      order_schedule_canceled: "Turno de orden anulado",
      alert_sla_objective_progress: "Alerta de progreso de objetivo de SLA",
      alert_sla_total_progress: "Alerta de progreso total de SLA",
      sinister_external_status_updated: "Estado externo de siniestro actualizado",
      complaint_confirmation_signature: "Denuncia firmada",
      tags_view: "Vista de etiquetas",
      tag_created: "Etiqueta creada",
      tag_updated: "Etiqueta actualizada",
      tag_deleted: "Etiqueta eliminada",
      claim_file_uploaded: "Documento de reclamo cargado",
      claim_comment_created: "Comentario en reclamo creado",
      claim_confirmation_signature: "Firma de reclamo",
      offer_agreement_created: "Conformidad creada",
      offer_created: "Ofrecimiento creado",
      target_group_created: "Grupo creado",
      target_group_deleted: "Grupo eliminado",
      target_group_updated: "Grupo actualizado",
      target_groups_view: "Vista de grupos",
      target_group_detail_view: "Vista de detalle de grupo",
      rfp_canceled: "Licitaci\xF3n cancelada",
      claim_created_documents_missing: "Reclamo creado con documentaci\xF3n faltante",
      offer_agreement_dispatch_failed: "Env\xEDo a firmar fallido",
      user_assignments_paused: "Usuario marcado como no disponible",
      user_assignments_resumed: "Usuario marcado como disponible",
      team_claims_reassigned: "Reclamos del equipo reasignados",
      team_claims_delegated: "Reclamos delegados por inactividad",
      user_inactivity_started: "Usuario pas\xF3 a inactivo",
      user_inactivity_ended: "Usuario volvi\xF3 a activo",
      user_inactivity_scheduled: "Inactividad de usuario programada",
      user_inactivity_rescheduled: "Inactividad de usuario modificada",
      user_inactivity_return_changed: "Fecha de regreso de usuario modificada",
      user_inactivity_cancelled: "Inactividad de usuario cancelada",
      team_claims_recovered: "Reclamos delegados recuperados por su due\xF1o",
      user_delegated_claims_recovered: "Reclamos delegados recuperados",
      user_delegated_claims_returned: "Reclamos delegados retornados",
      user_derived_claims_returned: "Reclamos derivados retornados desde Gesti\xF3n de equipo",
      user_derived_claims_recovered: "Reclamos derivados recuperados desde Gesti\xF3n de equipo"
    };
    var fileRequest = {
      cancelPlaceholderTitle: "Cancelar solicitud de documento",
      cancelPlaceholderDescription: "Escribe el motivo por el cual cancelas la solicitud de este documento",
      cancelPlaceholderSuccess: "Solicitud cancelada",
      cancelPlaceholderSuccessDescription: "La solicitud de documento fue cancelada correctamente",
      cancelled: "Cancelado",
      reason: "Motivo"
    };
    var entities = {
      vehicle_id_card_back: {
        label: "C\xE9dula (dorso)",
        owner_name: "Nombre",
        owner_address: "Direcci\xF3n",
        owner_identity_number: "Documento"
      },
      vehicle_id_card_front: {
        label: "C\xE9dula (frente)",
        license_plate: "Patente",
        id_card_number: "Documento",
        chassis_number: "Chasis",
        model: "Modelo",
        make: "Marca",
        type: "Tipo",
        use: "Uso",
        motor: "Motor",
        expiration_date: "Fecha de expiraci\xF3n"
      },
      death_certificate: {
        label: "Certificado de defunci\xF3n",
        day: "Dia",
        hour: "Hora",
        year: "A\xF1o",
        reason: "Motivo"
      },
      medical_certificate: {
        label: "Certificado m\xE9dico",
        doctor_full_name: "Medico",
        doctor_license_number: "Matricula",
        date: "Fecha",
        diagnosis: "Diagn\xF3stico"
      },
      coverage_certificate: {
        label: "Certificado de cobertura",
        effective_date_from: "Vigencia desde",
        effective_date_to: "Vigencia hasta"
      },
      vehicle: {
        label: "Veh\xEDculo",
        license_plate: "Patente"
      },
      national_identity_card: {
        label: "DNI",
        first_name: "Nombre",
        last_name: "Apellido",
        birth_date: "Fecha de nacimiento",
        issued_date: "Fecha de emision",
        sex: "G\xE9nero",
        expiration_date: "Fecha de expiraci\xF3n",
        document_number: "Documento"
      }
    };
    var validations = {
      document_number: "N\xFAmero de documento",
      full_name: "Nombre",
      address: "Direcci\xF3n/Domicilio",
      make: "Marca",
      model: "Modelo",
      license_plate: "Patente/Dominio",
      birth_date: "Fecha de nacimiento",
      victim_national_identity_card_birth_date: "Fecha de nacimiento",
      medical_certificate_sinister_date: "Dias h\xE1biles",
      health_insurance_fund: "Obra social",
      doctor_stamp_visible: "Sello del m\xE9dico",
      doctor_license_number_visible: "Matr\xEDcula del m\xE9dico",
      diagnosis_visible: "Diagn\xF3stico",
      vehicle_license_plate: "Patente",
      vehicle_ownership: "Propiedad del veh\xEDculo",
      policy_period: "Vigencia de la p\xF3liza",
      death_certificate_fields: "Certificado de defunci\xF3n",
      national_identity_card_fields: "DNI",
      worker_compensation_insurer: "ART"
    };
    var entrypoints = {
      claim: "Reclamo",
      complaint: "Denuncia"
    };
    var backends = {
      rivadavia: "Rivadavia Seguros",
      tajy: "Tajy Seguros",
      demoempleo: "Demo Empleo",
      gamma: "Gamma Distribuidora"
    };
    var file_types = {
      other: "Otro",
      pdf: "PDF",
      audio: "Audio",
      image: "Imagen",
      document: "Documento",
      video: "Video",
      any: "Cualquier archivo"
    };
    var sinister = {
      tabs: {
        documents: "Documentaci\xF3n",
        claims: "Reclamos",
        activity: "Actividad"
      },
      status: {
        pending: "Pendiente",
        open: "Abierto",
        closed: "Cerrado",
        rejected: "Rechazado",
        in_process: "En proceso"
      }
    };
    var errors = {
      not_found_trigger_mapping: {
        title: "Equivalencia no encontrada",
        description: "La equivalencia ya no existe. Actualiz\xE1 la p\xE1gina."
      },
      trigger_mapping_move_out_of_bounds: {
        title: "No se puede mover la equivalencia",
        description: "La equivalencia ya est\xE1 en el extremo de la lista."
      },
      ownership_transfer_superseded: {
        title: "La invitaci\xF3n ya no es v\xE1lida",
        description: "El reclamo cambi\xF3 de reclamante despu\xE9s de que se envi\xF3 esta invitaci\xF3n."
      },
      victim_email_must_differ_from_owner: {
        title: "El email del damnificado no puede ser el tuyo",
        description: "Est\xE1s cargando el reclamo en representaci\xF3n de otra persona, as\xED que el damnificado tiene que quedar con su propio email."
      },
      claimant_email_must_differ_from_victim: {
        title: "El damnificado y el reclamante no pueden compartir el email",
        description: "El reclamo no se carga en nombre propio, as\xED que el damnificado tiene que quedar con un email distinto al del reclamante."
      },
      claimant_identification_must_match_victim: {
        title: "El documento no es el del damnificado",
        description: "Elegiste reclamar en nombre propio, pero el documento de tu cuenta no es el que figura como damnificado. Si est\xE1s reclamando por otra persona, indic\xE1 el v\xEDnculo que te une a ella."
      },
      claim_owner_already_assigned: {
        title: "Ya es el reclamante",
        description: "Ese usuario ya es el due\xF1o del reclamo."
      },
      agreement_template_not_found: {
        title: "No se encontr\xF3 la plantilla",
        description: "La plantilla no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_template_version_not_found: {
        title: "No se encontr\xF3 la versi\xF3n",
        description: "La versi\xF3n no existe o no pertenece a esta plantilla."
      },
      agreement_template_name_already_exists: {
        title: "Nombre repetido",
        description: "Ya existe una plantilla con ese nombre en la compa\xF1\xEDa."
      },
      agreement_template_draft_already_exists: {
        title: "Ya hay un borrador",
        description: "La plantilla ya tiene un borrador en edici\xF3n. Publicalo o segu\xED edit\xE1ndolo."
      },
      agreement_template_version_not_draft: {
        title: "La versi\xF3n no es un borrador",
        description: "Solo se puede editar un borrador. Cre\xE1 una versi\xF3n nueva para cambiar el texto."
      },
      agreement_template_version_not_published: {
        title: "La versi\xF3n no est\xE1 publicada",
        description: "Solo se puede deprecar una versi\xF3n publicada."
      },
      agreement_template_syntax_error: {
        title: "Error de sintaxis en un bloque",
        description: "Un bloque tiene una condici\xF3n mal cerrada o una sintaxis inv\xE1lida: {{message}}"
      },
      agreement_template_unknown_variable: {
        title: "Variables desconocidas",
        description: "El texto referencia variables que no existen en el cat\xE1logo: {{keys}}"
      },
      agreement_clone_target_company_not_found: {
        title: "Compa\xF1\xEDa destino inexistente",
        description: "La compa\xF1\xEDa a la que se quiere clonar no existe."
      },
      agreement_clone_same_company: {
        title: "Es la misma compa\xF1\xEDa",
        description: "Para copiar dentro de la misma compa\xF1\xEDa us\xE1 Duplicar."
      },
      agreement_clone_unresolved_references: {
        title: "Faltan referencias por resolver",
        description: "Estas referencias no tienen equivalente elegido en la compa\xF1\xEDa destino: {{references}}"
      },
      agreement_clone_missing_variables: {
        title: "Variables que el destino no tiene",
        description: "El texto usa variables que la compa\xF1\xEDa destino no define: {{keys}}"
      },
      agreement_template_unknown_condition_option: {
        title: "Condici\xF3n hacia algo que la compa\xF1\xEDa no tiene",
        description: "El bloque {{block_id}} est\xE1 condicionado a valores que esta compa\xF1\xEDa no tiene, as\xED que nunca se imprimir\xEDa: {{values}}"
      },
      agreement_template_invalid_signers: {
        title: "Recuadros de firma inconsistentes",
        description: "Hay bloques de firmas que referencian recuadros inexistentes o recuadros que ning\xFAn bloque imprime: {{keys}}"
      },
      agreement_template_version_unchanged: {
        title: "Sin cambios",
        description: "El contenido es id\xE9ntico al de la versi\xF3n publicada."
      },
      agreement_template_has_published_version: {
        title: "La plantilla tiene una versi\xF3n publicada",
        description: "Deprec\xE1 la versi\xF3n publicada antes de eliminar la plantilla."
      },
      agreement_document_not_found: {
        title: "No se encontr\xF3 el documento",
        description: "El documento de conformidad no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_document_render_failed: {
        title: "No se pudo generar el PDF",
        description: "El renderizado fall\xF3 y el documento qued\xF3 registrado como fallido: {{reason}}"
      },
      agreement_claim_not_found: {
        title: "No se encontr\xF3 el reclamo",
        description: "El reclamo no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_offer_not_found: {
        title: "El reclamo no tiene ofrecimiento",
        description: "No encontramos el ofrecimiento indicado para este reclamo. Sin ofrecimiento no hay variables que resolver."
      },
      agreement_offer_type_unsupported: {
        title: "Ofrecimiento no soportado",
        description: "Las conformidades solo aplican a ofrecimientos de reclamos."
      },
      agreement_message_template_not_found: {
        title: "No se encontr\xF3 la plantilla",
        description: "La plantilla de ofrecimiento no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_acceptance_values_invalid: {
        title: "Valores de aceptaci\xF3n inv\xE1lidos",
        description: "Los valores de la aceptaci\xF3n deben ser un objeto indexado por el guid de cada variable."
      },
      non_corporate_integration_account: {
        title: "Cuenta no corporativa",
        description: "Conect\xE1 la integraci\xF3n con tu cuenta de correo corporativa."
      },
      unexpected_error: {
        title: "Ocurri\xF3 un error",
        description: "No pudimos completar la acci\xF3n. Por favor, intent\xE1 nuevamente en unos minutos."
      },
      customer_organization_already_exists: {
        title: "Nombre en uso",
        description: "Ya existe una organizaci\xF3n con ese nombre."
      },
      customer_organization_not_found: {
        title: "Organizaci\xF3n no encontrada",
        description: "La organizaci\xF3n no existe o fue eliminada."
      },
      customer_organization_user_not_linkable: {
        title: "No se puede vincular",
        description: "Solo se puede vincular un reclamante que no pertenezca a otra organizaci\xF3n."
      },
      customer_organization_user_not_member: {
        title: "Usuario no pertenece a la organizaci\xF3n",
        description: "El usuario indicado no es miembro de esta organizaci\xF3n."
      },
      customer_organization_user_owns_claims: {
        title: "Reclamos pendientes de reasignar",
        description: "El usuario tiene reclamos de la organizaci\xF3n a su nombre: eleg\xED a qui\xE9n reasignarlos."
      },
      customer_organization_invitation_not_found: {
        title: "Invitaci\xF3n no encontrada",
        description: "La invitaci\xF3n no existe o no pertenece a esta organizaci\xF3n."
      },
      customer_organization_invitation_already_exists: {
        title: "Invitaci\xF3n pendiente",
        description: "Ya hay una invitaci\xF3n vigente para ese email en esta organizaci\xF3n. Pod\xE9s reenviarla desde la tabla de invitaciones."
      },
      customer_organization_invitation_not_resendable: {
        title: "No se puede reenviar",
        description: "Solo se pueden reenviar invitaciones pendientes o vencidas."
      },
      customer_organization_invitation_not_cancellable: {
        title: "No se puede cancelar",
        description: "Solo se pueden cancelar invitaciones pendientes o vencidas."
      },
      customer_organization_invitation_invalid_tenant: {
        title: "Aseguradora inv\xE1lida",
        description: "Eleg\xED una aseguradora con portal habilitado para enviar la invitaci\xF3n."
      },
      customer_organization_sign_in_invalid_tenant: {
        title: "Aseguradora inv\xE1lida",
        description: "Eleg\xED una aseguradora con portal habilitado para iniciar sesi\xF3n."
      },
      customer_organization_transfer_not_allowed: {
        title: "Transferencia no disponible",
        description: "Los reclamos de una organizaci\xF3n pertenecen a la organizaci\xF3n: sus miembros no pueden transferirlos ni recibir transferencias."
      },
      order_document_requirement_name_already_exists: {
        title: "Nombre repetido",
        description: "Esta compa\xF1\xEDa ya tiene un documento con ese nombre."
      },
      order_document_requirement_not_found: {
        title: "Documento no encontrado",
        description: "El documento ya no existe o fue eliminado."
      },
      claim_status_without_equivalence: {
        title: "Estado sin equivalencia",
        description: "El estado elegido no tiene una equivalencia configurada. Definila primero para que la sincronizaci\xF3n pueda derivar la etapa y la referencia del reclamo."
      },
      status_linked_to_order_claim_mapping: {
        title: "Estado vinculado a una sincronizaci\xF3n",
        description: "Este estado est\xE1 siendo usado por una sincronizaci\xF3n orden - reclamo. Elimin\xE1 esa sincronizaci\xF3n antes de eliminar el estado."
      },
      order_claim_status_mapping_not_found: {
        title: "Sincronizaci\xF3n no encontrada",
        description: "La sincronizaci\xF3n ya no existe o fue eliminada."
      },
      autoinspector_not_configured: {
        title: "Autoinspector no est\xE1 configurado",
        description: "La compa\xF1\xEDa todav\xEDa no carg\xF3 su API Key de Autoinspector."
      },
      autoinspector_already_configured: {
        title: "Autoinspector ya est\xE1 configurado",
        description: "Ya hay una API Key cargada. Si quer\xE9s cambiarla, us\xE1 la opci\xF3n de actualizar."
      },
      autoinspector_invalid_credentials: {
        title: "API Key inv\xE1lida",
        description: "Autoinspector rechaz\xF3 la clave. Verific\xE1 que la copiaste completa y que sigue activa."
      },
      autoinspector_subscription_inactive: {
        title: "Suscripci\xF3n inactiva",
        description: "La cuenta de Autoinspector tiene la suscripci\xF3n vencida o una factura impaga."
      },
      autoinspector_quota_exceeded: {
        title: "L\xEDmite del plan alcanzado",
        description: "La cuenta de Autoinspector lleg\xF3 al l\xEDmite de inspecciones de su plan."
      },
      autoinspector_wrong_environment: {
        title: "Clave de otro entorno",
        description: "Est\xE1s usando una clave de prueba contra un recurso productivo, o al rev\xE9s."
      },
      autoinspector_invalid_request: {
        title: "Autoinspector rechaz\xF3 la solicitud",
        description: "Los datos enviados no cumplen con lo que espera Autoinspector."
      },
      autoinspector_inspection_not_found: {
        title: "Inspecci\xF3n no encontrada",
        description: "La inspecci\xF3n no existe en Autoinspector."
      },
      autoinspector_unavailable: {
        title: "Autoinspector no est\xE1 disponible",
        description: "No pudimos comunicarnos con Autoinspector. Intent\xE1 nuevamente en unos minutos."
      },
      kach_unavailable: {
        title: "Kach no est\xE1 disponible",
        description: "No pudimos comunicarnos con Kach. Intent\xE1 nuevamente en unos minutos."
      },
      integration_connection_not_found: {
        title: "Integraci\xF3n no configurada",
        description: "Tu compa\xF1\xEDa todav\xEDa no tiene configurada la integraci\xF3n con Kach. Pedile a tu administrador que la active."
      },
      kach_insufficient_permissions: {
        title: "Tu rol en Kach no lo permite",
        description: "Tu cuenta de Kach est\xE1 conectada, pero tu rol no permite esta acci\xF3n. Pedile a un administrador de Kach que revise tus permisos."
      },
      kach_machine_client_incomplete: {
        title: "Falta el cliente de m\xE1quina",
        description: "Para usar la credencial de m\xE1quina carg\xE1 el ID y el secreto del cliente de Kach."
      },
      kach_machine_credential_rejected: {
        title: "Kach rechaz\xF3 la credencial de la compa\xF1\xEDa",
        description: "Revis\xE1 el cliente de m\xE1quina de Kach en el backoffice o desactiv\xE1 la credencial de m\xE1quina."
      },
      kach_connection_required: {
        title: "Conect\xE1 tu cuenta de Kach",
        description: "Para continuar necesit\xE1s conectar o reconectar tu cuenta de Kach desde este mismo di\xE1logo."
      },
      kach_connection_not_found: {
        title: "No hay una cuenta de Kach conectada",
        description: "Todav\xEDa no conectaste tu cuenta de Kach."
      },
      kach_oauth_disabled: {
        title: "Conexi\xF3n con Kach no habilitada",
        description: "Tu aseguradora todav\xEDa no habilit\xF3 la conexi\xF3n de cuentas con Kach."
      },
      kach_oauth_not_configured: {
        title: "Conexi\xF3n con Kach sin configurar",
        description: "Falta configurar la conexi\xF3n con Kach para tu aseguradora. Avisale a soporte."
      },
      kach_oauth_state_invalid: {
        title: "La conexi\xF3n expir\xF3",
        description: "El intento de conexi\xF3n venci\xF3 o ya se us\xF3. Volv\xE9 a intentarlo desde Piramid."
      },
      kach_oauth_denied: {
        title: "Kach no autoriz\xF3 la conexi\xF3n",
        description: "No se complet\xF3 la autorizaci\xF3n en Kach. Volv\xE9 a intentarlo."
      },
      kach_company_mismatch: {
        title: "La cuenta de Kach es de otra aseguradora",
        description: "Inici\xE1 sesi\xF3n en Kach con la cuenta de tu aseguradora y volv\xE9 a intentarlo."
      },
      kach_email_mismatch: {
        title: "La cuenta de Kach no coincide",
        description: "Conect\xE1 la cuenta de Kach que usa tu mismo correo electr\xF3nico."
      },
      unauthorized_oauth_query: {
        title: "No se pudo completar la conexi\xF3n",
        description: "El proveedor rechaz\xF3 el c\xF3digo de autorizaci\xF3n. Volv\xE9 a intentarlo."
      },
      autoinspector_webhook_deletion_failed: {
        title: "No pudimos borrar el webhook",
        description: "Autoinspector no acept\xF3 eliminar el webhook, as\xED que no borramos las credenciales. Si la cuenta ya no existe, volv\xE9 a intentarlo forzando la eliminaci\xF3n."
      },
      autoinspector_template_not_configured: {
        title: "Falta la plantilla",
        description: "Este caso de uso no tiene ninguna plantilla de Autoinspector asignada."
      },
      autoinspector_template_already_assigned: {
        title: "El caso de uso ya tiene plantilla",
        description: "Hay una sola plantilla por caso de uso. Edit\xE1 la existente o eliminala antes de asignar otra."
      },
      autoinspector_template_not_found: {
        title: "Plantilla no encontrada",
        description: "La asignaci\xF3n que quer\xE9s modificar no existe o pertenece a otra empresa."
      },
      order_work_proof_not_completed: {
        title: "Falta la prueba de trabajo",
        description: "La orden necesita al menos una inspecci\xF3n de Autoinspector completada para poder finalizarse."
      },
      order_work_proof_not_creatable: {
        title: "No se puede crear la inspecci\xF3n",
        description: "Solo se puede solicitar una inspecci\xF3n con la orden en curso y sin otra inspecci\xF3n vigente sin resolver."
      },
      order_work_proof_inspection_not_found: {
        title: "La orden no tiene inspecciones",
        description: "Todav\xEDa no se solicit\xF3 una prueba de trabajo para esta orden."
      },
      order_work_proof_invalid_item_count: {
        title: "No se podr\xE1 crear la prueba de trabajo",
        description: "Esta orden incluye una prueba de trabajo, que exige entre 1 y 10 \xEDtems en total. Cargalos antes de derivarla: despu\xE9s no se pueden modificar."
      },
      order_work_proof_missing_product_brand: {
        title: "No se podr\xE1 crear la prueba de trabajo",
        description: "Esta orden incluye una prueba de trabajo, que necesita la marca de los productos. Us\xE1 \xEDtems del cat\xE1logo con marca cargada antes de derivarla."
      },
      order_work_proof_missing_license_plate: {
        title: "No se podr\xE1 crear la prueba de trabajo",
        description: "Esta orden incluye una prueba de trabajo, que necesita la patente del veh\xEDculo. Cargala en el da\xF1o material del reclamo antes de derivarla."
      },
      order_work_proof_template_mismatch: {
        title: "La plantilla de inspecci\xF3n no coincide",
        description: "La plantilla de Autoinspector ya no expone los datos que la prueba de trabajo necesita ({{assets}}). Revis\xE1 la configuraci\xF3n de la plantilla."
      },
      order_not_scheduled: {
        title: "Falta la coordinaci\xF3n del trabajo",
        description: "Registr\xE1 cu\xE1ndo se realiza el trabajo antes de finalizar la orden."
      },
      order_schedule_not_editable: {
        title: "No se puede coordinar",
        description: "Solo se puede registrar o modificar la coordinaci\xF3n con la orden en curso."
      },
      unknown_autoinspector_use_case: {
        title: "Caso de uso desconocido",
        description: "El caso de uso no est\xE1 en el cat\xE1logo de Autoinspector."
      },
      webhook_signature_invalid: {
        title: "Firma inv\xE1lida",
        description: "La firma del webhook no coincide con la esperada."
      },
      integration_backend_self_managed: {
        title: "Integraci\xF3n autoadministrada",
        description: "Esta integraci\xF3n se configura desde su propia secci\xF3n. Crearla ac\xE1 guardar\xEDa la credencial sin cifrar y sin webhook."
      },
      not_claim_owner: {
        title: "No sos el due\xF1o del reclamo",
        description: "Solo el due\xF1o actual del reclamo puede realizar esta acci\xF3n."
      },
      validation_error: {
        title: "Error de validaci\xF3n",
        description: "El valor ingresado no es v\xE1lido"
      },
      product_sku_already_exists: {
        title: "SKU ya registrado",
        description: "El SKU ingresado ya est\xE1 en uso por otro producto, incluso si fue eliminado."
      },
      product_not_found: {
        title: "Producto no encontrado",
        description: "El producto indicado no existe"
      },
      customer_already_exists: {
        title: "Cliente ya registrado",
        description: "El nombre ingresado ya est\xE1 en uso por otro cliente, incluso si fue eliminado."
      },
      customer_not_found: {
        title: "Cliente no encontrado",
        description: "El cliente indicado no existe"
      },
      engagement_external_id_already_exists: {
        title: "C\xF3digo ya registrado",
        description: "Otro proveedor de tu red ya usa este c\xF3digo interno."
      },
      provider_group_already_exists: {
        title: "Grupo ya registrado",
        description: "Ya existe otro grupo de proveedores con el mismo nombre."
      },
      provider_group_not_found: {
        title: "Grupo no encontrado",
        description: "El grupo de proveedores indicado no existe."
      },
      provider_group_not_empty: {
        title: "El grupo tiene proveedores",
        description: "Para eliminar el grupo, primero quit\xE1 todos sus proveedores."
      },
      provider_not_in_active_network: {
        title: "Proveedor no disponible",
        description: "El proveedor debe tener una relaci\xF3n activa con tu empresa para formar parte de un grupo."
      },
      case_already_closed: {
        title: "El caso no puede derivarse porque ya fue analizado y cerrado.",
        description: "Comunicate con el responsable de la investigaci\xF3n en Kach ({{responsible_name}} - {{responsible_email}}) y pedile que lo reabra."
      },
      kach_case_in_trash: {
        title: "El siniestro #{{sinister_id}} ya existe pero se encuentra en la papelera.",
        description: "No es posible crear un nuevo caso con este n\xFAmero de siniestro. Comun\xEDquese con un usuario con permisos suficientes para restaurar el caso desde la papelera."
      },
      fraud_case_linked_to_another_sinister: {
        title: "El caso ya est\xE1 asociado a otro siniestro",
        description: "El caso de kach ya est\xE1 asociado a la investigaci\xF3n de otro siniestro de Piramid. Deriv\xE1 los reclamos desde ese siniestro."
      },
      not_found_vertical: {
        title: "Vertical no encontrado",
        description: "El vertical indicado no existe"
      },
      engagement_already_exists: {
        title: "Proveedor ya en tu red",
        description: "Este proveedor ya forma parte de tu red"
      },
      provider_invitation_already_exists: {
        title: "Invitaci\xF3n pendiente",
        description: "Ya existe una invitaci\xF3n pendiente para este email. Debes anularla antes de volver a invitar."
      },
      provider_invitation_not_found: {
        title: "Invitaci\xF3n no encontrada",
        description: "La invitaci\xF3n indicada no existe"
      },
      provider_invitation_not_pending: {
        title: "Acci\xF3n no disponible",
        description: "Solo se puede reenviar o anular una invitaci\xF3n pendiente"
      },
      provider_already_exists: {
        title: "Proveedor ya registrado",
        description: "Ya existe un proveedor registrado con este email"
      },
      provider_ein_already_exists: {
        title: "CUIT ya registrado",
        description: "Ya existe un proveedor registrado con este CUIT"
      },
      provider_legal_name_already_exists: {
        title: "Raz\xF3n social ya registrada",
        description: "Ya existe una empresa registrada con esta raz\xF3n social"
      },
      invalid_invitation_token: {
        title: "Invitaci\xF3n inv\xE1lida",
        description: "El enlace de invitaci\xF3n no es v\xE1lido"
      },
      invitation_expired: {
        title: "Invitaci\xF3n vencida",
        description: "La invitaci\xF3n ya expir\xF3. Ped\xED que te reenv\xEDen una nueva."
      },
      engagement_not_pending: {
        title: "Acci\xF3n no disponible",
        description: "Solo se puede aceptar o rechazar una invitaci\xF3n pendiente"
      },
      engagement_invalid_transition: {
        title: "Acci\xF3n no disponible",
        description: "El estado actual del proveedor no permite esta acci\xF3n"
      },
      engagement_not_active: {
        title: "Proveedor no vinculado",
        description: "No hay un v\xEDnculo activo con este proveedor para derivarle trabajo"
      },
      provider_has_active_order: {
        title: "El proveedor ya tiene una orden activa",
        description: "Este proveedor ya tiene una orden pendiente o en curso en este reclamo. An\xFAlala antes de derivar una nueva."
      },
      order_not_in_progress: {
        title: "La orden no est\xE1 en curso",
        description: "La orden debe estar en curso para subir o revisar la documentaci\xF3n requerida."
      },
      order_not_open: {
        title: "La orden ya est\xE1 cerrada",
        description: "Solo se puede gestionar la documentaci\xF3n mientras la orden est\xE1 pendiente o en curso."
      },
      order_file_not_importable: {
        title: "Documentaci\xF3n no disponible",
        description: "Uno o m\xE1s documentos no pertenecen al reclamo o denuncia de esta orden."
      },
      order_document_not_found: {
        title: "Documento no encontrado",
        description: "El documento no est\xE1 adjunto a esta orden o ya fue eliminado."
      },
      order_document_wrong_uploader: {
        title: "Acci\xF3n no disponible",
        description: "Solo pod\xE9s eliminar la documentaci\xF3n que subi\xF3 tu compa\xF1\xEDa."
      },
      deliverable_not_latest: {
        title: "Entregable no vigente",
        description: "Solo se puede revisar el entregable m\xE1s reciente."
      },
      invalid_deliverable_review_transition: {
        title: "Acci\xF3n no disponible",
        description: "No es posible realizar esa acci\xF3n sobre el estado actual del entregable."
      },
      vertical_in_use: {
        title: "Vertical en uso",
        description: "No se puede eliminar: el vertical est\xE1 asignado a una o m\xE1s aseguradoras"
      },
      vertical_slug_already_exists: {
        title: "Slug duplicado",
        description: "Ya existe un vertical con ese slug"
      },
      not_found_good: {
        title: "Bien no encontrado",
        description: "El bien indicado no existe"
      },
      not_found_service: {
        title: "Servicio no encontrado",
        description: "El servicio indicado no existe"
      },
      good_name_already_exists: {
        title: "Bien duplicado",
        description: "Ya existe un bien con ese nombre en el vertical"
      },
      service_name_already_exists: {
        title: "Servicio duplicado",
        description: "Ya existe un servicio con ese nombre en el vertical"
      },
      tenant_slug_already_set: {
        title: "Subdominio ya configurado",
        description: "No puedes cambiar un subdominio ya configurado"
      },
      invalid_verification_code: {
        title: "C\xF3digo de verificaci\xF3n inv\xE1lido",
        description: "El c\xF3digo de verificaci\xF3n ingresado no es v\xE1lido"
      },
      team_name_already_exists: {
        title: "Equipo ya existente",
        description: "Ya existe un equipo con el nombre '{{name}}'"
      },
      invalid_claim_system_status: {
        title: "Reclamo cerrado",
        description: "No puedes realizar modificaciones sobre un reclamo cerrado"
      },
      claim_locked_by_fraud_investigation: {
        title: "Reclamo bloqueado",
        description: "El reclamo se encuentra temporalmente bloqueado y no permite esta acci\xF3n"
      },
      complaint_is_already_closed: {
        title: "Denuncia cerrada",
        description: "La denuncia se encuentra cerrada, por lo que no puedes cambiar al estado deseado"
      },
      status_already_linked: {
        title: "Equivalencia vinculada",
        description: "Este estado se encuentra dentro de una equivalencia, por lo que no puedes eliminarlo"
      },
      existent_trigger_mapping: {
        title: "Opci\xF3n vinculada en equivalencias",
        description: "Esta opci\xF3n se encuentra vinculada a una equivalencia con el estado: {{triggerMappingStatusName}}. Aseg\xFArate de eliminar la equivalencia antes de eliminar la opci\xF3n"
      },
      invalid_role: {
        title: "Permisos insuficientes",
        description: "Tu rol no cuenta con los permisos necesarios para realizar esta acci\xF3n"
      },
      zip_code_not_found: {
        title: "C\xF3digo postal invalido",
        description: "El c\xF3digo postal no es valido seg\xFAn el pa\xEDs y provincia ingresado"
      },
      overlapping_sla: {
        title: "Conflicto con otra versi\xF3n",
        description: "Ya existe otra versi\xF3n de SLA con la misma fecha de vigencia"
      },
      integration_auth_error: {
        title: "Error de autenticaci\xF3n de integraci\xF3n",
        description: "Se ha producido un error de autenticaci\xF3n de integraci\xF3n. Aseg\xFArate de tener una conexi\xF3n v\xE1lida y que tu usuario tenga permisos para acceder al recurso solicitado."
      },
      not_found_provider_template: {
        title: "Plantilla no encontrada",
        description: "No se pudo encontrar la plantilla seleccionada en el proveedor. Aseg\xFArate de tener una conexi\xF3n valida y que tu usuario tenga permisos para acceder a la plantilla."
      },
      unexpected_provider_error: {
        title: "Error inesperado en proveedor",
        description: "Ocurri\xF3 un error inesperado al momento de comunicarse con el proveedor. Intenta de nuevo o mas tarde."
      },
      missing_variable_definition: {
        title: "Referencia a variable invalida",
        description: "El mensaje contiene una referencia una variable inexistente"
      },
      wrong_ownership_transfer_destination_user: {
        title: "Usuario invalido",
        description: "Esta solicitud de transferencia de propiedad del reclamo le pertenece al usuario {{destination_user_email}}"
      },
      not_found_destination_user: {
        title: "Usuario no encontrado",
        description: "El correo ingresado no pertenece a ning\xFAn usuario. Aseg\xFArate de que el correo sea correcto"
      },
      wrong_recoverable_user_company: {
        title: "Empresa invalida",
        description: "No puedes registrarte con este correo ya que pertenece a un usuario de otra empresa"
      },
      unrecoverable_user_type: {
        title: "Tipo de usuario invalido",
        description: "No puedes registrarte con este correo ya que posee un rol no apto para la plataforma actual"
      },
      cannot_transfer_to_yourself: {
        title: "Usuario invalido",
        description: "No puedes transferir un reclamo a ti mismo"
      },
      invalid_field_value_from_provider: {
        title: "Error de validaci\xF3n de campo",
        description: "El proveedor ha indicado que el valor del campo '{{field_label}}' no es v\xE1lido de acuerdo a la configuraci\xF3n de la plantilla en la plataforma externa"
      },
      user_already_exists: {
        title: "Usuario ya existente",
        description: "Este usuario ya existe actualmente o se ha invitado previamente. Aseg\xFArate de ingresar un correo de un usuario que no forme parte de la plataforma"
      },
      complaint_already_exists: {
        title: "Denuncia duplicada",
        description: "Recientemente se ha creado una denuncia id\xE9ntica a la actual"
      },
      license_plate_remote_not_found: {
        title: "Patente invalida",
        description: "No pudimos corroborar correctamente los datos con la patente ingresada"
      },
      license_plate_remote_check_error: {
        title: "Error al validar el ingreso del reclamo",
        description: "{{attributeCheckErrorMessage}}"
      },
      role_name_already_exists: {
        title: "Nombre de rol existente",
        description: "El nombre de rol ya existe. Por favor, ingrese otro nombre."
      },
      company_not_found: {
        title: "Empresa no encontrada",
        description: "La empresa ingresada no fue encontrada."
      },
      role_not_found: {
        title: "Rol no encontrado",
        description: "El rol ingresado no fue encontrado."
      },
      invalid_user_type: {
        title: "Tipo de usuario inv\xE1lido",
        description: "El tipo de usuario ingresado no puede realizar esta acci\xF3n."
      },
      not_found_user: {
        title: "Usuario no encontrado",
        description: "El usuario ingresado no fue encontrado."
      },
      emails_already_exists: {
        title: "Emails existentes",
        description: "Los emails ingresados ya existen en nuestra base de datos. Por favor, ingrese otros emails."
      },
      invitations_already_exists: {
        title: "Invitaciones existentes",
        description: "Las invitaciones ingresadas ya existen en nuestra base de datos. Por favor, ingrese otras invitaciones."
      },
      invitation_not_found: {
        title: "Invitaci\xF3n no encontrada",
        description: "La invitaci\xF3n ingresada no fue encontrada."
      },
      username_already_exists: {
        title: "Nombre de usuario existente",
        description: "El nombre de usuario ya existe en nuestra base de datos. Por favor, ingrese otro nombre de usuario."
      },
      not_found_claim: {
        title: "Reclamo no encontrado",
        description: "El reclamo ingresado no fue encontrado."
      },
      derived_claim_status_locked: {
        title: "Reclamo derivado",
        description: "El estado no puede cambiarse mientras el reclamo est\xE9 derivado. Devolv\xE9 o cancel\xE1 la derivaci\xF3n primero."
      },
      claim_has_active_offer: {
        title: "Ofrecimiento activo",
        description: "Cerr\xE1 o retir\xE1 el ofrecimiento activo antes de derivar el reclamo."
      },
      claim_derived_offer_locked: {
        title: "Reclamo derivado",
        description: "No se puede enviar un ofrecimiento mientras el reclamo est\xE9 derivado. Devolv\xE9 o cancel\xE1 la derivaci\xF3n primero."
      },
      derivation_already_closed: {
        title: "Derivaci\xF3n ya cerrada",
        description: "Esta derivaci\xF3n ya fue devuelta o cancelada por otra persona."
      },
      derivation_target_not_operational: {
        title: "Usuario inactivo",
        description: "No pod\xE9s derivar a un usuario inactivo: no podr\xEDa devolver el reclamo."
      },
      derivation_target_paused: {
        title: "Usuario no disponible",
        description: "No pod\xE9s derivar a un usuario que no est\xE1 recibiendo reclamos nuevos."
      },
      responsible_target_not_operational: {
        title: "Usuario inactivo",
        description: "No pod\xE9s asignarle el reclamo a un usuario inactivo."
      },
      responsible_target_paused: {
        title: "Usuario no disponible",
        description: "No pod\xE9s asignarle el reclamo a un usuario que no est\xE1 recibiendo reclamos nuevos."
      },
      derivation_target_is_deriver: {
        title: "Derivaci\xF3n inv\xE1lida",
        description: "No pod\xE9s derivarte el reclamo a vos mismo."
      },
      derivation_target_is_titular: {
        title: "Derivaci\xF3n inv\xE1lida",
        description: "No pod\xE9s derivar el reclamo a su responsable original. Para devolv\xE9rselo, cancel\xE1 la derivaci\xF3n."
      },
      team_does_not_accept_assignments: {
        title: "Grupo no disponible",
        description: "El grupo seleccionado no acepta reclamos de otros grupos internos."
      },
      not_found_claim_derivation: {
        title: "Derivaci\xF3n no encontrada",
        description: "La derivaci\xF3n ingresada no fue encontrada en este reclamo."
      },
      not_found_claim_responsible: {
        title: "Reclamo sin responsable",
        description: "El reclamo no tiene un responsable activo."
      },
      wrong_identity_email: {
        title: "Email incorrecto",
        description: "El email ingresado no se pudo autenticar. Por favor, ingrese otro email."
      },
      identity_already_exists: {
        title: "Identity provider existente",
        description: "El IDP ya existe en nuestra base de datos. Por favor, ingrese otra identidad."
      },
      style_already_exists: {
        title: "Estilo existente",
        description: "El estilo ya existe en nuestra base de datos. Por favor, ingrese otro estilo."
      },
      style_not_found: {
        title: "Estilo no encontrado",
        description: "El estilo ingresado no fue encontrado."
      },
      not_found_entrypoint: {
        title: "Entrypoint no encontrado",
        description: "El entrypoint ingresado no fue encontrado."
      },
      not_found_ramo: {
        title: "Ramo no encontrado",
        description: "El ramo ingresado no fue encontrado."
      },
      axios_bad_request: {
        title: "Error de solicitud",
        description: "Error de solicitud"
      },
      cookie_not_found: {
        title: "Cookie no encontrada",
        description: "La cookie ingresada no fue encontrada."
      },
      not_found_fraud: {
        title: "Fraude no encontrado",
        description: "El fraude ingresado no fue encontrado."
      },
      not_found_default_status: {
        title: "Estado por defecto no encontrado",
        description: "El estado por defecto ingresado no fue encontrado."
      },
      not_found_company_status: {
        title: "Estado no encontrado",
        description: "El estado de empresa ingresado no fue encontrado."
      },
      claim_is_already_closed: {
        title: "Reclamo cerrado",
        description: "El reclamo ingresado ya se encuentra cerrado."
      },
      claim_status_not_manually_selectable: {
        title: "Estado no seleccionable",
        description: "Este estado se asigna autom\xE1ticamente a partir del ofrecimiento o de su conformidad y no puede seleccionarse manualmente."
      },
      claim_status_role_already_assigned: {
        title: "Rol ya asignado",
        description: "Otro estado de la empresa ya tiene este rol de orden de trabajo. Quit\xE1selo antes de asignarlo a este estado."
      },
      not_found_adobe_sign_connection: {
        title: "Conexi\xF3n de Adobe Sign no encontrada",
        description: "La conexi\xF3n de Adobe Sign ingresada no fue encontrada."
      },
      not_found_job: {
        title: "Tarea no encontrado",
        description: "La tarear ingresado no fue encontrado."
      },
      company_link_not_found: {
        title: "Link de empresa no encontrado",
        description: "El link de empresa ingresado no fue encontrado."
      },
      not_found_coordinator: {
        title: "Coordinador no encontrado",
        description: "El coordinador ingresado no fue encontrado."
      },
      invalid_style_scope: {
        title: "Scope inv\xE1lido",
        description: "El scope ingresado no es v\xE1lido."
      },
      invalid_file_token: {
        title: "Token de archivo inv\xE1lido",
        description: "El token de archivo ingresado no es v\xE1lido"
      },
      not_found_permissions: {
        title: "Permisos no encontrados",
        description: "Los permisos ingresados no fueron encontrados"
      },
      user_is_responsible: {
        title: "Usuario es responsable",
        description: "El usuario seleccionado es responsable de uno o mas siniestros. Por favor, reasigne los siniestros antes de eliminar el usuario"
      },
      unauthorized: {
        title: "No autorizado",
        description: "El token enviado no es valido"
      },
      empty_team: {
        title: "Grupo sin miembros disponibles",
        description: "El grupo de destino seleccionado no cuenta con usuarios que puedan ser asignados al reclamo"
      },
      case_request_repeated: {
        title: "Derivaci\xF3n ya realizada",
        description: "Ya hay una derivaci\xF3n a fraudes con el n\xFAmero de siniestro ingresado"
      },
      not_found_sinisterId: {
        title: "Siniestro no encontrado",
        description: "El siniestro ingresado no fue encontrado en la integraci\xF3n"
      },
      integration_invalid_credentials: {
        title: "Credenciales inv\xE1lidas",
        description: "Las credenciales configuradas en la integraci\xF3n no son validas"
      },
      not_found_sinister: {
        title: "Siniestro no encontrado",
        description: "El siniestro ingresado no fue encontrado en la integraci\xF3n"
      },
      not_found_policy: {
        title: "P\xF3liza no encontrada",
        description: "La p\xF3liza ingresada no fue encontrada en la integraci\xF3n"
      },
      not_found_matricula: {
        title: "Matricula no encontrada",
        description: "La matricula ingresada no fue encontrada en la integraci\xF3n"
      },
      email_mismatch: {
        title: "Cuenta incorrecta",
        description: "El correo electr\xF3nico de la cuenta seleccionada no coincide con el correo electr\xF3nico de la cuenta actual. Por favor, seleccione una cuenta diferente."
      },
      domain_not_allowed: {
        title: "Dominio no permitido",
        description: "El dominio de la direcci\xF3n de correo electr\xF3nico no pertenece a la empresa"
      },
      endpoint_already_exists: {
        title: "Endpoint ya existente",
        description: "El endpoint ya existe en nuestra base de datos. Por favor, ingrese otro endpoint."
      },
      user_already_assigned: {
        title: "Usuario ya asignado",
        description: "El usuario ya se encuentra asignado al reclamo"
      },
      user_not_verified: {
        title: "Cuenta no verificada",
        description: "Por favor, verifique su cuenta para poder continuar."
      },
      cannot_process_request: {
        title: "No se pudo procesar la solicitud",
        description: "Por favor, intente nuevamente m\xE1s tarde."
      },
      wrong_target_user: {
        title: "Usuario invalido",
        description: "Este usuario no puede acceder a esta plataforma"
      },
      inhouse_lawyer_wrong_tenant: {
        title: "Email registrado en otra empresa",
        description: "Este email est\xE1 registrado en otra empresa. Inici\xE1 sesi\xF3n en la url de la empresa que te invit\xF3."
      },
      tenant_session_mismatch: {
        title: "Sesi\xF3n de otra empresa",
        description: "Tu sesi\xF3n pertenece a otra empresa. Inici\xE1 sesi\xF3n en la url de esta empresa."
      },
      invalid_credentials: {
        title: "Credenciales incorrectas",
        description: "El email o la contrase\xF1a son incorrectos."
      },
      email_already_exists: {
        title: "Email existente",
        description: "El correo ingresado ya se encuentra en uso. Por favor, reg\xEDstrate con otro email o ingresa a la plataforma en caso de ya estar registrado."
      },
      company_name_already_exists: {
        title: "Nombre de empresa en uso",
        description: "El nombre de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
      },
      company_ein_already_exists: {
        title: "CUIT/CUIL de empresa en uso",
        description: "El CUIT/CUIL de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
      },
      company_domain_already_exists: {
        title: "Dominio de empresa en uso",
        description: "El dominio de la empresa ya se encuentra en uso. Por favor, utilice uno diferente"
      },
      user_dni_already_exists: {
        title: "Dni invalido",
        description: "Ya existe un usuario con el DNI ingresado. Por favor, utilice uno diferente"
      },
      user_email_already_exists: {
        title: "Email invalido",
        description: "Ya existe un usuario con el email ingresado. Por favor, utilice uno diferente"
      },
      user_ein_already_exists: {
        title: "CUIT/CUIL invalido",
        description: "Ya existe un usuario con el CUIT/CUIL ingresado. Por favor, utilice uno diferente"
      },
      unique_company_currency: {
        title: "No se puede eliminar",
        description: "La moneda es la \xFAnica disponible"
      },
      duplicate_file_request_placeholders: {
        title: "Documentos repetidos",
        description: "Los siguientes documentos ya fueron solicitados anteriormente: {{duplicate_tags}}"
      },
      tag_already_exists: {
        title: "Etiqueta ya existente",
        description: "Ya existe una etiqueta con este nombre"
      },
      use_case_already_exists: {
        title: "Caso de uso ya existente",
        description: "Ya existe un caso de uso con este nombre"
      },
      not_found_ravel_ai_use_case: {
        title: "Caso de uso no encontrado",
        description: "No se encontr\xF3 un caso de uso con este ID"
      },
      invalid_offer_status: {
        title: "Ofrecimiento no disponible",
        description: "El ofrecimiento ya no est\xE1 disponible"
      },
      user_not_found: {
        title: "Usuario no encontrado",
        description: "No se encontr\xF3 un usuario con este email"
      },
      total_amount_out_of_range: {
        title: "Monto fuera de rango",
        description: "El monto total de la oferta excede el valor m\xE1ximo permitido ($99.999.999,99)"
      },
      bid_already_submitted: {
        title: "Oferta ya enviada",
        description: "Ya enviaste una oferta para esta licitaci\xF3n"
      },
      internal_server_error: {
        title: "Error interno",
        description: "Ocurri\xF3 un error inesperado. Por favor, intente nuevamente m\xE1s tarde."
      },
      contact_already_exists: {
        title: "Contacto ya existente",
        description: "Ya existe un contacto con este correo electr\xF3nico"
      },
      team_has_no_assignable_user_for_delegation: {
        title: "Sin usuarios para derivar",
        description: "Ninguno de los equipos correspondientes a tus reclamos a derivar tiene usuarios elegibles"
      },
      product_import_already_running: {
        title: "Ya hay una importaci\xF3n en curso",
        description: "Esper\xE1 a que termine la importaci\xF3n actual antes de iniciar otra."
      },
      product_import_not_found: {
        title: "Importaci\xF3n no encontrada",
        description: "La importaci\xF3n que busc\xE1s no existe o pertenece a otra empresa."
      },
      product_import_invalid_file: {
        title: "No pudimos leer el archivo",
        description: "Revis\xE1 que sea un CSV v\xE1lido y volv\xE9 a intentarlo."
      },
      product_import_file_too_large: {
        title: "El archivo es demasiado grande",
        description: "Dividilo en partes m\xE1s chicas y volv\xE9 a subirlo."
      },
      product_import_has_invalid_rows: {
        title: "El archivo tiene filas con errores",
        description: "Correg\xED el archivo o confirm\xE1 que quer\xE9s importar s\xF3lo las filas v\xE1lidas."
      },
      order_proof_mechanism_mismatch: {
        title: "Acci\xF3n no disponible para esta orden",
        description: "La orden demuestra el trabajo realizado con el otro mecanismo: esta acci\xF3n no le corresponde."
      },
      field_adjuster_contact_not_found: {
        title: "Invitaci\xF3n no encontrada",
        description: "No encontramos una invitaci\xF3n de liquidador para este email. Pedile a la aseguradora que te invite."
      },
      contact_already_registered: {
        title: "El contacto ya se registr\xF3",
        description: "Este contacto ya tiene una cuenta activa, no hace falta reenviar la invitaci\xF3n."
      },
      invalid_current_password: {
        title: "Contrase\xF1a incorrecta",
        description: "La contrase\xF1a actual que ingresaste no es correcta."
      },
      password_not_set: {
        title: "Tu cuenta no tiene contrase\xF1a",
        description: 'Ingresaste con un proveedor externo. Us\xE1 "Olvid\xE9 mi contrase\xF1a" para crear una.'
      },
      agreement_rule_not_found: {
        title: "No se encontr\xF3 la regla",
        description: "La regla no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_rule_priority_taken: {
        title: "Prioridad repetida",
        description: "Ya hay otra regla habilitada con esa prioridad. El orden entre reglas tiene que ser expl\xEDcito."
      },
      agreement_rule_conflicts: {
        title: "Reglas en conflicto",
        description: "Otra regla habilitada tiene exactamente estas condiciones y elige otra conformidad."
      },
      agreement_rule_incomplete: {
        title: "La regla est\xE1 incompleta",
        description: "Para habilitarla, su plantilla tiene que tener una versi\xF3n publicada."
      },
      agreement_template_in_use_by_rule: {
        title: "La plantilla est\xE1 en uso",
        description: "Hay una regla habilitada que la usa. Deshabilit\xE1 la regla antes de deprecar o eliminar la plantilla."
      },
      agreement_plan_not_found: {
        title: "Sin plan de conformidad",
        description: "Todav\xEDa no se calcul\xF3 qu\xE9 conformidad corresponde a este ofrecimiento."
      },
      agreement_signature_rule_not_found: {
        title: "No se encontr\xF3 la regla de firma",
        description: "La regla de firma no existe o no pertenece a esta compa\xF1\xEDa."
      },
      agreement_rule_unknown_option: {
        title: "Valor desconocido en una condici\xF3n",
        description: "Una condici\xF3n apunta a un tipo de reclamo o plantilla que la compa\xF1\xEDa no tiene."
      },
      agreement_rule_unknown_template: {
        title: "Plantilla desconocida",
        description: "La regla apunta a una plantilla que la compa\xF1\xEDa no tiene."
      },
      agreement_signature_rule_unknown_template: {
        title: "Plantilla desconocida en el alcance",
        description: "El alcance nombra una plantilla que la compa\xF1\xEDa no tiene."
      },
      agreement_template_kind_mismatch: {
        title: "Tipo de plantilla incorrecto",
        description: "La regla apunta a una conformidad donde va un mensaje de ofrecimiento, o al rev\xE9s."
      },
      agreement_template_invalid_block_kind: {
        title: "Bloques no admitidos",
        description: "Un mensaje de ofrecimiento solo admite t\xEDtulos y p\xE1rrafos: {{kinds}}"
      },
      agreement_template_stage_not_allowed: {
        title: "Variables de la aceptaci\xF3n en el mensaje",
        description: "El mensaje de ofrecimiento se env\xEDa antes de que el reclamante acepte: no puede usar {{keys}}"
      },
      agreement_rule_kit_incomplete: {
        title: "Kit incompleto",
        description: "El mensaje de ofrecimiento y la plantilla de aceptaci\xF3n van juntos: indic\xE1 ambos o ninguno."
      },
      offer_amount_exceeds_cap: {
        title: "Monto por encima del tope",
        description: "El monto del ofrecimiento supera el tope de la estimaci\xF3n. Para ofrecer m\xE1s, actualiz\xE1 la estimaci\xF3n."
      },
      offer_cap_not_computable: {
        title: "Tope no calculable",
        description: "Carg\xE1 la responsabilidad y la estimaci\xF3n judicial del reclamo para poder ofrecer."
      },
      offer_terms_invalid: {
        title: "Condiciones de pago no permitidas",
        description: "Las cuotas, los d\xEDas, el porcentaje de honorarios o qui\xE9n cobra no corresponden a las opciones de la compa\xF1\xEDa o al reclamo."
      },
      acceptance_payee_invalid: {
        title: "Datos de cobro no v\xE1lidos",
        description: "Los datos de cobro no corresponden a una persona habilitada para cobrar este reclamo."
      },
      agreement_plan_changed: {
        title: "La configuraci\xF3n cambi\xF3",
        description: "Lo previsualizado ya no coincide con lo que se enviar\xEDa. Revis\xE1 la vista previa y volv\xE9 a enviar."
      },
      offer_message_incomplete: {
        title: "Faltan datos en el mensaje",
        description: "El mensaje de ofrecimiento tiene datos del reclamo sin cargar: {{keys}}"
      },
      acceptance_template_incompatible: {
        title: "Plantilla de aceptaci\xF3n incompatible",
        description: "La plantilla de aceptaci\xF3n exige variables que el ofrecimiento guiado no completa. Revis\xE1 el kit de la regla."
      },
      batch_claim_job_already_running: {
        title: "Ya hay un proceso en curso",
        description: "Los reclamos de esta persona ya se est\xE1n delegando o recuperando. Esper\xE1 a que termine para volver a intentarlo."
      },
      job_already_scheduled: {
        title: "Ya tiene una inactividad programada",
        description: "Cancel\xE1 o finaliz\xE1 la inactividad vigente antes de programar otra."
      },
      inactivity_not_found: {
        title: "No tiene inactividad",
        description: "Este miembro ya no tiene una inactividad programada ni en curso. Actualiz\xE1 la p\xE1gina."
      },
      inactivity_changed: {
        title: "La inactividad cambi\xF3",
        description: "La inactividad cambi\xF3 mientras tanto, por ejemplo porque ya empez\xF3. Revis\xE1 sus datos e intent\xE1 de nuevo."
      },
      inactivity_period_invalid: {
        title: "Fechas inv\xE1lidas",
        description: "La fecha Hasta tiene que ser igual o posterior a Desde."
      },
      not_found_delegated: {
        title: "Los reclamos ya no est\xE1n delegados",
        description: "Alguno de los reclamos que seleccionaste dej\xF3 de estar delegado. Actualiz\xE1 la lista y volv\xE9 a intentarlo."
      },
      offer_agreement_not_applicable: {
        title: "El ofrecimiento no lleva conformidad",
        description: "Se envi\xF3 sin una conformidad elegida, as\xED que no hay documento que generar."
      },
      offer_agreement_not_retryable: {
        title: "No hay nada que reintentar",
        description: "La generaci\xF3n de la conformidad no fall\xF3 ni qued\xF3 trabada."
      },
      manual_agreement_not_applicable: {
        title: "El ofrecimiento no admite una conformidad cargada a mano",
        description: "Solo el \xFAltimo ofrecimiento, aceptado y enviado sin conformidad, puede tener una conformidad cargada a mano."
      },
      manual_agreement_file_not_pdf: {
        title: "El archivo no es un PDF",
        description: "La conformidad tiene que cargarse en formato PDF."
      },
      manual_agreement_changed: {
        title: "La conformidad cambi\xF3",
        description: "Otra persona carg\xF3 una conformidad para este ofrecimiento mientras tanto. Revis\xE1 la versi\xF3n actual y volv\xE9 a intentarlo."
      },
      agreement_automation_disabled: {
        title: "Conformidad autom\xE1tica apagada",
        description: "La compa\xF1\xEDa tiene la conformidad autom\xE1tica apagada: no se genera ning\xFAn documento."
      },
      agreement_signature_dispatch_blocked: {
        title: "No se puede enviar a firmar",
        description: "Para enviar este ofrecimiento necesit\xE1s tu cuenta de AutoSign conectada desde Integraciones y un correo electr\xF3nico distinto para cada firmante."
      },
      agreement_signature_disabled: {
        title: "La firma digital est\xE1 apagada",
        description: "La compa\xF1\xEDa no est\xE1 enviando conformidades a firmar por AutoSign."
      },
      offer_agreement_dispatch_not_retryable: {
        title: "No hay env\xEDo para reintentar",
        description: "El env\xEDo a firmar est\xE1 en curso, ya sali\xF3 o esta conformidad no se env\xEDa por AutoSign."
      },
      offer_agreement_dispatch_account_pinned: {
        title: "Se reintenta desde otra cuenta",
        description: "La solicitud pudo haber salido desde la cuenta de AutoSign {{account_email}}: solo esa cuenta puede reintentar el env\xEDo."
      },
      offer_agreement_sync_unavailable: {
        title: "No hay nada que sincronizar",
        description: "Esta conformidad no tiene una solicitud de firma en AutoSign para consultar."
      },
      offer_agreement_sync_connection_required: {
        title: "Hace falta reconectar la cuenta",
        description: "Solo la cuenta de AutoSign {{account_email}} puede consultar esta solicitud, y su conexi\xF3n no est\xE1 disponible. Reconectala desde Integraciones."
      },
      offer_agreement_sync_provider_error: {
        title: "AutoSign no respondi\xF3",
        description: "No se pudo consultar el estado de la solicitud. Volv\xE9 a intentar en unos minutos."
      },
      not_found_integration_connection: {
        title: "No hay una cuenta conectada",
        description: "No encontramos una conexi\xF3n con esa integraci\xF3n."
      },
      not_found_integration: {
        title: "Integraci\xF3n no disponible",
        description: "La integraci\xF3n no est\xE1 configurada en Piramid."
      },
      order_export_too_many_rows: {
        title: "Demasiadas \xF3rdenes para exportar",
        description: "Los filtros aplicados abarcan {{total}} \xF3rdenes y el m\xE1ximo por exportaci\xF3n es {{max}}. Acot\xE1 los filtros e intent\xE1 de nuevo."
      },
      embedded_signing_session_invalid: {
        title: "No pudimos continuar con la firma",
        description: "Vas a recibir un email de AutoSign para firmar la conformidad."
      },
      team_member_inactive: {
        title: "Usuario en inactividad",
        description: "Mientras est\xE1 inactivo no recibe reclamos. Su disponibilidad se puede cambiar cuando vuelva."
      },
      team_member_not_managed: {
        title: "Usuario fuera de tus equipos",
        description: "Solo pod\xE9s gestionar a los miembros de los equipos que coordin\xE1s."
      },
      team_claims_not_found: {
        title: "Reclamos no encontrados",
        description: "Alguno de los reclamos seleccionados ya no existe."
      },
      team_claims_mixed_teams: {
        title: "Reclamos de distintos equipos",
        description: "Seleccion\xE1 reclamos de un mismo equipo."
      },
      team_claims_not_reassignable: {
        title: "Reclamos fuera de tus equipos",
        description: "Solo pod\xE9s reasignar reclamos de los equipos que coordin\xE1s."
      },
      team_reassignment_target_not_eligible: {
        title: "Destino no disponible",
        description: "El destino tiene que ser un miembro activo y disponible del equipo. Actualiz\xE1 la lista y eleg\xED otro."
      },
      team_claims_reassignment_conflict: {
        title: "No se reasign\xF3 ning\xFAn reclamo",
        description: "Alguno de los reclamos cambi\xF3 mientras tanto: se cerr\xF3, pas\xF3 a otro equipo o ya no lo tiene este miembro. Actualiz\xE1 la lista e intent\xE1 de nuevo."
      },
      team_reassignment_target_is_deriver: {
        title: "No se puede reasignar a quien lo deriv\xF3",
        description: "Alguno de los reclamos fue derivado por este miembro. Para devolv\xE9rselo, retorn\xE1 la derivaci\xF3n desde el reclamo."
      },
      team_delegation_claims_changed: {
        title: "Llegaron reclamos nuevos",
        description: "El tramitador recibi\xF3 reclamos mientras defin\xEDas los destinos. Eleg\xED qu\xE9 pasa con los que faltan e intent\xE1 de nuevo."
      },
      team_delegation_target_not_eligible: {
        title: "Alg\xFAn destino ya no puede recibir el reclamo",
        description: "Dej\xF3 de estar activo y disponible en el equipo del reclamo, o quien lo deleg\xF3 ya no puede recuperarlo. Revis\xE1 los destinos e intent\xE1 de nuevo."
      },
      team_delegation_not_found: {
        title: "No hay delegaci\xF3n programada",
        description: "La inactividad de esta persona ya no tiene reclamos para delegar: se dej\xF3 sin delegar o se cancel\xF3. Actualiz\xE1 la p\xE1gina."
      },
      team_delegation_member_active: {
        title: "Todav\xEDa est\xE1 activo",
        description: "Sus reclamos se delegan cuando empiece la inactividad. Pod\xE9s revisar la distribuci\xF3n desde su ficha."
      },
      team_delegated_claims_changed: {
        title: "No se movi\xF3 ning\xFAn reclamo",
        description: "Alguno de los reclamos cambi\xF3 mientras tanto: se cerr\xF3, se deriv\xF3, ya se retorn\xF3 o recuper\xF3, o lo tiene otra persona. Actualiz\xE1 la lista e intent\xE1 de nuevo."
      },
      derivation_responsible_changed: {
        title: "El reclamo cambi\xF3 de responsable",
        description: "Mientras lo retornabas, alguien se lo reasign\xF3 a otra persona. Actualiz\xE1 la p\xE1gina e intent\xE1 de nuevo."
      },
      team_derived_claims_changed: {
        title: "No se retorn\xF3 ning\xFAn reclamo",
        description: "Alguno de los reclamos ya no est\xE1 derivado a esta persona: se retorn\xF3, se recuper\xF3 o pas\xF3 a otra. Actualiz\xE1 la lista e intent\xE1 de nuevo."
      },
      team_delegation_recovery_member_unavailable: {
        title: "Todav\xEDa no puede recuperar",
        description: "Los reclamos delegados se recuperan cuando la persona est\xE1 activa y disponible."
      },
      inactivity_managed_by_team_management: {
        title: "La inactividad se gestiona desde Gesti\xF3n de equipo",
        description: "Las inactividades y sus delegaciones se programan, cambian y cancelan desde Gesti\xF3n de equipo."
      },
      release_note_not_published: {
        title: "La nota no est\xE1 publicada",
        description: "S\xF3lo una nota publicada se env\xEDa a una compa\xF1\xEDa, se avisa por mail o se oculta."
      },
      release_note_role_invalid: {
        title: "Rol inv\xE1lido",
        description: "Alguno de los roles elegidos no es de esta compa\xF1\xEDa."
      },
      release_note_unavailable_for_company: {
        title: "La compa\xF1\xEDa no puede ver la nota",
        description: "Le falta la flag que pide la nota: sus usuarios no podr\xEDan abrirla."
      },
      release_note_hidden: {
        title: "La nota est\xE1 oculta",
        description: "Hacela visible antes de enviarla o de avisar por mail: sus usuarios no podr\xEDan abrirla."
      },
      release_note_already_published: {
        title: "La nota ya est\xE1 publicada",
        description: "Una nota publicada no se reemplaza, republica ni elimina: los lectores y sus eventos cuelgan de ella."
      }
    };
    var legalPersonType = {
      hospital: "Hospital",
      worker_compensation_insurer: "ART",
      health_insurance_fund: "Obra social",
      insurer: "Aseguradora"
    };
    var claim_properties_insurance_insurer = "Aseguradora";
    var claim_properties_insurance_policy_number = "N\xFAmero de p\xF3liza";
    var claim_properties_driver_ownership_owner = "Due\xF1o";
    var claim_properties_vehicle_type_car = "Auto";
    var claim_properties_vehicle_category_with_license_plate = "Veh\xEDculo con patente";
    var claim_properties_driver_owner = "Due\xF1o";
    var claim_properties_vehicle_document_type_title = "T\xEDtulo";
    var claim_properties_insurance_coverage_third_full = "Tercero Completo";
    var claim_victim_relationship_own = "Directo";
    var claim_properties_damage_driver_last_name = "Apellido";
    var claim_properties_damage_driver_first_name = "Nombre";
    var claim_properties_damage_hasInsurance = "\xBFTiene seguro?";
    var claim_properties_damage_type = "Tipo de da\xF1o";
    var claim_properties_vehicle_category = "Categor\xEDa";
    var claim_properties_vehicle_type = "Tipo de veh\xEDculo";
    var claim_properties_vehicle_year = "Patente";
    var claim_properties_vehicle_license_plate = "Patente";
    var claim_properties_vehicle_engine = "Motor";
    var claim_properties_vehicle_chassis = "Chasis";
    var claim_properties_vehicle_use = "Uso";
    var claim_properties_vehicle_model = "Modelo";
    var claim_properties_vehicle_make = "Marca";
    var claim_properties_vehicle_version = "Versi\xF3n";
    var claim_properties_vehicle_document_type = "Documentaci\xF3n";
    var claim_properties_driver_ownership = "Propiedad";
    var claim_properties_insurance_coverage = "Cobertura";
    var damages_material_vehicle = "Veh\xEDculo";
    var damages_material_real_property = "Inmueble";
    var materialDamage = {
      vehicle: "Veh\xEDculo",
      real_property: "Inmueble"
    };
    var parents = {
      mother: "Madre",
      father: "Padre"
    };
    var claim_identification_type_label = "Tipo de documento";
    var identification_type = {
      national_id_document: "DNI",
      enrollment_book: "Libreta Enrolamiento",
      civil_registry_card: "Libreta C\xEDvica",
      passport: "Pasaporte",
      cuil: "CUIL",
      cuit: "CUIT"
    };
    var local_insured_relationships = {
      friend: "Amigo/a",
      brother: "Hermano/a",
      couple: "Pareja",
      parent: "Padre/Madre",
      son: "Hijo/a",
      uncle: "T\xEDo/a",
      cousin: "Primo/a",
      niece: "Sobrino/a",
      rider: "Pasajero - uso comercial",
      other: "Otro",
      spouse: "Conyuge",
      concubine: "Concubina"
    };
    var victim_injuries_roles = {
      pedestrian: "Peat\xF3n",
      driver: "Conductor del veh\xEDculo tercero",
      rider: "Transportado en el veh\xEDculo tercero",
      policyholder_rider: "Transportado en el veh\xEDculo asegurado en {{insurerName}}"
    };
    var coverages = {
      civil_responsibility: "Responsabilidad Civil",
      third_robbery_fire: "Tercero, Robo e incendio",
      third_full: "Tercero Completo",
      all_risks_without_franchise: "Todo Riesgo sin Franquicia",
      all_risks_with_franchise: "Todo Riesgo con Franquicia",
      other: "Otro"
    };
    var driver_ownership = {
      owner: "Due\xF1o",
      third: "Tercero",
      own: "Due\xF1o"
    };
    var real_property = {
      ownership: {
        own: "Propietario",
        rented: "Inquilino",
        other: "Otro"
      },
      type: {
        housing: "Vivienda",
        commercial: "Local Comercial",
        building: "Edificio",
        government: "Organismo Publico",
        warehouse: "Galp\xF3n",
        other: "Otro"
      }
    };
    var vehicle = {
      identification_key: {
        license_plate: "N\xFAmero de chapa",
        chassis: "N\xFAmero de chasis"
      },
      bike: "Bicicleta",
      machinery: "Maquinaria",
      skateboard: "Monopat\xEDn",
      other: "Otro",
      car: "Auto",
      moto: "Motocicleta-Motoneta-Cuatriciclo",
      documents: {
        title: "T\xEDtulo",
        registration: "C\xE9dula Verde",
        other: "Otro"
      },
      category: {
        with_license_plate: "S\xED - el veh\xEDculo posee patente",
        without_license_plate: "No - el veh\xEDculo no est\xE1 patentado"
      },
      use: {
        special_school_pickup: "Servicios Especiales y Escolares (Pick Up)",
        private: "Particular",
        public: "P\xFAblico",
        taxi: "Taxi",
        remis: "Remis",
        rental: "Alquiler de Autos",
        ambulance: "Ambulancia",
        police: "Patrullero",
        school: "Escuela",
        specialService: "Sev. Especial Plataforma Electron",
        special_service: "Serv. Especiales (Excepto Pick Up)",
        goods: "Transporte de mercader\xEDas",
        persons: "Transporte de personas",
        goods_transport: "Transporte de Bienes",
        local: "Locales",
        route_service: "Ruteros",
        school_transport: "Escolares",
        electronic_platform: "Servicio Especial Plataforma Electr\xF3nica",
        delivery_service: "Servicio de Reparto y Mensajer\xEDa",
        agency: "Agencias (Con/Sin Chofer c/ chapa Particular)"
      },
      special_transport_service: "Servicio Transporte Especial",
      public_transport_service: "Servicio Transporte P\xFAblico",
      trailer_motor_home: "Trailer - Casa Rodante",
      pickup_class_a_and_b_jeep: "Pick Up Clase 'A' y 'B' - Jeep",
      truck_chassis: "Cami\xF3n - Chasis",
      hitched_semi_trailer: "Acoplado - Semiremolque",
      tractors_and_rural_machines: "Tractores y M\xE1quinas Rurales"
    };
    var type = {};
    var claim_state_label = "Provincia";
    var claim_city_label = "Ciudad";
    var claim_country_label = "Pa\xEDs";
    var claim_identification_label = "Identificaci\xF3n";
    var claim_first_name_label = "Nombre";
    var claim_last_name_label = "Apellido";
    var claim_cuit_label = "CUIT";
    var claim_address_label = "Direcci\xF3n";
    var claim_type_label = "Tipo";
    var claim_social_reason_label = "Raz\xF3n Social";
    var claim_zip_code_label = "C\xF3digo Postal";
    var claim_victim_relationship_label = "Relaci\xF3n con el asegurado";
    var fractures = {
      upper: "Miembro superior",
      lower: "Miembro inferior",
      right: "Miembro derecho",
      left: "Miembro izquierdo"
    };
    var severities = {
      major: "Mayor",
      minor: "Menor",
      moderate: "Moderado"
    };
    var injuries = {
      abrasions: {
        label: "Escoriaciones",
        description: "Lesi\xF3n en la piel consistente en una p\xE9rdida superficial de sustancia que s\xF3lo afecta a la epidermis. Ej: rozaduras, raspones, etc."
      },
      whiplash: {
        label: "Traumatismos varios / Latigazo",
        description: "Lesi\xF3n o da\xF1o f\xEDsico que ha sido causado por una fuerza externa."
      },
      severe_had_injury: {
        label: "Traumatismo de cr\xE1neo grave",
        description: "Lesi\xF3n cerebral de origen traum\xE1tico causada por un impacto o movimiento brusco de la cabeza, que puede alterar temporal o permanentemente la funci\xF3n cerebral."
      },
      fractures: {
        label: "Fracturas"
      }
    };
    var claimant_victim_violation = {
      for_declared_relationship: "Para el v\xEDnculo declarado:",
      claimant_identification_must_match_victim: "El documento del reclamante deber\xEDa ser el mismo que el del damnificado.",
      claimant_email_must_match_victim: "El email del reclamante deber\xEDa ser el mismo que el del damnificado.",
      claimant_identification_must_differ_from_victim: "El documento del reclamante deber\xEDa ser diferente al del damnificado.",
      claimant_email_must_differ_from_victim: "El email del reclamante deber\xEDa ser diferente al del damnificado.",
      victim_email_must_differ_from_owner: "El email del damnificado deber\xEDa ser diferente al de la persona registrada due\xF1a del reclamo.",
      claimant_identification_must_be_cuit: "Un abogado deber\xEDa cargar su CUIT como documento de identidad.",
      consistent: "El v\xEDnculo declarado es consistente con los datos del reclamante y del damnificado."
    };
    var claim_ownership_transfer = {
      assign_title: "Transferir el reclamo",
      new_claimant: "Nuevo reclamante",
      assign_description: "Le vamos a enviar una invitaci\xF3n para que acepte el reclamo. El due\xF1o cambia reci\xE9n cuando la acepta, y ah\xED declara su v\xEDnculo con el damnificado.",
      assign_confirm: "Enviar invitaci\xF3n",
      assign_success: "Invitaci\xF3n enviada",
      assign_success_description: "Le enviamos la invitaci\xF3n a {{ name }}. El reclamo cambia de due\xF1o cuando la acepte.",
      accept_description: "Indic\xE1 tu v\xEDnculo con el damnificado para aceptar la transferencia.",
      victim_relationship_placeholder: "Seleccion\xE1 el v\xEDnculo",
      victim_relationship_other_placeholder: "Describ\xED el v\xEDnculo",
      identification_label: "CUIT",
      identification_placeholder: "Ingres\xE1 tu CUIT",
      identification_hint: "Como actu\xE1s en representaci\xF3n del damnificado, el reclamo se registra con tu CUIT.",
      confirm: "Confirmar transferencia"
    };
    var victim_relationship = {
      label: "Relaci\xF3n con el asegurado",
      mother: "Madre",
      father: "Padre",
      other_family_member: "Otro familiar",
      tutor_curator: "Tutor/Curador",
      attorney_in_fact: "Abogado apoderado",
      legal_representative: "Apoderado legal",
      attorney_representative: "Abogado patrocinante",
      other: "Otro",
      brother: "Hermano",
      producer: "Productor",
      workshopper: "Tallerista",
      own: "Reclamo en nombre propio",
      particular_victim: "Damnificado particular",
      friend: "Amigo/a",
      son: "Hijo/a",
      spouse: "C\xF3nyuge",
      concubine: "Concubino/a",
      grandparent: "Abuelo/a"
    };
    var sex = {
      male: "Masculino",
      female: "Femenino",
      other: "Otro"
    };
    var damages = {
      with_license_plate: "Con patente",
      without_license_plate: "Sin patente",
      real_property: "Inmueble",
      vehicle: "Veh\xEDculo",
      person: "Da\xF1os a personas",
      death: "Fallecido",
      injury: "Lesiones",
      recovery: "Recuperos",
      material: "Da\xF1os materiales",
      injuries: "Lesiones",
      deceased: "Fallecido",
      hospital: "Hospitales",
      healthInsuranceFund: "Obra social",
      workerCompensationInsurer: "ART",
      insurer: "Aseguradoras"
    };
    var company_service = {
      backends: {
        rivadavia: "Rivadavia Seguros"
      },
      claim: "Reclamo",
      complaint: "Denuncia"
    };
    var permissions = {
      can_create_claim: "Crear Reclamo",
      can_read_claim: "Visualizar Reclamo",
      can_update_claim: "Actualizar Reclamo",
      can_delete_claim: "Eliminar Reclamo",
      can_update_sinister: "Actualizar Siniestro",
      can_read_sinister: "Visualizar Siniestro",
      can_create_sinister: "Crear Siniestro",
      can_delete_sinister: "Eliminar Siniestro",
      can_read_team: "Visualizar Grupo Destino",
      can_create_team: "Crear Grupo Destino",
      can_delete_team: "Eliminar Grupo Destino",
      can_update_team: "Actualizar Grupo Destino",
      can_create_load_balance_rule: "Crear Regla de Distribuci\xF3n",
      can_update_load_balance_rule: "Actualizar Regla de Distribuci\xF3n",
      can_read_load_balance_rule: "Visualizar Regla de Distribuci\xF3n",
      can_delete_load_balance_rule: "Eliminar Regla de Distribuci\xF3n",
      can_read_role: "Visualizar Rol",
      can_create_role: "Crear Rol",
      can_update_role: "Actualizar Rol",
      can_delete_role: "Eliminar Rol",
      can_read_user: "Visualizar Usuario",
      can_create_user: "Crear Usuario",
      can_update_user: "Actualizar Usuario",
      can_delete_user: "Eliminar Usuario",
      can_read_complaint: "Visualizar Denuncia",
      can_create_complaint: "Crear Denuncia",
      can_update_complaint: "Actualizar Denuncia",
      can_delete_complaint: "Eliminar Denuncia",
      can_read_invitation: "Visualizar Invitaci\xF3n",
      can_create_invitation: "Crear Invitaci\xF3n",
      can_update_invitation: "Actualizar Invitaci\xF3n",
      can_delete_invitation: "Eliminar Invitaci\xF3n",
      can_read_settings: "Visualizar Configuraci\xF3n",
      can_update_settings: "Actualizar Configuraci\xF3n",
      can_read_account: "Visualizar Cuenta",
      can_update_account: "Actualizar Cuenta",
      can_read_notification: "Visualizar Notificaciones",
      can_read_claim_estimates: "Visualizar Estimaciones",
      can_read_claim_offers: "Visualizar Ofrecimientos",
      can_read_claim_agreements: "Visualizar Conformidades"
    };
    var company_enums_claim_status = " \u2937 Estados del reclamo";
    var company_enums_claim_stage = " \u2937 Etapas del reclamo";
    var company_enums_claim_reference = " \u2937 Referencias del reclamo";
    var company_enums_claim_status_order_rule = " \u2937 Reglas de orden \u2014 reclamo (etapas)";
    var company_enums_claim_type = "Tipos de reclamo";
    var company_enums_complaint_status = "Estados de la denuncia";
    var company_enums_complaint_stage = "Etapas de la denuncia";
    var company_enums_complaint_reference = "Referencias de la denuncia";
    var company_enums_complaint_status_order_rule = "Reglas de orden - denuncia";
    var company_enums_ramos = "Ramo";
    var company_enums_agencies = "Agencia";
    var company_enums_complaint_public_status = "Estado publico de la denuncia";
    var company_enums_claim_public_status = "Estado publico de reclamo";
    var _claims = "Reclamos";
    var _complaints = "Denuncias";
    var _companies = "Compa\xF1ias";
    var _autoinspector_inspections = "Autoinspector";
    var _fraud_investigations = "Investigaciones de fraude";
    var _catalog = "Cat\xE1logo";
    var _document_types = "Tipos de documentos";
    var _providers = "Proveedores";
    var _customer_organizations = "Organizaciones";
    var _provider_invitations = "Invitaciones";
    var _geo = "Geo";
    var _metrics = "Generales";
    var _metrics_performance = "Performance";
    var _metrics_experimental = "Experimental";
    var _reviews = "Rese\xF1as";
    var _users = "Usuarios";
    var _integrations = "Integraciones";
    var _recordings = "Grabaciones";
    var _release_notes = "Novedades";
    var recordings = {
      show_no_progress: "Mostrar los que no pasaron del primer paso"
    };
    var sidebar = {
      insurer: "Aseguradoras",
      customers: "Customer",
      providers: "Proveedores",
      metrics: "M\xE9tricas",
      metrics_general: "Generales",
      logout: "Cerrar sesi\xF3n",
      logout_confirm_title: "\xBFCerrar sesi\xF3n?",
      logout_confirm_description: "Se cerrar\xE1 tu sesi\xF3n y volver\xE1s a la pantalla de inicio de sesi\xF3n.",
      cancel: "Cancelar",
      session: "Sesi\xF3n iniciada"
    };
    var fraud_investigations = {
      title: "Investigaciones de fraude",
      description: "Casos de fraude de Kach entrelazados con Piramid, en todas las aseguradoras.",
      search_placeholder: "Buscar por N\xB0 de caso Kach o siniestro...",
      entity_label: "investigaciones",
      view: "Ver",
      files: "Archivos",
      created_after_label: "Desde",
      stats: {
        created_in_kach: "Creados desde Piramid en Kach",
        associated_existing_kach_case: "Asociados a casos existentes en Kach"
      },
      columns: {
        company: "Aseguradora",
        sinister_number: "N\xB0 Siniestro",
        external_case_id: "Caso Kach",
        creation_mode: "Modo de creaci\xF3n",
        status: "Estado interno",
        external_status: "Estado en Kach",
        result: "Resultado",
        handler: "Asignado",
        created_at: "Creado",
        closed_at: "Cerrado"
      },
      detail: {
        back: "Volver a investigaciones",
        case_section: "Datos del caso",
        affected_claims_section: "Reclamos afectados",
        news_section: "Novedades",
        events_section: "Actividad",
        no_claims: "No hay reclamos en el siniestro.",
        no_news: "No hay novedades registradas.",
        no_events: "No hay actividad registrada.",
        news_request: "Solicitud de novedades",
        news_answer: "Respuesta",
        no_annotation: "Sin anotaci\xF3n",
        attributes: {
          company: "Aseguradora",
          sinister_number: "N\xB0 Siniestro",
          external_case_id: "Caso Kach",
          status: "Estado interno",
          external_status: "Estado en Kach",
          result: "Resultado",
          case_type: "Tipo de caso",
          creation_mode: "Origen",
          reason: "Motivo",
          sinister_type: "Tipo de siniestro",
          ramo: "Ramo",
          agency: "Agencia",
          instance: "Instancia",
          handler: "Asignado",
          responsible: "Responsable",
          close_motive: "Motivo de cierre",
          created_by: "Creado por",
          created_at: "Creado el",
          closed_at: "Cerrado el"
        },
        claim_columns: {
          ref_id: "Reclamo",
          status: "Estado",
          system_status: "Sistema",
          alert: "Fraude",
          created_at: "Creado"
        }
      },
      creation_mode: {
        created_in_kach: "Creado en Kach",
        associated_existing_kach_case: "Asociado a caso existente"
      },
      status: {
        not_assigned: "Sin asignar",
        in_progress: "En curso",
        closed: "Cerrado"
      },
      result: {
        positive: "Positivo",
        negative: "Negativo",
        elements_for_rejection: "Elementos para rechazo",
        in_extension: "En pr\xF3rroga",
        canceled: "Cancelado",
        possible_prescription: "Posible prescripci\xF3n",
        without_result: "Sin resultado",
        not_defined: "Sin definir",
        not_derived: "No derivado",
        canceled_by_management: "Cancelado por gerencia"
      },
      case_type: {
        insured: "Asegurado",
        third_party: "Tercero"
      },
      system_status: {
        open: "Abierto",
        closed: "Cerrado"
      },
      alert: {
        fraud_investigation_in_progress: "En investigaci\xF3n",
        fraud_resolved_positive: "Fraude confirmado",
        fraud_related_positive_in_sinister: "Relacionado a positivo",
        none: "Sin alerta",
        resolved: "Resuelta"
      },
      no_value: "\u2014"
    };
    var geo = {
      search_placeholder: "Buscar por nombre...",
      nav: {
        localities: "Localidades",
        departments: "Departamentos",
        provinces: "Provincias"
      },
      localities: {
        title: "Localidades",
        description: "Localidades del dataset oficial de Georef. Datos de referencia (solo lectura).",
        entity_label: "localidades",
        name: "Localidad",
        georef_id: "ID Georef",
        province: "Provincia",
        department: "Departamento",
        latitude: "Latitud",
        longitude: "Longitud",
        created_at: "Fecha de creaci\xF3n"
      },
      departments: {
        title: "Departamentos",
        description: "Departamentos del dataset oficial de Georef. Datos de referencia (solo lectura).",
        entity_label: "departamentos",
        name: "Departamento",
        georef_id: "ID Georef",
        province: "Provincia",
        created_at: "Fecha de creaci\xF3n"
      },
      provinces: {
        title: "Provincias",
        description: "Provincias del dataset oficial de Georef. Datos de referencia (solo lectura).",
        entity_label: "provincias",
        name: "Provincia",
        georef_id: "ID Georef",
        created_at: "Fecha de creaci\xF3n"
      }
    };
    var catalog = {
      page_title: "Cat\xE1logo",
      page_description: "Verticales, bienes y servicios. Cat\xE1logo global administrado por Piramid.",
      columns: {
        id: "ID",
        name: "Nombre",
        slug: "Slug",
        actions: "Acciones"
      },
      verticals_entity_label: "verticales",
      detail: "Detalle",
      vertical: {
        entity_label: "vertical",
        create: "Crear vertical",
        new: "Nuevo vertical",
        edit: "Editar vertical",
        detail_title: "Detalle del vertical",
        detail_description: "Gestiona los bienes y servicios que forman parte de este vertical.",
        name_label: "Nombre",
        name_placeholder: "Cristales automotor",
        slug_label: "Slug",
        slug_placeholder: "cristales-automotor",
        slug_description: "Se genera autom\xE1ticamente a partir del nombre.",
        created_toast: "Vertical creado correctamente",
        updated_toast: "Vertical actualizado correctamente"
      },
      good: {
        singular: "bien",
        plural: "bienes",
        section_title: "Bienes"
      },
      service: {
        singular: "servicio",
        plural: "servicios",
        section_title: "Servicios"
      },
      items: {
        name_label: "Nombre",
        name_placeholder: "Ingrese el nombre",
        add: "Agregar",
        save: "Guardar",
        new: "Nuevo {{entity}}",
        edit: "Editar {{entity}}",
        list_header: "Listado de {{entity}} del vertical ({{count}})",
        empty: "Sin {{entity}}.",
        created_toast: "{{entity}} creado correctamente",
        updated_toast: "{{entity}} actualizado correctamente"
      },
      remove: {
        title: "\xBFEliminar {{entity}} \u201C{{name}}\u201D?",
        description: "Esta acci\xF3n no se puede deshacer. Revisa antes de continuar.",
        cancel: "Cancelar",
        confirm: "Eliminar",
        deleted_toast: "{{entity}} eliminado correctamente"
      },
      company_verticals: {
        section_title: "Verticales",
        empty: "No hay verticales en el cat\xE1logo. Cre\xE1 verticales en la secci\xF3n Proveedores.",
        save: "Guardar",
        updated_toast: "Verticales actualizados correctamente"
      }
    };
    var style_config = {
      scope: {
        insurer: "Aseguradora",
        claim: "Reclamo",
        complaint: "Denuncia"
      },
      "font-family": {
        inter: "Inter",
        roboto: "Roboto",
        roboto_mono: "Roboto mono",
        space_grotesk: "Space grotesk",
        space_mono: "Space mono",
        noto_color_emoji: "Noto Color Emoji",
        playfair_display: "Playfair Display",
        prata: "Prata",
        glegoo: "Glegoo",
        robot_flex: "Roboto flex",
        roboto_condensed: "Roboto Condensed",
        roboto_slab: "Roboto Slab",
        ibm_plex_sans_condensed: "IBM Plex Sans Condensed",
        ubuntu_condensed: "Ubuntu Condensed",
        barlow_condensed: "Barlow Condensed",
        saira_condensed: "Saira Condensed"
      }
    };
    var fraud_investigation_case = {
      kach_connection: {
        title: "Cuenta de Kach",
        connected_as: "Conectada como {{email}}",
        not_connected: "Todav\xEDa no conectaste tu cuenta de Kach.",
        connect: "Conectar cuenta",
        reconnect: "Reconectar",
        disconnect: "Desconectar",
        invalidated: "La conexi\xF3n dej\xF3 de ser v\xE1lida. Volv\xE9 a conectar tu cuenta.",
        connected_toast: "Cuenta de Kach conectada",
        disconnected_toast: "Cuenta de Kach desconectada",
        error_toast: "No se pudo conectar la cuenta de Kach",
        popup_blocked: "El navegador bloque\xF3 la ventana. Permit\xED ventanas emergentes para este sitio y volv\xE9 a intentar."
      },
      fields: {
        insurer: "Aseguradora",
        sinister_id: "Siniestro",
        sinister_type: "Tipo de siniestro",
        reason: "Motivo de an\xE1lisis",
        policy_id: "N\xFAmero de p\xF3liza",
        instance: "Instancia",
        matricula: "Matricula",
        description: "Indicadores o motivos espec\xEDficos de la elevaci\xF3n",
        denounced_at: "Fecha de denuncia",
        occurrence_description: "Descripci\xF3n del hecho",
        annotation: "Informaci\xF3n extra",
        annotation_confidential: "Confidencial: s\xF3lo la ve el analista de Kach, no entra en los indicadores.",
        description_placeholder: "Ej.: relato inconsistente, denuncia tard\xEDa, documentaci\xF3n dudosa\u2026",
        annotation_placeholder: "Contexto adicional que ayude al analista de Kach\u2026"
      },
      derive_disabled: {
        open_investigation: "El siniestro ya tiene una investigaci\xF3n en curso.",
        no_linked_claim: "Vincul\xE1 al menos un reclamo a una denuncia para poder derivar."
      },
      new_case: {
        title: "El siniestro #{{sinister_id}} puede derivarse a Kach.",
        description: "El caso se crear\xE1 con los datos ingresados y se asignar\xE1 a un analista."
      },
      linked_to_another_sinister: {
        description: "Ya existe un caso de fraude en kach para este siniestro, pero est\xE1 asociado a la investigaci\xF3n de otro siniestro de Piramid. Los reclamos se derivan desde ese siniestro.",
        go_to_sinister: "Ir al siniestro",
        acknowledge: "Entendido"
      },
      in_trash: {
        title: "El siniestro #{{sinister_id}} ya existe pero se encuentra en la papelera.",
        description: "No es posible crear un nuevo caso con este n\xFAmero de siniestro. Comun\xEDquese con un usuario con permisos suficientes para restaurar el caso desde la papelera.",
        acknowledge: "Entendido"
      },
      closed: {
        title: "El caso no puede derivarse porque ya fue analizado y cerrado.",
        description: "Comunicate con el responsable de la investigaci\xF3n en Kach y pedile que lo reabra.",
        acknowledge: "Entendido"
      }
    };
    var role = {
      permissions: {
        labels: {
          manage_case_load_balance_rule: "Gestionar Reglas de distribuci\xF3n",
          manage_team: "Gestionar Grupos destino",
          manage_sinister: "Gestionar Siniestro",
          read_sinister: "Visualizar Siniestro",
          manage_complaint: "Gestionar Denuncia",
          read_complaint: "Visualizar Denuncia",
          manage_claim: "Gestionar Reclamo",
          manage_role: "Gestionar Roles",
          manage_user: "Gestionar Usuarios",
          manage_settings: "Gestionar Settings",
          read_notification: "Visualizar Notificaciones",
          read_company_link: "Visualizar Accesos Directos",
          read_user: "Visualizar Usuarios"
        }
      }
    };
    var webhook = {
      events: {
        "claim#created": {
          title: "Reclamo creado"
        },
        "claim#sla#objective#instance#threshold#exceeded": {
          title: "Umbral de objetivo SLA excedido"
        },
        "claim#sla#instance#threshold#exceeded": {
          title: "Umbral de instancia SLA excedido"
        },
        "claim#ownership_transfer#created": {
          title: "Transferencia de propiedad creada"
        },
        "claim#ownership_transfer#accepted": {
          title: "Transferencia de propiedad aceptada"
        },
        "claim#ownership_transfer#rejected": {
          title: "Transferencia de propiedad rechazada"
        },
        "claim#file_request#created": {
          title: "Solicitud de archivo creada"
        },
        "claim#updated": {
          title: "Reclamo actualizado"
        },
        "claim#message#created": {
          title: "Mensaje creado"
        },
        "claim#file#uploaded": {
          title: "Archivo subido"
        },
        "claim#handler#assigned": {
          title: "Tramitador asignado"
        },
        "claim#handler#unassigned": {
          title: "Tramitador desasignado"
        },
        "claim#status#updated": {
          title: "Estado actualizado"
        },
        "claim#order#created": {
          title: "Orden creada"
        },
        "claim#order#invoice#created": {
          title: "Factura de orden creada"
        },
        "claim#order#updates#requested": {
          title: "Actualizaciones de orden solicitadas"
        },
        "claim#order#updates#published": {
          title: "Actualizaciones de orden publicadas"
        },
        "claim#order#report#created": {
          title: "Informe de orden creado"
        },
        "claim#order#report#accepted": {
          title: "Informe de orden aceptado"
        },
        "claim#order#report#rejected": {
          title: "Informe de orden rechazado"
        },
        "claim#offer#created": {
          title: "Oferta creada"
        },
        "claim#offer#accepted": {
          title: "Oferta aceptada"
        },
        "claim#offer#rejected": {
          title: "Oferta rechazada"
        },
        "claim#offer#expired": {
          title: "Oferta expirada"
        },
        "claim#offer#canceled": {
          title: "Oferta anulada"
        },
        "claim#offer#agreement#created": {
          title: "Acuerdo de oferta creado"
        },
        "claim#offer#agreement#completed": {
          title: "Acuerdo de oferta completado"
        },
        "claim#offer#agreement#rejected": {
          title: "Acuerdo de oferta rechazado"
        },
        "claim#offer#agreement#expired": {
          title: "Acuerdo de oferta expirado"
        },
        "claim#offer#agreement#canceled": {
          title: "Acuerdo de oferta cancelado"
        },
        "claim#rfp#created": {
          title: "Solicitud de propuesta creada"
        },
        "claim#rfp#closed": {
          title: "Solicitud de propuesta cerrada"
        },
        "claim#rfp#canceled": {
          title: "Solicitud de propuesta cancelada"
        },
        "claim#rfp#bid#submitted": {
          title: "Oferta de RFP enviada"
        },
        "claim#rfp#bid#selected": {
          title: "Oferta de RFP seleccionada"
        },
        "claim#estimates#updated": {
          title: "Estimaciones actualizadas"
        },
        "claim#appraisal#field_adjuster#assigned": {
          title: "Perito de campo asignado"
        },
        "claim#appraisal#invoice#uploaded": {
          title: "Factura de peritaje subida"
        },
        "claim#appraisal#report#created": {
          title: "Informe de peritaje creado"
        },
        "claim#appraisal#report#accepted": {
          title: "Informe de peritaje aceptado"
        },
        "claim#appraisal#report#rejected": {
          title: "Informe de peritaje rechazado"
        },
        "claim#appraisal#updates#requested": {
          title: "Actualizaciones de peritaje solicitadas"
        },
        "claim#appraisal#updates#published": {
          title: "Actualizaciones de peritaje publicadas"
        }
      },
      scope: {
        user: "Usuario",
        company: "Compa\xF1ia"
      }
    };
    var resources = {
      claims: "Reclamo",
      complaints: "Denuncia"
    };
    var occurrence = {
      circulation_direction: {
        unique: "Unica",
        both: "Ambas"
      }
    };
    var currencies = {
      labels: {
        PYG: "Guaran\xED",
        USD: "D\xF3lar",
        EUR: "Euro",
        ARS: "Peso Argentino"
      }
    };
    var company = {
      properties: {
        name: "Nombre",
        domain: "Dominio",
        type: "Tipo",
        country: "Pa\xEDs",
        ein: "CUIT/CUIL",
        alias: "Alias"
      }
    };
    var teams = {
      coordinator: {
        disclaimer: "Los reclamos no se asignan autom\xE1ticamente al coordinador, pero pueden asignarse de forma manual cuando sea necesario."
      }
    };
    var metrics = {
      "team-management": {
        eyebrow: "Performance del equipo",
        title: "Tablero de performance del equipo",
        tabs: {
          p1: "Estado & Alertas",
          p2: "Productividad",
          p3: "Conciliaci\xF3n"
        },
        scope: {
          label: "Alcance",
          "all-teams": "Todos mis equipos",
          members: "{{count}} miembros",
          hint: "Los datos y los filtros aplican a los equipos seleccionados."
        },
        header: {
          members: "{{count}} miembros",
          "open-claims": "{{count}} reclamos abiertos"
        },
        "scope-summary": {
          title: "Performance del equipo",
          description: "M\xE9tricas consolidadas del alcance seleccionado \xB7 se recalculan al filtrar por equipo.",
          productivity: "Productividad",
          "conciliation-rate": "Tasa de conciliaci\xF3n",
          "resolved-count": "Reclamos resueltos",
          "avg-aging-open": "Aging promedio abiertos",
          "delta-points": "{{value}} pp",
          days: "{{value}} d"
        },
        cohort: {
          "all-handlers": "Todos los tramitadores"
        }
      },
      title: "M\xE9tricas Generales",
      description: "Visualiza m\xE9tricas y estad\xEDsticas de todas las empresas",
      select_period_message: "Selecciona un per\xEDodo para ver las m\xE9tricas",
      total_claims: "Total reclamos",
      total_claimed: "Total reclamado",
      average_claimed: "Promedio reclamado",
      average_management_time: "Tiempo promedio de gesti\xF3n",
      "analysis-period": {
        title: "An\xE1lisis de per\xEDodo"
      },
      "claims-weekly-comparison": {
        title: "Comparaci\xF3n Semanal de Reclamos",
        description: "Volumen de reclamos creados: semana actual vs. semana anterior"
      },
      "select-company": {
        placeholder: "Seleccionar empresa",
        total: "Total (todas las empresas)"
      },
      companies: {
        title: "Empresas",
        rivadavia: "Rivadavia Seguros"
      },
      "current-week": "Semana actual",
      "previous-week": "\xDAltima semana",
      "week-before-last": "Ante \xFAltima semana",
      no_changes: "Sin cambios entre las \xFAltimas semanas completas",
      select_period_placeholder: "Seleccionar per\xEDodo",
      "daily-claims": {
        title: "Reclamos Diarios",
        total: "Total",
        average: "Promedio",
        max: "M\xE1ximo",
        min: "M\xEDnimo",
        claims: "Reclamos",
        "average-line": "Promedio"
      },
      "day-type": {
        working_day: "D\xEDa h\xE1bil",
        weekend: "Fin de semana",
        holiday: "Feriado"
      },
      distribution: {
        title: "Propagaci\xF3n de reclamos",
        "total-claims": "Total de reclamos",
        count: "Cantidad",
        successful: "Prereclamo creado - Vinculado",
        preclaim_error: "Errores",
        no_linking: "Prereclamo creado - No vinculado",
        local: "No propagables (Otros riesgos)",
        no_error_details: "No hay detalles de errores disponibles",
        error_breakdown: "Desglose de errores",
        and_more_errors: "Y {{count}} errores m\xE1s...",
        view_errors: "Ver errores",
        view_reasons: "Ver motivos ({{count}})"
      },
      attempts: {
        title: "Intentos de creaci\xF3n de reclamo",
        "total-attempts": "Total de intentos",
        completed: "Completados",
        recovered: "Completados con error",
        failed: "Fallidos",
        abandoned: "Abandonados",
        in_progress: "En curso",
        view_errors: "Ver errores",
        coefficient: "Coeficiente",
        people: {
          unique: "Personas \xFAnicas",
          title: "\xBFTerminaron su reclamo?",
          description: "Misma empresa y per\xEDodo que Intentos de creaci\xF3n. Cada persona cuenta una vez, aunque haya recargado o vuelto a empezar.",
          finished: "Terminaron",
          abandoned: "Abandonaron",
          in_progress: "Siguen en curso"
        },
        by_user: {
          title: "Intentos por usuario",
          user: "Usuario",
          email: "Email",
          total: "Intentos",
          failed: "Sin terminar",
          successful: "Exitosos",
          coefficient: "Coef.",
          no_name: "Sin nombre",
          no_data: "No hay intentos en el per\xEDodo",
          limited: "Se muestran los 300 usuarios con m\xE1s intentos sin terminar",
          search_placeholder: "Buscar por email...",
          export_csv: "Descargar CSV",
          coefficient_description: "Coeficiente = intentos \xF7 reclamos creados. Un intento empieza cuando se pasa del primer paso; no cuentan los que siguen en curso. Ej.: 3 intentos y 2 creados = 1,50. Cuanto m\xE1s alto, m\xE1s veces tuvo que intentar por cada reclamo creado (m\xE1s fricci\xF3n). \u221E = intent\xF3 y nunca lleg\xF3 a crear un reclamo."
        },
        error_code: {
          not_found_file: "Archivo no encontrado",
          validation_error: "Error de validaci\xF3n",
          license_plate_remote_check_error: "Validaci\xF3n para ingreso de reclamo",
          not_found_vehicle_version: "Versi\xF3n de veh\xEDculo no encontrada",
          invalid_file_token: "Token de archivo inv\xE1lido",
          unauthorized: "No autorizado",
          unknown_error: "Error desconocido"
        }
      },
      "weekly-evolution": {
        title: "Evoluci\xF3n Semanal",
        weeks: "semanas",
        week: "Semana",
        claims: "Reclamos",
        variation: "Variaci\xF3n",
        period: "Per\xEDodo"
      },
      users_stats: {
        title: "Estad\xEDsticas de Usuarios",
        third_verified: "Terceros verificados",
        third_pending: "Terceros pendientes",
        insurer_active: "Tramitadores activos",
        with_claims: "Tramitadores responsables de reclamos"
      },
      "processing-amount": {
        title: "Monto de Tramitaci\xF3n",
        claimed_amount: "Monto Reclamado",
        claimed_amount_with_accepted_offers: "Monto Reclamado (con ofertas aceptadas)",
        estimation_amount: "Monto de Estimaci\xF3n",
        offer_amount: "Monto de Ofrecimiento",
        p50: "P50 (Mediana)",
        p95: "P95",
        average: "Promedio",
        count: "Cantidad",
        claims_count: "reclamos",
        offers_count: "ofertas aceptadas",
        no_data: "Sin datos en el per\xEDodo",
        only_accepted_offers: "Solo reclamos con ofertas aceptadas"
      },
      experimental: {
        title: "Experimental",
        description: "An\xE1lisis en prueba, de uso interno. Todav\xEDa no se muestran a los clientes.",
        tabs: {
          "risk-zone": "Zona de riesgo",
          "closure-cohort": "Cohorte de cierre por etapa"
        },
        "closure-cohort": {
          title: "Cohorte de cierre por etapa",
          "description-monthly": "Cu\xE1ntos reclamos de cada cohorte cerraron en cada mes, sin sumar los meses anteriores. Con una etapa de cierre elegida, cuenta solo los que cerraron en esa etapa.",
          "description-cumulative": "Cu\xE1ntos reclamos de cada cohorte cerraron hasta cada mes, sumando los meses anteriores. Con una etapa de cierre elegida, cuenta solo los que cerraron en esa etapa.",
          "month-tooltip-one": "% del cohorte cerrado en el mes siguiente al de creaci\xF3n.",
          "month-tooltip-many": "% del cohorte cerrado {{n}} meses despu\xE9s del de creaci\xF3n, sin sumar los meses anteriores.",
          "pick-company": "Eleg\xED una empresa para ver el cohorte.",
          "outcome-filter": {
            all: "Todas las etapas",
            search: "Buscar etapa",
            empty: "No hay etapas",
            clear: "Limpiar",
            selected: "{{count}} etapas"
          },
          mode: {
            partial: "Parcial",
            cumulative: "Acumulado"
          },
          base: {
            created: {
              label: "Sobre creados",
              description: "El % es sobre el tama\xF1o del cohorte."
            },
            closed: {
              label: "Sobre cerrados",
              description: "El % es sobre el total que cerr\xF3 cada cohorte hasta hoy, en las etapas elegidas. En las cohortes recientes ese total todav\xEDa va a crecer.",
              "cell-hint": "Sobre el total cerrado de la cohorte, no sobre los creados."
            }
          },
          summary: {
            "cohort-count": {
              label: "Meses completos",
              tooltip: "Cu\xE1ntos meses de creaci\xF3n ya terminaron esa columna. Solo esos entran en las filas de abajo: la celda con * sigue en curso y queda afuera.",
              "tooltip-closed": "Cu\xE1ntos meses de creaci\xF3n ya terminaron esa columna y tienen alg\xFAn cerrado. Solo esos entran en las filas de abajo: la celda con * sigue en curso y queda afuera."
            },
            average: {
              label: "Promedio",
              tooltip: "Cerrados en esa columna sumando los meses completos, dividido por los creados de esos mismos meses. Los meses con m\xE1s reclamos pesan m\xE1s.",
              "tooltip-closed": "Cerrados en esa columna sumando los meses completos, dividido por el total cerrado de esos mismos meses. Los meses con m\xE1s reclamos pesan m\xE1s."
            },
            p25: {
              label: "P25",
              tooltip: "Un cuarto de los meses qued\xF3 por debajo de este valor. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
            },
            median: {
              label: "Mediana",
              tooltip: "La mitad de los meses qued\xF3 por debajo y la otra mitad por arriba. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
            },
            p75: {
              label: "P75",
              tooltip: "Tres cuartos de los meses quedaron por debajo de este valor. Cada mes cuenta igual, sin importar cu\xE1ntos reclamos tuvo."
            },
            p95: {
              label: "P95",
              tooltip: "El 95% de los meses qued\xF3 por debajo de este valor. Con pocos meses es casi el m\xE1ximo."
            }
          }
        }
      },
      "risk-zone": {
        "claim-type-selector": "Tipo de reclamo",
        "claim-types": {
          injured: "Lesionado",
          combined: "Combinado",
          material_damage: "Da\xF1o Material"
        },
        "coming-soon": "Pr\xF3ximamente",
        title: "Zona de riesgo en reclamos de {{claimType}}",
        lede: "Cada reclamo tiene un score de 0 a 100 seg\xFAn qu\xE9 tan parecido es a los que terminaron en mediaci\xF3n o juicio. A la derecha, perfil de origen m\xE1s riesgoso; arriba, gesti\xF3n m\xE1s riesgosa. Las bandas naranjas son las zonas Alto y Muy alto.",
        zones: {
          very_high: "Muy alto (+{{score}})",
          high: "Alto o m\xE1s (+{{score}})"
        },
        confusion: {
          title: "\xBFLa zona dice la verdad?",
          subtitle: "Cerrados creados entre {{from}} y {{to}}, cuando ya se sabe c\xF3mo terminaron.",
          "zone-selector": "Zona a evaluar",
          "true-positives": {
            label: "escalaron dentro de la zona",
            hint: "verdaderos positivos"
          },
          "false-positives": {
            label: "no escalaron, {{count}} de ellos conciliados",
            hint: "falsos positivos"
          },
          "false-negatives": {
            label: "escalaron fuera de la zona",
            hint: "falsos negativos"
          },
          precision: {
            label: "precisi\xF3n, atrapa {{recall}} de los escalados",
            hint: "{{count}} abiertos hoy en esta zona"
          }
        },
        "load-error": "No se pudo cargar la zona de riesgo.",
        outcomes: {
          open: "Abierto",
          mediation: "Mediaci\xF3n",
          judgment: "Juicio",
          conciliated: "Conciliado",
          rejected: "Rechazado",
          withdrawn: "Desistido",
          other: "Anulado, fraude o no prosper\xF3"
        },
        signals: {
          claimed_amount_5_20m: "Monto reclamado $5\u201320M",
          claimed_amount_over_20m: "Monto reclamado mayor a $20M",
          high_risk_province: "Provincia de alto riesgo",
          low_risk_province: "Provincia de bajo riesgo",
          massive_sinister: "Siniestro con +4 reclamos",
          attorney_claimant: "Reclama un abogado",
          volume_claimant: "Reclamante de volumen (+50 reclamos previos)",
          no_estimate: "Sin estimaci\xF3n",
          estimate_below_half_claimed: "Estimaci\xF3n menor al 50% del monto reclamado",
          estimated_without_offer: "Estimado sin oferta",
          open_over_30_days: "+30 d\xEDas abierto",
          accepted_offer: "Oferta aceptada"
        },
        map: {
          "filters-label": "Qu\xE9 reclamos mostrar",
          filters: {
            top: "Top 50",
            escalated: "Mediaci\xF3n y juicio",
            open: "Abiertos",
            conciliated: "Conciliados",
            closed_other: "Cerrados no conciliados"
          },
          "aria-label": "Dispersi\xF3n de reclamos por perfil de origen y gesti\xF3n",
          "x-axis": "Perfil de origen (puntos): qu\xE9 se reclama y qui\xE9n reclama",
          "x-axis-short": "Perfil de origen (puntos)",
          "y-axis": "Gesti\xF3n (puntos)",
          bands: {
            high: "Alto",
            very_high: "Muy alto"
          },
          "accepted-offer-strip": "Con oferta aceptada (en cierre, riesgo bajo)"
        },
        methodology: {
          "profile-title": "Perfil de origen",
          "management-title": "Gesti\xF3n",
          "reading-title": "C\xF3mo leerlo",
          points: {
            lead: "Cada se\xF1al suma o resta puntos; ",
            emphasis: "{{points}} puntos equivalen al doble de riesgo",
            rest: ". Perfil m\xE1s gesti\xF3n da el score, por eso las zonas son diagonales. El score es el percentil: {{score}} significa m\xE1s riesgoso que el {{score}}% de los reclamos hist\xF3ricos de {{claimType}}. Montos inv\xE1lidos (tipo $1.111.111.111) se toman como monto alto."
          },
          "closed-moment": "Los cerrados se ubican en su momento m\xE1s riesgoso de los primeros {{days}} d\xEDas, antes del cierre. Los abiertos, con su estado de hoy.",
          accepted: {
            lead: "Una oferta aceptada resta ",
            emphasis: "{{points}} puntos",
            rest: ": esos reclamos van en la franja inferior para no aplastar el mapa."
          },
          capped: " El peso de \u201C{{signal}}\u201D est\xE1 moderado: hubo solo {{cases}} casos, as\xED que se usa un tope conservador en lugar del valor extremo que dar\xEDa el modelo.",
          scope: "Se muestran todos los reclamos de {{claimType}}: {{closed}} cerrados ({{period}}) y {{open}} abiertos. Tasa base de escalada: {{baseRate}}.",
          period: "{{from}} a {{to}}",
          "calibrated-at": "Calibraci\xF3n del {{date}}"
        },
        "top-claims": {
          title: "Top 50 abiertos",
          lede: "Del 1 al 50, ordenados por score. Score: percentil de riesgo (0 a 100). Prob.: probabilidad estimada de escalar. Toc\xE1 uno para ubicarlo en el mapa.",
          score: "Score",
          probability: "Prob.",
          "open-days": {
            one: "1 d\xEDa abierto",
            other: "{{count}} d\xEDas abierto"
          }
        },
        tooltip: {
          score: "Score",
          "top-rank": "#{{rank}} del top 50",
          "no-reference": "Sin referencia",
          "open-days": {
            one: "Abierto hace 1 d\xEDa",
            other: "Abierto hace {{count}} d\xEDas"
          },
          evaluated: "{{stage}}, evaluado al d\xEDa {{day}}",
          probability: "Probabilidad de escalar {{probability}}",
          "claimed-amount": "Monto reclamado {{amount}}",
          "placeholder-amount": "Monto reclamado inv\xE1lido (se toma como alto)",
          claimant: "Reclama: {{relationship}}",
          "unknown-relationship": "sin dato",
          "previous-claims": {
            one: "1 reclamo previo",
            other: "{{count}} reclamos previos"
          },
          handler: "Tramitador {{name}}",
          "no-handler": "Sin tramitador",
          "days-without-response": {
            one: "1 d\xEDa sin respuesta al reclamante",
            other: "{{count}} d\xEDas sin respuesta al reclamante"
          }
        }
      },
      performance: {
        title: "Performance de las compa\xF1\xEDas",
        "title-company": "Performance de {{company}}",
        description: "Estado actual, alertas y comparaciones con per\xEDodos anteriores.",
        scope: {
          label: "Alcance",
          "all-teams": "Todos los equipos",
          "selected-teams": "{{count}} equipos",
          search: "Buscar equipo\u2026",
          empty: "Sin equipos",
          clear: "Limpiar",
          summary: "{{members}} miembros \xB7 {{openClaims}} reclamos abiertos \xB7 El filtro de equipo aplica a los bloques de esta p\xE1gina."
        },
        "pts-suffix": "pts",
        "metric-explainer": {
          numerator: "Numerador",
          denominator: "Denominador",
          "positives-title": "Desenlaces positivos",
          "negatives-title": "Desenlaces negativos"
        },
        "success-explainer": {
          title: "\xBFC\xF3mo se calcula la Eficacia operativa?",
          "info-label": "\xBFC\xF3mo se calcula la Eficacia operativa?",
          description: "Mide qu\xE9 parte de los reclamos creados en el mes evit\xF3 un desenlace negativo. Contando solo los que ya cerraron",
          "calculation-description": "Es el porcentaje de cerrados que termin\xF3 en un desenlace positivo.",
          "columns-caption": "Datos del mes actual",
          footer: "Los reclamos del mes que siguen abiertos todav\xEDa no cuentan, por eso los meses recientes se van ajustando a medida que cierran.",
          "point-detail": "{{failures}} negativos de {{closed}} cerrados"
        },
        "productivity-explainer": {
          title: "\xBFC\xF3mo se calcula la Productividad operativa?",
          "info-label": "\xBFC\xF3mo se calcula la Productividad operativa?",
          description: "Cu\xE1ntos reclamos cierra el equipo por cada d\xEDa trabajado y por tramitador. Cuanto m\xE1s alta, mejor.",
          numerator: "reclamos cerrados en el mes",
          denominator: "d\xEDas del mes \xD7 tramitadores activos (los que cerraron al menos un caso)",
          "window-previous": "{{month}}: {{resolved}} cerrados / ({{days}} d\xEDas del mes \xD7 {{handlers}} tramitadores) = {{value}}.",
          "window-current": "{{month}} (en curso): {{resolved}} cerrados / ({{days}} d\xEDas transcurridos \xD7 {{handlers}} tramitadores) = {{value}}."
        },
        "leading-explainer": {
          judicializationRate: {
            title: "\xBFC\xF3mo se calcula Judicializaci\xF3n?",
            "info-label": "\xBFC\xF3mo se calcula Judicializaci\xF3n?",
            description: "Cu\xE1ntos de los reclamos creados en el mes terminaron en juicio, cada 10.000 que ya cerraron.",
            numerator: "reclamos creados en el mes que cerraron en Juicio",
            denominator: "reclamos creados en el mes que ya est\xE1n cerrados",
            base: "Es una frecuencia, no un porcentaje: cuanto m\xE1s baja, mejor. Los meses recientes se van ajustando a medida que cierran sus reclamos."
          },
          resolutionRate: {
            title: "\xBFC\xF3mo se calcula la Tasa de resoluci\xF3n?",
            "info-label": "\xBFC\xF3mo se calcula la Tasa de resoluci\xF3n?",
            description: "De los reclamos que tuvieron movimiento en el mes (los que se crearon y los de meses anteriores que se cerraron), qu\xE9 parte qued\xF3 cerrada.",
            numerator: "reclamos cerrados en el mes",
            denominator: "reclamos creados en el mes m\xE1s los cerrados en el mes, sin contar dos veces los que se crearon y cerraron en el mismo mes",
            base: "Ejemplo: en el mes entran 100 reclamos y se cierran 90, de los cuales 30 son de los creados en el mes. La tasa es 90 / (100 + 90 \u2212 30) = 56%."
          },
          mediationRate: {
            title: "\xBFC\xF3mo se calcula Mediaci\xF3n?",
            "info-label": "\xBFC\xF3mo se calcula Mediaci\xF3n?",
            description: "Cu\xE1ntos de los reclamos creados en el mes terminaron en mediaci\xF3n, cada 10.000 que ya cerraron.",
            numerator: "reclamos creados en el mes que cerraron en Mediaci\xF3n",
            denominator: "reclamos creados en el mes que ya est\xE1n cerrados",
            base: "Es una frecuencia, no un porcentaje: cuanto m\xE1s baja, mejor. Los meses recientes se van ajustando a medida que cierran sus reclamos."
          },
          pendingOfferCount: {
            title: "\xBFC\xF3mo se calcula Reclamos con oferta pendiente?",
            "info-label": "\xBFC\xF3mo se calcula Reclamos con oferta pendiente?",
            description: "Reclamos abiertos y listos para enviar ofrecimiento (con responsabilidad y la estimaci\xF3n de cada da\xF1o cargada) desde los que todav\xEDa no se envi\xF3 ning\xFAn ofrecimiento. Cuanto m\xE1s bajo, mejor.",
            base: "Cada punto toma datos al \xFAltimo d\xEDa del mes, con la responsabilidad y la estimaci\xF3n que el reclamo ten\xEDa ese d\xEDa. El mes en curso es la situaci\xF3n actual. Un mismo reclamo puede aparecer en varios meses si sigui\xF3 sin ofrecimiento."
          }
        },
        "north-star": {
          "previous-month": "Mes anterior",
          "month-in-progress": "(en curso)",
          conciliation: {
            title: "Eficacia operativa"
          },
          productivity: {
            title: "Productividad operativa"
          }
        },
        leading: {
          judicializationRate: "Judicializaci\xF3n",
          resolutionRate: "Tasa de resoluci\xF3n",
          mediationRate: "Mediaci\xF3n",
          pendingOfferCount: "Reclamos con oferta pendiente",
          subtitle: {
            judicializationRate: "cada 10.000 casos cerrados",
            mediationRate: "cada 10.000 casos cerrados"
          },
          "pp-suffix": "pp"
        },
        focus: {
          title: "Foco del mes",
          subtitle: "M\xE1s cierres exitosos perdidos",
          metric: {
            "aging-open": "Aging promedio abiertos",
            "money-in-dispute": "$ en disputa",
            mediation: "A mediaci\xF3n",
            judgment: "A juicio"
          },
          "efficacy-drop": "Eficacia operativa {{value}} en {{month}} vs {{previousValue}} en {{previousMonth}}",
          "lost-successes": "{{count}} cierres exitosos menos",
          "month-note": "Datos de {{month}}, el \xFAltimo mes completo"
        },
        "team-table": {
          title: "Performance por equipo",
          column: {
            team: "Equipo",
            productivity: "Productividad",
            conciliation: "Conciliaci\xF3n",
            delta: "\u0394 per\xEDodo ant.",
            "delta-tooltip": "Variaci\xF3n vs per\xEDodo anterior seg\xFAn el filtro seleccionado."
          },
          "focus-tag": "foco",
          "show-inactive": "Mostrar {count} equipos sin actividad",
          "hide-inactive": "Ocultar equipos sin actividad"
        },
        aging: {
          title: "Aging de Casos Abiertos",
          average: "Promedio",
          "days-suffix": "d",
          "risk-zone": "Zona de riesgo: {count} reclamos ({pct} del total)",
          bucket: {
            "0-30": "0-30 d",
            "30-60": "31-60 d",
            "60-90": "61-90 d",
            "90+": "90+ d"
          }
        },
        "open-stock": {
          "as-of-today": "Actualizado a las {{time}} \xB7 no responde al filtro de per\xEDodo",
          "as-of-date": "Actualizado el {{date}} a las {{time}} \xB7 no responde al filtro de per\xEDodo"
        },
        "critical-status": {
          title: "Reclamos por estado cr\xEDtico",
          "snapshot-note": "Foto actual \xB7 no responde al filtro de per\xEDodo",
          "column-status": "Estado",
          "column-count": "Cantidad de reclamos",
          empty: "No hay estados cr\xEDticos configurados",
          "stage-prefix": "Etapa",
          "aging-prefix": "aging prom",
          "days-suffix": "d",
          total: "{{count}} reclamos abiertos en estados cr\xEDticos",
          "tooltip-share": "del total"
        },
        "damage-table": {
          title: "Performance por tipo de da\xF1o",
          column: {
            category: "Tipo de da\xF1o",
            resolved: "Resueltos",
            "avg-days": "D\xEDas prom.",
            mediation: "Mediaci\xF3n",
            judgment: "Juicio",
            aging: "Aging abiertos",
            "percent-of-total": "% del total",
            efficacy: "Eficacia operativa"
          },
          category: {
            Lesionado: "Lesionado",
            Fallecidos: "Fallecidos",
            "Da\xF1o Material": "Da\xF1o Material",
            Combinado: "Combinado",
            "Da\xF1o a Inmueble": "Da\xF1o a Inmueble"
          },
          "historical-badge": "Hist\xF3rico \xB7 acumulado de toda la compa\xF1\xEDa"
        },
        filters: {
          company: "Empresa",
          period: "Per\xEDodo",
          from: "Desde",
          to: "Hasta",
          preset: {
            "7d": "7 d\xEDas",
            "15d": "15 d\xEDas",
            "30d": "30 d\xEDas",
            "3m": "3 meses",
            "6m": "6 meses",
            "12m": "12 meses"
          },
          "preset-long": {
            "7d": "\xDAltimos 7 d\xEDas",
            "15d": "\xDAltimos 15 d\xEDas",
            "30d": "\xDAltimos 30 d\xEDas",
            "3m": "\xDAltimos 3 meses",
            "6m": "\xDAltimos 6 meses",
            "12m": "\xDAltimos 12 meses"
          },
          date: {
            "range-placeholder": "Seleccion\xE1 un rango",
            clear: "Limpiar",
            cancel: "Cancelar",
            apply: "Aplicar",
            "disabled-tooltip": "El filtro de fecha no aplica a Estado & Alertas",
            "disabled-notice": "El filtro de fecha no aplica a Estado & Alertas \u2014 todos los datos son foto actual o hist\xF3rico."
          },
          custom: "Personalizado",
          exclude: {
            label: "Excluir",
            none: "Ninguno",
            today: "Hoy",
            week: "Semana actual",
            month: "Mes actual",
            quarter: "Trimestre actual"
          }
        },
        "focus-hidden": "Equipo foco no encontrado en esta empresa.",
        tabs: {
          p1: "Estado & Alertas",
          p2: "Productividad",
          p3: "Conciliaci\xF3n",
          p4: "Fraude \xB7 Kach",
          p5: "Impacto al Cliente",
          "coming-soon": "Pr\xF3ximamente",
          "coming-soon-description": "Esta pesta\xF1a estar\xE1 disponible en una pr\xF3xima entrega."
        },
        p4: {
          "section-title": "Detecci\xF3n de fraude",
          "section-description": "Integraci\xF3n Piramid + Kach",
          filters: {
            "all-types": "Todos los tipos"
          },
          banner: {
            eyebrow: "Impacto del per\xEDodo",
            derived: "casos derivados",
            confirmed: "fraudes confirmados",
            saved: "valor protegido",
            "delta-suffix": "vs per\xEDodo anterior",
            "saved-note-one": "{{count}} reclamo sin estimaci\xF3n judicial cargada",
            "saved-note-other": "{{count}} reclamos sin estimaci\xF3n judicial cargada"
          },
          "in-process": {
            title: "Casos en proceso",
            subtitle: "Investigaciones abiertas hoy",
            "snapshot-tag": "Foto actual",
            "total-label": "casos abiertos en Kach",
            "breakdown-label": "Desglose por tipo de reclamo",
            "breakdown-tooltip": "Un caso puede aparecer en m\xE1s de un tipo si involucra reclamos de distintos tipos.",
            footnote: "No responde al filtro de per\xEDodo \xB7 estado en tiempo real.",
            empty: "Sin casos abiertos en Kach en este momento."
          },
          aging: {
            title: "Aging de casos abiertos",
            subtitle: "Antig\xFCedad de los casos que Kach todav\xEDa no cerr\xF3",
            "snapshot-tag": "Foto actual",
            "avg-label": "d\xEDas promedio abiertos",
            "total-label": "casos abiertos en Kach",
            "breakdown-label": "Distribuci\xF3n por antig\xFCedad",
            footnote: "No responde al filtro de per\xEDodo \xB7 estado en tiempo real.",
            empty: "Sin casos abiertos en Kach en este momento."
          },
          time: {
            title: "Tiempo de investigaci\xF3n",
            subtitle: "D\xEDas desde la derivaci\xF3n a Kach hasta el cierre del caso",
            unit: "d\xEDas",
            caption: "Cuanto antes cierra el caso, menos costo operativo consume el reclamo.",
            "breakdown-label": "Desglose \xB7 d\xEDas promedio",
            "delta-suffix": "vs per\xEDodo anterior",
            "no-previous": "Sin datos comparables en per\xEDodo anterior",
            positive: "Resultado positivo",
            "positive-note": "Fraude confirmado \xB7 cerrado",
            negative: "Resultado negativo",
            "negative-note": "Vuelve al flujo operativo",
            empty: "Sin casos cerrados en el per\xEDodo seleccionado."
          }
        },
        p2: {
          "section-title": "Diagn\xF3stico de Productividad",
          "section-description": "D\xF3nde se acumulan los reclamos y por qu\xE9 no estamos resolviendo m\xE1s r\xE1pido.",
          "stage-sla": {
            title: "Cumplimiento de SLA por etapa",
            subtitle: "% de reclamos que cerraron cada etapa dentro del SLA definido. Cerrados en el per\xEDodo seleccionado.",
            empty: {
              "no-sla": "Esta compa\xF1\xEDa no tiene SLA por etapa configurado.",
              "no-data": "No hay etapas cerradas en el per\xEDodo para el tipo de reclamo seleccionado."
            },
            kpi: {
              global: "Cumplimiento global",
              "global-delta": "{{sign}} {{n}} pts vs per\xEDodo ant.",
              "in-green": "Etapas en verde",
              "in-green-sub": "\u2265 80% cumplimiento",
              worst: "Peor etapa",
              "worst-sub": "{{pct}} cumplimiento"
            },
            stage: {
              "sla-label": "SLA: {{value}} {{unit}}",
              out: "fuera",
              avg: "Prom: {{days}} d"
            },
            footnote: "Verde \u2265 80% \xB7 Amarillo 50-79% \xB7 Rojo < 50%. Solo se muestran etapas con SLA definido en la configuraci\xF3n de la compa\xF1\xEDa."
          }
        },
        p3: {
          "section-title": "Diagn\xF3stico de Conciliaci\xF3n",
          "section-description": "Por qu\xE9 algunos reclamos terminan en mediaci\xF3n o juicio, y qu\xE9 los distingue de los que se concilian.",
          outcome: {
            reconciled: "Conciliados",
            mediation: "Mediaci\xF3n",
            judgment: "Juicio",
            notSuccessful: "No prosper\xF3",
            claimantDisinterest: "Desinter\xE9s del reclamante",
            rejected: "Rechazados",
            cancelled: "Anulados",
            fraud: "Fraude"
          },
          kpis: {
            conciliated: "Conciliados del per\xEDodo",
            mediation: "A mediaci\xF3n",
            judgment: "A juicio",
            "in-dispute": "$ en disputa",
            "vs-previous-period": "vs per\xEDodo ant."
          },
          negotiation: {
            title: "Indicadores tempranos de negociaci\xF3n",
            description: "Los reclamos que terminan en juicio suelen ofrecerse m\xE1s tarde, menos veces y por debajo de la estimaci\xF3n.",
            "days-to-first-offer": "D\xEDas al 1\xB0 ofrecimiento",
            "offers-count": "Ofrecimientos promedio",
            "gap-vs-estimation": "Gap $ vs estimaci\xF3n",
            "days-to-close": "D\xEDas al cierre",
            tooltip: {
              "days-to-first-offer": "D\xEDas entre la creaci\xF3n del reclamo y la primera oferta al reclamante. Actuar temprano correlaciona con conciliar.",
              "offers-count": "Cantidad promedio de rondas de ofrecimiento por reclamo. M\xE1s rondas suelen implicar negociaci\xF3n activa; muy pocas pueden derivar en juicio.",
              "gap-vs-estimation": "Diferencia porcentual entre el primer ofrecimiento y el monto judicial reclamado. Valores negativos indican que la primera oferta fue menor al monto reclamado. Un gap m\xE1s negativo suele conciliar mejor; un gap chico o positivo indica que ya se paga cerca de lo pedido.",
              "days-to-close": "D\xEDas totales desde la creaci\xF3n del reclamo hasta su cierre definitivo."
            },
            column: {
              indicator: "Indicador",
              diff: "\u0394 concil. \u2192 juicio"
            }
          },
          "outcome-cohort": {
            title: "Desenlace por mes de creaci\xF3n",
            description: "C\xF3mo cerraron los reclamos de cada mes de creaci\xF3n, por etapa de cierre. Los porcentajes son sobre los cerrados del cohorte y suman 100%. 'A\xFAn abiertos' se mide sobre el cohorte completo.",
            empty: "No hay cohortes en el rango seleccionado.",
            "statuses-tooltip": "Estados: {{statuses}}",
            "still-open": "A\xFAn abiertos",
            "immature-hint": "* Cohorte en curso, los valores pueden variar hasta que cierre.",
            column: {
              cohort: "Cohorte",
              size: "Tama\xF1o"
            }
          },
          "dispute-treemap": {
            title: "$ en disputa por tipo de da\xF1o",
            description: "Monto judicial total en mediaci\xF3n y juicio, por tipo de da\xF1o.",
            empty: "No hay reclamos en mediaci\xF3n o juicio en el per\xEDodo.",
            "tooltip-share": "del total en disputa"
          },
          patterns: {
            title: "Patrones agregados",
            description: "Reclamos que fueron a mediaci\xF3n o juicio, agrupados por tipo de da\xF1o y desenlace.",
            empty: "No hay patrones para el per\xEDodo seleccionado.",
            column: {
              category: "Tipo de da\xF1o",
              outcome: "Desenlace",
              count: "Q",
              "days-to-first-offer": "D\xEDas al 1\xB0 ofrec.",
              "offers-count": "Ofrec. prom.",
              gap: "Gap vs estim.",
              money: "$ involucrado"
            }
          },
          "risk-zone": {
            title: "Zona de riesgo",
            description: "Reclamos abiertos con patrones similares a los que terminaron en mediaci\xF3n o juicio en los \xFAltimos 6 meses.",
            "no-period-hint": "Esta secci\xF3n no depende del filtro de fecha de la p\xE1gina.",
            filter: {
              label: "Filtros",
              "damage-type-label": "Tipo de da\xF1o",
              "damage-type-all": "Todos los tipos",
              "amount-label": "Monto",
              "amount-all": "Todo el monto",
              "amount-gt500k": "> $ 500.000",
              "amount-gt1m": "> $ 1.000.000"
            },
            kpi: {
              "amount-sub": "acumulado del top 50 en riesgo",
              "amount-tooltip": "Suma del monto en disputa de los 50 reclamos abiertos con mayor score de riesgo hoy.",
              "aging-label": "Aging promedio",
              "aging-tooltip": "D\xEDas promedio desde la creaci\xF3n hasta hoy, sobre el top 50 en riesgo.",
              "score-label": "Score promedio",
              "score-tooltip": "Promedio del score de riesgo del top 50. Score 0-100 seg\xFAn similitud con casos que fueron a mediaci\xF3n o juicio en los \xFAltimos 6 meses.",
              "without-offer-label": "Sin ofrecimiento",
              "without-offer-sub": "abiertos sin evaluar",
              "without-offer-tooltip": "Reclamos abiertos con m\xE1s de 15 d\xEDas que a\xFAn no tienen ning\xFAn ofrecimiento registrado. No se pueden evaluar con el score, pero merecen atenci\xF3n."
            },
            table: {
              title: "Top 10 en riesgo",
              "title-selected": "Reclamo en riesgo",
              tooltip: "Score 0-100 calculado por percentil ponderado de 4 indicadores respecto a mediaciones y juicios de los \xFAltimos 6 meses: d\xEDas abiertos, d\xEDas al 1\xB0 ofrecimiento, cantidad de ofrecimientos, gap vs estimaci\xF3n.",
              "csv-btn": "CSV",
              row: {
                "days-open": "{{days}}d abierto"
              }
            },
            scatter: {
              title: "Mapa de los 50 reclamos abiertos de mayor riesgo",
              legend: {
                size: "Tama\xF1o: monto",
                number: "N\xFAmero: ofrecimientos",
                color: "Color (gap $):",
                "color-scale": "chico \u2192 grande"
              },
              "toggle-historic": "Mostrar cerrados \xFAltimos 6m (mediaci\xF3n o juicio)",
              "axis-x": "D\xEDas de vida del reclamo",
              "axis-y": "Score de riesgo",
              "risk-zone-label": "Riesgo (score \u2265 60)",
              "risk-zone-critical-label": "Riesgo cr\xEDtico (score \u2265 80)",
              tooltip: {
                open: {
                  score: "Score: {{score}}/100",
                  "days-open": "D\xEDas abiertos: {{days}}",
                  "days-first-offer": "D\xEDas al 1\xB0 ofrec: {{days}}",
                  offers: "Ofrecimientos: {{count}}",
                  gap: "Gap: {{gap}}",
                  amount: "Monto: {{amount}}"
                },
                historic: {
                  "closed-in": "Cerrado en {{outcome}}",
                  "final-score": "Score final: {{score}}/100",
                  duration: "Duraci\xF3n: {{days}} d",
                  amount: "Monto: {{amount}}"
                }
              }
            },
            outcome: {
              mediation: "Mediaci\xF3n",
              judgment: "Juicio"
            },
            "selected-banner": "Filtrando por reclamo seleccionado en el gr\xE1fico",
            "clear-selection": "Quitar selecci\xF3n",
            empty: {
              "no-results": "Sin reclamos en zona de riesgo con los filtros actuales",
              "no-reference": "Sin mediaciones ni juicios en los \xFAltimos 6 meses. No es posible calcular riesgo."
            },
            error: "No se pudo cargar la zona de riesgo.",
            retry: "Reintentar"
          }
        },
        funnel: {
          title: "Funnel de etapas",
          "drill-down-title": "Estados dentro de {stage}",
          back: "Volver a etapas",
          "bottleneck-tag": "Cuello de botella",
          hint: "La barra representa los d\xEDas promedio en cada etapa. La l\xEDnea negra marca el SLA; sin filtro se muestra el rango m\xEDn-m\xE1x entre tipos de da\xF1o. Si la barra supera el SLA (o el m\xEDnimo del rango), la etapa incumple SLA en promedio. Hac\xE9 clic en una etapa para ver el detalle de estados.",
          "special-section": "Estados especiales (pueden ocurrir en cualquier momento)",
          filter: {
            "damage-type-label": "Tipo de da\xF1o",
            "damage-type-all": "Todos los tipos"
          },
          sla: {
            "tooltip-single": "SLA: {{days}} d",
            "tooltip-range": "SLA: {{min}} d \u2013 {{max}} d seg\xFAn tipo de da\xF1o"
          },
          empty: "No hubo transiciones de etapa en el per\xEDodo.",
          error: "No pudimos cargar el detalle de estados.",
          "no-states": "Esta etapa no tuvo entradas de estados en el per\xEDodo.",
          column: {
            stage: "Etapa",
            count: "Reclamos",
            "count-tooltip": "Cantidad de reclamos que pasaron por esta etapa en el per\xEDodo.",
            "avg-days": "D\xEDas prom.",
            delta: "\u0394 per\xEDodo ant."
          },
          "drill-down": {
            column: {
              state: "Estado",
              count: "Reclamos",
              "count-tooltip": "Cantidad de reclamos que pasaron por este estado en el per\xEDodo.",
              "avg-days": "D\xEDas prom."
            }
          }
        },
        flow: {
          title: "Flujo entrante vs saliente",
          legend: {
            created: "Creados",
            closed: "Cerrados"
          },
          "backlog-label": "Backlog acumulado del per\xEDodo",
          "monthly-note": "Los puntos representan totales mensuales completos."
        },
        "backlog-by-age": {
          title: "Backlog abierto por edad",
          subtitle: "Distribuci\xF3n detallada del stock actual.",
          kpi: {
            stock: "Stock total",
            "stock-detail": "reclamos abiertos",
            runway: "Runway estimado",
            "runway-months": "meses",
            "runway-detail": "al ritmo neto de cierre ({{rate}}/mes)",
            "runway-null": "el backlog no se reduce ({{rate}}/mes neto)",
            critical: "Cr\xEDtico (>90 d\xEDas)",
            "critical-detail": "{{pct}} del backlog"
          },
          tooltip: {
            claims: "{{count}} reclamos",
            pct: "{{pct}} del backlog"
          },
          "foot-note": "La edad se calcula desde la fecha de creaci\xF3n de cada reclamo hasta hoy. El runway estimado divide el stock actual por la reducci\xF3n neta (cerrados \u2212 creados) del \xFAltimo mes calendario completo."
        },
        cohort: {
          title: "Cohorte de cierre por mes de creaci\xF3n",
          description: "% del cohorte que ya cerr\xF3 seg\xFAn el mes calendario en que se cerr\xF3, relativo a su mes de creaci\xF3n. Cohortes recientes pueden no estar maduros.",
          empty: "No hay reclamos creados en los \xFAltimos meses.",
          "in-progress-hint": "Bucket a\xFAn no completo \u2014 el cohorte sigue corriendo.",
          "excluded-recent-hint": "Se excluyen cohortes con menos de 15 d\xEDas desde el inicio del mes (datos no significativos).",
          filter: {
            all: "Todos los tipos",
            active: "Filtrado",
            clear: "Limpiar filtro"
          },
          column: {
            cohort: "Cohorte",
            size: "Tama\xF1o",
            "still-open": "A\xFAn abiertos",
            "total-closed": "Total cerrado",
            "month-label-current": "M0",
            "month-label": "M+{{n}}",
            "month-tooltip-current": "% del cohorte cerrado dentro del mismo mes de creaci\xF3n.",
            "month-tooltip-one": "% acumulado del cohorte cerrado hasta 1 mes despu\xE9s del de creaci\xF3n.",
            "month-tooltip-many": "% acumulado del cohorte cerrado hasta {{n}} meses despu\xE9s del de creaci\xF3n.",
            "cell-tooltip-current": "Cerrados en {{month}}: {{count}} de {{size}} ({{pct}})",
            "cell-tooltip": "Cerrados hasta {{month}}: {{count}} de {{size}} ({{pct}})"
          }
        },
        "team-extended": {
          title: "Performance por equipo (extendida)",
          column: {
            team: "Equipo",
            handler: "Tramitador",
            handlers: "Tramitadores",
            "handlers-tooltip": "Personas que atendieron reclamos del equipo en el per\xEDodo; es el divisor de la Productividad, no la dotaci\xF3n del equipo. Puede incluir colaboradores y tramitadores que ya no pertenecen al equipo.",
            resolved: "Resueltos",
            productivity: "Productividad",
            "avg-days": "D\xEDas prom.",
            open: "Abiertos",
            aging: "Aging prom.",
            delta: "\u0394 per\xEDodo ant.",
            "delta-tooltip": "Variaci\xF3n porcentual de la productividad del equipo respecto al per\xEDodo anterior seg\xFAn el filtro seleccionado. Verde: mejor\xF3 \xB7 Rojo: empeor\xF3.",
            "drill-down-tooltip": "Ver tramitadores del equipo"
          },
          "show-inactive": "Mostrar {count} equipos sin actividad",
          "hide-inactive": "Ocultar equipos sin actividad",
          hint: "Hac\xE9 click en un equipo para ver la performance de sus tramitadores.",
          empty: "Sin datos para el per\xEDodo seleccionado.",
          error: "No se pudieron cargar los tramitadores del equipo.",
          "drill-down": {
            title: "Performance de tramitadores \xB7 {team}",
            back: "Volver a equipos"
          }
        },
        "focus-explainer": {
          title: "\xBFC\xF3mo se elige el foco?",
          "info-label": "\xBFC\xF3mo se elige el foco?",
          description: "El equipo cuya ca\xEDda de Eficacia operativa le cost\xF3 m\xE1s cierres exitosos a la compa\xF1\xEDa. La pregunta es: \xBFcu\xE1ntos cierres exitosos m\xE1s habr\xEDa tenido este mes si manten\xEDa la eficacia del mes anterior?",
          base: "Se compara as\xED, y no por puntos de ca\xEDda, porque un equipo chico sube y baja varios puntos por el volumen chico de reclamos: una ca\xEDda de 2,5 puntos sobre 1.470 cierres pesa m\xE1s que una de 10 puntos sobre 45. Se comparan los dos \xFAltimos meses completos, porque contra el mes en curso todos los equipos parecer\xEDan haberse desplomado durante los primeros d\xEDas."
        },
        "vs-previous-month": "vs mes ant."
      }
    };
    var team_management = {
      nav: "Gesti\xF3n de equipo",
      title: "Gesti\xF3n de equipo",
      "scope-hint": "Coordinadores ven sus equipos. Administradores pueden elegir cualquier equipo.",
      header: {
        members: "{{count}} miembros",
        "open-claims": "{{count}} reclamos abiertos",
        snapshot: "Foto actual"
      },
      summary: {
        active: "Activos",
        "active-hint": "de {{total}} miembros",
        paused: "Activos no disponibles",
        "paused-hint": "sin recibir reclamos nuevos",
        inactive: "Inactivos no disponibles",
        "inactive-hint": "pr\xF3ximo regreso el {{date}}",
        "inactive-empty": "sin licencias en curso",
        scheduled: "Inactividades programadas",
        "scheduled-hint": "pr\xF3ximo inicio el {{date}}",
        "scheduled-empty": "sin licencias programadas",
        overloaded: "Usuarios sobrecargados",
        "overloaded-hint": "sobre su carga habitual"
      },
      thresholds: "Carga habitual: {{median}} \xB7 Alto desde {{high}} \xB7 Sobrepasado desde {{overloaded}}",
      "thresholds-empty": "Sin tramitadores activos para calcular la carga habitual.",
      "thresholds-per-team": "Cada miembro se compara con la carga habitual de su equipo: Alto desde un {{high}}% m\xE1s, Sobrepasado desde un {{overloaded}}% m\xE1s.",
      "thresholds-show": "Ver la carga habitual de los {{count}} equipos",
      "thresholds-dialog": {
        title: "Carga habitual por equipo",
        description: "Cada miembro se compara con la carga habitual de los tramitadores activos de su equipo, sin contar al coordinador. Es Alto desde un {{high}}% m\xE1s y Sobrepasado desde un {{overloaded}}% m\xE1s.",
        median: "Carga habitual {{median}}",
        high: "Alto desde {{value}}",
        overloaded: "Sobrepasado desde {{value}}"
      },
      empty: {
        title: "No hay equipos para gestionar",
        description: "La compa\xF1\xEDa todav\xEDa no tiene equipos configurados."
      },
      members: {
        title: "Usuarios",
        "title-team": "Usuarios - {{team}}",
        hint: "Ordenado por cr\xEDticos >90d. Click en un miembro para ver sus reclamos.",
        search: "Buscar tramitador",
        empty: "Ning\xFAn miembro coincide con la b\xFAsqueda.",
        "empty-scope": "No hay miembros en este alcance.",
        coordinator: "Coordinador",
        days: "{{value}} d",
        columns: {
          member: "Ordenar por tramitador",
          team: "Equipo",
          state: "Estado",
          assignments: "Operativo",
          open: "Abiertos",
          load: "Carga",
          aging: "Aging prom.",
          critical: "Cr\xEDticos",
          "critical-hint": "Reclamos abiertos hace m\xE1s de {{days}} d\xEDas",
          actions: "Acciones"
        },
        state: {
          active: "Activo",
          inactive: "Inactivo"
        },
        "teams-more": "+{{count}}",
        assignments: {
          available: "Disponible",
          unavailable: "No disponible",
          "paused-today": "No recibe reclamos nuevos desde hoy",
          "paused-one-day": "No recibe reclamos nuevos desde hace 1 d\xEDa",
          "paused-days": "No recibe reclamos nuevos desde hace {{days}} d\xEDas",
          "inactive-hint": "En inactividad: no recibe reclamos",
          "paused-toast": "{{name}} no recibir\xE1 reclamos nuevos",
          "resumed-toast": "{{name}} volver\xE1 a estar disponible para recibir reclamos nuevos"
        },
        load: {
          normal: "Normal",
          high: "Alto",
          overloaded: "Sobrepasado",
          median: "Carga habitual de su equipo: {{median}}",
          hint: "{{level}} \xB7 Carga habitual de su equipo: {{median}}",
          "team-hint": "{{team}} \xB7 {{level}} \xB7 Carga habitual: {{median}}",
          "team-hint-empty": "{{team}} \xB7 Sin tramitadores activos para calcular la carga habitual."
        },
        "excess-critical": "Tiene un {{percent}}% m\xE1s de cr\xEDticos que lo habitual en su equipo, o m\xE1s",
        "unmanaged-claims": "{{count}} son de equipos que no gestion\xE1s: no vas a poder reasignarlos.",
        "schedule-inactivity": "Programar inactividad",
        actions: {
          open: "Ver detalle",
          pause: "Marcar no disponible",
          resume: "Marcar disponible"
        },
        "scheduled-delegation": "Delegaci\xF3n programada",
        "returned-without-claims": "Volvi\xF3 de su inactividad sin reclamos asignados. Entr\xE1 a su detalle para recuperar los que deleg\xF3."
      },
      "member-dialog": {
        kpis: {
          open: "Abiertos",
          aging: "Aging prom.",
          critical: "Cr\xEDticos"
        },
        banner: {
          inactive: "Inactivo",
          scheduled: "Inactividad programada",
          period: "{{title}} del {{from}} al {{to}}",
          since: "{{title}} desde el {{from}}, sin fecha de regreso",
          until: "{{title}} hasta el {{to}}",
          reason: "\xB7 Motivo: {{reason}}.",
          "inactive-hint": "Las notificaciones de sus reclamos las recibe el coordinador del equipo.",
          "scheduled-hint": "Sigue recibiendo y trabajando reclamos hasta que empiece."
        },
        inactivity: {
          edit: "Editar fechas",
          cancel: "Cancelar inactividad",
          "change-return": "Cambiar fecha de regreso",
          "end-now": "Finalizar ahora",
          save: "Guardar",
          discard: "Descartar",
          back: "Volver",
          "cancel-confirm": "\xBFCancelar la inactividad de {{name}} del {{from}} al {{to}}?",
          "cancel-confirm-hint": "Sigue activo y, si hab\xEDa dejado de recibir reclamos nuevos para esta inactividad, vuelve a estar disponible.",
          "end-confirm-title": "Finalizar inactividad",
          "end-confirm": "\xBFFinalizar ahora la inactividad de {{name}}?",
          "end-confirm-hint": "Vuelve a activo y disponible en el momento. Los reclamos que deleg\xF3 siguen con quienes los recibieron.",
          "toast-rescheduled": "Inactividad de {{name}} actualizada",
          "toast-started": "{{name}} pas\xF3 a inactivo",
          "toast-return-changed": "Fecha de regreso de {{name}} actualizada",
          "toast-cancelled": "Inactividad de {{name}} cancelada",
          "toast-ended": "{{name}} volvi\xF3 a activo"
        },
        tabs: {
          responsible: "Responsable",
          delegated: "Delegados",
          derived: "Derivados"
        },
        search: "Buscar por n\xFAmero de reclamo",
        "all-stages": "Todas las etapas",
        "all-statuses": "Todos los estados",
        "no-stage": "Sin etapa",
        "option-count": "{{label}} ({{count}})",
        columns: {
          claim: "Reclamo",
          damage: "Tipo de da\xF1o",
          stage: "Etapa",
          status: "Estado",
          aging: "Aging",
          "offer-cap": "Tope"
        },
        unmanaged: "Equipo {{team}}: no lo gestion\xE1s",
        empty: "No es responsable de reclamos abiertos.",
        "empty-filtered": "Ning\xFAn reclamo coincide con los filtros.",
        "claims-not-readable": "Tu rol no permite ver los reclamos de otros miembros.",
        "select-all": "Seleccionar todos",
        "select-claim": "Seleccionar reclamo",
        "not-reassignable": "Equipo {{team}}: no pod\xE9s reasignarlo",
        "no-team": "Sin equipo",
        selection: {
          count: "{{count}} reclamos seleccionados",
          "count-one": "1 reclamo seleccionado",
          reassign: "Reasignar seleccionados",
          "mixed-teams": "Seleccion\xE1 reclamos de un mismo equipo"
        },
        delegation: {
          review: "Revisar distribuci\xF3n",
          "delegate-uncovered": "Delegar ahora",
          "delegate-all": "Delegar reclamos",
          scheduled: "Tiene una delegaci\xF3n programada de {{claims}}.",
          unplanned: "Sus reclamos no tienen una distribuci\xF3n programada.",
          uncovered: "Tiene {{claims}} en su poder sin delegar."
        },
        delegations: {
          received: "Recibidos",
          "received-hint": "Reclamos que otros le delegaron",
          delegated: "Delegados",
          "delegated-hint": "Reclamos que deleg\xF3 y hoy tiene otra persona",
          empty: "Sin reclamos",
          columns: {
            claim: "Reclamo",
            "delegated-at": "Fecha delegado",
            owner: "Tramitador original",
            "owner-team": "Equipo original",
            holder: "Responsable actual",
            "holder-team": "Equipo actual",
            action: "Acci\xF3n"
          },
          return: "Retornar",
          "return-selected": "Retornar seleccionados",
          recover: "Recuperar",
          "recover-selected": "Recuperar seleccionados",
          "open-derivation": "Con derivaci\xF3n abierta",
          "open-derivation-hint": "Se deriv\xF3 despu\xE9s de delegarlo. Se puede recuperar cuando retornen la derivaci\xF3n.",
          "recover-unavailable": "Se habilita cuando est\xE9 activo y disponible",
          "owner-inactive": "Inactivo",
          "no-holder": "Sin responsable"
        },
        derivations: {
          received: "Recibidos",
          "received-hint": "Reclamos que tiene por una derivaci\xF3n abierta",
          "not-returnable": "Lo tiene en un equipo que no coordin\xE1s: lo retorna su coordinador o desde el reclamo.",
          given: "Derivados",
          "given-hint": "Reclamos que deriv\xF3 y hoy tiene otra persona",
          "not-recoverable": "Lo deriv\xF3 desde un equipo que no coordin\xE1s: lo recupera su coordinador.",
          columns: {
            claim: "Reclamo",
            "derived-at": "Fecha derivado",
            deriver: "Tramitador original",
            "deriver-team": "Equipo original"
          }
        }
      },
      "derivation-recovery-dialog": {
        title: "Recuperar reclamos derivados",
        description: "Se le sacan a quien los tiene hoy, que recibe un aviso, y vuelven a {{name}} y a su equipo, con el estado que ten\xEDan antes de la derivaci\xF3n y su SLA reanudado. No se comunica nada al tercero.",
        reason: "Motivo",
        "reason-placeholder": "Queda en la actividad de cada reclamo",
        "deriver-paused": "({{name}} no est\xE1 disponible)",
        "substitute-hint": "Como {{name}} no est\xE1 activo y disponible, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y queda delegado: lo recupera cuando vuelva.",
        skipped: "{{claims}} ya no estaban derivados por esta persona y quedaron como estaban."
      },
      "derived-claims-dialog": {
        title: "Retornar reclamos derivados",
        description: "Vuelven a quien los deriv\xF3 y a su equipo, con el estado que ten\xEDan antes de la derivaci\xF3n y su SLA reanudado. No se comunica nada al tercero.",
        "absent-hint": "Con quien deriv\xF3 inactivo, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y queda delegado: lo recupera cuando vuelva.",
        comment: "Comentario (opcional)",
        "comment-placeholder": "Queda en la actividad de cada reclamo",
        toast: "Se retornaron {{claims}}",
        skipped: "{{claims}} ya no estaban derivados a esta persona y quedaron como estaban."
      },
      "delegated-claims-dialog": {
        "return-title": "Retornar reclamos delegados",
        "recover-title": "Recuperar reclamos delegados",
        "return-description": "Vuelven a quien los deleg\xF3 y a su equipo, y la delegaci\xF3n se cierra.",
        "recover-description": "Vuelven a {{name}} y la delegaci\xF3n se cierra. Quien los tiene hoy recibe un aviso.",
        columns: {
          claim: "Reclamo",
          holder: "Hoy lo tiene",
          to: "Vuelve a"
        },
        "owner-inactive": "({{name}} est\xE1 en inactividad)",
        "redelegated-hint": "Con el due\xF1o inactivo, el reclamo va a otro tramitador de su equipo, en el mismo orden que los reclamos nuevos, y sigue delegado: lo recupera cuando vuelva.",
        "no-destination": "Nadie de su equipo puede recibirlo: queda con {{name}}",
        cancel: "Cancelar",
        "return-confirm": "Retornar {{claims}}",
        "recover-confirm": "Recuperar {{claims}}",
        "return-toast": "Se retornaron {{claims}}",
        "recover-toast": "{{name}} recuper\xF3 {{claims}}"
      },
      "account-notice": {
        title: "No est\xE1s recibiendo reclamos nuevos desde el {{date}}",
        hint: "Segu\xEDs trabajando tus reclamos y recibiendo sus notificaciones. Tu coordinador puede volver a habilitarte."
      },
      reassign: {
        title: "Reasignar reclamos",
        description: {
          reassigning: "Est\xE1s reasignando",
          from: "de",
          "pick-target": "Eleg\xED un nuevo responsable dentro del equipo"
        },
        claims: "{{count}} reclamos",
        "claims-one": "1 reclamo",
        target: "Destino",
        "candidate-stats": "{{open}} abiertos \xB7 aging {{aging}} \xB7 {{critical}} cr\xEDticos",
        empty: "No hay otros miembros activos y disponibles en el equipo.",
        footer: "La reasignaci\xF3n es inmediata y queda registrada en la Actividad de cada reclamo.",
        cancel: "Cancelar",
        confirm: "Reasignar {{claims}}",
        toast: "{{claims}} reasignados a {{target}}",
        "toast-one": "1 reclamo reasignado a {{target}}"
      },
      activity: {
        title: "Actividad",
        subtitle: "Reasignaciones, disponibilidad, inactividades, delegaciones, derivaciones y retornos",
        empty: "Todav\xEDa no hay actividad en los equipos seleccionados.",
        "empty-category": "No hay actividad de este tipo en los equipos seleccionados.",
        categories: {
          all: "Todos los eventos",
          reassignments: "Reasignaciones",
          availability: "Disponibilidad",
          inactivities: "Inactividades",
          delegations: "Delegaciones",
          derivations: "Derivaciones"
        },
        "claims-mention": "los reclamos {{claims}}",
        "claims-mention-one": "el reclamo {{claims}}",
        "claims-more": "y {{count}} m\xE1s",
        "claims-gone": "reclamos que ya no existen",
        "delegated-claims": "Reclamos delegados: {{claims}}",
        "system-author": "Piramid",
        team_claims_reassigned: "{{author}} reasign\xF3 {{claims}} de {{from}} a {{to}}",
        "user-assignments": "{{author}} marc\xF3 como {{state}} a {{user}}",
        "paused-state": "no disponible",
        "resumed-state": "disponible",
        user_inactivity_scheduled: "Se program\xF3 inactividad de {{user}} del {{from}} al {{to}} \xB7 {{reason}} \xB7 {{delegation}}",
        "without-delegation": "sin delegar",
        "delegation-delegated": "{{count}} reclamos delegados a {{recipients}}",
        "delegation-delegated-one": "1 reclamo delegado a {{recipients}}",
        "delegation-recipients": "{{count}} tramitadores",
        "delegation-recipients-one": "1 tramitador",
        "delegation-returned": "{{count}} retornados",
        "delegation-returned-one": "1 retornado",
        "delegation-kept": "{{count}} mantenidos",
        "delegation-kept-one": "1 mantenido",
        user_inactivity_started: "{{user}} pas\xF3 a inactivo \xB7 vuelve el {{date}}",
        "user_inactivity_started-no-return": "{{user}} pas\xF3 a inactivo",
        user_inactivity_ended: "{{user}} volvi\xF3 a activo",
        "user_inactivity_ended-by": "{{author}} finaliz\xF3 la inactividad de {{user}} \xB7 volvi\xF3 a activo",
        user_inactivity_rescheduled: "{{author}} modific\xF3 la inactividad de {{user}}: {{previous}} \u2192 {{current}}",
        "reason-change": " \xB7 motivo: {{previous}} \u2192 {{current}}",
        period: "{{from}} al {{to}}",
        user_inactivity_return_changed: "{{author}} cambi\xF3 la fecha de regreso de {{user}}: {{previous}} \u2192 {{current}}",
        "no-return": "sin fecha",
        user_inactivity_cancelled: "{{author}} cancel\xF3 la inactividad programada de {{user}}",
        today: "Hoy, {{time}}",
        yesterday: "Ayer, {{time}}",
        user_inactivity_claims_delegated: "Se delegaron los reclamos de {{user}} \xB7 {{delegation}}",
        "user_inactivity_claims_delegated-by": "{{author}} deleg\xF3 los reclamos de {{user}} \xB7 {{delegation}}",
        "user_inactivity_claims_delegated-own": "{{user}} deleg\xF3 sus reclamos \xB7 {{delegation}}",
        user_inactivity_delegation_updated: "{{author}} actualiz\xF3 la delegaci\xF3n de {{user}} \xB7 {{delegation}}",
        user_inactivity_delegation_discarded: "{{author}} dej\xF3 sin delegar los reclamos de {{user}}",
        "pending-recovery": " \xB7 {{count}} reclamos delegados para recuperar",
        "pending-recovery-one": " \xB7 1 reclamo delegado para recuperar",
        "recover-link": "Recuperar sus reclamos delegados",
        user_delegated_claims_recovered: "{{author}} le recuper\xF3 {{claims}} a {{holder}} del tramitador {{user}}",
        "user_delegated_claims_recovered-unknown-holder": "{{author}} recuper\xF3 {{claims}} del tramitador {{user}}",
        "user_delegated_claims_recovered-own": "{{user}} recuper\xF3 {{claims}} que ten\xEDa {{holder}}",
        "user_delegated_claims_returned-to": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a {{to}}",
        "user_delegated_claims_returned-to-redelegated": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a {{to}} porque el tramitador {{owner}} est\xE1 inactivo",
        "user_delegated_claims_returned-owner": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} a su due\xF1o",
        "user_delegated_claims_returned-owner-redelegated": "{{author}} retorn\xF3 {{claims}} que ten\xEDa {{user}} al equipo de su due\xF1o, que est\xE1 inactivo",
        user_derived_claims_returned: "{{author}} retorn\xF3 la derivaci\xF3n de {{claims}} que ten\xEDa {{user}} a {{to}}",
        user_derived_claims_recovered: "{{author}} recuper\xF3 {{claims}} que deriv\xF3 {{user}} \xB7 motivo: {{reason}}"
      },
      pagination: {
        page: "P\xE1gina {{page}} de {{pages}}",
        previous: "\u2039 Anteriores",
        next: "Siguientes \u203A"
      },
      "inactivity-reasons": {
        medical_leave: "Licencia m\xE9dica",
        vacation: "Vacaciones",
        study_day: "D\xEDa de estudio",
        training: "Capacitaci\xF3n / evento",
        personal_leave: "Licencia personal",
        other: "Otro",
        none: "Sin motivo"
      },
      leaves: {
        title: "Licencias",
        subtitle: "D\xEDas de inactividad en el a\xF1o calendario, incluidas las en curso y programadas",
        year: "A\xF1o calendario",
        days: "{{count}} d",
        segment: "{{reason}}: {{count}} d\xEDas",
        "segment-one": "{{reason}}: 1 d\xEDa",
        "without-leaves": "{{count}} miembros sin licencias en {{year}}",
        "without-leaves-one": "1 miembro sin licencias en {{year}}",
        empty: "Sin licencias en {{year}}"
      },
      "schedule-inactivity": {
        title: "Programar inactividad",
        description: "Defin\xED el per\xEDodo en el que {{name}} no estar\xE1 operativo. Durante ese rango no se le asignan reclamos nuevos.",
        steps: {
          period: "Per\xEDodo",
          delegate: "Delegar reclamos"
        },
        from: "Desde",
        to: "Hasta",
        reason: "Motivo",
        "reason-placeholder": "Eleg\xED un motivo",
        "reason-hint": "Se guarda como referencia para la Actividad del equipo. No se le notifica al tramitador.",
        "pause-now": "Dejar de asignarle reclamos nuevos desde hoy",
        "pause-now-hint": "Queda No disponible desde ahora hasta que empiece la inactividad.",
        days: "{{count}} d\xEDas",
        "days-one": "1 d\xEDa",
        "open-claims": "{{count}} reclamos abiertos",
        "open-claims-one": "1 reclamo abierto",
        summary: "{{name}} tiene {{claims}} asignados. Pod\xE9s programar sin delegar o pasar a delegar sus reclamos.",
        "summary-one": "{{name}} tiene {{claims}} asignado. Pod\xE9s programar sin delegar o pasar a delegar sus reclamos.",
        cancel: "Cancelar",
        schedule: "Programar sin delegar",
        delegate: "Delegar reclamos",
        required: "Complet\xE1 este campo",
        "from-before-today": "Eleg\xED hoy o una fecha posterior",
        "to-before-from": "Tiene que ser igual o posterior a Desde",
        "toast-started": "{{name}} pas\xF3 a inactivo",
        "toast-scheduled": "Inactividad programada para {{name}} desde el {{date}}",
        "toast-delegation": "Al empezar: {{delegation}}",
        delegation: {
          description: "Eleg\xED qu\xE9 pasa con sus reclamos durante el per\xEDodo de inactividad.",
          mode: "Distribuci\xF3n",
          modes: {
            automatic: "Autom\xE1tico",
            manual: "Manual"
          },
          "mode-hints": {
            automatic: "Los reclamos se reparten entre los tramitadores disponibles del equipo, en el mismo orden que los reclamos nuevos. El coordinador recibe solo si no queda nadie m\xE1s.",
            manual: "Eleg\xEDs a qui\xE9n va cada reclamo. Los que no definas se mantienen con el tramitador."
          },
          "by-load": "Hacer la delegaci\xF3n de acuerdo a la carga de los tramitadores disponibles",
          "by-load-hint": "Cada reclamo va al tramitador que menos abiertos tiene en ese momento. Quien ya tiene m\xE1s carga que el resto no recibe.",
          include: "Qu\xE9 incluir",
          categories: {
            own: "Reclamos propios",
            delegated: "Delegados recibidos",
            derived: "Derivados recibidos"
          },
          "own-hint": "Se delegan temporalmente. El tramitador sigue siendo el due\xF1o y los recupera cuando vuelve.",
          "delegated-returning": "{{count}} vuelven a quien se los deleg\xF3, que est\xE1 activo durante el per\xEDodo.",
          "delegated-returning-one": "1 vuelve a quien se lo deleg\xF3, que est\xE1 activo durante el per\xEDodo.",
          "delegated-staying": "{{count}} se delegan a otro del equipo porque quien se los deleg\xF3 no est\xE1 activo durante el per\xEDodo.",
          "delegated-staying-one": "1 se delega a otro del equipo porque quien se lo deleg\xF3 no est\xE1 activo durante el per\xEDodo.",
          "derived-hint": "Se delegan a otro tramitador del equipo receptor. La derivaci\xF3n sigue abierta y, cuando se retorne, vuelve a quien lo deriv\xF3.",
          distribution: "Distribuci\xF3n estimada",
          columns: {
            member: "Tramitador",
            open: "Abiertos hoy",
            total: "Carga total",
            "total-hint": "Abiertos hoy m\xE1s los que recibe en esta distribuci\xF3n",
            load: "Carga",
            owner: "Titular",
            claims: "Reclamos"
          },
          returning: "Vuelven a su titular",
          members: "{{count}} tramitadores",
          "members-one": "1 tramitador",
          overloaded: "No reciben {{members}} que ya tienen m\xE1s carga que el resto.",
          "overloaded-one": "No recibe {{members}} que ya tiene m\xE1s carga que el resto.",
          unavailable: "No participan {{members}} no disponibles.",
          "unavailable-one": "No participa {{members}} no disponible.",
          kept: "Nadie del equipo puede recibir {{claims}}: quedan con {{name}}",
          "without-team": "{{claims}} sin equipo quedan con {{name}}",
          empty: "No hay reclamos para delegar.",
          back: "Volver",
          confirm: "Confirmar y programar",
          manual: {
            progress: "{{defined}} de {{total}} reclamos con destino definido",
            "progress-hint": "Eleg\xED qu\xE9 pasa con cada reclamo. Los que no definas se mantienen con {{name}}.",
            search: "Buscar por n\xFAmero de reclamo",
            columns: {
              claim: "Reclamo",
              origin: "Origen",
              status: "Estado",
              aging: "Aging",
              destination: "Destino"
            },
            origins: {
              own: "Propio",
              delegated: "Delegado recibido",
              derived: "Derivado recibido"
            },
            from: "de {{name}}",
            "from-team": "de {{name}} \xB7 {{team}}",
            placeholder: "Elegir destino...",
            keep: "Mantener con {{name}}",
            return: "Retornar a {{name}}",
            candidate: "{{name}} \xB7 {{count}} abiertos",
            coordinator: "{{name}} (Coord.)",
            pending: "{{count}} reclamos sin destino se mantienen con el tramitador",
            "pending-one": "1 reclamo sin destino se mantiene con el tramitador",
            "empty-filtered": "Ning\xFAn reclamo coincide con la b\xFAsqueda.",
            new: "Nuevo",
            "new-undefined": "Nuevo \xB7 sin definir"
          }
        }
      },
      "manage-link": "Programar en Gesti\xF3n de equipo",
      "linked-member-not-found": {
        title: "No est\xE1 en tus equipos",
        description: "El usuario no forma parte de los equipos que gestion\xE1s."
      },
      "own-inactivity": {
        title: "Inactividad",
        "managed-by-coordinator": "La inactividad la gestiona tu coordinador",
        "managed-by-you": "Program\xE1 o cambi\xE1 tu inactividad desde Gesti\xF3n de equipo",
        inactivity: "Inactividad",
        none: "No ten\xE9s una inactividad programada ni en curso.",
        assignments: "Reclamos nuevos",
        receiving: "Est\xE1s recibiendo reclamos nuevos"
      },
      "own-delegations": {
        title: "Reclamos delegados",
        description: "Los reclamos que delegaste y qui\xE9n los tiene hoy. Cuando vuelvas, recuperalos desde ac\xE1.",
        section: "Delegados",
        "section-hint": "Reclamos que delegaste y hoy tiene otra persona",
        "recover-unavailable": "Se habilita cuando est\xE9s activo y disponible",
        "recover-description": "Vuelven a vos y la delegaci\xF3n se cierra. Quien los tiene hoy recibe un aviso.",
        "recover-toast": "Recuperaste {{claims}}",
        delegate: "Delegar reclamos",
        "delegate-title": "Delegar tus reclamos",
        "delegate-description": "Tus reclamos abiertos se reparten entre los tramitadores disponibles de tu equipo, en el mismo orden que los reclamos nuevos. Los que te delegaron vuelven a su due\xF1o si est\xE1 activo.",
        "delegate-plan": "Se van a mover: {{delegation}}.",
        "delegate-nothing": "No ten\xE9s reclamos abiertos para delegar.",
        "delegate-confirm": "Delegar",
        "delegate-toast": "Delegando tus reclamos",
        "delegate-toast-description": "{{delegation}}. La lista se actualiza cuando termine.",
        delegating: "Delegando\u2026"
      },
      "delegation-dialog": {
        "review-title": "Revisar distribuci\xF3n",
        "review-starts-tomorrow": "Ma\xF1ana empieza la inactividad de {{name}}.",
        "review-starts-on": "La inactividad de {{name}} empieza el {{date}}.",
        "review-scheduled-on": "La inactividad programada el {{planned}} para {{name}} empieza el {{date}}.",
        "review-scheduled-tomorrow": "La inactividad programada el {{planned}} para {{name}} empieza ma\xF1ana.",
        "review-load-changed": "Al programarla ten\xEDa {{planned}}; hoy tiene {{current}}.",
        "review-unplanned": "Se program\xF3 sin delegar: pod\xE9s definir la distribuci\xF3n de sus reclamos antes de que se ejecute.",
        cancel: "Cancelar",
        "leave-undelegated": "Dejar sin delegar",
        save: "Guardar distribuci\xF3n",
        "toast-saved": "Distribuci\xF3n de {{name}} actualizada",
        "toast-discarded": "Los reclamos de {{name}} quedan sin delegar",
        "delegate-title": "Delegar reclamos",
        "delegate-uncovered": "{{name}} est\xE1 inactivo y tiene {{claims}} en su poder sin delegar.",
        "delegate-all": "{{name}} est\xE1 inactivo. Sus reclamos se delegan en el momento.",
        "delegate-now": "Delegar ahora",
        "toast-delegated": "Se est\xE1n delegando los reclamos de {{name}}"
      },
      "delegation-notices": {
        "review-starts-tomorrow": "Ma\xF1ana empieza la inactividad de {{name}}.",
        "review-starts-on": "El {{date}} empieza la inactividad de {{name}}.",
        "review-load-changed": "Su carga cambi\xF3 desde que la programaste ({{planned}} \u2192 {{current}} reclamos).",
        "review-hint": "Pod\xE9s revisar la distribuci\xF3n de sus reclamos antes de que se ejecute.",
        "review-action": "Revisar distribuci\xF3n",
        uncovered: "{{name}} est\xE1 inactivo y tiene {{claims}} en su poder sin delegar.",
        "uncovered-action": "Delegar ahora",
        dismiss: "Cerrar aviso"
      }
    };
    var claims_table = {
      customer_organization: "Empresa Customer",
      fraud_status: "Estado de fraude",
      notifications: "Notificaciones",
      last_user_activity: "\xDAltima actividad",
      no_unread_notifications: "Sin notificaciones pendientes",
      mark_all_read: "Marcar todo como le\xEDdo"
    };
    var review = {
      form: {
        title: "\xBFC\xF3mo calificarias tu experiencia completando el formulario?",
        subtitle: "Tu opini\xF3n nos ayuda a mejorar la experiencia de nuestros usuarios.",
        commentLabel: "\xBFQuieres contarnos m\xE1s sobre tu experiencia?",
        commentPlaceholder: "M\xE1x. {{max}} caracteres",
        submit: "Enviar",
        skip: "Omitir"
      },
      resolution: {
        title: "Califica tu experiencia con Piramid en la resoluci\xF3n de tu reclamo.",
        subtitle: "Tu opini\xF3n nos ayuda a mejorar la experiencia de nuestros usuarios.",
        commentLabel: "\xBFQuieres contarnos m\xE1s sobre tu experiencia?",
        commentPlaceholder: "M\xE1x. {{max}} caracteres",
        submit: "Enviar",
        thanksTitle: "\xA1Gracias!",
        thanksBody: "Tu opini\xF3n nos ayuda a mejorar.",
        alreadyAnswered: "Ya registramos tu respuesta. \xA1Gracias!",
        invalid: "Este enlace no es v\xE1lido o expir\xF3."
      }
    };
    var reviews = {
      title: "Rese\xF1as",
      description: "Satisfacci\xF3n de los usuarios seg\xFAn sus rese\xF1as.",
      distribution: {
        title: "Distribuci\xF3n de puntajes",
        total: "Rese\xF1as",
        claims_created: "Reclamos creados en el per\xEDodo",
        average: "Promedio",
        score: "Puntaje",
        empty: "No hay rese\xF1as en el per\xEDodo seleccionado."
      },
      export: {
        button: "Descargar CSV",
        tooltip: "Descarga las rese\xF1as para analizarlas con tu LLM. Pr\xF3ximamente podr\xE1s hacerlo con RavelAI.",
        error: "No se pudieron exportar las rese\xF1as."
      },
      table: {
        title: "Rese\xF1as",
        search_placeholder: "Buscar por email del reclamante...",
        entity_label: "Rese\xF1as",
        comment_modal_title: "Comentario",
        score_filter: {
          placeholder: "Puntaje",
          all: "Todas"
        },
        type_filter: {
          placeholder: "Tipo de rese\xF1a",
          all: "Todos"
        },
        columns: {
          email: "Email",
          type: "Tipo",
          score: "Puntaje",
          claim_type: "Tipo de reclamo",
          third_party_relationship: "Tipo de reclamante",
          zone: "Zona",
          time: "Tiempo",
          comment: "Comentario",
          answered: "Respondida",
          more: "M\xE1s datos",
          handler: "Tramitador",
          claims_count: "Reclamos"
        },
        third_party_relationship: {
          particular: "Particular"
        },
        summary: {
          requested: "Rese\xF1as solicitadas",
          answered: "Rese\xF1as respondidas"
        },
        more_modal: {
          trigger: "Ver",
          title: "Datos del reclamo",
          external_claim_id: "Nro Reclamo externo",
          ref_id: "RefID",
          claim_id: "ID del reclamo",
          sinister_id: "ID del siniestro",
          recording_id: "Recording ID",
          company: "Empresa",
          date: "Fecha",
          detail_link: "Ver detalle en Piramid"
        }
      },
      type: {
        claim_creation_form: "Formulario de creaci\xF3n",
        claim_resolution: "Resoluci\xF3n de reclamo"
      },
      review: {
        title: "Impacto al Cliente",
        subtitle: {
          form: "Rese\xF1as del formulario de creaci\xF3n (CES).",
          close: "Rese\xF1as post-cierre del reclamo (CSAT)."
        },
        tabs: {
          form: "Valoraci\xF3n Formulario",
          close: "Valoraci\xF3n de Resoluci\xF3n"
        },
        filters: {
          claim_type: "Tipo de reclamo",
          team: "Equipo",
          zone: "Zona",
          all_types: "Todos los tipos",
          all_teams: "Todos los equipos",
          all_zones: "Todas las zonas",
          all_relationships: "Todos los reclamantes",
          all_insured: "Socios y no socios",
          insured: "Solo socios",
          not_insured: "Solo no socios",
          all_handlers: "Todos los tramitadores",
          all_cities: "Todas las ciudades",
          search: "Buscar\u2026",
          empty: "Sin resultados",
          selected: "{{count}} seleccionados",
          clear: "Limpiar",
          clear_all: "Limpiar filtros"
        },
        kpis: {
          previous_month: "mes anterior: {{value}}",
          no_comparable: "sin mes anterior comparable",
          empty: "Sin datos en el per\xEDodo",
          score_avg: {
            label: "Score promedio",
            footnote: "Sobre {{count}} respuestas del mes \xB7 escala 1 a 5"
          },
          response_rate: {
            label: "Tasa de respuesta",
            footnote_form: "{{respondents}} respondidas / {{universe}} creados en el mes",
            footnote_close: "{{respondents}} respondidas / {{universe}} enviadas en el mes"
          },
          detractors: {
            label: "Detractores",
            footnote: "{{count}} personas puntuaron 1 o 2 en el mes"
          },
          satisfied: {
            label: "Satisfechos",
            footnote: "{{count}} puntuaron 3, 4 o 5 en el mes \xB7 {{noReply}} sin responder"
          }
        },
        states: {
          empty: "Sin datos en el per\xEDodo"
        },
        distribution: {
          title: "Distribuci\xF3n de puntajes",
          subtitle: "Distribuci\xF3n de las respuestas del per\xEDodo seleccionado",
          tooltip: "Al hacer clic en un puntaje del gr\xE1fico o en la leyenda, se filtra la tabla de rese\xF1as de abajo por esa valoraci\xF3n. Volv\xE9 a hacer clic para quitar el filtro.",
          stats: {
            reviews: "Rese\xF1as",
            avg: "Promedio",
            universe: {
              form: "Reclamos creados",
              close: "Encuestas enviadas"
            }
          },
          includeNoReply: "Incluir no respondidas en los porcentajes",
          noReply: "Sin respuesta"
        },
        monthly: {
          title: "Evoluci\xF3n mensual",
          subtitle: "Volumen por puntaje seg\xFAn el per\xEDodo seleccionado",
          absolutes: "Absoluto",
          percentage: "Porcentaje",
          tooltip: "Total: {{total}} \xB7 Promedio: {{avg}}"
        },
        heatmap: {
          title: "Score por dimensi\xF3n",
          subtitle: "Detect\xE1 d\xF3nde bajan los puntajes seg\xFAn cada dimensi\xF3n",
          dim: {
            type: "Tipo de reclamo",
            team: "Equipo",
            zone: "Zona",
            outcome: "Desenlace",
            relationship: "Tipo de reclamante"
          },
          col: {
            responses: "Respuestas",
            average: "Promedio"
          },
          foot: "La intensidad del color refleja la cantidad de rese\xF1as. Clic en las columnas 1-5 para ordenar."
        },
        resolutionTime: {
          reviews: "{{count}} rese\xF1as",
          title_form: "Score seg\xFAn tiempo de creaci\xF3n",
          subtitle_form: "\xBFLos formularios que llevan m\xE1s tiempo se punt\xFAan peor?",
          foot_form: "Cada barra promedia los puntajes de reclamos cuyo formulario de creaci\xF3n tard\xF3 lo indicado. Correlaci\xF3n: {{max}} \u2192 {{min}}.",
          title_close: "Score seg\xFAn tiempo de resoluci\xF3n",
          subtitle_close: "\xBFLos reclamos que tardan m\xE1s se punt\xFAan peor?",
          foot_close: "Cada barra promedia los puntajes de reclamos con tiempo total (creaci\xF3n \u2192 cierre) dentro del bucket. Correlaci\xF3n: {{max}} \u2192 {{min}}.",
          dim_time: "Por tiempo",
          dim_handler: "Por tramitador",
          title_handler: "Score por tramitador",
          subtitle_handler: "\xBFC\xF3mo punt\xFAan los reclamantes a cada tramitador?",
          foot_handler: "Cada barra promedia los puntajes de las rese\xF1as de los reclamos que tramit\xF3. Ordenado por cantidad de rese\xF1as."
        },
        outcomeDistribution: {
          title: "Distribuci\xF3n de puntajes por desenlace",
          subtitle: "C\xF3mo se distribuye cada valoraci\xF3n seg\xFAn c\xF3mo cerr\xF3 el reclamo"
        },
        keywords: {
          title: "Temas frecuentes en comentarios negativos",
          subtitle: "Palabras m\xE1s repetidas en rese\xF1as con puntaje 1 o 2 ({{count}} comentarios analizados)",
          foot: "An\xE1lisis simple por frecuencia (excluye stopwords). Clic en un tema para filtrar la tabla y ver los comentarios donde aparece."
        },
        reviews: {
          title: "Rese\xF1as",
          subtitle: "Detalle de cada respuesta recibida en el per\xEDodo",
          search: "Buscar por email del reclamante\u2026",
          empty: "Sin rese\xF1as con estos filtros.",
          crossFilter: "Filtrado desde gr\xE1fico: {{label}}",
          filter: {
            rating: "Valoraci\xF3n",
            allRatings: "Todas las valoraciones"
          },
          lead_potencial: {
            label: "Lead Potencial",
            tooltip: "Filtra rese\xF1as con 5 estrellas que adem\xE1s dejaron un comentario, excluyendo a los socios de la compa\xF1\xEDa. \xDAtiles para pedir testimonios o captar clientes.",
            blocked_tooltip: 'No disponible con el filtro "Solo socios": un lead es, por definici\xF3n, alguien que todav\xEDa no es socio de la compa\xF1\xEDa.'
          },
          col: {
            days: "D\xEDas al cierre"
          }
        }
      }
    };
    var home = {
      greeting: {
        morning: "Buenos d\xEDas",
        afternoon: "Buenas tardes",
        evening: "Buenas noches"
      },
      subtitle: "Recib\xED nuevas \xF3rdenes, organiz\xE1 tus tareas y gestion\xE1 cada trabajo desde un solo lugar.",
      invitations: {
        title: "Invitaciones pendientes ({{count}})",
        description: "Ten\xE9s invitaciones de compa\xF1\xEDas esperando tu respuesta.",
        cta: "Ver invitaciones"
      },
      actionRequired: {
        badge: "Acci\xF3n requerida",
        title: "{{count}} \xF3rdenes esperan tu respuesta",
        titleOne: "1 orden espera tu respuesta",
        description: "Aceptalas o rechazalas para que puedan avanzar.",
        cta: "Ver \xF3rdenes pendientes"
      },
      month: {
        title: "Resumen del mes",
        inProgress: "En curso",
        inProgressSub: "Aceptadas y en ejecuci\xF3n",
        completed: "Cerradas este mes",
        rejected: "Rechazadas este mes"
      },
      inbox: {
        title: "Tareas pendientes",
        awaitingInsurer: "{{count}} esperando a la aseguradora",
        empty: "No ten\xE9s acciones pendientes. Todo lo abierto est\xE1 del lado de la aseguradora.",
        seeAll: "Ver todas mis \xF3rdenes"
      },
      activity: {
        title: "Actividad reciente",
        empty: "Todav\xEDa no ten\xE9s novedades.",
        seeAll: "Ver todas las notificaciones"
      }
    };
    var onboarding = {
      title: "Perfil de la empresa",
      description: "Administr\xE1 la informaci\xF3n p\xFAblica y operativa de tu empresa.",
      unavailable: "El perfil de empresa no est\xE1 disponible para esta cuenta.",
      alert: {
        completedTitle: "Perfil completo",
        completedDescription: "La informaci\xF3n de tu empresa est\xE1 actualizada y lista para ser consultada.",
        pendingTitle: "Perfil incompleto",
        pendingDescription: "Complet\xE1 las secciones pendientes para mantener actualizado el perfil de tu empresa.",
        pendingCta: "Completar perfil"
      },
      banner: {
        title: "Complet\xE1 tu perfil",
        progress: "Progreso",
        cta: "Continuar"
      },
      status: {
        completed: "Completo",
        pending: "Pendiente"
      },
      steps: {
        company_data: "Datos de la empresa",
        company_data_subtitle: "Complet\xE1 la informaci\xF3n b\xE1sica de tu empresa.",
        documentation: "Documentaci\xF3n",
        documentation_subtitle: "Sub\xED la documentaci\xF3n requerida para validar tu perfil.",
        capabilities: "Capacidades",
        capabilities_subtitle: "Indic\xE1 los servicios que ofrec\xE9s y los bienes con los que trabaj\xE1s.",
        coverage: "Cobertura",
        coverage_subtitle: "Seleccion\xE1 las zonas donde brind\xE1s tus servicios."
      },
      companyData: {
        logo: "Imagen de perfil de la empresa",
        logoUpdated: "Imagen de perfil actualizada",
        legalName: "Raz\xF3n social",
        legalNamePlaceholder: "Raz\xF3n social de la empresa",
        ein: "CUIT de la empresa",
        einPlaceholder: "CUIT de la empresa",
        firstName: "Nombre responsable",
        firstNamePlaceholder: "Nombre responsable",
        lastName: "Apellido responsable",
        lastNamePlaceholder: "Apellido responsable",
        phone: "Tel\xE9fono de la empresa",
        phonePlaceholder: "Tel\xE9fono de la empresa",
        contactEmail: "Email de la empresa",
        contactEmailPlaceholder: "Email de la empresa",
        address: "Domicilio de la empresa",
        addressPlaceholder: "Domicilio de la empresa",
        locality: "Localidad",
        localityPlaceholder: "Busc\xE1 tu localidad",
        noResults: "No se encontraron resultados",
        description: "Descripci\xF3n de la empresa",
        descriptionPlaceholder: "Descripci\xF3n de la empresa",
        save: "Guardar datos",
        saved: "Datos guardados",
        branches: {
          title: "Sucursales de la empresa",
          description: "La ubicaci\xF3n de tu empresa se determina por sus sucursales. Necesit\xE1s al menos una para completar este paso.",
          emptyTitle: "Todav\xEDa no registraste sucursales",
          empty: "Registr\xE1 al menos una sucursal con su ubicaci\xF3n para completar los datos de la empresa.",
          emptyCta: "Registrar sucursales"
        }
      },
      capabilities: {
        empty: "Todav\xEDa no cargaste capacidades.",
        loading: "Cargando cat\xE1logo\u2026",
        emptyCatalog: "No hay rubros disponibles.",
        noServices: "Sin servicios en este rubro.",
        allGoods: "Todos los bienes",
        someGoods: "{{count}} bien(es) seleccionado(s)",
        verticalPlaceholder: "Eleg\xED un rubro",
        selectVertical: "Eleg\xED tu rubro",
        selectServices: "Eleg\xED tus servicios",
        servicePlaceholder: "Eleg\xED un servicio",
        noResults: "No se encontraron resultados",
        add: "Agregar",
        save: "Guardar capacidades",
        saved: "Capacidades guardadas"
      },
      coverage: {
        empty: "Todav\xEDa no cargaste zonas de cobertura.",
        level: {
          province: "Provincia",
          department: "Departamento",
          locality: "Localidad"
        },
        group: {
          province: "Provincias",
          department: "Departamentos",
          locality: "Localidades"
        },
        searchPlaceholder: {
          province: "Busc\xE1 una provincia",
          department: "Busc\xE1 un departamento",
          locality: "Busc\xE1 una localidad"
        },
        noResults: "No se encontraron resultados",
        add: "Agregar",
        save: "Guardar cobertura",
        saved: "Cobertura guardada"
      }
    };
    var documents = {
      required: "Obligatorio",
      uploadedBadge: "Cargado",
      missing: "Falta cargar",
      view: "Ver",
      replace: "Reemplazar",
      upload: "Subir documento",
      delete: "Eliminar documento",
      uploaded: "Documento subido",
      deleted: "Documento eliminado",
      empty: "No hay documentos solicitados por el momento."
    };
    var documentTypes = {
      title: "Tipos de documentos",
      description: "Cat\xE1logo global de tipos documentales que los proveedores deben cargar.",
      entityLabel: "tipos",
      search: "Buscar por nombre...",
      columns: {
        id: "ID",
        name: "Nombre",
        description: "Descripci\xF3n",
        required: "Obligatorio",
        active: "Activo",
        documents: "Documentos"
      },
      actions: {
        create: "Nuevo tipo",
        edit: "Editar",
        created: "Tipo creado",
        updated: "Tipo actualizado"
      },
      form: {
        name: "Nombre",
        namePlaceholder: "Nombre del tipo de documento",
        description: "Descripci\xF3n",
        descriptionPlaceholder: "Descripci\xF3n del tipo de documento",
        isRequired: "Obligatorio para todos los proveedores",
        isActive: "Activo",
        save: "Guardar",
        cancel: "Cancelar"
      },
      yes: "S\xED",
      no: "No"
    };
    var products = {
      title: "Productos",
      description: "Cat\xE1logo de productos de tu empresa.",
      entityLabel: "productos",
      search: "Buscar por nombre, marca o c\xF3digo SKU...",
      columns: {
        sku: "C\xF3digo SKU",
        name: "Nombre del producto",
        brand: "Marca",
        description: "Descripci\xF3n",
        unit_price: "Precio unitario",
        status: "Estado"
      },
      status: {
        active: "Activo",
        inactive: "Inactivo"
      },
      actions: {
        create: "Nuevo producto",
        edit: "Editar",
        delete: "Eliminar",
        created: "Producto creado",
        updated: "Producto actualizado",
        deleted: "Producto eliminado"
      },
      form: {
        createHint: "Complet\xE1 los datos del producto que quer\xE9s agregar al cat\xE1logo.",
        editHint: "Modific\xE1 los datos del producto.",
        save: "Guardar",
        cancel: "Cancelar",
        activeLabel: "Producto activo",
        activeHint: "Los productos inactivos siguen en el listado, pero no podr\xE1n seleccionarse al crear una orden.",
        placeholders: {
          sku: "COD-1234",
          name: "Nombre del producto",
          brand: "Bosch, Saint-Gobain, ...",
          description: "Detalle o especificaciones del producto",
          unit_price: "$ 0.00"
        }
      },
      detail: {
        title: "Detalle del producto",
        sku: "SKU",
        name: "Nombre",
        brand: "Marca",
        description: "Descripci\xF3n",
        unit_price: "Precio unitario",
        status: "Estado",
        created_at: "Creado el",
        empty: "\u2014"
      },
      remove: {
        title: '\xBFEliminar el producto "{{name}}"?',
        description: "Esta acci\xF3n es irreversible. El producto dejar\xE1 de estar disponible."
      }
    };
    var providerGroups = {
      title: "Grupos de proveedores",
      description: "Agrup\xE1 proveedores de tu red (por zona, categor\xEDa, etc.) para filtrarlos al derivar una orden.",
      entityLabel: "grupos",
      search: "Buscar por nombre...",
      columns: {
        name: "Nombre del grupo",
        description: "Descripci\xF3n",
        member_count: "N\xB0 proveedores",
        members: "Proveedores"
      },
      actions: {
        create: "Nuevo grupo",
        edit: "Editar",
        members: "Miembros",
        delete: "Eliminar",
        created: "Grupo creado",
        updated: "Grupo actualizado",
        deleted: "Grupo eliminado"
      },
      form: {
        createHint: "Complet\xE1 los datos del grupo que quer\xE9s crear.",
        editHint: "Modific\xE1 los datos del grupo.",
        save: "Guardar",
        cancel: "Cancelar",
        placeholders: {
          name: "Nombre del grupo",
          description: "Detalle o notas sobre el grupo"
        }
      },
      members: {
        title: "Miembros del grupo",
        description: "Agreg\xE1 o quit\xE1 proveedores de tu red activa. Solo los proveedores activos pueden formar parte de un grupo. Los cambios se aplican al guardar.",
        pluralLabel: "proveedores",
        placeholder: "Busc\xE1 y agreg\xE1 proveedores",
        empty: "No se encontraron proveedores activos",
        currentTitle: "Proveedores en el grupo",
        emptyList: "A\xFAn no hay proveedores en este grupo",
        save: "Guardar cambios",
        cancel: "Cancelar",
        saved: "Miembros actualizados"
      },
      detail: {
        description: "Detalle del grupo y estado de la red de cada proveedor.",
        membersTitle: "Proveedores en el grupo",
        empty: "Este grupo no tiene proveedores"
      },
      remove: {
        title: '\xBFEliminar el grupo "{{name}}"?',
        description: "Esta acci\xF3n es irreversible. El grupo debe estar vac\xEDo para poder eliminarlo."
      }
    };
    var test_environment = {
      title: "Entorno de prueba",
      description: "Este es un entorno de prueba de Piramid. Los reclamos cargados aqu\xED no se procesan. Si necesitas denunciar un siniestro, comun\xEDcate con tu aseguradora."
    };
    var productImport = {
      title: "Importar productos",
      steps: {
        "1": "Sub\xED un archivo CSV con tu listado de productos.",
        "2": "Eleg\xED qu\xE9 columna del archivo corresponde a cada campo. Las que dejes sin asignar no se importan.",
        "3": "Revis\xE1 el resumen antes de confirmar. Todav\xEDa no se modific\xF3 nada."
      },
      fields: {
        sku: "C\xF3digo SKU",
        name: "Nombre del producto",
        brand: "Marca",
        description: "Descripci\xF3n",
        unit_price: "Precio unitario",
        is_active: "Estado"
      },
      upload: {
        title: "Formato del archivo",
        description: "Aceptamos archivos CSV. Detectamos autom\xE1ticamente el separador (coma, punto y coma o tabulaci\xF3n) y la codificaci\xF3n, as\xED que pod\xE9s guardarlo directo desde Excel o Google Sheets.",
        dropzone: "Arrastr\xE1 el CSV o hac\xE9 clic para elegirlo",
        analyzing: "Analizando el archivo...",
        downloadTemplate: "Descargar plantilla"
      },
      mapping: {
        required: "Obligatorio",
        notImported: "No importar",
        numberFormat: "Formato de los precios",
        numberFormatHint: "En tu archivo: {{ samples }}",
        fileSummary: "{{ file }} \u2014 {{ rows }} fila(s), {{ columns }} columna(s)",
        invalidTitle: "Revis\xE1 el mapeo de columnas"
      },
      summary: {
        toCreate: "Se crear\xE1n",
        toUpdate: "Se actualizar\xE1n",
        errors: "Con errores",
        blankRows: "Filas vac\xEDas",
        readyTitle: "El archivo est\xE1 listo",
        readyDescription: "Se procesar\xE1n {{ total }} fila(s). S\xF3lo se modifican los campos que mapeaste.",
        errorsTitle: "El archivo tiene filas con errores",
        errorsDescription: "{{ errors }} fila(s) no se pueden importar. Correg\xED el archivo y volv\xE9 a subirlo, o import\xE1 s\xF3lo las {{ valid }} fila(s) v\xE1lidas.",
        skipInvalidLabel: "Importar las {{ valid }} filas v\xE1lidas y omitir las {{ errors }} con error",
        skipInvalidHint: "Las filas omitidas quedan registradas en el historial para que puedas corregirlas despu\xE9s."
      },
      errors: {
        title: "Errores de la importaci\xF3n",
        download: "Descargar errores CSV",
        truncated: "Mostrando {{ shown }} de {{ total }} errores (se guardan hasta {{ max }}).",
        columns: {
          row: "Fila",
          sku: "SKU",
          column: "Columna",
          received: "Valor recibido",
          reason: "Motivo"
        }
      },
      rowErrors: {
        empty_required: "Falta un valor obligatorio",
        empty_required_field: "\xAB{{ field }}\xBB es obligatorio y la celda est\xE1 vac\xEDa",
        invalid_number: "\xAB{{ value }}\xBB no es un n\xFAmero v\xE1lido",
        ambiguous_number: "\xAB{{ value }}\xBB no se puede leer con el formato de precios elegido",
        too_many_decimals: "\xAB{{ value }}\xBB tiene m\xE1s de dos decimales",
        invalid_boolean: "\xAB{{ value }}\xBB no es un estado v\xE1lido: us\xE1 SI o NO",
        invalid_value: "\xAB{{ value }}\xBB no es un valor v\xE1lido",
        duplicate_sku_in_file: "El SKU se repite en el archivo",
        sku_deleted: "El SKU corresponde a un producto eliminado",
        sku_already_exists: "Otro proceso cre\xF3 un producto con ese SKU mientras se importaba"
      },
      status: {
        pending: "En cola",
        processing: "Procesando",
        completed: "Completada",
        completed_with_errors: "Completada con errores",
        failed: "Fallida"
      },
      history: {
        title: "Importaciones recientes",
        description: "Historial de importaciones masivas de productos de tu empresa.",
        inProgress: "{{ done }} de {{ total }} procesadas",
        result: "{{ created }} creados, {{ updated }} actualizados, {{ errors }} con error",
        failedFallback: "La importaci\xF3n fall\xF3. Volv\xE9 a subir el archivo.",
        viewErrors: "Ver errores",
        columns: {
          date: "Fecha",
          file: "Archivo",
          status: "Estado",
          result: "Resultado",
          user: "Usuario"
        },
        entityLabel: "importaciones",
        empty: "Todav\xEDa no importaste productos."
      },
      actions: {
        open: "Importar",
        export: "Exportar",
        back: "Volver",
        validate: "Validar archivo",
        confirm: "Confirmar importaci\xF3n",
        queuedTitle: "Importaci\xF3n en cola",
        queuedDescription: "La estamos procesando en segundo plano. Vas a ver el resultado en \xABImportaciones recientes\xBB.",
        history: "Importaciones"
      }
    };
    var orderDocumentRequirements = {
      title: "Documentaci\xF3n de \xF3rdenes",
      description: "Documentos que las \xF3rdenes de trabajo de esta compa\xF1\xEDa pueden o deben tener para poder finalizarse. Los cambios aplican solo a las \xF3rdenes nuevas.",
      empty: "Todav\xEDa no hay documentos configurados.",
      columns: {
        name: "Nombre",
        uploader: "Qui\xE9n lo carga",
        required: "Obligatoriedad",
        review: "Revisi\xF3n",
        status: "Estado"
      },
      uploader: {
        insurer: "Aseguradora",
        provider: "Proveedor"
      },
      required: {
        yes: "Obligatorio",
        no: "Opcional"
      },
      review: {
        yes: "Requiere revisi\xF3n",
        no: "Sin revisi\xF3n"
      },
      status: {
        active: "Activo",
        inactive: "Inactivo",
        deleted: "Eliminado"
      },
      actions: {
        create: "Nuevo documento",
        edit: "Editar",
        delete: "Eliminar",
        created: "Documento creado",
        updated: "Documento actualizado",
        deleted: "Documento eliminado"
      },
      form: {
        createHint: "Complet\xE1 los datos del documento. Se aplicar\xE1 a las \xF3rdenes que la compa\xF1\xEDa cree de ac\xE1 en adelante.",
        editHint: "Modific\xE1 los datos del documento. Las \xF3rdenes ya creadas conservan su configuraci\xF3n original.",
        save: "Guardar",
        cancel: "Cancelar",
        nameLabel: "Nombre",
        descriptionLabel: "Descripci\xF3n",
        uploaderLabel: "\xBFQui\xE9n debe cargarlo?",
        requiredLabel: "Obligatorio",
        requiredHint: "Bloquea la finalizaci\xF3n de la orden hasta que el documento se cargue (y se apruebe, si corresponde).",
        reviewLabel: "Requiere revisi\xF3n",
        reviewHint: "El documento del proveedor debe ser aprobado por la aseguradora.",
        reviewDisabledHint: "Solo los documentos del proveedor pueden requerir revisi\xF3n.",
        activeLabel: "Activo",
        activeHint: "Los documentos inactivos no se aplican a las \xF3rdenes nuevas.",
        placeholders: {
          name: "Ej: Factura del taller",
          description: "Instrucciones para quien carga el documento\u2026"
        }
      },
      remove: {
        title: '\xBFEliminar el documento "{{name}}"?',
        description: "Las \xF3rdenes existentes conservan su documentaci\xF3n y el documento deja de aplicarse a las \xF3rdenes nuevas. Queda listado ac\xE1 como historial, y su nombre vuelve a estar disponible."
      }
    };
    var offerAgreement = {
      title: "Conformidad",
      description: "Configuraci\xF3n del ofrecimiento y la conformidad de la compa\xF1\xEDa: el simulador, la carta que lee el reclamante, las plantillas del documento, las reglas que eligen la plantilla, las que deciden c\xF3mo se firma y los ajustes del env\xEDo.",
      back: "Volver a las compa\xF1\xEDas",
      open: "Configurar conformidad",
      tabs: {
        simulator: "Simulador",
        "offer-messages": "Mensajes de ofrecimiento",
        "agreement-templates": "Plantillas de conformidad",
        rules: "Reglas de generaci\xF3n",
        signature: "Reglas de firma",
        variables: "Variables de conformidad",
        settings: "Configuraci\xF3n"
      },
      pendingTitle: "Todav\xEDa no disponible",
      pending: {
        rules: "Ac\xE1 se van a definir las reglas que eligen qu\xE9 template se usa, con qu\xE9 acci\xF3n y qui\xE9nes firman.",
        settings: "Ac\xE1 se van a configurar la automatizaci\xF3n, la cuenta remitente y los valores por defecto de la compa\xF1\xEDa."
      }
    };
    var agreementVariables2 = {
      title: "Variables de conformidad",
      description: "Cat\xE1logo de datos que puede imprimir una conformidad, variables din\xE1micas de las plantillas de ofrecimiento de la compa\xF1\xEDa y vinculaci\xF3n de conceptos por nombre. Solo lectura y diagn\xF3stico.",
      catalog: {
        title: "Cat\xE1logo de datos y variables",
        columns: {
          key: "Clave",
          label: "Etiqueta",
          group: "Grupo",
          type: "Tipo",
          stage: "Etapa"
        },
        stage: {
          send: "Al enviar",
          accept: "Al aceptar",
          document: "Al generar"
        },
        type: {
          text: "Texto",
          money: "Importe",
          number: "N\xFAmero",
          percent: "Porcentaje",
          date: "Fecha",
          words: "Importe en letras",
          boolean: "S\xED/No",
          enum: "Opci\xF3n",
          list: "Lista"
        }
      },
      dynamic: {
        title: "Variables de las plantillas de ofrecimiento",
        offer: "Del ofrecimiento (compile_time)",
        acceptance: "De la aceptaci\xF3n (runtime)",
        empty: "La compa\xF1\xEDa no tiene plantillas de ofrecimiento.",
        columns: {
          key: "Clave",
          name: "Nombre",
          type: "Tipo",
          templates: "Plantillas"
        }
      },
      bindings: {
        title: "Conceptos vinculados por nombre",
        concept: "Concepto",
        names: "Nombres aceptados",
        source: {
          default: "Convenci\xF3n",
          company: "Compa\xF1\xEDa"
        },
        matched: "Plantillas que lo definen",
        unbound: "Sin vincular",
        concepts: {
          amount: "Importe",
          amount_in_words: "Importe en letras",
          installments: "Cuotas",
          fee_percentage: "Honorarios",
          payment_days: "Plazo de pago",
          payment_method: "Medio de pago",
          cbu: "CBU",
          cuit: "CUIT",
          lawyer_cbu: "CBU del letrado",
          lawyer_cuit: "CUIT del letrado",
          identification: "Documento declarado"
        }
      },
      resolve: {
        title: "Diagn\xF3stico",
        description: "Resuelve las variables de un reclamo real \u2014con su ofrecimiento aceptado, el indicado o ninguno\u2014 sin modificar nada.",
        claim: "ID del reclamo",
        offer: "ID del ofrecimiento (opcional)",
        acceptance: "Aceptaci\xF3n",
        acceptancePersisted: "Usar la aceptaci\xF3n persistida",
        acceptanceNone: "Ignorar la aceptaci\xF3n",
        submit: "Resolver",
        columns: {
          key: "Variable",
          status: "Estado",
          value: "Valor impreso",
          reason: "Motivo"
        },
        status: {
          resolved: "Resuelta",
          missing: "Falta",
          not_applicable: "No aplica"
        },
        warnings: "Advertencias",
        parties: "Partes",
        claimantRule: "Reclamante principal por",
        lawyerRule: "Abogado por",
        empty: "Todav\xEDa no se resolvi\xF3 ning\xFAn reclamo.",
        withoutOffer: "Resolver sin ofrecimiento (como antes del primer env\xEDo)"
      }
    };
    var agreementTemplates = {
      pages: {
        agreement: {
          title: "Plantillas de conformidad",
          description: "El documento que se firma, redactado por bloques, con versiones publicadas inmutables, vista previa con datos de ejemplo y PDF de prueba sobre un reclamo real.",
          empty: "La compa\xF1\xEDa todav\xEDa no tiene plantillas de conformidad.",
          create: "Nueva conformidad"
        },
        offer_message: {
          title: "Mensajes de ofrecimiento",
          description: "La carta que lee el reclamante cuando recibe el ofrecimiento. Las variantes (cuotas, honorarios) se resuelven adentro con condicionales: la compa\xF1\xEDa usa una sola.",
          empty: "La compa\xF1\xEDa todav\xEDa no tiene cartas de ofrecimiento.",
          create: "Nueva carta"
        }
      },
      activeLetter: {
        title: "Carta activa",
        description: "La que sale con cada ofrecimiento nuevo. Sin carta activa y publicada, el wizard sigue por el flujo manual.",
        label: "Mensaje de ofrecimiento de la compa\xF1\xEDa",
        none: "Sin carta activa",
        notPublished: "La carta elegida no tiene versi\xF3n publicada",
        disabled: "La conformidad autom\xE1tica est\xE1 apagada: el wizard sigue manual aunque haya carta."
      },
      clone: {
        title: "Clonar a otra compa\xF1\xEDa",
        description: "La copia queda como borrador: no se publica, no queda como carta activa y ninguna regla la elige todav\xEDa.",
        targetCompany: "Compa\xF1\xEDa destino",
        chooseCompany: "Eleg\xED la compa\xF1\xEDa",
        noCompanies: "No hay otra compa\xF1\xEDa",
        name: "Nombre en el destino",
        namePlaceholder: "El mismo, o el primero libre",
        includeRules: "Clonar tambi\xE9n las reglas de generaci\xF3n (llegan deshabilitadas)",
        review: "Revisar",
        submit: "Clonar",
        cloned: "Plantilla clonada como borrador",
        willCreate: "Se va a crear \xAB{{name}}\xBB en {{company}}",
        rulesToClone: "{{count}} regla(s) se clonan deshabilitadas",
        references: "Referencias a resolver",
        resolvedAutomatically: "{{count}} resueltas autom\xE1ticamente por nombre",
        chooseEquivalent: "Eleg\xED el equivalente",
        noEquivalent: "La compa\xF1\xEDa destino no tiene ning\xFAn equivalente para elegir",
        usageBlock: "Bloque {{block}}",
        usageRule: "Regla {{rule}}",
        missingVariables: "El texto usa variables que la compa\xF1\xEDa destino no define: {{keys}}",
        acceptMissing: "Clonar igual y dejarlas como hueco"
      },
      table: {
        columns: {
          name: "Plantilla",
          published: "Publicada",
          draft: "Borrador",
          updated: "Actualizada",
          actions: "Acciones"
        },
        noPublished: "Sin publicar",
        noDraft: "\u2014",
        version: "v{{version}}",
        open: "Abrir",
        duplicate: "Duplicar",
        duplicated: "Plantilla duplicada como borrador",
        clone: "Clonar a otra compa\xF1\xEDa"
      },
      create: {
        name: "Nombre",
        namePlaceholder: "Nombre de la plantilla",
        descriptionField: "Descripci\xF3n",
        descriptionPlaceholder: "Descripci\xF3n de la plantilla",
        kindHint: {
          agreement: "El documento de conformidad que se firma: bloques, cl\xE1usulas numeradas y recuadros de firma.",
          offer_message: "La carta del ofrecimiento que lee el reclamante: solo texto, con variables y condicionales para cuotas y honorarios."
        },
        fromExample: "Utilizar plantilla de ejemplo",
        fromExampleHint: "Carga un texto provisorio de conformidad con variables del cat\xE1logo, listo para corregir.",
        submit: "Crear",
        created: "Plantilla creada"
      },
      editor: {
        back: "Volver a las plantillas",
        version: "Versi\xF3n {{version}}",
        status: {
          draft: "Borrador",
          published: "Publicada",
          deprecated: "Deprecada"
        },
        readOnly: "Esta versi\xF3n est\xE1 congelada. Para cambiar el texto, cre\xE1 una versi\xF3n nueva.",
        save: "Guardar borrador",
        saved: "Borrador guardado",
        editButton: "Editar",
        publish: "Publicar",
        published: "Versi\xF3n publicada",
        newVersion: "Nueva versi\xF3n",
        newVersionCreated: "Borrador creado a partir de la versi\xF3n {{version}}",
        deprecate: "Deprecar",
        deprecated: "Versi\xF3n deprecada",
        delete: "Eliminar plantilla",
        deleted: "Plantilla eliminada",
        render: "PDF de prueba",
        preview: "Vista previa",
        previewNote: "La conformidad compilada sobre un ofrecimiento de ejemplo. Eleg\xED el escenario para ver cada rama de los condicionales; las referencias sin valor se listan debajo.",
        previewMissing: "Referencias sin valor en el ejemplo",
        previewInvalid: "Complet\xE1 los campos obligatorios de los bloques para ver la vista previa.",
        messagePreviewNote: "La carta compilada sobre un ofrecimiento de ejemplo. Eleg\xED el escenario para ver cada rama de los condicionales.",
        sampleScenario: "Escenario de ejemplo",
        scenarios: {
          guidedSinglePayment: "Pago \xFAnico, sin honorarios",
          guidedSinglePaymentWithFees: "Pago \xFAnico, con honorarios (12 %)",
          guidedInstallments: "3 cuotas, sin honorarios",
          guidedInstallmentsWithFees: "3 cuotas, con honorarios (12 %)"
        },
        versions: "Versiones",
        versionPlaceholder: "Seleccionar versi\xF3n",
        details: "Datos de la plantilla",
        name: "Nombre",
        description: "Descripci\xF3n",
        saveDetails: "Guardar datos",
        detailsSaved: "Datos guardados"
      },
      blocks: {
        title: "Bloques",
        add: "Agregar bloque",
        empty: "Agreg\xE1 el primer bloque.",
        kind: {
          title: "T\xEDtulo",
          paragraph: "P\xE1rrafo",
          clause: "Cl\xE1usula",
          key_values: "Datos clave",
          signatures: "Firmas",
          page_break: "Salto de p\xE1gina"
        },
        text: "Texto",
        clauseTitle: "T\xEDtulo de la cl\xE1usula (opcional)",
        format: "Formato: *negrita*, _cursiva_, __subrayado__.",
        items: "Datos",
        addItem: "Agregar dato",
        label: "Etiqueta",
        variable: "Variable",
        signers: "Recuadros a imprimir",
        moveUp: "Subir",
        moveDown: "Bajar",
        remove: "Quitar",
        copy: "Copiar bloque",
        copied: "Bloque copiado",
        paste: "Pegar bloque",
        pasteRejected: {
          unreadable: "No hay ning\xFAn bloque copiado",
          kind_not_allowed: "Ese tipo de bloque no se puede usar en esta plantilla"
        },
        hint: "Mencion\xE1 variables con @ (cat\xE1logo y variables din\xE1micas de la compa\xF1\xEDa). Condicionales: [[#if @variable]] \u2026 [[else]] \u2026 [[/if]]. Un bloque cuyo texto queda vac\xEDo no se imprime.",
        messageHint: "La carta se env\xEDa antes de que el reclamante acepte: solo t\xEDtulos y p\xE1rrafos, sin variables de la aceptaci\xF3n. Para cuotas y honorarios us\xE1 [[#if @Cantidad de cuotas]] \u2026 [[else]] \u2026 [[/if]] y [[#if @Porcentaje de honorarios]] \u2026 [[/if]].",
        condition: {
          title: "Condici\xF3n del bloque",
          description: "Si no se cumple, el bloque no se imprime. Sin condiciones, se imprime siempre."
        }
      },
      signers: {
        title: "Recuadros de firma",
        add: "Agregar recuadro",
        empty: "Sin recuadros: el documento se imprime sin firmas.",
        key: "Clave",
        keyHint: "min\xFAsculas, n\xFAmeros y guion bajo; es el ancla [[SIG:clave]]",
        label: "Etiqueta impresa",
        party: "Parte",
        parties: {
          company_sender: "Compa\xF1\xEDa (remitente)",
          victim: "Damnificado",
          claimant: "Reclamante",
          lawyer: "Abogado",
          heirs: "Sucesores"
        },
        optional: "Opcional",
        withDate: "Con fecha",
        withName: "Con aclaraci\xF3n",
        remove: "Quitar"
      },
      render: {
        title: "PDF de prueba",
        description: "Genera el documento con esta versi\xF3n sobre un reclamo real, sin efectos sobre el reclamo: crea un documento de tipo muestra con marca de agua y ubica las anclas de firma.",
        claim: "Reclamo",
        offer: "Ofrecimiento",
        acceptance: "Aceptaci\xF3n",
        acceptancePersisted: "Usar la aceptaci\xF3n persistida",
        acceptanceNone: "Ignorar la aceptaci\xF3n",
        submit: "Generar",
        status: {
          rendering: "Generando",
          ready: "Listo",
          invalid: "Inv\xE1lido",
          failed: "Fall\xF3"
        },
        open: "Abrir PDF",
        renderMs: "Render: {{ms}} ms",
        anchors: "Anclas de firma",
        anchor: {
          key: "Recuadro",
          page: "P\xE1gina",
          position: "Posici\xF3n (x, y)",
          size: "Tama\xF1o (ancho \xD7 alto)",
          found: "Encontrada",
          missing: "No encontrada"
        },
        variables: "Variables resueltas",
        missing: "Referencias sin valor",
        syntaxErrors: "Bloques que no se imprimieron",
        missingRequired: "obligatoria",
        missingOptional: "opcional",
        warnings: "Advertencias"
      },
      missingStatus: {
        missing: "sin valor",
        not_applicable: "no aplica",
        unknown_key: "clave desconocida"
      },
      confirm: {
        publish: {
          title: "\xBFPublicar esta versi\xF3n?",
          description: "La versi\xF3n queda congelada y reemplaza a la publicada actual."
        },
        deprecate: {
          title: "\xBFDeprecar la versi\xF3n publicada?",
          description: "La plantilla queda sin versi\xF3n publicada hasta que publiques otra."
        },
        delete: {
          title: "\xBFEliminar la plantilla?",
          description: "Deja de aparecer en el listado. Solo se puede eliminar si no tiene una versi\xF3n publicada."
        },
        cancel: "Cancelar",
        confirm: "Confirmar"
      }
    };
    var orderClaimStatusMappings = {
      title: "Sincronizaci\xF3n orden - reclamo",
      description: "Cuando la orden vigente alcanza un momento configurado, el reclamo pasa autom\xE1ticamente al estado definido. La etapa, referencia y condici\xF3n contin\xFAan deriv\xE1ndose de las Equivalencias.",
      empty: "Todav\xEDa no hay sincronizaciones configuradas. Los cambios de las \xF3rdenes no modifican el reclamo.",
      columns: {
        trigger: "Momento de la orden",
        claimStatus: "Estado del reclamo"
      },
      derived: "Etapa {{stage}} \xB7 Referencia {{reference}}",
      deletedStatus: "Estado eliminado",
      trigger: {
        accepted: {
          awaiting_provider: "Orden derivada \u2014 esperando respuesta del proveedor",
          rejected: "El proveedor rechaz\xF3 la orden"
        },
        scheduling: {
          awaiting_provider: "Orden aceptada \u2014 coordinaci\xF3n de turno pendiente"
        },
        work_proof: {
          awaiting_provider: "Inspecci\xF3n pendiente de captura",
          in_progress: "Inspecci\xF3n en an\xE1lisis",
          rejected: "Inspecci\xF3n no completada (bloqueada o vencida)"
        },
        documentation: {
          awaiting_provider: "Documentaci\xF3n pendiente del proveedor",
          awaiting_insurer: "Documentaci\xF3n pendiente de la aseguradora",
          rejected: "Documentaci\xF3n rechazada \u2014 debe rehacerse"
        },
        completed: {
          awaiting_insurer: "Orden lista para finalizar",
          done: "Orden finalizada",
          canceled: "Orden anulada"
        }
      },
      actions: {
        create: "Nueva sincronizaci\xF3n",
        edit: "Editar",
        delete: "Eliminar",
        saved: "Sincronizaci\xF3n guardada",
        deleted: "Sincronizaci\xF3n eliminada"
      },
      form: {
        hint: "Eleg\xED un momento del ciclo de la orden y el estado interno al que debe pasar el reclamo. Aplica solo a la orden vigente (la m\xE1s reciente) del reclamo.",
        schedulingHint: "El turno coordinado no es un momento propio: al registrarse el turno, la orden pasa al siguiente momento pendiente (inspecci\xF3n, documentaci\xF3n o finalizaci\xF3n). Configur\xE1 ese momento.",
        triggerLabel: "Momento de la orden",
        claimStatusLabel: "Estado del reclamo",
        triggerPlaceholder: "Seleccion\xE1 un momento",
        claimStatusPlaceholder: "Seleccion\xE1 un estado",
        save: "Guardar",
        cancel: "Cancelar"
      },
      remove: {
        title: "\xBFEliminar la sincronizaci\xF3n?",
        description: 'El momento "{{trigger}}" dejar\xE1 de actualizar autom\xE1ticamente el estado del reclamo.'
      }
    };
    var claimCurrentOrder = {
      title: "Orden de trabajo vigente",
      viewOrder: "Ver orden"
    };
    var customerClaims = {
      externalClaimId: "Reclamo externo",
      licensePlate: "Patente",
      createdBy: "Creado por"
    };
    var customerAccountSettings = {
      profilePhoto: {
        title: "Foto de perfil",
        description: "Se muestra en el men\xFA lateral y en tus reclamos.",
        updated: "Foto de perfil actualizada",
        updatedDescription: "La foto de perfil se actualiz\xF3 correctamente"
      }
    };
    var claimantPendingActions = {
      inbox: {
        titleOne: "Ten\xE9s una acci\xF3n pendiente en un reclamo",
        titleMany: "Ten\xE9s acciones pendientes en {{count}} reclamos",
        description: "Resolvelas para que tu reclamo pueda avanzar.",
        viewOne: "Ver acci\xF3n",
        viewMany: "Ver acciones",
        dialog: {
          title: "Acciones pendientes",
          description: "Eleg\xED un reclamo para resolver lo que falta."
        }
      },
      actions: {
        offer_response: {
          label: "Ofrecimiento pendiente de respuesta",
          title: "Recibiste un ofrecimiento",
          description: "Revisalo y respondelo para que tu reclamo pueda avanzar.",
          cta: "Ver ofrecimiento",
          section: "Ofrecimientos por responder"
        },
        agreement_signature: {
          label: "Conformidad pendiente de firma",
          title: "Tu conformidad est\xE1 lista para firmar",
          description: "Firmala para terminar el proceso del ofrecimiento que aceptaste.",
          cta: "Firmar conformidad",
          section: "Conformidades por firmar"
        },
        documentation_upload: {
          label: "Documentaci\xF3n pendiente de subir",
          title: "Ten\xE9s documentaci\xF3n pendiente",
          description: "Sub\xED la documentaci\xF3n solicitada para que tu reclamo pueda avanzar.",
          cta: "Subir documentaci\xF3n",
          section: "Documentaci\xF3n por subir"
        }
      }
    };
    var claimOrderTracking = {
      title: "Orden de trabajo vigente",
      viewDetail: "Ver detalle",
      nextAppointment: "Turno coordinado: {{at}}",
      modal: {
        title: "Orden {{refId}}",
        description: "Tramitaci\xF3n de la orden de trabajo con {{provider}}"
      },
      sections: {
        progress: "Estado de la orden",
        schedulingHistory: "Historial de coordinaci\xF3n de turnos"
      },
      tabs: {
        info: "Informaci\xF3n",
        scheduling: "Coordinaci\xF3n turno",
        workProof: "Inspecciones"
      },
      info: {
        name: "Descripci\xF3n de la orden",
        service: "Servicio",
        good: "Bien",
        provider: "Proveedor asignado",
        location: "Localidad o zona del servicio",
        createdAt: "Fecha de creaci\xF3n",
        vehicle: "Veh\xEDculo",
        description: "Informaci\xF3n adicional",
        rejectedReason: "Motivo del rechazo",
        canceledReason: "Motivo de la anulaci\xF3n"
      },
      scheduling: {
        empty: "Todav\xEDa no hay un turno coordinado.",
        notified: "Se avis\xF3 al reclamante",
        recordedAt: "Registrado el {{at}}",
        canceledAt: "Anulado el {{at}}",
        phones: "Tel\xE9fonos"
      },
      workProof: {
        empty: "Todav\xEDa no hay inspecciones para esta orden."
      },
      list: {
        tab: "\xD3rdenes",
        title: "\xD3rdenes de trabajo",
        description: "Todas las \xF3rdenes de trabajo asociadas al reclamo.",
        empty: "Todav\xEDa no hay \xF3rdenes de trabajo para este reclamo.",
        current: "Vigente",
        columns: {
          reference: "Orden",
          provider: "Proveedor",
          service: "Servicio",
          status: "Estado",
          createdAt: "Creaci\xF3n"
        }
      }
    };
    var field_adjuster_registration = {
      title: "Complet\xE1 tu registro en Piramid.",
      description: "Cre\xE1 tu cuenta de liquidador para acceder a tus reclamos.",
      invitedEmail: "Te registr\xE1s con el email al que lleg\xF3 la invitaci\xF3n.",
      emailLabel: "Email",
      emailPlaceholder: "liquidador@empresa.com",
      passwordLabel: "Contrase\xF1a",
      passwordPlaceholder: "M\xEDnimo 8 caracteres",
      confirmPasswordLabel: "Confirmar contrase\xF1a",
      confirmPasswordPlaceholder: "Repet\xED la contrase\xF1a",
      passwordsDontMatch: "Las contrase\xF1as no coinciden",
      submit: "Crear cuenta",
      alreadyHaveAccount: "\xBFYa ten\xE9s una cuenta?",
      login: "Inici\xE1 sesi\xF3n",
      backToLogin: "Volver al inicio de sesi\xF3n"
    };
    var claimSharedDocuments = {
      tabClaimant: "Del reclamante",
      tabTramitation: "De tramitaci\xF3n (interna)",
      tabShared: "Compartida con el reclamante",
      customerTabOwn: "Tu documentaci\xF3n",
      customerTabShared: "Compartida por la compa\xF1\xEDa",
      empty: "Todav\xEDa no compartiste documentaci\xF3n con el reclamante.",
      customerEmpty: "La compa\xF1\xEDa todav\xEDa no comparti\xF3 documentaci\xF3n.",
      removeAction: "Dejar de compartir documento",
      removeTitle: "Dejar de compartir documento",
      removeDescription: '"{{name}}" dejar\xE1 de estar disponible para el reclamante.',
      removeConfirm: "Dejar de compartir",
      removed: "El documento dej\xF3 de compartirse",
      cancel: "Cancelar"
    };
    var providerAccountSettings = {
      password: {
        title: "Cambiar contrase\xF1a",
        description: "Actualiz\xE1 la contrase\xF1a con la que ingres\xE1s a tu cuenta.",
        currentPassword: "Contrase\xF1a actual",
        newPassword: "Nueva contrase\xF1a",
        confirmPassword: "Confirmar nueva contrase\xF1a",
        submit: "Cambiar contrase\xF1a",
        updated: "Contrase\xF1a actualizada",
        updatedDescription: "Tu contrase\xF1a se cambi\xF3 correctamente."
      }
    };
    var provider_signin_as = {
      loading: "Iniciando sesi\xF3n...",
      error_title: "Error de autenticaci\xF3n",
      error_description: "No pudimos iniciar la sesi\xF3n. El enlace puede haber vencido: ped\xED uno nuevo desde el Backoffice.",
      go_to_login: "Ir al login"
    };
    var agreementSettings = {
      title: "Configuraci\xF3n de la conformidad",
      description: "Interruptor general de la compa\xF1\xEDa y los nombres con que llama a cada concepto de las plantillas de ofrecimiento.",
      enabled: {
        label: "Conformidad autom\xE1tica habilitada",
        description: "Con esto apagado, el sistema no elige ninguna conformidad: el circuito manual sigue igual."
      },
      validateBankData: {
        label: "Validar CBU y CUIT contra Interbanking",
        description: "Al aceptar, se verifica que la cuenta del tercero exista. Si el servicio no responde, el reclamante no puede aceptar: encenderlo solo con el servicio configurado."
      },
      validateAcceptancePayee: {
        label: "Validar qui\xE9n puede cobrar",
        description: "Al aceptar, se verifica que el DNI y el CUIT de la cuenta de cobro correspondan a una persona habilitada por el reclamo: el damnificado, su padre o madre si es menor, o un sucesor si falleci\xF3. Si el reclamo no alcanza para decidirlo, el ofrecimiento no se puede enviar ni aceptar."
      },
      bindings: {
        title: "Nombres de las variables",
        description: "Una fila por concepto. Vac\xEDo = se usan los nombres por convenci\xF3n. Separ\xE1 varios nombres con coma.",
        placeholder: "Nombres por convenci\xF3n"
      },
      offerTerms: {
        title: "Condiciones de pago del ofrecimiento",
        description: "Las opciones que ofrece el wizard guiado. Vac\xEDo = las del producto. Separ\xE1 los valores con coma.",
        installment_options: "Cuotas",
        fee_percentage_options: "Honorarios (%)",
        payment_days_options: "D\xEDas a pagar"
      },
      save: "Guardar",
      saved: "Configuraci\xF3n guardada",
      signatureEnabled: {
        label: "Firma de la conformidad por AutoSign",
        description: "Al aceptarse, la conformidad sale a firmar por AutoSign desde la cuenta del tramitador que envi\xF3 el ofrecimiento, as\xED que enviarlo exige esa cuenta conectada. Apagado, el PDF se genera igual y se firma por fuera. Se congela en cada ofrecimiento al enviarlo; apagarlo pausa los env\xEDos pendientes."
      },
      embeddedSigningEnabled: {
        label: "Firma inmediata al aceptar",
        description: "Si el reclamante es el primer firmante, firma la conformidad dentro de Piramid apenas acepta, sin esperar el email de AutoSign. Necesita la firma por AutoSign encendida. Se aplica en vivo: apagarlo corta tambi\xE9n las firmas en preparaci\xF3n y el reclamante firma por email."
      }
    };
    var agreementRules = {
      title: "Reglas de generaci\xF3n",
      description: "Qu\xE9 plantilla corresponde a cada reclamo, mirando solo sus datos. Se eval\xFAan en orden de prioridad y gana la primera que coincide; la simulaci\xF3n muestra por qu\xE9.",
      empty: "Todav\xEDa no hay reglas. Cre\xE1 la primera para que el sistema pueda elegir una conformidad.",
      add: "Nueva regla",
      columns: {
        priority: "Orden prioridad",
        name: "Nombre",
        template: "Plantilla",
        conditions: "Condiciones",
        signers: "Firmantes",
        health: "Estado",
        enabled: "Estado"
      },
      catchAll: "Sin condiciones (aplica siempre)",
      conditionsCount: "{{count}} condiciones",
      healthy: "Lista",
      moveUp: "Subir",
      moveDown: "Bajar",
      form: {
        createTitle: "Nueva regla",
        editTitle: "Editar regla",
        name: "Nombre",
        namePlaceholder: "Ej: Fallecidos con sucesores",
        description: "Notas",
        descriptionPlaceholder: "Para qu\xE9 casos se usa esta regla\u2026",
        priority: "Prioridad",
        priorityHint: "Menor n\xFAmero, se eval\xFAa antes.",
        template: "Plantilla",
        templateHint: "Se usa siempre su versi\xF3n publicada.",
        enabled: "Habilitada",
        enabledHint: "Una regla deshabilitada no se eval\xFAa.",
        save: "Guardar regla",
        saved: "Regla guardada",
        removed: "Regla eliminada"
      },
      conditions: {
        title: "Condiciones",
        description: 'Se tienen que cumplir todas. Para un "o", us\xE1 "es alguno de" o escrib\xED otra regla. Solo datos del reclamo: lo del ofrecimiento se resuelve con condiciones por bloque en la plantilla.',
        add: "Agregar condici\xF3n",
        remove: "Quitar",
        attribute: "Atributo",
        operator: "Operador",
        value: "Valor",
        variableName: "Nombre de la variable",
        variableNamePlaceholder: "Ej: metodo de pago",
        listHint: "Separ\xE1 los valores con coma.",
        searchPlaceholder: "Buscar",
        empty: "Sin condiciones: la regla aplica a todo reclamo que llegue hasta ella."
      },
      recipients: {
        title: "Orden de firma",
        description: "La plantilla ya dice qu\xE9 recuadros hay y qu\xE9 parte firma cada uno. Ac\xE1 va s\xF3lo en qu\xE9 orden se firman.",
        add: "Agregar recuadro",
        signerKey: "Recuadro",
        index: "Orden",
        empty: "Sin filas: se usa el orden de la plantilla y todos firman."
      },
      remove: {
        title: '\xBFEliminar la regla "{{name}}"?',
        description: "Deja de evaluarse. Los planes que ya decidi\xF3 siguen apuntando a ella."
      },
      simulator: {
        title: "Simulador",
        description: "Sobre un reclamo real: qu\xE9 plantilla gana, c\xF3mo se firma, por qu\xE9 las otras reglas no y qu\xE9 falta. No escribe nada.",
        claimId: "ID del reclamo",
        offerId: "ID del ofrecimiento (opcional)",
        acceptance: "Aceptaci\xF3n",
        run: "Simular",
        outcome: "Resultado",
        trace: "Reglas evaluadas",
        recipients: "Firmantes",
        missing: "Faltantes",
        warnings: "Advertencias",
        noConditions: "Sin condiciones",
        actual: "Valor del reclamo",
        empty: "Ingres\xE1 un reclamo y simul\xE1 para ver la decisi\xF3n.",
        signature: "Firma",
        signatureTrace: "Reglas de firma evaluadas",
        withoutOffer: "Simular sin ofrecimiento (como antes del primer env\xEDo)",
        outOfScope: "Fuera de alcance",
        message: {
          title: "Mensaje del ofrecimiento",
          description: "Lo que ver\xEDa el tramitador en el wizard para este reclamo: el modo, la carta de la compa\xF1\xEDa con las condiciones tipeadas y qu\xE9 se le va a pedir al reclamante. No escribe nada.",
          amount: "Importe",
          installments: "Cuotas",
          feePercentage: "Honorarios (%)",
          paymentDays: "D\xEDas",
          payee: "Qui\xE9n cobra",
          payeeNone: "Sin elegir",
          run: "Previsualizar mensaje",
          mode: "Modo del wizard",
          letter: "Carta",
          noLetter: "La compa\xF1\xEDa no tiene carta publicada",
          acceptance: "Se le pedir\xE1",
          gaps: "Faltantes del mensaje",
          fingerprint: "Huella",
          empty: "Ingres\xE1 un reclamo arriba y previsualiz\xE1 para ver la carta.",
          optional: "opcional"
        }
      },
      enabledBadge: "Habilitada",
      disabledBadge: "Deshabilitada"
    };
    var agreementSignatureRules = {
      title: "Reglas de firma",
      description: "C\xF3mo se firma la conformidad una vez elegida la plantilla: digital o presencial. Se eval\xFAan en orden de prioridad entre las que alcanzan a la plantilla elegida y gana la primera que coincide.",
      empty: "Todav\xEDa no hay reglas de firma: ning\xFAn plan tiene m\xE9todo de firma hasta que exista al menos una.",
      add: "Nueva regla de firma",
      columns: {
        priority: "Orden prioridad",
        name: "Nombre",
        method: "M\xE9todo",
        scope: "Alcance",
        conditions: "Condiciones",
        health: "Estado",
        enabled: "Estado"
      },
      scopeAll: "Todas las plantillas",
      scopeCount: "{{count}} plantillas",
      form: {
        createTitle: "Nueva regla de firma",
        editTitle: "Editar regla de firma",
        name: "Nombre",
        namePlaceholder: "Ej: Monto alto, presencial",
        description: "Notas",
        descriptionPlaceholder: "Para qu\xE9 casos se usa esta regla\u2026",
        priority: "Prioridad",
        priorityHint: "Menor n\xFAmero, se eval\xFAa antes.",
        method: "M\xE9todo de firma",
        enabled: "Habilitada",
        enabledHint: "Una regla deshabilitada no se eval\xFAa.",
        scope: "Alcance",
        scopeAll: "Aplica a todas las plantillas de la compa\xF1\xEDa.",
        scopeTemplates: "Solo a estas plantillas:",
        scopeEmpty: "Eleg\xED al menos una plantilla.",
        conditionsHint: "Se tienen que cumplir todas. Puede mirar el reclamo, el ofrecimiento y la aceptaci\xF3n; lo que todav\xEDa no existe deja la regla pendiente, no falsa.",
        save: "Guardar regla",
        saved: "Regla de firma guardada",
        removed: "Regla de firma eliminada"
      },
      remove: {
        title: '\xBFEliminar la regla de firma "{{name}}"?',
        description: "Deja de evaluarse. Los planes que ya decidi\xF3 siguen apuntando a ella."
      }
    };
    var idCardScan = {
      offerTitle: "\xBFTen\xE9s el DNI a mano?",
      offerDescription: "Escanealo y completamos los datos por vos.",
      filledTitle: "Le\xEDmos el DNI",
      filledDescription: "Completamos {{count}} campos. Revisalos y correg\xED lo que haga falta.",
      title: "Escane\xE1 el DNI",
      starting: "Abriendo la c\xE1mara\u2026",
      scanning: "Buscando el c\xF3digo\u2026",
      searchingMrz: "Probando tambi\xE9n la banda del dorso\u2026",
      denied: "No pudimos usar la c\xE1mara. Revis\xE1 los permisos del navegador y volv\xE9 a intentar.",
      failed: "No pudimos leer el documento. Prob\xE1 de nuevo con mejor luz, o carg\xE1 una foto.",
      failedUpload: "No pudimos leer ese archivo. Prob\xE1 con una foto m\xE1s n\xEDtida, enfocada sobre el c\xF3digo y sin reflejos.",
      uploadPhoto: "Cargar una foto",
      useCamera: "Prefiero usar la c\xE1mara",
      cantScan: "No puedo escanearlo",
      cancel: "Cancelar",
      retry: "Escanear de nuevo",
      attachedNotice: "Adem\xE1s guardamos la foto como {{side}}.",
      discardedNotice: "No pudimos leer con seguridad {{fields}}: completalos a mano.",
      signal: {
        barcodeRead: "{{format}} le\xEDdo",
        barcodeUnknown: "{{format}} detectado, no es un DNI"
      },
      sideFront: "DNI (frente)",
      sideBack: "DNI (dorso)",
      field: {
        first_name: "Nombre",
        last_name: "Apellido",
        document_number: "Documento",
        sex: "G\xE9nero",
        birth_date: "Fecha de nacimiento",
        nationality: "Nacionalidad"
      },
      document: {
        dni: {
          trigger: "Escanear DNI",
          offerTitle: "\xBFTen\xE9s el DNI a mano?",
          hint: "Mostr\xE1 el frente, el lado del c\xF3digo de barras",
          title: "Escane\xE1 el DNI",
          uploadHint: "Sub\xED una foto del frente del DNI, del lado del c\xF3digo de barras."
        },
        licence: {
          trigger: "Escanear licencia",
          offerTitle: "\xBFTen\xE9s la licencia de conducir?",
          hint: "Sosten\xE9 la licencia en vertical, con el c\xF3digo de barras dentro del recuadro",
          title: "Escane\xE1 la licencia",
          uploadHint: "Sub\xED una foto del dorso de la licencia, donde est\xE1 el c\xF3digo de barras."
        },
        passport: {
          trigger: "Escanear pasaporte",
          offerTitle: "\xBFTen\xE9s el pasaporte?",
          hint: "Mostr\xE1 la p\xE1gina de datos, con las dos l\xEDneas de abajo dentro del recuadro",
          title: "Escane\xE1 el pasaporte",
          uploadHint: "Sub\xED una foto de la p\xE1gina de datos del pasaporte, con las dos l\xEDneas de abajo bien visibles."
        }
      }
    };
    var integrations = {
      kach_user: {
        connect: "Conectar cuenta",
        reconnect: "Reconectar",
        disconnect: "Desconectar cuenta",
        invalidated: "La conexi\xF3n dej\xF3 de ser v\xE1lida. Volv\xE9 a conectar tu cuenta."
      },
      autosign: {
        disconnect_disabled: "La cuenta de AutoSign no se puede desconectar: las conformidades de tus ofrecimientos se env\xEDan a firmar con ella. Si necesit\xE1s volver a autorizarla o cambiar de cuenta, us\xE1 \xABReconectar\xBB."
      },
      oauth: {
        connect: "Conectar cuenta",
        reconnect: "Reconectar",
        connected: {
          title: "Integraci\xF3n conectada",
          description: "Se estableci\xF3 correctamente la conexi\xF3n con {{name}}"
        }
      },
      agreementRules: {
        back: "Volver a Integraciones",
        title: "Reglas de conformidad",
        description: "Reglas que deciden qu\xE9 conformidad se genera y c\xF3mo se firma en AutoSign. Las configura el equipo de Piramid; ac\xE1 pod\xE9s consultarlas.",
        tabs: {
          generation: "Generaci\xF3n",
          signature: "Firma",
          templates: "Plantillas"
        },
        entityLabel: "Reglas",
        empty: "La compa\xF1\xEDa no tiene reglas configuradas.",
        error: "No se pudieron cargar las reglas.",
        retry: "Reintentar",
        columns: {
          priority: "Prioridad",
          name: "Nombre",
          template: "Plantilla",
          method: "M\xE9todo de firma",
          scope: "Alcance",
          conditions: "Condiciones",
          status: "Estado",
          createdAt: "Creada",
          publishedVersion: "Versi\xF3n publicada",
          publishedAt: "Publicada el",
          signers: "Recuadros de firma"
        },
        status: {
          enabled: "Habilitada",
          disabled: "Deshabilitada"
        },
        conditionsCount: "{{count}} condici\xF3n(es)",
        allCases: "Todos los casos",
        allTemplates: "Todas las plantillas",
        scopeUnavailable: "Plantillas que ya no existen",
        templatesEntityLabel: "Plantillas",
        emptyTemplates: "La compa\xF1\xEDa no tiene plantillas de conformidad publicadas.",
        templateDetail: {
          publishedVersion: "Versi\xF3n publicada v{{version}} \xB7 {{date}}",
          loadError: "No se pudo cargar la plantilla."
        },
        noPublishedVersion: "Sin versi\xF3n publicada",
        templateVersion: "{{name}} \xB7 v{{version}}",
        detail: {
          loadError: "No se pudo cargar el detalle de la regla.",
          general: "General",
          priority: "Prioridad",
          template: "Plantilla",
          method: "M\xE9todo de firma",
          scope: "Alcance",
          createdAt: "Creada",
          updatedAt: "Actualizada",
          conditions: "Condiciones",
          conditionsHint: "La regla aplica cuando se cumplen todas las condiciones.",
          noConditions: "Sin condiciones: aplica a todos los casos.",
          recipients: "Firmantes",
          recipientsHint: "Orden en que se env\xEDa la conformidad a firmar.",
          noRecipients: "Sin firmantes configurados.",
          unknownSigner: "Recuadro no encontrado en la versi\xF3n publicada"
        }
      }
    };
    var activity = {
      offer_agreement_created: {
        own: "Enviaste la conformidad a firmar por AutoSign",
        other: "envi\xF3 la conformidad a firmar por AutoSign"
      },
      offer_agreement_dispatch_failed: "notifica que no se pudo enviar la conformidad a firmar",
      offer_agreement_recipient_submitted: "notifica que {{name}} firm\xF3 la conformidad",
      claim_derivation_restore_status_updated: 'actualiz\xF3 el estado que se restaurar\xE1 al devolver la derivaci\xF3n: de "{{previous}}" a "{{status}}"',
      claim_sinister_changed: "movi\xF3 el reclamo {{ref_id}} al siniestro que agrupa los reclamos de la denuncia {{complaint}}",
      claim_delegated_by_owner: {
        self: "Delegaste este reclamo a {{responsible}}",
        other: "deleg\xF3 este reclamo a {{responsible}}"
      },
      offer_agreement_completed: "notifica que la conformidad fue firmada por todas las partes",
      offer_agreement_expired: "notifica que la conformidad expir\xF3 sin firmarse",
      offer_agreement_rejected: "notifica que la conformidad fue rechazada",
      offer_agreement_cancelled: {
        own: "Anulaste la conformidad",
        other: "anul\xF3 la conformidad",
        provider: "notifica que la conformidad fue cancelada en AutoSign"
      },
      offer_rejected_on_behalf: {
        own: "Registraste el rechazo del reclamante al ofrecimiento",
        other: "registr\xF3 el rechazo del reclamante al ofrecimiento",
        claimant: "registr\xF3 tu rechazo del"
      }
    };
    var _orders = "\xD3rdenes de trabajo";
    var backofficeOrders = {
      title: "\xD3rdenes de trabajo",
      description: "\xD3rdenes de trabajo de todas las compa\xF1\xEDas",
      searchPlaceholder: "Buscar por N\xB0 de orden, descripci\xF3n o reclamo",
      searchTooltip: "Busca por n\xFAmero de orden, descripci\xF3n de la orden o n\xFAmero de reclamo",
      dateField: {
        label: "Aplicar sobre",
        created_at: "Fecha de derivaci\xF3n",
        accepted_at: "Fecha de aceptaci\xF3n",
        completed_at: "Fecha de finalizaci\xF3n"
      },
      export: {
        button: "Exportar",
        title: "Exportar \xF3rdenes de trabajo",
        description: "Los filtros de la tabla aplicar\xE1n tambi\xE9n al exportar las \xF3rdenes. S\xF3lo se exportan \xF3rdenes de reclamos.",
        recipient: "Enviar a",
        recipientPlaceholder: "nombre@revelaciondata.com.ar",
        recipientDomain: "S\xF3lo casillas @revelaciondata.com.ar",
        submit: "Exportar",
        successTitle: "Reporte enviado",
        successDescription: "Enviamos {{total}} \xF3rdenes a {{email}}. El link de descarga vence en 3 d\xEDas."
      }
    };
    var release_notes = {
      nav: "Novedades",
      brand: "PIRAMID",
      back: "Volver a Piramid",
      index: {
        empty: "Todav\xEDa no hay novedades para mostrar.",
        dateline: "Todo lo que cambia en Piramid",
        "no-match": "No hay novedades con ese filtro.",
        "show-all": "Ver todas",
        search: "Buscar una novedad",
        "new-unread": "Nueva, sin leer",
        unread: "Sin leer",
        latest: "\xDAltima novedad",
        open: "Ver la novedad",
        reopen: "Volver a verla",
        "read-on": "Le\xEDda el {{date}}",
        "in-this-note": "En esta novedad",
        filter: {
          label: "Filtrar novedades",
          all: "Todas",
          unread: "Sin leer",
          mine: "Para m\xED"
        },
        "sent-to": "Enviada a"
      },
      viewers: {
        one: "1 persona la vio",
        many: "{{count}} personas la vieron",
        title: "Vieron esta novedad",
        aria: "Vieron esta novedad: {{count}} personas",
        more: "y {{count}} personas m\xE1s",
        "more-one": "y 1 persona m\xE1s",
        you: "Vos",
        "your-user": "Tu usuario",
        "just-now": "hace un momento",
        today: "hoy {{time}}"
      },
      sidebar: {
        new: "Novedad",
        open: "Ver la novedad",
        dismiss: "Ocultar",
        unread: "{{count}} sin leer"
      },
      kind: {
        feature: "Funcionalidad nueva",
        improvement: "Mejora",
        fix: "Correcci\xF3n"
      },
      published: "Publicada el {{date}}",
      article: {
        contents: "En esta nota",
        overview: "Antes y ahora",
        item: "Novedad {{number}}",
        toc: "Contenido",
        all: "Todas las novedades",
        "read-on": "La le\xEDste el {{date}}",
        progress: "Progreso de lectura",
        byline: "Por el equipo de producto de Piramid",
        "reading-time": {
          one: "1 minuto de lectura",
          many: "{{count}} minutos de lectura"
        },
        "must-know": "Lo que hay que saber",
        "try-it": "Ya est\xE1 disponible en Piramid",
        more: "M\xE1s en Novedades"
      },
      demo: {
        badge: "Demo interactiva",
        sandbox: "Datos de ejemplo: nada de lo que hagas ac\xE1 afecta a tu equipo.",
        "sample-data": "Datos de ejemplo",
        restart: "Reiniciar demo",
        credit: "Demo con datos de ejemplo",
        team: "Siniestros",
        "toast-description": "Es una demo: no cambi\xF3 nada en tu equipo.",
        member: {
          description: "En Gesti\xF3n de equipo, ac\xE1 ves sus reclamos y pod\xE9s reasignarlos, retornarlos o recuperarlos.",
          open: "Abiertos",
          aging: "Aging prom.",
          critical: "Cr\xEDticos",
          "received-delegated": "Delegados recibidos",
          "received-derived": "Derivados recibidos",
          "schedule-hint": "En la versi\xF3n real, ac\xE1 program\xE1s la licencia: desde, hasta, motivo y c\xF3mo delegar sus reclamos."
        },
        "preview-only": "La demo interactiva se ve en la app del insurer.",
        names: {
          team_members_table: "Tabla de miembros del equipo"
        }
      },
      cover: {
        member: "Tramitador"
      },
      feedback: {
        title: "\xBFTe result\xF3 \xFAtil esta nota?",
        subtitle: "Tu respuesta nos ayuda a mejorar las pr\xF3ximas novedades.",
        yes: "S\xED, me sirvi\xF3",
        no: "No mucho",
        thanks: "\xA1Gracias! Nos ayuda a escribir mejor las pr\xF3ximas."
      },
      cta: {
        "team-management": "Ir a Gesti\xF3n de equipo"
      },
      decision: {
        yes: "S\xED",
        no: "No"
      },
      error: {
        title: "No pudimos cargar las novedades",
        retry: "Reintentar"
      },
      peek: {
        read: "Leer la novedad",
        all: "Ver todas las novedades",
        "more-unread": "Y {{count}} m\xE1s sin leer.",
        empty: "Todav\xEDa no hay novedades."
      },
      crumbs: {
        label: "Ubicaci\xF3n",
        home: "Portada"
      }
    };
    var openai_decision = {
      email_name_match: {
        tooltip: "Coincidencia estimada entre nombre y correo: {{percentage}}%. No bloquea el env\xEDo.",
        tiers: {
          strong: "Alta coincidencia",
          partial: "Coincidencia posible",
          weak: "Recomendamos revisar"
        }
      }
    };
    var es_default2 = {
      claim_status_locked_by_derivation,
      autoinspectorInspections,
      documentAnalysis,
      providerInvitations,
      backofficeCustomerOrganizations,
      backofficeReleaseNotes,
      backofficeProviders,
      customer_signin_as,
      customer_organization_invitation,
      provider_registration,
      engagements,
      branches,
      network,
      use_cases,
      field_mapping_config,
      message_template,
      stats,
      chart,
      distribution,
      "trigger-mappings": trigger_mappings,
      sla,
      "working-days": working_days,
      "payment-method": payment_method,
      "estimates-definition": estimates_definition,
      person,
      entrypoint,
      demoempleo,
      gamma,
      "target-group": target_group,
      actions,
      operators,
      delta,
      offer,
      orders,
      variable,
      "inhouse-lawyer": inhouse_lawyer,
      load_balance_rule,
      document: document2,
      circulation,
      license,
      contract,
      cost,
      bid,
      rfp,
      contact,
      filters,
      filtersPanel,
      legal_person,
      user,
      zod,
      inspection,
      professions,
      "exported-report": exported_report,
      claims,
      notifications,
      fraud,
      breadcrumb,
      complaint,
      "validation-pattern": validation_pattern,
      frequency,
      claimants,
      claim,
      events,
      fileRequest,
      entities,
      validations,
      entrypoints,
      backends,
      file_types,
      sinister,
      errors,
      legalPersonType,
      "claim.properties.insurance.insurer": claim_properties_insurance_insurer,
      "claim.properties.insurance.policy_number": claim_properties_insurance_policy_number,
      "claim.properties.driver.ownership.owner": claim_properties_driver_ownership_owner,
      "claim.properties.vehicle.type.car": claim_properties_vehicle_type_car,
      "claim.properties.vehicle.category.with_license_plate": claim_properties_vehicle_category_with_license_plate,
      "claim.properties.driver.owner": claim_properties_driver_owner,
      "claim.properties.vehicle.document_type.title": claim_properties_vehicle_document_type_title,
      "claim.properties.insurance.coverage.third_full": claim_properties_insurance_coverage_third_full,
      "claim.victim_relationship.own": claim_victim_relationship_own,
      "claim.properties.damage.driver.last_name": claim_properties_damage_driver_last_name,
      "claim.properties.damage.driver.first_name": claim_properties_damage_driver_first_name,
      "claim.properties.damage.hasInsurance": claim_properties_damage_hasInsurance,
      "claim.properties.damage.type": claim_properties_damage_type,
      "claim.properties.vehicle.category": claim_properties_vehicle_category,
      "claim.properties.vehicle.type": claim_properties_vehicle_type,
      "claim.properties.vehicle.year": claim_properties_vehicle_year,
      "claim.properties.vehicle.license_plate": claim_properties_vehicle_license_plate,
      "claim.properties.vehicle.engine": claim_properties_vehicle_engine,
      "claim.properties.vehicle.chassis": claim_properties_vehicle_chassis,
      "claim.properties.vehicle.use": claim_properties_vehicle_use,
      "claim.properties.vehicle.model": claim_properties_vehicle_model,
      "claim.properties.vehicle.make": claim_properties_vehicle_make,
      "claim.properties.vehicle.version": claim_properties_vehicle_version,
      "claim.properties.vehicle.document_type": claim_properties_vehicle_document_type,
      "claim.properties.driver.ownership": claim_properties_driver_ownership,
      "claim.properties.insurance.coverage": claim_properties_insurance_coverage,
      "damages.material.vehicle": damages_material_vehicle,
      "damages.material.real_property": damages_material_real_property,
      materialDamage,
      parents,
      "claim.identification_type.label": claim_identification_type_label,
      "identification-type": identification_type,
      "local-insured-relationships": local_insured_relationships,
      "victim-injuries-roles": victim_injuries_roles,
      coverages,
      "driver-ownership": driver_ownership,
      real_property,
      vehicle,
      type,
      "claim.state.label": claim_state_label,
      "claim.city.label": claim_city_label,
      "claim.country.label": claim_country_label,
      "claim.identification.label": claim_identification_label,
      "claim.first_name.label": claim_first_name_label,
      "claim.last_name.label": claim_last_name_label,
      "claim.cuit.label": claim_cuit_label,
      "claim.address.label": claim_address_label,
      "claim.type.label": claim_type_label,
      "claim.social_reason.label": claim_social_reason_label,
      "claim.zip_code.label": claim_zip_code_label,
      "claim.victim_relationship.label": claim_victim_relationship_label,
      fractures,
      severities,
      injuries,
      claimant_victim_violation,
      claim_ownership_transfer,
      victim_relationship,
      sex,
      damages,
      "company-service": company_service,
      permissions,
      "company-enums.claim_status": company_enums_claim_status,
      "company-enums.claim_stage": company_enums_claim_stage,
      "company-enums.claim_reference": company_enums_claim_reference,
      "company-enums.claim_status_order_rule": company_enums_claim_status_order_rule,
      "company-enums.claim_type": company_enums_claim_type,
      "company-enums.complaint_status": company_enums_complaint_status,
      "company-enums.complaint_stage": company_enums_complaint_stage,
      "company-enums.complaint_reference": company_enums_complaint_reference,
      "company-enums.complaint_status_order_rule": company_enums_complaint_status_order_rule,
      "company-enums.ramos": company_enums_ramos,
      "company-enums.agencies": company_enums_agencies,
      "company-enums.complaint_public_status": company_enums_complaint_public_status,
      "company-enums.claim_public_status": company_enums_claim_public_status,
      "/claims": _claims,
      "/complaints": _complaints,
      "/companies": _companies,
      "/autoinspector-inspections": _autoinspector_inspections,
      "/fraud-investigations": _fraud_investigations,
      "/catalog": _catalog,
      "/document-types": _document_types,
      "/providers": _providers,
      "/customer-organizations": _customer_organizations,
      "/provider-invitations": _provider_invitations,
      "/geo": _geo,
      "/metrics": _metrics,
      "/metrics/performance": _metrics_performance,
      "/metrics/experimental": _metrics_experimental,
      "/reviews": _reviews,
      "/users": _users,
      "/integrations": _integrations,
      "/recordings": _recordings,
      "/release-notes": _release_notes,
      recordings,
      sidebar,
      fraud_investigations,
      geo,
      catalog,
      "style-config": style_config,
      "fraud-investigation-case": fraud_investigation_case,
      role,
      webhook,
      resources,
      occurrence,
      currencies,
      company,
      teams,
      metrics,
      "team-management": team_management,
      claims_table,
      review,
      reviews,
      home,
      onboarding,
      documents,
      documentTypes,
      products,
      providerGroups,
      test_environment,
      productImport,
      orderDocumentRequirements,
      offerAgreement,
      agreementVariables: agreementVariables2,
      agreementTemplates,
      orderClaimStatusMappings,
      claimCurrentOrder,
      customerClaims,
      customerAccountSettings,
      claimantPendingActions,
      claimOrderTracking,
      field_adjuster_registration,
      claimSharedDocuments,
      providerAccountSettings,
      provider_signin_as,
      agreementSettings,
      agreementRules,
      agreementSignatureRules,
      idCardScan,
      integrations,
      activity,
      "/orders": _orders,
      backofficeOrders,
      "release-notes": release_notes,
      openai_decision
    };
    var translate7 = (key = "", data, fallback) => {
      const word = (0, import_lodash.default)(es_exports, key);
      if (!word) return fallback || "";
      const regex = /{{\s*([^{}]+)\s*}}/g;
      const final = String(word || key || "");
      return final.replace(
        regex,
        (_, match83) => String((0, import_lodash.default)(data, match83.trim()))
      ) || "" || key;
    };
    var useTranslations = (namespace, _fallback) => (key, data, fallback) => translate7(
      namespace ? `${namespace}.${key}` : key,
      data,
      fallback || _fallback
    );
  }
});

// ../piramid-constants/dist/index.js
var require_dist2 = __commonJS({
  "../piramid-constants/dist/index.js"(exports2, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod2) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod2);
    var piramid_constants_exports = {};
    __export2(piramid_constants_exports, {
      AGREEMENT_BLOCKING_WARNING_CODES: () => AGREEMENT_BLOCKING_WARNING_CODES2,
      AGREEMENT_CATALOG_VERSION: () => AGREEMENT_CATALOG_VERSION2,
      AGREEMENT_CEREMONY_WINDOW_GAP_MS: () => AGREEMENT_CEREMONY_WINDOW_GAP_MS,
      AGREEMENT_DYNAMIC_PREFIXES: () => AGREEMENT_DYNAMIC_PREFIXES2,
      AGREEMENT_FORMAT_VERSION: () => AGREEMENT_FORMAT_VERSION2,
      AGREEMENT_GENERATION_RULE_GROUPS: () => AGREEMENT_GENERATION_RULE_GROUPS2,
      AGREEMENT_OFFER_MESSAGE_BLOCK_KINDS: () => AGREEMENT_OFFER_MESSAGE_BLOCK_KINDS,
      AGREEMENT_PLACEHOLDER_CLOSE: () => AGREEMENT_PLACEHOLDER_CLOSE,
      AGREEMENT_PLACEHOLDER_OPEN: () => AGREEMENT_PLACEHOLDER_OPEN,
      AGREEMENT_PLACEHOLDER_PATTERN: () => AGREEMENT_PLACEHOLDER_PATTERN2,
      AGREEMENT_PRESERVE_CASE_KEYS: () => AGREEMENT_PRESERVE_CASE_KEYS2,
      AGREEMENT_RULES_TAKE: () => AGREEMENT_RULES_TAKE,
      AGREEMENT_RULE_MAX_CONDITIONS: () => AGREEMENT_RULE_MAX_CONDITIONS2,
      AGREEMENT_RULE_TYPE_OPERATORS: () => AGREEMENT_RULE_TYPE_OPERATORS,
      AGREEMENT_SIGNATURE_BOX_MM: () => AGREEMENT_SIGNATURE_BOX_MM,
      AGREEMENT_SIGNATURE_ORIGIN_BY_CEREMONY_ENTRY: () => AGREEMENT_SIGNATURE_ORIGIN_BY_CEREMONY_ENTRY2,
      AGREEMENT_SIGNATURE_ORIGIN_GRACE_MS: () => AGREEMENT_SIGNATURE_ORIGIN_GRACE_MS2,
      AGREEMENT_SIGNATURE_RULE_GROUPS: () => AGREEMENT_SIGNATURE_RULE_GROUPS,
      AGREEMENT_SIGNATURE_SLOT_MM: () => AGREEMENT_SIGNATURE_SLOT_MM,
      AGREEMENT_SIGNATURE_TOKEN_PREFIX: () => AGREEMENT_SIGNATURE_TOKEN_PREFIX,
      ALERT_ENVIRONMENT_TAG: () => ALERT_ENVIRONMENT_TAG2,
      AUTH_URL_PARAMS: () => AUTH_URL_PARAMS,
      AUTOSIGN_DOCUMENT_POLL_DELAYS_MS: () => AUTOSIGN_DOCUMENT_POLL_DELAYS_MS,
      AUTOSIGN_MAX_FILE_BYTES: () => AUTOSIGN_MAX_FILE_BYTES,
      AUTOSIGN_NOTIFICATION_ENDPOINT_MAX_LENGTH: () => AUTOSIGN_NOTIFICATION_ENDPOINT_MAX_LENGTH,
      AUTOSIGN_OAUTH_SCOPES: () => AUTOSIGN_OAUTH_SCOPES3,
      AUTOSIGN_RECIPIENT_COLORS: () => AUTOSIGN_RECIPIENT_COLORS,
      AUTOSIGN_REQUEST_TIMEOUT_MS: () => AUTOSIGN_REQUEST_TIMEOUT_MS,
      AUTOSIGN_SIGNATURE_FIELD_STYLE: () => AUTOSIGN_SIGNATURE_FIELD_STYLE,
      BACKOFFICE_ORDER_EXPORT_MAX_ROWS: () => BACKOFFICE_ORDER_EXPORT_MAX_ROWS,
      BACKOFFICE_ORDER_REPORT_DEFAULT_COLUMNS: () => BACKOFFICE_ORDER_REPORT_DEFAULT_COLUMNS,
      BATCH_RESTORE_DELEGATIONS_PAGE_SIZE: () => BATCH_RESTORE_DELEGATIONS_PAGE_SIZE,
      BRANCH_CENTRAL_COLOR: () => BRANCH_CENTRAL_COLOR,
      BRANCH_REGULAR_COLOR: () => BRANCH_REGULAR_COLOR,
      CALENDAR_INVITE_ATTACHMENT_FILENAME: () => CALENDAR_INVITE_ATTACHMENT_FILENAME,
      CHECKBOX_COLUMN_ID: () => CHECKBOX_COLUMN_ID,
      CHILDREN_WINDOW_DONE_WORD_TOKEN: () => CHILDREN_WINDOW_DONE_WORD_TOKEN,
      CHILDREN_WINDOW_ERROR_WORD_TOKEN: () => CHILDREN_WINDOW_ERROR_WORD_TOKEN,
      CLAIMANT_PENDING_ACTIONS_FLAT_LIST_MAX: () => CLAIMANT_PENDING_ACTIONS_FLAT_LIST_MAX,
      CLAIMANT_PENDING_ACTIONS_LIMIT: () => CLAIMANT_PENDING_ACTIONS_LIMIT,
      CLAIMANT_PENDING_ACTIONS_STALE_TIME_MS: () => CLAIMANT_PENDING_ACTIONS_STALE_TIME_MS,
      CLAIM_ATTEMPTS_BY_USER_LIMIT: () => CLAIM_ATTEMPTS_BY_USER_LIMIT,
      CLAIM_ATTEMPT_IN_PROGRESS_WINDOW_MS: () => CLAIM_ATTEMPT_IN_PROGRESS_WINDOW_MS,
      CLAIM_BATCH_JOB_IN_FLIGHT_WINDOW_MS: () => CLAIM_BATCH_JOB_IN_FLIGHT_WINDOW_MS,
      CLAIM_CLASSIFIED_CLOSURE_STAGES: () => CLAIM_CLASSIFIED_CLOSURE_STAGES,
      CLAIM_ESTIMATE_CHANGES_CAP: () => CLAIM_ESTIMATE_CHANGES_CAP,
      CLAIM_ESTIMATE_HISTORY_START: () => CLAIM_ESTIMATE_HISTORY_START,
      CLAIM_FAILURE_STAGES: () => CLAIM_FAILURE_STAGES,
      CLAIM_STATUS_ROLE_DERIVATION_POLICY: () => CLAIM_STATUS_ROLE_DERIVATION_POLICY,
      CLAIM_STATUS_WILDCARD_ORDER: () => CLAIM_STATUS_WILDCARD_ORDER2,
      CLAIM_SUCCESS_STAGES: () => CLAIM_SUCCESS_STAGES,
      CUIT_IDENTIFICATION_LENGTH: () => CUIT_IDENTIFICATION_LENGTH3,
      CUIT_LEGAL_PERSON_PREFIXES: () => CUIT_LEGAL_PERSON_PREFIXES,
      CUIT_NATURAL_PERSON_PREFIXES: () => CUIT_NATURAL_PERSON_PREFIXES2,
      CUSTOMER_CLAIM_ORDERS_LIMIT: () => CUSTOMER_CLAIM_ORDERS_LIMIT,
      CUSTOMER_ORGANIZATION_INVITATION_TTL_DAYS: () => CUSTOMER_ORGANIZATION_INVITATION_TTL_DAYS,
      DAMAGES_VEHICLE_MARKET_VALUE_CHANGE_REASON: () => DAMAGES_VEHICLE_MARKET_VALUE_CHANGE_REASON,
      DEFAULT_CLAIM_PRESENTATION_PROFILE: () => DEFAULT_CLAIM_PRESENTATION_PROFILE,
      DEFAULT_COUNTRY_CODE: () => DEFAULT_COUNTRY_CODE2,
      DEFAULT_CURRENCY: () => DEFAULT_CURRENCY3,
      DEFAULT_ENDORSEMENT: () => DEFAULT_ENDORSEMENT,
      DEFAULT_ENTRYPOINT_SPECIFICATION: () => DEFAULT_ENTRYPOINT_SPECIFICATION2,
      DEFAULT_INSURER_NAVIGATION_PROFILE: () => DEFAULT_INSURER_NAVIGATION_PROFILE,
      DEFAULT_LOCALE: () => DEFAULT_LOCALE5,
      DEFAULT_ORDER_TAX_PERCENT: () => DEFAULT_ORDER_TAX_PERCENT2,
      DEFAULT_PIRAMID_THEME: () => DEFAULT_PIRAMID_THEME,
      DEFAULT_PUBLIC_OFFER_CANCELED_REASON: () => DEFAULT_PUBLIC_OFFER_CANCELED_REASON,
      DEFAULT_TIMEZONE: () => DEFAULT_TIMEZONE4,
      DERIVATION_CANDIDATES_LIMIT: () => DERIVATION_CANDIDATES_LIMIT,
      DERIVED_CLAIM_STATUS_ROLES: () => DERIVED_CLAIM_STATUS_ROLES,
      DERIVED_CLAIM_WHERE: () => DERIVED_CLAIM_WHERE,
      EMAIL_NAME_MATCH_TIER_MIN_PROBABILITY: () => EMAIL_NAME_MATCH_TIER_MIN_PROBABILITY,
      EMBEDDED_SIGNING_POLL_MS: () => EMBEDDED_SIGNING_POLL_MS,
      EMBEDDED_SIGNING_PREPARE_TIMEOUT_MS: () => EMBEDDED_SIGNING_PREPARE_TIMEOUT_MS,
      EMBEDDED_SIGNING_SIGNED_POLL_MS: () => EMBEDDED_SIGNING_SIGNED_POLL_MS,
      EMBEDDED_SIGNING_SLOW_NOTICE_MS: () => EMBEDDED_SIGNING_SLOW_NOTICE_MS,
      EMBEDDED_SIGNING_WINDOW_MS: () => EMBEDDED_SIGNING_WINDOW_MS,
      EVENT_DRIVEN_CLAIM_STATUS_ROLES: () => EVENT_DRIVEN_CLAIM_STATUS_ROLES,
      FALLBACK_LOCALE: () => FALLBACK_LOCALE,
      FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_RESULT: () => FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_RESULT,
      FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_STATUS: () => FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_STATUS,
      FRAUD_INVESTIGATION_STATUS_BY_KACH_WEBHOOK_EVENT: () => FRAUD_INVESTIGATION_STATUS_BY_KACH_WEBHOOK_EVENT,
      FRAUD_LOCKED_CLAIM_STATUS_ROLES: () => FRAUD_LOCKED_CLAIM_STATUS_ROLES,
      FRAUD_RESOLUTION_DERIVATION_CLOSURE_REASON: () => FRAUD_RESOLUTION_DERIVATION_CLOSURE_REASON,
      GAMMA_GLASS_BRAND_EDGE_NOISE: () => GAMMA_GLASS_BRAND_EDGE_NOISE,
      GAMMA_GLASS_BRAND_FORBIDDEN_CHARS: () => GAMMA_GLASS_BRAND_FORBIDDEN_CHARS,
      GAMMA_GLASS_BRAND_LIST_PATTERN: () => GAMMA_GLASS_BRAND_LIST_PATTERN,
      GAMMA_MAX_GLASS_COUNT: () => GAMMA_MAX_GLASS_COUNT,
      GAMMA_MIN_GLASS_COUNT: () => GAMMA_MIN_GLASS_COUNT,
      GAMMA_VERTICAL_SLUG: () => GAMMA_VERTICAL_SLUG,
      ICALENDAR_PRODID: () => ICALENDAR_PRODID,
      INSURER_SYSTEM_DERIVATION_CLOSURE_REASON: () => INSURER_SYSTEM_DERIVATION_CLOSURE_REASON,
      KACH_CASE_RESULTS: () => KACH_CASE_RESULTS,
      KACH_CASE_STATUSES: () => KACH_CASE_STATUSES2,
      KACH_CASE_VERDICT_RESULTS: () => KACH_CASE_VERDICT_RESULTS,
      KACH_CLAIM_RESULTS: () => KACH_CLAIM_RESULTS,
      KACH_DERIVATION_INSTANCE: () => KACH_DERIVATION_INSTANCE,
      KACH_EXCLUDED_SINISTER_TYPES: () => KACH_EXCLUDED_SINISTER_TYPES,
      KACH_INTEGRATION_PRODUCTION_LAUNCH_DATE: () => KACH_INTEGRATION_PRODUCTION_LAUNCH_DATE2,
      KACH_PARTICIPANT_SYNC_DISPATCH_BATCH_LIMIT: () => KACH_PARTICIPANT_SYNC_DISPATCH_BATCH_LIMIT,
      KACH_PARTICIPANT_SYNC_MAX_CLAIMS: () => KACH_PARTICIPANT_SYNC_MAX_CLAIMS,
      KACH_PARTICIPANT_SYNC_REDISPATCH_AFTER_MS: () => KACH_PARTICIPANT_SYNC_REDISPATCH_AFTER_MS,
      KACH_SINISTER_TYPE_BY_DAMAGE_CATEGORY: () => KACH_SINISTER_TYPE_BY_DAMAGE_CATEGORY,
      KACH_WEBHOOK_EVENTS: () => KACH_WEBHOOK_EVENTS2,
      LAST_ACTIVITY_EVENTS_PER_CLAIM_CAP: () => LAST_ACTIVITY_EVENTS_PER_CLAIM_CAP,
      LEGAL_PERSON_AGE_THRESHOLD: () => LEGAL_PERSON_AGE_THRESHOLD2,
      MAX_CLAIMED_AMOUNT: () => MAX_CLAIMED_AMOUNT2,
      MAX_CLAIMS_FOR_IN_MEMORY_SORT: () => MAX_CLAIMS_FOR_IN_MEMORY_SORT,
      MAX_CLAIM_ESTIMATE_AMOUNT: () => MAX_CLAIM_ESTIMATE_AMOUNT2,
      MAX_CLAIM_FILES_PER_UPLOAD: () => MAX_CLAIM_FILES_PER_UPLOAD3,
      MAX_IMPORTABLE_ORDER_FILES: () => MAX_IMPORTABLE_ORDER_FILES,
      MAX_IMPORTED_ORDER_FILES: () => MAX_IMPORTED_ORDER_FILES2,
      MAX_NEWS_REQUEST_FILES: () => MAX_NEWS_REQUEST_FILES2,
      MAX_ORDER_AMOUNT: () => MAX_ORDER_AMOUNT2,
      MAX_ORDER_ITEM_QUANTITY: () => MAX_ORDER_ITEM_QUANTITY2,
      MAX_ORDER_UNIT_PRICE: () => MAX_ORDER_UNIT_PRICE2,
      MAX_PRODUCT_EXPORT_ROWS: () => MAX_PRODUCT_EXPORT_ROWS,
      MAX_PRODUCT_IMPORT_COLUMNS: () => MAX_PRODUCT_IMPORT_COLUMNS,
      MAX_PRODUCT_IMPORT_ROWS: () => MAX_PRODUCT_IMPORT_ROWS,
      MAX_RFP_FILES: () => MAX_RFP_FILES4,
      MAX_STORED_ROW_ERRORS: () => MAX_STORED_ROW_ERRORS,
      MAX_TOTAL_AMOUNT: () => MAX_TOTAL_AMOUNT,
      NATURAL_PERSON_NAME_MAX_LENGTH: () => NATURAL_PERSON_NAME_MAX_LENGTH3,
      NEGOTIATION_AGGREGATES_WINDOW_MONTHS: () => NEGOTIATION_AGGREGATES_WINDOW_MONTHS,
      NEGOTIATION_CLAIMER_CLAIMS_LISTED: () => NEGOTIATION_CLAIMER_CLAIMS_LISTED,
      NEGOTIATION_MAX_CREDIBLE_RATIO: () => NEGOTIATION_MAX_CREDIBLE_RATIO,
      NEGOTIATION_MIN_ESCALATION_UNIVERSE_SIZE: () => NEGOTIATION_MIN_ESCALATION_UNIVERSE_SIZE,
      NEGOTIATION_TYPE_AVERAGE_MAX_AGE_MS: () => NEGOTIATION_TYPE_AVERAGE_MAX_AGE_MS,
      NEGOTIATION_TYPE_AVERAGE_REFRESH_AFTER_MS: () => NEGOTIATION_TYPE_AVERAGE_REFRESH_AFTER_MS,
      NEGOTIATION_TYPE_AVERAGE_REFRESH_LEASE_MS: () => NEGOTIATION_TYPE_AVERAGE_REFRESH_LEASE_MS,
      NEGOTIATION_TYPE_AVERAGE_SELF_CHANGE_MARGIN_MS: () => NEGOTIATION_TYPE_AVERAGE_SELF_CHANGE_MARGIN_MS,
      NETWORK_BRANCHES_MAP_LIMIT: () => NETWORK_BRANCHES_MAP_LIMIT,
      NOT_DERIVED_CLAIM_WHERE: () => NOT_DERIVED_CLAIM_WHERE,
      NO_COLLABORATOR_FILTER_VALUE: () => NO_COLLABORATOR_FILTER_VALUE,
      OFFER_ACCEPTANCE_FIELDS: () => OFFER_ACCEPTANCE_FIELDS2,
      OFFER_ACCEPTANCE_REQUIREMENTS_VERSION: () => OFFER_ACCEPTANCE_REQUIREMENTS_VERSION3,
      OFFER_AGREEMENT_ACTIVITY_EVENT_TYPES: () => OFFER_AGREEMENT_ACTIVITY_EVENT_TYPES2,
      OFFER_AGREEMENT_DISPATCH_BUDGET_MS: () => OFFER_AGREEMENT_DISPATCH_BUDGET_MS,
      OFFER_AGREEMENT_DOCUMENT_POLL_INTERVAL_MS: () => OFFER_AGREEMENT_DOCUMENT_POLL_INTERVAL_MS,
      OFFER_AGREEMENT_JOB_LEASE_MS: () => OFFER_AGREEMENT_JOB_LEASE_MS,
      OFFER_AGREEMENT_PROVIDER_CANCEL_RETRY_WINDOW_HOURS: () => OFFER_AGREEMENT_PROVIDER_CANCEL_RETRY_WINDOW_HOURS2,
      OFFER_AGREEMENT_RECONCILE_AFTER_HOURS: () => OFFER_AGREEMENT_RECONCILE_AFTER_HOURS,
      OFFER_AGREEMENT_RECONCILE_BATCH_LIMIT: () => OFFER_AGREEMENT_RECONCILE_BATCH_LIMIT,
      OFFER_AGREEMENT_RECONCILIATION_EVENT_TYPE: () => OFFER_AGREEMENT_RECONCILIATION_EVENT_TYPE,
      OFFER_AGREEMENT_SEALED_DOWNLOAD_TIMEOUT_MS: () => OFFER_AGREEMENT_SEALED_DOWNLOAD_TIMEOUT_MS,
      OFFER_AMOUNT_IN_WORDS_VARIABLE_NAME: () => OFFER_AMOUNT_IN_WORDS_VARIABLE_NAME,
      OFFER_AMOUNT_IN_WORDS_VARIABLE_NAMES: () => OFFER_AMOUNT_IN_WORDS_VARIABLE_NAMES,
      OFFER_AMOUNT_VARIABLE_NAME: () => OFFER_AMOUNT_VARIABLE_NAME3,
      OFFER_CANCELED_ON_CLAIM_CLOSE_REASON: () => OFFER_CANCELED_ON_CLAIM_CLOSE_REASON,
      OFFER_DEFAULT_FEE_PERCENTAGE: () => OFFER_DEFAULT_FEE_PERCENTAGE2,
      OFFER_DEFAULT_PAYMENT_DAYS: () => OFFER_DEFAULT_PAYMENT_DAYS2,
      OFFER_EXPIRATION_DAYS: () => OFFER_EXPIRATION_DAYS,
      OFFER_FEES_VARIABLE_NAME: () => OFFER_FEES_VARIABLE_NAME,
      OFFER_FEE_PERCENTAGE_OPTIONS: () => OFFER_FEE_PERCENTAGE_OPTIONS2,
      OFFER_INSTALLMENTS_VARIABLE_NAME: () => OFFER_INSTALLMENTS_VARIABLE_NAME,
      OFFER_INSTALLMENT_OPTIONS: () => OFFER_INSTALLMENT_OPTIONS2,
      OFFER_OUTCOME_DERIVATION_CLOSURE_REASON: () => OFFER_OUTCOME_DERIVATION_CLOSURE_REASON,
      OFFER_PAYMENT_DAYS_OPTIONS: () => OFFER_PAYMENT_DAYS_OPTIONS2,
      OFFER_PAYMENT_DAYS_VARIABLE_NAMES: () => OFFER_PAYMENT_DAYS_VARIABLE_NAMES,
      OFFER_PAYMENT_METHOD_LABELS: () => OFFER_PAYMENT_METHOD_LABELS2,
      OFFER_PUBLIC_REASON_VARIABLE_NAMES: () => OFFER_PUBLIC_REASON_VARIABLE_NAMES,
      OFFER_SINGLE_PAYMENT_INSTALLMENTS: () => OFFER_SINGLE_PAYMENT_INSTALLMENTS2,
      OPENAI_DECISIONS_MODEL: () => OPENAI_DECISIONS_MODEL,
      OPENAI_DECISIONS_TIMEOUT_MS: () => OPENAI_DECISIONS_TIMEOUT_MS,
      OPENAI_DECISIONS_URL: () => OPENAI_DECISIONS_URL,
      OPEN_CLAIM_DERIVATION_WHERE: () => OPEN_CLAIM_DERIVATION_WHERE,
      ORDER_ACTION_ITEMS_LIMIT: () => ORDER_ACTION_ITEMS_LIMIT,
      ORDER_CALENDAR_UID_DOMAIN: () => ORDER_CALENDAR_UID_DOMAIN,
      ORDER_CANDIDATES_PAGE_SIZE: () => ORDER_CANDIDATES_PAGE_SIZE,
      ORDER_CANDIDATES_RELAXED_PAGE_SIZE: () => ORDER_CANDIDATES_RELAXED_PAGE_SIZE,
      ORDER_CLAIM_STATUS_ROLES: () => ORDER_CLAIM_STATUS_ROLES,
      ORDER_REFERENCE_PREFIX: () => ORDER_REFERENCE_PREFIX,
      ORDER_REPORT_CSV_DELIMITER: () => ORDER_REPORT_CSV_DELIMITER,
      ORDER_REPORT_DEFAULT_COLUMNS: () => ORDER_REPORT_DEFAULT_COLUMNS,
      ORDER_REPORT_ITEMS_SEPARATOR: () => ORDER_REPORT_ITEMS_SEPARATOR,
      ORDER_SCHEDULE_BRANCH_OPTIONS_LIMIT: () => ORDER_SCHEDULE_BRANCH_OPTIONS_LIMIT,
      ORDER_SCHEDULE_CALENDAR_DURATION_MINUTES: () => ORDER_SCHEDULE_CALENDAR_DURATION_MINUTES,
      ORDER_SCHEDULE_HISTORY_LIMIT: () => ORDER_SCHEDULE_HISTORY_LIMIT,
      ORDER_SCHEDULING_MAX_PAST_DAYS: () => ORDER_SCHEDULING_MAX_PAST_DAYS2,
      ORDER_SCHEDULING_NOTE_MAX_LENGTH: () => ORDER_SCHEDULING_NOTE_MAX_LENGTH2,
      ORDER_TAX_PERCENTS: () => ORDER_TAX_PERCENTS,
      PERFORMANCE_CLOSED_RATE_BASE: () => PERFORMANCE_CLOSED_RATE_BASE,
      PERFORMANCE_COHORT_MIN_START_AGE_DAYS: () => PERFORMANCE_COHORT_MIN_START_AGE_DAYS,
      PERFORMANCE_FRAUD_STATUS_ROLE: () => PERFORMANCE_FRAUD_STATUS_ROLE,
      PERFORMANCE_METRICS_STALE_TIME_MS: () => PERFORMANCE_METRICS_STALE_TIME_MS,
      PERFORMANCE_NORTH_STAR_TREND_MIN_DAYS: () => PERFORMANCE_NORTH_STAR_TREND_MIN_DAYS,
      PERFORMANCE_OFFER_READINESS_PROPERTIES: () => PERFORMANCE_OFFER_READINESS_PROPERTIES,
      PERFORMANCE_OUTCOME_COHORT_DEFAULT_MONTHS: () => PERFORMANCE_OUTCOME_COHORT_DEFAULT_MONTHS,
      PERFORMANCE_REVIEW_CSV_LIMIT: () => PERFORMANCE_REVIEW_CSV_LIMIT,
      PERFORMANCE_RISK_ZONE_CRITICAL_SCORE_THRESHOLD: () => PERFORMANCE_RISK_ZONE_CRITICAL_SCORE_THRESHOLD,
      PERFORMANCE_RISK_ZONE_MIN_DAYS_OPEN: () => PERFORMANCE_RISK_ZONE_MIN_DAYS_OPEN,
      PERFORMANCE_RISK_ZONE_QUERY_LIMIT: () => PERFORMANCE_RISK_ZONE_QUERY_LIMIT,
      PERFORMANCE_RISK_ZONE_REFERENCE_MONTHS: () => PERFORMANCE_RISK_ZONE_REFERENCE_MONTHS,
      PERFORMANCE_RISK_ZONE_SCORE_THRESHOLD: () => PERFORMANCE_RISK_ZONE_SCORE_THRESHOLD,
      PERFORMANCE_RISK_ZONE_TABLE_ROWS: () => PERFORMANCE_RISK_ZONE_TABLE_ROWS,
      PERFORMANCE_RISK_ZONE_TOP_CLAIMS: () => PERFORMANCE_RISK_ZONE_TOP_CLAIMS,
      PERFORMANCE_RUNWAY_MONTHS: () => PERFORMANCE_RUNWAY_MONTHS,
      PERFORMANCE_SNAPSHOT_MAX_STALE_MS: () => PERFORMANCE_SNAPSHOT_MAX_STALE_MS,
      PERFORMANCE_SNAPSHOT_RETENTION_DAYS: () => PERFORMANCE_SNAPSHOT_RETENTION_DAYS,
      PERFORMANCE_SNAPSHOT_TTL_MS: () => PERFORMANCE_SNAPSHOT_TTL_MS,
      PERFORMANCE_TREND_MONTHS: () => PERFORMANCE_TREND_MONTHS,
      PRODUCT_EXPORT_DELIMITER: () => PRODUCT_EXPORT_DELIMITER,
      PRODUCT_EXPORT_HEADERS: () => PRODUCT_EXPORT_HEADERS,
      PRODUCT_IMPORT_CHUNK_SIZE: () => PRODUCT_IMPORT_CHUNK_SIZE,
      PRODUCT_IMPORT_FILE_EXTENSION: () => PRODUCT_IMPORT_FILE_EXTENSION,
      PRODUCT_IMPORT_SAMPLE_ROWS: () => PRODUCT_IMPORT_SAMPLE_ROWS,
      PRODUCT_IMPORT_TEMPLATE_ROWS: () => PRODUCT_IMPORT_TEMPLATE_ROWS,
      PRODUCT_IMPORT_WRITE_CONCURRENCY: () => PRODUCT_IMPORT_WRITE_CONCURRENCY,
      PROVIDER_INVITATION_TTL_DAYS: () => PROVIDER_INVITATION_TTL_DAYS,
      PUBLIC_ASSETS_BASE_URL: () => PUBLIC_ASSETS_BASE_URL2,
      RECORDING_RETENTION_DAYS: () => RECORDING_RETENTION_DAYS,
      RELEASE_NOTES_LIST_LIMIT: () => RELEASE_NOTES_LIST_LIMIT,
      RELEASE_NOTES_PATH: () => RELEASE_NOTES_PATH,
      RELEASE_NOTES_SEARCH_EVENT_DELAY_MS: () => RELEASE_NOTES_SEARCH_EVENT_DELAY_MS,
      RELEASE_NOTES_SEARCH_QUERY_MAX_LENGTH: () => RELEASE_NOTES_SEARCH_QUERY_MAX_LENGTH2,
      RELEASE_NOTES_SIDEBAR_STALE_TIME_MS: () => RELEASE_NOTES_SIDEBAR_STALE_TIME_MS,
      RELEASE_NOTE_ADOPTION_WEEKS_AFTER_LIMIT: () => RELEASE_NOTE_ADOPTION_WEEKS_AFTER_LIMIT,
      RELEASE_NOTE_ADOPTION_WEEKS_BEFORE: () => RELEASE_NOTE_ADOPTION_WEEKS_BEFORE,
      RELEASE_NOTE_EVENTS_BATCH_LIMIT: () => RELEASE_NOTE_EVENTS_BATCH_LIMIT2,
      RELEASE_NOTE_EVENTS_FLUSH_INTERVAL_MS: () => RELEASE_NOTE_EVENTS_FLUSH_INTERVAL_MS,
      RELEASE_NOTE_ITEM_VIEW_DWELL_MS: () => RELEASE_NOTE_ITEM_VIEW_DWELL_MS,
      RELEASE_NOTE_ITEM_VIEW_RATIO: () => RELEASE_NOTE_ITEM_VIEW_RATIO,
      RELEASE_NOTE_VIEWERS_SAMPLE_LIMIT: () => RELEASE_NOTE_VIEWERS_SAMPLE_LIMIT,
      REVELACION_DATA_EMAIL_DOMAIN: () => REVELACION_DATA_EMAIL_DOMAIN2,
      REVIEW_CREATION_TIME_BUCKETS: () => REVIEW_CREATION_TIME_BUCKETS,
      REVIEW_HEATMAP_DIMS_BY_TAB: () => REVIEW_HEATMAP_DIMS_BY_TAB,
      REVIEW_RESOLUTION_TIME_BUCKETS: () => REVIEW_RESOLUTION_TIME_BUCKETS,
      REVIEW_SCORE_BREAKDOWN_DIMS_BY_TAB: () => REVIEW_SCORE_BREAKDOWN_DIMS_BY_TAB,
      REVIEW_SCORE_COLORS: () => REVIEW_SCORE_COLORS,
      REVIEW_TAB_TO_TYPE: () => REVIEW_TAB_TO_TYPE,
      RISK_ZONE_CLOSED_EVALUATION_DAYS: () => RISK_ZONE_CLOSED_EVALUATION_DAYS,
      RISK_ZONE_DATA_START: () => RISK_ZONE_DATA_START,
      RISK_ZONE_MATRIX_MATURITY_MONTHS: () => RISK_ZONE_MATRIX_MATURITY_MONTHS,
      RISK_ZONE_PLACEHOLDER_AMOUNT: () => RISK_ZONE_PLACEHOLDER_AMOUNT,
      RISK_ZONE_POINTS_PER_DOUBLING: () => RISK_ZONE_POINTS_PER_DOUBLING,
      RISK_ZONE_QUERY_LIMIT: () => RISK_ZONE_QUERY_LIMIT,
      RISK_ZONE_TENANT_SLUG: () => RISK_ZONE_TENANT_SLUG,
      RISK_ZONE_TOP_CLAIMS: () => RISK_ZONE_TOP_CLAIMS,
      RISK_ZONE_WINDOW_MONTHS: () => RISK_ZONE_WINDOW_MONTHS,
      SHOW_OFFER_PAYMENT_HINTS: () => SHOW_OFFER_PAYMENT_HINTS,
      STOPWORDS_ES: () => STOPWORDS_ES,
      SYSTEM_EMAIL: () => SYSTEM_EMAIL,
      TEAM_ACTIVITY_PAGE_SIZE: () => TEAM_ACTIVITY_PAGE_SIZE,
      TEAM_CRITICAL_CLAIM_MIN_DAYS: () => TEAM_CRITICAL_CLAIM_MIN_DAYS,
      TEAM_DELEGATION_POLL_INTERVAL_MS: () => TEAM_DELEGATION_POLL_INTERVAL_MS,
      TEAM_DELEGATION_REQUEUE_WINDOW_MS: () => TEAM_DELEGATION_REQUEUE_WINDOW_MS,
      TEAM_DELEGATION_REVIEW_NOTICE_LEAD_BUSINESS_DAYS: () => TEAM_DELEGATION_REVIEW_NOTICE_LEAD_BUSINESS_DAYS,
      TEAM_LOAD_HIGH_MARGIN_PERCENT: () => TEAM_LOAD_HIGH_MARGIN_PERCENT,
      TEAM_LOAD_OVERLOADED_MARGIN_PERCENT: () => TEAM_LOAD_OVERLOADED_MARGIN_PERCENT,
      TEAM_MEMBERS_PAGE_SIZE: () => TEAM_MEMBERS_PAGE_SIZE,
      TEAM_MEMBER_CLAIMS_LIMIT: () => TEAM_MEMBER_CLAIMS_LIMIT2,
      TENANT_SLUG_HEADER_KEY: () => TENANT_SLUG_HEADER_KEY,
      TERMINAL_CASE_RESULTS_WITHOUT_CLOSE: () => TERMINAL_CASE_RESULTS_WITHOUT_CLOSE,
      TEST_TENANT_SLUGS: () => TEST_TENANT_SLUGS,
      THEME_COLORS: () => THEME_COLORS,
      USER_TYPE_COOKIE_NAME: () => USER_TYPE_COOKIE_NAME,
      VEHICLE_ID_CARD_UPLOAD_ENABLED: () => VEHICLE_ID_CARD_UPLOAD_ENABLED,
      WORK_PROOF_VERDICT_CLAIM_STATUS_ROLE: () => WORK_PROOF_VERDICT_CLAIM_STATUS_ROLE,
      acceptanceCheckStatuses: () => acceptanceCheckStatuses2,
      acceptanceLawyerBlockers: () => acceptanceLawyerBlockers2,
      acceptancePayeeBlockers: () => acceptancePayeeBlockers2,
      acceptancePayeeCases: () => acceptancePayeeCases2,
      acceptancePayeeIssueCodes: () => acceptancePayeeIssueCodes2,
      acceptancePayeeRelations: () => acceptancePayeeRelations2,
      actions: () => actions,
      agreementBindingConcepts: () => agreementBindingConcepts3,
      agreementBindingDeterminations: () => agreementBindingDeterminations2,
      agreementBlockKinds: () => agreementBlockKinds,
      agreementCeremonyEntries: () => agreementCeremonyEntries,
      agreementClauseOrdinals: () => agreementClauseOrdinals2,
      agreementConditionResults: () => agreementConditionResults2,
      agreementConditionUndeterminedReasons: () => agreementConditionUndeterminedReasons2,
      agreementDateFormats: () => agreementDateFormats,
      agreementDocumentResolutionFallbacks: () => agreementDocumentResolutionFallbacks2,
      agreementDocumentResolutions: () => agreementDocumentResolutions2,
      agreementDocumentSignatureSources: () => agreementDocumentSignatureSources2,
      agreementDocumentStatusCodes: () => agreementDocumentStatusCodes2,
      agreementGapClasses: () => agreementGapClasses2,
      agreementLawyerKinds: () => agreementLawyerKinds3,
      agreementMissingReasons: () => agreementMissingReasons3,
      agreementNotApplicableReasons: () => agreementNotApplicableReasons3,
      agreementPersonKinds: () => agreementPersonKinds2,
      agreementPersonVariableFields: () => agreementPersonVariableFields2,
      agreementPlaceholderToken: () => agreementPlaceholderToken2,
      agreementPlanGapKinds: () => agreementPlanGapKinds2,
      agreementPlanOutcomes: () => agreementPlanOutcomes2,
      agreementPlanReasons: () => agreementPlanReasons2,
      agreementPlanRecipientReasons: () => agreementPlanRecipientReasons2,
      agreementPlanStages: () => agreementPlanStages2,
      agreementRuleAttribute: () => agreementRuleAttribute3,
      agreementRuleAttributeGroups: () => agreementRuleAttributeGroups,
      agreementRuleAttributeKeys: () => agreementRuleAttributeKeys,
      agreementRuleAttributeTypes: () => agreementRuleAttributeTypes,
      agreementRuleAttributes: () => agreementRuleAttributes,
      agreementRuleAttributesFor: () => agreementRuleAttributesFor,
      agreementRuleNullSemantics: () => agreementRuleNullSemantics,
      agreementRuleOperators: () => agreementRuleOperators3,
      agreementRuleOperatorsFor: () => agreementRuleOperatorsFor2,
      agreementRuleOptionSourceOf: () => agreementRuleOptionSourceOf2,
      agreementRuleOptionSources: () => agreementRuleOptionSources2,
      agreementRuleResults: () => agreementRuleResults2,
      agreementRuleStages: () => agreementRuleStages,
      agreementRuleValueShapeFor: () => agreementRuleValueShapeFor2,
      agreementRuleValueShapes: () => agreementRuleValueShapes,
      agreementSignatureMethods: () => agreementSignatureMethods2,
      agreementSignatureOrigins: () => agreementSignatureOrigins,
      agreementSignatureOutcomes: () => agreementSignatureOutcomes2,
      agreementSignatureToken: () => agreementSignatureToken2,
      agreementSignerParties: () => agreementSignerParties3,
      agreementTemplateKinds: () => agreementTemplateKinds2,
      agreementVariableGroups: () => agreementVariableGroups,
      agreementVariableKeys: () => agreementVariableKeys,
      agreementVariableStageOf: () => agreementVariableStageOf2,
      agreementVariableStages: () => agreementVariableStages,
      agreementVariableStatuses: () => agreementVariableStatuses,
      agreementVariableTypes: () => agreementVariableTypes2,
      agreementVariables: () => agreementVariables2,
      agreementWarningCodes: () => agreementWarningCodes2,
      alertEnvironmentTags: () => alertEnvironmentTags2,
      alertTables: () => alertTables,
      argentinaCities: () => argentinaCities,
      argentinaStateParties: () => argentinaStateParties,
      argentinaStates: () => argentinaStates,
      argentinaStatesRequiredParty: () => argentinaStatesRequiredParty,
      assignmentPauseScope: () => assignmentPauseScope,
      attorneyVictimRelationships: () => attorneyVictimRelationships2,
      autosignConnectionStatuses: () => autosignConnectionStatuses,
      autosignTransactionEventTypes: () => autosignTransactionEventTypes,
      backofficeOrderReportColumns: () => backofficeOrderReportColumns2,
      blockingNewClaimReasons: () => blockingNewClaimReasons,
      bodyParts: () => bodyParts3,
      booleansString: () => booleansString6,
      canReadAllClaims: () => canReadAllClaims,
      catalogBackedVehicleTypes: () => catalogBackedVehicleTypes,
      claimAgreementAbsenceReasons: () => claimAgreementAbsenceReasons,
      claimCheckAttributes: () => claimCheckAttributes2,
      claimClosingIngestEvents: () => claimClosingIngestEvents,
      claimCombinations: () => claimCombinations2,
      claimPresentationProfiles: () => claimPresentationProfiles,
      claimReactiveFormFlowSteps: () => claimReactiveFormFlowSteps,
      claimReportColumns: () => claimReportColumns2,
      claimSummaryCardKeys: () => claimSummaryCardKeys,
      claimTypes: () => claimTypes5,
      claimVehicleUses: () => claimVehicleUses,
      claimantPendingActionTypes: () => claimantPendingActionTypes,
      claimantVictimIdentityFields: () => claimantVictimIdentityFields3,
      claimantVictimIdentityIssues: () => claimantVictimIdentityIssues2,
      claimantVictimRelationships: () => claimantVictimRelationships,
      claimants: () => claimants,
      classifyTeamLoad: () => classifyTeamLoad,
      classifyWorstTeamLoad: () => classifyWorstTeamLoad,
      companyPersonEventMetadataKeys: () => companyPersonEventMetadataKeys,
      companyServiceBackends: () => companyServiceBackends,
      companyServices: () => companyServices,
      complaintCheckAttributes: () => complaintCheckAttributes,
      complaintReactiveFormFlowSteps: () => complaintReactiveFormFlowSteps,
      complaintWithLicensePlateVehicleTypes: () => complaintWithLicensePlateVehicleTypes2,
      computeTeamLoadThresholds: () => computeTeamLoadThresholds,
      countryAndStates: () => countryAndStates4,
      countryCodesAndName: () => countryCodesAndName,
      countryCuit: () => countryCuit,
      countryCurrencyList: () => countryCurrencyList,
      currencySymbolLabels: () => currencySymbolLabels,
      currencySymbolLocaleEquivalences: () => currencySymbolLocaleEquivalences2,
      customerUserTypes: () => customerUserTypes,
      damageTypes: () => damageTypes,
      datasetEntities: () => datasetEntities,
      datasetEntityKeys: () => datasetEntityKeys,
      deathClaimantVictimRelationships: () => deathClaimantVictimRelationships,
      decimalAmountFormatExamples: () => decimalAmountFormatExamples,
      decimalAmountFormats: () => decimalAmountFormats2,
      defaultAgreementVariableBindings: () => defaultAgreementVariableBindings3,
      defaultElapsedDurationCriteria: () => defaultElapsedDurationCriteria2,
      delegateClaimStrategies: () => delegateClaimStrategies,
      delegateComplaintStrategies: () => delegateComplaintStrategies,
      delegationOverloadThreshold: () => delegationOverloadThreshold,
      deriveClaimStrategies: () => deriveClaimStrategies2,
      deriveComplaintStrategies: () => deriveComplaintStrategies,
      distinctList: () => distinctList,
      documentApps: () => documentApps,
      documentTemplates: () => documentTemplates,
      documentTypes: () => documentTypes,
      documentValidations: () => documentValidations,
      documentVariants: () => documentVariants4,
      driverVehicleOwnership: () => driverVehicleOwnership3,
      elapsedDurationCriteriaOptsByType: () => elapsedDurationCriteriaOptsByType2,
      emailNameMatchTiers: () => emailNameMatchTiers,
      embeddedSigningIneligibleReasons: () => embeddedSigningIneligibleReasons,
      embeddedSigningPreparingStages: () => embeddedSigningPreparingStages,
      embeddedSigningStatuses: () => embeddedSigningStatuses,
      embeddedSigningUnavailableReasons: () => embeddedSigningUnavailableReasons,
      fieldAdjusterClaimStatus: () => fieldAdjusterClaimStatus2,
      flattenDamageTypeToParentType: () => flattenDamageTypeToParentType,
      flattenDamageTypes: () => flattenDamageTypes,
      formatMoneyInCurrency: () => formatMoneyInCurrency,
      getAllColumnPaths: () => getAllColumnPaths,
      getClaimPresentationProfile: () => getClaimPresentationProfile,
      getInsurerClaimColumns: () => getInsurerClaimColumns,
      getInsurerNavigationProfile: () => getInsurerNavigationProfile,
      identityProviders: () => identityProviders2,
      inactivityEndOutcomes: () => inactivityEndOutcomes,
      inactivityReasons: () => inactivityReasons4,
      insurerClaimColumnProfiles: () => insurerClaimColumnProfiles,
      insurerClaimColumns: () => insurerClaimColumns,
      insurerClaimFilters: () => insurerClaimFilters,
      insurerComplaintColumns: () => insurerComplaintColumns,
      insurerComplaintFilters: () => insurerComplaintFilters,
      insurerNavigationProfiles: () => insurerNavigationProfiles,
      insurerNavigationSections: () => insurerNavigationSections,
      insurerSinisterColumns: () => insurerSinisterColumns,
      integrationTemplateParentObjectReferences: () => integrationTemplateParentObjectReferences2,
      invalidChassisMessage: () => invalidChassisMessage2,
      invalidEngineMessage: () => invalidEngineMessage2,
      isActiveFraudDerivationClaim: () => isActiveFraudDerivationClaim,
      isAgreementDynamicVariableKey: () => isAgreementDynamicVariableKey2,
      isAgreementRuleAttributeKey: () => isAgreementRuleAttributeKey2,
      isAgreementRuleAttributeSearchable: () => isAgreementRuleAttributeSearchable,
      isAgreementVariableKey: () => isAgreementVariableKey2,
      isAttorneyVictimRelationship: () => isAttorneyVictimRelationship2,
      isCatalogBackedVehicleType: () => isCatalogBackedVehicleType,
      isClaimLockedByFraudInvestigation: () => isClaimLockedByFraudInvestigation,
      isEventDrivenClaimStatusRole: () => isEventDrivenClaimStatusRole,
      isExcludedKachSinisterType: () => isExcludedKachSinisterType2,
      isFraudLockedClaimStatusRole: () => isFraudLockedClaimStatusRole,
      isKachCaseResult: () => isKachCaseResult,
      isKachWebhookEvent: () => isKachWebhookEvent,
      isNewClaimBlocked: () => isNewClaimBlocked,
      isOpenClaimDerivation: () => isOpenClaimDerivation,
      isOrderClaimStatusRole: () => isOrderClaimStatusRole,
      isOrderTaxPercent: () => isOrderTaxPercent2,
      isPersonIdentityRestricted: () => isPersonIdentityRestricted,
      isPropagableBackend: () => isPropagableBackend,
      isRecordingExpired: () => isRecordingExpired,
      isRevelacionDataEmail: () => isRevelacionDataEmail2,
      isSameKachEnumName: () => isSameKachEnumName,
      isTerminalCaseResultWithoutClose: () => isTerminalCaseResultWithoutClose,
      isTestTenantSlug: () => isTestTenantSlug,
      kachDamageCategories: () => kachDamageCategories,
      legacyPublicAssetsBaseUrls: () => legacyPublicAssetsBaseUrls,
      legalPersonClaimantVictimRelationships: () => legalPersonClaimantVictimRelationships,
      loadBalanceRuleFields: () => loadBalanceRuleFields,
      messageTemplateContextPaths: () => messageTemplateContextPaths2,
      messageTemplateContextPathsByScope: () => messageTemplateContextPathsByScope,
      metricsCountGroupBy: () => metricsCountGroupBy,
      metricsFrequency: () => metricsFrequency2,
      metricsHistogramBuckets: () => metricsHistogramBuckets2,
      naturalPersonNameMaxLengthMessage: () => naturalPersonNameMaxLengthMessage3,
      negotiationStageReadPermission: () => negotiationStageReadPermission2,
      negotiationStageStates: () => negotiationStageStates,
      negotiationStages: () => negotiationStages,
      newClaimBlockReasons: () => newClaimBlockReasons,
      noAttorneyVictimRelationships: () => noAttorneyVictimRelationships,
      nonLicensePlateClaimVehicleUses: () => nonLicensePlateClaimVehicleUses,
      notificationEventsSupported: () => notificationEventsSupported,
      notificationScopes: () => notificationScopes2,
      occurrenceCirculationDirection: () => occurrenceCirculationDirection,
      offerAcceptanceField: () => offerAcceptanceField3,
      offerAcceptanceFieldKeys: () => offerAcceptanceFieldKeys2,
      offerAcceptanceFieldTypes: () => offerAcceptanceFieldTypes2,
      offerAgreementCancelNotices: () => offerAgreementCancelNotices,
      offerAgreementDispatchFailureCodes: () => offerAgreementDispatchFailureCodes3,
      offerAgreementDispatchFailureKind: () => offerAgreementDispatchFailureKind,
      offerAgreementGenerationSkipReasons: () => offerAgreementGenerationSkipReasons,
      offerAgreementJobTypes: () => offerAgreementJobTypes,
      offerAgreementObservationOrigins: () => offerAgreementObservationOrigins,
      offerAgreementPhases: () => offerAgreementPhases,
      offerAgreementProgressStepStates: () => offerAgreementProgressStepStates,
      offerAgreementProgressSteps: () => offerAgreementProgressSteps,
      offerAgreementProviderCancelOutcomes: () => offerAgreementProviderCancelOutcomes2,
      offerAgreementProviderCancelStatuses: () => offerAgreementProviderCancelStatuses,
      offerAgreementTransitionIgnoreReasons: () => offerAgreementTransitionIgnoreReasons,
      offerPayees: () => offerPayees4,
      offerPaymentMethods: () => offerPaymentMethods2,
      onboardingSteps: () => onboardingSteps,
      openAIDecisionQueries: () => openAIDecisionQueries,
      orderReportColumns: () => orderReportColumns2,
      orderScheduleFloor: () => orderScheduleFloor2,
      orderTypeSubTypes: () => orderTypeSubTypes2,
      paraguayCities: () => paraguayCities,
      performanceAgingBucketLimits: () => performanceAgingBucketLimits,
      performanceAgingBuckets: () => performanceAgingBuckets,
      performanceAllClosedStages: () => performanceAllClosedStages,
      performanceBacklogAgeAgingBucket: () => performanceBacklogAgeAgingBucket,
      performanceBacklogAgeBucketLimits: () => performanceBacklogAgeBucketLimits,
      performanceBacklogAgeBuckets: () => performanceBacklogAgeBuckets,
      performanceClosingOutcomes: () => performanceClosingOutcomes2,
      performanceCohortHeatmapThresholds: () => performanceCohortHeatmapThresholds,
      performanceCohortRateBases: () => performanceCohortRateBases,
      performanceCohortSummaryPercentiles: () => performanceCohortSummaryPercentiles,
      performanceCohortSummaryStats: () => performanceCohortSummaryStats,
      performanceConciliationOutcomeStages: () => performanceConciliationOutcomeStages,
      performanceFraudInvestigationStageName: () => performanceFraudInvestigationStageName,
      performanceFunnelSpecialStages: () => performanceFunnelSpecialStages,
      performanceFunnelStageOrder: () => performanceFunnelStageOrder,
      performanceHeatmapThresholds: () => performanceHeatmapThresholds,
      performanceNegotiationStages: () => performanceNegotiationStages,
      performanceOfferableExcludedStatusNames: () => performanceOfferableExcludedStatusNames,
      performanceOperativeStages: () => performanceOperativeStages,
      performanceRiskAmountFilterMinimums: () => performanceRiskAmountFilterMinimums,
      performanceRiskAmountFilters: () => performanceRiskAmountFilters2,
      performanceStageNames: () => performanceStageNames,
      performanceTechnicalStages: () => performanceTechnicalStages,
      permissionLabelType: () => permissionLabelType,
      permissionsWithLabel: () => permissionsWithLabel,
      personDamageTypes: () => personDamageTypes,
      personParents: () => personParents,
      productImportDelimiters: () => productImportDelimiters2,
      productImportEncodings: () => productImportEncodings2,
      productImportFalsyValues: () => productImportFalsyValues,
      productImportHeaderAliases: () => productImportHeaderAliases,
      productImportRowErrorCodes: () => productImportRowErrorCodes2,
      productImportTargetFields: () => productImportTargetFields2,
      productImportTruthyValues: () => productImportTruthyValues,
      providerUserTypes: () => providerUserTypes,
      realPropertyOwnershipTypes: () => realPropertyOwnershipTypes2,
      realPropertyTypes: () => realPropertyTypes2,
      recoveryVictimRelationships: () => recoveryVictimRelationships,
      releaseNotePath: () => releaseNotePath,
      requiredCompanyFields: () => requiredCompanyFields,
      requiredFieldMessage: () => requiredFieldMessage38,
      resolveFraudInvestigationStatusFromKachCase: () => resolveFraudInvestigationStatusFromKachCase,
      resolveFraudInvestigationStatusOnCaseUpdate: () => resolveFraudInvestigationStatusOnCaseUpdate,
      resolveFraudInvestigationStatusOnKachCaseStatus: () => resolveFraudInvestigationStatusOnKachCaseStatus,
      resources: () => resources,
      retrieveCaseInspectionTokenResource: () => retrieveCaseInspectionTokenResource,
      reviewBlocks: () => reviewBlocks,
      reviewFilters: () => reviewFilters,
      reviewHeatmapDims: () => reviewHeatmapDims2,
      reviewRespondentRelationshipLabel: () => reviewRespondentRelationshipLabel,
      reviewRespondentRelationships: () => reviewRespondentRelationships,
      reviewScoreBreakdownDims: () => reviewScoreBreakdownDims2,
      reviewTabs: () => reviewTabs2,
      reviewTypes: () => reviewTypes3,
      riskZoneClaimTypeNames: () => riskZoneClaimTypeNames,
      riskZoneClaimTypes: () => riskZoneClaimTypes2,
      riskZoneEscalatedOutcomes: () => riskZoneEscalatedOutcomes,
      riskZoneMatrixOutcomes: () => riskZoneMatrixOutcomes,
      riskZoneModels: () => riskZoneModels,
      riskZoneOutcomes: () => riskZoneOutcomes,
      riskZoneSignalIds: () => riskZoneSignalIds,
      riskZoneZoneMinPoints: () => riskZoneZoneMinPoints,
      riskZoneZoneMinScores: () => riskZoneZoneMinScores,
      riskZoneZones: () => riskZoneZones,
      searchableEntities: () => searchableEntities2,
      sessionTypes: () => sessionTypes,
      sexTypes: () => sexTypes2,
      signatureDispatchBlockerCodes: () => signatureDispatchBlockerCodes,
      sinisterObjectOptions: () => sinisterObjectOptions,
      sinisterObjectValues: () => sinisterObjectValues3,
      slaReportColumns: () => slaReportColumns2,
      slaTypesWithTotalDuration: () => slaTypesWithTotalDuration2,
      sortTypes: () => sortTypes5,
      ssnStatementCsvOutputKeys: () => ssnStatementCsvOutputKeys,
      teamActivityCategories: () => teamActivityCategories2,
      teamActivityCategoryEventTypes: () => teamActivityCategoryEventTypes,
      teamActivityEventTypes: () => teamActivityEventTypes,
      teamClaimsReassignScope: () => teamClaimsReassignScope,
      teamDelegationCategories: () => teamDelegationCategories3,
      teamDelegationClaimScopes: () => teamDelegationClaimScopes2,
      teamDelegationModes: () => teamDelegationModes,
      teamDelegationStrategies: () => teamDelegationStrategies3,
      teamDelegationTriggers: () => teamDelegationTriggers3,
      teamInactivityScope: () => teamInactivityScope,
      teamLoadLevels: () => teamLoadLevels,
      teamManagementScope: () => teamManagementScope,
      teamMemberAvailabilityStates: () => teamMemberAvailabilityStates,
      teamType: () => teamType,
      themes: () => themes,
      thirdPartyLabeledRelationships: () => thirdPartyLabeledRelationships,
      thirdPartyProfessionalRelationships: () => thirdPartyProfessionalRelationships,
      timezones: () => timezones,
      toAgreementDocumentStatusCode: () => toAgreementDocumentStatusCode,
      toOfferAgreementDispatchFailureCode: () => toOfferAgreementDispatchFailureCode,
      transformationApplyTo: () => transformationApplyTo,
      transformers: () => transformers,
      userAssignmentsResumeReasons: () => userAssignmentsResumeReasons2,
      userAvailabilityJobTypes: () => userAvailabilityJobTypes,
      userClaimBatchJobTypes: () => userClaimBatchJobTypes,
      userTypes: () => userTypes2,
      validationMessages: () => validationMessages,
      vehicleDocumentTypes: () => vehicleDocumentTypes2,
      vehicleIdCardExtractionOutcomes: () => vehicleIdCardExtractionOutcomes,
      vehicleIdCardStatuses: () => vehicleIdCardStatuses,
      vehicleIdentificationKeys: () => vehicleIdentificationKeys,
      vehicleUses: () => vehicleUses,
      victimInjuriesRolesWithMaterialDamage: () => victimInjuriesRolesWithMaterialDamage,
      virtualMetrics: () => virtualMetrics2,
      webhookEvents: () => webhookEvents,
      withLicensePlateVehicleTypes: () => withLicensePlateVehicleTypes3,
      withPublicAssetsBaseUrl: () => withPublicAssetsBaseUrl,
      withoutLicensePlateVehicleTypes: () => withoutLicensePlateVehicleTypes2
    });
    module2.exports = __toCommonJS2(piramid_constants_exports);
    var userTypes2 = [
      "third",
      "system",
      "insurer",
      "policyholder",
      "backoffice",
      "field_adjuster",
      "vendor",
      "inhouse_lawyer"
    ];
    var customerUserTypes = [
      "third",
      "inhouse_lawyer"
    ];
    var SYSTEM_EMAIL = "support@piramid.com.ar";
    var isPersonIdentityRestricted = (viewerType) => customerUserTypes.includes(viewerType);
    var companyPersonEventMetadataKeys = [
      "responsible_user_last_name",
      "responsible_user_email",
      "previous_responsible_user_last_name",
      "previous_responsible_user_email",
      "collaborator_user_last_name",
      "collaborator_user_email",
      "authorized_by_user_last_name",
      "authorized_by_user_email",
      "rejected_by_user_last_name",
      "rejected_by_user_email",
      "approved_by_user_last_name",
      "approved_by_user_email",
      "selected_by_user_email",
      "assignment_reason"
    ];
    var userAvailabilityJobTypes = [
      "non_operational_user",
      "operational_user"
    ];
    var userClaimBatchJobTypes = [
      "batch_delegate_user_claims",
      "batch_restore_user_claims"
    ];
    var CLAIM_BATCH_JOB_IN_FLIGHT_WINDOW_MS = 15 * 60 * 1e3;
    var TEAM_DELEGATION_REQUEUE_WINDOW_MS = 2 * 60 * 60 * 1e3;
    var offerAgreementJobTypes = [
      "process_offer_agreement",
      "dispatch_offer_agreement",
      "reconcile_offer_agreement",
      "cancel_offer_agreement"
    ];
    var transformers = ["date_diff_workdays", "date_diff"];
    var transformationApplyTo = ["comparison", "entity"];
    var alertTables = [
      {
        label: "Casos",
        table: "case",
        type: "table",
        columns: [
          {
            label: "Estado",
            column: "status",
            type: "enum",
            enum: [
              {
                value: "not_assigned",
                label: "Sin asignaci\xF3n"
              },
              {
                value: "in_progress",
                label: "En progreso"
              },
              {
                value: "closed",
                label: "Cerrado"
              }
            ]
          },
          {
            label: "Solicitud de caso",
            column: "caseRequest",
            type: "table",
            columns: [
              {
                column: "denouncedAt",
                type: "date",
                label: "Fecha de denuncia"
              }
            ]
          }
        ]
      },
      {
        type: "table",
        label: "Intentos de env\xEDo de carta documento",
        table: "mailAttempt",
        columns: [
          {
            type: "date",
            column: "receivedAt",
            label: "Recibido el"
          },
          {
            type: "date",
            column: "sentAt",
            label: "Enviado el"
          },
          {
            type: "date",
            column: "expiredAt",
            label: "Expirado el"
          }
        ]
      },
      {
        type: "table",
        label: "Investigaciones",
        table: "investigation",
        columns: [
          {
            type: "enum",
            column: "status",
            label: "Estado",
            enum: [
              {
                label: "Pendiente",
                value: "pending"
              },
              {
                label: "Aceptado",
                value: "accepted"
              },
              {
                label: "Rechazado",
                value: "rejected"
              },
              {
                label: "Cerrado",
                value: "closed"
              }
            ]
          },
          {
            type: "date",
            column: "closedAt",
            label: "Cerrado el"
          },
          {
            type: "date",
            column: "acceptedAt",
            label: "Aceptado el"
          },
          {
            type: "date",
            column: "createdAt",
            label: "Creado el"
          }
        ]
      }
    ];
    function getAllColumnPaths(entity) {
      const table = alertTables.find((ele) => ele.table === entity);
      if (!table) {
        return [];
      }
      const paths = [];
      for (const column of table.columns) {
        const isTable = column.type === "table";
        if (isTable) {
          for (const nestedColumn of column.columns) {
            paths.push(`${column.column}.${nestedColumn.column}`);
          }
        }
        if (!isTable) {
          paths.push(column.column);
        }
      }
      return paths;
    }
    var insurerClaimFilters = [
      "claim_damages",
      "responsible",
      "claimed_amount_from",
      "claimed_amount_to",
      "references",
      "status",
      "date_from",
      "date_to",
      "sub_status",
      "victim_relationship",
      "ramo",
      "team",
      "type",
      "coordinator",
      "collaborator",
      "states",
      "municipalities",
      "system_status",
      "stages",
      "is_claimant_and_victim_same_insurer",
      "sinister_object",
      "customer_organization",
      "fraud_status"
    ];
    var insurerComplaintFilters = [
      "responsible",
      "references",
      "status",
      "date_from",
      "date_to",
      "sub_status",
      "ramo",
      "team",
      "type",
      "stages",
      "system_status"
    ];
    var insurerClaimColumns = [
      "notifications",
      "victim",
      "damages",
      "claimed_at",
      "claimed_amount",
      "status",
      "reference",
      "sinister_number",
      "responsible",
      "last_user_activity",
      "fraud_status"
    ];
    var GAMMA_CLAIM_COLUMNS = [
      "notifications",
      "ref_id",
      "external_claim_id",
      "claimed_at",
      "victim",
      "status",
      "reference",
      "responsible",
      "last_user_activity"
    ];
    var insurerClaimColumnProfiles = {
      gamma: GAMMA_CLAIM_COLUMNS,
      // Delta: espejo de Gamma para QA. Comparte el MISMO array a propósito —
      // copiar las columnas dejaría que el espejo derive sin que nadie lo note.
      delta: GAMMA_CLAIM_COLUMNS
    };
    var getInsurerClaimColumns = (tenantSlug) => tenantSlug && insurerClaimColumnProfiles[tenantSlug] || insurerClaimColumns;
    var insurerComplaintColumns = [
      "type",
      "status",
      "damages",
      "description",
      "responsible",
      "policyholder",
      "created_at",
      "ramo",
      "reference",
      "stage",
      "system_status"
    ];
    var insurerSinisterColumns = [
      "sinister_number",
      "created_at",
      "sinister_date",
      "policy_number",
      "license_plate"
    ];
    var ssnStatementCsvOutputKeys = [
      "emp",
      "id",
      "hasInvestigation",
      "derivedAt",
      "sinisterId",
      "ramo",
      "investigationSummary",
      "result",
      "closeMotive",
      "allegedInvolvedType",
      "allegedInvolvedName",
      "allegedInvolvedDocumentType",
      "allegedInvolvedDocumentNumber",
      "allegedInvolvedEin",
      "allegedInvolvedAddress",
      "allegedInvolvedState",
      "allegedInvolvedCity",
      "allegedInvolvedZipCode",
      "professionalProfession",
      "professionalName",
      "professionalDocumentType",
      "professionalDocumentNumber",
      "professionalEin",
      "professionalAddress",
      "professionalState",
      "professionalCity",
      "professionalZipCode",
      "witnessName",
      "witnessDocumentType",
      "witnessDocumentNumber",
      "witnessEin",
      "witnessAddress",
      "witnessState",
      "witnessCity",
      "witnessZipCode",
      "lawyerType",
      "lawyerName",
      "lawyerDocumentType",
      "lawyerDocumentNumber",
      "lawyerEin",
      "lawyerState",
      "lawyerCity",
      "lawyerZipCode",
      "lawyerEnrollment",
      "liquidatorName",
      "liquidatorDocumentType",
      "liquidatorDocumentNumber",
      "liquidatorEin",
      "liquidatorSummary",
      "liquidatorEnrollment",
      "agreement",
      "surrender",
      "reluctance",
      "rejected",
      "prescription",
      "expiration",
      "demandRejected",
      "juice",
      "criminalComplaint",
      "complaint",
      "probation",
      "criminalConviction",
      "suspension",
      "others",
      "saving",
      "criminalComplaintPerform",
      "criminalComplaintAuthority",
      "criminalComplaintFollowUp",
      "criminalComplaintProfessionalAdvice",
      "criminalComplaintProfessionalAdviceName",
      "observations"
    ];
    var personParents = ["father", "mother"];
    var NATURAL_PERSON_NAME_MAX_LENGTH3 = 20;
    var requiredFieldMessage38 = "Campo requerido";
    var naturalPersonNameMaxLengthMessage3 = `M\xE1ximo ${NATURAL_PERSON_NAME_MAX_LENGTH3} caracteres`;
    var invalidChassisMessage2 = "El n\xFAmero de chasis no es v\xE1lido";
    var invalidEngineMessage2 = "El n\xFAmero de motor no es v\xE1lido";
    var validationMessages = [{ name: "testingg" }];
    var sessionTypes = [
      "system",
      "third",
      "policyholder",
      "insurer",
      "backoffice",
      "provider"
    ];
    var providerUserTypes = [
      "field_adjuster",
      "vendor"
    ];
    var import_i11n5 = require_dist();
    var reviewTypes3 = [
      "claim_creation_form",
      "claim_resolution"
    ];
    var thirdPartyProfessionalRelationships = [
      "attorney_in_fact",
      "attorney_representative",
      "producer"
    ];
    var thirdPartyLabeledRelationships = [
      ...thirdPartyProfessionalRelationships,
      "own"
    ];
    var reviewRespondentRelationships = [
      ...thirdPartyLabeledRelationships,
      "particular",
      "inhouse_lawyer"
    ];
    var REVIEW_RESPONDENT_RELATIONSHIP_LABEL_KEYS = {
      particular: "reviews.table.third_party_relationship.particular",
      inhouse_lawyer: "user.type.inhouse_lawyer"
    };
    var DECLARED_OTHER_MAX_LENGTH = 30;
    var declaredVictimRelationshipLabel = ({
      relationship,
      other
    }) => {
      const freeText = other == null ? void 0 : other.trim();
      if (relationship !== "other" || !freeText) {
        return (0, import_i11n5.translate)(`victim_relationship.${relationship}`);
      }
      return freeText.length > DECLARED_OTHER_MAX_LENGTH ? `${freeText.slice(0, DECLARED_OTHER_MAX_LENGTH)}\u2026` : freeText;
    };
    var reviewRespondentRelationshipLabel = (relationship, declared) => {
      const label = (0, import_i11n5.translate)(
        REVIEW_RESPONDENT_RELATIONSHIP_LABEL_KEYS[relationship] ?? `victim_relationship.${relationship}`
      );
      return declared ? `${label} (${declaredVictimRelationshipLabel(declared)})` : label;
    };
    var timezones = ["America/Buenos_Aires"];
    var documentTypes = ["dni", "passport"];
    var sexTypes2 = ["male", "female"];
    var companyServices = ["claim", "complaint"];
    var companyServiceBackends = [
      "rivadavia",
      "tajy"
    ];
    var virtualMetrics2 = [
      "time_to_first_response",
      "avg_response_time"
    ];
    var elapsedDurationCriteriaOptsByType2 = {
      reference: ["working_days", "elapsed_days"],
      status: ["working_days", "elapsed_days"],
      stage: ["working_days", "elapsed_days"],
      chat: ["working_hours", "elapsed_hours"]
    };
    var slaTypesWithTotalDuration2 = [
      "stage",
      "reference"
    ];
    var slaReportColumns2 = [
      "sla_type",
      "sla_name",
      "sla_elapsed_duration_criteria",
      "sla_version",
      "relation_type_responsible",
      "relation_type_coordinator",
      "relation_type_id",
      "started_at",
      "deadline",
      "completed_at",
      "status",
      "compliance",
      "sla_objective_reference_name",
      "progress",
      "sla_expected_time_to_resolution",
      "sla_current_time_to_resolution"
    ];
    var defaultElapsedDurationCriteria2 = "elapsed_days";
    var ORDER_CANDIDATES_PAGE_SIZE = 10;
    var ORDER_CANDIDATES_RELAXED_PAGE_SIZE = 50;
    var ORDER_ACTION_ITEMS_LIMIT = 8;
    var ORDER_REFERENCE_PREFIX = "ORD";
    var ORDER_SCHEDULING_MAX_PAST_DAYS2 = 30;
    var ORDER_SCHEDULING_NOTE_MAX_LENGTH2 = 500;
    var ORDER_SCHEDULE_HISTORY_LIMIT = 300;
    var CUSTOMER_CLAIM_ORDERS_LIMIT = 300;
    var ORDER_SCHEDULE_BRANCH_OPTIONS_LIMIT = 200;
    var ORDER_SCHEDULE_CALENDAR_DURATION_MINUTES = 60;
    var ORDER_CALENDAR_UID_DOMAIN = "piramid.app";
    var ICALENDAR_PRODID = "-//Piramid//Order Scheduling//ES";
    var CALENDAR_INVITE_ATTACHMENT_FILENAME = "invite.ics";
    var DAY_IN_MS = 24 * 60 * 60 * 1e3;
    var orderScheduleFloor2 = (now) => new Date(now.getTime() - ORDER_SCHEDULING_MAX_PAST_DAYS2 * DAY_IN_MS);
    var orderTypeSubTypes2 = {
      service: ["assessment", "repair", "investigation"],
      purchase: ["parts"]
    };
    var ORDER_TAX_PERCENTS = [0, 10.5, 21];
    var DEFAULT_ORDER_TAX_PERCENT2 = 0;
    var isOrderTaxPercent2 = (value) => ORDER_TAX_PERCENTS.some((percent) => percent === value);
    var MAX_ORDER_UNIT_PRICE2 = 9999999999e-2;
    var MAX_ORDER_AMOUNT2 = 999999999999e-2;
    var MAX_ORDER_ITEM_QUANTITY2 = 9999;
    var MAX_IMPORTED_ORDER_FILES2 = 25;
    var MAX_IMPORTABLE_ORDER_FILES = 500;
    var orderReportColumns2 = [
      "ref_id",
      "created_at",
      "status",
      "claim_ref_id",
      "claim_external_id",
      "claim_created_at",
      "claim_status",
      "claim_owner_name",
      "insurer_name",
      "claimant_name",
      "claimant_identification",
      "vehicle_make",
      "vehicle_model",
      "vehicle_version",
      "vehicle_year",
      "vehicle_license_plate",
      "service_name",
      "good_name",
      "name",
      "items_quantity",
      "items_detail",
      "currency",
      "total_amount",
      "coverage_amount",
      "amount_to_charge",
      "taxes_percent",
      "taxes_amount",
      "total_with_taxes",
      "provider_legal_name",
      "provider_ein",
      "provider_external_id",
      "derived_by_name",
      "scheduled_for",
      "scheduled_branch",
      "workflow_stage",
      "description",
      "items_brands",
      "vertical_name",
      "accepted_at",
      "completed_at",
      "rejected_at",
      "rejected_reason",
      "canceled_at",
      "canceled_reason",
      "work_proof_mechanism",
      "work_proof_status",
      "provider_email",
      "derived_by_email",
      "locality_name",
      "department_name",
      "province_name",
      "sinister_external_id",
      "claim_system_status",
      "claim_ramo",
      "occurrence_sinister_date",
      "claimant_email",
      "claimant_phone",
      "claimant_address",
      "policyholder_policy_number",
      "policyholder_license_plate",
      "insurance_coverage",
      "insurance_policy_number",
      "insurance_franchise_amount"
    ];
    var ORDER_REPORT_DEFAULT_COLUMNS = [
      "ref_id",
      "created_at",
      "status",
      "claim_ref_id",
      "claim_external_id",
      "claim_created_at",
      "claim_status",
      "claim_owner_name",
      "insurer_name",
      "claimant_name",
      "claimant_identification",
      "vehicle_make",
      "vehicle_model",
      "vehicle_version",
      "vehicle_year",
      "vehicle_license_plate",
      "service_name",
      "good_name",
      "name",
      "items_quantity",
      "items_detail",
      "currency",
      "total_amount",
      "coverage_amount",
      "amount_to_charge",
      "taxes_percent",
      "taxes_amount",
      "total_with_taxes",
      "provider_legal_name",
      "provider_ein",
      "provider_external_id",
      "derived_by_name",
      "scheduled_for",
      "scheduled_branch"
    ];
    var backofficeOrderReportColumns2 = [
      "company_name",
      ...orderReportColumns2
    ];
    var BACKOFFICE_ORDER_REPORT_DEFAULT_COLUMNS = [
      "company_name",
      ...ORDER_REPORT_DEFAULT_COLUMNS
    ];
    var BACKOFFICE_ORDER_EXPORT_MAX_ROWS = 1e4;
    var REVELACION_DATA_EMAIL_DOMAIN2 = "revelaciondata.com.ar";
    var isRevelacionDataEmail2 = (email) => email.toLowerCase().endsWith(`@${REVELACION_DATA_EMAIL_DOMAIN2}`);
    var ORDER_REPORT_CSV_DELIMITER = ";";
    var ORDER_REPORT_ITEMS_SEPARATOR = " | ";
    var messageTemplateContextPaths2 = [
      "claim.owner.first_name",
      "claim.owner.last_name",
      "claim.owner.email",
      "claim.id",
      "claim.external_claim_id",
      "claim.sinister.policyholder_license_plate",
      "claim.sinister.selected_external_complaint.external_id",
      "file_request_placeholder_list",
      "file_request_message",
      "claim.ref_id"
    ];
    var messageTemplateContextPathsByScope = {
      offer: [],
      communication: messageTemplateContextPaths2
    };
    var complaintCheckAttributes = [
      "license_plate",
      "policyholder",
      "chassis"
    ];
    var delegateComplaintStrategies = ["users", "team"];
    var deriveComplaintStrategies = ["user", "team"];
    var DEFAULT_ENDORSEMENT = "0";
    var CHILDREN_WINDOW_DONE_WORD_TOKEN = "done";
    var CHILDREN_WINDOW_ERROR_WORD_TOKEN = "error";
    var claimantVictimRelationships = [
      "brother",
      "mother",
      "father",
      "other_family_member",
      "tutor_curator",
      "attorney_in_fact",
      "attorney_representative",
      "other",
      "producer",
      "workshopper",
      "particular_victim"
    ];
    var noAttorneyVictimRelationships = [
      "brother",
      "mother",
      "father",
      "other_family_member",
      "tutor_curator",
      "other",
      "workshopper",
      "particular_victim"
    ];
    var deathClaimantVictimRelationships = [
      "father",
      "mother",
      "son",
      "brother",
      "grandparent",
      "spouse",
      "concubine",
      "tutor_curator",
      "other"
    ];
    var attorneyVictimRelationships2 = [
      "attorney_in_fact",
      "attorney_representative",
      "producer"
    ];
    var recoveryVictimRelationships = [
      ...attorneyVictimRelationships2,
      "other"
    ];
    var isAttorneyVictimRelationship2 = (relationship) => relationship === "attorney_in_fact" || relationship === "attorney_representative";
    var legalPersonClaimantVictimRelationships = [
      "legal_representative",
      "attorney_in_fact",
      "attorney_representative",
      "other"
    ];
    var damageTypes = ["material", "person"];
    var personDamageTypes = [
      "injuries",
      "death",
      "reimbursement"
    ];
    var claimCheckAttributes2 = [
      "license_plate",
      "policy_number",
      "zip_code",
      "zip_code_strict",
      "claim_entry"
    ];
    var realPropertyTypes2 = [
      "commercial",
      "building",
      "government",
      "warehouse",
      "other",
      "housing"
    ];
    var realPropertyOwnershipTypes2 = ["own", "rented", "other"];
    var victimInjuriesRolesWithMaterialDamage = [
      "driver",
      "rider"
    ];
    var claimants = ["legalPerson", "naturalPerson"];
    var argentinaStatesRequiredParty = ["B", "S"];
    var LEGAL_PERSON_AGE_THRESHOLD2 = 18;
    var claimCombinations2 = [
      ["material"],
      ["person"],
      ["material", "person"],
      ["recovery"],
      ["recovery", "person"],
      ["recovery", "material"]
    ];
    var flattenDamageTypes = [
      "death",
      "injury",
      "recovery",
      "material"
    ];
    var flattenDamageTypeToParentType = {
      death: "person",
      injury: "person",
      material: "material",
      recovery: "recovery"
    };
    var delegateClaimStrategies = ["users", "team"];
    var deriveClaimStrategies2 = ["user", "team"];
    var claimReportColumns2 = [
      "id",
      "external_claim_id",
      "declared_damages",
      "occurrence_sinister_date",
      "occurrence_country",
      "occurrence_state",
      "occurrence_city",
      "occurrence_address",
      "occurrence_description",
      "occurrence_zip_code",
      "created_at",
      "closed_at",
      "desired_support_location",
      "claimed_amount",
      "created_by_email",
      "created_by_name",
      "victim_type",
      "victim_name",
      "victim_city",
      "victim_identification_type",
      "victim_identification_value",
      "ramo",
      "status",
      "claim_status",
      "team",
      "policyholder_license_plate",
      "policyholder_policy_number",
      "reference",
      "responsible_name",
      "responsible_email",
      "complaint_external_id",
      "complaint_external_status",
      "complaint_agency",
      "complaint_occurrence_date",
      "complaint_registered_by",
      "complaint_handler_name",
      "complaint_handler_email",
      "complaint_registered_at",
      "complaint_location",
      "fraud_created_at",
      "fraud_reason",
      "fraud_close_motive",
      "fraud_external_status",
      "fraud_external_id",
      "fraud_sinister_type",
      "fraud_description",
      "fraud_result",
      "fraud_responsible_name",
      "fraud_responsible_email",
      "fraud_instance",
      "fraud_report_accepted_by_name",
      "fraud_report_accepted_by_email",
      "fraud_report_lab",
      "fraud_report_conclusion",
      "fraud_sinister_number",
      "offers_count",
      "latest_offer_amount",
      "latest_offer_status",
      "latest_offer_sent_at",
      "current_pretension",
      "material_judicial_amount",
      "person_judicial_amount",
      "material_administrative_amount",
      "person_administrative_amount",
      "percentage_of_liability",
      "person_percentage_of_judicial_risk",
      "estimates_updated_at"
    ];
    var MAX_CLAIM_FILES_PER_UPLOAD3 = 5;
    var claimTypes5 = [
      "material",
      "material_vehicle_with_license_plate",
      "material_vehicle_without_license_plate",
      "person_injury",
      "material_and_person_injury",
      "person_death",
      "material_real_property",
      "claimant_worker_compensation_insurer",
      "material_and_person_death",
      "recovery"
    ];
    var MAX_CLAIMED_AMOUNT2 = 999999999999999e-2;
    var CLAIM_STATUS_WILDCARD_ORDER2 = -1;
    var DEFAULT_TIMEZONE4 = "America/Argentina/Buenos_Aires";
    var NO_COLLABORATOR_FILTER_VALUE = "__no_collaborator__";
    var MAX_CLAIMS_FOR_IN_MEMORY_SORT = 1e3;
    var LAST_ACTIVITY_EVENTS_PER_CLAIM_CAP = 5;
    var FRAUD_LOCKED_CLAIM_STATUS_ROLES = [
      "sinister_derived_fraud",
      "fraud"
    ];
    var isFraudLockedClaimStatusRole = (role) => !!role && FRAUD_LOCKED_CLAIM_STATUS_ROLES.includes(
      role
    );
    var isActiveFraudDerivationClaim = (claim) => {
      var _a2;
      return claim.system_status !== "closed" && !isFraudLockedClaimStatusRole((_a2 = claim.claim_status) == null ? void 0 : _a2.role);
    };
    var isClaimLockedByFraudInvestigation = ({
      role,
      hasFraudInvestigationCase
    }) => hasFraudInvestigationCase && isFraudLockedClaimStatusRole(role);
    var DERIVATION_CANDIDATES_LIMIT = 20;
    var DERIVED_CLAIM_STATUS_ROLES = [
      "claim_derived_user_strategy",
      "claim_derived_team_strategy"
    ];
    var OPEN_CLAIM_DERIVATION_WHERE = {
      returned_at: null,
      canceled_at: null
    };
    var DERIVED_CLAIM_WHERE = {
      claim_status: { role: { in: [...DERIVED_CLAIM_STATUS_ROLES] } },
      claim_derivations: { some: OPEN_CLAIM_DERIVATION_WHERE }
    };
    var NOT_DERIVED_CLAIM_WHERE = {
      OR: [
        { claim_derivations: { none: OPEN_CLAIM_DERIVATION_WHERE } },
        {
          claim_status: {
            OR: [
              { role: null },
              { role: { notIn: [...DERIVED_CLAIM_STATUS_ROLES] } }
            ]
          }
        }
      ]
    };
    var BATCH_RESTORE_DELEGATIONS_PAGE_SIZE = 100;
    var isOpenClaimDerivation = (derivation) => !derivation.returned_at && !derivation.canceled_at;
    var FRAUD_RESOLUTION_DERIVATION_CLOSURE_REASON = "Derivaci\xF3n cerrada autom\xE1ticamente por resoluci\xF3n de fraude";
    var INSURER_SYSTEM_DERIVATION_CLOSURE_REASON = "Derivaci\xF3n cerrada autom\xE1ticamente por cierre del reclamo en el sistema de la aseguradora";
    var OFFER_OUTCOME_DERIVATION_CLOSURE_REASON = "Derivaci\xF3n cerrada autom\xE1ticamente por el resultado del ofrecimiento";
    var EVENT_DRIVEN_CLAIM_STATUS_ROLES = [
      "offer_created",
      "offer_rejected",
      "offer_canceled",
      "offer_expired",
      "offer_agreement_started"
    ];
    var isEventDrivenClaimStatusRole = (role) => !!role && EVENT_DRIVEN_CLAIM_STATUS_ROLES.includes(
      role
    );
    var CLAIM_STATUS_ROLE_DERIVATION_POLICY = {
      offer_created: "defer",
      offer_expired: "defer",
      offer_canceled: "defer",
      offer_agreement_started: "defer",
      offer_accepted: "resolve",
      offer_rejected: "resolve",
      offer_agreement_completed: "resolve",
      order_created: "defer",
      order_accepted: "defer",
      order_rejected: "defer",
      order_canceled: "defer",
      order_completed: "defer",
      order_work_proof_completed: "defer",
      order_work_proof_approved: "defer",
      order_work_proof_disapproved: "defer"
    };
    var ORDER_CLAIM_STATUS_ROLES = [
      "order_created",
      "order_accepted",
      "order_rejected",
      "order_canceled",
      "order_completed",
      "order_work_proof_completed",
      "order_work_proof_approved",
      "order_work_proof_disapproved"
    ];
    var isOrderClaimStatusRole = (role) => !!role && ORDER_CLAIM_STATUS_ROLES.includes(role);
    var WORK_PROOF_VERDICT_CLAIM_STATUS_ROLE = {
      approved: "order_work_proof_approved",
      disapproved: "order_work_proof_disapproved"
    };
    var CLAIM_ESTIMATE_CHANGES_CAP = 300;
    var MAX_CLAIM_ESTIMATE_AMOUNT2 = 999999999;
    var DAMAGES_VEHICLE_MARKET_VALUE_CHANGE_REASON = "Actualizaci\xF3n autom\xE1tica a partir de los datos de Da\xF1os materiales";
    var claimSummaryCardKeys = [
      "victim",
      // Damnificado
      "claimant",
      // Reclamante
      "damages",
      // Daños
      "occurrence",
      // Datos del siniestro
      "location",
      // Ubicación del siniestro
      "intake"
      // Datos de la derivación (IntakeSubmission)
    ];
    var DEFAULT_CLAIM_PRESENTATION_PROFILE = {
      tabs: {
        inspections: true,
        estimates: true,
        offers: true,
        orders: true,
        sla: true
      },
      statusTimeline: true,
      // Fail-closed exception to "default shows everything": order tracking is
      // opt-in per tenant because it exposes work-order data to claim owners.
      customerOrderTracking: false,
      // Same criterion: only tenants with structured intake have anything to show.
      customerIntakeSummary: false,
      // Same criterion: the origin's identifiers only mean something to the tenant
      // that derived the claim.
      customerExternalClaimIdentity: false,
      // Same criterion: sharing exposes the insurer's own documentation to the
      // claim owner, so it is opt-in per tenant.
      sharedClaimantDocumentation: false,
      attributes: {
        sinister: true,
        collaborator: true
      },
      // Enumerated instead of spreading every key: `intake` is opt-in like the
      // `customer*` flags above, so tenants without structured intake never show it.
      summaryCards: ["victim", "claimant", "damages", "occurrence", "location"],
      propagate: true,
      singleCompanyRamo: false,
      singleCompanyClaimType: false
    };
    var claimPresentationProfiles = {
      // DemoEmpleo (Chile, seguro de desempleo): caso simple, sin integración
      // externa ni las secciones de un flujo automotor/Rivadavia.
      demoempleo: {
        tabs: {
          inspections: false,
          estimates: false,
          offers: false,
          orders: false,
          sla: false
        },
        statusTimeline: false,
        customerOrderTracking: false,
        customerIntakeSummary: false,
        customerExternalClaimIdentity: false,
        sharedClaimantDocumentation: false,
        attributes: {
          sinister: false,
          collaborator: false
        },
        summaryCards: ["claimant", "occurrence", "location"],
        propagate: false,
        singleCompanyRamo: true,
        singleCompanyClaimType: false
      },
      // Gamma (ARG, automotive glass distributor): glass-replacement claims derived
      // from other insurers, worked through the provider network.
      gamma: {
        tabs: {
          inspections: false,
          estimates: false,
          offers: false,
          orders: true,
          sla: false
        },
        statusTimeline: true,
        // AMCA operates Gamma's customer-app: order tracking and the intake they
        // themselves submitted are part of the deal.
        customerOrderTracking: true,
        customerIntakeSummary: true,
        // The claim is derived by AMCA: its own claim number and the policyholder's
        // plate are what AMCA looks the claim up by.
        customerExternalClaimIdentity: true,
        // Gamma shares the claim invoice and other paperwork with AMCA.
        sharedClaimantDocumentation: true,
        attributes: {
          sinister: false,
          collaborator: false
        },
        // The sinister location is optional in Gamma's form, so the useful geo
        // reference is the intake card's requested repair locality instead.
        summaryCards: ["claimant", "damages", "occurrence", "intake"],
        propagate: false,
        singleCompanyRamo: true,
        singleCompanyClaimType: true
      }
    };
    var getClaimPresentationProfile = (backend) => backend && claimPresentationProfiles[backend] || DEFAULT_CLAIM_PRESENTATION_PROFILE;
    var isPropagableBackend = (backend) => getClaimPresentationProfile(backend).propagate;
    var insurerNavigationSections = [
      "sinisters",
      // Siniestros
      "derived_claims",
      // Reclamos derivados
      "stats"
      // Estadísticas
    ];
    var DEFAULT_INSURER_NAVIGATION_PROFILE = {
      sinisters: true,
      derived_claims: true,
      stats: true
    };
    var GAMMA_NAVIGATION_PROFILE = {
      sinisters: false,
      derived_claims: false,
      stats: false
    };
    var insurerNavigationProfiles = {
      gamma: GAMMA_NAVIGATION_PROFILE,
      // Delta: espejo de Gamma para QA. Comparte el MISMO objeto a propósito —
      // copiar los valores dejaría que el espejo derive sin que nadie lo note.
      delta: GAMMA_NAVIGATION_PROFILE
    };
    var getInsurerNavigationProfile = (tenantSlug) => tenantSlug && insurerNavigationProfiles[tenantSlug] || DEFAULT_INSURER_NAVIGATION_PROFILE;
    var GAMMA_VERTICAL_SLUG = "cristales-automotores";
    var GAMMA_MIN_GLASS_COUNT = 1;
    var GAMMA_MAX_GLASS_COUNT = 10;
    var GAMMA_GLASS_BRAND_LIST_PATTERN = /^\s*(?!.*(?:,\s*,|,\s*$))[A-Za-zÀ-ÖØ-öø-ÿ0-9][A-Za-zÀ-ÖØ-öø-ÿ0-9 .&'\/_,-]*\s*$/;
    var GAMMA_GLASS_BRAND_FORBIDDEN_CHARS = /[^A-Za-zÀ-ÖØ-öø-ÿ0-9 .&'\/_-]/g;
    var GAMMA_GLASS_BRAND_EDGE_NOISE = /^[^A-Za-zÀ-ÖØ-öø-ÿ0-9]+|[^A-Za-zÀ-ÖØ-öø-ÿ0-9]+$/g;
    var fieldAdjusterClaimStatus2 = [
      "with_appraisal_report",
      "without_appraisal_report"
    ];
    var documentValidations = [
      {
        alias: "father_national_id_document_front",
        validations: [
          {
            entity: "national_identity_card",
            validation: "national_identity_card_fields"
          }
        ]
      },
      {
        alias: "mother_national_id_document_front",
        validations: [
          {
            entity: "national_identity_card",
            validation: "national_identity_card_fields"
          }
        ]
      },
      {
        alias: "certificate_medical_treatment",
        validations: [
          {
            entity: "medical_certificate",
            validation: "doctor_stamp_visible"
          },
          {
            entity: "medical_certificate",
            validation: "diagnosis_visible"
          },
          {
            entity: "medical_certificate",
            validation: "doctor_license_number_visible"
          }
        ]
      },
      {
        alias: "victim_national_identity_card_front",
        validations: [
          {
            validation: "birth_date",
            entity: "national_identity_card"
          }
        ]
      },
      {
        alias: "certificate_medical_treatment",
        validations: [
          {
            validation: "medical_certificate_sinister_date",
            entity: "medical_certificate"
          }
        ]
      },
      {
        alias: "certificate_medical_treatment",
        validations: [
          {
            validation: "medical_certificate_sinister_date",
            entity: "medical_certificate"
          }
        ]
      },
      {
        alias: "vehicle",
        validations: [
          {
            validation: "license_plate",
            entity: "vehicle"
          }
        ]
      },
      {
        alias: "vehicle_id_card_front",
        validations: [
          {
            validation: "make",
            entity: "vehicle_id_card_front"
          },
          {
            validation: "model",
            entity: "vehicle_id_card_front"
          },
          {
            validation: "license_plate",
            entity: "vehicle_id_card_front"
          }
        ]
      },
      {
        alias: "policy_coverage_certificate",
        validations: [
          {
            validation: "policy_period",
            entity: "coverage_certificate"
          }
        ]
      },
      {
        alias: "death_certificate",
        validations: [
          {
            validation: "death_certificate_fields",
            entity: "death_certificate"
          }
        ]
      },
      {
        alias: "vehicle_id_card_back",
        validations: [
          {
            validation: "address",
            entity: "vehicle_id_card_back"
          },
          {
            validation: "full_name",
            entity: "vehicle_id_card_back"
          },
          {
            validation: "document_number",
            entity: "vehicle_id_card_back"
          }
        ]
      }
    ];
    var searchableEntities2 = [
      "insurer",
      "worker_compensation_insurer",
      "health_insurance_fund"
    ];
    var sortTypes5 = ["asc", "desc"];
    var countryAndStates4 = [
      {
        code: "AFG",
        name: "Afghanistan",
        states: [
          { id: 3901, name: "Badakhshan", code: "BDS" },
          { id: 3871, name: "Badghis", code: "BDG" },
          { id: 3875, name: "Baghlan", code: "BGL" },
          { id: 3884, name: "Balkh", code: "BAL" },
          { id: 3872, name: "Bamyan", code: "BAM" },
          { id: 3892, name: "Daykundi", code: "DAY" },
          { id: 3899, name: "Farah", code: "FRA" },
          { id: 3889, name: "Faryab", code: "FYB" },
          { id: 3870, name: "Ghazni", code: "GHA" },
          { id: 3888, name: "Gh\u014Dr", code: "GHO" },
          { id: 3873, name: "Helmand", code: "HEL" },
          { id: 3887, name: "Herat", code: "HER" },
          { id: 3886, name: "Jowzjan", code: "JOW" },
          { id: 3902, name: "Kabul", code: "KAB" },
          { id: 3890, name: "Kandahar", code: "KAN" },
          { id: 3879, name: "Kapisa", code: "KAP" },
          { id: 3878, name: "Khost", code: "KHO" },
          { id: 3876, name: "Kunar", code: "KNR" },
          { id: 3900, name: "Kunduz Province", code: "KDZ" },
          { id: 3891, name: "Laghman", code: "LAG" },
          { id: 3897, name: "Logar", code: "LOG" },
          { id: 3882, name: "Nangarhar", code: "NAN" },
          { id: 3896, name: "Nimruz", code: "NIM" },
          { id: 3880, name: "Nuristan", code: "NUR" },
          { id: 3894, name: "Paktia", code: "PIA" },
          { id: 3877, name: "Paktika", code: "PKA" },
          { id: 3881, name: "Panjshir", code: "PAN" },
          { id: 3895, name: "Parwan", code: "PAR" },
          { id: 3883, name: "Samangan", code: "SAM" },
          { id: 3885, name: "Sar-e Pol", code: "SAR" },
          { id: 3893, name: "Takhar", code: "TAK" },
          { id: 3898, name: "Urozgan", code: "URU" },
          { id: 3874, name: "Zabul", code: "ZAB" }
        ]
      },
      { code: "ALA", name: "Aland Islands", states: [] },
      {
        code: "ALB",
        name: "Albania",
        states: [
          { id: 603, name: "Berat County", code: "01" },
          { id: 629, name: "Berat District", code: "BR" },
          { id: 607, name: "Bulqiz\xEB District", code: "BU" },
          { id: 618, name: "Delvin\xEB District", code: "DL" },
          { id: 608, name: "Devoll District", code: "DV" },
          { id: 610, name: "Dib\xEBr County", code: "09" },
          { id: 605, name: "Dib\xEBr District", code: "DI" },
          { id: 632, name: "Durr\xEBs County", code: "02" },
          { id: 639, name: "Durr\xEBs District", code: "DR" },
          { id: 598, name: "Elbasan County", code: "03" },
          { id: 631, name: "Fier County", code: "04" },
          { id: 627, name: "Fier District", code: "FR" },
          { id: 604, name: "Gjirokast\xEBr County", code: "05" },
          { id: 621, name: "Gjirokast\xEBr District", code: "GJ" },
          { id: 617, name: "Gramsh District", code: "GR" },
          { id: 600, name: "Has District", code: "HA" },
          { id: 594, name: "Kavaj\xEB District", code: "KA" },
          { id: 628, name: "Kolonj\xEB District", code: "ER" },
          { id: 630, name: "Kor\xE7\xEB County", code: "06" },
          { id: 597, name: "Kor\xE7\xEB District", code: "KO" },
          { id: 614, name: "Kruj\xEB District", code: "KR" },
          { id: 612, name: "Ku\xE7ov\xEB District", code: "KC" },
          { id: 601, name: "Kuk\xEBs County", code: "07" },
          { id: 623, name: "Kuk\xEBs District", code: "KU" },
          { id: 622, name: "Kurbin District", code: "KB" },
          { id: 609, name: "Lezh\xEB County", code: "08" },
          { id: 595, name: "Lezh\xEB District", code: "LE" },
          { id: 596, name: "Librazhd District", code: "LB" },
          { id: 599, name: "Lushnj\xEB District", code: "LU" },
          { id: 602, name: "Mal\xEBsi e Madhe District", code: "MM" },
          { id: 637, name: "Mallakast\xEBr District", code: "MK" },
          { id: 635, name: "Mat District", code: "MT" },
          { id: 638, name: "Mirdit\xEB District", code: "MR" },
          { id: 619, name: "Peqin District", code: "PQ" },
          { id: 625, name: "P\xEBrmet District", code: "PR" },
          { id: 606, name: "Pogradec District", code: "PG" },
          { id: 620, name: "Puk\xEB District", code: "PU" },
          { id: 624, name: "Sarand\xEB District", code: "SR" },
          { id: 611, name: "Shkod\xEBr County", code: "10" },
          { id: 626, name: "Shkod\xEBr District", code: "SH" },
          { id: 593, name: "Skrapar District", code: "SK" },
          { id: 616, name: "Tepelen\xEB District", code: "TE" },
          { id: 615, name: "Tirana County", code: "11" },
          { id: 633, name: "Tirana District", code: "TR" },
          { id: 636, name: "Tropoj\xEB District", code: "TP" },
          { id: 634, name: "Vlor\xEB County", code: "12" },
          { id: 613, name: "Vlor\xEB District", code: "VL" }
        ]
      },
      {
        code: "DZA",
        name: "Algeria",
        states: [
          { id: 1118, name: "Adrar", code: "01" },
          { id: 1119, name: "A\xEFn Defla", code: "44" },
          { id: 1122, name: "A\xEFn T\xE9mouchent", code: "46" },
          { id: 1144, name: "Algiers", code: "16" },
          { id: 1103, name: "Annaba", code: "23" },
          { id: 1142, name: "Batna", code: "05" },
          { id: 1108, name: "B\xE9char", code: "08" },
          { id: 1128, name: "B\xE9ja\xEFa", code: "06" },
          { id: 4909, name: "B\xE9ni Abb\xE8s", code: "53" },
          { id: 1114, name: "Biskra", code: "07" },
          { id: 1111, name: "Blida", code: "09" },
          { id: 4908, name: "Bordj Baji Mokhtar", code: "52" },
          { id: 1116, name: "Bordj Bou Arr\xE9ridj", code: "34" },
          { id: 1104, name: "Bou\xEFra", code: "10" },
          { id: 1125, name: "Boumerd\xE8s", code: "35" },
          { id: 1105, name: "Chlef", code: "02" },
          { id: 1121, name: "Constantine", code: "25" },
          { id: 4912, name: "Djanet", code: "56" },
          { id: 1098, name: "Djelfa", code: "17" },
          { id: 1129, name: "El Bayadh", code: "32" },
          { id: 4905, name: "El M'ghair", code: "49" },
          { id: 4906, name: "El Menia", code: "50" },
          { id: 1099, name: "El Oued", code: "39" },
          { id: 1100, name: "El Tarf", code: "36" },
          { id: 1127, name: "Gharda\xEFa", code: "47" },
          { id: 1137, name: "Guelma", code: "24" },
          { id: 1112, name: "Illizi", code: "33" },
          { id: 4914, name: "In Guezzam", code: "58" },
          { id: 4913, name: "In Salah", code: "57" },
          { id: 1113, name: "Jijel", code: "18" },
          { id: 1126, name: "Khenchela", code: "40" },
          { id: 1138, name: "Laghouat", code: "03" },
          { id: 1134, name: "M'Sila", code: "28" },
          { id: 1124, name: "Mascara", code: "29" },
          { id: 1109, name: "M\xE9d\xE9a", code: "26" },
          { id: 1132, name: "Mila", code: "43" },
          { id: 1140, name: "Mostaganem", code: "27" },
          { id: 1102, name: "Naama", code: "45" },
          { id: 1101, name: "Oran", code: "31" },
          { id: 1139, name: "Ouargla", code: "30" },
          { id: 4907, name: "Ouled Djellal", code: "51" },
          { id: 1136, name: "Oum El Bouaghi", code: "04" },
          { id: 1130, name: "Relizane", code: "48" },
          { id: 1123, name: "Sa\xEFda", code: "20" },
          { id: 1141, name: "S\xE9tif", code: "19" },
          { id: 4902, name: "Sidi Bel Abb\xE8s", code: "22" },
          { id: 1110, name: "Skikda", code: "21" },
          { id: 1143, name: "Souk Ahras", code: "41" },
          { id: 1135, name: "Tamanghasset", code: "11" },
          { id: 1117, name: "T\xE9bessa", code: "12" },
          { id: 1106, name: "Tiaret", code: "14" },
          { id: 4910, name: "Timimoun", code: "54" },
          { id: 1120, name: "Tindouf", code: "37" },
          { id: 1115, name: "Tipasa", code: "42" },
          { id: 1133, name: "Tissemsilt", code: "38" },
          { id: 1131, name: "Tizi Ouzou", code: "15" },
          { id: 1107, name: "Tlemcen", code: "13" },
          { id: 4911, name: "Touggourt", code: "55" }
        ]
      },
      { code: "ASM", name: "American Samoa", states: [] },
      {
        code: "AND",
        name: "Andorra",
        states: [
          { id: 488, name: "Andorra la Vella", code: "07" },
          { id: 489, name: "Canillo", code: "02" },
          { id: 487, name: "Encamp", code: "03" },
          { id: 492, name: "Escaldes-Engordany", code: "08" },
          { id: 493, name: "La Massana", code: "04" },
          { id: 491, name: "Ordino", code: "05" },
          { id: 490, name: "Sant Juli\xE0 de L\xF2ria", code: "06" }
        ]
      },
      {
        code: "AGO",
        name: "Angola",
        states: [
          { id: 221, name: "Bengo Province", code: "BGO" },
          { id: 218, name: "Benguela Province", code: "BGU" },
          { id: 212, name: "Bi\xE9 Province", code: "BIE" },
          { id: 228, name: "Cabinda Province", code: "CAB" },
          { id: 226, name: "Cuando Cubango Province", code: "CCU" },
          { id: 217, name: "Cuanza Norte Province", code: "CNO" },
          { id: 216, name: "Cuanza Sul", code: "CUS" },
          { id: 215, name: "Cunene Province", code: "CNN" },
          { id: 213, name: "Huambo Province", code: "HUA" },
          { id: 225, name: "Hu\xEDla Province", code: "HUI" },
          { id: 222, name: "Luanda Province", code: "LUA" },
          { id: 223, name: "Lunda Norte Province", code: "LNO" },
          { id: 220, name: "Lunda Sul Province", code: "LSU" },
          { id: 227, name: "Malanje Province", code: "MAL" },
          { id: 219, name: "Moxico Province", code: "MOX" },
          { id: 224, name: "U\xEDge Province", code: "UIG" },
          { id: 214, name: "Zaire Province", code: "ZAI" }
        ]
      },
      { code: "AIA", name: "Anguilla", states: [] },
      { code: "ATA", name: "Antarctica", states: [] },
      {
        code: "ATG",
        name: "Antigua And Barbuda",
        states: [
          { id: 3708, name: "Barbuda", code: "10" },
          { id: 3703, name: "Redonda", code: "11" },
          { id: 3709, name: "Saint George Parish", code: "03" },
          { id: 3706, name: "Saint John Parish", code: "04" },
          { id: 3707, name: "Saint Mary Parish", code: "05" },
          { id: 3705, name: "Saint Paul Parish", code: "06" },
          { id: 3704, name: "Saint Peter Parish", code: "07" },
          { id: 3710, name: "Saint Philip Parish", code: "08" }
        ]
      },
      {
        code: "ARG",
        name: "Argentina",
        states: [
          { id: 3656, name: "Buenos Aires", code: "B" },
          { id: 3647, name: "Catamarca", code: "K" },
          { id: 3640, name: "Chaco", code: "H" },
          { id: 3651, name: "Chubut", code: "U" },
          { id: 4880, name: "Ciudad Aut\xF3noma de Buenos Aires", code: "C" },
          { id: 3642, name: "C\xF3rdoba", code: "X" },
          { id: 3638, name: "Corrientes", code: "W" },
          { id: 3654, name: "Entre R\xEDos", code: "E" },
          { id: 3652, name: "Formosa", code: "P" },
          { id: 3645, name: "Jujuy", code: "Y" },
          { id: 3655, name: "La Pampa", code: "L" },
          { id: 3653, name: "La Rioja", code: "F" },
          { id: 3646, name: "Mendoza", code: "M" },
          { id: 3644, name: "Misiones", code: "N" },
          { id: 3648, name: "Neuqu\xE9n", code: "Q" },
          { id: 3639, name: "R\xEDo Negro", code: "R" },
          { id: 3643, name: "Salta", code: "A" },
          { id: 3634, name: "San Juan", code: "J" },
          { id: 3636, name: "San Luis", code: "D" },
          { id: 3649, name: "Santa Cruz", code: "Z" },
          { id: 3641, name: "Santa Fe", code: "S" },
          { id: 3635, name: "Santiago del Estero", code: "G" },
          { id: 3650, name: "Tierra del Fuego", code: "V" },
          { id: 3637, name: "Tucum\xE1n", code: "T" }
        ]
      },
      {
        code: "ARM",
        name: "Armenia",
        states: [
          { id: 2023, name: "Aragatsotn Region", code: "AG" },
          { id: 2024, name: "Ararat Province", code: "AR" },
          { id: 2026, name: "Armavir Region", code: "AV" },
          { id: 2028, name: "Gegharkunik Province", code: "GR" },
          { id: 2033, name: "Kotayk Region", code: "KT" },
          { id: 2029, name: "Lori Region", code: "LO" },
          { id: 2031, name: "Shirak Region", code: "SH" },
          { id: 2027, name: "Syunik Province", code: "SU" },
          { id: 2032, name: "Tavush Region", code: "TV" },
          { id: 2025, name: "Vayots Dzor Region", code: "VD" },
          { id: 2030, name: "Yerevan", code: "ER" }
        ]
      },
      { code: "ABW", name: "Aruba", states: [] },
      {
        code: "AUS",
        name: "Australia",
        states: [
          { id: 3907, name: "Australian Capital Territory", code: "ACT" },
          { id: 3909, name: "New South Wales", code: "NSW" },
          { id: 3910, name: "Northern Territory", code: "NT" },
          { id: 3905, name: "Queensland", code: "QLD" },
          { id: 3904, name: "South Australia", code: "SA" },
          { id: 3908, name: "Tasmania", code: "TAS" },
          { id: 3903, name: "Victoria", code: "VIC" },
          { id: 3906, name: "Western Australia", code: "WA" }
        ]
      },
      {
        code: "AUT",
        name: "Austria",
        states: [
          { id: 2062, name: "Burgenland", code: "1" },
          { id: 2057, name: "Carinthia", code: "2" },
          { id: 2065, name: "Lower Austria", code: "3" },
          { id: 2061, name: "Salzburg", code: "5" },
          { id: 2059, name: "Styria", code: "6" },
          { id: 2064, name: "Tyrol", code: "7" },
          { id: 2058, name: "Upper Austria", code: "4" },
          { id: 2060, name: "Vienna", code: "9" },
          { id: 2063, name: "Vorarlberg", code: "8" }
        ]
      },
      {
        code: "AZE",
        name: "Azerbaijan",
        states: [
          { id: 540, name: "Absheron District", code: "ABS" },
          { id: 559, name: "Agdam District", code: "AGM" },
          { id: 553, name: "Agdash District", code: "AGS" },
          { id: 577, name: "Aghjabadi District", code: "AGC" },
          { id: 543, name: "Agstafa District", code: "AGA" },
          { id: 547, name: "Agsu District", code: "AGU" },
          { id: 528, name: "Astara District", code: "AST" },
          { id: 575, name: "Babek District", code: "BAB" },
          { id: 552, name: "Baku", code: "BA" },
          { id: 560, name: "Balakan District", code: "BAL" },
          { id: 569, name: "Barda District", code: "BAR" },
          { id: 554, name: "Beylagan District", code: "BEY" },
          { id: 532, name: "Bilasuvar District", code: "BIL" },
          { id: 561, name: "Dashkasan District", code: "DAS" },
          { id: 527, name: "Fizuli District", code: "FUZ" },
          { id: 585, name: "Ganja", code: "GA" },
          { id: 589, name: "G\u0259d\u0259b\u0259y", code: "GAD" },
          { id: 573, name: "Gobustan District", code: "QOB" },
          { id: 551, name: "Goranboy District", code: "GOR" },
          { id: 531, name: "Goychay", code: "GOY" },
          { id: 574, name: "Goygol District", code: "GYG" },
          { id: 571, name: "Hajigabul District", code: "HAC" },
          { id: 544, name: "Imishli District", code: "IMI" },
          { id: 564, name: "Ismailli District", code: "ISM" },
          { id: 570, name: "Jabrayil District", code: "CAB" },
          { id: 578, name: "Jalilabad District", code: "CAL" },
          { id: 572, name: "Julfa District", code: "CUL" },
          { id: 525, name: "Kalbajar District", code: "KAL" },
          { id: 567, name: "Kangarli District", code: "KAN" },
          { id: 590, name: "Khachmaz District", code: "XAC" },
          { id: 537, name: "Khizi District", code: "XIZ" },
          { id: 524, name: "Khojali District", code: "XCI" },
          { id: 549, name: "Kurdamir District", code: "KUR" },
          { id: 541, name: "Lachin District", code: "LAC" },
          { id: 587, name: "Lankaran", code: "LAN" },
          { id: 558, name: "Lankaran District", code: "LA" },
          { id: 546, name: "Lerik District", code: "LER" },
          { id: 568, name: "Martuni", code: "XVD" },
          { id: 555, name: "Masally District", code: "MAS" },
          { id: 580, name: "Mingachevir", code: "MI" },
          { id: 562, name: "Nakhchivan Autonomous Republic", code: "NX" },
          { id: 530, name: "Neftchala District", code: "NEF" },
          { id: 556, name: "Oghuz District", code: "OGU" },
          { id: 534, name: "Ordubad District", code: "ORD" },
          { id: 542, name: "Qabala District", code: "QAB" },
          { id: 526, name: "Qakh District", code: "QAX" },
          { id: 521, name: "Qazakh District", code: "QAZ" },
          { id: 563, name: "Quba District", code: "QBA" },
          { id: 548, name: "Qubadli District", code: "QBI" },
          { id: 588, name: "Qusar District", code: "QUS" },
          { id: 557, name: "Saatly District", code: "SAT" },
          { id: 565, name: "Sabirabad District", code: "SAB" },
          { id: 522, name: "Sadarak District", code: "SAD" },
          { id: 545, name: "Salyan District", code: "SAL" },
          { id: 536, name: "Samukh District", code: "SMX" },
          { id: 591, name: "Shabran District", code: "SBN" },
          { id: 579, name: "Shahbuz District", code: "SAH" },
          { id: 518, name: "Shaki", code: "SA" },
          { id: 586, name: "Shaki District", code: "SAK" },
          { id: 529, name: "Shamakhi District", code: "SMI" },
          { id: 583, name: "Shamkir District", code: "SKR" },
          { id: 535, name: "Sharur District", code: "SAR" },
          { id: 520, name: "Shirvan", code: "SR" },
          { id: 592, name: "Shusha District", code: "SUS" },
          { id: 584, name: "Siazan District", code: "SIY" },
          { id: 582, name: "Sumqayit", code: "SM" },
          { id: 519, name: "Tartar District", code: "TAR" },
          { id: 533, name: "Tovuz District", code: "TOV" },
          { id: 539, name: "Ujar District", code: "UCA" },
          { id: 550, name: "Yardymli District", code: "YAR" },
          { id: 538, name: "Yevlakh", code: "YE" },
          { id: 523, name: "Yevlakh District", code: "YEV" },
          { id: 581, name: "Zangilan District", code: "ZAN" },
          { id: 566, name: "Zaqatala District", code: "ZAQ" },
          { id: 576, name: "Zardab District", code: "ZAR" }
        ]
      },
      {
        code: "BHR",
        name: "Bahrain",
        states: [
          { id: 1992, name: "Capital", code: "13" },
          { id: 1996, name: "Central", code: "16" },
          { id: 1995, name: "Muharraq", code: "15" },
          { id: 1994, name: "Northern", code: "17" },
          { id: 1993, name: "Southern", code: "14" }
        ]
      },
      {
        code: "BGD",
        name: "Bangladesh",
        states: [
          { id: 796, name: "Bagerhat District", code: "05" },
          { id: 802, name: "Bahadia", code: "33" },
          { id: 752, name: "Bandarban District", code: "01" },
          { id: 784, name: "Barguna District", code: "02" },
          { id: 818, name: "Barisal District", code: "06" },
          { id: 807, name: "Barisal Division", code: "A" },
          { id: 756, name: "Bhola District", code: "07" },
          { id: 797, name: "Bogra District", code: "03" },
          { id: 810, name: "Brahmanbaria District", code: "04" },
          { id: 768, name: "Chandpur District", code: "09" },
          { id: 761, name: "Chapai Nawabganj District", code: "45" },
          { id: 785, name: "Chittagong District", code: "10" },
          { id: 803, name: "Chittagong Division", code: "B" },
          { id: 788, name: "Chuadanga District", code: "12" },
          { id: 763, name: "Comilla District", code: "08" },
          { id: 751, name: "Cox's Bazar District", code: "11" },
          { id: 771, name: "Dhaka District", code: "13" },
          { id: 760, name: "Dhaka Division", code: "C" },
          { id: 783, name: "Dinajpur District", code: "14" },
          { id: 762, name: "Faridpur District", code: "15" },
          { id: 816, name: "Feni District", code: "16" },
          { id: 795, name: "Gaibandha District", code: "19" },
          { id: 798, name: "Gazipur District", code: "18" },
          { id: 792, name: "Gopalganj District", code: "17" },
          { id: 805, name: "Habiganj District", code: "20" },
          { id: 808, name: "Jamalpur District", code: "21" },
          { id: 757, name: "Jessore District", code: "22" },
          { id: 778, name: "Jhalokati District", code: "25" },
          { id: 789, name: "Jhenaidah District", code: "23" },
          { id: 806, name: "Joypurhat District", code: "24" },
          { id: 786, name: "Khagrachari District", code: "29" },
          { id: 811, name: "Khulna District", code: "27" },
          { id: 775, name: "Khulna Division", code: "D" },
          { id: 779, name: "Kishoreganj District", code: "26" },
          { id: 793, name: "Kurigram District", code: "28" },
          { id: 774, name: "Kushtia District", code: "30" },
          { id: 819, name: "Lakshmipur District", code: "31" },
          { id: 780, name: "Lalmonirhat District", code: "32" },
          { id: 817, name: "Madaripur District", code: "36" },
          { id: 776, name: "Meherpur District", code: "39" },
          { id: 794, name: "Moulvibazar District", code: "38" },
          { id: 790, name: "Munshiganj District", code: "35" },
          { id: 766, name: "Mymensingh District", code: "34" },
          { id: 758, name: "Mymensingh Division", code: "H" },
          { id: 814, name: "Naogaon District", code: "48" },
          { id: 769, name: "Narail District", code: "43" },
          { id: 770, name: "Narayanganj District", code: "40" },
          { id: 787, name: "Natore District", code: "44" },
          { id: 764, name: "Netrokona District", code: "41" },
          { id: 772, name: "Nilphamari District", code: "46" },
          { id: 815, name: "Noakhali District", code: "47" },
          { id: 754, name: "Pabna District", code: "49" },
          { id: 800, name: "Panchagarh District", code: "52" },
          { id: 777, name: "Patuakhali District", code: "51" },
          { id: 791, name: "Pirojpur District", code: "50" },
          { id: 773, name: "Rajbari District", code: "53" },
          { id: 813, name: "Rajshahi District", code: "54" },
          { id: 753, name: "Rajshahi Division", code: "E" },
          { id: 809, name: "Rangamati Hill District", code: "56" },
          { id: 759, name: "Rangpur District", code: "55" },
          { id: 750, name: "Rangpur Division", code: "F" },
          { id: 799, name: "Satkhira District", code: "58" },
          { id: 801, name: "Shariatpur District", code: "62" },
          { id: 755, name: "Sherpur District", code: "57" },
          { id: 781, name: "Sirajganj District", code: "59" },
          { id: 812, name: "Sunamganj District", code: "61" },
          { id: 767, name: "Sylhet District", code: "60" },
          { id: 765, name: "Sylhet Division", code: "G" },
          { id: 782, name: "Tangail District", code: "63" },
          { id: 804, name: "Thakurgaon District", code: "64" }
        ]
      },
      {
        code: "BRB",
        name: "Barbados",
        states: [
          { id: 1228, name: "Christ Church", code: "01" },
          { id: 1229, name: "Saint Andrew", code: "02" },
          { id: 1226, name: "Saint George", code: "03" },
          { id: 1224, name: "Saint James", code: "04" },
          { id: 1227, name: "Saint John", code: "05" },
          { id: 1223, name: "Saint Joseph", code: "06" },
          { id: 1221, name: "Saint Lucy", code: "07" },
          { id: 1230, name: "Saint Michael", code: "08" },
          { id: 1222, name: "Saint Peter", code: "09" },
          { id: 1220, name: "Saint Philip", code: "10" },
          { id: 1225, name: "Saint Thomas", code: "11" }
        ]
      },
      {
        code: "BLR",
        name: "Belarus",
        states: [
          { id: 2959, name: "Brest Region", code: "BR" },
          { id: 2955, name: "Gomel Region", code: "HO" },
          { id: 2956, name: "Grodno Region", code: "HR" },
          { id: 2958, name: "Minsk", code: "HM" },
          { id: 2957, name: "Minsk Region", code: "MI" },
          { id: 2954, name: "Mogilev Region", code: "MA" },
          { id: 2960, name: "Vitebsk Region", code: "VI" }
        ]
      },
      {
        code: "BEL",
        name: "Belgium",
        states: [
          { id: 1381, name: "Antwerp", code: "VAN" },
          { id: 1376, name: "Brussels-Capital Region", code: "BRU" },
          { id: 1377, name: "East Flanders", code: "VOV" },
          { id: 1373, name: "Flanders", code: "VLG" },
          { id: 1374, name: "Flemish Brabant", code: "VBR" },
          { id: 1375, name: "Hainaut", code: "WHT" },
          { id: 1384, name: "Li\xE8ge", code: "WLG" },
          { id: 1372, name: "Limburg", code: "VLI" },
          { id: 1379, name: "Luxembourg", code: "WLX" },
          { id: 1378, name: "Namur", code: "WNA" },
          { id: 1380, name: "Wallonia", code: "WAL" },
          { id: 1382, name: "Walloon Brabant", code: "WBR" },
          { id: 1383, name: "West Flanders", code: "VWV" }
        ]
      },
      {
        code: "BLZ",
        name: "Belize",
        states: [
          { id: 264, name: "Belize District", code: "BZ" },
          { id: 269, name: "Cayo District", code: "CY" },
          { id: 266, name: "Corozal District", code: "CZL" },
          { id: 268, name: "Orange Walk District", code: "OW" },
          { id: 265, name: "Stann Creek District", code: "SC" },
          { id: 267, name: "Toledo District", code: "TOL" }
        ]
      },
      {
        code: "BEN",
        name: "Benin",
        states: [
          { id: 3077, name: "Alibori Department", code: "AL" },
          { id: 3076, name: "Atakora Department", code: "AK" },
          { id: 3079, name: "Atlantique Department", code: "AQ" },
          { id: 3078, name: "Borgou Department", code: "BO" },
          { id: 3070, name: "Collines Department", code: "CO" },
          { id: 3072, name: "Donga Department", code: "DO" },
          { id: 3071, name: "Kouffo Department", code: "KO" },
          { id: 3081, name: "Littoral Department", code: "LI" },
          { id: 3075, name: "Mono Department", code: "MO" },
          { id: 3080, name: "Ou\xE9m\xE9 Department", code: "OU" },
          { id: 3074, name: "Plateau Department", code: "PL" },
          { id: 3073, name: "Zou Department", code: "ZO" }
        ]
      },
      {
        code: "BMU",
        name: "Bermuda",
        states: [
          { id: 4860, name: "Devonshire", code: "DEV" },
          { id: 4861, name: "Hamilton", code: "HA" },
          { id: 4863, name: "Paget", code: "PAG" },
          { id: 4864, name: "Pembroke", code: "PEM" },
          { id: 4866, name: "Saint George's", code: "SGE" },
          { id: 4867, name: "Sandys", code: "SAN" },
          { id: 4868, name: "Smith's", code: "SMI" },
          { id: 4869, name: "Southampton", code: "SOU" },
          { id: 4870, name: "Warwick", code: "WAR" }
        ]
      },
      {
        code: "BTN",
        name: "Bhutan",
        states: [
          { id: 240, name: "Bumthang District", code: "33" },
          { id: 239, name: "Chukha District", code: "12" },
          { id: 238, name: "Dagana District", code: "22" },
          { id: 229, name: "Gasa District", code: "GA" },
          { id: 232, name: "Haa District", code: "13" },
          { id: 234, name: "Lhuntse District", code: "44" },
          { id: 242, name: "Mongar District", code: "42" },
          { id: 237, name: "Paro District", code: "11" },
          { id: 244, name: "Pemagatshel District", code: "43" },
          { id: 235, name: "Punakha District", code: "23" },
          { id: 243, name: "Samdrup Jongkhar District", code: "45" },
          { id: 246, name: "Samtse District", code: "14" },
          { id: 247, name: "Sarpang District", code: "31" },
          { id: 241, name: "Thimphu District", code: "15" },
          { id: 236, name: "Trashigang District", code: "41" },
          { id: 245, name: "Trongsa District", code: "32" },
          { id: 230, name: "Tsirang District", code: "21" },
          { id: 231, name: "Wangdue Phodrang District", code: "24" },
          { id: 233, name: "Zhemgang District", code: "34" }
        ]
      },
      {
        code: "BOL",
        name: "Bolivia",
        states: [
          { id: 3375, name: "Beni Department", code: "B" },
          { id: 3382, name: "Chuquisaca Department", code: "H" },
          { id: 3381, name: "Cochabamba Department", code: "C" },
          { id: 3380, name: "La Paz Department", code: "L" },
          { id: 3376, name: "Oruro Department", code: "O" },
          { id: 3379, name: "Pando Department", code: "N" },
          { id: 3383, name: "Potos\xED Department", code: "P" },
          { id: 3377, name: "Santa Cruz Department", code: "S" },
          { id: 3378, name: "Tarija Department", code: "T" }
        ]
      },
      {
        code: "BES",
        name: "Bonaire, Sint Eustatius and Saba",
        states: [
          { id: 5086, name: "Bonaire", code: "BQ1" },
          { id: 5087, name: "Saba", code: "BQ2" },
          { id: 5088, name: "Sint Eustatius", code: "BQ3" }
        ]
      },
      {
        code: "BIH",
        name: "Bosnia and Herzegovina",
        states: [
          { id: 472, name: "Bosnian Podrinje Canton", code: "05" },
          { id: 460, name: "Br\u010Dko District", code: "BRC" },
          { id: 471, name: "Canton 10", code: "10" },
          { id: 462, name: "Central Bosnia Canton", code: "06" },
          {
            id: 467,
            name: "Federation of Bosnia and Herzegovina",
            code: "BIH"
          },
          { id: 463, name: "Herzegovina-Neretva Canton", code: "07" },
          { id: 464, name: "Posavina Canton", code: "02" },
          { id: 470, name: "Republika Srpska", code: "SRP" },
          { id: 466, name: "Sarajevo Canton", code: "09" },
          { id: 461, name: "Tuzla Canton", code: "03" },
          { id: 465, name: "Una-Sana Canton", code: "01" },
          { id: 469, name: "West Herzegovina Canton", code: "08" },
          { id: 468, name: "Zenica-Doboj Canton", code: "04" }
        ]
      },
      {
        code: "BWA",
        name: "Botswana",
        states: [
          { id: 3067, name: "Central District", code: "CE" },
          { id: 3061, name: "Ghanzi District", code: "GH" },
          { id: 3066, name: "Kgalagadi District", code: "KG" },
          { id: 3062, name: "Kgatleng District", code: "KL" },
          { id: 3069, name: "Kweneng District", code: "KW" },
          { id: 3060, name: "Ngamiland", code: "NG" },
          { id: 3068, name: "North-East District", code: "NE" },
          { id: 3065, name: "North-West District", code: "NW" },
          { id: 3064, name: "South-East District", code: "SE" },
          { id: 3063, name: "Southern District", code: "SO" }
        ]
      },
      { code: "BVT", name: "Bouvet Island", states: [] },
      {
        code: "BRA",
        name: "Brazil",
        states: [
          { id: 2012, name: "Acre", code: "AC" },
          { id: 2007, name: "Alagoas", code: "AL" },
          { id: 1999, name: "Amap\xE1", code: "AP" },
          { id: 2004, name: "Amazonas", code: "AM" },
          { id: 2002, name: "Bahia", code: "BA" },
          { id: 2016, name: "Cear\xE1", code: "CE" },
          { id: 2017, name: "Distrito Federal", code: "DF" },
          { id: 2018, name: "Esp\xEDrito Santo", code: "ES" },
          { id: 2e3, name: "Goi\xE1s", code: "GO" },
          { id: 2015, name: "Maranh\xE3o", code: "MA" },
          { id: 2011, name: "Mato Grosso", code: "MT" },
          { id: 2010, name: "Mato Grosso do Sul", code: "MS" },
          { id: 1998, name: "Minas Gerais", code: "MG" },
          { id: 2009, name: "Par\xE1", code: "PA" },
          { id: 2005, name: "Para\xEDba", code: "PB" },
          { id: 2022, name: "Paran\xE1", code: "PR" },
          { id: 2006, name: "Pernambuco", code: "PE" },
          { id: 2008, name: "Piau\xED", code: "PI" },
          { id: 1997, name: "Rio de Janeiro", code: "RJ" },
          { id: 2019, name: "Rio Grande do Norte", code: "RN" },
          { id: 2001, name: "Rio Grande do Sul", code: "RS" },
          { id: 2013, name: "Rond\xF4nia", code: "RO" },
          { id: 4858, name: "Roraima", code: "RR" },
          { id: 2014, name: "Santa Catarina", code: "SC" },
          { id: 2021, name: "S\xE3o Paulo", code: "SP" },
          { id: 2003, name: "Sergipe", code: "SE" },
          { id: 2020, name: "Tocantins", code: "TO" }
        ]
      },
      { code: "IOT", name: "British Indian Ocean Territory", states: [] },
      {
        code: "BRN",
        name: "Brunei",
        states: [
          { id: 1217, name: "Belait District", code: "BE" },
          { id: 1216, name: "Brunei-Muara District", code: "BM" },
          { id: 1218, name: "Temburong District", code: "TE" },
          { id: 1219, name: "Tutong District", code: "TU" }
        ]
      },
      {
        code: "BGR",
        name: "Bulgaria",
        states: [
          { id: 4699, name: "Blagoevgrad Province", code: "01" },
          { id: 4715, name: "Burgas Province", code: "02" },
          { id: 4718, name: "Dobrich Province", code: "08" },
          { id: 4693, name: "Gabrovo Province", code: "07" },
          { id: 4704, name: "Haskovo Province", code: "26" },
          { id: 4702, name: "Kardzhali Province", code: "09" },
          { id: 4703, name: "Kyustendil Province", code: "10" },
          { id: 4710, name: "Lovech Province", code: "11" },
          { id: 4696, name: "Montana Province", code: "12" },
          { id: 4712, name: "Pazardzhik Province", code: "13" },
          { id: 4695, name: "Pernik Province", code: "14" },
          { id: 4706, name: "Pleven Province", code: "15" },
          { id: 4701, name: "Plovdiv Province", code: "16" },
          { id: 4698, name: "Razgrad Province", code: "17" },
          { id: 4713, name: "Ruse Province", code: "18" },
          { id: 4882, name: "Shumen", code: "27" },
          { id: 4708, name: "Silistra Province", code: "19" },
          { id: 4700, name: "Sliven Province", code: "20" },
          { id: 4694, name: "Smolyan Province", code: "21" },
          { id: 4705, name: "Sofia City Province", code: "22" },
          { id: 4719, name: "Sofia Province", code: "23" },
          { id: 4707, name: "Stara Zagora Province", code: "24" },
          { id: 4714, name: "Targovishte Province", code: "25" },
          { id: 4717, name: "Varna Province", code: "03" },
          { id: 4709, name: "Veliko Tarnovo Province", code: "04" },
          { id: 4697, name: "Vidin Province", code: "05" },
          { id: 4711, name: "Vratsa Province", code: "06" },
          { id: 4716, name: "Yambol Province", code: "28" }
        ]
      },
      {
        code: "BFA",
        name: "Burkina Faso",
        states: [
          { id: 3160, name: "Bal\xE9 Province", code: "BAL" },
          { id: 3155, name: "Bam Province", code: "BAM" },
          { id: 3120, name: "Banwa Province", code: "BAN" },
          { id: 3152, name: "Baz\xE8ga Province", code: "BAZ" },
          { id: 3138, name: "Boucle du Mouhoun Region", code: "01" },
          { id: 3121, name: "Bougouriba Province", code: "BGR" },
          { id: 3131, name: "Boulgou", code: "BLG" },
          { id: 3153, name: "Cascades Region", code: "02" },
          { id: 3136, name: "Centre", code: "03" },
          { id: 3162, name: "Centre-Est Region", code: "04" },
          { id: 3127, name: "Centre-Nord Region", code: "05" },
          { id: 3115, name: "Centre-Ouest Region", code: "06" },
          { id: 3149, name: "Centre-Sud Region", code: "07" },
          { id: 3167, name: "Como\xE9 Province", code: "COM" },
          { id: 3158, name: "Est Region", code: "08" },
          { id: 3148, name: "Ganzourgou Province", code: "GAN" },
          { id: 3122, name: "Gnagna Province", code: "GNA" },
          { id: 3143, name: "Gourma Province", code: "GOU" },
          { id: 3165, name: "Hauts-Bassins Region", code: "09" },
          { id: 3129, name: "Houet Province", code: "HOU" },
          { id: 3135, name: "Ioba Province", code: "IOB" },
          { id: 3168, name: "Kadiogo Province", code: "KAD" },
          { id: 3112, name: "K\xE9n\xE9dougou Province", code: "KEN" },
          { id: 3132, name: "Komondjari Province", code: "KMD" },
          { id: 3157, name: "Kompienga Province", code: "KMP" },
          { id: 3146, name: "Kossi Province", code: "KOS" },
          { id: 3133, name: "Koulp\xE9logo Province", code: "KOP" },
          { id: 3161, name: "Kouritenga Province", code: "KOT" },
          { id: 3147, name: "Kourw\xE9ogo Province", code: "KOW" },
          { id: 3159, name: "L\xE9raba Province", code: "LER" },
          { id: 3151, name: "Loroum Province", code: "LOR" },
          { id: 3123, name: "Mouhoun", code: "MOU" },
          { id: 3116, name: "Nahouri Province", code: "NAO" },
          { id: 3113, name: "Namentenga Province", code: "NAM" },
          { id: 3142, name: "Nayala Province", code: "NAY" },
          { id: 3164, name: "Nord Region, Burkina Faso", code: "10" },
          { id: 3156, name: "Noumbiel Province", code: "NOU" },
          { id: 3141, name: "Oubritenga Province", code: "OUB" },
          { id: 3144, name: "Oudalan Province", code: "OUD" },
          { id: 3117, name: "Passor\xE9 Province", code: "PAS" },
          { id: 3125, name: "Plateau-Central Region", code: "11" },
          { id: 3163, name: "Poni Province", code: "PON" },
          { id: 3114, name: "Sahel Region", code: "12" },
          { id: 3154, name: "Sangui\xE9 Province", code: "SNG" },
          { id: 3126, name: "Sanmatenga Province", code: "SMT" },
          { id: 3139, name: "S\xE9no Province", code: "SEN" },
          { id: 3119, name: "Sissili Province", code: "SIS" },
          { id: 3166, name: "Soum Province", code: "SOM" },
          { id: 3137, name: "Sourou Province", code: "SOR" },
          { id: 3140, name: "Sud-Ouest Region", code: "13" },
          { id: 3128, name: "Tapoa Province", code: "TAP" },
          { id: 3134, name: "Tuy Province", code: "TUI" },
          { id: 3124, name: "Yagha Province", code: "YAG" },
          { id: 3150, name: "Yatenga Province", code: "YAT" },
          { id: 3145, name: "Ziro Province", code: "ZIR" },
          { id: 3130, name: "Zondoma Province", code: "ZON" },
          { id: 3118, name: "Zoundw\xE9ogo Province", code: "ZOU" }
        ]
      },
      {
        code: "BDI",
        name: "Burundi",
        states: [
          { id: 3196, name: "Bubanza Province", code: "BB" },
          { id: 3198, name: "Bujumbura Mairie Province", code: "BM" },
          { id: 3200, name: "Bujumbura Rural Province", code: "BL" },
          { id: 3202, name: "Bururi Province", code: "BR" },
          { id: 3201, name: "Cankuzo Province", code: "CA" },
          { id: 3190, name: "Cibitoke Province", code: "CI" },
          { id: 3197, name: "Gitega Province", code: "GI" },
          { id: 3194, name: "Karuzi Province", code: "KR" },
          { id: 3192, name: "Kayanza Province", code: "KY" },
          { id: 3195, name: "Kirundo Province", code: "KI" },
          { id: 3188, name: "Makamba Province", code: "MA" },
          { id: 3193, name: "Muramvya Province", code: "MU" },
          { id: 3186, name: "Muyinga Province", code: "MY" },
          { id: 3187, name: "Mwaro Province", code: "MW" },
          { id: 3199, name: "Ngozi Province", code: "NG" },
          { id: 3185, name: "Rumonge Province", code: "RM" },
          { id: 3189, name: "Rutana Province", code: "RT" },
          { id: 3191, name: "Ruyigi Province", code: "RY" }
        ]
      },
      {
        code: "KHM",
        name: "Cambodia",
        states: [
          { id: 3984, name: "Banteay Meanchey", code: "1" },
          { id: 3976, name: "Battambang", code: "2" },
          { id: 3991, name: "Kampong Cham", code: "3" },
          { id: 3979, name: "Kampong Chhnang", code: "4" },
          { id: 3988, name: "Kampong Speu", code: "5" },
          { id: 5070, name: "Kampong Thom", code: "6" },
          { id: 3981, name: "Kampot", code: "7" },
          { id: 3983, name: "Kandal", code: "8" },
          { id: 3978, name: "Kep", code: "23" },
          { id: 3982, name: "Koh Kong", code: "9" },
          { id: 3986, name: "Kratie", code: "10" },
          { id: 3985, name: "Mondulkiri", code: "11" },
          { id: 3987, name: "Oddar Meanchey", code: "22" },
          { id: 3980, name: "Pailin", code: "24" },
          { id: 3994, name: "Phnom Penh", code: "12" },
          { id: 3973, name: "Preah Vihear", code: "13" },
          { id: 3974, name: "Prey Veng", code: "14" },
          { id: 3977, name: "Pursat", code: "15" },
          { id: 3990, name: "Ratanakiri", code: "16" },
          { id: 3992, name: "Siem Reap", code: "17" },
          { id: 3989, name: "Sihanoukville", code: "18" },
          { id: 3993, name: "Stung Treng", code: "19" },
          { id: 3972, name: "Svay Rieng", code: "20" },
          { id: 3975, name: "Takeo", code: "21" }
        ]
      },
      {
        code: "CMR",
        name: "Cameroon",
        states: [
          { id: 2663, name: "Adamawa", code: "AD" },
          { id: 2660, name: "Centre", code: "CE" },
          { id: 2661, name: "East", code: "ES" },
          { id: 2656, name: "Far North", code: "EN" },
          { id: 2662, name: "Littoral", code: "LT" },
          { id: 2665, name: "North", code: "NO" },
          { id: 2657, name: "Northwest", code: "NW" },
          { id: 2659, name: "South", code: "SU" },
          { id: 2658, name: "Southwest", code: "SW" },
          { id: 2664, name: "West", code: "OU" }
        ]
      },
      {
        code: "CAN",
        name: "Canada",
        states: [
          { id: 872, name: "Alberta", code: "AB" },
          { id: 875, name: "British Columbia", code: "BC" },
          { id: 867, name: "Manitoba", code: "MB" },
          { id: 868, name: "New Brunswick", code: "NB" },
          { id: 877, name: "Newfoundland and Labrador", code: "NL" },
          { id: 878, name: "Northwest Territories", code: "NT" },
          { id: 874, name: "Nova Scotia", code: "NS" },
          { id: 876, name: "Nunavut", code: "NU" },
          { id: 866, name: "Ontario", code: "ON" },
          { id: 871, name: "Prince Edward Island", code: "PE" },
          { id: 873, name: "Quebec", code: "QC" },
          { id: 870, name: "Saskatchewan", code: "SK" },
          { id: 869, name: "Yukon", code: "YT" }
        ]
      },
      {
        code: "CPV",
        name: "Cape Verde",
        states: [
          { id: 2994, name: "Barlavento Islands", code: "B" },
          { id: 2999, name: "Boa Vista", code: "BV" },
          { id: 2996, name: "Brava", code: "BR" },
          { id: 2991, name: "Maio Municipality", code: "MA" },
          { id: 2987, name: "Mosteiros", code: "MO" },
          { id: 2997, name: "Paul", code: "PA" },
          { id: 2989, name: "Porto Novo", code: "PN" },
          { id: 2988, name: "Praia", code: "PR" },
          { id: 2982, name: "Ribeira Brava Municipality", code: "RB" },
          { id: 3002, name: "Ribeira Grande", code: "RG" },
          { id: 2984, name: "Ribeira Grande de Santiago", code: "RS" },
          { id: 2998, name: "Sal", code: "SL" },
          { id: 2985, name: "Santa Catarina", code: "CA" },
          { id: 2995, name: "Santa Catarina do Fogo", code: "CF" },
          { id: 3004, name: "Santa Cruz", code: "CR" },
          { id: 2986, name: "S\xE3o Domingos", code: "SD" },
          { id: 3e3, name: "S\xE3o Filipe", code: "SF" },
          { id: 2993, name: "S\xE3o Louren\xE7o dos \xD3rg\xE3os", code: "SO" },
          { id: 2990, name: "S\xE3o Miguel", code: "SM" },
          { id: 3001, name: "S\xE3o Vicente", code: "SV" },
          { id: 2992, name: "Sotavento Islands", code: "S" },
          { id: 2983, name: "Tarrafal", code: "TA" },
          { id: 3003, name: "Tarrafal de S\xE3o Nicolau", code: "TS" }
        ]
      },
      { code: "CYM", name: "Cayman Islands", states: [] },
      {
        code: "CAF",
        name: "Central African Republic",
        states: [
          { id: 1259, name: "Bamingui-Bangoran Prefecture", code: "BB" },
          { id: 1262, name: "Bangui", code: "BGF" },
          { id: 1264, name: "Basse-Kotto Prefecture", code: "BK" },
          { id: 1258, name: "Haut-Mbomou Prefecture", code: "HM" },
          { id: 1268, name: "Haute-Kotto Prefecture", code: "HK" },
          { id: 1263, name: "K\xE9mo Prefecture", code: "KG" },
          { id: 1256, name: "Lobaye Prefecture", code: "LB" },
          { id: 1257, name: "Mamb\xE9r\xE9-Kad\xE9\xEF", code: "HS" },
          { id: 1266, name: "Mbomou Prefecture", code: "MB" },
          { id: 1253, name: "Nana-Gr\xE9bizi Economic Prefecture", code: "KB" },
          { id: 1260, name: "Nana-Mamb\xE9r\xE9 Prefecture", code: "NM" },
          { id: 1255, name: "Ombella-M'Poko Prefecture", code: "MP" },
          { id: 1265, name: "Ouaka Prefecture", code: "UK" },
          { id: 1254, name: "Ouham Prefecture", code: "AC" },
          { id: 1267, name: "Ouham-Pend\xE9 Prefecture", code: "OP" },
          { id: 1252, name: "Sangha-Mba\xE9r\xE9", code: "SE" },
          { id: 1261, name: "Vakaga Prefecture", code: "VK" }
        ]
      },
      {
        code: "TCD",
        name: "Chad",
        states: [
          { id: 3583, name: "Bahr el Gazel", code: "BG" },
          { id: 3590, name: "Batha", code: "BA" },
          { id: 3574, name: "Borkou", code: "BO" },
          { id: 5114, name: "Chari-Baguirmi", code: "CB" },
          { id: 3575, name: "Ennedi-Est", code: "EE" },
          { id: 3584, name: "Ennedi-Ouest", code: "EO" },
          { id: 3576, name: "Gu\xE9ra", code: "GR" },
          { id: 3573, name: "Hadjer-Lamis", code: "HL" },
          { id: 3588, name: "Kanem", code: "KA" },
          { id: 3577, name: "Lac", code: "LC" },
          { id: 3585, name: "Logone Occidental", code: "LO" },
          { id: 3591, name: "Logone Oriental", code: "LR" },
          { id: 3589, name: "Mandoul", code: "MA" },
          { id: 3580, name: "Mayo-Kebbi Est", code: "ME" },
          { id: 3571, name: "Mayo-Kebbi Ouest", code: "MO" },
          { id: 3570, name: "Moyen-Chari", code: "MC" },
          { id: 3586, name: "N'Djamena", code: "ND" },
          { id: 3582, name: "Ouadda\xEF", code: "OD" },
          { id: 3592, name: "Salamat", code: "SA" },
          { id: 3572, name: "Sila", code: "SI" },
          { id: 3579, name: "Tandjil\xE9", code: "TA" },
          { id: 3587, name: "Tibesti", code: "TI" },
          { id: 3581, name: "Wadi Fira", code: "WF" }
        ]
      },
      {
        code: "CHL",
        name: "Chile",
        states: [
          {
            id: 2828,
            name: "Ais\xE9n del General Carlos Iba\xF1ez del Campo",
            code: "AI"
          },
          { id: 2832, name: "Antofagasta", code: "AN" },
          { id: 2829, name: "Arica y Parinacota", code: "AP" },
          { id: 2823, name: "Atacama", code: "AT" },
          { id: 2827, name: "Biob\xEDo", code: "BI" },
          { id: 2825, name: "Coquimbo", code: "CO" },
          { id: 2826, name: "La Araucan\xEDa", code: "AR" },
          {
            id: 2838,
            name: "Libertador General Bernardo O'Higgins",
            code: "LI"
          },
          { id: 2835, name: "Los Lagos", code: "LL" },
          { id: 2834, name: "Los R\xEDos", code: "LR" },
          {
            id: 2836,
            name: "Magallanes y de la Ant\xE1rtica Chilena",
            code: "MA"
          },
          { id: 2833, name: "Maule", code: "ML" },
          { id: 2831, name: "\xD1uble", code: "NB" },
          { id: 2824, name: "Regi\xF3n Metropolitana de Santiago", code: "RM" },
          { id: 2837, name: "Tarapac\xE1", code: "TA" },
          { id: 2830, name: "Valpara\xEDso", code: "VS" }
        ]
      },
      {
        code: "CHN",
        name: "China",
        states: [
          { id: 2251, name: "Anhui", code: "AH" },
          { id: 2257, name: "Beijing", code: "BJ" },
          { id: 2271, name: "Chongqing", code: "CQ" },
          { id: 2248, name: "Fujian", code: "FJ" },
          { id: 2275, name: "Gansu", code: "GS" },
          { id: 2279, name: "Guangdong", code: "GD" },
          { id: 2278, name: "Guangxi Zhuang", code: "GX" },
          { id: 2261, name: "Guizhou", code: "GZ" },
          { id: 2273, name: "Hainan", code: "HI" },
          { id: 2280, name: "Hebei", code: "HE" },
          { id: 2265, name: "Heilongjiang", code: "HL" },
          { id: 2259, name: "Henan", code: "HA" },
          { id: 2267, name: "Hong Kong SAR", code: "HK" },
          { id: 2274, name: "Hubei", code: "HB" },
          { id: 2258, name: "Hunan", code: "HN" },
          { id: 2269, name: "Inner Mongolia", code: "NM" },
          { id: 2250, name: "Jiangsu", code: "JS" },
          { id: 2256, name: "Jiangxi", code: "JX" },
          { id: 2253, name: "Jilin", code: "JL" },
          { id: 2268, name: "Liaoning", code: "LN" },
          { id: 2266, name: "Macau SAR", code: "MO" },
          { id: 2262, name: "Ningxia Huizu", code: "NX" },
          { id: 2270, name: "Qinghai", code: "QH" },
          { id: 2272, name: "Shaanxi", code: "SN" },
          { id: 2252, name: "Shandong", code: "SD" },
          { id: 2249, name: "Shanghai", code: "SH" },
          { id: 2254, name: "Shanxi", code: "SX" },
          { id: 2277, name: "Sichuan", code: "SC" },
          { id: 2255, name: "Taiwan", code: "TW" },
          { id: 2276, name: "Tianjin", code: "TJ" },
          { id: 2263, name: "Xinjiang", code: "XJ" },
          { id: 2264, name: "Xizang", code: "XZ" },
          { id: 2260, name: "Yunnan", code: "YN" },
          { id: 2247, name: "Zhejiang", code: "ZJ" }
        ]
      },
      { code: "CXR", name: "Christmas Island", states: [] },
      { code: "CCK", name: "Cocos (Keeling) Islands", states: [] },
      {
        code: "COL",
        name: "Colombia",
        states: [
          { id: 2895, name: "Amazonas", code: "AMA" },
          { id: 2890, name: "Antioquia", code: "ANT" },
          { id: 2881, name: "Arauca", code: "ARA" },
          {
            id: 2900,
            name: "Archipi\xE9lago de San Andr\xE9s, Providencia y Santa Catalina",
            code: "SAP"
          },
          { id: 2880, name: "Atl\xE1ntico", code: "ATL" },
          { id: 4921, name: "Bogot\xE1 D.C.", code: "DC" },
          { id: 2893, name: "Bol\xEDvar", code: "BOL" },
          { id: 2903, name: "Boyac\xE1", code: "BOY" },
          { id: 2887, name: "Caldas", code: "CAL" },
          { id: 2891, name: "Caquet\xE1", code: "CAQ" },
          { id: 2892, name: "Casanare", code: "CAS" },
          { id: 2884, name: "Cauca", code: "CAU" },
          { id: 2899, name: "Cesar", code: "CES" },
          { id: 2876, name: "Choc\xF3", code: "CHO" },
          { id: 2898, name: "C\xF3rdoba", code: "COR" },
          { id: 2875, name: "Cundinamarca", code: "CUN" },
          { id: 2882, name: "Guain\xEDa", code: "GUA" },
          { id: 2888, name: "Guaviare", code: "GUV" },
          { id: 4871, name: "Huila", code: "HUI" },
          { id: 2889, name: "La Guajira", code: "LAG" },
          { id: 2886, name: "Magdalena", code: "MAG" },
          { id: 2878, name: "Meta", code: "MET" },
          { id: 2897, name: "Nari\xF1o", code: "NAR" },
          { id: 2877, name: "Norte de Santander", code: "NSA" },
          { id: 2896, name: "Putumayo", code: "PUT" },
          { id: 2874, name: "Quind\xEDo", code: "QUI" },
          { id: 2879, name: "Risaralda", code: "RIS" },
          { id: 2901, name: "Santander", code: "SAN" },
          { id: 2902, name: "Sucre", code: "SUC" },
          { id: 2883, name: "Tolima", code: "TOL" },
          { id: 2904, name: "Valle del Cauca", code: "VAC" },
          { id: 2885, name: "Vaup\xE9s", code: "VAU" },
          { id: 2894, name: "Vichada", code: "VID" }
        ]
      },
      {
        code: "COM",
        name: "Comoros",
        states: [
          { id: 2821, name: "Anjouan", code: "A" },
          { id: 2822, name: "Grande Comore", code: "G" },
          { id: 2820, name: "Moh\xE9li", code: "M" }
        ]
      },
      {
        code: "COG",
        name: "Congo",
        states: [
          { id: 2866, name: "Bouenza Department", code: "11" },
          { id: 2870, name: "Brazzaville", code: "BZV" },
          { id: 2864, name: "Cuvette Department", code: "8" },
          { id: 2869, name: "Cuvette-Ouest Department", code: "15" },
          { id: 2867, name: "Kouilou Department", code: "5" },
          { id: 2868, name: "L\xE9koumou Department", code: "2" },
          { id: 2865, name: "Likouala Department", code: "7" },
          { id: 2872, name: "Niari Department", code: "9" },
          { id: 2862, name: "Plateaux Department", code: "14" },
          { id: 2863, name: "Pointe-Noire", code: "16" },
          { id: 2873, name: "Pool Department", code: "12" },
          { id: 2871, name: "Sangha Department", code: "13" }
        ]
      },
      { code: "COK", name: "Cook Islands", states: [] },
      {
        code: "CRI",
        name: "Costa Rica",
        states: [
          { id: 1215, name: "Alajuela Province", code: "A" },
          { id: 1209, name: "Guanacaste Province", code: "G" },
          { id: 1212, name: "Heredia Province", code: "H" },
          { id: 1213, name: "Lim\xF3n Province", code: "L" },
          { id: 1211, name: "Provincia de Cartago", code: "C" },
          { id: 1210, name: "Puntarenas Province", code: "P" },
          { id: 1214, name: "San Jos\xE9 Province", code: "SJ" }
        ]
      },
      {
        code: "CIV",
        name: "Cote D'Ivoire (Ivory Coast)",
        states: [
          { id: 2634, name: "Abidjan", code: "AB" },
          { id: 2626, name: "Agn\xE9by", code: "16" },
          { id: 2636, name: "Bafing Region", code: "17" },
          { id: 2643, name: "Bas-Sassandra District", code: "BS" },
          { id: 2635, name: "Bas-Sassandra Region", code: "09" },
          { id: 2654, name: "Como\xE9 District", code: "CM" },
          { id: 2644, name: "Dengu\xE9l\xE9 District", code: "DN" },
          { id: 2642, name: "Dengu\xE9l\xE9 Region", code: "10" },
          { id: 2645, name: "Dix-Huit Montagnes", code: "06" },
          { id: 2633, name: "Fromager", code: "18" },
          { id: 2651, name: "G\xF4h-Djiboua District", code: "GD" },
          { id: 2638, name: "Haut-Sassandra", code: "02" },
          { id: 2632, name: "Lacs District", code: "LC" },
          { id: 2640, name: "Lacs Region", code: "07" },
          { id: 2627, name: "Lagunes District", code: "LG" },
          { id: 2639, name: "Lagunes region", code: "01" },
          { id: 2631, name: "Marahou\xE9 Region", code: "12" },
          { id: 2629, name: "Montagnes District", code: "MG" },
          { id: 2646, name: "Moyen-Cavally", code: "19" },
          { id: 2630, name: "Moyen-Como\xE9", code: "05" },
          { id: 2655, name: "N'zi-Como\xE9", code: "11" },
          { id: 2648, name: "Sassandra-Marahou\xE9 District", code: "SM" },
          { id: 2625, name: "Savanes Region", code: "03" },
          { id: 2628, name: "Sud-Bandama", code: "15" },
          { id: 2652, name: "Sud-Como\xE9", code: "13" },
          { id: 2637, name: "Vall\xE9e du Bandama District", code: "VB" },
          { id: 2647, name: "Vall\xE9e du Bandama Region", code: "04" },
          { id: 2650, name: "Woroba District", code: "WR" },
          { id: 2649, name: "Worodougou", code: "14" },
          { id: 2653, name: "Yamoussoukro", code: "YM" },
          { id: 2641, name: "Zanzan Region", code: "ZZ" }
        ]
      },
      {
        code: "HRV",
        name: "Croatia",
        states: [
          { id: 734, name: "Bjelovar-Bilogora", code: "07" },
          { id: 737, name: "Brod-Posavina", code: "12" },
          { id: 728, name: "Dubrovnik-Neretva", code: "19" },
          { id: 743, name: "Istria", code: "18" },
          { id: 5069, name: "Karlovac", code: "04" },
          { id: 742, name: "Koprivnica-Kri\u017Eevci", code: "06" },
          { id: 729, name: "Krapina-Zagorje", code: "02" },
          { id: 731, name: "Lika-Senj", code: "09" },
          { id: 726, name: "Me\u0111imurje", code: "20" },
          { id: 740, name: "Osijek-Baranja", code: "14" },
          { id: 724, name: "Po\u017Eega-Slavonia", code: "11" },
          { id: 735, name: "Primorje-Gorski Kotar", code: "08" },
          { id: 730, name: "\u0160ibenik-Knin", code: "15" },
          { id: 733, name: "Sisak-Moslavina", code: "03" },
          { id: 725, name: "Split-Dalmatia", code: "17" },
          { id: 739, name: "Vara\u017Edin", code: "05" },
          { id: 732, name: "Virovitica-Podravina", code: "10" },
          { id: 741, name: "Vukovar-Syrmia", code: "16" },
          { id: 727, name: "Zadar", code: "13" },
          { id: 736, name: "Zagreb", code: "01" },
          { id: 738, name: "Zagreb", code: "21" }
        ]
      },
      {
        code: "CUB",
        name: "Cuba",
        states: [
          { id: 283, name: "Artemisa Province", code: "15" },
          { id: 286, name: "Camag\xFCey Province", code: "09" },
          { id: 282, name: "Ciego de \xC1vila Province", code: "08" },
          { id: 287, name: "Cienfuegos Province", code: "06" },
          { id: 275, name: "Granma Province", code: "12" },
          { id: 285, name: "Guant\xE1namo Province", code: "14" },
          { id: 272, name: "Havana Province", code: "03" },
          { id: 279, name: "Holgu\xEDn Province", code: "11" },
          { id: 278, name: "Isla de la Juventud", code: "99" },
          { id: 281, name: "Las Tunas Province", code: "10" },
          { id: 284, name: "Matanzas Province", code: "04" },
          { id: 276, name: "Mayabeque Province", code: "16" },
          { id: 277, name: "Pinar del R\xEDo Province", code: "01" },
          { id: 274, name: "Sancti Sp\xEDritus Province", code: "07" },
          { id: 273, name: "Santiago de Cuba Province", code: "13" },
          { id: 280, name: "Villa Clara Province", code: "05" }
        ]
      },
      { code: "CUW", name: "Cura\xE7ao", states: [] },
      {
        code: "CYP",
        name: "Cyprus",
        states: [
          { id: 749, name: "Famagusta District (Ma\u011Fusa)", code: "04" },
          { id: 744, name: "Kyrenia District (Keryneia)", code: "06" },
          { id: 747, name: "Larnaca District (Larnaka)", code: "03" },
          { id: 748, name: "Limassol District (Leymasun)", code: "02" },
          { id: 745, name: "Nicosia District (Lefko\u015Fa)", code: "01" },
          { id: 746, name: "Paphos District (Pafos)", code: "05" }
        ]
      },
      {
        code: "CZE",
        name: "Czech Republic",
        states: [
          { id: 4627, name: "Bene\u0161ov", code: "201" },
          { id: 4620, name: "Beroun", code: "202" },
          { id: 4615, name: "Blansko", code: "641" },
          { id: 4542, name: "B\u0159eclav", code: "644" },
          { id: 4568, name: "Brno-m\u011Bsto", code: "642" },
          { id: 4545, name: "Brno-venkov", code: "643" },
          { id: 4644, name: "Brunt\xE1l", code: "801" },
          { id: 4633, name: "\u010Cesk\xE1 L\xEDpa", code: "511" },
          { id: 4556, name: "\u010Cesk\xE9 Bud\u011Bjovice", code: "311" },
          { id: 4543, name: "\u010Cesk\xFD Krumlov", code: "312" },
          { id: 4573, name: "Cheb", code: "411" },
          { id: 4553, name: "Chomutov", code: "422" },
          { id: 4634, name: "Chrudim", code: "531" },
          { id: 4609, name: "D\u011B\u010D\xEDn", code: "421" },
          { id: 4641, name: "Doma\u017Elice", code: "321" },
          { id: 4559, name: "Fr\xFDdek-M\xEDstek", code: "802" },
          { id: 4611, name: "Havl\xED\u010Dk\u016Fv Brod", code: "631" },
          { id: 4561, name: "Hodon\xEDn", code: "645" },
          { id: 4580, name: "Hradec Kr\xE1lov\xE9", code: "521" },
          { id: 4612, name: "Jablonec nad Nisou", code: "512" },
          { id: 4625, name: "Jesen\xEDk", code: "711" },
          { id: 4640, name: "Ji\u010D\xEDn", code: "522" },
          { id: 4613, name: "Jihlava", code: "632" },
          { id: 4639, name: "Jiho\u010Desk\xFD kraj", code: "31" },
          { id: 4602, name: "Jihomoravsk\xFD kraj", code: "64" },
          { id: 4624, name: "Jind\u0159ich\u016Fv Hradec", code: "313" },
          { id: 4581, name: "Karlovarsk\xFD kraj", code: "41" },
          { id: 4604, name: "Karlovy Vary", code: "412" },
          { id: 4586, name: "Karvin\xE1", code: "803" },
          { id: 4631, name: "Kladno", code: "203" },
          { id: 4591, name: "Klatovy", code: "322" },
          { id: 4618, name: "Kol\xEDn", code: "204" },
          { id: 4575, name: "Kraj Vyso\u010Dina", code: "63" },
          { id: 4614, name: "Kr\xE1lov\xE9hradeck\xFD kraj", code: "52" },
          { id: 4593, name: "Krom\u011B\u0159\xED\u017E", code: "721" },
          { id: 4923, name: "Kutn\xE1 Hora", code: "205" },
          { id: 4590, name: "Liberec", code: "513" },
          { id: 4601, name: "Libereck\xFD kraj", code: "51" },
          { id: 4605, name: "Litom\u011B\u0159ice", code: "423" },
          { id: 4617, name: "Louny", code: "424" },
          { id: 4638, name: "M\u011Bln\xEDk", code: "206" },
          { id: 4643, name: "Mlad\xE1 Boleslav", code: "207" },
          { id: 4600, name: "Moravskoslezsk\xFD kraj", code: "80" },
          { id: 4629, name: "Most", code: "425" },
          { id: 4550, name: "N\xE1chod", code: "523" },
          { id: 4548, name: "Nov\xFD Ji\u010D\xEDn", code: "804" },
          { id: 4582, name: "Nymburk", code: "208" },
          { id: 4574, name: "Olomouc", code: "712" },
          { id: 4589, name: "Olomouck\xFD kraj", code: "71" },
          { id: 4623, name: "Opava", code: "805" },
          { id: 4584, name: "Ostrava-m\u011Bsto", code: "806" },
          { id: 4547, name: "Pardubice", code: "532" },
          { id: 4588, name: "Pardubick\xFD kraj", code: "53" },
          { id: 4645, name: "Pelh\u0159imov", code: "633" },
          { id: 4560, name: "P\xEDsek", code: "314" },
          { id: 4608, name: "Plze\u0148-jih", code: "324" },
          { id: 4544, name: "Plze\u0148-m\u011Bsto", code: "323" },
          { id: 4564, name: "Plze\u0148-sever", code: "325" },
          { id: 4607, name: "Plze\u0148sk\xFD kraj", code: "32" },
          { id: 4578, name: "Prachatice", code: "315" },
          { id: 4606, name: "Praha-v\xFDchod", code: "209" },
          { id: 4619, name: "Praha-z\xE1pad", code: "20A" },
          { id: 4598, name: "Praha, Hlavn\xED m\u011Bsto", code: "10" },
          { id: 4626, name: "P\u0159erov", code: "714" },
          { id: 4546, name: "P\u0159\xEDbram", code: "20B" },
          { id: 4551, name: "Prost\u011Bjov", code: "713" },
          { id: 4558, name: "Rakovn\xEDk", code: "20C" },
          { id: 4583, name: "Rokycany", code: "326" },
          { id: 4636, name: "Rychnov nad Kn\u011B\u017Enou", code: "524" },
          { id: 4596, name: "Semily", code: "514" },
          { id: 4595, name: "Sokolov", code: "413" },
          { id: 4628, name: "Strakonice", code: "316" },
          { id: 4554, name: "St\u0159edo\u010Desk\xFD kraj", code: "20" },
          { id: 4642, name: "\u0160umperk", code: "715" },
          { id: 4571, name: "Svitavy", code: "533" },
          { id: 4565, name: "T\xE1bor", code: "317" },
          { id: 4646, name: "Tachov", code: "327" },
          { id: 4621, name: "Teplice", code: "426" },
          { id: 4597, name: "T\u0159eb\xED\u010D", code: "634" },
          { id: 4579, name: "Trutnov", code: "525" },
          { id: 4592, name: "Uhersk\xE9 Hradi\u0161t\u011B", code: "722" },
          { id: 4576, name: "\xDAsteck\xFD kraj", code: "42" },
          { id: 4599, name: "\xDAst\xED nad Labem", code: "427" },
          { id: 4647, name: "\xDAst\xED nad Orlic\xED", code: "534" },
          { id: 4572, name: "Vset\xEDn", code: "723" },
          { id: 4622, name: "Vy\u0161kov", code: "646" },
          { id: 4648, name: "\u017D\u010F\xE1r nad S\xE1zavou", code: "635" },
          { id: 4563, name: "Zl\xEDn", code: "724" },
          { id: 4552, name: "Zl\xEDnsk\xFD kraj", code: "72" },
          { id: 4630, name: "Znojmo", code: "647" }
        ]
      },
      {
        code: "COD",
        name: "Democratic Republic of the Congo",
        states: [
          { id: 2753, name: "Bas-U\xE9l\xE9", code: "BU" },
          { id: 2744, name: "\xC9quateur", code: "EQ" },
          { id: 2750, name: "Haut-Katanga", code: "HK" },
          { id: 2758, name: "Haut-Lomami", code: "HL" },
          { id: 2734, name: "Haut-U\xE9l\xE9", code: "HU" },
          { id: 2751, name: "Ituri", code: "IT" },
          { id: 2757, name: "Kasa\xEF", code: "KS" },
          { id: 2742, name: "Kasa\xEF Central", code: "KC" },
          { id: 2735, name: "Kasa\xEF Oriental", code: "KE" },
          { id: 2741, name: "Kinshasa", code: "KN" },
          { id: 2746, name: "Kongo Central", code: "BC" },
          { id: 2740, name: "Kwango", code: "KG" },
          { id: 2759, name: "Kwilu", code: "KL" },
          { id: 2747, name: "Lomami", code: "LO" },
          { id: 4953, name: "Lualaba", code: "LU" },
          { id: 2755, name: "Mai-Ndombe", code: "MN" },
          { id: 2745, name: "Maniema", code: "MA" },
          { id: 2752, name: "Mongala", code: "MO" },
          { id: 2749, name: "Nord-Kivu", code: "NK" },
          { id: 2739, name: "Nord-Ubangi", code: "NU" },
          { id: 2743, name: "Sankuru", code: "SA" },
          { id: 2738, name: "Sud-Kivu", code: "SK" },
          { id: 2748, name: "Sud-Ubangi", code: "SU" },
          { id: 2733, name: "Tanganyika", code: "TA" },
          { id: 2756, name: "Tshopo", code: "TO" },
          { id: 2732, name: "Tshuapa", code: "TU" }
        ]
      },
      {
        code: "DNK",
        name: "Denmark",
        states: [
          { id: 1530, name: "Capital Region of Denmark", code: "84" },
          { id: 1531, name: "Central Denmark Region", code: "82" },
          { id: 1532, name: "North Denmark Region", code: "81" },
          { id: 1529, name: "Region of Southern Denmark", code: "83" },
          { id: 1528, name: "Region Zealand", code: "85" }
        ]
      },
      {
        code: "DJI",
        name: "Djibouti",
        states: [
          { id: 2933, name: "Ali Sabieh Region", code: "AS" },
          { id: 2932, name: "Arta Region", code: "AR" },
          { id: 2930, name: "Dikhil Region", code: "DI" },
          { id: 2929, name: "Djibouti", code: "DJ" },
          { id: 2928, name: "Obock Region", code: "OB" },
          { id: 2931, name: "Tadjourah Region", code: "TA" }
        ]
      },
      {
        code: "DMA",
        name: "Dominica",
        states: [
          { id: 4082, name: "Saint Andrew Parish", code: "02" },
          { id: 4078, name: "Saint David Parish", code: "03" },
          { id: 4079, name: "Saint George Parish", code: "04" },
          { id: 4076, name: "Saint John Parish", code: "05" },
          { id: 4085, name: "Saint Joseph Parish", code: "06" },
          { id: 4083, name: "Saint Luke Parish", code: "07" },
          { id: 4077, name: "Saint Mark Parish", code: "08" },
          { id: 4080, name: "Saint Patrick Parish", code: "09" },
          { id: 4084, name: "Saint Paul Parish", code: "10" },
          { id: 4081, name: "Saint Peter Parish", code: "11" }
        ]
      },
      {
        code: "DOM",
        name: "Dominican Republic",
        states: [
          { id: 4114, name: "Azua Province", code: "02" },
          { id: 4105, name: "Baoruco Province", code: "03" },
          { id: 4090, name: "Barahona Province", code: "04" },
          { id: 4107, name: "Dajab\xF3n Province", code: "05" },
          { id: 4095, name: "Distrito Nacional", code: "01" },
          { id: 4113, name: "Duarte Province", code: "06" },
          { id: 4086, name: "El Seibo Province", code: "08" },
          { id: 4102, name: "Espaillat Province", code: "09" },
          { id: 4106, name: "Hato Mayor Province", code: "30" },
          { id: 4089, name: "Hermanas Mirabal Province", code: "19" },
          { id: 4097, name: "Independencia", code: "10" },
          { id: 4109, name: "La Altagracia Province", code: "11" },
          { id: 4087, name: "La Romana Province", code: "12" },
          { id: 4116, name: "La Vega Province", code: "13" },
          { id: 4094, name: "Mar\xEDa Trinidad S\xE1nchez Province", code: "14" },
          { id: 4099, name: "Monse\xF1or Nouel Province", code: "28" },
          { id: 4115, name: "Monte Cristi Province", code: "15" },
          { id: 4111, name: "Monte Plata Province", code: "29" },
          { id: 4101, name: "Pedernales Province", code: "16" },
          { id: 4096, name: "Peravia Province", code: "17" },
          { id: 4092, name: "Puerto Plata Province", code: "18" },
          { id: 4103, name: "Saman\xE1 Province", code: "20" },
          { id: 4091, name: "San Crist\xF3bal Province", code: "21" },
          { id: 4112, name: "San Jos\xE9 de Ocoa Province", code: "31" },
          { id: 4098, name: "San Juan Province", code: "22" },
          { id: 4110, name: "San Pedro de Macor\xEDs", code: "23" },
          { id: 4088, name: "S\xE1nchez Ram\xEDrez Province", code: "24" },
          { id: 4108, name: "Santiago Province", code: "25" },
          { id: 4100, name: "Santiago Rodr\xEDguez Province", code: "26" },
          { id: 4093, name: "Santo Domingo Province", code: "32" },
          { id: 4104, name: "Valverde Province", code: "27" }
        ]
      },
      {
        code: "TLS",
        name: "East Timor",
        states: [
          { id: 4520, name: "Aileu municipality", code: "AL" },
          { id: 4518, name: "Ainaro Municipality", code: "AN" },
          { id: 4521, name: "Baucau Municipality", code: "BA" },
          { id: 4525, name: "Bobonaro Municipality", code: "BO" },
          { id: 4522, name: "Cova Lima Municipality", code: "CO" },
          { id: 4524, name: "Dili municipality", code: "DI" },
          { id: 4516, name: "Ermera District", code: "ER" },
          { id: 4523, name: "Laut\xE9m Municipality", code: "LA" },
          { id: 4515, name: "Liqui\xE7\xE1 Municipality", code: "LI" },
          { id: 4517, name: "Manatuto District", code: "MT" },
          { id: 4519, name: "Manufahi Municipality", code: "MF" },
          { id: 4514, name: "Viqueque Municipality", code: "VI" }
        ]
      },
      {
        code: "ECU",
        name: "Ecuador",
        states: [
          { id: 2923, name: "Azuay", code: "A" },
          { id: 2920, name: "Bol\xEDvar", code: "B" },
          { id: 2917, name: "Ca\xF1ar", code: "F" },
          { id: 2915, name: "Carchi", code: "C" },
          { id: 2925, name: "Chimborazo", code: "H" },
          { id: 2921, name: "Cotopaxi", code: "X" },
          { id: 2924, name: "El Oro", code: "O" },
          { id: 2922, name: "Esmeraldas", code: "E" },
          { id: 2905, name: "Gal\xE1pagos", code: "W" },
          { id: 2914, name: "Guayas", code: "G" },
          { id: 2911, name: "Imbabura", code: "I" },
          { id: 5068, name: "Loja", code: "L" },
          { id: 2910, name: "Los R\xEDos", code: "R" },
          { id: 2913, name: "Manab\xED", code: "M" },
          { id: 2918, name: "Morona-Santiago", code: "S" },
          { id: 2916, name: "Napo", code: "N" },
          { id: 2926, name: "Orellana", code: "D" },
          { id: 2907, name: "Pastaza", code: "Y" },
          { id: 2927, name: "Pichincha", code: "P" },
          { id: 2912, name: "Santa Elena", code: "SE" },
          { id: 2919, name: "Santo Domingo de los Ts\xE1chilas", code: "SD" },
          { id: 2906, name: "Sucumb\xEDos", code: "U" },
          { id: 2908, name: "Tungurahua", code: "T" },
          { id: 2909, name: "Zamora Chinchipe", code: "Z" }
        ]
      },
      {
        code: "EGY",
        name: "Egypt",
        states: [
          { id: 3235, name: "Alexandria", code: "ALX" },
          { id: 3225, name: "Aswan", code: "ASN" },
          { id: 3236, name: "Asyut", code: "AST" },
          { id: 3241, name: "Beheira", code: "BH" },
          { id: 3230, name: "Beni Suef", code: "BNS" },
          { id: 3223, name: "Cairo", code: "C" },
          { id: 3245, name: "Dakahlia", code: "DK" },
          { id: 3224, name: "Damietta", code: "DT" },
          { id: 3238, name: "Faiyum", code: "FYM" },
          { id: 3234, name: "Gharbia", code: "GH" },
          { id: 3239, name: "Giza", code: "GZ" },
          { id: 3244, name: "Ismailia", code: "IS" },
          { id: 3222, name: "Kafr el-Sheikh", code: "KFS" },
          { id: 3242, name: "Luxor", code: "LX" },
          { id: 3231, name: "Matrouh", code: "MT" },
          { id: 3243, name: "Minya", code: "MN" },
          { id: 3228, name: "Monufia", code: "MNF" },
          { id: 3246, name: "New Valley", code: "WAD" },
          { id: 3227, name: "North Sinai", code: "SIN" },
          { id: 3229, name: "Port Said", code: "PTS" },
          { id: 3232, name: "Qalyubia", code: "KB" },
          { id: 3247, name: "Qena", code: "KN" },
          { id: 3240, name: "Red Sea", code: "BA" },
          { id: 5067, name: "Sharqia", code: "SHR" },
          { id: 3226, name: "Sohag", code: "SHG" },
          { id: 3237, name: "South Sinai", code: "JS" },
          { id: 3233, name: "Suez", code: "SUZ" }
        ]
      },
      {
        code: "SLV",
        name: "El Salvador",
        states: [
          { id: 4139, name: "Ahuachap\xE1n Department", code: "AH" },
          { id: 4132, name: "Caba\xF1as Department", code: "CA" },
          { id: 4131, name: "Chalatenango Department", code: "CH" },
          { id: 4137, name: "Cuscatl\xE1n Department", code: "CU" },
          { id: 4134, name: "La Libertad Department", code: "LI" },
          { id: 4136, name: "La Paz Department", code: "PA" },
          { id: 4138, name: "La Uni\xF3n Department", code: "UN" },
          { id: 4130, name: "Moraz\xE1n Department", code: "MO" },
          { id: 4135, name: "San Miguel Department", code: "SM" },
          { id: 4133, name: "San Salvador Department", code: "SS" },
          { id: 4127, name: "San Vicente Department", code: "SV" },
          { id: 4128, name: "Santa Ana Department", code: "SA" },
          { id: 4140, name: "Sonsonate Department", code: "SO" },
          { id: 4129, name: "Usulut\xE1n Department", code: "US" }
        ]
      },
      {
        code: "GNQ",
        name: "Equatorial Guinea",
        states: [
          { id: 3444, name: "Annob\xF3n Province", code: "AN" },
          { id: 3446, name: "Bioko Norte Province", code: "BN" },
          { id: 3443, name: "Bioko Sur Province", code: "BS" },
          { id: 3445, name: "Centro Sur Province", code: "CS" },
          { id: 3442, name: "Insular Region", code: "I" },
          { id: 3439, name: "Ki\xE9-Ntem Province", code: "KN" },
          { id: 3441, name: "Litoral Province", code: "LI" },
          { id: 3438, name: "R\xEDo Muni", code: "C" },
          { id: 3440, name: "Wele-Nzas Province", code: "WN" }
        ]
      },
      {
        code: "ERI",
        name: "Eritrea",
        states: [
          { id: 3425, name: "Anseba Region", code: "AN" },
          { id: 3427, name: "Debub Region", code: "DU" },
          { id: 3428, name: "Gash-Barka Region", code: "GB" },
          { id: 3426, name: "Maekel Region", code: "MA" },
          { id: 3424, name: "Northern Red Sea Region", code: "SK" },
          { id: 3429, name: "Southern Red Sea Region", code: "DK" }
        ]
      },
      {
        code: "EST",
        name: "Estonia",
        states: [
          { id: 3567, name: "Harju County", code: "37" },
          { id: 3555, name: "Hiiu County", code: "39" },
          { id: 3569, name: "Ida-Viru County", code: "44" },
          { id: 3566, name: "J\xE4rva County", code: "51" },
          { id: 3565, name: "J\xF5geva County", code: "49" },
          { id: 3568, name: "L\xE4\xE4ne County", code: "57" },
          { id: 3564, name: "L\xE4\xE4ne-Viru County", code: "59" },
          { id: 3562, name: "P\xE4rnu County", code: "67" },
          { id: 3563, name: "P\xF5lva County", code: "65" },
          { id: 3559, name: "Rapla County", code: "70" },
          { id: 3561, name: "Saare County", code: "74" },
          { id: 3557, name: "Tartu County", code: "78" },
          { id: 3558, name: "Valga County", code: "82" },
          { id: 3556, name: "Viljandi County", code: "84" },
          { id: 3560, name: "V\xF5ru County", code: "86" }
        ]
      },
      {
        code: "ETH",
        name: "Ethiopia",
        states: [
          { id: 11, name: "Addis Ababa", code: "AA" },
          { id: 6, name: "Afar Region", code: "AF" },
          { id: 3, name: "Amhara Region", code: "AM" },
          { id: 9, name: "Benishangul-Gumuz Region", code: "BE" },
          { id: 8, name: "Dire Dawa", code: "DD" },
          { id: 10, name: "Gambela Region", code: "GA" },
          { id: 7, name: "Harari Region", code: "HA" },
          { id: 5, name: "Oromia Region", code: "OR" },
          { id: 2, name: "Somali Region", code: "SO" },
          {
            id: 1,
            name: "Southern Nations, Nationalities, and Peoples' Region",
            code: "SN"
          },
          { id: 4, name: "Tigray Region", code: "TI" }
        ]
      },
      { code: "FLK", name: "Falkland Islands", states: [] },
      { code: "FRO", name: "Faroe Islands", states: [] },
      {
        code: "FJI",
        name: "Fiji Islands",
        states: [
          { id: 1917, name: "Ba", code: "01" },
          { id: 1930, name: "Bua", code: "02" },
          { id: 1924, name: "Cakaudrove", code: "03" },
          { id: 1929, name: "Central Division", code: "C" },
          { id: 1932, name: "Eastern Division", code: "E" },
          { id: 1934, name: "Kadavu", code: "04" },
          { id: 1933, name: "Lau", code: "05" },
          { id: 1916, name: "Lomaiviti", code: "06" },
          { id: 1922, name: "Macuata", code: "07" },
          { id: 1919, name: "Nadroga-Navosa", code: "08" },
          { id: 1927, name: "Naitasiri", code: "09" },
          { id: 1928, name: "Namosi", code: "10" },
          { id: 1921, name: "Northern Division", code: "N" },
          { id: 1926, name: "Ra", code: "11" },
          { id: 1920, name: "Rewa", code: "12" },
          { id: 1931, name: "Rotuma", code: "R" },
          { id: 1925, name: "Serua", code: "13" },
          { id: 1918, name: "Tailevu", code: "14" },
          { id: 1923, name: "Western Division", code: "W" }
        ]
      },
      {
        code: "FIN",
        name: "Finland",
        states: [
          { id: 1509, name: "\xC5land Islands", code: "01" },
          { id: 1511, name: "Central Finland", code: "08" },
          { id: 1494, name: "Central Ostrobothnia", code: "07" },
          { id: 1507, name: "Finland Proper", code: "19" },
          { id: 1496, name: "Kainuu", code: "05" },
          { id: 1512, name: "Kymenlaakso", code: "09" },
          { id: 1500, name: "Lapland", code: "10" },
          { id: 1504, name: "North Karelia", code: "13" },
          { id: 1505, name: "Northern Ostrobothnia", code: "14" },
          { id: 1503, name: "Northern Savonia", code: "15" },
          { id: 1508, name: "Ostrobothnia", code: "12" },
          { id: 1502, name: "P\xE4ij\xE4nne Tavastia", code: "16" },
          { id: 1506, name: "Pirkanmaa", code: "11" },
          { id: 1501, name: "Satakunta", code: "17" },
          { id: 1497, name: "South Karelia", code: "02" },
          { id: 1498, name: "Southern Ostrobothnia", code: "03" },
          { id: 1495, name: "Southern Savonia", code: "04" },
          { id: 1493, name: "Tavastia Proper", code: "06" },
          { id: 1510, name: "Uusimaa", code: "18" }
        ]
      },
      {
        code: "FRA",
        name: "France",
        states: [
          { id: 4967, name: "Ain", code: "01" },
          { id: 4968, name: "Aisne", code: "02" },
          { id: 4969, name: "Allier", code: "03" },
          { id: 4970, name: "Alpes-de-Haute-Provence", code: "04" },
          { id: 4972, name: "Alpes-Maritimes", code: "06" },
          { id: 4811, name: "Alsace", code: "6AE" },
          { id: 4973, name: "Ard\xE8che", code: "07" },
          { id: 4974, name: "Ardennes", code: "08" },
          { id: 4975, name: "Ari\xE8ge", code: "09" },
          { id: 4976, name: "Aube", code: "10" },
          { id: 4977, name: "Aude", code: "11" },
          { id: 4798, name: "Auvergne-Rh\xF4ne-Alpes", code: "ARA" },
          { id: 4978, name: "Aveyron", code: "12" },
          { id: 5035, name: "Bas-Rhin", code: "67" },
          { id: 4979, name: "Bouches-du-Rh\xF4ne", code: "13" },
          { id: 4825, name: "Bourgogne-Franche-Comt\xE9", code: "BFC" },
          { id: 4807, name: "Bretagne", code: "BRE" },
          { id: 4981, name: "Calvados", code: "14" },
          { id: 4982, name: "Cantal", code: "15" },
          { id: 4818, name: "Centre-Val de Loire", code: "CVL" },
          { id: 4983, name: "Charente", code: "16" },
          { id: 4984, name: "Charente-Maritime", code: "17" },
          { id: 4985, name: "Cher", code: "18" },
          { id: 5064, name: "Clipperton", code: "CP" },
          { id: 4986, name: "Corr\xE8ze", code: "19" },
          { id: 4806, name: "Corse", code: "20R" },
          { id: 4996, name: "Corse-du-Sud", code: "2A" },
          { id: 4987, name: "C\xF4te-d'Or", code: "21" },
          { id: 4988, name: "C\xF4tes-d'Armor", code: "22" },
          { id: 4989, name: "Creuse", code: "23" },
          { id: 5047, name: "Deux-S\xE8vres", code: "79" },
          { id: 4990, name: "Dordogne", code: "24" },
          { id: 4991, name: "Doubs", code: "25" },
          { id: 4992, name: "Dr\xF4me", code: "26" },
          { id: 5059, name: "Essonne", code: "91" },
          { id: 4993, name: "Eure", code: "27" },
          { id: 4994, name: "Eure-et-Loir", code: "28" },
          { id: 4995, name: "Finist\xE8re", code: "29" },
          { id: 4822, name: "French Guiana", code: "973" },
          { id: 4824, name: "French Polynesia", code: "PF" },
          {
            id: 5065,
            name: "French Southern and Antarctic Lands",
            code: "TF"
          },
          { id: 4998, name: "Gard", code: "30" },
          { id: 5e3, name: "Gers", code: "32" },
          { id: 5001, name: "Gironde", code: "33" },
          { id: 4820, name: "Grand-Est", code: "GES" },
          { id: 4829, name: "Guadeloupe", code: "971" },
          { id: 5036, name: "Haut-Rhin", code: "68" },
          { id: 4997, name: "Haute-Corse", code: "2B" },
          { id: 4999, name: "Haute-Garonne", code: "31" },
          { id: 5011, name: "Haute-Loire", code: "43" },
          { id: 5020, name: "Haute-Marne", code: "52" },
          { id: 5039, name: "Haute-Sa\xF4ne", code: "70" },
          { id: 5043, name: "Haute-Savoie", code: "74" },
          { id: 5055, name: "Haute-Vienne", code: "87" },
          { id: 4971, name: "Hautes-Alpes", code: "05" },
          { id: 5033, name: "Hautes-Pyr\xE9n\xE9es", code: "65" },
          { id: 4828, name: "Hauts-de-France", code: "HDF" },
          { id: 5060, name: "Hauts-de-Seine", code: "92" },
          { id: 5002, name: "H\xE9rault", code: "34" },
          { id: 4796, name: "\xCEle-de-France", code: "IDF" },
          { id: 5003, name: "Ille-et-Vilaine", code: "35" },
          { id: 5004, name: "Indre", code: "36" },
          { id: 5005, name: "Indre-et-Loire", code: "37" },
          { id: 5006, name: "Is\xE8re", code: "38" },
          { id: 5007, name: "Jura", code: "39" },
          { id: 4823, name: "La R\xE9union", code: "974" },
          { id: 5008, name: "Landes", code: "40" },
          { id: 5009, name: "Loir-et-Cher", code: "41" },
          { id: 5010, name: "Loire", code: "42" },
          { id: 5012, name: "Loire-Atlantique", code: "44" },
          { id: 5013, name: "Loiret", code: "45" },
          { id: 5014, name: "Lot", code: "46" },
          { id: 5015, name: "Lot-et-Garonne", code: "47" },
          { id: 5016, name: "Loz\xE8re", code: "48" },
          { id: 5017, name: "Maine-et-Loire", code: "49" },
          { id: 5018, name: "Manche", code: "50" },
          { id: 5019, name: "Marne", code: "51" },
          { id: 4827, name: "Martinique", code: "972" },
          { id: 5021, name: "Mayenne", code: "53" },
          { id: 4797, name: "Mayotte", code: "976" },
          { id: 5038, name: "M\xE9tropole de Lyon", code: "69M" },
          { id: 5022, name: "Meurthe-et-Moselle", code: "54" },
          { id: 5023, name: "Meuse", code: "55" },
          { id: 5024, name: "Morbihan", code: "56" },
          { id: 5025, name: "Moselle", code: "57" },
          { id: 5026, name: "Ni\xE8vre", code: "58" },
          { id: 5027, name: "Nord", code: "59" },
          { id: 4804, name: "Normandie", code: "NOR" },
          { id: 4795, name: "Nouvelle-Aquitaine", code: "NAQ" },
          { id: 4799, name: "Occitanie", code: "OCC" },
          { id: 5028, name: "Oise", code: "60" },
          { id: 5029, name: "Orne", code: "61" },
          { id: 4816, name: "Paris", code: "75C" },
          { id: 5030, name: "Pas-de-Calais", code: "62" },
          { id: 4802, name: "Pays-de-la-Loire", code: "PDL" },
          { id: 4812, name: "Provence-Alpes-C\xF4te-d\u2019Azur", code: "PAC" },
          { id: 5031, name: "Puy-de-D\xF4me", code: "63" },
          { id: 5032, name: "Pyr\xE9n\xE9es-Atlantiques", code: "64" },
          { id: 5034, name: "Pyr\xE9n\xE9es-Orientales", code: "66" },
          { id: 5037, name: "Rh\xF4ne", code: "69" },
          { id: 4821, name: "Saint Pierre and Miquelon", code: "PM" },
          { id: 4794, name: "Saint-Barth\xE9lemy", code: "BL" },
          { id: 4809, name: "Saint-Martin", code: "MF" },
          { id: 5040, name: "Sa\xF4ne-et-Loire", code: "71" },
          { id: 5041, name: "Sarthe", code: "72" },
          { id: 5042, name: "Savoie", code: "73" },
          { id: 5045, name: "Seine-et-Marne", code: "77" },
          { id: 5044, name: "Seine-Maritime", code: "76" },
          { id: 5061, name: "Seine-Saint-Denis", code: "93" },
          { id: 5048, name: "Somme", code: "80" },
          { id: 5049, name: "Tarn", code: "81" },
          { id: 5050, name: "Tarn-et-Garonne", code: "82" },
          { id: 5058, name: "Territoire de Belfort", code: "90" },
          { id: 5063, name: "Val-d'Oise", code: "95" },
          { id: 5062, name: "Val-de-Marne", code: "94" },
          { id: 5051, name: "Var", code: "83" },
          { id: 5052, name: "Vaucluse", code: "84" },
          { id: 5053, name: "Vend\xE9e", code: "85" },
          { id: 5054, name: "Vienne", code: "86" },
          { id: 5056, name: "Vosges", code: "88" },
          { id: 4810, name: "Wallis and Futuna", code: "WF" },
          { id: 5057, name: "Yonne", code: "89" },
          { id: 5046, name: "Yvelines", code: "78" }
        ]
      },
      { code: "GUF", name: "French Guiana", states: [] },
      { code: "PYF", name: "French Polynesia", states: [] },
      { code: "ATF", name: "French Southern Territories", states: [] },
      {
        code: "GAB",
        name: "Gabon",
        states: [
          { id: 2727, name: "Estuaire Province", code: "1" },
          { id: 2726, name: "Haut-Ogoou\xE9 Province", code: "2" },
          { id: 2730, name: "Moyen-Ogoou\xE9 Province", code: "3" },
          { id: 2731, name: "Ngouni\xE9 Province", code: "4" },
          { id: 2725, name: "Nyanga Province", code: "5" },
          { id: 2724, name: "Ogoou\xE9-Ivindo Province", code: "6" },
          { id: 2729, name: "Ogoou\xE9-Lolo Province", code: "7" },
          { id: 2728, name: "Ogoou\xE9-Maritime Province", code: "8" },
          { id: 2723, name: "Woleu-Ntem Province", code: "9" }
        ]
      },
      {
        code: "GMB",
        name: "Gambia The",
        states: [
          { id: 2666, name: "Banjul", code: "B" },
          { id: 2669, name: "Central River Division", code: "M" },
          { id: 2670, name: "Lower River Division", code: "L" },
          { id: 2671, name: "North Bank Division", code: "N" },
          { id: 2668, name: "Upper River Division", code: "U" },
          { id: 2667, name: "West Coast Division", code: "W" }
        ]
      },
      {
        code: "GEO",
        name: "Georgia",
        states: [
          { id: 900, name: "Adjara", code: "AJ" },
          { id: 901, name: "Autonomous Republic of Abkhazia", code: "AB" },
          { id: 907, name: "Guria", code: "GU" },
          { id: 905, name: "Imereti", code: "IM" },
          { id: 910, name: "Kakheti", code: "KA" },
          { id: 897, name: "Khelvachauri Municipality", code: "29" },
          { id: 904, name: "Kvemo Kartli", code: "KK" },
          { id: 902, name: "Mtskheta-Mtianeti", code: "MM" },
          { id: 909, name: "Racha-Lechkhumi and Kvemo Svaneti", code: "RL" },
          { id: 908, name: "Samegrelo-Zemo Svaneti", code: "SZ" },
          { id: 906, name: "Samtskhe-Javakheti", code: "SJ" },
          { id: 898, name: "Senaki Municipality", code: "50" },
          { id: 903, name: "Shida Kartli", code: "SK" },
          { id: 899, name: "Tbilisi", code: "TB" }
        ]
      },
      {
        code: "DEU",
        name: "Germany",
        states: [
          { id: 3006, name: "Baden-W\xFCrttemberg", code: "BW" },
          { id: 3009, name: "Bavaria", code: "BY" },
          { id: 3010, name: "Berlin", code: "BE" },
          { id: 3013, name: "Brandenburg", code: "BB" },
          { id: 3014, name: "Bremen", code: "HB" },
          { id: 3016, name: "Hamburg", code: "HH" },
          { id: 3018, name: "Hesse", code: "HE" },
          { id: 3008, name: "Lower Saxony", code: "NI" },
          { id: 3007, name: "Mecklenburg-Vorpommern", code: "MV" },
          { id: 3017, name: "North Rhine-Westphalia", code: "NW" },
          { id: 3019, name: "Rhineland-Palatinate", code: "RP" },
          { id: 3020, name: "Saarland", code: "SL" },
          { id: 3021, name: "Saxony", code: "SN" },
          { id: 3011, name: "Saxony-Anhalt", code: "ST" },
          { id: 3005, name: "Schleswig-Holstein", code: "SH" },
          { id: 3015, name: "Thuringia", code: "TH" }
        ]
      },
      {
        code: "GHA",
        name: "Ghana",
        states: [
          { id: 53, name: "Ahafo", code: "AF" },
          { id: 48, name: "Ashanti", code: "AH" },
          { id: 4959, name: "Bono", code: "BO" },
          { id: 4958, name: "Bono East", code: "BE" },
          { id: 52, name: "Central", code: "CP" },
          { id: 50, name: "Eastern", code: "EP" },
          { id: 54, name: "Greater Accra", code: "AA" },
          { id: 4960, name: "North East", code: "NE" },
          { id: 51, name: "Northern", code: "NP" },
          { id: 4961, name: "Oti", code: "OT" },
          { id: 4962, name: "Savannah", code: "SV" },
          { id: 55, name: "Upper East", code: "UE" },
          { id: 57, name: "Upper West", code: "UW" },
          { id: 56, name: "Volta", code: "TV" },
          { id: 49, name: "Western", code: "WP" },
          { id: 4963, name: "Western North", code: "WN" }
        ]
      },
      { code: "GIB", name: "Gibraltar", states: [] },
      {
        code: "GRC",
        name: "Greece",
        states: [
          { id: 2116, name: "Achaea Regional Unit", code: "13" },
          { id: 2123, name: "Aetolia-Acarnania Regional Unit", code: "01" },
          { id: 2098, name: "Arcadia Prefecture", code: "12" },
          { id: 2105, name: "Argolis Regional Unit", code: "11" },
          { id: 2122, name: "Attica Region", code: "I" },
          { id: 2126, name: "Boeotia Regional Unit", code: "03" },
          { id: 2128, name: "Central Greece Region", code: "H" },
          { id: 2125, name: "Central Macedonia", code: "B" },
          { id: 2115, name: "Chania Regional Unit", code: "94" },
          { id: 2124, name: "Corfu Prefecture", code: "22" },
          { id: 2129, name: "Corinthia Regional Unit", code: "15" },
          { id: 2109, name: "Crete Region", code: "M" },
          { id: 2130, name: "Drama Regional Unit", code: "52" },
          { id: 2120, name: "East Attica Regional Unit", code: "A2" },
          { id: 2117, name: "East Macedonia and Thrace", code: "A" },
          { id: 2110, name: "Epirus Region", code: "D" },
          { id: 2101, name: "Euboea", code: "04" },
          { id: 2102, name: "Grevena Prefecture", code: "51" },
          { id: 2099, name: "Imathia Regional Unit", code: "53" },
          { id: 2113, name: "Ioannina Regional Unit", code: "33" },
          { id: 2131, name: "Ionian Islands Region", code: "F" },
          { id: 2095, name: "Karditsa Regional Unit", code: "41" },
          { id: 2100, name: "Kastoria Regional Unit", code: "56" },
          { id: 2127, name: "Kefalonia Prefecture", code: "23" },
          { id: 2111, name: "Kilkis Regional Unit", code: "57" },
          { id: 2112, name: "Kozani Prefecture", code: "58" },
          { id: 2106, name: "Laconia", code: "16" },
          { id: 2132, name: "Larissa Prefecture", code: "42" },
          { id: 2104, name: "Lefkada Regional Unit", code: "24" },
          { id: 2107, name: "Pella Regional Unit", code: "59" },
          { id: 2119, name: "Peloponnese Region", code: "J" },
          { id: 2114, name: "Phthiotis Prefecture", code: "06" },
          { id: 2103, name: "Preveza Prefecture", code: "34" },
          { id: 2121, name: "Serres Prefecture", code: "62" },
          { id: 2118, name: "South Aegean", code: "L" },
          { id: 2097, name: "Thessaloniki Regional Unit", code: "54" },
          { id: 2096, name: "West Greece Region", code: "G" },
          { id: 2108, name: "West Macedonia Region", code: "C" }
        ]
      },
      { code: "GRL", name: "Greenland", states: [] },
      {
        code: "GRD",
        name: "Grenada",
        states: [
          { id: 3867, name: "Carriacou and Petite Martinique", code: "10" },
          { id: 3865, name: "Saint Andrew Parish", code: "01" },
          { id: 3869, name: "Saint David Parish", code: "02" },
          { id: 3864, name: "Saint George Parish", code: "03" },
          { id: 3868, name: "Saint John Parish", code: "04" },
          { id: 3866, name: "Saint Mark Parish", code: "05" },
          { id: 3863, name: "Saint Patrick Parish", code: "06" }
        ]
      },
      { code: "GLP", name: "Guadeloupe", states: [] },
      { code: "GUM", name: "Guam", states: [] },
      {
        code: "GTM",
        name: "Guatemala",
        states: [
          { id: 3671, name: "Alta Verapaz Department", code: "AV" },
          { id: 3674, name: "Baja Verapaz Department", code: "BV" },
          { id: 3675, name: "Chimaltenango Department", code: "CM" },
          { id: 3666, name: "Chiquimula Department", code: "CQ" },
          { id: 3662, name: "El Progreso Department", code: "PR" },
          { id: 3677, name: "Escuintla Department", code: "ES" },
          { id: 3672, name: "Guatemala Department", code: "GU" },
          { id: 3670, name: "Huehuetenango Department", code: "HU" },
          { id: 3659, name: "Izabal Department", code: "IZ" },
          { id: 3658, name: "Jalapa Department", code: "JA" },
          { id: 3673, name: "Jutiapa Department", code: "JU" },
          { id: 3669, name: "Pet\xE9n Department", code: "PE" },
          { id: 3668, name: "Quetzaltenango Department", code: "QZ" },
          { id: 3657, name: "Quich\xE9 Department", code: "QC" },
          { id: 3664, name: "Retalhuleu Department", code: "RE" },
          { id: 3676, name: "Sacatep\xE9quez Department", code: "SA" },
          { id: 3667, name: "San Marcos Department", code: "SM" },
          { id: 3665, name: "Santa Rosa Department", code: "SR" },
          { id: 3661, name: "Solol\xE1 Department", code: "SO" },
          { id: 3660, name: "Suchitep\xE9quez Department", code: "SU" },
          { id: 3663, name: "Totonicap\xE1n Department", code: "TO" }
        ]
      },
      { code: "GGY", name: "Guernsey and Alderney", states: [] },
      {
        code: "GIN",
        name: "Guinea",
        states: [
          { id: 2672, name: "Beyla Prefecture", code: "BE" },
          { id: 2699, name: "Boffa Prefecture", code: "BF" },
          { id: 2709, name: "Bok\xE9 Prefecture", code: "BK" },
          { id: 2676, name: "Bok\xE9 Region", code: "B" },
          { id: 2686, name: "Conakry", code: "C" },
          { id: 2705, name: "Coyah Prefecture", code: "CO" },
          { id: 2679, name: "Dabola Prefecture", code: "DB" },
          { id: 2706, name: "Dalaba Prefecture", code: "DL" },
          { id: 2688, name: "Dinguiraye Prefecture", code: "DI" },
          { id: 2681, name: "Dubr\xE9ka Prefecture", code: "DU" },
          { id: 2682, name: "Faranah Prefecture", code: "FA" },
          { id: 2683, name: "For\xE9cariah Prefecture", code: "FO" },
          { id: 2675, name: "Fria Prefecture", code: "FR" },
          { id: 2685, name: "Gaoual Prefecture", code: "GA" },
          { id: 2711, name: "Gu\xE9ck\xE9dou Prefecture", code: "GU" },
          { id: 2704, name: "Kankan Prefecture", code: "KA" },
          { id: 2697, name: "Kankan Region", code: "K" },
          { id: 2710, name: "K\xE9rouan\xE9 Prefecture", code: "KE" },
          { id: 2693, name: "Kindia Prefecture", code: "KD" },
          { id: 2701, name: "Kindia Region", code: "D" },
          { id: 2691, name: "Kissidougou Prefecture", code: "KS" },
          { id: 2692, name: "Koubia Prefecture", code: "KB" },
          { id: 2703, name: "Koundara Prefecture", code: "KN" },
          { id: 2695, name: "Kouroussa Prefecture", code: "KO" },
          { id: 2680, name: "Lab\xE9 Prefecture", code: "LA" },
          { id: 2677, name: "Lab\xE9 Region", code: "L" },
          { id: 2690, name: "L\xE9louma Prefecture", code: "LE" },
          { id: 2708, name: "Lola Prefecture", code: "LO" },
          { id: 2702, name: "Macenta Prefecture", code: "MC" },
          { id: 2700, name: "Mali Prefecture", code: "ML" },
          { id: 2689, name: "Mamou Prefecture", code: "MM" },
          { id: 2698, name: "Mamou Region", code: "M" },
          { id: 2673, name: "Mandiana Prefecture", code: "MD" },
          { id: 2678, name: "Nz\xE9r\xE9kor\xE9 Prefecture", code: "NZ" },
          { id: 2684, name: "Nz\xE9r\xE9kor\xE9 Region", code: "N" },
          { id: 2694, name: "Pita Prefecture", code: "PI" },
          { id: 2707, name: "Siguiri Prefecture", code: "SI" },
          { id: 2687, name: "T\xE9lim\xE9l\xE9 Prefecture", code: "TE" },
          { id: 2696, name: "Tougu\xE9 Prefecture", code: "TO" },
          { id: 2674, name: "Yomou Prefecture", code: "YO" }
        ]
      },
      {
        code: "GNB",
        name: "Guinea-Bissau",
        states: [
          { id: 2720, name: "Bafat\xE1", code: "BA" },
          { id: 2714, name: "Biombo Region", code: "BM" },
          { id: 2722, name: "Bolama Region", code: "BL" },
          { id: 2713, name: "Cacheu Region", code: "CA" },
          { id: 2719, name: "Gab\xFA Region", code: "GA" },
          { id: 2721, name: "Leste Province", code: "L" },
          { id: 2717, name: "Norte Province", code: "N" },
          { id: 2718, name: "Oio Region", code: "OI" },
          { id: 2715, name: "Quinara Region", code: "QU" },
          { id: 2716, name: "Sul Province", code: "S" },
          { id: 2712, name: "Tombali Region", code: "TO" }
        ]
      },
      {
        code: "GUY",
        name: "Guyana",
        states: [
          { id: 2764, name: "Barima-Waini", code: "BA" },
          { id: 2760, name: "Cuyuni-Mazaruni", code: "CU" },
          { id: 2767, name: "Demerara-Mahaica", code: "DE" },
          { id: 2766, name: "East Berbice-Corentyne", code: "EB" },
          { id: 2768, name: "Essequibo Islands-West Demerara", code: "ES" },
          { id: 2762, name: "Mahaica-Berbice", code: "MA" },
          { id: 2765, name: "Pomeroon-Supenaam", code: "PM" },
          { id: 2761, name: "Potaro-Siparuni", code: "PT" },
          { id: 2763, name: "Upper Demerara-Berbice", code: "UD" },
          { id: 2769, name: "Upper Takutu-Upper Essequibo", code: "UT" }
        ]
      },
      {
        code: "HTI",
        name: "Haiti",
        states: [
          { id: 4123, name: "Artibonite", code: "AR" },
          { id: 4125, name: "Centre", code: "CE" },
          { id: 4119, name: "Grand'Anse", code: "GA" },
          { id: 4118, name: "Nippes", code: "NI" },
          { id: 4117, name: "Nord", code: "ND" },
          { id: 4121, name: "Nord-Est", code: "NE" },
          { id: 4126, name: "Nord-Ouest", code: "NO" },
          { id: 4120, name: "Ouest", code: "OU" },
          { id: 4122, name: "Sud", code: "SD" },
          { id: 4124, name: "Sud-Est", code: "SE" }
        ]
      },
      { code: "HMD", name: "Heard Island and McDonald Islands", states: [] },
      {
        code: "HND",
        name: "Honduras",
        states: [
          { id: 4047, name: "Atl\xE1ntida Department", code: "AT" },
          { id: 4045, name: "Bay Islands Department", code: "IB" },
          { id: 4041, name: "Choluteca Department", code: "CH" },
          { id: 4051, name: "Col\xF3n Department", code: "CL" },
          { id: 4042, name: "Comayagua Department", code: "CM" },
          { id: 4049, name: "Cop\xE1n Department", code: "CP" },
          { id: 4046, name: "Cort\xE9s Department", code: "CR" },
          { id: 4043, name: "El Para\xEDso Department", code: "EP" },
          { id: 4052, name: "Francisco Moraz\xE1n Department", code: "FM" },
          { id: 4048, name: "Gracias a Dios Department", code: "GD" },
          { id: 4044, name: "Intibuc\xE1 Department", code: "IN" },
          { id: 4058, name: "La Paz Department", code: "LP" },
          { id: 4054, name: "Lempira Department", code: "LE" },
          { id: 4056, name: "Ocotepeque Department", code: "OC" },
          { id: 4050, name: "Olancho Department", code: "OL" },
          { id: 4053, name: "Santa B\xE1rbara Department", code: "SB" },
          { id: 4055, name: "Valle Department", code: "VA" },
          { id: 4057, name: "Yoro Department", code: "YO" }
        ]
      },
      {
        code: "HKG",
        name: "Hong Kong S.A.R.",
        states: [
          { id: 4889, name: "Central and Western", code: "HCW" },
          { id: 4891, name: "Eastern", code: "HEA" },
          { id: 4888, name: "Islands", code: "NIS" },
          { id: 4895, name: "Kowloon City", code: "KKC" },
          { id: 4898, name: "Kwai Tsing", code: "NKT" },
          { id: 4897, name: "Kwun Tong", code: "KKT" },
          { id: 4900, name: "North", code: "NNO" },
          { id: 4887, name: "Sai Kung", code: "NSK" },
          { id: 4901, name: "Sha Tin", code: "NST" },
          { id: 4894, name: "Sham Shui Po", code: "KSS" },
          { id: 4892, name: "Southern", code: "HSO" },
          { id: 4885, name: "Tai Po", code: "NTP" },
          { id: 4884, name: "Tsuen Wan", code: "NTW" },
          { id: 4899, name: "Tuen Mun", code: "NTM" },
          { id: 4890, name: "Wan Chai", code: "HWC" },
          { id: 4896, name: "Wong Tai Sin", code: "KWT" },
          { id: 4893, name: "Yau Tsim Mong", code: "KYT" },
          { id: 4883, name: "Yuen Long", code: "NYL" }
        ]
      },
      {
        code: "HUN",
        name: "Hungary",
        states: [
          { id: 1048, name: "B\xE1cs-Kiskun", code: "BK" },
          { id: 1055, name: "Baranya", code: "BA" },
          { id: 1060, name: "B\xE9k\xE9s", code: "BE" },
          { id: 1036, name: "B\xE9k\xE9scsaba", code: "BC" },
          { id: 1058, name: "Borsod-Aba\xFAj-Zempl\xE9n", code: "BZ" },
          { id: 1064, name: "Budapest", code: "BU" },
          { id: 1031, name: "Csongr\xE1d County", code: "CS" },
          { id: 1032, name: "Debrecen", code: "DE" },
          { id: 1049, name: "Duna\xFAjv\xE1ros", code: "DU" },
          { id: 1037, name: "Eger", code: "EG" },
          { id: 1028, name: "\xC9rd", code: "ER" },
          { id: 1044, name: "Fej\xE9r County", code: "FE" },
          { id: 1041, name: "Gy\u0151r", code: "GY" },
          { id: 1042, name: "Gy\u0151r-Moson-Sopron County", code: "GS" },
          { id: 1063, name: "Hajd\xFA-Bihar County", code: "HB" },
          { id: 1040, name: "Heves County", code: "HE" },
          { id: 1027, name: "H\xF3dmez\u0151v\xE1s\xE1rhely", code: "HV" },
          { id: 1043, name: "J\xE1sz-Nagykun-Szolnok County", code: "JN" },
          { id: 1067, name: "Kaposv\xE1r", code: "KV" },
          { id: 1056, name: "Kecskem\xE9t", code: "KM" },
          { id: 5085, name: "Kom\xE1rom-Esztergom", code: "KE" },
          { id: 1065, name: "Miskolc", code: "MI" },
          { id: 1030, name: "Nagykanizsa", code: "NK" },
          { id: 1051, name: "N\xF3gr\xE1d County", code: "NO" },
          { id: 1034, name: "Ny\xEDregyh\xE1za", code: "NY" },
          { id: 1053, name: "P\xE9cs", code: "PS" },
          { id: 1059, name: "Pest County", code: "PE" },
          { id: 1068, name: "Salg\xF3tarj\xE1n", code: "ST" },
          { id: 1035, name: "Somogy County", code: "SO" },
          { id: 1057, name: "Sopron", code: "SN" },
          { id: 1045, name: "Szabolcs-Szatm\xE1r-Bereg County", code: "SZ" },
          { id: 1029, name: "Szeged", code: "SD" },
          { id: 1033, name: "Sz\xE9kesfeh\xE9rv\xE1r", code: "SF" },
          { id: 1061, name: "Szeksz\xE1rd", code: "SS" },
          { id: 1047, name: "Szolnok", code: "SK" },
          { id: 1052, name: "Szombathely", code: "SH" },
          { id: 1066, name: "Tatab\xE1nya", code: "TB" },
          { id: 1038, name: "Tolna County", code: "TO" },
          { id: 1039, name: "Vas County", code: "VA" },
          { id: 1062, name: "Veszpr\xE9m", code: "VM" },
          { id: 1054, name: "Veszpr\xE9m County", code: "VE" },
          { id: 1046, name: "Zala County", code: "ZA" },
          { id: 1050, name: "Zalaegerszeg", code: "ZE" }
        ]
      },
      {
        code: "ISL",
        name: "Iceland",
        states: [
          { id: 3431, name: "Capital Region", code: "1" },
          { id: 3433, name: "Eastern Region", code: "7" },
          { id: 3437, name: "Northeastern Region", code: "6" },
          { id: 3435, name: "Northwestern Region", code: "5" },
          { id: 3430, name: "Southern Peninsula Region", code: "2" },
          { id: 3434, name: "Southern Region", code: "8" },
          { id: 3436, name: "Western Region", code: "3" },
          { id: 3432, name: "Westfjords", code: "4" }
        ]
      },
      {
        code: "IND",
        name: "India",
        states: [
          { id: 4023, name: "Andaman and Nicobar Islands", code: "AN" },
          { id: 4017, name: "Andhra Pradesh", code: "AP" },
          { id: 4024, name: "Arunachal Pradesh", code: "AR" },
          { id: 4027, name: "Assam", code: "AS" },
          { id: 4037, name: "Bihar", code: "BR" },
          { id: 4031, name: "Chandigarh", code: "CH" },
          { id: 4040, name: "Chhattisgarh", code: "CT" },
          {
            id: 4033,
            name: "Dadra and Nagar Haveli and Daman and Diu",
            code: "DH"
          },
          { id: 4021, name: "Delhi", code: "DL" },
          { id: 4009, name: "Goa", code: "GA" },
          { id: 4030, name: "Gujarat", code: "GJ" },
          { id: 4007, name: "Haryana", code: "HR" },
          { id: 4020, name: "Himachal Pradesh", code: "HP" },
          { id: 4029, name: "Jammu and Kashmir", code: "JK" },
          { id: 4025, name: "Jharkhand", code: "JH" },
          { id: 4026, name: "Karnataka", code: "KA" },
          { id: 4028, name: "Kerala", code: "KL" },
          { id: 4852, name: "Ladakh", code: "LA" },
          { id: 4019, name: "Lakshadweep", code: "LD" },
          { id: 4039, name: "Madhya Pradesh", code: "MP" },
          { id: 4008, name: "Maharashtra", code: "MH" },
          { id: 4010, name: "Manipur", code: "MN" },
          { id: 4006, name: "Meghalaya", code: "ML" },
          { id: 4036, name: "Mizoram", code: "MZ" },
          { id: 4018, name: "Nagaland", code: "NL" },
          { id: 4013, name: "Odisha", code: "OR" },
          { id: 4011, name: "Puducherry", code: "PY" },
          { id: 4015, name: "Punjab", code: "PB" },
          { id: 4014, name: "Rajasthan", code: "RJ" },
          { id: 4034, name: "Sikkim", code: "SK" },
          { id: 4035, name: "Tamil Nadu", code: "TN" },
          { id: 4012, name: "Telangana", code: "TG" },
          { id: 4038, name: "Tripura", code: "TR" },
          { id: 4022, name: "Uttar Pradesh", code: "UP" },
          { id: 4016, name: "Uttarakhand", code: "UT" },
          { id: 4853, name: "West Bengal", code: "WB" }
        ]
      },
      {
        code: "IDN",
        name: "Indonesia",
        states: [
          { id: 1822, name: "Aceh", code: "AC" },
          { id: 1826, name: "Bali", code: "BA" },
          { id: 1810, name: "Banten", code: "BT" },
          { id: 1793, name: "Bengkulu", code: "BE" },
          { id: 1829, name: "DI Yogyakarta", code: "YO" },
          { id: 1805, name: "DKI Jakarta", code: "JK" },
          { id: 1812, name: "Gorontalo", code: "GO" },
          { id: 1815, name: "Jambi", code: "JA" },
          { id: 1825, name: "Jawa Barat", code: "JB" },
          { id: 1802, name: "Jawa Tengah", code: "JT" },
          { id: 1827, name: "Jawa Timur", code: "JI" },
          { id: 1806, name: "Kalimantan Barat", code: "KB" },
          { id: 1819, name: "Kalimantan Selatan", code: "KS" },
          { id: 1794, name: "Kalimantan Tengah", code: "KT" },
          { id: 1804, name: "Kalimantan Timur", code: "KI" },
          { id: 1824, name: "Kalimantan Utara", code: "KU" },
          { id: 1820, name: "Kepulauan Bangka Belitung", code: "BB" },
          { id: 1807, name: "Kepulauan Riau", code: "KR" },
          { id: 1811, name: "Lampung", code: "LA" },
          { id: 1800, name: "Maluku", code: "MA" },
          { id: 1801, name: "Maluku Utara", code: "MU" },
          { id: 1814, name: "Nusa Tenggara Barat", code: "NB" },
          { id: 1818, name: "Nusa Tenggara Timur", code: "NT" },
          { id: 1798, name: "Papua", code: "PA" },
          { id: 1799, name: "Papua Barat", code: "PB" },
          { id: 1809, name: "Riau", code: "RI" },
          { id: 1817, name: "Sulawesi Barat", code: "SR" },
          { id: 1795, name: "Sulawesi Selatan", code: "SN" },
          { id: 1813, name: "Sulawesi Tengah", code: "ST" },
          { id: 1796, name: "Sulawesi Tenggara", code: "SG" },
          { id: 1808, name: "Sulawesi Utara", code: "SA" },
          { id: 1828, name: "Sumatera Barat", code: "SB" },
          { id: 1816, name: "Sumatera Selatan", code: "SS" },
          { id: 1792, name: "Sumatera Utara", code: "SU" }
        ]
      },
      {
        code: "IRN",
        name: "Iran",
        states: [
          { id: 3929, name: "Alborz", code: "30" },
          { id: 3934, name: "Ardabil", code: "24" },
          { id: 3932, name: "Bushehr", code: "18" },
          { id: 3921, name: "Chaharmahal and Bakhtiari", code: "14" },
          { id: 3944, name: "East Azerbaijan", code: "03" },
          { id: 3939, name: "Fars", code: "07" },
          { id: 3920, name: "Gilan", code: "01" },
          { id: 3933, name: "Golestan", code: "27" },
          { id: 4920, name: "Hamadan", code: "13" },
          { id: 3937, name: "Hormozgan", code: "22" },
          { id: 3918, name: "Ilam", code: "16" },
          { id: 3923, name: "Isfahan", code: "10" },
          { id: 3943, name: "Kerman", code: "08" },
          { id: 3919, name: "Kermanshah", code: "05" },
          { id: 3917, name: "Khuzestan", code: "06" },
          { id: 3926, name: "Kohgiluyeh and Boyer-Ahmad", code: "17" },
          { id: 3935, name: "Kurdistan", code: "12" },
          { id: 3928, name: "Lorestan", code: "15" },
          { id: 3916, name: "Markazi", code: "00" },
          { id: 3938, name: "Mazandaran", code: "02" },
          { id: 3942, name: "North Khorasan", code: "28" },
          { id: 3941, name: "Qazvin", code: "26" },
          { id: 3922, name: "Qom", code: "25" },
          { id: 3927, name: "Razavi Khorasan", code: "09" },
          { id: 3940, name: "Semnan", code: "20" },
          { id: 3931, name: "Sistan and Baluchestan", code: "11" },
          { id: 3930, name: "South Khorasan", code: "29" },
          { id: 3945, name: "Tehran", code: "23" },
          { id: 3924, name: "West Azarbaijan", code: "04" },
          { id: 3936, name: "Yazd", code: "21" },
          { id: 3925, name: "Zanjan", code: "19" }
        ]
      },
      {
        code: "IRQ",
        name: "Iraq",
        states: [
          { id: 3964, name: "Al Anbar", code: "AN" },
          { id: 3958, name: "Al Muthanna", code: "MU" },
          { id: 3956, name: "Al-Q\u0101disiyyah", code: "QA" },
          { id: 3955, name: "Babylon", code: "BB" },
          { id: 3959, name: "Baghdad", code: "BG" },
          { id: 3960, name: "Basra", code: "BA" },
          { id: 3954, name: "Dhi Qar", code: "DQ" },
          { id: 3965, name: "Diyala", code: "DI" },
          { id: 3967, name: "Dohuk", code: "DA" },
          { id: 3968, name: "Erbil", code: "AR" },
          { id: 3957, name: "Karbala", code: "KA" },
          { id: 3971, name: "Kirkuk", code: "KI" },
          { id: 3966, name: "Maysan", code: "MA" },
          { id: 3962, name: "Najaf", code: "NA" },
          { id: 3963, name: "Nineveh", code: "NI" },
          { id: 3961, name: "Saladin", code: "SD" },
          { id: 3969, name: "Sulaymaniyah", code: "SU" },
          { id: 3970, name: "Wasit", code: "WA" }
        ]
      },
      {
        code: "IRL",
        name: "Ireland",
        states: [
          { id: 1095, name: "Carlow", code: "CW" },
          { id: 1088, name: "Cavan", code: "CN" },
          { id: 1091, name: "Clare", code: "CE" },
          { id: 1087, name: "Connacht", code: "C" },
          { id: 1074, name: "Cork", code: "CO" },
          { id: 1071, name: "Donegal", code: "DL" },
          { id: 1072, name: "Dublin", code: "D" },
          { id: 1079, name: "Galway", code: "G" },
          { id: 1077, name: "Kerry", code: "KY" },
          { id: 1082, name: "Kildare", code: "KE" },
          { id: 1090, name: "Kilkenny", code: "KK" },
          { id: 1096, name: "Laois", code: "LS" },
          { id: 1073, name: "Leinster", code: "L" },
          { id: 1094, name: "Limerick", code: "LK" },
          { id: 1076, name: "Longford", code: "LD" },
          { id: 1083, name: "Louth", code: "LH" },
          { id: 1084, name: "Mayo", code: "MO" },
          { id: 1092, name: "Meath", code: "MH" },
          { id: 1075, name: "Monaghan", code: "MN" },
          { id: 1080, name: "Munster", code: "M" },
          { id: 1078, name: "Offaly", code: "OY" },
          { id: 1081, name: "Roscommon", code: "RN" },
          { id: 1070, name: "Sligo", code: "SO" },
          { id: 1069, name: "Tipperary", code: "TA" },
          { id: 1086, name: "Ulster", code: "U" },
          { id: 1089, name: "Waterford", code: "WD" },
          { id: 1097, name: "Westmeath", code: "WH" },
          { id: 1093, name: "Wexford", code: "WX" },
          { id: 1085, name: "Wicklow", code: "WW" }
        ]
      },
      {
        code: "ISR",
        name: "Israel",
        states: [
          { id: 1367, name: "Central District", code: "M" },
          { id: 1369, name: "Haifa District", code: "HA" },
          { id: 1370, name: "Jerusalem District", code: "JM" },
          { id: 1366, name: "Northern District", code: "Z" },
          { id: 1368, name: "Southern District", code: "D" },
          { id: 1371, name: "Tel Aviv District", code: "TA" }
        ]
      },
      {
        code: "ITA",
        name: "Italy",
        states: [
          { id: 1679, name: "Abruzzo", code: "65" },
          { id: 1727, name: "Agrigento", code: "AG" },
          { id: 1783, name: "Alessandria", code: "AL" },
          { id: 1672, name: "Ancona", code: "AN" },
          { id: 1716, name: "Aosta Valley", code: "23" },
          { id: 1688, name: "Apulia", code: "75" },
          { id: 1681, name: "Ascoli Piceno", code: "AP" },
          { id: 1780, name: "Asti", code: "AT" },
          { id: 1692, name: "Avellino", code: "AV" },
          { id: 1686, name: "Barletta-Andria-Trani", code: "BT" },
          { id: 1706, name: "Basilicata", code: "77" },
          { id: 1689, name: "Belluno", code: "BL" },
          { id: 1701, name: "Benevento", code: "BN" },
          { id: 1704, name: "Bergamo", code: "BG" },
          { id: 1778, name: "Biella", code: "BI" },
          { id: 1717, name: "Brescia", code: "BS" },
          { id: 1714, name: "Brindisi", code: "BR" },
          { id: 1703, name: "Calabria", code: "78" },
          { id: 1718, name: "Caltanissetta", code: "CL" },
          { id: 1669, name: "Campania", code: "72" },
          { id: 1721, name: "Campobasso", code: "CB" },
          { id: 1731, name: "Caserta", code: "CE" },
          { id: 1728, name: "Catanzaro", code: "CZ" },
          { id: 1739, name: "Chieti", code: "CH" },
          { id: 1740, name: "Como", code: "CO" },
          { id: 1742, name: "Cosenza", code: "CS" },
          { id: 1751, name: "Cremona", code: "CR" },
          { id: 1754, name: "Crotone", code: "KR" },
          { id: 1775, name: "Cuneo", code: "CN" },
          { id: 1773, name: "Emilia-Romagna", code: "45" },
          { id: 1723, name: "Enna", code: "EN" },
          { id: 1744, name: "Fermo", code: "FM" },
          { id: 1746, name: "Ferrara", code: "FE" },
          { id: 1771, name: "Foggia", code: "FG" },
          { id: 1779, name: "Forl\xEC-Cesena", code: "FC" },
          { id: 1756, name: "Friuli\u2013Venezia Giulia", code: "36" },
          { id: 1776, name: "Frosinone", code: "FR" },
          { id: 1777, name: "Gorizia", code: "GO" },
          { id: 1787, name: "Grosseto", code: "GR" },
          { id: 1788, name: "Imperia", code: "IM" },
          { id: 1789, name: "Isernia", code: "IS" },
          { id: 1781, name: "L'Aquila", code: "AQ" },
          { id: 1791, name: "La Spezia", code: "SP" },
          { id: 1674, name: "Latina", code: "LT" },
          { id: 1678, name: "Lazio", code: "62" },
          { id: 1675, name: "Lecce", code: "LE" },
          { id: 1677, name: "Lecco", code: "LC" },
          { id: 1768, name: "Liguria", code: "42" },
          { id: 1745, name: "Livorno", code: "LI" },
          { id: 1747, name: "Lodi", code: "LO" },
          { id: 1705, name: "Lombardy", code: "25" },
          { id: 1749, name: "Lucca", code: "LU" },
          { id: 1750, name: "Macerata", code: "MC" },
          { id: 1758, name: "Mantua", code: "MN" },
          { id: 1670, name: "Marche", code: "57" },
          { id: 1759, name: "Massa and Carrara", code: "MS" },
          { id: 1760, name: "Matera", code: "MT" },
          { id: 1761, name: "Medio Campidano", code: "VS" },
          { id: 1757, name: "Modena", code: "MO" },
          { id: 1695, name: "Molise", code: "67" },
          { id: 1769, name: "Monza and Brianza", code: "MB" },
          { id: 1774, name: "Novara", code: "NO" },
          { id: 1790, name: "Nuoro", code: "NU" },
          { id: 1786, name: "Oristano", code: "OR" },
          { id: 1665, name: "Padua", code: "PD" },
          { id: 1668, name: "Palermo", code: "PA" },
          { id: 1666, name: "Parma", code: "PR" },
          { id: 1676, name: "Pavia", code: "PV" },
          { id: 1691, name: "Perugia", code: "PG" },
          { id: 1693, name: "Pesaro and Urbino", code: "PU" },
          { id: 1694, name: "Pescara", code: "PE" },
          { id: 1696, name: "Piacenza", code: "PC" },
          { id: 1702, name: "Piedmont", code: "21" },
          { id: 1685, name: "Pisa", code: "PI" },
          { id: 1687, name: "Pistoia", code: "PT" },
          { id: 1690, name: "Pordenone", code: "PN" },
          { id: 1697, name: "Potenza", code: "PZ" },
          { id: 1700, name: "Prato", code: "PO" },
          { id: 1729, name: "Ragusa", code: "RG" },
          { id: 1707, name: "Ravenna", code: "RA" },
          { id: 1708, name: "Reggio Emilia", code: "RE" },
          { id: 1712, name: "Rieti", code: "RI" },
          { id: 1713, name: "Rimini", code: "RN" },
          { id: 1719, name: "Rovigo", code: "RO" },
          { id: 1720, name: "Salerno", code: "SA" },
          { id: 1715, name: "Sardinia", code: "88" },
          { id: 1722, name: "Sassari", code: "SS" },
          { id: 1732, name: "Savona", code: "SV" },
          { id: 1709, name: "Sicily", code: "82" },
          { id: 1734, name: "Siena", code: "SI" },
          { id: 1667, name: "Siracusa", code: "SR" },
          { id: 1741, name: "Sondrio", code: "SO" },
          { id: 1730, name: "South Sardinia", code: "SU" },
          { id: 1743, name: "Taranto", code: "TA" },
          { id: 1752, name: "Teramo", code: "TE" },
          { id: 1755, name: "Terni", code: "TR" },
          { id: 1733, name: "Trapani", code: "TP" },
          { id: 1725, name: "Trentino-South Tyrol", code: "32" },
          { id: 1762, name: "Treviso", code: "TV" },
          { id: 1763, name: "Trieste", code: "TS" },
          { id: 1664, name: "Tuscany", code: "52" },
          { id: 1764, name: "Udine", code: "UD" },
          { id: 1683, name: "Umbria", code: "55" },
          { id: 1765, name: "Varese", code: "VA" },
          { id: 1753, name: "Veneto", code: "34" },
          { id: 1726, name: "Verbano-Cusio-Ossola", code: "VB" },
          { id: 1785, name: "Vercelli", code: "VC" },
          { id: 1736, name: "Verona", code: "VR" },
          { id: 1737, name: "Vibo Valentia", code: "VV" },
          { id: 1738, name: "Vicenza", code: "VI" },
          { id: 1735, name: "Viterbo", code: "VT" }
        ]
      },
      {
        code: "JAM",
        name: "Jamaica",
        states: [
          { id: 3753, name: "Clarendon Parish", code: "13" },
          { id: 3749, name: "Hanover Parish", code: "09" },
          { id: 3748, name: "Kingston Parish", code: "01" },
          { id: 3754, name: "Manchester Parish", code: "12" },
          { id: 3752, name: "Portland Parish", code: "04" },
          { id: 3751, name: "Saint Andrew", code: "02" },
          { id: 3744, name: "Saint Ann Parish", code: "06" },
          { id: 3746, name: "Saint Catherine Parish", code: "14" },
          { id: 3743, name: "Saint Elizabeth Parish", code: "11" },
          { id: 3745, name: "Saint James Parish", code: "08" },
          { id: 3747, name: "Saint Mary Parish", code: "05" },
          { id: 3750, name: "Saint Thomas Parish", code: "03" },
          { id: 3755, name: "Trelawny Parish", code: "07" },
          { id: 3742, name: "Westmoreland Parish", code: "10" }
        ]
      },
      {
        code: "JPN",
        name: "Japan",
        states: [
          { id: 827, name: "Aichi Prefecture", code: "23" },
          { id: 829, name: "Akita Prefecture", code: "05" },
          { id: 839, name: "Aomori Prefecture", code: "02" },
          { id: 821, name: "Chiba Prefecture", code: "12" },
          { id: 865, name: "Ehime Prefecture", code: "38" },
          { id: 848, name: "Fukui Prefecture", code: "18" },
          { id: 861, name: "Fukuoka Prefecture", code: "40" },
          { id: 847, name: "Fukushima Prefecture", code: "07" },
          { id: 858, name: "Gifu Prefecture", code: "21" },
          { id: 862, name: "Gunma Prefecture", code: "10" },
          { id: 828, name: "Hiroshima Prefecture", code: "34" },
          { id: 832, name: "Hokkaid\u014D Prefecture", code: "01" },
          { id: 831, name: "Hy\u014Dgo Prefecture", code: "28" },
          { id: 851, name: "Ibaraki Prefecture", code: "08" },
          { id: 830, name: "Ishikawa Prefecture", code: "17" },
          { id: 856, name: "Iwate Prefecture", code: "03" },
          { id: 864, name: "Kagawa Prefecture", code: "37" },
          { id: 840, name: "Kagoshima Prefecture", code: "46" },
          { id: 842, name: "Kanagawa Prefecture", code: "14" },
          { id: 4924, name: "K\u014Dchi Prefecture", code: "39" },
          { id: 846, name: "Kumamoto Prefecture", code: "43" },
          { id: 834, name: "Ky\u014Dto Prefecture", code: "26" },
          { id: 833, name: "Mie Prefecture", code: "24" },
          { id: 857, name: "Miyagi Prefecture", code: "04" },
          { id: 855, name: "Miyazaki Prefecture", code: "45" },
          { id: 843, name: "Nagano Prefecture", code: "20" },
          { id: 849, name: "Nagasaki Prefecture", code: "42" },
          { id: 824, name: "Nara Prefecture", code: "29" },
          { id: 841, name: "Niigata Prefecture", code: "15" },
          { id: 822, name: "\u014Cita Prefecture", code: "44" },
          { id: 820, name: "Okayama Prefecture", code: "33" },
          { id: 853, name: "Okinawa Prefecture", code: "47" },
          { id: 859, name: "\u014Csaka Prefecture", code: "27" },
          { id: 863, name: "Saga Prefecture", code: "41" },
          { id: 860, name: "Saitama Prefecture", code: "11" },
          { id: 845, name: "Shiga Prefecture", code: "25" },
          { id: 826, name: "Shimane Prefecture", code: "32" },
          { id: 825, name: "Shizuoka Prefecture", code: "22" },
          { id: 854, name: "Tochigi Prefecture", code: "09" },
          { id: 836, name: "Tokushima Prefecture", code: "36" },
          { id: 823, name: "Tokyo", code: "13" },
          { id: 850, name: "Tottori Prefecture", code: "31" },
          { id: 838, name: "Toyama Prefecture", code: "16" },
          { id: 844, name: "Wakayama Prefecture", code: "30" },
          { id: 837, name: "Yamagata Prefecture", code: "06" },
          { id: 835, name: "Yamaguchi Prefecture", code: "35" },
          { id: 852, name: "Yamanashi Prefecture", code: "19" }
        ]
      },
      { code: "JEY", name: "Jersey", states: [] },
      {
        code: "JOR",
        name: "Jordan",
        states: [
          { id: 963, name: "Ajloun", code: "AJ" },
          { id: 965, name: "Amman", code: "AM" },
          { id: 959, name: "Aqaba", code: "AQ" },
          { id: 961, name: "Balqa", code: "BA" },
          { id: 960, name: "Irbid", code: "IR" },
          { id: 966, name: "Jerash", code: "JA" },
          { id: 956, name: "Karak", code: "KA" },
          { id: 964, name: "Ma'an", code: "MN" },
          { id: 958, name: "Madaba", code: "MD" },
          { id: 962, name: "Mafraq", code: "MA" },
          { id: 957, name: "Tafilah", code: "AT" },
          { id: 967, name: "Zarqa", code: "AZ" }
        ]
      },
      {
        code: "KAZ",
        name: "Kazakhstan",
        states: [
          { id: 145, name: "Akmola Region", code: "AKM" },
          { id: 151, name: "Aktobe Region", code: "AKT" },
          { id: 152, name: "Almaty", code: "ALA" },
          { id: 143, name: "Almaty Region", code: "ALM" },
          { id: 153, name: "Atyrau Region", code: "ATY" },
          { id: 155, name: "Baikonur", code: "BAY" },
          { id: 154, name: "East Kazakhstan Region", code: "VOS" },
          { id: 147, name: "Jambyl Region", code: "ZHA" },
          { id: 150, name: "Karaganda Region", code: "KAR" },
          { id: 157, name: "Kostanay Region", code: "KUS" },
          { id: 142, name: "Kyzylorda Region", code: "KZY" },
          { id: 141, name: "Mangystau Region", code: "MAN" },
          { id: 144, name: "North Kazakhstan Region", code: "SEV" },
          { id: 156, name: "Nur-Sultan", code: "AST" },
          { id: 146, name: "Pavlodar Region", code: "PAV" },
          { id: 149, name: "Turkestan Region", code: "YUZ" },
          { id: 148, name: "West Kazakhstan Province", code: "ZAP" }
        ]
      },
      {
        code: "KEN",
        name: "Kenya",
        states: [
          { id: 181, name: "Baringo", code: "01" },
          { id: 210, name: "Bomet", code: "02" },
          { id: 168, name: "Bungoma", code: "03" },
          { id: 161, name: "Busia", code: "04" },
          { id: 201, name: "Elgeyo-Marakwet", code: "05" },
          { id: 163, name: "Embu", code: "06" },
          { id: 196, name: "Garissa", code: "07" },
          { id: 195, name: "Homa Bay", code: "08" },
          { id: 170, name: "Isiolo", code: "09" },
          { id: 197, name: "Kajiado", code: "10" },
          { id: 158, name: "Kakamega", code: "11" },
          { id: 193, name: "Kericho", code: "12" },
          { id: 199, name: "Kiambu", code: "13" },
          { id: 174, name: "Kilifi", code: "14" },
          { id: 167, name: "Kirinyaga", code: "15" },
          { id: 159, name: "Kisii", code: "16" },
          { id: 171, name: "Kisumu", code: "17" },
          { id: 211, name: "Kitui", code: "18" },
          { id: 173, name: "Kwale", code: "19" },
          { id: 164, name: "Laikipia", code: "20" },
          { id: 166, name: "Lamu", code: "21" },
          { id: 184, name: "Machakos", code: "22" },
          { id: 188, name: "Makueni", code: "23" },
          { id: 187, name: "Mandera", code: "24" },
          { id: 194, name: "Marsabit", code: "25" },
          { id: 198, name: "Meru", code: "26" },
          { id: 190, name: "Migori", code: "27" },
          { id: 200, name: "Mombasa", code: "28" },
          { id: 178, name: "Murang'a", code: "29" },
          { id: 191, name: "Nairobi City", code: "30" },
          { id: 203, name: "Nakuru", code: "31" },
          { id: 165, name: "Nandi", code: "32" },
          { id: 175, name: "Narok", code: "33" },
          { id: 209, name: "Nyamira", code: "34" },
          { id: 192, name: "Nyandarua", code: "35" },
          { id: 180, name: "Nyeri", code: "36" },
          { id: 207, name: "Samburu", code: "37" },
          { id: 186, name: "Siaya", code: "38" },
          { id: 176, name: "Taita\u2013Taveta", code: "39" },
          { id: 205, name: "Tana River", code: "40" },
          { id: 185, name: "Tharaka-Nithi", code: "41" },
          { id: 183, name: "Trans Nzoia", code: "42" },
          { id: 206, name: "Turkana", code: "43" },
          { id: 169, name: "Uasin Gishu", code: "44" },
          { id: 202, name: "Vihiga", code: "45" },
          { id: 182, name: "Wajir", code: "46" },
          { id: 208, name: "West Pokot", code: "47" }
        ]
      },
      {
        code: "KIR",
        name: "Kiribati",
        states: [
          { id: 1831, name: "Gilbert Islands", code: "G" },
          { id: 1832, name: "Line Islands", code: "L" },
          { id: 1830, name: "Phoenix Islands", code: "P" }
        ]
      },
      {
        code: "XKX",
        name: "Kosovo",
        states: [
          { id: 4876, name: "\u0110akovica District (Gjakove)", code: "XDG" },
          { id: 4877, name: "Gjilan District", code: "XGJ" },
          { id: 4878, name: "Kosovska Mitrovica District", code: "XKM" },
          { id: 3738, name: "Pe\u0107 District", code: "XPE" },
          { id: 4879, name: "Pristina (Pri\u015Ftine)", code: "XPI" },
          { id: 3723, name: "Prizren District", code: "XPR" },
          { id: 4874, name: "Uro\u0161evac District (Ferizaj)", code: "XUF" }
        ]
      },
      {
        code: "KWT",
        name: "Kuwait",
        states: [
          { id: 977, name: "Al Ahmadi", code: "AH" },
          { id: 975, name: "Al Farwaniyah", code: "FA" },
          { id: 972, name: "Al Jahra", code: "JA" },
          { id: 976, name: "Capital", code: "KU" },
          { id: 973, name: "Hawalli", code: "HA" },
          { id: 974, name: "Mubarak Al-Kabeer", code: "MU" }
        ]
      },
      {
        code: "KGZ",
        name: "Kyrgyzstan",
        states: [
          { id: 998, name: "Batken Region", code: "B" },
          { id: 1001, name: "Bishkek", code: "GB" },
          { id: 1004, name: "Chuy Region", code: "C" },
          { id: 1002, name: "Issyk-Kul Region", code: "Y" },
          { id: 1e3, name: "Jalal-Abad Region", code: "J" },
          { id: 999, name: "Naryn Region", code: "N" },
          { id: 1003, name: "Osh", code: "GO" },
          { id: 1005, name: "Osh Region", code: "O" },
          { id: 997, name: "Talas Region", code: "T" }
        ]
      },
      {
        code: "LAO",
        name: "Laos",
        states: [
          { id: 982, name: "Attapeu Province", code: "AT" },
          { id: 991, name: "Bokeo Province", code: "BK" },
          { id: 985, name: "Bolikhamsai Province", code: "BL" },
          { id: 996, name: "Champasak Province", code: "CH" },
          { id: 989, name: "Houaphanh Province", code: "HO" },
          { id: 986, name: "Khammouane Province", code: "KH" },
          { id: 992, name: "Luang Namtha Province", code: "LM" },
          { id: 978, name: "Luang Prabang Province", code: "LP" },
          { id: 988, name: "Oudomxay Province", code: "OU" },
          { id: 987, name: "Phongsaly Province", code: "PH" },
          { id: 993, name: "Sainyabuli Province", code: "XA" },
          { id: 981, name: "Salavan Province", code: "SL" },
          { id: 990, name: "Savannakhet Province", code: "SV" },
          { id: 984, name: "Sekong Province", code: "XE" },
          { id: 979, name: "Vientiane Prefecture", code: "VT" },
          { id: 980, name: "Vientiane Province", code: "VI" },
          { id: 994, name: "Xaisomboun", code: "XN" },
          { id: 983, name: "Xaisomboun Province", code: "XS" },
          { id: 995, name: "Xiangkhouang Province", code: "XI" }
        ]
      },
      {
        code: "LVA",
        name: "Latvia",
        states: [
          { id: 4445, name: "Aglona Municipality", code: "001" },
          { id: 4472, name: "Aizkraukle Municipality", code: "002" },
          { id: 4496, name: "Aizpute Municipality", code: "003" },
          { id: 4499, name: "Akn\u012Bste Municipality", code: "004" },
          { id: 4484, name: "Aloja Municipality", code: "005" },
          { id: 4485, name: "Alsunga Municipality", code: "006" },
          { id: 4487, name: "Al\u016Bksne Municipality", code: "007" },
          { id: 4497, name: "Amata Municipality", code: "008" },
          { id: 4457, name: "Ape Municipality", code: "009" },
          { id: 4481, name: "Auce Municipality", code: "010" },
          { id: 4427, name: "Bab\u012Bte Municipality", code: "012" },
          { id: 4482, name: "Baldone Municipality", code: "013" },
          { id: 4498, name: "Baltinava Municipality", code: "014" },
          { id: 4505, name: "Balvi Municipality", code: "015" },
          { id: 4465, name: "Bauska Municipality", code: "016" },
          { id: 4471, name: "Bever\u012Bna Municipality", code: "017" },
          { id: 4468, name: "Broc\u0113ni Municipality", code: "018" },
          { id: 4411, name: "Burtnieki Municipality", code: "019" },
          { id: 4454, name: "Carnikava Municipality", code: "020" },
          { id: 4469, name: "C\u0113sis Municipality", code: "022" },
          { id: 4414, name: "Cesvaine Municipality", code: "021" },
          { id: 4410, name: "Cibla Municipality", code: "023" },
          { id: 4504, name: "Dagda Municipality", code: "024" },
          { id: 4463, name: "Daugavpils", code: "DGV" },
          { id: 4492, name: "Daugavpils Municipality", code: "025" },
          { id: 4437, name: "Dobele Municipality", code: "026" },
          { id: 4428, name: "Dundaga Municipality", code: "027" },
          { id: 4458, name: "Durbe Municipality", code: "028" },
          { id: 4448, name: "Engure Municipality", code: "029" },
          { id: 4444, name: "\u0112rg\u013Ci Municipality", code: "030" },
          { id: 4510, name: "Garkalne Municipality", code: "031" },
          { id: 4470, name: "Grobi\u0146a Municipality", code: "032" },
          { id: 4400, name: "Gulbene Municipality", code: "033" },
          { id: 4441, name: "Iecava Municipality", code: "034" },
          { id: 4511, name: "Ik\u0161\u0137ile Municipality", code: "035" },
          { id: 4399, name: "Il\u016Bkste Municipality", code: "036" },
          { id: 4449, name: "In\u010Dukalns Municipality", code: "037" },
          { id: 4475, name: "Jaunjelgava Municipality", code: "038" },
          { id: 4407, name: "Jaunpiebalga Municipality", code: "039" },
          { id: 4489, name: "Jaunpils Municipality", code: "040" },
          { id: 4464, name: "J\u0113kabpils", code: "JKB" },
          { id: 4438, name: "J\u0113kabpils Municipality", code: "042" },
          { id: 4500, name: "Jelgava", code: "JEL" },
          { id: 4424, name: "Jelgava Municipality", code: "041" },
          { id: 4446, name: "J\u016Brmala", code: "JUR" },
          { id: 4420, name: "Kandava Municipality", code: "043" },
          { id: 4453, name: "K\u0101rsava Municipality", code: "044" },
          { id: 4412, name: "\u0136egums Municipality", code: "051" },
          { id: 4435, name: "\u0136ekava Municipality", code: "052" },
          { id: 4495, name: "Koc\u0113ni Municipality", code: "045" },
          { id: 4452, name: "Koknese Municipality", code: "046" },
          { id: 4474, name: "Kr\u0101slava Municipality", code: "047" },
          { id: 4422, name: "Krimulda Municipality", code: "048" },
          { id: 4413, name: "Krustpils Municipality", code: "049" },
          { id: 4490, name: "Kuld\u012Bga Municipality", code: "050" },
          { id: 4512, name: "Lielv\u0101rde Municipality", code: "053" },
          { id: 4460, name: "Liep\u0101ja", code: "LPX" },
          { id: 4488, name: "L\u012Bgatne Municipality", code: "055" },
          { id: 4418, name: "Limba\u017Ei Municipality", code: "054" },
          { id: 4401, name: "L\u012Bv\u0101ni Municipality", code: "056" },
          { id: 4419, name: "Lub\u0101na Municipality", code: "057" },
          { id: 4501, name: "Ludza Municipality", code: "058" },
          { id: 4433, name: "Madona Municipality", code: "059" },
          { id: 4461, name: "M\u0101lpils Municipality", code: "061" },
          { id: 4450, name: "M\u0101rupe Municipality", code: "062" },
          { id: 4513, name: "Mazsalaca Municipality", code: "060" },
          { id: 4451, name: "M\u0113rsrags Municipality", code: "063" },
          { id: 4398, name: "Nauk\u0161\u0113ni Municipality", code: "064" },
          { id: 4432, name: "Nereta Municipality", code: "065" },
          { id: 4436, name: "N\u012Bca Municipality", code: "066" },
          { id: 4416, name: "Ogre Municipality", code: "067" },
          { id: 4417, name: "Olaine Municipality", code: "068" },
          { id: 4442, name: "Ozolnieki Municipality", code: "069" },
          { id: 4507, name: "P\u0101rgauja Municipality", code: "070" },
          { id: 4467, name: "P\u0101vilosta Municipality", code: "071" },
          { id: 4405, name: "P\u013Cavi\u0146as Municipality", code: "072" },
          { id: 4483, name: "Prei\u013Ci Municipality", code: "073" },
          { id: 4429, name: "Priekule Municipality", code: "074" },
          { id: 4506, name: "Prieku\u013Ci Municipality", code: "075" },
          { id: 4479, name: "Rauna Municipality", code: "076" },
          { id: 4509, name: "R\u0113zekne", code: "REZ" },
          { id: 4455, name: "R\u0113zekne Municipality", code: "077" },
          { id: 4502, name: "Riebi\u0146i Municipality", code: "078" },
          { id: 4491, name: "Riga", code: "RIX" },
          { id: 4440, name: "Roja Municipality", code: "079" },
          { id: 4493, name: "Ropa\u017Ei Municipality", code: "080" },
          { id: 4503, name: "Rucava Municipality", code: "081" },
          { id: 4423, name: "Rug\u0101ji Municipality", code: "082" },
          { id: 4426, name: "R\u016Bjiena Municipality", code: "084" },
          { id: 4404, name: "Rund\u0101le Municipality", code: "083" },
          { id: 4434, name: "Sala Municipality", code: "085" },
          { id: 4396, name: "Salacgr\u012Bva Municipality", code: "086" },
          { id: 4402, name: "Salaspils Municipality", code: "087" },
          { id: 4439, name: "Saldus Municipality", code: "088" },
          { id: 4443, name: "Saulkrasti Municipality", code: "089" },
          { id: 4408, name: "S\u0113ja Municipality", code: "090" },
          { id: 4476, name: "Sigulda Municipality", code: "091" },
          { id: 4415, name: "Skr\u012Bveri Municipality", code: "092" },
          { id: 4447, name: "Skrunda Municipality", code: "093" },
          { id: 4462, name: "Smiltene Municipality", code: "094" },
          { id: 4478, name: "Stopi\u0146i Municipality", code: "095" },
          { id: 4494, name: "Stren\u010Di Municipality", code: "096" },
          { id: 4459, name: "Talsi Municipality", code: "097" },
          { id: 4480, name: "T\u0113rvete Municipality", code: "098" },
          { id: 4409, name: "Tukums Municipality", code: "099" },
          { id: 4508, name: "Vai\u0146ode Municipality", code: "100" },
          { id: 4425, name: "Valka Municipality", code: "101" },
          { id: 4473, name: "Valmiera", code: "VMR" },
          { id: 4431, name: "Varak\u013C\u0101ni Municipality", code: "102" },
          { id: 4406, name: "V\u0101rkava Municipality", code: "103" },
          { id: 4466, name: "Vecpiebalga Municipality", code: "104" },
          { id: 4397, name: "Vecumnieki Municipality", code: "105" },
          { id: 4421, name: "Ventspils", code: "VEN" },
          { id: 4403, name: "Ventspils Municipality", code: "106" },
          { id: 4456, name: "Vies\u012Bte Municipality", code: "107" },
          { id: 4477, name: "Vi\u013Caka Municipality", code: "108" },
          { id: 4486, name: "Vi\u013C\u0101ni Municipality", code: "109" },
          { id: 4430, name: "Zilupe Municipality", code: "110" }
        ]
      },
      {
        code: "LBN",
        name: "Lebanon",
        states: [
          { id: 2285, name: "Akkar", code: "AK" },
          { id: 2283, name: "Baalbek-Hermel", code: "BH" },
          { id: 2286, name: "Beirut", code: "BA" },
          { id: 2287, name: "Beqaa", code: "BI" },
          { id: 2282, name: "Mount Lebanon", code: "JL" },
          { id: 2288, name: "Nabatieh", code: "NA" },
          { id: 2284, name: "North", code: "AS" },
          { id: 2281, name: "South", code: "JA" }
        ]
      },
      {
        code: "LSO",
        name: "Lesotho",
        states: [
          { id: 3030, name: "Berea District", code: "D" },
          { id: 3029, name: "Butha-Buthe District", code: "B" },
          { id: 3026, name: "Leribe District", code: "C" },
          { id: 3022, name: "Mafeteng District", code: "E" },
          { id: 3028, name: "Maseru District", code: "A" },
          { id: 3023, name: "Mohale's Hoek District", code: "F" },
          { id: 3024, name: "Mokhotlong District", code: "J" },
          { id: 3025, name: "Qacha's Nek District", code: "H" },
          { id: 3027, name: "Quthing District", code: "G" },
          { id: 3031, name: "Thaba-Tseka District", code: "K" }
        ]
      },
      {
        code: "LBR",
        name: "Liberia",
        states: [
          { id: 3041, name: "Bomi County", code: "BM" },
          { id: 3034, name: "Bong County", code: "BG" },
          { id: 3044, name: "Gbarpolu County", code: "GP" },
          { id: 3040, name: "Grand Bassa County", code: "GB" },
          { id: 3036, name: "Grand Cape Mount County", code: "CM" },
          { id: 3039, name: "Grand Gedeh County", code: "GG" },
          { id: 3045, name: "Grand Kru County", code: "GK" },
          { id: 3037, name: "Lofa County", code: "LO" },
          { id: 3043, name: "Margibi County", code: "MG" },
          { id: 3042, name: "Maryland County", code: "MY" },
          { id: 3032, name: "Montserrado County", code: "MO" },
          { id: 3046, name: "Nimba", code: "NI" },
          { id: 3033, name: "River Cess County", code: "RI" },
          { id: 3038, name: "River Gee County", code: "RG" },
          { id: 3035, name: "Sinoe County", code: "SI" }
        ]
      },
      {
        code: "LBY",
        name: "Libya",
        states: [
          { id: 2964, name: "Al Wahat District", code: "WA" },
          { id: 2981, name: "Benghazi", code: "BA" },
          { id: 2966, name: "Derna District", code: "DR" },
          { id: 2969, name: "Ghat District", code: "GT" },
          { id: 2980, name: "Jabal al Akhdar", code: "JA" },
          { id: 2974, name: "Jabal al Gharbi District", code: "JG" },
          { id: 2979, name: "Jafara", code: "JI" },
          { id: 2970, name: "Jufra", code: "JU" },
          { id: 2972, name: "Kufra District", code: "KF" },
          { id: 2968, name: "Marj District", code: "MJ" },
          { id: 2978, name: "Misrata District", code: "MI" },
          { id: 2961, name: "Murqub", code: "MB" },
          { id: 2967, name: "Murzuq District", code: "MQ" },
          { id: 2976, name: "Nalut District", code: "NL" },
          { id: 2962, name: "Nuqat al Khams", code: "NQ" },
          { id: 2965, name: "Sabha District", code: "SB" },
          { id: 2977, name: "Sirte District", code: "SR" },
          { id: 2971, name: "Tripoli District", code: "TB" },
          { id: 2973, name: "Wadi al Hayaa District", code: "WD" },
          { id: 2975, name: "Wadi al Shatii District", code: "WS" },
          { id: 2963, name: "Zawiya District", code: "ZA" }
        ]
      },
      {
        code: "LIE",
        name: "Liechtenstein",
        states: [
          { id: 458, name: "Balzers", code: "01" },
          { id: 451, name: "Eschen", code: "02" },
          { id: 457, name: "Gamprin", code: "03" },
          { id: 455, name: "Mauren", code: "04" },
          { id: 454, name: "Planken", code: "05" },
          { id: 453, name: "Ruggell", code: "06" },
          { id: 450, name: "Schaan", code: "07" },
          { id: 449, name: "Schellenberg", code: "08" },
          { id: 459, name: "Triesen", code: "09" },
          { id: 456, name: "Triesenberg", code: "10" },
          { id: 452, name: "Vaduz", code: "11" }
        ]
      },
      {
        code: "LTU",
        name: "Lithuania",
        states: [
          { id: 1561, name: "Akmen\u0117 District Municipality", code: "01" },
          { id: 1605, name: "Alytus City Municipality", code: "02" },
          { id: 1574, name: "Alytus County", code: "AL" },
          { id: 1599, name: "Alytus District Municipality", code: "03" },
          { id: 1603, name: "Bir\u0161tonas Municipality", code: "05" },
          { id: 1566, name: "Bir\u017Eai District Municipality", code: "06" },
          { id: 1579, name: "Druskininkai municipality", code: "07" },
          { id: 1559, name: "Elektr\u0117nai municipality", code: "08" },
          { id: 1562, name: "Ignalina District Municipality", code: "09" },
          { id: 1567, name: "Jonava District Municipality", code: "10" },
          { id: 1581, name: "Joni\u0161kis District Municipality", code: "11" },
          { id: 1555, name: "Jurbarkas District Municipality", code: "12" },
          { id: 1583, name: "Kai\u0161iadorys District Municipality", code: "13" },
          { id: 1591, name: "Kalvarija municipality", code: "14" },
          { id: 1580, name: "Kaunas City Municipality", code: "15" },
          { id: 1556, name: "Kaunas County", code: "KU" },
          { id: 1565, name: "Kaunas District Municipality", code: "16" },
          { id: 1575, name: "Kazl\u0173 R\u016Bda municipality", code: "17" },
          { id: 1584, name: "K\u0117dainiai District Municipality", code: "18" },
          { id: 1618, name: "Kelm\u0117 District Municipality", code: "19" },
          { id: 1597, name: "Klaipeda City Municipality", code: "20" },
          { id: 1600, name: "Klaip\u0117da County", code: "KL" },
          { id: 1604, name: "Klaip\u0117da District Municipality", code: "21" },
          { id: 1571, name: "Kretinga District Municipality", code: "22" },
          { id: 1585, name: "Kupi\u0161kis District Municipality", code: "23" },
          { id: 1611, name: "Lazdijai District Municipality", code: "24" },
          { id: 1570, name: "Marijampol\u0117 County", code: "MR" },
          { id: 1610, name: "Marijampol\u0117 Municipality", code: "25" },
          { id: 1557, name: "Ma\u017Eeikiai District Municipality", code: "26" },
          { id: 1582, name: "Mol\u0117tai District Municipality", code: "27" },
          { id: 1563, name: "Neringa Municipality", code: "28" },
          { id: 1612, name: "Pag\u0117giai municipality", code: "29" },
          { id: 1595, name: "Pakruojis District Municipality", code: "30" },
          { id: 1588, name: "Palanga City Municipality", code: "31" },
          { id: 1589, name: "Panev\u0117\u017Eys City Municipality", code: "32" },
          { id: 1558, name: "Panev\u0117\u017Eys County", code: "PN" },
          { id: 1614, name: "Panev\u0117\u017Eys District Municipality", code: "33" },
          { id: 1616, name: "Pasvalys District Municipality", code: "34" },
          { id: 1553, name: "Plung\u0117 District Municipality", code: "35" },
          { id: 1578, name: "Prienai District Municipality", code: "36" },
          { id: 1568, name: "Radvili\u0161kis District Municipality", code: "37" },
          { id: 1587, name: "Raseiniai District Municipality", code: "38" },
          { id: 1590, name: "Rietavas municipality", code: "39" },
          { id: 1615, name: "Roki\u0161kis District Municipality", code: "40" },
          { id: 1576, name: "\u0160akiai District Municipality", code: "41" },
          { id: 1577, name: "\u0160al\u010Dininkai District Municipality", code: "42" },
          { id: 1609, name: "\u0160iauliai City Municipality", code: "43" },
          { id: 1586, name: "\u0160iauliai County", code: "SA" },
          { id: 1554, name: "\u0160iauliai District Municipality", code: "44" },
          { id: 1613, name: "\u0160ilal\u0117 District Municipality", code: "45" },
          { id: 1607, name: "\u0160ilut\u0117 District Municipality", code: "46" },
          { id: 1594, name: "\u0160irvintos District Municipality", code: "47" },
          { id: 1617, name: "Skuodas District Municipality", code: "48" },
          { id: 1560, name: "\u0160ven\u010Dionys District Municipality", code: "49" },
          { id: 1573, name: "Taurag\u0117 County", code: "TA" },
          { id: 1572, name: "Taurag\u0117 District Municipality", code: "50" },
          { id: 1569, name: "Tel\u0161iai County", code: "TE" },
          { id: 1608, name: "Tel\u0161iai District Municipality", code: "51" },
          { id: 1593, name: "Trakai District Municipality", code: "52" },
          { id: 1596, name: "Ukmerg\u0117 District Municipality", code: "53" },
          { id: 1621, name: "Utena County", code: "UT" },
          { id: 1598, name: "Utena District Municipality", code: "54" },
          { id: 1602, name: "Var\u0117na District Municipality", code: "55" },
          { id: 1620, name: "Vilkavi\u0161kis District Municipality", code: "56" },
          { id: 1606, name: "Vilnius City Municipality", code: "57" },
          { id: 1601, name: "Vilnius County", code: "VL" },
          { id: 1592, name: "Vilnius District Municipality", code: "58" },
          { id: 1564, name: "Visaginas Municipality", code: "59" },
          { id: 1619, name: "Zarasai District Municipality", code: "60" }
        ]
      },
      {
        code: "LUX",
        name: "Luxembourg",
        states: [
          { id: 1518, name: "Canton of Capellen", code: "CA" },
          { id: 1521, name: "Canton of Clervaux", code: "CL" },
          { id: 1513, name: "Canton of Diekirch", code: "DI" },
          { id: 1515, name: "Canton of Echternach", code: "EC" },
          { id: 1517, name: "Canton of Esch-sur-Alzette", code: "ES" },
          { id: 1525, name: "Canton of Grevenmacher", code: "GR" },
          { id: 1527, name: "Canton of Luxembourg", code: "LU" },
          { id: 1522, name: "Canton of Mersch", code: "ME" },
          { id: 1516, name: "Canton of Redange", code: "RD" },
          { id: 1519, name: "Canton of Remich", code: "RM" },
          { id: 1523, name: "Canton of Vianden", code: "VD" },
          { id: 1526, name: "Canton of Wiltz", code: "WI" },
          { id: 1524, name: "Diekirch District", code: "D" },
          { id: 1520, name: "Grevenmacher District", code: "G" },
          { id: 1514, name: "Luxembourg District", code: "L" }
        ]
      },
      { code: "MAC", name: "Macau S.A.R.", states: [] },
      {
        code: "MDG",
        name: "Madagascar",
        states: [
          { id: 2951, name: "Antananarivo Province", code: "T" },
          { id: 2950, name: "Antsiranana Province", code: "D" },
          { id: 2948, name: "Fianarantsoa Province", code: "F" },
          { id: 2953, name: "Mahajanga Province", code: "M" },
          { id: 2952, name: "Toamasina Province", code: "A" },
          { id: 2949, name: "Toliara Province", code: "U" }
        ]
      },
      {
        code: "MWI",
        name: "Malawi",
        states: [
          { id: 3096, name: "Balaka District", code: "BA" },
          { id: 3102, name: "Blantyre District", code: "BL" },
          { id: 3092, name: "Central Region", code: "C" },
          { id: 3107, name: "Chikwawa District", code: "CK" },
          { id: 3109, name: "Chiradzulu District", code: "CR" },
          { id: 3087, name: "Chitipa district", code: "CT" },
          { id: 3097, name: "Dedza District", code: "DE" },
          { id: 3090, name: "Dowa District", code: "DO" },
          { id: 3091, name: "Karonga District", code: "KR" },
          { id: 3094, name: "Kasungu District", code: "KS" },
          { id: 3093, name: "Likoma District", code: "LK" },
          { id: 3101, name: "Lilongwe District", code: "LI" },
          { id: 3082, name: "Machinga District", code: "MH" },
          { id: 3110, name: "Mangochi District", code: "MG" },
          { id: 3099, name: "Mchinji District", code: "MC" },
          { id: 3103, name: "Mulanje District", code: "MU" },
          { id: 3084, name: "Mwanza District", code: "MW" },
          { id: 3104, name: "Mzimba District", code: "MZ" },
          { id: 3095, name: "Nkhata Bay District", code: "NB" },
          { id: 3100, name: "Nkhotakota District", code: "NK" },
          { id: 3105, name: "Northern Region", code: "N" },
          { id: 3085, name: "Nsanje District", code: "NS" },
          { id: 3088, name: "Ntcheu District", code: "NU" },
          { id: 3111, name: "Ntchisi District", code: "NI" },
          { id: 3108, name: "Phalombe District", code: "PH" },
          { id: 3089, name: "Rumphi District", code: "RU" },
          { id: 3086, name: "Salima District", code: "SA" },
          { id: 3106, name: "Southern Region", code: "S" },
          { id: 3098, name: "Thyolo District", code: "TH" },
          { id: 3083, name: "Zomba District", code: "ZO" }
        ]
      },
      {
        code: "MYS",
        name: "Malaysia",
        states: [
          { id: 1950, name: "Johor", code: "01" },
          { id: 1947, name: "Kedah", code: "02" },
          { id: 1946, name: "Kelantan", code: "03" },
          { id: 1949, name: "Kuala Lumpur", code: "14" },
          { id: 1935, name: "Labuan", code: "15" },
          { id: 1941, name: "Malacca", code: "04" },
          { id: 1948, name: "Negeri Sembilan", code: "05" },
          { id: 1940, name: "Pahang", code: "06" },
          { id: 1939, name: "Penang", code: "07" },
          { id: 1943, name: "Perak", code: "08" },
          { id: 1938, name: "Perlis", code: "09" },
          { id: 1945, name: "Putrajaya", code: "16" },
          { id: 1936, name: "Sabah", code: "12" },
          { id: 1937, name: "Sarawak", code: "13" },
          { id: 1944, name: "Selangor", code: "10" },
          { id: 1942, name: "Terengganu", code: "11" }
        ]
      },
      {
        code: "MDV",
        name: "Maldives",
        states: [
          { id: 2594, name: "Addu Atoll", code: "01" },
          { id: 2587, name: "Alif Alif Atoll", code: "02" },
          { id: 2600, name: "Alif Dhaal Atoll", code: "00" },
          { id: 2604, name: "Central Province", code: "CE" },
          { id: 2590, name: "Dhaalu Atoll", code: "17" },
          { id: 2599, name: "Faafu Atoll", code: "14" },
          { id: 2598, name: "Gaafu Alif Atoll", code: "27" },
          { id: 2603, name: "Gaafu Dhaalu Atoll", code: "28" },
          { id: 2595, name: "Gnaviyani Atoll", code: "29" },
          { id: 2586, name: "Haa Alif Atoll", code: "07" },
          { id: 2597, name: "Haa Dhaalu Atoll", code: "23" },
          { id: 2596, name: "Kaafu Atoll", code: "26" },
          { id: 2601, name: "Laamu Atoll", code: "05" },
          { id: 2607, name: "Lhaviyani Atoll", code: "03" },
          { id: 2609, name: "Mal\xE9", code: "MLE" },
          { id: 2608, name: "Meemu Atoll", code: "12" },
          { id: 2592, name: "Noonu Atoll", code: "25" },
          { id: 2589, name: "North Central Province", code: "NC" },
          { id: 2588, name: "North Province", code: "NO" },
          { id: 2602, name: "Raa Atoll", code: "13" },
          { id: 2585, name: "Shaviyani Atoll", code: "24" },
          { id: 2606, name: "South Central Province", code: "SC" },
          { id: 2605, name: "South Province", code: "SU" },
          { id: 2591, name: "Thaa Atoll", code: "08" },
          { id: 2593, name: "Upper South Province", code: "US" },
          { id: 2584, name: "Vaavu Atoll", code: "04" }
        ]
      },
      {
        code: "MLI",
        name: "Mali",
        states: [
          { id: 253, name: "Bamako", code: "BKO" },
          { id: 258, name: "Gao Region", code: "7" },
          { id: 252, name: "Kayes Region", code: "1" },
          { id: 257, name: "Kidal Region", code: "8" },
          { id: 250, name: "Koulikoro Region", code: "2" },
          { id: 251, name: "M\xE9naka Region", code: "9" },
          { id: 255, name: "Mopti Region", code: "5" },
          { id: 249, name: "S\xE9gou Region", code: "4" },
          { id: 254, name: "Sikasso Region", code: "3" },
          { id: 256, name: "Taoud\xE9nit Region", code: "10" },
          { id: 248, name: "Tombouctou Region", code: "6" }
        ]
      },
      {
        code: "MLT",
        name: "Malta",
        states: [
          { id: 110, name: "Attard", code: "01" },
          { id: 108, name: "Balzan", code: "02" },
          { id: 107, name: "Birgu", code: "03" },
          { id: 97, name: "Birkirkara", code: "04" },
          { id: 88, name: "Bir\u017Cebbu\u0121a", code: "05" },
          { id: 138, name: "Cospicua", code: "06" },
          { id: 117, name: "Dingli", code: "07" },
          { id: 129, name: "Fgura", code: "08" },
          { id: 84, name: "Floriana", code: "09" },
          { id: 134, name: "Fontana", code: "10" },
          { id: 130, name: "G\u0127ajnsielem", code: "13" },
          { id: 92, name: "G\u0127arb", code: "14" },
          { id: 120, name: "G\u0127arg\u0127ur", code: "15" },
          { id: 106, name: "G\u0127asri", code: "16" },
          { id: 124, name: "G\u0127axaq", code: "17" },
          { id: 118, name: "Gudja", code: "11" },
          { id: 113, name: "G\u017Cira", code: "12" },
          { id: 105, name: "\u0126amrun", code: "18" },
          { id: 93, name: "Iklin", code: "19" },
          { id: 99, name: "Kalkara", code: "21" },
          { id: 91, name: "Ker\u010Bem", code: "22" },
          { id: 82, name: "Kirkop", code: "23" },
          { id: 126, name: "Lija", code: "24" },
          { id: 77, name: "Luqa", code: "25" },
          { id: 128, name: "Marsa", code: "26" },
          { id: 137, name: "Marsaskala", code: "27" },
          { id: 78, name: "Marsaxlokk", code: "28" },
          { id: 89, name: "Mdina", code: "29" },
          { id: 102, name: "Mellie\u0127a", code: "30" },
          { id: 109, name: "M\u0121arr", code: "31" },
          { id: 140, name: "Mosta", code: "32" },
          { id: 74, name: "Mqabba", code: "33" },
          { id: 96, name: "Msida", code: "34" },
          { id: 131, name: "Mtarfa", code: "35" },
          { id: 132, name: "Munxar", code: "36" },
          { id: 133, name: "Nadur", code: "37" },
          { id: 112, name: "Naxxar", code: "38" },
          { id: 115, name: "Paola", code: "39" },
          { id: 125, name: "Pembroke", code: "40" },
          { id: 127, name: "Piet\xE0", code: "41" },
          { id: 79, name: "Qala", code: "42" },
          { id: 119, name: "Qormi", code: "43" },
          { id: 111, name: "Qrendi", code: "44" },
          { id: 83, name: "Rabat", code: "46" },
          { id: 87, name: "Saint Lawrence", code: "50" },
          { id: 75, name: "San \u0120wann", code: "49" },
          { id: 116, name: "Sannat", code: "52" },
          { id: 94, name: "Santa Lu\u010Bija", code: "53" },
          { id: 90, name: "Santa Venera", code: "54" },
          { id: 136, name: "Senglea", code: "20" },
          { id: 98, name: "Si\u0121\u0121iewi", code: "55" },
          { id: 104, name: "Sliema", code: "56" },
          { id: 100, name: "St. Julian's", code: "48" },
          { id: 139, name: "St. Paul's Bay", code: "51" },
          { id: 86, name: "Swieqi", code: "57" },
          { id: 122, name: "Ta' Xbiex", code: "58" },
          { id: 103, name: "Tarxien", code: "59" },
          { id: 95, name: "Valletta", code: "60" },
          { id: 101, name: "Victoria", code: "45" },
          { id: 114, name: "Xag\u0127ra", code: "61" },
          { id: 121, name: "Xewkija", code: "62" },
          { id: 81, name: "Xg\u0127ajra", code: "63" },
          { id: 123, name: "\u017Babbar", code: "64" },
          { id: 85, name: "\u017Bebbu\u0121 Gozo", code: "65" },
          { id: 80, name: "\u017Bebbu\u0121 Malta", code: "66" },
          { id: 135, name: "\u017Bejtun", code: "67" },
          { id: 76, name: "\u017Burrieq", code: "68" }
        ]
      },
      { code: "IMN", name: "Man (Isle of)", states: [] },
      {
        code: "MHL",
        name: "Marshall Islands",
        states: [
          { id: 2574, name: "Ralik Chain", code: "L" },
          { id: 2573, name: "Ratak Chain", code: "T" }
        ]
      },
      { code: "MTQ", name: "Martinique", states: [] },
      {
        code: "MRT",
        name: "Mauritania",
        states: [
          { id: 3344, name: "Adrar", code: "07" },
          { id: 3349, name: "Assaba", code: "03" },
          { id: 3339, name: "Brakna", code: "05" },
          { id: 3346, name: "Dakhlet Nouadhibou", code: "08" },
          { id: 3341, name: "Gorgol", code: "04" },
          { id: 3350, name: "Guidimaka", code: "10" },
          { id: 3338, name: "Hodh Ech Chargui", code: "01" },
          { id: 3351, name: "Hodh El Gharbi", code: "02" },
          { id: 3342, name: "Inchiri", code: "12" },
          { id: 3343, name: "Nouakchott-Nord", code: "14" },
          { id: 3352, name: "Nouakchott-Ouest", code: "13" },
          { id: 3347, name: "Nouakchott-Sud", code: "15" },
          { id: 3345, name: "Tagant", code: "09" },
          { id: 3340, name: "Tiris Zemmour", code: "11" },
          { id: 3348, name: "Trarza", code: "06" }
        ]
      },
      {
        code: "MUS",
        name: "Mauritius",
        states: [
          { id: 3248, name: "Agalega Islands", code: "AG" },
          { id: 3259, name: "Black River", code: "BL" },
          { id: 3254, name: "Flacq", code: "FL" },
          { id: 3264, name: "Grand Port", code: "GP" },
          { id: 3253, name: "Moka", code: "MO" },
          { id: 3250, name: "Pamplemousses", code: "PA" },
          { id: 3263, name: "Plaines Wilhems", code: "PW" },
          { id: 3260, name: "Port Louis", code: "PL" },
          { id: 3261, name: "Rivi\xE8re du Rempart", code: "RR" },
          { id: 3249, name: "Rodrigues Island", code: "RO" },
          { id: 3251, name: "Saint Brandon Islands", code: "CC" },
          { id: 3257, name: "Savanne", code: "SA" }
        ]
      },
      { code: "MYT", name: "Mayotte", states: [] },
      {
        code: "MEX",
        name: "Mexico",
        states: [
          { id: 3456, name: "Aguascalientes", code: "AGU" },
          { id: 3457, name: "Baja California", code: "BCN" },
          { id: 3460, name: "Baja California Sur", code: "BCS" },
          { id: 3475, name: "Campeche", code: "CAM" },
          { id: 3451, name: "Chiapas", code: "CHP" },
          { id: 3447, name: "Chihuahua", code: "CHH" },
          { id: 3473, name: "Ciudad de M\xE9xico", code: "CDMX" },
          { id: 3471, name: "Coahuila de Zaragoza", code: "COA" },
          { id: 3472, name: "Colima", code: "COL" },
          { id: 3453, name: "Durango", code: "DUR" },
          { id: 3450, name: "Estado de M\xE9xico", code: "MEX" },
          { id: 3469, name: "Guanajuato", code: "GUA" },
          { id: 3459, name: "Guerrero", code: "GRO" },
          { id: 3470, name: "Hidalgo", code: "HID" },
          { id: 4857, name: "Jalisco", code: "JAL" },
          { id: 3474, name: "Michoac\xE1n de Ocampo", code: "MIC" },
          { id: 3465, name: "Morelos", code: "MOR" },
          { id: 3477, name: "Nayarit", code: "NAY" },
          { id: 3452, name: "Nuevo Le\xF3n", code: "NLE" },
          { id: 3448, name: "Oaxaca", code: "OAX" },
          { id: 3476, name: "Puebla", code: "PUE" },
          { id: 3455, name: "Quer\xE9taro", code: "QUE" },
          { id: 3467, name: "Quintana Roo", code: "ROO" },
          { id: 3461, name: "San Luis Potos\xED", code: "SLP" },
          { id: 3449, name: "Sinaloa", code: "SIN" },
          { id: 3468, name: "Sonora", code: "SON" },
          { id: 3454, name: "Tabasco", code: "TAB" },
          { id: 3463, name: "Tamaulipas", code: "TAM" },
          { id: 3458, name: "Tlaxcala", code: "TLA" },
          { id: 3464, name: "Veracruz de Ignacio de la Llave", code: "VER" },
          { id: 3466, name: "Yucat\xE1n", code: "YUC" },
          { id: 3462, name: "Zacatecas", code: "ZAC" }
        ]
      },
      {
        code: "FSM",
        name: "Micronesia",
        states: [
          { id: 2580, name: "Chuuk State", code: "TRK" },
          { id: 2583, name: "Kosrae State", code: "KSA" },
          { id: 2581, name: "Pohnpei State", code: "PNI" },
          { id: 2582, name: "Yap State", code: "YAP" }
        ]
      },
      {
        code: "MDA",
        name: "Moldova",
        states: [
          { id: 4368, name: "Anenii Noi District", code: "AN" },
          { id: 4393, name: "B\u0103l\u021Bi Municipality", code: "BA" },
          { id: 4379, name: "Basarabeasca District", code: "BS" },
          { id: 4362, name: "Bender Municipality", code: "BD" },
          { id: 4375, name: "Briceni District", code: "BR" },
          { id: 4391, name: "Cahul District", code: "CA" },
          { id: 4366, name: "C\u0103l\u0103ra\u0219i District", code: "CL" },
          { id: 4380, name: "Cantemir District", code: "CT" },
          { id: 4365, name: "C\u0103u\u0219eni District", code: "CS" },
          { id: 4373, name: "Chi\u0219in\u0103u Municipality", code: "CU" },
          { id: 4360, name: "Cimi\u0219lia District", code: "CM" },
          { id: 4390, name: "Criuleni District", code: "CR" },
          { id: 4384, name: "Dondu\u0219eni District", code: "DO" },
          { id: 4392, name: "Drochia District", code: "DR" },
          { id: 4383, name: "Dub\u0103sari District", code: "DU" },
          { id: 4387, name: "Edine\u021B District", code: "ED" },
          { id: 4381, name: "F\u0103le\u0219ti District", code: "FA" },
          { id: 4370, name: "Flore\u0219ti District", code: "FL" },
          { id: 4385, name: "Gagauzia", code: "GA" },
          { id: 4367, name: "Glodeni District", code: "GL" },
          { id: 4382, name: "H\xEEnce\u0219ti District", code: "HI" },
          { id: 4369, name: "Ialoveni District", code: "IA" },
          { id: 4363, name: "Nisporeni District", code: "NI" },
          { id: 4389, name: "Ocni\u021Ba District", code: "OC" },
          { id: 4361, name: "Orhei District", code: "OR" },
          { id: 4394, name: "Rezina District", code: "RE" },
          { id: 4376, name: "R\xEE\u0219cani District", code: "RI" },
          { id: 4364, name: "S\xEEngerei District", code: "SI" },
          { id: 4388, name: "\u0218old\u0103ne\u0219ti District", code: "SD" },
          { id: 4374, name: "Soroca District", code: "SO" },
          { id: 4378, name: "\u0218tefan Vod\u0103 District", code: "SV" },
          { id: 4377, name: "Str\u0103\u0219eni District", code: "ST" },
          { id: 4372, name: "Taraclia District", code: "TA" },
          { id: 4371, name: "Telene\u0219ti District", code: "TE" },
          {
            id: 4395,
            name: "Transnistria autonomous territorial unit",
            code: "SN"
          },
          { id: 4386, name: "Ungheni District", code: "UN" }
        ]
      },
      {
        code: "MCO",
        name: "Monaco",
        states: [
          { id: 4917, name: "La Colle", code: "CL" },
          { id: 4918, name: "La Condamine", code: "CO" },
          { id: 4919, name: "Moneghetti", code: "MG" }
        ]
      },
      {
        code: "MNG",
        name: "Mongolia",
        states: [
          { id: 1973, name: "Arkhangai Province", code: "073" },
          { id: 1969, name: "Bayan-\xD6lgii Province", code: "071" },
          { id: 1976, name: "Bayankhongor Province", code: "069" },
          { id: 1961, name: "Bulgan Province", code: "067" },
          { id: 1962, name: "Darkhan-Uul Province", code: "037" },
          { id: 1963, name: "Dornod Province", code: "061" },
          { id: 1981, name: "Dornogovi Province", code: "063" },
          { id: 1970, name: "Dundgovi Province", code: "059" },
          { id: 1972, name: "Govi-Altai Province", code: "065" },
          { id: 1978, name: "Govis\xFCmber Province", code: "064" },
          { id: 1974, name: "Khentii Province", code: "039" },
          { id: 1964, name: "Khovd Province", code: "043" },
          { id: 1975, name: "Kh\xF6vsg\xF6l Province", code: "041" },
          { id: 1967, name: "\xD6mn\xF6govi Province", code: "053" },
          { id: 1966, name: "Orkhon Province", code: "035" },
          { id: 1965, name: "\xD6v\xF6rkhangai Province", code: "055" },
          { id: 1980, name: "Selenge Province", code: "049" },
          { id: 1977, name: "S\xFCkhbaatar Province", code: "051" },
          { id: 1968, name: "T\xF6v Province", code: "047" },
          { id: 1971, name: "Uvs Province", code: "046" },
          { id: 1979, name: "Zavkhan Province", code: "057" }
        ]
      },
      {
        code: "MNE",
        name: "Montenegro",
        states: [
          { id: 23, name: "Andrijevica Municipality", code: "01" },
          { id: 13, name: "Bar Municipality", code: "02" },
          { id: 21, name: "Berane Municipality", code: "03" },
          { id: 25, name: "Bijelo Polje Municipality", code: "04" },
          { id: 30, name: "Budva Municipality", code: "05" },
          { id: 14, name: "Danilovgrad Municipality", code: "07" },
          { id: 24, name: "Gusinje Municipality", code: "22" },
          { id: 31, name: "Kola\u0161in Municipality", code: "09" },
          { id: 26, name: "Kotor Municipality", code: "10" },
          { id: 22, name: "Mojkovac Municipality", code: "11" },
          { id: 17, name: "Nik\u0161i\u0107 Municipality", code: "12" },
          { id: 28, name: "Old Royal Capital Cetinje", code: "06" },
          { id: 12, name: "Petnjica Municipality", code: "23" },
          { id: 19, name: "Plav Municipality", code: "13" },
          { id: 20, name: "Pljevlja Municipality", code: "14" },
          { id: 16, name: "Plu\u017Eine Municipality", code: "15" },
          { id: 27, name: "Podgorica Municipality", code: "16" },
          { id: 15, name: "Ro\u017Eaje Municipality", code: "17" },
          { id: 18, name: "\u0160avnik Municipality", code: "18" },
          { id: 29, name: "Tivat Municipality", code: "19" },
          { id: 33, name: "Ulcinj Municipality", code: "20" },
          { id: 32, name: "\u017Dabljak Municipality", code: "21" }
        ]
      },
      { code: "MSR", name: "Montserrat", states: [] },
      {
        code: "MAR",
        name: "Morocco",
        states: [
          { id: 4928, name: "Agadir-Ida-Ou-Tanane", code: "AGD" },
          { id: 3320, name: "Al Haouz", code: "HAO" },
          { id: 3267, name: "Al Hoce\xEFma", code: "HOC" },
          { id: 3266, name: "Aousserd (EH)", code: "AOU" },
          { id: 3297, name: "Assa-Zag (EH-partial)", code: "ASZ" },
          { id: 3321, name: "Azilal", code: "AZI" },
          { id: 3272, name: "B\xE9ni Mellal", code: "BEM" },
          { id: 3278, name: "B\xE9ni Mellal-Kh\xE9nifra", code: "05" },
          { id: 3304, name: "Benslimane", code: "BES" },
          { id: 3285, name: "Berkane", code: "BER" },
          { id: 4929, name: "Berrechid", code: "BRR" },
          { id: 3275, name: "Boujdour (EH)", code: "BOD" },
          { id: 3270, name: "Boulemane", code: "BOM" },
          { id: 4930, name: "Casablanca", code: "CAS" },
          { id: 3303, name: "Casablanca-Settat", code: "06" },
          { id: 3310, name: "Chefchaouen", code: "CHE" },
          { id: 3274, name: "Chichaoua", code: "CHI" },
          { id: 3302, name: "Chtouka-Ait Baha", code: "CHT" },
          { id: 3306, name: "Dakhla-Oued Ed-Dahab (EH)", code: "12" },
          { id: 3290, name: "Dr\xE2a-Tafilalet", code: "08" },
          { id: 4931, name: "Driouch", code: "DRI" },
          { id: 3291, name: "El Hajeb", code: "HAJ" },
          { id: 3280, name: "El Jadida", code: "JDI" },
          { id: 3309, name: "El Kel\xE2a des Sraghna", code: "KES" },
          { id: 3299, name: "Errachidia", code: "ERR" },
          { id: 3292, name: "Es-Semara (EH-partial)", code: "ESM" },
          { id: 3316, name: "Essaouira", code: "ESI" },
          { id: 3300, name: "Fahs-Anjra", code: "FAH" },
          { id: 4932, name: "F\xE8s", code: "FES" },
          { id: 3313, name: "F\xE8s-Mekn\xE8s", code: "03" },
          { id: 3301, name: "Figuig", code: "FIG" },
          { id: 4933, name: "Fquih Ben Salah", code: "FQH" },
          { id: 3265, name: "Guelmim", code: "GUE" },
          { id: 3305, name: "Guelmim-Oued Noun (EH-partial)", code: "10" },
          { id: 4934, name: "Guercif", code: "GUF" },
          { id: 3325, name: "Ifrane", code: "IFR" },
          { id: 3294, name: "Inezgane-Ait Melloul", code: "INE" },
          { id: 3307, name: "Jerada", code: "JRA" },
          { id: 3308, name: "K\xE9nitra", code: "KEN" },
          { id: 3276, name: "Kh\xE9misset", code: "KHE" },
          { id: 3317, name: "Kh\xE9nifra", code: "KHN" },
          { id: 3326, name: "Khouribga", code: "KHO" },
          { id: 3271, name: "L'Oriental", code: "02" },
          { id: 3293, name: "La\xE2youne (EH)", code: "LAA" },
          {
            id: 3298,
            name: "La\xE2youne-Sakia El Hamra (EH-partial)",
            code: "11"
          },
          { id: 3268, name: "Larache", code: "LAR" },
          { id: 4936, name: "M\u2019diq-Fnideq", code: "MDF" },
          { id: 4935, name: "Marrakech", code: "MAR" },
          { id: 3288, name: "Marrakesh-Safi", code: "07" },
          { id: 3284, name: "M\xE9diouna", code: "MED" },
          { id: 4937, name: "Mekn\xE8s", code: "MEK" },
          { id: 4938, name: "Midelt", code: "MID" },
          { id: 4939, name: "Mohammadia", code: "MOH" },
          { id: 3315, name: "Moulay Yacoub", code: "MOU" },
          { id: 3281, name: "Nador", code: "NAD" },
          { id: 3287, name: "Nouaceur", code: "NOU" },
          { id: 3269, name: "Ouarzazate", code: "OUA" },
          { id: 3319, name: "Oued Ed-Dahab (EH)", code: "OUD" },
          { id: 4941, name: "Ouezzane", code: "OUZ" },
          { id: 4940, name: "Oujda-Angad", code: "OUJ" },
          { id: 4942, name: "Rabat", code: "RAB" },
          { id: 4927, name: "Rabat-Sal\xE9-K\xE9nitra", code: "04" },
          { id: 4943, name: "Rehamna", code: "REH" },
          { id: 3311, name: "Safi", code: "SAF" },
          { id: 4944, name: "Sal\xE9", code: "SAL" },
          { id: 3289, name: "Sefrou", code: "SEF" },
          { id: 3282, name: "Settat", code: "SET" },
          { id: 4945, name: "Sidi Bennour", code: "SIB" },
          { id: 4946, name: "Sidi Ifni", code: "SIF" },
          { id: 3279, name: "Sidi Kacem", code: "SIK" },
          { id: 4952, name: "Sidi Slimane", code: "SIL" },
          { id: 4947, name: "Skhirate-T\xE9mara", code: "SKH" },
          { id: 3295, name: "Souss-Massa", code: "09" },
          { id: 3286, name: "Tan-Tan (EH-partial)", code: "TNT" },
          { id: 4950, name: "Tanger-Assilah", code: "TNG" },
          { id: 3324, name: "Tanger-T\xE9touan-Al Hoce\xEFma", code: "01" },
          { id: 3323, name: "Taounate", code: "TAO" },
          { id: 3322, name: "Taourirt", code: "TAI" },
          { id: 4948, name: "Tarfaya (EH-partial)", code: "TAF" },
          { id: 3314, name: "Taroudannt", code: "TAR" },
          { id: 3312, name: "Tata", code: "TAT" },
          { id: 3296, name: "Taza", code: "TAZ" },
          { id: 3318, name: "T\xE9touan", code: "TET" },
          { id: 4949, name: "Tinghir", code: "TIN" },
          { id: 3277, name: "Tiznit", code: "TIZ" },
          { id: 4951, name: "Youssoufia", code: "YUS" },
          { id: 3283, name: "Zagora", code: "ZAG" }
        ]
      },
      {
        code: "MOZ",
        name: "Mozambique",
        states: [
          { id: 3327, name: "Cabo Delgado Province", code: "P" },
          { id: 3329, name: "Gaza Province", code: "G" },
          { id: 3330, name: "Inhambane Province", code: "I" },
          { id: 3337, name: "Manica Province", code: "B" },
          { id: 3335, name: "Maputo", code: "MPM" },
          { id: 3332, name: "Maputo Province", code: "L" },
          { id: 3336, name: "Nampula Province", code: "N" },
          { id: 3333, name: "Niassa Province", code: "A" },
          { id: 3331, name: "Sofala Province", code: "S" },
          { id: 3334, name: "Tete Province", code: "T" },
          { id: 3328, name: "Zambezia Province", code: "Q" }
        ]
      },
      {
        code: "MMR",
        name: "Myanmar",
        states: [
          { id: 2142, name: "Ayeyarwady Region", code: "07" },
          { id: 2141, name: "Bago", code: "02" },
          { id: 2137, name: "Chin State", code: "14" },
          { id: 2143, name: "Kachin State", code: "11" },
          { id: 2144, name: "Kayah State", code: "12" },
          { id: 2133, name: "Kayin State", code: "13" },
          { id: 2136, name: "Magway Region", code: "03" },
          { id: 2134, name: "Mandalay Region", code: "04" },
          { id: 2147, name: "Mon State", code: "15" },
          { id: 2146, name: "Naypyidaw Union Territory", code: "18" },
          { id: 2138, name: "Rakhine State", code: "16" },
          { id: 2145, name: "Sagaing Region", code: "01" },
          { id: 2139, name: "Shan State", code: "17" },
          { id: 2140, name: "Tanintharyi Region", code: "05" },
          { id: 2135, name: "Yangon Region", code: "06" }
        ]
      },
      {
        code: "NAM",
        name: "Namibia",
        states: [
          { id: 43, name: "Erongo Region", code: "ER" },
          { id: 38, name: "Hardap Region", code: "HA" },
          { id: 45, name: "Karas Region", code: "KA" },
          { id: 36, name: "Kavango East Region", code: "KE" },
          { id: 35, name: "Kavango West Region", code: "KW" },
          { id: 44, name: "Khomas Region", code: "KH" },
          { id: 34, name: "Kunene Region", code: "KU" },
          { id: 40, name: "Ohangwena Region", code: "OW" },
          { id: 41, name: "Omaheke Region", code: "OH" },
          { id: 39, name: "Omusati Region", code: "OS" },
          { id: 37, name: "Oshana Region", code: "ON" },
          { id: 42, name: "Oshikoto Region", code: "OT" },
          { id: 46, name: "Otjozondjupa Region", code: "OD" },
          { id: 47, name: "Zambezi Region", code: "CA" }
        ]
      },
      {
        code: "NRU",
        name: "Nauru",
        states: [
          { id: 4656, name: "Aiwo District", code: "01" },
          { id: 4658, name: "Anabar District", code: "02" },
          { id: 4667, name: "Anetan District", code: "03" },
          { id: 4663, name: "Anibare District", code: "04" },
          { id: 4660, name: "Baiti District", code: "05" },
          { id: 4665, name: "Boe District", code: "06" },
          { id: 4662, name: "Buada District", code: "07" },
          { id: 4666, name: "Denigomodu District", code: "08" },
          { id: 4654, name: "Ewa District", code: "09" },
          { id: 4661, name: "Ijuw District", code: "10" },
          { id: 4657, name: "Meneng District", code: "11" },
          { id: 4659, name: "Nibok District", code: "12" },
          { id: 4655, name: "Uaboe District", code: "13" },
          { id: 4664, name: "Yaren District", code: "14" }
        ]
      },
      {
        code: "NPL",
        name: "Nepal",
        states: [
          { id: 2082, name: "Bagmati Zone", code: "BA" },
          { id: 2071, name: "Bheri Zone", code: "BH" },
          { id: 2073, name: "Central Region", code: "1" },
          { id: 2080, name: "Dhaulagiri Zone", code: "DH" },
          { id: 2069, name: "Eastern Development Region", code: "4" },
          { id: 2068, name: "Far-Western Development Region", code: "5" },
          { id: 2081, name: "Gandaki Zone", code: "GA" },
          { id: 2076, name: "Janakpur Zone", code: "JA" },
          { id: 2079, name: "Karnali Zone", code: "KA" },
          { id: 2072, name: "Kosi Zone", code: "KO" },
          { id: 2074, name: "Lumbini Zone", code: "LU" },
          { id: 2083, name: "Mahakali Zone", code: "MA" },
          { id: 2070, name: "Mechi Zone", code: "ME" },
          { id: 2066, name: "Mid-Western Region", code: "2" },
          { id: 2075, name: "Narayani Zone", code: "NA" },
          { id: 2077, name: "Rapti Zone", code: "RA" },
          { id: 2084, name: "Sagarmatha Zone", code: "SA" },
          { id: 2078, name: "Seti Zone", code: "SE" },
          { id: 2067, name: "Western Region", code: "3" }
        ]
      },
      {
        code: "NLD",
        name: "Netherlands",
        states: [
          { id: 2624, name: "Bonaire", code: "BQ1" },
          { id: 2613, name: "Drenthe", code: "DR" },
          { id: 2619, name: "Flevoland", code: "FL" },
          { id: 2622, name: "Friesland", code: "FR" },
          { id: 2611, name: "Gelderland", code: "GE" },
          { id: 2617, name: "Groningen", code: "GR" },
          { id: 2615, name: "Limburg", code: "LI" },
          { id: 2623, name: "North Brabant", code: "NB" },
          { id: 2612, name: "North Holland", code: "NH" },
          { id: 2618, name: "Overijssel", code: "OV" },
          { id: 2621, name: "Saba", code: "BQ2" },
          { id: 2616, name: "Sint Eustatius", code: "BQ3" },
          { id: 2614, name: "South Holland", code: "ZH" },
          { id: 2610, name: "Utrecht", code: "UT" },
          { id: 2620, name: "Zeeland", code: "ZE" }
        ]
      },
      { code: "NCL", name: "New Caledonia", states: [] },
      {
        code: "NZL",
        name: "New Zealand",
        states: [
          { id: 4072, name: "Auckland Region", code: "AUK" },
          { id: 4074, name: "Bay of Plenty Region", code: "BOP" },
          { id: 4066, name: "Canterbury Region", code: "CAN" },
          { id: 4067, name: "Chatham Islands", code: "CIT" },
          { id: 4068, name: "Gisborne District", code: "GIS" },
          { id: 4075, name: "Hawke's Bay Region", code: "HKB" },
          { id: 4060, name: "Manawatu-Wanganui Region", code: "MWT" },
          { id: 4063, name: "Marlborough Region", code: "MBH" },
          { id: 4070, name: "Nelson Region", code: "NSN" },
          { id: 4059, name: "Northland Region", code: "NTL" },
          { id: 4062, name: "Otago Region", code: "OTA" },
          { id: 4071, name: "Southland Region", code: "STL" },
          { id: 4069, name: "Taranaki Region", code: "TKI" },
          { id: 4073, name: "Tasman District", code: "TAS" },
          { id: 4061, name: "Waikato Region", code: "WKO" },
          { id: 4065, name: "Wellington Region", code: "WGN" },
          { id: 4064, name: "West Coast Region", code: "WTC" }
        ]
      },
      {
        code: "NIC",
        name: "Nicaragua",
        states: [
          { id: 946, name: "Boaco", code: "BO" },
          { id: 950, name: "Carazo", code: "CA" },
          { id: 954, name: "Chinandega", code: "CI" },
          { id: 940, name: "Chontales", code: "CO" },
          { id: 945, name: "Estel\xED", code: "ES" },
          { id: 943, name: "Granada", code: "GR" },
          { id: 955, name: "Jinotega", code: "JI" },
          { id: 944, name: "Le\xF3n", code: "LE" },
          { id: 948, name: "Madriz", code: "MD" },
          { id: 941, name: "Managua", code: "MN" },
          { id: 953, name: "Masaya", code: "MS" },
          { id: 947, name: "Matagalpa", code: "MT" },
          { id: 951, name: "North Caribbean Coast", code: "AN" },
          { id: 4964, name: "Nueva Segovia", code: "NS" },
          { id: 949, name: "R\xEDo San Juan", code: "SJ" },
          { id: 942, name: "Rivas", code: "RI" },
          { id: 952, name: "South Caribbean Coast", code: "AS" }
        ]
      },
      {
        code: "NER",
        name: "Niger",
        states: [
          { id: 71, name: "Agadez Region", code: "1" },
          { id: 72, name: "Diffa Region", code: "2" },
          { id: 68, name: "Dosso Region", code: "3" },
          { id: 70, name: "Maradi Region", code: "4" },
          { id: 73, name: "Tahoua Region", code: "5" },
          { id: 67, name: "Tillab\xE9ri Region", code: "6" },
          { id: 69, name: "Zinder Region", code: "7" }
        ]
      },
      {
        code: "NGA",
        name: "Nigeria",
        states: [
          { id: 303, name: "Abia", code: "AB" },
          { id: 293, name: "Abuja Federal Capital Territory", code: "FC" },
          { id: 320, name: "Adamawa", code: "AD" },
          { id: 304, name: "Akwa Ibom", code: "AK" },
          { id: 315, name: "Anambra", code: "AN" },
          { id: 312, name: "Bauchi", code: "BA" },
          { id: 305, name: "Bayelsa", code: "BY" },
          { id: 291, name: "Benue", code: "BE" },
          { id: 307, name: "Borno", code: "BO" },
          { id: 314, name: "Cross River", code: "CR" },
          { id: 316, name: "Delta", code: "DE" },
          { id: 311, name: "Ebonyi", code: "EB" },
          { id: 318, name: "Edo", code: "ED" },
          { id: 309, name: "Ekiti", code: "EK" },
          { id: 289, name: "Enugu", code: "EN" },
          { id: 310, name: "Gombe", code: "GO" },
          { id: 308, name: "Imo", code: "IM" },
          { id: 288, name: "Jigawa", code: "JI" },
          { id: 294, name: "Kaduna", code: "KD" },
          { id: 300, name: "Kano", code: "KN" },
          { id: 313, name: "Katsina", code: "KT" },
          { id: 290, name: "Kebbi", code: "KE" },
          { id: 298, name: "Kogi", code: "KO" },
          { id: 295, name: "Kwara", code: "KW" },
          { id: 306, name: "Lagos", code: "LA" },
          { id: 301, name: "Nasarawa", code: "NA" },
          { id: 317, name: "Niger", code: "NI" },
          { id: 323, name: "Ogun", code: "OG" },
          { id: 321, name: "Ondo", code: "ON" },
          { id: 322, name: "Osun", code: "OS" },
          { id: 296, name: "Oyo", code: "OY" },
          { id: 302, name: "Plateau", code: "PL" },
          { id: 4926, name: "Rivers", code: "RI" },
          { id: 292, name: "Sokoto", code: "SO" },
          { id: 319, name: "Taraba", code: "TA" },
          { id: 297, name: "Yobe", code: "YO" },
          { id: 299, name: "Zamfara", code: "ZA" }
        ]
      },
      { code: "NIU", name: "Niue", states: [] },
      { code: "NFK", name: "Norfolk Island", states: [] },
      {
        code: "PRK",
        name: "North Korea",
        states: [
          { id: 3998, name: "Chagang Province", code: "04" },
          { id: 3999, name: "Kangwon Province", code: "07" },
          { id: 3995, name: "North Hamgyong Province", code: "09" },
          { id: 4004, name: "North Hwanghae Province", code: "06" },
          { id: 4002, name: "North Pyongan Province", code: "03" },
          { id: 4005, name: "Pyongyang", code: "01" },
          { id: 4001, name: "Rason", code: "13" },
          { id: 3996, name: "Ryanggang Province", code: "10" },
          { id: 4e3, name: "South Hamgyong Province", code: "08" },
          { id: 4003, name: "South Hwanghae Province", code: "05" },
          { id: 3997, name: "South Pyongan Province", code: "02" }
        ]
      },
      {
        code: "MKD",
        name: "North Macedonia",
        states: [
          { id: 703, name: "Aerodrom Municipality", code: "01" },
          { id: 656, name: "Ara\u010Dinovo Municipality", code: "02" },
          { id: 716, name: "Berovo Municipality", code: "03" },
          { id: 679, name: "Bitola Municipality", code: "04" },
          { id: 649, name: "Bogdanci Municipality", code: "05" },
          { id: 721, name: "Bogovinje Municipality", code: "06" },
          { id: 652, name: "Bosilovo Municipality", code: "07" },
          { id: 660, name: "Brvenica Municipality", code: "08" },
          { id: 694, name: "Butel Municipality", code: "09" },
          { id: 704, name: "\u010Cair Municipality", code: "79" },
          { id: 676, name: "\u010Ca\u0161ka Municipality", code: "80" },
          { id: 702, name: "Centar Municipality", code: "77" },
          { id: 720, name: "Centar \u017Dupa Municipality", code: "78" },
          { id: 644, name: "\u010Ce\u0161inovo-Oble\u0161evo Municipality", code: "81" },
          { id: 715, name: "\u010Cu\u010Der-Sandevo Municipality", code: "82" },
          { id: 645, name: "Debarca Municipality", code: "22" },
          { id: 695, name: "Del\u010Devo Municipality", code: "23" },
          { id: 687, name: "Demir Hisar Municipality", code: "25" },
          { id: 655, name: "Demir Kapija Municipality", code: "24" },
          { id: 697, name: "Dojran Municipality", code: "26" },
          { id: 675, name: "Dolneni Municipality", code: "27" },
          { id: 657, name: "Drugovo Municipality", code: "28" },
          { id: 707, name: "Gazi Baba Municipality", code: "17" },
          { id: 648, name: "Gevgelija Municipality", code: "18" },
          { id: 722, name: "Gjor\u010De Petrov Municipality", code: "29" },
          { id: 693, name: "Gostivar Municipality", code: "19" },
          { id: 708, name: "Gradsko Municipality", code: "20" },
          { id: 684, name: "Greater Skopje", code: "85" },
          { id: 690, name: "Ilinden Municipality", code: "34" },
          { id: 678, name: "Jegunovce Municipality", code: "35" },
          { id: 674, name: "Karbinci", code: "37" },
          { id: 681, name: "Karpo\u0161 Municipality", code: "38" },
          { id: 713, name: "Kavadarci Municipality", code: "36" },
          { id: 688, name: "Ki\u010Devo Municipality", code: "40" },
          { id: 686, name: "Kisela Voda Municipality", code: "39" },
          { id: 723, name: "Ko\u010Dani Municipality", code: "42" },
          { id: 665, name: "Kon\u010De Municipality", code: "41" },
          { id: 641, name: "Kratovo Municipality", code: "43" },
          { id: 677, name: "Kriva Palanka Municipality", code: "44" },
          { id: 647, name: "Krivoga\u0161tani Municipality", code: "45" },
          { id: 714, name: "Kru\u0161evo Municipality", code: "46" },
          { id: 683, name: "Kumanovo Municipality", code: "47" },
          { id: 659, name: "Lipkovo Municipality", code: "48" },
          { id: 705, name: "Lozovo Municipality", code: "49" },
          { id: 701, name: "Makedonska Kamenica Municipality", code: "51" },
          { id: 692, name: "Makedonski Brod Municipality", code: "52" },
          { id: 669, name: "Mavrovo and Rostu\u0161a Municipality", code: "50" },
          { id: 653, name: "Mogila Municipality", code: "53" },
          { id: 664, name: "Negotino Municipality", code: "54" },
          { id: 696, name: "Novaci Municipality", code: "55" },
          { id: 718, name: "Novo Selo Municipality", code: "56" },
          { id: 699, name: "Ohrid Municipality", code: "58" },
          { id: 682, name: "Oslomej Municipality", code: "57" },
          { id: 685, name: "Peh\u010Devo Municipality", code: "60" },
          { id: 698, name: "Petrovec Municipality", code: "59" },
          { id: 670, name: "Plasnica Municipality", code: "61" },
          { id: 666, name: "Prilep Municipality", code: "62" },
          { id: 646, name: "Probi\u0161tip Municipality", code: "63" },
          { id: 709, name: "Radovi\u0161 Municipality", code: "64" },
          { id: 717, name: "Rankovce Municipality", code: "65" },
          { id: 712, name: "Resen Municipality", code: "66" },
          { id: 691, name: "Rosoman Municipality", code: "67" },
          { id: 667, name: "Saraj Municipality", code: "68" },
          { id: 719, name: "Sopi\u0161te Municipality", code: "70" },
          { id: 643, name: "Staro Nagori\u010Dane Municipality", code: "71" },
          { id: 661, name: "\u0160tip Municipality", code: "83" },
          { id: 700, name: "Struga Municipality", code: "72" },
          { id: 710, name: "Strumica Municipality", code: "73" },
          { id: 711, name: "Studeni\u010Dani Municipality", code: "74" },
          { id: 680, name: "\u0160uto Orizari Municipality", code: "84" },
          { id: 640, name: "Sveti Nikole Municipality", code: "69" },
          { id: 654, name: "Tearce Municipality", code: "75" },
          { id: 663, name: "Tetovo Municipality", code: "76" },
          { id: 671, name: "Valandovo Municipality", code: "10" },
          { id: 658, name: "Vasilevo Municipality", code: "11" },
          { id: 651, name: "Veles Municipality", code: "13" },
          { id: 662, name: "Vev\u010Dani Municipality", code: "12" },
          { id: 672, name: "Vinica Municipality", code: "14" },
          { id: 650, name: "Vrane\u0161tica Municipality", code: "15" },
          { id: 689, name: "Vrap\u010Di\u0161te Municipality", code: "16" },
          { id: 642, name: "Zajas Municipality", code: "31" },
          { id: 706, name: "Zelenikovo Municipality", code: "32" },
          { id: 668, name: "\u017Delino Municipality", code: "30" },
          { id: 673, name: "Zrnovci Municipality", code: "33" }
        ]
      },
      { code: "MNP", name: "Northern Mariana Islands", states: [] },
      {
        code: "NOR",
        name: "Norway",
        states: [
          { id: 1014, name: "Agder", code: "42" },
          { id: 1009, name: "Innlandet", code: "34" },
          { id: 1026, name: "Jan Mayen", code: "22" },
          { id: 1020, name: "M\xF8re og Romsdal", code: "15" },
          { id: 1025, name: "Nordland", code: "18" },
          { id: 1007, name: "Oslo", code: "03" },
          { id: 1021, name: "Rogaland", code: "11" },
          { id: 1013, name: "Svalbard", code: "21" },
          { id: 1015, name: "Troms og Finnmark", code: "54" },
          { id: 1006, name: "Tr\xF8ndelag", code: "50" },
          { id: 1024, name: "Vestfold og Telemark", code: "38" },
          { id: 1018, name: "Vestland", code: "46" },
          { id: 1011, name: "Viken", code: "30" }
        ]
      },
      {
        code: "OMN",
        name: "Oman",
        states: [
          { id: 3058, name: "Ad Dakhiliyah", code: "DA" },
          { id: 3047, name: "Ad Dhahirah", code: "ZA" },
          { id: 3048, name: "Al Batinah North", code: "BS" },
          { id: 3050, name: "Al Batinah Region", code: "BA" },
          { id: 3049, name: "Al Batinah South", code: "BJ" },
          { id: 3059, name: "Al Buraimi", code: "BU" },
          { id: 3056, name: "Al Wusta", code: "WU" },
          { id: 3053, name: "Ash Sharqiyah North", code: "SS" },
          { id: 3051, name: "Ash Sharqiyah Region", code: "SH" },
          { id: 3054, name: "Ash Sharqiyah South", code: "SJ" },
          { id: 3057, name: "Dhofar", code: "ZU" },
          { id: 3052, name: "Musandam", code: "MU" },
          { id: 3055, name: "Muscat", code: "MA" }
        ]
      },
      {
        code: "PAK",
        name: "Pakistan",
        states: [
          { id: 3172, name: "Azad Kashmir", code: "JK" },
          { id: 3174, name: "Balochistan", code: "BA" },
          {
            id: 3173,
            name: "Federally Administered Tribal Areas",
            code: "TA"
          },
          { id: 3170, name: "Gilgit-Baltistan", code: "GB" },
          { id: 3169, name: "Islamabad Capital Territory", code: "IS" },
          { id: 3171, name: "Khyber Pakhtunkhwa", code: "KP" },
          { id: 3176, name: "Punjab", code: "PB" },
          { id: 3175, name: "Sindh", code: "SD" }
        ]
      },
      {
        code: "PLW",
        name: "Palau",
        states: [
          { id: 4540, name: "Aimeliik", code: "002" },
          { id: 4528, name: "Airai", code: "004" },
          { id: 4538, name: "Angaur", code: "010" },
          { id: 4529, name: "Hatohobei", code: "050" },
          { id: 4539, name: "Kayangel", code: "100" },
          { id: 4532, name: "Koror", code: "150" },
          { id: 4530, name: "Melekeok", code: "212" },
          { id: 4537, name: "Ngaraard", code: "214" },
          { id: 4533, name: "Ngarchelong", code: "218" },
          { id: 4527, name: "Ngardmau", code: "222" },
          { id: 4531, name: "Ngatpang", code: "224" },
          { id: 4536, name: "Ngchesar", code: "226" },
          { id: 4541, name: "Ngeremlengui", code: "227" },
          { id: 4534, name: "Ngiwal", code: "228" },
          { id: 4526, name: "Peleliu", code: "350" },
          { id: 4535, name: "Sonsorol", code: "370" }
        ]
      },
      {
        code: "PSE",
        name: "Palestinian Territory Occupied",
        states: [
          { id: 5118, name: "Bethlehem", code: "BTH" },
          { id: 5119, name: "Deir El Balah", code: "DEB" },
          { id: 5120, name: "Gaza", code: "GZA" },
          { id: 5121, name: "Hebron", code: "HBN" },
          { id: 5122, name: "Jenin", code: "JEN" },
          { id: 5123, name: "Jericho and Al Aghwar", code: "JRH" },
          { id: 5124, name: "Jerusalem", code: "JEM" },
          { id: 5125, name: "Khan Yunis", code: "KYS" },
          { id: 5126, name: "Nablus", code: "NBS" },
          { id: 5127, name: "North Gaza", code: "NGZ" },
          { id: 5128, name: "Qalqilya", code: "QQA" },
          { id: 5129, name: "Rafah", code: "RFH" },
          { id: 5130, name: "Ramallah", code: "RBH" },
          { id: 5131, name: "Salfit", code: "SLT" },
          { id: 5132, name: "Tubas", code: "TBS" },
          { id: 5133, name: "Tulkarm", code: "TKM" }
        ]
      },
      {
        code: "PAN",
        name: "Panama",
        states: [
          { id: 1393, name: "Bocas del Toro Province", code: "1" },
          { id: 1397, name: "Chiriqu\xED Province", code: "4" },
          { id: 1387, name: "Cocl\xE9 Province", code: "2" },
          { id: 1386, name: "Col\xF3n Province", code: "3" },
          { id: 1385, name: "Dari\xE9n Province", code: "5" },
          { id: 1396, name: "Ember\xE1-Wounaan Comarca", code: "EM" },
          { id: 1388, name: "Guna Yala", code: "KY" },
          { id: 1389, name: "Herrera Province", code: "6" },
          { id: 1390, name: "Los Santos Province", code: "7" },
          { id: 1391, name: "Ng\xF6be-Bugl\xE9 Comarca", code: "NB" },
          { id: 1394, name: "Panam\xE1 Oeste Province", code: "10" },
          { id: 1395, name: "Panam\xE1 Province", code: "8" },
          { id: 1392, name: "Veraguas Province", code: "9" }
        ]
      },
      {
        code: "PNG",
        name: "Papua new Guinea",
        states: [
          { id: 4831, name: "Bougainville", code: "NSB" },
          { id: 4847, name: "Central Province", code: "CPM" },
          { id: 4846, name: "Chimbu Province", code: "CPK" },
          { id: 4834, name: "East New Britain", code: "EBR" },
          { id: 4845, name: "Eastern Highlands Province", code: "EHG" },
          { id: 4848, name: "Enga Province", code: "EPW" },
          { id: 4839, name: "Gulf", code: "GPK" },
          { id: 4833, name: "Hela", code: "HLA" },
          { id: 4832, name: "Jiwaka Province", code: "JWK" },
          { id: 4843, name: "Madang Province", code: "MPM" },
          { id: 4842, name: "Manus Province", code: "MRL" },
          { id: 4849, name: "Milne Bay Province", code: "MBA" },
          { id: 4835, name: "Morobe Province", code: "MPL" },
          { id: 4841, name: "New Ireland Province", code: "NIK" },
          { id: 4838, name: "Oro Province", code: "NPP" },
          { id: 4837, name: "Port Moresby", code: "NCD" },
          { id: 4836, name: "Sandaun Province", code: "SAN" },
          { id: 4844, name: "Southern Highlands Province", code: "SHM" },
          { id: 4830, name: "West New Britain Province", code: "WBK" },
          { id: 4840, name: "Western Highlands Province", code: "WHM" },
          { id: 4850, name: "Western Province", code: "WPD" }
        ]
      },
      {
        code: "PRY",
        name: "Paraguay",
        states: [
          { id: 2785, name: "Alto Paraguay Department", code: "16" },
          { id: 2784, name: "Alto Paran\xE1 Department", code: "10" },
          { id: 2782, name: "Amambay Department", code: "13" },
          { id: 5221, name: "Asuncion", code: "ASU" },
          { id: 2780, name: "Boquer\xF3n Department", code: "19" },
          { id: 2773, name: "Caaguaz\xFA", code: "5" },
          { id: 2775, name: "Caazap\xE1", code: "6" },
          { id: 2771, name: "Canindey\xFA", code: "14" },
          { id: 2777, name: "Central Department", code: "11" },
          { id: 2779, name: "Concepci\xF3n Department", code: "1" },
          { id: 2783, name: "Cordillera Department", code: "3" },
          { id: 2772, name: "Guair\xE1 Department", code: "4" },
          { id: 2778, name: "Itap\xFAa", code: "7" },
          { id: 2786, name: "Misiones Department", code: "8" },
          { id: 2781, name: "\xD1eembuc\xFA Department", code: "12" },
          { id: 2774, name: "Paraguar\xED Department", code: "9" },
          { id: 2770, name: "Presidente Hayes Department", code: "15" },
          { id: 2776, name: "San Pedro Department", code: "2" }
        ]
      },
      {
        code: "PER",
        name: "Peru",
        states: [
          { id: 3685, name: "Amazonas", code: "AMA" },
          { id: 3680, name: "\xC1ncash", code: "ANC" },
          { id: 3699, name: "Apur\xEDmac", code: "APU" },
          { id: 3681, name: "Arequipa", code: "ARE" },
          { id: 3692, name: "Ayacucho", code: "AYA" },
          { id: 3688, name: "Cajamarca", code: "CAJ" },
          { id: 3701, name: "Callao", code: "CAL" },
          { id: 3691, name: "Cusco", code: "CUS" },
          { id: 3679, name: "Huancavelica", code: "HUV" },
          { id: 3687, name: "Huanuco", code: "HUC" },
          { id: 3700, name: "Ica", code: "ICA" },
          { id: 3693, name: "Jun\xEDn", code: "JUN" },
          { id: 3683, name: "La Libertad", code: "LAL" },
          { id: 3702, name: "Lambayeque", code: "LAM" },
          { id: 3695, name: "Lima", code: "LIM" },
          { id: 4922, name: "Loreto", code: "LOR" },
          { id: 3678, name: "Madre de Dios", code: "MDD" },
          { id: 3698, name: "Moquegua", code: "MOQ" },
          { id: 3686, name: "Pasco", code: "PAS" },
          { id: 3697, name: "Piura", code: "PIU" },
          { id: 3682, name: "Puno", code: "PUN" },
          { id: 3694, name: "San Mart\xEDn", code: "SAM" },
          { id: 3696, name: "Tacna", code: "TAC" },
          { id: 3689, name: "Tumbes", code: "TUM" },
          { id: 3684, name: "Ucayali", code: "UCA" }
        ]
      },
      {
        code: "PHL",
        name: "Philippines",
        states: [
          { id: 1324, name: "Abra", code: "ABR" },
          { id: 1323, name: "Agusan del Norte", code: "AGN" },
          { id: 1326, name: "Agusan del Sur", code: "AGS" },
          { id: 1331, name: "Aklan", code: "AKL" },
          { id: 1337, name: "Albay", code: "ALB" },
          { id: 1336, name: "Antique", code: "ANT" },
          { id: 1334, name: "Apayao", code: "APA" },
          { id: 1341, name: "Aurora", code: "AUR" },
          {
            id: 1316,
            name: "Autonomous Region in Muslim Mindanao",
            code: "14"
          },
          { id: 1346, name: "Basilan", code: "BAS" },
          { id: 1344, name: "Bataan", code: "BAN" },
          { id: 1352, name: "Batanes", code: "BTN" },
          { id: 1359, name: "Batangas", code: "BTG" },
          { id: 1363, name: "Benguet", code: "BEN" },
          { id: 1304, name: "Bicol", code: "05" },
          { id: 1274, name: "Biliran", code: "BIL" },
          { id: 1272, name: "Bohol", code: "BOH" },
          { id: 1270, name: "Bukidnon", code: "BUK" },
          { id: 1278, name: "Bulacan", code: "BUL" },
          { id: 1279, name: "Cagayan", code: "CAG" },
          { id: 1342, name: "Cagayan Valley", code: "02" },
          { id: 1294, name: "Calabarzon", code: "40" },
          { id: 1283, name: "Camarines Norte", code: "CAN" },
          { id: 1287, name: "Camarines Sur", code: "CAS" },
          { id: 1285, name: "Camiguin", code: "CAM" },
          { id: 1292, name: "Capiz", code: "CAP" },
          { id: 1314, name: "Caraga", code: "13" },
          { id: 1301, name: "Catanduanes", code: "CAT" },
          { id: 1307, name: "Cavite", code: "CAV" },
          { id: 1306, name: "Cebu", code: "CEB" },
          { id: 1345, name: "Central Luzon", code: "03" },
          { id: 1308, name: "Central Visayas", code: "07" },
          { id: 1311, name: "Compostela Valley", code: "COM" },
          { id: 1335, name: "Cordillera Administrative", code: "15" },
          { id: 1320, name: "Cotabato", code: "NCO" },
          { id: 1340, name: "Davao", code: "11" },
          { id: 1319, name: "Davao del Norte", code: "DAV" },
          { id: 1318, name: "Davao del Sur", code: "DAS" },
          { id: 1309, name: "Davao Occidental", code: "DVO" },
          { id: 1289, name: "Davao Oriental", code: "DAO" },
          { id: 1291, name: "Dinagat Islands", code: "DIN" },
          { id: 1290, name: "Eastern Samar", code: "EAS" },
          { id: 1322, name: "Eastern Visayas", code: "08" },
          { id: 1303, name: "Guimaras", code: "GUI" },
          { id: 1300, name: "Ifugao", code: "IFU" },
          { id: 1355, name: "Ilocos", code: "01" },
          { id: 1298, name: "Ilocos Norte", code: "ILN" },
          { id: 1321, name: "Ilocos Sur", code: "ILS" },
          { id: 1315, name: "Iloilo", code: "ILI" },
          { id: 1313, name: "Isabela", code: "ISA" },
          { id: 1312, name: "Kalinga", code: "KAL" },
          { id: 1317, name: "La Union", code: "LUN" },
          { id: 1328, name: "Laguna", code: "LAG" },
          { id: 1327, name: "Lanao del Norte", code: "LAN" },
          { id: 1333, name: "Lanao del Sur", code: "LAS" },
          { id: 1332, name: "Leyte", code: "LEY" },
          { id: 1330, name: "Maguindanao", code: "MAG" },
          { id: 1329, name: "Marinduque", code: "MAD" },
          { id: 1338, name: "Masbate", code: "MAS" },
          { id: 1347, name: "Metro Manila", code: "NCR" },
          { id: 1299, name: "Mimaropa", code: "41" },
          { id: 1343, name: "Misamis Occidental", code: "MSC" },
          { id: 1348, name: "Misamis Oriental", code: "MSR" },
          { id: 1353, name: "Mountain Province", code: "MOU" },
          { id: 1351, name: "Negros Occidental", code: "NEC" },
          { id: 1350, name: "Negros Oriental", code: "NER" },
          { id: 1339, name: "Northern Mindanao", code: "10" },
          { id: 1349, name: "Northern Samar", code: "NSA" },
          { id: 1360, name: "Nueva Ecija", code: "NUE" },
          { id: 1358, name: "Nueva Vizcaya", code: "NUV" },
          { id: 1356, name: "Occidental Mindoro", code: "MDC" },
          { id: 1354, name: "Oriental Mindoro", code: "MDR" },
          { id: 1361, name: "Palawan", code: "PLW" },
          { id: 1365, name: "Pampanga", code: "PAM" },
          { id: 1364, name: "Pangasinan", code: "PAN" },
          { id: 1275, name: "Quezon", code: "QUE" },
          { id: 1273, name: "Quirino", code: "QUI" },
          { id: 1271, name: "Rizal", code: "RIZ" },
          { id: 1269, name: "Romblon", code: "ROM" },
          { id: 1277, name: "Sarangani", code: "SAR" },
          { id: 1276, name: "Siquijor", code: "SIG" },
          { id: 1310, name: "Soccsksargen", code: "12" },
          { id: 1281, name: "Sorsogon", code: "SOR" },
          { id: 1280, name: "South Cotabato", code: "SCO" },
          { id: 1284, name: "Southern Leyte", code: "SLE" },
          { id: 1282, name: "Sultan Kudarat", code: "SUK" },
          { id: 1288, name: "Sulu", code: "SLU" },
          { id: 1286, name: "Surigao del Norte", code: "SUN" },
          { id: 1296, name: "Surigao del Sur", code: "SUR" },
          { id: 1295, name: "Tarlac", code: "TAR" },
          { id: 1293, name: "Tawi-Tawi", code: "TAW" },
          { id: 5115, name: "Western Samar", code: "WSA" },
          { id: 1305, name: "Western Visayas", code: "06" },
          { id: 1297, name: "Zambales", code: "ZMB" },
          { id: 1302, name: "Zamboanga del Norte", code: "ZAN" },
          { id: 1357, name: "Zamboanga del Sur", code: "ZAS" },
          { id: 1325, name: "Zamboanga Peninsula", code: "09" },
          { id: 1362, name: "Zamboanga Sibugay", code: "ZSI" }
        ]
      },
      { code: "PCN", name: "Pitcairn Island", states: [] },
      {
        code: "POL",
        name: "Poland",
        states: [
          { id: 1634, name: "Greater Poland Voivodeship", code: "WP" },
          { id: 1625, name: "Kuyavian-Pomeranian Voivodeship", code: "KP" },
          { id: 1635, name: "Lesser Poland Voivodeship", code: "MA" },
          { id: 1629, name: "Lower Silesian Voivodeship", code: "DS" },
          { id: 1638, name: "Lublin Voivodeship", code: "LU" },
          { id: 1631, name: "Lubusz Voivodeship", code: "LB" },
          { id: 1636, name: "\u0141\xF3d\u017A Voivodeship", code: "LD" },
          { id: 1637, name: "Masovian Voivodeship", code: "MZ" },
          { id: 1622, name: "Opole Voivodeship", code: "OP" },
          { id: 1626, name: "Podkarpackie Voivodeship", code: "PK" },
          { id: 1632, name: "Podlaskie Voivodeship", code: "PD" },
          { id: 1624, name: "Pomeranian Voivodeship", code: "PM" },
          { id: 1623, name: "Silesian Voivodeship", code: "SL" },
          { id: 1630, name: "\u015Awi\u0119tokrzyskie Voivodeship", code: "SK" },
          { id: 1628, name: "Warmian-Masurian Voivodeship", code: "WN" },
          { id: 1633, name: "West Pomeranian Voivodeship", code: "ZP" }
        ]
      },
      {
        code: "PRT",
        name: "Portugal",
        states: [
          { id: 2233, name: "A\xE7ores", code: "20" },
          { id: 2235, name: "Aveiro", code: "01" },
          { id: 2230, name: "Beja", code: "02" },
          { id: 2244, name: "Braga", code: "03" },
          { id: 2229, name: "Bragan\xE7a", code: "04" },
          { id: 2241, name: "Castelo Branco", code: "05" },
          { id: 2246, name: "Coimbra", code: "06" },
          { id: 2236, name: "\xC9vora", code: "07" },
          { id: 2239, name: "Faro", code: "08" },
          { id: 4859, name: "Guarda", code: "09" },
          { id: 2240, name: "Leiria", code: "10" },
          { id: 2228, name: "Lisbon", code: "11" },
          { id: 2231, name: "Madeira", code: "30" },
          { id: 2232, name: "Portalegre", code: "12" },
          { id: 2243, name: "Porto", code: "13" },
          { id: 2238, name: "Santar\xE9m", code: "14" },
          { id: 2242, name: "Set\xFAbal", code: "15" },
          { id: 2245, name: "Viana do Castelo", code: "16" },
          { id: 2234, name: "Vila Real", code: "17" },
          { id: 2237, name: "Viseu", code: "18" }
        ]
      },
      {
        code: "PRI",
        name: "Puerto Rico",
        states: [
          { id: 5134, name: "Adjuntas", code: "001" },
          { id: 5135, name: "Aguada", code: "003" },
          { id: 5136, name: "Aguadilla", code: "005" },
          { id: 5137, name: "Aguas Buenas", code: "007" },
          { id: 5138, name: "Aibonito", code: "009" },
          { id: 5139, name: "A\xF1asco", code: "011" },
          { id: 5140, name: "Arecibo", code: "013" },
          { id: 5081, name: "Arecibo", code: "AR" },
          { id: 5141, name: "Arroyo", code: "015" },
          { id: 5142, name: "Barceloneta", code: "017" },
          { id: 5143, name: "Barranquitas", code: "019" },
          { id: 5076, name: "Bayamon", code: "BY" },
          { id: 5144, name: "Bayam\xF3n", code: "021" },
          { id: 5145, name: "Cabo Rojo", code: "023" },
          { id: 5079, name: "Caguas", code: "CG" },
          { id: 5146, name: "Caguas", code: "025" },
          { id: 5147, name: "Camuy", code: "027" },
          { id: 5148, name: "Can\xF3vanas", code: "029" },
          { id: 5077, name: "Carolina", code: "CL" },
          { id: 5149, name: "Carolina", code: "031" },
          { id: 5150, name: "Cata\xF1o", code: "033" },
          { id: 5151, name: "Cayey", code: "035" },
          { id: 5152, name: "Ceiba", code: "037" },
          { id: 5153, name: "Ciales", code: "039" },
          { id: 5154, name: "Cidra", code: "041" },
          { id: 5155, name: "Coamo", code: "043" },
          { id: 5156, name: "Comer\xEDo", code: "045" },
          { id: 5157, name: "Corozal", code: "047" },
          { id: 5158, name: "Culebra", code: "049" },
          { id: 5159, name: "Dorado", code: "051" },
          { id: 5160, name: "Fajardo", code: "053" },
          { id: 5161, name: "Florida", code: "054" },
          { id: 5162, name: "Gu\xE1nica", code: "055" },
          { id: 5163, name: "Guayama", code: "057" },
          { id: 5164, name: "Guayanilla", code: "059" },
          { id: 5080, name: "Guaynabo", code: "GN" },
          { id: 5165, name: "Guaynabo", code: "061" },
          { id: 5166, name: "Gurabo", code: "063" },
          { id: 5167, name: "Hatillo", code: "065" },
          { id: 5168, name: "Hormigueros", code: "067" },
          { id: 5169, name: "Humacao", code: "069" },
          { id: 5170, name: "Isabela", code: "071" },
          { id: 5171, name: "Jayuya", code: "073" },
          { id: 5172, name: "Juana D\xEDaz", code: "075" },
          { id: 5173, name: "Juncos", code: "077" },
          { id: 5174, name: "Lajas", code: "079" },
          { id: 5175, name: "Lares", code: "081" },
          { id: 5176, name: "Las Mar\xEDas", code: "083" },
          { id: 5177, name: "Las Piedras", code: "085" },
          { id: 5178, name: "Lo\xEDza", code: "087" },
          { id: 5179, name: "Luquillo", code: "089" },
          { id: 5180, name: "Manat\xED", code: "091" },
          { id: 5181, name: "Maricao", code: "093" },
          { id: 5182, name: "Maunabo", code: "095" },
          { id: 5083, name: "Mayag\xFCez", code: "MG" },
          { id: 5183, name: "Mayag\xFCez", code: "097" },
          { id: 5184, name: "Moca", code: "099" },
          { id: 5185, name: "Morovis", code: "101" },
          { id: 5186, name: "Naguabo", code: "103" },
          { id: 5187, name: "Naranjito", code: "105" },
          { id: 5188, name: "Orocovis", code: "107" },
          { id: 5189, name: "Patillas", code: "109" },
          { id: 5190, name: "Pe\xF1uelas", code: "111" },
          { id: 5078, name: "Ponce", code: "PO" },
          { id: 5191, name: "Ponce", code: "113" },
          { id: 5192, name: "Quebradillas", code: "115" },
          { id: 5193, name: "Rinc\xF3n", code: "117" },
          { id: 5194, name: "R\xEDo Grande", code: "119" },
          { id: 5195, name: "Sabana Grande", code: "121" },
          { id: 5196, name: "Salinas", code: "123" },
          { id: 5197, name: "San Germ\xE1n", code: "125" },
          { id: 5198, name: "San Juan", code: "127" },
          { id: 5075, name: "San Juan", code: "SJ" },
          { id: 5199, name: "San Lorenzo", code: "129" },
          { id: 5200, name: "San Sebasti\xE1n", code: "131" },
          { id: 5201, name: "Santa Isabel", code: "133" },
          { id: 5202, name: "Toa Alta", code: "135" },
          { id: 5082, name: "Toa Baja", code: "TB" },
          { id: 5203, name: "Toa Baja", code: "137" },
          { id: 5084, name: "Trujillo Alto", code: "TA" },
          { id: 5204, name: "Trujillo Alto", code: "139" },
          { id: 5205, name: "Utuado", code: "141" },
          { id: 5206, name: "Vega Alta", code: "143" },
          { id: 5207, name: "Vega Baja", code: "145" },
          { id: 5208, name: "Vieques", code: "147" },
          { id: 5209, name: "Villalba", code: "149" },
          { id: 5210, name: "Yabucoa", code: "151" },
          { id: 5211, name: "Yauco", code: "153" }
        ]
      },
      {
        code: "QAT",
        name: "Qatar",
        states: [
          { id: 3182, name: "Al Daayen", code: "ZA" },
          { id: 3183, name: "Al Khor", code: "KH" },
          { id: 3177, name: "Al Rayyan Municipality", code: "RA" },
          { id: 3179, name: "Al Wakrah", code: "WA" },
          { id: 3178, name: "Al-Shahaniya", code: "SH" },
          { id: 3181, name: "Doha", code: "DA" },
          { id: 3180, name: "Madinat ash Shamal", code: "MS" },
          { id: 3184, name: "Umm Salal Municipality", code: "US" }
        ]
      },
      { code: "REU", name: "Reunion", states: [] },
      {
        code: "ROU",
        name: "Romania",
        states: [
          { id: 4724, name: "Alba", code: "AB" },
          { id: 4739, name: "Arad County", code: "AR" },
          { id: 4722, name: "Arges", code: "AG" },
          { id: 4744, name: "Bac\u0103u County", code: "BC" },
          { id: 4723, name: "Bihor County", code: "BH" },
          { id: 4733, name: "Bistri\u021Ba-N\u0103s\u0103ud County", code: "BN" },
          { id: 4740, name: "Boto\u0219ani County", code: "BT" },
          { id: 4736, name: "Braila", code: "BR" },
          { id: 4759, name: "Bra\u0219ov County", code: "BV" },
          { id: 4730, name: "Bucharest", code: "B" },
          { id: 4756, name: "Buz\u0103u County", code: "BZ" },
          { id: 4732, name: "C\u0103l\u0103ra\u0219i County", code: "CL" },
          { id: 4753, name: "Cara\u0219-Severin County", code: "CS" },
          { id: 4734, name: "Cluj County", code: "CJ" },
          { id: 4737, name: "Constan\u021Ba County", code: "CT" },
          { id: 4754, name: "Covasna County", code: "CV" },
          { id: 4745, name: "D\xE2mbovi\u021Ba County", code: "DB" },
          { id: 4742, name: "Dolj County", code: "DJ" },
          { id: 4747, name: "Gala\u021Bi County", code: "GL" },
          { id: 4726, name: "Giurgiu County", code: "GR" },
          { id: 4750, name: "Gorj County", code: "GJ" },
          { id: 4749, name: "Harghita County", code: "HR" },
          { id: 4721, name: "Hunedoara County", code: "HD" },
          { id: 4743, name: "Ialomi\u021Ba County", code: "IL" },
          { id: 4735, name: "Ia\u0219i County", code: "IS" },
          { id: 4725, name: "Ilfov County", code: "IF" },
          { id: 4760, name: "Maramure\u0219 County", code: "MM" },
          { id: 4751, name: "Mehedin\u021Bi County", code: "MH" },
          { id: 4915, name: "Mure\u0219 County", code: "MS" },
          { id: 4731, name: "Neam\u021B County", code: "NT" },
          { id: 4738, name: "Olt County", code: "OT" },
          { id: 4729, name: "Prahova County", code: "PH" },
          { id: 4741, name: "S\u0103laj County", code: "SJ" },
          { id: 4746, name: "Satu Mare County", code: "SM" },
          { id: 4755, name: "Sibiu County", code: "SB" },
          { id: 4720, name: "Suceava County", code: "SV" },
          { id: 4728, name: "Teleorman County", code: "TR" },
          { id: 4748, name: "Timi\u0219 County", code: "TM" },
          { id: 4727, name: "Tulcea County", code: "TL" },
          { id: 4757, name: "V\xE2lcea County", code: "VL" },
          { id: 4752, name: "Vaslui County", code: "VS" },
          { id: 4758, name: "Vrancea County", code: "VN" }
        ]
      },
      {
        code: "RUS",
        name: "Russia",
        states: [
          { id: 1911, name: "Altai Krai", code: "ALT" },
          { id: 1876, name: "Altai Republic", code: "AL" },
          { id: 1858, name: "Amur Oblast", code: "AMU" },
          { id: 1849, name: "Arkhangelsk", code: "ARK" },
          { id: 1866, name: "Astrakhan Oblast", code: "AST" },
          { id: 1903, name: "Belgorod Oblast", code: "BEL" },
          { id: 1867, name: "Bryansk Oblast", code: "BRY" },
          { id: 1893, name: "Chechen Republic", code: "CE" },
          { id: 1845, name: "Chelyabinsk Oblast", code: "CHE" },
          { id: 1859, name: "Chukotka Autonomous Okrug", code: "CHU" },
          { id: 1914, name: "Chuvash Republic", code: "CU" },
          { id: 1880, name: "Irkutsk", code: "IRK" },
          { id: 1864, name: "Ivanovo Oblast", code: "IVA" },
          { id: 1835, name: "Jewish Autonomous Oblast", code: "YEV" },
          { id: 1892, name: "Kabardino-Balkar Republic", code: "KB" },
          { id: 1902, name: "Kaliningrad", code: "KGD" },
          { id: 1844, name: "Kaluga Oblast", code: "KLU" },
          { id: 1865, name: "Kamchatka Krai", code: "KAM" },
          { id: 1869, name: "Karachay-Cherkess Republic", code: "KC" },
          { id: 1897, name: "Kemerovo Oblast", code: "KEM" },
          { id: 1873, name: "Khabarovsk Krai", code: "KHA" },
          { id: 1838, name: "Khanty-Mansi Autonomous Okrug", code: "KHM" },
          { id: 1890, name: "Kirov Oblast", code: "KIR" },
          { id: 1899, name: "Komi Republic", code: "KO" },
          { id: 1910, name: "Kostroma Oblast", code: "KOS" },
          { id: 1891, name: "Krasnodar Krai", code: "KDA" },
          { id: 1840, name: "Krasnoyarsk Krai", code: "KYA" },
          { id: 1915, name: "Kurgan Oblast", code: "KGN" },
          { id: 1855, name: "Kursk Oblast", code: "KRS" },
          { id: 1896, name: "Leningrad Oblast", code: "LEN" },
          { id: 1889, name: "Lipetsk Oblast", code: "LIP" },
          { id: 1839, name: "Magadan Oblast", code: "MAG" },
          { id: 1870, name: "Mari El Republic", code: "ME" },
          { id: 1901, name: "Moscow", code: "MOW" },
          { id: 1882, name: "Moscow Oblast", code: "MOS" },
          { id: 1843, name: "Murmansk Oblast", code: "MUR" },
          { id: 1836, name: "Nenets Autonomous Okrug", code: "NEN" },
          { id: 1857, name: "Nizhny Novgorod Oblast", code: "NIZ" },
          { id: 1834, name: "Novgorod Oblast", code: "NGR" },
          { id: 1888, name: "Novosibirsk", code: "NVS" },
          { id: 1846, name: "Omsk Oblast", code: "OMS" },
          { id: 1886, name: "Orenburg Oblast", code: "ORE" },
          { id: 1908, name: "Oryol Oblast", code: "ORL" },
          { id: 1909, name: "Penza Oblast", code: "PNZ" },
          { id: 1871, name: "Perm Krai", code: "PER" },
          { id: 1833, name: "Primorsky Krai", code: "PRI" },
          { id: 1863, name: "Pskov Oblast", code: "PSK" },
          { id: 1852, name: "Republic of Adygea", code: "AD" },
          { id: 1854, name: "Republic of Bashkortostan", code: "BA" },
          { id: 1842, name: "Republic of Buryatia", code: "BU" },
          { id: 1850, name: "Republic of Dagestan", code: "DA" },
          { id: 1884, name: "Republic of Ingushetia", code: "IN" },
          { id: 1883, name: "Republic of Kalmykia", code: "KL" },
          { id: 1841, name: "Republic of Karelia", code: "KR" },
          { id: 1877, name: "Republic of Khakassia", code: "KK" },
          { id: 1898, name: "Republic of Mordovia", code: "MO" },
          { id: 1853, name: "Republic of North Ossetia-Alania", code: "SE" },
          { id: 1861, name: "Republic of Tatarstan", code: "TA" },
          { id: 1837, name: "Rostov Oblast", code: "ROS" },
          { id: 1905, name: "Ryazan Oblast", code: "RYA" },
          { id: 1879, name: "Saint Petersburg", code: "SPE" },
          { id: 1848, name: "Sakha Republic", code: "SA" },
          { id: 1875, name: "Sakhalin", code: "SAK" },
          { id: 1862, name: "Samara Oblast", code: "SAM" },
          { id: 1887, name: "Saratov Oblast", code: "SAR" },
          { id: 1912, name: "Sevastopol", code: "UA-40" },
          { id: 1885, name: "Smolensk Oblast", code: "SMO" },
          { id: 1868, name: "Stavropol Krai", code: "STA" },
          { id: 1894, name: "Sverdlovsk", code: "SVE" },
          { id: 1878, name: "Tambov Oblast", code: "TAM" },
          { id: 1872, name: "Tomsk Oblast", code: "TOM" },
          { id: 1895, name: "Tula Oblast", code: "TUL" },
          { id: 1900, name: "Tuva Republic", code: "TY" },
          { id: 1860, name: "Tver Oblast", code: "TVE" },
          { id: 1907, name: "Tyumen Oblast", code: "TYU" },
          { id: 1913, name: "Udmurt Republic", code: "UD" },
          { id: 1856, name: "Ulyanovsk Oblast", code: "ULY" },
          { id: 1881, name: "Vladimir Oblast", code: "VLA" },
          { id: 4916, name: "Volgograd Oblast", code: "VGG" },
          { id: 1874, name: "Vologda Oblast", code: "VLG" },
          { id: 1906, name: "Voronezh Oblast", code: "VOR" },
          { id: 1847, name: "Yamalo-Nenets Autonomous Okrug", code: "YAN" },
          { id: 1851, name: "Yaroslavl Oblast", code: "YAR" },
          { id: 1904, name: "Zabaykalsky Krai", code: "ZAB" }
        ]
      },
      {
        code: "RWA",
        name: "Rwanda",
        states: [
          { id: 261, name: "Eastern Province", code: "02" },
          { id: 262, name: "Kigali district", code: "01" },
          { id: 263, name: "Northern Province", code: "03" },
          { id: 259, name: "Southern Province", code: "05" },
          { id: 260, name: "Western Province", code: "04" }
        ]
      },
      { code: "SHN", name: "Saint Helena", states: [] },
      {
        code: "KNA",
        name: "Saint Kitts And Nevis",
        states: [
          { id: 3833, name: "Christ Church Nichola Town Parish", code: "01" },
          { id: 3832, name: "Nevis", code: "N" },
          { id: 3836, name: "Saint Anne Sandy Point Parish", code: "02" },
          { id: 3837, name: "Saint George Gingerland Parish", code: "04" },
          { id: 3835, name: "Saint James Windward Parish", code: "05" },
          { id: 3845, name: "Saint John Capisterre Parish", code: "06" },
          { id: 3840, name: "Saint John Figtree Parish", code: "07" },
          { id: 3841, name: "Saint Kitts", code: "K" },
          { id: 3844, name: "Saint Mary Cayon Parish", code: "08" },
          { id: 3834, name: "Saint Paul Capisterre Parish", code: "09" },
          { id: 3838, name: "Saint Paul Charlestown Parish", code: "10" },
          { id: 3831, name: "Saint Peter Basseterre Parish", code: "11" },
          { id: 3839, name: "Saint Thomas Lowland Parish", code: "12" },
          { id: 3842, name: "Saint Thomas Middle Island Parish", code: "13" },
          { id: 3843, name: "Trinity Palmetto Point Parish", code: "15" }
        ]
      },
      {
        code: "LCA",
        name: "Saint Lucia",
        states: [
          { id: 3757, name: "Anse la Raye Quarter", code: "01" },
          { id: 3761, name: "Canaries", code: "12" },
          { id: 3758, name: "Castries Quarter", code: "02" },
          { id: 3760, name: "Choiseul Quarter", code: "03" },
          { id: 3767, name: "Dauphin Quarter", code: "04" },
          { id: 3756, name: "Dennery Quarter", code: "05" },
          { id: 3766, name: "Gros Islet Quarter", code: "06" },
          { id: 3759, name: "Laborie Quarter", code: "07" },
          { id: 3762, name: "Micoud Quarter", code: "08" },
          { id: 3765, name: "Praslin Quarter", code: "09" },
          { id: 3764, name: "Soufri\xE8re Quarter", code: "10" },
          { id: 3763, name: "Vieux Fort Quarter", code: "11" }
        ]
      },
      { code: "SPM", name: "Saint Pierre and Miquelon", states: [] },
      {
        code: "VCT",
        name: "Saint Vincent And The Grenadines",
        states: [
          { id: 3389, name: "Charlotte Parish", code: "01" },
          { id: 3388, name: "Grenadines Parish", code: "06" },
          { id: 3386, name: "Saint Andrew Parish", code: "02" },
          { id: 3387, name: "Saint David Parish", code: "03" },
          { id: 3384, name: "Saint George Parish", code: "04" },
          { id: 3385, name: "Saint Patrick Parish", code: "05" }
        ]
      },
      { code: "BLM", name: "Saint-Barthelemy", states: [] },
      { code: "MAF", name: "Saint-Martin (French part)", states: [] },
      {
        code: "WSM",
        name: "Samoa",
        states: [
          { id: 4763, name: "A'ana", code: "AA" },
          { id: 4761, name: "Aiga-i-le-Tai", code: "AL" },
          { id: 4765, name: "Atua", code: "AT" },
          { id: 4764, name: "Fa'asaleleaga", code: "FA" },
          { id: 4769, name: "Gaga'emauga", code: "GE" },
          { id: 4771, name: "Gaga'ifomauga", code: "GI" },
          { id: 4767, name: "Palauli", code: "PA" },
          { id: 4762, name: "Satupa'itea", code: "SA" },
          { id: 4770, name: "Tuamasaga", code: "TU" },
          { id: 4768, name: "Va'a-o-Fonoti", code: "VF" },
          { id: 4766, name: "Vaisigano", code: "VS" }
        ]
      },
      {
        code: "SMR",
        name: "San Marino",
        states: [
          { id: 59, name: "Acquaviva", code: "01" },
          { id: 61, name: "Borgo Maggiore", code: "06" },
          { id: 60, name: "Chiesanuova", code: "02" },
          { id: 64, name: "Domagnano", code: "03" },
          { id: 62, name: "Faetano", code: "04" },
          { id: 66, name: "Fiorentino", code: "05" },
          { id: 63, name: "Montegiardino", code: "08" },
          { id: 58, name: "San Marino", code: "07" },
          { id: 65, name: "Serravalle", code: "09" }
        ]
      },
      {
        code: "STP",
        name: "Sao Tome and Principe",
        states: [
          { id: 270, name: "Pr\xEDncipe Province", code: "P" },
          { id: 271, name: "S\xE3o Tom\xE9 Province", code: "S" }
        ]
      },
      {
        code: "SAU",
        name: "Saudi Arabia",
        states: [
          { id: 2853, name: "'Asir", code: "14" },
          { id: 2859, name: "Al Bahah", code: "11" },
          { id: 2857, name: "Al Jawf", code: "12" },
          { id: 2851, name: "Al Madinah", code: "03" },
          { id: 2861, name: "Al-Qassim", code: "05" },
          { id: 2856, name: "Eastern Province", code: "04" },
          { id: 2855, name: "Ha'il", code: "06" },
          { id: 2858, name: "Jizan", code: "09" },
          { id: 2850, name: "Makkah", code: "02" },
          { id: 2860, name: "Najran", code: "10" },
          { id: 2854, name: "Northern Borders", code: "08" },
          { id: 2849, name: "Riyadh", code: "01" },
          { id: 2852, name: "Tabuk", code: "07" }
        ]
      },
      {
        code: "SEN",
        name: "Senegal",
        states: [
          { id: 473, name: "Dakar", code: "DK" },
          { id: 480, name: "Diourbel Region", code: "DB" },
          { id: 479, name: "Fatick", code: "FK" },
          { id: 475, name: "Kaffrine", code: "KA" },
          { id: 483, name: "Kaolack", code: "KL" },
          { id: 481, name: "K\xE9dougou", code: "KE" },
          { id: 474, name: "Kolda", code: "KD" },
          { id: 485, name: "Louga", code: "LG" },
          { id: 476, name: "Matam", code: "MT" },
          { id: 477, name: "Saint-Louis", code: "SL" },
          { id: 482, name: "S\xE9dhiou", code: "SE" },
          { id: 486, name: "Tambacounda Region", code: "TC" },
          { id: 484, name: "Thi\xE8s Region", code: "TH" },
          { id: 478, name: "Ziguinchor", code: "ZG" }
        ]
      },
      {
        code: "SRB",
        name: "Serbia",
        states: [
          { id: 3728, name: "Belgrade", code: "00" },
          { id: 3717, name: "Bor District", code: "14" },
          { id: 3732, name: "Brani\u010Devo District", code: "11" },
          { id: 3716, name: "Central Banat District", code: "02" },
          { id: 3715, name: "Jablanica District", code: "23" },
          { id: 3724, name: "Kolubara District", code: "09" },
          { id: 3719, name: "Ma\u010Dva District", code: "08" },
          { id: 3727, name: "Moravica District", code: "17" },
          { id: 3722, name: "Ni\u0161ava District", code: "20" },
          { id: 3714, name: "North Ba\u010Dka District", code: "01" },
          { id: 3736, name: "North Banat District", code: "03" },
          { id: 3721, name: "P\u010Dinja District", code: "24" },
          { id: 3712, name: "Pirot District", code: "22" },
          { id: 3741, name: "Podunavlje District", code: "10" },
          { id: 3737, name: "Pomoravlje District", code: "13" },
          { id: 3720, name: "Rasina District", code: "19" },
          { id: 3725, name: "Ra\u0161ka District", code: "18" },
          { id: 3711, name: "South Ba\u010Dka District", code: "06" },
          { id: 3713, name: "South Banat District", code: "04" },
          { id: 3740, name: "Srem District", code: "07" },
          { id: 3734, name: "\u0160umadija District", code: "12" },
          { id: 3718, name: "Toplica District", code: "21" },
          { id: 3733, name: "Vojvodina", code: "VO" },
          { id: 3726, name: "West Ba\u010Dka District", code: "05" },
          { id: 3731, name: "Zaje\u010Dar District", code: "15" },
          { id: 3729, name: "Zlatibor District", code: "16" }
        ]
      },
      {
        code: "SYC",
        name: "Seychelles",
        states: [
          { id: 513, name: "Anse Boileau", code: "02" },
          { id: 502, name: "Anse Royale", code: "05" },
          { id: 506, name: "Anse-aux-Pins", code: "01" },
          { id: 508, name: "Au Cap", code: "04" },
          { id: 497, name: "Baie Lazare", code: "06" },
          { id: 514, name: "Baie Sainte Anne", code: "07" },
          { id: 512, name: "Beau Vallon", code: "08" },
          { id: 515, name: "Bel Air", code: "09" },
          { id: 505, name: "Bel Ombre", code: "10" },
          { id: 517, name: "Cascade", code: "11" },
          { id: 503, name: "Glacis", code: "12" },
          { id: 500, name: "Grand'Anse Mah\xE9", code: "13" },
          { id: 504, name: "Grand'Anse Praslin", code: "14" },
          { id: 495, name: "La Digue", code: "15" },
          { id: 516, name: "La Rivi\xE8re Anglaise", code: "16" },
          { id: 499, name: "Les Mamelles", code: "24" },
          { id: 494, name: "Mont Buxton", code: "17" },
          { id: 498, name: "Mont Fleuri", code: "18" },
          { id: 511, name: "Plaisance", code: "19" },
          { id: 510, name: "Pointe La Rue", code: "20" },
          { id: 507, name: "Port Glaud", code: "21" },
          { id: 501, name: "Roche Caiman", code: "25" },
          { id: 496, name: "Saint Louis", code: "22" },
          { id: 509, name: "Takamaka", code: "23" }
        ]
      },
      {
        code: "SLE",
        name: "Sierra Leone",
        states: [
          { id: 914, name: "Eastern Province", code: "E" },
          { id: 911, name: "Northern Province", code: "N" },
          { id: 912, name: "Southern Province", code: "S" },
          { id: 913, name: "Western Area", code: "W" }
        ]
      },
      {
        code: "SGP",
        name: "Singapore",
        states: [
          { id: 4651, name: "Central Singapore", code: "01" },
          { id: 4649, name: "North East", code: "02" },
          { id: 4653, name: "North West", code: "03" },
          { id: 4650, name: "South East", code: "04" },
          { id: 4652, name: "South West", code: "05" }
        ]
      },
      { code: "SXM", name: "Sint Maarten (Dutch part)", states: [] },
      {
        code: "SVK",
        name: "Slovakia",
        states: [
          { id: 4352, name: "Bansk\xE1 Bystrica Region", code: "BC" },
          { id: 4356, name: "Bratislava Region", code: "BL" },
          { id: 4353, name: "Ko\u0161ice Region", code: "KI" },
          { id: 4357, name: "Nitra Region", code: "NI" },
          { id: 4354, name: "Pre\u0161ov Region", code: "PV" },
          { id: 4358, name: "Tren\u010D\xEDn Region", code: "TC" },
          { id: 4355, name: "Trnava Region", code: "TA" },
          { id: 4359, name: "\u017Dilina Region", code: "ZI" }
        ]
      },
      {
        code: "SVN",
        name: "Slovenia",
        states: [
          { id: 4183, name: "Ajdov\u0161\u010Dina Municipality", code: "001" },
          { id: 4326, name: "Ankaran Municipality", code: "213" },
          { id: 4301, name: "Beltinci Municipality", code: "002" },
          { id: 4166, name: "Benedikt Municipality", code: "148" },
          { id: 4179, name: "Bistrica ob Sotli Municipality", code: "149" },
          { id: 4202, name: "Bled Municipality", code: "003" },
          { id: 4278, name: "Bloke Municipality", code: "150" },
          { id: 4282, name: "Bohinj Municipality", code: "004" },
          { id: 4200, name: "Borovnica Municipality", code: "005" },
          { id: 4181, name: "Bovec Municipality", code: "006" },
          { id: 4141, name: "Braslov\u010De Municipality", code: "151" },
          { id: 4240, name: "Brda Municipality", code: "007" },
          { id: 4215, name: "Bre\u017Eice Municipality", code: "009" },
          { id: 4165, name: "Brezovica Municipality", code: "008" },
          { id: 4147, name: "Cankova Municipality", code: "152" },
          {
            id: 4310,
            name: "Cerklje na Gorenjskem Municipality",
            code: "012"
          },
          { id: 4162, name: "Cerknica Municipality", code: "013" },
          { id: 4178, name: "Cerkno Municipality", code: "014" },
          { id: 4176, name: "Cerkvenjak Municipality", code: "153" },
          { id: 4191, name: "City Municipality of Celje", code: "011" },
          { id: 4236, name: "City Municipality of Novo Mesto", code: "085" },
          { id: 4151, name: "\u010Cren\u0161ovci Municipality", code: "015" },
          { id: 4232, name: "\u010Crna na Koro\u0161kem Municipality", code: "016" },
          { id: 4291, name: "\u010Crnomelj Municipality", code: "017" },
          { id: 4304, name: "Destrnik Municipality", code: "018" },
          { id: 4167, name: "Diva\u010Da Municipality", code: "019" },
          { id: 4295, name: "Dobje Municipality", code: "154" },
          { id: 4216, name: "Dobrepolje Municipality", code: "020" },
          { id: 4252, name: "Dobrna Municipality", code: "155" },
          {
            id: 4308,
            name: "Dobrova\u2013Polhov Gradec Municipality",
            code: "021"
          },
          { id: 4189, name: "Dobrovnik Municipality", code: "156" },
          { id: 4173, name: "Dol pri Ljubljani Municipality", code: "022" },
          { id: 4281, name: "Dolenjske Toplice Municipality", code: "157" },
          { id: 4159, name: "Dom\u017Eale Municipality", code: "023" },
          { id: 4290, name: "Dornava Municipality", code: "024" },
          { id: 4345, name: "Dravograd Municipality", code: "025" },
          { id: 4213, name: "Duplek Municipality", code: "026" },
          { id: 4293, name: "Gorenja Vas\u2013Poljane Municipality", code: "027" },
          { id: 4210, name: "Gori\u0161nica Municipality", code: "028" },
          { id: 4284, name: "Gorje Municipality", code: "207" },
          { id: 4343, name: "Gornja Radgona Municipality", code: "029" },
          { id: 4339, name: "Gornji Grad Municipality", code: "030" },
          { id: 4271, name: "Gornji Petrovci Municipality", code: "031" },
          { id: 4217, name: "Grad Municipality", code: "158" },
          { id: 4336, name: "Grosuplje Municipality", code: "032" },
          { id: 4145, name: "Hajdina Municipality", code: "159" },
          { id: 4175, name: "Ho\u010De\u2013Slivnica Municipality", code: "160" },
          { id: 4327, name: "Hodo\u0161 Municipality", code: "161" },
          { id: 4193, name: "Horjul Municipality", code: "162" },
          { id: 4341, name: "Hrastnik Municipality", code: "034" },
          { id: 4321, name: "Hrpelje\u2013Kozina Municipality", code: "035" },
          { id: 4152, name: "Idrija Municipality", code: "036" },
          { id: 4286, name: "Ig Municipality", code: "037" },
          { id: 4305, name: "Ivan\u010Dna Gorica Municipality", code: "039" },
          { id: 4322, name: "Izola Municipality", code: "040" },
          { id: 4337, name: "Jesenice Municipality", code: "041" },
          { id: 4203, name: "Jezersko Municipality", code: "163" },
          { id: 4266, name: "Jur\u0161inci Municipality", code: "042" },
          { id: 4180, name: "Kamnik Municipality", code: "043" },
          { id: 4227, name: "Kanal ob So\u010Di Municipality", code: "044" },
          { id: 4150, name: "Kidri\u010Devo Municipality", code: "045" },
          { id: 4243, name: "Kobarid Municipality", code: "046" },
          { id: 4325, name: "Kobilje Municipality", code: "047" },
          { id: 4335, name: "Ko\u010Devje Municipality", code: "048" },
          { id: 4315, name: "Komen Municipality", code: "049" },
          { id: 4283, name: "Komenda Municipality", code: "164" },
          { id: 4319, name: "Koper City Municipality", code: "050" },
          {
            id: 4254,
            name: "Kostanjevica na Krki Municipality",
            code: "197"
          },
          { id: 4331, name: "Kostel Municipality", code: "165" },
          { id: 4186, name: "Kozje Municipality", code: "051" },
          { id: 4287, name: "Kranj City Municipality", code: "052" },
          { id: 4340, name: "Kranjska Gora Municipality", code: "053" },
          { id: 4238, name: "Kri\u017Eevci Municipality", code: "166" },
          { id: 4197, name: "Kungota", code: "055" },
          { id: 4211, name: "Kuzma Municipality", code: "056" },
          { id: 4338, name: "La\u0161ko Municipality", code: "057" },
          { id: 4142, name: "Lenart Municipality", code: "058" },
          { id: 4225, name: "Lendava Municipality", code: "059" },
          { id: 4347, name: "Litija Municipality", code: "060" },
          { id: 4270, name: "Ljubljana City Municipality", code: "061" },
          { id: 4294, name: "Ljubno Municipality", code: "062" },
          { id: 4351, name: "Ljutomer Municipality", code: "063" },
          { id: 4306, name: "Log\u2013Dragomer Municipality", code: "208" },
          { id: 4350, name: "Logatec Municipality", code: "064" },
          { id: 4174, name: "Lo\u0161ka Dolina Municipality", code: "065" },
          { id: 4158, name: "Lo\u0161ki Potok Municipality", code: "066" },
          { id: 4156, name: "Lovrenc na Pohorju Municipality", code: "167" },
          { id: 4219, name: "Lu\u010De Municipality", code: "067" },
          { id: 4302, name: "Lukovica Municipality", code: "068" },
          { id: 4157, name: "Maj\u0161perk Municipality", code: "069" },
          { id: 4224, name: "Makole Municipality", code: "198" },
          { id: 4242, name: "Maribor City Municipality", code: "070" },
          { id: 4244, name: "Markovci Municipality", code: "168" },
          { id: 4349, name: "Medvode Municipality", code: "071" },
          { id: 4348, name: "Menge\u0161 Municipality", code: "072" },
          { id: 4323, name: "Metlika Municipality", code: "073" },
          { id: 4265, name: "Me\u017Eica Municipality", code: "074" },
          {
            id: 4223,
            name: "Miklav\u017E na Dravskem Polju Municipality",
            code: "169"
          },
          { id: 4220, name: "Miren\u2013Kostanjevica Municipality", code: "075" },
          { id: 4298, name: "Mirna Municipality", code: "212" },
          { id: 4237, name: "Mirna Pe\u010D Municipality", code: "170" },
          { id: 4212, name: "Mislinja Municipality", code: "076" },
          { id: 4297, name: "Mokronog\u2013Trebelno Municipality", code: "199" },
          { id: 4168, name: "Morav\u010De Municipality", code: "077" },
          { id: 4218, name: "Moravske Toplice Municipality", code: "078" },
          { id: 4190, name: "Mozirje Municipality", code: "079" },
          { id: 4318, name: "Municipality of Apa\u010De", code: "195" },
          { id: 4309, name: "Municipality of Cirkulane", code: "196" },
          { id: 4344, name: "Municipality of Ilirska Bistrica", code: "038" },
          { id: 4314, name: "Municipality of Kr\u0161ko", code: "054" },
          { id: 4187, name: "Municipality of \u0160kofljica", code: "123" },
          { id: 4313, name: "Murska Sobota City Municipality", code: "080" },
          { id: 4208, name: "Muta Municipality", code: "081" },
          { id: 4177, name: "Naklo Municipality", code: "082" },
          { id: 4329, name: "Nazarje Municipality", code: "083" },
          { id: 4205, name: "Nova Gorica City Municipality", code: "084" },
          { id: 4320, name: "Odranci Municipality", code: "086" },
          { id: 4143, name: "Oplotnica", code: "171" },
          { id: 4221, name: "Ormo\u017E Municipality", code: "087" },
          { id: 4199, name: "Osilnica Municipality", code: "088" },
          { id: 4172, name: "Pesnica Municipality", code: "089" },
          { id: 4201, name: "Piran Municipality", code: "090" },
          { id: 4184, name: "Pivka Municipality", code: "091" },
          { id: 4146, name: "Pod\u010Detrtek Municipality", code: "092" },
          { id: 4161, name: "Podlehnik Municipality", code: "172" },
          { id: 4234, name: "Podvelka Municipality", code: "093" },
          { id: 4239, name: "Polj\u010Dane Municipality", code: "200" },
          { id: 4272, name: "Polzela Municipality", code: "173" },
          { id: 4330, name: "Postojna Municipality", code: "094" },
          { id: 4188, name: "Prebold Municipality", code: "174" },
          { id: 4303, name: "Preddvor Municipality", code: "095" },
          { id: 4274, name: "Prevalje Municipality", code: "175" },
          { id: 4228, name: "Ptuj City Municipality", code: "096" },
          { id: 4288, name: "Puconci Municipality", code: "097" },
          { id: 4204, name: "Ra\u010De\u2013Fram Municipality", code: "098" },
          { id: 4195, name: "Rade\u010De Municipality", code: "099" },
          { id: 4292, name: "Radenci Municipality", code: "100" },
          { id: 4275, name: "Radlje ob Dravi Municipality", code: "101" },
          { id: 4231, name: "Radovljica Municipality", code: "102" },
          { id: 4155, name: "Ravne na Koro\u0161kem Municipality", code: "103" },
          { id: 4206, name: "Razkri\u017Eje Municipality", code: "176" },
          { id: 4160, name: "Re\u010Dica ob Savinji Municipality", code: "209" },
          { id: 4253, name: "Ren\u010De\u2013Vogrsko Municipality", code: "201" },
          { id: 4235, name: "Ribnica Municipality", code: "104" },
          { id: 4207, name: "Ribnica na Pohorju Municipality", code: "177" },
          { id: 4233, name: "Roga\u0161ka Slatina Municipality", code: "106" },
          { id: 4264, name: "Roga\u0161ovci Municipality", code: "105" },
          { id: 4209, name: "Rogatec Municipality", code: "107" },
          { id: 4280, name: "Ru\u0161e Municipality", code: "108" },
          { id: 4222, name: "\u0160alovci Municipality", code: "033" },
          { id: 4230, name: "Selnica ob Dravi Municipality", code: "178" },
          { id: 4346, name: "Semi\u010D Municipality", code: "109" },
          { id: 4317, name: "\u0160empeter\u2013Vrtojba Municipality", code: "183" },
          { id: 4299, name: "\u0160en\u010Dur Municipality", code: "117" },
          { id: 4324, name: "\u0160entilj Municipality", code: "118" },
          { id: 4241, name: "\u0160entjernej Municipality", code: "119" },
          { id: 4171, name: "\u0160entjur Municipality", code: "120" },
          { id: 4311, name: "\u0160entrupert Municipality", code: "211" },
          { id: 4268, name: "Sevnica Municipality", code: "110" },
          { id: 4149, name: "Se\u017Eana Municipality", code: "111" },
          { id: 4170, name: "\u0160kocjan Municipality", code: "121" },
          { id: 4316, name: "\u0160kofja Loka Municipality", code: "122" },
          { id: 4169, name: "Slovenj Gradec City Municipality", code: "112" },
          { id: 4332, name: "Slovenska Bistrica Municipality", code: "113" },
          { id: 4198, name: "Slovenske Konjice Municipality", code: "114" },
          { id: 4285, name: "\u0160marje pri Jel\u0161ah Municipality", code: "124" },
          { id: 4289, name: "\u0160marje\u0161ke Toplice Municipality", code: "206" },
          { id: 4296, name: "\u0160martno ob Paki Municipality", code: "125" },
          { id: 4279, name: "\u0160martno pri Litiji Municipality", code: "194" },
          { id: 4277, name: "Sodra\u017Eica Municipality", code: "179" },
          { id: 4261, name: "Sol\u010Dava Municipality", code: "180" },
          { id: 4248, name: "\u0160o\u0161tanj Municipality", code: "126" },
          { id: 4263, name: "Sredi\u0161\u010De ob Dravi", code: "202" },
          { id: 4259, name: "Star\u0161e Municipality", code: "115" },
          { id: 4185, name: "\u0160tore Municipality", code: "127" },
          { id: 4333, name: "Stra\u017Ea Municipality", code: "203" },
          { id: 4164, name: "Sveta Ana Municipality", code: "181" },
          {
            id: 4260,
            name: "Sveta Trojica v Slovenskih Goricah Municipality",
            code: "204"
          },
          {
            id: 4229,
            name: "Sveti Andra\u017E v Slovenskih Goricah Municipality",
            code: "182"
          },
          {
            id: 4255,
            name: "Sveti Jurij ob \u0160\u010Davnici Municipality",
            code: "116"
          },
          {
            id: 4328,
            name: "Sveti Jurij v Slovenskih Goricah Municipality",
            code: "210"
          },
          { id: 4273, name: "Sveti Toma\u017E Municipality", code: "205" },
          { id: 4194, name: "Tabor Municipality", code: "184" },
          { id: 4312, name: "Ti\u0161ina Municipality", code: "010" },
          { id: 4247, name: "Tolmin Municipality", code: "128" },
          { id: 4246, name: "Trbovlje Municipality", code: "129" },
          { id: 4214, name: "Trebnje Municipality", code: "130" },
          { id: 4153, name: "Trnovska Vas Municipality", code: "185" },
          { id: 4250, name: "Tr\u017Ei\u010D Municipality", code: "131" },
          { id: 4334, name: "Trzin Municipality", code: "186" },
          { id: 4251, name: "Turni\u0161\u010De Municipality", code: "132" },
          { id: 4267, name: "Velika Polana Municipality", code: "187" },
          { id: 4144, name: "Velike La\u0161\u010De Municipality", code: "134" },
          { id: 4257, name: "Ver\u017Eej Municipality", code: "188" },
          { id: 4300, name: "Videm Municipality", code: "135" },
          { id: 4196, name: "Vipava Municipality", code: "136" },
          { id: 4148, name: "Vitanje Municipality", code: "137" },
          { id: 4154, name: "Vodice Municipality", code: "138" },
          { id: 4245, name: "Vojnik Municipality", code: "139" },
          { id: 4163, name: "Vransko Municipality", code: "189" },
          { id: 4262, name: "Vrhnika Municipality", code: "140" },
          { id: 4226, name: "Vuzenica Municipality", code: "141" },
          { id: 4269, name: "Zagorje ob Savi Municipality", code: "142" },
          { id: 4258, name: "\u017Dalec Municipality", code: "190" },
          { id: 4182, name: "Zavr\u010D Municipality", code: "143" },
          { id: 4256, name: "\u017Delezniki Municipality", code: "146" },
          { id: 4249, name: "\u017Detale Municipality", code: "191" },
          { id: 4192, name: "\u017Diri Municipality", code: "147" },
          { id: 4276, name: "\u017Dirovnica Municipality", code: "192" },
          { id: 4342, name: "Zre\u010De Municipality", code: "144" },
          { id: 4307, name: "\u017Du\u017Eemberk Municipality", code: "193" }
        ]
      },
      {
        code: "SLB",
        name: "Solomon Islands",
        states: [
          { id: 4784, name: "Central Province", code: "CE" },
          { id: 4781, name: "Choiseul Province", code: "CH" },
          { id: 4785, name: "Guadalcanal Province", code: "GU" },
          { id: 4778, name: "Honiara", code: "CT" },
          { id: 4780, name: "Isabel Province", code: "IS" },
          { id: 4782, name: "Makira-Ulawa Province", code: "MK" },
          { id: 4783, name: "Malaita Province", code: "ML" },
          { id: 4787, name: "Rennell and Bellona Province", code: "RB" },
          { id: 4779, name: "Temotu Province", code: "TE" },
          { id: 4786, name: "Western Province", code: "WE" }
        ]
      },
      {
        code: "SOM",
        name: "Somalia",
        states: [
          { id: 925, name: "Awdal Region", code: "AW" },
          { id: 917, name: "Bakool", code: "BK" },
          { id: 927, name: "Banaadir", code: "BN" },
          { id: 930, name: "Bari", code: "BR" },
          { id: 926, name: "Bay", code: "BY" },
          { id: 918, name: "Galguduud", code: "GA" },
          { id: 928, name: "Gedo", code: "GE" },
          { id: 915, name: "Hiran", code: "HI" },
          { id: 924, name: "Lower Juba", code: "JH" },
          { id: 921, name: "Lower Shebelle", code: "SH" },
          { id: 922, name: "Middle Juba", code: "JD" },
          { id: 923, name: "Middle Shebelle", code: "SD" },
          { id: 916, name: "Mudug", code: "MU" },
          { id: 920, name: "Nugal", code: "NU" },
          { id: 919, name: "Sanaag Region", code: "SA" },
          { id: 929, name: "Togdheer Region", code: "TO" }
        ]
      },
      {
        code: "ZAF",
        name: "South Africa",
        states: [
          { id: 938, name: "Eastern Cape", code: "EC" },
          { id: 932, name: "Free State", code: "FS" },
          { id: 936, name: "Gauteng", code: "GP" },
          { id: 935, name: "KwaZulu-Natal", code: "KZN" },
          { id: 933, name: "Limpopo", code: "LP" },
          { id: 937, name: "Mpumalanga", code: "MP" },
          { id: 934, name: "North West", code: "NW" },
          { id: 931, name: "Northern Cape", code: "NC" },
          { id: 939, name: "Western Cape", code: "WC" }
        ]
      },
      { code: "SGS", name: "South Georgia", states: [] },
      {
        code: "KOR",
        name: "South Korea",
        states: [
          { id: 3860, name: "Busan", code: "26" },
          { id: 3846, name: "Daegu", code: "27" },
          { id: 3850, name: "Daejeon", code: "30" },
          { id: 3862, name: "Gangwon Province", code: "42" },
          { id: 3858, name: "Gwangju", code: "29" },
          { id: 3847, name: "Gyeonggi Province", code: "41" },
          { id: 3848, name: "Incheon", code: "28" },
          { id: 3853, name: "Jeju", code: "49" },
          { id: 3854, name: "North Chungcheong Province", code: "43" },
          { id: 3855, name: "North Gyeongsang Province", code: "47" },
          { id: 3851, name: "North Jeolla Province", code: "45" },
          { id: 3861, name: "Sejong City", code: "50" },
          { id: 3849, name: "Seoul", code: "11" },
          { id: 3859, name: "South Chungcheong Province", code: "44" },
          { id: 3857, name: "South Gyeongsang Province", code: "48" },
          { id: 3856, name: "South Jeolla Province", code: "46" },
          { id: 3852, name: "Ulsan", code: "31" }
        ]
      },
      {
        code: "SSD",
        name: "South Sudan",
        states: [
          { id: 2092, name: "Central Equatoria", code: "EC" },
          { id: 2093, name: "Eastern Equatoria", code: "EE" },
          { id: 2094, name: "Jonglei State", code: "JG" },
          { id: 2090, name: "Lakes", code: "LK" },
          { id: 2088, name: "Northern Bahr el Ghazal", code: "BN" },
          { id: 2085, name: "Unity", code: "UY" },
          { id: 2086, name: "Upper Nile", code: "NU" },
          { id: 2087, name: "Warrap", code: "WR" },
          { id: 2091, name: "Western Bahr el Ghazal", code: "BW" },
          { id: 2089, name: "Western Equatoria", code: "EW" }
        ]
      },
      {
        code: "ESP",
        name: "Spain",
        states: [
          { id: 5089, name: "A Coru\xF1a", code: "C" },
          { id: 5109, name: "Albacete", code: "AB" },
          { id: 5108, name: "Alicante", code: "A" },
          { id: 5095, name: "Almeria", code: "AL" },
          { id: 5093, name: "Araba", code: "VI" },
          { id: 1160, name: "Asturias", code: "O" },
          { id: 1189, name: "\xC1vila", code: "AV" },
          { id: 5092, name: "Badajoz", code: "BA" },
          { id: 5102, name: "Barcelona", code: "B" },
          { id: 5094, name: "Bizkaia", code: "BI" },
          { id: 1146, name: "Burgos", code: "BU" },
          { id: 1190, name: "Caceres", code: "CC" },
          { id: 5096, name: "C\xE1diz", code: "CA" },
          { id: 1170, name: "Cantabria", code: "S" },
          { id: 5110, name: "Castell\xF3n", code: "CS" },
          { id: 5105, name: "Ciudad Real", code: "CR" },
          { id: 5097, name: "C\xF3rdoba", code: "CO" },
          { id: 5106, name: "Cuenca", code: "CU" },
          { id: 1191, name: "Gipuzkoa", code: "SS" },
          { id: 5103, name: "Girona", code: "GI" },
          { id: 5098, name: "Granada", code: "GR" },
          { id: 5107, name: "Guadalajara", code: "GU" },
          { id: 5099, name: "Huelva", code: "H" },
          { id: 1177, name: "Huesca", code: "HU" },
          { id: 1174, name: "Islas Baleares", code: "PM" },
          { id: 5100, name: "Ja\xE9n", code: "J" },
          { id: 1171, name: "La Rioja", code: "LO" },
          { id: 1185, name: "Las Palmas", code: "GC" },
          { id: 1200, name: "L\xE9on", code: "LE" },
          { id: 5104, name: "Lleida", code: "L" },
          { id: 5090, name: "Lugo", code: "LU" },
          { id: 1158, name: "Madrid", code: "M" },
          { id: 5101, name: "M\xE1laga", code: "MA" },
          { id: 1176, name: "Murcia", code: "MU" },
          { id: 1204, name: "Navarra", code: "NA" },
          { id: 5091, name: "Ourense", code: "OR" },
          { id: 1157, name: "Palencia", code: "P" },
          { id: 1167, name: "Pontevedra", code: "PO" },
          { id: 1147, name: "Salamanca", code: "SA" },
          { id: 5112, name: "Santa Cruz de Tenerife", code: "TF" },
          { id: 1192, name: "Segovia", code: "SG" },
          { id: 1193, name: "Sevilla", code: "SE" },
          { id: 1208, name: "Soria", code: "SO" },
          { id: 1203, name: "Tarragona", code: "T" },
          { id: 5111, name: "Teruel", code: "TE" },
          { id: 1205, name: "Toledo", code: "TO" },
          { id: 1175, name: "Valencia", code: "V" },
          { id: 1183, name: "Valladolid", code: "VA" },
          { id: 1161, name: "Zamora", code: "ZA" },
          { id: 5113, name: "Zaragoza", code: "Z" }
        ]
      },
      {
        code: "LKA",
        name: "Sri Lanka",
        states: [
          { id: 2799, name: "Ampara District", code: "52" },
          { id: 2816, name: "Anuradhapura District", code: "71" },
          { id: 2790, name: "Badulla District", code: "81" },
          { id: 2818, name: "Batticaloa District", code: "51" },
          { id: 2798, name: "Central Province", code: "2" },
          { id: 2815, name: "Colombo District", code: "11" },
          { id: 2808, name: "Eastern Province", code: "5" },
          { id: 2792, name: "Galle District", code: "31" },
          { id: 2804, name: "Gampaha District", code: "12" },
          { id: 2791, name: "Hambantota District", code: "33" },
          { id: 2787, name: "Jaffna District", code: "41" },
          { id: 2789, name: "Kalutara District", code: "13" },
          { id: 2788, name: "Kandy District", code: "21" },
          { id: 2797, name: "Kegalle District", code: "92" },
          { id: 2793, name: "Kilinochchi District", code: "42" },
          { id: 2805, name: "Mannar District", code: "43" },
          { id: 2810, name: "Matale District", code: "22" },
          { id: 2806, name: "Matara District", code: "32" },
          { id: 2819, name: "Monaragala District", code: "82" },
          { id: 2814, name: "Mullaitivu District", code: "45" },
          { id: 2800, name: "North Central Province", code: "7" },
          { id: 2817, name: "North Western Province", code: "6" },
          { id: 2813, name: "Northern Province", code: "4" },
          { id: 2794, name: "Nuwara Eliya District", code: "23" },
          { id: 2812, name: "Polonnaruwa District", code: "72" },
          { id: 2796, name: "Puttalam District", code: "62" },
          { id: 2807, name: "Ratnapura district", code: "91" },
          { id: 2803, name: "Sabaragamuwa Province", code: "9" },
          { id: 2801, name: "Southern Province", code: "3" },
          { id: 2795, name: "Trincomalee District", code: "53" },
          { id: 2811, name: "Uva Province", code: "8" },
          { id: 2809, name: "Vavuniya District", code: "44" },
          { id: 2802, name: "Western Province", code: "1" }
        ]
      },
      {
        code: "SDN",
        name: "Sudan",
        states: [
          { id: 885, name: "Al Jazirah", code: "GZ" },
          { id: 886, name: "Al Qadarif", code: "GD" },
          { id: 887, name: "Blue Nile", code: "NB" },
          { id: 896, name: "Central Darfur", code: "DC" },
          { id: 892, name: "East Darfur", code: "DE" },
          { id: 884, name: "Kassala", code: "KA" },
          { id: 881, name: "Khartoum", code: "KH" },
          { id: 890, name: "North Darfur", code: "DN" },
          { id: 893, name: "North Kordofan", code: "KN" },
          { id: 895, name: "Northern", code: "NO" },
          { id: 880, name: "Red Sea", code: "RS" },
          { id: 891, name: "River Nile", code: "NR" },
          { id: 882, name: "Sennar", code: "SI" },
          { id: 894, name: "South Darfur", code: "DS" },
          { id: 883, name: "South Kordofan", code: "KS" },
          { id: 888, name: "West Darfur", code: "DW" },
          { id: 889, name: "West Kordofan", code: "GK" },
          { id: 879, name: "White Nile", code: "NW" }
        ]
      },
      {
        code: "SUR",
        name: "Suriname",
        states: [
          { id: 2846, name: "Brokopondo District", code: "BR" },
          { id: 2839, name: "Commewijne District", code: "CM" },
          { id: 2842, name: "Coronie District", code: "CR" },
          { id: 2845, name: "Marowijne District", code: "MA" },
          { id: 2840, name: "Nickerie District", code: "NI" },
          { id: 2841, name: "Para District", code: "PR" },
          { id: 2843, name: "Paramaribo District", code: "PM" },
          { id: 2848, name: "Saramacca District", code: "SA" },
          { id: 2847, name: "Sipaliwini District", code: "SI" },
          { id: 2844, name: "Wanica District", code: "WA" }
        ]
      },
      { code: "SJM", name: "Svalbard And Jan Mayen Islands", states: [] },
      {
        code: "SWZ",
        name: "Swaziland",
        states: [
          { id: 969, name: "Hhohho District", code: "HH" },
          { id: 970, name: "Lubombo District", code: "LU" },
          { id: 968, name: "Manzini District", code: "MA" },
          { id: 971, name: "Shiselweni District", code: "SH" }
        ]
      },
      {
        code: "SWE",
        name: "Sweden",
        states: [
          { id: 1537, name: "Blekinge", code: "K" },
          { id: 1534, name: "Dalarna County", code: "W" },
          { id: 1533, name: "G\xE4vleborg County", code: "X" },
          { id: 1546, name: "Gotland County", code: "I" },
          { id: 1548, name: "Halland County", code: "N" },
          { id: 5117, name: "J\xE4mtland County", code: "0" },
          { id: 1550, name: "J\xF6nk\xF6ping County", code: "F" },
          { id: 1544, name: "Kalmar County", code: "H" },
          { id: 1542, name: "Kronoberg County", code: "G" },
          { id: 1538, name: "Norrbotten County", code: "BD" },
          { id: 1539, name: "\xD6rebro County", code: "T" },
          { id: 1536, name: "\xD6sterg\xF6tland County", code: "E" },
          { id: 1541, name: "Sk\xE5ne County", code: "M" },
          { id: 1540, name: "S\xF6dermanland County", code: "D" },
          { id: 1551, name: "Stockholm County", code: "AB" },
          { id: 1545, name: "Uppsala County", code: "C" },
          { id: 1535, name: "V\xE4rmland County", code: "S" },
          { id: 1543, name: "V\xE4sterbotten County", code: "AC" },
          { id: 1552, name: "V\xE4sternorrland County", code: "Y" },
          { id: 1549, name: "V\xE4stmanland County", code: "U" },
          { id: 1547, name: "V\xE4stra G\xF6taland County", code: "O" }
        ]
      },
      {
        code: "CHE",
        name: "Switzerland",
        states: [
          { id: 1639, name: "Aargau", code: "AG" },
          { id: 1655, name: "Appenzell Ausserrhoden", code: "AR" },
          { id: 1649, name: "Appenzell Innerrhoden", code: "AI" },
          { id: 1641, name: "Basel-Land", code: "BL" },
          { id: 4957, name: "Basel-Stadt", code: "BS" },
          { id: 1645, name: "Bern", code: "BE" },
          { id: 1640, name: "Fribourg", code: "FR" },
          { id: 1647, name: "Geneva", code: "GE" },
          { id: 1661, name: "Glarus", code: "GL" },
          { id: 1660, name: "Graub\xFCnden", code: "GR" },
          { id: 1658, name: "Jura", code: "JU" },
          { id: 1663, name: "Lucerne", code: "LU" },
          { id: 1659, name: "Neuch\xE2tel", code: "NE" },
          { id: 1652, name: "Nidwalden", code: "NW" },
          { id: 1650, name: "Obwalden", code: "OW" },
          { id: 1654, name: "Schaffhausen", code: "SH" },
          { id: 1653, name: "Schwyz", code: "SZ" },
          { id: 1662, name: "Solothurn", code: "SO" },
          { id: 1644, name: "St. Gallen", code: "SG" },
          { id: 1657, name: "Thurgau", code: "TG" },
          { id: 1643, name: "Ticino", code: "TI" },
          { id: 1642, name: "Uri", code: "UR" },
          { id: 1648, name: "Valais", code: "VS" },
          { id: 1651, name: "Vaud", code: "VD" },
          { id: 1646, name: "Zug", code: "ZG" },
          { id: 1656, name: "Z\xFCrich", code: "ZH" }
        ]
      },
      {
        code: "SYR",
        name: "Syria",
        states: [
          { id: 2941, name: "Al-Hasakah", code: "HA" },
          { id: 2944, name: "Al-Raqqah", code: "RA" },
          { id: 2946, name: "Aleppo", code: "HL" },
          { id: 2936, name: "As-Suwayda", code: "SU" },
          { id: 2939, name: "Damascus", code: "DI" },
          { id: 2945, name: "Daraa", code: "DR" },
          { id: 2937, name: "Deir ez-Zor", code: "DY" },
          { id: 2934, name: "Hama", code: "HM" },
          { id: 2942, name: "Homs", code: "HI" },
          { id: 2940, name: "Idlib", code: "ID" },
          { id: 2938, name: "Latakia", code: "LA" },
          { id: 2943, name: "Quneitra", code: "QU" },
          { id: 2935, name: "Rif Dimashq", code: "RD" },
          { id: 2947, name: "Tartus", code: "TA" }
        ]
      },
      {
        code: "TWN",
        name: "Taiwan",
        states: [
          { id: 3404, name: "Changhua", code: "CHA" },
          { id: 3408, name: "Chiayi", code: "CYI" },
          { id: 3418, name: "Chiayi", code: "CYQ" },
          { id: 3423, name: "Hsinchu", code: "HSQ" },
          { id: 3417, name: "Hsinchu", code: "HSZ" },
          { id: 3411, name: "Hualien", code: "HUA" },
          { id: 3412, name: "Kaohsiung", code: "KHH" },
          { id: 4965, name: "Keelung", code: "KEE" },
          { id: 3415, name: "Kinmen", code: "KIN" },
          { id: 3420, name: "Lienchiang", code: "LIE" },
          { id: 3413, name: "Miaoli", code: "MIA" },
          { id: 3407, name: "Nantou", code: "NAN" },
          { id: 4966, name: "New Taipei", code: "NWT" },
          { id: 3403, name: "Penghu", code: "PEN" },
          { id: 3405, name: "Pingtung", code: "PIF" },
          { id: 3406, name: "Taichung", code: "TXG" },
          { id: 3421, name: "Tainan", code: "TNN" },
          { id: 3422, name: "Taipei", code: "TPE" },
          { id: 3410, name: "Taitung", code: "TTT" },
          { id: 3419, name: "Taoyuan", code: "TAO" },
          { id: 3402, name: "Yilan", code: "ILA" },
          { id: 3416, name: "Yunlin", code: "YUN" }
        ]
      },
      {
        code: "TJK",
        name: "Tajikistan",
        states: [
          {
            id: 3397,
            name: "districts of Republican Subordination",
            code: "RA"
          },
          {
            id: 3399,
            name: "Gorno-Badakhshan Autonomous Province",
            code: "GB"
          },
          { id: 3398, name: "Khatlon Province", code: "KT" },
          { id: 3400, name: "Sughd Province", code: "SU" }
        ]
      },
      {
        code: "TZA",
        name: "Tanzania",
        states: [
          { id: 1491, name: "Arusha", code: "01" },
          { id: 1490, name: "Dar es Salaam", code: "02" },
          { id: 1466, name: "Dodoma", code: "03" },
          { id: 1481, name: "Geita", code: "27" },
          { id: 1489, name: "Iringa", code: "04" },
          { id: 1465, name: "Kagera", code: "05" },
          { id: 1482, name: "Katavi", code: "28" },
          { id: 1478, name: "Kigoma", code: "08" },
          { id: 1467, name: "Kilimanjaro", code: "09" },
          { id: 1483, name: "Lindi", code: "12" },
          { id: 1484, name: "Manyara", code: "26" },
          { id: 1468, name: "Mara", code: "13" },
          { id: 4955, name: "Mbeya", code: "14" },
          { id: 1470, name: "Morogoro", code: "16" },
          { id: 1476, name: "Mtwara", code: "17" },
          { id: 1479, name: "Mwanza", code: "18" },
          { id: 1480, name: "Njombe", code: "29" },
          { id: 1488, name: "Pemba North", code: "06" },
          { id: 1472, name: "Pemba South", code: "10" },
          { id: 1485, name: "Pwani", code: "19" },
          { id: 1477, name: "Rukwa", code: "20" },
          { id: 1486, name: "Ruvuma", code: "21" },
          { id: 1463, name: "Shinyanga", code: "22" },
          { id: 1464, name: "Simiyu", code: "30" },
          { id: 1474, name: "Singida", code: "23" },
          { id: 4956, name: "Songwe", code: "31" },
          { id: 1469, name: "Tabora", code: "24" },
          { id: 1487, name: "Tanga", code: "25" },
          { id: 1473, name: "Zanzibar North", code: "07" },
          { id: 1471, name: "Zanzibar South", code: "11" },
          { id: 1475, name: "Zanzibar West", code: "15" }
        ]
      },
      {
        code: "THA",
        name: "Thailand",
        states: [
          { id: 3523, name: "Amnat Charoen", code: "37" },
          { id: 3519, name: "Ang Thong", code: "15" },
          { id: 3554, name: "Bangkok", code: "10" },
          { id: 3533, name: "Bueng Kan", code: "38" },
          { id: 3534, name: "Buri Ram", code: "31" },
          { id: 3552, name: "Chachoengsao", code: "24" },
          { id: 3522, name: "Chai Nat", code: "18" },
          { id: 4954, name: "Chaiyaphum", code: "36" },
          { id: 3486, name: "Chanthaburi", code: "22" },
          { id: 3491, name: "Chiang Mai", code: "50" },
          { id: 3498, name: "Chiang Rai", code: "57" },
          { id: 3513, name: "Chon Buri", code: "20" },
          { id: 3526, name: "Chumphon", code: "86" },
          { id: 3550, name: "Kalasin", code: "46" },
          { id: 3516, name: "Kamphaeng Phet", code: "62" },
          { id: 3511, name: "Kanchanaburi", code: "71" },
          { id: 3485, name: "Khon Kaen", code: "40" },
          { id: 3478, name: "Krabi", code: "81" },
          { id: 3544, name: "Lampang", code: "52" },
          { id: 3483, name: "Lamphun", code: "51" },
          { id: 3509, name: "Loei", code: "42" },
          { id: 3543, name: "Lop Buri", code: "16" },
          { id: 3505, name: "Mae Hong Son", code: "58" },
          { id: 3517, name: "Maha Sarakham", code: "44" },
          { id: 3546, name: "Mukdahan", code: "49" },
          { id: 3535, name: "Nakhon Nayok", code: "26" },
          { id: 3503, name: "Nakhon Pathom", code: "73" },
          { id: 3548, name: "Nakhon Phanom", code: "48" },
          { id: 3497, name: "Nakhon Ratchasima", code: "30" },
          { id: 3492, name: "Nakhon Sawan", code: "60" },
          { id: 3520, name: "Nakhon Si Thammarat", code: "80" },
          { id: 3530, name: "Nan", code: "55" },
          { id: 3553, name: "Narathiwat", code: "96" },
          { id: 3480, name: "Nong Bua Lam Phu", code: "39" },
          { id: 3484, name: "Nong Khai", code: "43" },
          { id: 3495, name: "Nonthaburi", code: "12" },
          { id: 3500, name: "Pathum Thani", code: "13" },
          { id: 3540, name: "Pattani", code: "94" },
          { id: 3507, name: "Pattaya", code: "S" },
          { id: 3549, name: "Phangnga", code: "82" },
          { id: 3488, name: "Phatthalung", code: "93" },
          { id: 3538, name: "Phayao", code: "56" },
          { id: 3515, name: "Phetchabun", code: "67" },
          { id: 3532, name: "Phetchaburi", code: "76" },
          { id: 3514, name: "Phichit", code: "66" },
          { id: 3506, name: "Phitsanulok", code: "65" },
          { id: 3494, name: "Phra Nakhon Si Ayutthaya", code: "14" },
          { id: 3528, name: "Phrae", code: "54" },
          { id: 3536, name: "Phuket", code: "83" },
          { id: 3542, name: "Prachin Buri", code: "25" },
          { id: 3508, name: "Prachuap Khiri Khan", code: "77" },
          { id: 3479, name: "Ranong", code: "85" },
          { id: 3499, name: "Ratchaburi", code: "70" },
          { id: 3518, name: "Rayong", code: "21" },
          { id: 3510, name: "Roi Et", code: "45" },
          { id: 3529, name: "Sa Kaeo", code: "27" },
          { id: 3501, name: "Sakon Nakhon", code: "47" },
          { id: 3481, name: "Samut Prakan", code: "11" },
          { id: 3504, name: "Samut Sakhon", code: "74" },
          { id: 3502, name: "Samut Songkhram", code: "75" },
          { id: 3487, name: "Saraburi", code: "19" },
          { id: 3537, name: "Satun", code: "91" },
          { id: 3547, name: "Si Sa Ket", code: "33" },
          { id: 3490, name: "Sing Buri", code: "17" },
          { id: 3539, name: "Songkhla", code: "90" },
          { id: 3545, name: "Sukhothai", code: "64" },
          { id: 3524, name: "Suphan Buri", code: "72" },
          { id: 3482, name: "Surat Thani", code: "84" },
          { id: 3531, name: "Surin", code: "32" },
          { id: 3525, name: "Tak", code: "63" },
          { id: 3541, name: "Trang", code: "92" },
          { id: 3496, name: "Trat", code: "23" },
          { id: 3512, name: "Ubon Ratchathani", code: "34" },
          { id: 3527, name: "Udon Thani", code: "41" },
          { id: 3551, name: "Uthai Thani", code: "61" },
          { id: 3489, name: "Uttaradit", code: "53" },
          { id: 3493, name: "Yala", code: "95" },
          { id: 3521, name: "Yasothon", code: "35" }
        ]
      },
      {
        code: "BHS",
        name: "The Bahamas",
        states: [
          { id: 3601, name: "Acklins", code: "AK" },
          { id: 3628, name: "Acklins and Crooked Islands", code: "AC" },
          { id: 3593, name: "Berry Islands", code: "BY" },
          { id: 3629, name: "Bimini", code: "BI" },
          { id: 3605, name: "Black Point", code: "BP" },
          { id: 3611, name: "Cat Island", code: "CI" },
          { id: 3603, name: "Central Abaco", code: "CO" },
          { id: 3631, name: "Central Andros", code: "CS" },
          { id: 3596, name: "Central Eleuthera", code: "CE" },
          { id: 3621, name: "Crooked Island", code: "CK" },
          { id: 3614, name: "East Grand Bahama", code: "EG" },
          { id: 3612, name: "Exuma", code: "EX" },
          { id: 3626, name: "Freeport", code: "FP" },
          { id: 3619, name: "Fresh Creek", code: "FC" },
          { id: 3597, name: "Governor's Harbour", code: "GH" },
          { id: 3632, name: "Grand Cay", code: "GC" },
          { id: 3595, name: "Green Turtle Cay", code: "GT" },
          { id: 3613, name: "Harbour Island", code: "HI" },
          { id: 3598, name: "High Rock", code: "HR" },
          { id: 3624, name: "Hope Town", code: "HT" },
          { id: 3609, name: "Inagua", code: "IN" },
          { id: 3618, name: "Kemps Bay", code: "KB" },
          { id: 3610, name: "Long Island", code: "LI" },
          { id: 3625, name: "Mangrove Cay", code: "MC" },
          { id: 3604, name: "Marsh Harbour", code: "MH" },
          { id: 3633, name: "Mayaguana District", code: "MG" },
          { id: 4881, name: "New Providence", code: "NP" },
          { id: 3594, name: "Nichollstown and Berry Islands", code: "NB" },
          { id: 3616, name: "North Abaco", code: "NO" },
          { id: 3617, name: "North Andros", code: "NS" },
          { id: 3602, name: "North Eleuthera", code: "NE" },
          { id: 3615, name: "Ragged Island", code: "RI" },
          { id: 3623, name: "Rock Sound", code: "RS" },
          { id: 3600, name: "Rum Cay District", code: "RC" },
          { id: 3620, name: "San Salvador and Rum Cay", code: "SR" },
          { id: 3627, name: "San Salvador Island", code: "SS" },
          { id: 3606, name: "Sandy Point", code: "SP" },
          { id: 3608, name: "South Abaco", code: "SO" },
          { id: 3622, name: "South Andros", code: "SA" },
          { id: 3607, name: "South Eleuthera", code: "SE" },
          { id: 3630, name: "Spanish Wells", code: "SW" },
          { id: 3599, name: "West Grand Bahama", code: "WG" }
        ]
      },
      {
        code: "TGO",
        name: "Togo",
        states: [
          { id: 2575, name: "Centrale Region", code: "C" },
          { id: 2579, name: "Kara Region", code: "K" },
          { id: 2576, name: "Maritime", code: "M" },
          { id: 2577, name: "Plateaux Region", code: "P" },
          { id: 2578, name: "Savanes Region", code: "S" }
        ]
      },
      { code: "TKL", name: "Tokelau", states: [] },
      {
        code: "TON",
        name: "Tonga",
        states: [
          { id: 3913, name: "Ha\u02BBapai", code: "02" },
          { id: 3915, name: "\u02BBEua", code: "01" },
          { id: 3914, name: "Niuas", code: "03" },
          { id: 3912, name: "Tongatapu", code: "04" },
          { id: 3911, name: "Vava\u02BBu", code: "05" }
        ]
      },
      {
        code: "TTO",
        name: "Trinidad And Tobago",
        states: [
          { id: 3362, name: "Arima", code: "ARI" },
          { id: 3366, name: "Chaguanas", code: "CHA" },
          {
            id: 3354,
            name: "Couva-Tabaquite-Talparo Regional Corporation",
            code: "CTT"
          },
          {
            id: 3367,
            name: "Diego Martin Regional Corporation",
            code: "DMN"
          },
          { id: 3355, name: "Eastern Tobago", code: "ETO" },
          { id: 3365, name: "Penal-Debe Regional Corporation", code: "PED" },
          { id: 3360, name: "Point Fortin", code: "PTF" },
          { id: 3363, name: "Port of Spain", code: "POS" },
          {
            id: 3368,
            name: "Princes Town Regional Corporation",
            code: "PRT"
          },
          {
            id: 3356,
            name: "Rio Claro-Mayaro Regional Corporation",
            code: "MRC"
          },
          { id: 3359, name: "San Fernando", code: "SFO" },
          {
            id: 3357,
            name: "San Juan-Laventille Regional Corporation",
            code: "SJL"
          },
          {
            id: 3361,
            name: "Sangre Grande Regional Corporation",
            code: "SGE"
          },
          { id: 3364, name: "Siparia Regional Corporation", code: "SIP" },
          {
            id: 3358,
            name: "Tunapuna-Piarco Regional Corporation",
            code: "TUP"
          },
          { id: 3353, name: "Western Tobago", code: "WTO" }
        ]
      },
      {
        code: "TUN",
        name: "Tunisia",
        states: [
          { id: 2550, name: "Ariana", code: "12" },
          { id: 2572, name: "B\xE9ja", code: "31" },
          { id: 2566, name: "Ben Arous", code: "13" },
          { id: 2551, name: "Bizerte", code: "23" },
          { id: 2558, name: "Gab\xE8s", code: "81" },
          { id: 2556, name: "Gafsa", code: "71" },
          { id: 2552, name: "Jendouba", code: "32" },
          { id: 2564, name: "Kairouan", code: "41" },
          { id: 2570, name: "Kasserine", code: "42" },
          { id: 2562, name: "Kebili", code: "73" },
          { id: 2561, name: "Kef", code: "33" },
          { id: 2568, name: "Mahdia", code: "53" },
          { id: 2555, name: "Manouba", code: "14" },
          { id: 2560, name: "Medenine", code: "82" },
          { id: 2553, name: "Monastir", code: "52" },
          { id: 5116, name: "Nabeul", code: "21" },
          { id: 2557, name: "Sfax", code: "61" },
          { id: 2567, name: "Sidi Bouzid", code: "43" },
          { id: 2563, name: "Siliana", code: "34" },
          { id: 2571, name: "Sousse", code: "51" },
          { id: 2559, name: "Tataouine", code: "83" },
          { id: 2569, name: "Tozeur", code: "72" },
          { id: 2554, name: "Tunis", code: "11" },
          { id: 2565, name: "Zaghouan", code: "22" }
        ]
      },
      {
        code: "TUR",
        name: "Turkey",
        states: [
          { id: 2212, name: "Adana", code: "01" },
          { id: 2155, name: "Ad\u0131yaman", code: "02" },
          { id: 2179, name: "Afyonkarahisar", code: "03" },
          { id: 2193, name: "A\u011Fr\u0131", code: "04" },
          { id: 2210, name: "Aksaray", code: "68" },
          { id: 2161, name: "Amasya", code: "05" },
          { id: 2217, name: "Ankara", code: "06" },
          { id: 2169, name: "Antalya", code: "07" },
          { id: 2185, name: "Ardahan", code: "75" },
          { id: 2191, name: "Artvin", code: "08" },
          { id: 2187, name: "Ayd\u0131n", code: "09" },
          { id: 2175, name: "Bal\u0131kesir", code: "10" },
          { id: 2148, name: "Bart\u0131n", code: "74" },
          { id: 2194, name: "Batman", code: "72" },
          { id: 2177, name: "Bayburt", code: "69" },
          { id: 2221, name: "Bilecik", code: "11" },
          { id: 2153, name: "Bing\xF6l", code: "12" },
          { id: 2215, name: "Bitlis", code: "13" },
          { id: 2172, name: "Bolu", code: "14" },
          { id: 2209, name: "Burdur", code: "15" },
          { id: 2163, name: "Bursa", code: "16" },
          { id: 2216, name: "\xC7anakkale", code: "17" },
          { id: 2168, name: "\xC7ank\u0131r\u0131", code: "18" },
          { id: 2173, name: "\xC7orum", code: "19" },
          { id: 2157, name: "Denizli", code: "20" },
          { id: 2226, name: "Diyarbak\u0131r", code: "21" },
          { id: 2202, name: "D\xFCzce", code: "81" },
          { id: 2151, name: "Edirne", code: "22" },
          { id: 2159, name: "Elaz\u0131\u011F", code: "23" },
          { id: 2160, name: "Erzincan", code: "24" },
          { id: 2165, name: "Erzurum", code: "25" },
          { id: 2164, name: "Eski\u015Fehir", code: "26" },
          { id: 2203, name: "Gaziantep", code: "27" },
          { id: 2186, name: "Giresun", code: "28" },
          { id: 2204, name: "G\xFCm\xFC\u015Fhane", code: "29" },
          { id: 2190, name: "Hakk\xE2ri", code: "30" },
          { id: 2211, name: "Hatay", code: "31" },
          { id: 2166, name: "I\u011Fd\u0131r", code: "76" },
          { id: 2222, name: "Isparta", code: "32" },
          { id: 2170, name: "\u0130stanbul", code: "34" },
          { id: 2205, name: "\u0130zmir", code: "35" },
          { id: 2227, name: "Kahramanmara\u015F", code: "46" },
          { id: 2223, name: "Karab\xFCk", code: "78" },
          { id: 2184, name: "Karaman", code: "70" },
          { id: 2208, name: "Kars", code: "36" },
          { id: 2197, name: "Kastamonu", code: "37" },
          { id: 2200, name: "Kayseri", code: "38" },
          { id: 2154, name: "Kilis", code: "79" },
          { id: 2178, name: "K\u0131r\u0131kkale", code: "71" },
          { id: 2176, name: "K\u0131rklareli", code: "39" },
          { id: 2180, name: "K\u0131r\u015Fehir", code: "40" },
          { id: 2195, name: "Kocaeli", code: "41" },
          { id: 2171, name: "Konya", code: "42" },
          { id: 2149, name: "K\xFCtahya", code: "43" },
          { id: 2158, name: "Malatya", code: "44" },
          { id: 2198, name: "Manisa", code: "45" },
          { id: 2224, name: "Mardin", code: "47" },
          { id: 2156, name: "Mersin", code: "33" },
          { id: 2182, name: "Mu\u011Fla", code: "48" },
          { id: 2162, name: "Mu\u015F", code: "49" },
          { id: 2196, name: "Nev\u015Fehir", code: "50" },
          { id: 2189, name: "Ni\u011Fde", code: "51" },
          { id: 2174, name: "Ordu", code: "52" },
          { id: 2214, name: "Osmaniye", code: "80" },
          { id: 2219, name: "Rize", code: "53" },
          { id: 2150, name: "Sakarya", code: "54" },
          { id: 2220, name: "Samsun", code: "55" },
          { id: 2183, name: "\u015Eanl\u0131urfa", code: "63" },
          { id: 2207, name: "Siirt", code: "56" },
          { id: 4854, name: "Sinop", code: "57" },
          { id: 2181, name: "Sivas", code: "58" },
          { id: 2225, name: "\u015E\u0131rnak", code: "73" },
          { id: 2167, name: "Tekirda\u011F", code: "59" },
          { id: 2199, name: "Tokat", code: "60" },
          { id: 2206, name: "Trabzon", code: "61" },
          { id: 2192, name: "Tunceli", code: "62" },
          { id: 2201, name: "U\u015Fak", code: "64" },
          { id: 2152, name: "Van", code: "65" },
          { id: 2218, name: "Yalova", code: "77" },
          { id: 2188, name: "Yozgat", code: "66" },
          { id: 2213, name: "Zonguldak", code: "67" }
        ]
      },
      {
        code: "TKM",
        name: "Turkmenistan",
        states: [
          { id: 3374, name: "Ahal Region", code: "A" },
          { id: 3371, name: "Ashgabat", code: "S" },
          { id: 3372, name: "Balkan Region", code: "B" },
          { id: 3373, name: "Da\u015Foguz Region", code: "D" },
          { id: 3370, name: "Lebap Region", code: "L" },
          { id: 3369, name: "Mary Region", code: "M" }
        ]
      },
      { code: "TCA", name: "Turks And Caicos Islands", states: [] },
      {
        code: "TUV",
        name: "Tuvalu",
        states: [
          { id: 3951, name: "Funafuti", code: "FUN" },
          { id: 3947, name: "Nanumanga", code: "NMG" },
          { id: 3949, name: "Nanumea", code: "NMA" },
          { id: 3946, name: "Niutao Island Council", code: "NIT" },
          { id: 3948, name: "Nui", code: "NUI" },
          { id: 3952, name: "Nukufetau", code: "NKF" },
          { id: 3953, name: "Nukulaelae", code: "NKL" },
          { id: 3950, name: "Vaitupu", code: "VAI" }
        ]
      },
      {
        code: "UGA",
        name: "Uganda",
        states: [
          { id: 329, name: "Abim District", code: "314" },
          { id: 361, name: "Adjumani District", code: "301" },
          { id: 392, name: "Agago District", code: "322" },
          { id: 344, name: "Alebtong District", code: "323" },
          { id: 416, name: "Amolatar District", code: "315" },
          { id: 353, name: "Amudat District", code: "324" },
          { id: 352, name: "Amuria District", code: "216" },
          { id: 335, name: "Amuru District", code: "316" },
          { id: 328, name: "Apac District", code: "302" },
          { id: 447, name: "Arua District", code: "303" },
          { id: 441, name: "Budaka District", code: "217" },
          { id: 349, name: "Bududa District", code: "218" },
          { id: 387, name: "Bugiri District", code: "201" },
          { id: 391, name: "Buhweju District", code: "420" },
          { id: 377, name: "Buikwe District", code: "117" },
          { id: 343, name: "Bukedea District", code: "219" },
          { id: 375, name: "Bukomansimbi District", code: "118" },
          { id: 385, name: "Bukwo District", code: "220" },
          { id: 428, name: "Bulambuli District", code: "225" },
          { id: 389, name: "Buliisa District", code: "416" },
          { id: 419, name: "Bundibugyo District", code: "401" },
          { id: 381, name: "Bunyangabu District", code: "430" },
          { id: 386, name: "Bushenyi District", code: "402" },
          { id: 431, name: "Busia District", code: "202" },
          { id: 365, name: "Butaleja District", code: "221" },
          { id: 384, name: "Butambala District", code: "119" },
          { id: 388, name: "Butebo District", code: "233" },
          { id: 414, name: "Buvuma District", code: "120" },
          { id: 380, name: "Buyende District", code: "226" },
          { id: 396, name: "Central Region", code: "C" },
          { id: 341, name: "Dokolo District", code: "317" },
          { id: 372, name: "Eastern Region", code: "E" },
          { id: 366, name: "Gomba District", code: "121" },
          { id: 413, name: "Gulu District", code: "304" },
          { id: 339, name: "Ibanda District", code: "417" },
          { id: 340, name: "Iganga District", code: "203" },
          { id: 383, name: "Isingiro District", code: "418" },
          { id: 367, name: "Jinja District", code: "204" },
          { id: 434, name: "Kaabong District", code: "318" },
          { id: 426, name: "Kabale District", code: "404" },
          { id: 326, name: "Kabarole District", code: "405" },
          { id: 336, name: "Kaberamaido District", code: "213" },
          { id: 403, name: "Kagadi District", code: "427" },
          { id: 399, name: "Kakumiro District", code: "428" },
          { id: 405, name: "Kalangala District", code: "101" },
          { id: 398, name: "Kaliro District", code: "222" },
          { id: 394, name: "Kalungu District", code: "122" },
          { id: 382, name: "Kampala District", code: "102" },
          { id: 334, name: "Kamuli District", code: "205" },
          { id: 360, name: "Kamwenge District", code: "413" },
          { id: 373, name: "Kanungu District", code: "414" },
          { id: 432, name: "Kapchorwa District", code: "206" },
          { id: 440, name: "Kasese District", code: "406" },
          { id: 420, name: "Katakwi District", code: "207" },
          { id: 368, name: "Kayunga District", code: "112" },
          { id: 436, name: "Kibaale District", code: "407" },
          { id: 347, name: "Kiboga District", code: "103" },
          { id: 338, name: "Kibuku District", code: "227" },
          { id: 355, name: "Kiruhura District", code: "419" },
          { id: 346, name: "Kiryandongo District", code: "421" },
          { id: 409, name: "Kisoro District", code: "408" },
          { id: 348, name: "Kitgum District", code: "305" },
          { id: 345, name: "Koboko District", code: "319" },
          { id: 401, name: "Kole District", code: "325" },
          { id: 443, name: "Kotido District", code: "306" },
          { id: 425, name: "Kumi District", code: "208" },
          { id: 369, name: "Kween District", code: "228" },
          { id: 325, name: "Kyankwanzi District", code: "123" },
          { id: 437, name: "Kyegegwa District", code: "422" },
          { id: 402, name: "Kyenjojo District", code: "415" },
          { id: 448, name: "Kyotera District", code: "125" },
          { id: 411, name: "Lamwo District", code: "326" },
          { id: 342, name: "Lira District", code: "307" },
          { id: 445, name: "Luuka District", code: "229" },
          { id: 433, name: "Luwero District", code: "104" },
          { id: 417, name: "Lwengo District", code: "124" },
          { id: 376, name: "Lyantonde District", code: "114" },
          { id: 438, name: "Manafwa District", code: "223" },
          { id: 421, name: "Maracha District", code: "320" },
          { id: 356, name: "Masaka District", code: "105" },
          { id: 354, name: "Masindi District", code: "409" },
          { id: 418, name: "Mayuge District", code: "214" },
          { id: 350, name: "Mbale District", code: "209" },
          { id: 415, name: "Mbarara District", code: "410" },
          { id: 435, name: "Mitooma District", code: "423" },
          { id: 364, name: "Mityana District", code: "115" },
          { id: 395, name: "Moroto District", code: "308" },
          { id: 363, name: "Moyo District", code: "309" },
          { id: 327, name: "Mpigi District", code: "106" },
          { id: 371, name: "Mubende District", code: "107" },
          { id: 410, name: "Mukono District", code: "108" },
          { id: 393, name: "Nakapiripirit District", code: "311" },
          { id: 423, name: "Nakaseke District", code: "116" },
          { id: 406, name: "Nakasongola District", code: "109" },
          { id: 351, name: "Namayingo District", code: "230" },
          { id: 400, name: "Namisindwa District", code: "234" },
          { id: 337, name: "Namutumba District", code: "224" },
          { id: 430, name: "Napak District", code: "327" },
          { id: 446, name: "Nebbi District", code: "310" },
          { id: 424, name: "Ngora District", code: "231" },
          { id: 332, name: "Northern Region", code: "N" },
          { id: 422, name: "Ntoroko District", code: "424" },
          { id: 404, name: "Ntungamo District", code: "411" },
          { id: 378, name: "Nwoya District", code: "328" },
          { id: 374, name: "Omoro District", code: "331" },
          { id: 390, name: "Otuke District", code: "329" },
          { id: 397, name: "Oyam District", code: "321" },
          { id: 408, name: "Pader District", code: "312" },
          { id: 357, name: "Pakwach District", code: "332" },
          { id: 412, name: "Pallisa District", code: "210" },
          { id: 439, name: "Rakai District", code: "110" },
          { id: 358, name: "Rubanda District", code: "429" },
          { id: 442, name: "Rubirizi District", code: "425" },
          { id: 331, name: "Rukiga District", code: "431" },
          { id: 324, name: "Rukungiri District", code: "412" },
          { id: 427, name: "Sembabule District", code: "111" },
          { id: 333, name: "Serere District", code: "232" },
          { id: 407, name: "Sheema District", code: "426" },
          { id: 429, name: "Sironko District", code: "215" },
          { id: 444, name: "Soroti District", code: "211" },
          { id: 359, name: "Tororo District", code: "212" },
          { id: 362, name: "Wakiso District", code: "113" },
          { id: 370, name: "Western Region", code: "W" },
          { id: 330, name: "Yumbe District", code: "313" },
          { id: 379, name: "Zombo District", code: "330" }
        ]
      },
      {
        code: "UKR",
        name: "Ukraine",
        states: [
          { id: 4689, name: "Autonomous Republic of Crimea", code: "43" },
          { id: 4680, name: "Cherkaska oblast", code: "71" },
          { id: 4692, name: "Chernihivska oblast", code: "74" },
          { id: 4678, name: "Chernivetska oblast", code: "77" },
          { id: 4675, name: "Dnipropetrovska oblast", code: "12" },
          { id: 4691, name: "Donetska oblast", code: "14" },
          { id: 4682, name: "Ivano-Frankivska oblast", code: "26" },
          { id: 4686, name: "Kharkivska oblast", code: "63" },
          { id: 4684, name: "Khersonska oblast", code: "65" },
          { id: 4681, name: "Khmelnytska oblast", code: "68" },
          { id: 4677, name: "Kirovohradska oblast", code: "35" },
          { id: 4676, name: "Kyiv", code: "30" },
          { id: 4671, name: "Kyivska oblast", code: "32" },
          { id: 4673, name: "Luhanska oblast", code: "09" },
          { id: 4672, name: "Lvivska oblast", code: "46" },
          { id: 4679, name: "Mykolaivska oblast", code: "48" },
          { id: 4688, name: "Odeska oblast", code: "51" },
          { id: 5071, name: "Poltavska oblast", code: "53" },
          { id: 4683, name: "Rivnenska oblast", code: "56" },
          { id: 4685, name: "Sumska oblast", code: "59" },
          { id: 4674, name: "Ternopilska oblast", code: "61" },
          { id: 4669, name: "Vinnytska oblast", code: "05" },
          { id: 4690, name: "Volynska oblast", code: "07" },
          { id: 4670, name: "Zakarpatska Oblast", code: "21" },
          { id: 4687, name: "Zaporizka oblast", code: "23" },
          { id: 4668, name: "Zhytomyrska oblast", code: "18" }
        ]
      },
      {
        code: "ARE",
        name: "United Arab Emirates",
        states: [
          { id: 3396, name: "Abu Dhabi Emirate", code: "AZ" },
          { id: 3395, name: "Ajman Emirate", code: "AJ" },
          { id: 3391, name: "Dubai", code: "DU" },
          { id: 3393, name: "Fujairah", code: "FU" },
          { id: 3394, name: "Ras al-Khaimah", code: "RK" },
          { id: 3390, name: "Sharjah Emirate", code: "SH" },
          { id: 3392, name: "Umm al-Quwain", code: "UQ" }
        ]
      },
      {
        code: "GBR",
        name: "United Kingdom",
        states: [
          { id: 2463, name: "Aberdeen", code: "ABE" },
          { id: 2401, name: "Aberdeenshire", code: "ABD" },
          { id: 2387, name: "Angus", code: "ANS" },
          { id: 2533, name: "Antrim", code: "ANT" },
          { id: 2412, name: "Antrim and Newtownabbey", code: "ANN" },
          { id: 2498, name: "Ards", code: "ARD" },
          { id: 2523, name: "Ards and North Down", code: "AND" },
          { id: 2392, name: "Argyll and Bute", code: "AGB" },
          { id: 2331, name: "Armagh City and District Council", code: "ARM" },
          { id: 2324, name: "Armagh, Banbridge and Craigavon", code: "ABC" },
          { id: 2378, name: "Ascension Island", code: "SH-AC" },
          { id: 2363, name: "Ballymena Borough", code: "BLA" },
          { id: 2361, name: "Ballymoney", code: "BLY" },
          { id: 2315, name: "Banbridge", code: "BNB" },
          { id: 2499, name: "Barnsley", code: "BNS" },
          { id: 2339, name: "Bath and North East Somerset", code: "BAS" },
          { id: 2507, name: "Bedford", code: "BDF" },
          { id: 2311, name: "Belfast district", code: "BFS" },
          { id: 2425, name: "Birmingham", code: "BIR" },
          { id: 2329, name: "Blackburn with Darwen", code: "BBD" },
          { id: 2451, name: "Blackpool", code: "BPL" },
          { id: 2530, name: "Blaenau Gwent County Borough", code: "BGW" },
          { id: 2504, name: "Bolton", code: "BOL" },
          { id: 2342, name: "Bournemouth", code: "BMH" },
          { id: 2470, name: "Bracknell Forest", code: "BRC" },
          { id: 2529, name: "Bradford", code: "BRD" },
          { id: 2452, name: "Bridgend County Borough", code: "BGE" },
          { id: 2395, name: "Brighton and Hove", code: "BNH" },
          { id: 2405, name: "Buckinghamshire", code: "BKM" },
          { id: 2459, name: "Bury", code: "BUR" },
          { id: 2298, name: "Caerphilly County Borough", code: "CAY" },
          { id: 2517, name: "Calderdale", code: "CLD" },
          { id: 2423, name: "Cambridgeshire", code: "CAM" },
          { id: 2484, name: "Carmarthenshire", code: "CMN" },
          { id: 2439, name: "Carrickfergus Borough Council", code: "CKF" },
          { id: 2525, name: "Castlereagh", code: "CSR" },
          { id: 2316, name: "Causeway Coast and Glens", code: "CCG" },
          { id: 2303, name: "Central Bedfordshire", code: "CBF" },
          { id: 2509, name: "Ceredigion", code: "CGN" },
          { id: 2444, name: "Cheshire East", code: "CHE" },
          { id: 2442, name: "Cheshire West and Chester", code: "CHW" },
          { id: 2528, name: "City and County of Cardiff", code: "CRF" },
          { id: 2433, name: "City and County of Swansea", code: "SWA" },
          { id: 2413, name: "City of Bristol", code: "BST" },
          { id: 2485, name: "City of Derby", code: "DER" },
          { id: 2475, name: "City of Kingston upon Hull", code: "KHL" },
          { id: 2318, name: "City of Leicester", code: "LCE" },
          { id: 2424, name: "City of London", code: "LND" },
          { id: 2359, name: "City of Nottingham", code: "NGM" },
          { id: 2297, name: "City of Peterborough", code: "PTE" },
          { id: 2514, name: "City of Plymouth", code: "PLY" },
          { id: 2305, name: "City of Portsmouth", code: "POR" },
          { id: 2294, name: "City of Southampton", code: "STH" },
          { id: 2506, name: "City of Stoke-on-Trent", code: "STE" },
          { id: 2372, name: "City of Sunderland", code: "SND" },
          { id: 2357, name: "City of Westminster", code: "WSM" },
          { id: 2489, name: "City of Wolverhampton", code: "WLV" },
          { id: 2426, name: "City of York", code: "YOR" },
          { id: 2450, name: "Clackmannanshire", code: "CLK" },
          { id: 2461, name: "Coleraine Borough Council", code: "CLR" },
          { id: 2352, name: "Conwy County Borough", code: "CWY" },
          { id: 2445, name: "Cookstown District Council", code: "CKT" },
          { id: 2312, name: "Cornwall", code: "CON" },
          { id: 2406, name: "County Durham", code: "DUR" },
          { id: 2438, name: "Coventry", code: "COV" },
          { id: 2449, name: "Craigavon Borough Council", code: "CGV" },
          { id: 2334, name: "Cumbria", code: "CMA" },
          { id: 2389, name: "Darlington", code: "DAL" },
          { id: 2497, name: "Denbighshire", code: "DEN" },
          { id: 2403, name: "Derbyshire", code: "DBY" },
          { id: 2446, name: "Derry City and Strabane", code: "DRS" },
          { id: 2417, name: "Derry City Council", code: "DRY" },
          { id: 2491, name: "Devon", code: "DEV" },
          { id: 2364, name: "Doncaster", code: "DNC" },
          { id: 2345, name: "Dorset", code: "DOR" },
          { id: 2304, name: "Down District Council", code: "DOW" },
          { id: 2457, name: "Dudley", code: "DUD" },
          { id: 2415, name: "Dumfries and Galloway", code: "DGY" },
          { id: 2511, name: "Dundee", code: "DND" },
          {
            id: 2508,
            name: "Dungannon and South Tyrone Borough Council",
            code: "DGN"
          },
          { id: 2374, name: "East Ayrshire", code: "EAY" },
          { id: 2454, name: "East Dunbartonshire", code: "EDU" },
          { id: 2462, name: "East Lothian", code: "ELN" },
          { id: 2333, name: "East Renfrewshire", code: "ERW" },
          { id: 2370, name: "East Riding of Yorkshire", code: "ERY" },
          { id: 2414, name: "East Sussex", code: "ESX" },
          { id: 2428, name: "Edinburgh", code: "EDH" },
          { id: 2336, name: "England", code: "ENG" },
          { id: 2410, name: "Essex", code: "ESS" },
          { id: 2344, name: "Falkirk", code: "FAL" },
          { id: 2366, name: "Fermanagh and Omagh", code: "FMO" },
          { id: 2531, name: "Fermanagh District Council", code: "FER" },
          { id: 2479, name: "Fife", code: "FIF" },
          { id: 2437, name: "Flintshire", code: "FLN" },
          { id: 2431, name: "Gateshead", code: "GAT" },
          { id: 2404, name: "Glasgow", code: "GLG" },
          { id: 2373, name: "Gloucestershire", code: "GLS" },
          { id: 2379, name: "Gwynedd", code: "GWN" },
          { id: 2466, name: "Halton", code: "HAL" },
          { id: 2435, name: "Hampshire", code: "HAM" },
          { id: 2309, name: "Hartlepool", code: "HPL" },
          { id: 2500, name: "Herefordshire", code: "HEF" },
          { id: 2369, name: "Hertfordshire", code: "HRT" },
          { id: 2383, name: "Highland", code: "HLD" },
          { id: 2388, name: "Inverclyde", code: "IVC" },
          { id: 2289, name: "Isle of Wight", code: "IOW" },
          { id: 2343, name: "Isles of Scilly", code: "IOS" },
          { id: 2464, name: "Kent", code: "KEN" },
          { id: 2371, name: "Kirklees", code: "KIR" },
          { id: 2330, name: "Knowsley", code: "KWL" },
          { id: 2495, name: "Lancashire", code: "LAN" },
          { id: 2515, name: "Larne Borough Council", code: "LRN" },
          { id: 2503, name: "Leeds", code: "LDS" },
          { id: 2516, name: "Leicestershire", code: "LEC" },
          { id: 2382, name: "Limavady Borough Council", code: "LMV" },
          { id: 2355, name: "Lincolnshire", code: "LIN" },
          { id: 2460, name: "Lisburn and Castlereagh", code: "LBC" },
          { id: 2494, name: "Lisburn City Council", code: "LSB" },
          { id: 2340, name: "Liverpool", code: "LIV" },
          {
            id: 2356,
            name: "London Borough of Barking and Dagenham",
            code: "BDG"
          },
          { id: 2520, name: "London Borough of Barnet", code: "BNE" },
          { id: 2307, name: "London Borough of Bexley", code: "BEX" },
          { id: 2291, name: "London Borough of Brent", code: "BEN" },
          { id: 2490, name: "London Borough of Bromley", code: "BRY" },
          { id: 2349, name: "London Borough of Camden", code: "CMD" },
          { id: 2512, name: "London Borough of Croydon", code: "CRY" },
          { id: 2532, name: "London Borough of Ealing", code: "EAL" },
          { id: 2476, name: "London Borough of Enfield", code: "ENF" },
          { id: 2411, name: "London Borough of Hackney", code: "HCK" },
          {
            id: 2448,
            name: "London Borough of Hammersmith and Fulham",
            code: "HMF"
          },
          { id: 2306, name: "London Borough of Haringey", code: "HRY" },
          { id: 2385, name: "London Borough of Harrow", code: "HRW" },
          { id: 2347, name: "London Borough of Havering", code: "HAV" },
          { id: 2376, name: "London Borough of Hillingdon", code: "HIL" },
          { id: 2380, name: "London Borough of Hounslow", code: "HNS" },
          { id: 2319, name: "London Borough of Islington", code: "ISL" },
          { id: 2396, name: "London Borough of Lambeth", code: "LBH" },
          { id: 2358, name: "London Borough of Lewisham", code: "LEW" },
          { id: 2483, name: "London Borough of Merton", code: "MRT" },
          { id: 2418, name: "London Borough of Newham", code: "NWM" },
          { id: 2397, name: "London Borough of Redbridge", code: "RDB" },
          {
            id: 2501,
            name: "London Borough of Richmond upon Thames",
            code: "RIC"
          },
          { id: 2432, name: "London Borough of Southwark", code: "SWK" },
          { id: 2313, name: "London Borough of Sutton", code: "STN" },
          { id: 2390, name: "London Borough of Tower Hamlets", code: "TWH" },
          { id: 2326, name: "London Borough of Waltham Forest", code: "WFT" },
          { id: 2434, name: "London Borough of Wandsworth", code: "WND" },
          { id: 2322, name: "Magherafelt District Council", code: "MFT" },
          { id: 2398, name: "Manchester", code: "MAN" },
          { id: 2381, name: "Medway", code: "MDW" },
          { id: 2328, name: "Merthyr Tydfil County Borough", code: "MTY" },
          { id: 2320, name: "Metropolitan Borough of Wigan", code: "WGN" },
          { id: 2429, name: "Mid and East Antrim", code: "MEA" },
          { id: 2399, name: "Mid Ulster", code: "MUL" },
          { id: 2332, name: "Middlesbrough", code: "MDB" },
          { id: 2519, name: "Midlothian", code: "MLN" },
          { id: 2416, name: "Milton Keynes", code: "MIK" },
          { id: 2402, name: "Monmouthshire", code: "MON" },
          { id: 2360, name: "Moray", code: "MRY" },
          { id: 2348, name: "Moyle District Council", code: "MYL" },
          { id: 2351, name: "Neath Port Talbot County Borough", code: "NTL" },
          { id: 2458, name: "Newcastle upon Tyne", code: "NET" },
          { id: 2524, name: "Newport", code: "NWP" },
          {
            id: 2350,
            name: "Newry and Mourne District Council",
            code: "NYM"
          },
          { id: 2534, name: "Newry, Mourne and Down", code: "NMD" },
          { id: 2317, name: "Newtownabbey Borough Council", code: "NTA" },
          { id: 2473, name: "Norfolk", code: "NFK" },
          { id: 2535, name: "North Ayrshire", code: "NAY" },
          { id: 2513, name: "North Down Borough Council", code: "NDN" },
          { id: 2384, name: "North East Lincolnshire", code: "NEL" },
          { id: 2487, name: "North Lanarkshire", code: "NLK" },
          { id: 2453, name: "North Lincolnshire", code: "NLN" },
          { id: 2430, name: "North Somerset", code: "NSM" },
          { id: 2521, name: "North Tyneside", code: "NTY" },
          { id: 2522, name: "North Yorkshire", code: "NYK" },
          { id: 2480, name: "Northamptonshire", code: "NTH" },
          { id: 2337, name: "Northern Ireland", code: "NIR" },
          { id: 2365, name: "Northumberland", code: "NBL" },
          { id: 2456, name: "Nottinghamshire", code: "NTT" },
          { id: 2477, name: "Oldham", code: "OLD" },
          { id: 2314, name: "Omagh District Council", code: "OMH" },
          { id: 2474, name: "Orkney Islands", code: "ORK" },
          { id: 2353, name: "Outer Hebrides", code: "ELS" },
          { id: 2321, name: "Oxfordshire", code: "OXF" },
          { id: 2486, name: "Pembrokeshire", code: "PEM" },
          { id: 2325, name: "Perth and Kinross", code: "PKN" },
          { id: 2302, name: "Poole", code: "POL" },
          { id: 2441, name: "Powys", code: "POW" },
          { id: 2455, name: "Reading", code: "RDG" },
          { id: 2527, name: "Redcar and Cleveland", code: "RCC" },
          { id: 2443, name: "Renfrewshire", code: "RFW" },
          { id: 2301, name: "Rhondda Cynon Taf", code: "RCT" },
          { id: 2327, name: "Rochdale", code: "RCH" },
          { id: 2308, name: "Rotherham", code: "ROT" },
          { id: 2492, name: "Royal Borough of Greenwich", code: "GRE" },
          {
            id: 2368,
            name: "Royal Borough of Kensington and Chelsea",
            code: "KEC"
          },
          {
            id: 2481,
            name: "Royal Borough of Kingston upon Thames",
            code: "KTT"
          },
          { id: 2472, name: "Rutland", code: "RUT" },
          { id: 2502, name: "Saint Helena", code: "SH-HL" },
          { id: 2493, name: "Salford", code: "SLF" },
          { id: 2341, name: "Sandwell", code: "SAW" },
          { id: 2335, name: "Scotland", code: "SCT" },
          { id: 2346, name: "Scottish Borders", code: "SCB" },
          { id: 2518, name: "Sefton", code: "SFT" },
          { id: 2295, name: "Sheffield", code: "SHF" },
          { id: 2300, name: "Shetland Islands", code: "ZET" },
          { id: 2407, name: "Shropshire", code: "SHR" },
          { id: 2427, name: "Slough", code: "SLG" },
          { id: 2469, name: "Solihull", code: "SOL" },
          { id: 2386, name: "Somerset", code: "SOM" },
          { id: 2377, name: "South Ayrshire", code: "SAY" },
          { id: 2400, name: "South Gloucestershire", code: "SGC" },
          { id: 2362, name: "South Lanarkshire", code: "SLK" },
          { id: 2409, name: "South Tyneside", code: "STY" },
          { id: 2323, name: "Southend-on-Sea", code: "SOS" },
          { id: 2290, name: "St Helens", code: "SHN" },
          { id: 2447, name: "Staffordshire", code: "STS" },
          { id: 2488, name: "Stirling", code: "STG" },
          { id: 2394, name: "Stockport", code: "SKP" },
          { id: 2421, name: "Stockton-on-Tees", code: "STT" },
          { id: 2393, name: "Strabane District Council", code: "STB" },
          { id: 2467, name: "Suffolk", code: "SFK" },
          { id: 2526, name: "Surrey", code: "SRY" },
          { id: 2422, name: "Swindon", code: "SWD" },
          { id: 2367, name: "Tameside", code: "TAM" },
          { id: 2310, name: "Telford and Wrekin", code: "TFW" },
          { id: 2468, name: "Thurrock", code: "THR" },
          { id: 2478, name: "Torbay", code: "TOB" },
          { id: 2496, name: "Torfaen", code: "TOF" },
          { id: 2293, name: "Trafford", code: "TRF" },
          { id: 2375, name: "United Kingdom", code: "UKM" },
          { id: 2299, name: "Vale of Glamorgan", code: "VGL" },
          { id: 2465, name: "Wakefield", code: "WKF" },
          { id: 2338, name: "Wales", code: "WLS" },
          { id: 2292, name: "Walsall", code: "WLL" },
          { id: 2420, name: "Warrington", code: "WRT" },
          { id: 2505, name: "Warwickshire", code: "WAR" },
          { id: 2471, name: "West Berkshire", code: "WBK" },
          { id: 2440, name: "West Dunbartonshire", code: "WDU" },
          { id: 2354, name: "West Lothian", code: "WLN" },
          { id: 2296, name: "West Sussex", code: "WSX" },
          { id: 2391, name: "Wiltshire", code: "WIL" },
          { id: 2482, name: "Windsor and Maidenhead", code: "WNM" },
          { id: 2408, name: "Wirral", code: "WRL" },
          { id: 2419, name: "Wokingham", code: "WOK" },
          { id: 2510, name: "Worcestershire", code: "WOR" },
          { id: 2436, name: "Wrexham County Borough", code: "WRX" }
        ]
      },
      {
        code: "USA",
        name: "United States",
        states: [
          { id: 1456, name: "Alabama", code: "AL" },
          { id: 1400, name: "Alaska", code: "AK" },
          { id: 1424, name: "American Samoa", code: "AS" },
          { id: 1434, name: "Arizona", code: "AZ" },
          { id: 1444, name: "Arkansas", code: "AR" },
          { id: 1402, name: "Baker Island", code: "UM-81" },
          { id: 1416, name: "California", code: "CA" },
          { id: 1450, name: "Colorado", code: "CO" },
          { id: 1435, name: "Connecticut", code: "CT" },
          { id: 1399, name: "Delaware", code: "DE" },
          { id: 1437, name: "District of Columbia", code: "DC" },
          { id: 1436, name: "Florida", code: "FL" },
          { id: 1455, name: "Georgia", code: "GA" },
          { id: 1412, name: "Guam", code: "GU" },
          { id: 1411, name: "Hawaii", code: "HI" },
          { id: 1398, name: "Howland Island", code: "UM-84" },
          { id: 1460, name: "Idaho", code: "ID" },
          { id: 1425, name: "Illinois", code: "IL" },
          { id: 1440, name: "Indiana", code: "IN" },
          { id: 1459, name: "Iowa", code: "IA" },
          { id: 1410, name: "Jarvis Island", code: "UM-86" },
          { id: 1428, name: "Johnston Atoll", code: "UM-67" },
          { id: 1406, name: "Kansas", code: "KS" },
          { id: 1419, name: "Kentucky", code: "KY" },
          { id: 1403, name: "Kingman Reef", code: "UM-89" },
          { id: 1457, name: "Louisiana", code: "LA" },
          { id: 1453, name: "Maine", code: "ME" },
          { id: 1401, name: "Maryland", code: "MD" },
          { id: 1433, name: "Massachusetts", code: "MA" },
          { id: 1426, name: "Michigan", code: "MI" },
          { id: 1438, name: "Midway Atoll", code: "UM-71" },
          { id: 1420, name: "Minnesota", code: "MN" },
          { id: 1430, name: "Mississippi", code: "MS" },
          { id: 1451, name: "Missouri", code: "MO" },
          { id: 1446, name: "Montana", code: "MT" },
          { id: 1439, name: "Navassa Island", code: "UM-76" },
          { id: 1408, name: "Nebraska", code: "NE" },
          { id: 1458, name: "Nevada", code: "NV" },
          { id: 1404, name: "New Hampshire", code: "NH" },
          { id: 1417, name: "New Jersey", code: "NJ" },
          { id: 1423, name: "New Mexico", code: "NM" },
          { id: 1452, name: "New York", code: "NY" },
          { id: 1447, name: "North Carolina", code: "NC" },
          { id: 1418, name: "North Dakota", code: "ND" },
          { id: 1431, name: "Northern Mariana Islands", code: "MP" },
          { id: 4851, name: "Ohio", code: "OH" },
          { id: 1421, name: "Oklahoma", code: "OK" },
          { id: 1415, name: "Oregon", code: "OR" },
          { id: 1448, name: "Palmyra Atoll", code: "UM-95" },
          { id: 1422, name: "Pennsylvania", code: "PA" },
          { id: 1449, name: "Puerto Rico", code: "PR" },
          { id: 1461, name: "Rhode Island", code: "RI" },
          { id: 1443, name: "South Carolina", code: "SC" },
          { id: 1445, name: "South Dakota", code: "SD" },
          { id: 1454, name: "Tennessee", code: "TN" },
          { id: 1407, name: "Texas", code: "TX" },
          {
            id: 1432,
            name: "United States Minor Outlying Islands",
            code: "UM"
          },
          { id: 1413, name: "United States Virgin Islands", code: "VI" },
          { id: 1414, name: "Utah", code: "UT" },
          { id: 1409, name: "Vermont", code: "VT" },
          { id: 1427, name: "Virginia", code: "VA" },
          { id: 1405, name: "Wake Island", code: "UM-79" },
          { id: 1462, name: "Washington", code: "WA" },
          { id: 1429, name: "West Virginia", code: "WV" },
          { id: 1441, name: "Wisconsin", code: "WI" },
          { id: 1442, name: "Wyoming", code: "WY" }
        ]
      },
      {
        code: "UMI",
        name: "United States Minor Outlying Islands",
        states: [
          { id: 5212, name: "Baker Island", code: "81" },
          { id: 5213, name: "Howland Island", code: "84" },
          { id: 5214, name: "Jarvis Island", code: "86" },
          { id: 5215, name: "Johnston Atoll", code: "67" },
          { id: 5216, name: "Kingman Reef", code: "89" },
          { id: 5217, name: "Midway Islands", code: "71" },
          { id: 5218, name: "Navassa Island", code: "76" },
          { id: 5219, name: "Palmyra Atoll", code: "95" },
          { id: 5220, name: "Wake Island", code: "79" }
        ]
      },
      {
        code: "URY",
        name: "Uruguay",
        states: [
          { id: 3205, name: "Artigas Department", code: "AR" },
          { id: 3213, name: "Canelones Department", code: "CA" },
          { id: 3211, name: "Cerro Largo Department", code: "CL" },
          { id: 3208, name: "Colonia Department", code: "CO" },
          { id: 3209, name: "Durazno Department", code: "DU" },
          { id: 3203, name: "Flores Department", code: "FS" },
          { id: 3217, name: "Florida Department", code: "FD" },
          { id: 3215, name: "Lavalleja Department", code: "LA" },
          { id: 3206, name: "Maldonado Department", code: "MA" },
          { id: 3218, name: "Montevideo Department", code: "MO" },
          { id: 3212, name: "Paysand\xFA Department", code: "PA" },
          { id: 3210, name: "R\xEDo Negro Department", code: "RN" },
          { id: 3207, name: "Rivera Department", code: "RV" },
          { id: 3216, name: "Rocha Department", code: "RO" },
          { id: 3220, name: "Salto Department", code: "SA" },
          { id: 3204, name: "San Jos\xE9 Department", code: "SJ" },
          { id: 3219, name: "Soriano Department", code: "SO" },
          { id: 3221, name: "Tacuaremb\xF3 Department", code: "TA" },
          { id: 3214, name: "Treinta y Tres Department", code: "TT" }
        ]
      },
      {
        code: "UZB",
        name: "Uzbekistan",
        states: [
          { id: 2540, name: "Andijan Region", code: "AN" },
          { id: 2541, name: "Bukhara Region", code: "BU" },
          { id: 2538, name: "Fergana Region", code: "FA" },
          { id: 2545, name: "Jizzakh Region", code: "JI" },
          { id: 2548, name: "Karakalpakstan", code: "QR" },
          { id: 2537, name: "Namangan Region", code: "NG" },
          { id: 2542, name: "Navoiy Region", code: "NW" },
          { id: 2543, name: "Qashqadaryo Region", code: "QA" },
          { id: 2544, name: "Samarqand Region", code: "SA" },
          { id: 2547, name: "Sirdaryo Region", code: "SI" },
          { id: 2546, name: "Surxondaryo Region", code: "SU" },
          { id: 2536, name: "Tashkent", code: "TK" },
          { id: 2549, name: "Tashkent Region", code: "TO" },
          { id: 2539, name: "Xorazm Region", code: "XO" }
        ]
      },
      {
        code: "VUT",
        name: "Vanuatu",
        states: [
          { id: 4775, name: "Malampa", code: "MAP" },
          { id: 4773, name: "Penama", code: "PAM" },
          { id: 4776, name: "Sanma", code: "SAM" },
          { id: 4774, name: "Shefa", code: "SEE" },
          { id: 4777, name: "Tafea", code: "TAE" },
          { id: 4772, name: "Torba", code: "TOB" }
        ]
      },
      { code: "VAT", name: "Vatican City State (Holy See)", states: [] },
      {
        code: "VEN",
        name: "Venezuela",
        states: [
          { id: 2044, name: "Amazonas", code: "Z" },
          { id: 2050, name: "Anzo\xE1tegui", code: "B" },
          { id: 4856, name: "Apure", code: "C" },
          { id: 2047, name: "Aragua", code: "D" },
          { id: 2049, name: "Barinas", code: "E" },
          { id: 2039, name: "Bol\xEDvar", code: "F" },
          { id: 2040, name: "Carabobo", code: "G" },
          { id: 2034, name: "Cojedes", code: "H" },
          { id: 2051, name: "Delta Amacuro", code: "Y" },
          { id: 4855, name: "Distrito Capital", code: "A" },
          { id: 2035, name: "Falc\xF3n", code: "I" },
          { id: 2046, name: "Federal Dependencies of Venezuela", code: "W" },
          { id: 2045, name: "Gu\xE1rico", code: "J" },
          { id: 2055, name: "La Guaira", code: "X" },
          { id: 2038, name: "Lara", code: "K" },
          { id: 2053, name: "M\xE9rida", code: "L" },
          { id: 2037, name: "Miranda", code: "M" },
          { id: 2054, name: "Monagas", code: "N" },
          { id: 2052, name: "Nueva Esparta", code: "O" },
          { id: 2036, name: "Portuguesa", code: "P" },
          { id: 2056, name: "Sucre", code: "R" },
          { id: 2048, name: "T\xE1chira", code: "S" },
          { id: 2043, name: "Trujillo", code: "T" },
          { id: 2041, name: "Yaracuy", code: "U" },
          { id: 2042, name: "Zulia", code: "V" }
        ]
      },
      {
        code: "VNM",
        name: "Vietnam",
        states: [
          { id: 3794, name: "An Giang", code: "44" },
          { id: 3770, name: "B\xE0 R\u1ECBa-V\u0169ng T\xE0u", code: "43" },
          { id: 3815, name: "B\u1EAFc Giang", code: "54" },
          { id: 3822, name: "B\u1EAFc K\u1EA1n", code: "53" },
          { id: 3804, name: "B\u1EA1c Li\xEAu", code: "55" },
          { id: 3791, name: "B\u1EAFc Ninh", code: "56" },
          { id: 3796, name: "B\u1EBFn Tre", code: "50" },
          { id: 3785, name: "B\xECnh D\u01B0\u01A1ng", code: "57" },
          { id: 3830, name: "B\xECnh \u0110\u1ECBnh", code: "31" },
          { id: 3797, name: "B\xECnh Ph\u01B0\u1EDBc", code: "58" },
          { id: 3787, name: "B\xECnh Thu\u1EADn", code: "40" },
          { id: 3778, name: "C\xE0 Mau", code: "59" },
          { id: 4925, name: "C\u1EA7n Th\u01A1", code: "CT" },
          { id: 3782, name: "Cao B\u1EB1ng", code: "04" },
          { id: 3806, name: "\u0110\xE0 N\u1EB5ng", code: "DN" },
          { id: 3829, name: "\u0110\u1EAFk L\u1EAFk", code: "33" },
          { id: 3823, name: "\u0110\u1EAFk N\xF4ng", code: "72" },
          { id: 3773, name: "\u0110i\u1EC7n Bi\xEAn", code: "71" },
          { id: 3821, name: "\u0110\u1ED3ng Nai", code: "39" },
          { id: 3769, name: "\u0110\u1ED3ng Th\xE1p", code: "45" },
          { id: 3813, name: "Gia Lai", code: "30" },
          { id: 3779, name: "H\xE0 Giang", code: "03" },
          { id: 3802, name: "H\xE0 Nam", code: "63" },
          { id: 3810, name: "H\xE0 N\u1ED9i", code: "HN" },
          { id: 3816, name: "H\xE0 T\u0129nh", code: "23" },
          { id: 3827, name: "H\u1EA3i D\u01B0\u01A1ng", code: "61" },
          { id: 3783, name: "H\u1EA3i Ph\xF2ng", code: "HP" },
          { id: 3777, name: "H\u1EADu Giang", code: "73" },
          { id: 3811, name: "H\u1ED3 Ch\xED Minh", code: "SG" },
          { id: 3799, name: "H\xF2a B\xECnh", code: "14" },
          { id: 3768, name: "H\u01B0ng Y\xEAn", code: "66" },
          { id: 3793, name: "Kh\xE1nh H\xF2a", code: "34" },
          { id: 3800, name: "Ki\xEAn Giang", code: "47" },
          { id: 3772, name: "Kon Tum", code: "28" },
          { id: 3825, name: "Lai Ch\xE2u", code: "01" },
          { id: 3818, name: "L\xE2m \u0110\u1ED3ng", code: "35" },
          { id: 3792, name: "L\u1EA1ng S\u01A1n", code: "09" },
          { id: 3817, name: "L\xE0o Cai", code: "02" },
          { id: 3808, name: "Long An", code: "41" },
          { id: 3789, name: "Nam \u0110\u1ECBnh", code: "67" },
          { id: 3780, name: "Ngh\u1EC7 An", code: "22" },
          { id: 3786, name: "Ninh B\xECnh", code: "18" },
          { id: 3788, name: "Ninh Thu\u1EADn", code: "36" },
          { id: 3801, name: "Ph\xFA Th\u1ECD", code: "68" },
          { id: 3824, name: "Ph\xFA Y\xEAn", code: "32" },
          { id: 3809, name: "Qu\u1EA3ng B\xECnh", code: "24" },
          { id: 3776, name: "Qu\u1EA3ng Nam", code: "27" },
          { id: 3828, name: "Qu\u1EA3ng Ng\xE3i", code: "29" },
          { id: 3814, name: "Qu\u1EA3ng Ninh", code: "13" },
          { id: 3803, name: "Qu\u1EA3ng Tr\u1ECB", code: "25" },
          { id: 3819, name: "S\xF3c Tr\u0103ng", code: "52" },
          { id: 3812, name: "S\u01A1n La", code: "05" },
          { id: 3826, name: "T\xE2y Ninh", code: "37" },
          { id: 3775, name: "Th\xE1i B\xECnh", code: "20" },
          { id: 3807, name: "Th\xE1i Nguy\xEAn", code: "69" },
          { id: 3771, name: "Thanh H\xF3a", code: "21" },
          { id: 3798, name: "Th\u1EEBa Thi\xEAn-Hu\u1EBF", code: "26" },
          { id: 3781, name: "Ti\u1EC1n Giang", code: "46" },
          { id: 3805, name: "Tr\xE0 Vinh", code: "51" },
          { id: 3795, name: "Tuy\xEAn Quang", code: "07" },
          { id: 3790, name: "V\u0129nh Long", code: "49" },
          { id: 3774, name: "V\u0129nh Ph\xFAc", code: "70" },
          { id: 3784, name: "Y\xEAn B\xE1i", code: "06" }
        ]
      },
      { code: "VGB", name: "Virgin Islands (British)", states: [] },
      {
        code: "VIR",
        name: "Virgin Islands (US)",
        states: [
          { id: 5074, name: "Saint Croix", code: "SC" },
          { id: 5073, name: "Saint John", code: "SJ" },
          { id: 5072, name: "Saint Thomas", code: "ST" }
        ]
      },
      { code: "WLF", name: "Wallis And Futuna Islands", states: [] },
      { code: "ESH", name: "Western Sahara", states: [] },
      {
        code: "YEM",
        name: "Yemen",
        states: [
          { id: 1242, name: "'Adan", code: "AD" },
          { id: 1250, name: "'Amran", code: "AM" },
          { id: 1237, name: "Abyan", code: "AB" },
          { id: 1240, name: "Al Bayda'", code: "BA" },
          { id: 1241, name: "Al Hudaydah", code: "HU" },
          { id: 1243, name: "Al Jawf", code: "JA" },
          { id: 1251, name: "Al Mahrah", code: "MR" },
          { id: 1235, name: "Al Mahwit", code: "MW" },
          { id: 1232, name: "Amanat Al Asimah", code: "SA" },
          { id: 1246, name: "Dhamar", code: "DH" },
          { id: 1238, name: "Hadhramaut", code: "HD" },
          { id: 1244, name: "Hajjah", code: "HJ" },
          { id: 1233, name: "Ibb", code: "IB" },
          { id: 1245, name: "Lahij", code: "LA" },
          { id: 1234, name: "Ma'rib", code: "MA" },
          { id: 1248, name: "Raymah", code: "RA" },
          { id: 1249, name: "Saada", code: "SD" },
          { id: 1236, name: "Sana'a", code: "SN" },
          { id: 1247, name: "Shabwah", code: "SH" },
          { id: 1239, name: "Socotra", code: "SU" },
          { id: 1231, name: "Ta'izz", code: "TA" }
        ]
      },
      {
        code: "ZMB",
        name: "Zambia",
        states: [
          { id: 1986, name: "Central Province", code: "02" },
          { id: 1984, name: "Copperbelt Province", code: "08" },
          { id: 1991, name: "Eastern Province", code: "03" },
          { id: 1987, name: "Luapula Province", code: "04" },
          { id: 1988, name: "Lusaka Province", code: "09" },
          { id: 1989, name: "Muchinga Province", code: "10" },
          { id: 1982, name: "Northern Province", code: "05" },
          { id: 1985, name: "Northwestern Province", code: "06" },
          { id: 1990, name: "Southern Province", code: "07" },
          { id: 1983, name: "Western Province", code: "01" }
        ]
      },
      {
        code: "ZWE",
        name: "Zimbabwe",
        states: [
          { id: 1956, name: "Bulawayo Province", code: "BU" },
          { id: 1958, name: "Harare Province", code: "HA" },
          { id: 1959, name: "Manicaland", code: "MA" },
          { id: 1955, name: "Mashonaland Central Province", code: "MC" },
          { id: 1951, name: "Mashonaland East Province", code: "ME" },
          { id: 1953, name: "Mashonaland West Province", code: "MW" },
          { id: 1960, name: "Masvingo Province", code: "MV" },
          { id: 1954, name: "Matabeleland North Province", code: "MN" },
          { id: 1952, name: "Matabeleland South Province", code: "MS" },
          { id: 1957, name: "Midlands Province", code: "MI" }
        ]
      }
    ];
    var DEFAULT_CURRENCY3 = "ARS";
    var DEFAULT_LOCALE5 = "es-AR";
    var DEFAULT_COUNTRY_CODE2 = "ARG";
    var countryCodesAndName = () => countryAndStates4.map((c2) => {
      return {
        code: c2.code,
        name: c2.name
      };
    });
    var EXP_LIMIT = 9e15;
    var MAX_DIGITS = 1e9;
    var NUMERALS = "0123456789abcdef";
    var LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058";
    var PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789";
    var DEFAULTS = {
      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.
      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,
      // 1 to MAX_DIGITS
      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,
      // 0 to 8
      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,
      // 0 to 9
      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,
      // 0 to -EXP_LIMIT
      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos: 21,
      // 0 to EXP_LIMIT
      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -EXP_LIMIT,
      // -1 to -EXP_LIMIT
      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: EXP_LIMIT,
      // 1 to EXP_LIMIT
      // Whether to use cryptographically-secure random number generation, if available.
      crypto: false
      // true/false
    };
    var inexact;
    var quadrant;
    var external = true;
    var decimalError = "[DecimalError] ";
    var invalidArgument = decimalError + "Invalid argument: ";
    var precisionLimitExceeded = decimalError + "Precision limit exceeded";
    var cryptoUnavailable = decimalError + "crypto unavailable";
    var tag = "[object Decimal]";
    var mathfloor = Math.floor;
    var mathpow = Math.pow;
    var isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i;
    var isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i;
    var isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i;
    var isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    var BASE = 1e7;
    var LOG_BASE = 7;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var LN10_PRECISION = LN10.length - 1;
    var PI_PRECISION = PI.length - 1;
    var P = { toStringTag: tag };
    P.absoluteValue = P.abs = function() {
      var x2 = new this.constructor(this);
      if (x2.s < 0) x2.s = 1;
      return finalise(x2);
    };
    P.ceil = function() {
      return finalise(new this.constructor(this), this.e + 1, 2);
    };
    P.clampedTo = P.clamp = function(min22, max22) {
      var k2, x2 = this, Ctor = x2.constructor;
      min22 = new Ctor(min22);
      max22 = new Ctor(max22);
      if (!min22.s || !max22.s) return new Ctor(NaN);
      if (min22.gt(max22)) throw Error(invalidArgument + max22);
      k2 = x2.cmp(min22);
      return k2 < 0 ? min22 : x2.cmp(max22) > 0 ? max22 : new Ctor(x2);
    };
    P.comparedTo = P.cmp = function(y3) {
      var i2, j, xdL, ydL, x2 = this, xd = x2.d, yd = (y3 = new x2.constructor(y3)).d, xs = x2.s, ys = y3.s;
      if (!xd || !yd) {
        return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
      }
      if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
      if (xs !== ys) return xs;
      if (x2.e !== y3.e) return x2.e > y3.e ^ xs < 0 ? 1 : -1;
      xdL = xd.length;
      ydL = yd.length;
      for (i2 = 0, j = xdL < ydL ? xdL : ydL; i2 < j; ++i2) {
        if (xd[i2] !== yd[i2]) return xd[i2] > yd[i2] ^ xs < 0 ? 1 : -1;
      }
      return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    P.cosine = P.cos = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (!x2.d) return new Ctor(NaN);
      if (!x2.d[0]) return new Ctor(1);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x2.e, x2.sd()) + LOG_BASE;
      Ctor.rounding = 1;
      x2 = cosine(Ctor, toLessThanHalfPi(Ctor, x2));
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return finalise(quadrant == 2 || quadrant == 3 ? x2.neg() : x2, pr, rm, true);
    };
    P.cubeRoot = P.cbrt = function() {
      var e2, m3, n, r, rep, s3, sd, t2, t3, t3plusx, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite() || x2.isZero()) return new Ctor(x2);
      external = false;
      s3 = x2.s * mathpow(x2.s * x2, 1 / 3);
      if (!s3 || Math.abs(s3) == 1 / 0) {
        n = digitsToString(x2.d);
        e2 = x2.e;
        if (s3 = (e2 - n.length + 1) % 3) n += s3 == 1 || s3 == -2 ? "0" : "00";
        s3 = mathpow(n, 1 / 3);
        e2 = mathfloor((e2 + 1) / 3) - (e2 % 3 == (e2 < 0 ? -1 : 2));
        if (s3 == 1 / 0) {
          n = "5e" + e2;
        } else {
          n = s3.toExponential();
          n = n.slice(0, n.indexOf("e") + 1) + e2;
        }
        r = new Ctor(n);
        r.s = x2.s;
      } else {
        r = new Ctor(s3.toString());
      }
      sd = (e2 = Ctor.precision) + 3;
      for (; ; ) {
        t2 = r;
        t3 = t2.times(t2).times(t2);
        t3plusx = t3.plus(x2);
        r = divide(t3plusx.plus(x2).times(t2), t3plusx.plus(t3), sd + 2, 1);
        if (digitsToString(t2.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
          n = n.slice(sd - 3, sd + 1);
          if (n == "9999" || !rep && n == "4999") {
            if (!rep) {
              finalise(t2, e2 + 1, 0);
              if (t2.times(t2).times(t2).eq(x2)) {
                r = t2;
                break;
              }
            }
            sd += 4;
            rep = 1;
          } else {
            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
              finalise(r, e2 + 1, 1);
              m3 = !r.times(r).times(r).eq(x2);
            }
            break;
          }
        }
      }
      external = true;
      return finalise(r, e2, Ctor.rounding, m3);
    };
    P.decimalPlaces = P.dp = function() {
      var w2, d3 = this.d, n = NaN;
      if (d3) {
        w2 = d3.length - 1;
        n = (w2 - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
        w2 = d3[w2];
        if (w2) for (; w2 % 10 == 0; w2 /= 10) n--;
        if (n < 0) n = 0;
      }
      return n;
    };
    P.dividedBy = P.div = function(y3) {
      return divide(this, new this.constructor(y3));
    };
    P.dividedToIntegerBy = P.divToInt = function(y3) {
      var x2 = this, Ctor = x2.constructor;
      return finalise(divide(x2, new Ctor(y3), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    P.equals = P.eq = function(y3) {
      return this.cmp(y3) === 0;
    };
    P.floor = function() {
      return finalise(new this.constructor(this), this.e + 1, 3);
    };
    P.greaterThan = P.gt = function(y3) {
      return this.cmp(y3) > 0;
    };
    P.greaterThanOrEqualTo = P.gte = function(y3) {
      var k2 = this.cmp(y3);
      return k2 == 1 || k2 === 0;
    };
    P.hyperbolicCosine = P.cosh = function() {
      var k2, n, pr, rm, len, x2 = this, Ctor = x2.constructor, one = new Ctor(1);
      if (!x2.isFinite()) return new Ctor(x2.s ? 1 / 0 : NaN);
      if (x2.isZero()) return one;
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x2.e, x2.sd()) + 4;
      Ctor.rounding = 1;
      len = x2.d.length;
      if (len < 32) {
        k2 = Math.ceil(len / 3);
        n = (1 / tinyPow(4, k2)).toString();
      } else {
        k2 = 16;
        n = "2.3283064365386962890625e-10";
      }
      x2 = taylorSeries(Ctor, 1, x2.times(n), new Ctor(1), true);
      var cosh2_x, i2 = k2, d8 = new Ctor(8);
      for (; i2--; ) {
        cosh2_x = x2.times(x2);
        x2 = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
      }
      return finalise(x2, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    P.hyperbolicSine = P.sinh = function() {
      var k2, pr, rm, len, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite() || x2.isZero()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x2.e, x2.sd()) + 4;
      Ctor.rounding = 1;
      len = x2.d.length;
      if (len < 3) {
        x2 = taylorSeries(Ctor, 2, x2, x2, true);
      } else {
        k2 = 1.4 * Math.sqrt(len);
        k2 = k2 > 16 ? 16 : k2 | 0;
        x2 = x2.times(1 / tinyPow(5, k2));
        x2 = taylorSeries(Ctor, 2, x2, x2, true);
        var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for (; k2--; ) {
          sinh2_x = x2.times(x2);
          x2 = x2.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
        }
      }
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return finalise(x2, pr, rm, true);
    };
    P.hyperbolicTangent = P.tanh = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite()) return new Ctor(x2.s);
      if (x2.isZero()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 7;
      Ctor.rounding = 1;
      return divide(x2.sinh(), x2.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    P.inverseCosine = P.acos = function() {
      var halfPi, x2 = this, Ctor = x2.constructor, k2 = x2.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
      if (k2 !== -1) {
        return k2 === 0 ? x2.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
      }
      if (x2.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
      Ctor.precision = pr + 6;
      Ctor.rounding = 1;
      x2 = x2.asin();
      halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return halfPi.minus(x2);
    };
    P.inverseHyperbolicCosine = P.acosh = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (x2.lte(1)) return new Ctor(x2.eq(1) ? 0 : NaN);
      if (!x2.isFinite()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(Math.abs(x2.e), x2.sd()) + 4;
      Ctor.rounding = 1;
      external = false;
      x2 = x2.times(x2).minus(1).sqrt().plus(x2);
      external = true;
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return x2.ln();
    };
    P.inverseHyperbolicSine = P.asinh = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite() || x2.isZero()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 2 * Math.max(Math.abs(x2.e), x2.sd()) + 6;
      Ctor.rounding = 1;
      external = false;
      x2 = x2.times(x2).plus(1).sqrt().plus(x2);
      external = true;
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return x2.ln();
    };
    P.inverseHyperbolicTangent = P.atanh = function() {
      var pr, rm, wpr, xsd, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite()) return new Ctor(NaN);
      if (x2.e >= 0) return new Ctor(x2.abs().eq(1) ? x2.s / 0 : x2.isZero() ? x2 : NaN);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      xsd = x2.sd();
      if (Math.max(xsd, pr) < 2 * -x2.e - 1) return finalise(new Ctor(x2), pr, rm, true);
      Ctor.precision = wpr = xsd - x2.e;
      x2 = divide(x2.plus(1), new Ctor(1).minus(x2), wpr + pr, 1);
      Ctor.precision = pr + 4;
      Ctor.rounding = 1;
      x2 = x2.ln();
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return x2.times(0.5);
    };
    P.inverseSine = P.asin = function() {
      var halfPi, k2, pr, rm, x2 = this, Ctor = x2.constructor;
      if (x2.isZero()) return new Ctor(x2);
      k2 = x2.abs().cmp(1);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      if (k2 !== -1) {
        if (k2 === 0) {
          halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
          halfPi.s = x2.s;
          return halfPi;
        }
        return new Ctor(NaN);
      }
      Ctor.precision = pr + 6;
      Ctor.rounding = 1;
      x2 = x2.div(new Ctor(1).minus(x2.times(x2)).sqrt().plus(1)).atan();
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return x2.times(2);
    };
    P.inverseTangent = P.atan = function() {
      var i2, j, k2, n, px, t2, r, wpr, x2, x3 = this, Ctor = x3.constructor, pr = Ctor.precision, rm = Ctor.rounding;
      if (!x3.isFinite()) {
        if (!x3.s) return new Ctor(NaN);
        if (pr + 4 <= PI_PRECISION) {
          r = getPi(Ctor, pr + 4, rm).times(0.5);
          r.s = x3.s;
          return r;
        }
      } else if (x3.isZero()) {
        return new Ctor(x3);
      } else if (x3.abs().eq(1) && pr + 4 <= PI_PRECISION) {
        r = getPi(Ctor, pr + 4, rm).times(0.25);
        r.s = x3.s;
        return r;
      }
      Ctor.precision = wpr = pr + 10;
      Ctor.rounding = 1;
      k2 = Math.min(28, wpr / LOG_BASE + 2 | 0);
      for (i2 = k2; i2; --i2) x3 = x3.div(x3.times(x3).plus(1).sqrt().plus(1));
      external = false;
      j = Math.ceil(wpr / LOG_BASE);
      n = 1;
      x2 = x3.times(x3);
      r = new Ctor(x3);
      px = x3;
      for (; i2 !== -1; ) {
        px = px.times(x2);
        t2 = r.minus(px.div(n += 2));
        px = px.times(x2);
        r = t2.plus(px.div(n += 2));
        if (r.d[j] !== void 0) for (i2 = j; r.d[i2] === t2.d[i2] && i2--; ) ;
      }
      if (k2) r = r.times(2 << k2 - 1);
      external = true;
      return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    P.isFinite = function() {
      return !!this.d;
    };
    P.isInteger = P.isInt = function() {
      return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    P.isNaN = function() {
      return !this.s;
    };
    P.isNegative = P.isNeg = function() {
      return this.s < 0;
    };
    P.isPositive = P.isPos = function() {
      return this.s > 0;
    };
    P.isZero = function() {
      return !!this.d && this.d[0] === 0;
    };
    P.lessThan = P.lt = function(y3) {
      return this.cmp(y3) < 0;
    };
    P.lessThanOrEqualTo = P.lte = function(y3) {
      return this.cmp(y3) < 1;
    };
    P.logarithm = P.log = function(base) {
      var isBase10, d3, denominator, k2, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
      if (base == null) {
        base = new Ctor(10);
        isBase10 = true;
      } else {
        base = new Ctor(base);
        d3 = base.d;
        if (base.s < 0 || !d3 || !d3[0] || base.eq(1)) return new Ctor(NaN);
        isBase10 = base.eq(10);
      }
      d3 = arg.d;
      if (arg.s < 0 || !d3 || !d3[0] || arg.eq(1)) {
        return new Ctor(d3 && !d3[0] ? -1 / 0 : arg.s != 1 ? NaN : d3 ? 0 : 1 / 0);
      }
      if (isBase10) {
        if (d3.length > 1) {
          inf = true;
        } else {
          for (k2 = d3[0]; k2 % 10 === 0; ) k2 /= 10;
          inf = k2 !== 1;
        }
      }
      external = false;
      sd = pr + guard;
      num = naturalLogarithm(arg, sd);
      denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
      r = divide(num, denominator, sd, 1);
      if (checkRoundingDigits(r.d, k2 = pr, rm)) {
        do {
          sd += 10;
          num = naturalLogarithm(arg, sd);
          denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
          r = divide(num, denominator, sd, 1);
          if (!inf) {
            if (+digitsToString(r.d).slice(k2 + 1, k2 + 15) + 1 == 1e14) {
              r = finalise(r, pr + 1, 0);
            }
            break;
          }
        } while (checkRoundingDigits(r.d, k2 += 10, rm));
      }
      external = true;
      return finalise(r, pr, rm);
    };
    P.minus = P.sub = function(y3) {
      var d3, e2, i2, j, k2, len, pr, rm, xd, xe, xLTy, yd, x2 = this, Ctor = x2.constructor;
      y3 = new Ctor(y3);
      if (!x2.d || !y3.d) {
        if (!x2.s || !y3.s) y3 = new Ctor(NaN);
        else if (x2.d) y3.s = -y3.s;
        else y3 = new Ctor(y3.d || x2.s !== y3.s ? x2 : NaN);
        return y3;
      }
      if (x2.s != y3.s) {
        y3.s = -y3.s;
        return x2.plus(y3);
      }
      xd = x2.d;
      yd = y3.d;
      pr = Ctor.precision;
      rm = Ctor.rounding;
      if (!xd[0] || !yd[0]) {
        if (yd[0]) y3.s = -y3.s;
        else if (xd[0]) y3 = new Ctor(x2);
        else return new Ctor(rm === 3 ? -0 : 0);
        return external ? finalise(y3, pr, rm) : y3;
      }
      e2 = mathfloor(y3.e / LOG_BASE);
      xe = mathfloor(x2.e / LOG_BASE);
      xd = xd.slice();
      k2 = xe - e2;
      if (k2) {
        xLTy = k2 < 0;
        if (xLTy) {
          d3 = xd;
          k2 = -k2;
          len = yd.length;
        } else {
          d3 = yd;
          e2 = xe;
          len = xd.length;
        }
        i2 = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
        if (k2 > i2) {
          k2 = i2;
          d3.length = 1;
        }
        d3.reverse();
        for (i2 = k2; i2--; ) d3.push(0);
        d3.reverse();
      } else {
        i2 = xd.length;
        len = yd.length;
        xLTy = i2 < len;
        if (xLTy) len = i2;
        for (i2 = 0; i2 < len; i2++) {
          if (xd[i2] != yd[i2]) {
            xLTy = xd[i2] < yd[i2];
            break;
          }
        }
        k2 = 0;
      }
      if (xLTy) {
        d3 = xd;
        xd = yd;
        yd = d3;
        y3.s = -y3.s;
      }
      len = xd.length;
      for (i2 = yd.length - len; i2 > 0; --i2) xd[len++] = 0;
      for (i2 = yd.length; i2 > k2; ) {
        if (xd[--i2] < yd[i2]) {
          for (j = i2; j && xd[--j] === 0; ) xd[j] = BASE - 1;
          --xd[j];
          xd[i2] += BASE;
        }
        xd[i2] -= yd[i2];
      }
      for (; xd[--len] === 0; ) xd.pop();
      for (; xd[0] === 0; xd.shift()) --e2;
      if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
      y3.d = xd;
      y3.e = getBase10Exponent(xd, e2);
      return external ? finalise(y3, pr, rm) : y3;
    };
    P.modulo = P.mod = function(y3) {
      var q2, x2 = this, Ctor = x2.constructor;
      y3 = new Ctor(y3);
      if (!x2.d || !y3.s || y3.d && !y3.d[0]) return new Ctor(NaN);
      if (!y3.d || x2.d && !x2.d[0]) {
        return finalise(new Ctor(x2), Ctor.precision, Ctor.rounding);
      }
      external = false;
      if (Ctor.modulo == 9) {
        q2 = divide(x2, y3.abs(), 0, 3, 1);
        q2.s *= y3.s;
      } else {
        q2 = divide(x2, y3, 0, Ctor.modulo, 1);
      }
      q2 = q2.times(y3);
      external = true;
      return x2.minus(q2);
    };
    P.naturalExponential = P.exp = function() {
      return naturalExponential(this);
    };
    P.naturalLogarithm = P.ln = function() {
      return naturalLogarithm(this);
    };
    P.negated = P.neg = function() {
      var x2 = new this.constructor(this);
      x2.s = -x2.s;
      return finalise(x2);
    };
    P.plus = P.add = function(y3) {
      var carry, d3, e2, i2, k2, len, pr, rm, xd, yd, x2 = this, Ctor = x2.constructor;
      y3 = new Ctor(y3);
      if (!x2.d || !y3.d) {
        if (!x2.s || !y3.s) y3 = new Ctor(NaN);
        else if (!x2.d) y3 = new Ctor(y3.d || x2.s === y3.s ? x2 : NaN);
        return y3;
      }
      if (x2.s != y3.s) {
        y3.s = -y3.s;
        return x2.minus(y3);
      }
      xd = x2.d;
      yd = y3.d;
      pr = Ctor.precision;
      rm = Ctor.rounding;
      if (!xd[0] || !yd[0]) {
        if (!yd[0]) y3 = new Ctor(x2);
        return external ? finalise(y3, pr, rm) : y3;
      }
      k2 = mathfloor(x2.e / LOG_BASE);
      e2 = mathfloor(y3.e / LOG_BASE);
      xd = xd.slice();
      i2 = k2 - e2;
      if (i2) {
        if (i2 < 0) {
          d3 = xd;
          i2 = -i2;
          len = yd.length;
        } else {
          d3 = yd;
          e2 = k2;
          len = xd.length;
        }
        k2 = Math.ceil(pr / LOG_BASE);
        len = k2 > len ? k2 + 1 : len + 1;
        if (i2 > len) {
          i2 = len;
          d3.length = 1;
        }
        d3.reverse();
        for (; i2--; ) d3.push(0);
        d3.reverse();
      }
      len = xd.length;
      i2 = yd.length;
      if (len - i2 < 0) {
        i2 = len;
        d3 = yd;
        yd = xd;
        xd = d3;
      }
      for (carry = 0; i2; ) {
        carry = (xd[--i2] = xd[i2] + yd[i2] + carry) / BASE | 0;
        xd[i2] %= BASE;
      }
      if (carry) {
        xd.unshift(carry);
        ++e2;
      }
      for (len = xd.length; xd[--len] == 0; ) xd.pop();
      y3.d = xd;
      y3.e = getBase10Exponent(xd, e2);
      return external ? finalise(y3, pr, rm) : y3;
    };
    P.precision = P.sd = function(z110) {
      var k2, x2 = this;
      if (z110 !== void 0 && z110 !== !!z110 && z110 !== 1 && z110 !== 0) throw Error(invalidArgument + z110);
      if (x2.d) {
        k2 = getPrecision(x2.d);
        if (z110 && x2.e + 1 > k2) k2 = x2.e + 1;
      } else {
        k2 = NaN;
      }
      return k2;
    };
    P.round = function() {
      var x2 = this, Ctor = x2.constructor;
      return finalise(new Ctor(x2), x2.e + 1, Ctor.rounding);
    };
    P.sine = P.sin = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite()) return new Ctor(NaN);
      if (x2.isZero()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + Math.max(x2.e, x2.sd()) + LOG_BASE;
      Ctor.rounding = 1;
      x2 = sine(Ctor, toLessThanHalfPi(Ctor, x2));
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return finalise(quadrant > 2 ? x2.neg() : x2, pr, rm, true);
    };
    P.squareRoot = P.sqrt = function() {
      var m3, n, sd, r, rep, t2, x2 = this, d3 = x2.d, e2 = x2.e, s3 = x2.s, Ctor = x2.constructor;
      if (s3 !== 1 || !d3 || !d3[0]) {
        return new Ctor(!s3 || s3 < 0 && (!d3 || d3[0]) ? NaN : d3 ? x2 : 1 / 0);
      }
      external = false;
      s3 = Math.sqrt(+x2);
      if (s3 == 0 || s3 == 1 / 0) {
        n = digitsToString(d3);
        if ((n.length + e2) % 2 == 0) n += "0";
        s3 = Math.sqrt(n);
        e2 = mathfloor((e2 + 1) / 2) - (e2 < 0 || e2 % 2);
        if (s3 == 1 / 0) {
          n = "5e" + e2;
        } else {
          n = s3.toExponential();
          n = n.slice(0, n.indexOf("e") + 1) + e2;
        }
        r = new Ctor(n);
      } else {
        r = new Ctor(s3.toString());
      }
      sd = (e2 = Ctor.precision) + 3;
      for (; ; ) {
        t2 = r;
        r = t2.plus(divide(x2, t2, sd + 2, 1)).times(0.5);
        if (digitsToString(t2.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
          n = n.slice(sd - 3, sd + 1);
          if (n == "9999" || !rep && n == "4999") {
            if (!rep) {
              finalise(t2, e2 + 1, 0);
              if (t2.times(t2).eq(x2)) {
                r = t2;
                break;
              }
            }
            sd += 4;
            rep = 1;
          } else {
            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
              finalise(r, e2 + 1, 1);
              m3 = !r.times(r).eq(x2);
            }
            break;
          }
        }
      }
      external = true;
      return finalise(r, e2, Ctor.rounding, m3);
    };
    P.tangent = P.tan = function() {
      var pr, rm, x2 = this, Ctor = x2.constructor;
      if (!x2.isFinite()) return new Ctor(NaN);
      if (x2.isZero()) return new Ctor(x2);
      pr = Ctor.precision;
      rm = Ctor.rounding;
      Ctor.precision = pr + 10;
      Ctor.rounding = 1;
      x2 = x2.sin();
      x2.s = 1;
      x2 = divide(x2, new Ctor(1).minus(x2.times(x2)).sqrt(), pr + 10, 0);
      Ctor.precision = pr;
      Ctor.rounding = rm;
      return finalise(quadrant == 2 || quadrant == 4 ? x2.neg() : x2, pr, rm, true);
    };
    P.times = P.mul = function(y3) {
      var carry, e2, i2, k2, r, rL, t2, xdL, ydL, x2 = this, Ctor = x2.constructor, xd = x2.d, yd = (y3 = new Ctor(y3)).d;
      y3.s *= x2.s;
      if (!xd || !xd[0] || !yd || !yd[0]) {
        return new Ctor(!y3.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y3.s / 0 : y3.s * 0);
      }
      e2 = mathfloor(x2.e / LOG_BASE) + mathfloor(y3.e / LOG_BASE);
      xdL = xd.length;
      ydL = yd.length;
      if (xdL < ydL) {
        r = xd;
        xd = yd;
        yd = r;
        rL = xdL;
        xdL = ydL;
        ydL = rL;
      }
      r = [];
      rL = xdL + ydL;
      for (i2 = rL; i2--; ) r.push(0);
      for (i2 = ydL; --i2 >= 0; ) {
        carry = 0;
        for (k2 = xdL + i2; k2 > i2; ) {
          t2 = r[k2] + yd[i2] * xd[k2 - i2 - 1] + carry;
          r[k2--] = t2 % BASE | 0;
          carry = t2 / BASE | 0;
        }
        r[k2] = (r[k2] + carry) % BASE | 0;
      }
      for (; !r[--rL]; ) r.pop();
      if (carry) ++e2;
      else r.shift();
      y3.d = r;
      y3.e = getBase10Exponent(r, e2);
      return external ? finalise(y3, Ctor.precision, Ctor.rounding) : y3;
    };
    P.toBinary = function(sd, rm) {
      return toStringBinary(this, 2, sd, rm);
    };
    P.toDecimalPlaces = P.toDP = function(dp, rm) {
      var x2 = this, Ctor = x2.constructor;
      x2 = new Ctor(x2);
      if (dp === void 0) return x2;
      checkInt32(dp, 0, MAX_DIGITS);
      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
      return finalise(x2, dp + x2.e + 1, rm);
    };
    P.toExponential = function(dp, rm) {
      var str, x2 = this, Ctor = x2.constructor;
      if (dp === void 0) {
        str = finiteToString(x2, true);
      } else {
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        x2 = finalise(new Ctor(x2), dp + 1, rm);
        str = finiteToString(x2, true, dp + 1);
      }
      return x2.isNeg() && !x2.isZero() ? "-" + str : str;
    };
    P.toFixed = function(dp, rm) {
      var str, y3, x2 = this, Ctor = x2.constructor;
      if (dp === void 0) {
        str = finiteToString(x2);
      } else {
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y3 = finalise(new Ctor(x2), dp + x2.e + 1, rm);
        str = finiteToString(y3, false, dp + y3.e + 1);
      }
      return x2.isNeg() && !x2.isZero() ? "-" + str : str;
    };
    P.toFraction = function(maxD) {
      var d3, d0, d1, d22, e2, k2, n, n0, n1, pr, q2, r, x2 = this, xd = x2.d, Ctor = x2.constructor;
      if (!xd) return new Ctor(x2);
      n1 = d0 = new Ctor(1);
      d1 = n0 = new Ctor(0);
      d3 = new Ctor(d1);
      e2 = d3.e = getPrecision(xd) - x2.e - 1;
      k2 = e2 % LOG_BASE;
      d3.d[0] = mathpow(10, k2 < 0 ? LOG_BASE + k2 : k2);
      if (maxD == null) {
        maxD = e2 > 0 ? d3 : n1;
      } else {
        n = new Ctor(maxD);
        if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
        maxD = n.gt(d3) ? e2 > 0 ? d3 : n1 : n;
      }
      external = false;
      n = new Ctor(digitsToString(xd));
      pr = Ctor.precision;
      Ctor.precision = e2 = xd.length * LOG_BASE * 2;
      for (; ; ) {
        q2 = divide(n, d3, 0, 1, 1);
        d22 = d0.plus(q2.times(d1));
        if (d22.cmp(maxD) == 1) break;
        d0 = d1;
        d1 = d22;
        d22 = n1;
        n1 = n0.plus(q2.times(d22));
        n0 = d22;
        d22 = d3;
        d3 = n.minus(q2.times(d22));
        n = d22;
      }
      d22 = divide(maxD.minus(d0), d1, 0, 1, 1);
      n0 = n0.plus(d22.times(n1));
      d0 = d0.plus(d22.times(d1));
      n0.s = n1.s = x2.s;
      r = divide(n1, d1, e2, 1).minus(x2).abs().cmp(divide(n0, d0, e2, 1).minus(x2).abs()) < 1 ? [n1, d1] : [n0, d0];
      Ctor.precision = pr;
      external = true;
      return r;
    };
    P.toHexadecimal = P.toHex = function(sd, rm) {
      return toStringBinary(this, 16, sd, rm);
    };
    P.toNearest = function(y3, rm) {
      var x2 = this, Ctor = x2.constructor;
      x2 = new Ctor(x2);
      if (y3 == null) {
        if (!x2.d) return x2;
        y3 = new Ctor(1);
        rm = Ctor.rounding;
      } else {
        y3 = new Ctor(y3);
        if (rm === void 0) {
          rm = Ctor.rounding;
        } else {
          checkInt32(rm, 0, 8);
        }
        if (!x2.d) return y3.s ? x2 : y3;
        if (!y3.d) {
          if (y3.s) y3.s = x2.s;
          return y3;
        }
      }
      if (y3.d[0]) {
        external = false;
        x2 = divide(x2, y3, 0, rm, 1).times(y3);
        external = true;
        finalise(x2);
      } else {
        y3.s = x2.s;
        x2 = y3;
      }
      return x2;
    };
    P.toNumber = function() {
      return +this;
    };
    P.toOctal = function(sd, rm) {
      return toStringBinary(this, 8, sd, rm);
    };
    P.toPower = P.pow = function(y3) {
      var e2, k2, pr, r, rm, s3, x2 = this, Ctor = x2.constructor, yn = +(y3 = new Ctor(y3));
      if (!x2.d || !y3.d || !x2.d[0] || !y3.d[0]) return new Ctor(mathpow(+x2, yn));
      x2 = new Ctor(x2);
      if (x2.eq(1)) return x2;
      pr = Ctor.precision;
      rm = Ctor.rounding;
      if (y3.eq(1)) return finalise(x2, pr, rm);
      e2 = mathfloor(y3.e / LOG_BASE);
      if (e2 >= y3.d.length - 1 && (k2 = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
        r = intPow(Ctor, x2, k2, pr);
        return y3.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
      }
      s3 = x2.s;
      if (s3 < 0) {
        if (e2 < y3.d.length - 1) return new Ctor(NaN);
        if ((y3.d[e2] & 1) == 0) s3 = 1;
        if (x2.e == 0 && x2.d[0] == 1 && x2.d.length == 1) {
          x2.s = s3;
          return x2;
        }
      }
      k2 = mathpow(+x2, yn);
      e2 = k2 == 0 || !isFinite(k2) ? mathfloor(yn * (Math.log("0." + digitsToString(x2.d)) / Math.LN10 + x2.e + 1)) : new Ctor(k2 + "").e;
      if (e2 > Ctor.maxE + 1 || e2 < Ctor.minE - 1) return new Ctor(e2 > 0 ? s3 / 0 : 0);
      external = false;
      Ctor.rounding = x2.s = 1;
      k2 = Math.min(12, (e2 + "").length);
      r = naturalExponential(y3.times(naturalLogarithm(x2, pr + k2)), pr);
      if (r.d) {
        r = finalise(r, pr + 5, 1);
        if (checkRoundingDigits(r.d, pr, rm)) {
          e2 = pr + 10;
          r = finalise(naturalExponential(y3.times(naturalLogarithm(x2, e2 + k2)), e2), e2 + 5, 1);
          if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
            r = finalise(r, pr + 1, 0);
          }
        }
      }
      r.s = s3;
      external = true;
      Ctor.rounding = rm;
      return finalise(r, pr, rm);
    };
    P.toPrecision = function(sd, rm) {
      var str, x2 = this, Ctor = x2.constructor;
      if (sd === void 0) {
        str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
      } else {
        checkInt32(sd, 1, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        x2 = finalise(new Ctor(x2), sd, rm);
        str = finiteToString(x2, sd <= x2.e || x2.e <= Ctor.toExpNeg, sd);
      }
      return x2.isNeg() && !x2.isZero() ? "-" + str : str;
    };
    P.toSignificantDigits = P.toSD = function(sd, rm) {
      var x2 = this, Ctor = x2.constructor;
      if (sd === void 0) {
        sd = Ctor.precision;
        rm = Ctor.rounding;
      } else {
        checkInt32(sd, 1, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
      }
      return finalise(new Ctor(x2), sd, rm);
    };
    P.toString = function() {
      var x2 = this, Ctor = x2.constructor, str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
      return x2.isNeg() && !x2.isZero() ? "-" + str : str;
    };
    P.truncated = P.trunc = function() {
      return finalise(new this.constructor(this), this.e + 1, 1);
    };
    P.valueOf = P.toJSON = function() {
      var x2 = this, Ctor = x2.constructor, str = finiteToString(x2, x2.e <= Ctor.toExpNeg || x2.e >= Ctor.toExpPos);
      return x2.isNeg() ? "-" + str : str;
    };
    function digitsToString(d3) {
      var i2, k2, ws, indexOfLastWord = d3.length - 1, str = "", w2 = d3[0];
      if (indexOfLastWord > 0) {
        str += w2;
        for (i2 = 1; i2 < indexOfLastWord; i2++) {
          ws = d3[i2] + "";
          k2 = LOG_BASE - ws.length;
          if (k2) str += getZeroString(k2);
          str += ws;
        }
        w2 = d3[i2];
        ws = w2 + "";
        k2 = LOG_BASE - ws.length;
        if (k2) str += getZeroString(k2);
      } else if (w2 === 0) {
        return "0";
      }
      for (; w2 % 10 === 0; ) w2 /= 10;
      return str + w2;
    }
    function checkInt32(i2, min22, max22) {
      if (i2 !== ~~i2 || i2 < min22 || i2 > max22) {
        throw Error(invalidArgument + i2);
      }
    }
    function checkRoundingDigits(d3, i2, rm, repeating) {
      var di, k2, r, rd;
      for (k2 = d3[0]; k2 >= 10; k2 /= 10) --i2;
      if (--i2 < 0) {
        i2 += LOG_BASE;
        di = 0;
      } else {
        di = Math.ceil((i2 + 1) / LOG_BASE);
        i2 %= LOG_BASE;
      }
      k2 = mathpow(10, LOG_BASE - i2);
      rd = d3[di] % k2 | 0;
      if (repeating == null) {
        if (i2 < 3) {
          if (i2 == 0) rd = rd / 100 | 0;
          else if (i2 == 1) rd = rd / 10 | 0;
          r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 5e4 || rd == 0;
        } else {
          r = (rm < 4 && rd + 1 == k2 || rm > 3 && rd + 1 == k2 / 2) && (d3[di + 1] / k2 / 100 | 0) == mathpow(10, i2 - 2) - 1 || (rd == k2 / 2 || rd == 0) && (d3[di + 1] / k2 / 100 | 0) == 0;
        }
      } else {
        if (i2 < 4) {
          if (i2 == 0) rd = rd / 1e3 | 0;
          else if (i2 == 1) rd = rd / 100 | 0;
          else if (i2 == 2) rd = rd / 10 | 0;
          r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else {
          r = ((repeating || rm < 4) && rd + 1 == k2 || !repeating && rm > 3 && rd + 1 == k2 / 2) && (d3[di + 1] / k2 / 1e3 | 0) == mathpow(10, i2 - 3) - 1;
        }
      }
      return r;
    }
    function convertBase(str, baseIn, baseOut) {
      var j, arr = [0], arrL, i2 = 0, strL = str.length;
      for (; i2 < strL; ) {
        for (arrL = arr.length; arrL--; ) arr[arrL] *= baseIn;
        arr[0] += NUMERALS.indexOf(str.charAt(i2++));
        for (j = 0; j < arr.length; j++) {
          if (arr[j] > baseOut - 1) {
            if (arr[j + 1] === void 0) arr[j + 1] = 0;
            arr[j + 1] += arr[j] / baseOut | 0;
            arr[j] %= baseOut;
          }
        }
      }
      return arr.reverse();
    }
    function cosine(Ctor, x2) {
      var k2, len, y3;
      if (x2.isZero()) return x2;
      len = x2.d.length;
      if (len < 32) {
        k2 = Math.ceil(len / 3);
        y3 = (1 / tinyPow(4, k2)).toString();
      } else {
        k2 = 16;
        y3 = "2.3283064365386962890625e-10";
      }
      Ctor.precision += k2;
      x2 = taylorSeries(Ctor, 1, x2.times(y3), new Ctor(1));
      for (var i2 = k2; i2--; ) {
        var cos2x = x2.times(x2);
        x2 = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
      }
      Ctor.precision -= k2;
      return x2;
    }
    var divide = /* @__PURE__ */ function() {
      function multiplyInteger(x2, k2, base) {
        var temp, carry = 0, i2 = x2.length;
        for (x2 = x2.slice(); i2--; ) {
          temp = x2[i2] * k2 + carry;
          x2[i2] = temp % base | 0;
          carry = temp / base | 0;
        }
        if (carry) x2.unshift(carry);
        return x2;
      }
      function compare(a3, b2, aL, bL) {
        var i2, r;
        if (aL != bL) {
          r = aL > bL ? 1 : -1;
        } else {
          for (i2 = r = 0; i2 < aL; i2++) {
            if (a3[i2] != b2[i2]) {
              r = a3[i2] > b2[i2] ? 1 : -1;
              break;
            }
          }
        }
        return r;
      }
      function subtract(a3, b2, aL, base) {
        var i2 = 0;
        for (; aL--; ) {
          a3[aL] -= i2;
          i2 = a3[aL] < b2[aL] ? 1 : 0;
          a3[aL] = i2 * base + a3[aL] - b2[aL];
        }
        for (; !a3[0] && a3.length > 1; ) a3.shift();
      }
      return function(x2, y3, pr, rm, dp, base) {
        var cmp, e2, i2, k2, logBase, more, prod, prodL, q2, qd, rem, remL, rem0, sd, t2, xi, xL, yd0, yL, yz, Ctor = x2.constructor, sign2 = x2.s == y3.s ? 1 : -1, xd = x2.d, yd = y3.d;
        if (!xd || !xd[0] || !yd || !yd[0]) {
          return new Ctor(
            // Return NaN if either NaN, or both Infinity or 0.
            !x2.s || !y3.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : (
              // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
              xd && xd[0] == 0 || !yd ? sign2 * 0 : sign2 / 0
            )
          );
        }
        if (base) {
          logBase = 1;
          e2 = x2.e - y3.e;
        } else {
          base = BASE;
          logBase = LOG_BASE;
          e2 = mathfloor(x2.e / logBase) - mathfloor(y3.e / logBase);
        }
        yL = yd.length;
        xL = xd.length;
        q2 = new Ctor(sign2);
        qd = q2.d = [];
        for (i2 = 0; yd[i2] == (xd[i2] || 0); i2++) ;
        if (yd[i2] > (xd[i2] || 0)) e2--;
        if (pr == null) {
          sd = pr = Ctor.precision;
          rm = Ctor.rounding;
        } else if (dp) {
          sd = pr + (x2.e - y3.e) + 1;
        } else {
          sd = pr;
        }
        if (sd < 0) {
          qd.push(1);
          more = true;
        } else {
          sd = sd / logBase + 2 | 0;
          i2 = 0;
          if (yL == 1) {
            k2 = 0;
            yd = yd[0];
            sd++;
            for (; (i2 < xL || k2) && sd--; i2++) {
              t2 = k2 * base + (xd[i2] || 0);
              qd[i2] = t2 / yd | 0;
              k2 = t2 % yd | 0;
            }
            more = k2 || i2 < xL;
          } else {
            k2 = base / (yd[0] + 1) | 0;
            if (k2 > 1) {
              yd = multiplyInteger(yd, k2, base);
              xd = multiplyInteger(xd, k2, base);
              yL = yd.length;
              xL = xd.length;
            }
            xi = yL;
            rem = xd.slice(0, yL);
            remL = rem.length;
            for (; remL < yL; ) rem[remL++] = 0;
            yz = yd.slice();
            yz.unshift(0);
            yd0 = yd[0];
            if (yd[1] >= base / 2) ++yd0;
            do {
              k2 = 0;
              cmp = compare(yd, rem, yL, remL);
              if (cmp < 0) {
                rem0 = rem[0];
                if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                k2 = rem0 / yd0 | 0;
                if (k2 > 1) {
                  if (k2 >= base) k2 = base - 1;
                  prod = multiplyInteger(yd, k2, base);
                  prodL = prod.length;
                  remL = rem.length;
                  cmp = compare(prod, rem, prodL, remL);
                  if (cmp == 1) {
                    k2--;
                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                  }
                } else {
                  if (k2 == 0) cmp = k2 = 1;
                  prod = yd.slice();
                }
                prodL = prod.length;
                if (prodL < remL) prod.unshift(0);
                subtract(rem, prod, remL, base);
                if (cmp == -1) {
                  remL = rem.length;
                  cmp = compare(yd, rem, yL, remL);
                  if (cmp < 1) {
                    k2++;
                    subtract(rem, yL < remL ? yz : yd, remL, base);
                  }
                }
                remL = rem.length;
              } else if (cmp === 0) {
                k2++;
                rem = [0];
              }
              qd[i2++] = k2;
              if (cmp && rem[0]) {
                rem[remL++] = xd[xi] || 0;
              } else {
                rem = [xd[xi]];
                remL = 1;
              }
            } while ((xi++ < xL || rem[0] !== void 0) && sd--);
            more = rem[0] !== void 0;
          }
          if (!qd[0]) qd.shift();
        }
        if (logBase == 1) {
          q2.e = e2;
          inexact = more;
        } else {
          for (i2 = 1, k2 = qd[0]; k2 >= 10; k2 /= 10) i2++;
          q2.e = i2 + e2 * logBase - 1;
          finalise(q2, dp ? pr + q2.e + 1 : pr, rm, more);
        }
        return q2;
      };
    }();
    function finalise(x2, sd, rm, isTruncated) {
      var digits, i2, j, k2, rd, roundUp, w2, xd, xdi, Ctor = x2.constructor;
      out: if (sd != null) {
        xd = x2.d;
        if (!xd) return x2;
        for (digits = 1, k2 = xd[0]; k2 >= 10; k2 /= 10) digits++;
        i2 = sd - digits;
        if (i2 < 0) {
          i2 += LOG_BASE;
          j = sd;
          w2 = xd[xdi = 0];
          rd = w2 / mathpow(10, digits - j - 1) % 10 | 0;
        } else {
          xdi = Math.ceil((i2 + 1) / LOG_BASE);
          k2 = xd.length;
          if (xdi >= k2) {
            if (isTruncated) {
              for (; k2++ <= xdi; ) xd.push(0);
              w2 = rd = 0;
              digits = 1;
              i2 %= LOG_BASE;
              j = i2 - LOG_BASE + 1;
            } else {
              break out;
            }
          } else {
            w2 = k2 = xd[xdi];
            for (digits = 1; k2 >= 10; k2 /= 10) digits++;
            i2 %= LOG_BASE;
            j = i2 - LOG_BASE + digits;
            rd = j < 0 ? 0 : w2 / mathpow(10, digits - j - 1) % 10 | 0;
          }
        }
        isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w2 : w2 % mathpow(10, digits - j - 1));
        roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x2.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (i2 > 0 ? j > 0 ? w2 / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x2.s < 0 ? 8 : 7));
        if (sd < 1 || !xd[0]) {
          xd.length = 0;
          if (roundUp) {
            sd -= x2.e + 1;
            xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
            x2.e = -sd || 0;
          } else {
            xd[0] = x2.e = 0;
          }
          return x2;
        }
        if (i2 == 0) {
          xd.length = xdi;
          k2 = 1;
          xdi--;
        } else {
          xd.length = xdi + 1;
          k2 = mathpow(10, LOG_BASE - i2);
          xd[xdi] = j > 0 ? (w2 / mathpow(10, digits - j) % mathpow(10, j) | 0) * k2 : 0;
        }
        if (roundUp) {
          for (; ; ) {
            if (xdi == 0) {
              for (i2 = 1, j = xd[0]; j >= 10; j /= 10) i2++;
              j = xd[0] += k2;
              for (k2 = 1; j >= 10; j /= 10) k2++;
              if (i2 != k2) {
                x2.e++;
                if (xd[0] == BASE) xd[0] = 1;
              }
              break;
            } else {
              xd[xdi] += k2;
              if (xd[xdi] != BASE) break;
              xd[xdi--] = 0;
              k2 = 1;
            }
          }
        }
        for (i2 = xd.length; xd[--i2] === 0; ) xd.pop();
      }
      if (external) {
        if (x2.e > Ctor.maxE) {
          x2.d = null;
          x2.e = NaN;
        } else if (x2.e < Ctor.minE) {
          x2.e = 0;
          x2.d = [0];
        }
      }
      return x2;
    }
    function finiteToString(x2, isExp, sd) {
      if (!x2.isFinite()) return nonFiniteToString(x2);
      var k2, e2 = x2.e, str = digitsToString(x2.d), len = str.length;
      if (isExp) {
        if (sd && (k2 = sd - len) > 0) {
          str = str.charAt(0) + "." + str.slice(1) + getZeroString(k2);
        } else if (len > 1) {
          str = str.charAt(0) + "." + str.slice(1);
        }
        str = str + (x2.e < 0 ? "e" : "e+") + x2.e;
      } else if (e2 < 0) {
        str = "0." + getZeroString(-e2 - 1) + str;
        if (sd && (k2 = sd - len) > 0) str += getZeroString(k2);
      } else if (e2 >= len) {
        str += getZeroString(e2 + 1 - len);
        if (sd && (k2 = sd - e2 - 1) > 0) str = str + "." + getZeroString(k2);
      } else {
        if ((k2 = e2 + 1) < len) str = str.slice(0, k2) + "." + str.slice(k2);
        if (sd && (k2 = sd - len) > 0) {
          if (e2 + 1 === len) str += ".";
          str += getZeroString(k2);
        }
      }
      return str;
    }
    function getBase10Exponent(digits, e2) {
      var w2 = digits[0];
      for (e2 *= LOG_BASE; w2 >= 10; w2 /= 10) e2++;
      return e2;
    }
    function getLn10(Ctor, sd, pr) {
      if (sd > LN10_PRECISION) {
        external = true;
        if (pr) Ctor.precision = pr;
        throw Error(precisionLimitExceeded);
      }
      return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
      if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
      return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
      var w2 = digits.length - 1, len = w2 * LOG_BASE + 1;
      w2 = digits[w2];
      if (w2) {
        for (; w2 % 10 == 0; w2 /= 10) len--;
        for (w2 = digits[0]; w2 >= 10; w2 /= 10) len++;
      }
      return len;
    }
    function getZeroString(k2) {
      var zs = "";
      for (; k2--; ) zs += "0";
      return zs;
    }
    function intPow(Ctor, x2, n, pr) {
      var isTruncated, r = new Ctor(1), k2 = Math.ceil(pr / LOG_BASE + 4);
      external = false;
      for (; ; ) {
        if (n % 2) {
          r = r.times(x2);
          if (truncate(r.d, k2)) isTruncated = true;
        }
        n = mathfloor(n / 2);
        if (n === 0) {
          n = r.d.length - 1;
          if (isTruncated && r.d[n] === 0) ++r.d[n];
          break;
        }
        x2 = x2.times(x2);
        truncate(x2.d, k2);
      }
      external = true;
      return r;
    }
    function isOdd(n) {
      return n.d[n.d.length - 1] & 1;
    }
    function maxOrMin(Ctor, args, ltgt) {
      var y3, x2 = new Ctor(args[0]), i2 = 0;
      for (; ++i2 < args.length; ) {
        y3 = new Ctor(args[i2]);
        if (!y3.s) {
          x2 = y3;
          break;
        } else if (x2[ltgt](y3)) {
          x2 = y3;
        }
      }
      return x2;
    }
    function naturalExponential(x2, sd) {
      var denominator, guard, j, pow2, sum2, t2, wpr, rep = 0, i2 = 0, k2 = 0, Ctor = x2.constructor, rm = Ctor.rounding, pr = Ctor.precision;
      if (!x2.d || !x2.d[0] || x2.e > 17) {
        return new Ctor(x2.d ? !x2.d[0] ? 1 : x2.s < 0 ? 0 : 1 / 0 : x2.s ? x2.s < 0 ? 0 : x2 : 0 / 0);
      }
      if (sd == null) {
        external = false;
        wpr = pr;
      } else {
        wpr = sd;
      }
      t2 = new Ctor(0.03125);
      while (x2.e > -2) {
        x2 = x2.times(t2);
        k2 += 5;
      }
      guard = Math.log(mathpow(2, k2)) / Math.LN10 * 2 + 5 | 0;
      wpr += guard;
      denominator = pow2 = sum2 = new Ctor(1);
      Ctor.precision = wpr;
      for (; ; ) {
        pow2 = finalise(pow2.times(x2), wpr, 1);
        denominator = denominator.times(++i2);
        t2 = sum2.plus(divide(pow2, denominator, wpr, 1));
        if (digitsToString(t2.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
          j = k2;
          while (j--) sum2 = finalise(sum2.times(sum2), wpr, 1);
          if (sd == null) {
            if (rep < 3 && checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
              Ctor.precision = wpr += 10;
              denominator = pow2 = t2 = new Ctor(1);
              i2 = 0;
              rep++;
            } else {
              return finalise(sum2, Ctor.precision = pr, rm, external = true);
            }
          } else {
            Ctor.precision = pr;
            return sum2;
          }
        }
        sum2 = t2;
      }
    }
    function naturalLogarithm(y3, sd) {
      var c2, c0, denominator, e2, numerator, rep, sum2, t2, wpr, x1, x2, n = 1, guard = 10, x3 = y3, xd = x3.d, Ctor = x3.constructor, rm = Ctor.rounding, pr = Ctor.precision;
      if (x3.s < 0 || !xd || !xd[0] || !x3.e && xd[0] == 1 && xd.length == 1) {
        return new Ctor(xd && !xd[0] ? -1 / 0 : x3.s != 1 ? NaN : xd ? 0 : x3);
      }
      if (sd == null) {
        external = false;
        wpr = pr;
      } else {
        wpr = sd;
      }
      Ctor.precision = wpr += guard;
      c2 = digitsToString(xd);
      c0 = c2.charAt(0);
      if (Math.abs(e2 = x3.e) < 15e14) {
        while (c0 < 7 && c0 != 1 || c0 == 1 && c2.charAt(1) > 3) {
          x3 = x3.times(y3);
          c2 = digitsToString(x3.d);
          c0 = c2.charAt(0);
          n++;
        }
        e2 = x3.e;
        if (c0 > 1) {
          x3 = new Ctor("0." + c2);
          e2++;
        } else {
          x3 = new Ctor(c0 + "." + c2.slice(1));
        }
      } else {
        t2 = getLn10(Ctor, wpr + 2, pr).times(e2 + "");
        x3 = naturalLogarithm(new Ctor(c0 + "." + c2.slice(1)), wpr - guard).plus(t2);
        Ctor.precision = pr;
        return sd == null ? finalise(x3, pr, rm, external = true) : x3;
      }
      x1 = x3;
      sum2 = numerator = x3 = divide(x3.minus(1), x3.plus(1), wpr, 1);
      x2 = finalise(x3.times(x3), wpr, 1);
      denominator = 3;
      for (; ; ) {
        numerator = finalise(numerator.times(x2), wpr, 1);
        t2 = sum2.plus(divide(numerator, new Ctor(denominator), wpr, 1));
        if (digitsToString(t2.d).slice(0, wpr) === digitsToString(sum2.d).slice(0, wpr)) {
          sum2 = sum2.times(2);
          if (e2 !== 0) sum2 = sum2.plus(getLn10(Ctor, wpr + 2, pr).times(e2 + ""));
          sum2 = divide(sum2, new Ctor(n), wpr, 1);
          if (sd == null) {
            if (checkRoundingDigits(sum2.d, wpr - guard, rm, rep)) {
              Ctor.precision = wpr += guard;
              t2 = numerator = x3 = divide(x1.minus(1), x1.plus(1), wpr, 1);
              x2 = finalise(x3.times(x3), wpr, 1);
              denominator = rep = 1;
            } else {
              return finalise(sum2, Ctor.precision = pr, rm, external = true);
            }
          } else {
            Ctor.precision = pr;
            return sum2;
          }
        }
        sum2 = t2;
        denominator += 2;
      }
    }
    function nonFiniteToString(x2) {
      return String(x2.s * x2.s / 0);
    }
    function parseDecimal(x2, str) {
      var e2, i2, len;
      if ((e2 = str.indexOf(".")) > -1) str = str.replace(".", "");
      if ((i2 = str.search(/e/i)) > 0) {
        if (e2 < 0) e2 = i2;
        e2 += +str.slice(i2 + 1);
        str = str.substring(0, i2);
      } else if (e2 < 0) {
        e2 = str.length;
      }
      for (i2 = 0; str.charCodeAt(i2) === 48; i2++) ;
      for (len = str.length; str.charCodeAt(len - 1) === 48; --len) ;
      str = str.slice(i2, len);
      if (str) {
        len -= i2;
        x2.e = e2 = e2 - i2 - 1;
        x2.d = [];
        i2 = (e2 + 1) % LOG_BASE;
        if (e2 < 0) i2 += LOG_BASE;
        if (i2 < len) {
          if (i2) x2.d.push(+str.slice(0, i2));
          for (len -= LOG_BASE; i2 < len; ) x2.d.push(+str.slice(i2, i2 += LOG_BASE));
          str = str.slice(i2);
          i2 = LOG_BASE - str.length;
        } else {
          i2 -= len;
        }
        for (; i2--; ) str += "0";
        x2.d.push(+str);
        if (external) {
          if (x2.e > x2.constructor.maxE) {
            x2.d = null;
            x2.e = NaN;
          } else if (x2.e < x2.constructor.minE) {
            x2.e = 0;
            x2.d = [0];
          }
        }
      } else {
        x2.e = 0;
        x2.d = [0];
      }
      return x2;
    }
    function parseOther(x2, str) {
      var base, Ctor, divisor, i2, isFloat, len, p, xd, xe;
      if (str.indexOf("_") > -1) {
        str = str.replace(/(\d)_(?=\d)/g, "$1");
        if (isDecimal.test(str)) return parseDecimal(x2, str);
      } else if (str === "Infinity" || str === "NaN") {
        if (!+str) x2.s = NaN;
        x2.e = NaN;
        x2.d = null;
        return x2;
      }
      if (isHex.test(str)) {
        base = 16;
        str = str.toLowerCase();
      } else if (isBinary.test(str)) {
        base = 2;
      } else if (isOctal.test(str)) {
        base = 8;
      } else {
        throw Error(invalidArgument + str);
      }
      i2 = str.search(/p/i);
      if (i2 > 0) {
        p = +str.slice(i2 + 1);
        str = str.substring(2, i2);
      } else {
        str = str.slice(2);
      }
      i2 = str.indexOf(".");
      isFloat = i2 >= 0;
      Ctor = x2.constructor;
      if (isFloat) {
        str = str.replace(".", "");
        len = str.length;
        i2 = len - i2;
        divisor = intPow(Ctor, new Ctor(base), i2, i2 * 2);
      }
      xd = convertBase(str, base, BASE);
      xe = xd.length - 1;
      for (i2 = xe; xd[i2] === 0; --i2) xd.pop();
      if (i2 < 0) return new Ctor(x2.s * 0);
      x2.e = getBase10Exponent(xd, xe);
      x2.d = xd;
      external = false;
      if (isFloat) x2 = divide(x2, divisor, len * 4);
      if (p) x2 = x2.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal11.pow(2, p));
      external = true;
      return x2;
    }
    function sine(Ctor, x2) {
      var k2, len = x2.d.length;
      if (len < 3) {
        return x2.isZero() ? x2 : taylorSeries(Ctor, 2, x2, x2);
      }
      k2 = 1.4 * Math.sqrt(len);
      k2 = k2 > 16 ? 16 : k2 | 0;
      x2 = x2.times(1 / tinyPow(5, k2));
      x2 = taylorSeries(Ctor, 2, x2, x2);
      var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
      for (; k2--; ) {
        sin2_x = x2.times(x2);
        x2 = x2.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
      }
      return x2;
    }
    function taylorSeries(Ctor, n, x2, y3, isHyperbolic) {
      var j, t2, u2, x22, i2 = 1, pr = Ctor.precision, k2 = Math.ceil(pr / LOG_BASE);
      external = false;
      x22 = x2.times(x2);
      u2 = new Ctor(y3);
      for (; ; ) {
        t2 = divide(u2.times(x22), new Ctor(n++ * n++), pr, 1);
        u2 = isHyperbolic ? y3.plus(t2) : y3.minus(t2);
        y3 = divide(t2.times(x22), new Ctor(n++ * n++), pr, 1);
        t2 = u2.plus(y3);
        if (t2.d[k2] !== void 0) {
          for (j = k2; t2.d[j] === u2.d[j] && j--; ) ;
          if (j == -1) break;
        }
        j = u2;
        u2 = y3;
        y3 = t2;
        t2 = j;
        i2++;
      }
      external = true;
      t2.d.length = k2 + 1;
      return t2;
    }
    function tinyPow(b2, e2) {
      var n = b2;
      while (--e2) n *= b2;
      return n;
    }
    function toLessThanHalfPi(Ctor, x2) {
      var t2, isNeg = x2.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
      x2 = x2.abs();
      if (x2.lte(halfPi)) {
        quadrant = isNeg ? 4 : 1;
        return x2;
      }
      t2 = x2.divToInt(pi);
      if (t2.isZero()) {
        quadrant = isNeg ? 3 : 2;
      } else {
        x2 = x2.minus(t2.times(pi));
        if (x2.lte(halfPi)) {
          quadrant = isOdd(t2) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
          return x2;
        }
        quadrant = isOdd(t2) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
      }
      return x2.minus(pi).abs();
    }
    function toStringBinary(x2, baseOut, sd, rm) {
      var base, e2, i2, k2, len, roundUp, str, xd, y3, Ctor = x2.constructor, isExp = sd !== void 0;
      if (isExp) {
        checkInt32(sd, 1, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
      } else {
        sd = Ctor.precision;
        rm = Ctor.rounding;
      }
      if (!x2.isFinite()) {
        str = nonFiniteToString(x2);
      } else {
        str = finiteToString(x2);
        i2 = str.indexOf(".");
        if (isExp) {
          base = 2;
          if (baseOut == 16) {
            sd = sd * 4 - 3;
          } else if (baseOut == 8) {
            sd = sd * 3 - 2;
          }
        } else {
          base = baseOut;
        }
        if (i2 >= 0) {
          str = str.replace(".", "");
          y3 = new Ctor(1);
          y3.e = str.length - i2;
          y3.d = convertBase(finiteToString(y3), 10, base);
          y3.e = y3.d.length;
        }
        xd = convertBase(str, 10, base);
        e2 = len = xd.length;
        for (; xd[--len] == 0; ) xd.pop();
        if (!xd[0]) {
          str = isExp ? "0p+0" : "0";
        } else {
          if (i2 < 0) {
            e2--;
          } else {
            x2 = new Ctor(x2);
            x2.d = xd;
            x2.e = e2;
            x2 = divide(x2, y3, sd, rm, 0, base);
            xd = x2.d;
            e2 = x2.e;
            roundUp = inexact;
          }
          i2 = xd[sd];
          k2 = base / 2;
          roundUp = roundUp || xd[sd + 1] !== void 0;
          roundUp = rm < 4 ? (i2 !== void 0 || roundUp) && (rm === 0 || rm === (x2.s < 0 ? 3 : 2)) : i2 > k2 || i2 === k2 && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x2.s < 0 ? 8 : 7));
          xd.length = sd;
          if (roundUp) {
            for (; ++xd[--sd] > base - 1; ) {
              xd[sd] = 0;
              if (!sd) {
                ++e2;
                xd.unshift(1);
              }
            }
          }
          for (len = xd.length; !xd[len - 1]; --len) ;
          for (i2 = 0, str = ""; i2 < len; i2++) str += NUMERALS.charAt(xd[i2]);
          if (isExp) {
            if (len > 1) {
              if (baseOut == 16 || baseOut == 8) {
                i2 = baseOut == 16 ? 4 : 3;
                for (--len; len % i2; len++) str += "0";
                xd = convertBase(str, base, baseOut);
                for (len = xd.length; !xd[len - 1]; --len) ;
                for (i2 = 1, str = "1."; i2 < len; i2++) str += NUMERALS.charAt(xd[i2]);
              } else {
                str = str.charAt(0) + "." + str.slice(1);
              }
            }
            str = str + (e2 < 0 ? "p" : "p+") + e2;
          } else if (e2 < 0) {
            for (; ++e2; ) str = "0" + str;
            str = "0." + str;
          } else {
            if (++e2 > len) for (e2 -= len; e2--; ) str += "0";
            else if (e2 < len) str = str.slice(0, e2) + "." + str.slice(e2);
          }
        }
        str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
      }
      return x2.s < 0 ? "-" + str : str;
    }
    function truncate(arr, len) {
      if (arr.length > len) {
        arr.length = len;
        return true;
      }
    }
    function abs(x2) {
      return new this(x2).abs();
    }
    function acos(x2) {
      return new this(x2).acos();
    }
    function acosh(x2) {
      return new this(x2).acosh();
    }
    function add2(x2, y3) {
      return new this(x2).plus(y3);
    }
    function asin(x2) {
      return new this(x2).asin();
    }
    function asinh(x2) {
      return new this(x2).asinh();
    }
    function atan(x2) {
      return new this(x2).atan();
    }
    function atanh(x2) {
      return new this(x2).atanh();
    }
    function atan2(y3, x2) {
      y3 = new this(y3);
      x2 = new this(x2);
      var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
      if (!y3.s || !x2.s) {
        r = new this(NaN);
      } else if (!y3.d && !x2.d) {
        r = getPi(this, wpr, 1).times(x2.s > 0 ? 0.25 : 0.75);
        r.s = y3.s;
      } else if (!x2.d || y3.isZero()) {
        r = x2.s < 0 ? getPi(this, pr, rm) : new this(0);
        r.s = y3.s;
      } else if (!y3.d || x2.isZero()) {
        r = getPi(this, wpr, 1).times(0.5);
        r.s = y3.s;
      } else if (x2.s < 0) {
        this.precision = wpr;
        this.rounding = 1;
        r = this.atan(divide(y3, x2, wpr, 1));
        x2 = getPi(this, wpr, 1);
        this.precision = pr;
        this.rounding = rm;
        r = y3.s < 0 ? r.minus(x2) : r.plus(x2);
      } else {
        r = this.atan(divide(y3, x2, wpr, 1));
      }
      return r;
    }
    function cbrt(x2) {
      return new this(x2).cbrt();
    }
    function ceil(x2) {
      return finalise(x2 = new this(x2), x2.e + 1, 2);
    }
    function clamp2(x2, min22, max22) {
      return new this(x2).clamp(min22, max22);
    }
    function config(obj) {
      if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
      var i2, p, v, useDefaults = obj.defaults === true, ps = [
        "precision",
        1,
        MAX_DIGITS,
        "rounding",
        0,
        8,
        "toExpNeg",
        -EXP_LIMIT,
        0,
        "toExpPos",
        0,
        EXP_LIMIT,
        "maxE",
        0,
        EXP_LIMIT,
        "minE",
        -EXP_LIMIT,
        0,
        "modulo",
        0,
        9
      ];
      for (i2 = 0; i2 < ps.length; i2 += 3) {
        if (p = ps[i2], useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
          if (mathfloor(v) === v && v >= ps[i2 + 1] && v <= ps[i2 + 2]) this[p] = v;
          else throw Error(invalidArgument + p + ": " + v);
        }
      }
      if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
      if ((v = obj[p]) !== void 0) {
        if (v === true || v === false || v === 0 || v === 1) {
          if (v) {
            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
              this[p] = true;
            } else {
              throw Error(cryptoUnavailable);
            }
          } else {
            this[p] = false;
          }
        } else {
          throw Error(invalidArgument + p + ": " + v);
        }
      }
      return this;
    }
    function cos(x2) {
      return new this(x2).cos();
    }
    function cosh(x2) {
      return new this(x2).cosh();
    }
    function clone(obj) {
      var i2, p, ps;
      function Decimal22(v) {
        var e2, i22, t2, x2 = this;
        if (!(x2 instanceof Decimal22)) return new Decimal22(v);
        x2.constructor = Decimal22;
        if (isDecimalInstance(v)) {
          x2.s = v.s;
          if (external) {
            if (!v.d || v.e > Decimal22.maxE) {
              x2.e = NaN;
              x2.d = null;
            } else if (v.e < Decimal22.minE) {
              x2.e = 0;
              x2.d = [0];
            } else {
              x2.e = v.e;
              x2.d = v.d.slice();
            }
          } else {
            x2.e = v.e;
            x2.d = v.d ? v.d.slice() : v.d;
          }
          return;
        }
        t2 = typeof v;
        if (t2 === "number") {
          if (v === 0) {
            x2.s = 1 / v < 0 ? -1 : 1;
            x2.e = 0;
            x2.d = [0];
            return;
          }
          if (v < 0) {
            v = -v;
            x2.s = -1;
          } else {
            x2.s = 1;
          }
          if (v === ~~v && v < 1e7) {
            for (e2 = 0, i22 = v; i22 >= 10; i22 /= 10) e2++;
            if (external) {
              if (e2 > Decimal22.maxE) {
                x2.e = NaN;
                x2.d = null;
              } else if (e2 < Decimal22.minE) {
                x2.e = 0;
                x2.d = [0];
              } else {
                x2.e = e2;
                x2.d = [v];
              }
            } else {
              x2.e = e2;
              x2.d = [v];
            }
            return;
          } else if (v * 0 !== 0) {
            if (!v) x2.s = NaN;
            x2.e = NaN;
            x2.d = null;
            return;
          }
          return parseDecimal(x2, v.toString());
        } else if (t2 !== "string") {
          throw Error(invalidArgument + v);
        }
        if ((i22 = v.charCodeAt(0)) === 45) {
          v = v.slice(1);
          x2.s = -1;
        } else {
          if (i22 === 43) v = v.slice(1);
          x2.s = 1;
        }
        return isDecimal.test(v) ? parseDecimal(x2, v) : parseOther(x2, v);
      }
      Decimal22.prototype = P;
      Decimal22.ROUND_UP = 0;
      Decimal22.ROUND_DOWN = 1;
      Decimal22.ROUND_CEIL = 2;
      Decimal22.ROUND_FLOOR = 3;
      Decimal22.ROUND_HALF_UP = 4;
      Decimal22.ROUND_HALF_DOWN = 5;
      Decimal22.ROUND_HALF_EVEN = 6;
      Decimal22.ROUND_HALF_CEIL = 7;
      Decimal22.ROUND_HALF_FLOOR = 8;
      Decimal22.EUCLID = 9;
      Decimal22.config = Decimal22.set = config;
      Decimal22.clone = clone;
      Decimal22.isDecimal = isDecimalInstance;
      Decimal22.abs = abs;
      Decimal22.acos = acos;
      Decimal22.acosh = acosh;
      Decimal22.add = add2;
      Decimal22.asin = asin;
      Decimal22.asinh = asinh;
      Decimal22.atan = atan;
      Decimal22.atanh = atanh;
      Decimal22.atan2 = atan2;
      Decimal22.cbrt = cbrt;
      Decimal22.ceil = ceil;
      Decimal22.clamp = clamp2;
      Decimal22.cos = cos;
      Decimal22.cosh = cosh;
      Decimal22.div = div;
      Decimal22.exp = exp;
      Decimal22.floor = floor;
      Decimal22.hypot = hypot;
      Decimal22.ln = ln;
      Decimal22.log = log;
      Decimal22.log10 = log10;
      Decimal22.log2 = log2;
      Decimal22.max = max2;
      Decimal22.min = min2;
      Decimal22.mod = mod;
      Decimal22.mul = mul;
      Decimal22.pow = pow;
      Decimal22.random = random;
      Decimal22.round = round;
      Decimal22.sign = sign;
      Decimal22.sin = sin;
      Decimal22.sinh = sinh;
      Decimal22.sqrt = sqrt;
      Decimal22.sub = sub2;
      Decimal22.sum = sum;
      Decimal22.tan = tan;
      Decimal22.tanh = tanh;
      Decimal22.trunc = trunc2;
      if (obj === void 0) obj = {};
      if (obj) {
        if (obj.defaults !== true) {
          ps = ["precision", "rounding", "toExpNeg", "toExpPos", "maxE", "minE", "modulo", "crypto"];
          for (i2 = 0; i2 < ps.length; ) if (!obj.hasOwnProperty(p = ps[i2++])) obj[p] = this[p];
        }
      }
      Decimal22.config(obj);
      return Decimal22;
    }
    function div(x2, y3) {
      return new this(x2).div(y3);
    }
    function exp(x2) {
      return new this(x2).exp();
    }
    function floor(x2) {
      return finalise(x2 = new this(x2), x2.e + 1, 3);
    }
    function hypot() {
      var i2, n, t2 = new this(0);
      external = false;
      for (i2 = 0; i2 < arguments.length; ) {
        n = new this(arguments[i2++]);
        if (!n.d) {
          if (n.s) {
            external = true;
            return new this(1 / 0);
          }
          t2 = n;
        } else if (t2.d) {
          t2 = t2.plus(n.times(n));
        }
      }
      external = true;
      return t2.sqrt();
    }
    function isDecimalInstance(obj) {
      return obj instanceof Decimal11 || obj && obj.toStringTag === tag || false;
    }
    function ln(x2) {
      return new this(x2).ln();
    }
    function log(x2, y3) {
      return new this(x2).log(y3);
    }
    function log2(x2) {
      return new this(x2).log(2);
    }
    function log10(x2) {
      return new this(x2).log(10);
    }
    function max2() {
      return maxOrMin(this, arguments, "lt");
    }
    function min2() {
      return maxOrMin(this, arguments, "gt");
    }
    function mod(x2, y3) {
      return new this(x2).mod(y3);
    }
    function mul(x2, y3) {
      return new this(x2).mul(y3);
    }
    function pow(x2, y3) {
      return new this(x2).pow(y3);
    }
    function random(sd) {
      var d3, e2, k2, n, i2 = 0, r = new this(1), rd = [];
      if (sd === void 0) sd = this.precision;
      else checkInt32(sd, 1, MAX_DIGITS);
      k2 = Math.ceil(sd / LOG_BASE);
      if (!this.crypto) {
        for (; i2 < k2; ) rd[i2++] = Math.random() * 1e7 | 0;
      } else if (crypto.getRandomValues) {
        d3 = crypto.getRandomValues(new Uint32Array(k2));
        for (; i2 < k2; ) {
          n = d3[i2];
          if (n >= 429e7) {
            d3[i2] = crypto.getRandomValues(new Uint32Array(1))[0];
          } else {
            rd[i2++] = n % 1e7;
          }
        }
      } else if (crypto.randomBytes) {
        d3 = crypto.randomBytes(k2 *= 4);
        for (; i2 < k2; ) {
          n = d3[i2] + (d3[i2 + 1] << 8) + (d3[i2 + 2] << 16) + ((d3[i2 + 3] & 127) << 24);
          if (n >= 214e7) {
            crypto.randomBytes(4).copy(d3, i2);
          } else {
            rd.push(n % 1e7);
            i2 += 4;
          }
        }
        i2 = k2 / 4;
      } else {
        throw Error(cryptoUnavailable);
      }
      k2 = rd[--i2];
      sd %= LOG_BASE;
      if (k2 && sd) {
        n = mathpow(10, LOG_BASE - sd);
        rd[i2] = (k2 / n | 0) * n;
      }
      for (; rd[i2] === 0; i2--) rd.pop();
      if (i2 < 0) {
        e2 = 0;
        rd = [0];
      } else {
        e2 = -1;
        for (; rd[0] === 0; e2 -= LOG_BASE) rd.shift();
        for (k2 = 1, n = rd[0]; n >= 10; n /= 10) k2++;
        if (k2 < LOG_BASE) e2 -= LOG_BASE - k2;
      }
      r.e = e2;
      r.d = rd;
      return r;
    }
    function round(x2) {
      return finalise(x2 = new this(x2), x2.e + 1, this.rounding);
    }
    function sign(x2) {
      x2 = new this(x2);
      return x2.d ? x2.d[0] ? x2.s : 0 * x2.s : x2.s || NaN;
    }
    function sin(x2) {
      return new this(x2).sin();
    }
    function sinh(x2) {
      return new this(x2).sinh();
    }
    function sqrt(x2) {
      return new this(x2).sqrt();
    }
    function sub2(x2, y3) {
      return new this(x2).sub(y3);
    }
    function sum() {
      var i2 = 0, args = arguments, x2 = new this(args[i2]);
      external = false;
      for (; x2.s && ++i2 < args.length; ) x2 = x2.plus(args[i2]);
      external = true;
      return finalise(x2, this.precision, this.rounding);
    }
    function tan(x2) {
      return new this(x2).tan();
    }
    function tanh(x2) {
      return new this(x2).tanh();
    }
    function trunc2(x2) {
      return finalise(x2 = new this(x2), x2.e + 1, 1);
    }
    P[Symbol.for("nodejs.util.inspect.custom")] = P.toString;
    P[Symbol.toStringTag] = "Decimal";
    var Decimal11 = P.constructor = clone(DEFAULTS);
    LN10 = new Decimal11(LN10);
    PI = new Decimal11(PI);
    var decimal_default = Decimal11;
    var MAX_RFP_FILES4 = 5;
    var MAX_TOTAL_AMOUNT = new decimal_default("99999999.99");
    var argentinaStates = [
      {
        nombre_completo: "Provincia de Misiones",
        fuente: "IGN",
        iso_id: "AR-N",
        nombre: "Misiones",
        id: "54",
        categoria: "Provincia",
        iso_nombre: "Misiones",
        centroide: { lat: -26.8753965086829, lon: -54.6516966230371 }
      },
      {
        nombre_completo: "Provincia de San Luis",
        fuente: "IGN",
        iso_id: "AR-D",
        nombre: "San Luis",
        id: "74",
        categoria: "Provincia",
        iso_nombre: "San Luis",
        centroide: { lat: -33.7577257449137, lon: -66.0281298195836 }
      },
      {
        nombre_completo: "Provincia de San Juan",
        fuente: "IGN",
        iso_id: "AR-J",
        nombre: "San Juan",
        id: "70",
        categoria: "Provincia",
        iso_nombre: "San Juan",
        centroide: { lat: -30.8653679979618, lon: -68.8894908486844 }
      },
      {
        nombre_completo: "Provincia de Entre R\xEDos",
        fuente: "IGN",
        iso_id: "AR-E",
        nombre: "Entre R\xEDos",
        id: "30",
        categoria: "Provincia",
        iso_nombre: "Entre R\xEDos",
        centroide: { lat: -32.0588735436448, lon: -59.2014475514635 }
      },
      {
        nombre_completo: "Provincia de Santa Cruz",
        fuente: "IGN",
        iso_id: "AR-Z",
        nombre: "Santa Cruz",
        id: "78",
        categoria: "Provincia",
        iso_nombre: "Santa Cruz",
        centroide: { lat: -48.8154851827063, lon: -69.9557621671973 }
      },
      {
        nombre_completo: "Provincia de R\xEDo Negro",
        fuente: "IGN",
        iso_id: "AR-R",
        nombre: "R\xEDo Negro",
        id: "62",
        categoria: "Provincia",
        iso_nombre: "R\xEDo Negro",
        centroide: { lat: -40.4057957178801, lon: -67.229329893694 }
      },
      {
        nombre_completo: "Provincia del Chubut",
        fuente: "IGN",
        iso_id: "AR-U",
        nombre: "Chubut",
        id: "26",
        categoria: "Provincia",
        iso_nombre: "Chubut",
        centroide: { lat: -43.7886233529878, lon: -68.5267593943345 }
      },
      {
        nombre_completo: "Provincia de C\xF3rdoba",
        fuente: "IGN",
        iso_id: "AR-X",
        nombre: "C\xF3rdoba",
        id: "14",
        categoria: "Provincia",
        iso_nombre: "C\xF3rdoba",
        centroide: { lat: -32.142932663607, lon: -63.8017532741662 }
      },
      {
        nombre_completo: "Provincia de Mendoza",
        fuente: "IGN",
        iso_id: "AR-M",
        nombre: "Mendoza",
        id: "50",
        categoria: "Provincia",
        iso_nombre: "Mendoza",
        centroide: { lat: -34.6298873058957, lon: -68.5831228183798 }
      },
      {
        nombre_completo: "Provincia de La Rioja",
        fuente: "IGN",
        iso_id: "AR-F",
        nombre: "La Rioja",
        id: "46",
        categoria: "Provincia",
        iso_nombre: "La Rioja",
        centroide: { lat: -29.685776298315, lon: -67.1817359694432 }
      },
      {
        nombre_completo: "Provincia de Catamarca",
        fuente: "IGN",
        iso_id: "AR-K",
        nombre: "Catamarca",
        id: "10",
        categoria: "Provincia",
        iso_nombre: "Catamarca",
        centroide: { lat: -27.3358332810217, lon: -66.9476824299928 }
      },
      {
        nombre_completo: "Provincia de La Pampa",
        fuente: "IGN",
        iso_id: "AR-L",
        nombre: "La Pampa",
        id: "42",
        categoria: "Provincia",
        iso_nombre: "La Pampa",
        centroide: { lat: -37.1315537735949, lon: -65.4466546606951 }
      },
      {
        nombre_completo: "Provincia de Santiago del Estero",
        fuente: "IGN",
        iso_id: "AR-G",
        nombre: "Santiago del Estero",
        id: "86",
        categoria: "Provincia",
        iso_nombre: "Santiago del Estero",
        centroide: { lat: -27.7824116550944, lon: -63.2523866568588 }
      },
      {
        nombre_completo: "Provincia de Corrientes",
        fuente: "IGN",
        iso_id: "AR-W",
        nombre: "Corrientes",
        id: "18",
        categoria: "Provincia",
        iso_nombre: "Corrientes",
        centroide: { lat: -28.7743047046407, lon: -57.8012191977913 }
      },
      {
        nombre_completo: "Provincia de Santa Fe",
        fuente: "IGN",
        iso_id: "AR-S",
        nombre: "Santa Fe",
        id: "82",
        categoria: "Provincia",
        iso_nombre: "Santa Fe",
        centroide: { lat: -30.7069271588117, lon: -60.9498369430241 }
      },
      {
        nombre_completo: "Provincia de Tucum\xE1n",
        fuente: "IGN",
        iso_id: "AR-T",
        nombre: "Tucum\xE1n",
        id: "90",
        categoria: "Provincia",
        iso_nombre: "Tucum\xE1n",
        centroide: { lat: -26.9478001830786, lon: -65.3647579441481 }
      },
      {
        nombre_completo: "Provincia del Neuqu\xE9n",
        fuente: "IGN",
        iso_id: "AR-Q",
        nombre: "Neuqu\xE9n",
        id: "58",
        categoria: "Provincia",
        iso_nombre: "Neuqu\xE9n",
        centroide: { lat: -38.6417575824599, lon: -70.1185705180601 }
      },
      {
        nombre_completo: "Provincia de Salta",
        fuente: "IGN",
        iso_id: "AR-A",
        nombre: "Salta",
        id: "66",
        categoria: "Provincia",
        iso_nombre: "Salta",
        centroide: { lat: -24.2991344492002, lon: -64.8144629600627 }
      },
      {
        nombre_completo: "Provincia del Chaco",
        fuente: "IGN",
        iso_id: "AR-H",
        nombre: "Chaco",
        id: "22",
        categoria: "Provincia",
        iso_nombre: "Chaco",
        centroide: { lat: -26.3864309061226, lon: -60.7658307438603 }
      },
      {
        nombre_completo: "Provincia de Formosa",
        fuente: "IGN",
        iso_id: "AR-P",
        nombre: "Formosa",
        id: "34",
        categoria: "Provincia",
        iso_nombre: "Formosa",
        centroide: { lat: -24.894972594871, lon: -59.9324405800872 }
      },
      {
        nombre_completo: "Provincia de Jujuy",
        fuente: "IGN",
        iso_id: "AR-Y",
        nombre: "Jujuy",
        id: "38",
        categoria: "Provincia",
        iso_nombre: "Jujuy",
        centroide: { lat: -23.3200784211351, lon: -65.7642522180337 }
      },
      {
        nombre_completo: "Ciudad Aut\xF3noma de Buenos Aires",
        fuente: "IGN",
        iso_id: "AR-C",
        nombre: "Ciudad Aut\xF3noma de Buenos Aires",
        id: "02",
        categoria: "Ciudad Aut\xF3noma",
        iso_nombre: "Ciudad Aut\xF3noma de Buenos Aires",
        centroide: { lat: -34.6144934119689, lon: -58.4458563545429 }
      },
      {
        nombre_completo: "Provincia de Buenos Aires",
        fuente: "IGN",
        iso_id: "AR-B",
        nombre: "Buenos Aires",
        id: "06",
        categoria: "Provincia",
        iso_nombre: "Buenos Aires",
        centroide: { lat: -36.6769415180527, lon: -60.5588319815719 }
      },
      {
        nombre_completo: "Provincia de Tierra del Fuego, Ant\xE1rtida e Islas del Atl\xE1ntico Sur",
        fuente: "IGN",
        iso_id: "AR-V",
        nombre: "Tierra del Fuego, Ant\xE1rtida e Islas del Atl\xE1ntico Sur",
        id: "94",
        categoria: "Provincia",
        iso_nombre: "Tierra del Fuego",
        centroide: { lat: -82.52151781221, lon: -50.7427486049785 }
      }
    ];
    var argentinaCities = {
      B: [
        "ALBERTI",
        "CORONEL SEGUI",
        "MECHITA",
        "PLA",
        "VILLA GRISOLIA",
        "VILLA MARIA",
        "VILLA ORTIZ",
        "ADROGUE",
        "BURZACO",
        "CLAYPOLE",
        "DON ORIONE",
        "GLEW",
        "JOSE MARMOL",
        "LONGCHAMPS",
        "MALVINAS ARGENTINAS",
        "MINISTRO RIVADAVIA",
        "RAFAEL CALZADA",
        "SAN JOSE",
        "AREA CINTURON ECOLOGICO",
        "AVELLANEDA",
        "CRUCESITA",
        "DOCK SUD",
        "GERLI",
        "PI\xD1EYRO",
        "SARANDI",
        "VILLA DOMINICO",
        "WILDE",
        "AYACUCHO",
        "LA CONSTANCIA",
        "SOLANET",
        "UDAQUIOLA",
        "ARIEL",
        "AZUL",
        "CACHARI",
        "CHILLAR",
        "16 DE JULIO",
        "BAHIA BLANCA",
        "GR\xDCNBEIN",
        "INGENIERO WHITE",
        "VILLA BORDEAU",
        "VILLA ESPORA",
        "CABILDO",
        "GENERAL DANIEL CERRI",
        "BALCARCE",
        "LOS PINOS",
        "NAPALEOFU",
        "RAMOS OTERO",
        "SAN AGUSTIN",
        "VILLA LAGUNA LA BRAVA",
        "BARADERO",
        "IRINEO PORTELA",
        "SANTA COLOMA",
        "VILLA ALSINA",
        "ARRECIFES",
        "TODD",
        "VI\xA5A",
        "BARKER",
        "BENITO JUAREZ",
        "LOPEZ",
        "TEDIN URIBURU",
        "VILLA CACIQUE",
        "BERAZATEGUI",
        "BERAZATEGUI OESTE",
        "CARLOS TOMAS SOURIGUES",
        "EL PATO",
        "GUILLERMO ENRIQUE HUDSON",
        "JUAN MARIA GUTIERREZ",
        "PEREYRA",
        "PLATANOS",
        "RANELAGH",
        "VILLA ESPA\xD1A",
        "BARRIO BANCO PROVINCIA",
        "BARRIO EL CARMEN (ESTE)",
        "BARRIO UNIVERSITARIO",
        "BERISSO",
        "LOS TALAS",
        "VILLA ARG\xDCELLO",
        "VILLA DOLORES",
        "VILLA INDEPENDENCIA",
        "VILLA NUEVA",
        "VILLA PORTE\xD1A",
        "VILLA PROGRESO",
        "VILLA SAN CARLOS",
        "VILLA ZULA",
        "HALE",
        "JUAN F. IBARRA",
        "PAULA",
        "PIROVANO",
        "SAN CARLOS DE BOLIVAR",
        "URDAMPILLETA",
        "VILLA LYNCH PUEYRREDON",
        "ASAMBLEA",
        "BRAGADO",
        "COMODORO PY",
        "GENERAL O'BRIEN",
        "IRALA",
        "LA LIMPIA",
        "MAXIMO FERNANDEZ",
        "OLASCOAGA",
        "WARNES",
        "ALTAMIRANO",
        "BARRIO EL MIRADOR",
        "BARRIO LAS GOLONDRINAS",
        "BARRIO LOS BOSQUECITOS",
        "BARRIO PARQUE LAS ACACIAS",
        "CAMPOS DE ROCA",
        "CORONEL BRANDSEN",
        "CLUB DE CAMPO LAS MALVINAS",
        "GOMEZ",
        "JEPPENER",
        "OLIDEN",
        "POSADA DE LOS LAGOS",
        "SAMBOROMBON",
        "ALTO LOS CARDALES",
        "BARRIO LOS PIONEROS",
        "CAMPANA",
        "CHACRAS DEL RIO LUJAN",
        "LOMAS DEL RIO LUJAN",
        "ALEJANDRO PETION",
        "BARRIO EL TALADRO",
        "CA\xA5UELAS",
        "GOBERNADOR UDAONDO",
        "BARRIO BELGRANO",
        "MAXIMO PAZ",
        "SANTA ROSA",
        "URIBELARREA",
        "VICENTE CASARES",
        "CAPITAN SARMIENTO",
        "LA LUISA",
        "BELLOCQ",
        "CADRET",
        "CARLOS CASARES",
        "COLONIA MAURICIO",
        "HORTENSIA",
        "LA SOFIA",
        "MAURICIO HIRSCH",
        "MOCTEZUMA",
        "ORDOQUI",
        "SANTO TOMAS",
        "SMITH",
        "CARLOS TEJEDOR",
        "COLONIA SERE",
        "CURARU",
        "TIMOTE",
        "TRES ALGARROBOS",
        "CARMEN DE ARECO",
        "PUEBLO GOUIN",
        "TRES SARGENTOS",
        "CASTELLI",
        "CENTRO GUERRERO",
        "CERRO DE LA GLORIA (CANAL 15)",
        "COLON",
        "EL ARBOLITO",
        "PEARSON",
        "SARASA",
        "BAJO HONDO",
        "BALNEARIO PEHUEN CO",
        "PAGO CHICO",
        "PUNTA ALTA",
        "VILLA DEL MAR",
        "VILLA GENERAL ARIAS",
        "APARICIO",
        "BALNEARIO MARISOL",
        "CORONEL DORREGO",
        "EL PERDIDO",
        "FARO",
        "IRENE",
        "ORIENTE",
        "LA RUTA",
        "SAN ROMAN",
        "CORONEL PRINGLES",
        "EL DIVISORIO",
        "EL PENSAMIENTO",
        "INDIO RICO",
        "LARTIGAU",
        "CASCADAS",
        "CORONEL SUAREZ",
        "CURA MALAL",
        "D'ORBIGNY",
        "HUANGUELEN",
        "PASMAN",
        "SANTA MARIA",
        "SANTA TRINIDAD",
        "VILLA LA ARCADIA",
        "CASTILLA",
        "CHACABUCO",
        "LOS ANGELES",
        "O'HIGGINS",
        "RAWSON",
        "BARRIO LOMAS ALTAS",
        "CHASCOMUS",
        "BARRIO SAN CAYETANO",
        "LAGUNA VITEL",
        "MANUEL J. COBO",
        "VILLA PARQUE GIRADO",
        "BENITEZ",
        "CHIVILCOY",
        "EMILIO AYARZA",
        "GOROSTIAGA",
        "LA RICA",
        "MOQUEHUA",
        "RAMON BIAUS",
        "SAN SEBASTIAN",
        "ANDANT",
        "ARBOLEDAS",
        "DAIREAUX",
        "LA LARGA",
        "SALAZAR",
        "DOLORES",
        "SEVIGNE",
        "DIQUE N\xBA 1",
        "ENSENADA",
        "ISLA SANTIAGO (OESTE)",
        "PUNTA LARA",
        "VILLA CATELA",
        "BELEN DE ESCOBAR",
        "EL CAZADOR",
        "GARIN",
        "INGENIERO MASCHWITZ",
        "LOMA VERDE",
        "MATHEU",
        "MAQUINISTA F. SAVIO ESTE",
        "CANNING",
        "EL JAG\xDCEL",
        "LUIS GUILLON",
        "MONTE GRANDE",
        "9 DE ABRIL",
        "ARROYO DE LA CRUZ",
        "CAPILLA DEL SE\xA5OR",
        "DIEGO GAYNOR",
        "LOS CARDALES",
        "PARADA ORLANDO",
        "EL REMANSO",
        "PARADA ROBLES",
        "PAVON",
        "AEROPUERTO INTERNACIONAL EZEIZA",
        "CARLOS SPEGAZZINI",
        "JOSE MARIA EZEIZA",
        "LA UNION",
        "TRISTAN SUAREZ",
        "BOSQUES",
        "ESTANISLAO SEVERO ZEBALLOS",
        "FLORENCIO VARELA",
        "GOBERNADOR JULIO A. COSTA",
        "INGENIERO JUAN ALLAN",
        "VILLA BROWN",
        "VILLA SAN LUIS",
        "VILLA SANTA ROSA",
        "VILLA VATTEONE",
        "EL TROPEZON",
        "LA CAPILLA",
        "BLAQUIER",
        "FLORENTINO AMEGHINO",
        "PORVENIR",
        "CENTINELA DEL MAR",
        "COMANDANTE NICANOR OTAMENDI",
        "MAR DEL SUR",
        "MECHONGUE",
        "MIRAMAR",
        "GENERAL ALVEAR",
        "ARRIBE\xA5OS",
        "ASCENSION",
        "ESTACION ARENALES",
        "FERRE",
        "GENERAL ARENALES",
        "LA ANGELITA",
        "LA TRINIDAD",
        "GENERAL BELGRANO",
        "GORCHS",
        "GENERAL GUIDO",
        "LABARDEN",
        "BARRIO KENNEDY",
        "GENERAL JUAN MADARIAGA",
        "GENERAL LA MADRID",
        "LA COLINA",
        "LAS MARTINETAS",
        "LIBANO",
        "PONTAUT",
        "GENERAL HORNOS",
        "GENERAL LAS HERAS",
        "LA CHOZA",
        "PLOMER",
        "VILLARS",
        "GENERAL LAVALLE",
        "BARRIO RIO SALADO",
        "RANCHOS",
        "VILLANUEVA",
        "COLONIA SAN RICARDO",
        "GENERAL PINTO",
        "GERMANIA",
        "GUNTHER",
        "VILLA FRANCIA",
        "VILLA ROTH",
        "BARRIO EL BOQUERON",
        "BARRIO LA GLORIA",
        "BARRIO SANTA PAULA",
        "BATAN",
        "CHAPADMALAL",
        "EL MARQUESADO",
        "ESTACION CHAPADMALAL",
        "CAMET",
        "ESTACION CAMET",
        "MAR DEL PLATA",
        "PUNTA MOGOTES",
        "BARRIO EL CASAL",
        "SIERRA DE LOS PADRES",
        "BARRIO COLINAS VERDES",
        "BARRIO EL COYUNCO",
        "GENERAL RODRIGUEZ",
        "BARRIO MORABO",
        "BARRIO RUTA 24 KM. 10",
        "C.C. BOSQUE REAL",
        "GENERAL RODRGUEZ",
        "BARRIO PARQUE GENERAL SAN MARTIN",
        "BILLINGHURST",
        "CIUDAD DEL LIBERTADOR GENERAL SAN MARTIN",
        "CIUDAD JARDIN EL LIBERTADOR",
        "VILLA AYACUCHO",
        "VILLA BALLESTER",
        "VILLA BERNARDO MONTEAGUDO",
        "VILLA CHACABUCO",
        "VILLA CORONEL JOSE M. ZAPIOLA",
        "VILLA GENERAL ANTONIO J. DE SUCRE",
        "VILLA GENERAL EUGENIO NECOCHEA",
        "VILLA GENERAL JOSE TOMAS GUIDO",
        "VILLA GENERAL JUAN G. LAS HERAS",
        "VILLA GODOY CRUZ",
        "VILLA GRANADEROS DE SAN MARTIN",
        "VILLA GREGORIA MATORRAS",
        "VILLA JOSE LEON SUAREZ",
        "VILLA JUAN MARTIN DE PUEYRREDON",
        "VILLA LIBERTAD",
        "VILLA LYNCH",
        "VILLA MAIPU",
        "VILLA MARIA IRENE DE LOS REMEDIOS DE ESCALADA",
        "VILLA MARQUES ALEJANDRO MARIA DE AGUADO",
        "VILLA PARQUE PRESIDENTE FIGUEROA ALCORTA",
        "VILLA PARQUE SAN LORENZO",
        "VILLA SAN ANDRES",
        "VILLA YAPEYU",
        "BAIGORRITA",
        "LA DELFINA",
        "LOS TOLDOS",
        "SAN EMILIO",
        "ZAVALIA",
        "BANDERALO",
        "CA\xA5ADA SECA",
        "CORONEL CHARLONE",
        "EMILIO V. BUNGE",
        "GENERAL VILLEGAS",
        "MASSEY",
        "PICHINCHA",
        "PIEDRITAS",
        "SANTA ELEODORA",
        "SANTA REGINA",
        "VILLA SABOYA",
        "VILLA SAUZE",
        "ARROYO VENADO",
        "CASBAS",
        "GARRE",
        "GUAMINI",
        "LAGUNA ALSINA",
        "HENDERSON",
        "HERRERA VEGAS",
        "HURLINGHAM",
        "VILLA SANTOS TESEI",
        "WILLIAM C. MORRIS",
        "ITUZAINGO CENTRO",
        "ITUZAINGO SUR",
        "VILLA GOBERNADOR UDAONDO",
        "DEL VISO",
        "JOSE C. PAZ",
        "AGUSTIN ROCA",
        "AGUSTINA",
        "BALNEARIO LAGUNA DE GOMEZ",
        "FORTIN TIBURCIO",
        "JUNIN",
        "LA AGRARIA",
        "LAPLACETTE",
        "MORSE",
        "SAFORCADA",
        "LAS TONINAS",
        "AGUAS VERDES",
        "LUCILA DEL MAR",
        "MAR DE AJO",
        "MAR DE AJO NORTE",
        "SAN BERNARDO",
        "SAN CLEMENTE DEL TUYU",
        "MAR DEL TUYU",
        "SANTA TERESITA",
        "ALDO BONZI",
        "CIUDAD EVITA",
        "GONZALEZ CATAN",
        "GREGORIO DE LAFERRERE",
        "ISIDRO CASANOVA",
        "LA TABLADA",
        "LOMAS DEL MIRADOR",
        "RAFAEL CASTILLO",
        "RAMOS MEJIA",
        "SAN JUSTO",
        "TAPIALES",
        "20 DE JUNIO",
        "VILLA EDUARDO MADERO",
        "VILLA LUZURIAGA",
        "VIRREY DEL PINO",
        "LANUS ESTE",
        "LANUS OESTE",
        "MONTE CHINGOLO",
        "REMEDIOS ESCALADA DE SAN MARTIN",
        "VALENTIN ALSINA",
        "COUNTRY CLUB EL RODEO",
        "IGNACIO CORREAS",
        "ABASTO",
        "ANGEL ETCHEVERRY",
        "ARANA",
        "ARTURO SEGUI",
        "BARRIO EL CARMEN (OESTE)",
        "BARRIO GAMBIER",
        "BARRIO LAS MALVINAS",
        "BARRIO LAS QUINTAS",
        "CITY BELL",
        "EL RETIRO",
        "JOAQUIN GORINA",
        "JOSE HERNANDEZ",
        "JOSE MELCHOR ROMERO",
        "LA CUMBRE",
        "LA PLATA",
        "LISANDRO OLMOS",
        "LOS HORNOS",
        "MANUEL B. GONNET",
        "RINGUELET",
        "RUFINO DE ELIZALDE",
        "TOLOSA",
        "TRANSRADIO",
        "VILLA ELISA",
        "VILLA ELVIRA",
        "VILLA GARIBALDI",
        "VILLA MONTORO",
        "VILLA PARQUE SICARDI",
        "LOMAS DE COPELLO",
        "BARRIO RUTA SOL",
        "LAPRIDA",
        "PUEBLO NUEVO",
        "PUEBLO SAN JORGE",
        "CORONEL BOERR",
        "EL TRIGO",
        "LAS FLORES",
        "PARDO",
        "ALBERDI VIEJO",
        "EL DORADO",
        "FORTIN ACHA",
        "JUAN BAUTISTA ALBERDI",
        "LEANDRO N. ALEM",
        "VEDIA",
        "ARENAZA",
        "BAYAUCA",
        "BERMUDEZ",
        "CARLOS SALAS",
        "CORONEL MARTINEZ DE HOZ",
        "EL TRIUNFO",
        "LAS TOSCAS",
        "LINCOLN",
        "PASTEUR",
        "ROBERTS",
        "TRIUNVIRATO",
        "ARENAS VERDES",
        "LICENCIADO MATIENZO",
        "LOBERIA",
        "PIERES",
        "SAN MANUEL",
        "TAMANGUEYU",
        "ANTONIO CARBONI",
        "ELVIRA",
        "LAGUNA DE LOBOS",
        "LOBOS",
        "SALVADOR MARIA",
        "BANFIELD",
        "LLAVALLOL",
        "LOMAS DE ZAMORA",
        "TEMPERLEY",
        "TURDERA",
        "VILLA CENTENARIO",
        "VILLA FIORITO",
        "CARLOS KEEN",
        "CLUB DE CAMPO LOS PUENTES",
        "LUJAN",
        "BARRIO LAS CASUARINAS",
        "CORTINES",
        "LEZICA Y TORREZURI",
        "VILLA FLANDRIA NORTE (PUEBLO NUEVO)",
        "VILLA FLANDRIA SUR (EST. JAUREGUI)",
        "COUNTRY CLUB LAS PRADERAS",
        "OPEN DOOR",
        "OLIVERA",
        "TORRES",
        "ATALAYA",
        "GENERAL MANSILLA",
        "LOS NARANJOS",
        "MAGDALENA",
        "ROBERTO J. PAYRO",
        "VIEYTES",
        "LAS ARMAS",
        "MAIPU",
        "SANTO DOMINGO",
        "AREA DE PROMOCION EL TRIANGULO",
        "GRAND BOURG",
        "INGENIERO ADOLFO SOURDEAUX",
        "INGENIERO PABLO NOGUES",
        "LOS POLVORINES",
        "TORTUGUITAS",
        "VILLA DE MAYO",
        "CORONEL VIDAL",
        "GENERAL PIRAN",
        "LA ARMONIA",
        "MAR CHIQUITA",
        "LA BALIZA",
        "LA CALETA",
        "MAR DE COBO",
        "ATLANTIDA",
        "CAMET NORTE",
        "FRENTE MAR",
        "PLAYA DORADA",
        "SANTA CLARA DEL MAR",
        "SANTA ELENA",
        "VIVORATA",
        "BARRIO SANTA ROSA",
        "BARRIOS LISANDRO DE LA TORRE Y SANTA MARTA",
        "MARCOS PAZ",
        "GOLDNEY",
        "GOWLAND",
        "MERCEDES",
        "TOMAS JOFRE",
        "LIBERTAD",
        "MARIANO ACOSTA",
        "MERLO",
        "PONTEVEDRA",
        "SAN ANTONIO DE PADUA",
        "ABBOTT",
        "SAN MIGUEL DEL MONTE",
        "ZENON VIDELA DORNA",
        "BALNEARIO SAUCE GRANDE",
        "MONTE HERMOSO",
        "CUARTEL V",
        "FRANCISCO ALVAREZ",
        "LA REJA",
        "MORENO",
        "PASO DEL REY",
        "TRUJUI",
        "CASTELAR",
        "EL PALOMAR",
        "HAEDO",
        "MORON",
        "VILLA SARMIENTO",
        "JOSE JUAN ALMEYRA",
        "LAS MARIANAS",
        "NAVARRO",
        "VILLA MOLL",
        "CLARAZ",
        "ENERGIA",
        "JUAN N. FERNANDEZ",
        "NECOCHEA",
        "QUEQUEN",
        "COSTA BONITA",
        "NICANOR OLIVERA",
        "RAMON SANTAMARINA",
        "ALFREDO DEMARCHI",
        "CARLOS MARIA NAON",
        "12 DE OCTUBRE",
        "DUDIGNAC",
        "LA AURORA",
        "MARCELINO UGARTE",
        "MOREA",
        "NORUMBEGA",
        "9 DE JULIO",
        "PATRICIOS",
        "VILLA GENERAL FOURNIER",
        "BLANCAGRANDE",
        "COLONIA NIEVAS",
        "COLONIA SAN MIGUEL",
        "ESPIGAS",
        "HINOJO",
        "COLONIA HINOJO",
        "OLAVARRIA",
        "RECALDE",
        "SANTA LUISA",
        "SIERRA CHICA",
        "SIERRAS BAYAS",
        "VILLA ARRIETA",
        "VILLA ALFREDO FORTABAT",
        "VILLA LA SERRANIA",
        "BAHIA SAN BLAS",
        "CARDENAL CAGLIERO",
        "CARMEN DE PATAGONES",
        "JOSE B. CASAS",
        "JUAN A. PRADERE",
        "STROEDER",
        "VILLALONGA",
        "CAPITAN CASTRO",
        "CHICLANA",
        "FRANCISCO MADERO",
        "INOCENCIO SOSA",
        "JUAN JOSE PASO",
        "MAGDALA",
        "MONES CAZON",
        "NUEVA PLATA",
        "PEHUAJO",
        "BOCAYUVA",
        "DE BARY",
        "PELLEGRINI",
        "ACEVEDO",
        "FONTEZUELA",
        "GUERRICO",
        "JUAN A. DE LA PE\xA5A",
        "JUAN ANCHORENA",
        "LA VIOLETA",
        "MANUEL OCAMPO",
        "MARIANO BENITEZ",
        "MARIANO H. ALFONZO",
        "PERGAMINO",
        "PINZON",
        "RANCAGUA",
        "VILLA ANGELICA",
        "VILLA SAN JOSE",
        "CASALINS",
        "PILA",
        "FATIMA",
        "LA LONJA",
        "LOS CACHORROS",
        "MANZANARES",
        "MANZONE",
        "MAQUINISTA F. SAVIO (OESTE)",
        "PILAR",
        "PRESIDENTE DERQUI",
        "ROBERTO DE VICENZO",
        "SANTA TERESA",
        "VILLA ASTOLFI",
        "VILLA ROSA",
        "ZELAYA",
        "CARILO",
        "OSTENDE",
        "PINAMAR",
        "VALERIA DEL MAR",
        "BARRIO AMERICA UNIDA",
        "GUERNICA",
        "AZOPARDO",
        "BORDENAVE",
        "DARREGUEIRA",
        "17 DE AGOSTO",
        "ESTELA",
        "FELIPE SOLA",
        "LOPEZ LECUBE",
        "PUAN",
        "SAN GERMAN",
        "VILLA CASTELAR",
        "VILLA IRIS",
        "ALVAREZ JONTE",
        "PIPINAS",
        "PUNTA INDIO",
        "VERONICA",
        "BERNAL",
        "BERNAL OESTE",
        "DON BOSCO",
        "EZPELETA",
        "EZPELETA OESTE",
        "QUILMES",
        "QUILMES OESTE",
        "SAN FRANCISCO SOLANO",
        "VILLA LA FLORIDA",
        "EL PARAISO",
        "LAS BAHAMAS",
        "PEREZ MILLAN",
        "RAMALLO",
        "VILLA GENERAL SAVIO",
        "VILLA RAMALLO",
        "RAUCH",
        "AMERICA",
        "FORTIN OLAVARRIA",
        "GONZALEZ MORENO",
        "MIRA PAMPA",
        "ROOSEVELT",
        "SAN MAURICIO",
        "SANSINENA",
        "SUNDBLAD",
        "LA BEBA",
        "LAS CARABELAS",
        "LOS INDIOS",
        "RAFAEL OBLIGADO",
        "ROBERTO CANO",
        "BARRIO LAS MARGARITAS",
        "ROJAS",
        "VILLA PARQUE CECIR",
        "ESTACION SOL DE MAYO",
        "VILLA MANUEL POMAR",
        "CARLOS BEGUERIE",
        "ROQUE PEREZ",
        "ARROYO CORTO",
        "COLONIA SAN MARTIN",
        "DUFAUR",
        "ESPARTILLAR (E)",
        "GOYENA",
        "LAS ENCADENADAS",
        "PIGUE",
        "SAAVEDRA",
        "ALVAREZ DE TOLEDO",
        "CAZON",
        "DEL CARRIL",
        "POLVAREDAS",
        "SALADILLO",
        "ARROYO DULCE",
        "BERDIER",
        "GAHAN",
        "INES INDART",
        "LA INVENCIBLE",
        "SALTO",
        "QUENUMA",
        "SALLIQUELO",
        "AZCUENAGA",
        "CULULLU",
        "FRANKLIN",
        "SAN ANDRES DE GILES",
        "SOLIS",
        "VILLA ESPIL",
        "VILLA RUIZ",
        "DUGGAN",
        "SAN ANTONIO DE ARECO",
        "VILLA LIA",
        "BALNEARIO SAN CAYETANO",
        "OCHANDIO",
        "SAN CAYETANO",
        "SAN FERNANDO",
        "VICTORIA",
        "VIRREYES",
        "ACASSUSO",
        "BECCAR",
        "BOULOGNE SUR MER",
        "MARTINEZ",
        "SAN ISIDRO",
        "VILLA ADELINA",
        "BELLA VISTA",
        "CAMPO DE MAYO",
        "MU\xD1IZ",
        "SAN MIGUEL",
        "CONESA",
        "EREZCANO",
        "GENERAL ROJO",
        "LA EMILIA",
        "VILLA CAMPI",
        "VILLA CANTO",
        "VILLA RICCIO",
        "CAMPOS SALLES",
        "SAN NICOLAS DE LOS ARROYOS",
        "VILLA ESPERANZA",
        "GOBERNADOR CASTRO",
        "INGENIERO MONETA",
        "OBLIGADO",
        "PUEBLO DOYLE",
        "RIO TALA",
        "SAN PEDRO",
        "SANTA LUCIA",
        "ALEJANDRO KORN",
        "SAN VICENTE",
        "DOMSELAAR",
        "GENERAL RIVAS",
        "SUIPACHA",
        "DE LA CANAL",
        "GARDEY",
        "MARIA IGNACIA",
        "TANDIL",
        "CROTTO",
        "TAPALQUE",
        "VELLOSO",
        "BENAVIDEZ",
        "DIQUE LUJAN",
        "DON TORCUATO ESTE",
        "DON TORCUATO OESTE",
        "EL TALAR",
        "GENERAL PACHECO",
        "LOS TRONCOS DEL TALAR",
        "RICARDO ROJAS",
        "RINCON DE MILBERG",
        "TIGRE",
        "GENERAL CONESA",
        "CHASICO",
        "SALDUNGARAY",
        "SIERRA DE LA VENTANA",
        "TORNQUIST",
        "TRES PICOS",
        "VILLA SERRANA LA GRUTA",
        "VILLA VENTANA",
        "BERUTTI",
        "GIRODIAS",
        "LA CARRETA",
        "30 DE AGOSTO",
        "TRENQUE LAUQUEN",
        "TRONGE",
        "BALNEARIO ORENSE",
        "CLAROMECO",
        "DUNAMAR",
        "COPETONAS",
        "LIN CALEL",
        "MICAELA CASCALLARES",
        "ORENSE",
        "RETA",
        "SAN FRANCISCO DE BELLOCQ",
        "SAN MAYOL",
        "TRES ARROYOS",
        "VILLA RODRIGUEZ",
        "CASEROS",
        "CHURRUCA",
        "CIUDAD JARDIN LOMAS DEL PALOMAR",
        "CIUDADELA",
        "EL LIBERTADOR",
        "JOSE INGENIEROS",
        "LOMA HERMOSA",
        "MARTIN CORONADO",
        "11 DE SEPTIEMBRE",
        "PABLO PODESTA",
        "REMEDIOS DE ESCALADA",
        "SAENZ PE\xD1A",
        "SANTOS LUGARES",
        "VILLA BOSCH (EST. JUAN MARIA BOSCH)",
        "VILLA RAFFO",
        "INGENIERO THOMPSON",
        "TRES LOMAS",
        "AGUSTIN MOSCONI",
        "DEL VALLE",
        "ERNESTINA",
        "GOBERNADOR UGARTE",
        "LUCAS MONTEVERDE",
        "NORBERTO DE LA RIESTRA",
        "PEDERNALES",
        "SAN ENRIQUE",
        "VALDES",
        "25 DE MAYO",
        "CARAPACHAY",
        "FLORIDA",
        "FLORIDA OESTE",
        "LA LUCILA",
        "MUNRO",
        "OLIVOS",
        "VICENTE LOPEZ",
        "VILLA MARTELLI",
        "MAR AZUL",
        "MAR DE LAS PAMPAS",
        "VILLA GESELL",
        "ARGERICH",
        "COLONIA SAN ADOLFO",
        "COUNTRY LOS MEDANOS",
        "HILARIO ASCASUBI",
        "JUAN COUSTE",
        "MAYOR BURATOVICH",
        "MEDANOS",
        "PEDRO LURO",
        "TENIENTE ORIGONE",
        "COUNTRY CLUB EL CASCO",
        "ESCALADA",
        "LIMA",
        "ZARATE",
        "BARRIO SAAVEDRA",
        "CARHUE",
        "COLONIA SAN MIGUEL ARCANGEL",
        "DELFIN HUERGO",
        "ESPARTILLAR",
        "ESTEBAN AGUSTIN GASCON",
        "LA PALA",
        "MAZA",
        "RIVERA",
        "VILLA MARGARITA",
        "YUTUYACO",
        "ADOLFO GONZALES CHAVES",
        "DE LA GARMA",
        "JUAN E. BARRA",
        "VASQUEZ",
        "BARRIO RUTA 24 KILOMETRO 10"
      ],
      K: [
        "CHUCHUCARUANA",
        "COLPES",
        "EL BOLSON",
        "EL RODEO",
        "HUAYCAMA",
        "LA PUERTA",
        "LAS CHACRITAS",
        "LAS JUNTAS",
        "LOS CASTILLOS",
        "LOS TALAS",
        "LOS VARELA",
        "SINGUIL",
        "ANCASTI",
        "ANQUINCILA",
        "LA CANDELARIA",
        "LA MAJADA",
        "AMANAO",
        "ANDALGALA",
        "CHAQUIAGO",
        "CHOYA",
        "BUENA VISTA",
        "EL ALAMITO",
        "ACONQUIJA",
        "ALTO DE LAS JUNTAS",
        "EL LINDERO",
        "LA MESADA",
        "EL POTRERO",
        "LA AGUADA",
        "ANTOFAGASTA DE LA SIERRA",
        "ANTOFALLA",
        "EL PE\xD1ON",
        "LOS NACIMIENTOS",
        "BARRANCA LARGA",
        "BELEN",
        "CONDOR HUASI",
        "CORRAL QUEMADO",
        "EL DURAZNO",
        "FARALLON NEGRO",
        "HUALFIN",
        "JACIPUNCO",
        "LA PUNTILLA",
        "LONDRES",
        "PUERTA DE CORRAL QUEMADO",
        "PUERTA DE SAN JOSE",
        "VILLA VIL",
        "ADOLFO E. CARRANZA",
        "BALDE DE LA PUNTA",
        "CAPAYAN",
        "CHUMBICHA",
        "COLONIA DEL VALLE",
        "COLONIA NUEVA CONETA",
        "CONCEPCION",
        "CONETA",
        "EL BA\xD1ADO",
        "HUILLAPIMA",
        "LOS ANGELES",
        "LOS ANGELES NORTE",
        "LOS ANGELES SUR",
        "MIRAFLORES",
        "SAN MARTIN",
        "SAN PABLO",
        "SAN PEDRO",
        "EL PANTANILLO",
        "SAN FERNANDO DEL VALLE DE CATAMARCA",
        "EL ALTO",
        "GUAYAMBA",
        "INFANZON",
        "LOS CORRALES",
        "TAPSO",
        "VILISMAN",
        "COLLAGASTA",
        "POMANCILLO ESTE",
        "POMANCILLO OESTE",
        "EL HUECO",
        "LA CARRERA",
        "LA FALDA DE SAN ANTONIO",
        "LA TERCENA",
        "SAN ANTONIO",
        "SAN JOSE",
        "VILLA LAS PIRQUITAS",
        "CASA DE PIEDRA",
        "EL AYBAL",
        "EL DIVISADERO",
        "EL QUIMILO",
        "ESQUIU",
        "ICA\xD1O",
        "LA DORADA",
        "LA GUARDIA",
        "LAS ESQUINAS",
        "LAS PALMITAS",
        "QUIROS",
        "RAMBLONES",
        "RECREO",
        "AMADORES",
        "EL ROSARIO",
        "LA BAJADA",
        "LA HIGUERA",
        "LA MERCED",
        "LA VI\xD1A",
        "LAS LAJAS",
        "MONTE POTRERO",
        "PALO LABRADO",
        "VILLA DE BALCOZNA",
        "APOYACO",
        "COLANA",
        "EL PAJONAL",
        "JOYANGO",
        "MUTQUIN",
        "POMAN",
        "RINCON",
        "SAN MIGUEL",
        "SAUJIL",
        "SIJAN",
        "ANDALHUALA",
        "CASPICHANGO",
        "CHA\xD1AR PUNCO",
        "LAMPACITO",
        "MEDANITOS",
        "EL CAJON",
        "EL DESMONTE",
        "EL PUESTO",
        "FAMATANCA",
        "SAN JOSE BANDA",
        "FUERTE QUEMADO",
        "LA HOYADA",
        "LA LOMA",
        "EL CERRITO",
        "LAS MOJARRAS",
        "LORO HUASI",
        "PUNTA DE BALASTO",
        "PALO SECO",
        "SAN JOSE NORTE",
        "SAN JOSE VILLA",
        "SANTA MARIA",
        "YAPES",
        "ALIJILAN",
        "BA\xD1ADO DE OVANTA",
        "LAS CA\xD1AS",
        "LAVALLE",
        "LOS ALTOS",
        "MANANTIALES",
        "ANILLACO",
        "ANTINACO",
        "BANDA DE LUCERO",
        "CERRO NEGRO",
        "COPACABANA",
        "CORDOBITA",
        "COSTA DE REYES",
        "EL PUEBLITO",
        "EL SALADO",
        "FIAMBALA",
        "LA RAMADITA",
        "PAMPA BLANCA",
        "LOS BALVERDIS",
        "PALO BLANCO",
        "PUNTA DEL AGUA",
        "TATON",
        "TINOGASTA",
        "EL PORTEZUELO",
        "LAS TEJAS",
        "POLCOS",
        "POZO DEL MISTOL",
        "SAN ISIDRO",
        "SANTA ROSA",
        "SUMALAO",
        "VILLA DOLORES",
        "SANTA CRUZ"
      ],
      X: [
        "AMBOY",
        "ARROYO SAN ANTONIO",
        "CA\xD1ADA DEL SAUCE",
        "CAPILLA VIEJA",
        "EL CORCOVADO - EL TORREON",
        "EL DURAZNO",
        "EMBALSE",
        "LA CRUZ",
        "LA CUMBRECITA",
        "LAS BAJADAS",
        "LAS CALERAS",
        "LOS CONDORES",
        "LOS MOLINOS",
        "VILLA SAN MIGUEL",
        "LOS REARTES",
        "LUTTI",
        "PARQUE CALMAYO",
        "RIO DE LOS SAUCES",
        "SAN AGUSTIN",
        "SAN IGNACIO (LOTEO SAN JAVIER)",
        "SANTA ROSA DE CALAMUCHITA",
        "SANTA MONICA",
        "SAN IGNACIO (LOTEO VELEZ CRESPO)",
        "SEGUNDA USINA",
        "SOLAR DE LOS MOLINOS",
        "VILLA ALPINA",
        "VILLA AMANCAY",
        "VILLA BERNA",
        "VILLA CIUDAD PARQUE LOS REARTES (1a.SECC",
        "VILLA CIUDAD PARQUE LOS REARTES",
        "VILLA CIUDAD PARQUES LOS REARTES (1\xB0 SECCION)",
        "VILLA CIUDAD PARQUE LOS REARTES (3\xB0 SECCION)",
        "VILLA DEL DIQUE",
        "VILLA EL TALA",
        "VILLA GENERAL BELGRANO",
        "VILLA LA RIVERA",
        "VILLA QUILLINZO",
        "VILLA RUMIPAL",
        "VILLA YACANTO",
        "CORDOBA",
        "JARDIN ARENALES",
        "LA FLORESTA",
        "AGUA DE ORO",
        "ASCOCHINGA",
        "BARRIO NUEVO RIO CEBALLOS",
        "CANTERAS EL SAUCE",
        "CASA BAMBA",
        "COLONIA CAROYA",
        "COLONIA TIROLESA",
        "COLONIA VICENTE AGUERO",
        "VILLA CORAZON DE MARIA",
        "CORRAL QUEMADO",
        "COUNTRY CHACRAS DE LA VILLA - COUNTRY SA",
        "COUNTRY CHACRAS DE LA VILLA",
        "COUNTRY SAN ISIDRO",
        "EL MANZANO",
        "ESTACION COLONIA TIROLESA",
        "GENERAL PAZ",
        "JESUS MARIA",
        "LA CALERA",
        "DUMESNIL",
        "EL DIQUECITO",
        "LA GRANJA",
        "LA MORADA",
        "LA PUERTA",
        "LAS CORZUELAS",
        "LOS MOLLES",
        "MALVINAS ARGENTINAS",
        "MENDIOLAZA",
        "MI GRANJA",
        "PAJAS BLANCAS",
        "RIO CEBALLOS",
        "SALDAN",
        "SALSIPUEDES",
        "EL PUEBLITO",
        "SANTA ELENA",
        "TINOCO",
        "UNQUILLO",
        "VILLA ALLENDE",
        "VILLA CERRO AZUL",
        "VILLA EL FACHINAL - PARQUE NORTE - GUI\xD1A",
        "GUI\xD1AZU NORTE",
        "PARQUE NORTE",
        "1 DE AGOSTO",
        "ALMIRANTE BROWN",
        "CIUDAD DE LOS NI\xD1OS",
        "VILLA PASTORA",
        "VILLA LOS LLANOS",
        "JUAREZ CELMAN",
        "ALTO DE LOS QUEBRACHOS",
        "BA\xD1ADO DE SOTO",
        "CANTERAS QUILPO",
        "CRUZ DE CA\xD1A",
        "CRUZ DEL EJE",
        "EL BRETE",
        "EL RINCON",
        "GUANACO MUERTO",
        "LA BANDA",
        "LA BATEA",
        "LA HIGUERA",
        "LAS CA\xD1ADAS",
        "LAS PLAYAS",
        "LOS CHA\xD1ARITOS",
        "MEDIA NARANJA",
        "PASO VIEJO",
        "SAN MARCOS SIERRA",
        "SERREZUELA",
        "TUCLAME",
        "VILLA DE SOTO",
        "DEL CAMPILLO",
        "ESTACION LECUEDER",
        "HIPOLITO BOUCHARD",
        "HUINCA RENANCO",
        "ITALO",
        "MATTALDI",
        "NICOLAS BRUZZONE",
        "ONAGOITY",
        "PINCEN",
        "RANQUELES",
        "SANTA MAGDALENA",
        "VILLA HUIDOBRO",
        "VILLA SARMIENTO",
        "VILLA VALERIA",
        "ARROYO ALGODON",
        "ARROYO CABRAL",
        "AUSONIA",
        "CHAZON",
        "ETRURIA",
        "LA LAGUNA",
        "LA PALESTINA",
        "LA PLAYOSA",
        "LAS MOJARRAS",
        "LUCA",
        "PASCO",
        "SANABRIA",
        "SILVIO PELLICO",
        "TICINO",
        "TIO PUJIO",
        "VILLA ALBERTINA",
        "VILLA MARIA",
        "VILLA NUEVA",
        "VILLA OESTE",
        "AVELLANEDA",
        "CA\xD1ADA DE RIO PINTO",
        "CHU\xD1A",
        "COPACABANA",
        "DEAN FUNES",
        "ESQUINA DEL ALAMBRE",
        "LOS POZOS",
        "OLIVARES DE SAN NICOLAS",
        "QUILINO",
        "SAN PEDRO DE TOYOS",
        "VILLA GUTIERREZ",
        "VILLA QUILINO",
        "ALEJANDRO ROCA",
        "ASSUNTA",
        "BENGOLEA",
        "CARNERILLO",
        "CHARRAS",
        "EL RASTREADOR",
        "GENERAL CABRERA",
        "GENERAL DEHEZA",
        "HUANCHILLAS",
        "LA CARLOTA",
        "LOS CISNES",
        "OLAETA",
        "PACHECO DE MELO",
        "PASO DEL DURAZNO",
        "SANTA EUFEMIA",
        "UCACHA",
        "VILLA REDUCCION",
        "ALEJO LEDESMA",
        "ARIAS",
        "CAMILO ALDAO",
        "CAPITAN GENERAL BERNARDO O`HIGGINS",
        "CAVANAGH",
        "COLONIA BARGE",
        "COLONIA ITALIANA",
        "COLONIA VEINTICINCO",
        "CORRAL DE BUSTOS",
        "CRUZ ALTA",
        "GENERAL BALDISSERA",
        "GENERAL ROCA",
        "GUATIMOZIN",
        "INRIVILLE",
        "ISLA VERDE",
        "LEONES",
        "LOS SURGENTES",
        "MARCOS JUAREZ",
        "MONTE BUEY",
        "SAIRA",
        "SALADILLO",
        "VILLA ELISA",
        "CIENAGA DEL CORO",
        "EL CHACHO",
        "ESTANCIA DE GUADALUPE",
        "GUASAPAMPA",
        "LA PLAYA",
        "SAN CARLOS MINAS",
        "TALAINI",
        "TOSNO",
        "CHANCANI",
        "LAS PALMAS",
        "LOS TALARES",
        "SALSACATE",
        "SAN GERONIMO",
        "TALA CA\xD1ADA",
        "TANINGA",
        "VILLA DE POCHO",
        "GENERAL LEVALLE",
        "LA CESIRA",
        "LABOULAYE",
        "LEGUIZAMON",
        "MELO",
        "RIO BAMBA",
        "ROSALES",
        "SAN JOAQUIN",
        "SERRANO",
        "VILLA ROSSI",
        "BARRIO SANTA ISABEL",
        "BIALET MASSE",
        "SAN ROQUE DEL LAGO",
        "CABALANGO",
        "CAPILLA DEL MONTE",
        "CASA GRANDE",
        "CHARBONIER",
        "COSQUIN",
        "CUESTA BLANCA",
        "ESTANCIA VIEJA",
        "HUERTA GRANDE",
        "LA CUMBRE",
        "LA FALDA",
        "LAS JARILLAS",
        "LOS COCOS",
        "MALLIN",
        "MAYU SUMAJ",
        "QUEBRADA DE LUNA",
        "SAN ANTONIO DE ARREDONDO",
        "SAN ESTEBAN",
        "SAN ROQUE",
        "SANTA MARIA DE PUNILLA",
        "TALA HUASI",
        "TANTI",
        "VALLE HERMOSO",
        "VILLA CARLOS PAZ",
        "VILLA FLOR SERRANA",
        "VILLA GIARDINO",
        "VILLA LAGO AZUL",
        "VILLA PARQUE SIQUIMAN",
        "VILLA RIO ICHO CRUZ",
        "VILLA SAN JOSE",
        "VILLA SANTA CRUZ DEL LAGO",
        "ACHIRAS",
        "ADELIA MARIA",
        "ALCIRA",
        "ALPA CORRAL",
        "BERROTARAN",
        "BULNES",
        "CHAJAN",
        "CHUCUL",
        "CORONEL BAIGORRIA",
        "CORONEL MOLDES",
        "ELENA",
        "LA CAROLINA",
        "LA CAUTIVA",
        "LA GILDA",
        "LAS ACEQUIAS",
        "LAS ALBAHACAS",
        "LAS HIGUERAS",
        "LAS PE\xD1AS",
        "LAS VERTIENTES",
        "MALENA",
        "MONTE DE LOS GAUCHOS",
        "RIO CUARTO",
        "SAMPACHO",
        "SAN BASILIO",
        "SANTA CATALINA",
        "SUCO",
        "TOSQUITAS",
        "VICU\xD1A MACKENNA",
        "VILLA EL CHACAY",
        "VILLA SANTA EUGENIA",
        "WASHINGTON",
        "ATAHONA",
        "CA\xD1ADA DE MACHADO",
        "CAPILLA DE LOS REMEDIOS",
        "CHALACEA",
        "COLONIA LAS CUATRO ESQUINAS",
        "DIEGO DE ROJAS",
        "EL ALCALDE",
        "EL CRISPIN",
        "ESQUINA",
        "KILOMETRO 658",
        "LA PARA",
        "LA POSTA",
        "LA QUINTA",
        "LAS GRAMILLAS",
        "LAS SALADAS",
        "MAQUINISTA GALLINI",
        "MONTE DEL ROSARIO",
        "MONTECRISTO",
        "OBISPO TREJO",
        "PIQUILLIN",
        "PLAZA DE MERCEDES",
        "PUEBLO COMECHINGONES",
        "RIO PRIMERO",
        "SAGRADA FAMILIA",
        "SANTA ROSA DE RIO PRIMERO",
        "VILLA FONTANA",
        "CERRO COLORADO",
        "CHA\xD1AR VIEJO",
        "EUFRASIO LOZA",
        "GUTEMBERG",
        "LA RINCONADA",
        "LOS HOYOS",
        "PUESTO DE CASTRO",
        "RAYO CORTADO",
        "SAN PEDRO DE GUTEMBERG",
        "SEBASTIAN ELCANO",
        "VILLA CANDELARIA NORTE",
        "VILLA DE MARIA",
        "CALCHIN",
        "CALCHIN OESTE",
        "CAPILLA DEL CARMEN",
        "CARRILOBO",
        "COLAZO",
        "COLONIA VIDELA",
        "COSTASACATE",
        "IMPIRA",
        "LAGUNA LARGA",
        "LAS JUNTURAS",
        "LUQUE",
        "MANFREDI",
        "MATORRALES",
        "ONCATIVO",
        "PILAR",
        "POZO DEL MOLLE",
        "RINCON",
        "RIO SEGUNDO",
        "SANTIAGO TEMPLE",
        "VILLA DEL ROSARIO",
        "AMBUL",
        "ARROYO LOS PATOS",
        "EL HUAYCO",
        "LA CORTADERA",
        "LAS CALLES",
        "LAS OSCURAS",
        "LAS RABONAS",
        "LOS CALLEJONES",
        "MINA CLAVERO",
        "MUSSI",
        "NONO",
        "PANAHOLMA",
        "SAN HUBERTO",
        "SAN LORENZO",
        "SAN MARTIN",
        "SAN PEDRO",
        "SAN VICENTE",
        "SAUCE ARRIBA",
        "TASNA",
        "VILLA CURA BROCHERO",
        "CONLARA",
        "CRUZ CA\xD1A",
        "DOS ARROYOS",
        "EL PANTANILLO",
        "LA PAZ",
        "LA POBLACION",
        "LA RAMADA",
        "LA TRAVESIA",
        "LAS CHACRAS",
        "LAS TAPIAS",
        "LOMA BOLA",
        "LOS CERRILLOS",
        "LOS HORNILLOS",
        "LUYABA",
        "QUEBRACHO LADEADO",
        "QUEBRADA DE LOS POZOS",
        "SAN JAVIER Y YACANTO",
        "SAN JOSE",
        "VILLA DE LAS ROSAS",
        "ALTO RESBALOSO - EL BARRIAL",
        "EL VALLE",
        "VILLA DOLORES",
        "VILLA LA VI\xD1A",
        "ALICIA",
        "ALTOS DE CHIPION",
        "ARROYITO",
        "BALNEARIA",
        "BRINCKMANN",
        "COLONIA ANITA",
        "COLONIA 10 DE JULIO",
        "COLONIA LAS PICHANAS",
        "COLONIA MARINA",
        "COLONIA PROSPERIDAD",
        "COLONIA SAN BARTOLOME",
        "COLONIA SAN PEDRO",
        "COLONIA SANTA MARIA",
        "COLONIA VALTELINA",
        "COLONIA VIGNAUD",
        "DEVOTO",
        "EL ARA\xD1ADO",
        "EL FORTIN",
        "EL FUERTECITO",
        "EL TIO",
        "ESTACION LUXARDO",
        "COLONIA ITURRASPE",
        "FREYRE",
        "LA FRANCIA",
        "LA PAQUITA",
        "LA TORDILLA",
        "LAS VARAS",
        "LAS VARILLAS",
        "MARULL",
        "MIRAMAR",
        "MORTEROS",
        "PLAZA LUXARDO",
        "PLAZA SAN FRANCISCO",
        "PORTE\xD1A",
        "QUEBRACHO HERRADO",
        "SACANTA",
        "SAN FRANCISCO",
        "SATURNINO MARIA LASPIUR",
        "SEEBER",
        "TORO PUJIO",
        "TRANSITO",
        "VILLA CONCEPCION DEL TIO",
        "VILLA DEL TRANSITO",
        "VILLA SAN ESTEBAN",
        "ALTA GRACIA",
        "ANISACATE",
        "BARRIO GILBERT",
        "BARRIO GILBERT (1\xB0 DE MAYO)",
        "TEJAS TRES",
        "BOUWER",
        "CAMPOS DEL VIRREY",
        "CASEROS CENTRO",
        "CAUSANA",
        "COSTA AZUL",
        "DESPE\xD1ADEROS",
        "DIQUE CHICO",
        "EL POTRERILLO",
        "FALDA DEL CA\xD1ETE",
        "FALDA DEL CARMEN",
        "JOSE DE LA QUINTANA",
        "LA BOCA DEL RIO",
        "LA CARBONADA",
        "LA PAISANITA",
        "LA PERLA",
        "LA RANCHERITA",
        "LA SERRANITA",
        "LOS CEDROS - LAS QUINTAS",
        "BARRIO LAS QUINTAS",
        "LOS CEDROS",
        "LOZADA",
        "MALAGUE\xD1O",
        "MILENICA",
        "MONTE RALO",
        "POTRERO DE GARAY",
        "RAFAEL GARCIA",
        "SAN CLEMENTE",
        "SAN NICOLAS",
        "TIERRA ALTA",
        "SOCAVONES",
        "TOLEDO",
        "VALLE ALEGRE",
        "VALLE DE ANISACATE",
        "VILLA CIUDAD DE AMERICA (LOTEO DIEGO DE",
        "BARRIO VILLA DEL PARQUE",
        "VILLA CIUDAD DE AMERICA",
        "VILLA DEL PRADO",
        "LA DONOSA",
        "VILLA LA BOLSA",
        "VILLA LOS AROMOS",
        "VILLA PARQUE SANTA ANA",
        "MI VALLE",
        "VILLA SAN ISIDRO - JOSE DE LA QUINTANA",
        "VILLA SIERRAS DE ORO",
        "YOCSINA",
        "CAMINIAGA",
        "CHU\xD1A HUASI",
        "POZO NUEVO",
        "SAN FRANCISCO DEL CHA\xD1AR",
        "ALMAFUERTE",
        "COLONIA ALMADA",
        "CORRALITO",
        "DALMACIO VELEZ",
        "GENERAL FOTHERINGHAM",
        "HERNANDO",
        "JAMES CRAIK",
        "LAS ISLETILLAS",
        "LAS PERDICES",
        "LOS ZORROS",
        "OLIVA",
        "PAMPAYASTA NORTE",
        "PAMPAYASTA SUR",
        "PUNTA DEL AGUA",
        "RIO TERCERO",
        "TANCACHA",
        "VILLA ASCASUBI",
        "CANDELARIA SUR",
        "CA\xD1ADA DE LUQUE",
        "CAPILLA DE SITON",
        "LA PAMPA",
        "LOS MISTOLES",
        "SARMIENTO",
        "SIMBOLAR",
        "SINSACATE",
        "VILLA DEL TOTORAL",
        "CHURQUI CA\xD1ADA",
        "EL RODEO",
        "EL TUSCAL",
        "LAS ARRIAS",
        "LUCIO V. MANSILLA",
        "ROSARIO DEL SALADILLO",
        "SAN JOSE DE LA DORMIDA",
        "SAN JOSE DE LAS SALINAS",
        "SAN PEDRO NORTE",
        "VILLA TULUMBA",
        "ALDEA SANTA MARIA",
        "ALTO ALEGRE",
        "ANA ZUMARAN",
        "BALLESTEROS",
        "BALLESTEROS SUR",
        "BELL VILLE",
        "BENJAMIN GOULD",
        "CANALS",
        "CHILIBROSTE",
        "CINTRA",
        "COLONIA BISMARCK",
        "COLONIA BREMEN",
        "IDIAZABAL",
        "JUSTINIANO POSSE",
        "LABORDE",
        "MONTE LE\xD1A",
        "MONTE MAIZ",
        "MORRISON",
        "NOETINGER",
        "ORDO\xD1EZ",
        "PASCANAS",
        "PUEBLO ITALIANO",
        "RAMON J. CARCANO",
        "SAN ANTONIO DE LITIN",
        "SAN MARCOS",
        "SAN SEVERO",
        "VIAMONTE",
        "VILLA LOS PATOS",
        "WENCESLAO ESCALANTE"
      ],
      W: [
        "BELLA VISTA",
        "BERON DE ASTRADA",
        "YAHAPE",
        "CORRIENTES",
        "LAGUNA BRAVA",
        "RIACHUELO",
        "SAN CAYETANO",
        "CONCEPCION",
        "SANTA ROSA",
        "TABAY",
        "TATACUA",
        "CAZADORES CORRENTINOS",
        "CURUZU CUATIA",
        "PERUGORRIA",
        "EL SOMBRERO",
        "EMPEDRADO",
        "ESQUINA",
        "PUEBLO LIBERTADOR",
        "ALVEAR",
        "ESTACION TORRENT",
        "ITA IBATE",
        "LOMAS DE VALLEJOS",
        "NUESTRA SE\xD1ORA DEL ROSARIO DE CAA CATI",
        "PALMAR GRANDE",
        "COLONIA CAROLINA",
        "GOYA",
        "ITATI",
        "RAMADA PASO",
        "COLONIA LIEBIG'S",
        "ITUZAINGO",
        "SAN ANTONIO",
        "SAN CARLOS",
        "VILLA OLIVARI",
        "CRUZ DE LOS MILAGROS",
        "GOBERNADOR JUAN E. MARTINEZ",
        "LAVALLE",
        "SANTA LUCIA",
        "VILLA CORDOBA",
        "YATAYTI CALLE",
        "MBURUCUYA",
        "FELIPE YOFRE",
        "MARIANO I. LOZA",
        "MERCEDES",
        "COLONIA LIBERTAD",
        "ESTACION LIBERTAD",
        "JUAN PUJOL",
        "MOCORETA",
        "MONTE CASEROS",
        "PARADA ACU\xD1A",
        "PARADA LABOUGLE",
        "BONPLAND",
        "PARADA PUCHETA",
        "PASO DE LOS LIBRES",
        "TAPEBICUA",
        "SALADAS",
        "SAN LORENZO",
        "INGENIO PRIMER CORRENTINO",
        "PASO DE LA PATRIA",
        "SAN COSME",
        "SANTA ANA",
        "SAN LUIS DEL PALMAR",
        "COLONIA CARLOS PELLEGRINI",
        "GUAVIRAVI",
        "LA CRUZ",
        "YAPEYU",
        "LORETO",
        "SAN MIGUEL",
        "CHAVARRIA",
        "COLONIA PANDO",
        "9 DE JULIO",
        "PEDRO R. FERNANDEZ",
        "SAN ROQUE",
        "JOSE R. GOMEZ",
        "GARRUCHOS",
        "GOBERNADOR IGR.VALENTIN VIRASORO",
        "SANTO TOME",
        "SAUCE"
      ],
      H: [
        "CONCEPCION DEL BERMEJO",
        "LOS FRENTONES",
        "PAMPA DEL INFIERNO",
        "RIO MUERTO",
        "TACO POZO",
        "GENERAL VEDIA",
        "ISLA DEL CERRITO",
        "LA LEONESA",
        "LAS PALMAS",
        "PUERTO BERMEJO NUEVO",
        "PUERTO BERMEJO VIEJO",
        "PUERTO EVA PERON",
        "PRESIDENCIA ROQUE SAENZ PENA",
        "CHARATA",
        "GANCEDO",
        "GENERAL CAPDEVILA",
        "GENERAL PINEDO",
        "MESON DE FIERRO",
        "PAMPA LANDRIEL",
        "HERMOSO CAMPO",
        "ITIN",
        "CHOROTIS",
        "SANTA SYLVINA",
        "VENADOS GRANDES",
        "CORZUELA",
        "LA ESCONDIDA",
        "LA VERDE",
        "LAPACHITO",
        "MAKALLE",
        "EL ESPINILLO",
        "EL SAUZAL",
        "EL SAUZALITO",
        "FORTIN LAVALLE",
        "FUERTE ESPERANZA",
        "JUAN JOSE CASTELLI",
        "NUEVA POMPEYA",
        "VILLA RIO BERMEJITO",
        "WICHI",
        "ZAPARINQUI",
        "AVIA TERAI",
        "CAMPO LARGO",
        "FORTIN LAS CHU\xD1AS",
        "NAPENAY",
        "COLONIA POPULAR",
        "ESTACION GENERAL OBLIGADO",
        "LAGUNA BLANCA",
        "PUERTO TIROL",
        "CIERVO PETISO",
        "GENERAL JOSE DE SAN MARTIN",
        "LA EDUVIGIS",
        "LAGUNA LIMPIA",
        "PAMPA ALMIRON",
        "PAMPA DEL INDIO",
        "PRESIDENCIA ROCA",
        "SELVAS DEL RIO DE ORO",
        "TRES ISLETAS",
        "CORONEL DU GRATY",
        "ENRIQUE URIEN",
        "VILLA ANGELA",
        "LAS BRE\xD1AS",
        "LA CLOTILDE",
        "LA TIGRA",
        "SAN BERNARDO",
        "PRESIDENCIA DE LA PLAZA",
        "BARRIO DE LOS PESCADORES",
        "COLONIA BENITEZ",
        "MARGARITA BELEN",
        "QUITILIPI",
        "VILLA EL PALMAR",
        "BARRANQUERAS",
        "BASAIL",
        "COLONIA BARANDA",
        "FONTANA",
        "PUERTO VILELAS",
        "RESISTENCIA",
        "SAMUHU",
        "VILLA BERTHET",
        "CAPITAN SOLARI",
        "COLONIA ELISA",
        "COLONIAS UNIDAS",
        "INGENIERO BARBET",
        "LAS GARCITAS",
        "CHARADAI",
        "COTE LAI",
        "HAUMONIA",
        "HORQUILLA",
        "LA SABANA",
        "COLONIA ABORIGEN",
        "MACHAGAI",
        "NAPALPI",
        "MIRAFLORES"
      ],
      U: [
        "ARROYO VERDE",
        "PUERTO MADRYN",
        "PUERTO PIRAMIDE",
        "QUINTA EL MIRADOR",
        "RESERVA AREA PROTEGIDA EL DORADILLO",
        "BUENOS AIRES CHICO",
        "CHOLILA",
        "COSTA DE CHUBUT",
        "CUSHAMEN CENTRO",
        "EL HOYO",
        "EL MAITEN",
        "EPUYEN",
        "FOFO CAHUEL",
        "GUALJAINA",
        "LAGO EPUYEN",
        "LAGO PUELO",
        "LELEQUE",
        "ASTRA",
        "BAHIA BUSTAMANTE",
        "ACCESO NORTE",
        "BARRIO CALETA CORDOVA",
        "BARRIO CALETA OLIVARES",
        "BARRIO CASTELLI",
        "BARRIO CIUDADELA",
        "BARRIO GASODUCTO",
        "BARRIO G\xDCEMES",
        "BARRIO LAPRIDA",
        "BARRIO MANANTIAL ROSALES",
        "BARRIO MILITAR - AEROPUERTO MILITAR",
        "BARRIO PROSPERO PALAZZO",
        "BARRIO RESTINGA ALI",
        "BARRIO RODRIGUEZ PE\xD1A",
        "BARRIO SAAVEDRA",
        "BARRIO SARMIENTO",
        "BARRIO 25 DE MAYO",
        "BARRIO VILLA S.U.P.E.",
        "COMODORO RIVADAVIA",
        "KM. 5 - PRESIDENTE ORTIZ",
        "KM. 8 - DON BOSCO",
        "KM. 11 - CUARTELES",
        "KM. 3 - GENERAL MOSCONI",
        "DIADEMA ARGENTINA",
        "RADA TILLY",
        "CAMARONES",
        "GARAYALDE",
        "ALDEA ESCOLAR",
        "CORCOVADO",
        "ESQUEL",
        "LAGO ROSARIO",
        "LOS CIPRESES",
        "TREVELIN",
        "VILLA FUTALAUFQUEN",
        "DIQUE FLORENTINO AMEGHINO",
        "DOLAVON",
        "GAIMAN",
        "28 DE JULIO",
        "BLANCUNTRE",
        "EL ESCORIAL",
        "GASTRE",
        "LAGUNITA SALADA",
        "YALA LAUBAT",
        "ALDEA EPULEF",
        "CARRENLEUFU",
        "COLAN CONHUE",
        "PASO DEL SAPO",
        "TECKA",
        "EL MIRASOL",
        "LAS PLUMAS",
        "CERRO CONDOR",
        "LOS ALTARES",
        "PASO DE INDIOS",
        "PLAYA MAGAGNA",
        "PLAYA UNION",
        "RAWSON",
        "TRELEW",
        "ALDEA APELEG",
        "ALDEA BELEIRO",
        "ALTO RIO SENGUER",
        "DOCTOR RICARDO ROJAS",
        "FACUNDO",
        "LAGO BLANCO",
        "RIO MAYO",
        "BUEN PASTO",
        "SARMIENTO",
        "FRONTERA DE RIO PICO",
        "GOBERNADOR COSTA",
        "JOSE DE SAN MARTIN",
        "RIO PICO",
        "GAN GAN",
        "TELSEN"
      ],
      E: [
        "ARROYO BARU",
        "COLON",
        "COLONIA HUGUES",
        "HAMBIS",
        "HOCKER",
        "LA CLARITA",
        "PUEBLO CAZES",
        "PUEBLO LIEBIG'S",
        "EL BRILLANTE",
        "EL COLORADO",
        "SAN JOSE",
        "UBAJAY",
        "VILLA ELISA",
        "CALABACILLA",
        "CLODOMIRO LEDESMA",
        "COLONIA AYUI",
        "COLONIA GENERAL ROCA",
        "BENITO LEGEREN",
        "CONCORDIA",
        "LAS TEJAS",
        "VILLA ADELA",
        "VILLA ZORRAQUIN",
        "ESTACION YERUA",
        "ESTACION YUQUERI",
        "ESTANCIA GRANDE",
        "LA CRIOLLA",
        "LOS CHARRUAS",
        "NUEVA ESCOCIA",
        "PEDERNAL",
        "PUERTO YERUA",
        "ALDEA BRASILERA",
        "ALDEA GRAPSCHENTAL",
        "ALDEA PROTESTANTE",
        "ALDEA SALTO",
        "ALDEA SAN FRANCISCO",
        "ALDEA SPATZENKUTTER",
        "ALDEA VALLE MARIA",
        "COLONIA ENSAYO",
        "DIAMANTE",
        "STROBEL",
        "ESTACION CAMPS",
        "GENERAL ALVEAR",
        "GENERAL RACEDO",
        "GENERAL RAMIREZ",
        "LA JUANITA",
        "LA JAULA",
        "PARAJE LA VIRGEN",
        "PUERTO LAS CUEVAS",
        "ESTACION PUIGGARI",
        "VILLA LIBERTADOR SAN MARTIN",
        "CHAJARI",
        "COLONIA ALEMANA",
        "COLONIA PE\xD1A",
        "FEDERACION",
        "LOS CONQUISTADORES",
        "SAN JAIME DE LA FRONTERA",
        "SAN PEDRO",
        "SAN RAMON",
        "SANTA ANA",
        "VILLA DEL ROSARIO",
        "CONSCRIPTO BERNARDI",
        "EL CIMARRON",
        "FEDERAL",
        "NUEVA VIZCAYA",
        "SAUCE DE LUNA",
        "SAN JOSE DE FELICIANO",
        "SAN VICTOR",
        "ALDEA ASUNCION",
        "ESTACION LAZO",
        "GENERAL GALARZA",
        "GUALEGUAY",
        "PUERTO RUIZ",
        "ALDEA SAN ANTONIO",
        "ALDEA SAN JUAN",
        "ENRIQUE CARBO",
        "ESTACION ESCRI\xD1A",
        "FAUSTINO M. PARERA",
        "GENERAL ALMADA",
        "GILBERT",
        "GUALEGUAYCHU",
        "IRAZUSTA",
        "LARROQUE",
        "PASTOR BRITOS",
        "PUEBLO GENERAL BELGRANO",
        "URDINARRAIN",
        "CEIBAS",
        "IBICUY",
        "MEDANOS",
        "VILLA PARANACITO",
        "ALCARAZ",
        "BOVRIL",
        "COLONIA AVIGDOR",
        "EL SOLAR",
        "LA PAZ",
        "PIEDRAS BLANCAS",
        "SAN GUSTAVO",
        "SANTA ELENA",
        "SIR LEONARD",
        "ARANGUREN",
        "BETBEDER",
        "DON CRISTOBAL",
        "FEBRE",
        "HERNANDEZ",
        "LUCAS GONZALEZ",
        "NOGOYA",
        "XX DE SETIEMBRE",
        "ALDEA MARIA LUISA",
        "ALDEA SAN RAFAEL",
        "ALDEA SANTA MARIA",
        "ALDEA SANTA ROSA",
        "CERRITO",
        "PUEBLO MORENO",
        "COLONIA AVELLANEDA",
        "COLONIA CRESPO",
        "CRESPO",
        "EL PALENQUE",
        "EL PINGO",
        "EL RAMBLON",
        "HASENKAMP",
        "HERNANDARIAS",
        "LA PICADA",
        "LAS TUNAS",
        "MARIA GRANDE",
        "ORO VERDE",
        "PARANA",
        "PUEBLO BELLOCQ",
        "PUEBLO BRUGO",
        "PUEBLO GENERAL SAN MARTIN",
        "SAN BENITO",
        "SAUCE MONTRULL",
        "SAUCE PINTO",
        "SEGUI",
        "SOSA",
        "TABOSSI",
        "TEZANOS PINTO",
        "VIALE",
        "VILLA FONTANA",
        "VILLA GOBERNADOR LUIS F. ETCHEVEHERE",
        "VILLA URQUIZA",
        "GENERAL CAMPOS",
        "SAN SALVADOR",
        "ALTAMIRANO SUR",
        "DURAZNO",
        "ESTACION ARROYO CLE",
        "GOBERNADOR ECHAGUE",
        "GOBERNADOR MANSILLA",
        "GOBERNADOR SOLA",
        "GUARDAMONTE",
        "LAS GUACHAS",
        "MACIA",
        "ROSARIO DEL TALA",
        "BASAVILBASO",
        "CASEROS",
        "COLONIA ELIA",
        "CONCEPCION DEL URUGUAY",
        "HERRERA",
        "LAS MOSCAS",
        "LIBAROS",
        "1 DE MAYO",
        "PRONUNCIAMIENTO",
        "ROCAMORA",
        "SANTA ANITA",
        "VILLA MANTERO",
        "VILLA SAN JUSTO",
        "VILLA SAN MARCIAL",
        "ANTELO",
        "MOLINO DOLL",
        "VICTORIA",
        "ESTACION RAICES",
        "INGENIERO MIGUEL SAJAROFF",
        "JUBILEO",
        "PASO DE LA LAGUNA",
        "VILLA CLARA",
        "VILLA DOMINGUEZ",
        "VILLAGUAY"
      ],
      P: [
        "LA SOLEDAD",
        "GUADALCAZAR",
        "LA RINCONADA",
        "LAGUNA YEMA",
        "LAMADRID",
        "LOS CHIRIGUANOS",
        "POZO DE MAZA",
        "POZO DEL MORTERO",
        "VACA PERDIDA",
        "COLONIA PASTORIL",
        "FORMOSA",
        "GRAN GUARDIA",
        "MARIANO BOEDO",
        "MOJON DE FIERRO",
        "SAN HILARIO",
        "VILLA DEL CARMEN",
        "BANCO PAYAGUA",
        "GENERAL LUCIO V MANSILLA",
        "HERRADURA",
        "SAN FRANCISCO DE LAISHI",
        "TATANE",
        "VILLA ESCOLAR",
        "INGENIERO GUILLERMO N. JUAREZ",
        "BARTOLOME DE LAS CASAS",
        "COMUNIDAD ABORIGEN BARTOLOME DE LAS CASAS",
        "COLONIA SARMIENTO",
        "COMANDANTE FONTANA",
        "EL RECREO",
        "ESTANISLAO DEL CAMPO",
        "FORTIN CABO 1\xB0 LUGONES",
        "FORTIN SARGENTO 1\xB0 LEYES",
        "IBARRETA",
        "JUAN G. BAZAN",
        "LAS LOMITAS",
        "POSTA CAMBIO ZALAZAR",
        "POZO DEL TIGRE",
        "SAN MARTIN I",
        "SAN MARTIN II",
        "SUBTENIENTE PERIN",
        "VILLA GENERAL GUEMES",
        "VILLA GENERAL MANUEL BELGRANO",
        "BUENA VISTA",
        "EL ESPINILLO",
        "LAGUNA GALLO",
        "MISION TACAAGLE",
        "PORTON NEGRO",
        "TRES LAGUNAS",
        "CLORINDA",
        "LAGUNA BLANCA",
        "LAGUNA NAICK-NECK",
        "PALMA SOLA",
        "PUERTO PILCOMAYO",
        "RIACHO HE-HE",
        "RIACHO NEGRO",
        "SIETE PALMAS",
        "COLONIA CAMPO VILLAFA\xD1E",
        "EL COLORADO",
        "PALO SANTO",
        "PIRANE",
        "VILLA KILOMETRO 213",
        "EL POTRILLO",
        "GENERAL MOSCONI",
        "EL QUEBRACHO"
      ],
      Y: [
        "ABDON CASTRO TOLAY",
        "ABRA PAMPA",
        "ABRALAITE",
        "AGUA DE CASTILLA",
        "CASABINDO",
        "COCHINOCA",
        "LA REDONDA",
        "PUESTO DEL MARQUEZ",
        "QUEBRALE\xD1A",
        "QUERA",
        "RINCONADILLAS",
        "SAN FRANCISCO DE ALFARCITO",
        "SANTA ANA DE LA PUNA",
        "SANTUARIO DE TRES POZOS",
        "TAMBILLOS",
        "TUSAQUILLAS",
        "AGUAS CALIENTES",
        "FLEMING",
        "PILA PARDO",
        "BARRIO EL MILAGRO",
        "BARRIO LA UNION",
        "EL CARMEN",
        "LOS LAPACHOS",
        "SAN VICENTE",
        "MANANTIALES",
        "MONTERRICO",
        "PAMPA BLANCA",
        "PERICO",
        "PUESTO VIEJO",
        "SAN ISIDRO",
        "SAN JUANCITO",
        "GUERRERO",
        "LA ALMONA",
        "LEON",
        "LOZANO",
        "OCLOYAS",
        "SAN SALVADOR DE JUJUY",
        "TESORERO",
        "LOS NOGALES",
        "SAN PABLO DE REYES",
        "YALA",
        "APARZO",
        "CIANZO",
        "COCTACA",
        "EL AGUILAR",
        "HIPOLITO YRIGOYEN",
        "HUMAHUACA",
        "PALCA DE APARZO",
        "PALCA DE VARAS",
        "RODERO",
        "TRES CRUCES",
        "UQUIA",
        "BANANAL",
        "BERMEJITO",
        "CAIMANCITO",
        "CALILEGUA",
        "CHALICAN",
        "FRAILE PINTADO",
        "LIBERTAD",
        "LIBERTADOR GENERAL SAN MARTIN",
        "PUEBLO LEDESMA",
        "MAIZ NEGRO",
        "PAULINA",
        "YUTO",
        "CARAHUNCO",
        "CENTRO FORESTAL",
        "PALPALA",
        "RIO BLANCO",
        "CASA COLORADA",
        "COYAGUAIMA",
        "LAGUNILLAS DE FARALLON",
        "LIVIARA",
        "LOMA BLANCA",
        "NUEVO PIRQUITAS",
        "OROSMAYO",
        "RINCONADA",
        "EL CEIBAL",
        "LOS ALISOS",
        "LOTEO NAVEA",
        "NUESTRA SE?ORA DEL ROSARIO",
        "SAN ANTONIO",
        "ARRAYANAL",
        "ARROYO COLORADO",
        "DON EMILIO",
        "EL ACHERAL",
        "EL PUESTO",
        "EL QUEMADO",
        "LA ESPERANZA",
        "LA MANGA",
        "LA MENDIETA",
        "MIRAFLORES",
        "PALOS BLANCOS",
        "PARAPETI",
        "PIEDRITAS",
        "RODEITO",
        "ROSARIO DE RIO GRANDE",
        "SAN LUCAS",
        "SAN PEDRO",
        "SAUZAL",
        "EL FUERTE",
        "EL PIQUETE",
        "EL TALAR",
        "PALMA SOLA",
        "PUENTE LAVAYEN",
        "SANTA CLARA",
        "VINALITO",
        "CASIRA",
        "CIENEGA",
        "CIENEGUILLAS",
        "CUSI CUSI",
        "EL ANGOSTO",
        "LA CIENEGA",
        "MISARRUMI",
        "ORATORIO",
        "PAICONE",
        "SAN JUAN DE OROS",
        "SANTA CATALINA",
        "YOSCABA",
        "CATUA",
        "CORANZULI",
        "EL TORO",
        "HUANCAR",
        "JAMA",
        "MINA PROVIDENCIA",
        "OLACAPATO",
        "OLAROZ CHICO",
        "PASTOS CHICOS",
        "PUESTO SEY",
        "SAN JUAN DE QUILLAQUES",
        "SUSQUES",
        "COLONIA SAN JOSE",
        "YACORAITE",
        "HUACALERA",
        "JUELLA",
        "MAIMARA",
        "TILCARA",
        "BARCENA",
        "EL MORENO",
        "PUERTA DE COLORADOS",
        "PURMAMARCA",
        "TUMBAYA",
        "VOLCAN",
        "CASPALA",
        "PAMPICHUELA",
        "SAN FRANCISCO",
        "SANTA ANA",
        "VALLE COLORADO",
        "VALLE GRANDE",
        "BARRIOS",
        "CANGREJILLOS",
        "EL CONDOR",
        "LA INTERMEDIA",
        "LA QUIACA",
        "LLULLUCHAYOC",
        "PUMAHUASI",
        "SAN JOSE",
        "YAVI CHICO",
        "LA TOMA"
      ],
      L: [
        "DOBLAS",
        "MACACHIN",
        "MIGUEL RIGLOS",
        "ROLON",
        "TOMAS M. ANCHORENA",
        "ANZOATEGUI",
        "LA ADELA",
        "ANGUIL",
        "SANTA ROSA",
        "CATRILO",
        "LA GLORIA",
        "LONQUIMAY",
        "URIBURU",
        "CONHELO",
        "EDUARDO CASTEX",
        "MAURICIO MAYER",
        "MONTE NIEVAS",
        "RUCANELO",
        "WINIFREDA",
        "GOBERNADOR DUVAL",
        "PUELCHES",
        "SANTA ISABEL",
        "BERNARDO LARROUDE",
        "CEBALLOS",
        "CORONEL HILARIO LAGOS",
        "INTENDENTE ALVEAR",
        "SARAH",
        "VERTIZ",
        "ALGARROBO DEL AGUILA",
        "LA HUMADA",
        "ALPACHIRI",
        "GENERAL MANUEL J. CAMPOS",
        "GUATRACHE",
        "PERU",
        "SANTA TERESA",
        "ABRAMO",
        "BERNASCONI",
        "GENERAL SAN MARTIN",
        "HUCAL",
        "JACINTO ARAUZ",
        "CUCHILLO CO",
        "LA REFORMA",
        "LIMAY MAHUIDA",
        "CARRO QUEMADO",
        "LOVENTUE",
        "LUAN TORO",
        "TELEN",
        "VICTORICA",
        "AGUSTONI",
        "DORILA",
        "GENERAL PICO",
        "SPELUZZI",
        "TREBOLARES",
        "CASA DE PIEDRA",
        "PUELEN",
        "25 DE MAYO",
        "COLONIA BARON",
        "COLONIA SAN JOSE",
        "MIGUEL CANE",
        "QUEMU QUEMU",
        "RELMO",
        "VILLA MIRASOL",
        "CALEUFU",
        "INGENIERO FOSTER",
        "LA MARUJA",
        "PARERA",
        "PICHI HUINCA",
        "QUETREQUEN",
        "RANCUL",
        "ADOLFO VAN PRAET",
        "ALTA ITALIA",
        "DAMIAN MAISONAVE",
        "EMBAJADOR MARTINI",
        "FALUCHO",
        "INGENIERO LUIGGI",
        "OJEDA",
        "REALICO",
        "CACHIRULO",
        "NAICO",
        "TOAY",
        "ARATA",
        "METILEO",
        "TRENEL",
        "ATALIVA ROCA",
        "CHACHARRAMENDI",
        "COLONIA SANTA MARIA",
        "GENERAL ACHA",
        "QUEHUE",
        "UNANUE"
      ],
      F: [
        "AIMOGASTA",
        "MACHIGASTA",
        "SAN ANTONIO",
        "ARAUCO",
        "BA\xD1ADO DE LOS PANTANOS",
        "ESTACION MAZAN",
        "TERMAS DE SANTA TERESITA",
        "VILLA MAZAN",
        "LA RIOJA",
        "AMINGA",
        "ANILLACO",
        "ANJULLON",
        "CHUQUIS",
        "LOS MOLINOS",
        "PINCHAS",
        "SAN PEDRO",
        "SANTA VERA CRUZ",
        "AICU\xD1A",
        "GUANDACOL",
        "SANTA CLARA",
        "LOS PALACIOS",
        "PAGANCILLO",
        "BANDA FLORIDA",
        "VILLA UNION",
        "CHAMICAL",
        "POLCO",
        "ANGUINAN",
        "CHILECITO",
        "LA PUNTILLA",
        "LOS SARMIENTOS",
        "SAN MIGUEL",
        "COLONIA ANGUINAN",
        "COLONIA CATINZACO",
        "COLONIA MALLIGASTA",
        "COLONIA VICHIGASTA",
        "GUANCHIN",
        "MALLIGASTA",
        "MIRANDA",
        "NONOGASTA",
        "SAN NICOLAS",
        "SANTA FLORENTINA",
        "SA\xD1OGASTA",
        "TILIMUQUI",
        "VICHIGASTA",
        "ALTO CARRIZAL",
        "ANGULOS",
        "ANTINACO",
        "BAJO CARRIZAL",
        "CAMPANAS",
        "CHA\xD1ARMUYO",
        "FAMATINA",
        "LA CUADRA",
        "PITUIL",
        "PLAZA VIEJA",
        "SANTA CRUZ",
        "SANTO DOMINGO",
        "PUNTA DE LOS LLANOS",
        "TAMA",
        "CASTRO BARROS",
        "CHA\xD1AR",
        "LOMA BLANCA",
        "OLTA",
        "MALANZAN",
        "NACATE",
        "PORTEZUELO",
        "VILLA CASTELLI",
        "AMBIL",
        "COLONIA ORTIZ DE OCAMPO",
        "MILAGRO",
        "OLPAS",
        "SANTA RITA DE CATUNA",
        "ULAPES",
        "JAGUE",
        "VILLA SAN JOSE DE VINCHINA",
        "AMANA",
        "PATQUIA",
        "CHEPES",
        "DESIDERIO TELLO",
        "ALPASINCHE",
        "AMUSCHINA",
        "ANDOLUCAS",
        "CHAUPIHUASI",
        "CUIPAN",
        "LAS TALAS",
        "LOS ROBLES",
        "SALICAS",
        "SAN BLAS",
        "SHAQUI",
        "SURIYACO",
        "TUYUBIL",
        "VILLA SANAGASTA"
      ],
      M: [
        "1A. SECCION",
        "2A. SECCION",
        "3A. SECCION",
        "4A. SECCION",
        "5A. SECCION",
        "6A. SECCION",
        "7A. SECCION",
        "8A. SECCION",
        "9A. SECCION",
        "10A. SECCION",
        "11A. SECCION",
        "BOWEN",
        "CARMENSA",
        "GENERAL ALVEAR",
        "LOS COMPARTOS",
        "GODOY CRUZ",
        "GOBERNADOR BENEGAS",
        "LAS TORTUGAS",
        "PRESIDENTE SARMIENTO",
        "SAN FRANCISCO DEL MONTE",
        "VILLA HIPODROMO",
        "VILLA MARINI",
        "COLONIA SEGOVIA",
        "BERMEJO",
        "BUENA NUEVA",
        "CAPILLA DEL ROSARIO",
        "DORREGO",
        "EL SAUCE",
        "GENERAL BELGRANO",
        "JESUS NAZARENO",
        "LAS CA\xD1AS",
        "GUAYMALLEN",
        "PEDRO MOLINA",
        "RODEO DE LA CRUZ",
        "SAN JOSE",
        "VILLA NUEVA",
        "LA PRIMAVERA",
        "LOS CORRALITOS",
        "PUENTE DE HIERRO",
        "INGENIERO GIAGNONI",
        "JUNIN",
        "LA COLONIA",
        "LOS BARRIALES",
        "MEDRANO",
        "PHILLIPS",
        "RODRIGUEZ PE\xD1A",
        "DESAGUADERO",
        "LA PAZ",
        "VILLA ANTIGUA",
        "BLANCO ENCALADA",
        "JOCOLI",
        "LAS CUEVAS",
        "CAPDEVILA",
        "LAS HERAS",
        "EL ALGARROBAL",
        "EL BORBOLLON",
        "EL CHALLAO",
        "EL PLUMERILLO",
        "EL RESGUARDO",
        "EL ZAPALLAR",
        "LA CIENEGUITA",
        "PANQUEHUA",
        "SIERRAS DE ENCALADA",
        "LOS PENITENTES",
        "POLVAREDAS",
        "PUENTE DEL INCA",
        "PUNTA DE VACAS",
        "USPALLATA",
        "BARRIO ALTO DEL OLVIDO",
        "BARRIO JOCOLI II",
        "BARRIO LA PALMERA",
        "BARRIO LA PEGA",
        "BARRIO LAGUNAS DE BARTOLUZZI",
        "BARRIO LOS JARILLEROS",
        "BARRIO LOS OLIVOS",
        "BARRIO VIRGEN DEL ROSARIO",
        "COSTA DE ARAUJO",
        "EL PARAMILLO",
        "EL VERGEL",
        "BARRIO LA ESPERANZA",
        "INGENIERO GUSTAVO ANDRE",
        "JOCOLI VIEJO",
        "LAS VIOLETAS",
        "3 DE MAYO",
        "VILLA TULUMAYA",
        "AGRELO",
        "BARRIO PERDRIEL IV",
        "CACHEUTA",
        "COSTA FLORES",
        "EL CARRIZAL",
        "EL CARMELO",
        "EL SALTO",
        "LAS CARDITAS",
        "LOS MANANTIALES",
        "LAS COMPUERTAS",
        "LAS VEGAS",
        "PIEDRAS BLANCAS",
        "VALLE DEL SOL",
        "VILLA EL REFUGIO",
        "CARRODILLA",
        "CHACRAS DE CORIA",
        "LUJAN DE CUYO",
        "LA PUNTILLA",
        "MAYOR DRUMMOND",
        "VISTALBA",
        "BARRIO ADINA I Y II",
        "PERDRIEL",
        "POTRERILLOS",
        "UGARTECHE",
        "BARRANCAS",
        "BARRIO JESUS DE NAZARET",
        "CRUZ DE PIEDRA",
        "EL PEDREGAL",
        "FRAY LUIS BELTRAN",
        "COQUIMBITO",
        "GENERAL GUTIERREZ",
        "LUZURIAGA",
        "MAIPU",
        "RODEO DEL MEDIO",
        "RUSSELL",
        "SAN ROQUE",
        "VILLA TERESA",
        "AGUA ESCONDIDA",
        "LAS LE\xD1AS",
        "MALARGUE",
        "ANDRADE",
        "BARRIO COOPERATIVA LOS CAMPAMENTOS",
        "BARRIO RIVADAVIA",
        "EL MIRADOR",
        "LA CENTRAL",
        "LA ESPERANZA",
        "CUADRO ORTEGA",
        "LA FLORIDA",
        "LA LIBERTAD",
        "LOS ARBOLES",
        "LOS CAMPAMENTOS",
        "MUNDO NUEVO",
        "REDUCCION DE ABAJO",
        "RIVADAVIA",
        "SANTA MARIA DE ORO",
        "BARRIO CARRASCO",
        "BARRIO EL CEPILLO",
        "CHILECITO",
        "EUGENIO BUSTOS",
        "LA CONSULTA",
        "PAREDITAS",
        "SAN CARLOS",
        "ALTO VERDE",
        "BARRIO CHIVILCOY",
        "BARRIO EMANUEL",
        "BARRIO LA ESTACION",
        "BARRIO LOS CHARABONES",
        "BARRIO NTRA. SRA. DE FATIMA",
        "CHAPANAY",
        "CHIVILCOY",
        "EL ESPINO",
        "EL RAMBLON",
        "MONTECASEROS",
        "NUEVA CALIFORNIA",
        "PALMIRA",
        "CIUDAD DE SAN MARTIN",
        "TRES PORTE\xD1AS",
        "BARRIO CAMPOS EL TOLEDANO",
        "BARRIO EL NEVADO",
        "BARRIO EMPLEADOS DE COMERCIO",
        "BARRIO INTENDENCIA",
        "CAPITAN MONTOYA",
        "BARRIO ECHEVERRIA",
        "BARRIO LAS ROSAS",
        "BARRIO PRIMAVERA",
        "EL NIHUIL",
        "EL SOSNEADO",
        "EL TROPEZON",
        "GOUDGE",
        "JAIME PRATS",
        "LA LLAVE NUEVA",
        "LAS MALVINAS",
        "LOS REYUNOS",
        "MONTE COMAN",
        "POBRE DIABLO",
        "PUNTA DEL AGUA",
        "RAMA CAIDA",
        "REAL DEL PADRE",
        "SALTO DE LAS ROSAS",
        "CUADRO NACIONAL",
        "SAN RAFAEL",
        "25 DE MAYO",
        "VILLA ATUEL",
        "VILLA ATUEL NORTE",
        "BARRIO 12 DE OCTUBRE",
        "BARRIO MARIA AUXILIADORA",
        "BARRIO MOLINA CABRERA",
        "LA DORMIDA",
        "LAS CATITAS",
        "SANTA ROSA",
        "BARRIO SAN CAYETANO",
        "CAMPO LOS ANDES",
        "COLONIA LAS ROSAS",
        "EL MANZANO",
        "LOS SAUCES",
        "TUNUYAN",
        "VISTA FLORES",
        "BARRIO BELGRANO NORTE",
        "CORDON DEL PLATA",
        "EL PERAL",
        "EL ZAMPAL",
        "LA ARBOLEDA",
        "TUPUNGATO",
        "VILLA BASTIAS"
      ],
      N: [
        "APOSTOLES",
        "AZARA",
        "BARRIO RURAL",
        "ESTACION APOSTOLES",
        "PINDAPOY",
        "RINCON DE AZARA",
        "SAN JOSE",
        "TRES CAPONES",
        "ARISTOBULO DEL VALLE",
        "CAMPO GRANDE",
        "DOS DE MAYO NUCLEO I",
        "NUCLEO I",
        "NUCLEO II",
        "DOS DE MAYO NUCLEO III",
        "KILOMETRO 17 (RUTA 8)",
        "1 DE MAYO",
        "PUEBLO ILLIA",
        "SALTO ENCANTADO",
        "BARRIO DEL LAGO",
        "BONPLAND",
        "CANDELARIA",
        "CERRO CORA",
        "LORETO",
        "MARTIRES",
        "PROFUNDIDAD",
        "PUERTO SANTA ANA",
        "SANTA ANA",
        "BARRIO NUEVO GARUPA",
        "GARUPA",
        "NEMESIO PARMA",
        "POSADAS",
        "BARRA CONCEPCION",
        "CONCEPCION DE LA SIERRA",
        "LA CORITA",
        "SANTA MARIA",
        "COLONIA VICTORIA",
        "ELDORADO",
        "MARIA MAGDALENA",
        "NUEVA DELICIA",
        "9 DE JULIO",
        "9 DE JULIO KILOMETRO 20",
        "PUEBLO NUEVO",
        "PUERTO MADO",
        "PUERTO PINARES",
        "SANTIAGO DE LINIERS",
        "VALLE HERMOSO",
        "VILLA ROULET",
        "ALMIRANTE BROWN",
        "BERNARDO DE IRIGOYEN",
        "CABUREI",
        "DOS HERMANAS",
        "INTEGRACION",
        "PI\xD1ALITO NORTE",
        "PUERTO ANDRESITO",
        "PUERTO DESEADO",
        "SAN ANTONIO",
        "EL SOBERBIO",
        "FRACRAN",
        "SAN VICENTE",
        "ESPERANZA",
        "LIBERTAD",
        "PUERTO IGUAZU",
        "VILLA COOPERATIVA",
        "WANDA",
        "ALMAFUERTE",
        "ARROYO DEL MEDIO",
        "CAA - YARI",
        "CERRO AZUL",
        "DOS ARROYOS",
        "GOBERNADOR LOPEZ",
        "LEANDRO N. ALEM",
        "OLEGARIO V. ANDRADE",
        "VILLA LIBERTAD",
        "CAPIOVI",
        "CAPIOVICI\xD1O",
        "EL ALCAZAR",
        "GARUHAPE",
        "MBOPICUA",
        "PUERTO LEONI",
        "PUERTO RICO",
        "RUIZ DE MONTOYA",
        "SAN ALBERTO",
        "SAN GOTARDO",
        "SAN MIGUEL",
        "VILLA AKERMAN",
        "VILLA URRUTIA",
        "BARRIO CUATRO BOCAS",
        "BARRIO GUATAMBU",
        "BARIO ITA",
        "CARAGUATAY",
        "LAHARRAGUE",
        "MONTECARLO",
        "PIRAY KILOMETRO 18",
        "PUERTO PIRAY",
        "TARUMA",
        "VILLA PARODI",
        "ALBERDI",
        "BARRIO ESCUELA 461",
        "BARRIO ESCUELA 633",
        "CAMPO RAMON",
        "CAMPO VIERA",
        "EL SALTO",
        "GENERAL ALVEAR",
        "GUARANI",
        "LOS HELECHOS",
        "OBERA",
        "PANAMBI",
        "PANAMBI KILOMETRO 8",
        "PANAMBI KILOMETRO 15",
        "SAN MARTIN",
        "VILLA BONITA",
        "BARRIO TUNGOIL",
        "COLONIA POLANA",
        "CORPUS",
        "DOMINGO SAVIO",
        "GENERAL URQUIZA",
        "GOBERNADOR ROCA",
        "HELVECIA",
        "HIPOLITO YRIGOYEN",
        "JARDIN AMERICA",
        "OASIS",
        "ROCA CHICA",
        "SAN IGNACIO",
        "SANTO PIPO",
        "FLORENTINO AMEGHINO",
        "ITACARUARE",
        "MOJON GRANDE",
        "SAN JAVIER",
        "CRUCE CABALLERO",
        "PARAISO",
        "PI\xD1ALITO SUR",
        "SAN PEDRO",
        "TOBUNA",
        "ALBA POSSE",
        "COLONIA ALICIA",
        "ALICIA BAJA",
        "COLONIA AURORA",
        "SAN FRANCISCO DE ASIS",
        "SANTA RITA",
        "25 DE MAYO"
      ],
      Q: [
        "ALUMINE",
        "MOQUEHUE",
        "VILLA PEHUENIA",
        "AGUADA SAN ROQUE",
        "A\xD1ELO",
        "SAN PATRICIO DEL CHA\xD1AR",
        "LAS COLORADAS",
        "PIEDRA DEL AGUILA",
        "SANTO TOMAS",
        "ARROYITO",
        "BARRIO RUCA LUHE",
        "CENTENARIO",
        "CUTRAL CO",
        "EL CHOCON",
        "MARI MENUCO",
        "NEUQUEN",
        "11 DE OCTUBRE",
        "PLAZA HUINCUL",
        "PLOTTIER",
        "SENILLOSA",
        "VILLA EL CHOCON",
        "VISTA ALEGRE NORTE",
        "VISTA ALEGRE SUR",
        "CHOS MALAL",
        "TRICAO MALAL",
        "VILLA DEL CURI LEUVU",
        "JUNIN DE LOS ANDES",
        "SAN MARTIN DE LOS ANDES",
        "LAGO MELIQUINA",
        "CHORRIACA",
        "LONCOPUE",
        "VILLA LA ANGOSTURA",
        "VILLA TRAFUL",
        "ANDACOLLO",
        "HUINGANCO",
        "LAS OVEJAS",
        "LOS MICHES",
        "MANZANO AMARGO",
        "VARVARCO",
        "VILLA DEL NAHUEVE",
        "CAVIAHUE",
        "COPAHUE",
        "EL CHOLAR",
        "EL HUECU",
        "TAQUIMILAN",
        "BARRANCAS",
        "BUTA RANQUIL",
        "OCTAVIO PICO",
        "RINCON DE LOS SAUCES",
        "EL SAUCE",
        "PASO AGUERRE",
        "PICUN LEUFU",
        "BAJADA DEL AGRIO",
        "LA BUITRERA",
        "LAS LAJAS",
        "QUILI MALAL",
        "LOS CATUTOS",
        "COVUNCO CENTRO",
        "MARIANO MORENO",
        "RAMON M. CASTRO",
        "ZAPALA"
      ],
      R: [
        "BAHIA CREEK",
        "EL CONDOR",
        "EL JUNCAL",
        "GUARDIA MITRE",
        "LA LOBERIA",
        "LOTEO COSTA DE RIO",
        "POZO SALADO",
        "SAN JAVIER",
        "VIEDMA",
        "BARRIO UNION",
        "CHELFORO",
        "CHIMPAY",
        "CHOELE CHOEL",
        "CORONEL BELISLE",
        "DARWIN",
        "LAMARQUE",
        "LUIS BELTRAN",
        "POMONA",
        "VILLA ARELAUQUEN",
        "BARRIO EL PILAR",
        "COLONIA SUIZA",
        "EL BOLSON",
        "EL FOYEL",
        "MALLIN AHOGADO",
        "RIO VILLEGAS",
        "SAN CARLOS DE BARILOCHE",
        "VILLA CAMPANARIO",
        "VILLA LLAO LLAO",
        "VILLA CATEDRAL",
        "VILLA LOS COIHUES",
        "VILLA MASCARDI",
        "BARRIO COLONIA CONESA",
        "GENERAL CONESA",
        "BARRIO PLANTA COMPRESORA DE GAS",
        "AGUADA GUZMAN",
        "CERRO POLICIA",
        "EL CUY",
        "LAS PERLAS",
        "MENCUE",
        "NAUPA HUEN",
        "PASO CORDOVA",
        "VALLE AZUL",
        "ALLEN",
        "BAJO SAN CAYETANO",
        "BARDA DEL MEDIO",
        "BARRIO BLANCO",
        "BARRIO CALLE CIEGA N? 10",
        "BARRIO CALLE CIEGA N? 6",
        "BARRIO CANALE",
        "BARRIO CHACRA MONTE",
        "BARRIO COSTA ESTE",
        "BARRIO COSTA LINDA",
        "BARRIO COSTA OESTE",
        "BARRIO DESTACAMENTO",
        "BARRIO EL LABRADOR",
        "BARRIO EL MARUCHITO",
        "BARRIO EL PETROLEO",
        "BARRIO EMERGENTE",
        "COLONIA FATIMA",
        "BARRIO FRONTERA",
        "BARRIO GUERRICO",
        "BARRIO ISLA 10",
        "BARRIO LA BARDA",
        "BARRIO LA COSTA",
        "BARRIO LA DEFENSA",
        "BARRIO LA HERRADURA",
        "BARRIO LA RIBERA - BARRIO APYCAR",
        "BARRIO LAS ANGUSTIAS",
        "BARRIO LUISILLO",
        "BARRIO MAR DEL PLATA",
        "BARRIO MARIA ELVIRA",
        "BARRIO MO\xD1O AZUL",
        "BARRIO MOSCONI",
        "BARRIO NORTE",
        "BARRIO PINAR",
        "BARRIO PORVENIR",
        "BARRIO EL TREINTA",
        "BARRIO GORETTI",
        "BARRIO PUENTE 83",
        "BARRIO PUENTE DE MADERA",
        "BARRIO TRES LUCES",
        "TRES LUCES",
        "SANTA LUCIA",
        "BARRIO SANTA RITA",
        "CATRIEL",
        "CERVANTES",
        "CHICHINALES",
        "CINCO SALTOS",
        "BARRIO PRESIDENTE PERON",
        "CIPOLLETTI",
        "BARRIO LA LOR",
        "CONTRALMIRANTE CORDERO",
        "FERRI",
        "GENERAL ENRIQUE GODOY",
        "GENERAL FERNANDEZ ORO",
        "GENERAL ROCA",
        "BARRIO PINO AZUL",
        "INGENIERO LUIS A. HUERGO",
        "INGENIERO OTTO KRAUSE",
        "MAINQUE",
        "PENINSULA RUCA CO",
        "SARGENTO VIDAL",
        "VILLA ALBERDI",
        "VILLA DEL PARQUE",
        "VILLA MANZANO",
        "VILLA REGINA",
        "VILLA SAN ISIDRO",
        "COMICO",
        "CONA NIYEU",
        "MINISTRO RAMOS MEXIA",
        "PRAHUANIYEU",
        "SIERRA COLORADA",
        "TRENETA",
        "YAMINUE",
        "LAS BAYAS",
        "MAMUEL CHOIQUE",
        "\xD1ORQUINCO",
        "OJOS DE AGUA",
        "RIO CHICO",
        "BARRIO ESPERANZA",
        "COLONIA JULIA Y ECHARREN",
        "JUVENTUD UNIDA",
        "PICHI MAHUIDA",
        "RIO COLORADO",
        "SALTO ANDERSEN",
        "CA\xD1ADON CHILENO",
        "COMALLO",
        "DINA HUAPI",
        "LAGUNA BLANCA",
        "\xD1IRIHUAU",
        "PILCANIYEU",
        "PILQUINIYEU DEL LIMAY",
        "VILLA LLANQUIN",
        "ESTACION EMPALME",
        "LAS GRUTAS",
        "PLAYAS DORADAS",
        "PUERTO SAN ANTONIO ESTE",
        "PUNTA COLORADA",
        "SACO VIEJO",
        "SAN ANTONIO OESTE",
        "SIERRA GRANDE",
        "AGUADA CECILIO",
        "ARROYO LOS BERROS",
        "ARROYO VENTANA",
        "NAHUEL NIYEU",
        "SIERRA PAILEMAN",
        "VALCHETA",
        "AGUADA DE GUERRA",
        "CLEMENTE ONELLI",
        "COLAN CONUE",
        "EL CAIN",
        "INGENIERO JACOBACCI",
        "LOS MENUCOS",
        "MAQUINCHAO",
        "MINA SANTA TERESITA",
        "PILQUINIYEU"
      ],
      A: [
        "APOLINARIO SARAVIA",
        "CEIBALITO",
        "CENTRO 25 DE JUNIO",
        "CORONEL MOLLINEDO",
        "CORONEL OLLEROS",
        "EL QUEBRACHAL",
        "GAONA",
        "GENERAL PIZARRO",
        "JOAQUIN V. GONZALEZ",
        "LAS LAJITAS",
        "LUIS BURELA",
        "MACAPILLO",
        "NUESTRA SE\xD1ORA DE TALAVERA",
        "PIQUETE CABADO",
        "RIO DEL VALLE",
        "TOLLOCHE",
        "CACHI",
        "PAYOGASTA",
        "CAFAYATE",
        "TOLOMBOM",
        "ATOCHA",
        "BARRIO SAN RAFAEL",
        "LA CIENAGA",
        "LAS COSTAS",
        "SALTA",
        "CC EL TIPAL",
        "CC LA ALMUDENA",
        "VILLA SAN LORENZO",
        "CERRILLOS",
        "LA MERCED",
        "SAN AGUSTIN",
        "VILLA LOS ALAMOS",
        "BARRIO EL CONGRESO",
        "BARRIO LAS TUNAS",
        "BARRIO LOS OLMOS",
        "BARRIO LOS PINARES",
        "LA MAROMA",
        "BARRIO LA ROTONDA",
        "BARRIO SANTA TERESITA",
        "CHICOANA",
        "EL CARRIL",
        "CAMPO SANTO",
        "COBOS",
        "EL BORDO",
        "GENERAL GUEMES",
        "AGUARAY",
        "CAMPAMENTO VESPUCIO",
        "CAMPICHUELO",
        "CAMPO DURAN",
        "CAPIAZUTI",
        "CARBONCITO",
        "CORONEL CORNEJO",
        "DRAGONES",
        "EMBARCACION",
        "MISION TIERRAS FISCALES",
        "GENERAL BALLIVIAN",
        "GENERAL MOSCONI",
        "RECAREDO",
        "HICKMAN",
        "MISION CHAQUE\xD1A",
        "BARRIO EL MILAGRO",
        "BARRIO EL JARDIN DE SAN MARTIN",
        "MISION EL CRUCE",
        "MISION KILOMETRO 6",
        "PACARA",
        "PADRE LOZANO",
        "PIQUIRENDA",
        "PROFESOR SALVADOR MAZZA",
        "TARTAGAL",
        "TOBANTIRENDA",
        "TRANQUITAS",
        "YACUY",
        "GUACHIPAS",
        "IRUYA",
        "ISLA DE CA\xD1AS",
        "PUEBLO VIEJO",
        "LA CALDERA",
        "VAQUEROS",
        "EL JARDIN",
        "EL TALA",
        "LA CANDELARIA",
        "COBRES",
        "LA POMA",
        "AMPASCACHI",
        "CABRA CORRAL",
        "CORONEL MOLDES",
        "LA VI\xD1A",
        "TALAPAMPA",
        "OLACAPATO",
        "SAN ANTONIO DE LOS COBRES",
        "SANTA ROSA DE LOS PASTOS GRANDES",
        "TOLAR GRANDE",
        "EL GALPON",
        "EL TUNAL",
        "LUMBRERAS",
        "SAN JOSE DE METAN",
        "METAN VIEJO",
        "RIO PIEDRAS",
        "SAN JOSE DE ORQUERA",
        "LA PUERTA",
        "MOLINOS",
        "SECLANTAS",
        "AGUAS BLANCAS",
        "COLONIA SANTA ROSA",
        "LA MISION",
        "EL TABACAL",
        "HIPOLITO YRIGOYEN",
        "PICHANAL",
        "SAN RAMON DE LA NUEVA ORAN",
        "URUNDEL",
        "ALTO DE LA SIERRA",
        "CAPITAN JUAN PAGE",
        "CORONEL JUAN SOLA",
        "HITO 1",
        "LA UNION",
        "LOS BLANCOS",
        "PLUMA DE PATO",
        "RIVADAVIA",
        "SANTA MARIA",
        "SANTA ROSA",
        "SANTA VICTORIA ESTE",
        "ANTILLA",
        "COPO QUILE",
        "EL NARANJO",
        "EL POTRERO",
        "ROSARIO DE LA FRONTERA",
        "SAN FELIPE",
        "CAMPO QUIJANO",
        "LA MERCED DEL ENCON",
        "LA SILLETA",
        "ROSARIO DE LERMA",
        "ANGASTACO",
        "ANIMANA",
        "EL BARRIAL",
        "SAN CARLOS",
        "ACOYTE",
        "CAMPO LA CRUZ",
        "LOS TOLDOS",
        "NAZARENO",
        "POSCAYA",
        "SAN MARCOS",
        "SANTA VICTORIA"
      ],
      J: [
        "EL RINCON",
        "CAMPO AFUERA",
        "VILLA AMPACAMA",
        "VILLA GENERAL SAN MARTIN",
        "LAS TAPIAS",
        "VILLA EL SALVADOR",
        "VILLA SEFAIR (TALACASTO)",
        "BARREAL",
        "VILLA PITUIL",
        "CALINGASTA",
        "TAMBERIAS",
        "SAN JUAN",
        "BERMEJO",
        "BARRIO JUSTO P. CASTRO IV",
        "CAUCETE",
        "LAS TALAS",
        "LOS MEDANOS",
        "MARAYES",
        "PIE DE PALO",
        "VALLECITO",
        "VILLA INDEPENDENCIA",
        "CHIMBAS",
        "EL MOGOTE",
        "VILLA PAULA ALBARRACIN",
        "ANGUALASTO",
        "BELLA VISTA",
        "IGLESIA",
        "LAS FLORES",
        "PISMANTA",
        "RODEO",
        "TUDCUM",
        "EL MEDANO",
        "GRAN CHINA",
        "HUACO",
        "MOGNA",
        "NIQUIVIL",
        "EL FISCAL",
        "LA FALDA",
        "PAMPA VIEJA",
        "SAN ISIDRO",
        "SAN JOSE DE JACHAL",
        "VILLA MALVINAS ARGENTINAS",
        "VILLA MERCEDES",
        "COLONIA FIORITO",
        "LAS CHACRITAS",
        "9 DE JULIO",
        "BARRIO MUNICIPAL",
        "BARRIO RUTA 40",
        "CARPINTERIA",
        "LAS PIEDRITAS",
        "QUINTO CUARTEL",
        "LA RINCONADA",
        "VILLA ABERASTAIN",
        "VILLA BARBOZA",
        "VILLA NACUSI",
        "VILLA CENTENARIO",
        "EL MEDANITO",
        "RAWSON",
        "VILLA KRAUSE",
        "VILLA BOLA\xD1OS",
        "RIVADAVIA",
        "BARRIO SADOP",
        "DOS ACEQUIAS",
        "VILLA DOMINGUITO",
        "VILLA DON BOSCO",
        "VILLA SAN MARTIN",
        "ALTO DE SIERRA",
        "COLONIA GUTIERREZ",
        "SANTA LUCIA",
        "CA\xD1ADA HONDA",
        "CIENAGUITA",
        "COLONIA FISCAL",
        "DIVISADERO",
        "GUANACACHE",
        "LAS LAGUNAS",
        "LOS BERROS",
        "PEDERNAL",
        "PUNTA DEL MEDANO",
        "VILLA MEDIA AGUA",
        "VILLA IBA\xD1EZ",
        "ASTICA",
        "BALDE DEL ROSARIO",
        "CHUCUMA",
        "LOS BALDECITOS",
        "USNO",
        "VILLA SAN AGUSTIN",
        "EL ENCON",
        "TUPELI",
        "LA CHIMBERA",
        "VILLA BORJAS",
        "VILLA EL TANGO",
        "VILLA SANTA ROSA",
        "VILLA BASILIO NIEVAS",
        "VILLA TACU",
        "LA CA\xD1ADA"
      ],
      D: [
        "CANDELARIA",
        "LEANDRO N. ALEM",
        "LUJAN",
        "QUINES",
        "SAN FRANCISCO DEL MONTE DE ORO",
        "LA CALERA",
        "NOGOLI",
        "VILLA DE LA QUEBRADA",
        "VILLA GENERAL ROCA",
        "CAROLINA",
        "EL TRAPICHE",
        "ESTANCIA GRANDE",
        "FRAGA",
        "LA BAJADA",
        "LA FLORIDA",
        "LA TOMA",
        "RIOCITO",
        "RIO GRANDE",
        "SALADILLO",
        "CONCARAN",
        "CORTADERAS",
        "NASCHEL",
        "PAPAGAYOS",
        "RENCA",
        "SAN PABLO",
        "TILISARAO",
        "VILLA DEL CARMEN",
        "VILLA LARCA",
        "JUAN JORBA",
        "JUAN LLERENA",
        "JUSTO DARACT",
        "LA PUNILLA",
        "LAVAISSE",
        "NACION RANQUEL",
        "SAN JOSE DEL MORRO",
        "VILLA MERCEDES",
        "LA RIBERA",
        "VILLA REYNOLDS",
        "COUNTRY CLUB LOS CALDENES",
        "5TA BRIGADA",
        "VILLA SALLES",
        "ANCHORENA",
        "ARIZONA",
        "BAGUAL",
        "BATAVIA",
        "BUENA ESPERANZA",
        "FORTIN EL PATRIA",
        "FORTUNA",
        "LA MAROMA",
        "LOS OVEROS",
        "MARTIN DE LOYOLA",
        "NAHUEL MAPA",
        "NAVIA",
        "NUEVA GALIA",
        "UNION",
        "CARPINTERIA",
        "CERRO DE ORO",
        "LAFINUR",
        "LOS CAJONES",
        "LOS MOLLES",
        "MERLO",
        "SANTA ROSA DEL CONLARA",
        "TALITA",
        "ALTO PELADO",
        "ALTO PENCOSO",
        "BALDE",
        "BEAZLEY",
        "CAZADOR",
        "CHOSMES",
        "DESAGUADERO",
        "EL VOLCAN",
        "JARILLA",
        "CERRO COLORADO",
        "CRUZ DE PIEDRA",
        "EL CHORRILLO",
        "LAS CHACRAS",
        "SAN ROQUE",
        "CIUDAD DE LA PUNTA",
        "MOSMOTA",
        "POTRERO DE LOS FUNES",
        "SALINAS DEL BEBEDERO",
        "SAN JERONIMO",
        "SAN LUIS",
        "ZANJITAS",
        "LA VERTIENTE",
        "LAS AGUADAS",
        "LAS LAGUNAS",
        "PASO GRANDE",
        "POTRERILLO",
        "SAN MARTIN",
        "VILLA DE PRAGA"
      ],
      Z: [
        "COMANDANTE LUIS PIEDRABUENA",
        "PUERTO SANTA CRUZ",
        "CALETA OLIVIA",
        "CA\xD1ADON SECO",
        "FITZ ROY",
        "JARAMILLO",
        "KOLUEL KAIKE",
        "LAS HERAS",
        "PICO TRUNCADO",
        "PUERTO DESEADO",
        "TELLIER",
        "EL TURBIO",
        "JULIA DUFOUR",
        "MINA 3",
        "RIO GALLEGOS",
        "ROSPENTEK",
        "28 DE NOVIEMBRE",
        "YACIMIENTOS RIO TURBIO",
        "EL CALAFATE",
        "EL CHALTEN",
        "TRES LAGOS",
        "LOS ANTIGUOS",
        "PERITO MORENO",
        "PUERTO SAN JULIAN",
        "BAJO CARACOLES",
        "GOBERNADOR GREGORES",
        "HIPOLITO YRIGOYEN"
      ],
      S: [
        "ARMSTRONG",
        "BOUQUET",
        "LAS PAREJAS",
        "LAS ROSAS",
        "MONTES DE OCA",
        "TORTUGAS",
        "AREQUITO",
        "ARTEAGA",
        "BERAVEBU",
        "BIGAND",
        "CASILDA",
        "CHABAS",
        "CHA\xD1AR LADEADO",
        "GODEKEN",
        "LOS MOLINOS",
        "LOS NOGALES",
        "LOS QUIRQUINCHOS",
        "SAN JOSE DE LA ESQUINA",
        "SANFORD",
        "VILLADA",
        "ALDAO",
        "ANGELICA",
        "ATALIVA",
        "AURELIA",
        "BARRIOS ACAPULCO Y VERACRUZ",
        "BAUER Y SIGEL",
        "BELLA ITALIA",
        "CASTELLANOS",
        "COLONIA BICHA",
        "COLONIA CELLO",
        "COLONIA MARGARITA",
        "COLONIA RAQUEL",
        "CORONEL FRAGA",
        "EGUSQUIZA",
        "ESMERALDA",
        "ESTACION CLUCELLAS",
        "ESTACION SAGUIER",
        "EUSEBIA Y CAROLINA",
        "EUSTOLIA",
        "FRONTERA",
        "GARIBALDI",
        "HUMBERTO PRIMO",
        "JOSEFINA",
        "LEHMANN",
        "MARIA JUANA",
        "NUEVA LEHMANN",
        "PLAZA CLUCELLAS",
        "PLAZA SAGUIER",
        "ESTACION PRESIDENTE ROCA",
        "PRESIDENTE ROCA",
        "PUEBLO MARINI",
        "RAFAELA",
        "RAMONA",
        "SAN ANTONIO",
        "SAN VICENTE",
        "SANTA CLARA DE SAGUIER",
        "SUNCHALES",
        "SUSANA",
        "TACURAL",
        "VILA",
        "VILLA JOSEFINA",
        "VILLA SAN JOSE",
        "VIRGINIA",
        "ZENON PEREYRA",
        "ALCORTA",
        "BARRIO ARROYO DEL MEDIO",
        "BARRIO MITRE",
        "BOMBAL",
        "CA\xD1ADA RICA",
        "CEPEDA",
        "EMPALME VILLA CONSTITUCION",
        "FIRMAT",
        "GENERAL GELLY",
        "GODOY",
        "JUAN B. MOLINA",
        "JUNCAL",
        "LA VANGUARDIA",
        "MAXIMO PAZ",
        "PAVON",
        "PAVON ARRIBA",
        "PEYRANO",
        "RUEDA",
        "SANTA TERESA",
        "SARGENTO CABRAL",
        "STEPHENSON",
        "THEOBALD",
        "VILLA CONSTITUCION",
        "CAYASTA",
        "HELVECIA",
        "LOS ZAPALLOS",
        "SALADERO MARIANO CABAL",
        "SANTA ROSA DE CALCHINES",
        "AARON CASTELLANOS",
        "AMENABAR",
        "CAFFERATA",
        "CA\xD1ADA DEL UCLE",
        "CARMEN",
        "CARRERAS",
        "CHAPUY",
        "CHOVET",
        "CHRISTOPHERSEN",
        "DIEGO DE ALVEAR",
        "ELORTONDO",
        "HUGHES",
        "LA CHISPA",
        "LABORDEBOY",
        "LAZZARINO",
        "MAGGIOLO",
        "MARIA TERESA",
        "MELINCUE",
        "MIGUEL TORRES",
        "MURPHY",
        "RUFINO",
        "SAN EDUARDO",
        "SAN FRANCISCO DE SANTA FE",
        "SAN GREGORIO",
        "SANCTI SPIRITU",
        "SANTA ISABEL",
        "TEODELINA",
        "VENADO TUERTO",
        "VILLA CA\xD1AS",
        "WHEELWRIGHT",
        "ARROYO CEIBAL",
        "AVELLANEDA",
        "BERNA",
        "EL ARAZA",
        "EL RABON",
        "FLORENCIA",
        "GUADALUPE NORTE",
        "INGENIERO CHANOURDIE",
        "LA ISLETA",
        "LA SARITA",
        "LANTERI",
        "LAS GARZAS",
        "LAS TOSCAS",
        "LOS LAURELES",
        "MALABRIGO",
        "PARAJE SAN MANUEL",
        "PUERTO RECONQUISTA",
        "RECONQUISTA",
        "SAN ANTONIO DE OBLIGADO",
        "TACUARENDI",
        "VILLA ANA",
        "VILLA GUILLERMINA",
        "VILLA OCAMPO",
        "BARRIO CICARELLI",
        "BUSTINZA",
        "CA\xD1ADA DE GOMEZ",
        "CARRIZALES",
        "CLASSON",
        "COLONIA MEDICI",
        "CORREA",
        "LARGUIA",
        "LUCIO V. LOPEZ",
        "OLIVEROS",
        "PUEBLO ANDINO",
        "SALTO GRANDE",
        "SERODINO",
        "TOTORAS",
        "VILLA ELOISA",
        "VILLA LA RIVERA - OLIVEROS",
        "VILLA LA RIVERA - PUEBLO ANDINO",
        "ANGEL GALLARDO",
        "ARROYO AGUIAR",
        "ARROYO LEYES",
        "RINCON NORTE",
        "CABAL",
        "CAMPO ANDINO",
        "CANDIOTI",
        "EMILIA",
        "LAGUNA PAIVA",
        "LLAMBI CAMPBELL",
        "MONTE VERA",
        "NELSON",
        "PARAJE CHACO CHICO",
        "PARAJE LA COSTA",
        "RECREO",
        "RINCON POTRERO",
        "SAN JOSE DEL RINCON",
        "SANTA FE",
        "SANTO TOME",
        "SAUCE VIEJO",
        "VILLA ADELINA",
        "VILLA LAURA",
        "CAVOUR",
        "CULULU",
        "ELISA",
        "EMPALME SAN CARLOS",
        "ESPERANZA",
        "FELICIA",
        "FRANCK",
        "GRUTLY",
        "HIPATIA",
        "HUMBOLDT",
        "JACINTO L. ARAUZ",
        "LA PELADA",
        "LAS TUNAS",
        "MARIA LUISA",
        "MATILDE",
        "NUEVO TORINO",
        "PILAR",
        "PLAZA MATILDE",
        "PROGRESO",
        "PROVIDENCIA",
        "SA PEREYRA",
        "SAN AGUSTIN",
        "SAN CARLOS CENTRO",
        "SAN CARLOS NORTE",
        "SAN CARLOS SUD",
        "SAN JERONIMO DEL SAUCE",
        "SAN JERONIMO NORTE",
        "SAN MARIANO",
        "SANTA CLARA DE BUENA VISTA",
        "SANTO DOMINGO",
        "SARMIENTO",
        "ESTEBAN RAMS",
        "GATO COLORADO",
        "GREGORIA PEREZ DE DENIS",
        "LOGRO\xD1O",
        "MONTEFIORE",
        "POZO BORRADO",
        "SAN BERNARDO",
        "SANTA MARGARITA",
        "TOSTADO",
        "VILLA MINETTI",
        "ACEBAL",
        "ALBARELLOS",
        "ALVAREZ",
        "ALVEAR",
        "ARBILLA",
        "ARMINDA",
        "ARROYO SECO",
        "CARMEN DEL SAUCE",
        "CORONEL BOGADO",
        "CORONEL RODOLFO S. DOMINGUEZ",
        "CUATRO ESQUINAS",
        "EL CARAMELO",
        "FIGHIERA",
        "FUNES",
        "GENERAL LAGOS",
        "GRANADERO BAIGORRIA",
        "IBARLUCEA",
        "KILOMETRO 101",
        "LOS MUCHACHOS - LA ALBORADA",
        "MONTE FLORES",
        "PEREZ",
        "PI\xD1ERO",
        "PUEBLO ESTHER",
        "PUEBLO MU\xD1OZ",
        "PUEBLO URANGA",
        "PUERTO ARROYO SECO",
        "ROSARIO",
        "SOLDINI",
        "VILLA AMELIA",
        "VILLA DEL PLATA",
        "VILLA GOBERNADOR GALVEZ",
        "ZAVALLA",
        "AGUARA GRANDE",
        "AMBROSETTI",
        "ARRUFO",
        "BALNEARIO LA VERDE",
        "CAPIVARA",
        "CERES",
        "COLONIA ANA",
        "COLONIA BOSSI",
        "COLONIA ROSA",
        "CONSTANZA",
        "CURUPAYTI",
        "HERSILIA",
        "HUANQUEROS",
        "LA CABRAL",
        "LA LUCILA",
        "LA RUBIA",
        "LAS AVISPAS",
        "LAS PALMERAS",
        "MOISES VILLE",
        "MONIGOTES",
        "\xD1ANDUCITA",
        "PALACIOS",
        "SAN CRISTOBAL",
        "SAN GUILLERMO",
        "SANTURCE",
        "SOLEDAD",
        "SUARDI",
        "VILLA SARALEGUI",
        "VILLA TRINIDAD",
        "ALEJANDRA",
        "CACIQUE ARIACAIQUIN",
        "COLONIA DURAN",
        "LA BRAVA",
        "ROMANG",
        "SAN JAVIER",
        "AROCENA",
        "BALNEARIO MONJE",
        "BARRANCAS",
        "BARRIO CAIMA",
        "BARRIO EL PACAA - BARRIO COMIPINI",
        "BERNARDO DE IRIGOYEN",
        "CASALEGNO",
        "CENTENO",
        "CORONDA",
        "DESVIO ARIJON",
        "DIAZ",
        "GABOTO",
        "GALVEZ",
        "GESSLER",
        "IRIGOYEN",
        "LARRECHEA",
        "LOMA ALTA",
        "LOPEZ",
        "MACIEL",
        "MONJE",
        "PUERTO ARAGON",
        "SAN EUGENIO",
        "SAN FABIAN",
        "SAN GENARO",
        "SAN GENARO NORTE",
        "ANGELONI",
        "CAYASTACITO",
        "COLONIA DOLORES",
        "ESTHER",
        "GOBERNADOR CRESPO",
        "LA CRIOLLA",
        "LA PENCA Y CARAGUATA",
        "MARCELINO ESCALADA",
        "NARE",
        "PEDRO GOMEZ CELLO",
        "RAMAYON",
        "SAN JUSTO",
        "SAN MARTIN NORTE",
        "SILVA",
        "VERA Y PINTADO",
        "VIDELA",
        "CAPITAN BERMUDEZ",
        "CARCARA\xD1A",
        "CORONEL ARNOLD",
        "FRAY LUIS BELTRAN",
        "FUENTES",
        "LUIS PALACIOS",
        "PUERTO GENERAL SAN MARTIN",
        "PUJATO",
        "RICARDONE",
        "ROLDAN",
        "SAN JERONIMO SUD",
        "SAN LORENZO",
        "TIMBUES",
        "VILLA ELVIRA",
        "VILLA MUGUETA",
        "CA\xD1ADA ROSQUIN",
        "CARLOS PELLEGRINI",
        "CASAS",
        "CASTELAR",
        "COLONIA BELGRANO",
        "CRISPI",
        "EL TREBOL",
        "LANDETA",
        "LAS BANDURRIAS",
        "LAS PETACAS",
        "LOS CARDOS",
        "MARIA SUSANA",
        "PIAMONTE",
        "SAN JORGE",
        "SAN MARTIN DE LAS ESCOBAS",
        "SASTRE",
        "TRAILL",
        "WILDERMUTH",
        "CALCHAQUI",
        "CA\xD1ADA OMBU",
        "COLMENA",
        "FORTIN OLMOS",
        "GARABATO",
        "GOLONDRINA",
        "INTIYACO",
        "KILOMETRO 115",
        "LA GALLARETA",
        "LOS AMORES",
        "MARGARITA",
        "PARAJE 29",
        "POZO DE LOS INDIOS",
        "PUEBLO SANTA LUCIA",
        "TARTAGAL",
        "TOBA",
        "VERA"
      ],
      G: [
        "ARGENTINA",
        "CASARES",
        "MALBRAN",
        "VILLA GENERAL MITRE",
        "CAMPO GALLO",
        "CORONEL MANUEL L. RICO",
        "DONADEU",
        "SACHAYOJ",
        "SANTOS LUGARES",
        "ESTACION ATAMISQUI",
        "MEDELLIN",
        "VILLA ATAMISQUI",
        "COLONIA DORA",
        "HERRERA",
        "ICA\xD1O",
        "LUGONES",
        "REAL SAYANA",
        "VILLA MAILIN",
        "ABRA GRANDE",
        "ANTAJE",
        "ARDILES",
        "CA\xD1ADA ESCOBAR",
        "CHAUPI POZO",
        "CLODOMIRA",
        "HUYAMAMPA",
        "LA AURORA",
        "LA BANDA",
        "LA DARSENA",
        "LOS QUIROGA",
        "LOS SORIA",
        "SIMBOLAR",
        "TRAMO 16",
        "TRAMO 20",
        "BANDERA",
        "CUATRO BOCAS",
        "FORTIN INCA",
        "GUARDIA ESCOLTA",
        "EL DEAN",
        "EL MOJON",
        "EL ZANJON",
        "LOS CARDOZOS",
        "MACO",
        "MAQUITO",
        "MORALES",
        "PUESTO DE SAN ANTONIO",
        "SAN PEDRO",
        "SANTA MARIA",
        "SANTIAGO DEL ESTERO",
        "VUELTA DE LA BARRANCA",
        "YANDA",
        "EL CABURE",
        "LA FIRMEZA",
        "LOS PIRPINTOS",
        "LOS TIGRES",
        "MONTE QUEMADO",
        "NUEVA ESPERANZA",
        "PAMPA DE LOS GUANACOS",
        "SAN JOSE DEL BOQUERON",
        "URUTAU",
        "ANCAJAN",
        "CHOYA",
        "ESTACION LA PUNTA",
        "FRIAS",
        "LAPRIDA",
        "TAPSO",
        "VILLA LA PUNTA",
        "BANDERA BAJADA",
        "CASPI CORRAL",
        "COLONIA SAN JUAN",
        "EL CRUCERO",
        "KILOMETRO 30",
        "LA CA\xD1ADA",
        "LA INVERNADA",
        "MINERVA",
        "VACA HUA\xD1UNA",
        "VILLA FIGUEROA",
        "A\xD1ATUYA",
        "AVERIAS",
        "ESTACION TACA\xD1ITAS",
        "LA NENA",
        "LOS JURIES",
        "TOMAS YOUNG",
        "LAVALLE",
        "EL ARENAL",
        "EL BOBADAL",
        "EL CHARCO",
        "EL RINCON",
        "GRAMILLA",
        "LILO VIEJO",
        "ISCA YACU",
        "ISCA YACU SEMAUL",
        "POZO HONDO",
        "EL COLORADO",
        "EL CUADRADO",
        "MATARA",
        "SUNCHO CORRAL",
        "VILELAS",
        "YUCHAN",
        "VILLA SAN MARTIN",
        "VILLA UNION",
        "AEROLITO",
        "ALHUAMPA",
        "HASSE",
        "HERNAN MEJIA MIRAVAL",
        "LAS TINAJAS",
        "LIBERTAD",
        "PATAY",
        "PUEBLO PABLO TORELO",
        "QUIMILI",
        "ROVERSI",
        "TINTINA",
        "WEISBURD",
        "EL 49",
        "SOL DE JULIO",
        "VILLA OJO DE AGUA",
        "LAS DELICIAS",
        "POZO BETBEDER",
        "RAPELLI",
        "SANTO DOMINGO",
        "RAMIREZ DE VELAZCO",
        "SUMAMPA",
        "SUMAMPA VIEJO",
        "CHA\xD1AR POZO DE ABAJO",
        "CHAUCHILLAS",
        "COLONIA TINCO",
        "LA NUEVA DONOSA",
        "LOS MIRANDA",
        "LOS NU\xD1EZ",
        "MANSUPA",
        "POZUELOS",
        "RODEO DE VALDEZ",
        "SAUZAL",
        "TERMAS DE RIO HONDO",
        "VILLA GIMENEZ",
        "VILLA RIO HONDO",
        "VILLA TURISTICA DEL EMBALSE",
        "VINARA",
        "COLONIA ALPINA",
        "PALO NEGRO",
        "SELVA",
        "BELTRAN",
        "COLONIA EL SIMBOLAR",
        "FERNANDEZ",
        "INGENIERO FORRES",
        "VILMER",
        "CHILCA JULIANA",
        "LOS TELARES",
        "VILLA SALAVINA",
        "BREA POZO",
        "ESTACION ROBLES",
        "ESTACION TABOADA",
        "VILLA NUEVA",
        "GARZA",
        "ARRAGA",
        "NUEVA FRANCIA",
        "SIMBOL",
        "SUMAMAO",
        "VILLA SILIPICA"
      ],
      C: [
        "CIUDAD DE BUENOS AIRES",
        "CONSTITUCION",
        "MONSERRAT",
        "PUERTO MADERO",
        "RETIRO",
        "SAN NICOLAS",
        "SAN TELMO",
        "RECOLETA",
        "BALVANERA",
        "SAN CRISTOBAL",
        "BARRACAS",
        "BOCA",
        "NUEVA POMPEYA",
        "PARQUE PATRICIOS",
        "ALMAGRO",
        "BOEDO",
        "CABALLITO",
        "FLORES",
        "PARQUE CHACABUCO",
        "VILLA LUGANO",
        "VILLA RIACHUELO",
        "VILLA SOLDATI",
        "LINIERS",
        "MATADEROS",
        "PARQUE AVELLANEDA",
        "FLORESTA",
        "MONTE CASTRO",
        "VELEZ SARSFIELD",
        "VERSALLES",
        "VILLA LURO",
        "VILLA REAL",
        "VILLA DEL PARQUE",
        "VILLA DEVOTO",
        "VILLA GENERAL MITRE",
        "VILLA SANTA RITA",
        "COGHLAN",
        "SAAVEDRA",
        "VILLA PUEYRREDON",
        "VILLA URQUIZA",
        "BELGRANO",
        "COLEGIALES",
        "NU\xD1EZ",
        "PALERMO",
        "AGRONOMIA",
        "CHACARITA",
        "PARQUE CHAS",
        "PATERNAL",
        "VILLA CRESPO",
        "VILLA ORTUZAR"
      ],
      T: [
        "BARRIO SAN JORGE",
        "EL CHA\xD1AR",
        "EL NARANJO",
        "GARMENDIA",
        "LA RAMADA",
        "MACOMITAS",
        "PIEDRABUENA",
        "7 DE ABRIL",
        "VILLA BENJAMIN ARAOZ",
        "VILLA BURRUYACU",
        "VILLA PADRE MONTI",
        "ALDERETES",
        "EL CORTE",
        "LOS GUTIERREZ",
        "BANDA DEL RIO SALI",
        "BARRIO AEROPUERTO",
        "LASTENIA",
        "COLOMBRES",
        "COLONIA MAYO - BARRIO LA MILAGROSA",
        "EL PARAISO",
        "EX INGENIO ESPERANZA",
        "EX INGENIO LUJAN",
        "EL BRACHO",
        "INGENIO LA FLORIDA",
        "LA FLORIDA",
        "LAS CEJAS",
        "EX INGENIO LOS RALOS",
        "VILLA RECASTE",
        "VILLA TERCERA",
        "PACARA",
        "RANCHILLOS",
        "SAN ANDRES",
        "ALPACHIRI",
        "ALTO VERDE",
        "ARCADIA",
        "SAN ROQUE",
        "CONCEPCION",
        "ILTICO",
        "LA TRINIDAD",
        "MEDINA",
        "BARRIO CASA ROSADA",
        "CAMPO DE HERRERA",
        "EX INGENIO NUEVA BAVIERA",
        "FAMAILLA",
        "INGENIO FRONTERITA",
        "GRANEROS",
        "LAMADRID",
        "TACO RALO",
        "JUAN BAUTISTA ALBERDI",
        "VILLA BELGRANO",
        "LA COCHA",
        "SAN JOSE DE LA COCHA",
        "BELLA VISTA",
        "ESTACION ARAOZ",
        "LOS PUESTOS",
        "MANUEL GARCIA FERNANDEZ",
        "PALA PALA",
        "RIO COLORADO",
        "SANTA ROSA DE LEALES",
        "VILLA FIAD - INGENIO LEALES",
        "VILLA DE LEALES",
        "BARRIO SAN FELIPE",
        "BARRIO ARAUJO",
        "EL MANANTIAL",
        "INGENIO SAN PABLO",
        "LA REDUCCION",
        "LULES",
        "ACHERAL",
        "CAPITAN CACERES",
        "MONTEROS",
        "PUEBLO INDEPENDENCIA",
        "RIO SECO",
        "SANTA LUCIA",
        "SARGENTO MOYA",
        "SOLDADO MALDONADO",
        "TENIENTE BERDINA",
        "VILLA QUINTEROS",
        "AGUILARES",
        "INGENIO SANTA BARBARA",
        "LOS SARMIENTOS",
        "RIO CHICO",
        "SANTA ANA",
        "VILLA CLODOMIRO HILERET",
        "SAN MIGUEL DE TUCUMAN",
        "ATAHONA",
        "MONTEAGUDO",
        "NUEVA TRINIDAD",
        "SANTA CRUZ",
        "SIMOCA",
        "VILLA CHICLIGASTA",
        "AMAICHA DEL VALLE",
        "COLALAO DEL VALLE",
        "EL MOLLAR",
        "TAFI DEL VALLE",
        "BARRIO EL CRUCE",
        "BARRIO LOMAS DE TAFI",
        "BARRIO MUTUAL SAN MARTIN",
        "BARRIO PARADA 14",
        "BARRIO U.T.A. II",
        "DIAG. NORTE - LUZ Y FUERZA - LOS POCITOS",
        "EL CADILLAL",
        "TAFI VIEJO",
        "VILLA LAS FLORES",
        "VILLA MARIANO MORENO - EL COLMENAR",
        "CHOROMORO",
        "SAN PEDRO DE COLALAO",
        "VILLA DE TRANCAS",
        "BARRIO SAN JOSE III",
        "COUNTRY JOCKEY CLUB",
        "VILLA CARMELA",
        "EX INGENIO SAN JOSE",
        "YERBA BUENA - MARCOS PAZ"
      ],
      V: ["RIO GRANDE", "TOLHUIN", "LAGUNA ESCONDIDA", "USHUAIA"]
    };
    var paraguayCities = {
      "16": ["test"],
      "10": ["test"],
      "13": ["test"],
      ASU: ["test"],
      "19": ["test"],
      "5": ["test"],
      "6": ["test"],
      "14": ["test"],
      "11": ["test"],
      "1": ["test"],
      "3": ["test"],
      "4": ["test"],
      "7": ["test"],
      "8": ["test"],
      "12": ["test"],
      "9": ["test"],
      "15": ["test"],
      "2": ["test"]
    };
    var MAX_NEWS_REQUEST_FILES2 = 10;
    var identityProviders2 = ["google", "facebook", "microsoft"];
    var datasetEntities = ["car", "moto"];
    var datasetEntityKeys = ["make", "model"];
    var metricsCountGroupBy = [
      "claim_damage_type",
      "responsible_assigned",
      "ramo",
      "zone"
    ];
    var metricsHistogramBuckets2 = [
      "50000",
      "100000",
      "250000",
      "5000000",
      "1000000"
    ];
    var metricsFrequency2 = ["daily", "monthly"];
    var booleansString6 = ["true", "false"];
    var performanceAgingBuckets = [
      "0-30",
      "30-60",
      "60-90",
      "90+"
    ];
    var performanceAgingBucketLimits = {
      "0-30": 30,
      "30-60": 60,
      "60-90": 90
    };
    var performanceBacklogAgeBuckets = [
      "365+",
      "181-365",
      "91-180",
      "61-90",
      "31-60",
      "16-30",
      "0-15"
    ];
    var performanceBacklogAgeBucketLimits = {
      "0-15": 15,
      "16-30": 30,
      "31-60": 60,
      "61-90": 90,
      "91-180": 180,
      "181-365": 365
    };
    var performanceBacklogAgeAgingBucket = {
      "365+": "90+",
      "181-365": "90+",
      "91-180": "90+",
      "61-90": "60-90",
      "31-60": "30-60",
      "16-30": "0-30",
      "0-15": "0-30"
    };
    var PERFORMANCE_RUNWAY_MONTHS = 1;
    var performanceHeatmapThresholds = {
      // Operational efficacy runs higher than the old conciliation-only rate (its
      // numerator adds Rechazado/Anulado), so its bands sit above the ones the
      // column used while it measured Conciliado over Group A.
      efficacyRate: { good: 0.8, bad: 0.6 },
      // higher is better
      avgResolutionDays: { good: 45, bad: 70 },
      // lower is better
      mediationRate: { good: 0.02, bad: 0.05 },
      // lower is better
      avgAgingOpen: { good: 45, bad: 75 }
      // lower is better
    };
    var performanceClosingOutcomes2 = [
      "reconciled",
      "mediation",
      "judgment",
      "notSuccessful",
      "claimantDisinterest",
      "rejected",
      "cancelled",
      "fraud"
    ];
    var performanceStageNames = {
      reconciled: "Conciliado",
      cancelled: "Anulado",
      rejected: "Rechazado",
      claimantDisinterest: "Desinter\xE9s del Reclamante",
      mediation: "Mediaci\xF3n",
      notSuccessful: "No Prosper\xF3",
      fraud: "Fraude",
      judgment: "Juicio"
    };
    var performanceNegotiationStages = [
      performanceStageNames.reconciled,
      // 'Conciliado'
      performanceStageNames.mediation,
      // 'Mediación'
      performanceStageNames.judgment
      // 'Juicio'
    ];
    var performanceTechnicalStages = [
      performanceStageNames.rejected,
      // 'Rechazado'
      performanceStageNames.fraud,
      // 'Fraude'
      performanceStageNames.notSuccessful,
      // 'No Prosperó'
      performanceStageNames.claimantDisinterest
      // 'Desinterés del Reclamante'
    ];
    var performanceOperativeStages = [
      performanceStageNames.cancelled
      // 'Anulado'
    ];
    var performanceAllClosedStages = [
      ...performanceNegotiationStages,
      ...performanceTechnicalStages,
      ...performanceOperativeStages
    ];
    var CLAIM_SUCCESS_STAGES = [
      performanceStageNames.reconciled,
      // 'Conciliado'
      performanceStageNames.fraud,
      // 'Fraude' (incl. desistimientos)
      performanceStageNames.rejected,
      // 'Rechazado' (antecedentes, prescripción, exclusión…)
      performanceStageNames.cancelled
      // 'Anulado' (operativo: Cleas, duplicado…)
    ];
    var CLAIM_FAILURE_STAGES = [
      performanceStageNames.mediation,
      // 'Mediación'
      performanceStageNames.judgment,
      // 'Juicio'
      performanceStageNames.notSuccessful,
      // 'No Prosperó'
      performanceStageNames.claimantDisinterest
      // 'Desinterés del Reclamante'
    ];
    var CLAIM_CLASSIFIED_CLOSURE_STAGES = [
      ...CLAIM_SUCCESS_STAGES,
      ...CLAIM_FAILURE_STAGES
    ];
    var PERFORMANCE_CLOSED_RATE_BASE = 1e4;
    var PERFORMANCE_OFFER_READINESS_PROPERTIES = [
      "percentage_of_liability",
      "material_judicial_amount",
      "person_judicial_amount"
    ];
    var CLAIM_ESTIMATE_HISTORY_START = /* @__PURE__ */ new Date(
      "2026-08-27T23:11:06.000Z"
    );
    var performanceOfferableExcludedStatusNames = [
      "Pedido de documentaci\xF3n adicional",
      "Pendiente de documentaci\xF3n",
      "Pendiente de documentaci\xF3n - sin denuncia del asegurado"
    ];
    var performanceFraudInvestigationStageName = "Derivaci\xF3n a fraude";
    var performanceFunnelStageOrder = [
      "Generaci\xF3n de Reclamo",
      "An\xE1lisis del reclamo",
      "Inspecci\xF3n",
      "Negociaci\xF3n",
      "En proceso de Cierre"
    ];
    var performanceFunnelSpecialStages = [
      "Derivaci\xF3n a usuario",
      "Derivaci\xF3n a grupo",
      performanceFraudInvestigationStageName
      // 'Derivación a fraude'
    ];
    var PERFORMANCE_COHORT_MIN_START_AGE_DAYS = 15;
    var performanceCohortHeatmapThresholds = {
      good: 0.65,
      warning: 0.45,
      bad: 0.3
    };
    var performanceCohortSummaryStats = [
      "average",
      "p25",
      "median",
      "p75",
      "p95"
    ];
    var performanceCohortSummaryPercentiles = {
      p25: 25,
      median: 50,
      p75: 75,
      p95: 95
    };
    var performanceCohortRateBases = ["created", "closed"];
    var PERFORMANCE_NORTH_STAR_TREND_MIN_DAYS = 30;
    var PERFORMANCE_TREND_MONTHS = 6;
    var PERFORMANCE_METRICS_STALE_TIME_MS = 5 * 60 * 1e3;
    var PERFORMANCE_SNAPSHOT_TTL_MS = 15 * 60 * 1e3;
    var PERFORMANCE_SNAPSHOT_MAX_STALE_MS = 24 * 60 * 60 * 1e3;
    var PERFORMANCE_SNAPSHOT_RETENTION_DAYS = 7;
    var performanceConciliationOutcomeStages = {
      reconciled: performanceStageNames.reconciled,
      mediation: performanceStageNames.mediation,
      judgment: performanceStageNames.judgment
    };
    var PERFORMANCE_FRAUD_STATUS_ROLE = "fraud";
    var PERFORMANCE_OUTCOME_COHORT_DEFAULT_MONTHS = 12;
    var OFFER_AMOUNT_VARIABLE_NAME3 = "Importe";
    var performanceRiskAmountFilters2 = ["all", "gt500k", "gt1m"];
    var performanceRiskAmountFilterMinimums = {
      gt500k: 5e5,
      gt1m: 1e6
    };
    var PERFORMANCE_RISK_ZONE_MIN_DAYS_OPEN = 15;
    var PERFORMANCE_RISK_ZONE_REFERENCE_MONTHS = 6;
    var PERFORMANCE_RISK_ZONE_SCORE_THRESHOLD = 60;
    var PERFORMANCE_RISK_ZONE_CRITICAL_SCORE_THRESHOLD = 80;
    var PERFORMANCE_RISK_ZONE_TOP_CLAIMS = 50;
    var PERFORMANCE_RISK_ZONE_TABLE_ROWS = 10;
    var PERFORMANCE_RISK_ZONE_QUERY_LIMIT = 2e4;
    var CLAIM_ATTEMPT_IN_PROGRESS_WINDOW_MS = 48 * 60 * 60 * 1e3;
    var CLAIM_ATTEMPTS_BY_USER_LIMIT = 300;
    var riskZoneClaimTypes2 = [
      "injured",
      "combined",
      "material_damage"
    ];
    var riskZoneClaimTypeNames = {
      injured: "Lesionado",
      combined: "Combinado Da\xF1o Material con patente y Lesiones",
      material_damage: "Da\xF1o Material (con patente)"
    };
    var riskZoneZones = ["very_high", "high"];
    var riskZoneZoneMinScores = {
      very_high: 95,
      high: 80
    };
    var riskZoneOutcomes = [
      "open",
      "mediation",
      "judgment",
      "conciliated",
      "rejected",
      "withdrawn",
      "other"
    ];
    var riskZoneEscalatedOutcomes = [
      "mediation",
      "judgment"
    ];
    var riskZoneMatrixOutcomes = [
      "mediation",
      "judgment",
      "conciliated",
      "rejected",
      "withdrawn"
    ];
    var RISK_ZONE_TENANT_SLUG = "rivadaviaseguros";
    var RISK_ZONE_WINDOW_MONTHS = 9;
    var RISK_ZONE_DATA_START = "2026-01-01";
    var RISK_ZONE_MATRIX_MATURITY_MONTHS = 3;
    var RISK_ZONE_CLOSED_EVALUATION_DAYS = 30;
    var RISK_ZONE_TOP_CLAIMS = 50;
    var RISK_ZONE_QUERY_LIMIT = 1e5;
    var RISK_ZONE_PLACEHOLDER_AMOUNT = 1e9;
    var RISK_ZONE_POINTS_PER_DOUBLING = 20;
    var riskZoneSignalIds = [
      "claimed_amount_5_20m",
      "claimed_amount_over_20m",
      "high_risk_province",
      "low_risk_province",
      "massive_sinister",
      "attorney_claimant",
      "volume_claimant",
      "no_estimate",
      "estimate_below_half_claimed",
      "estimated_without_offer",
      "open_over_30_days"
    ];
    var riskZoneModels = {
      injured: {
        calibratedAt: "2026-09-21",
        intercept: -103.52,
        profileSignals: [
          {
            id: "claimed_amount_5_20m",
            rule: {
              kind: "claimed_amount",
              greaterThan: 5e6,
              lessThan: 2e7
            },
            points: 14.8
          },
          {
            id: "claimed_amount_over_20m",
            rule: { kind: "claimed_amount", atLeast: 2e7 },
            points: 41.9
          },
          {
            id: "high_risk_province",
            rule: { kind: "occurrence_state", states: ["C", "M"] },
            points: 29.1
          },
          {
            id: "low_risk_province",
            rule: {
              kind: "occurrence_state",
              states: ["K", "H", "U", "W", "P", "N", "A", "J", "Z", "S", "V"]
            },
            points: -29
          },
          {
            id: "massive_sinister",
            rule: { kind: "massive_sinister", minClaims: 4 },
            points: -27.1
          },
          {
            id: "attorney_claimant",
            rule: {
              kind: "claimant_relationship",
              relationships: ["attorney_representative", "attorney_in_fact"]
            },
            points: 9.9
          },
          {
            id: "volume_claimant",
            rule: { kind: "volume_claimant", minClaims: 50 },
            points: -48.4
          }
        ],
        managementSignals: [
          { id: "no_estimate", rule: { kind: "no_estimate" }, points: 22.8 },
          {
            id: "estimate_below_half_claimed",
            rule: { kind: "estimate_below_claimed", maxRatio: 0.5 },
            points: 17.8
          },
          {
            id: "estimated_without_offer",
            rule: { kind: "estimated_without_offer" },
            points: 21.5
          },
          {
            id: "open_over_30_days",
            rule: { kind: "days_open", minDays: 30 },
            points: 4.9
          }
        ],
        acceptedOfferPoints: -56.9,
        scoreThresholds: [
          -69.3,
          -52,
          -42.1,
          -38.5,
          -28.4,
          -24.3,
          -14.2,
          -12.1,
          -12.1,
          -10.8,
          -10.8,
          -10.8,
          -10.8,
          -10.8,
          -10.8,
          -10.8,
          -9.5,
          -7.4,
          -1.3,
          -1.3,
          -1.3,
          3.6,
          4.8,
          7.3,
          8.6,
          8.6,
          8.6,
          8.6,
          8.6,
          8.6,
          8.6,
          14.8,
          14.8,
          14.8,
          18.4,
          18.4,
          22.1,
          23.4,
          23.4,
          23.4,
          23.4,
          23.4,
          25.1,
          26.4,
          27.7,
          27.7,
          27.7,
          27.7,
          27.7,
          27.7,
          29.6,
          29.6,
          31.1,
          32.6,
          36.3,
          36.3,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          37.6,
          41.8,
          43.9,
          47.4,
          50.5,
          50.5,
          50.5,
          52.3,
          52.4,
          52.4,
          52.4,
          52.4,
          52.4,
          52.4,
          52.4,
          54.4,
          56.8,
          56.8,
          65.4,
          66.7,
          67,
          68.9,
          69.6,
          74.5,
          79.5,
          79.5,
          79.5,
          81.6,
          86.1,
          96,
          108.6,
          125.1
        ],
        cappedSignal: { id: "massive_sinister", calibrationCases: 71 }
      }
    };
    var riskZoneZoneMinPoints = (model, zone) => model.scoreThresholds[riskZoneZoneMinScores[zone] - 1];
    var reviewTabs2 = ["form", "close"];
    var reviewBlocks = [
      "kpis",
      "distribution",
      "monthly",
      "heatmap",
      "score-breakdown",
      "outcome-distribution",
      "keywords",
      "reviews-table"
    ];
    var reviewFilters = [
      "claim-type",
      "team",
      "handler",
      "zone",
      "municipality",
      "relationship",
      "insured"
    ];
    var REVIEW_TAB_TO_TYPE = {
      form: "claim_creation_form",
      close: "claim_resolution"
    };
    var PERFORMANCE_REVIEW_CSV_LIMIT = 2e4;
    var REVIEW_SCORE_COLORS = {
      0: "#a8a29e",
      1: "#ef4444",
      2: "#f59e0b",
      3: "#22c55e",
      4: "#14b8a6",
      5: "#10b981"
    };
    var REVIEW_RESOLUTION_TIME_BUCKETS = [
      { label: "0-30 d\xEDas", min: 0, max: 30 },
      { label: "30-60 d\xEDas", min: 31, max: 60 },
      { label: "60-90 d\xEDas", min: 61, max: 90 },
      { label: "90+ d\xEDas", min: 91, max: null }
    ];
    var REVIEW_CREATION_TIME_BUCKETS = [
      { label: "0-15 min", min: 0, max: 15 },
      { label: "15-30 min", min: 15, max: 30 },
      { label: "30-45 min", min: 30, max: 45 },
      { label: "45-60 min", min: 45, max: 60 },
      { label: "1h-1h15", min: 60, max: 75 },
      { label: "+1h15", min: 75, max: null }
    ];
    var reviewScoreBreakdownDims2 = ["time", "handler"];
    var REVIEW_SCORE_BREAKDOWN_DIMS_BY_TAB = {
      form: ["time"],
      close: ["time", "handler"]
    };
    var reviewHeatmapDims2 = [
      "type",
      "relationship",
      "team",
      "zone",
      "outcome"
    ];
    var REVIEW_HEATMAP_DIMS_BY_TAB = {
      form: ["type", "relationship"],
      close: ["type", "relationship", "team", "zone", "outcome"]
    };
    var STOPWORDS_ES = /* @__PURE__ */ new Set([
      "para",
      "pero",
      "porque",
      "como",
      "cuando",
      "donde",
      "quien",
      "quienes",
      "cual",
      "cuales",
      "desde",
      "hasta",
      "sobre",
      "entre",
      "contra",
      "durante",
      "antes",
      "despues",
      "despu\xE9s",
      "todo",
      "toda",
      "todos",
      "todas",
      "nada",
      "algo",
      "alguno",
      "alguna",
      "algunos",
      "algunas",
      "esta",
      "este",
      "esto",
      "estos",
      "estas",
      "esos",
      "esas",
      "aquel",
      "aquella",
      "muy",
      "mucho",
      "mucha",
      "muchos",
      "muchas",
      "poco",
      "poca",
      "menos",
      "tanto",
      "tambien",
      "tambi\xE9n",
      "solo",
      "s\xF3lo",
      "solamente",
      "siempre",
      "nunca",
      "aunque",
      "entonces",
      "mientras",
      "segun",
      "seg\xFAn",
      "cada",
      "otro",
      "otra",
      "otros",
      "otras",
      "mismo",
      "misma",
      "ademas",
      "adem\xE1s",
      "asi",
      "as\xED",
      "ahora",
      "luego",
      "aqui",
      "aqu\xED",
      "alli",
      "all\xED",
      "ese",
      "esa",
      "unos",
      "unas",
      "una",
      "uno",
      "los",
      "las",
      "del",
      "con",
      "sin",
      "por",
      "que",
      "los",
      "les",
      "nos",
      "sus",
      "mis",
      "tus",
      "ser",
      "son",
      "era",
      "eran",
      "fue",
      "fueron",
      "estar",
      "esta",
      "estan",
      "est\xE1n",
      "estaba",
      "estuvo",
      "haber",
      "habia",
      "hab\xEDa",
      "tiene",
      "tienen",
      "tenia",
      "ten\xEDa",
      "tener",
      "hacer",
      "hace",
      "hizo",
      "puede",
      "pueden",
      "podia",
      "pod\xEDa",
      "sea",
      "sean",
      "hola",
      "gracias",
      "buenas",
      "buenos",
      "dias",
      "d\xEDas",
      "usted",
      "ustedes",
      "ellos",
      "ellas",
      "nosotros",
      "nuestro",
      "nuestra"
    ]);
    var import_i11n22 = require_dist();
    var argentinaStateParties = {
      B: [
        "Jos\xE9 C. Paz",
        "Adolfo Gonzales Chaves",
        "General Juan Madariaga",
        "Tandil",
        "Coronel Pringles",
        "Tigre",
        "Tornquist",
        "Campana",
        "Maip\xFA",
        "Adolfo Alsina",
        "Pu\xE1n",
        "Villarino",
        "General Villegas",
        "San Pedro",
        "Chivilcoy",
        "General Alvear",
        "Castelli",
        "Almirante Brown",
        "La Plata",
        "Brandsen",
        "25 de Mayo",
        "Pehuaj\xF3",
        "General Belgrano",
        "Monte",
        "Roque P\xE9rez",
        "Pilar",
        "Luj\xE1n",
        "Azul",
        "Merlo",
        "Chacabuco",
        "Carmen de Areco",
        "General Rodr\xEDguez",
        "Exaltaci\xF3n de la Cruz",
        "San Miguel",
        "San Andr\xE9s de Giles",
        "Jun\xEDn",
        "Marcos Paz",
        "Mercedes",
        "Hurlingham",
        "Mor\xF3n",
        "Ciudad Libertador San Mart\xEDn",
        "Ituzaing\xF3",
        "Suipacha",
        "Tres de Febrero",
        "Alberti",
        "Lan\xFAs",
        "General Las Heras",
        "Lomas de Zamora",
        "Navarro",
        "Ca\xF1uelas",
        "Lobos",
        "Quilmes",
        "Pila",
        "General La Madrid",
        "Bol\xEDvar",
        "Balcarce",
        "Hip\xF3lito Yrigoyen",
        "Dolores",
        "Tres Lomas",
        "Ayacucho",
        "General Pinto",
        "Guamin\xED",
        "Avellaneda",
        "Col\xF3n",
        "San Cayetano",
        "Tres Arroyos",
        "Saavedra",
        "Monte Hermoso",
        "Lober\xEDa",
        "Berisso",
        "Tordillo",
        "Ramallo",
        "San Nicol\xE1s",
        "General Guido",
        "Coronel Su\xE1rez",
        "Coronel Dorrego",
        "Necochea",
        "Bah\xEDa Blanca",
        "General Alvarado",
        "General Pueyrred\xF3n",
        "Mar Chiquita",
        "Villa Gesell",
        "Pinamar",
        "General Lavalle",
        "La Costa",
        "Magdalena",
        "Vicente L\xF3pez",
        "Saladillo",
        "Las Flores",
        "Rojas",
        "Escobar",
        "Pergamino",
        "Rauch",
        "Salliquel\xF3",
        "Berazategui",
        "Presidente Per\xF3n",
        "Coronel de Marina Leonardo Rosales",
        "Leandro N. Alem",
        "General Arenales",
        "Rivadavia",
        "General Paz",
        "San Antonio de Areco",
        "Moreno",
        "La Matanza",
        "Lezama",
        "Punta Indio",
        "Pellegrini",
        "Carlos Tejedor",
        "Arrecifes",
        "Capit\xE1n Sarmiento",
        "Salto",
        "9 de Julio",
        "Trenque Lauquen",
        "Carlos Casares",
        "Olavarr\xEDa",
        "Esteban Echeverr\xEDa",
        "General Viamonte",
        "Malvinas Argentinas",
        "Lincoln",
        "Tapalqu\xE9",
        "Bragado",
        "Jos\xE9 M. Ezeiza",
        "Florencio Varela",
        "San Vicente",
        "Daireaux",
        "Ensenada",
        "Laprida",
        "San Isidro",
        "Benito Ju\xE1rez",
        "San Fernando",
        "Z\xE1rate",
        "Patagones",
        "Chascom\xFAs",
        "Baradero",
        "Florentino Ameghino"
      ],
      S: [
        "Villa Constituci\xF3n",
        "La Capital",
        "Vera",
        "9 de Julio",
        "Garay",
        "Las Colonias",
        "Caseros",
        "Rosario",
        "San Lorenzo",
        "Iriondo",
        "Belgrano",
        "San Jer\xF3nimo",
        "San Mart\xEDn",
        "Castellanos",
        "San Justo",
        "San Crist\xF3bal",
        "San Javier",
        "General Obligado",
        "General L\xF3pez"
      ]
    };
    var sinisterObjectValues3 = ["vehicle", "other_risk"];
    var sinisterObjectOptions = [
      { label: "Veh\xEDculo", value: "vehicle" },
      { label: "Otros riesgos", value: "other_risk" }
    ];
    var distinctList = (list, distinctKey) => {
      return [...new Set(list.map((l) => l[distinctKey]))].map((l) => ({
        label: l,
        value: l
      }));
    };
    var _a;
    var loadBalanceRuleFields = [
      {
        label: "Ramo",
        path: "ramo",
        load: "lazy",
        options: []
      },
      {
        label: "Ocurrencia Ciudad",
        load: "lazy",
        path: "occurrence.city",
        options: []
      },
      {
        load: "eager",
        label: "Provincia",
        path: "desired_support_location_state",
        options: (((_a = countryAndStates4.find((c2) => c2.code === DEFAULT_COUNTRY_CODE2)) == null ? void 0 : _a.states) || []).map((opt) => ({
          label: opt.name,
          value: opt.code
        }))
      },
      {
        load: "eager",
        label: "Partido",
        path: "desired_support_location_state_municipality",
        options: distinctList(
          Object.values(argentinaStateParties).flat().map((opt) => ({
            label: opt,
            value: opt
          })),
          "value"
        )
      },
      {
        load: "eager",
        label: "Tipo de reclamo",
        path: "claim_type",
        options: claimTypes5.map((type) => ({
          label: (0, import_i11n22.translate)(`claim.type.${type}`),
          value: type
        }))
      },
      {
        load: "eager",
        label: "Tipo de usuario",
        path: "user_type",
        options: customerUserTypes.map((type) => ({
          label: (0, import_i11n22.translate)(`user.type.${type}`),
          value: type
        }))
      },
      {
        load: "eager",
        label: "Tercero socio",
        path: "is_claimant_and_victim_same_insurer",
        options: [
          {
            label: "S\xED",
            value: "true"
          },
          {
            label: "No",
            value: "false"
          }
        ]
      },
      {
        load: "eager",
        label: "Objeto del siniestro",
        path: "sinister_object",
        options: sinisterObjectOptions
      }
    ];
    var bodyParts3 = ["upper", "lower", "left", "right"];
    var withLicensePlateVehicleTypes3 = [
      "car",
      "moto",
      "special_transport_service",
      "public_transport_service",
      "trailer_motor_home",
      "pickup_class_a_and_b_jeep",
      "truck_chassis",
      "hitched_semi_trailer",
      "tractors_and_rural_machines",
      "other"
    ];
    var catalogBackedVehicleTypes = [
      "car",
      "pickup_class_a_and_b_jeep",
      "moto",
      "truck_chassis"
    ];
    var isCatalogBackedVehicleType = (type) => !!type && catalogBackedVehicleTypes.includes(type);
    var complaintWithLicensePlateVehicleTypes2 = ["car", "moto"];
    var withoutLicensePlateVehicleTypes2 = [
      "bike",
      "machinery",
      "skateboard",
      "other"
    ];
    var claimVehicleUses = [
      "private",
      "taxi",
      "remis",
      "ambulance",
      "police",
      "school",
      "special_service",
      "goods_transport",
      "local",
      "route_service",
      "electronic_platform",
      "delivery_service",
      "agency",
      "school_transport",
      "special_school_pickup"
    ];
    var nonLicensePlateClaimVehicleUses = [
      "private",
      "school",
      "delivery_service"
    ];
    var vehicleUses = [
      "private",
      "taxi",
      "remis",
      "rental",
      "ambulance",
      "police",
      "school",
      "specialService",
      "goods",
      "persons"
    ];
    var driverVehicleOwnership3 = ["owner", "third"];
    var vehicleDocumentTypes2 = ["title", "registration", "other"];
    var vehicleIdentificationKeys = ["license_plate", "chassis"];
    var vehicleIdCardExtractionOutcomes = [
      "prefilled",
      "nothing_to_fill",
      "rejected",
      "failed",
      "manual_entry"
    ];
    var vehicleIdCardStatuses = [
      "idle",
      "busy",
      "done",
      "rejected",
      "failed",
      "manual"
    ];
    var VEHICLE_ID_CARD_UPLOAD_ENABLED = false;
    var notificationEventsSupported = [
      "contract_invoice_uploaded",
      "contract_report_created",
      "contract_updates_published",
      "order_updates_published",
      // F3.1 — fanout bidireccional de órdenes (insurer ↔ provider). Los `*_reset`
      // no notifican ([O3], solo `order_reopened` notifica).
      // order_required_docs — `order_completed` ahora SÍ notifica: la finalización
      // es una acción explícita del insurer.
      "order_created",
      "order_accepted",
      "order_rejected",
      "order_canceled",
      "order_completed",
      "order_reopened",
      "order_document_uploaded",
      "order_required_document_uploaded",
      "order_required_document_accepted",
      "order_required_document_rejected",
      // order_work_proof — la aseguradora solicita la prueba (`created`, avisa al
      // proveedor que tiene que capturar la evidencia) y los resultados los emite el
      // system user al recibir el webhook.
      "order_work_proof_created",
      "order_work_proof_approved",
      "order_work_proof_disapproved",
      "order_work_proof_blocked",
      // order_scheduling — bidirectional: the counterpart of whoever scheduled is
      // notified, since the date drives both sides' planning. Same for voiding it:
      // the other side has to stop planning around a date that no longer holds.
      "order_scheduled",
      "order_rescheduled",
      "order_schedule_canceled",
      "rfp_bid_submitted",
      "appraisal_invoice_uploaded",
      "appraisal_updates_published",
      "appraisal_report_created",
      "claim_created",
      "fraud_news_answered",
      "fraud_investigation_report_accepted",
      "fraud_investigation_case_created",
      "file_request_uploaded",
      "complaint_file_request_uploaded",
      "pending_file_request_upload",
      "pending_sinister_complaint",
      "claim_responsible_assigned",
      "team_claims_reassigned",
      "team_claims_delegated",
      "team_claims_recovered",
      "sinister_claim_chat_message_send",
      "fraud_updated",
      "fraud_closed",
      "offer_accepted",
      "offer_rejected",
      "offer_expired",
      "claim_documentation_requested",
      "criminal_case_request",
      "claim_not_response",
      "claim_offer_flow",
      "claim_documentation_completed",
      "claim_file_request_completed",
      "claim_rejected",
      "claim_additional_management",
      "appraisal_report_created",
      "pending_offer_agreement_response",
      "pending_offer_response",
      "pending_offer_agreement_response_internal",
      "pending_offer_response_internal",
      "offer_agreement_rejected",
      "offer_agreement_expired",
      "offer_agreement_completed",
      "offer_agreement_cancelled",
      // Conformidad v2 — the AutoSign dispatch stopped: in-app to the sender only.
      "offer_agreement_dispatch_failed",
      "alert_sla_objective_progress",
      "alert_sla_total_progress",
      "claim_comment_created",
      "claim_estimates_updated",
      "sinister_external_status_updated"
    ];
    var notificationScopes2 = ["all", "unread", "read"];
    var claimClosingIngestEvents = {
      claim_mediation_started: {
        claimStatusRole: "mediation",
        eventType: "claim_mediation_started",
        closingReasonLabel: "el inicio del proceso de mediaci\xF3n"
      },
      claim_lawsuit_started: {
        claimStatusRole: "lawsuit",
        eventType: "claim_lawsuit_started",
        closingReasonLabel: "el inicio del juicio"
      },
      claim_reconciled: {
        claimStatusRole: "reconciled",
        eventType: "claim_reconciled",
        closingReasonLabel: "la conciliaci\xF3n"
      }
    };
    var retrieveCaseInspectionTokenResource = [
      "case",
      "case_request",
      "investigation"
    ];
    var teamType = ["case", "complaint", "claim", "lab"];
    var resources = [
      "case",
      "case_enums",
      "invitation",
      "company",
      "case_request",
      "case_request_processor",
      "user",
      "investigation",
      "team",
      "case_load_balance_rule",
      "contact",
      "price",
      "price_group",
      "contact_price",
      "role",
      "alert",
      "stats",
      "integration",
      "virtual_view",
      "workflow",
      "case_draft",
      "statement",
      "company_link",
      "trash_transaction",
      "investigation_user",
      "autoinspector-integration",
      "claim",
      "complaint"
    ];
    var actions = [
      "create",
      "update",
      "read",
      "read_all",
      "read_own",
      "delete",
      "take",
      "define",
      "assign",
      "create_own",
      "create_all",
      "update_own",
      "update_all",
      "remove_own",
      "remove_all"
    ];
    var themes = [
      {
        name: "zinc",
        label: "Zinc",
        activeColor: {
          light: "240 5.9% 10%",
          dark: "240 5.2% 33.9%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "240 10% 3.9%",
            card: "0 0% 100%",
            "card-foreground": "240 10% 3.9%",
            popover: "0 0% 100%",
            "popover-foreground": "240 10% 3.9%",
            primary: "240 5.9% 10%",
            "primary-foreground": "0 0% 98%",
            secondary: "240 4.8% 95.9%",
            "secondary-foreground": "240 5.9% 10%",
            muted: "240 4.8% 95.9%",
            "muted-foreground": "240 3.8% 46.1%",
            accent: "240 4.8% 95.9%",
            "accent-foreground": "240 5.9% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "0 0% 98%",
            border: "240 5.9% 90%",
            input: "240 5.9% 90%",
            ring: "240 5.9% 10%",
            radius: "0.5rem"
          },
          dark: {
            background: "240 10% 3.9%",
            foreground: "0 0% 98%",
            card: "240 10% 3.9%",
            "card-foreground": "0 0% 98%",
            popover: "240 10% 3.9%",
            "popover-foreground": "0 0% 98%",
            primary: "0 0% 98%",
            "primary-foreground": "240 5.9% 10%",
            secondary: "240 3.7% 15.9%",
            "secondary-foreground": "0 0% 98%",
            muted: "240 3.7% 15.9%",
            "muted-foreground": "240 5% 64.9%",
            accent: "240 3.7% 15.9%",
            "accent-foreground": "0 0% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "0 0% 98%",
            border: "240 3.7% 15.9%",
            input: "240 3.7% 15.9%",
            ring: "240 4.9% 83.9%"
          }
        }
      },
      {
        name: "slate",
        label: "Slate",
        activeColor: {
          light: "215.4 16.3% 46.9%",
          dark: "215.3 19.3% 34.5%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "222.2 84% 4.9%",
            card: "0 0% 100%",
            "card-foreground": "222.2 84% 4.9%",
            popover: "0 0% 100%",
            "popover-foreground": "222.2 84% 4.9%",
            primary: "222.2 47.4% 11.2%",
            "primary-foreground": "210 40% 98%",
            secondary: "210 40% 96.1%",
            "secondary-foreground": "222.2 47.4% 11.2%",
            muted: "210 40% 96.1%",
            "muted-foreground": "215.4 16.3% 46.9%",
            accent: "210 40% 96.1%",
            "accent-foreground": "222.2 47.4% 11.2%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "210 40% 98%",
            border: "214.3 31.8% 91.4%",
            input: "214.3 31.8% 91.4%",
            ring: "222.2 84% 4.9%",
            radius: "0.5rem"
          },
          dark: {
            background: "222.2 84% 4.9%",
            foreground: "210 40% 98%",
            card: "222.2 84% 4.9%",
            "card-foreground": "210 40% 98%",
            popover: "222.2 84% 4.9%",
            "popover-foreground": "210 40% 98%",
            primary: "210 40% 98%",
            "primary-foreground": "222.2 47.4% 11.2%",
            secondary: "217.2 32.6% 17.5%",
            "secondary-foreground": "210 40% 98%",
            muted: "217.2 32.6% 17.5%",
            "muted-foreground": "215 20.2% 65.1%",
            accent: "217.2 32.6% 17.5%",
            "accent-foreground": "210 40% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "210 40% 98%",
            border: "217.2 32.6% 17.5%",
            input: "217.2 32.6% 17.5%",
            ring: "212.7 26.8% 83.9"
          }
        }
      },
      {
        name: "stone",
        label: "Stone",
        activeColor: {
          light: "25 5.3% 44.7%",
          dark: "33.3 5.5% 32.4%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "20 14.3% 4.1%",
            card: "0 0% 100%",
            "card-foreground": "20 14.3% 4.1%",
            popover: "0 0% 100%",
            "popover-foreground": "20 14.3% 4.1%",
            primary: "24 9.8% 10%",
            "primary-foreground": "60 9.1% 97.8%",
            secondary: "60 4.8% 95.9%",
            "secondary-foreground": "24 9.8% 10%",
            muted: "60 4.8% 95.9%",
            "muted-foreground": "25 5.3% 44.7%",
            accent: "60 4.8% 95.9%",
            "accent-foreground": "24 9.8% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "20 5.9% 90%",
            input: "20 5.9% 90%",
            ring: "20 14.3% 4.1%",
            radius: "0.95rem"
          },
          dark: {
            background: "20 14.3% 4.1%",
            foreground: "60 9.1% 97.8%",
            card: "20 14.3% 4.1%",
            "card-foreground": "60 9.1% 97.8%",
            popover: "20 14.3% 4.1%",
            "popover-foreground": "60 9.1% 97.8%",
            primary: "60 9.1% 97.8%",
            "primary-foreground": "24 9.8% 10%",
            secondary: "12 6.5% 15.1%",
            "secondary-foreground": "60 9.1% 97.8%",
            muted: "12 6.5% 15.1%",
            "muted-foreground": "24 5.4% 63.9%",
            accent: "12 6.5% 15.1%",
            "accent-foreground": "60 9.1% 97.8%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "12 6.5% 15.1%",
            input: "12 6.5% 15.1%",
            ring: "24 5.7% 82.9%"
          }
        }
      },
      {
        name: "gray",
        label: "Gray",
        activeColor: {
          light: "220 8.9% 46.1%",
          dark: "215 13.8% 34.1%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "224 71.4% 4.1%",
            card: "0 0% 100%",
            "card-foreground": "224 71.4% 4.1%",
            popover: "0 0% 100%",
            "popover-foreground": "224 71.4% 4.1%",
            primary: "220.9 39.3% 11%",
            "primary-foreground": "210 20% 98%",
            secondary: "220 14.3% 95.9%",
            "secondary-foreground": "220.9 39.3% 11%",
            muted: "220 14.3% 95.9%",
            "muted-foreground": "220 8.9% 46.1%",
            accent: "220 14.3% 95.9%",
            "accent-foreground": "220.9 39.3% 11%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "210 20% 98%",
            border: "220 13% 91%",
            input: "220 13% 91%",
            ring: "224 71.4% 4.1%",
            radius: "0.35rem"
          },
          dark: {
            background: "224 71.4% 4.1%",
            foreground: "210 20% 98%",
            card: "224 71.4% 4.1%",
            "card-foreground": "210 20% 98%",
            popover: "224 71.4% 4.1%",
            "popover-foreground": "210 20% 98%",
            primary: "210 20% 98%",
            "primary-foreground": "220.9 39.3% 11%",
            secondary: "215 27.9% 16.9%",
            "secondary-foreground": "210 20% 98%",
            muted: "215 27.9% 16.9%",
            "muted-foreground": "217.9 10.6% 64.9%",
            accent: "215 27.9% 16.9%",
            "accent-foreground": "210 20% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "210 20% 98%",
            border: "215 27.9% 16.9%",
            input: "215 27.9% 16.9%",
            ring: "216 12.2% 83.9%"
          }
        }
      },
      {
        name: "neutral",
        label: "Neutral",
        activeColor: {
          light: "0 0% 45.1%",
          dark: "0 0% 32.2%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "0 0% 3.9%",
            card: "0 0% 100%",
            "card-foreground": "0 0% 3.9%",
            popover: "0 0% 100%",
            "popover-foreground": "0 0% 3.9%",
            primary: "0 0% 9%",
            "primary-foreground": "0 0% 98%",
            secondary: "0 0% 96.1%",
            "secondary-foreground": "0 0% 9%",
            muted: "0 0% 96.1%",
            "muted-foreground": "0 0% 45.1%",
            accent: "0 0% 96.1%",
            "accent-foreground": "0 0% 9%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "0 0% 98%",
            border: "0 0% 89.8%",
            input: "0 0% 89.8%",
            ring: "0 0% 3.9%"
          },
          dark: {
            background: "0 0% 3.9%",
            foreground: "0 0% 98%",
            card: "0 0% 3.9%",
            "card-foreground": "0 0% 98%",
            popover: "0 0% 3.9%",
            "popover-foreground": "0 0% 98%",
            primary: "0 0% 98%",
            "primary-foreground": "0 0% 9%",
            secondary: "0 0% 14.9%",
            "secondary-foreground": "0 0% 98%",
            muted: "0 0% 14.9%",
            "muted-foreground": "0 0% 63.9%",
            accent: "0 0% 14.9%",
            "accent-foreground": "0 0% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "0 0% 98%",
            border: "0 0% 14.9%",
            input: "0 0% 14.9%",
            ring: "0 0% 83.1%"
          }
        }
      },
      {
        name: "red",
        label: "Red",
        activeColor: {
          light: "0 72.2% 50.6%",
          dark: "0 72.2% 50.6%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "0 0% 3.9%",
            card: "0 0% 100%",
            "card-foreground": "0 0% 3.9%",
            popover: "0 0% 100%",
            "popover-foreground": "0 0% 3.9%",
            primary: "0 72.2% 50.6%",
            "primary-foreground": "0 85.7% 97.3%",
            secondary: "0 0% 96.1%",
            "secondary-foreground": "0 0% 9%",
            muted: "0 0% 96.1%",
            "muted-foreground": "0 0% 45.1%",
            accent: "0 0% 96.1%",
            "accent-foreground": "0 0% 9%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "0 0% 98%",
            border: "0 0% 89.8%",
            input: "0 0% 89.8%",
            ring: "0 72.2% 50.6%",
            radius: "0.4rem"
          },
          dark: {
            background: "0 0% 3.9%",
            foreground: "0 0% 98%",
            card: "0 0% 3.9%",
            "card-foreground": "0 0% 98%",
            popover: "0 0% 3.9%",
            "popover-foreground": "0 0% 98%",
            primary: "0 72.2% 50.6%",
            "primary-foreground": "0 85.7% 97.3%",
            secondary: "0 0% 14.9%",
            "secondary-foreground": "0 0% 98%",
            muted: "0 0% 14.9%",
            "muted-foreground": "0 0% 63.9%",
            accent: "0 0% 14.9%",
            "accent-foreground": "0 0% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "0 0% 98%",
            border: "0 0% 14.9%",
            input: "0 0% 14.9%",
            ring: "0 72.2% 50.6%"
          }
        }
      },
      {
        name: "rose",
        label: "Rose",
        activeColor: {
          light: "346.8 77.2% 49.8%",
          dark: "346.8 77.2% 49.8%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "240 10% 3.9%",
            card: "0 0% 100%",
            "card-foreground": "240 10% 3.9%",
            popover: "0 0% 100%",
            "popover-foreground": "240 10% 3.9%",
            primary: "346.8 77.2% 49.8%",
            "primary-foreground": "355.7 100% 97.3%",
            secondary: "240 4.8% 95.9%",
            "secondary-foreground": "240 5.9% 10%",
            muted: "240 4.8% 95.9%",
            "muted-foreground": "240 3.8% 46.1%",
            accent: "240 4.8% 95.9%",
            "accent-foreground": "240 5.9% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "0 0% 98%",
            border: "240 5.9% 90%",
            input: "240 5.9% 90%",
            ring: "346.8 77.2% 49.8%",
            radius: "0.5rem"
          },
          dark: {
            background: "20 14.3% 4.1%",
            foreground: "0 0% 95%",
            popover: "0 0% 9%",
            "popover-foreground": "0 0% 95%",
            card: "24 9.8% 10%",
            "card-foreground": "0 0% 95%",
            primary: "346.8 77.2% 49.8%",
            "primary-foreground": "355.7 100% 97.3%",
            secondary: "240 3.7% 15.9%",
            "secondary-foreground": "0 0% 98%",
            muted: "0 0% 15%",
            "muted-foreground": "240 5% 64.9%",
            accent: "12 6.5% 15.1%",
            "accent-foreground": "0 0% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "0 85.7% 97.3%",
            border: "240 3.7% 15.9%",
            input: "240 3.7% 15.9%",
            ring: "346.8 77.2% 49.8%"
          }
        }
      },
      {
        name: "orange",
        label: "Orange",
        activeColor: {
          light: "24.6 95% 53.1%",
          dark: "20.5 90.2% 48.2%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "20 14.3% 4.1%",
            card: "0 0% 100%",
            "card-foreground": "20 14.3% 4.1%",
            popover: "0 0% 100%",
            "popover-foreground": "20 14.3% 4.1%",
            primary: "24.6 95% 53.1%",
            "primary-foreground": "60 9.1% 97.8%",
            secondary: "60 4.8% 95.9%",
            "secondary-foreground": "24 9.8% 10%",
            muted: "60 4.8% 95.9%",
            "muted-foreground": "25 5.3% 44.7%",
            accent: "60 4.8% 95.9%",
            "accent-foreground": "24 9.8% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "20 5.9% 90%",
            input: "20 5.9% 90%",
            ring: "24.6 95% 53.1%",
            radius: "0.95rem"
          },
          dark: {
            background: "20 14.3% 4.1%",
            foreground: "60 9.1% 97.8%",
            card: "20 14.3% 4.1%",
            "card-foreground": "60 9.1% 97.8%",
            popover: "20 14.3% 4.1%",
            "popover-foreground": "60 9.1% 97.8%",
            primary: "20.5 90.2% 48.2%",
            "primary-foreground": "60 9.1% 97.8%",
            secondary: "12 6.5% 15.1%",
            "secondary-foreground": "60 9.1% 97.8%",
            muted: "12 6.5% 15.1%",
            "muted-foreground": "24 5.4% 63.9%",
            accent: "12 6.5% 15.1%",
            "accent-foreground": "60 9.1% 97.8%",
            destructive: "0 72.2% 50.6%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "12 6.5% 15.1%",
            input: "12 6.5% 15.1%",
            ring: "20.5 90.2% 48.2%"
          }
        }
      },
      {
        name: "green",
        label: "Green",
        activeColor: {
          light: "142.1 76.2% 36.3%",
          dark: "142.1 70.6% 45.3%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "240 10% 3.9%",
            card: "0 0% 100%",
            "card-foreground": "240 10% 3.9%",
            popover: "0 0% 100%",
            "popover-foreground": "240 10% 3.9%",
            primary: "142.1 76.2% 36.3%",
            "primary-foreground": "355.7 100% 97.3%",
            secondary: "240 4.8% 95.9%",
            "secondary-foreground": "240 5.9% 10%",
            muted: "240 4.8% 95.9%",
            "muted-foreground": "240 3.8% 46.1%",
            accent: "240 4.8% 95.9%",
            "accent-foreground": "240 5.9% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "0 0% 98%",
            border: "240 5.9% 90%",
            input: "240 5.9% 90%",
            ring: "142.1 76.2% 36.3%"
          },
          dark: {
            background: "20 14.3% 4.1%",
            foreground: "0 0% 95%",
            popover: "0 0% 9%",
            "popover-foreground": "0 0% 95%",
            card: "24 9.8% 10%",
            "card-foreground": "0 0% 95%",
            primary: "142.1 70.6% 45.3%",
            "primary-foreground": "144.9 80.4% 10%",
            secondary: "240 3.7% 15.9%",
            "secondary-foreground": "0 0% 98%",
            muted: "0 0% 15%",
            "muted-foreground": "240 5% 64.9%",
            accent: "12 6.5% 15.1%",
            "accent-foreground": "0 0% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "0 85.7% 97.3%",
            border: "240 3.7% 15.9%",
            input: "240 3.7% 15.9%",
            ring: "142.4 71.8% 29.2%"
          }
        }
      },
      {
        name: "blue",
        label: "Blue",
        activeColor: {
          light: "221.2 83.2% 53.3%",
          dark: "217.2 91.2% 59.8%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "222.2 84% 4.9%",
            card: "0 0% 100%",
            "card-foreground": "222.2 84% 4.9%",
            popover: "0 0% 100%",
            "popover-foreground": "222.2 84% 4.9%",
            primary: "221.2 83.2% 53.3%",
            "primary-foreground": "210 40% 98%",
            secondary: "210 40% 96.1%",
            "secondary-foreground": "222.2 47.4% 11.2%",
            muted: "210 40% 96.1%",
            "muted-foreground": "215.4 16.3% 46.9%",
            accent: "210 40% 96.1%",
            "accent-foreground": "222.2 47.4% 11.2%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "210 40% 98%",
            border: "214.3 31.8% 91.4%",
            input: "214.3 31.8% 91.4%",
            ring: "221.2 83.2% 53.3%"
          },
          dark: {
            background: "222.2 84% 4.9%",
            foreground: "210 40% 98%",
            card: "222.2 84% 4.9%",
            "card-foreground": "210 40% 98%",
            popover: "222.2 84% 4.9%",
            "popover-foreground": "210 40% 98%",
            primary: "217.2 91.2% 59.8%",
            "primary-foreground": "222.2 47.4% 11.2%",
            secondary: "217.2 32.6% 17.5%",
            "secondary-foreground": "210 40% 98%",
            muted: "217.2 32.6% 17.5%",
            "muted-foreground": "215 20.2% 65.1%",
            accent: "217.2 32.6% 17.5%",
            "accent-foreground": "210 40% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "210 40% 98%",
            border: "217.2 32.6% 17.5%",
            input: "217.2 32.6% 17.5%",
            ring: "224.3 76.3% 48%"
          }
        }
      },
      {
        name: "yellow",
        label: "Yellow",
        activeColor: {
          light: "47.9 95.8% 53.1%",
          dark: "47.9 95.8% 53.1%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "20 14.3% 4.1%",
            card: "0 0% 100%",
            "card-foreground": "20 14.3% 4.1%",
            popover: "0 0% 100%",
            "popover-foreground": "20 14.3% 4.1%",
            primary: "47.9 95.8% 53.1%",
            "primary-foreground": "26 83.3% 14.1%",
            secondary: "60 4.8% 95.9%",
            "secondary-foreground": "24 9.8% 10%",
            muted: "60 4.8% 95.9%",
            "muted-foreground": "25 5.3% 44.7%",
            accent: "60 4.8% 95.9%",
            "accent-foreground": "24 9.8% 10%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "20 5.9% 90%",
            input: "20 5.9% 90%",
            ring: "20 14.3% 4.1%",
            radius: "0.95rem"
          },
          dark: {
            background: "20 14.3% 4.1%",
            foreground: "60 9.1% 97.8%",
            card: "20 14.3% 4.1%",
            "card-foreground": "60 9.1% 97.8%",
            popover: "20 14.3% 4.1%",
            "popover-foreground": "60 9.1% 97.8%",
            primary: "47.9 95.8% 53.1%",
            "primary-foreground": "26 83.3% 14.1%",
            secondary: "12 6.5% 15.1%",
            "secondary-foreground": "60 9.1% 97.8%",
            muted: "12 6.5% 15.1%",
            "muted-foreground": "24 5.4% 63.9%",
            accent: "12 6.5% 15.1%",
            "accent-foreground": "60 9.1% 97.8%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "60 9.1% 97.8%",
            border: "12 6.5% 15.1%",
            input: "12 6.5% 15.1%",
            ring: "35.5 91.7% 32.9%"
          }
        }
      },
      {
        name: "violet",
        label: "Violet",
        activeColor: {
          light: "262.1 83.3% 57.8%",
          dark: "263.4 70% 50.4%"
        },
        cssVars: {
          light: {
            background: "0 0% 100%",
            foreground: "224 71.4% 4.1%",
            card: "0 0% 100%",
            "card-foreground": "224 71.4% 4.1%",
            popover: "0 0% 100%",
            "popover-foreground": "224 71.4% 4.1%",
            primary: "262.1 83.3% 57.8%",
            "primary-foreground": "210 20% 98%",
            secondary: "220 14.3% 95.9%",
            "secondary-foreground": "220.9 39.3% 11%",
            muted: "220 14.3% 95.9%",
            "muted-foreground": "220 8.9% 46.1%",
            accent: "220 14.3% 95.9%",
            "accent-foreground": "220.9 39.3% 11%",
            destructive: "0 84.2% 60.2%",
            "destructive-foreground": "210 20% 98%",
            border: "220 13% 91%",
            input: "220 13% 91%",
            ring: "262.1 83.3% 57.8%"
          },
          dark: {
            background: "224 71.4% 4.1%",
            foreground: "210 20% 98%",
            card: "224 71.4% 4.1%",
            "card-foreground": "210 20% 98%",
            popover: "224 71.4% 4.1%",
            "popover-foreground": "210 20% 98%",
            primary: "263.4 70% 50.4%",
            "primary-foreground": "210 20% 98%",
            secondary: "215 27.9% 16.9%",
            "secondary-foreground": "210 20% 98%",
            muted: "215 27.9% 16.9%",
            "muted-foreground": "217.9 10.6% 64.9%",
            accent: "215 27.9% 16.9%",
            "accent-foreground": "210 20% 98%",
            destructive: "0 62.8% 30.6%",
            "destructive-foreground": "210 20% 98%",
            border: "215 27.9% 16.9%",
            input: "215 27.9% 16.9%",
            ring: "263.4 70% 50.4%"
          }
        }
      }
    ];
    var KACH_INTEGRATION_PRODUCTION_LAUNCH_DATE2 = "2026-06-25";
    var KACH_CASE_RESULTS = [
      "positive",
      "negative",
      "elements_for_rejection",
      "in_extension",
      "canceled",
      "possible_prescription",
      "without_result",
      "not_defined",
      "not_derived",
      "canceled_by_management"
    ];
    var isKachCaseResult = (value) => !!value && KACH_CASE_RESULTS.includes(value);
    var KACH_CLAIM_RESULTS = [
      "fraud",
      "not_fraud",
      "not_defined"
    ];
    var KACH_CASE_VERDICT_RESULTS = [
      "positive",
      "negative"
    ];
    var TERMINAL_CASE_RESULTS_WITHOUT_CLOSE = [
      "not_derived",
      "canceled",
      "canceled_by_management"
    ];
    var isTerminalCaseResultWithoutClose = (result) => !!result && TERMINAL_CASE_RESULTS_WITHOUT_CLOSE.includes(
      result
    );
    var KACH_DERIVATION_INSTANCE = "Administrativo";
    var KACH_EXCLUDED_SINISTER_TYPES = ["CLEAS"];
    var isSameKachEnumName = (name, other) => name.trim() === other.trim();
    var isExcludedKachSinisterType2 = (name) => KACH_EXCLUDED_SINISTER_TYPES.some(
      (excluded) => isSameKachEnumName(name, excluded)
    );
    var kachDamageCategories = ["material", "person", "combined"];
    var KACH_SINISTER_TYPE_BY_DAMAGE_CATEGORY = {
      material: "Da\xF1os materiales",
      person: "Da\xF1os corporales",
      combined: "Da\xF1os materiales y corporales"
    };
    var KACH_CASE_STATUSES2 = [
      "not_assigned",
      "in_progress",
      "closed"
    ];
    var KACH_WEBHOOK_EVENTS2 = [
      "case_created",
      "case_taken",
      "case_assigned",
      "case_responsibility_delegated",
      "case_responsibility_restored",
      "case_investigation_derived",
      "case_updated",
      "case_request_updated",
      "case_news_created",
      "investigation_report_accepted",
      "case_closed",
      "case_reopened",
      "claim_result_updated"
    ];
    var isKachWebhookEvent = (event) => KACH_WEBHOOK_EVENTS2.includes(event);
    var FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_STATUS = {
      not_assigned: "not_assigned",
      in_progress: "in_progress",
      closed: "closed"
    };
    var FRAUD_INVESTIGATION_STATUS_BY_KACH_WEBHOOK_EVENT = {
      case_taken: "in_progress",
      case_assigned: "in_progress",
      case_investigation_derived: "derived_to_lab",
      case_reopened: "in_progress",
      case_closed: "closed"
    };
    var FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_RESULT = {
      in_extension: "in_extension",
      without_result: "without_result",
      not_derived: "closed",
      canceled: "closed",
      canceled_by_management: "closed"
    };
    var RESULT_DRIVEN_FRAUD_INVESTIGATION_STATUSES = [
      "in_extension",
      "without_result"
    ];
    var resolveFraudInvestigationStatusOnKachCaseStatus = (status) => status && FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_STATUS[status] || "in_progress";
    var resultDrivenFraudInvestigationStatusOf = (result) => {
      const status = FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_RESULT[result];
      return RESULT_DRIVEN_FRAUD_INVESTIGATION_STATUSES.includes(status) ? status : null;
    };
    var resolveFraudInvestigationStatusOnCaseUpdate = ({
      current,
      result,
      isClosed
    }) => {
      if (!result || isClosed) return current;
      const resultStatus = FRAUD_INVESTIGATION_STATUS_BY_KACH_CASE_RESULT[result];
      if (resultStatus) return resultStatus;
      const leavesItsStage = [
        ...RESULT_DRIVEN_FRAUD_INVESTIGATION_STATUSES,
        "closed"
      ].includes(current);
      return leavesItsStage ? "in_progress" : current;
    };
    var resolveFraudInvestigationStatusFromKachCase = ({
      status,
      result
    }) => {
      const resultStage = isKachCaseResult(result) ? resultDrivenFraudInvestigationStatusOf(result) : null;
      if (resultStage) return resultStage;
      const statusDriven = resolveFraudInvestigationStatusOnKachCaseStatus(status);
      return statusDriven === "closed" ? "in_progress" : statusDriven;
    };
    var KACH_PARTICIPANT_SYNC_REDISPATCH_AFTER_MS = 10 * 60 * 1e3;
    var KACH_PARTICIPANT_SYNC_DISPATCH_BATCH_LIMIT = 200;
    var KACH_PARTICIPANT_SYNC_MAX_CLAIMS = 100;
    var permissionLabelType = [
      "manage_case_load_balance_rule",
      "manage_team",
      "manage_sinister",
      "read_sinister",
      "manage_complaint",
      "read_complaint",
      "manage_claim",
      "read_claim",
      "manage_role",
      "manage_user",
      "manage_settings",
      "manage_team",
      "read_notification",
      "read_company_link"
    ];
    var permissionsWithLabel = [
      {
        label: "manage_case_load_balance_rule",
        permissions: [
          "can_create_load_balance_rule",
          "can_read_load_balance_rule",
          "can_delete_load_balance_rule",
          "can_update_load_balance_rule"
        ]
      },
      {
        label: "manage_team",
        permissions: [
          "can_create_team",
          "can_read_team",
          "can_update_team",
          "can_delete_team"
        ]
      },
      {
        label: "manage_sinister",
        permissions: [
          "can_create_sinister",
          "can_update_sinister",
          "can_read_sinister",
          "can_delete_sinister"
        ]
      },
      {
        label: "read_sinister",
        permissions: ["can_read_sinister"]
      },
      {
        label: "manage_complaint",
        permissions: [
          "can_create_complaint",
          "can_update_complaint",
          "can_read_complaint",
          "can_delete_complaint"
        ]
      },
      {
        label: "read_complaint",
        permissions: ["can_read_complaint"]
      },
      {
        label: "manage_claim",
        permissions: [
          "can_create_claim",
          "can_update_claim",
          "can_read_claim",
          "can_delete_claim"
        ]
      },
      {
        label: "read_claim",
        permissions: ["can_read_claim"]
      },
      {
        label: "manage_role",
        permissions: [
          "can_read_role",
          "can_update_role",
          "can_delete_role",
          "can_create_role"
        ]
      },
      {
        label: "manage_user",
        permissions: ["can_read_user", "can_update_user"]
      },
      {
        label: "manage_settings",
        permissions: ["can_read_settings", "can_update_settings"]
      },
      {
        label: "manage_team",
        permissions: ["can_read_team", "can_update_team"]
      },
      {
        label: "read_notification",
        permissions: ["can_read_notification"]
      },
      {
        label: "read_company_link",
        permissions: ["can_read_company_link"]
      }
    ];
    var TEAM_CRITICAL_CLAIM_MIN_DAYS = performanceAgingBucketLimits["60-90"];
    var TEAM_MEMBER_CLAIMS_LIMIT2 = 1e3;
    var teamMemberAvailabilityStates = [
      "active",
      "scheduled",
      "inactive"
    ];
    var userAssignmentsResumeReasons2 = [
      "inactivity_ended",
      "inactivity_cancelled"
    ];
    var inactivityReasons4 = [
      "medical_leave",
      "vacation",
      "study_day",
      "training",
      "personal_leave",
      "other"
    ];
    var teamActivityEventTypes = [
      "team_claims_reassigned",
      "user_assignments_paused",
      "user_assignments_resumed",
      "user_inactivity_scheduled",
      "user_inactivity_started",
      "user_inactivity_ended",
      "user_inactivity_rescheduled",
      "user_inactivity_return_changed",
      "user_inactivity_cancelled",
      "user_inactivity_claims_delegated",
      "user_inactivity_delegation_updated",
      "user_inactivity_delegation_discarded",
      "user_delegated_claims_recovered",
      "user_delegated_claims_returned",
      "user_derived_claims_returned",
      "user_derived_claims_recovered"
    ];
    var inactivityEndOutcomes = ["cancelled", "ended"];
    var teamDelegationCategories3 = [
      "own",
      "delegated",
      "derived"
    ];
    var teamDelegationModes = ["automatic", "manual"];
    var teamDelegationStrategies3 = ["by_load", "round_robin"];
    var teamDelegationTriggers3 = [
      "inactivity_started",
      "requested",
      "self_requested"
    ];
    var teamDelegationClaimScopes2 = ["all", "uncovered"];
    var TEAM_DELEGATION_REVIEW_NOTICE_LEAD_BUSINESS_DAYS = 2;
    var TEAM_DELEGATION_POLL_INTERVAL_MS = 5e3;
    var teamActivityCategories2 = [
      "reassignments",
      "availability",
      "inactivities",
      "delegations",
      "derivations"
    ];
    var teamActivityCategoryEventTypes = {
      reassignments: ["team_claims_reassigned"],
      availability: ["user_assignments_paused", "user_assignments_resumed"],
      inactivities: [
        "user_inactivity_scheduled",
        "user_inactivity_started",
        "user_inactivity_ended",
        "user_inactivity_rescheduled",
        "user_inactivity_return_changed",
        "user_inactivity_cancelled"
      ],
      delegations: [
        "user_inactivity_claims_delegated",
        "user_inactivity_delegation_updated",
        "user_inactivity_delegation_discarded",
        "user_delegated_claims_recovered",
        "user_delegated_claims_returned"
      ],
      derivations: [
        "user_derived_claims_returned",
        "user_derived_claims_recovered"
      ]
    };
    var TEAM_ACTIVITY_PAGE_SIZE = 5;
    var TEAM_MEMBERS_PAGE_SIZE = 15;
    var TEAM_LOAD_HIGH_MARGIN_PERCENT = 5;
    var TEAM_LOAD_OVERLOADED_MARGIN_PERCENT = 15;
    var teamLoadLevels = ["normal", "high", "overloaded"];
    var newClaimBlockReasons = [
      "inactive",
      "paused",
      "overloaded"
    ];
    var blockingNewClaimReasons = ["inactive", "paused"];
    var isNewClaimBlocked = (reason) => blockingNewClaimReasons.some((blocking) => blocking === reason);
    var medianOf = (values) => {
      const sorted = [...values].sort((a3, b2) => a3 - b2);
      const middle = Math.floor(sorted.length / 2);
      return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
    };
    var ceilWithMargin = (median, marginPercent) => Math.max(1, Math.ceil(median * (100 + marginPercent) / 100));
    var computeTeamLoadThresholds = (openClaimCounts) => {
      if (!openClaimCounts.length) return null;
      const median = Math.round(medianOf(openClaimCounts));
      return {
        median,
        high: ceilWithMargin(median, TEAM_LOAD_HIGH_MARGIN_PERCENT),
        overloaded: ceilWithMargin(median, TEAM_LOAD_OVERLOADED_MARGIN_PERCENT)
      };
    };
    var delegationOverloadThreshold = ({
      openClaimCounts,
      delegatedClaims
    }) => {
      if (!openClaimCounts.length) return null;
      const total = openClaimCounts.reduce((sum2, count) => sum2 + count, 0);
      return ceilWithMargin(
        (total + delegatedClaims) / openClaimCounts.length,
        TEAM_LOAD_OVERLOADED_MARGIN_PERCENT
      );
    };
    var classifyTeamLoad = (openClaims, thresholds) => {
      if (!thresholds) return "normal";
      if (openClaims >= thresholds.overloaded) return "overloaded";
      if (openClaims >= thresholds.high) return "high";
      return "normal";
    };
    var teamLoadLevelRank = {
      normal: 0,
      high: 1,
      overloaded: 2
    };
    var classifyWorstTeamLoad = (openClaims, teamsThresholds) => teamsThresholds.reduce(
      (worst, thresholds) => {
        const level = classifyTeamLoad(openClaims, thresholds);
        return teamLoadLevelRank[level] > teamLoadLevelRank[worst.level] ? { level, thresholds } : worst;
      },
      {
        level: "normal",
        thresholds: teamsThresholds.find((thresholds) => !!thresholds) ?? null
      }
    );
    var canReadAllClaims = (permissions) => permissions.some(
      ({ type, scope }) => type === "can_read_claim" && scope === "all"
    );
    var grantedTeamScope = (permissions, type) => {
      const granted = permissions.filter((permission) => permission.type === type);
      if (!granted.length) return void 0;
      return granted.some(({ scope }) => scope === "all") ? "all" : "own";
    };
    var teamManagementScope = (permissions) => grantedTeamScope(permissions, "can_read_team_management");
    var assignmentPauseScope = (permissions) => grantedTeamScope(permissions, "can_pause_user_assignments");
    var teamClaimsReassignScope = (permissions) => grantedTeamScope(permissions, "can_reassign_team_claims");
    var teamInactivityScope = (permissions) => permissions.some(({ type }) => type === "can_update_user_availability") ? teamManagementScope(permissions) : void 0;
    var RELEASE_NOTE_EVENTS_BATCH_LIMIT2 = 50;
    var RELEASE_NOTE_EVENTS_FLUSH_INTERVAL_MS = 1e4;
    var RELEASE_NOTE_ITEM_VIEW_RATIO = 0.4;
    var RELEASE_NOTE_ITEM_VIEW_DWELL_MS = 1e3;
    var RELEASE_NOTES_LIST_LIMIT = 50;
    var RELEASE_NOTE_VIEWERS_SAMPLE_LIMIT = 8;
    var RELEASE_NOTES_SEARCH_EVENT_DELAY_MS = 800;
    var RELEASE_NOTES_SEARCH_QUERY_MAX_LENGTH2 = 100;
    var RELEASE_NOTES_PATH = "/releases";
    var releaseNotePath = (releaseNoteId) => `/release-notes/${releaseNoteId}`;
    var RELEASE_NOTES_SIDEBAR_STALE_TIME_MS = 5 * 60 * 1e3;
    var RELEASE_NOTE_ADOPTION_WEEKS_BEFORE = 8;
    var RELEASE_NOTE_ADOPTION_WEEKS_AFTER_LIMIT = 26;
    var countryCuit = ["ARG", "PRY"];
    var countryCurrencyList = [
      {
        country: "Afghanistan",
        currency_code: "AFN"
      },
      {
        country: "Albania",
        currency_code: "ALL"
      },
      {
        country: "Algeria",
        currency_code: "DZD"
      },
      {
        country: "American Samoa",
        currency_code: "USD"
      },
      {
        country: "Andorra",
        currency_code: "EUR"
      },
      {
        country: "Angola",
        currency_code: "AOA"
      },
      {
        country: "Anguilla",
        currency_code: "XCD"
      },
      {
        country: "Antarctica",
        currency_code: "XCD"
      },
      {
        country: "Antigua and Barbuda",
        currency_code: "XCD"
      },
      {
        country: "ARG",
        currency_code: "ARS"
      },
      {
        country: "Armenia",
        currency_code: "AMD"
      },
      {
        country: "Aruba",
        currency_code: "AWG"
      },
      {
        country: "Australia",
        currency_code: "AUD"
      },
      {
        country: "Austria",
        currency_code: "EUR"
      },
      {
        country: "Azerbaijan",
        currency_code: "AZN"
      },
      {
        country: "Bahamas",
        currency_code: "BSD"
      },
      {
        country: "Bahrain",
        currency_code: "BHD"
      },
      {
        country: "Bangladesh",
        currency_code: "BDT"
      },
      {
        country: "Barbados",
        currency_code: "BBD"
      },
      {
        country: "Belarus",
        currency_code: "BYR"
      },
      {
        country: "Belgium",
        currency_code: "EUR"
      },
      {
        country: "Belize",
        currency_code: "BZD"
      },
      {
        country: "Benin",
        currency_code: "XOF"
      },
      {
        country: "Bermuda",
        currency_code: "BMD"
      },
      {
        country: "Bhutan",
        currency_code: "BTN"
      },
      {
        country: "Bolivia",
        currency_code: "BOB"
      },
      {
        country: "Bosnia and Herzegovina",
        currency_code: "BAM"
      },
      {
        country: "Botswana",
        currency_code: "BWP"
      },
      {
        country: "Bouvet Island",
        currency_code: "NOK"
      },
      {
        country: "Brazil",
        currency_code: "BRL"
      },
      {
        country: "British Indian Ocean Territory",
        currency_code: "USD"
      },
      {
        country: "Brunei",
        currency_code: "BND"
      },
      {
        country: "Bulgaria",
        currency_code: "BGN"
      },
      {
        country: "Burkina Faso",
        currency_code: "XOF"
      },
      {
        country: "Burundi",
        currency_code: "BIF"
      },
      {
        country: "Cambodia",
        currency_code: "KHR"
      },
      {
        country: "Cameroon",
        currency_code: "XAF"
      },
      {
        country: "Canada",
        currency_code: "CAD"
      },
      {
        country: "Cape Verde",
        currency_code: "CVE"
      },
      {
        country: "Cayman Islands",
        currency_code: "KYD"
      },
      {
        country: "Central African Republic",
        currency_code: "XAF"
      },
      {
        country: "Chad",
        currency_code: "XAF"
      },
      {
        country: "Chile",
        currency_code: "CLP"
      },
      {
        country: "China",
        currency_code: "CNY"
      },
      {
        country: "Christmas Island",
        currency_code: "AUD"
      },
      {
        country: "Cocos (Keeling) Islands",
        currency_code: "AUD"
      },
      {
        country: "Colombia",
        currency_code: "COP"
      },
      {
        country: "Comoros",
        currency_code: "KMF"
      },
      {
        country: "Congo",
        currency_code: "XAF"
      },
      {
        country: "Cook Islands",
        currency_code: "NZD"
      },
      {
        country: "Costa Rica",
        currency_code: "CRC"
      },
      {
        country: "Croatia",
        currency_code: "EUR"
      },
      {
        country: "Cuba",
        currency_code: "CUP"
      },
      {
        country: "Cyprus",
        currency_code: "EUR"
      },
      {
        country: "Czech Republic",
        currency_code: "CZK"
      },
      {
        country: "Denmark",
        currency_code: "DKK"
      },
      {
        country: "Djibouti",
        currency_code: "DJF"
      },
      {
        country: "Dominica",
        currency_code: "XCD"
      },
      {
        country: "Dominican Republic",
        currency_code: "DOP"
      },
      {
        country: "East Timor",
        currency_code: "USD"
      },
      {
        country: "Ecuador",
        currency_code: "ECS"
      },
      {
        country: "Egypt",
        currency_code: "EGP"
      },
      {
        country: "El Salvador",
        currency_code: "SVC"
      },
      {
        country: "England",
        currency_code: "GBP"
      },
      {
        country: "Equatorial Guinea",
        currency_code: "XAF"
      },
      {
        country: "Eritrea",
        currency_code: "ERN"
      },
      {
        country: "Estonia",
        currency_code: "EUR"
      },
      {
        country: "Ethiopia",
        currency_code: "ETB"
      },
      {
        country: "Falkland Islands",
        currency_code: "FKP"
      },
      {
        country: "Faroe Islands",
        currency_code: "DKK"
      },
      {
        country: "Fiji Islands",
        currency_code: "FJD"
      },
      {
        country: "Finland",
        currency_code: "EUR"
      },
      {
        country: "France",
        currency_code: "EUR"
      },
      {
        country: "French Guiana",
        currency_code: "EUR"
      },
      {
        country: "French Polynesia",
        currency_code: "XPF"
      },
      {
        country: "French Southern territories",
        currency_code: "EUR"
      },
      {
        country: "Gabon",
        currency_code: "XAF"
      },
      {
        country: "Gambia",
        currency_code: "GMD"
      },
      {
        country: "Georgia",
        currency_code: "GEL"
      },
      {
        country: "Germany",
        currency_code: "EUR"
      },
      {
        country: "Ghana",
        currency_code: "GHS"
      },
      {
        country: "Gibraltar",
        currency_code: "GIP"
      },
      {
        country: "Greece",
        currency_code: "EUR"
      },
      {
        country: "Greenland",
        currency_code: "DKK"
      },
      {
        country: "Grenada",
        currency_code: "XCD"
      },
      {
        country: "Guadeloupe",
        currency_code: "EUR"
      },
      {
        country: "Guam",
        currency_code: "USD"
      },
      {
        country: "Guatemala",
        currency_code: "QTQ"
      },
      {
        country: "Guinea",
        currency_code: "GNF"
      },
      {
        country: "Guinea-Bissau",
        currency_code: "CFA"
      },
      {
        country: "Guyana",
        currency_code: "GYD"
      },
      {
        country: "Haiti",
        currency_code: "HTG"
      },
      {
        country: "Heard Island and McDonald Islands",
        currency_code: "AUD"
      },
      {
        country: "Holy See (Vatican City State)",
        currency_code: "EUR"
      },
      {
        country: "Honduras",
        currency_code: "HNL"
      },
      {
        country: "Hong Kong",
        currency_code: "HKD"
      },
      {
        country: "Hungary",
        currency_code: "HUF"
      },
      {
        country: "Iceland",
        currency_code: "ISK"
      },
      {
        country: "India",
        currency_code: "INR"
      },
      {
        country: "Indonesia",
        currency_code: "IDR"
      },
      {
        country: "Iran",
        currency_code: "IRR"
      },
      {
        country: "Iraq",
        currency_code: "IQD"
      },
      {
        country: "Ireland",
        currency_code: "EUR"
      },
      {
        country: "Israel",
        currency_code: "ILS"
      },
      {
        country: "Italy",
        currency_code: "EUR"
      },
      {
        country: "Ivory Coast",
        currency_code: "XOF"
      },
      {
        country: "Jamaica",
        currency_code: "JMD"
      },
      {
        country: "Japan",
        currency_code: "JPY"
      },
      {
        country: "Jordan",
        currency_code: "JOD"
      },
      {
        country: "Kazakhstan",
        currency_code: "KZT"
      },
      {
        country: "Kenya",
        currency_code: "KES"
      },
      {
        country: "Kiribati",
        currency_code: "AUD"
      },
      {
        country: "Kuwait",
        currency_code: "KWD"
      },
      {
        country: "Kyrgyzstan",
        currency_code: "KGS"
      },
      {
        country: "Laos",
        currency_code: "LAK"
      },
      {
        country: "Latvia",
        currency_code: "EUR"
      },
      {
        country: "Lebanon",
        currency_code: "LBP"
      },
      {
        country: "Lesotho",
        currency_code: "LSL"
      },
      {
        country: "Liberia",
        currency_code: "LRD"
      },
      {
        country: "Libyan Arab Jamahiriya",
        currency_code: "LYD"
      },
      {
        country: "Liechtenstein",
        currency_code: "CHF"
      },
      {
        country: "Lithuania",
        currency_code: "EUR"
      },
      {
        country: "Luxembourg",
        currency_code: "EUR"
      },
      {
        country: "Macau",
        currency_code: "MOP"
      },
      {
        country: "North Macedonia",
        currency_code: "MKD"
      },
      {
        country: "Madagascar",
        currency_code: "MGF"
      },
      {
        country: "Malawi",
        currency_code: "MWK"
      },
      {
        country: "Malaysia",
        currency_code: "MYR"
      },
      {
        country: "Maldives",
        currency_code: "MVR"
      },
      {
        country: "Mali",
        currency_code: "XOF"
      },
      {
        country: "Malta",
        currency_code: "EUR"
      },
      {
        country: "Marshall Islands",
        currency_code: "USD"
      },
      {
        country: "Martinique",
        currency_code: "EUR"
      },
      {
        country: "Mauritania",
        currency_code: "MRO"
      },
      {
        country: "Mauritius",
        currency_code: "MUR"
      },
      {
        country: "Mayotte",
        currency_code: "EUR"
      },
      {
        country: "Mexico",
        currency_code: "MXN"
      },
      {
        country: "Micronesia, Federated States of",
        currency_code: "USD"
      },
      {
        country: "Moldova",
        currency_code: "MDL"
      },
      {
        country: "Monaco",
        currency_code: "EUR"
      },
      {
        country: "Mongolia",
        currency_code: "MNT"
      },
      {
        country: "Montserrat",
        currency_code: "XCD"
      },
      {
        country: "Morocco",
        currency_code: "MAD"
      },
      {
        country: "Mozambique",
        currency_code: "MZN"
      },
      {
        country: "Myanmar",
        currency_code: "MMR"
      },
      {
        country: "Namibia",
        currency_code: "NAD"
      },
      {
        country: "Nauru",
        currency_code: "AUD"
      },
      {
        country: "Nepal",
        currency_code: "NPR"
      },
      {
        country: "Netherlands",
        currency_code: "EUR"
      },
      {
        country: "Netherlands Antilles",
        currency_code: "ANG"
      },
      {
        country: "New Caledonia",
        currency_code: "XPF"
      },
      {
        country: "New Zealand",
        currency_code: "NZD"
      },
      {
        country: "Nicaragua",
        currency_code: "NIO"
      },
      {
        country: "Niger",
        currency_code: "XOF"
      },
      {
        country: "Nigeria",
        currency_code: "NGN"
      },
      {
        country: "Niue",
        currency_code: "NZD"
      },
      {
        country: "Norfolk Island",
        currency_code: "AUD"
      },
      {
        country: "North Korea",
        currency_code: "KPW"
      },
      {
        country: "Northern Ireland",
        currency_code: "GBP"
      },
      {
        country: "Northern Mariana Islands",
        currency_code: "USD"
      },
      {
        country: "Norway",
        currency_code: "NOK"
      },
      {
        country: "Oman",
        currency_code: "OMR"
      },
      {
        country: "Pakistan",
        currency_code: "PKR"
      },
      {
        country: "Palau",
        currency_code: "USD"
      },
      {
        country: "Palestine",
        currency_code: null
      },
      {
        country: "Panama",
        currency_code: "PAB"
      },
      {
        country: "Papua New Guinea",
        currency_code: "PGK"
      },
      {
        country: "PRY",
        currency_code: "PYG"
      },
      {
        country: "Peru",
        currency_code: "PEN"
      },
      {
        country: "Philippines",
        currency_code: "PHP"
      },
      {
        country: "Pitcairn Islands",
        currency_code: "NZD"
      },
      {
        country: "Poland",
        currency_code: "PLN"
      },
      {
        country: "Portugal",
        currency_code: "EUR"
      },
      {
        country: "Puerto Rico",
        currency_code: "USD"
      },
      {
        country: "Qatar",
        currency_code: "QAR"
      },
      {
        country: "Reunion",
        currency_code: "EUR"
      },
      {
        country: "Romania",
        currency_code: "RON"
      },
      {
        country: "Russia",
        currency_code: "RUB"
      },
      {
        country: "Rwanda",
        currency_code: "RWF"
      },
      {
        country: "Saint Helena",
        currency_code: "SHP"
      },
      {
        country: "Saint Kitts and Nevis",
        currency_code: "XCD"
      },
      {
        country: "Saint Lucia",
        currency_code: "XCD"
      },
      {
        country: "Saint Pierre and Miquelon",
        currency_code: "EUR"
      },
      {
        country: "Saint Vincent and the Grenadines",
        currency_code: "XCD"
      },
      {
        country: "Samoa",
        currency_code: "WST"
      },
      {
        country: "San Marino",
        currency_code: "EUR"
      },
      {
        country: "Sao Tome and Principe",
        currency_code: "STD"
      },
      {
        country: "Saudi Arabia",
        currency_code: "SAR"
      },
      {
        country: "Scotland",
        currency_code: "GBP"
      },
      {
        country: "Senegal",
        currency_code: "XOF"
      },
      {
        country: "Serbia",
        currency_code: "RSD"
      },
      {
        country: "Seychelles",
        currency_code: "SCR"
      },
      {
        country: "Sierra Leone",
        currency_code: "SLL"
      },
      {
        country: "Singapore",
        currency_code: "SGD"
      },
      {
        country: "Slovakia",
        currency_code: "EUR"
      },
      {
        country: "Slovenia",
        currency_code: "EUR"
      },
      {
        country: "Solomon Islands",
        currency_code: "SBD"
      },
      {
        country: "Somalia",
        currency_code: "SOS"
      },
      {
        country: "South Africa",
        currency_code: "ZAR"
      },
      {
        country: "South Georgia and the South Sandwich Islands",
        currency_code: "GBP"
      },
      {
        country: "South Korea",
        currency_code: "KRW"
      },
      {
        country: "South Sudan",
        currency_code: "SSP"
      },
      {
        country: "Spain",
        currency_code: "EUR"
      },
      {
        country: "Sri Lanka",
        currency_code: "LKR"
      },
      {
        country: "Sudan",
        currency_code: "SDG"
      },
      {
        country: "Suriname",
        currency_code: "SRD"
      },
      {
        country: "Svalbard and Jan Mayen",
        currency_code: "NOK"
      },
      {
        country: "Swaziland",
        currency_code: "SZL"
      },
      {
        country: "Sweden",
        currency_code: "SEK"
      },
      {
        country: "Switzerland",
        currency_code: "CHF"
      },
      {
        country: "Syria",
        currency_code: "SYP"
      },
      {
        country: "Tajikistan",
        currency_code: "TJS"
      },
      {
        country: "Tanzania",
        currency_code: "TZS"
      },
      {
        country: "Thailand",
        currency_code: "THB"
      },
      {
        country: "The Democratic Republic of Congo",
        currency_code: "CDF"
      },
      {
        country: "Togo",
        currency_code: "XOF"
      },
      {
        country: "Tokelau",
        currency_code: "NZD"
      },
      {
        country: "Tonga",
        currency_code: "TOP"
      },
      {
        country: "Trinidad and Tobago",
        currency_code: "TTD"
      },
      {
        country: "Tunisia",
        currency_code: "TND"
      },
      {
        country: "Turkey",
        currency_code: "TRY"
      },
      {
        country: "Turkmenistan",
        currency_code: "TMT"
      },
      {
        country: "Turks and Caicos Islands",
        currency_code: "USD"
      },
      {
        country: "Tuvalu",
        currency_code: "AUD"
      },
      {
        country: "Uganda",
        currency_code: "UGX"
      },
      {
        country: "Ukraine",
        currency_code: "UAH"
      },
      {
        country: "United Arab Emirates",
        currency_code: "AED"
      },
      {
        country: "United Kingdom",
        currency_code: "GBP"
      },
      {
        country: "United States",
        currency_code: "USD"
      },
      {
        country: "United States Minor Outlying Islands",
        currency_code: "USD"
      },
      {
        country: "Uruguay",
        currency_code: "UYU"
      },
      {
        country: "Uzbekistan",
        currency_code: "UZS"
      },
      {
        country: "Vanuatu",
        currency_code: "VUV"
      },
      {
        country: "Venezuela",
        currency_code: "VEF"
      },
      {
        country: "Vietnam",
        currency_code: "VND"
      },
      {
        country: "Virgin Islands, British",
        currency_code: "USD"
      },
      {
        country: "Virgin Islands, U.S.",
        currency_code: "USD"
      },
      {
        country: "Wales",
        currency_code: "GBP"
      },
      {
        country: "Wallis and Futuna",
        currency_code: "XPF"
      },
      {
        country: "Western Sahara",
        currency_code: "MAD"
      },
      {
        country: "Yemen",
        currency_code: "YER"
      },
      {
        country: "Zambia",
        currency_code: "ZMW"
      },
      {
        country: "Zimbabwe",
        currency_code: "ZWD"
      }
    ];
    var currencySymbolLocaleEquivalences2 = {
      ARS: "es-AR",
      PYG: "es-PY",
      USD: "en-US",
      EUR: "de-DE"
    };
    var FALLBACK_LOCALE = "es-AR";
    var formatMoneyInCurrency = (amount, currency, options) => {
      const locale94 = currencySymbolLocaleEquivalences2[currency] || FALLBACK_LOCALE;
      return new Intl.NumberFormat(locale94, {
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: (options == null ? void 0 : options.compact) ? 1 : 0,
        ...(options == null ? void 0 : options.compact) ? { notation: "compact", compactDisplay: "short" } : {}
      }).format(amount).replace("MRD", "mil M");
    };
    var webhookEvents = [
      "claim_collaborator_assigned",
      "claim_created",
      "claim_responsible_unassigned",
      "claim_responsible_assigned",
      "claim_status_updated",
      "file_requested",
      "upload_files",
      "claim_documentation_requested",
      "claim_offer_flow",
      "claim_documentation_completed",
      "claim_file_request_completed",
      "contract_created",
      "contract_report_created",
      "contract_report_accepted",
      "contract_report_rejected",
      "field_adjuster_assigned",
      "offer_expired",
      "offer_rejected",
      "offer_accepted",
      "fraud_closed"
    ];
    var occurrenceCirculationDirection = ["both", "unique"];
    var DEFAULT_ENTRYPOINT_SPECIFICATION2 = "rivadavia_v2";
    var complaintReactiveFormFlowSteps = [
      "welcome",
      "current-email",
      "policyholder-vehicle-info",
      "is-third-party-involved",
      "driver-detail",
      "insured-type",
      "third-party-vehicle-type",
      "occurrence",
      "insured-info",
      "third-party-exists",
      "complaint-confirmation",
      "third-party-detail",
      "vehicle-driver-info",
      "third-party-info",
      "occurrence-sinister",
      "complaint-created",
      "complaint-type",
      "complaint-other-details",
      "ask-police-intervention",
      "policyholder-info",
      "policyholder-type",
      "all-documents"
    ];
    var claimReactiveFormFlowSteps = [
      "claim-created",
      "has-insurance",
      "has-income-verification",
      "occurrence-optional-info",
      "welcome",
      "claim-confirmation",
      "vehicle-category",
      "is-local-insured-involved",
      "special-branch-info",
      "insured-info",
      "damage-material-type",
      "damage-declaration",
      "victim-type-choose",
      "own-claim-choose",
      "own-material-claim-choose",
      "recovery-institution-info",
      "recovery-institution-relationship",
      "recovery-claimant-info",
      "recovery-claimant-address-info",
      "recovery-injured-person-info",
      "recovery-asset-owner-info",
      "recovery-damage-type",
      "claimant-info",
      "claimant-address-info",
      "sinister-type",
      "material-damage-documents",
      "victim-type-choose-real-property",
      "victim-death-info",
      "victim-death-address-info",
      "victim-death-relationship",
      "victim-death-rol",
      "victim-natural-person-address-info",
      "victim-legal-person-info",
      "victim-natural-person-info",
      "vehicle-driver-ownership",
      "legal-person-reimbursements-info",
      "vehicle-info",
      "material-damage-insurer-info",
      "vehicle-driver-info",
      "victim-minor-father-info",
      "victim-minor-mother-info",
      "has-health-insurance",
      "was-treated-by-worker-compensation-insurer",
      "surgery-description",
      "had-surgery",
      "was-treated-by-medical-institution",
      "health-insurance-info",
      "worker-compensation-insurer-info",
      "medical-institution-info",
      "claimant-list",
      "sinister-info",
      "claimed-amount",
      "location-info",
      "match-real-property-victim-address",
      "real-property-location",
      "real-property-info",
      "vehicle-ownership-document-choose",
      "victim-injuries-rol",
      "victim-injuries-rol-material",
      "victim-injuries-details",
      "victim-relationship",
      "injured-identity-card",
      "same-damage-victim",
      "same-damage-victim-real-property",
      "material-victim-natural-person-info",
      "material-victim-natural-person-address-info",
      "material-victim-minor-father-info",
      "material-victim-minor-mother-info",
      "material-claimant-info",
      "material-claimant-address-info",
      "material-victim-relationship",
      "all-documents",
      "demoempleo-claimant-info",
      "demoempleo-sinister-info",
      "demoempleo-documents",
      "gamma-derivation-info",
      "gamma-insured-info",
      "gamma-vehicle-info",
      "gamma-damage-info",
      "gamma-documents",
      "gamma-claim-info"
    ];
    var integrationTemplateParentObjectReferences2 = [
      "claim.victim.natural_person.first_name",
      "claim.victim.natural_person.last_name",
      "claim.victim.natural_person.nationality",
      "claim.victim.natural_person.address",
      "claim.victim.natural_person.state",
      "claim.victim.natural_person.city",
      "claim.victim.natural_person.zip_code",
      "claim.victim.natural_person.sex",
      "claim.victim.natural_person.identification_type",
      "claim.victim.natural_person.identification_value",
      "claim.owner.first_name",
      "claim.owner.last_name",
      "claim.owner.cellphone",
      "claim.owner.email",
      "claim.owner.identification",
      "claim.owner.sex",
      "claim.created_by.first_name",
      "claim.created_by.last_name",
      "claim.created_by.cellphone",
      "claim.created_by.email",
      "claim.created_by.identification",
      "claim.created_by.sex",
      "claim.sinister.date",
      "claim.sinister.license_plate",
      "claim.sinister.external_complaint.external_id",
      "claim.sinister.external_complaint.external_status",
      "claim.sinister.external_complaint.agency",
      "claim.sinister.external_complaint.occurrence_date",
      "claim.sinister.external_complaint.registered_by",
      "claim.sinister.external_complaint.policyholder.policy_number",
      "claim.sinister.external_complaint.policyholder.make",
      "claim.sinister.external_complaint.policyholder.model",
      "claim.sinister.external_complaint.policyholder.version",
      "claim.sinister.external_complaint.policyholder.agency",
      "claim.sinister.external_complaint.policyholder.order",
      "claim.sinister.external_complaint.policyholder.cuil",
      "claim.sinister.external_complaint.policyholder.address",
      "claim.sinister.external_complaint.policyholder.city",
      "claim.sinister.external_complaint.policyholder.country",
      "claim.sinister.external_complaint.policyholder.identification",
      "claim.sinister.external_complaint.policyholder.first_name",
      "claim.sinister.external_complaint.policyholder.last_name",
      "claim.sinister.external_complaint.policyholder.sex",
      "claim.sinister.external_complaint.policyholder.landline_phone",
      "claim.sinister.external_complaint.policyholder.marital_status",
      "claim.sinister.external_complaint.policyholder.license_plate",
      "claim.sinister.external_complaint.policyholder.plan",
      "claim.sinister.external_complaint.policyholder.use",
      "claim.sinister.external_complaint.policyholder.year",
      "claim.sinister.external_complaint.policyholder.zip_code",
      "claim.occurrence.address",
      "claim.occurrence.time",
      "claim.occurrence.city",
      "claim.occurrence.state",
      "claim.occurrence.country",
      "claim.occurrence.zip_code",
      "claim.occurrence.description",
      "claim.occurrence.damage_description",
      "claim.occurrence.sinister_date"
    ];
    var currencySymbolLabels = {
      PYG: "Guaran\xED",
      USD: "D\xF3lar",
      EUR: "Euro",
      ARS: "Peso Argentino"
    };
    var CHECKBOX_COLUMN_ID = "select";
    var TENANT_SLUG_HEADER_KEY = "x-tenant-slug";
    var TEST_TENANT_SLUGS = ["ravel", "revelacion"];
    var isTestTenantSlug = (tenantSlug) => TEST_TENANT_SLUGS.some((testSlug) => testSlug === tenantSlug);
    var THEME_COLORS = {
      theme_zinc: "#181a1b",
      theme_red: "#eb4d4d",
      theme_rose: "#e11d48",
      theme_orange: "#ff6b35",
      theme_green: "#16a34a",
      theme_amber: "#f59e0b",
      theme_yellow: "#eab308",
      theme_lime: "#84cc16",
      theme_emerald: "#10b981",
      theme_teal: "#14b8a6",
      theme_cyan: "#06b6d4",
      theme_sky: "#0ea5e9",
      theme_blue: "#3b82f6",
      theme_indigo: "#6366f1",
      theme_violet: "#8b5cf6",
      theme_purple: "#a855f7",
      theme_fuchsia: "#d946ef",
      theme_pink: "#ec4899"
    };
    var DEFAULT_PIRAMID_THEME = "theme_orange";
    var AUTH_URL_PARAMS = {
      TOKEN: "token"
    };
    var PROVIDER_INVITATION_TTL_DAYS = 7;
    var CUSTOMER_ORGANIZATION_INVITATION_TTL_DAYS = 7;
    var onboardingSteps = [
      "company_data",
      "documentation",
      "capabilities"
    ];
    var requiredCompanyFields = ["legal_name", "ein"];
    var OFFER_CANCELED_ON_CLAIM_CLOSE_REASON = "Anulado autom\xE1ticamente por baja del reclamo";
    var DEFAULT_PUBLIC_OFFER_CANCELED_REASON = "El ofrecimiento previo ha sido dejado sin efecto";
    var NEGOTIATION_AGGREGATES_WINDOW_MONTHS = 12;
    var NEGOTIATION_MAX_CREDIBLE_RATIO = 3;
    var NEGOTIATION_MIN_ESCALATION_UNIVERSE_SIZE = 5;
    var NEGOTIATION_CLAIMER_CLAIMS_LISTED = 15;
    var NEGOTIATION_TYPE_AVERAGE_REFRESH_AFTER_MS = 10 * 60 * 1e3;
    var NEGOTIATION_TYPE_AVERAGE_MAX_AGE_MS = 15 * 60 * 1e3;
    var NEGOTIATION_TYPE_AVERAGE_SELF_CHANGE_MARGIN_MS = 2 * 60 * 1e3;
    var NEGOTIATION_TYPE_AVERAGE_REFRESH_LEASE_MS = 2 * 60 * 1e3;
    var OFFER_AMOUNT_IN_WORDS_VARIABLE_NAME = "Importe en letras";
    var OFFER_AMOUNT_IN_WORDS_VARIABLE_NAMES = [
      OFFER_AMOUNT_IN_WORDS_VARIABLE_NAME,
      "Importe ofrecido en texto"
    ];
    var OFFER_PUBLIC_REASON_VARIABLE_NAMES = [
      "Motivo del ofrecimiento"
    ];
    var OFFER_INSTALLMENTS_VARIABLE_NAME = "Cuotas";
    var OFFER_INSTALLMENT_OPTIONS2 = [1, 2, 3, 4];
    var OFFER_SINGLE_PAYMENT_INSTALLMENTS2 = 1;
    var OFFER_FEES_VARIABLE_NAME = "Honorarios";
    var OFFER_FEE_PERCENTAGE_OPTIONS2 = [10, 12, 15];
    var SHOW_OFFER_PAYMENT_HINTS = true;
    var OFFER_PAYMENT_DAYS_VARIABLE_NAMES = [
      "D\xEDas",
      "Cantidad de d\xEDas"
    ];
    var OFFER_PAYMENT_DAYS_OPTIONS2 = [15, 30];
    var OFFER_DEFAULT_PAYMENT_DAYS2 = 30;
    var OFFER_DEFAULT_FEE_PERCENTAGE2 = 10;
    var OFFER_EXPIRATION_DAYS = 30;
    var claimantPendingActionTypes = [
      "agreement_signature",
      "offer_response",
      "documentation_upload"
    ];
    var CLAIMANT_PENDING_ACTIONS_LIMIT = 100;
    var CLAIMANT_PENDING_ACTIONS_FLAT_LIST_MAX = 5;
    var CLAIMANT_PENDING_ACTIONS_STALE_TIME_MS = 1e4;
    var offerAcceptanceFieldKeys2 = [
      "identification",
      "cbu",
      "cuit",
      "cbu_proof",
      "lawyer_cbu",
      "lawyer_cuit",
      "lawyer_cbu_proof",
      "fee_invoice"
    ];
    var offerAcceptanceFieldTypes2 = ["text", "file"];
    var OFFER_ACCEPTANCE_FIELDS2 = [
      {
        key: "identification",
        type: "text",
        required: true,
        concept: "identification",
        name: null,
        min_length: 7,
        max_length: 8
      },
      {
        key: "cbu",
        type: "text",
        required: true,
        concept: "cbu",
        name: null,
        min_length: 22,
        max_length: 22
      },
      {
        key: "cuit",
        type: "text",
        required: true,
        concept: "cuit",
        name: null,
        min_length: 11,
        max_length: 11
      },
      {
        key: "cbu_proof",
        type: "file",
        required: true,
        concept: null,
        name: "Constancia de CBU",
        min_length: null,
        max_length: null
      },
      {
        key: "lawyer_cbu",
        type: "text",
        required: true,
        concept: "lawyer_cbu",
        name: null,
        min_length: 22,
        max_length: 22
      },
      {
        key: "lawyer_cuit",
        type: "text",
        required: true,
        concept: "lawyer_cuit",
        name: null,
        min_length: 11,
        max_length: 11
      },
      {
        key: "lawyer_cbu_proof",
        type: "file",
        required: true,
        concept: null,
        name: "Constancia de CBU Letrado",
        min_length: null,
        max_length: null
      },
      {
        key: "fee_invoice",
        type: "file",
        required: false,
        concept: null,
        name: "Factura de honorarios",
        min_length: null,
        max_length: null
      }
    ];
    var offerAcceptanceField3 = (key) => OFFER_ACCEPTANCE_FIELDS2.find((field) => field.key === key);
    var offerPaymentMethods2 = ["transfer"];
    var OFFER_PAYMENT_METHOD_LABELS2 = {
      transfer: "Transferencia"
    };
    var OFFER_ACCEPTANCE_REQUIREMENTS_VERSION3 = 3;
    var acceptancePayeeCases2 = [
      /** Persona física, mayor de edad y viva: cobra el damnificado. */
      "victim",
      /** Menor de edad: cobra el padre, la madre o quien lo represente. */
      "minor_victim",
      /** Fallecido: cobra uno de los sucesores. */
      "deceased_victim",
      /** Persona jurídica: su identificación **es** el CUIT, no hay documento que pedir. */
      "legal_person_victim"
    ];
    var acceptancePayeeRelations2 = [
      "victim",
      "father",
      "mother",
      "heir",
      "tutor_curator",
      "legal_representative"
    ];
    var offerPayees4 = ["victim", "attorney_in_fact"];
    var acceptancePayeeBlockers2 = [
      /** Sin fecha de nacimiento no se asume adulto (invariante 5 del catálogo). */
      "minority_unknown",
      /** El caso no dejó ninguna persona: menor sin padres, fallecido sin sucesores. */
      "no_candidates",
      /** Hay personas, pero ninguna tiene documento con el que comparar. */
      "candidates_without_identification"
    ];
    var acceptanceLawyerBlockers2 = [
      "lawyer_identification_not_cuit"
    ];
    var acceptancePayeeIssueCodes2 = [
      "payee_cuit_invalid",
      "payee_cuit_does_not_match_identification",
      "payee_identification_not_a_candidate",
      "payee_cuit_not_a_candidate",
      "payee_unresolved",
      "payee_cuit_not_attorney",
      "lawyer_cuit_does_not_match",
      "lawyer_cuit_unavailable"
    ];
    var acceptanceCheckStatuses2 = ["valid", "invalid", "missing"];
    var CUIT_NATURAL_PERSON_PREFIXES2 = ["20", "23", "24", "27"];
    var CUIT_LEGAL_PERSON_PREFIXES = ["30", "33", "34"];
    var CUIT_IDENTIFICATION_LENGTH3 = 8;
    var RECORDING_RETENTION_DAYS = 30;
    var MILLISECONDS_IN_A_DAY = 864e5;
    var isRecordingExpired = (createdAt) => {
      const createdAtMilliseconds = new Date(createdAt).getTime();
      if (Number.isNaN(createdAtMilliseconds)) return false;
      return Date.now() - createdAtMilliseconds > RECORDING_RETENTION_DAYS * MILLISECONDS_IN_A_DAY;
    };
    var documentTemplates = [
      "sample",
      "order_report",
      "agreement"
    ];
    var documentVariants4 = ["default"];
    var documentApps = ["insurer", "provider", "customer"];
    var productImportTargetFields2 = [
      "sku",
      "name",
      "brand",
      "description",
      "unit_price",
      "is_active"
    ];
    var productImportRowErrorCodes2 = [
      "empty_required",
      "invalid_number",
      "ambiguous_number",
      "too_many_decimals",
      "invalid_boolean",
      "invalid_value",
      "duplicate_sku_in_file",
      "sku_deleted",
      "sku_already_exists"
    ];
    var decimalAmountFormats2 = ["es-AR", "en-US"];
    var decimalAmountFormatExamples = {
      "es-AR": "1.234,56",
      "en-US": "1,234.56"
    };
    var productImportDelimiters2 = [",", ";", "	"];
    var productImportEncodings2 = ["utf-8", "windows-1252"];
    var productImportTruthyValues = [
      "si",
      "s\xED",
      "s",
      "yes",
      "y",
      "true",
      "verdadero",
      "1",
      "activo"
    ];
    var productImportFalsyValues = [
      "no",
      "n",
      "false",
      "falso",
      "0",
      "inactivo"
    ];
    var productImportHeaderAliases = {
      sku: ["sku", "codigo", "cod", "articulo", "item", "referencia"],
      name: ["nombre", "name", "producto", "titulo", "denominacion"],
      brand: ["marca", "brand", "fabricante", "marca producto"],
      description: ["descripcion", "description", "detalle", "observaciones"],
      unit_price: [
        "precio",
        "price",
        "importe",
        "precio unitario",
        "precio venta",
        "pvp",
        "valor"
      ],
      is_active: ["activo", "estado", "is active", "habilitado", "vigente"]
    };
    var MAX_PRODUCT_IMPORT_ROWS = 1e4;
    var MAX_PRODUCT_IMPORT_COLUMNS = 50;
    var PRODUCT_IMPORT_CHUNK_SIZE = 200;
    var PRODUCT_IMPORT_WRITE_CONCURRENCY = 25;
    var MAX_STORED_ROW_ERRORS = 500;
    var PRODUCT_IMPORT_SAMPLE_ROWS = 10;
    var MAX_PRODUCT_EXPORT_ROWS = 5e4;
    var PRODUCT_EXPORT_DELIMITER = ";";
    var PRODUCT_IMPORT_FILE_EXTENSION = ".csv";
    var PRODUCT_EXPORT_HEADERS = [
      "SKU",
      "NOMBRE",
      "MARCA",
      "DESCRIPCION",
      "PRECIO",
      "ACTIVO"
    ];
    var PRODUCT_IMPORT_TEMPLATE_ROWS = [
      [
        "VG-001",
        "Parabrisas Corsa",
        "Saint-Gobain",
        "Vidrio delantero laminado",
        "125000,00",
        "SI"
      ],
      [
        "VG-002",
        "Luneta Gol Trend",
        "Pilkington",
        "Vidrio trasero t\xE9rmico",
        "98500,50",
        "SI"
      ]
    ];
    var NETWORK_BRANCHES_MAP_LIMIT = 500;
    var BRANCH_CENTRAL_COLOR = "#16a34a";
    var BRANCH_REGULAR_COLOR = "#FC762D";
    var AGREEMENT_CATALOG_VERSION2 = 6;
    var AGREEMENT_FORMAT_VERSION2 = 4;
    var agreementVariableTypes2 = [
      "text",
      "money",
      "number",
      "percent",
      "date",
      "words",
      "boolean",
      "enum",
      "list"
    ];
    var agreementVariableGroups = [
      "company",
      "claim",
      "victim",
      "claimant",
      "lawyer",
      "heirs",
      "insured",
      "insured_vehicle",
      "sinister",
      "damage_material",
      "damage_person",
      "damage_recovery",
      "offer",
      "payment",
      "acceptance",
      "document"
    ];
    var agreementVariableStages = ["send", "accept", "document"];
    var agreementDateFormats = ["short", "long"];
    var agreementPersonVariableFields2 = [
      "full_name",
      "first_name",
      "last_name",
      "identification_type",
      "identification",
      "address",
      "city",
      "state",
      "zip_code",
      "email",
      "phone"
    ];
    var PERSON_FIELD_TYPES = {
      full_name: "text",
      first_name: "text",
      last_name: "text",
      identification_type: "enum",
      identification: "text",
      address: "text",
      city: "text",
      state: "enum",
      zip_code: "text",
      email: "text",
      phone: "text"
    };
    var definePersonVariables = (group) => agreementPersonVariableFields2.map(
      (field) => ({
        key: `${group}.${field}`,
        group,
        type: PERSON_FIELD_TYPES[field],
        stage: "send",
        printable: true
      })
    );
    var defineDamageVariable = (group, key, type) => ({
      key,
      group,
      type,
      stage: "send",
      printable: true
    });
    var agreementVariables2 = [
      {
        key: "company.name",
        group: "company",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "company.tax_id",
        group: "company",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "claim.ref_id",
        group: "claim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "claim.external_claim_id",
        group: "claim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "claim.external_claim_request_id",
        group: "claim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "claim.type",
        group: "claim",
        type: "text",
        stage: "send",
        printable: true
      },
      defineDamageVariable("claim", "claim.damages.types", "list"),
      ...definePersonVariables("victim"),
      {
        key: "victim.birth_date",
        group: "victim",
        type: "date",
        stage: "send",
        date_format: "short",
        printable: true
      },
      {
        key: "victim.is_minor",
        group: "victim",
        type: "boolean",
        stage: "send",
        printable: true
      },
      {
        key: "victim.is_deceased",
        group: "victim",
        type: "boolean",
        stage: "send",
        printable: true
      },
      {
        key: "victim.parents.father.full_name",
        group: "victim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "victim.parents.father.identification",
        group: "victim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "victim.parents.mother.full_name",
        group: "victim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "victim.parents.mother.identification",
        group: "victim",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "victim.representatives",
        group: "victim",
        type: "list",
        stage: "send",
        printable: true
      },
      ...definePersonVariables("claimant"),
      {
        key: "claimant.relationship",
        group: "claimant",
        type: "enum",
        stage: "send",
        printable: true
      },
      {
        key: "claimant.relationship_other",
        group: "claimant",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "claimant.is_victim",
        group: "claimant",
        type: "boolean",
        stage: "send",
        printable: true
      },
      ...definePersonVariables("lawyer"),
      {
        key: "lawyer.kind",
        group: "lawyer",
        type: "enum",
        stage: "send",
        printable: true
      },
      {
        key: "lawyer.cuit",
        group: "lawyer",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "heirs.count",
        group: "heirs",
        type: "number",
        stage: "send",
        printable: true
      },
      {
        key: "heirs.list",
        group: "heirs",
        type: "list",
        stage: "send",
        printable: true
      },
      {
        key: "heirs.names",
        group: "heirs",
        type: "list",
        stage: "send",
        printable: true
      },
      {
        key: "insured.full_name",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured.identification",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured.address",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured.city",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured.state",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured.policy_number",
        group: "insured",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured_vehicle.license_plate",
        group: "insured_vehicle",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured_vehicle.description",
        group: "insured_vehicle",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured_vehicle.make",
        group: "insured_vehicle",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured_vehicle.model",
        group: "insured_vehicle",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "insured_vehicle.year",
        group: "insured_vehicle",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "sinister.number",
        group: "sinister",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "sinister.date",
        group: "sinister",
        type: "date",
        stage: "send",
        date_format: "short",
        printable: true
      },
      /** La misma fecha en la forma larga, como `document.date` junto a `document.date_short`. */
      {
        key: "sinister.date_long",
        group: "sinister",
        type: "date",
        stage: "send",
        date_format: "long",
        printable: true
      },
      {
        key: "sinister.address",
        group: "sinister",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "sinister.city",
        group: "sinister",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "sinister.state",
        group: "sinister",
        type: "enum",
        stage: "send",
        printable: true
      },
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.kind",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.description",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.summary",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.description",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.make",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.model",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.version",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.year",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.license_plate",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.chassis",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.engine",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.type",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.vehicle.use",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.driver.full_name",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.insurance.insurer",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.insurance.policy_number",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.insurance.coverage",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.type",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.ownership",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.address",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.city",
        "text"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.state",
        "enum"
      ),
      defineDamageVariable(
        "damage_material",
        "claim.damages.material.real_property.zip_code",
        "text"
      ),
      defineDamageVariable("damage_person", "claim.damages.person.kind", "enum"),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.victim_role",
        "enum"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.policyholder_relationship",
        "enum"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.treatment_medical_institution",
        "text"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.health_insurance_fund",
        "text"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.treatment_worker_compensation_insurer",
        "text"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.surgery_description",
        "text"
      ),
      defineDamageVariable(
        "damage_person",
        "claim.damages.person.injuries",
        "list"
      ),
      defineDamageVariable(
        "damage_recovery",
        "claim.damages.recovery.institution.full_name",
        "text"
      ),
      defineDamageVariable(
        "damage_recovery",
        "claim.damages.recovery.institution.identification",
        "text"
      ),
      defineDamageVariable(
        "damage_recovery",
        "claim.damages.recovery.institution.type",
        "enum"
      ),
      defineDamageVariable(
        "damage_recovery",
        "claim.damages.recovery.claimant_relationship",
        "enum"
      ),
      {
        key: "offer.amount",
        group: "offer",
        type: "money",
        stage: "send",
        printable: true
      },
      {
        key: "offer.amount_in_words",
        group: "offer",
        type: "words",
        stage: "send",
        printable: true
      },
      {
        key: "offer.amount_in_words_declared",
        group: "offer",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "offer.installments",
        group: "offer",
        type: "number",
        stage: "send",
        printable: true
      },
      {
        key: "offer.fee_percentage",
        group: "offer",
        type: "percent",
        stage: "send",
        printable: true
      },
      {
        key: "offer.payment_days",
        group: "offer",
        type: "number",
        stage: "send",
        printable: true
      },
      {
        key: "offer.public_reason",
        group: "offer",
        type: "text",
        stage: "send",
        printable: true
      },
      {
        key: "offer.sent_at",
        group: "offer",
        type: "date",
        stage: "send",
        date_format: "short",
        printable: true
      },
      {
        key: "offer.accepted_at",
        group: "offer",
        type: "date",
        stage: "accept",
        date_format: "short",
        printable: true
      },
      {
        key: "payment.fees_amount",
        group: "payment",
        type: "money",
        stage: "send",
        printable: true
      },
      {
        key: "payment.total_amount",
        group: "payment",
        type: "money",
        stage: "send",
        printable: true
      },
      {
        key: "payment.installment_amount",
        group: "payment",
        type: "money",
        stage: "send",
        printable: true
      },
      {
        key: "payment.installment_amount_in_words",
        group: "payment",
        type: "words",
        stage: "send",
        printable: true
      },
      {
        key: "payment.fees_amount_in_words",
        group: "payment",
        type: "words",
        stage: "send",
        printable: true
      },
      {
        key: "acceptance.payment_method",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "acceptance.cbu",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "acceptance.cuit",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "acceptance.lawyer_cbu",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "acceptance.lawyer_cuit",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "acceptance.identification",
        group: "acceptance",
        type: "text",
        stage: "accept",
        printable: true
      },
      {
        key: "document.date",
        group: "document",
        type: "date",
        stage: "document",
        date_format: "long",
        printable: true
      },
      {
        key: "document.date_short",
        group: "document",
        type: "date",
        stage: "document",
        date_format: "short",
        printable: true
      }
    ];
    var agreementVariableKeys = agreementVariables2.map((variable) => variable.key);
    var isAgreementVariableKey2 = (key) => agreementVariableKeys.some((candidate) => candidate === key);
    var AGREEMENT_PRESERVE_CASE_KEYS2 = [
      // Identificadores con los que alguien busca el reclamo: si el valor distingue
      // mayúsculas de minúsculas, cambiarlas deja de nombrar la misma cosa.
      "claim.ref_id",
      "claim.external_claim_id",
      "claim.external_claim_request_id",
      // Un mail en mayúsculas se lee como error de tipeo, y su parte local es
      // sensible a las mayúsculas.
      "victim.email",
      "claimant.email",
      "lawyer.email",
      // Párrafos escritos a mano: en mayúsculas se leen como grito.
      "offer.public_reason",
      "insured_vehicle.description",
      "claim.damages.material.description",
      "claim.damages.material.summary",
      "claim.damages.material.vehicle.description",
      "claim.damages.person.surgery_description"
    ];
    var AGREEMENT_DYNAMIC_PREFIXES2 = {
      offer: "offer_variable",
      acceptance: "acceptance_variable"
    };
    var agreementDynamicKeyPattern = new RegExp(
      `^(${Object.values(AGREEMENT_DYNAMIC_PREFIXES2).join("|")})\\.[a-z0-9_]+$`
    );
    var isAgreementDynamicVariableKey2 = (key) => agreementDynamicKeyPattern.test(key);
    var stageByKey = new Map(
      agreementVariables2.map((variable) => [variable.key, variable.stage])
    );
    var agreementVariableStageOf2 = (key) => key.startsWith(`${AGREEMENT_DYNAMIC_PREFIXES2.acceptance}.`) ? "accept" : stageByKey.get(key) ?? "send";
    var agreementGapClasses2 = [
      "pending",
      "absent",
      "not_applicable",
      "unknown_key"
    ];
    var agreementVariableStatuses = [
      "resolved",
      "missing",
      "not_applicable"
    ];
    var agreementMissingReasons3 = [
      "empty_field",
      "no_selected_external_complaint",
      "acceptance_unknown",
      "not_provided",
      "invalid_value",
      "out_of_range",
      "unsupported_currency",
      "unknown_state_code",
      "no_claimant",
      "lawyer_identification_not_cuit",
      "birth_date_missing",
      "representative_unknown",
      /** El reclamo todavía no tiene ofrecimiento: nada suyo puede resolverse. */
      "no_offer",
      "no_claim_type"
    ];
    var agreementNotApplicableReasons3 = [
      "legal_person",
      "no_lawyer",
      "no_parents",
      "not_represented",
      "no_heirs",
      "no_installments",
      "no_fees",
      "no_binding",
      "ambiguous_binding",
      "hidden_by_condition",
      "unprintable",
      "draft_offer",
      /** El ofrecimiento no le pide ese dato al reclamante (p. ej. no hay abogado). */
      "not_requested",
      /** El ofrecimiento se mandó sin motivo público: es opcional, no un hueco. */
      "no_public_reason",
      "no_material_damage",
      "no_person_damage",
      "no_recovery_damage",
      "no_vehicle",
      "no_real_property",
      "no_driver",
      "no_insurance",
      "no_injury_details",
      "not_policyholder_rider"
    ];
    var agreementWarningCodes2 = [
      "multiple_principal_claimants",
      "principal_fallback_positional",
      "multiple_lawyers",
      "heirs_without_death",
      "parents_without_minor",
      "owner_not_a_claimant",
      "claimant_victim_mismatch",
      "relationship_null",
      "relationship_other_free_text",
      "sinister_date_mismatch",
      "invalid_cbu_format",
      "invalid_cuit_checksum",
      "bank_fields_swapped",
      "amount_in_words_mismatch",
      "currency_differs_from_company_default",
      "binding_matched_by_normalization",
      "ambiguous_binding",
      "definitions_not_snapshotted",
      "unknown_select_option",
      "dynamic_key_collision",
      "multiple_damages_of_same_type",
      "multiple_rules_matched",
      /** La denuncia del asegurado salió del siniestro (por patente), no de la seleccionada en el reclamo. */
      "external_complaint_inferred",
      /** El siniestro tiene denuncias con asegurado pero ninguna coincide con la patente del reclamo. */
      "external_complaint_unmatched",
      /** Los daños actuales ya no encajan en la composición del tipo de reclamo asignado. */
      "claim_type_damages_mismatch"
    ];
    var AGREEMENT_BLOCKING_WARNING_CODES2 = [
      "claimant_victim_mismatch"
    ];
    var claimantVictimIdentityFields3 = [
      "identification",
      "email"
    ];
    var claimantVictimIdentityIssues2 = [
      "mismatch",
      "missing_on_victim",
      "missing_on_claimant",
      "missing_on_both"
    ];
    var agreementPersonKinds2 = ["natural_person", "legal_person"];
    var agreementLawyerKinds3 = [
      "attorney_in_fact",
      "attorney_representative"
    ];
    var agreementBindingConcepts3 = [
      "amount",
      "amount_in_words",
      "installments",
      "fee_percentage",
      "payment_days",
      "payment_method",
      "cbu",
      "cuit",
      "lawyer_cbu",
      "lawyer_cuit",
      "identification"
    ];
    var agreementBindingDeterminations2 = {
      amount: "compile_time",
      amount_in_words: "compile_time",
      installments: "compile_time",
      fee_percentage: "compile_time",
      payment_days: "compile_time",
      payment_method: "runtime",
      cbu: "runtime",
      cuit: "runtime",
      lawyer_cbu: "runtime",
      lawyer_cuit: "runtime",
      identification: "runtime"
    };
    var defaultAgreementVariableBindings3 = {
      amount: [OFFER_AMOUNT_VARIABLE_NAME3],
      amount_in_words: OFFER_AMOUNT_IN_WORDS_VARIABLE_NAMES,
      installments: [OFFER_INSTALLMENTS_VARIABLE_NAME],
      fee_percentage: [OFFER_FEES_VARIABLE_NAME],
      payment_days: OFFER_PAYMENT_DAYS_VARIABLE_NAMES,
      payment_method: ["M\xE9todo de pago", "Metodo de cobro"],
      cbu: ["CBU"],
      cuit: ["CUIT"],
      lawyer_cbu: ["CBU Letrado"],
      lawyer_cuit: ["CUIT Letrado"],
      // Sin uso en producción todavía: lo introduce el formulario extendido de
      // aceptación (PIRAMID-835).
      identification: ["DNI", "DNI del titular"]
    };
    var agreementBlockKinds = [
      "title",
      "paragraph",
      "clause",
      "key_values",
      "signatures",
      "page_break"
    ];
    var agreementTemplateKinds2 = ["agreement", "offer_message"];
    var AGREEMENT_OFFER_MESSAGE_BLOCK_KINDS = ["title", "paragraph"];
    var AGREEMENT_PLACEHOLDER_OPEN = "\u27E6";
    var AGREEMENT_PLACEHOLDER_CLOSE = "\u27E7";
    var agreementPlaceholderToken2 = (gapClass, key) => `${AGREEMENT_PLACEHOLDER_OPEN}${gapClass}:${key}${AGREEMENT_PLACEHOLDER_CLOSE}`;
    var AGREEMENT_PLACEHOLDER_PATTERN2 = new RegExp(
      `${AGREEMENT_PLACEHOLDER_OPEN}(pending|absent|unknown_key):([A-Za-z0-9_.]+)${AGREEMENT_PLACEHOLDER_CLOSE}`,
      "g"
    );
    var agreementSignerParties3 = [
      "company_sender",
      "victim",
      "claimant",
      "lawyer",
      "heirs"
    ];
    var AGREEMENT_SIGNATURE_BOX_MM = { width: 50, height: 15 };
    var AGREEMENT_SIGNATURE_SLOT_MM = { width: 64 };
    var AGREEMENT_SIGNATURE_TOKEN_PREFIX = "SIG";
    var agreementSignatureToken2 = (key) => `[[${AGREEMENT_SIGNATURE_TOKEN_PREFIX}:${key}]]`;
    var agreementClauseOrdinals2 = [
      "PRIMERA",
      "SEGUNDA",
      "TERCERA",
      "CUARTA",
      "QUINTA",
      "SEXTA",
      "S\xC9PTIMA",
      "OCTAVA",
      "NOVENA",
      "D\xC9CIMA",
      "D\xC9CIMA PRIMERA",
      "D\xC9CIMA SEGUNDA",
      "D\xC9CIMA TERCERA",
      "D\xC9CIMA CUARTA",
      "D\xC9CIMA QUINTA",
      "D\xC9CIMA SEXTA",
      "D\xC9CIMA S\xC9PTIMA",
      "D\xC9CIMA OCTAVA",
      "D\xC9CIMA NOVENA",
      "VIG\xC9SIMA"
    ];
    var import_database48 = require_index_browser4();
    var agreementSignatureMethods2 = ["digital", "in_person"];
    var agreementRuleStages = ["claim", "offer", "accept"];
    var agreementPlanStages2 = ["send", "accept"];
    var agreementRuleAttributeGroups = [
      "claim",
      "offer",
      "acceptance"
    ];
    var agreementRuleAttributeTypes = [
      "boolean",
      "number",
      "enum",
      "enum_list",
      "id",
      "text",
      /** Variable de la plantilla de ofrecimiento, direccionada por nombre. */
      "variable"
    ];
    var agreementRuleOperators3 = [
      "eq",
      "ne",
      "in",
      "not_in",
      "gt",
      "gte",
      "lt",
      "lte",
      "contains_any",
      "contains_all",
      "contains_none",
      "is_empty",
      "exists"
    ];
    var AGREEMENT_RULE_TYPE_OPERATORS = {
      boolean: ["eq"],
      number: ["eq", "ne", "gt", "gte", "lt", "lte"],
      enum: ["eq", "ne", "in", "not_in"],
      enum_list: ["contains_any", "contains_all", "contains_none", "is_empty"],
      id: ["eq", "ne", "in", "not_in"],
      text: ["eq", "ne", "in", "not_in", "exists"],
      variable: ["eq", "ne", "in", "not_in", "exists"]
    };
    var agreementRuleNullSemantics = [
      /** La ausencia es el dato (no hay abogado ⇒ no hay `lawyer_kind`): la condición es falsa. */
      "absent",
      /** Falta el dato (sin fecha de nacimiento no se sabe si es menor): indeterminada. */
      "unknown"
    ];
    var agreementRuleOptionSources2 = [
      "claim_type",
      "message_template",
      "offer_variable",
      "acceptance_variable",
      "team",
      "user"
    ];
    var agreementRuleAttributes = [
      {
        key: "claim.claim_type_id",
        group: "claim",
        type: "id",
        stage: "claim",
        null_semantics: "unknown",
        options: { kind: "remote", source: "claim_type" }
      },
      {
        key: "claim.classification",
        group: "claim",
        type: "enum",
        stage: "claim",
        null_semantics: "unknown",
        options: {
          kind: "enum",
          values: claimTypes5,
          label_prefix: "offer.agreement.claim_classification"
        }
      },
      {
        key: "claim.damage_types",
        group: "claim",
        type: "enum_list",
        stage: "claim",
        options: {
          kind: "enum",
          values: Object.values(import_database48.DamageTypes),
          label_prefix: "damages"
        }
      },
      {
        key: "claim.person_damage_types",
        group: "claim",
        type: "enum_list",
        stage: "claim",
        options: {
          kind: "enum",
          values: Object.values(import_database48.PersonDamageTypes),
          label_prefix: "offer.agreement.person_damage_kind"
        }
      },
      {
        key: "claim.material_damage_types",
        group: "claim",
        type: "enum_list",
        stage: "claim",
        options: {
          kind: "enum",
          values: Object.values(import_database48.MaterialDamageTypes),
          label_prefix: "damages"
        }
      },
      {
        key: "claim.victim_kind",
        group: "claim",
        type: "enum",
        stage: "claim",
        options: {
          kind: "enum",
          values: agreementPersonKinds2,
          label_prefix: "offer.agreement.person_kind"
        }
      },
      {
        key: "claim.victim_is_minor",
        group: "claim",
        type: "boolean",
        stage: "claim",
        null_semantics: "unknown"
      },
      {
        key: "claim.victim_is_deceased",
        group: "claim",
        type: "boolean",
        stage: "claim"
      },
      {
        key: "claim.victim_has_parents",
        group: "claim",
        type: "boolean",
        stage: "claim"
      },
      {
        key: "claim.claimants_count",
        group: "claim",
        type: "number",
        stage: "claim"
      },
      {
        key: "claim.claimant_relationship",
        group: "claim",
        type: "enum",
        stage: "claim",
        null_semantics: "unknown",
        options: {
          kind: "enum",
          values: Object.values(import_database48.VictimRelationshipTypes),
          label_prefix: "victim_relationship"
        }
      },
      {
        key: "claim.claimant_relationships",
        group: "claim",
        type: "enum_list",
        stage: "claim",
        options: {
          kind: "enum",
          values: Object.values(import_database48.VictimRelationshipTypes),
          label_prefix: "victim_relationship"
        }
      },
      {
        key: "claim.claimant_is_victim",
        group: "claim",
        type: "boolean",
        stage: "claim"
      },
      { key: "claim.has_lawyer", group: "claim", type: "boolean", stage: "claim" },
      {
        key: "claim.lawyer_kind",
        group: "claim",
        type: "enum",
        stage: "claim",
        null_semantics: "absent",
        options: {
          kind: "enum",
          values: agreementLawyerKinds3,
          label_prefix: "offer.agreement.lawyer_kind"
        }
      },
      { key: "claim.lawyer_count", group: "claim", type: "number", stage: "claim" },
      { key: "claim.heirs_count", group: "claim", type: "number", stage: "claim" },
      {
        key: "claim.has_external_complaint",
        group: "claim",
        type: "boolean",
        stage: "claim"
      },
      // El equipo y el responsable de hoy (en una derivación, quien la tramita).
      // Sin asignar es un hecho, no un dato faltante: la regla no coincide y no
      // frena a las de abajo.
      {
        key: "claim.team_id",
        group: "claim",
        type: "id",
        stage: "claim",
        null_semantics: "absent",
        options: { kind: "remote", source: "team" }
      },
      {
        key: "claim.responsible_user_id",
        group: "claim",
        type: "id",
        stage: "claim",
        null_semantics: "absent",
        options: { kind: "remote", source: "user", searchable: true }
      },
      {
        key: "offer.message_template_id",
        group: "offer",
        type: "id",
        stage: "offer",
        options: { kind: "remote", source: "message_template" }
      },
      {
        key: "offer.amount",
        group: "offer",
        type: "number",
        stage: "offer",
        null_semantics: "unknown"
      },
      {
        key: "offer.currency",
        group: "offer",
        type: "enum",
        stage: "offer",
        options: {
          kind: "enum",
          values: Object.values(import_database48.CurrencySymbol),
          label_prefix: "offer.agreement.currency"
        }
      },
      /**
       * Sin variable de cuotas el ofrecimiento es de pago único, no un dato
       * faltante; lo mismo para honorarios y plazo. `has_installments` y
       * `has_fees` son la forma directa de preguntar por su existencia.
       */
      {
        key: "offer.installments",
        group: "offer",
        type: "number",
        stage: "offer",
        null_semantics: "absent"
      },
      {
        key: "offer.fee_percentage",
        group: "offer",
        type: "number",
        stage: "offer",
        null_semantics: "absent"
      },
      {
        key: "offer.payment_days",
        group: "offer",
        type: "number",
        stage: "offer",
        null_semantics: "absent"
      },
      {
        key: "offer.has_installments",
        group: "offer",
        type: "boolean",
        stage: "offer"
      },
      { key: "offer.has_fees", group: "offer", type: "boolean", stage: "offer" },
      {
        key: "offer.variable",
        group: "offer",
        type: "variable",
        stage: "offer",
        null_semantics: "unknown",
        options: { kind: "remote", source: "offer_variable" }
      },
      {
        key: "acceptance.complete",
        group: "acceptance",
        type: "boolean",
        stage: "accept"
      },
      {
        key: "acceptance.payment_method",
        group: "acceptance",
        type: "text",
        stage: "accept",
        null_semantics: "unknown"
      },
      {
        key: "acceptance.has_lawyer_bank_data",
        group: "acceptance",
        type: "boolean",
        stage: "accept"
      },
      {
        key: "acceptance.variable",
        group: "acceptance",
        type: "variable",
        stage: "accept",
        null_semantics: "unknown",
        options: { kind: "remote", source: "acceptance_variable" }
      }
    ];
    var agreementRuleAttributeKeys = agreementRuleAttributes.map((attribute) => attribute.key);
    var isAgreementRuleAttributeKey2 = (key) => agreementRuleAttributeKeys.some((candidate) => candidate === key);
    var attributesByKey = new Map(agreementRuleAttributes.map((attribute) => [attribute.key, attribute]));
    var agreementRuleAttribute3 = (key) => attributesByKey.get(key);
    var agreementRuleOptionSourceOf2 = (key) => {
      const { options } = agreementRuleAttribute3(key);
      return (options == null ? void 0 : options.kind) === "remote" ? options.source : null;
    };
    var isAgreementRuleAttributeSearchable = (key) => {
      const { options } = agreementRuleAttribute3(key);
      return (options == null ? void 0 : options.kind) === "remote" && options.searchable === true;
    };
    var agreementRuleOperatorsFor2 = (type) => AGREEMENT_RULE_TYPE_OPERATORS[type];
    var agreementRuleValueShapes = [
      "list",
      "boolean",
      "number",
      "text"
    ];
    var LIST_OPERATORS = [
      "in",
      "not_in",
      "contains_any",
      "contains_all",
      "contains_none"
    ];
    var FLAG_OPERATORS = [
      "is_empty",
      "exists"
    ];
    var NUMBER_OPERATORS = [
      "gt",
      "gte",
      "lt",
      "lte"
    ];
    var agreementRuleValueShapeFor2 = (type, operator) => {
      if (LIST_OPERATORS.includes(operator)) return "list";
      if (FLAG_OPERATORS.includes(operator)) return "boolean";
      if (NUMBER_OPERATORS.includes(operator)) return "number";
      if (type === "boolean") return "boolean";
      return type === "number" ? "number" : "text";
    };
    var AGREEMENT_RULES_TAKE = 200;
    var AGREEMENT_GENERATION_RULE_GROUPS2 = ["claim"];
    var AGREEMENT_SIGNATURE_RULE_GROUPS = ["claim", "offer", "acceptance"];
    var agreementRuleAttributesFor = (groups) => agreementRuleAttributes.filter(
      (attribute) => groups.includes(attribute.group)
    );
    var AGREEMENT_RULE_MAX_CONDITIONS2 = 20;
    var agreementConditionResults2 = [
      "true",
      "false",
      "undetermined"
    ];
    var agreementConditionUndeterminedReasons2 = [
      /** El contexto trae `null` en un atributo cuyo `null` es dato faltante. */
      "unknown_value",
      /** Depende del ofrecimiento y todavía no hay ofrecimiento. */
      "pending_offer",
      /** Depende de la aceptación y todavía no hay aceptación. */
      "pending_acceptance",
      /** La variable de plantilla que nombra la condición no existe en el ofrecimiento. */
      "unknown_variable"
    ];
    var agreementRuleResults2 = [
      "match",
      "no_match",
      "undetermined"
    ];
    var agreementPlanOutcomes2 = [
      "selected",
      /** Hay regla, pero no puede producir un documento (su template no está publicado). */
      "blocked",
      "no_match",
      "undetermined",
      "disabled"
    ];
    var agreementPlanReasons2 = [
      "automation_disabled",
      "no_rules_configured",
      "no_rule_matched",
      "pending_offer",
      "pending_acceptance",
      "missing_context_data",
      "template_not_published",
      "template_deleted"
    ];
    var agreementSignatureOutcomes2 = [
      "selected",
      "undetermined",
      "unresolved"
    ];
    var agreementPlanGapKinds2 = [
      "variable",
      "signer",
      "signature"
    ];
    var agreementPlanRecipientReasons2 = [
      "no_lawyer",
      "no_heirs",
      "no_claimant",
      "no_name",
      "no_email",
      "company_sender_unavailable"
    ];
    var agreementDocumentStatusCodes2 = [
      /** Una variable obligatoria no resolvió: no se imprime un documento legal con huecos. */
      "missing_data",
      /** Un bloque no compila. */
      "syntax_error",
      /** Una cláusula depende de un dato que no se sabe: no se puede decidir si va. */
      "undetermined_condition",
      /** El PDF existe, pero falta el ancla de un recuadro obligatorio: sirve para papel, no para firma digital. */
      "missing_anchors",
      /** La Lambda falló, no respondió o su página no cargó. */
      "render_failed",
      /** El PDF impreso no se pudo leer para ubicar las firmas. */
      "pdf_unreadable",
      /** Quedó `rendering` y el proceso que lo generaba ya no existe. */
      "abandoned"
    ];
    var toAgreementDocumentStatusCode = (value) => agreementDocumentStatusCodes2.find((code) => code === value) ?? null;
    var agreementDocumentResolutions2 = ["frozen", "fresh"];
    var agreementDocumentResolutionFallbacks2 = [
      /** El plan es anterior al congelado (ofrecimiento enviado antes del deploy). */
      "subject_snapshot_missing",
      /** El snapshot no pasa el contrato actual del sujeto. */
      "subject_snapshot_unreadable"
    ];
    var agreementDocumentSignatureSources2 = [
      "plan",
      "acceptance"
    ];
    var offerAgreementGenerationSkipReasons = [
      "offer_not_accepted",
      "automation_disabled",
      "plan_not_found",
      "plan_not_selected",
      /** El reclamo o la oferta dejaron de poder resolverse (no debería pasar con una oferta aceptada). */
      "resolution_failed"
    ];
    var OFFER_AGREEMENT_JOB_LEASE_MS = 4 * 60 * 1e3;
    var OFFER_AGREEMENT_DOCUMENT_POLL_INTERVAL_MS = 5e3;
    var offerAgreementPhases = [
      /** El ofrecimiento se envió con conformidad y espera la respuesta del reclamante. */
      "awaiting_acceptance",
      "generating",
      /** La generación automática terminó sin documento (motivo en el job). */
      "skipped",
      /** El render falló o el job quedó trabado: se puede reintentar. */
      "generation_failed",
      /** El documento no debe imprimirse (datos faltantes, sintaxis, cláusula indeterminada, anclas). */
      "invalid",
      /** Lista para firmar por fuera de AutoSign: presencial, firma apagada o sin método. */
      "ready_offline",
      "dispatching",
      "dispatch_failed",
      "signing",
      "completed",
      "rejected",
      "expired",
      /** Cancelada desde el tablero de AutoSign con el ofrecimiento todavía aceptado. */
      "canceled_by_provider",
      /** Anulada junto con su ofrecimiento. */
      "canceled"
    ];
    var offerAgreementProgressSteps = [
      "acceptance",
      "document",
      "dispatch",
      "signature",
      /** Todos firmaron en AutoSign: el proceso terminó. Solo existe en la firma digital. */
      "completed"
    ];
    var offerAgreementProgressStepStates = [
      "done",
      "current",
      "error",
      "upcoming"
    ];
    var OFFER_AGREEMENT_ACTIVITY_EVENT_TYPES2 = [
      "offer_accepted",
      "offer_canceled",
      "offer_agreement_created",
      "offer_agreement_dispatch_failed",
      "offer_agreement_recipient_submitted",
      "offer_agreement_completed",
      "offer_agreement_rejected",
      "offer_agreement_expired",
      "offer_agreement_cancelled",
      "pending_offer_agreement_response",
      "pending_offer_agreement_response_internal"
    ];
    var claimAgreementAbsenceReasons = [
      "no_offers",
      /** El último ofrecimiento tenía conformidad y se anuló: queda como anterior. */
      "offer_canceled",
      /** Una conformidad del circuito anterior (sin documento propio): se ve en el ofrecimiento. */
      "legacy_agreement",
      /** El último ofrecimiento usa el circuito anterior (plantilla de mensaje). */
      "legacy_offer",
      /** El último ofrecimiento es guiado y ninguna regla de conformidad aplicaba al enviarlo. */
      "sent_without_agreement",
      /** El último ofrecimiento se envió con conformidad pero se cerró sin aceptarse. */
      "offer_not_accepted"
    ];
    var negotiationStageStates = [
      "done",
      "in_progress",
      "attention",
      "pending"
    ];
    var negotiationStages = ["estimates", "offers", "agreement"];
    var negotiationStageReadPermission2 = {
      estimates: "can_read_claim_estimates",
      offers: "can_read_claim_offers",
      agreement: "can_read_claim_agreements"
    };
    var AUTOSIGN_OAUTH_SCOPES3 = [
      "transaction:read",
      "transaction:create",
      "transaction:update",
      "file:create",
      "template:read",
      "profile:read"
    ];
    var AUTOSIGN_REQUEST_TIMEOUT_MS = 15e3;
    var OFFER_AGREEMENT_DISPATCH_BUDGET_MS = 9e4;
    var AUTOSIGN_DOCUMENT_POLL_DELAYS_MS = [
      1e3,
      2e3,
      4e3,
      8e3,
      1e4
    ];
    var AUTOSIGN_MAX_FILE_BYTES = 10 * 1024 * 1024;
    var AUTOSIGN_NOTIFICATION_ENDPOINT_MAX_LENGTH = 255;
    var AUTOSIGN_RECIPIENT_COLORS = [
      "purple",
      "lime",
      "sky",
      "amber",
      "rose",
      "teal",
      "indigo",
      "orange"
    ];
    var AUTOSIGN_SIGNATURE_FIELD_STYLE = {
      font_family: "helvetica",
      font_size: 12,
      font_color: "#000000",
      helper_text: ""
    };
    var autosignConnectionStatuses = [
      "connected",
      "disconnected",
      /** Existe, pero se autorizó con permisos viejos o AutoSign la rechazó: hay que volver a conectar. */
      "reconnect_required"
    ];
    var signatureDispatchBlockerCodes = [
      "sender_connection_missing",
      "sender_connection_reconnect_required",
      /** La firma se decide al aceptar y un firmante obligatorio no tiene email. */
      "signer_email_missing",
      /** Two different signers share an email: AutoSign rejects the request. */
      "signer_email_shared"
    ];
    var offerAgreementDispatchFailureCodes3 = [
      /** El interruptor de firma de la compañía está apagado: el despacho espera. */
      "signature_disabled",
      "claim_closed",
      /** El remitente ya no existe en Piramid. */
      "sender_unavailable",
      "sender_connection_missing",
      "sender_connection_reconnect_required",
      /** El documento final no está listo o no tiene PDF. */
      "document_unavailable",
      /** El PDF guardado no es el que se imprimió: nunca se manda otro documento. */
      "document_mismatch",
      "document_too_large",
      /** Un recuadro obligatorio no tiene a quién mandárselo. */
      "recipient_unresolved",
      "recipient_without_email",
      /** Un recuadro que se manda a firmar no aparece en el PDF. */
      "anchor_missing",
      "no_signers",
      "notification_endpoint_too_long",
      /** AutoSign rechazó el pedido (4xx con detalle). */
      "provider_rejected",
      /** AutoSign no pudo procesar el PDF. */
      "provider_document_failed",
      /** A start requested from another account went unconfirmed: only that account can tell whether it went out. */
      "provider_start_unconfirmed",
      /** AutoSign no respondió, respondió 5xx o 429: la cola reintenta. */
      "provider_unavailable",
      /** AutoSign sigue procesando el PDF: la cola reintenta. */
      "provider_document_processing",
      /** La transacción ya no existe (el borrador se borró en AutoSign): la próxima corrida arma otra. */
      "provider_transaction_missing",
      "unexpected_error"
    ];
    var offerAgreementDispatchFailureKind = {
      signature_disabled: "permanent",
      claim_closed: "permanent",
      sender_unavailable: "permanent",
      sender_connection_missing: "permanent",
      sender_connection_reconnect_required: "permanent",
      document_unavailable: "permanent",
      document_mismatch: "permanent",
      document_too_large: "permanent",
      recipient_unresolved: "permanent",
      recipient_without_email: "permanent",
      anchor_missing: "permanent",
      no_signers: "permanent",
      notification_endpoint_too_long: "permanent",
      provider_rejected: "permanent",
      provider_document_failed: "permanent",
      provider_start_unconfirmed: "permanent",
      provider_unavailable: "transient",
      provider_document_processing: "transient",
      provider_transaction_missing: "transient",
      unexpected_error: "transient"
    };
    var toOfferAgreementDispatchFailureCode = (value) => offerAgreementDispatchFailureCodes3.find((code) => code === value) ?? null;
    var autosignTransactionEventTypes = [
      "transaction_created",
      "transaction_started",
      "recipient_submitted",
      "transaction_completed",
      "transaction_expired",
      "transaction_rejected",
      "transaction_cancelled"
    ];
    var OFFER_AGREEMENT_RECONCILIATION_EVENT_TYPE = "reconciliation";
    var offerAgreementObservationOrigins = [
      "webhook",
      "manual_sync",
      "reconciliation"
    ];
    var OFFER_AGREEMENT_SEALED_DOWNLOAD_TIMEOUT_MS = 3e4;
    var OFFER_AGREEMENT_RECONCILE_AFTER_HOURS = 6;
    var OFFER_AGREEMENT_RECONCILE_BATCH_LIMIT = 300;
    var offerAgreementProviderCancelOutcomes2 = [
      /** AutoSign la canceló (o ya estaba cancelada). */
      "canceled",
      /** Ya estaba cerrada en AutoSign: firmada, rechazada o vencida. */
      "already_closed",
      /** Nunca se inició: un borrador, que nadie ve y AutoSign no cancela. */
      "not_started",
      /** AutoSign ya no la tiene. */
      "transaction_missing",
      /** La cuenta del remitente no está conectada o no tiene permisos. */
      "connection_unavailable",
      /** AutoSign rechazó el pedido por otro motivo. */
      "rejected"
    ];
    var OFFER_AGREEMENT_PROVIDER_CANCEL_RETRY_WINDOW_HOURS2 = 24;
    var offerAgreementProviderCancelStatuses = [
      "in_progress",
      "canceled",
      /** No hacía falta: ya estaba cerrada, nunca salió o AutoSign no la tiene. */
      "not_needed",
      /** No se pudo: hay que cancelarla a mano desde el panel de AutoSign. */
      "failed"
    ];
    var offerAgreementCancelNotices = [
      /** Está en firma en AutoSign: anular también cancela la solicitud. */
      "cancels_signature_request",
      /** Ya se firmó: anular no revierte las firmas. */
      "keeps_signed_document"
    ];
    var offerAgreementTransitionIgnoreReasons = [
      /** El evento es de otra transacción (un borrador huérfano de un intento anterior). */
      "provider_mismatch",
      /** Se anuló en Piramid: la anulación local gana. */
      "agreement_canceled",
      "offer_not_accepted",
      /** Ya terminó: un evento repetido no descarga ni notifica dos veces. */
      "already_terminal"
    ];
    var EMBEDDED_SIGNING_WINDOW_MS = 30 * 6e4;
    var EMBEDDED_SIGNING_POLL_MS = 2e3;
    var EMBEDDED_SIGNING_SIGNED_POLL_MS = 1e4;
    var EMBEDDED_SIGNING_PREPARE_TIMEOUT_MS = 9e4;
    var EMBEDDED_SIGNING_SLOW_NOTICE_MS = 3e4;
    var embeddedSigningStatuses = [
      "preparing",
      "ready",
      "signed",
      "unavailable"
    ];
    var embeddedSigningPreparingStages = ["document", "dispatch"];
    var embeddedSigningUnavailableReasons = [
      "disabled",
      "not_eligible",
      "expired",
      "not_dispatched",
      "dispatch_failed",
      "canceled",
      "url_missing",
      "signer_mismatch"
    ];
    var embeddedSigningIneligibleReasons = [
      "disabled",
      "no_plan",
      "signature_not_enabled",
      "signature_not_digital",
      "no_signer",
      "signer_without_email",
      "owner_without_email",
      "signer_is_not_owner"
    ];
    var agreementCeremonyEntries = [
      "after_acceptance",
      "signing_cta"
    ];
    var agreementSignatureOrigins = [
      "piramid_after_acceptance",
      "piramid_signing_cta",
      "external"
    ];
    var AGREEMENT_SIGNATURE_ORIGIN_BY_CEREMONY_ENTRY2 = {
      after_acceptance: "piramid_after_acceptance",
      signing_cta: "piramid_signing_cta"
    };
    var AGREEMENT_CEREMONY_WINDOW_GAP_MS = 3e4;
    var AGREEMENT_SIGNATURE_ORIGIN_GRACE_MS2 = 6e4;
    var ALERT_ENVIRONMENT_TAG2 = "ALERT_ENVIRONMENT_TAG";
    var alertEnvironmentTags2 = ["QA"];
    var PUBLIC_ASSETS_BASE_URL2 = "PUBLIC_ASSETS_BASE_URL";
    var legacyPublicAssetsBaseUrls = [
      "https://piramid-public.s3.us-east-1.amazonaws.com",
      "https://piramid-public.s3.amazonaws.com"
    ];
    var withPublicAssetsBaseUrl = (content, baseUrl) => {
      if (!baseUrl) return content;
      const base = baseUrl.replace(/\/+$/, "");
      return legacyPublicAssetsBaseUrls.reduce(
        (rewritten, legacyBaseUrl) => rewritten.split(`${legacyBaseUrl}/`).join(`${base}/`),
        content
      );
    };
    var openAIDecisionQueries = ["email_name_match"];
    var OPENAI_DECISIONS_MODEL = "gpt-6-luna";
    var OPENAI_DECISIONS_URL = "https://api.openai.com/v1/decisions";
    var OPENAI_DECISIONS_TIMEOUT_MS = 8e3;
    var emailNameMatchTiers = ["strong", "partial", "weak"];
    var EMAIL_NAME_MATCH_TIER_MIN_PROBABILITY = {
      strong: 0.8,
      partial: 0.5,
      weak: 0
    };
    var USER_TYPE_COOKIE_NAME = "user_type";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var init_typeof = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/typeof.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/_lib/toInteger/index.js
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
var init_toInteger = __esm({
  "../../node_modules/date-fns/esm/_lib/toInteger/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
var init_requiredArgs = __esm({
  "../../node_modules/date-fns/esm/_lib/requiredArgs/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/toDate/index.js
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
var init_toDate = __esm({
  "../../node_modules/date-fns/esm/toDate/index.js"() {
    "use strict";
    init_typeof();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addDays/index.js
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}
var init_addDays = __esm({
  "../../node_modules/date-fns/esm/addDays/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addMonths/index.js
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date;
  }
  var dayOfMonth = date.getDate();
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
var init_addMonths = __esm({
  "../../node_modules/date-fns/esm/addMonths/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/add/index.js
function add(dirtyDate, duration) {
  requiredArgs(2, arguments);
  if (!duration || _typeof(duration) !== "object") return /* @__PURE__ */ new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0;
  var months2 = duration.months ? toInteger(duration.months) : 0;
  var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
  var days2 = duration.days ? toInteger(duration.days) : 0;
  var hours = duration.hours ? toInteger(duration.hours) : 0;
  var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
  var seconds = duration.seconds ? toInteger(duration.seconds) : 0;
  var date = toDate(dirtyDate);
  var dateWithMonths = months2 || years ? addMonths(date, months2 + years * 12) : date;
  var dateWithDays = days2 || weeks ? addDays(dateWithMonths, days2 + weeks * 7) : dateWithMonths;
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1e3;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
var init_add = __esm({
  "../../node_modules/date-fns/esm/add/index.js"() {
    "use strict";
    init_typeof();
    init_addDays();
    init_addMonths();
    init_toDate();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/isWeekend/index.js
function isWeekend(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day === 0 || day === 6;
}
var init_isWeekend = __esm({
  "../../node_modules/date-fns/esm/isWeekend/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSunday/index.js
function isSunday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 0;
}
var init_isSunday = __esm({
  "../../node_modules/date-fns/esm/isSunday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSaturday/index.js
function isSaturday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 6;
}
var init_isSaturday = __esm({
  "../../node_modules/date-fns/esm/isSaturday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addBusinessDays/index.js
function addBusinessDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var startedOnWeekend = isWeekend(date);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) return /* @__PURE__ */ new Date(NaN);
  var hours = date.getHours();
  var sign = amount < 0 ? -1 : 1;
  var fullWeeks = toInteger(amount / 5);
  date.setDate(date.getDate() + fullWeeks * 7);
  var restDays = Math.abs(amount % 5);
  while (restDays > 0) {
    date.setDate(date.getDate() + sign);
    if (!isWeekend(date)) restDays -= 1;
  }
  if (startedOnWeekend && isWeekend(date) && amount !== 0) {
    if (isSaturday(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
    if (isSunday(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
  }
  date.setHours(hours);
  return date;
}
var init_addBusinessDays = __esm({
  "../../node_modules/date-fns/esm/addBusinessDays/index.js"() {
    "use strict";
    init_isWeekend();
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_isSunday();
    init_isSaturday();
  }
});

// ../../node_modules/date-fns/esm/addMilliseconds/index.js
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
var init_addMilliseconds = __esm({
  "../../node_modules/date-fns/esm/addMilliseconds/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addHours/index.js
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
var MILLISECONDS_IN_HOUR;
var init_addHours = __esm({
  "../../node_modules/date-fns/esm/addHours/index.js"() {
    "use strict";
    init_toInteger();
    init_addMilliseconds();
    init_requiredArgs();
    MILLISECONDS_IN_HOUR = 36e5;
  }
});

// ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}
var defaultOptions;
var init_defaultOptions = __esm({
  "../../node_modules/date-fns/esm/_lib/defaultOptions/index.js"() {
    "use strict";
    defaultOptions = {};
  }
});

// ../../node_modules/date-fns/esm/startOfWeek/index.js
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfWeek = __esm({
  "../../node_modules/date-fns/esm/startOfWeek/index.js"() {
    "use strict";
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/startOfISOWeek/index.js
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
var init_startOfISOWeek = __esm({
  "../../node_modules/date-fns/esm/startOfISOWeek/index.js"() {
    "use strict";
    init_startOfWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getISOWeekYear/index.js
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
var init_getISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/getISOWeekYear/index.js"() {
    "use strict";
    init_toDate();
    init_startOfISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfISOWeekYear/index.js
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}
var init_startOfISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/startOfISOWeekYear/index.js"() {
    "use strict";
    init_getISOWeekYear();
    init_startOfISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
var init_getTimezoneOffsetInMilliseconds = __esm({
  "../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/startOfDay/index.js
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfDay = __esm({
  "../../node_modules/date-fns/esm/startOfDay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
var MILLISECONDS_IN_DAY;
var init_differenceInCalendarDays = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarDays/index.js"() {
    "use strict";
    init_getTimezoneOffsetInMilliseconds();
    init_startOfDay();
    init_requiredArgs();
    MILLISECONDS_IN_DAY = 864e5;
  }
});

// ../../node_modules/date-fns/esm/setISOWeekYear/index.js
function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeekYear = toInteger(dirtyISOWeekYear);
  var diff = differenceInCalendarDays(date, startOfISOWeekYear(date));
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  date = startOfISOWeekYear(fourthOfJanuary);
  date.setDate(date.getDate() + diff);
  return date;
}
var init_setISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/setISOWeekYear/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_startOfISOWeekYear();
    init_differenceInCalendarDays();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addISOWeekYears/index.js
function addISOWeekYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return setISOWeekYear(dirtyDate, getISOWeekYear(dirtyDate) + amount);
}
var init_addISOWeekYears = __esm({
  "../../node_modules/date-fns/esm/addISOWeekYears/index.js"() {
    "use strict";
    init_toInteger();
    init_getISOWeekYear();
    init_setISOWeekYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addMinutes/index.js
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
var MILLISECONDS_IN_MINUTE;
var init_addMinutes = __esm({
  "../../node_modules/date-fns/esm/addMinutes/index.js"() {
    "use strict";
    init_toInteger();
    init_addMilliseconds();
    init_requiredArgs();
    MILLISECONDS_IN_MINUTE = 6e4;
  }
});

// ../../node_modules/date-fns/esm/addQuarters/index.js
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var months2 = amount * 3;
  return addMonths(dirtyDate, months2);
}
var init_addQuarters = __esm({
  "../../node_modules/date-fns/esm/addQuarters/index.js"() {
    "use strict";
    init_toInteger();
    init_addMonths();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addSeconds/index.js
function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1e3);
}
var init_addSeconds = __esm({
  "../../node_modules/date-fns/esm/addSeconds/index.js"() {
    "use strict";
    init_toInteger();
    init_addMilliseconds();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addWeeks/index.js
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days2 = amount * 7;
  return addDays(dirtyDate, days2);
}
var init_addWeeks = __esm({
  "../../node_modules/date-fns/esm/addWeeks/index.js"() {
    "use strict";
    init_toInteger();
    init_addDays();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/addYears/index.js
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
var init_addYears = __esm({
  "../../node_modules/date-fns/esm/addYears/index.js"() {
    "use strict";
    init_toInteger();
    init_addMonths();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/areIntervalsOverlapping/index.js
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
  requiredArgs(2, arguments);
  var leftStartTime = toDate(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
  var leftEndTime = toDate(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
  var rightStartTime = toDate(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
  var rightEndTime = toDate(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime();
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError("Invalid interval");
  }
  if (options !== null && options !== void 0 && options.inclusive) {
    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
  }
  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}
var init_areIntervalsOverlapping = __esm({
  "../../node_modules/date-fns/esm/areIntervalsOverlapping/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/max/index.js
function max(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
var init_max = __esm({
  "../../node_modules/date-fns/esm/max/index.js"() {
    "use strict";
    init_typeof();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/min/index.js
function min(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else if (_typeof(dirtyDatesArray) === "object" && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
  var result;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === void 0 || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || /* @__PURE__ */ new Date(NaN);
}
var init_min = __esm({
  "../../node_modules/date-fns/esm/min/index.js"() {
    "use strict";
    init_typeof();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/clamp/index.js
function clamp(date, _ref) {
  var start = _ref.start, end = _ref.end;
  requiredArgs(2, arguments);
  return min([max([date, start]), end]);
}
var init_clamp = __esm({
  "../../node_modules/date-fns/esm/clamp/index.js"() {
    "use strict";
    init_max();
    init_min();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/closestIndexTo/index.js
function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
  requiredArgs(2, arguments);
  var dateToCompare = toDate(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return NaN;
  var timeToCompare = dateToCompare.getTime();
  var datesArray;
  if (dirtyDatesArray == null) {
    datesArray = [];
  } else if (typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }
  var result;
  var minDistance;
  datesArray.forEach(function(dirtyDate, index) {
    var currentDate = toDate(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = NaN;
      minDistance = NaN;
      return;
    }
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < Number(minDistance)) {
      result = index;
      minDistance = distance;
    }
  });
  return result;
}
var init_closestIndexTo = __esm({
  "../../node_modules/date-fns/esm/closestIndexTo/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/closestTo/index.js
function closestTo(dirtyDateToCompare, dirtyDatesArray) {
  requiredArgs(2, arguments);
  var dateToCompare = toDate(dirtyDateToCompare);
  if (isNaN(Number(dateToCompare))) return /* @__PURE__ */ new Date(NaN);
  var timeToCompare = dateToCompare.getTime();
  var datesArray;
  if (dirtyDatesArray == null) {
    datesArray = [];
  } else if (typeof dirtyDatesArray.forEach === "function") {
    datesArray = dirtyDatesArray;
  } else {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  }
  var result;
  var minDistance;
  datesArray.forEach(function(dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (isNaN(Number(currentDate))) {
      result = /* @__PURE__ */ new Date(NaN);
      minDistance = NaN;
      return;
    }
    var distance = Math.abs(timeToCompare - currentDate.getTime());
    if (result == null || distance < Number(minDistance)) {
      result = currentDate;
      minDistance = distance;
    }
  });
  return result;
}
var init_closestTo = __esm({
  "../../node_modules/date-fns/esm/closestTo/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/compareAsc/index.js
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
var init_compareAsc = __esm({
  "../../node_modules/date-fns/esm/compareAsc/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/compareDesc/index.js
function compareDesc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff > 0) {
    return -1;
  } else if (diff < 0) {
    return 1;
  } else {
    return diff;
  }
}
var init_compareDesc = __esm({
  "../../node_modules/date-fns/esm/compareDesc/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/constants/index.js
var daysInWeek, daysInYear, maxTime, millisecondsInMinute, millisecondsInHour, millisecondsInSecond, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter;
var init_constants = __esm({
  "../../node_modules/date-fns/esm/constants/index.js"() {
    "use strict";
    daysInWeek = 7;
    daysInYear = 365.2425;
    maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
    millisecondsInMinute = 6e4;
    millisecondsInHour = 36e5;
    millisecondsInSecond = 1e3;
    minTime = -maxTime;
    minutesInHour = 60;
    monthsInQuarter = 3;
    monthsInYear = 12;
    quartersInYear = 4;
    secondsInHour = 3600;
    secondsInMinute = 60;
    secondsInDay = secondsInHour * 24;
    secondsInWeek = secondsInDay * 7;
    secondsInYear = secondsInDay * daysInYear;
    secondsInMonth = secondsInYear / 12;
    secondsInQuarter = secondsInMonth * 3;
  }
});

// ../../node_modules/date-fns/esm/daysToWeeks/index.js
function daysToWeeks(days2) {
  requiredArgs(1, arguments);
  var weeks = days2 / daysInWeek;
  return Math.floor(weeks);
}
var init_daysToWeeks = __esm({
  "../../node_modules/date-fns/esm/daysToWeeks/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/isSameDay/index.js
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
var init_isSameDay = __esm({
  "../../node_modules/date-fns/esm/isSameDay/index.js"() {
    "use strict";
    init_startOfDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isDate/index.js
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var init_isDate = __esm({
  "../../node_modules/date-fns/esm/isDate/index.js"() {
    "use strict";
    init_typeof();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isValid/index.js
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}
var init_isValid = __esm({
  "../../node_modules/date-fns/esm/isValid/index.js"() {
    "use strict";
    init_isDate();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInBusinessDays/index.js
function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  if (!isValid(dateLeft) || !isValid(dateRight)) return NaN;
  var calendarDifference = differenceInCalendarDays(dateLeft, dateRight);
  var sign = calendarDifference < 0 ? -1 : 1;
  var weeks = toInteger(calendarDifference / 7);
  var result = weeks * 5;
  dateRight = addDays(dateRight, weeks * 7);
  while (!isSameDay(dateLeft, dateRight)) {
    result += isWeekend(dateRight) ? 0 : sign;
    dateRight = addDays(dateRight, sign);
  }
  return result === 0 ? 0 : result;
}
var init_differenceInBusinessDays = __esm({
  "../../node_modules/date-fns/esm/differenceInBusinessDays/index.js"() {
    "use strict";
    init_addDays();
    init_differenceInCalendarDays();
    init_isSameDay();
    init_isValid();
    init_isWeekend();
    init_toDate();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js
function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  return getISOWeekYear(dirtyDateLeft) - getISOWeekYear(dirtyDateRight);
}
var init_differenceInCalendarISOWeekYears = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarISOWeekYears/index.js"() {
    "use strict";
    init_getISOWeekYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js
function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft);
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight);
  var timestampLeft = startOfISOWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfISOWeekLeft);
  var timestampRight = startOfISOWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfISOWeekRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}
var MILLISECONDS_IN_WEEK;
var init_differenceInCalendarISOWeeks = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarISOWeeks/index.js"() {
    "use strict";
    init_getTimezoneOffsetInMilliseconds();
    init_startOfISOWeek();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarMonths/index.js
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
var init_differenceInCalendarMonths = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarMonths/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getQuarter/index.js
function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}
var init_getQuarter = __esm({
  "../../node_modules/date-fns/esm/getQuarter/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarQuarters/index.js
function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight);
  return yearDiff * 4 + quarterDiff;
}
var init_differenceInCalendarQuarters = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarQuarters/index.js"() {
    "use strict";
    init_getQuarter();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarWeeks/index.js
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, options);
  var startOfWeekRight = startOfWeek(dirtyDateRight, options);
  var timestampLeft = startOfWeekLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - getTimezoneOffsetInMilliseconds(startOfWeekRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK2);
}
var MILLISECONDS_IN_WEEK2;
var init_differenceInCalendarWeeks = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarWeeks/index.js"() {
    "use strict";
    init_startOfWeek();
    init_getTimezoneOffsetInMilliseconds();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK2 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/differenceInCalendarYears/index.js
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
var init_differenceInCalendarYears = __esm({
  "../../node_modules/date-fns/esm/differenceInCalendarYears/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInDays/index.js
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
var init_differenceInDays = __esm({
  "../../node_modules/date-fns/esm/differenceInDays/index.js"() {
    "use strict";
    init_toDate();
    init_differenceInCalendarDays();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInMilliseconds/index.js
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
var init_differenceInMilliseconds = __esm({
  "../../node_modules/date-fns/esm/differenceInMilliseconds/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/_lib/roundingMethods/index.js
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
var roundingMap, defaultRoundingMethod;
var init_roundingMethods = __esm({
  "../../node_modules/date-fns/esm/_lib/roundingMethods/index.js"() {
    "use strict";
    roundingMap = {
      ceil: Math.ceil,
      round: Math.round,
      floor: Math.floor,
      trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
      }
      // Math.trunc is not supported by IE
    };
    defaultRoundingMethod = "trunc";
  }
});

// ../../node_modules/date-fns/esm/differenceInHours/index.js
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
var init_differenceInHours = __esm({
  "../../node_modules/date-fns/esm/differenceInHours/index.js"() {
    "use strict";
    init_constants();
    init_differenceInMilliseconds();
    init_requiredArgs();
    init_roundingMethods();
  }
});

// ../../node_modules/date-fns/esm/subISOWeekYears/index.js
function subISOWeekYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addISOWeekYears(dirtyDate, -amount);
}
var init_subISOWeekYears = __esm({
  "../../node_modules/date-fns/esm/subISOWeekYears/index.js"() {
    "use strict";
    init_addISOWeekYears();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/differenceInISOWeekYears/index.js
function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarISOWeekYears(dateLeft, dateRight));
  dateLeft = subISOWeekYears(dateLeft, sign * difference);
  var isLastISOWeekYearNotFull = Number(compareAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastISOWeekYearNotFull);
  return result === 0 ? 0 : result;
}
var init_differenceInISOWeekYears = __esm({
  "../../node_modules/date-fns/esm/differenceInISOWeekYears/index.js"() {
    "use strict";
    init_toDate();
    init_differenceInCalendarISOWeekYears();
    init_compareAsc();
    init_subISOWeekYears();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInMinutes/index.js
function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
var init_differenceInMinutes = __esm({
  "../../node_modules/date-fns/esm/differenceInMinutes/index.js"() {
    "use strict";
    init_constants();
    init_differenceInMilliseconds();
    init_requiredArgs();
    init_roundingMethods();
  }
});

// ../../node_modules/date-fns/esm/endOfDay/index.js
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfDay = __esm({
  "../../node_modules/date-fns/esm/endOfDay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfMonth/index.js
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfMonth = __esm({
  "../../node_modules/date-fns/esm/endOfMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isLastDayOfMonth/index.js
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
var init_isLastDayOfMonth = __esm({
  "../../node_modules/date-fns/esm/isLastDayOfMonth/index.js"() {
    "use strict";
    init_toDate();
    init_endOfDay();
    init_endOfMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/differenceInMonths/index.js
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign * (difference - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
var init_differenceInMonths = __esm({
  "../../node_modules/date-fns/esm/differenceInMonths/index.js"() {
    "use strict";
    init_toDate();
    init_differenceInCalendarMonths();
    init_compareAsc();
    init_requiredArgs();
    init_isLastDayOfMonth();
  }
});

// ../../node_modules/date-fns/esm/differenceInQuarters/index.js
function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
var init_differenceInQuarters = __esm({
  "../../node_modules/date-fns/esm/differenceInQuarters/index.js"() {
    "use strict";
    init_differenceInMonths();
    init_requiredArgs();
    init_roundingMethods();
  }
});

// ../../node_modules/date-fns/esm/differenceInSeconds/index.js
function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
var init_differenceInSeconds = __esm({
  "../../node_modules/date-fns/esm/differenceInSeconds/index.js"() {
    "use strict";
    init_differenceInMilliseconds();
    init_requiredArgs();
    init_roundingMethods();
  }
});

// ../../node_modules/date-fns/esm/differenceInWeeks/index.js
function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}
var init_differenceInWeeks = __esm({
  "../../node_modules/date-fns/esm/differenceInWeeks/index.js"() {
    "use strict";
    init_differenceInDays();
    init_requiredArgs();
    init_roundingMethods();
  }
});

// ../../node_modules/date-fns/esm/differenceInYears/index.js
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
var init_differenceInYears = __esm({
  "../../node_modules/date-fns/esm/differenceInYears/index.js"() {
    "use strict";
    init_toDate();
    init_differenceInCalendarYears();
    init_compareAsc();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachDayOfInterval/index.js
function eachDayOfInterval(dirtyInterval, options) {
  var _options$step;
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }
  return dates;
}
var init_eachDayOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachDayOfInterval/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachHourOfInterval/index.js
function eachHourOfInterval(dirtyInterval, options) {
  var _options$step;
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setMinutes(0, 0, 0);
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number greater than 1");
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addHours(currentDate, step);
  }
  return dates;
}
var init_eachHourOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachHourOfInterval/index.js"() {
    "use strict";
    init_addHours();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfMinute/index.js
function startOfMinute(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setSeconds(0, 0);
  return date;
}
var init_startOfMinute = __esm({
  "../../node_modules/date-fns/esm/startOfMinute/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachMinuteOfInterval/index.js
function eachMinuteOfInterval(interval, options) {
  var _options$step;
  requiredArgs(1, arguments);
  var startDate = startOfMinute(toDate(interval.start));
  var endDate = toDate(interval.end);
  var startTime = startDate.getTime();
  var endTime = endDate.getTime();
  if (startTime >= endTime) {
    throw new RangeError("Invalid interval");
  }
  var dates = [];
  var currentDate = startDate;
  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step < 1 || isNaN(step)) throw new RangeError("`options.step` must be a number equal to or greater than 1");
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addMinutes(currentDate, step);
  }
  return dates;
}
var init_eachMinuteOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachMinuteOfInterval/index.js"() {
    "use strict";
    init_addMinutes();
    init_toDate();
    init_startOfMinute();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachMonthOfInterval/index.js
function eachMonthOfInterval(dirtyInterval) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  var dates = [];
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setDate(1);
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setMonth(currentDate.getMonth() + 1);
  }
  return dates;
}
var init_eachMonthOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachMonthOfInterval/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfQuarter/index.js
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfQuarter = __esm({
  "../../node_modules/date-fns/esm/startOfQuarter/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachQuarterOfInterval/index.js
function eachQuarterOfInterval(dirtyInterval) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var startDateQuarter = startOfQuarter(startDate);
  var endDateQuarter = startOfQuarter(endDate);
  endTime = endDateQuarter.getTime();
  var quarters = [];
  var currentQuarter = startDateQuarter;
  while (currentQuarter.getTime() <= endTime) {
    quarters.push(toDate(currentQuarter));
    currentQuarter = addQuarters(currentQuarter, 1);
  }
  return quarters;
}
var init_eachQuarterOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachQuarterOfInterval/index.js"() {
    "use strict";
    init_addQuarters();
    init_startOfQuarter();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachWeekOfInterval/index.js
function eachWeekOfInterval(dirtyInterval, options) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var startDateWeek = startOfWeek(startDate, options);
  var endDateWeek = startOfWeek(endDate, options);
  startDateWeek.setHours(15);
  endDateWeek.setHours(15);
  endTime = endDateWeek.getTime();
  var weeks = [];
  var currentWeek = startDateWeek;
  while (currentWeek.getTime() <= endTime) {
    currentWeek.setHours(0);
    weeks.push(toDate(currentWeek));
    currentWeek = addWeeks(currentWeek, 1);
    currentWeek.setHours(15);
  }
  return weeks;
}
var init_eachWeekOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachWeekOfInterval/index.js"() {
    "use strict";
    init_addWeeks();
    init_startOfWeek();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachWeekendOfInterval/index.js
function eachWeekendOfInterval(interval) {
  requiredArgs(1, arguments);
  var dateInterval = eachDayOfInterval(interval);
  var weekends = [];
  var index = 0;
  while (index < dateInterval.length) {
    var date = dateInterval[index++];
    if (isWeekend(date)) {
      weekends.push(date);
      if (isSunday(date)) index = index + 5;
    }
  }
  return weekends;
}
var init_eachWeekendOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachWeekendOfInterval/index.js"() {
    "use strict";
    init_eachDayOfInterval();
    init_isSunday();
    init_isWeekend();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfMonth/index.js
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfMonth = __esm({
  "../../node_modules/date-fns/esm/startOfMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachWeekendOfMonth/index.js
function eachWeekendOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var startDate = startOfMonth(dirtyDate);
  if (isNaN(startDate.getTime())) throw new RangeError("The passed date is invalid");
  var endDate = endOfMonth(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
var init_eachWeekendOfMonth = __esm({
  "../../node_modules/date-fns/esm/eachWeekendOfMonth/index.js"() {
    "use strict";
    init_eachWeekendOfInterval();
    init_startOfMonth();
    init_endOfMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfYear/index.js
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfYear = __esm({
  "../../node_modules/date-fns/esm/endOfYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfYear/index.js
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfYear = __esm({
  "../../node_modules/date-fns/esm/startOfYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachWeekendOfYear/index.js
function eachWeekendOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var startDate = startOfYear(dirtyDate);
  var endDate = endOfYear(dirtyDate);
  return eachWeekendOfInterval({
    start: startDate,
    end: endDate
  });
}
var init_eachWeekendOfYear = __esm({
  "../../node_modules/date-fns/esm/eachWeekendOfYear/index.js"() {
    "use strict";
    init_eachWeekendOfInterval();
    init_endOfYear();
    init_startOfYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/eachYearOfInterval/index.js
function eachYearOfInterval(dirtyInterval) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  currentDate.setMonth(0, 1);
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setFullYear(currentDate.getFullYear() + 1);
  }
  return dates;
}
var init_eachYearOfInterval = __esm({
  "../../node_modules/date-fns/esm/eachYearOfInterval/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfDecade/index.js
function endOfDecade(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade, 11, 31);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfDecade = __esm({
  "../../node_modules/date-fns/esm/endOfDecade/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfHour/index.js
function endOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(59, 59, 999);
  return date;
}
var init_endOfHour = __esm({
  "../../node_modules/date-fns/esm/endOfHour/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfWeek/index.js
function endOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfWeek = __esm({
  "../../node_modules/date-fns/esm/endOfWeek/index.js"() {
    "use strict";
    init_defaultOptions();
    init_toDate();
    init_toInteger();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfISOWeek/index.js
function endOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return endOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
var init_endOfISOWeek = __esm({
  "../../node_modules/date-fns/esm/endOfISOWeek/index.js"() {
    "use strict";
    init_endOfWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfISOWeekYear/index.js
function endOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear);
  date.setMilliseconds(date.getMilliseconds() - 1);
  return date;
}
var init_endOfISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/endOfISOWeekYear/index.js"() {
    "use strict";
    init_getISOWeekYear();
    init_startOfISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfMinute/index.js
function endOfMinute(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setSeconds(59, 999);
  return date;
}
var init_endOfMinute = __esm({
  "../../node_modules/date-fns/esm/endOfMinute/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfQuarter/index.js
function endOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfQuarter = __esm({
  "../../node_modules/date-fns/esm/endOfQuarter/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfSecond/index.js
function endOfSecond(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMilliseconds(999);
  return date;
}
var init_endOfSecond = __esm({
  "../../node_modules/date-fns/esm/endOfSecond/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/endOfToday/index.js
function endOfToday() {
  return endOfDay(Date.now());
}
var init_endOfToday = __esm({
  "../../node_modules/date-fns/esm/endOfToday/index.js"() {
    "use strict";
    init_endOfDay();
  }
});

// ../../node_modules/date-fns/esm/endOfTomorrow/index.js
function endOfTomorrow() {
  var now = /* @__PURE__ */ new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfTomorrow = __esm({
  "../../node_modules/date-fns/esm/endOfTomorrow/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/endOfYesterday/index.js
function endOfYesterday() {
  var now = /* @__PURE__ */ new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(23, 59, 59, 999);
  return date;
}
var init_endOfYesterday = __esm({
  "../../node_modules/date-fns/esm/endOfYesterday/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/subMilliseconds/index.js
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var init_subMilliseconds = __esm({
  "../../node_modules/date-fns/esm/subMilliseconds/index.js"() {
    "use strict";
    init_addMilliseconds();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY2) + 1;
}
var MILLISECONDS_IN_DAY2;
var init_getUTCDayOfYear = __esm({
  "../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    MILLISECONDS_IN_DAY2 = 864e5;
  }
});

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
var init_startOfUTCISOWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
var init_getUTCISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    init_startOfUTCISOWeek();
  }
});

// ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}
var init_startOfUTCISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js"() {
    "use strict";
    init_getUTCISOWeekYear();
    init_startOfUTCISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK3) + 1;
}
var MILLISECONDS_IN_WEEK3;
var init_getUTCISOWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js"() {
    "use strict";
    init_toDate();
    init_startOfUTCISOWeek();
    init_startOfUTCISOWeekYear();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK3 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
var init_startOfUTCWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    init_toInteger();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
var init_getUTCWeekYear = __esm({
  "../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    init_startOfUTCWeek();
    init_toInteger();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}
var init_startOfUTCWeekYear = __esm({
  "../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js"() {
    "use strict";
    init_getUTCWeekYear();
    init_requiredArgs();
    init_startOfUTCWeek();
    init_toInteger();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK4) + 1;
}
var MILLISECONDS_IN_WEEK4;
var init_getUTCWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js"() {
    "use strict";
    init_toDate();
    init_startOfUTCWeek();
    init_startOfUTCWeekYear();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK4 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? "-" : "";
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign + output;
}
var init_addLeadingZeros = __esm({
  "../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js
var formatters, lightFormatters_default;
var init_lightFormatters = __esm({
  "../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js"() {
    "use strict";
    init_addLeadingZeros();
    formatters = {
      // Year
      y: function y(date, token) {
        var signedYear = date.getUTCFullYear();
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
      },
      // Month
      M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
      },
      // Day of the month
      d: function d(date, token) {
        return addLeadingZeros(date.getUTCDate(), token.length);
      },
      // AM or PM
      a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return dayPeriodEnumValue.toUpperCase();
          case "aaa":
            return dayPeriodEnumValue;
          case "aaaaa":
            return dayPeriodEnumValue[0];
          case "aaaa":
          default:
            return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
      },
      // Hour [1-12]
      h: function h(date, token) {
        return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
      },
      // Hour [0-23]
      H: function H(date, token) {
        return addLeadingZeros(date.getUTCHours(), token.length);
      },
      // Minute
      m: function m(date, token) {
        return addLeadingZeros(date.getUTCMinutes(), token.length);
      },
      // Second
      s: function s(date, token) {
        return addLeadingZeros(date.getUTCSeconds(), token.length);
      },
      // Fraction of second
      S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds2 = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds2 * Math.pow(10, numberOfDigits - 3));
        return addLeadingZeros(fractionalSeconds, token.length);
      }
    };
    lightFormatters_default = formatters;
  }
});

// ../../node_modules/date-fns/esm/_lib/format/formatters/index.js
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || "";
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? "-" : "+";
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || "";
  var sign = offset > 0 ? "-" : "+";
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var dayPeriodEnum, formatters2, formatters_default;
var init_formatters = __esm({
  "../../node_modules/date-fns/esm/_lib/format/formatters/index.js"() {
    "use strict";
    init_getUTCDayOfYear();
    init_getUTCISOWeek();
    init_getUTCISOWeekYear();
    init_getUTCWeek();
    init_getUTCWeekYear();
    init_addLeadingZeros();
    init_lightFormatters();
    dayPeriodEnum = {
      am: "am",
      pm: "pm",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    };
    formatters2 = {
      // Era
      G: function G(date, token, localize84) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch (token) {
          // AD, BC
          case "G":
          case "GG":
          case "GGG":
            return localize84.era(era, {
              width: "abbreviated"
            });
          // A, B
          case "GGGGG":
            return localize84.era(era, {
              width: "narrow"
            });
          // Anno Domini, Before Christ
          case "GGGG":
          default:
            return localize84.era(era, {
              width: "wide"
            });
        }
      },
      // Year
      y: function y2(date, token, localize84) {
        if (token === "yo") {
          var signedYear = date.getUTCFullYear();
          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return localize84.ordinalNumber(year, {
            unit: "year"
          });
        }
        return lightFormatters_default.y(date, token);
      },
      // Local week-numbering year
      Y: function Y(date, token, localize84, options) {
        var signedWeekYear = getUTCWeekYear(date, options);
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        if (token === "YY") {
          var twoDigitYear = weekYear % 100;
          return addLeadingZeros(twoDigitYear, 2);
        }
        if (token === "Yo") {
          return localize84.ordinalNumber(weekYear, {
            unit: "year"
          });
        }
        return addLeadingZeros(weekYear, token.length);
      },
      // ISO week-numbering year
      R: function R(date, token) {
        var isoWeekYear = getUTCISOWeekYear(date);
        return addLeadingZeros(isoWeekYear, token.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function u(date, token) {
        var year = date.getUTCFullYear();
        return addLeadingZeros(year, token.length);
      },
      // Quarter
      Q: function Q(date, token, localize84) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "Q":
            return String(quarter);
          // 01, 02, 03, 04
          case "QQ":
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "Qo":
            return localize84.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "QQQ":
            return localize84.quarter(quarter, {
              width: "abbreviated",
              context: "formatting"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "QQQQQ":
            return localize84.quarter(quarter, {
              width: "narrow",
              context: "formatting"
            });
          // 1st quarter, 2nd quarter, ...
          case "QQQQ":
          default:
            return localize84.quarter(quarter, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone quarter
      q: function q(date, token, localize84) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "q":
            return String(quarter);
          // 01, 02, 03, 04
          case "qq":
            return addLeadingZeros(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "qo":
            return localize84.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "qqq":
            return localize84.quarter(quarter, {
              width: "abbreviated",
              context: "standalone"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "qqqqq":
            return localize84.quarter(quarter, {
              width: "narrow",
              context: "standalone"
            });
          // 1st quarter, 2nd quarter, ...
          case "qqqq":
          default:
            return localize84.quarter(quarter, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Month
      M: function M2(date, token, localize84) {
        var month = date.getUTCMonth();
        switch (token) {
          case "M":
          case "MM":
            return lightFormatters_default.M(date, token);
          // 1st, 2nd, ..., 12th
          case "Mo":
            return localize84.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "MMM":
            return localize84.month(month, {
              width: "abbreviated",
              context: "formatting"
            });
          // J, F, ..., D
          case "MMMMM":
            return localize84.month(month, {
              width: "narrow",
              context: "formatting"
            });
          // January, February, ..., December
          case "MMMM":
          default:
            return localize84.month(month, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone month
      L: function L(date, token, localize84) {
        var month = date.getUTCMonth();
        switch (token) {
          // 1, 2, ..., 12
          case "L":
            return String(month + 1);
          // 01, 02, ..., 12
          case "LL":
            return addLeadingZeros(month + 1, 2);
          // 1st, 2nd, ..., 12th
          case "Lo":
            return localize84.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "LLL":
            return localize84.month(month, {
              width: "abbreviated",
              context: "standalone"
            });
          // J, F, ..., D
          case "LLLLL":
            return localize84.month(month, {
              width: "narrow",
              context: "standalone"
            });
          // January, February, ..., December
          case "LLLL":
          default:
            return localize84.month(month, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Local week of year
      w: function w(date, token, localize84, options) {
        var week2 = getUTCWeek(date, options);
        if (token === "wo") {
          return localize84.ordinalNumber(week2, {
            unit: "week"
          });
        }
        return addLeadingZeros(week2, token.length);
      },
      // ISO week of year
      I: function I(date, token, localize84) {
        var isoWeek = getUTCISOWeek(date);
        if (token === "Io") {
          return localize84.ordinalNumber(isoWeek, {
            unit: "week"
          });
        }
        return addLeadingZeros(isoWeek, token.length);
      },
      // Day of the month
      d: function d2(date, token, localize84) {
        if (token === "do") {
          return localize84.ordinalNumber(date.getUTCDate(), {
            unit: "date"
          });
        }
        return lightFormatters_default.d(date, token);
      },
      // Day of year
      D: function D(date, token, localize84) {
        var dayOfYear = getUTCDayOfYear(date);
        if (token === "Do") {
          return localize84.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
          });
        }
        return addLeadingZeros(dayOfYear, token.length);
      },
      // Day of week
      E: function E(date, token, localize84) {
        var dayOfWeek = date.getUTCDay();
        switch (token) {
          // Tue
          case "E":
          case "EE":
          case "EEE":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "EEEEE":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "EEEEEE":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "EEEE":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Local day of week
      e: function e(date, token, localize84, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case "e":
            return String(localDayOfWeek);
          // Padded numerical value
          case "ee":
            return addLeadingZeros(localDayOfWeek, 2);
          // 1st, 2nd, ..., 7th
          case "eo":
            return localize84.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "eee":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "eeeee":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "eeeeee":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "eeee":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone local day of week
      c: function c(date, token, localize84, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (same as in `e`)
          case "c":
            return String(localDayOfWeek);
          // Padded numerical value
          case "cc":
            return addLeadingZeros(localDayOfWeek, token.length);
          // 1st, 2nd, ..., 7th
          case "co":
            return localize84.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "ccc":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "standalone"
            });
          // T
          case "ccccc":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "standalone"
            });
          // Tu
          case "cccccc":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "standalone"
            });
          // Tuesday
          case "cccc":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // ISO day of week
      i: function i(date, token, localize84) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch (token) {
          // 2
          case "i":
            return String(isoDayOfWeek);
          // 02
          case "ii":
            return addLeadingZeros(isoDayOfWeek, token.length);
          // 2nd
          case "io":
            return localize84.ordinalNumber(isoDayOfWeek, {
              unit: "day"
            });
          // Tue
          case "iii":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "iiiii":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "iiiiii":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "iiii":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM or PM
      a: function a2(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "aaa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "aaaaa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM, PM, midnight, noon
      b: function b(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum.noon;
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum.midnight;
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        }
        switch (token) {
          case "b":
          case "bb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "bbb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "bbbbb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function B(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum.evening;
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum.afternoon;
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum.morning;
        } else {
          dayPeriodEnumValue = dayPeriodEnum.night;
        }
        switch (token) {
          case "B":
          case "BB":
          case "BBB":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "BBBBB":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Hour [1-12]
      h: function h2(date, token, localize84) {
        if (token === "ho") {
          var hours = date.getUTCHours() % 12;
          if (hours === 0) hours = 12;
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return lightFormatters_default.h(date, token);
      },
      // Hour [0-23]
      H: function H2(date, token, localize84) {
        if (token === "Ho") {
          return localize84.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
          });
        }
        return lightFormatters_default.H(date, token);
      },
      // Hour [0-11]
      K: function K(date, token, localize84) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") {
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return addLeadingZeros(hours, token.length);
      },
      // Hour [1-24]
      k: function k(date, token, localize84) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") {
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return addLeadingZeros(hours, token.length);
      },
      // Minute
      m: function m2(date, token, localize84) {
        if (token === "mo") {
          return localize84.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
          });
        }
        return lightFormatters_default.m(date, token);
      },
      // Second
      s: function s2(date, token, localize84) {
        if (token === "so") {
          return localize84.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
          });
        }
        return lightFormatters_default.s(date, token);
      },
      // Fraction of second
      S: function S2(date, token) {
        return lightFormatters_default.S(date, token);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) {
          return "Z";
        }
        switch (token) {
          // Hours and optional minutes
          case "X":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Hours and optional minutes
          case "x":
            return formatTimezoneWithOptionalMinutes(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return formatTimezone(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (GMT)
      O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + formatTimezoneShort(timezoneOffset, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + formatTimezone(timezoneOffset, ":");
        }
      },
      // Timezone (specific non-location)
      z: function z2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return "GMT" + formatTimezoneShort(timezoneOffset, ":");
          // Long
          case "zzzz":
          default:
            return "GMT" + formatTimezone(timezoneOffset, ":");
        }
      },
      // Seconds timestamp
      t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1e3);
        return addLeadingZeros(timestamp, token.length);
      },
      // Milliseconds timestamp
      T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return addLeadingZeros(timestamp, token.length);
      }
    };
    formatters_default = formatters2;
  }
});

// ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var dateLongFormatter, timeLongFormatter, dateTimeLongFormatter, longFormatters, longFormatters_default;
var init_longFormatters = __esm({
  "../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js"() {
    "use strict";
    dateLongFormatter = function dateLongFormatter2(pattern, formatLong92) {
      switch (pattern) {
        case "P":
          return formatLong92.date({
            width: "short"
          });
        case "PP":
          return formatLong92.date({
            width: "medium"
          });
        case "PPP":
          return formatLong92.date({
            width: "long"
          });
        case "PPPP":
        default:
          return formatLong92.date({
            width: "full"
          });
      }
    };
    timeLongFormatter = function timeLongFormatter2(pattern, formatLong92) {
      switch (pattern) {
        case "p":
          return formatLong92.time({
            width: "short"
          });
        case "pp":
          return formatLong92.time({
            width: "medium"
          });
        case "ppp":
          return formatLong92.time({
            width: "long"
          });
        case "pppp":
        default:
          return formatLong92.time({
            width: "full"
          });
      }
    };
    dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong92) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];
      if (!timePattern) {
        return dateLongFormatter(pattern, formatLong92);
      }
      var dateTimeFormat;
      switch (datePattern) {
        case "P":
          dateTimeFormat = formatLong92.dateTime({
            width: "short"
          });
          break;
        case "PP":
          dateTimeFormat = formatLong92.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          dateTimeFormat = formatLong92.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          dateTimeFormat = formatLong92.dateTime({
            width: "full"
          });
          break;
      }
      return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong92)).replace("{{time}}", timeLongFormatter(timePattern, formatLong92));
    };
    longFormatters = {
      p: timeLongFormatter,
      P: dateTimeLongFormatter
    };
    longFormatters_default = longFormatters;
  }
});

// ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format2, input) {
  if (token === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var protectedDayOfYearTokens, protectedWeekYearTokens;
var init_protectedTokens = __esm({
  "../../node_modules/date-fns/esm/_lib/protectedTokens/index.js"() {
    "use strict";
    protectedDayOfYearTokens = ["D", "DD"];
    protectedWeekYearTokens = ["YY", "YYYY"];
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale, formatDistance, formatDistance_default;
var init_formatDistance = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    };
    formatDistance = function formatDistance2(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "in " + result;
        } else {
          return result + " ago";
        }
      }
      return result;
    };
    formatDistance_default = formatDistance;
  }
});

// ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var init_buildFormatLongFn = __esm({
  "../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js
var dateFormats, timeFormats, dateTimeFormats, formatLong, formatLong_default;
var init_formatLong = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong = {
      date: buildFormatLongFn({
        formats: dateFormats,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats,
        defaultWidth: "full"
      })
    };
    formatLong_default = formatLong;
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale, formatRelative, formatRelative_default;
var init_formatRelative = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    };
    formatRelative = function formatRelative2(token, _date, _baseDate, _options) {
      return formatRelativeLocale[token];
    };
    formatRelative_default = formatRelative;
  }
});

// ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function(dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}
var init_buildLocalizeFn = __esm({
  "../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js
var eraValues, quarterValues, monthValues, dayValues, dayPeriodValues, formattingDayPeriodValues, ordinalNumber, localize, localize_default;
var init_localize = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues = {
      narrow: ["B", "A"],
      abbreviated: ["BC", "AD"],
      wide: ["Before Christ", "Anno Domini"]
    };
    quarterValues = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
    };
    monthValues = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    dayValues = {
      narrow: ["S", "M", "T", "W", "T", "F", "S"],
      short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    };
    dayPeriodValues = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      }
    };
    formattingDayPeriodValues = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      }
    };
    ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "st";
          case 2:
            return number + "nd";
          case 3:
            return number + "rd";
        }
      }
      return number + "th";
    };
    localize = {
      ordinalNumber,
      era: buildLocalizeFn({
        values: eraValues,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default = localize;
  }
});

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return void 0;
}
var init_buildMatchFn = __esm({
  "../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function(string) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var init_buildMatchPatternFn = __esm({
  "../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js
var matchOrdinalNumberPattern, parseOrdinalNumberPattern, matchEraPatterns, parseEraPatterns, matchQuarterPatterns, parseQuarterPatterns, matchMonthPatterns, parseMonthPatterns, matchDayPatterns, parseDayPatterns, matchDayPeriodPatterns, parseDayPeriodPatterns, match, match_default;
var init_match = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern = /\d+/i;
    matchEraPatterns = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    };
    parseEraPatterns = {
      any: [/^b/i, /^(a|c)/i]
    };
    matchQuarterPatterns = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    parseQuarterPatterns = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    parseMonthPatterns = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    parseDayPatterns = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    parseDayPeriodPatterns = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    match = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback2(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
      })
    };
    match_default = match;
  }
});

// ../../node_modules/date-fns/esm/locale/en-US/index.js
var locale, en_US_default;
var init_en_US = __esm({
  "../../node_modules/date-fns/esm/locale/en-US/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatLong();
    init_formatRelative();
    init_localize();
    init_match();
    locale = {
      code: "en-US",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    en_US_default = locale;
  }
});

// ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js
var defaultLocale_default;
var init_defaultLocale = __esm({
  "../../node_modules/date-fns/esm/_lib/defaultLocale/index.js"() {
    "use strict";
    init_en_US();
    defaultLocale_default = en_US_default;
  }
});

// ../../node_modules/date-fns/esm/format/index.js
function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale94.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale94.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale94,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters_default[firstCharacter];
      return longFormatter(substring, locale94.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters_default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale94.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
var formattingTokensRegExp, longFormattingTokensRegExp, escapedStringRegExp, doubleQuoteRegExp, unescapedLatinCharacterRegExp;
var init_format = __esm({
  "../../node_modules/date-fns/esm/format/index.js"() {
    "use strict";
    init_isValid();
    init_subMilliseconds();
    init_toDate();
    init_formatters();
    init_longFormatters();
    init_getTimezoneOffsetInMilliseconds();
    init_protectedTokens();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
    init_defaultLocale();
    formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    escapedStringRegExp = /^'([^]*?)'?$/;
    doubleQuoteRegExp = /''/g;
    unescapedLatinCharacterRegExp = /[a-zA-Z]/;
  }
});

// ../../node_modules/date-fns/esm/_lib/assign/index.js
function assign(target, object) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
var init_assign = __esm({
  "../../node_modules/date-fns/esm/_lib/assign/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/_lib/cloneObject/index.js
function cloneObject(object) {
  return assign({}, object);
}
var init_cloneObject = __esm({
  "../../node_modules/date-fns/esm/_lib/cloneObject/index.js"() {
    "use strict";
    init_assign();
  }
});

// ../../node_modules/date-fns/esm/formatDistance/index.js
function formatDistance3(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  if (!locale94.formatDistance) {
    throw new RangeError("locale must contain formatDistance property");
  }
  var comparison = compareAsc(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  var localizeOptions = assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }
  var seconds = differenceInSeconds(dateRight, dateLeft);
  var offsetInSeconds = (getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft)) / 1e3;
  var minutes = Math.round((seconds - offsetInSeconds) / 60);
  var months2;
  if (minutes < 2) {
    if (options !== null && options !== void 0 && options.includeSeconds) {
      if (seconds < 5) {
        return locale94.formatDistance("lessThanXSeconds", 5, localizeOptions);
      } else if (seconds < 10) {
        return locale94.formatDistance("lessThanXSeconds", 10, localizeOptions);
      } else if (seconds < 20) {
        return locale94.formatDistance("lessThanXSeconds", 20, localizeOptions);
      } else if (seconds < 40) {
        return locale94.formatDistance("halfAMinute", 0, localizeOptions);
      } else if (seconds < 60) {
        return locale94.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale94.formatDistance("xMinutes", 1, localizeOptions);
      }
    } else {
      if (minutes === 0) {
        return locale94.formatDistance("lessThanXMinutes", 1, localizeOptions);
      } else {
        return locale94.formatDistance("xMinutes", minutes, localizeOptions);
      }
    }
  } else if (minutes < 45) {
    return locale94.formatDistance("xMinutes", minutes, localizeOptions);
  } else if (minutes < 90) {
    return locale94.formatDistance("aboutXHours", 1, localizeOptions);
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60);
    return locale94.formatDistance("aboutXHours", hours, localizeOptions);
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return locale94.formatDistance("xDays", 1, localizeOptions);
  } else if (minutes < MINUTES_IN_MONTH) {
    var days2 = Math.round(minutes / MINUTES_IN_DAY);
    return locale94.formatDistance("xDays", days2, localizeOptions);
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months2 = Math.round(minutes / MINUTES_IN_MONTH);
    return locale94.formatDistance("aboutXMonths", months2, localizeOptions);
  }
  months2 = differenceInMonths(dateRight, dateLeft);
  if (months2 < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return locale94.formatDistance("xMonths", nearestMonth, localizeOptions);
  } else {
    var monthsSinceStartOfYear = months2 % 12;
    var years = Math.floor(months2 / 12);
    if (monthsSinceStartOfYear < 3) {
      return locale94.formatDistance("aboutXYears", years, localizeOptions);
    } else if (monthsSinceStartOfYear < 9) {
      return locale94.formatDistance("overXYears", years, localizeOptions);
    } else {
      return locale94.formatDistance("almostXYears", years + 1, localizeOptions);
    }
  }
}
var MINUTES_IN_DAY, MINUTES_IN_ALMOST_TWO_DAYS, MINUTES_IN_MONTH, MINUTES_IN_TWO_MONTHS;
var init_formatDistance2 = __esm({
  "../../node_modules/date-fns/esm/formatDistance/index.js"() {
    "use strict";
    init_defaultOptions();
    init_compareAsc();
    init_differenceInMonths();
    init_differenceInSeconds();
    init_defaultLocale();
    init_toDate();
    init_cloneObject();
    init_assign();
    init_getTimezoneOffsetInMilliseconds();
    init_requiredArgs();
    MINUTES_IN_DAY = 1440;
    MINUTES_IN_ALMOST_TWO_DAYS = 2520;
    MINUTES_IN_MONTH = 43200;
    MINUTES_IN_TWO_MONTHS = 86400;
  }
});

// ../../node_modules/date-fns/esm/formatDistanceStrict/index.js
function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _options$roundingMeth;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  if (!locale94.formatDistance) {
    throw new RangeError("locale must contain localize.formatDistance property");
  }
  var comparison = compareAsc(dirtyDate, dirtyBaseDate);
  if (isNaN(comparison)) {
    throw new RangeError("Invalid time value");
  }
  var localizeOptions = assign(cloneObject(options), {
    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
    comparison
  });
  var dateLeft;
  var dateRight;
  if (comparison > 0) {
    dateLeft = toDate(dirtyBaseDate);
    dateRight = toDate(dirtyDate);
  } else {
    dateLeft = toDate(dirtyDate);
    dateRight = toDate(dirtyBaseDate);
  }
  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : "round");
  var roundingMethodFn;
  if (roundingMethod === "floor") {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === "ceil") {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === "round") {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }
  var milliseconds2 = dateRight.getTime() - dateLeft.getTime();
  var minutes = milliseconds2 / MILLISECONDS_IN_MINUTE2;
  var timezoneOffset = getTimezoneOffsetInMilliseconds(dateRight) - getTimezoneOffsetInMilliseconds(dateLeft);
  var dstNormalizedMinutes = (milliseconds2 - timezoneOffset) / MILLISECONDS_IN_MINUTE2;
  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
  var unit;
  if (!defaultUnit) {
    if (minutes < 1) {
      unit = "second";
    } else if (minutes < 60) {
      unit = "minute";
    } else if (minutes < MINUTES_IN_DAY2) {
      unit = "hour";
    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH2) {
      unit = "day";
    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
      unit = "month";
    } else {
      unit = "year";
    }
  } else {
    unit = String(defaultUnit);
  }
  if (unit === "second") {
    var seconds = roundingMethodFn(milliseconds2 / 1e3);
    return locale94.formatDistance("xSeconds", seconds, localizeOptions);
  } else if (unit === "minute") {
    var roundedMinutes = roundingMethodFn(minutes);
    return locale94.formatDistance("xMinutes", roundedMinutes, localizeOptions);
  } else if (unit === "hour") {
    var hours = roundingMethodFn(minutes / 60);
    return locale94.formatDistance("xHours", hours, localizeOptions);
  } else if (unit === "day") {
    var days2 = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY2);
    return locale94.formatDistance("xDays", days2, localizeOptions);
  } else if (unit === "month") {
    var months2 = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH2);
    return months2 === 12 && defaultUnit !== "month" ? locale94.formatDistance("xYears", 1, localizeOptions) : locale94.formatDistance("xMonths", months2, localizeOptions);
  } else if (unit === "year") {
    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
    return locale94.formatDistance("xYears", years, localizeOptions);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
var MILLISECONDS_IN_MINUTE2, MINUTES_IN_DAY2, MINUTES_IN_MONTH2, MINUTES_IN_YEAR;
var init_formatDistanceStrict = __esm({
  "../../node_modules/date-fns/esm/formatDistanceStrict/index.js"() {
    "use strict";
    init_defaultOptions();
    init_getTimezoneOffsetInMilliseconds();
    init_compareAsc();
    init_toDate();
    init_cloneObject();
    init_assign();
    init_defaultLocale();
    init_requiredArgs();
    MILLISECONDS_IN_MINUTE2 = 1e3 * 60;
    MINUTES_IN_DAY2 = 60 * 24;
    MINUTES_IN_MONTH2 = MINUTES_IN_DAY2 * 30;
    MINUTES_IN_YEAR = MINUTES_IN_DAY2 * 365;
  }
});

// ../../node_modules/date-fns/esm/formatDistanceToNow/index.js
function formatDistanceToNow(dirtyDate, options) {
  requiredArgs(1, arguments);
  return formatDistance3(dirtyDate, Date.now(), options);
}
var init_formatDistanceToNow = __esm({
  "../../node_modules/date-fns/esm/formatDistanceToNow/index.js"() {
    "use strict";
    init_formatDistance2();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/formatDistanceToNowStrict/index.js
function formatDistanceToNowStrict(dirtyDate, options) {
  requiredArgs(1, arguments);
  return formatDistanceStrict(dirtyDate, Date.now(), options);
}
var init_formatDistanceToNowStrict = __esm({
  "../../node_modules/date-fns/esm/formatDistanceToNowStrict/index.js"() {
    "use strict";
    init_formatDistanceStrict();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/formatDuration/index.js
function formatDuration(duration, options) {
  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  var format2 = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
  if (!locale94.formatDistance) {
    return "";
  }
  var result = format2.reduce(function(acc, unit) {
    var token = "x".concat(unit.replace(/(^.)/, function(m3) {
      return m3.toUpperCase();
    }));
    var value = duration[unit];
    if (typeof value === "number" && (zero || duration[unit])) {
      return acc.concat(locale94.formatDistance(token, value));
    }
    return acc;
  }, []).join(delimiter);
  return result;
}
var defaultFormat;
var init_formatDuration = __esm({
  "../../node_modules/date-fns/esm/formatDuration/index.js"() {
    "use strict";
    init_defaultOptions();
    init_defaultLocale();
    defaultFormat = ["years", "months", "weeks", "days", "hours", "minutes", "seconds"];
  }
});

// ../../node_modules/date-fns/esm/formatISO/index.js
function formatISO(date, options) {
  var _options$format, _options$representati;
  requiredArgs(1, arguments);
  var originalDate = toDate(date);
  if (isNaN(originalDate.getTime())) {
    throw new RangeError("Invalid time value");
  }
  var format2 = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
  if (format2 !== "extended" && format2 !== "basic") {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== "date" && representation !== "time" && representation !== "complete") {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = "";
  var tzOffset = "";
  var dateDelimiter = format2 === "extended" ? "-" : "";
  var timeDelimiter = format2 === "extended" ? ":" : "";
  if (representation !== "time") {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4);
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }
  if (representation !== "date") {
    var offset = originalDate.getTimezoneOffset();
    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      var sign = offset < 0 ? "+" : "-";
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = "Z";
    }
    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2);
    var separator = result === "" ? "" : "T";
    var time = [hour, minute, second].join(timeDelimiter);
    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }
  return result;
}
var init_formatISO = __esm({
  "../../node_modules/date-fns/esm/formatISO/index.js"() {
    "use strict";
    init_toDate();
    init_addLeadingZeros();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/formatISO9075/index.js
function formatISO9075(dirtyDate, options) {
  var _options$format, _options$representati;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var format2 = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : "extended");
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
  if (format2 !== "extended" && format2 !== "basic") {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== "date" && representation !== "time" && representation !== "complete") {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = "";
  var dateDelimiter = format2 === "extended" ? "-" : "";
  var timeDelimiter = format2 === "extended" ? ":" : "";
  if (representation !== "time") {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4);
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }
  if (representation !== "date") {
    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2);
    var separator = result === "" ? "" : " ";
    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
  }
  return result;
}
var init_formatISO9075 = __esm({
  "../../node_modules/date-fns/esm/formatISO9075/index.js"() {
    "use strict";
    init_toDate();
    init_isValid();
    init_addLeadingZeros();
  }
});

// ../../node_modules/date-fns/esm/formatISODuration/index.js
function formatISODuration(duration) {
  requiredArgs(1, arguments);
  if (_typeof(duration) !== "object") throw new Error("Duration must be an object");
  var _duration$years = duration.years, years = _duration$years === void 0 ? 0 : _duration$years, _duration$months = duration.months, months2 = _duration$months === void 0 ? 0 : _duration$months, _duration$days = duration.days, days2 = _duration$days === void 0 ? 0 : _duration$days, _duration$hours = duration.hours, hours = _duration$hours === void 0 ? 0 : _duration$hours, _duration$minutes = duration.minutes, minutes = _duration$minutes === void 0 ? 0 : _duration$minutes, _duration$seconds = duration.seconds, seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
  return "P".concat(years, "Y").concat(months2, "M").concat(days2, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}
var init_formatISODuration = __esm({
  "../../node_modules/date-fns/esm/formatISODuration/index.js"() {
    "use strict";
    init_typeof();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/formatRFC3339/index.js
function formatRFC3339(dirtyDate, options) {
  var _options$fractionDigi;
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0);
  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
    throw new RangeError("fractionDigits must be between 0 and 3 inclusively");
  }
  var day = addLeadingZeros(originalDate.getDate(), 2);
  var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
  var year = originalDate.getFullYear();
  var hour = addLeadingZeros(originalDate.getHours(), 2);
  var minute = addLeadingZeros(originalDate.getMinutes(), 2);
  var second = addLeadingZeros(originalDate.getSeconds(), 2);
  var fractionalSecond = "";
  if (fractionDigits > 0) {
    var milliseconds2 = originalDate.getMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds2 * Math.pow(10, fractionDigits - 3));
    fractionalSecond = "." + addLeadingZeros(fractionalSeconds, fractionDigits);
  }
  var offset = "";
  var tzOffset = originalDate.getTimezoneOffset();
  if (tzOffset !== 0) {
    var absoluteOffset = Math.abs(tzOffset);
    var hourOffset = addLeadingZeros(toInteger(absoluteOffset / 60), 2);
    var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
    var sign = tzOffset < 0 ? "+" : "-";
    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
  } else {
    offset = "Z";
  }
  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}
var init_formatRFC3339 = __esm({
  "../../node_modules/date-fns/esm/formatRFC3339/index.js"() {
    "use strict";
    init_toDate();
    init_isValid();
    init_addLeadingZeros();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/formatRFC7231/index.js
function formatRFC7231(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var dayName = days[originalDate.getUTCDay()];
  var dayOfMonth = addLeadingZeros(originalDate.getUTCDate(), 2);
  var monthName = months[originalDate.getUTCMonth()];
  var year = originalDate.getUTCFullYear();
  var hour = addLeadingZeros(originalDate.getUTCHours(), 2);
  var minute = addLeadingZeros(originalDate.getUTCMinutes(), 2);
  var second = addLeadingZeros(originalDate.getUTCSeconds(), 2);
  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}
var days, months;
var init_formatRFC7231 = __esm({
  "../../node_modules/date-fns/esm/formatRFC7231/index.js"() {
    "use strict";
    init_toDate();
    init_isValid();
    init_addLeadingZeros();
    days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  }
});

// ../../node_modules/date-fns/esm/formatRelative/index.js
function formatRelative3(dirtyDate, dirtyBaseDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var baseDate = toDate(dirtyBaseDate);
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  var weekStartsOn = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!locale94.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale94.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  if (!locale94.formatRelative) {
    throw new RangeError("locale must contain formatRelative property");
  }
  var diff = differenceInCalendarDays(date, baseDate);
  if (isNaN(diff)) {
    throw new RangeError("Invalid time value");
  }
  var token;
  if (diff < -6) {
    token = "other";
  } else if (diff < -1) {
    token = "lastWeek";
  } else if (diff < 0) {
    token = "yesterday";
  } else if (diff < 1) {
    token = "today";
  } else if (diff < 2) {
    token = "tomorrow";
  } else if (diff < 7) {
    token = "nextWeek";
  } else {
    token = "other";
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var utcBaseDate = subMilliseconds(baseDate, getTimezoneOffsetInMilliseconds(baseDate));
  var formatStr = locale94.formatRelative(token, utcDate, utcBaseDate, {
    locale: locale94,
    weekStartsOn
  });
  return format(date, formatStr, {
    locale: locale94,
    weekStartsOn
  });
}
var init_formatRelative2 = __esm({
  "../../node_modules/date-fns/esm/formatRelative/index.js"() {
    "use strict";
    init_defaultOptions();
    init_differenceInCalendarDays();
    init_format();
    init_defaultLocale();
    init_subMilliseconds();
    init_toDate();
    init_getTimezoneOffsetInMilliseconds();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/fromUnixTime/index.js
function fromUnixTime(dirtyUnixTime) {
  requiredArgs(1, arguments);
  var unixTime = toInteger(dirtyUnixTime);
  return toDate(unixTime * 1e3);
}
var init_fromUnixTime = __esm({
  "../../node_modules/date-fns/esm/fromUnixTime/index.js"() {
    "use strict";
    init_toDate();
    init_toInteger();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDate/index.js
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}
var init_getDate = __esm({
  "../../node_modules/date-fns/esm/getDate/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDay/index.js
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}
var init_getDay = __esm({
  "../../node_modules/date-fns/esm/getDay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDayOfYear/index.js
function getDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = differenceInCalendarDays(date, startOfYear(date));
  var dayOfYear = diff + 1;
  return dayOfYear;
}
var init_getDayOfYear = __esm({
  "../../node_modules/date-fns/esm/getDayOfYear/index.js"() {
    "use strict";
    init_toDate();
    init_startOfYear();
    init_differenceInCalendarDays();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDaysInMonth/index.js
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth2 = /* @__PURE__ */ new Date(0);
  lastDayOfMonth2.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth2.setHours(0, 0, 0, 0);
  return lastDayOfMonth2.getDate();
}
var init_getDaysInMonth = __esm({
  "../../node_modules/date-fns/esm/getDaysInMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isLeapYear/index.js
function isLeapYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var init_isLeapYear = __esm({
  "../../node_modules/date-fns/esm/isLeapYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDaysInYear/index.js
function getDaysInYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  if (String(new Date(date)) === "Invalid Date") {
    return NaN;
  }
  return isLeapYear(date) ? 366 : 365;
}
var init_getDaysInYear = __esm({
  "../../node_modules/date-fns/esm/getDaysInYear/index.js"() {
    "use strict";
    init_toDate();
    init_isLeapYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDecade/index.js
function getDecade(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  return decade;
}
var init_getDecade = __esm({
  "../../node_modules/date-fns/esm/getDecade/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getDefaultOptions/index.js
function getDefaultOptions2() {
  return assign({}, getDefaultOptions());
}
var init_getDefaultOptions = __esm({
  "../../node_modules/date-fns/esm/getDefaultOptions/index.js"() {
    "use strict";
    init_defaultOptions();
    init_assign();
  }
});

// ../../node_modules/date-fns/esm/getHours/index.js
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}
var init_getHours = __esm({
  "../../node_modules/date-fns/esm/getHours/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getISODay/index.js
function getISODay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}
var init_getISODay = __esm({
  "../../node_modules/date-fns/esm/getISODay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getISOWeek/index.js
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK5) + 1;
}
var MILLISECONDS_IN_WEEK5;
var init_getISOWeek = __esm({
  "../../node_modules/date-fns/esm/getISOWeek/index.js"() {
    "use strict";
    init_toDate();
    init_startOfISOWeek();
    init_startOfISOWeekYear();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK5 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/getISOWeeksInYear/index.js
function getISOWeeksInYear(dirtyDate) {
  requiredArgs(1, arguments);
  var thisYear = startOfISOWeekYear(dirtyDate);
  var nextYear = startOfISOWeekYear(addWeeks(thisYear, 60));
  var diff = nextYear.valueOf() - thisYear.valueOf();
  return Math.round(diff / MILLISECONDS_IN_WEEK6);
}
var MILLISECONDS_IN_WEEK6;
var init_getISOWeeksInYear = __esm({
  "../../node_modules/date-fns/esm/getISOWeeksInYear/index.js"() {
    "use strict";
    init_startOfISOWeekYear();
    init_addWeeks();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK6 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/getMilliseconds/index.js
function getMilliseconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var milliseconds2 = date.getMilliseconds();
  return milliseconds2;
}
var init_getMilliseconds = __esm({
  "../../node_modules/date-fns/esm/getMilliseconds/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getMinutes/index.js
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}
var init_getMinutes = __esm({
  "../../node_modules/date-fns/esm/getMinutes/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getMonth/index.js
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}
var init_getMonth = __esm({
  "../../node_modules/date-fns/esm/getMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js
function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
  requiredArgs(2, arguments);
  var intervalLeft = dirtyIntervalLeft || {};
  var intervalRight = dirtyIntervalRight || {};
  var leftStartTime = toDate(intervalLeft.start).getTime();
  var leftEndTime = toDate(intervalLeft.end).getTime();
  var rightStartTime = toDate(intervalRight.start).getTime();
  var rightEndTime = toDate(intervalRight.end).getTime();
  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
    throw new RangeError("Invalid interval");
  }
  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
  if (!isOverlapping) {
    return 0;
  }
  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
  var differenceInMs = overlapEndDate - overlapStartDate;
  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY3);
}
var MILLISECONDS_IN_DAY3;
var init_getOverlappingDaysInIntervals = __esm({
  "../../node_modules/date-fns/esm/getOverlappingDaysInIntervals/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    MILLISECONDS_IN_DAY3 = 24 * 60 * 60 * 1e3;
  }
});

// ../../node_modules/date-fns/esm/getSeconds/index.js
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}
var init_getSeconds = __esm({
  "../../node_modules/date-fns/esm/getSeconds/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getTime/index.js
function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}
var init_getTime = __esm({
  "../../node_modules/date-fns/esm/getTime/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getUnixTime/index.js
function getUnixTime(dirtyDate) {
  requiredArgs(1, arguments);
  return Math.floor(getTime(dirtyDate) / 1e3);
}
var init_getUnixTime = __esm({
  "../../node_modules/date-fns/esm/getUnixTime/index.js"() {
    "use strict";
    init_getTime();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getWeekYear/index.js
function getWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
var init_getWeekYear = __esm({
  "../../node_modules/date-fns/esm/getWeekYear/index.js"() {
    "use strict";
    init_startOfWeek();
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/startOfWeekYear/index.js
function startOfWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getWeekYear(dirtyDate, options);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  var date = startOfWeek(firstWeek, options);
  return date;
}
var init_startOfWeekYear = __esm({
  "../../node_modules/date-fns/esm/startOfWeekYear/index.js"() {
    "use strict";
    init_getWeekYear();
    init_startOfWeek();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/getWeek/index.js
function getWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfWeek(date, options).getTime() - startOfWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK7) + 1;
}
var MILLISECONDS_IN_WEEK7;
var init_getWeek = __esm({
  "../../node_modules/date-fns/esm/getWeek/index.js"() {
    "use strict";
    init_startOfWeek();
    init_startOfWeekYear();
    init_toDate();
    init_requiredArgs();
    MILLISECONDS_IN_WEEK7 = 6048e5;
  }
});

// ../../node_modules/date-fns/esm/getWeekOfMonth/index.js
function getWeekOfMonth(date, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var currentDayOfMonth = getDate(date);
  if (isNaN(currentDayOfMonth)) return NaN;
  var startWeekDay = getDay(startOfMonth(date));
  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}
var init_getWeekOfMonth = __esm({
  "../../node_modules/date-fns/esm/getWeekOfMonth/index.js"() {
    "use strict";
    init_defaultOptions();
    init_getDate();
    init_getDay();
    init_startOfMonth();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfMonth/index.js
function lastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_lastDayOfMonth = __esm({
  "../../node_modules/date-fns/esm/lastDayOfMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getWeeksInMonth/index.js
function getWeeksInMonth(date, options) {
  requiredArgs(1, arguments);
  return differenceInCalendarWeeks(lastDayOfMonth(date), startOfMonth(date), options) + 1;
}
var init_getWeeksInMonth = __esm({
  "../../node_modules/date-fns/esm/getWeeksInMonth/index.js"() {
    "use strict";
    init_differenceInCalendarWeeks();
    init_lastDayOfMonth();
    init_startOfMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/getYear/index.js
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
var init_getYear = __esm({
  "../../node_modules/date-fns/esm/getYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/hoursToMilliseconds/index.js
function hoursToMilliseconds(hours) {
  requiredArgs(1, arguments);
  return Math.floor(hours * millisecondsInHour);
}
var init_hoursToMilliseconds = __esm({
  "../../node_modules/date-fns/esm/hoursToMilliseconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/hoursToMinutes/index.js
function hoursToMinutes(hours) {
  requiredArgs(1, arguments);
  return Math.floor(hours * minutesInHour);
}
var init_hoursToMinutes = __esm({
  "../../node_modules/date-fns/esm/hoursToMinutes/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/hoursToSeconds/index.js
function hoursToSeconds(hours) {
  requiredArgs(1, arguments);
  return Math.floor(hours * secondsInHour);
}
var init_hoursToSeconds = __esm({
  "../../node_modules/date-fns/esm/hoursToSeconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/intervalToDuration/index.js
function intervalToDuration(interval) {
  requiredArgs(1, arguments);
  var start = toDate(interval.start);
  var end = toDate(interval.end);
  if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
  if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
  var duration = {};
  duration.years = Math.abs(differenceInYears(end, start));
  var sign = compareAsc(end, start);
  var remainingMonths = add(start, {
    years: sign * duration.years
  });
  duration.months = Math.abs(differenceInMonths(end, remainingMonths));
  var remainingDays = add(remainingMonths, {
    months: sign * duration.months
  });
  duration.days = Math.abs(differenceInDays(end, remainingDays));
  var remainingHours = add(remainingDays, {
    days: sign * duration.days
  });
  duration.hours = Math.abs(differenceInHours(end, remainingHours));
  var remainingMinutes = add(remainingHours, {
    hours: sign * duration.hours
  });
  duration.minutes = Math.abs(differenceInMinutes(end, remainingMinutes));
  var remainingSeconds = add(remainingMinutes, {
    minutes: sign * duration.minutes
  });
  duration.seconds = Math.abs(differenceInSeconds(end, remainingSeconds));
  return duration;
}
var init_intervalToDuration = __esm({
  "../../node_modules/date-fns/esm/intervalToDuration/index.js"() {
    "use strict";
    init_compareAsc();
    init_add();
    init_differenceInDays();
    init_differenceInHours();
    init_differenceInMinutes();
    init_differenceInMonths();
    init_differenceInSeconds();
    init_differenceInYears();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/intlFormat/index.js
function intlFormat(date, formatOrLocale, localeOptions) {
  var _localeOptions;
  requiredArgs(1, arguments);
  var formatOptions;
  if (isFormatOptions(formatOrLocale)) {
    formatOptions = formatOrLocale;
  } else {
    localeOptions = formatOrLocale;
  }
  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}
function isFormatOptions(opts) {
  return opts !== void 0 && !("locale" in opts);
}
var init_intlFormat = __esm({
  "../../node_modules/date-fns/esm/intlFormat/index.js"() {
    "use strict";
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/intlFormatDistance/index.js
function intlFormatDistance(date, baseDate, options) {
  requiredArgs(2, arguments);
  var value = 0;
  var unit;
  var dateLeft = toDate(date);
  var dateRight = toDate(baseDate);
  if (!(options !== null && options !== void 0 && options.unit)) {
    var diffInSeconds = differenceInSeconds(dateLeft, dateRight);
    if (Math.abs(diffInSeconds) < secondsInMinute) {
      value = differenceInSeconds(dateLeft, dateRight);
      unit = "second";
    } else if (Math.abs(diffInSeconds) < secondsInHour) {
      value = differenceInMinutes(dateLeft, dateRight);
      unit = "minute";
    } else if (Math.abs(diffInSeconds) < secondsInDay && Math.abs(differenceInCalendarDays(dateLeft, dateRight)) < 1) {
      value = differenceInHours(dateLeft, dateRight);
      unit = "hour";
    } else if (Math.abs(diffInSeconds) < secondsInWeek && (value = differenceInCalendarDays(dateLeft, dateRight)) && Math.abs(value) < 7) {
      unit = "day";
    } else if (Math.abs(diffInSeconds) < secondsInMonth) {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
      unit = "week";
    } else if (Math.abs(diffInSeconds) < secondsInQuarter) {
      value = differenceInCalendarMonths(dateLeft, dateRight);
      unit = "month";
    } else if (Math.abs(diffInSeconds) < secondsInYear) {
      if (differenceInCalendarQuarters(dateLeft, dateRight) < 4) {
        value = differenceInCalendarQuarters(dateLeft, dateRight);
        unit = "quarter";
      } else {
        value = differenceInCalendarYears(dateLeft, dateRight);
        unit = "year";
      }
    } else {
      value = differenceInCalendarYears(dateLeft, dateRight);
      unit = "year";
    }
  } else {
    unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === "second") {
      value = differenceInSeconds(dateLeft, dateRight);
    } else if (unit === "minute") {
      value = differenceInMinutes(dateLeft, dateRight);
    } else if (unit === "hour") {
      value = differenceInHours(dateLeft, dateRight);
    } else if (unit === "day") {
      value = differenceInCalendarDays(dateLeft, dateRight);
    } else if (unit === "week") {
      value = differenceInCalendarWeeks(dateLeft, dateRight);
    } else if (unit === "month") {
      value = differenceInCalendarMonths(dateLeft, dateRight);
    } else if (unit === "quarter") {
      value = differenceInCalendarQuarters(dateLeft, dateRight);
    } else if (unit === "year") {
      value = differenceInCalendarYears(dateLeft, dateRight);
    }
  }
  var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
    localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
    numeric: (options === null || options === void 0 ? void 0 : options.numeric) || "auto",
    style: options === null || options === void 0 ? void 0 : options.style
  });
  return rtf.format(value, unit);
}
var init_intlFormatDistance = __esm({
  "../../node_modules/date-fns/esm/intlFormatDistance/index.js"() {
    "use strict";
    init_constants();
    init_differenceInCalendarDays();
    init_differenceInCalendarMonths();
    init_differenceInCalendarQuarters();
    init_differenceInCalendarWeeks();
    init_differenceInCalendarYears();
    init_differenceInHours();
    init_differenceInMinutes();
    init_differenceInSeconds();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isAfter/index.js
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
var init_isAfter = __esm({
  "../../node_modules/date-fns/esm/isAfter/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isBefore/index.js
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
var init_isBefore = __esm({
  "../../node_modules/date-fns/esm/isBefore/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isEqual/index.js
function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
var init_isEqual = __esm({
  "../../node_modules/date-fns/esm/isEqual/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isExists/index.js
function isExists(year, month, day) {
  if (arguments.length < 3) {
    throw new TypeError("3 argument required, but only " + arguments.length + " present");
  }
  var date = new Date(year, month, day);
  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}
var init_isExists = __esm({
  "../../node_modules/date-fns/esm/isExists/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/isFirstDayOfMonth/index.js
function isFirstDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDate() === 1;
}
var init_isFirstDayOfMonth = __esm({
  "../../node_modules/date-fns/esm/isFirstDayOfMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isFriday/index.js
function isFriday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 5;
}
var init_isFriday = __esm({
  "../../node_modules/date-fns/esm/isFriday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isFuture/index.js
function isFuture(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getTime() > Date.now();
}
var init_isFuture = __esm({
  "../../node_modules/date-fns/esm/isFuture/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a3) {
  (null == a3 || a3 > r.length) && (a3 = r.length);
  for (var e2 = 0, n = Array(a3); e2 < a3; e2++) n[e2] = r[e2];
  return n;
}
var init_arrayLikeToArray = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray(r, a3) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a3);
    var t2 = {}.toString.call(r).slice(8, -1);
    return "Object" === t2 && r.constructor && (t2 = r.constructor.name), "Map" === t2 || "Set" === t2 ? Array.from(r) : "Arguments" === t2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t2) ? _arrayLikeToArray(r, a3) : void 0;
  }
}
var init_unsupportedIterableToArray = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js"() {
    "use strict";
    init_arrayLikeToArray();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js
function _createForOfIteratorHelper(r, e2) {
  var t2 = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t2) {
    if (Array.isArray(r) || (t2 = _unsupportedIterableToArray(r)) || e2 && r && "number" == typeof r.length) {
      t2 && (r = t2);
      var _n = 0, F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: true
          } : {
            done: false,
            value: r[_n++]
          };
        },
        e: function e3(r2) {
          throw r2;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a3 = true, u2 = false;
  return {
    s: function s3() {
      t2 = t2.call(r);
    },
    n: function n() {
      var r2 = t2.next();
      return a3 = r2.done, r2;
    },
    e: function e3(r2) {
      u2 = true, o = r2;
    },
    f: function f() {
      try {
        a3 || null == t2["return"] || t2["return"]();
      } finally {
        if (u2) throw o;
      }
    }
  };
}
var init_createForOfIteratorHelper = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js"() {
    "use strict";
    init_unsupportedIterableToArray();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e2) {
  if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e2;
}
var init_assertThisInitialized = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t2, e2) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, e3) {
    return t3.__proto__ = e3, t3;
  }, _setPrototypeOf(t2, e2);
}
var init_setPrototypeOf = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(t2, e2) {
  if ("function" != typeof e2 && null !== e2) throw new TypeError("Super expression must either be null or a function");
  t2.prototype = Object.create(e2 && e2.prototype, {
    constructor: {
      value: t2,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t2, "prototype", {
    writable: false
  }), e2 && _setPrototypeOf(t2, e2);
}
var init_inherits = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/inherits.js"() {
    "use strict";
    init_setPrototypeOf();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(t2) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
    return t3.__proto__ || Object.getPrototypeOf(t3);
  }, _getPrototypeOf(t2);
}
var init_getPrototypeOf = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
var init_isNativeReflectConstruct = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(t2, e2) {
  if (e2 && ("object" == _typeof(e2) || "function" == typeof e2)) return e2;
  if (void 0 !== e2) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t2);
}
var init_possibleConstructorReturn = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js"() {
    "use strict";
    init_typeof();
    init_assertThisInitialized();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper(t2) {
  var r = _isNativeReflectConstruct();
  return function() {
    var e2, o = _getPrototypeOf(t2);
    if (r) {
      var s3 = _getPrototypeOf(this).constructor;
      e2 = Reflect.construct(o, arguments, s3);
    } else e2 = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e2);
  };
}
var init_createSuper = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/createSuper.js"() {
    "use strict";
    init_getPrototypeOf();
    init_isNativeReflectConstruct();
    init_possibleConstructorReturn();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a3, n) {
  if (!(a3 instanceof n)) throw new TypeError("Cannot call a class as a function");
}
var init_classCallCheck = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js"() {
    "use strict";
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t2, r) {
  if ("object" != _typeof(t2) || !t2) return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t2, r || "default");
    if ("object" != _typeof(i2)) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t2);
}
var init_toPrimitive = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    "use strict";
    init_typeof();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t2) {
  var i2 = toPrimitive(t2, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}
var init_toPropertyKey = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    "use strict";
    init_typeof();
    init_toPrimitive();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(e2, r) {
  for (var t2 = 0; t2 < r.length; t2++) {
    var o = r[t2];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e2, toPropertyKey(o.key), o);
  }
}
function _createClass(e2, r, t2) {
  return r && _defineProperties(e2.prototype, r), t2 && _defineProperties(e2, t2), Object.defineProperty(e2, "prototype", {
    writable: false
  }), e2;
}
var init_createClass = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/createClass.js"() {
    "use strict";
    init_toPropertyKey();
  }
});

// ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(e2, r, t2) {
  return (r = toPropertyKey(r)) in e2 ? Object.defineProperty(e2, r, {
    value: t2,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e2[r] = t2, e2;
}
var init_defineProperty = __esm({
  "../../node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    "use strict";
    init_toPropertyKey();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/Setter.js
var TIMEZONE_UNIT_PRIORITY, Setter, ValueSetter, DateToSystemTimezoneSetter;
var init_Setter = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/Setter.js"() {
    "use strict";
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_classCallCheck();
    init_createClass();
    init_defineProperty();
    TIMEZONE_UNIT_PRIORITY = 10;
    Setter = /* @__PURE__ */ function() {
      function Setter2() {
        _classCallCheck(this, Setter2);
        _defineProperty(this, "priority", void 0);
        _defineProperty(this, "subPriority", 0);
      }
      _createClass(Setter2, [{
        key: "validate",
        value: function validate2(_utcDate, _options) {
          return true;
        }
      }]);
      return Setter2;
    }();
    ValueSetter = /* @__PURE__ */ function(_Setter) {
      _inherits(ValueSetter2, _Setter);
      var _super = _createSuper(ValueSetter2);
      function ValueSetter2(value, validateValue, setValue, priority, subPriority) {
        var _this;
        _classCallCheck(this, ValueSetter2);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) {
          _this.subPriority = subPriority;
        }
        return _this;
      }
      _createClass(ValueSetter2, [{
        key: "validate",
        value: function validate2(utcDate, options) {
          return this.validateValue(utcDate, this.value, options);
        }
      }, {
        key: "set",
        value: function set2(utcDate, flags, options) {
          return this.setValue(utcDate, flags, this.value, options);
        }
      }]);
      return ValueSetter2;
    }(Setter);
    DateToSystemTimezoneSetter = /* @__PURE__ */ function(_Setter2) {
      _inherits(DateToSystemTimezoneSetter2, _Setter2);
      var _super2 = _createSuper(DateToSystemTimezoneSetter2);
      function DateToSystemTimezoneSetter2() {
        var _this2;
        _classCallCheck(this, DateToSystemTimezoneSetter2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this2 = _super2.call.apply(_super2, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        _defineProperty(_assertThisInitialized(_this2), "subPriority", -1);
        return _this2;
      }
      _createClass(DateToSystemTimezoneSetter2, [{
        key: "set",
        value: function set2(date, flags) {
          if (flags.timestampIsSet) {
            return date;
          }
          var convertedDate = /* @__PURE__ */ new Date(0);
          convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
          convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
          return convertedDate;
        }
      }]);
      return DateToSystemTimezoneSetter2;
    }(Setter);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/Parser.js
var Parser;
var init_Parser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/Parser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_defineProperty();
    init_Setter();
    Parser = /* @__PURE__ */ function() {
      function Parser2() {
        _classCallCheck(this, Parser2);
        _defineProperty(this, "incompatibleTokens", void 0);
        _defineProperty(this, "priority", void 0);
        _defineProperty(this, "subPriority", void 0);
      }
      _createClass(Parser2, [{
        key: "run",
        value: function run(dateString, token, match83, options) {
          var result = this.parse(dateString, token, match83, options);
          if (!result) {
            return null;
          }
          return {
            setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
          };
        }
      }, {
        key: "validate",
        value: function validate2(_utcDate, _value, _options) {
          return true;
        }
      }]);
      return Parser2;
    }();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js
var EraParser;
var init_EraParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    EraParser = /* @__PURE__ */ function(_Parser) {
      _inherits(EraParser2, _Parser);
      var _super = _createSuper(EraParser2);
      function EraParser2() {
        var _this;
        _classCallCheck(this, EraParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 140);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
        return _this;
      }
      _createClass(EraParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
              return match83.era(dateString, {
                width: "abbreviated"
              }) || match83.era(dateString, {
                width: "narrow"
              });
            // A, B
            case "GGGGG":
              return match83.era(dateString, {
                width: "narrow"
              });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
              return match83.era(dateString, {
                width: "wide"
              }) || match83.era(dateString, {
                width: "abbreviated"
              }) || match83.era(dateString, {
                width: "narrow"
              });
          }
        }
      }, {
        key: "set",
        value: function set2(date, flags, value) {
          flags.era = value;
          date.setUTCFullYear(value, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return EraParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns, timezonePatterns;
var init_constants2 = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/constants.js"() {
    "use strict";
    numericPatterns = {
      month: /^(1[0-2]|0?\d)/,
      // 0 to 12
      date: /^(3[0-1]|[0-2]?\d)/,
      // 0 to 31
      dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
      // 0 to 366
      week: /^(5[0-3]|[0-4]?\d)/,
      // 0 to 53
      hour23h: /^(2[0-3]|[0-1]?\d)/,
      // 0 to 23
      hour24h: /^(2[0-4]|[0-1]?\d)/,
      // 0 to 24
      hour11h: /^(1[0-1]|0?\d)/,
      // 0 to 11
      hour12h: /^(1[0-2]|0?\d)/,
      // 0 to 12
      minute: /^[0-5]?\d/,
      // 0 to 59
      second: /^[0-5]?\d/,
      // 0 to 59
      singleDigit: /^\d/,
      // 0 to 9
      twoDigits: /^\d{1,2}/,
      // 0 to 99
      threeDigits: /^\d{1,3}/,
      // 0 to 999
      fourDigits: /^\d{1,4}/,
      // 0 to 9999
      anyDigitsSigned: /^-?\d+/,
      singleDigitSigned: /^-?\d/,
      // 0 to 9, -0 to -9
      twoDigitsSigned: /^-?\d{1,2}/,
      // 0 to 99, -0 to -99
      threeDigitsSigned: /^-?\d{1,3}/,
      // 0 to 999, -0 to -999
      fourDigitsSigned: /^-?\d{1,4}/
      // 0 to 9999, -0 to -9999
    };
    timezonePatterns = {
      basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
      basic: /^([+-])(\d{2})(\d{2})|Z/,
      basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
      extended: /^([+-])(\d{2}):(\d{2})|Z/,
      extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
    };
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/utils.js
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var init_utils = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/utils.js"() {
    "use strict";
    init_constants();
    init_constants2();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js
var YearParser;
var init_YearParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    YearParser = /* @__PURE__ */ function(_Parser) {
      _inherits(YearParser2, _Parser);
      var _super = _createSuper(YearParser2);
      function YearParser2() {
        var _this;
        _classCallCheck(this, YearParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(YearParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          var valueCallback164 = function valueCallback165(year) {
            return {
              year,
              isTwoDigitYear: token === "yy"
            };
          };
          switch (token) {
            case "y":
              return mapValue(parseNDigits(4, dateString), valueCallback164);
            case "yo":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "year"
              }), valueCallback164);
            default:
              return mapValue(parseNDigits(token.length, dateString), valueCallback164);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value.isTwoDigitYear || value.year > 0;
        }
      }, {
        key: "set",
        value: function set2(date, flags, value) {
          var currentYear = date.getUTCFullYear();
          if (value.isTwoDigitYear) {
            var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
            date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          }
          var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
          date.setUTCFullYear(year, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return YearParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js
var LocalWeekYearParser;
var init_LocalWeekYearParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    init_getUTCWeekYear();
    init_startOfUTCWeek();
    LocalWeekYearParser = /* @__PURE__ */ function(_Parser) {
      _inherits(LocalWeekYearParser2, _Parser);
      var _super = _createSuper(LocalWeekYearParser2);
      function LocalWeekYearParser2() {
        var _this;
        _classCallCheck(this, LocalWeekYearParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
        return _this;
      }
      _createClass(LocalWeekYearParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          var valueCallback164 = function valueCallback165(year) {
            return {
              year,
              isTwoDigitYear: token === "YY"
            };
          };
          switch (token) {
            case "Y":
              return mapValue(parseNDigits(4, dateString), valueCallback164);
            case "Yo":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "year"
              }), valueCallback164);
            default:
              return mapValue(parseNDigits(token.length, dateString), valueCallback164);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value.isTwoDigitYear || value.year > 0;
        }
      }, {
        key: "set",
        value: function set2(date, flags, value, options) {
          var currentYear = getUTCWeekYear(date, options);
          if (value.isTwoDigitYear) {
            var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
            date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return startOfUTCWeek(date, options);
          }
          var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
          date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
          date.setUTCHours(0, 0, 0, 0);
          return startOfUTCWeek(date, options);
        }
      }]);
      return LocalWeekYearParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js
var ISOWeekYearParser;
var init_ISOWeekYearParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    init_startOfUTCISOWeek();
    ISOWeekYearParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ISOWeekYearParser2, _Parser);
      var _super = _createSuper(ISOWeekYearParser2);
      function ISOWeekYearParser2() {
        var _this;
        _classCallCheck(this, ISOWeekYearParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(ISOWeekYearParser2, [{
        key: "parse",
        value: function parse3(dateString, token) {
          if (token === "R") {
            return parseNDigitsSigned(4, dateString);
          }
          return parseNDigitsSigned(token.length, dateString);
        }
      }, {
        key: "set",
        value: function set2(_date, _flags, value) {
          var firstWeekOfYear = /* @__PURE__ */ new Date(0);
          firstWeekOfYear.setUTCFullYear(value, 0, 4);
          firstWeekOfYear.setUTCHours(0, 0, 0, 0);
          return startOfUTCISOWeek(firstWeekOfYear);
        }
      }]);
      return ISOWeekYearParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js
var ExtendedYearParser;
var init_ExtendedYearParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    ExtendedYearParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ExtendedYearParser2, _Parser);
      var _super = _createSuper(ExtendedYearParser2);
      function ExtendedYearParser2() {
        var _this;
        _classCallCheck(this, ExtendedYearParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 130);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(ExtendedYearParser2, [{
        key: "parse",
        value: function parse3(dateString, token) {
          if (token === "u") {
            return parseNDigitsSigned(4, dateString);
          }
          return parseNDigitsSigned(token.length, dateString);
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCFullYear(value, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return ExtendedYearParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js
var QuarterParser;
var init_QuarterParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    QuarterParser = /* @__PURE__ */ function(_Parser) {
      _inherits(QuarterParser2, _Parser);
      var _super = _createSuper(QuarterParser2);
      function QuarterParser2() {
        var _this;
        _classCallCheck(this, QuarterParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 120);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(QuarterParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
              return parseNDigits(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
              return match83.ordinalNumber(dateString, {
                unit: "quarter"
              });
            // Q1, Q2, Q3, Q4
            case "QQQ":
              return match83.quarter(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.quarter(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
              return match83.quarter(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
              return match83.quarter(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.quarter(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.quarter(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 4;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMonth((value - 1) * 3, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return QuarterParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js
var StandAloneQuarterParser;
var init_StandAloneQuarterParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    StandAloneQuarterParser = /* @__PURE__ */ function(_Parser) {
      _inherits(StandAloneQuarterParser2, _Parser);
      var _super = _createSuper(StandAloneQuarterParser2);
      function StandAloneQuarterParser2() {
        var _this;
        _classCallCheck(this, StandAloneQuarterParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 120);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(StandAloneQuarterParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            // 1, 2, 3, 4
            case "q":
            case "qq":
              return parseNDigits(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
              return match83.ordinalNumber(dateString, {
                unit: "quarter"
              });
            // Q1, Q2, Q3, Q4
            case "qqq":
              return match83.quarter(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.quarter(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
              return match83.quarter(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
              return match83.quarter(dateString, {
                width: "wide",
                context: "standalone"
              }) || match83.quarter(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.quarter(dateString, {
                width: "narrow",
                context: "standalone"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 4;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMonth((value - 1) * 3, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return StandAloneQuarterParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js
var MonthParser;
var init_MonthParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_utils();
    init_Parser();
    init_constants2();
    MonthParser = /* @__PURE__ */ function(_Parser) {
      _inherits(MonthParser2, _Parser);
      var _super = _createSuper(MonthParser2);
      function MonthParser2() {
        var _this;
        _classCallCheck(this, MonthParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
        _defineProperty(_assertThisInitialized(_this), "priority", 110);
        return _this;
      }
      _createClass(MonthParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          var valueCallback164 = function valueCallback165(value) {
            return value - 1;
          };
          switch (token) {
            // 1, 2, ..., 12
            case "M":
              return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback164);
            // 01, 02, ..., 12
            case "MM":
              return mapValue(parseNDigits(2, dateString), valueCallback164);
            // 1st, 2nd, ..., 12th
            case "Mo":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "month"
              }), valueCallback164);
            // Jan, Feb, ..., Dec
            case "MMM":
              return match83.month(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.month(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // J, F, ..., D
            case "MMMMM":
              return match83.month(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // January, February, ..., December
            case "MMMM":
            default:
              return match83.month(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.month(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.month(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 11;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMonth(value, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return MonthParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js
var StandAloneMonthParser;
var init_StandAloneMonthParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    StandAloneMonthParser = /* @__PURE__ */ function(_Parser) {
      _inherits(StandAloneMonthParser2, _Parser);
      var _super = _createSuper(StandAloneMonthParser2);
      function StandAloneMonthParser2() {
        var _this;
        _classCallCheck(this, StandAloneMonthParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 110);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(StandAloneMonthParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          var valueCallback164 = function valueCallback165(value) {
            return value - 1;
          };
          switch (token) {
            // 1, 2, ..., 12
            case "L":
              return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback164);
            // 01, 02, ..., 12
            case "LL":
              return mapValue(parseNDigits(2, dateString), valueCallback164);
            // 1st, 2nd, ..., 12th
            case "Lo":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "month"
              }), valueCallback164);
            // Jan, Feb, ..., Dec
            case "LLL":
              return match83.month(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.month(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // J, F, ..., D
            case "LLLLL":
              return match83.month(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // January, February, ..., December
            case "LLLL":
            default:
              return match83.month(dateString, {
                width: "wide",
                context: "standalone"
              }) || match83.month(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.month(dateString, {
                width: "narrow",
                context: "standalone"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 11;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMonth(value, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return StandAloneMonthParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/_lib/setUTCWeek/index.js
function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week2 = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week2;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var init_setUTCWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/setUTCWeek/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_getUTCWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js
var LocalWeekParser;
var init_LocalWeekParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    init_setUTCWeek();
    init_startOfUTCWeek();
    LocalWeekParser = /* @__PURE__ */ function(_Parser) {
      _inherits(LocalWeekParser2, _Parser);
      var _super = _createSuper(LocalWeekParser2);
      function LocalWeekParser2() {
        var _this;
        _classCallCheck(this, LocalWeekParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 100);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
        return _this;
      }
      _createClass(LocalWeekParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "w":
              return parseNumericPattern(numericPatterns.week, dateString);
            case "wo":
              return match83.ordinalNumber(dateString, {
                unit: "week"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 53;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value, options) {
          return startOfUTCWeek(setUTCWeek(date, value, options), options);
        }
      }]);
      return LocalWeekParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
var init_setUTCISOWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_getUTCISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js
var ISOWeekParser;
var init_ISOWeekParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    init_setUTCISOWeek();
    init_startOfUTCISOWeek();
    ISOWeekParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ISOWeekParser2, _Parser);
      var _super = _createSuper(ISOWeekParser2);
      function ISOWeekParser2() {
        var _this;
        _classCallCheck(this, ISOWeekParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 100);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(ISOWeekParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "I":
              return parseNumericPattern(numericPatterns.week, dateString);
            case "Io":
              return match83.ordinalNumber(dateString, {
                unit: "week"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 53;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          return startOfUTCISOWeek(setUTCISOWeek(date, value));
        }
      }]);
      return ISOWeekParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js
var DAYS_IN_MONTH, DAYS_IN_MONTH_LEAP_YEAR, DateParser;
var init_DateParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_utils();
    init_Parser();
    init_constants2();
    DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    DateParser = /* @__PURE__ */ function(_Parser) {
      _inherits(DateParser2, _Parser);
      var _super = _createSuper(DateParser2);
      function DateParser2() {
        var _this;
        _classCallCheck(this, DateParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "subPriority", 1);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(DateParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "d":
              return parseNumericPattern(numericPatterns.date, dateString);
            case "do":
              return match83.ordinalNumber(dateString, {
                unit: "date"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(date, value) {
          var year = date.getUTCFullYear();
          var isLeapYear2 = isLeapYearIndex(year);
          var month = date.getUTCMonth();
          if (isLeapYear2) {
            return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
          } else {
            return value >= 1 && value <= DAYS_IN_MONTH[month];
          }
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCDate(value);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return DateParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js
var DayOfYearParser;
var init_DayOfYearParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    DayOfYearParser = /* @__PURE__ */ function(_Parser) {
      _inherits(DayOfYearParser2, _Parser);
      var _super = _createSuper(DayOfYearParser2);
      function DayOfYearParser2() {
        var _this;
        _classCallCheck(this, DayOfYearParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "subpriority", 1);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(DayOfYearParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "D":
            case "DD":
              return parseNumericPattern(numericPatterns.dayOfYear, dateString);
            case "Do":
              return match83.ordinalNumber(dateString, {
                unit: "date"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(date, value) {
          var year = date.getUTCFullYear();
          var isLeapYear2 = isLeapYearIndex(year);
          if (isLeapYear2) {
            return value >= 1 && value <= 366;
          } else {
            return value >= 1 && value <= 365;
          }
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMonth(0, value);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return DayOfYearParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/_lib/setUTCDay/index.js
function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var init_setUTCDay = __esm({
  "../../node_modules/date-fns/esm/_lib/setUTCDay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    init_toInteger();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js
var DayParser;
var init_DayParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_setUTCDay();
    DayParser = /* @__PURE__ */ function(_Parser) {
      _inherits(DayParser2, _Parser);
      var _super = _createSuper(DayParser2);
      function DayParser2() {
        var _this;
        _classCallCheck(this, DayParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(DayParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            // Tue
            case "E":
            case "EE":
            case "EEE":
              return match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // T
            case "EEEEE":
              return match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // Tu
            case "EEEEEE":
              return match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // Tuesday
            case "EEEE":
            default:
              return match83.day(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 6;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value, options) {
          date = setUTCDay(date, value, options);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return DayParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js
var LocalDayParser;
var init_LocalDayParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    init_setUTCDay();
    LocalDayParser = /* @__PURE__ */ function(_Parser) {
      _inherits(LocalDayParser2, _Parser);
      var _super = _createSuper(LocalDayParser2);
      function LocalDayParser2() {
        var _this;
        _classCallCheck(this, LocalDayParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
        return _this;
      }
      _createClass(LocalDayParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83, options) {
          var valueCallback164 = function valueCallback165(value) {
            var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
          };
          switch (token) {
            // 3
            case "e":
            case "ee":
              return mapValue(parseNDigits(token.length, dateString), valueCallback164);
            // 3rd
            case "eo":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "day"
              }), valueCallback164);
            // Tue
            case "eee":
              return match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // T
            case "eeeee":
              return match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // Tu
            case "eeeeee":
              return match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
            // Tuesday
            case "eeee":
            default:
              return match83.day(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 6;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value, options) {
          date = setUTCDay(date, value, options);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return LocalDayParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js
var StandAloneLocalDayParser;
var init_StandAloneLocalDayParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    init_setUTCDay();
    StandAloneLocalDayParser = /* @__PURE__ */ function(_Parser) {
      _inherits(StandAloneLocalDayParser2, _Parser);
      var _super = _createSuper(StandAloneLocalDayParser2);
      function StandAloneLocalDayParser2() {
        var _this;
        _classCallCheck(this, StandAloneLocalDayParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
        return _this;
      }
      _createClass(StandAloneLocalDayParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83, options) {
          var valueCallback164 = function valueCallback165(value) {
            var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
          };
          switch (token) {
            // 3
            case "c":
            case "cc":
              return mapValue(parseNDigits(token.length, dateString), valueCallback164);
            // 3rd
            case "co":
              return mapValue(match83.ordinalNumber(dateString, {
                unit: "day"
              }), valueCallback164);
            // Tue
            case "ccc":
              return match83.day(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "short",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // T
            case "ccccc":
              return match83.day(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // Tu
            case "cccccc":
              return match83.day(dateString, {
                width: "short",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "standalone"
              });
            // Tuesday
            case "cccc":
            default:
              return match83.day(dateString, {
                width: "wide",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "abbreviated",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "short",
                context: "standalone"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "standalone"
              });
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 6;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value, options) {
          date = setUTCDay(date, value, options);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return StandAloneLocalDayParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/_lib/setUTCISODay/index.js
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
var init_setUTCISODay = __esm({
  "../../node_modules/date-fns/esm/_lib/setUTCISODay/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js
var ISODayParser;
var init_ISODayParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    init_setUTCISODay();
    ISODayParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ISODayParser2, _Parser);
      var _super = _createSuper(ISODayParser2);
      function ISODayParser2() {
        var _this;
        _classCallCheck(this, ISODayParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 90);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
        return _this;
      }
      _createClass(ISODayParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          var valueCallback164 = function valueCallback165(value) {
            if (value === 0) {
              return 7;
            }
            return value;
          };
          switch (token) {
            // 2
            case "i":
            case "ii":
              return parseNDigits(token.length, dateString);
            // 2nd
            case "io":
              return match83.ordinalNumber(dateString, {
                unit: "day"
              });
            // Tue
            case "iii":
              return mapValue(match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              }), valueCallback164);
            // T
            case "iiiii":
              return mapValue(match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              }), valueCallback164);
            // Tu
            case "iiiiii":
              return mapValue(match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              }), valueCallback164);
            // Tuesday
            case "iiii":
            default:
              return mapValue(match83.day(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "short",
                context: "formatting"
              }) || match83.day(dateString, {
                width: "narrow",
                context: "formatting"
              }), valueCallback164);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 7;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date = setUTCISODay(date, value);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
      }]);
      return ISODayParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js
var AMPMParser;
var init_AMPMParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    AMPMParser = /* @__PURE__ */ function(_Parser) {
      _inherits(AMPMParser2, _Parser);
      var _super = _createSuper(AMPMParser2);
      function AMPMParser2() {
        var _this;
        _classCallCheck(this, AMPMParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
        return _this;
      }
      _createClass(AMPMParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "a":
            case "aa":
            case "aaa":
              return match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "aaaaa":
              return match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "aaaa":
            default:
              return match83.dayPeriod(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
          return date;
        }
      }]);
      return AMPMParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js
var AMPMMidnightParser;
var init_AMPMMidnightParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    AMPMMidnightParser = /* @__PURE__ */ function(_Parser) {
      _inherits(AMPMMidnightParser2, _Parser);
      var _super = _createSuper(AMPMMidnightParser2);
      function AMPMMidnightParser2() {
        var _this;
        _classCallCheck(this, AMPMMidnightParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
        return _this;
      }
      _createClass(AMPMMidnightParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "b":
            case "bb":
            case "bbb":
              return match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "bbbbb":
              return match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "bbbb":
            default:
              return match83.dayPeriod(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
          return date;
        }
      }]);
      return AMPMMidnightParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js
var DayPeriodParser;
var init_DayPeriodParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    DayPeriodParser = /* @__PURE__ */ function(_Parser) {
      _inherits(DayPeriodParser2, _Parser);
      var _super = _createSuper(DayPeriodParser2);
      function DayPeriodParser2() {
        var _this;
        _classCallCheck(this, DayPeriodParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 80);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
        return _this;
      }
      _createClass(DayPeriodParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "B":
            case "BB":
            case "BBB":
              return match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "BBBBB":
              return match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
            case "BBBB":
            default:
              return match83.dayPeriod(dateString, {
                width: "wide",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "abbreviated",
                context: "formatting"
              }) || match83.dayPeriod(dateString, {
                width: "narrow",
                context: "formatting"
              });
          }
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
          return date;
        }
      }]);
      return DayPeriodParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js
var Hour1to12Parser;
var init_Hour1to12Parser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    Hour1to12Parser = /* @__PURE__ */ function(_Parser) {
      _inherits(Hour1to12Parser2, _Parser);
      var _super = _createSuper(Hour1to12Parser2);
      function Hour1to12Parser2() {
        var _this;
        _classCallCheck(this, Hour1to12Parser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
        return _this;
      }
      _createClass(Hour1to12Parser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "h":
              return parseNumericPattern(numericPatterns.hour12h, dateString);
            case "ho":
              return match83.ordinalNumber(dateString, {
                unit: "hour"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 12;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          var isPM = date.getUTCHours() >= 12;
          if (isPM && value < 12) {
            date.setUTCHours(value + 12, 0, 0, 0);
          } else if (!isPM && value === 12) {
            date.setUTCHours(0, 0, 0, 0);
          } else {
            date.setUTCHours(value, 0, 0, 0);
          }
          return date;
        }
      }]);
      return Hour1to12Parser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js
var Hour0to23Parser;
var init_Hour0to23Parser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    Hour0to23Parser = /* @__PURE__ */ function(_Parser) {
      _inherits(Hour0to23Parser2, _Parser);
      var _super = _createSuper(Hour0to23Parser2);
      function Hour0to23Parser2() {
        var _this;
        _classCallCheck(this, Hour0to23Parser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
        return _this;
      }
      _createClass(Hour0to23Parser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "H":
              return parseNumericPattern(numericPatterns.hour23h, dateString);
            case "Ho":
              return match83.ordinalNumber(dateString, {
                unit: "hour"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 23;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCHours(value, 0, 0, 0);
          return date;
        }
      }]);
      return Hour0to23Parser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js
var Hour0To11Parser;
var init_Hour0To11Parser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    Hour0To11Parser = /* @__PURE__ */ function(_Parser) {
      _inherits(Hour0To11Parser2, _Parser);
      var _super = _createSuper(Hour0To11Parser2);
      function Hour0To11Parser2() {
        var _this;
        _classCallCheck(this, Hour0To11Parser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
        return _this;
      }
      _createClass(Hour0To11Parser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "K":
              return parseNumericPattern(numericPatterns.hour11h, dateString);
            case "Ko":
              return match83.ordinalNumber(dateString, {
                unit: "hour"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 11;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          var isPM = date.getUTCHours() >= 12;
          if (isPM && value < 12) {
            date.setUTCHours(value + 12, 0, 0, 0);
          } else {
            date.setUTCHours(value, 0, 0, 0);
          }
          return date;
        }
      }]);
      return Hour0To11Parser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js
var Hour1To24Parser;
var init_Hour1To24Parser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    Hour1To24Parser = /* @__PURE__ */ function(_Parser) {
      _inherits(Hour1To24Parser2, _Parser);
      var _super = _createSuper(Hour1To24Parser2);
      function Hour1To24Parser2() {
        var _this;
        _classCallCheck(this, Hour1To24Parser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 70);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
        return _this;
      }
      _createClass(Hour1To24Parser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "k":
              return parseNumericPattern(numericPatterns.hour24h, dateString);
            case "ko":
              return match83.ordinalNumber(dateString, {
                unit: "hour"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 1 && value <= 24;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          var hours = value <= 24 ? value % 24 : value;
          date.setUTCHours(hours, 0, 0, 0);
          return date;
        }
      }]);
      return Hour1To24Parser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js
var MinuteParser;
var init_MinuteParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    MinuteParser = /* @__PURE__ */ function(_Parser) {
      _inherits(MinuteParser2, _Parser);
      var _super = _createSuper(MinuteParser2);
      function MinuteParser2() {
        var _this;
        _classCallCheck(this, MinuteParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 60);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
        return _this;
      }
      _createClass(MinuteParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "m":
              return parseNumericPattern(numericPatterns.minute, dateString);
            case "mo":
              return match83.ordinalNumber(dateString, {
                unit: "minute"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 59;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMinutes(value, 0, 0);
          return date;
        }
      }]);
      return MinuteParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js
var SecondParser;
var init_SecondParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    SecondParser = /* @__PURE__ */ function(_Parser) {
      _inherits(SecondParser2, _Parser);
      var _super = _createSuper(SecondParser2);
      function SecondParser2() {
        var _this;
        _classCallCheck(this, SecondParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 50);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
        return _this;
      }
      _createClass(SecondParser2, [{
        key: "parse",
        value: function parse3(dateString, token, match83) {
          switch (token) {
            case "s":
              return parseNumericPattern(numericPatterns.second, dateString);
            case "so":
              return match83.ordinalNumber(dateString, {
                unit: "second"
              });
            default:
              return parseNDigits(token.length, dateString);
          }
        }
      }, {
        key: "validate",
        value: function validate2(_date, value) {
          return value >= 0 && value <= 59;
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCSeconds(value, 0);
          return date;
        }
      }]);
      return SecondParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js
var FractionOfSecondParser;
var init_FractionOfSecondParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    FractionOfSecondParser = /* @__PURE__ */ function(_Parser) {
      _inherits(FractionOfSecondParser2, _Parser);
      var _super = _createSuper(FractionOfSecondParser2);
      function FractionOfSecondParser2() {
        var _this;
        _classCallCheck(this, FractionOfSecondParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 30);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
        return _this;
      }
      _createClass(FractionOfSecondParser2, [{
        key: "parse",
        value: function parse3(dateString, token) {
          var valueCallback164 = function valueCallback165(value) {
            return Math.floor(value * Math.pow(10, -token.length + 3));
          };
          return mapValue(parseNDigits(token.length, dateString), valueCallback164);
        }
      }, {
        key: "set",
        value: function set2(date, _flags, value) {
          date.setUTCMilliseconds(value);
          return date;
        }
      }]);
      return FractionOfSecondParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js
var ISOTimezoneWithZParser;
var init_ISOTimezoneWithZParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    ISOTimezoneWithZParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ISOTimezoneWithZParser2, _Parser);
      var _super = _createSuper(ISOTimezoneWithZParser2);
      function ISOTimezoneWithZParser2() {
        var _this;
        _classCallCheck(this, ISOTimezoneWithZParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 10);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "x"]);
        return _this;
      }
      _createClass(ISOTimezoneWithZParser2, [{
        key: "parse",
        value: function parse3(dateString, token) {
          switch (token) {
            case "X":
              return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
            case "XX":
              return parseTimezonePattern(timezonePatterns.basic, dateString);
            case "XXXX":
              return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
            case "XXXXX":
              return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
            case "XXX":
            default:
              return parseTimezonePattern(timezonePatterns.extended, dateString);
          }
        }
      }, {
        key: "set",
        value: function set2(date, flags, value) {
          if (flags.timestampIsSet) {
            return date;
          }
          return new Date(date.getTime() - value);
        }
      }]);
      return ISOTimezoneWithZParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js
var ISOTimezoneParser;
var init_ISOTimezoneParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_constants2();
    init_utils();
    ISOTimezoneParser = /* @__PURE__ */ function(_Parser) {
      _inherits(ISOTimezoneParser2, _Parser);
      var _super = _createSuper(ISOTimezoneParser2);
      function ISOTimezoneParser2() {
        var _this;
        _classCallCheck(this, ISOTimezoneParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 10);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "X"]);
        return _this;
      }
      _createClass(ISOTimezoneParser2, [{
        key: "parse",
        value: function parse3(dateString, token) {
          switch (token) {
            case "x":
              return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
            case "xx":
              return parseTimezonePattern(timezonePatterns.basic, dateString);
            case "xxxx":
              return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
            case "xxxxx":
              return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
            case "xxx":
            default:
              return parseTimezonePattern(timezonePatterns.extended, dateString);
          }
        }
      }, {
        key: "set",
        value: function set2(date, flags, value) {
          if (flags.timestampIsSet) {
            return date;
          }
          return new Date(date.getTime() - value);
        }
      }]);
      return ISOTimezoneParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js
var TimestampSecondsParser;
var init_TimestampSecondsParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    TimestampSecondsParser = /* @__PURE__ */ function(_Parser) {
      _inherits(TimestampSecondsParser2, _Parser);
      var _super = _createSuper(TimestampSecondsParser2);
      function TimestampSecondsParser2() {
        var _this;
        _classCallCheck(this, TimestampSecondsParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 40);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
        return _this;
      }
      _createClass(TimestampSecondsParser2, [{
        key: "parse",
        value: function parse3(dateString) {
          return parseAnyDigitsSigned(dateString);
        }
      }, {
        key: "set",
        value: function set2(_date, _flags, value) {
          return [new Date(value * 1e3), {
            timestampIsSet: true
          }];
        }
      }]);
      return TimestampSecondsParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js
var TimestampMillisecondsParser;
var init_TimestampMillisecondsParser = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js"() {
    "use strict";
    init_classCallCheck();
    init_createClass();
    init_assertThisInitialized();
    init_inherits();
    init_createSuper();
    init_defineProperty();
    init_Parser();
    init_utils();
    TimestampMillisecondsParser = /* @__PURE__ */ function(_Parser) {
      _inherits(TimestampMillisecondsParser2, _Parser);
      var _super = _createSuper(TimestampMillisecondsParser2);
      function TimestampMillisecondsParser2() {
        var _this;
        _classCallCheck(this, TimestampMillisecondsParser2);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this].concat(args));
        _defineProperty(_assertThisInitialized(_this), "priority", 20);
        _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", "*");
        return _this;
      }
      _createClass(TimestampMillisecondsParser2, [{
        key: "parse",
        value: function parse3(dateString) {
          return parseAnyDigitsSigned(dateString);
        }
      }, {
        key: "set",
        value: function set2(_date, _flags, value) {
          return [new Date(value), {
            timestampIsSet: true
          }];
        }
      }]);
      return TimestampMillisecondsParser2;
    }(Parser);
  }
});

// ../../node_modules/date-fns/esm/parse/_lib/parsers/index.js
var parsers;
var init_parsers = __esm({
  "../../node_modules/date-fns/esm/parse/_lib/parsers/index.js"() {
    "use strict";
    init_EraParser();
    init_YearParser();
    init_LocalWeekYearParser();
    init_ISOWeekYearParser();
    init_ExtendedYearParser();
    init_QuarterParser();
    init_StandAloneQuarterParser();
    init_MonthParser();
    init_StandAloneMonthParser();
    init_LocalWeekParser();
    init_ISOWeekParser();
    init_DateParser();
    init_DayOfYearParser();
    init_DayParser();
    init_LocalDayParser();
    init_StandAloneLocalDayParser();
    init_ISODayParser();
    init_AMPMParser();
    init_AMPMMidnightParser();
    init_DayPeriodParser();
    init_Hour1to12Parser();
    init_Hour0to23Parser();
    init_Hour0To11Parser();
    init_Hour1To24Parser();
    init_MinuteParser();
    init_SecondParser();
    init_FractionOfSecondParser();
    init_ISOTimezoneWithZParser();
    init_ISOTimezoneParser();
    init_TimestampSecondsParser();
    init_TimestampMillisecondsParser();
    parsers = {
      G: new EraParser(),
      y: new YearParser(),
      Y: new LocalWeekYearParser(),
      R: new ISOWeekYearParser(),
      u: new ExtendedYearParser(),
      Q: new QuarterParser(),
      q: new StandAloneQuarterParser(),
      M: new MonthParser(),
      L: new StandAloneMonthParser(),
      w: new LocalWeekParser(),
      I: new ISOWeekParser(),
      d: new DateParser(),
      D: new DayOfYearParser(),
      E: new DayParser(),
      e: new LocalDayParser(),
      c: new StandAloneLocalDayParser(),
      i: new ISODayParser(),
      a: new AMPMParser(),
      b: new AMPMMidnightParser(),
      B: new DayPeriodParser(),
      h: new Hour1to12Parser(),
      H: new Hour0to23Parser(),
      K: new Hour0To11Parser(),
      k: new Hour1To24Parser(),
      m: new MinuteParser(),
      s: new SecondParser(),
      S: new FractionOfSecondParser(),
      X: new ISOTimezoneWithZParser(),
      x: new ISOTimezoneParser(),
      t: new TimestampSecondsParser(),
      T: new TimestampMillisecondsParser()
    };
  }
});

// ../../node_modules/date-fns/esm/parse/index.js
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : defaultLocale_default;
  if (!locale94.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale94
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp2).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters_default) {
      var longFormatter = longFormatters_default[firstCharacter];
      return longFormatter(substring, locale94.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp2);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens), _step;
  try {
    var _loop = function _loop2() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale94.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp2)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString2(token);
        }
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a3, b2) {
    return b2 - a3;
  }).filter(function(priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function(priority) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority;
    }).sort(function(a3, b2) {
      return b2.subPriority - a3.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]);
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString2(input) {
  return input.match(escapedStringRegExp2)[1].replace(doubleQuoteRegExp2, "'");
}
var formattingTokensRegExp2, longFormattingTokensRegExp2, escapedStringRegExp2, doubleQuoteRegExp2, notWhitespaceRegExp, unescapedLatinCharacterRegExp2;
var init_parse = __esm({
  "../../node_modules/date-fns/esm/parse/index.js"() {
    "use strict";
    init_typeof();
    init_createForOfIteratorHelper();
    init_defaultLocale();
    init_subMilliseconds();
    init_toDate();
    init_assign();
    init_longFormatters();
    init_getTimezoneOffsetInMilliseconds();
    init_protectedTokens();
    init_toInteger();
    init_requiredArgs();
    init_Setter();
    init_parsers();
    init_defaultOptions();
    formattingTokensRegExp2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    longFormattingTokensRegExp2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    escapedStringRegExp2 = /^'([^]*?)'?$/;
    doubleQuoteRegExp2 = /''/g;
    notWhitespaceRegExp = /\S/;
    unescapedLatinCharacterRegExp2 = /[a-zA-Z]/;
  }
});

// ../../node_modules/date-fns/esm/isMatch/index.js
function isMatch(dateString, formatString, options) {
  requiredArgs(2, arguments);
  return isValid(parse(dateString, formatString, /* @__PURE__ */ new Date(), options));
}
var init_isMatch = __esm({
  "../../node_modules/date-fns/esm/isMatch/index.js"() {
    "use strict";
    init_parse();
    init_isValid();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isMonday/index.js
function isMonday(date) {
  requiredArgs(1, arguments);
  return toDate(date).getDay() === 1;
}
var init_isMonday = __esm({
  "../../node_modules/date-fns/esm/isMonday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isPast/index.js
function isPast(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getTime() < Date.now();
}
var init_isPast = __esm({
  "../../node_modules/date-fns/esm/isPast/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfHour/index.js
function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}
var init_startOfHour = __esm({
  "../../node_modules/date-fns/esm/startOfHour/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameHour/index.js
function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}
var init_isSameHour = __esm({
  "../../node_modules/date-fns/esm/isSameHour/index.js"() {
    "use strict";
    init_startOfHour();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameWeek/index.js
function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
var init_isSameWeek = __esm({
  "../../node_modules/date-fns/esm/isSameWeek/index.js"() {
    "use strict";
    init_startOfWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameISOWeek/index.js
function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {
    weekStartsOn: 1
  });
}
var init_isSameISOWeek = __esm({
  "../../node_modules/date-fns/esm/isSameISOWeek/index.js"() {
    "use strict";
    init_isSameWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameISOWeekYear/index.js
function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfYear = startOfISOWeekYear(dirtyDateLeft);
  var dateRightStartOfYear = startOfISOWeekYear(dirtyDateRight);
  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
}
var init_isSameISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/isSameISOWeekYear/index.js"() {
    "use strict";
    init_startOfISOWeekYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameMinute/index.js
function isSameMinute(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft);
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight);
  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}
var init_isSameMinute = __esm({
  "../../node_modules/date-fns/esm/isSameMinute/index.js"() {
    "use strict";
    init_startOfMinute();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameMonth/index.js
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
var init_isSameMonth = __esm({
  "../../node_modules/date-fns/esm/isSameMonth/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameQuarter/index.js
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}
var init_isSameQuarter = __esm({
  "../../node_modules/date-fns/esm/isSameQuarter/index.js"() {
    "use strict";
    init_startOfQuarter();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfSecond/index.js
function startOfSecond(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMilliseconds(0);
  return date;
}
var init_startOfSecond = __esm({
  "../../node_modules/date-fns/esm/startOfSecond/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameSecond/index.js
function isSameSecond(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft);
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight);
  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}
var init_isSameSecond = __esm({
  "../../node_modules/date-fns/esm/isSameSecond/index.js"() {
    "use strict";
    init_startOfSecond();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isSameYear/index.js
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
var init_isSameYear = __esm({
  "../../node_modules/date-fns/esm/isSameYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisHour/index.js
function isThisHour(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameHour(Date.now(), dirtyDate);
}
var init_isThisHour = __esm({
  "../../node_modules/date-fns/esm/isThisHour/index.js"() {
    "use strict";
    init_isSameHour();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisISOWeek/index.js
function isThisISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameISOWeek(dirtyDate, Date.now());
}
var init_isThisISOWeek = __esm({
  "../../node_modules/date-fns/esm/isThisISOWeek/index.js"() {
    "use strict";
    init_isSameISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisMinute/index.js
function isThisMinute(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameMinute(Date.now(), dirtyDate);
}
var init_isThisMinute = __esm({
  "../../node_modules/date-fns/esm/isThisMinute/index.js"() {
    "use strict";
    init_isSameMinute();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisMonth/index.js
function isThisMonth(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameMonth(Date.now(), dirtyDate);
}
var init_isThisMonth = __esm({
  "../../node_modules/date-fns/esm/isThisMonth/index.js"() {
    "use strict";
    init_isSameMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisQuarter/index.js
function isThisQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameQuarter(Date.now(), dirtyDate);
}
var init_isThisQuarter = __esm({
  "../../node_modules/date-fns/esm/isThisQuarter/index.js"() {
    "use strict";
    init_isSameQuarter();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisSecond/index.js
function isThisSecond(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameSecond(Date.now(), dirtyDate);
}
var init_isThisSecond = __esm({
  "../../node_modules/date-fns/esm/isThisSecond/index.js"() {
    "use strict";
    init_isSameSecond();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisWeek/index.js
function isThisWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  return isSameWeek(dirtyDate, Date.now(), options);
}
var init_isThisWeek = __esm({
  "../../node_modules/date-fns/esm/isThisWeek/index.js"() {
    "use strict";
    init_isSameWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThisYear/index.js
function isThisYear(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameYear(dirtyDate, Date.now());
}
var init_isThisYear = __esm({
  "../../node_modules/date-fns/esm/isThisYear/index.js"() {
    "use strict";
    init_isSameYear();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isThursday/index.js
function isThursday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 4;
}
var init_isThursday = __esm({
  "../../node_modules/date-fns/esm/isThursday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isToday/index.js
function isToday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, Date.now());
}
var init_isToday = __esm({
  "../../node_modules/date-fns/esm/isToday/index.js"() {
    "use strict";
    init_isSameDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isTomorrow/index.js
function isTomorrow(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, addDays(Date.now(), 1));
}
var init_isTomorrow = __esm({
  "../../node_modules/date-fns/esm/isTomorrow/index.js"() {
    "use strict";
    init_addDays();
    init_isSameDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isTuesday/index.js
function isTuesday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 2;
}
var init_isTuesday = __esm({
  "../../node_modules/date-fns/esm/isTuesday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isWednesday/index.js
function isWednesday(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getDay() === 3;
}
var init_isWednesday = __esm({
  "../../node_modules/date-fns/esm/isWednesday/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/isWithinInterval/index.js
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  return time >= startTime && time <= endTime;
}
var init_isWithinInterval = __esm({
  "../../node_modules/date-fns/esm/isWithinInterval/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/subDays/index.js
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
var init_subDays = __esm({
  "../../node_modules/date-fns/esm/subDays/index.js"() {
    "use strict";
    init_addDays();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/isYesterday/index.js
function isYesterday(dirtyDate) {
  requiredArgs(1, arguments);
  return isSameDay(dirtyDate, subDays(Date.now(), 1));
}
var init_isYesterday = __esm({
  "../../node_modules/date-fns/esm/isYesterday/index.js"() {
    "use strict";
    init_isSameDay();
    init_subDays();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfDecade/index.js
function lastDayOfDecade(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var decade = 9 + Math.floor(year / 10) * 10;
  date.setFullYear(decade + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_lastDayOfDecade = __esm({
  "../../node_modules/date-fns/esm/lastDayOfDecade/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfWeek/index.js
function lastDayOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6");
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date;
}
var init_lastDayOfWeek = __esm({
  "../../node_modules/date-fns/esm/lastDayOfWeek/index.js"() {
    "use strict";
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfISOWeek/index.js
function lastDayOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return lastDayOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}
var init_lastDayOfISOWeek = __esm({
  "../../node_modules/date-fns/esm/lastDayOfISOWeek/index.js"() {
    "use strict";
    init_lastDayOfWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js
function lastDayOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setFullYear(year + 1, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  date.setDate(date.getDate() - 1);
  return date;
}
var init_lastDayOfISOWeekYear = __esm({
  "../../node_modules/date-fns/esm/lastDayOfISOWeekYear/index.js"() {
    "use strict";
    init_getISOWeekYear();
    init_startOfISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfQuarter/index.js
function lastDayOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3 + 3;
  date.setMonth(month, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_lastDayOfQuarter = __esm({
  "../../node_modules/date-fns/esm/lastDayOfQuarter/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lastDayOfYear/index.js
function lastDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_lastDayOfYear = __esm({
  "../../node_modules/date-fns/esm/lastDayOfYear/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/lightFormat/index.js
function lightFormat(dirtyDate, formatStr) {
  requiredArgs(2, arguments);
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var tokens = formatStr.match(formattingTokensRegExp3);
  if (!tokens) return "";
  var result = tokens.map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString3(substring);
    }
    var formatter = lightFormatters_default[firstCharacter];
    if (formatter) {
      return formatter(utcDate, substring);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp3)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString3(input) {
  var matches = input.match(escapedStringRegExp3);
  if (!matches) {
    return input;
  }
  return matches[1].replace(doubleQuoteRegExp3, "'");
}
var formattingTokensRegExp3, escapedStringRegExp3, doubleQuoteRegExp3, unescapedLatinCharacterRegExp3;
var init_lightFormat = __esm({
  "../../node_modules/date-fns/esm/lightFormat/index.js"() {
    "use strict";
    init_toDate();
    init_lightFormatters();
    init_getTimezoneOffsetInMilliseconds();
    init_isValid();
    init_subMilliseconds();
    init_requiredArgs();
    formattingTokensRegExp3 = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
    escapedStringRegExp3 = /^'([^]*?)'?$/;
    doubleQuoteRegExp3 = /''/g;
    unescapedLatinCharacterRegExp3 = /[a-zA-Z]/;
  }
});

// ../../node_modules/date-fns/esm/milliseconds/index.js
function milliseconds(_ref) {
  var years = _ref.years, months2 = _ref.months, weeks = _ref.weeks, days2 = _ref.days, hours = _ref.hours, minutes = _ref.minutes, seconds = _ref.seconds;
  requiredArgs(1, arguments);
  var totalDays = 0;
  if (years) totalDays += years * daysInYear2;
  if (months2) totalDays += months2 * (daysInYear2 / 12);
  if (weeks) totalDays += weeks * 7;
  if (days2) totalDays += days2;
  var totalSeconds = totalDays * 24 * 60 * 60;
  if (hours) totalSeconds += hours * 60 * 60;
  if (minutes) totalSeconds += minutes * 60;
  if (seconds) totalSeconds += seconds;
  return Math.round(totalSeconds * 1e3);
}
var daysInYear2;
var init_milliseconds = __esm({
  "../../node_modules/date-fns/esm/milliseconds/index.js"() {
    "use strict";
    init_requiredArgs();
    daysInYear2 = 365.2425;
  }
});

// ../../node_modules/date-fns/esm/millisecondsToHours/index.js
function millisecondsToHours(milliseconds2) {
  requiredArgs(1, arguments);
  var hours = milliseconds2 / millisecondsInHour;
  return Math.floor(hours);
}
var init_millisecondsToHours = __esm({
  "../../node_modules/date-fns/esm/millisecondsToHours/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/millisecondsToMinutes/index.js
function millisecondsToMinutes(milliseconds2) {
  requiredArgs(1, arguments);
  var minutes = milliseconds2 / millisecondsInMinute;
  return Math.floor(minutes);
}
var init_millisecondsToMinutes = __esm({
  "../../node_modules/date-fns/esm/millisecondsToMinutes/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/millisecondsToSeconds/index.js
function millisecondsToSeconds(milliseconds2) {
  requiredArgs(1, arguments);
  var seconds = milliseconds2 / millisecondsInSecond;
  return Math.floor(seconds);
}
var init_millisecondsToSeconds = __esm({
  "../../node_modules/date-fns/esm/millisecondsToSeconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/minutesToHours/index.js
function minutesToHours(minutes) {
  requiredArgs(1, arguments);
  var hours = minutes / minutesInHour;
  return Math.floor(hours);
}
var init_minutesToHours = __esm({
  "../../node_modules/date-fns/esm/minutesToHours/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/minutesToMilliseconds/index.js
function minutesToMilliseconds(minutes) {
  requiredArgs(1, arguments);
  return Math.floor(minutes * millisecondsInMinute);
}
var init_minutesToMilliseconds = __esm({
  "../../node_modules/date-fns/esm/minutesToMilliseconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/minutesToSeconds/index.js
function minutesToSeconds(minutes) {
  requiredArgs(1, arguments);
  return Math.floor(minutes * secondsInMinute);
}
var init_minutesToSeconds = __esm({
  "../../node_modules/date-fns/esm/minutesToSeconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/monthsToQuarters/index.js
function monthsToQuarters(months2) {
  requiredArgs(1, arguments);
  var quarters = months2 / monthsInQuarter;
  return Math.floor(quarters);
}
var init_monthsToQuarters = __esm({
  "../../node_modules/date-fns/esm/monthsToQuarters/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/monthsToYears/index.js
function monthsToYears(months2) {
  requiredArgs(1, arguments);
  var years = months2 / monthsInYear;
  return Math.floor(years);
}
var init_monthsToYears = __esm({
  "../../node_modules/date-fns/esm/monthsToYears/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/nextDay/index.js
function nextDay(date, day) {
  requiredArgs(2, arguments);
  var delta = day - getDay(date);
  if (delta <= 0) delta += 7;
  return addDays(date, delta);
}
var init_nextDay = __esm({
  "../../node_modules/date-fns/esm/nextDay/index.js"() {
    "use strict";
    init_addDays();
    init_getDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextFriday/index.js
function nextFriday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 5);
}
var init_nextFriday = __esm({
  "../../node_modules/date-fns/esm/nextFriday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextMonday/index.js
function nextMonday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 1);
}
var init_nextMonday = __esm({
  "../../node_modules/date-fns/esm/nextMonday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextSaturday/index.js
function nextSaturday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 6);
}
var init_nextSaturday = __esm({
  "../../node_modules/date-fns/esm/nextSaturday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextSunday/index.js
function nextSunday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 0);
}
var init_nextSunday = __esm({
  "../../node_modules/date-fns/esm/nextSunday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextThursday/index.js
function nextThursday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 4);
}
var init_nextThursday = __esm({
  "../../node_modules/date-fns/esm/nextThursday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextTuesday/index.js
function nextTuesday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 2);
}
var init_nextTuesday = __esm({
  "../../node_modules/date-fns/esm/nextTuesday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/nextWednesday/index.js
function nextWednesday(date) {
  requiredArgs(1, arguments);
  return nextDay(date, 3);
}
var init_nextWednesday = __esm({
  "../../node_modules/date-fns/esm/nextWednesday/index.js"() {
    "use strict";
    init_nextDay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/parseISO/index.js
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], "");
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex);
  if (!captures) return {
    year: NaN,
    restDateString: ""
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null) return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures) return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week2 = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week2, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week2, dayOfWeek);
  } else {
    var date = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z") return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week2, day) {
  var date = /* @__PURE__ */ new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week2 - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
function isLeapYearIndex2(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex2(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex2(year) ? 366 : 365);
}
function validateWeekDate(_year, week2, day) {
  return week2 >= 1 && week2 <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
var patterns, dateRegex, timeRegex, timezoneRegex, daysInMonths;
var init_parseISO = __esm({
  "../../node_modules/date-fns/esm/parseISO/index.js"() {
    "use strict";
    init_constants();
    init_requiredArgs();
    init_toInteger();
    patterns = {
      dateTimeDelimiter: /[T ]/,
      timeZoneDelimiter: /[Z ]/i,
      timezone: /([Z+-].*)$/
    };
    dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
    timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
    timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
    daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  }
});

// ../../node_modules/date-fns/esm/parseJSON/index.js
function parseJSON(argument) {
  requiredArgs(1, arguments);
  if (typeof argument === "string") {
    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
    if (parts) {
      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == "-" ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == "-" ? -1 : 1), +parts[6], +((parts[7] || "0") + "00").substring(0, 3)));
    }
    return /* @__PURE__ */ new Date(NaN);
  }
  return toDate(argument);
}
var init_parseJSON = __esm({
  "../../node_modules/date-fns/esm/parseJSON/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/previousDay/index.js
function previousDay(date, day) {
  requiredArgs(2, arguments);
  var delta = getDay(date) - day;
  if (delta <= 0) delta += 7;
  return subDays(date, delta);
}
var init_previousDay = __esm({
  "../../node_modules/date-fns/esm/previousDay/index.js"() {
    "use strict";
    init_requiredArgs();
    init_getDay();
    init_subDays();
  }
});

// ../../node_modules/date-fns/esm/previousFriday/index.js
function previousFriday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 5);
}
var init_previousFriday = __esm({
  "../../node_modules/date-fns/esm/previousFriday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousMonday/index.js
function previousMonday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 1);
}
var init_previousMonday = __esm({
  "../../node_modules/date-fns/esm/previousMonday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousSaturday/index.js
function previousSaturday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 6);
}
var init_previousSaturday = __esm({
  "../../node_modules/date-fns/esm/previousSaturday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousSunday/index.js
function previousSunday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 0);
}
var init_previousSunday = __esm({
  "../../node_modules/date-fns/esm/previousSunday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousThursday/index.js
function previousThursday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 4);
}
var init_previousThursday = __esm({
  "../../node_modules/date-fns/esm/previousThursday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousTuesday/index.js
function previousTuesday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 2);
}
var init_previousTuesday = __esm({
  "../../node_modules/date-fns/esm/previousTuesday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/previousWednesday/index.js
function previousWednesday(date) {
  requiredArgs(1, arguments);
  return previousDay(date, 3);
}
var init_previousWednesday = __esm({
  "../../node_modules/date-fns/esm/previousWednesday/index.js"() {
    "use strict";
    init_requiredArgs();
    init_previousDay();
  }
});

// ../../node_modules/date-fns/esm/quartersToMonths/index.js
function quartersToMonths(quarters) {
  requiredArgs(1, arguments);
  return Math.floor(quarters * monthsInQuarter);
}
var init_quartersToMonths = __esm({
  "../../node_modules/date-fns/esm/quartersToMonths/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/quartersToYears/index.js
function quartersToYears(quarters) {
  requiredArgs(1, arguments);
  var years = quarters / quartersInYear;
  return Math.floor(years);
}
var init_quartersToYears = __esm({
  "../../node_modules/date-fns/esm/quartersToYears/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/roundToNearestMinutes/index.js
function roundToNearestMinutes(dirtyDate, options) {
  var _options$nearestTo;
  if (arguments.length < 1) {
    throw new TypeError("1 argument required, but only none provided present");
  }
  var nearestTo = toInteger((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
  if (nearestTo < 1 || nearestTo > 30) {
    throw new RangeError("`options.nearestTo` must be between 1 and 30");
  }
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  var minutes = date.getMinutes() + seconds / 60;
  var roundingMethod = getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod);
  var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
  var remainderMinutes = minutes % nearestTo;
  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}
var init_roundToNearestMinutes = __esm({
  "../../node_modules/date-fns/esm/roundToNearestMinutes/index.js"() {
    "use strict";
    init_toDate();
    init_roundingMethods();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/secondsToHours/index.js
function secondsToHours(seconds) {
  requiredArgs(1, arguments);
  var hours = seconds / secondsInHour;
  return Math.floor(hours);
}
var init_secondsToHours = __esm({
  "../../node_modules/date-fns/esm/secondsToHours/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/secondsToMilliseconds/index.js
function secondsToMilliseconds(seconds) {
  requiredArgs(1, arguments);
  return seconds * millisecondsInSecond;
}
var init_secondsToMilliseconds = __esm({
  "../../node_modules/date-fns/esm/secondsToMilliseconds/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/secondsToMinutes/index.js
function secondsToMinutes(seconds) {
  requiredArgs(1, arguments);
  var minutes = seconds / secondsInMinute;
  return Math.floor(minutes);
}
var init_secondsToMinutes = __esm({
  "../../node_modules/date-fns/esm/secondsToMinutes/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/setMonth/index.js
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}
var init_setMonth = __esm({
  "../../node_modules/date-fns/esm/setMonth/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_getDaysInMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/set/index.js
function set(dirtyDate, values) {
  requiredArgs(2, arguments);
  if (_typeof(values) !== "object" || values === null) {
    throw new RangeError("values parameter must be an object");
  }
  var date = toDate(dirtyDate);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = setMonth(date, values.month);
  }
  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }
  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }
  return date;
}
var init_set = __esm({
  "../../node_modules/date-fns/esm/set/index.js"() {
    "use strict";
    init_typeof();
    init_toDate();
    init_setMonth();
    init_toInteger();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setDate/index.js
function setDate(dirtyDate, dirtyDayOfMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = toInteger(dirtyDayOfMonth);
  date.setDate(dayOfMonth);
  return date;
}
var init_setDate = __esm({
  "../../node_modules/date-fns/esm/setDate/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setDay/index.js
function setDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var delta = 7 - weekStartsOn;
  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(date, diff);
}
var init_setDay = __esm({
  "../../node_modules/date-fns/esm/setDay/index.js"() {
    "use strict";
    init_addDays();
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/setDayOfYear/index.js
function setDayOfYear(dirtyDate, dirtyDayOfYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dayOfYear = toInteger(dirtyDayOfYear);
  date.setMonth(0);
  date.setDate(dayOfYear);
  return date;
}
var init_setDayOfYear = __esm({
  "../../node_modules/date-fns/esm/setDayOfYear/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setDefaultOptions/index.js
function setDefaultOptions2(newOptions) {
  requiredArgs(1, arguments);
  var result = {};
  var defaultOptions2 = getDefaultOptions();
  for (var property in defaultOptions2) {
    if (Object.prototype.hasOwnProperty.call(defaultOptions2, property)) {
      ;
      result[property] = defaultOptions2[property];
    }
  }
  for (var _property in newOptions) {
    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
      if (newOptions[_property] === void 0) {
        delete result[_property];
      } else {
        ;
        result[_property] = newOptions[_property];
      }
    }
  }
  setDefaultOptions(result);
}
var init_setDefaultOptions = __esm({
  "../../node_modules/date-fns/esm/setDefaultOptions/index.js"() {
    "use strict";
    init_defaultOptions();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setHours/index.js
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}
var init_setHours = __esm({
  "../../node_modules/date-fns/esm/setHours/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setISODay/index.js
function setISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = getISODay(date);
  var diff = day - currentDay;
  return addDays(date, diff);
}
var init_setISODay = __esm({
  "../../node_modules/date-fns/esm/setISODay/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_addDays();
    init_getISODay();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setISOWeek/index.js
function setISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getISOWeek(date) - isoWeek;
  date.setDate(date.getDate() - diff * 7);
  return date;
}
var init_setISOWeek = __esm({
  "../../node_modules/date-fns/esm/setISOWeek/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_getISOWeek();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setMilliseconds/index.js
function setMilliseconds(dirtyDate, dirtyMilliseconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var milliseconds2 = toInteger(dirtyMilliseconds);
  date.setMilliseconds(milliseconds2);
  return date;
}
var init_setMilliseconds = __esm({
  "../../node_modules/date-fns/esm/setMilliseconds/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setMinutes/index.js
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}
var init_setMinutes = __esm({
  "../../node_modules/date-fns/esm/setMinutes/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setQuarter/index.js
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}
var init_setQuarter = __esm({
  "../../node_modules/date-fns/esm/setQuarter/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_setMonth();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setSeconds/index.js
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}
var init_setSeconds = __esm({
  "../../node_modules/date-fns/esm/setSeconds/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/setWeek/index.js
function setWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week2 = toInteger(dirtyWeek);
  var diff = getWeek(date, options) - week2;
  date.setDate(date.getDate() - diff * 7);
  return date;
}
var init_setWeek = __esm({
  "../../node_modules/date-fns/esm/setWeek/index.js"() {
    "use strict";
    init_getWeek();
    init_toDate();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/setWeekYear/index.js
function setWeekYear(dirtyDate, dirtyWeekYear, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var date = toDate(dirtyDate);
  var weekYear = toInteger(dirtyWeekYear);
  var diff = differenceInCalendarDays(date, startOfWeekYear(date, options));
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  date = startOfWeekYear(firstWeek, options);
  date.setDate(date.getDate() + diff);
  return date;
}
var init_setWeekYear = __esm({
  "../../node_modules/date-fns/esm/setWeekYear/index.js"() {
    "use strict";
    init_differenceInCalendarDays();
    init_startOfWeekYear();
    init_toDate();
    init_toInteger();
    init_requiredArgs();
    init_defaultOptions();
  }
});

// ../../node_modules/date-fns/esm/setYear/index.js
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}
var init_setYear = __esm({
  "../../node_modules/date-fns/esm/setYear/index.js"() {
    "use strict";
    init_toInteger();
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfDecade/index.js
function startOfDecade(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var decade = Math.floor(year / 10) * 10;
  date.setFullYear(decade, 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfDecade = __esm({
  "../../node_modules/date-fns/esm/startOfDecade/index.js"() {
    "use strict";
    init_toDate();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/startOfToday/index.js
function startOfToday() {
  return startOfDay(Date.now());
}
var init_startOfToday = __esm({
  "../../node_modules/date-fns/esm/startOfToday/index.js"() {
    "use strict";
    init_startOfDay();
  }
});

// ../../node_modules/date-fns/esm/startOfTomorrow/index.js
function startOfTomorrow() {
  var now = /* @__PURE__ */ new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(year, month, day + 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfTomorrow = __esm({
  "../../node_modules/date-fns/esm/startOfTomorrow/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/startOfYesterday/index.js
function startOfYesterday() {
  var now = /* @__PURE__ */ new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var day = now.getDate();
  var date = /* @__PURE__ */ new Date(0);
  date.setFullYear(year, month, day - 1);
  date.setHours(0, 0, 0, 0);
  return date;
}
var init_startOfYesterday = __esm({
  "../../node_modules/date-fns/esm/startOfYesterday/index.js"() {
    "use strict";
  }
});

// ../../node_modules/date-fns/esm/subMonths/index.js
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
var init_subMonths = __esm({
  "../../node_modules/date-fns/esm/subMonths/index.js"() {
    "use strict";
    init_toInteger();
    init_addMonths();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/sub/index.js
function sub(date, duration) {
  requiredArgs(2, arguments);
  if (!duration || _typeof(duration) !== "object") return /* @__PURE__ */ new Date(NaN);
  var years = duration.years ? toInteger(duration.years) : 0;
  var months2 = duration.months ? toInteger(duration.months) : 0;
  var weeks = duration.weeks ? toInteger(duration.weeks) : 0;
  var days2 = duration.days ? toInteger(duration.days) : 0;
  var hours = duration.hours ? toInteger(duration.hours) : 0;
  var minutes = duration.minutes ? toInteger(duration.minutes) : 0;
  var seconds = duration.seconds ? toInteger(duration.seconds) : 0;
  var dateWithoutMonths = subMonths(date, months2 + years * 12);
  var dateWithoutDays = subDays(dateWithoutMonths, days2 + weeks * 7);
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1e3;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
var init_sub = __esm({
  "../../node_modules/date-fns/esm/sub/index.js"() {
    "use strict";
    init_typeof();
    init_subDays();
    init_subMonths();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/subBusinessDays/index.js
function subBusinessDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addBusinessDays(dirtyDate, -amount);
}
var init_subBusinessDays = __esm({
  "../../node_modules/date-fns/esm/subBusinessDays/index.js"() {
    "use strict";
    init_addBusinessDays();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/subHours/index.js
function subHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addHours(dirtyDate, -amount);
}
var init_subHours = __esm({
  "../../node_modules/date-fns/esm/subHours/index.js"() {
    "use strict";
    init_addHours();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/subMinutes/index.js
function subMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMinutes(dirtyDate, -amount);
}
var init_subMinutes = __esm({
  "../../node_modules/date-fns/esm/subMinutes/index.js"() {
    "use strict";
    init_addMinutes();
    init_requiredArgs();
    init_toInteger();
  }
});

// ../../node_modules/date-fns/esm/subQuarters/index.js
function subQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}
var init_subQuarters = __esm({
  "../../node_modules/date-fns/esm/subQuarters/index.js"() {
    "use strict";
    init_toInteger();
    init_addQuarters();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/subSeconds/index.js
function subSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addSeconds(dirtyDate, -amount);
}
var init_subSeconds = __esm({
  "../../node_modules/date-fns/esm/subSeconds/index.js"() {
    "use strict";
    init_toInteger();
    init_addSeconds();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/subWeeks/index.js
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}
var init_subWeeks = __esm({
  "../../node_modules/date-fns/esm/subWeeks/index.js"() {
    "use strict";
    init_toInteger();
    init_addWeeks();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/subYears/index.js
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}
var init_subYears = __esm({
  "../../node_modules/date-fns/esm/subYears/index.js"() {
    "use strict";
    init_toInteger();
    init_addYears();
    init_requiredArgs();
  }
});

// ../../node_modules/date-fns/esm/weeksToDays/index.js
function weeksToDays(weeks) {
  requiredArgs(1, arguments);
  return Math.floor(weeks * daysInWeek);
}
var init_weeksToDays = __esm({
  "../../node_modules/date-fns/esm/weeksToDays/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/yearsToMonths/index.js
function yearsToMonths(years) {
  requiredArgs(1, arguments);
  return Math.floor(years * monthsInYear);
}
var init_yearsToMonths = __esm({
  "../../node_modules/date-fns/esm/yearsToMonths/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/yearsToQuarters/index.js
function yearsToQuarters(years) {
  requiredArgs(1, arguments);
  return Math.floor(years * quartersInYear);
}
var init_yearsToQuarters = __esm({
  "../../node_modules/date-fns/esm/yearsToQuarters/index.js"() {
    "use strict";
    init_requiredArgs();
    init_constants();
  }
});

// ../../node_modules/date-fns/esm/index.js
var esm_exports = {};
__export(esm_exports, {
  add: () => add,
  addBusinessDays: () => addBusinessDays,
  addDays: () => addDays,
  addHours: () => addHours,
  addISOWeekYears: () => addISOWeekYears,
  addMilliseconds: () => addMilliseconds,
  addMinutes: () => addMinutes,
  addMonths: () => addMonths,
  addQuarters: () => addQuarters,
  addSeconds: () => addSeconds,
  addWeeks: () => addWeeks,
  addYears: () => addYears,
  areIntervalsOverlapping: () => areIntervalsOverlapping,
  clamp: () => clamp,
  closestIndexTo: () => closestIndexTo,
  closestTo: () => closestTo,
  compareAsc: () => compareAsc,
  compareDesc: () => compareDesc,
  daysInWeek: () => daysInWeek,
  daysInYear: () => daysInYear,
  daysToWeeks: () => daysToWeeks,
  differenceInBusinessDays: () => differenceInBusinessDays,
  differenceInCalendarDays: () => differenceInCalendarDays,
  differenceInCalendarISOWeekYears: () => differenceInCalendarISOWeekYears,
  differenceInCalendarISOWeeks: () => differenceInCalendarISOWeeks,
  differenceInCalendarMonths: () => differenceInCalendarMonths,
  differenceInCalendarQuarters: () => differenceInCalendarQuarters,
  differenceInCalendarWeeks: () => differenceInCalendarWeeks,
  differenceInCalendarYears: () => differenceInCalendarYears,
  differenceInDays: () => differenceInDays,
  differenceInHours: () => differenceInHours,
  differenceInISOWeekYears: () => differenceInISOWeekYears,
  differenceInMilliseconds: () => differenceInMilliseconds,
  differenceInMinutes: () => differenceInMinutes,
  differenceInMonths: () => differenceInMonths,
  differenceInQuarters: () => differenceInQuarters,
  differenceInSeconds: () => differenceInSeconds,
  differenceInWeeks: () => differenceInWeeks,
  differenceInYears: () => differenceInYears,
  eachDayOfInterval: () => eachDayOfInterval,
  eachHourOfInterval: () => eachHourOfInterval,
  eachMinuteOfInterval: () => eachMinuteOfInterval,
  eachMonthOfInterval: () => eachMonthOfInterval,
  eachQuarterOfInterval: () => eachQuarterOfInterval,
  eachWeekOfInterval: () => eachWeekOfInterval,
  eachWeekendOfInterval: () => eachWeekendOfInterval,
  eachWeekendOfMonth: () => eachWeekendOfMonth,
  eachWeekendOfYear: () => eachWeekendOfYear,
  eachYearOfInterval: () => eachYearOfInterval,
  endOfDay: () => endOfDay,
  endOfDecade: () => endOfDecade,
  endOfHour: () => endOfHour,
  endOfISOWeek: () => endOfISOWeek,
  endOfISOWeekYear: () => endOfISOWeekYear,
  endOfMinute: () => endOfMinute,
  endOfMonth: () => endOfMonth,
  endOfQuarter: () => endOfQuarter,
  endOfSecond: () => endOfSecond,
  endOfToday: () => endOfToday,
  endOfTomorrow: () => endOfTomorrow,
  endOfWeek: () => endOfWeek,
  endOfYear: () => endOfYear,
  endOfYesterday: () => endOfYesterday,
  format: () => format,
  formatDistance: () => formatDistance3,
  formatDistanceStrict: () => formatDistanceStrict,
  formatDistanceToNow: () => formatDistanceToNow,
  formatDistanceToNowStrict: () => formatDistanceToNowStrict,
  formatDuration: () => formatDuration,
  formatISO: () => formatISO,
  formatISO9075: () => formatISO9075,
  formatISODuration: () => formatISODuration,
  formatRFC3339: () => formatRFC3339,
  formatRFC7231: () => formatRFC7231,
  formatRelative: () => formatRelative3,
  fromUnixTime: () => fromUnixTime,
  getDate: () => getDate,
  getDay: () => getDay,
  getDayOfYear: () => getDayOfYear,
  getDaysInMonth: () => getDaysInMonth,
  getDaysInYear: () => getDaysInYear,
  getDecade: () => getDecade,
  getDefaultOptions: () => getDefaultOptions2,
  getHours: () => getHours,
  getISODay: () => getISODay,
  getISOWeek: () => getISOWeek,
  getISOWeekYear: () => getISOWeekYear,
  getISOWeeksInYear: () => getISOWeeksInYear,
  getMilliseconds: () => getMilliseconds,
  getMinutes: () => getMinutes,
  getMonth: () => getMonth,
  getOverlappingDaysInIntervals: () => getOverlappingDaysInIntervals,
  getQuarter: () => getQuarter,
  getSeconds: () => getSeconds,
  getTime: () => getTime,
  getUnixTime: () => getUnixTime,
  getWeek: () => getWeek,
  getWeekOfMonth: () => getWeekOfMonth,
  getWeekYear: () => getWeekYear,
  getWeeksInMonth: () => getWeeksInMonth,
  getYear: () => getYear,
  hoursToMilliseconds: () => hoursToMilliseconds,
  hoursToMinutes: () => hoursToMinutes,
  hoursToSeconds: () => hoursToSeconds,
  intervalToDuration: () => intervalToDuration,
  intlFormat: () => intlFormat,
  intlFormatDistance: () => intlFormatDistance,
  isAfter: () => isAfter,
  isBefore: () => isBefore,
  isDate: () => isDate,
  isEqual: () => isEqual,
  isExists: () => isExists,
  isFirstDayOfMonth: () => isFirstDayOfMonth,
  isFriday: () => isFriday,
  isFuture: () => isFuture,
  isLastDayOfMonth: () => isLastDayOfMonth,
  isLeapYear: () => isLeapYear,
  isMatch: () => isMatch,
  isMonday: () => isMonday,
  isPast: () => isPast,
  isSameDay: () => isSameDay,
  isSameHour: () => isSameHour,
  isSameISOWeek: () => isSameISOWeek,
  isSameISOWeekYear: () => isSameISOWeekYear,
  isSameMinute: () => isSameMinute,
  isSameMonth: () => isSameMonth,
  isSameQuarter: () => isSameQuarter,
  isSameSecond: () => isSameSecond,
  isSameWeek: () => isSameWeek,
  isSameYear: () => isSameYear,
  isSaturday: () => isSaturday,
  isSunday: () => isSunday,
  isThisHour: () => isThisHour,
  isThisISOWeek: () => isThisISOWeek,
  isThisMinute: () => isThisMinute,
  isThisMonth: () => isThisMonth,
  isThisQuarter: () => isThisQuarter,
  isThisSecond: () => isThisSecond,
  isThisWeek: () => isThisWeek,
  isThisYear: () => isThisYear,
  isThursday: () => isThursday,
  isToday: () => isToday,
  isTomorrow: () => isTomorrow,
  isTuesday: () => isTuesday,
  isValid: () => isValid,
  isWednesday: () => isWednesday,
  isWeekend: () => isWeekend,
  isWithinInterval: () => isWithinInterval,
  isYesterday: () => isYesterday,
  lastDayOfDecade: () => lastDayOfDecade,
  lastDayOfISOWeek: () => lastDayOfISOWeek,
  lastDayOfISOWeekYear: () => lastDayOfISOWeekYear,
  lastDayOfMonth: () => lastDayOfMonth,
  lastDayOfQuarter: () => lastDayOfQuarter,
  lastDayOfWeek: () => lastDayOfWeek,
  lastDayOfYear: () => lastDayOfYear,
  lightFormat: () => lightFormat,
  max: () => max,
  maxTime: () => maxTime,
  milliseconds: () => milliseconds,
  millisecondsInHour: () => millisecondsInHour,
  millisecondsInMinute: () => millisecondsInMinute,
  millisecondsInSecond: () => millisecondsInSecond,
  millisecondsToHours: () => millisecondsToHours,
  millisecondsToMinutes: () => millisecondsToMinutes,
  millisecondsToSeconds: () => millisecondsToSeconds,
  min: () => min,
  minTime: () => minTime,
  minutesInHour: () => minutesInHour,
  minutesToHours: () => minutesToHours,
  minutesToMilliseconds: () => minutesToMilliseconds,
  minutesToSeconds: () => minutesToSeconds,
  monthsInQuarter: () => monthsInQuarter,
  monthsInYear: () => monthsInYear,
  monthsToQuarters: () => monthsToQuarters,
  monthsToYears: () => monthsToYears,
  nextDay: () => nextDay,
  nextFriday: () => nextFriday,
  nextMonday: () => nextMonday,
  nextSaturday: () => nextSaturday,
  nextSunday: () => nextSunday,
  nextThursday: () => nextThursday,
  nextTuesday: () => nextTuesday,
  nextWednesday: () => nextWednesday,
  parse: () => parse,
  parseISO: () => parseISO,
  parseJSON: () => parseJSON,
  previousDay: () => previousDay,
  previousFriday: () => previousFriday,
  previousMonday: () => previousMonday,
  previousSaturday: () => previousSaturday,
  previousSunday: () => previousSunday,
  previousThursday: () => previousThursday,
  previousTuesday: () => previousTuesday,
  previousWednesday: () => previousWednesday,
  quartersInYear: () => quartersInYear,
  quartersToMonths: () => quartersToMonths,
  quartersToYears: () => quartersToYears,
  roundToNearestMinutes: () => roundToNearestMinutes,
  secondsInDay: () => secondsInDay,
  secondsInHour: () => secondsInHour,
  secondsInMinute: () => secondsInMinute,
  secondsInMonth: () => secondsInMonth,
  secondsInQuarter: () => secondsInQuarter,
  secondsInWeek: () => secondsInWeek,
  secondsInYear: () => secondsInYear,
  secondsToHours: () => secondsToHours,
  secondsToMilliseconds: () => secondsToMilliseconds,
  secondsToMinutes: () => secondsToMinutes,
  set: () => set,
  setDate: () => setDate,
  setDay: () => setDay,
  setDayOfYear: () => setDayOfYear,
  setDefaultOptions: () => setDefaultOptions2,
  setHours: () => setHours,
  setISODay: () => setISODay,
  setISOWeek: () => setISOWeek,
  setISOWeekYear: () => setISOWeekYear,
  setMilliseconds: () => setMilliseconds,
  setMinutes: () => setMinutes,
  setMonth: () => setMonth,
  setQuarter: () => setQuarter,
  setSeconds: () => setSeconds,
  setWeek: () => setWeek,
  setWeekYear: () => setWeekYear,
  setYear: () => setYear,
  startOfDay: () => startOfDay,
  startOfDecade: () => startOfDecade,
  startOfHour: () => startOfHour,
  startOfISOWeek: () => startOfISOWeek,
  startOfISOWeekYear: () => startOfISOWeekYear,
  startOfMinute: () => startOfMinute,
  startOfMonth: () => startOfMonth,
  startOfQuarter: () => startOfQuarter,
  startOfSecond: () => startOfSecond,
  startOfToday: () => startOfToday,
  startOfTomorrow: () => startOfTomorrow,
  startOfWeek: () => startOfWeek,
  startOfWeekYear: () => startOfWeekYear,
  startOfYear: () => startOfYear,
  startOfYesterday: () => startOfYesterday,
  sub: () => sub,
  subBusinessDays: () => subBusinessDays,
  subDays: () => subDays,
  subHours: () => subHours,
  subISOWeekYears: () => subISOWeekYears,
  subMilliseconds: () => subMilliseconds,
  subMinutes: () => subMinutes,
  subMonths: () => subMonths,
  subQuarters: () => subQuarters,
  subSeconds: () => subSeconds,
  subWeeks: () => subWeeks,
  subYears: () => subYears,
  toDate: () => toDate,
  weeksToDays: () => weeksToDays,
  yearsToMonths: () => yearsToMonths,
  yearsToQuarters: () => yearsToQuarters
});
var init_esm = __esm({
  "../../node_modules/date-fns/esm/index.js"() {
    "use strict";
    init_add();
    init_addBusinessDays();
    init_addDays();
    init_addHours();
    init_addISOWeekYears();
    init_addMilliseconds();
    init_addMinutes();
    init_addMonths();
    init_addQuarters();
    init_addSeconds();
    init_addWeeks();
    init_addYears();
    init_areIntervalsOverlapping();
    init_clamp();
    init_closestIndexTo();
    init_closestTo();
    init_compareAsc();
    init_compareDesc();
    init_daysToWeeks();
    init_differenceInBusinessDays();
    init_differenceInCalendarDays();
    init_differenceInCalendarISOWeekYears();
    init_differenceInCalendarISOWeeks();
    init_differenceInCalendarMonths();
    init_differenceInCalendarQuarters();
    init_differenceInCalendarWeeks();
    init_differenceInCalendarYears();
    init_differenceInDays();
    init_differenceInHours();
    init_differenceInISOWeekYears();
    init_differenceInMilliseconds();
    init_differenceInMinutes();
    init_differenceInMonths();
    init_differenceInQuarters();
    init_differenceInSeconds();
    init_differenceInWeeks();
    init_differenceInYears();
    init_eachDayOfInterval();
    init_eachHourOfInterval();
    init_eachMinuteOfInterval();
    init_eachMonthOfInterval();
    init_eachQuarterOfInterval();
    init_eachWeekOfInterval();
    init_eachWeekendOfInterval();
    init_eachWeekendOfMonth();
    init_eachWeekendOfYear();
    init_eachYearOfInterval();
    init_endOfDay();
    init_endOfDecade();
    init_endOfHour();
    init_endOfISOWeek();
    init_endOfISOWeekYear();
    init_endOfMinute();
    init_endOfMonth();
    init_endOfQuarter();
    init_endOfSecond();
    init_endOfToday();
    init_endOfTomorrow();
    init_endOfWeek();
    init_endOfYear();
    init_endOfYesterday();
    init_format();
    init_formatDistance2();
    init_formatDistanceStrict();
    init_formatDistanceToNow();
    init_formatDistanceToNowStrict();
    init_formatDuration();
    init_formatISO();
    init_formatISO9075();
    init_formatISODuration();
    init_formatRFC3339();
    init_formatRFC7231();
    init_formatRelative2();
    init_fromUnixTime();
    init_getDate();
    init_getDay();
    init_getDayOfYear();
    init_getDaysInMonth();
    init_getDaysInYear();
    init_getDecade();
    init_getDefaultOptions();
    init_getHours();
    init_getISODay();
    init_getISOWeek();
    init_getISOWeekYear();
    init_getISOWeeksInYear();
    init_getMilliseconds();
    init_getMinutes();
    init_getMonth();
    init_getOverlappingDaysInIntervals();
    init_getQuarter();
    init_getSeconds();
    init_getTime();
    init_getUnixTime();
    init_getWeek();
    init_getWeekOfMonth();
    init_getWeekYear();
    init_getWeeksInMonth();
    init_getYear();
    init_hoursToMilliseconds();
    init_hoursToMinutes();
    init_hoursToSeconds();
    init_intervalToDuration();
    init_intlFormat();
    init_intlFormatDistance();
    init_isAfter();
    init_isBefore();
    init_isDate();
    init_isEqual();
    init_isExists();
    init_isFirstDayOfMonth();
    init_isFriday();
    init_isFuture();
    init_isLastDayOfMonth();
    init_isLeapYear();
    init_isMatch();
    init_isMonday();
    init_isPast();
    init_isSameDay();
    init_isSameHour();
    init_isSameISOWeek();
    init_isSameISOWeekYear();
    init_isSameMinute();
    init_isSameMonth();
    init_isSameQuarter();
    init_isSameSecond();
    init_isSameWeek();
    init_isSameYear();
    init_isSaturday();
    init_isSunday();
    init_isThisHour();
    init_isThisISOWeek();
    init_isThisMinute();
    init_isThisMonth();
    init_isThisQuarter();
    init_isThisSecond();
    init_isThisWeek();
    init_isThisYear();
    init_isThursday();
    init_isToday();
    init_isTomorrow();
    init_isTuesday();
    init_isValid();
    init_isWednesday();
    init_isWeekend();
    init_isWithinInterval();
    init_isYesterday();
    init_lastDayOfDecade();
    init_lastDayOfISOWeek();
    init_lastDayOfISOWeekYear();
    init_lastDayOfMonth();
    init_lastDayOfQuarter();
    init_lastDayOfWeek();
    init_lastDayOfYear();
    init_lightFormat();
    init_max();
    init_milliseconds();
    init_millisecondsToHours();
    init_millisecondsToMinutes();
    init_millisecondsToSeconds();
    init_min();
    init_minutesToHours();
    init_minutesToMilliseconds();
    init_minutesToSeconds();
    init_monthsToQuarters();
    init_monthsToYears();
    init_nextDay();
    init_nextFriday();
    init_nextMonday();
    init_nextSaturday();
    init_nextSunday();
    init_nextThursday();
    init_nextTuesday();
    init_nextWednesday();
    init_parse();
    init_parseISO();
    init_parseJSON();
    init_previousDay();
    init_previousFriday();
    init_previousMonday();
    init_previousSaturday();
    init_previousSunday();
    init_previousThursday();
    init_previousTuesday();
    init_previousWednesday();
    init_quartersToMonths();
    init_quartersToYears();
    init_roundToNearestMinutes();
    init_secondsToHours();
    init_secondsToMilliseconds();
    init_secondsToMinutes();
    init_set();
    init_setDate();
    init_setDay();
    init_setDayOfYear();
    init_setDefaultOptions();
    init_setHours();
    init_setISODay();
    init_setISOWeek();
    init_setISOWeekYear();
    init_setMilliseconds();
    init_setMinutes();
    init_setMonth();
    init_setQuarter();
    init_setSeconds();
    init_setWeek();
    init_setWeekYear();
    init_setYear();
    init_startOfDay();
    init_startOfDecade();
    init_startOfHour();
    init_startOfISOWeek();
    init_startOfISOWeekYear();
    init_startOfMinute();
    init_startOfMonth();
    init_startOfQuarter();
    init_startOfSecond();
    init_startOfToday();
    init_startOfTomorrow();
    init_startOfWeek();
    init_startOfWeekYear();
    init_startOfYear();
    init_startOfYesterday();
    init_sub();
    init_subBusinessDays();
    init_subDays();
    init_subHours();
    init_subISOWeekYears();
    init_subMilliseconds();
    init_subMinutes();
    init_subMonths();
    init_subQuarters();
    init_subSeconds();
    init_subWeeks();
    init_subYears();
    init_toDate();
    init_weeksToDays();
    init_yearsToMonths();
    init_yearsToQuarters();
    init_constants();
  }
});

// ../../node_modules/@babel/runtime/helpers/interopRequireDefault.js
var require_interopRequireDefault = __commonJS({
  "../../node_modules/@babel/runtime/helpers/interopRequireDefault.js"(exports2, module2) {
    "use strict";
    function _interopRequireDefault(e2) {
      return e2 && e2.__esModule ? e2 : {
        "default": e2
      };
    }
    module2.exports = _interopRequireDefault, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/@babel/runtime/helpers/typeof.js
var require_typeof = __commonJS({
  "../../node_modules/@babel/runtime/helpers/typeof.js"(exports2, module2) {
    "use strict";
    function _typeof2(o) {
      "@babel/helpers - typeof";
      return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
        return typeof o2;
      } : function(o2) {
        return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
      }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(o);
    }
    module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
  }
});

// ../../node_modules/date-fns/_lib/requiredArgs/index.js
var require_requiredArgs = __commonJS({
  "../../node_modules/date-fns/_lib/requiredArgs/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = requiredArgs2;
    function requiredArgs2(required, args) {
      if (args.length < required) {
        throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
      }
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/isDate/index.js
var require_isDate = __commonJS({
  "../../node_modules/date-fns/isDate/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = isDate2;
    var _typeof2 = _interopRequireDefault(require_typeof());
    var _index = _interopRequireDefault(require_requiredArgs());
    function isDate2(value) {
      (0, _index.default)(1, arguments);
      return value instanceof Date || (0, _typeof2.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/toDate/index.js
var require_toDate = __commonJS({
  "../../node_modules/date-fns/toDate/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = toDate2;
    var _typeof2 = _interopRequireDefault(require_typeof());
    var _index = _interopRequireDefault(require_requiredArgs());
    function toDate2(argument) {
      (0, _index.default)(1, arguments);
      var argStr = Object.prototype.toString.call(argument);
      if (argument instanceof Date || (0, _typeof2.default)(argument) === "object" && argStr === "[object Date]") {
        return new Date(argument.getTime());
      } else if (typeof argument === "number" || argStr === "[object Number]") {
        return new Date(argument);
      } else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
          console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
          console.warn(new Error().stack);
        }
        return /* @__PURE__ */ new Date(NaN);
      }
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/isValid/index.js
var require_isValid = __commonJS({
  "../../node_modules/date-fns/isValid/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = isValid2;
    var _index = _interopRequireDefault(require_isDate());
    var _index2 = _interopRequireDefault(require_toDate());
    var _index3 = _interopRequireDefault(require_requiredArgs());
    function isValid2(dirtyDate) {
      (0, _index3.default)(1, arguments);
      if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== "number") {
        return false;
      }
      var date = (0, _index2.default)(dirtyDate);
      return !isNaN(Number(date));
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/toInteger/index.js
var require_toInteger = __commonJS({
  "../../node_modules/date-fns/_lib/toInteger/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = toInteger2;
    function toInteger2(dirtyNumber) {
      if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
        return NaN;
      }
      var number = Number(dirtyNumber);
      if (isNaN(number)) {
        return number;
      }
      return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/addMilliseconds/index.js
var require_addMilliseconds = __commonJS({
  "../../node_modules/date-fns/addMilliseconds/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = addMilliseconds2;
    var _index = _interopRequireDefault(require_toInteger());
    var _index2 = _interopRequireDefault(require_toDate());
    var _index3 = _interopRequireDefault(require_requiredArgs());
    function addMilliseconds2(dirtyDate, dirtyAmount) {
      (0, _index3.default)(2, arguments);
      var timestamp = (0, _index2.default)(dirtyDate).getTime();
      var amount = (0, _index.default)(dirtyAmount);
      return new Date(timestamp + amount);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/subMilliseconds/index.js
var require_subMilliseconds = __commonJS({
  "../../node_modules/date-fns/subMilliseconds/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = subMilliseconds2;
    var _index = _interopRequireDefault(require_addMilliseconds());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var _index3 = _interopRequireDefault(require_toInteger());
    function subMilliseconds2(dirtyDate, dirtyAmount) {
      (0, _index2.default)(2, arguments);
      var amount = (0, _index3.default)(dirtyAmount);
      return (0, _index.default)(dirtyDate, -amount);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getUTCDayOfYear/index.js
var require_getUTCDayOfYear = __commonJS({
  "../../node_modules/date-fns/_lib/getUTCDayOfYear/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getUTCDayOfYear2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var MILLISECONDS_IN_DAY4 = 864e5;
    function getUTCDayOfYear2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var timestamp = date.getTime();
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
      var startOfYearTimestamp = date.getTime();
      var difference = timestamp - startOfYearTimestamp;
      return Math.floor(difference / MILLISECONDS_IN_DAY4) + 1;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/startOfUTCISOWeek/index.js
var require_startOfUTCISOWeek = __commonJS({
  "../../node_modules/date-fns/_lib/startOfUTCISOWeek/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = startOfUTCISOWeek2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    function startOfUTCISOWeek2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var weekStartsOn = 1;
      var date = (0, _index.default)(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getUTCISOWeekYear/index.js
var require_getUTCISOWeekYear = __commonJS({
  "../../node_modules/date-fns/_lib/getUTCISOWeekYear/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getUTCISOWeekYear2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var _index3 = _interopRequireDefault(require_startOfUTCISOWeek());
    function getUTCISOWeekYear2(dirtyDate) {
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var year = date.getUTCFullYear();
      var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
      fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
      fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
      var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
      fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
      fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/startOfUTCISOWeekYear/index.js
var require_startOfUTCISOWeekYear = __commonJS({
  "../../node_modules/date-fns/_lib/startOfUTCISOWeekYear/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = startOfUTCISOWeekYear2;
    var _index = _interopRequireDefault(require_getUTCISOWeekYear());
    var _index2 = _interopRequireDefault(require_startOfUTCISOWeek());
    var _index3 = _interopRequireDefault(require_requiredArgs());
    function startOfUTCISOWeekYear2(dirtyDate) {
      (0, _index3.default)(1, arguments);
      var year = (0, _index.default)(dirtyDate);
      var fourthOfJanuary = /* @__PURE__ */ new Date(0);
      fourthOfJanuary.setUTCFullYear(year, 0, 4);
      fourthOfJanuary.setUTCHours(0, 0, 0, 0);
      var date = (0, _index2.default)(fourthOfJanuary);
      return date;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getUTCISOWeek/index.js
var require_getUTCISOWeek = __commonJS({
  "../../node_modules/date-fns/_lib/getUTCISOWeek/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getUTCISOWeek2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_startOfUTCISOWeek());
    var _index3 = _interopRequireDefault(require_startOfUTCISOWeekYear());
    var _index4 = _interopRequireDefault(require_requiredArgs());
    var MILLISECONDS_IN_WEEK8 = 6048e5;
    function getUTCISOWeek2(dirtyDate) {
      (0, _index4.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
      return Math.round(diff / MILLISECONDS_IN_WEEK8) + 1;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/defaultOptions/index.js
var require_defaultOptions = __commonJS({
  "../../node_modules/date-fns/_lib/defaultOptions/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.getDefaultOptions = getDefaultOptions3;
    exports2.setDefaultOptions = setDefaultOptions3;
    var defaultOptions2 = {};
    function getDefaultOptions3() {
      return defaultOptions2;
    }
    function setDefaultOptions3(newOptions) {
      defaultOptions2 = newOptions;
    }
  }
});

// ../../node_modules/date-fns/_lib/startOfUTCWeek/index.js
var require_startOfUTCWeek = __commonJS({
  "../../node_modules/date-fns/_lib/startOfUTCWeek/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = startOfUTCWeek2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var _index3 = _interopRequireDefault(require_toInteger());
    var _index4 = require_defaultOptions();
    function startOfUTCWeek2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var defaultOptions2 = (0, _index4.getDefaultOptions)();
      var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      }
      var date = (0, _index.default)(dirtyDate);
      var day = date.getUTCDay();
      var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
      date.setUTCDate(date.getUTCDate() - diff);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getUTCWeekYear/index.js
var require_getUTCWeekYear = __commonJS({
  "../../node_modules/date-fns/_lib/getUTCWeekYear/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getUTCWeekYear2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var _index3 = _interopRequireDefault(require_startOfUTCWeek());
    var _index4 = _interopRequireDefault(require_toInteger());
    var _index5 = require_defaultOptions();
    function getUTCWeekYear2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var year = date.getUTCFullYear();
      var defaultOptions2 = (0, _index5.getDefaultOptions)();
      var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      }
      var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
      firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
      firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
      var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
      var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
      firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
      var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
      if (date.getTime() >= startOfNextYear.getTime()) {
        return year + 1;
      } else if (date.getTime() >= startOfThisYear.getTime()) {
        return year;
      } else {
        return year - 1;
      }
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/startOfUTCWeekYear/index.js
var require_startOfUTCWeekYear = __commonJS({
  "../../node_modules/date-fns/_lib/startOfUTCWeekYear/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = startOfUTCWeekYear2;
    var _index = _interopRequireDefault(require_getUTCWeekYear());
    var _index2 = _interopRequireDefault(require_requiredArgs());
    var _index3 = _interopRequireDefault(require_startOfUTCWeek());
    var _index4 = _interopRequireDefault(require_toInteger());
    var _index5 = require_defaultOptions();
    function startOfUTCWeekYear2(dirtyDate, options) {
      var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
      (0, _index2.default)(1, arguments);
      var defaultOptions2 = (0, _index5.getDefaultOptions)();
      var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
      var year = (0, _index.default)(dirtyDate, options);
      var firstWeek = /* @__PURE__ */ new Date(0);
      firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
      firstWeek.setUTCHours(0, 0, 0, 0);
      var date = (0, _index3.default)(firstWeek, options);
      return date;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getUTCWeek/index.js
var require_getUTCWeek = __commonJS({
  "../../node_modules/date-fns/_lib/getUTCWeek/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getUTCWeek2;
    var _index = _interopRequireDefault(require_toDate());
    var _index2 = _interopRequireDefault(require_startOfUTCWeek());
    var _index3 = _interopRequireDefault(require_startOfUTCWeekYear());
    var _index4 = _interopRequireDefault(require_requiredArgs());
    var MILLISECONDS_IN_WEEK8 = 6048e5;
    function getUTCWeek2(dirtyDate, options) {
      (0, _index4.default)(1, arguments);
      var date = (0, _index.default)(dirtyDate);
      var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
      return Math.round(diff / MILLISECONDS_IN_WEEK8) + 1;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/addLeadingZeros/index.js
var require_addLeadingZeros = __commonJS({
  "../../node_modules/date-fns/_lib/addLeadingZeros/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = addLeadingZeros2;
    function addLeadingZeros2(number, targetLength) {
      var sign = number < 0 ? "-" : "";
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = "0" + output;
      }
      return sign + output;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/format/lightFormatters/index.js
var require_lightFormatters = __commonJS({
  "../../node_modules/date-fns/_lib/format/lightFormatters/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_addLeadingZeros());
    var formatters3 = {
      // Year
      y: function y3(date, token) {
        var signedYear = date.getUTCFullYear();
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === "yy" ? year % 100 : year, token.length);
      },
      // Month
      M: function M3(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, _index.default)(month + 1, 2);
      },
      // Day of the month
      d: function d3(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
      },
      // AM or PM
      a: function a3(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return dayPeriodEnumValue.toUpperCase();
          case "aaa":
            return dayPeriodEnumValue;
          case "aaaaa":
            return dayPeriodEnumValue[0];
          case "aaaa":
          default:
            return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
      },
      // Hour [1-12]
      h: function h3(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
      },
      // Hour [0-23]
      H: function H3(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
      },
      // Minute
      m: function m3(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
      },
      // Second
      s: function s3(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
      },
      // Fraction of second
      S: function S3(date, token) {
        var numberOfDigits = token.length;
        var milliseconds2 = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds2 * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
      }
    };
    var _default = formatters3;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/format/formatters/index.js
var require_formatters = __commonJS({
  "../../node_modules/date-fns/_lib/format/formatters/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_getUTCDayOfYear());
    var _index2 = _interopRequireDefault(require_getUTCISOWeek());
    var _index3 = _interopRequireDefault(require_getUTCISOWeekYear());
    var _index4 = _interopRequireDefault(require_getUTCWeek());
    var _index5 = _interopRequireDefault(require_getUTCWeekYear());
    var _index6 = _interopRequireDefault(require_addLeadingZeros());
    var _index7 = _interopRequireDefault(require_lightFormatters());
    var dayPeriodEnum2 = {
      am: "am",
      pm: "pm",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    };
    var formatters3 = {
      // Era
      G: function G2(date, token, localize84) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch (token) {
          // AD, BC
          case "G":
          case "GG":
          case "GGG":
            return localize84.era(era, {
              width: "abbreviated"
            });
          // A, B
          case "GGGGG":
            return localize84.era(era, {
              width: "narrow"
            });
          // Anno Domini, Before Christ
          case "GGGG":
          default:
            return localize84.era(era, {
              width: "wide"
            });
        }
      },
      // Year
      y: function y3(date, token, localize84) {
        if (token === "yo") {
          var signedYear = date.getUTCFullYear();
          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return localize84.ordinalNumber(year, {
            unit: "year"
          });
        }
        return _index7.default.y(date, token);
      },
      // Local week-numbering year
      Y: function Y2(date, token, localize84, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        if (token === "YY") {
          var twoDigitYear = weekYear % 100;
          return (0, _index6.default)(twoDigitYear, 2);
        }
        if (token === "Yo") {
          return localize84.ordinalNumber(weekYear, {
            unit: "year"
          });
        }
        return (0, _index6.default)(weekYear, token.length);
      },
      // ISO week-numbering year
      R: function R2(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        return (0, _index6.default)(isoWeekYear, token.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function u2(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
      },
      // Quarter
      Q: function Q2(date, token, localize84) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "Q":
            return String(quarter);
          // 01, 02, 03, 04
          case "QQ":
            return (0, _index6.default)(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "Qo":
            return localize84.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "QQQ":
            return localize84.quarter(quarter, {
              width: "abbreviated",
              context: "formatting"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "QQQQQ":
            return localize84.quarter(quarter, {
              width: "narrow",
              context: "formatting"
            });
          // 1st quarter, 2nd quarter, ...
          case "QQQQ":
          default:
            return localize84.quarter(quarter, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone quarter
      q: function q2(date, token, localize84) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch (token) {
          // 1, 2, 3, 4
          case "q":
            return String(quarter);
          // 01, 02, 03, 04
          case "qq":
            return (0, _index6.default)(quarter, 2);
          // 1st, 2nd, 3rd, 4th
          case "qo":
            return localize84.ordinalNumber(quarter, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "qqq":
            return localize84.quarter(quarter, {
              width: "abbreviated",
              context: "standalone"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "qqqqq":
            return localize84.quarter(quarter, {
              width: "narrow",
              context: "standalone"
            });
          // 1st quarter, 2nd quarter, ...
          case "qqqq":
          default:
            return localize84.quarter(quarter, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Month
      M: function M3(date, token, localize84) {
        var month = date.getUTCMonth();
        switch (token) {
          case "M":
          case "MM":
            return _index7.default.M(date, token);
          // 1st, 2nd, ..., 12th
          case "Mo":
            return localize84.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "MMM":
            return localize84.month(month, {
              width: "abbreviated",
              context: "formatting"
            });
          // J, F, ..., D
          case "MMMMM":
            return localize84.month(month, {
              width: "narrow",
              context: "formatting"
            });
          // January, February, ..., December
          case "MMMM":
          default:
            return localize84.month(month, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone month
      L: function L2(date, token, localize84) {
        var month = date.getUTCMonth();
        switch (token) {
          // 1, 2, ..., 12
          case "L":
            return String(month + 1);
          // 01, 02, ..., 12
          case "LL":
            return (0, _index6.default)(month + 1, 2);
          // 1st, 2nd, ..., 12th
          case "Lo":
            return localize84.ordinalNumber(month + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "LLL":
            return localize84.month(month, {
              width: "abbreviated",
              context: "standalone"
            });
          // J, F, ..., D
          case "LLLLL":
            return localize84.month(month, {
              width: "narrow",
              context: "standalone"
            });
          // January, February, ..., December
          case "LLLL":
          default:
            return localize84.month(month, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Local week of year
      w: function w2(date, token, localize84, options) {
        var week2 = (0, _index4.default)(date, options);
        if (token === "wo") {
          return localize84.ordinalNumber(week2, {
            unit: "week"
          });
        }
        return (0, _index6.default)(week2, token.length);
      },
      // ISO week of year
      I: function I2(date, token, localize84) {
        var isoWeek = (0, _index2.default)(date);
        if (token === "Io") {
          return localize84.ordinalNumber(isoWeek, {
            unit: "week"
          });
        }
        return (0, _index6.default)(isoWeek, token.length);
      },
      // Day of the month
      d: function d3(date, token, localize84) {
        if (token === "do") {
          return localize84.ordinalNumber(date.getUTCDate(), {
            unit: "date"
          });
        }
        return _index7.default.d(date, token);
      },
      // Day of year
      D: function D2(date, token, localize84) {
        var dayOfYear = (0, _index.default)(date);
        if (token === "Do") {
          return localize84.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
          });
        }
        return (0, _index6.default)(dayOfYear, token.length);
      },
      // Day of week
      E: function E2(date, token, localize84) {
        var dayOfWeek = date.getUTCDay();
        switch (token) {
          // Tue
          case "E":
          case "EE":
          case "EEE":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "EEEEE":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "EEEEEE":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "EEEE":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Local day of week
      e: function e2(date, token, localize84, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case "e":
            return String(localDayOfWeek);
          // Padded numerical value
          case "ee":
            return (0, _index6.default)(localDayOfWeek, 2);
          // 1st, 2nd, ..., 7th
          case "eo":
            return localize84.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "eee":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "eeeee":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "eeeeee":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "eeee":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone local day of week
      c: function c2(date, token, localize84, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch (token) {
          // Numerical value (same as in `e`)
          case "c":
            return String(localDayOfWeek);
          // Padded numerical value
          case "cc":
            return (0, _index6.default)(localDayOfWeek, token.length);
          // 1st, 2nd, ..., 7th
          case "co":
            return localize84.ordinalNumber(localDayOfWeek, {
              unit: "day"
            });
          case "ccc":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "standalone"
            });
          // T
          case "ccccc":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "standalone"
            });
          // Tu
          case "cccccc":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "standalone"
            });
          // Tuesday
          case "cccc":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // ISO day of week
      i: function i2(date, token, localize84) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch (token) {
          // 2
          case "i":
            return String(isoDayOfWeek);
          // 02
          case "ii":
            return (0, _index6.default)(isoDayOfWeek, token.length);
          // 2nd
          case "io":
            return localize84.ordinalNumber(isoDayOfWeek, {
              unit: "day"
            });
          // Tue
          case "iii":
            return localize84.day(dayOfWeek, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "iiiii":
            return localize84.day(dayOfWeek, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "iiiiii":
            return localize84.day(dayOfWeek, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "iiii":
          default:
            return localize84.day(dayOfWeek, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM or PM
      a: function a3(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch (token) {
          case "a":
          case "aa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "aaa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "aaaaa":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM, PM, midnight, noon
      b: function b2(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) {
          dayPeriodEnumValue = dayPeriodEnum2.noon;
        } else if (hours === 0) {
          dayPeriodEnumValue = dayPeriodEnum2.midnight;
        } else {
          dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        }
        switch (token) {
          case "b":
          case "bb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "bbb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "bbbbb":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function B2(date, token, localize84) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) {
          dayPeriodEnumValue = dayPeriodEnum2.evening;
        } else if (hours >= 12) {
          dayPeriodEnumValue = dayPeriodEnum2.afternoon;
        } else if (hours >= 4) {
          dayPeriodEnumValue = dayPeriodEnum2.morning;
        } else {
          dayPeriodEnumValue = dayPeriodEnum2.night;
        }
        switch (token) {
          case "B":
          case "BB":
          case "BBB":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "abbreviated",
              context: "formatting"
            });
          case "BBBBB":
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return localize84.dayPeriod(dayPeriodEnumValue, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Hour [1-12]
      h: function h3(date, token, localize84) {
        if (token === "ho") {
          var hours = date.getUTCHours() % 12;
          if (hours === 0) hours = 12;
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return _index7.default.h(date, token);
      },
      // Hour [0-23]
      H: function H3(date, token, localize84) {
        if (token === "Ho") {
          return localize84.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
          });
        }
        return _index7.default.H(date, token);
      },
      // Hour [0-11]
      K: function K2(date, token, localize84) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") {
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return (0, _index6.default)(hours, token.length);
      },
      // Hour [1-24]
      k: function k2(date, token, localize84) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") {
          return localize84.ordinalNumber(hours, {
            unit: "hour"
          });
        }
        return (0, _index6.default)(hours, token.length);
      },
      // Minute
      m: function m3(date, token, localize84) {
        if (token === "mo") {
          return localize84.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
          });
        }
        return _index7.default.m(date, token);
      },
      // Second
      s: function s3(date, token, localize84) {
        if (token === "so") {
          return localize84.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
          });
        }
        return _index7.default.s(date, token);
      },
      // Fraction of second
      S: function S3(date, token) {
        return _index7.default.S(date, token);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function X2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) {
          return "Z";
        }
        switch (token) {
          // Hours and optional minutes
          case "X":
            return formatTimezoneWithOptionalMinutes2(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return formatTimezone2(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function x2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Hours and optional minutes
          case "x":
            return formatTimezoneWithOptionalMinutes2(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return formatTimezone2(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimiter
          default:
            return formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (GMT)
      O: function O2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + formatTimezoneShort2(timezoneOffset, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (specific non-location)
      z: function z110(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch (token) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return "GMT" + formatTimezoneShort2(timezoneOffset, ":");
          // Long
          case "zzzz":
          default:
            return "GMT" + formatTimezone2(timezoneOffset, ":");
        }
      },
      // Seconds timestamp
      t: function t2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1e3);
        return (0, _index6.default)(timestamp, token.length);
      },
      // Milliseconds timestamp
      T: function T2(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
      }
    };
    function formatTimezoneShort2(offset, dirtyDelimiter) {
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      if (minutes === 0) {
        return sign + String(hours);
      }
      var delimiter = dirtyDelimiter || "";
      return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
    }
    function formatTimezoneWithOptionalMinutes2(offset, dirtyDelimiter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
      }
      return formatTimezone2(offset, dirtyDelimiter);
    }
    function formatTimezone2(offset, dirtyDelimiter) {
      var delimiter = dirtyDelimiter || "";
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
      var minutes = (0, _index6.default)(absOffset % 60, 2);
      return sign + hours + delimiter + minutes;
    }
    var _default = formatters3;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/format/longFormatters/index.js
var require_longFormatters = __commonJS({
  "../../node_modules/date-fns/_lib/format/longFormatters/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var dateLongFormatter3 = function dateLongFormatter4(pattern, formatLong92) {
      switch (pattern) {
        case "P":
          return formatLong92.date({
            width: "short"
          });
        case "PP":
          return formatLong92.date({
            width: "medium"
          });
        case "PPP":
          return formatLong92.date({
            width: "long"
          });
        case "PPPP":
        default:
          return formatLong92.date({
            width: "full"
          });
      }
    };
    var timeLongFormatter3 = function timeLongFormatter4(pattern, formatLong92) {
      switch (pattern) {
        case "p":
          return formatLong92.time({
            width: "short"
          });
        case "pp":
          return formatLong92.time({
            width: "medium"
          });
        case "ppp":
          return formatLong92.time({
            width: "long"
          });
        case "pppp":
        default:
          return formatLong92.time({
            width: "full"
          });
      }
    };
    var dateTimeLongFormatter3 = function dateTimeLongFormatter4(pattern, formatLong92) {
      var matchResult = pattern.match(/(P+)(p+)?/) || [];
      var datePattern = matchResult[1];
      var timePattern = matchResult[2];
      if (!timePattern) {
        return dateLongFormatter3(pattern, formatLong92);
      }
      var dateTimeFormat;
      switch (datePattern) {
        case "P":
          dateTimeFormat = formatLong92.dateTime({
            width: "short"
          });
          break;
        case "PP":
          dateTimeFormat = formatLong92.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          dateTimeFormat = formatLong92.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          dateTimeFormat = formatLong92.dateTime({
            width: "full"
          });
          break;
      }
      return dateTimeFormat.replace("{{date}}", dateLongFormatter3(datePattern, formatLong92)).replace("{{time}}", timeLongFormatter3(timePattern, formatLong92));
    };
    var longFormatters2 = {
      p: timeLongFormatter3,
      P: dateTimeLongFormatter3
    };
    var _default = longFormatters2;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js
var require_getTimezoneOffsetInMilliseconds = __commonJS({
  "../../node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getTimezoneOffsetInMilliseconds2;
    function getTimezoneOffsetInMilliseconds2(date) {
      var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
      utcDate.setUTCFullYear(date.getFullYear());
      return date.getTime() - utcDate.getTime();
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/protectedTokens/index.js
var require_protectedTokens = __commonJS({
  "../../node_modules/date-fns/_lib/protectedTokens/index.js"(exports2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.isProtectedDayOfYearToken = isProtectedDayOfYearToken2;
    exports2.isProtectedWeekYearToken = isProtectedWeekYearToken2;
    exports2.throwProtectedError = throwProtectedError2;
    var protectedDayOfYearTokens2 = ["D", "DD"];
    var protectedWeekYearTokens2 = ["YY", "YYYY"];
    function isProtectedDayOfYearToken2(token) {
      return protectedDayOfYearTokens2.indexOf(token) !== -1;
    }
    function isProtectedWeekYearToken2(token) {
      return protectedWeekYearTokens2.indexOf(token) !== -1;
    }
    function throwProtectedError2(token, format2, input) {
      if (token === "YYYY") {
        throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === "YY") {
        throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === "D") {
        throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      } else if (token === "DD") {
        throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
      }
    }
  }
});

// ../../node_modules/date-fns/locale/en-US/_lib/formatDistance/index.js
var require_formatDistance = __commonJS({
  "../../node_modules/date-fns/locale/en-US/_lib/formatDistance/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var formatDistanceLocale83 = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    };
    var formatDistance168 = function formatDistance169(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale83[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "in " + result;
        } else {
          return result + " ago";
        }
      }
      return result;
    };
    var _default = formatDistance168;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/_lib/buildFormatLongFn/index.js
var require_buildFormatLongFn = __commonJS({
  "../../node_modules/date-fns/locale/_lib/buildFormatLongFn/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = buildFormatLongFn2;
    function buildFormatLongFn2(args) {
      return function() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format2 = args.formats[width] || args.formats[args.defaultWidth];
        return format2;
      };
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/en-US/_lib/formatLong/index.js
var require_formatLong = __commonJS({
  "../../node_modules/date-fns/locale/en-US/_lib/formatLong/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_buildFormatLongFn());
    var dateFormats92 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    var timeFormats92 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    var dateTimeFormats92 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    var formatLong92 = {
      date: (0, _index.default)({
        formats: dateFormats92,
        defaultWidth: "full"
      }),
      time: (0, _index.default)({
        formats: timeFormats92,
        defaultWidth: "full"
      }),
      dateTime: (0, _index.default)({
        formats: dateTimeFormats92,
        defaultWidth: "full"
      })
    };
    var _default = formatLong92;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/en-US/_lib/formatRelative/index.js
var require_formatRelative = __commonJS({
  "../../node_modules/date-fns/locale/en-US/_lib/formatRelative/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var formatRelativeLocale84 = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    };
    var formatRelative168 = function formatRelative169(token, _date, _baseDate, _options) {
      return formatRelativeLocale84[token];
    };
    var _default = formatRelative168;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/_lib/buildLocalizeFn/index.js
var require_buildLocalizeFn = __commonJS({
  "../../node_modules/date-fns/locale/_lib/buildLocalizeFn/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = buildLocalizeFn2;
    function buildLocalizeFn2(args) {
      return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
          var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
          var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
          valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
          var _defaultWidth = args.defaultWidth;
          var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
          valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index];
      };
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/en-US/_lib/localize/index.js
var require_localize = __commonJS({
  "../../node_modules/date-fns/locale/en-US/_lib/localize/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_buildLocalizeFn());
    var eraValues84 = {
      narrow: ["B", "A"],
      abbreviated: ["BC", "AD"],
      wide: ["Before Christ", "Anno Domini"]
    };
    var quarterValues84 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
    };
    var monthValues84 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    var dayValues84 = {
      narrow: ["S", "M", "T", "W", "T", "F", "S"],
      short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    };
    var dayPeriodValues84 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      }
    };
    var formattingDayPeriodValues69 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      }
    };
    var ordinalNumber167 = function ordinalNumber168(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "st";
          case 2:
            return number + "nd";
          case 3:
            return number + "rd";
        }
      }
      return number + "th";
    };
    var localize84 = {
      ordinalNumber: ordinalNumber167,
      era: (0, _index.default)({
        values: eraValues84,
        defaultWidth: "wide"
      }),
      quarter: (0, _index.default)({
        values: quarterValues84,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback84(quarter) {
          return quarter - 1;
        }
      }),
      month: (0, _index.default)({
        values: monthValues84,
        defaultWidth: "wide"
      }),
      day: (0, _index.default)({
        values: dayValues84,
        defaultWidth: "wide"
      }),
      dayPeriod: (0, _index.default)({
        values: dayPeriodValues84,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues69,
        defaultFormattingWidth: "wide"
      })
    };
    var _default = localize84;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/_lib/buildMatchFn/index.js
var require_buildMatchFn = __commonJS({
  "../../node_modules/date-fns/locale/_lib/buildMatchFn/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = buildMatchFn2;
    function buildMatchFn2(args) {
      return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) {
          return null;
        }
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex2(parsePatterns, function(pattern) {
          return pattern.test(matchedString);
        }) : findKey2(parsePatterns, function(pattern) {
          return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value,
          rest
        };
      };
    }
    function findKey2(object, predicate) {
      for (var key in object) {
        if (object.hasOwnProperty(key) && predicate(object[key])) {
          return key;
        }
      }
      return void 0;
    }
    function findIndex2(array, predicate) {
      for (var key = 0; key < array.length; key++) {
        if (predicate(array[key])) {
          return key;
        }
      }
      return void 0;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/_lib/buildMatchPatternFn/index.js
var require_buildMatchPatternFn = __commonJS({
  "../../node_modules/date-fns/locale/_lib/buildMatchPatternFn/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = buildMatchPatternFn2;
    function buildMatchPatternFn2(args) {
      return function(string) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
          value,
          rest
        };
      };
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/en-US/_lib/match/index.js
var require_match = __commonJS({
  "../../node_modules/date-fns/locale/en-US/_lib/match/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_buildMatchFn());
    var _index2 = _interopRequireDefault(require_buildMatchPatternFn());
    var matchOrdinalNumberPattern83 = /^(\d+)(th|st|nd|rd)?/i;
    var parseOrdinalNumberPattern83 = /\d+/i;
    var matchEraPatterns83 = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var parseEraPatterns83 = {
      any: [/^b/i, /^(a|c)/i]
    };
    var matchQuarterPatterns83 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var parseQuarterPatterns83 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    var matchMonthPatterns83 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var parseMonthPatterns83 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    var matchDayPatterns83 = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var parseDayPatterns83 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    var matchDayPeriodPatterns83 = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var parseDayPeriodPatterns83 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    var match83 = {
      ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern83,
        parsePattern: parseOrdinalNumberPattern83,
        valueCallback: function valueCallback164(value) {
          return parseInt(value, 10);
        }
      }),
      era: (0, _index.default)({
        matchPatterns: matchEraPatterns83,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns83,
        defaultParseWidth: "any"
      }),
      quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns83,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns83,
        defaultParseWidth: "any",
        valueCallback: function valueCallback164(index) {
          return index + 1;
        }
      }),
      month: (0, _index.default)({
        matchPatterns: matchMonthPatterns83,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns83,
        defaultParseWidth: "any"
      }),
      day: (0, _index.default)({
        matchPatterns: matchDayPatterns83,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns83,
        defaultParseWidth: "any"
      }),
      dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns83,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns83,
        defaultParseWidth: "any"
      })
    };
    var _default = match83;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/locale/en-US/index.js
var require_en_US = __commonJS({
  "../../node_modules/date-fns/locale/en-US/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_formatDistance());
    var _index2 = _interopRequireDefault(require_formatLong());
    var _index3 = _interopRequireDefault(require_formatRelative());
    var _index4 = _interopRequireDefault(require_localize());
    var _index5 = _interopRequireDefault(require_match());
    var locale94 = {
      code: "en-US",
      formatDistance: _index.default,
      formatLong: _index2.default,
      formatRelative: _index3.default,
      localize: _index4.default,
      match: _index5.default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    var _default = locale94;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/defaultLocale/index.js
var require_defaultLocale = __commonJS({
  "../../node_modules/date-fns/_lib/defaultLocale/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_en_US());
    var _default = _index.default;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/format/index.js
var require_format = __commonJS({
  "../../node_modules/date-fns/format/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = format2;
    var _index = _interopRequireDefault(require_isValid());
    var _index2 = _interopRequireDefault(require_subMilliseconds());
    var _index3 = _interopRequireDefault(require_toDate());
    var _index4 = _interopRequireDefault(require_formatters());
    var _index5 = _interopRequireDefault(require_longFormatters());
    var _index6 = _interopRequireDefault(require_getTimezoneOffsetInMilliseconds());
    var _index7 = require_protectedTokens();
    var _index8 = _interopRequireDefault(require_toInteger());
    var _index9 = _interopRequireDefault(require_requiredArgs());
    var _index10 = require_defaultOptions();
    var _index11 = _interopRequireDefault(require_defaultLocale());
    var formattingTokensRegExp4 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var longFormattingTokensRegExp3 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var escapedStringRegExp4 = /^'([^]*?)'?$/;
    var doubleQuoteRegExp4 = /''/g;
    var unescapedLatinCharacterRegExp4 = /[a-zA-Z]/;
    function format2(dirtyDate, dirtyFormatStr, options) {
      var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
      (0, _index9.default)(2, arguments);
      var formatStr = String(dirtyFormatStr);
      var defaultOptions2 = (0, _index10.getDefaultOptions)();
      var locale94 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
      var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
      if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      }
      var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
      if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      }
      if (!locale94.localize) {
        throw new RangeError("locale must contain localize property");
      }
      if (!locale94.formatLong) {
        throw new RangeError("locale must contain formatLong property");
      }
      var originalDate = (0, _index3.default)(dirtyDate);
      if (!(0, _index.default)(originalDate)) {
        throw new RangeError("Invalid time value");
      }
      var timezoneOffset = (0, _index6.default)(originalDate);
      var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
      var formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale: locale94,
        _originalDate: originalDate
      };
      var result = formatStr.match(longFormattingTokensRegExp3).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          var longFormatter = _index5.default[firstCharacter];
          return longFormatter(substring, locale94.formatLong);
        }
        return substring;
      }).join("").match(formattingTokensRegExp4).map(function(substring) {
        if (substring === "''") {
          return "'";
        }
        var firstCharacter = substring[0];
        if (firstCharacter === "'") {
          return cleanEscapedString4(substring);
        }
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
          if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
            (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
          }
          if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
            (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
          }
          return formatter(utcDate, substring, locale94.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp4)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        return substring;
      }).join("");
      return result;
    }
    function cleanEscapedString4(input) {
      var matched = input.match(escapedStringRegExp4);
      if (!matched) {
        return input;
      }
      return matched[1].replace(doubleQuoteRegExp4, "'");
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/_lib/tzIntlTimeZoneName/index.js
var require_tzIntlTimeZoneName = __commonJS({
  "../../node_modules/date-fns-tz/_lib/tzIntlTimeZoneName/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = tzIntlTimeZoneName;
    function tzIntlTimeZoneName(length, date, options) {
      var dtf = getDTF(length, options.timeZone, options.locale);
      return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
    }
    function partsTimeZone(dtf, date) {
      var formatted = dtf.formatToParts(date);
      for (var i2 = formatted.length - 1; i2 >= 0; --i2) {
        if (formatted[i2].type === "timeZoneName") {
          return formatted[i2].value;
        }
      }
    }
    function hackyTimeZone(dtf, date) {
      var formatted = dtf.format(date).replace(/\u200E/g, "");
      var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
      return tzNameMatch ? tzNameMatch[0].substr(1) : "";
    }
    function getDTF(length, timeZone, locale94) {
      if (locale94 && !locale94.code) {
        throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
      }
      return new Intl.DateTimeFormat(locale94 ? [locale94.code, "en-US"] : void 0, {
        timeZone,
        timeZoneName: length
      });
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/_lib/tzTokenizeDate/index.js
var require_tzTokenizeDate = __commonJS({
  "../../node_modules/date-fns-tz/_lib/tzTokenizeDate/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = tzTokenizeDate;
    function tzTokenizeDate(date, timeZone) {
      var dtf = getDateTimeFormat(timeZone);
      return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    }
    var typeToPos = {
      year: 0,
      month: 1,
      day: 2,
      hour: 3,
      minute: 4,
      second: 5
    };
    function partsOffset(dtf, date) {
      try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for (var i2 = 0; i2 < formatted.length; i2++) {
          var pos = typeToPos[formatted[i2].type];
          if (pos >= 0) {
            filled[pos] = parseInt(formatted[i2].value, 10);
          }
        }
        return filled;
      } catch (error) {
        if (error instanceof RangeError) {
          return [NaN];
        }
        throw error;
      }
    }
    function hackyOffset(dtf, date) {
      var formatted = dtf.format(date);
      var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
      return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
    }
    var dtfCache = {};
    function getDateTimeFormat(timeZone) {
      if (!dtfCache[timeZone]) {
        var testDateFormatted = new Intl.DateTimeFormat("en-US", {
          hourCycle: "h23",
          timeZone: "America/New_York",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z"));
        var hourCycleSupported = testDateFormatted === "06/25/2014, 00:00:00" || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat("en-US", {
          hourCycle: "h23",
          timeZone,
          year: "numeric",
          month: "numeric",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        }) : new Intl.DateTimeFormat("en-US", {
          hour12: false,
          timeZone,
          year: "numeric",
          month: "numeric",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        });
      }
      return dtfCache[timeZone];
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/_lib/newDateUTC/index.js
var require_newDateUTC = __commonJS({
  "../../node_modules/date-fns-tz/_lib/newDateUTC/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = newDateUTC;
    function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
      var utcDate = /* @__PURE__ */ new Date(0);
      utcDate.setUTCFullYear(fullYear, month, day);
      utcDate.setUTCHours(hour, minute, second, millisecond);
      return utcDate;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/_lib/tzParseTimezone/index.js
var require_tzParseTimezone = __commonJS({
  "../../node_modules/date-fns-tz/_lib/tzParseTimezone/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = tzParseTimezone;
    var _index = _interopRequireDefault(require_tzTokenizeDate());
    var _index2 = _interopRequireDefault(require_newDateUTC());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_HOUR2 = 36e5;
    var MILLISECONDS_IN_MINUTE3 = 6e4;
    var patterns2 = {
      timezone: /([Z+-].*)$/,
      timezoneZ: /^(Z)$/,
      timezoneHH: /^([+-]\d{2})$/,
      timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function tzParseTimezone(timezoneString, date, isUtcDate) {
      var token;
      var absoluteOffset;
      if (!timezoneString) {
        return 0;
      }
      token = patterns2.timezoneZ.exec(timezoneString);
      if (token) {
        return 0;
      }
      var hours;
      token = patterns2.timezoneHH.exec(timezoneString);
      if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone2(hours)) {
          return NaN;
        }
        return -(hours * MILLISECONDS_IN_HOUR2);
      }
      token = patterns2.timezoneHHMM.exec(timezoneString);
      if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!validateTimezone2(hours, minutes)) {
          return NaN;
        }
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR2 + minutes * MILLISECONDS_IN_MINUTE3;
        return token[1] === "+" ? -absoluteOffset : absoluteOffset;
      }
      if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
      }
      return NaN;
    }
    function toUtcDate(date) {
      return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function calcOffset(date, timezoneString) {
      var tokens = (0, _index.default)(date, timezoneString);
      var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
      var asTS = date.getTime();
      var over = asTS % 1e3;
      asTS -= over >= 0 ? over : 1e3 + over;
      return asUTC - asTS;
    }
    function fixOffset(date, offset, timezoneString) {
      var localTS = date.getTime();
      var utcGuess = localTS - offset;
      var o2 = calcOffset(new Date(utcGuess), timezoneString);
      if (offset === o2) {
        return offset;
      }
      utcGuess -= o2 - offset;
      var o3 = calcOffset(new Date(utcGuess), timezoneString);
      if (o2 === o3) {
        return o2;
      }
      return Math.max(o2, o3);
    }
    function validateTimezone2(hours, minutes) {
      return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var validIANATimezoneCache = {};
    function isValidTimezoneIANAString(timeZoneString) {
      if (validIANATimezoneCache[timeZoneString]) return true;
      try {
        new Intl.DateTimeFormat(void 0, {
          timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
      } catch (error) {
        return false;
      }
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/format/formatters/index.js
var require_formatters2 = __commonJS({
  "../../node_modules/date-fns-tz/format/formatters/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var _index = _interopRequireDefault(require_tzIntlTimeZoneName());
    var _index2 = _interopRequireDefault(require_tzParseTimezone());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_MINUTE3 = 60 * 1e3;
    var formatters3 = {
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function(date, token, localize84, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) {
          return "Z";
        }
        switch (token) {
          // Hours and optional minutes
          case "X":
            return formatTimezoneWithOptionalMinutes2(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return formatTimezone2(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimeter
          default:
            return formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function(date, token, localize84, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch (token) {
          // Hours and optional minutes
          case "x":
            return formatTimezoneWithOptionalMinutes2(timezoneOffset);
          // Hours, minutes and optional seconds without `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return formatTimezone2(timezoneOffset);
          // Hours, minutes and optional seconds with `:` delimeter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimeter
          default:
            return formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (GMT)
      O: function(date, token, localize84, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch (token) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + formatTimezoneShort2(timezoneOffset, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + formatTimezone2(timezoneOffset, ":");
        }
      },
      // Timezone (specific non-location)
      z: function(date, token, localize84, options) {
        switch (token) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return (0, _index.default)("short", date, options);
          // Long
          case "zzzz":
          default:
            return (0, _index.default)("long", date, options);
        }
      }
    };
    function getTimeZoneOffset(timeZone, originalDate) {
      var timeZoneOffset = timeZone ? (0, _index2.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE3 : originalDate.getTimezoneOffset();
      if (Number.isNaN(timeZoneOffset)) {
        throw new RangeError("Invalid time zone specified: " + timeZone);
      }
      return timeZoneOffset;
    }
    function addLeadingZeros2(number, targetLength) {
      var sign = number < 0 ? "-" : "";
      var output = Math.abs(number).toString();
      while (output.length < targetLength) {
        output = "0" + output;
      }
      return sign + output;
    }
    function formatTimezone2(offset, dirtyDelimeter) {
      var delimeter = dirtyDelimeter || "";
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = addLeadingZeros2(Math.floor(absOffset / 60), 2);
      var minutes = addLeadingZeros2(Math.floor(absOffset % 60), 2);
      return sign + hours + delimeter + minutes;
    }
    function formatTimezoneWithOptionalMinutes2(offset, dirtyDelimeter) {
      if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + addLeadingZeros2(Math.abs(offset) / 60, 2);
      }
      return formatTimezone2(offset, dirtyDelimeter);
    }
    function formatTimezoneShort2(offset, dirtyDelimiter) {
      var sign = offset > 0 ? "-" : "+";
      var absOffset = Math.abs(offset);
      var hours = Math.floor(absOffset / 60);
      var minutes = absOffset % 60;
      if (minutes === 0) {
        return sign + String(hours);
      }
      var delimiter = dirtyDelimiter || "";
      return sign + String(hours) + delimiter + addLeadingZeros2(minutes, 2);
    }
    var _default = formatters3;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/_lib/tzPattern/index.js
var require_tzPattern = __commonJS({
  "../../node_modules/date-fns-tz/_lib/tzPattern/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = void 0;
    var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var _default = tzPattern;
    exports2.default = _default;
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/toDate/index.js
var require_toDate2 = __commonJS({
  "../../node_modules/date-fns-tz/toDate/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = toDate2;
    var _index = _interopRequireDefault(require_toInteger());
    var _index2 = _interopRequireDefault(require_getTimezoneOffsetInMilliseconds());
    var _index3 = _interopRequireDefault(require_tzParseTimezone());
    var _index4 = _interopRequireDefault(require_tzPattern());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var MILLISECONDS_IN_HOUR2 = 36e5;
    var MILLISECONDS_IN_MINUTE3 = 6e4;
    var DEFAULT_ADDITIONAL_DIGITS = 2;
    var patterns2 = {
      dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
      datePattern: /^([0-9W+-]+)(.*)/,
      plainTime: /:/,
      // year tokens
      YY: /^(\d{2})$/,
      YYY: [
        /^([+-]\d{2})$/,
        // 0 additional digits
        /^([+-]\d{3})$/,
        // 1 additional digit
        /^([+-]\d{4})$/
        // 2 additional digits
      ],
      YYYY: /^(\d{4})/,
      YYYYY: [
        /^([+-]\d{4})/,
        // 0 additional digits
        /^([+-]\d{5})/,
        // 1 additional digit
        /^([+-]\d{6})/
        // 2 additional digits
      ],
      // date tokens
      MM: /^-(\d{2})$/,
      DDD: /^-?(\d{3})$/,
      MMDD: /^-?(\d{2})-?(\d{2})$/,
      Www: /^-?W(\d{2})$/,
      WwwD: /^-?W(\d{2})-?(\d{1})$/,
      HH: /^(\d{2}([.,]\d*)?)$/,
      HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
      HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
      // time zone tokens (to identify the presence of a tz)
      timeZone: _index4.default
    };
    function toDate2(argument, dirtyOptions) {
      if (arguments.length < 1) {
        throw new TypeError("1 argument required, but only " + arguments.length + " present");
      }
      if (argument === null) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var options = dirtyOptions || {};
      var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);
      if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
        throw new RangeError("additionalDigits must be 0, 1 or 2");
      }
      if (argument instanceof Date || typeof argument === "object" && Object.prototype.toString.call(argument) === "[object Date]") {
        return new Date(argument.getTime());
      } else if (typeof argument === "number" || Object.prototype.toString.call(argument) === "[object Number]") {
        return new Date(argument);
      } else if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var dateStrings = splitDateString2(argument);
      var parseYearResult = parseYear2(dateStrings.date, additionalDigits);
      var year = parseYearResult.year;
      var restDateString = parseYearResult.restDateString;
      var date = parseDate3(restDateString, year);
      if (isNaN(date)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
          time = parseTime2(dateStrings.time);
          if (isNaN(time)) {
            return /* @__PURE__ */ new Date(NaN);
          }
        }
        if (dateStrings.timeZone || options.timeZone) {
          offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
          if (isNaN(offset)) {
            return /* @__PURE__ */ new Date(NaN);
          }
        } else {
          offset = (0, _index2.default)(new Date(timestamp + time));
          offset = (0, _index2.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
      } else {
        return /* @__PURE__ */ new Date(NaN);
      }
    }
    function splitDateString2(dateString) {
      var dateStrings = {};
      var parts = patterns2.dateTimePattern.exec(dateString);
      var timeString;
      if (!parts) {
        parts = patterns2.datePattern.exec(dateString);
        if (parts) {
          dateStrings.date = parts[1];
          timeString = parts[2];
        } else {
          dateStrings.date = null;
          timeString = dateString;
        }
      } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
      }
      if (timeString) {
        var token = patterns2.timeZone.exec(timeString);
        if (token) {
          dateStrings.time = timeString.replace(token[1], "");
          dateStrings.timeZone = token[1].trim();
        } else {
          dateStrings.time = timeString;
        }
      }
      return dateStrings;
    }
    function parseYear2(dateString, additionalDigits) {
      var patternYYY = patterns2.YYY[additionalDigits];
      var patternYYYYY = patterns2.YYYYY[additionalDigits];
      var token;
      token = patterns2.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
      if (token) {
        var yearString = token[1];
        return {
          year: parseInt(yearString, 10),
          restDateString: dateString.slice(yearString.length)
        };
      }
      token = patterns2.YY.exec(dateString) || patternYYY.exec(dateString);
      if (token) {
        var centuryString = token[1];
        return {
          year: parseInt(centuryString, 10) * 100,
          restDateString: dateString.slice(centuryString.length)
        };
      }
      return {
        year: null
      };
    }
    function parseDate3(dateString, year) {
      if (year === null) {
        return null;
      }
      var token;
      var date;
      var month;
      var week2;
      if (dateString.length === 0) {
        date = /* @__PURE__ */ new Date(0);
        date.setUTCFullYear(year);
        return date;
      }
      token = patterns2.MM.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate2(year, month)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, month);
        return date;
      }
      token = patterns2.DDD.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate2(year, dayOfYear)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
      }
      token = patterns2.MMDD.exec(dateString);
      if (token) {
        date = /* @__PURE__ */ new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate2(year, month, day)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        date.setUTCFullYear(year, month, day);
        return date;
      }
      token = patterns2.Www.exec(dateString);
      if (token) {
        week2 = parseInt(token[1], 10) - 1;
        if (!validateWeekDate2(year, week2)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        return dayOfISOWeekYear2(year, week2);
      }
      token = patterns2.WwwD.exec(dateString);
      if (token) {
        week2 = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate2(year, week2, dayOfWeek)) {
          return /* @__PURE__ */ new Date(NaN);
        }
        return dayOfISOWeekYear2(year, week2, dayOfWeek);
      }
      return null;
    }
    function parseTime2(timeString) {
      var token;
      var hours;
      var minutes;
      token = patterns2.HH.exec(timeString);
      if (token) {
        hours = parseFloat(token[1].replace(",", "."));
        if (!validateTime2(hours)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR2;
      }
      token = patterns2.HHMM.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(",", "."));
        if (!validateTime2(hours, minutes)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR2 + minutes * MILLISECONDS_IN_MINUTE3;
      }
      token = patterns2.HHMMSS.exec(timeString);
      if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(",", "."));
        if (!validateTime2(hours, minutes, seconds)) {
          return NaN;
        }
        return hours % 24 * MILLISECONDS_IN_HOUR2 + minutes * MILLISECONDS_IN_MINUTE3 + seconds * 1e3;
      }
      return null;
    }
    function dayOfISOWeekYear2(isoWeekYear, week2, day) {
      week2 = week2 || 0;
      day = day || 0;
      var date = /* @__PURE__ */ new Date(0);
      date.setUTCFullYear(isoWeekYear, 0, 4);
      var fourthOfJanuaryDay = date.getUTCDay() || 7;
      var diff = week2 * 7 + day + 1 - fourthOfJanuaryDay;
      date.setUTCDate(date.getUTCDate() + diff);
      return date;
    }
    var DAYS_IN_MONTH2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    var DAYS_IN_MONTH_LEAP_YEAR2 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function isLeapYearIndex3(year) {
      return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function validateDate2(year, month, date) {
      if (month < 0 || month > 11) {
        return false;
      }
      if (date != null) {
        if (date < 1) {
          return false;
        }
        var isLeapYear2 = isLeapYearIndex3(year);
        if (isLeapYear2 && date > DAYS_IN_MONTH_LEAP_YEAR2[month]) {
          return false;
        }
        if (!isLeapYear2 && date > DAYS_IN_MONTH2[month]) {
          return false;
        }
      }
      return true;
    }
    function validateDayOfYearDate2(year, dayOfYear) {
      if (dayOfYear < 1) {
        return false;
      }
      var isLeapYear2 = isLeapYearIndex3(year);
      if (isLeapYear2 && dayOfYear > 366) {
        return false;
      }
      if (!isLeapYear2 && dayOfYear > 365) {
        return false;
      }
      return true;
    }
    function validateWeekDate2(year, week2, day) {
      if (week2 < 0 || week2 > 52) {
        return false;
      }
      if (day != null && (day < 0 || day > 6)) {
        return false;
      }
      return true;
    }
    function validateTime2(hours, minutes, seconds) {
      if (hours != null && (hours < 0 || hours >= 25)) {
        return false;
      }
      if (minutes != null && (minutes < 0 || minutes >= 60)) {
        return false;
      }
      if (seconds != null && (seconds < 0 || seconds >= 60)) {
        return false;
      }
      return true;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/format/index.js
var require_format2 = __commonJS({
  "../../node_modules/date-fns-tz/format/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = format2;
    var _index = _interopRequireDefault(require_format());
    var _index2 = _interopRequireDefault(require_formatters2());
    var _index3 = _interopRequireDefault(require_toDate2());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function format2(dirtyDate, dirtyFormatStr, dirtyOptions) {
      var formatStr = String(dirtyFormatStr);
      var options = dirtyOptions || {};
      var matches = formatStr.match(tzFormattingTokensRegExp);
      if (matches) {
        var date = (0, _index3.default)(options.originalDate || dirtyDate, options);
        formatStr = matches.reduce(function(result, token) {
          if (token[0] === "'") {
            return result;
          }
          var pos = result.indexOf(token);
          var precededByQuotedSection = result[pos - 1] === "'";
          var replaced = result.replace(token, "'" + _index2.default[token[0]](date, token, null, options) + "'");
          return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
      }
      return (0, _index.default)(dirtyDate, formatStr, options);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/assign/index.js
var require_assign = __commonJS({
  "../../node_modules/date-fns/_lib/assign/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = assign2;
    function assign2(target, object) {
      if (target == null) {
        throw new TypeError("assign requires that input parameter not be null or undefined");
      }
      for (var property in object) {
        if (Object.prototype.hasOwnProperty.call(object, property)) {
          ;
          target[property] = object[property];
        }
      }
      return target;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns/_lib/cloneObject/index.js
var require_cloneObject = __commonJS({
  "../../node_modules/date-fns/_lib/cloneObject/index.js"(exports2, module2) {
    "use strict";
    var _interopRequireDefault = require_interopRequireDefault().default;
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = cloneObject2;
    var _index = _interopRequireDefault(require_assign());
    function cloneObject2(object) {
      return (0, _index.default)({}, object);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/utcToZonedTime/index.js
var require_utcToZonedTime = __commonJS({
  "../../node_modules/date-fns-tz/utcToZonedTime/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = utcToZonedTime;
    var _index = _interopRequireDefault(require_tzParseTimezone());
    var _index2 = _interopRequireDefault(require_toDate2());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function utcToZonedTime(dirtyDate, timeZone, options) {
      var date = (0, _index2.default)(dirtyDate, options);
      var offsetMilliseconds = (0, _index.default)(timeZone, date, true);
      var d3 = new Date(date.getTime() - offsetMilliseconds);
      var resultDate = /* @__PURE__ */ new Date(0);
      resultDate.setFullYear(d3.getUTCFullYear(), d3.getUTCMonth(), d3.getUTCDate());
      resultDate.setHours(d3.getUTCHours(), d3.getUTCMinutes(), d3.getUTCSeconds(), d3.getUTCMilliseconds());
      return resultDate;
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/formatInTimeZone/index.js
var require_formatInTimeZone = __commonJS({
  "../../node_modules/date-fns-tz/formatInTimeZone/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = formatInTimeZone;
    var _index = _interopRequireDefault(require_cloneObject());
    var _index2 = _interopRequireDefault(require_format2());
    var _index3 = _interopRequireDefault(require_utcToZonedTime());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function formatInTimeZone(date, timeZone, formatStr, options) {
      var extendedOptions = (0, _index.default)(options);
      extendedOptions.timeZone = timeZone;
      extendedOptions.originalDate = date;
      return (0, _index2.default)((0, _index3.default)(date, timeZone), formatStr, extendedOptions);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/getTimezoneOffset/index.js
var require_getTimezoneOffset = __commonJS({
  "../../node_modules/date-fns-tz/getTimezoneOffset/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = getTimezoneOffset;
    var _index = _interopRequireDefault(require_tzParseTimezone());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function getTimezoneOffset(timeZone, date) {
      return -(0, _index.default)(timeZone, date);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/zonedTimeToUtc/index.js
var require_zonedTimeToUtc = __commonJS({
  "../../node_modules/date-fns-tz/zonedTimeToUtc/index.js"(exports2, module2) {
    "use strict";
    Object.defineProperty(exports2, "__esModule", {
      value: true
    });
    exports2.default = zonedTimeToUtc;
    var _index = _interopRequireDefault(require_cloneObject());
    var _index2 = _interopRequireDefault(require_toDate2());
    var _index3 = _interopRequireDefault(require_tzPattern());
    var _index4 = _interopRequireDefault(require_tzParseTimezone());
    var _index5 = _interopRequireDefault(require_newDateUTC());
    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
    function zonedTimeToUtc(date, timeZone, options) {
      if (typeof date === "string" && !date.match(_index3.default)) {
        var extendedOptions = (0, _index.default)(options);
        extendedOptions.timeZone = timeZone;
        return (0, _index2.default)(date, extendedOptions);
      }
      var d3 = (0, _index2.default)(date, options);
      var utc = (0, _index5.default)(d3.getFullYear(), d3.getMonth(), d3.getDate(), d3.getHours(), d3.getMinutes(), d3.getSeconds(), d3.getMilliseconds()).getTime();
      var offsetMilliseconds = (0, _index4.default)(timeZone, new Date(utc));
      return new Date(utc + offsetMilliseconds);
    }
    module2.exports = exports2.default;
  }
});

// ../../node_modules/date-fns-tz/index.js
var require_date_fns_tz = __commonJS({
  "../../node_modules/date-fns-tz/index.js"(exports2, module2) {
    "use strict";
    module2.exports = {
      format: require_format2(),
      formatInTimeZone: require_formatInTimeZone(),
      getTimezoneOffset: require_getTimezoneOffset(),
      toDate: require_toDate2(),
      utcToZonedTime: require_utcToZonedTime(),
      zonedTimeToUtc: require_zonedTimeToUtc()
    };
  }
});

// ../utils/node_modules/uuid/dist/esm-node/max.js
var max_default;
var init_max2 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/max.js"() {
    "use strict";
    max_default = "ffffffff-ffff-ffff-ffff-ffffffffffff";
  }
});

// ../utils/node_modules/uuid/dist/esm-node/nil.js
var nil_default;
var init_nil = __esm({
  "../utils/node_modules/uuid/dist/esm-node/nil.js"() {
    "use strict";
    nil_default = "00000000-0000-0000-0000-000000000000";
  }
});

// ../utils/node_modules/uuid/dist/esm-node/regex.js
var regex_default;
var init_regex = __esm({
  "../utils/node_modules/uuid/dist/esm-node/regex.js"() {
    "use strict";
    regex_default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/validate.js
function validate(uuid) {
  return typeof uuid === "string" && regex_default.test(uuid);
}
var validate_default;
var init_validate = __esm({
  "../utils/node_modules/uuid/dist/esm-node/validate.js"() {
    "use strict";
    init_regex();
    validate_default = validate;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/parse.js
function parse2(uuid) {
  if (!validate_default(uuid)) {
    throw TypeError("Invalid UUID");
  }
  let v;
  const arr = new Uint8Array(16);
  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 255;
  arr[2] = v >>> 8 & 255;
  arr[3] = v & 255;
  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 255;
  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 255;
  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 255;
  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 1099511627776 & 255;
  arr[11] = v / 4294967296 & 255;
  arr[12] = v >>> 24 & 255;
  arr[13] = v >>> 16 & 255;
  arr[14] = v >>> 8 & 255;
  arr[15] = v & 255;
  return arr;
}
var parse_default;
var init_parse2 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/parse.js"() {
    "use strict";
    init_validate();
    parse_default = parse2;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/stringify.js
function unsafeStringify(arr, offset = 0) {
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset);
  if (!validate_default(uuid)) {
    throw TypeError("Stringified UUID is invalid");
  }
  return uuid;
}
var byteToHex, stringify_default;
var init_stringify = __esm({
  "../utils/node_modules/uuid/dist/esm-node/stringify.js"() {
    "use strict";
    init_validate();
    byteToHex = [];
    for (let i2 = 0; i2 < 256; ++i2) {
      byteToHex.push((i2 + 256).toString(16).slice(1));
    }
    stringify_default = stringify;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/rng.js
function rng() {
  if (poolPtr > rnds8Pool.length - 16) {
    import_node_crypto.default.randomFillSync(rnds8Pool);
    poolPtr = 0;
  }
  return rnds8Pool.slice(poolPtr, poolPtr += 16);
}
var import_node_crypto, rnds8Pool, poolPtr;
var init_rng = __esm({
  "../utils/node_modules/uuid/dist/esm-node/rng.js"() {
    "use strict";
    import_node_crypto = __toESM(require("crypto"));
    rnds8Pool = new Uint8Array(256);
    poolPtr = rnds8Pool.length;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v1.js
function v1(options, buf, offset) {
  let i2 = buf && offset || 0;
  const b2 = buf || new Array(16);
  options = options || {};
  let node = options.node;
  let clockseq = options.clockseq;
  if (!options._v6) {
    if (!node) {
      node = _nodeId;
    }
    if (clockseq == null) {
      clockseq = _clockseq;
    }
  }
  if (node == null || clockseq == null) {
    const seedBytes = options.random || (options.rng || rng)();
    if (node == null) {
      node = [seedBytes[0], seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
      if (!_nodeId && !options._v6) {
        node[0] |= 1;
        _nodeId = node;
      }
    }
    if (clockseq == null) {
      clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 16383;
      if (_clockseq === void 0 && !options._v6) {
        _clockseq = clockseq;
      }
    }
  }
  let msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  let nsecs = options.nsecs !== void 0 ? options.nsecs : _lastNSecs + 1;
  const dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 1e4;
  if (dt < 0 && options.clockseq === void 0) {
    clockseq = clockseq + 1 & 16383;
  }
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === void 0) {
    nsecs = 0;
  }
  if (nsecs >= 1e4) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }
  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;
  msecs += 122192928e5;
  const tl = ((msecs & 268435455) * 1e4 + nsecs) % 4294967296;
  b2[i2++] = tl >>> 24 & 255;
  b2[i2++] = tl >>> 16 & 255;
  b2[i2++] = tl >>> 8 & 255;
  b2[i2++] = tl & 255;
  const tmh = msecs / 4294967296 * 1e4 & 268435455;
  b2[i2++] = tmh >>> 8 & 255;
  b2[i2++] = tmh & 255;
  b2[i2++] = tmh >>> 24 & 15 | 16;
  b2[i2++] = tmh >>> 16 & 255;
  b2[i2++] = clockseq >>> 8 | 128;
  b2[i2++] = clockseq & 255;
  for (let n = 0; n < 6; ++n) {
    b2[i2 + n] = node[n];
  }
  return buf || unsafeStringify(b2);
}
var _nodeId, _clockseq, _lastMSecs, _lastNSecs, v1_default;
var init_v1 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v1.js"() {
    "use strict";
    init_rng();
    init_stringify();
    _lastMSecs = 0;
    _lastNSecs = 0;
    v1_default = v1;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v1ToV6.js
function v1ToV6(uuid) {
  const v1Bytes = typeof uuid === "string" ? parse_default(uuid) : uuid;
  const v6Bytes = _v1ToV6(v1Bytes);
  return typeof uuid === "string" ? unsafeStringify(v6Bytes) : v6Bytes;
}
function _v1ToV6(v1Bytes, randomize = false) {
  return Uint8Array.of((v1Bytes[6] & 15) << 4 | v1Bytes[7] >> 4 & 15, (v1Bytes[7] & 15) << 4 | (v1Bytes[4] & 240) >> 4, (v1Bytes[4] & 15) << 4 | (v1Bytes[5] & 240) >> 4, (v1Bytes[5] & 15) << 4 | (v1Bytes[0] & 240) >> 4, (v1Bytes[0] & 15) << 4 | (v1Bytes[1] & 240) >> 4, (v1Bytes[1] & 15) << 4 | (v1Bytes[2] & 240) >> 4, 96 | v1Bytes[2] & 15, v1Bytes[3], v1Bytes[8], v1Bytes[9], v1Bytes[10], v1Bytes[11], v1Bytes[12], v1Bytes[13], v1Bytes[14], v1Bytes[15]);
}
var init_v1ToV6 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v1ToV6.js"() {
    "use strict";
    init_parse2();
    init_stringify();
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v35.js
function stringToBytes(str) {
  str = unescape(encodeURIComponent(str));
  const bytes = [];
  for (let i2 = 0; i2 < str.length; ++i2) {
    bytes.push(str.charCodeAt(i2));
  }
  return bytes;
}
function v35(name, version2, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    var _namespace;
    if (typeof value === "string") {
      value = stringToBytes(value);
    }
    if (typeof namespace === "string") {
      namespace = parse_default(namespace);
    }
    if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) {
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    }
    let bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 15 | version2;
    bytes[8] = bytes[8] & 63 | 128;
    if (buf) {
      offset = offset || 0;
      for (let i2 = 0; i2 < 16; ++i2) {
        buf[offset + i2] = bytes[i2];
      }
      return buf;
    }
    return unsafeStringify(bytes);
  }
  try {
    generateUUID.name = name;
  } catch (err) {
  }
  generateUUID.DNS = DNS;
  generateUUID.URL = URL2;
  return generateUUID;
}
var DNS, URL2;
var init_v35 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v35.js"() {
    "use strict";
    init_stringify();
    init_parse2();
    DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
    URL2 = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
  }
});

// ../utils/node_modules/uuid/dist/esm-node/md5.js
function md5(bytes) {
  if (Array.isArray(bytes)) {
    bytes = Buffer.from(bytes);
  } else if (typeof bytes === "string") {
    bytes = Buffer.from(bytes, "utf8");
  }
  return import_node_crypto2.default.createHash("md5").update(bytes).digest();
}
var import_node_crypto2, md5_default;
var init_md5 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/md5.js"() {
    "use strict";
    import_node_crypto2 = __toESM(require("crypto"));
    md5_default = md5;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v3.js
var v3, v3_default;
var init_v3 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v3.js"() {
    "use strict";
    init_v35();
    init_md5();
    v3 = v35("v3", 48, md5_default);
    v3_default = v3;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/native.js
var import_node_crypto3, native_default;
var init_native = __esm({
  "../utils/node_modules/uuid/dist/esm-node/native.js"() {
    "use strict";
    import_node_crypto3 = __toESM(require("crypto"));
    native_default = {
      randomUUID: import_node_crypto3.default.randomUUID
    };
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v4.js
function v4(options, buf, offset) {
  if (native_default.randomUUID && !buf && !options) {
    return native_default.randomUUID();
  }
  options = options || {};
  const rnds = options.random || (options.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    for (let i2 = 0; i2 < 16; ++i2) {
      buf[offset + i2] = rnds[i2];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var v4_default;
var init_v4 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v4.js"() {
    "use strict";
    init_native();
    init_rng();
    init_stringify();
    v4_default = v4;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/sha1.js
function sha1(bytes) {
  if (Array.isArray(bytes)) {
    bytes = Buffer.from(bytes);
  } else if (typeof bytes === "string") {
    bytes = Buffer.from(bytes, "utf8");
  }
  return import_node_crypto4.default.createHash("sha1").update(bytes).digest();
}
var import_node_crypto4, sha1_default;
var init_sha1 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/sha1.js"() {
    "use strict";
    import_node_crypto4 = __toESM(require("crypto"));
    sha1_default = sha1;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v5.js
var v5, v5_default;
var init_v5 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v5.js"() {
    "use strict";
    init_v35();
    init_sha1();
    v5 = v35("v5", 80, sha1_default);
    v5_default = v5;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v6.js
function v6(options = {}, buf, offset = 0) {
  let bytes = v1_default({
    ...options,
    _v6: true
  }, new Uint8Array(16));
  bytes = v1ToV6(bytes);
  if (buf) {
    for (let i2 = 0; i2 < 16; i2++) {
      buf[offset + i2] = bytes[i2];
    }
    return buf;
  }
  return unsafeStringify(bytes);
}
var init_v6 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v6.js"() {
    "use strict";
    init_stringify();
    init_v1();
    init_v1ToV6();
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v6ToV1.js
function v6ToV1(uuid) {
  const v6Bytes = typeof uuid === "string" ? parse_default(uuid) : uuid;
  const v1Bytes = _v6ToV1(v6Bytes);
  return typeof uuid === "string" ? unsafeStringify(v1Bytes) : v1Bytes;
}
function _v6ToV1(v6Bytes) {
  return Uint8Array.of((v6Bytes[3] & 15) << 4 | v6Bytes[4] >> 4 & 15, (v6Bytes[4] & 15) << 4 | (v6Bytes[5] & 240) >> 4, (v6Bytes[5] & 15) << 4 | v6Bytes[6] & 15, v6Bytes[7], (v6Bytes[1] & 15) << 4 | (v6Bytes[2] & 240) >> 4, (v6Bytes[2] & 15) << 4 | (v6Bytes[3] & 240) >> 4, 16 | (v6Bytes[0] & 240) >> 4, (v6Bytes[0] & 15) << 4 | (v6Bytes[1] & 240) >> 4, v6Bytes[8], v6Bytes[9], v6Bytes[10], v6Bytes[11], v6Bytes[12], v6Bytes[13], v6Bytes[14], v6Bytes[15]);
}
var init_v6ToV1 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v6ToV1.js"() {
    "use strict";
    init_parse2();
    init_stringify();
  }
});

// ../utils/node_modules/uuid/dist/esm-node/v7.js
function v7(options, buf, offset) {
  options = options || {};
  let i2 = buf && offset || 0;
  const b2 = buf || new Uint8Array(16);
  const rnds = options.random || (options.rng || rng)();
  const msecs = options.msecs !== void 0 ? options.msecs : Date.now();
  let seq = options.seq !== void 0 ? options.seq : null;
  let seqHigh = _seqHigh;
  let seqLow = _seqLow;
  if (msecs > _msecs && options.msecs === void 0) {
    _msecs = msecs;
    if (seq !== null) {
      seqHigh = null;
      seqLow = null;
    }
  }
  if (seq !== null) {
    if (seq > 2147483647) {
      seq = 2147483647;
    }
    seqHigh = seq >>> 19 & 4095;
    seqLow = seq & 524287;
  }
  if (seqHigh === null || seqLow === null) {
    seqHigh = rnds[6] & 127;
    seqHigh = seqHigh << 8 | rnds[7];
    seqLow = rnds[8] & 63;
    seqLow = seqLow << 8 | rnds[9];
    seqLow = seqLow << 5 | rnds[10] >>> 3;
  }
  if (msecs + 1e4 > _msecs && seq === null) {
    if (++seqLow > 524287) {
      seqLow = 0;
      if (++seqHigh > 4095) {
        seqHigh = 0;
        _msecs++;
      }
    }
  } else {
    _msecs = msecs;
  }
  _seqHigh = seqHigh;
  _seqLow = seqLow;
  b2[i2++] = _msecs / 1099511627776 & 255;
  b2[i2++] = _msecs / 4294967296 & 255;
  b2[i2++] = _msecs / 16777216 & 255;
  b2[i2++] = _msecs / 65536 & 255;
  b2[i2++] = _msecs / 256 & 255;
  b2[i2++] = _msecs & 255;
  b2[i2++] = seqHigh >>> 4 & 15 | 112;
  b2[i2++] = seqHigh & 255;
  b2[i2++] = seqLow >>> 13 & 63 | 128;
  b2[i2++] = seqLow >>> 5 & 255;
  b2[i2++] = seqLow << 3 & 255 | rnds[10] & 7;
  b2[i2++] = rnds[11];
  b2[i2++] = rnds[12];
  b2[i2++] = rnds[13];
  b2[i2++] = rnds[14];
  b2[i2++] = rnds[15];
  return buf || unsafeStringify(b2);
}
var _seqLow, _seqHigh, _msecs, v7_default;
var init_v7 = __esm({
  "../utils/node_modules/uuid/dist/esm-node/v7.js"() {
    "use strict";
    init_rng();
    init_stringify();
    _seqLow = null;
    _seqHigh = null;
    _msecs = 0;
    v7_default = v7;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/version.js
function version(uuid) {
  if (!validate_default(uuid)) {
    throw TypeError("Invalid UUID");
  }
  return parseInt(uuid.slice(14, 15), 16);
}
var version_default;
var init_version = __esm({
  "../utils/node_modules/uuid/dist/esm-node/version.js"() {
    "use strict";
    init_validate();
    version_default = version;
  }
});

// ../utils/node_modules/uuid/dist/esm-node/index.js
var esm_node_exports = {};
__export(esm_node_exports, {
  MAX: () => max_default,
  NIL: () => nil_default,
  parse: () => parse_default,
  stringify: () => stringify_default,
  v1: () => v1_default,
  v1ToV6: () => v1ToV6,
  v3: () => v3_default,
  v4: () => v4_default,
  v5: () => v5_default,
  v6: () => v6,
  v6ToV1: () => v6ToV1,
  v7: () => v7_default,
  validate: () => validate_default,
  version: () => version_default
});
var init_esm_node = __esm({
  "../utils/node_modules/uuid/dist/esm-node/index.js"() {
    "use strict";
    init_max2();
    init_nil();
    init_parse2();
    init_stringify();
    init_v1();
    init_v1ToV6();
    init_v3();
    init_v4();
    init_v5();
    init_v6();
    init_v6ToV1();
    init_v7();
    init_validate();
    init_version();
  }
});

// ../../node_modules/mrz/lib-esm/formats.js
var formats;
var init_formats = __esm({
  "../../node_modules/mrz/lib-esm/formats.js"() {
    "use strict";
    formats = {
      TD1: "TD1",
      TD2: "TD2",
      TD3: "TD3",
      SWISS_DRIVING_LICENSE: "SWISS_DRIVING_LICENSE",
      FRENCH_NATIONAL_ID: "FRENCH_NATIONAL_ID",
      FRENCH_DRIVING_LICENSE: "FRENCH_DRIVING_LICENSE"
    };
  }
});

// ../../node_modules/mrz/lib-esm/generated/states.js
var states, states_default;
var init_states = __esm({
  "../../node_modules/mrz/lib-esm/generated/states.js"() {
    "use strict";
    states = {
      "AFG": "Afghanistan",
      "ALB": "Albania",
      "DZA": "Algeria",
      "ASM": "American Samoa",
      "AND": "Andorra",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ATA": "Antarctica",
      "ATG": "Antigua and Barbuda",
      "ARG": "Argentina",
      "ARM": "Armenia",
      "ABW": "Aruba",
      "AUS": "Australia",
      "AUT": "Austria",
      "AZE": "Azerbaijan",
      "BHS": "Bahamas (the)",
      "BHR": "Bahrain",
      "BGD": "Bangladesh",
      "BRB": "Barbados",
      "BLR": "Belarus",
      "BEL": "Belgium",
      "BLZ": "Belize",
      "BEN": "Benin",
      "BMU": "Bermuda",
      "BTN": "Bhutan",
      "BOL": "Bolivia (Plurinational State of)",
      "BES": "Bonaire, Sint Eustatius and Saba",
      "BIH": "Bosnia and Herzegovina",
      "BWA": "Botswana",
      "BVT": "Bouvet Island",
      "BRA": "Brazil",
      "IOT": "British Indian Ocean Territory (the)",
      "BRN": "Brunei Darussalam",
      "BGR": "Bulgaria",
      "BFA": "Burkina Faso",
      "BDI": "Burundi",
      "CPV": "Cabo Verde",
      "KHM": "Cambodia",
      "CMR": "Cameroon",
      "CAN": "Canada",
      "CYM": "Cayman Islands (the)",
      "CAF": "Central African Republic (the)",
      "TCD": "Chad",
      "CHL": "Chile",
      "CHN": "China",
      "CXR": "Christmas Island",
      "CCK": "Cocos (Keeling) Islands (the)",
      "COL": "Colombia",
      "COM": "Comoros (the)",
      "COD": "Congo (the Democratic Republic of the)",
      "COG": "Congo (the)",
      "COK": "Cook Islands (the)",
      "CRI": "Costa Rica",
      "HRV": "Croatia",
      "CUB": "Cuba",
      "CUW": "Cura\xE7ao",
      "CYP": "Cyprus",
      "CZE": "Czechia",
      "CIV": "C\xF4te d'Ivoire",
      "DNK": "Denmark",
      "DJI": "Djibouti",
      "DMA": "Dominica",
      "DOM": "Dominican Republic (the)",
      "ECU": "Ecuador",
      "EGY": "Egypt",
      "SLV": "El Salvador",
      "GNQ": "Equatorial Guinea",
      "ERI": "Eritrea",
      "EST": "Estonia",
      "SWZ": "Eswatini",
      "ETH": "Ethiopia",
      "FLK": "Falkland Islands (the) [Malvinas]",
      "FRO": "Faroe Islands (the)",
      "FJI": "Fiji",
      "FIN": "Finland",
      "FRA": "France",
      "GUF": "French Guiana",
      "PYF": "French Polynesia",
      "ATF": "French Southern Territories (the)",
      "GAB": "Gabon",
      "GMB": "Gambia (the)",
      "GEO": "Georgia",
      "DEU": "Germany",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GRC": "Greece",
      "GRL": "Greenland",
      "GRD": "Grenada",
      "GLP": "Guadeloupe",
      "GUM": "Guam",
      "GTM": "Guatemala",
      "GGY": "Guernsey",
      "GIN": "Guinea",
      "GNB": "Guinea-Bissau",
      "GUY": "Guyana",
      "HTI": "Haiti",
      "HMD": "Heard Island and McDonald Islands",
      "VAT": "Holy See (the)",
      "HND": "Honduras",
      "HKG": "Hong Kong",
      "HUN": "Hungary",
      "ISL": "Iceland",
      "IND": "India",
      "IDN": "Indonesia",
      "IRN": "Iran (Islamic Republic of)",
      "IRQ": "Iraq",
      "IRL": "Ireland",
      "IMN": "Isle of Man",
      "ISR": "Israel",
      "ITA": "Italy",
      "JAM": "Jamaica",
      "JPN": "Japan",
      "JEY": "Jersey",
      "JOR": "Jordan",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KIR": "Kiribati",
      "PRK": "Korea (the Democratic People's Republic of)",
      "KOR": "Korea (the Republic of)",
      "KWT": "Kuwait",
      "KGZ": "Kyrgyzstan",
      "LAO": "Lao People's Democratic Republic (the)",
      "LVA": "Latvia",
      "LBN": "Lebanon",
      "LSO": "Lesotho",
      "LBR": "Liberia",
      "LBY": "Libya",
      "LIE": "Liechtenstein",
      "LTU": "Lithuania",
      "LUX": "Luxembourg",
      "MAC": "Macao",
      "MDG": "Madagascar",
      "MWI": "Malawi",
      "MYS": "Malaysia",
      "MDV": "Maldives",
      "MLI": "Mali",
      "MLT": "Malta",
      "MHL": "Marshall Islands (the)",
      "MTQ": "Martinique",
      "MRT": "Mauritania",
      "MUS": "Mauritius",
      "MYT": "Mayotte",
      "MEX": "Mexico",
      "FSM": "Micronesia (Federated States of)",
      "MDA": "Moldova (the Republic of)",
      "MCO": "Monaco",
      "MNG": "Mongolia",
      "MNE": "Montenegro",
      "MSR": "Montserrat",
      "MAR": "Morocco",
      "MOZ": "Mozambique",
      "MMR": "Myanmar",
      "NAM": "Namibia",
      "NRU": "Nauru",
      "NPL": "Nepal",
      "NLD": "Netherlands (the)",
      "NCL": "New Caledonia",
      "NZL": "New Zealand",
      "NIC": "Nicaragua",
      "NER": "Niger (the)",
      "NGA": "Nigeria",
      "NIU": "Niue",
      "NFK": "Norfolk Island",
      "MKD": "North Macedonia",
      "MNP": "Northern Mariana Islands (the)",
      "NOR": "Norway",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PLW": "Palau",
      "PSE": "Palestine, State of",
      "PAN": "Panama",
      "PNG": "Papua New Guinea",
      "PRY": "Paraguay",
      "PER": "Peru",
      "PHL": "Philippines (the)",
      "PCN": "Pitcairn",
      "POL": "Poland",
      "PRT": "Portugal",
      "PRI": "Puerto Rico",
      "QAT": "Qatar",
      "ROU": "Romania",
      "RUS": "Russian Federation (the)",
      "RWA": "Rwanda",
      "REU": "R\xE9union",
      "BLM": "Saint Barth\xE9lemy",
      "SHN": "Saint Helena, Ascension and Tristan da Cunha",
      "KNA": "Saint Kitts and Nevis",
      "LCA": "Saint Lucia",
      "MAF": "Saint Martin (French part)",
      "SPM": "Saint Pierre and Miquelon",
      "VCT": "Saint Vincent and the Grenadines",
      "WSM": "Samoa",
      "SMR": "San Marino",
      "STP": "Sao Tome and Principe",
      "SAU": "Saudi Arabia",
      "SEN": "Senegal",
      "SRB": "Serbia",
      "SYC": "Seychelles",
      "SLE": "Sierra Leone",
      "SGP": "Singapore",
      "SXM": "Sint Maarten (Dutch part)",
      "SVK": "Slovakia",
      "SVN": "Slovenia",
      "SLB": "Solomon Islands",
      "SOM": "Somalia",
      "ZAF": "South Africa",
      "SGS": "South Georgia and the South Sandwich Islands",
      "SSD": "South Sudan",
      "ESP": "Spain",
      "LKA": "Sri Lanka",
      "SDN": "Sudan (the)",
      "SUR": "Suriname",
      "SJM": "Svalbard and Jan Mayen",
      "SWE": "Sweden",
      "CHE": "Switzerland",
      "SYR": "Syrian Arab Republic (the)",
      "TWN": "Taiwan (Province of China)",
      "TJK": "Tajikistan",
      "TZA": "Tanzania, the United Republic of",
      "THA": "Thailand",
      "TLS": "Timor-Leste",
      "TGO": "Togo",
      "TKL": "Tokelau",
      "TON": "Tonga",
      "TTO": "Trinidad and Tobago",
      "TUN": "Tunisia",
      "TUR": "Turkey",
      "TKM": "Turkmenistan",
      "TCA": "Turks and Caicos Islands (the)",
      "TUV": "Tuvalu",
      "UGA": "Uganda",
      "UKR": "Ukraine",
      "ARE": "United Arab Emirates (the)",
      "GBR": "United Kingdom of Great Britain and Northern Ireland (the)",
      "UMI": "United States Minor Outlying Islands (the)",
      "USA": "United States of America (the)",
      "URY": "Uruguay",
      "UZB": "Uzbekistan",
      "VUT": "Vanuatu",
      "VEN": "Venezuela (Bolivarian Republic of)",
      "VNM": "Viet Nam",
      "VGB": "Virgin Islands (British)",
      "VIR": "Virgin Islands (U.S.)",
      "WLF": "Wallis and Futuna",
      "ESH": "Western Sahara*",
      "YEM": "Yemen",
      "ZMB": "Zambia",
      "ZWE": "Zimbabwe",
      "ALA": "\xC5land Islands",
      "GBD": "British Overseas Territories Citizen",
      "GBN": "British National (Overseas)",
      "GBO": "British Overseas Citizen",
      "GBS": "British Subject",
      "GBP": "British Protected Person",
      "RKS": "Republic of Kosovo",
      "D": "Germany",
      "XXK": "Kosovo",
      "EUE": "European Union (EU)",
      "UNO": "United Nations Organization or one of its officials",
      "UNA": "United Nations specialized agency or one of its officials",
      "UNK": "Resident of Kosovo to whom a travel document has been issued by the United Nations Interim Administration Mission in Kosovo (UNMIK)",
      "XBA": "African Development Bank (ADB)",
      "XIM": "African Export-Import Bank (AFREXIM bank)",
      "XCC": "Caribbean Community or one of its emissaries (CARICOM)",
      "XCE": "Council of Europe",
      "XCO": "Common Market for Eastern and Southern Africa (COMESA)",
      "XEC": "Economic Community of West African States (ECOWAS)",
      "XPO": "International Criminal Police Organization (INTERPOL)",
      "XES": "Organization of Eastern Caribbean States (OECS)",
      "XOM": "Sovereign Military Order of Malta or one of its emissaries",
      "XDC": "Southern African Development Community",
      "XXA": "Stateless person, as defined in Article 1 of the 1954 Convention Relating to the Status of Stateless Persons",
      "XXB": "Refugee, as defined in Article 1 of the 1951 Convention Relating to the Status of Refugees as amended by the 1967 Protocol",
      "XXC": "Refugee, other than as defined under the code XXB above",
      "XXX": "Person of unspecified nationality, for whom issuing State does not consider it necessary to specify any of the codes XXA, XXB or XXC above, whatever that person\u2019s status may be. This category may include a person who is neither stateless nor a refugee but who is of unknown nationality and legally residing in the State of issue.",
      "ANT": "Netherlands Antilles",
      "NTZ": "Neutral Zone"
    };
    Object.freeze(states);
    states_default = states;
  }
});

// ../../node_modules/mrz/lib-esm/parse/checkLines.js
function checkLines(lines) {
  if (typeof lines === "string") {
    lines = lines.split(/[\r\n]+/);
  }
  if (!Array.isArray(lines)) {
    throw new TypeError("input must be an array or string");
  }
  for (const line of lines) {
    if (!line.match(/[A-Z0-9<]+/)) {
      throw new TypeError('lines must be composed of only alphanumerical characters and "<"');
    }
  }
  return lines;
}
var init_checkLines = __esm({
  "../../node_modules/mrz/lib-esm/parse/checkLines.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/frenchDrivingLicence/parseDocumentCode.js
function parseDocumentCode(source) {
  if (source.length !== 2) {
    throw new Error(`invalid document code: ${source}. must be 2 char length`);
  }
  const [first, second] = source;
  validateFirstChar(first, source);
  validateSecondChar(second, source);
  return `${first}${second}`;
}
function validateFirstChar(char, source) {
  if (!knownPrefixCode.includes(char)) {
    const formatter = new Intl.ListFormat("en-US", {
      style: "short",
      type: "disjunction"
    });
    throw new Error(`invalid document code: ${source}. First character must be ${formatter.format(knownPrefixCode)}`);
  }
}
function validateSecondChar(char, source) {
  const num = parseInt(char, 10);
  if (Number.isNaN(num)) {
    throw new Error(`invalid document code number: ${source}. Second character must be a number`);
  }
}
var knownPrefixCode;
var init_parseDocumentCode = __esm({
  "../../node_modules/mrz/lib-esm/parsers/frenchDrivingLicence/parseDocumentCode.js"() {
    "use strict";
    knownPrefixCode = ["A", "B", "D"];
  }
});

// ../../node_modules/mrz/lib-esm/parsers/cleanText.js
function cleanText(string) {
  return string.replace(/<+$/g, "").replace(/</g, " ");
}
var init_cleanText = __esm({
  "../../node_modules/mrz/lib-esm/parsers/cleanText.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseAlpha.js
function parseAlpha(source) {
  if (!source.match(/^[A-Z<]+$/)) {
    throw new Error(`invalid text: ${source}. Must be only alphabetical with <`);
  }
  return cleanText(source);
}
var init_parseAlpha = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseAlpha.js"() {
    "use strict";
    init_cleanText();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseText.js
function parseText(source, initialStart, regexp = /^[0-9A-Z<]+$/) {
  const cleaned = cleanText(source);
  if (!regexp.test(source)) {
    throw new ParseTextError(`invalid text: ${source}. Must match the following regular expression: ${regexp.toString()}`, cleaned, initialStart, initialStart + cleaned.length);
  }
  return cleaned;
}
var ParseTextError;
var init_parseText = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseText.js"() {
    "use strict";
    init_cleanText();
    ParseTextError = class extends Error {
      constructor(message, value, start, end) {
        super(message);
        this.value = value;
        this.start = start;
        this.end = end;
      }
    };
  }
});

// ../../node_modules/mrz/lib-esm/parse/autoCorrection.js
function letterToNumber(char) {
  if (letterToNumberMismatches[char]) {
    return letterToNumberMismatches[char];
  }
  return char;
}
function numberToLetter(char) {
  if (numberToLetterMismatches[char]) {
    return numberToLetterMismatches[char];
  }
  return char;
}
function autoCorrection(source, fieldOptions) {
  let correctedText = "";
  const autocorrect = [];
  const chars = source.split("");
  chars.forEach((char, i2) => {
    if (fieldOptions.type === fieldTypes.ALPHABETIC) {
      const correctedChar = numberToLetter(char);
      if (correctedChar !== char) {
        autocorrect.push({
          line: fieldOptions.line,
          column: fieldOptions.start + i2,
          original: char,
          corrected: correctedChar
        });
      }
      correctedText += correctedChar;
    } else if (fieldOptions.type === fieldTypes.NUMERIC) {
      const correctedChar = letterToNumber(char);
      if (correctedChar !== char) {
        autocorrect.push({
          line: fieldOptions.line,
          column: fieldOptions.start + i2,
          original: char,
          corrected: correctedChar
        });
      }
      correctedText += correctedChar;
    } else {
      correctedText += char;
    }
  });
  return { correctedText, autocorrect };
}
var numberToLetterMismatches, letterToNumberMismatches;
var init_autoCorrection = __esm({
  "../../node_modules/mrz/lib-esm/parse/autoCorrection.js"() {
    "use strict";
    init_createFieldParser();
    numberToLetterMismatches = {
      "8": "B",
      "6": "G",
      "0": "O",
      "1": "I",
      "5": "S",
      "2": "Z"
    };
    letterToNumberMismatches = {
      B: "8",
      G: "6",
      O: "0",
      I: "1",
      S: "5",
      Z: "2"
    };
  }
});

// ../../node_modules/mrz/lib-esm/parse/createFieldParser.js
function createFieldParser(fieldOptions) {
  checkType(fieldOptions, "label", "string");
  if (fieldOptions.field !== null) {
    checkType(fieldOptions, "field", "string");
  }
  checkType(fieldOptions, "line", "number");
  checkType(fieldOptions, "start", "number");
  checkType(fieldOptions, "end", "number");
  checkType(fieldOptions, "parser", "function");
  const mainRange = {
    line: fieldOptions.line,
    start: fieldOptions.start,
    end: fieldOptions.end
  };
  const ranges = [mainRange];
  if (Array.isArray(fieldOptions.related)) {
    for (const related of fieldOptions.related) {
      checkType(related, "line", "number");
      checkType(related, "start", "number");
      checkType(related, "end", "number");
      ranges.push(related);
    }
  }
  const parser = (lines, autocorrect) => {
    const source = getText(lines, fieldOptions);
    const related = fieldOptions.related || [];
    const textRelated = related.map((r) => getText(lines, r));
    const result = {
      label: fieldOptions.label,
      field: fieldOptions.field,
      value: null,
      valid: false,
      ranges: ranges.map((range2) => ({
        ...range2,
        raw: getText(lines, range2)
      })),
      line: 0,
      start: 0,
      end: 0,
      autocorrect: []
    };
    const range = result.ranges[0];
    result.line = range.line;
    result.start = range.start;
    result.end = range.end;
    try {
      const parsed = fieldOptions.parser(source, ...textRelated);
      result.value = typeof parsed === "object" ? parsed.value : parsed;
      result.valid = true;
      if (typeof parsed === "object") {
        result.start = range.start + parsed.start;
        result.end = range.start + parsed.end;
      }
    } catch (err) {
      result.error = err.message;
      if (err instanceof ParseTextError) {
        result.value = err.value;
        result.start = range.start + err.start;
        result.end = range.start + err.end;
      }
    }
    for (const autocorrectElement of autocorrect) {
      if (autocorrectElement.line === result.line && autocorrectElement.column >= result.start && autocorrectElement.column < result.end) {
        result.autocorrect.push(autocorrectElement);
      }
    }
    return result;
  };
  const autocorrector = (lines) => {
    const originalText = getText(lines, fieldOptions);
    return {
      ...autoCorrection(originalText, fieldOptions),
      range: mainRange
    };
  };
  return { parser, autocorrector };
}
function getText(lines, options) {
  const line = lines[options.line];
  return line.substring(options.start, options.end);
}
function checkType(options, name, type) {
  if (typeof options[name] !== type) {
    throw new TypeError(`${name} must be a ${type}`);
  }
}
var fieldTypes;
var init_createFieldParser = __esm({
  "../../node_modules/mrz/lib-esm/parse/createFieldParser.js"() {
    "use strict";
    init_parseText();
    init_autoCorrection();
    fieldTypes = {
      NUMERIC: "NUMERIC",
      ALPHABETIC: "ALPHABETIC",
      ALPHANUMERIC: "ALPHANUMERIC"
    };
  }
});

// ../../node_modules/mrz/lib-esm/parsers/check.js
function check(string, value) {
  let code = 0;
  const factors = [7, 3, 1];
  for (let i2 = 0; i2 < string.length; i2++) {
    let charCode = string.charCodeAt(i2);
    if (charCode === 60)
      charCode = 0;
    if (charCode >= 65)
      charCode -= 55;
    if (charCode >= 48)
      charCode -= 48;
    charCode *= factors[i2 % 3];
    code += charCode;
  }
  code %= 10;
  if (code !== Number(value)) {
    throw new Error(`invalid check digit: ${value}. Must be ${code}`);
  }
}
var init_check = __esm({
  "../../node_modules/mrz/lib-esm/parsers/check.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseCompositeCheckDigit.js
function parseCompositeCheckDigit(checkDigit, ...sources) {
  const source = sources.join("");
  check(source, checkDigit);
  return checkDigit;
}
var init_parseCompositeCheckDigit = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseCompositeCheckDigit.js"() {
    "use strict";
    init_check();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDate.js
function parseDate2(value) {
  if (!value.match(/^[0-9<]{4,6}$/)) {
    throw new Error(`invalid date: ${value}`);
  }
  const month = value.substring(2, 4);
  if (month !== "<<" && (parseInt(month, 10) < 1 || parseInt(month, 10) > 12)) {
    throw new Error(`invalid date month: ${month}`);
  }
  if (value.length === 6) {
    const day = value.substring(4, 6);
    if (day !== "<<" && (parseInt(day, 10) < 1 || parseInt(day, 10) > 31)) {
      throw new Error(`invalid date day: ${day}`);
    }
  }
  return value;
}
var init_parseDate = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDate.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDateCheckDigit.js
function parseCheckDigit(checkDigit, value) {
  check(value, checkDigit);
  return checkDigit;
}
var init_parseDateCheckDigit = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDateCheckDigit.js"() {
    "use strict";
    init_check();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDocumentNumber.js
function parseDocumentNumber(source, checkDigit, optional) {
  let end, value;
  if (checkDigit === "<" && optional) {
    const firstFiller = optional.indexOf("<");
    const tail = optional.substring(0, firstFiller - 1);
    value = source + tail;
    end = value.length + 1;
  } else {
    value = cleanText(source);
    end = value.length;
  }
  return {
    value,
    start: 0,
    end
  };
}
var init_parseDocumentNumber = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDocumentNumber.js"() {
    "use strict";
    init_cleanText();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDocumentNumberCheckDigit.js
function parseDocumentNumberCheckDigit(checkDigit, source, optional) {
  if (checkDigit === "<" && optional) {
    const firstFiller = optional.indexOf("<");
    const tail = optional.substring(0, firstFiller - 1);
    source = `${source}<${tail}`;
    checkDigit = optional.charAt(firstFiller - 1);
    check(source, checkDigit);
    return {
      value: checkDigit,
      start: firstFiller,
      end: firstFiller + 1
    };
  } else {
    check(source, checkDigit);
    return checkDigit;
  }
}
var init_parseDocumentNumberCheckDigit = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDocumentNumberCheckDigit.js"() {
    "use strict";
    init_check();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseFirstName.js
function parseFirstName(source) {
  const withoutStart = source.replace(/.*?<{2}/, "");
  const value = parseText(withoutStart, source.length - withoutStart.length, /^[A-Z<]+<*$/);
  const start = source.length - withoutStart.length;
  return {
    value,
    start,
    end: start + value.length
  };
}
var init_parseFirstName = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseFirstName.js"() {
    "use strict";
    init_parseText();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseLastName.js
function parseLastName(source) {
  const parsed = parseText(source.replace(/<{2}.*$/, ""), 0, /^[A-Z<]*<*$/);
  return {
    value: parsed,
    start: 0,
    end: parsed.length
  };
}
var init_parseLastName = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseLastName.js"() {
    "use strict";
    init_parseText();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseSex.js
function parseSex(source) {
  switch (source) {
    case "M":
      return "male";
    case "F":
      return "female";
    case "<":
      return "nonspecified";
    default:
      throw new Error(`invalid sex: ${source}. Must be M, F or <.`);
  }
}
var init_parseSex = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseSex.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseState.js
function parseState(source) {
  source = cleanText(source);
  const state = states_default[source];
  if (!state) {
    throw new Error(`invalid state code: ${source}`);
  }
  return {
    value: source,
    start: 0,
    end: source.length
  };
}
var init_parseState = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseState.js"() {
    "use strict";
    init_states();
    init_cleanText();
  }
});

// ../../node_modules/mrz/lib-esm/parse/fieldTemplates.js
var documentNumberTemplate, documentNumberCheckDigitTemplate, documentCodeTemplate, documentCodeAlphaNumTemplate, nationalityTemplate, sexTemplate, expirationDateTemplate, expirationDateCheckDigitTemplate, compositeCheckDigitTemplate, birthDateTemplate, birthDateCheckDigitTemplate, issueDateTemplate, firstNameTemplate, lastNameTemplate, issuingStateTemplate;
var init_fieldTemplates = __esm({
  "../../node_modules/mrz/lib-esm/parse/fieldTemplates.js"() {
    "use strict";
    init_parseCompositeCheckDigit();
    init_parseDate();
    init_parseDateCheckDigit();
    init_parseDocumentNumber();
    init_parseDocumentNumberCheckDigit();
    init_parseFirstName();
    init_parseLastName();
    init_parseSex();
    init_parseState();
    init_createFieldParser();
    documentNumberTemplate = {
      label: "Document number",
      field: "documentNumber",
      parser: parseDocumentNumber,
      type: fieldTypes.ALPHANUMERIC
    };
    documentNumberCheckDigitTemplate = {
      label: "Document number check digit",
      field: "documentNumberCheckDigit",
      parser: parseDocumentNumberCheckDigit,
      type: fieldTypes.NUMERIC
    };
    documentCodeTemplate = {
      label: "Document code",
      field: "documentCode",
      type: fieldTypes.ALPHABETIC
    };
    documentCodeAlphaNumTemplate = {
      label: "Document code",
      field: "documentCode",
      type: fieldTypes.ALPHANUMERIC
    };
    nationalityTemplate = {
      label: "Nationality",
      field: "nationality",
      parser: parseState,
      type: fieldTypes.ALPHABETIC
    };
    sexTemplate = {
      label: "Sex",
      field: "sex",
      parser: parseSex,
      type: fieldTypes.ALPHABETIC
    };
    expirationDateTemplate = {
      label: "Expiration date",
      field: "expirationDate",
      parser: parseDate2,
      type: fieldTypes.NUMERIC
    };
    expirationDateCheckDigitTemplate = {
      label: "Expiration date check digit",
      field: "expirationDateCheckDigit",
      parser: parseCheckDigit,
      type: fieldTypes.NUMERIC
    };
    compositeCheckDigitTemplate = {
      label: "Composite check digit",
      field: "compositeCheckDigit",
      parser: parseCompositeCheckDigit,
      type: fieldTypes.NUMERIC
    };
    birthDateTemplate = {
      label: "Birth date",
      field: "birthDate",
      parser: parseDate2,
      type: fieldTypes.NUMERIC
    };
    birthDateCheckDigitTemplate = {
      label: "Birth date check digit",
      field: "birthDateCheckDigit",
      parser: parseCheckDigit,
      type: fieldTypes.NUMERIC
    };
    issueDateTemplate = {
      label: "Issue date",
      field: "issueDate",
      parser: parseDate2,
      type: fieldTypes.NUMERIC
    };
    firstNameTemplate = {
      label: "First name",
      field: "firstName",
      parser: parseFirstName,
      type: fieldTypes.ALPHABETIC
    };
    lastNameTemplate = {
      label: "Last name",
      field: "lastName",
      parser: parseLastName,
      type: fieldTypes.ALPHABETIC
    };
    issuingStateTemplate = {
      label: "Issuing state",
      field: "issuingState",
      parser: parseState,
      type: fieldTypes.ALPHABETIC
    };
  }
});

// ../../node_modules/mrz/lib-esm/parse/frenchDrivingLicenceFields.js
var fields, frenchDrivingLicenceFields_default;
var init_frenchDrivingLicenceFields = __esm({
  "../../node_modules/mrz/lib-esm/parse/frenchDrivingLicenceFields.js"() {
    "use strict";
    init_parseDocumentCode();
    init_parseAlpha();
    init_createFieldParser();
    init_fieldTemplates();
    fields = [
      {
        ...documentCodeAlphaNumTemplate,
        line: 0,
        start: 0,
        end: 2,
        parser: parseDocumentCode
      },
      { ...issuingStateTemplate, line: 0, start: 2, end: 5 },
      { ...documentNumberTemplate, line: 0, start: 5, end: 14 },
      {
        ...documentNumberCheckDigitTemplate,
        line: 0,
        start: 14,
        end: 15,
        related: [
          {
            line: 0,
            start: 0,
            end: 14
          }
        ]
      },
      { ...expirationDateTemplate, line: 0, start: 15, end: 21 },
      { ...lastNameTemplate, line: 0, start: 21, end: 29, parser: parseAlpha },
      {
        ...compositeCheckDigitTemplate,
        line: 0,
        start: 29,
        end: 30,
        related: [
          {
            line: 0,
            start: 0,
            end: 29
          }
        ]
      }
    ];
    frenchDrivingLicenceFields_default = fields.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/getDocumentNumber.js
function getDocumentNumber(format2, fields7) {
  switch (format2) {
    case "TD1":
    case "TD2":
    case "TD3":
    case "FRENCH_DRIVING_LICENSE":
      return buildDocumentNumber(fields7.documentNumber);
    case "FRENCH_NATIONAL_ID":
      return buildDocumentNumber(fields7.issueDate, fields7.administrativeCode2, fields7.documentNumber);
    case "SWISS_DRIVING_LICENSE":
      return buildDocumentNumber(fields7.pinCode, fields7.versionNumber);
    default:
      assertUnreachableFormat(format2);
  }
}
function buildDocumentNumber(...parts) {
  let result = "";
  for (const part of parts) {
    if (!part) {
      return null;
    }
    result += part;
  }
  return result;
}
function assertUnreachableFormat(format2) {
  throw new Error(`unrecognized format: ${format2}`);
}
var init_getDocumentNumber = __esm({
  "../../node_modules/mrz/lib-esm/parse/getDocumentNumber.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parse/getResult.js
function getDetails(lines, fieldParsers, autocorrectArray) {
  const details = [];
  fieldParsers.forEach(({ parser }, i2) => {
    details.push(parser(lines, autocorrectArray[i2]));
  });
  return details;
}
function getFields(details) {
  const fields7 = {};
  let allValid = true;
  for (const detail of details) {
    if (!detail.valid) {
      allValid = false;
    }
    if (detail.field) {
      fields7[detail.field] = detail.valid ? detail.value : null;
    }
  }
  return { fields: fields7, allValid };
}
function getCorrection(lines, fieldParsers, autocorrect) {
  const corrected = lines.slice();
  let autocorrectArray = [];
  if (autocorrect) {
    fieldParsers.forEach(({ autocorrector }) => {
      const { autocorrect: autocorrect2, correctedText, range } = autocorrector(lines);
      autocorrectArray.push(autocorrect2);
      const line = corrected[range.line];
      corrected[range.line] = line.slice(0, range.start) + correctedText + line.slice(range.end);
    });
  } else {
    autocorrectArray = new Array(fieldParsers.length).fill([]);
  }
  return { corrected, autocorrectArray };
}
function getResult(format2, lines, fieldParsers, options) {
  const { autocorrect = false } = options;
  const { corrected, autocorrectArray } = getCorrection(lines, fieldParsers, autocorrect);
  const details = getDetails(corrected, fieldParsers, autocorrectArray);
  const fields7 = getFields(details);
  return {
    format: format2,
    details,
    fields: fields7.fields,
    documentNumber: getDocumentNumber(format2, fields7.fields),
    valid: fields7.allValid
  };
}
var init_getResult = __esm({
  "../../node_modules/mrz/lib-esm/parse/getResult.js"() {
    "use strict";
    init_getDocumentNumber();
  }
});

// ../../node_modules/mrz/lib-esm/parse/frenchDrivingLicence.js
function parseFrenchDrivingLicense(lines, options) {
  if (lines.length !== 1) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 1 for ${FRENCH_DRIVING_LICENSE}`);
  }
  if (lines[0].length !== 30) {
    throw new Error(`invalid number of characters for line 1: ${lines[0].length}. Must be 30 for ${FRENCH_DRIVING_LICENSE}`);
  }
  return getResult(FRENCH_DRIVING_LICENSE, lines, frenchDrivingLicenceFields_default, options);
}
var FRENCH_DRIVING_LICENSE;
var init_frenchDrivingLicence = __esm({
  "../../node_modules/mrz/lib-esm/parse/frenchDrivingLicence.js"() {
    "use strict";
    init_formats();
    init_frenchDrivingLicenceFields();
    init_getResult();
    FRENCH_DRIVING_LICENSE = formats.FRENCH_DRIVING_LICENSE;
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDocumentCodeId.js
function parseDocumentCodeId(source) {
  const first = source.charAt(0);
  if (first !== "A" && first !== "C" && first !== "I") {
    throw new Error(`invalid document code: ${source}. First character must be A, C or I`);
  }
  const second = source.charAt(1);
  if (second === "V") {
    throw new Error(`invalid document code: ${source}. Second character may not be V`);
  }
  if (second === "<") {
    return {
      value: first,
      start: 0,
      end: 1
    };
  } else {
    return source;
  }
}
var init_parseDocumentCodeId = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDocumentCodeId.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseOptional.js
function parseOptional(source) {
  const value = parseText(source, 0);
  return {
    value,
    start: 0,
    end: value.length
  };
}
var init_parseOptional = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseOptional.js"() {
    "use strict";
    init_parseText();
  }
});

// ../../node_modules/mrz/lib-esm/parse/frenchNationalIdFields.js
var fields2, frenchNationalIdFields_default;
var init_frenchNationalIdFields = __esm({
  "../../node_modules/mrz/lib-esm/parse/frenchNationalIdFields.js"() {
    "use strict";
    init_parseAlpha();
    init_parseDocumentCodeId();
    init_parseOptional();
    init_createFieldParser();
    init_fieldTemplates();
    fields2 = [
      {
        ...documentCodeTemplate,
        line: 0,
        start: 0,
        end: 2,
        parser: parseDocumentCodeId
      },
      { ...issuingStateTemplate, line: 0, start: 2, end: 5 },
      { ...lastNameTemplate, line: 0, start: 5, end: 30, parser: parseAlpha },
      {
        label: "Administrative code",
        field: "administrativeCode",
        line: 0,
        start: 30,
        end: 36,
        parser: parseOptional
      },
      { ...issueDateTemplate, line: 1, start: 0, end: 4 },
      {
        label: "Administrative code 2",
        field: "administrativeCode2",
        line: 1,
        start: 4,
        end: 7,
        parser: parseOptional
      },
      { ...documentNumberTemplate, line: 1, start: 7, end: 12 },
      {
        ...documentNumberCheckDigitTemplate,
        line: 1,
        start: 12,
        end: 13,
        related: [
          {
            line: 1,
            start: 0,
            end: 12
          }
        ]
      },
      { ...firstNameTemplate, line: 1, start: 13, end: 27, parser: parseAlpha },
      { ...birthDateTemplate, line: 1, start: 27, end: 33 },
      {
        ...birthDateCheckDigitTemplate,
        line: 1,
        start: 33,
        end: 34,
        related: [
          {
            line: 1,
            start: 27,
            end: 33
          }
        ]
      },
      { ...sexTemplate, line: 1, start: 34, end: 35 },
      {
        ...compositeCheckDigitTemplate,
        line: 1,
        start: 35,
        end: 36,
        related: [
          {
            line: 0,
            start: 0,
            end: 36
          },
          {
            line: 1,
            start: 0,
            end: 35
          }
        ]
      }
    ];
    frenchNationalIdFields_default = fields2.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/frenchNationalId.js
function parseFrenchNationalId(lines, options) {
  if (lines.length !== 2) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 2 for ${FRENCH_NATIONAL_ID}`);
  }
  lines.forEach((line, index) => {
    if (line.length !== 36) {
      throw new Error(`invalid number of characters for line ${index + 1}: ${line.length}. Must be 36 for ${FRENCH_NATIONAL_ID}`);
    }
  });
  return getResult(FRENCH_NATIONAL_ID, lines, frenchNationalIdFields_default, options);
}
var FRENCH_NATIONAL_ID;
var init_frenchNationalId = __esm({
  "../../node_modules/mrz/lib-esm/parse/frenchNationalId.js"() {
    "use strict";
    init_formats();
    init_frenchNationalIdFields();
    init_getResult();
    FRENCH_NATIONAL_ID = formats.FRENCH_NATIONAL_ID;
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseNumber.js
function parseNumber(source) {
  if (!source.match(/^[0-9]+$/)) {
    throw new Error(`invalid number: ${source}`);
  }
  return source;
}
var init_parseNumber = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseNumber.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/checkSeparator.js
function checkSeparator(source) {
  if (!source.match(/^<*$/)) {
    throw new Error(`invalid separator: ${source}. Must be composed only of "<"`);
  }
  return source;
}
var init_checkSeparator = __esm({
  "../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/checkSeparator.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseDocumentCode.js
function parseDocumentCode2(source) {
  if (source !== "FA") {
    throw new Error(`invalid document code: ${source}. Must be FA`);
  }
  return source;
}
var init_parseDocumentCode2 = __esm({
  "../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseDocumentCode.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseLanguageCode.js
function parseLanguageCode(languageCode) {
  switch (languageCode) {
    case "D":
    case "F":
    case "I":
    case "R":
      return languageCode;
    default:
      throw new Error(`invalid languageCode code: ${languageCode}. Must be D, F, I or R`);
  }
}
var init_parseLanguageCode = __esm({
  "../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseLanguageCode.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseDocumentNumber.js
function parseDocumentNumber2(source) {
  const first = source.substring(0, 3);
  const second = source.substring(3, 6);
  const languageCode = source.charAt(6);
  const end = source.substring(7);
  if (!first.match(/^[A-Z0-9]{3}$/)) {
    throw new Error(`invalid document number: ${source}. Must start with three alphanumeric digits`);
  }
  if (!second.match(/^[0-9]{3}$/)) {
    throw new Error(`invalid document number: ${source}. Must have numeric digits in positions 4, 5 and 6`);
  }
  if (end !== "<<") {
    throw new Error(`invalid document number: ${source}. Must end with <<`);
  }
  parseLanguageCode(languageCode);
  return {
    value: source.substring(0, 7),
    start: 0,
    end: 7
  };
}
var init_parseDocumentNumber2 = __esm({
  "../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseDocumentNumber.js"() {
    "use strict";
    init_parseLanguageCode();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseIssuingState.js
function parseIssuingState(source) {
  if (source !== "CHE" && source !== "LIE") {
    throw new Error(`invalid state code: ${source}. Must be CHE or LIE`);
  }
  return source;
}
var init_parseIssuingState = __esm({
  "../../node_modules/mrz/lib-esm/parsers/swissDrivingLicense/parseIssuingState.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parse/swissDrivingLicenseFields.js
var fields3, swissDrivingLicenseFields_default;
var init_swissDrivingLicenseFields = __esm({
  "../../node_modules/mrz/lib-esm/parse/swissDrivingLicenseFields.js"() {
    "use strict";
    init_parseNumber();
    init_checkSeparator();
    init_parseDocumentCode2();
    init_parseDocumentNumber2();
    init_parseIssuingState();
    init_parseLanguageCode();
    init_createFieldParser();
    init_fieldTemplates();
    fields3 = [
      {
        ...documentNumberTemplate,
        line: 0,
        start: 0,
        end: 9,
        parser: parseDocumentNumber2
      },
      {
        label: "Language code",
        field: "languageCode",
        line: 0,
        start: 6,
        end: 7,
        parser: parseLanguageCode,
        type: fieldTypes.ALPHABETIC
      },
      {
        ...documentCodeTemplate,
        line: 1,
        start: 0,
        end: 2,
        parser: parseDocumentCode2
      },
      {
        ...issuingStateTemplate,
        line: 1,
        start: 2,
        end: 5,
        parser: parseIssuingState
      },
      {
        label: "PIN code",
        field: "pinCode",
        line: 1,
        start: 5,
        end: 14,
        parser: parseNumber,
        type: fieldTypes.NUMERIC
      },
      {
        label: "Version number",
        field: "versionNumber",
        line: 1,
        start: 14,
        end: 17,
        parser: parseNumber,
        type: fieldTypes.NUMERIC
      },
      {
        label: "Separator 1",
        field: null,
        line: 1,
        start: 17,
        end: 19,
        parser: checkSeparator
      },
      { ...birthDateTemplate, line: 1, start: 19, end: 25 },
      {
        label: "Separator 2",
        field: null,
        line: 1,
        start: 25,
        end: 30,
        parser: checkSeparator
      },
      { ...lastNameTemplate, line: 2, start: 0, end: 30 },
      { ...firstNameTemplate, line: 2, start: 0, end: 30 }
    ];
    swissDrivingLicenseFields_default = fields3.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/swissDrivingLicense.js
function parseSwissDrivingLicense(lines, options) {
  if (lines.length !== 3) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 3 for ${SWISS_DRIVING_LICENSE}`);
  }
  if (lines[0].length !== 9) {
    throw new Error(`invalid number of characters for line 1: ${lines[0].length}. Must be 9 for ${SWISS_DRIVING_LICENSE}`);
  }
  if (lines[1].length !== 30) {
    throw new Error(`invalid number of characters for line 2: ${lines[1].length}. Must be 30 for ${SWISS_DRIVING_LICENSE}`);
  }
  if (lines[2].length !== 30) {
    throw new Error(`invalid number of characters for line 3: ${lines[2].length}. Must be 30 for ${SWISS_DRIVING_LICENSE}`);
  }
  return getResult(SWISS_DRIVING_LICENSE, lines, swissDrivingLicenseFields_default, options);
}
var SWISS_DRIVING_LICENSE;
var init_swissDrivingLicense = __esm({
  "../../node_modules/mrz/lib-esm/parse/swissDrivingLicense.js"() {
    "use strict";
    init_formats();
    init_getResult();
    init_swissDrivingLicenseFields();
    SWISS_DRIVING_LICENSE = formats.SWISS_DRIVING_LICENSE;
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDocumentNumberOptional.js
function parseDocumentNumberOptional(optional, checkDigit) {
  if (checkDigit === "<") {
    const firstFiller = optional.indexOf("<");
    const value = parseText(optional.substring(firstFiller + 1), firstFiller + 1);
    return {
      value,
      start: firstFiller + 1,
      end: firstFiller + 1 + value.length
    };
  } else {
    const value = parseText(optional, 0);
    return {
      value,
      start: 0,
      end: value.length
    };
  }
}
var init_parseDocumentNumberOptional = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDocumentNumberOptional.js"() {
    "use strict";
    init_parseText();
  }
});

// ../../node_modules/mrz/lib-esm/parse/td1Fields.js
var fields4, td1Fields_default;
var init_td1Fields = __esm({
  "../../node_modules/mrz/lib-esm/parse/td1Fields.js"() {
    "use strict";
    init_parseDocumentCodeId();
    init_parseDocumentNumberOptional();
    init_parseOptional();
    init_createFieldParser();
    init_fieldTemplates();
    fields4 = [
      {
        ...documentCodeTemplate,
        line: 0,
        start: 0,
        end: 2,
        parser: parseDocumentCodeId
      },
      { ...issuingStateTemplate, line: 0, start: 2, end: 5 },
      {
        ...documentNumberTemplate,
        line: 0,
        start: 5,
        end: 14,
        related: [
          {
            line: 0,
            start: 14,
            end: 15
          },
          {
            line: 0,
            start: 15,
            end: 30
          }
        ]
      },
      {
        ...documentNumberCheckDigitTemplate,
        line: 0,
        start: 14,
        end: 15,
        related: [
          {
            line: 0,
            start: 5,
            end: 14
          },
          {
            line: 0,
            start: 15,
            end: 30
          }
        ]
      },
      {
        label: "Optional field 1",
        field: "optional1",
        line: 0,
        start: 15,
        end: 30,
        related: [
          {
            line: 0,
            start: 5,
            end: 14
          },
          {
            line: 0,
            start: 14,
            end: 15
          }
        ],
        parser: parseDocumentNumberOptional
      },
      { ...birthDateTemplate, start: 0, end: 6, line: 1 },
      {
        ...birthDateCheckDigitTemplate,
        line: 1,
        start: 6,
        end: 7,
        related: [
          {
            line: 1,
            start: 0,
            end: 6
          }
        ]
      },
      { ...sexTemplate, line: 1, start: 7, end: 8 },
      { ...expirationDateTemplate, line: 1, start: 8, end: 14 },
      {
        ...expirationDateCheckDigitTemplate,
        line: 1,
        start: 14,
        end: 15,
        related: [
          {
            line: 1,
            start: 8,
            end: 14
          }
        ]
      },
      { ...nationalityTemplate, line: 1, start: 15, end: 18 },
      {
        label: "Optional field 2",
        field: "optional2",
        line: 1,
        start: 18,
        end: 29,
        parser: parseOptional
      },
      {
        ...compositeCheckDigitTemplate,
        line: 1,
        start: 29,
        end: 30,
        related: [
          {
            line: 0,
            start: 5,
            end: 30
          },
          {
            line: 1,
            start: 0,
            end: 7
          },
          {
            line: 1,
            start: 8,
            end: 15
          },
          {
            line: 1,
            start: 18,
            end: 29
          }
        ]
      },
      { ...lastNameTemplate, line: 2, start: 0, end: 30 },
      { ...firstNameTemplate, line: 2, start: 0, end: 30 }
    ];
    td1Fields_default = fields4.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/td1.js
function parseTD1(lines, options) {
  if (lines.length !== 3) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 3 for ${TD1}`);
  }
  lines.forEach((line, index) => {
    if (line.length !== 30) {
      throw new Error(`invalid number of characters for line ${index + 1}: ${line.length}. Must be 30 for ${TD1}`);
    }
  });
  return getResult(TD1, lines, td1Fields_default, options);
}
var TD1;
var init_td1 = __esm({
  "../../node_modules/mrz/lib-esm/parse/td1.js"() {
    "use strict";
    init_formats();
    init_getResult();
    init_td1Fields();
    TD1 = formats.TD1;
  }
});

// ../../node_modules/mrz/lib-esm/parse/td2Fields.js
var fields5, td2Fields_default;
var init_td2Fields = __esm({
  "../../node_modules/mrz/lib-esm/parse/td2Fields.js"() {
    "use strict";
    init_parseDocumentCodeId();
    init_parseOptional();
    init_createFieldParser();
    init_fieldTemplates();
    fields5 = [
      {
        ...documentCodeTemplate,
        line: 0,
        start: 0,
        end: 2,
        parser: parseDocumentCodeId
      },
      { ...issuingStateTemplate, line: 0, start: 2, end: 5 },
      { ...lastNameTemplate, line: 0, start: 5, end: 36 },
      { ...firstNameTemplate, line: 0, start: 5, end: 36 },
      {
        ...documentNumberTemplate,
        line: 1,
        start: 0,
        end: 9,
        related: [
          {
            line: 1,
            start: 9,
            end: 10
          },
          {
            line: 1,
            start: 28,
            end: 35
          }
        ]
      },
      {
        ...documentNumberCheckDigitTemplate,
        line: 1,
        start: 9,
        end: 10,
        related: [
          {
            line: 1,
            start: 0,
            end: 9
          },
          {
            line: 1,
            start: 28,
            end: 35
          }
        ]
      },
      { ...nationalityTemplate, line: 1, start: 10, end: 13 },
      { ...birthDateTemplate, line: 1, start: 13, end: 19 },
      {
        ...birthDateCheckDigitTemplate,
        line: 1,
        start: 19,
        end: 20,
        related: [
          {
            line: 1,
            start: 13,
            end: 19
          }
        ]
      },
      { ...sexTemplate, line: 1, start: 20, end: 21 },
      { ...expirationDateTemplate, line: 1, start: 21, end: 27 },
      {
        ...expirationDateCheckDigitTemplate,
        line: 1,
        start: 27,
        end: 28,
        related: [
          {
            line: 1,
            start: 21,
            end: 27
          }
        ]
      },
      {
        label: "Optional field",
        field: "optional",
        line: 1,
        start: 28,
        end: 35,
        parser: parseOptional
      },
      {
        ...compositeCheckDigitTemplate,
        line: 1,
        start: 35,
        end: 36,
        related: [
          {
            line: 1,
            start: 0,
            end: 10
          },
          {
            line: 1,
            start: 13,
            end: 20
          },
          {
            line: 1,
            start: 21,
            end: 35
          }
        ]
      }
    ];
    td2Fields_default = fields5.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/td2.js
function parseTD2(lines, options) {
  if (lines.length !== 2) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 2 for ${TD2}`);
  }
  lines.forEach((line, index) => {
    if (line.length !== 36) {
      throw new Error(`invalid number of characters for line ${index + 1}: ${line.length}. Must be 36 for TD2`);
    }
  });
  return getResult(TD2, lines, td2Fields_default, options);
}
var TD2;
var init_td2 = __esm({
  "../../node_modules/mrz/lib-esm/parse/td2.js"() {
    "use strict";
    init_formats();
    init_getResult();
    init_td2Fields();
    TD2 = formats.TD2;
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parseDocumentCodePassport.js
function parseDocumentCodePassport(source) {
  const first = source.charAt(0);
  if (first !== "P") {
    throw new Error(`invalid document code: ${source}. First character must be P`);
  }
  const second = source.charAt(1);
  if (!second.match(/[A-Z<]/)) {
    throw new Error(`invalid document code: ${source}. Second character must be a letter or <`);
  }
  if (second === "<") {
    return {
      value: first,
      start: 0,
      end: 1
    };
  } else {
    return source;
  }
}
var init_parseDocumentCodePassport = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parseDocumentCodePassport.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parsePersonalNumber.js
function parsePersonalNumber(source) {
  const value = parseText(source, 0, /^[A-Z0-9<]+<*$/);
  return {
    value,
    start: 0,
    end: value.length
  };
}
var init_parsePersonalNumber = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parsePersonalNumber.js"() {
    "use strict";
    init_parseText();
  }
});

// ../../node_modules/mrz/lib-esm/parsers/parsePersonalNumberCheckDigit.js
function parsePersonalNumberCheckDigit(checkDigit, personalNumber) {
  const cleanNumber = cleanText(personalNumber);
  if (cleanNumber === "") {
    if (checkDigit !== "<" && checkDigit !== "0") {
      throw new Error(`invalid check digit ${checkDigit}: must be 0 or <`);
    } else {
      return checkDigit;
    }
  }
  check(personalNumber, checkDigit);
  return checkDigit;
}
var init_parsePersonalNumberCheckDigit = __esm({
  "../../node_modules/mrz/lib-esm/parsers/parsePersonalNumberCheckDigit.js"() {
    "use strict";
    init_check();
    init_cleanText();
  }
});

// ../../node_modules/mrz/lib-esm/parse/td3Fields.js
var fields6, td3Fields_default;
var init_td3Fields = __esm({
  "../../node_modules/mrz/lib-esm/parse/td3Fields.js"() {
    "use strict";
    init_parseDocumentCodePassport();
    init_parsePersonalNumber();
    init_parsePersonalNumberCheckDigit();
    init_createFieldParser();
    init_fieldTemplates();
    fields6 = [
      {
        ...documentCodeTemplate,
        line: 0,
        start: 0,
        end: 2,
        parser: parseDocumentCodePassport
      },
      { ...issuingStateTemplate, line: 0, start: 2, end: 5 },
      { ...lastNameTemplate, line: 0, start: 5, end: 44 },
      { ...firstNameTemplate, line: 0, start: 5, end: 44 },
      { ...documentNumberTemplate, line: 1, start: 0, end: 9 },
      {
        ...documentNumberCheckDigitTemplate,
        line: 1,
        start: 9,
        end: 10,
        related: [
          {
            line: 1,
            start: 0,
            end: 9
          }
        ]
      },
      { ...nationalityTemplate, line: 1, start: 10, end: 13 },
      { ...birthDateTemplate, line: 1, start: 13, end: 19 },
      {
        ...birthDateCheckDigitTemplate,
        line: 1,
        start: 19,
        end: 20,
        related: [
          {
            line: 1,
            start: 13,
            end: 19
          }
        ]
      },
      { ...sexTemplate, line: 1, start: 20, end: 21 },
      { ...expirationDateTemplate, line: 1, start: 21, end: 27 },
      {
        ...expirationDateCheckDigitTemplate,
        line: 1,
        start: 27,
        end: 28,
        related: [
          {
            line: 1,
            start: 21,
            end: 27
          }
        ]
      },
      {
        label: "Personal number",
        field: "personalNumber",
        line: 1,
        start: 28,
        end: 42,
        parser: parsePersonalNumber
      },
      {
        label: "Personal number check digit",
        field: "personalNumberCheckDigit",
        line: 1,
        start: 42,
        end: 43,
        related: [
          {
            line: 1,
            start: 28,
            end: 42
          }
        ],
        parser: parsePersonalNumberCheckDigit
      },
      {
        ...compositeCheckDigitTemplate,
        line: 1,
        start: 43,
        end: 44,
        related: [
          {
            line: 1,
            start: 0,
            end: 10
          },
          {
            line: 1,
            start: 13,
            end: 20
          },
          {
            line: 1,
            start: 21,
            end: 43
          }
        ]
      }
    ];
    td3Fields_default = fields6.map(createFieldParser);
  }
});

// ../../node_modules/mrz/lib-esm/parse/td3.js
function parseTD3(lines, options) {
  if (lines.length !== 2) {
    throw new Error(`invalid number of lines: ${lines.length}: Must be 2 for ${TD3}`);
  }
  lines.forEach((line, index) => {
    if (line.length !== 44) {
      throw new Error(`invalid number of characters for line ${index + 1}: ${line.length}. Must be 44 for TD3`);
    }
  });
  return getResult(TD3, lines, td3Fields_default, options);
}
var TD3;
var init_td3 = __esm({
  "../../node_modules/mrz/lib-esm/parse/td3.js"() {
    "use strict";
    init_formats();
    init_getResult();
    init_td3Fields();
    TD3 = formats.TD3;
  }
});

// ../../node_modules/mrz/lib-esm/parse/parsers.js
var parsers2;
var init_parsers2 = __esm({
  "../../node_modules/mrz/lib-esm/parse/parsers.js"() {
    "use strict";
    init_frenchDrivingLicence();
    init_frenchNationalId();
    init_swissDrivingLicense();
    init_td1();
    init_td2();
    init_td3();
    parsers2 = {
      td1: parseTD1,
      td2: parseTD2,
      td3: parseTD3,
      swissDrivingLicense: parseSwissDrivingLicense,
      frenchNationalId: parseFrenchNationalId,
      frenchDrivingLicense: parseFrenchDrivingLicense
    };
  }
});

// ../../node_modules/mrz/lib-esm/parse/parse.js
function parseMRZ(inputLines, options = {}) {
  const lines = checkLines(inputLines);
  switch (lines.length) {
    case 1: {
      switch (lines[0].length) {
        case 30:
          return parsers2.frenchDrivingLicense(lines, options);
        default:
          throw new Error(`unrecognized document format. First line of input must have 30 (French Driving License) characters and it has a length of ${lines[0].length}`);
      }
    }
    case 2:
    case 3: {
      switch (lines[0].length) {
        case 30:
          return parsers2.td1(lines, options);
        case 36: {
          if (lines[0].substring(30, 35).match(/[0-9]/) || lines[0].match(/^IDFRA/)) {
            return parsers2.frenchNationalId(lines, options);
          } else {
            return parsers2.td2(lines, options);
          }
        }
        case 44:
          return parsers2.td3(lines, options);
        case 9:
          return parsers2.swissDrivingLicense(lines, options);
        default:
          throw new Error(`unrecognized document format. First line of input must have 30 (TD1), 36 (TD2 or French National Id), 44 (TD3) or 9 (Swiss Driving License) characters and it has a length of ${lines[0].length}`);
      }
    }
    default:
      throw new Error(`unrecognized document format. Input must have one, two or three lines, found ${lines.length}`);
  }
}
var parse_default2;
var init_parse3 = __esm({
  "../../node_modules/mrz/lib-esm/parse/parse.js"() {
    "use strict";
    init_checkLines();
    init_parsers2();
    parse_default2 = parseMRZ;
  }
});

// ../../node_modules/mrz/lib-esm/types.js
var init_types = __esm({
  "../../node_modules/mrz/lib-esm/types.js"() {
    "use strict";
  }
});

// ../../node_modules/mrz/lib-esm/index.js
var lib_esm_exports = {};
__export(lib_esm_exports, {
  formats: () => formats,
  parse: () => parse_default2,
  states: () => states_default
});
var init_lib_esm = __esm({
  "../../node_modules/mrz/lib-esm/index.js"() {
    "use strict";
    init_formats();
    init_states();
    init_parse3();
    init_types();
  }
});

// ../../node_modules/date-fns/esm/locale/af/_lib/formatDistance/index.js
var formatDistanceLocale2, formatDistance4, formatDistance_default2;
var init_formatDistance3 = __esm({
  "../../node_modules/date-fns/esm/locale/af/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale2 = {
      lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
      },
      xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
      },
      halfAMinute: "'n halwe minuut",
      lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
      },
      xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
      },
      aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
      },
      xHours: {
        one: "1 uur",
        other: "{{count}} ure"
      },
      xDays: {
        one: "1 dag",
        other: "{{count}} dae"
      },
      aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
      },
      aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
      },
      xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
      },
      aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
      },
      xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
      },
      overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
      },
      almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
      }
    };
    formatDistance4 = function formatDistance5(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale2[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "oor " + result;
        } else {
          return result + " gelede";
        }
      }
      return result;
    };
    formatDistance_default2 = formatDistance4;
  }
});

// ../../node_modules/date-fns/esm/locale/af/_lib/formatLong/index.js
var dateFormats2, timeFormats2, dateTimeFormats2, formatLong2, formatLong_default2;
var init_formatLong2 = __esm({
  "../../node_modules/date-fns/esm/locale/af/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats2 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "yyyy/MM/dd"
    };
    timeFormats2 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats2 = {
      full: "{{date}} 'om' {{time}}",
      long: "{{date}} 'om' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong2 = {
      date: buildFormatLongFn({
        formats: dateFormats2,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats2,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats2,
        defaultWidth: "full"
      })
    };
    formatLong_default2 = formatLong2;
  }
});

// ../../node_modules/date-fns/esm/locale/af/_lib/formatRelative/index.js
var formatRelativeLocale2, formatRelative4, formatRelative_default2;
var init_formatRelative3 = __esm({
  "../../node_modules/date-fns/esm/locale/af/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale2 = {
      lastWeek: "'verlede' eeee 'om' p",
      yesterday: "'gister om' p",
      today: "'vandag om' p",
      tomorrow: "'m\xF4re om' p",
      nextWeek: "eeee 'om' p",
      other: "P"
    };
    formatRelative4 = function formatRelative5(token, _date, _baseDate, _options) {
      return formatRelativeLocale2[token];
    };
    formatRelative_default2 = formatRelative4;
  }
});

// ../../node_modules/date-fns/esm/locale/af/_lib/localize/index.js
var eraValues2, quarterValues2, monthValues2, dayValues2, dayPeriodValues2, formattingDayPeriodValues2, ordinalNumber3, localize2, localize_default2;
var init_localize2 = __esm({
  "../../node_modules/date-fns/esm/locale/af/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues2 = {
      narrow: ["vC", "nC"],
      abbreviated: ["vC", "nC"],
      wide: ["voor Christus", "na Christus"]
    };
    quarterValues2 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
    };
    monthValues2 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mrt", "Apr", "Mei", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
      wide: ["Januarie", "Februarie", "Maart", "April", "Mei", "Junie", "Julie", "Augustus", "September", "Oktober", "November", "Desember"]
    };
    dayValues2 = {
      narrow: ["S", "M", "D", "W", "D", "V", "S"],
      short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
      abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
      wide: ["Sondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrydag", "Saterdag"]
    };
    dayPeriodValues2 = {
      narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
      },
      abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
      },
      wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
      }
    };
    formattingDayPeriodValues2 = {
      narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
      },
      abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
      },
      wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
      }
    };
    ordinalNumber3 = function ordinalNumber4(dirtyNumber) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 < 20) {
        switch (rem100) {
          case 1:
          case 8:
            return number + "ste";
          default:
            return number + "de";
        }
      }
      return number + "ste";
    };
    localize2 = {
      ordinalNumber: ordinalNumber3,
      era: buildLocalizeFn({
        values: eraValues2,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues2,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback2(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues2,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues2,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues2,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues2,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default2 = localize2;
  }
});

// ../../node_modules/date-fns/esm/locale/af/_lib/match/index.js
var matchOrdinalNumberPattern2, parseOrdinalNumberPattern2, matchEraPatterns2, parseEraPatterns2, matchQuarterPatterns2, parseQuarterPatterns2, matchMonthPatterns2, parseMonthPatterns2, matchDayPatterns2, parseDayPatterns2, matchDayPeriodPatterns2, parseDayPeriodPatterns2, match2, match_default2;
var init_match2 = __esm({
  "../../node_modules/date-fns/esm/locale/af/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern2 = /^(\d+)(ste|de)?/i;
    parseOrdinalNumberPattern2 = /\d+/i;
    matchEraPatterns2 = {
      narrow: /^([vn]\.? ?C\.?)/,
      abbreviated: /^([vn]\. ?C\.?)/,
      wide: /^((voor|na) Christus)/
    };
    parseEraPatterns2 = {
      any: [/^v/, /^n/]
    };
    matchQuarterPatterns2 = {
      narrow: /^[1234]/i,
      abbreviated: /^K[1234]/i,
      wide: /^[1234](st|d)e kwartaal/i
    };
    parseQuarterPatterns2 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns2 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
      wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
    };
    parseMonthPatterns2 = {
      narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
      any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
    };
    matchDayPatterns2 = {
      narrow: /^[smdwv]/i,
      short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
      abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
      wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
    };
    parseDayPatterns2 = {
      narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
      any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
    };
    matchDayPeriodPatterns2 = {
      any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
    };
    parseDayPeriodPatterns2 = {
      any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
      }
    };
    match2 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern2,
        parsePattern: parseOrdinalNumberPattern2,
        valueCallback: function valueCallback3(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns2,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns2,
        defaultParseWidth: "any",
        valueCallback: function valueCallback4(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns2,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns2,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns2,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns2,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns2,
        defaultParseWidth: "any"
      })
    };
    match_default2 = match2;
  }
});

// ../../node_modules/date-fns/esm/locale/af/index.js
var locale2, af_default;
var init_af = __esm({
  "../../node_modules/date-fns/esm/locale/af/index.js"() {
    "use strict";
    init_formatDistance3();
    init_formatLong2();
    init_formatRelative3();
    init_localize2();
    init_match2();
    locale2 = {
      code: "af",
      formatDistance: formatDistance_default2,
      formatLong: formatLong_default2,
      formatRelative: formatRelative_default2,
      localize: localize_default2,
      match: match_default2,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    af_default = locale2;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/_lib/formatDistance/index.js
var formatDistanceLocale3, formatDistance6, formatDistance_default3;
var init_formatDistance4 = __esm({
  "../../node_modules/date-fns/esm/locale/ar/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale3 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
      },
      xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
      },
      aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
      },
      aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
      },
      almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
      }
    };
    formatDistance6 = function formatDistance7(token, count, options) {
      var usageGroup = formatDistanceLocale3[token];
      var result;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else if (count === 2) {
        result = usageGroup.two;
      } else if (count <= 10) {
        result = usageGroup.threeToTen.replace("{{count}}", String(count));
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u062E\u0644\u0627\u0644 " + result;
        } else {
          return "\u0645\u0646\u0630 " + result;
        }
      }
      return result;
    };
    formatDistance_default3 = formatDistance6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/_lib/formatLong/index.js
var dateFormats3, timeFormats3, dateTimeFormats3, formatLong3, formatLong_default3;
var init_formatLong3 = __esm({
  "../../node_modules/date-fns/esm/locale/ar/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats3 = {
      full: "EEEE\u060C do MMMM y",
      long: "do MMMM y",
      medium: "d MMM y",
      short: "dd/MM/yyyy"
    };
    timeFormats3 = {
      full: "HH:mm:ss",
      long: "HH:mm:ss",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats3 = {
      full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
      long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong3 = {
      date: buildFormatLongFn({
        formats: dateFormats3,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats3,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats3,
        defaultWidth: "full"
      })
    };
    formatLong_default3 = formatLong3;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/_lib/formatRelative/index.js
var formatRelativeLocale3, formatRelative6, formatRelative_default3;
var init_formatRelative4 = __esm({
  "../../node_modules/date-fns/esm/locale/ar/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale3 = {
      lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
      yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
      today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
      tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
      nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
      other: "P"
    };
    formatRelative6 = function formatRelative7(token) {
      return formatRelativeLocale3[token];
    };
    formatRelative_default3 = formatRelative6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/_lib/localize/index.js
var eraValues3, quarterValues3, monthValues3, dayValues3, dayPeriodValues3, formattingDayPeriodValues3, ordinalNumber5, localize3, localize_default3;
var init_localize3 = __esm({
  "../../node_modules/date-fns/esm/locale/ar/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues3 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues3 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues3 = {
      narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
      abbreviated: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648", "\u0623\u063A\u0633\u0637\u0633", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"],
      wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648", "\u0623\u063A\u0633\u0637\u0633", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
    };
    dayValues3 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues3 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      }
    };
    formattingDayPeriodValues3 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber5 = function ordinalNumber6(num) {
      return String(num);
    };
    localize3 = {
      ordinalNumber: ordinalNumber5,
      era: buildLocalizeFn({
        values: eraValues3,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues3,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback3(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues3,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues3,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues3,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues3,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default3 = localize3;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/_lib/match/index.js
var matchOrdinalNumberPattern3, parseOrdinalNumberPattern3, matchEraPatterns3, parseEraPatterns3, matchQuarterPatterns3, parseQuarterPatterns3, matchMonthPatterns3, parseMonthPatterns3, matchDayPatterns3, parseDayPatterns3, matchDayPeriodPatterns3, parseDayPeriodPatterns3, match3, match_default3;
var init_match3 = __esm({
  "../../node_modules/date-fns/esm/locale/ar/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern3 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern3 = /\d+/i;
    matchEraPatterns3 = {
      narrow: /[قب]/,
      abbreviated: /[قب]\.م\./,
      wide: /(قبل|بعد) الميلاد/
    };
    parseEraPatterns3 = {
      any: [/قبل/, /بعد/]
    };
    matchQuarterPatterns3 = {
      narrow: /^[1234]/i,
      abbreviated: /ر[1234]/,
      wide: /الربع (الأول|الثاني|الثالث|الرابع)/
    };
    parseQuarterPatterns3 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns3 = {
      narrow: /^[أيفمسند]/,
      abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
      wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
    };
    parseMonthPatterns3 = {
      narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
      any: [/^يناير/i, /^فبراير/i, /^مارس/i, /^أبريل/i, /^مايو/i, /^يونيو/i, /^يوليو/i, /^أغسطس/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
    };
    matchDayPatterns3 = {
      narrow: /^[حنثرخجس]/i,
      short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
    };
    parseDayPatterns3 = {
      narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
      wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
      any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
    };
    matchDayPeriodPatterns3 = {
      narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
      any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
    };
    parseDayPeriodPatterns3 = {
      any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
      }
    };
    match3 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern3,
        parsePattern: parseOrdinalNumberPattern3,
        valueCallback: function valueCallback5(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns3,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns3,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns3,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns3,
        defaultParseWidth: "any",
        valueCallback: function valueCallback6(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns3,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns3,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns3,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns3,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns3,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns3,
        defaultParseWidth: "any"
      })
    };
    match_default3 = match3;
  }
});

// ../../node_modules/date-fns/esm/locale/ar/index.js
var locale3, ar_default;
var init_ar = __esm({
  "../../node_modules/date-fns/esm/locale/ar/index.js"() {
    "use strict";
    init_formatDistance4();
    init_formatLong3();
    init_formatRelative4();
    init_localize3();
    init_match3();
    locale3 = {
      code: "ar",
      formatDistance: formatDistance_default3,
      formatLong: formatLong_default3,
      formatRelative: formatRelative_default3,
      localize: localize_default3,
      match: match_default3,
      options: {
        weekStartsOn: 6,
        firstWeekContainsDate: 1
      }
    };
    ar_default = locale3;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatDistance/index.js
var formatDistanceLocale4, formatDistance8, formatDistance_default4;
var init_formatDistance5 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale4 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
      },
      aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
      },
      aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
      },
      almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      }
    };
    formatDistance8 = function formatDistance9(token, count, options) {
      options = options || {};
      var usageGroup = formatDistanceLocale4[token];
      var result;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else if (count === 2) {
        result = usageGroup.two;
      } else if (count <= 10) {
        result = usageGroup.threeToTen.replace("{{count}}", String(count));
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        } else {
          return "\u0645\u0646\u0630 " + result;
        }
      }
      return result;
    };
    formatDistance_default4 = formatDistance8;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatLong/index.js
var dateFormats4, timeFormats4, dateTimeFormats4, formatLong4, formatLong_default4;
var init_formatLong4 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats4 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats4 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats4 = {
      full: "{{date}} '\u0639\u0646\u062F' {{time}}",
      long: "{{date}} '\u0639\u0646\u062F' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong4 = {
      date: buildFormatLongFn({
        formats: dateFormats4,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats4,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats4,
        defaultWidth: "full"
      })
    };
    formatLong_default4 = formatLong4;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatRelative/index.js
var formatRelativeLocale4, formatRelative8, formatRelative_default4;
var init_formatRelative5 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale4 = {
      lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
      yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
      today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
      tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
      nextWeek: "eeee '\u0639\u0646\u062F' p",
      other: "P"
    };
    formatRelative8 = function formatRelative9(token, _date, _baseDate, _options) {
      return formatRelativeLocale4[token];
    };
    formatRelative_default4 = formatRelative8;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/_lib/localize/index.js
var eraValues4, quarterValues4, monthValues4, dayValues4, dayPeriodValues4, formattingDayPeriodValues4, ordinalNumber7, localize4, localize_default4;
var init_localize4 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues4 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues4 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues4 = {
      narrow: ["\u062C", "\u0641", "\u0645", "\u0623", "\u0645", "\u062C", "\u062C", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
      abbreviated: ["\u062C\u0627\u0646\u0640", "\u0641\u064A\u0641\u0640", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A\u0640", "\u062C\u0648\u0627\u0646\u0640", "\u062C\u0648\u064A\u0640", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0641\u0640", "\u062F\u064A\u0633\u0640"],
      wide: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
    };
    dayValues4 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues4 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      }
    };
    formattingDayPeriodValues4 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber7 = function ordinalNumber8(dirtyNumber) {
      return String(dirtyNumber);
    };
    localize4 = {
      ordinalNumber: ordinalNumber7,
      era: buildLocalizeFn({
        values: eraValues4,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues4,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback4(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues4,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues4,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues4,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues4,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default4 = localize4;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/_lib/match/index.js
var matchOrdinalNumberPattern4, parseOrdinalNumberPattern4, matchEraPatterns4, parseEraPatterns4, matchQuarterPatterns4, parseQuarterPatterns4, matchMonthPatterns4, parseMonthPatterns4, matchDayPatterns4, parseDayPatterns4, matchDayPeriodPatterns4, parseDayPeriodPatterns4, match4, match_default4;
var init_match4 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern4 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern4 = /\d+/i;
    matchEraPatterns4 = {
      narrow: /^(ق|ب)/i,
      abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
      wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
    };
    parseEraPatterns4 = {
      any: [/^قبل/i, /^بعد/i]
    };
    matchQuarterPatterns4 = {
      narrow: /^[1234]/i,
      abbreviated: /^ر[1234]/i,
      wide: /^الربع [1234]/i
    };
    parseQuarterPatterns4 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns4 = {
      narrow: /^[جفمأسند]/i,
      abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
      wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
    };
    parseMonthPatterns4 = {
      narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
      any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
    };
    matchDayPatterns4 = {
      narrow: /^[حنثرخجس]/i,
      short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
      wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
    };
    parseDayPatterns4 = {
      narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
      wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
      any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
    };
    matchDayPeriodPatterns4 = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    parseDayPeriodPatterns4 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    match4 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern4,
        parsePattern: parseOrdinalNumberPattern4,
        valueCallback: function valueCallback7(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns4,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns4,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns4,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns4,
        defaultParseWidth: "any",
        valueCallback: function valueCallback8(index) {
          return Number(index) + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns4,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns4,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns4,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns4,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns4,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns4,
        defaultParseWidth: "any"
      })
    };
    match_default4 = match4;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-DZ/index.js
var locale4, ar_DZ_default;
var init_ar_DZ = __esm({
  "../../node_modules/date-fns/esm/locale/ar-DZ/index.js"() {
    "use strict";
    init_formatDistance5();
    init_formatLong4();
    init_formatRelative5();
    init_localize4();
    init_match4();
    locale4 = {
      code: "ar-DZ",
      formatDistance: formatDistance_default4,
      formatLong: formatLong_default4,
      formatRelative: formatRelative_default4,
      localize: localize_default4,
      match: match_default4,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ar_DZ_default = locale4;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatDistance/index.js
var formatDistanceLocale5, formatDistance10, formatDistance_default5;
var init_formatDistance6 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale5 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
      },
      xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
      },
      aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
      },
      xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
      },
      aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
      },
      xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
      },
      almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
      }
    };
    formatDistance10 = function formatDistance11(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale5[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2) {
        result = tokenValue.two;
      } else if (count <= 10) {
        result = tokenValue.threeToTen.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        } else {
          return "\u0645\u0646\u0630 ".concat(result);
        }
      }
      return result;
    };
    formatDistance_default5 = formatDistance10;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatLong/index.js
var dateFormats5, timeFormats5, dateTimeFormats5, formatLong5, formatLong_default5;
var init_formatLong5 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats5 = {
      full: "EEEE\u060C do MMMM y",
      long: "do MMMM y",
      medium: "dd/MMM/y",
      short: "d/MM/y"
    };
    timeFormats5 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats5 = {
      full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
      long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong5 = {
      date: buildFormatLongFn({
        formats: dateFormats5,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats5,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats5,
        defaultWidth: "full"
      })
    };
    formatLong_default5 = formatLong5;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatRelative/index.js
var formatRelativeLocale5, formatRelative10, formatRelative_default5;
var init_formatRelative6 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale5 = {
      lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
      yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
      today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
      tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
      nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
      other: "P"
    };
    formatRelative10 = function formatRelative11(token, _date, _baseDate, _options) {
      return formatRelativeLocale5[token];
    };
    formatRelative_default5 = formatRelative10;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/_lib/localize/index.js
var eraValues5, quarterValues5, monthValues5, dayValues5, dayPeriodValues5, formattingDayPeriodValues5, ordinalNumber9, localize5, localize_default5;
var init_localize5 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues5 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645", "\u0628.\u0645"],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues5 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues5 = {
      narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
      abbreviated: ["\u064A\u0646\u0627", "\u0641\u0628\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u0640", "\u064A\u0648\u0644\u0640", "\u0623\u063A\u0633\u0640", "\u0633\u0628\u062A\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0641\u0640", "\u062F\u064A\u0633\u0640"],
      wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648", "\u0623\u063A\u0633\u0637\u0633", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
    };
    dayValues5 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues5 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      }
    };
    formattingDayPeriodValues5 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber9 = function ordinalNumber10(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize5 = {
      ordinalNumber: ordinalNumber9,
      era: buildLocalizeFn({
        values: eraValues5,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues5,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback5(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues5,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues5,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues5,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues5,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default5 = localize5;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/_lib/match/index.js
var matchOrdinalNumberPattern5, parseOrdinalNumberPattern5, matchEraPatterns5, parseEraPatterns5, matchQuarterPatterns5, parseQuarterPatterns5, matchMonthPatterns5, parseMonthPatterns5, matchDayPatterns5, parseDayPatterns5, matchDayPeriodPatterns5, parseDayPeriodPatterns5, match5, match_default5;
var init_match5 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern5 = /^(\d+)/;
    parseOrdinalNumberPattern5 = /\d+/i;
    matchEraPatterns5 = {
      narrow: /^(ق|ب)/g,
      abbreviated: /^(ق.م|ب.م)/g,
      wide: /^(قبل الميلاد|بعد الميلاد)/g
    };
    parseEraPatterns5 = {
      any: [/^ق/g, /^ب/g]
    };
    matchQuarterPatterns5 = {
      narrow: /^[1234]/,
      abbreviated: /^ر[1234]/,
      wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
    };
    parseQuarterPatterns5 = {
      wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
      any: [/1/, /2/, /3/, /4/]
    };
    matchMonthPatterns5 = {
      narrow: /^(ي|ف|م|أ|س|ن|د)/,
      abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
      wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
    };
    parseMonthPatterns5 = {
      narrow: [/^ي/, /^ف/, /^م/, /^أ/, /^م/, /^ي/, /^ي/, /^أ/, /^س/, /^أ/, /^ن/, /^د/],
      any: [/^ينا/, /^فبر/, /^مارس/, /^أبريل/, /^مايو/, /^يون/, /^يول/, /^أغس/, /^سبت/, /^أكت/, /^نوف/, /^ديس/]
    };
    matchDayPatterns5 = {
      narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
      short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
      abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
      wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
    };
    parseDayPatterns5 = {
      narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
      any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
    };
    matchDayPeriodPatterns5 = {
      narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
      abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
      wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
      any: /^(ص|م|صباح|ظهر|مساء|ليل)/
    };
    parseDayPeriodPatterns5 = {
      any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
      }
    };
    match5 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern5,
        parsePattern: parseOrdinalNumberPattern5,
        valueCallback: function valueCallback9(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns5,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns5,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns5,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns5,
        defaultParseWidth: "any",
        valueCallback: function valueCallback10(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns5,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns5,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns5,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns5,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns5,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns5,
        defaultParseWidth: "any"
      })
    };
    match_default5 = match5;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-EG/index.js
var locale5, ar_EG_default;
var init_ar_EG = __esm({
  "../../node_modules/date-fns/esm/locale/ar-EG/index.js"() {
    "use strict";
    init_formatDistance6();
    init_formatLong5();
    init_formatRelative6();
    init_localize5();
    init_match5();
    locale5 = {
      code: "ar-EG",
      formatDistance: formatDistance_default5,
      formatLong: formatLong_default5,
      formatRelative: formatRelative_default5,
      localize: localize_default5,
      match: match_default5,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ar_EG_default = locale5;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatDistance/index.js
var formatDistanceLocale6, formatDistance12, formatDistance_default6;
var init_formatDistance7 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale6 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
      },
      aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
      },
      aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
      },
      almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      }
    };
    formatDistance12 = function formatDistance13(token, count, options) {
      options = options || {};
      var usageGroup = formatDistanceLocale6[token];
      var result;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else if (count === 2) {
        result = usageGroup.two;
      } else if (count <= 10) {
        result = usageGroup.threeToTen.replace("{{count}}", String(count));
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        } else {
          return "\u0645\u0646\u0630 " + result;
        }
      }
      return result;
    };
    formatDistance_default6 = formatDistance12;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatLong/index.js
var dateFormats6, timeFormats6, dateTimeFormats6, formatLong6, formatLong_default6;
var init_formatLong6 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats6 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats6 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats6 = {
      full: "{{date}} '\u0639\u0646\u062F' {{time}}",
      long: "{{date}} '\u0639\u0646\u062F' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong6 = {
      date: buildFormatLongFn({
        formats: dateFormats6,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats6,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats6,
        defaultWidth: "full"
      })
    };
    formatLong_default6 = formatLong6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatRelative/index.js
var formatRelativeLocale6, formatRelative12, formatRelative_default6;
var init_formatRelative7 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale6 = {
      lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
      yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
      today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
      tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
      nextWeek: "eeee '\u0639\u0646\u062F' p",
      other: "P"
    };
    formatRelative12 = function formatRelative13(token, _date, _baseDate, _options) {
      return formatRelativeLocale6[token];
    };
    formatRelative_default6 = formatRelative12;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/_lib/localize/index.js
var eraValues6, quarterValues6, monthValues6, dayValues6, dayPeriodValues6, formattingDayPeriodValues6, ordinalNumber11, localize6, localize_default6;
var init_localize6 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues6 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues6 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues6 = {
      narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u063A", "\u0634", "\u0623", "\u0646", "\u062F"],
      abbreviated: ["\u064A\u0646\u0627", "\u0641\u0628\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u064A\u0648\u0646\u0640", "\u064A\u0648\u0644\u0640", "\u063A\u0634\u062A", "\u0634\u062A\u0646\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0646\u0640", "\u062F\u062C\u0646\u0640"],
      wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648\u0632", "\u063A\u0634\u062A", "\u0634\u062A\u0646\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0646\u0628\u0631", "\u062F\u062C\u0646\u0628\u0631"]
    };
    dayValues6 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0625\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues6 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      }
    };
    formattingDayPeriodValues6 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber11 = function ordinalNumber12(dirtyNumber) {
      return String(dirtyNumber);
    };
    localize6 = {
      ordinalNumber: ordinalNumber11,
      era: buildLocalizeFn({
        values: eraValues6,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues6,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback6(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues6,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues6,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues6,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues6,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default6 = localize6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/_lib/match/index.js
var matchOrdinalNumberPattern6, parseOrdinalNumberPattern6, matchEraPatterns6, parseEraPatterns6, matchQuarterPatterns6, parseQuarterPatterns6, matchMonthPatterns6, parseMonthPatterns6, matchDayPatterns6, parseDayPatterns6, matchDayPeriodPatterns6, parseDayPeriodPatterns6, match6, match_default6;
var init_match6 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern6 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern6 = /\d+/i;
    matchEraPatterns6 = {
      narrow: /^(ق|ب)/i,
      abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
      wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
    };
    parseEraPatterns6 = {
      any: [/^قبل/i, /^بعد/i]
    };
    matchQuarterPatterns6 = {
      narrow: /^[1234]/i,
      abbreviated: /^ر[1234]/i,
      wide: /^الربع [1234]/i
    };
    parseQuarterPatterns6 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns6 = {
      narrow: /^[يفمأمسند]/i,
      abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
      wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
    };
    parseMonthPatterns6 = {
      narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
      any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
    };
    matchDayPatterns6 = {
      narrow: /^[حنثرخجس]/i,
      short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
      wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
    };
    parseDayPatterns6 = {
      narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
      wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
      any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
    };
    matchDayPeriodPatterns6 = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    parseDayPeriodPatterns6 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    match6 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern6,
        parsePattern: parseOrdinalNumberPattern6,
        valueCallback: function valueCallback11(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns6,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns6,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns6,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns6,
        defaultParseWidth: "any",
        valueCallback: function valueCallback12(index) {
          return Number(index) + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns6,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns6,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns6,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns6,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns6,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns6,
        defaultParseWidth: "any"
      })
    };
    match_default6 = match6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-MA/index.js
var locale6, ar_MA_default;
var init_ar_MA = __esm({
  "../../node_modules/date-fns/esm/locale/ar-MA/index.js"() {
    "use strict";
    init_formatDistance7();
    init_formatLong6();
    init_formatRelative7();
    init_localize6();
    init_match6();
    locale6 = {
      code: "ar-MA",
      formatDistance: formatDistance_default6,
      formatLong: formatLong_default6,
      formatRelative: formatRelative_default6,
      localize: localize_default6,
      match: match_default6,
      options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ar_MA_default = locale6;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatDistance/index.js
var formatDistanceLocale7, formatDistance14, formatDistance_default7;
var init_formatDistance8 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale7 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
      },
      aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
      },
      aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      },
      xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
      },
      almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
      }
    };
    formatDistance14 = function formatDistance15(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale7[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2) {
        result = tokenValue.two;
      } else if (count <= 10) {
        result = tokenValue.threeToTen.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        } else {
          return "\u0645\u0646\u0630 " + result;
        }
      }
      return result;
    };
    formatDistance_default7 = formatDistance14;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatLong/index.js
var dateFormats7, timeFormats7, dateTimeFormats7, formatLong7, formatLong_default7;
var init_formatLong7 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats7 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats7 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats7 = {
      full: "{{date}} '\u0639\u0646\u062F' {{time}}",
      long: "{{date}} '\u0639\u0646\u062F' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong7 = {
      date: buildFormatLongFn({
        formats: dateFormats7,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats7,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats7,
        defaultWidth: "full"
      })
    };
    formatLong_default7 = formatLong7;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatRelative/index.js
var formatRelativeLocale7, formatRelative14, formatRelative_default7;
var init_formatRelative8 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale7 = {
      lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
      yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
      today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
      tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
      nextWeek: "eeee '\u0639\u0646\u062F' p",
      other: "P"
    };
    formatRelative14 = function formatRelative15(token, _date, _baseDate, _options) {
      return formatRelativeLocale7[token];
    };
    formatRelative_default7 = formatRelative14;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/_lib/localize/index.js
var eraValues7, quarterValues7, monthValues7, dayValues7, dayPeriodValues7, formattingDayPeriodValues7, ordinalNumber13, localize7, localize_default7;
var init_localize7 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues7 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues7 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues7 = {
      narrow: ["\u064A", "\u0641", "\u0645", "\u0623", "\u0645", "\u064A", "\u064A", "\u0623", "\u0633", "\u0623", "\u0646", "\u062F"],
      abbreviated: ["\u064A\u0646\u0627", "\u0641\u0628\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u0640", "\u064A\u0648\u0644\u0640", "\u0623\u063A\u0633\u0640", "\u0633\u0628\u062A\u0640", "\u0623\u0643\u062A\u0640", "\u0646\u0648\u0641\u0640", "\u062F\u064A\u0633\u0640"],
      wide: ["\u064A\u0646\u0627\u064A\u0631", "\u0641\u0628\u0631\u0627\u064A\u0631", "\u0645\u0627\u0631\u0633", "\u0623\u0628\u0631\u064A\u0644", "\u0645\u0627\u064A\u0648", "\u064A\u0648\u0646\u064A\u0648", "\u064A\u0648\u0644\u064A\u0648", "\u0623\u063A\u0633\u0637\u0633", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
    };
    dayValues7 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u0640", "\u062B\u0644\u0627", "\u0623\u0631\u0628\u0640", "\u062E\u0645\u064A\u0640", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues7 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
      }
    };
    formattingDayPeriodValues7 = {
      narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber13 = function ordinalNumber14(dirtyNumber) {
      return String(dirtyNumber);
    };
    localize7 = {
      ordinalNumber: ordinalNumber13,
      era: buildLocalizeFn({
        values: eraValues7,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues7,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback7(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues7,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues7,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues7,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues7,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default7 = localize7;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/_lib/match/index.js
var matchOrdinalNumberPattern7, parseOrdinalNumberPattern7, matchEraPatterns7, parseEraPatterns7, matchQuarterPatterns7, parseQuarterPatterns7, matchMonthPatterns7, parseMonthPatterns7, matchDayPatterns7, parseDayPatterns7, matchDayPeriodPatterns7, parseDayPeriodPatterns7, match7, match_default7;
var init_match7 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern7 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern7 = /\d+/i;
    matchEraPatterns7 = {
      narrow: /^(ق|ب)/i,
      abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
      wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
    };
    parseEraPatterns7 = {
      any: [/^قبل/i, /^بعد/i]
    };
    matchQuarterPatterns7 = {
      narrow: /^[1234]/i,
      abbreviated: /^ر[1234]/i,
      wide: /^الربع [1234]/i
    };
    parseQuarterPatterns7 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns7 = {
      narrow: /^[يفمأمسند]/i,
      abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
      wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
    };
    parseMonthPatterns7 = {
      narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
      any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
    };
    matchDayPatterns7 = {
      narrow: /^[حنثرخجس]/i,
      short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
      wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
    };
    parseDayPatterns7 = {
      narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
      wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
      any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
    };
    matchDayPeriodPatterns7 = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    parseDayPeriodPatterns7 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    };
    match7 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern7,
        parsePattern: parseOrdinalNumberPattern7,
        valueCallback: function valueCallback13(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns7,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns7,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns7,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns7,
        defaultParseWidth: "any",
        valueCallback: function valueCallback14(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns7,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns7,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns7,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns7,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns7,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns7,
        defaultParseWidth: "any"
      })
    };
    match_default7 = match7;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-SA/index.js
var locale7, ar_SA_default;
var init_ar_SA = __esm({
  "../../node_modules/date-fns/esm/locale/ar-SA/index.js"() {
    "use strict";
    init_formatDistance8();
    init_formatLong7();
    init_formatRelative8();
    init_localize7();
    init_match7();
    locale7 = {
      code: "ar-SA",
      formatDistance: formatDistance_default7,
      formatLong: formatLong_default7,
      formatRelative: formatRelative_default7,
      localize: localize_default7,
      match: match_default7,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ar_SA_default = locale7;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatDistance/index.js
var formatDistanceLocale8, formatDistance16, formatDistance_default8;
var init_formatDistance9 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale8 = {
      lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
      },
      halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
      lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
      },
      aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
      },
      xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
      },
      xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
      },
      aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
      },
      xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
      },
      aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
      },
      xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
      },
      aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
      },
      xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
      },
      overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
      },
      almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
      }
    };
    formatDistance16 = function formatDistance17(token, count, options) {
      var usageGroup = formatDistanceLocale8[token];
      var result;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else if (count === 2) {
        result = usageGroup.two;
      } else if (count <= 10) {
        result = usageGroup.threeToTen.replace("{{count}}", String(count));
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0641\u064A " + result;
        } else {
          return "\u0639\u0646\u062F\u0648 " + result;
        }
      }
      return result;
    };
    formatDistance_default8 = formatDistance16;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatLong/index.js
var dateFormats8, timeFormats8, dateTimeFormats8, formatLong8, formatLong_default8;
var init_formatLong8 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats8 = {
      full: "EEEE\u060C do MMMM y",
      long: "do MMMM y",
      medium: "d MMM y",
      short: "dd/MM/yyyy"
    };
    timeFormats8 = {
      full: "HH:mm:ss",
      long: "HH:mm:ss",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats8 = {
      full: "{{date}} '\u0645\u0639' {{time}}",
      long: "{{date}} '\u0645\u0639' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong8 = {
      date: buildFormatLongFn({
        formats: dateFormats8,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats8,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats8,
        defaultWidth: "full"
      })
    };
    formatLong_default8 = formatLong8;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatRelative/index.js
var formatRelativeLocale8, formatRelative16, formatRelative_default8;
var init_formatRelative9 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale8 = {
      lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
      yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
      today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
      tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
      nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
      other: "P"
    };
    formatRelative16 = function formatRelative17(token) {
      return formatRelativeLocale8[token];
    };
    formatRelative_default8 = formatRelative16;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/_lib/localize/index.js
var eraValues8, quarterValues8, monthValues8, dayValues8, dayPeriodValues8, formattingDayPeriodValues8, ordinalNumber15, localize8, localize_default8;
var init_localize8 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues8 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"]
    };
    quarterValues8 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u06311", "\u06312", "\u06313", "\u06314"],
      wide: ["\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B", "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"]
    };
    monthValues8 = {
      narrow: ["\u062F", "\u0646", "\u0623", "\u0633", "\u0623", "\u062C", "\u062C", "\u0645", "\u0623", "\u0645", "\u0641", "\u062C"],
      abbreviated: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"],
      wide: ["\u062C\u0627\u0646\u0641\u064A", "\u0641\u064A\u0641\u0631\u064A", "\u0645\u0627\u0631\u0633", "\u0623\u0641\u0631\u064A\u0644", "\u0645\u0627\u064A", "\u062C\u0648\u0627\u0646", "\u062C\u0648\u064A\u0644\u064A\u0629", "\u0623\u0648\u062A", "\u0633\u0628\u062A\u0645\u0628\u0631", "\u0623\u0643\u062A\u0648\u0628\u0631", "\u0646\u0648\u0641\u0645\u0628\u0631", "\u062F\u064A\u0633\u0645\u0628\u0631"]
    };
    dayValues8 = {
      narrow: ["\u062D", "\u0646", "\u062B", "\u0631", "\u062E", "\u062C", "\u0633"],
      short: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      abbreviated: ["\u0623\u062D\u062F", "\u0627\u062B\u0646\u064A\u0646", "\u062B\u0644\u0627\u062B\u0627\u0621", "\u0623\u0631\u0628\u0639\u0627\u0621", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639\u0629", "\u0633\u0628\u062A"],
      wide: ["\u0627\u0644\u0623\u062D\u062F", "\u0627\u0644\u0627\u062B\u0646\u064A\u0646", "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621", "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621", "\u0627\u0644\u062E\u0645\u064A\u0633", "\u0627\u0644\u062C\u0645\u0639\u0629", "\u0627\u0644\u0633\u0628\u062A"]
    };
    dayPeriodValues8 = {
      narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      }
    };
    formattingDayPeriodValues8 = {
      narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      },
      abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      },
      wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
      }
    };
    ordinalNumber15 = function ordinalNumber16(num) {
      return String(num);
    };
    localize8 = {
      ordinalNumber: ordinalNumber15,
      era: buildLocalizeFn({
        values: eraValues8,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues8,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback8(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues8,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues8,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues8,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues8,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default8 = localize8;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/_lib/match/index.js
var matchOrdinalNumberPattern8, parseOrdinalNumberPattern8, matchEraPatterns8, parseEraPatterns8, matchQuarterPatterns8, parseQuarterPatterns8, matchMonthPatterns8, parseMonthPatterns8, matchDayPatterns8, parseDayPatterns8, matchDayPeriodPatterns8, parseDayPeriodPatterns8, match8, match_default8;
var init_match8 = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern8 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern8 = /\d+/i;
    matchEraPatterns8 = {
      narrow: /[قب]/,
      abbreviated: /[قب]\.م\./,
      wide: /(قبل|بعد) الميلاد/
    };
    parseEraPatterns8 = {
      any: [/قبل/, /بعد/]
    };
    matchQuarterPatterns8 = {
      narrow: /^[1234]/i,
      abbreviated: /ر[1234]/,
      wide: /الربع (الأول|الثاني|الثالث|الرابع)/
    };
    parseQuarterPatterns8 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns8 = {
      narrow: /^[جفمأسند]/,
      abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
      wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
    };
    parseMonthPatterns8 = {
      narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
      any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
    };
    matchDayPatterns8 = {
      narrow: /^[حنثرخجس]/i,
      short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
      wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
    };
    parseDayPatterns8 = {
      narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
      wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
      any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
    };
    matchDayPeriodPatterns8 = {
      narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
      any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
    };
    parseDayPeriodPatterns8 = {
      any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
      }
    };
    match8 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern8,
        parsePattern: parseOrdinalNumberPattern8,
        valueCallback: function valueCallback15(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns8,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns8,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns8,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns8,
        defaultParseWidth: "any",
        valueCallback: function valueCallback16(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns8,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns8,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns8,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns8,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns8,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns8,
        defaultParseWidth: "any"
      })
    };
    match_default8 = match8;
  }
});

// ../../node_modules/date-fns/esm/locale/ar-TN/index.js
var locale8, ar_TN_default;
var init_ar_TN = __esm({
  "../../node_modules/date-fns/esm/locale/ar-TN/index.js"() {
    "use strict";
    init_formatDistance9();
    init_formatLong8();
    init_formatRelative9();
    init_localize8();
    init_match8();
    locale8 = {
      code: "ar-TN",
      formatDistance: formatDistance_default8,
      formatLong: formatLong_default8,
      formatRelative: formatRelative_default8,
      localize: localize_default8,
      match: match_default8,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ar_TN_default = locale8;
  }
});

// ../../node_modules/date-fns/esm/locale/az/_lib/formatDistance/index.js
var formatDistanceLocale9, formatDistance18, formatDistance_default9;
var init_formatDistance10 = __esm({
  "../../node_modules/date-fns/esm/locale/az/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale9 = {
      lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
      },
      xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
      },
      halfAMinute: "yar\u0131m d\u0259qiq\u0259",
      lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
      },
      xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
      },
      aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
      },
      xHours: {
        one: "1 saat",
        other: "{{count}} saat"
      },
      xDays: {
        one: "1 g\xFCn",
        other: "{{count}} g\xFCn"
      },
      aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
      },
      xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
      },
      aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
      },
      xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
      },
      aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
      },
      xYears: {
        one: "1 il",
        other: "{{count}} il"
      },
      overXYears: {
        one: "1 ild\u0259n \xE7ox",
        other: "{{count}} ild\u0259n \xE7ox"
      },
      almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
      }
    };
    formatDistance18 = function formatDistance19(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale9[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " sonra";
        } else {
          return result + " \u0259vv\u0259l";
        }
      }
      return result;
    };
    formatDistance_default9 = formatDistance18;
  }
});

// ../../node_modules/date-fns/esm/locale/az/_lib/formatLong/index.js
var dateFormats9, timeFormats9, dateTimeFormats9, formatLong9, formatLong_default9;
var init_formatLong9 = __esm({
  "../../node_modules/date-fns/esm/locale/az/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats9 = {
      full: "EEEE, do MMMM y 'il'",
      long: "do MMMM y 'il'",
      medium: "d MMM y 'il'",
      short: "dd.MM.yyyy"
    };
    timeFormats9 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats9 = {
      full: "{{date}} {{time}} - 'd\u0259'",
      long: "{{date}} {{time}} - 'd\u0259'",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong9 = {
      date: buildFormatLongFn({
        formats: dateFormats9,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats9,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats9,
        defaultWidth: "full"
      })
    };
    formatLong_default9 = formatLong9;
  }
});

// ../../node_modules/date-fns/esm/locale/az/_lib/formatRelative/index.js
var formatRelativeLocale9, formatRelative18, formatRelative_default9;
var init_formatRelative10 = __esm({
  "../../node_modules/date-fns/esm/locale/az/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale9 = {
      lastWeek: "'sonuncu' eeee p -'d\u0259'",
      yesterday: "'d\xFCn\u0259n' p -'d\u0259'",
      today: "'bug\xFCn' p -'d\u0259'",
      tomorrow: "'sabah' p -'d\u0259'",
      nextWeek: "eeee p -'d\u0259'",
      other: "P"
    };
    formatRelative18 = function formatRelative19(token, _date, _baseDate, _options) {
      return formatRelativeLocale9[token];
    };
    formatRelative_default9 = formatRelative18;
  }
});

// ../../node_modules/date-fns/esm/locale/az/_lib/localize/index.js
var eraValues9, quarterValues9, monthValues9, dayValues9, dayPeriodValues9, formattingDayPeriodValues9, suffixes, getSuffix, ordinalNumber17, localize9, localize_default9;
var init_localize9 = __esm({
  "../../node_modules/date-fns/esm/locale/az/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues9 = {
      narrow: ["e.\u0259", "b.e"],
      abbreviated: ["e.\u0259", "b.e"],
      wide: ["eram\u0131zdan \u0259vv\u0259l", "bizim era"]
    };
    quarterValues9 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1ci kvartal", "2ci kvartal", "3c\xFC kvartal", "4c\xFC kvartal"]
    };
    monthValues9 = {
      narrow: ["Y", "F", "M", "A", "M", "\u0130", "\u0130", "A", "S", "O", "N", "D"],
      abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "\u0130yun", "\u0130yul", "Avq", "Sen", "Okt", "Noy", "Dek"],
      wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "\u0130yun", "\u0130yul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"]
    };
    dayValues9 = {
      narrow: ["B.", "B.e", "\xC7.a", "\xC7.", "C.a", "C.", "\u015E."],
      short: ["B.", "B.e", "\xC7.a", "\xC7.", "C.a", "C.", "\u015E."],
      abbreviated: ["Baz", "Baz.e", "\xC7\u0259r.a", "\xC7\u0259r", "C\xFCm.a", "C\xFCm", "\u015E\u0259"],
      wide: ["Bazar", "Bazar ert\u0259si", "\xC7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131", "\xC7\u0259r\u015F\u0259nb\u0259", "C\xFCm\u0259 ax\u015Fam\u0131", "C\xFCm\u0259", "\u015E\u0259nb\u0259"]
    };
    dayPeriodValues9 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      }
    };
    formattingDayPeriodValues9 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xFCn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xFCnd\xFCz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
      }
    };
    suffixes = {
      1: "-inci",
      5: "-inci",
      8: "-inci",
      70: "-inci",
      80: "-inci",
      2: "-nci",
      7: "-nci",
      20: "-nci",
      50: "-nci",
      3: "-\xFCnc\xFC",
      4: "-\xFCnc\xFC",
      100: "-\xFCnc\xFC",
      6: "-nc\u0131",
      9: "-uncu",
      10: "-uncu",
      30: "-uncu",
      60: "-\u0131nc\u0131",
      90: "-\u0131nc\u0131"
    };
    getSuffix = function getSuffix2(number) {
      if (number === 0) {
        return number + "-\u0131nc\u0131";
      }
      var a3 = number % 10;
      var b2 = number % 100 - a3;
      var c2 = number >= 100 ? 100 : null;
      if (suffixes[a3]) {
        return suffixes[a3];
      } else if (suffixes[b2]) {
        return suffixes[b2];
      } else if (c2 !== null) {
        return suffixes[c2];
      }
      return "";
    };
    ordinalNumber17 = function ordinalNumber18(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var suffix = getSuffix(number);
      return number + suffix;
    };
    localize9 = {
      ordinalNumber: ordinalNumber17,
      era: buildLocalizeFn({
        values: eraValues9,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues9,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback9(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues9,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues9,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues9,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues9,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default9 = localize9;
  }
});

// ../../node_modules/date-fns/esm/locale/az/_lib/match/index.js
var matchOrdinalNumberPattern9, parseOrdinalNumberPattern9, matchEraPatterns9, parseEraPatterns9, matchQuarterPatterns9, parseQuarterPatterns9, matchMonthPatterns9, parseMonthPatterns9, matchDayPatterns9, parseDayPatterns9, matchDayPeriodPatterns9, parseDayPeriodPatterns9, match9, match_default9;
var init_match9 = __esm({
  "../../node_modules/date-fns/esm/locale/az/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern9 = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
    parseOrdinalNumberPattern9 = /\d+/i;
    matchEraPatterns9 = {
      narrow: /^(b|a)$/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
      wide: /^(bizim eradan əvvəl|bizim era)$/i
    };
    parseEraPatterns9 = {
      any: [/^b$/i, /^(a|c)$/i]
    };
    matchQuarterPatterns9 = {
      narrow: /^[1234]$/i,
      abbreviated: /^K[1234]$/i,
      wide: /^[1234](ci)? kvartal$/i
    };
    parseQuarterPatterns9 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns9 = {
      narrow: /^[(?-i)yfmaisond]$/i,
      abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
      wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
    };
    parseMonthPatterns9 = {
      narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
      abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
      wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
    };
    matchDayPatterns9 = {
      narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
      short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
      abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
      wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
    };
    parseDayPatterns9 = {
      narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
      abbreviated: [/^Baz$/i, /^Baz\.e$/i, /^Çər\.a$/i, /^Çər$/i, /^Cüm\.a$/i, /^Cüm$/i, /^Şə$/i],
      wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
      any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
    };
    matchDayPeriodPatterns9 = {
      narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
      any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
    };
    parseDayPeriodPatterns9 = {
      any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
      }
    };
    match9 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern9,
        parsePattern: parseOrdinalNumberPattern9,
        valueCallback: function valueCallback17(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns9,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns9,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns9,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns9,
        defaultParseWidth: "any",
        valueCallback: function valueCallback18(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns9,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns9,
        defaultParseWidth: "narrow"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns9,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns9,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns9,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns9,
        defaultParseWidth: "any"
      })
    };
    match_default9 = match9;
  }
});

// ../../node_modules/date-fns/esm/locale/az/index.js
var locale9, az_default;
var init_az = __esm({
  "../../node_modules/date-fns/esm/locale/az/index.js"() {
    "use strict";
    init_formatDistance10();
    init_formatLong9();
    init_formatRelative10();
    init_localize9();
    init_match9();
    locale9 = {
      code: "az",
      formatDistance: formatDistance_default9,
      formatLong: formatLong_default9,
      formatRelative: formatRelative_default9,
      localize: localize_default9,
      match: match_default9,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    az_default = locale9;
  }
});

// ../../node_modules/date-fns/esm/locale/be/_lib/formatDistance/index.js
function declension(scheme, count) {
  if (scheme.one !== void 0 && count === 1) {
    return scheme.one;
  }
  var rem10 = count % 10;
  var rem100 = count % 100;
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}
function buildLocalizeTokenFn(scheme) {
  return function(count, options) {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}
var halfAMinute, formatDistanceLocale10, formatDistance20, formatDistance_default10;
var init_formatDistance11 = __esm({
  "../../node_modules/date-fns/esm/locale/be/_lib/formatDistance/index.js"() {
    "use strict";
    halfAMinute = function halfAMinute2(_, options) {
      if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        } else {
          return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
        }
      }
      return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
    };
    formatDistanceLocale10 = {
      lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
          one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      xSeconds: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      halfAMinute,
      lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
          one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
      }),
      xMinutes: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
          singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
          singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
      }),
      aboutXHours: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
      }),
      xHours: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
          singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
      }),
      xDays: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
          singularGenitive: "{{count}} \u0434\u043D\u0456",
          pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
      }),
      aboutXWeeks: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          // TODO
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
          // TODO
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          // TODO
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
          // TODO
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          // TODO
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          // TODO
        }
      }),
      xWeeks: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      aboutXMonths: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      xMonths: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      aboutXYears: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      xYears: buildLocalizeTokenFn({
        regular: {
          singularNominative: "{{count}} \u0433\u043E\u0434",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      overXYears: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      almostXYears: buildLocalizeTokenFn({
        regular: {
          singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      })
    };
    formatDistance20 = function formatDistance21(token, count, options) {
      options = options || {};
      return formatDistanceLocale10[token](count, options);
    };
    formatDistance_default10 = formatDistance20;
  }
});

// ../../node_modules/date-fns/esm/locale/be/_lib/formatLong/index.js
var dateFormats10, timeFormats10, dateTimeFormats10, formatLong10, formatLong_default10;
var init_formatLong10 = __esm({
  "../../node_modules/date-fns/esm/locale/be/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats10 = {
      full: "EEEE, d MMMM y '\u0433.'",
      long: "d MMMM y '\u0433.'",
      medium: "d MMM y '\u0433.'",
      short: "dd.MM.y"
    };
    timeFormats10 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats10 = {
      any: "{{date}}, {{time}}"
    };
    formatLong10 = {
      date: buildFormatLongFn({
        formats: dateFormats10,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats10,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats10,
        defaultWidth: "any"
      })
    };
    formatLong_default10 = formatLong10;
  }
});

// ../../node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}
var init_isSameUTCWeek = __esm({
  "../../node_modules/date-fns/esm/_lib/isSameUTCWeek/index.js"() {
    "use strict";
    init_requiredArgs();
    init_startOfUTCWeek();
  }
});

// ../../node_modules/date-fns/esm/locale/be/_lib/formatRelative/index.js
function lastWeek(day) {
  var weekday = accusativeWeekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
  }
}
function thisWeek(day) {
  var weekday = accusativeWeekdays[day];
  return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
  var weekday = accusativeWeekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
  }
}
var accusativeWeekdays, lastWeekFormat, nextWeekFormat, formatRelativeLocale10, formatRelative20, formatRelative_default10;
var init_formatRelative11 = __esm({
  "../../node_modules/date-fns/esm/locale/be/_lib/formatRelative/index.js"() {
    "use strict";
    init_esm();
    init_isSameUTCWeek();
    accusativeWeekdays = ["\u043D\u044F\u0434\u0437\u0435\u043B\u044E", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0443", "\u0447\u0430\u0446\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0443", "\u0441\u0443\u0431\u043E\u0442\u0443"];
    lastWeekFormat = function lastWeekFormat2(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek(day);
      } else {
        return lastWeek(day);
      }
    };
    nextWeekFormat = function nextWeekFormat2(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek(day);
      } else {
        return nextWeek(day);
      }
    };
    formatRelativeLocale10 = {
      lastWeek: lastWeekFormat,
      yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
      today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
      tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
      nextWeek: nextWeekFormat,
      other: "P"
    };
    formatRelative20 = function formatRelative21(token, date, baseDate, options) {
      var format2 = formatRelativeLocale10[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default10 = formatRelative20;
  }
});

// ../../node_modules/date-fns/esm/locale/be/_lib/localize/index.js
var eraValues10, quarterValues10, monthValues10, formattingMonthValues, dayValues10, dayPeriodValues10, formattingDayPeriodValues10, ordinalNumber19, localize10, localize_default10;
var init_localize10 = __esm({
  "../../node_modules/date-fns/esm/locale/be/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues10 = {
      narrow: ["\u0434\u0430 \u043D.\u044D.", "\u043D.\u044D."],
      abbreviated: ["\u0434\u0430 \u043D. \u044D.", "\u043D. \u044D."],
      wide: ["\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B", "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"]
    };
    quarterValues10 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u044B \u043A\u0432.", "2-\u0456 \u043A\u0432.", "3-\u0456 \u043A\u0432.", "4-\u044B \u043A\u0432."],
      wide: ["1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues10 = {
      narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u041C", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
      abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u043D\u0435\u0436."],
      wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C", "\u043B\u044E\u0442\u044B", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A", "\u043C\u0430\u0439", "\u0447\u044D\u0440\u0432\u0435\u043D\u044C", "\u043B\u0456\u043F\u0435\u043D\u044C", "\u0436\u043D\u0456\u0432\u0435\u043D\u044C", "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434", "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"]
    };
    formattingMonthValues = {
      narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u041C", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
      abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u043C\u0430\u044F", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u043D\u0435\u0436."],
      wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F", "\u043B\u044E\u0442\u0430\u0433\u0430", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430", "\u043C\u0430\u044F", "\u0447\u044D\u0440\u0432\u0435\u043D\u044F", "\u043B\u0456\u043F\u0435\u043D\u044F", "\u0436\u043D\u0456\u045E\u043D\u044F", "\u0432\u0435\u0440\u0430\u0441\u043D\u044F", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430", "\u0441\u043D\u0435\u0436\u043D\u044F"]
    };
    dayValues10 = {
      narrow: ["\u041D", "\u041F", "\u0410", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0434", "\u043F\u043D", "\u0430\u045E", "\u0441\u0440", "\u0447\u0446", "\u043F\u0442", "\u0441\u0431"],
      abbreviated: ["\u043D\u044F\u0434\u0437", "\u043F\u0430\u043D", "\u0430\u045E\u0442", "\u0441\u0435\u0440", "\u0447\u0430\u0446", "\u043F\u044F\u0442", "\u0441\u0443\u0431"],
      wide: ["\u043D\u044F\u0434\u0437\u0435\u043B\u044F", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0430", "\u0447\u0430\u0446\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0430", "\u0441\u0443\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues10 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
      }
    };
    formattingDayPeriodValues10 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
      }
    };
    ordinalNumber19 = function ordinalNumber20(dirtyNumber, options) {
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      var number = Number(dirtyNumber);
      var suffix;
      if (unit === "date") {
        suffix = "-\u0433\u0430";
      } else if (unit === "hour" || unit === "minute" || unit === "second") {
        suffix = "-\u044F";
      } else {
        suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
      }
      return number + suffix;
    };
    localize10 = {
      ordinalNumber: ordinalNumber19,
      era: buildLocalizeFn({
        values: eraValues10,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues10,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback10(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues10,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues10,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues10,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues10,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default10 = localize10;
  }
});

// ../../node_modules/date-fns/esm/locale/be/_lib/match/index.js
var matchOrdinalNumberPattern10, parseOrdinalNumberPattern10, matchEraPatterns10, parseEraPatterns10, matchQuarterPatterns10, parseQuarterPatterns10, matchMonthPatterns10, parseMonthPatterns10, matchDayPatterns10, parseDayPatterns10, matchDayPeriodPatterns10, parseDayPeriodPatterns10, match10, match_default10;
var init_match10 = __esm({
  "../../node_modules/date-fns/esm/locale/be/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern10 = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
    parseOrdinalNumberPattern10 = /\d+/i;
    matchEraPatterns10 = {
      narrow: /^((да )?н\.?\s?э\.?)/i,
      abbreviated: /^((да )?н\.?\s?э\.?)/i,
      wide: /^(да нашай эры|нашай эры|наша эра)/i
    };
    parseEraPatterns10 = {
      any: [/^д/i, /^н/i]
    };
    matchQuarterPatterns10 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
      wide: /^[1234](-?[ыі]?)? квартал/i
    };
    parseQuarterPatterns10 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns10 = {
      narrow: /^[слкмчжв]/i,
      abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
      wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
    };
    parseMonthPatterns10 = {
      narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
      any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
    };
    matchDayPatterns10 = {
      narrow: /^[нпасч]/i,
      short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
      abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
      wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
    };
    parseDayPatterns10 = {
      narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
    };
    matchDayPeriodPatterns10 = {
      narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
      abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
      wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
    };
    parseDayPeriodPatterns10 = {
      any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
      }
    };
    match10 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern10,
        parsePattern: parseOrdinalNumberPattern10,
        valueCallback: function valueCallback19(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns10,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns10,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns10,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns10,
        defaultParseWidth: "any",
        valueCallback: function valueCallback20(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns10,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns10,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns10,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns10,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns10,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns10,
        defaultParseWidth: "any"
      })
    };
    match_default10 = match10;
  }
});

// ../../node_modules/date-fns/esm/locale/be/index.js
var locale10, be_default;
var init_be = __esm({
  "../../node_modules/date-fns/esm/locale/be/index.js"() {
    "use strict";
    init_formatDistance11();
    init_formatLong10();
    init_formatRelative11();
    init_localize10();
    init_match10();
    locale10 = {
      code: "be",
      formatDistance: formatDistance_default10,
      formatLong: formatLong_default10,
      formatRelative: formatRelative_default10,
      localize: localize_default10,
      match: match_default10,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    be_default = locale10;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatDistance/index.js
function declension2(scheme, count) {
  if (scheme.one !== void 0 && count === 1) {
    return scheme.one;
  }
  var rem10 = count % 10;
  var rem100 = count % 100;
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}
function buildLocalizeTokenFn2(scheme) {
  return function(count, options) {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension2(scheme.future, count);
        } else {
          return "\u043F\u0440\u0430\u0437 " + declension2(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension2(scheme.past, count);
        } else {
          return declension2(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
        }
      }
    } else {
      return declension2(scheme.regular, count);
    }
  };
}
var halfAMinute3, formatDistanceLocale11, formatDistance22, formatDistance_default11;
var init_formatDistance12 = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatDistance/index.js"() {
    "use strict";
    halfAMinute3 = function halfAMinute4(_, options) {
      if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        } else {
          return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
        }
      }
      return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
    };
    formatDistanceLocale11 = {
      lessThanXSeconds: buildLocalizeTokenFn2({
        regular: {
          one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      xSeconds: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      halfAMinute: halfAMinute3,
      lessThanXMinutes: buildLocalizeTokenFn2({
        regular: {
          one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
      }),
      xMinutes: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
          singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
          singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
      }),
      aboutXHours: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
      }),
      xHours: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
          singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
          singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
          singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
          pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
      }),
      xDays: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
          singularGenitive: "{{count}} \u0434\u043D\u0456",
          pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
      }),
      aboutXWeeks: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          // TODO
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
          // TODO
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          // TODO
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
          // TODO
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          // TODO
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
          // TODO
        }
      }),
      xWeeks: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      aboutXMonths: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      xMonths: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
          pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
      }),
      aboutXYears: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
          singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
          pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      xYears: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "{{count}} \u0433\u043E\u0434",
          singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      overXYears: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      }),
      almostXYears: buildLocalizeTokenFn2({
        regular: {
          singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
          singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
          pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
      })
    };
    formatDistance22 = function formatDistance23(token, count, options) {
      options = options || {};
      return formatDistanceLocale11[token](count, options);
    };
    formatDistance_default11 = formatDistance22;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatLong/index.js
var dateFormats11, timeFormats11, dateTimeFormats11, formatLong11, formatLong_default11;
var init_formatLong11 = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats11 = {
      full: "EEEE, d MMMM y '\u0433.'",
      long: "d MMMM y '\u0433.'",
      medium: "d MMM y '\u0433.'",
      short: "dd.MM.y"
    };
    timeFormats11 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats11 = {
      any: "{{date}}, {{time}}"
    };
    formatLong11 = {
      date: buildFormatLongFn({
        formats: dateFormats11,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats11,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats11,
        defaultWidth: "any"
      })
    };
    formatLong_default11 = formatLong11;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatRelative/index.js
function lastWeek2(day) {
  var weekday = accusativeWeekdays2[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
  }
}
function thisWeek2(day) {
  var weekday = accusativeWeekdays2[day];
  return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek2(day) {
  var weekday = accusativeWeekdays2[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
  }
}
var accusativeWeekdays2, lastWeekFormat3, nextWeekFormat3, formatRelativeLocale11, formatRelative22, formatRelative_default11;
var init_formatRelative12 = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/_lib/formatRelative/index.js"() {
    "use strict";
    init_esm();
    init_isSameUTCWeek();
    accusativeWeekdays2 = ["\u043D\u044F\u0434\u0437\u0435\u043B\u044E", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0443", "\u0447\u0430\u0446\u044C\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0443", "\u0441\u0443\u0431\u043E\u0442\u0443"];
    lastWeekFormat3 = function lastWeekFormat4(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek2(day);
      } else {
        return lastWeek2(day);
      }
    };
    nextWeekFormat3 = function nextWeekFormat4(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek2(day);
      } else {
        return nextWeek2(day);
      }
    };
    formatRelativeLocale11 = {
      lastWeek: lastWeekFormat3,
      yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
      today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
      tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
      nextWeek: nextWeekFormat3,
      other: "P"
    };
    formatRelative22 = function formatRelative23(token, date, baseDate, options) {
      var format2 = formatRelativeLocale11[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default11 = formatRelative22;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/_lib/localize/index.js
var eraValues11, quarterValues11, monthValues11, formattingMonthValues2, dayValues11, dayPeriodValues11, formattingDayPeriodValues11, ordinalNumber21, localize11, localize_default11;
var init_localize11 = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues11 = {
      narrow: ["\u0434\u0430 \u043D.\u044D.", "\u043D.\u044D."],
      abbreviated: ["\u0434\u0430 \u043D. \u044D.", "\u043D. \u044D."],
      wide: ["\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B", "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"]
    };
    quarterValues11 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u044B \u043A\u0432.", "2-\u0456 \u043A\u0432.", "3-\u0456 \u043A\u0432.", "4-\u044B \u043A\u0432."],
      wide: ["1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues11 = {
      narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u0422", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
      abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u0442\u0440\u0430\u0432.", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u044C\u043D\u0435\u0436."],
      wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C", "\u043B\u044E\u0442\u044B", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A", "\u0442\u0440\u0430\u0432\u0435\u043D\u044C", "\u0447\u044D\u0440\u0432\u0435\u043D\u044C", "\u043B\u0456\u043F\u0435\u043D\u044C", "\u0436\u043D\u0456\u0432\u0435\u043D\u044C", "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434", "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"]
    };
    formattingMonthValues2 = {
      narrow: ["\u0421", "\u041B", "\u0421", "\u041A", "\u0422", "\u0427", "\u041B", "\u0416", "\u0412", "\u041A", "\u041B", "\u0421"],
      abbreviated: ["\u0441\u0442\u0443\u0434\u0437.", "\u043B\u044E\u0442.", "\u0441\u0430\u043A.", "\u043A\u0440\u0430\u0441.", "\u0442\u0440\u0430\u0432.", "\u0447\u044D\u0440\u0432.", "\u043B\u0456\u043F.", "\u0436\u043D.", "\u0432\u0435\u0440.", "\u043A\u0430\u0441\u0442\u0440.", "\u043B\u0456\u0441\u0442.", "\u0441\u044C\u043D\u0435\u0436."],
      wide: ["\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F", "\u043B\u044E\u0442\u0430\u0433\u0430", "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430", "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430", "\u0442\u0440\u0430\u045E\u043D\u044F", "\u0447\u044D\u0440\u0432\u0435\u043D\u044F", "\u043B\u0456\u043F\u0435\u043D\u044F", "\u0436\u043D\u0456\u045E\u043D\u044F", "\u0432\u0435\u0440\u0430\u0441\u043D\u044F", "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430", "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430", "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"]
    };
    dayValues11 = {
      narrow: ["\u041D", "\u041F", "\u0410", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0434", "\u043F\u043D", "\u0430\u045E", "\u0441\u0440", "\u0447\u0446", "\u043F\u0442", "\u0441\u0431"],
      abbreviated: ["\u043D\u044F\u0434\u0437", "\u043F\u0430\u043D", "\u0430\u045E\u0442", "\u0441\u0435\u0440", "\u0447\u0430\u0446\u044C", "\u043F\u044F\u0442", "\u0441\u0443\u0431"],
      wide: ["\u043D\u044F\u0434\u0437\u0435\u043B\u044F", "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A", "\u0430\u045E\u0442\u043E\u0440\u0430\u043A", "\u0441\u0435\u0440\u0430\u0434\u0430", "\u0447\u0430\u0446\u044C\u0432\u0435\u0440", "\u043F\u044F\u0442\u043D\u0456\u0446\u0430", "\u0441\u0443\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues11 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
      }
    };
    formattingDayPeriodValues11 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
      }
    };
    ordinalNumber21 = function ordinalNumber22(dirtyNumber, options) {
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      var number = Number(dirtyNumber);
      var suffix;
      if (unit === "date") {
        suffix = "-\u0433\u0430";
      } else if (unit === "hour" || unit === "minute" || unit === "second") {
        suffix = "-\u044F";
      } else {
        suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
      }
      return number + suffix;
    };
    localize11 = {
      ordinalNumber: ordinalNumber21,
      era: buildLocalizeFn({
        values: eraValues11,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues11,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback11(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues11,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues2,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues11,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues11,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues11,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default11 = localize11;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/_lib/match/index.js
var matchOrdinalNumberPattern11, parseOrdinalNumberPattern11, matchEraPatterns11, parseEraPatterns11, matchQuarterPatterns11, parseQuarterPatterns11, matchMonthPatterns11, parseMonthPatterns11, matchDayPatterns11, parseDayPatterns11, matchDayPeriodPatterns11, parseDayPeriodPatterns11, match11, match_default11;
var init_match11 = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern11 = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
    parseOrdinalNumberPattern11 = /\d+/i;
    matchEraPatterns11 = {
      narrow: /^((да )?н\.?\s?э\.?)/i,
      abbreviated: /^((да )?н\.?\s?э\.?)/i,
      wide: /^(да нашай эры|нашай эры|наша эра)/i
    };
    parseEraPatterns11 = {
      any: [/^д/i, /^н/i]
    };
    matchQuarterPatterns11 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
      wide: /^[1234](-?[ыі]?)? квартал/i
    };
    parseQuarterPatterns11 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns11 = {
      narrow: /^[слкмчжв]/i,
      abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
      wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
    };
    parseMonthPatterns11 = {
      narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
      any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^тр/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
    };
    matchDayPatterns11 = {
      narrow: /^[нпасч]/i,
      short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
      abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
      wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
    };
    parseDayPatterns11 = {
      narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
    };
    matchDayPeriodPatterns11 = {
      narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
      abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
      wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
    };
    parseDayPeriodPatterns11 = {
      any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
      }
    };
    match11 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern11,
        parsePattern: parseOrdinalNumberPattern11,
        valueCallback: function valueCallback21(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns11,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns11,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns11,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns11,
        defaultParseWidth: "any",
        valueCallback: function valueCallback22(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns11,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns11,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns11,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns11,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns11,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns11,
        defaultParseWidth: "any"
      })
    };
    match_default11 = match11;
  }
});

// ../../node_modules/date-fns/esm/locale/be-tarask/index.js
var locale11, be_tarask_default;
var init_be_tarask = __esm({
  "../../node_modules/date-fns/esm/locale/be-tarask/index.js"() {
    "use strict";
    init_formatDistance12();
    init_formatLong11();
    init_formatRelative12();
    init_localize11();
    init_match11();
    locale11 = {
      code: "be-tarask",
      formatDistance: formatDistance_default11,
      formatLong: formatLong_default11,
      formatRelative: formatRelative_default11,
      localize: localize_default11,
      match: match_default11,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    be_tarask_default = locale11;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatDistance/index.js
var formatDistanceLocale12, formatDistance24, formatDistance_default12;
var init_formatDistance13 = __esm({
  "../../node_modules/date-fns/esm/locale/bg/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale12 = {
      lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
      lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
      },
      xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
      },
      aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
      },
      xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
      },
      xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
      },
      aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
      },
      xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
      },
      aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
      },
      xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
      },
      aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      }
    };
    formatDistance24 = function formatDistance25(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale12[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0441\u043B\u0435\u0434 " + result;
        } else {
          return "\u043F\u0440\u0435\u0434\u0438 " + result;
        }
      }
      return result;
    };
    formatDistance_default12 = formatDistance24;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatLong/index.js
var dateFormats12, timeFormats12, dateTimeFormats12, formatLong12, formatLong_default12;
var init_formatLong12 = __esm({
  "../../node_modules/date-fns/esm/locale/bg/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats12 = {
      full: "EEEE, dd MMMM yyyy",
      long: "dd MMMM yyyy",
      medium: "dd MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats12 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats12 = {
      any: "{{date}} {{time}}"
    };
    formatLong12 = {
      date: buildFormatLongFn({
        formats: dateFormats12,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats12,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats12,
        defaultWidth: "any"
      })
    };
    formatLong_default12 = formatLong12;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/_lib/formatRelative/index.js
function lastWeek3(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
  }
}
function thisWeek3(day) {
  var weekday = weekdays[day];
  if (day === 2) {
    return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
  } else {
    return "'\u0432 " + weekday + " \u0432' p";
  }
}
function nextWeek3(day) {
  var weekday = weekdays[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
  }
}
var weekdays, lastWeekFormatToken, nextWeekFormatToken, formatRelativeLocale12, formatRelative24, formatRelative_default12;
var init_formatRelative13 = __esm({
  "../../node_modules/date-fns/esm/locale/bg/_lib/formatRelative/index.js"() {
    "use strict";
    init_toDate();
    init_isSameUTCWeek();
    weekdays = ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"];
    lastWeekFormatToken = function lastWeekFormatToken2(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek3(day);
      } else {
        return lastWeek3(day);
      }
    };
    nextWeekFormatToken = function nextWeekFormatToken2(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek3(day);
      } else {
        return nextWeek3(day);
      }
    };
    formatRelativeLocale12 = {
      lastWeek: lastWeekFormatToken,
      yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
      today: "'\u0434\u043D\u0435\u0441 \u0432' p",
      tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
      nextWeek: nextWeekFormatToken,
      other: "P"
    };
    formatRelative24 = function formatRelative25(token, date, baseDate, options) {
      var format2 = formatRelativeLocale12[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default12 = formatRelative24;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/_lib/localize/index.js
function isFeminine(unit) {
  return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function isNeuter(unit) {
  return unit === "quarter";
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
  return number + "-" + suffix;
}
var eraValues12, quarterValues12, monthValues12, dayValues12, dayPeriodValues12, ordinalNumber23, localize12, localize_default12;
var init_localize12 = __esm({
  "../../node_modules/date-fns/esm/locale/bg/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues12 = {
      narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
      abbreviated: ["\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.", "\u043D. \u0435."],
      wide: ["\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"]
    };
    quarterValues12 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."],
      wide: ["1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435", "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"]
    };
    monthValues12 = {
      abbreviated: ["\u044F\u043D\u0443", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0435", "\u0434\u0435\u043A"],
      wide: ["\u044F\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0439", "\u044E\u043D\u0438", "\u044E\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
    };
    dayValues12 = {
      narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
      abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u044F", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u044A\u0431"],
      wide: ["\u043D\u0435\u0434\u0435\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u044F\u0434\u0430", "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A", "\u043F\u0435\u0442\u044A\u043A", "\u0441\u044A\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues12 = {
      wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
      }
    };
    ordinalNumber23 = function ordinalNumber24(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      if (number === 0) {
        return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
      } else if (number % 1e3 === 0) {
        return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
      } else if (number % 100 === 0) {
        return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
      }
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
          case 2:
            return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
          case 7:
          case 8:
            return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
        }
      }
      return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
    };
    localize12 = {
      ordinalNumber: ordinalNumber23,
      era: buildLocalizeFn({
        values: eraValues12,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues12,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback12(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues12,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues12,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues12,
        defaultWidth: "wide"
      })
    };
    localize_default12 = localize12;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/_lib/match/index.js
var matchOrdinalNumberPattern12, parseOrdinalNumberPattern12, matchEraPatterns12, parseEraPatterns12, matchQuarterPatterns12, parseQuarterPatterns12, matchDayPatterns12, parseDayPatterns12, matchMonthPatterns12, parseMonthPatterns12, matchDayPeriodPatterns12, parseDayPeriodPatterns12, match12, match_default12;
var init_match12 = __esm({
  "../../node_modules/date-fns/esm/locale/bg/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern12 = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
    parseOrdinalNumberPattern12 = /\d+/i;
    matchEraPatterns12 = {
      narrow: /^((пр)?н\.?\s?е\.?)/i,
      abbreviated: /^((пр)?н\.?\s?е\.?)/i,
      wide: /^(преди новата ера|новата ера|нова ера)/i
    };
    parseEraPatterns12 = {
      any: [/^п/i, /^н/i]
    };
    matchQuarterPatterns12 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
      wide: /^[1234](-?[врт]?о?)? тримесечие/i
    };
    parseQuarterPatterns12 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchDayPatterns12 = {
      narrow: /^[нпвсч]/i,
      short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
      abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
      wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
    };
    parseDayPatterns12 = {
      narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
    };
    matchMonthPatterns12 = {
      abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
      wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
    };
    parseMonthPatterns12 = {
      any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
    };
    matchDayPeriodPatterns12 = {
      any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
    };
    parseDayPeriodPatterns12 = {
      any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
      }
    };
    match12 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern12,
        parsePattern: parseOrdinalNumberPattern12,
        valueCallback: function valueCallback23(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns12,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns12,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns12,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns12,
        defaultParseWidth: "any",
        valueCallback: function valueCallback24(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns12,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns12,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns12,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns12,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns12,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns12,
        defaultParseWidth: "any"
      })
    };
    match_default12 = match12;
  }
});

// ../../node_modules/date-fns/esm/locale/bg/index.js
var locale12, bg_default;
var init_bg = __esm({
  "../../node_modules/date-fns/esm/locale/bg/index.js"() {
    "use strict";
    init_formatDistance13();
    init_formatLong12();
    init_formatRelative13();
    init_localize12();
    init_match12();
    locale12 = {
      code: "bg",
      formatDistance: formatDistance_default12,
      formatLong: formatLong_default12,
      formatRelative: formatRelative_default12,
      localize: localize_default12,
      match: match_default12,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    bg_default = locale12;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/_lib/localize/index.js
function dateOrdinalNumber(number, localeNumber) {
  if (number > 18 && number <= 31) {
    return localeNumber + "\u09B6\u09C7";
  } else {
    switch (number) {
      case 1:
        return localeNumber + "\u09B2\u09BE";
      case 2:
      case 3:
        return localeNumber + "\u09B0\u09BE";
      case 4:
        return localeNumber + "\u09A0\u09BE";
      default:
        return localeNumber + "\u0987";
    }
  }
}
function numberToLocale(enNumber) {
  return enNumber.toString().replace(/\d/g, function(match83) {
    return numberValues.locale[match83];
  });
}
var numberValues, eraValues13, quarterValues13, monthValues13, dayValues13, dayPeriodValues13, formattingDayPeriodValues12, ordinalNumber25, localize13, localize_default13;
var init_localize13 = __esm({
  "../../node_modules/date-fns/esm/locale/bn/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    numberValues = {
      locale: {
        "1": "\u09E7",
        "2": "\u09E8",
        "3": "\u09E9",
        "4": "\u09EA",
        "5": "\u09EB",
        "6": "\u09EC",
        "7": "\u09ED",
        "8": "\u09EE",
        "9": "\u09EF",
        "0": "\u09E6"
      },
      number: {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
      }
    };
    eraValues13 = {
      narrow: ["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983", "\u0996\u09CD\u09B0\u09BF\u0983"],
      abbreviated: ["\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC", "\u0996\u09CD\u09B0\u09BF\u0983"],
      wide: ["\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC", "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"]
    };
    quarterValues13 = {
      narrow: ["\u09E7", "\u09E8", "\u09E9", "\u09EA"],
      abbreviated: ["\u09E7\u09A4\u09CD\u09B0\u09C8", "\u09E8\u09A4\u09CD\u09B0\u09C8", "\u09E9\u09A4\u09CD\u09B0\u09C8", "\u09EA\u09A4\u09CD\u09B0\u09C8"],
      wide: ["\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995", "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"]
    };
    monthValues13 = {
      narrow: ["\u099C\u09BE\u09A8\u09C1", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F", "\u0985\u0995\u09CD\u099F\u09CB", "\u09A8\u09AD\u09C7", "\u09A1\u09BF\u09B8\u09C7"],
      abbreviated: ["\u099C\u09BE\u09A8\u09C1", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F", "\u0985\u0995\u09CD\u099F\u09CB", "\u09A8\u09AD\u09C7", "\u09A1\u09BF\u09B8\u09C7"],
      wide: ["\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF", "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF", "\u09AE\u09BE\u09B0\u09CD\u099A", "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2", "\u09AE\u09C7", "\u099C\u09C1\u09A8", "\u099C\u09C1\u09B2\u09BE\u0987", "\u0986\u0997\u09B8\u09CD\u099F", "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0", "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0", "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0", "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"]
    };
    dayValues13 = {
      narrow: ["\u09B0", "\u09B8\u09CB", "\u09AE", "\u09AC\u09C1", "\u09AC\u09C3", "\u09B6\u09C1", "\u09B6"],
      short: ["\u09B0\u09AC\u09BF", "\u09B8\u09CB\u09AE", "\u09AE\u0999\u09CD\u0997\u09B2", "\u09AC\u09C1\u09A7", "\u09AC\u09C3\u09B9", "\u09B6\u09C1\u0995\u09CD\u09B0", "\u09B6\u09A8\u09BF"],
      abbreviated: ["\u09B0\u09AC\u09BF", "\u09B8\u09CB\u09AE", "\u09AE\u0999\u09CD\u0997\u09B2", "\u09AC\u09C1\u09A7", "\u09AC\u09C3\u09B9", "\u09B6\u09C1\u0995\u09CD\u09B0", "\u09B6\u09A8\u09BF"],
      wide: ["\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0", "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0", "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0", "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0", "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ", "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0", "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"]
    };
    dayPeriodValues13 = {
      narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      },
      abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      },
      wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      }
    };
    formattingDayPeriodValues12 = {
      narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      },
      abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      },
      wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
      }
    };
    ordinalNumber25 = function ordinalNumber26(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var localeNumber = numberToLocale(number);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      if (unit === "date") {
        return dateOrdinalNumber(number, localeNumber);
      }
      if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
      var rem10 = number % 10;
      switch (rem10) {
        case 2:
        case 3:
          return localeNumber + "\u09DF";
        case 4:
          return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
          return localeNumber + "\u09B7\u09CD\u09A0";
        default:
          return localeNumber + "\u09AE";
      }
    };
    localize13 = {
      ordinalNumber: ordinalNumber25,
      era: buildLocalizeFn({
        values: eraValues13,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues13,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback13(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues13,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues13,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues13,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues12,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default13 = localize13;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/_lib/formatDistance/index.js
var formatDistanceLocale13, formatDistance26, formatDistance_default13;
var init_formatDistance14 = __esm({
  "../../node_modules/date-fns/esm/locale/bn/_lib/formatDistance/index.js"() {
    "use strict";
    init_localize13();
    formatDistanceLocale13 = {
      lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
      },
      xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
      },
      halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
      lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
      },
      xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
      },
      aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
      },
      xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
      },
      xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
      },
      aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
      },
      xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
      },
      aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
      },
      xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
      },
      aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
      },
      xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
      },
      overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
      },
      almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
      }
    };
    formatDistance26 = function formatDistance27(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale13[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", numberToLocale(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        } else {
          return result + " \u0986\u0997\u09C7";
        }
      }
      return result;
    };
    formatDistance_default13 = formatDistance26;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/_lib/formatLong/index.js
var dateFormats13, timeFormats13, dateTimeFormats13, formatLong13, formatLong_default13;
var init_formatLong13 = __esm({
  "../../node_modules/date-fns/esm/locale/bn/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats13 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats13 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats13 = {
      full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
      long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong13 = {
      date: buildFormatLongFn({
        formats: dateFormats13,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats13,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats13,
        defaultWidth: "full"
      })
    };
    formatLong_default13 = formatLong13;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/_lib/formatRelative/index.js
var formatRelativeLocale13, formatRelative26, formatRelative_default13;
var init_formatRelative14 = __esm({
  "../../node_modules/date-fns/esm/locale/bn/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale13 = {
      lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
      yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
      today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
      tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
      nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
      other: "P"
    };
    formatRelative26 = function formatRelative27(token, _date, _baseDate, _options) {
      return formatRelativeLocale13[token];
    };
    formatRelative_default13 = formatRelative26;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/_lib/match/index.js
var matchOrdinalNumberPattern13, parseOrdinalNumberPattern13, matchEraPatterns13, parseEraPatterns13, matchQuarterPatterns13, parseQuarterPatterns13, matchMonthPatterns13, parseMonthPatterns13, matchDayPatterns13, parseDayPatterns13, matchDayPeriodPatterns13, parseDayPeriodPatterns13, match13, match_default13;
var init_match13 = __esm({
  "../../node_modules/date-fns/esm/locale/bn/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern13 = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
    parseOrdinalNumberPattern13 = /\d+/i;
    matchEraPatterns13 = {
      narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
      abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
      wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
    };
    parseEraPatterns13 = {
      narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
      abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
      wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
    };
    matchQuarterPatterns13 = {
      narrow: /^[১২৩৪]/i,
      abbreviated: /^[১২৩৪]ত্রৈ/i,
      wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
    };
    parseQuarterPatterns13 = {
      any: [/১/i, /২/i, /৩/i, /৪/i]
    };
    matchMonthPatterns13 = {
      narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
      abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
      wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
    };
    parseMonthPatterns13 = {
      any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
    };
    matchDayPatterns13 = {
      narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
      short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
      abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
      wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
    };
    parseDayPatterns13 = {
      narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
      short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
      abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
      wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
    };
    matchDayPeriodPatterns13 = {
      narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
      abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
      wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
    };
    parseDayPeriodPatterns13 = {
      any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
      }
    };
    match13 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern13,
        parsePattern: parseOrdinalNumberPattern13,
        valueCallback: function valueCallback25(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns13,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns13,
        defaultParseWidth: "wide"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns13,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns13,
        defaultParseWidth: "any",
        valueCallback: function valueCallback26(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns13,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns13,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns13,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns13,
        defaultParseWidth: "wide"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns13,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns13,
        defaultParseWidth: "any"
      })
    };
    match_default13 = match13;
  }
});

// ../../node_modules/date-fns/esm/locale/bn/index.js
var locale13, bn_default;
var init_bn = __esm({
  "../../node_modules/date-fns/esm/locale/bn/index.js"() {
    "use strict";
    init_formatDistance14();
    init_formatLong13();
    init_formatRelative14();
    init_localize13();
    init_match13();
    locale13 = {
      code: "bn",
      formatDistance: formatDistance_default13,
      formatLong: formatLong_default13,
      formatRelative: formatRelative_default13,
      localize: localize_default13,
      match: match_default13,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    bn_default = locale13;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/_lib/formatDistance/index.js
var formatDistanceLocale14, formatDistance28, formatDistance_default14;
var init_formatDistance15 = __esm({
  "../../node_modules/date-fns/esm/locale/bs/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale14 = {
      lessThanXSeconds: {
        one: {
          standalone: "manje od 1 sekunde",
          withPrepositionAgo: "manje od 1 sekunde",
          withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
      },
      xSeconds: {
        one: {
          standalone: "1 sekunda",
          withPrepositionAgo: "1 sekunde",
          withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
      },
      halfAMinute: "pola minute",
      lessThanXMinutes: {
        one: {
          standalone: "manje od 1 minute",
          withPrepositionAgo: "manje od 1 minute",
          withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
      },
      xMinutes: {
        one: {
          standalone: "1 minuta",
          withPrepositionAgo: "1 minute",
          withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
      },
      aboutXHours: {
        one: {
          standalone: "oko 1 sat",
          withPrepositionAgo: "oko 1 sat",
          withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
      },
      xHours: {
        one: {
          standalone: "1 sat",
          withPrepositionAgo: "1 sat",
          withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
      },
      xDays: {
        one: {
          standalone: "1 dan",
          withPrepositionAgo: "1 dan",
          withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
      },
      aboutXWeeks: {
        one: {
          standalone: "oko 1 sedmicu",
          withPrepositionAgo: "oko 1 sedmicu",
          withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
      },
      xWeeks: {
        one: {
          standalone: "1 sedmicu",
          withPrepositionAgo: "1 sedmicu",
          withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
      },
      aboutXMonths: {
        one: {
          standalone: "oko 1 mjesec",
          withPrepositionAgo: "oko 1 mjesec",
          withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
      },
      xMonths: {
        one: {
          standalone: "1 mjesec",
          withPrepositionAgo: "1 mjesec",
          withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
      },
      aboutXYears: {
        one: {
          standalone: "oko 1 godinu",
          withPrepositionAgo: "oko 1 godinu",
          withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
      },
      xYears: {
        one: {
          standalone: "1 godina",
          withPrepositionAgo: "1 godine",
          withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
      },
      overXYears: {
        one: {
          standalone: "preko 1 godinu",
          withPrepositionAgo: "preko 1 godinu",
          withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
      },
      almostXYears: {
        one: {
          standalone: "gotovo 1 godinu",
          withPrepositionAgo: "gotovo 1 godinu",
          withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
      }
    };
    formatDistance28 = function formatDistance29(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale14[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            result = tokenValue.one.withPrepositionIn;
          } else {
            result = tokenValue.one.withPrepositionAgo;
          }
        } else {
          result = tokenValue.one.standalone;
        }
      } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
      String(count).substr(-2, 1) !== "1") {
        result = tokenValue.dual.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "za " + result;
        } else {
          return "prije " + result;
        }
      }
      return result;
    };
    formatDistance_default14 = formatDistance28;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/_lib/formatLong/index.js
var dateFormats14, timeFormats14, dateTimeFormats14, formatLong14, formatLong_default14;
var init_formatLong14 = __esm({
  "../../node_modules/date-fns/esm/locale/bs/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats14 = {
      full: "EEEE, d. MMMM yyyy.",
      long: "d. MMMM yyyy.",
      medium: "d. MMM yy.",
      short: "dd. MM. yy."
    };
    timeFormats14 = {
      full: "HH:mm:ss (zzzz)",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats14 = {
      full: "{{date}} 'u' {{time}}",
      long: "{{date}} 'u' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong14 = {
      date: buildFormatLongFn({
        formats: dateFormats14,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats14,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats14,
        defaultWidth: "full"
      })
    };
    formatLong_default14 = formatLong14;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/_lib/formatRelative/index.js
var formatRelativeLocale14, formatRelative28, formatRelative_default14;
var init_formatRelative15 = __esm({
  "../../node_modules/date-fns/esm/locale/bs/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale14 = {
      lastWeek: function lastWeek4(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'pro\u0161le nedjelje u' p";
          case 3:
            return "'pro\u0161le srijede u' p";
          case 6:
            return "'pro\u0161le subote u' p";
          default:
            return "'pro\u0161li' EEEE 'u' p";
        }
      },
      yesterday: "'ju\u010De u' p",
      today: "'danas u' p",
      tomorrow: "'sutra u' p",
      nextWeek: function nextWeek4(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'sljede\u0107e nedjelje u' p";
          case 3:
            return "'sljede\u0107u srijedu u' p";
          case 6:
            return "'sljede\u0107u subotu u' p";
          default:
            return "'sljede\u0107i' EEEE 'u' p";
        }
      },
      other: "P"
    };
    formatRelative28 = function formatRelative29(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale14[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default14 = formatRelative28;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/_lib/localize/index.js
var eraValues14, quarterValues14, monthValues14, formattingMonthValues3, dayValues14, dayPeriodValues14, formattingDayPeriodValues13, ordinalNumber27, localize14, localize_default14;
var init_localize14 = __esm({
  "../../node_modules/date-fns/esm/locale/bs/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues14 = {
      narrow: ["pr.n.e.", "AD"],
      abbreviated: ["pr. Hr.", "po. Hr."],
      wide: ["Prije Hrista", "Poslije Hrista"]
    };
    quarterValues14 = {
      narrow: ["1.", "2.", "3.", "4."],
      abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues14 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
      wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
    };
    formattingMonthValues3 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
      wide: ["januar", "februar", "mart", "april", "maj", "juni", "juli", "avgust", "septembar", "oktobar", "novembar", "decembar"]
    };
    dayValues14 = {
      narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
      short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
      abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
      wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "\u010Detvrtak", "petak", "subota"]
    };
    dayPeriodValues14 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
      }
    };
    formattingDayPeriodValues13 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
      }
    };
    ordinalNumber27 = function ordinalNumber28(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return String(number) + ".";
    };
    localize14 = {
      ordinalNumber: ordinalNumber27,
      era: buildLocalizeFn({
        values: eraValues14,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues14,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback14(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues14,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues3,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues14,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues14,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues13,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default14 = localize14;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/_lib/match/index.js
var matchOrdinalNumberPattern14, parseOrdinalNumberPattern14, matchEraPatterns14, parseEraPatterns14, matchQuarterPatterns14, parseQuarterPatterns14, matchMonthPatterns14, parseMonthPatterns14, matchDayPatterns14, parseDayPatterns14, matchDayPeriodPatterns14, parseDayPeriodPatterns14, match14, match_default14;
var init_match14 = __esm({
  "../../node_modules/date-fns/esm/locale/bs/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern14 = /^(\d+)\./i;
    parseOrdinalNumberPattern14 = /\d+/i;
    matchEraPatterns14 = {
      narrow: /^(pr\.n\.e\.|AD)/i,
      abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
      wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
    };
    parseEraPatterns14 = {
      any: [/^pr/i, /^(po|nova)/i]
    };
    matchQuarterPatterns14 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\.\s?kv\.?/i,
      wide: /^[1234]\. kvartal/i
    };
    parseQuarterPatterns14 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns14 = {
      narrow: /^(10|11|12|[123456789])\./i,
      abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
      wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
    };
    parseMonthPatterns14 = {
      narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns14 = {
      narrow: /^[npusčc]/i,
      short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
      abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
      wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
    };
    parseDayPatterns14 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns14 = {
      any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
    };
    parseDayPeriodPatterns14 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
      }
    };
    match14 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern14,
        parsePattern: parseOrdinalNumberPattern14,
        valueCallback: function valueCallback27(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns14,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns14,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns14,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns14,
        defaultParseWidth: "any",
        valueCallback: function valueCallback28(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns14,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns14,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns14,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns14,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns14,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns14,
        defaultParseWidth: "any"
      })
    };
    match_default14 = match14;
  }
});

// ../../node_modules/date-fns/esm/locale/bs/index.js
var locale14, bs_default;
var init_bs = __esm({
  "../../node_modules/date-fns/esm/locale/bs/index.js"() {
    "use strict";
    init_formatDistance15();
    init_formatLong14();
    init_formatRelative15();
    init_localize14();
    init_match14();
    locale14 = {
      code: "bs",
      formatDistance: formatDistance_default14,
      formatLong: formatLong_default14,
      formatRelative: formatRelative_default14,
      localize: localize_default14,
      match: match_default14,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    bs_default = locale14;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/_lib/formatDistance/index.js
var formatDistanceLocale15, formatDistance30, formatDistance_default15;
var init_formatDistance16 = __esm({
  "../../node_modules/date-fns/esm/locale/ca/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale15 = {
      lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
      },
      xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
      },
      halfAMinute: "mig minut",
      lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
      },
      xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
      },
      aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
      },
      xHours: {
        one: "1 hora",
        other: "{{count}} hores"
      },
      xDays: {
        one: "1 dia",
        other: "{{count}} dies"
      },
      aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
      },
      xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
      },
      aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
      },
      xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
      },
      aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
      },
      xYears: {
        one: "1 any",
        other: "{{count}} anys"
      },
      overXYears: {
        one: "m\xE9s d'un any",
        eleven: "m\xE9s d'onze anys",
        other: "m\xE9s de {{count}} anys"
      },
      almostXYears: {
        one: "gaireb\xE9 un any",
        other: "gaireb\xE9 {{count}} anys"
      }
    };
    formatDistance30 = function formatDistance31(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale15[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 11 && tokenValue.eleven) {
        result = tokenValue.eleven;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "en " + result;
        } else {
          return "fa " + result;
        }
      }
      return result;
    };
    formatDistance_default15 = formatDistance30;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/_lib/formatLong/index.js
var dateFormats15, timeFormats15, dateTimeFormats15, formatLong15, formatLong_default15;
var init_formatLong15 = __esm({
  "../../node_modules/date-fns/esm/locale/ca/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats15 = {
      full: "EEEE, d 'de' MMMM y",
      long: "d 'de' MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats15 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats15 = {
      full: "{{date}} 'a les' {{time}}",
      long: "{{date}} 'a les' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong15 = {
      date: buildFormatLongFn({
        formats: dateFormats15,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats15,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats15,
        defaultWidth: "full"
      })
    };
    formatLong_default15 = formatLong15;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/_lib/formatRelative/index.js
var formatRelativeLocale15, formatRelativeLocalePlural, formatRelative30, formatRelative_default15;
var init_formatRelative16 = __esm({
  "../../node_modules/date-fns/esm/locale/ca/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale15 = {
      lastWeek: "'el' eeee 'passat a la' LT",
      yesterday: "'ahir a la' p",
      today: "'avui a la' p",
      tomorrow: "'dem\xE0 a la' p",
      nextWeek: "eeee 'a la' p",
      other: "P"
    };
    formatRelativeLocalePlural = {
      lastWeek: "'el' eeee 'passat a les' p",
      yesterday: "'ahir a les' p",
      today: "'avui a les' p",
      tomorrow: "'dem\xE0 a les' p",
      nextWeek: "eeee 'a les' p",
      other: "P"
    };
    formatRelative30 = function formatRelative31(token, date, _baseDate, _options) {
      if (date.getUTCHours() !== 1) {
        return formatRelativeLocalePlural[token];
      }
      return formatRelativeLocale15[token];
    };
    formatRelative_default15 = formatRelative30;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/_lib/localize/index.js
var eraValues15, quarterValues15, monthValues15, dayValues15, dayPeriodValues15, formattingDayPeriodValues14, ordinalNumber29, localize15, localize_default15;
var init_localize15 = __esm({
  "../../node_modules/date-fns/esm/locale/ca/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues15 = {
      narrow: ["aC", "dC"],
      abbreviated: ["a. de C.", "d. de C."],
      wide: ["abans de Crist", "despr\xE9s de Crist"]
    };
    quarterValues15 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
    };
    monthValues15 = {
      narrow: ["GN", "FB", "M\xC7", "AB", "MG", "JN", "JL", "AG", "ST", "OC", "NV", "DS"],
      /**
       * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
       * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
       * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
       */
      abbreviated: ["gen.", "febr.", "mar\xE7", "abr.", "maig", "juny", "jul.", "ag.", "set.", "oct.", "nov.", "des."],
      wide: ["gener", "febrer", "mar\xE7", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"]
    };
    dayValues15 = {
      narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
      short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
      abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
      wide: ["diumenge", "dilluns", "dimarts", "dimecres", "dijous", "divendres", "dissabte"]
    };
    dayPeriodValues15 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xED",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
      },
      abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xED",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
      },
      wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xED",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
      }
    };
    formattingDayPeriodValues14 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xED",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xED",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
      },
      wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xED",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
      }
    };
    ordinalNumber29 = function ordinalNumber30(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "r";
          case 2:
            return number + "n";
          case 3:
            return number + "r";
          case 4:
            return number + "t";
        }
      }
      return number + "\xE8";
    };
    localize15 = {
      ordinalNumber: ordinalNumber29,
      era: buildLocalizeFn({
        values: eraValues15,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues15,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback15(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues15,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues15,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues15,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues14,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default15 = localize15;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/_lib/match/index.js
var matchOrdinalNumberPattern15, parseOrdinalNumberPattern15, matchEraPatterns15, parseEraPatterns15, matchQuarterPatterns15, parseQuarterPatterns15, matchMonthPatterns15, parseMonthPatterns15, matchDayPatterns15, parseDayPatterns15, matchDayPeriodPatterns15, parseDayPeriodPatterns15, match15, match_default15;
var init_match15 = __esm({
  "../../node_modules/date-fns/esm/locale/ca/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern15 = /^(\d+)(è|r|n|r|t)?/i;
    parseOrdinalNumberPattern15 = /\d+/i;
    matchEraPatterns15 = {
      narrow: /^(aC|dC)/i,
      abbreviated: /^(a. de C.|d. de C.)/i,
      wide: /^(abans de Crist|despr[eé]s de Crist)/i
    };
    parseEraPatterns15 = {
      narrow: [/^aC/i, /^dC/i],
      abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
      wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
    };
    matchQuarterPatterns15 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^[1234](è|r|n|r|t)? trimestre/i
    };
    parseQuarterPatterns15 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns15 = {
      narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
      abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
      wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
    };
    parseMonthPatterns15 = {
      narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
      abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
      wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
    };
    matchDayPatterns15 = {
      narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
      short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
      abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
      wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
    };
    parseDayPatterns15 = {
      narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
      abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
      wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
    };
    matchDayPeriodPatterns15 = {
      narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
      abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
      wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
    };
    parseDayPeriodPatterns15 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
      }
    };
    match15 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern15,
        parsePattern: parseOrdinalNumberPattern15,
        valueCallback: function valueCallback29(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns15,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns15,
        defaultParseWidth: "wide"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns15,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns15,
        defaultParseWidth: "any",
        valueCallback: function valueCallback30(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns15,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns15,
        defaultParseWidth: "wide"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns15,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns15,
        defaultParseWidth: "wide"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns15,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns15,
        defaultParseWidth: "any"
      })
    };
    match_default15 = match15;
  }
});

// ../../node_modules/date-fns/esm/locale/ca/index.js
var locale15, ca_default;
var init_ca = __esm({
  "../../node_modules/date-fns/esm/locale/ca/index.js"() {
    "use strict";
    init_formatDistance16();
    init_formatLong15();
    init_formatRelative16();
    init_localize15();
    init_match15();
    locale15 = {
      code: "ca",
      formatDistance: formatDistance_default15,
      formatLong: formatLong_default15,
      formatRelative: formatRelative_default15,
      localize: localize_default15,
      match: match_default15,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    ca_default = locale15;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/_lib/formatDistance/index.js
var formatDistanceLocale16, formatDistance32, formatDistance_default16;
var init_formatDistance17 = __esm({
  "../../node_modules/date-fns/esm/locale/cs/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale16 = {
      lessThanXSeconds: {
        one: {
          regular: "m\xE9n\u011B ne\u017E sekunda",
          past: "p\u0159ed m\xE9n\u011B ne\u017E sekundou",
          future: "za m\xE9n\u011B ne\u017E sekundu"
        },
        few: {
          regular: "m\xE9n\u011B ne\u017E {{count}} sekundy",
          past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
          future: "za m\xE9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
          regular: "m\xE9n\u011B ne\u017E {{count}} sekund",
          past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} sekundami",
          future: "za m\xE9n\u011B ne\u017E {{count}} sekund"
        }
      },
      xSeconds: {
        one: {
          regular: "sekunda",
          past: "p\u0159ed sekundou",
          future: "za sekundu"
        },
        few: {
          regular: "{{count}} sekundy",
          past: "p\u0159ed {{count}} sekundami",
          future: "za {{count}} sekundy"
        },
        many: {
          regular: "{{count}} sekund",
          past: "p\u0159ed {{count}} sekundami",
          future: "za {{count}} sekund"
        }
      },
      halfAMinute: {
        type: "other",
        other: {
          regular: "p\u016Fl minuty",
          past: "p\u0159ed p\u016Fl minutou",
          future: "za p\u016Fl minuty"
        }
      },
      lessThanXMinutes: {
        one: {
          regular: "m\xE9n\u011B ne\u017E minuta",
          past: "p\u0159ed m\xE9n\u011B ne\u017E minutou",
          future: "za m\xE9n\u011B ne\u017E minutu"
        },
        few: {
          regular: "m\xE9n\u011B ne\u017E {{count}} minuty",
          past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
          future: "za m\xE9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
          regular: "m\xE9n\u011B ne\u017E {{count}} minut",
          past: "p\u0159ed m\xE9n\u011B ne\u017E {{count}} minutami",
          future: "za m\xE9n\u011B ne\u017E {{count}} minut"
        }
      },
      xMinutes: {
        one: {
          regular: "minuta",
          past: "p\u0159ed minutou",
          future: "za minutu"
        },
        few: {
          regular: "{{count}} minuty",
          past: "p\u0159ed {{count}} minutami",
          future: "za {{count}} minuty"
        },
        many: {
          regular: "{{count}} minut",
          past: "p\u0159ed {{count}} minutami",
          future: "za {{count}} minut"
        }
      },
      aboutXHours: {
        one: {
          regular: "p\u0159ibli\u017En\u011B hodina",
          past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
          future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
          regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
          future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
          regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
          future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
      },
      xHours: {
        one: {
          regular: "hodina",
          past: "p\u0159ed hodinou",
          future: "za hodinu"
        },
        few: {
          regular: "{{count}} hodiny",
          past: "p\u0159ed {{count}} hodinami",
          future: "za {{count}} hodiny"
        },
        many: {
          regular: "{{count}} hodin",
          past: "p\u0159ed {{count}} hodinami",
          future: "za {{count}} hodin"
        }
      },
      xDays: {
        one: {
          regular: "den",
          past: "p\u0159ed dnem",
          future: "za den"
        },
        few: {
          regular: "{{count}} dny",
          past: "p\u0159ed {{count}} dny",
          future: "za {{count}} dny"
        },
        many: {
          regular: "{{count}} dn\xED",
          past: "p\u0159ed {{count}} dny",
          future: "za {{count}} dn\xED"
        }
      },
      aboutXWeeks: {
        one: {
          regular: "p\u0159ibli\u017En\u011B t\xFDden",
          past: "p\u0159ibli\u017En\u011B p\u0159ed t\xFDdnem",
          future: "p\u0159ibli\u017En\u011B za t\xFDden"
        },
        few: {
          regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdny",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
          future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdny"
        },
        many: {
          regular: "p\u0159ibli\u017En\u011B {{count}} t\xFDdn\u016F",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xFDdny",
          future: "p\u0159ibli\u017En\u011B za {{count}} t\xFDdn\u016F"
        }
      },
      xWeeks: {
        one: {
          regular: "t\xFDden",
          past: "p\u0159ed t\xFDdnem",
          future: "za t\xFDden"
        },
        few: {
          regular: "{{count}} t\xFDdny",
          past: "p\u0159ed {{count}} t\xFDdny",
          future: "za {{count}} t\xFDdny"
        },
        many: {
          regular: "{{count}} t\xFDdn\u016F",
          past: "p\u0159ed {{count}} t\xFDdny",
          future: "za {{count}} t\xFDdn\u016F"
        }
      },
      aboutXMonths: {
        one: {
          regular: "p\u0159ibli\u017En\u011B m\u011Bs\xEDc",
          past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xEDcem",
          future: "p\u0159ibli\u017En\u011B za m\u011Bs\xEDc"
        },
        few: {
          regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDce",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
          future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDce"
        },
        many: {
          regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xEDc\u016F",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xEDci",
          future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xEDc\u016F"
        }
      },
      xMonths: {
        one: {
          regular: "m\u011Bs\xEDc",
          past: "p\u0159ed m\u011Bs\xEDcem",
          future: "za m\u011Bs\xEDc"
        },
        few: {
          regular: "{{count}} m\u011Bs\xEDce",
          past: "p\u0159ed {{count}} m\u011Bs\xEDci",
          future: "za {{count}} m\u011Bs\xEDce"
        },
        many: {
          regular: "{{count}} m\u011Bs\xEDc\u016F",
          past: "p\u0159ed {{count}} m\u011Bs\xEDci",
          future: "za {{count}} m\u011Bs\xEDc\u016F"
        }
      },
      aboutXYears: {
        one: {
          regular: "p\u0159ibli\u017En\u011B rok",
          past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
          future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
          regular: "p\u0159ibli\u017En\u011B {{count}} roky",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
          future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
          regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
          past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
          future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
      },
      xYears: {
        one: {
          regular: "rok",
          past: "p\u0159ed rokem",
          future: "za rok"
        },
        few: {
          regular: "{{count}} roky",
          past: "p\u0159ed {{count}} roky",
          future: "za {{count}} roky"
        },
        many: {
          regular: "{{count}} rok\u016F",
          past: "p\u0159ed {{count}} roky",
          future: "za {{count}} rok\u016F"
        }
      },
      overXYears: {
        one: {
          regular: "v\xEDce ne\u017E rok",
          past: "p\u0159ed v\xEDce ne\u017E rokem",
          future: "za v\xEDce ne\u017E rok"
        },
        few: {
          regular: "v\xEDce ne\u017E {{count}} roky",
          past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
          future: "za v\xEDce ne\u017E {{count}} roky"
        },
        many: {
          regular: "v\xEDce ne\u017E {{count}} rok\u016F",
          past: "p\u0159ed v\xEDce ne\u017E {{count}} roky",
          future: "za v\xEDce ne\u017E {{count}} rok\u016F"
        }
      },
      almostXYears: {
        one: {
          regular: "skoro rok",
          past: "skoro p\u0159ed rokem",
          future: "skoro za rok"
        },
        few: {
          regular: "skoro {{count}} roky",
          past: "skoro p\u0159ed {{count}} roky",
          future: "skoro za {{count}} roky"
        },
        many: {
          regular: "skoro {{count}} rok\u016F",
          past: "skoro p\u0159ed {{count}} roky",
          future: "skoro za {{count}} rok\u016F"
        }
      }
    };
    formatDistance32 = function formatDistance33(token, count, options) {
      var pluralResult;
      var tokenValue = formatDistanceLocale16[token];
      if (tokenValue.type === "other") {
        pluralResult = tokenValue.other;
      } else if (count === 1) {
        pluralResult = tokenValue.one;
      } else if (count > 1 && count < 5) {
        pluralResult = tokenValue.few;
      } else {
        pluralResult = tokenValue.many;
      }
      var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
      var comparison = options === null || options === void 0 ? void 0 : options.comparison;
      var timeResult;
      if (suffixExist && comparison === -1) {
        timeResult = pluralResult.past;
      } else if (suffixExist && comparison === 1) {
        timeResult = pluralResult.future;
      } else {
        timeResult = pluralResult.regular;
      }
      return timeResult.replace("{{count}}", String(count));
    };
    formatDistance_default16 = formatDistance32;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/_lib/formatLong/index.js
var dateFormats16, timeFormats16, dateTimeFormats16, formatLong16, formatLong_default16;
var init_formatLong16 = __esm({
  "../../node_modules/date-fns/esm/locale/cs/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats16 = {
      full: "EEEE, d. MMMM yyyy",
      long: "d. MMMM yyyy",
      medium: "d. M. yyyy",
      short: "dd.MM.yyyy"
    };
    timeFormats16 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats16 = {
      full: "{{date}} 'v' {{time}}",
      long: "{{date}} 'v' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong16 = {
      date: buildFormatLongFn({
        formats: dateFormats16,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats16,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats16,
        defaultWidth: "full"
      })
    };
    formatLong_default16 = formatLong16;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/_lib/formatRelative/index.js
var accusativeWeekdays3, formatRelativeLocale16, formatRelative32, formatRelative_default16;
var init_formatRelative17 = __esm({
  "../../node_modules/date-fns/esm/locale/cs/_lib/formatRelative/index.js"() {
    "use strict";
    accusativeWeekdays3 = ["ned\u011Bli", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159edu", "\u010Dtvrtek", "p\xE1tek", "sobotu"];
    formatRelativeLocale16 = {
      lastWeek: "'posledn\xED' eeee 've' p",
      yesterday: "'v\u010Dera v' p",
      today: "'dnes v' p",
      tomorrow: "'z\xEDtra v' p",
      nextWeek: function nextWeek5(date) {
        var day = date.getUTCDay();
        return "'v " + accusativeWeekdays3[day] + " o' p";
      },
      other: "P"
    };
    formatRelative32 = function formatRelative33(token, date) {
      var format2 = formatRelativeLocale16[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default16 = formatRelative32;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/_lib/localize/index.js
var eraValues16, quarterValues16, monthValues16, formattingMonthValues4, dayValues16, dayPeriodValues16, formattingDayPeriodValues15, ordinalNumber31, localize16, localize_default16;
var init_localize16 = __esm({
  "../../node_modules/date-fns/esm/locale/cs/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues16 = {
      narrow: ["p\u0159. n. l.", "n. l."],
      abbreviated: ["p\u0159. n. l.", "n. l."],
      wide: ["p\u0159ed na\u0161\xEDm letopo\u010Dtem", "na\u0161eho letopo\u010Dtu"]
    };
    quarterValues16 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"],
      wide: ["1. \u010Dtvrtlet\xED", "2. \u010Dtvrtlet\xED", "3. \u010Dtvrtlet\xED", "4. \u010Dtvrtlet\xED"]
    };
    monthValues16 = {
      narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
      abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
      wide: ["leden", "\xFAnor", "b\u0159ezen", "duben", "kv\u011Bten", "\u010Derven", "\u010Dervenec", "srpen", "z\xE1\u0159\xED", "\u0159\xEDjen", "listopad", "prosinec"]
    };
    formattingMonthValues4 = {
      narrow: ["L", "\xDA", "B", "D", "K", "\u010C", "\u010C", "S", "Z", "\u0158", "L", "P"],
      abbreviated: ["led", "\xFAno", "b\u0159e", "dub", "kv\u011B", "\u010Dvn", "\u010Dvc", "srp", "z\xE1\u0159", "\u0159\xEDj", "lis", "pro"],
      wide: ["ledna", "\xFAnora", "b\u0159ezna", "dubna", "kv\u011Btna", "\u010Dervna", "\u010Dervence", "srpna", "z\xE1\u0159\xED", "\u0159\xEDjna", "listopadu", "prosince"]
    };
    dayValues16 = {
      narrow: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
      short: ["ne", "po", "\xFAt", "st", "\u010Dt", "p\xE1", "so"],
      abbreviated: ["ned", "pon", "\xFAte", "st\u0159", "\u010Dtv", "p\xE1t", "sob"],
      wide: ["ned\u011Ble", "pond\u011Bl\xED", "\xFAter\xFD", "st\u0159eda", "\u010Dtvrtek", "p\xE1tek", "sobota"]
    };
    dayPeriodValues16 = {
      narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      },
      abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      },
      wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      }
    };
    formattingDayPeriodValues15 = {
      narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      },
      abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      },
      wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xE1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
      }
    };
    ordinalNumber31 = function ordinalNumber32(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize16 = {
      ordinalNumber: ordinalNumber31,
      era: buildLocalizeFn({
        values: eraValues16,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues16,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback16(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues16,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues4,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues16,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues16,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues15,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default16 = localize16;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/_lib/match/index.js
var matchOrdinalNumberPattern16, parseOrdinalNumberPattern16, matchEraPatterns16, parseEraPatterns16, matchQuarterPatterns16, parseQuarterPatterns16, matchMonthPatterns16, parseMonthPatterns16, matchDayPatterns16, parseDayPatterns16, matchDayPeriodPatterns16, parseDayPeriodPatterns16, match16, match_default16;
var init_match16 = __esm({
  "../../node_modules/date-fns/esm/locale/cs/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern16 = /^(\d+)\.?/i;
    parseOrdinalNumberPattern16 = /\d+/i;
    matchEraPatterns16 = {
      narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
      abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
      wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
    };
    parseEraPatterns16 = {
      any: [/^p[řr]/i, /^(po|n)/i]
    };
    matchQuarterPatterns16 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
      wide: /^[1234]\. [čc]tvrtlet[íi]/i
    };
    parseQuarterPatterns16 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns16 = {
      narrow: /^[lúubdkčcszřrlp]/i,
      abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
      wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
    };
    parseMonthPatterns16 = {
      narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
      any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
    };
    matchDayPatterns16 = {
      narrow: /^[npuúsčps]/i,
      short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
      abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
      wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
    };
    parseDayPatterns16 = {
      narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
      any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
    };
    matchDayPeriodPatterns16 = {
      any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
    };
    parseDayPeriodPatterns16 = {
      any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
      }
    };
    match16 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern16,
        parsePattern: parseOrdinalNumberPattern16,
        valueCallback: function valueCallback31(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns16,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns16,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns16,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns16,
        defaultParseWidth: "any",
        valueCallback: function valueCallback32(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns16,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns16,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns16,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns16,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns16,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns16,
        defaultParseWidth: "any"
      })
    };
    match_default16 = match16;
  }
});

// ../../node_modules/date-fns/esm/locale/cs/index.js
var locale16, cs_default;
var init_cs = __esm({
  "../../node_modules/date-fns/esm/locale/cs/index.js"() {
    "use strict";
    init_formatDistance17();
    init_formatLong16();
    init_formatRelative17();
    init_localize16();
    init_match16();
    locale16 = {
      code: "cs",
      formatDistance: formatDistance_default16,
      formatLong: formatLong_default16,
      formatRelative: formatRelative_default16,
      localize: localize_default16,
      match: match_default16,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    cs_default = locale16;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/_lib/formatDistance/index.js
var formatDistanceLocale17, formatDistance34, formatDistance_default17;
var init_formatDistance18 = __esm({
  "../../node_modules/date-fns/esm/locale/cy/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale17 = {
      lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
      },
      xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
      },
      halfAMinute: "hanner munud",
      lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
      },
      xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
      },
      aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
      },
      xHours: {
        one: "1 awr",
        other: "{{count}} awr"
      },
      xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
      },
      aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
      },
      xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
      },
      aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
      },
      xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
      },
      aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
      },
      xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
      },
      overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
      },
      almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
      }
    };
    formatDistance34 = function formatDistance35(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale17[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2 && !!tokenValue.two) {
        result = tokenValue.two;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "mewn " + result;
        } else {
          return result + " yn \xF4l";
        }
      }
      return result;
    };
    formatDistance_default17 = formatDistance34;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/_lib/formatLong/index.js
var dateFormats17, timeFormats17, dateTimeFormats17, formatLong17, formatLong_default17;
var init_formatLong17 = __esm({
  "../../node_modules/date-fns/esm/locale/cy/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats17 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats17 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats17 = {
      full: "{{date}} 'am' {{time}}",
      long: "{{date}} 'am' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong17 = {
      date: buildFormatLongFn({
        formats: dateFormats17,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats17,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats17,
        defaultWidth: "full"
      })
    };
    formatLong_default17 = formatLong17;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/_lib/formatRelative/index.js
var formatRelativeLocale17, formatRelative34, formatRelative_default17;
var init_formatRelative18 = __esm({
  "../../node_modules/date-fns/esm/locale/cy/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale17 = {
      lastWeek: "eeee 'diwethaf am' p",
      yesterday: "'ddoe am' p",
      today: "'heddiw am' p",
      tomorrow: "'yfory am' p",
      nextWeek: "eeee 'am' p",
      other: "P"
    };
    formatRelative34 = function formatRelative35(token, _date, _baseDate, _options) {
      return formatRelativeLocale17[token];
    };
    formatRelative_default17 = formatRelative34;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/_lib/localize/index.js
var eraValues17, quarterValues17, monthValues17, dayValues17, dayPeriodValues17, formattingDayPeriodValues16, ordinalNumber33, localize17, localize_default17;
var init_localize17 = __esm({
  "../../node_modules/date-fns/esm/locale/cy/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues17 = {
      narrow: ["C", "O"],
      abbreviated: ["CC", "OC"],
      wide: ["Cyn Crist", "Ar \xF4l Crist"]
    };
    quarterValues17 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
      wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
    };
    monthValues17 = {
      narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
      abbreviated: ["Ion", "Chwe", "Maw", "Ebr", "Mai", "Meh", "Gor", "Aws", "Med", "Hyd", "Tach", "Rhag"],
      wide: ["Ionawr", "Chwefror", "Mawrth", "Ebrill", "Mai", "Mehefin", "Gorffennaf", "Awst", "Medi", "Hydref", "Tachwedd", "Rhagfyr"]
    };
    dayValues17 = {
      narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
      short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
      abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
      wide: ["dydd Sul", "dydd Llun", "dydd Mawrth", "dydd Mercher", "dydd Iau", "dydd Gwener", "dydd Sadwrn"]
    };
    dayPeriodValues17 = {
      narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
      },
      abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
      },
      wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
      }
    };
    formattingDayPeriodValues16 = {
      narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
      },
      abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
      },
      wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
      }
    };
    ordinalNumber33 = function ordinalNumber34(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      if (number < 20) {
        switch (number) {
          case 0:
            return number + "fed";
          case 1:
            return number + "af";
          case 2:
            return number + "ail";
          case 3:
          case 4:
            return number + "ydd";
          case 5:
          case 6:
            return number + "ed";
          case 7:
          case 8:
          case 9:
          case 10:
          case 12:
          case 15:
          case 18:
            return number + "fed";
          case 11:
          case 13:
          case 14:
          case 16:
          case 17:
          case 19:
            return number + "eg";
        }
      } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
        return number + "fed";
      }
      return number + "ain";
    };
    localize17 = {
      ordinalNumber: ordinalNumber33,
      era: buildLocalizeFn({
        values: eraValues17,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues17,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback17(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues17,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues17,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues17,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues16,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default17 = localize17;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/_lib/match/index.js
var matchOrdinalNumberPattern17, parseOrdinalNumberPattern17, matchEraPatterns17, parseEraPatterns17, matchQuarterPatterns17, parseQuarterPatterns17, matchMonthPatterns17, parseMonthPatterns17, matchDayPatterns17, parseDayPatterns17, matchDayPeriodPatterns17, parseDayPeriodPatterns17, match17, match_default17;
var init_match17 = __esm({
  "../../node_modules/date-fns/esm/locale/cy/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern17 = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
    parseOrdinalNumberPattern17 = /\d+/i;
    matchEraPatterns17 = {
      narrow: /^(c|o)/i,
      abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
      wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
    };
    parseEraPatterns17 = {
      wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
      any: [/^c/i, /^o/i]
    };
    matchQuarterPatterns17 = {
      narrow: /^[1234]/i,
      abbreviated: /^ch[1234]/i,
      wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
    };
    parseQuarterPatterns17 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns17 = {
      narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
      abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
      wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
    };
    parseMonthPatterns17 = {
      narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
      any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
    };
    matchDayPatterns17 = {
      narrow: /^(s|ll|m|i|g)/i,
      short: /^(su|ll|ma|me|ia|gw|sa)/i,
      abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
      wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
    };
    parseDayPatterns17 = {
      narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
      wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
      any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
    };
    matchDayPeriodPatterns17 = {
      narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
      any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
    };
    parseDayPeriodPatterns17 = {
      any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
      }
    };
    match17 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern17,
        parsePattern: parseOrdinalNumberPattern17,
        valueCallback: function valueCallback33(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns17,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns17,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns17,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns17,
        defaultParseWidth: "any",
        valueCallback: function valueCallback34(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns17,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns17,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns17,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns17,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns17,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns17,
        defaultParseWidth: "any"
      })
    };
    match_default17 = match17;
  }
});

// ../../node_modules/date-fns/esm/locale/cy/index.js
var locale17, cy_default;
var init_cy = __esm({
  "../../node_modules/date-fns/esm/locale/cy/index.js"() {
    "use strict";
    init_formatDistance18();
    init_formatLong17();
    init_formatRelative18();
    init_localize17();
    init_match17();
    locale17 = {
      code: "cy",
      formatDistance: formatDistance_default17,
      formatLong: formatLong_default17,
      formatRelative: formatRelative_default17,
      localize: localize_default17,
      match: match_default17,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    cy_default = locale17;
  }
});

// ../../node_modules/date-fns/esm/locale/da/_lib/formatDistance/index.js
var formatDistanceLocale18, formatDistance36, formatDistance_default18;
var init_formatDistance19 = __esm({
  "../../node_modules/date-fns/esm/locale/da/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale18 = {
      lessThanXSeconds: {
        one: "mindre end \xE9t sekund",
        other: "mindre end {{count}} sekunder"
      },
      xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
      },
      halfAMinute: "\xE9t halvt minut",
      lessThanXMinutes: {
        one: "mindre end \xE9t minut",
        other: "mindre end {{count}} minutter"
      },
      xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
      },
      aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
      },
      xHours: {
        one: "1 time",
        other: "{{count}} timer"
      },
      xDays: {
        one: "1 dag",
        other: "{{count}} dage"
      },
      aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
      },
      xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
      },
      aboutXMonths: {
        one: "cirka 1 m\xE5ned",
        other: "cirka {{count}} m\xE5neder"
      },
      xMonths: {
        one: "1 m\xE5ned",
        other: "{{count}} m\xE5neder"
      },
      aboutXYears: {
        one: "cirka 1 \xE5r",
        other: "cirka {{count}} \xE5r"
      },
      xYears: {
        one: "1 \xE5r",
        other: "{{count}} \xE5r"
      },
      overXYears: {
        one: "over 1 \xE5r",
        other: "over {{count}} \xE5r"
      },
      almostXYears: {
        one: "n\xE6sten 1 \xE5r",
        other: "n\xE6sten {{count}} \xE5r"
      }
    };
    formatDistance36 = function formatDistance37(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale18[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "om " + result;
        } else {
          return result + " siden";
        }
      }
      return result;
    };
    formatDistance_default18 = formatDistance36;
  }
});

// ../../node_modules/date-fns/esm/locale/da/_lib/formatLong/index.js
var dateFormats18, timeFormats18, dateTimeFormats18, formatLong18, formatLong_default18;
var init_formatLong18 = __esm({
  "../../node_modules/date-fns/esm/locale/da/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats18 = {
      full: "EEEE 'den' d. MMMM y",
      long: "d. MMMM y",
      medium: "d. MMM y",
      short: "dd/MM/y"
    };
    timeFormats18 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats18 = {
      full: "{{date}} 'kl'. {{time}}",
      long: "{{date}} 'kl'. {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong18 = {
      date: buildFormatLongFn({
        formats: dateFormats18,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats18,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats18,
        defaultWidth: "full"
      })
    };
    formatLong_default18 = formatLong18;
  }
});

// ../../node_modules/date-fns/esm/locale/da/_lib/formatRelative/index.js
var formatRelativeLocale18, formatRelative36, formatRelative_default18;
var init_formatRelative19 = __esm({
  "../../node_modules/date-fns/esm/locale/da/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale18 = {
      lastWeek: "'sidste' eeee 'kl.' p",
      yesterday: "'i g\xE5r kl.' p",
      today: "'i dag kl.' p",
      tomorrow: "'i morgen kl.' p",
      nextWeek: "'p\xE5' eeee 'kl.' p",
      other: "P"
    };
    formatRelative36 = function formatRelative37(token, _date, _baseDate, _options) {
      return formatRelativeLocale18[token];
    };
    formatRelative_default18 = formatRelative36;
  }
});

// ../../node_modules/date-fns/esm/locale/da/_lib/localize/index.js
var eraValues18, quarterValues18, monthValues18, dayValues18, dayPeriodValues18, formattingDayPeriodValues17, ordinalNumber35, localize18, localize_default18;
var init_localize18 = __esm({
  "../../node_modules/date-fns/esm/locale/da/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues18 = {
      narrow: ["fvt", "vt"],
      abbreviated: ["f.v.t.", "v.t."],
      wide: ["f\xF8r vesterlandsk tidsregning", "vesterlandsk tidsregning"]
    };
    quarterValues18 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues18 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
      wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
    };
    dayValues18 = {
      narrow: ["S", "M", "T", "O", "T", "F", "L"],
      short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
      abbreviated: ["s\xF8n.", "man.", "tir.", "ons.", "tor.", "fre.", "l\xF8r."],
      wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
    };
    dayPeriodValues18 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
      }
    };
    formattingDayPeriodValues17 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
      }
    };
    ordinalNumber35 = function ordinalNumber36(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize18 = {
      ordinalNumber: ordinalNumber35,
      era: buildLocalizeFn({
        values: eraValues18,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues18,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback18(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues18,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues18,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues18,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues17,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default18 = localize18;
  }
});

// ../../node_modules/date-fns/esm/locale/da/_lib/match/index.js
var matchOrdinalNumberPattern18, parseOrdinalNumberPattern18, matchEraPatterns18, parseEraPatterns18, matchQuarterPatterns18, parseQuarterPatterns18, matchMonthPatterns18, parseMonthPatterns18, matchDayPatterns18, parseDayPatterns18, matchDayPeriodPatterns18, parseDayPeriodPatterns18, match18, match_default18;
var init_match18 = __esm({
  "../../node_modules/date-fns/esm/locale/da/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern18 = /^(\d+)(\.)?/i;
    parseOrdinalNumberPattern18 = /\d+/i;
    matchEraPatterns18 = {
      narrow: /^(fKr|fvt|eKr|vt)/i,
      abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
      wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
    };
    parseEraPatterns18 = {
      any: [/^f/i, /^(v|e)/i]
    };
    matchQuarterPatterns18 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]. kvt\./i,
      wide: /^[1234]\.? kvartal/i
    };
    parseQuarterPatterns18 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns18 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
      wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
    };
    parseMonthPatterns18 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns18 = {
      narrow: /^[smtofl]/i,
      short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
      abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
      wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
    };
    parseDayPatterns18 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
      any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
    };
    matchDayPeriodPatterns18 = {
      narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
      any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
    };
    parseDayPeriodPatterns18 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
      }
    };
    match18 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern18,
        parsePattern: parseOrdinalNumberPattern18,
        valueCallback: function valueCallback35(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns18,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns18,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns18,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns18,
        defaultParseWidth: "any",
        valueCallback: function valueCallback36(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns18,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns18,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns18,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns18,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns18,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns18,
        defaultParseWidth: "any"
      })
    };
    match_default18 = match18;
  }
});

// ../../node_modules/date-fns/esm/locale/da/index.js
var locale18, da_default;
var init_da = __esm({
  "../../node_modules/date-fns/esm/locale/da/index.js"() {
    "use strict";
    init_formatDistance19();
    init_formatLong18();
    init_formatRelative19();
    init_localize18();
    init_match18();
    locale18 = {
      code: "da",
      formatDistance: formatDistance_default18,
      formatLong: formatLong_default18,
      formatRelative: formatRelative_default18,
      localize: localize_default18,
      match: match_default18,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    da_default = locale18;
  }
});

// ../../node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js
var formatDistanceLocale19, formatDistance38, formatDistance_default19;
var init_formatDistance20 = __esm({
  "../../node_modules/date-fns/esm/locale/de/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale19 = {
      lessThanXSeconds: {
        standalone: {
          one: "weniger als 1 Sekunde",
          other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
          one: "weniger als 1 Sekunde",
          other: "weniger als {{count}} Sekunden"
        }
      },
      xSeconds: {
        standalone: {
          one: "1 Sekunde",
          other: "{{count}} Sekunden"
        },
        withPreposition: {
          one: "1 Sekunde",
          other: "{{count}} Sekunden"
        }
      },
      halfAMinute: {
        standalone: "halbe Minute",
        withPreposition: "halben Minute"
      },
      lessThanXMinutes: {
        standalone: {
          one: "weniger als 1 Minute",
          other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
          one: "weniger als 1 Minute",
          other: "weniger als {{count}} Minuten"
        }
      },
      xMinutes: {
        standalone: {
          one: "1 Minute",
          other: "{{count}} Minuten"
        },
        withPreposition: {
          one: "1 Minute",
          other: "{{count}} Minuten"
        }
      },
      aboutXHours: {
        standalone: {
          one: "etwa 1 Stunde",
          other: "etwa {{count}} Stunden"
        },
        withPreposition: {
          one: "etwa 1 Stunde",
          other: "etwa {{count}} Stunden"
        }
      },
      xHours: {
        standalone: {
          one: "1 Stunde",
          other: "{{count}} Stunden"
        },
        withPreposition: {
          one: "1 Stunde",
          other: "{{count}} Stunden"
        }
      },
      xDays: {
        standalone: {
          one: "1 Tag",
          other: "{{count}} Tage"
        },
        withPreposition: {
          one: "1 Tag",
          other: "{{count}} Tagen"
        }
      },
      aboutXWeeks: {
        standalone: {
          one: "etwa 1 Woche",
          other: "etwa {{count}} Wochen"
        },
        withPreposition: {
          one: "etwa 1 Woche",
          other: "etwa {{count}} Wochen"
        }
      },
      xWeeks: {
        standalone: {
          one: "1 Woche",
          other: "{{count}} Wochen"
        },
        withPreposition: {
          one: "1 Woche",
          other: "{{count}} Wochen"
        }
      },
      aboutXMonths: {
        standalone: {
          one: "etwa 1 Monat",
          other: "etwa {{count}} Monate"
        },
        withPreposition: {
          one: "etwa 1 Monat",
          other: "etwa {{count}} Monaten"
        }
      },
      xMonths: {
        standalone: {
          one: "1 Monat",
          other: "{{count}} Monate"
        },
        withPreposition: {
          one: "1 Monat",
          other: "{{count}} Monaten"
        }
      },
      aboutXYears: {
        standalone: {
          one: "etwa 1 Jahr",
          other: "etwa {{count}} Jahre"
        },
        withPreposition: {
          one: "etwa 1 Jahr",
          other: "etwa {{count}} Jahren"
        }
      },
      xYears: {
        standalone: {
          one: "1 Jahr",
          other: "{{count}} Jahre"
        },
        withPreposition: {
          one: "1 Jahr",
          other: "{{count}} Jahren"
        }
      },
      overXYears: {
        standalone: {
          one: "mehr als 1 Jahr",
          other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
          one: "mehr als 1 Jahr",
          other: "mehr als {{count}} Jahren"
        }
      },
      almostXYears: {
        standalone: {
          one: "fast 1 Jahr",
          other: "fast {{count}} Jahre"
        },
        withPreposition: {
          one: "fast 1 Jahr",
          other: "fast {{count}} Jahren"
        }
      }
    };
    formatDistance38 = function formatDistance39(token, count, options) {
      var result;
      var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale19[token].withPreposition : formatDistanceLocale19[token].standalone;
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "in " + result;
        } else {
          return "vor " + result;
        }
      }
      return result;
    };
    formatDistance_default19 = formatDistance38;
  }
});

// ../../node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js
var dateFormats19, timeFormats19, dateTimeFormats19, formatLong19, formatLong_default19;
var init_formatLong19 = __esm({
  "../../node_modules/date-fns/esm/locale/de/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats19 = {
      full: "EEEE, do MMMM y",
      // Montag, 7. Januar 2018
      long: "do MMMM y",
      // 7. Januar 2018
      medium: "do MMM y",
      // 7. Jan. 2018
      short: "dd.MM.y"
      // 07.01.2018
    };
    timeFormats19 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats19 = {
      full: "{{date}} 'um' {{time}}",
      long: "{{date}} 'um' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong19 = {
      date: buildFormatLongFn({
        formats: dateFormats19,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats19,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats19,
        defaultWidth: "full"
      })
    };
    formatLong_default19 = formatLong19;
  }
});

// ../../node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js
var formatRelativeLocale19, formatRelative38, formatRelative_default19;
var init_formatRelative20 = __esm({
  "../../node_modules/date-fns/esm/locale/de/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale19 = {
      lastWeek: "'letzten' eeee 'um' p",
      yesterday: "'gestern um' p",
      today: "'heute um' p",
      tomorrow: "'morgen um' p",
      nextWeek: "eeee 'um' p",
      other: "P"
    };
    formatRelative38 = function formatRelative39(token, _date, _baseDate, _options) {
      return formatRelativeLocale19[token];
    };
    formatRelative_default19 = formatRelative38;
  }
});

// ../../node_modules/date-fns/esm/locale/de/_lib/localize/index.js
var eraValues19, quarterValues19, monthValues19, formattingMonthValues5, dayValues19, dayPeriodValues19, formattingDayPeriodValues18, ordinalNumber37, localize19, localize_default19;
var init_localize19 = __esm({
  "../../node_modules/date-fns/esm/locale/de/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues19 = {
      narrow: ["v.Chr.", "n.Chr."],
      abbreviated: ["v.Chr.", "n.Chr."],
      wide: ["vor Christus", "nach Christus"]
    };
    quarterValues19 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
    };
    monthValues19 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      wide: ["Januar", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
    };
    formattingMonthValues5 = {
      narrow: monthValues19.narrow,
      abbreviated: ["Jan.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
      wide: monthValues19.wide
    };
    dayValues19 = {
      narrow: ["S", "M", "D", "M", "D", "F", "S"],
      short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
      wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
    };
    dayPeriodValues19 = {
      narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
      },
      abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
      },
      wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
      }
    };
    formattingDayPeriodValues18 = {
      narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
      },
      abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
      },
      wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
      }
    };
    ordinalNumber37 = function ordinalNumber38(dirtyNumber) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize19 = {
      ordinalNumber: ordinalNumber37,
      era: buildLocalizeFn({
        values: eraValues19,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues19,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback19(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues19,
        formattingValues: formattingMonthValues5,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues19,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues19,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues18,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default19 = localize19;
  }
});

// ../../node_modules/date-fns/esm/locale/de/_lib/match/index.js
var matchOrdinalNumberPattern19, parseOrdinalNumberPattern19, matchEraPatterns19, parseEraPatterns19, matchQuarterPatterns19, parseQuarterPatterns19, matchMonthPatterns19, parseMonthPatterns19, matchDayPatterns19, parseDayPatterns19, matchDayPeriodPatterns19, parseDayPeriodPatterns19, match19, match_default19;
var init_match19 = __esm({
  "../../node_modules/date-fns/esm/locale/de/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern19 = /^(\d+)(\.)?/i;
    parseOrdinalNumberPattern19 = /\d+/i;
    matchEraPatterns19 = {
      narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
      abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
      wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
    };
    parseEraPatterns19 = {
      any: [/^v/i, /^n/i]
    };
    matchQuarterPatterns19 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](\.)? Quartal/i
    };
    parseQuarterPatterns19 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns19 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
      wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
    };
    parseMonthPatterns19 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns19 = {
      narrow: /^[smdmf]/i,
      short: /^(so|mo|di|mi|do|fr|sa)/i,
      abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
      wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
    };
    parseDayPatterns19 = {
      any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns19 = {
      narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
      abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
      wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
    };
    parseDayPeriodPatterns19 = {
      any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i
        // will never be matched. Night is matched by `pm`
      }
    };
    match19 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern19,
        parsePattern: parseOrdinalNumberPattern19,
        valueCallback: function valueCallback37(value) {
          return parseInt(value);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns19,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns19,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns19,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns19,
        defaultParseWidth: "any",
        valueCallback: function valueCallback38(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns19,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns19,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns19,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns19,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns19,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns19,
        defaultParseWidth: "any"
      })
    };
    match_default19 = match19;
  }
});

// ../../node_modules/date-fns/esm/locale/de/index.js
var locale19, de_default;
var init_de = __esm({
  "../../node_modules/date-fns/esm/locale/de/index.js"() {
    "use strict";
    init_formatDistance20();
    init_formatLong19();
    init_formatRelative20();
    init_localize19();
    init_match19();
    locale19 = {
      code: "de",
      formatDistance: formatDistance_default19,
      formatLong: formatLong_default19,
      formatRelative: formatRelative_default19,
      localize: localize_default19,
      match: match_default19,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    de_default = locale19;
  }
});

// ../../node_modules/date-fns/esm/locale/de-AT/_lib/localize/index.js
var eraValues20, quarterValues20, monthValues20, formattingMonthValues6, dayValues20, dayPeriodValues20, formattingDayPeriodValues19, ordinalNumber39, localize20, localize_default20;
var init_localize20 = __esm({
  "../../node_modules/date-fns/esm/locale/de-AT/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues20 = {
      narrow: ["v.Chr.", "n.Chr."],
      abbreviated: ["v.Chr.", "n.Chr."],
      wide: ["vor Christus", "nach Christus"]
    };
    quarterValues20 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
    };
    monthValues20 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["J\xE4n", "Feb", "M\xE4r", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      wide: ["J\xE4nner", "Februar", "M\xE4rz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
    };
    formattingMonthValues6 = {
      narrow: monthValues20.narrow,
      abbreviated: ["J\xE4n.", "Feb.", "M\xE4rz", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
      wide: monthValues20.wide
    };
    dayValues20 = {
      narrow: ["S", "M", "D", "M", "D", "F", "S"],
      short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
      abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
      wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
    };
    dayPeriodValues20 = {
      narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
      },
      abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
      },
      wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
      }
    };
    formattingDayPeriodValues19 = {
      narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
      },
      abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
      },
      wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
      }
    };
    ordinalNumber39 = function ordinalNumber40(dirtyNumber) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize20 = {
      ordinalNumber: ordinalNumber39,
      era: buildLocalizeFn({
        values: eraValues20,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues20,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback20(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues20,
        formattingValues: formattingMonthValues6,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues20,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues20,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues19,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default20 = localize20;
  }
});

// ../../node_modules/date-fns/esm/locale/de-AT/index.js
var locale20, de_AT_default;
var init_de_AT = __esm({
  "../../node_modules/date-fns/esm/locale/de-AT/index.js"() {
    "use strict";
    init_formatDistance20();
    init_formatLong19();
    init_formatRelative20();
    init_match19();
    init_localize20();
    locale20 = {
      code: "de-AT",
      formatDistance: formatDistance_default19,
      formatLong: formatLong_default19,
      formatRelative: formatRelative_default19,
      localize: localize_default20,
      match: match_default19,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    de_AT_default = locale20;
  }
});

// ../../node_modules/date-fns/esm/locale/el/_lib/formatDistance/index.js
var formatDistanceLocale20, formatDistance40, formatDistance_default20;
var init_formatDistance21 = __esm({
  "../../node_modules/date-fns/esm/locale/el/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale20 = {
      lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
      },
      xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
      },
      halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
      lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
      },
      xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
      },
      aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
      },
      xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
      },
      xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
      },
      aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
      },
      xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
      },
      aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
      },
      xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
      },
      aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
      },
      xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
      },
      overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
      },
      almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
      }
    };
    formatDistance40 = function formatDistance41(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale20[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u03C3\u03B5 " + result;
        } else {
          return result + " \u03C0\u03C1\u03B9\u03BD";
        }
      }
      return result;
    };
    formatDistance_default20 = formatDistance40;
  }
});

// ../../node_modules/date-fns/esm/locale/el/_lib/formatLong/index.js
var dateFormats20, timeFormats20, dateTimeFormats20, formatLong20, formatLong_default20;
var init_formatLong20 = __esm({
  "../../node_modules/date-fns/esm/locale/el/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats20 = {
      full: "EEEE, d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "d/M/yy"
    };
    timeFormats20 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats20 = {
      full: "{{date}} - {{time}}",
      long: "{{date}} - {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong20 = {
      date: buildFormatLongFn({
        formats: dateFormats20,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats20,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats20,
        defaultWidth: "full"
      })
    };
    formatLong_default20 = formatLong20;
  }
});

// ../../node_modules/date-fns/esm/locale/el/_lib/formatRelative/index.js
var formatRelativeLocale20, formatRelative40, formatRelative_default20;
var init_formatRelative21 = __esm({
  "../../node_modules/date-fns/esm/locale/el/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale20 = {
      lastWeek: function lastWeek5(date) {
        switch (date.getUTCDay()) {
          case 6:
            return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
          default:
            return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
      },
      yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
      today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
      tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
      nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
      other: "P"
    };
    formatRelative40 = function formatRelative41(token, date) {
      var format2 = formatRelativeLocale20[token];
      if (typeof format2 === "function") return format2(date);
      return format2;
    };
    formatRelative_default20 = formatRelative40;
  }
});

// ../../node_modules/date-fns/esm/locale/el/_lib/localize/index.js
var eraValues21, quarterValues21, monthValues21, formattingMonthValues7, dayValues21, dayPeriodValues21, ordinalNumber41, localize21, localize_default21;
var init_localize21 = __esm({
  "../../node_modules/date-fns/esm/locale/el/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues21 = {
      narrow: ["\u03C0\u03A7", "\u03BC\u03A7"],
      abbreviated: ["\u03C0.\u03A7.", "\u03BC.\u03A7."],
      wide: ["\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD", "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"]
    };
    quarterValues21 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u03A41", "\u03A42", "\u03A43", "\u03A44"],
      wide: ["1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF", "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"]
    };
    monthValues21 = {
      narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
      abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03AC\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03AC\u03B9", "\u0399\u03BF\u03CD\u03BD", "\u0399\u03BF\u03CD\u03BB", "\u0391\u03CD\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03AD", "\u0394\u03B5\u03BA"],
      wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2", "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2", "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2", "\u039C\u03AC\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2", "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2", "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2", "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2", "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2", "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"]
    };
    formattingMonthValues7 = {
      narrow: ["\u0399", "\u03A6", "\u039C", "\u0391", "\u039C", "\u0399", "\u0399", "\u0391", "\u03A3", "\u039F", "\u039D", "\u0394"],
      abbreviated: ["\u0399\u03B1\u03BD", "\u03A6\u03B5\u03B2", "\u039C\u03B1\u03C1", "\u0391\u03C0\u03C1", "\u039C\u03B1\u0390", "\u0399\u03BF\u03C5\u03BD", "\u0399\u03BF\u03C5\u03BB", "\u0391\u03C5\u03B3", "\u03A3\u03B5\u03C0", "\u039F\u03BA\u03C4", "\u039D\u03BF\u03B5", "\u0394\u03B5\u03BA"],
      wide: ["\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5", "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5", "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5", "\u039C\u03B1\u0390\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5", "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5", "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5", "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5", "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5", "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"]
    };
    dayValues21 = {
      narrow: ["\u039A", "\u0394", "T", "\u03A4", "\u03A0", "\u03A0", "\u03A3"],
      short: ["\u039A\u03C5", "\u0394\u03B5", "\u03A4\u03C1", "\u03A4\u03B5", "\u03A0\u03AD", "\u03A0\u03B1", "\u03A3\u03AC"],
      abbreviated: ["\u039A\u03C5\u03C1", "\u0394\u03B5\u03C5", "\u03A4\u03C1\u03AF", "\u03A4\u03B5\u03C4", "\u03A0\u03AD\u03BC", "\u03A0\u03B1\u03C1", "\u03A3\u03AC\u03B2"],
      wide: ["\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE", "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1", "\u03A4\u03C1\u03AF\u03C4\u03B7", "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7", "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7", "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE", "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"]
    };
    dayPeriodValues21 = {
      narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
      },
      abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
      },
      wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
      }
    };
    ordinalNumber41 = function ordinalNumber42(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      var suffix;
      if (unit === "year" || unit === "month") {
        suffix = "\u03BF\u03C2";
      } else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") {
        suffix = "\u03B7";
      } else {
        suffix = "\u03BF";
      }
      return number + suffix;
    };
    localize21 = {
      ordinalNumber: ordinalNumber41,
      era: buildLocalizeFn({
        values: eraValues21,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues21,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback21(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues21,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues7,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues21,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues21,
        defaultWidth: "wide"
      })
    };
    localize_default21 = localize21;
  }
});

// ../../node_modules/date-fns/esm/locale/el/_lib/match/index.js
var matchOrdinalNumberPattern20, parseOrdinalNumberPattern20, matchEraPatterns20, parseEraPatterns20, matchQuarterPatterns20, parseQuarterPatterns20, matchMonthPatterns20, parseMonthPatterns20, matchDayPatterns20, parseDayPatterns20, matchDayPeriodPatterns20, parseDayPeriodPatterns20, match20, match_default20;
var init_match20 = __esm({
  "../../node_modules/date-fns/esm/locale/el/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern20 = /^(\d+)(ος|η|ο)?/i;
    parseOrdinalNumberPattern20 = /\d+/i;
    matchEraPatterns20 = {
      narrow: /^(πΧ|μΧ)/i,
      abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
      wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
    };
    parseEraPatterns20 = {
      any: [/^π/i, /^(μ|κ)/i]
    };
    matchQuarterPatterns20 = {
      narrow: /^[1234]/i,
      abbreviated: /^τ[1234]/i,
      wide: /^[1234]ο? τρ(ί|ι)μηνο/i
    };
    parseQuarterPatterns20 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns20 = {
      narrow: /^[ιφμαμιιασονδ]/i,
      abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
      wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
    };
    parseMonthPatterns20 = {
      narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
      any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
    };
    matchDayPatterns20 = {
      narrow: /^[κδτπσ]/i,
      short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
      abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
      wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
    };
    parseDayPatterns20 = {
      narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
      any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
    };
    matchDayPeriodPatterns20 = {
      narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
      any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
    };
    parseDayPeriodPatterns20 = {
      any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
      }
    };
    match20 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern20,
        parsePattern: parseOrdinalNumberPattern20,
        valueCallback: function valueCallback39(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns20,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns20,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns20,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns20,
        defaultParseWidth: "any",
        valueCallback: function valueCallback40(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns20,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns20,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns20,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns20,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns20,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns20,
        defaultParseWidth: "any"
      })
    };
    match_default20 = match20;
  }
});

// ../../node_modules/date-fns/esm/locale/el/index.js
var locale21, el_default;
var init_el = __esm({
  "../../node_modules/date-fns/esm/locale/el/index.js"() {
    "use strict";
    init_formatDistance21();
    init_formatLong20();
    init_formatRelative21();
    init_localize21();
    init_match20();
    locale21 = {
      code: "el",
      formatDistance: formatDistance_default20,
      formatLong: formatLong_default20,
      formatRelative: formatRelative_default20,
      localize: localize_default21,
      match: match_default20,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    el_default = locale21;
  }
});

// ../../node_modules/date-fns/esm/locale/en-AU/_lib/formatLong/index.js
var dateFormats21, timeFormats21, dateTimeFormats21, formatLong21, formatLong_default21;
var init_formatLong21 = __esm({
  "../../node_modules/date-fns/esm/locale/en-AU/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats21 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats21 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats21 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong21 = {
      date: buildFormatLongFn({
        formats: dateFormats21,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats21,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats21,
        defaultWidth: "full"
      })
    };
    formatLong_default21 = formatLong21;
  }
});

// ../../node_modules/date-fns/esm/locale/en-AU/index.js
var locale22, en_AU_default;
var init_en_AU = __esm({
  "../../node_modules/date-fns/esm/locale/en-AU/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatLong21();
    init_formatRelative();
    init_localize();
    init_match();
    locale22 = {
      code: "en-AU",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default21,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    en_AU_default = locale22;
  }
});

// ../../node_modules/date-fns/esm/locale/en-CA/_lib/formatDistance/index.js
var formatDistanceLocale21, formatDistance42, formatDistance_default21;
var init_formatDistance22 = __esm({
  "../../node_modules/date-fns/esm/locale/en-CA/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale21 = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "an hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "a day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "a month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "a year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over a year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
      }
    };
    formatDistance42 = function formatDistance43(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale21[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "in " + result;
        } else {
          return result + " ago";
        }
      }
      return result;
    };
    formatDistance_default21 = formatDistance42;
  }
});

// ../../node_modules/date-fns/esm/locale/en-CA/_lib/formatLong/index.js
var dateFormats22, timeFormats22, dateTimeFormats22, formatLong22, formatLong_default22;
var init_formatLong22 = __esm({
  "../../node_modules/date-fns/esm/locale/en-CA/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats22 = {
      full: "EEEE, MMMM do, yyyy",
      long: "MMMM do, yyyy",
      medium: "MMM d, yyyy",
      short: "yyyy-MM-dd"
    };
    timeFormats22 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats22 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong22 = {
      date: buildFormatLongFn({
        formats: dateFormats22,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats22,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats22,
        defaultWidth: "full"
      })
    };
    formatLong_default22 = formatLong22;
  }
});

// ../../node_modules/date-fns/esm/locale/en-CA/index.js
var locale23, en_CA_default;
var init_en_CA = __esm({
  "../../node_modules/date-fns/esm/locale/en-CA/index.js"() {
    "use strict";
    init_formatRelative();
    init_localize();
    init_match();
    init_formatDistance22();
    init_formatLong22();
    locale23 = {
      code: "en-CA",
      formatDistance: formatDistance_default21,
      formatLong: formatLong_default22,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    en_CA_default = locale23;
  }
});

// ../../node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js
var dateFormats23, timeFormats23, dateTimeFormats23, formatLong23, formatLong_default23;
var init_formatLong23 = __esm({
  "../../node_modules/date-fns/esm/locale/en-GB/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats23 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats23 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats23 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong23 = {
      date: buildFormatLongFn({
        formats: dateFormats23,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats23,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats23,
        defaultWidth: "full"
      })
    };
    formatLong_default23 = formatLong23;
  }
});

// ../../node_modules/date-fns/esm/locale/en-GB/index.js
var locale24, en_GB_default;
var init_en_GB = __esm({
  "../../node_modules/date-fns/esm/locale/en-GB/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatRelative();
    init_localize();
    init_match();
    init_formatLong23();
    locale24 = {
      code: "en-GB",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default23,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    en_GB_default = locale24;
  }
});

// ../../node_modules/date-fns/esm/locale/en-IE/index.js
var locale25, en_IE_default;
var init_en_IE = __esm({
  "../../node_modules/date-fns/esm/locale/en-IE/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatRelative();
    init_localize();
    init_match();
    init_formatLong23();
    locale25 = {
      code: "en-IE",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default23,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    en_IE_default = locale25;
  }
});

// ../../node_modules/date-fns/esm/locale/en-IN/_lib/formatLong/index.js
var dateFormats24, timeFormats24, dateTimeFormats24, formatLong24, formatLong_default24;
var init_formatLong24 = __esm({
  "../../node_modules/date-fns/esm/locale/en-IN/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats24 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM, yyyy",
      medium: "d MMM, yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats24 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats24 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong24 = {
      date: buildFormatLongFn({
        formats: dateFormats24,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats24,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats24,
        defaultWidth: "full"
      })
    };
    formatLong_default24 = formatLong24;
  }
});

// ../../node_modules/date-fns/esm/locale/en-IN/index.js
var locale26, en_IN_default;
var init_en_IN = __esm({
  "../../node_modules/date-fns/esm/locale/en-IN/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatRelative();
    init_localize();
    init_match();
    init_formatLong24();
    locale26 = {
      code: "en-IN",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default24,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4
        // The week that contains Jan 4th is the first week of the year.
      }
    };
    en_IN_default = locale26;
  }
});

// ../../node_modules/date-fns/esm/locale/en-NZ/_lib/formatLong/index.js
var dateFormats25, timeFormats25, dateTimeFormats25, formatLong25, formatLong_default25;
var init_formatLong25 = __esm({
  "../../node_modules/date-fns/esm/locale/en-NZ/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats25 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats25 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats25 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong25 = {
      date: buildFormatLongFn({
        formats: dateFormats25,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats25,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats25,
        defaultWidth: "full"
      })
    };
    formatLong_default25 = formatLong25;
  }
});

// ../../node_modules/date-fns/esm/locale/en-NZ/index.js
var locale27, en_NZ_default;
var init_en_NZ = __esm({
  "../../node_modules/date-fns/esm/locale/en-NZ/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatRelative();
    init_localize();
    init_match();
    init_formatLong25();
    locale27 = {
      code: "en-NZ",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default25,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    en_NZ_default = locale27;
  }
});

// ../../node_modules/date-fns/esm/locale/en-ZA/_lib/formatLong/index.js
var dateFormats26, timeFormats26, dateTimeFormats26, formatLong26, formatLong_default26;
var init_formatLong26 = __esm({
  "../../node_modules/date-fns/esm/locale/en-ZA/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats26 = {
      full: "EEEE, dd MMMM yyyy",
      long: "dd MMMM yyyy",
      medium: "dd MMM yyyy",
      short: "yyyy/MM/dd"
    };
    timeFormats26 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats26 = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong26 = {
      date: buildFormatLongFn({
        formats: dateFormats26,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats26,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats26,
        defaultWidth: "full"
      })
    };
    formatLong_default26 = formatLong26;
  }
});

// ../../node_modules/date-fns/esm/locale/en-ZA/index.js
var locale28, en_ZA_default;
var init_en_ZA = __esm({
  "../../node_modules/date-fns/esm/locale/en-ZA/index.js"() {
    "use strict";
    init_formatDistance();
    init_formatRelative();
    init_localize();
    init_match();
    init_formatLong26();
    locale28 = {
      code: "en-ZA",
      formatDistance: formatDistance_default,
      formatLong: formatLong_default26,
      formatRelative: formatRelative_default,
      localize: localize_default,
      match: match_default,
      options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1
        // The week that contains Jan 1st is the first week of the year.
      }
    };
    en_ZA_default = locale28;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/_lib/formatDistance/index.js
var formatDistanceLocale22, formatDistance44, formatDistance_default22;
var init_formatDistance23 = __esm({
  "../../node_modules/date-fns/esm/locale/eo/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale22 = {
      lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
      },
      xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
      },
      halfAMinute: "duonminuto",
      lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
      },
      xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
      },
      aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
      },
      xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
      },
      xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
      },
      aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
      },
      xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
      },
      aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
      },
      xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
      },
      aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
      },
      xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
      },
      overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
      },
      almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
      }
    };
    formatDistance44 = function formatDistance45(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale22[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) {
          return "post " + result;
        } else {
          return "anta\u016D " + result;
        }
      }
      return result;
    };
    formatDistance_default22 = formatDistance44;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/_lib/formatLong/index.js
var dateFormats27, timeFormats27, dateTimeFormats27, formatLong27, formatLong_default27;
var init_formatLong27 = __esm({
  "../../node_modules/date-fns/esm/locale/eo/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats27 = {
      full: "EEEE, do 'de' MMMM y",
      long: "y-MMMM-dd",
      medium: "y-MMM-dd",
      short: "yyyy-MM-dd"
    };
    timeFormats27 = {
      full: "Ho 'horo kaj' m:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats27 = {
      any: "{{date}} {{time}}"
    };
    formatLong27 = {
      date: buildFormatLongFn({
        formats: dateFormats27,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats27,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats27,
        defaultWidth: "any"
      })
    };
    formatLong_default27 = formatLong27;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/_lib/formatRelative/index.js
var formatRelativeLocale21, formatRelative42, formatRelative_default21;
var init_formatRelative22 = __esm({
  "../../node_modules/date-fns/esm/locale/eo/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale21 = {
      lastWeek: "'pasinta' eeee 'je' p",
      yesterday: "'hiera\u016D je' p",
      today: "'hodia\u016D je' p",
      tomorrow: "'morga\u016D je' p",
      nextWeek: "eeee 'je' p",
      other: "P"
    };
    formatRelative42 = function formatRelative43(token, _date, _baseDate, _options) {
      return formatRelativeLocale21[token];
    };
    formatRelative_default21 = formatRelative42;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/_lib/localize/index.js
var eraValues22, quarterValues22, monthValues22, dayValues22, dayPeriodValues22, ordinalNumber43, localize22, localize_default22;
var init_localize22 = __esm({
  "../../node_modules/date-fns/esm/locale/eo/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues22 = {
      narrow: ["aK", "pK"],
      abbreviated: ["a.K.E.", "p.K.E."],
      wide: ["anta\u016D Komuna Erao", "Komuna Erao"]
    };
    quarterValues22 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1-a kvaronjaro", "2-a kvaronjaro", "3-a kvaronjaro", "4-a kvaronjaro"]
    };
    monthValues22 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "a\u016Dg", "sep", "okt", "nov", "dec"],
      wide: ["januaro", "februaro", "marto", "aprilo", "majo", "junio", "julio", "a\u016Dgusto", "septembro", "oktobro", "novembro", "decembro"]
    };
    dayValues22 = {
      narrow: ["D", "L", "M", "M", "\u0134", "V", "S"],
      short: ["di", "lu", "ma", "me", "\u0135a", "ve", "sa"],
      abbreviated: ["dim", "lun", "mar", "mer", "\u0135a\u016D", "ven", "sab"],
      wide: ["diman\u0109o", "lundo", "mardo", "merkredo", "\u0135a\u016Ddo", "vendredo", "sabato"]
    };
    dayPeriodValues22 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
      },
      abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
      },
      wide: {
        am: "anta\u016Dtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
      }
    };
    ordinalNumber43 = function ordinalNumber44(dirtyNumber) {
      var number = Number(dirtyNumber);
      return number + "-a";
    };
    localize22 = {
      ordinalNumber: ordinalNumber43,
      era: buildLocalizeFn({
        values: eraValues22,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues22,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback22(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues22,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues22,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues22,
        defaultWidth: "wide"
      })
    };
    localize_default22 = localize22;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/_lib/match/index.js
var matchOrdinalNumberPattern21, parseOrdinalNumberPattern21, matchEraPatterns21, parseEraPatterns21, matchQuarterPatterns21, parseQuarterPatterns21, matchMonthPatterns21, parseMonthPatterns21, matchDayPatterns21, parseDayPatterns21, matchDayPeriodPatterns21, parseDayPeriodPatterns21, match21, match_default21;
var init_match21 = __esm({
  "../../node_modules/date-fns/esm/locale/eo/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern21 = /^(\d+)(-?a)?/i;
    parseOrdinalNumberPattern21 = /\d+/i;
    matchEraPatterns21 = {
      narrow: /^([ap]k)/i,
      abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
      wide: /^((antaǔ |post )?komuna erao)/i
    };
    parseEraPatterns21 = {
      any: [/^a/i, /^[kp]/i]
    };
    matchQuarterPatterns21 = {
      narrow: /^[1234]/i,
      abbreviated: /^k[1234]/i,
      wide: /^[1234](-?a)? kvaronjaro/i
    };
    parseQuarterPatterns21 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns21 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
      wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
    };
    parseMonthPatterns21 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns21 = {
      narrow: /^[dlmĵjvs]/i,
      short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
      abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
      wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
    };
    parseDayPatterns21 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
      any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
    };
    matchDayPeriodPatterns21 = {
      narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
      abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
      wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
    };
    parseDayPeriodPatterns21 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
      }
    };
    match21 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern21,
        parsePattern: parseOrdinalNumberPattern21,
        valueCallback: function valueCallback41(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns21,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns21,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns21,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns21,
        defaultParseWidth: "any",
        valueCallback: function valueCallback42(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns21,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns21,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns21,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns21,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns21,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns21,
        defaultParseWidth: "any"
      })
    };
    match_default21 = match21;
  }
});

// ../../node_modules/date-fns/esm/locale/eo/index.js
var locale29, eo_default;
var init_eo = __esm({
  "../../node_modules/date-fns/esm/locale/eo/index.js"() {
    "use strict";
    init_formatDistance23();
    init_formatLong27();
    init_formatRelative22();
    init_localize22();
    init_match21();
    locale29 = {
      code: "eo",
      formatDistance: formatDistance_default22,
      formatLong: formatLong_default27,
      formatRelative: formatRelative_default21,
      localize: localize_default22,
      match: match_default21,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    eo_default = locale29;
  }
});

// ../../node_modules/date-fns/esm/locale/es/_lib/formatDistance/index.js
var formatDistanceLocale23, formatDistance46, formatDistance_default23;
var init_formatDistance24 = __esm({
  "../../node_modules/date-fns/esm/locale/es/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale23 = {
      lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
      },
      xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
      },
      halfAMinute: "medio minuto",
      lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
      },
      xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
      },
      aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
      },
      xHours: {
        one: "1 hora",
        other: "{{count}} horas"
      },
      xDays: {
        one: "1 d\xEDa",
        other: "{{count}} d\xEDas"
      },
      aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
      },
      xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
      },
      aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
      },
      xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
      },
      aboutXYears: {
        one: "alrededor de 1 a\xF1o",
        other: "alrededor de {{count}} a\xF1os"
      },
      xYears: {
        one: "1 a\xF1o",
        other: "{{count}} a\xF1os"
      },
      overXYears: {
        one: "m\xE1s de 1 a\xF1o",
        other: "m\xE1s de {{count}} a\xF1os"
      },
      almostXYears: {
        one: "casi 1 a\xF1o",
        other: "casi {{count}} a\xF1os"
      }
    };
    formatDistance46 = function formatDistance47(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale23[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "en " + result;
        } else {
          return "hace " + result;
        }
      }
      return result;
    };
    formatDistance_default23 = formatDistance46;
  }
});

// ../../node_modules/date-fns/esm/locale/es/_lib/formatLong/index.js
var dateFormats28, timeFormats28, dateTimeFormats28, formatLong28, formatLong_default28;
var init_formatLong28 = __esm({
  "../../node_modules/date-fns/esm/locale/es/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats28 = {
      full: "EEEE, d 'de' MMMM 'de' y",
      long: "d 'de' MMMM 'de' y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats28 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats28 = {
      full: "{{date}} 'a las' {{time}}",
      long: "{{date}} 'a las' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong28 = {
      date: buildFormatLongFn({
        formats: dateFormats28,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats28,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats28,
        defaultWidth: "full"
      })
    };
    formatLong_default28 = formatLong28;
  }
});

// ../../node_modules/date-fns/esm/locale/es/_lib/formatRelative/index.js
var formatRelativeLocale22, formatRelativeLocalePlural2, formatRelative44, formatRelative_default22;
var init_formatRelative23 = __esm({
  "../../node_modules/date-fns/esm/locale/es/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale22 = {
      lastWeek: "'el' eeee 'pasado a la' p",
      yesterday: "'ayer a la' p",
      today: "'hoy a la' p",
      tomorrow: "'ma\xF1ana a la' p",
      nextWeek: "eeee 'a la' p",
      other: "P"
    };
    formatRelativeLocalePlural2 = {
      lastWeek: "'el' eeee 'pasado a las' p",
      yesterday: "'ayer a las' p",
      today: "'hoy a las' p",
      tomorrow: "'ma\xF1ana a las' p",
      nextWeek: "eeee 'a las' p",
      other: "P"
    };
    formatRelative44 = function formatRelative45(token, date, _baseDate, _options) {
      if (date.getUTCHours() !== 1) {
        return formatRelativeLocalePlural2[token];
      } else {
        return formatRelativeLocale22[token];
      }
    };
    formatRelative_default22 = formatRelative44;
  }
});

// ../../node_modules/date-fns/esm/locale/es/_lib/localize/index.js
var eraValues23, quarterValues23, monthValues23, dayValues23, dayPeriodValues23, formattingDayPeriodValues20, ordinalNumber45, localize23, localize_default23;
var init_localize23 = __esm({
  "../../node_modules/date-fns/esm/locale/es/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues23 = {
      narrow: ["AC", "DC"],
      abbreviated: ["AC", "DC"],
      wide: ["antes de cristo", "despu\xE9s de cristo"]
    };
    quarterValues23 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
    };
    monthValues23 = {
      narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      wide: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"]
    };
    dayValues23 = {
      narrow: ["d", "l", "m", "m", "j", "v", "s"],
      short: ["do", "lu", "ma", "mi", "ju", "vi", "s\xE1"],
      abbreviated: ["dom", "lun", "mar", "mi\xE9", "jue", "vie", "s\xE1b"],
      wide: ["domingo", "lunes", "martes", "mi\xE9rcoles", "jueves", "viernes", "s\xE1bado"]
    };
    dayPeriodValues23 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xF1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xF1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xF1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
      }
    };
    formattingDayPeriodValues20 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xF1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xF1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xF1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
      }
    };
    ordinalNumber45 = function ordinalNumber46(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\xBA";
    };
    localize23 = {
      ordinalNumber: ordinalNumber45,
      era: buildLocalizeFn({
        values: eraValues23,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues23,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback23(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues23,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues23,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues23,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues20,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default23 = localize23;
  }
});

// ../../node_modules/date-fns/esm/locale/es/_lib/match/index.js
var matchOrdinalNumberPattern22, parseOrdinalNumberPattern22, matchEraPatterns22, parseEraPatterns22, matchQuarterPatterns22, parseQuarterPatterns22, matchMonthPatterns22, parseMonthPatterns22, matchDayPatterns22, parseDayPatterns22, matchDayPeriodPatterns22, parseDayPeriodPatterns22, match22, match_default22;
var init_match22 = __esm({
  "../../node_modules/date-fns/esm/locale/es/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern22 = /^(\d+)(º)?/i;
    parseOrdinalNumberPattern22 = /\d+/i;
    matchEraPatterns22 = {
      narrow: /^(ac|dc|a|d)/i,
      abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
      wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
    };
    parseEraPatterns22 = {
      any: [/^ac/i, /^dc/i],
      wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
    };
    matchQuarterPatterns22 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^[1234](º)? trimestre/i
    };
    parseQuarterPatterns22 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns22 = {
      narrow: /^[efmajsond]/i,
      abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
      wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
    };
    parseMonthPatterns22 = {
      narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
    };
    matchDayPatterns22 = {
      narrow: /^[dlmjvs]/i,
      short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
      abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
      wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
    };
    parseDayPatterns22 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
      any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
    };
    matchDayPeriodPatterns22 = {
      narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
      any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
    };
    parseDayPeriodPatterns22 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
      }
    };
    match22 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern22,
        parsePattern: parseOrdinalNumberPattern22,
        valueCallback: function valueCallback43(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns22,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns22,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns22,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns22,
        defaultParseWidth: "any",
        valueCallback: function valueCallback44(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns22,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns22,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns22,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns22,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns22,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns22,
        defaultParseWidth: "any"
      })
    };
    match_default22 = match22;
  }
});

// ../../node_modules/date-fns/esm/locale/es/index.js
var locale30, es_default;
var init_es = __esm({
  "../../node_modules/date-fns/esm/locale/es/index.js"() {
    "use strict";
    init_formatDistance24();
    init_formatLong28();
    init_formatRelative23();
    init_localize23();
    init_match22();
    locale30 = {
      code: "es",
      formatDistance: formatDistance_default23,
      formatLong: formatLong_default28,
      formatRelative: formatRelative_default22,
      localize: localize_default23,
      match: match_default22,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    es_default = locale30;
  }
});

// ../../node_modules/date-fns/esm/locale/et/_lib/formatDistance/index.js
var formatDistanceLocale24, formatDistance48, formatDistance_default24;
var init_formatDistance25 = __esm({
  "../../node_modules/date-fns/esm/locale/et/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale24 = {
      lessThanXSeconds: {
        standalone: {
          one: "v\xE4hem kui \xFCks sekund",
          other: "v\xE4hem kui {{count}} sekundit"
        },
        withPreposition: {
          one: "v\xE4hem kui \xFChe sekundi",
          other: "v\xE4hem kui {{count}} sekundi"
        }
      },
      xSeconds: {
        standalone: {
          one: "\xFCks sekund",
          other: "{{count}} sekundit"
        },
        withPreposition: {
          one: "\xFChe sekundi",
          other: "{{count}} sekundi"
        }
      },
      halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
      },
      lessThanXMinutes: {
        standalone: {
          one: "v\xE4hem kui \xFCks minut",
          other: "v\xE4hem kui {{count}} minutit"
        },
        withPreposition: {
          one: "v\xE4hem kui \xFChe minuti",
          other: "v\xE4hem kui {{count}} minuti"
        }
      },
      xMinutes: {
        standalone: {
          one: "\xFCks minut",
          other: "{{count}} minutit"
        },
        withPreposition: {
          one: "\xFChe minuti",
          other: "{{count}} minuti"
        }
      },
      aboutXHours: {
        standalone: {
          one: "umbes \xFCks tund",
          other: "umbes {{count}} tundi"
        },
        withPreposition: {
          one: "umbes \xFChe tunni",
          other: "umbes {{count}} tunni"
        }
      },
      xHours: {
        standalone: {
          one: "\xFCks tund",
          other: "{{count}} tundi"
        },
        withPreposition: {
          one: "\xFChe tunni",
          other: "{{count}} tunni"
        }
      },
      xDays: {
        standalone: {
          one: "\xFCks p\xE4ev",
          other: "{{count}} p\xE4eva"
        },
        withPreposition: {
          one: "\xFChe p\xE4eva",
          other: "{{count}} p\xE4eva"
        }
      },
      aboutXWeeks: {
        standalone: {
          one: "umbes \xFCks n\xE4dal",
          other: "umbes {{count}} n\xE4dalat"
        },
        withPreposition: {
          one: "umbes \xFChe n\xE4dala",
          other: "umbes {{count}} n\xE4dala"
        }
      },
      xWeeks: {
        standalone: {
          one: "\xFCks n\xE4dal",
          other: "{{count}} n\xE4dalat"
        },
        withPreposition: {
          one: "\xFChe n\xE4dala",
          other: "{{count}} n\xE4dala"
        }
      },
      aboutXMonths: {
        standalone: {
          one: "umbes \xFCks kuu",
          other: "umbes {{count}} kuud"
        },
        withPreposition: {
          one: "umbes \xFChe kuu",
          other: "umbes {{count}} kuu"
        }
      },
      xMonths: {
        standalone: {
          one: "\xFCks kuu",
          other: "{{count}} kuud"
        },
        withPreposition: {
          one: "\xFChe kuu",
          other: "{{count}} kuu"
        }
      },
      aboutXYears: {
        standalone: {
          one: "umbes \xFCks aasta",
          other: "umbes {{count}} aastat"
        },
        withPreposition: {
          one: "umbes \xFChe aasta",
          other: "umbes {{count}} aasta"
        }
      },
      xYears: {
        standalone: {
          one: "\xFCks aasta",
          other: "{{count}} aastat"
        },
        withPreposition: {
          one: "\xFChe aasta",
          other: "{{count}} aasta"
        }
      },
      overXYears: {
        standalone: {
          one: "rohkem kui \xFCks aasta",
          other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
          one: "rohkem kui \xFChe aasta",
          other: "rohkem kui {{count}} aasta"
        }
      },
      almostXYears: {
        standalone: {
          one: "peaaegu \xFCks aasta",
          other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
          one: "peaaegu \xFChe aasta",
          other: "peaaegu {{count}} aasta"
        }
      }
    };
    formatDistance48 = function formatDistance49(token, count, options) {
      var usageGroup = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale24[token].withPreposition : formatDistanceLocale24[token].standalone;
      var result;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " p\xE4rast";
        } else {
          return result + " eest";
        }
      }
      return result;
    };
    formatDistance_default24 = formatDistance48;
  }
});

// ../../node_modules/date-fns/esm/locale/et/_lib/formatLong/index.js
var dateFormats29, timeFormats29, dateTimeFormats29, formatLong29, formatLong_default29;
var init_formatLong29 = __esm({
  "../../node_modules/date-fns/esm/locale/et/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats29 = {
      full: "EEEE, d. MMMM y",
      long: "d. MMMM y",
      medium: "d. MMM y",
      short: "dd.MM.y"
    };
    timeFormats29 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats29 = {
      full: "{{date}} 'kell' {{time}}",
      long: "{{date}} 'kell' {{time}}",
      medium: "{{date}}. {{time}}",
      short: "{{date}}. {{time}}"
    };
    formatLong29 = {
      date: buildFormatLongFn({
        formats: dateFormats29,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats29,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats29,
        defaultWidth: "full"
      })
    };
    formatLong_default29 = formatLong29;
  }
});

// ../../node_modules/date-fns/esm/locale/et/_lib/formatRelative/index.js
var formatRelativeLocale23, formatRelative46, formatRelative_default23;
var init_formatRelative24 = __esm({
  "../../node_modules/date-fns/esm/locale/et/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale23 = {
      lastWeek: "'eelmine' eeee 'kell' p",
      yesterday: "'eile kell' p",
      today: "'t\xE4na kell' p",
      tomorrow: "'homme kell' p",
      nextWeek: "'j\xE4rgmine' eeee 'kell' p",
      other: "P"
    };
    formatRelative46 = function formatRelative47(token, _date, _baseDate, _options) {
      return formatRelativeLocale23[token];
    };
    formatRelative_default23 = formatRelative46;
  }
});

// ../../node_modules/date-fns/esm/locale/et/_lib/localize/index.js
var eraValues24, quarterValues24, monthValues24, dayValues24, dayPeriodValues24, formattingDayPeriodValues21, ordinalNumber47, localize24, localize_default24;
var init_localize24 = __esm({
  "../../node_modules/date-fns/esm/locale/et/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues24 = {
      narrow: ["e.m.a", "m.a.j"],
      abbreviated: ["e.m.a", "m.a.j"],
      wide: ["enne meie ajaarvamist", "meie ajaarvamise j\xE4rgi"]
    };
    quarterValues24 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues24 = {
      narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jaan", "veebr", "m\xE4rts", "apr", "mai", "juuni", "juuli", "aug", "sept", "okt", "nov", "dets"],
      wide: ["jaanuar", "veebruar", "m\xE4rts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
    };
    dayValues24 = {
      narrow: ["P", "E", "T", "K", "N", "R", "L"],
      short: ["P", "E", "T", "K", "N", "R", "L"],
      abbreviated: ["p\xFChap.", "esmasp.", "teisip.", "kolmap.", "neljap.", "reede.", "laup."],
      wide: ["p\xFChap\xE4ev", "esmasp\xE4ev", "teisip\xE4ev", "kolmap\xE4ev", "neljap\xE4ev", "reede", "laup\xE4ev"]
    };
    dayPeriodValues24 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6",
        noon: "keskp\xE4ev",
        morning: "hommik",
        afternoon: "p\xE4rastl\xF5una",
        evening: "\xF5htu",
        night: "\xF6\xF6"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6",
        noon: "keskp\xE4ev",
        morning: "hommik",
        afternoon: "p\xE4rastl\xF5una",
        evening: "\xF5htu",
        night: "\xF6\xF6"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6",
        noon: "keskp\xE4ev",
        morning: "hommik",
        afternoon: "p\xE4rastl\xF5una",
        evening: "\xF5htu",
        night: "\xF6\xF6"
      }
    };
    formattingDayPeriodValues21 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6l",
        noon: "keskp\xE4eval",
        morning: "hommikul",
        afternoon: "p\xE4rastl\xF5unal",
        evening: "\xF5htul",
        night: "\xF6\xF6sel"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6l",
        noon: "keskp\xE4eval",
        morning: "hommikul",
        afternoon: "p\xE4rastl\xF5unal",
        evening: "\xF5htul",
        night: "\xF6\xF6sel"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xF6\xF6l",
        noon: "keskp\xE4eval",
        morning: "hommikul",
        afternoon: "p\xE4rastl\xF5unal",
        evening: "\xF5htul",
        night: "\xF6\xF6sel"
      }
    };
    ordinalNumber47 = function ordinalNumber48(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize24 = {
      ordinalNumber: ordinalNumber47,
      era: buildLocalizeFn({
        values: eraValues24,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues24,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback24(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues24,
        defaultWidth: "wide",
        formattingValues: monthValues24,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues24,
        defaultWidth: "wide",
        formattingValues: dayValues24,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues24,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues21,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default24 = localize24;
  }
});

// ../../node_modules/date-fns/esm/locale/et/_lib/match/index.js
var matchOrdinalNumberPattern23, parseOrdinalNumberPattern23, matchEraPatterns23, parseEraPatterns23, matchQuarterPatterns23, parseQuarterPatterns23, matchMonthPatterns23, parseMonthPatterns23, matchDayPatterns23, parseDayPatterns23, matchDayPeriodPatterns23, parseDayPeriodPatterns23, match23, match_default23;
var init_match23 = __esm({
  "../../node_modules/date-fns/esm/locale/et/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern23 = /^\d+\./i;
    parseOrdinalNumberPattern23 = /\d+/i;
    matchEraPatterns23 = {
      narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
      abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
      wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
    };
    parseEraPatterns23 = {
      any: [/^e/i, /^(m|p)/i]
    };
    matchQuarterPatterns23 = {
      narrow: /^[1234]/i,
      abbreviated: /^K[1234]/i,
      wide: /^[1234](\.)? kvartal/i
    };
    parseQuarterPatterns23 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns23 = {
      narrow: /^[jvmasond]/i,
      abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
      wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
    };
    parseMonthPatterns23 = {
      narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns23 = {
      narrow: /^[petknrl]/i,
      short: /^[petknrl]/i,
      abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
      wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
    };
    parseDayPatterns23 = {
      any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
    };
    matchDayPeriodPatterns23 = {
      any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
    };
    parseDayPeriodPatterns23 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
      }
    };
    match23 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern23,
        parsePattern: parseOrdinalNumberPattern23,
        valueCallback: function valueCallback45(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns23,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns23,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns23,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns23,
        defaultParseWidth: "any",
        valueCallback: function valueCallback46(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns23,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns23,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns23,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns23,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns23,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns23,
        defaultParseWidth: "any"
      })
    };
    match_default23 = match23;
  }
});

// ../../node_modules/date-fns/esm/locale/et/index.js
var locale31, et_default;
var init_et = __esm({
  "../../node_modules/date-fns/esm/locale/et/index.js"() {
    "use strict";
    init_formatDistance25();
    init_formatLong29();
    init_formatRelative24();
    init_localize24();
    init_match23();
    locale31 = {
      code: "et",
      formatDistance: formatDistance_default24,
      formatLong: formatLong_default29,
      formatRelative: formatRelative_default23,
      localize: localize_default24,
      match: match_default23,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    et_default = locale31;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/_lib/formatDistance/index.js
var formatDistanceLocale25, formatDistance50, formatDistance_default25;
var init_formatDistance26 = __esm({
  "../../node_modules/date-fns/esm/locale/eu/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale25 = {
      lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
      },
      xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
      },
      halfAMinute: "minutu erdi",
      lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
      },
      xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
      },
      aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
      },
      xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
      },
      xDays: {
        one: "1 egun",
        other: "{{count}} egun"
      },
      aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
      },
      xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
      },
      aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
      },
      xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
      },
      aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
      },
      xYears: {
        one: "1 urte",
        other: "{{count}} urte"
      },
      overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
      },
      almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
      }
    };
    formatDistance50 = function formatDistance51(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale25[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "en " + result;
        } else {
          return "duela " + result;
        }
      }
      return result;
    };
    formatDistance_default25 = formatDistance50;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/_lib/formatLong/index.js
var dateFormats30, timeFormats30, dateTimeFormats30, formatLong30, formatLong_default30;
var init_formatLong30 = __esm({
  "../../node_modules/date-fns/esm/locale/eu/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats30 = {
      full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
      long: "y'ko' MMMM'ren' d'a'",
      medium: "y MMM d",
      short: "yy/MM/dd"
    };
    timeFormats30 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats30 = {
      full: "{{date}} 'tan' {{time}}",
      long: "{{date}} 'tan' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong30 = {
      date: buildFormatLongFn({
        formats: dateFormats30,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats30,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats30,
        defaultWidth: "full"
      })
    };
    formatLong_default30 = formatLong30;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/_lib/formatRelative/index.js
var formatRelativeLocale24, formatRelativeLocalePlural3, formatRelative48, formatRelative_default24;
var init_formatRelative25 = __esm({
  "../../node_modules/date-fns/esm/locale/eu/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale24 = {
      lastWeek: "'joan den' eeee, LT",
      yesterday: "'atzo,' p",
      today: "'gaur,' p",
      tomorrow: "'bihar,' p",
      nextWeek: "eeee, p",
      other: "P"
    };
    formatRelativeLocalePlural3 = {
      lastWeek: "'joan den' eeee, p",
      yesterday: "'atzo,' p",
      today: "'gaur,' p",
      tomorrow: "'bihar,' p",
      nextWeek: "eeee, p",
      other: "P"
    };
    formatRelative48 = function formatRelative49(token, date) {
      if (date.getUTCHours() !== 1) {
        return formatRelativeLocalePlural3[token];
      }
      return formatRelativeLocale24[token];
    };
    formatRelative_default24 = formatRelative48;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/_lib/localize/index.js
var eraValues25, quarterValues25, monthValues25, dayValues25, dayPeriodValues25, formattingDayPeriodValues22, ordinalNumber49, localize25, localize_default25;
var init_localize25 = __esm({
  "../../node_modules/date-fns/esm/locale/eu/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues25 = {
      narrow: ["k.a.", "k.o."],
      abbreviated: ["k.a.", "k.o."],
      wide: ["kristo aurretik", "kristo ondoren"]
    };
    quarterValues25 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1H", "2H", "3H", "4H"],
      wide: ["1. hiruhilekoa", "2. hiruhilekoa", "3. hiruhilekoa", "4. hiruhilekoa"]
    };
    monthValues25 = {
      narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
      abbreviated: ["urt", "ots", "mar", "api", "mai", "eka", "uzt", "abu", "ira", "urr", "aza", "abe"],
      wide: ["urtarrila", "otsaila", "martxoa", "apirila", "maiatza", "ekaina", "uztaila", "abuztua", "iraila", "urria", "azaroa", "abendua"]
    };
    dayValues25 = {
      narrow: ["i", "a", "a", "a", "o", "o", "l"],
      short: ["ig", "al", "as", "az", "og", "or", "lr"],
      abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
      wide: ["igandea", "astelehena", "asteartea", "asteazkena", "osteguna", "ostirala", "larunbata"]
    };
    dayPeriodValues25 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
      }
    };
    formattingDayPeriodValues22 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
      }
    };
    ordinalNumber49 = function ordinalNumber50(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize25 = {
      ordinalNumber: ordinalNumber49,
      era: buildLocalizeFn({
        values: eraValues25,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues25,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback25(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues25,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues25,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues25,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues22,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default25 = localize25;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/_lib/match/index.js
var matchOrdinalNumberPattern24, parseOrdinalNumberPattern24, matchEraPatterns24, parseEraPatterns24, matchQuarterPatterns24, parseQuarterPatterns24, matchMonthPatterns24, parseMonthPatterns24, matchDayPatterns24, parseDayPatterns24, matchDayPeriodPatterns24, parseDayPeriodPatterns24, match24, match_default24;
var init_match24 = __esm({
  "../../node_modules/date-fns/esm/locale/eu/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern24 = /^(\d+)(.)?/i;
    parseOrdinalNumberPattern24 = /\d+/i;
    matchEraPatterns24 = {
      narrow: /^(k.a.|k.o.)/i,
      abbreviated: /^(k.a.|k.o.)/i,
      wide: /^(kristo aurretik|kristo ondoren)/i
    };
    parseEraPatterns24 = {
      narrow: [/^k.a./i, /^k.o./i],
      abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
      wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
    };
    matchQuarterPatterns24 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]H/i,
      wide: /^[1234](.)? hiruhilekoa/i
    };
    parseQuarterPatterns24 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns24 = {
      narrow: /^[uomaei]/i,
      abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
      wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
    };
    parseMonthPatterns24 = {
      narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
      any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
    };
    matchDayPatterns24 = {
      narrow: /^[iaol]/i,
      short: /^(ig|al|as|az|og|or|lr)/i,
      abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
      wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
    };
    parseDayPatterns24 = {
      narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
      short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
      abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
      wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
    };
    matchDayPeriodPatterns24 = {
      narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
      any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
    };
    parseDayPeriodPatterns24 = {
      narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
      },
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
      }
    };
    match24 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern24,
        parsePattern: parseOrdinalNumberPattern24,
        valueCallback: function valueCallback47(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns24,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns24,
        defaultParseWidth: "wide"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns24,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns24,
        defaultParseWidth: "any",
        valueCallback: function valueCallback48(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns24,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns24,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns24,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns24,
        defaultParseWidth: "wide"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns24,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns24,
        defaultParseWidth: "any"
      })
    };
    match_default24 = match24;
  }
});

// ../../node_modules/date-fns/esm/locale/eu/index.js
var locale32, eu_default;
var init_eu = __esm({
  "../../node_modules/date-fns/esm/locale/eu/index.js"() {
    "use strict";
    init_formatDistance26();
    init_formatLong30();
    init_formatRelative25();
    init_localize25();
    init_match24();
    locale32 = {
      code: "eu",
      formatDistance: formatDistance_default25,
      formatLong: formatLong_default30,
      formatRelative: formatRelative_default24,
      localize: localize_default25,
      match: match_default24,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    eu_default = locale32;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatDistance/index.js
var formatDistanceLocale26, formatDistance52, formatDistance_default26;
var init_formatDistance27 = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale26 = {
      lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
      },
      xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
      },
      halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
      lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
      },
      xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
      },
      aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
      },
      xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
      },
      xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
      },
      aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
      },
      xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
      },
      aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
      },
      xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
      },
      aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
      },
      xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
      },
      overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
      },
      almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
      }
    };
    formatDistance52 = function formatDistance53(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale26[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u062F\u0631 " + result;
        } else {
          return result + " \u0642\u0628\u0644";
        }
      }
      return result;
    };
    formatDistance_default26 = formatDistance52;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatLong/index.js
var dateFormats31, timeFormats31, dateTimeFormats31, formatLong31, formatLong_default31;
var init_formatLong31 = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats31 = {
      full: "EEEE do MMMM y",
      long: "do MMMM y",
      medium: "d MMM y",
      short: "yyyy/MM/dd"
    };
    timeFormats31 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats31 = {
      full: "{{date}} '\u062F\u0631' {{time}}",
      long: "{{date}} '\u062F\u0631' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong31 = {
      date: buildFormatLongFn({
        formats: dateFormats31,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats31,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats31,
        defaultWidth: "full"
      })
    };
    formatLong_default31 = formatLong31;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatRelative/index.js
var formatRelativeLocale25, formatRelative50, formatRelative_default25;
var init_formatRelative26 = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale25 = {
      lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
      yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
      today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
      tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
      nextWeek: "eeee '\u062F\u0631' p",
      other: "P"
    };
    formatRelative50 = function formatRelative51(token, _date, _baseDate, _options) {
      return formatRelativeLocale25[token];
    };
    formatRelative_default25 = formatRelative50;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/_lib/localize/index.js
var eraValues26, quarterValues26, monthValues26, dayValues26, dayPeriodValues26, formattingDayPeriodValues23, ordinalNumber51, localize26, localize_default26;
var init_localize26 = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues26 = {
      narrow: ["\u0642", "\u0628"],
      abbreviated: ["\u0642.\u0645.", "\u0628.\u0645."],
      wide: ["\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F", "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"]
    };
    quarterValues26 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u0633\u200C\u06451", "\u0633\u200C\u06452", "\u0633\u200C\u06453", "\u0633\u200C\u06454"],
      wide: ["\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3", "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"]
    };
    monthValues26 = {
      narrow: ["\u0698", "\u0641", "\u0645", "\u0622", "\u0645", "\u062C", "\u062C", "\u0622", "\u0633", "\u0627", "\u0646", "\u062F"],
      abbreviated: ["\u0698\u0627\u0646\u0640", "\u0641\u0648\u0631", "\u0645\u0627\u0631\u0633", "\u0622\u067E\u0631", "\u0645\u06CC", "\u062C\u0648\u0646", "\u062C\u0648\u0644\u0640", "\u0622\u06AF\u0648", "\u0633\u067E\u062A\u0640", "\u0627\u06A9\u062A\u0640", "\u0646\u0648\u0627\u0645\u0640", "\u062F\u0633\u0627\u0645\u0640"],
      wide: ["\u0698\u0627\u0646\u0648\u06CC\u0647", "\u0641\u0648\u0631\u06CC\u0647", "\u0645\u0627\u0631\u0633", "\u0622\u067E\u0631\u06CC\u0644", "\u0645\u06CC", "\u062C\u0648\u0646", "\u062C\u0648\u0644\u0627\u06CC", "\u0622\u06AF\u0648\u0633\u062A", "\u0633\u067E\u062A\u0627\u0645\u0628\u0631", "\u0627\u06A9\u062A\u0628\u0631", "\u0646\u0648\u0627\u0645\u0628\u0631", "\u062F\u0633\u0627\u0645\u0628\u0631"]
    };
    dayValues26 = {
      narrow: ["\u06CC", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
      short: ["1\u0634", "2\u0634", "3\u0634", "4\u0634", "5\u0634", "\u062C", "\u0634"],
      abbreviated: ["\u06CC\u06A9\u0634\u0646\u0628\u0647", "\u062F\u0648\u0634\u0646\u0628\u0647", "\u0633\u0647\u200C\u0634\u0646\u0628\u0647", "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647", "\u067E\u0646\u062C\u0634\u0646\u0628\u0647", "\u062C\u0645\u0639\u0647", "\u0634\u0646\u0628\u0647"],
      wide: ["\u06CC\u06A9\u0634\u0646\u0628\u0647", "\u062F\u0648\u0634\u0646\u0628\u0647", "\u0633\u0647\u200C\u0634\u0646\u0628\u0647", "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647", "\u067E\u0646\u062C\u0634\u0646\u0628\u0647", "\u062C\u0645\u0639\u0647", "\u0634\u0646\u0628\u0647"]
    };
    dayPeriodValues26 = {
      narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
      },
      abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
      },
      wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
      }
    };
    formattingDayPeriodValues23 = {
      narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
      },
      abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
      },
      wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
      }
    };
    ordinalNumber51 = function ordinalNumber52(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize26 = {
      ordinalNumber: ordinalNumber51,
      era: buildLocalizeFn({
        values: eraValues26,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues26,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback26(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues26,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues26,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues26,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues23,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default26 = localize26;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/_lib/match/index.js
var matchOrdinalNumberPattern25, parseOrdinalNumberPattern25, matchEraPatterns25, parseEraPatterns25, matchQuarterPatterns25, parseQuarterPatterns25, matchMonthPatterns25, parseMonthPatterns25, matchDayPatterns25, parseDayPatterns25, matchDayPeriodPatterns25, parseDayPeriodPatterns25, match25, match_default25;
var init_match25 = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern25 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern25 = /\d+/i;
    matchEraPatterns25 = {
      narrow: /^(ق|ب)/i,
      abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
      wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
    };
    parseEraPatterns25 = {
      any: [/^قبل/i, /^بعد/i]
    };
    matchQuarterPatterns25 = {
      narrow: /^[1234]/i,
      abbreviated: /^س‌م[1234]/i,
      wide: /^سه‌ماهه [1234]/i
    };
    parseQuarterPatterns25 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns25 = {
      narrow: /^[جژفمآاماسند]/i,
      abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
      wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
    };
    parseMonthPatterns25 = {
      narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
      any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
    };
    matchDayPatterns25 = {
      narrow: /^[شیدسچپج]/i,
      short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
      abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
      wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
    };
    parseDayPatterns25 = {
      narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
      any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
    };
    matchDayPeriodPatterns25 = {
      narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
      abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
      wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
    };
    parseDayPeriodPatterns25 = {
      any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
      }
    };
    match25 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern25,
        parsePattern: parseOrdinalNumberPattern25,
        valueCallback: function valueCallback49(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns25,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns25,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns25,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns25,
        defaultParseWidth: "any",
        valueCallback: function valueCallback50(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns25,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns25,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns25,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns25,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns25,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns25,
        defaultParseWidth: "any"
      })
    };
    match_default25 = match25;
  }
});

// ../../node_modules/date-fns/esm/locale/fa-IR/index.js
var locale33, fa_IR_default;
var init_fa_IR = __esm({
  "../../node_modules/date-fns/esm/locale/fa-IR/index.js"() {
    "use strict";
    init_formatDistance27();
    init_formatLong31();
    init_formatRelative26();
    init_localize26();
    init_match25();
    locale33 = {
      code: "fa-IR",
      formatDistance: formatDistance_default26,
      formatLong: formatLong_default31,
      formatRelative: formatRelative_default25,
      localize: localize_default26,
      match: match_default25,
      options: {
        weekStartsOn: 6,
        firstWeekContainsDate: 1
      }
    };
    fa_IR_default = locale33;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/_lib/formatDistance/index.js
function futureSeconds(text2) {
  return text2.replace(/sekuntia?/, "sekunnin");
}
function futureMinutes(text2) {
  return text2.replace(/minuuttia?/, "minuutin");
}
function futureHours(text2) {
  return text2.replace(/tuntia?/, "tunnin");
}
function futureDays(text2) {
  return text2.replace(/päivää?/, "p\xE4iv\xE4n");
}
function futureWeeks(text2) {
  return text2.replace(/(viikko|viikkoa)/, "viikon");
}
function futureMonths(text2) {
  return text2.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function futureYears(text2) {
  return text2.replace(/(vuosi|vuotta)/, "vuoden");
}
var formatDistanceLocale27, formatDistance54, formatDistance_default27;
var init_formatDistance28 = __esm({
  "../../node_modules/date-fns/esm/locale/fi/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale27 = {
      lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: futureSeconds
      },
      xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: futureSeconds
      },
      halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: function futureTense(_text) {
          return "puolen minuutin";
        }
      },
      lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: futureMinutes
      },
      xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: futureMinutes
      },
      aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: futureHours
      },
      xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: futureHours
      },
      xDays: {
        one: "p\xE4iv\xE4",
        other: "{{count}} p\xE4iv\xE4\xE4",
        futureTense: futureDays
      },
      aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: futureWeeks
      },
      xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: futureWeeks
      },
      aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: futureMonths
      },
      xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: futureMonths
      },
      aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: futureYears
      },
      xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: futureYears
      },
      overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: futureYears
      },
      almostXYears: {
        one: "l\xE4hes vuosi",
        other: "l\xE4hes {{count}} vuotta",
        futureTense: futureYears
      }
    };
    formatDistance54 = function formatDistance55(token, count, options) {
      var tokenValue = formatDistanceLocale27[token];
      var result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return tokenValue.futureTense(result) + " kuluttua";
        } else {
          return result + " sitten";
        }
      }
      return result;
    };
    formatDistance_default27 = formatDistance54;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/_lib/formatLong/index.js
var dateFormats32, timeFormats32, dateTimeFormats32, formatLong32, formatLong_default32;
var init_formatLong32 = __esm({
  "../../node_modules/date-fns/esm/locale/fi/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats32 = {
      full: "eeee d. MMMM y",
      long: "d. MMMM y",
      medium: "d. MMM y",
      short: "d.M.y"
    };
    timeFormats32 = {
      full: "HH.mm.ss zzzz",
      long: "HH.mm.ss z",
      medium: "HH.mm.ss",
      short: "HH.mm"
    };
    dateTimeFormats32 = {
      full: "{{date}} 'klo' {{time}}",
      long: "{{date}} 'klo' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong32 = {
      date: buildFormatLongFn({
        formats: dateFormats32,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats32,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats32,
        defaultWidth: "full"
      })
    };
    formatLong_default32 = formatLong32;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/_lib/formatRelative/index.js
var formatRelativeLocale26, formatRelative52, formatRelative_default26;
var init_formatRelative27 = __esm({
  "../../node_modules/date-fns/esm/locale/fi/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale26 = {
      lastWeek: "'viime' eeee 'klo' p",
      yesterday: "'eilen klo' p",
      today: "'t\xE4n\xE4\xE4n klo' p",
      tomorrow: "'huomenna klo' p",
      nextWeek: "'ensi' eeee 'klo' p",
      other: "P"
    };
    formatRelative52 = function formatRelative53(token, _date, _baseDate, _options) {
      return formatRelativeLocale26[token];
    };
    formatRelative_default26 = formatRelative52;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/_lib/localize/index.js
var eraValues27, quarterValues27, monthValues27, formattingMonthValues8, dayValues27, formattingDayValues, dayPeriodValues27, ordinalNumber53, localize27, localize_default27;
var init_localize27 = __esm({
  "../../node_modules/date-fns/esm/locale/fi/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues27 = {
      narrow: ["eaa.", "jaa."],
      abbreviated: ["eaa.", "jaa."],
      wide: ["ennen ajanlaskun alkua", "j\xE4lkeen ajanlaskun alun"]
    };
    quarterValues27 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
    };
    monthValues27 = {
      narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
      abbreviated: ["tammi", "helmi", "maalis", "huhti", "touko", "kes\xE4", "hein\xE4", "elo", "syys", "loka", "marras", "joulu"],
      wide: ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kes\xE4kuu", "hein\xE4kuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"]
    };
    formattingMonthValues8 = {
      narrow: monthValues27.narrow,
      abbreviated: monthValues27.abbreviated,
      wide: ["tammikuuta", "helmikuuta", "maaliskuuta", "huhtikuuta", "toukokuuta", "kes\xE4kuuta", "hein\xE4kuuta", "elokuuta", "syyskuuta", "lokakuuta", "marraskuuta", "joulukuuta"]
    };
    dayValues27 = {
      narrow: ["S", "M", "T", "K", "T", "P", "L"],
      short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
      abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
      wide: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"]
    };
    formattingDayValues = {
      narrow: dayValues27.narrow,
      short: dayValues27.short,
      abbreviated: dayValues27.abbreviated,
      wide: ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"]
    };
    dayPeriodValues27 = {
      narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xF6",
        noon: "keskip\xE4iv\xE4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xF6ll\xE4"
      },
      abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xF6",
        noon: "keskip\xE4iv\xE4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xF6ll\xE4"
      },
      wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xF6ll\xE4",
        noon: "keskip\xE4iv\xE4ll\xE4",
        morning: "aamup\xE4iv\xE4ll\xE4",
        afternoon: "iltap\xE4iv\xE4ll\xE4",
        evening: "illalla",
        night: "y\xF6ll\xE4"
      }
    };
    ordinalNumber53 = function ordinalNumber54(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize27 = {
      ordinalNumber: ordinalNumber53,
      era: buildLocalizeFn({
        values: eraValues27,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues27,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback27(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues27,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues8,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues27,
        defaultWidth: "wide",
        formattingValues: formattingDayValues,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues27,
        defaultWidth: "wide"
      })
    };
    localize_default27 = localize27;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/_lib/match/index.js
var matchOrdinalNumberPattern26, parseOrdinalNumberPattern26, matchEraPatterns26, parseEraPatterns26, matchQuarterPatterns26, parseQuarterPatterns26, matchMonthPatterns26, parseMonthPatterns26, matchDayPatterns26, parseDayPatterns26, matchDayPeriodPatterns26, parseDayPeriodPatterns26, match26, match_default26;
var init_match26 = __esm({
  "../../node_modules/date-fns/esm/locale/fi/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern26 = /^(\d+)(\.)/i;
    parseOrdinalNumberPattern26 = /\d+/i;
    matchEraPatterns26 = {
      narrow: /^(e|j)/i,
      abbreviated: /^(eaa.|jaa.)/i,
      wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
    };
    parseEraPatterns26 = {
      any: [/^e/i, /^j/i]
    };
    matchQuarterPatterns26 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234]\.? kvartaali/i
    };
    parseQuarterPatterns26 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns26 = {
      narrow: /^[thmkeslj]/i,
      abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
      wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
    };
    parseMonthPatterns26 = {
      narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
      any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
    };
    matchDayPatterns26 = {
      narrow: /^[smtkpl]/i,
      short: /^(su|ma|ti|ke|to|pe|la)/i,
      abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
      wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
    };
    parseDayPatterns26 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
      any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
    };
    matchDayPeriodPatterns26 = {
      narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
      any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
    };
    parseDayPeriodPatterns26 = {
      any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
      }
    };
    match26 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern26,
        parsePattern: parseOrdinalNumberPattern26,
        valueCallback: function valueCallback51(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns26,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns26,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns26,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns26,
        defaultParseWidth: "any",
        valueCallback: function valueCallback52(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns26,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns26,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns26,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns26,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns26,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns26,
        defaultParseWidth: "any"
      })
    };
    match_default26 = match26;
  }
});

// ../../node_modules/date-fns/esm/locale/fi/index.js
var locale34, fi_default;
var init_fi = __esm({
  "../../node_modules/date-fns/esm/locale/fi/index.js"() {
    "use strict";
    init_formatDistance28();
    init_formatLong32();
    init_formatRelative27();
    init_localize27();
    init_match26();
    locale34 = {
      code: "fi",
      formatDistance: formatDistance_default27,
      formatLong: formatLong_default32,
      formatRelative: formatRelative_default26,
      localize: localize_default27,
      match: match_default26,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    fi_default = locale34;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/_lib/formatDistance/index.js
var formatDistanceLocale28, formatDistance56, formatDistance_default28;
var init_formatDistance29 = __esm({
  "../../node_modules/date-fns/esm/locale/fr/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale28 = {
      lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
      },
      xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
      },
      halfAMinute: "30 secondes",
      lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
      },
      xHours: {
        one: "1 heure",
        other: "{{count}} heures"
      },
      xDays: {
        one: "1 jour",
        other: "{{count}} jours"
      },
      aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
      },
      xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
      },
      aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
      },
      xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
      },
      aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
      },
      xYears: {
        one: "1 an",
        other: "{{count}} ans"
      },
      overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
      },
      almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
      }
    };
    formatDistance56 = function formatDistance57(token, count, options) {
      var result;
      var form = formatDistanceLocale28[token];
      if (typeof form === "string") {
        result = form;
      } else if (count === 1) {
        result = form.one;
      } else {
        result = form.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "dans " + result;
        } else {
          return "il y a " + result;
        }
      }
      return result;
    };
    formatDistance_default28 = formatDistance56;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/_lib/formatLong/index.js
var dateFormats33, timeFormats33, dateTimeFormats33, formatLong33, formatLong_default33;
var init_formatLong33 = __esm({
  "../../node_modules/date-fns/esm/locale/fr/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats33 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats33 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats33 = {
      full: "{{date}} '\xE0' {{time}}",
      long: "{{date}} '\xE0' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong33 = {
      date: buildFormatLongFn({
        formats: dateFormats33,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats33,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats33,
        defaultWidth: "full"
      })
    };
    formatLong_default33 = formatLong33;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/_lib/formatRelative/index.js
var formatRelativeLocale27, formatRelative54, formatRelative_default27;
var init_formatRelative28 = __esm({
  "../../node_modules/date-fns/esm/locale/fr/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale27 = {
      lastWeek: "eeee 'dernier \xE0' p",
      yesterday: "'hier \xE0' p",
      today: "'aujourd\u2019hui \xE0' p",
      tomorrow: "'demain \xE0' p'",
      nextWeek: "eeee 'prochain \xE0' p",
      other: "P"
    };
    formatRelative54 = function formatRelative55(token, _date, _baseDate, _options) {
      return formatRelativeLocale27[token];
    };
    formatRelative_default27 = formatRelative54;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/_lib/localize/index.js
var eraValues28, quarterValues28, monthValues28, dayValues28, dayPeriodValues28, ordinalNumber55, localize28, localize_default28;
var init_localize28 = __esm({
  "../../node_modules/date-fns/esm/locale/fr/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues28 = {
      narrow: ["av. J.-C", "ap. J.-C"],
      abbreviated: ["av. J.-C", "ap. J.-C"],
      wide: ["avant J\xE9sus-Christ", "apr\xE8s J\xE9sus-Christ"]
    };
    quarterValues28 = {
      narrow: ["T1", "T2", "T3", "T4"],
      abbreviated: ["1er trim.", "2\xE8me trim.", "3\xE8me trim.", "4\xE8me trim."],
      wide: ["1er trimestre", "2\xE8me trimestre", "3\xE8me trimestre", "4\xE8me trimestre"]
    };
    monthValues28 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["janv.", "f\xE9vr.", "mars", "avr.", "mai", "juin", "juil.", "ao\xFBt", "sept.", "oct.", "nov.", "d\xE9c."],
      wide: ["janvier", "f\xE9vrier", "mars", "avril", "mai", "juin", "juillet", "ao\xFBt", "septembre", "octobre", "novembre", "d\xE9cembre"]
    };
    dayValues28 = {
      narrow: ["D", "L", "M", "M", "J", "V", "S"],
      short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
      abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
      wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
    };
    dayPeriodValues28 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xE8s-midi",
        evening: "soir",
        night: "matin"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xE8s-midi",
        evening: "du soir",
        night: "du matin"
      }
    };
    ordinalNumber55 = function ordinalNumber56(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      if (number === 0) return "0";
      var feminineUnits = ["year", "week", "hour", "minute", "second"];
      var suffix;
      if (number === 1) {
        suffix = unit && feminineUnits.includes(unit) ? "\xE8re" : "er";
      } else {
        suffix = "\xE8me";
      }
      return number + suffix;
    };
    localize28 = {
      ordinalNumber: ordinalNumber55,
      era: buildLocalizeFn({
        values: eraValues28,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues28,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback28(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues28,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues28,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues28,
        defaultWidth: "wide"
      })
    };
    localize_default28 = localize28;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/_lib/match/index.js
var matchOrdinalNumberPattern27, parseOrdinalNumberPattern27, matchEraPatterns27, parseEraPatterns27, matchQuarterPatterns27, parseQuarterPatterns27, matchMonthPatterns27, parseMonthPatterns27, matchDayPatterns27, parseDayPatterns27, matchDayPeriodPatterns27, parseDayPeriodPatterns27, match27, match_default27;
var init_match27 = __esm({
  "../../node_modules/date-fns/esm/locale/fr/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern27 = /^(\d+)(ième|ère|ème|er|e)?/i;
    parseOrdinalNumberPattern27 = /\d+/i;
    matchEraPatterns27 = {
      narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
      abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
      wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
    };
    parseEraPatterns27 = {
      any: [/^av/i, /^ap/i]
    };
    matchQuarterPatterns27 = {
      narrow: /^T?[1234]/i,
      abbreviated: /^[1234](er|ème|e)? trim\.?/i,
      wide: /^[1234](er|ème|e)? trimestre/i
    };
    parseQuarterPatterns27 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns27 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
      wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
    };
    parseMonthPatterns27 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns27 = {
      narrow: /^[lmjvsd]/i,
      short: /^(di|lu|ma|me|je|ve|sa)/i,
      abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
      wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
    };
    parseDayPatterns27 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
      any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
    };
    matchDayPeriodPatterns27 = {
      narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
      any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
    };
    parseDayPeriodPatterns27 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
      }
    };
    match27 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern27,
        parsePattern: parseOrdinalNumberPattern27,
        valueCallback: function valueCallback53(value) {
          return parseInt(value);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns27,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns27,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns27,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns27,
        defaultParseWidth: "any",
        valueCallback: function valueCallback54(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns27,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns27,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns27,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns27,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns27,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns27,
        defaultParseWidth: "any"
      })
    };
    match_default27 = match27;
  }
});

// ../../node_modules/date-fns/esm/locale/fr/index.js
var locale35, fr_default;
var init_fr = __esm({
  "../../node_modules/date-fns/esm/locale/fr/index.js"() {
    "use strict";
    init_formatDistance29();
    init_formatLong33();
    init_formatRelative28();
    init_localize28();
    init_match27();
    locale35 = {
      code: "fr",
      formatDistance: formatDistance_default28,
      formatLong: formatLong_default33,
      formatRelative: formatRelative_default27,
      localize: localize_default28,
      match: match_default27,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    fr_default = locale35;
  }
});

// ../../node_modules/date-fns/esm/locale/fr-CA/_lib/formatLong/index.js
var dateFormats34, timeFormats34, dateTimeFormats34, formatLong34, formatLong_default34;
var init_formatLong34 = __esm({
  "../../node_modules/date-fns/esm/locale/fr-CA/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats34 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "yy-MM-dd"
    };
    timeFormats34 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats34 = {
      full: "{{date}} '\xE0' {{time}}",
      long: "{{date}} '\xE0' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong34 = {
      date: buildFormatLongFn({
        formats: dateFormats34,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats34,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats34,
        defaultWidth: "full"
      })
    };
    formatLong_default34 = formatLong34;
  }
});

// ../../node_modules/date-fns/esm/locale/fr-CA/index.js
var locale36, fr_CA_default;
var init_fr_CA = __esm({
  "../../node_modules/date-fns/esm/locale/fr-CA/index.js"() {
    "use strict";
    init_formatDistance29();
    init_formatRelative28();
    init_localize28();
    init_match27();
    init_formatLong34();
    locale36 = {
      code: "fr-CA",
      formatDistance: formatDistance_default28,
      formatLong: formatLong_default34,
      formatRelative: formatRelative_default27,
      localize: localize_default28,
      match: match_default27,
      // Unique for fr-CA
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    fr_CA_default = locale36;
  }
});

// ../../node_modules/date-fns/esm/locale/fr-CH/_lib/formatLong/index.js
var dateFormats35, timeFormats35, dateTimeFormats35, formatLong35, formatLong_default35;
var init_formatLong35 = __esm({
  "../../node_modules/date-fns/esm/locale/fr-CH/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats35 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd.MM.y"
    };
    timeFormats35 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats35 = {
      full: "{{date}} '\xE0' {{time}}",
      long: "{{date}} '\xE0' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong35 = {
      date: buildFormatLongFn({
        formats: dateFormats35,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats35,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats35,
        defaultWidth: "full"
      })
    };
    formatLong_default35 = formatLong35;
  }
});

// ../../node_modules/date-fns/esm/locale/fr-CH/_lib/formatRelative/index.js
var formatRelativeLocale28, formatRelative56, formatRelative_default28;
var init_formatRelative29 = __esm({
  "../../node_modules/date-fns/esm/locale/fr-CH/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale28 = {
      lastWeek: "eeee 'la semaine derni\xE8re \xE0' p",
      yesterday: "'hier \xE0' p",
      today: "'aujourd\u2019hui \xE0' p",
      tomorrow: "'demain \xE0' p'",
      nextWeek: "eeee 'la semaine prochaine \xE0' p",
      other: "P"
    };
    formatRelative56 = function formatRelative57(token, _date, _baseDate, _options) {
      return formatRelativeLocale28[token];
    };
    formatRelative_default28 = formatRelative56;
  }
});

// ../../node_modules/date-fns/esm/locale/fr-CH/index.js
var locale37, fr_CH_default;
var init_fr_CH = __esm({
  "../../node_modules/date-fns/esm/locale/fr-CH/index.js"() {
    "use strict";
    init_formatDistance29();
    init_localize28();
    init_match27();
    init_formatLong35();
    init_formatRelative29();
    locale37 = {
      code: "fr-CH",
      formatDistance: formatDistance_default28,
      formatLong: formatLong_default35,
      formatRelative: formatRelative_default28,
      localize: localize_default28,
      match: match_default27,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    fr_CH_default = locale37;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/_lib/formatDistance/index.js
var formatDistanceLocale29, formatDistance58, formatDistance_default29;
var init_formatDistance30 = __esm({
  "../../node_modules/date-fns/esm/locale/fy/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale29 = {
      lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
      },
      xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
      },
      halfAMinute: "oardel min\xFAt",
      lessThanXMinutes: {
        one: "minder as 1 min\xFAt",
        other: "minder as {{count}} minuten"
      },
      xMinutes: {
        one: "1 min\xFAt",
        other: "{{count}} minuten"
      },
      aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
      },
      xHours: {
        one: "1 oere",
        other: "{{count}} oere"
      },
      xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
      },
      aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
      },
      xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
      },
      aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
      },
      xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
      },
      aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
      },
      xYears: {
        one: "1 jier",
        other: "{{count}} jier"
      },
      overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
      },
      almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
      }
    };
    formatDistance58 = function formatDistance59(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale29[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "oer " + result;
        } else {
          return result + " lyn";
        }
      }
      return result;
    };
    formatDistance_default29 = formatDistance58;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/_lib/formatLong/index.js
var dateFormats36, timeFormats36, dateTimeFormats36, formatLong36, formatLong_default36;
var init_formatLong36 = __esm({
  "../../node_modules/date-fns/esm/locale/fy/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats36 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd-MM-y"
    };
    timeFormats36 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats36 = {
      full: "{{date}} 'om' {{time}}",
      long: "{{date}} 'om' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong36 = {
      date: buildFormatLongFn({
        formats: dateFormats36,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats36,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats36,
        defaultWidth: "full"
      })
    };
    formatLong_default36 = formatLong36;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/_lib/formatRelative/index.js
var formatRelativeLocale29, formatRelative58, formatRelative_default29;
var init_formatRelative30 = __esm({
  "../../node_modules/date-fns/esm/locale/fy/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale29 = {
      lastWeek: "'\xF4fr\xFBne' eeee 'om' p",
      yesterday: "'juster om' p",
      today: "'hjoed om' p",
      tomorrow: "'moarn om' p",
      nextWeek: "eeee 'om' p",
      other: "P"
    };
    formatRelative58 = function formatRelative59(token, _date, _baseDate, _options) {
      return formatRelativeLocale29[token];
    };
    formatRelative_default29 = formatRelative58;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/_lib/localize/index.js
var eraValues29, quarterValues29, monthValues29, dayValues29, dayPeriodValues29, ordinalNumber57, localize29, localize_default29;
var init_localize29 = __esm({
  "../../node_modules/date-fns/esm/locale/fy/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues29 = {
      narrow: ["f.K.", "n.K."],
      abbreviated: ["f.Kr.", "n.Kr."],
      wide: ["foar Kristus", "nei Kristus"]
    };
    quarterValues29 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1e fearnsjier", "2e fearnsjier", "3e fearnsjier", "4e fearnsjier"]
    };
    monthValues29 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mai.", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "des."],
      wide: ["jannewaris", "febrewaris", "maart", "april", "maaie", "juny", "july", "augustus", "septimber", "oktober", "novimber", "desimber"]
    };
    dayValues29 = {
      narrow: ["s", "m", "t", "w", "t", "f", "s"],
      short: ["si", "mo", "ti", "wo", "to", "fr", "so"],
      abbreviated: ["snein", "moa", "tii", "woa", "ton", "fre", "sneon"],
      wide: ["snein", "moandei", "tiisdei", "woansdei", "tongersdei", "freed", "sneon"]
    };
    dayPeriodValues29 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xFBns",
        night: "nachts"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xFBns",
        night: "nachts"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xFBns",
        night: "nachts"
      }
    };
    ordinalNumber57 = function ordinalNumber58(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "e";
    };
    localize29 = {
      ordinalNumber: ordinalNumber57,
      era: buildLocalizeFn({
        values: eraValues29,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues29,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback29(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues29,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues29,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues29,
        defaultWidth: "wide"
      })
    };
    localize_default29 = localize29;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/_lib/match/index.js
var matchOrdinalNumberPattern28, parseOrdinalNumberPattern28, matchEraPatterns28, parseEraPatterns28, matchQuarterPatterns28, parseQuarterPatterns28, matchMonthPatterns28, parseMonthPatterns28, matchDayPatterns28, parseDayPatterns28, matchDayPeriodPatterns28, parseDayPeriodPatterns28, match28, match_default28;
var init_match28 = __esm({
  "../../node_modules/date-fns/esm/locale/fy/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern28 = /^(\d+)e?/i;
    parseOrdinalNumberPattern28 = /\d+/i;
    matchEraPatterns28 = {
      narrow: /^([fn]\.? ?K\.?)/,
      abbreviated: /^([fn]\. ?Kr\.?)/,
      wide: /^((foar|nei) Kristus)/
    };
    parseEraPatterns28 = {
      any: [/^f/, /^n/]
    };
    matchQuarterPatterns28 = {
      narrow: /^[1234]/i,
      abbreviated: /^K[1234]/i,
      wide: /^[1234]e fearnsjier/i
    };
    parseQuarterPatterns28 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns28 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
      wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
    };
    parseMonthPatterns28 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^des/i]
    };
    matchDayPatterns28 = {
      narrow: /^[smtwf]/i,
      short: /^(si|mo|ti|wo|to|fr|so)/i,
      abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
      wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
    };
    parseDayPatterns28 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
    };
    matchDayPeriodPatterns28 = {
      any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
    };
    parseDayPeriodPatterns28 = {
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
      }
    };
    match28 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern28,
        parsePattern: parseOrdinalNumberPattern28,
        valueCallback: function valueCallback55(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns28,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns28,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns28,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns28,
        defaultParseWidth: "any",
        valueCallback: function valueCallback56(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns28,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns28,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns28,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns28,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns28,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns28,
        defaultParseWidth: "any"
      })
    };
    match_default28 = match28;
  }
});

// ../../node_modules/date-fns/esm/locale/fy/index.js
var locale38, fy_default;
var init_fy = __esm({
  "../../node_modules/date-fns/esm/locale/fy/index.js"() {
    "use strict";
    init_formatDistance30();
    init_formatLong36();
    init_formatRelative30();
    init_localize29();
    init_match28();
    locale38 = {
      code: "fy",
      formatDistance: formatDistance_default29,
      formatLong: formatLong_default36,
      formatRelative: formatRelative_default29,
      localize: localize_default29,
      match: match_default28,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    fy_default = locale38;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/_lib/formatDistance/index.js
var formatDistanceLocale30, formatDistance60, formatDistance_default30;
var init_formatDistance31 = __esm({
  "../../node_modules/date-fns/esm/locale/gd/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale30 = {
      lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
      },
      xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
      },
      halfAMinute: "leth mhionaid",
      lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
      },
      xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
      },
      aboutXHours: {
        one: "mu uair de th\xECde",
        other: "mu {{count}} uairean de th\xECde"
      },
      xHours: {
        one: "1 uair de th\xECde",
        two: "2 uair de th\xECde",
        twenty: "20 uair de th\xECde",
        other: "{{count}} uairean de th\xECde"
      },
      xDays: {
        one: "1 l\xE0",
        other: "{{count}} l\xE0"
      },
      aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
      },
      xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
      },
      aboutXMonths: {
        one: "mu mh\xECos",
        other: "mu {{count}} m\xECosan"
      },
      xMonths: {
        one: "1 m\xECos",
        other: "{{count}} m\xECosan"
      },
      aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
      },
      xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
      },
      overXYears: {
        one: "c\xF2rr is bliadhna",
        other: "c\xF2rr is {{count}} bliadhnaichean"
      },
      almostXYears: {
        one: "cha mh\xF2r bliadhna",
        other: "cha mh\xF2r {{count}} bliadhnaichean"
      }
    };
    formatDistance60 = function formatDistance61(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale30[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2 && !!tokenValue.two) {
        result = tokenValue.two;
      } else if (count === 20 && !!tokenValue.twenty) {
        result = tokenValue.twenty;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "ann an " + result;
        } else {
          return "o chionn " + result;
        }
      }
      return result;
    };
    formatDistance_default30 = formatDistance60;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/_lib/formatLong/index.js
var dateFormats37, timeFormats37, dateTimeFormats37, formatLong37, formatLong_default37;
var init_formatLong37 = __esm({
  "../../node_modules/date-fns/esm/locale/gd/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats37 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats37 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats37 = {
      full: "{{date}} 'aig' {{time}}",
      long: "{{date}} 'aig' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong37 = {
      date: buildFormatLongFn({
        formats: dateFormats37,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats37,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats37,
        defaultWidth: "full"
      })
    };
    formatLong_default37 = formatLong37;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/_lib/formatRelative/index.js
var formatRelativeLocale30, formatRelative60, formatRelative_default30;
var init_formatRelative31 = __esm({
  "../../node_modules/date-fns/esm/locale/gd/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale30 = {
      lastWeek: "'mu dheireadh' eeee 'aig' p",
      //FIX
      yesterday: "'an-d\xE8 aig' p",
      today: "'an-diugh aig' p",
      tomorrow: "'a-m\xE0ireach aig' p",
      nextWeek: "eeee 'aig' p",
      other: "P"
    };
    formatRelative60 = function formatRelative61(token, _date, _baseDate, _options) {
      return formatRelativeLocale30[token];
    };
    formatRelative_default30 = formatRelative60;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/_lib/localize/index.js
var eraValues30, quarterValues30, monthValues30, dayValues30, dayPeriodValues30, formattingDayPeriodValues24, ordinalNumber59, localize30, localize_default30;
var init_localize30 = __esm({
  "../../node_modules/date-fns/esm/locale/gd/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues30 = {
      narrow: ["R", "A"],
      abbreviated: ["RC", "AD"],
      wide: ["ro Chr\xECosta", "anno domini"]
    };
    quarterValues30 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["C1", "C2", "C3", "C4"],
      wide: ["a' chiad chairteal", "an d\xE0rna cairteal", "an treas cairteal", "an ceathramh cairteal"]
    };
    monthValues30 = {
      narrow: ["F", "G", "M", "G", "C", "\xD2", "I", "L", "S", "D", "S", "D"],
      abbreviated: ["Faoi", "Gear", "M\xE0rt", "Gibl", "C\xE8it", "\xD2gmh", "Iuch", "L\xF9n", "Sult", "D\xE0mh", "Samh", "D\xF9bh"],
      wide: ["Am Faoilleach", "An Gearran", "Am M\xE0rt", "An Giblean", "An C\xE8itean", "An t-\xD2gmhios", "An t-Iuchar", "An L\xF9nastal", "An t-Sultain", "An D\xE0mhair", "An t-Samhain", "An D\xF9bhlachd"]
    };
    dayValues30 = {
      narrow: ["D", "L", "M", "C", "A", "H", "S"],
      short: ["D\xF2", "Lu", "M\xE0", "Ci", "Ar", "Ha", "Sa"],
      abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
      wide: ["Did\xF2mhnaich", "Diluain", "Dim\xE0irt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"]
    };
    dayPeriodValues30 = {
      narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
      },
      abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xE0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
      },
      wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xE0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
      }
    };
    formattingDayPeriodValues24 = {
      narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
      },
      abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xE0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
      },
      wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xE0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
      }
    };
    ordinalNumber59 = function ordinalNumber60(dirtyNumber) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "d";
          case 2:
            return number + "na";
        }
      }
      if (rem100 === 12) {
        return number + "na";
      }
      return number + "mh";
    };
    localize30 = {
      ordinalNumber: ordinalNumber59,
      era: buildLocalizeFn({
        values: eraValues30,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues30,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback30(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues30,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues30,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues30,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues24,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default30 = localize30;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/_lib/match/index.js
var matchOrdinalNumberPattern29, parseOrdinalNumberPattern29, matchEraPatterns29, parseEraPatterns29, matchQuarterPatterns29, parseQuarterPatterns29, matchMonthPatterns29, parseMonthPatterns29, matchDayPatterns29, parseDayPatterns29, matchDayPeriodPatterns29, parseDayPeriodPatterns29, match29, match_default29;
var init_match29 = __esm({
  "../../node_modules/date-fns/esm/locale/gd/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern29 = /^(\d+)(d|na|tr|mh)?/i;
    parseOrdinalNumberPattern29 = /\d+/i;
    matchEraPatterns29 = {
      narrow: /^(r|a)/i,
      abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
      wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
    };
    parseEraPatterns29 = {
      any: [/^b/i, /^(a|c)/i]
    };
    matchQuarterPatterns29 = {
      narrow: /^[1234]/i,
      abbreviated: /^c[1234]/i,
      wide: /^[1234](cd|na|tr|mh)? cairteal/i
    };
    parseQuarterPatterns29 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns29 = {
      narrow: /^[fgmcòilsd]/i,
      abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
      wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
    };
    parseMonthPatterns29 = {
      narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
      any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
    };
    matchDayPatterns29 = {
      narrow: /^[dlmcahs]/i,
      short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
      abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
      wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
    };
    parseDayPatterns29 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
      any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
    };
    matchDayPeriodPatterns29 = {
      narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
      any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
    };
    parseDayPeriodPatterns29 = {
      any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
      }
    };
    match29 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern29,
        parsePattern: parseOrdinalNumberPattern29,
        valueCallback: function valueCallback57(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns29,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns29,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns29,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns29,
        defaultParseWidth: "any",
        valueCallback: function valueCallback58(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns29,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns29,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns29,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns29,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns29,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns29,
        defaultParseWidth: "any"
      })
    };
    match_default29 = match29;
  }
});

// ../../node_modules/date-fns/esm/locale/gd/index.js
var locale39, gd_default;
var init_gd = __esm({
  "../../node_modules/date-fns/esm/locale/gd/index.js"() {
    "use strict";
    init_formatDistance31();
    init_formatLong37();
    init_formatRelative31();
    init_localize30();
    init_match29();
    locale39 = {
      code: "gd",
      formatDistance: formatDistance_default30,
      formatLong: formatLong_default37,
      formatRelative: formatRelative_default30,
      localize: localize_default30,
      match: match_default29,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    gd_default = locale39;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/_lib/formatDistance/index.js
var formatDistanceLocale31, formatDistance62, formatDistance_default31;
var init_formatDistance32 = __esm({
  "../../node_modules/date-fns/esm/locale/gl/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale31 = {
      lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
      },
      xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
      },
      halfAMinute: "medio minuto",
      lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
      },
      xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
      },
      aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
      },
      xHours: {
        one: "1 hora",
        other: "{{count}} horas"
      },
      xDays: {
        one: "1 d\xEDa",
        other: "{{count}} d\xEDas"
      },
      aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
      },
      xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
      },
      aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
      },
      xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
      },
      aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
      },
      xYears: {
        one: "1 ano",
        other: "{{count}} anos"
      },
      overXYears: {
        one: "m\xE1is dun ano",
        other: "m\xE1is de {{count}} anos"
      },
      almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
      }
    };
    formatDistance62 = function formatDistance63(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale31[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "en " + result;
        } else {
          return "hai " + result;
        }
      }
      return result;
    };
    formatDistance_default31 = formatDistance62;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/_lib/formatLong/index.js
var dateFormats38, timeFormats38, dateTimeFormats38, formatLong38, formatLong_default38;
var init_formatLong38 = __esm({
  "../../node_modules/date-fns/esm/locale/gl/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats38 = {
      full: "EEEE, d 'de' MMMM y",
      long: "d 'de' MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats38 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats38 = {
      full: "{{date}} '\xE1s' {{time}}",
      long: "{{date}} '\xE1s' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong38 = {
      date: buildFormatLongFn({
        formats: dateFormats38,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats38,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats38,
        defaultWidth: "full"
      })
    };
    formatLong_default38 = formatLong38;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/_lib/formatRelative/index.js
var formatRelativeLocale31, formatRelativeLocalePlural4, formatRelative62, formatRelative_default31;
var init_formatRelative32 = __esm({
  "../../node_modules/date-fns/esm/locale/gl/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale31 = {
      lastWeek: "'o' eeee 'pasado \xE1' LT",
      yesterday: "'onte \xE1' p",
      today: "'hoxe \xE1' p",
      tomorrow: "'ma\xF1\xE1 \xE1' p",
      nextWeek: "eeee '\xE1' p",
      other: "P"
    };
    formatRelativeLocalePlural4 = {
      lastWeek: "'o' eeee 'pasado \xE1s' p",
      yesterday: "'onte \xE1s' p",
      today: "'hoxe \xE1s' p",
      tomorrow: "'ma\xF1\xE1 \xE1s' p",
      nextWeek: "eeee '\xE1s' p",
      other: "P"
    };
    formatRelative62 = function formatRelative63(token, date, _baseDate, _options) {
      if (date.getUTCHours() !== 1) {
        return formatRelativeLocalePlural4[token];
      }
      return formatRelativeLocale31[token];
    };
    formatRelative_default31 = formatRelative62;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/_lib/localize/index.js
var eraValues31, quarterValues31, monthValues31, dayValues31, dayPeriodValues31, formattingDayPeriodValues25, ordinalNumber61, localize31, localize_default31;
var init_localize31 = __esm({
  "../../node_modules/date-fns/esm/locale/gl/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues31 = {
      narrow: ["AC", "DC"],
      abbreviated: ["AC", "DC"],
      wide: ["antes de cristo", "despois de cristo"]
    };
    quarterValues31 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
    };
    monthValues31 = {
      narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["xan", "feb", "mar", "abr", "mai", "xun", "xul", "ago", "set", "out", "nov", "dec"],
      wide: ["xaneiro", "febreiro", "marzo", "abril", "maio", "xu\xF1o", "xullo", "agosto", "setembro", "outubro", "novembro", "decembro"]
    };
    dayValues31 = {
      narrow: ["d", "l", "m", "m", "j", "v", "s"],
      short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
      abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
      wide: ["domingo", "luns", "martes", "m\xE9rcores", "xoves", "venres", "s\xE1bado"]
    };
    dayPeriodValues31 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xF1\xE1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xEDa",
        morning: "ma\xF1\xE1",
        afternoon: "tarde",
        evening: "tardi\xF1a",
        night: "noite"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xEDa",
        morning: "ma\xF1\xE1",
        afternoon: "tarde",
        evening: "tardi\xF1a",
        night: "noite"
      }
    };
    formattingDayPeriodValues25 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xF1\xE1",
        afternoon: "da tarde",
        evening: "da tardi\xF1a",
        night: "da noite"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xEDa",
        morning: "da ma\xF1\xE1",
        afternoon: "da tarde",
        evening: "da tardi\xF1a",
        night: "da noite"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xEDa",
        morning: "da ma\xF1\xE1",
        afternoon: "da tarde",
        evening: "da tardi\xF1a",
        night: "da noite"
      }
    };
    ordinalNumber61 = function ordinalNumber62(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\xBA";
    };
    localize31 = {
      ordinalNumber: ordinalNumber61,
      era: buildLocalizeFn({
        values: eraValues31,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues31,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback31(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues31,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues31,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues31,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues25,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default31 = localize31;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/_lib/match/index.js
var matchOrdinalNumberPattern30, parseOrdinalNumberPattern30, matchEraPatterns30, parseEraPatterns30, matchQuarterPatterns30, parseQuarterPatterns30, matchMonthPatterns30, parseMonthPatterns30, matchDayPatterns30, parseDayPatterns30, matchDayPeriodPatterns30, parseDayPeriodPatterns30, match30, match_default30;
var init_match30 = __esm({
  "../../node_modules/date-fns/esm/locale/gl/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern30 = /^(\d+)(º)?/i;
    parseOrdinalNumberPattern30 = /\d+/i;
    matchEraPatterns30 = {
      narrow: /^(ac|dc|a|d)/i,
      abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
      wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
    };
    parseEraPatterns30 = {
      any: [/^ac/i, /^dc/i],
      wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
    };
    matchQuarterPatterns30 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^[1234](º)? trimestre/i
    };
    parseQuarterPatterns30 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns30 = {
      narrow: /^[xfmasond]/i,
      abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
      wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
    };
    parseMonthPatterns30 = {
      narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
    };
    matchDayPatterns30 = {
      narrow: /^[dlmxvs]/i,
      short: /^(do|lu|ma|me|xo|ve|sa)/i,
      abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
      wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
    };
    parseDayPatterns30 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
      any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
    };
    matchDayPeriodPatterns30 = {
      narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
      any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
    };
    parseDayPeriodPatterns30 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
      }
    };
    match30 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern30,
        parsePattern: parseOrdinalNumberPattern30,
        valueCallback: function valueCallback59(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns30,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns30,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns30,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns30,
        defaultParseWidth: "any",
        valueCallback: function valueCallback60(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns30,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns30,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns30,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns30,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns30,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns30,
        defaultParseWidth: "any"
      })
    };
    match_default30 = match30;
  }
});

// ../../node_modules/date-fns/esm/locale/gl/index.js
var locale40, gl_default;
var init_gl = __esm({
  "../../node_modules/date-fns/esm/locale/gl/index.js"() {
    "use strict";
    init_formatDistance32();
    init_formatLong38();
    init_formatRelative32();
    init_localize31();
    init_match30();
    locale40 = {
      code: "gl",
      formatDistance: formatDistance_default31,
      formatLong: formatLong_default38,
      formatRelative: formatRelative_default31,
      localize: localize_default31,
      match: match_default30,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    gl_default = locale40;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/_lib/formatDistance/index.js
var formatDistanceLocale32, formatDistance64, formatDistance_default32;
var init_formatDistance33 = __esm({
  "../../node_modules/date-fns/esm/locale/gu/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale32 = {
      lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
      },
      xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
      },
      halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
      lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
      },
      xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
      },
      aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
      },
      xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
      },
      xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
      },
      aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
      },
      xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
      },
      aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
      },
      xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
      },
      aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
      },
      xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
      },
      overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
      },
      almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
      }
    };
    formatDistance64 = function formatDistance65(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale32[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u0AAE\u0ABE\u0A82";
        } else {
          return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
        }
      }
      return result;
    };
    formatDistance_default32 = formatDistance64;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/_lib/formatLong/index.js
var dateFormats39, timeFormats39, dateTimeFormats39, formatLong39, formatLong_default39;
var init_formatLong39 = __esm({
  "../../node_modules/date-fns/esm/locale/gu/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats39 = {
      full: "EEEE, d MMMM, y",
      // CLDR #1825
      long: "d MMMM, y",
      // CLDR #1826
      medium: "d MMM, y",
      // CLDR #1827
      short: "d/M/yy"
      // CLDR #1828
    };
    timeFormats39 = {
      full: "hh:mm:ss a zzzz",
      // CLDR #1829
      long: "hh:mm:ss a z",
      // CLDR #1830
      medium: "hh:mm:ss a",
      // CLDR #1831
      short: "hh:mm a"
      // CLDR #1832
    };
    dateTimeFormats39 = {
      full: "{{date}} {{time}}",
      // CLDR #1833
      long: "{{date}} {{time}}",
      // CLDR #1834
      medium: "{{date}} {{time}}",
      // CLDR #1835
      short: "{{date}} {{time}}"
      // CLDR #1836
    };
    formatLong39 = {
      date: buildFormatLongFn({
        formats: dateFormats39,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats39,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats39,
        defaultWidth: "full"
      })
    };
    formatLong_default39 = formatLong39;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/_lib/formatRelative/index.js
var formatRelativeLocale32, formatRelative64, formatRelative_default32;
var init_formatRelative33 = __esm({
  "../../node_modules/date-fns/esm/locale/gu/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale32 = {
      lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
      // CLDR #1384
      yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
      // CLDR #1409
      today: "'\u0A86\u0A9C\u0AC7' p",
      // CLDR #1410
      tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
      // CLDR #1411
      nextWeek: "eeee p",
      // CLDR #1386
      other: "P"
    };
    formatRelative64 = function formatRelative65(token, _date, _baseDate, _options) {
      return formatRelativeLocale32[token];
    };
    formatRelative_default32 = formatRelative64;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/_lib/localize/index.js
var eraValues32, quarterValues32, monthValues32, dayValues32, dayPeriodValues32, formattingDayPeriodValues26, ordinalNumber63, localize32, localize_default32;
var init_localize32 = __esm({
  "../../node_modules/date-fns/esm/locale/gu/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues32 = {
      narrow: ["\u0A88\u0AB8\u0AAA\u0AC2", "\u0A88\u0AB8"],
      abbreviated: ["\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7", "\u0A88.\u0AB8."],
      wide: ["\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7", "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"]
    };
    quarterValues32 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8", "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"]
    };
    monthValues32 = {
      narrow: ["\u0A9C\u0ABE", "\u0AAB\u0AC7", "\u0AAE\u0ABE", "\u0A8F", "\u0AAE\u0AC7", "\u0A9C\u0AC2", "\u0A9C\u0AC1", "\u0A93", "\u0AB8", "\u0A93", "\u0AA8", "\u0AA1\u0ABF"],
      abbreviated: ["\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1", "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1", "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A", "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2", "\u0AAE\u0AC7", "\u0A9C\u0AC2\u0AA8", "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88", "\u0A91\u0A97\u0AB8\u0ACD\u0A9F", "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7", "\u0A93\u0A95\u0ACD\u0A9F\u0ACB", "\u0AA8\u0AB5\u0AC7", "\u0AA1\u0ABF\u0AB8\u0AC7"],
      wide: ["\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0", "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0", "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A", "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2", "\u0AAE\u0AC7", "\u0A9C\u0AC2\u0AA8", "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87", "\u0A93\u0A97\u0AB8\u0ACD\u0A9F", "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0", "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0", "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0", "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"]
    };
    dayValues32 = {
      narrow: ["\u0AB0", "\u0AB8\u0ACB", "\u0AAE\u0A82", "\u0AAC\u0AC1", "\u0A97\u0AC1", "\u0AB6\u0AC1", "\u0AB6"],
      short: ["\u0AB0", "\u0AB8\u0ACB", "\u0AAE\u0A82", "\u0AAC\u0AC1", "\u0A97\u0AC1", "\u0AB6\u0AC1", "\u0AB6"],
      abbreviated: ["\u0AB0\u0AB5\u0ABF", "\u0AB8\u0ACB\u0AAE", "\u0AAE\u0A82\u0A97\u0AB3", "\u0AAC\u0AC1\u0AA7", "\u0A97\u0AC1\u0AB0\u0AC1", "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0", "\u0AB6\u0AA8\u0ABF"],
      wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0",
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0",
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0",
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0",
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0",
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0"
        /* Saturday */
      ]
    };
    dayPeriodValues32 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      }
    };
    formattingDayPeriodValues26 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
      }
    };
    ordinalNumber63 = function ordinalNumber64(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize32 = {
      ordinalNumber: ordinalNumber63,
      era: buildLocalizeFn({
        values: eraValues32,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues32,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback32(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues32,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues32,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues32,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues26,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default32 = localize32;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/_lib/match/index.js
var matchOrdinalNumberPattern31, parseOrdinalNumberPattern31, matchEraPatterns31, parseEraPatterns31, matchQuarterPatterns31, parseQuarterPatterns31, matchMonthPatterns31, parseMonthPatterns31, matchDayPatterns31, parseDayPatterns31, matchDayPeriodPatterns31, parseDayPeriodPatterns31, match31, match_default31;
var init_match31 = __esm({
  "../../node_modules/date-fns/esm/locale/gu/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern31 = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
    parseOrdinalNumberPattern31 = /\d+/i;
    matchEraPatterns31 = {
      narrow: /^(ઈસપૂ|ઈસ)/i,
      abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
      wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
    };
    parseEraPatterns31 = {
      any: [/^ઈસપૂ/i, /^ઈસ/i]
    };
    matchQuarterPatterns31 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
    };
    parseQuarterPatterns31 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns31 = {
      // eslint-disable-next-line no-misleading-character-class
      narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
      abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
      wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
    };
    parseMonthPatterns31 = {
      narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
      any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
    };
    matchDayPatterns31 = {
      narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
      short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
      abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
      wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
    };
    parseDayPatterns31 = {
      narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
      any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
    };
    matchDayPeriodPatterns31 = {
      narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
      any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
    };
    parseDayPeriodPatterns31 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
      }
    };
    match31 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern31,
        parsePattern: parseOrdinalNumberPattern31,
        valueCallback: function valueCallback61(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns31,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns31,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns31,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns31,
        defaultParseWidth: "any",
        valueCallback: function valueCallback62(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns31,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns31,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns31,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns31,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns31,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns31,
        defaultParseWidth: "any"
      })
    };
    match_default31 = match31;
  }
});

// ../../node_modules/date-fns/esm/locale/gu/index.js
var locale41, gu_default;
var init_gu = __esm({
  "../../node_modules/date-fns/esm/locale/gu/index.js"() {
    "use strict";
    init_formatDistance33();
    init_formatLong39();
    init_formatRelative33();
    init_localize32();
    init_match31();
    locale41 = {
      code: "gu",
      formatDistance: formatDistance_default32,
      formatLong: formatLong_default39,
      formatRelative: formatRelative_default32,
      localize: localize_default32,
      match: match_default31,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    gu_default = locale41;
  }
});

// ../../node_modules/date-fns/esm/locale/he/_lib/formatDistance/index.js
var formatDistanceLocale33, formatDistance66, formatDistance_default33;
var init_formatDistance34 = __esm({
  "../../node_modules/date-fns/esm/locale/he/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale33 = {
      lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
      },
      xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
      },
      halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
      lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
      },
      xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
      },
      aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
      },
      xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
      },
      xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
      },
      aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
      },
      xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
      },
      aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
      },
      xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
      },
      aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
      },
      xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
      },
      overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
      },
      almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
      }
    };
    formatDistance66 = function formatDistance67(token, count, options) {
      if (token === "xDays" && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) {
          return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        }
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
      }
      var result;
      var tokenValue = formatDistanceLocale33[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2) {
        result = tokenValue.two;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u05D1\u05E2\u05D5\u05D3 " + result;
        } else {
          return "\u05DC\u05E4\u05E0\u05D9 " + result;
        }
      }
      return result;
    };
    formatDistance_default33 = formatDistance66;
  }
});

// ../../node_modules/date-fns/esm/locale/he/_lib/formatLong/index.js
var dateFormats40, timeFormats40, dateTimeFormats40, formatLong40, formatLong_default40;
var init_formatLong40 = __esm({
  "../../node_modules/date-fns/esm/locale/he/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats40 = {
      full: "EEEE, d \u05D1MMMM y",
      long: "d \u05D1MMMM y",
      medium: "d \u05D1MMM y",
      short: "d.M.y"
    };
    timeFormats40 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats40 = {
      full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
      long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong40 = {
      date: buildFormatLongFn({
        formats: dateFormats40,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats40,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats40,
        defaultWidth: "full"
      })
    };
    formatLong_default40 = formatLong40;
  }
});

// ../../node_modules/date-fns/esm/locale/he/_lib/formatRelative/index.js
var formatRelativeLocale33, formatRelative66, formatRelative_default33;
var init_formatRelative34 = __esm({
  "../../node_modules/date-fns/esm/locale/he/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale33 = {
      lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
      yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
      today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
      tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
      nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
      other: "P"
    };
    formatRelative66 = function formatRelative67(token, _date, _baseDate, _options) {
      return formatRelativeLocale33[token];
    };
    formatRelative_default33 = formatRelative66;
  }
});

// ../../node_modules/date-fns/esm/locale/he/_lib/localize/index.js
var eraValues33, quarterValues33, monthValues33, dayValues33, dayPeriodValues33, formattingDayPeriodValues27, ordinalNumber65, localize33, localize_default33;
var init_localize33 = __esm({
  "../../node_modules/date-fns/esm/locale/he/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues33 = {
      narrow: ["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
      abbreviated: ["\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"],
      wide: ["\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4", "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"]
    };
    quarterValues33 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["\u05E8\u05D1\u05E2\u05D5\u05DF 1", "\u05E8\u05D1\u05E2\u05D5\u05DF 2", "\u05E8\u05D1\u05E2\u05D5\u05DF 3", "\u05E8\u05D1\u05E2\u05D5\u05DF 4"]
    };
    monthValues33 = {
      narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      abbreviated: ["\u05D9\u05E0\u05D5\u05F3", "\u05E4\u05D1\u05E8\u05F3", "\u05DE\u05E8\u05E5", "\u05D0\u05E4\u05E8\u05F3", "\u05DE\u05D0\u05D9", "\u05D9\u05D5\u05E0\u05D9", "\u05D9\u05D5\u05DC\u05D9", "\u05D0\u05D5\u05D2\u05F3", "\u05E1\u05E4\u05D8\u05F3", "\u05D0\u05D5\u05E7\u05F3", "\u05E0\u05D5\u05D1\u05F3", "\u05D3\u05E6\u05DE\u05F3"],
      wide: ["\u05D9\u05E0\u05D5\u05D0\u05E8", "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8", "\u05DE\u05E8\u05E5", "\u05D0\u05E4\u05E8\u05D9\u05DC", "\u05DE\u05D0\u05D9", "\u05D9\u05D5\u05E0\u05D9", "\u05D9\u05D5\u05DC\u05D9", "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8", "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8", "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8", "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8", "\u05D3\u05E6\u05DE\u05D1\u05E8"]
    };
    dayValues33 = {
      narrow: ["\u05D0\u05F3", "\u05D1\u05F3", "\u05D2\u05F3", "\u05D3\u05F3", "\u05D4\u05F3", "\u05D5\u05F3", "\u05E9\u05F3"],
      short: ["\u05D0\u05F3", "\u05D1\u05F3", "\u05D2\u05F3", "\u05D3\u05F3", "\u05D4\u05F3", "\u05D5\u05F3", "\u05E9\u05F3"],
      abbreviated: ["\u05D9\u05D5\u05DD \u05D0\u05F3", "\u05D9\u05D5\u05DD \u05D1\u05F3", "\u05D9\u05D5\u05DD \u05D2\u05F3", "\u05D9\u05D5\u05DD \u05D3\u05F3", "\u05D9\u05D5\u05DD \u05D4\u05F3", "\u05D9\u05D5\u05DD \u05D5\u05F3", "\u05E9\u05D1\u05EA"],
      wide: ["\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF", "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9", "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9", "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"]
    };
    dayPeriodValues33 = {
      narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
      },
      abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
      },
      wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
      }
    };
    formattingDayPeriodValues27 = {
      narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
      },
      abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
      },
      wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
      }
    };
    ordinalNumber65 = function ordinalNumber66(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      if (number <= 0 || number > 10) return String(number);
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      var isFemale = ["year", "hour", "minute", "second"].indexOf(unit) >= 0;
      var male = ["\u05E8\u05D0\u05E9\u05D5\u05DF", "\u05E9\u05E0\u05D9", "\u05E9\u05DC\u05D9\u05E9\u05D9", "\u05E8\u05D1\u05D9\u05E2\u05D9", "\u05D7\u05DE\u05D9\u05E9\u05D9", "\u05E9\u05D9\u05E9\u05D9", "\u05E9\u05D1\u05D9\u05E2\u05D9", "\u05E9\u05DE\u05D9\u05E0\u05D9", "\u05EA\u05E9\u05D9\u05E2\u05D9", "\u05E2\u05E9\u05D9\u05E8\u05D9"];
      var female = ["\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4", "\u05E9\u05E0\u05D9\u05D9\u05D4", "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA", "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA", "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA", "\u05E9\u05D9\u05E9\u05D9\u05EA", "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA", "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA", "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA", "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"];
      var index = number - 1;
      return isFemale ? female[index] : male[index];
    };
    localize33 = {
      ordinalNumber: ordinalNumber65,
      era: buildLocalizeFn({
        values: eraValues33,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues33,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback33(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues33,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues33,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues33,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues27,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default33 = localize33;
  }
});

// ../../node_modules/date-fns/esm/locale/he/_lib/match/index.js
var matchOrdinalNumberPattern32, parseOrdinalNumberPattern32, matchEraPatterns32, parseEraPatterns32, matchQuarterPatterns32, parseQuarterPatterns32, matchMonthPatterns32, parseMonthPatterns32, matchDayPatterns32, parseDayPatterns32, matchDayPeriodPatterns32, parseDayPeriodPatterns32, ordinalName, match32, match_default32;
var init_match32 = __esm({
  "../../node_modules/date-fns/esm/locale/he/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern32 = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
    parseOrdinalNumberPattern32 = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
    matchEraPatterns32 = {
      narrow: /^ל(ספירה|פנה״ס)/i,
      abbreviated: /^ל(ספירה|פנה״ס)/i,
      wide: /^ל(פני ה)?ספירה/i
    };
    parseEraPatterns32 = {
      any: [/^לפ/i, /^לס/i]
    };
    matchQuarterPatterns32 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^רבעון [1234]/i
    };
    parseQuarterPatterns32 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns32 = {
      narrow: /^\d+/i,
      abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
      wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
    };
    parseMonthPatterns32 = {
      narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
      any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
    };
    matchDayPatterns32 = {
      narrow: /^[אבגדהוש]׳/i,
      short: /^[אבגדהוש]׳/i,
      abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
      wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
    };
    parseDayPatterns32 = {
      abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
      wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
      any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
    };
    matchDayPeriodPatterns32 = {
      any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
    };
    parseDayPeriodPatterns32 = {
      any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
      }
    };
    ordinalName = ["\u05E8\u05D0", "\u05E9\u05E0", "\u05E9\u05DC", "\u05E8\u05D1", "\u05D7", "\u05E9\u05D9", "\u05E9\u05D1", "\u05E9\u05DE", "\u05EA", "\u05E2"];
    match32 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern32,
        parsePattern: parseOrdinalNumberPattern32,
        valueCallback: function valueCallback63(value) {
          var number = parseInt(value, 10);
          return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns32,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns32,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns32,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns32,
        defaultParseWidth: "any",
        valueCallback: function valueCallback64(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns32,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns32,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns32,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns32,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns32,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns32,
        defaultParseWidth: "any"
      })
    };
    match_default32 = match32;
  }
});

// ../../node_modules/date-fns/esm/locale/he/index.js
var locale42, he_default;
var init_he = __esm({
  "../../node_modules/date-fns/esm/locale/he/index.js"() {
    "use strict";
    init_formatDistance34();
    init_formatLong40();
    init_formatRelative34();
    init_localize33();
    init_match32();
    locale42 = {
      code: "he",
      formatDistance: formatDistance_default33,
      formatLong: formatLong_default40,
      formatRelative: formatRelative_default33,
      localize: localize_default33,
      match: match_default32,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    he_default = locale42;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/_lib/localize/index.js
function localeToNumber(locale94) {
  var enNumber = locale94.toString().replace(/[१२३४५६७८९०]/g, function(match83) {
    return numberValues2.number[match83];
  });
  return Number(enNumber);
}
function numberToLocale2(enNumber) {
  return enNumber.toString().replace(/\d/g, function(match83) {
    return numberValues2.locale[match83];
  });
}
var numberValues2, eraValues34, quarterValues34, monthValues34, dayValues34, dayPeriodValues34, formattingDayPeriodValues28, ordinalNumber67, localize34, localize_default34;
var init_localize34 = __esm({
  "../../node_modules/date-fns/esm/locale/hi/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    numberValues2 = {
      locale: {
        "1": "\u0967",
        "2": "\u0968",
        "3": "\u0969",
        "4": "\u096A",
        "5": "\u096B",
        "6": "\u096C",
        "7": "\u096D",
        "8": "\u096E",
        "9": "\u096F",
        "0": "\u0966"
      },
      number: {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
      }
    };
    eraValues34 = {
      narrow: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u094D\u0935\u0940"],
      abbreviated: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u094D\u0935\u0940"],
      wide: ["\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935", "\u0908\u0938\u0935\u0940 \u0938\u0928"]
    };
    quarterValues34 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u0924\u093F1", "\u0924\u093F2", "\u0924\u093F3", "\u0924\u093F4"],
      wide: ["\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940", "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"]
    };
    monthValues34 = {
      narrow: ["\u091C", "\u092B\u093C", "\u092E\u093E", "\u0905", "\u092E\u0908", "\u091C\u0942", "\u091C\u0941", "\u0905\u0917", "\u0938\u093F", "\u0905\u0915\u094D\u091F\u0942", "\u0928", "\u0926\u093F"],
      abbreviated: ["\u091C\u0928", "\u092B\u093C\u0930", "\u092E\u093E\u0930\u094D\u091A", "\u0905\u092A\u094D\u0930\u0948\u0932", "\u092E\u0908", "\u091C\u0942\u0928", "\u091C\u0941\u0932", "\u0905\u0917", "\u0938\u093F\u0924", "\u0905\u0915\u094D\u091F\u0942", "\u0928\u0935", "\u0926\u093F\u0938"],
      wide: ["\u091C\u0928\u0935\u0930\u0940", "\u092B\u093C\u0930\u0935\u0930\u0940", "\u092E\u093E\u0930\u094D\u091A", "\u0905\u092A\u094D\u0930\u0948\u0932", "\u092E\u0908", "\u091C\u0942\u0928", "\u091C\u0941\u0932\u093E\u0908", "\u0905\u0917\u0938\u094D\u0924", "\u0938\u093F\u0924\u0902\u092C\u0930", "\u0905\u0915\u094D\u091F\u0942\u092C\u0930", "\u0928\u0935\u0902\u092C\u0930", "\u0926\u093F\u0938\u0902\u092C\u0930"]
    };
    dayValues34 = {
      narrow: ["\u0930", "\u0938\u094B", "\u092E\u0902", "\u092C\u0941", "\u0917\u0941", "\u0936\u0941", "\u0936"],
      short: ["\u0930", "\u0938\u094B", "\u092E\u0902", "\u092C\u0941", "\u0917\u0941", "\u0936\u0941", "\u0936"],
      abbreviated: ["\u0930\u0935\u093F", "\u0938\u094B\u092E", "\u092E\u0902\u0917\u0932", "\u092C\u0941\u0927", "\u0917\u0941\u0930\u0941", "\u0936\u0941\u0915\u094D\u0930", "\u0936\u0928\u093F"],
      wide: ["\u0930\u0935\u093F\u0935\u093E\u0930", "\u0938\u094B\u092E\u0935\u093E\u0930", "\u092E\u0902\u0917\u0932\u0935\u093E\u0930", "\u092C\u0941\u0927\u0935\u093E\u0930", "\u0917\u0941\u0930\u0941\u0935\u093E\u0930", "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930", "\u0936\u0928\u093F\u0935\u093E\u0930"]
    };
    dayPeriodValues34 = {
      narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      },
      abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      },
      wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      }
    };
    formattingDayPeriodValues28 = {
      narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      },
      abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      },
      wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
      }
    };
    ordinalNumber67 = function ordinalNumber68(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return numberToLocale2(number);
    };
    localize34 = {
      ordinalNumber: ordinalNumber67,
      era: buildLocalizeFn({
        values: eraValues34,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues34,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback34(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues34,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues34,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues34,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues28,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default34 = localize34;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/_lib/formatDistance/index.js
var formatDistanceLocale34, formatDistance68, formatDistance_default34;
var init_formatDistance35 = __esm({
  "../../node_modules/date-fns/esm/locale/hi/_lib/formatDistance/index.js"() {
    "use strict";
    init_localize34();
    formatDistanceLocale34 = {
      lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
      },
      xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
      },
      halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
      lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
      },
      xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
      },
      aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
      },
      xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947"
        // CLDR #4467
      },
      xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
      },
      aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
      },
      xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
      },
      aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
      },
      xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
      },
      aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
        // CLDR #4823
      },
      xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
      },
      overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
      },
      almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
      }
    };
    formatDistance68 = function formatDistance69(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale34[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", numberToLocale2(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u092E\u0947 ";
        } else {
          return result + " \u092A\u0939\u0932\u0947";
        }
      }
      return result;
    };
    formatDistance_default34 = formatDistance68;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/_lib/formatLong/index.js
var dateFormats41, timeFormats41, dateTimeFormats41, formatLong41, formatLong_default41;
var init_formatLong41 = __esm({
  "../../node_modules/date-fns/esm/locale/hi/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats41 = {
      full: "EEEE, do MMMM, y",
      // CLDR #1787
      long: "do MMMM, y",
      // CLDR #1788
      medium: "d MMM, y",
      // CLDR #1789
      short: "dd/MM/yyyy"
      // CLDR #1790
    };
    timeFormats41 = {
      full: "h:mm:ss a zzzz",
      // CLDR #1791
      long: "h:mm:ss a z",
      // CLDR #1792
      medium: "h:mm:ss a",
      // CLDR #1793
      short: "h:mm a"
      // CLDR #1794
    };
    dateTimeFormats41 = {
      full: "{{date}} '\u0915\u094B' {{time}}",
      // CLDR #1795
      long: "{{date}} '\u0915\u094B' {{time}}",
      // CLDR #1796
      medium: "{{date}}, {{time}}",
      // CLDR #1797
      short: "{{date}}, {{time}}"
      // CLDR #1798
    };
    formatLong41 = {
      date: buildFormatLongFn({
        formats: dateFormats41,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats41,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats41,
        defaultWidth: "full"
      })
    };
    formatLong_default41 = formatLong41;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/_lib/formatRelative/index.js
var formatRelativeLocale34, formatRelative68, formatRelative_default34;
var init_formatRelative35 = __esm({
  "../../node_modules/date-fns/esm/locale/hi/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale34 = {
      lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
      yesterday: "'\u0915\u0932' p",
      today: "'\u0906\u091C' p",
      tomorrow: "'\u0915\u0932' p",
      nextWeek: "eeee '\u0915\u094B' p",
      other: "P"
    };
    formatRelative68 = function formatRelative69(token, _date, _baseDate, _options) {
      return formatRelativeLocale34[token];
    };
    formatRelative_default34 = formatRelative68;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/_lib/match/index.js
var matchOrdinalNumberPattern33, parseOrdinalNumberPattern33, matchEraPatterns33, parseEraPatterns33, matchQuarterPatterns33, parseQuarterPatterns33, matchMonthPatterns33, parseMonthPatterns33, matchDayPatterns33, parseDayPatterns33, matchDayPeriodPatterns33, parseDayPeriodPatterns33, match33, match_default33;
var init_match33 = __esm({
  "../../node_modules/date-fns/esm/locale/hi/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    init_localize34();
    matchOrdinalNumberPattern33 = /^[०१२३४५६७८९]+/i;
    parseOrdinalNumberPattern33 = /^[०१२३४५६७८९]+/i;
    matchEraPatterns33 = {
      narrow: /^(ईसा-पूर्व|ईस्वी)/i,
      abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
      wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
    };
    parseEraPatterns33 = {
      any: [/^b/i, /^(a|c)/i]
    };
    matchQuarterPatterns33 = {
      narrow: /^[1234]/i,
      abbreviated: /^ति[1234]/i,
      wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
    };
    parseQuarterPatterns33 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns33 = {
      // eslint-disable-next-line no-misleading-character-class
      narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
      abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
      wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
    };
    parseMonthPatterns33 = {
      narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
      any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
    };
    matchDayPatterns33 = {
      // eslint-disable-next-line no-misleading-character-class
      narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
      short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
      abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
      wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
    };
    parseDayPatterns33 = {
      narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
      any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
    };
    matchDayPeriodPatterns33 = {
      narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
      any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
    };
    parseDayPeriodPatterns33 = {
      any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
      }
    };
    match33 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern33,
        parsePattern: parseOrdinalNumberPattern33,
        valueCallback: localeToNumber
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns33,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns33,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns33,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns33,
        defaultParseWidth: "any",
        valueCallback: function valueCallback65(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns33,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns33,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns33,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns33,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns33,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns33,
        defaultParseWidth: "any"
      })
    };
    match_default33 = match33;
  }
});

// ../../node_modules/date-fns/esm/locale/hi/index.js
var locale43, hi_default;
var init_hi = __esm({
  "../../node_modules/date-fns/esm/locale/hi/index.js"() {
    "use strict";
    init_formatDistance35();
    init_formatLong41();
    init_formatRelative35();
    init_localize34();
    init_match33();
    locale43 = {
      code: "hi",
      formatDistance: formatDistance_default34,
      formatLong: formatLong_default41,
      formatRelative: formatRelative_default34,
      localize: localize_default34,
      match: match_default33,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 4
      }
    };
    hi_default = locale43;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/_lib/formatDistance/index.js
var formatDistanceLocale35, formatDistance70, formatDistance_default35;
var init_formatDistance36 = __esm({
  "../../node_modules/date-fns/esm/locale/hr/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale35 = {
      lessThanXSeconds: {
        one: {
          standalone: "manje od 1 sekunde",
          withPrepositionAgo: "manje od 1 sekunde",
          withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
      },
      xSeconds: {
        one: {
          standalone: "1 sekunda",
          withPrepositionAgo: "1 sekunde",
          withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
      },
      halfAMinute: "pola minute",
      lessThanXMinutes: {
        one: {
          standalone: "manje od 1 minute",
          withPrepositionAgo: "manje od 1 minute",
          withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
      },
      xMinutes: {
        one: {
          standalone: "1 minuta",
          withPrepositionAgo: "1 minute",
          withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
      },
      aboutXHours: {
        one: {
          standalone: "oko 1 sat",
          withPrepositionAgo: "oko 1 sat",
          withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
      },
      xHours: {
        one: {
          standalone: "1 sat",
          withPrepositionAgo: "1 sat",
          withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
      },
      xDays: {
        one: {
          standalone: "1 dan",
          withPrepositionAgo: "1 dan",
          withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
      },
      aboutXWeeks: {
        one: {
          standalone: "oko 1 tjedan",
          withPrepositionAgo: "oko 1 tjedan",
          withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
      },
      xWeeks: {
        one: {
          standalone: "1 tjedan",
          withPrepositionAgo: "1 tjedan",
          withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
      },
      aboutXMonths: {
        one: {
          standalone: "oko 1 mjesec",
          withPrepositionAgo: "oko 1 mjesec",
          withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
      },
      xMonths: {
        one: {
          standalone: "1 mjesec",
          withPrepositionAgo: "1 mjesec",
          withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
      },
      aboutXYears: {
        one: {
          standalone: "oko 1 godinu",
          withPrepositionAgo: "oko 1 godinu",
          withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
      },
      xYears: {
        one: {
          standalone: "1 godina",
          withPrepositionAgo: "1 godine",
          withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
      },
      overXYears: {
        one: {
          standalone: "preko 1 godinu",
          withPrepositionAgo: "preko 1 godinu",
          withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
      },
      almostXYears: {
        one: {
          standalone: "gotovo 1 godinu",
          withPrepositionAgo: "gotovo 1 godinu",
          withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
      }
    };
    formatDistance70 = function formatDistance71(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale35[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            result = tokenValue.one.withPrepositionIn;
          } else {
            result = tokenValue.one.withPrepositionAgo;
          }
        } else {
          result = tokenValue.one.standalone;
        }
      } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
      String(count).substr(-2, 1) !== "1") {
        result = tokenValue.dual.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "za " + result;
        } else {
          return "prije " + result;
        }
      }
      return result;
    };
    formatDistance_default35 = formatDistance70;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/_lib/formatLong/index.js
var dateFormats42, timeFormats42, dateTimeFormats42, formatLong42, formatLong_default42;
var init_formatLong42 = __esm({
  "../../node_modules/date-fns/esm/locale/hr/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats42 = {
      full: "EEEE, d. MMMM y.",
      long: "d. MMMM y.",
      medium: "d. MMM y.",
      short: "dd. MM. y."
    };
    timeFormats42 = {
      full: "HH:mm:ss (zzzz)",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats42 = {
      full: "{{date}} 'u' {{time}}",
      long: "{{date}} 'u' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong42 = {
      date: buildFormatLongFn({
        formats: dateFormats42,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats42,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats42,
        defaultWidth: "full"
      })
    };
    formatLong_default42 = formatLong42;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/_lib/formatRelative/index.js
var formatRelativeLocale35, formatRelative70, formatRelative_default35;
var init_formatRelative36 = __esm({
  "../../node_modules/date-fns/esm/locale/hr/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale35 = {
      lastWeek: function lastWeek6(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'pro\u0161lu nedjelju u' p";
          case 3:
            return "'pro\u0161lu srijedu u' p";
          case 6:
            return "'pro\u0161lu subotu u' p";
          default:
            return "'pro\u0161li' EEEE 'u' p";
        }
      },
      yesterday: "'ju\u010Der u' p",
      today: "'danas u' p",
      tomorrow: "'sutra u' p",
      nextWeek: function nextWeek6(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'idu\u0107u nedjelju u' p";
          case 3:
            return "'idu\u0107u srijedu u' p";
          case 6:
            return "'idu\u0107u subotu u' p";
          default:
            return "'pro\u0161li' EEEE 'u' p";
        }
      },
      other: "P"
    };
    formatRelative70 = function formatRelative71(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale35[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default35 = formatRelative70;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/_lib/localize/index.js
var eraValues35, quarterValues35, monthValues35, formattingMonthValues9, dayValues35, formattingDayPeriodValues29, dayPeriodValues35, ordinalNumber69, localize35, localize_default35;
var init_localize35 = __esm({
  "../../node_modules/date-fns/esm/locale/hr/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues35 = {
      narrow: ["pr.n.e.", "AD"],
      abbreviated: ["pr. Kr.", "po. Kr."],
      wide: ["Prije Krista", "Poslije Krista"]
    };
    quarterValues35 = {
      narrow: ["1.", "2.", "3.", "4."],
      abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues35 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["sij", "velj", "o\u017Eu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
      wide: ["sije\u010Danj", "velja\u010Da", "o\u017Eujak", "travanj", "svibanj", "lipanj", "srpanj", "kolovoz", "rujan", "listopad", "studeni", "prosinac"]
    };
    formattingMonthValues9 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["sij", "velj", "o\u017Eu", "tra", "svi", "lip", "srp", "kol", "ruj", "lis", "stu", "pro"],
      wide: ["sije\u010Dnja", "velja\u010De", "o\u017Eujka", "travnja", "svibnja", "lipnja", "srpnja", "kolovoza", "rujna", "listopada", "studenog", "prosinca"]
    };
    dayValues35 = {
      narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
      short: ["ned", "pon", "uto", "sri", "\u010Det", "pet", "sub"],
      abbreviated: ["ned", "pon", "uto", "sri", "\u010Det", "pet", "sub"],
      wide: ["nedjelja", "ponedjeljak", "utorak", "srijeda", "\u010Detvrtak", "petak", "subota"]
    };
    formattingDayPeriodValues29 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      }
    };
    dayPeriodValues35 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
      }
    };
    ordinalNumber69 = function ordinalNumber70(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize35 = {
      ordinalNumber: ordinalNumber69,
      era: buildLocalizeFn({
        values: eraValues35,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues35,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback35(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues35,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues9,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues35,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues35,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues29,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default35 = localize35;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/_lib/match/index.js
var matchOrdinalNumberPattern34, parseOrdinalNumberPattern34, matchEraPatterns34, parseEraPatterns34, matchQuarterPatterns34, parseQuarterPatterns34, matchMonthPatterns34, parseMonthPatterns34, matchDayPatterns34, parseDayPatterns34, matchDayPeriodPatterns34, parseDayPeriodPatterns34, match34, match_default34;
var init_match34 = __esm({
  "../../node_modules/date-fns/esm/locale/hr/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern34 = /^(\d+)\./i;
    parseOrdinalNumberPattern34 = /\d+/i;
    matchEraPatterns34 = {
      narrow: /^(pr\.n\.e\.|AD)/i,
      abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
      wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
    };
    parseEraPatterns34 = {
      any: [/^pr/i, /^(po|nova)/i]
    };
    matchQuarterPatterns34 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\.\s?kv\.?/i,
      wide: /^[1234]\. kvartal/i
    };
    parseQuarterPatterns34 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns34 = {
      narrow: /^(10|11|12|[123456789])\./i,
      abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
      wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
    };
    parseMonthPatterns34 = {
      narrow: [/1/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i, /8/i, /9/i, /10/i, /11/i, /12/i],
      abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
      wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
    };
    matchDayPatterns34 = {
      narrow: /^[npusčc]/i,
      short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
      abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
      wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
    };
    parseDayPatterns34 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns34 = {
      any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
    };
    parseDayPeriodPatterns34 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
      }
    };
    match34 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern34,
        parsePattern: parseOrdinalNumberPattern34,
        valueCallback: function valueCallback66(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns34,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns34,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns34,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns34,
        defaultParseWidth: "any",
        valueCallback: function valueCallback67(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns34,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns34,
        defaultParseWidth: "wide"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns34,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns34,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns34,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns34,
        defaultParseWidth: "any"
      })
    };
    match_default34 = match34;
  }
});

// ../../node_modules/date-fns/esm/locale/hr/index.js
var locale44, hr_default;
var init_hr = __esm({
  "../../node_modules/date-fns/esm/locale/hr/index.js"() {
    "use strict";
    init_formatDistance36();
    init_formatLong42();
    init_formatRelative36();
    init_localize35();
    init_match34();
    locale44 = {
      code: "hr",
      formatDistance: formatDistance_default35,
      formatLong: formatLong_default42,
      formatRelative: formatRelative_default35,
      localize: localize_default35,
      match: match_default34,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    hr_default = locale44;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/_lib/formatDistance/index.js
var formatDistanceLocale36, formatDistance72, formatDistance_default36;
var init_formatDistance37 = __esm({
  "../../node_modules/date-fns/esm/locale/ht/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale36 = {
      lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
      },
      xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
      },
      halfAMinute: "30 segond",
      lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
      },
      xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
      },
      aboutXHours: {
        one: "anviwon in\xE8",
        other: "anviwon {{count}} \xE8"
      },
      xHours: {
        one: "1 l\xE8",
        other: "{{count}} l\xE8"
      },
      xDays: {
        one: "1 jou",
        other: "{{count}} jou"
      },
      aboutXWeeks: {
        one: "anviwon 1 sem\xE8n",
        other: "anviwon {{count}} sem\xE8n"
      },
      xWeeks: {
        one: "1 sem\xE8n",
        other: "{{count}} sem\xE8n"
      },
      aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
      },
      xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
      },
      aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
      },
      xYears: {
        one: "1 an",
        other: "{{count}} an"
      },
      overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
      },
      almostXYears: {
        one: "pr\xE8ske 1 an",
        other: "pr\xE8ske {{count}} an"
      }
    };
    formatDistance72 = function formatDistance73(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale36[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "nan " + result;
        } else {
          return "sa f\xE8 " + result;
        }
      }
      return result;
    };
    formatDistance_default36 = formatDistance72;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/_lib/formatLong/index.js
var dateFormats43, timeFormats43, dateTimeFormats43, formatLong43, formatLong_default43;
var init_formatLong43 = __esm({
  "../../node_modules/date-fns/esm/locale/ht/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats43 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats43 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats43 = {
      full: "{{date}} 'nan l\xE8' {{time}}",
      long: "{{date}} 'nan l\xE8' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong43 = {
      date: buildFormatLongFn({
        formats: dateFormats43,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats43,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats43,
        defaultWidth: "full"
      })
    };
    formatLong_default43 = formatLong43;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/_lib/formatRelative/index.js
var formatRelativeLocale36, formatRelative72, formatRelative_default36;
var init_formatRelative37 = __esm({
  "../../node_modules/date-fns/esm/locale/ht/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale36 = {
      lastWeek: "eeee 'pase nan l\xE8' p",
      yesterday: "'y\xE8 nan l\xE8' p",
      today: "'jodi a' p",
      tomorrow: "'demen nan l\xE8' p'",
      nextWeek: "eeee 'pwochen nan l\xE8' p",
      other: "P"
    };
    formatRelative72 = function formatRelative73(token, _date, _baseDate, _options) {
      return formatRelativeLocale36[token];
    };
    formatRelative_default36 = formatRelative72;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/_lib/localize/index.js
var eraValues36, quarterValues36, monthValues36, dayValues36, dayPeriodValues36, ordinalNumber71, localize36, localize_default36;
var init_localize36 = __esm({
  "../../node_modules/date-fns/esm/locale/ht/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues36 = {
      narrow: ["av. J.-K", "ap. J.-K"],
      abbreviated: ["av. J.-K", "ap. J.-K"],
      wide: ["anvan Jezi Kris", "apre Jezi Kris"]
    };
    quarterValues36 = {
      narrow: ["T1", "T2", "T3", "T4"],
      abbreviated: ["1ye trim.", "2y\xE8m trim.", "3y\xE8m trim.", "4y\xE8m trim."],
      wide: ["1ye trim\xE8s", "2y\xE8m trim\xE8s", "3y\xE8m trim\xE8s", "4y\xE8m trim\xE8s"]
    };
    monthValues36 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
      abbreviated: ["janv.", "fevr.", "mas", "avr.", "me", "jen", "jiy\xE8", "out", "sept.", "okt.", "nov.", "des."],
      wide: ["janvye", "fevrye", "mas", "avril", "me", "jen", "jiy\xE8", "out", "septanm", "okt\xF2b", "novanm", "desanm"]
    };
    dayValues36 = {
      narrow: ["D", "L", "M", "M", "J", "V", "S"],
      short: ["di", "le", "ma", "m\xE8", "je", "va", "sa"],
      abbreviated: ["dim.", "len.", "mad.", "m\xE8k.", "jed.", "van.", "sam."],
      wide: ["dimanch", "lendi", "madi", "m\xE8kredi", "jedi", "vandredi", "samdi"]
    };
    dayPeriodValues36 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xE8midi",
        evening: "swa",
        night: "maten"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xE8midi",
        evening: "nan asw\xE8",
        night: "nan maten"
      }
    };
    ordinalNumber71 = function ordinalNumber72(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      if (number === 0) return String(number);
      var suffix = number === 1 ? "ye" : "y\xE8m";
      return number + suffix;
    };
    localize36 = {
      ordinalNumber: ordinalNumber71,
      era: buildLocalizeFn({
        values: eraValues36,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues36,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback36(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues36,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues36,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues36,
        defaultWidth: "wide"
      })
    };
    localize_default36 = localize36;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/_lib/match/index.js
var matchOrdinalNumberPattern35, parseOrdinalNumberPattern35, matchEraPatterns35, parseEraPatterns35, matchQuarterPatterns35, parseQuarterPatterns35, matchMonthPatterns35, parseMonthPatterns35, matchDayPatterns35, parseDayPatterns35, matchDayPeriodPatterns35, parseDayPeriodPatterns35, match35, match_default35;
var init_match35 = __esm({
  "../../node_modules/date-fns/esm/locale/ht/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern35 = /^(\d+)(ye|yèm)?/i;
    parseOrdinalNumberPattern35 = /\d+/i;
    matchEraPatterns35 = {
      narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
      abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
      wide: /^(avan Jezi Kris|apre Jezi Kris)/i
    };
    parseEraPatterns35 = {
      any: [/^av/i, /^ap/i]
    };
    matchQuarterPatterns35 = {
      narrow: /^[1234]/i,
      abbreviated: /^t[1234]/i,
      wide: /^[1234](ye|yèm)? trimès/i
    };
    parseQuarterPatterns35 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns35 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
      wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
    };
    parseMonthPatterns35 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
    };
    matchDayPatterns35 = {
      narrow: /^[lmjvsd]/i,
      short: /^(di|le|ma|me|je|va|sa)/i,
      abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
      wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
    };
    parseDayPatterns35 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
      any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
    };
    matchDayPeriodPatterns35 = {
      narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
      any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
    };
    parseDayPeriodPatterns35 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
      }
    };
    match35 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern35,
        parsePattern: parseOrdinalNumberPattern35,
        valueCallback: function valueCallback68(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns35,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns35,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns35,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns35,
        defaultParseWidth: "any",
        valueCallback: function valueCallback69(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns35,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns35,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns35,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns35,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns35,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns35,
        defaultParseWidth: "any"
      })
    };
    match_default35 = match35;
  }
});

// ../../node_modules/date-fns/esm/locale/ht/index.js
var locale45, ht_default;
var init_ht = __esm({
  "../../node_modules/date-fns/esm/locale/ht/index.js"() {
    "use strict";
    init_formatDistance37();
    init_formatLong43();
    init_formatRelative37();
    init_localize36();
    init_match35();
    locale45 = {
      code: "ht",
      formatDistance: formatDistance_default36,
      formatLong: formatLong_default43,
      formatRelative: formatRelative_default36,
      localize: localize_default36,
      match: match_default35,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    ht_default = locale45;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatDistance/index.js
var translations, withoutSuffixes, withSuffixes, formatDistance74, formatDistance_default37;
var init_formatDistance38 = __esm({
  "../../node_modules/date-fns/esm/locale/hu/_lib/formatDistance/index.js"() {
    "use strict";
    translations = {
      about: "k\xF6r\xFClbel\xFCl",
      over: "t\xF6bb mint",
      almost: "majdnem",
      lessthan: "kevesebb mint"
    };
    withoutSuffixes = {
      xseconds: " m\xE1sodperc",
      halfaminute: "f\xE9l perc",
      xminutes: " perc",
      xhours: " \xF3ra",
      xdays: " nap",
      xweeks: " h\xE9t",
      xmonths: " h\xF3nap",
      xyears: " \xE9v"
    };
    withSuffixes = {
      xseconds: {
        "-1": " m\xE1sodperccel ezel\u0151tt",
        "1": " m\xE1sodperc m\xFAlva",
        "0": " m\xE1sodperce"
      },
      halfaminute: {
        "-1": "f\xE9l perccel ezel\u0151tt",
        "1": "f\xE9l perc m\xFAlva",
        "0": "f\xE9l perce"
      },
      xminutes: {
        "-1": " perccel ezel\u0151tt",
        "1": " perc m\xFAlva",
        "0": " perce"
      },
      xhours: {
        "-1": " \xF3r\xE1val ezel\u0151tt",
        "1": " \xF3ra m\xFAlva",
        "0": " \xF3r\xE1ja"
      },
      xdays: {
        "-1": " nappal ezel\u0151tt",
        "1": " nap m\xFAlva",
        "0": " napja"
      },
      xweeks: {
        "-1": " h\xE9ttel ezel\u0151tt",
        "1": " h\xE9t m\xFAlva",
        "0": " hete"
      },
      xmonths: {
        "-1": " h\xF3nappal ezel\u0151tt",
        "1": " h\xF3nap m\xFAlva",
        "0": " h\xF3napja"
      },
      xyears: {
        "-1": " \xE9vvel ezel\u0151tt",
        "1": " \xE9v m\xFAlva",
        "0": " \xE9ve"
      }
    };
    formatDistance74 = function formatDistance75(token, count, options) {
      var adverb = token.match(/about|over|almost|lessthan/i);
      var unit = adverb ? token.replace(adverb[0], "") : token;
      var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
      var key = unit.toLowerCase();
      var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
      var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
      var result = key === "halfaminute" ? translated : count + translated;
      if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = translations[adv] + " " + result;
      }
      return result;
    };
    formatDistance_default37 = formatDistance74;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatLong/index.js
var dateFormats44, timeFormats44, dateTimeFormats44, formatLong44, formatLong_default44;
var init_formatLong44 = __esm({
  "../../node_modules/date-fns/esm/locale/hu/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats44 = {
      full: "y. MMMM d., EEEE",
      long: "y. MMMM d.",
      medium: "y. MMM d.",
      short: "y. MM. dd."
    };
    timeFormats44 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats44 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong44 = {
      date: buildFormatLongFn({
        formats: dateFormats44,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats44,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats44,
        defaultWidth: "full"
      })
    };
    formatLong_default44 = formatLong44;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/_lib/formatRelative/index.js
function week(isFuture2) {
  return function(date) {
    var weekday = accusativeWeekdays4[date.getUTCDay()];
    var prefix = isFuture2 ? "" : "'m\xFAlt' ";
    return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
  };
}
var accusativeWeekdays4, formatRelativeLocale37, formatRelative74, formatRelative_default37;
var init_formatRelative38 = __esm({
  "../../node_modules/date-fns/esm/locale/hu/_lib/formatRelative/index.js"() {
    "use strict";
    accusativeWeekdays4 = ["vas\xE1rnap", "h\xE9tf\u0151n", "kedden", "szerd\xE1n", "cs\xFCt\xF6rt\xF6k\xF6n", "p\xE9nteken", "szombaton"];
    formatRelativeLocale37 = {
      lastWeek: week(false),
      yesterday: "'tegnap' p'-kor'",
      today: "'ma' p'-kor'",
      tomorrow: "'holnap' p'-kor'",
      nextWeek: week(true),
      other: "P"
    };
    formatRelative74 = function formatRelative75(token, date) {
      var format2 = formatRelativeLocale37[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default37 = formatRelative74;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/_lib/localize/index.js
var eraValues37, quarterValues37, formattingQuarterValues, monthValues37, dayValues37, dayPeriodValues37, ordinalNumber73, localize37, localize_default37;
var init_localize37 = __esm({
  "../../node_modules/date-fns/esm/locale/hu/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues37 = {
      narrow: ["ie.", "isz."],
      abbreviated: ["i. e.", "i. sz."],
      wide: ["Krisztus el\u0151tt", "id\u0151sz\xE1m\xEDt\xE1sunk szerint"]
    };
    quarterValues37 = {
      narrow: ["1.", "2.", "3.", "4."],
      abbreviated: ["1. n.\xE9v", "2. n.\xE9v", "3. n.\xE9v", "4. n.\xE9v"],
      wide: ["1. negyed\xE9v", "2. negyed\xE9v", "3. negyed\xE9v", "4. negyed\xE9v"]
    };
    formattingQuarterValues = {
      narrow: ["I.", "II.", "III.", "IV."],
      abbreviated: ["I. n.\xE9v", "II. n.\xE9v", "III. n.\xE9v", "IV. n.\xE9v"],
      wide: ["I. negyed\xE9v", "II. negyed\xE9v", "III. negyed\xE9v", "IV. negyed\xE9v"]
    };
    monthValues37 = {
      narrow: ["J", "F", "M", "\xC1", "M", "J", "J", "A", "Sz", "O", "N", "D"],
      abbreviated: ["jan.", "febr.", "m\xE1rc.", "\xE1pr.", "m\xE1j.", "j\xFAn.", "j\xFAl.", "aug.", "szept.", "okt.", "nov.", "dec."],
      wide: ["janu\xE1r", "febru\xE1r", "m\xE1rcius", "\xE1prilis", "m\xE1jus", "j\xFAnius", "j\xFAlius", "augusztus", "szeptember", "okt\xF3ber", "november", "december"]
    };
    dayValues37 = {
      narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
      short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
      abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
      wide: ["vas\xE1rnap", "h\xE9tf\u0151", "kedd", "szerda", "cs\xFCt\xF6rt\xF6k", "p\xE9ntek", "szombat"]
    };
    dayPeriodValues37 = {
      narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xE9jf\xE9l",
        noon: "d\xE9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xE9jjel"
      },
      abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xE9jf\xE9l",
        noon: "d\xE9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xE9jjel"
      },
      wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xE9jf\xE9l",
        noon: "d\xE9l",
        morning: "reggel",
        afternoon: "d\xE9lut\xE1n",
        evening: "este",
        night: "\xE9jjel"
      }
    };
    ordinalNumber73 = function ordinalNumber74(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize37 = {
      ordinalNumber: ordinalNumber73,
      era: buildLocalizeFn({
        values: eraValues37,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues37,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback37(quarter) {
          return quarter - 1;
        },
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: "wide"
      }),
      month: buildLocalizeFn({
        values: monthValues37,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues37,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues37,
        defaultWidth: "wide"
      })
    };
    localize_default37 = localize37;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/_lib/match/index.js
var matchOrdinalNumberPattern36, parseOrdinalNumberPattern36, matchEraPatterns36, parseEraPatterns36, matchQuarterPatterns36, parseQuarterPatterns36, matchMonthPatterns36, parseMonthPatterns36, matchDayPatterns36, parseDayPatterns36, matchDayPeriodPatterns36, parseDayPeriodPatterns36, match36, match_default36;
var init_match36 = __esm({
  "../../node_modules/date-fns/esm/locale/hu/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern36 = /^(\d+)\.?/i;
    parseOrdinalNumberPattern36 = /\d+/i;
    matchEraPatterns36 = {
      narrow: /^(ie\.|isz\.)/i,
      abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
      wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
    };
    parseEraPatterns36 = {
      narrow: [/ie/i, /isz/i],
      abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
      any: [/előtt/i, /(szerint|i. sz.)/i]
    };
    matchQuarterPatterns36 = {
      narrow: /^[1234]\.?/i,
      abbreviated: /^[1234]?\.?\s?n\.év/i,
      wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
    };
    parseQuarterPatterns36 = {
      any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
    };
    matchMonthPatterns36 = {
      narrow: /^[jfmaásond]|sz/i,
      abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
      wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
    };
    parseMonthPatterns36 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns36 = {
      narrow: /^([vhkpc]|sz|cs|sz)/i,
      short: /^([vhkp]|sze|cs|szo)/i,
      abbreviated: /^([vhkp]|sze|cs|szo)/i,
      wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
    };
    parseDayPatterns36 = {
      narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
      any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
    };
    matchDayPeriodPatterns36 = {
      any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
    };
    parseDayPeriodPatterns36 = {
      any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
      }
    };
    match36 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern36,
        parsePattern: parseOrdinalNumberPattern36,
        valueCallback: function valueCallback70(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns36,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns36,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns36,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns36,
        defaultParseWidth: "any",
        valueCallback: function valueCallback71(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns36,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns36,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns36,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns36,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns36,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns36,
        defaultParseWidth: "any"
      })
    };
    match_default36 = match36;
  }
});

// ../../node_modules/date-fns/esm/locale/hu/index.js
var locale46, hu_default;
var init_hu = __esm({
  "../../node_modules/date-fns/esm/locale/hu/index.js"() {
    "use strict";
    init_formatDistance38();
    init_formatLong44();
    init_formatRelative38();
    init_localize37();
    init_match36();
    locale46 = {
      code: "hu",
      formatDistance: formatDistance_default37,
      formatLong: formatLong_default44,
      formatRelative: formatRelative_default37,
      localize: localize_default37,
      match: match_default36,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    hu_default = locale46;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/_lib/formatDistance/index.js
var formatDistanceLocale37, formatDistance76, formatDistance_default38;
var init_formatDistance39 = __esm({
  "../../node_modules/date-fns/esm/locale/hy/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale37 = {
      lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
      },
      xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
      },
      halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
      lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
      },
      xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
      },
      aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
      },
      xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
      },
      xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
      },
      aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
      },
      xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
      },
      aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
      },
      xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
      },
      aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
      },
      xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
      },
      overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
      },
      almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
      }
    };
    formatDistance76 = function formatDistance77(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale37[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " \u0570\u0565\u057F\u0578";
        } else {
          return result + " \u0561\u057C\u0561\u057B";
        }
      }
      return result;
    };
    formatDistance_default38 = formatDistance76;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/_lib/formatLong/index.js
var dateFormats45, timeFormats45, dateTimeFormats45, formatLong45, formatLong_default45;
var init_formatLong45 = __esm({
  "../../node_modules/date-fns/esm/locale/hy/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats45 = {
      full: "d MMMM, y, EEEE",
      long: "d MMMM, y",
      medium: "d MMM, y",
      short: "dd.MM.yyyy"
    };
    timeFormats45 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats45 = {
      full: "{{date}} '\u056A\u2024'{{time}}",
      long: "{{date}} '\u056A\u2024'{{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong45 = {
      date: buildFormatLongFn({
        formats: dateFormats45,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats45,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats45,
        defaultWidth: "full"
      })
    };
    formatLong_default45 = formatLong45;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/_lib/formatRelative/index.js
var formatRelativeLocale38, formatRelative76, formatRelative_default38;
var init_formatRelative39 = __esm({
  "../../node_modules/date-fns/esm/locale/hy/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale38 = {
      lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
      yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
      today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
      tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
      nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
      other: "P"
    };
    formatRelative76 = function formatRelative77(token, _date, _baseDate, _options) {
      return formatRelativeLocale38[token];
    };
    formatRelative_default38 = formatRelative76;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/_lib/localize/index.js
var eraValues38, quarterValues38, monthValues38, dayValues38, dayPeriodValues38, formattingDayPeriodValues30, ordinalNumber75, localize38, localize_default38;
var init_localize38 = __esm({
  "../../node_modules/date-fns/esm/locale/hy/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues38 = {
      narrow: ["\u0554", "\u0544"],
      abbreviated: ["\u0554\u0531", "\u0544\u0539"],
      wide: ["\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B", "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"]
    };
    quarterValues38 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u05541", "\u05542", "\u05543", "\u05544"],
      wide: ["1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564", "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564", "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564", "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"]
    };
    monthValues38 = {
      narrow: ["\u0540", "\u0553", "\u0544", "\u0531", "\u0544", "\u0540", "\u0540", "\u0555", "\u054D", "\u0540", "\u0546", "\u0534"],
      abbreviated: ["\u0570\u0578\u0582\u0576", "\u0583\u0565\u057F", "\u0574\u0561\u0580", "\u0561\u057A\u0580", "\u0574\u0561\u0575", "\u0570\u0578\u0582\u0576", "\u0570\u0578\u0582\u056C", "\u0585\u0563\u057D", "\u057D\u0565\u057A", "\u0570\u0578\u056F", "\u0576\u0578\u0575", "\u0564\u0565\u056F"],
      wide: ["\u0570\u0578\u0582\u0576\u057E\u0561\u0580", "\u0583\u0565\u057F\u0580\u057E\u0561\u0580", "\u0574\u0561\u0580\u057F", "\u0561\u057A\u0580\u056B\u056C", "\u0574\u0561\u0575\u056B\u057D", "\u0570\u0578\u0582\u0576\u056B\u057D", "\u0570\u0578\u0582\u056C\u056B\u057D", "\u0585\u0563\u0578\u057D\u057F\u0578\u057D", "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580", "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580", "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580", "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"]
    };
    dayValues38 = {
      narrow: ["\u053F", "\u0535", "\u0535", "\u0549", "\u0540", "\u0548", "\u0547"],
      short: ["\u056F\u0580", "\u0565\u0580", "\u0565\u0584", "\u0579\u0584", "\u0570\u0563", "\u0578\u0582\u0580", "\u0577\u0562"],
      abbreviated: ["\u056F\u056B\u0580", "\u0565\u0580\u056F", "\u0565\u0580\u0584", "\u0579\u0578\u0580", "\u0570\u0576\u0563", "\u0578\u0582\u0580\u0562", "\u0577\u0561\u0562"],
      wide: ["\u056F\u056B\u0580\u0561\u056F\u056B", "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B", "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B", "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B", "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B", "\u0578\u0582\u0580\u0562\u0561\u0569", "\u0577\u0561\u0562\u0561\u0569"]
    };
    dayPeriodValues38 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
      }
    };
    formattingDayPeriodValues30 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
      }
    };
    ordinalNumber75 = function ordinalNumber76(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 < 10) {
        if (rem100 % 10 === 1) {
          return number + "\u058A\u056B\u0576";
        }
      }
      return number + "\u058A\u0580\u0564";
    };
    localize38 = {
      ordinalNumber: ordinalNumber75,
      era: buildLocalizeFn({
        values: eraValues38,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues38,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback38(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues38,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues38,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues38,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues30,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default38 = localize38;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/_lib/match/index.js
var matchOrdinalNumberPattern37, parseOrdinalNumberPattern37, matchEraPatterns37, parseEraPatterns37, matchQuarterPatterns37, parseQuarterPatterns37, matchMonthPatterns37, parseMonthPatterns37, matchDayPatterns37, parseDayPatterns37, matchDayPeriodPatterns37, parseDayPeriodPatterns37, match37, match_default37;
var init_match37 = __esm({
  "../../node_modules/date-fns/esm/locale/hy/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern37 = /^(\d+)((-|֊)?(ին|րդ))?/i;
    parseOrdinalNumberPattern37 = /\d+/i;
    matchEraPatterns37 = {
      narrow: /^(Ք|Մ)/i,
      abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
      wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
    };
    parseEraPatterns37 = {
      any: [/^ք/i, /^մ/i]
    };
    matchQuarterPatterns37 = {
      narrow: /^[1234]/i,
      abbreviated: /^ք[1234]/i,
      wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
    };
    parseQuarterPatterns37 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns37 = {
      narrow: /^[հփմաօսնդ]/i,
      abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
      wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
    };
    parseMonthPatterns37 = {
      narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
      any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
    };
    matchDayPatterns37 = {
      narrow: /^[եչհոշկ]/i,
      short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
      abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
      wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
    };
    parseDayPatterns37 = {
      narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
      short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
      abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
      wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
    };
    matchDayPeriodPatterns37 = {
      narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
      any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
    };
    parseDayPeriodPatterns37 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
      }
    };
    match37 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern37,
        parsePattern: parseOrdinalNumberPattern37,
        valueCallback: function valueCallback72(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns37,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns37,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns37,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns37,
        defaultParseWidth: "any",
        valueCallback: function valueCallback73(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns37,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns37,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns37,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns37,
        defaultParseWidth: "wide"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns37,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns37,
        defaultParseWidth: "any"
      })
    };
    match_default37 = match37;
  }
});

// ../../node_modules/date-fns/esm/locale/hy/index.js
var locale47, hy_default;
var init_hy = __esm({
  "../../node_modules/date-fns/esm/locale/hy/index.js"() {
    "use strict";
    init_formatDistance39();
    init_formatLong45();
    init_formatRelative39();
    init_localize38();
    init_match37();
    locale47 = {
      code: "hy",
      formatDistance: formatDistance_default38,
      formatLong: formatLong_default45,
      formatRelative: formatRelative_default38,
      localize: localize_default38,
      match: match_default37,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    hy_default = locale47;
  }
});

// ../../node_modules/date-fns/esm/locale/id/_lib/formatDistance/index.js
var formatDistanceLocale38, formatDistance78, formatDistance_default39;
var init_formatDistance40 = __esm({
  "../../node_modules/date-fns/esm/locale/id/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale38 = {
      lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
      },
      xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
      },
      halfAMinute: "setengah menit",
      lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
      },
      xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
      },
      aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
      },
      xHours: {
        one: "1 jam",
        other: "{{count}} jam"
      },
      xDays: {
        one: "1 hari",
        other: "{{count}} hari"
      },
      aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
      },
      xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
      },
      aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
      },
      xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
      },
      aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
      },
      xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
      },
      overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
      },
      almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
      }
    };
    formatDistance78 = function formatDistance79(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale38[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "dalam waktu " + result;
        } else {
          return result + " yang lalu";
        }
      }
      return result;
    };
    formatDistance_default39 = formatDistance78;
  }
});

// ../../node_modules/date-fns/esm/locale/id/_lib/formatLong/index.js
var dateFormats46, timeFormats46, dateTimeFormats46, formatLong46, formatLong_default46;
var init_formatLong46 = __esm({
  "../../node_modules/date-fns/esm/locale/id/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats46 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "d/M/yyyy"
    };
    timeFormats46 = {
      full: "HH.mm.ss",
      long: "HH.mm.ss",
      medium: "HH.mm",
      short: "HH.mm"
    };
    dateTimeFormats46 = {
      full: "{{date}} 'pukul' {{time}}",
      long: "{{date}} 'pukul' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong46 = {
      date: buildFormatLongFn({
        formats: dateFormats46,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats46,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats46,
        defaultWidth: "full"
      })
    };
    formatLong_default46 = formatLong46;
  }
});

// ../../node_modules/date-fns/esm/locale/id/_lib/formatRelative/index.js
var formatRelativeLocale39, formatRelative78, formatRelative_default39;
var init_formatRelative40 = __esm({
  "../../node_modules/date-fns/esm/locale/id/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale39 = {
      lastWeek: "eeee 'lalu pukul' p",
      yesterday: "'Kemarin pukul' p",
      today: "'Hari ini pukul' p",
      tomorrow: "'Besok pukul' p",
      nextWeek: "eeee 'pukul' p",
      other: "P"
    };
    formatRelative78 = function formatRelative79(token, _date, _baseDate, _options) {
      return formatRelativeLocale39[token];
    };
    formatRelative_default39 = formatRelative78;
  }
});

// ../../node_modules/date-fns/esm/locale/id/_lib/localize/index.js
var eraValues39, quarterValues39, monthValues39, dayValues39, dayPeriodValues39, formattingDayPeriodValues31, ordinalNumber77, localize39, localize_default39;
var init_localize39 = __esm({
  "../../node_modules/date-fns/esm/locale/id/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues39 = {
      narrow: ["SM", "M"],
      abbreviated: ["SM", "M"],
      wide: ["Sebelum Masehi", "Masehi"]
    };
    quarterValues39 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
    };
    monthValues39 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agt", "Sep", "Okt", "Nov", "Des"],
      wide: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
    };
    dayValues39 = {
      narrow: ["M", "S", "S", "R", "K", "J", "S"],
      short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
      abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
      wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
    dayPeriodValues39 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      }
    };
    formattingDayPeriodValues31 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
      }
    };
    ordinalNumber77 = function ordinalNumber78(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return "ke-" + number;
    };
    localize39 = {
      ordinalNumber: ordinalNumber77,
      era: buildLocalizeFn({
        values: eraValues39,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues39,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback39(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues39,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues39,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues39,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues31,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default39 = localize39;
  }
});

// ../../node_modules/date-fns/esm/locale/id/_lib/match/index.js
var matchOrdinalNumberPattern38, parseOrdinalNumberPattern38, matchEraPatterns38, parseEraPatterns38, matchQuarterPatterns38, parseQuarterPatterns38, matchMonthPatterns38, parseMonthPatterns38, matchDayPatterns38, parseDayPatterns38, matchDayPeriodPatterns38, parseDayPeriodPatterns38, match38, match_default38;
var init_match38 = __esm({
  "../../node_modules/date-fns/esm/locale/id/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern38 = /^ke-(\d+)?/i;
    parseOrdinalNumberPattern38 = /\d+/i;
    matchEraPatterns38 = {
      narrow: /^(sm|m)/i,
      abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
      wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
    };
    parseEraPatterns38 = {
      any: [/^s/i, /^(m|e)/i]
    };
    matchQuarterPatterns38 = {
      narrow: /^[1234]/i,
      abbreviated: /^K-?\s[1234]/i,
      wide: /^Kuartal ke-?\s?[1234]/i
    };
    parseQuarterPatterns38 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns38 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
      wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
    };
    parseMonthPatterns38 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns38 = {
      narrow: /^[srkjm]/i,
      short: /^(min|sen|sel|rab|kam|jum|sab)/i,
      abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
      wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
    };
    parseDayPatterns38 = {
      narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
      any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
    };
    matchDayPeriodPatterns38 = {
      narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
      any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
    };
    parseDayPeriodPatterns38 = {
      any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
      }
    };
    match38 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern38,
        parsePattern: parseOrdinalNumberPattern38,
        valueCallback: function valueCallback74(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns38,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns38,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns38,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns38,
        defaultParseWidth: "any",
        valueCallback: function valueCallback75(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns38,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns38,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns38,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns38,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns38,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns38,
        defaultParseWidth: "any"
      })
    };
    match_default38 = match38;
  }
});

// ../../node_modules/date-fns/esm/locale/id/index.js
var locale48, id_default;
var init_id = __esm({
  "../../node_modules/date-fns/esm/locale/id/index.js"() {
    "use strict";
    init_formatDistance40();
    init_formatLong46();
    init_formatRelative40();
    init_localize39();
    init_match38();
    locale48 = {
      code: "id",
      formatDistance: formatDistance_default39,
      formatLong: formatLong_default46,
      formatRelative: formatRelative_default39,
      localize: localize_default39,
      match: match_default38,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    id_default = locale48;
  }
});

// ../../node_modules/date-fns/esm/locale/is/_lib/formatDistance/index.js
var formatDistanceLocale39, formatDistance80, formatDistance_default40;
var init_formatDistance41 = __esm({
  "../../node_modules/date-fns/esm/locale/is/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale39 = {
      lessThanXSeconds: {
        one: "minna en 1 sek\xFAnda",
        other: "minna en {{count}} sek\xFAndur"
      },
      xSeconds: {
        one: "1 sek\xFAnda",
        other: "{{count}} sek\xFAndur"
      },
      halfAMinute: "h\xE1lf m\xEDn\xFAta",
      lessThanXMinutes: {
        one: "minna en 1 m\xEDn\xFAta",
        other: "minna en {{count}} m\xEDn\xFAtur"
      },
      xMinutes: {
        one: "1 m\xEDn\xFAta",
        other: "{{count}} m\xEDn\xFAtur"
      },
      aboutXHours: {
        one: "u.\xFE.b. 1 klukkustund",
        other: "u.\xFE.b. {{count}} klukkustundir"
      },
      xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
      },
      xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
      },
      aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
      },
      xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
      },
      aboutXMonths: {
        one: "u.\xFE.b. 1 m\xE1nu\xF0ur",
        other: "u.\xFE.b. {{count}} m\xE1nu\xF0ir"
      },
      xMonths: {
        one: "1 m\xE1nu\xF0ur",
        other: "{{count}} m\xE1nu\xF0ir"
      },
      aboutXYears: {
        one: "u.\xFE.b. 1 \xE1r",
        other: "u.\xFE.b. {{count}} \xE1r"
      },
      xYears: {
        one: "1 \xE1r",
        other: "{{count}} \xE1r"
      },
      overXYears: {
        one: "meira en 1 \xE1r",
        other: "meira en {{count}} \xE1r"
      },
      almostXYears: {
        one: "n\xE6stum 1 \xE1r",
        other: "n\xE6stum {{count}} \xE1r"
      }
    };
    formatDistance80 = function formatDistance81(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale39[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\xED " + result;
        } else {
          return result + " s\xED\xF0an";
        }
      }
      return result;
    };
    formatDistance_default40 = formatDistance80;
  }
});

// ../../node_modules/date-fns/esm/locale/is/_lib/formatLong/index.js
var dateFormats47, timeFormats47, dateTimeFormats47, formatLong47, formatLong_default47;
var init_formatLong47 = __esm({
  "../../node_modules/date-fns/esm/locale/is/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats47 = {
      full: "EEEE, do MMMM y",
      long: "do MMMM y",
      medium: "do MMM y",
      short: "d.MM.y"
    };
    timeFormats47 = {
      full: "'kl'. HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats47 = {
      full: "{{date}} 'kl.' {{time}}",
      long: "{{date}} 'kl.' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong47 = {
      date: buildFormatLongFn({
        formats: dateFormats47,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats47,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats47,
        defaultWidth: "full"
      })
    };
    formatLong_default47 = formatLong47;
  }
});

// ../../node_modules/date-fns/esm/locale/is/_lib/formatRelative/index.js
var formatRelativeLocale40, formatRelative80, formatRelative_default40;
var init_formatRelative41 = __esm({
  "../../node_modules/date-fns/esm/locale/is/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale40 = {
      lastWeek: "'s\xED\xF0asta' dddd 'kl.' p",
      yesterday: "'\xED g\xE6r kl.' p",
      today: "'\xED dag kl.' p",
      tomorrow: "'\xE1 morgun kl.' p",
      nextWeek: "dddd 'kl.' p",
      other: "P"
    };
    formatRelative80 = function formatRelative81(token, _date, _baseDate, _options) {
      return formatRelativeLocale40[token];
    };
    formatRelative_default40 = formatRelative80;
  }
});

// ../../node_modules/date-fns/esm/locale/is/_lib/localize/index.js
var eraValues40, quarterValues40, monthValues40, dayValues40, dayPeriodValues40, formattingDayPeriodValues32, ordinalNumber79, localize40, localize_default40;
var init_localize40 = __esm({
  "../../node_modules/date-fns/esm/locale/is/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues40 = {
      narrow: ["f.Kr.", "e.Kr."],
      abbreviated: ["f.Kr.", "e.Kr."],
      wide: ["fyrir Krist", "eftir Krist"]
    };
    quarterValues40 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1F", "2F", "3F", "4F"],
      wide: ["1. fj\xF3r\xF0ungur", "2. fj\xF3r\xF0ungur", "3. fj\xF3r\xF0ungur", "4. fj\xF3r\xF0ungur"]
    };
    monthValues40 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "\xC1", "S", "\xD3", "N", "D"],
      abbreviated: ["jan.", "feb.", "mars", "apr\xEDl", "ma\xED", "j\xFAn\xED", "j\xFAl\xED", "\xE1g\xFAst", "sept.", "okt.", "n\xF3v.", "des."],
      wide: ["jan\xFAar", "febr\xFAar", "mars", "apr\xEDl", "ma\xED", "j\xFAn\xED", "j\xFAl\xED", "\xE1g\xFAst", "september", "okt\xF3ber", "n\xF3vember", "desember"]
    };
    dayValues40 = {
      narrow: ["S", "M", "\xDE", "M", "F", "F", "L"],
      short: ["Su", "M\xE1", "\xDEr", "Mi", "Fi", "F\xF6", "La"],
      abbreviated: ["sun.", "m\xE1n.", "\xFEri.", "mi\xF0.", "fim.", "f\xF6s.", "lau."],
      wide: ["sunnudagur", "m\xE1nudagur", "\xFEri\xF0judagur", "mi\xF0vikudagur", "fimmtudagur", "f\xF6studagur", "laugardagur"]
    };
    dayPeriodValues40 = {
      narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xF0n\xE6tti",
        noon: "h\xE1degi",
        morning: "morgunn",
        afternoon: "s\xED\xF0degi",
        evening: "kv\xF6ld",
        night: "n\xF3tt"
      },
      abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xF0n\xE6tti",
        noon: "h\xE1degi",
        morning: "morgunn",
        afternoon: "s\xED\xF0degi",
        evening: "kv\xF6ld",
        night: "n\xF3tt"
      },
      wide: {
        am: "fyrir h\xE1degi",
        pm: "eftir h\xE1degi",
        midnight: "mi\xF0n\xE6tti",
        noon: "h\xE1degi",
        morning: "morgunn",
        afternoon: "s\xED\xF0degi",
        evening: "kv\xF6ld",
        night: "n\xF3tt"
      }
    };
    formattingDayPeriodValues32 = {
      narrow: {
        am: "f",
        pm: "e",
        midnight: "\xE1 mi\xF0n\xE6tti",
        noon: "\xE1 h\xE1degi",
        morning: "a\xF0 morgni",
        afternoon: "s\xED\xF0degis",
        evening: "um kv\xF6ld",
        night: "um n\xF3tt"
      },
      abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xE1 mi\xF0n\xE6tti",
        noon: "\xE1 h\xE1degi",
        morning: "a\xF0 morgni",
        afternoon: "s\xED\xF0degis",
        evening: "um kv\xF6ld",
        night: "um n\xF3tt"
      },
      wide: {
        am: "fyrir h\xE1degi",
        pm: "eftir h\xE1degi",
        midnight: "\xE1 mi\xF0n\xE6tti",
        noon: "\xE1 h\xE1degi",
        morning: "a\xF0 morgni",
        afternoon: "s\xED\xF0degis",
        evening: "um kv\xF6ld",
        night: "um n\xF3tt"
      }
    };
    ordinalNumber79 = function ordinalNumber80(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize40 = {
      ordinalNumber: ordinalNumber79,
      era: buildLocalizeFn({
        values: eraValues40,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues40,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback40(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues40,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues40,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues40,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues32,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default40 = localize40;
  }
});

// ../../node_modules/date-fns/esm/locale/is/_lib/match/index.js
var matchOrdinalNumberPattern39, parseOrdinalNumberPattern39, matchEraPatterns39, parseEraPatterns39, matchQuarterPatterns39, parseQuarterPatterns39, matchMonthPatterns39, parseMonthPatterns39, matchDayPatterns39, parseDayPatterns39, matchDayPeriodPatterns39, parseDayPeriodPatterns39, match39, match_default39;
var init_match39 = __esm({
  "../../node_modules/date-fns/esm/locale/is/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern39 = /^(\d+)(\.)?/i;
    parseOrdinalNumberPattern39 = /\d+(\.)?/i;
    matchEraPatterns39 = {
      narrow: /^(f\.Kr\.|e\.Kr\.)/i,
      abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
      wide: /^(fyrir Krist|eftir Krist)/i
    };
    parseEraPatterns39 = {
      any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
    };
    matchQuarterPatterns39 = {
      narrow: /^[1234]\.?/i,
      abbreviated: /^q[1234]\.?/i,
      wide: /^[1234]\.? fjórðungur/i
    };
    parseQuarterPatterns39 = {
      any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
    };
    matchMonthPatterns39 = {
      narrow: /^[jfmásónd]/i,
      abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
      wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
    };
    parseMonthPatterns39 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
    };
    matchDayPatterns39 = {
      narrow: /^[smtwf]/i,
      short: /^(su|má|þr|mi|fi|fö|la)/i,
      abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
      wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
    };
    parseDayPatterns39 = {
      narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
      any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
    };
    matchDayPeriodPatterns39 = {
      narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
      any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
    };
    parseDayPeriodPatterns39 = {
      any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
      }
    };
    match39 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern39,
        parsePattern: parseOrdinalNumberPattern39,
        valueCallback: function valueCallback76(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns39,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns39,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns39,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns39,
        defaultParseWidth: "any",
        valueCallback: function valueCallback77(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns39,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns39,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns39,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns39,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns39,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns39,
        defaultParseWidth: "any"
      })
    };
    match_default39 = match39;
  }
});

// ../../node_modules/date-fns/esm/locale/is/index.js
var locale49, is_default;
var init_is = __esm({
  "../../node_modules/date-fns/esm/locale/is/index.js"() {
    "use strict";
    init_formatDistance41();
    init_formatLong47();
    init_formatRelative41();
    init_localize40();
    init_match39();
    locale49 = {
      code: "is",
      formatDistance: formatDistance_default40,
      formatLong: formatLong_default47,
      formatRelative: formatRelative_default40,
      localize: localize_default40,
      match: match_default39,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    is_default = locale49;
  }
});

// ../../node_modules/date-fns/esm/locale/it/_lib/formatDistance/index.js
var formatDistanceLocale40, formatDistance82, formatDistance_default41;
var init_formatDistance42 = __esm({
  "../../node_modules/date-fns/esm/locale/it/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale40 = {
      lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
      },
      xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
      },
      halfAMinute: "alcuni secondi",
      lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
      },
      xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
      },
      aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
      },
      xHours: {
        one: "un'ora",
        other: "{{count}} ore"
      },
      xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
      },
      aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
      },
      xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
      },
      aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
      },
      xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
      },
      aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
      },
      xYears: {
        one: "un anno",
        other: "{{count}} anni"
      },
      overXYears: {
        one: "pi\xF9 di un anno",
        other: "pi\xF9 di {{count}} anni"
      },
      almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
      }
    };
    formatDistance82 = function formatDistance83(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale40[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "tra " + result;
        } else {
          return result + " fa";
        }
      }
      return result;
    };
    formatDistance_default41 = formatDistance82;
  }
});

// ../../node_modules/date-fns/esm/locale/it/_lib/formatLong/index.js
var dateFormats48, timeFormats48, dateTimeFormats48, formatLong48, formatLong_default48;
var init_formatLong48 = __esm({
  "../../node_modules/date-fns/esm/locale/it/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats48 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats48 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats48 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong48 = {
      date: buildFormatLongFn({
        formats: dateFormats48,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats48,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats48,
        defaultWidth: "full"
      })
    };
    formatLong_default48 = formatLong48;
  }
});

// ../../node_modules/date-fns/esm/locale/it/_lib/formatRelative/index.js
function _lastWeek(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + weekdays2[day] + " scorso alle' p";
  }
}
function thisWeek4(day) {
  return "'" + weekdays2[day] + " alle' p";
}
function _nextWeek(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + weekdays2[day] + " prossimo alle' p";
  }
}
var weekdays2, formatRelativeLocale41, formatRelative82, formatRelative_default41;
var init_formatRelative42 = __esm({
  "../../node_modules/date-fns/esm/locale/it/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    weekdays2 = ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"];
    formatRelativeLocale41 = {
      lastWeek: function lastWeek7(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek4(day);
        } else {
          return _lastWeek(day);
        }
      },
      yesterday: "'ieri alle' p",
      today: "'oggi alle' p",
      tomorrow: "'domani alle' p",
      nextWeek: function nextWeek7(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek4(day);
        } else {
          return _nextWeek(day);
        }
      },
      other: "P"
    };
    formatRelative82 = function formatRelative83(token, date, baseDate, options) {
      var format2 = formatRelativeLocale41[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default41 = formatRelative82;
  }
});

// ../../node_modules/date-fns/esm/locale/it/_lib/localize/index.js
var eraValues41, quarterValues41, monthValues41, dayValues41, dayPeriodValues41, formattingDayPeriodValues33, ordinalNumber81, localize41, localize_default41;
var init_localize41 = __esm({
  "../../node_modules/date-fns/esm/locale/it/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues41 = {
      narrow: ["aC", "dC"],
      abbreviated: ["a.C.", "d.C."],
      wide: ["avanti Cristo", "dopo Cristo"]
    };
    quarterValues41 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
    };
    monthValues41 = {
      narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
      abbreviated: ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"],
      wide: ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"]
    };
    dayValues41 = {
      narrow: ["D", "L", "M", "M", "G", "V", "S"],
      short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
      abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
      wide: ["domenica", "luned\xEC", "marted\xEC", "mercoled\xEC", "gioved\xEC", "venerd\xEC", "sabato"]
    };
    dayPeriodValues41 = {
      narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
      }
    };
    formattingDayPeriodValues33 = {
      narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
      }
    };
    ordinalNumber81 = function ordinalNumber82(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return String(number);
    };
    localize41 = {
      ordinalNumber: ordinalNumber81,
      era: buildLocalizeFn({
        values: eraValues41,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues41,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback41(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues41,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues41,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues41,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues33,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default41 = localize41;
  }
});

// ../../node_modules/date-fns/esm/locale/it/_lib/match/index.js
var matchOrdinalNumberPattern40, parseOrdinalNumberPattern40, matchEraPatterns40, parseEraPatterns40, matchQuarterPatterns40, parseQuarterPatterns40, matchMonthPatterns40, parseMonthPatterns40, matchDayPatterns40, parseDayPatterns40, matchDayPeriodPatterns40, parseDayPeriodPatterns40, match40, match_default40;
var init_match40 = __esm({
  "../../node_modules/date-fns/esm/locale/it/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern40 = /^(\d+)(º)?/i;
    parseOrdinalNumberPattern40 = /\d+/i;
    matchEraPatterns40 = {
      narrow: /^(aC|dC)/i,
      abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
      wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
    };
    parseEraPatterns40 = {
      any: [/^a/i, /^(d|e)/i]
    };
    matchQuarterPatterns40 = {
      narrow: /^[1234]/i,
      abbreviated: /^t[1234]/i,
      wide: /^[1234](º)? trimestre/i
    };
    parseQuarterPatterns40 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns40 = {
      narrow: /^[gfmalsond]/i,
      abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
      wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
    };
    parseMonthPatterns40 = {
      narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns40 = {
      narrow: /^[dlmgvs]/i,
      short: /^(do|lu|ma|me|gi|ve|sa)/i,
      abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
      wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
    };
    parseDayPatterns40 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
      any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
    };
    matchDayPeriodPatterns40 = {
      narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
      any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
    };
    parseDayPeriodPatterns40 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
      }
    };
    match40 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern40,
        parsePattern: parseOrdinalNumberPattern40,
        valueCallback: function valueCallback78(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns40,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns40,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns40,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns40,
        defaultParseWidth: "any",
        valueCallback: function valueCallback79(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns40,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns40,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns40,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns40,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns40,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns40,
        defaultParseWidth: "any"
      })
    };
    match_default40 = match40;
  }
});

// ../../node_modules/date-fns/esm/locale/it/index.js
var locale50, it_default;
var init_it = __esm({
  "../../node_modules/date-fns/esm/locale/it/index.js"() {
    "use strict";
    init_formatDistance42();
    init_formatLong48();
    init_formatRelative42();
    init_localize41();
    init_match40();
    locale50 = {
      code: "it",
      formatDistance: formatDistance_default41,
      formatLong: formatLong_default48,
      formatRelative: formatRelative_default41,
      localize: localize_default41,
      match: match_default40,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    it_default = locale50;
  }
});

// ../../node_modules/date-fns/esm/locale/it-CH/_lib/formatLong/index.js
var dateFormats49, timeFormats49, dateTimeFormats49, formatLong49, formatLong_default49;
var init_formatLong49 = __esm({
  "../../node_modules/date-fns/esm/locale/it-CH/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats49 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd.MM.y"
    };
    timeFormats49 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats49 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong49 = {
      date: buildFormatLongFn({
        formats: dateFormats49,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats49,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats49,
        defaultWidth: "full"
      })
    };
    formatLong_default49 = formatLong49;
  }
});

// ../../node_modules/date-fns/esm/locale/it-CH/index.js
var locale51, it_CH_default;
var init_it_CH = __esm({
  "../../node_modules/date-fns/esm/locale/it-CH/index.js"() {
    "use strict";
    init_formatDistance42();
    init_formatRelative42();
    init_localize41();
    init_match40();
    init_formatLong49();
    locale51 = {
      code: "it-CH",
      formatDistance: formatDistance_default41,
      formatLong: formatLong_default49,
      formatRelative: formatRelative_default41,
      localize: localize_default41,
      match: match_default40,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    it_CH_default = locale51;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/_lib/formatDistance/index.js
var formatDistanceLocale41, formatDistance84, formatDistance_default42;
var init_formatDistance43 = __esm({
  "../../node_modules/date-fns/esm/locale/ja/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale41 = {
      lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
      },
      xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
      },
      halfAMinute: "30\u79D2",
      lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
      },
      xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
      },
      aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
      },
      xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
      },
      xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
      },
      aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
      },
      xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
      },
      aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
      },
      xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
      },
      aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
      },
      xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
      },
      overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
      },
      almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
      }
    };
    formatDistance84 = function formatDistance85(token, count, options) {
      options = options || {};
      var result;
      var tokenValue = formatDistanceLocale41[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) {
          result = tokenValue.oneWithSuffix;
        } else {
          result = tokenValue.one;
        }
      } else {
        if (options.addSuffix && tokenValue.otherWithSuffix) {
          result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
        } else {
          result = tokenValue.other.replace("{{count}}", String(count));
        }
      }
      if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u5F8C";
        } else {
          return result + "\u524D";
        }
      }
      return result;
    };
    formatDistance_default42 = formatDistance84;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/_lib/formatLong/index.js
var dateFormats50, timeFormats50, dateTimeFormats50, formatLong50, formatLong_default50;
var init_formatLong50 = __esm({
  "../../node_modules/date-fns/esm/locale/ja/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats50 = {
      full: "y\u5E74M\u6708d\u65E5EEEE",
      long: "y\u5E74M\u6708d\u65E5",
      medium: "y/MM/dd",
      short: "y/MM/dd"
    };
    timeFormats50 = {
      full: "H\u6642mm\u5206ss\u79D2 zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats50 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong50 = {
      date: buildFormatLongFn({
        formats: dateFormats50,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats50,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats50,
        defaultWidth: "full"
      })
    };
    formatLong_default50 = formatLong50;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/_lib/formatRelative/index.js
var formatRelativeLocale42, formatRelative84, formatRelative_default42;
var init_formatRelative43 = __esm({
  "../../node_modules/date-fns/esm/locale/ja/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale42 = {
      lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
      yesterday: "\u6628\u65E5\u306Ep",
      today: "\u4ECA\u65E5\u306Ep",
      tomorrow: "\u660E\u65E5\u306Ep",
      nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
      other: "P"
    };
    formatRelative84 = function formatRelative85(token, _date, _baseDate, _options) {
      return formatRelativeLocale42[token];
    };
    formatRelative_default42 = formatRelative84;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/_lib/localize/index.js
var eraValues42, quarterValues42, monthValues42, dayValues42, dayPeriodValues42, formattingDayPeriodValues34, ordinalNumber83, localize42, localize_default42;
var init_localize42 = __esm({
  "../../node_modules/date-fns/esm/locale/ja/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues42 = {
      narrow: ["BC", "AC"],
      abbreviated: ["\u7D00\u5143\u524D", "\u897F\u66A6"],
      wide: ["\u7D00\u5143\u524D", "\u897F\u66A6"]
    };
    quarterValues42 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["\u7B2C1\u56DB\u534A\u671F", "\u7B2C2\u56DB\u534A\u671F", "\u7B2C3\u56DB\u534A\u671F", "\u7B2C4\u56DB\u534A\u671F"]
    };
    monthValues42 = {
      narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
      wide: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"]
    };
    dayValues42 = {
      narrow: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
      short: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
      abbreviated: ["\u65E5", "\u6708", "\u706B", "\u6C34", "\u6728", "\u91D1", "\u571F"],
      wide: ["\u65E5\u66DC\u65E5", "\u6708\u66DC\u65E5", "\u706B\u66DC\u65E5", "\u6C34\u66DC\u65E5", "\u6728\u66DC\u65E5", "\u91D1\u66DC\u65E5", "\u571F\u66DC\u65E5"]
    };
    dayPeriodValues42 = {
      narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      },
      abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      },
      wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      }
    };
    formattingDayPeriodValues34 = {
      narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      },
      abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      },
      wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
      }
    };
    ordinalNumber83 = function ordinalNumber84(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      switch (unit) {
        case "year":
          return "".concat(number, "\u5E74");
        case "quarter":
          return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case "month":
          return "".concat(number, "\u6708");
        case "week":
          return "\u7B2C".concat(number, "\u9031");
        case "date":
          return "".concat(number, "\u65E5");
        case "hour":
          return "".concat(number, "\u6642");
        case "minute":
          return "".concat(number, "\u5206");
        case "second":
          return "".concat(number, "\u79D2");
        default:
          return "".concat(number);
      }
    };
    localize42 = {
      ordinalNumber: ordinalNumber83,
      era: buildLocalizeFn({
        values: eraValues42,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues42,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback42(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues42,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues42,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues42,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues34,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default42 = localize42;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/_lib/match/index.js
var matchOrdinalNumberPattern41, parseOrdinalNumberPattern41, matchEraPatterns41, parseEraPatterns41, matchQuarterPatterns41, parseQuarterPatterns41, matchMonthPatterns41, parseMonthPatterns41, matchDayPatterns41, parseDayPatterns41, matchDayPeriodPatterns41, parseDayPeriodPatterns41, match41, match_default41;
var init_match41 = __esm({
  "../../node_modules/date-fns/esm/locale/ja/_lib/match/index.js"() {
    "use strict";
    init_buildMatchPatternFn();
    init_buildMatchFn();
    matchOrdinalNumberPattern41 = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
    parseOrdinalNumberPattern41 = /\d+/i;
    matchEraPatterns41 = {
      narrow: /^(B\.?C\.?|A\.?D\.?)/i,
      abbreviated: /^(紀元[前後]|西暦)/i,
      wide: /^(紀元[前後]|西暦)/i
    };
    parseEraPatterns41 = {
      narrow: [/^B/i, /^A/i],
      any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
    };
    matchQuarterPatterns41 = {
      narrow: /^[1234]/i,
      abbreviated: /^Q[1234]/i,
      wide: /^第[1234一二三四１２３４]四半期/i
    };
    parseQuarterPatterns41 = {
      any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
    };
    matchMonthPatterns41 = {
      narrow: /^([123456789]|1[012])/,
      abbreviated: /^([123456789]|1[012])月/i,
      wide: /^([123456789]|1[012])月/i
    };
    parseMonthPatterns41 = {
      any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
    };
    matchDayPatterns41 = {
      narrow: /^[日月火水木金土]/,
      short: /^[日月火水木金土]/,
      abbreviated: /^[日月火水木金土]/,
      wide: /^[日月火水木金土]曜日/
    };
    parseDayPatterns41 = {
      any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
    };
    matchDayPeriodPatterns41 = {
      any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
    };
    parseDayPeriodPatterns41 = {
      any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
      }
    };
    match41 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern41,
        parsePattern: parseOrdinalNumberPattern41,
        valueCallback: function valueCallback80(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns41,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns41,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns41,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns41,
        defaultParseWidth: "any",
        valueCallback: function valueCallback81(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns41,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns41,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns41,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns41,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns41,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns41,
        defaultParseWidth: "any"
      })
    };
    match_default41 = match41;
  }
});

// ../../node_modules/date-fns/esm/locale/ja/index.js
var locale52, ja_default;
var init_ja = __esm({
  "../../node_modules/date-fns/esm/locale/ja/index.js"() {
    "use strict";
    init_formatDistance43();
    init_formatLong50();
    init_formatRelative43();
    init_localize42();
    init_match41();
    locale52 = {
      code: "ja",
      formatDistance: formatDistance_default42,
      formatLong: formatLong_default50,
      formatRelative: formatRelative_default42,
      localize: localize_default42,
      match: match_default41,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ja_default = locale52;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatDistance/index.js
var formatDistanceLocale42, formatDistance86, formatDistance_default43;
var init_formatDistance44 = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale42 = {
      lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
      },
      xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
      },
      halfAMinute: "30\u3073\u3087\u3046",
      lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
      },
      xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
      },
      aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
      },
      xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
      },
      xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
      },
      aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
      },
      xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
      },
      aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
      },
      xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
      },
      aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
      },
      xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
      },
      overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
      },
      almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
      }
    };
    formatDistance86 = function formatDistance87(token, count, options) {
      options = options || {};
      var result;
      var tokenValue = formatDistanceLocale42[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) {
          result = tokenValue.oneWithSuffix;
        } else {
          result = tokenValue.one;
        }
      } else {
        if (options.addSuffix && tokenValue.otherWithSuffix) {
          result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
        } else {
          result = tokenValue.other.replace("{{count}}", String(count));
        }
      }
      if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u3042\u3068";
        } else {
          return result + "\u307E\u3048";
        }
      }
      return result;
    };
    formatDistance_default43 = formatDistance86;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatLong/index.js
var dateFormats51, timeFormats51, dateTimeFormats51, formatLong51, formatLong_default51;
var init_formatLong51 = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats51 = {
      full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
      long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
      medium: "y/MM/dd",
      short: "y/MM/dd"
    };
    timeFormats51 = {
      full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats51 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong51 = {
      date: buildFormatLongFn({
        formats: dateFormats51,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats51,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats51,
        defaultWidth: "full"
      })
    };
    formatLong_default51 = formatLong51;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatRelative/index.js
var formatRelativeLocale43, formatRelative86, formatRelative_default43;
var init_formatRelative44 = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale43 = {
      lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
      yesterday: "\u304D\u306E\u3046\u306Ep",
      today: "\u304D\u3087\u3046\u306Ep",
      tomorrow: "\u3042\u3057\u305F\u306Ep",
      nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
      other: "P"
    };
    formatRelative86 = function formatRelative87(token, _date, _baseDate, _options) {
      return formatRelativeLocale43[token];
    };
    formatRelative_default43 = formatRelative86;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/_lib/localize/index.js
var eraValues43, quarterValues43, monthValues43, dayValues43, dayPeriodValues43, formattingDayPeriodValues35, ordinalNumber85, localize43, localize_default43;
var init_localize43 = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues43 = {
      narrow: ["BC", "AC"],
      abbreviated: ["\u304D\u3052\u3093\u305C\u3093", "\u305B\u3044\u308C\u304D"],
      wide: ["\u304D\u3052\u3093\u305C\u3093", "\u305B\u3044\u308C\u304D"]
    };
    quarterValues43 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["\u3060\u30441\u3057\u306F\u3093\u304D", "\u3060\u30442\u3057\u306F\u3093\u304D", "\u3060\u30443\u3057\u306F\u3093\u304D", "\u3060\u30444\u3057\u306F\u3093\u304D"]
    };
    monthValues43 = {
      narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      abbreviated: ["1\u304C\u3064", "2\u304C\u3064", "3\u304C\u3064", "4\u304C\u3064", "5\u304C\u3064", "6\u304C\u3064", "7\u304C\u3064", "8\u304C\u3064", "9\u304C\u3064", "10\u304C\u3064", "11\u304C\u3064", "12\u304C\u3064"],
      wide: ["1\u304C\u3064", "2\u304C\u3064", "3\u304C\u3064", "4\u304C\u3064", "5\u304C\u3064", "6\u304C\u3064", "7\u304C\u3064", "8\u304C\u3064", "9\u304C\u3064", "10\u304C\u3064", "11\u304C\u3064", "12\u304C\u3064"]
    };
    dayValues43 = {
      narrow: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
      short: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
      abbreviated: ["\u306B\u3061", "\u3052\u3064", "\u304B", "\u3059\u3044", "\u3082\u304F", "\u304D\u3093", "\u3069"],
      wide: ["\u306B\u3061\u3088\u3046\u3073", "\u3052\u3064\u3088\u3046\u3073", "\u304B\u3088\u3046\u3073", "\u3059\u3044\u3088\u3046\u3073", "\u3082\u304F\u3088\u3046\u3073", "\u304D\u3093\u3088\u3046\u3073", "\u3069\u3088\u3046\u3073"]
    };
    dayPeriodValues43 = {
      narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      },
      abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      },
      wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      }
    };
    formattingDayPeriodValues35 = {
      narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      },
      abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      },
      wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
      }
    };
    ordinalNumber85 = function ordinalNumber86(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      switch (unit) {
        case "year":
          return "".concat(number, "\u306D\u3093");
        case "quarter":
          return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case "month":
          return "".concat(number, "\u304C\u3064");
        case "week":
          return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case "date":
          return "".concat(number, "\u306B\u3061");
        case "hour":
          return "".concat(number, "\u3058");
        case "minute":
          return "".concat(number, "\u3075\u3093");
        case "second":
          return "".concat(number, "\u3073\u3087\u3046");
        default:
          return "".concat(number);
      }
    };
    localize43 = {
      ordinalNumber: ordinalNumber85,
      era: buildLocalizeFn({
        values: eraValues43,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues43,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback43(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues43,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues43,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues43,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues35,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default43 = localize43;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/_lib/match/index.js
var matchOrdinalNumberPattern42, parseOrdinalNumberPattern42, matchEraPatterns42, parseEraPatterns42, matchQuarterPatterns42, parseQuarterPatterns42, matchMonthPatterns42, parseMonthPatterns42, matchDayPatterns42, parseDayPatterns42, matchDayPeriodPatterns42, parseDayPeriodPatterns42, match42, match_default42;
var init_match42 = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern42 = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
    parseOrdinalNumberPattern42 = /\d+/i;
    matchEraPatterns42 = {
      narrow: /^(B\.?C\.?|A\.?D\.?)/i,
      abbreviated: /^(きげん[前後]|せいれき)/i,
      wide: /^(きげん[前後]|せいれき)/i
    };
    parseEraPatterns42 = {
      narrow: [/^B/i, /^A/i],
      any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
    };
    matchQuarterPatterns42 = {
      narrow: /^[1234]/i,
      abbreviated: /^Q[1234]/i,
      wide: /^だい[1234一二三四１２３４]しはんき/i
    };
    parseQuarterPatterns42 = {
      any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
    };
    matchMonthPatterns42 = {
      narrow: /^([123456789]|1[012])/,
      abbreviated: /^([123456789]|1[012])がつ/i,
      wide: /^([123456789]|1[012])がつ/i
    };
    parseMonthPatterns42 = {
      any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
    };
    matchDayPatterns42 = {
      narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
      short: /^(にち|げつ|か|すい|もく|きん|ど)/,
      abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
      wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
    };
    parseDayPatterns42 = {
      any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
    };
    matchDayPeriodPatterns42 = {
      any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
    };
    parseDayPeriodPatterns42 = {
      any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
      }
    };
    match42 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern42,
        parsePattern: parseOrdinalNumberPattern42,
        valueCallback: function valueCallback82(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns42,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns42,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns42,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns42,
        defaultParseWidth: "any",
        valueCallback: function valueCallback83(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns42,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns42,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns42,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns42,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns42,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns42,
        defaultParseWidth: "any"
      })
    };
    match_default42 = match42;
  }
});

// ../../node_modules/date-fns/esm/locale/ja-Hira/index.js
var locale53, ja_Hira_default;
var init_ja_Hira = __esm({
  "../../node_modules/date-fns/esm/locale/ja-Hira/index.js"() {
    "use strict";
    init_formatDistance44();
    init_formatLong51();
    init_formatRelative44();
    init_localize43();
    init_match42();
    locale53 = {
      code: "ja-Hira",
      formatDistance: formatDistance_default43,
      formatLong: formatLong_default51,
      formatRelative: formatRelative_default43,
      localize: localize_default43,
      match: match_default42,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ja_Hira_default = locale53;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/_lib/formatDistance/index.js
var formatDistanceLocale43, formatDistance88, formatDistance_default44;
var init_formatDistance45 = __esm({
  "../../node_modules/date-fns/esm/locale/ka/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale43 = {
      lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
      },
      xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
      },
      halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
      },
      lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
      },
      xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
      },
      aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
      },
      xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
      },
      xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
      },
      aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
      },
      xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
      },
      aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
      },
      xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
      },
      aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
      },
      xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
      },
      overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
      },
      almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
      }
    };
    formatDistance88 = function formatDistance89(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale43[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) {
        result = tokenValue.future.replace("{{count}}", String(count));
      } else if (options !== null && options !== void 0 && options.addSuffix) {
        result = tokenValue.past.replace("{{count}}", String(count));
      } else {
        result = tokenValue.present.replace("{{count}}", String(count));
      }
      return result;
    };
    formatDistance_default44 = formatDistance88;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/_lib/formatLong/index.js
var dateFormats52, timeFormats52, dateTimeFormats52, formatLong52, formatLong_default52;
var init_formatLong52 = __esm({
  "../../node_modules/date-fns/esm/locale/ka/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats52 = {
      full: "EEEE, do MMMM, y",
      long: "do, MMMM, y",
      medium: "d, MMM, y",
      short: "dd/MM/yyyy"
    };
    timeFormats52 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats52 = {
      full: "{{date}} {{time}}'-\u10D6\u10D4'",
      long: "{{date}} {{time}}'-\u10D6\u10D4'",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong52 = {
      date: buildFormatLongFn({
        formats: dateFormats52,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats52,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats52,
        defaultWidth: "full"
      })
    };
    formatLong_default52 = formatLong52;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/_lib/formatRelative/index.js
var formatRelativeLocale44, formatRelative88, formatRelative_default44;
var init_formatRelative45 = __esm({
  "../../node_modules/date-fns/esm/locale/ka/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale44 = {
      lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
      yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
      today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
      tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
      nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
      other: "P"
    };
    formatRelative88 = function formatRelative89(token, _date, _baseDate, _options) {
      return formatRelativeLocale44[token];
    };
    formatRelative_default44 = formatRelative88;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/_lib/localize/index.js
var eraValues44, quarterValues44, monthValues44, dayValues44, dayPeriodValues44, formattingDayPeriodValues36, ordinalNumber87, localize44, localize_default44;
var init_localize44 = __esm({
  "../../node_modules/date-fns/esm/locale/ka/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues44 = {
      narrow: ["\u10E9.\u10EC-\u10DB\u10D3\u10D4", "\u10E9.\u10EC"],
      abbreviated: ["\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4", "\u10E9\u10D5.\u10EC"],
      wide: ["\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4", "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"]
    };
    quarterValues44 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u10DA\u10D8 \u10D9\u10D5", "2-\u10D4 \u10D9\u10D5", "3-\u10D4 \u10D9\u10D5", "4-\u10D4 \u10D9\u10D5"],
      wide: ["1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8", "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"]
    };
    monthValues44 = {
      narrow: ["\u10D8\u10D0", "\u10D7\u10D4", "\u10DB\u10D0", "\u10D0\u10DE", "\u10DB\u10E1", "\u10D5\u10DC", "\u10D5\u10DA", "\u10D0\u10D2", "\u10E1\u10D4", "\u10DD\u10E5", "\u10DC\u10DD", "\u10D3\u10D4"],
      abbreviated: ["\u10D8\u10D0\u10DC", "\u10D7\u10D4\u10D1", "\u10DB\u10D0\u10E0", "\u10D0\u10DE\u10E0", "\u10DB\u10D0\u10D8", "\u10D8\u10D5\u10DC", "\u10D8\u10D5\u10DA", "\u10D0\u10D2\u10D5", "\u10E1\u10D4\u10E5", "\u10DD\u10E5\u10E2", "\u10DC\u10DD\u10D4", "\u10D3\u10D4\u10D9"],
      wide: ["\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8", "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8", "\u10DB\u10D0\u10E0\u10E2\u10D8", "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8", "\u10DB\u10D0\u10D8\u10E1\u10D8", "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8", "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8", "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD", "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8", "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"]
    };
    dayValues44 = {
      narrow: ["\u10D9\u10D5", "\u10DD\u10E0", "\u10E1\u10D0", "\u10DD\u10D7", "\u10EE\u10E3", "\u10DE\u10D0", "\u10E8\u10D0"],
      short: ["\u10D9\u10D5\u10D8", "\u10DD\u10E0\u10E8", "\u10E1\u10D0\u10DB", "\u10DD\u10D7\u10EE", "\u10EE\u10E3\u10D7", "\u10DE\u10D0\u10E0", "\u10E8\u10D0\u10D1"],
      abbreviated: ["\u10D9\u10D5\u10D8", "\u10DD\u10E0\u10E8", "\u10E1\u10D0\u10DB", "\u10DD\u10D7\u10EE", "\u10EE\u10E3\u10D7", "\u10DE\u10D0\u10E0", "\u10E8\u10D0\u10D1"],
      wide: ["\u10D9\u10D5\u10D8\u10E0\u10D0", "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8", "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8", "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"]
    };
    dayPeriodValues44 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
      }
    };
    formattingDayPeriodValues36 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
      }
    };
    ordinalNumber87 = function ordinalNumber88(dirtyNumber) {
      var number = Number(dirtyNumber);
      if (number === 1) {
        return number + "-\u10DA\u10D8";
      }
      return number + "-\u10D4";
    };
    localize44 = {
      ordinalNumber: ordinalNumber87,
      era: buildLocalizeFn({
        values: eraValues44,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues44,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback44(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues44,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues44,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues44,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues36,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default44 = localize44;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/_lib/match/index.js
var matchOrdinalNumberPattern43, parseOrdinalNumberPattern43, matchEraPatterns43, parseEraPatterns43, matchQuarterPatterns43, parseQuarterPatterns43, matchMonthPatterns43, parseMonthPatterns43, matchDayPatterns43, parseDayPatterns43, matchDayPeriodPatterns43, parseDayPeriodPatterns43, match43, match_default43;
var init_match43 = __esm({
  "../../node_modules/date-fns/esm/locale/ka/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern43 = /^(\d+)(-ლი|-ე)?/i;
    parseOrdinalNumberPattern43 = /\d+/i;
    matchEraPatterns43 = {
      narrow: /^(ჩვ?\.წ)/i,
      abbreviated: /^(ჩვ?\.წ)/i,
      wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    };
    parseEraPatterns43 = {
      any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
    };
    matchQuarterPatterns43 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]-(ლი|ე)? კვ/i,
      wide: /^[1234]-(ლი|ე)? კვარტალი/i
    };
    parseQuarterPatterns43 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns43 = {
      any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
    };
    parseMonthPatterns43 = {
      any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
    };
    matchDayPatterns43 = {
      narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
      short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
      wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
    };
    parseDayPatterns43 = {
      any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
    };
    matchDayPeriodPatterns43 = {
      any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
    };
    parseDayPeriodPatterns43 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
      }
    };
    match43 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern43,
        parsePattern: parseOrdinalNumberPattern43,
        valueCallback: function valueCallback84(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns43,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns43,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns43,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns43,
        defaultParseWidth: "any",
        valueCallback: function valueCallback85(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns43,
        defaultMatchWidth: "any",
        parsePatterns: parseMonthPatterns43,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns43,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns43,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns43,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns43,
        defaultParseWidth: "any"
      })
    };
    match_default43 = match43;
  }
});

// ../../node_modules/date-fns/esm/locale/ka/index.js
var locale54, ka_default;
var init_ka = __esm({
  "../../node_modules/date-fns/esm/locale/ka/index.js"() {
    "use strict";
    init_formatDistance45();
    init_formatLong52();
    init_formatRelative45();
    init_localize44();
    init_match43();
    locale54 = {
      code: "ka",
      formatDistance: formatDistance_default44,
      formatLong: formatLong_default52,
      formatRelative: formatRelative_default44,
      localize: localize_default44,
      match: match_default43,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ka_default = locale54;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/_lib/formatDistance/index.js
function declension3(scheme, count) {
  if (scheme.one && count === 1) return scheme.one;
  var rem10 = count % 10;
  var rem100 = count % 100;
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}
var formatDistanceLocale44, formatDistance90, formatDistance_default45;
var init_formatDistance46 = __esm({
  "../../node_modules/date-fns/esm/locale/kk/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale44 = {
      lessThanXSeconds: {
        regular: {
          one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
          one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      xSeconds: {
        regular: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      halfAMinute: function halfAMinute5(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
          } else {
            return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
          }
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
      },
      lessThanXMinutes: {
        regular: {
          one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
          one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
      },
      xMinutes: {
        regular: {
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      aboutXHours: {
        regular: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      xHours: {
        regular: {
          singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
          singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
          pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
      },
      xDays: {
        regular: {
          singularNominative: "{{count}} \u043A\u04AF\u043D",
          singularGenitive: "{{count}} \u043A\u04AF\u043D",
          pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
          singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      aboutXWeeks: {
        type: "weeks",
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
      },
      xWeeks: {
        type: "weeks",
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
      },
      aboutXMonths: {
        regular: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      xMonths: {
        regular: {
          singularNominative: "{{count}} \u0430\u0439",
          singularGenitive: "{{count}} \u0430\u0439",
          pluralGenitive: "{{count}} \u0430\u0439"
        }
      },
      aboutXYears: {
        regular: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
          singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      xYears: {
        regular: {
          singularNominative: "{{count}} \u0436\u044B\u043B",
          singularGenitive: "{{count}} \u0436\u044B\u043B",
          pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
          singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      },
      overXYears: {
        regular: {
          singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
          singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
          pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
          singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
          singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
          pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
      },
      almostXYears: {
        regular: {
          singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
          singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
          pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
          singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
          pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
      }
    };
    formatDistance90 = function formatDistance91(token, count, options) {
      var tokenValue = formatDistanceLocale44[token];
      if (typeof tokenValue === "function") return tokenValue(options);
      if (tokenValue.type === "weeks") {
        return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          if (tokenValue.future) {
            return declension3(tokenValue.future, count);
          } else {
            return declension3(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
          }
        } else {
          if (tokenValue.past) {
            return declension3(tokenValue.past, count);
          } else {
            return declension3(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
          }
        }
      } else {
        return declension3(tokenValue.regular, count);
      }
    };
    formatDistance_default45 = formatDistance90;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/_lib/formatLong/index.js
var dateFormats53, timeFormats53, dateTimeFormats53, formatLong53, formatLong_default53;
var init_formatLong53 = __esm({
  "../../node_modules/date-fns/esm/locale/kk/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats53 = {
      full: "EEEE, do MMMM y '\u0436.'",
      long: "do MMMM y '\u0436.'",
      medium: "d MMM y '\u0436.'",
      short: "dd.MM.yyyy"
    };
    timeFormats53 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats53 = {
      any: "{{date}}, {{time}}"
    };
    formatLong53 = {
      date: buildFormatLongFn({
        formats: dateFormats53,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats53,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats53,
        defaultWidth: "any"
      })
    };
    formatLong_default53 = formatLong53;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/_lib/formatRelative/index.js
function _lastWeek2(day) {
  var weekday = accusativeWeekdays5[day];
  return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function thisWeek5(day) {
  var weekday = accusativeWeekdays5[day];
  return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function _nextWeek2(day) {
  var weekday = accusativeWeekdays5[day];
  return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var accusativeWeekdays5, formatRelativeLocale45, formatRelative90, formatRelative_default45;
var init_formatRelative46 = __esm({
  "../../node_modules/date-fns/esm/locale/kk/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    accusativeWeekdays5 = ["\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435", "\u0436\u04B1\u043C\u0430\u0434\u0430", "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"];
    formatRelativeLocale45 = {
      lastWeek: function lastWeek8(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek5(day);
        } else {
          return _lastWeek2(day);
        }
      },
      yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
      today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
      tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
      nextWeek: function nextWeek8(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek5(day);
        } else {
          return _nextWeek2(day);
        }
      },
      other: "P"
    };
    formatRelative90 = function formatRelative91(token, date, baseDate, options) {
      var format2 = formatRelativeLocale45[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default45 = formatRelative90;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/_lib/localize/index.js
var eraValues45, quarterValues45, monthValues45, formattingMonthValues10, dayValues45, dayPeriodValues45, formattingDayPeriodValues37, suffixes2, ordinalNumber89, localize45, localize_default45;
var init_localize45 = __esm({
  "../../node_modules/date-fns/esm/locale/kk/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues45 = {
      narrow: ["\u0431.\u0437.\u0434.", "\u0431.\u0437."],
      abbreviated: ["\u0431.\u0437.\u0434.", "\u0431.\u0437."],
      wide: ["\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D", "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"]
    };
    quarterValues45 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0448\u0456 \u0442\u043E\u049B.", "2-\u0448\u0456 \u0442\u043E\u049B.", "3-\u0448\u0456 \u0442\u043E\u049B.", "4-\u0448\u0456 \u0442\u043E\u049B."],
      wide: ["1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D", "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"]
    };
    monthValues45 = {
      narrow: ["\u049A", "\u0410", "\u041D", "\u0421", "\u041C", "\u041C", "\u0428", "\u0422", "\u049A", "\u049A", "\u049A", "\u0416"],
      abbreviated: ["\u049B\u0430\u04A3", "\u0430\u049B\u043F", "\u043D\u0430\u0443", "\u0441\u04D9\u0443", "\u043C\u0430\u043C", "\u043C\u0430\u0443", "\u0448\u0456\u043B", "\u0442\u0430\u043C", "\u049B\u044B\u0440", "\u049B\u0430\u0437", "\u049B\u0430\u0440", "\u0436\u0435\u043B"],
      wide: ["\u049B\u0430\u04A3\u0442\u0430\u0440", "\u0430\u049B\u043F\u0430\u043D", "\u043D\u0430\u0443\u0440\u044B\u0437", "\u0441\u04D9\u0443\u0456\u0440", "\u043C\u0430\u043C\u044B\u0440", "\u043C\u0430\u0443\u0441\u044B\u043C", "\u0448\u0456\u043B\u0434\u0435", "\u0442\u0430\u043C\u044B\u0437", "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A", "\u049B\u0430\u0437\u0430\u043D", "\u049B\u0430\u0440\u0430\u0448\u0430", "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]
    };
    formattingMonthValues10 = {
      narrow: ["\u049A", "\u0410", "\u041D", "\u0421", "\u041C", "\u041C", "\u0428", "\u0422", "\u049A", "\u049A", "\u049A", "\u0416"],
      abbreviated: ["\u049B\u0430\u04A3", "\u0430\u049B\u043F", "\u043D\u0430\u0443", "\u0441\u04D9\u0443", "\u043C\u0430\u043C", "\u043C\u0430\u0443", "\u0448\u0456\u043B", "\u0442\u0430\u043C", "\u049B\u044B\u0440", "\u049B\u0430\u0437", "\u049B\u0430\u0440", "\u0436\u0435\u043B"],
      wide: ["\u049B\u0430\u04A3\u0442\u0430\u0440", "\u0430\u049B\u043F\u0430\u043D", "\u043D\u0430\u0443\u0440\u044B\u0437", "\u0441\u04D9\u0443\u0456\u0440", "\u043C\u0430\u043C\u044B\u0440", "\u043C\u0430\u0443\u0441\u044B\u043C", "\u0448\u0456\u043B\u0434\u0435", "\u0442\u0430\u043C\u044B\u0437", "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A", "\u049B\u0430\u0437\u0430\u043D", "\u049B\u0430\u0440\u0430\u0448\u0430", "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"]
    };
    dayValues45 = {
      narrow: ["\u0416", "\u0414", "\u0421", "\u0421", "\u0411", "\u0416", "\u0421"],
      short: ["\u0436\u0441", "\u0434\u0441", "\u0441\u0441", "\u0441\u0440", "\u0431\u0441", "\u0436\u043C", "\u0441\u0431"],
      abbreviated: ["\u0436\u0441", "\u0434\u0441", "\u0441\u0441", "\u0441\u0440", "\u0431\u0441", "\u0436\u043C", "\u0441\u0431"],
      wide: ["\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456", "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456", "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456", "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456", "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456", "\u0436\u04B1\u043C\u0430", "\u0441\u0435\u043D\u0431\u0456"]
    };
    dayPeriodValues45 = {
      narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
      },
      wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
      }
    };
    formattingDayPeriodValues37 = {
      narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
      },
      wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
      }
    };
    suffixes2 = {
      0: "-\u0448\u0456",
      1: "-\u0448\u0456",
      2: "-\u0448\u0456",
      3: "-\u0448\u0456",
      4: "-\u0448\u0456",
      5: "-\u0448\u0456",
      6: "-\u0448\u044B",
      7: "-\u0448\u0456",
      8: "-\u0448\u0456",
      9: "-\u0448\u044B",
      10: "-\u0448\u044B",
      20: "-\u0448\u044B",
      30: "-\u0448\u044B",
      40: "-\u0448\u044B",
      50: "-\u0448\u0456",
      60: "-\u0448\u044B",
      70: "-\u0448\u0456",
      80: "-\u0448\u0456",
      90: "-\u0448\u044B",
      100: "-\u0448\u0456"
    };
    ordinalNumber89 = function ordinalNumber90(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var mod10 = number % 10;
      var b2 = number >= 100 ? 100 : null;
      var suffix = suffixes2[number] || suffixes2[mod10] || b2 && suffixes2[b2] || "";
      return number + suffix;
    };
    localize45 = {
      ordinalNumber: ordinalNumber89,
      era: buildLocalizeFn({
        values: eraValues45,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues45,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback45(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues45,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues10,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues45,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues45,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues37,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default45 = localize45;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/_lib/match/index.js
var matchOrdinalNumberPattern44, parseOrdinalNumberPattern44, matchEraPatterns44, parseEraPatterns44, matchQuarterPatterns44, parseQuarterPatterns44, matchMonthPatterns44, parseMonthPatterns44, matchDayPatterns44, parseDayPatterns44, matchDayPeriodPatterns44, parseDayPeriodPatterns44, match44, match_default44;
var init_match44 = __esm({
  "../../node_modules/date-fns/esm/locale/kk/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern44 = /^(\d+)(-?(ші|шы))?/i;
    parseOrdinalNumberPattern44 = /\d+/i;
    matchEraPatterns44 = {
      narrow: /^((б )?з\.?\s?д\.?)/i,
      abbreviated: /^((б )?з\.?\s?д\.?)/i,
      wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
    };
    parseEraPatterns44 = {
      any: [/^б/i, /^з/i]
    };
    matchQuarterPatterns44 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?ші)? тоқ.?/i,
      wide: /^[1234](-?ші)? тоқсан/i
    };
    parseQuarterPatterns44 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns44 = {
      narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
      abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
      wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
    };
    parseMonthPatterns44 = {
      narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
      abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
      any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
    };
    matchDayPatterns44 = {
      narrow: /^(ж|д|с|с|б|ж|с)/i,
      short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
      wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
    };
    parseDayPatterns44 = {
      narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
      short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
      any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
    };
    matchDayPeriodPatterns44 = {
      narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
      wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
      any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
    };
    parseDayPeriodPatterns44 = {
      any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
      }
    };
    match44 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern44,
        parsePattern: parseOrdinalNumberPattern44,
        valueCallback: function valueCallback86(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns44,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns44,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns44,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns44,
        defaultParseWidth: "any",
        valueCallback: function valueCallback87(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns44,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns44,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns44,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns44,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns44,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns44,
        defaultParseWidth: "any"
      })
    };
    match_default44 = match44;
  }
});

// ../../node_modules/date-fns/esm/locale/kk/index.js
var locale55, kk_default;
var init_kk = __esm({
  "../../node_modules/date-fns/esm/locale/kk/index.js"() {
    "use strict";
    init_formatDistance46();
    init_formatLong53();
    init_formatRelative46();
    init_localize45();
    init_match44();
    locale55 = {
      code: "kk",
      formatDistance: formatDistance_default45,
      formatLong: formatLong_default53,
      formatRelative: formatRelative_default45,
      localize: localize_default45,
      match: match_default44,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    kk_default = locale55;
  }
});

// ../../node_modules/date-fns/esm/locale/km/_lib/formatDistance/index.js
var formatDistanceLocale45, formatDistance92, formatDistance_default46;
var init_formatDistance47 = __esm({
  "../../node_modules/date-fns/esm/locale/km/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale45 = {
      lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
      xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
      halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
      lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
      xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
      aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
      xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
      xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
      aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
      xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
      aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
      xMonths: "{{count}} \u1781\u17C2",
      aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
      xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
      overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
      almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
    };
    formatDistance92 = function formatDistance93(token, count, options) {
      var tokenValue = formatDistanceLocale45[token];
      var result = tokenValue;
      if (typeof count === "number") {
        result = result.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        } else {
          return result + "\u1798\u17BB\u1793";
        }
      }
      return result;
    };
    formatDistance_default46 = formatDistance92;
  }
});

// ../../node_modules/date-fns/esm/locale/km/_lib/formatLong/index.js
var dateFormats54, timeFormats54, dateTimeFormats54, formatLong54, formatLong_default54;
var init_formatLong54 = __esm({
  "../../node_modules/date-fns/esm/locale/km/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats54 = {
      full: "EEEE do MMMM y",
      long: "do MMMM y",
      medium: "d MMM y",
      short: "dd/MM/yyyy"
    };
    timeFormats54 = {
      full: "h:mm:ss a",
      long: "h:mm:ss a",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats54 = {
      full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
      long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong54 = {
      date: buildFormatLongFn({
        formats: dateFormats54,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats54,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats54,
        defaultWidth: "full"
      })
    };
    formatLong_default54 = formatLong54;
  }
});

// ../../node_modules/date-fns/esm/locale/km/_lib/formatRelative/index.js
var formatRelativeLocale46, formatRelative92, formatRelative_default46;
var init_formatRelative47 = __esm({
  "../../node_modules/date-fns/esm/locale/km/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale46 = {
      lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
      yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
      today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
      tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
      nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
      other: "P"
    };
    formatRelative92 = function formatRelative93(token, _date, _baseDate, _options) {
      return formatRelativeLocale46[token];
    };
    formatRelative_default46 = formatRelative92;
  }
});

// ../../node_modules/date-fns/esm/locale/km/_lib/localize/index.js
var eraValues46, quarterValues46, monthValues46, dayValues46, dayPeriodValues46, formattingDayPeriodValues38, ordinalNumber91, localize46, localize_default46;
var init_localize46 = __esm({
  "../../node_modules/date-fns/esm/locale/km/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues46 = {
      narrow: ["\u1798.\u1782\u179F", "\u1782\u179F"],
      abbreviated: ["\u1798\u17BB\u1793\u1782.\u179F", "\u1782.\u179F"],
      wide: ["\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787", "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"]
    };
    quarterValues46 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1", "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2", "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3", "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"]
    };
    monthValues46 = {
      narrow: ["\u1798.\u1780", "\u1780.\u1798", "\u1798\u17B7", "\u1798.\u179F", "\u17A7.\u179F", "\u1798.\u1790", "\u1780.\u178A", "\u179F\u17B8", "\u1780\u1789", "\u178F\u17BB", "\u179C\u17B7", "\u1792"],
      abbreviated: ["\u1798\u1780\u179A\u17B6", "\u1780\u17BB\u1798\u17D2\u1797\u17C8", "\u1798\u17B8\u1793\u17B6", "\u1798\u17C1\u179F\u17B6", "\u17A7\u179F\u1797\u17B6", "\u1798\u17B7\u1790\u17BB\u1793\u17B6", "\u1780\u1780\u17D2\u1780\u178A\u17B6", "\u179F\u17B8\u17A0\u17B6", "\u1780\u1789\u17D2\u1789\u17B6", "\u178F\u17BB\u179B\u17B6", "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6", "\u1792\u17D2\u1793\u17BC"],
      wide: ["\u1798\u1780\u179A\u17B6", "\u1780\u17BB\u1798\u17D2\u1797\u17C8", "\u1798\u17B8\u1793\u17B6", "\u1798\u17C1\u179F\u17B6", "\u17A7\u179F\u1797\u17B6", "\u1798\u17B7\u1790\u17BB\u1793\u17B6", "\u1780\u1780\u17D2\u1780\u178A\u17B6", "\u179F\u17B8\u17A0\u17B6", "\u1780\u1789\u17D2\u1789\u17B6", "\u178F\u17BB\u179B\u17B6", "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6", "\u1792\u17D2\u1793\u17BC"]
    };
    dayValues46 = {
      narrow: ["\u17A2\u17B6", "\u1785", "\u17A2", "\u1796", "\u1796\u17D2\u179A", "\u179F\u17BB", "\u179F"],
      short: ["\u17A2\u17B6", "\u1785", "\u17A2", "\u1796", "\u1796\u17D2\u179A", "\u179F\u17BB", "\u179F"],
      abbreviated: ["\u17A2\u17B6", "\u1785", "\u17A2", "\u1796", "\u1796\u17D2\u179A", "\u179F\u17BB", "\u179F"],
      wide: ["\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799", "\u1785\u1793\u17D2\u1791", "\u17A2\u1784\u17D2\u1782\u17B6\u179A", "\u1796\u17BB\u1792", "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD", "\u179F\u17BB\u1780\u17D2\u179A", "\u179F\u17C5\u179A\u17CD"]
    };
    dayPeriodValues46 = {
      narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      },
      abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      },
      wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      }
    };
    formattingDayPeriodValues38 = {
      narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      },
      abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      },
      wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
      }
    };
    ordinalNumber91 = function ordinalNumber92(dirtyNumber, _) {
      var number = Number(dirtyNumber);
      return number.toString();
    };
    localize46 = {
      ordinalNumber: ordinalNumber91,
      era: buildLocalizeFn({
        values: eraValues46,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues46,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback46(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues46,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues46,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues46,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues38,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default46 = localize46;
  }
});

// ../../node_modules/date-fns/esm/locale/km/_lib/match/index.js
var matchOrdinalNumberPattern45, parseOrdinalNumberPattern45, matchEraPatterns45, parseEraPatterns45, matchQuarterPatterns45, parseQuarterPatterns45, matchMonthPatterns45, parseMonthPatterns45, matchDayPatterns45, parseDayPatterns45, matchDayPeriodPatterns45, parseDayPeriodPatterns45, match45, match_default45;
var init_match45 = __esm({
  "../../node_modules/date-fns/esm/locale/km/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern45 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern45 = /\d+/i;
    matchEraPatterns45 = {
      narrow: /^(ម\.)?គស/i,
      abbreviated: /^(មុន)?គ\.ស/i,
      wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
    };
    parseEraPatterns45 = {
      any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
    };
    matchQuarterPatterns45 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
    };
    parseQuarterPatterns45 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns45 = {
      narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
      abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
      wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
    };
    parseMonthPatterns45 = {
      narrow: [/^ម\.ក/i, /^ក\.ម/i, /^មិ/i, /^ម\.ស/i, /^ឧ\.ស/i, /^ម\.ថ/i, /^ក\.ដ/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិ/i, /^ធ/i],
      any: [/^មក/i, /^កុ/i, /^មីន/i, /^មេ/i, /^ឧស/i, /^មិថ/i, /^កក/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិច/i, /^ធ/i]
    };
    matchDayPatterns45 = {
      narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
      short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
      abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
      wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
    };
    parseDayPatterns45 = {
      narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
      any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
    };
    matchDayPeriodPatterns45 = {
      narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
      any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
    };
    parseDayPeriodPatterns45 = {
      any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
      }
    };
    match45 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern45,
        parsePattern: parseOrdinalNumberPattern45,
        valueCallback: function valueCallback88(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns45,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns45,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns45,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns45,
        defaultParseWidth: "any",
        valueCallback: function valueCallback89(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns45,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns45,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns45,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns45,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns45,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns45,
        defaultParseWidth: "any"
      })
    };
    match_default45 = match45;
  }
});

// ../../node_modules/date-fns/esm/locale/km/index.js
var locale56, km_default;
var init_km = __esm({
  "../../node_modules/date-fns/esm/locale/km/index.js"() {
    "use strict";
    init_formatDistance47();
    init_formatLong54();
    init_formatRelative47();
    init_localize46();
    init_match45();
    locale56 = {
      code: "km",
      formatDistance: formatDistance_default46,
      formatLong: formatLong_default54,
      formatRelative: formatRelative_default46,
      localize: localize_default46,
      match: match_default45,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    km_default = locale56;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/_lib/formatDistance/index.js
function getResultByTense(parentToken, options) {
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return parentToken.future;
    } else {
      return parentToken.past;
    }
  }
  return parentToken.default;
}
var formatDistanceLocale46, formatDistance94, formatDistance_default47;
var init_formatDistance48 = __esm({
  "../../node_modules/date-fns/esm/locale/kn/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale46 = {
      lessThanXSeconds: {
        one: {
          default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
          default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
      },
      xSeconds: {
        one: {
          default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
          future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      halfAMinute: {
        other: {
          default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
          future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      lessThanXMinutes: {
        one: {
          default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
          default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
          past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
      },
      xMinutes: {
        one: {
          default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
          future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      aboutXHours: {
        one: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      xHours: {
        one: {
          default: "1 \u0C97\u0C82\u0C9F\u0CC6",
          future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      xDays: {
        one: {
          default: "1 \u0CA6\u0CBF\u0CA8",
          future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      // TODO
      // aboutXWeeks: {},
      // TODO
      // xWeeks: {},
      aboutXMonths: {
        one: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      xMonths: {
        one: {
          default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
          future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      aboutXYears: {
        one: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
          future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      xYears: {
        one: {
          default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
          future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
          default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
          future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
      },
      overXYears: {
        one: {
          default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
          future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
          past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
          default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
          future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
          past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
      },
      almostXYears: {
        one: {
          default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
          default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
          past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
      }
    };
    formatDistance94 = function formatDistance95(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale46[token];
      if (tokenValue.one && count === 1) {
        result = getResultByTense(tokenValue.one, options);
      } else {
        result = getResultByTense(tokenValue.other, options);
      }
      return result.replace("{{count}}", String(count));
    };
    formatDistance_default47 = formatDistance94;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/_lib/formatLong/index.js
var dateFormats55, timeFormats55, dateTimeFormats55, formatLong55, formatLong_default55;
var init_formatLong55 = __esm({
  "../../node_modules/date-fns/esm/locale/kn/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats55 = {
      full: "EEEE, MMMM d, y",
      // CLDR 1816
      long: "MMMM d, y",
      // CLDR 1817
      medium: "MMM d, y",
      // CLDR 1818
      short: "d/M/yy"
      // CLDR 1819
    };
    timeFormats55 = {
      full: "hh:mm:ss a zzzz",
      // CLDR 1820
      long: "hh:mm:ss a z",
      // CLDR 1821
      medium: "hh:mm:ss a",
      // CLDR 1822
      short: "hh:mm a"
      // CLDR 1823
    };
    dateTimeFormats55 = {
      full: "{{date}} {{time}}",
      // CLDR 1824
      long: "{{date}} {{time}}",
      // CLDR 1825
      medium: "{{date}} {{time}}",
      // CLDR 1826
      short: "{{date}} {{time}}"
      // CLDR 1827
    };
    formatLong55 = {
      date: buildFormatLongFn({
        formats: dateFormats55,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats55,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats55,
        defaultWidth: "full"
      })
    };
    formatLong_default55 = formatLong55;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/_lib/formatRelative/index.js
var formatRelativeLocale47, formatRelative94, formatRelative_default47;
var init_formatRelative48 = __esm({
  "../../node_modules/date-fns/esm/locale/kn/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale47 = {
      lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
      yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
      today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
      tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
      nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
      other: "P"
    };
    formatRelative94 = function formatRelative95(token, _date, _baseDate, _options) {
      return formatRelativeLocale47[token];
    };
    formatRelative_default47 = formatRelative94;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/_lib/localize/index.js
var eraValues47, quarterValues47, monthValues47, dayValues47, dayPeriodValues47, formattingDayPeriodValues39, ordinalNumber93, localize47, localize_default47;
var init_localize47 = __esm({
  "../../node_modules/date-fns/esm/locale/kn/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues47 = {
      narrow: ["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2", "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
      abbreviated: ["\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2", "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"],
      // CLDR #1618, #1620
      wide: ["\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5", "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"]
      // CLDR #1614, #1616
    };
    quarterValues47 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u0CA4\u0CCD\u0CB0\u0CC8 1", "\u0CA4\u0CCD\u0CB0\u0CC8 2", "\u0CA4\u0CCD\u0CB0\u0CC8 3", "\u0CA4\u0CCD\u0CB0\u0CC8 4"],
      // CLDR #1630 - #1638
      wide: ["1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95", "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"]
      // CLDR #1622 - #1629
    };
    monthValues47 = {
      narrow: ["\u0C9C", "\u0CAB\u0CC6", "\u0CAE\u0CBE", "\u0C8F", "\u0CAE\u0CC7", "\u0C9C\u0CC2", "\u0C9C\u0CC1", "\u0C86", "\u0CB8\u0CC6", "\u0C85", "\u0CA8", "\u0CA1\u0CBF"],
      abbreviated: ["\u0C9C\u0CA8", "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0", "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD", "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF", "\u0CAE\u0CC7", "\u0C9C\u0CC2\u0CA8\u0CCD", "\u0C9C\u0CC1\u0CB2\u0CC8", "\u0C86\u0C97", "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82", "\u0C85\u0C95\u0CCD\u0C9F\u0CCB", "\u0CA8\u0CB5\u0CC6\u0C82", "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"],
      wide: ["\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF", "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF", "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD", "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD", "\u0CAE\u0CC7", "\u0C9C\u0CC2\u0CA8\u0CCD", "\u0C9C\u0CC1\u0CB2\u0CC8", "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD", "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD", "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD", "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD", "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"]
    };
    dayValues47 = {
      narrow: ["\u0CAD\u0CBE", "\u0CB8\u0CCB", "\u0CAE\u0C82", "\u0CAC\u0CC1", "\u0C97\u0CC1", "\u0CB6\u0CC1", "\u0CB6"],
      short: ["\u0CAD\u0CBE\u0CA8\u0CC1", "\u0CB8\u0CCB\u0CAE", "\u0CAE\u0C82\u0C97\u0CB3", "\u0CAC\u0CC1\u0CA7", "\u0C97\u0CC1\u0CB0\u0CC1", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0", "\u0CB6\u0CA8\u0CBF"],
      abbreviated: ["\u0CAD\u0CBE\u0CA8\u0CC1", "\u0CB8\u0CCB\u0CAE", "\u0CAE\u0C82\u0C97\u0CB3", "\u0CAC\u0CC1\u0CA7", "\u0C97\u0CC1\u0CB0\u0CC1", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0", "\u0CB6\u0CA8\u0CBF"],
      wide: ["\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0", "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0", "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0", "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0", "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0", "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0", "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"]
    };
    dayPeriodValues47 = {
      narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      },
      abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      },
      wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      }
    };
    formattingDayPeriodValues39 = {
      narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      },
      abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      },
      wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
      }
    };
    ordinalNumber93 = function ordinalNumber94(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\u0CA8\u0CC7";
    };
    localize47 = {
      ordinalNumber: ordinalNumber93,
      era: buildLocalizeFn({
        values: eraValues47,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues47,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback47(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues47,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues47,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues47,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues39,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default47 = localize47;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/_lib/match/index.js
var matchOrdinalNumberPattern46, parseOrdinalNumberPattern46, matchEraPatterns46, parseEraPatterns46, matchQuarterPatterns46, parseQuarterPatterns46, matchMonthPatterns46, parseMonthPatterns46, matchDayPatterns46, parseDayPatterns46, matchDayPeriodPatterns46, parseDayPeriodPatterns46, match46, match_default46;
var init_match46 = __esm({
  "../../node_modules/date-fns/esm/locale/kn/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern46 = /^(\d+)(ನೇ|ನೆ)?/i;
    parseOrdinalNumberPattern46 = /\d+/i;
    matchEraPatterns46 = {
      narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
      abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
      wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
    };
    parseEraPatterns46 = {
      any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
    };
    matchQuarterPatterns46 = {
      narrow: /^[1234]/i,
      abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
      wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
    };
    parseQuarterPatterns46 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns46 = {
      narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
      abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
      wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
    };
    parseMonthPatterns46 = {
      narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
      any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
    };
    matchDayPatterns46 = {
      narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
      short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
      abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
      wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
    };
    parseDayPatterns46 = {
      narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
      any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
    };
    matchDayPeriodPatterns46 = {
      narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
      any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
    };
    parseDayPeriodPatterns46 = {
      any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
      }
    };
    match46 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern46,
        parsePattern: parseOrdinalNumberPattern46,
        valueCallback: function valueCallback90(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns46,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns46,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns46,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns46,
        defaultParseWidth: "any",
        valueCallback: function valueCallback91(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns46,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns46,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns46,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns46,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns46,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns46,
        defaultParseWidth: "any"
      })
    };
    match_default46 = match46;
  }
});

// ../../node_modules/date-fns/esm/locale/kn/index.js
var locale57, kn_default;
var init_kn = __esm({
  "../../node_modules/date-fns/esm/locale/kn/index.js"() {
    "use strict";
    init_formatDistance48();
    init_formatLong55();
    init_formatRelative48();
    init_localize47();
    init_match46();
    locale57 = {
      code: "kn",
      formatDistance: formatDistance_default47,
      formatLong: formatLong_default55,
      formatRelative: formatRelative_default47,
      localize: localize_default47,
      match: match_default46,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    kn_default = locale57;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/_lib/formatDistance/index.js
var formatDistanceLocale47, formatDistance96, formatDistance_default48;
var init_formatDistance49 = __esm({
  "../../node_modules/date-fns/esm/locale/ko/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale47 = {
      lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
      },
      xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
      },
      halfAMinute: "30\uCD08",
      lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
      },
      xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
      },
      aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
      },
      xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
      },
      xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
      },
      aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
      },
      xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
      },
      aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
      },
      xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
      },
      aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
      },
      xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
      },
      overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
      },
      almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
      }
    };
    formatDistance96 = function formatDistance97(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale47[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " \uD6C4";
        } else {
          return result + " \uC804";
        }
      }
      return result;
    };
    formatDistance_default48 = formatDistance96;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/_lib/formatLong/index.js
var dateFormats56, timeFormats56, dateTimeFormats56, formatLong56, formatLong_default56;
var init_formatLong56 = __esm({
  "../../node_modules/date-fns/esm/locale/ko/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats56 = {
      full: "y\uB144 M\uC6D4 d\uC77C EEEE",
      long: "y\uB144 M\uC6D4 d\uC77C",
      medium: "y.MM.dd",
      short: "y.MM.dd"
    };
    timeFormats56 = {
      full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
      long: "a H:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats56 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong56 = {
      date: buildFormatLongFn({
        formats: dateFormats56,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats56,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats56,
        defaultWidth: "full"
      })
    };
    formatLong_default56 = formatLong56;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/_lib/formatRelative/index.js
var formatRelativeLocale48, formatRelative96, formatRelative_default48;
var init_formatRelative49 = __esm({
  "../../node_modules/date-fns/esm/locale/ko/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale48 = {
      lastWeek: "'\uC9C0\uB09C' eeee p",
      yesterday: "'\uC5B4\uC81C' p",
      today: "'\uC624\uB298' p",
      tomorrow: "'\uB0B4\uC77C' p",
      nextWeek: "'\uB2E4\uC74C' eeee p",
      other: "P"
    };
    formatRelative96 = function formatRelative97(token, _date, _baseDate, _options) {
      return formatRelativeLocale48[token];
    };
    formatRelative_default48 = formatRelative96;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/_lib/localize/index.js
var eraValues48, quarterValues48, monthValues48, dayValues48, dayPeriodValues48, formattingDayPeriodValues40, ordinalNumber95, localize48, localize_default48;
var init_localize48 = __esm({
  "../../node_modules/date-fns/esm/locale/ko/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues48 = {
      narrow: ["BC", "AD"],
      abbreviated: ["BC", "AD"],
      wide: ["\uAE30\uC6D0\uC804", "\uC11C\uAE30"]
    };
    quarterValues48 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1\uBD84\uAE30", "2\uBD84\uAE30", "3\uBD84\uAE30", "4\uBD84\uAE30"]
    };
    monthValues48 = {
      narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      abbreviated: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4"],
      wide: ["1\uC6D4", "2\uC6D4", "3\uC6D4", "4\uC6D4", "5\uC6D4", "6\uC6D4", "7\uC6D4", "8\uC6D4", "9\uC6D4", "10\uC6D4", "11\uC6D4", "12\uC6D4"]
    };
    dayValues48 = {
      narrow: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
      short: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
      abbreviated: ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"],
      wide: ["\uC77C\uC694\uC77C", "\uC6D4\uC694\uC77C", "\uD654\uC694\uC77C", "\uC218\uC694\uC77C", "\uBAA9\uC694\uC77C", "\uAE08\uC694\uC77C", "\uD1A0\uC694\uC77C"]
    };
    dayPeriodValues48 = {
      narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      },
      abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      },
      wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      }
    };
    formattingDayPeriodValues40 = {
      narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      },
      abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      },
      wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
      }
    };
    ordinalNumber95 = function ordinalNumber96(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      switch (unit) {
        case "minute":
        case "second":
          return String(number);
        case "date":
          return number + "\uC77C";
        default:
          return number + "\uBC88\uC9F8";
      }
    };
    localize48 = {
      ordinalNumber: ordinalNumber95,
      era: buildLocalizeFn({
        values: eraValues48,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues48,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback48(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues48,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues48,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues48,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues40,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default48 = localize48;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/_lib/match/index.js
var matchOrdinalNumberPattern47, parseOrdinalNumberPattern47, matchEraPatterns47, parseEraPatterns47, matchQuarterPatterns47, parseQuarterPatterns47, matchMonthPatterns47, parseMonthPatterns47, matchDayPatterns47, parseDayPatterns47, matchDayPeriodPatterns47, parseDayPeriodPatterns47, match47, match_default47;
var init_match47 = __esm({
  "../../node_modules/date-fns/esm/locale/ko/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern47 = /^(\d+)(일|번째)?/i;
    parseOrdinalNumberPattern47 = /\d+/i;
    matchEraPatterns47 = {
      narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(기원전|서기)/i
    };
    parseEraPatterns47 = {
      any: [/^(bc|기원전)/i, /^(ad|서기)/i]
    };
    matchQuarterPatterns47 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234]사?분기/i
    };
    parseQuarterPatterns47 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns47 = {
      narrow: /^(1[012]|[123456789])/,
      abbreviated: /^(1[012]|[123456789])월/i,
      wide: /^(1[012]|[123456789])월/i
    };
    parseMonthPatterns47 = {
      any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
    };
    matchDayPatterns47 = {
      narrow: /^[일월화수목금토]/,
      short: /^[일월화수목금토]/,
      abbreviated: /^[일월화수목금토]/,
      wide: /^[일월화수목금토]요일/
    };
    parseDayPatterns47 = {
      any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
    };
    matchDayPeriodPatterns47 = {
      any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
    };
    parseDayPeriodPatterns47 = {
      any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
      }
    };
    match47 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern47,
        parsePattern: parseOrdinalNumberPattern47,
        valueCallback: function valueCallback92(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns47,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns47,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns47,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns47,
        defaultParseWidth: "any",
        valueCallback: function valueCallback93(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns47,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns47,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns47,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns47,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns47,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns47,
        defaultParseWidth: "any"
      })
    };
    match_default47 = match47;
  }
});

// ../../node_modules/date-fns/esm/locale/ko/index.js
var locale58, ko_default;
var init_ko = __esm({
  "../../node_modules/date-fns/esm/locale/ko/index.js"() {
    "use strict";
    init_formatDistance49();
    init_formatLong56();
    init_formatRelative49();
    init_localize48();
    init_match47();
    locale58 = {
      code: "ko",
      formatDistance: formatDistance_default48,
      formatLong: formatLong_default56,
      formatRelative: formatRelative_default48,
      localize: localize_default48,
      match: match_default47,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ko_default = locale58;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/_lib/formatDistance/index.js
function isFinalNNeeded(nextWords) {
  var firstLetter = nextWords.charAt(0).toLowerCase();
  if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
    return true;
  }
  var firstWord = nextWords.split(" ")[0];
  var number = parseInt(firstWord);
  if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
    return true;
  }
  return false;
}
var formatDistanceLocale48, EXCEPTION_CONSONANTS, VOWELS, DIGITS_SPOKEN_N_NEEDED, FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED, formatDistance98, formatDistance_default49;
var init_formatDistance50 = __esm({
  "../../node_modules/date-fns/esm/locale/lb/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale48 = {
      lessThanXSeconds: {
        standalone: {
          one: "manner w\xE9i eng Sekonn",
          other: "manner w\xE9i {{count}} Sekonnen"
        },
        withPreposition: {
          one: "manner w\xE9i enger Sekonn",
          other: "manner w\xE9i {{count}} Sekonnen"
        }
      },
      xSeconds: {
        standalone: {
          one: "eng Sekonn",
          other: "{{count}} Sekonnen"
        },
        withPreposition: {
          one: "enger Sekonn",
          other: "{{count}} Sekonnen"
        }
      },
      halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
      },
      lessThanXMinutes: {
        standalone: {
          one: "manner w\xE9i eng Minutt",
          other: "manner w\xE9i {{count}} Minutten"
        },
        withPreposition: {
          one: "manner w\xE9i enger Minutt",
          other: "manner w\xE9i {{count}} Minutten"
        }
      },
      xMinutes: {
        standalone: {
          one: "eng Minutt",
          other: "{{count}} Minutten"
        },
        withPreposition: {
          one: "enger Minutt",
          other: "{{count}} Minutten"
        }
      },
      aboutXHours: {
        standalone: {
          one: "ongef\xE9ier eng Stonn",
          other: "ongef\xE9ier {{count}} Stonnen"
        },
        withPreposition: {
          one: "ongef\xE9ier enger Stonn",
          other: "ongef\xE9ier {{count}} Stonnen"
        }
      },
      xHours: {
        standalone: {
          one: "eng Stonn",
          other: "{{count}} Stonnen"
        },
        withPreposition: {
          one: "enger Stonn",
          other: "{{count}} Stonnen"
        }
      },
      xDays: {
        standalone: {
          one: "een Dag",
          other: "{{count}} Deeg"
        },
        withPreposition: {
          one: "engem Dag",
          other: "{{count}} Deeg"
        }
      },
      aboutXWeeks: {
        standalone: {
          one: "ongef\xE9ier eng Woch",
          other: "ongef\xE9ier {{count}} Wochen"
        },
        withPreposition: {
          one: "ongef\xE9ier enger Woche",
          other: "ongef\xE9ier {{count}} Wochen"
        }
      },
      xWeeks: {
        standalone: {
          one: "eng Woch",
          other: "{{count}} Wochen"
        },
        withPreposition: {
          one: "enger Woch",
          other: "{{count}} Wochen"
        }
      },
      aboutXMonths: {
        standalone: {
          one: "ongef\xE9ier ee Mount",
          other: "ongef\xE9ier {{count}} M\xE9int"
        },
        withPreposition: {
          one: "ongef\xE9ier engem Mount",
          other: "ongef\xE9ier {{count}} M\xE9int"
        }
      },
      xMonths: {
        standalone: {
          one: "ee Mount",
          other: "{{count}} M\xE9int"
        },
        withPreposition: {
          one: "engem Mount",
          other: "{{count}} M\xE9int"
        }
      },
      aboutXYears: {
        standalone: {
          one: "ongef\xE9ier ee Joer",
          other: "ongef\xE9ier {{count}} Joer"
        },
        withPreposition: {
          one: "ongef\xE9ier engem Joer",
          other: "ongef\xE9ier {{count}} Joer"
        }
      },
      xYears: {
        standalone: {
          one: "ee Joer",
          other: "{{count}} Joer"
        },
        withPreposition: {
          one: "engem Joer",
          other: "{{count}} Joer"
        }
      },
      overXYears: {
        standalone: {
          one: "m\xE9i w\xE9i ee Joer",
          other: "m\xE9i w\xE9i {{count}} Joer"
        },
        withPreposition: {
          one: "m\xE9i w\xE9i engem Joer",
          other: "m\xE9i w\xE9i {{count}} Joer"
        }
      },
      almostXYears: {
        standalone: {
          one: "bal ee Joer",
          other: "bal {{count}} Joer"
        },
        withPreposition: {
          one: "bal engem Joer",
          other: "bal {{count}} Joer"
        }
      }
    };
    EXCEPTION_CONSONANTS = ["d", "h", "n", "t", "z"];
    VOWELS = ["a,", "e", "i", "o", "u"];
    DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
    FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70];
    formatDistance98 = function formatDistance99(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale48[token];
      var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
      if (typeof usageGroup === "string") {
        result = usageGroup;
      } else if (count === 1) {
        result = usageGroup.one;
      } else {
        result = usageGroup.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "a" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
        } else {
          return "viru" + (isFinalNNeeded(result) ? "n" : "") + " " + result;
        }
      }
      return result;
    };
    formatDistance_default49 = formatDistance98;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/_lib/formatLong/index.js
var dateFormats57, timeFormats57, dateTimeFormats57, formatLong57, formatLong_default57;
var init_formatLong57 = __esm({
  "../../node_modules/date-fns/esm/locale/lb/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats57 = {
      full: "EEEE, do MMMM y",
      // Méindeg, 7. Januar 2018
      long: "do MMMM y",
      // 7. Januar 2018
      medium: "do MMM y",
      // 7. Jan 2018
      short: "dd.MM.yy"
      // 07.01.18
    };
    timeFormats57 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats57 = {
      full: "{{date}} 'um' {{time}}",
      long: "{{date}} 'um' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong57 = {
      date: buildFormatLongFn({
        formats: dateFormats57,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats57,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats57,
        defaultWidth: "full"
      })
    };
    formatLong_default57 = formatLong57;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/_lib/formatRelative/index.js
var formatRelativeLocale49, formatRelative98, formatRelative_default49;
var init_formatRelative50 = __esm({
  "../../node_modules/date-fns/esm/locale/lb/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale49 = {
      lastWeek: function lastWeek9(date) {
        var day = date.getUTCDay();
        var result = "'l\xE4schte";
        if (day === 2 || day === 4) {
          result += "n";
        }
        result += "' eeee 'um' p";
        return result;
      },
      yesterday: "'g\xEBschter um' p",
      today: "'haut um' p",
      tomorrow: "'moien um' p",
      nextWeek: "eeee 'um' p",
      other: "P"
    };
    formatRelative98 = function formatRelative99(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale49[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default49 = formatRelative98;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/_lib/localize/index.js
var eraValues49, quarterValues49, monthValues49, dayValues49, dayPeriodValues49, formattingDayPeriodValues41, ordinalNumber97, localize49, localize_default49;
var init_localize49 = __esm({
  "../../node_modules/date-fns/esm/locale/lb/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues49 = {
      narrow: ["v.Chr.", "n.Chr."],
      abbreviated: ["v.Chr.", "n.Chr."],
      wide: ["viru Christus", "no Christus"]
    };
    quarterValues49 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
    };
    monthValues49 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "M\xE4e", "Abr", "Mee", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      wide: ["Januar", "Februar", "M\xE4erz", "Abr\xEBll", "Mee", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
    };
    dayValues49 = {
      narrow: ["S", "M", "D", "M", "D", "F", "S"],
      short: ["So", "M\xE9", "D\xEB", "M\xEB", "Do", "Fr", "Sa"],
      abbreviated: ["So.", "M\xE9.", "D\xEB.", "M\xEB.", "Do.", "Fr.", "Sa."],
      wide: ["Sonndeg", "M\xE9indeg", "D\xEBnschdeg", "M\xEBttwoch", "Donneschdeg", "Freideg", "Samschdeg"]
    };
    dayPeriodValues49 = {
      narrow: {
        am: "mo.",
        pm: "nom\xEB.",
        midnight: "M\xEBtternuecht",
        noon: "M\xEBtteg",
        morning: "Moien",
        afternoon: "Nom\xEBtteg",
        evening: "Owend",
        night: "Nuecht"
      },
      abbreviated: {
        am: "moies",
        pm: "nom\xEBttes",
        midnight: "M\xEBtternuecht",
        noon: "M\xEBtteg",
        morning: "Moien",
        afternoon: "Nom\xEBtteg",
        evening: "Owend",
        night: "Nuecht"
      },
      wide: {
        am: "moies",
        pm: "nom\xEBttes",
        midnight: "M\xEBtternuecht",
        noon: "M\xEBtteg",
        morning: "Moien",
        afternoon: "Nom\xEBtteg",
        evening: "Owend",
        night: "Nuecht"
      }
    };
    formattingDayPeriodValues41 = {
      narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xEBtternuecht",
        noon: "m\xEBttes",
        morning: "moies",
        afternoon: "nom\xEBttes",
        evening: "owes",
        night: "nuets"
      },
      abbreviated: {
        am: "moies",
        pm: "nom\xEBttes",
        midnight: "M\xEBtternuecht",
        noon: "m\xEBttes",
        morning: "moies",
        afternoon: "nom\xEBttes",
        evening: "owes",
        night: "nuets"
      },
      wide: {
        am: "moies",
        pm: "nom\xEBttes",
        midnight: "M\xEBtternuecht",
        noon: "m\xEBttes",
        morning: "moies",
        afternoon: "nom\xEBttes",
        evening: "owes",
        night: "nuets"
      }
    };
    ordinalNumber97 = function ordinalNumber98(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize49 = {
      ordinalNumber: ordinalNumber97,
      era: buildLocalizeFn({
        values: eraValues49,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues49,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback49(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues49,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues49,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues49,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues41,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default49 = localize49;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/_lib/match/index.js
var matchOrdinalNumberPattern48, parseOrdinalNumberPattern48, matchEraPatterns48, parseEraPatterns48, matchQuarterPatterns48, parseQuarterPatterns48, matchMonthPatterns48, parseMonthPatterns48, matchDayPatterns48, parseDayPatterns48, matchDayPeriodPatterns48, parseDayPeriodPatterns48, match48, match_default48;
var init_match48 = __esm({
  "../../node_modules/date-fns/esm/locale/lb/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern48 = /^(\d+)(\.)?/i;
    parseOrdinalNumberPattern48 = /\d+/i;
    matchEraPatterns48 = {
      narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
      abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
      wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
    };
    parseEraPatterns48 = {
      any: [/^v/i, /^n/i]
    };
    matchQuarterPatterns48 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](\.)? Quartal/i
    };
    parseQuarterPatterns48 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns48 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
      wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
    };
    parseMonthPatterns48 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns48 = {
      narrow: /^[smdf]/i,
      short: /^(so|mé|dë|më|do|fr|sa)/i,
      abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
      wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
    };
    parseDayPatterns48 = {
      any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns48 = {
      narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
      abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
      wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
    };
    parseDayPeriodPatterns48 = {
      any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i
        // will never be matched. Night is matched by `pm`
      }
    };
    match48 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern48,
        parsePattern: parseOrdinalNumberPattern48,
        valueCallback: function valueCallback94(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns48,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns48,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns48,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns48,
        defaultParseWidth: "any",
        valueCallback: function valueCallback95(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns48,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns48,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns48,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns48,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns48,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns48,
        defaultParseWidth: "any"
      })
    };
    match_default48 = match48;
  }
});

// ../../node_modules/date-fns/esm/locale/lb/index.js
var locale59, lb_default;
var init_lb = __esm({
  "../../node_modules/date-fns/esm/locale/lb/index.js"() {
    "use strict";
    init_formatDistance50();
    init_formatLong57();
    init_formatRelative50();
    init_localize49();
    init_match48();
    locale59 = {
      code: "lb",
      formatDistance: formatDistance_default49,
      formatLong: formatLong_default57,
      formatRelative: formatRelative_default49,
      localize: localize_default49,
      match: match_default48,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    lb_default = locale59;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/_lib/formatDistance/index.js
function special(number) {
  return number % 10 === 0 || number > 10 && number < 20;
}
function forms(key) {
  return translations2[key].split("_");
}
var translations2, translateSeconds, translateSingular, translate, formatDistanceLocale49, formatDistance100, formatDistance_default50;
var init_formatDistance51 = __esm({
  "../../node_modules/date-fns/esm/locale/lt/_lib/formatDistance/index.js"() {
    "use strict";
    translations2 = {
      xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
      xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
      xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
      xhours_one: "valanda_valandos_valand\u0105",
      xhours_other: "valandos_valand\u0173_valandas",
      xdays_one: "diena_dienos_dien\u0105",
      xdays_other: "dienos_dien\u0173_dienas",
      xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
      xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
      xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
      xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
      xyears_one: "metai_met\u0173_metus",
      xyears_other: "metai_met\u0173_metus",
      about: "apie",
      over: "daugiau nei",
      almost: "beveik",
      lessthan: "ma\u017Eiau nei"
    };
    translateSeconds = function translateSeconds2(_number, addSuffix, _key, isFuture2) {
      if (!addSuffix) {
        return "kelios sekund\u0117s";
      } else {
        return isFuture2 ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
      }
    };
    translateSingular = function translateSingular2(_number, addSuffix, key, isFuture2) {
      return !addSuffix ? forms(key)[0] : isFuture2 ? forms(key)[1] : forms(key)[2];
    };
    translate = function translate2(number, addSuffix, key, isFuture2) {
      var result = number + " ";
      if (number === 1) {
        return result + translateSingular(number, addSuffix, key, isFuture2);
      } else if (!addSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
      } else {
        if (isFuture2) {
          return result + forms(key)[1];
        } else {
          return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
      }
    };
    formatDistanceLocale49 = {
      lessThanXSeconds: {
        one: translateSeconds,
        other: translate
      },
      xSeconds: {
        one: translateSeconds,
        other: translate
      },
      halfAMinute: "pus\u0117 minut\u0117s",
      lessThanXMinutes: {
        one: translateSingular,
        other: translate
      },
      xMinutes: {
        one: translateSingular,
        other: translate
      },
      aboutXHours: {
        one: translateSingular,
        other: translate
      },
      xHours: {
        one: translateSingular,
        other: translate
      },
      xDays: {
        one: translateSingular,
        other: translate
      },
      aboutXWeeks: {
        one: translateSingular,
        other: translate
      },
      xWeeks: {
        one: translateSingular,
        other: translate
      },
      aboutXMonths: {
        one: translateSingular,
        other: translate
      },
      xMonths: {
        one: translateSingular,
        other: translate
      },
      aboutXYears: {
        one: translateSingular,
        other: translate
      },
      xYears: {
        one: translateSingular,
        other: translate
      },
      overXYears: {
        one: translateSingular,
        other: translate
      },
      almostXYears: {
        one: translateSingular,
        other: translate
      }
    };
    formatDistance100 = function formatDistance101(token, count, options) {
      var adverb = token.match(/about|over|almost|lessthan/i);
      var unit = adverb ? token.replace(adverb[0], "") : token;
      var isFuture2 = (options === null || options === void 0 ? void 0 : options.comparison) !== void 0 && options.comparison > 0;
      var result;
      var tokenValue = formatDistanceLocale49[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_one", isFuture2);
      } else {
        result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_other", isFuture2);
      }
      if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = translations2[_key2] + " " + result;
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "po " + result;
        } else {
          return "prie\u0161 " + result;
        }
      }
      return result;
    };
    formatDistance_default50 = formatDistance100;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/_lib/formatLong/index.js
var dateFormats58, timeFormats58, dateTimeFormats58, formatLong58, formatLong_default58;
var init_formatLong58 = __esm({
  "../../node_modules/date-fns/esm/locale/lt/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats58 = {
      full: "y 'm'. MMMM d 'd'., EEEE",
      long: "y 'm'. MMMM d 'd'.",
      medium: "y-MM-dd",
      short: "y-MM-dd"
    };
    timeFormats58 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats58 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong58 = {
      date: buildFormatLongFn({
        formats: dateFormats58,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats58,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats58,
        defaultWidth: "full"
      })
    };
    formatLong_default58 = formatLong58;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/_lib/formatRelative/index.js
var formatRelativeLocale50, formatRelative100, formatRelative_default50;
var init_formatRelative51 = __esm({
  "../../node_modules/date-fns/esm/locale/lt/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale50 = {
      lastWeek: "'Pra\u0117jus\u012F' eeee p",
      yesterday: "'Vakar' p",
      today: "'\u0160iandien' p",
      tomorrow: "'Rytoj' p",
      nextWeek: "eeee p",
      other: "P"
    };
    formatRelative100 = function formatRelative101(token, _date, _baseDate, _options) {
      return formatRelativeLocale50[token];
    };
    formatRelative_default50 = formatRelative100;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/_lib/localize/index.js
var eraValues50, quarterValues50, formattingQuarterValues2, monthValues50, formattingMonthValues11, dayValues50, formattingDayValues2, dayPeriodValues50, formattingDayPeriodValues42, ordinalNumber99, localize50, localize_default50;
var init_localize50 = __esm({
  "../../node_modules/date-fns/esm/locale/lt/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues50 = {
      narrow: ["pr. Kr.", "po Kr."],
      abbreviated: ["pr. Kr.", "po Kr."],
      wide: ["prie\u0161 Krist\u0173", "po Kristaus"]
    };
    quarterValues50 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
      wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
    };
    formattingQuarterValues2 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["I k.", "II k.", "III k.", "IV k."],
      wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
    };
    monthValues50 = {
      narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
      abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "bir\u017E.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
      wide: ["sausis", "vasaris", "kovas", "balandis", "gegu\u017E\u0117", "bir\u017Eelis", "liepa", "rugpj\u016Btis", "rugs\u0117jis", "spalis", "lapkritis", "gruodis"]
    };
    formattingMonthValues11 = {
      narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
      abbreviated: ["saus.", "vas.", "kov.", "bal.", "geg.", "bir\u017E.", "liep.", "rugp.", "rugs.", "spal.", "lapkr.", "gruod."],
      wide: ["sausio", "vasario", "kovo", "baland\u017Eio", "gegu\u017E\u0117s", "bir\u017Eelio", "liepos", "rugpj\u016B\u010Dio", "rugs\u0117jo", "spalio", "lapkri\u010Dio", "gruod\u017Eio"]
    };
    dayValues50 = {
      narrow: ["S", "P", "A", "T", "K", "P", "\u0160"],
      short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "\u0160t"],
      abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "\u0161t"],
      wide: ["sekmadienis", "pirmadienis", "antradienis", "tre\u010Diadienis", "ketvirtadienis", "penktadienis", "\u0161e\u0161tadienis"]
    };
    formattingDayValues2 = {
      narrow: ["S", "P", "A", "T", "K", "P", "\u0160"],
      short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "\u0160t"],
      abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "\u0161t"],
      wide: ["sekmadien\u012F", "pirmadien\u012F", "antradien\u012F", "tre\u010Diadien\u012F", "ketvirtadien\u012F", "penktadien\u012F", "\u0161e\u0161tadien\u012F"]
    };
    dayPeriodValues50 = {
      narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
      },
      abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
      },
      wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
      }
    };
    formattingDayPeriodValues42 = {
      narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
      },
      abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
      },
      wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
      }
    };
    ordinalNumber99 = function ordinalNumber100(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "-oji";
    };
    localize50 = {
      ordinalNumber: ordinalNumber99,
      era: buildLocalizeFn({
        values: eraValues50,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues50,
        defaultWidth: "wide",
        formattingValues: formattingQuarterValues2,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback50(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues50,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues11,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues50,
        defaultWidth: "wide",
        formattingValues: formattingDayValues2,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues50,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues42,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default50 = localize50;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/_lib/match/index.js
var matchOrdinalNumberPattern49, parseOrdinalNumberPattern49, matchEraPatterns49, parseEraPatterns49, matchQuarterPatterns49, parseQuarterPatterns49, matchMonthPatterns49, parseMonthPatterns49, matchDayPatterns49, parseDayPatterns49, matchDayPeriodPatterns49, parseDayPeriodPatterns49, match49, match_default49;
var init_match49 = __esm({
  "../../node_modules/date-fns/esm/locale/lt/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern49 = /^(\d+)(-oji)?/i;
    parseOrdinalNumberPattern49 = /\d+/i;
    matchEraPatterns49 = {
      narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
      abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
      wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
    };
    parseEraPatterns49 = {
      wide: [/prieš/i, /(po|mūsų)/i],
      any: [/^pr/i, /^(po|m)/i]
    };
    matchQuarterPatterns49 = {
      narrow: /^([1234])/i,
      abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
      wide: /^(I|II|III|IV)\s?ketvirtis/i
    };
    parseQuarterPatterns49 = {
      narrow: [/1/i, /2/i, /3/i, /4/i],
      any: [/I$/i, /II$/i, /III/i, /IV/i]
    };
    matchMonthPatterns49 = {
      narrow: /^[svkbglr]/i,
      abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
      wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
    };
    parseMonthPatterns49 = {
      narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
      any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
    };
    matchDayPatterns49 = {
      narrow: /^[spatkš]/i,
      short: /^(sk|pr|an|tr|kt|pn|št)/i,
      abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
      wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
    };
    parseDayPatterns49 = {
      narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
      wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
      any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
    };
    matchDayPeriodPatterns49 = {
      narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
      any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
    };
    parseDayPeriodPatterns49 = {
      narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
      },
      any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
      }
    };
    match49 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern49,
        parsePattern: parseOrdinalNumberPattern49,
        valueCallback: function valueCallback96(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns49,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns49,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns49,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns49,
        defaultParseWidth: "any",
        valueCallback: function valueCallback97(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns49,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns49,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns49,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns49,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns49,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns49,
        defaultParseWidth: "any"
      })
    };
    match_default49 = match49;
  }
});

// ../../node_modules/date-fns/esm/locale/lt/index.js
var locale60, lt_default;
var init_lt = __esm({
  "../../node_modules/date-fns/esm/locale/lt/index.js"() {
    "use strict";
    init_formatDistance51();
    init_formatLong58();
    init_formatRelative51();
    init_localize50();
    init_match49();
    locale60 = {
      code: "lt",
      formatDistance: formatDistance_default50,
      formatLong: formatLong_default58,
      formatRelative: formatRelative_default50,
      localize: localize_default50,
      match: match_default49,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    lt_default = locale60;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/_lib/formatDistance/index.js
function buildLocalizeTokenFn3(schema) {
  return function(count, options) {
    if (count === 1) {
      if (options !== null && options !== void 0 && options.addSuffix) {
        return schema.one[0].replace("{{time}}", schema.one[2]);
      } else {
        return schema.one[0].replace("{{time}}", schema.one[1]);
      }
    } else {
      var rem = count % 10 === 1 && count % 100 !== 11;
      if (options !== null && options !== void 0 && options.addSuffix) {
        return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
      } else {
        return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
      }
    }
  };
}
var formatDistanceLocale50, formatDistance102, formatDistance_default51;
var init_formatDistance52 = __esm({
  "../../node_modules/date-fns/esm/locale/lv/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale50 = {
      lessThanXSeconds: buildLocalizeTokenFn3({
        one: ["maz\u0101k par {{time}}", "sekundi", "sekundi"],
        other: ["maz\u0101k nek\u0101 {{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekund\u0113m"]
      }),
      xSeconds: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "sekunde", "sekundes"],
        other: ["{{count}} {{time}}", "sekunde", "sekundes", "sekundes", "sekund\u0113m"]
      }),
      halfAMinute: function halfAMinute6(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          return "pusmin\u016Btes";
        } else {
          return "pusmin\u016Bte";
        }
      },
      lessThanXMinutes: buildLocalizeTokenFn3({
        one: ["maz\u0101k par {{time}}", "min\u016Bti", "min\u016Bti"],
        other: ["maz\u0101k nek\u0101 {{count}} {{time}}", "min\u016Bte", "min\u016Btes", "min\u016Btes", "min\u016Bt\u0113m"]
      }),
      xMinutes: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "min\u016Bte", "min\u016Btes"],
        other: ["{{count}} {{time}}", "min\u016Bte", "min\u016Btes", "min\u016Btes", "min\u016Bt\u0113m"]
      }),
      aboutXHours: buildLocalizeTokenFn3({
        one: ["apm\u0113ram 1 {{time}}", "stunda", "stundas"],
        other: ["apm\u0113ram {{count}} {{time}}", "stunda", "stundas", "stundas", "stund\u0101m"]
      }),
      xHours: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "stunda", "stundas"],
        other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stund\u0101m"]
      }),
      xDays: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "diena", "dienas"],
        other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dien\u0101m"]
      }),
      aboutXWeeks: buildLocalizeTokenFn3({
        one: ["apm\u0113ram 1 {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cas"],
        other: ["apm\u0113ram {{count}} {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cu", "ned\u0113\u013Cas", "ned\u0113\u013C\u0101m"]
      }),
      xWeeks: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "ned\u0113\u013Ca", "ned\u0113\u013Cas"],
        other: [
          "{{count}} {{time}}",
          // TODO
          "ned\u0113\u013Ca",
          "ned\u0113\u013Cu",
          "ned\u0113\u013Cas",
          "ned\u0113\u013C\u0101m"
        ]
      }),
      aboutXMonths: buildLocalizeTokenFn3({
        one: ["apm\u0113ram 1 {{time}}", "m\u0113nesis", "m\u0113ne\u0161a"],
        other: ["apm\u0113ram {{count}} {{time}}", "m\u0113nesis", "m\u0113ne\u0161i", "m\u0113ne\u0161a", "m\u0113ne\u0161iem"]
      }),
      xMonths: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "m\u0113nesis", "m\u0113ne\u0161a"],
        other: ["{{count}} {{time}}", "m\u0113nesis", "m\u0113ne\u0161i", "m\u0113ne\u0161a", "m\u0113ne\u0161iem"]
      }),
      aboutXYears: buildLocalizeTokenFn3({
        one: ["apm\u0113ram 1 {{time}}", "gads", "gada"],
        other: ["apm\u0113ram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
      }),
      xYears: buildLocalizeTokenFn3({
        one: ["1 {{time}}", "gads", "gada"],
        other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
      }),
      overXYears: buildLocalizeTokenFn3({
        one: ["ilg\u0101k par 1 {{time}}", "gadu", "gadu"],
        other: ["vair\u0101k nek\u0101 {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
      }),
      almostXYears: buildLocalizeTokenFn3({
        one: ["gandr\u012Bz 1 {{time}}", "gads", "gada"],
        other: ["vair\u0101k nek\u0101 {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
      })
    };
    formatDistance102 = function formatDistance103(token, count, options) {
      var result = formatDistanceLocale50[token](count, options);
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "p\u0113c " + result;
        } else {
          return "pirms " + result;
        }
      }
      return result;
    };
    formatDistance_default51 = formatDistance102;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/_lib/formatLong/index.js
var dateFormats59, timeFormats59, dateTimeFormats59, formatLong59, formatLong_default59;
var init_formatLong59 = __esm({
  "../../node_modules/date-fns/esm/locale/lv/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats59 = {
      full: "EEEE, y. 'gada' d. MMMM",
      long: "y. 'gada' d. MMMM",
      medium: "dd.MM.y.",
      short: "dd.MM.y."
    };
    timeFormats59 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats59 = {
      full: "{{date}} 'plkst.' {{time}}",
      long: "{{date}} 'plkst.' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong59 = {
      date: buildFormatLongFn({
        formats: dateFormats59,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats59,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats59,
        defaultWidth: "full"
      })
    };
    formatLong_default59 = formatLong59;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/_lib/formatRelative/index.js
var weekdays3, formatRelativeLocale51, formatRelative102, formatRelative_default51;
var init_formatRelative52 = __esm({
  "../../node_modules/date-fns/esm/locale/lv/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    weekdays3 = ["sv\u0113tdien\u0101", "pirmdien\u0101", "otrdien\u0101", "tre\u0161dien\u0101", "ceturtdien\u0101", "piektdien\u0101", "sestdien\u0101"];
    formatRelativeLocale51 = {
      lastWeek: function lastWeek10(date, baseDate, options) {
        if (isSameUTCWeek(date, baseDate, options)) {
          return "eeee 'plkst.' p";
        }
        var weekday = weekdays3[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
      },
      yesterday: "'Vakar plkst.' p",
      today: "'\u0160odien plkst.' p",
      tomorrow: "'R\u012Bt plkst.' p",
      nextWeek: function nextWeek9(date, baseDate, options) {
        if (isSameUTCWeek(date, baseDate, options)) {
          return "eeee 'plkst.' p";
        }
        var weekday = weekdays3[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
      },
      other: "P"
    };
    formatRelative102 = function formatRelative103(token, date, baseDate, options) {
      var format2 = formatRelativeLocale51[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default51 = formatRelative102;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/_lib/localize/index.js
var eraValues51, quarterValues51, formattingQuarterValues3, monthValues51, formattingMonthValues12, dayValues51, formattingDayValues3, dayPeriodValues51, formattingDayPeriodValues43, ordinalNumber101, localize51, localize_default51;
var init_localize51 = __esm({
  "../../node_modules/date-fns/esm/locale/lv/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues51 = {
      narrow: ["p.m.\u0113", "m.\u0113"],
      abbreviated: ["p. m. \u0113.", "m. \u0113."],
      wide: ["pirms m\u016Bsu \u0113ras", "m\u016Bsu \u0113r\u0101"]
    };
    quarterValues51 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
      wide: ["pirmais ceturksnis", "otrais ceturksnis", "tre\u0161ais ceturksnis", "ceturtais ceturksnis"]
    };
    formattingQuarterValues3 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
      wide: ["pirmaj\u0101 ceturksn\u012B", "otraj\u0101 ceturksn\u012B", "tre\u0161aj\u0101 ceturksn\u012B", "ceturtaj\u0101 ceturksn\u012B"]
    };
    monthValues51 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["janv.", "febr.", "marts", "apr.", "maijs", "j\u016Bn.", "j\u016Bl.", "aug.", "sept.", "okt.", "nov.", "dec."],
      wide: ["janv\u0101ris", "febru\u0101ris", "marts", "apr\u012Blis", "maijs", "j\u016Bnijs", "j\u016Blijs", "augusts", "septembris", "oktobris", "novembris", "decembris"]
    };
    formattingMonthValues12 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["janv.", "febr.", "mart\u0101", "apr.", "maijs", "j\u016Bn.", "j\u016Bl.", "aug.", "sept.", "okt.", "nov.", "dec."],
      wide: ["janv\u0101r\u012B", "febru\u0101r\u012B", "mart\u0101", "apr\u012Bl\u012B", "maij\u0101", "j\u016Bnij\u0101", "j\u016Blij\u0101", "august\u0101", "septembr\u012B", "oktobr\u012B", "novembr\u012B", "decembr\u012B"]
    };
    dayValues51 = {
      narrow: ["S", "P", "O", "T", "C", "P", "S"],
      short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
      abbreviated: ["sv\u0113td.", "pirmd.", "otrd.", "tre\u0161d.", "ceturtd.", "piektd.", "sestd."],
      wide: ["sv\u0113tdiena", "pirmdiena", "otrdiena", "tre\u0161diena", "ceturtdiena", "piektdiena", "sestdiena"]
    };
    formattingDayValues3 = {
      narrow: ["S", "P", "O", "T", "C", "P", "S"],
      short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
      abbreviated: ["sv\u0113td.", "pirmd.", "otrd.", "tre\u0161d.", "ceturtd.", "piektd.", "sestd."],
      wide: ["sv\u0113tdien\u0101", "pirmdien\u0101", "otrdien\u0101", "tre\u0161dien\u0101", "ceturtdien\u0101", "piektdien\u0101", "sestdien\u0101"]
    };
    dayPeriodValues51 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
      },
      abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
      },
      wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
      }
    };
    formattingDayPeriodValues43 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
      },
      abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
      },
      wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
      }
    };
    ordinalNumber101 = function ordinalNumber102(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize51 = {
      ordinalNumber: ordinalNumber101,
      era: buildLocalizeFn({
        values: eraValues51,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues51,
        defaultWidth: "wide",
        formattingValues: formattingQuarterValues3,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback51(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues51,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues12,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues51,
        defaultWidth: "wide",
        formattingValues: formattingDayValues3,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues51,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues43,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default51 = localize51;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/_lib/match/index.js
var matchOrdinalNumberPattern50, parseOrdinalNumberPattern50, matchEraPatterns50, parseEraPatterns50, matchQuarterPatterns50, parseQuarterPatterns50, matchMonthPatterns50, parseMonthPatterns50, matchDayPatterns50, parseDayPatterns50, matchDayPeriodPatterns50, parseDayPeriodPatterns50, match50, match_default50;
var init_match50 = __esm({
  "../../node_modules/date-fns/esm/locale/lv/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern50 = /^(\d+)\./i;
    parseOrdinalNumberPattern50 = /\d+/i;
    matchEraPatterns50 = {
      narrow: /^(p\.m\.ē|m\.ē)/i,
      abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
      wide: /^(pirms mūsu ēras|mūsu ērā)/i
    };
    parseEraPatterns50 = {
      any: [/^p/i, /^m/i]
    };
    matchQuarterPatterns50 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](\. cet\.)/i,
      wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
    };
    parseQuarterPatterns50 = {
      narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
      abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
      wide: [/^p/i, /^o/i, /^t/i, /^c/i]
    };
    matchMonthPatterns50 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
      wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
    };
    parseMonthPatterns50 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns50 = {
      narrow: /^[spotc]/i,
      short: /^(sv|pi|o|t|c|pk|s)/i,
      abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
      wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
    };
    parseDayPatterns50 = {
      narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
      any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
    };
    matchDayPeriodPatterns50 = {
      narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
      abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
      wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
    };
    parseDayPeriodPatterns50 = {
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
      }
    };
    match50 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern50,
        parsePattern: parseOrdinalNumberPattern50,
        valueCallback: function valueCallback98(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns50,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns50,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns50,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns50,
        defaultParseWidth: "wide",
        valueCallback: function valueCallback99(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns50,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns50,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns50,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns50,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns50,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns50,
        defaultParseWidth: "any"
      })
    };
    match_default50 = match50;
  }
});

// ../../node_modules/date-fns/esm/locale/lv/index.js
var locale61, lv_default;
var init_lv = __esm({
  "../../node_modules/date-fns/esm/locale/lv/index.js"() {
    "use strict";
    init_formatDistance52();
    init_formatLong59();
    init_formatRelative52();
    init_localize51();
    init_match50();
    locale61 = {
      code: "lv",
      formatDistance: formatDistance_default51,
      formatLong: formatLong_default59,
      formatRelative: formatRelative_default51,
      localize: localize_default51,
      match: match_default50,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    lv_default = locale61;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/_lib/formatDistance/index.js
var formatDistanceLocale51, formatDistance104, formatDistance_default52;
var init_formatDistance53 = __esm({
  "../../node_modules/date-fns/esm/locale/mk/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale51 = {
      lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
      lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
      },
      xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
      },
      aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
      },
      xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
      },
      xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
      },
      aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
      },
      xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
      },
      aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
      },
      xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
      },
      aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      },
      almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
      }
    };
    formatDistance104 = function formatDistance105(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale51[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0437\u0430 " + result;
        } else {
          return "\u043F\u0440\u0435\u0434 " + result;
        }
      }
      return result;
    };
    formatDistance_default52 = formatDistance104;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/_lib/formatLong/index.js
var dateFormats60, timeFormats60, dateTimeFormats60, formatLong60, formatLong_default60;
var init_formatLong60 = __esm({
  "../../node_modules/date-fns/esm/locale/mk/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats60 = {
      full: "EEEE, dd MMMM yyyy",
      long: "dd MMMM yyyy",
      medium: "dd MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats60 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats60 = {
      any: "{{date}} {{time}}"
    };
    formatLong60 = {
      date: buildFormatLongFn({
        formats: dateFormats60,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats60,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats60,
        defaultWidth: "any"
      })
    };
    formatLong_default60 = formatLong60;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/_lib/formatRelative/index.js
function _lastWeek3(day) {
  var weekday = weekdays4[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
  }
}
function thisWeek6(day) {
  var weekday = weekdays4[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
  }
}
function _nextWeek3(day) {
  var weekday = weekdays4[day];
  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
  }
}
var weekdays4, formatRelativeLocale52, formatRelative104, formatRelative_default52;
var init_formatRelative53 = __esm({
  "../../node_modules/date-fns/esm/locale/mk/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    weekdays4 = ["\u043D\u0435\u0434\u0435\u043B\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A", "\u043F\u0435\u0442\u043E\u043A", "\u0441\u0430\u0431\u043E\u0442\u0430"];
    formatRelativeLocale52 = {
      lastWeek: function lastWeek11(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek6(day);
        } else {
          return _lastWeek3(day);
        }
      },
      yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
      today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
      tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
      nextWeek: function nextWeek10(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek6(day);
        } else {
          return _nextWeek3(day);
        }
      },
      other: "P"
    };
    formatRelative104 = function formatRelative105(token, date, baseDate, options) {
      var format2 = formatRelativeLocale52[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default52 = formatRelative104;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/_lib/localize/index.js
var eraValues52, quarterValues52, monthValues52, dayValues52, dayPeriodValues52, ordinalNumber103, localize52, localize_default52;
var init_localize52 = __esm({
  "../../node_modules/date-fns/esm/locale/mk/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues52 = {
      narrow: ["\u043F\u0440.\u043D.\u0435.", "\u043D.\u0435."],
      abbreviated: ["\u043F\u0440\u0435\u0434 \u043D. \u0435.", "\u043D. \u0435."],
      wide: ["\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430", "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"]
    };
    quarterValues52 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0432\u0438 \u043A\u0432.", "2-\u0440\u0438 \u043A\u0432.", "3-\u0442\u0438 \u043A\u0432.", "4-\u0442\u0438 \u043A\u0432."],
      wide: ["1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues52 = {
      abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F\u0442", "\u043E\u043A\u0442", "\u043D\u043E\u0435\u043C", "\u0434\u0435\u043A"],
      wide: ["\u0458\u0430\u043D\u0443\u0430\u0440\u0438", "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D\u0438", "\u0458\u0443\u043B\u0438", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438", "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438", "\u043D\u043E\u0435\u043C\u0432\u0440\u0438", "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"]
    };
    dayValues52 = {
      narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0435", "\u043F\u043E", "\u0432\u0442", "\u0441\u0440", "\u0447\u0435", "\u043F\u0435", "\u0441\u0430"],
      abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0430\u0431"],
      wide: ["\u043D\u0435\u0434\u0435\u043B\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A", "\u043F\u0435\u0442\u043E\u043A", "\u0441\u0430\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues52 = {
      wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
      }
    };
    ordinalNumber103 = function ordinalNumber104(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
            return number + "-\u0432\u0438";
          case 2:
            return number + "-\u0440\u0438";
          case 7:
          case 8:
            return number + "-\u043C\u0438";
        }
      }
      return number + "-\u0442\u0438";
    };
    localize52 = {
      ordinalNumber: ordinalNumber103,
      era: buildLocalizeFn({
        values: eraValues52,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues52,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback52(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues52,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues52,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues52,
        defaultWidth: "wide"
      })
    };
    localize_default52 = localize52;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/_lib/match/index.js
var matchOrdinalNumberPattern51, parseOrdinalNumberPattern51, matchEraPatterns51, parseEraPatterns51, matchQuarterPatterns51, parseQuarterPatterns51, matchDayPatterns51, parseDayPatterns51, matchMonthPatterns51, parseMonthPatterns51, matchDayPeriodPatterns51, parseDayPeriodPatterns51, match51, match_default51;
var init_match51 = __esm({
  "../../node_modules/date-fns/esm/locale/mk/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern51 = /^(\d+)(-?[врмт][и])?/i;
    parseOrdinalNumberPattern51 = /\d+/i;
    matchEraPatterns51 = {
      narrow: /^((пр)?н\.?\s?е\.?)/i,
      abbreviated: /^((пр)?н\.?\s?е\.?)/i,
      wide: /^(пред нашата ера|нашата ера)/i
    };
    parseEraPatterns51 = {
      any: [/^п/i, /^н/i]
    };
    matchQuarterPatterns51 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
      wide: /^[1234](-?[врт]?и?)? квартал/i
    };
    parseQuarterPatterns51 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchDayPatterns51 = {
      narrow: /^[нпвсч]/i,
      short: /^(не|по|вт|ср|че|пе|са)/i,
      abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
      wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
    };
    parseDayPatterns51 = {
      narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
    };
    matchMonthPatterns51 = {
      abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
      wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
    };
    parseMonthPatterns51 = {
      any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
    };
    matchDayPeriodPatterns51 = {
      any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
    };
    parseDayPeriodPatterns51 = {
      any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
      }
    };
    match51 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern51,
        parsePattern: parseOrdinalNumberPattern51,
        valueCallback: function valueCallback100(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns51,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns51,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns51,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns51,
        defaultParseWidth: "any",
        valueCallback: function valueCallback101(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns51,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns51,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns51,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns51,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns51,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns51,
        defaultParseWidth: "any"
      })
    };
    match_default51 = match51;
  }
});

// ../../node_modules/date-fns/esm/locale/mk/index.js
var locale62, mk_default;
var init_mk = __esm({
  "../../node_modules/date-fns/esm/locale/mk/index.js"() {
    "use strict";
    init_formatDistance53();
    init_formatLong60();
    init_formatRelative53();
    init_localize52();
    init_match51();
    locale62 = {
      code: "mk",
      formatDistance: formatDistance_default52,
      formatLong: formatLong_default60,
      formatRelative: formatRelative_default52,
      localize: localize_default52,
      match: match_default51,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    mk_default = locale62;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/_lib/formatDistance/index.js
var formatDistanceLocale52, formatDistance106, formatDistance_default53;
var init_formatDistance54 = __esm({
  "../../node_modules/date-fns/esm/locale/mn/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale52 = {
      lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
      },
      xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
      },
      halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
      lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
      },
      xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
      },
      aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
      },
      xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
      },
      xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
      },
      aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
      },
      xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
      },
      aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
      },
      xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
      },
      aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
      },
      xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
      },
      overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
      },
      almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
      }
    };
    formatDistance106 = function formatDistance107(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale52[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        var words = result.split(" ");
        var lastword = words.pop();
        result = words.join(" ");
        switch (lastword) {
          case "\u0441\u0435\u043A\u0443\u043D\u0434":
            result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
            break;
          case "\u043C\u0438\u043D\u0443\u0442":
            result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
            break;
          case "\u0446\u0430\u0433":
            result += " \u0446\u0430\u0433\u0438\u0439\u043D";
            break;
          case "\u04E9\u0434\u04E9\u0440":
            result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
            break;
          case "\u0441\u0430\u0440":
            result += " \u0441\u0430\u0440\u044B\u043D";
            break;
          case "\u0436\u0438\u043B":
            result += " \u0436\u0438\u043B\u0438\u0439\u043D";
            break;
          case "\u0445\u043E\u043D\u043E\u0433":
            result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
            break;
          case "\u0433\u0430\u0440\u0430\u043D":
            result += " \u0433\u0430\u0440\u0430\u043D\u044B";
            break;
          case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
            result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
            break;
          default:
            result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) {
          return result + " \u0434\u0430\u0440\u0430\u0430";
        } else {
          return result + " \u04E9\u043C\u043D\u04E9";
        }
      }
      return result;
    };
    formatDistance_default53 = formatDistance106;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/_lib/formatLong/index.js
var dateFormats61, timeFormats61, dateTimeFormats61, formatLong61, formatLong_default61;
var init_formatLong61 = __esm({
  "../../node_modules/date-fns/esm/locale/mn/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats61 = {
      full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
      long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
      medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
      short: "y.MM.dd"
    };
    timeFormats61 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats61 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong61 = {
      date: buildFormatLongFn({
        formats: dateFormats61,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats61,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats61,
        defaultWidth: "full"
      })
    };
    formatLong_default61 = formatLong61;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/_lib/formatRelative/index.js
var formatRelativeLocale53, formatRelative106, formatRelative_default53;
var init_formatRelative54 = __esm({
  "../../node_modules/date-fns/esm/locale/mn/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale53 = {
      lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
      yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
      today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
      tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
      nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
      other: "P"
    };
    formatRelative106 = function formatRelative107(token, _date, _baseDate, _options) {
      return formatRelativeLocale53[token];
    };
    formatRelative_default53 = formatRelative106;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/_lib/localize/index.js
var eraValues53, quarterValues53, monthValues53, formattingMonthValues13, dayValues53, formattingDayValues4, dayPeriodValues53, ordinalNumber105, localize53, localize_default53;
var init_localize53 = __esm({
  "../../node_modules/date-fns/esm/locale/mn/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues53 = {
      narrow: ["\u041D\u0422\u04E8", "\u041D\u0422"],
      abbreviated: ["\u041D\u0422\u04E8", "\u041D\u0422"],
      wide: ["\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445", "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"]
    };
    quarterValues53 = {
      narrow: ["I", "II", "III", "IV"],
      abbreviated: ["I \u0443\u043B\u0438\u0440\u0430\u043B", "II \u0443\u043B\u0438\u0440\u0430\u043B", "III \u0443\u043B\u0438\u0440\u0430\u043B", "IV \u0443\u043B\u0438\u0440\u0430\u043B"],
      wide: ["1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B", "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"]
    };
    monthValues53 = {
      narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
      abbreviated: ["1-\u0440 \u0441\u0430\u0440", "2-\u0440 \u0441\u0430\u0440", "3-\u0440 \u0441\u0430\u0440", "4-\u0440 \u0441\u0430\u0440", "5-\u0440 \u0441\u0430\u0440", "6-\u0440 \u0441\u0430\u0440", "7-\u0440 \u0441\u0430\u0440", "8-\u0440 \u0441\u0430\u0440", "9-\u0440 \u0441\u0430\u0440", "10-\u0440 \u0441\u0430\u0440", "11-\u0440 \u0441\u0430\u0440", "12-\u0440 \u0441\u0430\u0440"],
      wide: ["\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]
    };
    formattingMonthValues13 = {
      narrow: ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"],
      abbreviated: ["1-\u0440 \u0441\u0430\u0440", "2-\u0440 \u0441\u0430\u0440", "3-\u0440 \u0441\u0430\u0440", "4-\u0440 \u0441\u0430\u0440", "5-\u0440 \u0441\u0430\u0440", "6-\u0440 \u0441\u0430\u0440", "7-\u0440 \u0441\u0430\u0440", "8-\u0440 \u0441\u0430\u0440", "9-\u0440 \u0441\u0430\u0440", "10-\u0440 \u0441\u0430\u0440", "11-\u0440 \u0441\u0430\u0440", "12-\u0440 \u0441\u0430\u0440"],
      wide: ["\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440", "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"]
    };
    dayValues53 = {
      narrow: ["\u041D", "\u0414", "\u041C", "\u041B", "\u041F", "\u0411", "\u0411"],
      short: ["\u041D\u044F", "\u0414\u0430", "\u041C\u044F", "\u041B\u0445", "\u041F\u04AF", "\u0411\u0430", "\u0411\u044F"],
      abbreviated: ["\u041D\u044F\u043C", "\u0414\u0430\u0432", "\u041C\u044F\u0433", "\u041B\u0445\u0430", "\u041F\u04AF\u0440", "\u0411\u0430\u0430", "\u0411\u044F\u043C"],
      wide: ["\u041D\u044F\u043C", "\u0414\u0430\u0432\u0430\u0430", "\u041C\u044F\u0433\u043C\u0430\u0440", "\u041B\u0445\u0430\u0433\u0432\u0430", "\u041F\u04AF\u0440\u044D\u0432", "\u0411\u0430\u0430\u0441\u0430\u043D", "\u0411\u044F\u043C\u0431\u0430"]
    };
    formattingDayValues4 = {
      narrow: ["\u041D", "\u0414", "\u041C", "\u041B", "\u041F", "\u0411", "\u0411"],
      short: ["\u041D\u044F", "\u0414\u0430", "\u041C\u044F", "\u041B\u0445", "\u041F\u04AF", "\u0411\u0430", "\u0411\u044F"],
      abbreviated: ["\u041D\u044F\u043C", "\u0414\u0430\u0432", "\u041C\u044F\u0433", "\u041B\u0445\u0430", "\u041F\u04AF\u0440", "\u0411\u0430\u0430", "\u0411\u044F\u043C"],
      wide: ["\u043D\u044F\u043C", "\u0434\u0430\u0432\u0430\u0430", "\u043C\u044F\u0433\u043C\u0430\u0440", "\u043B\u0445\u0430\u0433\u0432\u0430", "\u043F\u04AF\u0440\u044D\u0432", "\u0431\u0430\u0430\u0441\u0430\u043D", "\u0431\u044F\u043C\u0431\u0430"]
    };
    dayPeriodValues53 = {
      narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
      },
      abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
      },
      wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
      }
    };
    ordinalNumber105 = function ordinalNumber106(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize53 = {
      ordinalNumber: ordinalNumber105,
      era: buildLocalizeFn({
        values: eraValues53,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues53,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback53(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues53,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues13,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues53,
        defaultWidth: "wide",
        formattingValues: formattingDayValues4,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues53,
        defaultWidth: "wide"
      })
    };
    localize_default53 = localize53;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/_lib/match/index.js
var matchOrdinalNumberPattern52, parseOrdinalNumberPattern52, matchEraPatterns52, parseEraPatterns52, matchQuarterPatterns52, parseQuarterPatterns52, matchMonthPatterns52, parseMonthPatterns52, matchDayPatterns52, parseDayPatterns52, matchDayPeriodPatterns52, parseDayPeriodPatterns52, match52, match_default52;
var init_match52 = __esm({
  "../../node_modules/date-fns/esm/locale/mn/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern52 = /\d+/i;
    parseOrdinalNumberPattern52 = /\d+/i;
    matchEraPatterns52 = {
      narrow: /^(нтө|нт)/i,
      abbreviated: /^(нтө|нт)/i,
      wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
    };
    parseEraPatterns52 = {
      any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
    };
    matchQuarterPatterns52 = {
      narrow: /^(iv|iii|ii|i)/i,
      abbreviated: /^(iv|iii|ii|i) улирал/i,
      wide: /^[1-4]-р улирал/i
    };
    parseQuarterPatterns52 = {
      any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
    };
    matchMonthPatterns52 = {
      narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
      abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
      wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
    };
    parseMonthPatterns52 = {
      narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
      any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
    };
    matchDayPatterns52 = {
      narrow: /^[ндмлпбб]/i,
      short: /^(ня|да|мя|лх|пү|ба|бя)/i,
      abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
      wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
    };
    parseDayPatterns52 = {
      narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
      any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
    };
    matchDayPeriodPatterns52 = {
      narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
      any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
    };
    parseDayPeriodPatterns52 = {
      any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
      }
    };
    match52 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern52,
        parsePattern: parseOrdinalNumberPattern52,
        valueCallback: function valueCallback102(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns52,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns52,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns52,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns52,
        defaultParseWidth: "any",
        valueCallback: function valueCallback103(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns52,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns52,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns52,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns52,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns52,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns52,
        defaultParseWidth: "any"
      })
    };
    match_default52 = match52;
  }
});

// ../../node_modules/date-fns/esm/locale/mn/index.js
var locale63, mn_default;
var init_mn = __esm({
  "../../node_modules/date-fns/esm/locale/mn/index.js"() {
    "use strict";
    init_formatDistance54();
    init_formatLong61();
    init_formatRelative54();
    init_localize53();
    init_match52();
    locale63 = {
      code: "mn",
      formatDistance: formatDistance_default53,
      formatLong: formatLong_default61,
      formatRelative: formatRelative_default53,
      localize: localize_default53,
      match: match_default52,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    mn_default = locale63;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/_lib/formatDistance/index.js
var formatDistanceLocale53, formatDistance108, formatDistance_default54;
var init_formatDistance55 = __esm({
  "../../node_modules/date-fns/esm/locale/ms/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale53 = {
      lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
      },
      xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
      },
      halfAMinute: "setengah minit",
      lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
      },
      xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
      },
      aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
      },
      xHours: {
        one: "1 jam",
        other: "{{count}} jam"
      },
      xDays: {
        one: "1 hari",
        other: "{{count}} hari"
      },
      aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
      },
      xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
      },
      aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
      },
      xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
      },
      aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
      },
      xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
      },
      overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
      },
      almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
      }
    };
    formatDistance108 = function formatDistance109(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale53[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "dalam masa " + result;
        } else {
          return result + " yang lalu";
        }
      }
      return result;
    };
    formatDistance_default54 = formatDistance108;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/_lib/formatLong/index.js
var dateFormats62, timeFormats62, dateTimeFormats62, formatLong62, formatLong_default62;
var init_formatLong62 = __esm({
  "../../node_modules/date-fns/esm/locale/ms/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats62 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "d/M/yyyy"
    };
    timeFormats62 = {
      full: "HH.mm.ss",
      long: "HH.mm.ss",
      medium: "HH.mm",
      short: "HH.mm"
    };
    dateTimeFormats62 = {
      full: "{{date}} 'pukul' {{time}}",
      long: "{{date}} 'pukul' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong62 = {
      date: buildFormatLongFn({
        formats: dateFormats62,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats62,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats62,
        defaultWidth: "full"
      })
    };
    formatLong_default62 = formatLong62;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/_lib/formatRelative/index.js
var formatRelativeLocale54, formatRelative108, formatRelative_default54;
var init_formatRelative55 = __esm({
  "../../node_modules/date-fns/esm/locale/ms/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale54 = {
      lastWeek: "eeee 'lepas pada jam' p",
      yesterday: "'Semalam pada jam' p",
      today: "'Hari ini pada jam' p",
      tomorrow: "'Esok pada jam' p",
      nextWeek: "eeee 'pada jam' p",
      other: "P"
    };
    formatRelative108 = function formatRelative109(token, _date, _baseDate, _options) {
      return formatRelativeLocale54[token];
    };
    formatRelative_default54 = formatRelative108;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/_lib/localize/index.js
var eraValues54, quarterValues54, monthValues54, dayValues54, dayPeriodValues54, formattingDayPeriodValues44, ordinalNumber107, localize54, localize_default54;
var init_localize54 = __esm({
  "../../node_modules/date-fns/esm/locale/ms/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues54 = {
      narrow: ["SM", "M"],
      abbreviated: ["SM", "M"],
      wide: ["Sebelum Masihi", "Masihi"]
    };
    quarterValues54 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["S1", "S2", "S3", "S4"],
      wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
    };
    monthValues54 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mac", "Apr", "Mei", "Jun", "Jul", "Ogo", "Sep", "Okt", "Nov", "Dis"],
      wide: ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"]
    };
    dayValues54 = {
      narrow: ["A", "I", "S", "R", "K", "J", "S"],
      short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
      abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
      wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
    };
    dayPeriodValues54 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      }
    };
    formattingDayPeriodValues44 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
      }
    };
    ordinalNumber107 = function ordinalNumber108(dirtyNumber, _options) {
      return "ke-" + Number(dirtyNumber);
    };
    localize54 = {
      ordinalNumber: ordinalNumber107,
      era: buildLocalizeFn({
        values: eraValues54,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues54,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback54(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues54,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues54,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues54,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues44,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default54 = localize54;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/_lib/match/index.js
var matchOrdinalNumberPattern53, parseOrdinalNumberPattern53, matchEraPatterns53, parseEraPatterns53, matchQuarterPatterns53, parseQuarterPatterns53, matchMonthPatterns53, parseMonthPatterns53, matchDayPatterns53, parseDayPatterns53, matchDayPeriodPatterns53, parseDayPeriodPatterns53, match53, match_default53;
var init_match53 = __esm({
  "../../node_modules/date-fns/esm/locale/ms/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern53 = /^ke-(\d+)?/i;
    parseOrdinalNumberPattern53 = /petama|\d+/i;
    matchEraPatterns53 = {
      narrow: /^(sm|m)/i,
      abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
      wide: /^(sebelum masihi|masihi)/i
    };
    parseEraPatterns53 = {
      any: [/^s/i, /^(m)/i]
    };
    matchQuarterPatterns53 = {
      narrow: /^[1234]/i,
      abbreviated: /^S[1234]/i,
      wide: /Suku (pertama|kedua|ketiga|keempat)/i
    };
    parseQuarterPatterns53 = {
      any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
    };
    matchMonthPatterns53 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
      wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
    };
    parseMonthPatterns53 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
    };
    matchDayPatterns53 = {
      narrow: /^[aisrkj]/i,
      short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
      abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
      wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
    };
    parseDayPatterns53 = {
      narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
      any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
    };
    matchDayPeriodPatterns53 = {
      narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
      any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
    };
    parseDayPeriodPatterns53 = {
      any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
      }
    };
    match53 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern53,
        parsePattern: parseOrdinalNumberPattern53,
        valueCallback: function valueCallback104(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns53,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns53,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns53,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns53,
        defaultParseWidth: "any",
        valueCallback: function valueCallback105(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns53,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns53,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns53,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns53,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns53,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns53,
        defaultParseWidth: "any"
      })
    };
    match_default53 = match53;
  }
});

// ../../node_modules/date-fns/esm/locale/ms/index.js
var locale64, ms_default;
var init_ms = __esm({
  "../../node_modules/date-fns/esm/locale/ms/index.js"() {
    "use strict";
    init_formatDistance55();
    init_formatLong62();
    init_formatRelative55();
    init_localize54();
    init_match53();
    locale64 = {
      code: "ms",
      formatDistance: formatDistance_default54,
      formatLong: formatLong_default62,
      formatRelative: formatRelative_default54,
      localize: localize_default54,
      match: match_default53,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ms_default = locale64;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/_lib/formatDistance/index.js
var formatDistanceLocale54, formatDistance110, formatDistance_default55;
var init_formatDistance56 = __esm({
  "../../node_modules/date-fns/esm/locale/mt/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale54 = {
      lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
      },
      xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
      },
      halfAMinute: "nofs minuta",
      lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
      },
      xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
      },
      aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
      },
      xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
      },
      xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
      },
      aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
      },
      xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
      },
      aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
      },
      xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
      },
      aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
      },
      xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
      },
      overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
      },
      almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
      }
    };
    formatDistance110 = function formatDistance111(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale54[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else if (count === 2 && tokenValue.two) {
        result = tokenValue.two;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "f'" + result;
        } else {
          return result + " ilu";
        }
      }
      return result;
    };
    formatDistance_default55 = formatDistance110;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/_lib/formatLong/index.js
var dateFormats63, timeFormats63, dateTimeFormats63, formatLong63, formatLong_default63;
var init_formatLong63 = __esm({
  "../../node_modules/date-fns/esm/locale/mt/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats63 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd/MM/yyyy"
    };
    timeFormats63 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats63 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong63 = {
      date: buildFormatLongFn({
        formats: dateFormats63,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats63,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats63,
        defaultWidth: "full"
      })
    };
    formatLong_default63 = formatLong63;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/_lib/formatRelative/index.js
var formatRelativeLocale55, formatRelative110, formatRelative_default55;
var init_formatRelative56 = __esm({
  "../../node_modules/date-fns/esm/locale/mt/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale55 = {
      lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
      yesterday: "'Il-biera\u0127 fil-'p",
      today: "'Illum fil-'p",
      tomorrow: "'G\u0127ada fil-'p",
      nextWeek: "eeee 'fil-'p",
      other: "P"
    };
    formatRelative110 = function formatRelative111(token, _date, _baseDate, _options) {
      return formatRelativeLocale55[token];
    };
    formatRelative_default55 = formatRelative110;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/_lib/localize/index.js
var eraValues55, quarterValues55, monthValues55, dayValues55, dayPeriodValues55, formattingDayPeriodValues45, ordinalNumber109, localize55, localize_default55;
var init_localize55 = __esm({
  "../../node_modules/date-fns/esm/locale/mt/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues55 = {
      narrow: ["Q", "W"],
      abbreviated: ["QK", "WK"],
      wide: ["qabel Kristu", "wara Kristu"]
    };
    quarterValues55 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"]
    };
    monthValues55 = {
      narrow: ["J", "F", "M", "A", "M", "\u0120", "L", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Fra", "Mar", "Apr", "Mej", "\u0120un", "Lul", "Aww", "Set", "Ott", "Nov", "Di\u010B"],
      wide: ["Jannar", "Frar", "Marzu", "April", "Mejju", "\u0120unju", "Lulju", "Awwissu", "Settembru", "Ottubru", "Novembru", "Di\u010Bembru"]
    };
    dayValues55 = {
      narrow: ["\u0126", "T", "T", "E", "\u0126", "\u0120", "S"],
      short: ["\u0126a", "Tn", "Tl", "Er", "\u0126a", "\u0120i", "Si"],
      abbreviated: ["\u0126ad", "Tne", "Tli", "Erb", "\u0126am", "\u0120im", "Sib"],
      wide: ["Il-\u0126add", "It-Tnejn", "It-Tlieta", "L-Erbg\u0127a", "Il-\u0126amis", "Il-\u0120img\u0127a", "Is-Sibt"]
    };
    dayPeriodValues55 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
      }
    };
    formattingDayPeriodValues45 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
      }
    };
    ordinalNumber109 = function ordinalNumber110(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\xBA";
    };
    localize55 = {
      ordinalNumber: ordinalNumber109,
      era: buildLocalizeFn({
        values: eraValues55,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues55,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback55(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues55,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues55,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues55,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues45,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default55 = localize55;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/_lib/match/index.js
var matchOrdinalNumberPattern54, parseOrdinalNumberPattern54, matchEraPatterns54, parseEraPatterns54, matchQuarterPatterns54, parseQuarterPatterns54, matchMonthPatterns54, parseMonthPatterns54, matchDayPatterns54, parseDayPatterns54, matchDayPeriodPatterns54, parseDayPeriodPatterns54, match54, match_default54;
var init_match54 = __esm({
  "../../node_modules/date-fns/esm/locale/mt/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern54 = /^(\d+)(º)?/i;
    parseOrdinalNumberPattern54 = /\d+/i;
    matchEraPatterns54 = {
      narrow: /^(q|w)/i,
      abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
      wide: /^(qabel kristu|before common era|wara kristu|common era)/i
    };
    parseEraPatterns54 = {
      any: [/^(q|b)/i, /^(w|c)/i]
    };
    matchQuarterPatterns54 = {
      narrow: /^[1234]/i,
      abbreviated: /^k[1234]/i,
      wide: /^[1234](\.)? kwart/i
    };
    parseQuarterPatterns54 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns54 = {
      narrow: /^[jfmaglsond]/i,
      abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
      wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
    };
    parseMonthPatterns54 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns54 = {
      narrow: /^[ħteġs]/i,
      short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
      abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
      wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
    };
    parseDayPatterns54 = {
      narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
      any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
    };
    matchDayPeriodPatterns54 = {
      narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
      any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
    };
    parseDayPeriodPatterns54 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
      }
    };
    match54 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern54,
        parsePattern: parseOrdinalNumberPattern54,
        valueCallback: function valueCallback106(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns54,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns54,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns54,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns54,
        defaultParseWidth: "any",
        valueCallback: function valueCallback107(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns54,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns54,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns54,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns54,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns54,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns54,
        defaultParseWidth: "any"
      })
    };
    match_default54 = match54;
  }
});

// ../../node_modules/date-fns/esm/locale/mt/index.js
var locale65, mt_default;
var init_mt = __esm({
  "../../node_modules/date-fns/esm/locale/mt/index.js"() {
    "use strict";
    init_formatDistance56();
    init_formatLong63();
    init_formatRelative56();
    init_localize55();
    init_match54();
    locale65 = {
      code: "mt",
      formatDistance: formatDistance_default55,
      formatLong: formatLong_default63,
      formatRelative: formatRelative_default55,
      localize: localize_default55,
      match: match_default54,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    mt_default = locale65;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/_lib/formatDistance/index.js
var formatDistanceLocale55, formatDistance112, formatDistance_default56;
var init_formatDistance57 = __esm({
  "../../node_modules/date-fns/esm/locale/nb/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale55 = {
      lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
      },
      xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
      },
      halfAMinute: "et halvt minutt",
      lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
      },
      xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
      },
      aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
      },
      xHours: {
        one: "en time",
        other: "{{count}} timer"
      },
      xDays: {
        one: "en dag",
        other: "{{count}} dager"
      },
      aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
      },
      xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
      },
      aboutXMonths: {
        one: "omtrent en m\xE5ned",
        other: "omtrent {{count}} m\xE5neder"
      },
      xMonths: {
        one: "en m\xE5ned",
        other: "{{count}} m\xE5neder"
      },
      aboutXYears: {
        one: "omtrent ett \xE5r",
        other: "omtrent {{count}} \xE5r"
      },
      xYears: {
        one: "ett \xE5r",
        other: "{{count}} \xE5r"
      },
      overXYears: {
        one: "over ett \xE5r",
        other: "over {{count}} \xE5r"
      },
      almostXYears: {
        one: "nesten ett \xE5r",
        other: "nesten {{count}} \xE5r"
      }
    };
    formatDistance112 = function formatDistance113(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale55[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "om " + result;
        } else {
          return result + " siden";
        }
      }
      return result;
    };
    formatDistance_default56 = formatDistance112;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/_lib/formatLong/index.js
var dateFormats64, timeFormats64, dateTimeFormats64, formatLong64, formatLong_default64;
var init_formatLong64 = __esm({
  "../../node_modules/date-fns/esm/locale/nb/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats64 = {
      full: "EEEE d. MMMM y",
      long: "d. MMMM y",
      medium: "d. MMM y",
      short: "dd.MM.y"
    };
    timeFormats64 = {
      full: "'kl'. HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats64 = {
      full: "{{date}} 'kl.' {{time}}",
      long: "{{date}} 'kl.' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong64 = {
      date: buildFormatLongFn({
        formats: dateFormats64,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats64,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats64,
        defaultWidth: "full"
      })
    };
    formatLong_default64 = formatLong64;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/_lib/formatRelative/index.js
var formatRelativeLocale56, formatRelative112, formatRelative_default56;
var init_formatRelative57 = __esm({
  "../../node_modules/date-fns/esm/locale/nb/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale56 = {
      lastWeek: "'forrige' eeee 'kl.' p",
      yesterday: "'i g\xE5r kl.' p",
      today: "'i dag kl.' p",
      tomorrow: "'i morgen kl.' p",
      nextWeek: "EEEE 'kl.' p",
      other: "P"
    };
    formatRelative112 = function formatRelative113(token, _date, _baseDate, _options) {
      return formatRelativeLocale56[token];
    };
    formatRelative_default56 = formatRelative112;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/_lib/localize/index.js
var eraValues56, quarterValues56, monthValues56, dayValues56, dayPeriodValues56, ordinalNumber111, localize56, localize_default56;
var init_localize56 = __esm({
  "../../node_modules/date-fns/esm/locale/nb/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues56 = {
      narrow: ["f.Kr.", "e.Kr."],
      abbreviated: ["f.Kr.", "e.Kr."],
      wide: ["f\xF8r Kristus", "etter Kristus"]
    };
    quarterValues56 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues56 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
      wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
    };
    dayValues56 = {
      narrow: ["S", "M", "T", "O", "T", "F", "L"],
      short: ["s\xF8", "ma", "ti", "on", "to", "fr", "l\xF8"],
      abbreviated: ["s\xF8n", "man", "tir", "ons", "tor", "fre", "l\xF8r"],
      wide: ["s\xF8ndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "l\xF8rdag"]
    };
    dayPeriodValues56 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 etterm.",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natten"
      },
      abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 etterm.",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natten"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morgenen",
        afternoon: "p\xE5 ettermiddagen",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natten"
      }
    };
    ordinalNumber111 = function ordinalNumber112(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize56 = {
      ordinalNumber: ordinalNumber111,
      era: buildLocalizeFn({
        values: eraValues56,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues56,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback56(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues56,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues56,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues56,
        defaultWidth: "wide"
      })
    };
    localize_default56 = localize56;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/_lib/match/index.js
var matchOrdinalNumberPattern55, parseOrdinalNumberPattern55, matchEraPatterns55, parseEraPatterns55, matchQuarterPatterns55, parseQuarterPatterns55, matchMonthPatterns55, parseMonthPatterns55, matchDayPatterns55, parseDayPatterns55, matchDayPeriodPatterns55, parseDayPeriodPatterns55, match55, match_default55;
var init_match55 = __esm({
  "../../node_modules/date-fns/esm/locale/nb/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern55 = /^(\d+)\.?/i;
    parseOrdinalNumberPattern55 = /\d+/i;
    matchEraPatterns55 = {
      narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
      abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
      wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
    };
    parseEraPatterns55 = {
      any: [/^f/i, /^e/i]
    };
    matchQuarterPatterns55 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](\.)? kvartal/i
    };
    parseQuarterPatterns55 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns55 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
      wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
    };
    parseMonthPatterns55 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns55 = {
      narrow: /^[smtofl]/i,
      short: /^(sø|ma|ti|on|to|fr|lø)/i,
      abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
      wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
    };
    parseDayPatterns55 = {
      any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
    };
    matchDayPeriodPatterns55 = {
      narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
      any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
    };
    parseDayPeriodPatterns55 = {
      any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
      }
    };
    match55 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern55,
        parsePattern: parseOrdinalNumberPattern55,
        valueCallback: function valueCallback108(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns55,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns55,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns55,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns55,
        defaultParseWidth: "any",
        valueCallback: function valueCallback109(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns55,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns55,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns55,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns55,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns55,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns55,
        defaultParseWidth: "any"
      })
    };
    match_default55 = match55;
  }
});

// ../../node_modules/date-fns/esm/locale/nb/index.js
var locale66, nb_default;
var init_nb = __esm({
  "../../node_modules/date-fns/esm/locale/nb/index.js"() {
    "use strict";
    init_formatDistance57();
    init_formatLong64();
    init_formatRelative57();
    init_localize56();
    init_match55();
    locale66 = {
      code: "nb",
      formatDistance: formatDistance_default56,
      formatLong: formatLong_default64,
      formatRelative: formatRelative_default56,
      localize: localize_default56,
      match: match_default55,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    nb_default = locale66;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/_lib/formatDistance/index.js
var formatDistanceLocale56, formatDistance114, formatDistance_default57;
var init_formatDistance58 = __esm({
  "../../node_modules/date-fns/esm/locale/nl/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale56 = {
      lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
      },
      xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
      },
      halfAMinute: "een halve minuut",
      lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
      },
      xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
      },
      aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
      },
      xHours: {
        one: "1 uur",
        other: "{{count}} uur"
      },
      xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
      },
      aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
      },
      aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
      },
      xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
      },
      aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
      },
      xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
      },
      overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
      },
      almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
      }
    };
    formatDistance114 = function formatDistance115(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale56[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "over " + result;
        } else {
          return result + " geleden";
        }
      }
      return result;
    };
    formatDistance_default57 = formatDistance114;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/_lib/formatLong/index.js
var dateFormats65, timeFormats65, dateTimeFormats65, formatLong65, formatLong_default65;
var init_formatLong65 = __esm({
  "../../node_modules/date-fns/esm/locale/nl/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats65 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd-MM-y"
    };
    timeFormats65 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats65 = {
      full: "{{date}} 'om' {{time}}",
      long: "{{date}} 'om' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong65 = {
      date: buildFormatLongFn({
        formats: dateFormats65,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats65,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats65,
        defaultWidth: "full"
      })
    };
    formatLong_default65 = formatLong65;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/_lib/formatRelative/index.js
var formatRelativeLocale57, formatRelative114, formatRelative_default57;
var init_formatRelative58 = __esm({
  "../../node_modules/date-fns/esm/locale/nl/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale57 = {
      lastWeek: "'afgelopen' eeee 'om' p",
      yesterday: "'gisteren om' p",
      today: "'vandaag om' p",
      tomorrow: "'morgen om' p",
      nextWeek: "eeee 'om' p",
      other: "P"
    };
    formatRelative114 = function formatRelative115(token, _date, _baseDate, _options) {
      return formatRelativeLocale57[token];
    };
    formatRelative_default57 = formatRelative114;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/_lib/localize/index.js
var eraValues57, quarterValues57, monthValues57, dayValues57, dayPeriodValues57, ordinalNumber113, localize57, localize_default57;
var init_localize57 = __esm({
  "../../node_modules/date-fns/esm/locale/nl/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues57 = {
      narrow: ["v.C.", "n.C."],
      abbreviated: ["v.Chr.", "n.Chr."],
      wide: ["voor Christus", "na Christus"]
    };
    quarterValues57 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
    };
    monthValues57 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
      wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
    };
    dayValues57 = {
      narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
      short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
      abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
      wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
    };
    dayPeriodValues57 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
      }
    };
    ordinalNumber113 = function ordinalNumber114(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "e";
    };
    localize57 = {
      ordinalNumber: ordinalNumber113,
      era: buildLocalizeFn({
        values: eraValues57,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues57,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback57(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues57,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues57,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues57,
        defaultWidth: "wide"
      })
    };
    localize_default57 = localize57;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/_lib/match/index.js
var matchOrdinalNumberPattern56, parseOrdinalNumberPattern56, matchEraPatterns56, parseEraPatterns56, matchQuarterPatterns56, parseQuarterPatterns56, matchMonthPatterns56, parseMonthPatterns56, matchDayPatterns56, parseDayPatterns56, matchDayPeriodPatterns56, parseDayPeriodPatterns56, match56, match_default56;
var init_match56 = __esm({
  "../../node_modules/date-fns/esm/locale/nl/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern56 = /^(\d+)e?/i;
    parseOrdinalNumberPattern56 = /\d+/i;
    matchEraPatterns56 = {
      narrow: /^([vn]\.? ?C\.?)/,
      abbreviated: /^([vn]\. ?Chr\.?)/,
      wide: /^((voor|na) Christus)/
    };
    parseEraPatterns56 = {
      any: [/^v/, /^n/]
    };
    matchQuarterPatterns56 = {
      narrow: /^[1234]/i,
      abbreviated: /^K[1234]/i,
      wide: /^[1234]e kwartaal/i
    };
    parseQuarterPatterns56 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns56 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
      wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
    };
    parseMonthPatterns56 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
    };
    matchDayPatterns56 = {
      narrow: /^[zmdwv]/i,
      short: /^(zo|ma|di|wo|do|vr|za)/i,
      abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
      wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
    };
    parseDayPatterns56 = {
      narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
      any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
    };
    matchDayPeriodPatterns56 = {
      any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
    };
    parseDayPeriodPatterns56 = {
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
      }
    };
    match56 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern56,
        parsePattern: parseOrdinalNumberPattern56,
        valueCallback: function valueCallback110(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns56,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns56,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns56,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns56,
        defaultParseWidth: "any",
        valueCallback: function valueCallback111(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns56,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns56,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns56,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns56,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns56,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns56,
        defaultParseWidth: "any"
      })
    };
    match_default56 = match56;
  }
});

// ../../node_modules/date-fns/esm/locale/nl/index.js
var locale67, nl_default;
var init_nl = __esm({
  "../../node_modules/date-fns/esm/locale/nl/index.js"() {
    "use strict";
    init_formatDistance58();
    init_formatLong65();
    init_formatRelative58();
    init_localize57();
    init_match56();
    locale67 = {
      code: "nl",
      formatDistance: formatDistance_default57,
      formatLong: formatLong_default65,
      formatRelative: formatRelative_default57,
      localize: localize_default57,
      match: match_default56,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    nl_default = locale67;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatDistance/index.js
var formatDistanceLocale57, formatDistance116, formatDistance_default58;
var init_formatDistance59 = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale57 = {
      lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
      },
      xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
      },
      halfAMinute: "een halve minuut",
      lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
      },
      xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
      },
      aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
      },
      xHours: {
        one: "1 uur",
        other: "{{count}} uur"
      },
      xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
      },
      aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
      },
      aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
      },
      xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
      },
      aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
      },
      xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
      },
      overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
      },
      almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
      }
    };
    formatDistance116 = function formatDistance117(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale57[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "over " + result;
        } else {
          return result + " geleden";
        }
      }
      return result;
    };
    formatDistance_default58 = formatDistance116;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatLong/index.js
var dateFormats66, timeFormats66, dateTimeFormats66, formatLong66, formatLong_default66;
var init_formatLong66 = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats66 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd.MM.y"
    };
    timeFormats66 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats66 = {
      full: "{{date}} 'om' {{time}}",
      long: "{{date}} 'om' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong66 = {
      date: buildFormatLongFn({
        formats: dateFormats66,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats66,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats66,
        defaultWidth: "full"
      })
    };
    formatLong_default66 = formatLong66;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatRelative/index.js
var formatRelativeLocale58, formatRelative116, formatRelative_default58;
var init_formatRelative59 = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale58 = {
      lastWeek: "'vorige' eeee 'om' p",
      yesterday: "'gisteren om' p",
      today: "'vandaag om' p",
      tomorrow: "'morgen om' p",
      nextWeek: "eeee 'om' p",
      other: "P"
    };
    formatRelative116 = function formatRelative117(token, _date, _baseDate, _options) {
      return formatRelativeLocale58[token];
    };
    formatRelative_default58 = formatRelative116;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/_lib/localize/index.js
var eraValues58, quarterValues58, monthValues58, dayValues58, dayPeriodValues58, ordinalNumber115, localize58, localize_default58;
var init_localize58 = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues58 = {
      narrow: ["v.C.", "n.C."],
      abbreviated: ["v.Chr.", "n.Chr."],
      wide: ["voor Christus", "na Christus"]
    };
    quarterValues58 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["K1", "K2", "K3", "K4"],
      wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
    };
    monthValues58 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mrt.", "apr.", "mei", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
      wide: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
    };
    dayValues58 = {
      narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
      short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
      abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
      wide: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
    };
    dayPeriodValues58 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
      }
    };
    ordinalNumber115 = function ordinalNumber116(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "e";
    };
    localize58 = {
      ordinalNumber: ordinalNumber115,
      era: buildLocalizeFn({
        values: eraValues58,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues58,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback58(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues58,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues58,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues58,
        defaultWidth: "wide"
      })
    };
    localize_default58 = localize58;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/_lib/match/index.js
var matchOrdinalNumberPattern57, parseOrdinalNumberPattern57, matchEraPatterns57, parseEraPatterns57, matchQuarterPatterns57, parseQuarterPatterns57, matchMonthPatterns57, parseMonthPatterns57, matchDayPatterns57, parseDayPatterns57, matchDayPeriodPatterns57, parseDayPeriodPatterns57, match57, match_default57;
var init_match57 = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern57 = /^(\d+)e?/i;
    parseOrdinalNumberPattern57 = /\d+/i;
    matchEraPatterns57 = {
      narrow: /^([vn]\.? ?C\.?)/,
      abbreviated: /^([vn]\. ?Chr\.?)/,
      wide: /^((voor|na) Christus)/
    };
    parseEraPatterns57 = {
      any: [/^v/, /^n/]
    };
    matchQuarterPatterns57 = {
      narrow: /^[1234]/i,
      abbreviated: /^K[1234]/i,
      wide: /^[1234]e kwartaal/i
    };
    parseQuarterPatterns57 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns57 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
      wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
    };
    parseMonthPatterns57 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
    };
    matchDayPatterns57 = {
      narrow: /^[zmdwv]/i,
      short: /^(zo|ma|di|wo|do|vr|za)/i,
      abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
      wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
    };
    parseDayPatterns57 = {
      narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
      any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
    };
    matchDayPeriodPatterns57 = {
      any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
    };
    parseDayPeriodPatterns57 = {
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
      }
    };
    match57 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern57,
        parsePattern: parseOrdinalNumberPattern57,
        valueCallback: function valueCallback112(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns57,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns57,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns57,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns57,
        defaultParseWidth: "any",
        valueCallback: function valueCallback113(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns57,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns57,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns57,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns57,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns57,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns57,
        defaultParseWidth: "any"
      })
    };
    match_default57 = match57;
  }
});

// ../../node_modules/date-fns/esm/locale/nl-BE/index.js
var locale68, nl_BE_default;
var init_nl_BE = __esm({
  "../../node_modules/date-fns/esm/locale/nl-BE/index.js"() {
    "use strict";
    init_formatDistance59();
    init_formatLong66();
    init_formatRelative59();
    init_localize58();
    init_match57();
    locale68 = {
      code: "nl-BE",
      formatDistance: formatDistance_default58,
      formatLong: formatLong_default66,
      formatRelative: formatRelative_default58,
      localize: localize_default58,
      match: match_default57,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    nl_BE_default = locale68;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/_lib/formatDistance/index.js
var formatDistanceLocale58, wordMapping, formatDistance118, formatDistance_default59;
var init_formatDistance60 = __esm({
  "../../node_modules/date-fns/esm/locale/nn/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale58 = {
      lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
      },
      xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
      },
      halfAMinute: "eit halvt minutt",
      lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
      },
      xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
      },
      aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
      },
      xHours: {
        one: "ein time",
        other: "{{count}} timar"
      },
      xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
      },
      aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
      },
      xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
      },
      aboutXMonths: {
        one: "omtrent ein m\xE5nad",
        other: "omtrent {{count}} m\xE5nader"
      },
      xMonths: {
        one: "ein m\xE5nad",
        other: "{{count}} m\xE5nader"
      },
      aboutXYears: {
        one: "omtrent eitt \xE5r",
        other: "omtrent {{count}} \xE5r"
      },
      xYears: {
        one: "eitt \xE5r",
        other: "{{count}} \xE5r"
      },
      overXYears: {
        one: "over eitt \xE5r",
        other: "over {{count}} \xE5r"
      },
      almostXYears: {
        one: "nesten eitt \xE5r",
        other: "nesten {{count}} \xE5r"
      }
    };
    wordMapping = ["null", "ein", "to", "tre", "fire", "fem", "seks", "sju", "\xE5tte", "ni", "ti", "elleve", "tolv"];
    formatDistance118 = function formatDistance119(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale58[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        if (options && options.onlyNumeric) {
          result = tokenValue.other.replace("{{count}}", String(count));
        } else {
          result = tokenValue.other.replace("{{count}}", count < 13 ? wordMapping[count] : String(count));
        }
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "om " + result;
        } else {
          return result + " sidan";
        }
      }
      return result;
    };
    formatDistance_default59 = formatDistance118;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/_lib/formatLong/index.js
var dateFormats67, timeFormats67, dateTimeFormats67, formatLong67, formatLong_default67;
var init_formatLong67 = __esm({
  "../../node_modules/date-fns/esm/locale/nn/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats67 = {
      full: "EEEE d. MMMM y",
      long: "d. MMMM y",
      medium: "d. MMM y",
      short: "dd.MM.y"
    };
    timeFormats67 = {
      full: "'kl'. HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats67 = {
      full: "{{date}} 'kl.' {{time}}",
      long: "{{date}} 'kl.' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong67 = {
      date: buildFormatLongFn({
        formats: dateFormats67,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats67,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats67,
        defaultWidth: "full"
      })
    };
    formatLong_default67 = formatLong67;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/_lib/formatRelative/index.js
var formatRelativeLocale59, formatRelative118, formatRelative_default59;
var init_formatRelative60 = __esm({
  "../../node_modules/date-fns/esm/locale/nn/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale59 = {
      lastWeek: "'f\xF8rre' eeee 'kl.' p",
      yesterday: "'i g\xE5r kl.' p",
      today: "'i dag kl.' p",
      tomorrow: "'i morgon kl.' p",
      nextWeek: "EEEE 'kl.' p",
      other: "P"
    };
    formatRelative118 = function formatRelative119(token, _date, _baseDate, _options) {
      return formatRelativeLocale59[token];
    };
    formatRelative_default59 = formatRelative118;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/_lib/localize/index.js
var eraValues59, quarterValues59, monthValues59, dayValues59, dayPeriodValues59, ordinalNumber117, localize59, localize_default59;
var init_localize59 = __esm({
  "../../node_modules/date-fns/esm/locale/nn/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues59 = {
      narrow: ["f.Kr.", "e.Kr."],
      abbreviated: ["f.Kr.", "e.Kr."],
      wide: ["f\xF8r Kristus", "etter Kristus"]
    };
    quarterValues59 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues59 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mars", "apr.", "mai", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "des."],
      wide: ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"]
    };
    dayValues59 = {
      narrow: ["S", "M", "T", "O", "T", "F", "L"],
      short: ["su", "m\xE5", "ty", "on", "to", "fr", "lau"],
      abbreviated: ["sun", "m\xE5n", "tys", "ons", "tor", "fre", "laur"],
      wide: ["sundag", "m\xE5ndag", "tysdag", "onsdag", "torsdag", "fredag", "laurdag"]
    };
    dayPeriodValues59 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 etterm.",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natta"
      },
      abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 etterm.",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natta"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morgonen",
        afternoon: "p\xE5 ettermiddagen",
        evening: "p\xE5 kvelden",
        night: "p\xE5 natta"
      }
    };
    ordinalNumber117 = function ordinalNumber118(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize59 = {
      ordinalNumber: ordinalNumber117,
      era: buildLocalizeFn({
        values: eraValues59,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues59,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback59(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues59,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues59,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues59,
        defaultWidth: "wide"
      })
    };
    localize_default59 = localize59;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/_lib/match/index.js
var matchOrdinalNumberPattern58, parseOrdinalNumberPattern58, matchEraPatterns58, parseEraPatterns58, matchQuarterPatterns58, parseQuarterPatterns58, matchMonthPatterns58, parseMonthPatterns58, matchDayPatterns58, parseDayPatterns58, matchDayPeriodPatterns58, parseDayPeriodPatterns58, match58, match_default58;
var init_match58 = __esm({
  "../../node_modules/date-fns/esm/locale/nn/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern58 = /^(\d+)\.?/i;
    parseOrdinalNumberPattern58 = /\d+/i;
    matchEraPatterns58 = {
      narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
      abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
      wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
    };
    parseEraPatterns58 = {
      any: [/^f/i, /^e/i]
    };
    matchQuarterPatterns58 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](\.)? kvartal/i
    };
    parseQuarterPatterns58 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns58 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
      wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
    };
    parseMonthPatterns58 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns58 = {
      narrow: /^[smtofl]/i,
      short: /^(su|må|ty|on|to|fr|la)/i,
      abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
      wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
    };
    parseDayPatterns58 = {
      any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
    };
    matchDayPeriodPatterns58 = {
      narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
      any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
    };
    parseDayPeriodPatterns58 = {
      any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
      }
    };
    match58 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern58,
        parsePattern: parseOrdinalNumberPattern58,
        valueCallback: function valueCallback114(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns58,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns58,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns58,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns58,
        defaultParseWidth: "any",
        valueCallback: function valueCallback115(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns58,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns58,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns58,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns58,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns58,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns58,
        defaultParseWidth: "any"
      })
    };
    match_default58 = match58;
  }
});

// ../../node_modules/date-fns/esm/locale/nn/index.js
var locale69, nn_default;
var init_nn = __esm({
  "../../node_modules/date-fns/esm/locale/nn/index.js"() {
    "use strict";
    init_formatDistance60();
    init_formatLong67();
    init_formatRelative60();
    init_localize59();
    init_match58();
    locale69 = {
      code: "nn",
      formatDistance: formatDistance_default59,
      formatLong: formatLong_default67,
      formatRelative: formatRelative_default59,
      localize: localize_default59,
      match: match_default58,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    nn_default = locale69;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/_lib/formatDistance/index.js
var formatDistanceLocale59, formatDistance120, formatDistance_default60;
var init_formatDistance61 = __esm({
  "../../node_modules/date-fns/esm/locale/oc/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale59 = {
      lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: "mens de {{count}} segondas"
      },
      xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
      },
      halfAMinute: "30 segondas",
      lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: "mens de {{count}} minutas"
      },
      xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
      },
      aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
      },
      xHours: {
        one: "1 ora",
        other: "{{count}} oras"
      },
      xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
      },
      aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
      },
      xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
      },
      aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
      },
      xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
      },
      aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
      },
      xYears: {
        one: "1 an",
        other: "{{count}} ans"
      },
      overXYears: {
        one: "mai d\u2019un an",
        other: "mai de {{count}} ans"
      },
      almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
      }
    };
    formatDistance120 = function formatDistance121(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale59[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "d\u2019aqu\xED " + result;
        } else {
          return "fa " + result;
        }
      }
      return result;
    };
    formatDistance_default60 = formatDistance120;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/_lib/formatLong/index.js
var dateFormats68, timeFormats68, dateTimeFormats68, formatLong68, formatLong_default68;
var init_formatLong68 = __esm({
  "../../node_modules/date-fns/esm/locale/oc/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats68 = {
      full: "EEEE d 'de' MMMM y",
      long: "d 'de' MMMM y",
      medium: "d MMM y",
      short: "dd/MM/y"
    };
    timeFormats68 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats68 = {
      full: "{{date}} 'a' {{time}}",
      long: "{{date}} 'a' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong68 = {
      date: buildFormatLongFn({
        formats: dateFormats68,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats68,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats68,
        defaultWidth: "full"
      })
    };
    formatLong_default68 = formatLong68;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/_lib/formatRelative/index.js
var formatRelativeLocale60, formatRelative120, formatRelative_default60;
var init_formatRelative61 = __esm({
  "../../node_modules/date-fns/esm/locale/oc/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale60 = {
      lastWeek: "eeee 'passat a' p",
      yesterday: "'i\xE8r a' p",
      today: "'u\xE8i a' p",
      tomorrow: "'deman a' p",
      nextWeek: "eeee 'a' p",
      other: "P"
    };
    formatRelative120 = function formatRelative121(token, _date, _baseDate, _options) {
      return formatRelativeLocale60[token];
    };
    formatRelative_default60 = formatRelative120;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/_lib/localize/index.js
var eraValues60, quarterValues60, monthValues60, dayValues60, dayPeriodValues60, formattingDayPeriodValues46, ordinalNumber119, localize60, localize_default60;
var init_localize60 = __esm({
  "../../node_modules/date-fns/esm/locale/oc/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues60 = {
      narrow: ["ab. J.C.", "apr. J.C."],
      abbreviated: ["ab. J.C.", "apr. J.C."],
      wide: ["abans J\xE8sus-Crist", "apr\xE8s J\xE8sus-Crist"]
    };
    quarterValues60 = {
      narrow: ["T1", "T2", "T3", "T4"],
      abbreviated: ["1\xE8r trim.", "2nd trim.", "3en trim.", "4en trim."],
      wide: ["1\xE8r trim\xE8stre", "2nd trim\xE8stre", "3en trim\xE8stre", "4en trim\xE8stre"]
    };
    monthValues60 = {
      narrow: ["GN", "FB", "M\xC7", "AB", "MA", "JN", "JL", "AG", "ST", "OC", "NV", "DC"],
      abbreviated: ["gen.", "febr.", "mar\xE7", "abr.", "mai", "junh", "jul.", "ag.", "set.", "oct.", "nov.", "dec."],
      wide: ["geni\xE8r", "febri\xE8r", "mar\xE7", "abril", "mai", "junh", "julhet", "agost", "setembre", "oct\xF2bre", "novembre", "decembre"]
    };
    dayValues60 = {
      narrow: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
      short: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
      abbreviated: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
      wide: ["dimenge", "diluns", "dimars", "dim\xE8cres", "dij\xF2us", "divendres", "dissabte"]
    };
    dayPeriodValues60 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "matin",
        afternoon: "apr\xE8p-mi\xE8gjorn",
        evening: "v\xE8spre",
        night: "nu\xE8ch"
      },
      abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "matin",
        afternoon: "apr\xE8p-mi\xE8gjorn",
        evening: "v\xE8spre",
        night: "nu\xE8ch"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "matin",
        afternoon: "apr\xE8p-mi\xE8gjorn",
        evening: "v\xE8spre",
        night: "nu\xE8ch"
      }
    };
    formattingDayPeriodValues46 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xE8p-mi\xE8gjorn",
        evening: "del ser",
        night: "de la nu\xE8ch"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xE8p-mi\xE8gjorn",
        evening: "del ser",
        night: "de la nu\xE8ch"
      },
      wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xE8janu\xE8ch",
        noon: "mi\xE8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xE8p-mi\xE8gjorn",
        evening: "del ser",
        night: "de la nu\xE8ch"
      }
    };
    ordinalNumber119 = function ordinalNumber120(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      var ordinal;
      switch (number) {
        case 1:
          ordinal = "\xE8r";
          break;
        case 2:
          ordinal = "nd";
          break;
        default:
          ordinal = "en";
      }
      if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") {
        ordinal += "a";
      }
      return number + ordinal;
    };
    localize60 = {
      ordinalNumber: ordinalNumber119,
      era: buildLocalizeFn({
        values: eraValues60,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues60,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback60(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues60,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues60,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues60,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues46,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default60 = localize60;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/_lib/match/index.js
var matchOrdinalNumberPattern59, parseOrdinalNumberPattern59, matchEraPatterns59, parseEraPatterns59, matchQuarterPatterns59, parseQuarterPatterns59, matchMonthPatterns59, parseMonthPatterns59, matchDayPatterns59, parseDayPatterns59, matchDayPeriodPatterns59, parseDayPeriodPatterns59, match59, match_default59;
var init_match59 = __esm({
  "../../node_modules/date-fns/esm/locale/oc/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern59 = /^(\d+)(èr|nd|en)?[a]?/i;
    parseOrdinalNumberPattern59 = /\d+/i;
    matchEraPatterns59 = {
      narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
      abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
      wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
    };
    parseEraPatterns59 = {
      any: [/^ab/i, /^ap/i]
    };
    matchQuarterPatterns59 = {
      narrow: /^T[1234]/i,
      abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
      wide: /^[1234](èr|nd|en)? trimèstre/i
    };
    parseQuarterPatterns59 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns59 = {
      narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
      abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
      wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
    };
    parseMonthPatterns59 = {
      any: [/^g/i, /^f/i, /^ma[r?]|MÇ/i, /^ab/i, /^ma[i?]/i, /^ju[n?]|JN/i, /^ju[l?]|JL/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns59 = {
      narrow: /^d[glmcjvs]\.?/i,
      short: /^d[glmcjvs]\.?/i,
      abbreviated: /^d[glmcjvs]\.?/i,
      wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
    };
    parseDayPatterns59 = {
      narrow: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
      short: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
      abbreviated: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
      any: [/^dg|dime/i, /^dl|dil/i, /^dm|dima/i, /^dc|dimè/i, /^dj|dij/i, /^dv|div/i, /^ds|dis/i]
    };
    matchDayPeriodPatterns59 = {
      any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
    };
    parseDayPeriodPatterns59 = {
      any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
      }
    };
    match59 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern59,
        parsePattern: parseOrdinalNumberPattern59,
        valueCallback: function valueCallback116(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns59,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns59,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns59,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns59,
        defaultParseWidth: "any",
        valueCallback: function valueCallback117(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns59,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns59,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns59,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns59,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns59,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns59,
        defaultParseWidth: "any"
      })
    };
    match_default59 = match59;
  }
});

// ../../node_modules/date-fns/esm/locale/oc/index.js
var locale70, oc_default;
var init_oc = __esm({
  "../../node_modules/date-fns/esm/locale/oc/index.js"() {
    "use strict";
    init_formatDistance61();
    init_formatLong68();
    init_formatRelative61();
    init_localize60();
    init_match59();
    locale70 = {
      code: "oc",
      formatDistance: formatDistance_default60,
      formatLong: formatLong_default68,
      formatRelative: formatRelative_default60,
      localize: localize_default60,
      match: match_default59,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    oc_default = locale70;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/_lib/formatDistance/index.js
function declensionGroup(scheme, count) {
  if (count === 1) {
    return scheme.one;
  }
  var rem100 = count % 100;
  if (rem100 <= 20 && rem100 > 10) {
    return scheme.other;
  }
  var rem10 = rem100 % 10;
  if (rem10 >= 2 && rem10 <= 4) {
    return scheme.twoFour;
  }
  return scheme.other;
}
function declension4(scheme, count, time) {
  var group = declensionGroup(scheme, count);
  var finalText = typeof group === "string" ? group : group[time];
  return finalText.replace("{{count}}", String(count));
}
var formatDistanceLocale60, formatDistance122, formatDistance_default61;
var init_formatDistance62 = __esm({
  "../../node_modules/date-fns/esm/locale/pl/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale60 = {
      lessThanXSeconds: {
        one: {
          regular: "mniej ni\u017C sekunda",
          past: "mniej ni\u017C sekund\u0119",
          future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
      },
      xSeconds: {
        one: {
          regular: "sekunda",
          past: "sekund\u0119",
          future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
      },
      halfAMinute: {
        one: "p\xF3\u0142 minuty",
        twoFour: "p\xF3\u0142 minuty",
        other: "p\xF3\u0142 minuty"
      },
      lessThanXMinutes: {
        one: {
          regular: "mniej ni\u017C minuta",
          past: "mniej ni\u017C minut\u0119",
          future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
      },
      xMinutes: {
        one: {
          regular: "minuta",
          past: "minut\u0119",
          future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
      },
      aboutXHours: {
        one: {
          regular: "oko\u0142o godziny",
          past: "oko\u0142o godziny",
          future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
      },
      xHours: {
        one: {
          regular: "godzina",
          past: "godzin\u0119",
          future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
      },
      xDays: {
        one: {
          regular: "dzie\u0144",
          past: "dzie\u0144",
          future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
      },
      aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
      },
      xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
      },
      aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
      },
      xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
      },
      aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
      },
      xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
      },
      overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
      },
      almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
      }
    };
    formatDistance122 = function formatDistance123(token, count, options) {
      var scheme = formatDistanceLocale60[token];
      if (!(options !== null && options !== void 0 && options.addSuffix)) {
        return declension4(scheme, count, "regular");
      }
      if (options.comparison && options.comparison > 0) {
        return "za " + declension4(scheme, count, "future");
      } else {
        return declension4(scheme, count, "past") + " temu";
      }
    };
    formatDistance_default61 = formatDistance122;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/_lib/formatLong/index.js
var dateFormats69, timeFormats69, dateTimeFormats69, formatLong69, formatLong_default69;
var init_formatLong69 = __esm({
  "../../node_modules/date-fns/esm/locale/pl/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats69 = {
      full: "EEEE, do MMMM y",
      long: "do MMMM y",
      medium: "do MMM y",
      short: "dd.MM.y"
    };
    timeFormats69 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats69 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong69 = {
      date: buildFormatLongFn({
        formats: dateFormats69,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats69,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats69,
        defaultWidth: "full"
      })
    };
    formatLong_default69 = formatLong69;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/_lib/formatRelative/index.js
function dayAndTimeWithAdjective(token, date, baseDate, options) {
  var adjectives;
  if (isSameUTCWeek(date, baseDate, options)) {
    adjectives = adjectivesThisWeek;
  } else if (token === "lastWeek") {
    adjectives = adjectivesLastWeek;
  } else if (token === "nextWeek") {
    adjectives = adjectivesNextWeek;
  } else {
    throw new Error("Cannot determine adjectives for token ".concat(token));
  }
  var day = date.getUTCDay();
  var grammaticalGender = dayGrammaticalGender[day];
  var adjective = adjectives[grammaticalGender];
  return "'".concat(adjective, "' eeee 'o' p");
}
var adjectivesLastWeek, adjectivesThisWeek, adjectivesNextWeek, dayGrammaticalGender, formatRelativeLocale61, formatRelative122, formatRelative_default61;
var init_formatRelative62 = __esm({
  "../../node_modules/date-fns/esm/locale/pl/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    adjectivesLastWeek = {
      masculine: "ostatni",
      feminine: "ostatnia"
    };
    adjectivesThisWeek = {
      masculine: "ten",
      feminine: "ta"
    };
    adjectivesNextWeek = {
      masculine: "nast\u0119pny",
      feminine: "nast\u0119pna"
    };
    dayGrammaticalGender = {
      0: "feminine",
      1: "masculine",
      2: "masculine",
      3: "feminine",
      4: "masculine",
      5: "masculine",
      6: "feminine"
    };
    formatRelativeLocale61 = {
      lastWeek: dayAndTimeWithAdjective,
      yesterday: "'wczoraj o' p",
      today: "'dzisiaj o' p",
      tomorrow: "'jutro o' p",
      nextWeek: dayAndTimeWithAdjective,
      other: "P"
    };
    formatRelative122 = function formatRelative123(token, date, baseDate, options) {
      var format2 = formatRelativeLocale61[token];
      if (typeof format2 === "function") {
        return format2(token, date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default61 = formatRelative122;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/_lib/localize/index.js
var eraValues61, quarterValues61, monthValues61, monthFormattingValues, dayValues61, dayFormattingValues, dayPeriodValues61, dayPeriodFormattingValues, ordinalNumber121, localize61, localize_default61;
var init_localize61 = __esm({
  "../../node_modules/date-fns/esm/locale/pl/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues61 = {
      narrow: ["p.n.e.", "n.e."],
      abbreviated: ["p.n.e.", "n.e."],
      wide: ["przed nasz\u0105 er\u0105", "naszej ery"]
    };
    quarterValues61 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
      wide: ["I kwarta\u0142", "II kwarta\u0142", "III kwarta\u0142", "IV kwarta\u0142"]
    };
    monthValues61 = {
      narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
      abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "pa\u017A", "lis", "gru"],
      wide: ["stycze\u0144", "luty", "marzec", "kwiecie\u0144", "maj", "czerwiec", "lipiec", "sierpie\u0144", "wrzesie\u0144", "pa\u017Adziernik", "listopad", "grudzie\u0144"]
    };
    monthFormattingValues = {
      narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
      abbreviated: ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "pa\u017A", "lis", "gru"],
      wide: ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca", "lipca", "sierpnia", "wrze\u015Bnia", "pa\u017Adziernika", "listopada", "grudnia"]
    };
    dayValues61 = {
      narrow: ["N", "P", "W", "\u015A", "C", "P", "S"],
      short: ["nie", "pon", "wto", "\u015Bro", "czw", "pi\u0105", "sob"],
      abbreviated: ["niedz.", "pon.", "wt.", "\u015Br.", "czw.", "pt.", "sob."],
      wide: ["niedziela", "poniedzia\u0142ek", "wtorek", "\u015Broda", "czwartek", "pi\u0105tek", "sobota"]
    };
    dayFormattingValues = {
      narrow: ["n", "p", "w", "\u015B", "c", "p", "s"],
      short: ["nie", "pon", "wto", "\u015Bro", "czw", "pi\u0105", "sob"],
      abbreviated: ["niedz.", "pon.", "wt.", "\u015Br.", "czw.", "pt.", "sob."],
      wide: ["niedziela", "poniedzia\u0142ek", "wtorek", "\u015Broda", "czwartek", "pi\u0105tek", "sobota"]
    };
    dayPeriodValues61 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xF3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xF3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xF3r",
        night: "noc"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xF3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xF3r",
        night: "noc"
      }
    };
    dayPeriodFormattingValues = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xF3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xF3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xF3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
      }
    };
    ordinalNumber121 = function ordinalNumber122(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize61 = {
      ordinalNumber: ordinalNumber121,
      era: buildLocalizeFn({
        values: eraValues61,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues61,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback61(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues61,
        defaultWidth: "wide",
        formattingValues: monthFormattingValues,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues61,
        defaultWidth: "wide",
        formattingValues: dayFormattingValues,
        defaultFormattingWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues61,
        defaultWidth: "wide",
        formattingValues: dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default61 = localize61;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/_lib/match/index.js
var matchOrdinalNumberPattern60, parseOrdinalNumberPattern60, matchEraPatterns60, parseEraPatterns60, matchQuarterPatterns60, parseQuarterPatterns60, matchMonthPatterns60, parseMonthPatterns60, matchDayPatterns60, parseDayPatterns60, matchDayPeriodPatterns60, parseDayPeriodPatterns60, match60, match_default60;
var init_match60 = __esm({
  "../../node_modules/date-fns/esm/locale/pl/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern60 = /^(\d+)?/i;
    parseOrdinalNumberPattern60 = /\d+/i;
    matchEraPatterns60 = {
      narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
      abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
      wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
    };
    parseEraPatterns60 = {
      any: [/^p/i, /^n/i]
    };
    matchQuarterPatterns60 = {
      narrow: /^[1234]/i,
      abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
      wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
    };
    parseQuarterPatterns60 = {
      narrow: [/1/i, /2/i, /3/i, /4/i],
      any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
    };
    matchMonthPatterns60 = {
      narrow: /^[slmkcwpg]/i,
      abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
      wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
    };
    parseMonthPatterns60 = {
      narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
      any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
    };
    matchDayPatterns60 = {
      narrow: /^[npwścs]/i,
      short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
      abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
      wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
    };
    parseDayPatterns60 = {
      narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
      abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
      any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
    };
    matchDayPeriodPatterns60 = {
      narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
      any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
    };
    parseDayPeriodPatterns60 = {
      narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
      },
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
      }
    };
    match60 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern60,
        parsePattern: parseOrdinalNumberPattern60,
        valueCallback: function valueCallback118(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns60,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns60,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns60,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns60,
        defaultParseWidth: "any",
        valueCallback: function valueCallback119(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns60,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns60,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns60,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns60,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns60,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns60,
        defaultParseWidth: "any"
      })
    };
    match_default60 = match60;
  }
});

// ../../node_modules/date-fns/esm/locale/pl/index.js
var locale71, pl_default;
var init_pl = __esm({
  "../../node_modules/date-fns/esm/locale/pl/index.js"() {
    "use strict";
    init_formatDistance62();
    init_formatLong69();
    init_formatRelative62();
    init_localize61();
    init_match60();
    locale71 = {
      code: "pl",
      formatDistance: formatDistance_default61,
      formatLong: formatLong_default69,
      formatRelative: formatRelative_default61,
      localize: localize_default61,
      match: match_default60,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    pl_default = locale71;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatDistance/index.js
var formatDistanceLocale61, formatDistance124, formatDistance_default62;
var init_formatDistance63 = __esm({
  "../../node_modules/date-fns/esm/locale/pt/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale61 = {
      lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
      },
      xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
      },
      halfAMinute: "meio minuto",
      lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
      },
      xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
      },
      aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
      },
      xHours: {
        one: "1 hora",
        other: "{{count}} horas"
      },
      xDays: {
        one: "1 dia",
        other: "{{count}} dias"
      },
      aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
      },
      xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
      },
      aboutXMonths: {
        one: "aproximadamente 1 m\xEAs",
        other: "aproximadamente {{count}} meses"
      },
      xMonths: {
        one: "1 m\xEAs",
        other: "{{count}} meses"
      },
      aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
      },
      xYears: {
        one: "1 ano",
        other: "{{count}} anos"
      },
      overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
      },
      almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
      }
    };
    formatDistance124 = function formatDistance125(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale61[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "daqui a " + result;
        } else {
          return "h\xE1 " + result;
        }
      }
      return result;
    };
    formatDistance_default62 = formatDistance124;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatLong/index.js
var dateFormats70, timeFormats70, dateTimeFormats70, formatLong70, formatLong_default70;
var init_formatLong70 = __esm({
  "../../node_modules/date-fns/esm/locale/pt/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats70 = {
      full: "EEEE, d 'de' MMMM 'de' y",
      long: "d 'de' MMMM 'de' y",
      medium: "d 'de' MMM 'de' y",
      short: "dd/MM/y"
    };
    timeFormats70 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats70 = {
      full: "{{date}} '\xE0s' {{time}}",
      long: "{{date}} '\xE0s' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong70 = {
      date: buildFormatLongFn({
        formats: dateFormats70,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats70,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats70,
        defaultWidth: "full"
      })
    };
    formatLong_default70 = formatLong70;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/_lib/formatRelative/index.js
var formatRelativeLocale62, formatRelative124, formatRelative_default62;
var init_formatRelative63 = __esm({
  "../../node_modules/date-fns/esm/locale/pt/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale62 = {
      lastWeek: function lastWeek12(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
        return "'" + last + "' eeee '\xE0s' p";
      },
      yesterday: "'ontem \xE0s' p",
      today: "'hoje \xE0s' p",
      tomorrow: "'amanh\xE3 \xE0s' p",
      nextWeek: "eeee '\xE0s' p",
      other: "P"
    };
    formatRelative124 = function formatRelative125(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale62[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default62 = formatRelative124;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/_lib/localize/index.js
var eraValues62, quarterValues62, monthValues62, dayValues62, dayPeriodValues62, formattingDayPeriodValues47, ordinalNumber123, localize62, localize_default62;
var init_localize62 = __esm({
  "../../node_modules/date-fns/esm/locale/pt/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues62 = {
      narrow: ["aC", "dC"],
      abbreviated: ["a.C.", "d.C."],
      wide: ["antes de Cristo", "depois de Cristo"]
    };
    quarterValues62 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
    };
    monthValues62 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
      wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
    };
    dayValues62 = {
      narrow: ["d", "s", "t", "q", "q", "s", "s"],
      short: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
      abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"],
      wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
    };
    dayPeriodValues62 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
      }
    };
    formattingDayPeriodValues47 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
      }
    };
    ordinalNumber123 = function ordinalNumber124(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\xBA";
    };
    localize62 = {
      ordinalNumber: ordinalNumber123,
      era: buildLocalizeFn({
        values: eraValues62,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues62,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback62(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues62,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues62,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues62,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues47,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default62 = localize62;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/_lib/match/index.js
var matchOrdinalNumberPattern61, parseOrdinalNumberPattern61, matchEraPatterns61, parseEraPatterns61, matchQuarterPatterns61, parseQuarterPatterns61, matchMonthPatterns61, parseMonthPatterns61, matchDayPatterns61, parseDayPatterns61, matchDayPeriodPatterns61, parseDayPeriodPatterns61, match61, match_default61;
var init_match61 = __esm({
  "../../node_modules/date-fns/esm/locale/pt/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern61 = /^(\d+)(º|ª)?/i;
    parseOrdinalNumberPattern61 = /\d+/i;
    matchEraPatterns61 = {
      narrow: /^(ac|dc|a|d)/i,
      abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
      wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
    };
    parseEraPatterns61 = {
      any: [/^ac/i, /^dc/i],
      wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
    };
    matchQuarterPatterns61 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^[1234](º|ª)? trimestre/i
    };
    parseQuarterPatterns61 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns61 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
      wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
    };
    parseMonthPatterns61 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns61 = {
      narrow: /^[dstq]/i,
      short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
      abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
      wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
    };
    parseDayPatterns61 = {
      narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
      any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
    };
    matchDayPeriodPatterns61 = {
      narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
      any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
    };
    parseDayPeriodPatterns61 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
      }
    };
    match61 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern61,
        parsePattern: parseOrdinalNumberPattern61,
        valueCallback: function valueCallback120(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns61,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns61,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns61,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns61,
        defaultParseWidth: "any",
        valueCallback: function valueCallback121(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns61,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns61,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns61,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns61,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns61,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns61,
        defaultParseWidth: "any"
      })
    };
    match_default61 = match61;
  }
});

// ../../node_modules/date-fns/esm/locale/pt/index.js
var locale72, pt_default;
var init_pt = __esm({
  "../../node_modules/date-fns/esm/locale/pt/index.js"() {
    "use strict";
    init_formatDistance63();
    init_formatLong70();
    init_formatRelative63();
    init_localize62();
    init_match61();
    locale72 = {
      code: "pt",
      formatDistance: formatDistance_default62,
      formatLong: formatLong_default70,
      formatRelative: formatRelative_default62,
      localize: localize_default62,
      match: match_default61,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    pt_default = locale72;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatDistance/index.js
var formatDistanceLocale62, formatDistance126, formatDistance_default63;
var init_formatDistance64 = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale62 = {
      lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
      },
      xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
      },
      halfAMinute: "meio minuto",
      lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
      },
      xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
      },
      aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
      },
      xHours: {
        one: "1 hora",
        other: "{{count}} horas"
      },
      xDays: {
        one: "1 dia",
        other: "{{count}} dias"
      },
      aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
      },
      xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
      },
      aboutXMonths: {
        one: "cerca de 1 m\xEAs",
        other: "cerca de {{count}} meses"
      },
      xMonths: {
        one: "1 m\xEAs",
        other: "{{count}} meses"
      },
      aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
      },
      xYears: {
        one: "1 ano",
        other: "{{count}} anos"
      },
      overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
      },
      almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
      }
    };
    formatDistance126 = function formatDistance127(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale62[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "em " + result;
        } else {
          return "h\xE1 " + result;
        }
      }
      return result;
    };
    formatDistance_default63 = formatDistance126;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatLong/index.js
var dateFormats71, timeFormats71, dateTimeFormats71, formatLong71, formatLong_default71;
var init_formatLong71 = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats71 = {
      full: "EEEE, d 'de' MMMM 'de' y",
      long: "d 'de' MMMM 'de' y",
      medium: "d MMM y",
      short: "dd/MM/yyyy"
    };
    timeFormats71 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats71 = {
      full: "{{date}} '\xE0s' {{time}}",
      long: "{{date}} '\xE0s' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong71 = {
      date: buildFormatLongFn({
        formats: dateFormats71,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats71,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats71,
        defaultWidth: "full"
      })
    };
    formatLong_default71 = formatLong71;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatRelative/index.js
var formatRelativeLocale63, formatRelative126, formatRelative_default63;
var init_formatRelative64 = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale63 = {
      lastWeek: function lastWeek13(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xFAltimo" : "\xFAltima";
        return "'" + last + "' eeee '\xE0s' p";
      },
      yesterday: "'ontem \xE0s' p",
      today: "'hoje \xE0s' p",
      tomorrow: "'amanh\xE3 \xE0s' p",
      nextWeek: "eeee '\xE0s' p",
      other: "P"
    };
    formatRelative126 = function formatRelative127(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale63[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default63 = formatRelative126;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/_lib/localize/index.js
var eraValues63, quarterValues63, monthValues63, dayValues63, dayPeriodValues63, formattingDayPeriodValues48, ordinalNumber125, localize63, localize_default63;
var init_localize63 = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues63 = {
      narrow: ["AC", "DC"],
      abbreviated: ["AC", "DC"],
      wide: ["antes de cristo", "depois de cristo"]
    };
    quarterValues63 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["1\xBA trimestre", "2\xBA trimestre", "3\xBA trimestre", "4\xBA trimestre"]
    };
    monthValues63 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
      wide: ["janeiro", "fevereiro", "mar\xE7o", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"]
    };
    dayValues63 = {
      narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
      short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
      abbreviated: ["domingo", "segunda", "ter\xE7a", "quarta", "quinta", "sexta", "s\xE1bado"],
      wide: ["domingo", "segunda-feira", "ter\xE7a-feira", "quarta-feira", "quinta-feira", "sexta-feira", "s\xE1bado"]
    };
    dayPeriodValues63 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xE3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
      }
    };
    formattingDayPeriodValues48 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xE3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
      }
    };
    ordinalNumber125 = function ordinalNumber126(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      if ((options === null || options === void 0 ? void 0 : options.unit) === "week") {
        return number + "\xAA";
      }
      return number + "\xBA";
    };
    localize63 = {
      ordinalNumber: ordinalNumber125,
      era: buildLocalizeFn({
        values: eraValues63,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues63,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback63(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues63,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues63,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues63,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues48,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default63 = localize63;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/_lib/match/index.js
var matchOrdinalNumberPattern62, parseOrdinalNumberPattern62, matchEraPatterns62, parseEraPatterns62, matchQuarterPatterns62, parseQuarterPatterns62, matchMonthPatterns62, parseMonthPatterns62, matchDayPatterns62, parseDayPatterns62, matchDayPeriodPatterns62, parseDayPeriodPatterns62, match62, match_default62;
var init_match62 = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern62 = /^(\d+)[ºªo]?/i;
    parseOrdinalNumberPattern62 = /\d+/i;
    matchEraPatterns62 = {
      narrow: /^(ac|dc|a|d)/i,
      abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
      wide: /^(antes de cristo|depois de cristo)/i
    };
    parseEraPatterns62 = {
      any: [/^ac/i, /^dc/i],
      wide: [/^antes de cristo/i, /^depois de cristo/i]
    };
    matchQuarterPatterns62 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^[1234](º)? trimestre/i
    };
    parseQuarterPatterns62 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns62 = {
      narrow: /^[jfmajsond]/i,
      abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
      wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
    };
    parseMonthPatterns62 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
    };
    matchDayPatterns62 = {
      narrow: /^(dom|[23456]ª?|s[aá]b)/i,
      short: /^(dom|[23456]ª?|s[aá]b)/i,
      abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
      wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
    };
    parseDayPatterns62 = {
      short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
      narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
      any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
    };
    matchDayPeriodPatterns62 = {
      narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
      any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
    };
    parseDayPeriodPatterns62 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
      }
    };
    match62 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern62,
        parsePattern: parseOrdinalNumberPattern62,
        valueCallback: function valueCallback122(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns62,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns62,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns62,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns62,
        defaultParseWidth: "any",
        valueCallback: function valueCallback123(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns62,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns62,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns62,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns62,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns62,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns62,
        defaultParseWidth: "any"
      })
    };
    match_default62 = match62;
  }
});

// ../../node_modules/date-fns/esm/locale/pt-BR/index.js
var locale73, pt_BR_default;
var init_pt_BR = __esm({
  "../../node_modules/date-fns/esm/locale/pt-BR/index.js"() {
    "use strict";
    init_formatDistance64();
    init_formatLong71();
    init_formatRelative64();
    init_localize63();
    init_match62();
    locale73 = {
      code: "pt-BR",
      formatDistance: formatDistance_default63,
      formatLong: formatLong_default71,
      formatRelative: formatRelative_default63,
      localize: localize_default63,
      match: match_default62,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    pt_BR_default = locale73;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatDistance/index.js
var formatDistanceLocale63, formatDistance128, formatDistance_default64;
var init_formatDistance65 = __esm({
  "../../node_modules/date-fns/esm/locale/ro/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale63 = {
      lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
      },
      xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
      },
      halfAMinute: "jum\u0103tate de minut",
      lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
      },
      xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
      },
      aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
      },
      xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
      },
      xDays: {
        one: "1 zi",
        other: "{{count}} zile"
      },
      aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xE2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xE2ni"
      },
      xWeeks: {
        one: "1 s\u0103pt\u0103m\xE2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xE2ni"
      },
      aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
      },
      xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
      },
      aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
      },
      xYears: {
        one: "1 an",
        other: "{{count}} ani"
      },
      overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
      },
      almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
      }
    };
    formatDistance128 = function formatDistance129(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale63[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\xEEn " + result;
        } else {
          return result + " \xEEn urm\u0103";
        }
      }
      return result;
    };
    formatDistance_default64 = formatDistance128;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatLong/index.js
var dateFormats72, timeFormats72, dateTimeFormats72, formatLong72, formatLong_default72;
var init_formatLong72 = __esm({
  "../../node_modules/date-fns/esm/locale/ro/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats72 = {
      full: "EEEE, d MMMM yyyy",
      long: "d MMMM yyyy",
      medium: "d MMM yyyy",
      short: "dd.MM.yyyy"
    };
    timeFormats72 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats72 = {
      full: "{{date}} 'la' {{time}}",
      long: "{{date}} 'la' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong72 = {
      date: buildFormatLongFn({
        formats: dateFormats72,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats72,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats72,
        defaultWidth: "full"
      })
    };
    formatLong_default72 = formatLong72;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/_lib/formatRelative/index.js
var formatRelativeLocale64, formatRelative128, formatRelative_default64;
var init_formatRelative65 = __esm({
  "../../node_modules/date-fns/esm/locale/ro/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale64 = {
      lastWeek: "eeee 'trecut\u0103 la' p",
      yesterday: "'ieri la' p",
      today: "'ast\u0103zi la' p",
      tomorrow: "'m\xE2ine la' p",
      nextWeek: "eeee 'viitoare la' p",
      other: "P"
    };
    formatRelative128 = function formatRelative129(token, _date, _baseDate, _options) {
      return formatRelativeLocale64[token];
    };
    formatRelative_default64 = formatRelative128;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/_lib/localize/index.js
var eraValues64, quarterValues64, monthValues64, dayValues64, dayPeriodValues64, formattingDayPeriodValues49, ordinalNumber127, localize64, localize_default64;
var init_localize64 = __esm({
  "../../node_modules/date-fns/esm/locale/ro/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues64 = {
      narrow: ["\xCE", "D"],
      abbreviated: ["\xCE.d.C.", "D.C."],
      wide: ["\xCEnainte de Cristos", "Dup\u0103 Cristos"]
    };
    quarterValues64 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["T1", "T2", "T3", "T4"],
      wide: ["primul trimestru", "al doilea trimestru", "al treilea trimestru", "al patrulea trimestru"]
    };
    monthValues64 = {
      narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
      abbreviated: ["ian", "feb", "mar", "apr", "mai", "iun", "iul", "aug", "sep", "oct", "noi", "dec"],
      wide: ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie", "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"]
    };
    dayValues64 = {
      narrow: ["d", "l", "m", "m", "j", "v", "s"],
      short: ["du", "lu", "ma", "mi", "jo", "vi", "s\xE2"],
      abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "s\xE2m"],
      wide: ["duminic\u0103", "luni", "mar\u021Bi", "miercuri", "joi", "vineri", "s\xE2mb\u0103t\u0103"]
    };
    dayPeriodValues64 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
      }
    };
    formattingDayPeriodValues49 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
      }
    };
    ordinalNumber127 = function ordinalNumber128(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize64 = {
      ordinalNumber: ordinalNumber127,
      era: buildLocalizeFn({
        values: eraValues64,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues64,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback64(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues64,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues64,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues64,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues49,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default64 = localize64;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/_lib/match/index.js
var matchOrdinalNumberPattern63, parseOrdinalNumberPattern63, matchEraPatterns63, parseEraPatterns63, matchQuarterPatterns63, parseQuarterPatterns63, matchMonthPatterns63, parseMonthPatterns63, matchDayPatterns63, parseDayPatterns63, matchDayPeriodPatterns63, parseDayPeriodPatterns63, match63, match_default63;
var init_match63 = __esm({
  "../../node_modules/date-fns/esm/locale/ro/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern63 = /^(\d+)?/i;
    parseOrdinalNumberPattern63 = /\d+/i;
    matchEraPatterns63 = {
      narrow: /^(Î|D)/i,
      abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
      wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
    };
    parseEraPatterns63 = {
      any: [/^ÎC/i, /^DC/i],
      wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
    };
    matchQuarterPatterns63 = {
      narrow: /^[1234]/i,
      abbreviated: /^T[1234]/i,
      wide: /^trimestrul [1234]/i
    };
    parseQuarterPatterns63 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns63 = {
      narrow: /^[ifmaasond]/i,
      abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
      wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
    };
    parseMonthPatterns63 = {
      narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns63 = {
      narrow: /^[dlmjvs]/i,
      short: /^(d|l|ma|mi|j|v|s)/i,
      abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
      wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
    };
    parseDayPatterns63 = {
      narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
      any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
    };
    matchDayPeriodPatterns63 = {
      narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
      any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
    };
    parseDayPeriodPatterns63 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
      }
    };
    match63 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern63,
        parsePattern: parseOrdinalNumberPattern63,
        valueCallback: function valueCallback124(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns63,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns63,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns63,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns63,
        defaultParseWidth: "any",
        valueCallback: function valueCallback125(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns63,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns63,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns63,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns63,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns63,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns63,
        defaultParseWidth: "any"
      })
    };
    match_default63 = match63;
  }
});

// ../../node_modules/date-fns/esm/locale/ro/index.js
var locale74, ro_default;
var init_ro = __esm({
  "../../node_modules/date-fns/esm/locale/ro/index.js"() {
    "use strict";
    init_formatDistance65();
    init_formatLong72();
    init_formatRelative65();
    init_localize64();
    init_match63();
    locale74 = {
      code: "ro",
      formatDistance: formatDistance_default64,
      formatLong: formatLong_default72,
      formatRelative: formatRelative_default64,
      localize: localize_default64,
      match: match_default63,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ro_default = locale74;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/_lib/formatDistance/index.js
function declension5(scheme, count) {
  if (scheme.one !== void 0 && count === 1) {
    return scheme.one;
  }
  var rem10 = count % 10;
  var rem100 = count % 100;
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}
function buildLocalizeTokenFn4(scheme) {
  return function(count, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension5(scheme.future, count);
        } else {
          return "\u0447\u0435\u0440\u0435\u0437 " + declension5(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension5(scheme.past, count);
        } else {
          return declension5(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
        }
      }
    } else {
      return declension5(scheme.regular, count);
    }
  };
}
var formatDistanceLocale64, formatDistance130, formatDistance_default65;
var init_formatDistance66 = __esm({
  "../../node_modules/date-fns/esm/locale/ru/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale64 = {
      lessThanXSeconds: buildLocalizeTokenFn4({
        regular: {
          one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
          pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
          one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      xSeconds: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
          singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
          pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      halfAMinute: function halfAMinute7(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
          } else {
            return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
          }
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
      },
      lessThanXMinutes: buildLocalizeTokenFn4({
        regular: {
          one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
          singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
          singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
          pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
          one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
          singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
          singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
          pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
      }),
      xMinutes: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
          singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
          singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
          pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
          singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
          singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
          pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
      }),
      aboutXHours: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
          singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
          pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
      }),
      xHours: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u0447\u0430\u0441",
          singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
          pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
      }),
      xDays: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
          singularGenitive: "{{count}} \u0434\u043D\u044F",
          pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
      }),
      aboutXWeeks: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
          singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
          pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
      }),
      xWeeks: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
          singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
          pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
      }),
      aboutXMonths: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
          pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
      }),
      xMonths: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
          singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
          pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
      }),
      aboutXYears: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
          singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
          pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
      }),
      xYears: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "{{count}} \u0433\u043E\u0434",
          singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
          pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
      }),
      overXYears: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
          singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
          pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
      }),
      almostXYears: buildLocalizeTokenFn4({
        regular: {
          singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
          pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
          singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
          singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
          pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
      })
    };
    formatDistance130 = function formatDistance131(token, count, options) {
      return formatDistanceLocale64[token](count, options);
    };
    formatDistance_default65 = formatDistance130;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/_lib/formatLong/index.js
var dateFormats73, timeFormats73, dateTimeFormats73, formatLong73, formatLong_default73;
var init_formatLong73 = __esm({
  "../../node_modules/date-fns/esm/locale/ru/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats73 = {
      full: "EEEE, d MMMM y '\u0433.'",
      long: "d MMMM y '\u0433.'",
      medium: "d MMM y '\u0433.'",
      short: "dd.MM.y"
    };
    timeFormats73 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats73 = {
      any: "{{date}}, {{time}}"
    };
    formatLong73 = {
      date: buildFormatLongFn({
        formats: dateFormats73,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats73,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats73,
        defaultWidth: "any"
      })
    };
    formatLong_default73 = formatLong73;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/_lib/formatRelative/index.js
function _lastWeek4(day) {
  var weekday = accusativeWeekdays6[day];
  switch (day) {
    case 0:
      return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
      return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
    case 3:
    case 5:
    case 6:
      return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
  }
}
function thisWeek7(day) {
  var weekday = accusativeWeekdays6[day];
  if (day === 2) {
    return "'\u0432\u043E " + weekday + " \u0432' p";
  } else {
    return "'\u0432 " + weekday + " \u0432' p";
  }
}
function _nextWeek4(day) {
  var weekday = accusativeWeekdays6[day];
  switch (day) {
    case 0:
      return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
    case 1:
    case 2:
    case 4:
      return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
    case 3:
    case 5:
    case 6:
      return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
  }
}
var accusativeWeekdays6, formatRelativeLocale65, formatRelative130, formatRelative_default65;
var init_formatRelative66 = __esm({
  "../../node_modules/date-fns/esm/locale/ru/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    accusativeWeekdays6 = ["\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0443", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0443", "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"];
    formatRelativeLocale65 = {
      lastWeek: function lastWeek14(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek7(day);
        } else {
          return _lastWeek4(day);
        }
      },
      yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
      today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
      tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
      nextWeek: function nextWeek11(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek7(day);
        } else {
          return _nextWeek4(day);
        }
      },
      other: "P"
    };
    formatRelative130 = function formatRelative131(token, date, baseDate, options) {
      var format2 = formatRelativeLocale65[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default65 = formatRelative130;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/_lib/localize/index.js
var eraValues65, quarterValues65, monthValues65, formattingMonthValues14, dayValues65, dayPeriodValues65, formattingDayPeriodValues50, ordinalNumber129, localize65, localize_default65;
var init_localize65 = __esm({
  "../../node_modules/date-fns/esm/locale/ru/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues65 = {
      narrow: ["\u0434\u043E \u043D.\u044D.", "\u043D.\u044D."],
      abbreviated: ["\u0434\u043E \u043D. \u044D.", "\u043D. \u044D."],
      wide: ["\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B", "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"]
    };
    quarterValues65 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0439 \u043A\u0432.", "2-\u0439 \u043A\u0432.", "3-\u0439 \u043A\u0432.", "4-\u0439 \u043A\u0432."],
      wide: ["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues65 = {
      narrow: ["\u042F", "\u0424", "\u041C", "\u0410", "\u041C", "\u0418", "\u0418", "\u0410", "\u0421", "\u041E", "\u041D", "\u0414"],
      abbreviated: ["\u044F\u043D\u0432.", "\u0444\u0435\u0432.", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440.", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433.", "\u0441\u0435\u043D\u0442.", "\u043E\u043A\u0442.", "\u043D\u043E\u044F\u0431.", "\u0434\u0435\u043A."],
      wide: ["\u044F\u043D\u0432\u0430\u0440\u044C", "\u0444\u0435\u0432\u0440\u0430\u043B\u044C", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B\u044C", "\u043C\u0430\u0439", "\u0438\u044E\u043D\u044C", "\u0438\u044E\u043B\u044C", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C", "\u043E\u043A\u0442\u044F\u0431\u0440\u044C", "\u043D\u043E\u044F\u0431\u0440\u044C", "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"]
    };
    formattingMonthValues14 = {
      narrow: ["\u042F", "\u0424", "\u041C", "\u0410", "\u041C", "\u0418", "\u0418", "\u0410", "\u0421", "\u041E", "\u041D", "\u0414"],
      abbreviated: ["\u044F\u043D\u0432.", "\u0444\u0435\u0432.", "\u043C\u0430\u0440.", "\u0430\u043F\u0440.", "\u043C\u0430\u044F", "\u0438\u044E\u043D.", "\u0438\u044E\u043B.", "\u0430\u0432\u0433.", "\u0441\u0435\u043D\u0442.", "\u043E\u043A\u0442.", "\u043D\u043E\u044F\u0431.", "\u0434\u0435\u043A."],
      wide: ["\u044F\u043D\u0432\u0430\u0440\u044F", "\u0444\u0435\u0432\u0440\u0430\u043B\u044F", "\u043C\u0430\u0440\u0442\u0430", "\u0430\u043F\u0440\u0435\u043B\u044F", "\u043C\u0430\u044F", "\u0438\u044E\u043D\u044F", "\u0438\u044E\u043B\u044F", "\u0430\u0432\u0433\u0443\u0441\u0442\u0430", "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F", "\u043E\u043A\u0442\u044F\u0431\u0440\u044F", "\u043D\u043E\u044F\u0431\u0440\u044F", "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"]
    };
    dayValues65 = {
      narrow: ["\u0412", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u0432\u0441", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
      abbreviated: ["\u0432\u0441\u043A", "\u043F\u043D\u0434", "\u0432\u0442\u0440", "\u0441\u0440\u0434", "\u0447\u0442\u0432", "\u043F\u0442\u043D", "\u0441\u0443\u0431"],
      wide: ["\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435", "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A", "\u0432\u0442\u043E\u0440\u043D\u0438\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0435\u0440\u0433", "\u043F\u044F\u0442\u043D\u0438\u0446\u0430", "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues65 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
      }
    };
    formattingDayPeriodValues50 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
      }
    };
    ordinalNumber129 = function ordinalNumber130(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      var suffix;
      if (unit === "date") {
        suffix = "-\u0435";
      } else if (unit === "week" || unit === "minute" || unit === "second") {
        suffix = "-\u044F";
      } else {
        suffix = "-\u0439";
      }
      return number + suffix;
    };
    localize65 = {
      ordinalNumber: ordinalNumber129,
      era: buildLocalizeFn({
        values: eraValues65,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues65,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback65(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues65,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues14,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues65,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues65,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues50,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default65 = localize65;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/_lib/match/index.js
var matchOrdinalNumberPattern64, parseOrdinalNumberPattern64, matchEraPatterns64, parseEraPatterns64, matchQuarterPatterns64, parseQuarterPatterns64, matchMonthPatterns64, parseMonthPatterns64, matchDayPatterns64, parseDayPatterns64, matchDayPeriodPatterns64, parseDayPeriodPatterns64, match64, match_default64;
var init_match64 = __esm({
  "../../node_modules/date-fns/esm/locale/ru/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern64 = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
    parseOrdinalNumberPattern64 = /\d+/i;
    matchEraPatterns64 = {
      narrow: /^((до )?н\.?\s?э\.?)/i,
      abbreviated: /^((до )?н\.?\s?э\.?)/i,
      wide: /^(до нашей эры|нашей эры|наша эра)/i
    };
    parseEraPatterns64 = {
      any: [/^д/i, /^н/i]
    };
    matchQuarterPatterns64 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
      wide: /^[1234](-?[ыои]?й?)? квартал/i
    };
    parseQuarterPatterns64 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns64 = {
      narrow: /^[яфмаисонд]/i,
      abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
      wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
    };
    parseMonthPatterns64 = {
      narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
      any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
    };
    matchDayPatterns64 = {
      narrow: /^[впсч]/i,
      short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
      abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
      wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
    };
    parseDayPatterns64 = {
      narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
    };
    matchDayPeriodPatterns64 = {
      narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
      abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
      wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
    };
    parseDayPeriodPatterns64 = {
      any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
      }
    };
    match64 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern64,
        parsePattern: parseOrdinalNumberPattern64,
        valueCallback: function valueCallback126(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns64,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns64,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns64,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns64,
        defaultParseWidth: "any",
        valueCallback: function valueCallback127(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns64,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns64,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns64,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns64,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns64,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns64,
        defaultParseWidth: "any"
      })
    };
    match_default64 = match64;
  }
});

// ../../node_modules/date-fns/esm/locale/ru/index.js
var locale75, ru_default;
var init_ru = __esm({
  "../../node_modules/date-fns/esm/locale/ru/index.js"() {
    "use strict";
    init_formatDistance66();
    init_formatLong73();
    init_formatRelative66();
    init_localize65();
    init_match64();
    locale75 = {
      code: "ru",
      formatDistance: formatDistance_default65,
      formatLong: formatLong_default73,
      formatRelative: formatRelative_default65,
      localize: localize_default65,
      match: match_default64,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    ru_default = locale75;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatDistance/index.js
function declensionGroup2(scheme, count) {
  if (count === 1 && scheme.one) {
    return scheme.one;
  }
  if (count >= 2 && count <= 4 && scheme.twoFour) {
    return scheme.twoFour;
  }
  return scheme.other;
}
function declension6(scheme, count, time) {
  var group = declensionGroup2(scheme, count);
  var finalText = group[time];
  return finalText.replace("{{count}}", String(count));
}
function extractPreposition(token) {
  var result = ["lessThan", "about", "over", "almost"].filter(function(preposition) {
    return !!token.match(new RegExp("^" + preposition));
  });
  return result[0];
}
function prefixPreposition(preposition) {
  var translation = "";
  if (preposition === "almost") {
    translation = "takmer";
  }
  if (preposition === "about") {
    translation = "pribli\u017Ene";
  }
  return translation.length > 0 ? translation + " " : "";
}
function suffixPreposition(preposition) {
  var translation = "";
  if (preposition === "lessThan") {
    translation = "menej ne\u017E";
  }
  if (preposition === "over") {
    translation = "viac ne\u017E";
  }
  return translation.length > 0 ? translation + " " : "";
}
function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
var formatDistanceLocale65, formatDistance132, formatDistance_default66;
var init_formatDistance67 = __esm({
  "../../node_modules/date-fns/esm/locale/sk/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale65 = {
      xSeconds: {
        one: {
          present: "sekunda",
          past: "sekundou",
          future: "sekundu"
        },
        twoFour: {
          present: "{{count}} sekundy",
          past: "{{count}} sekundami",
          future: "{{count}} sekundy"
        },
        other: {
          present: "{{count}} sek\xFAnd",
          past: "{{count}} sekundami",
          future: "{{count}} sek\xFAnd"
        }
      },
      halfAMinute: {
        other: {
          present: "pol min\xFAty",
          past: "pol min\xFAtou",
          future: "pol min\xFAty"
        }
      },
      xMinutes: {
        one: {
          present: "min\xFAta",
          past: "min\xFAtou",
          future: "min\xFAtu"
        },
        twoFour: {
          present: "{{count}} min\xFAty",
          past: "{{count}} min\xFAtami",
          future: "{{count}} min\xFAty"
        },
        other: {
          present: "{{count}} min\xFAt",
          past: "{{count}} min\xFAtami",
          future: "{{count}} min\xFAt"
        }
      },
      xHours: {
        one: {
          present: "hodina",
          past: "hodinou",
          future: "hodinu"
        },
        twoFour: {
          present: "{{count}} hodiny",
          past: "{{count}} hodinami",
          future: "{{count}} hodiny"
        },
        other: {
          present: "{{count}} hod\xEDn",
          past: "{{count}} hodinami",
          future: "{{count}} hod\xEDn"
        }
      },
      xDays: {
        one: {
          present: "de\u0148",
          past: "d\u0148om",
          future: "de\u0148"
        },
        twoFour: {
          present: "{{count}} dni",
          past: "{{count}} d\u0148ami",
          future: "{{count}} dni"
        },
        other: {
          present: "{{count}} dn\xED",
          past: "{{count}} d\u0148ami",
          future: "{{count}} dn\xED"
        }
      },
      xWeeks: {
        one: {
          present: "t\xFD\u017Ede\u0148",
          past: "t\xFD\u017Ed\u0148om",
          future: "t\xFD\u017Ede\u0148"
        },
        twoFour: {
          present: "{{count}} t\xFD\u017Edne",
          past: "{{count}} t\xFD\u017Ed\u0148ami",
          future: "{{count}} t\xFD\u017Edne"
        },
        other: {
          present: "{{count}} t\xFD\u017Ed\u0148ov",
          past: "{{count}} t\xFD\u017Ed\u0148ami",
          future: "{{count}} t\xFD\u017Ed\u0148ov"
        }
      },
      xMonths: {
        one: {
          present: "mesiac",
          past: "mesiacom",
          future: "mesiac"
        },
        twoFour: {
          present: "{{count}} mesiace",
          past: "{{count}} mesiacmi",
          future: "{{count}} mesiace"
        },
        other: {
          present: "{{count}} mesiacov",
          past: "{{count}} mesiacmi",
          future: "{{count}} mesiacov"
        }
      },
      xYears: {
        one: {
          present: "rok",
          past: "rokom",
          future: "rok"
        },
        twoFour: {
          present: "{{count}} roky",
          past: "{{count}} rokmi",
          future: "{{count}} roky"
        },
        other: {
          present: "{{count}} rokov",
          past: "{{count}} rokmi",
          future: "{{count}} rokov"
        }
      }
    };
    formatDistance132 = function formatDistance133(token, count, options) {
      var preposition = extractPreposition(token) || "";
      var key = lowercaseFirstLetter(token.substring(preposition.length));
      var scheme = formatDistanceLocale65[key];
      if (!(options !== null && options !== void 0 && options.addSuffix)) {
        return prefixPreposition(preposition) + suffixPreposition(preposition) + declension6(scheme, count, "present");
      }
      if (options.comparison && options.comparison > 0) {
        return prefixPreposition(preposition) + "o " + suffixPreposition(preposition) + declension6(scheme, count, "future");
      } else {
        return prefixPreposition(preposition) + "pred " + suffixPreposition(preposition) + declension6(scheme, count, "past");
      }
    };
    formatDistance_default66 = formatDistance132;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatLong/index.js
var dateFormats74, timeFormats74, dateTimeFormats74, formatLong74, formatLong_default74;
var init_formatLong74 = __esm({
  "../../node_modules/date-fns/esm/locale/sk/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats74 = {
      full: "EEEE d. MMMM y",
      long: "d. MMMM y",
      medium: "d. M. y",
      short: "d. M. y"
    };
    timeFormats74 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats74 = {
      full: "{{date}}, {{time}}",
      long: "{{date}}, {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong74 = {
      date: buildFormatLongFn({
        formats: dateFormats74,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats74,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats74,
        defaultWidth: "full"
      })
    };
    formatLong_default74 = formatLong74;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/_lib/formatRelative/index.js
function _lastWeek5(day) {
  var weekday = accusativeWeekdays7[day];
  switch (day) {
    case 0:
    /* Sun */
    case 3:
    /* Wed */
    case 6:
      return "'minul\xFA " + weekday + " o' p";
    default:
      return "'minul\xFD' eeee 'o' p";
  }
}
function thisWeek8(day) {
  var weekday = accusativeWeekdays7[day];
  if (day === 4) {
    return "'vo' eeee 'o' p";
  } else {
    return "'v " + weekday + " o' p";
  }
}
function _nextWeek5(day) {
  var weekday = accusativeWeekdays7[day];
  switch (day) {
    case 0:
    /* Sun */
    case 4:
    /* Wed */
    case 6:
      return "'bud\xFAcu " + weekday + " o' p";
    default:
      return "'bud\xFAci' eeee 'o' p";
  }
}
var accusativeWeekdays7, formatRelativeLocale66, formatRelative132, formatRelative_default66;
var init_formatRelative67 = __esm({
  "../../node_modules/date-fns/esm/locale/sk/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    accusativeWeekdays7 = ["nede\u013Eu", "pondelok", "utorok", "stredu", "\u0161tvrtok", "piatok", "sobotu"];
    formatRelativeLocale66 = {
      lastWeek: function lastWeek15(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek8(day);
        } else {
          return _lastWeek5(day);
        }
      },
      yesterday: "'v\u010Dera o' p",
      today: "'dnes o' p",
      tomorrow: "'zajtra o' p",
      nextWeek: function nextWeek12(date, baseDate, options) {
        var day = date.getUTCDay();
        if (isSameUTCWeek(date, baseDate, options)) {
          return thisWeek8(day);
        } else {
          return _nextWeek5(day);
        }
      },
      other: "P"
    };
    formatRelative132 = function formatRelative133(token, date, baseDate, options) {
      var format2 = formatRelativeLocale66[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default66 = formatRelative132;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/_lib/localize/index.js
var eraValues66, quarterValues66, monthValues66, formattingMonthValues15, dayValues66, dayPeriodValues66, formattingDayPeriodValues51, ordinalNumber131, localize66, localize_default66;
var init_localize66 = __esm({
  "../../node_modules/date-fns/esm/locale/sk/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues66 = {
      narrow: ["pred Kr.", "po Kr."],
      abbreviated: ["pred Kr.", "po Kr."],
      wide: ["pred Kristom", "po Kristovi"]
    };
    quarterValues66 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1. \u0161tvr\u0165rok", "2. \u0161tvr\u0165rok", "3. \u0161tvr\u0165rok", "4. \u0161tvr\u0165rok"]
    };
    monthValues66 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
      wide: ["janu\xE1r", "febru\xE1r", "marec", "apr\xEDl", "m\xE1j", "j\xFAn", "j\xFAl", "august", "september", "okt\xF3ber", "november", "december"]
    };
    formattingMonthValues15 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan", "feb", "mar", "apr", "m\xE1j", "j\xFAn", "j\xFAl", "aug", "sep", "okt", "nov", "dec"],
      wide: ["janu\xE1ra", "febru\xE1ra", "marca", "apr\xEDla", "m\xE1ja", "j\xFAna", "j\xFAla", "augusta", "septembra", "okt\xF3bra", "novembra", "decembra"]
    };
    dayValues66 = {
      narrow: ["n", "p", "u", "s", "\u0161", "p", "s"],
      short: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
      abbreviated: ["ne", "po", "ut", "st", "\u0161t", "pi", "so"],
      wide: ["nede\u013Ea", "pondelok", "utorok", "streda", "\u0161tvrtok", "piatok", "sobota"]
    };
    dayPeriodValues66 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xE1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "noc"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xE1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "noc"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xE1no",
        afternoon: "popoludnie",
        evening: "ve\u010Der",
        night: "noc"
      }
    };
    formattingDayPeriodValues51 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xE1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "v n."
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xE1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "v noci"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xE1no",
        afternoon: "popoludn\xED",
        evening: "ve\u010Der",
        night: "v noci"
      }
    };
    ordinalNumber131 = function ordinalNumber132(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize66 = {
      ordinalNumber: ordinalNumber131,
      era: buildLocalizeFn({
        values: eraValues66,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues66,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback66(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues66,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues15,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues66,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues66,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues51,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default66 = localize66;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/_lib/match/index.js
var matchOrdinalNumberPattern65, parseOrdinalNumberPattern65, matchEraPatterns65, parseEraPatterns65, matchQuarterPatterns65, parseQuarterPatterns65, matchMonthPatterns65, parseMonthPatterns65, matchDayPatterns65, parseDayPatterns65, matchDayPeriodPatterns65, parseDayPeriodPatterns65, match65, match_default65;
var init_match65 = __esm({
  "../../node_modules/date-fns/esm/locale/sk/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern65 = /^(\d+)\.?/i;
    parseOrdinalNumberPattern65 = /\d+/i;
    matchEraPatterns65 = {
      narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
      abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
      wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
    };
    parseEraPatterns65 = {
      any: [/^pr/i, /^(po|n)/i]
    };
    matchQuarterPatterns65 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234]\. [šs]tvr[ťt]rok/i
    };
    parseQuarterPatterns65 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns65 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
      wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
    };
    parseMonthPatterns65 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns65 = {
      narrow: /^[npusšp]/i,
      short: /^(ne|po|ut|st|št|pi|so)/i,
      abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
      wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
    };
    parseDayPatterns65 = {
      narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
      any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
    };
    matchDayPeriodPatterns65 = {
      narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
      abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
      any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
    };
    parseDayPeriodPatterns65 = {
      any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
      }
    };
    match65 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern65,
        parsePattern: parseOrdinalNumberPattern65,
        valueCallback: function valueCallback128(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns65,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns65,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns65,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns65,
        defaultParseWidth: "any",
        valueCallback: function valueCallback129(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns65,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns65,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns65,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns65,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns65,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns65,
        defaultParseWidth: "any"
      })
    };
    match_default65 = match65;
  }
});

// ../../node_modules/date-fns/esm/locale/sk/index.js
var locale76, sk_default;
var init_sk = __esm({
  "../../node_modules/date-fns/esm/locale/sk/index.js"() {
    "use strict";
    init_formatDistance67();
    init_formatLong74();
    init_formatRelative67();
    init_localize66();
    init_match65();
    locale76 = {
      code: "sk",
      formatDistance: formatDistance_default66,
      formatLong: formatLong_default74,
      formatRelative: formatRelative_default66,
      localize: localize_default66,
      match: match_default65,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    sk_default = locale76;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/_lib/formatDistance/index.js
function isPluralType(val) {
  return val.one !== void 0;
}
function getFormFromCount(count) {
  switch (count % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}
var formatDistanceLocale66, formatDistance134, formatDistance_default67;
var init_formatDistance68 = __esm({
  "../../node_modules/date-fns/esm/locale/sl/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale66 = {
      lessThanXSeconds: {
        present: {
          one: "manj kot {{count}} sekunda",
          two: "manj kot {{count}} sekundi",
          few: "manj kot {{count}} sekunde",
          other: "manj kot {{count}} sekund"
        },
        past: {
          one: "manj kot {{count}} sekundo",
          two: "manj kot {{count}} sekundama",
          few: "manj kot {{count}} sekundami",
          other: "manj kot {{count}} sekundami"
        },
        future: {
          one: "manj kot {{count}} sekundo",
          two: "manj kot {{count}} sekundi",
          few: "manj kot {{count}} sekunde",
          other: "manj kot {{count}} sekund"
        }
      },
      xSeconds: {
        present: {
          one: "{{count}} sekunda",
          two: "{{count}} sekundi",
          few: "{{count}} sekunde",
          other: "{{count}} sekund"
        },
        past: {
          one: "{{count}} sekundo",
          two: "{{count}} sekundama",
          few: "{{count}} sekundami",
          other: "{{count}} sekundami"
        },
        future: {
          one: "{{count}} sekundo",
          two: "{{count}} sekundi",
          few: "{{count}} sekunde",
          other: "{{count}} sekund"
        }
      },
      halfAMinute: "pol minute",
      lessThanXMinutes: {
        present: {
          one: "manj kot {{count}} minuta",
          two: "manj kot {{count}} minuti",
          few: "manj kot {{count}} minute",
          other: "manj kot {{count}} minut"
        },
        past: {
          one: "manj kot {{count}} minuto",
          two: "manj kot {{count}} minutama",
          few: "manj kot {{count}} minutami",
          other: "manj kot {{count}} minutami"
        },
        future: {
          one: "manj kot {{count}} minuto",
          two: "manj kot {{count}} minuti",
          few: "manj kot {{count}} minute",
          other: "manj kot {{count}} minut"
        }
      },
      xMinutes: {
        present: {
          one: "{{count}} minuta",
          two: "{{count}} minuti",
          few: "{{count}} minute",
          other: "{{count}} minut"
        },
        past: {
          one: "{{count}} minuto",
          two: "{{count}} minutama",
          few: "{{count}} minutami",
          other: "{{count}} minutami"
        },
        future: {
          one: "{{count}} minuto",
          two: "{{count}} minuti",
          few: "{{count}} minute",
          other: "{{count}} minut"
        }
      },
      aboutXHours: {
        present: {
          one: "pribli\u017Eno {{count}} ura",
          two: "pribli\u017Eno {{count}} uri",
          few: "pribli\u017Eno {{count}} ure",
          other: "pribli\u017Eno {{count}} ur"
        },
        past: {
          one: "pribli\u017Eno {{count}} uro",
          two: "pribli\u017Eno {{count}} urama",
          few: "pribli\u017Eno {{count}} urami",
          other: "pribli\u017Eno {{count}} urami"
        },
        future: {
          one: "pribli\u017Eno {{count}} uro",
          two: "pribli\u017Eno {{count}} uri",
          few: "pribli\u017Eno {{count}} ure",
          other: "pribli\u017Eno {{count}} ur"
        }
      },
      xHours: {
        present: {
          one: "{{count}} ura",
          two: "{{count}} uri",
          few: "{{count}} ure",
          other: "{{count}} ur"
        },
        past: {
          one: "{{count}} uro",
          two: "{{count}} urama",
          few: "{{count}} urami",
          other: "{{count}} urami"
        },
        future: {
          one: "{{count}} uro",
          two: "{{count}} uri",
          few: "{{count}} ure",
          other: "{{count}} ur"
        }
      },
      xDays: {
        present: {
          one: "{{count}} dan",
          two: "{{count}} dni",
          few: "{{count}} dni",
          other: "{{count}} dni"
        },
        past: {
          one: "{{count}} dnem",
          two: "{{count}} dnevoma",
          few: "{{count}} dnevi",
          other: "{{count}} dnevi"
        },
        future: {
          one: "{{count}} dan",
          two: "{{count}} dni",
          few: "{{count}} dni",
          other: "{{count}} dni"
        }
      },
      // no tenses for weeks?
      aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
      },
      // no tenses for weeks?
      xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
      },
      aboutXMonths: {
        present: {
          one: "pribli\u017Eno {{count}} mesec",
          two: "pribli\u017Eno {{count}} meseca",
          few: "pribli\u017Eno {{count}} mesece",
          other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
          one: "pribli\u017Eno {{count}} mesecem",
          two: "pribli\u017Eno {{count}} mesecema",
          few: "pribli\u017Eno {{count}} meseci",
          other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
          one: "pribli\u017Eno {{count}} mesec",
          two: "pribli\u017Eno {{count}} meseca",
          few: "pribli\u017Eno {{count}} mesece",
          other: "pribli\u017Eno {{count}} mesecev"
        }
      },
      xMonths: {
        present: {
          one: "{{count}} mesec",
          two: "{{count}} meseca",
          few: "{{count}} meseci",
          other: "{{count}} mesecev"
        },
        past: {
          one: "{{count}} mesecem",
          two: "{{count}} mesecema",
          few: "{{count}} meseci",
          other: "{{count}} meseci"
        },
        future: {
          one: "{{count}} mesec",
          two: "{{count}} meseca",
          few: "{{count}} mesece",
          other: "{{count}} mesecev"
        }
      },
      aboutXYears: {
        present: {
          one: "pribli\u017Eno {{count}} leto",
          two: "pribli\u017Eno {{count}} leti",
          few: "pribli\u017Eno {{count}} leta",
          other: "pribli\u017Eno {{count}} let"
        },
        past: {
          one: "pribli\u017Eno {{count}} letom",
          two: "pribli\u017Eno {{count}} letoma",
          few: "pribli\u017Eno {{count}} leti",
          other: "pribli\u017Eno {{count}} leti"
        },
        future: {
          one: "pribli\u017Eno {{count}} leto",
          two: "pribli\u017Eno {{count}} leti",
          few: "pribli\u017Eno {{count}} leta",
          other: "pribli\u017Eno {{count}} let"
        }
      },
      xYears: {
        present: {
          one: "{{count}} leto",
          two: "{{count}} leti",
          few: "{{count}} leta",
          other: "{{count}} let"
        },
        past: {
          one: "{{count}} letom",
          two: "{{count}} letoma",
          few: "{{count}} leti",
          other: "{{count}} leti"
        },
        future: {
          one: "{{count}} leto",
          two: "{{count}} leti",
          few: "{{count}} leta",
          other: "{{count}} let"
        }
      },
      overXYears: {
        present: {
          one: "ve\u010D kot {{count}} leto",
          two: "ve\u010D kot {{count}} leti",
          few: "ve\u010D kot {{count}} leta",
          other: "ve\u010D kot {{count}} let"
        },
        past: {
          one: "ve\u010D kot {{count}} letom",
          two: "ve\u010D kot {{count}} letoma",
          few: "ve\u010D kot {{count}} leti",
          other: "ve\u010D kot {{count}} leti"
        },
        future: {
          one: "ve\u010D kot {{count}} leto",
          two: "ve\u010D kot {{count}} leti",
          few: "ve\u010D kot {{count}} leta",
          other: "ve\u010D kot {{count}} let"
        }
      },
      almostXYears: {
        present: {
          one: "skoraj {{count}} leto",
          two: "skoraj {{count}} leti",
          few: "skoraj {{count}} leta",
          other: "skoraj {{count}} let"
        },
        past: {
          one: "skoraj {{count}} letom",
          two: "skoraj {{count}} letoma",
          few: "skoraj {{count}} leti",
          other: "skoraj {{count}} leti"
        },
        future: {
          one: "skoraj {{count}} leto",
          two: "skoraj {{count}} leti",
          few: "skoraj {{count}} leta",
          other: "skoraj {{count}} let"
        }
      }
    };
    formatDistance134 = function formatDistance135(token, count, options) {
      var result = "";
      var tense = "present";
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          tense = "future";
          result = "\u010Dez ";
        } else {
          tense = "past";
          result = "pred ";
        }
      }
      var tokenValue = formatDistanceLocale66[token];
      if (typeof tokenValue === "string") {
        result += tokenValue;
      } else {
        var form = getFormFromCount(count);
        if (isPluralType(tokenValue)) {
          result += tokenValue[form].replace("{{count}}", String(count));
        } else {
          result += tokenValue[tense][form].replace("{{count}}", String(count));
        }
      }
      return result;
    };
    formatDistance_default67 = formatDistance134;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/_lib/formatLong/index.js
var dateFormats75, timeFormats75, dateTimeFormats75, formatLong75, formatLong_default75;
var init_formatLong75 = __esm({
  "../../node_modules/date-fns/esm/locale/sl/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats75 = {
      full: "EEEE, dd. MMMM y",
      long: "dd. MMMM y",
      medium: "d. MMM y",
      short: "d. MM. yy"
    };
    timeFormats75 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats75 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong75 = {
      date: buildFormatLongFn({
        formats: dateFormats75,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats75,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats75,
        defaultWidth: "full"
      })
    };
    formatLong_default75 = formatLong75;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/_lib/formatRelative/index.js
var formatRelativeLocale67, formatRelative134, formatRelative_default67;
var init_formatRelative68 = __esm({
  "../../node_modules/date-fns/esm/locale/sl/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale67 = {
      lastWeek: function lastWeek16(date) {
        var day = date.getUTCDay();
        switch (day) {
          case 0:
            return "'prej\u0161njo nedeljo ob' p";
          case 3:
            return "'prej\u0161njo sredo ob' p";
          case 6:
            return "'prej\u0161njo soboto ob' p";
          default:
            return "'prej\u0161nji' EEEE 'ob' p";
        }
      },
      yesterday: "'v\u010Deraj ob' p",
      today: "'danes ob' p",
      tomorrow: "'jutri ob' p",
      nextWeek: function nextWeek13(date) {
        var day = date.getUTCDay();
        switch (day) {
          case 0:
            return "'naslednjo nedeljo ob' p";
          case 3:
            return "'naslednjo sredo ob' p";
          case 6:
            return "'naslednjo soboto ob' p";
          default:
            return "'naslednji' EEEE 'ob' p";
        }
      },
      other: "P"
    };
    formatRelative134 = function formatRelative135(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale67[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default67 = formatRelative134;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/_lib/localize/index.js
var eraValues67, quarterValues67, monthValues67, dayValues67, dayPeriodValues67, formattingDayPeriodValues52, ordinalNumber133, localize67, localize_default67;
var init_localize67 = __esm({
  "../../node_modules/date-fns/esm/locale/sl/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues67 = {
      narrow: ["pr. n. \u0161t.", "po n. \u0161t."],
      abbreviated: ["pr. n. \u0161t.", "po n. \u0161t."],
      wide: ["pred na\u0161im \u0161tetjem", "po na\u0161em \u0161tetju"]
    };
    quarterValues67 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1. \u010Det.", "2. \u010Det.", "3. \u010Det.", "4. \u010Det."],
      wide: ["1. \u010Detrtletje", "2. \u010Detrtletje", "3. \u010Detrtletje", "4. \u010Detrtletje"]
    };
    monthValues67 = {
      narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
      abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "avg.", "sep.", "okt.", "nov.", "dec."],
      wide: ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"]
    };
    dayValues67 = {
      narrow: ["n", "p", "t", "s", "\u010D", "p", "s"],
      short: ["ned.", "pon.", "tor.", "sre.", "\u010Det.", "pet.", "sob."],
      abbreviated: ["ned.", "pon.", "tor.", "sre.", "\u010Det.", "pet.", "sob."],
      wide: ["nedelja", "ponedeljek", "torek", "sreda", "\u010Detrtek", "petek", "sobota"]
    };
    dayPeriodValues67 = {
      narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
      },
      abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "no\u010D"
      },
      wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polno\u010D",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "ve\u010Der",
        night: "no\u010D"
      }
    };
    formattingDayPeriodValues52 = {
      narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
      },
      abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zve\u010D.",
        night: "pono\u010Di"
      },
      wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolno\u010Di",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zve\u010Der",
        night: "pono\u010Di"
      }
    };
    ordinalNumber133 = function ordinalNumber134(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize67 = {
      ordinalNumber: ordinalNumber133,
      era: buildLocalizeFn({
        values: eraValues67,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues67,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback67(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues67,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues67,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues67,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues52,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default67 = localize67;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/_lib/match/index.js
var matchOrdinalNumberPattern66, parseOrdinalNumberPattern66, matchEraPatterns66, parseEraPatterns66, matchQuarterPatterns66, parseQuarterPatterns66, matchMonthPatterns66, parseMonthPatterns66, matchDayPatterns66, parseDayPatterns66, matchDayPeriodPatterns66, parseDayPeriodPatterns66, match66, match_default66;
var init_match66 = __esm({
  "../../node_modules/date-fns/esm/locale/sl/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern66 = /^(\d+)\./i;
    parseOrdinalNumberPattern66 = /\d+/i;
    matchEraPatterns66 = {
      abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
      wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
    };
    parseEraPatterns66 = {
      any: [/^pr/i, /^(po|na[sš]em)/i]
    };
    matchQuarterPatterns66 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\.\s?[čc]et\.?/i,
      wide: /^[1234]\. [čc]etrtletje/i
    };
    parseQuarterPatterns66 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns66 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
      wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
    };
    parseMonthPatterns66 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
      wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns66 = {
      narrow: /^[nptsčc]/i,
      short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
      abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
      wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
    };
    parseDayPatterns66 = {
      narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
      any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
    };
    matchDayPeriodPatterns66 = {
      narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
      any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
    };
    parseDayPeriodPatterns66 = {
      narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
      },
      any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
      }
    };
    match66 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern66,
        parsePattern: parseOrdinalNumberPattern66,
        valueCallback: function valueCallback130(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns66,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns66,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns66,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns66,
        defaultParseWidth: "any",
        valueCallback: function valueCallback131(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns66,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns66,
        defaultParseWidth: "wide"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns66,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns66,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns66,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns66,
        defaultParseWidth: "any"
      })
    };
    match_default66 = match66;
  }
});

// ../../node_modules/date-fns/esm/locale/sl/index.js
var locale77, sl_default;
var init_sl = __esm({
  "../../node_modules/date-fns/esm/locale/sl/index.js"() {
    "use strict";
    init_formatDistance68();
    init_formatLong75();
    init_formatRelative68();
    init_localize67();
    init_match66();
    locale77 = {
      code: "sl",
      formatDistance: formatDistance_default67,
      formatLong: formatLong_default75,
      formatRelative: formatRelative_default67,
      localize: localize_default67,
      match: match_default66,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    sl_default = locale77;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/_lib/formatDistance/index.js
var formatDistanceLocale67, formatDistance136, formatDistance_default68;
var init_formatDistance69 = __esm({
  "../../node_modules/date-fns/esm/locale/sq/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale67 = {
      lessThanXSeconds: {
        one: "m\xEB pak se nj\xEB sekond\xEB",
        other: "m\xEB pak se {{count}} sekonda"
      },
      xSeconds: {
        one: "1 sekond\xEB",
        other: "{{count}} sekonda"
      },
      halfAMinute: "gjys\xEBm minuti",
      lessThanXMinutes: {
        one: "m\xEB pak se nj\xEB minute",
        other: "m\xEB pak se {{count}} minuta"
      },
      xMinutes: {
        one: "1 minut\xEB",
        other: "{{count}} minuta"
      },
      aboutXHours: {
        one: "rreth 1 or\xEB",
        other: "rreth {{count}} or\xEB"
      },
      xHours: {
        one: "1 or\xEB",
        other: "{{count}} or\xEB"
      },
      xDays: {
        one: "1 dit\xEB",
        other: "{{count}} dit\xEB"
      },
      aboutXWeeks: {
        one: "rreth 1 jav\xEB",
        other: "rreth {{count}} jav\xEB"
      },
      xWeeks: {
        one: "1 jav\xEB",
        other: "{{count}} jav\xEB"
      },
      aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
      },
      xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
      },
      aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
      },
      xYears: {
        one: "1 vit",
        other: "{{count}} vite"
      },
      overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
      },
      almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
      }
    };
    formatDistance136 = function formatDistance137(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale67[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "n\xEB " + result;
        } else {
          return result + " m\xEB par\xEB";
        }
      }
      return result;
    };
    formatDistance_default68 = formatDistance136;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/_lib/formatLong/index.js
var dateFormats76, timeFormats76, dateTimeFormats76, formatLong76, formatLong_default76;
var init_formatLong76 = __esm({
  "../../node_modules/date-fns/esm/locale/sq/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats76 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats76 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats76 = {
      full: "{{date}} 'n\xEB' {{time}}",
      long: "{{date}} 'n\xEB' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong76 = {
      date: buildFormatLongFn({
        formats: dateFormats76,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats76,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats76,
        defaultWidth: "full"
      })
    };
    formatLong_default76 = formatLong76;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/_lib/formatRelative/index.js
var formatRelativeLocale68, formatRelative136, formatRelative_default68;
var init_formatRelative69 = __esm({
  "../../node_modules/date-fns/esm/locale/sq/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale68 = {
      lastWeek: "'t\xEB' eeee 'e shkuar n\xEB' p",
      yesterday: "'dje n\xEB' p",
      today: "'sot n\xEB' p",
      tomorrow: "'nes\xEBr n\xEB' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    };
    formatRelative136 = function formatRelative137(token, _date, _baseDate, _options) {
      return formatRelativeLocale68[token];
    };
    formatRelative_default68 = formatRelative136;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/_lib/localize/index.js
var eraValues68, quarterValues68, monthValues68, dayValues68, dayPeriodValues68, formattingDayPeriodValues53, ordinalNumber135, localize68, localize_default68;
var init_localize68 = __esm({
  "../../node_modules/date-fns/esm/locale/sq/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues68 = {
      narrow: ["P", "M"],
      abbreviated: ["PK", "MK"],
      wide: ["Para Krishtit", "Mbas Krishtit"]
    };
    quarterValues68 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"]
    };
    monthValues68 = {
      narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
      abbreviated: ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Kor", "Gus", "Sht", "Tet", "N\xEBn", "Dhj"],
      wide: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "N\xEBntor", "Dhjetor"]
    };
    dayValues68 = {
      narrow: ["D", "H", "M", "M", "E", "P", "S"],
      short: ["Di", "H\xEB", "Ma", "M\xEB", "En", "Pr", "Sh"],
      abbreviated: ["Die", "H\xEBn", "Mar", "M\xEBr", "Enj", "Pre", "Sht"],
      wide: ["Diel\xEB", "H\xEBn\xEB", "Mart\xEB", "M\xEBrkur\xEB", "Enjte", "Premte", "Shtun\xEB"]
    };
    dayPeriodValues68 = {
      narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xEBngjes",
        afternoon: "dite",
        evening: "mbr\xEBmje",
        night: "nat\xEB"
      },
      abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xEBt\xEB",
        noon: "drek",
        morning: "m\xEBngjes",
        afternoon: "mbasdite",
        evening: "mbr\xEBmje",
        night: "nat\xEB"
      },
      wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xEBt\xEB",
        noon: "drek",
        morning: "m\xEBngjes",
        afternoon: "mbasdite",
        evening: "mbr\xEBmje",
        night: "nat\xEB"
      }
    };
    formattingDayPeriodValues53 = {
      narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xEB m\xEBngjes",
        afternoon: "n\xEB mbasdite",
        evening: "n\xEB mbr\xEBmje",
        night: "n\xEB mesnat\xEB"
      },
      abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xEB",
        noon: "drek",
        morning: "n\xEB m\xEBngjes",
        afternoon: "n\xEB mbasdite",
        evening: "n\xEB mbr\xEBmje",
        night: "n\xEB mesnat\xEB"
      },
      wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xEB",
        noon: "drek",
        morning: "n\xEB m\xEBngjes",
        afternoon: "n\xEB mbasdite",
        evening: "n\xEB mbr\xEBmje",
        night: "n\xEB mesnat\xEB"
      }
    };
    ordinalNumber135 = function ordinalNumber136(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      if ((options === null || options === void 0 ? void 0 : options.unit) === "hour") return String(number);
      if (number === 1) return number + "-r\xEB";
      if (number === 4) return number + "t";
      return number + "-t\xEB";
    };
    localize68 = {
      ordinalNumber: ordinalNumber135,
      era: buildLocalizeFn({
        values: eraValues68,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues68,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback68(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues68,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues68,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues68,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues53,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default68 = localize68;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/_lib/match/index.js
var matchOrdinalNumberPattern67, parseOrdinalNumberPattern67, matchEraPatterns67, parseEraPatterns67, matchQuarterPatterns67, parseQuarterPatterns67, matchMonthPatterns67, parseMonthPatterns67, matchDayPatterns67, parseDayPatterns67, matchDayPeriodPatterns67, parseDayPeriodPatterns67, match67, match_default67;
var init_match67 = __esm({
  "../../node_modules/date-fns/esm/locale/sq/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern67 = /^(\d+)(-rë|-të|t|)?/i;
    parseOrdinalNumberPattern67 = /\d+/i;
    matchEraPatterns67 = {
      narrow: /^(p|m)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(para krishtit|mbas krishtit)/i
    };
    parseEraPatterns67 = {
      any: [/^b/i, /^(p|m)/i]
    };
    matchQuarterPatterns67 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234]-mujori (i{1,3}|iv)/i
    };
    parseQuarterPatterns67 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns67 = {
      narrow: /^[jsmpqkftnd]/i,
      abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
      wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
    };
    parseMonthPatterns67 = {
      narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
      any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
    };
    matchDayPatterns67 = {
      narrow: /^[dhmeps]/i,
      short: /^(di|hë|ma|më|en|pr|sh)/i,
      abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
      wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
    };
    parseDayPatterns67 = {
      narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
      any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
    };
    matchDayPeriodPatterns67 = {
      narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
      any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
    };
    parseDayPeriodPatterns67 = {
      any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
      }
    };
    match67 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern67,
        parsePattern: parseOrdinalNumberPattern67,
        valueCallback: function valueCallback132(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns67,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns67,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns67,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns67,
        defaultParseWidth: "any",
        valueCallback: function valueCallback133(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns67,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns67,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns67,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns67,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns67,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns67,
        defaultParseWidth: "any"
      })
    };
    match_default67 = match67;
  }
});

// ../../node_modules/date-fns/esm/locale/sq/index.js
var locale78, sq_default;
var init_sq = __esm({
  "../../node_modules/date-fns/esm/locale/sq/index.js"() {
    "use strict";
    init_formatDistance69();
    init_formatLong76();
    init_formatRelative69();
    init_localize68();
    init_match67();
    locale78 = {
      code: "sq",
      formatDistance: formatDistance_default68,
      formatLong: formatLong_default76,
      formatRelative: formatRelative_default68,
      localize: localize_default68,
      match: match_default67,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    sq_default = locale78;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/_lib/formatDistance/index.js
var formatDistanceLocale68, formatDistance138, formatDistance_default69;
var init_formatDistance70 = __esm({
  "../../node_modules/date-fns/esm/locale/sr/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale68 = {
      lessThanXSeconds: {
        one: {
          standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
          withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
          withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      xSeconds: {
        one: {
          standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
          withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
      },
      halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
      lessThanXMinutes: {
        one: {
          standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
          withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
          withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
      },
      xMinutes: {
        one: {
          standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
          withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
          withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
      },
      aboutXHours: {
        one: {
          standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
          withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
          withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
      },
      xHours: {
        one: {
          standalone: "1 \u0441\u0430\u0442",
          withPrepositionAgo: "1 \u0441\u0430\u0442",
          withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
      },
      xDays: {
        one: {
          standalone: "1 \u0434\u0430\u043D",
          withPrepositionAgo: "1 \u0434\u0430\u043D",
          withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
      },
      aboutXWeeks: {
        one: {
          standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
          withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
          withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
      },
      xWeeks: {
        one: {
          standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
          withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
          withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
      },
      aboutXMonths: {
        one: {
          standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
          withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
          withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
      },
      xMonths: {
        one: {
          standalone: "1 \u043C\u0435\u0441\u0435\u0446",
          withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
          withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
      },
      aboutXYears: {
        one: {
          standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
      },
      xYears: {
        one: {
          standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
          withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
          withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
      },
      overXYears: {
        one: {
          standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
      },
      almostXYears: {
        one: {
          standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
          withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
      }
    };
    formatDistance138 = function formatDistance139(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale68[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            result = tokenValue.one.withPrepositionIn;
          } else {
            result = tokenValue.one.withPrepositionAgo;
          }
        } else {
          result = tokenValue.one.standalone;
        }
      } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
      String(count).substr(-2, 1) !== "1") {
        result = tokenValue.dual.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0437\u0430 " + result;
        } else {
          return "\u043F\u0440\u0435 " + result;
        }
      }
      return result;
    };
    formatDistance_default69 = formatDistance138;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/_lib/formatLong/index.js
var dateFormats77, timeFormats77, dateTimeFormats77, formatLong77, formatLong_default77;
var init_formatLong77 = __esm({
  "../../node_modules/date-fns/esm/locale/sr/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats77 = {
      full: "EEEE, d. MMMM yyyy.",
      long: "d. MMMM yyyy.",
      medium: "d. MMM yy.",
      short: "dd. MM. yy."
    };
    timeFormats77 = {
      full: "HH:mm:ss (zzzz)",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats77 = {
      full: "{{date}} '\u0443' {{time}}",
      long: "{{date}} '\u0443' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong77 = {
      date: buildFormatLongFn({
        formats: dateFormats77,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats77,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats77,
        defaultWidth: "full"
      })
    };
    formatLong_default77 = formatLong77;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/_lib/formatRelative/index.js
var formatRelativeLocale69, formatRelative138, formatRelative_default69;
var init_formatRelative70 = __esm({
  "../../node_modules/date-fns/esm/locale/sr/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale69 = {
      lastWeek: function lastWeek17(date) {
        var day = date.getUTCDay();
        switch (day) {
          case 0:
            return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
          case 3:
            return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
          case 6:
            return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
          default:
            return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
      },
      yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
      today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
      tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
      nextWeek: function nextWeek14(date) {
        var day = date.getUTCDay();
        switch (day) {
          case 0:
            return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
          case 3:
            return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
          case 6:
            return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
          default:
            return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
      },
      other: "P"
    };
    formatRelative138 = function formatRelative139(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale69[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default69 = formatRelative138;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/_lib/localize/index.js
var eraValues69, quarterValues69, monthValues69, formattingMonthValues16, dayValues69, formattingDayPeriodValues54, dayPeriodValues69, ordinalNumber137, localize69, localize_default69;
var init_localize69 = __esm({
  "../../node_modules/date-fns/esm/locale/sr/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues69 = {
      narrow: ["\u043F\u0440.\u043D.\u0435.", "\u0410\u0414"],
      abbreviated: ["\u043F\u0440. \u0425\u0440.", "\u043F\u043E. \u0425\u0440."],
      wide: ["\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430", "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"]
    };
    quarterValues69 = {
      narrow: ["1.", "2.", "3.", "4."],
      abbreviated: ["1. \u043A\u0432.", "2. \u043A\u0432.", "3. \u043A\u0432.", "4. \u043A\u0432."],
      wide: ["1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues69 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0431", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0432", "\u0434\u0435\u0446"],
      wide: ["\u0458\u0430\u043D\u0443\u0430\u0440", "\u0444\u0435\u0431\u0440\u0443\u0430\u0440", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440", "\u043E\u043A\u0442\u043E\u0431\u0430\u0440", "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440", "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]
    };
    formattingMonthValues16 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["\u0458\u0430\u043D", "\u0444\u0435\u0431", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043F", "\u043E\u043A\u0442", "\u043D\u043E\u0432", "\u0434\u0435\u0446"],
      wide: ["\u0458\u0430\u043D\u0443\u0430\u0440", "\u0444\u0435\u0431\u0440\u0443\u0430\u0440", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0438\u043B", "\u043C\u0430\u0458", "\u0458\u0443\u043D", "\u0458\u0443\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440", "\u043E\u043A\u0442\u043E\u0431\u0430\u0440", "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440", "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"]
    };
    dayValues69 = {
      narrow: ["\u041D", "\u041F", "\u0423", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0443\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0443\u0431"],
      abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0443\u0442\u043E", "\u0441\u0440\u0435", "\u0447\u0435\u0442", "\u043F\u0435\u0442", "\u0441\u0443\u0431"],
      wide: ["\u043D\u0435\u0434\u0435\u0459\u0430", "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A", "\u0443\u0442\u043E\u0440\u0430\u043A", "\u0441\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A", "\u043F\u0435\u0442\u0430\u043A", "\u0441\u0443\u0431\u043E\u0442\u0430"]
    };
    formattingDayPeriodValues54 = {
      narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      },
      abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      }
    };
    dayPeriodValues69 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
      }
    };
    ordinalNumber137 = function ordinalNumber138(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize69 = {
      ordinalNumber: ordinalNumber137,
      era: buildLocalizeFn({
        values: eraValues69,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues69,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback69(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues69,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues16,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues69,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues69,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues54,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default69 = localize69;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/_lib/match/index.js
var matchOrdinalNumberPattern68, parseOrdinalNumberPattern68, matchEraPatterns68, parseEraPatterns68, matchQuarterPatterns68, parseQuarterPatterns68, matchMonthPatterns68, parseMonthPatterns68, matchDayPatterns68, parseDayPatterns68, matchDayPeriodPatterns68, parseDayPeriodPatterns68, match68, match_default68;
var init_match68 = __esm({
  "../../node_modules/date-fns/esm/locale/sr/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern68 = /^(\d+)\./i;
    parseOrdinalNumberPattern68 = /\d+/i;
    matchEraPatterns68 = {
      narrow: /^(пр\.н\.е\.|АД)/i,
      abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
      wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
    };
    parseEraPatterns68 = {
      any: [/^пр/i, /^(по|нова)/i]
    };
    matchQuarterPatterns68 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\.\s?кв\.?/i,
      wide: /^[1234]\. квартал/i
    };
    parseQuarterPatterns68 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns68 = {
      narrow: /^(10|11|12|[123456789])\./i,
      abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
      wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
    };
    parseMonthPatterns68 = {
      narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
      any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
    };
    matchDayPatterns68 = {
      narrow: /^[пусчн]/i,
      short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
      abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
      wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
    };
    parseDayPatterns68 = {
      narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
      any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
    };
    matchDayPeriodPatterns68 = {
      any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
    };
    parseDayPeriodPatterns68 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
      }
    };
    match68 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern68,
        parsePattern: parseOrdinalNumberPattern68,
        valueCallback: function valueCallback134(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns68,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns68,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns68,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns68,
        defaultParseWidth: "any",
        valueCallback: function valueCallback135(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns68,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns68,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns68,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns68,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns68,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns68,
        defaultParseWidth: "any"
      })
    };
    match_default68 = match68;
  }
});

// ../../node_modules/date-fns/esm/locale/sr/index.js
var locale79, sr_default;
var init_sr = __esm({
  "../../node_modules/date-fns/esm/locale/sr/index.js"() {
    "use strict";
    init_formatDistance70();
    init_formatLong77();
    init_formatRelative70();
    init_localize69();
    init_match68();
    locale79 = {
      code: "sr",
      formatDistance: formatDistance_default69,
      formatLong: formatLong_default77,
      formatRelative: formatRelative_default69,
      localize: localize_default69,
      match: match_default68,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    sr_default = locale79;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatDistance/index.js
var formatDistanceLocale69, formatDistance140, formatDistance_default70;
var init_formatDistance71 = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale69 = {
      lessThanXSeconds: {
        one: {
          standalone: "manje od 1 sekunde",
          withPrepositionAgo: "manje od 1 sekunde",
          withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
      },
      xSeconds: {
        one: {
          standalone: "1 sekunda",
          withPrepositionAgo: "1 sekunde",
          withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
      },
      halfAMinute: "pola minute",
      lessThanXMinutes: {
        one: {
          standalone: "manje od 1 minute",
          withPrepositionAgo: "manje od 1 minute",
          withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
      },
      xMinutes: {
        one: {
          standalone: "1 minuta",
          withPrepositionAgo: "1 minute",
          withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
      },
      aboutXHours: {
        one: {
          standalone: "oko 1 sat",
          withPrepositionAgo: "oko 1 sat",
          withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
      },
      xHours: {
        one: {
          standalone: "1 sat",
          withPrepositionAgo: "1 sat",
          withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
      },
      xDays: {
        one: {
          standalone: "1 dan",
          withPrepositionAgo: "1 dan",
          withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
      },
      aboutXWeeks: {
        one: {
          standalone: "oko 1 nedelju",
          withPrepositionAgo: "oko 1 nedelju",
          withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
      },
      xWeeks: {
        one: {
          standalone: "1 nedelju",
          withPrepositionAgo: "1 nedelju",
          withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
      },
      aboutXMonths: {
        one: {
          standalone: "oko 1 mesec",
          withPrepositionAgo: "oko 1 mesec",
          withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
      },
      xMonths: {
        one: {
          standalone: "1 mesec",
          withPrepositionAgo: "1 mesec",
          withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
      },
      aboutXYears: {
        one: {
          standalone: "oko 1 godinu",
          withPrepositionAgo: "oko 1 godinu",
          withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
      },
      xYears: {
        one: {
          standalone: "1 godina",
          withPrepositionAgo: "1 godine",
          withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
      },
      overXYears: {
        one: {
          standalone: "preko 1 godinu",
          withPrepositionAgo: "preko 1 godinu",
          withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
      },
      almostXYears: {
        one: {
          standalone: "gotovo 1 godinu",
          withPrepositionAgo: "gotovo 1 godinu",
          withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
      }
    };
    formatDistance140 = function formatDistance141(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale69[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
          if (options.comparison && options.comparison > 0) {
            result = tokenValue.one.withPrepositionIn;
          } else {
            result = tokenValue.one.withPrepositionAgo;
          }
        } else {
          result = tokenValue.one.standalone;
        }
      } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
      String(count).substr(-2, 1) !== "1") {
        result = tokenValue.dual.replace("{{count}}", String(count));
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "za " + result;
        } else {
          return "pre " + result;
        }
      }
      return result;
    };
    formatDistance_default70 = formatDistance140;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatLong/index.js
var dateFormats78, timeFormats78, dateTimeFormats78, formatLong78, formatLong_default78;
var init_formatLong78 = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats78 = {
      full: "EEEE, d. MMMM yyyy.",
      long: "d. MMMM yyyy.",
      medium: "d. MMM yy.",
      short: "dd. MM. yy."
    };
    timeFormats78 = {
      full: "HH:mm:ss (zzzz)",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats78 = {
      full: "{{date}} 'u' {{time}}",
      long: "{{date}} 'u' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong78 = {
      date: buildFormatLongFn({
        formats: dateFormats78,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats78,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats78,
        defaultWidth: "full"
      })
    };
    formatLong_default78 = formatLong78;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatRelative/index.js
var formatRelativeLocale70, formatRelative140, formatRelative_default70;
var init_formatRelative71 = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale70 = {
      lastWeek: function lastWeek18(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'pro\u0161le nedelje u' p";
          case 3:
            return "'pro\u0161le srede u' p";
          case 6:
            return "'pro\u0161le subote u' p";
          default:
            return "'pro\u0161li' EEEE 'u' p";
        }
      },
      yesterday: "'ju\u010De u' p",
      today: "'danas u' p",
      tomorrow: "'sutra u' p",
      nextWeek: function nextWeek15(date) {
        switch (date.getUTCDay()) {
          case 0:
            return "'slede\u0107e nedelje u' p";
          case 3:
            return "'slede\u0107u sredu u' p";
          case 6:
            return "'slede\u0107u subotu u' p";
          default:
            return "'slede\u0107i' EEEE 'u' p";
        }
      },
      other: "P"
    };
    formatRelative140 = function formatRelative141(token, date, _baseDate, _options) {
      var format2 = formatRelativeLocale70[token];
      if (typeof format2 === "function") {
        return format2(date);
      }
      return format2;
    };
    formatRelative_default70 = formatRelative140;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/localize/index.js
var eraValues70, quarterValues70, monthValues70, formattingMonthValues17, dayValues70, formattingDayPeriodValues55, dayPeriodValues70, ordinalNumber139, localize70, localize_default70;
var init_localize70 = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues70 = {
      narrow: ["pr.n.e.", "AD"],
      abbreviated: ["pr. Hr.", "po. Hr."],
      wide: ["Pre Hrista", "Posle Hrista"]
    };
    quarterValues70 = {
      narrow: ["1.", "2.", "3.", "4."],
      abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
      wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
    };
    monthValues70 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
      wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
    };
    formattingMonthValues17 = {
      narrow: ["1.", "2.", "3.", "4.", "5.", "6.", "7.", "8.", "9.", "10.", "11.", "12."],
      abbreviated: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "avg", "sep", "okt", "nov", "dec"],
      wide: ["januar", "februar", "mart", "april", "maj", "jun", "jul", "avgust", "septembar", "oktobar", "novembar", "decembar"]
    };
    dayValues70 = {
      narrow: ["N", "P", "U", "S", "\u010C", "P", "S"],
      short: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
      abbreviated: ["ned", "pon", "uto", "sre", "\u010Det", "pet", "sub"],
      wide: ["nedelja", "ponedeljak", "utorak", "sreda", "\u010Detvrtak", "petak", "subota"]
    };
    formattingDayPeriodValues55 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
      }
    };
    dayPeriodValues70 = {
      narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
      },
      wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
      }
    };
    ordinalNumber139 = function ordinalNumber140(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize70 = {
      ordinalNumber: ordinalNumber139,
      era: buildLocalizeFn({
        values: eraValues70,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues70,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback70(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues70,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues17,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues70,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues70,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues55,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default70 = localize70;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/_lib/match/index.js
var matchOrdinalNumberPattern69, parseOrdinalNumberPattern69, matchEraPatterns69, parseEraPatterns69, matchQuarterPatterns69, parseQuarterPatterns69, matchMonthPatterns69, parseMonthPatterns69, matchDayPatterns69, parseDayPatterns69, matchDayPeriodPatterns69, parseDayPeriodPatterns69, match69, match_default69;
var init_match69 = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern69 = /^(\d+)\./i;
    parseOrdinalNumberPattern69 = /\d+/i;
    matchEraPatterns69 = {
      narrow: /^(pr\.n\.e\.|AD)/i,
      abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
      wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
    };
    parseEraPatterns69 = {
      any: [/^pr/i, /^(po|nova)/i]
    };
    matchQuarterPatterns69 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]\.\s?kv\.?/i,
      wide: /^[1234]\. kvartal/i
    };
    parseQuarterPatterns69 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns69 = {
      narrow: /^(10|11|12|[123456789])\./i,
      abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
      wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
    };
    parseMonthPatterns69 = {
      narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns69 = {
      narrow: /^[npusčc]/i,
      short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
      abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
      wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
    };
    parseDayPatterns69 = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    };
    matchDayPeriodPatterns69 = {
      any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
    };
    parseDayPeriodPatterns69 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
      }
    };
    match69 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern69,
        parsePattern: parseOrdinalNumberPattern69,
        valueCallback: function valueCallback136(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns69,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns69,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns69,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns69,
        defaultParseWidth: "any",
        valueCallback: function valueCallback137(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns69,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns69,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns69,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns69,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns69,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns69,
        defaultParseWidth: "any"
      })
    };
    match_default69 = match69;
  }
});

// ../../node_modules/date-fns/esm/locale/sr-Latn/index.js
var locale80, sr_Latn_default;
var init_sr_Latn = __esm({
  "../../node_modules/date-fns/esm/locale/sr-Latn/index.js"() {
    "use strict";
    init_formatDistance71();
    init_formatLong78();
    init_formatRelative71();
    init_localize70();
    init_match69();
    locale80 = {
      code: "sr-Latn",
      formatDistance: formatDistance_default70,
      formatLong: formatLong_default78,
      formatRelative: formatRelative_default70,
      localize: localize_default70,
      match: match_default69,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    sr_Latn_default = locale80;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/_lib/formatDistance/index.js
var formatDistanceLocale70, wordMapping2, formatDistance142, formatDistance_default71;
var init_formatDistance72 = __esm({
  "../../node_modules/date-fns/esm/locale/sv/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale70 = {
      lessThanXSeconds: {
        one: "mindre \xE4n en sekund",
        other: "mindre \xE4n {{count}} sekunder"
      },
      xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
      },
      halfAMinute: "en halv minut",
      lessThanXMinutes: {
        one: "mindre \xE4n en minut",
        other: "mindre \xE4n {{count}} minuter"
      },
      xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
      },
      aboutXHours: {
        one: "ungef\xE4r en timme",
        other: "ungef\xE4r {{count}} timmar"
      },
      xHours: {
        one: "en timme",
        other: "{{count}} timmar"
      },
      xDays: {
        one: "en dag",
        other: "{{count}} dagar"
      },
      aboutXWeeks: {
        one: "ungef\xE4r en vecka",
        other: "ungef\xE4r {{count}} vecka"
      },
      xWeeks: {
        one: "en vecka",
        other: "{{count}} vecka"
      },
      aboutXMonths: {
        one: "ungef\xE4r en m\xE5nad",
        other: "ungef\xE4r {{count}} m\xE5nader"
      },
      xMonths: {
        one: "en m\xE5nad",
        other: "{{count}} m\xE5nader"
      },
      aboutXYears: {
        one: "ungef\xE4r ett \xE5r",
        other: "ungef\xE4r {{count}} \xE5r"
      },
      xYears: {
        one: "ett \xE5r",
        other: "{{count}} \xE5r"
      },
      overXYears: {
        one: "\xF6ver ett \xE5r",
        other: "\xF6ver {{count}} \xE5r"
      },
      almostXYears: {
        one: "n\xE4stan ett \xE5r",
        other: "n\xE4stan {{count}} \xE5r"
      }
    };
    wordMapping2 = ["noll", "en", "tv\xE5", "tre", "fyra", "fem", "sex", "sju", "\xE5tta", "nio", "tio", "elva", "tolv"];
    formatDistance142 = function formatDistance143(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale70[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        if (options && options.onlyNumeric) {
          result = tokenValue.other.replace("{{count}}", String(count));
        } else {
          result = tokenValue.other.replace("{{count}}", count < 13 ? wordMapping2[count] : String(count));
        }
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "om " + result;
        } else {
          return result + " sedan";
        }
      }
      return result;
    };
    formatDistance_default71 = formatDistance142;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/_lib/formatLong/index.js
var dateFormats79, timeFormats79, dateTimeFormats79, formatLong79, formatLong_default79;
var init_formatLong79 = __esm({
  "../../node_modules/date-fns/esm/locale/sv/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats79 = {
      full: "EEEE d MMMM y",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "y-MM-dd"
    };
    timeFormats79 = {
      full: "'kl'. HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats79 = {
      full: "{{date}} 'kl.' {{time}}",
      long: "{{date}} 'kl.' {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong79 = {
      date: buildFormatLongFn({
        formats: dateFormats79,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats79,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats79,
        defaultWidth: "full"
      })
    };
    formatLong_default79 = formatLong79;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/_lib/formatRelative/index.js
var formatRelativeLocale71, formatRelative142, formatRelative_default71;
var init_formatRelative72 = __esm({
  "../../node_modules/date-fns/esm/locale/sv/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale71 = {
      lastWeek: "'i' EEEE's kl.' p",
      yesterday: "'ig\xE5r kl.' p",
      today: "'idag kl.' p",
      tomorrow: "'imorgon kl.' p",
      nextWeek: "EEEE 'kl.' p",
      other: "P"
    };
    formatRelative142 = function formatRelative143(token, _date, _baseDate, _options) {
      return formatRelativeLocale71[token];
    };
    formatRelative_default71 = formatRelative142;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/_lib/localize/index.js
var eraValues71, quarterValues71, monthValues71, dayValues71, dayPeriodValues71, formattingDayPeriodValues56, ordinalNumber141, localize71, localize_default71;
var init_localize71 = __esm({
  "../../node_modules/date-fns/esm/locale/sv/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues71 = {
      narrow: ["f.Kr.", "e.Kr."],
      abbreviated: ["f.Kr.", "e.Kr."],
      wide: ["f\xF6re Kristus", "efter Kristus"]
    };
    quarterValues71 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
    };
    monthValues71 = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
      wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
    };
    dayValues71 = {
      narrow: ["S", "M", "T", "O", "T", "F", "L"],
      short: ["s\xF6", "m\xE5", "ti", "on", "to", "fr", "l\xF6"],
      abbreviated: ["s\xF6n", "m\xE5n", "tis", "ons", "tors", "fre", "l\xF6r"],
      wide: ["s\xF6ndag", "m\xE5ndag", "tisdag", "onsdag", "torsdag", "fredag", "l\xF6rdag"]
    };
    dayPeriodValues71 = {
      narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xE4ll",
        night: "natt"
      },
      abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xE4ll",
        night: "natt"
      },
      wide: {
        am: "f\xF6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xE4ll",
        night: "natt"
      }
    };
    formattingDayPeriodValues56 = {
      narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 efterm.",
        evening: "p\xE5 kv\xE4llen",
        night: "p\xE5 natten"
      },
      abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morg.",
        afternoon: "p\xE5 efterm.",
        evening: "p\xE5 kv\xE4llen",
        night: "p\xE5 natten"
      },
      wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xE5 morgonen",
        afternoon: "p\xE5 eftermiddagen",
        evening: "p\xE5 kv\xE4llen",
        night: "p\xE5 natten"
      }
    };
    ordinalNumber141 = function ordinalNumber142(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      var rem100 = number % 100;
      if (rem100 > 20 || rem100 < 10) {
        switch (rem100 % 10) {
          case 1:
          case 2:
            return number + ":a";
        }
      }
      return number + ":e";
    };
    localize71 = {
      ordinalNumber: ordinalNumber141,
      era: buildLocalizeFn({
        values: eraValues71,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues71,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback71(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues71,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues71,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues71,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues56,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default71 = localize71;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/_lib/match/index.js
var matchOrdinalNumberPattern70, parseOrdinalNumberPattern70, matchEraPatterns70, parseEraPatterns70, matchQuarterPatterns70, parseQuarterPatterns70, matchMonthPatterns70, parseMonthPatterns70, matchDayPatterns70, parseDayPatterns70, matchDayPeriodPatterns70, parseDayPeriodPatterns70, match70, match_default70;
var init_match70 = __esm({
  "../../node_modules/date-fns/esm/locale/sv/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern70 = /^(\d+)(:a|:e)?/i;
    parseOrdinalNumberPattern70 = /\d+/i;
    matchEraPatterns70 = {
      narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
      abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
      wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
    };
    parseEraPatterns70 = {
      any: [/^f/i, /^[ev]/i]
    };
    matchQuarterPatterns70 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](:a|:e)? kvartalet/i
    };
    parseQuarterPatterns70 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns70 = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
      wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
    };
    parseMonthPatterns70 = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns70 = {
      narrow: /^[smtofl]/i,
      short: /^(sö|må|ti|on|to|fr|lö)/i,
      abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
      wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
    };
    parseDayPatterns70 = {
      any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
    };
    matchDayPeriodPatterns70 = {
      any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
    };
    parseDayPeriodPatterns70 = {
      any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
      }
    };
    match70 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern70,
        parsePattern: parseOrdinalNumberPattern70,
        valueCallback: function valueCallback138(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns70,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns70,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns70,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns70,
        defaultParseWidth: "any",
        valueCallback: function valueCallback139(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns70,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns70,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns70,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns70,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns70,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns70,
        defaultParseWidth: "any"
      })
    };
    match_default70 = match70;
  }
});

// ../../node_modules/date-fns/esm/locale/sv/index.js
var locale81, sv_default;
var init_sv = __esm({
  "../../node_modules/date-fns/esm/locale/sv/index.js"() {
    "use strict";
    init_formatDistance72();
    init_formatLong79();
    init_formatRelative72();
    init_localize71();
    init_match70();
    locale81 = {
      code: "sv",
      formatDistance: formatDistance_default71,
      formatLong: formatLong_default79,
      formatRelative: formatRelative_default71,
      localize: localize_default71,
      match: match_default70,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    sv_default = locale81;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/_lib/formatDistance/index.js
function isPluralType2(val) {
  return val.one !== void 0;
}
var formatDistanceLocale71, formatDistance144, formatDistance_default72;
var init_formatDistance73 = __esm({
  "../../node_modules/date-fns/esm/locale/ta/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale71 = {
      lessThanXSeconds: {
        one: {
          default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
          in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
          ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
          in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
          ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xSeconds: {
        one: {
          default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
          in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
      },
      lessThanXMinutes: {
        one: {
          default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
          in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
          ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
          in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
          ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xMinutes: {
        one: {
          default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
          in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      aboutXHours: {
        one: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
      },
      xHours: {
        one: {
          default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
          in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
          in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xDays: {
        one: {
          default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
          in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      aboutXWeeks: {
        one: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xWeeks: {
        one: {
          default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
          in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      aboutXMonths: {
        one: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xMonths: {
        one: {
          default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
          in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      aboutXYears: {
        one: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
          in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      xYears: {
        one: {
          default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
          in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
          ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
          in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      overXYears: {
        one: {
          default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
          in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
          ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
          in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      },
      almostXYears: {
        one: {
          default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
          in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
          ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
          default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
          in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
          ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
      }
    };
    formatDistance144 = function formatDistance145(token, count, options) {
      var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
      var tokenValue = formatDistanceLocale71[token];
      if (!isPluralType2(tokenValue)) return tokenValue[tense];
      if (count === 1) {
        return tokenValue.one[tense];
      } else {
        return tokenValue.other[tense].replace("{{count}}", String(count));
      }
    };
    formatDistance_default72 = formatDistance144;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/_lib/formatLong/index.js
var dateFormats80, timeFormats80, dateTimeFormats80, formatLong80, formatLong_default80;
var init_formatLong80 = __esm({
  "../../node_modules/date-fns/esm/locale/ta/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats80 = {
      full: "EEEE, d MMMM, y",
      long: "d MMMM, y",
      medium: "d MMM, y",
      short: "d/M/yy"
    };
    timeFormats80 = {
      full: "a h:mm:ss zzzz",
      long: "a h:mm:ss z",
      medium: "a h:mm:ss",
      short: "a h:mm"
    };
    dateTimeFormats80 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong80 = {
      date: buildFormatLongFn({
        formats: dateFormats80,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats80,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats80,
        defaultWidth: "full"
      })
    };
    formatLong_default80 = formatLong80;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/_lib/formatRelative/index.js
var formatRelativeLocale72, formatRelative144, formatRelative_default72;
var init_formatRelative73 = __esm({
  "../../node_modules/date-fns/esm/locale/ta/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale72 = {
      lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
      yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
      today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
      tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
      nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
      other: "P"
    };
    formatRelative144 = function formatRelative145(token, _date, _baseDate, _options) {
      return formatRelativeLocale72[token];
    };
    formatRelative_default72 = formatRelative144;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/_lib/localize/index.js
var eraValues72, quarterValues72, monthValues72, dayValues72, dayPeriodValues72, formattingDayPeriodValues57, ordinalNumber143, localize72, localize_default72;
var init_localize72 = __esm({
  "../../node_modules/date-fns/esm/locale/ta/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues72 = {
      narrow: ["\u0B95\u0BBF.\u0BAE\u0BC1.", "\u0B95\u0BBF.\u0BAA\u0BBF."],
      abbreviated: ["\u0B95\u0BBF.\u0BAE\u0BC1.", "\u0B95\u0BBF.\u0BAA\u0BBF."],
      // CLDR #1624, #1626
      wide: ["\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD", "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"]
      // CLDR #1620, #1622
    };
    quarterValues72 = {
      // CLDR #1644 - #1647
      narrow: ["1", "2", "3", "4"],
      // CLDR #1636 - #1639
      abbreviated: ["\u0B95\u0BBE\u0BB2\u0BBE.1", "\u0B95\u0BBE\u0BB2\u0BBE.2", "\u0B95\u0BBE\u0BB2\u0BBE.3", "\u0B95\u0BBE\u0BB2\u0BBE.4"],
      // CLDR #1628 - #1631
      wide: ["\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1", "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"]
    };
    monthValues72 = {
      // CLDR #700 - #711
      narrow: ["\u0B9C", "\u0BAA\u0BBF", "\u0BAE\u0BBE", "\u0B8F", "\u0BAE\u0BC7", "\u0B9C\u0BC2", "\u0B9C\u0BC2", "\u0B86", "\u0B9A\u0BC6", "\u0B85", "\u0BA8", "\u0B9F\u0BBF"],
      // CLDR #1676 - #1687
      abbreviated: ["\u0B9C\u0BA9.", "\u0BAA\u0BBF\u0BAA\u0BCD.", "\u0BAE\u0BBE\u0BB0\u0BCD.", "\u0B8F\u0BAA\u0BCD.", "\u0BAE\u0BC7", "\u0B9C\u0BC2\u0BA9\u0BCD", "\u0B9C\u0BC2\u0BB2\u0BC8", "\u0B86\u0B95.", "\u0B9A\u0BC6\u0BAA\u0BCD.", "\u0B85\u0B95\u0BCD.", "\u0BA8\u0BB5.", "\u0B9F\u0BBF\u0B9A."],
      // CLDR #1652 - #1663
      wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD"
        // December
      ]
    };
    dayValues72 = {
      // CLDR #1766 - #1772
      narrow: ["\u0B9E\u0BBE", "\u0BA4\u0BBF", "\u0B9A\u0BC6", "\u0BAA\u0BC1", "\u0BB5\u0BBF", "\u0BB5\u0BC6", "\u0B9A"],
      // CLDR #1752 - #1758
      short: ["\u0B9E\u0BBE", "\u0BA4\u0BBF", "\u0B9A\u0BC6", "\u0BAA\u0BC1", "\u0BB5\u0BBF", "\u0BB5\u0BC6", "\u0B9A"],
      // CLDR #1738 - #1744
      abbreviated: ["\u0B9E\u0BBE\u0BAF\u0BBF.", "\u0BA4\u0BBF\u0B99\u0BCD.", "\u0B9A\u0BC6\u0BB5\u0BCD.", "\u0BAA\u0BC1\u0BA4.", "\u0BB5\u0BBF\u0BAF\u0BBE.", "\u0BB5\u0BC6\u0BB3\u0BCD.", "\u0B9A\u0BA9\u0BBF"],
      // CLDR #1724 - #1730
      wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF"
        // Saturday
      ]
    };
    dayPeriodValues72 = {
      narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
      },
      abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
      },
      wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
      }
    };
    formattingDayPeriodValues57 = {
      narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
      },
      abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
      },
      wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
      }
    };
    ordinalNumber143 = function ordinalNumber144(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize72 = {
      ordinalNumber: ordinalNumber143,
      era: buildLocalizeFn({
        values: eraValues72,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues72,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback72(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues72,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues72,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues72,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues57,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default72 = localize72;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/_lib/match/index.js
var matchOrdinalNumberPattern71, parseOrdinalNumberPattern71, matchEraPatterns71, parseEraPatterns71, matchQuarterPatterns71, parseQuarterPatterns71, matchMonthPatterns71, parseMonthPatterns71, matchDayPatterns71, parseDayPatterns71, matchDayPeriodPatterns71, parseDayPeriodPatterns71, match71, match_default71;
var init_match71 = __esm({
  "../../node_modules/date-fns/esm/locale/ta/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern71 = /^(\d+)(வது)?/i;
    parseOrdinalNumberPattern71 = /\d+/i;
    matchEraPatterns71 = {
      narrow: /^(கி.மு.|கி.பி.)/i,
      abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
      wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
    };
    parseEraPatterns71 = {
      any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
    };
    matchQuarterPatterns71 = {
      narrow: /^[1234]/i,
      abbreviated: /^காலா.[1234]/i,
      wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
    };
    parseQuarterPatterns71 = {
      narrow: [/1/i, /2/i, /3/i, /4/i],
      any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
    };
    matchMonthPatterns71 = {
      narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
      abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
      wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
    };
    parseMonthPatterns71 = {
      narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
      any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
    };
    matchDayPatterns71 = {
      narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
      short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
      abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
      wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
    };
    parseDayPatterns71 = {
      narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
      any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
    };
    matchDayPeriodPatterns71 = {
      narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
      any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
    };
    parseDayPeriodPatterns71 = {
      any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
      }
    };
    match71 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern71,
        parsePattern: parseOrdinalNumberPattern71,
        valueCallback: function valueCallback140(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns71,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns71,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns71,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns71,
        defaultParseWidth: "any",
        valueCallback: function valueCallback141(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns71,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns71,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns71,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns71,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns71,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns71,
        defaultParseWidth: "any"
      })
    };
    match_default71 = match71;
  }
});

// ../../node_modules/date-fns/esm/locale/ta/index.js
var locale82, ta_default;
var init_ta = __esm({
  "../../node_modules/date-fns/esm/locale/ta/index.js"() {
    "use strict";
    init_formatDistance73();
    init_formatLong80();
    init_formatRelative73();
    init_localize72();
    init_match71();
    locale82 = {
      code: "ta",
      formatDistance: formatDistance_default72,
      formatLong: formatLong_default80,
      formatRelative: formatRelative_default72,
      localize: localize_default72,
      match: match_default71,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    ta_default = locale82;
  }
});

// ../../node_modules/date-fns/esm/locale/te/_lib/formatDistance/index.js
var formatDistanceLocale72, formatDistance146, formatDistance_default73;
var init_formatDistance74 = __esm({
  "../../node_modules/date-fns/esm/locale/te/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale72 = {
      lessThanXSeconds: {
        standalone: {
          one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
          other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
          one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
          other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
      },
      xSeconds: {
        standalone: {
          one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
          // CLDR #1314
          other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
          other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
      },
      halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
      },
      lessThanXMinutes: {
        standalone: {
          one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
          other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
          other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
      },
      xMinutes: {
        standalone: {
          one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
          // CLDR #1311
          other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
          // CLDR #1311
          other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
      },
      aboutXHours: {
        standalone: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
      },
      xHours: {
        standalone: {
          one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
          // CLDR #1308
          other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
          other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
      },
      xDays: {
        standalone: {
          one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
          // CLDR #1292
          other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
          other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
      },
      aboutXWeeks: {
        standalone: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
      },
      xWeeks: {
        standalone: {
          one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
          other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
          other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
      },
      aboutXMonths: {
        standalone: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
      },
      xMonths: {
        standalone: {
          one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
          // CLDR #1281
          other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
          other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
      },
      aboutXYears: {
        standalone: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
      },
      xYears: {
        standalone: {
          one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          // CLDR #1275
          other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
      },
      overXYears: {
        standalone: {
          one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
          other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
          one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
      },
      almostXYears: {
        standalone: {
          one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
          one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
          other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
      }
    };
    formatDistance146 = function formatDistance147(token, count, options) {
      var result;
      var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale72[token].withPreposition : formatDistanceLocale72[token].standalone;
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u0C32\u0C4B";
        } else {
          return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
        }
      }
      return result;
    };
    formatDistance_default73 = formatDistance146;
  }
});

// ../../node_modules/date-fns/esm/locale/te/_lib/formatLong/index.js
var dateFormats81, timeFormats81, dateTimeFormats81, formatLong81, formatLong_default81;
var init_formatLong81 = __esm({
  "../../node_modules/date-fns/esm/locale/te/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats81 = {
      full: "d, MMMM y, EEEE",
      long: "d MMMM, y",
      medium: "d MMM, y",
      short: "dd-MM-yy"
    };
    timeFormats81 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats81 = {
      full: "{{date}} {{time}}'\u0C15\u0C3F'",
      long: "{{date}} {{time}}'\u0C15\u0C3F'",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong81 = {
      date: buildFormatLongFn({
        formats: dateFormats81,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats81,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats81,
        defaultWidth: "full"
      })
    };
    formatLong_default81 = formatLong81;
  }
});

// ../../node_modules/date-fns/esm/locale/te/_lib/formatRelative/index.js
var formatRelativeLocale73, formatRelative146, formatRelative_default73;
var init_formatRelative74 = __esm({
  "../../node_modules/date-fns/esm/locale/te/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale73 = {
      lastWeek: "'\u0C17\u0C24' eeee p",
      // CLDR #1384
      yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
      // CLDR #1393
      today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
      // CLDR #1394
      tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
      // CLDR #1395
      nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
      // CLDR #1386
      other: "P"
    };
    formatRelative146 = function formatRelative147(token, _date, _baseDate, _options) {
      return formatRelativeLocale73[token];
    };
    formatRelative_default73 = formatRelative146;
  }
});

// ../../node_modules/date-fns/esm/locale/te/_lib/localize/index.js
var eraValues73, quarterValues73, monthValues73, dayValues73, dayPeriodValues73, formattingDayPeriodValues58, ordinalNumber145, localize73, localize_default73;
var init_localize73 = __esm({
  "../../node_modules/date-fns/esm/locale/te/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues73 = {
      narrow: ["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.", "\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
      abbreviated: ["\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.", "\u0C15\u0C4D\u0C30\u0C40.\u0C36."],
      wide: ["\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02", "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"]
    };
    quarterValues73 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u0C24\u0C4D\u0C30\u0C481", "\u0C24\u0C4D\u0C30\u0C482", "\u0C24\u0C4D\u0C30\u0C483", "\u0C24\u0C4D\u0C30\u0C484"],
      wide: ["1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02", "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"]
    };
    monthValues73 = {
      narrow: ["\u0C1C", "\u0C2B\u0C3F", "\u0C2E\u0C3E", "\u0C0F", "\u0C2E\u0C47", "\u0C1C\u0C42", "\u0C1C\u0C41", "\u0C06", "\u0C38\u0C46", "\u0C05", "\u0C28", "\u0C21\u0C3F"],
      abbreviated: ["\u0C1C\u0C28", "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30", "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F", "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F", "\u0C2E\u0C47", "\u0C1C\u0C42\u0C28\u0C4D", "\u0C1C\u0C41\u0C32\u0C48", "\u0C06\u0C17", "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02", "\u0C05\u0C15\u0C4D\u0C1F\u0C4B", "\u0C28\u0C35\u0C02", "\u0C21\u0C3F\u0C38\u0C46\u0C02"],
      wide: ["\u0C1C\u0C28\u0C35\u0C30\u0C3F", "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F", "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F", "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D", "\u0C2E\u0C47", "\u0C1C\u0C42\u0C28\u0C4D", "\u0C1C\u0C41\u0C32\u0C48", "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41", "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D", "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D", "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D", "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"]
    };
    dayValues73 = {
      narrow: ["\u0C06", "\u0C38\u0C4B", "\u0C2E", "\u0C2C\u0C41", "\u0C17\u0C41", "\u0C36\u0C41", "\u0C36"],
      short: ["\u0C06\u0C26\u0C3F", "\u0C38\u0C4B\u0C2E", "\u0C2E\u0C02\u0C17\u0C33", "\u0C2C\u0C41\u0C27", "\u0C17\u0C41\u0C30\u0C41", "\u0C36\u0C41\u0C15\u0C4D\u0C30", "\u0C36\u0C28\u0C3F"],
      abbreviated: ["\u0C06\u0C26\u0C3F", "\u0C38\u0C4B\u0C2E", "\u0C2E\u0C02\u0C17\u0C33", "\u0C2C\u0C41\u0C27", "\u0C17\u0C41\u0C30\u0C41", "\u0C36\u0C41\u0C15\u0C4D\u0C30", "\u0C36\u0C28\u0C3F"],
      wide: ["\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02", "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02", "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02", "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02", "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02", "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02", "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"]
    };
    dayPeriodValues73 = {
      narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      },
      abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      },
      wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      }
    };
    formattingDayPeriodValues58 = {
      narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      },
      abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      },
      wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
      }
    };
    ordinalNumber145 = function ordinalNumber146(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + "\u0C35";
    };
    localize73 = {
      ordinalNumber: ordinalNumber145,
      era: buildLocalizeFn({
        values: eraValues73,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues73,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback73(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues73,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues73,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues73,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues58,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default73 = localize73;
  }
});

// ../../node_modules/date-fns/esm/locale/te/_lib/match/index.js
var matchOrdinalNumberPattern72, parseOrdinalNumberPattern72, matchEraPatterns72, parseEraPatterns72, matchQuarterPatterns72, parseQuarterPatterns72, matchMonthPatterns72, parseMonthPatterns72, matchDayPatterns72, parseDayPatterns72, matchDayPeriodPatterns72, parseDayPeriodPatterns72, match72, match_default72;
var init_match72 = __esm({
  "../../node_modules/date-fns/esm/locale/te/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern72 = /^(\d+)(వ)?/i;
    parseOrdinalNumberPattern72 = /\d+/i;
    matchEraPatterns72 = {
      narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
      abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
      wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
    };
    parseEraPatterns72 = {
      any: [/^(పూ|శ)/i, /^సా/i]
    };
    matchQuarterPatterns72 = {
      narrow: /^[1234]/i,
      abbreviated: /^త్రై[1234]/i,
      wide: /^[1234](వ)? త్రైమాసికం/i
    };
    parseQuarterPatterns72 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns72 = {
      narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
      abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
      wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
    };
    parseMonthPatterns72 = {
      narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
      any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
    };
    matchDayPatterns72 = {
      narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
      short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
      abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
      wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
    };
    parseDayPatterns72 = {
      narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
      any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
    };
    matchDayPeriodPatterns72 = {
      narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
      any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
    };
    parseDayPeriodPatterns72 = {
      any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
      }
    };
    match72 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern72,
        parsePattern: parseOrdinalNumberPattern72,
        valueCallback: function valueCallback142(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns72,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns72,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns72,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns72,
        defaultParseWidth: "any",
        valueCallback: function valueCallback143(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns72,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns72,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns72,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns72,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns72,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns72,
        defaultParseWidth: "any"
      })
    };
    match_default72 = match72;
  }
});

// ../../node_modules/date-fns/esm/locale/te/index.js
var locale83, te_default;
var init_te = __esm({
  "../../node_modules/date-fns/esm/locale/te/index.js"() {
    "use strict";
    init_formatDistance74();
    init_formatLong81();
    init_formatRelative74();
    init_localize73();
    init_match72();
    locale83 = {
      code: "te",
      formatDistance: formatDistance_default73,
      formatLong: formatLong_default81,
      formatRelative: formatRelative_default73,
      localize: localize_default73,
      match: match_default72,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    te_default = locale83;
  }
});

// ../../node_modules/date-fns/esm/locale/th/_lib/formatDistance/index.js
var formatDistanceLocale73, formatDistance148, formatDistance_default74;
var init_formatDistance75 = __esm({
  "../../node_modules/date-fns/esm/locale/th/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale73 = {
      lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
      },
      xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
      },
      halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
      lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
      },
      xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
      },
      aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
      },
      xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
      },
      xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
      },
      aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
      },
      xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
      },
      aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
      },
      xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
      },
      aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
      },
      xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
      },
      overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
      },
      almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
      }
    };
    formatDistance148 = function formatDistance149(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale73[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          if (token === "halfAMinute") {
            return "\u0E43\u0E19" + result;
          } else {
            return "\u0E43\u0E19 " + result;
          }
        } else {
          return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
        }
      }
      return result;
    };
    formatDistance_default74 = formatDistance148;
  }
});

// ../../node_modules/date-fns/esm/locale/th/_lib/formatLong/index.js
var dateFormats82, timeFormats82, dateTimeFormats82, formatLong82, formatLong_default82;
var init_formatLong82 = __esm({
  "../../node_modules/date-fns/esm/locale/th/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats82 = {
      full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
      long: "do MMMM y",
      medium: "d MMM y",
      short: "dd/MM/yyyy"
    };
    timeFormats82 = {
      full: "H:mm:ss \u0E19. zzzz",
      long: "H:mm:ss \u0E19. z",
      medium: "H:mm:ss \u0E19.",
      short: "H:mm \u0E19."
    };
    dateTimeFormats82 = {
      full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
      long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong82 = {
      date: buildFormatLongFn({
        formats: dateFormats82,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats82,
        defaultWidth: "medium"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats82,
        defaultWidth: "full"
      })
    };
    formatLong_default82 = formatLong82;
  }
});

// ../../node_modules/date-fns/esm/locale/th/_lib/formatRelative/index.js
var formatRelativeLocale74, formatRelative148, formatRelative_default74;
var init_formatRelative75 = __esm({
  "../../node_modules/date-fns/esm/locale/th/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale74 = {
      lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
      yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
      today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
      tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
      nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
      other: "P"
    };
    formatRelative148 = function formatRelative149(token, _date, _baseDate, _options) {
      return formatRelativeLocale74[token];
    };
    formatRelative_default74 = formatRelative148;
  }
});

// ../../node_modules/date-fns/esm/locale/th/_lib/localize/index.js
var eraValues74, quarterValues74, dayValues74, monthValues74, dayPeriodValues74, formattingDayPeriodValues59, ordinalNumber147, localize74, localize_default74;
var init_localize74 = __esm({
  "../../node_modules/date-fns/esm/locale/th/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues74 = {
      narrow: ["B", "\u0E04\u0E28"],
      abbreviated: ["BC", "\u0E04.\u0E28."],
      wide: ["\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25", "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"]
    };
    quarterValues74 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21", "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"]
    };
    dayValues74 = {
      narrow: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
      short: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
      abbreviated: ["\u0E2D\u0E32.", "\u0E08.", "\u0E2D.", "\u0E1E.", "\u0E1E\u0E24.", "\u0E28.", "\u0E2A."],
      wide: ["\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C", "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C", "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23", "\u0E1E\u0E38\u0E18", "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35", "\u0E28\u0E38\u0E01\u0E23\u0E4C", "\u0E40\u0E2A\u0E32\u0E23\u0E4C"]
    };
    monthValues74 = {
      narrow: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
      abbreviated: ["\u0E21.\u0E04.", "\u0E01.\u0E1E.", "\u0E21\u0E35.\u0E04.", "\u0E40\u0E21.\u0E22.", "\u0E1E.\u0E04.", "\u0E21\u0E34.\u0E22.", "\u0E01.\u0E04.", "\u0E2A.\u0E04.", "\u0E01.\u0E22.", "\u0E15.\u0E04.", "\u0E1E.\u0E22.", "\u0E18.\u0E04."],
      wide: ["\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21", "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C", "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21", "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19", "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21", "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19", "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21", "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21", "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19", "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21", "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19", "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"]
    };
    dayPeriodValues74 = {
      narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      },
      abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      },
      wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      }
    };
    formattingDayPeriodValues59 = {
      narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      },
      abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      },
      wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
      }
    };
    ordinalNumber147 = function ordinalNumber148(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize74 = {
      ordinalNumber: ordinalNumber147,
      era: buildLocalizeFn({
        values: eraValues74,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues74,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback74(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues74,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues74,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues74,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues59,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default74 = localize74;
  }
});

// ../../node_modules/date-fns/esm/locale/th/_lib/match/index.js
var matchOrdinalNumberPattern73, parseOrdinalNumberPattern73, matchEraPatterns73, parseEraPatterns73, matchQuarterPatterns73, parseQuarterPatterns73, matchMonthPatterns73, parseMonthPatterns73, matchDayPatterns73, parseDayPatterns73, matchDayPeriodPatterns73, parseDayPeriodPatterns73, match73, match_default73;
var init_match73 = __esm({
  "../../node_modules/date-fns/esm/locale/th/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern73 = /^\d+/i;
    parseOrdinalNumberPattern73 = /\d+/i;
    matchEraPatterns73 = {
      narrow: /^([bB]|[aA]|คศ)/i,
      abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
      wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
    };
    parseEraPatterns73 = {
      any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
    };
    matchQuarterPatterns73 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^ไตรมาส(ที่)? ?[1234]/i
    };
    parseQuarterPatterns73 = {
      any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
    };
    matchMonthPatterns73 = {
      narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
      abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
      wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
    };
    parseMonthPatterns73 = {
      wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
      any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
    };
    matchDayPatterns73 = {
      narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
      short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
      abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
      wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
    };
    parseDayPatterns73 = {
      wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
      any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
    };
    matchDayPeriodPatterns73 = {
      any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
    };
    parseDayPeriodPatterns73 = {
      any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
      }
    };
    match73 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern73,
        parsePattern: parseOrdinalNumberPattern73,
        valueCallback: function valueCallback144(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns73,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns73,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns73,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns73,
        defaultParseWidth: "any",
        valueCallback: function valueCallback145(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns73,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns73,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns73,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns73,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns73,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns73,
        defaultParseWidth: "any"
      })
    };
    match_default73 = match73;
  }
});

// ../../node_modules/date-fns/esm/locale/th/index.js
var locale84, th_default;
var init_th = __esm({
  "../../node_modules/date-fns/esm/locale/th/index.js"() {
    "use strict";
    init_formatDistance75();
    init_formatLong82();
    init_formatRelative75();
    init_localize74();
    init_match73();
    locale84 = {
      code: "th",
      formatDistance: formatDistance_default74,
      formatLong: formatLong_default82,
      formatRelative: formatRelative_default74,
      localize: localize_default74,
      match: match_default73,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    th_default = locale84;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatDistance/index.js
var formatDistanceLocale74, formatDistance150, formatDistance_default75;
var init_formatDistance76 = __esm({
  "../../node_modules/date-fns/esm/locale/tr/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale74 = {
      lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
      },
      xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
      },
      halfAMinute: "yar\u0131m dakika",
      lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
      },
      xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
      },
      aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
      },
      xHours: {
        one: "1 saat",
        other: "{{count}} saat"
      },
      xDays: {
        one: "1 g\xFCn",
        other: "{{count}} g\xFCn"
      },
      aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
      },
      xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
      },
      aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
      },
      xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
      },
      aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
      },
      xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
      },
      overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
      },
      almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
      }
    };
    formatDistance150 = function formatDistance151(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale74[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", count.toString());
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " sonra";
        } else {
          return result + " \xF6nce";
        }
      }
      return result;
    };
    formatDistance_default75 = formatDistance150;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatLong/index.js
var dateFormats83, timeFormats83, dateTimeFormats83, formatLong83, formatLong_default83;
var init_formatLong83 = __esm({
  "../../node_modules/date-fns/esm/locale/tr/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats83 = {
      full: "d MMMM y EEEE",
      long: "d MMMM y",
      medium: "d MMM y",
      short: "dd.MM.yyyy"
    };
    timeFormats83 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats83 = {
      full: "{{date}} 'saat' {{time}}",
      long: "{{date}} 'saat' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong83 = {
      date: buildFormatLongFn({
        formats: dateFormats83,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats83,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats83,
        defaultWidth: "full"
      })
    };
    formatLong_default83 = formatLong83;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/_lib/formatRelative/index.js
var formatRelativeLocale75, formatRelative150, formatRelative_default75;
var init_formatRelative76 = __esm({
  "../../node_modules/date-fns/esm/locale/tr/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale75 = {
      lastWeek: "'ge\xE7en hafta' eeee 'saat' p",
      yesterday: "'d\xFCn saat' p",
      today: "'bug\xFCn saat' p",
      tomorrow: "'yar\u0131n saat' p",
      nextWeek: "eeee 'saat' p",
      other: "P"
    };
    formatRelative150 = function formatRelative151(token, _date, _baseDate, _options) {
      return formatRelativeLocale75[token];
    };
    formatRelative_default75 = formatRelative150;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/_lib/localize/index.js
var eraValues75, quarterValues75, monthValues75, dayValues75, dayPeriodValues75, formattingDayPeriodValues60, ordinalNumber149, localize75, localize_default75;
var init_localize75 = __esm({
  "../../node_modules/date-fns/esm/locale/tr/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues75 = {
      narrow: ["M\xD6", "MS"],
      abbreviated: ["M\xD6", "MS"],
      wide: ["Milattan \xD6nce", "Milattan Sonra"]
    };
    quarterValues75 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1\xC7", "2\xC7", "3\xC7", "4\xC7"],
      wide: ["\u0130lk \xE7eyrek", "\u0130kinci \xC7eyrek", "\xDC\xE7\xFCnc\xFC \xE7eyrek", "Son \xE7eyrek"]
    };
    monthValues75 = {
      narrow: ["O", "\u015E", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
      abbreviated: ["Oca", "\u015Eub", "Mar", "Nis", "May", "Haz", "Tem", "A\u011Fu", "Eyl", "Eki", "Kas", "Ara"],
      wide: ["Ocak", "\u015Eubat", "Mart", "Nisan", "May\u0131s", "Haziran", "Temmuz", "A\u011Fustos", "Eyl\xFCl", "Ekim", "Kas\u0131m", "Aral\u0131k"]
    };
    dayValues75 = {
      narrow: ["P", "P", "S", "\xC7", "P", "C", "C"],
      short: ["Pz", "Pt", "Sa", "\xC7a", "Pe", "Cu", "Ct"],
      abbreviated: ["Paz", "Pzt", "Sal", "\xC7ar", "Per", "Cum", "Cts"],
      wide: ["Pazar", "Pazartesi", "Sal\u0131", "\xC7ar\u015Famba", "Per\u015Fembe", "Cuma", "Cumartesi"]
    };
    dayPeriodValues75 = {
      narrow: {
        am: "\xF6\xF6",
        pm: "\xF6s",
        midnight: "gy",
        noon: "\xF6",
        morning: "sa",
        afternoon: "\xF6s",
        evening: "ak",
        night: "ge"
      },
      abbreviated: {
        am: "\xD6\xD6",
        pm: "\xD6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xF6\u011Fle",
        morning: "sabah",
        afternoon: "\xF6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
      },
      wide: {
        am: "\xD6.\xD6.",
        pm: "\xD6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xF6\u011Fle",
        morning: "sabah",
        afternoon: "\xF6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
      }
    };
    formattingDayPeriodValues60 = {
      narrow: {
        am: "\xF6\xF6",
        pm: "\xF6s",
        midnight: "gy",
        noon: "\xF6",
        morning: "sa",
        afternoon: "\xF6s",
        evening: "ak",
        night: "ge"
      },
      abbreviated: {
        am: "\xD6\xD6",
        pm: "\xD6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xF6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xF6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
      },
      wide: {
        am: "\xF6.\xF6.",
        pm: "\xF6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xF6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xF6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
      }
    };
    ordinalNumber149 = function ordinalNumber150(dirtyNumber, _options) {
      var number = Number(dirtyNumber);
      return number + ".";
    };
    localize75 = {
      ordinalNumber: ordinalNumber149,
      era: buildLocalizeFn({
        values: eraValues75,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues75,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback75(quarter) {
          return Number(quarter) - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues75,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues75,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues75,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues60,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default75 = localize75;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/_lib/match/index.js
var matchOrdinalNumberPattern74, parseOrdinalNumberPattern74, matchEraPatterns74, parseEraPatterns74, matchQuarterPatterns74, parseQuarterPatterns74, matchMonthPatterns74, parseMonthPatterns74, matchDayPatterns74, parseDayPatterns74, matchDayPeriodPatterns74, parseDayPeriodPatterns74, match74, match_default74;
var init_match74 = __esm({
  "../../node_modules/date-fns/esm/locale/tr/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern74 = /^(\d+)(\.)?/i;
    parseOrdinalNumberPattern74 = /\d+/i;
    matchEraPatterns74 = {
      narrow: /^(mö|ms)/i,
      abbreviated: /^(mö|ms)/i,
      wide: /^(milattan önce|milattan sonra)/i
    };
    parseEraPatterns74 = {
      any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
    };
    matchQuarterPatterns74 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]ç/i,
      wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
    };
    parseQuarterPatterns74 = {
      any: [/1/i, /2/i, /3/i, /4/i],
      abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
      wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
    };
    matchMonthPatterns74 = {
      narrow: /^[oşmnhtaek]/i,
      abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
      wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
    };
    parseMonthPatterns74 = {
      narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
      any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
    };
    matchDayPatterns74 = {
      narrow: /^[psçc]/i,
      short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
      abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
      wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
    };
    parseDayPatterns74 = {
      narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
      any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
      wide: [/^pazar(?!tesi)/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma(?!rtesi)/i, /^cumartesi/i]
    };
    matchDayPeriodPatterns74 = {
      narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
      any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
    };
    parseDayPeriodPatterns74 = {
      any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
      }
    };
    match74 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern74,
        parsePattern: parseOrdinalNumberPattern74,
        valueCallback: function valueCallback146(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns74,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns74,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns74,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns74,
        defaultParseWidth: "any",
        valueCallback: function valueCallback147(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns74,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns74,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns74,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns74,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns74,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns74,
        defaultParseWidth: "any"
      })
    };
    match_default74 = match74;
  }
});

// ../../node_modules/date-fns/esm/locale/tr/index.js
var locale85, tr_default;
var init_tr = __esm({
  "../../node_modules/date-fns/esm/locale/tr/index.js"() {
    "use strict";
    init_formatDistance76();
    init_formatLong83();
    init_formatRelative76();
    init_localize75();
    init_match74();
    locale85 = {
      code: "tr",
      formatDistance: formatDistance_default75,
      formatLong: formatLong_default83,
      formatRelative: formatRelative_default75,
      localize: localize_default75,
      match: match_default74,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    tr_default = locale85;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/_lib/formatDistance/index.js
var formatDistanceLocale75, formatDistance152, formatDistance_default76;
var init_formatDistance77 = __esm({
  "../../node_modules/date-fns/esm/locale/ug/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale75 = {
      lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
      },
      xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
      },
      halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
      lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
      },
      xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
      },
      aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
      },
      xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
      },
      xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
      },
      aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
      },
      xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
      },
      aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
      },
      xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
      },
      aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
      },
      xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
      },
      overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
      },
      almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
      }
    };
    formatDistance152 = function formatDistance153(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale75[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result;
        } else {
          return result + " \u0628\u0648\u0644\u062F\u0649";
        }
      }
      return result;
    };
    formatDistance_default76 = formatDistance152;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/_lib/formatLong/index.js
var dateFormats84, timeFormats84, dateTimeFormats84, formatLong84, formatLong_default84;
var init_formatLong84 = __esm({
  "../../node_modules/date-fns/esm/locale/ug/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats84 = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    };
    timeFormats84 = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    };
    dateTimeFormats84 = {
      full: "{{date}} '\u062F\u06D5' {{time}}",
      long: "{{date}} '\u062F\u06D5' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong84 = {
      date: buildFormatLongFn({
        formats: dateFormats84,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats84,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats84,
        defaultWidth: "full"
      })
    };
    formatLong_default84 = formatLong84;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/_lib/formatRelative/index.js
var formatRelativeLocale76, formatRelative152, formatRelative_default76;
var init_formatRelative77 = __esm({
  "../../node_modules/date-fns/esm/locale/ug/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale76 = {
      lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
      yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
      today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
      tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
      nextWeek: "eeee '\u062F\u06D5' p",
      other: "P"
    };
    formatRelative152 = function formatRelative153(token, _date, _baseDate, _options) {
      return formatRelativeLocale76[token];
    };
    formatRelative_default76 = formatRelative152;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/_lib/localize/index.js
var eraValues76, quarterValues76, monthValues76, dayValues76, dayPeriodValues76, formattingDayPeriodValues61, ordinalNumber151, localize76, localize_default76;
var init_localize76 = __esm({
  "../../node_modules/date-fns/esm/locale/ug/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues76 = {
      narrow: ["\u0628", "\u0643"],
      abbreviated: ["\u0628", "\u0643"],
      wide: ["\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646", "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"]
    };
    quarterValues76 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1", "2", "3", "4"],
      wide: ["\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643", "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"]
    };
    monthValues76 = {
      narrow: ["\u064A", "\u0641", "\u0645", "\u0627", "\u0645", "\u0649", "\u0649", "\u0627", "\u0633", "\u06C6", "\u0646", "\u062F"],
      abbreviated: ["\u064A\u0627\u0646\u06CB\u0627\u0631", "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644", "\u0645\u0627\u0631\u062A", "\u0626\u0627\u067E\u0631\u0649\u0644", "\u0645\u0627\u064A", "\u0626\u0649\u064A\u06C7\u0646", "\u0626\u0649\u064A\u0648\u0644", "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A", "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631", "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631", "\u0646\u0648\u064A\u0627\u0628\u0649\u0631", "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"],
      wide: ["\u064A\u0627\u0646\u06CB\u0627\u0631", "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644", "\u0645\u0627\u0631\u062A", "\u0626\u0627\u067E\u0631\u0649\u0644", "\u0645\u0627\u064A", "\u0626\u0649\u064A\u06C7\u0646", "\u0626\u0649\u064A\u0648\u0644", "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A", "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631", "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631", "\u0646\u0648\u064A\u0627\u0628\u0649\u0631", "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"]
    };
    dayValues76 = {
      narrow: ["\u064A", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
      short: ["\u064A", "\u062F", "\u0633", "\u0686", "\u067E", "\u062C", "\u0634"],
      abbreviated: ["\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5", "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5", "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5", "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u062C\u06C8\u0645\u06D5", "\u0634\u06D5\u0646\u0628\u06D5"],
      wide: ["\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5", "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5", "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5", "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5", "\u062C\u06C8\u0645\u06D5", "\u0634\u06D5\u0646\u0628\u06D5"]
    };
    dayPeriodValues76 = {
      narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
      },
      abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
      },
      wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
      }
    };
    formattingDayPeriodValues61 = {
      narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
      },
      abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
      },
      wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
      }
    };
    ordinalNumber151 = function ordinalNumber152(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize76 = {
      ordinalNumber: ordinalNumber151,
      era: buildLocalizeFn({
        values: eraValues76,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues76,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback76(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues76,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues76,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues76,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues61,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default76 = localize76;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/_lib/match/index.js
var matchOrdinalNumberPattern75, parseOrdinalNumberPattern75, matchEraPatterns75, parseEraPatterns75, matchQuarterPatterns75, parseQuarterPatterns75, matchMonthPatterns75, parseMonthPatterns75, matchDayPatterns75, parseDayPatterns75, matchDayPeriodPatterns75, parseDayPeriodPatterns75, match75, match_default75;
var init_match75 = __esm({
  "../../node_modules/date-fns/esm/locale/ug/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern75 = /^(\d+)(th|st|nd|rd)?/i;
    parseOrdinalNumberPattern75 = /\d+/i;
    matchEraPatterns75 = {
      narrow: /^(ب|ك)/i,
      wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
    };
    parseEraPatterns75 = {
      any: [/^بۇرۇن/i, /^كىيىن/i]
    };
    matchQuarterPatterns75 = {
      narrow: /^[1234]/i,
      abbreviated: /^چ[1234]/i,
      wide: /^چارەك [1234]/i
    };
    parseQuarterPatterns75 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns75 = {
      // eslint-disable-next-line no-misleading-character-class
      narrow: /^[يفمئامئ‍ئاسۆند]/i,
      abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
      wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
    };
    parseMonthPatterns75 = {
      narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
      any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
    };
    matchDayPatterns75 = {
      narrow: /^[دسچپجشي]/i,
      short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
      abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
      wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
    };
    parseDayPatterns75 = {
      narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
      any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
    };
    matchDayPeriodPatterns75 = {
      narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
      any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
    };
    parseDayPeriodPatterns75 = {
      any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
      }
    };
    match75 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern75,
        parsePattern: parseOrdinalNumberPattern75,
        valueCallback: function valueCallback148(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns75,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns75,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns75,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns75,
        defaultParseWidth: "any",
        valueCallback: function valueCallback149(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns75,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns75,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns75,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns75,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns75,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns75,
        defaultParseWidth: "any"
      })
    };
    match_default75 = match75;
  }
});

// ../../node_modules/date-fns/esm/locale/ug/index.js
var locale86, ug_default;
var init_ug = __esm({
  "../../node_modules/date-fns/esm/locale/ug/index.js"() {
    "use strict";
    init_formatDistance77();
    init_formatLong84();
    init_formatRelative77();
    init_localize76();
    init_match75();
    locale86 = {
      code: "ug",
      formatDistance: formatDistance_default76,
      formatLong: formatLong_default84,
      formatRelative: formatRelative_default76,
      localize: localize_default76,
      match: match_default75,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    ug_default = locale86;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/_lib/formatDistance/index.js
function declension7(scheme, count) {
  if (scheme.one !== void 0 && count === 1) {
    return scheme.one;
  }
  var rem10 = count % 10;
  var rem100 = count % 100;
  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace("{{count}}", String(count));
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace("{{count}}", String(count));
  } else {
    return scheme.pluralGenitive.replace("{{count}}", String(count));
  }
}
function buildLocalizeTokenFn5(scheme) {
  return function(count, options) {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension7(scheme.future, count);
        } else {
          return "\u0437\u0430 " + declension7(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension7(scheme.past, count);
        } else {
          return declension7(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
        }
      }
    } else {
      return declension7(scheme.regular, count);
    }
  };
}
var halfAtMinute, formatDistanceLocale76, formatDistance154, formatDistance_default77;
var init_formatDistance78 = __esm({
  "../../node_modules/date-fns/esm/locale/uk/_lib/formatDistance/index.js"() {
    "use strict";
    halfAtMinute = function halfAtMinute2(_, options) {
      if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        } else {
          return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
        }
      }
      return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
    };
    formatDistanceLocale76 = {
      lessThanXSeconds: buildLocalizeTokenFn5({
        regular: {
          one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
          singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
          singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
          pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
          pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      xSeconds: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
          singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
          singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
          pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
          singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
          singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
          pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
      }),
      halfAMinute: halfAtMinute,
      lessThanXMinutes: buildLocalizeTokenFn5({
        regular: {
          one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
          singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
          singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
          pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
          one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
          singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
          singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
          pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
      }),
      xMinutes: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
          singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
          pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
          singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
          singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
          pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
          singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
          singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
          pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
      }),
      aboutXHours: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
          singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
          pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
      }),
      xHours: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
          singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
          pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
      }),
      xDays: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
          singularGenitive: "{{count}} \u0434\u043Di",
          pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
      }),
      aboutXWeeks: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
          singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
          pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
      }),
      xWeeks: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
          singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
          pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
      }),
      aboutXMonths: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
          singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
          pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
      }),
      xMonths: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
          singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
          pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
      }),
      aboutXYears: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
          singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
          pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
          singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
          singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
          pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
      }),
      xYears: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "{{count}} \u0440\u0456\u043A",
          singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
          pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
      }),
      overXYears: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
          singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
          pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
          singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
          singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
          pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
      }),
      almostXYears: buildLocalizeTokenFn5({
        regular: {
          singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
          singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
          pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
          singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
          singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
          pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
      })
    };
    formatDistance154 = function formatDistance155(token, count, options) {
      options = options || {};
      return formatDistanceLocale76[token](count, options);
    };
    formatDistance_default77 = formatDistance154;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/_lib/formatLong/index.js
var dateFormats85, timeFormats85, dateTimeFormats85, formatLong85, formatLong_default85;
var init_formatLong85 = __esm({
  "../../node_modules/date-fns/esm/locale/uk/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats85 = {
      full: "EEEE, do MMMM y '\u0440.'",
      long: "do MMMM y '\u0440.'",
      medium: "d MMM y '\u0440.'",
      short: "dd.MM.y"
    };
    timeFormats85 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats85 = {
      full: "{{date}} '\u043E' {{time}}",
      long: "{{date}} '\u043E' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    };
    formatLong85 = {
      date: buildFormatLongFn({
        formats: dateFormats85,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats85,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats85,
        defaultWidth: "full"
      })
    };
    formatLong_default85 = formatLong85;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/_lib/formatRelative/index.js
function lastWeek19(day) {
  var weekday = accusativeWeekdays8[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
  }
}
function thisWeek9(day) {
  var weekday = accusativeWeekdays8[day];
  return "'\u0443 " + weekday + " \u043E' p";
}
function nextWeek16(day) {
  var weekday = accusativeWeekdays8[day];
  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
    case 1:
    case 2:
    case 4:
      return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
  }
}
var accusativeWeekdays8, lastWeekFormat5, nextWeekFormat5, formatRelativeLocale77, formatRelative154, formatRelative_default77;
var init_formatRelative78 = __esm({
  "../../node_modules/date-fns/esm/locale/uk/_lib/formatRelative/index.js"() {
    "use strict";
    init_esm();
    init_isSameUTCWeek();
    accusativeWeekdays8 = ["\u043D\u0435\u0434\u0456\u043B\u044E", "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A", "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A", "\u0441\u0435\u0440\u0435\u0434\u0443", "\u0447\u0435\u0442\u0432\u0435\u0440", "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E", "\u0441\u0443\u0431\u043E\u0442\u0443"];
    lastWeekFormat5 = function lastWeekFormat6(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek9(day);
      } else {
        return lastWeek19(day);
      }
    };
    nextWeekFormat5 = function nextWeekFormat6(dirtyDate, baseDate, options) {
      var date = toDate(dirtyDate);
      var day = date.getUTCDay();
      if (isSameUTCWeek(date, baseDate, options)) {
        return thisWeek9(day);
      } else {
        return nextWeek16(day);
      }
    };
    formatRelativeLocale77 = {
      lastWeek: lastWeekFormat5,
      yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
      today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
      tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
      nextWeek: nextWeekFormat5,
      other: "P"
    };
    formatRelative154 = function formatRelative155(token, date, baseDate, options) {
      var format2 = formatRelativeLocale77[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default77 = formatRelative154;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/_lib/localize/index.js
var eraValues77, quarterValues77, monthValues77, formattingMonthValues18, dayValues77, dayPeriodValues77, formattingDayPeriodValues62, ordinalNumber153, localize77, localize_default77;
var init_localize77 = __esm({
  "../../node_modules/date-fns/esm/locale/uk/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues77 = {
      narrow: ["\u0434\u043E \u043D.\u0435.", "\u043D.\u0435."],
      abbreviated: ["\u0434\u043E \u043D. \u0435.", "\u043D. \u0435."],
      wide: ["\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438", "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"]
    };
    quarterValues77 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0439 \u043A\u0432.", "2-\u0439 \u043A\u0432.", "3-\u0439 \u043A\u0432.", "4-\u0439 \u043A\u0432."],
      wide: ["1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B", "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"]
    };
    monthValues77 = {
      // ДСТУ 3582:2013
      narrow: ["\u0421", "\u041B", "\u0411", "\u041A", "\u0422", "\u0427", "\u041B", "\u0421", "\u0412", "\u0416", "\u041B", "\u0413"],
      abbreviated: ["\u0441\u0456\u0447.", "\u043B\u044E\u0442.", "\u0431\u0435\u0440\u0435\u0437.", "\u043A\u0432\u0456\u0442.", "\u0442\u0440\u0430\u0432.", "\u0447\u0435\u0440\u0432.", "\u043B\u0438\u043F.", "\u0441\u0435\u0440\u043F.", "\u0432\u0435\u0440\u0435\u0441.", "\u0436\u043E\u0432\u0442.", "\u043B\u0438\u0441\u0442\u043E\u043F.", "\u0433\u0440\u0443\u0434."],
      wide: ["\u0441\u0456\u0447\u0435\u043D\u044C", "\u043B\u044E\u0442\u0438\u0439", "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C", "\u043A\u0432\u0456\u0442\u0435\u043D\u044C", "\u0442\u0440\u0430\u0432\u0435\u043D\u044C", "\u0447\u0435\u0440\u0432\u0435\u043D\u044C", "\u043B\u0438\u043F\u0435\u043D\u044C", "\u0441\u0435\u0440\u043F\u0435\u043D\u044C", "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C", "\u0436\u043E\u0432\u0442\u0435\u043D\u044C", "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434", "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"]
    };
    formattingMonthValues18 = {
      narrow: ["\u0421", "\u041B", "\u0411", "\u041A", "\u0422", "\u0427", "\u041B", "\u0421", "\u0412", "\u0416", "\u041B", "\u0413"],
      abbreviated: ["\u0441\u0456\u0447.", "\u043B\u044E\u0442.", "\u0431\u0435\u0440\u0435\u0437.", "\u043A\u0432\u0456\u0442.", "\u0442\u0440\u0430\u0432.", "\u0447\u0435\u0440\u0432.", "\u043B\u0438\u043F.", "\u0441\u0435\u0440\u043F.", "\u0432\u0435\u0440\u0435\u0441.", "\u0436\u043E\u0432\u0442.", "\u043B\u0438\u0441\u0442\u043E\u043F.", "\u0433\u0440\u0443\u0434."],
      wide: ["\u0441\u0456\u0447\u043D\u044F", "\u043B\u044E\u0442\u043E\u0433\u043E", "\u0431\u0435\u0440\u0435\u0437\u043D\u044F", "\u043A\u0432\u0456\u0442\u043D\u044F", "\u0442\u0440\u0430\u0432\u043D\u044F", "\u0447\u0435\u0440\u0432\u043D\u044F", "\u043B\u0438\u043F\u043D\u044F", "\u0441\u0435\u0440\u043F\u043D\u044F", "\u0432\u0435\u0440\u0435\u0441\u043D\u044F", "\u0436\u043E\u0432\u0442\u043D\u044F", "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430", "\u0433\u0440\u0443\u0434\u043D\u044F"]
    };
    dayValues77 = {
      narrow: ["\u041D", "\u041F", "\u0412", "\u0421", "\u0427", "\u041F", "\u0421"],
      short: ["\u043D\u0434", "\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431"],
      abbreviated: ["\u043D\u0435\u0434", "\u043F\u043E\u043D", "\u0432\u0456\u0432", "\u0441\u0435\u0440", "\u0447\u0442\u0432", "\u043F\u0442\u043D", "\u0441\u0443\u0431"],
      wide: ["\u043D\u0435\u0434\u0456\u043B\u044F", "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A", "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A", "\u0441\u0435\u0440\u0435\u0434\u0430", "\u0447\u0435\u0442\u0432\u0435\u0440", "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F", "\u0441\u0443\u0431\u043E\u0442\u0430"]
    };
    dayPeriodValues77 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
      }
    };
    formattingDayPeriodValues62 = {
      narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
      },
      abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
      },
      wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
      }
    };
    ordinalNumber153 = function ordinalNumber154(dirtyNumber, options) {
      var unit = String(options === null || options === void 0 ? void 0 : options.unit);
      var number = Number(dirtyNumber);
      var suffix;
      if (unit === "date") {
        if (number === 3 || number === 23) {
          suffix = "-\u0454";
        } else {
          suffix = "-\u0435";
        }
      } else if (unit === "minute" || unit === "second" || unit === "hour") {
        suffix = "-\u0430";
      } else {
        suffix = "-\u0439";
      }
      return number + suffix;
    };
    localize77 = {
      ordinalNumber: ordinalNumber153,
      era: buildLocalizeFn({
        values: eraValues77,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues77,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback77(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues77,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues18,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues77,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues77,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues62,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default77 = localize77;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/_lib/match/index.js
var matchOrdinalNumberPattern76, parseOrdinalNumberPattern76, matchEraPatterns76, parseEraPatterns76, matchQuarterPatterns76, parseQuarterPatterns76, matchMonthPatterns76, parseMonthPatterns76, matchDayPatterns76, parseDayPatterns76, matchDayPeriodPatterns76, parseDayPeriodPatterns76, match76, match_default76;
var init_match76 = __esm({
  "../../node_modules/date-fns/esm/locale/uk/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern76 = /^(\d+)(-?(е|й|є|а|я))?/i;
    parseOrdinalNumberPattern76 = /\d+/i;
    matchEraPatterns76 = {
      narrow: /^((до )?н\.?\s?е\.?)/i,
      abbreviated: /^((до )?н\.?\s?е\.?)/i,
      wide: /^(до нашої ери|нашої ери|наша ера)/i
    };
    parseEraPatterns76 = {
      any: [/^д/i, /^н/i]
    };
    matchQuarterPatterns76 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
      wide: /^[1234](-?[иі]?й?)? квартал/i
    };
    parseQuarterPatterns76 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns76 = {
      narrow: /^[слбктчвжг]/i,
      abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
      wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
    };
    parseMonthPatterns76 = {
      narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
      any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
    };
    matchDayPatterns76 = {
      narrow: /^[нпвсч]/i,
      short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
      abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
      wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
    };
    parseDayPatterns76 = {
      narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
      any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
    };
    matchDayPeriodPatterns76 = {
      narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
      abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
      wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
    };
    parseDayPeriodPatterns76 = {
      any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
      }
    };
    match76 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern76,
        parsePattern: parseOrdinalNumberPattern76,
        valueCallback: function valueCallback150(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns76,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns76,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns76,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns76,
        defaultParseWidth: "any",
        valueCallback: function valueCallback151(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns76,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns76,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns76,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns76,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns76,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns76,
        defaultParseWidth: "any"
      })
    };
    match_default76 = match76;
  }
});

// ../../node_modules/date-fns/esm/locale/uk/index.js
var locale87, uk_default;
var init_uk = __esm({
  "../../node_modules/date-fns/esm/locale/uk/index.js"() {
    "use strict";
    init_formatDistance78();
    init_formatLong85();
    init_formatRelative78();
    init_localize77();
    init_match76();
    locale87 = {
      code: "uk",
      formatDistance: formatDistance_default77,
      formatLong: formatLong_default85,
      formatRelative: formatRelative_default77,
      localize: localize_default77,
      match: match_default76,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    uk_default = locale87;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/_lib/formatDistance/index.js
var formatDistanceLocale77, formatDistance156, formatDistance_default78;
var init_formatDistance79 = __esm({
  "../../node_modules/date-fns/esm/locale/uz/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale77 = {
      lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
      },
      xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
      },
      halfAMinute: "yarim minut",
      lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
      },
      xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
      },
      aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
      },
      xHours: {
        one: "1 soat",
        other: "{{count}} soat"
      },
      xDays: {
        one: "1 kun",
        other: "{{count}} kun"
      },
      aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
      },
      xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
      },
      aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
      },
      xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
      },
      aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
      },
      xYears: {
        one: "1 yil",
        other: "{{count}} yil"
      },
      overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
      },
      almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
      }
    };
    formatDistance156 = function formatDistance157(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale77[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " dan keyin";
        } else {
          return result + " oldin";
        }
      }
      return result;
    };
    formatDistance_default78 = formatDistance156;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/_lib/formatLong/index.js
var dateFormats86, timeFormats86, dateTimeFormats86, formatLong86, formatLong_default86;
var init_formatLong86 = __esm({
  "../../node_modules/date-fns/esm/locale/uz/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats86 = {
      full: "EEEE, do MMMM, y",
      long: "do MMMM, y",
      medium: "d MMM, y",
      short: "dd/MM/yyyy"
    };
    timeFormats86 = {
      full: "h:mm:ss zzzz",
      long: "h:mm:ss z",
      medium: "h:mm:ss",
      short: "h:mm"
    };
    dateTimeFormats86 = {
      any: "{{date}}, {{time}}"
    };
    formatLong86 = {
      date: buildFormatLongFn({
        formats: dateFormats86,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats86,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats86,
        defaultWidth: "any"
      })
    };
    formatLong_default86 = formatLong86;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/_lib/formatRelative/index.js
var formatRelativeLocale78, formatRelative156, formatRelative_default78;
var init_formatRelative79 = __esm({
  "../../node_modules/date-fns/esm/locale/uz/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale78 = {
      lastWeek: "'oldingi' eeee p 'da'",
      yesterday: "'kecha' p 'da'",
      today: "'bugun' p 'da'",
      tomorrow: "'ertaga' p 'da'",
      nextWeek: "eeee p 'da'",
      other: "P"
    };
    formatRelative156 = function formatRelative157(token, _date, _baseDate, _options) {
      return formatRelativeLocale78[token];
    };
    formatRelative_default78 = formatRelative156;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/_lib/localize/index.js
var eraValues78, quarterValues78, monthValues78, dayValues78, dayPeriodValues78, formattingDayPeriodValues63, ordinalNumber155, localize78, localize_default78;
var init_localize78 = __esm({
  "../../node_modules/date-fns/esm/locale/uz/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues78 = {
      narrow: ["M.A", "M."],
      abbreviated: ["M.A", "M."],
      wide: ["Miloddan Avvalgi", "Milodiy"]
    };
    quarterValues78 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
      wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
    };
    monthValues78 = {
      narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
      abbreviated: ["Yan", "Fev", "Mar", "Apr", "May", "Iyun", "Iyul", "Avg", "Sen", "Okt", "Noy", "Dek"],
      wide: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avgust", "Sentabr", "Oktabr", "Noyabr", "Dekabr"]
    };
    dayValues78 = {
      narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
      short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
      abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
      wide: ["Yakshanba", "Dushanba", "Seshanba", "Chorshanba", "Payshanba", "Juma", "Shanba"]
    };
    dayPeriodValues78 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      }
    };
    formattingDayPeriodValues63 = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
      }
    };
    ordinalNumber155 = function ordinalNumber156(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize78 = {
      ordinalNumber: ordinalNumber155,
      era: buildLocalizeFn({
        values: eraValues78,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues78,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback78(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues78,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues78,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues78,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues63,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default78 = localize78;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/_lib/match/index.js
var matchOrdinalNumberPattern77, parseOrdinalNumberPattern77, matchEraPatterns77, parseEraPatterns77, matchQuarterPatterns77, parseQuarterPatterns77, matchMonthPatterns77, parseMonthPatterns77, matchDayPatterns77, parseDayPatterns77, matchDayPeriodPatterns77, parseDayPeriodPatterns77, match77, match_default77;
var init_match77 = __esm({
  "../../node_modules/date-fns/esm/locale/uz/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern77 = /^(\d+)(chi)?/i;
    parseOrdinalNumberPattern77 = /\d+/i;
    matchEraPatterns77 = {
      narrow: /^(m\.a|m\.)/i,
      abbreviated: /^(m\.a\.?\s?m\.?)/i,
      wide: /^(miloddan avval|miloddan keyin)/i
    };
    parseEraPatterns77 = {
      any: [/^b/i, /^(a|c)/i]
    };
    matchQuarterPatterns77 = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](chi)? chorak/i
    };
    parseQuarterPatterns77 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns77 = {
      narrow: /^[yfmasond]/i,
      abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
      wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
    };
    parseMonthPatterns77 = {
      narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
    };
    matchDayPatterns77 = {
      narrow: /^[ydschj]/i,
      short: /^(ya|du|se|cho|pa|ju|sha)/i,
      abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
      wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
    };
    parseDayPatterns77 = {
      narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
      any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
    };
    matchDayPeriodPatterns77 = {
      narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
      any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
    };
    parseDayPeriodPatterns77 = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
      }
    };
    match77 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern77,
        parsePattern: parseOrdinalNumberPattern77,
        valueCallback: function valueCallback152(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns77,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns77,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns77,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns77,
        defaultParseWidth: "any",
        valueCallback: function valueCallback153(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns77,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns77,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns77,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns77,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns77,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns77,
        defaultParseWidth: "any"
      })
    };
    match_default77 = match77;
  }
});

// ../../node_modules/date-fns/esm/locale/uz/index.js
var locale88, uz_default;
var init_uz = __esm({
  "../../node_modules/date-fns/esm/locale/uz/index.js"() {
    "use strict";
    init_formatDistance79();
    init_formatLong86();
    init_formatRelative79();
    init_localize78();
    init_match77();
    locale88 = {
      code: "uz",
      formatDistance: formatDistance_default78,
      formatLong: formatLong_default86,
      formatRelative: formatRelative_default78,
      localize: localize_default78,
      match: match_default77,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    uz_default = locale88;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatDistance/index.js
var formatDistanceLocale78, formatDistance158, formatDistance_default79;
var init_formatDistance80 = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale78 = {
      lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
      },
      xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
      },
      halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
      lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
      },
      xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
      },
      aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
      },
      xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
      },
      xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
      },
      aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
      },
      xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
      },
      aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
      },
      xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
      },
      aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
      },
      xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
      },
      overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
      },
      almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
      }
    };
    formatDistance158 = function formatDistance159(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale78[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        } else {
          return result + " \u043E\u043B\u0434\u0438\u043D";
        }
      }
      return result;
    };
    formatDistance_default79 = formatDistance158;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatLong/index.js
var dateFormats87, timeFormats87, dateTimeFormats87, formatLong87, formatLong_default87;
var init_formatLong87 = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats87 = {
      full: "EEEE, do MMMM, y",
      long: "do MMMM, y",
      medium: "d MMM, y",
      short: "dd/MM/yyyy"
    };
    timeFormats87 = {
      full: "H:mm:ss zzzz",
      long: "H:mm:ss z",
      medium: "H:mm:ss",
      short: "H:mm"
    };
    dateTimeFormats87 = {
      any: "{{date}}, {{time}}"
    };
    formatLong87 = {
      date: buildFormatLongFn({
        formats: dateFormats87,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats87,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats87,
        defaultWidth: "any"
      })
    };
    formatLong_default87 = formatLong87;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatRelative/index.js
var formatRelativeLocale79, formatRelative158, formatRelative_default79;
var init_formatRelative80 = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale79 = {
      lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
      yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
      today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
      tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
      nextWeek: "eeee p '\u0434\u0430'",
      other: "P"
    };
    formatRelative158 = function formatRelative159(token, _date, _baseDate, _options) {
      return formatRelativeLocale79[token];
    };
    formatRelative_default79 = formatRelative158;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/localize/index.js
var eraValues79, quarterValues79, monthValues79, dayValues79, dayPeriodValues79, formattingDayPeriodValues64, ordinalNumber157, localize79, localize_default79;
var init_localize79 = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues79 = {
      narrow: ["\u041C.\u0410", "\u041C"],
      abbreviated: ["\u041C.\u0410", "\u041C"],
      wide: ["\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438", "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"]
    };
    quarterValues79 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["1-\u0447\u043E\u0440.", "2-\u0447\u043E\u0440.", "3-\u0447\u043E\u0440.", "4-\u0447\u043E\u0440."],
      wide: ["1-\u0447\u043E\u0440\u0430\u043A", "2-\u0447\u043E\u0440\u0430\u043A", "3-\u0447\u043E\u0440\u0430\u043A", "4-\u0447\u043E\u0440\u0430\u043A"]
    };
    monthValues79 = {
      narrow: ["\u042F", "\u0424", "\u041C", "\u0410", "\u041C", "\u0418", "\u0418", "\u0410", "\u0421", "\u041E", "\u041D", "\u0414"],
      abbreviated: ["\u044F\u043D\u0432", "\u0444\u0435\u0432", "\u043C\u0430\u0440", "\u0430\u043F\u0440", "\u043C\u0430\u0439", "\u0438\u044E\u043D", "\u0438\u044E\u043B", "\u0430\u0432\u0433", "\u0441\u0435\u043D", "\u043E\u043A\u0442", "\u043D\u043E\u044F", "\u0434\u0435\u043A"],
      wide: ["\u044F\u043D\u0432\u0430\u0440", "\u0444\u0435\u0432\u0440\u0430\u043B", "\u043C\u0430\u0440\u0442", "\u0430\u043F\u0440\u0435\u043B", "\u043C\u0430\u0439", "\u0438\u044E\u043D", "\u0438\u044E\u043B", "\u0430\u0432\u0433\u0443\u0441\u0442", "\u0441\u0435\u043D\u0442\u0430\u0431\u0440", "\u043E\u043A\u0442\u0430\u0431\u0440", "\u043D\u043E\u044F\u0431\u0440", "\u0434\u0435\u043A\u0430\u0431\u0440"]
    };
    dayValues79 = {
      narrow: ["\u042F", "\u0414", "\u0421", "\u0427", "\u041F", "\u0416", "\u0428"],
      short: ["\u044F\u043A", "\u0434\u0443", "\u0441\u0435", "\u0447\u043E", "\u043F\u0430", "\u0436\u0443", "\u0448\u0430"],
      abbreviated: ["\u044F\u043A\u0448", "\u0434\u0443\u0448", "\u0441\u0435\u0448", "\u0447\u043E\u0440", "\u043F\u0430\u0439", "\u0436\u0443\u043C", "\u0448\u0430\u043D"],
      wide: ["\u044F\u043A\u0448\u0430\u043D\u0431\u0430", "\u0434\u0443\u0448\u0430\u043D\u0431\u0430", "\u0441\u0435\u0448\u0430\u043D\u0431\u0430", "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430", "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430", "\u0436\u0443\u043C\u0430", "\u0448\u0430\u043D\u0431\u0430"]
    };
    dayPeriodValues79 = {
      any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
      }
    };
    formattingDayPeriodValues64 = {
      any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
      }
    };
    ordinalNumber157 = function ordinalNumber158(dirtyNumber, _options) {
      return String(dirtyNumber);
    };
    localize79 = {
      ordinalNumber: ordinalNumber157,
      era: buildLocalizeFn({
        values: eraValues79,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues79,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback79(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues79,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues79,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues79,
        defaultWidth: "any",
        formattingValues: formattingDayPeriodValues64,
        defaultFormattingWidth: "any"
      })
    };
    localize_default79 = localize79;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/match/index.js
var matchOrdinalNumberPattern78, parseOrdinalNumberPattern78, matchEraPatterns78, parseEraPatterns78, matchQuarterPatterns78, parseQuarterPatterns78, matchMonthPatterns78, parseMonthPatterns78, matchDayPatterns78, parseDayPatterns78, matchDayPeriodPatterns78, parseDayPeriodPatterns78, match78, match_default78;
var init_match78 = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern78 = /^(\d+)(чи)?/i;
    parseOrdinalNumberPattern78 = /\d+/i;
    matchEraPatterns78 = {
      narrow: /^(м\.а|м\.)/i,
      abbreviated: /^(м\.а|м\.)/i,
      wide: /^(милоддан аввал|милоддан кейин)/i
    };
    parseEraPatterns78 = {
      any: [/^м/i, /^а/i]
    };
    matchQuarterPatterns78 = {
      narrow: /^[1234]/i,
      abbreviated: /^[1234]-чор./i,
      wide: /^[1234]-чорак/i
    };
    parseQuarterPatterns78 = {
      any: [/1/i, /2/i, /3/i, /4/i]
    };
    matchMonthPatterns78 = {
      narrow: /^[яфмамииасонд]/i,
      abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
      wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
    };
    parseMonthPatterns78 = {
      narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^д/i],
      any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
    };
    matchDayPatterns78 = {
      narrow: /^[ядсчпжш]/i,
      short: /^(як|ду|се|чо|па|жу|ша)/i,
      abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
      wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
    };
    parseDayPatterns78 = {
      narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
      any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
    };
    matchDayPeriodPatterns78 = {
      any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
    };
    parseDayPeriodPatterns78 = {
      any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
      }
    };
    match78 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern78,
        parsePattern: parseOrdinalNumberPattern78,
        valueCallback: function valueCallback154(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns78,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns78,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns78,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns78,
        defaultParseWidth: "any",
        valueCallback: function valueCallback155(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns78,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns78,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns78,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns78,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns78,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns78,
        defaultParseWidth: "any"
      })
    };
    match_default78 = match78;
  }
});

// ../../node_modules/date-fns/esm/locale/uz-Cyrl/index.js
var locale89, uz_Cyrl_default;
var init_uz_Cyrl = __esm({
  "../../node_modules/date-fns/esm/locale/uz-Cyrl/index.js"() {
    "use strict";
    init_formatDistance80();
    init_formatLong87();
    init_formatRelative80();
    init_localize79();
    init_match78();
    locale89 = {
      code: "uz-Cyrl",
      formatDistance: formatDistance_default79,
      formatLong: formatLong_default87,
      formatRelative: formatRelative_default79,
      localize: localize_default79,
      match: match_default78,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
      }
    };
    uz_Cyrl_default = locale89;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/_lib/formatDistance/index.js
var formatDistanceLocale79, formatDistance160, formatDistance_default80;
var init_formatDistance81 = __esm({
  "../../node_modules/date-fns/esm/locale/vi/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale79 = {
      lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xE2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xE2y"
      },
      xSeconds: {
        one: "1 gi\xE2y",
        other: "{{count}} gi\xE2y"
      },
      halfAMinute: "n\u1EEDa ph\xFAt",
      lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xFAt",
        other: "d\u01B0\u1EDBi {{count}} ph\xFAt"
      },
      xMinutes: {
        one: "1 ph\xFAt",
        other: "{{count}} ph\xFAt"
      },
      aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
      },
      xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
      },
      xDays: {
        one: "1 ng\xE0y",
        other: "{{count}} ng\xE0y"
      },
      aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
      },
      xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
      },
      aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xE1ng",
        other: "kho\u1EA3ng {{count}} th\xE1ng"
      },
      xMonths: {
        one: "1 th\xE1ng",
        other: "{{count}} th\xE1ng"
      },
      aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
      },
      xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
      },
      overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
      },
      almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
      }
    };
    formatDistance160 = function formatDistance161(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale79[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + " n\u1EEFa";
        } else {
          return result + " tr\u01B0\u1EDBc";
        }
      }
      return result;
    };
    formatDistance_default80 = formatDistance160;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/_lib/formatLong/index.js
var dateFormats88, timeFormats88, dateTimeFormats88, formatLong88, formatLong_default88;
var init_formatLong88 = __esm({
  "../../node_modules/date-fns/esm/locale/vi/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats88 = {
      // thứ Sáu, ngày 25 tháng 08 năm 2017
      full: "EEEE, 'ng\xE0y' d MMMM 'n\u0103m' y",
      // ngày 25 tháng 08 năm 2017
      long: "'ng\xE0y' d MMMM 'n\u0103m' y",
      // 25 thg 08 năm 2017
      medium: "d MMM 'n\u0103m' y",
      // 25/08/2017
      short: "dd/MM/y"
    };
    timeFormats88 = {
      full: "HH:mm:ss zzzz",
      long: "HH:mm:ss z",
      medium: "HH:mm:ss",
      short: "HH:mm"
    };
    dateTimeFormats88 = {
      // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
      full: "{{date}} {{time}}",
      // ngày 25 tháng 08 năm 2017 23:25
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong88 = {
      date: buildFormatLongFn({
        formats: dateFormats88,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats88,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats88,
        defaultWidth: "full"
      })
    };
    formatLong_default88 = formatLong88;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/_lib/formatRelative/index.js
var formatRelativeLocale80, formatRelative160, formatRelative_default80;
var init_formatRelative81 = __esm({
  "../../node_modules/date-fns/esm/locale/vi/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale80 = {
      lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xE0o l\xFAc' p",
      yesterday: "'h\xF4m qua v\xE0o l\xFAc' p",
      today: "'h\xF4m nay v\xE0o l\xFAc' p",
      tomorrow: "'ng\xE0y mai v\xE0o l\xFAc' p",
      nextWeek: "eeee 't\u1EDBi v\xE0o l\xFAc' p",
      other: "P"
    };
    formatRelative160 = function formatRelative161(token, _date, _baseDate, _options) {
      return formatRelativeLocale80[token];
    };
    formatRelative_default80 = formatRelative160;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/_lib/localize/index.js
var eraValues80, quarterValues80, formattingQuarterValues4, monthValues80, formattingMonthValues19, dayValues80, dayPeriodValues80, formattingDayPeriodValues65, ordinalNumber159, localize80, localize_default80;
var init_localize80 = __esm({
  "../../node_modules/date-fns/esm/locale/vi/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues80 = {
      narrow: ["TCN", "SCN"],
      abbreviated: ["tr\u01B0\u1EDBc CN", "sau CN"],
      wide: ["tr\u01B0\u1EDBc C\xF4ng Nguy\xEAn", "sau C\xF4ng Nguy\xEAn"]
    };
    quarterValues80 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["Qu\xFD 1", "Qu\xFD 2", "Qu\xFD 3", "Qu\xFD 4"]
    };
    formattingQuarterValues4 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      // I notice many news outlet use this "quý II/2018"
      wide: ["qu\xFD I", "qu\xFD II", "qu\xFD III", "qu\xFD IV"]
    };
    monthValues80 = {
      narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      abbreviated: ["Thg 1", "Thg 2", "Thg 3", "Thg 4", "Thg 5", "Thg 6", "Thg 7", "Thg 8", "Thg 9", "Thg 10", "Thg 11", "Thg 12"],
      wide: ["Th\xE1ng M\u1ED9t", "Th\xE1ng Hai", "Th\xE1ng Ba", "Th\xE1ng T\u01B0", "Th\xE1ng N\u0103m", "Th\xE1ng S\xE1u", "Th\xE1ng B\u1EA3y", "Th\xE1ng T\xE1m", "Th\xE1ng Ch\xEDn", "Th\xE1ng M\u01B0\u1EDDi", "Th\xE1ng M\u01B0\u1EDDi M\u1ED9t", "Th\xE1ng M\u01B0\u1EDDi Hai"]
    };
    formattingMonthValues19 = {
      narrow: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      abbreviated: ["thg 1", "thg 2", "thg 3", "thg 4", "thg 5", "thg 6", "thg 7", "thg 8", "thg 9", "thg 10", "thg 11", "thg 12"],
      wide: ["th\xE1ng 01", "th\xE1ng 02", "th\xE1ng 03", "th\xE1ng 04", "th\xE1ng 05", "th\xE1ng 06", "th\xE1ng 07", "th\xE1ng 08", "th\xE1ng 09", "th\xE1ng 10", "th\xE1ng 11", "th\xE1ng 12"]
    };
    dayValues80 = {
      narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
      short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
      abbreviated: ["CN", "Th\u1EE9 2", "Th\u1EE9 3", "Th\u1EE9 4", "Th\u1EE9 5", "Th\u1EE9 6", "Th\u1EE9 7"],
      wide: ["Ch\u1EE7 Nh\u1EADt", "Th\u1EE9 Hai", "Th\u1EE9 Ba", "Th\u1EE9 T\u01B0", "Th\u1EE9 N\u0103m", "Th\u1EE9 S\xE1u", "Th\u1EE9 B\u1EA3y"]
    };
    dayPeriodValues80 = {
      // narrow date period is extremely rare in Vietnamese
      // I used abbreviated form for noon, morning and afternoon
      // which are regconizable by Vietnamese, others cannot be any shorter
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xEAm"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "tr\u01B0a",
        morning: "s\xE1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xEAm"
      },
      wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "tr\u01B0a",
        morning: "s\xE1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xEAm"
      }
    };
    formattingDayPeriodValues65 = {
      narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xEAm"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "tr\u01B0a",
        morning: "s\xE1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xEAm"
      },
      wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xEAm",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xE0o bu\u1ED5i s\xE1ng",
        afternoon: "v\xE0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xE0o bu\u1ED5i t\u1ED1i",
        night: "v\xE0o ban \u0111\xEAm"
      }
    };
    ordinalNumber159 = function ordinalNumber160(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      var unit = options === null || options === void 0 ? void 0 : options.unit;
      if (unit === "quarter") {
        switch (number) {
          case 1:
            return "I";
          case 2:
            return "II";
          case 3:
            return "III";
          case 4:
            return "IV";
        }
      } else if (unit === "day") {
        switch (number) {
          case 1:
            return "th\u1EE9 2";
          // meaning 2nd day but it's the first day of the week :D
          case 2:
            return "th\u1EE9 3";
          // meaning 3rd day
          case 3:
            return "th\u1EE9 4";
          // meaning 4th day and so on
          case 4:
            return "th\u1EE9 5";
          case 5:
            return "th\u1EE9 6";
          case 6:
            return "th\u1EE9 7";
          case 7:
            return "ch\u1EE7 nh\u1EADt";
        }
      } else if (unit === "week") {
        if (number === 1) {
          return "th\u1EE9 nh\u1EA5t";
        } else {
          return "th\u1EE9 " + number;
        }
      } else if (unit === "dayOfYear") {
        if (number === 1) {
          return "\u0111\u1EA7u ti\xEAn";
        } else {
          return "th\u1EE9 " + number;
        }
      }
      return String(number);
    };
    localize80 = {
      ordinalNumber: ordinalNumber159,
      era: buildLocalizeFn({
        values: eraValues80,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues80,
        defaultWidth: "wide",
        formattingValues: formattingQuarterValues4,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback80(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues80,
        defaultWidth: "wide",
        formattingValues: formattingMonthValues19,
        defaultFormattingWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues80,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues80,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues65,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default80 = localize80;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/_lib/match/index.js
var matchOrdinalNumberPattern79, parseOrdinalNumberPattern79, matchEraPatterns79, parseEraPatterns79, matchQuarterPatterns79, parseQuarterPatterns79, matchMonthPatterns79, parseMonthPatterns79, matchDayPatterns79, parseDayPatterns79, matchDayPeriodPatterns79, parseDayPeriodPatterns79, match79, match_default79;
var init_match79 = __esm({
  "../../node_modules/date-fns/esm/locale/vi/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern79 = /^(\d+)/i;
    parseOrdinalNumberPattern79 = /\d+/i;
    matchEraPatterns79 = {
      narrow: /^(tcn|scn)/i,
      abbreviated: /^(trước CN|sau CN)/i,
      wide: /^(trước Công Nguyên|sau Công Nguyên)/i
    };
    parseEraPatterns79 = {
      any: [/^t/i, /^s/i]
    };
    matchQuarterPatterns79 = {
      narrow: /^([1234]|i{1,3}v?)/i,
      abbreviated: /^q([1234]|i{1,3}v?)/i,
      wide: /^quý ([1234]|i{1,3}v?)/i
    };
    parseQuarterPatterns79 = {
      any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
    };
    matchMonthPatterns79 = {
      // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
      // note the order of '1' since it is a sub-string of '10', so must be lower priority
      narrow: /^(0?[2-9]|10|11|12|0?1)/i,
      // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
      abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
      // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
      wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
    };
    parseMonthPatterns79 = {
      narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
      abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
      wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
    };
    matchDayPatterns79 = {
      narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
      short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
      abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
      wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
    };
    parseDayPatterns79 = {
      narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
      short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
      abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
      wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
    };
    matchDayPeriodPatterns79 = {
      narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
      abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
      wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
    };
    parseDayPeriodPatterns79 = {
      any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
      }
    };
    match79 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern79,
        parsePattern: parseOrdinalNumberPattern79,
        valueCallback: function valueCallback156(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns79,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns79,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns79,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns79,
        defaultParseWidth: "any",
        valueCallback: function valueCallback157(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns79,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns79,
        defaultParseWidth: "wide"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns79,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns79,
        defaultParseWidth: "wide"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns79,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPeriodPatterns79,
        defaultParseWidth: "any"
      })
    };
    match_default79 = match79;
  }
});

// ../../node_modules/date-fns/esm/locale/vi/index.js
var locale90, vi_default;
var init_vi = __esm({
  "../../node_modules/date-fns/esm/locale/vi/index.js"() {
    "use strict";
    init_formatDistance81();
    init_formatLong88();
    init_formatRelative81();
    init_localize80();
    init_match79();
    locale90 = {
      code: "vi",
      formatDistance: formatDistance_default80,
      formatLong: formatLong_default88,
      formatRelative: formatRelative_default80,
      localize: localize_default80,
      match: match_default79,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
        /* First week of new year contains Jan 1st  */
      }
    };
    vi_default = locale90;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatDistance/index.js
var formatDistanceLocale80, formatDistance162, formatDistance_default81;
var init_formatDistance82 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale80 = {
      lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
      },
      xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
      },
      halfAMinute: "\u534A\u5206\u949F",
      lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
      },
      xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
      },
      xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
      },
      aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
      },
      xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
      },
      aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
      },
      xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
      },
      aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
      },
      xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
      },
      aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
      },
      xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
      },
      overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
      },
      almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
      }
    };
    formatDistance162 = function formatDistance163(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale80[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u5185";
        } else {
          return result + "\u524D";
        }
      }
      return result;
    };
    formatDistance_default81 = formatDistance162;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatLong/index.js
var dateFormats89, timeFormats89, dateTimeFormats89, formatLong89, formatLong_default89;
var init_formatLong89 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats89 = {
      full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
      long: "y'\u5E74'M'\u6708'd'\u65E5'",
      medium: "yyyy-MM-dd",
      short: "yy-MM-dd"
    };
    timeFormats89 = {
      full: "zzzz a h:mm:ss",
      long: "z a h:mm:ss",
      medium: "a h:mm:ss",
      short: "a h:mm"
    };
    dateTimeFormats89 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong89 = {
      date: buildFormatLongFn({
        formats: dateFormats89,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats89,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats89,
        defaultWidth: "full"
      })
    };
    formatLong_default89 = formatLong89;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatRelative/index.js
function checkWeek(date, baseDate, options) {
  var baseFormat = "eeee p";
  if (isSameUTCWeek(date, baseDate, options)) {
    return baseFormat;
  } else if (date.getTime() > baseDate.getTime()) {
    return "'\u4E0B\u4E2A'" + baseFormat;
  }
  return "'\u4E0A\u4E2A'" + baseFormat;
}
var formatRelativeLocale81, formatRelative162, formatRelative_default81;
var init_formatRelative82 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/_lib/formatRelative/index.js"() {
    "use strict";
    init_isSameUTCWeek();
    formatRelativeLocale81 = {
      lastWeek: checkWeek,
      // days before yesterday, maybe in this week or last week
      yesterday: "'\u6628\u5929' p",
      today: "'\u4ECA\u5929' p",
      tomorrow: "'\u660E\u5929' p",
      nextWeek: checkWeek,
      // days after tomorrow, maybe in this week or next week
      other: "PP p"
    };
    formatRelative162 = function formatRelative163(token, date, baseDate, options) {
      var format2 = formatRelativeLocale81[token];
      if (typeof format2 === "function") {
        return format2(date, baseDate, options);
      }
      return format2;
    };
    formatRelative_default81 = formatRelative162;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/_lib/localize/index.js
var eraValues81, quarterValues81, monthValues81, dayValues81, dayPeriodValues81, formattingDayPeriodValues66, ordinalNumber161, localize81, localize_default81;
var init_localize81 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues81 = {
      narrow: ["\u524D", "\u516C\u5143"],
      abbreviated: ["\u524D", "\u516C\u5143"],
      wide: ["\u516C\u5143\u524D", "\u516C\u5143"]
    };
    quarterValues81 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u7B2C\u4E00\u5B63", "\u7B2C\u4E8C\u5B63", "\u7B2C\u4E09\u5B63", "\u7B2C\u56DB\u5B63"],
      wide: ["\u7B2C\u4E00\u5B63\u5EA6", "\u7B2C\u4E8C\u5B63\u5EA6", "\u7B2C\u4E09\u5B63\u5EA6", "\u7B2C\u56DB\u5B63\u5EA6"]
    };
    monthValues81 = {
      narrow: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"],
      abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
      wide: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"]
    };
    dayValues81 = {
      narrow: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      short: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      abbreviated: ["\u5468\u65E5", "\u5468\u4E00", "\u5468\u4E8C", "\u5468\u4E09", "\u5468\u56DB", "\u5468\u4E94", "\u5468\u516D"],
      wide: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"]
    };
    dayPeriodValues81 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
      }
    };
    formattingDayPeriodValues66 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
      }
    };
    ordinalNumber161 = function ordinalNumber162(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      switch (options === null || options === void 0 ? void 0 : options.unit) {
        case "date":
          return number.toString() + "\u65E5";
        case "hour":
          return number.toString() + "\u65F6";
        case "minute":
          return number.toString() + "\u5206";
        case "second":
          return number.toString() + "\u79D2";
        default:
          return "\u7B2C " + number.toString();
      }
    };
    localize81 = {
      ordinalNumber: ordinalNumber161,
      era: buildLocalizeFn({
        values: eraValues81,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues81,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback81(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues81,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues81,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues81,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues66,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default81 = localize81;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/_lib/match/index.js
var matchOrdinalNumberPattern80, parseOrdinalNumberPattern80, matchEraPatterns80, parseEraPatterns80, matchQuarterPatterns80, parseQuarterPatterns80, matchMonthPatterns80, parseMonthPatterns80, matchDayPatterns80, parseDayPatterns80, matchDayPeriodPatterns80, parseDayPeriodPatterns80, match80, match_default80;
var init_match80 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern80 = /^(第\s*)?\d+(日|时|分|秒)?/i;
    parseOrdinalNumberPattern80 = /\d+/i;
    matchEraPatterns80 = {
      narrow: /^(前)/i,
      abbreviated: /^(前)/i,
      wide: /^(公元前|公元)/i
    };
    parseEraPatterns80 = {
      any: [/^(前)/i, /^(公元)/i]
    };
    matchQuarterPatterns80 = {
      narrow: /^[1234]/i,
      abbreviated: /^第[一二三四]刻/i,
      wide: /^第[一二三四]刻钟/i
    };
    parseQuarterPatterns80 = {
      any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
    };
    matchMonthPatterns80 = {
      narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
      abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
      wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
    };
    parseMonthPatterns80 = {
      narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
      any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
    };
    matchDayPatterns80 = {
      narrow: /^[一二三四五六日]/i,
      short: /^[一二三四五六日]/i,
      abbreviated: /^周[一二三四五六日]/i,
      wide: /^星期[一二三四五六日]/i
    };
    parseDayPatterns80 = {
      any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
    };
    matchDayPeriodPatterns80 = {
      any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
    };
    parseDayPeriodPatterns80 = {
      any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
      }
    };
    match80 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern80,
        parsePattern: parseOrdinalNumberPattern80,
        valueCallback: function valueCallback158(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns80,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns80,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns80,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns80,
        defaultParseWidth: "any",
        valueCallback: function valueCallback159(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns80,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns80,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns80,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns80,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns80,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns80,
        defaultParseWidth: "any"
      })
    };
    match_default80 = match80;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-CN/index.js
var locale91, zh_CN_default;
var init_zh_CN = __esm({
  "../../node_modules/date-fns/esm/locale/zh-CN/index.js"() {
    "use strict";
    init_formatDistance82();
    init_formatLong89();
    init_formatRelative82();
    init_localize81();
    init_match80();
    locale91 = {
      code: "zh-CN",
      formatDistance: formatDistance_default81,
      formatLong: formatLong_default89,
      formatRelative: formatRelative_default81,
      localize: localize_default81,
      match: match_default80,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    zh_CN_default = locale91;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatDistance/index.js
var formatDistanceLocale81, formatDistance164, formatDistance_default82;
var init_formatDistance83 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale81 = {
      lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
      },
      xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
      },
      halfAMinute: "\u534A\u5206\u9418",
      lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
      },
      xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
      },
      xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
      },
      aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
      },
      xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
      },
      aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
      },
      xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
      },
      aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
      },
      xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
      },
      aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
      },
      xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
      },
      overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
      },
      almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
      }
    };
    formatDistance164 = function formatDistance165(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale81[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u5167";
        } else {
          return result + "\u524D";
        }
      }
      return result;
    };
    formatDistance_default82 = formatDistance164;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatLong/index.js
var dateFormats90, timeFormats90, dateTimeFormats90, formatLong90, formatLong_default90;
var init_formatLong90 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats90 = {
      full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
      long: "y'\u5E74'M'\u6708'd'\u65E5'",
      medium: "yyyy-MM-dd",
      short: "yy-MM-dd"
    };
    timeFormats90 = {
      full: "zzzz a h:mm:ss",
      long: "z a h:mm:ss",
      medium: "a h:mm:ss",
      short: "a h:mm"
    };
    dateTimeFormats90 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong90 = {
      date: buildFormatLongFn({
        formats: dateFormats90,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats90,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats90,
        defaultWidth: "full"
      })
    };
    formatLong_default90 = formatLong90;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatRelative/index.js
var formatRelativeLocale82, formatRelative164, formatRelative_default82;
var init_formatRelative83 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale82 = {
      lastWeek: "'\u4E0A\u500B'eeee p",
      yesterday: "'\u6628\u5929' p",
      today: "'\u4ECA\u5929' p",
      tomorrow: "'\u660E\u5929' p",
      nextWeek: "'\u4E0B\u500B'eeee p",
      other: "P"
    };
    formatRelative164 = function formatRelative165(token, _date, _baseDate, _options) {
      return formatRelativeLocale82[token];
    };
    formatRelative_default82 = formatRelative164;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/_lib/localize/index.js
var eraValues82, quarterValues82, monthValues82, dayValues82, dayPeriodValues82, formattingDayPeriodValues67, ordinalNumber163, localize82, localize_default82;
var init_localize82 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues82 = {
      narrow: ["\u524D", "\u516C\u5143"],
      abbreviated: ["\u524D", "\u516C\u5143"],
      wide: ["\u516C\u5143\u524D", "\u516C\u5143"]
    };
    quarterValues82 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u7B2C\u4E00\u5B63", "\u7B2C\u4E8C\u5B63", "\u7B2C\u4E09\u5B63", "\u7B2C\u56DB\u5B63"],
      wide: ["\u7B2C\u4E00\u5B63\u5EA6", "\u7B2C\u4E8C\u5B63\u5EA6", "\u7B2C\u4E09\u5B63\u5EA6", "\u7B2C\u56DB\u5B63\u5EA6"]
    };
    monthValues82 = {
      narrow: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"],
      abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
      wide: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"]
    };
    dayValues82 = {
      narrow: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      short: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      abbreviated: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"],
      wide: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"]
    };
    dayPeriodValues82 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
      }
    };
    formattingDayPeriodValues67 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
      }
    };
    ordinalNumber163 = function ordinalNumber164(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      switch (options === null || options === void 0 ? void 0 : options.unit) {
        case "date":
          return number + "\u65E5";
        case "hour":
          return number + "\u6642";
        case "minute":
          return number + "\u5206";
        case "second":
          return number + "\u79D2";
        default:
          return "\u7B2C " + number;
      }
    };
    localize82 = {
      ordinalNumber: ordinalNumber163,
      era: buildLocalizeFn({
        values: eraValues82,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues82,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback82(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues82,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues82,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues82,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues67,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default82 = localize82;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/_lib/match/index.js
var matchOrdinalNumberPattern81, parseOrdinalNumberPattern81, matchEraPatterns81, parseEraPatterns81, matchQuarterPatterns81, parseQuarterPatterns81, matchMonthPatterns81, parseMonthPatterns81, matchDayPatterns81, parseDayPatterns81, matchDayPeriodPatterns81, parseDayPeriodPatterns81, match81, match_default81;
var init_match81 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern81 = /^(第\s*)?\d+(日|時|分|秒)?/i;
    parseOrdinalNumberPattern81 = /\d+/i;
    matchEraPatterns81 = {
      narrow: /^(前)/i,
      abbreviated: /^(前)/i,
      wide: /^(公元前|公元)/i
    };
    parseEraPatterns81 = {
      any: [/^(前)/i, /^(公元)/i]
    };
    matchQuarterPatterns81 = {
      narrow: /^[1234]/i,
      abbreviated: /^第[一二三四]季/i,
      wide: /^第[一二三四]季度/i
    };
    parseQuarterPatterns81 = {
      any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
    };
    matchMonthPatterns81 = {
      narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
      abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
      wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
    };
    parseMonthPatterns81 = {
      narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
      any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
    };
    matchDayPatterns81 = {
      narrow: /^[一二三四五六日]/i,
      short: /^[一二三四五六日]/i,
      abbreviated: /^週[一二三四五六日]/i,
      wide: /^星期[一二三四五六日]/i
    };
    parseDayPatterns81 = {
      any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
    };
    matchDayPeriodPatterns81 = {
      any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
    };
    parseDayPeriodPatterns81 = {
      any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
      }
    };
    match81 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern81,
        parsePattern: parseOrdinalNumberPattern81,
        valueCallback: function valueCallback160(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns81,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns81,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns81,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns81,
        defaultParseWidth: "any",
        valueCallback: function valueCallback161(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns81,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns81,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns81,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns81,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns81,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns81,
        defaultParseWidth: "any"
      })
    };
    match_default81 = match81;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-HK/index.js
var locale92, zh_HK_default;
var init_zh_HK = __esm({
  "../../node_modules/date-fns/esm/locale/zh-HK/index.js"() {
    "use strict";
    init_formatDistance83();
    init_formatLong90();
    init_formatRelative83();
    init_localize82();
    init_match81();
    locale92 = {
      code: "zh-HK",
      formatDistance: formatDistance_default82,
      formatLong: formatLong_default90,
      formatRelative: formatRelative_default82,
      localize: localize_default82,
      match: match_default81,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    };
    zh_HK_default = locale92;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatDistance/index.js
var formatDistanceLocale82, formatDistance166, formatDistance_default83;
var init_formatDistance84 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatDistance/index.js"() {
    "use strict";
    formatDistanceLocale82 = {
      lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
      },
      xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
      },
      halfAMinute: "\u534A\u5206\u9418",
      lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
      },
      xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
      },
      xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
      },
      aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
      },
      xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
      },
      aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
      },
      xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
      },
      aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
      },
      xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
      },
      aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
      },
      xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
      },
      overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
      },
      almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
      }
    };
    formatDistance166 = function formatDistance167(token, count, options) {
      var result;
      var tokenValue = formatDistanceLocale82[token];
      if (typeof tokenValue === "string") {
        result = tokenValue;
      } else if (count === 1) {
        result = tokenValue.one;
      } else {
        result = tokenValue.other.replace("{{count}}", String(count));
      }
      if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
          return result + "\u5167";
        } else {
          return result + "\u524D";
        }
      }
      return result;
    };
    formatDistance_default83 = formatDistance166;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatLong/index.js
var dateFormats91, timeFormats91, dateTimeFormats91, formatLong91, formatLong_default91;
var init_formatLong91 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatLong/index.js"() {
    "use strict";
    init_buildFormatLongFn();
    dateFormats91 = {
      full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
      long: "y'\u5E74'M'\u6708'd'\u65E5'",
      medium: "yyyy-MM-dd",
      short: "yy-MM-dd"
    };
    timeFormats91 = {
      full: "zzzz a h:mm:ss",
      long: "z a h:mm:ss",
      medium: "a h:mm:ss",
      short: "a h:mm"
    };
    dateTimeFormats91 = {
      full: "{{date}} {{time}}",
      long: "{{date}} {{time}}",
      medium: "{{date}} {{time}}",
      short: "{{date}} {{time}}"
    };
    formatLong91 = {
      date: buildFormatLongFn({
        formats: dateFormats91,
        defaultWidth: "full"
      }),
      time: buildFormatLongFn({
        formats: timeFormats91,
        defaultWidth: "full"
      }),
      dateTime: buildFormatLongFn({
        formats: dateTimeFormats91,
        defaultWidth: "full"
      })
    };
    formatLong_default91 = formatLong91;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatRelative/index.js
var formatRelativeLocale83, formatRelative166, formatRelative_default83;
var init_formatRelative84 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/_lib/formatRelative/index.js"() {
    "use strict";
    formatRelativeLocale83 = {
      lastWeek: "'\u4E0A\u500B'eeee p",
      yesterday: "'\u6628\u5929' p",
      today: "'\u4ECA\u5929' p",
      tomorrow: "'\u660E\u5929' p",
      nextWeek: "'\u4E0B\u500B'eeee p",
      other: "P"
    };
    formatRelative166 = function formatRelative167(token, _date, _baseDate, _options) {
      return formatRelativeLocale83[token];
    };
    formatRelative_default83 = formatRelative166;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/_lib/localize/index.js
var eraValues83, quarterValues83, monthValues83, dayValues83, dayPeriodValues83, formattingDayPeriodValues68, ordinalNumber165, localize83, localize_default83;
var init_localize83 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/_lib/localize/index.js"() {
    "use strict";
    init_buildLocalizeFn();
    eraValues83 = {
      narrow: ["\u524D", "\u516C\u5143"],
      abbreviated: ["\u524D", "\u516C\u5143"],
      wide: ["\u516C\u5143\u524D", "\u516C\u5143"]
    };
    quarterValues83 = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["\u7B2C\u4E00\u523B", "\u7B2C\u4E8C\u523B", "\u7B2C\u4E09\u523B", "\u7B2C\u56DB\u523B"],
      wide: ["\u7B2C\u4E00\u523B\u9418", "\u7B2C\u4E8C\u523B\u9418", "\u7B2C\u4E09\u523B\u9418", "\u7B2C\u56DB\u523B\u9418"]
    };
    monthValues83 = {
      narrow: ["\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D", "\u4E03", "\u516B", "\u4E5D", "\u5341", "\u5341\u4E00", "\u5341\u4E8C"],
      abbreviated: ["1\u6708", "2\u6708", "3\u6708", "4\u6708", "5\u6708", "6\u6708", "7\u6708", "8\u6708", "9\u6708", "10\u6708", "11\u6708", "12\u6708"],
      wide: ["\u4E00\u6708", "\u4E8C\u6708", "\u4E09\u6708", "\u56DB\u6708", "\u4E94\u6708", "\u516D\u6708", "\u4E03\u6708", "\u516B\u6708", "\u4E5D\u6708", "\u5341\u6708", "\u5341\u4E00\u6708", "\u5341\u4E8C\u6708"]
    };
    dayValues83 = {
      narrow: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      short: ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"],
      abbreviated: ["\u9031\u65E5", "\u9031\u4E00", "\u9031\u4E8C", "\u9031\u4E09", "\u9031\u56DB", "\u9031\u4E94", "\u9031\u516D"],
      wide: ["\u661F\u671F\u65E5", "\u661F\u671F\u4E00", "\u661F\u671F\u4E8C", "\u661F\u671F\u4E09", "\u661F\u671F\u56DB", "\u661F\u671F\u4E94", "\u661F\u671F\u516D"]
    };
    dayPeriodValues83 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
      }
    };
    formattingDayPeriodValues68 = {
      narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
      },
      abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
      },
      wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
      }
    };
    ordinalNumber165 = function ordinalNumber166(dirtyNumber, options) {
      var number = Number(dirtyNumber);
      switch (options === null || options === void 0 ? void 0 : options.unit) {
        case "date":
          return number + "\u65E5";
        case "hour":
          return number + "\u6642";
        case "minute":
          return number + "\u5206";
        case "second":
          return number + "\u79D2";
        default:
          return "\u7B2C " + number;
      }
    };
    localize83 = {
      ordinalNumber: ordinalNumber165,
      era: buildLocalizeFn({
        values: eraValues83,
        defaultWidth: "wide"
      }),
      quarter: buildLocalizeFn({
        values: quarterValues83,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback83(quarter) {
          return quarter - 1;
        }
      }),
      month: buildLocalizeFn({
        values: monthValues83,
        defaultWidth: "wide"
      }),
      day: buildLocalizeFn({
        values: dayValues83,
        defaultWidth: "wide"
      }),
      dayPeriod: buildLocalizeFn({
        values: dayPeriodValues83,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues68,
        defaultFormattingWidth: "wide"
      })
    };
    localize_default83 = localize83;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/_lib/match/index.js
var matchOrdinalNumberPattern82, parseOrdinalNumberPattern82, matchEraPatterns82, parseEraPatterns82, matchQuarterPatterns82, parseQuarterPatterns82, matchMonthPatterns82, parseMonthPatterns82, matchDayPatterns82, parseDayPatterns82, matchDayPeriodPatterns82, parseDayPeriodPatterns82, match82, match_default82;
var init_match82 = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/_lib/match/index.js"() {
    "use strict";
    init_buildMatchFn();
    init_buildMatchPatternFn();
    matchOrdinalNumberPattern82 = /^(第\s*)?\d+(日|時|分|秒)?/i;
    parseOrdinalNumberPattern82 = /\d+/i;
    matchEraPatterns82 = {
      narrow: /^(前)/i,
      abbreviated: /^(前)/i,
      wide: /^(公元前|公元)/i
    };
    parseEraPatterns82 = {
      any: [/^(前)/i, /^(公元)/i]
    };
    matchQuarterPatterns82 = {
      narrow: /^[1234]/i,
      abbreviated: /^第[一二三四]刻/i,
      wide: /^第[一二三四]刻鐘/i
    };
    parseQuarterPatterns82 = {
      any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
    };
    matchMonthPatterns82 = {
      narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
      abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
      wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
    };
    parseMonthPatterns82 = {
      narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
      any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
    };
    matchDayPatterns82 = {
      narrow: /^[一二三四五六日]/i,
      short: /^[一二三四五六日]/i,
      abbreviated: /^週[一二三四五六日]/i,
      wide: /^星期[一二三四五六日]/i
    };
    parseDayPatterns82 = {
      any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
    };
    matchDayPeriodPatterns82 = {
      any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
    };
    parseDayPeriodPatterns82 = {
      any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
      }
    };
    match82 = {
      ordinalNumber: buildMatchPatternFn({
        matchPattern: matchOrdinalNumberPattern82,
        parsePattern: parseOrdinalNumberPattern82,
        valueCallback: function valueCallback162(value) {
          return parseInt(value, 10);
        }
      }),
      era: buildMatchFn({
        matchPatterns: matchEraPatterns82,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns82,
        defaultParseWidth: "any"
      }),
      quarter: buildMatchFn({
        matchPatterns: matchQuarterPatterns82,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns82,
        defaultParseWidth: "any",
        valueCallback: function valueCallback163(index) {
          return index + 1;
        }
      }),
      month: buildMatchFn({
        matchPatterns: matchMonthPatterns82,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns82,
        defaultParseWidth: "any"
      }),
      day: buildMatchFn({
        matchPatterns: matchDayPatterns82,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns82,
        defaultParseWidth: "any"
      }),
      dayPeriod: buildMatchFn({
        matchPatterns: matchDayPeriodPatterns82,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns82,
        defaultParseWidth: "any"
      })
    };
    match_default82 = match82;
  }
});

// ../../node_modules/date-fns/esm/locale/zh-TW/index.js
var locale93, zh_TW_default;
var init_zh_TW = __esm({
  "../../node_modules/date-fns/esm/locale/zh-TW/index.js"() {
    "use strict";
    init_formatDistance84();
    init_formatLong91();
    init_formatRelative84();
    init_localize83();
    init_match82();
    locale93 = {
      code: "zh-TW",
      formatDistance: formatDistance_default83,
      formatLong: formatLong_default91,
      formatRelative: formatRelative_default83,
      localize: localize_default83,
      match: match_default82,
      options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
      }
    };
    zh_TW_default = locale93;
  }
});

// ../../node_modules/date-fns/esm/locale/index.js
var locale_exports = {};
__export(locale_exports, {
  af: () => af_default,
  ar: () => ar_default,
  arDZ: () => ar_DZ_default,
  arEG: () => ar_EG_default,
  arMA: () => ar_MA_default,
  arSA: () => ar_SA_default,
  arTN: () => ar_TN_default,
  az: () => az_default,
  be: () => be_default,
  beTarask: () => be_tarask_default,
  bg: () => bg_default,
  bn: () => bn_default,
  bs: () => bs_default,
  ca: () => ca_default,
  cs: () => cs_default,
  cy: () => cy_default,
  da: () => da_default,
  de: () => de_default,
  deAT: () => de_AT_default,
  el: () => el_default,
  enAU: () => en_AU_default,
  enCA: () => en_CA_default,
  enGB: () => en_GB_default,
  enIE: () => en_IE_default,
  enIN: () => en_IN_default,
  enNZ: () => en_NZ_default,
  enUS: () => en_US_default,
  enZA: () => en_ZA_default,
  eo: () => eo_default,
  es: () => es_default,
  et: () => et_default,
  eu: () => eu_default,
  faIR: () => fa_IR_default,
  fi: () => fi_default,
  fr: () => fr_default,
  frCA: () => fr_CA_default,
  frCH: () => fr_CH_default,
  fy: () => fy_default,
  gd: () => gd_default,
  gl: () => gl_default,
  gu: () => gu_default,
  he: () => he_default,
  hi: () => hi_default,
  hr: () => hr_default,
  ht: () => ht_default,
  hu: () => hu_default,
  hy: () => hy_default,
  id: () => id_default,
  is: () => is_default,
  it: () => it_default,
  itCH: () => it_CH_default,
  ja: () => ja_default,
  jaHira: () => ja_Hira_default,
  ka: () => ka_default,
  kk: () => kk_default,
  km: () => km_default,
  kn: () => kn_default,
  ko: () => ko_default,
  lb: () => lb_default,
  lt: () => lt_default,
  lv: () => lv_default,
  mk: () => mk_default,
  mn: () => mn_default,
  ms: () => ms_default,
  mt: () => mt_default,
  nb: () => nb_default,
  nl: () => nl_default,
  nlBE: () => nl_BE_default,
  nn: () => nn_default,
  oc: () => oc_default,
  pl: () => pl_default,
  pt: () => pt_default,
  ptBR: () => pt_BR_default,
  ro: () => ro_default,
  ru: () => ru_default,
  sk: () => sk_default,
  sl: () => sl_default,
  sq: () => sq_default,
  sr: () => sr_default,
  srLatn: () => sr_Latn_default,
  sv: () => sv_default,
  ta: () => ta_default,
  te: () => te_default,
  th: () => th_default,
  tr: () => tr_default,
  ug: () => ug_default,
  uk: () => uk_default,
  uz: () => uz_default,
  uzCyrl: () => uz_Cyrl_default,
  vi: () => vi_default,
  zhCN: () => zh_CN_default,
  zhHK: () => zh_HK_default,
  zhTW: () => zh_TW_default
});
var init_locale = __esm({
  "../../node_modules/date-fns/esm/locale/index.js"() {
    "use strict";
    init_af();
    init_ar();
    init_ar_DZ();
    init_ar_EG();
    init_ar_MA();
    init_ar_SA();
    init_ar_TN();
    init_az();
    init_be();
    init_be_tarask();
    init_bg();
    init_bn();
    init_bs();
    init_ca();
    init_cs();
    init_cy();
    init_da();
    init_de();
    init_de_AT();
    init_el();
    init_en_AU();
    init_en_CA();
    init_en_GB();
    init_en_IE();
    init_en_IN();
    init_en_NZ();
    init_en_US();
    init_en_ZA();
    init_eo();
    init_es();
    init_et();
    init_eu();
    init_fa_IR();
    init_fi();
    init_fr();
    init_fr_CA();
    init_fr_CH();
    init_fy();
    init_gd();
    init_gl();
    init_gu();
    init_he();
    init_hi();
    init_hr();
    init_ht();
    init_hu();
    init_hy();
    init_id();
    init_is();
    init_it();
    init_it_CH();
    init_ja();
    init_ja_Hira();
    init_ka();
    init_kk();
    init_km();
    init_kn();
    init_ko();
    init_lb();
    init_lt();
    init_lv();
    init_mk();
    init_mn();
    init_ms();
    init_mt();
    init_nb();
    init_nl();
    init_nl_BE();
    init_nn();
    init_oc();
    init_pl();
    init_pt();
    init_pt_BR();
    init_ro();
    init_ru();
    init_sk();
    init_sl();
    init_sq();
    init_sr();
    init_sr_Latn();
    init_sv();
    init_ta();
    init_te();
    init_th();
    init_tr();
    init_ug();
    init_uk();
    init_uz();
    init_uz_Cyrl();
    init_vi();
    init_zh_CN();
    init_zh_HK();
    init_zh_TW();
  }
});

// ../utils/dist/index.js
var require_dist3 = __commonJS({
  "../utils/dist/index.js"(exports2, module2) {
    "use strict";
    var __defProp2 = Object.defineProperty;
    var __getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
    var __getOwnPropNames2 = Object.getOwnPropertyNames;
    var __hasOwnProp2 = Object.prototype.hasOwnProperty;
    var __export2 = (target, all) => {
      for (var name in all)
        __defProp2(target, name, { get: all[name], enumerable: true });
    };
    var __copyProps2 = (to, from, except, desc) => {
      if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames2(from))
          if (!__hasOwnProp2.call(to, key) && key !== except)
            __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc2(from, key)) || desc.enumerable });
      }
      return to;
    };
    var __toCommonJS2 = (mod) => __copyProps2(__defProp2({}, "__esModule", { value: true }), mod);
    var utils_exports = {};
    __export2(utils_exports, {
      CALENDAR_INVITE_METHODS: () => CALENDAR_INVITE_METHODS,
      LIST_STATE_RESOURCES: () => LIST_STATE_RESOURCES,
      LIST_STATE_SNAPSHOT_VERSION: () => LIST_STATE_SNAPSHOT_VERSION,
      MAX_SPELLABLE_AMOUNT: () => MAX_SPELLABLE_AMOUNT,
      SCROLL_CONTAINER_ATTRIBUTE: () => SCROLL_CONTAINER_ATTRIBUTE,
      aggregatedToFlattenDamage: () => aggregatedToFlattenDamage,
      buildCalendarInvite: () => buildCalendarInvite,
      buildGoogleMapsUrl: () => buildGoogleMapsUrl,
      buildOrderName: () => buildOrderName,
      buildProductLabel: () => buildProductLabel,
      buildScheduleCalendarUid: () => buildScheduleCalendarUid,
      buildThemeToken: () => buildThemeToken,
      buildUserAcronym: () => buildUserAcronym,
      buildUserDisplayName: () => buildUserDisplayName,
      buildUserFullName: () => buildUserFullName,
      buildVehicleLabel: () => buildVehicleLabel2,
      calculateVerificationNumber: () => calculateVerificationNumber3,
      capitalizeFirstLetter: () => capitalizeFirstLetter,
      clearAllListStateSnapshots: () => clearAllListStateSnapshots,
      clearListStateSnapshot: () => clearListStateSnapshot,
      composeAddress: () => composeAddress,
      composePersonAddress: () => composePersonAddress,
      currencyFormat: () => currencyFormat,
      customFormatDistance: () => customFormatDistance,
      dateInTimeZonePatterns: () => dateInTimeZonePatterns,
      dayHourToDate: () => dayHourToDate,
      delay: () => delay,
      detectDecimalAmountFormat: () => detectDecimalAmountFormat,
      escapeCsvFormula: () => escapeCsvFormula,
      extractTimeSegments: () => extractTimeSegments,
      filterDocumentsByVisibility: () => filterDocumentsByVisibility,
      findPolicyholderVehicleDamage: () => findPolicyholderVehicleDamage,
      findServicedVehicleDamage: () => findServicedVehicleDamage,
      findStateLabel: () => findStateLabel2,
      findThirdPartyVehicleDamage: () => findThirdPartyVehicleDamage,
      formatCurrencyAmount: () => formatCurrencyAmount3,
      formatDateInTimeZone: () => formatDateInTimeZone3,
      formatDistance: () => formatDistance168,
      formatDurationMs: () => formatDurationMs,
      formatPlaceAddress: () => formatPlaceAddress,
      formatTaxPercent: () => formatTaxPercent3,
      getAgeByDateBirth: () => getAgeByDateBirth,
      getClaimKachFormat: () => getClaimKachFormat,
      getCountryLabel: () => getCountryLabel,
      getCountryStates: () => getCountryStates,
      getCurrencyCodeFromCountry: () => getCurrencyCodeFromCountry,
      getHumanFileSize: () => getHumanFileSize,
      getInitialsFromUser: () => getInitialsFromUser,
      getLastItem: () => getLastItem,
      getListStateSnapshot: () => getListStateSnapshot,
      getPiramidSinisterFormatFromKach: () => getPiramidSinisterFormatFromKach,
      getScrollContainer: () => getScrollContainer,
      getSinisterKachFormat: () => getSinisterKachFormat,
      getStateLabel: () => getStateLabel,
      groupByTyped: () => groupByTyped,
      hasDamagesCombination: () => hasDamagesCombination,
      haversineMeters: () => haversineMeters,
      idCardReadSources: () => idCardReadSources,
      isMinorAt: () => isMinorAt,
      isSafeInternalHref: () => isSafeInternalHref,
      isSpellableCurrency: () => isSpellableCurrency3,
      listStateResourceSchema: () => listStateResourceSchema,
      listStateSnapshotSchema: () => listStateSnapshotSchema,
      localeDateFormat: () => localeDateFormat,
      lowercaseFirstLetter: () => lowercaseFirstLetter2,
      minorities: () => minorities2,
      nativeEnumToArray: () => nativeEnumToArray,
      normalizeArgentineDocumentNumber: () => normalizeArgentineDocumentNumber,
      normalizeArgentinePersonalNumber: () => normalizeArgentinePersonalNumber,
      normalizeFilename: () => normalizeFilename,
      normalizeVariableName: () => normalizeVariableName4,
      numberToSpanishWords: () => numberToSpanishWords4,
      parseArgentineIdCardBarcode: () => parseArgentineIdCardBarcode,
      parseArgentineIdCardMrz: () => parseArgentineIdCardMrz,
      parseDecimalAmount: () => parseDecimalAmount,
      parseInvitedEmail: () => parseInvitedEmail,
      readInvitedEmail: () => readInvitedEmail,
      resolveClaimSinisterNumber: () => resolveClaimSinisterNumber,
      resolveKachDamageCategory: () => resolveKachDamageCategory,
      resolveKachSinisterType: () => resolveKachSinisterType,
      resolveMinority: () => resolveMinority2,
      resolveServicedLicensePlate: () => resolveServicedLicensePlate,
      resolveSinisterKachSinisterType: () => resolveSinisterKachSinisterType,
      setListStateSnapshot: () => setListStateSnapshot,
      slugify: () => slugify2,
      sortListAlphabetically: () => sortListAlphabetically,
      spellableCurrencies: () => spellableCurrencies,
      stringToRegex: () => stringToRegex,
      toTitleCase: () => toTitleCase,
      tryGetClaimKachFormat: () => tryGetClaimKachFormat,
      tryGetPiramidSinisterFormatFromKach: () => tryGetPiramidSinisterFormatFromKach,
      tryGetSinisterKachFormat: () => tryGetSinisterKachFormat,
      uniqueArrayItems: () => uniqueArrayItems,
      utc2utc3: () => utc2utc3
    });
    module2.exports = __toCommonJS2(utils_exports);
    var extractTimeSegments = (time) => {
      const [hour, minute] = time.split(":");
      return {
        hour: Number(hour),
        minute: Number(minute)
      };
    };
    var formatDurationMs = (ms, fallback = "-") => {
      if (ms == null || ms < 0) return fallback;
      const totalSeconds = Math.round(ms / 1e3);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor(totalSeconds % 3600 / 60);
      const seconds = totalSeconds % 60;
      const paddedSeconds = seconds.toString().padStart(2, "0");
      if (!hours) return `${minutes}:${paddedSeconds}`;
      return `${hours}:${minutes.toString().padStart(2, "0")}:${paddedSeconds}`;
    };
    var import_date_fns4 = (init_esm(), __toCommonJS(esm_exports));
    var getAgeByDateBirth = (dateOfBirth) => (0, import_date_fns4.differenceInYears)(/* @__PURE__ */ new Date(), new Date(dateOfBirth));
    var N14_REGEX = /^(\d{3})-(\d{2})-(\d{7})-(\d{2})$/;
    var N14_SINISTER_REGEX = /^\d{3}-\d{2}-\d{7}$/;
    var KACH_REGEX = /^\d{2}\/\d{2}\/\d{6}$/;
    function getSinisterKachFormat(sinisterNumber) {
      const match83 = sinisterNumber.match(N14_REGEX);
      if (!match83) {
        throw new Error(
          "Invalid sinister number format. Expected XXX-XX-XXXXXXX-XX with numbers."
        );
      }
      const [, agency, ramo, sinister] = match83;
      const result = `${agency.slice(-2)}/${ramo}/${sinister.slice(-6)}`;
      if (!KACH_REGEX.test(result)) {
        throw new Error(
          "Resulting format does not match traditional kach format AA/BB/CCCCCC."
        );
      }
      return result;
    }
    function tryGetSinisterKachFormat(sinisterNumber) {
      if (!sinisterNumber) return void 0;
      try {
        return getSinisterKachFormat(sinisterNumber);
      } catch {
        return void 0;
      }
    }
    function getPiramidSinisterFormatFromKach(kachSinister) {
      if (!KACH_REGEX.test(kachSinister)) {
        throw new Error(
          "Invalid kach sinister format. Expected AA/BB/CCCCCC with numbers."
        );
      }
      const [agency3, ramo, sinister7] = kachSinister.split("/");
      const result = `${agency3.padStart(3, "0")}-${ramo}-${sinister7.padStart(
        7,
        "0"
      )}`;
      if (!N14_SINISTER_REGEX.test(result)) {
        throw new Error(
          "Resulting format does not match N14 sinister prefix XXX-XX-XXXXXXX."
        );
      }
      return result;
    }
    function tryGetPiramidSinisterFormatFromKach(kachSinister) {
      if (!kachSinister) return void 0;
      try {
        return getPiramidSinisterFormatFromKach(kachSinister);
      } catch {
        return void 0;
      }
    }
    var CLAIM_KACH_REGEX = /^\d{2}-\d{2}-\d{6}-\d{2}$/;
    function getClaimKachFormat(claimNumber) {
      const match83 = claimNumber.match(N14_REGEX);
      if (!match83) {
        throw new Error(
          "Invalid claim number format. Expected XXX-XX-XXXXXXX-XX with numbers."
        );
      }
      const [, agency3, ramo, sinister7, claim2] = match83;
      const result = `${agency3.slice(-2)}-${ramo}-${sinister7.slice(
        -6
      )}-${claim2}`;
      if (!CLAIM_KACH_REGEX.test(result)) {
        throw new Error(
          "Resulting format does not match kach gateway format AA-BB-CCCCCC-DD."
        );
      }
      return result;
    }
    function tryGetClaimKachFormat(claimNumber) {
      if (!claimNumber) return void 0;
      try {
        return getClaimKachFormat(claimNumber);
      } catch {
        return void 0;
      }
    }
    var import_piramid_constants98 = require_dist2();
    var resolveKachDamageCategory = (damageTypes) => {
      const hasMaterial = damageTypes.includes("material");
      const hasPerson = damageTypes.includes("person");
      if (hasMaterial && hasPerson) return "combined";
      if (hasMaterial) return "material";
      if (hasPerson) return "person";
      return null;
    };
    var resolveKachSinisterType = (damageTypes) => {
      const category = resolveKachDamageCategory(damageTypes);
      return category ? import_piramid_constants98.KACH_SINISTER_TYPE_BY_DAMAGE_CATEGORY[category] : null;
    };
    var isLinkedToComplaint = (claim) => !!claim.selected_external_complaint_id || !!claim.selected_pending_complaint_id || !!claim.external_claim_id;
    var resolveSinisterKachSinisterType = (claims) => resolveKachSinisterType(
      claims.filter(
        (claim) => isLinkedToComplaint(claim) && (0, import_piramid_constants98.isActiveFraudDerivationClaim)(claim)
      ).flatMap(
        (claim) => {
          var _a;
          return ((_a = claim.claim_type) == null ? void 0 : _a.damages.map((damage2) => damage2.damage_type)) ?? [];
        }
      )
    );
    var import_piramid_constants210 = require_dist2();
    var getCountryLabel = (country) => {
      var _a;
      return (_a = import_piramid_constants210.countryAndStates.find((c2) => c2.code === country)) == null ? void 0 : _a.name;
    };
    var getHumanFileSize = (bytes, si = false, dp = 1) => {
      const thresh = si ? 1e3 : 1024;
      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }
      const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
      let u2 = -1;
      const r = 10 ** dp;
      do {
        bytes /= thresh;
        ++u2;
      } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u2 < units.length - 1);
      return bytes.toFixed(dp) + " " + units[u2];
    };
    var getInitialsFromUser = (user) => [user.first_name, user.last_name].map((name) => name == null ? void 0 : name.charAt(0).toUpperCase()).filter(Boolean).join("");
    var getLastItem = (array = []) => {
      if (!array) {
        return;
      }
      if (!array.length) {
        return;
      }
      return array[array.length - 1];
    };
    var import_piramid_constants310 = require_dist2();
    var getStateLabel = (country, state) => {
      var _a;
      return (_a = import_piramid_constants310.countryAndStates.find((c2) => c2.code === country).states.find((s3) => s3.code === state)) == null ? void 0 : _a.name;
    };
    var delay = (ms = 500) => new Promise((resolve) => setTimeout(resolve, ms));
    function buildThemeToken(theme) {
      return `theme-${theme.color_theme}-${theme == null ? void 0 : theme.mode}`;
    }
    var import_piramid_constants410 = require_dist2();
    var aggregatedToFlattenDamage = (damages) => {
      const flattenTypes = [];
      for (const damage2 of damages) {
        if (damage2.type !== "person") {
          flattenTypes.push(damage2.type);
        } else {
          flattenTypes.push(damage2.person.type);
        }
      }
      return flattenTypes;
    };
    var hasDamagesCombination = (candidateCombination, selectedCombination, strict = true) => {
      const predicate = (candidateSegment, selectedSegment) => candidateSegment.type === import_piramid_constants410.flattenDamageTypeToParentType[selectedSegment] && (candidateSegment.subtypes ? candidateSegment.subtypes.includes(selectedSegment) : true);
      if (strict)
        return candidateCombination.length === selectedCombination.length && candidateCombination.every(
          (candidateSegment) => selectedCombination.some(
            (selectedSegment) => predicate(candidateSegment, selectedSegment)
          )
        );
      return selectedCombination.every(
        (selectedSegment) => candidateCombination.some(
          (candidateSegment) => predicate(candidateSegment, selectedSegment)
        )
      );
    };
    var isVehicleDamage = (damage2) => {
      var _a;
      return damage2.type === "material" && ((_a = damage2.material) == null ? void 0 : _a.type) === "vehicle" && !!damage2.material.vehicle;
    };
    var normalizeLicensePlate = (plate) => (plate == null ? void 0 : plate.replace(/\s/g, "").toUpperCase()) || null;
    var findVehicleDamageByOwnership = (damages, ownership) => damages.find(
      (damage2) => {
        var _a, _b, _c;
        return isVehicleDamage(damage2) && ((_c = (_b = (_a = damage2.material) == null ? void 0 : _a.vehicle) == null ? void 0 : _b.driver) == null ? void 0 : _c.ownership) === ownership;
      }
    );
    var findPolicyholderVehicleDamage = (damages) => findVehicleDamageByOwnership(damages, "owner");
    var findThirdPartyVehicleDamage = (damages) => findVehicleDamageByOwnership(damages, "third");
    var findServicedVehicleDamage = (damages, policyholderLicensePlate) => {
      const vehicleDamages = damages.filter(isVehicleDamage);
      const policyholderPlate = normalizeLicensePlate(policyholderLicensePlate);
      const byPlate = policyholderPlate ? vehicleDamages.find(
        (damage2) => {
          var _a, _b;
          return normalizeLicensePlate((_b = (_a = damage2.material) == null ? void 0 : _a.vehicle) == null ? void 0 : _b.license_plate) === policyholderPlate;
        }
      ) : void 0;
      const [firstVehicleDamage] = vehicleDamages;
      return byPlate ?? findVehicleDamageByOwnership(vehicleDamages, "owner") ?? firstVehicleDamage;
    };
    var resolveServicedLicensePlate = (damages, policyholderLicensePlate) => {
      var _a, _b, _c;
      return ((_c = (_b = (_a = findServicedVehicleDamage(damages, policyholderLicensePlate)) == null ? void 0 : _a.material) == null ? void 0 : _b.vehicle) == null ? void 0 : _c.license_plate) ?? policyholderLicensePlate ?? null;
    };
    var buildVehicleLabel2 = (vehicle) => [vehicle == null ? void 0 : vehicle.make, vehicle == null ? void 0 : vehicle.model, vehicle == null ? void 0 : vehicle.version, vehicle == null ? void 0 : vehicle.year].filter(Boolean).join(" ");
    var buildOrderName = ({
      goodName,
      vehicle,
      fallbackLicensePlate
    }) => {
      const licensePlate = vehicle ? vehicle.license_plate : fallbackLicensePlate ?? null;
      const label = [goodName, buildVehicleLabel2(vehicle)].filter(Boolean).join(" ");
      const description = [label, licensePlate ? `(${licensePlate})` : ""].filter(Boolean).join(" ");
      return description || null;
    };
    var buildProductLabel = ({
      sku,
      name,
      brand
    }) => {
      const label = `${sku} - ${name}`;
      const trimmedBrand = brand == null ? void 0 : brand.trim();
      return trimmedBrand ? `${label} (${trimmedBrand})` : label;
    };
    var DEFAULT_LOCALE5 = "es-AR";
    var formatCurrencyAmount3 = (value, currency, options) => new Intl.NumberFormat((options == null ? void 0 : options.locale) ?? DEFAULT_LOCALE5, {
      style: "currency",
      currency,
      minimumFractionDigits: (options == null ? void 0 : options.noDecimals) ? 0 : void 0,
      maximumFractionDigits: (options == null ? void 0 : options.noDecimals) ? 0 : void 0
    }).format(Number(value));
    var UNITS = [
      "",
      "uno",
      "dos",
      "tres",
      "cuatro",
      "cinco",
      "seis",
      "siete",
      "ocho",
      "nueve",
      "diez",
      "once",
      "doce",
      "trece",
      "catorce",
      "quince",
      "diecis\xE9is",
      "diecisiete",
      "dieciocho",
      "diecinueve",
      "veinte",
      "veintiuno",
      "veintid\xF3s",
      "veintitr\xE9s",
      "veinticuatro",
      "veinticinco",
      "veintis\xE9is",
      "veintisiete",
      "veintiocho",
      "veintinueve"
    ];
    var TENS = [
      "",
      "",
      "",
      "treinta",
      "cuarenta",
      "cincuenta",
      "sesenta",
      "setenta",
      "ochenta",
      "noventa"
    ];
    var HUNDREDS = [
      "",
      "ciento",
      "doscientos",
      "trescientos",
      "cuatrocientos",
      "quinientos",
      "seiscientos",
      "setecientos",
      "ochocientos",
      "novecientos"
    ];
    var upToNinetyNine = (value) => {
      if (value < 30) return UNITS[value];
      const ten = Math.floor(value / 10);
      const unit = value % 10;
      return unit === 0 ? TENS[ten] : `${TENS[ten]} y ${UNITS[unit]}`;
    };
    var upToNineHundredNinetyNine = (value) => {
      if (value === 100) return "cien";
      if (value < 100) return upToNinetyNine(value);
      const hundred = Math.floor(value / 100);
      const rest = value % 100;
      return rest === 0 ? HUNDREDS[hundred] : `${HUNDREDS[hundred]} ${upToNinetyNine(rest)}`;
    };
    var apocopate = (words) => words.endsWith("veintiuno") ? words.replace(/veintiuno$/, "veinti\xFAn") : words.replace(/uno$/, "un");
    var upToNineHundredNinetyNineThousand = (value) => {
      const thousands = Math.floor(value / 1e3);
      const units = value % 1e3;
      const parts = [];
      if (thousands === 1) parts.push("mil");
      else if (thousands > 1)
        parts.push(`${apocopate(upToNineHundredNinetyNine(thousands))} mil`);
      if (units > 0) parts.push(upToNineHundredNinetyNine(units));
      return parts.join(" ");
    };
    var spell = (value) => {
      if (value === 0) return "cero";
      const millions = Math.floor(value / 1e6);
      const rest = value % 1e6;
      const parts = [];
      if (millions === 1) parts.push("un mill\xF3n");
      else if (millions > 1)
        parts.push(
          `${apocopate(upToNineHundredNinetyNineThousand(millions))} millones`
        );
      if (rest > 0) parts.push(upToNineHundredNinetyNineThousand(rest));
      return parts.join(" ");
    };
    var CURRENCY_WORDS = {
      ARS: { singular: "peso argentino", plural: "pesos argentinos" },
      USD: { singular: "d\xF3lar estadounidense", plural: "d\xF3lares estadounidenses" },
      EUR: { singular: "euro", plural: "euros" },
      PYG: { singular: "guaran\xED", plural: "guaran\xEDes" }
    };
    var MAX_SPELLABLE_AMOUNT = 999999999999;
    var numberToSpanishWords4 = (amount, currency = "ARS") => {
      if (!Number.isFinite(amount) || amount < 0) return "";
      const integer = Math.floor(amount);
      const cents = Math.round((amount - integer) * 100);
      if (integer > MAX_SPELLABLE_AMOUNT) return "";
      const words = spell(integer);
      const currencyWords = CURRENCY_WORDS[currency] ?? CURRENCY_WORDS.ARS;
      const currencyLabel = integer === 1 && cents === 0 ? currencyWords.singular : currencyWords.plural;
      const spelled = apocopate(words);
      const millionsLink = cents === 0 && (spelled.endsWith("mill\xF3n") || spelled.endsWith("millones")) ? "de " : "";
      const sentence = cents > 0 ? `${spelled} con ${String(cents).padStart(2, "0")}/100 ${currencyLabel}` : `${spelled} ${millionsLink}${currencyLabel}`;
      return sentence.charAt(0).toUpperCase() + sentence.slice(1);
    };
    var spellableCurrencies = Object.keys(CURRENCY_WORDS);
    var isSpellableCurrency3 = (currency) => currency in CURRENCY_WORDS;
    var composeAddress = (input) => `${input.address_street} ${input.address_number}${input.address_apartment ? `, ${input.address_apartment}` : ""}`;
    var import_piramid_constants510 = require_dist2();
    var getCurrencyCodeFromCountry = (countryCode = import_piramid_constants510.DEFAULT_COUNTRY_CODE) => {
      var _a;
      return (_a = import_piramid_constants510.countryCurrencyList.find((ele) => ele.country === countryCode)) == null ? void 0 : _a.currency_code;
    };
    var buildUserFullName = (user) => [user.first_name, user.last_name].filter(Boolean).join(" ");
    var buildUserDisplayName = (user) => buildUserFullName(user) || user.email || "";
    var buildUserAcronym = (opt) => getInitialsFromUser(opt);
    var groupByTyped = (list, groupByProperty, fallbackKey) => {
      const result = {};
      for (const item of list) {
        const groupKey = item[groupByProperty];
        if (!groupKey && fallbackKey) {
          const fallbackItems = result[fallbackKey];
          if (fallbackItems) {
            result[fallbackKey] = [
              //@ts-ignore
              ...fallbackItems,
              item
            ];
          }
          if (!fallbackItems) {
            result[fallbackKey] = [item];
          }
          continue;
        }
        const group = result[groupKey];
        if (group) {
          result[groupKey].push(item);
        } else {
          result[groupKey] = [item];
        }
      }
      return result;
    };
    var sortListAlphabetically = (list, key) => Array.from(list).sort((a3, b2) => {
      return a3[key].localeCompare(b2[key]);
    });
    var nativeEnumToArray = (obj) => Object.keys(obj);
    var import_piramid_constants610 = require_dist2();
    var getCountryStates = (country = "") => {
      var _a;
      const states2 = ((_a = import_piramid_constants610.countryAndStates.find((option) => option.code === country)) == null ? void 0 : _a.states) || [];
      return (states2 || []).map((state) => ({
        label: state.name,
        value: state.code
      }));
    };
    var DEFAULT_COUNTRY_CODE2 = "ARG";
    var currencyFormat = (value, country, noDecimals) => formatCurrencyAmount3(
      value,
      getCurrencyCodeFromCountry(country || DEFAULT_COUNTRY_CODE2),
      { noDecimals }
    );
    var stringToRegex = (input) => {
      const parts = /\/(.*)\/(.*)/.exec(input);
      console.log("parts", parts);
      if (!(parts == null ? void 0 : parts.length)) {
        return new RegExp("");
      }
      return new RegExp(parts[1], parts[2]);
    };
    var capitalizeFirstLetter = (value) => {
      return value.charAt(0).toUpperCase() + value.slice(1);
    };
    var lowercaseFirstLetter2 = (value) => {
      return value.charAt(0).toLowerCase() + value.slice(1);
    };
    var isValidDayMonthYearDateString = (day) => new RegExp(
      /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
    ).test(day);
    var import_date_fns_tz = require_date_fns_tz();
    var dayHourToDate = (day, hour) => {
      if (!isValidDayMonthYearDateString(day)) {
        return /* @__PURE__ */ new Date();
      }
      const [dayNumber, monthNumber, year] = day.split("/").map(Number);
      const [hourNumber, minuteNumber] = hour.split(":").map(Number);
      const date = /* @__PURE__ */ new Date();
      date.setFullYear(year, monthNumber - 1, dayNumber);
      date.setHours(hourNumber, minuteNumber);
      return (0, import_date_fns_tz.zonedTimeToUtc)(date, "America/Argentina/Buenos_Aires");
    };
    var utc2utc3 = (val) => {
      const date = new Date(val);
      const timestamp = date.getTime();
      const offset = 180 * 60 * 1e3;
      date.setTime(timestamp - offset);
      return date;
    };
    function uniqueArrayItems(value, index, array) {
      return array.indexOf(value) === index;
    }
    function calculateVerificationNumber3(cuit) {
      const factor = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      for (let i2 = 0; i2 < 10; i2++) {
        sum += parseInt(cuit.charAt(i2), 10) * factor[i2];
      }
      const remainder = sum % 11;
      return remainder === 0 ? 0 : remainder === 1 ? 9 : 11 - remainder;
    }
    var import_date_fns22 = (init_esm(), __toCommonJS(esm_exports));
    var localeDateFormat = (val) => {
      return (0, import_date_fns22.format)(new Date(val), "dd/MM/yyyy HH:mm");
    };
    var import_uuid = (init_esm_node(), __toCommonJS(esm_node_exports));
    var removeWhiteSpaces = (val) => val.replace(/ /g, "");
    var removeNonAscii = (val) => val.replace(/[^\x00-\x7F]/g, "");
    var normalizeFilename = (filename) => `${(0, import_uuid.v4)()}-${removeNonAscii(removeWhiteSpaces(filename)).toLowerCase()}`;
    var resolveClaimSinisterNumber = (claim) => {
      var _a, _b;
      return ((_a = claim.selected_external_complaint) == null ? void 0 : _a.external_id) || ((_b = claim.selected_pending_complaint) == null ? void 0 : _b.external_id) || null;
    };
    var MINUTE = 60;
    var HOUR = MINUTE * 60;
    var DAY = HOUR * 24;
    var MONTH = DAY * 30;
    var YEAR = DAY * 365;
    var customFormatDistance = (baseDate, date, options) => {
      const targetDate = date instanceof Date ? date : new Date(date);
      const baseDateObj = baseDate instanceof Date ? baseDate : new Date(baseDate);
      const formatter = new Intl.DateTimeFormat("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
      const formattedDate = formatter.format(targetDate);
      const now = baseDateObj;
      const diffInSeconds = Math.round(
        (now.getTime() - targetDate.getTime()) / 1e3
      );
      let timeText = "";
      if (diffInSeconds < MINUTE) {
        timeText = (options == null ? void 0 : options.includeSeconds) ? "Hace instantes" : "Ahora";
      } else if (diffInSeconds < HOUR) {
        const minutes = Math.floor(diffInSeconds / MINUTE);
        timeText = `Hace ${minutes} minuto${minutes !== 1 ? "s" : ""}`;
      } else if (diffInSeconds < DAY) {
        const hours = Math.floor(diffInSeconds / HOUR);
        timeText = `Hace ${hours} hora${hours !== 1 ? "s" : ""}`;
      } else if (diffInSeconds < MONTH) {
        const days2 = Math.floor(diffInSeconds / DAY);
        timeText = `Hace ${days2} d\xEDa${days2 !== 1 ? "s" : ""}`;
      } else if (diffInSeconds < YEAR) {
        const months2 = Math.floor(diffInSeconds / MONTH);
        timeText = `Hace ${months2} mes${months2 !== 1 ? "es" : ""}`;
      } else {
        const years = Math.floor(diffInSeconds / YEAR);
        timeText = `Hace ${years} a\xF1o${years !== 1 ? "s" : ""}`;
      }
      if (options == null ? void 0 : options.justDate) {
        return formattedDate;
      }
      const suffixedTimeText = (options == null ? void 0 : options.addSuffix) || (options == null ? void 0 : options.justSuffix) ? timeText : timeText.replace(/^Hace/, "").trim();
      if (options == null ? void 0 : options.justSuffix) {
        return suffixedTimeText;
      }
      return `${formattedDate} - ${suffixedTimeText}`;
    };
    var EARTH_RADIUS_METERS = 6371e3;
    var toRadians = (degrees) => degrees * Math.PI / 180;
    var haversineMeters = (a3, b2) => {
      const dLat = toRadians(b2.latitude - a3.latitude);
      const dLng = toRadians(b2.longitude - a3.longitude);
      const lat1 = toRadians(a3.latitude);
      const lat2 = toRadians(b2.latitude);
      const h3 = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
      return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(h3));
    };
    var formatDistance168 = (meters) => {
      if (meters < 1e3) return `${Math.round(meters)}mts`;
      const km = Math.round(meters / 1e3 * 10) / 10;
      return `${km}km`;
    };
    var buildGoogleMapsUrl = ({ latitude, longitude }) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      `${latitude},${longitude}`
    )}`;
    var import_piramid_constants710 = require_dist2();
    var CALENDAR_INVITE_METHODS = ["REQUEST", "CANCEL"];
    var INVITE_STATUS = {
      REQUEST: "CONFIRMED",
      CANCEL: "CANCELLED"
    };
    var MAX_LINE_OCTETS = 75;
    var CONTINUATION_OCTETS = MAX_LINE_OCTETS - 1;
    var CRLF = "\r\n";
    var GEO_DECIMALS = 6;
    var toICalendarUtcStamp = (date) => date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
    var escapeText = (value) => value.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r\n|\r|\n/g, "\\n");
    var escapeParamValue = (value) => `"${value.replace(/["\u0000-\u001f\u007f]/g, "")}"`;
    var utf8Width = (codePoint) => {
      if (codePoint < 128) return 1;
      if (codePoint < 2048) return 2;
      if (codePoint < 65536) return 3;
      return 4;
    };
    var foldLine = (line) => {
      const chunks = [];
      let current = "";
      let width = 0;
      let budget = MAX_LINE_OCTETS;
      for (const char of line) {
        const charWidth = utf8Width(char.codePointAt(0));
        if (width + charWidth > budget) {
          chunks.push(current);
          current = "";
          width = 0;
          budget = CONTINUATION_OCTETS;
        }
        current += char;
        width += charWidth;
      }
      chunks.push(current);
      return chunks.join(`${CRLF} `);
    };
    var participantLine = (property, participant, params = []) => {
      const withName = participant.name ? [...params, `CN=${escapeParamValue(participant.name)}`] : params;
      return `${property}${withName.map((param) => `;${param}`).join("")}:mailto:${participant.email}`;
    };
    var geoLine = ({ latitude, longitude }) => `GEO:${latitude.toFixed(GEO_DECIMALS)};${longitude.toFixed(GEO_DECIMALS)}`;
    var buildScheduleCalendarUid = (scheduleId) => `schedule-${scheduleId}@${import_piramid_constants710.ORDER_CALENDAR_UID_DOMAIN}`;
    var buildCalendarInvite = (invite) => {
      const lines = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        `PRODID:${import_piramid_constants710.ICALENDAR_PRODID}`,
        "CALSCALE:GREGORIAN",
        `METHOD:${invite.method}`,
        "BEGIN:VEVENT",
        `UID:${invite.uid}`,
        `SEQUENCE:${invite.sequence}`,
        `DTSTAMP:${toICalendarUtcStamp(invite.dtstamp)}`,
        `DTSTART:${toICalendarUtcStamp(invite.startsAt)}`,
        `DTEND:${toICalendarUtcStamp(invite.endsAt)}`,
        `SUMMARY:${escapeText(invite.summary)}`,
        ...invite.description ? [`DESCRIPTION:${escapeText(invite.description)}`] : [],
        ...invite.location ? [`LOCATION:${escapeText(invite.location)}`] : [],
        ...invite.geo ? [geoLine(invite.geo)] : [],
        participantLine("ORGANIZER", invite.organizer),
        // RSVP=FALSE because nothing in this system processes METHOD:REPLY — with it
        // on, Gmail offers Yes/No/Maybe and mails the answer into a black hole at
        // noreply@. PARTSTAT=ACCEPTED because the claimant is being TOLD, not asked:
        // the default NEEDS-ACTION renders a perpetually tentative event that, with
        // RSVP off, can never resolve.
        participantLine("ATTENDEE", invite.attendee, [
          "CUTYPE=INDIVIDUAL",
          "ROLE=REQ-PARTICIPANT",
          "PARTSTAT=ACCEPTED",
          "RSVP=FALSE"
        ]),
        `STATUS:${INVITE_STATUS[invite.method]}`,
        "END:VEVENT",
        "END:VCALENDAR"
      ];
      return lines.map(foldLine).join(CRLF) + CRLF;
    };
    var formatPlaceAddress = (place) => [
      place.address,
      place.locality.name,
      place.locality.department_name,
      place.locality.province_name
    ].filter(Boolean).join(", ");
    function filterDocumentsByVisibility({
      files,
      ownerId,
      oldOwnerIds,
      visibility,
      inhouseLawyerIds
    }) {
      if (!files) return [];
      return files.filter((file) => {
        const isUploadedByOwner = file.uploaded_by_id === ownerId;
        const isUploadedByOldOwner = oldOwnerIds == null ? void 0 : oldOwnerIds.includes(
          file.uploaded_by_id ?? ""
        );
        const isInhouseLawyer = inhouseLawyerIds == null ? void 0 : inhouseLawyerIds.some(
          (lawyer) => lawyer.id === file.uploaded_by_id
        );
        if (visibility.owner && ownerId) {
          return isUploadedByOwner || isInhouseLawyer || (oldOwnerIds == null ? void 0 : oldOwnerIds.length) && isUploadedByOldOwner;
        }
        if (visibility.tramitation) {
          return !isUploadedByOwner;
        }
        return true;
      });
    }
    var toTitleCase = (str) => {
      if (!str) return "";
      return str.toLowerCase().split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
    };
    var import_date_fns32 = (init_esm(), __toCommonJS(esm_exports));
    var import_piramid_constants810 = require_dist2();
    var isMinorAt = (dateOfBirth, referenceDate = /* @__PURE__ */ new Date()) => {
      if (!dateOfBirth) return false;
      const birthDate = new Date(dateOfBirth);
      if (Number.isNaN(birthDate.getTime())) return false;
      return (0, import_date_fns32.differenceInYears)(new Date(referenceDate), birthDate) < import_piramid_constants810.LEGAL_PERSON_AGE_THRESHOLD;
    };
    var isSafeInternalHref = (value) => {
      if (!value) return false;
      if (!value.startsWith("/")) return false;
      if (value.startsWith("//")) return false;
      if (value.startsWith("/\\")) return false;
      return true;
    };
    var external_exports = {};
    __export2(external_exports, {
      BRAND: () => BRAND,
      DIRTY: () => DIRTY,
      EMPTY_PATH: () => EMPTY_PATH,
      INVALID: () => INVALID,
      NEVER: () => NEVER,
      OK: () => OK,
      ParseStatus: () => ParseStatus,
      Schema: () => ZodType,
      ZodAny: () => ZodAny,
      ZodArray: () => ZodArray,
      ZodBigInt: () => ZodBigInt,
      ZodBoolean: () => ZodBoolean,
      ZodBranded: () => ZodBranded,
      ZodCatch: () => ZodCatch,
      ZodDate: () => ZodDate,
      ZodDefault: () => ZodDefault,
      ZodDiscriminatedUnion: () => ZodDiscriminatedUnion,
      ZodEffects: () => ZodEffects,
      ZodEnum: () => ZodEnum,
      ZodError: () => ZodError,
      ZodFirstPartyTypeKind: () => ZodFirstPartyTypeKind,
      ZodFunction: () => ZodFunction,
      ZodIntersection: () => ZodIntersection,
      ZodIssueCode: () => ZodIssueCode,
      ZodLazy: () => ZodLazy,
      ZodLiteral: () => ZodLiteral,
      ZodMap: () => ZodMap,
      ZodNaN: () => ZodNaN,
      ZodNativeEnum: () => ZodNativeEnum,
      ZodNever: () => ZodNever,
      ZodNull: () => ZodNull,
      ZodNullable: () => ZodNullable,
      ZodNumber: () => ZodNumber,
      ZodObject: () => ZodObject,
      ZodOptional: () => ZodOptional,
      ZodParsedType: () => ZodParsedType,
      ZodPipeline: () => ZodPipeline,
      ZodPromise: () => ZodPromise,
      ZodReadonly: () => ZodReadonly,
      ZodRecord: () => ZodRecord,
      ZodSchema: () => ZodType,
      ZodSet: () => ZodSet,
      ZodString: () => ZodString,
      ZodSymbol: () => ZodSymbol,
      ZodTransformer: () => ZodEffects,
      ZodTuple: () => ZodTuple,
      ZodType: () => ZodType,
      ZodUndefined: () => ZodUndefined,
      ZodUnion: () => ZodUnion,
      ZodUnknown: () => ZodUnknown,
      ZodVoid: () => ZodVoid,
      addIssueToContext: () => addIssueToContext,
      any: () => anyType,
      array: () => arrayType,
      bigint: () => bigIntType,
      boolean: () => booleanType,
      coerce: () => coerce,
      custom: () => custom,
      date: () => dateType,
      datetimeRegex: () => datetimeRegex,
      defaultErrorMap: () => en_default,
      discriminatedUnion: () => discriminatedUnionType,
      effect: () => effectsType,
      enum: () => enumType,
      function: () => functionType,
      getErrorMap: () => getErrorMap,
      getParsedType: () => getParsedType,
      instanceof: () => instanceOfType,
      intersection: () => intersectionType,
      isAborted: () => isAborted,
      isAsync: () => isAsync,
      isDirty: () => isDirty,
      isValid: () => isValid2,
      late: () => late,
      lazy: () => lazyType,
      literal: () => literalType,
      makeIssue: () => makeIssue,
      map: () => mapType,
      nan: () => nanType,
      nativeEnum: () => nativeEnumType,
      never: () => neverType,
      null: () => nullType,
      nullable: () => nullableType,
      number: () => numberType,
      object: () => objectType,
      objectUtil: () => objectUtil,
      oboolean: () => oboolean,
      onumber: () => onumber,
      optional: () => optionalType,
      ostring: () => ostring,
      pipeline: () => pipelineType,
      preprocess: () => preprocessType,
      promise: () => promiseType,
      quotelessJson: () => quotelessJson,
      record: () => recordType,
      set: () => setType,
      setErrorMap: () => setErrorMap,
      strictObject: () => strictObjectType,
      string: () => stringType,
      symbol: () => symbolType,
      transformer: () => effectsType,
      tuple: () => tupleType,
      undefined: () => undefinedType,
      union: () => unionType,
      unknown: () => unknownType,
      util: () => util,
      void: () => voidType
    });
    var util;
    (function(util2) {
      util2.assertEqual = (_) => {
      };
      function assertIs(_arg) {
      }
      util2.assertIs = assertIs;
      function assertNever(_x) {
        throw new Error();
      }
      util2.assertNever = assertNever;
      util2.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
          obj[item] = item;
        }
        return obj;
      };
      util2.getValidEnumValues = (obj) => {
        const validKeys = util2.objectKeys(obj).filter((k2) => typeof obj[obj[k2]] !== "number");
        const filtered = {};
        for (const k2 of validKeys) {
          filtered[k2] = obj[k2];
        }
        return util2.objectValues(filtered);
      };
      util2.objectValues = (obj) => {
        return util2.objectKeys(obj).map(function(e2) {
          return obj[e2];
        });
      };
      util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
        const keys = [];
        for (const key in object) {
          if (Object.prototype.hasOwnProperty.call(object, key)) {
            keys.push(key);
          }
        }
        return keys;
      };
      util2.find = (arr, checker) => {
        for (const item of arr) {
          if (checker(item))
            return item;
        }
        return void 0;
      };
      util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && Number.isFinite(val) && Math.floor(val) === val;
      function joinValues(array, separator = " | ") {
        return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
      }
      util2.joinValues = joinValues;
      util2.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
          return value.toString();
        }
        return value;
      };
    })(util || (util = {}));
    var objectUtil;
    (function(objectUtil2) {
      objectUtil2.mergeShapes = (first, second) => {
        return {
          ...first,
          ...second
          // second overwrites first
        };
      };
    })(objectUtil || (objectUtil = {}));
    var ZodParsedType = util.arrayToEnum([
      "string",
      "nan",
      "number",
      "integer",
      "float",
      "boolean",
      "date",
      "bigint",
      "symbol",
      "function",
      "undefined",
      "null",
      "array",
      "object",
      "unknown",
      "promise",
      "void",
      "never",
      "map",
      "set"
    ]);
    var getParsedType = (data) => {
      const t2 = typeof data;
      switch (t2) {
        case "undefined":
          return ZodParsedType.undefined;
        case "string":
          return ZodParsedType.string;
        case "number":
          return Number.isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
          return ZodParsedType.boolean;
        case "function":
          return ZodParsedType.function;
        case "bigint":
          return ZodParsedType.bigint;
        case "symbol":
          return ZodParsedType.symbol;
        case "object":
          if (Array.isArray(data)) {
            return ZodParsedType.array;
          }
          if (data === null) {
            return ZodParsedType.null;
          }
          if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
            return ZodParsedType.promise;
          }
          if (typeof Map !== "undefined" && data instanceof Map) {
            return ZodParsedType.map;
          }
          if (typeof Set !== "undefined" && data instanceof Set) {
            return ZodParsedType.set;
          }
          if (typeof Date !== "undefined" && data instanceof Date) {
            return ZodParsedType.date;
          }
          return ZodParsedType.object;
        default:
          return ZodParsedType.unknown;
      }
    };
    var ZodIssueCode = util.arrayToEnum([
      "invalid_type",
      "invalid_literal",
      "custom",
      "invalid_union",
      "invalid_union_discriminator",
      "invalid_enum_value",
      "unrecognized_keys",
      "invalid_arguments",
      "invalid_return_type",
      "invalid_date",
      "invalid_string",
      "too_small",
      "too_big",
      "invalid_intersection_types",
      "not_multiple_of",
      "not_finite"
    ]);
    var quotelessJson = (obj) => {
      const json = JSON.stringify(obj, null, 2);
      return json.replace(/"([^"]+)":/g, "$1:");
    };
    var ZodError = class _ZodError extends Error {
      get errors() {
        return this.issues;
      }
      constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub2) => {
          this.issues = [...this.issues, sub2];
        };
        this.addIssues = (subs = []) => {
          this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(this, actualProto);
        } else {
          this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
      }
      format(_mapper) {
        const mapper = _mapper || function(issue) {
          return issue.message;
        };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
          for (const issue of error.issues) {
            if (issue.code === "invalid_union") {
              issue.unionErrors.map(processError);
            } else if (issue.code === "invalid_return_type") {
              processError(issue.returnTypeError);
            } else if (issue.code === "invalid_arguments") {
              processError(issue.argumentsError);
            } else if (issue.path.length === 0) {
              fieldErrors._errors.push(mapper(issue));
            } else {
              let curr = fieldErrors;
              let i2 = 0;
              while (i2 < issue.path.length) {
                const el = issue.path[i2];
                const terminal = i2 === issue.path.length - 1;
                if (!terminal) {
                  curr[el] = curr[el] || { _errors: [] };
                } else {
                  curr[el] = curr[el] || { _errors: [] };
                  curr[el]._errors.push(mapper(issue));
                }
                curr = curr[el];
                i2++;
              }
            }
          }
        };
        processError(this);
        return fieldErrors;
      }
      static assert(value) {
        if (!(value instanceof _ZodError)) {
          throw new Error(`Not a ZodError: ${value}`);
        }
      }
      toString() {
        return this.message;
      }
      get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
      }
      get isEmpty() {
        return this.issues.length === 0;
      }
      flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub2 of this.issues) {
          if (sub2.path.length > 0) {
            const firstEl = sub2.path[0];
            fieldErrors[firstEl] = fieldErrors[firstEl] || [];
            fieldErrors[firstEl].push(mapper(sub2));
          } else {
            formErrors.push(mapper(sub2));
          }
        }
        return { formErrors, fieldErrors };
      }
      get formErrors() {
        return this.flatten();
      }
    };
    ZodError.create = (issues) => {
      const error = new ZodError(issues);
      return error;
    };
    var errorMap = (issue, _ctx) => {
      let message;
      switch (issue.code) {
        case ZodIssueCode.invalid_type:
          if (issue.received === ZodParsedType.undefined) {
            message = "Required";
          } else {
            message = `Expected ${issue.expected}, received ${issue.received}`;
          }
          break;
        case ZodIssueCode.invalid_literal:
          message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
          break;
        case ZodIssueCode.unrecognized_keys:
          message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
          break;
        case ZodIssueCode.invalid_union:
          message = `Invalid input`;
          break;
        case ZodIssueCode.invalid_union_discriminator:
          message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
          break;
        case ZodIssueCode.invalid_enum_value:
          message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
          break;
        case ZodIssueCode.invalid_arguments:
          message = `Invalid function arguments`;
          break;
        case ZodIssueCode.invalid_return_type:
          message = `Invalid function return type`;
          break;
        case ZodIssueCode.invalid_date:
          message = `Invalid date`;
          break;
        case ZodIssueCode.invalid_string:
          if (typeof issue.validation === "object") {
            if ("includes" in issue.validation) {
              message = `Invalid input: must include "${issue.validation.includes}"`;
              if (typeof issue.validation.position === "number") {
                message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
              }
            } else if ("startsWith" in issue.validation) {
              message = `Invalid input: must start with "${issue.validation.startsWith}"`;
            } else if ("endsWith" in issue.validation) {
              message = `Invalid input: must end with "${issue.validation.endsWith}"`;
            } else {
              util.assertNever(issue.validation);
            }
          } else if (issue.validation !== "regex") {
            message = `Invalid ${issue.validation}`;
          } else {
            message = "Invalid";
          }
          break;
        case ZodIssueCode.too_small:
          if (issue.type === "array")
            message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
          else if (issue.type === "string")
            message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
          else if (issue.type === "number")
            message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
          else if (issue.type === "bigint")
            message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
          else if (issue.type === "date")
            message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
          else
            message = "Invalid input";
          break;
        case ZodIssueCode.too_big:
          if (issue.type === "array")
            message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
          else if (issue.type === "string")
            message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
          else if (issue.type === "number")
            message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
          else if (issue.type === "bigint")
            message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
          else if (issue.type === "date")
            message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
          else
            message = "Invalid input";
          break;
        case ZodIssueCode.custom:
          message = `Invalid input`;
          break;
        case ZodIssueCode.invalid_intersection_types:
          message = `Intersection results could not be merged`;
          break;
        case ZodIssueCode.not_multiple_of:
          message = `Number must be a multiple of ${issue.multipleOf}`;
          break;
        case ZodIssueCode.not_finite:
          message = "Number must be finite";
          break;
        default:
          message = _ctx.defaultError;
          util.assertNever(issue);
      }
      return { message };
    };
    var en_default = errorMap;
    var overrideErrorMap = en_default;
    function setErrorMap(map) {
      overrideErrorMap = map;
    }
    function getErrorMap() {
      return overrideErrorMap;
    }
    var makeIssue = (params) => {
      const { data, path, errorMaps, issueData } = params;
      const fullPath = [...path, ...issueData.path || []];
      const fullIssue = {
        ...issueData,
        path: fullPath
      };
      if (issueData.message !== void 0) {
        return {
          ...issueData,
          path: fullPath,
          message: issueData.message
        };
      }
      let errorMessage = "";
      const maps = errorMaps.filter((m3) => !!m3).slice().reverse();
      for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
      }
      return {
        ...issueData,
        path: fullPath,
        message: errorMessage
      };
    };
    var EMPTY_PATH = [];
    function addIssueToContext(ctx, issueData) {
      const overrideMap = getErrorMap();
      const issue = makeIssue({
        issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          // contextual error map is first priority
          ctx.schemaErrorMap,
          // then schema-bound map if available
          overrideMap,
          // then global override map
          overrideMap === en_default ? void 0 : en_default
          // then global default map
        ].filter((x2) => !!x2)
      });
      ctx.common.issues.push(issue);
    }
    var ParseStatus = class _ParseStatus {
      constructor() {
        this.value = "valid";
      }
      dirty() {
        if (this.value === "valid")
          this.value = "dirty";
      }
      abort() {
        if (this.value !== "aborted")
          this.value = "aborted";
      }
      static mergeArray(status, results) {
        const arrayValue = [];
        for (const s3 of results) {
          if (s3.status === "aborted")
            return INVALID;
          if (s3.status === "dirty")
            status.dirty();
          arrayValue.push(s3.value);
        }
        return { status: status.value, value: arrayValue };
      }
      static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          syncPairs.push({
            key,
            value
          });
        }
        return _ParseStatus.mergeObjectSync(status, syncPairs);
      }
      static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
          const { key, value } = pair;
          if (key.status === "aborted")
            return INVALID;
          if (value.status === "aborted")
            return INVALID;
          if (key.status === "dirty")
            status.dirty();
          if (value.status === "dirty")
            status.dirty();
          if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
            finalObject[key.value] = value.value;
          }
        }
        return { status: status.value, value: finalObject };
      }
    };
    var INVALID = Object.freeze({
      status: "aborted"
    });
    var DIRTY = (value) => ({ status: "dirty", value });
    var OK = (value) => ({ status: "valid", value });
    var isAborted = (x2) => x2.status === "aborted";
    var isDirty = (x2) => x2.status === "dirty";
    var isValid2 = (x2) => x2.status === "valid";
    var isAsync = (x2) => typeof Promise !== "undefined" && x2 instanceof Promise;
    var errorUtil;
    (function(errorUtil2) {
      errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
      errorUtil2.toString = (message) => typeof message === "string" ? message : message == null ? void 0 : message.message;
    })(errorUtil || (errorUtil = {}));
    var ParseInputLazyPath = class {
      constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
      }
      get path() {
        if (!this._cachedPath.length) {
          if (Array.isArray(this._key)) {
            this._cachedPath.push(...this._path, ...this._key);
          } else {
            this._cachedPath.push(...this._path, this._key);
          }
        }
        return this._cachedPath;
      }
    };
    var handleResult = (ctx, result) => {
      if (isValid2(result)) {
        return { success: true, data: result.value };
      } else {
        if (!ctx.common.issues.length) {
          throw new Error("Validation failed but no issues detected.");
        }
        return {
          success: false,
          get error() {
            if (this._error)
              return this._error;
            const error = new ZodError(ctx.common.issues);
            this._error = error;
            return this._error;
          }
        };
      }
    };
    function processCreateParams(params) {
      if (!params)
        return {};
      const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
      if (errorMap2 && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
      }
      if (errorMap2)
        return { errorMap: errorMap2, description };
      const customMap = (iss, ctx) => {
        const { message } = params;
        if (iss.code === "invalid_enum_value") {
          return { message: message ?? ctx.defaultError };
        }
        if (typeof ctx.data === "undefined") {
          return { message: message ?? required_error ?? ctx.defaultError };
        }
        if (iss.code !== "invalid_type")
          return { message: ctx.defaultError };
        return { message: message ?? invalid_type_error ?? ctx.defaultError };
      };
      return { errorMap: customMap, description };
    }
    var ZodType = class {
      get description() {
        return this._def.description;
      }
      _getType(input) {
        return getParsedType(input.data);
      }
      _getOrReturnCtx(input, ctx) {
        return ctx || {
          common: input.parent.common,
          data: input.data,
          parsedType: getParsedType(input.data),
          schemaErrorMap: this._def.errorMap,
          path: input.path,
          parent: input.parent
        };
      }
      _processInputParams(input) {
        return {
          status: new ParseStatus(),
          ctx: {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
          }
        };
      }
      _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
          throw new Error("Synchronous parse encountered promise.");
        }
        return result;
      }
      _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
      }
      parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
          return result.data;
        throw result.error;
      }
      safeParse(data, params) {
        const ctx = {
          common: {
            issues: [],
            async: (params == null ? void 0 : params.async) ?? false,
            contextualErrorMap: params == null ? void 0 : params.errorMap
          },
          path: (params == null ? void 0 : params.path) || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data,
          parsedType: getParsedType(data)
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
      }
      "~validate"(data) {
        var _a, _b;
        const ctx = {
          common: {
            issues: [],
            async: !!this["~standard"].async
          },
          path: [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data,
          parsedType: getParsedType(data)
        };
        if (!this["~standard"].async) {
          try {
            const result = this._parseSync({ data, path: [], parent: ctx });
            return isValid2(result) ? {
              value: result.value
            } : {
              issues: ctx.common.issues
            };
          } catch (err) {
            if ((_b = (_a = err == null ? void 0 : err.message) == null ? void 0 : _a.toLowerCase()) == null ? void 0 : _b.includes("encountered")) {
              this["~standard"].async = true;
            }
            ctx.common = {
              issues: [],
              async: true
            };
          }
        }
        return this._parseAsync({ data, path: [], parent: ctx }).then((result) => isValid2(result) ? {
          value: result.value
        } : {
          issues: ctx.common.issues
        });
      }
      async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
          return result.data;
        throw result.error;
      }
      async safeParseAsync(data, params) {
        const ctx = {
          common: {
            issues: [],
            contextualErrorMap: params == null ? void 0 : params.errorMap,
            async: true
          },
          path: (params == null ? void 0 : params.path) || [],
          schemaErrorMap: this._def.errorMap,
          parent: null,
          data,
          parsedType: getParsedType(data)
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
      }
      refine(check2, message) {
        const getIssueProperties = (val) => {
          if (typeof message === "string" || typeof message === "undefined") {
            return { message };
          } else if (typeof message === "function") {
            return message(val);
          } else {
            return message;
          }
        };
        return this._refinement((val, ctx) => {
          const result = check2(val);
          const setError = () => ctx.addIssue({
            code: ZodIssueCode.custom,
            ...getIssueProperties(val)
          });
          if (typeof Promise !== "undefined" && result instanceof Promise) {
            return result.then((data) => {
              if (!data) {
                setError();
                return false;
              } else {
                return true;
              }
            });
          }
          if (!result) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      refinement(check2, refinementData) {
        return this._refinement((val, ctx) => {
          if (!check2(val)) {
            ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
            return false;
          } else {
            return true;
          }
        });
      }
      _refinement(refinement) {
        return new ZodEffects({
          schema: this,
          typeName: ZodFirstPartyTypeKind.ZodEffects,
          effect: { type: "refinement", refinement }
        });
      }
      superRefine(refinement) {
        return this._refinement(refinement);
      }
      constructor(def) {
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
        this["~standard"] = {
          version: 1,
          vendor: "zod",
          validate: (data) => this["~validate"](data)
        };
      }
      optional() {
        return ZodOptional.create(this, this._def);
      }
      nullable() {
        return ZodNullable.create(this, this._def);
      }
      nullish() {
        return this.nullable().optional();
      }
      array() {
        return ZodArray.create(this);
      }
      promise() {
        return ZodPromise.create(this, this._def);
      }
      or(option) {
        return ZodUnion.create([this, option], this._def);
      }
      and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
      }
      transform(transform) {
        return new ZodEffects({
          ...processCreateParams(this._def),
          schema: this,
          typeName: ZodFirstPartyTypeKind.ZodEffects,
          effect: { type: "transform", transform }
        });
      }
      default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
          ...processCreateParams(this._def),
          innerType: this,
          defaultValue: defaultValueFunc,
          typeName: ZodFirstPartyTypeKind.ZodDefault
        });
      }
      brand() {
        return new ZodBranded({
          typeName: ZodFirstPartyTypeKind.ZodBranded,
          type: this,
          ...processCreateParams(this._def)
        });
      }
      catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
          ...processCreateParams(this._def),
          innerType: this,
          catchValue: catchValueFunc,
          typeName: ZodFirstPartyTypeKind.ZodCatch
        });
      }
      describe(description) {
        const This = this.constructor;
        return new This({
          ...this._def,
          description
        });
      }
      pipe(target) {
        return ZodPipeline.create(this, target);
      }
      readonly() {
        return ZodReadonly.create(this);
      }
      isOptional() {
        return this.safeParse(void 0).success;
      }
      isNullable() {
        return this.safeParse(null).success;
      }
    };
    var cuidRegex = /^c[^\s-]{8,}$/i;
    var cuid2Regex = /^[0-9a-z]+$/;
    var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i;
    var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
    var nanoidRegex = /^[a-z0-9_-]{21}$/i;
    var jwtRegex = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/;
    var durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
    var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
    var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
    var emojiRegex;
    var ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
    var ipv4CidrRegex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/;
    var ipv6Regex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/;
    var ipv6CidrRegex = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
    var base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    var base64urlRegex = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/;
    var dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
    var dateRegex2 = new RegExp(`^${dateRegexSource}$`);
    function timeRegexSource(args) {
      let secondsRegexSource = `[0-5]\\d`;
      if (args.precision) {
        secondsRegexSource = `${secondsRegexSource}\\.\\d{${args.precision}}`;
      } else if (args.precision == null) {
        secondsRegexSource = `${secondsRegexSource}(\\.\\d+)?`;
      }
      const secondsQuantifier = args.precision ? "+" : "?";
      return `([01]\\d|2[0-3]):[0-5]\\d(:${secondsRegexSource})${secondsQuantifier}`;
    }
    function timeRegex2(args) {
      return new RegExp(`^${timeRegexSource(args)}$`);
    }
    function datetimeRegex(args) {
      let regex = `${dateRegexSource}T${timeRegexSource(args)}`;
      const opts = [];
      opts.push(args.local ? `Z?` : `Z`);
      if (args.offset)
        opts.push(`([+-]\\d{2}:?\\d{2})`);
      regex = `${regex}(${opts.join("|")})`;
      return new RegExp(`^${regex}$`);
    }
    function isValidIP(ip, version2) {
      if ((version2 === "v4" || !version2) && ipv4Regex.test(ip)) {
        return true;
      }
      if ((version2 === "v6" || !version2) && ipv6Regex.test(ip)) {
        return true;
      }
      return false;
    }
    function isValidJWT(jwt, alg) {
      if (!jwtRegex.test(jwt))
        return false;
      try {
        const [header] = jwt.split(".");
        if (!header)
          return false;
        const base64 = header.replace(/-/g, "+").replace(/_/g, "/").padEnd(header.length + (4 - header.length % 4) % 4, "=");
        const decoded = JSON.parse(atob(base64));
        if (typeof decoded !== "object" || decoded === null)
          return false;
        if ("typ" in decoded && (decoded == null ? void 0 : decoded.typ) !== "JWT")
          return false;
        if (!decoded.alg)
          return false;
        if (alg && decoded.alg !== alg)
          return false;
        return true;
      } catch {
        return false;
      }
    }
    function isValidCidr(ip, version2) {
      if ((version2 === "v4" || !version2) && ipv4CidrRegex.test(ip)) {
        return true;
      }
      if ((version2 === "v6" || !version2) && ipv6CidrRegex.test(ip)) {
        return true;
      }
      return false;
    }
    var ZodString = class _ZodString extends ZodType {
      _parse(input) {
        if (this._def.coerce) {
          input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
          const ctx2 = this._getOrReturnCtx(input);
          addIssueToContext(ctx2, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.string,
            received: ctx2.parsedType
          });
          return INVALID;
        }
        const status = new ParseStatus();
        let ctx = void 0;
        for (const check2 of this._def.checks) {
          if (check2.kind === "min") {
            if (input.data.length < check2.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check2.value,
                type: "string",
                inclusive: true,
                exact: false,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "max") {
            if (input.data.length > check2.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check2.value,
                type: "string",
                inclusive: true,
                exact: false,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "length") {
            const tooBig = input.data.length > check2.value;
            const tooSmall = input.data.length < check2.value;
            if (tooBig || tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              if (tooBig) {
                addIssueToContext(ctx, {
                  code: ZodIssueCode.too_big,
                  maximum: check2.value,
                  type: "string",
                  inclusive: true,
                  exact: true,
                  message: check2.message
                });
              } else if (tooSmall) {
                addIssueToContext(ctx, {
                  code: ZodIssueCode.too_small,
                  minimum: check2.value,
                  type: "string",
                  inclusive: true,
                  exact: true,
                  message: check2.message
                });
              }
              status.dirty();
            }
          } else if (check2.kind === "email") {
            if (!emailRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "email",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "emoji") {
            if (!emojiRegex) {
              emojiRegex = new RegExp(_emojiRegex, "u");
            }
            if (!emojiRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "emoji",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "uuid") {
            if (!uuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "uuid",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "nanoid") {
            if (!nanoidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "nanoid",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "cuid") {
            if (!cuidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cuid",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "cuid2") {
            if (!cuid2Regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cuid2",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "ulid") {
            if (!ulidRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "ulid",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "url") {
            try {
              new URL(input.data);
            } catch {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "url",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "regex") {
            check2.regex.lastIndex = 0;
            const testResult = check2.regex.test(input.data);
            if (!testResult) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "regex",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "trim") {
            input.data = input.data.trim();
          } else if (check2.kind === "includes") {
            if (!input.data.includes(check2.value, check2.position)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: { includes: check2.value, position: check2.position },
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "toLowerCase") {
            input.data = input.data.toLowerCase();
          } else if (check2.kind === "toUpperCase") {
            input.data = input.data.toUpperCase();
          } else if (check2.kind === "startsWith") {
            if (!input.data.startsWith(check2.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: { startsWith: check2.value },
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "endsWith") {
            if (!input.data.endsWith(check2.value)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: { endsWith: check2.value },
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "datetime") {
            const regex = datetimeRegex(check2);
            if (!regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "datetime",
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "date") {
            const regex = dateRegex2;
            if (!regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "date",
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "time") {
            const regex = timeRegex2(check2);
            if (!regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_string,
                validation: "time",
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "duration") {
            if (!durationRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "duration",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "ip") {
            if (!isValidIP(input.data, check2.version)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "ip",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "jwt") {
            if (!isValidJWT(input.data, check2.alg)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "jwt",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "cidr") {
            if (!isValidCidr(input.data, check2.version)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "cidr",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "base64") {
            if (!base64Regex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "base64",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "base64url") {
            if (!base64urlRegex.test(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                validation: "base64url",
                code: ZodIssueCode.invalid_string,
                message: check2.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(check2);
          }
        }
        return { status: status.value, value: input.data };
      }
      _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
          validation,
          code: ZodIssueCode.invalid_string,
          ...errorUtil.errToObj(message)
        });
      }
      _addCheck(check2) {
        return new _ZodString({
          ...this._def,
          checks: [...this._def.checks, check2]
        });
      }
      email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
      }
      url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
      }
      emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
      }
      uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
      }
      nanoid(message) {
        return this._addCheck({ kind: "nanoid", ...errorUtil.errToObj(message) });
      }
      cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
      }
      cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
      }
      ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
      }
      base64(message) {
        return this._addCheck({ kind: "base64", ...errorUtil.errToObj(message) });
      }
      base64url(message) {
        return this._addCheck({
          kind: "base64url",
          ...errorUtil.errToObj(message)
        });
      }
      jwt(options) {
        return this._addCheck({ kind: "jwt", ...errorUtil.errToObj(options) });
      }
      ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
      }
      cidr(options) {
        return this._addCheck({ kind: "cidr", ...errorUtil.errToObj(options) });
      }
      datetime(options) {
        if (typeof options === "string") {
          return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
          });
        }
        return this._addCheck({
          kind: "datetime",
          precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
          offset: (options == null ? void 0 : options.offset) ?? false,
          local: (options == null ? void 0 : options.local) ?? false,
          ...errorUtil.errToObj(options == null ? void 0 : options.message)
        });
      }
      date(message) {
        return this._addCheck({ kind: "date", message });
      }
      time(options) {
        if (typeof options === "string") {
          return this._addCheck({
            kind: "time",
            precision: null,
            message: options
          });
        }
        return this._addCheck({
          kind: "time",
          precision: typeof (options == null ? void 0 : options.precision) === "undefined" ? null : options == null ? void 0 : options.precision,
          ...errorUtil.errToObj(options == null ? void 0 : options.message)
        });
      }
      duration(message) {
        return this._addCheck({ kind: "duration", ...errorUtil.errToObj(message) });
      }
      regex(regex, message) {
        return this._addCheck({
          kind: "regex",
          regex,
          ...errorUtil.errToObj(message)
        });
      }
      includes(value, options) {
        return this._addCheck({
          kind: "includes",
          value,
          position: options == null ? void 0 : options.position,
          ...errorUtil.errToObj(options == null ? void 0 : options.message)
        });
      }
      startsWith(value, message) {
        return this._addCheck({
          kind: "startsWith",
          value,
          ...errorUtil.errToObj(message)
        });
      }
      endsWith(value, message) {
        return this._addCheck({
          kind: "endsWith",
          value,
          ...errorUtil.errToObj(message)
        });
      }
      min(minLength, message) {
        return this._addCheck({
          kind: "min",
          value: minLength,
          ...errorUtil.errToObj(message)
        });
      }
      max(maxLength, message) {
        return this._addCheck({
          kind: "max",
          value: maxLength,
          ...errorUtil.errToObj(message)
        });
      }
      length(len, message) {
        return this._addCheck({
          kind: "length",
          value: len,
          ...errorUtil.errToObj(message)
        });
      }
      /**
       * Equivalent to `.min(1)`
       */
      nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
      }
      trim() {
        return new _ZodString({
          ...this._def,
          checks: [...this._def.checks, { kind: "trim" }]
        });
      }
      toLowerCase() {
        return new _ZodString({
          ...this._def,
          checks: [...this._def.checks, { kind: "toLowerCase" }]
        });
      }
      toUpperCase() {
        return new _ZodString({
          ...this._def,
          checks: [...this._def.checks, { kind: "toUpperCase" }]
        });
      }
      get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
      }
      get isDate() {
        return !!this._def.checks.find((ch) => ch.kind === "date");
      }
      get isTime() {
        return !!this._def.checks.find((ch) => ch.kind === "time");
      }
      get isDuration() {
        return !!this._def.checks.find((ch) => ch.kind === "duration");
      }
      get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
      }
      get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
      }
      get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
      }
      get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
      }
      get isNANOID() {
        return !!this._def.checks.find((ch) => ch.kind === "nanoid");
      }
      get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
      }
      get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
      }
      get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
      }
      get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
      }
      get isCIDR() {
        return !!this._def.checks.find((ch) => ch.kind === "cidr");
      }
      get isBase64() {
        return !!this._def.checks.find((ch) => ch.kind === "base64");
      }
      get isBase64url() {
        return !!this._def.checks.find((ch) => ch.kind === "base64url");
      }
      get minLength() {
        let min2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "min") {
            if (min2 === null || ch.value > min2)
              min2 = ch.value;
          }
        }
        return min2;
      }
      get maxLength() {
        let max2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "max") {
            if (max2 === null || ch.value < max2)
              max2 = ch.value;
          }
        }
        return max2;
      }
    };
    ZodString.create = (params) => {
      return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (params == null ? void 0 : params.coerce) ?? false,
        ...processCreateParams(params)
      });
    };
    function floatSafeRemainder(val, step) {
      const valDecCount = (val.toString().split(".")[1] || "").length;
      const stepDecCount = (step.toString().split(".")[1] || "").length;
      const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
      const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
      const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
      return valInt % stepInt / 10 ** decCount;
    }
    var ZodNumber = class _ZodNumber extends ZodType {
      constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
      }
      _parse(input) {
        if (this._def.coerce) {
          input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
          const ctx2 = this._getOrReturnCtx(input);
          addIssueToContext(ctx2, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.number,
            received: ctx2.parsedType
          });
          return INVALID;
        }
        let ctx = void 0;
        const status = new ParseStatus();
        for (const check2 of this._def.checks) {
          if (check2.kind === "int") {
            if (!util.isInteger(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: "integer",
                received: "float",
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "min") {
            const tooSmall = check2.inclusive ? input.data < check2.value : input.data <= check2.value;
            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: check2.value,
                type: "number",
                inclusive: check2.inclusive,
                exact: false,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "max") {
            const tooBig = check2.inclusive ? input.data > check2.value : input.data >= check2.value;
            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: check2.value,
                type: "number",
                inclusive: check2.inclusive,
                exact: false,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "multipleOf") {
            if (floatSafeRemainder(input.data, check2.value) !== 0) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_multiple_of,
                multipleOf: check2.value,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "finite") {
            if (!Number.isFinite(input.data)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_finite,
                message: check2.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(check2);
          }
        }
        return { status: status.value, value: input.data };
      }
      gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
      }
      gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
      }
      lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
      }
      lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
      }
      setLimit(kind, value, inclusive, message) {
        return new _ZodNumber({
          ...this._def,
          checks: [
            ...this._def.checks,
            {
              kind,
              value,
              inclusive,
              message: errorUtil.toString(message)
            }
          ]
        });
      }
      _addCheck(check2) {
        return new _ZodNumber({
          ...this._def,
          checks: [...this._def.checks, check2]
        });
      }
      int(message) {
        return this._addCheck({
          kind: "int",
          message: errorUtil.toString(message)
        });
      }
      positive(message) {
        return this._addCheck({
          kind: "min",
          value: 0,
          inclusive: false,
          message: errorUtil.toString(message)
        });
      }
      negative(message) {
        return this._addCheck({
          kind: "max",
          value: 0,
          inclusive: false,
          message: errorUtil.toString(message)
        });
      }
      nonpositive(message) {
        return this._addCheck({
          kind: "max",
          value: 0,
          inclusive: true,
          message: errorUtil.toString(message)
        });
      }
      nonnegative(message) {
        return this._addCheck({
          kind: "min",
          value: 0,
          inclusive: true,
          message: errorUtil.toString(message)
        });
      }
      multipleOf(value, message) {
        return this._addCheck({
          kind: "multipleOf",
          value,
          message: errorUtil.toString(message)
        });
      }
      finite(message) {
        return this._addCheck({
          kind: "finite",
          message: errorUtil.toString(message)
        });
      }
      safe(message) {
        return this._addCheck({
          kind: "min",
          inclusive: true,
          value: Number.MIN_SAFE_INTEGER,
          message: errorUtil.toString(message)
        })._addCheck({
          kind: "max",
          inclusive: true,
          value: Number.MAX_SAFE_INTEGER,
          message: errorUtil.toString(message)
        });
      }
      get minValue() {
        let min2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "min") {
            if (min2 === null || ch.value > min2)
              min2 = ch.value;
          }
        }
        return min2;
      }
      get maxValue() {
        let max2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "max") {
            if (max2 === null || ch.value < max2)
              max2 = ch.value;
          }
        }
        return max2;
      }
      get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
      }
      get isFinite() {
        let max2 = null;
        let min2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
            return true;
          } else if (ch.kind === "min") {
            if (min2 === null || ch.value > min2)
              min2 = ch.value;
          } else if (ch.kind === "max") {
            if (max2 === null || ch.value < max2)
              max2 = ch.value;
          }
        }
        return Number.isFinite(min2) && Number.isFinite(max2);
      }
    };
    ZodNumber.create = (params) => {
      return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params == null ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
      });
    };
    var ZodBigInt = class _ZodBigInt extends ZodType {
      constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
      }
      _parse(input) {
        if (this._def.coerce) {
          try {
            input.data = BigInt(input.data);
          } catch {
            return this._getInvalidInput(input);
          }
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
          return this._getInvalidInput(input);
        }
        let ctx = void 0;
        const status = new ParseStatus();
        for (const check2 of this._def.checks) {
          if (check2.kind === "min") {
            const tooSmall = check2.inclusive ? input.data < check2.value : input.data <= check2.value;
            if (tooSmall) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                type: "bigint",
                minimum: check2.value,
                inclusive: check2.inclusive,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "max") {
            const tooBig = check2.inclusive ? input.data > check2.value : input.data >= check2.value;
            if (tooBig) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                type: "bigint",
                maximum: check2.value,
                inclusive: check2.inclusive,
                message: check2.message
              });
              status.dirty();
            }
          } else if (check2.kind === "multipleOf") {
            if (input.data % check2.value !== BigInt(0)) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.not_multiple_of,
                multipleOf: check2.value,
                message: check2.message
              });
              status.dirty();
            }
          } else {
            util.assertNever(check2);
          }
        }
        return { status: status.value, value: input.data };
      }
      _getInvalidInput(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.bigint,
          received: ctx.parsedType
        });
        return INVALID;
      }
      gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
      }
      gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
      }
      lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
      }
      lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
      }
      setLimit(kind, value, inclusive, message) {
        return new _ZodBigInt({
          ...this._def,
          checks: [
            ...this._def.checks,
            {
              kind,
              value,
              inclusive,
              message: errorUtil.toString(message)
            }
          ]
        });
      }
      _addCheck(check2) {
        return new _ZodBigInt({
          ...this._def,
          checks: [...this._def.checks, check2]
        });
      }
      positive(message) {
        return this._addCheck({
          kind: "min",
          value: BigInt(0),
          inclusive: false,
          message: errorUtil.toString(message)
        });
      }
      negative(message) {
        return this._addCheck({
          kind: "max",
          value: BigInt(0),
          inclusive: false,
          message: errorUtil.toString(message)
        });
      }
      nonpositive(message) {
        return this._addCheck({
          kind: "max",
          value: BigInt(0),
          inclusive: true,
          message: errorUtil.toString(message)
        });
      }
      nonnegative(message) {
        return this._addCheck({
          kind: "min",
          value: BigInt(0),
          inclusive: true,
          message: errorUtil.toString(message)
        });
      }
      multipleOf(value, message) {
        return this._addCheck({
          kind: "multipleOf",
          value,
          message: errorUtil.toString(message)
        });
      }
      get minValue() {
        let min2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "min") {
            if (min2 === null || ch.value > min2)
              min2 = ch.value;
          }
        }
        return min2;
      }
      get maxValue() {
        let max2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "max") {
            if (max2 === null || ch.value < max2)
              max2 = ch.value;
          }
        }
        return max2;
      }
    };
    ZodBigInt.create = (params) => {
      return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (params == null ? void 0 : params.coerce) ?? false,
        ...processCreateParams(params)
      });
    };
    var ZodBoolean = class extends ZodType {
      _parse(input) {
        if (this._def.coerce) {
          input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.boolean,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return OK(input.data);
      }
    };
    ZodBoolean.create = (params) => {
      return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params == null ? void 0 : params.coerce) || false,
        ...processCreateParams(params)
      });
    };
    var ZodDate = class _ZodDate extends ZodType {
      _parse(input) {
        if (this._def.coerce) {
          input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
          const ctx2 = this._getOrReturnCtx(input);
          addIssueToContext(ctx2, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.date,
            received: ctx2.parsedType
          });
          return INVALID;
        }
        if (Number.isNaN(input.data.getTime())) {
          const ctx2 = this._getOrReturnCtx(input);
          addIssueToContext(ctx2, {
            code: ZodIssueCode.invalid_date
          });
          return INVALID;
        }
        const status = new ParseStatus();
        let ctx = void 0;
        for (const check2 of this._def.checks) {
          if (check2.kind === "min") {
            if (input.data.getTime() < check2.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                message: check2.message,
                inclusive: true,
                exact: false,
                minimum: check2.value,
                type: "date"
              });
              status.dirty();
            }
          } else if (check2.kind === "max") {
            if (input.data.getTime() > check2.value) {
              ctx = this._getOrReturnCtx(input, ctx);
              addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                message: check2.message,
                inclusive: true,
                exact: false,
                maximum: check2.value,
                type: "date"
              });
              status.dirty();
            }
          } else {
            util.assertNever(check2);
          }
        }
        return {
          status: status.value,
          value: new Date(input.data.getTime())
        };
      }
      _addCheck(check2) {
        return new _ZodDate({
          ...this._def,
          checks: [...this._def.checks, check2]
        });
      }
      min(minDate, message) {
        return this._addCheck({
          kind: "min",
          value: minDate.getTime(),
          message: errorUtil.toString(message)
        });
      }
      max(maxDate, message) {
        return this._addCheck({
          kind: "max",
          value: maxDate.getTime(),
          message: errorUtil.toString(message)
        });
      }
      get minDate() {
        let min2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "min") {
            if (min2 === null || ch.value > min2)
              min2 = ch.value;
          }
        }
        return min2 != null ? new Date(min2) : null;
      }
      get maxDate() {
        let max2 = null;
        for (const ch of this._def.checks) {
          if (ch.kind === "max") {
            if (max2 === null || ch.value < max2)
              max2 = ch.value;
          }
        }
        return max2 != null ? new Date(max2) : null;
      }
    };
    ZodDate.create = (params) => {
      return new ZodDate({
        checks: [],
        coerce: (params == null ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params)
      });
    };
    var ZodSymbol = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.symbol,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return OK(input.data);
      }
    };
    ZodSymbol.create = (params) => {
      return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params)
      });
    };
    var ZodUndefined = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.undefined,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return OK(input.data);
      }
    };
    ZodUndefined.create = (params) => {
      return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params)
      });
    };
    var ZodNull = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.null,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return OK(input.data);
      }
    };
    ZodNull.create = (params) => {
      return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params)
      });
    };
    var ZodAny = class extends ZodType {
      constructor() {
        super(...arguments);
        this._any = true;
      }
      _parse(input) {
        return OK(input.data);
      }
    };
    ZodAny.create = (params) => {
      return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params)
      });
    };
    var ZodUnknown = class extends ZodType {
      constructor() {
        super(...arguments);
        this._unknown = true;
      }
      _parse(input) {
        return OK(input.data);
      }
    };
    ZodUnknown.create = (params) => {
      return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params)
      });
    };
    var ZodNever = class extends ZodType {
      _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.never,
          received: ctx.parsedType
        });
        return INVALID;
      }
    };
    ZodNever.create = (params) => {
      return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params)
      });
    };
    var ZodVoid = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.void,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return OK(input.data);
      }
    };
    ZodVoid.create = (params) => {
      return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params)
      });
    };
    var ZodArray = class _ZodArray extends ZodType {
      _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.array,
            received: ctx.parsedType
          });
          return INVALID;
        }
        if (def.exactLength !== null) {
          const tooBig = ctx.data.length > def.exactLength.value;
          const tooSmall = ctx.data.length < def.exactLength.value;
          if (tooBig || tooSmall) {
            addIssueToContext(ctx, {
              code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
              minimum: tooSmall ? def.exactLength.value : void 0,
              maximum: tooBig ? def.exactLength.value : void 0,
              type: "array",
              inclusive: true,
              exact: true,
              message: def.exactLength.message
            });
            status.dirty();
          }
        }
        if (def.minLength !== null) {
          if (ctx.data.length < def.minLength.value) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: def.minLength.value,
              type: "array",
              inclusive: true,
              exact: false,
              message: def.minLength.message
            });
            status.dirty();
          }
        }
        if (def.maxLength !== null) {
          if (ctx.data.length > def.maxLength.value) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: def.maxLength.value,
              type: "array",
              inclusive: true,
              exact: false,
              message: def.maxLength.message
            });
            status.dirty();
          }
        }
        if (ctx.common.async) {
          return Promise.all([...ctx.data].map((item, i2) => {
            return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i2));
          })).then((result2) => {
            return ParseStatus.mergeArray(status, result2);
          });
        }
        const result = [...ctx.data].map((item, i2) => {
          return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i2));
        });
        return ParseStatus.mergeArray(status, result);
      }
      get element() {
        return this._def.type;
      }
      min(minLength, message) {
        return new _ZodArray({
          ...this._def,
          minLength: { value: minLength, message: errorUtil.toString(message) }
        });
      }
      max(maxLength, message) {
        return new _ZodArray({
          ...this._def,
          maxLength: { value: maxLength, message: errorUtil.toString(message) }
        });
      }
      length(len, message) {
        return new _ZodArray({
          ...this._def,
          exactLength: { value: len, message: errorUtil.toString(message) }
        });
      }
      nonempty(message) {
        return this.min(1, message);
      }
    };
    ZodArray.create = (schema, params) => {
      return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params)
      });
    };
    function deepPartialify(schema) {
      if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
          const fieldSchema = schema.shape[key];
          newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
          ...schema._def,
          shape: () => newShape
        });
      } else if (schema instanceof ZodArray) {
        return new ZodArray({
          ...schema._def,
          type: deepPartialify(schema.element)
        });
      } else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
      } else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
      } else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
      } else {
        return schema;
      }
    }
    var ZodObject = class _ZodObject extends ZodType {
      constructor() {
        super(...arguments);
        this._cached = null;
        this.nonstrict = this.passthrough;
        this.augment = this.extend;
      }
      _getCached() {
        if (this._cached !== null)
          return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        this._cached = { shape, keys };
        return this._cached;
      }
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
          const ctx2 = this._getOrReturnCtx(input);
          addIssueToContext(ctx2, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.object,
            received: ctx2.parsedType
          });
          return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
          for (const key in ctx.data) {
            if (!shapeKeys.includes(key)) {
              extraKeys.push(key);
            }
          }
        }
        const pairs = [];
        for (const key of shapeKeys) {
          const keyValidator = shape[key];
          const value = ctx.data[key];
          pairs.push({
            key: { status: "valid", value: key },
            value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
            alwaysSet: key in ctx.data
          });
        }
        if (this._def.catchall instanceof ZodNever) {
          const unknownKeys = this._def.unknownKeys;
          if (unknownKeys === "passthrough") {
            for (const key of extraKeys) {
              pairs.push({
                key: { status: "valid", value: key },
                value: { status: "valid", value: ctx.data[key] }
              });
            }
          } else if (unknownKeys === "strict") {
            if (extraKeys.length > 0) {
              addIssueToContext(ctx, {
                code: ZodIssueCode.unrecognized_keys,
                keys: extraKeys
              });
              status.dirty();
            }
          } else if (unknownKeys === "strip") {
          } else {
            throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
          }
        } else {
          const catchall = this._def.catchall;
          for (const key of extraKeys) {
            const value = ctx.data[key];
            pairs.push({
              key: { status: "valid", value: key },
              value: catchall._parse(
                new ParseInputLazyPath(ctx, value, ctx.path, key)
                //, ctx.child(key), value, getParsedType(value)
              ),
              alwaysSet: key in ctx.data
            });
          }
        }
        if (ctx.common.async) {
          return Promise.resolve().then(async () => {
            const syncPairs = [];
            for (const pair of pairs) {
              const key = await pair.key;
              const value = await pair.value;
              syncPairs.push({
                key,
                value,
                alwaysSet: pair.alwaysSet
              });
            }
            return syncPairs;
          }).then((syncPairs) => {
            return ParseStatus.mergeObjectSync(status, syncPairs);
          });
        } else {
          return ParseStatus.mergeObjectSync(status, pairs);
        }
      }
      get shape() {
        return this._def.shape();
      }
      strict(message) {
        errorUtil.errToObj;
        return new _ZodObject({
          ...this._def,
          unknownKeys: "strict",
          ...message !== void 0 ? {
            errorMap: (issue, ctx) => {
              var _a, _b;
              const defaultError = ((_b = (_a = this._def).errorMap) == null ? void 0 : _b.call(_a, issue, ctx).message) ?? ctx.defaultError;
              if (issue.code === "unrecognized_keys")
                return {
                  message: errorUtil.errToObj(message).message ?? defaultError
                };
              return {
                message: defaultError
              };
            }
          } : {}
        });
      }
      strip() {
        return new _ZodObject({
          ...this._def,
          unknownKeys: "strip"
        });
      }
      passthrough() {
        return new _ZodObject({
          ...this._def,
          unknownKeys: "passthrough"
        });
      }
      // const AugmentFactory =
      //   <Def extends ZodObjectDef>(def: Def) =>
      //   <Augmentation extends ZodRawShape>(
      //     augmentation: Augmentation
      //   ): ZodObject<
      //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
      //     Def["unknownKeys"],
      //     Def["catchall"]
      //   > => {
      //     return new ZodObject({
      //       ...def,
      //       shape: () => ({
      //         ...def.shape(),
      //         ...augmentation,
      //       }),
      //     }) as any;
      //   };
      extend(augmentation) {
        return new _ZodObject({
          ...this._def,
          shape: () => ({
            ...this._def.shape(),
            ...augmentation
          })
        });
      }
      /**
       * Prior to zod@1.0.12 there was a bug in the
       * inferred type of merged objects. Please
       * upgrade if you are experiencing issues.
       */
      merge(merging) {
        const merged = new _ZodObject({
          unknownKeys: merging._def.unknownKeys,
          catchall: merging._def.catchall,
          shape: () => ({
            ...this._def.shape(),
            ...merging._def.shape()
          }),
          typeName: ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
      }
      // merge<
      //   Incoming extends AnyZodObject,
      //   Augmentation extends Incoming["shape"],
      //   NewOutput extends {
      //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
      //       ? Augmentation[k]["_output"]
      //       : k extends keyof Output
      //       ? Output[k]
      //       : never;
      //   },
      //   NewInput extends {
      //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
      //       ? Augmentation[k]["_input"]
      //       : k extends keyof Input
      //       ? Input[k]
      //       : never;
      //   }
      // >(
      //   merging: Incoming
      // ): ZodObject<
      //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
      //   Incoming["_def"]["unknownKeys"],
      //   Incoming["_def"]["catchall"],
      //   NewOutput,
      //   NewInput
      // > {
      //   const merged: any = new ZodObject({
      //     unknownKeys: merging._def.unknownKeys,
      //     catchall: merging._def.catchall,
      //     shape: () =>
      //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
      //     typeName: ZodFirstPartyTypeKind.ZodObject,
      //   }) as any;
      //   return merged;
      // }
      setKey(key, schema) {
        return this.augment({ [key]: schema });
      }
      // merge<Incoming extends AnyZodObject>(
      //   merging: Incoming
      // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
      // ZodObject<
      //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
      //   Incoming["_def"]["unknownKeys"],
      //   Incoming["_def"]["catchall"]
      // > {
      //   // const mergedShape = objectUtil.mergeShapes(
      //   //   this._def.shape(),
      //   //   merging._def.shape()
      //   // );
      //   const merged: any = new ZodObject({
      //     unknownKeys: merging._def.unknownKeys,
      //     catchall: merging._def.catchall,
      //     shape: () =>
      //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
      //     typeName: ZodFirstPartyTypeKind.ZodObject,
      //   }) as any;
      //   return merged;
      // }
      catchall(index) {
        return new _ZodObject({
          ...this._def,
          catchall: index
        });
      }
      pick(mask) {
        const shape = {};
        for (const key of util.objectKeys(mask)) {
          if (mask[key] && this.shape[key]) {
            shape[key] = this.shape[key];
          }
        }
        return new _ZodObject({
          ...this._def,
          shape: () => shape
        });
      }
      omit(mask) {
        const shape = {};
        for (const key of util.objectKeys(this.shape)) {
          if (!mask[key]) {
            shape[key] = this.shape[key];
          }
        }
        return new _ZodObject({
          ...this._def,
          shape: () => shape
        });
      }
      /**
       * @deprecated
       */
      deepPartial() {
        return deepPartialify(this);
      }
      partial(mask) {
        const newShape = {};
        for (const key of util.objectKeys(this.shape)) {
          const fieldSchema = this.shape[key];
          if (mask && !mask[key]) {
            newShape[key] = fieldSchema;
          } else {
            newShape[key] = fieldSchema.optional();
          }
        }
        return new _ZodObject({
          ...this._def,
          shape: () => newShape
        });
      }
      required(mask) {
        const newShape = {};
        for (const key of util.objectKeys(this.shape)) {
          if (mask && !mask[key]) {
            newShape[key] = this.shape[key];
          } else {
            const fieldSchema = this.shape[key];
            let newField = fieldSchema;
            while (newField instanceof ZodOptional) {
              newField = newField._def.innerType;
            }
            newShape[key] = newField;
          }
        }
        return new _ZodObject({
          ...this._def,
          shape: () => newShape
        });
      }
      keyof() {
        return createZodEnum(util.objectKeys(this.shape));
      }
    };
    ZodObject.create = (shape, params) => {
      return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
      });
    };
    ZodObject.strictCreate = (shape, params) => {
      return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
      });
    };
    ZodObject.lazycreate = (shape, params) => {
      return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params)
      });
    };
    var ZodUnion = class extends ZodType {
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
          for (const result of results) {
            if (result.result.status === "valid") {
              return result.result;
            }
          }
          for (const result of results) {
            if (result.result.status === "dirty") {
              ctx.common.issues.push(...result.ctx.common.issues);
              return result.result;
            }
          }
          const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_union,
            unionErrors
          });
          return INVALID;
        }
        if (ctx.common.async) {
          return Promise.all(options.map(async (option) => {
            const childCtx = {
              ...ctx,
              common: {
                ...ctx.common,
                issues: []
              },
              parent: null
            };
            return {
              result: await option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: childCtx
              }),
              ctx: childCtx
            };
          })).then(handleResults);
        } else {
          let dirty = void 0;
          const issues = [];
          for (const option of options) {
            const childCtx = {
              ...ctx,
              common: {
                ...ctx.common,
                issues: []
              },
              parent: null
            };
            const result = option._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: childCtx
            });
            if (result.status === "valid") {
              return result;
            } else if (result.status === "dirty" && !dirty) {
              dirty = { result, ctx: childCtx };
            }
            if (childCtx.common.issues.length) {
              issues.push(childCtx.common.issues);
            }
          }
          if (dirty) {
            ctx.common.issues.push(...dirty.ctx.common.issues);
            return dirty.result;
          }
          const unionErrors = issues.map((issues2) => new ZodError(issues2));
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_union,
            unionErrors
          });
          return INVALID;
        }
      }
      get options() {
        return this._def.options;
      }
    };
    ZodUnion.create = (types, params) => {
      return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params)
      });
    };
    var getDiscriminator = (type) => {
      if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
      } else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
      } else if (type instanceof ZodLiteral) {
        return [type.value];
      } else if (type instanceof ZodEnum) {
        return type.options;
      } else if (type instanceof ZodNativeEnum) {
        return util.objectValues(type.enum);
      } else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
      } else if (type instanceof ZodUndefined) {
        return [void 0];
      } else if (type instanceof ZodNull) {
        return [null];
      } else if (type instanceof ZodOptional) {
        return [void 0, ...getDiscriminator(type.unwrap())];
      } else if (type instanceof ZodNullable) {
        return [null, ...getDiscriminator(type.unwrap())];
      } else if (type instanceof ZodBranded) {
        return getDiscriminator(type.unwrap());
      } else if (type instanceof ZodReadonly) {
        return getDiscriminator(type.unwrap());
      } else if (type instanceof ZodCatch) {
        return getDiscriminator(type._def.innerType);
      } else {
        return [];
      }
    };
    var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.object,
            received: ctx.parsedType
          });
          return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_union_discriminator,
            options: Array.from(this.optionsMap.keys()),
            path: [discriminator]
          });
          return INVALID;
        }
        if (ctx.common.async) {
          return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
        } else {
          return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
        }
      }
      get discriminator() {
        return this._def.discriminator;
      }
      get options() {
        return this._def.options;
      }
      get optionsMap() {
        return this._def.optionsMap;
      }
      /**
       * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
       * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
       * have a different value for each object in the union.
       * @param discriminator the name of the discriminator property
       * @param types an array of object schemas
       * @param params
       */
      static create(discriminator, options, params) {
        const optionsMap = /* @__PURE__ */ new Map();
        for (const type of options) {
          const discriminatorValues = getDiscriminator(type.shape[discriminator]);
          if (!discriminatorValues.length) {
            throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
          }
          for (const value of discriminatorValues) {
            if (optionsMap.has(value)) {
              throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
            }
            optionsMap.set(value, type);
          }
        }
        return new _ZodDiscriminatedUnion({
          typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
          discriminator,
          options,
          optionsMap,
          ...processCreateParams(params)
        });
      }
    };
    function mergeValues(a3, b2) {
      const aType = getParsedType(a3);
      const bType = getParsedType(b2);
      if (a3 === b2) {
        return { valid: true, data: a3 };
      } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b2);
        const sharedKeys = util.objectKeys(a3).filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a3, ...b2 };
        for (const key of sharedKeys) {
          const sharedValue = mergeValues(a3[key], b2[key]);
          if (!sharedValue.valid) {
            return { valid: false };
          }
          newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
      } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a3.length !== b2.length) {
          return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a3.length; index++) {
          const itemA = a3[index];
          const itemB = b2[index];
          const sharedValue = mergeValues(itemA, itemB);
          if (!sharedValue.valid) {
            return { valid: false };
          }
          newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
      } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a3 === +b2) {
        return { valid: true, data: a3 };
      } else {
        return { valid: false };
      }
    }
    var ZodIntersection = class extends ZodType {
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
          if (isAborted(parsedLeft) || isAborted(parsedRight)) {
            return INVALID;
          }
          const merged = mergeValues(parsedLeft.value, parsedRight.value);
          if (!merged.valid) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.invalid_intersection_types
            });
            return INVALID;
          }
          if (isDirty(parsedLeft) || isDirty(parsedRight)) {
            status.dirty();
          }
          return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
          return Promise.all([
            this._def.left._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: ctx
            }),
            this._def.right._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: ctx
            })
          ]).then(([left, right]) => handleParsed(left, right));
        } else {
          return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          }));
        }
      }
    };
    ZodIntersection.create = (left, right, params) => {
      return new ZodIntersection({
        left,
        right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params)
      });
    };
    var ZodTuple = class _ZodTuple extends ZodType {
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.array,
            received: ctx.parsedType
          });
          return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: this._def.items.length,
            inclusive: true,
            exact: false,
            type: "array"
          });
          return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: this._def.items.length,
            inclusive: true,
            exact: false,
            type: "array"
          });
          status.dirty();
        }
        const items = [...ctx.data].map((item, itemIndex) => {
          const schema = this._def.items[itemIndex] || this._def.rest;
          if (!schema)
            return null;
          return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x2) => !!x2);
        if (ctx.common.async) {
          return Promise.all(items).then((results) => {
            return ParseStatus.mergeArray(status, results);
          });
        } else {
          return ParseStatus.mergeArray(status, items);
        }
      }
      get items() {
        return this._def.items;
      }
      rest(rest) {
        return new _ZodTuple({
          ...this._def,
          rest
        });
      }
    };
    ZodTuple.create = (schemas, params) => {
      if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
      }
      return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params)
      });
    };
    var ZodRecord = class _ZodRecord extends ZodType {
      get keySchema() {
        return this._def.keyType;
      }
      get valueSchema() {
        return this._def.valueType;
      }
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.object,
            received: ctx.parsedType
          });
          return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
          pairs.push({
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
          });
        }
        if (ctx.common.async) {
          return ParseStatus.mergeObjectAsync(status, pairs);
        } else {
          return ParseStatus.mergeObjectSync(status, pairs);
        }
      }
      get element() {
        return this._def.valueType;
      }
      static create(first, second, third) {
        if (second instanceof ZodType) {
          return new _ZodRecord({
            keyType: first,
            valueType: second,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(third)
          });
        }
        return new _ZodRecord({
          keyType: ZodString.create(),
          valueType: first,
          typeName: ZodFirstPartyTypeKind.ZodRecord,
          ...processCreateParams(second)
        });
      }
    };
    var ZodMap = class extends ZodType {
      get keySchema() {
        return this._def.keyType;
      }
      get valueSchema() {
        return this._def.valueType;
      }
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.map,
            received: ctx.parsedType
          });
          return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
          return {
            key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
            value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
          };
        });
        if (ctx.common.async) {
          const finalMap = /* @__PURE__ */ new Map();
          return Promise.resolve().then(async () => {
            for (const pair of pairs) {
              const key = await pair.key;
              const value = await pair.value;
              if (key.status === "aborted" || value.status === "aborted") {
                return INVALID;
              }
              if (key.status === "dirty" || value.status === "dirty") {
                status.dirty();
              }
              finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
          });
        } else {
          const finalMap = /* @__PURE__ */ new Map();
          for (const pair of pairs) {
            const key = pair.key;
            const value = pair.value;
            if (key.status === "aborted" || value.status === "aborted") {
              return INVALID;
            }
            if (key.status === "dirty" || value.status === "dirty") {
              status.dirty();
            }
            finalMap.set(key.value, value.value);
          }
          return { status: status.value, value: finalMap };
        }
      }
    };
    ZodMap.create = (keyType, valueType, params) => {
      return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params)
      });
    };
    var ZodSet = class _ZodSet extends ZodType {
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.set,
            received: ctx.parsedType
          });
          return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
          if (ctx.data.size < def.minSize.value) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: def.minSize.value,
              type: "set",
              inclusive: true,
              exact: false,
              message: def.minSize.message
            });
            status.dirty();
          }
        }
        if (def.maxSize !== null) {
          if (ctx.data.size > def.maxSize.value) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: def.maxSize.value,
              type: "set",
              inclusive: true,
              exact: false,
              message: def.maxSize.message
            });
            status.dirty();
          }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements2) {
          const parsedSet = /* @__PURE__ */ new Set();
          for (const element of elements2) {
            if (element.status === "aborted")
              return INVALID;
            if (element.status === "dirty")
              status.dirty();
            parsedSet.add(element.value);
          }
          return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i2) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i2)));
        if (ctx.common.async) {
          return Promise.all(elements).then((elements2) => finalizeSet(elements2));
        } else {
          return finalizeSet(elements);
        }
      }
      min(minSize, message) {
        return new _ZodSet({
          ...this._def,
          minSize: { value: minSize, message: errorUtil.toString(message) }
        });
      }
      max(maxSize, message) {
        return new _ZodSet({
          ...this._def,
          maxSize: { value: maxSize, message: errorUtil.toString(message) }
        });
      }
      size(size, message) {
        return this.min(size, message).max(size, message);
      }
      nonempty(message) {
        return this.min(1, message);
      }
    };
    ZodSet.create = (valueType, params) => {
      return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params)
      });
    };
    var ZodFunction = class _ZodFunction extends ZodType {
      constructor() {
        super(...arguments);
        this.validate = this.implement;
      }
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.function,
            received: ctx.parsedType
          });
          return INVALID;
        }
        function makeArgsIssue(args, error) {
          return makeIssue({
            data: args,
            path: ctx.path,
            errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x2) => !!x2),
            issueData: {
              code: ZodIssueCode.invalid_arguments,
              argumentsError: error
            }
          });
        }
        function makeReturnsIssue(returns, error) {
          return makeIssue({
            data: returns,
            path: ctx.path,
            errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, getErrorMap(), en_default].filter((x2) => !!x2),
            issueData: {
              code: ZodIssueCode.invalid_return_type,
              returnTypeError: error
            }
          });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
          const me = this;
          return OK(async function(...args) {
            const error = new ZodError([]);
            const parsedArgs = await me._def.args.parseAsync(args, params).catch((e2) => {
              error.addIssue(makeArgsIssue(args, e2));
              throw error;
            });
            const result = await Reflect.apply(fn, this, parsedArgs);
            const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e2) => {
              error.addIssue(makeReturnsIssue(result, e2));
              throw error;
            });
            return parsedReturns;
          });
        } else {
          const me = this;
          return OK(function(...args) {
            const parsedArgs = me._def.args.safeParse(args, params);
            if (!parsedArgs.success) {
              throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
            }
            const result = Reflect.apply(fn, this, parsedArgs.data);
            const parsedReturns = me._def.returns.safeParse(result, params);
            if (!parsedReturns.success) {
              throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
            }
            return parsedReturns.data;
          });
        }
      }
      parameters() {
        return this._def.args;
      }
      returnType() {
        return this._def.returns;
      }
      args(...items) {
        return new _ZodFunction({
          ...this._def,
          args: ZodTuple.create(items).rest(ZodUnknown.create())
        });
      }
      returns(returnType) {
        return new _ZodFunction({
          ...this._def,
          returns: returnType
        });
      }
      implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
      }
      strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
      }
      static create(args, returns, params) {
        return new _ZodFunction({
          args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
          returns: returns || ZodUnknown.create(),
          typeName: ZodFirstPartyTypeKind.ZodFunction,
          ...processCreateParams(params)
        });
      }
    };
    var ZodLazy = class extends ZodType {
      get schema() {
        return this._def.getter();
      }
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
      }
    };
    ZodLazy.create = (getter, params) => {
      return new ZodLazy({
        getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params)
      });
    };
    var ZodLiteral = class extends ZodType {
      _parse(input) {
        if (input.data !== this._def.value) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            received: ctx.data,
            code: ZodIssueCode.invalid_literal,
            expected: this._def.value
          });
          return INVALID;
        }
        return { status: "valid", value: input.data };
      }
      get value() {
        return this._def.value;
      }
    };
    ZodLiteral.create = (value, params) => {
      return new ZodLiteral({
        value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params)
      });
    };
    function createZodEnum(values, params) {
      return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params)
      });
    }
    var ZodEnum = class _ZodEnum extends ZodType {
      _parse(input) {
        if (typeof input.data !== "string") {
          const ctx = this._getOrReturnCtx(input);
          const expectedValues = this._def.values;
          addIssueToContext(ctx, {
            expected: util.joinValues(expectedValues),
            received: ctx.parsedType,
            code: ZodIssueCode.invalid_type
          });
          return INVALID;
        }
        if (!this._cache) {
          this._cache = new Set(this._def.values);
        }
        if (!this._cache.has(input.data)) {
          const ctx = this._getOrReturnCtx(input);
          const expectedValues = this._def.values;
          addIssueToContext(ctx, {
            received: ctx.data,
            code: ZodIssueCode.invalid_enum_value,
            options: expectedValues
          });
          return INVALID;
        }
        return OK(input.data);
      }
      get options() {
        return this._def.values;
      }
      get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
          enumValues[val] = val;
        }
        return enumValues;
      }
      get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
          enumValues[val] = val;
        }
        return enumValues;
      }
      get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
          enumValues[val] = val;
        }
        return enumValues;
      }
      extract(values, newDef = this._def) {
        return _ZodEnum.create(values, {
          ...this._def,
          ...newDef
        });
      }
      exclude(values, newDef = this._def) {
        return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)), {
          ...this._def,
          ...newDef
        });
      }
    };
    ZodEnum.create = createZodEnum;
    var ZodNativeEnum = class extends ZodType {
      _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
          const expectedValues = util.objectValues(nativeEnumValues);
          addIssueToContext(ctx, {
            expected: util.joinValues(expectedValues),
            received: ctx.parsedType,
            code: ZodIssueCode.invalid_type
          });
          return INVALID;
        }
        if (!this._cache) {
          this._cache = new Set(util.getValidEnumValues(this._def.values));
        }
        if (!this._cache.has(input.data)) {
          const expectedValues = util.objectValues(nativeEnumValues);
          addIssueToContext(ctx, {
            received: ctx.data,
            code: ZodIssueCode.invalid_enum_value,
            options: expectedValues
          });
          return INVALID;
        }
        return OK(input.data);
      }
      get enum() {
        return this._def.values;
      }
    };
    ZodNativeEnum.create = (values, params) => {
      return new ZodNativeEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params)
      });
    };
    var ZodPromise = class extends ZodType {
      unwrap() {
        return this._def.type;
      }
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.promise,
            received: ctx.parsedType
          });
          return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
          return this._def.type.parseAsync(data, {
            path: ctx.path,
            errorMap: ctx.common.contextualErrorMap
          });
        }));
      }
    };
    ZodPromise.create = (schema, params) => {
      return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params)
      });
    };
    var ZodEffects = class extends ZodType {
      innerType() {
        return this._def.schema;
      }
      sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
      }
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
          addIssue: (arg) => {
            addIssueToContext(ctx, arg);
            if (arg.fatal) {
              status.abort();
            } else {
              status.dirty();
            }
          },
          get path() {
            return ctx.path;
          }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
          const processed = effect.transform(ctx.data, checkCtx);
          if (ctx.common.async) {
            return Promise.resolve(processed).then(async (processed2) => {
              if (status.value === "aborted")
                return INVALID;
              const result = await this._def.schema._parseAsync({
                data: processed2,
                path: ctx.path,
                parent: ctx
              });
              if (result.status === "aborted")
                return INVALID;
              if (result.status === "dirty")
                return DIRTY(result.value);
              if (status.value === "dirty")
                return DIRTY(result.value);
              return result;
            });
          } else {
            if (status.value === "aborted")
              return INVALID;
            const result = this._def.schema._parseSync({
              data: processed,
              path: ctx.path,
              parent: ctx
            });
            if (result.status === "aborted")
              return INVALID;
            if (result.status === "dirty")
              return DIRTY(result.value);
            if (status.value === "dirty")
              return DIRTY(result.value);
            return result;
          }
        }
        if (effect.type === "refinement") {
          const executeRefinement = (acc) => {
            const result = effect.refinement(acc, checkCtx);
            if (ctx.common.async) {
              return Promise.resolve(result);
            }
            if (result instanceof Promise) {
              throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
            }
            return acc;
          };
          if (ctx.common.async === false) {
            const inner = this._def.schema._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: ctx
            });
            if (inner.status === "aborted")
              return INVALID;
            if (inner.status === "dirty")
              status.dirty();
            executeRefinement(inner.value);
            return { status: status.value, value: inner.value };
          } else {
            return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
              if (inner.status === "aborted")
                return INVALID;
              if (inner.status === "dirty")
                status.dirty();
              return executeRefinement(inner.value).then(() => {
                return { status: status.value, value: inner.value };
              });
            });
          }
        }
        if (effect.type === "transform") {
          if (ctx.common.async === false) {
            const base = this._def.schema._parseSync({
              data: ctx.data,
              path: ctx.path,
              parent: ctx
            });
            if (!isValid2(base))
              return INVALID;
            const result = effect.transform(base.value, checkCtx);
            if (result instanceof Promise) {
              throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
            }
            return { status: status.value, value: result };
          } else {
            return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
              if (!isValid2(base))
                return INVALID;
              return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({
                status: status.value,
                value: result
              }));
            });
          }
        }
        util.assertNever(effect);
      }
    };
    ZodEffects.create = (schema, effect, params) => {
      return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params)
      });
    };
    ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
      return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params)
      });
    };
    var ZodOptional = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
          return OK(void 0);
        }
        return this._def.innerType._parse(input);
      }
      unwrap() {
        return this._def.innerType;
      }
    };
    ZodOptional.create = (type, params) => {
      return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params)
      });
    };
    var ZodNullable = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
          return OK(null);
        }
        return this._def.innerType._parse(input);
      }
      unwrap() {
        return this._def.innerType;
      }
    };
    ZodNullable.create = (type, params) => {
      return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params)
      });
    };
    var ZodDefault = class extends ZodType {
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
          data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
          data,
          path: ctx.path,
          parent: ctx
        });
      }
      removeDefault() {
        return this._def.innerType;
      }
    };
    ZodDefault.create = (type, params) => {
      return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : () => params.default,
        ...processCreateParams(params)
      });
    };
    var ZodCatch = class extends ZodType {
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        const newCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          }
        };
        const result = this._def.innerType._parse({
          data: newCtx.data,
          path: newCtx.path,
          parent: {
            ...newCtx
          }
        });
        if (isAsync(result)) {
          return result.then((result2) => {
            return {
              status: "valid",
              value: result2.status === "valid" ? result2.value : this._def.catchValue({
                get error() {
                  return new ZodError(newCtx.common.issues);
                },
                input: newCtx.data
              })
            };
          });
        } else {
          return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
              get error() {
                return new ZodError(newCtx.common.issues);
              },
              input: newCtx.data
            })
          };
        }
      }
      removeCatch() {
        return this._def.innerType;
      }
    };
    ZodCatch.create = (type, params) => {
      return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params)
      });
    };
    var ZodNaN = class extends ZodType {
      _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
          const ctx = this._getOrReturnCtx(input);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.nan,
            received: ctx.parsedType
          });
          return INVALID;
        }
        return { status: "valid", value: input.data };
      }
    };
    ZodNaN.create = (params) => {
      return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params)
      });
    };
    var BRAND = Symbol("zod_brand");
    var ZodBranded = class extends ZodType {
      _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
          data,
          path: ctx.path,
          parent: ctx
        });
      }
      unwrap() {
        return this._def.type;
      }
    };
    var ZodPipeline = class _ZodPipeline extends ZodType {
      _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
          const handleAsync = async () => {
            const inResult = await this._def.in._parseAsync({
              data: ctx.data,
              path: ctx.path,
              parent: ctx
            });
            if (inResult.status === "aborted")
              return INVALID;
            if (inResult.status === "dirty") {
              status.dirty();
              return DIRTY(inResult.value);
            } else {
              return this._def.out._parseAsync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
              });
            }
          };
          return handleAsync();
        } else {
          const inResult = this._def.in._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
          });
          if (inResult.status === "aborted")
            return INVALID;
          if (inResult.status === "dirty") {
            status.dirty();
            return {
              status: "dirty",
              value: inResult.value
            };
          } else {
            return this._def.out._parseSync({
              data: inResult.value,
              path: ctx.path,
              parent: ctx
            });
          }
        }
      }
      static create(a3, b2) {
        return new _ZodPipeline({
          in: a3,
          out: b2,
          typeName: ZodFirstPartyTypeKind.ZodPipeline
        });
      }
    };
    var ZodReadonly = class extends ZodType {
      _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data) => {
          if (isValid2(data)) {
            data.value = Object.freeze(data.value);
          }
          return data;
        };
        return isAsync(result) ? result.then((data) => freeze(data)) : freeze(result);
      }
      unwrap() {
        return this._def.innerType;
      }
    };
    ZodReadonly.create = (type, params) => {
      return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params)
      });
    };
    function cleanParams(params, data) {
      const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
      const p2 = typeof p === "string" ? { message: p } : p;
      return p2;
    }
    function custom(check2, _params = {}, fatal) {
      if (check2)
        return ZodAny.create().superRefine((data, ctx) => {
          const r = check2(data);
          if (r instanceof Promise) {
            return r.then((r2) => {
              if (!r2) {
                const params = cleanParams(_params, data);
                const _fatal = params.fatal ?? fatal ?? true;
                ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
              }
            });
          }
          if (!r) {
            const params = cleanParams(_params, data);
            const _fatal = params.fatal ?? fatal ?? true;
            ctx.addIssue({ code: "custom", ...params, fatal: _fatal });
          }
          return;
        });
      return ZodAny.create();
    }
    var late = {
      object: ZodObject.lazycreate
    };
    var ZodFirstPartyTypeKind;
    (function(ZodFirstPartyTypeKind2) {
      ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
      ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
      ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
      ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
      ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
      ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
      ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
      ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
      ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
      ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
      ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
      ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
      ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
      ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
      ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
      ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
      ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
      ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
      ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
      ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
      ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
      ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
      ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
      ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
      ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
      ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
      ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
      ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
      ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
      ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
      ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
      ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
      ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
      ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
      ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
      ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
    })(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
    var instanceOfType = (cls, params = {
      message: `Input not instance of ${cls.name}`
    }) => custom((data) => data instanceof cls, params);
    var stringType = ZodString.create;
    var numberType = ZodNumber.create;
    var nanType = ZodNaN.create;
    var bigIntType = ZodBigInt.create;
    var booleanType = ZodBoolean.create;
    var dateType = ZodDate.create;
    var symbolType = ZodSymbol.create;
    var undefinedType = ZodUndefined.create;
    var nullType = ZodNull.create;
    var anyType = ZodAny.create;
    var unknownType = ZodUnknown.create;
    var neverType = ZodNever.create;
    var voidType = ZodVoid.create;
    var arrayType = ZodArray.create;
    var objectType = ZodObject.create;
    var strictObjectType = ZodObject.strictCreate;
    var unionType = ZodUnion.create;
    var discriminatedUnionType = ZodDiscriminatedUnion.create;
    var intersectionType = ZodIntersection.create;
    var tupleType = ZodTuple.create;
    var recordType = ZodRecord.create;
    var mapType = ZodMap.create;
    var setType = ZodSet.create;
    var functionType = ZodFunction.create;
    var lazyType = ZodLazy.create;
    var literalType = ZodLiteral.create;
    var enumType = ZodEnum.create;
    var nativeEnumType = ZodNativeEnum.create;
    var promiseType = ZodPromise.create;
    var effectsType = ZodEffects.create;
    var optionalType = ZodOptional.create;
    var nullableType = ZodNullable.create;
    var preprocessType = ZodEffects.createWithPreprocess;
    var pipelineType = ZodPipeline.create;
    var ostring = () => stringType().optional();
    var onumber = () => numberType().optional();
    var oboolean = () => booleanType().optional();
    var coerce = {
      string: (arg) => ZodString.create({ ...arg, coerce: true }),
      number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
      boolean: (arg) => ZodBoolean.create({
        ...arg,
        coerce: true
      }),
      bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
      date: (arg) => ZodDate.create({ ...arg, coerce: true })
    };
    var NEVER = INVALID;
    var LIST_STATE_SNAPSHOT_VERSION = 1;
    var listStateResourceSchema = external_exports.enum(["claim", "sinister"]);
    var LIST_STATE_RESOURCES = listStateResourceSchema.options;
    var listStateSnapshotSchema = external_exports.object({
      version: external_exports.literal(LIST_STATE_SNAPSHOT_VERSION),
      full_url: external_exports.string(),
      scroll_y: external_exports.number(),
      specs: external_exports.object({
        visible_filters: external_exports.array(external_exports.string()),
        columns: external_exports.array(external_exports.string()),
        sorting: external_exports.array(
          external_exports.object({
            id: external_exports.string(),
            desc: external_exports.boolean()
          })
        ),
        pagination: external_exports.object({
          pageIndex: external_exports.number().int().nonnegative(),
          pageSize: external_exports.number().int().positive()
        }),
        filters: external_exports.array(
          external_exports.object({
            column: external_exports.string(),
            value: external_exports.string(),
            display_value: external_exports.string().optional()
          })
        ),
        search: external_exports.string().optional(),
        virtual_view_id: external_exports.string().optional()
      }),
      saved_at: external_exports.number()
    });
    var buildStorageKey = (resource) => `piramid:list-state:${resource}`;
    var isBrowser = () => typeof window !== "undefined";
    var getListStateSnapshot = (resource) => {
      if (!isBrowser()) return null;
      const key = buildStorageKey(resource);
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      try {
        const parsed = listStateSnapshotSchema.safeParse(JSON.parse(raw));
        if (!parsed.success) {
          window.sessionStorage.removeItem(key);
          return null;
        }
        return parsed.data;
      } catch {
        window.sessionStorage.removeItem(key);
        return null;
      }
    };
    var setListStateSnapshot = (resource, snapshot) => {
      if (!isBrowser()) return;
      const payload = {
        ...snapshot,
        version: LIST_STATE_SNAPSHOT_VERSION,
        saved_at: Date.now()
      };
      window.sessionStorage.setItem(
        buildStorageKey(resource),
        JSON.stringify(payload)
      );
    };
    var clearListStateSnapshot = (resource) => {
      if (!isBrowser()) return;
      window.sessionStorage.removeItem(buildStorageKey(resource));
    };
    var clearAllListStateSnapshots = () => {
      LIST_STATE_RESOURCES.forEach(clearListStateSnapshot);
    };
    var SCROLL_CONTAINER_ATTRIBUTE = "data-scroll-container";
    var getScrollContainer = () => {
      if (typeof window === "undefined") return null;
      return document.querySelector(`[${SCROLL_CONTAINER_ATTRIBUTE}]`) ?? document.scrollingElement;
    };
    var separatorsByFormat = {
      "es-AR": { decimal: ",", group: "." },
      "en-US": { decimal: ".", group: "," }
    };
    var CURRENCY_NOISE = /^(ars|usd|eur|u\$s|\$|€)|(ars|usd|eur|\$|€)$/gi;
    var WHITESPACE = /\s/g;
    var MAX_DECIMALS = 2;
    var parseDecimalAmount = (raw, format2) => {
      const trimmed = (raw ?? "").trim();
      if (!trimmed) return { ok: false, reason: "empty" };
      const withoutNoise = trimmed.replace(WHITESPACE, "").replace(CURRENCY_NOISE, "");
      const sign = withoutNoise.startsWith("-") ? -1 : 1;
      const unsigned = withoutNoise.replace(/^[+-]/, "");
      if (!unsigned || !/^[0-9.,]+$/.test(unsigned))
        return { ok: false, reason: "not_a_number" };
      const { decimal, group } = separatorsByFormat[format2];
      const decimalOccurrences = unsigned.split(decimal).length - 1;
      if (decimalOccurrences > 1) return { ok: false, reason: "not_a_number" };
      const [integerPart, decimalPart = ""] = unsigned.split(decimal);
      if (decimalOccurrences === 1 && !/^\d+$/.test(decimalPart))
        return { ok: false, reason: "not_a_number" };
      if (decimalPart.length > MAX_DECIMALS)
        return { ok: false, reason: "too_many_decimals" };
      const integerDigits = stripGroupingOrNull(integerPart, group);
      if (integerDigits === null)
        return { ok: false, reason: "ambiguous_grouping" };
      const value = sign * Number(`${integerDigits || "0"}.${decimalPart || "0"}`);
      if (!Number.isFinite(value)) return { ok: false, reason: "not_a_number" };
      return { ok: true, value };
    };
    var escapeForCharClass = (separator) => separator.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    var stripGroupingOrNull = (integerPart, group) => {
      if (!integerPart) return "";
      if (!integerPart.includes(group))
        return /^\d+$/.test(integerPart) ? integerPart : null;
      const grouping = new RegExp(
        `^\\d{1,3}(${escapeForCharClass(group)}\\d{3})+$`
      );
      if (!grouping.test(integerPart)) return null;
      return integerPart.split(group).join("");
    };
    var PERCENT_ESCAPE = /%[0-9a-fA-F]{2}/;
    var MAX_DECODE_PASSES = 3;
    var decodeUntilStable = (value) => {
      let current = value;
      for (let pass = 0; pass < MAX_DECODE_PASSES; pass++) {
        if (!PERCENT_ESCAPE.test(current)) break;
        try {
          const decoded = decodeURIComponent(current);
          if (decoded === current) break;
          current = decoded;
        } catch {
          break;
        }
      }
      return current;
    };
    var isEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    var parseInvitedEmail = (value) => {
      const [raw] = Array.isArray(value) ? value : [value];
      if (!raw) return void 0;
      const decoded = decodeUntilStable(raw.trim());
      const candidates = [decoded, decoded.replace(/ /g, "+")];
      return candidates.find(isEmail);
    };
    var INVITED_EMAIL_PARAM = "email";
    var readInvitedEmail = (searchParams) => {
      const direct = parseInvitedEmail(searchParams[INVITED_EMAIL_PARAM]);
      if (direct) return direct;
      const prefix = `${INVITED_EMAIL_PARAM}=`;
      const pair = Object.keys(searchParams).find((key) => key.startsWith(prefix));
      return pair ? parseInvitedEmail(pair.slice(prefix.length)) : void 0;
    };
    var DEFAULT_FORMAT = "es-AR";
    var NOISE = /[\s$€]|ars|usd|eur/gi;
    var classify = (sample) => {
      const value = sample.replace(NOISE, "");
      if (!/^[0-9.,]+$/.test(value)) return null;
      const hasComma = value.includes(",");
      const hasDot = value.includes(".");
      if (hasComma && hasDot) {
        const lastIsComma = value.lastIndexOf(",") > value.lastIndexOf(".");
        return { format: lastIsComma ? "es-AR" : "en-US", strong: true };
      }
      if (hasComma) {
        if (/,\d{1,2}$/.test(value)) return { format: "es-AR", strong: true };
        if (/,\d{3}(\D|$)/.test(value)) return { format: "en-US", strong: false };
      }
      if (hasDot) {
        if (/\.\d{1,2}$/.test(value)) return { format: "en-US", strong: true };
        if (/\.\d{3}(\D|$)/.test(value)) return { format: "es-AR", strong: false };
      }
      return null;
    };
    var detectDecimalAmountFormat = (samples) => {
      const tally = {
        strong: { "es-AR": 0, "en-US": 0 },
        weak: { "es-AR": 0, "en-US": 0 }
      };
      for (const sample of samples) {
        const vote = classify(sample ?? "");
        if (!vote) continue;
        tally[vote.strong ? "strong" : "weak"][vote.format] += 1;
      }
      for (const votes of [tally.strong, tally.weak]) {
        if (votes["es-AR"] > votes["en-US"]) return "es-AR";
        if (votes["en-US"] > votes["es-AR"]) return "en-US";
      }
      return DEFAULT_FORMAT;
    };
    var FORMULA_TRIGGERS = ["=", "+", "@", "	", "\r"];
    var PLAIN_NUMBER = /^-?[\d.,]+$/;
    var escapeCsvFormula = (value) => {
      if (!value) return value;
      const startsWithTrigger = FORMULA_TRIGGERS.some(
        (trigger) => value.startsWith(trigger)
      );
      const isRiskyMinus = value.startsWith("-") && !PLAIN_NUMBER.test(value);
      return startsWithTrigger || isRiskyMinus ? `'${value}` : value;
    };
    var DEFAULT_LOCALE22 = "es-AR";
    var formatTaxPercent3 = (percent) => new Intl.NumberFormat(DEFAULT_LOCALE22, { maximumFractionDigits: 2 }).format(
      Number(percent ?? 0)
    );
    var import_mrz = (init_lib_esm(), __toCommonJS(lib_esm_exports));
    var idCardReadSources = ["pdf417", "mrz"];
    var empty = () => ({
      first_name: null,
      last_name: null,
      document_number: null,
      sex: null,
      birth_date: null,
      issued_date: null,
      expiration_date: null,
      nationality: null,
      procedure_number: null,
      street: null,
      street_number: null,
      floor: null,
      apartment: null,
      city: null,
      postal_code: null
    });
    var clean = (value) => {
      const trimmed = (value || "").trim();
      return trimmed || null;
    };
    var toSex = (value) => {
      const normalized = (value || "").trim().toUpperCase();
      if (normalized === "M" || normalized === "MALE") return "male";
      if (normalized === "F" || normalized === "FEMALE") return "female";
      return null;
    };
    var toIsoDate = (day, month, year) => {
      const date = /* @__PURE__ */ new Date(`${year}-${month}-${day}T00:00:00Z`);
      if (Number.isNaN(date.getTime())) return null;
      if (date.getUTCFullYear() !== Number(year)) return null;
      if (date.getUTCMonth() + 1 !== Number(month)) return null;
      if (date.getUTCDate() !== Number(day)) return null;
      return `${year}-${month}-${day}`;
    };
    var fromBarcodeDate = (value) => {
      const match83 = (value || "").trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!match83) return null;
      const [, day, month, year] = match83;
      return toIsoDate(day, month, year);
    };
    var fromMrzDate = (value, kind) => {
      const match83 = value.match(/^(\d{2})(\d{2})(\d{2})$/);
      if (!match83) return null;
      const [, shortYear, month, day] = match83;
      const candidate = 2e3 + Number(shortYear);
      const year = kind === "past" && candidate > (/* @__PURE__ */ new Date()).getUTCFullYear() ? candidate - 100 : candidate;
      return toIsoDate(day, month, String(year));
    };
    var LETTER_TO_NUMBER = {
      B: "8",
      G: "6",
      O: "0",
      I: "1",
      S: "5",
      Z: "2"
    };
    var DOCUMENT_NUMBER_START = 5;
    var DOCUMENT_NUMBER_END = 13;
    var PERSONAL_NUMBER_START = 28;
    var PERSONAL_NUMBER_END = 42;
    var undoOcrConfusions = (line, start, end) => line.slice(0, start) + [...line.slice(start, end)].map((char) => LETTER_TO_NUMBER[char] || char).join("") + line.slice(end);
    var normalizeArgentineDocumentNumber = (line) => undoOcrConfusions(line, DOCUMENT_NUMBER_START, DOCUMENT_NUMBER_END);
    var normalizeArgentinePersonalNumber = (line) => undoOcrConfusions(line, PERSONAL_NUMBER_START, PERSONAL_NUMBER_END);
    var FRONT_FIELD_COUNTS = [8, 9];
    var BACK_FIELD_COUNTS = [16, 17];
    var LICENCE_FIELD_COUNTS = [19];
    var EMPTY_LICENCE_VALUE = "---";
    var cleanLabelledValue = (part) => {
      const value = clean((part || "").replace(/^[^:]*:/, "").replace(/^N°/, ""));
      return value === EMPTY_LICENCE_VALUE ? null : value;
    };
    var DOCUMENT_NUMBER_PATTERN = /^\d{6,8}$/;
    var SEX_PATTERN = /^[MF]$/;
    var NAME_PATTERN = /^[A-ZÑÁÉÍÓÚÜ][A-ZÑÁÉÍÓÚÜ' -]+$/;
    var isDocumentNumber = (value) => !!value && DOCUMENT_NUMBER_PATTERN.test(value);
    var isName = (part = "") => NAME_PATTERN.test(part.toUpperCase());
    var readFrontLayout = (parts) => {
      const data = empty();
      data.procedure_number = clean(parts[0]);
      data.last_name = clean(parts[1]);
      data.first_name = clean(parts[2]);
      data.sex = toSex(parts[3]);
      data.document_number = clean(parts[4]);
      data.birth_date = fromBarcodeDate(parts[6]);
      data.issued_date = fromBarcodeDate(parts[7]);
      return data;
    };
    var readLicenceLayout = (parts) => {
      const data = empty();
      data.document_number = clean(parts[1]);
      data.sex = toSex(parts[2]);
      data.first_name = clean(parts[3]);
      data.last_name = clean(parts[4]);
      data.birth_date = fromBarcodeDate(parts[5]);
      data.street = clean(parts[7]);
      data.street_number = cleanLabelledValue(parts[8]);
      data.floor = cleanLabelledValue(parts[9]);
      data.apartment = cleanLabelledValue(parts[10]);
      data.city = clean(parts[12]);
      data.postal_code = clean(parts[13]);
      data.issued_date = fromBarcodeDate(parts[14]);
      data.expiration_date = fromBarcodeDate(parts[15]);
      return data;
    };
    var readBackLayout = (parts) => {
      const data = empty();
      data.document_number = clean(parts[1]);
      data.last_name = clean(parts[4]);
      data.first_name = clean(parts[5]);
      data.birth_date = fromBarcodeDate(parts[7]);
      data.sex = toSex(parts[8]);
      data.issued_date = fromBarcodeDate(parts[9]);
      data.expiration_date = fromBarcodeDate(parts[12]);
      return data;
    };
    var findNamePair = (parts) => {
      const index = parts.findIndex(
        (part, position) => isName(part) && isName(parts[position + 1])
      );
      return index === -1 ? null : { last: parts[index], first: parts[index + 1] };
    };
    var readByFieldShape = (parts) => {
      const data = empty();
      const dates = parts.map(fromBarcodeDate).filter((date) => !!date).sort();
      const [birthDate, ...laterDates] = dates;
      const today = (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
      const names = findNamePair(parts);
      data.document_number = clean(parts.find(isDocumentNumber));
      data.sex = toSex(parts.find((part) => SEX_PATTERN.test(part.toUpperCase())));
      data.birth_date = birthDate || null;
      data.expiration_date = laterDates.find((date) => date > today) || null;
      data.issued_date = laterDates.find((date) => date <= today) || null;
      data.last_name = clean(names == null ? void 0 : names.last);
      data.first_name = clean(names == null ? void 0 : names.first);
      return data;
    };
    var FIELD_SEPARATORS = ["@", "\r\n", "\r", "\n", "	", "|", ";"];
    var splitPayload = (payload) => {
      const separator = FIELD_SEPARATORS.find(
        (candidate) => payload.includes(candidate)
      );
      return separator ? payload.split(separator).map((part) => part.trim()) : [payload.trim()];
    };
    var readKnownLayout = (parts) => {
      if (FRONT_FIELD_COUNTS.includes(parts.length)) {
        const data = readFrontLayout(parts);
        return isDocumentNumber(data.document_number) ? data : null;
      }
      if (LICENCE_FIELD_COUNTS.includes(parts.length)) {
        const data = readLicenceLayout(parts);
        return isDocumentNumber(data.document_number) ? data : null;
      }
      if (BACK_FIELD_COUNTS.includes(parts.length)) {
        const data = readBackLayout(parts);
        return isDocumentNumber(data.document_number) ? data : null;
      }
      return null;
    };
    var parseArgentineIdCardBarcode = (payload) => {
      const parts = splitPayload(payload);
      const data = readKnownLayout(parts) || readByFieldShape(parts);
      if (!data.document_number) return null;
      return { source: "pdf417", data, discarded: [] };
    };
    var TD1_SHAPE = { lineCount: 3, lineLength: 30 };
    var TD3_SHAPE = { lineCount: 2, lineLength: 44 };
    var PROTECTED_BY = {
      documentNumberCheckDigit: "documentNumber",
      personalNumberCheckDigit: "personalNumber",
      birthDateCheckDigit: "birthDate",
      expirationDateCheckDigit: "expirationDate"
    };
    var MRZ_FIELD_TO_DATA = {
      birthDate: "birth_date",
      expirationDate: "expiration_date",
      sex: "sex",
      nationality: "nationality",
      firstName: "first_name",
      lastName: "last_name"
    };
    var hasShape = (lines, shape) => lines.length === shape.lineCount && lines.every((line) => line.length === shape.lineLength);
    var normalizeMrzLines = (lines) => hasShape(lines, TD1_SHAPE) ? [normalizeArgentineDocumentNumber(lines[0]), ...lines.slice(1)] : [lines[0], normalizeArgentinePersonalNumber(lines[1])];
    var documentNumberFieldOf = (format2) => format2 === "TD3" ? "personalNumber" : "documentNumber";
    var parseArgentineIdCardMrz = (lines) => {
      if (!hasShape(lines, TD1_SHAPE) && !hasShape(lines, TD3_SHAPE)) return null;
      const result = (0, import_mrz.parse)(normalizeMrzLines(lines), { autocorrect: true });
      if (result.format !== "TD1" && result.format !== "TD3") return null;
      const invalidFields = new Set(
        result.details.filter((detail) => detail.valid === false).map((detail) => String(detail.field))
      );
      Object.entries(PROTECTED_BY).forEach(([checkDigit, field]) => {
        if (invalidFields.has(checkDigit)) invalidFields.add(field);
      });
      const fields7 = result.fields;
      const isTrusted = (field) => !invalidFields.has(field);
      const documentNumberField = documentNumberFieldOf(result.format);
      const data = empty();
      if (isTrusted(documentNumberField)) {
        data.document_number = clean(fields7[documentNumberField] || void 0);
      }
      if (isTrusted("birthDate") && fields7.birthDate) {
        data.birth_date = fromMrzDate(fields7.birthDate, "past");
      }
      if (isTrusted("expirationDate") && fields7.expirationDate) {
        data.expiration_date = fromMrzDate(fields7.expirationDate, "future");
      }
      if (isTrusted("sex")) data.sex = toSex(fields7.sex || void 0);
      if (isTrusted("nationality")) {
        data.nationality = clean(fields7.nationality || void 0);
      }
      if (isTrusted("firstName")) {
        data.first_name = clean(fields7.firstName || void 0);
      }
      if (isTrusted("lastName")) {
        data.last_name = clean(fields7.lastName || void 0);
      }
      if (!data.document_number) return null;
      const readFields = {
        ...MRZ_FIELD_TO_DATA,
        [documentNumberField]: "document_number"
      };
      const discarded = Object.entries(readFields).filter(([mrzField]) => invalidFields.has(mrzField)).map(([, dataField]) => dataField);
      return { source: "mrz", data, discarded };
    };
    var slugify2 = (text2) => text2.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    var normalizeVariableName4 = (name) => name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase().replace(/\s+/g, " ");
    var import_date_fns42 = (init_esm(), __toCommonJS(esm_exports));
    var import_piramid_constants99 = require_dist2();
    var minorities2 = ["minor", "adult", "unknown"];
    var resolveMinority2 = (birthDate, referenceDate) => {
      if (!birthDate) return "unknown";
      const parsedBirthDate = new Date(birthDate);
      if (Number.isNaN(parsedBirthDate.getTime())) return "unknown";
      return (0, import_date_fns42.differenceInYears)(new Date(referenceDate), parsedBirthDate) < import_piramid_constants99.LEGAL_PERSON_AGE_THRESHOLD ? "minor" : "adult";
    };
    var import_piramid_constants102 = require_dist2();
    var findStateLabel2 = (country, state) => {
      var _a, _b;
      if (!country || !state) return null;
      const states2 = (_a = import_piramid_constants102.countryAndStates.find(
        (candidate) => candidate.code === country
      )) == null ? void 0 : _a.states;
      return ((_b = states2 == null ? void 0 : states2.find((candidate) => candidate.code === state)) == null ? void 0 : _b.name) ?? null;
    };
    var import_date_fns_tz2 = require_date_fns_tz();
    var import_locale = (init_locale(), __toCommonJS(locale_exports));
    var import_piramid_constants112 = require_dist2();
    var dateInTimeZonePatterns = {
      short: "dd/MM/yyyy",
      long: "d 'de' MMMM 'de' yyyy"
    };
    var formatDateInTimeZone3 = (value, format2, timezone = import_piramid_constants112.DEFAULT_TIMEZONE) => (0, import_date_fns_tz2.formatInTimeZone)(new Date(value), timezone, dateInTimeZonePatterns[format2], {
      locale: import_locale.es
    });
    var composePersonAddress = (person) => {
      var _a, _b;
      const street = [person.address_street, person.address_number].map((part) => part == null ? void 0 : part.trim()).filter(Boolean).join(" ");
      const composed = [street, (_a = person.address_apartment) == null ? void 0 : _a.trim()].filter(Boolean).join(", ");
      return composed || ((_b = person.address) == null ? void 0 : _b.trim()) || null;
    };
  }
});

// index.ts
var bff_exports = {};
__export(bff_exports, {
  ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS: () => ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS,
  ACCEPTANCE_PROBABILITY_BASE_SCORE: () => ACCEPTANCE_PROBABILITY_BASE_SCORE,
  ACCEPTANCE_PROBABILITY_FACTOR_TABLES: () => ACCEPTANCE_PROBABILITY_FACTOR_TABLES,
  ACCEPTANCE_PROBABILITY_MAX: () => ACCEPTANCE_PROBABILITY_MAX,
  ACCEPTANCE_PROBABILITY_MIN: () => ACCEPTANCE_PROBABILITY_MIN,
  ACCEPTANCE_PROBABILITY_MODEL_VERSION: () => ACCEPTANCE_PROBABILITY_MODEL_VERSION,
  ACCEPTED_ORDER_STATUSES: () => ACCEPTED_ORDER_STATUSES,
  AGREEMENT_BLOCK_COPY_FORMAT: () => AGREEMENT_BLOCK_COPY_FORMAT,
  AGREEMENT_FIXTURE_NOW: () => AGREEMENT_FIXTURE_NOW,
  AGREEMENT_RULE_ATTRIBUTE_READERS: () => AGREEMENT_RULE_ATTRIBUTE_READERS,
  AUTOINSPECTOR_CONFIGURABLE_USE_CASES: () => AUTOINSPECTOR_CONFIGURABLE_USE_CASES,
  AUTOINSPECTOR_CREATE_STAGE: () => AUTOINSPECTOR_CREATE_STAGE,
  AUTOINSPECTOR_FIELD_SOURCES: () => AUTOINSPECTOR_FIELD_SOURCES,
  AUTOINSPECTOR_INPUT_TYPES: () => AUTOINSPECTOR_INPUT_TYPES,
  AUTOINSPECTOR_INSPECTION_RESULT_FILTERS: () => AUTOINSPECTOR_INSPECTION_RESULT_FILTERS,
  AUTOINSPECTOR_REPORT_STATUSES: () => AUTOINSPECTOR_REPORT_STATUSES,
  AUTOINSPECTOR_USE_CASES: () => AUTOINSPECTOR_USE_CASES,
  AUTOINSPECTOR_USE_CASE_KEYS: () => AUTOINSPECTOR_USE_CASE_KEYS,
  BLOCKING_CLAIMANT_VICTIM_VIOLATIONS: () => BLOCKING_CLAIMANT_VICTIM_VIOLATIONS,
  BLOCKING_OWNERSHIP_ACCEPTANCE_VIOLATIONS: () => BLOCKING_OWNERSHIP_ACCEPTANCE_VIOLATIONS,
  CBU_LENGTH: () => CBU_LENGTH,
  CLAIM_ATTEMPT_CATEGORIES: () => CLAIM_ATTEMPT_CATEGORIES,
  CLAIM_ATTEMPT_PEOPLE_OUTCOMES: () => CLAIM_ATTEMPT_PEOPLE_OUTCOMES,
  CLAIM_DISTRIBUTION_CATEGORIES: () => CLAIM_DISTRIBUTION_CATEGORIES,
  CLAIM_DOCUMENT_ANALYSIS_FILE_FIELD_SOURCES: () => CLAIM_DOCUMENT_ANALYSIS_FILE_FIELD_SOURCES,
  CLAIM_DOCUMENT_ANALYSIS_INFERENCES: () => CLAIM_DOCUMENT_ANALYSIS_INFERENCES,
  CLAIM_DOCUMENT_ANALYSIS_RESULTS: () => CLAIM_DOCUMENT_ANALYSIS_RESULTS,
  CLAIM_DOCUMENT_ANALYSIS_VALUE_FIELD_SOURCES: () => CLAIM_DOCUMENT_ANALYSIS_VALUE_FIELD_SOURCES,
  CUIT_LENGTH: () => CUIT_LENGTH,
  DAY_TYPES: () => DAY_TYPES,
  DEFAULT_CUIT_LENGTH: () => DEFAULT_CUIT_LENGTH,
  DEFAULT_DNI_LENGTH: () => DEFAULT_DNI_LENGTH,
  ExternalWorkflowSchema: () => ExternalWorkflowSchema,
  ExternalWorkflowVersionSchema: () => ExternalWorkflowVersionSchema,
  IMPORTABLE_DOCUMENT_GROUPS: () => IMPORTABLE_DOCUMENT_GROUPS,
  ListCompanyUsersResponseBody: () => ListCompanyUsersResponseBody,
  ORDER_CLAIM_TRIGGERS: () => ORDER_CLAIM_TRIGGERS,
  ORDER_COMPLETION_BLOCKED_REASONS: () => ORDER_COMPLETION_BLOCKED_REASONS,
  ORDER_PENDING_SIDES: () => ORDER_PENDING_SIDES,
  ORDER_PENDING_SIDE_COLUMN: () => ORDER_PENDING_SIDE_COLUMN,
  ORDER_PROGRESS_STAGES: () => ORDER_PROGRESS_STAGES,
  ORDER_PROGRESS_STAGE_RANK: () => ORDER_PROGRESS_STAGE_RANK,
  ORDER_PROGRESS_STAGE_STATUSES: () => ORDER_PROGRESS_STAGE_STATUSES,
  ORDER_PROGRESS_WAITING_ON: () => ORDER_PROGRESS_WAITING_ON,
  ORDER_SCHEDULE_BLOCKED_REASONS: () => ORDER_SCHEDULE_BLOCKED_REASONS,
  ORDER_SCHEDULE_STATUSES: () => ORDER_SCHEDULE_STATUSES,
  ORDER_WORK_PROOF_BLOCKED_REASONS: () => ORDER_WORK_PROOF_BLOCKED_REASONS,
  ORDER_WORK_PROOF_CAPTURABLE_STATUSES: () => ORDER_WORK_PROOF_CAPTURABLE_STATUSES,
  ORDER_WORK_PROOF_COMPLETED_STATUSES: () => ORDER_WORK_PROOF_COMPLETED_STATUSES,
  ORDER_WORK_PROOF_DISPLAY_STATUSES: () => ORDER_WORK_PROOF_DISPLAY_STATUSES,
  ORDER_WORK_PROOF_OPEN_STATUSES: () => ORDER_WORK_PROOF_OPEN_STATUSES,
  PERFORMANCE_DAMAGE_CATEGORIES: () => PERFORMANCE_DAMAGE_CATEGORIES,
  PROFESSIONAL_VICTIM_RELATIONSHIPS: () => PROFESSIONAL_VICTIM_RELATIONSHIPS,
  RELEASE_NOTE_IMAGE_SRC_MAX_LENGTH: () => RELEASE_NOTE_IMAGE_SRC_MAX_LENGTH,
  REVIEW_COMMENT_MAX_LENGTH: () => REVIEW_COMMENT_MAX_LENGTH,
  REVIEW_LOW_SCORE_COMMENT_THRESHOLD: () => REVIEW_LOW_SCORE_COMMENT_THRESHOLD,
  REVIEW_MAX_SCORE: () => REVIEW_MAX_SCORE,
  REVIEW_MIN_SCORE: () => REVIEW_MIN_SCORE,
  RelationType: () => RelationType,
  SELF_MANAGED_INTEGRATION_BACKENDS: () => SELF_MANAGED_INTEGRATION_BACKENDS,
  TWENTY_FOUR_HOURS_REGEX: () => TWENTY_FOUR_HOURS_REGEX,
  acceptCustomerOrganizationInvitationRequestBody: () => acceptCustomerOrganizationInvitationRequestBody,
  acceptOfferRequestBody: () => acceptOfferRequestBody,
  acceptOwnershipTransferRequestBody: () => acceptOwnershipTransferRequestBody,
  acceptanceCheckSchema: () => acceptanceCheckSchema,
  acceptanceDeclaredIdentitySchema: () => acceptanceDeclaredIdentitySchema,
  acceptanceIdentityVerdictSchema: () => acceptanceIdentityVerdictSchema,
  acceptanceLawyerResolutionSchema: () => acceptanceLawyerResolutionSchema,
  acceptancePayeeBlockersOf: () => acceptancePayeeBlockersOf,
  acceptancePayeeCandidateSchema: () => acceptancePayeeCandidateSchema,
  acceptancePayeeContextCandidateSchema: () => acceptancePayeeContextCandidateSchema,
  acceptancePayeeContextSchema: () => acceptancePayeeContextSchema,
  acceptancePayeeResolutionSchema: () => acceptancePayeeResolutionSchema,
  acceptanceProbabilityBands: () => acceptanceProbabilityBands,
  acceptanceProbabilityFactorKeys: () => acceptanceProbabilityFactorKeys,
  acceptanceProbabilityFactorSkipReasons: () => acceptanceProbabilityFactorSkipReasons,
  ackFileRequestPlaceholderRequestBody: () => ackFileRequestPlaceholderRequestBody,
  ackFileRequestPlaceholderRequestParams: () => ackFileRequestPlaceholderRequestParams,
  addAppraisalReportRequestBody: () => addAppraisalReportRequestBody,
  addClaimCollaboratorRequestBody: () => addClaimCollaboratorRequestBody,
  addComplaintCollaboratorRequestBody: () => addComplaintCollaboratorRequestBody,
  addMessageRequestBody: () => addMessageRequestBody,
  addMessageToClaimRequestParams: () => addMessageToClaimRequestParams,
  addProviderGroupMemberRequestBody: () => addProviderGroupMemberRequestBody,
  affectedUserEventMetadata: () => affectedUserEventMetadata,
  aggregateClaimAssignableUsersRequestQuery: () => aggregateClaimAssignableUsersRequestQuery,
  aggregateClaimsNotificationsActivityRequestBody: () => aggregateClaimsNotificationsActivityRequestBody,
  agreementAcceptanceSourceKinds: () => agreementAcceptanceSourceKinds,
  agreementAcceptanceSources: () => agreementAcceptanceSources,
  agreementBindingResolutionSchema: () => agreementBindingResolutionSchema,
  agreementBindingStatuses: () => agreementBindingStatuses,
  agreementBlockCopyRejections: () => agreementBlockCopyRejections,
  agreementBlockSchema: () => agreementBlockSchema,
  agreementClaimSubjectSchema: () => agreementClaimSubjectSchema,
  agreementClaimTypeDamageSchema: () => agreementClaimTypeDamageSchema,
  agreementClaimTypeSchema: () => agreementClaimTypeSchema,
  agreementClaimantSchema: () => agreementClaimantSchema,
  agreementCloneMappingEntry: () => agreementCloneMappingEntry,
  agreementClonePlanRequestBody: () => agreementClonePlanRequestBody,
  agreementCondition: () => agreementCondition,
  agreementConditionEvaluationSchema: () => agreementConditionEvaluationSchema,
  agreementConditionsFingerprint: () => agreementConditionsFingerprint,
  agreementDamageSchema: () => agreementDamageSchema,
  agreementDamagesFactSchema: () => agreementDamagesFactSchema,
  agreementDispatchTransactionName: () => agreementDispatchTransactionName,
  agreementDocumentAnchorSchema: () => agreementDocumentAnchorSchema,
  agreementDocumentAnchorsSchema: () => agreementDocumentAnchorsSchema,
  agreementDocumentDiagnosticsSchema: () => agreementDocumentDiagnosticsSchema,
  agreementDocumentParamsSchema: () => agreementDocumentParamsSchema,
  agreementDocumentPayloadSchema: () => agreementDocumentPayloadSchema,
  agreementDriverSchema: () => agreementDriverSchema,
  agreementDynamicVariableKey: () => agreementDynamicVariableKey,
  agreementExternalComplaintSources: () => agreementExternalComplaintSources,
  agreementFactsSchema: () => agreementFactsSchema,
  agreementFinalDocumentBlocker: () => agreementFinalDocumentBlocker,
  agreementFixtureClaimTypes: () => agreementFixtureClaimTypes,
  agreementFixtureGuid: () => agreementFixtureGuid,
  agreementInjuryDetailSchema: () => agreementInjuryDetailSchema,
  agreementInsuranceSchema: () => agreementInsuranceSchema,
  agreementInsuredSchema: () => agreementInsuredSchema,
  agreementLawyerRules: () => agreementLawyerRules,
  agreementLawyerSchema: () => agreementLawyerSchema,
  agreementMissingEntrySchema: () => agreementMissingEntrySchema,
  agreementOfferKinds: () => agreementOfferKinds,
  agreementOfferTermsSchema: () => agreementOfferTermsSchema,
  agreementParentSchema: () => agreementParentSchema,
  agreementPartiesSchema: () => agreementPartiesSchema,
  agreementPaymentBreakdownSchema: () => agreementPaymentBreakdownSchema,
  agreementPersonKinds: () => import_piramid_constants39.agreementPersonKinds,
  agreementPersonSchema: () => agreementPersonSchema,
  agreementPlanGapSchema: () => agreementPlanGapSchema,
  agreementPlanRecipientSchema: () => agreementPlanRecipientSchema,
  agreementPlanRuleSchema: () => agreementPlanRuleSchema,
  agreementPlanSchema: () => agreementPlanSchema,
  agreementPlanSigners: () => agreementPlanSigners,
  agreementPlanTemplateSchema: () => agreementPlanTemplateSchema,
  agreementPrincipalClaimantRules: () => agreementPrincipalClaimantRules,
  agreementRealPropertySchema: () => agreementRealPropertySchema,
  agreementResolutionMetaSchema: () => agreementResolutionMetaSchema,
  agreementResolutionSchema: () => agreementResolutionSchema,
  agreementRuleAttributeKeySchema: () => agreementRuleAttributeKeySchema,
  agreementRuleConditionSchema: () => agreementRuleConditionSchema,
  agreementRuleConditionsSchema: () => agreementRuleConditionsSchema,
  agreementRuleConditionsSchemaFor: () => agreementRuleConditionsSchemaFor,
  agreementRuleContextSchema: () => agreementRuleContextSchema,
  agreementRuleEvaluationSchema: () => agreementRuleEvaluationSchema,
  agreementRuleHealthIssues: () => agreementRuleHealthIssues,
  agreementRuleRecipientSchema: () => agreementRuleRecipientSchema,
  agreementRuleRequestParams: () => agreementRuleRequestParams,
  agreementRuleValueSchema: () => agreementRuleValueSchema,
  agreementSampleScenarios: () => agreementSampleScenarios,
  agreementSampleTemplate: () => agreementSampleTemplate,
  agreementScenarios: () => agreementScenarios,
  agreementSendBlockerKeys: () => agreementSendBlockerKeys,
  agreementSendBlockers: () => agreementSendBlockers,
  agreementSignatureDecisionSchema: () => agreementSignatureDecisionSchema,
  agreementSignatureRuleEvaluationSchema: () => agreementSignatureRuleEvaluationSchema,
  agreementSignatureRuleScopeSchema: () => agreementSignatureRuleScopeSchema,
  agreementSignerKeySchema: () => agreementSignerKeySchema,
  agreementSignerSchema: () => agreementSignerSchema,
  agreementSubjectSchema: () => agreementSubjectSchema,
  agreementTemplateConditionGapSchema: () => agreementTemplateConditionGapSchema,
  agreementTemplateContentSchema: () => agreementTemplateContentSchema,
  agreementTemplateMissingSchema: () => agreementTemplateMissingSchema,
  agreementTemplateMissingStatuses: () => agreementTemplateMissingStatuses,
  agreementTemplateRequestParams: () => agreementTemplateRequestParams,
  agreementTemplateSyntaxErrorSchema: () => agreementTemplateSyntaxErrorSchema,
  agreementTemplateVariableSchema: () => agreementTemplateVariableSchema,
  agreementTemplateVersionRequestParams: () => agreementTemplateVersionRequestParams,
  agreementTermsSources: () => agreementTermsSources,
  agreementValuesByName: () => agreementValuesByName,
  agreementVariableBindingsSchema: () => agreementVariableBindingsSchema,
  agreementVariableDefinitionSchema: () => agreementVariableDefinitionSchema,
  agreementVariableValueSchema: () => agreementVariableValueSchema,
  agreementVariableValuesSchema: () => agreementVariableValuesSchema,
  agreementVariablesToTemplateContext: () => agreementVariablesToTemplateContext,
  agreementVehicleSchema: () => agreementVehicleSchema,
  agreementWarningSchema: () => agreementWarningSchema,
  alertEnvironmentEnvSchema: () => alertEnvironmentEnvSchema,
  alertTypesWithProgressTrigger: () => alertTypesWithProgressTrigger,
  amountSchema: () => amountSchema,
  appErrorSchema: () => appErrorSchema,
  applyConditionsToVariables: () => applyConditionsToVariables,
  applyRefinementsToCompanySLASchema: () => applyRefinementsToCompanySLASchema,
  applyTeamValidationsToSchema: () => applyTeamValidationsToSchema,
  appraisalInvoiceUploaded: () => appraisalInvoiceUploaded,
  appraisalReportAccepted: () => appraisalReportAccepted,
  appraisalReportCreated: () => appraisalReportCreated,
  appraisalReportRejected: () => appraisalReportRejected,
  appraisalUpdatesPublished: () => appraisalUpdatesPublished,
  appraisalUpdatesRequested: () => appraisalUpdatesRequested,
  assignAutoinspectorTemplateRequestBody: () => assignAutoinspectorTemplateRequestBody,
  assignClaimCollaboratorRequestBody: () => assignClaimCollaboratorRequestBody,
  assignClaimOwnerRequestBody: () => assignClaimOwnerRequestBody,
  assignClaimResponsibleRequestBody: () => assignClaimResponsibleRequestBody,
  assignComplaintResponsibleRequestBody: () => assignComplaintResponsibleRequestBody,
  assignmentReason: () => assignmentReason,
  associateSinisterToFraudRequestBody: () => associateSinisterToFraudRequestBody,
  attachFilesRequestBody: () => attachFilesRequestBody,
  autoinspectorFieldMappingSchema: () => autoinspectorFieldMappingSchema,
  autoinspectorFieldMappingsSchema: () => autoinspectorFieldMappingsSchema,
  autoinspectorFieldSourceDefinitions: () => autoinspectorFieldSourceDefinitions,
  autoinspectorUseCaseSupportsFieldConfig: () => autoinspectorUseCaseSupportsFieldConfig,
  autosignConnectionStatus: () => autosignConnectionStatus,
  autosignTransactionInfoSchema: () => autosignTransactionInfoSchema,
  azureCallbackQuerySchema: () => azureCallbackQuerySchema,
  backofficeAutoinspectorInspectionsFilterQuery: () => backofficeAutoinspectorInspectionsFilterQuery,
  backofficeEntityRequestParams: () => backofficeEntityRequestParams,
  backofficeEntitySpecificRequestParams: () => backofficeEntitySpecificRequestParams,
  backofficeListEntrypointsRequestQuery: () => backofficeListEntrypointsRequestQuery,
  backofficeListInvitationsRequestQuery: () => backofficeListInvitationsRequestQuery,
  backofficeListReviewsRequestQuery: () => backofficeListReviewsRequestQuery,
  backofficeListUsersRequestQuery: () => backofficeListUsersRequestQuery,
  backofficeMoveTriggerMappingRequestBody: () => backofficeMoveTriggerMappingRequestBody,
  backofficeMoveTriggerMappingRequestParams: () => backofficeMoveTriggerMappingRequestParams,
  backofficeOrderExportRecipientSchema: () => backofficeOrderExportRecipientSchema,
  backofficeOrdersFilterSchema: () => backofficeOrdersFilterSchema,
  backofficePreviewOfferRequestBody: () => backofficePreviewOfferRequestBody,
  backofficeRemoveCompanyEnumRequestParams: () => backofficeRemoveCompanyEnumRequestParams,
  backofficeRemoveEntitySpecificTriggerMappingRequestParams: () => backofficeRemoveEntitySpecificTriggerMappingRequestParams,
  backofficeUpdateCompanyEnumRequestParams: () => backofficeUpdateCompanyEnumRequestParams,
  backofficeUpdateComplaintSinisterCauseRequestBody: () => backofficeUpdateComplaintSinisterCauseRequestBody,
  backofficeUpsertEntitySpecificTriggerMappingRequestBody: () => backofficeUpsertEntitySpecificTriggerMappingRequestBody,
  bankConditions: () => bankConditions,
  bankPairWarnings: () => bankPairWarnings,
  batchCreateTeamMembershipsRequestBody: () => batchCreateTeamMembershipsRequestBody,
  batchListTagsRequestQuery: () => batchListTagsRequestQuery,
  batchReadNotificationsRequestBody: () => batchReadNotificationsRequestBody,
  bidLineSchema: () => bidLineSchema,
  bodyPartLabel: () => bodyPartLabel,
  buildAcceptanceProbabilityInput: () => buildAcceptanceProbabilityInput,
  buildAgreementAcceptanceRequirements: () => buildAgreementAcceptanceRequirements,
  buildAgreementClaimant: () => buildAgreementClaimant,
  buildAgreementDefinition: () => buildAgreementDefinition,
  buildAgreementDispatchFields: () => buildAgreementDispatchFields,
  buildAgreementDispatchRecipients: () => buildAgreementDispatchRecipients,
  buildAgreementDocumentSample: () => buildAgreementDocumentSample,
  buildAgreementDriver: () => buildAgreementDriver,
  buildAgreementFixtureResolution: () => buildAgreementFixtureResolution,
  buildAgreementFixtureRuleContext: () => buildAgreementFixtureRuleContext,
  buildAgreementInsurance: () => buildAgreementInsurance,
  buildAgreementInsured: () => buildAgreementInsured,
  buildAgreementLawyer: () => buildAgreementLawyer,
  buildAgreementLegalPerson: () => buildAgreementLegalPerson,
  buildAgreementNoOffer: () => buildAgreementNoOffer,
  buildAgreementOffer: () => buildAgreementOffer,
  buildAgreementParent: () => buildAgreementParent,
  buildAgreementPerson: () => buildAgreementPerson,
  buildAgreementPlan: () => buildAgreementPlan,
  buildAgreementRule: () => buildAgreementRule,
  buildAgreementRuleContext: () => buildAgreementRuleContext,
  buildAgreementSampleRuleContext: () => buildAgreementSampleRuleContext,
  buildAgreementSampleVariables: () => buildAgreementSampleVariables,
  buildAgreementSignatureRule: () => buildAgreementSignatureRule,
  buildAgreementSubject: () => buildAgreementSubject,
  buildAgreementVariableValues: () => buildAgreementVariableValues,
  buildAutosignAuthorizeUrl: () => buildAutosignAuthorizeUrl,
  buildClaimEstimateChanges: () => buildClaimEstimateChanges,
  buildMessageTemplateVariablesSchema: () => buildMessageTemplateVariablesSchema,
  buildOfferAgreementOverview: () => buildOfferAgreementOverview,
  buildOfferMessageSample: () => buildOfferMessageSample,
  buildOfferVariableRows: () => buildOfferVariableRows,
  buildRestatedEstimateChange: () => buildRestatedEstimateChange,
  buildSchemaFromEstimatesDefinition: () => buildSchemaFromEstimatesDefinition,
  byAgreementRulePriority: () => byAgreementRulePriority,
  calculateAcceptanceProbability: () => calculateAcceptanceProbability,
  calculateCohortMonthsMatured: () => calculateCohortMonthsMatured,
  canReadNegotiationStage: () => canReadNegotiationStage,
  cancelClaimDerivationRequestBody: () => cancelClaimDerivationRequestBody,
  cancelFileRequestPlaceholderRequestBody: () => cancelFileRequestPlaceholderRequestBody,
  cancelOfferAgreementJobMetadata: () => cancelOfferAgreementJobMetadata,
  cancelOfferRequestBody: () => cancelOfferRequestBody,
  cancelOrderRequestBody: () => cancelOrderRequestBody,
  cancelOrderScheduleRequestBody: () => cancelOrderScheduleRequestBody,
  cancelRFPForClaimRequestBody: () => cancelRFPForClaimRequestBody,
  canonicalJson: () => canonicalJson,
  caseStatus: () => caseStatus,
  changeUserPasswordRequestBody: () => changeUserPasswordRequestBody,
  chartFrequencies: () => chartFrequencies,
  checkClaimAttributeRequestQuery: () => checkClaimAttributeRequestQuery,
  checkComplaintAttributeRequestQuery: () => checkComplaintAttributeRequestQuery,
  claimClosedByInsurerSystemEventMetadata: () => claimClosedByInsurerSystemEventMetadata,
  claimCreatedEventPayloadSchema: () => claimCreatedEventPayloadSchema,
  claimDocumentAnalysisAssetDetailsSchema: () => claimDocumentAnalysisAssetDetailsSchema,
  claimDocumentGroups: () => claimDocumentGroups,
  claimDocumentPreview: () => claimDocumentPreview,
  claimDocumentRequirements: () => claimDocumentRequirements,
  claimDocumentRequirementsBySpecification: () => claimDocumentRequirementsBySpecification,
  claimDocumentRequirementsFor: () => claimDocumentRequirementsFor,
  claimDriverSchema: () => claimDriverSchema,
  claimEstimateChangeProperties: () => claimEstimateChangeProperties,
  claimEstimateEventProps: () => claimEstimateEventProps,
  claimEstimatesProps: () => claimEstimatesProps,
  claimEstimatesUpdated: () => claimEstimatesUpdated,
  claimFileRequestCreated: () => claimFileRequestCreated,
  claimFileUploadedEventPayloadSchema: () => claimFileUploadedEventPayloadSchema,
  claimHandlerAssignedPayloadSchema: () => claimHandlerAssignedPayloadSchema,
  claimHandlerUnassignedPayloadSchema: () => claimHandlerUnassignedPayloadSchema,
  claimIntakeSchema: () => claimIntakeSchema,
  claimMessageCreated: () => claimMessageCreated,
  claimNegotiationEscalationStages: () => claimNegotiationEscalationStages,
  claimNegotiationPretensionSources: () => claimNegotiationPretensionSources,
  claimObject: () => claimObject,
  claimOfferAccepted: () => claimOfferAccepted,
  claimOfferAgreementCanceled: () => claimOfferAgreementCanceled,
  claimOfferAgreementCompleted: () => claimOfferAgreementCompleted,
  claimOfferAgreementCreated: () => claimOfferAgreementCreated,
  claimOfferAgreementExpired: () => claimOfferAgreementExpired,
  claimOfferAgreementRejected: () => claimOfferAgreementRejected,
  claimOfferCanceled: () => claimOfferCanceled,
  claimOfferCreated: () => claimOfferCreated,
  claimOfferExpired: () => claimOfferExpired,
  claimOfferRejected: () => claimOfferRejected,
  claimOrderCreatedPayloadSchema: () => claimOrderCreatedPayloadSchema,
  claimOrderInvoiceCreated: () => claimOrderInvoiceCreated,
  claimOrderReportAccepted: () => claimOrderReportAccepted,
  claimOrderReportCreated: () => claimOrderReportCreated,
  claimOrderReportRejected: () => claimOrderReportRejected,
  claimOrderUpdatesPublished: () => claimOrderUpdatesPublished,
  claimOrderUpdatesRequested: () => claimOrderUpdatesRequested,
  claimOwnershipTransferAccepted: () => claimOwnershipTransferAccepted,
  claimOwnershipTransferCreated: () => claimOwnershipTransferCreated,
  claimOwnershipTransferRejected: () => claimOwnershipTransferRejected,
  claimRfpBidObject: () => claimRfpBidObject,
  claimRfpBidSelected: () => claimRfpBidSelected,
  claimRfpBidSubmitted: () => claimRfpBidSubmitted,
  claimRfpCanceled: () => claimRfpCanceled,
  claimRfpClosed: () => claimRfpClosed,
  claimRfpCreated: () => claimRfpCreated,
  claimSLAInstanceThresholdExceeded: () => claimSLAInstanceThresholdExceeded,
  claimSLAObjectiveInstanceThresholdExceeded: () => claimSLAObjectiveInstanceThresholdExceeded,
  claimStatusUpdatedPayloadSchema: () => claimStatusUpdatedPayloadSchema,
  claimTypeDamageSchema: () => claimTypeDamageSchema,
  claimantLegalPersonSchema: () => claimantLegalPersonSchema,
  claimantNaturalPersonInnerSchema: () => claimantNaturalPersonInnerSchema,
  claimantNaturalPersonSchema: () => claimantNaturalPersonSchema,
  claimantSchema: () => claimantSchema,
  claimantVictimIdentityMessages: () => claimantVictimIdentityMessages,
  claimantVictimMismatchDetailSchema: () => claimantVictimMismatchDetailSchema,
  claimantVictimViolationCodes: () => claimantVictimViolationCodes,
  claimsFilterSchema: () => claimsFilterSchema,
  classifyAgreementGap: () => classifyAgreementGap,
  cloneAgreementTemplateRequestBody: () => cloneAgreementTemplateRequestBody,
  commitEntrypointSnapshotProgressRequestBody: () => commitEntrypointSnapshotProgressRequestBody,
  companyAgreementSettingsRequestBody: () => companyAgreementSettingsRequestBody,
  companyBaseSchema: () => companyBaseSchema,
  companyEnumKeys: () => companyEnumKeys,
  companyEnumSchema: () => companyEnumSchema,
  companyEnumUnionType: () => companyEnumUnionType,
  companyEventsFiltersSchema: () => companyEventsFiltersSchema,
  companyOfferTermsOptionsSchema: () => companyOfferTermsOptionsSchema,
  companyOwnerSchema: () => companyOwnerSchema,
  companySchema: () => companySchema,
  companySchemaUnion: () => companySchemaUnion,
  compileAgreementMessage: () => compileAgreementMessage,
  compileAgreementTemplate: () => compileAgreementTemplate,
  compiledAgreementBlockSchema: () => compiledAgreementBlockSchema,
  compiledAgreementSignatureSlotSchema: () => compiledAgreementSignatureSlotSchema,
  complaintBaseSchema: () => complaintBaseSchema,
  complaintDocumentRequirements: () => complaintDocumentRequirements,
  complaintOtherDocumentRequirements: () => complaintOtherDocumentRequirements,
  complaintOtherOccurrenceSchema: () => complaintOtherOccurrenceSchema,
  complaintOtherSubTypeSchema: () => complaintOtherSubTypeSchema,
  complaintOtherSubTypes: () => complaintOtherSubTypes,
  complaintPolicyholderSchema: () => complaintPolicyholderSchema,
  complaintThirdPartySchema: () => complaintThirdPartySchema,
  complaintThirdPartyVehicleSchema: () => complaintThirdPartyVehicleSchema,
  composedEstimateAttributes: () => composedEstimateAttributes,
  computeOfferCap: () => computeOfferCap,
  computeOfferPaymentBreakdown: () => computeOfferPaymentBreakdown,
  computeOrderTotals: () => computeOrderTotals,
  configureAutoinspectorRequestBody: () => configureAutoinspectorRequestBody,
  consistencyIdentityOf: () => consistencyIdentityOf,
  contactRegistrationStatuses: () => contactRegistrationStatuses,
  coverageItem: () => coverageItem,
  coverageLabel: () => coverageLabel,
  createAgreementRuleRequestBody: () => createAgreementRuleRequestBody,
  createAgreementSignatureRuleRequestBody: () => createAgreementSignatureRuleRequestBody,
  createAgreementTemplateRequestBody: () => createAgreementTemplateRequestBody,
  createBatchEventsRequestBody: () => createBatchEventsRequestBody,
  createClaimFormReviewRequestBody: () => createClaimFormReviewRequestBody,
  createClaimOwnerRequestBody: () => createClaimOwnerRequestBody,
  createClaimRFPRequestBody: () => createClaimRFPRequestBody,
  createClaimRFPSchema: () => createClaimRFPSchema,
  createClaimRequestBody: () => createClaimRequestBody,
  createClaimSchema: () => createClaimSchema,
  createCommentRequestBody: () => createCommentRequestBody,
  createCommentRequestParam: () => createCommentRequestParam,
  createCompanyClaimStatusOrderRuleRequestBody: () => createCompanyClaimStatusOrderRuleRequestBody,
  createCompanyClaimStatusRequestBody: () => createCompanyClaimStatusRequestBody,
  createCompanyClaimTypeRequestBody: () => createCompanyClaimTypeRequestBody,
  createCompanyComplaintStatusOrderRuleRequestBody: () => createCompanyComplaintStatusOrderRuleRequestBody,
  createCompanyComplaintStatusRequestBody: () => createCompanyComplaintStatusRequestBody,
  createCompanyLinkRequestBody: () => createCompanyLinkRequestBody,
  createCompanySLARequestBody: () => createCompanySLARequestBody,
  createCompanySLASchema: () => createCompanySLASchema,
  createCompanyTagRequestBody: () => createCompanyTagRequestBody,
  createCompanyTagRequestParams: () => createCompanyTagRequestParams,
  createCompanyTagResponseBody: () => createCompanyTagResponseBody,
  createComplaintRequestBody: () => createComplaintRequestBody,
  createComplaintSinisterCauseRequestBody: () => createComplaintSinisterCauseRequestBody,
  createComplaintVehicleSchema: () => createComplaintVehicleSchema,
  createContactRequestBody: () => createContactRequestBody,
  createContractRequestBody: () => createContractRequestBody,
  createContractSchema: () => createContractSchema,
  createCustomerOrganizationInvitationRequestBody: () => createCustomerOrganizationInvitationRequestBody,
  createCustomerOrganizationRequestBody: () => createCustomerOrganizationRequestBody,
  createCustomerOrganizationUserRequestBody: () => createCustomerOrganizationUserRequestBody,
  createCustomerRequestBody: () => createCustomerRequestBody,
  createEntrypointRequestBody: () => createEntrypointRequestBody,
  createEntrypointSessionRequestBody: () => createEntrypointSessionRequestBody,
  createEstimatesDefinitionRequestBody: () => createEstimatesDefinitionRequestBody,
  createEventRequestParams: () => createEventRequestParams,
  createFileRequestRequestBody: () => createFileRequestRequestBody,
  createFileRequestRequestParams: () => createFileRequestRequestParams,
  createGoodRequestBody: () => createGoodRequestBody,
  createInHouseLawyerRequestBody: () => createInHouseLawyerRequestBody,
  createIntegrationConnectionRequestBody: () => createIntegrationConnectionRequestBody,
  createIntegrationTemplateRequestBody: () => createIntegrationTemplateRequestBody,
  createInvitationSchema: () => createInvitationSchema,
  createLoadBalanceRuleRequestBody: () => createLoadBalanceRuleRequestBody,
  createLoginCredentialRequestBody: () => createLoginCredentialRequestBody,
  createMessageTemplateRequestBody: () => createMessageTemplateRequestBody,
  createOfferAgreementRequestBody: () => createOfferAgreementRequestBody,
  createOfferRequestBody: () => createOfferRequestBody,
  createOrderDocumentRequirementRequestBody: () => createOrderDocumentRequirementRequestBody,
  createOrderRequestBody: () => createOrderRequestBody,
  createPendingComplaintRequestBody: () => createPendingComplaintRequestBody,
  createProductImportRequestBody: () => createProductImportRequestBody,
  createProductRequestBody: () => createProductRequestBody,
  createProviderGroupRequestBody: () => createProviderGroupRequestBody,
  createReleaseNoteEventsRequestBody: () => createReleaseNoteEventsRequestBody,
  createRoleRequestBody: () => createRoleRequestBody,
  createServiceAccountRequestBody: () => createServiceAccountRequestBody,
  createServiceRequestBody: () => createServiceRequestBody,
  createStyleConfigRequestBody: () => createStyleConfigRequestBody,
  createTeamClaimsReassignmentRequestBody: () => createTeamClaimsReassignmentRequestBody,
  createTeamDelegationRequestBody: () => createTeamDelegationRequestBody,
  createTeamMembershipRequestBody: () => createTeamMembershipRequestBody,
  createTeamRequestBody: () => createTeamRequestBody,
  createTeamSchema: () => createTeamSchema,
  createUserRequestBody: () => createUserRequestBody,
  createValidationPatternRequestBody: () => createValidationPatternRequestBody,
  createVerticalRequestBody: () => createVerticalRequestBody,
  createWebhookRequestBody: () => createWebhookRequestBody,
  createWorkflowRequestBody: () => createWorkflowRequestBody,
  cuitCountries: () => cuitCountries,
  cuitCuilSchema: () => cuitCuilSchema,
  cuitMatchesPerson: () => cuitMatchesPerson,
  cuitRefine: () => cuitRefine,
  cuitSchema: () => cuitSchema,
  customHandlebarsToHandlebars: () => customHandlebarsToHandlebars,
  customerOrganizationInvitationRequestParams: () => customerOrganizationInvitationRequestParams,
  customerOrganizationInvitationTokenRequestParams: () => customerOrganizationInvitationTokenRequestParams,
  customerOrganizationUserRequestParams: () => customerOrganizationUserRequestParams,
  deactivateGroupSLARequestBody: () => deactivateGroupSLARequestBody,
  decidedAgreementSignatureMethod: () => decidedAgreementSignatureMethod,
  defaultOfferTerms: () => defaultOfferTerms,
  delegateClaimHandlingRequestBody: () => delegateClaimHandlingRequestBody,
  delegateComplaintHandlingRequestBody: () => delegateComplaintHandlingRequestBody,
  deleteCompanyTagResponseBody: () => deleteCompanyTagResponseBody,
  deleteTeamRequestParams: () => deleteTeamRequestParams,
  deriveAgreementFacts: () => deriveAgreementFacts,
  deriveClaimRequestBody: () => deriveClaimRequestBody,
  deriveClaimType: () => deriveClaimType,
  deriveSinisterToFraudRequestBody: () => deriveSinisterToFraudRequestBody,
  describeOfferSnapshotContext: () => describeOfferSnapshotContext,
  diffClaimEstimateProperty: () => diffClaimEstimateProperty,
  diffClaimEstimates: () => diffClaimEstimates,
  disabledAgreementPlan: () => disabledAgreementPlan,
  dismissTeamDelegationNoticeRequestBody: () => dismissTeamDelegationNoticeRequestBody,
  dispatchOfferAgreementJobMetadata: () => dispatchOfferAgreementJobMetadata,
  dni: () => dni,
  dniSchema: () => dniSchema,
  documentAmountLineSchema: () => documentAmountLineSchema,
  documentBrandingSchema: () => documentBrandingSchema,
  documentContracts: () => documentContracts,
  documentDefinitionSchema: () => documentDefinitionSchema,
  documentMetaSchema: () => documentMetaSchema,
  documentSchema: () => documentSchema,
  duplicateAgreementTemplateRequestBody: () => duplicateAgreementTemplateRequestBody,
  einSchema: () => einSchema,
  emailNameMatchInputSchema: () => emailNameMatchInputSchema,
  embeddedSigningStatusRequestBody: () => embeddedSigningStatusRequestBody,
  entrypointAttemptErrorStatuses: () => entrypointAttemptErrorStatuses,
  estimatesDefinitionOperandSchema: () => estimatesDefinitionOperandSchema,
  estimatesImposterProps: () => estimatesImposterProps,
  evaluableAgreementRuleSchema: () => evaluableAgreementRuleSchema,
  evaluableAgreementSignatureRuleSchema: () => evaluableAgreementSignatureRuleSchema,
  evaluateAgreementCondition: () => evaluateAgreementCondition,
  evaluateAgreementRule: () => evaluateAgreementRule,
  eventReportColumns: () => eventReportColumns,
  eventRequestBody: () => eventRequestBody,
  exceedsOfferCap: () => exceedsOfferCap,
  exportBackofficeOrdersRequestBody: () => exportBackofficeOrdersRequestBody,
  exportClaimsRequestBody: () => exportClaimsRequestBody,
  exportCompanyEventsRequestBody: () => exportCompanyEventsRequestBody,
  exportCompanyEventsRequestFilters: () => exportCompanyEventsRequestFilters,
  exportInsurerOrdersRequestBody: () => exportInsurerOrdersRequestBody,
  exportReviewsCSVRequestQuery: () => exportReviewsCSVRequestQuery,
  exportSLAsRequestBody: () => exportSLAsRequestBody,
  extractAgreementTemplateVariables: () => extractAgreementTemplateVariables,
  extractRecipientSubmissions: () => extractRecipientSubmissions,
  extractVehicleIdCardRequestBody: () => extractVehicleIdCardRequestBody,
  fetchBackofficeFraudInvestigationParams: () => fetchBackofficeFraudInvestigationParams,
  fetchClaimAttemptsByUserRequestQuery: () => fetchClaimAttemptsByUserRequestQuery,
  fetchClaimCreationAttemptsRequestQuery: () => fetchClaimCreationAttemptsRequestQuery,
  fetchClaimDetailRequestParams: () => fetchClaimDetailRequestParams,
  fetchClaimFileRequestParams: () => fetchClaimFileRequestParams,
  fetchClaimFileResponseBody: () => fetchClaimFileResponseBody,
  fetchClaimMinimalRequestParams: () => fetchClaimMinimalRequestParams,
  fetchClaimMinimalResponseBody: () => fetchClaimMinimalResponseBody,
  fetchClaimsCountFrequencyRequestQuery: () => fetchClaimsCountFrequencyRequestQuery,
  fetchClaimsDistributionRequestQuery: () => fetchClaimsDistributionRequestQuery,
  fetchClaimsPeriodAnalysisRequestQuery: () => fetchClaimsPeriodAnalysisRequestQuery,
  fetchClaimsWeeklyComparisonRequestQuery: () => fetchClaimsWeeklyComparisonRequestQuery,
  fetchCompanyEntrypointRequestParams: () => fetchCompanyEntrypointRequestParams,
  fetchCompanyRequestParams: () => fetchCompanyRequestParams,
  fetchCoordinatorBlockRequestQuery: () => fetchCoordinatorBlockRequestQuery,
  fetchCoordinatorCohortRequestQuery: () => fetchCoordinatorCohortRequestQuery,
  fetchCoordinatorFunnelRequestQuery: () => fetchCoordinatorFunnelRequestQuery,
  fetchCoordinatorHandlersRequestQuery: () => fetchCoordinatorHandlersRequestQuery,
  fetchCoordinatorRiskZoneRequestQuery: () => fetchCoordinatorRiskZoneRequestQuery,
  fetchCoordinatorSnapshotRequestQuery: () => fetchCoordinatorSnapshotRequestQuery,
  fetchCoordinatorStageDrilldownRequestQuery: () => fetchCoordinatorStageDrilldownRequestQuery,
  fetchCoordinatorStageSlaRequestQuery: () => fetchCoordinatorStageSlaRequestQuery,
  fetchCoordinatorTeamExtendedRequestQuery: () => fetchCoordinatorTeamExtendedRequestQuery,
  fetchDailyClaimsRequestQuery: () => fetchDailyClaimsRequestQuery,
  fetchEntrypointRequestParams: () => fetchEntrypointRequestParams,
  fetchEntrypointRequestQuery: () => fetchEntrypointRequestQuery,
  fetchExistingKachCaseQuery: () => fetchExistingKachCaseQuery,
  fetchFraudDetailRequestParams: () => fetchFraudDetailRequestParams,
  fetchHistogramRequestQuery: () => fetchHistogramRequestQuery,
  fetchIntegrationConnectionRequestQuery: () => fetchIntegrationConnectionRequestQuery,
  fetchJobRequestParams: () => fetchJobRequestParams,
  fetchLoadBalanceRuleRequestParams: () => fetchLoadBalanceRuleRequestParams,
  fetchMetricsCaseRequestParam: () => fetchMetricsCaseRequestParam,
  fetchMetricsGlobalFiltersRequestQuery: () => fetchMetricsGlobalFiltersRequestQuery,
  fetchPerformanceBlockRequestQuery: () => fetchPerformanceBlockRequestQuery,
  fetchPerformanceClosureCohortByOutcomeRequestQuery: () => fetchPerformanceClosureCohortByOutcomeRequestQuery,
  fetchPerformanceCohortRequestQuery: () => fetchPerformanceCohortRequestQuery,
  fetchPerformanceFraudCasesInProcessRequestQuery: () => fetchPerformanceFraudCasesInProcessRequestQuery,
  fetchPerformanceFraudImpactRequestQuery: () => fetchPerformanceFraudImpactRequestQuery,
  fetchPerformanceFraudInvestigationTimeRequestQuery: () => fetchPerformanceFraudInvestigationTimeRequestQuery,
  fetchPerformanceFunnelRequestQuery: () => fetchPerformanceFunnelRequestQuery,
  fetchPerformanceRiskZoneRequestQuery: () => fetchPerformanceRiskZoneRequestQuery,
  fetchPerformanceSnapshotRequestQuery: () => fetchPerformanceSnapshotRequestQuery,
  fetchPerformanceStageDrilldownRequestQuery: () => fetchPerformanceStageDrilldownRequestQuery,
  fetchPerformanceStageSlaRequestQuery: () => fetchPerformanceStageSlaRequestQuery,
  fetchPerformanceTeamExtendedRequestQuery: () => fetchPerformanceTeamExtendedRequestQuery,
  fetchPerformanceTeamScopeRequestQuery: () => fetchPerformanceTeamScopeRequestQuery,
  fetchPolicyholderInspectionDetailRequestParams: () => fetchPolicyholderInspectionDetailRequestParams,
  fetchProcessingAmountMetricsRequestQuery: () => fetchProcessingAmountMetricsRequestQuery,
  fetchResourceDetailRequestParams: () => fetchResourceDetailRequestParams,
  fetchReviewsDistributionRequestQuery: () => fetchReviewsDistributionRequestQuery,
  fetchRiskZoneRequestQuery: () => fetchRiskZoneRequestQuery,
  fetchSinisterDetailRequestParams: () => fetchSinisterDetailRequestParams,
  fetchWeeklyEvolutionRequestQuery: () => fetchWeeklyEvolutionRequestQuery,
  fieldAdjusterAssigned: () => fieldAdjusterAssigned,
  fileRequestMessageSchema: () => fileRequestMessageSchema,
  findAgreementRuleConflict: () => findAgreementRuleConflict,
  formSteps: () => formSteps,
  formatAgreementBoolean: () => formatAgreementBoolean,
  formatAgreementDate: () => formatAgreementDate,
  formatAgreementList: () => formatAgreementList,
  formatAgreementMoney: () => formatAgreementMoney,
  formatAgreementNumber: () => formatAgreementNumber,
  formatAgreementPercent: () => formatAgreementPercent,
  formatAgreementValue: () => formatAgreementValue,
  formatAgreementWords: () => formatAgreementWords,
  formatClaimEstimateValue: () => formatClaimEstimateValue,
  franchiseAmountSchema: () => franchiseAmountSchema,
  freeAgreementTemplateName: () => freeAgreementTemplateName,
  generateNaturalPersonSchema: () => generateNaturalPersonSchema,
  genericDocumentNumber: () => genericDocumentNumber,
  getAcceptanceProbabilityBand: () => getAcceptanceProbabilityBand,
  getClaimDamage: () => getClaimDamage,
  getCurlyBracketsVariablePaths: () => getCurlyBracketsVariablePaths,
  getVictimIdentification: () => getVictimIdentification,
  guidedCreateOfferRequestBody: () => guidedCreateOfferRequestBody,
  handlebarsToCustomHandlebars: () => handlebarsToCustomHandlebars,
  hasAgreementPlaceholders: () => hasAgreementPlaceholders,
  hasAgreementSendBlockers: () => hasAgreementSendBlockers,
  hasDeathDamage: () => hasDeathDamage2,
  hasOfferAgreement: () => hasOfferAgreement,
  hasUnrecordedEstimateChange: () => hasUnrecordedEstimateChange,
  hasUnrecordedEstimateReason: () => hasUnrecordedEstimateReason,
  identificationInCuit: () => identificationInCuit,
  identificationTypeLabel: () => identificationTypeLabel,
  importBackofficeReleaseNoteRequestBody: () => importBackofficeReleaseNoteRequestBody,
  importOrderDocumentsRequestBody: () => importOrderDocumentsRequestBody,
  injuryDamageDocuments: () => injuryDamageDocuments,
  injuryDetail: () => injuryDetail,
  injuryLabel: () => injuryLabel,
  injurySeverityLabel: () => injurySeverityLabel,
  inspectProductImportRequestBody: () => inspectProductImportRequestBody,
  installmentsWithFeesDefinitions: () => installmentsWithFeesDefinitions,
  insuredPartySchema: () => insuredPartySchema,
  insurerOrdersFilterSchema: () => insurerOrdersFilterSchema,
  inviteProviderRequestBody: () => inviteProviderRequestBody,
  isAcceptanceProbabilityComputable: () => isAcceptanceProbabilityComputable,
  isAgreementTemplateVariableKey: () => isAgreementTemplateVariableKey,
  isAttorneyInFact: () => isAttorneyInFact,
  isAutoinspectorFieldSource: () => isAutoinspectorFieldSource,
  isAutoinspectorFieldSourceCompatible: () => isAutoinspectorFieldSourceCompatible,
  isAutoinspectorUseCase: () => isAutoinspectorUseCase,
  isCanceledOfferStatus: () => isCanceledOfferStatus,
  isCapturableWorkProof: () => isCapturableWorkProof,
  isClaimDocumentAnalysisResult: () => isClaimDocumentAnalysisResult,
  isCompletedWorkProof: () => isCompletedWorkProof,
  isLocalClaim: () => isLocalClaim,
  isManualAgreementOffer: () => isManualAgreementOffer,
  isOfferAgreementActivityEvent: () => isOfferAgreementActivityEvent,
  isOfferAgreementOpenAtProvider: () => isOfferAgreementOpenAtProvider,
  isOfferAgreementViewInFlight: () => isOfferAgreementViewInFlight,
  isOfferAgreementVisibleToClaimant: () => isOfferAgreementVisibleToClaimant,
  isOfferCapComputable: () => isOfferCapComputable,
  isOpenWorkProof: () => isOpenWorkProof,
  isOrderAccepted: () => isOrderAccepted,
  isOrderClaimTrigger: () => isOrderClaimTrigger,
  isProfessionalVictimRelationship: () => isProfessionalVictimRelationship,
  isRecoveryClaim: () => isRecoveryClaim,
  isReleaseNoteSectionKind: () => isReleaseNoteSectionKind,
  isReviewCommentRequired: () => isReviewCommentRequired,
  isSameEmail: () => isSameEmail,
  isSelfManagedIntegrationBackend: () => isSelfManagedIntegrationBackend,
  isValidCuit: () => isValidCuit,
  jobDetailRequestParams: () => jobDetailRequestParams,
  judicialEstimatesProps: () => judicialEstimatesProps,
  kachOAuthModes: () => kachOAuthModes,
  lawyerKindLabel: () => lawyerKindLabel,
  legacyCreateOfferRequestBody: () => legacyCreateOfferRequestBody,
  legalPersonSchema: () => legalPersonSchema,
  legalPersonTypeLabel: () => legalPersonTypeLabel,
  lineMetrics: () => lineMetrics,
  linkCustomerOrganizationUserRequestBody: () => linkCustomerOrganizationUserRequestBody,
  listAffectedCoveragesRequestQuery: () => listAffectedCoveragesRequestQuery,
  listAgreementTemplatesRequestQuery: () => listAgreementTemplatesRequestQuery,
  listAlertsRequestQuery: () => listAlertsRequestQuery,
  listBackofficeAutoinspectorInspectionsRequestQuery: () => listBackofficeAutoinspectorInspectionsRequestQuery,
  listBackofficeFraudInvestigationsRequestQuery: () => listBackofficeFraudInvestigationsRequestQuery,
  listBackofficeOrdersRequestQuery: () => listBackofficeOrdersRequestQuery,
  listBackofficeReleaseNoteEventsRequestQuery: () => listBackofficeReleaseNoteEventsRequestQuery,
  listBackofficeReleaseNotesRequestQuery: () => listBackofficeReleaseNotesRequestQuery,
  listClaimFilesApiResponseBody: () => listClaimFilesApiResponseBody,
  listClaimFilesMinimalRequestQuery: () => listClaimFilesMinimalRequestQuery,
  listClaimFilesRequestParams: () => listClaimFilesRequestParams,
  listClaimStatusResponseBody: () => listClaimStatusResponseBody,
  listClaimantPendingActionsRequestQuery: () => listClaimantPendingActionsRequestQuery,
  listCommentsRequestQuery: () => listCommentsRequestQuery,
  listCompanyAgreementRulesRequestQuery: () => listCompanyAgreementRulesRequestQuery,
  listCompanyAgreementTemplatesRequestQuery: () => listCompanyAgreementTemplatesRequestQuery,
  listCompanyClaimsResponseBody: () => listCompanyClaimsResponseBody,
  listCompanyEventsRequestQuery: () => listCompanyEventsRequestQuery,
  listCompanyLinkRequestQuery: () => listCompanyLinkRequestQuery,
  listCompanyMembersRequestQuery: () => listCompanyMembersRequestQuery,
  listCompanyMessageTemplatesRequestQuery: () => listCompanyMessageTemplatesRequestQuery,
  listCompanyOptionsRequestQuery: () => listCompanyOptionsRequestQuery,
  listCompanySubStatusRequestQuery: () => listCompanySubStatusRequestQuery,
  listContactsRequestQuery: () => listContactsRequestQuery,
  listCreatedJobsRequestQuery: () => listCreatedJobsRequestQuery,
  listCustomersRequestQuery: () => listCustomersRequestQuery,
  listDelegatedClaimsRequestQuery: () => listDelegatedClaimsRequestQuery,
  listDelegatedComplaintsRequestQuery: () => listDelegatedComplaintsRequestQuery,
  listDerivedClaimsRequestQuery: () => listDerivedClaimsRequestQuery,
  listEngagementsRequestQuery: () => listEngagementsRequestQuery,
  listEntrypointOptionsRequestQuery: () => listEntrypointOptionsRequestQuery,
  listEntrypointsAttemptsRequestQuery: () => listEntrypointsAttemptsRequestQuery,
  listEntrypointsRequestQuery: () => listEntrypointsRequestQuery,
  listExpertAppraisalPhotosRequestParams: () => listExpertAppraisalPhotosRequestParams,
  listExternalWorkflowVersionsResponseBody: () => listExternalWorkflowVersionsResponseBody,
  listExternalWorkflowsResponseBody: () => listExternalWorkflowsResponseBody,
  listFieldAdjusterClaimsRequestQuery: () => listFieldAdjusterClaimsRequestQuery,
  listFilesRequestQuery: () => listFilesRequestQuery,
  listGroupSLAVersionsRequestQuery: () => listGroupSLAVersionsRequestQuery,
  listImportableOrderDocumentsRequestQuery: () => listImportableOrderDocumentsRequestQuery,
  listInHouseLawyersRequestQuery: () => listInHouseLawyersRequestQuery,
  listInsurerClaimsRequestQuery: () => listInsurerClaimsRequestQuery,
  listInsurerComplaintsRequestQuery: () => listInsurerComplaintsRequestQuery,
  listInsurerOrdersRequestQuery: () => listInsurerOrdersRequestQuery,
  listIntegrationTemplatesRequestQuery: () => listIntegrationTemplatesRequestQuery,
  listInvitationsRequestQuery: () => listInvitationsRequestQuery,
  listMessageTemplatesRequestQuery: () => listMessageTemplatesRequestQuery,
  listNotificationsRequestQuery: () => listNotificationsRequestQuery,
  listOrderCandidatesRequestQuery: () => listOrderCandidatesRequestQuery,
  listPolicyholderInspectionsRequestParams: () => listPolicyholderInspectionsRequestParams,
  listProductImportsRequestQuery: () => listProductImportsRequestQuery,
  listProductsRequestQuery: () => listProductsRequestQuery,
  listProviderBranchesRequestQuery: () => listProviderBranchesRequestQuery,
  listProviderDocumentTypesBackofficeRequestQuery: () => listProviderDocumentTypesBackofficeRequestQuery,
  listProviderEngagementsRequestQuery: () => listProviderEngagementsRequestQuery,
  listProviderGroupsRequestQuery: () => listProviderGroupsRequestQuery,
  listProviderTemplatesRequestParams: () => listProviderTemplatesRequestParams,
  listProviderTemplatesRequestQuery: () => listProviderTemplatesRequestQuery,
  listSinisterClaimMessagesRequestParams: () => listSinisterClaimMessagesRequestParams,
  listSinisterRequestParams: () => listSinisterRequestParams,
  listTeamMembershipsRequestQuery: () => listTeamMembershipsRequestQuery,
  listVehicleMakeRequestQuery: () => listVehicleMakeRequestQuery,
  listVehicleModelsRequestQuery: () => listVehicleModelsRequestQuery,
  listVehicleVersionsRequestQuery: () => listVehicleVersionsRequestQuery,
  listVendorContractsRequestQuery: () => listVendorContractsRequestQuery,
  listVendorOrdersRequestQuery: () => listVendorOrdersRequestQuery,
  listVendorRFPsRequestQuery: () => listVendorRFPsRequestQuery,
  listVirtualViewsRequestQuery: () => listVirtualViewsRequestQuery,
  listWebhookLogsRequestQuery: () => listWebhookLogsRequestQuery,
  listWebhooksRequestQuery: () => listWebhooksRequestQuery,
  loginBackofficeRequestBody: () => loginBackofficeRequestBody,
  loginProvider: () => loginProvider,
  loginUserRequestBody: () => loginUserRequestBody,
  matchAcceptanceLawyer: () => matchAcceptanceLawyer,
  matchAcceptancePayee: () => matchAcceptancePayee,
  matchesClaimTypeComposition: () => matchesClaimTypeComposition,
  materialDamageBaseSchema: () => materialDamageBaseSchema,
  materialDamageDocuments: () => materialDamageDocuments,
  materialDamageKindLabel: () => materialDamageKindLabel,
  mergeAgreementBindings: () => mergeAgreementBindings,
  mergeAgreementSigners: () => mergeAgreementSigners,
  messageTemplateVariableOptionsSchema: () => messageTemplateVariableOptionsSchema,
  messageTemplateVariableSchema: () => messageTemplateVariableSchema,
  negotiationStageAccessOf: () => negotiationStageAccessOf,
  negotiationStageStatesOf: () => negotiationStageStatesOf,
  nonOperationalJobMetadata: () => nonOperationalJobMetadata,
  normalizeAutosignRecipientName: () => normalizeAutosignRecipientName,
  normalizeClaimEstimateValue: () => normalizeClaimEstimateValue,
  normalizeEmail: () => normalizeEmail,
  normalizeIdentification: () => normalizeIdentification,
  notFoundClaimErrorSchema: () => notFoundClaimErrorSchema,
  notFoundClaimOrFileErrorSchema: () => notFoundClaimOrFileErrorSchema,
  notFoundClaimStatusErrorSchema: () => notFoundClaimStatusErrorSchema,
  notFoundFileErrorSchema: () => notFoundFileErrorSchema,
  notifyBackofficeReleaseNoteRequestBody: () => notifyBackofficeReleaseNoteRequestBody,
  oauthExchangedCodeMessage: () => oauthExchangedCodeMessage,
  observationFromTransactionInfo: () => observationFromTransactionInfo,
  observationFromTransitionWebhook: () => observationFromTransitionWebhook,
  occurrenceBaseSchema: () => occurrenceBaseSchema,
  occurrenceSchema: () => occurrenceSchema2,
  offerAcceptanceFieldSchema: () => offerAcceptanceFieldSchema,
  offerAcceptanceRequirementSchema: () => offerAcceptanceRequirementSchema,
  offerAcceptanceRequirementsSchema: () => offerAcceptanceRequirementsSchema,
  offerAgreementCancelNotice: () => offerAgreementCancelNotice,
  offerAgreementDispatchFieldSchema: () => offerAgreementDispatchFieldSchema,
  offerAgreementDispatchFieldsSchema: () => offerAgreementDispatchFieldsSchema,
  offerAgreementDispatchRecipientRoles: () => offerAgreementDispatchRecipientRoles,
  offerAgreementDispatchRecipientSchema: () => offerAgreementDispatchRecipientSchema,
  offerAgreementDispatchRecipientsSchema: () => offerAgreementDispatchRecipientsSchema,
  offerAgreementPhaseOf: () => offerAgreementPhaseOf,
  offerAgreementPhaseOfStatus: () => offerAgreementPhaseOfStatus,
  offerAgreementProviderCancelSummary: () => offerAgreementProviderCancelSummary,
  offerAgreementTransitionBodySchema: () => offerAgreementTransitionBodySchema,
  offerAgreementTransitionDecision: () => offerAgreementTransitionDecision,
  offerAgreementTransitionEnvelopeSchema: () => offerAgreementTransitionEnvelopeSchema,
  offerMessageSampleTemplate: () => offerMessageSampleTemplate,
  offerSnapshotReferenceKeys: () => offerSnapshotReferenceKeys,
  offerTermsIssues: () => offerTermsIssues,
  offerTermsOptionsSchema: () => offerTermsOptionsSchema,
  offerTermsSchema: () => offerTermsSchema,
  offerWizardLegacyReasons: () => offerWizardLegacyReasons,
  offerWizardModes: () => offerWizardModes,
  openAIDecisionRequestBody: () => openAIDecisionRequestBody,
  operationalJobMetadata: () => operationalJobMetadata,
  optionalBooleanParam: () => optionalBooleanParam,
  optionalCommaListParam: () => optionalCommaListParam,
  orderCandidateScopes: () => orderCandidateScopes,
  orderClaimTriggerLabelKey: () => orderClaimTriggerLabelKey,
  orderDateFields: () => orderDateFields,
  orderItemInput: () => orderItemInput,
  orderReportInsuredSchema: () => orderReportInsuredSchema,
  orderReportItemSchema: () => orderReportItemSchema,
  orderReportParamsSchema: () => orderReportParamsSchema,
  orderReportPayloadSchema: () => orderReportPayloadSchema,
  orderReportSummarySchema: () => orderReportSummarySchema,
  orderReportVehicleSchema: () => orderReportVehicleSchema,
  orderReportWorkProofSchema: () => orderReportWorkProofSchema,
  orderScheduleCanceledEventMetadata: () => orderScheduleCanceledEventMetadata,
  orderSchedulingEventMetadata: () => orderSchedulingEventMetadata,
  orderTaxPercent: () => orderTaxPercent,
  orderWorkProofMechanism: () => orderWorkProofMechanism,
  overrideUserPermissions: () => overrideUserPermissions,
  paginateClaimsRequestQuery: () => paginateClaimsRequestQuery,
  paginateRequestQuery: () => paginateRequestQuery,
  paramIdSchema: () => paramIdSchema,
  parseAgreementBlockCopy: () => parseAgreementBlockCopy,
  parseBoundDigits: () => parseBoundDigits,
  parseBoundPositiveInteger: () => parseBoundPositiveInteger,
  parseBoundPositiveNumber: () => parseBoundPositiveNumber,
  parseMessageTemplateVariableOptions: () => parseMessageTemplateVariableOptions,
  parseReleaseNoteSection: () => parseReleaseNoteSection,
  parseRichText: () => parseRichText,
  passwordSchema: () => passwordSchema,
  patchAlertSubscriptionsRequestBody: () => patchAlertSubscriptionsRequestBody,
  patchTopicSubscriptionsRequestBody: () => patchTopicSubscriptionsRequestBody,
  patchedGenerateSchema: () => patchedGenerateSchema,
  payeeDocumentOf: () => payeeDocumentOf,
  percentageEstimatesProps: () => percentageEstimatesProps,
  performanceLeadingIndicatorKeys: () => performanceLeadingIndicatorKeys,
  personDamage: () => personDamage,
  personDamageKindLabel: () => personDamageKindLabel,
  pipeRefineSuperRefine: () => pipeRefineSuperRefine,
  placeholderRequestBody: () => placeholderRequestBody,
  planAgreementRequestBody: () => planAgreementRequestBody,
  policyholderRelationshipLabel: () => policyholderRelationshipLabel,
  presentAgreementValue: () => presentAgreementValue,
  previewOfferRequestBody: () => previewOfferRequestBody,
  previewProductImportRequestBody: () => previewProductImportRequestBody,
  processOfferAgreementJobMetadata: () => processOfferAgreementJobMetadata,
  productImportCreateRow: () => productImportCreateRow,
  productImportMapping: () => productImportMapping,
  productImportOptions: () => productImportOptions,
  productImportRowError: () => productImportRowError,
  productImportUpdateRow: () => productImportUpdateRow,
  providerBranchEmails: () => providerBranchEmails,
  providerBranchPhones: () => providerBranchPhones,
  providerPasswordSchema: () => providerPasswordSchema,
  providerRegistrationRequestBody: () => providerRegistrationRequestBody,
  providerUserRequestParams: () => providerUserRequestParams,
  proxyCreateComplaintRequestBody: () => proxyCreateComplaintRequestBody,
  proxyListComplaintCoveragesRequestQuery: () => proxyListComplaintCoveragesRequestQuery,
  proxyListOrderQuantityDescriptionRequestQuery: () => proxyListOrderQuantityDescriptionRequestQuery,
  publicAssetsEnvSchema: () => publicAssetsEnvSchema,
  publishAppraisalUpdatesRequestBody: () => publishAppraisalUpdatesRequestBody,
  publishBackofficeReleaseNoteRequestBody: () => publishBackofficeReleaseNoteRequestBody,
  publishContractUpdateNoteRequestBody: () => publishContractUpdateNoteRequestBody,
  publishOrderUpdateNoteRequestBody: () => publishOrderUpdateNoteRequestBody,
  readAgreementRuleAttribute: () => readAgreementRuleAttribute,
  realPropertyDamage: () => realPropertyDamage,
  realPropertyOwnershipLabel: () => realPropertyOwnershipLabel,
  realPropertyTypeLabel: () => realPropertyTypeLabel,
  reconcileOfferAgreementJobMetadata: () => reconcileOfferAgreementJobMetadata,
  recoverTeamDerivedClaimsRequestBody: () => recoverTeamDerivedClaimsRequestBody,
  recoveryDamage: () => recoveryDamage,
  recoveryDamageSchema: () => recoveryDamageSchema,
  recoveryRelationshipLabel: () => recoveryRelationshipLabel,
  registerInHouseLawyerAccountRequestBody: () => registerInHouseLawyerAccountRequestBody,
  registerUserByInvitationLocalRequestBody: () => registerUserByInvitationLocalRequestBody,
  registerUserByInvitationProviderRequestBody: () => registerUserByInvitationProviderRequestBody,
  registerUserExtendedRequestBody: () => registerUserExtendedRequestBody,
  registerUserRequestBody: () => registerUserRequestBody,
  rejectAppraisalReportRequestBody: () => rejectAppraisalReportRequestBody,
  rejectComplaintRequestBody: () => rejectComplaintRequestBody,
  rejectContractReportRequestBody: () => rejectContractReportRequestBody,
  rejectOfferRequestBody: () => rejectOfferRequestBody,
  rejectOrderDocumentRequestBody: () => rejectOrderDocumentRequestBody,
  rejectOrderRequestBody: () => rejectOrderRequestBody,
  releaseBackofficeReleaseNoteRequestBody: () => releaseBackofficeReleaseNoteRequestBody,
  releaseNoteEventRequest: () => releaseNoteEventRequest,
  releaseNoteItemInput: () => releaseNoteItemInput,
  releaseNoteListSelection: () => releaseNoteListSelection,
  releaseNoteSectionContentSchemas: () => releaseNoteSectionContentSchemas,
  releaseNoteSectionInput: () => releaseNoteSectionInput,
  remapAgreementConditions: () => remapAgreementConditions,
  removeAutoinspectorRequestQuery: () => removeAutoinspectorRequestQuery,
  removeClaimCollaboratorRequestParams: () => removeClaimCollaboratorRequestParams,
  removeCompanyCurrencyRequestParams: () => removeCompanyCurrencyRequestParams,
  removeCompanyEntrypointRequestParams: () => removeCompanyEntrypointRequestParams,
  removeCompanyLinkRequestParams: () => removeCompanyLinkRequestParams,
  removeCompanyStyleRequestParam: () => removeCompanyStyleRequestParam,
  removeComplaintCollaboratorRequestParams: () => removeComplaintCollaboratorRequestParams,
  removeIntegrationConnectionRequestParams: () => removeIntegrationConnectionRequestParams,
  removeOrderClaimStatusMappingRequestParams: () => removeOrderClaimStatusMappingRequestParams,
  removeProviderGroupMemberRequestParams: () => removeProviderGroupMemberRequestParams,
  removeValidationPatternRequestParams: () => removeValidationPatternRequestParams,
  renderAgreementMessageText: () => renderAgreementMessageText,
  renderAgreementSampleRequestBody: () => renderAgreementSampleRequestBody,
  renderDocumentRequestBody: () => renderDocumentRequestBody,
  reorderAgreementRulesRequestBody: () => reorderAgreementRulesRequestBody,
  reorderAgreementSignatureRulesRequestBody: () => reorderAgreementSignatureRulesRequestBody,
  reorderLoadBalanceRulesRequestBody: () => reorderLoadBalanceRulesRequestBody,
  requestAppraisalUpdatesRequestBody: () => requestAppraisalUpdatesRequestBody,
  requestContractUpdatesRequestBody: () => requestContractUpdatesRequestBody,
  requestFraudNewsRequestBody: () => requestFraudNewsRequestBody,
  requestLinkForgotPasswordRequestBody: () => requestLinkForgotPasswordRequestBody,
  requestResetPasswordToken: () => requestResetPasswordToken,
  requireVinculoOtherWhenRelationshipIsOther: () => requireVinculoOtherWhenRelationshipIsOther,
  rescheduleJobRequestParams: () => rescheduleJobRequestParams,
  resetUserPasswordRequestBody: () => resetUserPasswordRequestBody,
  resolveAcceptanceLawyer: () => resolveAcceptanceLawyer,
  resolveAcceptancePayee: () => resolveAcceptancePayee,
  resolveAgreementBindings: () => resolveAgreementBindings,
  resolveAgreementDamages: () => resolveAgreementDamages,
  resolveAgreementParties: () => resolveAgreementParties,
  resolveAgreementSignatureOrigin: () => resolveAgreementSignatureOrigin,
  resolveAgreementTemplateGaps: () => resolveAgreementTemplateGaps,
  resolveAgreementVariablesRequestBody: () => resolveAgreementVariablesRequestBody,
  resolveClaimPretension: () => resolveClaimPretension,
  resolveClaimantVictimIdentityIssues: () => resolveClaimantVictimIdentityIssues,
  resolveEmbeddedSigningEligibility: () => resolveEmbeddedSigningEligibility,
  resolveEstimatesDefinitionRequestQuery: () => resolveEstimatesDefinitionRequestQuery,
  resolveLawyerCuit: () => resolveLawyerCuit,
  resolveOfferAcceptanceRequirements: () => resolveOfferAcceptanceRequirements,
  resolveOfferAmountFromVariables: () => resolveOfferAmountFromVariables,
  resolveOfferCap: () => resolveOfferCap,
  resolveOfferPayeeNames: () => resolveOfferPayeeNames,
  resolveOfferTermsOptions: () => resolveOfferTermsOptions,
  resolveOfferWizardMode: () => resolveOfferWizardMode,
  resolvePrincipalClaimant: () => resolvePrincipalClaimant,
  resolveSignatureDispatch: () => resolveSignatureDispatch,
  respondEngagementRequestBody: () => respondEngagementRequestBody,
  restoreDelegatedClaimsRequestBody: () => restoreDelegatedClaimsRequestBody,
  restoreDelegatedComplaintsRequestBody: () => restoreDelegatedComplaintsRequestBody,
  retrieveAffectedCoverageRequestParams: () => retrieveAffectedCoverageRequestParams,
  retrieveAgreementPlanRequestQuery: () => retrieveAgreementPlanRequestQuery,
  retrieveAgreementTemplateRequestQuery: () => retrieveAgreementTemplateRequestQuery,
  retrieveClaimDerivationRequestParams: () => retrieveClaimDerivationRequestParams,
  retrieveClaimResponsibleCountRequestQuery: () => retrieveClaimResponsibleCountRequestQuery,
  retrieveClaimStatusRequestParams: () => retrieveClaimStatusRequestParams,
  retrieveCompanyAllowedScopesRequestBody: () => retrieveCompanyAllowedScopesRequestBody,
  retrieveCompanyClaimStatusOrderRuleRequestParams: () => retrieveCompanyClaimStatusOrderRuleRequestParams,
  retrieveCompanyClaimStatusRequestBody: () => retrieveCompanyClaimStatusRequestBody,
  retrieveCompanyComplaintStatusOrderRuleRequestParams: () => retrieveCompanyComplaintStatusOrderRuleRequestParams,
  retrieveCompanyComplaintStatusRequestBody: () => retrieveCompanyComplaintStatusRequestBody,
  retrieveCompanyEstimatesDefinitionRequestParams: () => retrieveCompanyEstimatesDefinitionRequestParams,
  retrieveCompanyStyleRequestQuery: () => retrieveCompanyStyleRequestQuery,
  retrieveComplaintDetailRequestParams: () => retrieveComplaintDetailRequestParams,
  retrieveComplaintPortalRequestParams: () => retrieveComplaintPortalRequestParams,
  retrieveComplaintRequestParamsSchema: () => retrieveComplaintRequestParamsSchema,
  retrieveComplaintSinisterCauseRequestParams: () => retrieveComplaintSinisterCauseRequestParams,
  retrieveCustomerRequestParams: () => retrieveCustomerRequestParams,
  retrieveEntrypointSnapshotRecordingRequestParams: () => retrieveEntrypointSnapshotRecordingRequestParams,
  retrieveExternalComplaintDetailRequestParams: () => retrieveExternalComplaintDetailRequestParams,
  retrieveInHouseLawyerRequestParams: () => retrieveInHouseLawyerRequestParams,
  retrieveInHouseLawyerRequestQuery: () => retrieveInHouseLawyerRequestQuery,
  retrieveInsurerProviderRequestParams: () => retrieveInsurerProviderRequestParams,
  retrieveIntegrationTemplateFieldsRequestParams: () => retrieveIntegrationTemplateFieldsRequestParams,
  retrieveIntegrationTemplateRequestParams: () => retrieveIntegrationTemplateRequestParams,
  retrieveInvitationInfoRequestBody: () => retrieveInvitationInfoRequestBody,
  retrieveMessageTemplateRequestParams: () => retrieveMessageTemplateRequestParams,
  retrieveOfferAgreementRequestParams: () => retrieveOfferAgreementRequestParams,
  retrieveOfferAgreementRequestQuery: () => retrieveOfferAgreementRequestQuery,
  retrieveOfferRequestParams: () => retrieveOfferRequestParams,
  retrieveOfferRequestQuery: () => retrieveOfferRequestQuery,
  retrieveOrderDocumentRequirementRequestParams: () => retrieveOrderDocumentRequirementRequestParams,
  retrieveProductImportRequestParams: () => retrieveProductImportRequestParams,
  retrieveProductRequestParams: () => retrieveProductRequestParams,
  retrieveProviderBranchRequestParams: () => retrieveProviderBranchRequestParams,
  retrieveProviderGroupRequestParams: () => retrieveProviderGroupRequestParams,
  retrieveRelationTypeSLAStatsRequestQuery: () => retrieveRelationTypeSLAStatsRequestQuery,
  retrieveReleaseNoteRequestParams: () => retrieveReleaseNoteRequestParams,
  retrieveResponsibilityTransferRequestParams: () => retrieveResponsibilityTransferRequestParams,
  retrieveReviewRequestParams: () => retrieveReviewRequestParams,
  retrieveSLAObjectivesRequestQuery: () => retrieveSLAObjectivesRequestQuery,
  retrieveSLARequestParams: () => retrieveSLARequestParams,
  retrieveSinisterRequestParams: () => retrieveSinisterRequestParams,
  retrieveUserRequestParams: () => retrieveUserRequestParams,
  retrieveValidationPatternRequestBody: () => retrieveValidationPatternRequestBody,
  returnClaimResponsibilityRequestBody: () => returnClaimResponsibilityRequestBody,
  returnTeamDerivedClaimsRequestBody: () => returnTeamDerivedClaimsRequestBody,
  revealApiKeyRequestParams: () => revealApiKeyRequestParams,
  reviewCommentSchema: () => reviewCommentSchema,
  reviewFiltersRequestQuery: () => reviewFiltersRequestQuery,
  reviewGlobalFiltersQuery: () => reviewGlobalFiltersQuery,
  reviewHeatmapRequestQuery: () => reviewHeatmapRequestQuery,
  reviewKpisRequestQuery: () => reviewKpisRequestQuery,
  reviewScoreBreakdownRequestQuery: () => reviewScoreBreakdownRequestQuery,
  reviewScoreOptions: () => reviewScoreOptions,
  reviewScoreSchema: () => reviewScoreSchema,
  reviewSortFields: () => reviewSortFields,
  reviewSortQuery: () => reviewSortQuery,
  reviewSparkVariants: () => reviewSparkVariants,
  reviewTokenRequestQuery: () => reviewTokenRequestQuery,
  richTextMarks: () => richTextMarks,
  rivadaviaCreateComplaintSchema: () => rivadaviaCreateComplaintSchema,
  sampleDocumentParamsSchema: () => sampleDocumentParamsSchema,
  sampleDocumentPayloadSchema: () => sampleDocumentPayloadSchema,
  saveAgreementTemplateVersionRequestBody: () => saveAgreementTemplateVersionRequestBody,
  saveBatchEntrypointRecordEventsRequestBody: () => saveBatchEntrypointRecordEventsRequestBody,
  saveVirtualViewRequestBody: () => saveVirtualViewRequestBody,
  scheduleNonOperationalJobRequestBody: () => scheduleNonOperationalJobRequestBody,
  scheduleTeamMemberInactivityRequestBody: () => scheduleTeamMemberInactivityRequestBody,
  searchCustomerOrganizationCandidateRequestQuery: () => searchCustomerOrganizationCandidateRequestQuery,
  searchDatasetRequestQuery: () => searchDatasetRequestQuery,
  searchEntityRequestQuery: () => searchEntityRequestQuery,
  searchIntegrationsRequestQuery: () => searchIntegrationsRequestQuery,
  searchRFPsByRelationTypeRequestQuery: () => searchRFPsByRelationTypeRequestQuery,
  searchRequestQuery: () => searchRequestQuery,
  searchTagsRequestQuery: () => searchTagsRequestQuery,
  searchUsersExactMatchRequestQuery: () => searchUsersExactMatchRequestQuery,
  searchUsersRequestQuery: () => searchUsersRequestQuery,
  searchVehicleRequestQuery: () => searchVehicleRequestQuery,
  selectAgreementRule: () => selectAgreementRule,
  selectAgreementSignatureRule: () => selectAgreementSignatureRule,
  selectBlockingViolations: () => selectBlockingViolations,
  selectClaimAgreements: () => selectClaimAgreements,
  selectExternalComplaintRequestBody: () => selectExternalComplaintRequestBody,
  selectManuallyRequestBody: () => selectManuallyRequestBody,
  serializeAgreementBlockCopy: () => serializeAgreementBlockCopy,
  setAutoinspectorTemplateEnabledRequestBody: () => setAutoinspectorTemplateEnabledRequestBody,
  setOrderScheduleRequestBody: () => setOrderScheduleRequestBody,
  shouldDispatchAgreementDocument: () => shouldDispatchAgreementDocument,
  signInAsCustomerOrganizationUserRequestBody: () => signInAsCustomerOrganizationUserRequestBody,
  signInKachRequestBody: () => signInKachRequestBody,
  signInRequestBody: () => signInRequestBody,
  signUpRequestBody: () => signUpRequestBody,
  signatureMayEndDigital: () => signatureMayEndDigital,
  signatureSchema: () => signatureSchema,
  signerKeysSharingEmail: () => signerKeysSharingEmail,
  signinAsQuerySchema: () => signinAsQuerySchema,
  singlePaymentDefinitions: () => singlePaymentDefinitions,
  sinisterExternalStatusUpdatedEventMetadata: () => sinisterExternalStatusUpdatedEventMetadata,
  slaFilterStatus: () => slaFilterStatus,
  slaReportFiltersSchema: () => slaReportFiltersSchema,
  splitAgreementPlaceholders: () => splitAgreementPlaceholders,
  stateLabel: () => stateLabel,
  submitBidRequestBody: () => submitBidRequestBody,
  submitReviewRequestBody: () => submitReviewRequestBody,
  supersedingOfferOf: () => supersedingOfferOf,
  tajyComplaintVehicleOccurrence: () => tajyComplaintVehicleOccurrence,
  tajyCreateComplaintOtherRequestBody: () => tajyCreateComplaintOtherRequestBody,
  tajyCreateComplaintRequestBody: () => tajyCreateComplaintRequestBody,
  tajyCreateComplaintSchema: () => tajyCreateComplaintSchema,
  tajyOccurrenceSchema: () => tajyOccurrenceSchema,
  teamActivityRequestQuery: () => teamActivityRequestQuery,
  teamClaimsDelegatedEventMetadata: () => teamClaimsDelegatedEventMetadata,
  teamClaimsReassignedEventMetadata: () => teamClaimsReassignedEventMetadata,
  teamClaimsRecoveredEventMetadata: () => teamClaimsRecoveredEventMetadata,
  teamDelegatedClaimsRequestBody: () => teamDelegatedClaimsRequestBody,
  teamDelegationClaimIds: () => teamDelegationClaimIds,
  teamDelegationCoveredClaimIds: () => teamDelegationCoveredClaimIds,
  teamDelegationJobMetadata: () => teamDelegationJobMetadata,
  teamDelegationPlanMetadata: () => teamDelegationPlanMetadata,
  teamDelegationPlanRequestQuery: () => teamDelegationPlanRequestQuery,
  teamDelegationRequest: () => teamDelegationRequest,
  teamDelegationSummary: () => teamDelegationSummary,
  teamLeavesRequestQuery: () => teamLeavesRequestQuery,
  teamManagementScopeRequestQuery: () => teamManagementScopeRequestQuery,
  teamManualDelegationAssignment: () => teamManualDelegationAssignment,
  teamManualDelegationMove: () => teamManualDelegationMove,
  teamManualDelegationRequestQuery: () => teamManualDelegationRequestQuery,
  teamReassignmentCandidatesRequestQuery: () => teamReassignmentCandidatesRequestQuery,
  tenantParamsSchema: () => tenantParamsSchema,
  testWebhookEventRequestBody: () => testWebhookEventRequestBody,
  toAgreementSignatureDecision: () => toAgreementSignatureDecision,
  toDocumentVariant: () => toDocumentVariant,
  toPreviewAcceptanceRequirements: () => toPreviewAcceptanceRequirements,
  toReleaseNoteItemView: () => toReleaseNoteItemView,
  tokenizeFileRequestBody: () => tokenizeFileRequestBody,
  transactionCancelledWebhookPayloadSchema: () => transactionCancelledWebhookPayloadSchema,
  transferClaimRequestBody: () => transferClaimRequestBody,
  triggerMappingMoveDirections: () => triggerMappingMoveDirections,
  unionComplaintSchema: () => unionComplaintSchema,
  unlinkCustomerOrganizationUserRequestBody: () => unlinkCustomerOrganizationUserRequestBody,
  updateAgreementRuleRequestBody: () => updateAgreementRuleRequestBody,
  updateAgreementSignatureRuleRequestBody: () => updateAgreementSignatureRuleRequestBody,
  updateAgreementTemplateRequestBody: () => updateAgreementTemplateRequestBody,
  updateAutoinspectorTemplateFieldMappingsRequestBody: () => updateAutoinspectorTemplateFieldMappingsRequestBody,
  updateAutoinspectorTemplateRequestBody: () => updateAutoinspectorTemplateRequestBody,
  updateBackofficeReleaseNoteVisibilityRequestBody: () => updateBackofficeReleaseNoteVisibilityRequestBody,
  updateCapabilitiesRequestBody: () => updateCapabilitiesRequestBody,
  updateClaimEstimatesRequestBody: () => updateClaimEstimatesRequestBody,
  updateClaimIntakeRequestBody: () => updateClaimIntakeRequestBody,
  updateClaimRequestBody: () => updateClaimRequestBody,
  updateClaimStatusDefinitionRequestBody: () => updateClaimStatusDefinitionRequestBody,
  updateClaimStatusDefinitionResponseBody: () => updateClaimStatusDefinitionResponseBody,
  updateClaimStatusRequestParams: () => updateClaimStatusRequestParams,
  updateClaimantSchema: () => updateClaimantSchema,
  updateCompanyClaimStatusOrderRuleRequestBody: () => updateCompanyClaimStatusOrderRuleRequestBody,
  updateCompanyClaimStatusRequestBody: () => updateCompanyClaimStatusRequestBody,
  updateCompanyComplaintStatusOrderRuleRequestBody: () => updateCompanyComplaintStatusOrderRuleRequestBody,
  updateCompanyComplaintStatusRequestBody: () => updateCompanyComplaintStatusRequestBody,
  updateCompanyConfigurationRequestBody: () => updateCompanyConfigurationRequestBody,
  updateCompanyCurrencyRequestBody: () => updateCompanyCurrencyRequestBody,
  updateCompanyCustomizationRequestBody: () => updateCompanyCustomizationRequestBody,
  updateCompanyEstimatesDefinitionRequestBody: () => updateCompanyEstimatesDefinitionRequestBody,
  updateCompanyFieldMappingConfigRequestBody: () => updateCompanyFieldMappingConfigRequestBody,
  updateCompanyFlagsRequestBody: () => updateCompanyFlagsRequestBody,
  updateCompanyLogoRequestBody: () => updateCompanyLogoRequestBody,
  updateCompanyRequestBody: () => updateCompanyRequestBody,
  updateCompanyResponseBody: () => updateCompanyResponseBody,
  updateCompanySinisterConfigRequestBody: () => updateCompanySinisterConfigRequestBody,
  updateCompanyTagRequestBody: () => updateCompanyTagRequestBody,
  updateCompanyTagRequestParams: () => updateCompanyTagRequestParams,
  updateCompanyTagResponseBody: () => updateCompanyTagResponseBody,
  updateCompanyVerticalsRequestBody: () => updateCompanyVerticalsRequestBody,
  updateCompanyWorkingDaysRequestBody: () => updateCompanyWorkingDaysRequestBody,
  updateComplaintRequestBody: () => updateComplaintRequestBody,
  updateComplaintSinisterCauseRequestBody: () => updateComplaintSinisterCauseRequestBody,
  updateComplaintStatusRequestParams: () => updateComplaintStatusRequestParams,
  updateContactRequestBody: () => updateContactRequestBody,
  updateCoverageRequestBody: () => updateCoverageRequestBody,
  updateCustomerOrganizationLogoRequestBody: () => updateCustomerOrganizationLogoRequestBody,
  updateCustomerOrganizationRequestBody: () => updateCustomerOrganizationRequestBody,
  updateCustomerRequestBody: () => updateCustomerRequestBody,
  updateEngagementRequestBody: () => updateEngagementRequestBody,
  updateEngagementStatusRequestBody: () => updateEngagementStatusRequestBody,
  updateEstimatesInstanceRequestBody: () => updateEstimatesInstanceRequestBody,
  updateFileRequestParams: () => updateFileRequestParams,
  updateFileTagRequestBody: () => updateFileTagRequestBody,
  updateFileTagRequestParams: () => updateFileTagRequestParams,
  updateFilesTagsInBatchRequestBody: () => updateFilesTagsInBatchRequestBody,
  updateFilesTagsInBatchRequestParams: () => updateFilesTagsInBatchRequestParams,
  updateGoodRequestBody: () => updateGoodRequestBody,
  updateInHouseLawyerRequestBody: () => updateInHouseLawyerRequestBody,
  updateInferredKeywordRequestBody: () => updateInferredKeywordRequestBody,
  updateInferredKeywordRequestParams: () => updateInferredKeywordRequestParams,
  updateInsurerUserRequestBody: () => updateInsurerUserRequestBody,
  updateIntegrationConnectionRequestBody: () => updateIntegrationConnectionRequestBody,
  updateIntegrationConnectionRequestParams: () => updateIntegrationConnectionRequestParams,
  updateIntegrationTemplateRequestBody: () => updateIntegrationTemplateRequestBody,
  updateLoadBalanceRuleRequestBody: () => updateLoadBalanceRuleRequestBody,
  updateMessageTemplateRequestBody: () => updateMessageTemplateRequestBody,
  updateOrderDocumentRequirementRequestBody: () => updateOrderDocumentRequirementRequestBody,
  updateProductRequestBody: () => updateProductRequestBody,
  updateProviderGroupRequestBody: () => updateProviderGroupRequestBody,
  updateProviderProfileRequestBody: () => updateProviderProfileRequestBody,
  updateRelationTypeStatusRequestBody: () => updateRelationTypeStatusRequestBody,
  updateServiceAccountRequestBody: () => updateServiceAccountRequestBody,
  updateServiceRequestBody: () => updateServiceRequestBody,
  updateTeamManagementMemberRequestBody: () => updateTeamManagementMemberRequestBody,
  updateTeamMemberInactivityRequestBody: () => updateTeamMemberInactivityRequestBody,
  updateTeamRequestBody: () => updateTeamRequestBody,
  updateTeamScheduledDelegationRequestBody: () => updateTeamScheduledDelegationRequestBody,
  updateUserAvatarRequestBody: () => updateUserAvatarRequestBody,
  updateUserInfoRequestBody: () => updateUserInfoRequestBody,
  updateUserOverridePermissionsRequestBody: () => updateUserOverridePermissionsRequestBody,
  updateValidationPatternRequestBody: () => updateValidationPatternRequestBody,
  updateValidationPatternRequestParams: () => updateValidationPatternRequestParams,
  updateVerticalRequestBody: () => updateVerticalRequestBody,
  updateWebhookRequestBody: () => updateWebhookRequestBody,
  updateWorkflowRequestBody: () => updateWorkflowRequestBody,
  updateWorkflowRequestParams: () => updateWorkflowRequestParams,
  uploadAppraisalInvoiceRequestBody: () => uploadAppraisalInvoiceRequestBody,
  uploadClaimSharedDocumentsRequestBody: () => uploadClaimSharedDocumentsRequestBody,
  uploadContractInvoiceRequestBody: () => uploadContractInvoiceRequestBody,
  uploadContractRequestBody: () => uploadContractRequestBody,
  uploadManualAgreementDocumentRequestBody: () => uploadManualAgreementDocumentRequestBody,
  uploadOrderDocumentRequestBody: () => uploadOrderDocumentRequestBody,
  uploadOrderRequiredDocumentRequestBody: () => uploadOrderRequiredDocumentRequestBody,
  uploadProviderDocumentRequestBody: () => uploadProviderDocumentRequestBody,
  upsertCompanySLARequestBody: () => upsertCompanySLARequestBody,
  upsertOrderClaimStatusMappingRequestBody: () => upsertOrderClaimStatusMappingRequestBody,
  upsertProviderBranchRequestBody: () => upsertProviderBranchRequestBody,
  upsertProviderDocumentTypeRequestBody: () => upsertProviderDocumentTypeRequestBody,
  userAssignmentsEventMetadata: () => userAssignmentsEventMetadata,
  userDelegatedClaimsRecoveredEventMetadata: () => userDelegatedClaimsRecoveredEventMetadata,
  userDelegatedClaimsReturnedEventMetadata: () => userDelegatedClaimsReturnedEventMetadata,
  userDerivedClaimsRecoveredEventMetadata: () => userDerivedClaimsRecoveredEventMetadata,
  userDerivedClaimsReturnedEventMetadata: () => userDerivedClaimsReturnedEventMetadata,
  userInactivityCancelledEventMetadata: () => userInactivityCancelledEventMetadata,
  userInactivityClaimsDelegatedEventMetadata: () => userInactivityClaimsDelegatedEventMetadata,
  userInactivityDelegationUpdatedEventMetadata: () => userInactivityDelegationUpdatedEventMetadata,
  userInactivityEndedEventMetadata: () => userInactivityEndedEventMetadata,
  userInactivityRescheduledEventMetadata: () => userInactivityRescheduledEventMetadata,
  userInactivityReturnChangedEventMetadata: () => userInactivityReturnChangedEventMetadata,
  userInactivityScheduledEventMetadata: () => userInactivityScheduledEventMetadata,
  userInactivityStartedEventMetadata: () => userInactivityStartedEventMetadata,
  validateAcceptancePayeeRequestBody: () => validateAcceptancePayeeRequestBody,
  validateAgreementTemplateSigners: () => validateAgreementTemplateSigners,
  validateClaimEstimateValue: () => validateClaimEstimateValue,
  validateClaimantVictimConsistency: () => validateClaimantVictimConsistency,
  validateInterbankingRequestQuery: () => validateInterbankingRequestQuery,
  validateLinkedList: () => validateLinkedList,
  validateOfferTerms: () => validateOfferTerms,
  validationIssueSchema: () => validationIssueSchema,
  validationIssuesSchema: () => validationIssuesSchema,
  validationPatternList: () => validationPatternList,
  vehicleDamage: () => vehicleDamage,
  vehicleTypeLabel: () => vehicleTypeLabel,
  vehicleUseLabel: () => vehicleUseLabel,
  verifyAccountRequestBody: () => verifyAccountRequestBody,
  victimRelationshipFormSchema: () => victimRelationshipFormSchema,
  victimRelationshipLabel: () => victimRelationshipLabel,
  victimRelationshipSchema: () => victimRelationshipSchema,
  victimRoleLabel: () => victimRoleLabel,
  vinculoOtherRefineParams: () => vinculoOtherRefineParams,
  webhookEventPayloadSchema: () => webhookEventPayloadSchema,
  webhookEventsSchema: () => webhookEventsSchema,
  webhookEventsSpec: () => webhookEventsSpec,
  webhookSchema: () => webhookSchema,
  whitelistedEmailSchema: () => whitelistedEmailSchema,
  withAlertEnvironmentTag: () => withAlertEnvironmentTag,
  withApplicableFranchise: () => withApplicableFranchise,
  workflowParamSchema: () => workflowParamSchema
});
module.exports = __toCommonJS(bff_exports);

// contracts/user.contracts.ts
var import_database = __toESM(require_index_browser4());
var import_zod3 = require("zod");
var import_piramid_constants3 = __toESM(require_dist2());

// contracts/authentication.contract.ts
var import_piramid_constants = __toESM(require_dist2());
var import_zod = require("zod");
var passwordSchema = import_zod.z.object({
  password: import_zod.z.string().min(1, import_piramid_constants.requiredFieldMessage).max(255, "La contrase\xF1a debe tener menos de 255 caracteres"),
  passwordConfirmation: import_zod.z.string().min(1, import_piramid_constants.requiredFieldMessage)
}).refine((data) => data.password === data.passwordConfirmation, {
  message: "Las contrase\xF1as no coinciden",
  path: ["passwordConfirmation"]
});
var providerPasswordSchema = import_zod.z.string({ required_error: import_piramid_constants.requiredFieldMessage }).min(8, "La contrase\xF1a debe tener al menos 8 caracteres");
var requestLinkForgotPasswordRequestBody = import_zod.z.object({
  email: import_zod.z.string().email()
});
var requestResetPasswordToken = import_zod.z.object({
  token: import_zod.z.string()
});
var resetUserPasswordRequestBody = passwordSchema;
var verifyAccountRequestBody = import_zod.z.object({
  verificationCode: import_zod.z.string(),
  email: import_zod.z.string().email()
});

// contracts/types.contract.ts
var import_piramid_constants2 = __toESM(require_dist2());
var import_zod2 = require("zod");

// validations/cuit.ts
var import_utils30 = __toESM(require_dist3());
var DEFAULT_CUIT_LENGTH = 11;
var cuitCountries = [
  {
    code: "ARG",
    name: "Argentina",
    type: ["20", "23", "24", "25", "26", "27"],
    len: {
      from: 11,
      to: 11
    },
    validator: (value) => {
      if (value.length !== DEFAULT_CUIT_LENGTH) {
        return false;
      }
      const verificationNumber = parseInt(
        value.charAt(DEFAULT_CUIT_LENGTH - 1),
        10
      );
      const cuit = value.slice(0, -1);
      console.log("cuit", cuit);
      return verificationNumber === (0, import_utils30.calculateVerificationNumber)(cuit);
    }
  },
  {
    code: "PRY",
    name: "Paraguay",
    type: ["80"],
    len: {
      from: 8,
      to: 9
    },
    validator: (value) => {
      if (value.slice(0, 2) !== "80") {
        return false;
      }
      return true;
    }
  }
];
var cuitRefine = ({
  val,
  country
}) => {
  const targetCountry = cuitCountries.find((c2) => c2.code === country);
  console.log("targetCountry", targetCountry);
  if (!targetCountry) {
    return true;
  }
  if (val.length < targetCountry.len.from || val.length > targetCountry.len.to) {
    return false;
  }
  if (targetCountry.validator) {
    return targetCountry.validator(val);
  }
  return true;
};

// contracts/types.contract.ts
var DEFAULT_DNI_LENGTH = 7;
var einSchema = (country) => {
  return import_zod2.z.string().max(
    DEFAULT_CUIT_LENGTH,
    `El CUIT no debe superar los ${DEFAULT_CUIT_LENGTH} d\xEDgitos`
  ).refine(
    (value) => {
      if (!country) {
        return true;
      }
      return cuitRefine({ val: value, country });
    },
    {
      message: "El CUIT ingresado no es v\xE1lido"
    }
  );
};
var cuitSchema = (country) => {
  return import_zod2.z.string().max(
    DEFAULT_CUIT_LENGTH,
    `El CUIT no debe superar los ${DEFAULT_CUIT_LENGTH} d\xEDgitos`
  ).refine(
    (value) => {
      if (!country) {
        return true;
      }
      return cuitRefine({ val: value, country });
    },
    {
      message: "El CUIT ingresado no es v\xE1lido"
    }
  );
};
var CUIT_CUIL_LENGTH = 11;
var genericDocumentNumber = import_zod2.z.string({
  message: import_piramid_constants2.requiredFieldMessage
}).max(8, `Maximo 8 d\xEDgitos`).regex(/^\d+$/, "\xDAnicamente d\xEDgitos");
var cuitCuilSchema = import_zod2.z.string().length(CUIT_CUIL_LENGTH, `Debe tener ${CUIT_CUIL_LENGTH} caracteres`).regex(/^\d+$/, "\xDAnicamente d\xEDgitos");
var dni = import_zod2.z.string({
  message: import_piramid_constants2.requiredFieldMessage
}).min(DEFAULT_DNI_LENGTH, `M\xEDnimo ${DEFAULT_DNI_LENGTH} d\xEDgitos`).max(8, `M\xE1ximo 8 d\xEDgitos`).regex(/^\d+$/, "\xDAnicamente d\xEDgitos");
var whitelistedEmailSchema = import_zod2.z.string({
  message: import_piramid_constants2.requiredFieldMessage
}).min(1, import_piramid_constants2.requiredFieldMessage).email("El email no es v\xE1lido").refine(
  (email) => {
    const forbiddenPrefixes = [
      "noposee",
      "no@posee",
      "notiene",
      "no@tiene",
      "noaplica",
      "no@aplica",
      "noposeo",
      "no@poseo",
      "notengo",
      "no@tengo",
      "mail@mail",
      "no@mail",
      "prueba",
      "o@posee"
    ];
    const lowercaseEmail = email.toLowerCase().trim().replace(/ /g, "");
    return !forbiddenPrefixes.some(
      (prefix) => lowercaseEmail.startsWith(prefix)
    );
  },
  {
    message: "El email no es v\xE1lido"
  }
);
var dniSchema = dni;
var pipeRefineSuperRefine = (path, schema, value, ctx) => {
  const valid2 = schema.safeParse(value);
  if (!valid2.success) {
    ctx.addIssue({
      code: import_zod2.z.ZodIssueCode.custom,
      message: valid2.error.issues[0].message,
      path: [path]
    });
    return false;
  }
  return true;
};

// contracts/user.contracts.ts
var createUserRequestBody = import_zod3.z.object({
  firstName: import_zod3.z.string(),
  lastName: import_zod3.z.string(),
  email: import_zod3.z.string().email(),
  ein: einSchema().optional(),
  dni: import_zod3.z.string().length(8).optional()
});
var searchUsersRequestQuery = import_zod3.z.object({
  search: import_zod3.z.string().optional(),
  limit: import_zod3.z.coerce.number().max(20).default(10),
  permissionType: import_zod3.z.nativeEnum(import_database.PermissionType).optional(),
  blacklistUserIds: import_zod3.z.array(import_zod3.z.coerce.string()).default([]),
  blacklistTeamIds: import_zod3.z.array(import_zod3.z.coerce.string()).default([]),
  userType: import_zod3.z.array(import_zod3.z.nativeEnum(import_database.UserType)).default([])
});
var searchUsersExactMatchRequestQuery = import_zod3.z.object({
  search: import_zod3.z.string().min(1, "Campo requerido"),
  limit: import_zod3.z.coerce.number()
});
var retrieveUserRequestParams = import_zod3.z.object({
  userId: import_zod3.z.coerce.string()
});
var overrideUserPermissions = [
  "can_create_judicial_amount",
  "can_update_judicial_amount",
  "can_create_administrative_amount",
  "can_update_administrative_amount",
  "can_create_percentage_of_liability",
  "can_update_percentage_of_liability"
];
var updateUserOverridePermissionsRequestBody = import_zod3.z.object({
  override_permissions: import_zod3.z.array(
    import_zod3.z.object({
      type: import_zod3.z.enum(overrideUserPermissions),
      limit: import_zod3.z.coerce.number().optional(),
      relative_deviation_percentage: import_zod3.z.number().gte(0).lte(100).nullish()
    }).refine(
      (permission) => {
        if (permission.type === "can_create_percentage_of_liability" && permission.limit && permission.limit > 100)
          return false;
        return true;
      },
      {
        message: "Limit must be less than or equal to 100 for percentage of liability permission"
      }
    )
  )
});
var updateInsurerUserRequestBody = updateUserOverridePermissionsRequestBody.extend({
  role_id: import_zod3.z.coerce.string()
});
var retrieveClaimResponsibleCountRequestQuery = import_zod3.z.object({
  system_status: import_zod3.z.array(import_zod3.z.nativeEnum(import_database.ClaimStatusType)).default([]),
  with_derived_breakdown: import_zod3.z.enum(["true", "false"]).transform((value) => value === "true").optional()
});
var ListCompanyUsersResponseBody = import_zod3.z.object({
  users: import_zod3.z.array(
    import_zod3.z.object({
      id: import_zod3.z.coerce.string(),
      value: import_zod3.z.coerce.string().min(1),
      profile_photo: import_zod3.z.string().url().nullish()
    })
  )
});
var updateUserAvatarRequestBody = import_zod3.z.object({
  file_token: import_zod3.z.string()
});
var changeUserPasswordRequestBody = import_zod3.z.object({
  currentPassword: import_zod3.z.string().min(1, import_piramid_constants3.requiredFieldMessage),
  password: providerPasswordSchema.max(
    255,
    "La contrase\xF1a debe tener menos de 255 caracteres"
  ),
  passwordConfirmation: import_zod3.z.string().min(1, import_piramid_constants3.requiredFieldMessage)
}).refine((data) => data.password === data.passwordConfirmation, {
  message: "Las contrase\xF1as no coinciden",
  path: ["passwordConfirmation"]
});

// contracts/sinister.contract.ts
var import_zod5 = require("zod");

// contracts/pagination.contract.ts
var import_zod4 = require("zod");
var import_piramid_constants4 = __toESM(require_dist2());
var paginateRequestQuery = import_zod4.z.object({
  page: import_zod4.z.coerce.number().min(1).default(1),
  limit: import_zod4.z.coerce.number().min(1).max(20).default(10),
  createdAt: import_zod4.z.enum(import_piramid_constants4.sortTypes).optional(),
  search: import_zod4.z.string().optional()
});

// contracts/sinister.contract.ts
var import_piramid_constants5 = __toESM(require_dist2());
var listSinisterRequestParams = paginateRequestQuery;
var fetchSinisterDetailRequestParams = import_zod5.z.object({
  id: import_zod5.z.coerce.string().min(1, import_piramid_constants5.requiredFieldMessage)
});
var listSinisterClaimMessagesRequestParams = import_zod5.z.object({
  sinisterId: import_zod5.z.coerce.string(),
  claimId: import_zod5.z.coerce.string()
});
var removeClaimCollaboratorRequestParams = import_zod5.z.object({
  userId: import_zod5.z.coerce.string(),
  claimId: import_zod5.z.coerce.string()
});
var retrieveSinisterRequestParams = import_zod5.z.object({
  sinisterId: import_zod5.z.coerce.string()
});
var selectExternalComplaintRequestBody = import_zod5.z.object({
  claims: import_zod5.z.array(
    import_zod5.z.object({
      id: import_zod5.z.coerce.string({
        invalid_type_error: import_piramid_constants5.requiredFieldMessage,
        required_error: import_piramid_constants5.requiredFieldMessage
      }).min(1, import_piramid_constants5.requiredFieldMessage)
    })
  ).min(1, "At least one claim").refine(
    (claims) => new Set(claims.map((c2) => c2.id)).size === claims.length,
    {
      message: "There are some duplicated claims",
      path: ["claims"]
    }
  )
});
var createPendingComplaintRequestBody = selectExternalComplaintRequestBody;
var selectManuallyRequestBody = selectExternalComplaintRequestBody.extend({
  externalComplaintId: import_zod5.z.string().min(1, import_piramid_constants5.requiredFieldMessage)
});

// contracts/backoffice-fraud.contract.ts
var import_piramid_constants6 = __toESM(require_dist2());
var import_zod6 = require("zod");
var listBackofficeFraudInvestigationsRequestQuery = paginateRequestQuery.extend({
  company: import_zod6.z.array(import_zod6.z.coerce.string()).default([]),
  created_after: import_zod6.z.coerce.date().default(new Date(import_piramid_constants6.KACH_INTEGRATION_PRODUCTION_LAUNCH_DATE))
});
var fetchBackofficeFraudInvestigationParams = import_zod6.z.object({
  id: import_zod6.z.coerce.string()
});

// contracts/file-request.contracts.ts
var import_database2 = __toESM(require_index_browser4());
var import_piramid_constants7 = __toESM(require_dist2());
var import_zod7 = require("zod");
var createFileRequestRequestParams = import_zod7.z.object({
  sinisterId: import_zod7.z.coerce.string(),
  relationType: import_zod7.z.enum(["claim", "complaint"]),
  relationTypeId: import_zod7.z.coerce.string()
});
var placeholderRequestBody = import_zod7.z.object({
  tag_name: import_zod7.z.string().optional().nullable(),
  tag_id: import_zod7.z.coerce.string({
    invalid_type_error: import_piramid_constants7.requiredFieldMessage,
    required_error: import_piramid_constants7.requiredFieldMessage
  }).min(1, import_piramid_constants7.requiredFieldMessage),
  max_files: import_zod7.z.coerce.number().min(1, "Minimo un archivo").default(1),
  context: import_zod7.z.string().max(255, "M\xE1ximo 255 caracteres").optional(),
  types: import_zod7.z.array(import_zod7.z.nativeEnum(import_database2.FileTypes)).min(1, "M\xEDnimo un tipo de archivo")
});
var fileRequestMessageSchema = import_zod7.z.string().min(1, import_piramid_constants7.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres");
var createFileRequestRequestBody = import_zod7.z.object({
  message: import_zod7.z.string().nullish(),
  placeholders: import_zod7.z.array(placeholderRequestBody).min(1, "M\xEDnimo un documento se debe solicitar").refine((p) => new Set(p.map((p2) => p2.tag_id)).size === p.length, {
    message: "En una misma solicitud no se puede repetir el mismo documento"
  }),
  notify: import_zod7.z.boolean().default(true)
});
var ackFileRequestPlaceholderRequestParams = import_zod7.z.object({
  fileRequestId: import_zod7.z.coerce.string(),
  placeholderId: import_zod7.z.coerce.string(),
  // TODO: use relation type params to indicate if its claim or complaint and their id
  claimId: import_zod7.z.coerce.string().nullish(),
  complaintId: import_zod7.z.coerce.string().nullish()
});
var ackFileRequestPlaceholderRequestBody = import_zod7.z.object({
  files: import_zod7.z.array(
    import_zod7.z.object({
      token: import_zod7.z.string().min(1, import_piramid_constants7.requiredFieldMessage)
    })
  ).min(1)
});
var cancelFileRequestPlaceholderRequestBody = import_zod7.z.object({
  reason: import_zod7.z.string({ required_error: import_piramid_constants7.requiredFieldMessage }).min(1, import_piramid_constants7.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres")
});

// contracts/tag.contracts.ts
var import_database3 = __toESM(require_index_browser4());
var import_zod8 = require("zod");
var searchTagsRequestQuery = import_zod8.z.object({
  search: import_zod8.z.string().optional(),
  limit: import_zod8.z.coerce.number().default(10)
});
var batchListTagsRequestQuery = import_zod8.z.object({
  aliases: import_zod8.z.array(import_zod8.z.nativeEnum(import_database3.TagAliases))
});
var createCompanyTagRequestBody = import_zod8.z.object({
  name: import_zod8.z.string().min(1, "El nombre es requerido"),
  description: import_zod8.z.string().optional(),
  type: import_zod8.z.nativeEnum(import_database3.TagTypes).default(import_database3.TagTypes.custom)
});
var createCompanyTagRequestParams = import_zod8.z.object({
  company_id: import_zod8.z.string()
});
var createCompanyTagResponseBody = import_zod8.z.object({
  tag: import_zod8.z.object({
    id: import_zod8.z.string()
  })
});
var updateCompanyTagRequestParams = import_zod8.z.object({
  tagId: import_zod8.z.string()
});
var deleteCompanyTagResponseBody = import_zod8.z.object({
  removed: import_zod8.z.boolean()
});
var updateCompanyTagResponseBody = import_zod8.z.object({
  updated: import_zod8.z.boolean()
});
var updateCompanyTagRequestBody = import_zod8.z.object({
  name: import_zod8.z.string(),
  description: import_zod8.z.string().optional()
});

// contracts/rfp.contract.ts
var import_database4 = __toESM(require_index_browser4());
var import_piramid_constants9 = __toESM(require_dist2());
var import_zod9 = require("zod");

// validations/country.ts
var import_piramid_constants8 = __toESM(require_dist2());
var countryRefine = (val) => import_piramid_constants8.countryAndStates.some((c2) => c2.code === val);
var stateRefine = (arg, mapCountry) => {
  if (!arg.state) return false;
  const country = import_piramid_constants8.countryAndStates.find((c2) => c2.code === mapCountry(arg));
  if (!country) return false;
  return country.states.some((s3) => s3.code === arg.state);
};

// contracts/rfp.contract.ts
var createClaimRFPSchema = import_zod9.z.object({
  vendors: import_zod9.z.array(
    import_zod9.z.object({
      id: import_zod9.z.coerce.string()
    })
  ).refine(
    (vendors) => new Set(vendors.map((vendor) => vendor.id)).size === vendors.length,
    {
      message: "Vendors must be unique"
    }
  ),
  country: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage).refine(countryRefine),
  state: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage),
  city: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage),
  name: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage),
  description: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage),
  tags: import_zod9.z.array(import_zod9.z.string()).default([]),
  deadline: import_zod9.z.coerce.date({
    invalid_type_error: import_piramid_constants9.requiredFieldMessage,
    required_error: import_piramid_constants9.requiredFieldMessage
  }).min(/* @__PURE__ */ new Date()),
  mode: import_zod9.z.nativeEnum(import_database4.RequestForProposalMode),
  files: import_zod9.z.array(
    import_zod9.z.object({
      token: import_zod9.z.string()
    })
  ).max(import_piramid_constants9.MAX_RFP_FILES).default([])
});
var createClaimRFPRequestBody = createClaimRFPSchema.refine(
  (arg) => stateRefine(arg, (data) => data.country)
);
var listVendorRFPsRequestQuery = paginateRequestQuery;
var bidLineSchema = import_zod9.z.object({
  type: import_zod9.z.nativeEnum(import_database4.BidLineType),
  make: import_zod9.z.string().max(255, "M\xE1ximo 255 caracteres!").optional(),
  model: import_zod9.z.string().max(255, "M\xE1ximo 255 caracteres!").optional(),
  serial_number: import_zod9.z.string().max(255, "M\xE1ximo 255 caracteres!").optional(),
  quantity: import_zod9.z.coerce.number(),
  unit_of_measurement: import_zod9.z.nativeEnum(import_database4.BidLineUnitOfMeasurement),
  unit_price: import_zod9.z.coerce.number()
});
var submitBidRequestBody = import_zod9.z.object({
  expiration: import_zod9.z.coerce.date(),
  lines: import_zod9.z.array(bidLineSchema).min(1),
  files: import_zod9.z.array(
    import_zod9.z.object({
      token: import_zod9.z.string()
    })
  ).max(import_piramid_constants9.MAX_RFP_FILES).default([])
});
var searchRFPsByRelationTypeRequestQuery = import_zod9.z.object({
  search: import_zod9.z.string().nullish(),
  page: import_zod9.z.coerce.number().min(1),
  limit: import_zod9.z.coerce.number().min(1).max(20)
});
var cancelRFPForClaimRequestBody = import_zod9.z.object({
  reason: import_zod9.z.string().min(1, import_piramid_constants9.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres")
});

// contracts/contract.ts
var import_database5 = __toESM(require_index_browser4());
var import_piramid_constants11 = __toESM(require_dist2());
var import_zod11 = require("zod");

// contracts/appraisal-report.contract.ts
var import_piramid_constants10 = __toESM(require_dist2());
var import_zod10 = require("zod");
var addAppraisalReportRequestBody = import_zod10.z.object({
  report_token: import_zod10.z.string().min(1, "Archivo requerido"),
  risk: import_zod10.z.coerce.number().nullish(),
  total_disability: import_zod10.z.coerce.number().nullish(),
  appraised_total_value: import_zod10.z.coerce.number().nullish()
});
var rejectAppraisalReportRequestBody = import_zod10.z.object({
  reason: import_zod10.z.string().min(1, import_piramid_constants10.requiredFieldMessage)
});
var requestAppraisalUpdatesRequestBody = import_zod10.z.object({
  message: import_zod10.z.string().min(1, import_piramid_constants10.requiredFieldMessage)
});
var publishAppraisalUpdatesRequestBody = import_zod10.z.object({
  message: import_zod10.z.string().min(1, import_piramid_constants10.requiredFieldMessage),
  files: import_zod10.z.array(
    import_zod10.z.object({
      token: import_zod10.z.string().min(1, import_piramid_constants10.requiredFieldMessage)
    })
  ).max(import_piramid_constants10.MAX_CLAIM_FILES_PER_UPLOAD).default([])
});
var uploadAppraisalInvoiceRequestBody = import_zod10.z.object({
  file_token: import_zod10.z.string().min(1, import_piramid_constants10.requiredFieldMessage)
});

// contracts/contract.ts
var createContractSchema = import_zod11.z.object({
  name: import_zod11.z.string().max(255, "M\xE1ximo 255 caracteres!"),
  start_date: import_zod11.z.coerce.date(),
  end_date: import_zod11.z.coerce.date(),
  cost_type: import_zod11.z.nativeEnum(import_database5.CostType),
  cost_value: import_zod11.z.coerce.string(),
  notes: import_zod11.z.string().optional(),
  contact_id: import_zod11.z.coerce.string(),
  files: import_zod11.z.array(
    import_zod11.z.object({
      token: import_zod11.z.string()
    })
  ).max(import_piramid_constants11.MAX_RFP_FILES).default([])
});
var createContractRequestBody = createContractSchema.refine(
  (v) => v.start_date < v.end_date,
  {
    message: "start_date should be less than end_date",
    path: ["start_date", "end_date"]
  }
);
var requestContractUpdatesRequestBody = import_zod11.z.object({
  message: import_zod11.z.string().min(1, import_piramid_constants11.requiredFieldMessage)
});
var listVendorContractsRequestQuery = paginateRequestQuery;
var publishContractUpdateNoteRequestBody = publishAppraisalUpdatesRequestBody;
var uploadContractRequestBody = import_zod11.z.object({
  file_token: import_zod11.z.string().min(1, import_piramid_constants11.requiredFieldMessage),
  notes: import_zod11.z.string().optional()
});
var uploadContractInvoiceRequestBody = import_zod11.z.object({
  file_token: import_zod11.z.string().min(1, import_piramid_constants11.requiredFieldMessage)
});
var rejectContractReportRequestBody = rejectAppraisalReportRequestBody;

// contracts/order.contract.ts
var import_database6 = __toESM(require_index_browser4());
var import_piramid_constants13 = __toESM(require_dist2());
var import_zod13 = require("zod");

// contracts/query-params.contract.ts
var import_piramid_constants12 = __toESM(require_dist2());
var import_zod12 = require("zod");
var optionalBooleanParam = import_zod12.z.enum(import_piramid_constants12.booleansString).optional().transform((value) => value === void 0 ? void 0 : value === "true");
var optionalCommaListParam = (values) => import_zod12.z.string().optional().transform((value) => {
  const items = value == null ? void 0 : value.split(",").filter(Boolean);
  return (items == null ? void 0 : items.length) ? items : void 0;
}).pipe(import_zod12.z.array(import_zod12.z.enum(values)).optional());

// contracts/order.contract.ts
var uploadOrderDocumentRequestBody = import_zod13.z.object({
  files: import_zod13.z.array(import_zod13.z.object({ token: import_zod13.z.string() })).min(1, import_piramid_constants13.requiredFieldMessage).max(import_piramid_constants13.MAX_RFP_FILES)
});
var listImportableOrderDocumentsRequestQuery = import_zod13.z.object({
  search: import_zod13.z.string().trim().max(191).optional()
});
var IMPORTABLE_DOCUMENT_GROUPS = [
  "claimant",
  "tramitation",
  "all"
];
var importOrderDocumentsRequestBody = import_zod13.z.object({
  imported_file_ids: import_zod13.z.array(import_zod13.z.string().min(1)).min(1, import_piramid_constants13.requiredFieldMessage).max(import_piramid_constants13.MAX_IMPORTED_ORDER_FILES)
});
var uploadOrderRequiredDocumentRequestBody = import_zod13.z.object({
  file_token: import_zod13.z.string().min(1)
});
var orderItemInput = import_zod13.z.object({
  product_id: import_zod13.z.string().min(1).optional(),
  description: import_zod13.z.string().optional(),
  quantity: import_zod13.z.coerce.number({ invalid_type_error: import_piramid_constants13.requiredFieldMessage }).int().positive("La cantidad debe ser mayor que 0").max(import_piramid_constants13.MAX_ORDER_ITEM_QUANTITY, "La cantidad es demasiado alta"),
  unit_price: import_zod13.z.coerce.number().nonnegative("El precio no puede ser negativo").max(import_piramid_constants13.MAX_ORDER_UNIT_PRICE, "El precio no puede superar $ 99.999.999,99").optional()
});
var orderWorkProofMechanism = import_zod13.z.nativeEnum(import_database6.OrderWorkProofMechanism);
var orderTaxPercent = import_zod13.z.coerce.number().refine(import_piramid_constants13.isOrderTaxPercent, "La al\xEDcuota de impuestos no es v\xE1lida").default(import_piramid_constants13.DEFAULT_ORDER_TAX_PERCENT);
var createOrderRequestBody = import_zod13.z.object({
  provider_id: import_zod13.z.coerce.string().min(1, import_piramid_constants13.requiredFieldMessage),
  vertical_id: import_zod13.z.coerce.string().min(1, import_piramid_constants13.requiredFieldMessage),
  service_id: import_zod13.z.coerce.string().min(1, import_piramid_constants13.requiredFieldMessage),
  good_id: import_zod13.z.coerce.string().min(1, import_piramid_constants13.requiredFieldMessage),
  locality_id: import_zod13.z.coerce.string().min(1, import_piramid_constants13.requiredFieldMessage),
  // Título de la orden: lo que el proveedor lee y busca en su listado, así que
  // es obligatorio. En Gamma llega precargado con el vehículo del siniestro.
  // El tope es el de la columna (VARCHAR(191)).
  name: import_zod13.z.string({
    required_error: import_piramid_constants13.requiredFieldMessage,
    invalid_type_error: import_piramid_constants13.requiredFieldMessage
  }).min(1, import_piramid_constants13.requiredFieldMessage).max(191, "El nombre no puede tener m\xE1s de 191 caracteres"),
  // Detalle libre del trabajo, opcional: el título ya identifica la orden.
  description: import_zod13.z.string().max(1500, "La descripci\xF3n no puede tener m\xE1s de 1500 caracteres").optional(),
  notes: import_zod13.z.string().optional(),
  files: import_zod13.z.array(
    import_zod13.z.object({
      token: import_zod13.z.string()
    })
  ).max(import_piramid_constants13.MAX_RFP_FILES).default([]),
  // order_document_import — files that ALREADY exist in the claim/complaint and
  // are linked by reference. Additive and optional: `files` is unchanged.
  imported_file_ids: import_zod13.z.array(import_zod13.z.string().min(1)).max(import_piramid_constants13.MAX_IMPORTED_ORDER_FILES).default([]),
  // F2.5 — ítems + cobertura. Opcionales: una orden sin ítems se comporta como
  // hoy. La moneda vive a nivel Order (se toma de la company en el server).
  items: import_zod13.z.array(orderItemInput).default([]),
  coverage_amount: import_zod13.z.coerce.number().nonnegative().max(import_piramid_constants13.MAX_ORDER_AMOUNT).optional(),
  // F2.5 — taxes. Always sent (default 21). An order WITHOUT items ignores
  // it: no amounts means no taxes.
  taxes_percent: orderTaxPercent,
  // order_work_proof — how this order will prove the work was done. Decided
  // when deriving and never changed afterwards.
  work_proof_mechanism: orderWorkProofMechanism.default("report")
}).superRefine((data, ctx) => {
  const items = data.items ?? [];
  if (items.length === 0) return;
  const hasCatalog = items.some((item) => !!item.product_id);
  const hasManual = items.some((item) => !item.product_id);
  if (hasCatalog && hasManual) {
    ctx.addIssue({
      code: import_zod13.z.ZodIssueCode.custom,
      path: ["items"],
      message: "No se pueden combinar productos del cat\xE1logo con detalle personalizado en una misma orden"
    });
  }
  const seenProductIds = /* @__PURE__ */ new Set();
  items.forEach((item, index) => {
    if (!item.product_id) return;
    if (seenProductIds.has(item.product_id)) {
      ctx.addIssue({
        code: import_zod13.z.ZodIssueCode.custom,
        path: ["items", index, "product_id"],
        message: "Este producto ya fue agregado a la orden"
      });
    }
    seenProductIds.add(item.product_id);
  });
  items.forEach((item, index) => {
    if (item.product_id) return;
    if (!item.description || item.description.trim() === "") {
      ctx.addIssue({
        code: import_zod13.z.ZodIssueCode.custom,
        path: ["items", index, "description"],
        message: "Requerido"
      });
    }
    if (item.unit_price === void 0) {
      ctx.addIssue({
        code: import_zod13.z.ZodIssueCode.custom,
        path: ["items", index, "unit_price"],
        message: "Requerido"
      });
    }
  });
});
var orderDateFields = [
  "created_at",
  "accepted_at",
  "completed_at",
  "rejected_at"
];
var ORDER_PENDING_SIDES = ["provider", "insurer"];
var ORDER_PENDING_SIDE_COLUMN = {
  provider: "workflow_pending_provider",
  insurer: "workflow_pending_insurer"
};
var workflowRequestQuery = {
  stage: import_zod13.z.array(import_zod13.z.nativeEnum(import_database6.OrderWorkflowStage)).default([]),
  pending: import_zod13.z.enum(ORDER_PENDING_SIDES).optional(),
  progress: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional()
};
var listVendorOrdersRequestQuery = paginateRequestQuery.extend({
  company: import_zod13.z.array(import_zod13.z.string()).default([]),
  service: import_zod13.z.array(import_zod13.z.string()).default([]),
  good: import_zod13.z.array(import_zod13.z.string()).default([]),
  status: import_zod13.z.array(import_zod13.z.nativeEnum(import_database6.OrderStatus)).default([]),
  date_from: import_zod13.z.coerce.date().optional(),
  date_to: import_zod13.z.coerce.date().optional(),
  // Columna sobre la que aplica el rango de fechas. El default es la derivación
  // (lo que muestra la tabla); el home la cambia para que "cerradas este mes"
  // signifique lo que dice y no "derivadas este mes que hoy están cerradas".
  date_field: import_zod13.z.enum(orderDateFields).default("created_at"),
  ...workflowRequestQuery
});
var orderListFilterQuery = {
  provider: import_zod13.z.array(import_zod13.z.string()).default([]),
  service: import_zod13.z.array(import_zod13.z.string()).default([]),
  good: import_zod13.z.array(import_zod13.z.string()).default([]),
  status: import_zod13.z.array(import_zod13.z.nativeEnum(import_database6.OrderStatus)).default([]),
  date_from: import_zod13.z.coerce.date().optional(),
  date_to: import_zod13.z.coerce.date().optional(),
  date_field: import_zod13.z.enum(orderDateFields).default("created_at")
};
var listInsurerOrdersRequestQuery = paginateRequestQuery.extend({
  ...orderListFilterQuery,
  // Usuarios de la compañía que derivaron la orden (`Order.created_by_id`).
  derived_by: import_zod13.z.array(import_zod13.z.string()).default([]),
  totalWithTaxes: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  ...workflowRequestQuery
});
var insurerOrdersFilterSchema = listInsurerOrdersRequestQuery.omit({
  page: true,
  limit: true
});
var exportInsurerOrdersRequestBody = import_zod13.z.object({
  filters: insurerOrdersFilterSchema,
  columns: import_zod13.z.array(import_zod13.z.enum(import_piramid_constants13.orderReportColumns)).min(1, "M\xEDnimo 1 columna").refine((cols) => new Set(cols).size === cols.length, {
    message: "Duplicated columns"
  })
});
var listBackofficeOrdersRequestQuery = paginateRequestQuery.extend({
  ...orderListFilterQuery,
  company: import_zod13.z.array(import_zod13.z.string()).default([]),
  acceptedAt: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  completedAt: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  totalAmount: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  totalWithTaxes: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  statusSort: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  companySort: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional(),
  providerSort: import_zod13.z.enum(import_piramid_constants13.sortTypes).optional()
});
var backofficeOrdersFilterSchema = listBackofficeOrdersRequestQuery.omit({
  page: true,
  limit: true
});
var backofficeOrderExportRecipientSchema = import_zod13.z.string().trim().toLowerCase().email().refine(import_piramid_constants13.isRevelacionDataEmail, {
  message: `Only @${import_piramid_constants13.REVELACION_DATA_EMAIL_DOMAIN} recipients are allowed`
});
var exportBackofficeOrdersRequestBody = import_zod13.z.object({
  filters: backofficeOrdersFilterSchema,
  columns: import_zod13.z.array(import_zod13.z.enum(import_piramid_constants13.backofficeOrderReportColumns)).min(1, "M\xEDnimo 1 columna").refine((cols) => new Set(cols).size === cols.length, {
    message: "Duplicated columns"
  }),
  recipient_email: backofficeOrderExportRecipientSchema
});
var orderCandidateScopes = ["available", "nearby"];
var listOrderCandidatesRequestQuery = import_zod13.z.object({
  vertical_id: import_zod13.z.string().min(1, import_piramid_constants13.requiredFieldMessage),
  service_id: import_zod13.z.string().min(1, import_piramid_constants13.requiredFieldMessage),
  good_id: import_zod13.z.string().min(1, import_piramid_constants13.requiredFieldMessage),
  locality_id: import_zod13.z.string().min(1, import_piramid_constants13.requiredFieldMessage),
  scope: import_zod13.z.enum(orderCandidateScopes).optional(),
  // DEPRECATED (F5.2) — ignored
  search: import_zod13.z.string().optional(),
  group_id: import_zod13.z.string().optional(),
  // F2.3 — restringe candidatos a los miembros del grupo
  // Elegibilidad. Ausente = true (retrocompat: matching completo — onboarding
  // terminado + capability declarada). false = el único requisito es tener el
  // Engagement activo; el ranking por proximidad se mantiene idéntico.
  strict: optionalBooleanParam
});
var rejectOrderDocumentRequestBody = rejectAppraisalReportRequestBody;
var rejectOrderRequestBody = import_zod13.z.object({
  // required_error/invalid_type_error keep the message localized when the field
  // is untouched (undefined) — otherwise Zod's default "Required" would show.
  reason: import_zod13.z.string({
    required_error: import_piramid_constants13.requiredFieldMessage,
    invalid_type_error: import_piramid_constants13.requiredFieldMessage
  }).min(1, import_piramid_constants13.requiredFieldMessage)
});
var cancelOrderRequestBody = import_zod13.z.object({
  reason: import_zod13.z.string({
    required_error: import_piramid_constants13.requiredFieldMessage,
    invalid_type_error: import_piramid_constants13.requiredFieldMessage
  }).min(1, import_piramid_constants13.requiredFieldMessage)
});
var publishOrderUpdateNoteRequestBody = publishAppraisalUpdatesRequestBody;
var ORDER_WORK_PROOF_DISPLAY_STATUSES = [
  "pending_capture",
  // The provider opened the magic link and started filling the inspection
  // (`inspection_started` webhook): no longer merely pending.
  "capturing",
  "processing",
  "approved",
  "disapproved",
  "error",
  "blocked"
];
var ORDER_WORK_PROOF_CAPTURABLE_STATUSES = [
  "pending_capture",
  "capturing"
];
var isCapturableWorkProof = (status) => ORDER_WORK_PROOF_CAPTURABLE_STATUSES.some((value) => value === status);
var ORDER_WORK_PROOF_OPEN_STATUSES = [
  ...ORDER_WORK_PROOF_CAPTURABLE_STATUSES,
  "processing"
];
var isOpenWorkProof = (status) => ORDER_WORK_PROOF_OPEN_STATUSES.some((value) => value === status);
var ORDER_WORK_PROOF_COMPLETED_STATUSES = [
  "approved",
  "disapproved",
  "error"
];
var isCompletedWorkProof = (status) => ORDER_WORK_PROOF_COMPLETED_STATUSES.some((value) => value === status);
var ORDER_WORK_PROOF_BLOCKED_REASONS = [
  // The order proves the work with a report: the inspection mechanism does not
  // apply to it at all.
  "not_required",
  // The provider has not accepted yet: the inspection is created on acceptance,
  // so before that there is nothing to create nor anything that failed.
  "order_not_accepted",
  "not_configured",
  "template_not_assigned",
  "inspection_in_progress",
  "inspection_approved",
  "invalid_order_status",
  "claim_not_open"
];
var ORDER_PROGRESS_STAGES = [
  "created",
  "accepted",
  "scheduling",
  "work_proof",
  "documentation",
  "completed"
];
var ORDER_PROGRESS_STAGE_RANK = {
  created: 10,
  accepted: 20,
  scheduling: 30,
  work_proof: 40,
  documentation: 50,
  completed: 60
};
var ORDER_PROGRESS_STAGE_STATUSES = [
  // Una etapa previa todavía no se cumplió, pero la etapa va a habilitarse.
  "blocked",
  "awaiting_provider",
  "awaiting_insurer",
  // Avanza fuera de la plataforma (análisis de la inspección): no hay acción
  // posible de ninguna de las dos partes.
  "in_progress",
  // El último intento fue rechazado y hay que rehacerlo.
  "rejected",
  "done",
  // La orden terminó antes de llegar acá: nunca va a ocurrir.
  "unreachable",
  // La orden se anuló (solo la etapa completed).
  "canceled"
];
var ORDER_PROGRESS_WAITING_ON = [
  "provider",
  "insurer",
  "external"
];
var ORDER_COMPLETION_BLOCKED_REASONS = [
  "work_proof_not_completed",
  "not_scheduled",
  "documentation_incomplete"
];
var setOrderScheduleRequestBody = import_zod13.z.object({
  // `coerce` accepts both the ISO 8601 the client sends and the form's `Date`.
  // NO upper bound: scheduling months ahead is legitimate.
  scheduled_for: import_zod13.z.date({
    required_error: import_piramid_constants13.requiredFieldMessage,
    invalid_type_error: import_piramid_constants13.requiredFieldMessage
  }).or(import_zod13.z.coerce.date()).refine((date) => date >= (0, import_piramid_constants13.orderScheduleFloor)(/* @__PURE__ */ new Date()), {
    message: `La fecha no puede ser anterior a los \xFAltimos ${import_piramid_constants13.ORDER_SCHEDULING_MAX_PAST_DAYS} d\xEDas`
  }),
  // Branch the claimant must go to. Coordinating is saying WHEN and WHERE, so
  // it is required. The server checks it belongs to the order's provider.
  branch_id: import_zod13.z.string({ required_error: import_piramid_constants13.requiredFieldMessage }).min(1, {
    message: import_piramid_constants13.requiredFieldMessage
  }),
  note: import_zod13.z.string().trim().max(import_piramid_constants13.ORDER_SCHEDULING_NOTE_MAX_LENGTH).nullish(),
  // Whether to email the claimant. Today the UI pins it to `true`, but the
  // decision travels as data so turning the checkbox on is a UI-only change.
  notify_insured: import_zod13.z.boolean().default(true)
});
var cancelOrderScheduleRequestBody = import_zod13.z.object({
  reason: import_zod13.z.string({
    required_error: import_piramid_constants13.requiredFieldMessage,
    invalid_type_error: import_piramid_constants13.requiredFieldMessage
  }).trim().min(1, import_piramid_constants13.requiredFieldMessage).max(import_piramid_constants13.ORDER_SCHEDULING_NOTE_MAX_LENGTH)
});
var ORDER_SCHEDULE_BLOCKED_REASONS = [
  // The order was not accepted yet: nobody scheduled anything.
  "order_not_accepted",
  // Rejected, canceled or already completed.
  "invalid_order_status",
  // Closed claim or fraud lock (mirrors ClaimSystemStatusGuard).
  "claim_not_open",
  // The provider has no branch to send the claimant to, and a coordination
  // names a place. Only reachable when a provider deletes every branch after
  // the order was derived — deleting the last one also reverts its onboarding.
  "no_branches",
  // Voiding only: there is no coordination to withdraw.
  "not_scheduled"
];
var ACCEPTED_ORDER_STATUSES = [
  "in_progress",
  "completed"
];
var isOrderAccepted = ({ status }) => ACCEPTED_ORDER_STATUSES.some((value) => value === status);
var ORDER_SCHEDULE_STATUSES = [
  "active",
  "superseded",
  "canceled"
];

// contracts/contact.contract.ts
var import_database7 = __toESM(require_index_browser4());
var import_zod14 = require("zod");
var import_piramid_constants14 = __toESM(require_dist2());
var createContactRequestBody = import_zod14.z.object({
  name: import_zod14.z.string().max(255, "Nombre demasiado largo. M\xE1ximo 255 caracteres"),
  external_id: import_zod14.z.string().nullish(),
  type: import_zod14.z.nativeEnum(import_database7.ContactTypes, {
    invalid_type_error: import_piramid_constants14.requiredFieldMessage,
    required_error: import_piramid_constants14.requiredFieldMessage
  }),
  email: import_zod14.z.string().email("Email inv\xE1lido"),
  address: import_zod14.z.string().optional(),
  city: import_zod14.z.string().optional(),
  cellphone: import_zod14.z.string().optional(),
  country: import_zod14.z.string().optional().refine((value) => !!value ? countryRefine(value) : true),
  state: import_zod14.z.string().optional(),
  zip_code: import_zod14.z.string().optional(),
  user_id: import_zod14.z.string().optional()
}).refine((arg) => {
  if (!arg.country || !arg.state) return true;
  return stateRefine(arg, (data) => data.country);
});
var updateContactRequestBody = createContactRequestBody;
var listContactsRequestQuery = paginateRequestQuery.extend({
  type: import_zod14.z.nativeEnum(import_database7.ContactTypes).optional()
});
var contactRegistrationStatuses = [
  "invited",
  "pending_verification",
  "registered"
];

// contracts/engagement.contract.ts
var import_database8 = __toESM(require_index_browser4());
var import_zod15 = require("zod");
var inviteProviderRequestBody = import_zod15.z.object({
  email: import_zod15.z.string().email("El email no es v\xE1lido"),
  invitation_name: import_zod15.z.string().max(255).optional()
});
var listEngagementsRequestQuery = paginateRequestQuery.extend({
  status: import_zod15.z.nativeEnum(import_database8.EngagementStatus).optional()
});
var listInvitationsRequestQuery = paginateRequestQuery;
var backofficeListInvitationsRequestQuery = paginateRequestQuery.extend({
  status: import_zod15.z.nativeEnum(import_database8.ProviderInvitationStatus).optional()
});
var updateEngagementStatusRequestBody = import_zod15.z.object({
  status: import_zod15.z.enum(["active", "paused", "suspended"])
});
var updateEngagementRequestBody = import_zod15.z.object({
  external_id: import_zod15.z.string().max(255, "El c\xF3digo es demasiado largo").nullable()
});

// contracts/provider-registration.contract.ts
var import_database9 = __toESM(require_index_browser4());
var import_piramid_constants15 = __toESM(require_dist2());
var import_zod16 = require("zod");
var providerRegistrationRequestBody = import_zod16.z.object({
  token: import_zod16.z.string().optional(),
  email: import_zod16.z.string({ required_error: import_piramid_constants15.requiredFieldMessage }).email("Email inv\xE1lido"),
  password: providerPasswordSchema,
  first_name: import_zod16.z.string({ required_error: import_piramid_constants15.requiredFieldMessage }).min(1, import_piramid_constants15.requiredFieldMessage),
  last_name: import_zod16.z.string({ required_error: import_piramid_constants15.requiredFieldMessage }).min(1, import_piramid_constants15.requiredFieldMessage),
  legal_name: import_zod16.z.string({ required_error: import_piramid_constants15.requiredFieldMessage }).min(1, import_piramid_constants15.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  ein: import_zod16.z.string({ required_error: import_piramid_constants15.requiredFieldMessage }).min(1, import_piramid_constants15.requiredFieldMessage).regex(/^\d{11}$/, "El CUIT debe contener exactamente 11 d\xEDgitos"),
  phone: import_zod16.z.string().optional()
});
var respondEngagementRequestBody = import_zod16.z.object({
  action: import_zod16.z.enum(["accept", "reject"])
});
var listProviderEngagementsRequestQuery = paginateRequestQuery.extend({
  // Optional status filter (e.g. only pending invitations for the home alert).
  status: import_zod16.z.nativeEnum(import_database9.EngagementStatus).optional()
});

// contracts/provider.contract.ts
var import_database10 = __toESM(require_index_browser4());
var import_zod17 = require("zod");
var updateProviderProfileRequestBody = import_zod17.z.object({
  phone: import_zod17.z.string().optional(),
  address: import_zod17.z.string().optional(),
  locality_id: import_zod17.z.string().optional(),
  contact_email: import_zod17.z.union([import_zod17.z.literal(""), import_zod17.z.string().email("Email inv\xE1lido")]).optional(),
  description: import_zod17.z.string().max(2e3, "M\xE1ximo 2000 caracteres").optional()
});
var updateCapabilitiesRequestBody = import_zod17.z.object({
  capabilities: import_zod17.z.array(
    import_zod17.z.object({
      vertical_id: import_zod17.z.string(),
      service_id: import_zod17.z.string(),
      good_ids: import_zod17.z.array(import_zod17.z.string()).optional()
      // empty/undefined = all goods
    })
  )
});
var coverageItem = import_zod17.z.object({
  level: import_zod17.z.nativeEnum(import_database10.GeoLevel),
  geo_id: import_zod17.z.string()
});
var updateCoverageRequestBody = import_zod17.z.object({
  coverage: import_zod17.z.array(coverageItem)
});

// contracts/provider-document.contract.ts
var import_piramid_constants16 = __toESM(require_dist2());
var import_zod18 = require("zod");
var uploadProviderDocumentRequestBody = import_zod18.z.object({
  document_type_id: import_zod18.z.string({ required_error: import_piramid_constants16.requiredFieldMessage }),
  file_token: import_zod18.z.string({ required_error: import_piramid_constants16.requiredFieldMessage })
});
var upsertProviderDocumentTypeRequestBody = import_zod18.z.object({
  name: import_zod18.z.string({ required_error: import_piramid_constants16.requiredFieldMessage }).min(1, import_piramid_constants16.requiredFieldMessage),
  description: import_zod18.z.string().optional(),
  is_required: import_zod18.z.boolean().default(false),
  is_active: import_zod18.z.boolean().default(true)
});
var listProviderDocumentTypesBackofficeRequestQuery = paginateRequestQuery;

// contracts/review.contract.ts
var import_zod19 = require("zod");
var REVIEW_COMMENT_MAX_LENGTH = 800;
var REVIEW_LOW_SCORE_COMMENT_THRESHOLD = 3;
var REVIEW_MIN_SCORE = 1;
var REVIEW_MAX_SCORE = 5;
var reviewScoreSchema = import_zod19.z.coerce.number().int().min(REVIEW_MIN_SCORE).max(REVIEW_MAX_SCORE);
var reviewScoreOptions = Array.from(
  { length: REVIEW_MAX_SCORE - REVIEW_MIN_SCORE + 1 },
  (_, index) => REVIEW_MIN_SCORE + index
);
var reviewCommentSchema = import_zod19.z.string().trim().max(REVIEW_COMMENT_MAX_LENGTH).optional();
var isReviewCommentRequired = (score) => score <= REVIEW_LOW_SCORE_COMMENT_THRESHOLD;
var hasCommentWhenRequired = (data) => !isReviewCommentRequired(data.score) || Boolean(data.comment);
var REVIEW_COMMENT_REQUIRED_ISSUE = {
  path: ["comment"],
  message: "A comment is required for low scores"
};
var createClaimFormReviewRequestBody = import_zod19.z.object({
  claim_id: import_zod19.z.string().optional(),
  score: reviewScoreSchema,
  comment: reviewCommentSchema
}).refine(hasCommentWhenRequired, REVIEW_COMMENT_REQUIRED_ISSUE);
var retrieveReviewRequestParams = import_zod19.z.object({
  reviewId: import_zod19.z.string()
});
var reviewTokenRequestQuery = import_zod19.z.object({
  token: import_zod19.z.string().min(1)
});
var submitReviewRequestBody = import_zod19.z.object({
  score: reviewScoreSchema,
  comment: reviewCommentSchema
}).refine(hasCommentWhenRequired, REVIEW_COMMENT_REQUIRED_ISSUE);

// contracts/load-balance-rule.contracts.ts
var import_database11 = __toESM(require_index_browser4());
var import_piramid_constants17 = __toESM(require_dist2());
var import_zod20 = require("zod");
var conditionCommon = import_zod20.z.object({
  type: import_zod20.z.nativeEnum(import_database11.ConditionTypes),
  operator: import_zod20.z.nativeEnum(import_database11.ConditionOperator)
});
var conditionUnion = import_zod20.z.discriminatedUnion("path", [
  conditionCommon.extend({
    path: import_zod20.z.literal("claim_type"),
    value: import_zod20.z.enum(import_piramid_constants17.claimTypes)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal(
      "desired_support_location_state"
    ),
    value: import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal(
      "desired_support_location_state_municipality"
    ),
    value: import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal("occurrence.city"),
    value: import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal("ramo"),
    value: import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal("user_type"),
    value: import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal(
      "is_claimant_and_victim_same_insurer"
    ),
    value: import_zod20.z.enum(["true", "false"])
  }),
  conditionCommon.extend({
    path: import_zod20.z.literal("sinister_object"),
    value: import_zod20.z.enum(import_piramid_constants17.sinisterObjectValues)
  })
]);
var createLoadBalanceRuleRequestBody = import_zod20.z.object({
  conditions: import_zod20.z.array(conditionUnion).min(1, "M\xEDnimo una condici\xF3n"),
  type: import_zod20.z.nativeEnum(import_database11.LoadBalanceRuleType),
  priority: import_zod20.z.number().int().min(1, "La prioridad debe ser mayor a 0").default(1),
  team_id: import_zod20.z.string({
    required_error: import_piramid_constants17.requiredFieldMessage,
    invalid_type_error: import_piramid_constants17.requiredFieldMessage
  }).min(1, import_piramid_constants17.requiredFieldMessage)
});
var reorderLoadBalanceRulesRequestBody = import_zod20.z.object({
  // Full ordered list of the company's rule ids. The backend rewrites
  // `priority` to each id's position (1..N), so the array must contain every
  // rule exactly once.
  ordered_ids: import_zod20.z.array(import_zod20.z.string().min(1, import_piramid_constants17.requiredFieldMessage)).min(1, import_piramid_constants17.requiredFieldMessage)
});
var fetchLoadBalanceRuleRequestParams = import_zod20.z.object({
  id: import_zod20.z.coerce.string()
});
var updateLoadBalanceRuleRequestBody = createLoadBalanceRuleRequestBody;

// contracts/authentication.contracts.ts
var import_piramid_constants18 = __toESM(require_dist2());
var import_zod21 = require("zod");
var import_database12 = __toESM(require_index_browser4());
var import_libphonenumber_js = require("libphonenumber-js");
init_esm();
var updateUserInfoRequestBody = import_zod21.z.object({
  first_name: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage),
  last_name: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage),
  identification: dni.optional(),
  sex: import_zod21.z.enum(import_piramid_constants18.sexTypes).optional(),
  address_street: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).optional(),
  address_number: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).optional(),
  address_apartment: import_zod21.z.string().optional(),
  marital_status: import_zod21.z.nativeEnum(import_database12.MaritalStatus, {
    invalid_type_error: import_piramid_constants18.requiredFieldMessage,
    required_error: import_piramid_constants18.requiredFieldMessage
  }).optional(),
  zip_code: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).regex(/^\d{4}$/, {
    message: "Debe tener 4 d\xEDgitos"
  }).optional(),
  cellphone: import_zod21.z.coerce.string().min(1, import_piramid_constants18.requiredFieldMessage).refine(import_libphonenumber_js.isValidPhoneNumber, {
    message: "Celular inv\xE1lido"
  }),
  nationality: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).optional(),
  country: import_zod21.z.string().refine((val) => import_piramid_constants18.countryAndStates.some((c2) => c2.code === val)).optional(),
  birth_date: import_zod21.z.coerce.date({
    errorMap: (issue, ctx) => {
      if (issue.code === "invalid_date" || issue.code === "invalid_type") {
        return { message: "Fecha inv\xE1lida" };
      }
      return { message: import_piramid_constants18.requiredFieldMessage };
    }
  }).refine(
    (val) => {
      return differenceInYears(/* @__PURE__ */ new Date(), new Date(val)) >= import_piramid_constants18.LEGAL_PERSON_AGE_THRESHOLD;
    },
    {
      message: `Debes tener al menos ${import_piramid_constants18.LEGAL_PERSON_AGE_THRESHOLD} a\xF1os`
    }
  ),
  state: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).optional(),
  city: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage).optional(),
  ein: cuitCuilSchema.optional()
  // use ein to save cuit
}).refine(
  (arg) => {
    if (!arg.country) return true;
    const countryHasStates = import_piramid_constants18.countryAndStates.find(
      (country) => country.code === arg.country
    );
    if (countryHasStates == null ? void 0 : countryHasStates.states.length)
      return stateRefine(arg, (data) => data.country ?? "");
    return true;
  },
  {
    path: ["state"],
    message: import_piramid_constants18.requiredFieldMessage
  }
);
var loginUserRequestBody = import_zod21.z.object({
  email: import_zod21.z.string().email(),
  password: import_zod21.z.string().min(1)
});
var loginBackofficeRequestBody = import_zod21.z.object({
  username: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage),
  password: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage)
});
var signInRequestBody = import_zod21.z.object({
  identity: import_zod21.z.object({
    provider: import_zod21.z.enum(import_piramid_constants18.identityProviders),
    access_token: import_zod21.z.string().min(1)
  })
});
var signUpRequestBody = signInRequestBody;
var registerUserRequestBody = import_zod21.z.object({
  type: import_zod21.z.enum(import_piramid_constants18.userTypes).optional(),
  email: import_zod21.z.string().email().max(255).min(1, import_piramid_constants18.requiredFieldMessage),
  password: import_zod21.z.string().max(255).min(1, import_piramid_constants18.requiredFieldMessage)
});
var registerUserExtendedRequestBody = registerUserRequestBody.extend({
  first_name: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage),
  last_name: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage)
});
var azureCallbackQuerySchema = import_zod21.z.object({
  code: import_zod21.z.string().min(1, import_piramid_constants18.requiredFieldMessage)
});
var signinAsQuerySchema = import_zod21.z.object({
  token: import_zod21.z.string()
});

// contracts/inhouse-lawyer.contract.ts
var import_zod22 = require("zod");
var createInHouseLawyerRequestBody = import_zod22.z.object({
  email: import_zod22.z.string().email(),
  name: import_zod22.z.string().max(255, "Nombre demasiado largo")
});
var updateInHouseLawyerRequestBody = createInHouseLawyerRequestBody;
var retrieveInHouseLawyerRequestParams = import_zod22.z.object({
  inHouseLawyerId: import_zod22.z.coerce.string()
});
var retrieveInHouseLawyerRequestQuery = import_zod22.z.object({});
var listInHouseLawyersRequestQuery = paginateRequestQuery;
var registerInHouseLawyerAccountRequestBody = registerUserExtendedRequestBody.pick({
  password: true,
  first_name: true,
  last_name: true
});

// contracts/product.contract.ts
var import_zod23 = require("zod");
var import_piramid_constants19 = __toESM(require_dist2());
var createProductRequestBody = import_zod23.z.object({
  sku: import_zod23.z.string({ required_error: "El SKU es obligatorio" }).min(1, "El SKU es obligatorio").max(255, "El SKU es demasiado largo"),
  name: import_zod23.z.string({ required_error: "El nombre es obligatorio" }).min(1, "El nombre es obligatorio").max(255, "El nombre es demasiado largo"),
  brand: import_zod23.z.string().max(255, "La marca es demasiado larga").optional(),
  description: import_zod23.z.string().max(2e3, "La descripci\xF3n es demasiado larga").optional(),
  unit_price: import_zod23.z.number({
    required_error: "El precio es obligatorio",
    invalid_type_error: "El precio debe ser un n\xFAmero"
  }).nonnegative("El precio no puede ser negativo").max(9999999999e-2, "El precio no puede superar $ 99.999.999,99"),
  // default true al crear; editable en edit (discontinuar)
  is_active: import_zod23.z.boolean().optional()
});
var updateProductRequestBody = createProductRequestBody;
var retrieveProductRequestParams = import_zod23.z.object({
  productId: import_zod23.z.coerce.string()
});
var listProductsRequestQuery = paginateRequestQuery.extend({
  unitPrice: import_zod23.z.enum(import_piramid_constants19.sortTypes).optional()
});

// contracts/customer.contract.ts
var import_zod24 = require("zod");
var createCustomerRequestBody = import_zod24.z.object({
  name: import_zod24.z.string({ required_error: "El nombre es obligatorio" }).min(1, "El nombre es obligatorio").max(255, "El nombre es demasiado largo"),
  code: import_zod24.z.string().max(255, "El c\xF3digo es demasiado largo").optional(),
  description: import_zod24.z.string().max(2e3, "La descripci\xF3n es demasiado larga").optional()
});
var updateCustomerRequestBody = createCustomerRequestBody;
var retrieveCustomerRequestParams = import_zod24.z.object({
  customerId: import_zod24.z.coerce.string()
});
var listCustomersRequestQuery = paginateRequestQuery;

// contracts/customer-organization.contract.ts
var import_libphonenumber_js2 = require("libphonenumber-js");
var import_zod27 = require("zod");

// contracts/company.contract.ts
var import_database14 = __toESM(require_index_browser4());
var import_zod26 = require("zod");
var import_piramid_constants21 = __toESM(require_dist2());

// contracts/webhook.contract.ts
var import_database13 = __toESM(require_index_browser4());
var import_zod25 = require("zod");
var import_zod_openapi2 = require("@anatine/zod-openapi");
var import_piramid_constants20 = __toESM(require_dist2());

// utils/getExampleFromSchema.ts
var MAX_LEVELS_DEEP = 5;
function guessFromFormat(schema, fallback = "") {
  const exampleValues = {
    // 'date-time': '1970-01-01T00:00:00Z',
    "date-time": (/* @__PURE__ */ new Date()).toISOString(),
    // 'date': '1970-01-01',
    "date": (/* @__PURE__ */ new Date()).toISOString().split("T")[0],
    "email": "hello@example.com",
    "hostname": "example.com",
    // https://tools.ietf.org/html/rfc6531#section-3.3
    "idn-email": "jane.doe@example.com",
    // https://tools.ietf.org/html/rfc5890#section-2.3.2.3
    "idn-hostname": "example.com",
    "ipv4": "127.0.0.1",
    "ipv6": "51d4:7fab:bfbf:b7d7:b2cb:d4b4:3dad:d998",
    "iri-reference": "/entitiy/1",
    // https://tools.ietf.org/html/rfc3987
    "iri": "https://example.com/entity/123",
    "json-pointer": "/nested/objects",
    "password": "super-secret",
    "regex": "/[a-z]/",
    // https://tools.ietf.org/html/draft-handrews-relative-json-pointer-01
    "relative-json-pointer": "1/nested/objects",
    // full-time in https://tools.ietf.org/html/rfc3339#section-5.6
    // 'time': '00:00:00Z',
    "time": (/* @__PURE__ */ new Date()).toISOString().split("T")[1].split(".")[0],
    // either a URI or relative-reference https://tools.ietf.org/html/rfc3986#section-4.1
    "uri-reference": "../folder",
    "uri-template": "https://example.com/{id}",
    "uri": "https://example.com",
    "uuid": "123e4567-e89b-12d3-a456-426614174000"
  };
  return exampleValues[schema.format] ?? fallback;
}
var getExampleFromSchema = (schema, options, level = 0, parentSchema, name) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  if (level === MAX_LEVELS_DEEP + 1) {
    try {
      JSON.stringify(schema);
    } catch {
      return "[Circular Reference]";
    }
  }
  const makeUpRandomData = !!(options == null ? void 0 : options.emptyString);
  if ((options == null ? void 0 : options.mode) === "write" && schema.readOnly) {
    return void 0;
  }
  if ((options == null ? void 0 : options.mode) === "read" && schema.writeOnly) {
    return void 0;
  }
  if (schema["x-variable"]) {
    const value = (_a = options == null ? void 0 : options.variables) == null ? void 0 : _a[schema["x-variable"]];
    if (value !== void 0) {
      if (schema.type === "number" || schema.type === "integer") {
        return parseInt(value, 10);
      }
      return value;
    }
  }
  if (Array.isArray(schema.examples) && schema.examples.length > 0) {
    return schema.examples[0];
  }
  if (schema.example !== void 0) {
    return schema.example;
  }
  if (schema.default !== void 0) {
    return schema.default;
  }
  if (schema.enum !== void 0) {
    return schema.enum[0];
  }
  const isObjectOrArray = schema.type === "object" || schema.type === "array" || !!((_c = (_b = schema.allOf) == null ? void 0 : _b.at) == null ? void 0 : _c.call(_b, 0)) || !!((_e = (_d = schema.anyOf) == null ? void 0 : _d.at) == null ? void 0 : _e.call(_d, 0)) || !!((_g = (_f = schema.oneOf) == null ? void 0 : _f.at) == null ? void 0 : _g.call(_f, 0));
  if (!isObjectOrArray && (options == null ? void 0 : options.omitEmptyAndOptionalProperties) === true) {
    const isRequired = schema.required === true || (parentSchema == null ? void 0 : parentSchema.required) === true || ((_h = parentSchema == null ? void 0 : parentSchema.required) == null ? void 0 : _h.includes(name ?? schema.name));
    if (!isRequired) {
      return void 0;
    }
  }
  if (schema.type === "object" || schema.properties !== void 0) {
    const response = {};
    if (schema.properties !== void 0) {
      Object.keys(schema.properties).forEach((propertyName) => {
        var _a2;
        const property = schema.properties[propertyName];
        const propertyXmlTagName = (options == null ? void 0 : options.xml) ? (_a2 = property.xml) == null ? void 0 : _a2.name : void 0;
        response[propertyXmlTagName ?? propertyName] = getExampleFromSchema(
          property,
          options,
          level + 1,
          schema,
          propertyName
        );
        if (typeof response[propertyXmlTagName ?? propertyName] === "undefined") {
          delete response[propertyXmlTagName ?? propertyName];
        }
      });
    }
    if (schema.additionalProperties !== void 0) {
      const anyTypeIsValid = (
        // true
        schema.additionalProperties === true || // or an empty object {}
        typeof schema.additionalProperties === "object" && !Object.keys(schema.additionalProperties).length
      );
      if (anyTypeIsValid) {
        response["ANY_ADDITIONAL_PROPERTY"] = "anything";
      } else if (schema.additionalProperties !== false) {
        response["ANY_ADDITIONAL_PROPERTY"] = getExampleFromSchema(
          schema.additionalProperties,
          options,
          level + 1
        );
      }
    }
    if (schema.anyOf !== void 0) {
      Object.assign(
        response,
        getExampleFromSchema(schema.anyOf[0], options, level + 1)
      );
    } else if (schema.oneOf !== void 0) {
      Object.assign(
        response,
        getExampleFromSchema(schema.oneOf[0], options, level + 1)
      );
    } else if (schema.allOf !== void 0) {
      Object.assign(
        response,
        ...schema.allOf.map(
          (item) => getExampleFromSchema(item, options, level + 1, schema)
        ).filter((item) => item !== void 0)
      );
    }
    return response;
  }
  if (schema.type === "array" || schema.items !== void 0) {
    const itemsXmlTagName = (_j = (_i = schema == null ? void 0 : schema.items) == null ? void 0 : _i.xml) == null ? void 0 : _j.name;
    const wrapItems = !!((options == null ? void 0 : options.xml) && ((_k = schema.xml) == null ? void 0 : _k.wrapped) && itemsXmlTagName);
    if (schema.example !== void 0) {
      return wrapItems ? { [itemsXmlTagName]: schema.example } : schema.example;
    }
    if (schema.items) {
      const rules = ["anyOf", "oneOf", "allOf"];
      for (const rule of rules) {
        if (!schema.items[rule]) {
          continue;
        }
        const schemas = ["anyOf", "oneOf"].includes(rule) ? (
          // Use the first item only
          schema.items[rule].slice(0, 1)
        ) : (
          // Use all items
          schema.items[rule]
        );
        const exampleFromRule = schemas.map(
          (item) => getExampleFromSchema(item, options, level + 1, schema)
        ).filter((item) => item !== void 0);
        return wrapItems ? [{ [itemsXmlTagName]: exampleFromRule }] : exampleFromRule;
      }
    }
    if ((_l = schema.items) == null ? void 0 : _l.type) {
      const exampleFromSchema = getExampleFromSchema(
        schema.items,
        options,
        level + 1
      );
      return wrapItems ? [{ [itemsXmlTagName]: exampleFromSchema }] : [exampleFromSchema];
    }
    return [];
  }
  const exampleValues = {
    string: makeUpRandomData ? guessFromFormat(schema, options == null ? void 0 : options.emptyString) : "",
    boolean: true,
    integer: schema.min ?? 1,
    number: schema.min ?? 1,
    array: []
  };
  if (schema.type !== void 0 && exampleValues[schema.type] !== void 0) {
    return exampleValues[schema.type];
  }
  const discriminateSchema = schema.oneOf || schema.anyOf;
  if (Array.isArray(discriminateSchema) && discriminateSchema.length > 0) {
    const firstOneOfItem = discriminateSchema[0];
    return getExampleFromSchema(firstOneOfItem, options, level + 1);
  }
  if (Array.isArray(schema.allOf)) {
    let example = null;
    schema.allOf.forEach((allOfItem) => {
      const newExample = getExampleFromSchema(allOfItem, options, level + 1);
      example = typeof newExample === "object" && typeof example === "object" ? {
        ...example ?? {},
        ...newExample
      } : Array.isArray(newExample) && Array.isArray(example) ? [...example ?? {}, ...newExample] : newExample;
    });
    return example;
  }
  if (Array.isArray(schema.type)) {
    if (schema.type.includes("null")) {
      return null;
    }
    const exampleValue = exampleValues[schema.type[0]];
    if (exampleValue !== void 0) {
      return exampleValue;
    }
  }
  console.warn(`[getExampleFromSchema] Unknown property type "${schema.type}".`);
  return null;
};

// utils/patched-generate-schema.ts
var import_zod_openapi = require("@anatine/zod-openapi");
var patchedGenerateSchema = (schema) => JSON.parse(
  JSON.stringify((0, import_zod_openapi.generateSchema)(schema)).replaceAll(`["object"]`, `"object"`).replaceAll(`["object", "null"]`, `"object"`)
);

// contracts/webhook.contract.ts
var listWebhooksRequestQuery = paginateRequestQuery;
var listWebhookLogsRequestQuery = paginateRequestQuery;
var userObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID del usuario"), {
    example: "user_01j9cr34s7fzrats3ehn9sj0ve"
  }),
  first_name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre").nullish(), {
    example: "John"
  }),
  last_name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Apellido").nullish(), {
    example: "Doe"
  }),
  email: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Email"), {
    example: "johndoe@gmail.com"
  }),
  type: (0, import_zod_openapi2.extendApi)(import_zod25.z.nativeEnum(import_database13.UserType).describe("Tipo de usuario"), {
    example: "insurer"
  })
});
var baseWebhookEventPayloadSchema = import_zod25.z.object({
  timestamp: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.coerce.date().describe("Fecha en que ocurri\xF3 el evento"),
    {
      example: "2024-10-11T01:08:49.320Z"
    }
  ),
  triggered_by: userObject.nullish().describe("El usuario que ha disparado el evento")
});
var naturalPersonObject = import_zod25.z.object({
  first_name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre"), {
    example: "John"
  }),
  last_name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Apellido"), {
    example: "Doe"
  }),
  birth_date: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.coerce.date().describe("Fecha de nacimiento. Formato ISO 8601"),
    {
      example: "2000-11-07T04:34:02.774Z"
    }
  ),
  nationality: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nacionalidad"), {
    example: "Argentino"
  }),
  address: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe(
      "Domicilio. Concatenacion de `address_street`, `address_number` y `address_apartment`"
    ),
    {
      example: "Av. del Cid, 100"
    }
  ),
  address_street: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Calle del domicilio"), {
    example: "Av. del Cid"
  }),
  address_number: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Altura del domicilio"), {
    example: "100"
  }),
  address_apartment: import_zod25.z.string().nullish().describe("Apartamento"),
  city: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Ciudad"), {
    example: "Buenos Aires"
  }),
  zip_code: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("C\xF3digo postal"), {
    example: "4000"
  }),
  email: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Correo electr\xF3nico").nullish(), {
    example: "johndoe@gmail.com"
  }),
  cellphone: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Tel\xE9fono celular").nullish(), {
    example: "+543813615120"
  }),
  sex: import_zod25.z.nativeEnum(import_database13.SexTypes).describe("Sexo"),
  identification_type: import_zod25.z.nativeEnum(import_database13.IdentificationTypes).describe("Tipo de identificaci\xF3n"),
  identification_value: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe("Valor de la identificaci\xF3n"),
    {
      example: "44188219"
    }
  )
}).describe("Persona fisica");
var claimObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID del reclamo"), {
    example: "claim_01j9cqqagceb9tdbhmqh8p38n5"
  }),
  ref_id: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.coerce.string().nullish().describe("ID de referencia del reclamo"),
    {
      example: "REV-1"
    }
  ),
  team_id: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.coerce.string().nullish().describe("ID del equipo del reclamo"),
    {
      example: "team_01jc2bqxh1ebnv1j6vb4g3w06q"
    }
  ),
  owner: userObject.describe("Usuario propietario del reclamo"),
  victim: import_zod25.z.object({
    type: import_zod25.z.literal("natural_person").describe("Tipo de persona"),
    natural_person: naturalPersonObject
  }).describe("Damnificado del reclamo"),
  occurrence: import_zod25.z.object({
    witnesses_info: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.string().nullish().describe("Informaci\xF3n de los testigos"),
      {
        example: "Juan Perez, Juan Domingo, Maria Teresa"
      }
    ),
    police_intervention: import_zod25.z.boolean().nullish().describe("Indica si hubo intervenci\xF3n policial"),
    police_station: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().nullish().describe("Comisaria"), {
      example: "Comisaria 1"
    }),
    criminal_case_number: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.string().nullish().describe("N\xFAmero de caso"),
      {
        example: "123456"
      }
    ),
    damage_description: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.string().describe("Descripci\xF3n de los da\xF1os").nullish(),
      {
        example: "Siendo aproximadamente las 19:00hs, ingresaron a mi propiedad, forzando la puerta no pudiendo abrir ingresaron por la ventana para robar"
      }
    ),
    sinister_date: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.coerce.date().describe("Fecha del siniestro"),
      {
        example: "2024-11-07T04:34:02.774Z"
      }
    ),
    state: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Estado"), {
      example: "B"
    }),
    country: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.string().describe("Pa\xEDs. Formato ISO 3166-1 alpha-2"),
      {
        example: "AR"
      }
    ),
    city: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Ciudad"), {
      example: "Tandil"
    })
  }).describe("Datos del incidente"),
  claimants: import_zod25.z.array(
    import_zod25.z.object({
      victim_relationship: import_zod25.z.nativeEnum(import_database13.VictimRelationshipTypes).describe("V\xEDnculo con el damnificado"),
      victim_relationship_other: import_zod25.z.string().describe(
        "Otro v\xEDnculo con el damnificado. Definido cuando `victim_relationship` es igual a `other`"
      ).nullish(),
      type: import_zod25.z.literal("natural_person").describe("Tipo de persona"),
      natural_person: naturalPersonObject
    }).describe("Reclamante")
  ).describe("Lista de reclamantes"),
  damages: import_zod25.z.array(
    import_zod25.z.discriminatedUnion("type", [
      import_zod25.z.object({
        type: import_zod25.z.literal("material").describe("Tipo de da\xF1o"),
        material: import_zod25.z.discriminatedUnion("type", [
          import_zod25.z.object({
            type: import_zod25.z.literal("vehicle"),
            vehicle: import_zod25.z.object({
              type: (0, import_zod_openapi2.extendApi)(import_zod25.z.nativeEnum(import_database13.VehicleTypes), {
                example: "car"
              }),
              identification_key: import_zod25.z.nativeEnum(import_database13.VehicleIdentificationKeys).describe("Atributo identificador del veh\xEDculo"),
              registration_state: import_zod25.z.string().nullish().describe("Estado/Provincia del registro"),
              registration_city: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.string().describe("Ciudad de registro").nullish(),
                {
                  example: "Villa Elisa"
                }
              ),
              year: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.coerce.string().describe("A\xF1o de fabricaci\xF3n"),
                {
                  example: 2020
                }
              ),
              make: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Marca"), {
                example: "FORD"
              }),
              model: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Modelo"), {
                example: "KA"
              }),
              version: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.string().nullish().describe("Versi\xF3n"),
                {
                  example: "1.5 SEL AUT                L/18"
                }
              ),
              chassis: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.string().nullish().describe("Chasis"),
                {
                  example: "KMHJN81VP5U195422"
                }
              ),
              engine: import_zod25.z.string().describe("Motor"),
              category: import_zod25.z.nativeEnum(import_database13.VehicleCategoryTypes).describe("Categor\xEDa"),
              market_value: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.coerce.number().nullish().describe("Valor venal"),
                {
                  example: 1743e4
                }
              ),
              license_plate: (0, import_zod_openapi2.extendApi)(
                import_zod25.z.string().nullish().describe("Patente"),
                {
                  example: "ASZ706"
                }
              )
            })
          }).describe("Da\xF1os a vehiculos"),
          import_zod25.z.object({
            type: import_zod25.z.literal("real_property"),
            real_property: import_zod25.z.object({
              address_street: import_zod25.z.string().describe("Calle"),
              address_number: import_zod25.z.string().describe("N\xFAmero"),
              address_apartment: import_zod25.z.string().describe("Apartamento"),
              state: import_zod25.z.string().describe("Estado"),
              city: import_zod25.z.string().describe("Ciudad"),
              zip_code: import_zod25.z.string().describe("C\xF3digo postal"),
              ownership: import_zod25.z.nativeEnum(import_database13.RealPropertyOwnershipTypes).describe("Propiedad"),
              type: import_zod25.z.nativeEnum(import_database13.RealPropertyTypes).describe("Tipo de propiedad")
            })
          }).describe("Da\xF1os a la propiedad")
        ])
      }).describe("Da\xF1os materiales"),
      import_zod25.z.object({
        type: import_zod25.z.literal("person").describe("Tipo de da\xF1o"),
        person: import_zod25.z.object({
          type: import_zod25.z.nativeEnum(import_database13.PersonDamageTypes).describe("Tipo de da\xF1o a persona"),
          surgery_description: import_zod25.z.string().nullish().describe("Descripci\xF3n de la cirug\xEDa"),
          health_insurance_fund: import_zod25.z.string().nullish().describe("obra social"),
          treatment_worker_compensation_insurer: import_zod25.z.string().nullish().describe("ART"),
          treatment_medical_institution: import_zod25.z.string().nullish().describe("Instituci\xF3n M\xE9dica"),
          victim_role: import_zod25.z.nativeEnum(import_database13.VictimRoleTypes).nullish().describe("Condici\xF3n de"),
          policyholder_relationship: import_zod25.z.nativeEnum(import_database13.PolicyHolderRelationshipTypes).describe("V\xEDnculo con el asegurado").nullish(),
          policyholder_relationship_other: import_zod25.z.string().nullish().describe(
            "Otro v\xEDnculo con el asegurado. Requerido cuando `policyholder_relationship` es igual a `other`"
          )
        })
      }).describe("Da\xF1os a personas")
    ])
  ),
  status: import_zod25.z.object({
    id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID del estado"), {
      example: "status_01j9cqtnzbeyna3f7yw50fn9c0"
    }),
    name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre del estado"), {
      example: "Pendiente de aprobaci\xF3n"
    }),
    metadata: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.record(
        import_zod25.z.string().max(40, "M\xE1ximo 40 caracteres"),
        import_zod25.z.string().max(500, "M\xE1ximo 500 caracteres")
      ).describe("Metadatos del estado").nullish(),
      {
        example: {
          my_custom_id: "123456789"
        }
      }
    )
  }).describe("Estado del reclamo"),
  system_status: import_zod25.z.nativeEnum(import_database13.ClaimSystemStatus).describe("Estado del sistema del reclamo"),
  material_judicial_amount: import_zod25.z.coerce.number().nullish().describe(
    "Monto de la demanda judicial con respecto a los da\xF1os materiales"
  ),
  person_judicial_amount: import_zod25.z.number().nullish().describe(
    "Monto de la demanda judicial con respecto a los da\xF1os a personas"
  ),
  person_percentage_of_judicial_risk: import_zod25.z.number().min(1).max(100).nullish().describe(
    "Porcentaje de riesgo judicial con respecto a los da\xF1os a personas"
  ),
  percentage_of_liability: import_zod25.z.number().nullish().describe("Porcentaje de responsabilidad"),
  administrative_amount: import_zod25.z.number().nullish().describe("Monto de la demanda administrativa"),
  material_administrative_amount: import_zod25.z.number().nullish().describe(
    "Monto de la demanda administrativa con respecto a los da\xF1os materiales"
  ),
  person_administrative_amount: import_zod25.z.number().nullish().describe(
    "Monto de la demanda administrativa con respecto a los da\xF1os a personas"
  ),
  estimates_updated_at: import_zod25.z.coerce.date().nullish().describe("Fecha de la ultima actualizaci\xF3n de estimaciones"),
  estimates_updated_source: import_zod25.z.nativeEnum(import_database13.EstimatesUpdatedSource).nullish().describe("Origen de las actualizaciones de estimaciones"),
  latest_estimates_update_reason: import_zod25.z.string().nullish().describe("Raz\xF3n de la \xFAltima actualizaci\xF3n de estimaciones")
}).describe("Reclamo");
var claimCreatedEventPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.created"),
  data: claimObject
});
var claimUpdatedEventPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.updated"),
  data: claimObject
});
var fileObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID del archivo"), {
    example: "file_01j9cs36r9fw2b8b8ygda67nty"
  }),
  original_name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre original del archivo"), {
    example: "document.pdf"
  }),
  url: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("URL del archivo"), {
    example: "https://piramid.s3.amazonaws.com/document.pdf"
  }),
  size: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.number().describe("Tama\xF1o del archivo en bytes"), {
    example: 1024
  }),
  type: (0, import_zod_openapi2.extendApi)(import_zod25.z.nativeEnum(import_database13.FileTypes).describe("Tipo de archivo"), {
    example: "pdf"
  }),
  uploaded_by: userObject.describe("Datos del usuario que subi\xF3 el archivo").nullish()
});
var claimFileUploadedEventPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.file.uploaded"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    file: fileObject
  })
});
var claimHandlerObject = import_zod25.z.object({
  type: import_zod25.z.nativeEnum(import_database13.ClaimHandlerTypes).describe("Tipo de tramitador"),
  user: userObject
});
var claimHandlerAssignedDataSchema = claimObject.pick({
  id: true,
  ref_id: true,
  team_id: true
}).extend({
  handler: claimHandlerObject.describe("Tramitador asignado del reclamo")
});
var claimHandlerAssignedPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.handler.assigned"),
  data: claimHandlerAssignedDataSchema
});
var claimHandlerUnassignedPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.handler.unassigned"),
  data: claimObject.pick({ id: true }).extend({
    handler: claimHandlerObject.describe(
      "Tramitador desasignado del reclamo"
    )
  })
});
var claimStatusUpdatedPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.status.updated"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    source: claimObject.shape.status.extend({
      system_status: import_zod25.z.nativeEnum(import_database13.ClaimSystemStatus).describe("Estado del sistema")
    }).nullish().describe("Estado anterior"),
    target: claimObject.shape.status.extend({
      system_status: import_zod25.z.nativeEnum(import_database13.ClaimSystemStatus).describe("Estado del sistema")
    }).describe("Estado actual")
  })
});
var contactObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de contacto"), {
    example: "contact_01j9cs4a47fgg9575xk6g8bq2d"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre del contacto"), {
    example: "Proveedor Norte"
  }),
  type: import_zod25.z.nativeEnum(import_database13.ContactTypes).describe("Tipo de contacto"),
  email: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Email del contacto"), {
    example: "proveedor@norte.com"
  }),
  cellphone: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().nullish().describe("Tel\xE9fono celular"), {
    example: "+543813615120"
  }),
  external_id: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().nullish().describe("ID externo"), {
    example: "12345"
  })
});
var claimOrderObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de la orden"), {
    example: "order_01j9cs5r9eerkvyfyvvhjsg6ye"
  }),
  // F1.4.1 — legacy order fields (type/sub_type/dates/vendor_contact) are now
  // nullable on the model; new orders don't set them. The order webhook
  // payload is redesigned around provider + catalog/geo snapshot in a later cut.
  type: import_zod25.z.nativeEnum(import_database13.OrderType).nullish().describe("Tipo de orden"),
  sub_type: import_zod25.z.nativeEnum(import_database13.OrderSubType).nullish().describe("Subtipo de orden"),
  start_date: import_zod25.z.coerce.date().nullish().describe("Fecha de inicio"),
  end_date: import_zod25.z.coerce.date().nullish().describe("Fecha de finalizacion"),
  notes: import_zod25.z.string().nullish().describe("Notas sobre el orden"),
  status: import_zod25.z.nativeEnum(import_database13.OrderStatus).describe("Estado del orden"),
  created_by: userObject,
  vendor_contact: contactObject.nullish().describe("Contacto del proveedor"),
  vendor_user: userObject.nullish().describe(
    "Proveedor usuario. Definido unicamente si el proveedor se registro en l plataforma de proveedores"
  )
}).describe("Orden del reclamo");
var updateNoteObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "updatenote_01j9cs6fewfyv8adeffm123338"
  }),
  message: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe("Mensaje de la nota de actualizaci\xF3n"),
    {
      example: "Hubo un avance en la negociaci\xF3n"
    }
  ),
  published_by: userObject.describe(
    "Usuario que public\xF3 la nota de actualizaci\xF3n"
  ),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la nota de actualizaci\xF3n"),
  files: import_zod25.z.array(fileObject).describe("Archivos asociados a la nota de actualizaci\xF3n")
}).describe("Nota de actualizaci\xF3n");
var claimOrderCreatedPayloadSchema = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject
  })
});
var claimOrderInvoiceCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.invoice.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true
    }).extend({
      invoice: import_zod25.z.object({
        id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
          example: "orderinvoice_01j9cs78q8ezmb0byx00ddwmpj"
        }),
        // F1.4.4 — invoice = solo el archivo (campos de negocio eliminados).
        created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la factura"),
        file: fileObject.describe("Archivo de la factura")
      }).describe("Factura de la orden")
    })
  })
});
var claimOrderUpdatesRequested = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.updates.requested"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true
    }).extend({
      message: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().nullish(), {
        example: "Necesitamos novedades"
      }),
      requested_by: userObject.describe(
        "Tramitador que solicit\xF3 novedades"
      )
    })
  })
});
var claimOrderUpdatesPublished = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.updates.published"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true,
      vendor_contact: true,
      vendor_user: true
    }).extend({
      update_note: updateNoteObject
    })
  })
});
var claimOrderReportObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "orderreport_01j9cs7rp6f10vca79sr02r8sx"
  }),
  status: import_zod25.z.nativeEnum(import_database13.OrderReportStatus).describe("Estado del reporte"),
  file: fileObject.describe("Archivo del reporte")
}).describe("Orden del reclamo");
var claimOrderReportCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.report.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true
    }).extend({
      report: claimOrderReportObject.omit({
        status: true
      }).extend({
        status: (0, import_zod_openapi2.extendApi)(claimOrderReportObject.shape.status, {
          example: "pending"
        })
      })
    })
  })
});
var claimOrderReportAccepted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.report.accepted"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true
    }).extend({
      report: claimOrderReportObject.omit({
        status: true
      }).extend({
        accepted_at: import_zod25.z.coerce.date().describe(
          "Fecha de aceptaci\xF3n del informe de la orden de trabajo"
        ),
        accepted_by: userObject.describe(
          "Tramitador que acept\xF3 el reporte"
        ),
        status: (0, import_zod_openapi2.extendApi)(claimOrderReportObject.shape.status, {
          example: "accepted"
        })
      })
    })
  })
});
var claimOrderReportRejected = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.order.report.rejected"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    order: claimOrderObject.pick({
      id: true
    }).extend({
      report: claimOrderReportObject.omit({
        status: true
      }).extend({
        status: (0, import_zod_openapi2.extendApi)(claimOrderReportObject.shape.status, {
          example: "rejected"
        }),
        rejected_by: userObject.describe(
          "Tramitador que rechaz\xF3 el reporte"
        ),
        rejected_reason: (0, import_zod_openapi2.extendApi)(
          import_zod25.z.string().nullish().describe("Raz\xF3n del rechazo"),
          {
            example: "Los servicios brindados por el proveedor no cumplen con los requisitos de la orden"
          }
        ),
        rejected_at: import_zod25.z.coerce.date().describe(
          "Fecha de rechazo del informe de la orden de trabajo"
        )
      })
    })
  })
});
var claimOfferObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "offer_01j9cs9cbwepxv02ykz6k491kp"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre del ofrecimiento"), {
    example: "Propuesta Indemnizatoria"
  }),
  offer_template_message: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe("Plantilla de mensaje del ofrecimiento"),
    {
      example: "El ofrecimiento para {{gtisUxbvz8NIDzakrr19N}} es de {{j1PZ2zCGyp2aaVE9l37fV}}. La forma de pago ser\xE1 de {{vyC0NUpiZzkjOOi7ubIKW}} cuotas"
    }
  ),
  offered_by: userObject.describe("Tramitador que realiz\xF3 el ofrecimiento"),
  expires_at: import_zod25.z.coerce.date().nullish().describe("Fecha de vencimiento del ofrecimiento"),
  rejected_reason: import_zod25.z.string().nullish().describe("Raz\xF3n del rechazo. Definido cuando la oferta es rechazada"),
  third_party_user_requested_amount: import_zod25.z.number().nullish().describe(
    "Monto pretendido por el tercero. Definido cuando la oferta es rechazada."
  ),
  status: import_zod25.z.nativeEnum(import_database13.OfferStatus).describe("Estado del ofrecimiento"),
  variable_values: import_zod25.z.array(
    import_zod25.z.object({
      id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
        example: "varvalue_01j9csd5rvekgty865ze01y7jn"
      }),
      name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre de la variable"), {
        example: "Cuotas"
      }),
      value: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Valor de la variable"), {
        example: "12"
      }),
      created_at: import_zod25.z.coerce.date().describe("Fecha de la definici\xF3n"),
      guid: (0, import_zod_openapi2.extendApi)(
        import_zod25.z.string().describe(
          "Identificador \xFAnico de la variable. Se usa para referenciar una variable en una plantilla de mensaje"
        ),
        {
          example: "vyC0NUpiZzkjOOi7ubIKW"
        }
      )
    }).describe("Definici\xF3n de una variable")
  ).describe("Definiciones de variables del ofrecimiento")
}).describe("Ofrecimiento");
var claimOfferCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.status, {
        example: "pending"
      })
    })
  })
});
var claimOfferAccepted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.accepted"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      accepted_at: import_zod25.z.coerce.date().describe("Fecha de aceptaci\xF3n del ofrecimiento"),
      status: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.status, {
        example: "accepted"
      }),
      accepted_by: userObject.describe(
        "El usuario tercero que acept\xF3 el ofrecimiento"
      )
    })
  })
});
var claimOfferRejected = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.rejected"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.status, {
        example: "rejected"
      }),
      rejected_at: import_zod25.z.coerce.date().describe("Fecha de rechazo del ofrecimiento"),
      rejected_reason: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.rejected_reason, {
        example: "El monto se encuentra por debajo del minimo."
      }),
      third_party_user_requested_amount: (0, import_zod_openapi2.extendApi)(
        claimOfferObject.shape.third_party_user_requested_amount,
        { example: 2e4 }
      ),
      rejected_by: userObject.describe(
        "El usuario tercero que rechaz\xF3 el ofrecimiento"
      )
    })
  })
});
var claimOfferCanceled = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.canceled"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.status, {
        example: "canceled"
      }),
      canceled_at: import_zod25.z.coerce.date().describe("Fecha de anulaci\xF3n del ofrecimiento"),
      canceled_reason: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.rejected_reason, {
        example: "El monto se encuentra por debajo del minimo."
      }),
      canceled_by: userObject.describe(
        "El tramitador que anul\xF3 el ofrecimiento"
      )
    })
  })
});
var claimOfferExpired = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.expired"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(claimOfferObject.shape.status, {
        example: "expired"
      }),
      expires_at: claimOfferObject.shape.expires_at,
      expired_at: import_zod25.z.coerce.date().describe("Fecha en la que expir\xF3 el ofrecimiento")
    })
  })
});
var claimOfferAgreementObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("ID de la conformidad"), {
    example: "offeragreement_01j9csa5n1fkvbwtf6ncwxkwvq"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre de la conformidad"), {
    example: "Conformidad del ofrecimiento A"
  }),
  provider_type: import_zod25.z.nativeEnum(import_database13.IntegrationTemplateProviderType).describe("Tipo de proveedor"),
  provider_id: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe("ID de la conformidad en el proveedor"),
    {
      example: "clwlljtpq001a4rwlw99x9qgg"
    }
  ),
  status: import_zod25.z.nativeEnum(import_database13.OfferAgreementStatus).describe("Estado de la conformidad"),
  created_by: userObject.describe("Tramitador que cre\xF3 la conformidad"),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la conformidad")
}).describe("Conformidad del ofrecimiento");
var claimOfferAgreementCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.agreement.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      agreement: claimOfferAgreementObject.omit({
        status: true
      }).extend({
        status: (0, import_zod_openapi2.extendApi)(claimOfferAgreementObject.shape.status, {
          example: "started"
        })
      })
    })
  })
});
var claimOfferAgreementCompleted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.agreement.completed"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      agreement: claimOfferAgreementObject.omit({
        status: true
      }).extend({
        status: (0, import_zod_openapi2.extendApi)(claimOfferAgreementObject.shape.status, {
          example: "completed"
        }),
        completed_at: import_zod25.z.coerce.date().describe("Fecha de finalizaci\xF3n de la conformidad")
      })
    })
  })
});
var claimOfferAgreementRejected = baseWebhookEventPayloadSchema.extend(
  {
    type: import_zod25.z.literal("claim.offer.agreement.rejected"),
    data: claimObject.pick({
      id: true,
      ref_id: true,
      team_id: true
    }).extend({
      offer: claimOfferObject.pick({
        id: true
      }).extend({
        agreement: claimOfferAgreementObject.omit({
          status: true
        }).extend({
          status: (0, import_zod_openapi2.extendApi)(claimOfferAgreementObject.shape.status, {
            example: "rejected"
          }),
          rejected_at: import_zod25.z.coerce.date().describe("Fecha de rechazo de la conformidad"),
          // Nulo cuando se rechaza sin comentario: `z.coerce.string()`
          // mandaba el literal "null" en vez del hueco.
          rejected_reason: (0, import_zod_openapi2.extendApi)(
            import_zod25.z.string().nullish().describe("Motivo del rechazo de la conformidad"),
            {
              example: "La conformidad tiene un monto erroneo"
            }
          )
        })
      })
    })
  }
);
var claimOfferAgreementExpired = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.offer.agreement.expired"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    offer: claimOfferObject.pick({
      id: true
    }).extend({
      agreement: claimOfferAgreementObject.omit({
        status: true
      }).extend({
        status: (0, import_zod_openapi2.extendApi)(claimOfferAgreementObject.shape.status, {
          example: "expired"
        }),
        expired_at: import_zod25.z.coerce.date().describe("Fecha de vencimiento de la conformidad")
      })
    })
  })
});
var claimOfferAgreementCanceled = baseWebhookEventPayloadSchema.extend(
  {
    type: import_zod25.z.literal("claim.offer.agreement.canceled"),
    data: claimObject.pick({
      id: true,
      ref_id: true,
      team_id: true
    }).extend({
      offer: claimOfferObject.pick({
        id: true
      }).extend({
        agreement: claimOfferAgreementObject.omit({
          status: true
        }).extend({
          status: (0, import_zod_openapi2.extendApi)(claimOfferAgreementObject.shape.status, {
            example: "canceled"
          }),
          canceled_at: import_zod25.z.coerce.date().describe("Fecha de cancelaci\xF3n de la conformidad"),
          // Nulo cuando la anulación no llevó motivo público y no se
          // cargó uno en AutoSign: nunca es el motivo interno.
          canceled_reason: (0, import_zod_openapi2.extendApi)(
            import_zod25.z.string().nullish().describe("Motivo de cancelaci\xF3n de la conformidad"),
            {
              example: "El destinatario de la conformidad no es el correcto"
            }
          )
        })
      })
    })
  }
);
var rfpVendorObject = import_zod25.z.object({
  contact: contactObject,
  user: userObject.nullish().describe(
    "Usuario proveedor. Definido si el provedor se registro en la plataforma"
  )
}).describe("Proveedor de la licitaci\xF3n");
var claimRfpObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "rfp_01j9csds2vepe9fchywsey86qf"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre de la licitaci\xF3n"), {
    example: "Licitacion arreglo de abolladura"
  }),
  country: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Pa\xEDs. Formato ISO 3166-1 alpha-2"), {
    example: "AR"
  }),
  state: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe("Provincia/Estado. Formato ISO 3166-1 alpha-2"),
    {
      example: "B"
    }
  ),
  city: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Ciudad"), {
    example: "La Plata"
  }),
  description: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Descripci\xF3n de la licitaci\xF3n"), {
    example: "Arreglo de abolladura"
  }),
  mode: import_zod25.z.nativeEnum(import_database13.RequestForProposalMode).describe("Modo de la licitaci\xF3n"),
  status: import_zod25.z.nativeEnum(import_database13.RequestForProposalStatus).describe("Estado de la licitaci\xF3n"),
  deadline: import_zod25.z.coerce.date().describe("Fecha de vencimiento de la licitaci\xF3n"),
  files: import_zod25.z.array(fileObject).describe("Lista de archivos asociados a la licitaci\xF3n"),
  created_by: userObject.describe("Tramitador creador de la licitaci\xF3n"),
  vendors: import_zod25.z.array(rfpVendorObject).describe("Lista de proveedores seleccionados para la licitaci\xF3n"),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la licitaci\xF3n")
});
var claimRfpCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.rfp.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    rfp: claimRfpObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(claimRfpObject.shape.status, {
        example: "open"
      })
    })
  })
});
var claimRfpClosed = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.rfp.closed"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    rfp: claimRfpObject.omit({
      status: true
    }).pick({
      id: true,
      deadline: true
    }).extend({
      closed_at: import_zod25.z.coerce.date().describe("Fecha de cierre de la licitaci\xF3n"),
      status: (0, import_zod_openapi2.extendApi)(claimRfpObject.shape.status, {
        example: "closed"
      })
    })
  })
});
var claimRfpCanceled = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.rfp.canceled"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    rfp: claimRfpObject.pick({
      id: true
    }).extend({
      canceled_at: import_zod25.z.coerce.date().describe("Fecha de cancelaci\xF3n de la licitaci\xF3n"),
      canceled_by: userObject.describe(
        "Tramitador que cancel\xF3 la licitaci\xF3n"
      ),
      status: (0, import_zod_openapi2.extendApi)(claimRfpObject.shape.status, {
        example: "canceled"
      })
    })
  })
});
var claimRfpBidObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "rfpbid_01j9cseq49f6arhread1w1hvn6"
  }),
  lines: import_zod25.z.array(
    import_zod25.z.object({
      id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
        example: "bidline_01j9csfbt8fym9kdxsmqsak8s3"
      }),
      type: import_zod25.z.nativeEnum(import_database13.BidLineType).describe("Tipo"),
      quantity: import_zod25.z.coerce.number(),
      unit_of_measurement: import_zod25.z.nativeEnum(import_database13.BidLineUnitOfMeasurement).describe("Unidad de medida"),
      unit_price: import_zod25.z.coerce.number(),
      total_price: import_zod25.z.coerce.number()
    }).describe("Linea de presupuesto")
  ).describe("Detalles del presupuesto de la oferta"),
  expiration: import_zod25.z.coerce.date().describe("Fecha de vencimiento"),
  files: import_zod25.z.array(fileObject).describe("Lista de archivos asociados a la oferta"),
  submitted_by: rfpVendorObject.describe(
    "Proveedor de la licitacion que envi\xF3 la oferta"
  ),
  created_at: import_zod25.z.coerce.date().describe("Fecha creaci\xF3n de la oferta"),
  total_amount: import_zod25.z.coerce.number()
});
var claimRfpBidSubmitted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.rfp.bid.submitted"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    rfp: claimRfpObject.pick({
      id: true
    }).extend({
      bid: claimRfpBidObject
    })
  })
});
var claimRfpBidSelected = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.rfp.bid.selected"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    rfp: claimRfpObject.pick({
      id: true
    }).extend({
      bid: claimRfpBidObject.extend({
        winner: (0, import_zod_openapi2.extendApi)(
          import_zod25.z.boolean().describe(
            "Indica si esta oferta es la ganadora de la licitaci\xF3n"
          ),
          {
            example: true
          }
        ),
        won_at: import_zod25.z.coerce.date().describe("Fecha en que se seleccion\xF3 esta oferta como ganadora")
      })
    })
  })
});
var claimEstimatesUpdated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.estimates.updated"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    material_judicial_amount: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.material_judicial_amount,
      { example: 1e3 }
    ),
    person_judicial_amount: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.person_judicial_amount,
      { example: 2e3 }
    ),
    person_percentage_of_judicial_risk: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.person_percentage_of_judicial_risk,
      { example: 10 }
    ),
    percentage_of_liability: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.percentage_of_liability,
      { example: 15 }
    ),
    material_administrative_amount: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.material_administrative_amount,
      { example: 4e3 }
    ),
    person_administrative_amount: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.person_administrative_amount,
      { example: 5e3 }
    ),
    estimates_updated_at: claimObject.shape.estimates_updated_at,
    estimates_updated_source: claimObject.shape.estimates_updated_source,
    latest_estimates_update_reason: (0, import_zod_openapi2.extendApi)(
      claimObject.shape.latest_estimates_update_reason,
      { example: "Recibimos informe del perito" }
    )
  })
});
var fieldAdjusterAssigned = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.field_adjuster.assigned"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    field_adjuster: userObject.omit({
      type: true
    }).extend({
      type: (0, import_zod_openapi2.extendApi)(userObject.shape.type, {
        example: "field_adjuster"
      })
    }).nullish().describe("Usuario perito"),
    field_adjuster_contact: contactObject.describe("Contacto del perito")
  })
});
var appraisalInvoiceUploaded = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.invoice.uploaded"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    appraisal_invoice: fileObject.describe(
      "Archivo de la factura de evaluaci\xF3n"
    ),
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact
  })
});
var appraisalReportObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "appraisalreport_01j9csg3e2eyxs1zy7sp524fpf"
  }),
  risk: import_zod25.z.coerce.number().nullish(),
  total_disability: import_zod25.z.coerce.number().nullish(),
  appraised_total_value: import_zod25.z.number().nullish().describe("Valor total de la evaluaci\xF3n"),
  status: import_zod25.z.nativeEnum(import_database13.AppraisalReporStatus).describe("Estado del informe de evaluaci\xF3n"),
  version: import_zod25.z.coerce.number(),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n"),
  report: fileObject.describe("Archivo del informe de evaluaci\xF3n")
}).describe("Informe de evaluaci\xF3n");
var appraisalReportCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.report.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    appraisal_report: appraisalReportObject.extend({
      status: (0, import_zod_openapi2.extendApi)(appraisalReportObject.shape.status, {
        example: "pending"
      })
    }),
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact
  })
});
var appraisalReportAccepted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.report.accepted"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    appraisal_report: appraisalReportObject.extend({
      status: (0, import_zod_openapi2.extendApi)(appraisalReportObject.shape.status, {
        example: "accepted"
      }),
      accepted_by: userObject.describe(
        "Tramitador que acept\xF3 el informe de evaluaci\xF3n"
      )
    }),
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact
  })
});
var appraisalReportRejected = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.report.rejected"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    appraisal_report: appraisalReportObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(appraisalReportObject.shape.status, {
        example: "rejected"
      }),
      rejected_by: userObject.describe(
        "Tramitador que rechaz\xF3 el informe de evaluaci\xF3n"
      )
    }),
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact
  })
});
var appraisalUpdatesRequested = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.updates.requested"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact,
    requested_by: userObject.describe("Tramitador que solicit\xF3 novedades")
  })
});
var appraisalUpdatesPublished = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.appraisal.updates.published"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    field_adjuster: fieldAdjusterAssigned.shape.data.shape.field_adjuster,
    field_adjuster_contact: fieldAdjusterAssigned.shape.data.shape.field_adjuster_contact,
    update_note: updateNoteObject
  })
});
var fraudInvestigationObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "fraudcase_01j9csgxwgffabdkydwjmfbajv"
  }),
  provider_type: import_zod25.z.literal("kach").default("kach").describe(
    "Plataforma externa para la tramitaci\xF3n de la investigaci\xF3n de fraude"
  ),
  case_type: import_zod25.z.nativeEnum(import_database13.FraudInvestigationCaseType).describe("Tipo de investigation de fraude"),
  reason: import_zod25.z.string().describe("Raz\xF3n de la investigaci\xF3n de fraude"),
  sinister_number: import_zod25.z.string().describe("Numero de siniestro/incidente"),
  external_case_id: import_zod25.z.string().describe("ID externo de la investigaci\xF3n de fraude"),
  status: import_zod25.z.enum(["not_assigned", "in_progress", "closed"]).describe("Estado de la investigaci\xF3n de fraude"),
  sinister_type: import_zod25.z.string().describe("Nombre del tipo de siniestro/incidente"),
  description: import_zod25.z.string().describe("Descripci\xF3n de la investigaci\xF3n de fraude"),
  handler_first_name: import_zod25.z.string().describe(
    "Nombre del tramitador encargado de tramitar la investigaci\xF3n de fraude"
  ),
  handler_last_name: import_zod25.z.string().describe(
    "Apellido del tramitador encargado de tramitar la investigaci\xF3n de fraude"
  ),
  handler_email: import_zod25.z.string().describe(
    "Email del tramitador encargado de tramitar la investigaci\xF3n de fraude"
  ),
  instance: import_zod25.z.string().describe("Nombre de la instancia de la investigaci\xF3n de fraude"),
  ramo: import_zod25.z.string().describe("Nombre del ramo de la investigaci\xF3n de fraude"),
  agency: import_zod25.z.string().describe("Nombre de la agencia de la investigaci\xF3n de fraude"),
  result: import_zod25.z.string().describe("Nombre del resultado de la investigaci\xF3n de fraude"),
  created_by: userObject.describe(
    "Tramitador que cre\xF3 la investigaci\xF3n de fraude"
  ),
  closed_at: import_zod25.z.coerce.date().describe("Fecha de cierre de la investigaci\xF3n de fraude"),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la investigaci\xF3n de fraude"),
  updated_at: import_zod25.z.coerce.date().describe("Fecha de la ultima actualizaci\xF3n de la investigaci\xF3n de fraude")
});
var newsRequestObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
    example: "newsrequest_01j9cskshfee2s50kpq6a2rtnm"
  }),
  annotation: import_zod25.z.string().describe("Anotaci\xF3n de la solicitud de novedades"),
  external_id: import_zod25.z.string().describe("ID externo de la solicitud de novedades"),
  requested_by: userObject.describe("Tramitador que solicit\xF3 la novedad"),
  files: import_zod25.z.array(fileObject).describe("Archivos asociados a la solicitud de novedades")
}).describe("Solicitud de novedades de novedades");
var fraudInvestigationNewsRequestCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("fraud_investigation.news_request.created"),
  data: fraudInvestigationObject.pick({
    id: true
  }).extend({
    news_request: newsRequestObject
  })
});
var fraudInvestigationNewsRequestAnswered = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("fraud_investigation.news_request.answered"),
  data: fraudInvestigationObject.pick({
    id: true
  }).extend({
    news_request: newsRequestObject.pick({
      id: true
    }).extend({
      answer: import_zod25.z.object({
        id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
          example: "newsanswer_01j9csmenber9vmnp3xcs74bnk"
        }),
        description: import_zod25.z.string().describe("Descripcion"),
        publisher_first_name: import_zod25.z.string().describe("Nombre del usuario que public\xF3 las novedades"),
        publisher_last_name: import_zod25.z.string().describe("Apellido del usuario que public\xF3 las novedades"),
        publisher_email: import_zod25.z.string().describe("Email del usuario que public\xF3 las novedades"),
        external_id: import_zod25.z.string().describe("ID externo de la novedad"),
        created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la novedad"),
        files: import_zod25.z.array(fileObject).describe("Archivos asociados a la novedad")
      })
    })
  })
});
var tagObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de etiqueta"), {
    example: "tag_01j9cs0ba7fs8sawwagm8t9881"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre del tag"), {
    example: "Cedula de identidad"
  }),
  description: import_zod25.z.string().nullish().describe("Descripci\xF3n del tag")
}).describe("Etiqueta");
var fileRequestObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de solicitud de archivos"), {
    example: "filereq_01j9crwrxpefrt4fazfb3dm8yc"
  }),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la solicitud de archivos"),
  placeholders: import_zod25.z.array(
    import_zod25.z.object({
      id: (0, import_zod_openapi2.extendApi)(
        import_zod25.z.coerce.string().describe("ID de un archivo solicitado"),
        {
          example: "filereqplace_01j9crxmf7fhwrsd4yhw4sees6"
        }
      ),
      tag: tagObject,
      max_files: import_zod25.z.number().describe("Cantidad m\xE1xima permitida para subir"),
      context: import_zod25.z.string().nullish().describe("Descripci\xF3n del archivo solicitado"),
      types: import_zod25.z.array(import_zod25.z.nativeEnum(import_database13.FileTypes)).describe("Tipos de archivos permitidos"),
      confirmed_at: import_zod25.z.coerce.date().nullish().describe("Fecha en que la solicitud de archivo fue respondida")
    })
  ).describe("Lista de archivos solicitados")
}).describe("Solicitud de archivos");
var claimMessageCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.message.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    message: import_zod25.z.object({
      id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID del mensaje"), {
        example: "message_01j9crysymeqsttqjdy7pacq26"
      }),
      message: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Contenido del mensaje"), {
        example: "Hola! Novedades sobre mi reclamo?"
      }),
      author_type: import_zod25.z.nativeEnum(import_database13.MessageAuthorType).describe("Tipo de autor del mensaje"),
      sender: userObject.describe(
        "Usuario que envi\xF3 el mensaje.  Para distinguir entre un tramitador y un usuario com\xFAn, puedes acceder a la propiedad `type`"
      ),
      type: import_zod25.z.nativeEnum(import_database13.ConversationMessageTypes).describe("Tipo de mensaje"),
      file_request: fileRequestObject.nullish().describe(
        "Solicitud de archivo. Definido cuando `type` es igual a `file_request`"
      ),
      created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n del mensaje")
    })
  })
});
var claimFileRequestCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.file_request.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    file_request: fileRequestObject
  })
});
var ownershipTransferObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.coerce.string().describe("ID de la transferencia de propiedad"),
    {
      example: "ownershtransfer_01j9crms8tfs9brnfqm5c989rj"
    }
  ),
  status: import_zod25.z.nativeEnum(import_database13.OwnershipTransferStatus).describe("Estado de la transferencia de propiedad"),
  source_user: userObject.describe("Usuario propietario actual del reclamo"),
  destination_user: userObject.describe(
    "Usuario que recibi\xF3 la transferencia de propiedad"
  ),
  transferred_by: userObject.describe(
    "Usuario que realiz\xF3 la transferencia de propiedad"
  ),
  created_at: import_zod25.z.coerce.date().describe("Fecha de creaci\xF3n de la transferencia de propiedad")
}).describe("Transferencia de propiedad del reclamo");
var claimOwnershipTransferCreated = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.ownership_transfer.created"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    ownership_transfer: ownershipTransferObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(ownershipTransferObject.shape.status, {
        example: "pending"
      })
    })
  })
});
var claimOwnershipTransferAccepted = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.ownership_transfer.accepted"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    ownership_transfer: ownershipTransferObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(ownershipTransferObject.shape.status, {
        example: "accepted"
      }),
      accepted_at: import_zod25.z.coerce.date().describe("Fecha de aceptaci\xF3n de la transferencia de propiedad")
    })
  })
});
var claimOwnershipTransferRejected = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.ownership_transfer.rejected"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    ownership_transfer: ownershipTransferObject.omit({
      status: true
    }).extend({
      status: (0, import_zod_openapi2.extendApi)(ownershipTransferObject.shape.status, {
        example: "rejected"
      }),
      rejected_at: import_zod25.z.coerce.date().describe("Fecha de rechazo de la transferencia de propiedad")
    })
  })
});
var companySLAObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de SLA"), {
    example: "sla_01j9crhq3zfwt9sjzbct4rq77p"
  }),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre de la SLA"), {
    example: "SLA para tramitadores"
  }),
  effective_from: import_zod25.z.coerce.date().describe("Fecha de inicio de la SLA"),
  active: import_zod25.z.boolean().describe("Indica si la SLA est\xE1 activa o no"),
  version: import_zod25.z.coerce.number(),
  group: import_zod25.z.object({
    id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de grupo de SLA"), {
      example: "groupsla_01j9crjq0efse8tzqcp5kdd43d"
    }),
    scope: import_zod25.z.nativeEnum(import_database13.ScopeSLA).describe("Alcance de SLA"),
    type: import_zod25.z.nativeEnum(import_database13.TypeSLA).describe("Tipo de SLA")
  }).describe("Grupo de SLA"),
  latest: import_zod25.z.boolean().describe("Indica si es la \xFAltima versi\xF3n dentro de su grupo"),
  total_duration_type: import_zod25.z.nativeEnum(import_database13.DurationType).nullish().describe("Tipo de duraci\xF3n para el objetivo global del SLA"),
  total_duration_value: import_zod25.z.number().nullish().describe("Valor de la duraci\xF3n para el objetivo global del SLA"),
  elapsed_duration_criteria: import_zod25.z.nativeEnum(import_database13.ElapsedDurationCriteria).describe("Criterio de duraci\xF3n")
}).describe("Definici\xF3n de Service Level Agreement");
var slaObjectiveObject = import_zod25.z.object({
  reference_type: import_zod25.z.nativeEnum(import_database13.TypeSLA).describe(
    "Indica sobre qu\xE9 tipo propiedad se aplica la definici\xF3n del objetivo"
  ),
  reference_value: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().describe(
      "Referencia a un identificador de una instancia de la propiedad"
    ),
    {
      example: "2"
    }
  ),
  duration_type: import_zod25.z.nativeEnum(import_database13.DurationType).describe("Tipo de duraci\xF3n"),
  duration_value: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.number().nullish().describe("Valor de la duraci\xF3n"),
    {
      example: 10
    }
  )
}).describe("Definici\xF3n de un objetivo de SLA");
var alertObject = import_zod25.z.object({
  id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string().describe("ID de la alerta"), {
    example: "alert_01j9crd1jzeygvk79xnr88wv2h"
  }),
  type: import_zod25.z.nativeEnum(import_database13.Alerts).describe("Tipo de alerta"),
  name: (0, import_zod_openapi2.extendApi)(import_zod25.z.string().describe("Nombre de la alerta"), {
    example: "Alerta general de progreso de SLA"
  }),
  description: (0, import_zod_openapi2.extendApi)(
    import_zod25.z.string().nullish().describe("Descripci\xF3n de la alerta"),
    {
      example: "Disparar alerta cuando llega al 80% del progreso"
    }
  ),
  subscription: import_zod25.z.object({
    id: (0, import_zod_openapi2.extendApi)(
      import_zod25.z.coerce.string().describe("ID de la suscripci\xF3n a una alerta"),
      {
        example: "alertsub_01j9cre6n7fn9rp68az0hssjz2"
      }
    ),
    interval_hours: import_zod25.z.number().describe(
      "Intervalo de horas en los que se desea evaluar y disparar la alerta"
    ),
    active: import_zod25.z.boolean().describe("Indica si la suscripci\xF3n est\xE1 activa o no"),
    progress_trigger: import_zod25.z.number().describe("Umbral de progreso para activar la alerta"),
    created_at: import_zod25.z.coerce.date().describe("Fecha de suscripci\xF3n a la alerta")
  }).describe("Suscripci\xF3n a una alerta")
}).describe("Definicion de una alerta");
var claimSLAObjectiveInstanceThresholdExceeded = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.sla.objective.instance.threshold.exceeded"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    sla: companySLAObject.extend({
      objective: slaObjectiveObject.extend({
        alert: alertObject,
        instance: import_zod25.z.object({
          id: (0, import_zod_openapi2.extendApi)(
            import_zod25.z.coerce.string().describe("ID de una instancia de objetivo de SLA"),
            {
              example: "objinstancesla_01j9crg9cgfpc8zwbqw27rqn7w"
            }
          ),
          time_to_resolution_type: import_zod25.z.nativeEnum(import_database13.DurationType).describe("Tipo de duraci\xF3n de la resoluci\xF3n del objetivo"),
          time_to_resolution_value: import_zod25.z.number().describe(
            "Valor de la duraci\xF3n de la resoluci\xF3n del objetivo"
          ),
          started_at: import_zod25.z.coerce.date().describe("Fecha de inicio de la resoluci\xF3n del objetivo"),
          deadline: import_zod25.z.coerce.date().describe("Fecha l\xEDmite de resoluci\xF3n del objetivo")
        }).describe(
          "Una instancia del objetivo asociada a una transici\xF3n en el estado del reclamo"
        )
      })
    })
  })
});
var claimSLAInstanceThresholdExceeded = baseWebhookEventPayloadSchema.extend({
  type: import_zod25.z.literal("claim.sla.instance.threshold.exceeded"),
  data: claimObject.pick({
    id: true,
    ref_id: true,
    team_id: true
  }).extend({
    sla: companySLAObject.extend({
      alert: alertObject,
      instance: import_zod25.z.object({
        id: (0, import_zod_openapi2.extendApi)(import_zod25.z.coerce.string(), {
          example: "slainstance_01j9csn03jfx88hmxjv3szfkc4"
        }),
        time_to_resolution_type: import_zod25.z.nativeEnum(import_database13.DurationType).describe(
          "Tipo de duraci\xF3n de la resoluci\xF3n del objetivo global"
        ),
        time_to_resolution_value: import_zod25.z.number().describe(
          "Valor de la duraci\xF3n de la resoluci\xF3n del objetivo global"
        ),
        created_at: import_zod25.z.coerce.date().describe(
          "Fecha de inicio de la resoluci\xF3n del objetivo global"
        ),
        deadline: import_zod25.z.coerce.date().describe("Fecha l\xEDmite de resoluci\xF3n del objetivo global")
      }).describe("Una instancia del objetivo global del SLA")
    })
  })
});
var webhookEventPayloadSchema = import_zod25.z.discriminatedUnion("type", [
  (0, import_zod_openapi2.extendApi)(claimCreatedEventPayloadSchema, {
    description: "Reclamo creado"
  }),
  (0, import_zod_openapi2.extendApi)(claimSLAObjectiveInstanceThresholdExceeded, {
    description: "Un objetivo de SLA alcanza el porcentaje de progreso configurado en una alerta de la empresa"
  }),
  (0, import_zod_openapi2.extendApi)(claimSLAInstanceThresholdExceeded, {
    description: "Un objetivo global de SLA alcanza el porcentaje de progreso configurado en una alerta de la empresa"
  }),
  (0, import_zod_openapi2.extendApi)(claimOwnershipTransferCreated, {
    description: "Transferencia de propiedad del reclamo creada"
  }),
  (0, import_zod_openapi2.extendApi)(claimOwnershipTransferAccepted, {
    description: "Transferencia de propiedad del reclamo aceptada"
  }),
  (0, import_zod_openapi2.extendApi)(claimOwnershipTransferRejected, {
    description: "Transferencia de propiedad del reclamo rechazada"
  }),
  (0, import_zod_openapi2.extendApi)(claimFileRequestCreated, {
    description: "Solicitud de archivos creada"
  }),
  (0, import_zod_openapi2.extendApi)(claimUpdatedEventPayloadSchema, {
    description: "Reclamo actualizado. Se dispara cuando algunos de los atributos enviados en la solicitud de creaci\xF3n del reclamo fueron actualizados."
  }),
  (0, import_zod_openapi2.extendApi)(claimMessageCreated, {
    description: "Un tramitador o un usuario externo envi\xF3 un mensaje en la conversaci\xF3n del reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(claimFileUploadedEventPayloadSchema, {
    description: "Archivo subido al reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(claimHandlerAssignedPayloadSchema, {
    description: "Tramitador asignado al reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(claimHandlerUnassignedPayloadSchema, {
    description: "Tramitador desasignado de un reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(claimStatusUpdatedPayloadSchema, {
    description: "Estado del reclamo actualizado"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderCreatedPayloadSchema, {
    description: "Orden de trabajo creada en un reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderInvoiceCreated, {
    description: "Factura de la orden de trabajo creada"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderUpdatesRequested, {
    description: "Un tramitador solicit\xF3 novedades sobre una orden de trabajo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderUpdatesPublished, {
    description: "Un proveedor public\xF3 novedades sobre una orden de trabajo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderReportCreated, {
    description: "Un proveedor agrego un reporte de un orden de trabajo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderReportAccepted, {
    description: "Un tramitador acept\xF3 un reporte de un orden de trabajo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOrderReportRejected, {
    description: "Un tramitador rechaz\xF3 un reporte de un orden de trabajo"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferCreated, {
    description: "Un tramitador realiz\xF3 un ofrecimiento al tercero"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAccepted, {
    description: "Un tercero acept\xF3 el ofrecimiento de un tramitador"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferRejected, {
    description: "Un usuario tercero rechaz\xF3 un ofrecimiento"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferCanceled, {
    description: "Un tramitador anul\xF3 un ofrecimiento"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferExpired, {
    description: "Un ofrecimiento de un tramitador ha expirado"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAgreementCreated, {
    description: "Un tramitador cre\xF3 una conformidad en un ofrecimiento"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAgreementCompleted, {
    description: "El tercero complet\xF3 sus acciones en una conformidad"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAgreementRejected, {
    description: "Un tercero rechaz\xF3 una conformidad"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAgreementExpired, {
    description: "La conformidad expir\xF3 debido al vencimiento"
  }),
  (0, import_zod_openapi2.extendApi)(claimOfferAgreementCanceled, {
    description: "Una conformidad fue cancelada por el tramitador"
  }),
  (0, import_zod_openapi2.extendApi)(claimRfpCreated, {
    description: "Una licitaci\xF3n fue creada por un tramitador"
  }),
  (0, import_zod_openapi2.extendApi)(claimRfpClosed, {
    description: "Una licitaci\xF3n fue cerrada automaticamente por vencimiento"
  }),
  (0, import_zod_openapi2.extendApi)(claimRfpCanceled, {
    description: "Una licitaci\xF3n fue cancelada por un tramitador"
  }),
  (0, import_zod_openapi2.extendApi)(claimRfpBidSubmitted, {
    description: "Una oferta fue enviada por un proveedor a una licitaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(claimRfpBidSelected, {
    description: "Una oferta de una licitaci\xF3n fue seleccionada como ganadora"
  }),
  (0, import_zod_openapi2.extendApi)(claimEstimatesUpdated, {
    description: "Las estimaciones de un reclamo fueron actualizadas"
  }),
  (0, import_zod_openapi2.extendApi)(fieldAdjusterAssigned, {
    description: "Un tramitador asign\xF3 un perito para la evaluaci\xF3n del reclamo"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalInvoiceUploaded, {
    description: "Un perito subi\xF3 una factura de evaluaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalReportCreated, {
    description: "Un perito cre\xF3 un informe de evaluaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalReportAccepted, {
    description: "Un tramitador acept\xF3 un informe de evaluaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalReportRejected, {
    description: "Un tramitador rechaz\xF3 un informe de evaluaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalUpdatesRequested, {
    description: "Un tramitador solicit\xF3 novedades sobre la evaluaci\xF3n"
  }),
  (0, import_zod_openapi2.extendApi)(appraisalUpdatesPublished, {
    description: "Un perito public\xF3 novedades sobre la evaluaci\xF3n"
  })
  // extendApi(fraudInvestigationCreated, {
  //   description: 'Una investigación de fraude fue creada por un tramitador',
  // }),
  // extendApi(fraudInvestigationUpdated, {
  //   description: 'Investigación de fraude actualizada',
  // }),
  // extendApi(fraudInvestigationClosed, {
  //   description: 'Investigación de fraude cerrada',
  // }),
  // extendApi(fraudInvestigationReportAccepted, {
  //   description: 'Un tramitador aceptó un reporte de investigación de fraude',
  // }),
  // extendApi(fraudInvestigationNewsRequestCreated, {
  //   description:
  //     'Un tramitador solicitó novedades sobre una investigación de fraude',
  // }),
  // extendApi(fraudInvestigationNewsRequestAnswered, {
  //   description:
  //     'Un tramitador de la plataforma de fraudes respondió a una solicitud de novedades sobre una investigación de fraude',
  // }),
]);
var webhookEventsSpec = webhookEventPayloadSchema._def.options.map(
  (schema) => {
    const jsonSchema = patchedGenerateSchema(schema);
    const title = jsonSchema.properties.type.enum[0];
    const description = jsonSchema.description;
    const example = getExampleFromSchema(jsonSchema);
    return {
      example,
      title,
      description,
      schema: jsonSchema,
      event: title
    };
  }
);
var webhookEventSchema = import_zod25.z.object({
  event: import_zod25.z.string().refine(
    (value) => webhookEventsSpec.some((event) => event.title === value),
    {
      message: "Evento invalido"
    }
  )
});
var webhookEventsSchema = import_zod25.z.array(webhookEventSchema);
var webhookSchema = import_zod25.z.object({
  teams: import_zod25.z.array(
    import_zod25.z.object({
      name: import_zod25.z.string().nullish(),
      id: import_zod25.z.string()
    })
  ).default([]),
  name: import_zod25.z.string().min(1, import_piramid_constants20.requiredFieldMessage),
  endpoint: import_zod25.z.string().url({
    message: "El endpoint debe ser una URL v\xE1lida"
  }),
  subscriptions: webhookEventsSchema.min(
    1,
    "Debes seleccionar al menos un evento"
  ),
  disabled: import_zod25.z.boolean().optional()
});
var createWebhookRequestBody = webhookSchema;
var updateWebhookRequestBody = webhookSchema.extend({
  mode: import_zod25.z.nativeEnum(import_database13.WebhookMode)
}).partial();
var testWebhookEventRequestBody = import_zod25.z.object({
  event: webhookEventSchema.shape.event
});

// contracts/company.contract.ts
var fetchCompanyRequestParams = import_zod26.z.object({
  companyId: import_zod26.z.coerce.string()
});
var companyOwnerSchema = import_zod26.z.object({
  email: import_zod26.z.string().email(),
  first_name: import_zod26.z.string().min(1),
  last_name: import_zod26.z.string().min(1),
  ein: einSchema().optional(),
  dni: import_zod26.z.string().length(8).optional()
});
var companyBaseSchema = import_zod26.z.object({
  name: import_zod26.z.string().min(1),
  domain: import_zod26.z.string().min(1),
  type: import_zod26.z.nativeEnum(import_database14.CompanyType),
  owner: companyOwnerSchema
});
var companySchemaUnion = import_zod26.z.discriminatedUnion("country", [
  companyBaseSchema.extend({
    country: import_zod26.z.literal("ARG"),
    ein: einSchema("ARG")
  }),
  companyBaseSchema.extend({
    country: import_zod26.z.literal("PRY"),
    ein: einSchema("PRY")
  })
]);
var companySchema = import_zod26.z.object({
  company: companySchemaUnion
});
var providerUserRequestParams = import_zod26.z.object({
  id: import_zod26.z.string().min(1),
  userId: import_zod26.z.string().min(1)
});
var createEntrypointRequestBody = import_zod26.z.object({
  integration: import_zod26.z.nativeEnum(import_database14.EntrypointIntegration).nullish(),
  type: import_zod26.z.nativeEnum(import_database14.EntrypointType),
  environment: import_zod26.z.nativeEnum(import_database14.EntrypointEnvironment),
  endpoint: import_zod26.z.string().regex(
    /^[a-zA-Z0-9_-]*$/,
    "Solamente letras, n\xFAmeros, guiones y guiones bajos"
  ).min(1, import_piramid_constants21.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  backend: import_zod26.z.nativeEnum(import_database14.EntrypointBackendTypes),
  name: import_zod26.z.string().min(1, import_piramid_constants21.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  avatar_token: import_zod26.z.string().min(1, import_piramid_constants21.requiredFieldMessage),
  validation_definitions: import_zod26.z.array(
    import_zod26.z.object({
      tag: import_zod26.z.object({
        id: import_zod26.z.coerce.string({
          invalid_type_error: import_piramid_constants21.requiredFieldMessage
        }).min(1),
        alias: import_zod26.z.nativeEnum(import_database14.TagAliases),
        name: import_zod26.z.string().nullable().optional()
      }),
      validation: import_zod26.z.nativeEnum(import_database14.ValidationsType, {
        invalid_type_error: import_piramid_constants21.requiredFieldMessage,
        required_error: import_piramid_constants21.requiredFieldMessage
      })
    })
  ).default([]),
  specification: import_zod26.z.nativeEnum(import_database14.EntrypointSpecification).nullish(),
  special_permissions: import_zod26.z.array(
    import_zod26.z.object({
      user_email: import_zod26.z.string().email("Email inv\xE1lido").min(1, import_piramid_constants21.requiredFieldMessage),
      permission: import_zod26.z.array(import_zod26.z.nativeEnum(import_database14.SpecialPermissionType)).min(1, import_piramid_constants21.requiredFieldMessage)
    })
  ).default([])
});
var removeCompanyEntrypointRequestParams = import_zod26.z.object({
  entrypointId: import_zod26.z.coerce.string(),
  companyId: import_zod26.z.coerce.string()
});
var fetchCompanyEntrypointRequestParams = import_zod26.z.object({
  entrypointId: import_zod26.z.coerce.string()
});
var listCompanySubStatusRequestQuery = import_zod26.z.object({
  search: import_zod26.z.string().optional()
});
var updateCompanySinisterConfigRequestBody = import_zod26.z.object({
  countries: import_zod26.z.array(import_zod26.z.string()).optional()
});
var updateCompanyCurrencyRequestBody = import_zod26.z.object({
  currency: import_zod26.z.nativeEnum(import_database14.CurrencySymbol),
  companyCurrencyId: import_zod26.z.coerce.string().nullish()
});
var removeCompanyCurrencyRequestParams = import_zod26.z.object({
  companyId: import_zod26.z.coerce.string(),
  companyCurrencyId: import_zod26.z.coerce.string()
});
var revealApiKeyRequestParams = import_zod26.z.object({
  type: import_zod26.z.enum(["prod", "sandbox"])
});
var listMessageTemplatesRequestQuery = import_zod26.z.object({
  variable_determination: import_zod26.z.nativeEnum(import_database14.VariableDetermination).nullish(),
  scope: import_zod26.z.nativeEnum(import_database14.MessageTemplateScope).default("offer")
});
var updateCompanyWorkingDaysRequestBody = import_zod26.z.object({
  working_days: import_zod26.z.array(
    import_zod26.z.object({
      enabled: import_zod26.z.boolean().default(true),
      day: import_zod26.z.nativeEnum(import_database14.DayOfWeek),
      start_time: import_zod26.z.coerce.date(),
      end_time: import_zod26.z.coerce.date()
    })
  )
});
var listCompanyOptionsRequestQuery = import_zod26.z.object({
  scope: import_zod26.z.enum(["complaint", "claim"]),
  type: import_zod26.z.enum(["status", "reference", "stage", "chat"])
});
var listClaimStatusResponseBody = import_zod26.z.object({
  options: import_zod26.z.array(
    claimObject.shape.status.extend({
      system_status: import_zod26.z.nativeEnum(import_database14.ClaimSystemStatus).nullish().describe("Estado del sistema")
    })
  ).describe("Lista de estados de reclamo")
});
var updateClaimStatusDefinitionRequestBody = claimObject.shape.status.pick({
  name: true,
  metadata: true
});
var updateClaimStatusDefinitionResponseBody = import_zod26.z.object({
  updated: import_zod26.z.boolean()
});
var retrieveClaimStatusRequestParams = import_zod26.z.object({
  claimStatusId: import_zod26.z.coerce.string()
});
var updateCompanyLogoRequestBody = import_zod26.z.object({
  file_token: import_zod26.z.string().min(1, import_piramid_constants21.requiredFieldMessage)
});
var updateCompanyCustomizationRequestBody = import_zod26.z.object({
  tenant_slug: import_zod26.z.string().max(63, "M\xE1ximo 63 caracteres").regex(
    /^[a-z0-9_-]+$/,
    "Solamente letras, n\xFAmeros, guiones y guiones bajos"
  ).nullish(),
  domain_invitations_only: import_zod26.z.boolean().nullish(),
  insurer_theme: import_zod26.z.nativeEnum(import_database14.CompanyTheme).nullish(),
  customer_theme: import_zod26.z.nativeEnum(import_database14.CompanyTheme).nullish()
});
var updateCompanyConfigurationRequestBody = import_zod26.z.object({
  domain_invitations_only: import_zod26.z.boolean()
});
var retrieveValidationPatternRequestBody = import_zod26.z.object({
  column: import_zod26.z.nativeEnum(import_database14.ValidationPatternColumns).nullish()
});
var listClaimFilesRequestParams = import_zod26.z.object({
  claimId: import_zod26.z.coerce.string()
});
var listClaimFilesApiResponseBody = import_zod26.z.object({
  files: import_zod26.z.array(
    import_zod26.z.object({
      id: import_zod26.z.string(),
      original_name: import_zod26.z.string(),
      stored_name: import_zod26.z.string(),
      type: import_zod26.z.string(),
      extension: import_zod26.z.string(),
      uploaded_by: import_zod26.z.object({
        first_name: import_zod26.z.string(),
        last_name: import_zod26.z.string(),
        email: import_zod26.z.string()
      }),
      tags: import_zod26.z.array(
        import_zod26.z.object({
          name: import_zod26.z.string()
        })
      ),
      InferredFileData: import_zod26.z.object({
        summary: import_zod26.z.string()
      }),
      previewURL: import_zod26.z.string(),
      url: import_zod26.z.string()
    })
  )
});
var fetchClaimFileRequestParams = import_zod26.z.object({
  claimId: import_zod26.z.coerce.string(),
  fileId: import_zod26.z.coerce.string()
});
var fetchClaimFileResponseBody = import_zod26.z.object({
  id: import_zod26.z.string(),
  original_name: import_zod26.z.string(),
  stored_name: import_zod26.z.string(),
  type: import_zod26.z.string(),
  extension: import_zod26.z.string(),
  uploaded_by: import_zod26.z.object({
    first_name: import_zod26.z.string(),
    last_name: import_zod26.z.string(),
    email: import_zod26.z.string()
  }),
  tags: import_zod26.z.array(
    import_zod26.z.object({
      name: import_zod26.z.string()
    })
  ),
  InferredFileData: import_zod26.z.object({
    summary: import_zod26.z.string()
  }),
  previewURL: import_zod26.z.string(),
  url: import_zod26.z.string()
});
var listCompanyClaimsResponseBody = import_zod26.z.object({
  claims: import_zod26.z.array(
    import_zod26.z.object({
      id: import_zod26.z.string(),
      claim_status: import_zod26.z.object({
        name: import_zod26.z.string(),
        mapping: import_zod26.z.object({
          system_status: import_zod26.z.string()
        }).nullable()
      })
    })
  )
});
var notFoundClaimErrorSchema = import_zod26.z.object({
  code: import_zod26.z.literal("not_found_claim"),
  description: import_zod26.z.string(),
  status: import_zod26.z.literal(404)
});
var notFoundFileErrorSchema = import_zod26.z.object({
  code: import_zod26.z.literal("not_found_file"),
  description: import_zod26.z.string(),
  status: import_zod26.z.literal(404)
});
var notFoundClaimOrFileErrorSchema = import_zod26.z.object({
  code: import_zod26.z.union([import_zod26.z.literal("not_found_claim"), import_zod26.z.literal("not_found_file")]),
  description: import_zod26.z.string(),
  status: import_zod26.z.literal(404)
});
var notFoundClaimStatusErrorSchema = import_zod26.z.object({
  code: import_zod26.z.literal("not_found_claim_status"),
  description: import_zod26.z.string(),
  status: import_zod26.z.literal(404)
});
var fetchClaimMinimalRequestParams = import_zod26.z.object({
  claimId: import_zod26.z.coerce.string()
});
var fetchClaimMinimalResponseBody = import_zod26.z.object({
  id: import_zod26.z.string(),
  external_claim_id: import_zod26.z.string().nullable(),
  formatted_external_claim_id: import_zod26.z.string().nullable().optional(),
  created_at: import_zod26.z.date(),
  sinister_date: import_zod26.z.date(),
  claim_status: import_zod26.z.object({
    id: import_zod26.z.string(),
    name: import_zod26.z.string(),
    mapping: import_zod26.z.object({
      system_status: import_zod26.z.string(),
      stage: import_zod26.z.object({
        id: import_zod26.z.string(),
        name: import_zod26.z.string()
      }).nullable()
    }).nullable()
  }),
  company: import_zod26.z.object({
    id: import_zod26.z.string(),
    name: import_zod26.z.string(),
    country: import_zod26.z.string()
  }),
  created_by: import_zod26.z.object({
    id: import_zod26.z.string(),
    email: import_zod26.z.string(),
    first_name: import_zod26.z.string(),
    last_name: import_zod26.z.string()
  }),
  owner: import_zod26.z.object({
    id: import_zod26.z.string(),
    email: import_zod26.z.string(),
    first_name: import_zod26.z.string(),
    last_name: import_zod26.z.string(),
    cellphone: import_zod26.z.string().nullable()
  }).nullable(),
  damages: import_zod26.z.array(
    import_zod26.z.object({
      id: import_zod26.z.string(),
      type: import_zod26.z.string(),
      material: import_zod26.z.object({
        type: import_zod26.z.string()
      }).nullable()
    })
  ),
  occurrence: import_zod26.z.object({
    location_address: import_zod26.z.string().nullable(),
    location_city: import_zod26.z.string().nullable(),
    location_state: import_zod26.z.string().nullable(),
    location_country: import_zod26.z.string().nullable()
  }),
  documents: import_zod26.z.array(
    import_zod26.z.object({
      id: import_zod26.z.string(),
      original_name: import_zod26.z.string(),
      stored_name: import_zod26.z.string(),
      type: import_zod26.z.string(),
      extension: import_zod26.z.string(),
      mimetype: import_zod26.z.string(),
      size: import_zod26.z.number(),
      uploaded_by: import_zod26.z.object({
        id: import_zod26.z.string(),
        first_name: import_zod26.z.string(),
        last_name: import_zod26.z.string(),
        email: import_zod26.z.string()
      }),
      tags: import_zod26.z.array(
        import_zod26.z.object({
          id: import_zod26.z.string(),
          name: import_zod26.z.string(),
          alias: import_zod26.z.string()
        })
      ),
      url: import_zod26.z.string()
    })
  ),
  can_create_offer: import_zod26.z.boolean()
});

// contracts/customer-organization.contract.ts
var createCustomerOrganizationRequestBody = import_zod27.z.object({
  name: import_zod27.z.string().min(1),
  ein: import_zod27.z.string().min(1).optional(),
  phone: import_zod27.z.string().refine((value) => !value || (0, import_libphonenumber_js2.isValidPhoneNumber)(value), {
    message: "Tel\xE9fono inv\xE1lido"
  }).optional(),
  email: import_zod27.z.union([import_zod27.z.literal(""), import_zod27.z.string().email("Email inv\xE1lido")]).optional(),
  address: import_zod27.z.string().max(500, "M\xE1ximo 500 caracteres").optional()
});
var updateCustomerOrganizationRequestBody = createCustomerOrganizationRequestBody;
var createCustomerOrganizationUserRequestBody = import_zod27.z.object({
  email: import_zod27.z.string().email(),
  first_name: import_zod27.z.string().min(1),
  last_name: import_zod27.z.string().min(1)
});
var linkCustomerOrganizationUserRequestBody = import_zod27.z.object({
  email: import_zod27.z.string().email()
});
var searchCustomerOrganizationCandidateRequestQuery = import_zod27.z.object({
  email: import_zod27.z.string().email()
});
var customerOrganizationUserRequestParams = import_zod27.z.object({
  id: import_zod27.z.string().min(1),
  userId: import_zod27.z.string().min(1)
});
var unlinkCustomerOrganizationUserRequestBody = import_zod27.z.object({
  transfer_claims_to_user_id: import_zod27.z.string().min(1).optional()
});
var updateCustomerOrganizationLogoRequestBody = updateCompanyLogoRequestBody;
var signInAsCustomerOrganizationUserRequestBody = import_zod27.z.object({
  // Insurer tenant whose customer portal opens with the member's session.
  company_id: import_zod27.z.string().min(1)
});

// contracts/customer-organization-invitation.contract.ts
var import_zod28 = require("zod");
var createCustomerOrganizationInvitationRequestBody = import_zod28.z.object({
  email: import_zod28.z.string().email(),
  first_name: import_zod28.z.string().min(1),
  last_name: import_zod28.z.string().min(1),
  // Insurer tenant the invitation belongs to: link subdomain, email branding
  // and the Member created on acceptance.
  company_id: import_zod28.z.string().min(1)
});
var customerOrganizationInvitationRequestParams = import_zod28.z.object({
  id: import_zod28.z.string().min(1),
  invitationId: import_zod28.z.string().min(1)
});
var customerOrganizationInvitationTokenRequestParams = import_zod28.z.object({
  token: import_zod28.z.string().min(1).max(128)
});
var acceptCustomerOrganizationInvitationRequestBody = passwordSchema;

// contracts/provider-group.contract.ts
var import_zod29 = require("zod");
var createProviderGroupRequestBody = import_zod29.z.object({
  name: import_zod29.z.string({ required_error: "El nombre es obligatorio" }).min(1, "El nombre es obligatorio").max(255, "El nombre es demasiado largo"),
  description: import_zod29.z.string().max(2e3, "La descripci\xF3n es demasiado larga").optional()
});
var updateProviderGroupRequestBody = createProviderGroupRequestBody;
var retrieveProviderGroupRequestParams = import_zod29.z.object({
  groupId: import_zod29.z.coerce.string()
});
var addProviderGroupMemberRequestBody = import_zod29.z.object({
  provider_id: import_zod29.z.string().min(1, "El proveedor es obligatorio")
});
var removeProviderGroupMemberRequestParams = import_zod29.z.object({
  groupId: import_zod29.z.coerce.string(),
  providerId: import_zod29.z.coerce.string()
});
var listProviderGroupsRequestQuery = paginateRequestQuery;

// contracts/order-document-requirement.contract.ts
var import_zod30 = require("zod");
var import_database15 = __toESM(require_index_browser4());
var createOrderDocumentRequirementRequestBody = import_zod30.z.object({
  name: import_zod30.z.string({ required_error: "El nombre es obligatorio" }).min(1, "El nombre es obligatorio").max(255, "El nombre es demasiado largo"),
  description: import_zod30.z.string().max(2e3, "La descripci\xF3n es demasiado larga").optional(),
  uploader: import_zod30.z.nativeEnum(import_database15.OrderFileUploader, {
    required_error: "Indic\xE1 qui\xE9n debe cargar el documento",
    invalid_type_error: "Indic\xE1 qui\xE9n debe cargar el documento"
  }),
  is_required: import_zod30.z.boolean({
    required_error: "Indic\xE1 si el documento es obligatorio"
  }),
  requires_review: import_zod30.z.boolean({
    required_error: "Indic\xE1 si el documento requiere revisi\xF3n"
  }),
  // default true al crear; editable en edit (desactivar)
  is_active: import_zod30.z.boolean().optional()
}).superRefine((value, ctx) => {
  if (value.uploader !== "provider" && value.requires_review) {
    ctx.addIssue({
      code: import_zod30.z.ZodIssueCode.custom,
      path: ["requires_review"],
      message: "Solo los documentos del proveedor pueden requerir revisi\xF3n"
    });
  }
});
var updateOrderDocumentRequirementRequestBody = createOrderDocumentRequirementRequestBody;
var retrieveOrderDocumentRequirementRequestParams = import_zod30.z.object({
  requirementId: import_zod30.z.coerce.string()
});

// contracts/order-claim-status-mapping.contract.ts
var import_zod31 = require("zod");
var import_database16 = __toESM(require_index_browser4());
var ORDER_CLAIM_TRIGGERS = [
  { workflow_stage: "accepted", workflow_stage_status: "awaiting_provider" },
  { workflow_stage: "accepted", workflow_stage_status: "rejected" },
  { workflow_stage: "scheduling", workflow_stage_status: "awaiting_provider" },
  { workflow_stage: "work_proof", workflow_stage_status: "awaiting_provider" },
  { workflow_stage: "work_proof", workflow_stage_status: "in_progress" },
  { workflow_stage: "work_proof", workflow_stage_status: "rejected" },
  {
    workflow_stage: "documentation",
    workflow_stage_status: "awaiting_provider"
  },
  {
    workflow_stage: "documentation",
    workflow_stage_status: "awaiting_insurer"
  },
  { workflow_stage: "documentation", workflow_stage_status: "rejected" },
  { workflow_stage: "completed", workflow_stage_status: "awaiting_insurer" },
  { workflow_stage: "completed", workflow_stage_status: "done" },
  { workflow_stage: "completed", workflow_stage_status: "canceled" }
];
var isOrderClaimTrigger = (stage, status) => ORDER_CLAIM_TRIGGERS.some(
  (trigger) => trigger.workflow_stage === stage && trigger.workflow_stage_status === status
);
var orderClaimTriggerLabelKey = (trigger) => `${trigger.workflow_stage}.${trigger.workflow_stage_status}`;
var upsertOrderClaimStatusMappingRequestBody = import_zod31.z.object({
  workflow_stage: import_zod31.z.nativeEnum(import_database16.OrderWorkflowStage),
  workflow_stage_status: import_zod31.z.nativeEnum(import_database16.OrderWorkflowStageStatus),
  claim_status_id: import_zod31.z.string({ required_error: "El estado del reclamo es obligatorio" }).min(1, "El estado del reclamo es obligatorio")
}).superRefine((value, ctx) => {
  if (!isOrderClaimTrigger(value.workflow_stage, value.workflow_stage_status)) {
    ctx.addIssue({
      code: import_zod31.z.ZodIssueCode.custom,
      path: ["workflow_stage"],
      message: "El momento de la orden no es configurable"
    });
  }
});
var removeOrderClaimStatusMappingRequestParams = import_zod31.z.object({
  mappingId: import_zod31.z.coerce.string()
});

// contracts/provider-branch.contract.ts
var import_zod32 = require("zod");
var providerBranchPhones = import_zod32.z.array(import_zod32.z.string().trim().min(1)).default([]);
var providerBranchEmails = import_zod32.z.array(import_zod32.z.string().trim().email("Email inv\xE1lido")).default([]);
var upsertProviderBranchRequestBody = import_zod32.z.object({
  name: import_zod32.z.string({ required_error: "El nombre es obligatorio" }).trim().min(1, "El nombre es obligatorio").max(255, "El nombre es demasiado largo"),
  address: import_zod32.z.string().trim().max(500, "La direcci\xF3n es demasiado larga").nullish(),
  locality_id: import_zod32.z.string().min(1, "La localidad es obligatoria"),
  latitude: import_zod32.z.number({ required_error: "La ubicaci\xF3n es obligatoria" }).min(-90).max(90),
  longitude: import_zod32.z.number({ required_error: "La ubicaci\xF3n es obligatoria" }).min(-180).max(180),
  phones: providerBranchPhones,
  emails: providerBranchEmails,
  is_central: import_zod32.z.boolean().default(false)
});
var retrieveProviderBranchRequestParams = import_zod32.z.object({
  branchId: import_zod32.z.coerce.string()
});
var listProviderBranchesRequestQuery = paginateRequestQuery;

// contracts/insurer-provider.contract.ts
var import_zod33 = require("zod");
var retrieveInsurerProviderRequestParams = import_zod33.z.object({
  providerId: import_zod33.z.coerce.string()
});

// utils/get-curly-brackets-variable-paths.ts
var keywords = ["#if", "if", "/if", "else"];
var getCurlyBracketsVariablePaths = (template) => {
  const paths = [];
  const regex = /\{\{([^}]+)\}\}/g;
  let m3;
  while ((m3 = regex.exec(template)) !== null) {
    if (m3.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    m3.forEach((match83, groupIndex) => {
      if (groupIndex === 1) {
        paths.push(match83.trim());
      }
    });
  }
  return paths.filter(
    (path) => !keywords.some((keyword) => path.includes(keyword))
  );
};

// utils/custom-handlebars.ts
var customHandlebarsToHandlebars = (input) => {
  let result = input.replace(/\[\[#if\s+\{\{(.+?)\}\}\s*\]\]/g, "{{#if $1}}");
  result = result.replace(/\[\[else\]\]/g, "{{else}}");
  result = result.replace(/\[\[\/if\]\]/g, "{{/if}}");
  result = result.replace(/\{\{\s+/g, "{{").replace(/\s+\}\}/g, "}}");
  return result;
};
var handlebarsToCustomHandlebars = (input) => {
  let result = input.replace(/\{\{#if\s+([^}\s]+)\s*\}\}/g, "[[#if {{$1}}]]");
  result = result.replace(/\{\{else\}\}/g, "[[else]]");
  result = result.replace(/\{\{\/if\}\}/g, "[[/if]]");
  result = result.replace(/\[\[#if\s+/g, "[[#if ").replace(/\s+\]\]/g, " ]]");
  return result;
};

// utils/validate-linked-list.ts
var validateLinkedList = (linkedList) => {
  let node = !!linkedList.head.value ? linkedList.head : false;
  let missingFieldPath = null;
  const clearPaths = [];
  if (!node) {
    let iterNode = linkedList.head;
    while (iterNode) {
      clearPaths.push(iterNode.path);
      if (iterNode.next) {
        iterNode = iterNode.next;
      } else {
        break;
      }
    }
    return {
      valid: true,
      clearPaths
    };
  }
  while (node) {
    if (!node.value) {
      missingFieldPath = node.path;
      break;
    }
    if (node.next) {
      clearPaths.push(node.path);
      node = node.next;
    } else {
      clearPaths.push(node.path);
      break;
    }
  }
  if (missingFieldPath)
    return {
      valid: false,
      path: missingFieldPath
    };
  return {
    valid: true,
    clearPaths
  };
};

// contracts/sla.contract.ts
var import_database17 = __toESM(require_index_browser4());
var import_piramid_constants22 = __toESM(require_dist2());
var import_zod34 = require("zod");
init_esm();
var import_piramid_constants23 = __toESM(require_dist2());
var import_piramid_constants24 = __toESM(require_dist2());
var createCompanySLASchema = import_zod34.z.object({
  overlapping: import_zod34.z.enum(["strict", "deactivate"]).default("deactivate"),
  expire_notification: import_zod34.z.boolean().default(true),
  active: import_zod34.z.boolean(),
  name: import_zod34.z.string({
    invalid_type_error: import_piramid_constants22.requiredFieldMessage,
    required_error: import_piramid_constants22.requiredFieldMessage
  }).min(1, import_piramid_constants22.requiredFieldMessage),
  effective_from: import_zod34.z.coerce.date({
    invalid_type_error: import_piramid_constants22.requiredFieldMessage,
    required_error: import_piramid_constants22.requiredFieldMessage,
    message: import_piramid_constants22.requiredFieldMessage
  }).refine(
    (value) => {
      return isSameDay(new Date(value), /* @__PURE__ */ new Date()) ? true : new Date(value) > /* @__PURE__ */ new Date();
    },
    {
      message: "La fecha de vigencia debe ser igual o mayor a la actual"
    }
  ),
  total_duration_type: import_zod34.z.nativeEnum(import_database17.DurationType, {
    invalid_type_error: import_piramid_constants22.requiredFieldMessage,
    required_error: import_piramid_constants22.requiredFieldMessage
  }).nullish(),
  total_duration_value: import_zod34.z.number({
    invalid_type_error: import_piramid_constants22.requiredFieldMessage,
    required_error: import_piramid_constants22.requiredFieldMessage
  }).int().min(1, import_piramid_constants22.requiredFieldMessage).nullish(),
  elapsed_duration_criteria: import_zod34.z.nativeEnum(import_database17.ElapsedDurationCriteria, {
    invalid_type_error: import_piramid_constants22.requiredFieldMessage,
    required_error: import_piramid_constants22.requiredFieldMessage
  }),
  scope: import_zod34.z.nativeEnum(import_database17.ScopeSLA),
  type: import_zod34.z.nativeEnum(import_database17.TypeSLA),
  objectives: import_zod34.z.array(
    import_zod34.z.object({
      duration_type: import_zod34.z.nativeEnum(import_database17.DurationType),
      duration_value: import_zod34.z.coerce.number().min(1).nullish(),
      reference_type: import_zod34.z.nativeEnum(import_database17.TypeSLA),
      reference_value: import_zod34.z.string(),
      name: import_zod34.z.string().nullish(),
      description: import_zod34.z.string().nullish(),
      group_type: import_zod34.z.nativeEnum(import_database17.ObjectiveGroupType).nullish(),
      group_value: import_zod34.z.string().nullish(),
      group_name: import_zod34.z.string().nullish()
    }).refine(
      (objective) => {
        if (objective.reference_type === "chat")
          return import_zod34.z.enum(import_piramid_constants22.virtualMetrics).safeParse(objective.reference_value).success;
        return true;
      },
      {
        message: "reference_value must be a valid enum value"
      }
    )
  ).transform(
    (objectives) => objectives.filter((objective) => !!objective.duration_value)
  ).refine((objectives) => objectives.length > 0, {
    message: "M\xEDnimo 1 objetivo"
  })
});
var applyRefinementsToCompanySLASchema = (schema) => {
  return schema.refine(
    (data) => data.objectives.every(
      (objective) => objective.reference_type === data.type
    ),
    {
      message: "objectives reference type must be the same as the type of the SLA",
      path: ["objectives"]
    }
  ).refine(
    (data) => import_piramid_constants23.elapsedDurationCriteriaOptsByType[data.type].includes(
      data.elapsed_duration_criteria
    ),
    {
      message: "elapsed_duration_criteria must be one of the available options",
      path: ["elapsed_duration_criteria"]
    }
  ).refine(
    (data) => {
      if (import_piramid_constants23.slaTypesWithTotalDuration.some((type) => data.type == type))
        return !!data.total_duration_type && !!data.total_duration_value;
      return true;
    },
    {
      message: import_piramid_constants22.requiredFieldMessage,
      path: ["total_duration_value"]
    }
  );
};
var createCompanySLARequestBody = applyRefinementsToCompanySLASchema(
  createCompanySLASchema
);
var upsertCompanySLARequestBody = createCompanySLARequestBody;
var listGroupSLAVersionsRequestQuery = import_zod34.z.object({
  scope: import_zod34.z.nativeEnum(import_database17.ScopeSLA),
  type: import_zod34.z.nativeEnum(import_database17.TypeSLA),
  name: import_zod34.z.string().nullish()
});
var deactivateGroupSLARequestBody = listGroupSLAVersionsRequestQuery;
var lineMetrics = [
  "avg",
  "max",
  "min",
  "median",
  "percentile_25",
  "percentile_75",
  "percentile_80",
  "percentile_90"
];
var chartFrequencies = ["daily", "weekly", "monthly"];
var slaFilterStatus = ["active", "completed"];
var retrieveRelationTypeSLAStatsRequestQuery = import_zod34.z.object({
  limit: import_zod34.z.coerce.number().min(1).max(30).default(10),
  scope: import_zod34.z.nativeEnum(import_database17.ScopeSLA),
  responsible_user_id: import_zod34.z.array(
    import_zod34.z.object({
      label: import_zod34.z.string().nullish(),
      value: import_zod34.z.coerce.string()
    })
  ).default([]),
  coordinator_id: import_zod34.z.array(
    import_zod34.z.object({
      label: import_zod34.z.string().nullish(),
      value: import_zod34.z.coerce.string()
    })
  ).default([]),
  sla_objective_started_at_from: import_zod34.z.coerce.date().nullish(),
  sla_objective_deadline_to: import_zod34.z.coerce.date().nullish(),
  sla_objective_references: import_zod34.z.array(
    import_zod34.z.object({
      label: import_zod34.z.string().nullish(),
      value: import_zod34.z.coerce.string()
    })
  ).default([]),
  relation_entity_system_status: import_zod34.z.array(import_zod34.z.nativeEnum(import_database17.ClaimSystemStatus)).default([]),
  relation_entity_created_at_from: import_zod34.z.coerce.date().nullish(),
  relation_entity_created_at_to: import_zod34.z.coerce.date().nullish(),
  sla_type: import_zod34.z.nativeEnum(import_database17.TypeSLA),
  sla_time_to_resolution_type: import_zod34.z.nativeEnum(import_database17.ElapsedDurationCriteria).nullish(),
  sla_status: import_zod34.z.enum(slaFilterStatus).nullish(),
  group_by: import_zod34.z.enum(chartFrequencies).default("monthly"),
  line_metric: import_zod34.z.enum(lineMetrics).default("avg"),
  elapsed_duration_criteria: import_zod34.z.nativeEnum(import_database17.ElapsedDurationCriteria).nullish().default(import_piramid_constants22.defaultElapsedDurationCriteria)
});
var retrieveSLARequestParams = import_zod34.z.object({
  slaId: import_zod34.z.coerce.string()
});
var retrieveSLAObjectivesRequestQuery = import_zod34.z.object({
  type: import_zod34.z.nativeEnum(import_database17.TypeSLA),
  scope: import_zod34.z.nativeEnum(import_database17.ScopeSLA),
  name: import_zod34.z.string().nullish()
});
var slaReportFiltersSchema = retrieveRelationTypeSLAStatsRequestQuery.pick({
  coordinator_id: true,
  responsible_user_id: true,
  sla_objective_deadline_to: true,
  sla_objective_started_at_from: true,
  sla_type: true,
  relation_entity_system_status: true,
  sla_status: true,
  sla_objective_references: true
}).partial();
var exportSLAsRequestBody = import_zod34.z.object({
  prefix: import_zod34.z.string().nullish(),
  scope: import_zod34.z.nativeEnum(import_database17.ScopeSLA),
  filters: slaReportFiltersSchema,
  columns: import_zod34.z.array(import_zod34.z.enum(import_piramid_constants24.slaReportColumns)).min(1, "M\xEDnimo 1 columna").refine((cols) => new Set(cols).size === cols.length, {
    message: "Duplicated columns"
  })
});

// contracts/message-template.contract.ts
var import_piramid_constants25 = __toESM(require_dist2());
var import_zod35 = require("zod");
var import_decimal2 = require("decimal.js");

// helpers/compute-offer-cap.ts
var import_decimal = require("decimal.js");
var computeOfferCap = (references) => new import_decimal.Decimal(references.material_judicial_amount || 0).add(new import_decimal.Decimal(references.person_judicial_amount || 0)).mul(new import_decimal.Decimal(references.percentage_of_liability || 0)).div(100).toNumber();
var isOfferCapComputable = (references) => references.percentage_of_liability !== null && references.percentage_of_liability !== void 0 && [references.material_judicial_amount, references.person_judicial_amount].some(
  (amount) => amount !== null && amount !== void 0
);
var resolveOfferCap = (references) => isOfferCapComputable(references) ? computeOfferCap(references) : null;
var exceedsOfferCap = (amount, offerCap) => new import_decimal.Decimal(amount).gt(offerCap);

// contracts/message-template.contract.ts
var computeReferenceValue = ({
  constraint,
  definition,
  references
}) => {
  const constraintReferenceTypeKey = `${constraint}_reference`;
  const constraintReferenceType = definition[constraintReferenceTypeKey];
  switch (constraintReferenceType) {
    case "judicial_amount_times_percentage_of_liability":
      return computeOfferCap(references);
    default:
      return null;
  }
};
var applyConditionsToVariables = ({
  values,
  variables,
  conditions
}) => variables.filter((variable) => {
  if (variable.determination !== "runtime") return false;
  const condition = conditions.find(
    (condition2) => condition2.target === variable.guid
  );
  if (!condition) return true;
  const evaluateCondition = () => {
    const referenceVariableValue = (values || {})[condition.variable];
    switch (condition.operator) {
      case "equals":
        return referenceVariableValue === condition.value;
      default:
        return false;
    }
  };
  const evaluation = evaluateCondition();
  switch (true) {
    case condition.action === "show":
      return evaluation;
    default:
      return false;
  }
});
var buildVariableSchema = (variable, references, validators) => {
  switch (variable.type) {
    case "text": {
      let fieldSchema = import_zod35.z.string({
        invalid_type_error: import_piramid_constants25.requiredFieldMessage,
        required_error: import_piramid_constants25.requiredFieldMessage
      });
      if (variable.min_length) {
        fieldSchema = fieldSchema.min(
          variable.min_length,
          `Campo muy corto. M\xEDnimo ${variable.min_length} caracteres`
        );
      }
      if (variable.max_length) {
        fieldSchema = fieldSchema.max(
          variable.max_length,
          `Campo demasiado largo. M\xE1ximo ${variable.max_length} caracteres`
        );
      }
      if (variable.required) {
        fieldSchema = fieldSchema.min(1, import_piramid_constants25.requiredFieldMessage);
      }
      if (!variable.required) return fieldSchema.nullish();
      return fieldSchema;
    }
    case "numeric": {
      let fieldSchema = import_zod35.z.coerce.number({
        invalid_type_error: import_piramid_constants25.requiredFieldMessage,
        required_error: import_piramid_constants25.requiredFieldMessage
      });
      if (variable.min_value_type) {
        const minValue = variable.min_value_type === "reference" ? computeReferenceValue({
          constraint: "min_value",
          definition: variable,
          references
        }) : new import_decimal2.Decimal(variable.min_value_literal).toNumber();
        if (minValue != null) {
          fieldSchema = fieldSchema.min(minValue, `Valor m\xEDnimo: ${minValue}`);
        }
      }
      if (variable.max_value_type) {
        const maxValue = variable.max_value_type === "reference" ? computeReferenceValue({
          constraint: "max_value",
          definition: variable,
          references
        }) : new import_decimal2.Decimal(variable.max_value_literal).toNumber();
        if (maxValue != null) {
          console.log("maxValue", maxValue);
          fieldSchema = fieldSchema.max(maxValue, `Valor m\xE1ximo: ${maxValue}`);
        }
      }
      if (variable.required)
        return fieldSchema.refine((value) => value != null, "Campo requerido");
      return fieldSchema.nullish();
    }
    case "select": {
      let fieldSchema = import_zod35.z.string({
        invalid_type_error: import_piramid_constants25.requiredFieldMessage,
        required_error: import_piramid_constants25.requiredFieldMessage
      });
      if (variable.required) {
        fieldSchema = fieldSchema.min(1, "Selecciona una opci\xF3n");
      }
      const applyRefine = (schema) => schema.refine(
        (value) => (variable.options || []).some(({ name }) => name === value),
        "Opci\xF3n invalida"
      );
      if (!variable.required) return applyRefine(fieldSchema).nullish();
      return applyRefine(fieldSchema);
    }
    case "file": {
      let fieldSchema = import_zod35.z.string({
        invalid_type_error: import_piramid_constants25.requiredFieldMessage,
        required_error: import_piramid_constants25.requiredFieldMessage
      });
      if (variable.required) {
        fieldSchema = fieldSchema.min(1, import_piramid_constants25.requiredFieldMessage);
      }
      if (validators == null ? void 0 : validators.file) {
        fieldSchema = fieldSchema.refine(
          (value) => validators.file.refine({
            guid: variable.guid,
            value
          }),
          {
            message: "Archivo invalido"
          }
        );
      }
      if (!variable.required) return fieldSchema.nullish();
      return fieldSchema;
    }
    default:
      return import_zod35.z.any();
  }
};
var validationMaskTranslations = {
  interbanking: "No se pudo validar este campo. Aseg\xFArese de que el CUIT y el CBU sean correctos y pertenezcan a la misma persona."
};
var buildMessageTemplateVariablesSchema = ({
  validations,
  variables,
  references,
  validators
}) => {
  const fieldsSchema = variables.reduce((previousFieldsSchemas, variable) => {
    return {
      ...previousFieldsSchemas,
      [variable.guid]: buildVariableSchema(variable, references, validators)
    };
  }, {});
  let base = import_zod35.z.object(fieldsSchema);
  if (!validators || !(validations == null ? void 0 : validations.length)) return base;
  for (const validation of validations || []) {
    const validator = validators[validation.validation];
    if (!validator) continue;
    base = base.superRefine(async (values, context) => {
      const getValues = () => {
        switch (validation.validation) {
          case "interbanking":
            const refs2 = {
              cbu: values[validation.references.cbu],
              cuit: values[validation.references.cuit]
            };
            return {
              validate: !!refs2.cbu && !!refs2.cuit,
              refs: refs2
            };
          default:
            return {
              validate: false,
              refs: {}
            };
        }
      };
      const { validate: validate2, refs } = getValues();
      if (!validate2) return true;
      const valid2 = await validator.refine({
        //@ts-ignore
        refs
      });
      if (!valid2) {
        const guids = Object.values(validation.references);
        guids.forEach((guid) => {
          context.addIssue({
            path: [guid],
            code: import_zod35.z.ZodIssueCode.custom,
            message: validationMaskTranslations[validation.validation]
          });
        });
      }
    });
  }
  return base;
};

// contracts/external-complaint.contract.ts
var import_zod36 = require("zod");
var retrieveExternalComplaintDetailRequestParams = import_zod36.z.object({
  externalComplaintId: import_zod36.z.coerce.string()
});

// contracts/oauth.contract.ts
var import_zod37 = require("zod");
var oauthExchangedCodeMessage = import_zod37.z.object({
  access_token: import_zod37.z.string(),
  idp: import_zod37.z.string()
});

// contracts/team.contracts.ts
var import_piramid_constants26 = __toESM(require_dist2());
var import_zod38 = require("zod");
var listTeamMembershipsRequestQuery = paginateRequestQuery;
var createTeamSchema = import_zod38.z.object({
  accepts_assignments: import_zod38.z.boolean().default(false).nullish(),
  name: import_zod38.z.string().min(1, import_piramid_constants26.requiredFieldMessage),
  coordinator_id: import_zod38.z.string().nullish(),
  users: import_zod38.z.array(
    import_zod38.z.object({
      id: import_zod38.z.coerce.string(),
      first_name: import_zod38.z.string().nullish(),
      last_name: import_zod38.z.string().nullish(),
      profile_photo: import_zod38.z.string().nullish(),
      email: import_zod38.z.string().email().nullish()
    })
  ).min(1, "M\xEDnimo un usuario")
});
var applyTeamValidationsToSchema = (schema) => (
  //@ts-ignore
  schema.refine(
    (values) => {
      if (values.accepts_assignments && !values.coordinator_id) return false;
      return true;
    },
    {
      message: "Debes marcar a un miembro como coordinador del equipo",
      path: ["users"]
    }
  )
);
var createTeamRequestBody = applyTeamValidationsToSchema(createTeamSchema);
var deleteTeamRequestParams = import_zod38.z.object({
  id: import_zod38.z.coerce.string()
});
var updateTeamRequestBody = applyTeamValidationsToSchema(
  createTeamSchema.pick({
    name: true,
    accepts_assignments: true,
    coordinator_id: true
  })
);
var createTeamMembershipRequestBody = import_zod38.z.object({
  user_id: import_zod38.z.string().min(1, import_piramid_constants26.requiredFieldMessage)
});
var batchCreateTeamMembershipsRequestBody = import_zod38.z.object({
  users: import_zod38.z.array(
    import_zod38.z.object({
      id: import_zod38.z.string().min(1, import_piramid_constants26.requiredFieldMessage)
    })
  ).min(1, "M\xEDnimo un usuario")
});

// contracts/complaint-portal.contract.ts
var import_zod39 = require("zod");
var retrieveComplaintPortalRequestParams = import_zod39.z.object({
  complaintId: import_zod39.z.coerce.string()
});

// contracts/search.contracts.ts
var import_zod40 = require("zod");
var searchRequestQuery = import_zod40.z.object({
  search: import_zod40.z.string().optional(),
  limit: import_zod40.z.coerce.number().max(20).default(10).optional()
});

// contracts/entrypoint.contracts.ts
var import_database18 = __toESM(require_index_browser4());
var import_piramid_constants27 = __toESM(require_dist2());
var import_zod41 = require("zod");
var fetchEntrypointRequestParams = import_zod41.z.object({
  endpoint: import_zod41.z.string().min(1, import_piramid_constants27.requiredFieldMessage).regex(/^[a-zA-Z0-9_-]*$/, "Debe ser alfanum\xE9rico")
});
var fetchEntrypointRequestQuery = import_zod41.z.object({
  type: import_zod41.z.nativeEnum(import_database18.EntrypointType).optional()
});
var listEntrypointsRequestQuery = import_zod41.z.object({
  type: import_zod41.z.nativeEnum(import_database18.EntrypointType).optional()
});
var createEntrypointSessionRequestBody = import_zod41.z.object({
  type: import_zod41.z.literal("complaint"),
  expiration_hours: import_zod41.z.coerce.number()
});
var commitEntrypointSnapshotProgressRequestBody = import_zod41.z.object({
  data: import_zod41.z.record(import_zod41.z.string(), import_zod41.z.any()),
  error: import_zod41.z.record(import_zod41.z.string(), import_zod41.z.any()).nullish(),
  completed_at: import_zod41.z.coerce.date().nullish()
});
var saveBatchEntrypointRecordEventsRequestBody = import_zod41.z.object({
  events: import_zod41.z.array(
    import_zod41.z.object({
      type: import_zod41.z.coerce.number(),
      data: import_zod41.z.record(import_zod41.z.string(), import_zod41.z.any()),
      timestamp: import_zod41.z.coerce.number()
    })
  ),
  sequence: import_zod41.z.coerce.number().int().nonnegative().default(0)
});
var retrieveEntrypointSnapshotRecordingRequestParams = fetchEntrypointRequestParams.extend({
  id: import_zod41.z.string().min(1)
});
var entrypointAttemptErrorStatuses = ["failed", "recovered"];
var listEntrypointsAttemptsRequestQuery = paginateRequestQuery.extend({
  partial_recording_id: import_zod41.z.string().nullish(),
  user_id: import_zod41.z.array(
    import_zod41.z.object({
      id: import_zod41.z.coerce.string(),
      label: import_zod41.z.string().nullish()
    })
  ).default([]),
  entrypoint_id: import_zod41.z.array(
    import_zod41.z.object({
      id: import_zod41.z.coerce.string(),
      label: import_zod41.z.string().nullish()
    })
  ).default([]),
  created_at_from: import_zod41.z.coerce.date().nullish(),
  created_at_to: import_zod41.z.coerce.date().nullish(),
  completed_at_from: import_zod41.z.coerce.date().nullish(),
  completed_at_to: import_zod41.z.coerce.date().nullish(),
  error_status: import_zod41.z.enum(entrypointAttemptErrorStatuses).nullish(),
  // Page loads that never moved past the first step are hidden unless asked.
  include_no_progress: import_zod41.z.enum(import_piramid_constants27.booleansString).optional()
});

// contracts/metrics.contract.ts
var import_piramid_constants30 = __toESM(require_dist2());
var import_zod45 = require("zod");

// contracts/claim.contracts.ts
var import_database20 = __toESM(require_index_browser4());
var import_piramid_constants29 = __toESM(require_dist2());
var import_zod44 = require("zod");

// contracts/file.contracts.ts
var import_database19 = __toESM(require_index_browser4());
var import_zod42 = require("zod");
var import_zod_openapi3 = require("@anatine/zod-openapi");
var listFilesRequestQuery = import_zod42.z.object({
  types: import_zod42.z.array(import_zod42.z.nativeEnum(import_database19.FileTypes)).default([]).optional(),
  tags: import_zod42.z.array(import_zod42.z.coerce.string()).default([]).optional(),
  search: import_zod42.z.string().optional(),
  limit: import_zod42.z.coerce.number().min(1).max(20).default(10).optional(),
  scope_type: import_zod42.z.enum([
    "claim",
    "sinister",
    "complaint",
    "external_complaint"
  ]),
  scope_id: import_zod42.z.coerce.string(),
  ownerId: import_zod42.z.coerce.string().optional()
});
var tokenizeFileRequestBody = import_zod42.z.object({
  name: (0, import_zod_openapi3.extendApi)(import_zod42.z.string().min(1), {
    example: "example.pdf"
  }),
  size: (0, import_zod_openapi3.extendApi)(import_zod42.z.coerce.number(), {
    example: 1e3
  })
});
var updateFileTagRequestBody = import_zod42.z.object({
  inferredFileDataId: import_zod42.z.string().min(1).optional()
});
var updateFileTagRequestParams = import_zod42.z.object({
  fileId: import_zod42.z.string().min(1),
  companyId: import_zod42.z.string().min(1),
  tagId: import_zod42.z.string().min(1)
});
var updateFileRequestParams = import_zod42.z.object({
  fileId: import_zod42.z.string().min(1),
  companyId: import_zod42.z.string().min(1).optional(),
  claimId: import_zod42.z.string().min(1).optional()
});
var updateFilesTagsInBatchRequestBody = import_zod42.z.object({
  files: import_zod42.z.array(
    import_zod42.z.object({
      id: import_zod42.z.string().min(1),
      tag_id: import_zod42.z.string().min(1)
    })
  )
});
var updateFilesTagsInBatchRequestParams = import_zod42.z.object({
  companyId: import_zod42.z.string().min(1)
});
var updateInferredKeywordRequestBody = import_zod42.z.object({
  key: import_zod42.z.string().min(1).optional(),
  value: import_zod42.z.string().min(1).optional()
});
var updateInferredKeywordRequestParams = import_zod42.z.object({
  fileId: import_zod42.z.string().min(1),
  companyId: import_zod42.z.string().min(1),
  inferredFileDataId: import_zod42.z.string().min(1),
  inferredKeywordId: import_zod42.z.string().min(1)
});

// contracts/amount.contract.ts
var import_zod43 = require("zod");

// validations/amount.ts
var import_decimal3 = __toESM(require("decimal.js"));
var amountRefine = ({ val, maxValue }) => {
  try {
    if (val.isNaN() || val.isNegative()) {
      return false;
    }
    if (!maxValue) {
      return true;
    }
    return !val.gt(new import_decimal3.default(maxValue));
  } catch (err) {
    return false;
  }
};

// contracts/amount.contract.ts
var import_piramid_constants28 = __toESM(require_dist2());
var import_decimal4 = __toESM(require("decimal.js"));
var amountSchema = (amount, required = false) => {
  return import_zod43.z.string({
    message: "El monto no es v\xE1lido"
  }).transform((val) => {
    if (val) return new import_decimal4.default(parseFloat(val.replace(/,/g, "")));
  }).refine(
    (val) => {
      if (val) return amountRefine({ val, maxValue: amount.maxValue });
      return true;
    },
    {
      message: `El monto m\xE1ximo es de ${Number(
        amount.maxValue
      ).toLocaleString()}`
    }
  ).refine(
    (value) => {
      if (!value && required) return false;
      return true;
    },
    {
      message: import_piramid_constants28.requiredFieldMessage
    }
  ).or(import_zod43.z.number());
};

// contracts/claim.contracts.ts
var import_libphonenumber_js3 = require("libphonenumber-js");
var generateNaturalPersonSchema = (extendSchema, options) => {
  const birthDateSchema = import_zod44.z.coerce.date({
    errorMap: (issue, ctx) => {
      if (issue.code === "invalid_date" || issue.code === "invalid_type") {
        return { message: "Fecha inv\xE1lida" };
      }
      return { message: import_piramid_constants29.requiredFieldMessage };
    }
  });
  return import_zod44.z.object({
    address_street: import_zod44.z.string().min(1).nullish(),
    address_number: import_zod44.z.string().min(1).nullish(),
    address_apartment: import_zod44.z.string().nullish(),
    parents: import_zod44.z.array(
      import_zod44.z.object({
        first_name: import_zod44.z.string().min(1).max(20, "El nombre no puede tener m\xE1s de 20 caracteres"),
        last_name: import_zod44.z.string().min(1).max(20, "El apellido no puede tener m\xE1s de 20 caracteres"),
        birth_date: import_zod44.z.coerce.date({
          errorMap: (issue, ctx) => {
            if (issue.code === "invalid_date" || issue.code === "invalid_type") {
              return { message: "Fecha inv\xE1lida" };
            }
            return { message: import_piramid_constants29.requiredFieldMessage };
          }
        }),
        identification: dni,
        type: import_zod44.z.nativeEnum(import_database20.PersonParentTypes)
      })
    ).default([]),
    identification_value: import_zod44.z.string().min(1),
    identification_type: import_zod44.z.nativeEnum(import_database20.IdentificationTypes),
    sex: import_zod44.z.nativeEnum(import_database20.SexTypes).nullish(),
    //TODO: in nodejs context we need to validate it querying db
    zip_code: import_zod44.z.string().min(1).regex(/^\d{4}$/, {
      message: "Debe tener 4 d\xEDgitos"
    }).nullish(),
    cellphone: import_zod44.z.coerce.string().min(1, import_piramid_constants29.requiredFieldMessage).refine(import_libphonenumber_js3.isValidPhoneNumber, {
      message: "N\xFAmero de celular inv\xE1lido"
    }),
    state: import_zod44.z.string().nullish(),
    city: import_zod44.z.string().nullish(),
    first_name: import_zod44.z.string().min(1).max(20, "El nombre no puede tener m\xE1s de 20 caracteres"),
    last_name: import_zod44.z.string().min(1).max(20, "El apellido no puede tener m\xE1s de 20 caracteres"),
    birth_date: (options == null ? void 0 : options.optionalBirthDate) ? birthDateSchema.nullish() : birthDateSchema,
    nationality: import_zod44.z.string().min(1).nullish(),
    email: whitelistedEmailSchema,
    ...extendSchema
  }).superRefine((val, ctx) => {
    const schemas = {
      cuil: cuitCuilSchema,
      cuit: cuitCuilSchema,
      national_id_document: dni,
      civil_registry_card: genericDocumentNumber,
      enrollment_book: genericDocumentNumber,
      passport: genericDocumentNumber
    };
    const mappedSchema = val.identification_type ? schemas[val.identification_type] : void 0;
    if (!mappedSchema) return true;
    return pipeRefineSuperRefine(
      "identification_value",
      mappedSchema,
      val.identification_value,
      ctx
    );
  });
};
var legalPersonSchema = import_zod44.z.object({
  type: import_zod44.z.nativeEnum(import_database20.LegalPersonTypes).nullish(),
  social_reason: import_zod44.z.string().min(1).max(40, "M\xE1ximo 40 caracteres"),
  address: import_zod44.z.string().min(1),
  state: import_zod44.z.string().min(1),
  city: import_zod44.z.string().min(1),
  zip_code: import_zod44.z.string().min(1).regex(/^\d{4}$/, {
    message: "Debe tener 4 d\xEDgitos"
  }),
  cuit: cuitSchema(),
  email: whitelistedEmailSchema
});
var blankToUndefined = (schema) => import_zod44.z.preprocess(
  (value) => typeof value === "string" && !value.trim() ? void 0 : value,
  schema
);
var recoveryDamageSchema = import_zod44.z.object({
  claimant_institution_relationship: import_zod44.z.nativeEnum(import_database20.ClaimantInstitutionRelationship).default("other"),
  institution: legalPersonSchema,
  damaged_person: generateNaturalPersonSchema({
    marital_status: blankToUndefined(import_zod44.z.nativeEnum(import_database20.MaritalStatus).nullish()),
    sex: blankToUndefined(import_zod44.z.nativeEnum(import_database20.SexTypes).nullish()),
    nationality: blankToUndefined(import_zod44.z.string().min(1).nullish()),
    birth_date: blankToUndefined(import_zod44.z.coerce.date().nullish()),
    cellphone: blankToUndefined(import_zod44.z.string().nullish()),
    email: blankToUndefined(whitelistedEmailSchema.nullish())
  }).nullish()
});
var victimSchema = import_zod44.z.discriminatedUnion("type", [
  import_zod44.z.object({
    type: import_zod44.z.literal("natural_person"),
    natural_person: generateNaturalPersonSchema({
      marital_status: import_zod44.z.nativeEnum(import_database20.MaritalStatus)
    }),
    legal_person: import_zod44.z.any().nullish().default(null)
  }),
  import_zod44.z.object({
    type: import_zod44.z.literal("legal_person"),
    legal_person: legalPersonSchema,
    natural_person: import_zod44.z.any().nullish().default(null)
  })
]);
var franchiseAmountSchema = import_zod44.z.preprocess((value) => {
  if (typeof value === "string" && value.trim() === "") return void 0;
  if (typeof value === "number" && Number.isNaN(value)) return void 0;
  return value;
}, import_zod44.z.coerce.number().int("Debe ingresar un monto de franquicia entero").positive("El monto de franquicia debe ser mayor a 0").max(999999999999, "El monto de franquicia supera el m\xE1ximo permitido").nullish());
var withApplicableFranchise = (schema) => import_zod44.z.preprocess((insurance) => {
  if (!insurance || typeof insurance !== "object") return insurance;
  const { coverage } = insurance;
  if (coverage === "all_risks_with_franchise")
    return insurance;
  return { ...insurance, franchise_amount: null };
}, schema);
var materialInsuranceSchema = import_zod44.z.object({
  coverage: import_zod44.z.nativeEnum(import_database20.CoverageTypes),
  other_coverage: import_zod44.z.string().nullish(),
  insurer: import_zod44.z.string().min(1).optional(),
  provided_policy_number: import_zod44.z.string().nullish(),
  policy_number: import_zod44.z.string().min(1).nullish(),
  franchise_amount: franchiseAmountSchema,
  plan: import_zod44.z.string().nullish(),
  coverage_amount: amountSchema({}).nullish()
}).refine(
  ({ coverage, franchise_amount }) => {
    if (coverage === "all_risks_with_franchise" && !franchise_amount) {
      return false;
    }
    return true;
  },
  {
    message: import_piramid_constants29.requiredFieldMessage,
    path: ["franchise_amount"]
  }
);
var materialDamageBaseSchema = import_zod44.z.object({
  insurance: withApplicableFranchise(materialInsuranceSchema).nullish()
});
var claimDriverSchema = import_zod44.z.object({
  first_name: import_zod44.z.string().min(1).max(import_piramid_constants29.NATURAL_PERSON_NAME_MAX_LENGTH, import_piramid_constants29.naturalPersonNameMaxLengthMessage),
  last_name: import_zod44.z.string().min(1).max(import_piramid_constants29.NATURAL_PERSON_NAME_MAX_LENGTH, import_piramid_constants29.naturalPersonNameMaxLengthMessage),
  cellphone: import_zod44.z.string().min(1).refine(import_libphonenumber_js3.isValidPhoneNumber, {
    message: "N\xFAmero de celular inv\xE1lido"
  }),
  country: import_zod44.z.string().min(1).refine(countryRefine),
  state: import_zod44.z.string().min(1)
}).nullish().default(null).refine(
  (data) => (data == null ? void 0 : data.country) ? stateRefine(data, (data2) => data2.country) : true
);
var damage = import_zod44.z.discriminatedUnion("type", [
  import_zod44.z.object({
    description: import_zod44.z.string(),
    fixed: import_zod44.z.boolean(),
    type: import_zod44.z.literal("material"),
    person: import_zod44.z.any().default(null),
    material: import_zod44.z.discriminatedUnion("type", [
      materialDamageBaseSchema.extend({
        type: import_zod44.z.literal("vehicle"),
        vehicle: import_zod44.z.object({
          document_type: import_zod44.z.nativeEnum(import_database20.VehicleDocumentTypes).default("other"),
          type: import_zod44.z.nativeEnum(import_database20.VehicleTypes),
          make: import_zod44.z.string().min(1),
          year: import_zod44.z.coerce.number().refine((val) => (/* @__PURE__ */ new Date()).getFullYear() >= val, {
            message: `No debe ser mayor a ${(/* @__PURE__ */ new Date()).getFullYear()}`
          }),
          // Nullish: backends con `intake` (Gamma) no capturan el uso y lo
          // envían null. Rivadavia lo sigue enviando (su formulario lo exige).
          use: import_zod44.z.nativeEnum(import_database20.VehicleUseTypes).nullish(),
          model: import_zod44.z.string().min(1),
          version: import_zod44.z.string().optional().nullish(),
          category: import_zod44.z.nativeEnum(import_database20.VehicleCategoryTypes),
          market_value: amountSchema({}).nullish(),
          license_plate: import_zod44.z.string().optional().nullable().nullish(),
          chassis: import_zod44.z.string().max(20, "M\xE1ximo 20 caracteres").nullish(),
          engine: import_zod44.z.string().max(20, "M\xE1ximo 20 caracteres").nullish()
        }),
        victim_role: import_zod44.z.nativeEnum(import_database20.VictimRoleTypes).nullish(),
        driver: claimDriverSchema
      }),
      materialDamageBaseSchema.extend({
        type: import_zod44.z.literal("real_property"),
        real_property: import_zod44.z.object({
          country: import_zod44.z.string().min(1).refine(countryRefine),
          address_street: import_zod44.z.string().min(1),
          address_number: import_zod44.z.string().min(1),
          address_apartment: import_zod44.z.string().nullish(),
          state: import_zod44.z.string().min(1),
          city: import_zod44.z.string().min(1),
          zip_code: import_zod44.z.string().min(1).regex(/^\d{4}$/, {
            message: "Debe tener 4 d\xEDgitos"
          }),
          type: import_zod44.z.nativeEnum(import_database20.RealPropertyTypes),
          ownership: import_zod44.z.nativeEnum(import_database20.RealPropertyOwnershipTypes),
          other_ownership: import_zod44.z.string().nullish(),
          other_type: import_zod44.z.string().nullish()
        }).refine((arg) => stateRefine(arg, (data) => data.country), {
          path: ["state"],
          message: "Invalid state for country"
        }).refine(
          (values) => {
            if (values.type === "other" && !values.other_type) return false;
            return true;
          },
          {
            path: ["other_type"],
            message: "other_type is required when type is other"
          }
        ).refine(
          (values) => {
            if (values.ownership === "other" && !values.other_ownership)
              return false;
            return true;
          },
          {
            path: ["other_ownership"],
            message: "other_ownership is required when ownership is other"
          }
        ),
        victim_role: import_zod44.z.nativeEnum(import_database20.VictimRoleTypes).nullish()
      })
    ]),
    victim: victimSchema,
    materialVictim: victimSchema.nullish()
  }),
  import_zod44.z.object({
    material: import_zod44.z.any().default(null),
    description: import_zod44.z.string(),
    fixed: import_zod44.z.boolean(),
    type: import_zod44.z.literal("person"),
    person: import_zod44.z.object({
      driver: claimDriverSchema,
      hadSurgery: import_zod44.z.boolean().nullish(),
      wasTreatedByWorkerCompensationInsurer: import_zod44.z.boolean().nullish(),
      wasTreatedByMedicalInstitution: import_zod44.z.boolean().nullish(),
      details: import_zod44.z.array(
        import_zod44.z.object({
          body_parts: import_zod44.z.array(import_zod44.z.enum(import_piramid_constants29.bodyParts)).default([]).optional(),
          severity: import_zod44.z.nativeEnum(import_database20.PersonDamageDetailSeverityTypes),
          damage: import_zod44.z.nativeEnum(import_database20.PersonDamageDetailTypes)
        })
      ).default([]),
      surgery_description: import_zod44.z.string().optional().nullable().nullish(),
      type: import_zod44.z.nativeEnum(import_database20.PersonDamageTypes),
      health_insurance_fund: import_zod44.z.string().nullish(),
      treatment_worker_compensation_insurer: import_zod44.z.string().optional().nullable().nullish(),
      treatment_medical_institution: import_zod44.z.string().optional().nullable().nullish(),
      victim_role: import_zod44.z.nativeEnum(import_database20.VictimRoleTypes).nullish(),
      policyholder_relationship: import_zod44.z.nativeEnum(import_database20.PolicyHolderRelationshipTypes).nullish(),
      policyholder_relationship_other: import_zod44.z.string().nullish()
    }).refine(
      ({ victim_role, policyholder_relationship }) => {
        if (!victim_role) return true;
        if (victim_role === "policyholder_rider" && !policyholder_relationship)
          return false;
        return true;
      },
      {
        message: `When victim_role is policyholder_rider, policyholder_relationship is required`,
        path: ["policyholder_relationship"]
      }
    ).transform((personDamage2) => {
      if (personDamage2.type === "death")
        return {
          ...personDamage2,
          details: []
        };
      return personDamage2;
    }).transform((personDamage2) => {
      if (personDamage2.victim_role !== "policyholder_rider" && personDamage2.policyholder_relationship)
        return {
          ...personDamage2,
          policyholder_relationship: void 0
        };
      return personDamage2;
    }).refine(
      (personDamage2) => {
        if (personDamage2.policyholder_relationship === "other" && !personDamage2.policyholder_relationship_other)
          return false;
        return true;
      },
      {
        message: "Debe indicar el vinculo",
        path: ["policyholder_relationship_other"]
      }
    ),
    victim: victimSchema,
    materialVictim: victimSchema.nullish()
  }),
  import_zod44.z.object({
    description: import_zod44.z.string(),
    fixed: import_zod44.z.boolean(),
    type: import_zod44.z.literal("recovery"),
    recovery: recoveryDamageSchema,
    victim: victimSchema,
    materialVictim: victimSchema.nullish()
  })
]);
var documentSchema = import_zod44.z.object({
  alias: import_zod44.z.nativeEnum(import_database20.TagAliases),
  token: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage)
});
var claimantNaturalPersonInnerSchema = generateNaturalPersonSchema({
  email: whitelistedEmailSchema
});
var claimantNaturalPersonSchema = import_zod44.z.object({
  //When absent the backend infers it positionally: first claimant of the
  //array is the principal (role claimant), the rest are heirs
  role: import_zod44.z.nativeEnum(import_database20.ClaimantRoles).nullish(),
  victim_relationship_other: import_zod44.z.string().nullish(),
  victim_relationship: import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes).nullish(),
  material_victim_relationship_other: import_zod44.z.string().nullish(),
  material_victim_relationship: import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes).nullish(),
  type: import_zod44.z.literal("natural_person"),
  natural_person: claimantNaturalPersonInnerSchema,
  //This is just a way to avoid diff when use compact-diff
  legal_person: import_zod44.z.any().nullish().default(null)
});
var claimantLegalPersonSchema = import_zod44.z.object({
  //When absent the backend infers it positionally: first claimant of the
  //array is the principal (role claimant), the rest are heirs
  role: import_zod44.z.nativeEnum(import_database20.ClaimantRoles).nullish(),
  victim_relationship_other: import_zod44.z.string().nullish(),
  victim_relationship: import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes).nullish(),
  material_victim_relationship_other: import_zod44.z.string().nullish(),
  material_victim_relationship: import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes).nullish(),
  type: import_zod44.z.literal("legal_person"),
  legal_person: legalPersonSchema,
  //This is just a way to avoid diff when use compact-diff
  natural_person: import_zod44.z.any().nullish().default(null)
});
var requireVinculoOtherWhenRelationshipIsOther = (claimant) => {
  if (claimant.victim_relationship === "other" && !claimant.victim_relationship_other)
    return false;
  return true;
};
var vinculoOtherRefineParams = {
  message: "Debe indicar el vinculo",
  path: ["victim_relationship_other"]
};
var VICTIM_RELATIONSHIP_REQUIRED_MESSAGE = "Debe indicar el v\xEDnculo con el damnificado";
var victimRelationshipSchema = import_zod44.z.object({
  victim_relationship: import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes, {
    required_error: VICTIM_RELATIONSHIP_REQUIRED_MESSAGE,
    invalid_type_error: VICTIM_RELATIONSHIP_REQUIRED_MESSAGE
  }),
  victim_relationship_other: import_zod44.z.string().nullish()
});
var victimRelationshipFormSchema = victimRelationshipSchema.refine(
  requireVinculoOtherWhenRelationshipIsOther,
  vinculoOtherRefineParams
);
var claimantSchema = import_zod44.z.discriminatedUnion("type", [
  claimantNaturalPersonSchema,
  claimantLegalPersonSchema
]).refine(requireVinculoOtherWhenRelationshipIsOther, vinculoOtherRefineParams);
var claimantIdSchema = import_zod44.z.string().min(1);
var updateClaimantSchema = import_zod44.z.discriminatedUnion("type", [
  claimantNaturalPersonSchema.extend({ id: claimantIdSchema }),
  claimantLegalPersonSchema.extend({ id: claimantIdSchema })
]).refine(requireVinculoOtherWhenRelationshipIsOther, vinculoOtherRefineParams);
var atMostOnePrincipalClaimant = (claimants) => claimants.filter(
  (claimant) => claimant.role === "claimant"
).length <= 1;
var applyOccurrenceValidations = (schema) => {
  return schema.refine(
    (arg) => {
      if (!arg.criminal_case_number) return true;
      return !!arg.court;
    },
    {
      path: ["court"],
      message: "Debe especificar n\xFAmero de juzgado"
    }
  ).superRefine((values, ctx) => {
    const list = {
      head: {
        path: "occurrence.judicial_department",
        value: values == null ? void 0 : values.judicial_department,
        next: {
          path: "occurrence.criminal_case_number",
          value: values == null ? void 0 : values.criminal_case_number,
          next: {
            path: "occurrence.court",
            value: values == null ? void 0 : values.court
          }
        }
      }
    };
    const validation = validateLinkedList(list);
    if (!validation.valid)
      return ctx.addIssue({
        code: import_zod44.z.ZodIssueCode.custom,
        message: import_piramid_constants29.requiredFieldMessage,
        path: [validation.path.replace("occurrence.", "")]
      });
    return true;
  });
};
var occurrenceSchema = import_zod44.z.object({
  police_station: import_zod44.z.string().optional().nullable().nullish(),
  criminal_case_number: import_zod44.z.coerce.string().max(6, "M\xE1ximo 6 d\xEDgitos").regex(/^\d+$/, "Unicamente d\xEDgitos").nullable().nullish().or(import_zod44.z.literal("")).transform((value) => !value ? void 0 : value),
  court: import_zod44.z.coerce.string().regex(/^\d+$/, "Unicamente d\xEDgitos").max(3, "M\xE1ximo 3 caracteres").optional().nullable().nullish().or(import_zod44.z.literal("")).transform((value) => !value ? void 0 : value),
  clerks_office: import_zod44.z.coerce.string().regex(/^\d+$/, "Unicamente d\xEDgitos").max(3, "M\xE1ximo 3 caracteres").optional().nullable().nullish().or(import_zod44.z.literal("")).transform((value) => !value ? void 0 : value),
  judicial_department: import_zod44.z.string().optional().nullable().nullish(),
  address: import_zod44.z.string().min(1),
  sinister_date: import_zod44.z.coerce.date({
    message: "La fecha del siniestro no es v\xE1lida"
  }).refine((date) => new Date(date).getTime() < (/* @__PURE__ */ new Date()).getTime(), {
    message: "Sinister date must be in the past"
  }),
  state: import_zod44.z.string().min(1),
  country: import_zod44.z.string().min(1).refine(countryRefine).default(import_piramid_constants29.DEFAULT_COUNTRY_CODE),
  city: import_zod44.z.string().min(1),
  zip_code: import_zod44.z.string().min(1).regex(/^\d{4}$/, {
    message: "Debe tener 4 d\xEDgitos"
  }),
  description: import_zod44.z.string().min(1)
});
var claimIntakeSchema = import_zod44.z.object({
  company_customer_id: import_zod44.z.string().nullish(),
  locality_id: import_zod44.z.string().nullish(),
  good_id: import_zod44.z.string().nullish(),
  service_id: import_zod44.z.string().nullish()
});
var createClaimSchema = import_zod44.z.object({
  endpoint: import_zod44.z.string().min(1),
  entrypoint_snapshot_progress_id: import_zod44.z.string().nullish(),
  policyholder_policy_number: import_zod44.z.string().nullable().nullish(),
  external_claim_id: import_zod44.z.string().nullish(),
  external_sinister_id: import_zod44.z.string().nullish(),
  policyholder_license_plate: import_zod44.z.string().nullable().nullish().transform((v) => v == null ? void 0 : v.toUpperCase()),
  is_policyholder_vehicle_trailer: import_zod44.z.boolean().nullish(),
  damages: import_zod44.z.array(damage).min(1).refine(
    (damages) => import_piramid_constants29.claimCombinations.some(
      (combination) => combination.length === damages.length && combination.every(
        (combinationDamage) => damages.some((d3) => d3.type === combinationDamage)
      )
    ),
    {
      message: "Invalid combination of damages"
    }
  ).refine(
    (damages) => {
      const personDamage2 = damages.find(
        (damage2) => damage2.type === "person" && damage2.person.victim_role === "rider"
      );
      const mustRequireDriverInfo = damages.some(
        (damage2) => damage2.type === "material" && damage2.material.type === "vehicle"
      ) && !!personDamage2;
      if (mustRequireDriverInfo) return !!personDamage2.person.driver;
      return true;
    },
    {
      message: "Driver info is required when there is a person damage and a vehicle damage",
      path: ["damages"]
    }
  ),
  claimants: import_zod44.z.array(claimantSchema).refine(atMostOnePrincipalClaimant, {
    message: "Only one claimant can have the claimant role"
  }),
  desired_support_location_state: import_zod44.z.string().min(1).refine(
    (val) => {
      if (!val) return false;
      const country = import_piramid_constants29.countryAndStates.find(
        (c2) => c2.code === import_piramid_constants29.DEFAULT_COUNTRY_CODE
      );
      return country.states.some((s3) => s3.code === val);
    },
    {
      message: `Invalid support location state for country ${import_piramid_constants29.DEFAULT_COUNTRY_CODE}`
    }
  ),
  desired_support_location_state_municipality: import_zod44.z.string().optional().nullable().nullish(),
  occurrence: applyOccurrenceValidations(
    occurrenceSchema.refine((arg) => stateRefine(arg, (data) => data.country), {
      path: ["state"],
      message: "Invalid state for country"
    })
  ),
  documents: import_zod44.z.array(documentSchema).default([]),
  claimed_amount: import_zod44.z.coerce.number({
    message: "El monto reclamado no es v\xE1lido"
  }).min(1, "El monto reclamado debe ser mayor a 0").max(
    import_piramid_constants29.MAX_CLAIMED_AMOUNT,
    `El monto reclamado debe ser menor a ${import_piramid_constants29.MAX_CLAIMED_AMOUNT}`
  ),
  material_claimed_amount: import_zod44.z.coerce.number({
    message: "El monto reclamado no es v\xE1lido"
  }).min(1, "El monto reclamado debe ser mayor a 0").max(
    import_piramid_constants29.MAX_CLAIMED_AMOUNT,
    `El monto reclamado debe ser menor a ${import_piramid_constants29.MAX_CLAIMED_AMOUNT}`
  ).optional(),
  victim: victimSchema.nullish(),
  // Present only for backends with structured intake (Gamma): it gates the
  // creation of the claim's `IntakeSubmission`. Rivadavia never sends it.
  intake: claimIntakeSchema.nullish()
});
var gammaOccurrenceSchema = applyOccurrenceValidations(
  occurrenceSchema.extend({
    address: import_zod44.z.string().nullish(),
    sinister_date: import_zod44.z.coerce.date({ message: "La fecha del siniestro no es v\xE1lida" }).refine((date) => new Date(date).getTime() < (/* @__PURE__ */ new Date()).getTime(), {
      message: "Sinister date must be in the past"
    }).nullish(),
    state: import_zod44.z.string().min(1).nullish(),
    city: import_zod44.z.string().min(1).nullish(),
    zip_code: import_zod44.z.string().min(1).regex(/^\d{4}$/, { message: "Debe tener 4 d\xEDgitos" }).nullish(),
    description: import_zod44.z.string().nullish()
  }).refine((arg) => !arg.state || stateRefine(arg, (data) => data.country), {
    path: ["state"],
    message: "Invalid state for country"
  })
);
var gammaClaimantSchema = import_zod44.z.discriminatedUnion("type", [
  claimantNaturalPersonSchema.extend({
    natural_person: generateNaturalPersonSchema(
      { email: whitelistedEmailSchema },
      { optionalBirthDate: true }
    )
  }),
  claimantLegalPersonSchema
]).refine(requireVinculoOtherWhenRelationshipIsOther, vinculoOtherRefineParams);
var gammaVictimSchema = import_zod44.z.discriminatedUnion("type", [
  import_zod44.z.object({
    type: import_zod44.z.literal("natural_person"),
    natural_person: generateNaturalPersonSchema(
      { marital_status: import_zod44.z.nativeEnum(import_database20.MaritalStatus).nullish() },
      { optionalBirthDate: true }
    ),
    legal_person: import_zod44.z.any().nullish().default(null)
  }),
  import_zod44.z.object({
    type: import_zod44.z.literal("legal_person"),
    legal_person: legalPersonSchema,
    natural_person: import_zod44.z.any().nullish().default(null)
  })
]);
var gammaDamageOptions = damage.options.map(
  (option) => option.extend({
    // Gamma no captura siempre la descripción del daño: opcional y acotada a
    // 190 caracteres (mirror de la validación del form). Los clásicos la exigen.
    description: import_zod44.z.string().max(190).nullish(),
    victim: gammaVictimSchema,
    materialVictim: gammaVictimSchema.nullish()
  })
);
var gammaDamage = import_zod44.z.discriminatedUnion(
  "type",
  gammaDamageOptions
);
var gammaCreateClaimSchema = createClaimSchema.extend({
  damages: import_zod44.z.array(gammaDamage).min(1),
  occurrence: gammaOccurrenceSchema,
  claimants: import_zod44.z.array(gammaClaimantSchema).refine(atMostOnePrincipalClaimant, {
    message: "Only one claimant can have the claimant role"
  }),
  victim: gammaVictimSchema.nullish(),
  // Provincia de atención no capturada por Gamma.
  desired_support_location_state: import_zod44.z.string().nullish(),
  // Gamma no captura monto reclamado: admite 0 (los clásicos exigen > 0).
  claimed_amount: import_zod44.z.coerce.number({ message: "El monto reclamado no es v\xE1lido" }).min(0, "El monto reclamado no puede ser negativo").max(
    import_piramid_constants29.MAX_CLAIMED_AMOUNT,
    `El monto reclamado debe ser menor a ${import_piramid_constants29.MAX_CLAIMED_AMOUNT}`
  )
});
var createClaimDiscriminatedBody = import_zod44.z.discriminatedUnion("backend", [
  createClaimSchema.extend({
    backend: import_zod44.z.literal("rivadavia")
  }),
  createClaimSchema.extend({
    backend: import_zod44.z.literal("tajy")
  }),
  createClaimSchema.extend({
    backend: import_zod44.z.literal("demoempleo")
  }),
  gammaCreateClaimSchema.extend({
    backend: import_zod44.z.literal("gamma")
  })
]).superRefine((arg, ctx) => {
  if (arg.backend === "gamma") return;
  if (!arg.occurrence.sinister_date && arg.damages.some(
    (d3) => d3.type === "material" && d3.material.type === "vehicle"
  )) {
    ctx.addIssue({
      code: import_zod44.z.ZodIssueCode.custom,
      message: "sinister_date is required when there is a vehicle damage",
      path: ["occurrence", "sinister_date"]
    });
  }
  if (!arg.policyholder_license_plate && !arg.policyholder_policy_number) {
    ctx.addIssue({
      code: import_zod44.z.ZodIssueCode.custom,
      message: "policyholder_license_plate or policy_number must be define in order to identify sinister"
    });
  }
  const isRecovery = arg.damages.some((damage2) => damage2.type === "recovery");
  arg.damages.forEach((damage2, index) => {
    if (damage2.type !== "material") return;
    if (damage2.material.insurance && !damage2.material.insurance.policy_number) {
      ctx.addIssue({
        code: import_zod44.z.ZodIssueCode.custom,
        message: import_piramid_constants29.requiredFieldMessage,
        path: ["damages", index, "material", "insurance", "policy_number"]
      });
    }
    if (damage2.material.insurance && !damage2.material.insurance.insurer) {
      ctx.addIssue({
        code: import_zod44.z.ZodIssueCode.custom,
        message: import_piramid_constants29.requiredFieldMessage,
        path: ["damages", index, "material", "insurance", "insurer"]
      });
    }
    if (!isRecovery && damage2.material.type === "vehicle" && !damage2.material.vehicle.use) {
      ctx.addIssue({
        code: import_zod44.z.ZodIssueCode.custom,
        message: import_piramid_constants29.requiredFieldMessage,
        path: ["damages", index, "material", "vehicle", "use"]
      });
    }
  });
  if (arg.policyholder_license_plate && !arg.occurrence.sinister_date) {
    ctx.addIssue({
      code: import_zod44.z.ZodIssueCode.custom,
      message: "sinister_date is required when policyholder_license_plate is defined",
      path: ["occurrence", "sinister_date"]
    });
  }
});
var createClaimRequestBody = import_zod44.z.preprocess((val) => {
  if (val && typeof val === "object" && !Array.isArray(val) && val.backend == null) {
    return {
      ...val,
      backend: "rivadavia"
    };
  }
  return val;
}, createClaimDiscriminatedBody);
var checkClaimAttributeRequestQuery = import_zod44.z.discriminatedUnion(
  "attribute",
  [
    import_zod44.z.object({
      attribute: import_zod44.z.literal("policy_number"),
      value: import_zod44.z.string().min(1),
      endpoint: import_zod44.z.string().min(1)
    }),
    import_zod44.z.object({
      attribute: import_zod44.z.literal("license_plate"),
      value: import_zod44.z.string().min(1),
      endpoint: import_zod44.z.string().min(1),
      sinister_date: import_zod44.z.coerce.date({
        message: "La fecha del siniestro no es v\xE1lida"
      }),
      victim_identification_value: import_zod44.z.string().min(1),
      victim_identification_type: import_zod44.z.nativeEnum(import_database20.IdentificationTypes),
      is_policyholder_vehicle_trailer: import_zod44.z.string().transform((value) => value === "true"),
      victim_type: import_zod44.z.enum(["natural_person", "legal_person"]).optional()
    }),
    import_zod44.z.object({
      attribute: import_zod44.z.literal("claim_entry"),
      value: import_zod44.z.string().min(1),
      endpoint: import_zod44.z.string().min(1),
      sinister_date: import_zod44.z.coerce.date({
        message: "La fecha del siniestro no es v\xE1lida"
      }),
      victim_identification_value: import_zod44.z.string().min(1),
      victim_identification_type: import_zod44.z.nativeEnum(import_database20.IdentificationTypes),
      is_policyholder_vehicle_trailer: import_zod44.z.string().transform((value) => value === "true"),
      victim_type: import_zod44.z.enum(["natural_person", "legal_person"]).optional()
    }),
    import_zod44.z.object({
      attribute: import_zod44.z.literal("zip_code"),
      endpoint: import_zod44.z.string().min(1),
      value: import_zod44.z.string().min(1).transform((v) => v.trim()),
      country: import_zod44.z.string().min(1),
      state: import_zod44.z.string().min(1)
    }),
    import_zod44.z.object({
      attribute: import_zod44.z.literal("zip_code_strict"),
      endpoint: import_zod44.z.string().min(1),
      value: import_zod44.z.string().min(1).transform((v) => v.trim()),
      country: import_zod44.z.string().min(1),
      state: import_zod44.z.string().min(1),
      city: import_zod44.z.string().optional(),
      address: import_zod44.z.string().optional()
    })
  ]
);
var paginateClaimsRequestQuery = paginateRequestQuery.extend({
  damages: import_zod44.z.array(import_zod44.z.nativeEnum(import_database20.DamageTypes)).default([]).optional()
});
var listInsurerClaimsRequestQuery = paginateRequestQuery.extend({
  user_id: import_zod44.z.string().nullish(),
  states: import_zod44.z.array(import_zod44.z.string()).default([]),
  municipalities: import_zod44.z.array(import_zod44.z.string()).default([]),
  claim_damages: import_zod44.z.array(import_zod44.z.nativeEnum(import_database20.DamageTypes)).default([]),
  date_from: import_zod44.z.coerce.date().optional(),
  date_to: import_zod44.z.coerce.date().optional(),
  claimed_amount_from: amountSchema({}).optional(),
  claimed_amount_to: amountSchema({}).optional(),
  coordinator: import_zod44.z.array(import_zod44.z.string()).default([]),
  victim_relationship: import_zod44.z.array(import_zod44.z.nativeEnum(import_database20.VictimRelationshipTypes)).default([]),
  team: import_zod44.z.array(import_zod44.z.string()).default([]),
  responsible: import_zod44.z.array(import_zod44.z.string()).default([]),
  collaborator: import_zod44.z.array(import_zod44.z.string()).default([]),
  system_status: import_zod44.z.array(import_zod44.z.nativeEnum(import_database20.ClaimSystemStatus)).default([]),
  status: import_zod44.z.array(import_zod44.z.string().min(1)).default([]),
  references: import_zod44.z.array(import_zod44.z.string().min(1)).default([]),
  stages: import_zod44.z.array(import_zod44.z.string().min(1)).default([]),
  type: import_zod44.z.array(import_zod44.z.enum(import_piramid_constants29.claimTypes)).default([]),
  ramo: import_zod44.z.array(import_zod44.z.string().min(1)).default([]),
  is_claimant_and_victim_same_insurer: import_zod44.z.array(import_zod44.z.enum(["true", "false"])).default([]),
  sinister_object: import_zod44.z.array(import_zod44.z.enum(import_piramid_constants29.sinisterObjectValues)).default([]),
  customer_organization: import_zod44.z.array(import_zod44.z.string().min(1)).default([]),
  fraud_status: import_zod44.z.array(import_zod44.z.enum(import_database20.fraudInvestigationStatuses)).default([]),
  external_claim_id: import_zod44.z.enum(import_piramid_constants29.sortTypes).optional(),
  sla_status_sort: import_zod44.z.enum(import_piramid_constants29.sortTypes).optional(),
  unread_notifications_sort: import_zod44.z.enum(import_piramid_constants29.sortTypes).optional()
});
var aggregateClaimsNotificationsActivityRequestBody = import_zod44.z.object({
  claim_ids: import_zod44.z.array(import_zod44.z.string().min(1)).min(1).max(100)
});
var fetchClaimDetailRequestParams = import_zod44.z.object({
  id: import_zod44.z.coerce.string()
});
var addMessageToClaimRequestParams = fetchClaimDetailRequestParams;
var addMessageRequestBody = import_zod44.z.object({
  message: import_zod44.z.string({
    invalid_type_error: import_piramid_constants29.requiredFieldMessage,
    required_error: import_piramid_constants29.requiredFieldMessage
  }).min(1, import_piramid_constants29.requiredFieldMessage)
});
var addClaimCollaboratorRequestBody = import_zod44.z.object({
  userId: import_zod44.z.coerce.string()
});
var assignClaimResponsibleRequestBody = import_zod44.z.object({
  group: import_zod44.z.enum([
    "current_team_membership",
    "prev_responsible",
    "team_coordinator"
  ]),
  target_id: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage)
});
var assignClaimCollaboratorRequestBody = import_zod44.z.object({
  userId: import_zod44.z.string()
});
var updateClaimStatusRequestParams = import_zod44.z.object({
  statusId: import_zod44.z.coerce.string(),
  claimId: import_zod44.z.coerce.string()
});
var updateRelationTypeStatusRequestBody = import_zod44.z.object({
  action_output_id: import_zod44.z.coerce.string().nullish()
});
var delegateClaimHandlingRequestBody = import_zod44.z.discriminatedUnion(
  "strategy",
  [
    import_zod44.z.object({
      strategy: import_zod44.z.literal("users"),
      users: import_zod44.z.array(
        import_zod44.z.object({
          id: import_zod44.z.coerce.string()
        })
      ).min(1, "M\xEDnimo 1 usuario").max(50, "M\xE1ximo 50 usuarios").refine(
        (users) => new Set(users.map((u2) => u2.id)).size === users.length,
        {
          message: "Usuarios duplicados!"
        }
      )
    }),
    import_zod44.z.object({
      strategy: import_zod44.z.literal("team"),
      team: import_zod44.z.coerce.string()
    })
  ],
  {
    required_error: import_piramid_constants29.requiredFieldMessage,
    invalid_type_error: import_piramid_constants29.requiredFieldMessage
  }
);
var listDelegatedClaimsRequestQuery = paginateRequestQuery.extend({});
var restoreDelegatedClaimsRequestBody = import_zod44.z.object({
  ids: import_zod44.z.array(import_zod44.z.coerce.string()).min(1).max(20).refine((items) => new Set(items).size === items.length, {
    message: "Duplicated ids"
  })
});
var claimsFilterSchema = listInsurerClaimsRequestQuery.omit({
  page: true,
  limit: true
});
var exportClaimsRequestBody = import_zod44.z.object({
  filters: claimsFilterSchema,
  columns: import_zod44.z.array(import_zod44.z.enum(import_piramid_constants29.claimReportColumns)).min(1, "M\xEDnimo 1 columna").refine((cols) => new Set(cols).size === cols.length, {
    message: "Duplicated columns"
  })
});
var attachFilesRequestBody = import_zod44.z.object({
  files: import_zod44.z.array(
    import_zod44.z.object({
      token: import_zod44.z.string().min(1),
      tags: import_zod44.z.array(import_zod44.z.coerce.string()).max(2, "M\xE1ximo 2 tags").refine((tags) => new Set(tags).size === tags.length, {
        message: "Duplicated tags"
      })
    })
  ).min(1)
});
var listClaimFilesMinimalRequestQuery = listFilesRequestQuery.pick({
  types: true,
  search: true,
  tags: true
});
var uploadClaimSharedDocumentsRequestBody = import_zod44.z.object({
  files: import_zod44.z.array(import_zod44.z.object({ token: import_zod44.z.string().min(1) })).min(1, import_piramid_constants29.requiredFieldMessage).max(import_piramid_constants29.MAX_CLAIM_FILES_PER_UPLOAD)
});
var listFieldAdjusterClaimsRequestQuery = paginateRequestQuery.extend({
  company: import_zod44.z.array(import_zod44.z.coerce.string()).default([]),
  status: import_zod44.z.array(import_zod44.z.enum(import_piramid_constants29.fieldAdjusterClaimStatus)).default([])
});
var transferClaimRequestBody = import_zod44.z.object({
  destination_user_email: import_zod44.z.string().email("El email no es v\xE1lido").min(1)
});
var assignClaimOwnerRequestBody = import_zod44.z.object({
  user_id: import_zod44.z.coerce.string()
});
var createClaimOwnerRequestBody = import_zod44.z.object({
  user_id: import_zod44.z.coerce.string()
});
var updateClaimEstimatesRequestBody = import_zod44.z.object({
  material_administrative_amount: import_zod44.z.coerce.number().int().optional(),
  person_administrative_amount: import_zod44.z.coerce.number().int().optional(),
  material_judicial_amount: import_zod44.z.coerce.number().int().optional(),
  person_judicial_amount: import_zod44.z.coerce.number().int().optional(),
  administrative_amount: import_zod44.z.coerce.number().int().optional(),
  percentage_of_liability: import_zod44.z.coerce.number().gte(0).lte(100).optional(),
  vehicle_market_value: import_zod44.z.coerce.number().int().nullish(),
  reason: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres")
});
var estimatesImposterProps = [
  "vehicle_market_value",
  "reason"
];
var percentageEstimatesProps = [
  "percentage_of_liability",
  "person_percentage_of_judicial_risk"
];
var updateDamageSchema = import_zod44.z.discriminatedUnion("type", [
  damage.options[0].omit({ victim: true }),
  damage.options[1].omit({ victim: true }),
  damage.options[2].omit({ victim: true })
]);
var updateClaimRequestBody = createClaimSchema.partial().pick({
  claimants: true
}).extend({
  // Override the create-time claimants with the id-carrying update variant so
  // each row can be edited in place by the service.
  claimants: import_zod44.z.array(updateClaimantSchema).refine(atMostOnePrincipalClaimant, {
    message: "Only one claimant can have the claimant role"
  }).optional(),
  damages: import_zod44.z.array(updateDamageSchema).optional(),
  occurrence: applyOccurrenceValidations(
    import_zod44.z.object({
      judicial_department: occurrenceSchema.shape.judicial_department,
      criminal_case_number: occurrenceSchema.shape.criminal_case_number,
      clerks_office: occurrenceSchema.shape.clerks_office,
      police_station: occurrenceSchema.shape.police_station,
      court: occurrenceSchema.shape.court,
      state: occurrenceSchema.shape.state.optional(),
      country: occurrenceSchema.shape.country.optional(),
      city: occurrenceSchema.shape.city.optional(),
      address: occurrenceSchema.shape.address.optional(),
      zip_code: occurrenceSchema.shape.zip_code.optional()
    })
  ).nullish(),
  victim: victimSchema.nullish()
}).superRefine((arg, ctx) => {
  var _a;
  (_a = arg.damages) == null ? void 0 : _a.forEach((damage2, index) => {
    if (damage2.type !== "material") return;
    if (damage2.material.insurance && !damage2.material.insurance.insurer) {
      ctx.addIssue({
        code: import_zod44.z.ZodIssueCode.custom,
        message: import_piramid_constants29.requiredFieldMessage,
        path: ["damages", index, "material", "insurance", "insurer"]
      });
    }
  });
});
var updateClaimIntakeRequestBody = claimIntakeSchema;
var listVehicleMakeRequestQuery = import_zod44.z.object({
  search: import_zod44.z.string().nullish(),
  type: import_zod44.z.nativeEnum(import_database20.VehicleTypes)
});
var listVehicleModelsRequestQuery = import_zod44.z.object({
  make: import_zod44.z.string().min(1),
  search: import_zod44.z.string().nullish(),
  type: import_zod44.z.nativeEnum(import_database20.VehicleTypes)
});
var listVehicleVersionsRequestQuery = import_zod44.z.object({
  make: import_zod44.z.string().min(1),
  model: import_zod44.z.string().min(1),
  year: import_zod44.z.coerce.string(),
  search: import_zod44.z.string().nullish(),
  type: import_zod44.z.nativeEnum(import_database20.VehicleTypes)
});
var extractVehicleIdCardRequestBody = import_zod44.z.object({
  file_token: import_zod44.z.string().min(1),
  type: import_zod44.z.nativeEnum(import_database20.VehicleTypes).nullish()
});
var listEntrypointOptionsRequestQuery = import_zod44.z.object({
  search: import_zod44.z.string().nullish(),
  // Acota el catálogo (servicios/bienes) a un vertical por slug. Opcional: sin
  // slug se devuelven los de todos los verticales habilitados de la company.
  vertical_slug: import_zod44.z.string().nullish()
});
var deriveClaimRequestBody = import_zod44.z.discriminatedUnion(
  "strategy",
  [
    import_zod44.z.object({
      reason: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage),
      strategy: import_zod44.z.literal("user"),
      user_id: import_zod44.z.coerce.string()
    }),
    import_zod44.z.object({
      reason: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage),
      strategy: import_zod44.z.literal("team"),
      team_id: import_zod44.z.coerce.string()
    })
  ],
  {
    required_error: import_piramid_constants29.requiredFieldMessage,
    invalid_type_error: import_piramid_constants29.requiredFieldMessage
  }
);
var returnClaimResponsibilityRequestBody = import_zod44.z.object({
  reason: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage)
});
var retrieveResponsibilityTransferRequestParams = import_zod44.z.object({
  responsibilityTransferId: import_zod44.z.coerce.string()
});
var cancelClaimDerivationRequestBody = import_zod44.z.object({
  reason: import_zod44.z.string().min(1, import_piramid_constants29.requiredFieldMessage)
});
var retrieveClaimDerivationRequestParams = import_zod44.z.object({
  derivationId: import_zod44.z.coerce.string()
});
var aggregateClaimAssignableUsersRequestQuery = import_zod44.z.object({
  search: import_zod44.z.string().nullish()
});
var listDerivedClaimsRequestQuery = paginateRequestQuery.extend({
  team_id: import_zod44.z.string().optional()
});

// contracts/metrics.contract.ts
var invalidDateRangeMessage = "La fecha hasta debe ser mayor o igual a desde";
var buildMetricsDateRangeQuery = () => import_zod45.z.object({
  company_id: import_zod45.z.string().optional(),
  from: import_zod45.z.string().transform((val) => new Date(val)),
  to: import_zod45.z.string().transform((val) => new Date(val))
}).superRefine((data, ctx) => {
  if (data.from > data.to) {
    ctx.addIssue({
      code: import_zod45.z.ZodIssueCode.custom,
      path: ["to"],
      message: invalidDateRangeMessage
    });
  }
});
var fetchMetricsGlobalFiltersRequestQueryBase = listInsurerClaimsRequestQuery.omit({
  page: true,
  limit: true,
  search: true
}).extend({
  user_id: import_zod45.z.coerce.string().nullish()
});
var fetchMetricsGlobalFiltersRequestQuery = fetchMetricsGlobalFiltersRequestQueryBase.superRefine((data, ctx) => {
  if (data.date_from && data.date_to && data.date_from > data.date_to) {
    ctx.addIssue({
      code: import_zod45.z.ZodIssueCode.custom,
      path: ["date_to"],
      message: invalidDateRangeMessage
    });
  }
});
var fetchClaimsWeeklyComparisonRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional()
});
var fetchHistogramRequestQuery = fetchMetricsGlobalFiltersRequestQueryBase.extend({
  bucket_size: import_zod45.z.enum(import_piramid_constants30.metricsHistogramBuckets)
});
var fetchClaimsCountFrequencyRequestQuery = fetchMetricsGlobalFiltersRequestQueryBase.extend({
  frequency: import_zod45.z.enum(import_piramid_constants30.metricsFrequency),
  count_status: import_zod45.z.enum(import_piramid_constants30.booleansString).default("false")
}).superRefine((data, ctx) => {
  if (data.date_from && data.date_to && data.date_from > data.date_to) {
    ctx.addIssue({
      code: import_zod45.z.ZodIssueCode.custom,
      path: ["date_to"],
      message: invalidDateRangeMessage
    });
  }
});
var fetchMetricsCaseRequestParam = import_zod45.z.object({
  moduleCase: import_zod45.z.enum(["claim", "complaint"])
});
var fetchDailyClaimsRequestQuery = buildMetricsDateRangeQuery();
var DAY_TYPES = ["working_day", "weekend", "holiday"];
var fetchClaimsDistributionRequestQuery = buildMetricsDateRangeQuery();
var CLAIM_DISTRIBUTION_CATEGORIES = [
  "preclaim_error",
  "no_linking",
  "successful",
  "local"
];
var fetchClaimCreationAttemptsRequestQuery = buildMetricsDateRangeQuery();
var fetchClaimAttemptsByUserRequestQuery = fetchClaimCreationAttemptsRequestQuery.and(
  import_zod45.z.object({
    search: import_zod45.z.string().trim().optional()
  })
);
var CLAIM_ATTEMPT_CATEGORIES = [
  "completed",
  // finished with no error
  "recovered",
  // finished, but hit an error along the way
  "failed",
  // never finished, blocked by an error
  "abandoned",
  // never finished, no error, left the form
  "in_progress"
  // updated recently, may still finish
];
var CLAIM_ATTEMPT_PEOPLE_OUTCOMES = [
  "finished",
  // at least one attempt created a claim
  "abandoned",
  // did not finish and has nothing in progress
  "in_progress"
  // did not finish yet, but an attempt is still in progress
];
var reviewGlobalFiltersQuery = import_zod45.z.object({
  claim_type_ids: import_zod45.z.string().optional(),
  team_ids: import_zod45.z.string().optional(),
  // The claims' active responsible handlers ("tramitador").
  handler_ids: import_zod45.z.string().optional(),
  // Province (`Claim.desired_support_location_state`) and city within it.
  zones: import_zod45.z.string().optional(),
  municipalities: import_zod45.z.string().optional(),
  // Respondent-relationship filter (e.g. "producer,particular"): the values the
  // "Tipo de reclamante" column shows. Unknown values are ignored.
  relationships: import_zod45.z.string().optional(),
  // "Tercero socio": true keeps only claims between insureds of the same
  // company, false only the rest. Absent means both.
  insured: optionalBooleanParam
});
var reviewSortFields = [
  "email",
  "score",
  "zone",
  "days",
  "time",
  "answered"
];
var reviewSortQuery = import_zod45.z.object({
  sort_field: import_zod45.z.enum(reviewSortFields).optional(),
  sort_dir: import_zod45.z.enum(["asc", "desc"]).optional()
});
var fetchReviewsDistributionRequestQuery = buildMetricsDateRangeQuery().and(reviewGlobalFiltersQuery).and(
  import_zod45.z.object({
    type: import_zod45.z.enum(import_piramid_constants30.reviewTypes).optional(),
    scores: import_zod45.z.string().optional(),
    keyword: import_zod45.z.string().optional(),
    leadPotencial: import_zod45.z.enum(import_piramid_constants30.booleansString).optional()
  })
);
var exportReviewsCSVRequestQuery = fetchReviewsDistributionRequestQuery.and(reviewSortQuery).and(import_zod45.z.object({ search: import_zod45.z.string().optional() }));
var reviewKpisRequestQuery = buildMetricsDateRangeQuery().and(reviewGlobalFiltersQuery).and(import_zod45.z.object({ tab: import_zod45.z.enum(import_piramid_constants30.reviewTabs) }));
var reviewSparkVariants = ["none", "line"];
var reviewFiltersRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional()
});
var reviewHeatmapRequestQuery = fetchReviewsDistributionRequestQuery.and(
  import_zod45.z.object({ dim: import_zod45.z.enum(import_piramid_constants30.reviewHeatmapDims) })
);
var reviewScoreBreakdownRequestQuery = fetchReviewsDistributionRequestQuery.and(
  import_zod45.z.object({ dim: import_zod45.z.enum(import_piramid_constants30.reviewScoreBreakdownDims) })
);
var fetchWeeklyEvolutionRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional(),
  weeks: import_zod45.z.coerce.number().min(1).max(52).default(8)
});
var fetchProcessingAmountMetricsRequestQuery = buildMetricsDateRangeQuery();
var globalTeamScopeQuery = import_zod45.z.object({
  team_ids: import_zod45.z.string().optional()
});
var fetchPerformanceBlockRequestQuery = buildMetricsDateRangeQuery().and(globalTeamScopeQuery);
var fetchPerformanceSnapshotRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional()
}).merge(globalTeamScopeQuery);
var fetchPerformanceCohortRequestQuery = fetchPerformanceBlockRequestQuery.and(
  import_zod45.z.object({
    damageType: import_zod45.z.enum(import_piramid_constants30.claimTypes).optional()
  })
);
var fetchPerformanceClosureCohortByOutcomeRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional(),
  damageType: import_zod45.z.enum(import_piramid_constants30.claimTypes).optional(),
  closingOutcomes: optionalCommaListParam(import_piramid_constants30.performanceClosingOutcomes)
}).merge(globalTeamScopeQuery);
var fetchPerformanceFunnelRequestQuery = fetchPerformanceBlockRequestQuery.and(
  import_zod45.z.object({
    companyClaimTypeId: import_zod45.z.string().optional()
  })
);
var fetchPerformanceStageSlaRequestQuery = fetchPerformanceFunnelRequestQuery;
var fetchPerformanceTeamScopeRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional()
}).merge(globalTeamScopeQuery);
var fetchPerformanceTeamExtendedRequestQuery = fetchPerformanceBlockRequestQuery.and(
  import_zod45.z.object({
    teamId: import_zod45.z.string().optional()
  })
);
var fetchPerformanceFraudImpactRequestQuery = fetchPerformanceBlockRequestQuery.and(
  import_zod45.z.object({
    companyClaimTypeId: import_zod45.z.string().optional()
  })
);
var fetchPerformanceFraudInvestigationTimeRequestQuery = fetchPerformanceFraudImpactRequestQuery;
var fetchPerformanceFraudCasesInProcessRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional(),
  companyClaimTypeId: import_zod45.z.string().optional()
}).merge(globalTeamScopeQuery);
var performanceLeadingIndicatorKeys = [
  "judicializationRate",
  "resolutionRate",
  "mediationRate",
  "pendingOfferCount"
];
var PERFORMANCE_DAMAGE_CATEGORIES = [
  "Lesionado",
  "Fallecidos",
  "Da\xF1o Material",
  "Combinado",
  "Da\xF1o a Inmueble"
];
var calculateCohortMonthsMatured = (cohortMonthIso, now) => {
  const [cohortYear, cohortMonth] = cohortMonthIso.split("-").map(Number);
  return (now.getUTCFullYear() - cohortYear) * 12 + (now.getUTCMonth() + 1 - cohortMonth);
};
var fetchPerformanceStageDrilldownRequestQuery = fetchPerformanceFunnelRequestQuery;
var fetchPerformanceRiskZoneRequestQuery = import_zod45.z.object({
  company_id: import_zod45.z.string().optional(),
  damageType: import_zod45.z.enum(import_piramid_constants30.claimTypes).optional(),
  amountFilter: import_zod45.z.enum(import_piramid_constants30.performanceRiskAmountFilters).optional()
}).merge(globalTeamScopeQuery);
var fetchCoordinatorBlockRequestQuery = fetchPerformanceBlockRequestQuery.and(
  import_zod45.z.object({
    teamId: import_zod45.z.string().optional()
  })
);
var fetchCoordinatorSnapshotRequestQuery = fetchPerformanceSnapshotRequestQuery.merge(
  import_zod45.z.object({
    teamId: import_zod45.z.string().optional()
  })
);
var fetchCoordinatorCohortRequestQuery = fetchCoordinatorBlockRequestQuery.and(
  import_zod45.z.object({
    handlerId: import_zod45.z.string().optional()
  })
);
var fetchCoordinatorFunnelRequestQuery = fetchCoordinatorBlockRequestQuery.and(
  import_zod45.z.object({
    companyClaimTypeId: import_zod45.z.string().optional()
  })
);
var fetchCoordinatorStageSlaRequestQuery = fetchCoordinatorFunnelRequestQuery;
var fetchCoordinatorStageDrilldownRequestQuery = fetchCoordinatorFunnelRequestQuery;
var fetchCoordinatorTeamExtendedRequestQuery = fetchCoordinatorBlockRequestQuery;
var fetchCoordinatorRiskZoneRequestQuery = import_zod45.z.object({
  teamId: import_zod45.z.string().optional(),
  damageType: import_zod45.z.enum(import_piramid_constants30.claimTypes).optional(),
  amountFilter: import_zod45.z.enum(import_piramid_constants30.performanceRiskAmountFilters).optional()
});
var fetchCoordinatorHandlersRequestQuery = import_zod45.z.object({
  teamId: import_zod45.z.string().optional()
});

// contracts/team-management.contract.ts
init_esm();
var import_database22 = __toESM(require_index_browser4());
var import_piramid_constants32 = __toESM(require_dist2());
var import_zod47 = require("zod");

// contracts/job.contract.ts
var import_database21 = __toESM(require_index_browser4());
var import_piramid_constants31 = __toESM(require_dist2());
var import_zod46 = require("zod");
var rescheduleJobRequestParams = import_zod46.z.object({
  job_id: import_zod46.z.coerce.string()
});
var scheduleNonOperationalJobRequestBody = import_zod46.z.object({
  from: import_zod46.z.coerce.date(),
  to: import_zod46.z.coerce.date()
}).refine(({ from, to }) => from.getTime() < to.getTime(), {
  message: "From date must be before to date"
}).refine(({ to }) => to.getTime() > Date.now(), {
  message: "El per\xEDodo tiene que terminar despu\xE9s de hoy"
});
var listCreatedJobsRequestQuery = import_zod46.z.object({
  status: import_zod46.z.nativeEnum(import_database21.JobStatus).optional(),
  execute_at_from: import_zod46.z.coerce.date().optional(),
  type: import_zod46.z.array(import_zod46.z.nativeEnum(import_database21.JobTypes)).default([])
});
var teamManualDelegationMove = import_zod46.z.discriminatedUnion("kind", [
  import_zod46.z.object({ claim_id: import_zod46.z.string(), kind: import_zod46.z.literal("return") }),
  import_zod46.z.object({
    claim_id: import_zod46.z.string(),
    kind: import_zod46.z.literal("delegate"),
    to_user_id: import_zod46.z.string()
  })
]);
var teamDelegationPlanBase = import_zod46.z.object({
  kept_claim_ids: import_zod46.z.array(import_zod46.z.string()).default([]),
  planned_at: import_zod46.z.coerce.date().optional()
});
var teamDelegationPlanMetadata = import_zod46.z.discriminatedUnion("mode", [
  teamDelegationPlanBase.extend({
    mode: import_zod46.z.literal("automatic"),
    categories: import_zod46.z.array(import_zod46.z.enum(import_piramid_constants31.teamDelegationCategories)),
    // Scheduled before there was a choice: by load, as it was.
    strategy: import_zod46.z.enum(import_piramid_constants31.teamDelegationStrategies).default("by_load"),
    claim_ids: import_zod46.z.array(import_zod46.z.string())
  }),
  teamDelegationPlanBase.extend({
    mode: import_zod46.z.literal("manual"),
    moves: import_zod46.z.array(teamManualDelegationMove)
  })
]);
var teamDelegationClaimIds = (delegation) => delegation.mode === "automatic" ? delegation.claim_ids : delegation.moves.map(({ claim_id: claimId }) => claimId);
var teamDelegationCoveredClaimIds = (delegation) => [...teamDelegationClaimIds(delegation), ...delegation.kept_claim_ids];
var nonOperationalJobMetadata = import_zod46.z.object({
  to: import_zod46.z.coerce.date(),
  reason: import_zod46.z.enum(import_piramid_constants31.inactivityReasons).optional(),
  scheduled_by_user_id: import_zod46.z.string().optional(),
  cancelled_by_user_id: import_zod46.z.string().optional(),
  // When scheduling it stopped the member's new claims. Cancelling lifts that
  // pause only while it is still this one, not a later one set by hand.
  assignments_paused_at: import_zod46.z.coerce.date().optional(),
  // The claims to delegate when it starts, chosen when it was scheduled: the
  // ones that came in later stay with the member.
  delegation: teamDelegationPlanMetadata.optional()
});
var operationalJobMetadata = import_zod46.z.object({
  scheduled_by_user_id: import_zod46.z.string().optional(),
  restored_by_user_id: import_zod46.z.string().optional(),
  cancelled_by_user_id: import_zod46.z.string().optional()
});
var processOfferAgreementJobMetadata = import_zod46.z.object({
  offer_id: import_zod46.z.string(),
  plan_id: import_zod46.z.string(),
  document_id: import_zod46.z.string().optional(),
  document_status: import_zod46.z.nativeEnum(import_database21.AgreementDocumentStatus).optional(),
  status_code: import_zod46.z.enum(import_piramid_constants31.agreementDocumentStatusCodes).nullable().optional()
});
var dispatchOfferAgreementJobMetadata = import_zod46.z.object({
  offer_id: import_zod46.z.string(),
  agreement_id: import_zod46.z.string(),
  failure_code: import_zod46.z.enum(import_piramid_constants31.offerAgreementDispatchFailureCodes).nullable().optional()
});
var reconcileOfferAgreementJobMetadata = import_zod46.z.object({
  offer_id: import_zod46.z.string(),
  agreement_id: import_zod46.z.string()
});
var cancelOfferAgreementJobMetadata = import_zod46.z.object({
  offer_id: import_zod46.z.string(),
  agreement_id: import_zod46.z.string(),
  outcome: import_zod46.z.enum(import_piramid_constants31.offerAgreementProviderCancelOutcomes).optional(),
  /** El estado que AutoSign informó cuando ya no se podía cancelar. */
  provider_status: import_zod46.z.string().nullable().optional()
});
var teamDelegationJobMetadata = import_zod46.z.object({
  source_user_id: import_zod46.z.string(),
  requested_by_user_id: import_zod46.z.string(),
  delegation: teamDelegationPlanMetadata,
  starts_at: import_zod46.z.coerce.date(),
  returns_at: import_zod46.z.coerce.date(),
  trigger: import_zod46.z.enum(import_piramid_constants31.teamDelegationTriggers).default("inactivity_started"),
  // Written when it ran: the claims to delegate that nobody could take, which
  // stay with the member as if they had never been covered.
  unassigned_claim_ids: import_zod46.z.array(import_zod46.z.string()).default([])
});
var jobDetailRequestParams = import_zod46.z.object({
  id: import_zod46.z.coerce.string()
});
var fetchJobRequestParams = import_zod46.z.object({
  job_id: import_zod46.z.coerce.string()
});

// contracts/team-management.contract.ts
var teamManagementScopeRequestQuery = import_zod47.z.object({
  team_id: import_zod47.z.string().optional()
});
var updateTeamManagementMemberRequestBody = import_zod47.z.object({
  accepts_assignments: import_zod47.z.boolean()
});
var teamManualDelegationAssignment = import_zod47.z.discriminatedUnion("kind", [
  import_zod47.z.object({ claim_id: import_zod47.z.string(), kind: import_zod47.z.literal("keep") }),
  ...teamManualDelegationMove.options
]);
var teamDelegationRequest = import_zod47.z.discriminatedUnion("mode", [
  import_zod47.z.object({
    mode: import_zod47.z.literal("automatic"),
    categories: import_zod47.z.array(import_zod47.z.enum(import_piramid_constants32.teamDelegationCategories)).min(1),
    strategy: import_zod47.z.enum(import_piramid_constants32.teamDelegationStrategies).default("round_robin")
  }),
  import_zod47.z.object({
    mode: import_zod47.z.literal("manual"),
    assignments: import_zod47.z.array(teamManualDelegationAssignment).min(1).max(import_piramid_constants32.TEAM_MEMBER_CLAIMS_LIMIT)
  })
]);
var scheduleTeamMemberInactivityRequestBody = scheduleNonOperationalJobRequestBody.and(
  import_zod47.z.object({
    reason: import_zod47.z.enum(import_piramid_constants32.inactivityReasons),
    pause_assignments_now: import_zod47.z.boolean(),
    delegation: teamDelegationRequest.optional()
  })
).refine(({ from }) => from > subDays(/* @__PURE__ */ new Date(), 1), {
  message: "The inactivity cannot start before today",
  path: ["from"]
});
var teamDelegationPlanRequestQuery = import_zod47.z.object({
  from: import_zod47.z.coerce.date(),
  to: import_zod47.z.coerce.date(),
  categories: import_zod47.z.array(import_zod47.z.enum(import_piramid_constants32.teamDelegationCategories)).default([]),
  strategy: import_zod47.z.enum(import_piramid_constants32.teamDelegationStrategies).default("round_robin"),
  claim_scope: import_zod47.z.enum(import_piramid_constants32.teamDelegationClaimScopes).default("all")
});
var teamManualDelegationRequestQuery = teamDelegationPlanRequestQuery.pick({
  from: true,
  to: true,
  claim_scope: true
});
var updateTeamScheduledDelegationRequestBody = import_zod47.z.object({
  delegation: teamDelegationRequest
});
var createTeamDelegationRequestBody = import_zod47.z.object({
  delegation: teamDelegationRequest,
  claim_scope: import_zod47.z.enum(import_piramid_constants32.teamDelegationClaimScopes)
});
var dismissTeamDelegationNoticeRequestBody = import_zod47.z.object({
  kind: import_zod47.z.enum(import_database22.teamDelegationNoticeKinds)
});
var updateTeamMemberInactivityRequestBody = import_zod47.z.object({
  from: import_zod47.z.coerce.date().optional(),
  to: import_zod47.z.coerce.date(),
  reason: import_zod47.z.enum(import_piramid_constants32.inactivityReasons).optional()
}).refine(({ from }) => !from || from > subDays(/* @__PURE__ */ new Date(), 1), {
  message: "The inactivity cannot start before today",
  path: ["from"]
}).refine(({ to }) => to.getTime() > Date.now(), {
  message: "The inactivity cannot end before today",
  path: ["to"]
}).refine(({ from, to }) => !from || from < to, {
  message: "The inactivity must end after it starts",
  path: ["to"]
});
var teamDelegatedClaimsRequestBody = import_zod47.z.object({
  claim_ids: import_zod47.z.array(import_zod47.z.string()).min(1).max(import_piramid_constants32.TEAM_MEMBER_CLAIMS_LIMIT)
});
var returnTeamDerivedClaimsRequestBody = teamDelegatedClaimsRequestBody.extend({
  comment: import_zod47.z.string().trim().max(2e3).optional()
});
var recoverTeamDerivedClaimsRequestBody = teamDelegatedClaimsRequestBody.extend({
  reason: import_zod47.z.string().trim().min(1).max(2e3)
});
var teamLeavesRequestQuery = teamManagementScopeRequestQuery.extend({
  year: import_zod47.z.coerce.number().int().min(2e3).max(2100).optional()
});
var teamReassignmentCandidatesRequestQuery = import_zod47.z.object({
  team_id: import_zod47.z.string(),
  from_user_id: import_zod47.z.string()
});
var createTeamClaimsReassignmentRequestBody = import_zod47.z.object({
  from_user_id: import_zod47.z.string(),
  to_user_id: import_zod47.z.string(),
  claim_ids: import_zod47.z.array(import_zod47.z.string()).min(1).max(import_piramid_constants32.TEAM_MEMBER_CLAIMS_LIMIT)
});
var teamActivityRequestQuery = teamManagementScopeRequestQuery.extend({
  page: paginateRequestQuery.shape.page,
  category: import_zod47.z.enum(import_piramid_constants32.teamActivityCategories).optional()
});

// contracts/release-note.contract.ts
var import_database23 = __toESM(require_index_browser4());
var import_piramid_constants33 = __toESM(require_dist2());
var import_zod48 = require("zod");
var textContent = import_zod48.z.object({
  body: import_zod48.z.string().min(1)
});
var headingContent = import_zod48.z.object({
  title: import_zod48.z.string().min(1),
  lead: import_zod48.z.string().min(1).optional()
});
var bulletsContent = import_zod48.z.object({
  items: import_zod48.z.array(
    import_zod48.z.object({
      title: import_zod48.z.string().min(1).optional(),
      body: import_zod48.z.string().min(1)
    })
  ).min(1)
});
var stepsContent = import_zod48.z.object({
  steps: import_zod48.z.array(import_zod48.z.object({ title: import_zod48.z.string().min(1), body: import_zod48.z.string().min(1) })).min(2)
});
var comparisonContent = import_zod48.z.object({
  columns: import_zod48.z.array(
    import_zod48.z.object({
      label: import_zod48.z.string().min(1),
      tone: import_zod48.z.enum(import_database23.releaseNoteComparisonTones)
    })
  ).min(1),
  rows: import_zod48.z.array(
    import_zod48.z.object({
      label: import_zod48.z.string().min(1),
      cells: import_zod48.z.array(import_zod48.z.string()).min(1)
    })
  ).min(1)
}).refine(
  ({ columns, rows }) => rows.every((row) => row.cells.length === columns.length),
  { message: "Every row needs one cell per column", path: ["rows"] }
);
var cardsContent = import_zod48.z.object({
  cards: import_zod48.z.array(
    import_zod48.z.object({
      title: import_zod48.z.string().min(1),
      body: import_zod48.z.string().min(1).optional(),
      rows: import_zod48.z.array(
        import_zod48.z.object({
          title: import_zod48.z.string().min(1),
          body: import_zod48.z.string().min(1),
          action: import_zod48.z.string().min(1).optional()
        })
      ).min(1).optional()
    })
  ).min(1)
});
var calloutContent = import_zod48.z.object({
  body: import_zod48.z.string().min(1)
});
var decisionContent = import_zod48.z.object({
  start: import_zod48.z.string().min(1),
  question: import_zod48.z.string().min(1),
  yes: import_zod48.z.object({ title: import_zod48.z.string().min(1), body: import_zod48.z.string().min(1) }),
  no: import_zod48.z.object({
    title: import_zod48.z.string().min(1),
    body: import_zod48.z.string().min(1),
    note: import_zod48.z.string().min(1).optional()
  })
});
var demoContent = import_zod48.z.object({
  demo: import_zod48.z.enum(import_database23.releaseNoteDemos),
  caption: import_zod48.z.string().min(1).optional()
});
var RELEASE_NOTE_IMAGE_SRC_PATTERN = /^data:image\/(?:png|jpeg|webp);base64,[A-Za-z0-9+/]+={0,2}$/;
var RELEASE_NOTE_IMAGE_SRC_MAX_LENGTH = 2e5;
var imageContent = import_zod48.z.object({
  src: import_zod48.z.string().max(RELEASE_NOTE_IMAGE_SRC_MAX_LENGTH).regex(RELEASE_NOTE_IMAGE_SRC_PATTERN),
  alt: import_zod48.z.string().min(1),
  caption: import_zod48.z.string().min(1).optional()
});
var releaseNoteSectionContentSchemas = {
  text: textContent,
  heading: headingContent,
  bullets: bulletsContent,
  steps: stepsContent,
  comparison: comparisonContent,
  cards: cardsContent,
  callout: calloutContent,
  decision: decisionContent,
  demo: demoContent,
  image: imageContent
};
var parseReleaseNoteSection = ({
  id,
  kind,
  title,
  content
}) => ({
  id,
  kind,
  title,
  content: releaseNoteSectionContentSchemas[kind].parse(content)
});
var isReleaseNoteSectionKind = (kind) => import_database23.releaseNoteSectionKinds.includes(kind);
var toReleaseNoteItemView = (item) => ({
  id: item.id,
  kind: item.kind,
  title: item.title,
  summary: item.summary,
  description: item.description,
  sections: item.sections.map(parseReleaseNoteSection)
});
var retrieveReleaseNoteRequestParams = import_zod48.z.object({
  releaseNoteId: import_zod48.z.string().min(1)
});
var eventBase = {
  occurred_at: import_zod48.z.coerce.date()
};
var noteEventBase = {
  ...eventBase,
  release_note_id: import_zod48.z.string().min(1)
};
var releaseNoteListSelection = import_zod48.z.union([
  import_zod48.z.object({ filter: import_zod48.z.enum(import_database23.releaseNoteListFilters) }),
  import_zod48.z.object({
    filter: import_zod48.z.literal(import_database23.RELEASE_NOTES_ROLE_FILTER),
    role_id: import_zod48.z.string().min(1)
  })
]);
var releaseNoteEventRequest = import_zod48.z.discriminatedUnion("type", [
  import_zod48.z.object({
    type: import_zod48.z.literal("release_notes_list_view"),
    ...eventBase
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_notes_list_filter"),
    ...eventBase,
    metadata: releaseNoteListSelection
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_notes_list_search"),
    ...eventBase,
    metadata: import_zod48.z.object({
      query: import_zod48.z.string().min(1).max(import_piramid_constants33.RELEASE_NOTES_SEARCH_QUERY_MAX_LENGTH)
    })
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_peek"),
    ...noteEventBase
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_view"),
    ...noteEventBase,
    metadata: import_zod48.z.object({ source: import_zod48.z.enum(import_database23.releaseNoteViewSources) })
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_item_view"),
    ...noteEventBase,
    item_id: import_zod48.z.string().min(1)
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_toc_click"),
    ...noteEventBase,
    item_id: import_zod48.z.string().min(1)
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal(
      "release_note_demo_interaction"
    ),
    ...noteEventBase,
    section_id: import_zod48.z.string().min(1),
    metadata: import_zod48.z.object({ action: import_zod48.z.string().min(1).max(64) })
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_link_click"),
    ...noteEventBase,
    metadata: import_zod48.z.object({ href: import_zod48.z.string().min(1).max(512) })
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_feedback"),
    ...noteEventBase,
    metadata: import_zod48.z.object({ helpful: import_zod48.z.boolean() })
  }),
  import_zod48.z.object({
    type: import_zod48.z.literal("release_note_read"),
    ...noteEventBase,
    duration_ms: import_zod48.z.number().int().min(0),
    metadata: import_zod48.z.object({
      max_scroll_percent: import_zod48.z.number().int().min(0).max(100),
      items_viewed: import_zod48.z.number().int().min(0)
    })
  })
]);
var createReleaseNoteEventsRequestBody = import_zod48.z.object({
  visit_id: import_zod48.z.string().min(8).max(64),
  events: import_zod48.z.array(releaseNoteEventRequest).min(1).max(import_piramid_constants33.RELEASE_NOTE_EVENTS_BATCH_LIMIT)
});
var listBackofficeReleaseNotesRequestQuery = import_zod48.z.object({
  company_id: import_zod48.z.string().min(1)
});
var listBackofficeReleaseNoteEventsRequestQuery = import_zod48.z.object({
  company_id: import_zod48.z.string().min(1),
  type: import_zod48.z.enum(import_database23.releaseNoteEventTypes).optional(),
  // The id of the last event of the previous page; ids sort by creation.
  cursor: import_zod48.z.string().min(1).optional(),
  limit: import_zod48.z.coerce.number().int().min(1).max(200).default(50)
});
var notifyBackofficeReleaseNoteRequestBody = import_zod48.z.object({
  only_pending: import_zod48.z.boolean()
});
var releaseBackofficeReleaseNoteRequestBody = import_zod48.z.object({
  role_ids: import_zod48.z.array(import_zod48.z.string().min(1)).min(1),
  notify: import_zod48.z.boolean()
});
var RELEASE_NOTE_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
var RELEASE_NOTE_ITEMS_LIMIT = 12;
var sectionInputOf = (kind) => import_zod48.z.object({
  kind: import_zod48.z.literal(kind),
  title: import_zod48.z.string().min(1).optional(),
  content: releaseNoteSectionContentSchemas[kind]
});
var releaseNoteSectionInput = import_zod48.z.discriminatedUnion("kind", [
  sectionInputOf("text"),
  sectionInputOf("heading"),
  sectionInputOf("bullets"),
  sectionInputOf("steps"),
  sectionInputOf("comparison"),
  sectionInputOf("cards"),
  sectionInputOf("callout"),
  sectionInputOf("decision"),
  sectionInputOf("demo"),
  sectionInputOf("image")
]);
var releaseNoteItemInput = import_zod48.z.object({
  kind: import_zod48.z.enum(import_database23.releaseNoteItemKinds),
  title: import_zod48.z.string().min(1),
  description: import_zod48.z.string().min(1),
  summary: import_zod48.z.string().min(1).optional(),
  sections: import_zod48.z.array(releaseNoteSectionInput).min(1)
});
var importBackofficeReleaseNoteRequestBody = import_zod48.z.object({
  slug: import_zod48.z.string().min(1).max(100).regex(RELEASE_NOTE_SLUG_PATTERN),
  title: import_zod48.z.string().min(1).max(80),
  subtitle: import_zod48.z.string().min(1),
  audience: import_zod48.z.string().min(1).optional(),
  kind: import_zod48.z.enum(import_database23.releaseNoteKinds),
  required_company_flag: import_zod48.z.enum(import_database23.releaseNoteCompanyFlags).optional(),
  items: import_zod48.z.array(releaseNoteItemInput).min(1).max(RELEASE_NOTE_ITEMS_LIMIT)
});
var publishBackofficeReleaseNoteRequestBody = import_zod48.z.object({
  published_at: import_zod48.z.coerce.date().optional()
});
var updateBackofficeReleaseNoteVisibilityRequestBody = import_zod48.z.object({
  visible: import_zod48.z.boolean()
});

// contracts/risk-zone.contract.ts
var import_piramid_constants34 = __toESM(require_dist2());
var import_zod49 = require("zod");
var fetchRiskZoneRequestQuery = import_zod49.z.object({
  claimType: import_zod49.z.enum(import_piramid_constants34.riskZoneClaimTypes)
});

// contracts/virtual-view.contract.ts
var import_database24 = __toESM(require_index_browser4());
var import_zod50 = require("zod");
var saveVirtualViewRequestBody = import_zod50.z.object({
  visible_filters: import_zod50.z.array(import_zod50.z.string()).default([]),
  name: import_zod50.z.string(),
  resource: import_zod50.z.nativeEnum(import_database24.VirtualViewResources),
  page_size: import_zod50.z.coerce.number(),
  filters: import_zod50.z.array(
    import_zod50.z.object({
      column: import_zod50.z.string(),
      value: import_zod50.z.string(),
      display_value: import_zod50.z.string().optional()
    })
  ),
  columns: import_zod50.z.array(
    import_zod50.z.object({
      column: import_zod50.z.string(),
      sort: import_zod50.z.nativeEnum(import_database24.ColumnSort).optional()
    })
  )
});
var listVirtualViewsRequestQuery = import_zod50.z.object({
  resource: import_zod50.z.nativeEnum(import_database24.VirtualViewResources)
});

// contracts/ownership-transfer.contracts.ts
var import_zod51 = require("zod");

// helpers/validate-claimant-victim-consistency.ts
var import_piramid_constants37 = __toESM(require_dist2());

// helpers/normalize-email.ts
var normalizeEmail = (email) => (email == null ? void 0 : email.trim().toLowerCase()) ?? "";

// helpers/validate-acceptance-identity.ts
var import_piramid_constants36 = __toESM(require_dist2());

// helpers/resolve-acceptance-payee.ts
var digitsOf = (value) => value ? value.replace(/\D/g, "") || null : null;
var PARENT_RELATIONSHIPS = [
  "mother",
  "father"
];
var REPRESENTATIVE_RELATIONS = {
  tutor_curator: "tutor_curator",
  legal_representative: "legal_representative"
};
var fromPerson = (person, relation) => ({
  relation,
  full_name: person.full_name ?? "",
  identification: digitsOf(person.identification),
  identification_type: person.identification_type
});
var fromClaimant = (claimant, relation) => fromPerson(claimant.person, relation);
var fromParent = (parent) => ({
  relation: parent.type,
  full_name: parent.full_name,
  identification: digitsOf(parent.identification),
  identification_type: null
});
var dedupe = (candidates) => {
  const seen = /* @__PURE__ */ new Set();
  return candidates.filter((candidate) => {
    if (!candidate.identification) return true;
    if (seen.has(candidate.identification)) return false;
    seen.add(candidate.identification);
    return true;
  });
};
var representativesOf = (facts) => facts.parties.representatives.flatMap((claimant) => {
  const relation = claimant.relationship ? REPRESENTATIVE_RELATIONS[claimant.relationship] : void 0;
  return relation ? [fromClaimant(claimant, relation)] : [];
});
var parentClaimantsOf = (subject) => subject.claimants.flatMap(
  (claimant) => claimant.relationship && PARENT_RELATIONSHIPS.includes(claimant.relationship) ? [
    fromClaimant(
      claimant,
      claimant.relationship
    )
  ] : []
);
var caseOf = (facts) => {
  if (facts.victim_kind === "legal_person") return "legal_person_victim";
  if (facts.victim_is_deceased) return "deceased_victim";
  if (facts.minority === "minor") return "minor_victim";
  if (facts.minority === "adult") return "victim";
  return "unknown";
};
var firstSuccessorOf = (facts) => {
  const [first] = facts.parties.heirs;
  return first ? [fromClaimant(first, "heir")] : [];
};
var chosenDeceasedCandidatesOf = (facts, payee) => {
  if (facts.parties.heirs.length === 0) return [];
  return payee === "attorney_in_fact" ? [fromPerson(facts.parties.victim, "victim")] : firstSuccessorOf(facts);
};
var candidatesFor = (payeeCase, subject, facts, payee) => {
  if (payee !== null && payeeCase === "deceased_victim")
    return chosenDeceasedCandidatesOf(facts, payee);
  const representatives = representativesOf(facts);
  const byCase = {
    victim: [fromPerson(facts.parties.victim, "victim")],
    legal_person_victim: [fromPerson(facts.parties.victim, "victim")],
    minor_victim: [
      ...facts.parties.victim_parents.map(fromParent),
      ...parentClaimantsOf(subject)
    ],
    deceased_victim: [
      ...facts.parties.heirs.map((heir) => fromClaimant(heir, "heir")),
      ...facts.parties.victim_parents.map(fromParent)
    ]
  };
  return dedupe([...byCase[payeeCase], ...representatives]);
};
var resolveAcceptancePayee = ({
  subject,
  facts,
  payee = null
}) => {
  const resolved2 = caseOf(facts);
  if (resolved2 === "unknown") {
    return { case: "victim", candidates: [], blocker: "minority_unknown" };
  }
  const candidates = candidatesFor(resolved2, subject, facts, payee);
  if (candidates.length === 0) {
    return { case: resolved2, candidates, blocker: "no_candidates" };
  }
  const withIdentification = candidates.filter(
    (candidate) => candidate.identification !== null
  );
  if (withIdentification.length === 0) {
    return {
      case: resolved2,
      candidates,
      blocker: "candidates_without_identification"
    };
  }
  return { case: resolved2, candidates: withIdentification, blocker: null };
};
var resolveLawyerCuit = (lawyer) => {
  const digits = digitsOf(lawyer.person.identification);
  return lawyer.person.identification_type === "cuit" && digits ? digits : null;
};
var isAttorneyInFact = (lawyer) => !!(lawyer == null ? void 0 : lawyer.present) && lawyer.kind === "attorney_in_fact";
var resolveOfferPayeeNames = (facts) => {
  var _a;
  const [firstSuccessor] = firstSuccessorOf(facts);
  const victimSide = facts.victim_is_deceased ? firstSuccessor == null ? void 0 : firstSuccessor.full_name : facts.parties.victim.full_name;
  return {
    victim: victimSide || null,
    attorney_in_fact: ((_a = facts.parties.lawyer) == null ? void 0 : _a.person.full_name) || null
  };
};
var resolveAcceptanceLawyer = (facts) => {
  const { lawyer } = facts.parties;
  if (!lawyer) {
    return {
      present: false,
      kind: null,
      full_name: null,
      cuit: null,
      blocker: null
    };
  }
  const cuit = resolveLawyerCuit(lawyer);
  return {
    present: true,
    kind: lawyer.kind,
    full_name: lawyer.person.full_name,
    cuit,
    blocker: cuit ? null : "lawyer_identification_not_cuit"
  };
};
var acceptancePayeeBlockersOf = ({
  payee,
  lawyer
}) => [
  ...payee.blocker ? ["payee_unresolved"] : [],
  ...lawyer.present && lawyer.blocker ? ["lawyer_cuit_unavailable"] : []
];

// helpers/resolve-agreement-bindings.ts
var import_piramid_constants35 = __toESM(require_dist2());
var import_utils31 = __toESM(require_dist3());
var mergeAgreementBindings = (defaults, override) => {
  const bindings = { ...defaults };
  const sources = Object.fromEntries(
    import_piramid_constants35.agreementBindingConcepts.map((concept) => [concept, "default"])
  );
  for (const concept of import_piramid_constants35.agreementBindingConcepts) {
    const names = override == null ? void 0 : override[concept];
    if (names && names.length > 0) {
      bindings[concept] = names;
      sources[concept] = "company";
    }
  }
  return { bindings, sources };
};
var resolveAgreementBindings = ({
  offer,
  acceptance,
  bindings,
  sources
}) => {
  const warnings = [];
  const resolutions = Object.fromEntries(
    import_piramid_constants35.agreementBindingConcepts.map((concept) => {
      const determination = import_piramid_constants35.agreementBindingDeterminations[concept];
      const acceptedNames = bindings[concept].map(import_utils31.normalizeVariableName);
      const matches = offer.definitions.filter(
        (definition2) => definition2.determination === determination && acceptedNames.includes(definition2.normalized_name)
      );
      const distinctNames = new Set(
        matches.map((match83) => match83.normalized_name)
      );
      const source = sources[concept];
      const unresolved = (status, matched_name = null) => ({
        status,
        matched_name,
        source,
        raw: null
      });
      if (distinctNames.size === 0) return [concept, unresolved("unbound")];
      if (distinctNames.size > 1) {
        warnings.push({
          code: "ambiguous_binding",
          detail: { concept, names: Array.from(distinctNames) }
        });
        return [concept, unresolved("ambiguous")];
      }
      const [definition] = matches;
      if (!bindings[concept].includes(definition.name)) {
        warnings.push({
          code: "binding_matched_by_normalization",
          detail: { concept, name: definition.name }
        });
      }
      if (determination === "runtime") {
        if (acceptance.source === "none") {
          return [concept, unresolved("acceptance_unknown", definition.name)];
        }
        if (acceptance.hidden_guids.includes(definition.guid)) {
          return [concept, unresolved("hidden", definition.name)];
        }
      }
      const values = determination === "runtime" ? offer.values.runtime : offer.values.compile_time;
      const raw = values[definition.guid];
      if (raw === void 0 || raw.trim() === "") {
        return [concept, unresolved("not_provided", definition.name)];
      }
      return [
        concept,
        { status: "resolved", matched_name: definition.name, source, raw }
      ];
    })
  );
  return { resolutions, warnings };
};
var CBU_LENGTH = 22;
var CUIT_LENGTH = 11;
var onlyDigits = (raw) => raw.replace(/\D/g, "");
var parseBoundPositiveInteger = (raw) => {
  if (raw === null) return null;
  const parsed = Number(raw.trim().replace(",", "."));
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};
var parseBoundDigits = (raw) => {
  if (raw === null) return null;
  const digits = onlyDigits(raw);
  return digits.length > 0 ? digits : null;
};
var isValidCuit = (digits) => digits.length === CUIT_LENGTH && (0, import_utils31.calculateVerificationNumber)(digits) === Number(digits[CUIT_LENGTH - 1]);
var bankPairWarnings = ({
  cbu,
  cuit,
  who
}) => {
  const warnings = [];
  if (cbu && cuit && cbu.length === CUIT_LENGTH && cuit.length === CBU_LENGTH) {
    warnings.push({ code: "bank_fields_swapped", detail: { who } });
    return warnings;
  }
  if (cbu && cbu.length !== CBU_LENGTH) {
    warnings.push({
      code: "invalid_cbu_format",
      detail: { who, length: cbu.length }
    });
  }
  if (cuit && !isValidCuit(cuit)) {
    warnings.push({ code: "invalid_cuit_checksum", detail: { who } });
  }
  return warnings;
};
var parseBoundPositiveNumber = (raw) => {
  if (raw === null) return null;
  const parsed = Number(raw.trim().replace(",", "."));
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

// helpers/validate-acceptance-identity.ts
var valid = { status: "valid", code: null };
var missing = { status: "missing", code: null };
var invalid = (code) => ({
  status: "invalid",
  code
});
var isNaturalPersonCuit = (cuit) => import_piramid_constants36.CUIT_NATURAL_PERSON_PREFIXES.some((prefix) => cuit.startsWith(prefix));
var identificationInCuit = (cuit) => isNaturalPersonCuit(cuit) ? cuit.slice(2, 2 + import_piramid_constants36.CUIT_IDENTIFICATION_LENGTH) : null;
var sameIdentification = (left, right) => left.padStart(import_piramid_constants36.CUIT_IDENTIFICATION_LENGTH, "0") === right.padStart(import_piramid_constants36.CUIT_IDENTIFICATION_LENGTH, "0");
var payeeDocumentOf = (candidate) => {
  if (!candidate.identification) return null;
  return candidate.identification_type === "cuit" || candidate.identification_type === "cuil" ? identificationInCuit(candidate.identification) : candidate.identification;
};
var cuitMatchesPerson = (cuit, candidate) => {
  if (!candidate.identification) return false;
  if (cuit === candidate.identification) return true;
  const declared = identificationInCuit(cuit);
  const document2 = payeeDocumentOf(candidate);
  return !!declared && !!document2 && sameIdentification(declared, document2);
};
var findByIdentification = (candidates, identification) => candidates.find((candidate) => {
  const document2 = payeeDocumentOf(candidate);
  return !!document2 && sameIdentification(document2, identification);
});
var isCollectingAttorney = (attorney) => isAttorneyInFact(attorney) && !!(attorney == null ? void 0 : attorney.cuit);
var matchAttorneyPayee = ({
  resolution,
  attorney,
  declared
}) => {
  if (!isCollectingAttorney(attorney)) {
    return { check: invalid("payee_unresolved"), matched: null };
  }
  if (!declared.cuit) return { check: missing, matched: null };
  const candidate = declared.identification ? findByIdentification(resolution.candidates, declared.identification) : null;
  if (declared.identification && !candidate) {
    return {
      check: invalid("payee_identification_not_a_candidate"),
      matched: null
    };
  }
  return declared.cuit === attorney.cuit ? { check: valid, matched: candidate ?? null } : { check: invalid("payee_cuit_not_attorney"), matched: null };
};
var matchAcceptancePayee = ({
  resolution,
  declared,
  payee = null,
  attorney = null
}) => {
  if (resolution.blocker) {
    return { check: invalid("payee_unresolved"), matched: null };
  }
  if (payee === "attorney_in_fact")
    return matchAttorneyPayee({ resolution, attorney, declared });
  if (!declared.cuit) return { check: missing, matched: null };
  if (!isValidCuit(declared.cuit)) {
    return { check: invalid("payee_cuit_invalid"), matched: null };
  }
  if (declared.identification) {
    const candidate = findByIdentification(
      resolution.candidates,
      declared.identification
    );
    if (!candidate) {
      return {
        check: invalid("payee_identification_not_a_candidate"),
        matched: null
      };
    }
    return cuitMatchesPerson(declared.cuit, candidate) ? { check: valid, matched: candidate } : {
      check: invalid("payee_cuit_does_not_match_identification"),
      matched: null
    };
  }
  const matched = resolution.candidates.find(
    (candidate) => cuitMatchesPerson(declared.cuit, candidate)
  );
  return matched ? { check: valid, matched } : { check: invalid("payee_cuit_not_a_candidate"), matched: null };
};
var matchAcceptanceLawyer = ({
  resolution,
  declaredCuit
}) => {
  if (!resolution.present) return valid;
  if (resolution.blocker) return invalid("lawyer_cuit_unavailable");
  if (!declaredCuit) return missing;
  return declaredCuit === resolution.cuit ? valid : invalid("lawyer_cuit_does_not_match");
};

// helpers/validate-claimant-victim-consistency.ts
var PROFESSIONAL_VICTIM_RELATIONSHIPS = [
  "attorney_in_fact",
  "attorney_representative"
];
var isProfessionalVictimRelationship = (relationship) => !!relationship && PROFESSIONAL_VICTIM_RELATIONSHIPS.includes(
  relationship
);
var CUIT_IDENTIFICATION_TYPES = [
  "cuit",
  "cuil"
];
var claimantVictimViolationCodes = [
  "claimant_identification_must_match_victim",
  "claimant_email_must_match_victim",
  "claimant_identification_must_differ_from_victim",
  "claimant_email_must_differ_from_victim",
  "victim_email_must_differ_from_owner",
  "claimant_identification_must_be_cuit"
];
var BLOCKING_CLAIMANT_VICTIM_VIOLATIONS = [
  // 'victim_email_must_differ_from_owner',
  "claimant_email_must_differ_from_victim"
];
var BLOCKING_OWNERSHIP_ACCEPTANCE_VIOLATIONS = [
  // 'victim_email_must_differ_from_owner',
  "claimant_email_must_differ_from_victim",
  "claimant_identification_must_match_victim"
];
var selectBlockingViolations = (violations, blocking = BLOCKING_CLAIMANT_VICTIM_VIOLATIONS) => blocking.filter((code) => violations.includes(code));
var consistencyIdentityOf = (party) => {
  if (party == null ? void 0 : party.natural_person) return party.natural_person;
  if (party == null ? void 0 : party.legal_person)
    return {
      identification_type: "cuit",
      identification_value: party.legal_person.cuit,
      email: party.legal_person.email
    };
  return null;
};
var isSameEmail = (left, right) => {
  const normalizedLeft = normalizeEmail(left);
  const normalizedRight = normalizeEmail(right);
  return !!normalizedLeft && !!normalizedRight && normalizedLeft === normalizedRight;
};
var documentOf = ({
  identification_type,
  identification_value
}) => {
  const digits = identification_value == null ? void 0 : identification_value.replace(/\D/g, "");
  if (!digits) return null;
  if (!identification_type || !CUIT_IDENTIFICATION_TYPES.includes(identification_type))
    return digits;
  return identificationInCuit(digits) ?? digits;
};
var sameDocument = (left, right) => left.padStart(import_piramid_constants37.CUIT_IDENTIFICATION_LENGTH, "0") === right.padStart(import_piramid_constants37.CUIT_IDENTIFICATION_LENGTH, "0");
var validateClaimantVictimConsistency = ({
  victimRelationship,
  claimant,
  victim,
  ownerEmail
}) => {
  if (!victimRelationship) return [];
  const violations = [];
  const claimantDocument = documentOf(claimant);
  const victimDocument = victim ? documentOf(victim) : null;
  const claimantEmail = normalizeEmail(claimant.email);
  const victimEmail = normalizeEmail(victim == null ? void 0 : victim.email);
  const comparableDocuments = !!claimantDocument && !!victimDocument;
  const comparableEmails = !!claimantEmail && !!victimEmail;
  if (victimRelationship === "own") {
    if (comparableDocuments && !sameDocument(claimantDocument, victimDocument))
      violations.push("claimant_identification_must_match_victim");
    if (comparableEmails && claimantEmail !== victimEmail)
      violations.push("claimant_email_must_match_victim");
    return violations;
  }
  if (comparableDocuments && sameDocument(claimantDocument, victimDocument))
    violations.push("claimant_identification_must_differ_from_victim");
  if (isSameEmail(claimantEmail, victimEmail))
    violations.push("claimant_email_must_differ_from_victim");
  if (isProfessionalVictimRelationship(victimRelationship) && !!claimant.identification_type && !CUIT_IDENTIFICATION_TYPES.includes(claimant.identification_type))
    violations.push("claimant_identification_must_be_cuit");
  return violations;
};

// contracts/ownership-transfer.contracts.ts
var digitsOf2 = (value) => value.replace(/\D/g, "");
var acceptOwnershipTransferRequestBody = victimRelationshipSchema.extend({
  identification: import_zod51.z.string().trim().nullish()
}).refine(requireVinculoOtherWhenRelationshipIsOther, vinculoOtherRefineParams).refine(
  (body) => !isProfessionalVictimRelationship(body.victim_relationship) || !!body.identification,
  {
    message: "Debe indicar el CUIT",
    path: ["identification"]
  }
).refine(
  (body) => !body.identification || isValidCuit(digitsOf2(body.identification)),
  {
    message: "El CUIT ingresado no es v\xE1lido",
    path: ["identification"]
  }
);

// contracts/offer.contract.ts
var import_database26 = __toESM(require_index_browser4());
var import_piramid_constants41 = __toESM(require_dist2());
var import_zod55 = require("zod");

// contracts/offer-terms.contract.ts
var import_piramid_constants40 = __toESM(require_dist2());
var import_zod54 = require("zod");

// contracts/agreement-subject.contract.ts
var import_database25 = __toESM(require_index_browser4());
var import_piramid_constants39 = __toESM(require_dist2());
var import_zod53 = require("zod");

// contracts/offer-acceptance.contract.ts
var import_piramid_constants38 = __toESM(require_dist2());
var import_zod52 = require("zod");
var offerAcceptanceFieldSchema = import_zod52.z.object({
  key: import_zod52.z.enum(import_piramid_constants38.offerAcceptanceFieldKeys),
  /** Lo que ve el reclamante; sale del binding de la compañía cuando el campo tiene concepto. */
  name: import_zod52.z.string().min(1),
  type: import_zod52.z.enum(import_piramid_constants38.offerAcceptanceFieldTypes),
  required: import_zod52.z.boolean()
});
var offerAcceptanceRequirementSchema = offerAcceptanceFieldSchema.extend({ guid: import_zod52.z.string().min(1) });
var offerAcceptanceRequirementsSchema = import_zod52.z.object({
  version: import_zod52.z.number().int().positive(),
  payment_method: import_zod52.z.enum(import_piramid_constants38.offerPaymentMethods),
  fields: import_zod52.z.array(offerAcceptanceRequirementSchema),
  /** v3. `null` (o ausente en v2) = sin elección: se valida como siempre. */
  payee: import_zod52.z.enum(import_piramid_constants38.offerPayees).nullable().default(null)
});

// contracts/agreement-subject.contract.ts
var nullableString = import_zod53.z.string().nullable();
var isoDate = import_zod53.z.string().datetime({ offset: true });
var agreementParentSchema = import_zod53.z.object({
  type: import_zod53.z.nativeEnum(import_database25.PersonParentTypes),
  first_name: import_zod53.z.string(),
  last_name: import_zod53.z.string(),
  full_name: import_zod53.z.string(),
  /** Sin tipo en el modelo: se imprime tal cual. */
  identification: import_zod53.z.string(),
  birth_date: isoDate.nullable()
});
var agreementPersonSchema = import_zod53.z.object({
  kind: import_zod53.z.enum(import_piramid_constants39.agreementPersonKinds),
  first_name: nullableString,
  last_name: nullableString,
  /** Persona jurídica: la razón social. */
  full_name: nullableString,
  /** Persona jurídica: siempre `cuit`. */
  identification_type: import_zod53.z.nativeEnum(import_database25.IdentificationTypes).nullable(),
  /** Solo personas jurídicas (hospital, ART, obra social, aseguradora). */
  legal_person_type: import_zod53.z.nativeEnum(import_database25.LegalPersonTypes).nullable(),
  identification: nullableString,
  email: nullableString,
  phone: nullableString,
  address_street: nullableString,
  address_number: nullableString,
  address_apartment: nullableString,
  /** Ya compuesto (calle, número, departamento o texto libre). */
  address: nullableString,
  city: nullableString,
  /** Código ISO-3166-2 en personas del reclamo; nombre libre en el asegurado. */
  state: nullableString,
  country: nullableString,
  zip_code: nullableString,
  birth_date: isoDate.nullable(),
  nationality: nullableString,
  sex: import_zod53.z.nativeEnum(import_database25.SexTypes).nullable(),
  marital_status: import_zod53.z.nativeEnum(import_database25.MaritalStatus).nullable(),
  parents: import_zod53.z.object({
    father: agreementParentSchema.nullable(),
    mother: agreementParentSchema.nullable()
  })
});
var agreementClaimantSchema = import_zod53.z.object({
  id: import_zod53.z.string(),
  role: import_zod53.z.nativeEnum(import_database25.ClaimantRoles),
  relationship: import_zod53.z.nativeEnum(import_database25.VictimRelationshipTypes).nullable(),
  relationship_other: nullableString,
  person: agreementPersonSchema
});
var agreementInsuredSchema = import_zod53.z.object({
  person_type: import_zod53.z.nativeEnum(import_database25.PersonType),
  first_name: nullableString,
  last_name: nullableString,
  full_name: nullableString,
  identification: nullableString,
  cuil: nullableString,
  address: nullableString,
  city: nullableString,
  /** Nombre de provincia (no código): no se traduce. */
  state: nullableString,
  zip_code: nullableString,
  license_plate: nullableString,
  make: nullableString,
  model: nullableString,
  year: nullableString,
  policy_number: nullableString
});
var agreementDriverSchema = import_zod53.z.object({
  first_name: nullableString,
  last_name: nullableString,
  full_name: nullableString,
  ownership: import_zod53.z.nativeEnum(import_database25.DriverOwnershipTypes)
});
var agreementVehicleSchema = import_zod53.z.object({
  make: nullableString,
  model: nullableString,
  version: nullableString,
  year: import_zod53.z.number().nullable(),
  license_plate: nullableString,
  category: import_zod53.z.nativeEnum(import_database25.VehicleCategoryTypes),
  type: import_zod53.z.nativeEnum(import_database25.VehicleTypes),
  use: import_zod53.z.nativeEnum(import_database25.VehicleUseTypes).nullable(),
  chassis: nullableString,
  engine: nullableString
});
var agreementRealPropertySchema = import_zod53.z.object({
  type: import_zod53.z.nativeEnum(import_database25.RealPropertyTypes),
  other_type: nullableString,
  ownership: import_zod53.z.nativeEnum(import_database25.RealPropertyOwnershipTypes),
  other_ownership: nullableString,
  address_street: nullableString,
  address_number: nullableString,
  address_apartment: nullableString,
  /** Ya compuesto (calle, número, departamento o texto libre). */
  address: nullableString,
  city: nullableString,
  /** Código ISO-3166-2. */
  state: nullableString,
  country: nullableString,
  zip_code: nullableString
});
var agreementInsuranceSchema = import_zod53.z.object({
  insurer: nullableString,
  policy_number: nullableString,
  coverage: import_zod53.z.nativeEnum(import_database25.CoverageTypes),
  other_coverage: nullableString
});
var agreementInjuryDetailSchema = import_zod53.z.object({
  damage: import_zod53.z.nativeEnum(import_database25.PersonDamageDetailTypes),
  severity: import_zod53.z.nativeEnum(import_database25.PersonDamageDetailSeverityTypes),
  /** Tokens crudos del JSON (`upper`, `lower`, `left`, `right`); se traducen al proyectar. */
  body_parts: import_zod53.z.array(import_zod53.z.string())
});
var agreementDamageSchema = import_zod53.z.object({
  /** Typeid ordenable por tiempo: decide cuál es el "primer" daño de cada tipo. */
  id: import_zod53.z.string(),
  type: import_zod53.z.nativeEnum(import_database25.DamageTypes),
  description: nullableString,
  fixed: import_zod53.z.boolean().nullable(),
  material: import_zod53.z.object({
    type: import_zod53.z.nativeEnum(import_database25.MaterialDamageTypes),
    vehicle: agreementVehicleSchema.nullable(),
    real_property: agreementRealPropertySchema.nullable(),
    insurance: agreementInsuranceSchema.nullable(),
    /** `MaterialDamage.driver`, o `Vehicle.driver` en las filas legacy que lo colgaban del vehículo. */
    driver: agreementDriverSchema.nullable()
  }).nullable(),
  person: import_zod53.z.object({
    type: import_zod53.z.nativeEnum(import_database25.PersonDamageTypes),
    victim_role: import_zod53.z.nativeEnum(import_database25.VictimRoleTypes).nullable(),
    surgery_description: nullableString,
    health_insurance_fund: nullableString,
    treatment_worker_compensation_insurer: nullableString,
    treatment_medical_institution: nullableString,
    policyholder_relationship: import_zod53.z.nativeEnum(import_database25.PolicyHolderRelationshipTypes).nullable(),
    policyholder_relationship_other: nullableString,
    /** En orden de creación (`id` ascendente). */
    details: import_zod53.z.array(agreementInjuryDetailSchema)
  }).nullable(),
  recovery: import_zod53.z.object({
    claimant_institution_relationship: import_zod53.z.nativeEnum(
      import_database25.ClaimantInstitutionRelationship
    ),
    /** Siempre una persona jurídica (hospital, ART, obra social). */
    institution: agreementPersonSchema
  }).nullable()
});
var agreementVariableDefinitionSchema = import_zod53.z.object({
  guid: import_zod53.z.string(),
  name: import_zod53.z.string(),
  normalized_name: import_zod53.z.string(),
  type: import_zod53.z.nativeEnum(import_database25.MessageTemplateVariableType),
  determination: import_zod53.z.nativeEnum(import_database25.VariableDetermination),
  required: import_zod53.z.boolean().nullable(),
  options: import_zod53.z.array(import_zod53.z.object({ guid: import_zod53.z.string(), name: import_zod53.z.string() })).nullable(),
  numeric_format: import_zod53.z.boolean().nullable(),
  numeric_format_currency: import_zod53.z.nativeEnum(import_database25.CurrencySymbol).nullable()
});
var agreementOfferKinds = ["persisted", "draft", "none"];
var agreementOfferTermsSchema = import_zod53.z.object({
  amount: import_zod53.z.number().positive(),
  /** 1 = pago único: nunca se imprime como "1 cuotas". */
  installments: import_zod53.z.number().int().min(1),
  /** null = sin honorarios. */
  fee_percentage: import_zod53.z.number().positive().nullable(),
  payment_days: import_zod53.z.number().int().min(1)
});
var agreementAcceptanceSources = [
  "persisted",
  "provided",
  "none"
];
var agreementExternalComplaintSources = ["claim", "sinister"];
var agreementClaimTypeDamageSchema = import_zod53.z.object({
  damage_type: import_zod53.z.nativeEnum(import_database25.DamageTypes),
  sub_damage_type: import_zod53.z.nativeEnum(import_database25.SubDamageTypes).nullable(),
  entity_damaged_category: import_zod53.z.nativeEnum(import_database25.EntityDamagedCategory).nullable()
});
var agreementClaimTypeSchema = import_zod53.z.object({
  id: import_zod53.z.string(),
  name: import_zod53.z.string(),
  damages: import_zod53.z.array(agreementClaimTypeDamageSchema)
});
var agreementSubjectSchema = import_zod53.z.object({
  company: import_zod53.z.object({
    id: import_zod53.z.string(),
    name: import_zod53.z.string(),
    tax_id: nullableString,
    country: import_zod53.z.string(),
    default_currency: import_zod53.z.nativeEnum(import_database25.CurrencySymbol).nullable()
  }),
  claim: import_zod53.z.object({
    id: import_zod53.z.string(),
    ref_id: nullableString,
    external_claim_id: nullableString,
    /** Added after the freeze shipped: a snapshot from before reads as null. */
    external_claim_request_id: nullableString.default(null),
    external_policyholder_number: nullableString,
    policyholder_license_plate: nullableString,
    policyholder_policy_number: nullableString,
    claim_type_id: nullableString,
    claim_type: agreementClaimTypeSchema.nullable(),
    /** Added after the freeze shipped: a snapshot from before reads as null. */
    team_id: nullableString.default(null),
    /** The active `responsible` handler; added after the freeze shipped, like `team_id`. */
    responsible_user_id: nullableString.default(null),
    created_at: isoDate
  }),
  /** Solo contacto: el owner no es una parte del documento. */
  owner: import_zod53.z.object({ email: import_zod53.z.string() }),
  victim: agreementPersonSchema,
  /** En orden de creación (`id` ascendente). */
  claimants: import_zod53.z.array(agreementClaimantSchema),
  occurrence: import_zod53.z.object({
    address: nullableString,
    city: nullableString,
    state: nullableString,
    country: nullableString,
    zip_code: nullableString,
    sinister_date: isoDate.nullable()
  }),
  sinister: import_zod53.z.object({
    date: isoDate.nullable(),
    policyholder_license_plate: nullableString,
    policyholder_policy_number: nullableString,
    /** Denuncias del siniestro con asegurado: cuántas había para elegir. */
    external_complaint_candidates: import_zod53.z.number().int().min(0)
  }),
  external_complaint: import_zod53.z.object({
    external_id: import_zod53.z.string(),
    occurrence_date: isoDate.nullable(),
    policyholder: agreementInsuredSchema.nullable(),
    source: import_zod53.z.enum(agreementExternalComplaintSources)
  }).nullable(),
  damages: import_zod53.z.array(agreementDamageSchema),
  offer: import_zod53.z.object({
    kind: import_zod53.z.enum(agreementOfferKinds),
    id: nullableString,
    status: import_zod53.z.nativeEnum(import_database25.OfferStatus).nullable(),
    message_template_id: nullableString,
    /** Decimal serializado; los cálculos lo convierten una sola vez. */
    amount: nullableString,
    /** Columnas tipadas del ofrecimiento guiado; null en los legacy (los términos salen de los bindings). */
    terms: agreementOfferTermsSchema.nullable(),
    /** El motivo que lee el reclamante (`Offer.public_offered_reason`); opcional por naturaleza. */
    public_reason: nullableString,
    /**
     * Qué datos se le piden al reclamante, declarados por el propio
     * ofrecimiento. Null en los legacy, donde el formulario salió de una
     * `MessageTemplate`: su presencia es la marca del modelo nuevo.
     */
    acceptance_requirements: offerAcceptanceRequirementsSchema.nullable(),
    created_at: isoDate.nullable(),
    accepted_at: isoDate.nullable(),
    definitions: import_zod53.z.array(agreementVariableDefinitionSchema),
    conditions: import_zod53.z.array(
      import_zod53.z.object({
        variable: import_zod53.z.string(),
        operator: import_zod53.z.string(),
        value: import_zod53.z.string(),
        target: import_zod53.z.string()
      })
    ),
    /**
     * Clave = guid de la definición; valor = string crudo tal como se persiste.
     * El guid es la identidad del valor dentro de la oferta: dos variables cuyos
     * nombres normalizan igual seguirían siendo dos valores distintos.
     */
    values: import_zod53.z.object({
      compile_time: import_zod53.z.record(import_zod53.z.string()),
      runtime: import_zod53.z.record(import_zod53.z.string())
    }),
    /** Variables `file`: guid → stored_name (nunca se imprimen). */
    files: import_zod53.z.record(import_zod53.z.string())
  }),
  acceptance: import_zod53.z.object({
    source: import_zod53.z.enum(agreementAcceptanceSources),
    /** Guids de las runtime ocultas por las condiciones (p. ej. bancarias con "Cheque"). */
    hidden_guids: import_zod53.z.array(import_zod53.z.string())
  })
});
var agreementClaimSubjectSchema = agreementSubjectSchema.omit({
  offer: true,
  acceptance: true
});

// contracts/offer-terms.contract.ts
var offerTermsSchema = agreementOfferTermsSchema.extend({
  amount: import_zod54.z.number().positive().max(import_piramid_constants40.MAX_CLAIM_ESTIMATE_AMOUNT),
  /** Quién cobra; solo se elige con abogado apoderado y validación de cobrador. */
  payee: import_zod54.z.enum(import_piramid_constants40.offerPayees).nullable().default(null)
});
var optionList = import_zod54.z.array(import_zod54.z.number().positive()).min(1);
var offerTermsOptionsSchema = import_zod54.z.object({
  installment_options: import_zod54.z.array(import_zod54.z.number().int().positive()).min(1),
  fee_percentage_options: optionList,
  payment_days_options: import_zod54.z.array(import_zod54.z.number().int().positive()).min(1)
});
var companyOfferTermsOptionsSchema = offerTermsOptionsSchema.partial();
var offerTermsIssues = [
  "installments_not_allowed",
  "payment_days_not_allowed",
  "fee_percentage_not_allowed",
  /** El reclamo tiene abogado: hay que elegir un porcentaje. */
  "fee_percentage_required",
  /** El reclamo no tiene abogado: no puede llevar honorarios. */
  "fee_percentage_not_applicable",
  /** El reclamo tiene apoderado y la compañía valida al cobrador: hay que decir quién cobra. */
  "payee_required",
  /** Sin apoderado o sin validación de cobrador no hay nada que elegir. */
  "payee_not_applicable"
];

// contracts/offer.contract.ts
var offerExpiresAt = import_zod55.z.coerce.date({
  invalid_type_error: import_piramid_constants41.requiredFieldMessage,
  required_error: import_piramid_constants41.requiredFieldMessage
}).min(/* @__PURE__ */ new Date(), "La fecha debe ser mayor a hoy").optional();
var offerReason = import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres");
var offerPublicReason = import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres").optional();
var legacyCreateOfferRequestBody = import_zod55.z.object({
  mode: import_zod55.z.literal("legacy").optional(),
  // Optional since the simulator wizard dropped the field: the API derives
  // "Ofrecimiento N°<ronda>" when absent. Legacy clients still send it.
  name: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres").optional(),
  message_template_id: import_zod55.z.coerce.string(),
  variables: import_zod55.z.record(import_zod55.z.string(), import_zod55.z.any()),
  expires_at: offerExpiresAt,
  reason: offerReason,
  public_reason: offerPublicReason
});
var guidedCreateOfferRequestBody = import_zod55.z.object({
  mode: import_zod55.z.literal("guided"),
  terms: offerTermsSchema,
  fingerprint: import_zod55.z.string().min(1),
  agreement_reviewed: import_zod55.z.boolean().default(false),
  expires_at: offerExpiresAt,
  reason: offerReason,
  public_reason: offerPublicReason
});
var createOfferRequestBody = import_zod55.z.union([
  guidedCreateOfferRequestBody,
  legacyCreateOfferRequestBody
]);
var cancelOfferRequestBody = import_zod55.z.object({
  /** Internal reason: activity/audit only, never shown to the third party. */
  reason: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres"),
  /** Optional message for the third party; a neutral default replaces it. */
  public_reason: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres").optional()
});
var uploadManualAgreementDocumentRequestBody = import_zod55.z.object({
  token: import_zod55.z.string().min(1),
  replaces_file_id: import_zod55.z.string().min(1).nullable()
});
var rejectOfferRequestBody = import_zod55.z.object({
  reason: import_zod55.z.string({
    invalid_type_error: import_piramid_constants41.requiredFieldMessage,
    required_error: import_piramid_constants41.requiredFieldMessage
  }).min(1, import_piramid_constants41.requiredFieldMessage).max(500, "M\xE1ximo 500 caracteres"),
  third_party_user_requested_amount: import_zod55.z.coerce.number().nullish()
});
var retrieveOfferRequestQuery = import_zod55.z.object({
  token: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage)
});
var retrieveOfferRequestParams = import_zod55.z.object({
  offerId: import_zod55.z.coerce.string()
});
var createOfferAgreementRequestBody = import_zod55.z.object({
  name: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage).max(255, import_piramid_constants41.requiredFieldMessage),
  integration_template_id: import_zod55.z.coerce.string(),
  provider_type: import_zod55.z.nativeEnum(import_database26.OfferAgreementProvider),
  fields: import_zod55.z.array(
    import_zod55.z.object({
      provider_id: import_zod55.z.string().min(1, import_piramid_constants41.requiredFieldMessage),
      value: import_zod55.z.any()
    })
  ).default([])
});
var listProviderTemplatesRequestParams = import_zod55.z.object({
  providerType: import_zod55.z.nativeEnum(import_database26.OfferAgreementProvider)
});
var listProviderTemplatesRequestQuery = import_zod55.z.object({
  search: import_zod55.z.string().nullish()
});
var retrieveOfferAgreementRequestParams = import_zod55.z.object({
  agreementId: import_zod55.z.coerce.string().min(1)
});
var retrieveOfferAgreementRequestQuery = import_zod55.z.object({
  token: import_zod55.z.string().min(1)
});
var acceptOfferRequestBody = import_zod55.z.object({
  variables: import_zod55.z.record(import_zod55.z.string(), import_zod55.z.any()).default({})
});
var embeddedSigningStatusRequestBody = import_zod55.z.object({
  secret: import_zod55.z.string().min(1)
});
var validateInterbankingRequestQuery = import_zod55.z.object({
  cbu: import_zod55.z.string().min(1),
  cuit: import_zod55.z.string().min(1)
});
var listClaimantPendingActionsRequestQuery = import_zod55.z.object({
  claim_id: import_zod55.z.string().min(1).optional()
});

// contracts/negotiation.contract.ts
var claimNegotiationPretensionSources = [
  "rejection_counter_offer",
  "claimed_amount"
];
var claimNegotiationEscalationStages = [
  "mediation",
  "judgment"
];

// contracts/detail.contract.ts
var import_zod56 = require("zod");
var fetchResourceDetailRequestParams = import_zod56.z.object({
  id: import_zod56.z.coerce.string()
});

// contracts/alert.contract.ts
var import_database27 = __toESM(require_index_browser4());
var import_piramid_constants42 = __toESM(require_dist2());
var import_zod57 = require("zod");
var alertTypesWithProgressTrigger = [
  "sla_objective_progress",
  "sla_total_progress"
];
var patchAlertSubscriptionsRequestBody = import_zod57.z.object({
  alerts: import_zod57.z.array(
    import_zod57.z.object({
      alert_id: import_zod57.z.coerce.string(),
      active: import_zod57.z.boolean().optional(),
      type: import_zod57.z.nativeEnum(import_database27.Alerts),
      interval_hours: import_zod57.z.coerce.number().min(1, "M\xEDnimo 1 hora").default(1),
      progress_trigger: import_zod57.z.coerce.number().min(1, "M\xEDnimo 1 porcentaje").max(100, "M\xE1ximo 100 porcentaje").nullish()
    }).refine(
      (data) => {
        if (!alertTypesWithProgressTrigger.includes(data.type)) return true;
        return !!data.progress_trigger;
      },
      {
        message: import_piramid_constants42.requiredFieldMessage,
        path: ["progress_trigger"]
      }
    )
  )
});
var listAlertsRequestQuery = import_zod57.z.object({
  scope: import_zod57.z.nativeEnum(import_database27.AlertScope)
});

// contracts/dataset.contracts.ts
var import_zod58 = require("zod");
var import_piramid_constants43 = __toESM(require_dist2());
var searchVehicleRequestQuery = import_zod58.z.object({
  search: import_zod58.z.string().min(1),
  entity: import_zod58.z.enum(import_piramid_constants43.withLicensePlateVehicleTypes),
  page: import_zod58.z.coerce.number().min(1).default(1)
});
var searchEntityRequestQuery = import_zod58.z.object({
  search: import_zod58.z.string().nullish(),
  entity: import_zod58.z.enum(import_piramid_constants43.searchableEntities),
  withPagination: import_zod58.z.enum(["true", "false"]).transform((val) => val === "true").default("true").nullish()
});
var searchDatasetRequestQuery = import_zod58.z.object({
  search: import_zod58.z.string().or(import_zod58.z.literal("")).default(""),
  limit: import_zod58.z.coerce.number().max(20).default(10)
});

// contracts/event.contracts.ts
var import_database28 = __toESM(require_index_browser4());
var import_piramid_constants44 = __toESM(require_dist2());
var import_zod59 = require("zod");
var createEventRequestParams = import_zod59.z.object({
  endpoint: import_zod59.z.string().optional()
});
var claimEstimatesProps = [
  "administrative_amount",
  "material_judicial_amount",
  "person_judicial_amount",
  "material_administrative_amount",
  "person_administrative_amount",
  "percentage_of_liability"
];
var claimEstimateEventProps = [
  ...claimEstimatesProps,
  "person_percentage_of_judicial_risk"
];
var judicialEstimatesProps = [
  "material_judicial_amount",
  "person_judicial_amount"
];
var assignmentReason = import_zod59.z.enum([
  "delegated_by_inactivity",
  // The member handed their own claims over from their settings.
  "delegated_by_owner",
  "delegated_claim_restored",
  "substituted_by_inactivity",
  "derivation_reassigned",
  "team_reassigned"
]);
var orderTransitionEventMetadata = import_zod59.z.object({
  company_id: import_zod59.z.coerce.string(),
  resource_type: import_zod59.z.enum(["claim", "complaint"]),
  sinister_id: import_zod59.z.coerce.string(),
  claim_id: import_zod59.z.coerce.string().nullish(),
  complaint_id: import_zod59.z.coerce.string().nullish(),
  order_name: import_zod59.z.string(),
  order_id: import_zod59.z.coerce.string(),
  // The order's human-facing reference (e.g. "ORD-12"). Carried on every order
  // event because the same event surfaces in the claim activity, where a claim
  // can hold many orders. Optional so pre-existing events still parse.
  order_ref_id: import_zod59.z.coerce.string().nullish(),
  // Reason for order-level rejects / cancels (order_rejected / order_canceled).
  reason: import_zod59.z.string().nullish()
});
var orderReviewEventMetadata = orderTransitionEventMetadata.extend({
  version: import_zod59.z.coerce.number(),
  order_report_id: import_zod59.z.coerce.string().nullish(),
  order_invoice_id: import_zod59.z.coerce.string().nullish(),
  reason: import_zod59.z.string().nullish(),
  // Original name of the deliverable's file, for the activity badge. Nullish for
  // events created before it was tracked.
  file_original_name: import_zod59.z.coerce.string().nullish()
});
var orderSchedulingEventMetadata = orderTransitionEventMetadata.extend(
  {
    // Not `coerce`: it must FAIL on another order event's metadata, because
    // `String(undefined)` is the valid string "undefined" and would pass.
    scheduled_for: import_zod59.z.string(),
    previous_scheduled_for: import_zod59.z.coerce.string().nullish(),
    // Either side can schedule, so the notification audience is derived from this
    // (same criterion as `published_by_user_type` on order_updates_published).
    scheduled_by_user_type: import_zod59.z.string(),
    // Branch the claimant was sent to, frozen so the activity feed reads the
    // place without joining a branch that may since have been renamed or
    // deleted. Nullish: events emitted before branches were part of the
    // coordination have none, and they must keep parsing.
    scheduled_branch_name: import_zod59.z.coerce.string().nullish()
  }
);
var orderScheduleCanceledEventMetadata = orderTransitionEventMetadata.extend({
  // The appointment that stops holding. Required: there is nothing to void
  // otherwise.
  previous_scheduled_for: import_zod59.z.string(),
  // Either side can void, so the notification audience is derived from this.
  canceled_by_user_type: import_zod59.z.string()
});
var orderWorkProofEventMetadata = orderTransitionEventMetadata.extend({
  autoinspector_inspection_id: import_zod59.z.coerce.string(),
  // Resultado crudo de Autoinspector (disapproved | error) para distinguir el
  // motivo en la actividad. Solo lo lleva order_work_proof_disapproved.
  result: import_zod59.z.string().nullish()
});
var orderRequiredDocumentEventMetadata = orderTransitionEventMetadata.extend({
  required_document_id: import_zod59.z.coerce.string(),
  document_name: import_zod59.z.string(),
  version: import_zod59.z.coerce.number(),
  file_original_name: import_zod59.z.coerce.string().nullish(),
  uploader: import_zod59.z.enum(["insurer", "provider"]).nullish()
});
var sinisterExternalStatusUpdatedEventMetadata = import_zod59.z.object({
  sinister_id: import_zod59.z.coerce.string(),
  external_status: import_zod59.z.string(),
  previous_status: import_zod59.z.string(),
  external_complaint_id: import_zod59.z.string().nullish()
});
var claimClosedByInsurerSystemEventMetadata = import_zod59.z.object({
  company_id: import_zod59.z.coerce.string(),
  claim_id: import_zod59.z.coerce.string(),
  ref_id: import_zod59.z.coerce.string().nullish(),
  sinister_id: import_zod59.z.coerce.string(),
  external_claim_id: import_zod59.z.string(),
  new_status_name: import_zod59.z.string(),
  previous_status_name: import_zod59.z.string(),
  ingest_event_id: import_zod59.z.coerce.string()
});
var affectedUserEventMetadata = import_zod59.z.object({
  user_id: import_zod59.z.coerce.string(),
  user_email: import_zod59.z.string(),
  user_first_name: import_zod59.z.string().nullable(),
  user_last_name: import_zod59.z.string().nullable()
});
var userAssignmentsEventMetadata = affectedUserEventMetadata.extend({
  // Absent when someone used the switch.
  reason: import_zod59.z.enum(import_piramid_constants44.userAssignmentsResumeReasons).optional()
});
var userInactivityEndedEventMetadata = affectedUserEventMetadata.extend({
  // The claims they delegated that others still held on their return. Absent
  // on returns recorded before it was counted.
  delegated_claim_count: import_zod59.z.number().optional()
});
var userInactivityStartedEventMetadata = affectedUserEventMetadata.extend({
  // Null when the inactivity has no scheduled return.
  returns_at: import_zod59.z.string().datetime().nullable()
});
var teamDelegationSummary = import_zod59.z.object({
  delegated_count: import_zod59.z.number(),
  recipient_count: import_zod59.z.number(),
  returned_count: import_zod59.z.number(),
  kept_count: import_zod59.z.number().optional()
});
var userInactivityScheduledEventMetadata = affectedUserEventMetadata.extend({
  starts_at: import_zod59.z.string().datetime(),
  returns_at: import_zod59.z.string().datetime(),
  reason: import_zod59.z.enum(import_piramid_constants44.inactivityReasons),
  claims_delegated: import_zod59.z.boolean(),
  // How the claims were to be delegated when it was scheduled.
  delegation: teamDelegationSummary.optional()
});
var userInactivityClaimsDelegatedEventMetadata = affectedUserEventMetadata.extend({
  trigger: import_zod59.z.enum(import_piramid_constants44.teamDelegationTriggers),
  delegation: teamDelegationSummary,
  // Absent on delegations recorded before they were listed.
  delegated_claim_ids: import_zod59.z.array(import_zod59.z.string()).optional()
});
var userInactivityDelegationUpdatedEventMetadata = affectedUserEventMetadata.extend({
  delegation: teamDelegationSummary
});
var userInactivityRescheduledEventMetadata = affectedUserEventMetadata.extend({
  previous_starts_at: import_zod59.z.string().datetime(),
  previous_returns_at: import_zod59.z.string().datetime(),
  previous_reason: import_zod59.z.enum(import_piramid_constants44.inactivityReasons).nullable(),
  starts_at: import_zod59.z.string().datetime(),
  returns_at: import_zod59.z.string().datetime(),
  reason: import_zod59.z.enum(import_piramid_constants44.inactivityReasons).nullable()
});
var userInactivityReturnChangedEventMetadata = affectedUserEventMetadata.extend({
  // Null when the running inactivity had no scheduled return.
  previous_returns_at: import_zod59.z.string().datetime().nullable(),
  returns_at: import_zod59.z.string().datetime()
});
var userInactivityCancelledEventMetadata = affectedUserEventMetadata.extend({
  starts_at: import_zod59.z.string().datetime(),
  returns_at: import_zod59.z.string().datetime(),
  reason: import_zod59.z.enum(import_piramid_constants44.inactivityReasons).nullable()
});
var teamClaimsReassignedEventMetadata = import_zod59.z.object({
  team_id: import_zod59.z.coerce.string(),
  team_name: import_zod59.z.string(),
  from_user_id: import_zod59.z.coerce.string(),
  from_user_email: import_zod59.z.string(),
  from_user_first_name: import_zod59.z.string().nullable(),
  from_user_last_name: import_zod59.z.string().nullable(),
  to_user_id: import_zod59.z.coerce.string(),
  to_user_email: import_zod59.z.string(),
  to_user_first_name: import_zod59.z.string().nullable(),
  to_user_last_name: import_zod59.z.string().nullable(),
  claim_ids: import_zod59.z.array(import_zod59.z.string())
});
var teamClaimsDelegatedEventMetadata = teamClaimsReassignedEventMetadata.extend({
  trigger: import_zod59.z.enum(import_piramid_constants44.teamDelegationTriggers).optional()
});
var teamClaimsRecoveredEventMetadata = teamClaimsReassignedEventMetadata;
var userDelegatedClaimsRecoveredEventMetadata = affectedUserEventMetadata.extend({
  claim_ids: import_zod59.z.array(import_zod59.z.string()),
  holders: import_zod59.z.array(
    import_zod59.z.object({ claim_id: import_zod59.z.string(), holder: affectedUserEventMetadata })
  ).optional()
});
var userDelegatedClaimsReturnedEventMetadata = affectedUserEventMetadata.extend({
  returned_claim_ids: import_zod59.z.array(import_zod59.z.string()),
  redelegated_claim_ids: import_zod59.z.array(import_zod59.z.string()),
  // Who took each claim and whose it is. Absent on returns recorded before.
  returns: import_zod59.z.array(
    import_zod59.z.object({
      claim_id: import_zod59.z.string(),
      to: affectedUserEventMetadata,
      owner: affectedUserEventMetadata
    })
  ).optional()
});
var userDerivedClaimsReturnedEventMetadata = affectedUserEventMetadata.extend({
  returns: import_zod59.z.array(
    import_zod59.z.object({
      claim_id: import_zod59.z.string(),
      to_user_id: import_zod59.z.coerce.string(),
      to_user_email: import_zod59.z.string(),
      to_user_first_name: import_zod59.z.string().nullable(),
      to_user_last_name: import_zod59.z.string().nullable(),
      to_team_id: import_zod59.z.string().nullable(),
      to_team_name: import_zod59.z.string().nullable()
    })
  )
});
var userDerivedClaimsRecoveredEventMetadata = affectedUserEventMetadata.extend({
  claim_ids: import_zod59.z.array(import_zod59.z.string()),
  reason: import_zod59.z.string()
});
var loginProvider = import_zod59.z.union([
  import_zod59.z.literal("password"),
  import_zod59.z.nativeEnum(import_database28.IdentityProviderType)
]);
var eventRequestBody = import_zod59.z.discriminatedUnion("type", [
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_external_status_updated"),
    metadata: sinisterExternalStatusUpdatedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("alert_sla_objective_progress"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      resource_id: import_zod59.z.coerce.string(),
      resource_ref_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      sla_objective_instance_id: import_zod59.z.coerce.string(),
      alert_id: import_zod59.z.coerce.string(),
      alert_subscription_id: import_zod59.z.coerce.string(),
      alert_name: import_zod59.z.string(),
      sla_objective_progress: import_zod59.z.coerce.number(),
      sla_objective_reference_name: import_zod59.z.string(),
      sla_objective_reference_type: import_zod59.z.string(),
      sla_objective_id: import_zod59.z.coerce.string(),
      sla_name: import_zod59.z.string(),
      sla_id: import_zod59.z.coerce.string(),
      sla_objective_instance_time_to_resolution_type: import_zod59.z.nativeEnum(import_database28.DurationType),
      sla_objective_instance_time_to_resolution_value: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("alert_sla_total_progress"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      resource_id: import_zod59.z.coerce.string(),
      resource_ref_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      alert_id: import_zod59.z.coerce.string(),
      alert_name: import_zod59.z.string(),
      alert_subscription_id: import_zod59.z.coerce.string(),
      sla_name: import_zod59.z.string(),
      sla_total_progress: import_zod59.z.coerce.number(),
      sla_instance_id: import_zod59.z.coerce.string(),
      sla_id: import_zod59.z.coerce.string(),
      sla_instance_time_to_resolution_type: import_zod59.z.nativeEnum(import_database28.DurationType),
      sla_instance_time_to_resolution_value: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_created"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      vendor_contact_name: import_zod59.z.string(),
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_accepted"),
    metadata: orderTransitionEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_rejected"),
    metadata: orderTransitionEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_canceled"),
    metadata: orderTransitionEventMetadata
  }),
  // F1.4.4 — order finalize / reopen (driven by invoice accept / undo).
  import_zod59.z.object({
    type: import_zod59.z.literal("order_completed"),
    metadata: orderTransitionEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_reopened"),
    metadata: orderTransitionEventMetadata
  }),
  // order_scheduling — first schedule and every later change.
  import_zod59.z.object({
    type: import_zod59.z.literal("order_scheduled"),
    metadata: orderSchedulingEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_rescheduled"),
    metadata: orderSchedulingEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_schedule_canceled"),
    metadata: orderScheduleCanceledEventMetadata
  }),
  // F1.4.4 — deliverable review events (report undo; invoice accept/reject/undo).
  import_zod59.z.object({
    type: import_zod59.z.literal("order_report_reset"),
    metadata: orderReviewEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_invoice_accepted"),
    metadata: orderReviewEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_invoice_rejected"),
    metadata: orderReviewEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_invoice_reset"),
    metadata: orderReviewEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_report_created"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      order_report_id: import_zod59.z.coerce.string(),
      file_original_name: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_report_accepted"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      order_report_id: import_zod59.z.coerce.string(),
      file_original_name: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_report_rejected"),
    metadata: import_zod59.z.object({
      reason: import_zod59.z.string().min(1),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      order_report_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      file_original_name: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_updates_published"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      message: import_zod59.z.string(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      update_note_id: import_zod59.z.coerce.string(),
      // F1.4.4-followup — who authored the novedad (provider | insurer). Drives
      // the notification direction (provider→insurer live; insurer→provider
      // in-app in F1.4.5). Optional for backwards-compat with older events.
      published_by_user_type: import_zod59.z.string().nullish(),
      // Number of files attached to the novedad (0 = none). Nullish for events
      // created before it was tracked.
      files_count: import_zod59.z.coerce.number().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_updates_requested"),
    metadata: import_zod59.z.object({
      message: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      requested_by_user_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      files_count: import_zod59.z.coerce.number().nullish()
    })
  }),
  // F2.4 — carga manual de documentación a la orden (cualquiera de los dos
  // lados). Las novedades con adjuntos NO emiten este evento (emiten
  // order_updates_published).
  import_zod59.z.object({
    type: import_zod59.z.literal("order_document_uploaded"),
    metadata: import_zod59.z.object({
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      // Lado que subió: 'insurer' | 'provider' (define la sección de Documentación).
      uploader: import_zod59.z.enum(["insurer", "provider"]),
      // Cuántos archivos se subieron en esta acción y sus nombres, para el badge
      // de Actividad.
      files_count: import_zod59.z.coerce.number(),
      file_names: import_zod59.z.array(import_zod59.z.string()).nullish(),
      // order_document_import — 'imported' means it was linked by reference from
      // the record. `nullish` so events written before this field still parse.
      source: import_zod59.z.enum(["uploaded", "imported"]).nullish()
    })
  }),
  // order_document_import — the insurer removed one of its own documents from the
  // order (logical delete). Activity only: it never fans out.
  import_zod59.z.object({
    type: import_zod59.z.literal("order_document_removed"),
    metadata: import_zod59.z.object({
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      uploader: import_zod59.z.enum(["insurer", "provider"]),
      source: import_zod59.z.enum(["uploaded", "imported"]),
      file_names: import_zod59.z.array(import_zod59.z.string()).nullish()
    })
  }),
  // order_required_docs — versioned uploads against a snapshotted requirement +
  // their review cycle (reset is activity-only).
  import_zod59.z.object({
    type: import_zod59.z.literal("order_required_document_uploaded"),
    metadata: orderRequiredDocumentEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_required_document_accepted"),
    metadata: orderRequiredDocumentEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_required_document_rejected"),
    metadata: orderRequiredDocumentEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_required_document_reset"),
    metadata: orderRequiredDocumentEventMetadata
  }),
  // order_work_proof — prueba de trabajo Autoinspector.
  import_zod59.z.object({
    type: import_zod59.z.literal("order_work_proof_created"),
    metadata: orderWorkProofEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_work_proof_approved"),
    metadata: orderWorkProofEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_work_proof_disapproved"),
    metadata: orderWorkProofEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_work_proof_blocked"),
    metadata: orderWorkProofEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("order_invoice_uploaded"),
    metadata: import_zod59.z.object({
      rfp_name: import_zod59.z.string().nullish(),
      rfp_id: import_zod59.z.coerce.string().nullish(),
      vendor_contact_name: import_zod59.z.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      order_invoice_id: import_zod59.z.coerce.string(),
      invoice_original_name: import_zod59.z.string(),
      // Uniform alias for the activity badge (matches the report events).
      file_original_name: import_zod59.z.coerce.string().nullish(),
      order_name: import_zod59.z.string(),
      order_id: import_zod59.z.coerce.string(),
      order_ref_id: import_zod59.z.coerce.string().nullish(),
      // Deliverable version. Nullish for events created before it was tracked.
      version: import_zod59.z.coerce.number().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_authorized"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      authorized_by_user_id: import_zod59.z.coerce.string(),
      authorized_by_user_email: import_zod59.z.string().min(1),
      authorized_by_user_first_name: import_zod59.z.string().min(1),
      authorized_by_user_last_name: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_estimates_updated"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      affected_coverage_id: import_zod59.z.coerce.string(),
      affected_coverage_name: import_zod59.z.string().min(1),
      total: import_zod59.z.coerce.number(),
      operands: import_zod59.z.array(
        import_zod59.z.object({
          name: import_zod59.z.string().min(1),
          value: import_zod59.z.coerce.string()
        })
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_rejected"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      rejected_by_user_id: import_zod59.z.coerce.string(),
      rejected_by_user_email: import_zod59.z.string().min(1),
      rejected_by_user_first_name: import_zod59.z.string().min(1),
      rejected_by_user_last_name: import_zod59.z.string().min(1),
      rejected_reason: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_approved"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      approved_by_user_id: import_zod59.z.coerce.string(),
      approved_by_user_email: import_zod59.z.string().min(1),
      approved_by_user_first_name: import_zod59.z.string().min(1),
      approved_by_user_last_name: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_rejected"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      external_complaint_id: import_zod59.z.string().min(1),
      reason: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_approved"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      external_complaint_id: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_authorized"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      external_complaint_id: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_created"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      sinister_cause_name: import_zod59.z.string().min(1),
      external_complaint_id: import_zod59.z.string().min(1),
      external_policy_number: import_zod59.z.string().min(1),
      coverages: import_zod59.z.array(import_zod59.z.string())
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_estimates_updated"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      updated_by_name: import_zod59.z.string(),
      updated_by_email: import_zod59.z.string(),
      claim_estimates_property: import_zod59.z.enum(claimEstimateEventProps),
      old_value: import_zod59.z.string().nullish(),
      new_value: import_zod59.z.string().nullish(),
      reason: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_search"),
    metadata: import_zod59.z.object({
      query: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_list_view"),
    metadata: import_zod59.z.object({
      query: import_zod59.z.string().optional(),
      page: import_zod59.z.coerce.number(),
      size: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_claims_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_expert_appraisals_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal(
      "sinister_fraud_investigation_cases_view"
    ),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_complaints_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_claim_detail_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("file_view"),
    metadata: import_zod59.z.object({
      original_name: import_zod59.z.string(),
      file_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_activity_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_activity_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_documentation_list_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_documentation_list_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_rejected"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_number: import_zod59.z.string().nullish(),
      reason: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string(),
      third_party_user_requested_amount: import_zod59.z.coerce.number().nullish(),
      // A company user recorded the claimant's rejection (`triggered_by` is
      // that user). Absent = the claimant rejected it themselves.
      on_behalf_of_claimant: import_zod59.z.literal(true).optional()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_canceled"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_number: import_zod59.z.string().nullish(),
      // Internal reason. listEvents replaces it with public_reason (or the
      // neutral default) before serving third users — historical events too.
      reason: import_zod59.z.string(),
      public_reason: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_expired"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_id: import_zod59.z.coerce.string(),
      expiration_date: import_zod59.z.string(),
      variable_values: import_zod59.z.array(
        import_zod59.z.object({
          name: import_zod59.z.string(),
          value: import_zod59.z.string()
        })
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_offer_agreement_response"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_created_at: import_zod59.z.coerce.date(),
      company_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_offer_response"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_name: import_zod59.z.string().min(1),
      offer_created_at: import_zod59.z.coerce.date()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal(
      "pending_offer_agreement_response_internal"
    ),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_created_at: import_zod59.z.coerce.date(),
      company_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_selected"),
    metadata: import_zod59.z.object({
      claims: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          ref_id: import_zod59.z.string().nullish()
        })
      ),
      sinister_id: import_zod59.z.coerce.string(),
      external_complaint_id: import_zod59.z.coerce.string(),
      external_complaint_external_id: import_zod59.z.string().min(1),
      selected_by_user_id: import_zod59.z.coerce.string(),
      selected_by_user_email: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_sinister_changed"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.string().nullish(),
      from_sinister_id: import_zod59.z.coerce.string(),
      to_sinister_id: import_zod59.z.coerce.string(),
      external_complaint_external_id: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("external_complaint_selection_failed"),
    metadata: import_zod59.z.object({
      claims: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          ref_id: import_zod59.z.string().nullish()
        })
      ),
      sinister_id: import_zod59.z.coerce.string(),
      external_complaint_id: import_zod59.z.coerce.string(),
      external_complaint_external_id: import_zod59.z.string().min(1),
      selected_by_user_id: import_zod59.z.coerce.string(),
      selected_by_user_email: import_zod59.z.string().min(1),
      reason: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_complaint_created"),
    metadata: import_zod59.z.object({
      claims: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          ref_id: import_zod59.z.string().nullish()
        })
      ),
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_complaint_requested"),
    metadata: import_zod59.z.object({
      claims: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          ref_id: import_zod59.z.string().nullish()
        })
      ),
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_complaint_creation_failed"),
    metadata: import_zod59.z.object({
      claims: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          ref_id: import_zod59.z.string().nullish()
        })
      ),
      reason: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_updated"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      diff: import_zod59.z.array(
        import_zod59.z.union([
          import_zod59.z.object({
            type: import_zod59.z.enum(["CREATE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            value: import_zod59.z.any().nullish()
          }),
          import_zod59.z.object({
            type: import_zod59.z.enum(["REMOVE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            oldValue: import_zod59.z.any().nullish()
          }),
          import_zod59.z.object({
            type: import_zod59.z.enum(["CHANGE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            oldValue: import_zod59.z.any().nullish(),
            value: import_zod59.z.any().nullish()
          })
        ])
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_updated"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      reason: import_zod59.z.string().nullish(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      diff: import_zod59.z.array(
        import_zod59.z.union([
          import_zod59.z.object({
            type: import_zod59.z.enum(["CREATE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            value: import_zod59.z.any().nullish()
          }),
          import_zod59.z.object({
            type: import_zod59.z.enum(["REMOVE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            oldValue: import_zod59.z.any().nullish()
          }),
          import_zod59.z.object({
            type: import_zod59.z.enum(["CHANGE"]),
            path: import_zod59.z.array(import_zod59.z.string().or(import_zod59.z.number())),
            oldValue: import_zod59.z.any().nullish(),
            value: import_zod59.z.any().nullish()
          })
        ])
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_offer_response_internal"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_name: import_zod59.z.string().min(1),
      offer_created_at: import_zod59.z.coerce.date()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_completed"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      company_name: import_zod59.z.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_created"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_rejected"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      rejected_reason: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_cancelled"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      // El reclamante ve esta actividad: acá va el motivo PÚBLICO de la
      // anulación (o el que se haya cargado en AutoSign), nunca el interno,
      // y queda vacío si nadie cargó uno.
      cancelled_reason: import_zod59.z.string().nullish(),
      // Una conformidad se cancela desde Piramid (la anula el tramitador) o
      // desde el tablero de AutoSign, y la Actividad las narra distinto. Los
      // eventos previos al flag son todos anulaciones locales.
      cancelled_by_provider: import_zod59.z.boolean().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_expired"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_dispatch_failed"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.literal("claim"),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      failure_code: import_zod59.z.enum(import_piramid_constants44.offerAgreementDispatchFailureCodes),
      /** A quién avisar: el remitente, o el titular si el remitente ya no existe. */
      sender_user_id: import_zod59.z.string().nullable(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_agreement_recipient_submitted"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.literal("claim"),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      offer_agreement_id: import_zod59.z.string().min(1),
      offer_agreement_name: import_zod59.z.string().min(1),
      recipient_name: import_zod59.z.string().nullable(),
      recipient_email: import_zod59.z.string(),
      recipient_role: import_zod59.z.string(),
      submitted_at: import_zod59.z.coerce.date().nullable(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_created"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("offer_accepted"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      ref_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_number: import_zod59.z.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      offer_id: import_zod59.z.coerce.string(),
      offer_name: import_zod59.z.string().min(1),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_documentation_list_view"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("documentation_search"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      query: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("documentation_filter"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      tags: import_zod59.z.array(import_zod59.z.string())
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_created"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_ownership_transfer_requested"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      destination_user_name: import_zod59.z.string(),
      destination_user_email: import_zod59.z.string().email(),
      source_user_email: import_zod59.z.string().email(),
      source_user_name: import_zod59.z.string(),
      ownership_transfer_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_ownership_transfer_accepted"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      ownership_transfer_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      destination_user_name: import_zod59.z.string(),
      destination_user_email: import_zod59.z.string().email(),
      source_user_email: import_zod59.z.string().email(),
      source_user_name: import_zod59.z.string(),
      transferred_by_name: import_zod59.z.string(),
      transferred_by_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_ownership_transfer_rejected"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      ownership_transfer_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      destination_user_name: import_zod59.z.string(),
      destination_user_email: import_zod59.z.string().email(),
      source_user_email: import_zod59.z.string().email(),
      source_user_name: import_zod59.z.string(),
      transferred_by_name: import_zod59.z.string(),
      transferred_by_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_ownership_assigned"),
    metadata: import_zod59.z.object({
      ownership_transfer_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      destination_user_name: import_zod59.z.string(),
      destination_user_email: import_zod59.z.string().email(),
      source_user_email: import_zod59.z.string().email(),
      source_user_name: import_zod59.z.string(),
      transferred_by_name: import_zod59.z.string(),
      transferred_by_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_updates_requested"),
    metadata: import_zod59.z.object({
      message: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      contact_name: import_zod59.z.string(),
      company_id: import_zod59.z.coerce.string(),
      requested_by_user_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_updates_published"),
    metadata: import_zod59.z.object({
      ref_id: import_zod59.z.string(),
      message: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      company_id: import_zod59.z.coerce.string(),
      update_note_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("rfp_bid_submitted"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      bid_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("rfp_bid_winner_selected"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      vendor_contact_name: import_zod59.z.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      bid_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("rfp_created"),
    metadata: import_zod59.z.object({
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("rfp_canceled"),
    metadata: import_zod59.z.object({
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      canceled_reason: import_zod59.z.string(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("rfp_expired"),
    metadata: import_zod59.z.object({
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_report_created"),
    metadata: import_zod59.z.object({
      ref_id: import_zod59.z.string(),
      report_original_name: import_zod59.z.string(),
      version: import_zod59.z.coerce.number(),
      appraisal_report_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_invoice_uploaded"),
    metadata: import_zod59.z.object({
      ref_id: import_zod59.z.string(),
      invoice_original_name: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_report_rejected"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      report_original_name: import_zod59.z.string(),
      reason: import_zod59.z.string(),
      version: import_zod59.z.coerce.number(),
      appraisal_report_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_created"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      vendor_contact_name: import_zod59.z.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_report_created"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_report_accepted"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_report_rejected"),
    metadata: import_zod59.z.object({
      reason: import_zod59.z.string().min(1),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      version: import_zod59.z.coerce.number(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_updates_published"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      message: import_zod59.z.string(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      rfp_id: import_zod59.z.coerce.string(),
      rfp_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_updates_requested"),
    metadata: import_zod59.z.object({
      message: import_zod59.z.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("contract_invoice_uploaded"),
    metadata: import_zod59.z.object({
      vendor_contact_name: import_zod59.z.string(),
      rfp_name: import_zod59.z.string(),
      rfp_id: import_zod59.z.coerce.string(),
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string(),
      invoice_original_name: import_zod59.z.string(),
      contract_name: import_zod59.z.string(),
      contract_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("appraisal_report_accepted"),
    metadata: import_zod59.z.object({
      report_original_name: import_zod59.z.string(),
      version: import_zod59.z.coerce.number(),
      appraisal_report_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      resource_type: import_zod59.z.enum(["claim", "complaint"])
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_responsible_assigned"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      responsible_user_id: import_zod59.z.coerce.string(),
      responsible_user_email: import_zod59.z.string(),
      responsible_user_first_name: import_zod59.z.string(),
      responsible_user_last_name: import_zod59.z.string(),
      claim_handler_id: import_zod59.z.coerce.string(),
      assignment_reason: assignmentReason.optional(),
      // Only carried by a `derivation_reassigned` or `team_reassigned`
      // assignment, where the activity has to name both ends of the move.
      previous_responsible_user_id: import_zod59.z.coerce.string().nullish(),
      previous_responsible_user_email: import_zod59.z.string().nullish(),
      previous_responsible_user_first_name: import_zod59.z.string().nullish(),
      previous_responsible_user_last_name: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_derived"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      responsible_user_id: import_zod59.z.coerce.string(),
      responsible_user_email: import_zod59.z.string(),
      responsible_user_first_name: import_zod59.z.string(),
      responsible_user_last_name: import_zod59.z.string(),
      reason: import_zod59.z.string(),
      strategy: import_zod59.z.enum(import_piramid_constants44.deriveClaimStrategies).nullish(),
      team_id: import_zod59.z.coerce.string().nullish(),
      team_name: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_derived_returned"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      responsible_user_id: import_zod59.z.coerce.string(),
      responsible_user_email: import_zod59.z.string(),
      responsible_user_first_name: import_zod59.z.string(),
      responsible_user_last_name: import_zod59.z.string(),
      // Absent when returned from the team board without a comment.
      reason: import_zod59.z.string().nullish(),
      restored_status_name: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_derivation_canceled"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      // Absent when an external resolution closed a derivation whose titular
      // could no longer be resolved: there is nobody the claim went back to.
      responsible_user_id: import_zod59.z.coerce.string().nullish(),
      responsible_user_email: import_zod59.z.string().nullish(),
      responsible_user_first_name: import_zod59.z.string().nullish(),
      responsible_user_last_name: import_zod59.z.string().nullish(),
      reason: import_zod59.z.string(),
      restored_status_name: import_zod59.z.string().nullable(),
      canceled_automatically: import_zod59.z.boolean().nullish(),
      // Who held it when it was recovered, absent before it was recorded.
      previous_responsible_user_id: import_zod59.z.coerce.string().nullish(),
      previous_responsible_user_first_name: import_zod59.z.string().nullish(),
      previous_responsible_user_last_name: import_zod59.z.string().nullish()
    })
  }),
  // An automatic transition that met an open derivation: the derived status
  // stays, and the return lands on the role's status instead (PIRAMID-953).
  import_zod59.z.object({
    type: import_zod59.z.literal(
      "claim_derivation_restore_status_updated"
    ),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      previous_restore_status_name: import_zod59.z.string(),
      restore_status_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_responsibility_returned"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      responsible_user_id: import_zod59.z.coerce.string(),
      responsible_user_email: import_zod59.z.string(),
      responsible_user_first_name: import_zod59.z.string(),
      responsible_user_last_name: import_zod59.z.string(),
      // Absent when returned from the team board without a comment.
      reason: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_responsible_assigned"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      responsible_user_id: import_zod59.z.coerce.string(),
      responsible_user_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_sinister_complaint"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("pending_file_request_upload"),
    metadata: import_zod59.z.discriminatedUnion("resource_type", [
      import_zod59.z.object({
        ref_id: import_zod59.z.coerce.string(),
        resource_type: import_zod59.z.literal("claim"),
        sinister_id: import_zod59.z.coerce.string(),
        claim_id: import_zod59.z.coerce.string(),
        documents: import_zod59.z.array(
          import_zod59.z.object({
            tag: import_zod59.z.string()
          })
        )
      }),
      import_zod59.z.object({
        ref_id: import_zod59.z.coerce.string(),
        resource_type: import_zod59.z.literal("complaint"),
        sinister_id: import_zod59.z.coerce.string(),
        complaint_id: import_zod59.z.coerce.string(),
        documents: import_zod59.z.array(
          import_zod59.z.object({
            tag: import_zod59.z.string()
          })
        )
      })
    ])
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("file_request_uploaded"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      files: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          type: import_zod59.z.nativeEnum(import_database28.FileTypes),
          original_name: import_zod59.z.string()
        })
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_file_request_uploaded"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      files: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string(),
          type: import_zod59.z.nativeEnum(import_database28.FileTypes),
          original_name: import_zod59.z.string()
        })
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("file_requested"),
    metadata: import_zod59.z.discriminatedUnion("resource_type", [
      import_zod59.z.object({
        company_id: import_zod59.z.coerce.string(),
        file_request_id: import_zod59.z.coerce.string(),
        resource_type: import_zod59.z.literal("claim"),
        claim_id: import_zod59.z.coerce.string(),
        placeholders: import_zod59.z.array(
          import_zod59.z.object({
            tag: import_zod59.z.string()
          })
        )
      }),
      import_zod59.z.object({
        claim_id: import_zod59.z.coerce.string().nullish(),
        company_id: import_zod59.z.coerce.string(),
        file_request_id: import_zod59.z.coerce.string(),
        resource_type: import_zod59.z.literal("complaint"),
        complaint_id: import_zod59.z.coerce.string(),
        placeholders: import_zod59.z.array(
          import_zod59.z.object({
            tag: import_zod59.z.string()
          })
        )
      })
    ])
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("file_request_placeholder_cancelled"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      file_request_id: import_zod59.z.coerce.string(),
      file_request_placeholder_id: import_zod59.z.coerce.string(),
      tag_name: import_zod59.z.string(),
      reason: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_collaborator_assigned"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_handler_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      collaborator_user_id: import_zod59.z.coerce.string(),
      collaborator_user_email: import_zod59.z.string(),
      collaborator_user_first_name: import_zod59.z.string(),
      collaborator_user_last_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_file_uploaded"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      file_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string(),
      file_original_name: import_zod59.z.string().min(1),
      file_stored_name: import_zod59.z.string().min(1),
      file_request_id: import_zod59.z.coerce.string().nullish(),
      file_request_placeholder_id: import_zod59.z.coerce.string().nullish(),
      file_tags: import_zod59.z.array(import_zod59.z.string()),
      file_type: import_zod59.z.nativeEnum(import_database28.FileTypes).nullish(),
      mimetype: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_collaborator_assigned"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      collaborator_user_id: import_zod59.z.coerce.string(),
      collaborator_user_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_collaborator_unassigned"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_handler_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      collaborator_user_id: import_zod59.z.coerce.string(),
      collaborator_user_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_collaborator_unassigned"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      collaborator_user_id: import_zod59.z.coerce.string(),
      collaborator_user_email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("settings_profile_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("settings_distribution_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("settings_team_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("settings_notifications_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("invitations_view"),
    metadata: import_zod59.z.object({
      page: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("roles_view"),
    metadata: import_zod59.z.object({
      page: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_created"),
    metadata: import_zod59.z.object({
      team_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string(),
      team_user_count: import_zod59.z.coerce.number()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_assignments_paused"),
    metadata: userAssignmentsEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_assignments_resumed"),
    metadata: userAssignmentsEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_claims_reassigned"),
    metadata: teamClaimsReassignedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_claims_delegated"),
    metadata: teamClaimsDelegatedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_claims_recovered"),
    metadata: teamClaimsRecoveredEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_started"),
    metadata: userInactivityStartedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_ended"),
    metadata: userInactivityEndedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_scheduled"),
    metadata: userInactivityScheduledEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_rescheduled"),
    metadata: userInactivityRescheduledEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_return_changed"),
    metadata: userInactivityReturnChangedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_cancelled"),
    metadata: userInactivityCancelledEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_claims_delegated"),
    metadata: userInactivityClaimsDelegatedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_delegation_updated"),
    metadata: userInactivityDelegationUpdatedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_inactivity_delegation_discarded"),
    metadata: affectedUserEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_delegated_claims_recovered"),
    metadata: userDelegatedClaimsRecoveredEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_delegated_claims_returned"),
    metadata: userDelegatedClaimsReturnedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_derived_claims_returned"),
    metadata: userDerivedClaimsReturnedEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("user_derived_claims_recovered"),
    metadata: userDerivedClaimsRecoveredEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_deleted"),
    metadata: import_zod59.z.object({
      team_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("load_balance_rule_created"),
    metadata: import_zod59.z.object({
      load_balance_rule_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("load_balance_rule_deleted"),
    metadata: import_zod59.z.object({
      load_balance_rule_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("load_balance_rule_updated"),
    metadata: import_zod59.z.object({
      load_balance_rule_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("load_balance_rules_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("teams_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("team_detail_view"),
    metadata: import_zod59.z.object({
      team_name: import_zod59.z.string(),
      team_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_investigation_report_accepted"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      accepted_report_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_news_answered"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      news_answer_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_activity_view"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_updated"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      // Kach webhook event behind the update; absent on legacy rows.
      kach_event: import_zod59.z.enum(import_piramid_constants44.KACH_WEBHOOK_EVENTS).nullish(),
      external_status: import_zod59.z.string().nullish(),
      instance: import_zod59.z.string().nullish(),
      // Internal status transition, only when the update changed it.
      status: import_zod59.z.enum(import_database28.fraudInvestigationStatuses).nullish(),
      previous_status: import_zod59.z.enum(import_database28.fraudInvestigationStatuses).nullish(),
      lab_name: import_zod59.z.string().nullish(),
      responsible_name: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_news_requested"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      news_request_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_investigation_case_created"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      external_case_id: import_zod59.z.coerce.string(),
      case_request_id: import_zod59.z.coerce.string(),
      reason: import_zod59.z.string().nullish(),
      creation_mode: import_zod59.z.enum(["created_in_kach", "associated_existing_kach_case"]).nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("load_balance_rule_detail_view"),
    metadata: import_zod59.z.object({
      load_balance_rule_id: import_zod59.z.coerce.string(),
      team_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("users_invited"),
    metadata: import_zod59.z.object({
      emails: import_zod59.z.array(import_zod59.z.string())
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("forwarded_invitation"),
    metadata: import_zod59.z.object({
      invitation_id: import_zod59.z.coerce.string(),
      email: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("role_detail_view"),
    metadata: import_zod59.z.object({
      role_id: import_zod59.z.coerce.string(),
      role_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("login"),
    metadata: import_zod59.z.object({
      provider: loginProvider.optional()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("logout"),
    metadata: import_zod59.z.object({})
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_form_step_view"),
    metadata: import_zod59.z.object({
      step: import_zod59.z.string().min(1),
      entrypoint_id: import_zod59.z.coerce.string(),
      entrypoint_endpoint: import_zod59.z.string().min(1),
      // The form session, so a step can be read per session instead of being
      // matched back to one by creator and time.
      entrypoint_snapshot_progress_id: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_form_vehicle_id_card_extracted"),
    metadata: import_zod59.z.object({
      entrypoint_id: import_zod59.z.coerce.string(),
      entrypoint_endpoint: import_zod59.z.string().min(1),
      entrypoint_snapshot_progress_id: import_zod59.z.string().nullish(),
      outcome: import_zod59.z.string().min(1),
      prefilled_fields: import_zod59.z.array(import_zod59.z.string()),
      already_filled_fields: import_zod59.z.array(import_zod59.z.string()),
      document_type_label: import_zod59.z.string().nullish(),
      document_side_label: import_zod59.z.string().nullish(),
      rejection_reason: import_zod59.z.string().nullish(),
      total_ms: import_zod59.z.number().nullish(),
      file_size_bytes: import_zod59.z.number().nullish(),
      upload_ms: import_zod59.z.number().nullish(),
      workflow_ms: import_zod59.z.number().nullish(),
      catalog_ms: import_zod59.z.number().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_form_step_view"),
    metadata: import_zod59.z.object({
      step: import_zod59.z.string().min(1),
      entrypoint_id: import_zod59.z.coerce.string(),
      entrypoint_endpoint: import_zod59.z.string().min(1)
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_closed"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      result: import_zod59.z.string().optional(),
      status: import_zod59.z.string().optional(),
      // Per-claim Kach verdicts; present only on a positive close, where
      // results can differ per claim.
      claims: import_zod59.z.array(
        import_zod59.z.object({
          ref_id: import_zod59.z.string().nullish(),
          result: import_zod59.z.string()
        })
      ).optional()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_reopened"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      result: import_zod59.z.string().optional(),
      status: import_zod59.z.string().optional()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("fraud_claim_result_updated"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      fraud_id: import_zod59.z.coerce.string(),
      fraud_sinister_number: import_zod59.z.string().nullish(),
      claim_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.string().nullish(),
      kach_claim_gateway_id: import_zod59.z.string().nullish(),
      previous_result: import_zod59.z.string().nullish(),
      new_result: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_claim_chat_message_send"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      sinister_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      message: import_zod59.z.string(),
      message_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("sinister_complaint_chat_message_send"),
    metadata: import_zod59.z.object({
      sinister_id: import_zod59.z.coerce.string(),
      complaint_id: import_zod59.z.coerce.string(),
      message: import_zod59.z.string(),
      sent_by_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_form_step_completed"),
    metadata: import_zod59.z.object({
      step: import_zod59.z.string().min(1),
      entrypoint_id: import_zod59.z.coerce.string(),
      entrypoint_endpoint: import_zod59.z.string().min(1),
      // The form session, so a step can be read per session instead of being
      // matched back to one by creator and time.
      entrypoint_snapshot_progress_id: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_status_updated"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string().nullish(),
      previous_status_name: import_zod59.z.string(),
      new_status_name: import_zod59.z.string(),
      status_transition_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_mediation_started"),
    metadata: claimClosedByInsurerSystemEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_lawsuit_started"),
    metadata: claimClosedByInsurerSystemEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_reconciled"),
    metadata: claimClosedByInsurerSystemEventMetadata
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_status_communication_sent"),
    metadata: import_zod59.z.object({
      company_id: import_zod59.z.coerce.string(),
      claim_id: import_zod59.z.coerce.string(),
      ref_id: import_zod59.z.coerce.string().nullish(),
      sinister_id: import_zod59.z.coerce.string().nullish(),
      new_status_name: import_zod59.z.string(),
      recipient_email: import_zod59.z.string(),
      status_transition_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_status_updated"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      previous_status_name: import_zod59.z.string().nullish(),
      new_status_name: import_zod59.z.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_sinister_cause_updated"),
    metadata: import_zod59.z.object({
      complaint_id: import_zod59.z.coerce.string(),
      previous_sinister_cause_name: import_zod59.z.string().nullish(),
      previous_sinister_cause_id: import_zod59.z.coerce.string().nullish(),
      new_sinister_cause_name: import_zod59.z.string(),
      new_sinister_cause_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_documentation_requested"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_documentation_completed"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_file_request_completed"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("criminal_case_request"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_not_response"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_rejected"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_offer_flow"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_additional_management"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("field_adjuster_assigned"),
    metadata: import_zod59.z.object({
      resource_type: import_zod59.z.enum(["claim", "complaint"]),
      claim_id: import_zod59.z.coerce.string().nullish(),
      complaint_id: import_zod59.z.coerce.string().nullish(),
      contact_name: import_zod59.z.string(),
      contact_email: import_zod59.z.string(),
      company_id: import_zod59.z.coerce.string()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("complaint_confirmation_signature"),
    metadata: import_zod59.z.object({
      file_name: import_zod59.z.string().nullish(),
      policyholder_id: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.coerce.string(),
      entrypoint: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_confirmation_signature"),
    metadata: import_zod59.z.object({
      file_name: import_zod59.z.string().nullish(),
      policyholder_id: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.number().nullish(),
      entrypoint: import_zod59.z.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("tag_created"),
    metadata: import_zod59.z.object({
      tag_id: import_zod59.z.coerce.string().nullish(),
      tag_name: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("tag_updated"),
    metadata: import_zod59.z.object({
      tag_id: import_zod59.z.coerce.string().nullish(),
      tag_name: import_zod59.z.string().nullish(),
      company_id: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("tag_deleted"),
    metadata: import_zod59.z.object({
      tag_id: import_zod59.z.coerce.string().nullish(),
      company_id: import_zod59.z.coerce.string().nullish()
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("tags_view"),
    metadata: import_zod59.z.object({}).optional()
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_comment_created"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      comment_id: import_zod59.z.coerce.string(),
      comment_content: import_zod59.z.string(),
      users_to_notify: import_zod59.z.array(
        import_zod59.z.object({
          id: import_zod59.z.coerce.string()
        })
      )
    })
  }),
  import_zod59.z.object({
    type: import_zod59.z.literal("claim_created_documents_missing"),
    metadata: import_zod59.z.object({
      claim_id: import_zod59.z.coerce.string(),
      missing_documents: import_zod59.z.array(import_zod59.z.string())
    })
  })
]);
var createBatchEventsRequestBody = import_zod59.z.object({
  events: import_zod59.z.array(eventRequestBody).min(1).max(20)
});
var eventReportColumns = [
  "user",
  "email",
  "event",
  "metadata",
  "sinister_id",
  "selected_external_complaint",
  "claim_id",
  "external_claim_request_id",
  "remote_ip",
  "user_agent",
  "date"
];
var companyEventsFiltersSchema = import_zod59.z.object({
  types: import_zod59.z.array(import_zod59.z.enum(import_database28.eventTypes)).optional().default([]),
  users: import_zod59.z.array(import_zod59.z.coerce.string()).default([]),
  date_from: import_zod59.z.coerce.date().optional(),
  date_to: import_zod59.z.coerce.date().optional(),
  timezone: import_zod59.z.string().optional().default("America/Argentina/Buenos_Aires")
});
var listCompanyEventsRequestQuery = paginateRequestQuery.merge(
  companyEventsFiltersSchema
);
var exportCompanyEventsRequestFilters = companyEventsFiltersSchema.extend({
  date_from: import_zod59.z.coerce.date(),
  date_to: import_zod59.z.coerce.date()
}).refine((data) => data.date_from <= data.date_to, {
  message: "date_from must be before or equal to date_to",
  path: ["date_from"]
});
var exportCompanyEventsRequestBody = import_zod59.z.object({
  filters: exportCompanyEventsRequestFilters,
  columns: import_zod59.z.array(import_zod59.z.enum(eventReportColumns)).min(1, "M\xEDnimo 1 columna").refine((cols) => new Set(cols).size === cols.length, {
    message: "Duplicated columns"
  })
});

// contracts/fraud.contract.ts
var import_piramid_constants45 = __toESM(require_dist2());
var import_zod60 = require("zod");
var fetchFraudDetailRequestParams = import_zod60.z.object({
  id: import_zod60.z.coerce.string()
});
var requestFraudNewsRequestBody = import_zod60.z.object({
  annotation: import_zod60.z.string().optional(),
  files: import_zod60.z.array(
    import_zod60.z.object({
      token: import_zod60.z.string().min(1)
    })
  ).max(import_piramid_constants45.MAX_NEWS_REQUEST_FILES).default([])
});

// interfaces/company.interface.ts
var companyEnumKeys = [
  "claim_stage",
  "claim_status",
  "claim_status_order_rule",
  "claim_reference",
  "claim_type",
  "agencies",
  "ramos",
  "complaint_stage",
  "complaint_reference",
  "complaint_status",
  "complaint_status_order_rule"
];

// contracts/error.contract.ts
var import_zod61 = require("zod");
var validationIssueSchema = import_zod61.z.object({
  code: import_zod61.z.string().optional(),
  message: import_zod61.z.string(),
  path: import_zod61.z.array(import_zod61.z.union([import_zod61.z.string(), import_zod61.z.number()])).optional()
});
var validationIssuesSchema = import_zod61.z.array(validationIssueSchema);
var appErrorSchema = import_zod61.z.object({
  status: import_zod61.z.number(),
  code: import_zod61.z.string(),
  description: import_zod61.z.string().nullable().optional(),
  metadata: import_zod61.z.record(import_zod61.z.string(), import_zod61.z.any()).optional(),
  errors: import_zod61.z.array(import_zod61.z.any()).default([]).nullable().optional()
});

// contracts/backoffice.contract.ts
var import_database29 = __toESM(require_index_browser4());
var import_zod62 = require("zod");
var import_piramid_constants46 = __toESM(require_dist2());
var createValidationPatternRequestBody = import_zod62.z.object({
  column: import_zod62.z.nativeEnum(import_database29.ValidationPatternColumns),
  extractor: import_zod62.z.nativeEnum(import_database29.ValidationPatternExtractors),
  pattern: import_zod62.z.string().refine(
    (val) => {
      try {
        new RegExp(val);
        return true;
      } catch (err) {
        return false;
      }
    },
    {
      message: "Patron invalido"
    }
  )
});
var removeValidationPatternRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  validationPatternId: import_zod62.z.coerce.string()
});
var removeIntegrationConnectionRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  integrationConnectionId: import_zod62.z.coerce.string()
});
var updateValidationPatternRequestParams = removeValidationPatternRequestParams;
var updateValidationPatternRequestBody = createValidationPatternRequestBody;
var kachOAuthFields = {
  external_company_id: import_zod62.z.string().trim().max(50).optional(),
  oauth_mode: import_zod62.z.enum(["off", "preferred", "required"]).optional(),
  // Machine client of the company in Kach (client_credentials). The secret is
  // write-only: stored sealed, never listed; empty on an edit keeps it.
  client_id: import_zod62.z.string().trim().max(100).optional(),
  client_secret: import_zod62.z.string().optional(),
  kach_m2m_enabled: import_zod62.z.boolean().optional()
};
var createIntegrationConnectionRequestBody = import_zod62.z.object({
  integration_id: import_zod62.z.coerce.string(),
  access_token: import_zod62.z.string().min(1),
  webhook_secret: import_zod62.z.string().optional(),
  ...kachOAuthFields
});
var updateIntegrationConnectionRequestParams = removeIntegrationConnectionRequestParams;
var updateIntegrationConnectionRequestBody = import_zod62.z.object({
  access_token: import_zod62.z.string().min(1),
  webhook_secret: import_zod62.z.string().optional(),
  ...kachOAuthFields
});
var searchIntegrationsRequestQuery = paginateRequestQuery;
var retrieveCompanyClaimStatusRequestBody = import_zod62.z.object({
  companyClaimStatusId: import_zod62.z.coerce.string()
});
var retrieveCompanyComplaintStatusRequestBody = import_zod62.z.object({
  companyComplaintStatusId: import_zod62.z.coerce.string()
});
var createCompanyClaimStatusRequestBody = import_zod62.z.object({
  name: import_zod62.z.string(),
  role: import_zod62.z.nativeEnum(import_database29.ClaimStatusRole).transform((val) => val || null).nullish(),
  description: import_zod62.z.string().nullish()
});
var createCompanyClaimStatusOrderRuleRequestBody = import_zod62.z.object({
  stage_id: import_zod62.z.coerce.string(),
  order: import_zod62.z.coerce.number(),
  fixed: import_zod62.z.boolean().default(false),
  transition_targets: import_zod62.z.array(
    import_zod62.z.object({
      stage_id: import_zod62.z.coerce.string()
    })
  )
});
var createCompanyComplaintStatusOrderRuleRequestBody = import_zod62.z.object({
  stage_id: import_zod62.z.coerce.string(),
  order: import_zod62.z.coerce.number(),
  fixed: import_zod62.z.boolean().default(false),
  transition_targets: import_zod62.z.array(
    import_zod62.z.object({
      stage_id: import_zod62.z.coerce.string()
    })
  )
});
var updateCompanyClaimStatusOrderRuleRequestBody = createCompanyClaimStatusOrderRuleRequestBody;
var updateCompanyComplaintStatusOrderRuleRequestBody = createCompanyComplaintStatusOrderRuleRequestBody;
var retrieveCompanyClaimStatusOrderRuleRequestParams = import_zod62.z.object({
  companyClaimStatusOrderRuleId: import_zod62.z.coerce.string()
});
var retrieveCompanyComplaintStatusOrderRuleRequestParams = import_zod62.z.object({
  companyComplaintStatusOrderRuleId: import_zod62.z.coerce.string()
});
var updateCompanyClaimStatusRequestBody = createCompanyClaimStatusRequestBody;
var createCompanyComplaintStatusRequestBody = import_zod62.z.object({
  name: import_zod62.z.string(),
  role: import_zod62.z.nativeEnum(import_database29.ComplaintStatusRole).optional().nullable(),
  description: import_zod62.z.string().nullish()
});
var updateCompanyComplaintStatusRequestBody = createCompanyComplaintStatusRequestBody;
var listCompanyMembersRequestQuery = paginateRequestQuery;
var createCompanyLinkRequestBody = import_zod62.z.object({
  token_logo: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
  link: import_zod62.z.string().url("Tiene que ser una URL valida"),
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage)
});
var removeCompanyLinkRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  linkId: import_zod62.z.coerce.string()
});
var backofficeListUsersRequestQuery = paginateRequestQuery.extend({
  type: import_zod62.z.array(import_zod62.z.nativeEnum(import_database29.UserType)).default([]),
  company: import_zod62.z.array(import_zod62.z.coerce.string()).default([])
});
var backofficeListReviewsRequestQuery = paginateRequestQuery.extend({
  // Optional star filter for the table listing (1..5).
  score: reviewScoreSchema.optional(),
  // Optional review-type filter for the table listing.
  type: import_zod62.z.enum(import_piramid_constants46.reviewTypes).optional(),
  // Shared performance filters (company + answered_at period). Dates are
  // `yyyy-MM-dd`; the service parses them to day bounds, matching the reviews
  // distribution card so both stay concordant.
  company_id: import_zod62.z.string().optional(),
  from: import_zod62.z.string().optional(),
  to: import_zod62.z.string().optional(),
  // Review cross-filters (mutually exclusive by UI convention): a multi-score
  // filter (comma-separated "1,2,5", from the donut click or the rating
  // dropdown) and a keyword the comment must contain.
  scores: import_zod62.z.string().optional(),
  keyword: import_zod62.z.string().optional(),
  // "Lead Potencial" quick filter (Tab 2): score=5 with a non-empty comment.
  // Mutually exclusive with the other cross-filters by UI convention.
  leadPotencial: import_zod62.z.enum(import_piramid_constants46.booleansString).optional()
}).merge(reviewGlobalFiltersQuery).merge(reviewSortQuery);
var createLoginCredentialRequestBody = import_zod62.z.object({
  user: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  password: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  extra_credential_value: import_zod62.z.string().max(255, "M\xE1ximo 255 caracteres").optional()
});
var updateCompanyFlagsRequestBody = import_zod62.z.object({
  claim_evaluation: import_zod62.z.boolean(),
  claim_rfp: import_zod62.z.boolean(),
  providers: import_zod62.z.boolean(),
  performance_metrics: import_zod62.z.boolean().optional(),
  recovery_claim: import_zod62.z.boolean().optional(),
  team_management: import_zod62.z.boolean().optional(),
  release_notes: import_zod62.z.boolean().optional()
});
var listCompanyMessageTemplatesRequestQuery = import_zod62.z.object({
  search: import_zod62.z.string().nullish(),
  scope: import_zod62.z.nativeEnum(import_database29.MessageTemplateScope).default("offer")
});
var messageTemplateVariableOptionsSchema = import_zod62.z.array(
  import_zod62.z.object({
    name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
    guid: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage)
  })
);
var parseMessageTemplateVariableOptions = (options) => {
  const parsed = messageTemplateVariableOptionsSchema.safeParse(options ?? []);
  return parsed.success ? parsed.data : [];
};
var baseVariableSchema = import_zod62.z.object({
  guid: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  required: import_zod62.z.boolean().nullish().default(false),
  determination: import_zod62.z.nativeEnum(import_database29.VariableDetermination).default("compile_time")
});
var messageTemplateVariableSchema = import_zod62.z.discriminatedUnion("type", [
  baseVariableSchema.extend({
    type: import_zod62.z.literal("numeric"),
    min_value_type: import_zod62.z.nativeEnum(import_database29.VariableValidationValueType).nullish(),
    min_value_literal: import_zod62.z.coerce.string().nullish(),
    min_value_reference: import_zod62.z.nativeEnum(import_database29.VariableValidationValueReference).nullish(),
    max_value_type: import_zod62.z.nativeEnum(import_database29.VariableValidationValueType).nullish(),
    max_value_literal: import_zod62.z.coerce.string().nullish(),
    max_value_reference: import_zod62.z.nativeEnum(import_database29.VariableValidationValueReference).nullish(),
    numeric_format: import_zod62.z.boolean().default(false),
    numeric_format_currency: import_zod62.z.nativeEnum(import_database29.CurrencySymbol).nullish()
  }),
  baseVariableSchema.extend({
    type: import_zod62.z.literal("text"),
    min_length: import_zod62.z.coerce.number().nullish(),
    max_length: import_zod62.z.coerce.number().nullish()
  }),
  baseVariableSchema.extend({
    type: import_zod62.z.literal("select"),
    options: messageTemplateVariableOptionsSchema.min(1).default([])
  }),
  baseVariableSchema.extend({
    type: import_zod62.z.literal("file")
  }),
  baseVariableSchema.omit({
    name: true
  }).extend({
    type: import_zod62.z.literal("context_path"),
    name: import_zod62.z.enum(import_piramid_constants46.messageTemplateContextPaths)
  })
]).refine(
  (values) => values.type === "numeric" && values.min_value_type === "literal" ? values.min_value_literal != null : true,
  {
    path: ["min_value_literal"],
    message: import_piramid_constants46.requiredFieldMessage
  }
).refine(
  (values) => values.type === "numeric" && values.min_value_type === "reference" ? values.min_value_reference != null : true,
  {
    path: ["min_value_reference"],
    message: import_piramid_constants46.requiredFieldMessage
  }
).refine(
  (values) => values.type === "numeric" && values.max_value_type === "literal" ? values.max_value_literal != null : true,
  {
    path: ["max_value_literal"],
    message: import_piramid_constants46.requiredFieldMessage
  }
).refine(
  (values) => values.type === "numeric" && values.max_value_type === "reference" ? values.max_value_reference != null : true,
  {
    path: ["max_value_reference"],
    message: import_piramid_constants46.requiredFieldMessage
  }
);
var createMessageTemplateRequestBody = import_zod62.z.object({
  role: import_zod62.z.nativeEnum(import_database29.MessageTemplateRole).or(import_zod62.z.literal("")).transform((value) => value ?? null).nullish(),
  scope: import_zod62.z.nativeEnum(import_database29.MessageTemplateScope).default("offer"),
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage).max(255, "M\xE1ximo 255 caracteres"),
  subject: import_zod62.z.string().nullish(),
  message: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
  variables: import_zod62.z.array(messageTemplateVariableSchema).default([]),
  conditions: import_zod62.z.array(
    import_zod62.z.object({
      guid: import_zod62.z.string(),
      variable: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
      operator: import_zod62.z.nativeEnum(import_database29.ConditionOperator).default("equals"),
      value: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
      action: import_zod62.z.nativeEnum(import_database29.ConditionAction).default("show"),
      target: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage)
    })
  ),
  validations: import_zod62.z.array(
    import_zod62.z.discriminatedUnion("validation", [
      import_zod62.z.object({
        guid: import_zod62.z.string(),
        validation: import_zod62.z.literal(
          "interbanking"
        ),
        references: import_zod62.z.object({
          cbu: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
          cuit: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage)
        })
      })
    ])
  )
}).refine(
  (values) => !values.conditions.find((condition) => {
    return !values.variables.find(
      (variable) => variable.guid === condition.variable
    ) || !values.variables.find(
      (variable) => variable.guid === condition.target
    );
  }),
  {
    message: "There is some condition with broken variable"
  }
).refine(
  (values) => !values.validations.find((validation) => {
    return !values.variables.find(
      (variable) => variable.guid === validation.references.cbu
    ) || !values.variables.find(
      (variable) => variable.guid === validation.references.cuit
    );
  }),
  {
    message: "There is some validation with broken variable"
  }
);
var updateMessageTemplateRequestBody = createMessageTemplateRequestBody;
var retrieveMessageTemplateRequestParams = import_zod62.z.object({
  messageTemplateId: import_zod62.z.coerce.string()
});
var createComplaintSinisterCauseRequestBody = import_zod62.z.object({
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
  external_id: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage)
});
var retrieveComplaintSinisterCauseRequestParams = import_zod62.z.object({
  complaintSinisterCauseId: import_zod62.z.coerce.string()
});
var retrieveCompanyEstimatesDefinitionRequestParams = import_zod62.z.object({
  companyEstimatesDefinitionId: import_zod62.z.coerce.string()
});
var backofficeUpdateComplaintSinisterCauseRequestBody = createComplaintSinisterCauseRequestBody;
var estimatesDefinitionOperandSchema = import_zod62.z.object({
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
  min_value: import_zod62.z.coerce.string(),
  max_value: import_zod62.z.coerce.string()
});
var createEstimatesDefinitionRequestBody = import_zod62.z.object({
  name: import_zod62.z.string().min(1, import_piramid_constants46.requiredFieldMessage),
  scope: import_zod62.z.nativeEnum(import_database29.CompanyEstimatesDefinitionScope, {
    invalid_type_error: import_piramid_constants46.requiredFieldMessage,
    required_error: import_piramid_constants46.requiredFieldMessage
  }),
  strategy: import_zod62.z.nativeEnum(import_database29.EstimatesDefinitionStrategy, {
    invalid_type_error: import_piramid_constants46.requiredFieldMessage,
    required_error: import_piramid_constants46.requiredFieldMessage
  }),
  operands: import_zod62.z.array(estimatesDefinitionOperandSchema).min(1, "M\xEDnimo 1 termino")
});
var updateCompanyEstimatesDefinitionRequestBody = createEstimatesDefinitionRequestBody;
var backofficeEntityRequestParams = import_zod62.z.object({
  entityType: import_zod62.z.enum(["claim", "complaint"])
});
var backofficeEntitySpecificRequestParams = import_zod62.z.object({
  entityType: import_zod62.z.enum(["claim", "complaint"]),
  entityId: import_zod62.z.coerce.string()
});
var backofficeUpsertEntitySpecificTriggerMappingRequestBody = import_zod62.z.object(
  {
    trigger: import_zod62.z.nativeEnum(import_database29.TriggerMapping),
    status_id: import_zod62.z.coerce.string(),
    reference_id: import_zod62.z.coerce.string(),
    stage_id: import_zod62.z.coerce.string(),
    system_status: import_zod62.z.nativeEnum(import_database29.ClaimSystemStatus).nullish(),
    message_template_id: import_zod62.z.coerce.string().nullish(),
    message_template_name: import_zod62.z.string().nullish(),
    action: import_zod62.z.string().or(import_zod62.z.literal("")).transform((value) => value ?? null).nullish(),
    request_resolution_review: import_zod62.z.coerce.boolean().optional().default(false),
    preserves_reference: import_zod62.z.coerce.boolean().optional().default(false)
  }
);
var backofficeRemoveEntitySpecificTriggerMappingRequestParams = backofficeEntityRequestParams.extend({
  companyId: import_zod62.z.coerce.string(),
  triggerMappingId: import_zod62.z.coerce.string()
});
var triggerMappingMoveDirections = ["up", "down"];
var backofficeMoveTriggerMappingRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  triggerMappingId: import_zod62.z.coerce.string()
});
var backofficeMoveTriggerMappingRequestBody = import_zod62.z.object({
  direction: import_zod62.z.enum(triggerMappingMoveDirections)
});
var backofficeUpdateCompanyEnumRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  enumId: import_zod62.z.coerce.string()
});
var backofficeRemoveCompanyEnumRequestParams = import_zod62.z.object({
  companyId: import_zod62.z.coerce.string(),
  enumId: import_zod62.z.coerce.string(),
  enumType: import_zod62.z.enum(companyEnumKeys)
});
var backofficeListEntrypointsRequestQuery = paginateRequestQuery.extend({
  search: import_zod62.z.string().nullish()
});
var updateCompanyRequestBody = import_zod62.z.object({
  name: import_zod62.z.string().optional(),
  domain: import_zod62.z.string().optional(),
  type: import_zod62.z.nativeEnum(import_database29.CompanyType).optional(),
  country: import_zod62.z.string().optional(),
  ein: import_zod62.z.string().optional(),
  alias: import_zod62.z.string().optional(),
  domain_invitations_only: import_zod62.z.boolean().optional()
});
var updateCompanyResponseBody = import_zod62.z.object({
  updated: import_zod62.z.boolean()
});
var updateCompanyFieldMappingConfigRequestBody = import_zod62.z.object({
  field_mappings: import_zod62.z.array(
    import_zod62.z.object({
      id: import_zod62.z.string().nullish(),
      entity: import_zod62.z.nativeEnum(import_database29.FieldMappingEntity, {
        errorMap: () => ({ message: import_piramid_constants46.requiredFieldMessage })
      }),
      from_field: import_zod62.z.nativeEnum(import_database29.MappingFieldName, {
        errorMap: () => ({ message: import_piramid_constants46.requiredFieldMessage })
      }),
      to_field: import_zod62.z.nativeEnum(import_database29.MappingFieldName, {
        errorMap: () => ({ message: import_piramid_constants46.requiredFieldMessage })
      })
    })
  )
});
var createWorkflowRequestBody = import_zod62.z.object({
  key_name: import_zod62.z.nativeEnum(import_database29.WorkflowKeyName),
  description: import_zod62.z.string().optional(),
  workflow_external_id: import_zod62.z.string().min(1),
  workflow_version_external_id: import_zod62.z.string().min(1),
  provider: import_zod62.z.nativeEnum(import_database29.WorkflowProvider)
});
var updateWorkflowRequestBody = createWorkflowRequestBody;
var updateWorkflowRequestParams = import_zod62.z.object({
  workflowId: import_zod62.z.string().min(1)
});
var workflowParamSchema = import_zod62.z.object({
  workflowId: import_zod62.z.string().min(1),
  companyId: import_zod62.z.string().min(1)
});
var ExternalWorkflowSchema = import_zod62.z.object({
  id: import_zod62.z.string(),
  name: import_zod62.z.string(),
  description: import_zod62.z.string().nullable(),
  created_by: import_zod62.z.any(),
  created_at: import_zod62.z.string(),
  updated_at: import_zod62.z.string(),
  status: import_zod62.z.string(),
  last_run_at: import_zod62.z.string().nullish()
});
var listExternalWorkflowsResponseBody = import_zod62.z.object({
  metadata: import_zod62.z.object({
    total: import_zod62.z.number(),
    page: import_zod62.z.number(),
    limit: import_zod62.z.number()
  }),
  workflows: import_zod62.z.array(ExternalWorkflowSchema)
});
var ExternalWorkflowVersionSchema = import_zod62.z.object({
  id: import_zod62.z.string(),
  version: import_zod62.z.coerce.number(),
  status: import_zod62.z.enum(["published", "draft"])
});
var listExternalWorkflowVersionsResponseBody = import_zod62.z.object({
  metadata: import_zod62.z.object({
    total: import_zod62.z.number(),
    page: import_zod62.z.number(),
    limit: import_zod62.z.number()
  }),
  versions: import_zod62.z.array(ExternalWorkflowVersionSchema)
});
var fetchClaimsPeriodAnalysisRequestQuery = import_zod62.z.object({
  company_id: import_zod62.z.string().optional(),
  from: import_zod62.z.string().transform((val) => new Date(val)),
  to: import_zod62.z.string().transform((val) => new Date(val))
}).superRefine((data, ctx) => {
  if (data.from > data.to) {
    ctx.addIssue({
      code: import_zod62.z.ZodIssueCode.custom,
      path: ["to"],
      message: "La fecha hasta debe ser mayor o igual a desde"
    });
  }
});

// contracts/param-id.ts
var import_zod63 = require("zod");
var paramIdSchema = import_zod63.z.object({
  id: import_zod63.z.coerce.string()
});

// contracts/estimates.contract.ts
var import_database30 = __toESM(require_index_browser4());
var import_zod64 = require("zod");
var resolveEstimatesDefinitionRequestQuery = import_zod64.z.object({
  scope: import_zod64.z.nativeEnum(import_database30.CompanyEstimatesDefinitionScope)
});
var updateEstimatesInstanceRequestBody = import_zod64.z.record(
  import_zod64.z.string(),
  import_zod64.z.number().min(0)
);

// contracts/company-enum.contract.ts
var import_database31 = __toESM(require_index_browser4());
var import_zod65 = require("zod");
var claimTypeDamageSchema = import_zod65.z.object({
  damage_type: import_zod65.z.nativeEnum(import_database31.DamageTypes),
  sub_damage_type: import_zod65.z.nativeEnum(import_database31.SubDamageTypes).nullish(),
  entity_damaged_category: import_zod65.z.nativeEnum(import_database31.EntityDamagedCategory).nullish()
});
var createCompanyClaimTypeRequestBody = import_zod65.z.object({
  id: import_zod65.z.coerce.string().nullish(),
  name: import_zod65.z.string(),
  type: import_zod65.z.literal("claim_type"),
  damages: import_zod65.z.array(claimTypeDamageSchema),
  priority: import_zod65.z.coerce.number()
});
var companyEnumUnionType = import_zod65.z.discriminatedUnion("type", [
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    code: import_zod65.z.string().min(1).optional().nullable(),
    name: import_zod65.z.string(),
    description: import_zod65.z.string().optional().nullable(),
    type: import_zod65.z.literal("agencies")
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    code: import_zod65.z.string().min(1).optional().nullable(),
    name: import_zod65.z.string(),
    description: import_zod65.z.string().optional().nullable(),
    type: import_zod65.z.literal("ramos"),
    is_automotive: import_zod65.z.boolean().default(false).optional()
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    description: import_zod65.z.string().nullish(),
    name: import_zod65.z.string(),
    type: import_zod65.z.literal("claim_stage")
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    name: import_zod65.z.string(),
    description: import_zod65.z.string().nullish(),
    type: import_zod65.z.literal("claim_reference")
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    name: import_zod65.z.string(),
    description: import_zod65.z.string().nullish(),
    type: import_zod65.z.literal("claim_status")
  }),
  createCompanyClaimTypeRequestBody,
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    name: import_zod65.z.string(),
    type: import_zod65.z.literal("complaint_status")
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    description: import_zod65.z.string().nullish(),
    name: import_zod65.z.string(),
    type: import_zod65.z.literal("complaint_stage")
  }),
  import_zod65.z.object({
    id: import_zod65.z.coerce.string().nullish(),
    name: import_zod65.z.string(),
    description: import_zod65.z.string().nullish(),
    type: import_zod65.z.literal("complaint_reference")
  })
]);
var companyEnumSchema = import_zod65.z.object({
  enum: companyEnumUnionType
});

// contracts/role.contract.ts
var import_database32 = __toESM(require_index_browser4());
var import_piramid_constants47 = __toESM(require_dist2());
var import_zod66 = require("zod");
var createRoleRequestBody = import_zod66.z.object({
  name: import_zod66.z.string().min(1, import_piramid_constants47.requiredFieldMessage).max(20),
  permissions: import_zod66.z.array(
    import_zod66.z.object({
      type: import_zod66.z.nativeEnum(import_database32.PermissionType),
      scope: import_zod66.z.nativeEnum(import_database32.PermissionScope).optional()
    })
  )
});

// contracts/invitation.contract.ts
var import_database33 = __toESM(require_index_browser4());
var import_zod67 = require("zod");
var import_piramid_constants48 = __toESM(require_dist2());
var createInvitationSchema = import_zod67.z.object({
  invited_by_id: import_zod67.z.coerce.string(),
  emails: import_zod67.z.array(
    import_zod67.z.object({
      //TODO: domain check at schema level. That way we can save a network call
      email: import_zod67.z.string().email("El email no es v\xE1lido")
    })
  ).min(1, "M\xEDnimo un invitado").default([]),
  role_id: import_zod67.z.coerce.string({
    invalid_type_error: import_piramid_constants48.requiredFieldMessage,
    required_error: import_piramid_constants48.requiredFieldMessage
  }).min(1)
});
var retrieveInvitationInfoRequestBody = import_zod67.z.object({
  token: import_zod67.z.string().min(1)
});
var registerUserByInvitationLocalRequestBody = import_zod67.z.object({
  token: import_zod67.z.string().min(1),
  user: registerUserExtendedRequestBody
});
var registerUserByInvitationProviderRequestBody = import_zod67.z.object({
  token: import_zod67.z.string().min(1),
  provider: signInRequestBody,
  type: import_zod67.z.nativeEnum(import_database33.UserType).optional()
});

// contracts/styles-config.contract.ts
var import_database34 = __toESM(require_index_browser4());
var import_zod68 = require("zod");
var import_piramid_constants49 = __toESM(require_dist2());
var createStyleConfigRequestBody = import_zod68.z.object({
  scope: import_zod68.z.nativeEnum(import_database34.StylesConfigScope),
  token_logo: import_zod68.z.string().min(1, import_piramid_constants49.requiredFieldMessage),
  border_radius: import_zod68.z.coerce.number(),
  color_theme: import_zod68.z.nativeEnum(import_database34.ColorThemeType),
  font_family: import_zod68.z.nativeEnum(import_database34.FontFamily).optional(),
  mode: import_zod68.z.nativeEnum(import_database34.StyleMode)
});
var retrieveCompanyAllowedScopesRequestBody = paramIdSchema;
var retrieveCompanyStyleRequestQuery = import_zod68.z.object({
  scope: import_zod68.z.nativeEnum(import_database34.StylesConfigScope).optional().nullable()
});
var removeCompanyStyleRequestParam = import_zod68.z.object({
  styleId: import_zod68.z.coerce.string(),
  companyId: import_zod68.z.coerce.string()
});

// contracts/complaint.contract.ts
var import_zod_openapi5 = require("@anatine/zod-openapi");
var import_database38 = __toESM(require_index_browser4());
var import_piramid_constants54 = __toESM(require_dist2());
var import_zod74 = require("zod");

// ssot/complaint.ts
var complaintDocumentRequirements = [
  {
    fileTypes: ["image", "pdf"],
    alias: "damage_budget",
    required: (fields7) => !!fields7.hasDamageBudget,
    predicate: (fields7) => !!fields7.hasDamageBudget,
    isSoftRequired: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "police_report",
    group: "documentation",
    optional: true,
    //@ts-ignore
    predicate: (data) => {
      var _a;
      return !!((_a = data.occurrence) == null ? void 0 : _a.police_intervention);
    }
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "policy_holder_identity_card_front",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "policy_holder_identity_card_back",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "policy_holder_driver_license_front",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "policy_holder_driver_license_back",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "vehicle_registration_card_front",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "vehicle_registration_card_back",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "vehicle_authorization_document_front",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image", "pdf"],
    alias: "vehicle_authorization_document_back",
    group: "documentation",
    optional: true
  },
  {
    fileTypes: ["image"],
    alias: "vehicle_side_left_damage",
    optional: true,
    group: "vehicle_damages",
    message: "Puede avanzar si no tiene da\xF1os en esta zona",
    maxFiles: 5
  },
  {
    fileTypes: ["image"],
    alias: "vehicle_side_right_damage",
    optional: true,
    group: "vehicle_damages",
    message: "Puede avanzar si no tiene da\xF1os en esta zona",
    maxFiles: 5
  },
  {
    fileTypes: ["image"],
    alias: "vehicle_back_damage",
    optional: true,
    group: "vehicle_damages",
    message: "Puede avanzar si no tiene da\xF1os en esta zona",
    maxFiles: 5
  },
  {
    fileTypes: ["image"],
    alias: "vehicle_front_damage",
    optional: true,
    group: "vehicle_damages",
    message: "Puede avanzar si no tiene da\xF1os en esta zona",
    maxFiles: 5
  },
  {
    fileTypes: ["image"],
    alias: "vehicle_roof_damage",
    optional: true,
    group: "vehicle_damages",
    message: "Puede avanzar si no tiene da\xF1os en esta zona",
    maxFiles: 5
  }
];
var complaintOtherDocumentRequirements = [
  {
    fileTypes: ["image", "pdf"],
    alias: "identity_card",
    message: "Puede subir multiples archivos",
    maxFiles: 5
  },
  {
    fileTypes: ["image"],
    alias: "incident_damage_photo",
    maxFiles: 10,
    message: "Puede subir multiples archivos"
  }
];

// ssot/validation-pattern.ts
var validationPatternList = {
  policy_number: {
    rivadavia: {
      extractor: (value) => {
        const [agency, ramo, policyNumber] = value.split("/");
        return {
          agency,
          ramo,
          policyNumber
        };
      },
      pattern: "^\\d{2}\\/\\d{2}\\/\\d{1,6}$",
      example: "01/01/123456"
    },
    tajy: {
      extractor: (value) => {
        const [ramo, policyNumber, endorsement] = value.split("-");
        return {
          endorsement,
          ramo,
          policyNumber
        };
      },
      pattern: "^\\d{4}-\\d{6}-\\d{2}$",
      example: "1234-123456-12"
    }
  }
};

// contracts/damage.contract.ts
var import_database36 = __toESM(require_index_browser4());
var import_piramid_constants52 = __toESM(require_dist2());
var import_zod71 = require("zod");

// contracts/vehicle.contract.ts
var import_database35 = __toESM(require_index_browser4());
var import_piramid_constants51 = __toESM(require_dist2());
var import_zod70 = require("zod");

// contracts/driver.contract.ts
var import_libphonenumber_js4 = require("libphonenumber-js");
var import_piramid_constants50 = __toESM(require_dist2());
var import_zod69 = require("zod");
var driverSchema = import_zod69.z.object({
  email: import_zod69.z.string().email().optional(),
  ownership: import_zod69.z.enum(import_piramid_constants50.driverVehicleOwnership),
  first_name: import_zod69.z.string().min(1, import_piramid_constants50.requiredFieldMessage),
  cellphone: import_zod69.z.string().optional().refine((value) => !value || (0, import_libphonenumber_js4.isValidPhoneNumber)(value), {
    message: "Celular inv\xE1lido"
  }),
  last_name: import_zod69.z.string().min(1, import_piramid_constants50.requiredFieldMessage),
  address: import_zod69.z.string().optional(),
  country: import_zod69.z.string().min(1, import_piramid_constants50.requiredFieldMessage),
  state: import_zod69.z.string().min(1, import_piramid_constants50.requiredFieldMessage),
  city: import_zod69.z.string().optional(),
  birth_date: import_zod69.z.coerce.date().optional(),
  driver_license_number: import_zod69.z.string().optional(),
  driver_identification_number: import_zod69.z.string().optional(),
  driver_identification_expended_date: import_zod69.z.coerce.date().optional()
});

// contracts/vehicle.contract.ts
var licensePlateBaseSchema = import_zod70.z.string().min(6, { message: "M\xEDnimo 6 caracteres" }).max(7, { message: "M\xE1ximo 7 caracteres" }).regex(/^[a-z0-9]+$/i, { message: "Solo se permiten letras y n\xFAmeros" }).transform((val) => val == null ? void 0 : val.toUpperCase());
var vehicleBaseSchema = import_zod70.z.object({
  market_value: import_zod70.z.string().optional(),
  document_type: import_zod70.z.enum(import_piramid_constants51.vehicleDocumentTypes).nullish(),
  driver: driverSchema.optional(),
  use: import_zod70.z.nativeEnum(import_database35.VehicleUseTypes).nullish(),
  make: import_zod70.z.string().min(1, import_piramid_constants51.requiredFieldMessage),
  model: import_zod70.z.string().min(1, import_piramid_constants51.requiredFieldMessage),
  vehicleId: import_zod70.z.coerce.string(),
  year: import_zod70.z.coerce.number().refine(
    (date) => {
      if (!date) {
        return false;
      }
      if (date > (/* @__PURE__ */ new Date()).getFullYear()) {
        return false;
      }
      return true;
    },
    {
      message: import_piramid_constants51.requiredFieldMessage
    }
  )
});
var vehicleWithLicensePlateSchema = vehicleBaseSchema.extend({
  category: import_zod70.z.literal("with_license_plate"),
  type: import_zod70.z.enum(import_piramid_constants51.withLicensePlateVehicleTypes),
  version: import_zod70.z.string().min(1, import_piramid_constants51.requiredFieldMessage),
  license_plate: licensePlateBaseSchema,
  chassis: import_zod70.z.string().regex(
    /^[a-zA-Z0-9*.-]+$/,
    "Campo requerido (Caracteres alfanum\xE9ricos, asterisco, guion, y punto)"
  ).max(20, "M\xE1ximo 20 caracteres").nullish(),
  engine: import_zod70.z.string().regex(
    /^[a-zA-Z0-9*.-]+$/,
    "Campo requerido (Caracteres alfanum\xE9ricos, asterisco, guion, y punto)"
  ).max(20, "M\xE1ximo 20 caracteres").nullish()
});
var vehicleWithoutLicensePlateSchema = vehicleBaseSchema.extend({
  category: import_zod70.z.literal("without_license_plate"),
  type: import_zod70.z.enum(import_piramid_constants51.withoutLicensePlateVehicleTypes)
});
var vehicleSchema = import_zod70.z.discriminatedUnion("category", [
  vehicleWithLicensePlateSchema,
  vehicleWithoutLicensePlateSchema
]);

// contracts/damage.contract.ts
var import_libphonenumber_js5 = require("libphonenumber-js");
var insuranceSchema = withApplicableFranchise(
  import_zod71.z.object({
    coverage: import_zod71.z.nativeEnum(import_database36.CoverageTypes),
    franchise_amount: franchiseAmountSchema,
    insurerId: import_zod71.z.coerce.string().min(1, import_piramid_constants52.requiredFieldMessage),
    insurer: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
    policy_number: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage)
  }).refine(
    ({ coverage, franchise_amount }) => {
      if (coverage === "all_risks_with_franchise" && !franchise_amount)
        return false;
      return true;
    },
    {
      message: import_piramid_constants52.requiredFieldMessage,
      path: ["franchise_amount"]
    }
  )
);
var realPropertySchema = import_zod71.z.object({
  isRealPropertyAddressSameAsVictimAddress: import_zod71.z.boolean(),
  country: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
  address_street: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
  address_number: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
  address_apartment: import_zod71.z.string().nullish(),
  state: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
  city: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage),
  zip_code: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage).regex(/^\d{4}$/, {
    message: "Debe tener 4 d\xEDgitos"
  }),
  type: import_zod71.z.enum(import_piramid_constants52.realPropertyTypes),
  ownership: import_zod71.z.enum(import_piramid_constants52.realPropertyOwnershipTypes),
  other_ownership: import_zod71.z.string().nullish(),
  other_type: import_zod71.z.string().nullish()
}).refine(
  (values) => {
    if (values.type === "other" && !values.other_type) return false;
    return true;
  },
  {
    path: ["other_type"],
    message: import_piramid_constants52.requiredFieldMessage
  }
).refine(
  (values) => {
    if (values.ownership === "other" && !values.other_ownership) return false;
    return true;
  },
  {
    path: ["other_ownership"],
    message: import_piramid_constants52.requiredFieldMessage
  }
);
var materialDamageBaseSchema2 = import_zod71.z.discriminatedUnion("hasInsurance", [
  import_zod71.z.object({
    type: import_zod71.z.nativeEnum(import_database36.MaterialDamageTypes),
    hasInsurance: import_zod71.z.literal(false),
    victim_role: import_zod71.z.nativeEnum(import_database36.VictimRoleTypes)
  }),
  import_zod71.z.object({
    hasInsurance: import_zod71.z.literal(true),
    insurance: insuranceSchema
  })
]);
var materialDamageVehicle = import_zod71.z.intersection(
  materialDamageBaseSchema2,
  import_zod71.z.object({
    type: import_zod71.z.literal("vehicle"),
    vehicle: vehicleSchema
  })
);
var materialDamageRealProperty = import_zod71.z.intersection(
  materialDamageBaseSchema2,
  import_zod71.z.object({
    type: import_zod71.z.literal("real_property"),
    real_property: realPropertySchema
  })
);
var materialDamageSubTypesSchema = import_zod71.z.union([materialDamageVehicle, materialDamageRealProperty]).describe("Datos del da\xF1o material");
var damageBaseSchema = import_zod71.z.object({
  description: import_zod71.z.string().optional().nullable().nullish(),
  fixed: import_zod71.z.boolean().default(false)
});
var materialDamageSchema = damageBaseSchema.extend({
  type: import_zod71.z.literal("material"),
  material: materialDamageSubTypesSchema
});
var damageSchema = import_zod71.z.discriminatedUnion("type", [
  damageBaseSchema.merge(materialDamageSchema),
  damageBaseSchema.merge(
    import_zod71.z.object({
      type: import_zod71.z.literal("person"),
      person: import_zod71.z.object({
        driver: import_zod71.z.object({
          first_name: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage).max(
            import_piramid_constants52.NATURAL_PERSON_NAME_MAX_LENGTH,
            import_piramid_constants52.naturalPersonNameMaxLengthMessage
          ),
          last_name: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage).max(
            import_piramid_constants52.NATURAL_PERSON_NAME_MAX_LENGTH,
            import_piramid_constants52.naturalPersonNameMaxLengthMessage
          ),
          cellphone: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage).refine(import_libphonenumber_js5.isValidPhoneNumber, {
            message: "Celular inv\xE1lido"
          }),
          country: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage).refine(countryRefine),
          state: import_zod71.z.string().min(1, import_piramid_constants52.requiredFieldMessage)
        }).optional().nullish(),
        details: import_zod71.z.array(
          import_zod71.z.object({
            body_parts: import_zod71.z.array(import_zod71.z.enum(import_piramid_constants52.bodyParts)).default([]).optional(),
            severity: import_zod71.z.nativeEnum(import_database36.PersonDamageDetailSeverityTypes),
            damage: import_zod71.z.nativeEnum(import_database36.PersonDamageDetailTypes)
          })
        ),
        hadSurgery: import_zod71.z.boolean(),
        hasHealthInsuranceFund: import_zod71.z.boolean(),
        health_insurance_fund: import_zod71.z.string(),
        surgery_description: import_zod71.z.string().optional().nullable().nullish(),
        wasTreatedByMedicalInstitution: import_zod71.z.boolean(),
        wasTreatedByWorkerCompensationInsurer: import_zod71.z.boolean(),
        hasIncomeVerification: import_zod71.z.boolean(),
        type: import_zod71.z.nativeEnum(import_database36.PersonDamageTypes),
        treatment_worker_compensation_insurer_id: import_zod71.z.coerce.string(),
        treatment_worker_compensation_insurer: import_zod71.z.string().optional().nullable().nullish(),
        treatment_medical_institution: import_zod71.z.string().optional().nullable().nullish(),
        victim_role: import_zod71.z.nativeEnum(import_database36.VictimRoleTypes),
        policyholder_relationship: import_zod71.z.nativeEnum(import_database36.PolicyHolderRelationshipTypes).or(import_zod71.z.literal("")).transform((value) => value ?? void 0).nullish(),
        policyholder_relationship_other: import_zod71.z.string().nullish()
      }).refine(
        (damage2) => {
          if (!damage2.victim_role) return true;
          if (damage2.victim_role !== "policyholder_rider") return true;
          return !!damage2.policyholder_relationship;
        },
        {
          path: ["policyholder_relationship"],
          message: import_piramid_constants52.requiredFieldMessage
        }
      ).refine(
        (personDamage2) => {
          if (personDamage2.policyholder_relationship === "other" && !personDamage2.policyholder_relationship_other)
            return false;
          return true;
        },
        {
          message: "Debe indicar el vinculo",
          path: ["policyholder_relationship_other"]
        }
      )
    })
  ),
  damageBaseSchema.merge(
    import_zod71.z.object({
      type: import_zod71.z.literal("recovery"),
      recovery: recoveryDamageSchema
    })
  )
]);

// contracts/document.contract.ts
var import_database37 = __toESM(require_index_browser4());
var import_zod72 = require("zod");
var documentSchema2 = import_zod72.z.object({
  token: import_zod72.z.string().describe("El token del archivo subido"),
  alias: import_zod72.z.nativeEnum(import_database37.TagAliases).describe("El tag, alias o prop\xF3sito del archivo")
});

// contracts/occurrence.contract.ts
var import_zod_openapi4 = require("@anatine/zod-openapi");
var import_piramid_constants53 = __toESM(require_dist2());
var import_zod73 = require("zod");
var TWENTY_FOUR_HOURS_REGEX = /^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/;
var occurrenceBaseSchema = import_zod73.z.object({
  police_station: import_zod73.z.string().optional().nullable().nullish(),
  criminal_case_number: import_zod73.z.coerce.string().max(6, "M\xE1ximo 6 d\xEDgitos").regex(/^\d+$/, "Unicamente d\xEDgitos").nullable().nullish().or(import_zod73.z.literal("")).transform((value) => !value ? void 0 : value),
  court: import_zod73.z.coerce.string().regex(/^\d+$/, "Unicamente d\xEDgitos").max(3, "M\xE1ximo 3 caracteres").optional().nullable().nullish().or(import_zod73.z.literal("")).transform((value) => !value ? void 0 : value),
  clerks_office: import_zod73.z.coerce.string().regex(/^\d+$/, "Unicamente d\xEDgitos").max(3, "M\xE1ximo 3 caracteres").optional().nullable().nullish().or(import_zod73.z.literal("")).transform((value) => !value ? void 0 : value),
  judicial_department: import_zod73.z.string().optional().nullable().nullish(),
  date: (0, import_zod_openapi4.extendApi)(
    import_zod73.z.coerce.date({
      errorMap: (issue, ctx) => {
        if (issue.code === "invalid_date" || issue.code === "invalid_type") {
          return { message: "Fecha inv\xE1lida" };
        }
        return { message: ctx.defaultError };
      }
    }).nullable().nullish().refine(
      (date) => {
        if (date && date.getTime() > (/* @__PURE__ */ new Date()).getTime()) {
          return false;
        }
        return true;
      },
      {
        message: "La fecha no puede ser mayor a la fecha actual"
      }
    ),
    {
      description: "Fecha de la ocurrencia del siniestro. Puede enviarse en formato ISO 8601 o en formato DD/MM/YYYY",
      example: "2021-01-01"
    }
  ),
  time: (0, import_zod_openapi4.extendApi)(
    import_zod73.z.string().regex(TWENTY_FOUR_HOURS_REGEX, {
      message: "El formato de la hora debe ser HH:MM"
    }),
    {
      description: "Hora de la ocurrencia del siniestro. Formato HH:MM",
      example: "12:00"
    }
  ),
  address: (0, import_zod_openapi4.extendApi)(import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage), {
    description: "Direcci\xF3n de la ocurrencia del siniestro",
    example: "Av. Mcal. L\xF3pez 1234"
  }),
  country: import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage),
  state: (0, import_zod_openapi4.extendApi)(import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage), {
    description: "Departamento/Provincia/Estado de la ocurrencia del siniestro",
    example: "Central"
  }),
  city: (0, import_zod_openapi4.extendApi)(
    import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage).describe("Ciudad/Municipio"),
    {
      example: "Asunci\xF3n"
    }
  ),
  zip_code: import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage).regex(/^\d{4}$/, {
    message: "Debe tener 4 d\xEDgitos"
  }),
  description: (0, import_zod_openapi4.extendApi)(import_zod73.z.string().min(1, import_piramid_constants53.requiredFieldMessage), {
    description: "Descripci\xF3n de la ocurrencia del siniestro",
    example: "El veh\xEDculo se encontraba estacionado en la v\xEDa p\xFAblica"
  })
}).describe("Datos relacionados al hecho del siniestro");
var occurrenceSchema2 = occurrenceBaseSchema;

// contracts/complaint.contract.ts
var retrieveComplaintDetailRequestParams = import_zod74.z.object({
  id: import_zod74.z.coerce.string()
});
var formSteps = ["select-service", "claim-branch"];
var tajyOccurrenceSchema = occurrenceBaseSchema.pick({
  city: true,
  description: true,
  address: true,
  time: true
}).extend({
  date: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.coerce.date().refine(
      (date) => {
        if (date && date.getTime() > (/* @__PURE__ */ new Date()).getTime()) {
          return false;
        }
        return true;
      },
      {
        message: "La fecha no puede ser mayor a la fecha actual"
      }
    ),
    {
      description: "Dia de la ocurrencia del siniestro. Puede enviarse en formato ISO 8601 o en formato DD/MM/YYYY",
      example: "2024-01-24T03:00:00.000Z"
    }
  )
}).describe("Datos del hecho del siniestro");
var tajyPolicyNumberSchema = (0, import_zod_openapi5.extendApi)(
  import_zod74.z.string().min(1, "Campo requerido").describe(
    "N\xFAmero de p\xF3liza. Debe tener el formato: {secci\xF3n|ramo}-{p\xF3liza}-{endoso}. En los segmentos unicamente se pueden enviar n\xFAmeros. La secci\xF3n/ramo debe estar incluida en la lista de secciones/ramos configuradas para la empresa"
  ).regex(new RegExp(validationPatternList.policy_number.tajy.pattern)),
  {
    example: "0501-352304-0"
  }
);
var complaintPolicyholderSchema = import_zod74.z.object({
  person_type: import_zod74.z.nativeEnum(import_database38.PersonType),
  identification: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string().min(1, "Campo requerido").describe(
      "En caso de ser persona f\xEDsica: C\xE9dula de identidad. En caso de ser persona jur\xEDdica: EIN/RUC/CUIL"
    ),
    {
      example: "44188219",
      required: ["identification"]
    }
  ),
  email: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string({
      invalid_type_error: "Debe ser un email v\xE1lido",
      required_error: "Campo requerido"
    }).email("Debe ser un email v\xE1lido").min(1, "Campo requerido"),
    {
      example: "johndoe@gmail.com"
    }
  )
}).describe("Datos del asegurado");
var complaintBaseSchema = import_zod74.z.object({
  occurrence: occurrenceBaseSchema,
  policyholder: complaintPolicyholderSchema,
  documents: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.array(documentSchema2).default([]).describe("Documentos"),
    {
      example: [
        {
          alias: "vehicle_damage_photo_roof",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwic3RvcmVkX25hbWUiOiJiODJmMTk0NS04NTY4LTQ5NjQtYmVlNi0zMmVjNjJjMTRlMDctY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwiaWF0IjoxNzA2MTQxNTY4LCJleHAiOjE3MDY3NDYzNjh9.mypGGe7Qvmf566e0TO4d_iMUDk4zUBlA9fTF6y6L5To"
        }
      ]
    }
  ),
  damages: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.array(damageSchema).default([]).describe("Da\xF1os ocurridos en el siniestro"),
    {
      example: [
        {
          type: "material",
          material: {
            type: "vehicle",
            vehicle: {
              category: "with_license_plate",
              driver: {
                ownership: "owner",
                email: "lucianoalvarez1212@gmail.com",
                first_name: "Luciano",
                last_name: "Alvarez",
                cellphone: "03813635420",
                driver_license_number: "2020",
                driver_identification_number: "23232",
                driver_identification_expended_date: "2024-01-23T03:00:00.000Z",
                address: "testing 100",
                birth_date: "2024-01-23T03:00:00.000Z"
              },
              engine: "3232",
              chassis: "3232",
              license_plate: "3232222",
              year: 222,
              type: "car",
              use: "private",
              make: "JEEP",
              model: "RENEGADE",
              version: "1.8 4X2 LONGITUDE AT",
              vehicleId: 1895
            },
            hasInsurance: false
          },
          description: "Venia manejando y me chocaron",
          fixed: false
        }
      ]
    }
  )
});
var createComplaintVehicleSchema = import_zod74.z.object({
  identification_key: (0, import_zod_openapi5.extendApi)(import_zod74.z.nativeEnum(import_database38.VehicleIdentificationKeys), {
    description: "Tipo de identificaci\xF3n del veh\xEDculo. Si es license_plate, se requiere patente. Si es chassis, se requiere n\xFAmero de chasis"
  }),
  license_plate: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string().nullish().transform(
      (val) => val ? val.toUpperCase().trim().replace(/ /g, "") : null
    ),
    {
      description: "Patente del veh\xEDculo. Requerido cuando identificaci\xF3n_key es license_plate",
      example: "ABC123"
    }
  ),
  chassis: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().nullish(), {
    description: "Chasis del veh\xEDculo. Requerido cuando identificaci\xF3n_key es chassis",
    example: "ABC123"
  }),
  damage_description: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    description: "Descripci\xF3n de los da\xF1os del veh\xEDculo",
    example: "Paragolpes trasero roto. Vidrio roto."
  }),
  type: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.enum(import_piramid_constants54.complaintWithLicensePlateVehicleTypes, {
      errorMap: (issue, ctx) => ({ message: import_piramid_constants54.requiredFieldMessage })
    }),
    {
      description: "Tipo de veh\xEDculo",
      example: "car"
    }
  ),
  make: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Jeep",
    description: "Marca del veh\xEDculo"
  }),
  model: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Renegade",
    description: "Modelo del veh\xEDculo"
  }),
  registration_city: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Aregua",
    description: "Municipio de registro del veh\xEDculo"
  }),
  driver: import_zod74.z.object({
    first_name: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      description: "Nombre del conductor",
      example: "John"
    }),
    last_name: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "Doe",
      description: "Apellido del conductor"
    }),
    identification: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "12345678",
      description: "N\xFAmero de documento del conductor"
    }),
    cellphone: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "12345678",
      description: "N\xFAmero de celular del conductor"
    }),
    address: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "Av. Corrientes 1234",
      description: "Direcci\xF3n del conductor"
    }),
    city: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "AREGUA",
      description: "Ciudad del conductor. Debe coincidir con una ciudad del sistema"
    }),
    age: (0, import_zod_openapi5.extendApi)(
      import_zod74.z.number({
        errorMap: () => ({ message: import_piramid_constants54.requiredFieldMessage })
      }).int(),
      {
        example: 30,
        description: "Edad del conductor"
      }
    ),
    license_number: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
      example: "12345678",
      description: "N\xFAmero de licencia del conductor"
    }),
    license_issue_date: (0, import_zod_openapi5.extendApi)(import_zod74.z.coerce.date(), {
      example: "2021-01-01",
      description: "Fecha de emisi\xF3n de la licencia del conductor"
    }),
    license_category_type: (0, import_zod_openapi5.extendApi)(
      import_zod74.z.string().min(1, "Campo requerido").transform((value) => value.trim()),
      {
        example: "PARTICULAR",
        description: "Tipo de licencia del conductor. El valor debe coincidir con una de las opciones que se encuentran en la base de datos configurada para la empresa"
      }
    ),
    license_category_other: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().optional().nullable(), {
      example: "PROF. B",
      description: "Categor\xEDa de licencia del conductor. Requerido si la opcion `license_category_type` cumple el rol de otro"
    })
  }).superRefine((driver, ctx) => {
    if (driver.license_category_type === "other" && !driver.license_category_other) {
      ctx.addIssue({
        code: import_zod74.z.ZodIssueCode.custom,
        message: import_piramid_constants54.requiredFieldMessage,
        path: ["license_category_other"]
      });
    }
  }).describe("Datos del conductor del veh\xEDculo")
}).describe("Datos del veh\xEDculo del asegurado");
var complaintThirdPartyVehicleSchema = import_zod74.z.object({
  make: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Jeep",
    description: "Marca del veh\xEDculo del tercero involucrado en el siniestro"
  }),
  model: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Renegade",
    description: "Modelo del veh\xEDculo del tercero involucrado en el siniestro"
  }),
  year: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.number({
      invalid_type_error: import_piramid_constants54.requiredFieldMessage,
      required_error: import_piramid_constants54.requiredFieldMessage
    }).int().min(1, "Campo requerido"),
    {
      example: 2019,
      description: "A\xF1o del veh\xEDculo del tercero involucrado en el siniestro"
    }
  ),
  license_plate: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string().min(1, "Campo requerido").transform((val) => val.toUpperCase().trim().replace(/ /g, "")),
    {
      example: "ABC123",
      description: "Patente del veh\xEDculo del tercero involucrado en el siniestro"
    }
  ),
  damage_description: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    description: "Descripci\xF3n de los da\xF1os del veh\xEDculo del tercero involucrado en el siniestro",
    example: "Paragolpes trasero roto. Vidrio roto."
  }),
  registration_city: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Aregua",
    description: "Municipio de registro del veh\xEDculo del tercero involucrado en el siniestro"
  }),
  type: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.enum(import_piramid_constants54.complaintWithLicensePlateVehicleTypes, {
      errorMap: (issue, ctx) => ({ message: import_piramid_constants54.requiredFieldMessage })
    }),
    {
      description: "Tipo de veh\xEDculo del tercero involucrado en el siniestro",
      example: "car"
    }
  )
}).describe("Datos del veh\xEDculo del tercero involucrado en el siniestro");
var complaintThirdPartySchema = import_zod74.z.object({
  first_name: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "John",
    description: "Nombre del tercero involucrado en el siniestro"
  }),
  last_name: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "Doe",
    description: "Apellido del tercero involucrado en el siniestro"
  }),
  identification: (0, import_zod_openapi5.extendApi)(import_zod74.z.string().min(1, "Campo requerido"), {
    example: "12345678",
    description: "N\xFAmero de documento del tercero involucrado en el siniestro"
  }),
  vehicle: complaintThirdPartyVehicleSchema
}).describe("Datos relacionados del tercero involucrado en el siniestro");
var tajyComplaintVehicleOccurrence = tajyOccurrenceSchema.extend({
  police_intervention: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.boolean().optional().default(false).describe("Indica si hubo intervenci\xF3n policial"),
    {
      example: true
    }
  ),
  witnesses_info: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string().optional().nullish().describe("Informaci\xF3n de los testigos que presenciaron el hecho"),
    {
      example: "Nombre: Juan Perez, Tel\xE9fono: 0981234567"
    }
  ),
  speed: (0, import_zod_openapi5.extendApi)(import_zod74.z.number().int(), {
    description: "Velocidad del veh\xEDculo en km/h",
    example: 60
  }),
  circulation_direction: (0, import_zod_openapi5.extendApi)(import_zod74.z.nativeEnum(import_database38.CirculationDirection), {
    description: "Sentido de circulaci\xF3n del veh\xEDculo",
    example: "one_way"
  })
});
var signatureSchema = import_zod74.z.object({
  token: import_zod74.z.string().min(1, import_piramid_constants54.requiredFieldMessage).describe("El token de la imagen de la firma subido por el cliente")
});
var tajyCreateComplaintRequestBody = import_zod74.z.object({
  documents: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.array(documentSchema2).default([]).describe(
      `Documentaci\xF3n necesaria para la denuncia. En el caso de las im\xE1genes de los da\xF1os al veh\xEDculo, m\xEDnimo se debe enviar una de la siguientes im\xE1genes: ${complaintDocumentRequirements.filter((d3) => d3.optional && d3.group === "vehicle_damages").map((d3) => `\`${d3.alias}\``).join(", ")}.
            En el caso de los documentos, se debe enviar m\xEDnimo uno de los siguientes archivos: ${complaintDocumentRequirements.filter((d3) => d3.optional && d3.group === "documentation").map((d3) => `\`${d3.alias}\``).join(", ")}
            `
    ),
    {
      example: [
        {
          alias: "identity_card",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiMDYxNzdkOGQtNGI1Zi00ODI3LThiNzMtOTYwMDQ3MGU2ZDBjLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI0ODgsImV4cCI6MTcwNjg4NzI4OH0.B26SPeNr4lnLwyQqfu10gjPJ8iFUz3Z-4vhcp7ml0DI"
        },
        {
          alias: "driver_license",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiMWIzZmJlNDAtZmMwZS00MDE4LWJmZjAtYTYxODgxZWE5NDEyLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI0OTUsImV4cCI6MTcwNjg4NzI5NX0.VC6qt9tDDGxxgqShnGNieIK0vEe8mYh98ZRonDZrDyY"
        },
        {
          alias: "vehicle_registration_card",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiOTQyZGZlMjYtMGRlOC00OTNlLTkwOGEtMTQ0Mjc0MWRkMDliLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI1MDksImV4cCI6MTcwNjg4NzMwOX0.GZZbBQzIPEBqJYuJl7QjZ1f1QqWbGx7JQOeUa4e4BtU"
        },
        {
          alias: "vehicle_authorization_document",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiOTQyZGZlMjYtMGRlOC00OTNlLTkwOGEtMTQ0Mjc0MWRkMDliLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI1MDksImV4cCI6MTcwNjg4NzMwOX0.GZZbBQzIPEBqJYuJl7QjZ1f1QqWbGx7JQOeUa4e4BtU"
        },
        {
          alias: "vehicle_side_left",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiOTQyZGZlMjYtMGRlOC00OTNlLTkwOGEtMTQ0Mjc0MWRkMDliLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI1MDksImV4cCI6MTcwNjg4NzMwOX0.GZZbBQzIPEBqJYuJl7QjZ1f1QqWbGx7JQOeUa4e4BtU"
        },
        {
          alias: "vehicle_roof",
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiYXBwLmF1dG9zaWduLmNvbS5hcl9zaWduX2NscnA3NHZ1NzAwb3oxMHI1NzRuYXM0ZHFfc2VudF90b2tlbj00NzEyMjM3NGVjMmM0YWY5ZjQyOTg0ZDdkYzhjMTFlYmY2OWZhMDQ2NTg1NTcwYmI4YzRlNjRlYzYyOTBjN2ZhLnBuZyIsInN0b3JlZF9uYW1lIjoiOTQyZGZlMjYtMGRlOC00OTNlLTkwOGEtMTQ0Mjc0MWRkMDliLWFwcC5hdXRvc2lnbi5jb20uYXJfc2lnbl9jbHJwNzR2dTcwMG96MTByNTc0bmFzNGRxX3NlbnRfdG9rZW49NDcxMjIzNzRlYzJjNGFmOWY0Mjk4NGQ3ZGM4YzExZWJmNjlmYTA0NjU4NTU3MGJiOGM0ZTY0ZWM2MjkwYzdmYS5wbmciLCJpYXQiOjE3MDYyODI1MDksImV4cCI6MTcwNjg4NzMwOX0.GZZbBQzIPEBqJYuJl7QjZ1f1QqWbGx7JQOeUa4e4BtU"
        }
      ]
    }
  ),
  occurrence: tajyComplaintVehicleOccurrence,
  policyholder: complaintPolicyholderSchema,
  vehicle: createComplaintVehicleSchema.refine(
    (data) => {
      if (data.identification_key === "license_plate" && !data.license_plate)
        return false;
      return true;
    },
    {
      message: "If identification_key is license_plate, you must provide license_plate",
      path: ["license_plate"]
    }
  ).refine(
    (data) => {
      if (data.identification_key === "chassis" && !data.chassis)
        return false;
      return true;
    },
    {
      message: "If identification_key is chassis, you must provide chassis",
      path: ["chassis"]
    }
  ),
  third_party: complaintThirdPartySchema.optional().nullish(),
  signature: signatureSchema
});
var complaintOtherSubTypes = [
  "building",
  "glass",
  "medical_assistance_accident",
  "electronic_equipment",
  "theft",
  "other"
];
var complaintOtherSubTypeSchema = import_zod74.z.enum(complaintOtherSubTypes).describe("El tipo de denuncia o riesgo");
var complaintOtherOccurrenceSchema = tajyOccurrenceSchema.omit({
  city: true
}).extend({
  damage_description: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.string().min(1, "Campo requerido").describe(
      "Descripcion generica de los da\xF1os ocasionados por el siniestro"
    ),
    {
      example: "Garage incendiado. Da\xF1os en el techo."
    }
  )
});
var tajyCreateComplaintOtherRequestBody = import_zod74.z.object({
  type: (0, import_zod_openapi5.extendApi)(complaintOtherSubTypeSchema, {
    example: "building"
  }),
  documents: (0, import_zod_openapi5.extendApi)(
    import_zod74.z.array(documentSchema2).default([]).describe(
      `Archivos a enviarse necesarios para la denuncia. Los documentos requeridos son (alias): ${complaintOtherDocumentRequirements.filter((d3) => !d3.optional).map((d3) => `\`${d3.alias}\``).join(", ")}
.
          Se pueden enviar multiples documentos usando un mismo alias`
    ),
    {
      example: [
        {
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwic3RvcmVkX25hbWUiOiJiODJmMTk0NS04NTY4LTQ5NjQtYmVlNi0zMmVjNjJjMTRlMDctY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwiaWF0IjoxNzA2MTQxNTY4LCJleHAiOjE3MDY3NDYzNjh9.mypGGe7Qvmf566e0TO4d_iMUDk4zUBlA9fTF6y6L5To",
          alias: "identity_card"
        },
        {
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwic3RvcmVkX25hbWUiOiJiODJmMTk0NS04NTY4LTQ5NjQtYmVlNi0zMmVjNjJjMTRlMDctY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwiaWF0IjoxNzA2MTQxNTY4LCJleHAiOjE3MDY3NDYzNjh9.mypGGe7Qvmf566e0TO4d_iMUDk4zUBlA9fTF6y6L5To",
          alias: "incident_damage_photo"
        },
        {
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJvcmlnaW5hbF9uYW1lIjoiY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwic3RvcmVkX25hbWUiOiJiODJmMTk0NS04NTY4LTQ5NjQtYmVlNi0zMmVjNjJjMTRlMDctY3VzdG9tZXIucGlyYW1pZC5sb2NhbGhvc3RfY29tcGxhaW50X2NyZWF0ZV9zZXNzaW9uPTBlNmE5MmQ1MWM2YTM5NWQzODJjNmJiMDhiMTkxYjM4NzliODMwZGEwN2E2MjRhZmVhMjMzZjBmMGZmZjFkOTgucG5nIiwiaWF0IjoxNzA2MTQxNTY4LCJleHAiOjE3MDY3NDYzNjh9.mypGGe7Qvmf566e0TO4d_iMUDk4zUBlA9fTF6y6L5To",
          alias: "incident_damage_photo"
        }
      ]
    }
  ),
  policyholder: complaintPolicyholderSchema,
  occurrence: complaintOtherOccurrenceSchema,
  signature: signatureSchema
});
var tajyCreateComplaintSchema = complaintBaseSchema.omit({
  occurrence: true
}).extend({
  occurrence: tajyOccurrenceSchema
});
var rivadaviaCreateComplaintSchema = complaintBaseSchema.merge(
  import_zod74.z.object({})
);
var unionComplaintSchema = import_zod74.z.discriminatedUnion("backend", [
  tajyCreateComplaintSchema.merge(
    import_zod74.z.object({
      backend: import_zod74.z.literal("tajy")
    })
  )
]);
var createComplaintRequestBody = import_zod74.z.object({
  data: unionComplaintSchema,
  endpoint: import_zod74.z.string().min(1)
});
var listInsurerComplaintsRequestQuery = paginateRequestQuery.extend({
  team: import_zod74.z.array(import_zod74.z.coerce.string()).default([]),
  date_from: import_zod74.z.coerce.date().optional().nullable(),
  date_to: import_zod74.z.coerce.date().optional().nullable(),
  responsible: import_zod74.z.array(import_zod74.z.coerce.string()).default([]),
  system_status: import_zod74.z.array(import_zod74.z.nativeEnum(import_database38.ComplaintSystemStatus)).default([]),
  type: import_zod74.z.array(import_zod74.z.nativeEnum(import_database38.ComplaintType)).default([]),
  ramo: import_zod74.z.array(import_zod74.z.string().min(1)).default([]),
  status: import_zod74.z.array(import_zod74.z.string().min(1)).default([]),
  references: import_zod74.z.array(import_zod74.z.string().min(1)).default([]),
  stages: import_zod74.z.array(import_zod74.z.string().min(1)).default([])
});
var retrieveComplaintRequestParamsSchema = import_zod74.z.object({
  complaintId: import_zod74.z.coerce.string()
});
var addComplaintCollaboratorRequestBody = addClaimCollaboratorRequestBody;
var assignComplaintResponsibleRequestBody = import_zod74.z.object({
  userId: import_zod74.z.string()
});
var removeComplaintCollaboratorRequestParams = import_zod74.z.object({
  userId: import_zod74.z.coerce.string(),
  complaintId: import_zod74.z.coerce.string()
});
var updateComplaintStatusRequestParams = import_zod74.z.object({
  statusId: import_zod74.z.coerce.string(),
  complaintId: import_zod74.z.coerce.string()
});
var updateComplaintSinisterCauseRequestBody = import_zod74.z.object({
  complaint_sinister_cause_id: import_zod74.z.coerce.string()
});
var checkComplaintAttributeRequestQuery = import_zod74.z.discriminatedUnion(
  "attribute",
  [
    import_zod74.z.object({
      attribute: import_zod74.z.literal("license_plate"),
      license_plate: import_zod74.z.string().min(1).transform((val) => val.toUpperCase().trim().replace(/ /g, "")),
      policyholder_identification: import_zod74.z.string().min(1),
      policyholder_person_type: import_zod74.z.nativeEnum(import_database38.PersonType)
    }),
    import_zod74.z.object({
      attribute: import_zod74.z.literal("chassis"),
      chassis: import_zod74.z.string().min(1),
      policyholder_identification: import_zod74.z.string().min(1),
      policyholder_person_type: import_zod74.z.nativeEnum(import_database38.PersonType)
    }),
    import_zod74.z.object({
      attribute: import_zod74.z.literal("policyholder"),
      policyholder_person_type: import_zod74.z.nativeEnum(import_database38.PersonType),
      policyholder_identification: import_zod74.z.string().min(1),
      non_automotive_active_policy: import_zod74.z.enum(["true", "false"]).transform((v) => v === "true")
    })
  ]
);
var proxyListComplaintCoveragesRequestQuery = import_zod74.z.object({
  policy_number: import_zod74.z.string().min(1, "Campo requerido"),
  section: import_zod74.z.string().min(1, "Campo requerido"),
  endorsement: import_zod74.z.string().min(1, "Campo requerido")
});
var proxyCreateComplaintRequestBody = import_zod74.z.object({
  sinister_cause_id: import_zod74.z.coerce.string({
    invalid_type_error: import_piramid_constants54.requiredFieldMessage,
    required_error: import_piramid_constants54.requiredFieldMessage
  }).min(1),
  policy_section: import_zod74.z.string().min(1, import_piramid_constants54.requiredFieldMessage),
  policy_number: import_zod74.z.string().min(1, import_piramid_constants54.requiredFieldMessage),
  policy_endorsement: import_zod74.z.string().min(1, import_piramid_constants54.requiredFieldMessage),
  coverages: import_zod74.z.array(
    import_zod74.z.object({
      name: import_zod74.z.string().min(1),
      index: import_zod74.z.coerce.number()
    })
  ).min(1, "Selecciona al menos una cobertura")
});
var rejectComplaintRequestBody = import_zod74.z.object({
  reason: import_zod74.z.string().min(1)
});
var listAffectedCoveragesRequestQuery = import_zod74.z.object({
  search: import_zod74.z.string().nullish()
});
var proxyListOrderQuantityDescriptionRequestQuery = import_zod74.z.object({
  order_type: import_zod74.z.nativeEnum(import_database38.OrderType),
  order_sub_type: import_zod74.z.nativeEnum(import_database38.OrderSubType)
}).refine(
  (val) => {
    return import_piramid_constants54.orderTypeSubTypes[val.order_type].includes(val.order_sub_type);
  },
  {
    message: "El sub-tipo de orden no es v\xE1lido para el tipo de orden",
    path: ["order_type", "order_sub_type"]
  }
);
var listDelegatedComplaintsRequestQuery = paginateRequestQuery.extend(
  {}
);
var restoreDelegatedComplaintsRequestBody = import_zod74.z.object({
  ids: import_zod74.z.array(import_zod74.z.coerce.string()).min(1).max(20).refine((items) => new Set(items).size === items.length, {
    message: "Duplicated ids"
  })
});
var delegateComplaintHandlingRequestBody = import_zod74.z.discriminatedUnion(
  "strategy",
  [
    import_zod74.z.object({
      strategy: import_zod74.z.literal("users"),
      users: import_zod74.z.array(
        import_zod74.z.object({
          id: import_zod74.z.coerce.string()
        })
      ).min(1, "M\xEDnimo 1 usuario").max(50, "M\xE1ximo 50 usuarios").refine(
        (users) => new Set(users.map((u2) => u2.id)).size === users.length,
        {
          message: "Usuarios duplicados!"
        }
      )
    }),
    import_zod74.z.object({
      strategy: import_zod74.z.literal("team"),
      team: import_zod74.z.coerce.string()
    })
  ],
  {
    required_error: import_piramid_constants54.requiredFieldMessage,
    invalid_type_error: import_piramid_constants54.requiredFieldMessage
  }
);
var updateComplaintRequestBody = import_zod74.z.object({
  is_recoverable: import_zod74.z.boolean().default(false),
  requires_spare_parts: import_zod74.z.boolean().default(false)
});

// contracts/policyholder.contract.ts
var import_zod75 = require("zod");
var listPolicyholderInspectionsRequestParams = import_zod75.z.object({
  policyholder_id: import_zod75.z.coerce.string()
});
var fetchPolicyholderInspectionDetailRequestParams = import_zod75.z.object({
  policyholder_id: import_zod75.z.coerce.string(),
  inspection_id: import_zod75.z.coerce.string()
});

// contracts/integration.contract.ts
var import_database39 = __toESM(require_index_browser4());
var import_zod76 = require("zod");
var fetchIntegrationConnectionRequestQuery = import_zod76.z.object({
  backend: import_zod76.z.nativeEnum(import_database39.IntegrationBackendType)
});

// contracts/notification.contract.ts
var import_piramid_constants55 = __toESM(require_dist2());
var import_zod77 = require("zod");
var batchReadNotificationsRequestBody = import_zod77.z.object({
  ids: import_zod77.z.array(import_zod77.z.coerce.string().min(1)).max(50)
});
var patchTopicSubscriptionsRequestBody = import_zod77.z.object({
  subscriptions: import_zod77.z.array(
    import_zod77.z.object({
      topic_id: import_zod77.z.coerce.string(),
      protocols: import_zod77.z.array(
        import_zod77.z.enum(["email", "push"])
      ).default([])
    })
  )
});
var listNotificationsRequestQuery = paginateRequestQuery.extend({
  scope: import_zod77.z.enum(import_piramid_constants55.notificationScopes).default("unread"),
  claim_id: import_zod77.z.string().min(1).optional(),
  exclude_claim_notifications: import_zod77.z.enum(import_piramid_constants55.booleansString).optional()
}).refine((q2) => !(q2.claim_id && q2.exclude_claim_notifications === "true"), {
  message: "claim_id and exclude_claim_notifications=true are mutually exclusive",
  path: ["exclude_claim_notifications"]
});

// contracts/coverages.contract.ts
var import_zod78 = require("zod");
var retrieveAffectedCoverageRequestParams = import_zod78.z.object({
  affectedCoverageId: import_zod78.z.coerce.string()
});

// helpers/build-schema-from-estimates-definition.ts
var import_zod79 = require("zod");
var import_decimal5 = require("decimal.js");
var import_piramid_constants56 = __toESM(require_dist2());
var buildSchemaFromEstimatesDefinition = (estimatesDefinition) => {
  return import_zod79.z.object(
    estimatesDefinition.operands.reduce((acc, operand) => {
      let propSchema = import_zod79.z.number({
        invalid_type_error: import_piramid_constants56.requiredFieldMessage,
        required_error: import_piramid_constants56.requiredFieldMessage
      });
      if (operand.min_value) {
        propSchema = propSchema.min(new import_decimal5.Decimal(operand.min_value).toNumber(), {
          message: `El valor m\xEDnimo es: ${operand.min_value}`
        });
      }
      if (operand.max_value) {
        propSchema = propSchema.max(new import_decimal5.Decimal(operand.max_value).toNumber(), {
          message: `El valor m\xE1ximo es: ${operand.min_value}`
        });
      }
      return {
        ...acc,
        [operand.natural_key]: propSchema
      };
    }, {})
  );
};

// helpers/alert-environment-tag.ts
var import_zod80 = require("zod");
var import_piramid_constants57 = __toESM(require_dist2());
var alertEnvironmentEnvSchema = import_zod80.z.object({
  [import_piramid_constants57.ALERT_ENVIRONMENT_TAG]: import_zod80.z.enum(import_piramid_constants57.alertEnvironmentTags).optional()
});
var withAlertEnvironmentTag = (tag, environmentTag) => environmentTag ? `${tag} ${environmentTag}` : `${tag}`;

// helpers/public-assets-env.ts
var import_zod81 = require("zod");
var import_piramid_constants58 = __toESM(require_dist2());
var publicAssetsEnvSchema = import_zod81.z.object({
  [import_piramid_constants58.PUBLIC_ASSETS_BASE_URL]: import_zod81.z.string().url().optional()
});

// contracts/expert-appraisal.contract.ts
var import_zod82 = require("zod");
var listExpertAppraisalPhotosRequestParams = import_zod82.z.object({
  id: import_zod82.z.coerce.string()
});

// helpers/get-claim-damage.ts
function getClaimDamage(fields7, targets, predicate) {
  const damages = Array.isArray(fields7) ? fields7 : fields7.damages;
  if (!damages)
    return {
      found: false
    };
  const index = damages.findIndex((damage2) => {
    const target = Array.isArray(targets) ? targets.some((target2) => target2 === damage2.type) : damage2.type === targets;
    const predicateOutput = predicate ? predicate(damage2) : true;
    return !!target && !!predicateOutput;
  });
  return {
    damage: damages[index],
    found: index !== -1,
    index
  };
}

// helpers/get-victim-identification.ts
var getVictimIdentification = (victim) => {
  var _a, _b;
  if (!victim) return null;
  if (victim.type === "natural_person")
    return ((_a = victim.natural_person) == null ? void 0 : _a.identification_value) ?? null;
  if (victim.type === "legal_person") return ((_b = victim.legal_person) == null ? void 0 : _b.cuit) ?? null;
  return null;
};

// helpers/validate-claim-estimate-value.ts
var import_decimal6 = __toESM(require("decimal.js"));
var composedEstimateAttributes = [
  {
    estimatesProps: ["person_judicial_amount", "material_judicial_amount"],
    permissionSuffix: "judicial_amount"
  },
  {
    estimatesProps: [
      "person_administrative_amount",
      "material_administrative_amount"
    ],
    permissionSuffix: "administrative_amount"
  }
];
var toDecimal = (value) => value === null || value === void 0 || value === "" ? new import_decimal6.default(0) : new import_decimal6.default(value.toString());
var isPercentageProp = (estimateProp) => percentageEstimatesProps.includes(estimateProp);
var validateClaimEstimateValue = (estimateProp, nextClaimState, currentClaimState, user) => {
  if (estimatesImposterProps.includes(estimateProp))
    return {
      can: true,
      metadata: {
        estimateProp
      }
    };
  const resolveAction = () => {
    const currentPropValue = currentClaimState[estimateProp];
    if (!currentPropValue) return "create";
    return "update";
  };
  const action = resolveAction();
  const estimatesGroup = composedEstimateAttributes.find(
    (group) => group.estimatesProps.includes(estimateProp)
  );
  const permissionSuffix = estimatesGroup ? estimatesGroup.permissionSuffix : estimateProp;
  const targetPermissionKey = `can_${action}_${permissionSuffix}`;
  const permission = user.override_permissions.find(
    (p) => p.type === targetPermissionKey
  );
  if (!permission)
    return {
      can: false,
      reason: "missing_permission",
      metadata: {
        estimateProp,
        targetPermissionKey
      }
    };
  const computeEstimateValue = (state) => {
    const estimatePropValue = toDecimal(state[estimateProp]);
    if (estimatesGroup)
      return estimatesGroup.estimatesProps.filter((prop) => prop !== estimateProp).reduce(
        (acc, groupEstimatesProp) => acc.add(toDecimal(state[groupEstimatesProp])),
        estimatePropValue
      );
    return estimatePropValue;
  };
  const resolveNextState = () => {
    const submittedProps = Object.entries(nextClaimState).filter(
      ([, value]) => value !== void 0
    );
    return {
      ...currentClaimState,
      ...Object.fromEntries(submittedProps)
    };
  };
  const currentEstimateValue = computeEstimateValue(currentClaimState);
  const nextEstimatePropValue = computeEstimateValue(resolveNextState());
  switch (action) {
    case "create": {
      if (!permission.limit)
        return {
          can: true,
          metadata: {
            estimateProp
          }
        };
      const limit = toDecimal(permission.limit);
      if (nextEstimatePropValue.lessThanOrEqualTo(limit))
        return {
          can: true,
          metadata: {
            estimateProp
          }
        };
      return {
        can: false,
        reason: "limit_exceeded",
        metadata: {
          limit: limit.toString(),
          total: nextEstimatePropValue.toString(),
          estimateProp
        }
      };
    }
    case "update": {
      if (!permission.relative_deviation_percentage)
        return {
          can: true,
          metadata: {
            estimateProp
          }
        };
      const coefficientWeight = isPercentageProp(estimateProp) ? new import_decimal6.default(permission.relative_deviation_percentage) : currentEstimateValue.mul(permission.relative_deviation_percentage).div(100);
      const range = {
        from: currentEstimateValue.sub(coefficientWeight),
        to: currentEstimateValue.add(coefficientWeight)
      };
      const can = nextEstimatePropValue.greaterThanOrEqualTo(range.from) && nextEstimatePropValue.lessThanOrEqualTo(range.to);
      if (can)
        return {
          can: true,
          metadata: {
            estimateProp
          }
        };
      return {
        can: false,
        reason: "out_of_range",
        metadata: {
          from: range.from.toString(),
          to: range.to.toString(),
          current: currentEstimateValue.toString(),
          total: nextEstimatePropValue.toString(),
          estimateProp
        }
      };
    }
  }
};

// helpers/diff-claim-estimates.ts
var import_decimal7 = __toESM(require("decimal.js"));
var normalizeClaimEstimateValue = (value) => {
  if (value === null || value === void 0 || value === "") return null;
  return new import_decimal7.default(value.toString()).toString();
};
var hasUnrecordedEstimateChange = (currentValue, lastRecordedChange) => {
  if (!lastRecordedChange) return false;
  return normalizeClaimEstimateValue(currentValue) !== normalizeClaimEstimateValue(lastRecordedChange.to_value);
};
var hasUnrecordedEstimateReason = (reason, lastRecordedChange) => !lastRecordedChange || lastRecordedChange.reason !== reason;
var buildRestatedEstimateChange = (property, value) => {
  const normalized = normalizeClaimEstimateValue(value);
  return { property, old_value: normalized, new_value: normalized };
};
var diffClaimEstimates = (currentEstimates, nextEstimates) => claimEstimateEventProps.filter((property) => nextEstimates[property] !== void 0).flatMap((property) => {
  const change = {
    property,
    old_value: normalizeClaimEstimateValue(currentEstimates[property]),
    new_value: normalizeClaimEstimateValue(nextEstimates[property])
  };
  if (change.old_value === change.new_value) return [];
  return [change];
});

// helpers/build-claim-estimate-changes.ts
var claimEstimateChangeProperties = [
  ...claimEstimateEventProps,
  "vehicle_market_value"
];
var diffClaimEstimateProperty = (property, currentValue, nextValue) => {
  const old_value = normalizeClaimEstimateValue(currentValue);
  const new_value = normalizeClaimEstimateValue(nextValue);
  if (old_value === new_value) return null;
  return { property, old_value, new_value };
};
var buildClaimEstimateChanges = ({
  claimId,
  changes,
  source,
  changedByUserId,
  reason,
  ingestEventId
}) => changes.map((change) => ({
  claim_id: claimId,
  property: change.property,
  from_value: change.old_value,
  to_value: change.new_value,
  reason: reason ?? null,
  source,
  changed_by_id: changedByUserId,
  ingest_event_id: ingestEventId ?? null
}));

// helpers/format-claim-estimate-value.ts
var import_piramid_constants59 = __toESM(require_dist2());
var import_utils32 = __toESM(require_dist3());
var isPercentageProperty = (property) => percentageEstimatesProps.includes(property);
var isKnownProperty = (property) => claimEstimateChangeProperties.includes(property);
var formatClaimEstimateValue = (property, value) => {
  if (value === null || value === void 0) return null;
  const storedValue = value.toString().trim();
  if (!storedValue) return null;
  if (!property || !isKnownProperty(property)) return storedValue;
  if (!Number.isFinite(Number(storedValue))) return storedValue;
  if (isPercentageProperty(property))
    return `${(0, import_utils32.formatTaxPercent)(storedValue)}%`;
  return (0, import_utils32.formatCurrencyAmount)(storedValue, import_piramid_constants59.DEFAULT_CURRENCY, {
    locale: import_piramid_constants59.DEFAULT_LOCALE
  });
};

// helpers/calculate-acceptance-probability.ts
var import_decimal8 = require("decimal.js");
var ACCEPTANCE_PROBABILITY_MODEL_VERSION = "v3";
var ACCEPTANCE_PROBABILITY_BASE_SCORE = 50;
var ACCEPTANCE_PROBABILITY_MIN = 3;
var ACCEPTANCE_PROBABILITY_MAX = 98;
var acceptanceProbabilityBands = ["high", "medium", "low"];
var ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS = {
  high: 65,
  medium: 35
};
var acceptanceProbabilityFactorKeys = [
  "cap_offered",
  "liability_percentage",
  "third_party_expectation",
  "type_average",
  "claimer_average",
  "mediation_judgment_floor",
  "previous_rejection"
];
var acceptanceProbabilityFactorSkipReasons = [
  "missing_liability",
  "missing_pretension",
  "empty_universe",
  "no_rejected_offer_with_probability"
];
var ACCEPTANCE_PROBABILITY_FACTOR_TABLES = {
  // % of the offer cap covered by the offered amount.
  cap_offered: [
    { gte: 90, points: 25 },
    { gte: 70, points: 15 },
    { gte: 50, points: 5 },
    { gte: null, points: -15 }
  ],
  // Liability percentage defined on the claim.
  liability_percentage: [
    { gte: 80, points: 10 },
    { gte: 50, points: 0 },
    { gte: null, points: -10 }
  ],
  // Offered amount / third-party expectation.
  third_party_expectation: [
    { gte: 0.9, points: 20 },
    { gte: 0.75, points: 10 },
    { gte: 0.5, points: -10 },
    { gte: null, points: -25 }
  ],
  // Offered amount / average accepted amount for the claim type.
  // The average is a ratio of the cap, so the reference is cap-based too.
  type_average: [
    { gte: 1, points: 10 },
    { gte: 0.85, points: 5 },
    { gte: 0.7, points: -5 },
    { gte: null, points: -15 }
  ],
  // Offered amount / average accepted amount for this claimer.
  claimer_average: [
    { gte: 1, points: 15 },
    { gte: 0.85, points: 10 },
    { gte: 0.7, points: -5 },
    { gte: null, points: -20 }
  ],
  // Offered amount / median last offer of claims that escalated anyway.
  // That median is a ratio of the cap, so the reference is cap-based too.
  mediation_judgment_floor: [
    { gte: 1.1, points: 15 },
    { gte: 0.95, points: 5 },
    { gte: 0.85, points: -10 },
    { gte: null, points: -20 }
  ],
  // Predicted probability of the last rejected offer of this same claim.
  previous_rejection: [
    { gte: 70, points: -20 },
    { gte: 50, points: -10 },
    { gte: null, points: 0 }
  ]
};
var buildAcceptanceProbabilityInput = ({
  context,
  offerAmount
}) => {
  var _a;
  return {
    material_judicial_amount: context.estimates.material_judicial_amount,
    person_judicial_amount: context.estimates.person_judicial_amount,
    percentage_of_liability: context.estimates.percentage_of_liability,
    offer_amount: offerAmount,
    pretension: ((_a = context.pretension) == null ? void 0 : _a.value) ?? null,
    type_average: context.aggregates.type_average,
    claimer_average: context.aggregates.claimer_average,
    mediation_judgment_average: context.aggregates.mediation_judgment_average,
    last_rejected_predicted_probability: context.last_rejected_predicted_probability
  };
};
var getAcceptanceProbabilityBand = (probability) => probability >= ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS.high ? "high" : probability >= ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS.medium ? "medium" : "low";
var judicialTotal = (references) => new import_decimal8.Decimal(references.material_judicial_amount || 0).add(
  new import_decimal8.Decimal(references.person_judicial_amount || 0)
);
var isAcceptanceProbabilityComputable = (references) => isOfferCapComputable(references) && judicialTotal(references).greaterThan(0) && computeOfferCap(references) > 0;
var pickPoints = (table, value) => {
  for (const row of table) {
    if (row.gte === null || value.greaterThanOrEqualTo(row.gte)) {
      return row.points;
    }
  }
  return 0;
};
var applied = (key, value) => ({
  key,
  value: value.toNumber(),
  points: pickPoints(ACCEPTANCE_PROBABILITY_FACTOR_TABLES[key], value),
  applied: true
});
var skipped = (key, reason) => ({
  key,
  value: null,
  points: 0,
  applied: false,
  reason_not_applied: reason
});
var calculateAcceptanceProbability = (input) => {
  if (!isAcceptanceProbabilityComputable(input) || input.offer_amount <= 0) {
    return null;
  }
  const amount = new import_decimal8.Decimal(input.offer_amount);
  const cap = new import_decimal8.Decimal(computeOfferCap(input));
  const factors = [];
  factors.push(applied("cap_offered", amount.div(cap).mul(100)));
  factors.push(
    input.percentage_of_liability === null || input.percentage_of_liability === void 0 ? skipped("liability_percentage", "missing_liability") : applied(
      "liability_percentage",
      new import_decimal8.Decimal(input.percentage_of_liability)
    )
  );
  factors.push(
    input.pretension !== null && input.pretension > 0 ? applied(
      "third_party_expectation",
      amount.div(new import_decimal8.Decimal(input.pretension))
    ) : skipped("third_party_expectation", "missing_pretension")
  );
  const aggregateFactor = (key, aggregate, base) => {
    if (aggregate.value === null || aggregate.value <= 0 || aggregate.universe_size <= 0) {
      return skipped(key, "empty_universe");
    }
    const referenceAmount = new import_decimal8.Decimal(aggregate.value).mul(base);
    return applied(key, amount.div(referenceAmount));
  };
  factors.push(aggregateFactor("type_average", input.type_average, cap));
  factors.push(aggregateFactor("claimer_average", input.claimer_average, cap));
  factors.push(
    aggregateFactor(
      "mediation_judgment_floor",
      input.mediation_judgment_average,
      cap
    )
  );
  factors.push(
    input.last_rejected_predicted_probability !== null ? applied(
      "previous_rejection",
      new import_decimal8.Decimal(input.last_rejected_predicted_probability)
    ) : skipped("previous_rejection", "no_rejected_offer_with_probability")
  );
  const totalBeforeClip = ACCEPTANCE_PROBABILITY_BASE_SCORE + factors.reduce((sum, factor) => sum + factor.points, 0);
  const probability = Math.min(
    ACCEPTANCE_PROBABILITY_MAX,
    Math.max(ACCEPTANCE_PROBABILITY_MIN, Math.round(totalBeforeClip))
  );
  return {
    version: ACCEPTANCE_PROBABILITY_MODEL_VERSION,
    probability,
    band: getAcceptanceProbabilityBand(probability),
    base_score: ACCEPTANCE_PROBABILITY_BASE_SCORE,
    total_before_clip: totalBeforeClip,
    factors
  };
};

// helpers/describe-offer-snapshot-context.ts
var BASIS_BY_MODEL_VERSION = {
  v2: { acceptance: "judicial", floor: "judicial" },
  v3: { acceptance: "cap", floor: "cap" }
};
var offerSnapshotReferenceKeys = [
  "claimer_average",
  "type_average",
  "mediation_judgment_average"
];
var UNIVERSE_SIZE_FIELD = {
  claimer_average: "claimer_average_universe_size",
  type_average: "type_average_universe_size",
  mediation_judgment_average: "mediation_judgment_universe_size"
};
var isBasisKnown = (version2) => version2 in BASIS_BY_MODEL_VERSION;
var describeOfferSnapshotContext = (snapshot) => {
  if (!snapshot || !isBasisKnown(snapshot.version)) return null;
  const basis = BASIS_BY_MODEL_VERSION[snapshot.version];
  const { context, input } = snapshot;
  const references = offerSnapshotReferenceKeys.flatMap((key) => {
    const ratio = context[key];
    const universeSize = context[UNIVERSE_SIZE_FIELD[key]];
    if (ratio === null || ratio <= 0 || universeSize <= 0) return [];
    return [
      {
        key,
        percentage: ratio * 100,
        universe_size: universeSize,
        basis: key === "mediation_judgment_average" ? basis.floor : basis.acceptance
      }
    ];
  });
  const offerPercentage = basis.acceptance === "cap" ? input.amount_as_percentage_of_cap ?? (context.offer_cap && context.offer_cap > 0 ? input.amount / context.offer_cap * 100 : null) : input.amount_as_percentage_of_judicial;
  const hasSomethingToShow = references.length > 0 || context.offer_cap !== null || context.pretension !== null;
  if (!hasSomethingToShow) return null;
  return {
    offer_percentage: offerPercentage,
    offer_basis: basis.acceptance,
    references,
    offer_cap: context.offer_cap,
    percentage_of_liability: context.percentage_of_liability,
    pretension: context.pretension
  };
};

// helpers/compute-offer-payment-breakdown.ts
var asPositiveNumber = (value) => typeof value === "number" && Number.isFinite(value) && value > 0 ? value : null;
var computeOfferPaymentBreakdown = ({
  amount,
  installments,
  feePercentage
}) => {
  const offeredAmount = asPositiveNumber(amount);
  if (offeredAmount === null) return null;
  const percentage = asPositiveNumber(feePercentage);
  const fees = percentage !== null ? offeredAmount * percentage / 100 : null;
  const total = offeredAmount + (fees ?? 0);
  const installmentCount = asPositiveNumber(installments);
  return {
    amount: offeredAmount,
    fees,
    total,
    installments: installmentCount,
    installmentAmount: installmentCount !== null ? offeredAmount / installmentCount : null,
    hasFees: fees !== null
  };
};

// helpers/resolve-claim-pretension.ts
var resolveClaimPretension = ({
  offers,
  claimedAmount
}) => {
  const latestCounterOffer = offers.filter((offer) => offer.status === "rejected").sort(
    (a3, b2) => (b2.rejected_at ?? b2.created_at).getTime() - (a3.rejected_at ?? a3.created_at).getTime()
  ).find((offer) => offer.third_party_user_requested_amount !== null);
  if (latestCounterOffer) {
    return {
      value: latestCounterOffer.third_party_user_requested_amount,
      source: "rejection_counter_offer"
    };
  }
  return claimedAmount > 0 ? { value: claimedAmount, source: "claimed_amount" } : null;
};

// helpers/compute-order-totals.ts
var import_decimal9 = __toESM(require("decimal.js"));
var HUNDRED = new import_decimal9.default(100);
var round2 = (value) => value.toDecimalPlaces(2, import_decimal9.default.ROUND_HALF_UP);
var computeOrderTotals = ({
  items,
  coverage_amount,
  taxes_percent
}) => {
  const subtotals = items.map(
    (item) => round2(new import_decimal9.default(item.unit_price).mul(item.quantity))
  );
  const totalAmount = subtotals.reduce(
    (acc, subtotal) => acc.add(subtotal),
    new import_decimal9.default(0)
  );
  const coverageAmount = round2(new import_decimal9.default(coverage_amount ?? 0));
  const amountToCharge = totalAmount.sub(coverageAmount);
  const taxesPercent = new import_decimal9.default(taxes_percent);
  const taxBase = import_decimal9.default.max(amountToCharge, 0);
  const taxesAmount = round2(taxBase.mul(taxesPercent).div(HUNDRED));
  return {
    subtotals: subtotals.map((subtotal) => subtotal.toFixed(2)),
    total_amount: totalAmount.toFixed(2),
    coverage_amount: coverageAmount.toFixed(2),
    amount_to_charge: amountToCharge.toFixed(2),
    taxes_percent: taxesPercent.toFixed(2),
    taxes_amount: taxesAmount.toFixed(2),
    total_with_taxes: amountToCharge.add(taxesAmount).toFixed(2)
  };
};

// ssot/claim.ts
var import_piramid_constants60 = __toESM(require_dist2());
var hasClaimantRelationship = (fields7, relationships) => !!(fields7 == null ? void 0 : fields7.claimants) && fields7.claimants.some(
  (claimant) => relationships.includes(claimant.victim_relationship) || relationships.includes(claimant.material_victim_relationship)
);
var hasInjuryDamage = (fields7) => !!(fields7 == null ? void 0 : fields7.damages) && fields7.damages.some(
  (damage2) => damage2.type === "person" && damage2.person.type === "injury"
);
var hasDeathDamage = (fields7) => !!(fields7 == null ? void 0 : fields7.damages) && fields7.damages.some(
  (damage2) => damage2.type === "person" && damage2.person.type === "death"
);
var hasRecoveryDamage = (fields7) => getClaimDamage(fields7, "recovery").found;
var hasMaterialVictimOfItsOwn = (fields7) => {
  const { damage: materialDamage, found: hasMaterialDamage } = getClaimDamage(
    fields7,
    "material"
  );
  if (!hasMaterialDamage) return false;
  const { damage: personDamage2, found: hasPersonDamage } = getClaimDamage(
    fields7,
    "person"
  );
  if (!hasPersonDamage) return true;
  return getVictimIdentification(materialDamage == null ? void 0 : materialDamage.victim) !== getVictimIdentification(personDamage2 == null ? void 0 : personDamage2.victim);
};
var isRecoveryClaimedBy = (fields7, institutionTypes) => {
  var _a, _b;
  const { damage: damage2, found } = getClaimDamage(fields7, "recovery");
  if (!found) return false;
  const institutionType = (_b = (_a = damage2 == null ? void 0 : damage2.recovery) == null ? void 0 : _a.institution) == null ? void 0 : _b.type;
  return !!institutionType && institutionTypes.includes(institutionType);
};
var rivadaviaV2ClaimDocumentRequirements = [
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "policy_coverage_certificate",
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        //@ts-ignore
        (d3) => d3.type === "material" && !!d3.material.insurance
      ));
    }
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "policy_deductible_letter",
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        (d3) => {
          var _a2;
          return d3.type === "material" && d3.material.type === "vehicle" && !!d3.material.insurance && ((_a2 = d3.material.insurance) == null ? void 0 : _a2.coverage) === "all_risks_with_franchise";
        }
      ));
    }
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "expense_detail_sheet",
    predicate: (fields7) => isRecoveryClaimedBy(fields7, [
      "worker_compensation_insurer",
      "health_insurance_fund",
      "hospital"
    ])
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "work_incapacity_payment_receipt",
    predicate: (fields7) => isRecoveryClaimedBy(fields7, ["worker_compensation_insurer"])
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "permanent_work_incapacity_documentation",
    predicate: (fields7) => isRecoveryClaimedBy(fields7, ["worker_compensation_insurer"])
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "medical_record",
    // A hospital recovering the cost of a death claims the death certificate
    // instead, already required by every death damage.
    predicate: (fields7) => isRecoveryClaimedBy(fields7, ["health_insurance_fund"]) || isRecoveryClaimedBy(fields7, ["hospital"]) && hasInjuryDamage(fields7)
  },
  {
    optional: true,
    fileTypes: ["document", "image", "pdf"],
    maxFiles: 10,
    alias: "subrogation_certificate",
    predicate: (fields7) => isRecoveryClaimedBy(fields7, ["hospital", "health_insurance_fund"])
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "deed",
    predicate: (fields7) => {
      var _a;
      if (!fields7.damages) return false;
      const { damage: damage2, found } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return ((_a = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _a.type) === "real_property" && damage2.material.real_property.ownership === "own";
    }
  },
  {
    optional: true,
    fileTypes: ["document", "image", "pdf"],
    maxFiles: 10,
    alias: "rental_agreement",
    predicate: (fields7) => {
      var _a;
      const { found, damage: damage2 } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return ((_a = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _a.type) === "real_property" && damage2.material.real_property.ownership === "rented";
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    alias: "vehicle",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        (d3) => d3.type === "material" && d3.material.type === "vehicle"
      ));
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    alias: "real_property",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        (d3) => d3.type === "material" && d3.material.type !== "vehicle"
      ));
    }
  },
  {
    optional: true,
    fileTypes: ["document", "image", "pdf"],
    alias: "repair_bill",
    maxFiles: 10,
    predicate: (fields7) => {
      const { damage: damage2, found } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return !!damage2 && !!damage2.fixed;
    }
  },
  {
    optional: true,
    fileTypes: ["document", "image", "pdf"],
    alias: "policy_insurance",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        //@ts-ignore
        (d3) => {
          var _a2;
          return d3.type === "material" && ((_a2 = d3 == null ? void 0 : d3.material) == null ? void 0 : _a2.type) === "real_property" && !!d3.material.insurance;
        }
      ));
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    alias: "vehicle_title",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some(
        (d3) => {
          var _a2, _b;
          return d3.type === "material" && ((_a2 = d3 == null ? void 0 : d3.material) == null ? void 0 : _a2.type) === "vehicle" && ((_b = d3.material.vehicle) == null ? void 0 : _b.document_type) === "title";
        }
      ));
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    alias: "vehicle_id_card_front",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a, _b;
      const { damage: damage2, found } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return ((_a = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _a.type) === "vehicle" && ((_b = damage2.material.vehicle) == null ? void 0 : _b.document_type) === "registration";
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    alias: "vehicle_id_card_back",
    maxFiles: 10,
    predicate: (fields7) => {
      var _a, _b;
      const { damage: damage2, found } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return ((_a = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _a.type) === "vehicle" && ((_b = damage2.material.vehicle) == null ? void 0 : _b.document_type) === "registration";
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "proof_of_ownership_document",
    predicate: (fields7) => {
      var _a, _b, _c;
      const { damage: damage2, found } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return ((_a = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _a.type) === "vehicle" && ((_b = damage2.material.vehicle) == null ? void 0 : _b.document_type) === "other" || ((_c = damage2 == null ? void 0 : damage2.material) == null ? void 0 : _c.type) === "real_property" && damage2.material.real_property.ownership === "other";
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "insurance_complaint",
    predicate: (fields7) => {
      const { found, damage: damage2 } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return !!damage2 && !!damage2.material.insurance;
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "affidavit_of_no_insurance",
    predicate: (fields7) => {
      const { found, damage: damage2 } = getClaimDamage(fields7, "material");
      if (!found) return false;
      return !!damage2 && !damage2.material.insurance;
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    alias: "certificate_medical_treatment",
    maxFiles: 10,
    predicate: (fields7) => hasInjuryDamage(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "death_certificate",
    predicate: (fields7) => hasDeathDamage(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "occupancy_report",
    // Both documents support the compensation owed to the heirs, which a
    // recovery does not claim: the institution only recovers its own expenses.
    predicate: (fields7) => hasDeathDamage(fields7) && !hasRecoveryDamage(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf", "document"],
    maxFiles: 10,
    alias: "income_verification",
    predicate: (fields7) => hasDeathDamage(fields7) && !hasRecoveryDamage(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "victim_national_identity_card_front",
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some((damage2) => damage2.type === "person"));
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "victim_national_identity_card_back",
    predicate: (fields7) => {
      var _a;
      return !!(fields7 == null ? void 0 : fields7.damages) && ((_a = fields7.damages) == null ? void 0 : _a.some((damage2) => damage2.type === "person"));
    }
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "material_victim_national_identity_card_front",
    predicate: (fields7) => hasMaterialVictimOfItsOwn(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "material_victim_national_identity_card_back",
    predicate: (fields7) => hasMaterialVictimOfItsOwn(fields7)
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "claim_note",
    predicate: (fields7) => hasClaimantRelationship(fields7, [
      "attorney_in_fact",
      "attorney_representative"
    ])
  },
  {
    optional: true,
    fileTypes: ["image", "pdf"],
    maxFiles: 10,
    alias: "power_of_attorney",
    predicate: (fields7) => hasClaimantRelationship(fields7, ["attorney_in_fact"])
  }
];
var gammaClaimDocumentRequirements = [
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "vehicle_id_card_front"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "vehicle_id_card_back"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "material_victim_national_identity_card_front"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "material_victim_national_identity_card_back"
  },
  {
    optional: true,
    maxFiles: 10,
    fileTypes: ["document", "image", "pdf"],
    alias: "vehicle"
  }
];
var demoEmpleoClaimDocumentRequirements = [
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "identity_card"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "income_verification"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "accounting_certificate"
  },
  {
    optional: true,
    maxFiles: 1,
    fileTypes: ["document", "image", "pdf"],
    alias: "policy_insurance"
  }
];
var claimDocumentRequirementsBySpecification = {
  rivadavia_v2: rivadaviaV2ClaimDocumentRequirements,
  gamma: gammaClaimDocumentRequirements,
  demoempleo: demoEmpleoClaimDocumentRequirements
};
var claimDocumentRequirements = rivadaviaV2ClaimDocumentRequirements;
var claimDocumentRequirementsFor = (specification) => claimDocumentRequirementsBySpecification[specification ?? import_piramid_constants60.DEFAULT_ENTRYPOINT_SPECIFICATION] ?? claimDocumentRequirementsBySpecification[import_piramid_constants60.DEFAULT_ENTRYPOINT_SPECIFICATION];
var materialDamageDocuments = [
  "deed",
  "rental_agreement",
  "vehicle",
  "real_property",
  "repair_bill",
  "vehicle_title",
  "vehicle_id_card_front",
  "vehicle_id_card_back",
  "proof_of_ownership_document",
  "material_victim_national_identity_card_front",
  "material_victim_national_identity_card_back"
];
var injuryDamageDocuments = [
  "certificate_medical_treatment",
  "birth_certificate",
  "death_certificate",
  "victim_national_identity_card_front",
  "victim_national_identity_card_back"
];
var claimDocumentGroups = [
  "vehicle",
  "real_property",
  "injury",
  "death",
  "recovery",
  "representation",
  "other"
];
var claimDocumentGroupsByAlias = {
  vehicle: ["vehicle"],
  vehicle_id_card_front: ["vehicle"],
  vehicle_id_card_back: ["vehicle"],
  vehicle_title: ["vehicle"],
  policy_deductible_letter: ["vehicle"],
  real_property: ["real_property"],
  deed: ["real_property"],
  rental_agreement: ["real_property"],
  policy_insurance: ["real_property"],
  proof_of_ownership_document: ["vehicle", "real_property"],
  repair_bill: ["vehicle", "real_property"],
  policy_coverage_certificate: ["vehicle", "real_property"],
  insurance_complaint: ["vehicle", "real_property"],
  affidavit_of_no_insurance: ["vehicle", "real_property"],
  material_victim_national_identity_card_front: ["vehicle", "real_property"],
  material_victim_national_identity_card_back: ["vehicle", "real_property"],
  certificate_medical_treatment: ["injury"],
  victim_national_identity_card_front: ["injury", "death"],
  victim_national_identity_card_back: ["injury", "death"],
  death_certificate: ["death"],
  occupancy_report: ["death"],
  income_verification: ["death"],
  expense_detail_sheet: ["recovery"],
  medical_record: ["recovery"],
  subrogation_certificate: ["recovery"],
  work_incapacity_payment_receipt: ["recovery"],
  permanent_work_incapacity_documentation: ["recovery"],
  claim_note: ["representation"],
  power_of_attorney: ["representation"]
};
var groupedClaimDocumentAliases = () => claimDocumentGroups.map((group) => ({
  group,
  aliases: rivadaviaV2ClaimDocumentRequirements.filter(
    (requirement) => (claimDocumentGroupsByAlias[requirement.alias] ?? ["other"]).includes(
      group
    )
  ).map((requirement) => requirement.alias)
})).filter(({ aliases }) => aliases.length > 0);
var flatClaimDocumentPreview = (specification) => ({
  type: "flat",
  aliases: claimDocumentRequirementsBySpecification[specification].map(
    ({ alias }) => alias
  )
});
var claimDocumentPreviewBySpecification = {
  rivadavia_v2: () => ({
    type: "grouped",
    groups: groupedClaimDocumentAliases()
  }),
  gamma: () => flatClaimDocumentPreview("gamma"),
  demoempleo: () => flatClaimDocumentPreview("demoempleo")
};
var claimDocumentPreview = (specification) => (claimDocumentPreviewBySpecification[specification ?? import_piramid_constants60.DEFAULT_ENTRYPOINT_SPECIFICATION] ?? claimDocumentPreviewBySpecification[import_piramid_constants60.DEFAULT_ENTRYPOINT_SPECIFICATION])();

// contracts/kach.contract.ts
var import_zod83 = require("zod");
var import_piramid_constants61 = __toESM(require_dist2());
var caseStatus = import_piramid_constants61.KACH_CASE_STATUSES;
var signInKachRequestBody = signInRequestBody;
var deriveSinisterToFraudRequestBody = import_zod83.z.object({
  sinister_type: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage).refine((name) => !(0, import_piramid_constants61.isExcludedKachSinisterType)(name), {
    message: "sinister type cannot be derived from Piramid"
  }),
  sinister_id: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage),
  reason: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage),
  description: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage),
  denounced_at: import_zod83.z.coerce.date().optional(),
  policy_id: import_zod83.z.string().optional(),
  matricula: import_zod83.z.string().optional(),
  annotation: import_zod83.z.string().optional()
});
var associateSinisterToFraudRequestBody = import_zod83.z.object({
  sinister_id: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage)
});
var fetchExistingKachCaseQuery = import_zod83.z.object({
  sinisterId: import_zod83.z.string().min(1, import_piramid_constants61.requiredFieldMessage)
});
var kachOAuthModes = ["off", "preferred", "required"];

// contracts/company-link.contract.ts
var import_zod84 = require("zod");
var listCompanyLinkRequestQuery = import_zod84.z.object({
  name: import_zod84.z.string().optional()
});

// contracts/integration-template.contract.ts
var import_database40 = __toESM(require_index_browser4());
var import_piramid_constants62 = __toESM(require_dist2());
var import_zod85 = require("zod");
var listIntegrationTemplatesRequestQuery = import_zod85.z.object({
  message_template_id: import_zod85.z.coerce.string().nullish(),
  provider: import_zod85.z.nativeEnum(import_database40.IntegrationTemplateProviderType),
  search: import_zod85.z.string().nullish()
});
var createIntegrationTemplateRequestBody = import_zod85.z.object({
  name: import_zod85.z.string().min(1, import_piramid_constants62.requiredFieldMessage).max(255, import_piramid_constants62.requiredFieldMessage),
  provider_type: import_zod85.z.nativeEnum(import_database40.IntegrationTemplateProviderType),
  provider_template_id: import_zod85.z.string().min(1, import_piramid_constants62.requiredFieldMessage),
  provider_template_name: import_zod85.z.string().nullish(),
  message_template_id: import_zod85.z.coerce.string(),
  fields_mappings: import_zod85.z.array(
    import_zod85.z.object({
      guid: import_zod85.z.string().min(1, import_piramid_constants62.requiredFieldMessage),
      provider_field_id: import_zod85.z.string().min(1, import_piramid_constants62.requiredFieldMessage),
      local_field_type: import_zod85.z.nativeEnum(import_database40.IntegrationTemplateFieldType),
      local_field_reference: import_zod85.z.string().min(1, import_piramid_constants62.requiredFieldMessage)
    }).refine(
      (data) => {
        if (data.local_field_type === "parent_object_field")
          return import_piramid_constants62.integrationTemplateParentObjectReferences.some(
            (fieldPath) => fieldPath === data.local_field_reference
          );
        return true;
      },
      {
        message: "No se encontr\xF3 la referencia de campo en la plantilla"
      }
    )
  )
});
var updateIntegrationTemplateRequestBody = createIntegrationTemplateRequestBody;
var retrieveIntegrationTemplateRequestParams = import_zod85.z.object({
  integrationTemplateId: import_zod85.z.coerce.string()
});
var retrieveIntegrationTemplateFieldsRequestParams = import_zod85.z.object({
  providerType: import_zod85.z.nativeEnum(import_database40.IntegrationTemplateProviderType),
  providerTemplateId: import_zod85.z.string().min(1)
});

// contracts/relation-type.contract.ts
var import_zod86 = require("zod");
var relationTypes = ["claim", "complaint"];
var RelationType = import_zod86.z.enum(relationTypes);

// contracts/service-account.contract.ts
var import_zod87 = require("zod");
var createServiceAccountRequestBody = import_zod87.z.object({
  name: import_zod87.z.string(),
  description: import_zod87.z.string().optional()
});
var updateServiceAccountRequestBody = createServiceAccountRequestBody;

// contracts/comment.contracts.ts
var import_zod88 = require("zod");
var createCommentRequestBody = import_zod88.z.object({
  content: import_zod88.z.string().min(1),
  mentions: import_zod88.z.array(
    import_zod88.z.object({
      userId: import_zod88.z.string()
    })
  )
});
var createCommentRequestParam = import_zod88.z.object({
  claim_id: import_zod88.z.string().min(1)
});
var listCommentsRequestQuery = import_zod88.z.object({
  claim_id: import_zod88.z.string().min(1)
});

// utils/claim.ts
var isLocalClaim = (claim) => {
  if (!claim.entrypoint_backend || !claim.policyholder_policy_number)
    return false;
  switch (claim.entrypoint_backend) {
    case "rivadavia":
      return !!claim.policyholder_policy_number;
    default:
      break;
  }
  return false;
};
var isRecoveryClaim = (damages) => (damages || []).some((damage2) => damage2.type === "recovery");

// contracts/tenant.contracts.ts
var import_zod89 = require("zod");
var tenantParamsSchema = import_zod89.z.object({
  tenantSlug: import_zod89.z.string()
});

// contracts/catalog.contract.ts
var import_piramid_constants63 = __toESM(require_dist2());
var import_zod90 = require("zod");
var createVerticalRequestBody = import_zod90.z.object({
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage),
  slug: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var updateVerticalRequestBody = import_zod90.z.object({
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage),
  slug: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var createGoodRequestBody = import_zod90.z.object({
  vertical_id: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage),
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var updateGoodRequestBody = import_zod90.z.object({
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var createServiceRequestBody = import_zod90.z.object({
  vertical_id: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage),
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var updateServiceRequestBody = import_zod90.z.object({
  name: import_zod90.z.string().min(1, import_piramid_constants63.requiredFieldMessage)
});
var updateCompanyVerticalsRequestBody = import_zod90.z.object({
  vertical_ids: import_zod90.z.array(import_zod90.z.string())
});

// contracts/document-render.contract.ts
var import_database43 = __toESM(require_index_browser4());
var import_piramid_constants77 = __toESM(require_dist2());
var import_zod95 = require("zod");

// helpers/agreement-template.fixture.ts
var import_i11n3 = __toESM(require_dist());
var import_piramid_constants74 = __toESM(require_dist2());

// helpers/agreement-subject.fixture.ts
var import_utils33 = __toESM(require_dist3());
var AGREEMENT_FIXTURE_NOW = /* @__PURE__ */ new Date("2026-09-11T15:00:00.000Z");
var LOCAL_MIDNIGHT_UTC_SUFFIX = "T03:00:00.000Z";
var iso = (value) => (value.length === 10 ? /* @__PURE__ */ new Date(`${value}${LOCAL_MIDNIGHT_UTC_SUFFIX}`) : new Date(value)).toISOString();
var buildAgreementPerson = (overrides = {}) => ({
  kind: "natural_person",
  first_name: "Ana",
  last_name: "G\xF3mez",
  full_name: "Ana G\xF3mez",
  identification_type: "national_id_document",
  legal_person_type: null,
  identification: "30123456",
  email: "ana@example.com",
  phone: "1150001111",
  address_street: "Av. Siempreviva",
  address_number: "742",
  address_apartment: null,
  address: "Av. Siempreviva 742",
  city: "LA PLATA",
  state: "B",
  country: "ARG",
  zip_code: "1900",
  birth_date: iso("1985-04-12"),
  nationality: "ARG",
  sex: "female",
  marital_status: null,
  parents: { father: null, mother: null },
  ...overrides
});
var buildAgreementLegalPerson = (overrides = {}) => buildAgreementPerson({
  kind: "legal_person",
  first_name: null,
  last_name: null,
  full_name: "Transportes del Sur S.A.",
  identification_type: "cuit",
  identification: "30712345678",
  phone: null,
  address_street: null,
  address_number: null,
  address: "Ruta 2 km 44",
  birth_date: null,
  nationality: null,
  sex: null,
  ...overrides
});
var buildAgreementParent = (type, overrides = {}) => ({
  type,
  first_name: type === "father" ? "Carlos" : "Mar\xEDa",
  last_name: "G\xF3mez",
  full_name: type === "father" ? "Carlos G\xF3mez" : "Mar\xEDa G\xF3mez",
  identification: type === "father" ? "20111111" : "27222222",
  birth_date: iso("1960-01-01"),
  ...overrides
});
var buildAgreementClaimant = (overrides = {}) => {
  const { person, ...rest } = overrides;
  return {
    id: "claimant_01",
    role: "claimant",
    relationship: "own",
    relationship_other: null,
    ...rest,
    person: buildAgreementPerson(person)
  };
};
var buildAgreementLawyer = (overrides = {}) => buildAgreementClaimant({
  id: "claimant_02",
  relationship: "attorney_in_fact",
  ...overrides,
  person: {
    first_name: "Laura",
    last_name: "P\xE9rez",
    full_name: "Laura P\xE9rez",
    identification_type: "cuit",
    identification: "27301234563",
    email: "laura@estudio.example.com",
    ...overrides.person
  }
});
var buildAgreementInsured = (overrides = {}) => ({
  person_type: "natural_person",
  first_name: "Pedro",
  last_name: "L\xF3pez",
  full_name: "Pedro L\xF3pez",
  identification: "25123456",
  cuil: "20251234561",
  address: "Calle 7 1234",
  city: "LA PLATA",
  state: "Buenos Aires",
  zip_code: "1900",
  license_plate: "AC123DD",
  make: "FIAT",
  model: "CRONOS",
  year: "2022",
  policy_number: "1234567",
  ...overrides
});
var agreementFixtureGuid = (name) => `guid-${(0, import_utils33.normalizeVariableName)(name).replace(/\s/g, "-")}`;
var agreementValuesByName = (values) => Object.fromEntries(
  Object.entries(values).map(([name, value]) => [
    agreementFixtureGuid(name),
    value
  ])
);
var buildAgreementDefinition = (overrides) => ({
  guid: agreementFixtureGuid(overrides.name),
  normalized_name: (0, import_utils33.normalizeVariableName)(overrides.name),
  type: "text",
  determination: "compile_time",
  required: true,
  options: null,
  numeric_format: null,
  numeric_format_currency: null,
  ...overrides
});
var singlePaymentDefinitions = () => [
  buildAgreementDefinition({
    name: "Importe",
    type: "numeric",
    numeric_format: true,
    numeric_format_currency: "ARS"
  }),
  buildAgreementDefinition({ name: "Importe ofrecido en texto" }),
  buildAgreementDefinition({
    name: "D\xEDas",
    type: "select",
    options: [
      { guid: "dias-15", name: "15" },
      { guid: "dias-30", name: "30" }
    ]
  }),
  buildAgreementDefinition({
    name: "M\xE9todo de pago",
    type: "select",
    determination: "runtime",
    options: [
      { guid: "pago-transferencia", name: "Transferencia" },
      { guid: "pago-cheque", name: "Cheque" }
    ]
  }),
  buildAgreementDefinition({ name: "CBU", determination: "runtime" }),
  buildAgreementDefinition({
    name: "CUIT",
    type: "numeric",
    determination: "runtime"
  }),
  buildAgreementDefinition({
    name: "Constancia de CBU",
    type: "file",
    determination: "runtime"
  })
];
var installmentsWithFeesDefinitions = () => [
  ...singlePaymentDefinitions(),
  buildAgreementDefinition({ name: "Cuotas", type: "numeric" }),
  buildAgreementDefinition({ name: "Honorarios", type: "numeric" }),
  buildAgreementDefinition({ name: "CBU Letrado", determination: "runtime" }),
  buildAgreementDefinition({
    name: "CUIT Letrado",
    determination: "runtime"
  }),
  buildAgreementDefinition({
    name: "Constancia de CBU Letrado",
    type: "file",
    determination: "runtime"
  })
];
var bankConditions = () => [
  "cbu",
  "cuit",
  "constancia-de-cbu",
  "cbu-letrado",
  "cuit-letrado",
  "constancia-de-cbu-letrado"
].map((target) => ({
  variable: "guid-metodo-de-pago",
  operator: "equals",
  value: "Transferencia",
  target: `guid-${target}`
}));
var buildAgreementAcceptanceRequirements = ({
  hasLawyer = false,
  withFeeInvoice = false
} = {}) => {
  const field = (key, name, type, required = true) => ({ key, name, type, required, guid: agreementFixtureGuid(name) });
  return {
    version: 1,
    payment_method: "transfer",
    payee: null,
    fields: [
      field("cbu", "CBU", "text"),
      field("cuit", "CUIT", "text"),
      field("cbu_proof", "Constancia de CBU", "file"),
      ...hasLawyer ? [
        field("lawyer_cbu", "CBU Letrado", "text"),
        field("lawyer_cuit", "CUIT Letrado", "text"),
        field("lawyer_cbu_proof", "Constancia de CBU Letrado", "file")
      ] : [],
      ...withFeeInvoice ? [field("fee_invoice", "Factura de honorarios", "file", false)] : []
    ]
  };
};
var buildAgreementOffer = (overrides = {}) => ({
  kind: "persisted",
  id: "offer_01",
  status: "accepted",
  message_template_id: "messagetemplate_01",
  amount: "1500000",
  terms: null,
  public_reason: null,
  acceptance_requirements: null,
  created_at: iso("2026-08-20T13:00:00.000Z"),
  accepted_at: iso("2026-08-22T16:30:00.000Z"),
  definitions: singlePaymentDefinitions(),
  conditions: bankConditions(),
  values: {
    compile_time: agreementValuesByName({
      importe: "1500000",
      "importe ofrecido en texto": "Un mill\xF3n quinientos mil pesos argentinos",
      dias: "30"
    }),
    runtime: agreementValuesByName({
      "metodo de pago": "Transferencia",
      cbu: "0170099220000067797370",
      cuit: "20301234563"
    })
  },
  files: agreementValuesByName({ "constancia de cbu": "constancia.pdf" }),
  ...overrides
});
var buildAgreementNoOffer = () => ({
  kind: "none",
  id: null,
  status: null,
  message_template_id: null,
  amount: null,
  terms: null,
  public_reason: null,
  acceptance_requirements: null,
  created_at: null,
  accepted_at: null,
  definitions: [],
  conditions: [],
  values: { compile_time: {}, runtime: {} },
  files: {}
});
var agreementFixtureClaimTypes = {
  vehicleWithPlate: () => ({
    id: "companyclaimtype_01",
    name: "Da\xF1o Material (con patente)",
    damages: [
      {
        damage_type: "material",
        sub_damage_type: "vehicle",
        entity_damaged_category: "with_license_plate"
      }
    ]
  }),
  realProperty: () => ({
    id: "companyclaimtype_02",
    name: "Da\xF1o a Inmueble",
    damages: [
      {
        damage_type: "material",
        sub_damage_type: "real_property",
        entity_damaged_category: null
      }
    ]
  }),
  injured: () => ({
    id: "companyclaimtype_03",
    name: "Lesionado",
    damages: [
      {
        damage_type: "person",
        sub_damage_type: "injury",
        entity_damaged_category: null
      }
    ]
  }),
  vehicleWithPlateAndDeath: () => ({
    id: "companyclaimtype_04",
    name: "Combinado Da\xF1o Material con patente con Fallecido",
    damages: [
      {
        damage_type: "material",
        sub_damage_type: "vehicle",
        entity_damaged_category: "with_license_plate"
      },
      {
        damage_type: "person",
        sub_damage_type: "death",
        entity_damaged_category: null
      }
    ]
  })
};
var buildAgreementDriver = (overrides = {}) => ({
  first_name: "Luciano",
  last_name: "\xC1lvarez",
  full_name: "Luciano \xC1lvarez",
  ownership: "owner",
  ...overrides
});
var buildAgreementInsurance = (overrides = {}) => ({
  insurer: "Mercantil Andina",
  policy_number: "9988",
  coverage: "third_full",
  other_coverage: null,
  ...overrides
});
var vehicleDamage = ({
  id = "damage_01",
  description = "Da\xF1os en el paragolpes delantero",
  license_plate = "AB123CD",
  insurance = buildAgreementInsurance(),
  driver = buildAgreementDriver()
} = {}) => ({
  id,
  type: "material",
  description,
  fixed: false,
  material: {
    type: "vehicle",
    vehicle: {
      make: "VOLKSWAGEN",
      model: "GOL",
      version: "TREND",
      year: 2018,
      license_plate,
      category: "with_license_plate",
      type: "car",
      use: "private",
      chassis: "9BWZZZ377VT004251",
      engine: "CFZ123456"
    },
    real_property: null,
    insurance,
    driver
  },
  person: null,
  recovery: null
});
var realPropertyDamage = (overrides = {}) => ({
  id: "damage_01",
  type: "material",
  description: "Rotura de vidriera y persiana",
  fixed: false,
  material: {
    type: "real_property",
    vehicle: null,
    real_property: {
      type: "commercial",
      other_type: null,
      ownership: "rented",
      other_ownership: null,
      address_street: "Calle 12",
      address_number: "1234",
      address_apartment: null,
      address: "Calle 12 1234",
      city: "LA PLATA",
      state: "B",
      country: "ARG",
      zip_code: "1900"
    },
    insurance: null,
    driver: null
  },
  person: null,
  recovery: null,
  ...overrides
});
var injuryDetail = (overrides = {}) => ({
  damage: "whiplash",
  severity: "minor",
  body_parts: [],
  ...overrides
});
var personDamage = (type, overrides = {}) => ({
  id: "damage_02",
  type: "person",
  description: null,
  fixed: null,
  material: null,
  person: {
    type,
    victim_role: "driver",
    surgery_description: null,
    health_insurance_fund: null,
    treatment_worker_compensation_insurer: null,
    treatment_medical_institution: null,
    policyholder_relationship: null,
    policyholder_relationship_other: null,
    details: type === "injury" ? [injuryDetail()] : [],
    ...overrides
  },
  recovery: null
});
var recoveryDamage = (overrides = {}) => ({
  id: "damage_03",
  type: "recovery",
  description: null,
  fixed: null,
  material: null,
  person: null,
  recovery: {
    claimant_institution_relationship: "legal_representative",
    institution: buildAgreementLegalPerson({
      full_name: "Hospital Italiano de La Plata",
      identification: "30500001234",
      legal_person_type: "hospital",
      address: "Calle 51 1725",
      email: null
    })
  },
  ...overrides
});
var buildAgreementSubject = (overrides = {}) => ({
  company: {
    id: "company_01",
    name: "Rivadavia Seguros",
    tax_id: "30500000001",
    country: "ARG",
    default_currency: "ARS"
  },
  claim: {
    id: "claim_01",
    ref_id: "RIV-1913",
    external_claim_id: "012-20-0259600-01",
    external_claim_request_id: "2026-0412883",
    external_policyholder_number: "0120021234567001",
    policyholder_license_plate: "AC123DD",
    policyholder_policy_number: null,
    claim_type_id: "companyclaimtype_01",
    claim_type: agreementFixtureClaimTypes.vehicleWithPlate(),
    team_id: "team_01",
    responsible_user_id: "user_handler_01",
    created_at: iso("2026-03-05T12:00:00.000Z")
  },
  owner: { email: "ana@example.com" },
  victim: buildAgreementPerson(),
  claimants: [buildAgreementClaimant()],
  occurrence: {
    address: "Av. 7 y 50",
    city: "LA PLATA",
    state: "B",
    country: "ARG",
    zip_code: "1900",
    sinister_date: iso("2026-03-02")
  },
  sinister: {
    date: iso("2026-03-02"),
    policyholder_license_plate: "AC123DD",
    policyholder_policy_number: null,
    external_complaint_candidates: 1
  },
  external_complaint: {
    external_id: "012-20-0259600",
    occurrence_date: iso("2026-03-02"),
    policyholder: buildAgreementInsured(),
    source: "claim"
  },
  damages: [vehicleDamage()],
  offer: buildAgreementOffer(),
  acceptance: { source: "persisted", hidden_guids: [] },
  ...overrides
});
var claimTyped = (type) => ({
  ...buildAgreementSubject().claim,
  claim_type_id: type.id,
  claim_type: type
});
var buildGuidedOfferSubject = ({
  amount,
  installments,
  feePercentage,
  paymentDays,
  hasLawyer,
  publicReason = null
}) => buildAgreementSubject({
  ...hasLawyer ? {
    owner: { email: "laura@estudio.example.com" },
    claimants: [buildAgreementLawyer({ id: "claimant_01" })]
  } : {},
  offer: buildAgreementOffer({
    kind: "draft",
    id: null,
    status: null,
    created_at: null,
    accepted_at: null,
    message_template_id: null,
    amount: String(amount),
    public_reason: publicReason,
    terms: {
      amount,
      installments,
      fee_percentage: feePercentage,
      payment_days: paymentDays
    },
    acceptance_requirements: buildAgreementAcceptanceRequirements({
      hasLawyer,
      withFeeInvoice: feePercentage !== null
    }),
    definitions: [],
    conditions: [],
    values: { compile_time: {}, runtime: {} },
    files: {}
  }),
  acceptance: { source: "none", hidden_guids: [] }
});
var agreementScenarios = {
  /** RIV-1913: claimant is the victim, single payment, transfer. */
  directTransfer: () => buildAgreementSubject(),
  /** Attorney-in-fact files the claim (principal), installments and fees. */
  attorneyInFactInstallments: () => buildAgreementSubject({
    owner: { email: "laura@estudio.example.com" },
    claimants: [buildAgreementLawyer({ id: "claimant_01" })],
    offer: buildAgreementOffer({
      definitions: installmentsWithFeesDefinitions(),
      values: {
        compile_time: agreementValuesByName({
          importe: "3000000",
          "importe ofrecido en texto": "Tres millones de pesos argentinos",
          dias: "15",
          cuotas: "3",
          honorarios: "12"
        }),
        runtime: agreementValuesByName({
          "metodo de pago": "Transferencia",
          cbu: "0170099220000067797370",
          cuit: "20301234563",
          "cbu letrado": "2850590940090418135201",
          "cuit letrado": "27301234563"
        })
      },
      amount: "3000000",
      files: agreementValuesByName({
        "constancia de cbu": "constancia.pdf",
        "constancia de cbu letrado": "constancia-letrado.pdf"
      })
    })
  }),
  /** Victim is the principal claimant; a patrocinante is the second claimant. */
  attorneyRepresentativeSinglePayment: () => buildAgreementSubject({
    claimants: [
      buildAgreementClaimant(),
      buildAgreementLawyer({
        id: "claimant_02",
        relationship: "attorney_representative"
      })
    ]
  }),
  /** Death claim: the son filed it (principal) and the spouse is an heir row. */
  deceasedWithHeirs: () => buildAgreementSubject({
    owner: { email: "juan@example.com" },
    victim: buildAgreementPerson({
      first_name: "Roberto",
      last_name: "D\xEDaz",
      full_name: "Roberto D\xEDaz",
      identification: "10123456",
      email: null,
      birth_date: iso("1950-06-01")
    }),
    claimants: [
      buildAgreementClaimant({
        id: "claimant_01",
        relationship: "son",
        person: {
          first_name: "Juan",
          last_name: "D\xEDaz",
          full_name: "Juan D\xEDaz",
          identification: "35123456",
          email: "juan@example.com"
        }
      }),
      buildAgreementClaimant({
        id: "claimant_02",
        role: "heir",
        relationship: "spouse",
        person: {
          first_name: "Marta",
          last_name: "Ruiz",
          full_name: "Marta Ruiz",
          identification: "12123456",
          email: "marta@example.com"
        }
      })
    ],
    damages: [vehicleDamage(), personDamage("death")],
    claim: claimTyped(agreementFixtureClaimTypes.vehicleWithPlateAndDeath())
  }),
  /** Minor victim with both parents declared; the mother filed the claim. */
  minorWithParents: () => buildAgreementSubject({
    owner: { email: "maria@example.com" },
    claim: claimTyped(agreementFixtureClaimTypes.injured()),
    victim: buildAgreementPerson({
      first_name: "Luc\xEDa",
      last_name: "G\xF3mez",
      full_name: "Luc\xEDa G\xF3mez",
      identification: "50123456",
      email: null,
      birth_date: iso("2012-05-20"),
      parents: {
        father: buildAgreementParent("father"),
        mother: buildAgreementParent("mother")
      }
    }),
    claimants: [
      buildAgreementClaimant({
        relationship: "mother",
        person: {
          first_name: "Mar\xEDa",
          last_name: "G\xF3mez",
          full_name: "Mar\xEDa G\xF3mez",
          identification: "27222222",
          email: "maria@example.com"
        }
      })
    ],
    damages: [personDamage("injury")]
  }),
  minorWithoutParents: () => buildAgreementSubject({
    victim: buildAgreementPerson({ birth_date: iso("2012-05-20") }),
    claimants: [
      buildAgreementClaimant({ relationship: "other_family_member" })
    ]
  }),
  unknownBirthDate: () => buildAgreementSubject({
    victim: buildAgreementPerson({ birth_date: null })
  }),
  /** A company as victim, represented by its legal representative. */
  legalPersonVictim: () => buildAgreementSubject({
    owner: { email: "apoderado@transportes.example.com" },
    victim: buildAgreementLegalPerson(),
    claimants: [
      buildAgreementClaimant({
        relationship: "legal_representative",
        person: {
          first_name: "Diego",
          last_name: "Molina",
          full_name: "Diego Molina",
          identification: "20333333",
          email: "apoderado@transportes.example.com"
        }
      })
    ]
  }),
  /** An insurance producer files on behalf of the victim (RIV-28708). */
  producerClaimant: () => buildAgreementSubject({
    owner: { email: "productor@example.com" },
    claimants: [
      buildAgreementClaimant({
        relationship: "producer",
        person: {
          first_name: "Sergio",
          last_name: "Vega",
          full_name: "Sergio Vega",
          identification: "18123456",
          email: "productor@example.com"
        }
      })
    ]
  }),
  twoLawyers: () => buildAgreementSubject({
    owner: { email: "laura@estudio.example.com" },
    claimants: [
      buildAgreementLawyer({ id: "claimant_01" }),
      buildAgreementLawyer({
        id: "claimant_02",
        relationship: "attorney_representative",
        person: {
          first_name: "Mart\xEDn",
          last_name: "Sosa",
          full_name: "Mart\xEDn Sosa",
          identification: "20301234563",
          email: "martin@estudio.example.com"
        }
      })
    ]
  }),
  /** Legacy claim with two `claimant`-role rows; the owner-synced one wins. */
  multiplePrincipals: () => buildAgreementSubject({
    claimants: [
      buildAgreementClaimant({
        id: "claimant_01",
        relationship: "other",
        relationship_other: "pareja",
        person: { email: "ex@example.com", identification: "11111111" }
      }),
      buildAgreementClaimant({ id: "claimant_02" })
    ]
  }),
  noSelectedComplaint: () => buildAgreementSubject({
    external_complaint: null,
    claim: {
      ...buildAgreementSubject().claim,
      external_policyholder_number: null
    },
    sinister: {
      ...buildAgreementSubject().sinister,
      external_complaint_candidates: 0
    }
  }),
  /** No complaint selected on the claim, but the sinister has one whose insured plate is the claim's. */
  inferredComplaint: () => buildAgreementSubject({
    external_complaint: {
      ...buildAgreementSubject().external_complaint,
      source: "sinister"
    },
    claim: {
      ...buildAgreementSubject().claim,
      external_policyholder_number: null
    }
  }),
  /** The sinister has complaints with an insured, none with the claim's plate. */
  unmatchedComplaint: () => buildAgreementSubject({
    external_complaint: null,
    claim: {
      ...buildAgreementSubject().claim,
      external_policyholder_number: null
    },
    sinister: {
      ...buildAgreementSubject().sinister,
      external_complaint_candidates: 2
    }
  }),
  /** No offer yet: the claim resolves, nothing of the offer does. */
  noOffer: () => buildAgreementSubject({
    offer: buildAgreementNoOffer(),
    acceptance: { source: "none", hidden_guids: [] }
  }),
  untypedClaim: () => buildAgreementSubject({
    claim: {
      ...buildAgreementSubject().claim,
      claim_type_id: null,
      claim_type: null
    }
  }),
  /** Damages edited after creation: an injury on a claim typed as a vehicle damage. */
  mismatchedClaimType: () => buildAgreementSubject({ damages: [personDamage("injury")] }),
  /** Claimant chose "Cheque": the bank variables are hidden by condition. */
  cheque: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      values: {
        compile_time: buildAgreementOffer().values.compile_time,
        runtime: agreementValuesByName({ "metodo de pago": "Cheque" })
      },
      files: {}
    }),
    acceptance: {
      source: "persisted",
      hidden_guids: ["cbu", "cuit", "constancia de cbu"].map(
        agreementFixtureGuid
      )
    }
  }),
  offerWithoutVariables: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      definitions: [],
      conditions: [],
      values: { compile_time: {}, runtime: {} },
      files: {}
    }),
    acceptance: { source: "persisted", hidden_guids: [] }
  }),
  /** Plan preview: the offer does not exist yet. */
  draftOffer: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      kind: "draft",
      id: null,
      status: null,
      created_at: null,
      accepted_at: null,
      values: {
        compile_time: buildAgreementOffer().values.compile_time,
        runtime: {}
      },
      files: {}
    }),
    acceptance: { source: "none", hidden_guids: [] }
  }),
  /** Pago único, sin abogado. */
  guidedSinglePayment: () => buildGuidedOfferSubject({
    amount: 15e5,
    installments: 1,
    feePercentage: null,
    paymentDays: 30,
    hasLawyer: false,
    publicReason: "Cierre por acuerdo directo"
  }),
  /** Pago único, con abogado: honorarios sin cuotas. */
  guidedSinglePaymentWithFees: () => buildGuidedOfferSubject({
    amount: 15e5,
    installments: 1,
    feePercentage: 12,
    paymentDays: 30,
    hasLawyer: true
  }),
  /** En cuotas, sin abogado: cuotas sin honorarios. */
  guidedInstallments: () => buildGuidedOfferSubject({
    amount: 3e6,
    installments: 3,
    feePercentage: null,
    paymentDays: 15,
    hasLawyer: false
  }),
  /** En cuotas, con abogado: las dos ramas del `[[#if]]` a la vez. */
  guidedInstallmentsWithFees: () => buildGuidedOfferSubject({
    amount: 3e6,
    installments: 3,
    feePercentage: 12,
    paymentDays: 15,
    hasLawyer: true
  }),
  /** Pending offer, nothing accepted yet. */
  noAcceptance: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      status: "pending",
      accepted_at: null,
      values: {
        compile_time: buildAgreementOffer().values.compile_time,
        runtime: {}
      },
      files: {}
    }),
    acceptance: { source: "none", hidden_guids: [] }
  }),
  /** Ceremony preview: the claimant typed the method but not the CUIT yet. */
  providedPartialAcceptance: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      status: "pending",
      accepted_at: null,
      values: {
        compile_time: buildAgreementOffer().values.compile_time,
        runtime: agreementValuesByName({
          "metodo de pago": "Transferencia",
          cbu: "0170099220000067797370"
        })
      },
      files: {}
    }),
    acceptance: { source: "provided", hidden_guids: [] }
  }),
  usdOffer: () => buildAgreementSubject({
    offer: buildAgreementOffer({
      definitions: singlePaymentDefinitions().map(
        (definition) => definition.normalized_name === "importe" ? { ...definition, numeric_format_currency: "USD" } : definition
      ),
      amount: "10000",
      values: {
        compile_time: agreementValuesByName({
          importe: "10000",
          "importe ofrecido en texto": "Diez mil d\xF3lares estadounidenses",
          dias: "30"
        }),
        runtime: buildAgreementOffer().values.runtime
      }
    })
  }),
  /** The damaged good is a shop front, not a vehicle. */
  realPropertyDamage: () => buildAgreementSubject({
    damages: [realPropertyDamage()],
    claim: claimTyped(agreementFixtureClaimTypes.realProperty())
  }),
  /** A pedestrian with two injuries, treated at a hospital under a health fund. */
  injuredWithDetails: () => buildAgreementSubject({
    claim: claimTyped(agreementFixtureClaimTypes.injured()),
    damages: [
      personDamage("injury", {
        victim_role: "pedestrian",
        treatment_medical_institution: "Hospital San Mart\xEDn",
        health_insurance_fund: "OSDE",
        surgery_description: "Osteos\xEDntesis de tibia",
        details: [
          injuryDetail({
            damage: "fractures",
            severity: "moderate",
            body_parts: ["lower", "left"]
          }),
          injuryDetail()
        ]
      })
    ]
  }),
  /** A hospital recovering the treatment cost: the only damage is a recovery. */
  recoveryClaim: () => buildAgreementSubject({ damages: [recoveryDamage()] }),
  /** Two material damages loaded by mistake, out of id order: the lowest id wins. */
  duplicateMaterialDamages: () => buildAgreementSubject({
    damages: [
      vehicleDamage({
        id: "damage_02",
        description: "Segundo da\xF1o cargado",
        license_plate: "ZZ999ZZ"
      }),
      vehicleDamage()
    ]
  })
};
var agreementSampleScenarios = [
  "guidedSinglePayment",
  "guidedSinglePaymentWithFees",
  "guidedInstallments",
  "guidedInstallmentsWithFees"
];

// helpers/build-agreement-variable-values.ts
var import_i11n2 = __toESM(require_dist());
var import_piramid_constants65 = __toESM(require_dist2());
var import_utils35 = __toESM(require_dist3());

// helpers/format-agreement-value.ts
var import_i11n = __toESM(require_dist());
var import_piramid_constants64 = __toESM(require_dist2());
var import_utils34 = __toESM(require_dist3());
var localeFor = (currency) => import_piramid_constants64.currencySymbolLocaleEquivalences[currency] ?? import_piramid_constants64.DEFAULT_LOCALE;
var formatAgreementMoney = (value, currency) => (0, import_utils34.formatCurrencyAmount)(value, currency, { locale: localeFor(currency) });
var formatAgreementNumber = (value, locale94) => new Intl.NumberFormat(locale94, { maximumFractionDigits: 2 }).format(value);
var formatAgreementPercent = (value) => `${(0, import_utils34.formatTaxPercent)(value)} %`;
var formatAgreementDate = (value, format2, timezone) => (0, import_utils34.formatDateInTimeZone)(value, format2, timezone);
var formatAgreementWords = (value, currency) => (0, import_utils34.numberToSpanishWords)(value, currency);
var formatAgreementBoolean = (value) => (0, import_i11n.translate)(
  value ? "offer.agreement.boolean.yes" : "offer.agreement.boolean.no"
);
var formatAgreementList = (values) => values.join("; ");
var identificationTypeLabel = (type) => (0, import_i11n.translate)(`identification-type.${type}`);
var victimRelationshipLabel = (relationship, other) => {
  const freeText = other == null ? void 0 : other.trim();
  return relationship === "other" && freeText ? freeText : (0, import_i11n.translate)(`victim_relationship.${relationship}`);
};
var lawyerKindLabel = (kind) => (0, import_i11n.translate)(`offer.agreement.lawyer_kind.${kind}`);
var stateLabel = (country, code) => (0, import_utils34.findStateLabel)(country, code);
var otherOrLabel = (isOther, other, label) => {
  const freeText = other == null ? void 0 : other.trim();
  return isOther && freeText ? freeText : label;
};
var materialDamageKindLabel = (kind) => (0, import_i11n.translate)(`materialDamage.${kind}`);
var vehicleTypeLabel = (type) => (0, import_i11n.translate)(`vehicle.${type}`);
var vehicleUseLabel = (use) => (0, import_i11n.translate)(`vehicle.use.${use}`);
var coverageLabel = (coverage, other) => otherOrLabel(coverage === "other", other, (0, import_i11n.translate)(`coverages.${coverage}`));
var realPropertyTypeLabel = (type, other) => otherOrLabel(
  type === "other",
  other,
  (0, import_i11n.translate)(`real_property.type.${type}`)
);
var realPropertyOwnershipLabel = (ownership, other) => otherOrLabel(
  ownership === "other",
  other,
  (0, import_i11n.translate)(`real_property.ownership.${ownership}`)
);
var personDamageKindLabel = (kind) => (0, import_i11n.translate)(`offer.agreement.person_damage_kind.${kind}`);
var victimRoleLabel = (role) => (0, import_i11n.translate)(`offer.agreement.victim_role.${role}`);
var policyholderRelationshipLabel = (relationship, other) => otherOrLabel(
  relationship === "other",
  other,
  (0, import_i11n.translate)(`local-insured-relationships.${relationship}`)
);
var injuryLabel = (damage2) => (0, import_i11n.translate)(`injuries.${damage2}.label`);
var injurySeverityLabel = (severity) => (0, import_i11n.translate)(`severities.${severity}`);
var bodyPartLabel = (part) => (0, import_i11n.translate)(`fractures.${part}`, void 0, part);
var legalPersonTypeLabel = (type) => (0, import_i11n.translate)(`legal_person.type.${type}`);
var recoveryRelationshipLabel = (relationship) => (0, import_i11n.translate)(`victim_relationship.${relationship}`);
var asText = (value) => Array.isArray(value) ? value.join(", ") : String(value);
var FORMATTERS = {
  text: (value) => asText(value).trim(),
  money: (value, _definition, options) => formatAgreementMoney(Number(value), options.currency),
  number: (value, _definition, options) => formatAgreementNumber(Number(value), options.locale),
  percent: (value) => formatAgreementPercent(Number(value)),
  date: (value, definition, options) => formatAgreementDate(
    asText(value),
    definition.date_format ?? "short",
    options.timezone
  ),
  words: (value, _definition, options) => formatAgreementWords(Number(value), options.currency),
  boolean: (value) => formatAgreementBoolean(Boolean(value)),
  // Enum values arrive already translated by the projection (it knows the family).
  enum: (value) => asText(value),
  list: (value) => formatAgreementList(Array.isArray(value) ? value : [asText(value)])
};
var formatAgreementValue = (definition, value, options) => FORMATTERS[definition.type](value, definition, options);
var preservesCase = new Set(
  import_piramid_constants64.AGREEMENT_PRESERVE_CASE_KEYS
);
var presentAgreementValue = (key, type, formatted) => type === "date" || preservesCase.has(key) ? formatted : formatted.toUpperCase();

// helpers/build-agreement-variable-values.ts
var resolved = (value, extra = {}) => ({ status: "resolved", value, ...extra });
var missing2 = (reason) => ({
  status: "missing",
  reason
});
var notApplicable = (reason) => ({
  status: "not_applicable",
  reason
});
var text = (value) => (value == null ? void 0 : value.trim()) ? resolved(value.trim()) : missing2("empty_field");
var identificationLabel = (person) => {
  if (!person.identification) return null;
  const typeLabel = person.identification_type ? identificationTypeLabel(person.identification_type) : null;
  return typeLabel ? `${typeLabel} ${person.identification}` : person.identification;
};
var describePerson = (fullName, roleLabel, identification) => [`${fullName ?? ""} (${roleLabel})`.trim(), identification].filter(Boolean).join(", ");
var describeClaimant = (claimant) => describePerson(
  claimant.person.full_name,
  claimant.relationship ? victimRelationshipLabel(
    claimant.relationship,
    claimant.relationship_other
  ) : (0, import_i11n2.translate)("claim.attributes.claimants.role.value.heir"),
  identificationLabel(claimant.person)
);
var describeParent = (parent) => describePerson(
  parent.full_name,
  (0, import_i11n2.translate)(`offer.agreement.parents.${parent.type}`),
  parent.identification
);
var resolveState = (code, country, fallbackCountry) => {
  if (!(code == null ? void 0 : code.trim())) return missing2("empty_field");
  const label = stateLabel(country ?? fallbackCountry, code);
  return label ? resolved(code, { formatted: label }) : missing2("unknown_state_code");
};
var resolvePersonField = (person, field, context) => {
  const isLegalPerson = person.kind === "legal_person";
  const byField = {
    full_name: () => text(person.full_name),
    first_name: () => isLegalPerson ? notApplicable("legal_person") : text(person.first_name),
    last_name: () => isLegalPerson ? notApplicable("legal_person") : text(person.last_name),
    identification_type: () => person.identification_type ? resolved(person.identification_type, {
      formatted: identificationTypeLabel(person.identification_type)
    }) : missing2("empty_field"),
    identification: () => text(person.identification),
    address: () => text(person.address),
    city: () => text(person.city),
    state: () => resolveState(
      person.state,
      person.country,
      context.subject.company.country
    ),
    zip_code: () => text(person.zip_code),
    email: () => text(person.email),
    phone: () => isLegalPerson ? notApplicable("legal_person") : text(person.phone)
  };
  return byField[field]();
};
var personResolvers = (group, pick2, absent) => Object.fromEntries(
  import_piramid_constants65.agreementPersonVariableFields.map((field) => [
    `${group}.${field}`,
    (context) => {
      const person = pick2(context);
      return person ? resolvePersonField(person, field, context) : absent();
    }
  ])
);
var boundOutcome = (resolution, unboundReason, value) => {
  const byStatus = {
    resolved: value,
    unbound: () => notApplicable(unboundReason),
    ambiguous: () => notApplicable("ambiguous_binding"),
    acceptance_unknown: () => missing2("acceptance_unknown"),
    hidden: () => notApplicable("hidden_by_condition"),
    not_provided: () => missing2("not_provided"),
    invalid: () => missing2("invalid_value")
  };
  return byStatus[resolution.status]();
};
var numberOrInvalid = (value) => value === null ? missing2("invalid_value") : resolved(value);
var isSinglePayment = (installments) => installments !== null && installments <= import_piramid_constants65.OFFER_SINGLE_PAYMENT_INSTALLMENTS;
var termsOutcome = (facts, concept, unboundReason, typed, bound) => facts.terms_source === "typed" ? typed() : boundOutcome(facts.bindings[concept], unboundReason, bound);
var acceptanceOutcome = (facts, concept, value) => {
  if (facts.acceptance_source !== "declared")
    return boundOutcome(facts.bindings[concept], "no_binding", value);
  if (!facts.requested_acceptance_concepts.includes(concept))
    return notApplicable("not_requested");
  return facts.acceptance_known ? boundOutcome(facts.bindings[concept], "no_binding", value) : missing2("acceptance_unknown");
};
var digitsOrInvalid = (value) => value === null ? missing2("invalid_value") : resolved(value);
var money = (value, currency) => resolved(value, { currency });
var moneyInWords = (value, currency) => {
  if (!(0, import_utils35.isSpellableCurrency)(currency)) return missing2("unsupported_currency");
  const words = (0, import_utils35.numberToSpanishWords)(value, currency);
  return words ? resolved(value, { formatted: words, currency }) : missing2("out_of_range");
};
var installmentAmountOutcome = (facts, print) => {
  if (!facts.payment) return missing2("empty_field");
  return facts.payment.installmentAmount === null || isSinglePayment(facts.payment.installments) ? notApplicable("no_installments") : print(facts.payment.installmentAmount);
};
var feesAmountOutcome = (facts, print) => {
  if (!facts.payment) return missing2("empty_field");
  return facts.payment.fees === null ? notApplicable("no_fees") : print(facts.payment.fees);
};
var insuredOutcome = (context, pick2) => {
  const insured = context.facts.parties.insured;
  return insured ? pick2(insured) : missing2("no_selected_external_complaint");
};
var withSourcedFallback = (context, value) => {
  if (value) return resolved(value);
  return context.facts.parties.insured ? missing2("empty_field") : missing2("no_selected_external_complaint");
};
var resolveRepresentatives = ({
  subject,
  facts
}) => {
  const { parties, minority } = facts;
  if (subject.victim.kind === "legal_person") {
    const legalRepresentatives = parties.representatives.filter(
      (claimant) => claimant.relationship === "legal_representative"
    );
    const representatives = [
      ...legalRepresentatives,
      ...parties.lawyer ? [parties.lawyer] : []
    ];
    return representatives.length > 0 ? resolved(representatives.map(describeClaimant)) : missing2("representative_unknown");
  }
  if (minority === "unknown") return missing2("birth_date_missing");
  if (minority === "adult") return notApplicable("not_represented");
  if (parties.victim_parents.length > 0) {
    return resolved(parties.victim_parents.map(describeParent));
  }
  const tutors = parties.representatives.filter(
    (claimant) => claimant.relationship === "tutor_curator"
  );
  return tutors.length > 0 ? resolved(tutors.map(describeClaimant)) : missing2("representative_unknown");
};
var DAMAGE_TYPE_ORDER = [
  "material",
  "person",
  "recovery"
];
var materialOutcome = ({ facts }, pick2) => {
  const damage2 = facts.damages.material;
  return (damage2 == null ? void 0 : damage2.material) ? pick2(damage2.material, damage2) : notApplicable("no_material_damage");
};
var vehicleOutcome = (context, pick2) => materialOutcome(context, (material) => {
  if (material.type !== "vehicle") return notApplicable("no_vehicle");
  return material.vehicle ? pick2(material.vehicle) : missing2("empty_field");
});
var realPropertyOutcome = (context, pick2) => materialOutcome(context, (material) => {
  if (material.type !== "real_property") {
    return notApplicable("no_real_property");
  }
  return material.real_property ? pick2(material.real_property) : missing2("empty_field");
});
var driverOutcome = (context, pick2) => materialOutcome(
  context,
  (material) => material.driver ? pick2(material.driver) : notApplicable("no_driver")
);
var insuranceOutcome = (context, pick2) => materialOutcome(
  context,
  (material) => material.insurance ? pick2(material.insurance) : notApplicable("no_insurance")
);
var personDamageOutcome = ({ facts }, pick2) => {
  var _a;
  const person = (_a = facts.damages.person) == null ? void 0 : _a.person;
  return person ? pick2(person) : notApplicable("no_person_damage");
};
var recoveryOutcome = ({ facts }, pick2) => {
  var _a;
  const recovery = (_a = facts.damages.recovery) == null ? void 0 : _a.recovery;
  return recovery ? pick2(recovery) : notApplicable("no_recovery_damage");
};
var vehicleSummary = (vehicle) => {
  const description = (0, import_utils35.buildVehicleLabel)(vehicle);
  if (!description) return null;
  return vehicle.license_plate ? (0, import_i11n2.translate)("offer.agreement.material_damage_summary.vehicle_with_plate", {
    description,
    license_plate: vehicle.license_plate
  }) : (0, import_i11n2.translate)("offer.agreement.material_damage_summary.vehicle", {
    description
  });
};
var realPropertySummary = (property) => {
  if (!property.address) return null;
  return property.city ? (0, import_i11n2.translate)(
    "offer.agreement.material_damage_summary.real_property_with_city",
    { address: property.address, city: property.city }
  ) : (0, import_i11n2.translate)("offer.agreement.material_damage_summary.real_property", {
    address: property.address
  });
};
var materialSummary = (material) => material.type === "vehicle" ? material.vehicle && vehicleSummary(material.vehicle) : material.real_property && realPropertySummary(material.real_property);
var describeInjury = (detail) => {
  const injury = `${injuryLabel(detail.damage)} (${injurySeverityLabel(
    detail.severity
  )})`;
  const parts = detail.body_parts.map(bodyPartLabel);
  return parts.length > 0 ? `${injury}: ${parts.join(", ")}` : injury;
};
var resolvePolicyholderRelationship = (person) => {
  if (person.policyholder_relationship) {
    return resolved(person.policyholder_relationship, {
      formatted: policyholderRelationshipLabel(
        person.policyholder_relationship,
        person.policyholder_relationship_other
      )
    });
  }
  const transportedByPolicyholder = person.victim_role === null || person.victim_role === "policyholder_rider";
  return transportedByPolicyholder ? missing2("empty_field") : notApplicable("not_policyholder_rider");
};
var resolveInjuries = (person) => {
  if (person.details.length > 0) {
    return resolved(person.details.map(describeInjury));
  }
  return person.type === "death" ? notApplicable("no_injury_details") : missing2("empty_field");
};
var sinisterDate = ({ facts }) => facts.sinister_date.value ? resolved(facts.sinister_date.value) : missing2("empty_field");
var STATIC_RESOLVERS = {
  "company.name": ({ subject }) => text(subject.company.name),
  "company.tax_id": ({ subject }) => text(subject.company.tax_id),
  "claim.ref_id": ({ subject }) => text(subject.claim.ref_id),
  "claim.external_claim_id": ({ subject }) => text(subject.claim.external_claim_id),
  "claim.external_claim_request_id": ({ subject }) => text(subject.claim.external_claim_request_id),
  "claim.type": ({ subject }) => subject.claim.claim_type ? text(subject.claim.claim_type.name) : missing2("no_claim_type"),
  "claim.damages.types": ({ facts }) => {
    const present = DAMAGE_TYPE_ORDER.filter(
      (type) => facts.damage_types.includes(type)
    );
    return present.length > 0 ? resolved(present.map((type) => (0, import_i11n2.translate)(`damages.${type}`))) : missing2("empty_field");
  },
  ...personResolvers(
    "victim",
    ({ subject }) => subject.victim,
    () => missing2("empty_field")
  ),
  "victim.birth_date": ({ subject }) => subject.victim.kind === "legal_person" ? notApplicable("legal_person") : subject.victim.birth_date ? resolved(subject.victim.birth_date) : missing2("empty_field"),
  "victim.is_minor": ({ subject, facts }) => {
    if (subject.victim.kind === "legal_person")
      return notApplicable("legal_person");
    if (facts.minority === "unknown") return missing2("birth_date_missing");
    return resolved(facts.minority === "minor");
  },
  "victim.is_deceased": ({ facts }) => resolved(facts.victim_is_deceased),
  "victim.parents.father.full_name": ({ subject }) => subject.victim.parents.father ? text(subject.victim.parents.father.full_name) : notApplicable("no_parents"),
  "victim.parents.father.identification": ({ subject }) => subject.victim.parents.father ? text(subject.victim.parents.father.identification) : notApplicable("no_parents"),
  "victim.parents.mother.full_name": ({ subject }) => subject.victim.parents.mother ? text(subject.victim.parents.mother.full_name) : notApplicable("no_parents"),
  "victim.parents.mother.identification": ({ subject }) => subject.victim.parents.mother ? text(subject.victim.parents.mother.identification) : notApplicable("no_parents"),
  "victim.representatives": resolveRepresentatives,
  ...personResolvers(
    "claimant",
    ({ facts }) => {
      var _a;
      return ((_a = facts.parties.claimant) == null ? void 0 : _a.person) ?? null;
    },
    () => missing2("no_claimant")
  ),
  "claimant.relationship": ({ facts }) => {
    const { claimant } = facts.parties;
    if (!claimant) return missing2("no_claimant");
    if (!claimant.relationship) return missing2("empty_field");
    return resolved(claimant.relationship, {
      formatted: victimRelationshipLabel(
        claimant.relationship,
        claimant.relationship_other
      )
    });
  },
  "claimant.relationship_other": ({ facts }) => facts.parties.claimant ? text(facts.parties.claimant.relationship_other) : missing2("no_claimant"),
  "claimant.is_victim": ({ facts }) => facts.parties.claimant ? resolved(facts.claimant_is_victim) : missing2("no_claimant"),
  ...personResolvers(
    "lawyer",
    ({ facts }) => {
      var _a;
      return ((_a = facts.parties.lawyer) == null ? void 0 : _a.person) ?? null;
    },
    () => notApplicable("no_lawyer")
  ),
  "lawyer.kind": ({ facts }) => facts.parties.lawyer ? resolved(facts.parties.lawyer.kind, {
    formatted: lawyerKindLabel(facts.parties.lawyer.kind)
  }) : notApplicable("no_lawyer"),
  "lawyer.cuit": ({ facts }) => {
    const { lawyer } = facts.parties;
    if (!lawyer) return notApplicable("no_lawyer");
    const cuit = resolveLawyerCuit(lawyer);
    return cuit ? resolved(cuit) : missing2("lawyer_identification_not_cuit");
  },
  "heirs.count": ({ facts }) => resolved(facts.heirs_count),
  "heirs.list": ({ facts }) => facts.parties.heirs.length > 0 ? resolved(facts.parties.heirs.map(describeClaimant)) : notApplicable("no_heirs"),
  "heirs.names": ({ facts }) => facts.parties.heirs.length > 0 ? resolved(
    facts.parties.heirs.map((heir) => heir.person.full_name ?? "").filter(Boolean)
  ) : notApplicable("no_heirs"),
  "insured.full_name": (context) => insuredOutcome(context, (insured) => text(insured.full_name)),
  "insured.identification": (context) => insuredOutcome(
    context,
    (insured) => text(insured.identification ?? insured.cuil)
  ),
  "insured.address": (context) => insuredOutcome(context, (insured) => text(insured.address)),
  "insured.city": (context) => insuredOutcome(context, (insured) => text(insured.city)),
  "insured.state": (context) => insuredOutcome(context, (insured) => text(insured.state)),
  "insured.policy_number": (context) => withSourcedFallback(context, context.facts.policy_number.value),
  "insured_vehicle.license_plate": (context) => withSourcedFallback(context, context.facts.license_plate.value),
  "insured_vehicle.description": (context) => insuredOutcome(
    context,
    (insured) => text(
      [insured.make, insured.model, insured.year].filter(Boolean).join(" ")
    )
  ),
  "insured_vehicle.make": (context) => insuredOutcome(context, (insured) => text(insured.make)),
  "insured_vehicle.model": (context) => insuredOutcome(context, (insured) => text(insured.model)),
  "insured_vehicle.year": (context) => insuredOutcome(context, (insured) => text(insured.year)),
  "sinister.number": ({ subject }) => subject.external_complaint ? text(subject.external_complaint.external_id) : missing2("no_selected_external_complaint"),
  "sinister.date": sinisterDate,
  "sinister.date_long": sinisterDate,
  "sinister.address": ({ subject }) => text(subject.occurrence.address),
  "sinister.city": ({ subject }) => text(subject.occurrence.city),
  "sinister.state": ({ subject }) => resolveState(
    subject.occurrence.state,
    subject.occurrence.country,
    subject.company.country
  ),
  "claim.damages.material.kind": (context) => materialOutcome(
    context,
    (material) => resolved(material.type, {
      formatted: materialDamageKindLabel(material.type)
    })
  ),
  "claim.damages.material.description": (context) => materialOutcome(context, (_material, damage2) => text(damage2.description)),
  "claim.damages.material.summary": (context) => materialOutcome(context, (material) => text(materialSummary(material))),
  "claim.damages.material.vehicle.description": (context) => vehicleOutcome(context, (vehicle) => text((0, import_utils35.buildVehicleLabel)(vehicle))),
  "claim.damages.material.vehicle.make": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.make)),
  "claim.damages.material.vehicle.model": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.model)),
  "claim.damages.material.vehicle.version": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.version)),
  "claim.damages.material.vehicle.year": (context) => vehicleOutcome(
    context,
    (vehicle) => vehicle.year === null ? missing2("empty_field") : resolved(String(vehicle.year))
  ),
  "claim.damages.material.vehicle.license_plate": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.license_plate)),
  "claim.damages.material.vehicle.chassis": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.chassis)),
  "claim.damages.material.vehicle.engine": (context) => vehicleOutcome(context, (vehicle) => text(vehicle.engine)),
  "claim.damages.material.vehicle.type": (context) => vehicleOutcome(
    context,
    (vehicle) => resolved(vehicle.type, { formatted: vehicleTypeLabel(vehicle.type) })
  ),
  "claim.damages.material.vehicle.use": (context) => vehicleOutcome(
    context,
    (vehicle) => vehicle.use ? resolved(vehicle.use, { formatted: vehicleUseLabel(vehicle.use) }) : missing2("empty_field")
  ),
  "claim.damages.material.driver.full_name": (context) => driverOutcome(context, (driver) => text(driver.full_name)),
  "claim.damages.material.insurance.insurer": (context) => insuranceOutcome(context, (insurance) => text(insurance.insurer)),
  "claim.damages.material.insurance.policy_number": (context) => insuranceOutcome(context, (insurance) => text(insurance.policy_number)),
  "claim.damages.material.insurance.coverage": (context) => insuranceOutcome(
    context,
    (insurance) => resolved(insurance.coverage, {
      formatted: coverageLabel(insurance.coverage, insurance.other_coverage)
    })
  ),
  "claim.damages.material.real_property.type": (context) => realPropertyOutcome(
    context,
    (property) => resolved(property.type, {
      formatted: realPropertyTypeLabel(property.type, property.other_type)
    })
  ),
  "claim.damages.material.real_property.ownership": (context) => realPropertyOutcome(
    context,
    (property) => resolved(property.ownership, {
      formatted: realPropertyOwnershipLabel(
        property.ownership,
        property.other_ownership
      )
    })
  ),
  "claim.damages.material.real_property.address": (context) => realPropertyOutcome(context, (property) => text(property.address)),
  "claim.damages.material.real_property.city": (context) => realPropertyOutcome(context, (property) => text(property.city)),
  "claim.damages.material.real_property.state": (context) => realPropertyOutcome(
    context,
    (property) => resolveState(
      property.state,
      property.country,
      context.subject.company.country
    )
  ),
  "claim.damages.material.real_property.zip_code": (context) => realPropertyOutcome(context, (property) => text(property.zip_code)),
  "claim.damages.person.kind": (context) => personDamageOutcome(
    context,
    (person) => resolved(person.type, { formatted: personDamageKindLabel(person.type) })
  ),
  "claim.damages.person.victim_role": (context) => personDamageOutcome(
    context,
    (person) => person.victim_role ? resolved(person.victim_role, {
      formatted: victimRoleLabel(person.victim_role)
    }) : missing2("empty_field")
  ),
  "claim.damages.person.policyholder_relationship": (context) => personDamageOutcome(context, resolvePolicyholderRelationship),
  "claim.damages.person.treatment_medical_institution": (context) => personDamageOutcome(
    context,
    (person) => text(person.treatment_medical_institution)
  ),
  "claim.damages.person.health_insurance_fund": (context) => personDamageOutcome(
    context,
    (person) => text(person.health_insurance_fund)
  ),
  "claim.damages.person.treatment_worker_compensation_insurer": (context) => personDamageOutcome(
    context,
    (person) => text(person.treatment_worker_compensation_insurer)
  ),
  "claim.damages.person.surgery_description": (context) => personDamageOutcome(context, (person) => text(person.surgery_description)),
  "claim.damages.person.injuries": (context) => personDamageOutcome(context, resolveInjuries),
  "claim.damages.recovery.institution.full_name": (context) => recoveryOutcome(
    context,
    (recovery) => text(recovery.institution.full_name)
  ),
  "claim.damages.recovery.institution.identification": (context) => recoveryOutcome(
    context,
    (recovery) => text(recovery.institution.identification)
  ),
  "claim.damages.recovery.institution.type": (context) => recoveryOutcome(
    context,
    ({ institution }) => institution.legal_person_type ? resolved(institution.legal_person_type, {
      formatted: legalPersonTypeLabel(institution.legal_person_type)
    }) : missing2("empty_field")
  ),
  "claim.damages.recovery.claimant_relationship": (context) => recoveryOutcome(
    context,
    (recovery) => resolved(recovery.claimant_institution_relationship, {
      formatted: recoveryRelationshipLabel(
        recovery.claimant_institution_relationship
      )
    })
  ),
  "offer.amount": ({ facts }) => facts.amount === null ? missing2("empty_field") : money(facts.amount, facts.currency),
  "offer.amount_in_words": ({ facts }) => facts.amount === null ? missing2("empty_field") : moneyInWords(facts.amount, facts.currency),
  "offer.amount_in_words_declared": ({ facts }) => boundOutcome(
    facts.bindings.amount_in_words,
    "no_binding",
    () => text(facts.amount_in_words_declared)
  ),
  "offer.installments": ({ facts }) => {
    const installments = () => isSinglePayment(facts.installments) ? notApplicable("no_installments") : numberOrInvalid(facts.installments);
    return termsOutcome(
      facts,
      "installments",
      "no_installments",
      installments,
      installments
    );
  },
  "offer.fee_percentage": ({ facts }) => termsOutcome(
    facts,
    "fee_percentage",
    "no_fees",
    () => facts.fee_percentage === null ? notApplicable("no_fees") : resolved(facts.fee_percentage),
    () => numberOrInvalid(facts.fee_percentage)
  ),
  "offer.payment_days": ({ facts }) => {
    const paymentDays = () => numberOrInvalid(facts.payment_days);
    return termsOutcome(
      facts,
      "payment_days",
      "no_binding",
      paymentDays,
      paymentDays
    );
  },
  // Opcional por naturaleza: sin motivo no es un hueco del reclamo, es que no
  // se escribió ninguno, y la carta lo oculta con `[[#if]]`.
  "offer.public_reason": ({ subject }) => {
    var _a;
    return ((_a = subject.offer.public_reason) == null ? void 0 : _a.trim()) ? text(subject.offer.public_reason.trim()) : notApplicable("no_public_reason");
  },
  "offer.sent_at": ({ subject }) => {
    if (subject.offer.kind === "draft") return notApplicable("draft_offer");
    return subject.offer.created_at ? resolved(subject.offer.created_at) : missing2("empty_field");
  },
  "offer.accepted_at": ({ subject }) => subject.offer.accepted_at ? resolved(subject.offer.accepted_at) : missing2("acceptance_unknown"),
  "payment.fees_amount": ({ facts }) => feesAmountOutcome(facts, (amount) => money(amount, facts.currency)),
  "payment.total_amount": ({ facts }) => facts.payment ? money(facts.payment.total, facts.currency) : missing2("empty_field"),
  "payment.installment_amount": ({ facts }) => installmentAmountOutcome(facts, (amount) => money(amount, facts.currency)),
  "payment.installment_amount_in_words": ({ facts }) => installmentAmountOutcome(
    facts,
    (amount) => moneyInWords(amount, facts.currency)
  ),
  "payment.fees_amount_in_words": ({ facts }) => feesAmountOutcome(facts, (amount) => moneyInWords(amount, facts.currency)),
  // El método lo fija el ofrecimiento al enviarse, no el reclamante: se sabe
  // desde la vista previa y nunca queda pendiente.
  "acceptance.payment_method": ({ facts }) => facts.acceptance_source === "declared" ? text(facts.payment_method) : boundOutcome(
    facts.bindings.payment_method,
    "no_binding",
    () => text(facts.payment_method)
  ),
  "acceptance.cbu": ({ facts }) => acceptanceOutcome(facts, "cbu", () => digitsOrInvalid(facts.cbu)),
  "acceptance.cuit": ({ facts }) => acceptanceOutcome(facts, "cuit", () => digitsOrInvalid(facts.cuit)),
  "acceptance.lawyer_cbu": ({ facts }) => acceptanceOutcome(
    facts,
    "lawyer_cbu",
    () => digitsOrInvalid(facts.lawyer_cbu)
  ),
  "acceptance.lawyer_cuit": ({ facts }) => acceptanceOutcome(
    facts,
    "lawyer_cuit",
    () => digitsOrInvalid(facts.lawyer_cuit)
  ),
  "acceptance.identification": ({ facts }) => acceptanceOutcome(
    facts,
    "identification",
    () => digitsOrInvalid(facts.declared_identification)
  ),
  "document.date": ({ documentDate }) => resolved(documentDate),
  "document.date_short": ({ documentDate }) => resolved(documentDate)
};
var agreementDynamicVariableKey = (determination, name) => {
  const prefix = determination === "runtime" ? import_piramid_constants65.AGREEMENT_DYNAMIC_PREFIXES.acceptance : import_piramid_constants65.AGREEMENT_DYNAMIC_PREFIXES.offer;
  const slug = (0, import_utils35.slugify)(name).replace(/-/g, "_") || "variable";
  return `${prefix}.${slug}`;
};
var formatPlainNumber = (value, locale94) => new Intl.NumberFormat(locale94, {
  useGrouping: false,
  maximumFractionDigits: 2
}).format(value);
var resolveDynamic = (definition, { subject }, options, warnings) => {
  if (definition.type === "file") {
    return { outcome: notApplicable("unprintable"), type: "text" };
  }
  const isRuntime = definition.determination === "runtime";
  if (isRuntime && subject.acceptance.source === "none") {
    return { outcome: missing2("acceptance_unknown"), type: "text" };
  }
  if (isRuntime && subject.acceptance.hidden_guids.includes(definition.guid)) {
    return { outcome: notApplicable("hidden_by_condition"), type: "text" };
  }
  const values = isRuntime ? subject.offer.values.runtime : subject.offer.values.compile_time;
  const raw = values[definition.guid];
  if (raw === void 0 || raw.trim() === "") {
    return {
      outcome: missing2(isRuntime ? "not_provided" : "empty_field"),
      type: "text"
    };
  }
  if (definition.type === "numeric") {
    const parsed = Number(raw);
    if (!Number.isFinite(parsed)) {
      return { outcome: missing2("invalid_value"), type: "number" };
    }
    if (definition.numeric_format_currency) {
      return {
        outcome: resolved(parsed, {
          currency: definition.numeric_format_currency,
          formatted: formatAgreementMoney(
            parsed,
            definition.numeric_format_currency
          )
        }),
        type: "money"
      };
    }
    return {
      outcome: resolved(parsed, {
        formatted: definition.numeric_format ? formatAgreementNumber(parsed, options.locale) : formatPlainNumber(parsed, options.locale)
      }),
      type: "number"
    };
  }
  if (definition.type === "select" && definition.options && !definition.options.some((option) => option.name === raw)) {
    warnings.push({
      code: "unknown_select_option",
      detail: { name: definition.name, value: raw }
    });
  }
  return { outcome: resolved(raw.trim()), type: "text" };
};
var toVariableValue = (key, definition, outcome, options) => {
  if (outcome.status === "resolved") {
    return {
      status: "resolved",
      key,
      type: definition.type,
      value: outcome.value,
      formatted: presentAgreementValue(
        key,
        definition.type,
        outcome.formatted ?? formatAgreementValue(definition, outcome.value, {
          ...options,
          currency: outcome.currency ?? options.currency
        })
      ),
      ...outcome.currency ? { currency: outcome.currency } : {}
    };
  }
  return {
    status: outcome.status,
    key,
    type: definition.type,
    reason: outcome.reason
  };
};
var OFFER_DEPENDENT_GROUPS = [
  "offer",
  "payment",
  "acceptance"
];
var buildAgreementVariableValues = (subject, facts, meta) => {
  const context = {
    subject,
    facts,
    documentDate: meta.document_date ?? meta.now
  };
  const options = {
    locale: meta.locale,
    timezone: meta.timezone,
    currency: facts.currency
  };
  const warnings = [];
  const variables = {};
  const withoutOffer = subject.offer.kind === "none";
  for (const definition of import_piramid_constants65.agreementVariables) {
    const outcome = withoutOffer && OFFER_DEPENDENT_GROUPS.includes(definition.group) ? missing2("no_offer") : STATIC_RESOLVERS[definition.key](context);
    variables[definition.key] = toVariableValue(
      definition.key,
      definition,
      outcome,
      options
    );
  }
  const usedKeys = /* @__PURE__ */ new Set();
  for (const definition of subject.offer.definitions) {
    const baseKey = agreementDynamicVariableKey(
      definition.determination,
      definition.name
    );
    let key = baseKey;
    let suffix = 2;
    while (usedKeys.has(key)) {
      key = `${baseKey}_${suffix}`;
      suffix += 1;
    }
    if (key !== baseKey) {
      warnings.push({
        code: "dynamic_key_collision",
        detail: { name: definition.name, key }
      });
    }
    usedKeys.add(key);
    const { outcome, type } = resolveDynamic(
      definition,
      context,
      options,
      warnings
    );
    variables[key] = toVariableValue(key, { type }, outcome, options);
  }
  const missingEntries = Object.values(variables).flatMap(
    (variable) => variable.status === "missing" ? [{ key: variable.key, reason: variable.reason }] : []
  );
  return { variables, missing: missingEntries, warnings };
};
var agreementVariablesToTemplateContext = (variables) => Object.fromEntries(
  Object.entries(variables).map(([key, variable]) => [
    key,
    variable.status === "resolved" ? variable.formatted : ""
  ])
);

// helpers/build-agreement-rule-context.ts
var variablesByName = (subject, determination) => Object.fromEntries(
  subject.offer.definitions.filter((definition) => definition.determination === determination).flatMap((definition) => {
    const value = subject.offer.values[determination][definition.guid];
    return value === void 0 ? [] : [[definition.normalized_name, value]];
  })
);
var buildAgreementRuleContext = (subject, facts) => ({
  company_id: subject.company.id,
  claim: {
    id: subject.claim.id,
    claim_type_id: subject.claim.claim_type_id,
    classification: facts.claim_classification,
    damage_types: facts.damage_types,
    person_damage_types: facts.person_damage_types,
    material_damage_types: facts.material_damage_types,
    victim_kind: facts.victim_kind,
    victim_is_minor: facts.minority === "unknown" ? null : facts.minority === "minor",
    victim_is_deceased: facts.victim_is_deceased,
    victim_has_parents: facts.victim_has_parents,
    claimants_count: facts.claimants_count,
    claimant_relationship: facts.claimant_relationship,
    claimant_relationships: facts.claimant_relationships,
    claimant_is_victim: facts.claimant_is_victim,
    has_lawyer: facts.has_lawyer,
    lawyer_kind: facts.lawyer_kind,
    lawyer_count: facts.lawyer_count,
    heirs_count: facts.heirs_count,
    has_external_complaint: facts.has_external_complaint,
    team_id: subject.claim.team_id,
    responsible_user_id: subject.claim.responsible_user_id
  },
  offer: {
    known: subject.offer.kind !== "none",
    message_template_id: subject.offer.message_template_id,
    amount: facts.amount,
    currency: facts.currency,
    installments: facts.installments,
    fee_percentage: facts.fee_percentage,
    payment_days: facts.payment_days,
    has_installments: (facts.installments ?? 0) > 1,
    has_fees: (facts.fee_percentage ?? 0) > 0,
    variable: variablesByName(subject, "compile_time")
  },
  acceptance: {
    known: facts.acceptance_known,
    source: subject.acceptance.source,
    complete: facts.acceptance_complete,
    payment_method: facts.payment_method,
    has_lawyer_bank_data: facts.lawyer_cbu !== null && facts.lawyer_cuit !== null,
    variable: variablesByName(subject, "runtime")
  }
});

// helpers/compile-agreement-template.ts
var import_handlebars2 = __toESM(require("handlebars"));
var import_piramid_constants69 = __toESM(require_dist2());

// helpers/extract-agreement-template-variables.ts
var import_handlebars = __toESM(require("handlebars"));
var import_piramid_constants66 = __toESM(require_dist2());
var IF_HELPER = "if";
var pathOf = (node) => node.type === "PathExpression" && !node.data ? node.original : null;
var collectReferences = (program, guards, into) => {
  for (const statement of program.body) {
    if (statement.type === "MustacheStatement") {
      const key = pathOf(statement.path);
      if (key) into.push({ key, required: !guards.includes(key) });
    }
    if (statement.type === "BlockStatement") {
      const block = statement;
      const [param] = block.params;
      const guard = pathOf(block.path) === IF_HELPER && param ? pathOf(param) : null;
      if (guard) into.push({ key: guard, required: false });
      collectReferences(
        block.program,
        guard ? [...guards, guard] : guards,
        into
      );
      if (block.inverse) {
        collectReferences(
          block.inverse,
          guard ? [...guards, guard] : guards,
          into
        );
      }
    }
  }
};
var textsOf = (block) => {
  switch (block.kind) {
    case "title":
    case "paragraph":
      return [block.text];
    case "clause":
      return block.title ? [block.title, block.text] : [block.text];
    default:
      return [];
  }
};
var isAgreementTemplateVariableKey = (key) => (0, import_piramid_constants66.isAgreementVariableKey)(key) || (0, import_piramid_constants66.isAgreementDynamicVariableKey)(key);
var extractAgreementTemplateVariables = (content) => {
  var _a;
  const references = [];
  const syntax_errors = [];
  for (const block of content.blocks) {
    const conditioned = Boolean((_a = block.condition) == null ? void 0 : _a.all.length);
    const collected = [];
    for (const text2 of textsOf(block)) {
      try {
        collectReferences(
          import_handlebars.default.parse(customHandlebarsToHandlebars(text2)),
          [],
          collected
        );
      } catch (error) {
        syntax_errors.push({
          block_id: block.id,
          message: error instanceof Error ? error.message : String(error)
        });
      }
    }
    if (block.kind === "key_values") {
      for (const item of block.items) {
        collected.push({ key: item.variable, required: true });
      }
    }
    references.push(
      ...collected.map((reference) => ({
        ...reference,
        required: reference.required && !conditioned
      }))
    );
  }
  const requiredByKey = /* @__PURE__ */ new Map();
  for (const reference of references) {
    requiredByKey.set(
      reference.key,
      (requiredByKey.get(reference.key) ?? false) || reference.required
    );
  }
  const variables = Array.from(requiredByKey, ([key, required]) => ({
    key,
    required
  }));
  return {
    variables,
    unknown_keys: variables.map((variable) => variable.key).filter((key) => !isAgreementTemplateVariableKey(key)),
    syntax_errors
  };
};

// helpers/evaluate-agreement-condition.ts
var import_piramid_constants67 = __toESM(require_dist2());

// helpers/read-agreement-rule-attribute.ts
var variableOf = (values, name) => name !== null && name in values ? values[name] : void 0;
var AGREEMENT_RULE_ATTRIBUTE_READERS = {
  "claim.claim_type_id": (context) => context.claim.claim_type_id,
  "claim.classification": (context) => context.claim.classification,
  "claim.damage_types": (context) => context.claim.damage_types,
  "claim.person_damage_types": (context) => context.claim.person_damage_types,
  "claim.material_damage_types": (context) => context.claim.material_damage_types,
  "claim.victim_kind": (context) => context.claim.victim_kind,
  "claim.victim_is_minor": (context) => context.claim.victim_is_minor,
  "claim.victim_is_deceased": (context) => context.claim.victim_is_deceased,
  "claim.victim_has_parents": (context) => context.claim.victim_has_parents,
  "claim.claimants_count": (context) => context.claim.claimants_count,
  "claim.claimant_relationship": (context) => context.claim.claimant_relationship,
  "claim.claimant_relationships": (context) => context.claim.claimant_relationships,
  "claim.claimant_is_victim": (context) => context.claim.claimant_is_victim,
  "claim.has_lawyer": (context) => context.claim.has_lawyer,
  "claim.lawyer_kind": (context) => context.claim.lawyer_kind,
  "claim.lawyer_count": (context) => context.claim.lawyer_count,
  "claim.heirs_count": (context) => context.claim.heirs_count,
  "claim.has_external_complaint": (context) => context.claim.has_external_complaint,
  "claim.team_id": (context) => context.claim.team_id,
  "claim.responsible_user_id": (context) => context.claim.responsible_user_id,
  "offer.message_template_id": (context) => context.offer.message_template_id,
  "offer.amount": (context) => context.offer.amount,
  "offer.currency": (context) => context.offer.currency,
  "offer.installments": (context) => context.offer.installments,
  "offer.fee_percentage": (context) => context.offer.fee_percentage,
  "offer.payment_days": (context) => context.offer.payment_days,
  "offer.has_installments": (context) => context.offer.has_installments,
  "offer.has_fees": (context) => context.offer.has_fees,
  "offer.variable": (context, name) => variableOf(context.offer.variable, name),
  "acceptance.complete": (context) => context.acceptance.complete,
  "acceptance.payment_method": (context) => context.acceptance.payment_method,
  "acceptance.has_lawyer_bank_data": (context) => context.acceptance.has_lawyer_bank_data,
  "acceptance.variable": (context, name) => variableOf(context.acceptance.variable, name)
};
var readAgreementRuleAttribute = (attribute, context, name) => AGREEMENT_RULE_ATTRIBUTE_READERS[attribute](context, name);

// helpers/evaluate-agreement-condition.ts
var asList = (value) => Array.isArray(value) ? value : [String(value)];
var asNumber = (value) => typeof value === "number" ? value : Number(value);
var COMPARATORS = {
  eq: (actual, value) => actual === value,
  ne: (actual, value) => actual !== value,
  in: (actual, value) => asList(value).includes(String(actual)),
  not_in: (actual, value) => !asList(value).includes(String(actual)),
  gt: (actual, value) => asNumber(actual) > asNumber(value),
  gte: (actual, value) => asNumber(actual) >= asNumber(value),
  lt: (actual, value) => asNumber(actual) < asNumber(value),
  lte: (actual, value) => asNumber(actual) <= asNumber(value),
  contains_any: (actual, value) => asList(actual).some((entry) => asList(value).includes(entry)),
  contains_all: (actual, value) => asList(value).every((entry) => asList(actual).includes(entry)),
  contains_none: (actual, value) => !asList(actual).some((entry) => asList(value).includes(entry)),
  is_empty: (actual, value) => asList(actual).length === 0 === value,
  exists: () => true
};
var decide = (condition, actual) => {
  if (condition.operator === "exists")
    return {
      result: (actual !== null && actual !== void 0) === condition.value ? "true" : "false",
      reason: null
    };
  if (actual === void 0)
    return { result: "undetermined", reason: "unknown_variable" };
  if (actual === null) {
    const { null_semantics } = (0, import_piramid_constants67.agreementRuleAttribute)(condition.attribute);
    return null_semantics === "absent" ? { result: "false", reason: null } : { result: "undetermined", reason: "unknown_value" };
  }
  return {
    result: COMPARATORS[condition.operator](actual, condition.value) ? "true" : "false",
    reason: null
  };
};
var evaluateAgreementCondition = (condition, context) => {
  const definition = (0, import_piramid_constants67.agreementRuleAttribute)(condition.attribute);
  const seen = { ...condition, actual: null };
  if (definition.stage !== "claim" && !context.offer.known)
    return { ...seen, result: "undetermined", reason: "pending_offer" };
  if (definition.stage === "accept" && !context.acceptance.known)
    return { ...seen, result: "undetermined", reason: "pending_acceptance" };
  const actual = readAgreementRuleAttribute(
    condition.attribute,
    context,
    condition.name
  );
  return {
    ...seen,
    actual: actual ?? null,
    ...decide(condition, actual)
  };
};

// helpers/classify-agreement-gap.ts
var import_piramid_constants68 = __toESM(require_dist2());
var classifyAgreementGap = ({
  key,
  value,
  stage
}) => {
  if (!value) return "unknown_key";
  if (value.status === "resolved") return null;
  if (value.status === "not_applicable") return "not_applicable";
  return stage === "send" && (0, import_piramid_constants68.agreementVariableStageOf)(key) === "accept" ? "pending" : "absent";
};

// helpers/resolve-agreement-template-gaps.ts
var resolveAgreementTemplateGaps = (referenced, variables, { stage = "accept" } = {}) => referenced.flatMap(({ key, required }) => {
  const value = variables[key];
  const gapClass = classifyAgreementGap({ key, value, stage });
  if (!gapClass || (value == null ? void 0 : value.status) === "resolved") return [];
  const blocking = required && (gapClass === "absent" || gapClass === "unknown_key");
  if (!value)
    return [
      {
        key,
        required,
        status: "unknown_key",
        reason: null,
        class: gapClass,
        blocking
      }
    ];
  return [
    {
      key,
      required,
      status: value.status,
      reason: value.reason,
      class: gapClass,
      blocking
    }
  ];
});

// helpers/compile-agreement-template.ts
var isContainer = (value) => typeof value === "object" && value !== null;
var createContainer = () => /* @__PURE__ */ Object.create(null);
var containerFor = (root, segments) => {
  let cursor = root;
  for (const segment of segments) {
    const existing = cursor[segment];
    if (existing !== void 0 && !isContainer(existing)) return null;
    const container = isContainer(existing) ? existing : createContainer();
    cursor[segment] = container;
    cursor = container;
  }
  return cursor;
};
var nestContext = (flat) => {
  const nested = createContainer();
  for (const [key, value] of Object.entries(flat)) {
    const segments = key.split(".");
    const leaf = segments[segments.length - 1];
    const container = containerFor(nested, segments.slice(0, -1));
    if (container && !isContainer(container[leaf])) container[leaf] = value;
  }
  return nested;
};
var failureMessage = (error) => error instanceof Error ? error.message : String(error);
var compileText = (text2, context) => import_handlebars2.default.compile(customHandlebarsToHandlebars(text2), {
  strict: true,
  noEscape: true
})(context).trim();
var clauseOrdinal = (index) => import_piramid_constants69.agreementClauseOrdinals[index] ?? String(index + 1);
var evaluateBlockCondition = (block, ruleContext) => {
  var _a;
  const conditions = (_a = block.condition) == null ? void 0 : _a.all;
  if (!conditions || conditions.length === 0 || !ruleContext) return null;
  const evaluated = conditions.map(
    (condition) => evaluateAgreementCondition(condition, ruleContext)
  );
  if (evaluated.some((condition) => condition.result === "false"))
    return { gap: null };
  const unanswered = evaluated.find(
    (condition) => condition.result === "undetermined"
  );
  return unanswered ? {
    gap: {
      block_id: block.id,
      attribute: unanswered.attribute,
      reason: unanswered.reason ?? "unknown_value"
    }
  } : null;
};
var placeholderClassOf = (gap) => {
  if (gap.class === "pending") return "pending";
  return gap.required && (gap.class === "absent" || gap.class === "unknown_key") ? gap.class : null;
};
var previewPlaceholders = (missing3) => new Map(
  missing3.flatMap((gap) => {
    const placeholderClass = placeholderClassOf(gap);
    return placeholderClass ? [[gap.key, (0, import_piramid_constants69.agreementPlaceholderToken)(placeholderClass, gap.key)]] : [];
  })
);
var compileAgreementTemplate = ({
  content,
  variables,
  ruleContext,
  stage = "accept",
  placeholders = "none"
}) => {
  const extracted = extractAgreementTemplateVariables(content);
  const flat = agreementVariablesToTemplateContext(variables);
  const missing3 = resolveAgreementTemplateGaps(extracted.variables, variables, {
    stage
  });
  const placeholderByKey = placeholders === "preview" ? previewPlaceholders(missing3) : /* @__PURE__ */ new Map();
  for (const { key } of extracted.variables) {
    if (!(key in flat)) flat[key] = "";
  }
  placeholderByKey.forEach((token, key) => {
    flat[key] = token;
  });
  const context = nestContext(flat);
  const signersByKey = new Map(
    content.signers.map((signer) => [signer.key, signer])
  );
  const brokenBlocks = new Set(
    extracted.syntax_errors.map((error) => error.block_id)
  );
  const syntaxErrors = [...extracted.syntax_errors];
  const conditionGaps = [];
  const blocks = [];
  let printedClauses = 0;
  for (const block of content.blocks) {
    if (brokenBlocks.has(block.id)) continue;
    const verdict = evaluateBlockCondition(block, ruleContext);
    if (verdict) {
      if (verdict.gap) conditionGaps.push(verdict.gap);
      continue;
    }
    try {
      switch (block.kind) {
        case "title":
        case "paragraph": {
          const text2 = compileText(block.text, context);
          if (text2) blocks.push({ id: block.id, kind: block.kind, text: text2 });
          break;
        }
        case "clause": {
          const text2 = compileText(block.text, context);
          if (!text2) break;
          blocks.push({
            id: block.id,
            kind: "clause",
            ordinal: clauseOrdinal(printedClauses),
            title: block.title ? compileText(block.title, context) || null : null,
            text: text2
          });
          printedClauses += 1;
          break;
        }
        case "key_values": {
          const rows = block.items.flatMap((item) => {
            const value = variables[item.variable];
            const placeholder = placeholderByKey.get(item.variable);
            if ((value == null ? void 0 : value.status) === "resolved")
              return [{ label: item.label, value: value.formatted }];
            return placeholder ? [{ label: item.label, value: placeholder }] : [];
          });
          if (rows.length > 0)
            blocks.push({ id: block.id, kind: "key_values", rows });
          break;
        }
        case "signatures": {
          const slots = block.signers.flatMap((key) => {
            const signer = signersByKey.get(key);
            return signer ? [
              {
                key,
                label: signer.label,
                token: (0, import_piramid_constants69.agreementSignatureToken)(key),
                with_date: signer.with_date,
                with_name: signer.with_name
              }
            ] : [];
          });
          if (slots.length > 0)
            blocks.push({ id: block.id, kind: "signatures", slots });
          break;
        }
        case "page_break":
          blocks.push({ id: block.id, kind: "page_break" });
          break;
      }
    } catch (error) {
      syntaxErrors.push({
        block_id: block.id,
        message: failureMessage(error)
      });
    }
  }
  return {
    blocks,
    missing: missing3,
    syntax_errors: syntaxErrors,
    condition_gaps: conditionGaps
  };
};

// helpers/derive-agreement-facts.ts
var import_piramid_constants73 = __toESM(require_dist2());
var import_utils37 = __toESM(require_dist3());

// helpers/claimant-victim-identity.ts
var import_piramid_constants71 = __toESM(require_dist2());

// contracts/agreement-variables.contract.ts
var import_database41 = __toESM(require_index_browser4());
var import_piramid_constants70 = __toESM(require_dist2());
var import_utils36 = __toESM(require_dist3());
var import_zod91 = require("zod");
var import_database42 = __toESM(require_index_browser4());
var agreementVariableValueSchema = import_zod91.z.discriminatedUnion("status", [
  import_zod91.z.object({
    status: import_zod91.z.literal("resolved"),
    key: import_zod91.z.string(),
    type: import_zod91.z.enum(import_piramid_constants70.agreementVariableTypes),
    value: import_zod91.z.union([import_zod91.z.string(), import_zod91.z.number(), import_zod91.z.boolean(), import_zod91.z.array(import_zod91.z.string())]),
    formatted: import_zod91.z.string(),
    currency: import_zod91.z.nativeEnum(import_database41.CurrencySymbol).optional()
  }),
  import_zod91.z.object({
    status: import_zod91.z.literal("missing"),
    key: import_zod91.z.string(),
    type: import_zod91.z.enum(import_piramid_constants70.agreementVariableTypes),
    reason: import_zod91.z.enum(import_piramid_constants70.agreementMissingReasons)
  }),
  import_zod91.z.object({
    status: import_zod91.z.literal("not_applicable"),
    key: import_zod91.z.string(),
    type: import_zod91.z.enum(import_piramid_constants70.agreementVariableTypes),
    reason: import_zod91.z.enum(import_piramid_constants70.agreementNotApplicableReasons)
  })
]);
var agreementVariableValuesSchema = import_zod91.z.record(
  agreementVariableValueSchema
);
var perBindingConcept = (schema) => import_zod91.z.object({
  amount: schema,
  amount_in_words: schema,
  installments: schema,
  fee_percentage: schema,
  payment_days: schema,
  payment_method: schema,
  cbu: schema,
  cuit: schema,
  lawyer_cbu: schema,
  lawyer_cuit: schema,
  identification: schema
});
var agreementVariableBindingsSchema = perBindingConcept(
  import_zod91.z.array(import_zod91.z.string().min(1)).min(1)
).partial();
var agreementWarningSchema = import_zod91.z.object({
  code: import_zod91.z.enum(import_piramid_constants70.agreementWarningCodes),
  detail: import_zod91.z.record(import_zod91.z.unknown()).optional()
});
var claimantVictimMismatchDetailSchema = import_zod91.z.object({
  issues: import_zod91.z.array(
    import_zod91.z.object({
      field: import_zod91.z.enum(import_piramid_constants70.claimantVictimIdentityFields),
      issue: import_zod91.z.enum(import_piramid_constants70.claimantVictimIdentityIssues)
    })
  ).min(1)
});
var agreementBindingStatuses = [
  "resolved",
  "unbound",
  "ambiguous",
  "not_provided",
  "hidden",
  "acceptance_unknown",
  "invalid"
];
var agreementBindingResolutionSchema = import_zod91.z.object({
  status: import_zod91.z.enum(agreementBindingStatuses),
  matched_name: import_zod91.z.string().nullable(),
  source: import_zod91.z.enum(["default", "company"]),
  raw: import_zod91.z.string().nullable()
});
var agreementLawyerSchema = agreementClaimantSchema.extend({
  kind: import_zod91.z.enum(import_piramid_constants70.agreementLawyerKinds)
});
var agreementPrincipalClaimantRules = [
  "owner_email",
  "first_principal",
  "positional",
  "none"
];
var agreementLawyerRules = [
  "principal",
  "first_by_id",
  "none"
];
var agreementPartiesSchema = import_zod91.z.object({
  victim: agreementPersonSchema,
  claimant: agreementClaimantSchema.nullable(),
  lawyer: agreementLawyerSchema.nullable(),
  /** `tutor_curator` (menores) y `legal_representative` (personas jurídicas). */
  representatives: import_zod91.z.array(agreementClaimantSchema),
  /** `producer`, `workshopper`: gestionan, no representan legalmente. */
  intermediaries: import_zod91.z.array(agreementClaimantSchema),
  /** Sucesores: solo con daño `death`, de cualquier rol. */
  heirs: import_zod91.z.array(agreementClaimantSchema),
  victim_parents: import_zod91.z.array(agreementParentSchema),
  insured: agreementInsuredSchema.nullable(),
  owner_contact: import_zod91.z.object({ email: import_zod91.z.string() })
});
var sourcedValue = (value, sources) => import_zod91.z.object({ value: value.nullable(), source: import_zod91.z.enum(sources).nullable() });
var agreementDamagesFactSchema = import_zod91.z.object({
  material: agreementDamageSchema.nullable(),
  person: agreementDamageSchema.nullable(),
  recovery: agreementDamageSchema.nullable()
});
var agreementTermsSources = ["typed", "bindings", "none"];
var agreementAcceptanceSourceKinds = [
  "declared",
  "bindings",
  "none"
];
var agreementPaymentBreakdownSchema = import_zod91.z.object({
  amount: import_zod91.z.number(),
  fees: import_zod91.z.number().nullable(),
  total: import_zod91.z.number(),
  installments: import_zod91.z.number().nullable(),
  installmentAmount: import_zod91.z.number().nullable(),
  hasFees: import_zod91.z.boolean()
});
var agreementFactsSchema = import_zod91.z.object({
  parties: agreementPartiesSchema,
  victim_kind: import_zod91.z.enum(import_piramid_constants39.agreementPersonKinds),
  minority: import_zod91.z.enum(import_utils36.minorities),
  victim_is_deceased: import_zod91.z.boolean(),
  victim_has_parents: import_zod91.z.boolean(),
  claimant_is_victim: import_zod91.z.boolean(),
  claimant_relationship: import_zod91.z.nativeEnum(import_database41.VictimRelationshipTypes).nullable(),
  claimant_relationships: import_zod91.z.array(import_zod91.z.nativeEnum(import_database41.VictimRelationshipTypes)),
  claimants_count: import_zod91.z.number(),
  has_lawyer: import_zod91.z.boolean(),
  lawyer_kind: import_zod91.z.enum(import_piramid_constants70.agreementLawyerKinds).nullable(),
  lawyer_count: import_zod91.z.number(),
  heirs_count: import_zod91.z.number(),
  claim_classification: import_zod91.z.enum(import_piramid_constants70.claimTypes).nullable(),
  damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.DamageTypes)),
  person_damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.PersonDamageTypes)),
  material_damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.MaterialDamageTypes)),
  damages: agreementDamagesFactSchema,
  has_external_complaint: import_zod91.z.boolean(),
  external_complaint_source: import_zod91.z.enum(agreementExternalComplaintSources).nullable(),
  currency: import_zod91.z.nativeEnum(import_database41.CurrencySymbol),
  currency_source: import_zod91.z.enum(["offer_definition", "company_default", "fallback"]),
  amount: import_zod91.z.number().nullable(),
  terms_source: import_zod91.z.enum(agreementTermsSources),
  acceptance_source: import_zod91.z.enum(agreementAcceptanceSourceKinds),
  /**
   * Los conceptos que este ofrecimiento le pide al reclamante. Vacío en los
   * legacy, donde no hay declaración y todo se resuelve por bindings; lo usa
   * la vista previa para distinguir "lo completa el reclamante" de "no
   * corresponde".
   */
  requested_acceptance_concepts: import_zod91.z.array(import_zod91.z.enum(import_piramid_constants70.agreementBindingConcepts)),
  bindings: perBindingConcept(agreementBindingResolutionSchema),
  installments: import_zod91.z.number().nullable(),
  fee_percentage: import_zod91.z.number().nullable(),
  payment_days: import_zod91.z.number().nullable(),
  payment_method: import_zod91.z.string().nullable(),
  cbu: import_zod91.z.string().nullable(),
  cuit: import_zod91.z.string().nullable(),
  lawyer_cbu: import_zod91.z.string().nullable(),
  lawyer_cuit: import_zod91.z.string().nullable(),
  declared_identification: import_zod91.z.string().nullable(),
  amount_in_words_declared: import_zod91.z.string().nullable(),
  payment: agreementPaymentBreakdownSchema.nullable(),
  acceptance_known: import_zod91.z.boolean(),
  acceptance_complete: import_zod91.z.boolean(),
  policy_number: sourcedValue(import_zod91.z.string(), [
    "claim_external",
    "policyholder",
    "claim",
    "sinister"
  ]),
  license_plate: sourcedValue(import_zod91.z.string(), [
    "claim",
    "sinister",
    "policyholder"
  ]),
  sinister_date: sourcedValue(import_zod91.z.string().datetime({ offset: true }), [
    "occurrence",
    "sinister"
  ]),
  rules: import_zod91.z.object({
    claimant_rule: import_zod91.z.enum(agreementPrincipalClaimantRules),
    lawyer_rule: import_zod91.z.enum(agreementLawyerRules)
  }),
  warnings: import_zod91.z.array(agreementWarningSchema)
});
var agreementRuleContextSchema = import_zod91.z.object({
  company_id: import_zod91.z.string(),
  claim: import_zod91.z.object({
    id: import_zod91.z.string(),
    claim_type_id: import_zod91.z.string().nullable(),
    classification: import_zod91.z.enum(import_piramid_constants70.claimTypes).nullable(),
    damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.DamageTypes)),
    person_damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.PersonDamageTypes)),
    material_damage_types: import_zod91.z.array(import_zod91.z.nativeEnum(import_database42.MaterialDamageTypes)),
    victim_kind: import_zod91.z.enum(import_piramid_constants39.agreementPersonKinds),
    /** null = fecha de nacimiento desconocida (una regla que lo compare queda indeterminada). */
    victim_is_minor: import_zod91.z.boolean().nullable(),
    victim_is_deceased: import_zod91.z.boolean(),
    victim_has_parents: import_zod91.z.boolean(),
    claimants_count: import_zod91.z.number(),
    claimant_relationship: import_zod91.z.nativeEnum(import_database41.VictimRelationshipTypes).nullable(),
    claimant_relationships: import_zod91.z.array(import_zod91.z.nativeEnum(import_database41.VictimRelationshipTypes)),
    claimant_is_victim: import_zod91.z.boolean(),
    has_lawyer: import_zod91.z.boolean(),
    lawyer_kind: import_zod91.z.enum(import_piramid_constants70.agreementLawyerKinds).nullable(),
    lawyer_count: import_zod91.z.number(),
    heirs_count: import_zod91.z.number(),
    has_external_complaint: import_zod91.z.boolean(),
    team_id: import_zod91.z.string().nullable(),
    responsible_user_id: import_zod91.z.string().nullable()
  }),
  offer: import_zod91.z.object({
    /** false = el reclamo no tiene ofrecimiento: todo atributo `offer.*` es incognoscible. */
    known: import_zod91.z.boolean(),
    message_template_id: import_zod91.z.string().nullable(),
    amount: import_zod91.z.number().nullable(),
    currency: import_zod91.z.nativeEnum(import_database41.CurrencySymbol),
    installments: import_zod91.z.number().nullable(),
    fee_percentage: import_zod91.z.number().nullable(),
    payment_days: import_zod91.z.number().nullable(),
    has_installments: import_zod91.z.boolean(),
    has_fees: import_zod91.z.boolean(),
    /** Crudos, por nombre normalizado, para `eq`/`in`/`exists`. */
    variable: import_zod91.z.record(import_zod91.z.string().nullable())
  }),
  acceptance: import_zod91.z.object({
    known: import_zod91.z.boolean(),
    source: import_zod91.z.enum(agreementAcceptanceSources),
    complete: import_zod91.z.boolean(),
    payment_method: import_zod91.z.string().nullable(),
    has_lawyer_bank_data: import_zod91.z.boolean(),
    variable: import_zod91.z.record(import_zod91.z.string().nullable())
  })
});
var agreementResolutionMetaSchema = import_zod91.z.object({
  catalog_version: import_zod91.z.number(),
  format_version: import_zod91.z.number(),
  locale: import_zod91.z.string(),
  timezone: import_zod91.z.string(),
  currency: import_zod91.z.nativeEnum(import_database41.CurrencySymbol),
  currency_source: import_zod91.z.enum(["offer_definition", "company_default", "fallback"]),
  now: import_zod91.z.string().datetime({ offset: true }),
  age_reference_date: import_zod91.z.string().datetime({ offset: true }),
  /**
   * Lo que imprime `document.date`: la aceptación en un documento final, para
   * que reintentos y regeneraciones no muevan la fecha. Ausente = `now`.
   */
  document_date: import_zod91.z.string().datetime({ offset: true }).optional(),
  acceptance_source: import_zod91.z.enum(agreementAcceptanceSources),
  bindings_used: perBindingConcept(import_zod91.z.array(import_zod91.z.string()))
});
var agreementMissingEntrySchema = import_zod91.z.object({
  key: import_zod91.z.string(),
  reason: import_zod91.z.enum(import_piramid_constants70.agreementMissingReasons)
});
var agreementResolutionSchema = import_zod91.z.object({
  subject: agreementSubjectSchema,
  facts: agreementFactsSchema,
  context: agreementRuleContextSchema,
  variables: agreementVariableValuesSchema,
  missing: import_zod91.z.array(agreementMissingEntrySchema),
  warnings: import_zod91.z.array(agreementWarningSchema),
  trace: import_zod91.z.object({
    bindings: perBindingConcept(agreementBindingResolutionSchema),
    parties: import_zod91.z.object({
      claimant_rule: import_zod91.z.enum(agreementPrincipalClaimantRules),
      lawyer_rule: import_zod91.z.enum(agreementLawyerRules)
    })
  }),
  meta: agreementResolutionMetaSchema
});
var resolveAgreementVariablesRequestBody = import_zod91.z.object({
  claim_id: import_zod91.z.string().min(1),
  offer_id: import_zod91.z.string().min(1).nullable().optional(),
  acceptance: import_zod91.z.enum(["persisted", "none"]).default("persisted")
});

// helpers/claimant-victim-identity.ts
var normalizeIdentification = (value) => value ? value.replace(/\D/g, "") || null : null;
var identityNormalizers = {
  identification: (person) => normalizeIdentification(person.identification),
  email: (person) => normalizeEmail(person.email) || null
};
var compareField = (claimant, victim) => {
  if (!claimant && !victim) return "missing_on_both";
  if (!victim) return "missing_on_victim";
  if (!claimant) return "missing_on_claimant";
  return claimant === victim ? null : "mismatch";
};
var resolveClaimantVictimIdentityIssues = (claimant, victim) => import_piramid_constants71.claimantVictimIdentityFields.flatMap((field) => {
  const normalize = identityNormalizers[field];
  const issue = compareField(normalize(claimant), normalize(victim));
  return issue ? [{ field, issue }] : [];
});
var claimantVictimIdentityMessages = (warning) => {
  const parsed = claimantVictimMismatchDetailSchema.safeParse(warning.detail);
  if (warning.code !== "claimant_victim_mismatch" || !parsed.success) return [];
  const { issues } = parsed.data;
  const bothMismatch = issues.length === 2 && issues.every(({ issue }) => issue === "mismatch");
  return bothMismatch ? ["identification_and_email_mismatch"] : issues.map(({ field, issue }) => `${field}_${issue}`);
};

// helpers/derive-claim-type.ts
var deriveClaimType = (claim) => {
  var _a;
  const { damages, claimants } = claim;
  const hasMaterial = damages.some((damage2) => damage2.type === "material");
  const hasPersonInjury = damages.some(
    (damage2) => {
      var _a2;
      return damage2.type === "person" && ((_a2 = damage2.person) == null ? void 0 : _a2.type) === "injury";
    }
  );
  const hasPersonDeath = damages.some(
    (damage2) => {
      var _a2;
      return damage2.type === "person" && ((_a2 = damage2.person) == null ? void 0 : _a2.type) === "death";
    }
  );
  const hasRealProperty = damages.some(
    (damage2) => {
      var _a2;
      return damage2.type === "material" && ((_a2 = damage2.material) == null ? void 0 : _a2.type) === "real_property";
    }
  );
  const hasVehicleWithoutPlate = damages.some(
    (damage2) => {
      var _a2, _b;
      return damage2.type === "material" && ((_a2 = damage2.material) == null ? void 0 : _a2.type) === "vehicle" && ((_b = damage2.material.vehicle) == null ? void 0 : _b.category) === "without_license_plate";
    }
  );
  const hasVehicleWithPlate = damages.some(
    (damage2) => {
      var _a2, _b;
      return damage2.type === "material" && ((_a2 = damage2.material) == null ? void 0 : _a2.type) === "vehicle" && ((_b = damage2.material.vehicle) == null ? void 0 : _b.category) === "with_license_plate";
    }
  );
  const hasWorkerCompensationInsurerClaimant = claimants.some(
    (claimant) => {
      var _a2;
      return claimant.type === "legal_person" && ((_a2 = claimant.legal_person) == null ? void 0 : _a2.type) === "worker_compensation_insurer";
    }
  );
  const hasRecovery = damages.some((damage2) => damage2.type === "recovery");
  const orderedRules = [
    // Takes precedence: the origin damage would otherwise mask the recovery.
    { type: "recovery", matches: hasRecovery },
    {
      type: "claimant_worker_compensation_insurer",
      matches: hasWorkerCompensationInsurerClaimant
    },
    {
      type: "material_and_person_death",
      matches: hasMaterial && hasPersonDeath
    },
    {
      type: "material_and_person_injury",
      matches: hasMaterial && hasPersonInjury
    },
    { type: "person_death", matches: hasPersonDeath },
    { type: "person_injury", matches: hasPersonInjury },
    { type: "material_real_property", matches: hasRealProperty },
    {
      type: "material_vehicle_without_license_plate",
      matches: hasVehicleWithoutPlate
    },
    {
      type: "material_vehicle_with_license_plate",
      matches: hasVehicleWithPlate
    },
    { type: "material", matches: hasMaterial }
  ];
  return ((_a = orderedRules.find((rule) => rule.matches)) == null ? void 0 : _a.type) ?? null;
};

// helpers/match-claim-type-composition.ts
var matchesClaimTypeComposition = (damages, composition) => damages.filter((damage2) => damage2.type !== "recovery").every((damage2) => {
  var _a, _b, _c, _d, _e;
  const subType = ((_a = damage2.material) == null ? void 0 : _a.type) ?? ((_b = damage2.person) == null ? void 0 : _b.type) ?? null;
  const category = ((_d = (_c = damage2.material) == null ? void 0 : _c.vehicle) == null ? void 0 : _d.category) ?? null;
  const hasType = composition.some(
    (row) => row.damage_type === damage2.type
  );
  const hasSubType = composition.some(
    (row) => row.sub_damage_type === null || row.sub_damage_type === subType
  );
  const hasCategory = ((_e = damage2.material) == null ? void 0 : _e.type) !== "vehicle" || composition.some(
    (row) => row.entity_damaged_category === null || row.entity_damaged_category === category
  );
  return hasType && hasSubType && hasCategory;
});

// helpers/resolve-agreement-damages.ts
var resolveAgreementDamages = (subject) => {
  const ordered = [...subject.damages].sort(
    (left, right) => left.id.localeCompare(right.id)
  );
  const warnings = [];
  const firstOf = (type) => {
    const [selected, ...ignored] = ordered.filter(
      (damage2) => damage2.type === type
    );
    if (!selected) return null;
    if (ignored.length > 0) {
      warnings.push({
        code: "multiple_damages_of_same_type",
        detail: {
          type,
          selected_id: selected.id,
          ignored_ids: ignored.map((damage2) => damage2.id)
        }
      });
    }
    return selected;
  };
  return {
    damages: {
      material: firstOf("material"),
      person: firstOf("person"),
      recovery: firstOf("recovery")
    },
    warnings
  };
};

// helpers/resolve-agreement-parties.ts
var import_piramid_constants72 = __toESM(require_dist2());

// helpers/resolve-principal-claimant.ts
var sameEmail = (left, right) => !!left && !!right && left.trim().toLowerCase() === right.trim().toLowerCase();
var resolvePrincipalClaimant = (claimants, ownerEmail) => {
  const ordered = [...claimants].sort(
    (left, right) => left.id.localeCompare(right.id)
  );
  const principals = ordered.filter(
    (candidate) => candidate.role === "claimant"
  );
  const syncedWithOwner = principals.find(
    (candidate) => sameEmail(candidate.person.email, ownerEmail)
  );
  if (syncedWithOwner) {
    return {
      claimant: syncedWithOwner,
      rule: "owner_email",
      principal_rows: principals.length
    };
  }
  const [firstPrincipal] = principals;
  if (firstPrincipal) {
    return {
      claimant: firstPrincipal,
      rule: "first_principal",
      principal_rows: principals.length
    };
  }
  const [first] = ordered;
  return first ? { claimant: first, rule: "positional", principal_rows: 0 } : { claimant: null, rule: "none", principal_rows: 0 };
};

// helpers/resolve-agreement-parties.ts
var REPRESENTATIVE_RELATIONSHIPS = [
  "tutor_curator",
  "legal_representative"
];
var INTERMEDIARY_RELATIONSHIPS = [
  "producer",
  "workshopper"
];
var NON_SUCCESSOR_RELATIONSHIPS = [
  ...import_piramid_constants72.attorneyVictimRelationships,
  "workshopper",
  "legal_representative",
  "own",
  "particular_victim"
];
var hasDeathDamage2 = (subject) => subject.damages.some(
  (damage2) => {
    var _a;
    return damage2.type === "person" && ((_a = damage2.person) == null ? void 0 : _a.type) === "death";
  }
);
var isSuccessor = (claimant) => claimant.relationship === null ? claimant.role === "heir" : !NON_SUCCESSOR_RELATIONSHIPS.includes(claimant.relationship);
var resolveAgreementParties = (subject) => {
  var _a;
  const warnings = [];
  const claimants = subject.claimants;
  const principal = resolvePrincipalClaimant(claimants, subject.owner.email);
  if (principal.principal_rows > 1) {
    warnings.push({
      code: "multiple_principal_claimants",
      detail: { rows: principal.principal_rows }
    });
  }
  if (principal.rule === "positional") {
    warnings.push({ code: "principal_fallback_positional" });
  }
  const ownerMatchesAClaimant = claimants.some(
    (claimant) => {
      var _a2;
      return ((_a2 = claimant.person.email) == null ? void 0 : _a2.trim().toLowerCase()) === subject.owner.email.trim().toLowerCase();
    }
  );
  if (claimants.length > 0 && !ownerMatchesAClaimant) {
    warnings.push({ code: "owner_not_a_claimant" });
  }
  const lawyers = claimants.filter(
    (claimant) => (0, import_piramid_constants72.isAttorneyVictimRelationship)(claimant.relationship)
  );
  const principalIsLawyer = !!principal.claimant && (0, import_piramid_constants72.isAttorneyVictimRelationship)(principal.claimant.relationship);
  const lawyerClaimant = principalIsLawyer ? principal.claimant : lawyers[0] ?? null;
  const lawyer = lawyerClaimant ? {
    ...lawyerClaimant,
    kind: lawyerClaimant.relationship
  } : null;
  const lawyer_rule = lawyerClaimant ? principalIsLawyer ? "principal" : "first_by_id" : "none";
  if (lawyers.length > 1) {
    warnings.push({
      code: "multiple_lawyers",
      detail: { count: lawyers.length }
    });
  }
  const death = hasDeathDamage2(subject);
  const heirRows = claimants.filter((claimant) => claimant.role === "heir");
  const heirs = death ? claimants.filter(isSuccessor) : [];
  if (!death && heirRows.length > 0) {
    warnings.push({
      code: "heirs_without_death",
      detail: { count: heirRows.length }
    });
  }
  const victimParents = [
    subject.victim.parents.father,
    subject.victim.parents.mother
  ].flatMap((parent) => parent ? [parent] : []);
  return {
    parties: {
      victim: subject.victim,
      claimant: principal.claimant,
      lawyer,
      representatives: claimants.filter(
        (claimant) => claimant.relationship !== null && REPRESENTATIVE_RELATIONSHIPS.includes(claimant.relationship)
      ),
      intermediaries: claimants.filter(
        (claimant) => claimant.relationship !== null && INTERMEDIARY_RELATIONSHIPS.includes(claimant.relationship)
      ),
      heirs,
      victim_parents: victimParents,
      insured: ((_a = subject.external_complaint) == null ? void 0 : _a.policyholder) ?? null,
      owner_contact: { email: subject.owner.email }
    },
    lawyer_count: lawyers.length,
    rules: { claimant_rule: principal.rule, lawyer_rule },
    warnings
  };
};

// helpers/derive-agreement-facts.ts
var firstPresent = (candidates) => {
  const found = candidates.find(([, value]) => !!(value == null ? void 0 : value.trim()));
  return found ? { value: found[1].trim(), source: found[0] } : { value: null, source: null };
};
var unique = (values) => Array.from(new Set(values));
var sameCalendarDay = (left, right) => (0, import_utils37.formatDateInTimeZone)(left, "short", import_piramid_constants73.DEFAULT_TIMEZONE) === (0, import_utils37.formatDateInTimeZone)(right, "short", import_piramid_constants73.DEFAULT_TIMEZONE);
var toAmount = (value) => {
  if (value === null) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};
var deriveAgreementFacts = (subject, { now, bindings: override }) => {
  var _a, _b, _c, _d;
  const warnings = [];
  const partiesResolution = resolveAgreementParties(subject);
  warnings.push(...partiesResolution.warnings);
  const { parties } = partiesResolution;
  const damagesResolution = resolveAgreementDamages(subject);
  warnings.push(...damagesResolution.warnings);
  const { bindings, sources } = mergeAgreementBindings(
    import_piramid_constants73.defaultAgreementVariableBindings,
    override
  );
  const bound = resolveAgreementBindings({
    offer: subject.offer,
    acceptance: subject.acceptance,
    bindings,
    sources
  });
  warnings.push(...bound.warnings);
  const resolutions = { ...bound.resolutions };
  const rawOf = (concept) => resolutions[concept].status === "resolved" ? resolutions[concept].raw : null;
  const parseBound = (concept, parse3) => {
    const raw = rawOf(concept);
    const parsed = parse3(raw);
    if (raw !== null && parsed === null) {
      resolutions[concept] = {
        ...resolutions[concept],
        status: "invalid"
      };
    }
    return parsed;
  };
  const { victim } = subject;
  const victim_kind = victim.kind;
  const minority = victim_kind === "legal_person" ? "adult" : (0, import_utils37.resolveMinority)(victim.birth_date, now);
  const victim_is_deceased = hasDeathDamage2(subject);
  const victim_has_parents = parties.victim_parents.length > 0;
  if (victim_has_parents && minority === "adult" && victim_kind === "natural_person") {
    warnings.push({ code: "parents_without_minor" });
  }
  const { claimant } = parties;
  const claimant_relationship = (claimant == null ? void 0 : claimant.relationship) ?? null;
  const claimant_relationships = subject.claimants.flatMap(
    (entry) => entry.relationship ? [entry.relationship] : []
  );
  if (claimant && claimant.relationship === null) {
    warnings.push({ code: "relationship_null" });
  }
  if ((claimant == null ? void 0 : claimant.relationship) === "other" && ((_a = claimant.relationship_other) == null ? void 0 : _a.trim())) {
    warnings.push({
      code: "relationship_other_free_text",
      detail: { text: claimant.relationship_other.trim() }
    });
  }
  const claimantIdentification = normalizeIdentification(
    (claimant == null ? void 0 : claimant.person.identification) ?? null
  );
  const victimIdentification = normalizeIdentification(victim.identification);
  const sameIdentification2 = !!claimantIdentification && !!victimIdentification && claimantIdentification === victimIdentification;
  const claimant_is_victim = (claimant == null ? void 0 : claimant.relationship) === "own" || sameIdentification2;
  const identityIssues = (claimant == null ? void 0 : claimant.relationship) === "own" ? resolveClaimantVictimIdentityIssues(claimant.person, victim) : [];
  if (identityIssues.length > 0) {
    warnings.push({
      code: "claimant_victim_mismatch",
      detail: { issues: identityIssues }
    });
  }
  const amountResolution = resolutions.amount;
  const amountDefinition = amountResolution.matched_name ? subject.offer.definitions.find(
    (definition) => definition.determination === "compile_time" && definition.normalized_name === (0, import_utils37.normalizeVariableName)(amountResolution.matched_name)
  ) : void 0;
  const offerCurrency = (amountDefinition == null ? void 0 : amountDefinition.numeric_format_currency) ?? null;
  const companyCurrency = subject.company.default_currency;
  const currency = offerCurrency ?? companyCurrency ?? import_piramid_constants73.DEFAULT_CURRENCY;
  const currency_source = offerCurrency ? "offer_definition" : companyCurrency ? "company_default" : "fallback";
  if (offerCurrency && companyCurrency && offerCurrency !== companyCurrency) {
    warnings.push({
      code: "currency_differs_from_company_default",
      detail: { offer: offerCurrency, company: companyCurrency }
    });
  }
  const { terms } = subject.offer;
  const terms_source = terms ? "typed" : subject.offer.kind === "none" ? "none" : "bindings";
  const boundInstallments = parseBound(
    "installments",
    parseBoundPositiveInteger
  );
  const boundFeePercentage = parseBound(
    "fee_percentage",
    parseBoundPositiveNumber
  );
  const boundPaymentDays = parseBound(
    "payment_days",
    parseBoundPositiveInteger
  );
  const amount = terms ? terms.amount : toAmount(subject.offer.amount);
  const installments = terms ? terms.installments : boundInstallments;
  const fee_percentage = terms ? terms.fee_percentage : boundFeePercentage;
  const payment_days = terms ? terms.payment_days : boundPaymentDays;
  const declared = subject.offer.acceptance_requirements;
  const acceptance_source = declared ? "declared" : subject.offer.kind === "none" ? "none" : "bindings";
  const requested_acceptance_concepts = ((declared == null ? void 0 : declared.fields) ?? []).flatMap(
    (field) => {
      const { concept } = (0, import_piramid_constants73.offerAcceptanceField)(field.key);
      return concept ? [concept] : [];
    }
  );
  const payment_method = declared ? import_piramid_constants73.OFFER_PAYMENT_METHOD_LABELS[declared.payment_method] : ((_b = rawOf("payment_method")) == null ? void 0 : _b.trim()) || null;
  const cbu = parseBound("cbu", parseBoundDigits);
  const cuit = parseBound("cuit", parseBoundDigits);
  const lawyer_cbu = parseBound("lawyer_cbu", parseBoundDigits);
  const lawyer_cuit = parseBound("lawyer_cuit", parseBoundDigits);
  const declared_identification = parseBound(
    "identification",
    parseBoundDigits
  );
  const amount_in_words_declared = ((_c = rawOf("amount_in_words")) == null ? void 0 : _c.trim()) || null;
  warnings.push(
    ...bankPairWarnings({ cbu, cuit, who: "third_party" }),
    ...bankPairWarnings({ cbu: lawyer_cbu, cuit: lawyer_cuit, who: "lawyer" })
  );
  if (amount_in_words_declared && amount !== null && (0, import_utils37.isSpellableCurrency)(currency)) {
    const computed = (0, import_utils37.numberToSpanishWords)(amount, currency);
    if (computed && (0, import_utils37.normalizeVariableName)(computed) !== (0, import_utils37.normalizeVariableName)(amount_in_words_declared)) {
      warnings.push({ code: "amount_in_words_mismatch" });
    }
  }
  const payment = amount !== null ? computeOfferPaymentBreakdown({
    amount,
    installments,
    feePercentage: fee_percentage
  }) : null;
  const acceptance_known = subject.acceptance.source !== "none";
  const visibleRequiredRuntime = subject.offer.definitions.filter(
    (definition) => definition.determination === "runtime" && definition.required === true && !subject.acceptance.hidden_guids.includes(definition.guid)
  );
  const acceptance_complete = acceptance_known && visibleRequiredRuntime.every(
    (definition) => {
      var _a2;
      return definition.type === "file" ? !!subject.offer.files[definition.guid] : !!((_a2 = subject.offer.values.runtime[definition.guid]) == null ? void 0 : _a2.trim());
    }
  );
  if (subject.offer.kind === "persisted" && subject.offer.definitions.length === 0) {
    warnings.push({ code: "definitions_not_snapshotted" });
  }
  const externalComplaint = subject.external_complaint;
  const policyholder = (externalComplaint == null ? void 0 : externalComplaint.policyholder) ?? null;
  const complaintCandidates = subject.sinister.external_complaint_candidates;
  if ((externalComplaint == null ? void 0 : externalComplaint.source) === "sinister") {
    warnings.push({
      code: "external_complaint_inferred",
      detail: { candidates: complaintCandidates }
    });
  }
  if (!externalComplaint && complaintCandidates > 0) {
    warnings.push({
      code: "external_complaint_unmatched",
      detail: { candidates: complaintCandidates }
    });
  }
  const policy_number = firstPresent([
    ["claim_external", subject.claim.external_policyholder_number],
    ["policyholder", policyholder == null ? void 0 : policyholder.policy_number],
    ["claim", subject.claim.policyholder_policy_number],
    ["sinister", subject.sinister.policyholder_policy_number]
  ]);
  const license_plate = firstPresent([
    ["claim", subject.claim.policyholder_license_plate],
    ["sinister", subject.sinister.policyholder_license_plate],
    ["policyholder", policyholder == null ? void 0 : policyholder.license_plate]
  ]);
  const sinister_date = firstPresent([
    ["occurrence", subject.occurrence.sinister_date],
    ["sinister", subject.sinister.date]
  ]);
  if (subject.occurrence.sinister_date && subject.sinister.date && !sameCalendarDay(subject.occurrence.sinister_date, subject.sinister.date)) {
    warnings.push({ code: "sinister_date_mismatch" });
  }
  const damage_types = unique(
    subject.damages.map((damage2) => damage2.type)
  );
  const person_damage_types = unique(
    subject.damages.flatMap(
      (damage2) => damage2.person ? [damage2.person.type] : []
    )
  );
  const material_damage_types = unique(
    subject.damages.flatMap(
      (damage2) => damage2.material ? [damage2.material.type] : []
    )
  );
  const { claim_type } = subject.claim;
  if (claim_type && !matchesClaimTypeComposition(subject.damages, claim_type.damages)) {
    warnings.push({
      code: "claim_type_damages_mismatch",
      detail: { claim_type_id: claim_type.id }
    });
  }
  const claim_classification = deriveClaimType({
    damages: subject.damages.map((damage2) => ({
      type: damage2.type,
      material: damage2.material ? {
        type: damage2.material.type,
        vehicle: damage2.material.vehicle ? { category: damage2.material.vehicle.category } : null
      } : null,
      person: damage2.person ? { type: damage2.person.type } : null
    })),
    claimants: subject.claimants.map((entry) => ({
      type: entry.person.kind,
      legal_person: entry.person.kind === "legal_person" ? { type: entry.person.legal_person_type } : null
    }))
  });
  return {
    parties,
    victim_kind,
    minority,
    victim_is_deceased,
    victim_has_parents,
    claimant_is_victim,
    claimant_relationship,
    claimant_relationships,
    claimants_count: subject.claimants.length,
    has_lawyer: parties.lawyer !== null,
    lawyer_kind: ((_d = parties.lawyer) == null ? void 0 : _d.kind) ?? null,
    lawyer_count: partiesResolution.lawyer_count,
    heirs_count: parties.heirs.length,
    claim_classification,
    damage_types,
    person_damage_types,
    material_damage_types,
    damages: damagesResolution.damages,
    has_external_complaint: externalComplaint !== null,
    external_complaint_source: (externalComplaint == null ? void 0 : externalComplaint.source) ?? null,
    currency,
    currency_source,
    amount,
    terms_source,
    acceptance_source,
    requested_acceptance_concepts,
    bindings: resolutions,
    installments,
    fee_percentage,
    payment_days,
    payment_method,
    cbu,
    cuit,
    lawyer_cbu,
    lawyer_cuit,
    declared_identification,
    amount_in_words_declared,
    payment,
    acceptance_known,
    acceptance_complete,
    policy_number,
    license_plate,
    sinister_date,
    rules: partiesResolution.rules,
    warnings
  };
};

// helpers/agreement-template.fixture.ts
var agreementSampleTemplate = {
  layout_variant: "default",
  signers: [
    {
      key: "claimant",
      label: "Firma del reclamante",
      party: "claimant",
      optional: false,
      with_date: true,
      with_name: true
    }
  ],
  blocks: [
    { id: "title", kind: "title", text: "CONFORMIDAD DE PAGO" },
    {
      id: "intro",
      kind: "paragraph",
      text: 'En la ciudad de {{sinister.city}}, a los {{document.date}}, entre {{company.name}}, CUIT {{company.tax_id}}, en adelante "la Compa\xF1\xEDa", y {{claimant.full_name}}, {{claimant.identification_type}} {{claimant.identification}}, con domicilio en {{claimant.address}}, {{claimant.city}}, en adelante "el Reclamante", se conviene lo siguiente:'
    },
    {
      id: "objeto",
      kind: "clause",
      title: "Objeto",
      text: "La presente conformidad se otorga con motivo del siniestro N\xB0 {{sinister.number}} ocurrido el {{sinister.date}} en {{sinister.address}}, {{sinister.city}}, en el que intervino el veh\xEDculo dominio {{insured_vehicle.license_plate}} asegurado en la Compa\xF1\xEDa bajo la p\xF3liza {{insured.policy_number}}. Sin que ello signifique reconocimiento de hechos, derecho ni responsabilidad alguna por parte de la Compa\xF1\xEDa ni de su asegurado, y dejando a salvo los derechos de los mismos, las partes acuerdan la indemnizaci\xF3n que se detalla[[#if {{claim.damages.material.summary}}]] por los da\xF1os materiales ocasionados al {{claim.damages.material.summary}}[[/if]][[#if {{claim.damages.person.injuries}}]] y por las lesiones sufridas por {{victim.full_name}} ({{claim.damages.person.injuries}})[[/if]]."
    },
    {
      id: "importe",
      kind: "clause",
      title: "Indemnizaci\xF3n",
      text: "La Compa\xF1\xEDa abonar\xE1 al Reclamante la suma \xFAnica, total y definitiva de {{offer.amount}} ({{offer.amount_in_words}})[[#if {{offer.installments}}]], pagadera en {{offer.installments}} cuotas iguales y consecutivas de {{payment.installment_amount}} cada una[[/if]][[#if {{offer.payment_days}}]], siendo el pago a los {{offer.payment_days}} d\xEDas de firmada la presente[[/if]]."
    },
    {
      id: "honorarios",
      kind: "clause",
      title: "Honorarios",
      text: "[[#if {{lawyer.full_name}}]]Se conviene adem\xE1s el pago de los honorarios profesionales del letrado interviniente, {{lawyer.full_name}}, CUIT {{lawyer.cuit}}, equivalentes al {{offer.fee_percentage}} de la indemnizaci\xF3n, es decir {{payment.fees_amount}}.[[/if]]"
    },
    {
      id: "pago",
      kind: "clause",
      title: "Forma de pago",
      text: "El pago se efectuar\xE1 mediante {{acceptance.payment_method}}[[#if {{acceptance.cbu}}]] a la cuenta bancaria CBU {{acceptance.cbu}}, CUIT/CUIL {{acceptance.cuit}}[[/if]][[#if {{acceptance.lawyer_cbu}}]], y los honorarios a la cuenta CBU {{acceptance.lawyer_cbu}}, CUIT {{acceptance.lawyer_cuit}}[[/if]]."
    },
    {
      id: "renuncia",
      kind: "clause",
      title: "Renuncia",
      text: "Percibida la suma indicada, el Reclamante declara que nada m\xE1s tendr\xE1 que reclamar a la Compa\xF1\xEDa, a su asegurado ni al conductor del veh\xEDculo por ning\xFAn concepto derivado del siniestro, otorgando carta de pago total y definitiva y renunciando a toda acci\xF3n presente o futura."
    },
    { id: "salto", kind: "page_break" },
    {
      id: "cierre",
      kind: "paragraph",
      text: "En prueba de conformidad se firman dos ejemplares de un mismo tenor y a un solo efecto, en {{sinister.city}}, el {{document.date}}."
    },
    {
      id: "firmas",
      kind: "signatures",
      signers: ["claimant"]
    }
  ]
};
var buildAgreementSampleVariables = () => {
  const subject = agreementScenarios.directTransfer();
  const facts = deriveAgreementFacts(subject, { now: AGREEMENT_FIXTURE_NOW });
  return buildAgreementVariableValues(subject, facts, {
    locale: import_piramid_constants74.DEFAULT_LOCALE,
    timezone: import_piramid_constants74.DEFAULT_TIMEZONE,
    now: AGREEMENT_FIXTURE_NOW.toISOString()
  }).variables;
};
var buildAgreementSampleRuleContext = () => {
  const subject = agreementScenarios.directTransfer();
  return buildAgreementRuleContext(
    subject,
    deriveAgreementFacts(subject, { now: AGREEMENT_FIXTURE_NOW })
  );
};
var buildAgreementDocumentSample = () => {
  const compiled = compileAgreementTemplate({
    content: agreementSampleTemplate,
    variables: buildAgreementSampleVariables(),
    ruleContext: buildAgreementSampleRuleContext()
  });
  return {
    meta: {
      branding: {
        company_name: "Aseguradora Demo",
        tax_id: "30-71234567-8",
        logo_data_uri: null
      },
      title: (0, import_i11n3.translate)("document.agreement.name"),
      reference: "RIV-1913",
      generated_at: AGREEMENT_FIXTURE_NOW.toISOString(),
      country_code: "ARG",
      variant: "default"
    },
    document: {
      id: "agreementdoc_01",
      kind: "sample",
      template_name: "Conformidad directo por transferencia en un pago",
      version: 1,
      claim_ref_id: "RIV-1913"
    },
    blocks: compiled.blocks,
    signers: agreementSampleTemplate.signers,
    watermark: (0, import_i11n3.translate)("document.agreement.watermark.sample")
  };
};

// contracts/agreement-template.contract.ts
var import_piramid_constants76 = __toESM(require_dist2());
var import_zod93 = require("zod");

// contracts/agreement-condition.contract.ts
var import_piramid_constants75 = __toESM(require_dist2());
var import_zod92 = require("zod");
var agreementRuleAttributeKeySchema = import_zod92.z.string().refine(import_piramid_constants75.isAgreementRuleAttributeKey, { message: "unknown_attribute" });
var agreementRuleValueSchema = import_zod92.z.union([
  import_zod92.z.string(),
  import_zod92.z.number(),
  import_zod92.z.boolean(),
  import_zod92.z.array(import_zod92.z.string())
]);
var matchesShape = (value, shape) => {
  switch (shape) {
    case "list":
      return Array.isArray(value) && value.length > 0;
    case "boolean":
      return typeof value === "boolean";
    case "number":
      return typeof value === "number";
    default:
      return typeof value === "string" && value.length > 0;
  }
};
var allowedValues = (attribute) => {
  const { options } = (0, import_piramid_constants75.agreementRuleAttribute)(attribute);
  return (options == null ? void 0 : options.kind) === "enum" ? options.values : null;
};
var agreementRuleConditionSchema = import_zod92.z.object({
  attribute: agreementRuleAttributeKeySchema,
  /** Solo en los atributos `variable`: el nombre de la variable del ofrecimiento. */
  name: import_zod92.z.string().min(1).nullable().default(null),
  operator: import_zod92.z.enum(import_piramid_constants75.agreementRuleOperators),
  value: agreementRuleValueSchema
}).superRefine((condition, ctx) => {
  if (!(0, import_piramid_constants75.isAgreementRuleAttributeKey)(condition.attribute)) return;
  const definition = (0, import_piramid_constants75.agreementRuleAttribute)(condition.attribute);
  const issue = (message, path) => ctx.addIssue({ code: import_zod92.z.ZodIssueCode.custom, message, path: [path] });
  if (!(0, import_piramid_constants75.agreementRuleOperatorsFor)(definition.type).includes(condition.operator))
    return issue("operator_not_allowed_for_attribute", "operator");
  if (!matchesShape(
    condition.value,
    (0, import_piramid_constants75.agreementRuleValueShapeFor)(definition.type, condition.operator)
  ))
    return issue("invalid_value_for_operator", "value");
  if (definition.type === "variable" !== (condition.name !== null))
    return issue("variable_attribute_requires_name", "name");
  const allowed = allowedValues(condition.attribute);
  if (!allowed) return;
  const used = Array.isArray(condition.value) ? condition.value : [condition.value];
  const unknown = used.filter(
    (entry) => typeof entry === "string" && !allowed.includes(entry)
  );
  if (unknown.length > 0) issue("value_not_in_attribute_options", "value");
});
var agreementRuleConditionsSchema = import_zod92.z.object({
  all: import_zod92.z.array(agreementRuleConditionSchema).max(import_piramid_constants75.AGREEMENT_RULE_MAX_CONDITIONS)
});
var agreementRuleConditionsSchemaFor = (groups) => agreementRuleConditionsSchema.superRefine((conditions, ctx) => {
  conditions.all.forEach((condition, index) => {
    if ((0, import_piramid_constants75.isAgreementRuleAttributeKey)(condition.attribute) && !groups.includes((0, import_piramid_constants75.agreementRuleAttribute)(condition.attribute).group))
      ctx.addIssue({
        code: import_zod92.z.ZodIssueCode.custom,
        message: "attribute_not_allowed_for_rule",
        path: ["all", index, "attribute"]
      });
  });
});

// contracts/agreement-template.contract.ts
var agreementSignerKeySchema = import_zod93.z.string().regex(/^[a-z][a-z0-9_]*$/, "invalid_signer_key");
var agreementSignerSchema = import_zod93.z.object({
  key: agreementSignerKeySchema,
  label: import_zod93.z.string().min(1),
  party: import_zod93.z.enum(import_piramid_constants76.agreementSignerParties),
  optional: import_zod93.z.boolean(),
  with_date: import_zod93.z.boolean(),
  with_name: import_zod93.z.boolean()
});
var blockBase = {
  id: import_zod93.z.string().min(1),
  condition: agreementRuleConditionsSchema.nullable().optional()
};
var agreementBlockSchema = import_zod93.z.discriminatedUnion("kind", [
  import_zod93.z.object({ ...blockBase, kind: import_zod93.z.literal("title"), text: import_zod93.z.string().min(1) }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("paragraph"),
    text: import_zod93.z.string().min(1)
  }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("clause"),
    title: import_zod93.z.string().nullable(),
    text: import_zod93.z.string().min(1)
  }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("key_values"),
    items: import_zod93.z.array(
      import_zod93.z.object({ label: import_zod93.z.string().min(1), variable: import_zod93.z.string().min(1) })
    ).min(1)
  }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("signatures"),
    signers: import_zod93.z.array(import_zod93.z.string().min(1)).min(1)
  }),
  import_zod93.z.object({ ...blockBase, kind: import_zod93.z.literal("page_break") })
]);
var hasUniqueValues = (values) => new Set(values).size === values.length;
var agreementTemplateContentSchema = import_zod93.z.object({
  blocks: import_zod93.z.array(agreementBlockSchema).min(1),
  signers: import_zod93.z.array(agreementSignerSchema),
  layout_variant: import_zod93.z.enum(import_piramid_constants76.documentVariants).default("default")
}).refine(
  (content) => hasUniqueValues(content.blocks.map((block) => block.id)),
  { message: "duplicate_block_id", path: ["blocks"] }
).refine(
  (content) => hasUniqueValues(content.signers.map((signer) => signer.key)),
  { message: "duplicate_signer_key", path: ["signers"] }
);
var agreementTemplateVariableSchema = import_zod93.z.object({
  key: import_zod93.z.string(),
  /** Referenciada sin un `[[#if]]` de la misma clave: sin valor, el documento queda con un hueco. */
  required: import_zod93.z.boolean()
});
var compiledAgreementSignatureSlotSchema = import_zod93.z.object({
  key: import_zod93.z.string(),
  label: import_zod93.z.string(),
  token: import_zod93.z.string(),
  with_date: import_zod93.z.boolean(),
  with_name: import_zod93.z.boolean()
});
var compiledAgreementBlockSchema = import_zod93.z.discriminatedUnion("kind", [
  import_zod93.z.object({ ...blockBase, kind: import_zod93.z.literal("title"), text: import_zod93.z.string() }),
  import_zod93.z.object({ ...blockBase, kind: import_zod93.z.literal("paragraph"), text: import_zod93.z.string() }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("clause"),
    ordinal: import_zod93.z.string(),
    title: import_zod93.z.string().nullable(),
    text: import_zod93.z.string()
  }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("key_values"),
    rows: import_zod93.z.array(import_zod93.z.object({ label: import_zod93.z.string(), value: import_zod93.z.string() }))
  }),
  import_zod93.z.object({
    ...blockBase,
    kind: import_zod93.z.literal("signatures"),
    slots: import_zod93.z.array(compiledAgreementSignatureSlotSchema)
  }),
  import_zod93.z.object({ ...blockBase, kind: import_zod93.z.literal("page_break") })
]);
var agreementTemplateMissingStatuses = [
  "missing",
  "not_applicable",
  "unknown_key"
];
var agreementTemplateMissingSchema = import_zod93.z.object({
  key: import_zod93.z.string(),
  required: import_zod93.z.boolean(),
  status: import_zod93.z.enum(agreementTemplateMissingStatuses),
  /** Qué significa el hueco en la etapa en que se compiló (ver `agreementGapClasses`). */
  class: import_zod93.z.enum(import_piramid_constants76.agreementGapClasses),
  reason: import_zod93.z.union([
    import_zod93.z.enum(import_piramid_constants76.agreementMissingReasons),
    import_zod93.z.enum(import_piramid_constants76.agreementNotApplicableReasons)
  ]).nullable(),
  blocking: import_zod93.z.boolean()
});
var agreementTemplateSyntaxErrorSchema = import_zod93.z.object({
  block_id: import_zod93.z.string(),
  message: import_zod93.z.string()
});
var agreementTemplateConditionGapSchema = import_zod93.z.object({
  block_id: import_zod93.z.string(),
  attribute: import_zod93.z.string(),
  reason: import_zod93.z.string()
});
var agreementDocumentAnchorSchema = import_zod93.z.object({
  /** 0-based, como `page` en AutoSign. */
  page_index: import_zod93.z.number().int().min(0),
  /** Porcentajes de la página, origen arriba-izquierda. */
  x: import_zod93.z.number(),
  y: import_zod93.z.number(),
  width: import_zod93.z.number(),
  height: import_zod93.z.number()
});
var agreementDocumentAnchorsSchema = import_zod93.z.record(
  agreementDocumentAnchorSchema
);
var createAgreementTemplateRequestBody = import_zod93.z.object({
  name: import_zod93.z.string().trim().min(1).max(120),
  kind: import_zod93.z.enum(import_piramid_constants76.agreementTemplateKinds).default("agreement"),
  description: import_zod93.z.string().trim().max(500).nullable().optional(),
  /** Arranca con el texto provisorio de `agreementSampleTemplate` en vez de vacío. */
  from_example: import_zod93.z.boolean().default(false)
});
var duplicateAgreementTemplateRequestBody = import_zod93.z.object({
  name: import_zod93.z.string().trim().min(1).max(120).optional(),
  description: import_zod93.z.string().trim().max(500).nullable().optional(),
  /** Por defecto la editable: el borrador, si no la publicada, si no la última. */
  source_version_id: import_zod93.z.string().min(1).optional()
});
var updateAgreementTemplateRequestBody = import_zod93.z.object({
  name: import_zod93.z.string().trim().min(1).max(120),
  description: import_zod93.z.string().trim().max(500).nullable().optional()
});
var saveAgreementTemplateVersionRequestBody = agreementTemplateContentSchema;
var agreementTemplateRequestParams = import_zod93.z.object({
  templateId: import_zod93.z.string().min(1)
});
var agreementTemplateVersionRequestParams = agreementTemplateRequestParams.extend({ versionId: import_zod93.z.string().min(1) });
var retrieveAgreementTemplateRequestQuery = import_zod93.z.object({
  version_id: import_zod93.z.string().min(1).optional()
});
var listAgreementTemplatesRequestQuery = import_zod93.z.object({
  kind: import_zod93.z.enum(import_piramid_constants76.agreementTemplateKinds).optional()
});
var renderAgreementSampleRequestBody = resolveAgreementVariablesRequestBody;
var listCompanyAgreementTemplatesRequestQuery = paginateRequestQuery;

// contracts/insured-party.contract.ts
var import_zod94 = require("zod");
var insuredPartySchema = import_zod94.z.object({
  name: import_zod94.z.string().nullable(),
  /** National id for a natural person, tax id for a legal one. */
  identification: import_zod94.z.string().nullable(),
  /** `LegalPerson` has no phone. */
  phone: import_zod94.z.string().nullable(),
  email: import_zod94.z.string().nullable(),
  /** Street, number, city and zip code, with whatever exists. */
  address: import_zod94.z.string().nullable()
});

// contracts/document-render.contract.ts
var documentBrandingSchema = import_zod95.z.object({
  company_name: import_zod95.z.string(),
  /** CUIT del emisor (`Company.ein`), debajo del nombre en la cabecera. */
  tax_id: import_zod95.z.string().nullable(),
  /**
   * Data URI, no URL. El renderer corre en una Lambda dentro de la VPC y una
   * `<img>` que no resuelve es una carrera silenciosa que produce PDFs sin logo.
   */
  logo_data_uri: import_zod95.z.string().nullable()
});
var documentMetaSchema = import_zod95.z.object({
  branding: documentBrandingSchema,
  title: import_zod95.z.string(),
  reference: import_zod95.z.string(),
  generated_at: import_zod95.z.string().datetime(),
  /** ISO-3, como el resto del repo (`DEFAULT_COUNTRY_CODE === 'ARG'`). */
  country_code: import_zod95.z.string(),
  /**
   * Layout a usar. Lo decide el backend; el frontend nunca lo manda. Un valor
   * sin componente registrado cae a `default` en `packages/documents`.
   */
  variant: import_zod95.z.enum(import_piramid_constants77.documentVariants)
});
var documentAmountLineSchema = import_zod95.z.object({
  description: import_zod95.z.string(),
  quantity: import_zod95.z.number(),
  unit_amount: import_zod95.z.string(),
  total_amount: import_zod95.z.string()
});
var documentDefinitionSchema = import_zod95.z.object({
  label: import_zod95.z.string(),
  value: import_zod95.z.string()
});
var sampleDocumentParamsSchema = import_zod95.z.object({
  reference: import_zod95.z.string().min(1).max(60)
});
var sampleDocumentPayloadSchema = import_zod95.z.object({
  meta: documentMetaSchema,
  summary: import_zod95.z.array(documentDefinitionSchema),
  items: import_zod95.z.array(documentAmountLineSchema),
  total_amount: import_zod95.z.string(),
  notes: import_zod95.z.string().nullable()
});
var orderReportParamsSchema = import_zod95.z.object({
  order_id: import_zod95.z.string().min(1)
});
var orderReportInsuredSchema = insuredPartySchema;
var orderReportVehicleSchema = import_zod95.z.object({
  make: import_zod95.z.string().nullable(),
  model: import_zod95.z.string().nullable(),
  version: import_zod95.z.string().nullable(),
  year: import_zod95.z.number().nullable(),
  license_plate: import_zod95.z.string().nullable()
});
var orderReportItemSchema = import_zod95.z.object({
  /** Frozen snapshot: "SKU - Name (Brand)" for catalog lines, free text if manual. */
  description: import_zod95.z.string(),
  quantity: import_zod95.z.number(),
  unit_price: import_zod95.z.string(),
  subtotal: import_zod95.z.string()
});
var orderReportSummarySchema = import_zod95.z.object({
  total_amount: import_zod95.z.string().nullable(),
  /** `null` se imprime como "sin límite", no como cero. */
  coverage_amount: import_zod95.z.string().nullable(),
  amount_to_charge: import_zod95.z.string().nullable(),
  // Optional for the same reason as `work_proof`: app deploys do not watch
  // `packages/bff/**`, so a missing field degrades instead of breaking the parse.
  taxes_percent: import_zod95.z.string().nullable().optional(),
  taxes_amount: import_zod95.z.string().nullable().optional(),
  total_with_taxes: import_zod95.z.string().nullable().optional(),
  /** ISO-4217 (`CurrencySymbol`), no se deriva del país. */
  currency: import_zod95.z.string()
});
var orderReportWorkProofSchema = import_zod95.z.object({
  mechanism: orderWorkProofMechanism,
  /** `null` when there is no capturable active inspection. */
  capture_link: import_zod95.z.string().nullable(),
  /** Status of the active one; `null` when none exists yet. */
  status: import_zod95.z.enum(ORDER_WORK_PROOF_DISPLAY_STATUSES).nullable()
});
var orderReportPayloadSchema = import_zod95.z.object({
  meta: documentMetaSchema,
  order: import_zod95.z.object({
    ref_id: import_zod95.z.string(),
    /**
     * Claim number in the origin system. Claim branch only, and only when the
     * intake captured it: complaint orders go without one.
     */
    external_claim_id: import_zod95.z.string().nullable(),
    created_at: import_zod95.z.string().datetime(),
    description: import_zod95.z.string().nullable(),
    service_name: import_zod95.z.string(),
    good_name: import_zod95.z.string(),
    locality_name: import_zod95.z.string()
  }),
  parties: import_zod95.z.object({
    /** Cliente del tenant si existe (Gamma → AMCA); si no, el tenant. */
    insurer_name: import_zod95.z.string(),
    provider_name: import_zod95.z.string(),
    insured: orderReportInsuredSchema
  }),
  vehicle: orderReportVehicleSchema.nullable(),
  items: import_zod95.z.array(orderReportItemSchema),
  summary: orderReportSummarySchema,
  // Optional on purpose: app deploy workflows do not watch `packages/bff/**`,
  // so a missing field degrades to "no work proof" instead of a broken parse.
  work_proof: orderReportWorkProofSchema.optional()
});
var agreementDocumentParamsSchema = import_zod95.z.object({
  document_id: import_zod95.z.string().min(1)
});
var agreementDocumentPayloadSchema = import_zod95.z.object({
  meta: documentMetaSchema,
  document: import_zod95.z.object({
    id: import_zod95.z.string(),
    kind: import_zod95.z.nativeEnum(import_database43.AgreementDocumentKind),
    template_name: import_zod95.z.string(),
    version: import_zod95.z.number().int(),
    claim_ref_id: import_zod95.z.string().nullable()
  }),
  blocks: import_zod95.z.array(compiledAgreementBlockSchema),
  signers: import_zod95.z.array(agreementSignerSchema),
  watermark: import_zod95.z.string().nullable()
});
var defineDocumentContract = (contract) => contract;
var documentContracts = {
  sample: defineDocumentContract({
    app: "insurer",
    params: sampleDocumentParamsSchema,
    payload: sampleDocumentPayloadSchema,
    sample: {
      meta: {
        branding: {
          company_name: "Aseguradora Demo",
          tax_id: "30-71234567-8",
          logo_data_uri: null
        },
        title: "Documento de ejemplo",
        reference: "DOC-000123",
        generated_at: "2026-07-31T12:00:00.000Z",
        country_code: "ARG",
        variant: "default"
      },
      summary: [
        { label: "Referencia", value: "DOC-000123" },
        { label: "Emitido por", value: "Aseguradora Demo" },
        { label: "Estado", value: "Vigente" }
      ],
      items: [
        {
          description: "Reemplazo de paragolpes delantero",
          quantity: 1,
          unit_amount: "180000.00",
          total_amount: "180000.00"
        },
        {
          description: "Mano de obra",
          quantity: 4,
          unit_amount: "15000.00",
          total_amount: "60000.00"
        }
      ],
      total_amount: "240000.00",
      notes: "Este documento es un ejemplo de referencia. No representa una operaci\xF3n real."
    }
  }),
  order_report: defineDocumentContract({
    app: "insurer",
    params: orderReportParamsSchema,
    payload: orderReportPayloadSchema,
    // Reproduce el caso real de `docs/gamma-pdf.pdf`: cobertura sin límite
    // (null) y dos ítems de catálogo.
    sample: {
      meta: {
        branding: {
          company_name: "Gamma Distribuidora",
          tax_id: "30-71234567-8",
          logo_data_uri: null
        },
        title: "Orden de trabajo",
        reference: "ORD-1234",
        generated_at: "2026-07-31T12:00:00.000Z",
        country_code: "ARG",
        variant: "default"
      },
      order: {
        ref_id: "ORD-1234",
        external_claim_id: "320832",
        created_at: "2026-07-30T09:15:00.000Z",
        description: "CHEVROLET SPIN 1.8 LTZ 5AS ACTIV 2017 - PARABRISAS + PDI",
        service_name: "Colocaci\xF3n",
        good_name: "Cristales",
        locality_name: "Flores"
      },
      parties: {
        insurer_name: "AMCA",
        provider_name: "CRISTAL BUS S.A.",
        insured: {
          name: "MENDEZ ROJAS SONILDA",
          identification: "41900392",
          phone: "1166202209",
          email: "wilfredogutierrez861@gmail.com",
          address: "AV. RIVADAVIA 7200, FLORES, 1406"
        }
      },
      vehicle: {
        make: "CHEVROLET",
        model: "SPIN",
        version: "1.8 LTZ 5AS ACTIV",
        year: 2017,
        license_plate: "AC057ZV"
      },
      items: [
        {
          description: "081330VSLP PSAS CHEVROLET SPIN",
          quantity: 1,
          unit_price: "479771.93",
          subtotal: "479771.93"
        },
        {
          description: "081313VNTP P.D.I. CHEVROLET SPIN",
          quantity: 1,
          unit_price: "103362.38",
          subtotal: "103362.38"
        }
      ],
      summary: {
        total_amount: "583134.31",
        coverage_amount: null,
        // With no coverage cap, the claimant carries the whole amount.
        amount_to_charge: "583134.31",
        // No trailing zeros, as `Decimal.toString()` emits it.
        taxes_percent: "21",
        taxes_amount: "122458.21",
        total_with_taxes: "705592.52",
        currency: "ARS"
      },
      // The QR case. For the notice block in the preview, set
      // `capture_link: null` with whatever `status` you want to try.
      work_proof: {
        mechanism: "inspection",
        capture_link: "https://app.autoinspector.ai/i/8f3a1c9e-2b47-4d6a",
        status: "pending_capture"
      }
    }
  }),
  agreement: defineDocumentContract({
    app: "insurer",
    params: agreementDocumentParamsSchema,
    payload: agreementDocumentPayloadSchema,
    // Compilado desde el template de ejemplo sobre el escenario de referencia,
    // así el preview y los specs nunca divergen del texto real.
    sample: buildAgreementDocumentSample()
  })
};
var renderDocumentRequestBody = import_zod95.z.discriminatedUnion("template", [
  import_zod95.z.object({
    template: import_zod95.z.literal("sample"),
    params: sampleDocumentParamsSchema
  }),
  import_zod95.z.object({
    template: import_zod95.z.literal("order_report"),
    params: orderReportParamsSchema
  }),
  import_zod95.z.object({
    template: import_zod95.z.literal("agreement"),
    params: agreementDocumentParamsSchema
  })
]);

// contracts/autoinspector.contract.ts
var import_database44 = __toESM(require_index_browser4());
var import_zod96 = require("zod");
var AUTOINSPECTOR_USE_CASES = [
  {
    key: "claim_document_analysis",
    label: "An\xE1lisis documental de reclamos",
    description: "Verifica autenticidad de im\xE1genes y PDFs adjuntos a un reclamo"
  },
  {
    key: "order_work_proof",
    label: "Prueba de trabajo",
    description: "Verifica autenticidad de las evidencias que el proveedor adjunta a una orden"
  }
];
var AUTOINSPECTOR_USE_CASE_KEYS = AUTOINSPECTOR_USE_CASES.map(
  (useCase) => useCase.key
);
var isAutoinspectorUseCase = (value) => AUTOINSPECTOR_USE_CASE_KEYS.includes(value);
var AUTOINSPECTOR_CONFIGURABLE_USE_CASES = [
  "claim_document_analysis"
];
var autoinspectorUseCaseSupportsFieldConfig = (useCase) => AUTOINSPECTOR_CONFIGURABLE_USE_CASES.includes(useCase);
var SELF_MANAGED_INTEGRATION_BACKENDS = [
  "autoinspector_templates",
  // La cuenta personal de Kach: sus filas nacen solo del flujo OAuth del
  // usuario (KachConnectionService) y se desconectan desde Integraciones.
  "kach_user"
];
var isSelfManagedIntegrationBackend = (backend) => SELF_MANAGED_INTEGRATION_BACKENDS.includes(backend);
var configureAutoinspectorRequestBody = import_zod96.z.object({
  api_key: import_zod96.z.string({ required_error: "La API Key es obligatoria" }).min(1, "La API Key es obligatoria")
});
var removeAutoinspectorRequestQuery = import_zod96.z.object({
  // Permite continuar cuando la cuenta de Autoinspector ya no existe y el
  // webhook no se puede borrar.
  force: import_zod96.z.coerce.boolean().optional()
});
var assignAutoinspectorTemplateRequestBody = import_zod96.z.object({
  use_case: import_zod96.z.string({ required_error: "El caso de uso es obligatorio" }).min(1, "El caso de uso es obligatorio"),
  external_id: import_zod96.z.string({ required_error: "La plantilla es obligatoria" }).min(1, "La plantilla es obligatoria"),
  external_name: import_zod96.z.string({ required_error: "La plantilla es obligatoria" }).min(1, "La plantilla es obligatoria"),
  // Opt-in per company and use case: the report is only produced for the
  // templates that declare it here.
  generates_report: import_zod96.z.boolean().default(false)
});
var updateAutoinspectorTemplateRequestBody = assignAutoinspectorTemplateRequestBody.omit({ use_case: true });
var AUTOINSPECTOR_REPORT_STATUSES = [
  // The inspection is not completed: Autoinspector has nothing to export yet.
  "unavailable",
  "generating",
  "ready",
  "failed"
];
var AUTOINSPECTOR_INPUT_TYPES = [
  "text",
  "textarea",
  "numeric",
  "file",
  "image"
];
var AUTOINSPECTOR_CREATE_STAGE = "create";
var CLAIM_DOCUMENT_ANALYSIS_VALUE_FIELD_SOURCES = [
  "victim_first_name",
  "victim_last_name",
  "victim_identification",
  "claimant_first_name",
  "claimant_last_name",
  "claimant_identification",
  "claim_id",
  "claim_ref_id",
  "external_claim_request_id",
  "third_vehicle_license_plate",
  "origin"
];
var CLAIM_DOCUMENT_ANALYSIS_FILE_FIELD_SOURCES = [
  "files_images",
  "files_pdf_documents",
  "files_all"
];
var AUTOINSPECTOR_FIELD_SOURCES = [
  ...CLAIM_DOCUMENT_ANALYSIS_VALUE_FIELD_SOURCES,
  ...CLAIM_DOCUMENT_ANALYSIS_FILE_FIELD_SOURCES
];
var autoinspectorFieldSourceDefinitions = {
  victim_first_name: {
    kind: "value",
    label: "Nombre del damnificado",
    input_types: ["text", "textarea"]
  },
  victim_last_name: {
    kind: "value",
    label: "Apellido del damnificado",
    input_types: ["text", "textarea"]
  },
  victim_identification: {
    kind: "value",
    label: "Identificaci\xF3n del damnificado",
    input_types: ["text", "textarea", "numeric"]
  },
  claimant_first_name: {
    kind: "value",
    label: "Nombre del reclamante",
    input_types: ["text", "textarea"]
  },
  claimant_last_name: {
    kind: "value",
    label: "Apellido del reclamante",
    input_types: ["text", "textarea"]
  },
  claimant_identification: {
    kind: "value",
    label: "Identificaci\xF3n del reclamante",
    input_types: ["text", "textarea", "numeric"]
  },
  claim_id: {
    kind: "value",
    label: "ID interno del reclamo (Piramid)",
    input_types: ["text", "textarea"]
  },
  claim_ref_id: {
    kind: "value",
    label: "Referencia del reclamo",
    input_types: ["text", "textarea"]
  },
  external_claim_request_id: {
    kind: "value",
    label: "ID externo del reclamo",
    input_types: ["text", "textarea", "numeric"]
  },
  third_vehicle_license_plate: {
    kind: "value",
    label: "Patente del veh\xEDculo del tercero",
    input_types: ["text", "textarea"]
  },
  // Distingue el origen cuando Kach y Piramid comparten la plantilla (espejo
  // de `origin_kach`): siempre resuelve la constante 'piramid'.
  origin: {
    kind: "value",
    label: "Origen (piramid)",
    input_types: ["text", "textarea"]
  },
  files_images: {
    kind: "file",
    label: "Im\xE1genes del reclamante",
    input_types: ["file", "image"]
  },
  files_pdf_documents: {
    kind: "file",
    label: "Documentos PDF del reclamante",
    input_types: ["file"]
  },
  files_all: {
    kind: "file",
    label: "Todos los archivos del reclamante (im\xE1genes y PDF)",
    input_types: ["file"]
  }
};
var isAutoinspectorFieldSource = (value) => value in autoinspectorFieldSourceDefinitions;
var isAutoinspectorFieldSourceCompatible = (input, source) => (input.stages ?? []).includes(AUTOINSPECTOR_CREATE_STAGE) && autoinspectorFieldSourceDefinitions[source].input_types.includes(
  input.type
);
var autoinspectorFieldMappingSchema = import_zod96.z.object({
  /// Identifier del input en la plantilla externa.
  identifier: import_zod96.z.string().min(1).max(255),
  /// Solo para mostrar y loguear; la coincidencia es por identifier.
  label: import_zod96.z.string().max(255).optional(),
  source: import_zod96.z.enum(AUTOINSPECTOR_FIELD_SOURCES)
});
var autoinspectorFieldMappingsSchema = import_zod96.z.array(autoinspectorFieldMappingSchema).max(50).superRefine((mappings, ctx) => {
  const identifiers = /* @__PURE__ */ new Set();
  const fileSources = /* @__PURE__ */ new Set();
  for (const mapping of mappings) {
    if (identifiers.has(mapping.identifier)) {
      ctx.addIssue({
        code: import_zod96.z.ZodIssueCode.custom,
        message: `Cada campo puede mapearse una sola vez (${mapping.identifier})`
      });
    }
    identifiers.add(mapping.identifier);
    const definition = autoinspectorFieldSourceDefinitions[mapping.source];
    if (definition.kind === "file") {
      if (fileSources.has(mapping.source)) {
        ctx.addIssue({
          code: import_zod96.z.ZodIssueCode.custom,
          message: `Cada fuente de archivos puede asignarse a un solo campo (${mapping.source})`
        });
      }
      fileSources.add(mapping.source);
    }
  }
  const hasAll = fileSources.has("files_all");
  if (hasAll && fileSources.size > 1) {
    ctx.addIssue({
      code: import_zod96.z.ZodIssueCode.custom,
      message: "La fuente de todos los archivos no se combina con las fuentes por tipo"
    });
  }
});
var CLAIM_DOCUMENT_ANALYSIS_INFERENCES = [
  "ia_detectada_images",
  "similitud_web_images",
  "pdf_forgery_verdict",
  "pdf_forgery_trust_score"
];
var CLAIM_DOCUMENT_ANALYSIS_RESULTS = [
  "approved",
  "needs_review",
  "disapproved"
];
var isClaimDocumentAnalysisResult = (value) => CLAIM_DOCUMENT_ANALYSIS_RESULTS.includes(
  value
);
var claimDocumentAnalysisAssetDetailsSchema = import_zod96.z.object({
  result: import_zod96.z.string().optional(),
  validationResult: import_zod96.z.string().nullable().optional(),
  ruleResult: import_zod96.z.string().optional(),
  inferences: import_zod96.z.array(import_zod96.z.string()).default([]),
  unknownInferences: import_zod96.z.array(import_zod96.z.string()).default([]),
  evaluatedCount: import_zod96.z.number().optional()
});
var updateAutoinspectorTemplateFieldMappingsRequestBody = import_zod96.z.object({
  mappings: autoinspectorFieldMappingsSchema
});
var setAutoinspectorTemplateEnabledRequestBody = import_zod96.z.object({
  enabled: import_zod96.z.boolean()
});
var AUTOINSPECTOR_INSPECTION_RESULT_FILTERS = [
  "approved",
  "disapproved",
  "error",
  "none"
];
var backofficeAutoinspectorInspectionsFilterQuery = import_zod96.z.object({
  date_from: import_zod96.z.coerce.date().optional(),
  date_to: import_zod96.z.coerce.date().optional(),
  status: import_zod96.z.nativeEnum(import_database44.AutoinspectorInspectionStatus).optional(),
  result: import_zod96.z.enum(AUTOINSPECTOR_INSPECTION_RESULT_FILTERS).optional(),
  company_id: import_zod96.z.string().optional(),
  template_id: import_zod96.z.string().optional(),
  use_case: import_zod96.z.string().optional(),
  /// Búsqueda por prefijo: id externo de la inspección o id de la entidad
  /// correlacionada (correlation_id).
  search: import_zod96.z.string().trim().min(1).max(64).optional()
});
var listBackofficeAutoinspectorInspectionsRequestQuery = backofficeAutoinspectorInspectionsFilterQuery.extend({
  page: import_zod96.z.coerce.number().min(1).default(1),
  limit: import_zod96.z.coerce.number().min(1).max(50).default(15)
});

// contracts/product-import.contract.ts
var import_piramid_constants78 = __toESM(require_dist2());
var import_zod97 = require("zod");
var columnIndex = import_zod97.z.number({ invalid_type_error: "La columna debe ser un n\xFAmero" }).int().nonnegative();
var productImportMapping = import_zod97.z.object({
  sku: columnIndex,
  name: columnIndex.optional(),
  brand: columnIndex.optional(),
  description: columnIndex.optional(),
  unit_price: columnIndex.optional(),
  is_active: columnIndex.optional()
}).refine(
  (mapping) => {
    const indexes = Object.values(mapping).filter(
      (value) => value !== void 0
    );
    return new Set(indexes).size === indexes.length;
  },
  { message: "No se puede mapear la misma columna a dos campos" }
);
var productImportOptions = import_zod97.z.object({
  number_format: import_zod97.z.enum(import_piramid_constants78.decimalAmountFormats).default("es-AR"),
  /**
   * Sólo tiene efecto cuando el preview ya mostró las filas inválidas: importa
   * las válidas y omite el resto en vez de bloquear el archivo completo.
   */
  skip_invalid_rows: import_zod97.z.boolean().default(false)
});
var productImportRowError = import_zod97.z.object({
  row_number: import_zod97.z.number().int().positive(),
  sku: import_zod97.z.string().nullable(),
  column_header: import_zod97.z.string().nullable(),
  target_field: import_zod97.z.enum(import_piramid_constants78.productImportTargetFields).nullable(),
  received_value: import_zod97.z.string(),
  code: import_zod97.z.enum(import_piramid_constants78.productImportRowErrorCodes),
  message: import_zod97.z.string()
});
var productImportCreateRow = createProductRequestBody;
var productImportUpdateRow = createProductRequestBody.partial().extend({ sku: createProductRequestBody.shape.sku });
var inspectProductImportRequestBody = import_zod97.z.object({
  file_token: import_zod97.z.string().min(1, "El archivo es obligatorio")
});
var previewProductImportRequestBody = import_zod97.z.object({
  file_token: import_zod97.z.string().min(1, "El archivo es obligatorio"),
  mapping: productImportMapping,
  options: productImportOptions
});
var createProductImportRequestBody = previewProductImportRequestBody;
var retrieveProductImportRequestParams = import_zod97.z.object({
  productImportId: import_zod97.z.coerce.string()
});
var listProductImportsRequestQuery = paginateRequestQuery;

// contracts/agreement-rule.contract.ts
var import_piramid_constants79 = __toESM(require_dist2());
var import_zod98 = require("zod");
var agreementRuleRecipientSchema = import_zod98.z.object({
  signer_key: import_zod98.z.string().regex(/^[a-z][a-z0-9_]*$/, "invalid_signer_key"),
  index: import_zod98.z.number().int().min(0)
});
var evaluableAgreementRuleSchema = import_zod98.z.object({
  id: import_zod98.z.string(),
  name: import_zod98.z.string(),
  priority: import_zod98.z.number().int(),
  template_id: import_zod98.z.string(),
  conditions: agreementRuleConditionsSchema,
  recipients: import_zod98.z.array(agreementRuleRecipientSchema)
});
var agreementSignatureRuleScopeSchema = import_zod98.z.array(import_zod98.z.string().min(1)).min(1).nullable();
var evaluableAgreementSignatureRuleSchema = import_zod98.z.object({
  id: import_zod98.z.string(),
  name: import_zod98.z.string(),
  priority: import_zod98.z.number().int(),
  method: import_zod98.z.enum(import_piramid_constants79.agreementSignatureMethods),
  conditions: agreementRuleConditionsSchema,
  template_ids: agreementSignatureRuleScopeSchema
});
var agreementConditionEvaluationSchema = import_zod98.z.object({
  attribute: agreementRuleAttributeKeySchema,
  name: import_zod98.z.string().nullable(),
  operator: import_zod98.z.enum(import_piramid_constants79.agreementRuleOperators),
  value: agreementRuleValueSchema,
  /** Lo que el contexto traía: sin nombres ni direcciones, se puede persistir y mostrar. */
  actual: agreementRuleValueSchema.nullable(),
  result: import_zod98.z.enum(import_piramid_constants79.agreementConditionResults),
  reason: import_zod98.z.enum(import_piramid_constants79.agreementConditionUndeterminedReasons).nullable()
});
var agreementRuleEvaluationSchema = import_zod98.z.object({
  rule_id: import_zod98.z.string(),
  name: import_zod98.z.string(),
  priority: import_zod98.z.number().int(),
  result: import_zod98.z.enum(import_piramid_constants79.agreementRuleResults),
  conditions: import_zod98.z.array(agreementConditionEvaluationSchema)
});
var agreementSignatureRuleEvaluationSchema = agreementRuleEvaluationSchema.extend({ in_scope: import_zod98.z.boolean() });
var agreementPlanRecipientSchema = import_zod98.z.object({
  signer_key: import_zod98.z.string(),
  label: import_zod98.z.string(),
  party: import_zod98.z.enum(import_piramid_constants79.agreementSignerParties),
  index: import_zod98.z.number().int().min(0),
  optional: import_zod98.z.boolean(),
  name: import_zod98.z.string().nullable(),
  email: import_zod98.z.string().nullable(),
  status: import_zod98.z.enum(["resolved", "missing"]),
  reason: import_zod98.z.enum(import_piramid_constants79.agreementPlanRecipientReasons).nullable()
});
var agreementPlanGapSchema = import_zod98.z.object({
  kind: import_zod98.z.enum(import_piramid_constants79.agreementPlanGapKinds),
  key: import_zod98.z.string(),
  reason: import_zod98.z.string()
});
var agreementPlanRuleSchema = import_zod98.z.object({
  id: import_zod98.z.string(),
  name: import_zod98.z.string(),
  priority: import_zod98.z.number().int()
});
var agreementPlanTemplateSchema = import_zod98.z.object({
  id: import_zod98.z.string(),
  name: import_zod98.z.string(),
  version_id: import_zod98.z.string(),
  version: import_zod98.z.number().int()
});
var agreementSignatureDecisionSchema = import_zod98.z.object({
  method: import_zod98.z.enum(import_piramid_constants79.agreementSignatureMethods).nullable(),
  outcome: import_zod98.z.enum(import_piramid_constants79.agreementSignatureOutcomes),
  reason: import_zod98.z.enum(import_piramid_constants79.agreementPlanReasons).nullable(),
  rule: agreementPlanRuleSchema.nullable(),
  /** Todas las reglas de firma, en orden de prioridad, con las fuera de alcance marcadas. */
  evaluations: import_zod98.z.array(agreementSignatureRuleEvaluationSchema)
});
var agreementPlanSchema = import_zod98.z.object({
  outcome: import_zod98.z.enum(import_piramid_constants79.agreementPlanOutcomes),
  reason: import_zod98.z.enum(import_piramid_constants79.agreementPlanReasons).nullable(),
  stage: import_zod98.z.enum(import_piramid_constants79.agreementPlanStages),
  rule: agreementPlanRuleSchema.nullable(),
  template: agreementPlanTemplateSchema.nullable(),
  signature: agreementSignatureDecisionSchema,
  recipients: import_zod98.z.array(agreementPlanRecipientSchema),
  missing: import_zod98.z.array(agreementPlanGapSchema),
  warnings: import_zod98.z.array(agreementWarningSchema),
  /** Todas las reglas de generación evaluadas, en el mismo orden en que se evaluaron. */
  evaluations: import_zod98.z.array(agreementRuleEvaluationSchema),
  meta: agreementResolutionMetaSchema
});
var companyAgreementSettingsRequestBody = import_zod98.z.object({
  enabled: import_zod98.z.boolean(),
  /** Override de los nombres con que esta compañía llama a cada concepto. */
  variable_bindings: import_zod98.z.record(import_zod98.z.array(import_zod98.z.string().min(1)).min(1)).nullable(),
  /** Opciones de cuotas / honorarios / días del wizard guiado; null = las del producto. */
  offer_terms: companyOfferTermsOptionsSchema.nullable().default(null),
  /** La única carta de ofrecimiento de la compañía (`AgreementTemplate` de `kind = offer_message`). */
  offer_message_template_id: import_zod98.z.string().min(1).nullable().default(null),
  /** Validar CBU y CUIT contra Interbanking al aceptar. Falla cerrado, así que se pide explícitamente. */
  validate_bank_data: import_zod98.z.boolean().default(false),
  /** Validar que quien declara la cuenta de cobro pueda cobrar este reclamo. Frena la aceptación, así que se pide explícitamente. */
  validate_acceptance_payee: import_zod98.z.boolean().default(false),
  /**
   * Mandar la conformidad aceptada a firmar por AutoSign. Opcional a propósito:
   * quien guarda otra parte de la configuración sin mandarlo no lo apaga.
   */
  signature_enabled: import_zod98.z.boolean().optional(),
  /**
   * Firma embebida: el reclamante firma dentro de Piramid apenas acepta. Opcional
   * por lo mismo que `signature_enabled`; apagarlo corta las firmas en curso.
   */
  embedded_signing_enabled: import_zod98.z.boolean().optional()
});
var agreementRuleRequestParams = import_zod98.z.object({
  ruleId: import_zod98.z.string().min(1)
});
var createAgreementRuleRequestBody = import_zod98.z.object({
  name: import_zod98.z.string().min(1).max(120),
  description: import_zod98.z.string().max(500).nullable().default(null),
  enabled: import_zod98.z.boolean().default(false),
  priority: import_zod98.z.number().int().min(0).max(9999),
  template_id: import_zod98.z.string().min(1),
  conditions: agreementRuleConditionsSchemaFor(
    import_piramid_constants79.AGREEMENT_GENERATION_RULE_GROUPS
  ),
  recipients: import_zod98.z.array(agreementRuleRecipientSchema).default([])
});
var updateAgreementRuleRequestBody = createAgreementRuleRequestBody;
var reorderAgreementRulesRequestBody = import_zod98.z.object({
  rule_ids: import_zod98.z.array(import_zod98.z.string().min(1)).min(1)
});
var createAgreementSignatureRuleRequestBody = import_zod98.z.object({
  name: import_zod98.z.string().min(1).max(120),
  description: import_zod98.z.string().max(500).nullable().default(null),
  enabled: import_zod98.z.boolean().default(false),
  priority: import_zod98.z.number().int().min(0).max(9999),
  method: import_zod98.z.enum(import_piramid_constants79.agreementSignatureMethods),
  conditions: agreementRuleConditionsSchema,
  template_ids: agreementSignatureRuleScopeSchema.default(null)
});
var updateAgreementSignatureRuleRequestBody = createAgreementSignatureRuleRequestBody;
var reorderAgreementSignatureRulesRequestBody = reorderAgreementRulesRequestBody;
var agreementRuleHealthIssues = [
  "template_not_published",
  "template_deleted",
  "unknown_condition_variable",
  /** Una condición apunta a un tipo de reclamo o plantilla que la compañía ya no tiene. */
  "unknown_condition_option",
  /** El alcance nombra un template eliminado. */
  "unknown_scope_template"
];
var listCompanyAgreementRulesRequestQuery = paginateRequestQuery;
var planAgreementRequestBody = import_zod98.z.object({
  claim_id: import_zod98.z.string().min(1),
  offer_id: import_zod98.z.string().min(1).nullable().optional(),
  acceptance: import_zod98.z.enum(["persisted", "none"]).default("persisted")
});
var retrieveAgreementPlanRequestQuery = import_zod98.z.object({
  offer_id: import_zod98.z.string().min(1)
});

// helpers/resolve-offer-amount-from-variables.ts
var import_piramid_constants80 = __toESM(require_dist2());
var resolveOfferAmountFromVariables = ({
  definitions,
  values
}) => {
  const amountVariable = definitions.find(
    (variable) => variable.determination === "compile_time" && variable.type === "numeric" && variable.name === import_piramid_constants80.OFFER_AMOUNT_VARIABLE_NAME
  );
  const providedAmount = amountVariable ? Number(values[amountVariable.guid]) : NaN;
  return Number.isFinite(providedAmount) && providedAmount > 0 ? providedAmount : null;
};

// helpers/agreement-send-blockers.ts
var import_piramid_constants81 = __toESM(require_dist2());
var RESOLVED_AT_ACCEPTANCE = "pending_acceptance";
var NO_BLOCKERS = {
  warnings: [],
  signers: [],
  variables: [],
  conditions: []
};
var isBlockingWarning = (code) => import_piramid_constants81.AGREEMENT_BLOCKING_WARNING_CODES.some((blocking) => blocking === code);
var agreementSendBlockers = ({
  plan,
  conditionGaps
}) => plan.outcome === "selected" && plan.template !== null ? {
  warnings: plan.warnings.map((warning) => warning.code).filter(isBlockingWarning),
  signers: plan.missing.filter((gap) => gap.kind === "signer"),
  variables: plan.missing.filter((gap) => gap.kind === "variable"),
  conditions: conditionGaps.filter(
    (gap) => gap.reason !== RESOLVED_AT_ACCEPTANCE
  )
} : NO_BLOCKERS;
var hasAgreementSendBlockers = ({
  warnings,
  signers,
  variables,
  conditions
}) => warnings.length > 0 || signers.length > 0 || variables.length > 0 || conditions.length > 0;
var agreementSendBlockerKeys = ({
  warnings,
  signers,
  variables,
  conditions
}) => [
  ...warnings,
  ...signers.map((gap) => gap.key),
  ...variables.map((gap) => gap.key),
  ...conditions.map((gap) => gap.attribute)
];

// helpers/agreement-final-document-blockers.ts
var agreementFinalDocumentBlocker = ({
  missing: missing3,
  syntax_errors,
  condition_gaps
}) => {
  if (syntax_errors.length > 0)
    return {
      code: "syntax_error",
      items: syntax_errors.map((error) => error.block_id)
    };
  const holes = missing3.filter((gap) => gap.blocking);
  if (holes.length > 0)
    return { code: "missing_data", items: holes.map((gap) => gap.key) };
  if (condition_gaps.length > 0)
    return {
      code: "undetermined_condition",
      items: condition_gaps.map((gap) => gap.block_id)
    };
  return null;
};

// helpers/normalize-autosign-recipient-name.ts
var ALLOWED_CHARACTER = /[a-zA-Z0-9_áéíóúüñÁÉÍÓÚÜÑ]/;
var COMBINING_MARKS = /[̀-ͯ]/g;
var WORD_SEPARATORS = /[\s\-'’.,]+/;
var toAllowedCharacters = (character) => ALLOWED_CHARACTER.test(character) ? character : Array.from(character.normalize("NFD").replace(COMBINING_MARKS, "")).filter((stripped) => ALLOWED_CHARACTER.test(stripped)).join("");
var normalizeAutosignRecipientName = (name) => {
  if (!name) return null;
  const words = name.normalize("NFC").split(WORD_SEPARATORS).map((word) => Array.from(word).map(toAllowedCharacters).join("")).filter((word) => word.length > 0);
  return words.length >= 2 ? words.join(" ") : null;
};

// helpers/autosign-connection-status.ts
var import_piramid_constants82 = __toESM(require_dist2());
var autosignConnectionStatus = (connection) => {
  if (!connection) return "disconnected";
  const granted = new Set((connection.scopes ?? "").split(/\s+/));
  const hasCurrentScopes = import_piramid_constants82.AUTOSIGN_OAUTH_SCOPES.every(
    (scope) => granted.has(scope)
  );
  const healthy = connection.invalidated_at === null && !!connection.connected_account_email && hasCurrentScopes;
  return healthy ? "connected" : "reconnect_required";
};

// helpers/build-autosign-authorize-url.ts
var import_piramid_constants83 = __toESM(require_dist2());
var buildAutosignAuthorizeUrl = ({
  storedUrl,
  clientId
}) => {
  const url = new URL(storedUrl);
  url.searchParams.delete("client_id");
  url.searchParams.delete("scopes");
  const query = [
    `client_id=${encodeURIComponent(clientId)}`,
    `scopes=${import_piramid_constants83.AUTOSIGN_OAUTH_SCOPES.join("%20")}`,
    url.searchParams.toString()
  ].filter((part) => part.length > 0).join("&");
  return `${url.origin}${url.pathname}?${query}`;
};

// helpers/build-agreement-dispatch.ts
var import_i11n4 = __toESM(require_dist());
var import_zod99 = require("zod");
var emailSchema = import_zod99.z.string().email();
var toDispatchable = (recipient, anchors) => {
  var _a;
  const email = ((_a = recipient.email) == null ? void 0 : _a.trim()) ?? "";
  const code = recipient.status === "missing" ? recipient.reason === "no_email" ? "recipient_without_email" : "recipient_unresolved" : !emailSchema.safeParse(email).success ? "recipient_without_email" : !anchors[recipient.signer_key] ? "anchor_missing" : null;
  if (code === null) return { kind: "signer", recipient, email };
  return recipient.optional ? { kind: "skip" } : { kind: "blocked", code, signer_key: recipient.signer_key };
};
var groupSigners = (signers) => Array.from(
  signers.reduce((groups, { recipient, email }) => {
    var _a;
    const name = normalizeAutosignRecipientName(recipient.name);
    const key = `${email.toLowerCase()}|${name ?? ""}`;
    const previous = ((_a = groups.get(key)) == null ? void 0 : _a.signer_keys) ?? [];
    return groups.set(key, {
      name,
      email,
      signer_keys: [...previous, recipient.signer_key]
    });
  }, /* @__PURE__ */ new Map()).values()
);
var reachableSignerGroups = (recipients) => groupSigners(
  recipients.flatMap((recipient) => {
    var _a;
    const email = ((_a = recipient.email) == null ? void 0 : _a.trim()) ?? "";
    const reachable = recipient.status === "resolved" && emailSchema.safeParse(email).success;
    return reachable ? [{ kind: "signer", recipient, email }] : [];
  })
);
var agreementPlanSigners = (recipients) => reachableSignerGroups(
  [...recipients].sort((left, right) => left.index - right.index)
);
var signerKeysSharingEmail = (recipients) => {
  const groupsByEmail = reachableSignerGroups(recipients).reduce(
    (byEmail, group) => {
      const key = group.email.toLowerCase();
      return byEmail.set(key, [...byEmail.get(key) ?? [], group]);
    },
    /* @__PURE__ */ new Map()
  );
  return Array.from(groupsByEmail.values()).filter((groups) => groups.length > 1).flatMap((groups) => groups.flatMap((group) => group.signer_keys));
};
var buildAgreementDispatchRecipients = ({
  recipients,
  anchors,
  sender,
  createId
}) => {
  const ordered = [...recipients].sort(
    (left, right) => left.index - right.index
  );
  const dispatchable = ordered.map(
    (recipient) => toDispatchable(recipient, anchors)
  );
  const blocked = dispatchable.find(
    (entry) => entry.kind === "blocked"
  );
  if (blocked)
    return { ok: false, code: blocked.code, signer_key: blocked.signer_key };
  const groups = groupSigners(
    dispatchable.filter(
      (entry) => entry.kind === "signer"
    )
  );
  if (groups.length === 0)
    return { ok: false, code: "no_signers", signer_key: null };
  const senderRecipient = {
    id: createId(),
    provider_recipient_id: null,
    index: 0,
    role: "sender",
    name: normalizeAutosignRecipientName(sender.name),
    email: sender.email,
    signer_keys: []
  };
  return {
    ok: true,
    recipients: [
      senderRecipient,
      ...groups.map(
        (group, position) => ({
          id: createId(),
          provider_recipient_id: null,
          index: position + 1,
          role: "signer",
          ...group
        })
      )
    ]
  };
};
var buildAgreementDispatchFields = ({
  recipients,
  anchors,
  labels
}) => recipients.filter((recipient) => recipient.role === "signer").flatMap(
  (recipient) => recipient.signer_keys.map((signer_key) => ({ recipient, signer_key }))
).flatMap(({ recipient, signer_key }, position) => {
  const anchor = anchors[signer_key];
  return anchor ? [
    {
      guid: `signature_${position + 1}`,
      signer_key,
      label: labels[signer_key] ?? "",
      recipient_id: recipient.id,
      page: anchor.page_index,
      positionX: anchor.x,
      positionY: anchor.y,
      width: anchor.width,
      height: anchor.height
    }
  ] : [];
});
var agreementDispatchTransactionName = (claim) => (0, import_i11n4.translate)("offer.agreement.dispatch.transaction_name", {
  ref: claim.external_claim_request_id || claim.ref_id || claim.id
});

// helpers/resolve-signature-dispatch.ts
var signatureMayEndDigital = (signature) => signature.method === "digital" || signature.outcome === "undetermined";
var connectionBlocker = {
  connected: null,
  disconnected: "sender_connection_missing",
  reconnect_required: "sender_connection_reconnect_required"
};
var NOT_REQUIRED = {
  sender: null,
  blockers: [],
  keys: [],
  shared_email_keys: []
};
var resolveSignatureDispatch = ({
  signatureEnabled,
  hasAgreement,
  plan,
  sender
}) => {
  var _a;
  const required = signatureEnabled && hasAgreement && signatureMayEndDigital(plan.signature);
  if (!required || !sender) return { required, ...NOT_REQUIRED };
  const status = autosignConnectionStatus(sender.connection);
  const blocker = connectionBlocker[status];
  const keys = plan.signature.outcome === "undetermined" ? plan.recipients.filter(
    (recipient) => !recipient.optional && recipient.status === "resolved" && !recipient.email
  ).map((recipient) => recipient.signer_key) : [];
  const sharedEmailKeys = signerKeysSharingEmail(plan.recipients);
  const blockers = [
    ...blocker ? [blocker] : [],
    ...keys.length > 0 ? ["signer_email_missing"] : [],
    ...sharedEmailKeys.length > 0 ? ["signer_email_shared"] : []
  ];
  return {
    required,
    sender: status === "connected" && ((_a = sender.connection) == null ? void 0 : _a.connected_account_email) ? { account_email: sender.connection.connected_account_email } : null,
    blockers,
    keys,
    shared_email_keys: sharedEmailKeys
  };
};

// helpers/agreement-signature-mode.ts
var decidedAgreementSignatureMethod = ({
  planSignature,
  diagnostics
}) => diagnostics ? diagnostics.signature.decision.method : planSignature.outcome === "selected" ? planSignature.method : null;
var shouldDispatchAgreementDocument = ({
  planSignatureEnabled,
  document: document2
}) => {
  var _a;
  return planSignatureEnabled && document2.status === "ready" && ((_a = document2.diagnostics) == null ? void 0 : _a.signature.decision.method) === "digital";
};

// helpers/offer-agreement-visibility.ts
var isOfferAgreementVisibleToClaimant = ({
  document_id,
  dispatched_at
}) => document_id === null || dispatched_at !== null;

// helpers/resolve-embedded-signing-eligibility.ts
var resolveEmbeddedSigningEligibility = ({
  plan,
  planSignatureEnabled,
  settings,
  signerEmail
}) => {
  if (!settings.signature_enabled || !settings.embedded_signing_enabled)
    return { eligible: false, reason: "disabled" };
  if (!plan || plan.outcome !== "selected" || !plan.template)
    return { eligible: false, reason: "no_plan" };
  if (!planSignatureEnabled)
    return { eligible: false, reason: "signature_not_enabled" };
  const decidedDigital = plan.signature.outcome === "selected" && plan.signature.method === "digital";
  if (!decidedDigital)
    return { eligible: false, reason: "signature_not_digital" };
  const [firstSigner] = agreementPlanSigners(plan.recipients);
  const [firstBox] = [...plan.recipients].sort(
    (left, right) => left.index - right.index
  );
  if (!firstBox) return { eligible: false, reason: "no_signer" };
  const firstBoxIsReachable = !!firstSigner && firstSigner.signer_keys.includes(firstBox.signer_key);
  if (!firstBoxIsReachable)
    return { eligible: false, reason: "signer_without_email" };
  const identity = normalizeEmail(signerEmail);
  if (!identity) return { eligible: false, reason: "owner_without_email" };
  if (normalizeEmail(firstSigner.email) !== identity)
    return { eligible: false, reason: "signer_is_not_owner" };
  return { eligible: true, signerEmail: firstSigner.email };
};

// helpers/resolve-agreement-signature-origin.ts
var import_piramid_constants84 = __toESM(require_dist2());

// helpers/offer-agreement-observation.ts
var import_database45 = __toESM(require_index_browser4());
var import_zod101 = require("zod");

// contracts/offer-agreement-dispatch.contract.ts
var import_zod100 = require("zod");
var offerAgreementDispatchRecipientRoles = [
  "sender",
  "signer"
];
var offerAgreementDispatchRecipientSchema = import_zod100.z.object({
  id: import_zod100.z.string().min(1),
  provider_recipient_id: import_zod100.z.string().nullable(),
  index: import_zod100.z.number().int().min(0),
  role: import_zod100.z.enum(offerAgreementDispatchRecipientRoles),
  name: import_zod100.z.string().nullable(),
  email: import_zod100.z.string().email(),
  signer_keys: import_zod100.z.array(import_zod100.z.string())
});
var offerAgreementDispatchRecipientsSchema = import_zod100.z.array(
  offerAgreementDispatchRecipientSchema
);
var offerAgreementDispatchFieldSchema = import_zod100.z.object({
  guid: import_zod100.z.string().min(1).max(30),
  signer_key: import_zod100.z.string(),
  /** El rótulo del recuadro ("Firma del reclamante"): AutoSign lo muestra al firmante. */
  label: import_zod100.z.string(),
  recipient_id: import_zod100.z.string(),
  page: import_zod100.z.number().int().min(0),
  positionX: import_zod100.z.number().min(0).max(100),
  positionY: import_zod100.z.number().min(0).max(100),
  width: import_zod100.z.number().min(0).max(100),
  height: import_zod100.z.number().min(0).max(100)
});
var offerAgreementDispatchFieldsSchema = import_zod100.z.array(
  offerAgreementDispatchFieldSchema
);

// helpers/offer-agreement-observation.ts
var observedRecipient = (recipient) => ({
  provider_recipient_id: recipient.id,
  email: recipient.email ?? null,
  name: recipient.name ?? null,
  role: recipient.role ?? null,
  submitted_at: recipient.submitted_at ?? null
});
var observationFromTransitionWebhook = (body) => {
  switch (body.type) {
    case "transaction_created":
      return {
        kind: "informational",
        transaction_id: body.data.id,
        provider_status: "draft"
      };
    case "transaction_started":
      return {
        kind: "informational",
        transaction_id: body.data.id,
        provider_status: "started"
      };
    case "recipient_submitted":
      return {
        kind: "recipient_submitted",
        transaction_id: body.data.id,
        recipient: observedRecipient(body.data.recipient)
      };
    case "transaction_completed":
      return {
        kind: "terminal",
        transaction_id: body.data.id,
        status: "completed",
        occurred_at: body.data.completed_at,
        reason: null,
        sealed_documents: body.data.sealed_documents.map((document2) => ({
          url: document2.url,
          name: document2.name
        })),
        recipients: body.data.recipients.map(observedRecipient),
        // Un `completed` sin PDFs adjuntos los deja pendientes en vez de cerrar
        // la conformidad sin firmados y sin camino de vuelta.
        documents_missing: body.data.sealed_documents.length === 0
      };
    case "transaction_rejected":
      return {
        kind: "terminal",
        transaction_id: body.data.id,
        status: "rejected",
        occurred_at: body.data.rejected_at ?? body.created,
        reason: body.data.rejected_reason ?? null,
        sealed_documents: [],
        recipients: [observedRecipient(body.data.rejected_by)],
        documents_missing: false
      };
    case "transaction_expired":
      return {
        kind: "terminal",
        transaction_id: body.data.id,
        status: "expired",
        occurred_at: body.data.expired_at,
        reason: null,
        sealed_documents: [],
        recipients: [],
        documents_missing: false
      };
    case "transaction_cancelled":
      return {
        kind: "terminal",
        transaction_id: body.data.id,
        status: "canceled",
        occurred_at: body.data.cancelled_at,
        reason: body.data.cancelled_reason,
        sealed_documents: [],
        recipients: [],
        documents_missing: false
      };
  }
};
var autosignTransactionInfoSchema = import_zod101.z.object({
  id: import_zod101.z.string().min(1),
  status: import_zod101.z.nativeEnum(import_database45.OfferAgreementStatus),
  template: import_zod101.z.object({
    recipients: import_zod101.z.array(
      import_zod101.z.object({
        id: import_zod101.z.string(),
        name: import_zod101.z.string().nullish(),
        email: import_zod101.z.string().nullish(),
        role: import_zod101.z.string().nullish(),
        submitted_at: import_zod101.z.coerce.date().nullish()
      })
    ).nullish()
  }).nullish()
});
var INFO_TERMINAL_STATUS = {
  completed: "completed",
  rejected: "rejected",
  expired: "expired",
  cancelled: "canceled",
  canceled: "canceled"
};
var observationFromTransactionInfo = (info) => {
  var _a;
  const parsed = autosignTransactionInfoSchema.safeParse(info);
  if (!parsed.success) return null;
  const terminal = INFO_TERMINAL_STATUS[parsed.data.status];
  const recipients = (((_a = parsed.data.template) == null ? void 0 : _a.recipients) ?? []).map(
    observedRecipient
  );
  if (!terminal)
    return {
      kind: "informational",
      transaction_id: parsed.data.id,
      provider_status: parsed.data.status === "started" ? "started" : "draft"
    };
  return {
    kind: "terminal",
    transaction_id: parsed.data.id,
    status: terminal,
    occurred_at: null,
    reason: null,
    sealed_documents: [],
    recipients,
    // El GET no trae los PDF firmados: solo el webhook `transaction_completed`.
    documents_missing: terminal === "completed"
  };
};
var recipientSubmittedPayloadSchema = import_zod101.z.object({
  type: import_zod101.z.literal("recipient_submitted"),
  data: import_zod101.z.object({
    id: import_zod101.z.string(),
    recipient: import_zod101.z.object({
      id: import_zod101.z.string(),
      email: import_zod101.z.string().nullish(),
      name: import_zod101.z.string().nullish(),
      role: import_zod101.z.string().nullish(),
      submitted_at: import_zod101.z.coerce.date().nullish()
    })
  })
});
var completedPayloadSchema = import_zod101.z.object({
  type: import_zod101.z.literal("transaction_completed"),
  data: import_zod101.z.object({
    id: import_zod101.z.string(),
    recipients: import_zod101.z.array(
      import_zod101.z.object({
        id: import_zod101.z.string(),
        email: import_zod101.z.string().nullish(),
        name: import_zod101.z.string().nullish(),
        role: import_zod101.z.string().nullish(),
        submitted_at: import_zod101.z.coerce.date().nullish()
      })
    ).nullish()
  })
});
var extractRecipientSubmissions = ({
  events,
  transaction_id
}) => {
  var _a;
  if (!transaction_id) return [];
  const submissions = /* @__PURE__ */ new Map();
  const record = (recipient) => {
    const known = submissions.get(recipient.provider_recipient_id);
    if (!known || known.submitted_at === null && recipient.submitted_at)
      submissions.set(recipient.provider_recipient_id, {
        ...recipient,
        ...(known == null ? void 0 : known.submitted_at) ? { submitted_at: known.submitted_at } : {}
      });
  };
  for (const event of events) {
    if (event.type === "recipient_submitted") {
      const parsed = recipientSubmittedPayloadSchema.safeParse(event.payload);
      if (parsed.success && parsed.data.data.id === transaction_id)
        record(observedRecipient(parsed.data.data.recipient));
    }
    if (event.type === "transaction_completed") {
      const parsed = completedPayloadSchema.safeParse(event.payload);
      if (parsed.success && parsed.data.data.id === transaction_id) {
        for (const recipient of parsed.data.data.recipients ?? [])
          if (recipient.submitted_at) record(observedRecipient(recipient));
      }
    }
    if (event.type === "reconciliation") {
      const parsed = autosignTransactionInfoSchema.safeParse(event.payload);
      if (parsed.success && parsed.data.id === transaction_id) {
        for (const recipient of ((_a = parsed.data.template) == null ? void 0 : _a.recipients) ?? [])
          if (recipient.submitted_at) record(observedRecipient(recipient));
      }
    }
  }
  return [...submissions.values()];
};
var mergeAgreementSigners = ({
  recipients,
  submissions,
  agreement_completed
}) => {
  const parsed = offerAgreementDispatchRecipientsSchema.safeParse(recipients);
  if (!parsed.success) return [];
  const findSubmission = (recipient) => submissions.find(
    (submission) => recipient.provider_recipient_id !== null && submission.provider_recipient_id === recipient.provider_recipient_id
  ) ?? submissions.find(
    (submission) => submission.email !== null && submission.email.toLowerCase() === recipient.email.toLowerCase() && (submission.role === null || submission.role === recipient.role)
  );
  return parsed.data.filter((recipient) => recipient.role === "signer").sort((left, right) => left.index - right.index).map((recipient) => {
    var _a;
    const submission = findSubmission(recipient);
    return {
      name: recipient.name,
      email: recipient.email,
      signer_keys: recipient.signer_keys,
      submitted: !!submission || agreement_completed,
      submitted_at: ((_a = submission == null ? void 0 : submission.submitted_at) == null ? void 0 : _a.toISOString()) ?? null
    };
  });
};

// helpers/resolve-agreement-signature-origin.ts
var distanceToWindow = (at, window2) => {
  const openedAt = window2.opened_at.getTime();
  const lastSeenAt = window2.last_seen_at.getTime();
  if (at < openedAt) return openedAt - at;
  if (at > lastSeenAt) return at - lastSeenAt;
  return 0;
};
var resolveAgreementSignatureOrigin = ({
  recipients,
  events,
  transaction_id,
  windows,
  graceMs = import_piramid_constants84.AGREEMENT_SIGNATURE_ORIGIN_GRACE_MS
}) => {
  if (!windows.length) return "external";
  const [firstSigner] = mergeAgreementSigners({
    recipients,
    submissions: extractRecipientSubmissions({ events, transaction_id }),
    agreement_completed: false
  });
  if (!(firstSigner == null ? void 0 : firstSigner.submitted_at)) return null;
  const submittedAt = new Date(firstSigner.submitted_at).getTime();
  const [closest] = windows.map((window2) => ({
    window: window2,
    distance: distanceToWindow(submittedAt, window2)
  })).filter(({ distance }) => distance <= graceMs).sort(
    (left, right) => left.distance - right.distance || right.window.last_seen_at.getTime() - left.window.last_seen_at.getTime()
  );
  return closest ? import_piramid_constants84.AGREEMENT_SIGNATURE_ORIGIN_BY_CEREMONY_ENTRY[closest.window.entry] : "external";
};

// helpers/offer-agreement-transition-guard.ts
var OPEN_STATUSES = ["pending", "started"];
var isOfferAgreementOpenAtProvider = ({
  status,
  start_requested_at
}) => OPEN_STATUSES.includes(status) || status === "failed" && start_requested_at !== null;
var offerAgreementTransitionDecision = ({
  agreement,
  offer_status,
  transaction_id,
  event_type
}) => {
  if (agreement.document_id === null) return { apply: true, mode: "legacy" };
  if (agreement.provider_id !== transaction_id)
    return { apply: false, reason: "provider_mismatch" };
  if (agreement.status === "canceled")
    return { apply: false, reason: "agreement_canceled" };
  if (offer_status !== "accepted")
    return { apply: false, reason: "offer_not_accepted" };
  if (isOfferAgreementOpenAtProvider(agreement))
    return { apply: true, mode: "transition" };
  if (agreement.status === "completed" && agreement.signed_documents_pending_at !== null && event_type === "transaction_completed")
    return { apply: true, mode: "attach_documents" };
  return { apply: false, reason: "already_terminal" };
};

// helpers/select-claim-agreements.ts
var isCanceledOfferStatus = (status) => status === "canceled" || status === "cancelled";
var hasOfferAgreement = (offer) => !!offer.agreement_reviewed_at && (offer.status === "pending" || !!offer.accepted_at);
var isManualAgreementOffer = (offer) => !offer.agreement_reviewed_at && !offer.agreement && offer.status === "accepted";
var absenceOf = (offers) => {
  const [latest] = offers;
  if (!latest) return "no_offers";
  if (hasOfferAgreement(latest)) return "offer_canceled";
  if (offers.some((offer) => {
    var _a;
    return ((_a = offer.agreement) == null ? void 0 : _a.document_id) === null;
  }))
    return "legacy_agreement";
  if (!latest.acceptance_requirements) return "legacy_offer";
  return latest.agreement_reviewed_at ? "offer_not_accepted" : "sent_without_agreement";
};
var selectClaimAgreements = (offers) => {
  const [latest] = offers;
  const current = latest && hasOfferAgreement(latest) && !isCanceledOfferStatus(latest.status) ? latest : null;
  return {
    current,
    previous: offers.filter(
      (offer) => offer.id !== (current == null ? void 0 : current.id) && hasOfferAgreement(offer)
    ),
    manual: latest && isManualAgreementOffer(latest) ? latest : null,
    absence: current ? null : absenceOf(offers)
  };
};
var supersedingOfferOf = (offers, offerId) => {
  const index = offers.findIndex((offer) => offer.id === offerId);
  return index > 0 ? offers[index - 1] : null;
};

// helpers/negotiation-stage-states.ts
var OFFER_STAGE_STATE = {
  accepted: "done",
  pending: "in_progress",
  rejected: "pending",
  expired: "pending",
  canceled: "pending",
  cancelled: "pending"
};
var AGREEMENT_STAGE_STATE = {
  draft: "in_progress",
  pending: "in_progress",
  started: "in_progress",
  completed: "done",
  failed: "attention",
  rejected: "attention",
  expired: "attention",
  canceled: "attention",
  cancelled: "attention"
};
var agreementStageStateOf = ({
  current,
  manual
}) => {
  if (manual) return manual.manual_agreement_file ? "done" : "pending";
  if (!current || current.status === "pending") return "pending";
  return current.agreement ? AGREEMENT_STAGE_STATE[current.agreement.status] : "in_progress";
};
var negotiationStageStatesOf = (offers) => {
  const [latest] = offers;
  return {
    offers: latest ? OFFER_STAGE_STATE[latest.status] : "pending",
    agreement: agreementStageStateOf(selectClaimAgreements(offers))
  };
};

// helpers/negotiation-stage-access.ts
var import_piramid_constants85 = __toESM(require_dist2());
var canReadNegotiationStage = ({
  user,
  stage
}) => !!user.abilities.can_read_claim && !!user.abilities[import_piramid_constants85.negotiationStageReadPermission[stage]];
var negotiationStageAccessOf = ({
  user,
  tabs
}) => {
  var _a;
  const isInsurer = user.type === "insurer";
  const canRead = (stage) => canReadNegotiationStage({ user, stage });
  const offers = tabs.offers && (!isInsurer || canRead("offers"));
  return {
    estimates: isInsurer && tabs.estimates && !!user.verified && canRead("estimates"),
    offers,
    agreement: isInsurer && offers && canRead("agreement") && !!((_a = user.company) == null ? void 0 : _a.agreement_automation_enabled)
  };
};

// helpers/offer-agreement-overview.ts
var import_piramid_constants86 = __toESM(require_dist2());
var isRunningJob = (job) => (job == null ? void 0 : job.status) === "pending" || (job == null ? void 0 : job.status) === "running";
var isOfferAgreementViewInFlight = (view) => {
  var _a, _b, _c, _d;
  return isRunningJob(view.job) || ((_a = view.document) == null ? void 0 : _a.status) === "rendering" || ((_b = view.dispatch) == null ? void 0 : _b.status) === "pending" && isRunningJob(view.dispatch.job) || ((_d = (_c = view.dispatch) == null ? void 0 : _c.provider_cancel) == null ? void 0 : _d.status) === "in_progress";
};
var PHASE_OF_DISPATCH = {
  draft: "dispatching",
  pending: "dispatching",
  failed: "dispatch_failed",
  started: "signing",
  completed: "completed",
  rejected: "rejected",
  expired: "expired",
  canceled: "canceled_by_provider",
  cancelled: "canceled_by_provider"
};
var offerAgreementPhaseOfStatus = (status) => PHASE_OF_DISPATCH[status];
var documentPhaseOf = (view) => {
  var _a, _b;
  if (isRunningJob(view.job)) return "generating";
  switch ((_a = view.document) == null ? void 0 : _a.status) {
    case "rendering":
      return "generating";
    case "failed":
      return "generation_failed";
    case "invalid":
      return "invalid";
    case "ready":
      return view.signature_mode === "digital" ? "dispatching" : "ready_offline";
  }
  return ((_b = view.job) == null ? void 0 : _b.status) === "failed" ? "generation_failed" : "skipped";
};
var offerAgreementPhaseOf = (offer, view) => {
  if (offer.status === "pending") return "awaiting_acceptance";
  if (isCanceledOfferStatus(offer.status) || !offer.accepted_at)
    return "canceled";
  return view.dispatch ? offerAgreementPhaseOfStatus(view.dispatch.status) : documentPhaseOf(view);
};
var toIso = (value) => value ? new Date(value).toISOString() : null;
var DOCUMENT_ERROR_PHASES = [
  "generation_failed",
  "invalid",
  "skipped"
];
var PHASES_PAST_DOCUMENT = [
  "ready_offline",
  "dispatching",
  "dispatch_failed",
  "signing",
  "completed",
  "rejected",
  "expired",
  "canceled_by_provider"
];
var PHASES_PAST_DISPATCH = [
  "signing",
  "completed",
  "rejected",
  "expired",
  "canceled_by_provider"
];
var TERMINAL_SIGNATURE_PHASES = [
  "rejected",
  "expired",
  "canceled_by_provider"
];
var documentStepState = (phase, view) => {
  var _a;
  if (phase === "generating") return "current";
  if (DOCUMENT_ERROR_PHASES.includes(phase)) return "error";
  if (PHASES_PAST_DOCUMENT.includes(phase)) return "done";
  return phase === "canceled" && ((_a = view.document) == null ? void 0 : _a.status) === "ready" ? "done" : "upcoming";
};
var dispatchStepState = (phase, dispatchedAt) => {
  if (phase === "dispatching") return "current";
  if (phase === "dispatch_failed") return "error";
  if (PHASES_PAST_DISPATCH.includes(phase)) return "done";
  return phase === "canceled" && dispatchedAt ? "done" : "upcoming";
};
var signatureStepState = (phase, dispatchedAt) => {
  if (phase === "signing" || phase === "ready_offline") return "current";
  if (phase === "completed") return "done";
  if (TERMINAL_SIGNATURE_PHASES.includes(phase)) return "error";
  return phase === "canceled" && dispatchedAt ? "error" : "upcoming";
};
var lastSignatureAt = (signers, completedAt) => {
  const [latest] = signers.flatMap((signer) => signer.submitted_at ? [signer.submitted_at] : []).sort().reverse();
  return latest ?? toIso(completedAt);
};
var signatureStepAt = (phase, offer, signers) => {
  const agreement = offer.agreement;
  switch (phase) {
    case "completed":
      return lastSignatureAt(signers, agreement == null ? void 0 : agreement.completed_at);
    case "rejected":
      return toIso(agreement == null ? void 0 : agreement.rejected_at);
    case "expired":
      return toIso(agreement == null ? void 0 : agreement.expired_at);
    case "canceled_by_provider":
      return toIso(agreement == null ? void 0 : agreement.canceled_at);
    case "canceled":
      return toIso(offer.canceled_at);
    default:
      return null;
  }
};
var buildOfferAgreementOverview = ({
  offer,
  view
}) => {
  var _a, _b, _c, _d;
  const phase = offerAgreementPhaseOf(offer, view);
  const digital = view.signature_mode === "digital";
  const dispatchedAt = ((_a = view.dispatch) == null ? void 0 : _a.dispatched_at) ?? null;
  const signers = ((_b = view.signing) == null ? void 0 : _b.signers) ?? [];
  const acceptanceState = offer.accepted_at ? "done" : phase === "awaiting_acceptance" ? "current" : "upcoming";
  const steps = [
    { key: "acceptance", state: acceptanceState, at: toIso(offer.accepted_at) },
    {
      key: "document",
      state: documentStepState(phase, view),
      at: ((_c = view.document) == null ? void 0 : _c.status) === "ready" ? toIso(view.document.rendered_at) : null
    },
    ...digital ? [
      {
        key: "dispatch",
        state: dispatchStepState(phase, dispatchedAt),
        at: dispatchedAt
      }
    ] : [],
    {
      key: "signature",
      state: signatureStepState(phase, dispatchedAt),
      at: signatureStepAt(phase, offer, signers)
    },
    ...digital ? [
      {
        key: "completed",
        state: phase === "completed" ? "done" : "upcoming",
        at: phase === "completed" ? toIso((_d = offer.agreement) == null ? void 0 : _d.completed_at) : null
      }
    ] : []
  ];
  const unsettledStep = steps.find(
    (step) => step.state === "current" || step.state === "error"
  );
  const [lastStep] = steps.slice(-1);
  const nextSignerIndex = phase === "signing" ? signers.findIndex((signer) => !signer.submitted) : -1;
  return {
    phase,
    digital,
    steps,
    signatures: signers.length ? {
      signed: signers.filter((signer) => signer.submitted).length,
      total: signers.length
    } : null,
    next_signer_index: nextSignerIndex >= 0 ? nextSignerIndex : null,
    active_step: (unsettledStep == null ? void 0 : unsettledStep.key) ?? ((lastStep == null ? void 0 : lastStep.state) === "done" ? lastStep.key : null)
  };
};
var isOfferAgreementActivityEvent = (event, offerId) => import_piramid_constants86.OFFER_AGREEMENT_ACTIVITY_EVENT_TYPES.includes(
  event.type
) && typeof event.metadata === "object" && event.metadata !== null && "offer_id" in event.metadata && event.metadata.offer_id === offerId;

// helpers/offer-agreement-provider-cancel.ts
var import_piramid_constants87 = __toESM(require_dist2());
var STATUS_OF_OUTCOME = {
  canceled: "canceled",
  already_closed: "not_needed",
  not_started: "not_needed",
  transaction_missing: "not_needed",
  connection_unavailable: "failed",
  rejected: "failed"
};
var RETRY_WINDOW_MS = import_piramid_constants87.OFFER_AGREEMENT_PROVIDER_CANCEL_RETRY_WINDOW_HOURS * 60 * 60 * 1e3;
var offerAgreementProviderCancelSummary = (job, now) => {
  const metadata = cancelOfferAgreementJobMetadata.safeParse(job.metadata);
  const outcome = metadata.success ? metadata.data.outcome ?? null : null;
  const withinRetryWindow = now.getTime() - job.created_at.getTime() < RETRY_WINDOW_MS;
  const statusOfJob = {
    completed: outcome ? STATUS_OF_OUTCOME[outcome] : "failed",
    cancelled: "not_needed",
    pending: withinRetryWindow ? "in_progress" : "failed",
    running: withinRetryWindow ? "in_progress" : "failed",
    failed: withinRetryWindow ? "in_progress" : "failed"
  };
  return {
    status: statusOfJob[job.status],
    outcome,
    provider_status: metadata.success ? metadata.data.provider_status ?? null : null,
    requested_at: job.created_at.toISOString()
  };
};

// helpers/offer-agreement-cancel-notice.ts
var offerAgreementCancelNotice = (agreement) => {
  if (!agreement) return null;
  if (agreement.status === "completed") return "keeps_signed_document";
  if (!agreement.document_id) return null;
  const startRequested = (agreement.status === "pending" || agreement.status === "failed") && !!agreement.start_requested_at;
  return agreement.status === "started" || startRequested ? "cancels_signature_request" : null;
};

// helpers/canonical-json.ts
var canonicalize = (value) => {
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value !== null && typeof value === "object") {
    const record = value;
    return Object.fromEntries(
      Object.keys(record).sort().map((key) => [key, canonicalize(record[key])])
    );
  }
  return value;
};
var canonicalJson = (value) => JSON.stringify(canonicalize(value));

// helpers/validate-agreement-template-signers.ts
var validateAgreementTemplateSigners = (content) => {
  const declared = new Set(content.signers.map((signer) => signer.key));
  const printed = new Set(
    content.blocks.flatMap(
      (block) => block.kind === "signatures" ? block.signers : []
    )
  );
  return {
    unknown_signers: Array.from(printed).filter((key) => !declared.has(key)),
    unprinted_signers: Array.from(declared).filter((key) => !printed.has(key))
  };
};

// helpers/parse-agreement-block-copy.ts
var import_zod102 = require("zod");
var AGREEMENT_BLOCK_COPY_FORMAT = "piramid.agreement-block.v1";
var agreementBlockCopySchema = import_zod102.z.object({
  format: import_zod102.z.literal(AGREEMENT_BLOCK_COPY_FORMAT),
  block: agreementBlockSchema
});
var serializeAgreementBlockCopy = (block) => JSON.stringify({ format: AGREEMENT_BLOCK_COPY_FORMAT, block });
var agreementBlockCopyRejections = [
  "unreadable",
  "kind_not_allowed"
];
var safeJson = (raw) => {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
var parseAgreementBlockCopy = (raw, {
  allowedKinds,
  id
}) => {
  if (!raw) return { rejection: "unreadable" };
  const parsed = agreementBlockCopySchema.safeParse(safeJson(raw));
  if (!parsed.success) return { rejection: "unreadable" };
  if (!allowedKinds.includes(parsed.data.block.kind))
    return { rejection: "kind_not_allowed" };
  return { block: { ...parsed.data.block, id } };
};

// contracts/agreement-template-clone.contract.ts
var import_piramid_constants88 = __toESM(require_dist2());
var import_zod103 = require("zod");
var agreementClonePlanRequestBody = import_zod103.z.object({
  target_company_id: import_zod103.z.string().min(1),
  name: import_zod103.z.string().trim().min(1).max(120).optional(),
  source_version_id: import_zod103.z.string().min(1).optional(),
  include_rules: import_zod103.z.boolean().default(false)
});
var agreementCloneMappingEntry = import_zod103.z.object({
  source: import_zod103.z.enum(import_piramid_constants88.agreementRuleOptionSources),
  value: import_zod103.z.string().min(1),
  target_value: import_zod103.z.string().min(1)
});
var cloneAgreementTemplateRequestBody = agreementClonePlanRequestBody.extend({
  description: import_zod103.z.string().trim().max(500).nullable().optional(),
  /** Una entrada por referencia del plan; la que falte frena la clonación. */
  mapping: import_zod103.z.array(agreementCloneMappingEntry).default([]),
  /** Claves dinámicas que el operador asume como hueco en el destino. */
  accept_missing_variables: import_zod103.z.array(import_zod103.z.string().min(1)).default([])
});

// helpers/remap-agreement-conditions.ts
var import_piramid_constants89 = __toESM(require_dist2());
var referencesByName = (source) => source === "offer_variable" || source === "acceptance_variable";
var remapValue = (value, translate7) => {
  const unmapped = [];
  const one = (entry) => {
    if (typeof entry !== "string") return entry;
    const target = translate7(entry);
    if (target === null) unmapped.push(entry);
    return target ?? entry;
  };
  return Array.isArray(value) ? { value: value.map((entry) => one(entry)), unmapped } : { value: one(value), unmapped };
};
var remapAgreementConditions = (conditions, mapping) => {
  const unmapped = [];
  const remapCondition = (condition) => {
    const source = (0, import_piramid_constants89.agreementRuleOptionSourceOf)(condition.attribute);
    if (!source) return condition;
    const entries = mapping[source];
    const translate7 = (entry) => (entries == null ? void 0 : entries.get(entry)) ?? null;
    if (referencesByName(source)) {
      if (!condition.name) return condition;
      const target = translate7(condition.name);
      if (target === null) unmapped.push({ source, value: condition.name });
      return { ...condition, name: target ?? condition.name };
    }
    const remapped = remapValue(condition.value, translate7);
    unmapped.push(...remapped.unmapped.map((value) => ({ source, value })));
    return { ...condition, value: remapped.value };
  };
  return { conditions: { all: conditions.all.map(remapCondition) }, unmapped };
};

// helpers/free-agreement-template-name.ts
var TEMPLATE_NAME_MAX = 120;
var COPY_SUFFIX_LIMIT = 50;
var suffixOf = (attempt) => attempt === 1 ? " (copia)" : ` (copia ${attempt})`;
var freeAgreementTemplateName = (name, taken) => {
  if (!taken.has(name)) return name;
  const base = name.slice(
    0,
    TEMPLATE_NAME_MAX - suffixOf(COPY_SUFFIX_LIMIT).length
  );
  for (let attempt = 1; attempt <= COPY_SUFFIX_LIMIT; attempt++) {
    const candidate = `${base}${suffixOf(attempt)}`;
    if (!taken.has(candidate)) return candidate;
  }
  return null;
};

// helpers/evaluate-agreement-rules.ts
var resultOf = (conditions) => {
  if (conditions.some((condition) => condition.result === "false"))
    return "no_match";
  return conditions.some((condition) => condition.result === "undetermined") ? "undetermined" : "match";
};
var evaluateAgreementRule = (rule, context) => {
  const conditions = rule.conditions.all.map(
    (condition) => evaluateAgreementCondition(condition, context)
  );
  return {
    rule_id: rule.id,
    name: rule.name,
    priority: rule.priority,
    result: resultOf(conditions),
    conditions
  };
};
var undeterminedReason = (evaluation) => {
  const reasons = evaluation.conditions.filter((condition) => condition.result === "undetermined").map((condition) => condition.reason);
  if (reasons.length === 0) return "missing_context_data";
  if (reasons.every((reason) => reason === "pending_acceptance"))
    return "pending_acceptance";
  return reasons.every(
    (reason) => reason === "pending_offer" || reason === "pending_acceptance"
  ) ? "pending_offer" : "missing_context_data";
};
var byAgreementRulePriority = (left, right) => left.priority === right.priority ? left.id.localeCompare(right.id) : left.priority - right.priority;
var selectAgreementRule = (rules, context) => {
  const ordered = [...rules].sort(byAgreementRulePriority);
  const evaluations = ordered.map(
    (rule) => evaluateAgreementRule(rule, context)
  );
  const matched = evaluations.findIndex(
    (evaluation) => evaluation.result === "match"
  );
  const blocked = evaluations.findIndex(
    (evaluation) => evaluation.result === "undetermined"
  );
  const empty = { selected: null, evaluations, warnings: [] };
  if (blocked >= 0 && (matched < 0 || blocked < matched))
    return {
      ...empty,
      outcome: "undetermined",
      reason: undeterminedReason(evaluations[blocked])
    };
  if (matched < 0)
    return {
      ...empty,
      outcome: "no_match",
      reason: rules.length === 0 ? "no_rules_configured" : "no_rule_matched"
    };
  const selected = ordered[matched];
  const alsoMatched = evaluations.filter(
    (evaluation) => evaluation.result === "match" && evaluation.rule_id !== selected.id
  ).map((evaluation) => evaluation.rule_id);
  return {
    outcome: "selected",
    reason: null,
    selected,
    evaluations,
    warnings: alsoMatched.length > 0 ? [
      {
        code: "multiple_rules_matched",
        detail: { selected_id: selected.id, also_matched: alsoMatched }
      }
    ] : []
  };
};

// helpers/select-agreement-signature-rule.ts
var appliesTo = (rule, templateId) => rule.template_ids === null || templateId !== null && rule.template_ids.includes(templateId);
var skipped2 = (rule) => ({
  rule_id: rule.id,
  name: rule.name,
  priority: rule.priority,
  result: "no_match",
  conditions: [],
  in_scope: false
});
var selectAgreementSignatureRule = (rules, context, templateId) => {
  const selection = selectAgreementRule(
    rules.filter((rule) => appliesTo(rule, templateId)),
    context
  );
  const evaluations = [
    ...selection.evaluations.map((evaluation) => ({
      ...evaluation,
      in_scope: true
    })),
    ...rules.filter((rule) => !appliesTo(rule, templateId)).map(skipped2)
  ].sort(
    (left, right) => byAgreementRulePriority(
      { id: left.rule_id, priority: left.priority },
      { id: right.rule_id, priority: right.priority }
    )
  );
  const shared = { evaluations, warnings: selection.warnings };
  if (selection.selected)
    return {
      ...shared,
      outcome: "selected",
      reason: null,
      method: selection.selected.method,
      rule: {
        id: selection.selected.id,
        name: selection.selected.name,
        priority: selection.selected.priority
      }
    };
  if (selection.outcome === "undetermined")
    return {
      ...shared,
      outcome: "undetermined",
      reason: selection.reason,
      method: null,
      rule: null
    };
  return {
    ...shared,
    outcome: "unresolved",
    reason: rules.length === 0 ? "no_rules_configured" : "no_rule_matched",
    method: null,
    rule: null
  };
};

// helpers/find-agreement-rule-conflict.ts
var agreementConditionsFingerprint = (conditions) => canonicalJson(
  [...conditions.all].map((condition) => canonicalJson(condition)).sort((left, right) => left.localeCompare(right))
);
var identityOf = (rule) => canonicalJson({
  conditions: agreementConditionsFingerprint(rule.conditions),
  scope: rule.scope ? [...rule.scope].sort() : null
});
var findAgreementRuleConflict = (siblings, candidate) => {
  if (siblings.some((rule) => rule.priority === candidate.priority))
    return { kind: "priority_taken", priority: candidate.priority };
  const identity = identityOf(candidate);
  const twin = siblings.find(
    (rule) => rule.decision !== candidate.decision && identityOf(rule) === identity
  );
  return twin ? { kind: "twin", rule_id: twin.id } : null;
};

// helpers/build-agreement-plan.ts
var stageOf = (facts) => facts.acceptance_known ? "accept" : "send";
var resolveParty = (party, parties, heirIndex) => {
  switch (party) {
    case "victim":
      return { name: parties.victim.full_name, email: parties.victim.email };
    case "claimant":
      return parties.claimant ? {
        name: parties.claimant.person.full_name,
        email: parties.claimant.person.email
      } : { reason: "no_claimant" };
    case "lawyer":
      return parties.lawyer ? {
        name: parties.lawyer.person.full_name,
        email: parties.lawyer.person.email
      } : { reason: "no_lawyer" };
    case "heirs": {
      const heir = parties.heirs[heirIndex];
      return heir ? { name: heir.person.full_name, email: heir.person.email } : { reason: "no_heirs" };
    }
    case "company_sender":
      return { reason: "company_sender_unavailable" };
  }
};
var emailRequired = (method) => method === "digital";
var toRecipient = (signer, resolved2, index, method) => {
  const base = {
    signer_key: signer.key,
    label: signer.label,
    party: signer.party,
    index,
    optional: signer.optional
  };
  if ("reason" in resolved2)
    return {
      ...base,
      name: null,
      email: null,
      status: "missing",
      reason: resolved2.reason
    };
  const gap = !resolved2.name ? "no_name" : emailRequired(method) && !resolved2.email ? "no_email" : null;
  return {
    ...base,
    name: resolved2.name,
    email: resolved2.email,
    status: gap ? "missing" : "resolved",
    reason: gap
  };
};
var buildRecipients = (template, overrides, parties, method) => {
  let heirIndex = 0;
  return template.signers.map((signer, position) => {
    const override = overrides.find(
      (recipient) => recipient.signer_key === signer.key
    );
    const resolved2 = resolveParty(
      signer.party,
      parties,
      signer.party === "heirs" ? heirIndex++ : 0
    );
    return toRecipient(signer, resolved2, (override == null ? void 0 : override.index) ?? position, method);
  }).sort((left, right) => left.index - right.index);
};
var gapsOf = (template, variables, recipients, signature, stage) => [
  // At `send` a key the claimant fills later is pending, not a gap of the plan.
  ...resolveAgreementTemplateGaps(template.variables, variables, { stage }).filter((gap) => gap.blocking).map(
    (gap) => ({
      kind: "variable",
      key: gap.key,
      reason: gap.reason ?? gap.status
    })
  ),
  ...recipients.filter(
    (recipient) => recipient.status === "missing" && !recipient.optional
  ).map(
    (recipient) => ({
      kind: "signer",
      key: recipient.signer_key,
      reason: recipient.reason ?? "unresolved"
    })
  ),
  // Waiting for the offer or the acceptance is not a gap; no rule ever applying is.
  ...signature.outcome === "unresolved" ? [
    {
      kind: "signature",
      key: "method",
      reason: signature.reason ?? "no_rule_matched"
    }
  ] : []
];
var undecided = { rule: null, template: null, recipients: [], missing: [] };
var unresolvedSignature = (reason) => ({
  method: null,
  outcome: "unresolved",
  reason,
  rule: null,
  evaluations: []
});
var toAgreementSignatureDecision = ({
  warnings: _warnings,
  ...decision
}) => decision;
var disabledAgreementPlan = (facts, meta) => ({
  ...undecided,
  stage: stageOf(facts),
  outcome: "disabled",
  reason: "automation_disabled",
  signature: unresolvedSignature("automation_disabled"),
  warnings: [],
  evaluations: [],
  meta
});
var buildAgreementPlan = ({
  selection,
  signature,
  template,
  facts,
  variables,
  warnings,
  meta
}) => {
  const decision = toAgreementSignatureDecision(signature);
  const shared = {
    stage: stageOf(facts),
    signature: decision,
    evaluations: selection.evaluations,
    warnings: [...warnings, ...selection.warnings, ...signature.warnings],
    meta
  };
  if (!selection.selected)
    return {
      ...undecided,
      ...shared,
      outcome: selection.outcome === "undetermined" ? "undetermined" : "no_match",
      reason: selection.reason
    };
  const rule = {
    id: selection.selected.id,
    name: selection.selected.name,
    priority: selection.selected.priority
  };
  if (!template)
    return {
      ...undecided,
      ...shared,
      outcome: "blocked",
      reason: "template_not_published",
      rule
    };
  const recipients = buildRecipients(
    template,
    selection.selected.recipients,
    facts.parties,
    decision.method
  );
  return {
    ...shared,
    outcome: "selected",
    reason: null,
    rule,
    template: {
      id: template.id,
      name: template.name,
      version_id: template.version_id,
      version: template.version
    },
    recipients,
    missing: gapsOf(template, variables, recipients, decision, shared.stage)
  };
};

// helpers/agreement-rule.fixture.ts
var import_piramid_constants90 = __toESM(require_dist2());
var agreementCondition = (attribute, operator, value, name = null) => ({ attribute, operator, value, name });
var buildAgreementRule = (overrides = {}) => ({
  id: "agreementrule_01",
  name: "Conformidad est\xE1ndar",
  priority: 10,
  template_id: "agreementtempl_01",
  conditions: { all: [] },
  recipients: [],
  ...overrides
});
var buildAgreementSignatureRule = (overrides = {}) => ({
  id: "agreementsigrule_01",
  name: "Firma digital",
  priority: 90,
  method: "digital",
  conditions: { all: [] },
  template_ids: null,
  ...overrides
});
var buildAgreementFixtureRuleContext = (subject) => buildAgreementRuleContext(
  subject,
  deriveAgreementFacts(subject, { now: AGREEMENT_FIXTURE_NOW })
);
var buildAgreementFixtureResolution = (scenario) => {
  const subject = agreementScenarios[scenario]();
  const facts = deriveAgreementFacts(subject, { now: AGREEMENT_FIXTURE_NOW });
  const now = AGREEMENT_FIXTURE_NOW.toISOString();
  const { variables } = buildAgreementVariableValues(subject, facts, {
    locale: import_piramid_constants90.DEFAULT_LOCALE,
    timezone: import_piramid_constants90.DEFAULT_TIMEZONE,
    now
  });
  return {
    subject,
    facts,
    context: buildAgreementRuleContext(subject, facts),
    variables,
    meta: {
      catalog_version: import_piramid_constants90.AGREEMENT_CATALOG_VERSION,
      format_version: import_piramid_constants90.AGREEMENT_FORMAT_VERSION,
      locale: import_piramid_constants90.DEFAULT_LOCALE,
      timezone: import_piramid_constants90.DEFAULT_TIMEZONE,
      currency: facts.currency,
      currency_source: facts.currency_source,
      now,
      age_reference_date: now,
      acceptance_source: subject.acceptance.source,
      bindings_used: Object.fromEntries(
        Object.entries(import_piramid_constants90.defaultAgreementVariableBindings).map(
          ([concept, names]) => [concept, [...names]]
        )
      )
    }
  };
};

// helpers/parse-rich-text.ts
var richTextMarks = ["bold", "italic", "underline"];
var DELIMITERS = [
  { token: "__", mark: "underline" },
  { token: "*", mark: "bold" },
  { token: "_", mark: "italic" }
];
var MARKER = /[*_]/;
var NO_MARKS = {
  bold: false,
  italic: false,
  underline: false
};
var WORD_CHARACTER = /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/;
var isWordCharacter = (char) => char !== void 0 && WORD_CHARACTER.test(char);
var isWhitespace = (char) => char !== void 0 && /\s/.test(char);
var findClosing = (text2, from, token) => {
  for (let index = from + 1; index <= text2.length - token.length; index += 1) {
    if (text2.slice(index, index + token.length) !== token) continue;
    if (isWhitespace(text2[index - 1])) continue;
    const after = text2[index + token.length];
    if (isWordCharacter(after) || after === token[0]) continue;
    return index;
  }
  return -1;
};
var openRunAt = (text2, index, active) => {
  for (const { token, mark } of DELIMITERS) {
    if (active[mark]) continue;
    if (text2.slice(index, index + token.length) !== token) continue;
    const before = text2[index - 1];
    const first = text2[index + token.length];
    if (isWordCharacter(before) || before === token[0]) continue;
    if (first === void 0 || isWhitespace(first) || first === token[0])
      continue;
    const closing = findClosing(text2, index + token.length, token);
    if (closing < 0) continue;
    return {
      mark,
      content: text2.slice(index + token.length, closing),
      end: closing + token.length
    };
  }
  return null;
};
var appendSpans = (text2, active, spans) => {
  let plain = "";
  let index = 0;
  const flushPlain = () => {
    if (plain) spans.push({ text: plain, ...active });
    plain = "";
  };
  while (index < text2.length) {
    const run = openRunAt(text2, index, active);
    if (!run) {
      plain += text2[index];
      index += 1;
      continue;
    }
    flushPlain();
    appendSpans(run.content, { ...active, [run.mark]: true }, spans);
    index = run.end;
  }
  flushPlain();
};
var parseRichText = (text2) => {
  if (!MARKER.test(text2)) return text2 ? [{ text: text2, ...NO_MARKS }] : [];
  const spans = [];
  appendSpans(text2, NO_MARKS, spans);
  return spans;
};

// contracts/offer-preview.contract.ts
var import_zod104 = require("zod");
var offerWizardModes = ["guided", "legacy"];
var offerWizardLegacyReasons = [
  "automation_disabled",
  "offer_message_missing",
  "offer_message_not_published"
];
var previewOfferRequestBody = import_zod104.z.object({
  /** null = decidir el modo con el reclamo solo, antes de tipear los términos. */
  terms: offerTermsSchema.nullable().default(null),
  /** Motivo para el reclamante: la carta lo imprime con `offer.public_reason`. */
  public_reason: import_zod104.z.string().max(500).nullable().default(null)
});
var backofficePreviewOfferRequestBody = previewOfferRequestBody.extend(
  { claim_id: import_zod104.z.string().min(1) }
);

// contracts/openai-decision.contract.ts
var import_zod105 = require("zod");
var emailNameMatchInputSchema = import_zod105.z.object({
  full_name: import_zod105.z.string().trim().min(1).max(200),
  email: import_zod105.z.string().trim().email().max(320)
});
var openAIDecisionRequestBody = import_zod105.z.discriminatedUnion("query", [
  import_zod105.z.object({
    query: import_zod105.z.literal("email_name_match"),
    input: emailNameMatchInputSchema
  })
]);

// contracts/offer-agreement-document.contract.ts
var import_piramid_constants91 = __toESM(require_dist2());
var import_zod106 = require("zod");
var agreementDocumentDiagnosticsSchema = import_zod106.z.object({
  resolution: import_zod106.z.enum(import_piramid_constants91.agreementDocumentResolutions),
  fallback: import_zod106.z.enum(import_piramid_constants91.agreementDocumentResolutionFallbacks).nullable(),
  missing: import_zod106.z.array(agreementTemplateMissingSchema),
  condition_gaps: import_zod106.z.array(agreementTemplateConditionGapSchema),
  syntax_errors: import_zod106.z.array(agreementTemplateSyntaxErrorSchema),
  warnings: import_zod106.z.array(agreementWarningSchema),
  missing_anchors: import_zod106.z.array(import_zod106.z.string()),
  signature: import_zod106.z.object({
    source: import_zod106.z.enum(import_piramid_constants91.agreementDocumentSignatureSources),
    decision: agreementSignatureDecisionSchema
  })
});

// contracts/offer-agreement-transition.contract.ts
var import_database46 = __toESM(require_index_browser4());
var import_zod107 = require("zod");
var commonWebhookPayloadSchema = import_zod107.z.object({
  created: import_zod107.z.coerce.date(),
  id: import_zod107.z.string()
});
var transactionCreatedWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_created"),
  data: import_zod107.z.object({
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    created_by: import_zod107.z.object({
      id: import_zod107.z.string(),
      email: import_zod107.z.string().email()
    })
  })
});
var transactionStartedWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_started"),
  data: import_zod107.z.object({
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    started_by: import_zod107.z.object({
      id: import_zod107.z.string(),
      email: import_zod107.z.string().email()
    })
  })
});
var recipientSubmittedWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("recipient_submitted"),
  data: import_zod107.z.object({
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    recipient: import_zod107.z.object({
      id: import_zod107.z.string(),
      email: import_zod107.z.string().email(),
      name: import_zod107.z.string(),
      role: import_zod107.z.string(),
      submitted_at: import_zod107.z.coerce.date().nullish()
    })
  })
});
var transactionRejectedWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_rejected"),
  data: import_zod107.z.object({
    rejected_reason: import_zod107.z.string().nullish(),
    rejected_at: import_zod107.z.coerce.date().nullish(),
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    rejected_by: import_zod107.z.object({
      id: import_zod107.z.string(),
      email: import_zod107.z.string().email(),
      name: import_zod107.z.string(),
      role: import_zod107.z.string()
    })
  })
});
var transactionCompletedWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_completed"),
  data: import_zod107.z.object({
    completed_at: import_zod107.z.coerce.date(),
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    recipients: import_zod107.z.array(
      import_zod107.z.object({
        id: import_zod107.z.string(),
        email: import_zod107.z.string().email(),
        name: import_zod107.z.string(),
        role: import_zod107.z.string(),
        submitted_at: import_zod107.z.coerce.date().nullish()
      })
    ),
    sealed_documents: import_zod107.z.array(
      import_zod107.z.object({
        id: import_zod107.z.string(),
        name: import_zod107.z.string(),
        document: import_zod107.z.object({
          id: import_zod107.z.string(),
          name: import_zod107.z.string()
        }),
        url: import_zod107.z.string().url(),
        created_at: import_zod107.z.coerce.date()
      })
    )
  })
});
var transactionExpiredWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_expired"),
  data: import_zod107.z.object({
    id: import_zod107.z.string(),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    expiration_days: import_zod107.z.coerce.number().nullish(),
    expired_at: import_zod107.z.coerce.date()
  })
});
var transactionCancelledWebhookPayloadSchema = commonWebhookPayloadSchema.extend({
  type: import_zod107.z.literal("transaction_cancelled").describe("El tipo de evento"),
  data: import_zod107.z.object({
    id: import_zod107.z.string().describe("El id de la transacci\xF3n"),
    status: import_zod107.z.nativeEnum(import_database46.OfferAgreementStatus),
    cancelled_at: import_zod107.z.coerce.date(),
    cancelled_reason: import_zod107.z.string()
  })
});
var offerAgreementTransitionBodySchema = import_zod107.z.discriminatedUnion("type", [
  recipientSubmittedWebhookPayloadSchema,
  transactionCreatedWebhookPayloadSchema,
  transactionStartedWebhookPayloadSchema,
  transactionRejectedWebhookPayloadSchema,
  transactionCompletedWebhookPayloadSchema,
  transactionExpiredWebhookPayloadSchema,
  transactionCancelledWebhookPayloadSchema
]);
var offerAgreementTransitionEnvelopeSchema = import_zod107.z.object({
  id: import_zod107.z.string().min(1).nullish(),
  type: import_zod107.z.string().min(1).nullish()
}).passthrough();

// contracts/acceptance-payee.contract.ts
var import_database47 = __toESM(require_index_browser4());
var import_piramid_constants92 = __toESM(require_dist2());
var import_zod108 = require("zod");
var acceptancePayeeCandidateSchema = import_zod108.z.object({
  relation: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeRelations),
  full_name: import_zod108.z.string(),
  /** Solo dígitos; `null` cuando la persona no tiene documento cargado. */
  identification: import_zod108.z.string().nullable(),
  /** `null` en un `PersonParent`, que guarda el documento sin tipo. */
  identification_type: import_zod108.z.nativeEnum(import_database47.IdentificationTypes).nullable()
});
var acceptancePayeeResolutionSchema = import_zod108.z.object({
  case: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeCases),
  candidates: import_zod108.z.array(acceptancePayeeCandidateSchema),
  /** Presente ⇒ el reclamo no alcanza para decidir quién cobra. */
  blocker: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeBlockers).nullable()
});
var acceptanceLawyerResolutionSchema = import_zod108.z.object({
  present: import_zod108.z.boolean(),
  kind: import_zod108.z.enum(import_piramid_constants92.agreementLawyerKinds).nullable(),
  full_name: import_zod108.z.string().nullable(),
  /** Solo dígitos, para precargar el campo. `null` si el abogado no tiene CUIT. */
  cuit: import_zod108.z.string().nullable(),
  blocker: import_zod108.z.enum(import_piramid_constants92.acceptanceLawyerBlockers).nullable()
});
var acceptanceCheckSchema = import_zod108.z.object({
  status: import_zod108.z.enum(import_piramid_constants92.acceptanceCheckStatuses),
  code: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeIssueCodes).nullable()
});
var acceptanceDeclaredIdentitySchema = import_zod108.z.object({
  identification: import_zod108.z.string().nullable(),
  cuit: import_zod108.z.string().nullable(),
  lawyer_cuit: import_zod108.z.string().nullable()
});
var acceptanceIdentityVerdictSchema = import_zod108.z.object({
  payee: acceptanceCheckSchema,
  lawyer: acceptanceCheckSchema
});
var acceptancePayeeContextCandidateSchema = import_zod108.z.object({
  relation: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeRelations),
  full_name: import_zod108.z.string(),
  identification_masked: import_zod108.z.string().nullable()
});
var acceptancePayeeContextSchema = import_zod108.z.object({
  case: import_zod108.z.enum(import_piramid_constants92.acceptancePayeeCases),
  /** Quién eligió el tramitador que cobra; `null` en ofertas sin elección. */
  payee: import_zod108.z.enum(import_piramid_constants92.offerPayees).nullable(),
  candidates: import_zod108.z.array(acceptancePayeeContextCandidateSchema),
  /** El documento a precargar cuando hay un único candidato con documento. */
  prefilled_identification: import_zod108.z.string().nullable(),
  /** El CUIT del apoderado cuando cobra él: se precarga y no se edita. */
  prefilled_cuit: import_zod108.z.string().nullable(),
  lawyer: acceptanceLawyerResolutionSchema.nullable()
});
var validateAcceptancePayeeRequestBody = import_zod108.z.object({
  identification: import_zod108.z.string().nullish(),
  cuit: import_zod108.z.string().nullish(),
  lawyer_cuit: import_zod108.z.string().nullish()
});

// helpers/split-agreement-placeholders.ts
var import_piramid_constants93 = __toESM(require_dist2());
var splitAgreementPlaceholders = (text2) => {
  const segments = [];
  const pattern = new RegExp(import_piramid_constants93.AGREEMENT_PLACEHOLDER_PATTERN.source, "g");
  let cursor = 0;
  let match83;
  while ((match83 = pattern.exec(text2)) !== null) {
    if (match83.index > cursor)
      segments.push({ kind: "text", text: text2.slice(cursor, match83.index) });
    segments.push({
      kind: "placeholder",
      class: match83[1],
      key: match83[2]
    });
    cursor = match83.index + match83[0].length;
  }
  if (cursor < text2.length)
    segments.push({ kind: "text", text: text2.slice(cursor) });
  return segments;
};
var hasAgreementPlaceholders = (text2) => new RegExp(import_piramid_constants93.AGREEMENT_PLACEHOLDER_PATTERN.source).test(text2);

// helpers/to-document-variant.ts
var import_piramid_constants94 = __toESM(require_dist2());
var toDocumentVariant = (value) => import_piramid_constants94.documentVariants.find((candidate) => candidate === value) ?? "default";

// helpers/compile-agreement-message.ts
var renderAgreementMessageText = (blocks) => blocks.flatMap((block) => {
  switch (block.kind) {
    case "title":
      return [block.text.toUpperCase()];
    case "paragraph":
      return [block.text];
    case "clause":
      return [
        `${block.ordinal}${block.title ? ` \u2014 ${block.title}` : ""}: ${block.text}`
      ];
    case "key_values":
      return [
        block.rows.map((row) => `${row.label}: ${row.value}`).join("\n")
      ];
    case "signatures":
    case "page_break":
      return [];
  }
}).join("\n\n");
var compileAgreementMessage = ({
  content,
  variables,
  ruleContext,
  stage = "send",
  placeholders = "none"
}) => {
  const compiled = compileAgreementTemplate({
    content: { blocks: content.blocks, signers: [] },
    variables,
    ruleContext,
    stage,
    placeholders
  });
  return { ...compiled, text: renderAgreementMessageText(compiled.blocks) };
};

// helpers/build-offer-variable-rows.ts
var import_piramid_constants95 = __toESM(require_dist2());
var buildOfferVariableRows = ({
  fields: fields7,
  amount,
  currency,
  validateBankData,
  payee,
  createGuid
}) => {
  const requirements = fields7.map((field) => ({
    ...field,
    guid: createGuid()
  }));
  const guidOf = (key) => {
    var _a;
    return ((_a = requirements.find((requirement) => requirement.key === key)) == null ? void 0 : _a.guid) ?? null;
  };
  const acceptanceDefinitions = requirements.map(
    (requirement) => {
      const field = (0, import_piramid_constants95.offerAcceptanceField)(requirement.key);
      return {
        guid: requirement.guid,
        name: requirement.name,
        type: requirement.type,
        determination: "runtime",
        required: requirement.required,
        min_length: field.min_length,
        max_length: field.max_length,
        numeric_format: null,
        numeric_format_currency: null
      };
    }
  );
  const amountGuid = createGuid();
  const amountDefinition = {
    guid: amountGuid,
    name: import_piramid_constants95.OFFER_AMOUNT_VARIABLE_NAME,
    type: "numeric",
    determination: "compile_time",
    required: true,
    min_length: null,
    max_length: null,
    numeric_format: true,
    numeric_format_currency: currency
  };
  const bankPairs = [
    [guidOf("cbu"), guidOf("cuit")],
    [guidOf("lawyer_cbu"), guidOf("lawyer_cuit")]
  ];
  const validations = validateBankData ? bankPairs.flatMap(
    ([cbu, cuit]) => cbu && cuit ? [
      {
        guid: createGuid(),
        validation: "interbanking",
        references: { cbu, cuit }
      }
    ] : []
  ) : [];
  return {
    requirements: {
      version: import_piramid_constants95.OFFER_ACCEPTANCE_REQUIREMENTS_VERSION,
      payment_method: "transfer",
      fields: requirements,
      payee
    },
    definitions: [amountDefinition, ...acceptanceDefinitions],
    validations,
    values: [
      {
        guid: amountGuid,
        name: import_piramid_constants95.OFFER_AMOUNT_VARIABLE_NAME,
        type: "numeric",
        value: String(amount)
      }
    ]
  };
};

// helpers/resolve-offer-acceptance-requirements.ts
var import_piramid_constants96 = __toESM(require_dist2());
var resolveOfferAcceptanceRequirements = ({
  hasLawyer,
  terms,
  bindings,
  requestIdentification
}) => {
  const nameOf = (field) => field.concept ? bindings[field.concept][0] ?? field.key : field.name;
  const keys = [
    ...requestIdentification ? ["identification"] : [],
    "cbu",
    "cuit",
    "cbu_proof",
    ...hasLawyer ? ["lawyer_cbu", "lawyer_cuit", "lawyer_cbu_proof"] : [],
    ...terms.fee_percentage !== null ? ["fee_invoice"] : []
  ];
  return import_piramid_constants96.OFFER_ACCEPTANCE_FIELDS.filter(
    (field) => keys.some((key) => key === field.key)
  ).map((field) => ({
    key: field.key,
    name: nameOf(field),
    type: field.type,
    required: field.required
  }));
};
var toPreviewAcceptanceRequirements = (fields7, payee) => ({
  version: import_piramid_constants96.OFFER_ACCEPTANCE_REQUIREMENTS_VERSION,
  payment_method: "transfer",
  fields: fields7.map((field) => ({ ...field, guid: field.key })),
  payee
});

// helpers/resolve-offer-terms-options.ts
var import_piramid_constants97 = __toESM(require_dist2());
var pick = (override, fallback) => override && override.length > 0 ? [...override] : [...fallback];
var resolveOfferTermsOptions = (override) => ({
  installment_options: pick(
    override == null ? void 0 : override.installment_options,
    import_piramid_constants97.OFFER_INSTALLMENT_OPTIONS
  ),
  fee_percentage_options: pick(
    override == null ? void 0 : override.fee_percentage_options,
    import_piramid_constants97.OFFER_FEE_PERCENTAGE_OPTIONS
  ),
  payment_days_options: pick(
    override == null ? void 0 : override.payment_days_options,
    import_piramid_constants97.OFFER_PAYMENT_DAYS_OPTIONS
  )
});
var preferred = (value, options) => options.includes(value) ? value : null;
var defaultOfferTerms = (options, { feesApplicable }) => ({
  payment_days: preferred(
    import_piramid_constants97.OFFER_DEFAULT_PAYMENT_DAYS,
    options.payment_days_options
  ),
  fee_percentage: feesApplicable ? preferred(import_piramid_constants97.OFFER_DEFAULT_FEE_PERCENTAGE, options.fee_percentage_options) : null
});
var validateOfferTerms = (terms, options, {
  feesApplicable,
  payeeSelectable
}) => {
  const issues = [];
  if (!options.installment_options.includes(terms.installments))
    issues.push("installments_not_allowed");
  if (!options.payment_days_options.includes(terms.payment_days))
    issues.push("payment_days_not_allowed");
  if (feesApplicable && terms.fee_percentage === null)
    issues.push("fee_percentage_required");
  if (!feesApplicable && terms.fee_percentage !== null)
    issues.push("fee_percentage_not_applicable");
  if (feesApplicable && terms.fee_percentage !== null && !options.fee_percentage_options.includes(terms.fee_percentage))
    issues.push("fee_percentage_not_allowed");
  if (payeeSelectable && terms.payee === null) issues.push("payee_required");
  if (!payeeSelectable && terms.payee !== null)
    issues.push("payee_not_applicable");
  return issues;
};

// helpers/resolve-offer-wizard-mode.ts
var resolveOfferWizardMode = ({
  enabled,
  templateId,
  publishedVersionId
}) => {
  if (!enabled) return { mode: "legacy", reason: "automation_disabled" };
  if (!templateId) return { mode: "legacy", reason: "offer_message_missing" };
  if (!publishedVersionId)
    return { mode: "legacy", reason: "offer_message_not_published" };
  return { mode: "guided", reason: null };
};

// helpers/agreement-message.fixture.ts
var offerMessageSampleTemplate = {
  layout_variant: "default",
  signers: [],
  blocks: [
    {
      id: "ofrecimiento",
      kind: "paragraph",
      text: "De nuestra mayor consideraci\xF3n: sin que la presente signifique reconocimiento de hechos, derecho ni responsabilidad alguna por parte de {{company.name}} respecto de nuestro asegurado, propietario y/o conductor del veh\xEDculo amparado, le informamos que la compa\xF1\xEDa ha dispuesto ofrecer la suma de {{offer.amount}} ({{offer.amount_in_words}})[[#if {{offer.installments}}]], pagaderos en {{offer.installments}} cuotas iguales, mensuales y consecutivas de {{payment.installment_amount}} cada una, siendo la primera a {{offer.payment_days}} d\xEDas de firmada la correspondiente conformidad[[else]], pagaderos a {{offer.payment_days}} d\xEDas de firmada la correspondiente conformidad[[/if]][[#if {{offer.fee_percentage}}]], m\xE1s el {{offer.fee_percentage}} de honorarios ({{payment.fees_amount}}) pagaderos a 30 d\xEDas de firmada la conformidad[[/if]] mediante transferencia bancaria."
    },
    {
      id: "cierre",
      kind: "paragraph",
      text: 'Para acceder a esta indemnizaci\xF3n, utilice el bot\xF3n "Aceptar" y dentro de las pr\xF3ximas 48 hs recibir\xE1 en su correo electr\xF3nico la conformidad que deber\xE1 firmar para que podamos ingresar los pagos. Saludamos atentamente.'
    }
  ]
};
var buildOfferMessageSample = (scenario = "guidedSinglePayment") => {
  const { variables, context } = buildAgreementFixtureResolution(scenario);
  return compileAgreementMessage({
    content: offerMessageSampleTemplate,
    variables,
    ruleContext: context,
    stage: "send"
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ACCEPTANCE_PROBABILITY_BAND_THRESHOLDS,
  ACCEPTANCE_PROBABILITY_BASE_SCORE,
  ACCEPTANCE_PROBABILITY_FACTOR_TABLES,
  ACCEPTANCE_PROBABILITY_MAX,
  ACCEPTANCE_PROBABILITY_MIN,
  ACCEPTANCE_PROBABILITY_MODEL_VERSION,
  ACCEPTED_ORDER_STATUSES,
  AGREEMENT_BLOCK_COPY_FORMAT,
  AGREEMENT_FIXTURE_NOW,
  AGREEMENT_RULE_ATTRIBUTE_READERS,
  AUTOINSPECTOR_CONFIGURABLE_USE_CASES,
  AUTOINSPECTOR_CREATE_STAGE,
  AUTOINSPECTOR_FIELD_SOURCES,
  AUTOINSPECTOR_INPUT_TYPES,
  AUTOINSPECTOR_INSPECTION_RESULT_FILTERS,
  AUTOINSPECTOR_REPORT_STATUSES,
  AUTOINSPECTOR_USE_CASES,
  AUTOINSPECTOR_USE_CASE_KEYS,
  BLOCKING_CLAIMANT_VICTIM_VIOLATIONS,
  BLOCKING_OWNERSHIP_ACCEPTANCE_VIOLATIONS,
  CBU_LENGTH,
  CLAIM_ATTEMPT_CATEGORIES,
  CLAIM_ATTEMPT_PEOPLE_OUTCOMES,
  CLAIM_DISTRIBUTION_CATEGORIES,
  CLAIM_DOCUMENT_ANALYSIS_FILE_FIELD_SOURCES,
  CLAIM_DOCUMENT_ANALYSIS_INFERENCES,
  CLAIM_DOCUMENT_ANALYSIS_RESULTS,
  CLAIM_DOCUMENT_ANALYSIS_VALUE_FIELD_SOURCES,
  CUIT_LENGTH,
  DAY_TYPES,
  DEFAULT_CUIT_LENGTH,
  DEFAULT_DNI_LENGTH,
  ExternalWorkflowSchema,
  ExternalWorkflowVersionSchema,
  IMPORTABLE_DOCUMENT_GROUPS,
  ListCompanyUsersResponseBody,
  ORDER_CLAIM_TRIGGERS,
  ORDER_COMPLETION_BLOCKED_REASONS,
  ORDER_PENDING_SIDES,
  ORDER_PENDING_SIDE_COLUMN,
  ORDER_PROGRESS_STAGES,
  ORDER_PROGRESS_STAGE_RANK,
  ORDER_PROGRESS_STAGE_STATUSES,
  ORDER_PROGRESS_WAITING_ON,
  ORDER_SCHEDULE_BLOCKED_REASONS,
  ORDER_SCHEDULE_STATUSES,
  ORDER_WORK_PROOF_BLOCKED_REASONS,
  ORDER_WORK_PROOF_CAPTURABLE_STATUSES,
  ORDER_WORK_PROOF_COMPLETED_STATUSES,
  ORDER_WORK_PROOF_DISPLAY_STATUSES,
  ORDER_WORK_PROOF_OPEN_STATUSES,
  PERFORMANCE_DAMAGE_CATEGORIES,
  PROFESSIONAL_VICTIM_RELATIONSHIPS,
  RELEASE_NOTE_IMAGE_SRC_MAX_LENGTH,
  REVIEW_COMMENT_MAX_LENGTH,
  REVIEW_LOW_SCORE_COMMENT_THRESHOLD,
  REVIEW_MAX_SCORE,
  REVIEW_MIN_SCORE,
  RelationType,
  SELF_MANAGED_INTEGRATION_BACKENDS,
  TWENTY_FOUR_HOURS_REGEX,
  acceptCustomerOrganizationInvitationRequestBody,
  acceptOfferRequestBody,
  acceptOwnershipTransferRequestBody,
  acceptanceCheckSchema,
  acceptanceDeclaredIdentitySchema,
  acceptanceIdentityVerdictSchema,
  acceptanceLawyerResolutionSchema,
  acceptancePayeeBlockersOf,
  acceptancePayeeCandidateSchema,
  acceptancePayeeContextCandidateSchema,
  acceptancePayeeContextSchema,
  acceptancePayeeResolutionSchema,
  acceptanceProbabilityBands,
  acceptanceProbabilityFactorKeys,
  acceptanceProbabilityFactorSkipReasons,
  ackFileRequestPlaceholderRequestBody,
  ackFileRequestPlaceholderRequestParams,
  addAppraisalReportRequestBody,
  addClaimCollaboratorRequestBody,
  addComplaintCollaboratorRequestBody,
  addMessageRequestBody,
  addMessageToClaimRequestParams,
  addProviderGroupMemberRequestBody,
  affectedUserEventMetadata,
  aggregateClaimAssignableUsersRequestQuery,
  aggregateClaimsNotificationsActivityRequestBody,
  agreementAcceptanceSourceKinds,
  agreementAcceptanceSources,
  agreementBindingResolutionSchema,
  agreementBindingStatuses,
  agreementBlockCopyRejections,
  agreementBlockSchema,
  agreementClaimSubjectSchema,
  agreementClaimTypeDamageSchema,
  agreementClaimTypeSchema,
  agreementClaimantSchema,
  agreementCloneMappingEntry,
  agreementClonePlanRequestBody,
  agreementCondition,
  agreementConditionEvaluationSchema,
  agreementConditionsFingerprint,
  agreementDamageSchema,
  agreementDamagesFactSchema,
  agreementDispatchTransactionName,
  agreementDocumentAnchorSchema,
  agreementDocumentAnchorsSchema,
  agreementDocumentDiagnosticsSchema,
  agreementDocumentParamsSchema,
  agreementDocumentPayloadSchema,
  agreementDriverSchema,
  agreementDynamicVariableKey,
  agreementExternalComplaintSources,
  agreementFactsSchema,
  agreementFinalDocumentBlocker,
  agreementFixtureClaimTypes,
  agreementFixtureGuid,
  agreementInjuryDetailSchema,
  agreementInsuranceSchema,
  agreementInsuredSchema,
  agreementLawyerRules,
  agreementLawyerSchema,
  agreementMissingEntrySchema,
  agreementOfferKinds,
  agreementOfferTermsSchema,
  agreementParentSchema,
  agreementPartiesSchema,
  agreementPaymentBreakdownSchema,
  agreementPersonKinds,
  agreementPersonSchema,
  agreementPlanGapSchema,
  agreementPlanRecipientSchema,
  agreementPlanRuleSchema,
  agreementPlanSchema,
  agreementPlanSigners,
  agreementPlanTemplateSchema,
  agreementPrincipalClaimantRules,
  agreementRealPropertySchema,
  agreementResolutionMetaSchema,
  agreementResolutionSchema,
  agreementRuleAttributeKeySchema,
  agreementRuleConditionSchema,
  agreementRuleConditionsSchema,
  agreementRuleConditionsSchemaFor,
  agreementRuleContextSchema,
  agreementRuleEvaluationSchema,
  agreementRuleHealthIssues,
  agreementRuleRecipientSchema,
  agreementRuleRequestParams,
  agreementRuleValueSchema,
  agreementSampleScenarios,
  agreementSampleTemplate,
  agreementScenarios,
  agreementSendBlockerKeys,
  agreementSendBlockers,
  agreementSignatureDecisionSchema,
  agreementSignatureRuleEvaluationSchema,
  agreementSignatureRuleScopeSchema,
  agreementSignerKeySchema,
  agreementSignerSchema,
  agreementSubjectSchema,
  agreementTemplateConditionGapSchema,
  agreementTemplateContentSchema,
  agreementTemplateMissingSchema,
  agreementTemplateMissingStatuses,
  agreementTemplateRequestParams,
  agreementTemplateSyntaxErrorSchema,
  agreementTemplateVariableSchema,
  agreementTemplateVersionRequestParams,
  agreementTermsSources,
  agreementValuesByName,
  agreementVariableBindingsSchema,
  agreementVariableDefinitionSchema,
  agreementVariableValueSchema,
  agreementVariableValuesSchema,
  agreementVariablesToTemplateContext,
  agreementVehicleSchema,
  agreementWarningSchema,
  alertEnvironmentEnvSchema,
  alertTypesWithProgressTrigger,
  amountSchema,
  appErrorSchema,
  applyConditionsToVariables,
  applyRefinementsToCompanySLASchema,
  applyTeamValidationsToSchema,
  appraisalInvoiceUploaded,
  appraisalReportAccepted,
  appraisalReportCreated,
  appraisalReportRejected,
  appraisalUpdatesPublished,
  appraisalUpdatesRequested,
  assignAutoinspectorTemplateRequestBody,
  assignClaimCollaboratorRequestBody,
  assignClaimOwnerRequestBody,
  assignClaimResponsibleRequestBody,
  assignComplaintResponsibleRequestBody,
  assignmentReason,
  associateSinisterToFraudRequestBody,
  attachFilesRequestBody,
  autoinspectorFieldMappingSchema,
  autoinspectorFieldMappingsSchema,
  autoinspectorFieldSourceDefinitions,
  autoinspectorUseCaseSupportsFieldConfig,
  autosignConnectionStatus,
  autosignTransactionInfoSchema,
  azureCallbackQuerySchema,
  backofficeAutoinspectorInspectionsFilterQuery,
  backofficeEntityRequestParams,
  backofficeEntitySpecificRequestParams,
  backofficeListEntrypointsRequestQuery,
  backofficeListInvitationsRequestQuery,
  backofficeListReviewsRequestQuery,
  backofficeListUsersRequestQuery,
  backofficeMoveTriggerMappingRequestBody,
  backofficeMoveTriggerMappingRequestParams,
  backofficeOrderExportRecipientSchema,
  backofficeOrdersFilterSchema,
  backofficePreviewOfferRequestBody,
  backofficeRemoveCompanyEnumRequestParams,
  backofficeRemoveEntitySpecificTriggerMappingRequestParams,
  backofficeUpdateCompanyEnumRequestParams,
  backofficeUpdateComplaintSinisterCauseRequestBody,
  backofficeUpsertEntitySpecificTriggerMappingRequestBody,
  bankConditions,
  bankPairWarnings,
  batchCreateTeamMembershipsRequestBody,
  batchListTagsRequestQuery,
  batchReadNotificationsRequestBody,
  bidLineSchema,
  bodyPartLabel,
  buildAcceptanceProbabilityInput,
  buildAgreementAcceptanceRequirements,
  buildAgreementClaimant,
  buildAgreementDefinition,
  buildAgreementDispatchFields,
  buildAgreementDispatchRecipients,
  buildAgreementDocumentSample,
  buildAgreementDriver,
  buildAgreementFixtureResolution,
  buildAgreementFixtureRuleContext,
  buildAgreementInsurance,
  buildAgreementInsured,
  buildAgreementLawyer,
  buildAgreementLegalPerson,
  buildAgreementNoOffer,
  buildAgreementOffer,
  buildAgreementParent,
  buildAgreementPerson,
  buildAgreementPlan,
  buildAgreementRule,
  buildAgreementRuleContext,
  buildAgreementSampleRuleContext,
  buildAgreementSampleVariables,
  buildAgreementSignatureRule,
  buildAgreementSubject,
  buildAgreementVariableValues,
  buildAutosignAuthorizeUrl,
  buildClaimEstimateChanges,
  buildMessageTemplateVariablesSchema,
  buildOfferAgreementOverview,
  buildOfferMessageSample,
  buildOfferVariableRows,
  buildRestatedEstimateChange,
  buildSchemaFromEstimatesDefinition,
  byAgreementRulePriority,
  calculateAcceptanceProbability,
  calculateCohortMonthsMatured,
  canReadNegotiationStage,
  cancelClaimDerivationRequestBody,
  cancelFileRequestPlaceholderRequestBody,
  cancelOfferAgreementJobMetadata,
  cancelOfferRequestBody,
  cancelOrderRequestBody,
  cancelOrderScheduleRequestBody,
  cancelRFPForClaimRequestBody,
  canonicalJson,
  caseStatus,
  changeUserPasswordRequestBody,
  chartFrequencies,
  checkClaimAttributeRequestQuery,
  checkComplaintAttributeRequestQuery,
  claimClosedByInsurerSystemEventMetadata,
  claimCreatedEventPayloadSchema,
  claimDocumentAnalysisAssetDetailsSchema,
  claimDocumentGroups,
  claimDocumentPreview,
  claimDocumentRequirements,
  claimDocumentRequirementsBySpecification,
  claimDocumentRequirementsFor,
  claimDriverSchema,
  claimEstimateChangeProperties,
  claimEstimateEventProps,
  claimEstimatesProps,
  claimEstimatesUpdated,
  claimFileRequestCreated,
  claimFileUploadedEventPayloadSchema,
  claimHandlerAssignedPayloadSchema,
  claimHandlerUnassignedPayloadSchema,
  claimIntakeSchema,
  claimMessageCreated,
  claimNegotiationEscalationStages,
  claimNegotiationPretensionSources,
  claimObject,
  claimOfferAccepted,
  claimOfferAgreementCanceled,
  claimOfferAgreementCompleted,
  claimOfferAgreementCreated,
  claimOfferAgreementExpired,
  claimOfferAgreementRejected,
  claimOfferCanceled,
  claimOfferCreated,
  claimOfferExpired,
  claimOfferRejected,
  claimOrderCreatedPayloadSchema,
  claimOrderInvoiceCreated,
  claimOrderReportAccepted,
  claimOrderReportCreated,
  claimOrderReportRejected,
  claimOrderUpdatesPublished,
  claimOrderUpdatesRequested,
  claimOwnershipTransferAccepted,
  claimOwnershipTransferCreated,
  claimOwnershipTransferRejected,
  claimRfpBidObject,
  claimRfpBidSelected,
  claimRfpBidSubmitted,
  claimRfpCanceled,
  claimRfpClosed,
  claimRfpCreated,
  claimSLAInstanceThresholdExceeded,
  claimSLAObjectiveInstanceThresholdExceeded,
  claimStatusUpdatedPayloadSchema,
  claimTypeDamageSchema,
  claimantLegalPersonSchema,
  claimantNaturalPersonInnerSchema,
  claimantNaturalPersonSchema,
  claimantSchema,
  claimantVictimIdentityMessages,
  claimantVictimMismatchDetailSchema,
  claimantVictimViolationCodes,
  claimsFilterSchema,
  classifyAgreementGap,
  cloneAgreementTemplateRequestBody,
  commitEntrypointSnapshotProgressRequestBody,
  companyAgreementSettingsRequestBody,
  companyBaseSchema,
  companyEnumKeys,
  companyEnumSchema,
  companyEnumUnionType,
  companyEventsFiltersSchema,
  companyOfferTermsOptionsSchema,
  companyOwnerSchema,
  companySchema,
  companySchemaUnion,
  compileAgreementMessage,
  compileAgreementTemplate,
  compiledAgreementBlockSchema,
  compiledAgreementSignatureSlotSchema,
  complaintBaseSchema,
  complaintDocumentRequirements,
  complaintOtherDocumentRequirements,
  complaintOtherOccurrenceSchema,
  complaintOtherSubTypeSchema,
  complaintOtherSubTypes,
  complaintPolicyholderSchema,
  complaintThirdPartySchema,
  complaintThirdPartyVehicleSchema,
  composedEstimateAttributes,
  computeOfferCap,
  computeOfferPaymentBreakdown,
  computeOrderTotals,
  configureAutoinspectorRequestBody,
  consistencyIdentityOf,
  contactRegistrationStatuses,
  coverageItem,
  coverageLabel,
  createAgreementRuleRequestBody,
  createAgreementSignatureRuleRequestBody,
  createAgreementTemplateRequestBody,
  createBatchEventsRequestBody,
  createClaimFormReviewRequestBody,
  createClaimOwnerRequestBody,
  createClaimRFPRequestBody,
  createClaimRFPSchema,
  createClaimRequestBody,
  createClaimSchema,
  createCommentRequestBody,
  createCommentRequestParam,
  createCompanyClaimStatusOrderRuleRequestBody,
  createCompanyClaimStatusRequestBody,
  createCompanyClaimTypeRequestBody,
  createCompanyComplaintStatusOrderRuleRequestBody,
  createCompanyComplaintStatusRequestBody,
  createCompanyLinkRequestBody,
  createCompanySLARequestBody,
  createCompanySLASchema,
  createCompanyTagRequestBody,
  createCompanyTagRequestParams,
  createCompanyTagResponseBody,
  createComplaintRequestBody,
  createComplaintSinisterCauseRequestBody,
  createComplaintVehicleSchema,
  createContactRequestBody,
  createContractRequestBody,
  createContractSchema,
  createCustomerOrganizationInvitationRequestBody,
  createCustomerOrganizationRequestBody,
  createCustomerOrganizationUserRequestBody,
  createCustomerRequestBody,
  createEntrypointRequestBody,
  createEntrypointSessionRequestBody,
  createEstimatesDefinitionRequestBody,
  createEventRequestParams,
  createFileRequestRequestBody,
  createFileRequestRequestParams,
  createGoodRequestBody,
  createInHouseLawyerRequestBody,
  createIntegrationConnectionRequestBody,
  createIntegrationTemplateRequestBody,
  createInvitationSchema,
  createLoadBalanceRuleRequestBody,
  createLoginCredentialRequestBody,
  createMessageTemplateRequestBody,
  createOfferAgreementRequestBody,
  createOfferRequestBody,
  createOrderDocumentRequirementRequestBody,
  createOrderRequestBody,
  createPendingComplaintRequestBody,
  createProductImportRequestBody,
  createProductRequestBody,
  createProviderGroupRequestBody,
  createReleaseNoteEventsRequestBody,
  createRoleRequestBody,
  createServiceAccountRequestBody,
  createServiceRequestBody,
  createStyleConfigRequestBody,
  createTeamClaimsReassignmentRequestBody,
  createTeamDelegationRequestBody,
  createTeamMembershipRequestBody,
  createTeamRequestBody,
  createTeamSchema,
  createUserRequestBody,
  createValidationPatternRequestBody,
  createVerticalRequestBody,
  createWebhookRequestBody,
  createWorkflowRequestBody,
  cuitCountries,
  cuitCuilSchema,
  cuitMatchesPerson,
  cuitRefine,
  cuitSchema,
  customHandlebarsToHandlebars,
  customerOrganizationInvitationRequestParams,
  customerOrganizationInvitationTokenRequestParams,
  customerOrganizationUserRequestParams,
  deactivateGroupSLARequestBody,
  decidedAgreementSignatureMethod,
  defaultOfferTerms,
  delegateClaimHandlingRequestBody,
  delegateComplaintHandlingRequestBody,
  deleteCompanyTagResponseBody,
  deleteTeamRequestParams,
  deriveAgreementFacts,
  deriveClaimRequestBody,
  deriveClaimType,
  deriveSinisterToFraudRequestBody,
  describeOfferSnapshotContext,
  diffClaimEstimateProperty,
  diffClaimEstimates,
  disabledAgreementPlan,
  dismissTeamDelegationNoticeRequestBody,
  dispatchOfferAgreementJobMetadata,
  dni,
  dniSchema,
  documentAmountLineSchema,
  documentBrandingSchema,
  documentContracts,
  documentDefinitionSchema,
  documentMetaSchema,
  documentSchema,
  duplicateAgreementTemplateRequestBody,
  einSchema,
  emailNameMatchInputSchema,
  embeddedSigningStatusRequestBody,
  entrypointAttemptErrorStatuses,
  estimatesDefinitionOperandSchema,
  estimatesImposterProps,
  evaluableAgreementRuleSchema,
  evaluableAgreementSignatureRuleSchema,
  evaluateAgreementCondition,
  evaluateAgreementRule,
  eventReportColumns,
  eventRequestBody,
  exceedsOfferCap,
  exportBackofficeOrdersRequestBody,
  exportClaimsRequestBody,
  exportCompanyEventsRequestBody,
  exportCompanyEventsRequestFilters,
  exportInsurerOrdersRequestBody,
  exportReviewsCSVRequestQuery,
  exportSLAsRequestBody,
  extractAgreementTemplateVariables,
  extractRecipientSubmissions,
  extractVehicleIdCardRequestBody,
  fetchBackofficeFraudInvestigationParams,
  fetchClaimAttemptsByUserRequestQuery,
  fetchClaimCreationAttemptsRequestQuery,
  fetchClaimDetailRequestParams,
  fetchClaimFileRequestParams,
  fetchClaimFileResponseBody,
  fetchClaimMinimalRequestParams,
  fetchClaimMinimalResponseBody,
  fetchClaimsCountFrequencyRequestQuery,
  fetchClaimsDistributionRequestQuery,
  fetchClaimsPeriodAnalysisRequestQuery,
  fetchClaimsWeeklyComparisonRequestQuery,
  fetchCompanyEntrypointRequestParams,
  fetchCompanyRequestParams,
  fetchCoordinatorBlockRequestQuery,
  fetchCoordinatorCohortRequestQuery,
  fetchCoordinatorFunnelRequestQuery,
  fetchCoordinatorHandlersRequestQuery,
  fetchCoordinatorRiskZoneRequestQuery,
  fetchCoordinatorSnapshotRequestQuery,
  fetchCoordinatorStageDrilldownRequestQuery,
  fetchCoordinatorStageSlaRequestQuery,
  fetchCoordinatorTeamExtendedRequestQuery,
  fetchDailyClaimsRequestQuery,
  fetchEntrypointRequestParams,
  fetchEntrypointRequestQuery,
  fetchExistingKachCaseQuery,
  fetchFraudDetailRequestParams,
  fetchHistogramRequestQuery,
  fetchIntegrationConnectionRequestQuery,
  fetchJobRequestParams,
  fetchLoadBalanceRuleRequestParams,
  fetchMetricsCaseRequestParam,
  fetchMetricsGlobalFiltersRequestQuery,
  fetchPerformanceBlockRequestQuery,
  fetchPerformanceClosureCohortByOutcomeRequestQuery,
  fetchPerformanceCohortRequestQuery,
  fetchPerformanceFraudCasesInProcessRequestQuery,
  fetchPerformanceFraudImpactRequestQuery,
  fetchPerformanceFraudInvestigationTimeRequestQuery,
  fetchPerformanceFunnelRequestQuery,
  fetchPerformanceRiskZoneRequestQuery,
  fetchPerformanceSnapshotRequestQuery,
  fetchPerformanceStageDrilldownRequestQuery,
  fetchPerformanceStageSlaRequestQuery,
  fetchPerformanceTeamExtendedRequestQuery,
  fetchPerformanceTeamScopeRequestQuery,
  fetchPolicyholderInspectionDetailRequestParams,
  fetchProcessingAmountMetricsRequestQuery,
  fetchResourceDetailRequestParams,
  fetchReviewsDistributionRequestQuery,
  fetchRiskZoneRequestQuery,
  fetchSinisterDetailRequestParams,
  fetchWeeklyEvolutionRequestQuery,
  fieldAdjusterAssigned,
  fileRequestMessageSchema,
  findAgreementRuleConflict,
  formSteps,
  formatAgreementBoolean,
  formatAgreementDate,
  formatAgreementList,
  formatAgreementMoney,
  formatAgreementNumber,
  formatAgreementPercent,
  formatAgreementValue,
  formatAgreementWords,
  formatClaimEstimateValue,
  franchiseAmountSchema,
  freeAgreementTemplateName,
  generateNaturalPersonSchema,
  genericDocumentNumber,
  getAcceptanceProbabilityBand,
  getClaimDamage,
  getCurlyBracketsVariablePaths,
  getVictimIdentification,
  guidedCreateOfferRequestBody,
  handlebarsToCustomHandlebars,
  hasAgreementPlaceholders,
  hasAgreementSendBlockers,
  hasDeathDamage,
  hasOfferAgreement,
  hasUnrecordedEstimateChange,
  hasUnrecordedEstimateReason,
  identificationInCuit,
  identificationTypeLabel,
  importBackofficeReleaseNoteRequestBody,
  importOrderDocumentsRequestBody,
  injuryDamageDocuments,
  injuryDetail,
  injuryLabel,
  injurySeverityLabel,
  inspectProductImportRequestBody,
  installmentsWithFeesDefinitions,
  insuredPartySchema,
  insurerOrdersFilterSchema,
  inviteProviderRequestBody,
  isAcceptanceProbabilityComputable,
  isAgreementTemplateVariableKey,
  isAttorneyInFact,
  isAutoinspectorFieldSource,
  isAutoinspectorFieldSourceCompatible,
  isAutoinspectorUseCase,
  isCanceledOfferStatus,
  isCapturableWorkProof,
  isClaimDocumentAnalysisResult,
  isCompletedWorkProof,
  isLocalClaim,
  isManualAgreementOffer,
  isOfferAgreementActivityEvent,
  isOfferAgreementOpenAtProvider,
  isOfferAgreementViewInFlight,
  isOfferAgreementVisibleToClaimant,
  isOfferCapComputable,
  isOpenWorkProof,
  isOrderAccepted,
  isOrderClaimTrigger,
  isProfessionalVictimRelationship,
  isRecoveryClaim,
  isReleaseNoteSectionKind,
  isReviewCommentRequired,
  isSameEmail,
  isSelfManagedIntegrationBackend,
  isValidCuit,
  jobDetailRequestParams,
  judicialEstimatesProps,
  kachOAuthModes,
  lawyerKindLabel,
  legacyCreateOfferRequestBody,
  legalPersonSchema,
  legalPersonTypeLabel,
  lineMetrics,
  linkCustomerOrganizationUserRequestBody,
  listAffectedCoveragesRequestQuery,
  listAgreementTemplatesRequestQuery,
  listAlertsRequestQuery,
  listBackofficeAutoinspectorInspectionsRequestQuery,
  listBackofficeFraudInvestigationsRequestQuery,
  listBackofficeOrdersRequestQuery,
  listBackofficeReleaseNoteEventsRequestQuery,
  listBackofficeReleaseNotesRequestQuery,
  listClaimFilesApiResponseBody,
  listClaimFilesMinimalRequestQuery,
  listClaimFilesRequestParams,
  listClaimStatusResponseBody,
  listClaimantPendingActionsRequestQuery,
  listCommentsRequestQuery,
  listCompanyAgreementRulesRequestQuery,
  listCompanyAgreementTemplatesRequestQuery,
  listCompanyClaimsResponseBody,
  listCompanyEventsRequestQuery,
  listCompanyLinkRequestQuery,
  listCompanyMembersRequestQuery,
  listCompanyMessageTemplatesRequestQuery,
  listCompanyOptionsRequestQuery,
  listCompanySubStatusRequestQuery,
  listContactsRequestQuery,
  listCreatedJobsRequestQuery,
  listCustomersRequestQuery,
  listDelegatedClaimsRequestQuery,
  listDelegatedComplaintsRequestQuery,
  listDerivedClaimsRequestQuery,
  listEngagementsRequestQuery,
  listEntrypointOptionsRequestQuery,
  listEntrypointsAttemptsRequestQuery,
  listEntrypointsRequestQuery,
  listExpertAppraisalPhotosRequestParams,
  listExternalWorkflowVersionsResponseBody,
  listExternalWorkflowsResponseBody,
  listFieldAdjusterClaimsRequestQuery,
  listFilesRequestQuery,
  listGroupSLAVersionsRequestQuery,
  listImportableOrderDocumentsRequestQuery,
  listInHouseLawyersRequestQuery,
  listInsurerClaimsRequestQuery,
  listInsurerComplaintsRequestQuery,
  listInsurerOrdersRequestQuery,
  listIntegrationTemplatesRequestQuery,
  listInvitationsRequestQuery,
  listMessageTemplatesRequestQuery,
  listNotificationsRequestQuery,
  listOrderCandidatesRequestQuery,
  listPolicyholderInspectionsRequestParams,
  listProductImportsRequestQuery,
  listProductsRequestQuery,
  listProviderBranchesRequestQuery,
  listProviderDocumentTypesBackofficeRequestQuery,
  listProviderEngagementsRequestQuery,
  listProviderGroupsRequestQuery,
  listProviderTemplatesRequestParams,
  listProviderTemplatesRequestQuery,
  listSinisterClaimMessagesRequestParams,
  listSinisterRequestParams,
  listTeamMembershipsRequestQuery,
  listVehicleMakeRequestQuery,
  listVehicleModelsRequestQuery,
  listVehicleVersionsRequestQuery,
  listVendorContractsRequestQuery,
  listVendorOrdersRequestQuery,
  listVendorRFPsRequestQuery,
  listVirtualViewsRequestQuery,
  listWebhookLogsRequestQuery,
  listWebhooksRequestQuery,
  loginBackofficeRequestBody,
  loginProvider,
  loginUserRequestBody,
  matchAcceptanceLawyer,
  matchAcceptancePayee,
  matchesClaimTypeComposition,
  materialDamageBaseSchema,
  materialDamageDocuments,
  materialDamageKindLabel,
  mergeAgreementBindings,
  mergeAgreementSigners,
  messageTemplateVariableOptionsSchema,
  messageTemplateVariableSchema,
  negotiationStageAccessOf,
  negotiationStageStatesOf,
  nonOperationalJobMetadata,
  normalizeAutosignRecipientName,
  normalizeClaimEstimateValue,
  normalizeEmail,
  normalizeIdentification,
  notFoundClaimErrorSchema,
  notFoundClaimOrFileErrorSchema,
  notFoundClaimStatusErrorSchema,
  notFoundFileErrorSchema,
  notifyBackofficeReleaseNoteRequestBody,
  oauthExchangedCodeMessage,
  observationFromTransactionInfo,
  observationFromTransitionWebhook,
  occurrenceBaseSchema,
  occurrenceSchema,
  offerAcceptanceFieldSchema,
  offerAcceptanceRequirementSchema,
  offerAcceptanceRequirementsSchema,
  offerAgreementCancelNotice,
  offerAgreementDispatchFieldSchema,
  offerAgreementDispatchFieldsSchema,
  offerAgreementDispatchRecipientRoles,
  offerAgreementDispatchRecipientSchema,
  offerAgreementDispatchRecipientsSchema,
  offerAgreementPhaseOf,
  offerAgreementPhaseOfStatus,
  offerAgreementProviderCancelSummary,
  offerAgreementTransitionBodySchema,
  offerAgreementTransitionDecision,
  offerAgreementTransitionEnvelopeSchema,
  offerMessageSampleTemplate,
  offerSnapshotReferenceKeys,
  offerTermsIssues,
  offerTermsOptionsSchema,
  offerTermsSchema,
  offerWizardLegacyReasons,
  offerWizardModes,
  openAIDecisionRequestBody,
  operationalJobMetadata,
  optionalBooleanParam,
  optionalCommaListParam,
  orderCandidateScopes,
  orderClaimTriggerLabelKey,
  orderDateFields,
  orderItemInput,
  orderReportInsuredSchema,
  orderReportItemSchema,
  orderReportParamsSchema,
  orderReportPayloadSchema,
  orderReportSummarySchema,
  orderReportVehicleSchema,
  orderReportWorkProofSchema,
  orderScheduleCanceledEventMetadata,
  orderSchedulingEventMetadata,
  orderTaxPercent,
  orderWorkProofMechanism,
  overrideUserPermissions,
  paginateClaimsRequestQuery,
  paginateRequestQuery,
  paramIdSchema,
  parseAgreementBlockCopy,
  parseBoundDigits,
  parseBoundPositiveInteger,
  parseBoundPositiveNumber,
  parseMessageTemplateVariableOptions,
  parseReleaseNoteSection,
  parseRichText,
  passwordSchema,
  patchAlertSubscriptionsRequestBody,
  patchTopicSubscriptionsRequestBody,
  patchedGenerateSchema,
  payeeDocumentOf,
  percentageEstimatesProps,
  performanceLeadingIndicatorKeys,
  personDamage,
  personDamageKindLabel,
  pipeRefineSuperRefine,
  placeholderRequestBody,
  planAgreementRequestBody,
  policyholderRelationshipLabel,
  presentAgreementValue,
  previewOfferRequestBody,
  previewProductImportRequestBody,
  processOfferAgreementJobMetadata,
  productImportCreateRow,
  productImportMapping,
  productImportOptions,
  productImportRowError,
  productImportUpdateRow,
  providerBranchEmails,
  providerBranchPhones,
  providerPasswordSchema,
  providerRegistrationRequestBody,
  providerUserRequestParams,
  proxyCreateComplaintRequestBody,
  proxyListComplaintCoveragesRequestQuery,
  proxyListOrderQuantityDescriptionRequestQuery,
  publicAssetsEnvSchema,
  publishAppraisalUpdatesRequestBody,
  publishBackofficeReleaseNoteRequestBody,
  publishContractUpdateNoteRequestBody,
  publishOrderUpdateNoteRequestBody,
  readAgreementRuleAttribute,
  realPropertyDamage,
  realPropertyOwnershipLabel,
  realPropertyTypeLabel,
  reconcileOfferAgreementJobMetadata,
  recoverTeamDerivedClaimsRequestBody,
  recoveryDamage,
  recoveryDamageSchema,
  recoveryRelationshipLabel,
  registerInHouseLawyerAccountRequestBody,
  registerUserByInvitationLocalRequestBody,
  registerUserByInvitationProviderRequestBody,
  registerUserExtendedRequestBody,
  registerUserRequestBody,
  rejectAppraisalReportRequestBody,
  rejectComplaintRequestBody,
  rejectContractReportRequestBody,
  rejectOfferRequestBody,
  rejectOrderDocumentRequestBody,
  rejectOrderRequestBody,
  releaseBackofficeReleaseNoteRequestBody,
  releaseNoteEventRequest,
  releaseNoteItemInput,
  releaseNoteListSelection,
  releaseNoteSectionContentSchemas,
  releaseNoteSectionInput,
  remapAgreementConditions,
  removeAutoinspectorRequestQuery,
  removeClaimCollaboratorRequestParams,
  removeCompanyCurrencyRequestParams,
  removeCompanyEntrypointRequestParams,
  removeCompanyLinkRequestParams,
  removeCompanyStyleRequestParam,
  removeComplaintCollaboratorRequestParams,
  removeIntegrationConnectionRequestParams,
  removeOrderClaimStatusMappingRequestParams,
  removeProviderGroupMemberRequestParams,
  removeValidationPatternRequestParams,
  renderAgreementMessageText,
  renderAgreementSampleRequestBody,
  renderDocumentRequestBody,
  reorderAgreementRulesRequestBody,
  reorderAgreementSignatureRulesRequestBody,
  reorderLoadBalanceRulesRequestBody,
  requestAppraisalUpdatesRequestBody,
  requestContractUpdatesRequestBody,
  requestFraudNewsRequestBody,
  requestLinkForgotPasswordRequestBody,
  requestResetPasswordToken,
  requireVinculoOtherWhenRelationshipIsOther,
  rescheduleJobRequestParams,
  resetUserPasswordRequestBody,
  resolveAcceptanceLawyer,
  resolveAcceptancePayee,
  resolveAgreementBindings,
  resolveAgreementDamages,
  resolveAgreementParties,
  resolveAgreementSignatureOrigin,
  resolveAgreementTemplateGaps,
  resolveAgreementVariablesRequestBody,
  resolveClaimPretension,
  resolveClaimantVictimIdentityIssues,
  resolveEmbeddedSigningEligibility,
  resolveEstimatesDefinitionRequestQuery,
  resolveLawyerCuit,
  resolveOfferAcceptanceRequirements,
  resolveOfferAmountFromVariables,
  resolveOfferCap,
  resolveOfferPayeeNames,
  resolveOfferTermsOptions,
  resolveOfferWizardMode,
  resolvePrincipalClaimant,
  resolveSignatureDispatch,
  respondEngagementRequestBody,
  restoreDelegatedClaimsRequestBody,
  restoreDelegatedComplaintsRequestBody,
  retrieveAffectedCoverageRequestParams,
  retrieveAgreementPlanRequestQuery,
  retrieveAgreementTemplateRequestQuery,
  retrieveClaimDerivationRequestParams,
  retrieveClaimResponsibleCountRequestQuery,
  retrieveClaimStatusRequestParams,
  retrieveCompanyAllowedScopesRequestBody,
  retrieveCompanyClaimStatusOrderRuleRequestParams,
  retrieveCompanyClaimStatusRequestBody,
  retrieveCompanyComplaintStatusOrderRuleRequestParams,
  retrieveCompanyComplaintStatusRequestBody,
  retrieveCompanyEstimatesDefinitionRequestParams,
  retrieveCompanyStyleRequestQuery,
  retrieveComplaintDetailRequestParams,
  retrieveComplaintPortalRequestParams,
  retrieveComplaintRequestParamsSchema,
  retrieveComplaintSinisterCauseRequestParams,
  retrieveCustomerRequestParams,
  retrieveEntrypointSnapshotRecordingRequestParams,
  retrieveExternalComplaintDetailRequestParams,
  retrieveInHouseLawyerRequestParams,
  retrieveInHouseLawyerRequestQuery,
  retrieveInsurerProviderRequestParams,
  retrieveIntegrationTemplateFieldsRequestParams,
  retrieveIntegrationTemplateRequestParams,
  retrieveInvitationInfoRequestBody,
  retrieveMessageTemplateRequestParams,
  retrieveOfferAgreementRequestParams,
  retrieveOfferAgreementRequestQuery,
  retrieveOfferRequestParams,
  retrieveOfferRequestQuery,
  retrieveOrderDocumentRequirementRequestParams,
  retrieveProductImportRequestParams,
  retrieveProductRequestParams,
  retrieveProviderBranchRequestParams,
  retrieveProviderGroupRequestParams,
  retrieveRelationTypeSLAStatsRequestQuery,
  retrieveReleaseNoteRequestParams,
  retrieveResponsibilityTransferRequestParams,
  retrieveReviewRequestParams,
  retrieveSLAObjectivesRequestQuery,
  retrieveSLARequestParams,
  retrieveSinisterRequestParams,
  retrieveUserRequestParams,
  retrieveValidationPatternRequestBody,
  returnClaimResponsibilityRequestBody,
  returnTeamDerivedClaimsRequestBody,
  revealApiKeyRequestParams,
  reviewCommentSchema,
  reviewFiltersRequestQuery,
  reviewGlobalFiltersQuery,
  reviewHeatmapRequestQuery,
  reviewKpisRequestQuery,
  reviewScoreBreakdownRequestQuery,
  reviewScoreOptions,
  reviewScoreSchema,
  reviewSortFields,
  reviewSortQuery,
  reviewSparkVariants,
  reviewTokenRequestQuery,
  richTextMarks,
  rivadaviaCreateComplaintSchema,
  sampleDocumentParamsSchema,
  sampleDocumentPayloadSchema,
  saveAgreementTemplateVersionRequestBody,
  saveBatchEntrypointRecordEventsRequestBody,
  saveVirtualViewRequestBody,
  scheduleNonOperationalJobRequestBody,
  scheduleTeamMemberInactivityRequestBody,
  searchCustomerOrganizationCandidateRequestQuery,
  searchDatasetRequestQuery,
  searchEntityRequestQuery,
  searchIntegrationsRequestQuery,
  searchRFPsByRelationTypeRequestQuery,
  searchRequestQuery,
  searchTagsRequestQuery,
  searchUsersExactMatchRequestQuery,
  searchUsersRequestQuery,
  searchVehicleRequestQuery,
  selectAgreementRule,
  selectAgreementSignatureRule,
  selectBlockingViolations,
  selectClaimAgreements,
  selectExternalComplaintRequestBody,
  selectManuallyRequestBody,
  serializeAgreementBlockCopy,
  setAutoinspectorTemplateEnabledRequestBody,
  setOrderScheduleRequestBody,
  shouldDispatchAgreementDocument,
  signInAsCustomerOrganizationUserRequestBody,
  signInKachRequestBody,
  signInRequestBody,
  signUpRequestBody,
  signatureMayEndDigital,
  signatureSchema,
  signerKeysSharingEmail,
  signinAsQuerySchema,
  singlePaymentDefinitions,
  sinisterExternalStatusUpdatedEventMetadata,
  slaFilterStatus,
  slaReportFiltersSchema,
  splitAgreementPlaceholders,
  stateLabel,
  submitBidRequestBody,
  submitReviewRequestBody,
  supersedingOfferOf,
  tajyComplaintVehicleOccurrence,
  tajyCreateComplaintOtherRequestBody,
  tajyCreateComplaintRequestBody,
  tajyCreateComplaintSchema,
  tajyOccurrenceSchema,
  teamActivityRequestQuery,
  teamClaimsDelegatedEventMetadata,
  teamClaimsReassignedEventMetadata,
  teamClaimsRecoveredEventMetadata,
  teamDelegatedClaimsRequestBody,
  teamDelegationClaimIds,
  teamDelegationCoveredClaimIds,
  teamDelegationJobMetadata,
  teamDelegationPlanMetadata,
  teamDelegationPlanRequestQuery,
  teamDelegationRequest,
  teamDelegationSummary,
  teamLeavesRequestQuery,
  teamManagementScopeRequestQuery,
  teamManualDelegationAssignment,
  teamManualDelegationMove,
  teamManualDelegationRequestQuery,
  teamReassignmentCandidatesRequestQuery,
  tenantParamsSchema,
  testWebhookEventRequestBody,
  toAgreementSignatureDecision,
  toDocumentVariant,
  toPreviewAcceptanceRequirements,
  toReleaseNoteItemView,
  tokenizeFileRequestBody,
  transactionCancelledWebhookPayloadSchema,
  transferClaimRequestBody,
  triggerMappingMoveDirections,
  unionComplaintSchema,
  unlinkCustomerOrganizationUserRequestBody,
  updateAgreementRuleRequestBody,
  updateAgreementSignatureRuleRequestBody,
  updateAgreementTemplateRequestBody,
  updateAutoinspectorTemplateFieldMappingsRequestBody,
  updateAutoinspectorTemplateRequestBody,
  updateBackofficeReleaseNoteVisibilityRequestBody,
  updateCapabilitiesRequestBody,
  updateClaimEstimatesRequestBody,
  updateClaimIntakeRequestBody,
  updateClaimRequestBody,
  updateClaimStatusDefinitionRequestBody,
  updateClaimStatusDefinitionResponseBody,
  updateClaimStatusRequestParams,
  updateClaimantSchema,
  updateCompanyClaimStatusOrderRuleRequestBody,
  updateCompanyClaimStatusRequestBody,
  updateCompanyComplaintStatusOrderRuleRequestBody,
  updateCompanyComplaintStatusRequestBody,
  updateCompanyConfigurationRequestBody,
  updateCompanyCurrencyRequestBody,
  updateCompanyCustomizationRequestBody,
  updateCompanyEstimatesDefinitionRequestBody,
  updateCompanyFieldMappingConfigRequestBody,
  updateCompanyFlagsRequestBody,
  updateCompanyLogoRequestBody,
  updateCompanyRequestBody,
  updateCompanyResponseBody,
  updateCompanySinisterConfigRequestBody,
  updateCompanyTagRequestBody,
  updateCompanyTagRequestParams,
  updateCompanyTagResponseBody,
  updateCompanyVerticalsRequestBody,
  updateCompanyWorkingDaysRequestBody,
  updateComplaintRequestBody,
  updateComplaintSinisterCauseRequestBody,
  updateComplaintStatusRequestParams,
  updateContactRequestBody,
  updateCoverageRequestBody,
  updateCustomerOrganizationLogoRequestBody,
  updateCustomerOrganizationRequestBody,
  updateCustomerRequestBody,
  updateEngagementRequestBody,
  updateEngagementStatusRequestBody,
  updateEstimatesInstanceRequestBody,
  updateFileRequestParams,
  updateFileTagRequestBody,
  updateFileTagRequestParams,
  updateFilesTagsInBatchRequestBody,
  updateFilesTagsInBatchRequestParams,
  updateGoodRequestBody,
  updateInHouseLawyerRequestBody,
  updateInferredKeywordRequestBody,
  updateInferredKeywordRequestParams,
  updateInsurerUserRequestBody,
  updateIntegrationConnectionRequestBody,
  updateIntegrationConnectionRequestParams,
  updateIntegrationTemplateRequestBody,
  updateLoadBalanceRuleRequestBody,
  updateMessageTemplateRequestBody,
  updateOrderDocumentRequirementRequestBody,
  updateProductRequestBody,
  updateProviderGroupRequestBody,
  updateProviderProfileRequestBody,
  updateRelationTypeStatusRequestBody,
  updateServiceAccountRequestBody,
  updateServiceRequestBody,
  updateTeamManagementMemberRequestBody,
  updateTeamMemberInactivityRequestBody,
  updateTeamRequestBody,
  updateTeamScheduledDelegationRequestBody,
  updateUserAvatarRequestBody,
  updateUserInfoRequestBody,
  updateUserOverridePermissionsRequestBody,
  updateValidationPatternRequestBody,
  updateValidationPatternRequestParams,
  updateVerticalRequestBody,
  updateWebhookRequestBody,
  updateWorkflowRequestBody,
  updateWorkflowRequestParams,
  uploadAppraisalInvoiceRequestBody,
  uploadClaimSharedDocumentsRequestBody,
  uploadContractInvoiceRequestBody,
  uploadContractRequestBody,
  uploadManualAgreementDocumentRequestBody,
  uploadOrderDocumentRequestBody,
  uploadOrderRequiredDocumentRequestBody,
  uploadProviderDocumentRequestBody,
  upsertCompanySLARequestBody,
  upsertOrderClaimStatusMappingRequestBody,
  upsertProviderBranchRequestBody,
  upsertProviderDocumentTypeRequestBody,
  userAssignmentsEventMetadata,
  userDelegatedClaimsRecoveredEventMetadata,
  userDelegatedClaimsReturnedEventMetadata,
  userDerivedClaimsRecoveredEventMetadata,
  userDerivedClaimsReturnedEventMetadata,
  userInactivityCancelledEventMetadata,
  userInactivityClaimsDelegatedEventMetadata,
  userInactivityDelegationUpdatedEventMetadata,
  userInactivityEndedEventMetadata,
  userInactivityRescheduledEventMetadata,
  userInactivityReturnChangedEventMetadata,
  userInactivityScheduledEventMetadata,
  userInactivityStartedEventMetadata,
  validateAcceptancePayeeRequestBody,
  validateAgreementTemplateSigners,
  validateClaimEstimateValue,
  validateClaimantVictimConsistency,
  validateInterbankingRequestQuery,
  validateLinkedList,
  validateOfferTerms,
  validationIssueSchema,
  validationIssuesSchema,
  validationPatternList,
  vehicleDamage,
  vehicleTypeLabel,
  vehicleUseLabel,
  verifyAccountRequestBody,
  victimRelationshipFormSchema,
  victimRelationshipLabel,
  victimRelationshipSchema,
  victimRoleLabel,
  vinculoOtherRefineParams,
  webhookEventPayloadSchema,
  webhookEventsSchema,
  webhookEventsSpec,
  webhookSchema,
  whitelistedEmailSchema,
  withAlertEnvironmentTag,
  withApplicableFranchise,
  workflowParamSchema
});
/*! Bundled license information:

decimal.js/decimal.mjs:
  (*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   *)
*/
/*! Bundled license information:

@prisma/client/runtime/index-browser.js:
  (*! Bundled license information:
  
  decimal.js/decimal.mjs:
    (*!
     *  decimal.js v10.4.3
     *  An arbitrary-precision Decimal type for JavaScript.
     *  https://github.com/MikeMcl/decimal.js
     *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
     *  MIT Licence
     *)
  *)
*/
